/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonp"];
/******/ 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, callbacks = [];
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId])
/******/ 				callbacks.push.apply(callbacks, installedChunks[chunkId]);
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules);
/******/ 		while(callbacks.length)
/******/ 			callbacks.shift().call(null, __webpack_require__);
/******/
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// object to store loaded and loading chunks
/******/ 	// "0" means "already loaded"
/******/ 	// Array means "loading", array contains callbacks
/******/ 	var installedChunks = {
/******/ 		5:0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId, callback) {
/******/ 		// "0" is the signal for "already loaded"
/******/ 		if(installedChunks[chunkId] === 0)
/******/ 			return callback.call(null, __webpack_require__);
/******/
/******/ 		// an array means "currently loading".
/******/ 		if(installedChunks[chunkId] !== undefined) {
/******/ 			installedChunks[chunkId].push(callback);
/******/ 		} else {
/******/ 			// start chunk loading
/******/ 			installedChunks[chunkId] = [callback];
/******/ 			var head = document.getElementsByTagName('head')[0];
/******/ 			var script = document.createElement('script');
/******/ 			script.type = 'text/javascript';
/******/ 			script.charset = 'utf-8';
/******/ 			script.async = true;
/******/
/******/ 			script.src = __webpack_require__.p + "" + chunkId + "." + "cce19a435ae9e192d99c" + ".chunk.js";
/******/ 			head.appendChild(script);
/******/ 		}
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1127);
	__webpack_require__(8);
	__webpack_require__(1776);
	module.exports = __webpack_require__(1138);


/***/ }),
/* 1 */
/***/ (function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function() {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};
	
		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(window.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0;
	
	module.exports = function(list, options) {
		if(false) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}
	
		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();
	
		var styles = listToStyles(list);
		addStylesToDom(styles, options);
	
		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}
	
	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}
	
	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}
	
	function createStyleElement() {
		var styleElement = document.createElement("style");
		var head = getHeadElement();
		styleElement.type = "text/css";
		head.appendChild(styleElement);
		return styleElement;
	}
	
	function createLinkElement() {
		var linkElement = document.createElement("link");
		var head = getHeadElement();
		linkElement.rel = "stylesheet";
		head.appendChild(linkElement);
		return linkElement;
	}
	
	function addStyle(obj, options) {
		var styleElement, update, remove;
	
		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement());
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else if(obj.sourceMap &&
			typeof URL === "function" &&
			typeof URL.createObjectURL === "function" &&
			typeof URL.revokeObjectURL === "function" &&
			typeof Blob === "function" &&
			typeof btoa === "function") {
			styleElement = createLinkElement();
			update = updateLink.bind(null, styleElement);
			remove = function() {
				styleElement.parentNode.removeChild(styleElement);
				if(styleElement.href)
					URL.revokeObjectURL(styleElement.href);
			};
		} else {
			styleElement = createStyleElement();
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				styleElement.parentNode.removeChild(styleElement);
			};
		}
	
		update(obj);
	
		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}
	
	var replaceText = (function () {
		var textStore = [];
	
		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();
	
	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}
	
	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
		var sourceMap = obj.sourceMap;
	
		if(media) {
			styleElement.setAttribute("media", media)
		}
	
		if(styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}
	
	function updateLink(linkElement, obj) {
		var css = obj.css;
		var media = obj.media;
		var sourceMap = obj.sourceMap;
	
		if(sourceMap) {
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}
	
		var blob = new Blob([css], { type: "text/css" });
	
		var oldSrc = linkElement.href;
	
		linkElement.href = URL.createObjectURL(blob);
	
		if(oldSrc)
			URL.revokeObjectURL(oldSrc);
	}


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(5);
	var core = __webpack_require__(45);
	var hide = __webpack_require__(25);
	var redefine = __webpack_require__(26);
	var ctx = __webpack_require__(46);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
	  var key, own, out, exp;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    // export native or passed
	    out = (own ? target : source)[key];
	    // bind timers to global for call from export context
	    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // extend global
	    if (target) redefine(target, key, out, type & $export.U);
	    // export
	    if (exports[key] != out) hide(exports, key, exp);
	    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
	  }
	};
	global.core = core;
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(7);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ }),
/* 5 */
/***/ (function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 6 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ }),
/* 7 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1137);
	module.exports = angular;


/***/ }),
/* 9 */,
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	var store = __webpack_require__(316)('wks');
	var uid = __webpack_require__(143);
	var Symbol = __webpack_require__(5).Symbol;
	var USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(48);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};


/***/ }),
/* 12 */,
/* 13 */,
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(6)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 15 */,
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(4);
	var IE8_DOM_DEFINE = __webpack_require__(1096);
	var toPrimitive = __webpack_require__(69);
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__(14) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(67);
	module.exports = function (it) {
	  return Object(defined(it));
	};


/***/ }),
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};


/***/ }),
/* 24 */,
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(16);
	var createDesc = __webpack_require__(139);
	module.exports = __webpack_require__(14) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(5);
	var hide = __webpack_require__(25);
	var has = __webpack_require__(36);
	var SRC = __webpack_require__(143)('src');
	var $toString = __webpack_require__(1368);
	var TO_STRING = 'toString';
	var TPL = ('' + $toString).split(TO_STRING);
	
	__webpack_require__(45).inspectSource = function (it) {
	  return $toString.call(it);
	};
	
	(module.exports = function (O, key, val, safe) {
	  var isFunction = typeof val == 'function';
	  if (isFunction) has(val, 'name') || hide(val, 'name', key);
	  if (O[key] === val) return;
	  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
	  if (O === global) {
	    O[key] = val;
	  } else if (!safe) {
	    delete O[key];
	    hide(O, key, val);
	  } else if (O[key]) {
	    O[key] = val;
	  } else {
	    hide(O, key, val);
	  }
	// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
	})(Function.prototype, TO_STRING, function toString() {
	  return typeof this == 'function' && this[SRC] || $toString.call(this);
	});


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(3);
	var fails = __webpack_require__(6);
	var defined = __webpack_require__(67);
	var quot = /"/g;
	// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
	var createHTML = function (string, tag, attribute, value) {
	  var S = String(defined(string));
	  var p1 = '<' + tag;
	  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
	  return p1 + '>' + S + '</' + tag + '>';
	};
	module.exports = function (NAME, exec) {
	  var O = {};
	  O[NAME] = exec(createHTML);
	  $export($export.P + $export.F * fails(function () {
	    var test = ''[NAME]('"');
	    return test !== test.toLowerCase() || test.split('"').length > 3;
	  }), 'String', O);
	};


/***/ }),
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */
/***/ (function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	var pIE = __webpack_require__(315);
	var createDesc = __webpack_require__(139);
	var toIObject = __webpack_require__(39);
	var toPrimitive = __webpack_require__(69);
	var has = __webpack_require__(36);
	var IE8_DOM_DEFINE = __webpack_require__(1096);
	var gOPD = Object.getOwnPropertyDescriptor;
	
	exports.f = __webpack_require__(14) ? gOPD : function getOwnPropertyDescriptor(O, P) {
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if (IE8_DOM_DEFINE) try {
	    return gOPD(O, P);
	  } catch (e) { /* empty */ }
	  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
	};


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has = __webpack_require__(36);
	var toObject = __webpack_require__(17);
	var IE_PROTO = __webpack_require__(721)('IE_PROTO');
	var ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function (O) {
	  O = toObject(O);
	  if (has(O, IE_PROTO)) return O[IE_PROTO];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(314);
	var defined = __webpack_require__(67);
	module.exports = function (it) {
	  return IObject(defined(it));
	};


/***/ }),
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};


/***/ }),
/* 45 */
/***/ (function(module, exports) {

	var core = module.exports = { version: '2.6.12' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(23);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var fails = __webpack_require__(6);
	
	module.exports = function (method, arg) {
	  return !!method && fails(function () {
	    // eslint-disable-next-line no-useless-call
	    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
	  });
	};


/***/ }),
/* 48 */
/***/ (function(module, exports) {

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};


/***/ }),
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	// 0 -> Array#forEach
	// 1 -> Array#map
	// 2 -> Array#filter
	// 3 -> Array#some
	// 4 -> Array#every
	// 5 -> Array#find
	// 6 -> Array#findIndex
	var ctx = __webpack_require__(46);
	var IObject = __webpack_require__(314);
	var toObject = __webpack_require__(17);
	var toLength = __webpack_require__(11);
	var asc = __webpack_require__(705);
	module.exports = function (TYPE, $create) {
	  var IS_MAP = TYPE == 1;
	  var IS_FILTER = TYPE == 2;
	  var IS_SOME = TYPE == 3;
	  var IS_EVERY = TYPE == 4;
	  var IS_FIND_INDEX = TYPE == 6;
	  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
	  var create = $create || asc;
	  return function ($this, callbackfn, that) {
	    var O = toObject($this);
	    var self = IObject(O);
	    var f = ctx(callbackfn, that, 3);
	    var length = toLength(self.length);
	    var index = 0;
	    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
	    var val, res;
	    for (;length > index; index++) if (NO_HOLES || index in self) {
	      val = self[index];
	      res = f(val, index, O);
	      if (TYPE) {
	        if (IS_MAP) result[index] = res;   // map
	        else if (res) switch (TYPE) {
	          case 3: return true;             // some
	          case 5: return val;              // find
	          case 6: return index;            // findIndex
	          case 2: result.push(val);        // filter
	        } else if (IS_EVERY) return false; // every
	      }
	    }
	    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
	  };
	};


/***/ }),
/* 67 */
/***/ (function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(3);
	var core = __webpack_require__(45);
	var fails = __webpack_require__(6);
	module.exports = function (KEY, exec) {
	  var fn = (core.Object || {})[KEY] || Object[KEY];
	  var exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
	};


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(7);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ }),
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

	var Map = __webpack_require__(1118);
	var $export = __webpack_require__(3);
	var shared = __webpack_require__(316)('metadata');
	var store = shared.store || (shared.store = new (__webpack_require__(1122))());
	
	var getOrCreateMetadataMap = function (target, targetKey, create) {
	  var targetMetadata = store.get(target);
	  if (!targetMetadata) {
	    if (!create) return undefined;
	    store.set(target, targetMetadata = new Map());
	  }
	  var keyMetadata = targetMetadata.get(targetKey);
	  if (!keyMetadata) {
	    if (!create) return undefined;
	    targetMetadata.set(targetKey, keyMetadata = new Map());
	  } return keyMetadata;
	};
	var ordinaryHasOwnMetadata = function (MetadataKey, O, P) {
	  var metadataMap = getOrCreateMetadataMap(O, P, false);
	  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
	};
	var ordinaryGetOwnMetadata = function (MetadataKey, O, P) {
	  var metadataMap = getOrCreateMetadataMap(O, P, false);
	  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
	};
	var ordinaryDefineOwnMetadata = function (MetadataKey, MetadataValue, O, P) {
	  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
	};
	var ordinaryOwnMetadataKeys = function (target, targetKey) {
	  var metadataMap = getOrCreateMetadataMap(target, targetKey, false);
	  var keys = [];
	  if (metadataMap) metadataMap.forEach(function (_, key) { keys.push(key); });
	  return keys;
	};
	var toMetaKey = function (it) {
	  return it === undefined || typeof it == 'symbol' ? it : String(it);
	};
	var exp = function (O) {
	  $export($export.S, 'Reflect', O);
	};
	
	module.exports = {
	  store: store,
	  map: getOrCreateMetadataMap,
	  has: ordinaryHasOwnMetadata,
	  get: ordinaryGetOwnMetadata,
	  set: ordinaryDefineOwnMetadata,
	  keys: ordinaryOwnMetadataKeys,
	  key: toMetaKey,
	  exp: exp
	};


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	if (__webpack_require__(14)) {
	  var LIBRARY = __webpack_require__(93);
	  var global = __webpack_require__(5);
	  var fails = __webpack_require__(6);
	  var $export = __webpack_require__(3);
	  var $typed = __webpack_require__(467);
	  var $buffer = __webpack_require__(726);
	  var ctx = __webpack_require__(46);
	  var anInstance = __webpack_require__(134);
	  var propertyDesc = __webpack_require__(139);
	  var hide = __webpack_require__(25);
	  var redefineAll = __webpack_require__(140);
	  var toInteger = __webpack_require__(48);
	  var toLength = __webpack_require__(11);
	  var toIndex = __webpack_require__(1116);
	  var toAbsoluteIndex = __webpack_require__(142);
	  var toPrimitive = __webpack_require__(69);
	  var has = __webpack_require__(36);
	  var classof = __webpack_require__(201);
	  var isObject = __webpack_require__(7);
	  var toObject = __webpack_require__(17);
	  var isArrayIter = __webpack_require__(712);
	  var create = __webpack_require__(136);
	  var getPrototypeOf = __webpack_require__(38);
	  var gOPN = __webpack_require__(137).f;
	  var getIterFn = __webpack_require__(728);
	  var uid = __webpack_require__(143);
	  var wks = __webpack_require__(10);
	  var createArrayMethod = __webpack_require__(66);
	  var createArrayIncludes = __webpack_require__(455);
	  var speciesConstructor = __webpack_require__(317);
	  var ArrayIterators = __webpack_require__(729);
	  var Iterators = __webpack_require__(202);
	  var $iterDetect = __webpack_require__(460);
	  var setSpecies = __webpack_require__(141);
	  var arrayFill = __webpack_require__(704);
	  var arrayCopyWithin = __webpack_require__(1088);
	  var $DP = __webpack_require__(16);
	  var $GOPD = __webpack_require__(37);
	  var dP = $DP.f;
	  var gOPD = $GOPD.f;
	  var RangeError = global.RangeError;
	  var TypeError = global.TypeError;
	  var Uint8Array = global.Uint8Array;
	  var ARRAY_BUFFER = 'ArrayBuffer';
	  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
	  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
	  var PROTOTYPE = 'prototype';
	  var ArrayProto = Array[PROTOTYPE];
	  var $ArrayBuffer = $buffer.ArrayBuffer;
	  var $DataView = $buffer.DataView;
	  var arrayForEach = createArrayMethod(0);
	  var arrayFilter = createArrayMethod(2);
	  var arraySome = createArrayMethod(3);
	  var arrayEvery = createArrayMethod(4);
	  var arrayFind = createArrayMethod(5);
	  var arrayFindIndex = createArrayMethod(6);
	  var arrayIncludes = createArrayIncludes(true);
	  var arrayIndexOf = createArrayIncludes(false);
	  var arrayValues = ArrayIterators.values;
	  var arrayKeys = ArrayIterators.keys;
	  var arrayEntries = ArrayIterators.entries;
	  var arrayLastIndexOf = ArrayProto.lastIndexOf;
	  var arrayReduce = ArrayProto.reduce;
	  var arrayReduceRight = ArrayProto.reduceRight;
	  var arrayJoin = ArrayProto.join;
	  var arraySort = ArrayProto.sort;
	  var arraySlice = ArrayProto.slice;
	  var arrayToString = ArrayProto.toString;
	  var arrayToLocaleString = ArrayProto.toLocaleString;
	  var ITERATOR = wks('iterator');
	  var TAG = wks('toStringTag');
	  var TYPED_CONSTRUCTOR = uid('typed_constructor');
	  var DEF_CONSTRUCTOR = uid('def_constructor');
	  var ALL_CONSTRUCTORS = $typed.CONSTR;
	  var TYPED_ARRAY = $typed.TYPED;
	  var VIEW = $typed.VIEW;
	  var WRONG_LENGTH = 'Wrong length!';
	
	  var $map = createArrayMethod(1, function (O, length) {
	    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
	  });
	
	  var LITTLE_ENDIAN = fails(function () {
	    // eslint-disable-next-line no-undef
	    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
	  });
	
	  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
	    new Uint8Array(1).set({});
	  });
	
	  var toOffset = function (it, BYTES) {
	    var offset = toInteger(it);
	    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
	    return offset;
	  };
	
	  var validate = function (it) {
	    if (isObject(it) && TYPED_ARRAY in it) return it;
	    throw TypeError(it + ' is not a typed array!');
	  };
	
	  var allocate = function (C, length) {
	    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
	      throw TypeError('It is not a typed array constructor!');
	    } return new C(length);
	  };
	
	  var speciesFromList = function (O, list) {
	    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
	  };
	
	  var fromList = function (C, list) {
	    var index = 0;
	    var length = list.length;
	    var result = allocate(C, length);
	    while (length > index) result[index] = list[index++];
	    return result;
	  };
	
	  var addGetter = function (it, key, internal) {
	    dP(it, key, { get: function () { return this._d[internal]; } });
	  };
	
	  var $from = function from(source /* , mapfn, thisArg */) {
	    var O = toObject(source);
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var iterFn = getIterFn(O);
	    var i, length, values, result, step, iterator;
	    if (iterFn != undefined && !isArrayIter(iterFn)) {
	      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
	        values.push(step.value);
	      } O = values;
	    }
	    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
	    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
	      result[i] = mapping ? mapfn(O[i], i) : O[i];
	    }
	    return result;
	  };
	
	  var $of = function of(/* ...items */) {
	    var index = 0;
	    var length = arguments.length;
	    var result = allocate(this, length);
	    while (length > index) result[index] = arguments[index++];
	    return result;
	  };
	
	  // iOS Safari 6.x fails here
	  var TO_LOCALE_BUG = !!Uint8Array && fails(function () { arrayToLocaleString.call(new Uint8Array(1)); });
	
	  var $toLocaleString = function toLocaleString() {
	    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
	  };
	
	  var proto = {
	    copyWithin: function copyWithin(target, start /* , end */) {
	      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
	    },
	    every: function every(callbackfn /* , thisArg */) {
	      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    fill: function fill(value /* , start, end */) { // eslint-disable-line no-unused-vars
	      return arrayFill.apply(validate(this), arguments);
	    },
	    filter: function filter(callbackfn /* , thisArg */) {
	      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
	        arguments.length > 1 ? arguments[1] : undefined));
	    },
	    find: function find(predicate /* , thisArg */) {
	      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    findIndex: function findIndex(predicate /* , thisArg */) {
	      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    forEach: function forEach(callbackfn /* , thisArg */) {
	      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    indexOf: function indexOf(searchElement /* , fromIndex */) {
	      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    includes: function includes(searchElement /* , fromIndex */) {
	      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    join: function join(separator) { // eslint-disable-line no-unused-vars
	      return arrayJoin.apply(validate(this), arguments);
	    },
	    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) { // eslint-disable-line no-unused-vars
	      return arrayLastIndexOf.apply(validate(this), arguments);
	    },
	    map: function map(mapfn /* , thisArg */) {
	      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    reduce: function reduce(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
	      return arrayReduce.apply(validate(this), arguments);
	    },
	    reduceRight: function reduceRight(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
	      return arrayReduceRight.apply(validate(this), arguments);
	    },
	    reverse: function reverse() {
	      var that = this;
	      var length = validate(that).length;
	      var middle = Math.floor(length / 2);
	      var index = 0;
	      var value;
	      while (index < middle) {
	        value = that[index];
	        that[index++] = that[--length];
	        that[length] = value;
	      } return that;
	    },
	    some: function some(callbackfn /* , thisArg */) {
	      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    sort: function sort(comparefn) {
	      return arraySort.call(validate(this), comparefn);
	    },
	    subarray: function subarray(begin, end) {
	      var O = validate(this);
	      var length = O.length;
	      var $begin = toAbsoluteIndex(begin, length);
	      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
	        O.buffer,
	        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
	        toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin)
	      );
	    }
	  };
	
	  var $slice = function slice(start, end) {
	    return speciesFromList(this, arraySlice.call(validate(this), start, end));
	  };
	
	  var $set = function set(arrayLike /* , offset */) {
	    validate(this);
	    var offset = toOffset(arguments[1], 1);
	    var length = this.length;
	    var src = toObject(arrayLike);
	    var len = toLength(src.length);
	    var index = 0;
	    if (len + offset > length) throw RangeError(WRONG_LENGTH);
	    while (index < len) this[offset + index] = src[index++];
	  };
	
	  var $iterators = {
	    entries: function entries() {
	      return arrayEntries.call(validate(this));
	    },
	    keys: function keys() {
	      return arrayKeys.call(validate(this));
	    },
	    values: function values() {
	      return arrayValues.call(validate(this));
	    }
	  };
	
	  var isTAIndex = function (target, key) {
	    return isObject(target)
	      && target[TYPED_ARRAY]
	      && typeof key != 'symbol'
	      && key in target
	      && String(+key) == String(key);
	  };
	  var $getDesc = function getOwnPropertyDescriptor(target, key) {
	    return isTAIndex(target, key = toPrimitive(key, true))
	      ? propertyDesc(2, target[key])
	      : gOPD(target, key);
	  };
	  var $setDesc = function defineProperty(target, key, desc) {
	    if (isTAIndex(target, key = toPrimitive(key, true))
	      && isObject(desc)
	      && has(desc, 'value')
	      && !has(desc, 'get')
	      && !has(desc, 'set')
	      // TODO: add validation descriptor w/o calling accessors
	      && !desc.configurable
	      && (!has(desc, 'writable') || desc.writable)
	      && (!has(desc, 'enumerable') || desc.enumerable)
	    ) {
	      target[key] = desc.value;
	      return target;
	    } return dP(target, key, desc);
	  };
	
	  if (!ALL_CONSTRUCTORS) {
	    $GOPD.f = $getDesc;
	    $DP.f = $setDesc;
	  }
	
	  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
	    getOwnPropertyDescriptor: $getDesc,
	    defineProperty: $setDesc
	  });
	
	  if (fails(function () { arrayToString.call({}); })) {
	    arrayToString = arrayToLocaleString = function toString() {
	      return arrayJoin.call(this);
	    };
	  }
	
	  var $TypedArrayPrototype$ = redefineAll({}, proto);
	  redefineAll($TypedArrayPrototype$, $iterators);
	  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
	  redefineAll($TypedArrayPrototype$, {
	    slice: $slice,
	    set: $set,
	    constructor: function () { /* noop */ },
	    toString: arrayToString,
	    toLocaleString: $toLocaleString
	  });
	  addGetter($TypedArrayPrototype$, 'buffer', 'b');
	  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
	  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
	  addGetter($TypedArrayPrototype$, 'length', 'e');
	  dP($TypedArrayPrototype$, TAG, {
	    get: function () { return this[TYPED_ARRAY]; }
	  });
	
	  // eslint-disable-next-line max-statements
	  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
	    CLAMPED = !!CLAMPED;
	    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
	    var GETTER = 'get' + KEY;
	    var SETTER = 'set' + KEY;
	    var TypedArray = global[NAME];
	    var Base = TypedArray || {};
	    var TAC = TypedArray && getPrototypeOf(TypedArray);
	    var FORCED = !TypedArray || !$typed.ABV;
	    var O = {};
	    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
	    var getter = function (that, index) {
	      var data = that._d;
	      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
	    };
	    var setter = function (that, index, value) {
	      var data = that._d;
	      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
	      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
	    };
	    var addElement = function (that, index) {
	      dP(that, index, {
	        get: function () {
	          return getter(this, index);
	        },
	        set: function (value) {
	          return setter(this, index, value);
	        },
	        enumerable: true
	      });
	    };
	    if (FORCED) {
	      TypedArray = wrapper(function (that, data, $offset, $length) {
	        anInstance(that, TypedArray, NAME, '_d');
	        var index = 0;
	        var offset = 0;
	        var buffer, byteLength, length, klass;
	        if (!isObject(data)) {
	          length = toIndex(data);
	          byteLength = length * BYTES;
	          buffer = new $ArrayBuffer(byteLength);
	        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
	          buffer = data;
	          offset = toOffset($offset, BYTES);
	          var $len = data.byteLength;
	          if ($length === undefined) {
	            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
	            byteLength = $len - offset;
	            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
	          } else {
	            byteLength = toLength($length) * BYTES;
	            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
	          }
	          length = byteLength / BYTES;
	        } else if (TYPED_ARRAY in data) {
	          return fromList(TypedArray, data);
	        } else {
	          return $from.call(TypedArray, data);
	        }
	        hide(that, '_d', {
	          b: buffer,
	          o: offset,
	          l: byteLength,
	          e: length,
	          v: new $DataView(buffer)
	        });
	        while (index < length) addElement(that, index++);
	      });
	      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
	      hide(TypedArrayPrototype, 'constructor', TypedArray);
	    } else if (!fails(function () {
	      TypedArray(1);
	    }) || !fails(function () {
	      new TypedArray(-1); // eslint-disable-line no-new
	    }) || !$iterDetect(function (iter) {
	      new TypedArray(); // eslint-disable-line no-new
	      new TypedArray(null); // eslint-disable-line no-new
	      new TypedArray(1.5); // eslint-disable-line no-new
	      new TypedArray(iter); // eslint-disable-line no-new
	    }, true)) {
	      TypedArray = wrapper(function (that, data, $offset, $length) {
	        anInstance(that, TypedArray, NAME);
	        var klass;
	        // `ws` module bug, temporarily remove validation length for Uint8Array
	        // https://github.com/websockets/ws/pull/645
	        if (!isObject(data)) return new Base(toIndex(data));
	        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
	          return $length !== undefined
	            ? new Base(data, toOffset($offset, BYTES), $length)
	            : $offset !== undefined
	              ? new Base(data, toOffset($offset, BYTES))
	              : new Base(data);
	        }
	        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
	        return $from.call(TypedArray, data);
	      });
	      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
	        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
	      });
	      TypedArray[PROTOTYPE] = TypedArrayPrototype;
	      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
	    }
	    var $nativeIterator = TypedArrayPrototype[ITERATOR];
	    var CORRECT_ITER_NAME = !!$nativeIterator
	      && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
	    var $iterator = $iterators.values;
	    hide(TypedArray, TYPED_CONSTRUCTOR, true);
	    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
	    hide(TypedArrayPrototype, VIEW, true);
	    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);
	
	    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
	      dP(TypedArrayPrototype, TAG, {
	        get: function () { return NAME; }
	      });
	    }
	
	    O[NAME] = TypedArray;
	
	    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);
	
	    $export($export.S, NAME, {
	      BYTES_PER_ELEMENT: BYTES
	    });
	
	    $export($export.S + $export.F * fails(function () { Base.of.call(TypedArray, 1); }), NAME, {
	      from: $from,
	      of: $of
	    });
	
	    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);
	
	    $export($export.P, NAME, proto);
	
	    setSpecies(NAME);
	
	    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });
	
	    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);
	
	    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;
	
	    $export($export.P + $export.F * fails(function () {
	      new TypedArray(1).slice();
	    }), NAME, { slice: $slice });
	
	    $export($export.P + $export.F * (fails(function () {
	      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
	    }) || !fails(function () {
	      TypedArrayPrototype.toLocaleString.call([1, 2]);
	    })), NAME, { toLocaleString: $toLocaleString });
	
	    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
	    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
	  };
	} else module.exports = function () { /* empty */ };


/***/ }),
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 88 */,
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var lbPoiSelect = angular.module('app.lbPoiSelect', []);
	
	lbPoiSelect.controller('lbPoiSelectCtrl', __webpack_require__(1226));
	lbPoiSelect.component('lbPoiSelect', __webpack_require__(1225));
	lbPoiSelect.filter('poiHighlightFilter', __webpack_require__(1227));
	
	exports['default'] = lbPoiSelect;
	module.exports = exports['default'];

/***/ }),
/* 90 */,
/* 91 */,
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.31 Array.prototype[@@unscopables]
	var UNSCOPABLES = __webpack_require__(10)('unscopables');
	var ArrayProto = Array.prototype;
	if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(25)(ArrayProto, UNSCOPABLES, {});
	module.exports = function (key) {
	  ArrayProto[UNSCOPABLES][key] = true;
	};


/***/ }),
/* 93 */
/***/ (function(module, exports) {

	module.exports = false;


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

	var META = __webpack_require__(143)('meta');
	var isObject = __webpack_require__(7);
	var has = __webpack_require__(36);
	var setDesc = __webpack_require__(16).f;
	var id = 0;
	var isExtensible = Object.isExtensible || function () {
	  return true;
	};
	var FREEZE = !__webpack_require__(6)(function () {
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function (it) {
	  setDesc(it, META, { value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  } });
	};
	var fastKey = function (it, create) {
	  // return primitive with prefix
	  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return 'F';
	    // not necessary to add metadata
	    if (!create) return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function (it, create) {
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return true;
	    // not necessary to add metadata
	    if (!create) return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function (it) {
	  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY: META,
	  NEED: false,
	  fastKey: fastKey,
	  getWeak: getWeak,
	  onFreeze: onFreeze
	};


/***/ }),
/* 95 */
/***/ (function(module, exports) {

	module.exports = "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAYEBQYFBAYGBQYHBwYIChAKCgkJChQODwwQFxQYGBcUFhYaHSUfGhsjHBYWICwgIyYnKSopGR8tMC0oMCUoKSgBBwcHCggKEwoKEygaFhooKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKP/CABEIBDgHgAMBIgACEQEDEQH/xAAbAAEBAQEBAQEBAAAAAAAAAAABAAIDBAYFB//aAAgBAQAAAAD8BaallpmllZmWmUWVmmZlaaWWpppmkZqmaqmqpKqqoqqooqoqKooooIioAoIIiAoAKCCCKAooIgCIEqKCvVTTStMtMrMrNMy0ssrMzS0tM01LNM1NVNUjJU1VUNRVVESVFEVRRBWUigIiIAIoIAgIiAooIKCzEEUVmqC9dTK00pqZllmZWm1MytamZpaZmmWmaamWqkYlJqqqqJiqoqhiiooqKgogIKICIICAiCAIiAigiATIVEREFBeuZWmZmlWZmVlRdUsyyzSzM0zMzM00zTVNU1VVVDVVFVJFVVURRQhRERBEEEQBBAQWYIgIgKIAogCIKgIgvZKzTNKsyzSrMqzallpmWZmlmaWWmqWppqqaqSqpKqqqEqoqiKqKiIis1miLNAQFmIACAKCCIgiyRFZKAiLMQXtZaZmtMszMrNq1MqszSys0y0ss000zTTU1VU1VE1VVVVVURVRVBUUUFEQEFARAQBAAWYIiIICgAIgogIAID9CaZmVZllmWVWl0zMyrNLMszSzTTTS1TU1TVTFVVVVVVUVRVFURURUERBBQEEBAAEAAEUVmAggjMFEQWSyAWf0WWmVZZZZmXUyrKyysyzKoszUzNS0zTNVNU1UVNVRNUJUVFVFRRUFFBEREBBAAQWSyGbNFEFBZICACIiCyZDMZ/TlmVZlWWlVllWVlZVmZZZppmWaZpqWqaqmqpKqqqqqqqoqKioooqIIioICAgAAIyZsgRUUEFZswAEEEQGchkD9NVlllVmVmVlVWW1KzLMstSzJqZpmmmmqaqmKaKqqqqqqopKqIqigqgoKCiCAAMgWQMmchTVQARAABZoIADJkMh+orKzLqWdTLKyqyqyszKzLMtM0y0tTVNTVMNVVUlIxVTUVQxCVFFRFEERQUQEGQzkgzZyYyFLNQFkgLJAEEAZM2chk/VVZm0rKrLam1MrplZlllZlaUWZpZpJppqmqqqmqqqqhGqhqooqKgqgohzEREEAGc5DJBjOc5zVOrVAUZAAswBEZDIGcgfqqyzpZZ1KysqqrMqzamVlaZmlmpmmmpqqaSaGqqqqqqimay1FRRUFUUREURZoDJgzjNmyZMYzkLU61KBBBmAAIAshkMhkz+srNpZXTWpVbUqss6lZWWZZpZaZpmpmqmpqqakpKphKqqqqqiqioqKIqiIKKIshkxjOM5zGTOcYziXW9aWoIAAAAgMxmyZAyZ/WWVVtLalVVlVZVbUrLKzNLMtS0zTVI1TVNVVVU0VVTUTUVVRFRVFRRRUWaigMmc4xzxjOQDOMYxmtdN71rTBEGYDIBAZgMhkyB+qq2pVVZ0q2llVZVWZWZaVpaZmaWimpmqaqqqqqqqqqqqqqqKqKKKoqIoiiIjOc4xy5455yZDOcc84nW+nXe3VAWaDIBmAAAyGTOS/VVVZdMulbUqqyqqyyrSyy1SzTNNU1LVVVTVVVVVVUlVVVFVVUUVRUVQUVFZiyYOfPly58sGQDGOeAt9OnXrvWmIAAsgAAAAZDOch+uyqqqqqs6VVWVZlVNSszNNMzTTTVNVVTSTVVVVVVVVVVRVVCVRFVFEUVRRAZzjny5ceXLGcgZzz55yO+nXt16b3MWbIAWQAsgFnIZyGf15nSq6WW0q6Z0rLKrLLLMtMzTUtTU1VU1TVVTVVVUw1ExVVRUSRVRVEFFRVEWQxjnx48ePLGMgZxnljJrXXt27dOm9VWYzZAAIzGQDNnJnJ+orq1pV02lXTKq6lZVtTLStNMzUzNTVU1TVNVNVVVVVVVVVVVRVUUNBUIQRVRUAZzz58OPDjx55zmyc8c8ZHfXt379OvTShZswAZIDNkAyGTOb9FVdbXSunSqqq6lWVZmWWaUWppamqamqamkqqpJqGhiqqqqqqiqoqoogsxFUlVnOcY5cOPDhx54wBnHPnjI769vR279euliAAADMBmM5zZs5A906dOta1rWtK6VVVVZW1SytM0zUzTTU0zC1VVTDVVVSVVVVVVRVVVFVRVWYACKamIznHPlw4efhy44xkM454xkd9O/o79+/TetEABBmzmzGSzkDIZD0K61vW9b1rWtaVV0qs2pZ1WpmmaaaZpmNVIzVVVNVTVDVVVVVVUU1RVFVUVRAGQIpmaLOMcuPHh5+HHlzxnJnPPHPA769/R39Hfr01qjMARkAyABkAyZBdL01vpve963rS6tKqsqyrNammmpaZqmmapqpqmoaYmqqqqqqqqsyMVVUVRUWcmTIUtqaLGccuPHzcOHHlywZznPLGMDvr37+j09+vXWqALJQGQMlkyAZyGeDrW976dOnTfTe9utKqqqrLLUrTS0zTTVNNNUktUM1VVVVVVVVVVUVVJUNFRFZzkznOSl1plDOMcuPDz+fhx488ZM4xzxjA76ej0ej0enr02oZIqCzZAyAZDJkM/nrvXTp169O3TrvpretK6W0srLU0rMy1NUs01TVNMNNDVVVVTVFVJVVDVVVFVURRZznOMZzVa1tdUYzy58vN5/Pw48eeM4yc8Y55HXX0d/R6fT16uiAKqgCyGTIBkM5Pxp106devbr36dunXe9bdKqqtLNVMqy1VSszU1S0VLVVVMTRNVFVNUVQ1DVVVREkGDPPGM5zLrW9aas45c+Pn8/n4cOXPnjOc4xjGR109Hf0+j0deukM5qrVUABkM5AyBn5t1rp069u3bv37denXpvelVVZZaqqVZWqmllmpqapqqqpqqqqqqqqqqIqqaqqoYojOc5588YwVret62tZxz5cfP5vPw48uXPGc4znnnA769vR6PR369GM5zS6dUlkADOTIGQ+Tnpvr169/R29Hbv169em9aV0zKzMVVKqtVUsrNM1VNVTVVVVVVVVVVUMBVTNVVVURGc4zz58+eCta6b3rShjny4efz+fhw5csYznGM884nfXt39Hp69dVnGMjrW961NGQAMmcgGfjTWunXt17ej0d/R37du3Te9a0rLMokVUrpWhKZXTSjVTVNVVVVVVVVVVVRQFVMzVVVUQZxnHLnz54yOt76b1tQzy58PP5/Pw4cefPODnnGM4nfXt37+jtvRnHPnmd76dN600BmAMmTIZ+HnfTp27du/o9Ho9Hbv369OmtLqWlaggpXS6YoqdWlZSamqmqqqqqqqqqiqqICGmZmqqqrJnGefLny54yWt9N73t1Zzz58PP5uHn4cufPGDGMZxmd9e3fv366jny5cg106devTelozQRksZzk+Eta6denbt39Hf0+jv6PR26dN60q0s1AZKtOtaaiJZXTpopmamqqqqqqqqiiqqiAKpaWmmooAxnly58ufPJa1vpve9ajPPnx83n4efhxxyxjOcZxkHe+/ft36Jjlx5csWunXt17dNaYgkQDOM5z8Ia106dO3Xv6e/o9Po9Hft26726mdS1BkCpda0tAE6XTpWqpZpqqqqqqoaCiKqoIAmlmaZmKIxnHPlz5csYJ1vpve9rZ58uPDz+fz8eHPnjGc5xnBO99u/bt0s8uPHhxxa6du3bt03pYqlgM5xnPwlrW99evXt39Po9Po9Po7duu97lVWYDOQBda0rQFTrWnTqaplmqqSpqiYqIizFTWYgKaWpWaaoyYxz5c+XLGMzrW99N70hz58fP5/Pw48eWOec4znOCd769+3Xdz48OHDjg1069+3brvTVKq1nGc4z8PO9b69Ovft6PR6fR6fR6O3TpvWlW0zBnOchTvSrBAzrWtaVaplZkqmpKSqoIMgVVUQRVNMyyzVBnOOfLlz58+YWtb3ve9tnHPjw8/n48OPLGMZzjOcBrfTr269d558fP5+HDnnXTr37deullnetOqznGeefjLWtb6dOvbt39Hp9Hp9Ho79Out6W0ssZM5zkF1tViCpda1vSzVNq1MNU1VVVUAZMwFNRAVVVNpWWmIMc8c+XPlzwZnWt73vWoxy5cOHDhx48sYxnOc4wTvp07dOqc+HDzebhyzrfXt267VrTre971Wc4xjPyU63vp06de3f0ej0en0ent26a3pVVaAxnGSV1rSkBVp1rWtaViZVWSppqqpgAyGcRDVQEIxTM6VZqDOcY58ufPngKta101pTGOXHz8ePDlz54xnOc4zmd769enTWeXDz+fzefll106dd7pp3vp16b0hnHPGPml1rp06dOnbt6fR6O/p79u3Te1dOlZM5znGcsutaagql1vWtaWqV0zNUzTUNUAGc5M5gSaIKEYpV02pqAzjHPnz588mSV1rbqMZ58eHLhy5csYxnODGczrpvr02558PN5/P5+fO1re9KVa3vp269NMY5454/D1ret9OnTp179vR6PR6O/br01vS606VgznGAFdaWSKpda1vSsi2nSzVNNVNVABjOc5zEVVBElSMqq1NBnGMc+fPOc4Jna6oMc+XLjy5cueM4xnOcZyOumunTTnlw4efz+fnzJ06rIzvp169O20zjHPHPwOt76dN9OnXt379/R379um97XWtadLWc5znJSulZiJV1rWnVTOl06mqZkqqSgznOc5zkKoqIpoqptKtJJnOcYxzxnOAKZVgxzxy48ufPnjOM4M5xkXW9dNWefDhw8/DlzzVVnMTvr069uu0xjHLGcaem99N769evft37+jr16dN6dutOtOiDGc5K0qrNVS6dadLUrp0rVMtRSVVGcmcYMgQ0VZaqollZqqDOc4xjOcABVSQZxz58+fPnjGcZznOcZJda0uOfLhw4ceXPAAZMhO99OvXp0jPPnzzj16103ve+nTp27de/bv26dd61rWnWtadUZzkCVZWZhp0606WpXTpaalpiKmoDOTGc5CKEhKqqqmZaKIznOc5znJkCzVWbOcYxzxjnnmYznOc4zmtTqM45cePDly54MmTGc4K3vp06b1WMY54P2Na3ve976dOvbr17duvXpvetOta1rSoAASqqzTU2l06WmXTrVTUyIVVVUZMZM5AKiiqmiilpqiAMmTOchkM2YKM5MZzzxjGM5xnOc5zjIlqjPPny48uXPnjOc5zjGcZHW9dNdJMYxjOfpNb3vW9dN9OnXr269evTpvW9Ota1pVrJBVpV1K001tXUtKrpappSgqqYgzkznIFEJFTJJFNVREGQM5AyAZLIBkznOM555xnOc5xnOc5MxVnOOfPly54xzznGcYxnGK0626YzjPPB9fre9b3rW+m+vTt07dN73vWnWta0q1BEy6VdK0zWlXU02lZpqWIiqpogyZMgURVVUxVFVERmAAyAAAZDIZM5znBnGM5znOc5xnOTIAZzjGOfPnjGMZzjGMZxnIquoM5xnOfuNdNa3rW9b3vr069d76a3rWta06XVUVLKrpVVmZVVpZVRpqkoqGpojObIBREVU1UURVmgzBZshEAGTJnJkznOc5znOM5znOc5znOc5M2c4znHPHPOMYzjGeeM4yBNJZyZyH3m971vTrW9b6dOnTpvet7da07dWmqmWVXSqqrMtqWmVmpqmiIqaagAyQRRFVNVBEQEEBZAgoAyGTOTOTBjOTODBjOcmc5zgwZznOc5xjGM4zzzjGM4xgyZikyZDIf0DfTWta063re99N73vetu3WnTpZaZVVXSqqsqstWppqpqkrNEzNQQAERRVVTQRBAQABZiCIDJkMBnOcmc5znOc5znOc5MZznOcZznOc4zjOcYxnGMZxnGcmQiAAA/oO971rS6273vpret7271rVrS7lWltLOnSqupW1amamaapqooKmpqoCzRFEVVVUQAQEFkgCKAAyGTOTOc5M5znOc5wYMmc4znOM5xnGTOM5zjOMYxgxnGcmQAgAC/oO971pda1rW9dN63reta1rTp06VVlbVpV0qqrKsszNTVVVUVUTNVBFmoKiqqEiyEEQEAQERBkDJkznJnOc5M5znOM5M5zgxnOcZxnOc5znOcZxnPPOc4xkMGYIMkB/Qem96dOtbda101vW9a3rWnWnSq6VWVW0rpVWVm1M1qqpqqoihFGqoIioKKhoqALMRBARAEEGQs5M5zkzkxYznOc4MGc5znOc5zjODBnOc5xnOc4zjOc4M5AAyAQf0He961p1rWnet63rW9a061rTpXS6VlWZ0rpWVZtUszU1VSRVCTVJVQVRURRVFABEFEAQQEWYMhnJnOcmTOcmM5zgzkwZznBjJjJgznJnOM5zjOcGc5M5ADJkgP6DvWt61rWnbvWt61rWta061p1q06lVllW0qqrNqZmZmpqkqKhKapKKKoqISoKygBBUUEBZiALIZMmTOQznOMmc4zkznOcmc4M5M5zkzkznOcZMZzkzkyZAyGQA/oGt63vWtada3reta1p1p060ul0qrMrMqqqszKzLNNJU0RVUjExVBVFFFFQRBBFVEWYLIEAWcgZM5DOc5znOc5yZzkyYM5M5DJkznJnGcmc5yGDOQMmTOQD+ga3rbvW9a1rW9adOtadOl06VdMszMrK6lllmZZlpqqqiqKSkqqiqqKCKCiIgoqKICMwBAAAZzkyYM5zkznJnIZznIBkMhnJnOTOc5M5MmcmTJkM5yGfv9b1vWtb1rWta1rWtOldK7ZdLSsyzMrKsy0tqrVTTTFVRVVVVUVVFEUEIRBFRVREQGYIALMAZyZMGc5yZMmchkzkACDJkznJkzkyZzkyZM5M5M5Mn3uta3reta1rbrWta0q6VVVWW1TTMzKtqlaWlaZqaqiqKmJKiqqKKqzFEREJUVEQEAEBFmCyZyZM5yZzkDJkyZgAosmcmTOTJkznIZznJnOc5yZD7vetb1vTretOtadKrpZ0qzLNNLMs6mWlplmmpqqqqKqqpKimKooIqCiIoqqIswQQEFBBZDIZyZyZyGcgZgIogDJkyZzkyGDOcmTOc5znOTOfu9a1t3rWta1p1p0qqrKsq0zMzTLK0y000zTVVVVVVUVVVFUNFBBVEUUVUURAAQUUUFkMmTJkzkAyZsgFCUAZDOcmTOTOcmc5M5znOc5znP3O9a1rWtb061p06VlWVlrU0zTMzKzM00zTNVVTRVVVVQiSVRFQkUQVFRJUREEAUFFEQGcmTJkMgGQAKJILIZDJnJnOTOTOc5znOc5znOc/cbd61rWtadadaVWVlZllpaZmaZWmaapmaqqaqhKSqqiqqoqKoiiiqKiqIiAsxEQgkRkDJnIGbIGQAhoiDNnIZM5M5M5znOc5znOc4M4PuHWtbd6da060qqyzLLMzTSzMy0zTTTTU1VVVVVVVVFVVUQxFRUUVQVRREQBBVEVEABnIZADMZAIqhAMhnIZDOcmc5znOc4znOcGc5+4duta1p1tdaXUsrIrSzUyzMs1LM1UtU1VUxVMMUxVVVVVFREVFRUVEVQQQQVFFFEBkyBkzZsgFmIqggzkMmQM5M5znOc5znGTGc5zn7d1rWta070unSyyrMtTNLTLLNSzTUlqqmqqqqaqqqoqqqqKoKqKioioqIiIAoqgqIshkyAGQAAIKooDIZyZDJgM5znOTGM5znOc5z9trTrW3WtadLpVlZlmmalmbVM1LItWhqqaqmqqqqqqJiqqBqCqKGKIqioigCCKgqKgsmQMgAZsgVmqIgDJkyZDOTOTODOM5xnOc5wZ+3061rTrWtOnSqsszLTM0zSszI0zNNNVNVU1VVVVVVFVRE0FRUSVBVRUQRAQEVVFQAZMgZIyABEVERmM5yBkyGc5DmZxnOMGM5yY+5XTt1rWnWnSqszSrTNVoWWUaWaaaq1VNVVTVFVVVVVVRVUFRVQVFFRRREBBFRVFEAZyBkADMBBRQQWc5DIZMhnJnBnOM4znBjOc/cOtOtada1p1pbVqrVNqaamZmWaZlqZGpaqaqqqqqqqqqiomKKioqHKVmkoKIgiKgqigADIZAMgAQFUQQZsmchkzkM5M5xnOM4M4yYz9wunWtu3TrS6ZWWmbVTUyzMzMyapGarVVI1VVVVVRVVE0RVFUVVZqoKqgos0BQVVEVmAMmQyAZCLMVQFGQDOTIZDOTOc4znGc4MZM5+3V1p2626daXUy2ppmmamVmlplFGaamRqhqpqqqoqqokKoqKqoKKqooKiAIiIqqizAZyZAyZshARQVQAGTJkyBkznODGM5zjOTGc/cNp1rTrWtOnTaZVplpppmVpmZpmaaapKWoppqqqCqqqoqiqKoioqKhgiskREVFVRZDIZDIZAzABFRUAAGTIZDIZxkzjOM4znOc5z9s6dOtOta1p0qtqWlmmaZmWZmmWmmmqapkkpqSkqGqqgqoqooioqKiEoiAgoqKKoDIBkMmQDNkIiqIIIM5DIZDOTOc5znOMGDOM5+01p061rWtOnWlZtM1qmaWmp1TNSy1M1NTVS1VVVVVVVVEVRUJRFFUURVCEEBEURQ1kAAyBkMgZCCIqogAyZAyZzZzkxkxnODBnGc/Z606061rWnTp0s2laWmmZmZpZqWWpaaqaqWqqqqqoqqKqiqCoqIqoKqiCCAgqzVFEBBnIZMhmMhBFVQEBkDIZMhnOcmDGc5MGM5z9lrWnWnWnWta1aVWl1TTNMzSzLNTMzLTUk1U1JUxNQVVVVWaqCioqoKqgoCAiCgoYoCzGDIZMhZACKGIIAADOQyZznJnJgznOc5znP2OtOtOta1rTp0q6mWllpppmZmaWmllmqmpqpqqEaqKqqioqgoqCqiKhIgICgIiohILIZM5DIBkAIqooAgMgZM5DOcmc5yZznOc5zn7Jda061rWtLp1qdMyytM01Ms00zNMzNNNVNTVVVVVVRVVVQRQRQlRQVRAUEBBRRUQEZMmTIGQAyEVVQQABmyZyZMmcmcmc5znOc5x9munWta07XWnSqrSsrNUzSzM1MzM1LUtVTU1VVVVUVVRVEREFRUURURQRZjNBFFURGc5DJmyZADMRVRQEGQDOTIZM5DAGc5znGc4+y060u3brTrTpVVmZZaamZaZmmaWlpmmmqamqqqqoqqioKiIIqiiISiCgAIiCKoiDOTIZDIBkCAqmCAAAzkM5yGTOQM5M5zjOM/Y7Xa61rWnWnWlVWZmZmmmWZmpmWlaZaqRaamqpioqqioKiIiKiogioiCAiAgiqKADJnIZAyGQCKqKCgzGQyZyZM5MhkDOM5zjOPstOtLrWta1p0606lVmpaaZmZmaallplZpqpRaqqqqqoQYSIgczmooggqIiCCCCIKooAyZM5DIGQMhENRFAABnJkyGc5MmYzjOc5xnH2bq1rWnW9Lt06dKsrNMpM02pqaZpZZlaamlqSpqKqSoiqooIoiiKzRBUFAQQUEFUUGQyZyZAzZMgARVVBBBkyZDIZzkyZM5M4zjOcfZunWnWtOta1rSutSrLNM000srTIzLLLLNU1NTVVVVUUVVFFBERREQURQRBAUEFFFABkMGQMmQDIEFMJBABkyGTJnJkzkznBnGc4z9lt06061p1tdadK6bUy1NMzMyzTUyzaWWTVU0wtVVVRRVRRUFQURREBFFEEEFAFZSioMmTOTJkyAGQAqqogLIZDIGTOcmcmTGTOMGM5+0dOnTrWtO9OnSqqqy1MtMzMzTUrNpWZamqmZqqqoKqKgYKKCKIiAqKKzBARBEUVAAZM5yZMmQAzAUVURZjIZyAZyZyZyZznOcZznBj7V1p1a1rTvWnWlbSraWWmaWaVmmpmVbTLLVTTM1VRCRVVFEURBEURBUUQEFmIizRFFABnJnJnJkDIFkiqKIsgGQDJnJnJgM5xnOMmM5z9rpdaXWta1rTp0qqqrLNqpaZWmmm0LaVZmaYWapmCqKqqKoIKAgqIIoigiAIiCCKKIDJnOTJnJkyQARVEQBZMgGQzkxkzkznOcGM5znP2y6dada061rS61alVVlZaWlmWaaVptKyszNTTVVVVFVFUUQEFEFAQVRQRAEFZoKCigMmc5yZyZyBBmgc1AWYyABkMmc5zkzkznGTGc5yfaadOtadOta060ulVtWq1KzNLKzM0yjaVtSzMtTTVVVRUVRRREBAUUAURVBWbMQREBEVAZDJnOcGTMFkiAqCyEZDMZs5M5znJkznJnOcZM4PtNadadadOta1rTaVVWdSs0zLM6mlqZZdSsyzMzTVVVEVQVRRAQARQUUFUQBARERmIoiM5Mmc5zkyBAQQRFmzGbIGQyBjOchgyZMZznOcn2jpdutOtadunS6VtStqVlmmVlpamWVVWVmpWaqqqKooqKKgAAgogoKoiAIIKMxBRBGTJnOc5yZCAiCM1GYjJkzZAzkznJnIZM5znOc5M/aK6da1rTrTrTrU6VWl0pqVpmVaZmZadKrKtSzTTVVFEVUURQBmCKAiCqKIACCgICKCAyZznOcmQzAQQEWYgDIAZAznJkzkyGcmc4znJ9mul1rWtOtOtOnSq2pbVpmWmZtTLMyysrpVtErTNTVURRVFERBGQgis1mIoQgCIIACIIoDJgyYM5MkAQQWYgACDIZMmTIZzkMmcmc5znP2LrS61rWtLrWtOlVVlVZVmlmWWlllbSqqsy01LTVFBFVRQRAABEQGYiqgKAAgIzBUQAZznOchnIZgLMQWSCALIAZzmzkDIZM4DAYzn7B06dO3WtO3WnTqVVWVtTLMszLLS2lbTpVZlappaaKgiqKgiAzAQQABE0QQZrMBAEFBRkzkznJkyGckEFkICCAAAyZyGQAyZzkM5zkx9dpda061p1rWtO21pltMrLKqzSzMrKzrS2tLamlpqlpqiKKiIiIAAIAjMRFEUARmCM0BFEZM5DOcmQMAAQGYCMwWUyWQzkMhZAznIYM5M5+s1p1rTrWnWta060rpZZWVlVZptSss2ldy6V00zSLTVMhVEEUUCZAAAgswFFUBAABAERRBkyGDJnIGcgBABkgAgskGTIBmyAZyZyZMmM/Wa06061p1p3rWl06VlZZVZtTLNqWdSul1qdKrM1TSzVVVEEURRABkAKACIqIzEAWYMxBFEBnJkMmc2cmTNkIAyAWYICyGTIAAGTJkyYM5z9XrWta0uta061rel1pllZVZaVlWWVdWnSul02rVNTVVapmiKCiKKLJks5IiALNREBBAFkCCiKyBnJkDJnOcmQCMwGQMlAFkyABkCyGTJnJkznP1eta1p26dO7eta1p0yrLK2plaVVZ1aXS6XSq6tVTVU1LVVVBEFBEAYAgiACiIgzQBGYAiCgAzkAyZzkzkyAEGQyEAQGQAyGYAzZM5MmTOM/Wa1rWtada06Xet6dOmlVpVllbUsrpVdtp06bUqzVVTNLVRIRARFAGTIBEARERAARAABBFBBkyBkzkznOTIBZADJZgAjIGQMwZIM5yZMmc5z9ZrWtuta061a1rW9OlVZ1NLKqyyqq6dOnS60sys0xNTMzVURAREUGTIBkrMQREQBZiLMAEQQQBkMgYDOM5MgAAZIMwAWQDJkjIBZM5yAYM4+tda1vWnWl061retLq0rMrTKrKzpVV1rTrSrpmWmpqqVpqqKAgiggM5MgARBFBABEEZrJQQQABkMmcmc5MBkAyBZIALMAZDIGQCM5MmQznJj63TvWt606V1rTrWtLp1K0zLKqraZ0urWtOtKqzLM1TTM01VRVkIIrMGchnIEQQRBBARARZgggAAyGTOTOTOcmTIAFmAAIAADObIBZyZM5sBnOfrNa1retbtLp1rTp1rWp1LLSyzqdSq6VbetOlVZaWZqaZWqqqICCKAMhnOQCAsxBBBEFARBmCAADNnJgM5yZzkDIABZIICsgBkMmYMhnJnIZM5+rd63renS6dadOnWnSumZaWVVVVdNqdadaVVlmZmaZrVTVUUEEFWQDJjIAABBEBERQVmACAAyAGTOTOchnJkyAABAUBAAAZMgGTOTAZDJn6nWt71rWtrq1pXWtaXWpdS0ssunUrpbVqXS60rLK0tLStTIxJRAREEGcmDJkAAgiIIigoshAQZDIBkyZyZyGcmTIZgICKCAACyZyFgM5zkyZAz9PvW9a3rTrS6dOl1rWl0qyzMq6VXSyq2ltatKqyzNMsrVUlVEQBRBkznOcmQAIIggoKIKAslmDOQzkAzkzmyZyZMmSCCIKozBmDIYgwZM5znJkA+md71vWta1pdLp1p0utOlWWWXUul0rKtalXSrq0srU0rNU1DFQQRBGc5zkzkMhABZqIgqCKAMkGcmchkDJkMmQznIAEAVFQQZsgGQMmcmM5zkAD6PW97d61rWl0unWtWtOtadSzKq6nTp1LM1qVXU6tLplalpZSqqqrKBBAZznJkzkMwAEFEFEUUAAAZzjIAAZyZMgZzkAAKCqojNkADNkznJnOcZyZoz9Fret63rWtadLp06060u3Sqyqqrp0qrTTOrUrpXSysyszMUklUEBAGc5DJnIZAACCoiCiKgAMmc4yZgAM5MhkzkyGbJQVVFAAAZAMmDOc5xnIFm+g1ret61rWta0utOtOnTrWtKqs6Z0unS6mZpZbSq6VVWlWWSYqqoiAMmQMmTOQMgABBRRZSis1AZznODABAGcmTJnJkMgBFUNVmDIZMkZM5M5zjOcgAfQa1rWumtada1p061p1pda1pXSqqunSutLM1TaldK6VVZW0001FVVEAZMgGchkyGbOYyBFRRRBVQRnOc4znJmAgzkyZyZM5AyEFNVQRkzkADIZyYznOchkD6DWtb1rWtutO3TrWta0utLrTpVdKutOldM1MzOm06XSrKyqzVVVVRFnJnIZMhkMgGQMgBFVEURMRZznGc5zkAgAznOTJnJnIGSCaSqDJkM2QMmTJjOTBkMx+/retO9O3Wta1rTrel1p1p06V0uldadOnStU0q6nS6XSyrK6FqqqKqAwZM5MhnOYAAyZDJFUURUVVBnOeZjJkCLIGc5znNnOTOTJBFNMQZMgZMgZDOc5yZyGQPoNa261rWtLvWta1t1pdadq6XTp06dOtOlVmmVXSurVrUqrWnVNVVRVBkznJnJnOcwAEZyZMhRUSRVVRGc5xjOTOQoAyZznOTOc5DOQzFVTEAZjJgDIGTOcmcmQyH0Wta0utada1reta1rWnTp06XTpXTrbrWnWmaa0q2tKqulVtSramKqqqAznOcmc5wBkCAMhkAqoiqKagDOcYznJnJQAGc5znJnGTIZyEVCMQFkyZMmQM5DOTJnJmD6N26V1rTrW9a271p1q1rSunTq061vWnWnS006VdOldSq6lZXS1VVFVBkznOc4znJmMhBZDIAVUJVFVEZznOcZznOYILIZxnJnOc5MmcgBVVUEZMmQyBkzkM5MmTMB9Hp1pV1p1rW963rWl1p06XS6XTrW9a1rSsyyutOtKupVnUq6tTNUUVQAZznGM5zkMgEQZAAqKkqEqAM5zjOcZyAEAZMZzkwZyZM5AIiqoCzkzZAM5M5s5yBkAA+j1pdKutad63vW3WnTrS6dKunWta1t1rS0y6XWta0rNplVVdMrUUVEQBnOc4xnJkyBEAAEU1RFFUGTJjOM5zizmAAM5zkznOTOTJmAKiKADNkADOcgYMgGSMkfR6VdTp1rWt71vW3S606XTrSunWta1p1pWZdOta27VmmXSqrploiiIIIznOcZznAWQiCAIqqqIqgMmc5znGMmTJZAMmc5MmcmTJnJAVBEAZCMwZyZMhkyAZICz9JaVtWnTvet63rWtaXTp0utaV1rWl1rSqs6da3p3pUaWVV1pVmiIrMRAGc5znOcmbMARZoimqqAiDIYzgxnOcgZMlnIZyGQwZAyZoiiAAM5CADJmyGcgAZiyH0dqWbWtad73rbvWtWnTrS60utadK606VW1rWta0701VKsul06VqggCCIjOTOcmTIQEQFFVMVQQBnOc5znGTBmAzkyGTIGQzkyEEVRGTIZyAAQGQAyWQADIfRNLLa1rWumta3t06Xa6da0unWtWl0q6tOnWta1p01U0sq6060tRAAEEUAZyGbJmslEEVMxUEAWc5znOc5znIAGTIZCxZDIZyAQ1QWcmc5yGYgACACDJkAyfQVNK6066a1vWta1pXa606061p02l02ldOnWtOtMjU00unTrbqYQyRkIqiAzkCyQBRUDNUUQABgznOc5yAAGQMgABkyGQCqqgznOc4MgQQQREABkznJn9+hmXTreta3rWta0rp1rTrWta0q6Vl0ul061pWqpqqnTrWt6dSWbIBmCmoAACzFmIiamooIAM2TOc5MhkozGQzAAAZMmQBmqM5znGc5zmIIIoqiyZM5zjOf3Sppda1reta1rbpdOnWnWta1p06dSyultOtOmaKpqJV1ret6ZgAyBmpqqMhZQIAiqpqqCAAADJkyERBkAIgDJkyBmqmIznOMZwZAoCCpqgyZzgxnH7NJM6Xeta1vWl06dOnWta1p1rTrSstLadaWmqKqqmdO963pasgZIKmqizAQUBRU01ERAAZggDMQVZICAgDIZMmYGkgzjGM4yARAFSjRZyZxjOM/q1VKu9a3rWnWl0unTrTrWta1rTpZqZXSrVVRQlSrrXTW9aqsgZiKpqICiIgIqZpooIyQAEQRVEQFBAWQyZMgFVEZznOM4zmCAAK0qQBnOM4zj9GJlXWt61rWnS6XSutOta063rSrNUy6ZaoqiKiXWne9720WSyRVTFQEREREUzNVEQQGQigoKSoooosgZM5AyCJBnOc4yZyEAZAFVqDJjOc5x7SltOta1rWtLrSrpXTrTrWtadaVqppVmYoohCm071rpvosFmAqmqIAiirNBSKi1RAAEBFEUVFUVVEQGTNiyGSggznODIBBnOQClWIyZM5wd2VdOta1rTp0q6tOrWl061rWtM6qqpVaYogoSlda3vpvSwAZqmmoAM1FUBEyKzJWRAyQERQVVFRVVRBAGcmQAgDJnOQKAznBkClqIDJkz0XSuta06da0qurTqdWtW3TvSrqqKlnU1EVZiqdO9b3006iyGYaVqs2cgFJRFVUqzQFBZAs0RRFUVVVVRBEZM5AM2TMGTJEhnOcZwZstVRQAGl0u11q3p0up0upVdLp1p1q06oimdLTFQRFTp1rfTW9KRkCqVms2c5DKVUVVVKrVBAAWbNEUFUVFVNVWYgjOTIZAzABFEZMYxjIBRFQkQ6ta0unWnTq06bStpV0adadadSxFKummoos0Wldb301pkMxkaVWrJnOTNVUVQNKq1QQAAARBVFRRVNVVQQBkwZAzAERSBnPPGMGQCCiaq//xAAZAQEBAQEBAQAAAAAAAAAAAAAAAQIDBQT/2gAIAQIQAAAA8ESIQkRBEIhCIQQAIBQCilUUq1S1VVVLVUtvGIiIREQiIiEIghAQAFAoKUqqottVVpVVVqqvGISIiESIiCREEIIAIFAKKKqlVVLbRpVqqq1avCIiIiJEJEREIghAIAAFChS0qqqrbVKtWqq21p86REiEiIkSEIiIIEAAACixSqVVq1bdClq2qq23V+aRJESESJEJEQhCAgAAACqCqWqttttoVVq2rbbq/LIiRlEREkREQRAgEAACgCiilrVuqutWSKq2raurbfliJJIiREiRCIQQIAAAAAoooq61rVt1ozmVVW6W223XyJEkkSJEiJCCQIABLAAoAKFCrdb3q270mM5lW1bpbbq35ZEkkiSIkSIQhABABAKAFlCqCrvpvemtas54xFW2rdLdW/PJMySSSIkRCEEAQBFIVKACgoULre+u9W70nPnzkq2222223lJnOcsyRIkIhAgEACAAoABVUC630671da1c45c8yrattumrZM5xjEzJEiQEgQEAIAAAoBZVtElb316dNXWt3PPlyzLVWrq22665zjnzxjOZEkBCBAgEBQAJQAUt0skLrp0673d3Vzz5YwtsFtt01fqmefPlz585MpAEQIECFAAAAALdatmZF1vr13vWrq5xyxLqyZS2tW3X3Zzz58+PPnjMkAEgICAAAAUgAautaszmGunXp01rWtM454b6amMZi1bda+6Zxz5cuXLGGUCiQWSCAqUAAKCBKt1vRMyNdOnXprV1q5xzzrp13nHPADV190znny58eXPOYiLaZQsSIAAAoFAgDWt6qZmWunTp01rWtM4xN9e25jnmCZXW/rmcYxy48uecxIW0zASJAIAKWgLFggt1vVJku99Omtau2c4b7dejOZUzjM1rfaYzjHLlz55zJIWiIEkgRAAVaKCiAautWoS73vetXWjOXTp26UWzOObW9ZznGeeOfPGc5kkWiQQkhECCwqqpQUQLbtVFutb1q61qwa69OmrdarGczW9fHnOcYzzxjEmZIUSIJEgkAAWrVAUiltq2qtu7u61dWmtb301rWtaTMa1ryszOc4xjOcyZkBIiISCIEoCqoqWUpaq0tXVturrd1dW3Wtb1rWt61SXWr4mczMxnOc5mZJCEiREIgEUAUqgLSqqqtttutXWrq3WrrWta1rWt6tq6XwszMmc5xM5TMiJCREiJYAACqAqqpaVVaturda1bq61rV1q63rWtXS22+DnMzMzOc5kkkkiEREiAAACgpVKLRattt1dXV1brWrrV1dXWtattt08LOczMzmZkkzIiQREQQAAAUFKoUqrbbbbq61bq26urdXV1q6tttvhZzmZzJMySJJCIIECKigAAFlUFUtq2226tt1bbbbdXVurbq3V8KZzMyTKSRCQgQlAAAAIFAKLVUt0turbVqrbq261bq3VvjZzmZkkRISCCAKBQAgCAApSqKrVtq21RbdW3V1dXV1rxpmZkkiRBECABSigIECACilKKtrS1apVt1brVutXWr5GZMyRlEEIEABVKAQQEAFFKFFttW1VU1bbdXV1q61fIkzJIkQhBBAApQBYBBACiqUFtq1aotttumrq61d3XkTMmYkRLIIIQCigoCAgSgUFVUWrbVqlWrq223V1rWtXyZmTMkREQEIABRQBABAqUFWgqtVbVUq2223V1da1q+TJJMyIkIEIBAUKlhQgBLKFSrQpVtW2rSqrTTV1da1q68mTMkkiIgiBAABSUJZUACgqqsoq21bathatt1bdautXXlSZkkkhEEIQIAFAAAAClKqgtttq1RVq26t1dXWrrypJmZSRCEIIIBKAABYUBQpVKpbatW1ZVW23TVum9XXlMyZkkSEQIQQEBSFACiUFFLS0VbbVtUVVturbbq63fKTMkzIkQgQgggAKAAAopSqpRbbbbVoKtturdW61rXlSTMkkkIiEIEEAAALKSlFlKpaBbbdLatBbbbdNautXWvKzJJmSJEQQksEECCwoAqUoUKtKKatW21VKrVtt1prV1q+XmSTMkkREEJAgiUhQSwUKFAtpVKVq22rVUtXS6urdXWrrypMySZkJEhBEIIIAABQpRZVVSqpbbbbS0tXS3VurdXWteTJMySSREhCEghEAAABSqUsWqqlLdNWqqqtttt1q227t8uSZmZJEREgiEESEqWFRZUoqlUKqlqi2222rVVaurbpdXVuteXJmSZmUSIhCIQkSAAAC1SqsotWqVV0ultq1atrVtturq68yTMmZllESIghIiJAIAUKqlVRVWqotttttq22qttttaurdebmSTMmZISIRCREiQAQChS0qlVVVSlttt1Vttq2rbaurbda82ZzJJmSSIhEREkiIJUCFKFW0tFVSqVatt1bqrWlW22tLdW3XnZzJJmZkkIiESJJEhACChStLSlUqi2qtat3bVqrbatttturvzJnMkzJJJCQiIiSRIICAKqrVqlVZVLVqrdXVttqqtW1q26t1b52ZmTMkkzEQkRIiIkQggBVUttqqKotLbbbbbdVVqqq3Vt1dW34M5zMpmSSZRLlJEEiRIJYgCqLppVVSlKttttttuqqlVbbbbrWrb58zMyZSZkzERJIiWIkiIIAKtW21VpSil1bbV1bbbVBbdLpq61brz5MzMkkmZMpIiTIgkkREAlFtrS1VtCgrV1bVurbbaoNVbbq6t1XxZkzJmTMkkkkkjKCIkkIkAKurWqW1QUUurq1WrdNW1QtXVXVutW34JJMyZzJJMpJMyIhGUhJCFJS6ttVVUFUW3V0q26turVKVdW23Vt1XwySTMznKTMjMkkiEkiREiAKXV1Voqgoq3d0tq6tttq0q2226tttt+CMsyZzMplmSTMiIjMhEiJKUq26qlLUoVbdatq22222qq1bpbbbbbb8ERmZmZJJMxmSSRJEgiRJKKpV0Uq0hSrrVttW2rbqqLbbbVttttt88ZTMzJlJmSSSJEkEETMBbQtUoBVVbq2qtqrbaFurbatVbdXXwISZmWYkzJMxCJkAJmZotWWLVKAVVLapaW1qqGtXVqqLbrV+IiTLMiZTMmUEiFgqRiFVQKWUAWqUCqW22qW6ttttSrdXXypJJJJIkkkkCIAEZyKLFCqABVosoCrbbS3Vq26orTV+eJJJJIkiSSAiApJMwtEKtAAFVRQApdW1VtW61a0VbxzJJEkiRJIghkFIkyVURVoFgBS1QLBRbbpbStXWrbWh//xAAZAQEBAQEBAQAAAAAAAAAAAAAAAQIDBQT/2gAIAQMQAAAA+ZSihSiiiilloUBQAABBBLAhEJCEREIiXPUUtBVCqKKVShRQoAAQCEBBIiEREhCJER0UtFKVRSlUpVKoUoBUAEIIEIiJEIkRCIiSJ1LSqVSirSqVaqiigoAAgIIIRIhIkRJZEREkkdSrVVSlVVpVqlUUUCgJUWWLAgQiISIkkiIiIykSdVWqpVVVq1VpaFKAFiiKSgAShIiIiSRmIiRIkSSdatUtVVq1atLRQAABQAKBUohAkiSSSSRIkSRJJ1tVbVWqtq2qVQAIAAAFCgVQJQkkmcySJIkiSSSdlaqrVtq1bVFAQQEAAAoUoVQVdLJmSTOZMpJIZiSZnda0tq2rWlqhARAQAAAFAVVULWt2yZkznOZJJJEkkjMndbVtaW1qlAgQggAEAqKChVWgret7szmZmcTMkjMiSZSZn0W0tq23SqCEIgECAAAAopbrVRlbrpvdZzM5znOZJIkkkzJJPqtoq221QRIIQggAAAAUUut70mcxd9Ou7JnOc5zMSSSMySSSTP2aqyyrbVCyTIJECAAAAoAq3fTppnGIu+nXpqZznOc5zMySSJMySSZ+62iVaqCkkgSQgQAACqEAXW+3Tozz54XfXt0smJjOZnMmZESTMkmc/fq2olKQtqZyLJmQQQACgtpIgLvfbr0s5c+cu+vbpWc5znOczMzmCTMkkmfv1baylES3WkxItkxJCQAAq2LWkhISt9Ovbpqc+fPLfXr00xnOc4mczOcwSSRmZn3a1q1IEQ1vVznJbM5xISQIA1bqktoSSRWunXt11M88YmunXe85znGc5mc5xlLJEiZmfv1rWlQhBre7MZLZnOMkZkEAt1vVFUEkyW9OnbppM4xLrrqzMxjOJmYzjMRmQSZz6N1u6oqsw3vVYkUznEiTMhEBdb1rVFAkki3fTrvVTOYurZnOcYznMxnEymcyCZmfT1u61ot1Uku9aMyCTOZIzmQkKGtb1qlAJIrWt71q0mQZznOMZznOJnMmczEhMzPr61d6urq3QNWmYiJmZiTOSJVRbrWtVVQoirdaurq1JImczGM4znOc5zMzOcZzJGZPZu7vWta1datVdJJJJIzJEykItEW61bVApVtuqt1VkmZmYznGcZxMTOZmZzjOc5jMnt3Wt63u71datttSZkzJJJESBFohdW2lQW1bbbVtpJmZznOcZxnGc5zMyZmMYznMkj2tbu9b1vd1rWrq0ZkzJJJJEQBRBbbQFttrVW1VSZmc5mM4znGc5zmTMznGcZzmSR7etXet63rV1u6ttRmSSSSSJASlQLSqottWrbapJJmZmc5xnOcZmJM5kxnGcTMkj2ta1reta1dXVurSIzGWUSRACoUUpVW2qLbbSTLMkkznOc5zmZzMzOc5xnMzJJ7eta3q6W1bbSxEiSSJEQAoFFLVq0K1VqIkQkkzmZzJnMznOc5zmZzMz29a1rSllFAkSJESIgFAUFWqqlLbVEBQSSTMzM5znOczOc5znPta1dWoiWIsEiJIhEAAFFC1VFKttUFq2rEiSSTOc5znOcZznOfZurqkkQiIiQiEhBAKAFKqlKLbbQW3VtqsxIkmZnOc5zjOcZz7F1bSSRERESIRECAAFBSqKtC21RWrq3SiSRJMyZznOM4zjM9e6tqMpESESIRIQBBQFFFFLQq6UVbdXVtJIkkkmZnOcZzjGc+xdWqzEiREIkIiEAQBQUUUtC1bVFt1q20IykkzJM4mM4xnOPY1baSRIiIiQiIQQAAFLZSlUW2qott1q1UREkzJM5mM4zjOM+xdW2DKSIRIkEiCEogoqUoqqCrbVUXS61aERJJGZnOc5xnnMY9jV0oiRJCJEQiIIAAFC0ooVa1VKq6umkISJJJmZxnOcYzjPsW6tERJEQiSEggRAAopVWKpVrVWhbdWqJCRJJM5znOc4xnOPYurbSJCRESIiIIEgAC0WqKpauqqlW20ISIkkzMTGc5ziYx7F1bpURIJESISIRCCKCgq1VVS22rVUatERESJMzOc5znOcZxn2NW6q2EiIEiQkSRAgAFKqqq1Wi21aFtBJCJEmc5znMxnOcYz7Orbq0IQiEkIiSRAgAFVapbWiratpRVJESETMzmZzjOc5xnGPa3bdW0IQiIgZkkkQQFAtVatW0W21VC0EiQiTMmczGc5xMZxjPta3bq20EIRIhEmYiEAClVbVqlVbVtUCwkREZmZnOZnOcZxMYzj29a1rVtqgQiJISJJJCICilW21VUttq1QBIiJJJM5zM5znOcZznGc+1rWt6ttoogiJESRmSIQCiqt0tW0q20qgQiSJJMyZzJiYzmYznOMz2N61rd1bVLFIRIiZSZkREFUVWrbVtWy1aWgSEkZkkzJMyZzMZznMzjOJ7Gtb1reltqlCCIkmZllEQClpbbbbVpVVVlESJJmSZmZlmZkznOc5mM5zn19a3reta1VVRQhlJmSSSEJFVVU1dWrapVUAiRM5zJmTMzJMzOZnMznOc5x7Gtb1rW9atqqWgkTMmZJECILVVbdW1bQtUCESM5znMzJmZkzMzOZM5zmYzj2Nb1u71vWraVaWUykzMyRAiEWratumqqlUsASJJnExnMkzJmTOZmZzMzOcZx7G961retb1pbTQoRmTKSIEiFlttlt1batCgIRJGM5xnMzmSSTMzMzEmc5zjOPZ1vW9a1retatVapSSSSQkQSAW2lutLbaQsBERmZznGc5zMyJmSZmZnOc5mMZz7G9b1rWt61rWtKtVQiSJIREhFFq1q3VtAICIzM5mcZzmZzlJJEznMzM4znGM59jW9b1rWt3W9aui2qUhJEiIkJQW2rdaqhBAiM5znMzMZmJnMiJJMzOZnGcYznPrb1vervWta1vV1pbVUqCSREkQBbat1bVggRBM4zmZmc5znOZmIkkmZnMzjGcZzn1d61vWt61reta1rVt0WqVEjMJJAC3TS6pUIEITOMTMzM5ziZzmSREmZnMznGcZzM+prWt63rWt61retXWtVatFiJEkSEUtturQEAgkxnGcyTOc4znOcyRDLOc5znOc5zMvSu9a1vW9a3rWta1dburVUEiQkkFFt1dABAIkzjOMSSZznGc5zmSQkznMziZznMkejda1ret73rWrvV1rWt6LSkIkSIULdW0AQCJM4xjOZMzOc4znOZJEkzMzGZnOZEk9DWrrWt73rd1u61rWtb1bSrFQkkRSlatWABAmc555xMzMznOczGZJImZmZzmZzJMpJ6NurrW973rV1rWtb1d6ttWihJIiqUtpUlgBEznGMTMzJnMznMzJCZziZzJmSSSZy9Ja1re961rWtb1rWtat1bSqUiZiloVRYQAhnOM5ykzJMzOZmQkmMYzmSITOcZz6VW3W963rV1ret63q1aqqFRJCrQVRACAjMzEkkkmZnORJjGMZzJAkxjGPQq3Wt63q61rW9b1rVFVQsCSWWqC2pYRUEBAhEkznOZlGc4xjMzmRUmMYx9lt3rWta1rWrrWt7tKKKEDItUKtEsAQIIAQznOZmSZxnOZnPPIZznOPqt1rWtbutW61rW9Uqy0AlMwtqkrSkAAhCACEZzjMmZnMkzzxzkkkzJ3ut6ut6utW61bvdGiqAiyRVoFpSAAQiAJFS5zjOZnKSTPPHPGZnMH/8QAIhABAAICAwEAAQUAAAAAAAAAEQABEHAwQFAgYJCgsMDQ/9oACAEBAAECAv6Mnf6aF9St4VK3fUrbN9evIcOr76lSpXlOr76lStt31K811XeLl9WvSrU14vrVwMXxKzUrFaivF/hlaivwVi+JWKlStSX4KviVis1itQ33L+H5Y5e3WKlYrFahuX27l/TKyqqr2alSpUqVqO+3fAqqqq9qsVK1Fcvt3wqqqqr8Kq81bBvhYqqqqqqq9CtfXi+FVVVVVVVehWvr41VVVVVVV5q2Beb4mKsVVVVXcaqqqu5lVYsd0vw7rf3tpADBCEDaYEMgAAAAAAAAbKAAAAAAAAAAAAAIAAAEMABq8AAAAAAAAAAAAAAAAAAAAhAwBpkwHwAAAAAAAAAAAAAAAABADJg1gc4AAAAAAAAZAP8AftjB/A8//8QAFBABAAAAAAAAAAAAAAAAAAAA4P/aAAgBAQADPwJ9If/EAB8QAQEBAQACAwEBAQAAAAAAAAARARAgMEBQcGCAkP/aAAgBAQABPyH/ACFP9QT7+fy0/Ep/n6f7w30b9TP8dz7Gfw2/6236bfzrf3Le7573eVfDP1nWta32b5Vn8dPw3WtbyqvjVVeVWcxjPpN+mn4brWta3W6qryqqt1VVVZqs5n6trWta1rW8vLyq3VVV5ms1jGM+fv5vrWt43m+neXuMYxjGfRb+Za1rWta3m8va3m6vLzGM1jGMZ69/Rd7rWta1rWt7V5qt3tVjGMYxjPpb+Xa1rW8a1rfGtXwqs1jNaYxjPpaqqq/lOta1rWta3wvN7vhjGdMYz6WqqqzVZrGM/JNa1rWta1vlrW83uMZ0xjPpaqqqs1ms1jPxa+zea1vGta1rfRvjjGM4xjPod8VXis1WazWbzGM7n4TvN+FrWta3jWta30b4YxngM+mqrxmqrNZrNZrOZzOZ+Fb5X261rW8a1rW+e+OMZ0xjGeFVV5fg76qqqzWazWazWazWM1jOYz8H1re7vavM3menWta3jWtb6Nb4YxnGMYxVVVVVVVX5NVWawzWazWazWazWazWMZ+DbzWt5rfLGczz1reN6a1rfbjGM4xjFVVVuqqs1WavyKqs1ms1ms1ms1pms1jOYxn4JvdbzW+OMYz063jeNa1rfTvhnMZxjO1urxu9KrNZrNVi/GrGaxjNZrTGb0zjGMZ+Cb3ea1rfHOZ6Na3jeNa1rW+e+OMYxjPCq3W63VVVZrNZq/E3t5eYxjNZrNZrNZrN4xjGfg+ta1vljF9GtbxrWta1rfDW+jGMYzlVW63W63hWGGazWazWaqqqr699OMYxms4zWmuMYxjPwbWta1vjnM1no1rW8a1rW+3GMYxna3W63W63V6YZrNZrNZqqqqqqvLy+zO4xjGma0xm8Zxnc+Vntv3t9tVfga1rWt9GMXz1rW8a1rWt8N9GcxjGd3W603W63eKrNZrNYZrCqvFVVVVXxrdbqr44zmMZxm9M4zeM5nxavneVV9N+/vb8G+eta1rfVnM3x1rW9Na1rfZjGMZyq1utNN1uqqsM1pms1noAMM1VVVVVbrdVfHOYxjGM8BrpnM+TfVeVe5vL9hVVV8L2+u9vwda3m+nNXlVe7rda1reNa1vsxjGM8N1ut1put1VVms1hnsCAqqqqqt1VXxzmM5jGMZvGa00zWM3t5fdfC8qry8qqq8vb5X6uryqq+V915eVeXxvlre76qrNVV5ut1rW9Na1vnvjjOYxnN1rW8brdVVZrNZrPULuOdGaqr030BjGM5jGMZxjGM1is3lXl9e83yvheX7m+i+NXt9NXl8L2+jda3mt9dVVVW63Wt1rWta1vN9ecxmqrda3W7xrWqqqvF9IBhhhnmA003wM5nMYxjGMYxnGMZrGcqr2+jfdfbn2F8KvKvaqqq8vjV7eXlVV8q3mtb6ryqqqrdVuta1vNa3253OVut1utN41vaqr6gBhhnmA0003xMYzmcxjGMYxpjNZrNZqqqqqry9q+yry+68q8q8v2N+FVVV5eVVVV5ut7rfTVVVVW63W63W61rW/Aqqqt1utN1rWqqqq+oAYYYYZ4g003y2MZzOYxjGcZrNZrNZqqqs1VVVVVVVVV5fOqqr8C+VXzvL41eVVXtVeX4FX4tVVVVVVVVVut1e751VVe1Vbrdbrdbzeb76qqqt1utN1vG8qqqqvF8QrDDDDPFGm+YZ5YxjGMYzWazVVmqqqqqqryqqr9DV5fVfGqvL29qqvwr8Kr6byqqqvtqqq8qq3VbrW+vfRVVW63W61rWt8aqqqqqqqsM4Z4BpppvC+GdzuM5jGMYzWbzFVfK9qqq+F7fub9VV5eVV9G+68qr4b4b8Kq3Vbrd5rW+etXtVVVVZ4g03W8LxnM5nM5nM5jGMYzWarN5VVVVVVVVVVfqr7byqqr436e+dVV+Nqry93m+O+qqqq3VVrWt8N5vN8d5VVVVVXiq3W7xe56cYxjGcqqqqqqqqqqqqv1dXt8qqqvnfrKqryqvL8Gr2r8qqqq3ea1vd5rW+iqqqqqvFbqqrGejOZzGM5ms1VZqqqqqr4Xwv9ZfoN+RfHWt8N8N5vrqqqqrd8c9WcxjOVmrzFVWaq8qqqqv3l/jd7vhvwd9G83m93m83ut7vpq+jPhZvc1eVe1VVV8L+Jb3fibzfHea3mt+Nnwc5nlfRfxXfgb4b6d7vhvxc9WeOM/Id9+93m81vd9Wt8d+LjPZnnnjn4nvu307zfhbnriJ7s7nhETkRnc5n47PPez3zk5ORERETkRERERERERERERERGYnIiIiIiIiIiIiIiIiIiIidieuInZ9tPbPRPgxOxE5E7PTE5ETkRETkRuIiIiciIiIiIiIiIiIiIiIiInE43oicTicTpERERERmIiIiIiIiMxERERERERERERERERERE5ERE7PKemeERPhRE+RE8IieUROzs8YiJycnInYiIiJyJyIiIiIiIiNxERERERERERERERPATiInzAAAABERERERERERERERGYiIjMREREREROxE5ERERERETxiIicieiInZ5xE8IiciIiciInIidicieE7ERE9kTkRERERORORERERERERERERERERERERERERERERE+pAAAAAACewAE4ieQIiIiIiIiIiIiIiIiIiIiIiIiJyIiInIiJ2IiIiIiInZyIiciIiIiIiIieERERETkRERERORERERERERERERERERERORORERERERERERERERERERERET64AAAAAAAZ0Z5AZ5gMzidIngIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiciIiIiciInIiIiIiciIiIiIiIiIiIiIiIiciIiIiIiIiciIiIiIiIiIiIiIiIiIiIicROkRE+0AAAAAAAAE6ZwiMziJxERERERERERERERERERORERERERERERE5PGInYiIiJyInYiciIiIiIiJycnZ2IiJyIididiJ4xERERERE7ERETkTkROREREREREREREREREREROIiIiIiIiIifDAAA30AERPEIiIjMRmIzERmIiIiIiIiIiIiIiIiIiIiIiIiIieieE5E8onhE5EROxOzs5PbPgzk9k84nhERERERERORERETkREREREREREREREREREREREREREREREREREREREREbiIiIiIiIiIiIiIiIiIiIiciJyInhERETzidieERERPOfQRPkRERE5OTk8J6Z6Z4RE7OxE7ERERERERERERERERERERERERERERERERERERERG4iI3ERERERERPRPgT0T6+cn2k+gnhETkRE5ERERERE5ERERORE5E5ERETkRETkROTk5PCenOz9i39r3x3xzxz9i1vwM/Vd9G+W+nPDP2PfXn6xvhvlv6Lv0u+3P2PfHfHeb+Y79nvN7v7Xvjv7Pvt39p3z39j34G/tO83w39u3/mXvjvN/wBv7+373fVnM/Y9/ad7vNb8q/o++u/su/uV/ed7vrzucz8n39v37nf8CX8uv+2d+33m/Fz/AKJX9Tz8Rvqvzs/Zd+Vn2Oflu/uucz+t3+G37PfRn7nn9nv91nxL9Nn9Xf4vPu6v3O/3WfwN+03+7xn8HeX8qxnhf1bfj3+uv3V/hM7ms303t/qN+Dfl3xv119l9l8M3l5fx3foKvwKvne342aq9vL4Z779Znz98r536y/Nvpvvq8vnu/Jv9Rv8ANX7PO59/n0F+u34Wt+jv2l+Bn8Lv2Gt+1vpvjfC+m+VXyvqvovw79Dn01+wvhV8b4XyvxL29vjV8Kvy88c+Nf4Pfs9+HfG/Hvavoqr5Vfl53Pk5/b779/js5jOZ8q+F9WfZb3frd+ZvN/is/j79tvjv8Rvzc9meOfV34F/op2JyfInZ5RPh54Z9RnxKq/FvL/FRETs5ORE5E8IiIiInnPZETkRERERE5E/ib29qqvL8C/wAHOxORERERERERERERERETk5ERETk5ERORORERERERERERERERE9mczzxn0uf00RETkTsREREREREREREREREREREREREREREREREREREROInERERERPrp7M+VnzN+snIiciIiIiIiInIiIiIiIiIiIiIiIiIiIiIiIiIiIiciJyIiIiIiIiI3ERETyieMTufwWM/jIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiI3ERuI3E8pyciInIidie6J4z6vGfxcTsRERERERERERERERERERERERERERERERERERERERERERERERuIjcRPRETkROxETkTkRPCdz7HGM/jJ64nYiIiIiIiIiInIiInJyJyIiIiIiIiIiInIiIiIiIiI3ERPKeERETk8J2evPss/pJyciIiIiJ6p5RERE5OT4G4iJ6In8Pnhnq3+dnnPdERORE5ufQz5ufVYz8GiN/p8ZzPLf6jfk7/AE2fhO/H/8QAHhEBAAICAgMBAAAAAAAAAAAAEQFgAEAQIDCAoLD/2gAIAQIBAQIB+YydUrEb5Yp2Jr85PQDUmuT1DDRnJybAABpTUo80cAAAGHgnicmvRkZHQAAAC2AAAAW0AAALkABdD1ya44qqqqqq4q4tWVVVVVVVVVXFamvLwqqqqqqr0f3zns6TVnq48Kq++f8A/8QAFBEBAAAAAAAAAAAAAAAAAAAAwP/aAAgBAgEDPwF/B//EACARAQAABwEAAwEAAAAAAAAAABEAARAgMEBQYHCAoLD/2gAIAQMBAQIB/W7LHKJexndL1kolcecAuAwyuA7ZU2CAAuAKGIA5pAFoZDVDMYADnAAbhrAAFwHQA6wAdoNsKGuAeVChBQPqKqr0nA9JhVVVVVVVWirCqqqqrRVVVVVVVcoYQ1VVVVVVVVasKwtVVVVWFVVVVVVzEAEBQg4LtORov9xYCgGEAA8kAAAAAAAAAAAAAUCgZTsAAAAAAAAAAAAAAWAAUPEAAAABAAAGAC48sGEA+fP/xAAUEQEAAAAAAAAAAAAAAAAAAADA/9oACAEDAQM/AX8H/8QAJBABAQEBAAMAAgMBAQEBAQAAAQARECAhMUFhMFFxgUCR8FD/2gAIAQEAAT8Qv97kdzh85nhnMs6cI9czuczmRzIO5zLI5nMssss5n6sg5llllkWMFlnMss5lnnkcLLGxsss/Vn6sssssss5nDuWc98yyzmWWcyyyyyyzucyyyyyyzmWWWWSWWWWWWWWWSWWcySRs5llnMkvxNlkklj/+JLOZxsmx42WST3/lklnM4+5LOtln9Sczmcck6998zmWTZf8ALPD718css4eAX+dzp3PDIiyz+AILLPVkRZFnM4WWfosssssssssgssss7nMg5lncgsssYPd/qwsgsss5llllnhln+WWbZZZZZZZZz/kWWWWeGcbLCwsLLLLLLLCwss/zmfqT36sssZLJLLO5ZZJJJzJLLGyzuNklnqyyybOZzLPc+KeDzP1JzJ45Y8bM4/8AZO5ZZZJZ1ssk68eM3uyzwfF8fxzIsg88j14EFnM7llnCyzhzLOZzJ4F7/qz3ZzLLOZZZZ3OFllkWQWQRzLLLLIyyCyzmWWWfpssssssss5kHqyyyCySywsLLLLLLLLLLLLCwssLLLLLLLLLLLLLLJLLLLJLP9ssskssskssssssJJLJLLP6s5nMs5klkklkk2cySyzmcywnjZZxLJ6nGyzmeOeWbPyfHOvi2T188Y7lnSzxIHAss7nuyyyDmQRZZZB6gvzZZZZZZZ6gsgss5lnAvzZZZB7ssgsgsssssssssssss4ySyCyyyxsYLLLLLCwsv+We7J5lllllllnMLLL/ll+bL1s8yyyz3JZZJZz1+r1+uZYWFklllhYWSWcLLLOZZZZZZJZJZNhZMySzmWWWSScySzmSSWTZxs9ydyyzjZZZJZzOvEk5+Z4zJJ5M2eDfGTr3LLP78A7kEWWcLIPVlnAssiyzmWWWcyILIPVlllkDBZJZ3OZZzLLLLLILLLLIPVllllkFnGWRf8s7ljBBZZZZZZZZZZZzLLLLLLLLLIJLLLLLLPVlknqyyyyz+rLH+rLLH+rLLLP1Z+rP1YwNjZZZfiyyzuWWWWWWWSWerGSyZLJ+2cTmcyTmWTZJzJLGzmWWWWScyZ7lnXxbLGSfvGzif15ZxOZxn7ZzOPH7x49zwzwyyyCyyyyyLIss4cyLLLOZY2RZZwLLLLLIPdlllkHyxsssss5lllkFlllkFnuyDuWcyyzmWeGQWWWdyyyyyzxyyyyzmTzLLLLLLLLLLLLLLLLLLLLOZBZZZZZZZZzCyyyyz3ZzLLL8Wcyyz3JZJJZZJJJYzvH5ZJZJJZYyWT85mczmWSTZZNmcTj3ONnEk5nckmf862TZ551nweLZwO55hZ5hzOBZ3ILIOHSyzmeB3Igssgssv+WcyzILILIjhZwLOhZZZZZBZZBZZZ4ZZZZZZZZZZZZZZZZ4ZZ3LLLOZZZZZZZZZzLLLLOJZZZzLLLLJLLPDLOZzLCySziWSWWeDxksk6nGSbJJOZ3OJ4PzmdySb8cTmT4fnmdSfU+GeL9kmfvHjPHocLOZZZBHDpws6fbOFnDzCDuWQWWerIIOZzIs7llkFln6sjmcAyM7lmdyyCyyzmWT8ssssssssssss7llnnlllllllllllllllll/wAssssss/VlnM5nMsksss7llnEsssss5nEksssksssss9WX/JLLJkksk48Zss7+J/yZ4+GWdybOM2TJPqyftk8yZsv+cbOPM43/AC+p635mb68QgzgWeGcyCCzmcLGyyDwyyyLIgssgsiYQREWWWWWcyw5lkEFlkFncsgbGz9WGWWe7OhZZ+rILDmWRZZHyyOZzLGyyCCyCSzmeWcz+HPPP3Z+5LLJLCSyyzmWdbJs5llklllkn9SWdyzbLLJLLLOJJZZJJzNsybJ6zPzxftlng8yyySyTxSyST1Zxs5nEs9WeDxmZ68Z8A92cP34HQ5kFkWQWWWQWQWWcCzh8gggsgsgsgsgjmWWcyLILIILOZZBZZZGWWcOBZZZ3LILLLILLLLLILL/7HuyySyJsjhZ1ss/VljZZY3+rLLLGxssssbGyyyyyyyyfDJLPdlllllnMksssssss7lnMs6SyTmSWWSTMklk8bNk4yTMzPzm823mdySzieOSe5mzueGcyTwesnTx4Rw6dzmQRBZzOZZBZBZBZzIgssj5H6v9sggss/R0LLPVkWWWWWWe7LIsbLL8QWWWWQQWWR8sg5kEFnQ5nhllkFllnMs5ncsssssssssbLLLLLLP8sssssssss/yz/LLLJJLL1ZJZZZZZZZZ3LONlllknMsks5k8zmWdybJLLJJOv748Zn5xmZZnn5h5vPzZZJzPVkyeSdbJL/O51nrxmZmZmzocDwz3HgdIOlnAsjmRzLILIILIizn4iyCzgWcyOZZBZZZBZ/VnMOZFllnMss/VgfO/wDLLLLLLLLLLLLLLLI/iyyYssb34Z5ZFllnf+dzvq9cyyyzOPMsssss5lncs4lk2WSWerLLLJLLJkkkmZ+TMzM83n4mWWXXhbYS9bERw6k2WTMl/wAnrZPi9zwfI/Zkn5zOHDhz/enCIg4WeGWQeWWR8jhw4HMs5llkX/LLLOZZZZzLII6QcCyyyzmWWWWWRZZ/FkEczh4BZZZZZZZfP75/yyyziXvuWeOeP/L/AJf87nX3xs8M7llnm8yyybLLLOZZJZM/b8p+TM/ZZf7ttniyyyy+5bbbbebEWWf3ZJ4v3iSTx8M5n9SeLPGZmZ+cZ+zZw7+IjhwI8CyzhZZ/dlnAsssg5nD30LILILOZzIPUHMsjmcCyyDpZZzLLLILLLLLO5HjkHgcy/wAs5lngX/LO5ZZZZZ38WWeGWdz+H3+uZZzLJ7nk8yzwyyyyfnMmzybOPGZnhmUtstssspZZS5PAf6ht4I++aczmcSySZJmZ4nG+d/Mkl+OMzMnfzw5hEHvmQe4OHDmWcDbIOBZZzOFkFkFhZEFlllllnuzmRzIILOlkHM4WWcyCLLOFnf8AnMg568M2yzhZZZZ5545ZBZzLLMs5lnM6+Hr+HLLOYeTZZZZ3ONllncs42WFlkllhZxOJDwHxPyWWW223iyyyl922wwxFERz8WT4tkhM8SyTiWTx/U2WSWdSeM3449yzhZH2zn4sgs4dyyyzmWQe7LIOBBZBZBEwgssv+cCz3BZBZzO5Z+rILILLLIss5kFlln7sgvV/zxzmWWWWWdCyyyyzmR/6vf6vfjn+cyzyyzmWdyzxyzuTzLLOZ3LLLLOJZJPyZOFKUsxjqW22WYxjF4NShlfF7R3LLLLJ7myWWc/Ekklk/Z6lk8ybOP2SHqeMEWWRwIPdnSOBBH/IOZZ0s9wQQWQWcy/HGf3ZZZwsssss5kHMYILLLLO5ZHyyzn/LI4HGOZzLP9gssgsssss5nnllllnhlnhlllllllncsssssssss/hyyyzmcyyzudzxeZZzLLLLLLJLOsz4g+gxjFmPB4H2kbww4CKGURHUskkk4/eNlkk9SbLPdnc7kkz7mSTueIcILIILLGyIOBFkFlllllllllllnibY2WcCyz3zLIPdl+eHcg7jZzOZzLLLO5ZZB4E89/wAGWf7Zz3/FlllllllnMbLLLLLO55ZZZZZZZZzO/wD2yfB8cs8HrZ4e773LLJ8D47OUpS8LM2faRwfaY8N6DnKUR4Z7mbJLJnnvjNkzZPE48efHPk/Z5nTxOhEeX9dCOHC/MRfjucO5B3LILPHOHM8Dyyzp/Fl/zzOZZZ5ZZZZB/f8AJnMs8Ms4T85lnM8Msss7nM8vxZ451+fwJ5ZxvxPyZvjl8r1KWUtstsvuWWX1L3L7mbDKU5SlwR4P2fvGeM8Z7kk2cZ8GZnntx+70+93hfnpH2LI4EEERZwOkWdyyCCyzhB78DwCyLO5Zbw5lkeB38eAWeWcLLO5zO5Z3LLP/AODlni8fDPDPHOPX7x8ss8M6z5B+Zy9y+5SzNlviXuXgzeB9ynyc5X1wdeP2ziWeJ+cePE6+mTr1mSfkk2w2228P3HSI4EFkQWWRZZFllnMgss5kFlnhllkHuyyCzmWcOZzPHLPLGPEss7llkeefy5zPDJ5n/lyfv8GeWWWcyfNbbbbbfMzx8XxfPjylLb0WU8Cy8EUp/Jz8ARzJLLJmyTmWcTrN+J6lknH5MyTJZ0NsNsMMMMMRFkQWQWdzgWWWQWWWczmWWWdLI9cCyzucy/8AkWWeOdLOFlnhlncss5kH8uf1ZZ/dk9yzv/eZzb7ZZZZZZZ45ZZZJ/Fllnjln8L47zbbfPOMk+S16nLhSyy+rZimLL7l4OJXytJz6EQT4M344lk8fUknvj95+esyScyZnucH9YhCEGGIYeF+ft+eHMg5kFllkFnM/uL1ZBwn7HMgsizmWR3OHhnM5kcyyyyzwzmWdyyD+HLLOZZHil/yyz+TPHP3Z+7P3Jf8AL/n8GWWSeWWWdzqcyfBZtl5tv8LM8fl5vfcpZfdsxZepllLMMpSlKfH1BEcyZ6nWSZmZ7kknWZLJOM8b66EOA/pwUpRERERZwIILLLPDIIjgWczpw4HjnM8Mjh3PEssvzHjm2e/LLLLPPLIO5Z4lllln8GWfxZZzN8P+X/L/AJZZzJ8X5Z4PGZmbfcttra22+bx+9fPX55fC4bZmWUpSythlP3OUu31HyI81n5ZzJk6k2WdbJ8GT3x48lKUoM8AF7l6iIiIjpF7s4R9s4QQcDmf3ZZ4kdzyO54fi/Pcss8M8MbPDOnjl/wA4WfyZ/wCHLLOZZZZZ4ZZe53+DLLJ5k8ZmX3Pzmy2/u2/1b/8AttiOfiOZ4Hj8+nzfPjDxt3iy8LNsMvHnz9ERzZlnm33wyZs5+Z+ceM8ZJPUzP3hnwSkOA7j3Qy8A4IizgeOdDmcO6+H54eIRZ5bniHjlln8GWW9/OWXq+eeeW9yyzn/2yyyeer8xZerJ8nh5nfz4Z/Kz9vqZS+5fctttseoeHBvxb14/OHrn5/hMLLks/Zm+p+cPvkxckd2W2W2222/7bbz8TPHqTx6zxmT13/cUpxlL/pezl6Je4fUolHvgiIs4R3Iss5+OZZ4/np04eR9n7HgcP4s8Dm8P5mPzH3w9x+/J7nlnPzPhvieeeBPizPGZmXhlyW21iDwYY8GZm+vH/i/W+/AMzLM8PTwf1w/fKlzbZjwVbf6t922+Dxnwy/E8PH7P+Tx7/uPWKT0Xt8XD5T4OUdP6iOZEEWX/ADh3IPPLL82x04eR94R0/gyJ88s896FlncvXjn/j/M8ft6t7v83qzbPD68Z8QsucNl4IN7IZQw358X7/ABfZTM/JmWb64bY49L7vw7uUenDwY9/7xCEGG223rxk8H7xnjPrn5nueNAz8/wDhS4I+xFkRZsEHCyOf86HjttvdtjhzLPDebbw88t/hzwyzmcyyD/2Zzb8Szbbbzbejzf4P+eGeDw8LhlkpZbbYZSiUMQ8Z4+vC/F8X5+CZ4zP2ZmXh4H8eHyvV8cPpMfC5ynAQYbebxmbePH7JxLOM8fvHux5gAvZfDtOcMvXH1EWQQQeH48Cyyevh+YfAju293p9hiOfmOnMjwOZ4ncs8csssssss4fwZZ3bbbbbbevHm22293m/zZx58TPRZe5ZLn2W2GUpShh5sz7n5N9cfV93xy/t89H7NsyzM/fAcHtvu+eHfUNt8cWs9vQp4UCKJtttsttvHr942TPX7bwuC9y98PVeyfy+UpT9Slz88HyPnDy/zxL8z85vHm2w9I+x4Lb5kREdzxP4Mj/xHH+DYyf5dtjm292223+Rmb4n7P2+54d9S9zbDDKGVvqGG3nqX15B+L878+nxwzPyZnh6cfXb5nDb6t9THh9v3r+4/eP38FD0httt/dtss2zb1+zPzj9npmbEGUpe70Xu8qqU5zlEX9cOEF9jh4s8fUsvdh4cG/PjttsMcGI9REW+W/wAT/PllnMs8Nl7vdtttlt7vdttthttt8Ni2222HzePzj95+r46LNsMMvcogww2wzPmX932x8IzL4DN94R8fBv3KHhj4rxh/BDZCeniG22228Xi33hZm222P3DL3KXufrkpeuxhKc55Lgjo83308fxbLbL3fVt/tsNsMMMPVtttthttiGODDHmc/FvTueO2+e/3bbbbHNt5tvNl5ttttttttttsvNttt/dsNsPNt5tsNu823m2+D9meF77fXDzYZQ8FDDDDbx83fz6/EzPGZmefmOq5++BlnyS+/1iHp4H/v6pTmcM+F33xsRZZZfcyyy2x0QylOXvpeyfJSl6lHyGVvPxF+bfdsd1ttl9WyzLb9ttttthlDbbbLLbbbbDDEGG22Hm822223m8Ob3fDXxPF4T47bbbbbbbLa2tsNsvqW3hbbbbbbbbbbW2/66bbbbb+7ebbbZMszfXhFyszwYYZSjUMMMssvD4f5ly5++FfEzP2+pmfA4OV6n7lDLw9XB73Xtmfccb3rvV3D3jnrv6w49ehNtllng9Ex4/PCUoZTlkuSlOV6pepQyhh9Qww282GG3uyyyy2yzw2G22GG+reH2mbbb++bbDDH9LebbDbbbbbbbbbbbw5ttttvjttttvd7vNtltllttl92222922W2223jbb4httttbbYebDbDbLbxtssvrjL3LwPxMy22wwww+5Q8BttllKfClz9T4+JmZmWfkvqWGOj7jw+0vKCHke/T9vPHgQ4H7eQEp6RDgxjweiax6SjopTnL3KXBSvaGUPu2G22G2G2Hm2zbLLLLbLbbDwMPNtt5tvG8E2OAxBhth5tttttttv7ht5svu222223y23u2+LbLLLLNs+INtt4W2Ytttttvq392228bbEG2GG3n5ty9W28ZZZb44U8rPHgww8DUP9xw9rbeg8nP1yvHHj8n5Mz8npLovU4fVsvrperh7uTwOX48kj9o9PvY/e/1z8xT+0Q9Y9Yp0NeF/efWTzYi+I+3xySnOXq+UvGCRl6IYYmnGw22w22222yyyzFth4HghBvi398ftPDVvAwxBh9w+obeNtLbbbbebbDbDbE+G22235tttttttt7svFllnjGbPDH98bb/AHaW+7eNt9y22tttsttv7t/dv7ibE3gm8bbbbxvuWX1L6llKWXlnmw22wwx7R6cCExL0F/c531LwSmZlmfnDzY4UM5cbwc5+pW3J4HiBSmb68onQkBnE72PA+kx9uEdLj7j71ezvxlKfqfrgo9OAxwGJsNsMNttstspZepbbbYeNhh9RN422222222GG2Hgw22222222w9IZbbW223hfnu22222222282WZZZb6tl922y228Dbbb0WXjbf3bb+7bW2398E2IMNvAw2rbbWW2X1b/AHwUpb64eLPNthhhj24IR8AFwU5dFw8MzxmbYi9IZ+poh6cF65fSU5S6EIUhTwP/AFH7RT9r9ngIekft0Y/tej7w9kzYb6jg8B9T931P3OfqcpzvRKXu31wen2JsMQbYbW1tl/cpcllllthh4MNtsTbZbbfEhhlDDDbbb+4ZbfXRt9ww228bbebbD6h5ttvhvNtttm2WWWWWW+rZbZhN6bbaleIa2rbbW31wQf3bE2IPGrVrbW1tttmKWXCmZmXOFtrHtDEIcHoPApTlPkGZ4zL0ZQ+4ZQ3xey9XL0T9Sn7nbLCtbFH/AHC/uf2v9T+1/q/1er9j94/e/ZwGP2iHp9v9X+5/e/ZfsvR9v2T+3COv1F9R9vrhTn6nNvRPxADoIQhCbfVtvDFllllltth9ww9B9cb+7f3bbbbDbbDDDDEHgi3+L/EMTYYYfdsNtsNttsNtsPq22222222222222X+7ZZZZcltttZbbbbZbbeFttt/dpb+y239kttrbb/cNtsMQh0bxvGpjGMXgpZfcpWzM8222FwcPueh6Oh/VKXR4zMszM/ObEMMQhWM9XhE/c5Sp9r/rw/7TGPae8Q8E/wC29Mend/fwUY8kdPwjgvw7KcvXL0eEJD2iHAQ6iFOj9uGMYsxbYWG23I8QDbbbbbawwwwwwww8b+7bbbY4DDDbbbE21b/dttsekTfENt41at42WWWWWWW2WWW223jX6tlttthtLbbbbbbbbYbbbYmo6Hwb6mvB6Biy+5SzbLbbPA6Nl6vjAFLKXeF4zMyz8ly2bYYePqOt8AHqlKXqWYx6WtfFH15yVPTlr2rXmREIiI+wy4fCn6ly9HAh6XsvbghCHAhCb4BjF7tsMMNtttt/231blttvhsNsMMMMNttvBNYmww2w222+7eNtttiftxpxsv8AXGw2I6Ntttlllllltlltttt4W220ttt3m228220ttiftbD7ttt9W/u23jePiYxjwsss8ZZZZbfIG36THgeBStlln9TMzMyl98W22G3wD/TwCUtl7n7lLLLL0Yz4mPiU9b0cDgL+sz9l7L2eAkRwRwR96HRXxLsD6l+4hCDD6hh9wxBh4xMcF8W2y/u+LbYg+4Ybbb/beFtvf+x9t4cGGGGH3zbbYYiGGG239222ttttpbbb/AJbb+7bZbbbYbZgy22yyyyyyzLLzbbbbf3bbbbb4bbbbbNtrbbbDbb02f2t8Bv7tlll/qWWVsstvGWW23bfVtrxsxjF9Syy9SyyymWZZZZZ9zPFt9Www23+pnomei9UspSlllllllKfSX9yzwIQhTkJ/q+PvH7L2/b9k+n2b/rg4Dg4L6h9cEpTlLpE9EMQ4EIQhDgcH+0z/ABwstttsMNsMMMNtsc223xGHhbHNv+22/wBcIhhh9QxNtttthttIZbbZiz4gH3bbbwsstssss83m2z87tvkW823i+G8LbXjW3922tsvDwYsststssttsz3ZZZbZbfcpjF4X1L6lLLjx4ZeL7lllltnwB4GMXuUvcpZl9yl9SmUvqWX1LL3bwYiEOZ4c19+q8SL4iI+xEfWIvSUpSnDEIQ4EIcCGo9IhwPANtttthtttttthhtt3hbbzefmPnBhiGG2222222GG2Hptt9W2y229Hg+1tttrbbE22W2ZZeLx7vn+bbbW2L3+v4Nlttttltt8AzZ6FmLLbLbbbMzMvNl9SzwWXhiy2yyyzM2yyyyyyzLM/ZbZbdl9TGMY+3BZS4Z4eFKWX3PzjLbHAhzzPeqfe9k+szXAiIiIjg4H3KUtIcOgeke17OCEIcDgP922/uJstt/q2223mw9GG22IbYbbY8j5H7thhtttththtthvdsNsNtv7ttttltttttt/dv7tttttLS22W2W3i28/zjxbebzbebbbbb4bzef/bbbZfVtsszbbZbbbZZbbbe7xZbZeLLMvFllll/qUsstsssvVlmZmfvGZZbZZmyyyylwy+p4ePDfEzMzPC22/14B4PBttsdERwh9RHAylKH+44CDKIQ8AD+4hNR4Bv7tt2222G2222GGG2G3m22w9PDfDbbbYbbYbebbzYbYbbbTu22stvG22w+7bbYbZbbbZ2bZZbbfDeLbz/7bbzbZ+92eLbzbZbW2WW222222WW2221tl9W235lllllll6rZZe/Usu8+JmZ4ssy354/ZmZeNllll2WWXqWU8M31PCyn5PHxPS82W2392ts+17SyyyyytvBH0iIjgxEMQwwww8Bh9cCDwQYeh4BttvG7bDbbDDbDDEMNtsMPNhttttt4Rbb3bbbYfVttv+W222222/wBy2222y2tv/wC22W22IbYbbbbZbZbZebL3e77tnm2222922W23m+G9beLbbzberbbbbbbbbNvqWW3jxZZZlmZZZ4s9PSzLP2ZtmWbZZZbZZZZSy9zMy5w31KejM8Z5+ZttmWW3evS+oiIi/EcGIfUR6Ydhh9Shl6hhhhh4GG23CGG3gffNht5tsMNvu3owww222www+I99bbwbb10v+3/b/rbltv7tttttttttttttttttt5tttv7tttm3i+W/ybbb3eLbLbbbbLbM/ObbM2z15tsvNmWfB4zMzMsyzMzwzP22fs9X3PGZnhZZlLMvqZ+zM31M8MzwzPEnrPgzxn98eD7ERHSOCIj70IiPkR8iIeERHD7ERbw+eBEeGx98Dw/Hdi2ObFtvNjy2PPP5N7r57x98/HjndeP68c8Px4PFnZ8F6zx8Pxx4+LP2e/3PyZmZmyZ4eM/Jn5PyZnj9n5PTw8PHxPTPyZmZ+T9khfEySTwkknEs9yWWSWWZM+OdfUREdIPcEEcB6iIiOCPsRwREfOHD5ERHc8T50jh4Ed/rh/4yPPOPPdvic3g22+Dx6ng+D+v4N8Hr14+CerOZJZx4mWeDM/ePXwb8cP2ZmfUzPGZkvwmZ+epmZnhhJMySSepJJJJJJkkks4JJJJJJJJJJPD0skkkkkkksssgg9wg2CEEHuCIQ9LIhBBBCCEEEEEEEEEFnuCyPkEFkWWWWNlkEHgeB9jwzh/BnPxHM8M5nM8c7llnc92eWWQWerPXM7knufVllnMk92SWSWWWe7LLLOvgknM4+KTxskmySSySyz3ZY2WSWSScSSSSSSyyYklkknuSEknCSSSe5JNkkkkskkkmJwnCTGMYxjEmMeTXg5mNY+DP9ZrHmx4PAQIhCEIescCHAhCEIQhCEIQh7RDwAII4ZZBBZ/lkFln+2dCZBECyyCCCCCyCyyzuWWQWWNnqCyyyyyyyyyyyyyySz9WWWWWf/ALLP1ZZZZZZZZMySyyyyyyyyyzjO5ZZZvCWWSWWSWSSWSWWfqz9Wfrj/ABZZMYzJjMsmZZJJZJZJMYkx4ZMYx9J9JOHgYxjGMyfSYxjH+kxjGMYxjWta1rWNa1rXk9hjGtY1jWNf0mPNrWveT2RT3inApwPeIU5SkKQhCEIf0jgQntHAhDwA8A/xxnvp8dMs9cBZZBBEyyCyyyyC+rLII4f4ssssssss/VllkFn+2fqz9SWeACyyyyyCyyyyyyyyyyz3ZZZZ+rJ4Y2WTw/6ssss/VnRmScZZ/srbJLLPEM4S+LOmerOH2v8AHR4IzwSej/HLGMYxn1PA8GPBjHwB6WtbvOXZ+Z/WeTGP68PvPP2/ExjFf1w/pw/pP6X+J/Sf0ng/pP6T/af0mMf0mM/xM/xf5v8AMfrFKU/SKU94p+sfrFP1h/1FKUpTs/58gClPa/xHiAP1ZwcA9fwgGo4EyyCyFE+uCZE/xZZZZ+rLGyIQmWcZY2WWWWumWfqy/wCumeA/xf4sf6tf1K6Zf441Y2frpn+xwSx/qxtWST0e3GNlllljZZZZZPDP10xYngz9L/Fn64Zl/jh8wDP8cM/aZqeDGMYxrGMa1/Sf0mMf0n9L/E1q5rWvP/Mx4P6TH9OGf4mP6cP6T+k/pP6TWP6TGP6Twa8mf54fb5PBc/pMY+nD+kUhCEIQ9rX5iHpEKdZCHAh+sfr3O8pPrgp6xTmczfixAcHgBwOghM6HgGRCH6cBB0Oj/HTW+AyzjL441xnTX8YAfFn6ss8gHRngGPiDL/E9GpXDw1w8PjyAw8gHoTpniHxPBjHgufW/zNY+sxjGPFrVzWta1rzehjP88Ky/xP6T+kxr+vLf88f4mvrPrNa/pf5n9Z/Wax/WfDWPp84a+0x/SY8PREP0v0RCAgceiJ8RCEOEh2esUhPiOfrF/wA9yGODxF9WLPObHJ4KQhwJ9Wen3HcT/EdB4g+I8Aw6Y6YscZY6fpZ5gf46ZP8AIBA8Pix4n/nyBnR/jIB/+erOMeAfCGPjP48UZj+uWtdz3ta1jWsY82txMfaY/pfU/pPp0eGv66f4nbJk3693h7zWpmtaxjc5Na1rX15fefWeTH2mvEp+kcB7R7x+vEh7xSFKUp2HpEOZyPBz18c/Tg4f44zj9vAE/wAR6dDyQJ9WHGWQWcHDLOnxwdGeACzwGdCPkB/i/wAX+LL/ABZxlliyzo9GeIZZPDLP9nox/qyyyZ8Wp8QPgGWeAeDM6ZMZ8ST0M/xf4ma6K4Y8GNeTHg1rXm18btffl55/qf1v83+b/PhmP6cf4n9OGMY/pw/pwx/SY8D6fJ4Mf0mM/wAz+s1jGMebSnpxPfh9cP0jkIU9uCEIPYpT+tr+ohDwD44P0j9OCE/x014gT/F/iOH1BYWWfqxssb4gg/Vh+SIHTLLLLP8AJ4ZB7s6Z4hln66ZZ+r/Fn6s4zjLLLGyyyyz9WfqyzjLLLLLLLLLLLJLLLOMmZJZZ+oJLLLLGz9cZZ+rLLLP10ySz/J9uGa/ro8GPgGeYDMmMYxjHgxj6TGMZ+kzH5J9r/E1z+LE37nNq/wAcPdu/zf4vjw6uf8zX9Zr+s1/Wa/rNa1r+s/rNY+luYs/rNa1r+s/rMPSIQh68EIQhwIUhPiIcCHDI6M4OGWWPH1wQ4B+rLLLLOCZZf4YmWWeAOBMgssgg4yyCyyyDgdyyzuWWWWWWWWWWWf5Z/ln+WX+r/Vllllllllllllllklllkm2WScM/xw8E4zjGZjZ+rL/Vln6ssss9SWTEkssskssmZJZ/XgMs4yT1fXDMs6MeDHoY8GPQ9LGM14Q/TwDzcTGMehjGYmMa19pjHgxjGMfa9F9T7T4A/S+In1EIQhCZZBBZZBEyCCCywss9QQWf/sggss/UQILLLIIL/VlkFljZBZZZYQQQWQQczgWWWWWWWWWQWcyyD3ZZZZZZZZZZf6slWWfqwsLCywssLCywsLLLLLLOZZZZZxsssss5n6sskssssssssksssssv9WWWWWceZNllkllklllnuyyywmyws9WWf3JPpJJJvDqYl8cPDL2mMeD6TwY8A8Az9p4ZMZ9STwyYx4PBOGMfSZkxjMn2k9zEmJ7kkmJBBBBBBBD3BBfEEFlnuD1BZBZBZZ+uZtmRZZBHgcyyyzuQQWWQWRZ3ILLOZZ0sssss5llngFlk+X/LPP8A5f8ALO5x92WWWWWWT3LLMs5lnMsss8Xwyzwb/lncsvzzLLLJLOPHmSeWWcyyyyz9czmTMkk2WWTf8mSySZM+8SSz9SSWf3ZZJZ/dn6ssks9WSSWSTJ7mflnE2SSz3JJPySSySSST3JJJJJ7hJ6kkgg9weosiIggjwDhw9X5/gyOFnDwPE8g8MyPB5nT+TY9/we/4P+/+POMc9fqf15PzmeGWWWcyyzuWT3OPXj+vDOZ5JZZ3J7kzJP2/MzMzMz1n7Z1mbPDJOv3j86nGSbJ9WTMzZZJM/ZmZ4nDPyZITMkcER4D7H2I4fIjh94x4HzwDh88DmeZ4Z04eB5Hg/P4A/nP/AAZP8Dac23vzwYn+R4+D4Pk8f4Pvi8Xr4Pi2cb8cepZtnM8c82fkz4PuZ+TPGefmZn0TM8fHGZmY++BERF+ERfiOHDpH8B4Zw8z+I8DrHzh/If8AqyzpHhtvdn7b4vhvhs8fBt6344+Tfie/iZnzfHbfA+cffgzxmev2ZnjPHuWSZ14z4rH2ZmfszN+OmeM8b6mZ48fiZiPsRHR8jgi/EeZzY+eJw/gHhw8fz/CeH56Wnf8At+Ob4D/Bsfz7bbzZ5ufwPrmeD/Dll+L8eC+O2+bx8Hjfjjb/AAPXj6njxmetvXjPHhNvgtrx4zPGXjx4/ZmeMz85kzMzMzPzwM9Ij5H2L64dIjwODHR5+IeniW2/wD3ebf8Af4Mjo+B04dObbb4jbbbbb/8Awnz/ABPd/g3jzbZ8XrfDjZZZ5PW/Fs8fc/JmZ49Z48fHffN8Xjx+cev2Z4/eNvHwM8MzM8N/c8fzPDhEcI4cIjh8j7wj7H3yOPN7+P4Dh0ienifLbeDwt4f+jf4d/hW223h/C+G+H4nyeb5Pg+Dx5+PFjz3m9XjMzM/Z8tlz4fwvHjx4s8ePGZnjx+Tx6ZmZmZm/ueCIiGIj7HCI9RERERbk8/PTzLffge/E6cI+8OnDn48z+L8W22/+bfLfFt8d8dt7nfx38Q+rfEJ8Hwef3bbxtt9cevdt7/8Aef34szM/ZmZmZbZ4/wAO82ePizMzMzMzPGZm+uMz94Z43x0fIiOEfYiGIhhjhHDp8t8N6Pd7vGPVvSOnc6d/EZ+OD0j+Heb5Hq2223h/5m3zZ8CfN8Twzye/LePV/g2fLJ9Hg8emWeMzxevd7ttvHw3n44y9WZmfs9Z4/Zmfs8PDz8JmZn5MxF+ekcIiOHBjg234jmx7jm22xwe7b5fjhze74jb47e+nTv57v8efzny9+H46WbZb/Vvi+T47b4beu7bbbzev8D4v3w/Mvm8eLLPHj1lnq9Zllt7tvjvNmeM/J+TM8fc34n5xmZn5PTP2fvDMzPSGIjhEcOEfL9REdI+9Pt+beHdj5HicO/jm+O+G+Bbbbb3bbbf4t7+ebbD3bb3zYeb5Z/A/P5H/AMu8Ob4bz88Zberb3bbbbeNssvWb/s8ePW2Z4zPd7tsvGf1P78ni+5mevqfnGb24zMzMzMzfhPyZhiIiIiIiOHBju8P4vX9344d++BzPE6eA+J4HzuWeJ5H8W/8Au3m93x2e74bb57zfDb8z6nr3e7bb3eb/AJLbM8ZnjbNszxmXj64vNtttttttn3PF6zxnjxZ+Txn3NvGZ4ZmZm/Cb8TERw5sRw/Uc2Itjp4D6t4c+Pd4+r89/Hl+eDb4ngPDh8t8i9+W/+rbbbbbbf4HyW3m2222222/yfePN5svdnm2zwt7uW2+G8ePHjPWWZeNvX13bebPlss8Xmyz1+ceM/mZll6ltmZ+zP2fszMzM9ERf5EMRDEc/EeuH2PE4Wx9vVttvd8R4W8Leb3fDbfDfEeDzbfHe757bbzeb/E/zbLbbb5P3+N+920tJbePi8Z692Xj1t7p3e/i04s/Zl5s283iyzLLzbebPdtl5tts+T1mebLxm2WWWePgM8/KfxENtsMRHCIjoxEeo4eBz8R5ncj+Ae73beD4bFvvwIbbebzfHfP8AyyJ+25bze7bbb57bbbbbbbfSyfD53ebbbzbbZbfDfDbb/nd5tttsy8ePG3m357pbKXq22W2X11bZ4y28eLLzZllttlttttlttltnmy35mWW2ZffFtlt9SzL14yzLMzP3pl4cHhEREPC3pHSOnDhzdv8At6vz47HgW+B3fDY5vSIbbYjw2H357bbbb/5X+Pe7PHrb473e7bbbLbbbLL6mfdvg82bZbfHebbbLbzfBZZZZZZeLLbbL1Zbb/LfDbZtlll434t9yy2ssvNltll4ssssszxl9TM8fsz8lmGIiIYYYYiG2GOER6iI4d3mw+rebHuO/mLeb4b473bbebFsfe74HNju2/wAZ/wC9ePg/OPdtt7tttttvNttttlt5vHrbbLbz/LbfDeb3ebMyzLLPN6tsvG2WZ5vdttttlttn9TxmZtyfvF9WzLPy/EvqWZ5syzxmZmZl2eH3oxwh5vCOjbHDhDzbeFvNti23n55tsNttsW228222223g8ObDb38RzfItt/8ATvm+O+rfDb82/wAe/wAjz8dbebPN5tts93w2eb3eLMy2y9WW3n5mWWWebLbPNi3v5ltm22ZebMzMss235ll5s8Zn7wssvufvD8lMMMfYYthjhw4Q+o5scI5uX45uW+O2w+vDfA4feDb08Nzgw823h++HNt5sQx5MfwbbHjtvdt8d8F8Xrbze775s+G2+Gy282222W+831bbPN7s2+Gy83m2292WXi9Xizxl4ststvVtbZbbbb/stsN8m23jx5ststsss+ieLL7m3uy28ZllmWX1LLw9WxEPBhhhiLYiIY8d4eW9Lebb3en+82222LbbfAt6fObEW+B85vNt/gPPbbf8Axbx+d2evhueO28bberac23m8e7zZl5strNvhs+G29OLPX7LkvGWXi82Zlttmbebb3Z7tttvH0Wy8WZZb/Z+W8Zn5Lxfcs/ZllmWWWWUs/bejDDDEMQwxDENsMMMNsMR8htti3wPDbYttttth6d3w3pFsfwb/ABngPNt5vjttttsfbfHf4N7vf+zb/d/nNt928W23m29ebbP668W2ebLMtvP++O8W23u222yzLbLLLx4vN4sss82WW2222222223i28Xm2lvF9S282Zn5MzM+59MzLksyy2yy2WWUMeuEeoiI6UPNhhjp09c23h6tt5ttvNLe7zbbeDwbbbY4Wc3Lef7w4cOHDp4747b/AOLf4Vnu+Lxbe7bzevzj3erb1vzzerbx68Z5vVt8XwfkzMssvHizx4z7mXx23w23j8v+228bZZtlmZn5LbLPtn1fmW22ZfUstssssspY9x84MMR9iGGIh9w2wxDwtt9w2+u7bf1zZtt8D705seB8htt6W9HLffDxH15H3m54nmfz7x/hXi+XyX30tnye73bePD5x4/eP3i89zxbZnz223m9WZ4zLPFlmWefiZ8P+zb/Avu2bbZl4tvF4vFlll9zLLLLsy+5ZZSzKWXqXqXZYyGI9xD/UNsRDDEMQxDDbzfdtqH1DbHD/AG2222ObbDw5vNteHD+E4Wx0iI4T4Db3e70n+V89nu9/M/e7xb8cbe7bbLLPN4+O+Dbz/ssvG14+DbbxbfHevHqzLxl7vVlllt423/be73bbb822yyy5a8WWWWWXiyyltl9Syy8WZZiyyy2y2w+4YYfdsMQxDwYYfVtuQ8GG/wAh4RDwYYh5+LYt4Zwbb8RfmeHdj5b3bbYt4PB4cOny/HD+HYeH8W+W/wAH483rxe7ze7bzePhvivG23q9fXnvGbbZ5svPxNvFlmXjx+WzbbLbM8W3z23i2823myyy+7ZbZt4szKZcltttll9yyyyyyy2yxEcGHg8Ih4MPBiGGHpDDkNtsPNt5se+fjh64euEdO7b05vPlvDu+/M8PxH8G2+O9fF/i3b8eDxevG2Xmzb4LNtttvd7s+G35427b3ZZeLbbzZbeLb148WZmWWW2f1NstvNl4svdt8d5tstststssvNllllltlll4X3L7llllllmWWWWWbbchiGGGIhhth4MMcPXDg28GGG22222Hg2222w+7bfEttttjx3n46W2xDzYiP305viffA/l2fLfHbZ483m2/1bvN622zbN+Zt5stvN7sz3Z8N5ts/OM2xM222222yy++LbMyyz8ltl9y2y29XzbbbbbbZtttllltttltttl9yy+pZbZbZZfcstsstsuPC5LwbfUMMRHBDL1bKHm5bHNwj5H22LYeHB9W2+Ow2w92G3g8PAtttvxbDb0b88I5tsPrh/Gf+hbfB8Wes822bbZbZ89ttt7vW2befnj86ueLbbbbb1ZZfVs+p4zKZZbbbbZ898Xm2y2yyzbxfVsttsssssvqWWWW22WWX1bLLLMzM8W3PsOxEQ8IeEQ+oY4W2xDbb4jb4ndt5+OnD1zYefm3gw22344c31EW2x3O757fnh/Fttttts/wb4vzyfF7vd5svk+O8+s/ry3m93uz1t6+LxnwUsyyy+G234t4+C82W222eM+p8Nltl422z8lll2ZZclmZ4sz84uPTg2wwwxHRh9RDbFscIi2LbbYbbbbbYbYY7vjsPiNsc/wC83m+I8I+8PDY5vkd222223z223w315fnw31x4922Z4zzePFm/2Xvq9Tb4Mzb/AFx5svu22W2WW23m282WWW2WWZZt9yyzLLNs2y2283m8Z9W2822WbbbfU8WW2XiyzLMsvWW2Zn5M8WeP2fszxttyGHp9hhhh4MQ8DtsMcG222GG3mx9tty3hzY8Rvzbbw5/23n5ti3w/Pdjh65tviQ+B9jp4bH8mzb/KvHjx5uW354tvnvjtvWZbZl692WbZbZbffNt5stssttsyyyzLLbLLLbzettltn7zf3bbLa2/u22bbZZbbbZZd4szMvWbeMvGfsyzP2ZmebDEMMPBiGLYYYbYfVsQ5bzeDbbDHiMMW9Ob6th7sNsNttttsNvq222LYbekX4hiHp18Nt8z/AMG22+o8d8GZ48ePHxWfbzeLbbbLbb6ttt48W2Xmy28ZbW2bZtlv+3+225LxZZtl4zLxZbfctssy2y+7bZfVts/bbbbZbZbeM83+peLLbLLMy8Z49Z+8ebvGXi2w22+oS2G3YYtyG2I4MMNsfu2G22Hm22w82PkPqH3b/dvNt9282G23hDaWkPdtthtthth9W3+8Ij75bwY4cLebbbHm2zx/g2W3r3bZm3j4vdyfs922W223hPF7s5Lfnjb4bbLeuLP2/wC3qZbZbZbZlltltlltlbLzZZbbbbbbZbbZbbbbbfcstsvFt4sssvuWWXiy82WffGWWX3L74/Jmb46GH1wYhyGGGGGGG2HhEMMoebDDbbw7sNtsMNsffXN6PSHh0eb089j54HDyPvmHS22LbZfFvkx/C+G8fky8Z6/eNss8XjzbfHbfBetststsvV9W+G28XxWW2ZZZZmfk/JeLMstttvNtlttlmWWW2231aW2yy22222yy+5ZeL7ltn7bLs2y+5fdvHjLM/Z+8LbYYYYYYhhh9xwYYhtiGG3h0ebDDb4nBt4NvNvzwttthtt4cHwOHD5w+eGxHgc23rHS23y3rffN+dXrx+T4M9Ztttmffitra2s228ebx4/JZbZeLbLzZZe7b3bZ6sszxbbdmeLzbebLbbP3mvFteLbbNstsWy22y22yy82Xn5tl6svN98fk2z9mZng22xDDDDDDDDDDbbDFsRER8ttthhht/zmxba3/Yh983gw2/u/Mc22PAYtjh96fYv6iPnD5w6dIvVt/3m/74/iO/9juzwnx3/b8Rze7x8Flnu83uzb18dt8GW2WW2bZZ7ts22228bbbbbfcsvV9y2zM/Znq34ty3my8WW3jbbbLbMtttttssv7t/22WWWWf94tsvq22WW2WZZZll4stsvq2W2GGIeDDHR9w2www+oYYYtIbYbYbbeENsPN5tu822GHw2G2IbYbbYjg9I4R+b8RfiPnC3mx453Y9N9W2222/wb3ZbebL3ev3n54vq/FszPyetvHjL7nu357pb6llttttlt7vWXJbebbLxZ992WWXiyzMzPyZl9TL6tm2WX3LLbzfcvFtl92y2yy2222y2y2yy+pZbZZltltv8ttll5sstsy+5ZZm2GG2H3EPBhhi2GHg+o6d223mxbb5DbDbzf1zebbHBth8T5Lp84fYvzEcOfiI8B8dttt5vrg823m5bFstvN5+LOfOvk2zM28f1LLbxbePW2W3m82beLx+eO22yy8fvNn5bbNvdlll5+JmWXq8ZeLMS22zzbbZbZeLLLbwvu/Evq3i22yzFll7sttsv9Wy8W2X3My2yy8Zl9ywwyhhhhtt4NvD5DbbDCxDFsX54W83m8GLbbe7bEc2Ithti3xI8Tp9jpEPltttttvicPA5/3yebPNlttlt5vNm/EuTx8Hm8Xi356vrm2zb1bbZZZmXiz842y2y+7bZberbbOy+rZ4/ZlmWXrMvu/Mttttttssy28W222X3LbbLbLbKyzLxZZfUtvGW23mzL7llLbbb7ll9Sywww+oYhiGIYtiHhDKGODD7tttiLY/cW2w83gw2xzYhj0+BbfiIh4Rw6R9tvxfhHDx2223v48dt8dfNjjbx7vN6vd4+rZebPzi+rZbbWW2XnqbbbbbeNtttvG222ZmWWWW3uzfm3i8fltszLxtl482ZlmebLbbbbLLbNsu2y29222W2X3Lb7mbbclt6tvFvV+ZZZZZZZbZ+yy+pZQwwwxERHRt4MfIhhhiPE4Rze7Dbb+oj7bbw5+bfDYh6Q8IiI4feEeZzbfLeb089ttt7vhvVtt7vCX3Mz8vxxZZbcZbbZbbZbZ4/ObNstts+LbbbLb/DvHnqWXi9Zl4vVlmWW2X31bZZbbbZerzZ7tss/JbZZbdm2Xmy2yy2234ni+7ZeMyyyzzYiJRwcOFsNsQxDENsPSGOnNhtOHCNt/wDtv9ww93h4EX5tj5fiOER+Yi3Onq2/yOH8G222+Bbbvd8Ntm3wfLbZni/rr9mWZnjbPNt/qWeL3bfcsttttts22zbbbP2fFtt4/Lbbber6n7bxm/3i8WWWWWXGWWWZZbfcvubZbbeLLbLbbbzbZeNszL1Z5ts+5lltllmWXh4wxDDwQx7iGG3pwhhh9Q2+rY9PCOj3YbYebwttvxEfYbeDfm1iI4N+Ih92wxDDb0YbYbbYYzm22222283w/HgP8G83wZePNt48Xjx6ttsvNt4vq222W158ttltlt5ttrbPG2b8zLNvGbebzZbZltltmXOMssszM8W2WX1MsuW73bZZbZe76t42933xZmevg2y234ltmZ+SzL6lmbYYYdhhhlzYbYYhyGGH3DDDDwY5sMW22293mxbwt9W2+4vxDwbYffBthh4MMNtvNhh7sPd4NvuW3m22293g2x/Btvgsy9eLndmXjPGZW2zLLbLLbLbbzfVv7ttlttlttty2W23my+7b828ZfVtsttsttttttts2yzb6lllltl6/rmz9tlm2fctttttvGWbZbbd5svX5bMzPGerP22ebMvrrL74vBhhhlDbD6h4PD50eDbDDDDbxtsMNsNvBht5vTg82Hu2w8I5+IebDEMoYb8Ww22www+oy3/IYebb3be73bbbe7bbbbbzbfB5vF8HjP2Ztl4/JZbbZbbZbZbbbdttlt49W222W3xWWWWbbZZbZZbb/AKltlllllllllllt4sstsst+ObbbNuWyy8WY4stvFt9z942zP2Z4z9tn5Myz8lll4tsvF4sMMMMoYbYYY+xDbD7th92xbDDDbbbDbFsc3u2w2w28GOHTxOnNhhiH3HDfVvNy2Ho3p5sW23qLbbYbfHbebbbb3fB6s83i2251+zxeGZeLLbMsvq3m229bbbbbZbZbbZttttv+zLbxtt6vGX1LLbbksssssssss2y2yyy83ulvq23m22y9fVtvWePWes8b834nizxbbZfctusvFmH3D7iUMPBiGGIbbbY+Wx0YbYh6dHhFtscPUMRw4NscGOb5HBv8hthth43mx474aX5+28Hh/Bttttvd482fJjmzLPDbPHxeb3bebbb4r3ZbbeNvXjPFy3i+5ZmW2WX36lltlt9Sz6ltv7425Py3OMzLxtm3m92b14s8Z8XjfnjLxmZ6zLPH50YYfcpQww+4YYYbbbYYh4MPBthhhtht9Q228I+2+J5n3hfjh07tsMMQw8G22HjYm34j7bbbz8c3hFvh+b/t7tt9Wttvd8NtnjxiXm82WWX1N6n9TM/b8Wy+57stttvdt5ttttttttttvN49ZtllmbZbZZZZbZlmX3LM+pZbZlllllt3my+542222+O923n5mZeL7meMzPGZl9zMzbbM8X3DD7hlKG2GIMMMPNhhh2HIYbYYfcQwwwwww28IYbfAfAjhFvDwLbejbDbbDbbDDbDwYfAeFtt+fAth981t7vN7tvg+DL6tm9zPqXJZZZcl5tszbb7mW2W2Xm22222283myy22922W3/ZZtnwWWW2WW23i2yy+pfcsvuW31LzZZZbZm2W2WW2bZ8dt8HjMs8ZltllPVmWW2WWW2Xm2yww+4YYYgwwww2w22wwwwwwww2+ofUMMQ22228OkfLe7DHCIvzbbFvRzw3hzebD/fRttyGG23mx8t5scG3g23+Xvu2w8WM58tt8Nt7sS22pZZfcts8bZZt9TbLLbbLLM2y2228W31zeLbb/tvu2/Hg8eMsssststt+JZjLbLLL3ZbZbZlltllttltttt89tlt5svdtllttltttlllmZllmXmy8YZQw9AYYYYfUMMMTYYmw+oYYdhhhhthth4Ww22823m8I8BjhfmOb3bbbbbbbbbY5sfeFvd3wfXd8Btj74Hdttttttv+2zzc7/2W22WWW2W2Ustsyy22y2yyyy2zfVpaW2ttttttvq3jbbL6tt5vdlllmL7llt4W22Xiy9W2WbbbZZbZZbZZbfdvNtttttttl5vNlllt9cZsststssssszFlltlttyWX1bLEGGHgPuPSGINsNsMMJltsMOxDDbvBhthhhthjg2xbDbbEN+Y6Pvg8LbfA+83hDDHB9x4Hic3pHTy2222fDfDfBt9Sy+5Zni+pZbZZbZZbZebaT9tlt/dssttvNtLbbbeNttvNt8Fy22ZZZfUvrhbZZebLLLbLxZbbZllltmWW2222WW2eG222222y222yyyyzwWW22W2YsszZZZZbZeLbLL6t/dsMNsMMNvgAkMQeB9Q2yth9xDDDDDDDDDDbHpDsNsMR0iIen3hfmJ7sNviRHDh94fYiPkfPARw8C/PD+Lbe714pZb8yyzFlll9S2zNlt/u2befmZl9y22y222280t5pLxbbbeb3fFZZct9TFltlt5tsTxZllll4y2yzLLLLacLbLaWlpaW/uIttttvFllll9Syy8MWZv9yyyy+7eCyyyylsstttpDDDDDDENuWww2xB9WwxbDDDzYiGLYYbYYYbf7h5+YebHDh8i/PTyLekfOEcIiIiPl+I+cLY+Rz8HD5fjhw/ifNnv4n1xbZbZepZbfDbZ5stststts82W223u22283+Fl4zLxeLzZfDZbeLNs/JbZZdltllltltlltbbZbbbbYbSYssssstsyyyyyyy2zLLbLs2+5ZZtmbZbYYhiIYYYhhhhhhhhhlwZQwwwxbbzYYbYhtthhht2GI4RHBiG2222Xm8I+xwjw/F+I5+OEcyOnH54fyfnxXiyzNstsyyzF0njLLze7Lx+2283w/7bLbf9v+93+PZtn7LL3LLLLLzfJ4ssspSzLLLLLMyy2yy823m2ttsNtttststvu2WWYsstttsstststtsvuWW1tltt4RENtsMMMMNtsMMMMMMMMNtrbD/UP7hiDDbwbfUMMMMMMMMS92wxEcODbbfm2IjhHCOHC2PnDhfju354R8jw/Fvnt76cfl+LeNstsy+pf1LLbbLLbLb7tmX3LLb15s+e2/ybLbxZZZSllmWXm282W1tltlllllllllllltllyWWWW2222220t/q2222W2WWWWYsstvqWWWWZtstszZZfXCyy8WWH3DEIebDwQhthtiDDEPqPfB9Q2+ogww2w2wx6Q22www2w+4fUMQ22xblsPG2282HhERwjw/PTm2+o+W5wYtvxxe7f4ttlttltyWWW3jLLkssssvuWW2WWWXjbbZbbbbbePHm8eZ47/A2yyyyy7LLLLLPNtmLbbwxZbZffCyyzF22WXjFttlltttttttt5tsssvGyzFlmL6ltlmPpbbLwzZbZZZZZttt4cH3DDbbDDDDDDDKGG2GVsNsMQwwww2w8GGGGGPcQxBhtht22222G222GODERwjh/APfUfIvzwj9cP4Nt5tttttstsss/el4/qWW2Zll/q31bzZbbebbM83m7fib3x5s+L57bMsspZZfUsststtvFttllllmLbLLMWWXbZZZbZltlttttt4tstvCy+pjFtttl5vq+OGLLbLLMZsstttsssttsMMPBhhth4PqGGGGUMMoYY+RbD6htt222Hgwwx6tiGGGGJQ+4bYbbf3bbbbLbDwiIiOHd6NvCI6fI6fOlvjtvNttllt/ctttsssyzMssszL7m3qy283wev77n/AIHj8t9y8WWWWWUtvvizxtlttJZZZSy2yyyzLLLbLsy2/wAW222222y+rZltltmWWW2WXi22z75vGbf6mesvDwGG222GGHY4oZSiUPuG2GGIYejDDw4NsOQwwww+4ibDb7vqG3m2wxEOXxEfYj5wjm2222w28LYebbD07tsttttttssttvNlttl99Uy3xx4/PBebx5vX7xs8c8c8m/uZ4zLLKX1Msszbbxl9zNuSy2yyz7tlmZ4+AzPHyb/k+H54zLNtvNm/EzPP78WZ4z4P5nj9nhEeGwwxF+YYt9wwxEMPG831Dbw9c2HgxfngxHCHg8GGGG2G2GIiIi/ERHNttttttthtttthhhh4Pd7tttuW8W222WZstsstssss/J+z94/J8Hj4N/fllln8T15+JmZlLMsspZmePGePqZ4zx+TMzPPzP2/ueMzzJLP1Yzxsszr9mZ+8fsvHjM2STMnGTmWWcyFlk2WT38Rw5vNt4X4hhiIi2Oh6R84Qxz4iHh84I+8GLYthhttttht4RH2Ib8xEPdt5tttsNtsMMPq2IMNsPNtbbebzbZeFttttltbZbZZ4z4M/J8Hx/uye+r145x8smeP54/ZmZZmZ+zP3j4ZMkzxmST1MyScySSSyySSSyyTjLOEWHGTJJJNkzZZJPGZPVnqSSSyThPdhwkkklljjJLJIPdnTwDhEMfOCGOiIiIj7HN4feEREfOEdOnDpEcIjjYjg22222lpDbbbbDbbEIQYbYYbbbbZbbbZZZZZbZZm/uZtttv8AdszMszxZmzr1O5ZZzLLLCzuSWWWT14zxmeszMzJMkkzNkklkklkxjGZJMzhOGMS+uMs/Un+3+G/xf4ngxj7SSSWSScZZJZZZZkkklkx4Jwz46Pt6mMeCcMSxssssssg5kEWQQRBERERw4fb88PkX5iOBB64RB0IizhER94QRERwjhbbbbbba8bbxtscCE2IMNttsNvd4sssv+zq22W2222W22X3x+T9njxs8MnwzrJZZZZzONncks5kz1+zJZZJJJ6kmyT1Jxln9TGYzweDGPB6Gr4fbhj0fXi2X/Vk9DVTEmJwx4JwzOHofETCPe8nXDPqYxjMsssbLLPUWQe7IWQiIPcRH2+Ie7HuQZZZHCCII4FkHAggsyzhe7IIg4cPkcEfI5ttsNttttvNtlhththhhhthhth9W22y8ZZbbeaWlttttttvGZ42SWTzJLJsn73LLOZZJZZZZJZMlnM8Eskkn7JJJJJJw9CrH+p/SZknDxebdX+eHgxnxPtPtM/zPJjMdDlj+7M8GtYxjweH/AHa8YfCHzYvFrHnvZjGvHVl/tllllnMbIIIPcEQQQQZB6g9Qe4siIIOHyDLIIiOBZZBBBZBvGQQWQRZ0i+Onzh98Ftttthtv+22lpwYfUMMMofcMc3fNZttmfA8/jj4vlkzzLLOZBZZZ0mbNskk48ZLOMkzJjGJPgDHpY8PS+rOHof1nm+t8zWMeH+L75z4bFi/xP68sYxjGPB4PR9TWZMfTjL9rF/mz/XZ5/wCJrWsffgxr2ZZ+rLLIhMNggg9xqIEHqEEEEHuyCyCIIIIIIggsiCCzgQQWWfqyyC/yzmRfiCPkWR05ts+W222xbFsRD4B8jwW3rbx5vTy3yTjzOPMss9+IWWcyyLLLLJLPB5nuSTmSWWWSSWT4BjxBj0f4v8dP8WOz6dHrY8H9Jjx+bFixfpw8GMY8GMYx8QPB4Y6f4j9L/Efpf4v8WOWN9HDyvYwskssv8WcZHApAiEIEHuOAWQQWWQQQWQWQeohMgggiB6sss9cyyyyyDpwjh5/m223m222228LYiHoRzbebk9fvHj3LL8+Lx8X7ZPyzjx5niWWeuZB3LLLLLJLLJ4kkllkllkknDMs6Y49uNeab4exjza1jHg/xYI8H+kxjGNeTweL3fXDMf1Y4ITFixy9DqeBjri1uWFllllkQ4BEIQIOCEPSDggRCECCCIFkPUEQQQFlkFlnMssssss4eBw7tttvhsvN8Nty/EcPAEeSzPllncssnj4PXvzjxs5lnMsssgsLP9ssssssnrZZJ78Msss9SSWWcZZZZZZZZZZ0ws4etrGsY8XxMzOAZ4DOMmMSeDqY32n+DCY9GdH28BixPtImMfbixjMk4FnGe7IIhCHAImQWRAyDjIggiCyCDgsggg8A9cyyyyyzyPkRHg+G9befnxOl+YPcEYPccJ5svV8Mss5lnk93zevp4nh/zn4szzz9z6mTjZ3XmWcTv4mzmWWWcyywsO5ZZZZZZZJZJZZMThPcxnxPQx4ZZZzJJPUkkxJCyyzh9J4MZkxOMs5nuyLLLLJJJLJODwegiyCD9cECCCCCCCCCyCCCxsggggggjmcIIiCCP3fnpZZ/AfI/h/vr5b4DHBEfYRw4zM/P4BZ3LON+ZmZefi3+B48yOHC/5ZB4vcn7ZJZ1+9ePg/fL3Z/Om2ZxJJOEkksk9ycZZZZZM2TZJJJM/bhmX1wxOCSSWWSWeLbx4ybZJZJJZBBBZZZBZECyCCCIOFlkEEQQWcDp6vxERw8REX/OvgcPl+fN5/fg8fI5+YhCCI8Ul4vgPfzzPF+28fD8Wx3/tk8f4TuR4Pd69ePU8nzfDO55ZZz/eZ3LJLPU/ZLLJn7162epLJLJJLJPVkmST7TBJMngeS+eWSdCLILILI9xZEcDh94HAmL+vEgj5wiIiOkR4Lz82xw+RHk+KeD98Qg9wQQQhBwQ82X30z6tmOnSzjPzr9l/iflttvmcI+x4vE68/M8Z+348n+Bt6222222/w5Zx4kzJPTMz3J9s+GWFhJZZJZJJJD1J64nHm28ebbltvFvxzJIiD3H2COEWR8iIiIiOfjpHy/HCPD8RHSIYiPFt8Dh96cO5Z4fnwTv8Azv4iCERHyO7LLzZt4xwjh1mZlnx/Ns34t8Hm+7bY+W8/MfwvHjfnuzPjtvhtttvntttvNtttttnv5nrPWe/mZn7Pq2eMlk+DJxmThPUmT+JmfkxP2eLaW22283u3/8QAHBEAAwEBAQEBAQAAAAAAAAAAAAERECAwQFBg/9oACAECAQE/EOblLl7vFy8UpdvFLly8XKXKUpSl6pcpSlKUuUpSlylLlylLqZSl8bl8bt7u3u83aUpSlLzSlKUvNKUpSlKUpSlKXKUpcpSlKUvNylKUuUpfC5RbS/Eu7xebtKUpcuUu0pSl5pSlKXm/LSly83b4Xu+V+G93i9XaXaUuXzpcpSl8aUpSlLxS5eaUpS7eLt9rl+Bd3wu0vFKXLxS5S7S8UpfO5eb73aUpS80vlfC8X4aX2uUpcvd+G/DeLxeqXhfJekL5rxcpfjpS/DSl+dcoS+W+t6pcvV7vjfwbxeb0sWwSEJEGhjy9XyWvq9Xu/wAGhCIJEIJCRCDQx5S7eL7vm+F4u3q+dL40pS5fsWIQhIS1ISEiY1j+l83b1frn5KEIQkQglkGhoY+76QaJjQ8fhdv7s8UIQhYhISxoeH5XpYiDDQ0Maxj2/wAahYQhCELGMY8mzheCyDDQ0NDQ0Mf8PCD6QhCFiRMWMeGQgkQhOULFzBoaGhBoaGPH/DQg+UIQhYsQsejIJC0NE9INDQ0NDQ0IMfs/wIQnhPRbBoaJkxCEIQtWvDIJCQsGhhohCEITha8aGhBBBj84TibCes+KdQnisXDROEIQhCFiyDGMgkILBhhiEIQhCEEhEJjGMaGhBoY16QhO590IQhCdTlCyE2EIJCwhC1axjRBIQSwww+yExBImMYxiDEEGhoZBohOIQhCE2EITITqEIT0nE9IQhCZBIQsmNEIQgkIWLELWNDQkIIIQg0Pl7LDwQQWmMYxjGhoZCEIQhBLuEJsITqe07hCE2EIQhCcQSxIXMIQgkJCELuEEhISEiEJ0Nll5oorbGMY0NDRBoaGiEIQgkTmE7hCEITZsIQhCEJk4hCEIQhCE5hCEIQhOYQhCCRBISELELIQhCCQkJCRBInAYYetFZsYx4xoY0NEINEJkIQnEJsITZs4hCcTIQmQmQhNnjCEIQhCZMncIJCRBYhLEQhCEEhIQhCQiCRCE4CCCDGPGMY0NEGiEIQhCEJ1PSEJ8U7nUIQhCE8IQgsgkISEhLFiIQgkJCQhCEIWQhCYgkQfMGhog0NEIQmQhOITZ7TYQhPOZPKdTZ1MWTzSxIgkIQsWLUQhCaxj4eMeMmMnwz6Z4T1Xa4QhC8ELhCFqL4vbyx4/ifjCEIQhCZCbPS+l90IWLU9RRFKJlExMTExMpRMpSlKNjZRspRsYpSlKUpS5S5S9X8ylLtLly5RMpRMpSiZSlKUpcUQWCCCwXmABhsehi6UpSlKUpSlKUuUpS8Uu33peb5XaUpSlylLlLlKUpSlEylKXyAC4BZLuIgsGGGGKPRSlKUpSlKUpSlKUpSlKXKXil+KlLzSlKUvVKUpS5cpSlKUonpSlxS9AXALBBc4XAUpRsYpSlKUpSlKXKXLzS8UpfrvN4pS8XqlKUpSlKXaUpSlKUpSlKUpSiYmUpRMomJiet42Xil7u39ylL4UpSl4pdpdpSlEylEy4sQv69YsWIQvjn4M+ifhLhYhC5ev3nM/kELVwsQhauH9E+CE+KfDPVLmE90LFq4evwnwwhCEJ+HCe684TJytgtQsXm8njPwpkJ6QnyTqcvpcLhCxcPH8U4nM9Z8s8p6QhBeE7hOUQXCxYseNZOoTZxCbPyZsJk8ITYTuE4mQmwmQhCEJiWLELELJrx+M2dTie84n2zieMxE2EITJs4QtWrFi4hPKe05nrCZOJ7QncETJxOJkycTJzOpxMSIJCEsSJrJkJ1PCcTmfhwnhPdeM2bCbCYliRBISxLibOZxMhNmwmTufoTiZPKEITZxMhBImJCQkJYsnLRMfU5ntPjnnOIQnlOp2vCbCCRCEEiEIThIS4nyTynM858sITmcQnpNhOZsIQhMSxImIQtmvYQnEJkJzCEITYT6ZzBcTuZOJ3BInlCEyczITYJdQnEITYTJsJkyeM91+DMhOITZs2EyEIQhCEyCRCdLiEyZCEHzOZsJkIQncx/LOJ3OpkyczIQnC2EIQhCEIQhMhCEJwuFryDWQnE2cwmQnlMnc8IT45xNnmlxOIJZMhCEEiZCE1IglqyEJjRCEGshCcQaJ4T5J7whMnE2cTITiYlkyCRNhNmTIQhCEITJxMgiE7a2cTZxCEJs8IQmT3nCybOoTidTITpbCbMhPVIXKWQg+WT1mz8Jek7hOYTUiExImwhPREyCQlkIJEGTtoaIQnhO5xCEJs4hPkmwmTxncIQSycwnqhbBZBIRCDQ0QmNZMgybCfFPSeU7mwnEITIQnUIQhCCQiZOoQhCcTELFqRBcNEINEIQhMaJkJk1rudzJk8Z3OJxOYTITmdwmQmTiZMhCeE2YkISEhLUiDGiEIQmQmQhCEJxCZPCZCZNnnOoTITmEyEIQmTZqRBEJk1IhCcwmTZkITITEJCWQhCEIMhCEITGQhNhOH3PqmJEyE4gkQnMJ1CEEiEJqQlxCEITmEITYQhCCIQS5aGiEITGTZs4nDJ2/gmQmQhCEIQmQhCeM7QiZCZBYkQhNhCcQmQhCEIIgkJbCDRCDRCEGhoayEyZCEIQnEITznUJ3CEIJcQhPigl1BISITYQncIQhCEIJEIJbPCZBjJjRCbMnU+mcomQhCfChISyEJxCeM2EJkIQhCCWL1mPJxBohB7MhO3syZCcQhCEJkITynvBIQup8SxZcXwv6ZzMhCdzYQnzLEIQvC5cpS8XKUTxFKXaUpSlKUpSlLl1/G+YQnMITqZCE6XzUuUpSlKUpS4pSlKXFKJiZRMpSlKUpSlKXCZSlylKUpRspSlyl2lLl9ZkJjHzNXpfe5SlKXFKUpcXFL2BRMpSlKUpSlKUpRMomUpSlKUpSlylLlLjZflY9n33qlKUpSlKJlKUpSlLtEylKUpSlKUpSiYmJ8XaXaXt/Ox/M/spSlLxRMpSlKUvihMvlfrnL956X610tvxPl8PH9bH4v0XLH5Lwer7//xAAcEQADAQEBAQEBAAAAAAAAAAAAAREQIDBAUCH/2gAIAQMBAT8Q6mz3hNhCdQhCEJxCbCEIQhCEIQhMhCEIQhCEITiEJkyEIQnM2E5hMnE8Jj5nc2E6hOJkJkIQhCEIQhCEIQhCEIQhCEIQhCEIQhCEIQhMhCEIQhCEIQhCcQmzYQmTmdzl/TMhCEIQhCEIQhCEIQhCEIQhCEIQhCEIQhCEIQhCEIQhCEIQhCEJxCEyE9JxPOczmEyEITmEIQhCEJsIQhCEIQhCEJkJzMnE4hCZCEITIQhCEIQhCEIQhCEIQhCZMnUITxhCZOZxCE5hCEJkITIQhCEIQhCE2EIQmQhCE85kIQhMhCEIQhCZCEIQhCEIQhCEIQhCEITJsyE8GieU5hMhCEIQhCEIQhCEIQhCflQhCEIQhCEIQhCEIQhBog0TZ4TJ5TiEyZCEIQhCEIQhCEITJ5z8GcwnEIQhCEIQhCEIQhCEITqE8JzCE2EyEIQhCEIQhCEJs/WhCEIQhCEIQaINEITIQhMhMmTmE5hMmTIQhCEIQhCEIQntfnv0whCEIQhCDQ0QhCEyEIQhOITiEIQSJkyEIQhMhCEJkIQhPK/bfC9rwgkQhCEIQaINUhCEIQnE2ZNhCEIQnhMhCEJk/aRPFIRCEGiEIMaGhomzYTYQa2YyEIQhCEIQgkQhCEyE5njfW/LfNLIQhOUJCRCEGiDQ0Qg0NDRCEJkIQhMg0QmwSIQhCEIQhCZOoT3pfunihCQkQg0NDxCEISEiEGiDQ0MeNDRCY9fE4hNSIQhCEIQhCEJ8Tx/krEJCRCDQ0NahCFrINEGsaGiEJkyEIQmQhCEINYkQhCEIQhCcTmEJsITIT7J8KxCCQkQaGhoeoTCJrWNDGTiDQ9hMa2EJjIISITIQhCdTiEIQmQhCEJ70pfaZCEyE7QhCQkQaEGhogkLCFjQxjGhjWPWMfc8EiYiEIQmQhOkhIhBoaIQgkQhBomTJ8UIQhCEIQhCEIQhCEIQSwghIg0NDDRCCQhCIMYx48YxjGMfox4hCEhIhCEIQhCEIQgkJCRBoaIQhCEGhoaIQhCEIQhCEJzCEEiE4EIQhCcCEIQhCCQkIJCRBoaGGGIJCQha1jGPljHxfBjHixCFkIQhCEIQhBISEhIg0NDWIQmGhoaIQhCEIQmQhCEIQmQSEJ0CEIQhOQhMQSEhISFkINDDwQSEuWhjQ8eMYx8UpcvTeLFiEQhCEITE0QSEiEIPCEIQg0NDQ0QhBiEIQhCEIQhCEEhISIQhNIQhCEIQhCEIQQSEhISIQhB8AkJE1jGMY8YxjH02Uu0pRsuIWIWwhCEJwEEEIQhCEIQhBoaIQhCDQ0QhCEIQhMQhBIgkJEIQhCEIQhCEITkEEEEiEEiE4EIThjxjGMYxjHyxlKUpSlGy4hCELIQgkJEITgQhCEIQhCEJkGhomwhCEIQhCEIQhCCRBIhCEIQhCEIQhCE6AkJExIhCDRCdMYx4xjHw8esYylKUpS4nixCFsFkJpCEIQhCDRCEIQhCEIQhCEIQmkJiEIQgkQmQhCEIQhCEIQnIQhCEJsITl4xsYxjxjxjHjGMYxjLt4QhCEIQhLJiIQhCEIQhMg0QhCDRCZCEIQmkJiYhNIQhCEJ1CbMhCEIQhCEIQhCcMYxjGMY8fDGPXjHjH4oQhCEIWrzg0QhCEIQhCEIQhCEITJxCfFBLYT0o3j1jGMYxjGPHj14xjGPtCEIQhCFwmIRcTKUpS/HfhpSl86UpS9UpSlKN6x4xjGPGMeMaxjGMYxkydIQsW0pSiZSl7ApSlKNlKUpSlKUpSlKUpSlKUpSlKUpSlKUpSlKUpSlLiiZSlKUuKUo2UpS8tDQxkIQhCEIQaGhoaGiDRCZCCQhIQkJcUpS4ovoAAAApeQvwgABS/QAAAClLlLsGhohBhiEGiDQ0NEGsMQhCEJiQkJC6pSlL9IAAAFKXF4F0pS+wAC/KAAAUpSl5mMhMTDDwaHg0NDDWIQg0NDQkLxpSlKUpSlKUpSlLilKUpSlKUpSlKUpSlKUpSlxSlKUpSlKUuKXSlKUpSlKUpSlKUvhMhNaIQg0NEGhoaGhoaGiDQ0TFi87lylKUpS5SlylLly83xvVLlKXLt8LlKXmlLq95kHkGMaGhoaGNEGNYsXi/gfk/wAZey5hMeTia8gxoaGhkGMfCXEH4T0mT1mT2hPtWr4HjGMYxjGMY+Zy+5zPmhPrhCE1ea+Bj14xjQ8YxjHqxcTZ+jMnvNnivOeDxjGMYxjGPznE854wmzJkJzOJ1CbCZOZ8KxLwnb5YxjGMYxjQ/RriEJ4zZ3OITZs7hPjS4hCZCE4QifGx6xjxjH4zmdTiZCEyE8J7T1hNhCEIQhCEJ1BIglq9nrGMeMYxjGMXc8J8E/BmwnUyZMhCE6S+JjGMYxjx4x6upkJ1CEIQhCEIQhCEITicQntOITuEIQhCE4hNmzxfi8fDHjxjGMYuF1CbCe0yEyZCZOYTznlPKZCez83jxjHjGMYxjHq1cTwhCcQhCEJ+FCcQnMIJE4hCE931Rj4YxjGPGxvF0uYTxnhPGbNhCEJsJsITiCRCE2ZOITYTudP0Yx8PGxsbGMY2PELheUIQhCE5nEIQnwQnhCbPKeEyfHcY9bGNjY2MYxsYx4hC7nhCEIQhCZCE5hCE+ibCbCEIQhMhMhPnbHrKNjY3jxsYx4sTEIXlCE4hCE6hOn3CEJ5TIQmwhCEJzCeEJ4PqlKUpR6xjx4xjGMeIQhMQvKcQnEITIQhCdz1hMnMJzMmQhMWz0fdxvaUuNlx42MbxjGMYyiYhCeL0hO4QhCDXM4hMhMhCeM7mTIQhMnwPq5RvKUoyjeUbKPHjx4xieJ4hCE9XpNnLxj1/BMhOUibBLicz4GPGyjGy5RspRspSly5cY3rGNiYhCEITEJi+Z8vZxCEIQmTITIQmQhCEycwhCfC2NjGyjKUpco3jfFG9bGNlKNjYxMQhMQhCE+F8r2EIQnlNRCbBLZ1CEJxCEyeDxjZS42N42N5S8t43lGUeNjGxjYhPExYmITEX6YTwhOITyWwncJ7XGxjKNjeUpSlLtLj4Y8Y3jeNjExCYhCylEyiYvBeMINEITJkITJsJ1CbMmLlImT46NjGxsYxsY3lLt14+HjG8bxsomITExMohMTKJiYmIvSydQhCEIQmQhCEJsIQhCEJ3MQsS+WjY2UbKXGPKUpSl4ePhjGMbGxsbGJiYmJiZRMTKJiExMpRecJkIQhMhCEITwhNmwmTEiZMhPhpRsbKNlKN5cbKUpS7RvLresY2MbKNjYmJiYmJiZRMTExMTExMomLpekJk4ZPCEycQhCEJ8jY2Uo3lKUY2NlKNjZcpSlHlKNjZRjY2NjZRsoyiYmJiYmJiYmJ4mUTEyiZRPF5z54QhCEIT0fg2NjY2NlyjeNlKUoylKUpS5SlGxso2NjY2NjGPExMTExMTExMQmJiYmJlExMTExMT7XF9oTxhCE9302UbGxsuXHjY2UbGylKXKXKUpSlKUbGyjZRvhCYmUTExMomJlE8TExMTKJiYn4X6piXzsbGxspS5SjY2Uo2NlKXKUpSjZRso2UbGyjY2Nl4pcTKJiYmJiExMTKJiZRMTExMT+Z8TZqWr5WNjY2NjY2XKUbGxsbKNjyly5SlGylKNjY2N6+kITEJlExCxFExPKXUJiYmJ+c2cTZkyEJwliXp/OpjxjYx48eNjGMfUIQmPHwyD2DROUuUIQhCFixCELUIXlCE2EITJkITIQhCfO8YxjyEGhohBog0Qa4EJow0NDRCEGiEH0AxCEIQhCCQkJCQkJEJiQkJEEiCQlkEsgiecIQhCEITIQhNhO4QnhMaGhoaHyB9BvyyJlhhhh+IGZZYeEJpBIQQSEhISEiCQkJCQkJCWIQhMhMhNhOZs6nnCZOIQhCEIQmTD83/ssvx/7LLLL8uHZZZYYhCEwgggggkJYSIJEEhISIQhMhO54P4psyEIQhCEJkIQnEIQngCfZCYYYYfIIQhCEGhoYYYhCCQkJCCQkJCRBISEhISEhIS6nEITyftMntCE5mwhPCEGGIQhCEGhoa4DDQ0NE4YxoaGtSIJCQkJCQkJCWoQhC5nhNnzr8SDQ0NdtEIQaGhoaHtKUfKFi1atWoQvoXkvrfb7Yx4xj18MYxjGPG+Gf/Z"

/***/ }),
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */
/***/ (function(module, exports) {

	module.exports = function (it, Constructor, name, forbiddenField) {
	  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
	    throw TypeError(name + ': incorrect invocation!');
	  } return it;
	};


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(46);
	var call = __webpack_require__(1099);
	var isArrayIter = __webpack_require__(712);
	var anObject = __webpack_require__(4);
	var toLength = __webpack_require__(11);
	var getIterFn = __webpack_require__(728);
	var BREAK = {};
	var RETURN = {};
	var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
	  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
	  var f = ctx(fn, that, entries ? 2 : 1);
	  var index = 0;
	  var length, step, iterator, result;
	  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
	  // fast case for arrays with default iterator
	  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
	    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
	    if (result === BREAK || result === RETURN) return result;
	  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
	    result = call(iterator, f, step.value, entries);
	    if (result === BREAK || result === RETURN) return result;
	  }
	};
	exports.BREAK = BREAK;
	exports.RETURN = RETURN;


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject = __webpack_require__(4);
	var dPs = __webpack_require__(1105);
	var enumBugKeys = __webpack_require__(708);
	var IE_PROTO = __webpack_require__(721)('IE_PROTO');
	var Empty = function () { /* empty */ };
	var PROTOTYPE = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(707)('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(710).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys = __webpack_require__(1107);
	var hiddenKeys = __webpack_require__(708).concat('length', 'prototype');
	
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return $keys(O, hiddenKeys);
	};


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(1107);
	var enumBugKeys = __webpack_require__(708);
	
	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};


/***/ }),
/* 139 */
/***/ (function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

	var redefine = __webpack_require__(26);
	module.exports = function (target, src, safe) {
	  for (var key in src) redefine(target, key, src[key], safe);
	  return target;
	};


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(5);
	var dP = __webpack_require__(16);
	var DESCRIPTORS = __webpack_require__(14);
	var SPECIES = __webpack_require__(10)('species');
	
	module.exports = function (KEY) {
	  var C = global[KEY];
	  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
	    configurable: true,
	    get: function () { return this; }
	  });
	};


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(48);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};


/***/ }),
/* 143 */
/***/ (function(module, exports) {

	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(7);
	module.exports = function (it, TYPE) {
	  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
	  return it;
	};


/***/ }),
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

	/* @preserve
	 * Leaflet 1.9.4, a JS library for interactive maps. https://leafletjs.com
	 * (c) 2010-2023 Vladimir Agafonkin, (c) 2010-2011 CloudMade
	 */
	
	(function (global, factory) {
	   true ? factory(exports) :
	  typeof define === 'function' && define.amd ? define(['exports'], factory) :
	  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global.leaflet = {}));
	})(this, (function (exports) { 'use strict';
	
	  var version = "1.9.4";
	
	  /*
	   * @namespace Util
	   *
	   * Various utility functions, used by Leaflet internally.
	   */
	
	  // @function extend(dest: Object, src?: Object): Object
	  // Merges the properties of the `src` object (or multiple objects) into `dest` object and returns the latter. Has an `L.extend` shortcut.
	  function extend(dest) {
	  	var i, j, len, src;
	
	  	for (j = 1, len = arguments.length; j < len; j++) {
	  		src = arguments[j];
	  		for (i in src) {
	  			dest[i] = src[i];
	  		}
	  	}
	  	return dest;
	  }
	
	  // @function create(proto: Object, properties?: Object): Object
	  // Compatibility polyfill for [Object.create](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/create)
	  var create$2 = Object.create || (function () {
	  	function F() {}
	  	return function (proto) {
	  		F.prototype = proto;
	  		return new F();
	  	};
	  })();
	
	  // @function bind(fn: Function, …): Function
	  // Returns a new function bound to the arguments passed, like [Function.prototype.bind](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Function/bind).
	  // Has a `L.bind()` shortcut.
	  function bind(fn, obj) {
	  	var slice = Array.prototype.slice;
	
	  	if (fn.bind) {
	  		return fn.bind.apply(fn, slice.call(arguments, 1));
	  	}
	
	  	var args = slice.call(arguments, 2);
	
	  	return function () {
	  		return fn.apply(obj, args.length ? args.concat(slice.call(arguments)) : arguments);
	  	};
	  }
	
	  // @property lastId: Number
	  // Last unique ID used by [`stamp()`](#util-stamp)
	  var lastId = 0;
	
	  // @function stamp(obj: Object): Number
	  // Returns the unique ID of an object, assigning it one if it doesn't have it.
	  function stamp(obj) {
	  	if (!('_leaflet_id' in obj)) {
	  		obj['_leaflet_id'] = ++lastId;
	  	}
	  	return obj._leaflet_id;
	  }
	
	  // @function throttle(fn: Function, time: Number, context: Object): Function
	  // Returns a function which executes function `fn` with the given scope `context`
	  // (so that the `this` keyword refers to `context` inside `fn`'s code). The function
	  // `fn` will be called no more than one time per given amount of `time`. The arguments
	  // received by the bound function will be any arguments passed when binding the
	  // function, followed by any arguments passed when invoking the bound function.
	  // Has an `L.throttle` shortcut.
	  function throttle(fn, time, context) {
	  	var lock, args, wrapperFn, later;
	
	  	later = function () {
	  		// reset lock and call if queued
	  		lock = false;
	  		if (args) {
	  			wrapperFn.apply(context, args);
	  			args = false;
	  		}
	  	};
	
	  	wrapperFn = function () {
	  		if (lock) {
	  			// called too soon, queue to call later
	  			args = arguments;
	
	  		} else {
	  			// call and lock until later
	  			fn.apply(context, arguments);
	  			setTimeout(later, time);
	  			lock = true;
	  		}
	  	};
	
	  	return wrapperFn;
	  }
	
	  // @function wrapNum(num: Number, range: Number[], includeMax?: Boolean): Number
	  // Returns the number `num` modulo `range` in such a way so it lies within
	  // `range[0]` and `range[1]`. The returned value will be always smaller than
	  // `range[1]` unless `includeMax` is set to `true`.
	  function wrapNum(x, range, includeMax) {
	  	var max = range[1],
	  	    min = range[0],
	  	    d = max - min;
	  	return x === max && includeMax ? x : ((x - min) % d + d) % d + min;
	  }
	
	  // @function falseFn(): Function
	  // Returns a function which always returns `false`.
	  function falseFn() { return false; }
	
	  // @function formatNum(num: Number, precision?: Number|false): Number
	  // Returns the number `num` rounded with specified `precision`.
	  // The default `precision` value is 6 decimal places.
	  // `false` can be passed to skip any processing (can be useful to avoid round-off errors).
	  function formatNum(num, precision) {
	  	if (precision === false) { return num; }
	  	var pow = Math.pow(10, precision === undefined ? 6 : precision);
	  	return Math.round(num * pow) / pow;
	  }
	
	  // @function trim(str: String): String
	  // Compatibility polyfill for [String.prototype.trim](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/String/Trim)
	  function trim(str) {
	  	return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
	  }
	
	  // @function splitWords(str: String): String[]
	  // Trims and splits the string on whitespace and returns the array of parts.
	  function splitWords(str) {
	  	return trim(str).split(/\s+/);
	  }
	
	  // @function setOptions(obj: Object, options: Object): Object
	  // Merges the given properties to the `options` of the `obj` object, returning the resulting options. See `Class options`. Has an `L.setOptions` shortcut.
	  function setOptions(obj, options) {
	  	if (!Object.prototype.hasOwnProperty.call(obj, 'options')) {
	  		obj.options = obj.options ? create$2(obj.options) : {};
	  	}
	  	for (var i in options) {
	  		obj.options[i] = options[i];
	  	}
	  	return obj.options;
	  }
	
	  // @function getParamString(obj: Object, existingUrl?: String, uppercase?: Boolean): String
	  // Converts an object into a parameter URL string, e.g. `{a: "foo", b: "bar"}`
	  // translates to `'?a=foo&b=bar'`. If `existingUrl` is set, the parameters will
	  // be appended at the end. If `uppercase` is `true`, the parameter names will
	  // be uppercased (e.g. `'?A=foo&B=bar'`)
	  function getParamString(obj, existingUrl, uppercase) {
	  	var params = [];
	  	for (var i in obj) {
	  		params.push(encodeURIComponent(uppercase ? i.toUpperCase() : i) + '=' + encodeURIComponent(obj[i]));
	  	}
	  	return ((!existingUrl || existingUrl.indexOf('?') === -1) ? '?' : '&') + params.join('&');
	  }
	
	  var templateRe = /\{ *([\w_ -]+) *\}/g;
	
	  // @function template(str: String, data: Object): String
	  // Simple templating facility, accepts a template string of the form `'Hello {a}, {b}'`
	  // and a data object like `{a: 'foo', b: 'bar'}`, returns evaluated string
	  // `('Hello foo, bar')`. You can also specify functions instead of strings for
	  // data values — they will be evaluated passing `data` as an argument.
	  function template(str, data) {
	  	return str.replace(templateRe, function (str, key) {
	  		var value = data[key];
	
	  		if (value === undefined) {
	  			throw new Error('No value provided for variable ' + str);
	
	  		} else if (typeof value === 'function') {
	  			value = value(data);
	  		}
	  		return value;
	  	});
	  }
	
	  // @function isArray(obj): Boolean
	  // Compatibility polyfill for [Array.isArray](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/isArray)
	  var isArray = Array.isArray || function (obj) {
	  	return (Object.prototype.toString.call(obj) === '[object Array]');
	  };
	
	  // @function indexOf(array: Array, el: Object): Number
	  // Compatibility polyfill for [Array.prototype.indexOf](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/indexOf)
	  function indexOf(array, el) {
	  	for (var i = 0; i < array.length; i++) {
	  		if (array[i] === el) { return i; }
	  	}
	  	return -1;
	  }
	
	  // @property emptyImageUrl: String
	  // Data URI string containing a base64-encoded empty GIF image.
	  // Used as a hack to free memory from unused images on WebKit-powered
	  // mobile devices (by setting image `src` to this string).
	  var emptyImageUrl = 'data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=';
	
	  // inspired by https://paulirish.com/2011/requestanimationframe-for-smart-animating/
	
	  function getPrefixed(name) {
	  	return window['webkit' + name] || window['moz' + name] || window['ms' + name];
	  }
	
	  var lastTime = 0;
	
	  // fallback for IE 7-8
	  function timeoutDefer(fn) {
	  	var time = +new Date(),
	  	    timeToCall = Math.max(0, 16 - (time - lastTime));
	
	  	lastTime = time + timeToCall;
	  	return window.setTimeout(fn, timeToCall);
	  }
	
	  var requestFn = window.requestAnimationFrame || getPrefixed('RequestAnimationFrame') || timeoutDefer;
	  var cancelFn = window.cancelAnimationFrame || getPrefixed('CancelAnimationFrame') ||
	  		getPrefixed('CancelRequestAnimationFrame') || function (id) { window.clearTimeout(id); };
	
	  // @function requestAnimFrame(fn: Function, context?: Object, immediate?: Boolean): Number
	  // Schedules `fn` to be executed when the browser repaints. `fn` is bound to
	  // `context` if given. When `immediate` is set, `fn` is called immediately if
	  // the browser doesn't have native support for
	  // [`window.requestAnimationFrame`](https://developer.mozilla.org/docs/Web/API/window/requestAnimationFrame),
	  // otherwise it's delayed. Returns a request ID that can be used to cancel the request.
	  function requestAnimFrame(fn, context, immediate) {
	  	if (immediate && requestFn === timeoutDefer) {
	  		fn.call(context);
	  	} else {
	  		return requestFn.call(window, bind(fn, context));
	  	}
	  }
	
	  // @function cancelAnimFrame(id: Number): undefined
	  // Cancels a previous `requestAnimFrame`. See also [window.cancelAnimationFrame](https://developer.mozilla.org/docs/Web/API/window/cancelAnimationFrame).
	  function cancelAnimFrame(id) {
	  	if (id) {
	  		cancelFn.call(window, id);
	  	}
	  }
	
	  var Util = {
	    __proto__: null,
	    extend: extend,
	    create: create$2,
	    bind: bind,
	    get lastId () { return lastId; },
	    stamp: stamp,
	    throttle: throttle,
	    wrapNum: wrapNum,
	    falseFn: falseFn,
	    formatNum: formatNum,
	    trim: trim,
	    splitWords: splitWords,
	    setOptions: setOptions,
	    getParamString: getParamString,
	    template: template,
	    isArray: isArray,
	    indexOf: indexOf,
	    emptyImageUrl: emptyImageUrl,
	    requestFn: requestFn,
	    cancelFn: cancelFn,
	    requestAnimFrame: requestAnimFrame,
	    cancelAnimFrame: cancelAnimFrame
	  };
	
	  // @class Class
	  // @aka L.Class
	
	  // @section
	  // @uninheritable
	
	  // Thanks to John Resig and Dean Edwards for inspiration!
	
	  function Class() {}
	
	  Class.extend = function (props) {
	
	  	// @function extend(props: Object): Function
	  	// [Extends the current class](#class-inheritance) given the properties to be included.
	  	// Returns a Javascript function that is a class constructor (to be called with `new`).
	  	var NewClass = function () {
	
	  		setOptions(this);
	
	  		// call the constructor
	  		if (this.initialize) {
	  			this.initialize.apply(this, arguments);
	  		}
	
	  		// call all constructor hooks
	  		this.callInitHooks();
	  	};
	
	  	var parentProto = NewClass.__super__ = this.prototype;
	
	  	var proto = create$2(parentProto);
	  	proto.constructor = NewClass;
	
	  	NewClass.prototype = proto;
	
	  	// inherit parent's statics
	  	for (var i in this) {
	  		if (Object.prototype.hasOwnProperty.call(this, i) && i !== 'prototype' && i !== '__super__') {
	  			NewClass[i] = this[i];
	  		}
	  	}
	
	  	// mix static properties into the class
	  	if (props.statics) {
	  		extend(NewClass, props.statics);
	  	}
	
	  	// mix includes into the prototype
	  	if (props.includes) {
	  		checkDeprecatedMixinEvents(props.includes);
	  		extend.apply(null, [proto].concat(props.includes));
	  	}
	
	  	// mix given properties into the prototype
	  	extend(proto, props);
	  	delete proto.statics;
	  	delete proto.includes;
	
	  	// merge options
	  	if (proto.options) {
	  		proto.options = parentProto.options ? create$2(parentProto.options) : {};
	  		extend(proto.options, props.options);
	  	}
	
	  	proto._initHooks = [];
	
	  	// add method for calling all hooks
	  	proto.callInitHooks = function () {
	
	  		if (this._initHooksCalled) { return; }
	
	  		if (parentProto.callInitHooks) {
	  			parentProto.callInitHooks.call(this);
	  		}
	
	  		this._initHooksCalled = true;
	
	  		for (var i = 0, len = proto._initHooks.length; i < len; i++) {
	  			proto._initHooks[i].call(this);
	  		}
	  	};
	
	  	return NewClass;
	  };
	
	
	  // @function include(properties: Object): this
	  // [Includes a mixin](#class-includes) into the current class.
	  Class.include = function (props) {
	  	var parentOptions = this.prototype.options;
	  	extend(this.prototype, props);
	  	if (props.options) {
	  		this.prototype.options = parentOptions;
	  		this.mergeOptions(props.options);
	  	}
	  	return this;
	  };
	
	  // @function mergeOptions(options: Object): this
	  // [Merges `options`](#class-options) into the defaults of the class.
	  Class.mergeOptions = function (options) {
	  	extend(this.prototype.options, options);
	  	return this;
	  };
	
	  // @function addInitHook(fn: Function): this
	  // Adds a [constructor hook](#class-constructor-hooks) to the class.
	  Class.addInitHook = function (fn) { // (Function) || (String, args...)
	  	var args = Array.prototype.slice.call(arguments, 1);
	
	  	var init = typeof fn === 'function' ? fn : function () {
	  		this[fn].apply(this, args);
	  	};
	
	  	this.prototype._initHooks = this.prototype._initHooks || [];
	  	this.prototype._initHooks.push(init);
	  	return this;
	  };
	
	  function checkDeprecatedMixinEvents(includes) {
	  	/* global L: true */
	  	if (typeof L === 'undefined' || !L || !L.Mixin) { return; }
	
	  	includes = isArray(includes) ? includes : [includes];
	
	  	for (var i = 0; i < includes.length; i++) {
	  		if (includes[i] === L.Mixin.Events) {
	  			console.warn('Deprecated include of L.Mixin.Events: ' +
	  				'this property will be removed in future releases, ' +
	  				'please inherit from L.Evented instead.', new Error().stack);
	  		}
	  	}
	  }
	
	  /*
	   * @class Evented
	   * @aka L.Evented
	   * @inherits Class
	   *
	   * A set of methods shared between event-powered classes (like `Map` and `Marker`). Generally, events allow you to execute some function when something happens with an object (e.g. the user clicks on the map, causing the map to fire `'click'` event).
	   *
	   * @example
	   *
	   * ```js
	   * map.on('click', function(e) {
	   * 	alert(e.latlng);
	   * } );
	   * ```
	   *
	   * Leaflet deals with event listeners by reference, so if you want to add a listener and then remove it, define it as a function:
	   *
	   * ```js
	   * function onClick(e) { ... }
	   *
	   * map.on('click', onClick);
	   * map.off('click', onClick);
	   * ```
	   */
	
	  var Events = {
	  	/* @method on(type: String, fn: Function, context?: Object): this
	  	 * Adds a listener function (`fn`) to a particular event type of the object. You can optionally specify the context of the listener (object the this keyword will point to). You can also pass several space-separated types (e.g. `'click dblclick'`).
	  	 *
	  	 * @alternative
	  	 * @method on(eventMap: Object): this
	  	 * Adds a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
	  	 */
	  	on: function (types, fn, context) {
	
	  		// types can be a map of types/handlers
	  		if (typeof types === 'object') {
	  			for (var type in types) {
	  				// we don't process space-separated events here for performance;
	  				// it's a hot path since Layer uses the on(obj) syntax
	  				this._on(type, types[type], fn);
	  			}
	
	  		} else {
	  			// types can be a string of space-separated words
	  			types = splitWords(types);
	
	  			for (var i = 0, len = types.length; i < len; i++) {
	  				this._on(types[i], fn, context);
	  			}
	  		}
	
	  		return this;
	  	},
	
	  	/* @method off(type: String, fn?: Function, context?: Object): this
	  	 * Removes a previously added listener function. If no function is specified, it will remove all the listeners of that particular event from the object. Note that if you passed a custom context to `on`, you must pass the same context to `off` in order to remove the listener.
	  	 *
	  	 * @alternative
	  	 * @method off(eventMap: Object): this
	  	 * Removes a set of type/listener pairs.
	  	 *
	  	 * @alternative
	  	 * @method off: this
	  	 * Removes all listeners to all events on the object. This includes implicitly attached events.
	  	 */
	  	off: function (types, fn, context) {
	
	  		if (!arguments.length) {
	  			// clear all listeners if called without arguments
	  			delete this._events;
	
	  		} else if (typeof types === 'object') {
	  			for (var type in types) {
	  				this._off(type, types[type], fn);
	  			}
	
	  		} else {
	  			types = splitWords(types);
	
	  			var removeAll = arguments.length === 1;
	  			for (var i = 0, len = types.length; i < len; i++) {
	  				if (removeAll) {
	  					this._off(types[i]);
	  				} else {
	  					this._off(types[i], fn, context);
	  				}
	  			}
	  		}
	
	  		return this;
	  	},
	
	  	// attach listener (without syntactic sugar now)
	  	_on: function (type, fn, context, _once) {
	  		if (typeof fn !== 'function') {
	  			console.warn('wrong listener type: ' + typeof fn);
	  			return;
	  		}
	
	  		// check if fn already there
	  		if (this._listens(type, fn, context) !== false) {
	  			return;
	  		}
	
	  		if (context === this) {
	  			// Less memory footprint.
	  			context = undefined;
	  		}
	
	  		var newListener = {fn: fn, ctx: context};
	  		if (_once) {
	  			newListener.once = true;
	  		}
	
	  		this._events = this._events || {};
	  		this._events[type] = this._events[type] || [];
	  		this._events[type].push(newListener);
	  	},
	
	  	_off: function (type, fn, context) {
	  		var listeners,
	  		    i,
	  		    len;
	
	  		if (!this._events) {
	  			return;
	  		}
	
	  		listeners = this._events[type];
	  		if (!listeners) {
	  			return;
	  		}
	
	  		if (arguments.length === 1) { // remove all
	  			if (this._firingCount) {
	  				// Set all removed listeners to noop
	  				// so they are not called if remove happens in fire
	  				for (i = 0, len = listeners.length; i < len; i++) {
	  					listeners[i].fn = falseFn;
	  				}
	  			}
	  			// clear all listeners for a type if function isn't specified
	  			delete this._events[type];
	  			return;
	  		}
	
	  		if (typeof fn !== 'function') {
	  			console.warn('wrong listener type: ' + typeof fn);
	  			return;
	  		}
	
	  		// find fn and remove it
	  		var index = this._listens(type, fn, context);
	  		if (index !== false) {
	  			var listener = listeners[index];
	  			if (this._firingCount) {
	  				// set the removed listener to noop so that's not called if remove happens in fire
	  				listener.fn = falseFn;
	
	  				/* copy array in case events are being fired */
	  				this._events[type] = listeners = listeners.slice();
	  			}
	  			listeners.splice(index, 1);
	  		}
	  	},
	
	  	// @method fire(type: String, data?: Object, propagate?: Boolean): this
	  	// Fires an event of the specified type. You can optionally provide a data
	  	// object — the first argument of the listener function will contain its
	  	// properties. The event can optionally be propagated to event parents.
	  	fire: function (type, data, propagate) {
	  		if (!this.listens(type, propagate)) { return this; }
	
	  		var event = extend({}, data, {
	  			type: type,
	  			target: this,
	  			sourceTarget: data && data.sourceTarget || this
	  		});
	
	  		if (this._events) {
	  			var listeners = this._events[type];
	  			if (listeners) {
	  				this._firingCount = (this._firingCount + 1) || 1;
	  				for (var i = 0, len = listeners.length; i < len; i++) {
	  					var l = listeners[i];
	  					// off overwrites l.fn, so we need to copy fn to a var
	  					var fn = l.fn;
	  					if (l.once) {
	  						this.off(type, fn, l.ctx);
	  					}
	  					fn.call(l.ctx || this, event);
	  				}
	
	  				this._firingCount--;
	  			}
	  		}
	
	  		if (propagate) {
	  			// propagate the event to parents (set with addEventParent)
	  			this._propagateEvent(event);
	  		}
	
	  		return this;
	  	},
	
	  	// @method listens(type: String, propagate?: Boolean): Boolean
	  	// @method listens(type: String, fn: Function, context?: Object, propagate?: Boolean): Boolean
	  	// Returns `true` if a particular event type has any listeners attached to it.
	  	// The verification can optionally be propagated, it will return `true` if parents have the listener attached to it.
	  	listens: function (type, fn, context, propagate) {
	  		if (typeof type !== 'string') {
	  			console.warn('"string" type argument expected');
	  		}
	
	  		// we don't overwrite the input `fn` value, because we need to use it for propagation
	  		var _fn = fn;
	  		if (typeof fn !== 'function') {
	  			propagate = !!fn;
	  			_fn = undefined;
	  			context = undefined;
	  		}
	
	  		var listeners = this._events && this._events[type];
	  		if (listeners && listeners.length) {
	  			if (this._listens(type, _fn, context) !== false) {
	  				return true;
	  			}
	  		}
	
	  		if (propagate) {
	  			// also check parents for listeners if event propagates
	  			for (var id in this._eventParents) {
	  				if (this._eventParents[id].listens(type, fn, context, propagate)) { return true; }
	  			}
	  		}
	  		return false;
	  	},
	
	  	// returns the index (number) or false
	  	_listens: function (type, fn, context) {
	  		if (!this._events) {
	  			return false;
	  		}
	
	  		var listeners = this._events[type] || [];
	  		if (!fn) {
	  			return !!listeners.length;
	  		}
	
	  		if (context === this) {
	  			// Less memory footprint.
	  			context = undefined;
	  		}
	
	  		for (var i = 0, len = listeners.length; i < len; i++) {
	  			if (listeners[i].fn === fn && listeners[i].ctx === context) {
	  				return i;
	  			}
	  		}
	  		return false;
	
	  	},
	
	  	// @method once(…): this
	  	// Behaves as [`on(…)`](#evented-on), except the listener will only get fired once and then removed.
	  	once: function (types, fn, context) {
	
	  		// types can be a map of types/handlers
	  		if (typeof types === 'object') {
	  			for (var type in types) {
	  				// we don't process space-separated events here for performance;
	  				// it's a hot path since Layer uses the on(obj) syntax
	  				this._on(type, types[type], fn, true);
	  			}
	
	  		} else {
	  			// types can be a string of space-separated words
	  			types = splitWords(types);
	
	  			for (var i = 0, len = types.length; i < len; i++) {
	  				this._on(types[i], fn, context, true);
	  			}
	  		}
	
	  		return this;
	  	},
	
	  	// @method addEventParent(obj: Evented): this
	  	// Adds an event parent - an `Evented` that will receive propagated events
	  	addEventParent: function (obj) {
	  		this._eventParents = this._eventParents || {};
	  		this._eventParents[stamp(obj)] = obj;
	  		return this;
	  	},
	
	  	// @method removeEventParent(obj: Evented): this
	  	// Removes an event parent, so it will stop receiving propagated events
	  	removeEventParent: function (obj) {
	  		if (this._eventParents) {
	  			delete this._eventParents[stamp(obj)];
	  		}
	  		return this;
	  	},
	
	  	_propagateEvent: function (e) {
	  		for (var id in this._eventParents) {
	  			this._eventParents[id].fire(e.type, extend({
	  				layer: e.target,
	  				propagatedFrom: e.target
	  			}, e), true);
	  		}
	  	}
	  };
	
	  // aliases; we should ditch those eventually
	
	  // @method addEventListener(…): this
	  // Alias to [`on(…)`](#evented-on)
	  Events.addEventListener = Events.on;
	
	  // @method removeEventListener(…): this
	  // Alias to [`off(…)`](#evented-off)
	
	  // @method clearAllEventListeners(…): this
	  // Alias to [`off()`](#evented-off)
	  Events.removeEventListener = Events.clearAllEventListeners = Events.off;
	
	  // @method addOneTimeEventListener(…): this
	  // Alias to [`once(…)`](#evented-once)
	  Events.addOneTimeEventListener = Events.once;
	
	  // @method fireEvent(…): this
	  // Alias to [`fire(…)`](#evented-fire)
	  Events.fireEvent = Events.fire;
	
	  // @method hasEventListeners(…): Boolean
	  // Alias to [`listens(…)`](#evented-listens)
	  Events.hasEventListeners = Events.listens;
	
	  var Evented = Class.extend(Events);
	
	  /*
	   * @class Point
	   * @aka L.Point
	   *
	   * Represents a point with `x` and `y` coordinates in pixels.
	   *
	   * @example
	   *
	   * ```js
	   * var point = L.point(200, 300);
	   * ```
	   *
	   * All Leaflet methods and options that accept `Point` objects also accept them in a simple Array form (unless noted otherwise), so these lines are equivalent:
	   *
	   * ```js
	   * map.panBy([200, 300]);
	   * map.panBy(L.point(200, 300));
	   * ```
	   *
	   * Note that `Point` does not inherit from Leaflet's `Class` object,
	   * which means new classes can't inherit from it, and new methods
	   * can't be added to it with the `include` function.
	   */
	
	  function Point(x, y, round) {
	  	// @property x: Number; The `x` coordinate of the point
	  	this.x = (round ? Math.round(x) : x);
	  	// @property y: Number; The `y` coordinate of the point
	  	this.y = (round ? Math.round(y) : y);
	  }
	
	  var trunc = Math.trunc || function (v) {
	  	return v > 0 ? Math.floor(v) : Math.ceil(v);
	  };
	
	  Point.prototype = {
	
	  	// @method clone(): Point
	  	// Returns a copy of the current point.
	  	clone: function () {
	  		return new Point(this.x, this.y);
	  	},
	
	  	// @method add(otherPoint: Point): Point
	  	// Returns the result of addition of the current and the given points.
	  	add: function (point) {
	  		// non-destructive, returns a new point
	  		return this.clone()._add(toPoint(point));
	  	},
	
	  	_add: function (point) {
	  		// destructive, used directly for performance in situations where it's safe to modify existing point
	  		this.x += point.x;
	  		this.y += point.y;
	  		return this;
	  	},
	
	  	// @method subtract(otherPoint: Point): Point
	  	// Returns the result of subtraction of the given point from the current.
	  	subtract: function (point) {
	  		return this.clone()._subtract(toPoint(point));
	  	},
	
	  	_subtract: function (point) {
	  		this.x -= point.x;
	  		this.y -= point.y;
	  		return this;
	  	},
	
	  	// @method divideBy(num: Number): Point
	  	// Returns the result of division of the current point by the given number.
	  	divideBy: function (num) {
	  		return this.clone()._divideBy(num);
	  	},
	
	  	_divideBy: function (num) {
	  		this.x /= num;
	  		this.y /= num;
	  		return this;
	  	},
	
	  	// @method multiplyBy(num: Number): Point
	  	// Returns the result of multiplication of the current point by the given number.
	  	multiplyBy: function (num) {
	  		return this.clone()._multiplyBy(num);
	  	},
	
	  	_multiplyBy: function (num) {
	  		this.x *= num;
	  		this.y *= num;
	  		return this;
	  	},
	
	  	// @method scaleBy(scale: Point): Point
	  	// Multiply each coordinate of the current point by each coordinate of
	  	// `scale`. In linear algebra terms, multiply the point by the
	  	// [scaling matrix](https://en.wikipedia.org/wiki/Scaling_%28geometry%29#Matrix_representation)
	  	// defined by `scale`.
	  	scaleBy: function (point) {
	  		return new Point(this.x * point.x, this.y * point.y);
	  	},
	
	  	// @method unscaleBy(scale: Point): Point
	  	// Inverse of `scaleBy`. Divide each coordinate of the current point by
	  	// each coordinate of `scale`.
	  	unscaleBy: function (point) {
	  		return new Point(this.x / point.x, this.y / point.y);
	  	},
	
	  	// @method round(): Point
	  	// Returns a copy of the current point with rounded coordinates.
	  	round: function () {
	  		return this.clone()._round();
	  	},
	
	  	_round: function () {
	  		this.x = Math.round(this.x);
	  		this.y = Math.round(this.y);
	  		return this;
	  	},
	
	  	// @method floor(): Point
	  	// Returns a copy of the current point with floored coordinates (rounded down).
	  	floor: function () {
	  		return this.clone()._floor();
	  	},
	
	  	_floor: function () {
	  		this.x = Math.floor(this.x);
	  		this.y = Math.floor(this.y);
	  		return this;
	  	},
	
	  	// @method ceil(): Point
	  	// Returns a copy of the current point with ceiled coordinates (rounded up).
	  	ceil: function () {
	  		return this.clone()._ceil();
	  	},
	
	  	_ceil: function () {
	  		this.x = Math.ceil(this.x);
	  		this.y = Math.ceil(this.y);
	  		return this;
	  	},
	
	  	// @method trunc(): Point
	  	// Returns a copy of the current point with truncated coordinates (rounded towards zero).
	  	trunc: function () {
	  		return this.clone()._trunc();
	  	},
	
	  	_trunc: function () {
	  		this.x = trunc(this.x);
	  		this.y = trunc(this.y);
	  		return this;
	  	},
	
	  	// @method distanceTo(otherPoint: Point): Number
	  	// Returns the cartesian distance between the current and the given points.
	  	distanceTo: function (point) {
	  		point = toPoint(point);
	
	  		var x = point.x - this.x,
	  		    y = point.y - this.y;
	
	  		return Math.sqrt(x * x + y * y);
	  	},
	
	  	// @method equals(otherPoint: Point): Boolean
	  	// Returns `true` if the given point has the same coordinates.
	  	equals: function (point) {
	  		point = toPoint(point);
	
	  		return point.x === this.x &&
	  		       point.y === this.y;
	  	},
	
	  	// @method contains(otherPoint: Point): Boolean
	  	// Returns `true` if both coordinates of the given point are less than the corresponding current point coordinates (in absolute values).
	  	contains: function (point) {
	  		point = toPoint(point);
	
	  		return Math.abs(point.x) <= Math.abs(this.x) &&
	  		       Math.abs(point.y) <= Math.abs(this.y);
	  	},
	
	  	// @method toString(): String
	  	// Returns a string representation of the point for debugging purposes.
	  	toString: function () {
	  		return 'Point(' +
	  		        formatNum(this.x) + ', ' +
	  		        formatNum(this.y) + ')';
	  	}
	  };
	
	  // @factory L.point(x: Number, y: Number, round?: Boolean)
	  // Creates a Point object with the given `x` and `y` coordinates. If optional `round` is set to true, rounds the `x` and `y` values.
	
	  // @alternative
	  // @factory L.point(coords: Number[])
	  // Expects an array of the form `[x, y]` instead.
	
	  // @alternative
	  // @factory L.point(coords: Object)
	  // Expects a plain object of the form `{x: Number, y: Number}` instead.
	  function toPoint(x, y, round) {
	  	if (x instanceof Point) {
	  		return x;
	  	}
	  	if (isArray(x)) {
	  		return new Point(x[0], x[1]);
	  	}
	  	if (x === undefined || x === null) {
	  		return x;
	  	}
	  	if (typeof x === 'object' && 'x' in x && 'y' in x) {
	  		return new Point(x.x, x.y);
	  	}
	  	return new Point(x, y, round);
	  }
	
	  /*
	   * @class Bounds
	   * @aka L.Bounds
	   *
	   * Represents a rectangular area in pixel coordinates.
	   *
	   * @example
	   *
	   * ```js
	   * var p1 = L.point(10, 10),
	   * p2 = L.point(40, 60),
	   * bounds = L.bounds(p1, p2);
	   * ```
	   *
	   * All Leaflet methods that accept `Bounds` objects also accept them in a simple Array form (unless noted otherwise), so the bounds example above can be passed like this:
	   *
	   * ```js
	   * otherBounds.intersects([[10, 10], [40, 60]]);
	   * ```
	   *
	   * Note that `Bounds` does not inherit from Leaflet's `Class` object,
	   * which means new classes can't inherit from it, and new methods
	   * can't be added to it with the `include` function.
	   */
	
	  function Bounds(a, b) {
	  	if (!a) { return; }
	
	  	var points = b ? [a, b] : a;
	
	  	for (var i = 0, len = points.length; i < len; i++) {
	  		this.extend(points[i]);
	  	}
	  }
	
	  Bounds.prototype = {
	  	// @method extend(point: Point): this
	  	// Extends the bounds to contain the given point.
	
	  	// @alternative
	  	// @method extend(otherBounds: Bounds): this
	  	// Extend the bounds to contain the given bounds
	  	extend: function (obj) {
	  		var min2, max2;
	  		if (!obj) { return this; }
	
	  		if (obj instanceof Point || typeof obj[0] === 'number' || 'x' in obj) {
	  			min2 = max2 = toPoint(obj);
	  		} else {
	  			obj = toBounds(obj);
	  			min2 = obj.min;
	  			max2 = obj.max;
	
	  			if (!min2 || !max2) { return this; }
	  		}
	
	  		// @property min: Point
	  		// The top left corner of the rectangle.
	  		// @property max: Point
	  		// The bottom right corner of the rectangle.
	  		if (!this.min && !this.max) {
	  			this.min = min2.clone();
	  			this.max = max2.clone();
	  		} else {
	  			this.min.x = Math.min(min2.x, this.min.x);
	  			this.max.x = Math.max(max2.x, this.max.x);
	  			this.min.y = Math.min(min2.y, this.min.y);
	  			this.max.y = Math.max(max2.y, this.max.y);
	  		}
	  		return this;
	  	},
	
	  	// @method getCenter(round?: Boolean): Point
	  	// Returns the center point of the bounds.
	  	getCenter: function (round) {
	  		return toPoint(
	  		        (this.min.x + this.max.x) / 2,
	  		        (this.min.y + this.max.y) / 2, round);
	  	},
	
	  	// @method getBottomLeft(): Point
	  	// Returns the bottom-left point of the bounds.
	  	getBottomLeft: function () {
	  		return toPoint(this.min.x, this.max.y);
	  	},
	
	  	// @method getTopRight(): Point
	  	// Returns the top-right point of the bounds.
	  	getTopRight: function () { // -> Point
	  		return toPoint(this.max.x, this.min.y);
	  	},
	
	  	// @method getTopLeft(): Point
	  	// Returns the top-left point of the bounds (i.e. [`this.min`](#bounds-min)).
	  	getTopLeft: function () {
	  		return this.min; // left, top
	  	},
	
	  	// @method getBottomRight(): Point
	  	// Returns the bottom-right point of the bounds (i.e. [`this.max`](#bounds-max)).
	  	getBottomRight: function () {
	  		return this.max; // right, bottom
	  	},
	
	  	// @method getSize(): Point
	  	// Returns the size of the given bounds
	  	getSize: function () {
	  		return this.max.subtract(this.min);
	  	},
	
	  	// @method contains(otherBounds: Bounds): Boolean
	  	// Returns `true` if the rectangle contains the given one.
	  	// @alternative
	  	// @method contains(point: Point): Boolean
	  	// Returns `true` if the rectangle contains the given point.
	  	contains: function (obj) {
	  		var min, max;
	
	  		if (typeof obj[0] === 'number' || obj instanceof Point) {
	  			obj = toPoint(obj);
	  		} else {
	  			obj = toBounds(obj);
	  		}
	
	  		if (obj instanceof Bounds) {
	  			min = obj.min;
	  			max = obj.max;
	  		} else {
	  			min = max = obj;
	  		}
	
	  		return (min.x >= this.min.x) &&
	  		       (max.x <= this.max.x) &&
	  		       (min.y >= this.min.y) &&
	  		       (max.y <= this.max.y);
	  	},
	
	  	// @method intersects(otherBounds: Bounds): Boolean
	  	// Returns `true` if the rectangle intersects the given bounds. Two bounds
	  	// intersect if they have at least one point in common.
	  	intersects: function (bounds) { // (Bounds) -> Boolean
	  		bounds = toBounds(bounds);
	
	  		var min = this.min,
	  		    max = this.max,
	  		    min2 = bounds.min,
	  		    max2 = bounds.max,
	  		    xIntersects = (max2.x >= min.x) && (min2.x <= max.x),
	  		    yIntersects = (max2.y >= min.y) && (min2.y <= max.y);
	
	  		return xIntersects && yIntersects;
	  	},
	
	  	// @method overlaps(otherBounds: Bounds): Boolean
	  	// Returns `true` if the rectangle overlaps the given bounds. Two bounds
	  	// overlap if their intersection is an area.
	  	overlaps: function (bounds) { // (Bounds) -> Boolean
	  		bounds = toBounds(bounds);
	
	  		var min = this.min,
	  		    max = this.max,
	  		    min2 = bounds.min,
	  		    max2 = bounds.max,
	  		    xOverlaps = (max2.x > min.x) && (min2.x < max.x),
	  		    yOverlaps = (max2.y > min.y) && (min2.y < max.y);
	
	  		return xOverlaps && yOverlaps;
	  	},
	
	  	// @method isValid(): Boolean
	  	// Returns `true` if the bounds are properly initialized.
	  	isValid: function () {
	  		return !!(this.min && this.max);
	  	},
	
	
	  	// @method pad(bufferRatio: Number): Bounds
	  	// Returns bounds created by extending or retracting the current bounds by a given ratio in each direction.
	  	// For example, a ratio of 0.5 extends the bounds by 50% in each direction.
	  	// Negative values will retract the bounds.
	  	pad: function (bufferRatio) {
	  		var min = this.min,
	  		max = this.max,
	  		heightBuffer = Math.abs(min.x - max.x) * bufferRatio,
	  		widthBuffer = Math.abs(min.y - max.y) * bufferRatio;
	
	
	  		return toBounds(
	  			toPoint(min.x - heightBuffer, min.y - widthBuffer),
	  			toPoint(max.x + heightBuffer, max.y + widthBuffer));
	  	},
	
	
	  	// @method equals(otherBounds: Bounds): Boolean
	  	// Returns `true` if the rectangle is equivalent to the given bounds.
	  	equals: function (bounds) {
	  		if (!bounds) { return false; }
	
	  		bounds = toBounds(bounds);
	
	  		return this.min.equals(bounds.getTopLeft()) &&
	  			this.max.equals(bounds.getBottomRight());
	  	},
	  };
	
	
	  // @factory L.bounds(corner1: Point, corner2: Point)
	  // Creates a Bounds object from two corners coordinate pairs.
	  // @alternative
	  // @factory L.bounds(points: Point[])
	  // Creates a Bounds object from the given array of points.
	  function toBounds(a, b) {
	  	if (!a || a instanceof Bounds) {
	  		return a;
	  	}
	  	return new Bounds(a, b);
	  }
	
	  /*
	   * @class LatLngBounds
	   * @aka L.LatLngBounds
	   *
	   * Represents a rectangular geographical area on a map.
	   *
	   * @example
	   *
	   * ```js
	   * var corner1 = L.latLng(40.712, -74.227),
	   * corner2 = L.latLng(40.774, -74.125),
	   * bounds = L.latLngBounds(corner1, corner2);
	   * ```
	   *
	   * All Leaflet methods that accept LatLngBounds objects also accept them in a simple Array form (unless noted otherwise), so the bounds example above can be passed like this:
	   *
	   * ```js
	   * map.fitBounds([
	   * 	[40.712, -74.227],
	   * 	[40.774, -74.125]
	   * ]);
	   * ```
	   *
	   * Caution: if the area crosses the antimeridian (often confused with the International Date Line), you must specify corners _outside_ the [-180, 180] degrees longitude range.
	   *
	   * Note that `LatLngBounds` does not inherit from Leaflet's `Class` object,
	   * which means new classes can't inherit from it, and new methods
	   * can't be added to it with the `include` function.
	   */
	
	  function LatLngBounds(corner1, corner2) { // (LatLng, LatLng) or (LatLng[])
	  	if (!corner1) { return; }
	
	  	var latlngs = corner2 ? [corner1, corner2] : corner1;
	
	  	for (var i = 0, len = latlngs.length; i < len; i++) {
	  		this.extend(latlngs[i]);
	  	}
	  }
	
	  LatLngBounds.prototype = {
	
	  	// @method extend(latlng: LatLng): this
	  	// Extend the bounds to contain the given point
	
	  	// @alternative
	  	// @method extend(otherBounds: LatLngBounds): this
	  	// Extend the bounds to contain the given bounds
	  	extend: function (obj) {
	  		var sw = this._southWest,
	  		    ne = this._northEast,
	  		    sw2, ne2;
	
	  		if (obj instanceof LatLng) {
	  			sw2 = obj;
	  			ne2 = obj;
	
	  		} else if (obj instanceof LatLngBounds) {
	  			sw2 = obj._southWest;
	  			ne2 = obj._northEast;
	
	  			if (!sw2 || !ne2) { return this; }
	
	  		} else {
	  			return obj ? this.extend(toLatLng(obj) || toLatLngBounds(obj)) : this;
	  		}
	
	  		if (!sw && !ne) {
	  			this._southWest = new LatLng(sw2.lat, sw2.lng);
	  			this._northEast = new LatLng(ne2.lat, ne2.lng);
	  		} else {
	  			sw.lat = Math.min(sw2.lat, sw.lat);
	  			sw.lng = Math.min(sw2.lng, sw.lng);
	  			ne.lat = Math.max(ne2.lat, ne.lat);
	  			ne.lng = Math.max(ne2.lng, ne.lng);
	  		}
	
	  		return this;
	  	},
	
	  	// @method pad(bufferRatio: Number): LatLngBounds
	  	// Returns bounds created by extending or retracting the current bounds by a given ratio in each direction.
	  	// For example, a ratio of 0.5 extends the bounds by 50% in each direction.
	  	// Negative values will retract the bounds.
	  	pad: function (bufferRatio) {
	  		var sw = this._southWest,
	  		    ne = this._northEast,
	  		    heightBuffer = Math.abs(sw.lat - ne.lat) * bufferRatio,
	  		    widthBuffer = Math.abs(sw.lng - ne.lng) * bufferRatio;
	
	  		return new LatLngBounds(
	  		        new LatLng(sw.lat - heightBuffer, sw.lng - widthBuffer),
	  		        new LatLng(ne.lat + heightBuffer, ne.lng + widthBuffer));
	  	},
	
	  	// @method getCenter(): LatLng
	  	// Returns the center point of the bounds.
	  	getCenter: function () {
	  		return new LatLng(
	  		        (this._southWest.lat + this._northEast.lat) / 2,
	  		        (this._southWest.lng + this._northEast.lng) / 2);
	  	},
	
	  	// @method getSouthWest(): LatLng
	  	// Returns the south-west point of the bounds.
	  	getSouthWest: function () {
	  		return this._southWest;
	  	},
	
	  	// @method getNorthEast(): LatLng
	  	// Returns the north-east point of the bounds.
	  	getNorthEast: function () {
	  		return this._northEast;
	  	},
	
	  	// @method getNorthWest(): LatLng
	  	// Returns the north-west point of the bounds.
	  	getNorthWest: function () {
	  		return new LatLng(this.getNorth(), this.getWest());
	  	},
	
	  	// @method getSouthEast(): LatLng
	  	// Returns the south-east point of the bounds.
	  	getSouthEast: function () {
	  		return new LatLng(this.getSouth(), this.getEast());
	  	},
	
	  	// @method getWest(): Number
	  	// Returns the west longitude of the bounds
	  	getWest: function () {
	  		return this._southWest.lng;
	  	},
	
	  	// @method getSouth(): Number
	  	// Returns the south latitude of the bounds
	  	getSouth: function () {
	  		return this._southWest.lat;
	  	},
	
	  	// @method getEast(): Number
	  	// Returns the east longitude of the bounds
	  	getEast: function () {
	  		return this._northEast.lng;
	  	},
	
	  	// @method getNorth(): Number
	  	// Returns the north latitude of the bounds
	  	getNorth: function () {
	  		return this._northEast.lat;
	  	},
	
	  	// @method contains(otherBounds: LatLngBounds): Boolean
	  	// Returns `true` if the rectangle contains the given one.
	
	  	// @alternative
	  	// @method contains (latlng: LatLng): Boolean
	  	// Returns `true` if the rectangle contains the given point.
	  	contains: function (obj) { // (LatLngBounds) or (LatLng) -> Boolean
	  		if (typeof obj[0] === 'number' || obj instanceof LatLng || 'lat' in obj) {
	  			obj = toLatLng(obj);
	  		} else {
	  			obj = toLatLngBounds(obj);
	  		}
	
	  		var sw = this._southWest,
	  		    ne = this._northEast,
	  		    sw2, ne2;
	
	  		if (obj instanceof LatLngBounds) {
	  			sw2 = obj.getSouthWest();
	  			ne2 = obj.getNorthEast();
	  		} else {
	  			sw2 = ne2 = obj;
	  		}
	
	  		return (sw2.lat >= sw.lat) && (ne2.lat <= ne.lat) &&
	  		       (sw2.lng >= sw.lng) && (ne2.lng <= ne.lng);
	  	},
	
	  	// @method intersects(otherBounds: LatLngBounds): Boolean
	  	// Returns `true` if the rectangle intersects the given bounds. Two bounds intersect if they have at least one point in common.
	  	intersects: function (bounds) {
	  		bounds = toLatLngBounds(bounds);
	
	  		var sw = this._southWest,
	  		    ne = this._northEast,
	  		    sw2 = bounds.getSouthWest(),
	  		    ne2 = bounds.getNorthEast(),
	
	  		    latIntersects = (ne2.lat >= sw.lat) && (sw2.lat <= ne.lat),
	  		    lngIntersects = (ne2.lng >= sw.lng) && (sw2.lng <= ne.lng);
	
	  		return latIntersects && lngIntersects;
	  	},
	
	  	// @method overlaps(otherBounds: LatLngBounds): Boolean
	  	// Returns `true` if the rectangle overlaps the given bounds. Two bounds overlap if their intersection is an area.
	  	overlaps: function (bounds) {
	  		bounds = toLatLngBounds(bounds);
	
	  		var sw = this._southWest,
	  		    ne = this._northEast,
	  		    sw2 = bounds.getSouthWest(),
	  		    ne2 = bounds.getNorthEast(),
	
	  		    latOverlaps = (ne2.lat > sw.lat) && (sw2.lat < ne.lat),
	  		    lngOverlaps = (ne2.lng > sw.lng) && (sw2.lng < ne.lng);
	
	  		return latOverlaps && lngOverlaps;
	  	},
	
	  	// @method toBBoxString(): String
	  	// Returns a string with bounding box coordinates in a 'southwest_lng,southwest_lat,northeast_lng,northeast_lat' format. Useful for sending requests to web services that return geo data.
	  	toBBoxString: function () {
	  		return [this.getWest(), this.getSouth(), this.getEast(), this.getNorth()].join(',');
	  	},
	
	  	// @method equals(otherBounds: LatLngBounds, maxMargin?: Number): Boolean
	  	// Returns `true` if the rectangle is equivalent (within a small margin of error) to the given bounds. The margin of error can be overridden by setting `maxMargin` to a small number.
	  	equals: function (bounds, maxMargin) {
	  		if (!bounds) { return false; }
	
	  		bounds = toLatLngBounds(bounds);
	
	  		return this._southWest.equals(bounds.getSouthWest(), maxMargin) &&
	  		       this._northEast.equals(bounds.getNorthEast(), maxMargin);
	  	},
	
	  	// @method isValid(): Boolean
	  	// Returns `true` if the bounds are properly initialized.
	  	isValid: function () {
	  		return !!(this._southWest && this._northEast);
	  	}
	  };
	
	  // TODO International date line?
	
	  // @factory L.latLngBounds(corner1: LatLng, corner2: LatLng)
	  // Creates a `LatLngBounds` object by defining two diagonally opposite corners of the rectangle.
	
	  // @alternative
	  // @factory L.latLngBounds(latlngs: LatLng[])
	  // Creates a `LatLngBounds` object defined by the geographical points it contains. Very useful for zooming the map to fit a particular set of locations with [`fitBounds`](#map-fitbounds).
	  function toLatLngBounds(a, b) {
	  	if (a instanceof LatLngBounds) {
	  		return a;
	  	}
	  	return new LatLngBounds(a, b);
	  }
	
	  /* @class LatLng
	   * @aka L.LatLng
	   *
	   * Represents a geographical point with a certain latitude and longitude.
	   *
	   * @example
	   *
	   * ```
	   * var latlng = L.latLng(50.5, 30.5);
	   * ```
	   *
	   * All Leaflet methods that accept LatLng objects also accept them in a simple Array form and simple object form (unless noted otherwise), so these lines are equivalent:
	   *
	   * ```
	   * map.panTo([50, 30]);
	   * map.panTo({lon: 30, lat: 50});
	   * map.panTo({lat: 50, lng: 30});
	   * map.panTo(L.latLng(50, 30));
	   * ```
	   *
	   * Note that `LatLng` does not inherit from Leaflet's `Class` object,
	   * which means new classes can't inherit from it, and new methods
	   * can't be added to it with the `include` function.
	   */
	
	  function LatLng(lat, lng, alt) {
	  	if (isNaN(lat) || isNaN(lng)) {
	  		throw new Error('Invalid LatLng object: (' + lat + ', ' + lng + ')');
	  	}
	
	  	// @property lat: Number
	  	// Latitude in degrees
	  	this.lat = +lat;
	
	  	// @property lng: Number
	  	// Longitude in degrees
	  	this.lng = +lng;
	
	  	// @property alt: Number
	  	// Altitude in meters (optional)
	  	if (alt !== undefined) {
	  		this.alt = +alt;
	  	}
	  }
	
	  LatLng.prototype = {
	  	// @method equals(otherLatLng: LatLng, maxMargin?: Number): Boolean
	  	// Returns `true` if the given `LatLng` point is at the same position (within a small margin of error). The margin of error can be overridden by setting `maxMargin` to a small number.
	  	equals: function (obj, maxMargin) {
	  		if (!obj) { return false; }
	
	  		obj = toLatLng(obj);
	
	  		var margin = Math.max(
	  		        Math.abs(this.lat - obj.lat),
	  		        Math.abs(this.lng - obj.lng));
	
	  		return margin <= (maxMargin === undefined ? 1.0E-9 : maxMargin);
	  	},
	
	  	// @method toString(): String
	  	// Returns a string representation of the point (for debugging purposes).
	  	toString: function (precision) {
	  		return 'LatLng(' +
	  		        formatNum(this.lat, precision) + ', ' +
	  		        formatNum(this.lng, precision) + ')';
	  	},
	
	  	// @method distanceTo(otherLatLng: LatLng): Number
	  	// Returns the distance (in meters) to the given `LatLng` calculated using the [Spherical Law of Cosines](https://en.wikipedia.org/wiki/Spherical_law_of_cosines).
	  	distanceTo: function (other) {
	  		return Earth.distance(this, toLatLng(other));
	  	},
	
	  	// @method wrap(): LatLng
	  	// Returns a new `LatLng` object with the longitude wrapped so it's always between -180 and +180 degrees.
	  	wrap: function () {
	  		return Earth.wrapLatLng(this);
	  	},
	
	  	// @method toBounds(sizeInMeters: Number): LatLngBounds
	  	// Returns a new `LatLngBounds` object in which each boundary is `sizeInMeters/2` meters apart from the `LatLng`.
	  	toBounds: function (sizeInMeters) {
	  		var latAccuracy = 180 * sizeInMeters / 40075017,
	  		    lngAccuracy = latAccuracy / Math.cos((Math.PI / 180) * this.lat);
	
	  		return toLatLngBounds(
	  		        [this.lat - latAccuracy, this.lng - lngAccuracy],
	  		        [this.lat + latAccuracy, this.lng + lngAccuracy]);
	  	},
	
	  	clone: function () {
	  		return new LatLng(this.lat, this.lng, this.alt);
	  	}
	  };
	
	
	
	  // @factory L.latLng(latitude: Number, longitude: Number, altitude?: Number): LatLng
	  // Creates an object representing a geographical point with the given latitude and longitude (and optionally altitude).
	
	  // @alternative
	  // @factory L.latLng(coords: Array): LatLng
	  // Expects an array of the form `[Number, Number]` or `[Number, Number, Number]` instead.
	
	  // @alternative
	  // @factory L.latLng(coords: Object): LatLng
	  // Expects an plain object of the form `{lat: Number, lng: Number}` or `{lat: Number, lng: Number, alt: Number}` instead.
	
	  function toLatLng(a, b, c) {
	  	if (a instanceof LatLng) {
	  		return a;
	  	}
	  	if (isArray(a) && typeof a[0] !== 'object') {
	  		if (a.length === 3) {
	  			return new LatLng(a[0], a[1], a[2]);
	  		}
	  		if (a.length === 2) {
	  			return new LatLng(a[0], a[1]);
	  		}
	  		return null;
	  	}
	  	if (a === undefined || a === null) {
	  		return a;
	  	}
	  	if (typeof a === 'object' && 'lat' in a) {
	  		return new LatLng(a.lat, 'lng' in a ? a.lng : a.lon, a.alt);
	  	}
	  	if (b === undefined) {
	  		return null;
	  	}
	  	return new LatLng(a, b, c);
	  }
	
	  /*
	   * @namespace CRS
	   * @crs L.CRS.Base
	   * Object that defines coordinate reference systems for projecting
	   * geographical points into pixel (screen) coordinates and back (and to
	   * coordinates in other units for [WMS](https://en.wikipedia.org/wiki/Web_Map_Service) services). See
	   * [spatial reference system](https://en.wikipedia.org/wiki/Spatial_reference_system).
	   *
	   * Leaflet defines the most usual CRSs by default. If you want to use a
	   * CRS not defined by default, take a look at the
	   * [Proj4Leaflet](https://github.com/kartena/Proj4Leaflet) plugin.
	   *
	   * Note that the CRS instances do not inherit from Leaflet's `Class` object,
	   * and can't be instantiated. Also, new classes can't inherit from them,
	   * and methods can't be added to them with the `include` function.
	   */
	
	  var CRS = {
	  	// @method latLngToPoint(latlng: LatLng, zoom: Number): Point
	  	// Projects geographical coordinates into pixel coordinates for a given zoom.
	  	latLngToPoint: function (latlng, zoom) {
	  		var projectedPoint = this.projection.project(latlng),
	  		    scale = this.scale(zoom);
	
	  		return this.transformation._transform(projectedPoint, scale);
	  	},
	
	  	// @method pointToLatLng(point: Point, zoom: Number): LatLng
	  	// The inverse of `latLngToPoint`. Projects pixel coordinates on a given
	  	// zoom into geographical coordinates.
	  	pointToLatLng: function (point, zoom) {
	  		var scale = this.scale(zoom),
	  		    untransformedPoint = this.transformation.untransform(point, scale);
	
	  		return this.projection.unproject(untransformedPoint);
	  	},
	
	  	// @method project(latlng: LatLng): Point
	  	// Projects geographical coordinates into coordinates in units accepted for
	  	// this CRS (e.g. meters for EPSG:3857, for passing it to WMS services).
	  	project: function (latlng) {
	  		return this.projection.project(latlng);
	  	},
	
	  	// @method unproject(point: Point): LatLng
	  	// Given a projected coordinate returns the corresponding LatLng.
	  	// The inverse of `project`.
	  	unproject: function (point) {
	  		return this.projection.unproject(point);
	  	},
	
	  	// @method scale(zoom: Number): Number
	  	// Returns the scale used when transforming projected coordinates into
	  	// pixel coordinates for a particular zoom. For example, it returns
	  	// `256 * 2^zoom` for Mercator-based CRS.
	  	scale: function (zoom) {
	  		return 256 * Math.pow(2, zoom);
	  	},
	
	  	// @method zoom(scale: Number): Number
	  	// Inverse of `scale()`, returns the zoom level corresponding to a scale
	  	// factor of `scale`.
	  	zoom: function (scale) {
	  		return Math.log(scale / 256) / Math.LN2;
	  	},
	
	  	// @method getProjectedBounds(zoom: Number): Bounds
	  	// Returns the projection's bounds scaled and transformed for the provided `zoom`.
	  	getProjectedBounds: function (zoom) {
	  		if (this.infinite) { return null; }
	
	  		var b = this.projection.bounds,
	  		    s = this.scale(zoom),
	  		    min = this.transformation.transform(b.min, s),
	  		    max = this.transformation.transform(b.max, s);
	
	  		return new Bounds(min, max);
	  	},
	
	  	// @method distance(latlng1: LatLng, latlng2: LatLng): Number
	  	// Returns the distance between two geographical coordinates.
	
	  	// @property code: String
	  	// Standard code name of the CRS passed into WMS services (e.g. `'EPSG:3857'`)
	  	//
	  	// @property wrapLng: Number[]
	  	// An array of two numbers defining whether the longitude (horizontal) coordinate
	  	// axis wraps around a given range and how. Defaults to `[-180, 180]` in most
	  	// geographical CRSs. If `undefined`, the longitude axis does not wrap around.
	  	//
	  	// @property wrapLat: Number[]
	  	// Like `wrapLng`, but for the latitude (vertical) axis.
	
	  	// wrapLng: [min, max],
	  	// wrapLat: [min, max],
	
	  	// @property infinite: Boolean
	  	// If true, the coordinate space will be unbounded (infinite in both axes)
	  	infinite: false,
	
	  	// @method wrapLatLng(latlng: LatLng): LatLng
	  	// Returns a `LatLng` where lat and lng has been wrapped according to the
	  	// CRS's `wrapLat` and `wrapLng` properties, if they are outside the CRS's bounds.
	  	wrapLatLng: function (latlng) {
	  		var lng = this.wrapLng ? wrapNum(latlng.lng, this.wrapLng, true) : latlng.lng,
	  		    lat = this.wrapLat ? wrapNum(latlng.lat, this.wrapLat, true) : latlng.lat,
	  		    alt = latlng.alt;
	
	  		return new LatLng(lat, lng, alt);
	  	},
	
	  	// @method wrapLatLngBounds(bounds: LatLngBounds): LatLngBounds
	  	// Returns a `LatLngBounds` with the same size as the given one, ensuring
	  	// that its center is within the CRS's bounds.
	  	// Only accepts actual `L.LatLngBounds` instances, not arrays.
	  	wrapLatLngBounds: function (bounds) {
	  		var center = bounds.getCenter(),
	  		    newCenter = this.wrapLatLng(center),
	  		    latShift = center.lat - newCenter.lat,
	  		    lngShift = center.lng - newCenter.lng;
	
	  		if (latShift === 0 && lngShift === 0) {
	  			return bounds;
	  		}
	
	  		var sw = bounds.getSouthWest(),
	  		    ne = bounds.getNorthEast(),
	  		    newSw = new LatLng(sw.lat - latShift, sw.lng - lngShift),
	  		    newNe = new LatLng(ne.lat - latShift, ne.lng - lngShift);
	
	  		return new LatLngBounds(newSw, newNe);
	  	}
	  };
	
	  /*
	   * @namespace CRS
	   * @crs L.CRS.Earth
	   *
	   * Serves as the base for CRS that are global such that they cover the earth.
	   * Can only be used as the base for other CRS and cannot be used directly,
	   * since it does not have a `code`, `projection` or `transformation`. `distance()` returns
	   * meters.
	   */
	
	  var Earth = extend({}, CRS, {
	  	wrapLng: [-180, 180],
	
	  	// Mean Earth Radius, as recommended for use by
	  	// the International Union of Geodesy and Geophysics,
	  	// see https://rosettacode.org/wiki/Haversine_formula
	  	R: 6371000,
	
	  	// distance between two geographical points using spherical law of cosines approximation
	  	distance: function (latlng1, latlng2) {
	  		var rad = Math.PI / 180,
	  		    lat1 = latlng1.lat * rad,
	  		    lat2 = latlng2.lat * rad,
	  		    sinDLat = Math.sin((latlng2.lat - latlng1.lat) * rad / 2),
	  		    sinDLon = Math.sin((latlng2.lng - latlng1.lng) * rad / 2),
	  		    a = sinDLat * sinDLat + Math.cos(lat1) * Math.cos(lat2) * sinDLon * sinDLon,
	  		    c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
	  		return this.R * c;
	  	}
	  });
	
	  /*
	   * @namespace Projection
	   * @projection L.Projection.SphericalMercator
	   *
	   * Spherical Mercator projection — the most common projection for online maps,
	   * used by almost all free and commercial tile providers. Assumes that Earth is
	   * a sphere. Used by the `EPSG:3857` CRS.
	   */
	
	  var earthRadius = 6378137;
	
	  var SphericalMercator = {
	
	  	R: earthRadius,
	  	MAX_LATITUDE: 85.0511287798,
	
	  	project: function (latlng) {
	  		var d = Math.PI / 180,
	  		    max = this.MAX_LATITUDE,
	  		    lat = Math.max(Math.min(max, latlng.lat), -max),
	  		    sin = Math.sin(lat * d);
	
	  		return new Point(
	  			this.R * latlng.lng * d,
	  			this.R * Math.log((1 + sin) / (1 - sin)) / 2);
	  	},
	
	  	unproject: function (point) {
	  		var d = 180 / Math.PI;
	
	  		return new LatLng(
	  			(2 * Math.atan(Math.exp(point.y / this.R)) - (Math.PI / 2)) * d,
	  			point.x * d / this.R);
	  	},
	
	  	bounds: (function () {
	  		var d = earthRadius * Math.PI;
	  		return new Bounds([-d, -d], [d, d]);
	  	})()
	  };
	
	  /*
	   * @class Transformation
	   * @aka L.Transformation
	   *
	   * Represents an affine transformation: a set of coefficients `a`, `b`, `c`, `d`
	   * for transforming a point of a form `(x, y)` into `(a*x + b, c*y + d)` and doing
	   * the reverse. Used by Leaflet in its projections code.
	   *
	   * @example
	   *
	   * ```js
	   * var transformation = L.transformation(2, 5, -1, 10),
	   * 	p = L.point(1, 2),
	   * 	p2 = transformation.transform(p), //  L.point(7, 8)
	   * 	p3 = transformation.untransform(p2); //  L.point(1, 2)
	   * ```
	   */
	
	
	  // factory new L.Transformation(a: Number, b: Number, c: Number, d: Number)
	  // Creates a `Transformation` object with the given coefficients.
	  function Transformation(a, b, c, d) {
	  	if (isArray(a)) {
	  		// use array properties
	  		this._a = a[0];
	  		this._b = a[1];
	  		this._c = a[2];
	  		this._d = a[3];
	  		return;
	  	}
	  	this._a = a;
	  	this._b = b;
	  	this._c = c;
	  	this._d = d;
	  }
	
	  Transformation.prototype = {
	  	// @method transform(point: Point, scale?: Number): Point
	  	// Returns a transformed point, optionally multiplied by the given scale.
	  	// Only accepts actual `L.Point` instances, not arrays.
	  	transform: function (point, scale) { // (Point, Number) -> Point
	  		return this._transform(point.clone(), scale);
	  	},
	
	  	// destructive transform (faster)
	  	_transform: function (point, scale) {
	  		scale = scale || 1;
	  		point.x = scale * (this._a * point.x + this._b);
	  		point.y = scale * (this._c * point.y + this._d);
	  		return point;
	  	},
	
	  	// @method untransform(point: Point, scale?: Number): Point
	  	// Returns the reverse transformation of the given point, optionally divided
	  	// by the given scale. Only accepts actual `L.Point` instances, not arrays.
	  	untransform: function (point, scale) {
	  		scale = scale || 1;
	  		return new Point(
	  		        (point.x / scale - this._b) / this._a,
	  		        (point.y / scale - this._d) / this._c);
	  	}
	  };
	
	  // factory L.transformation(a: Number, b: Number, c: Number, d: Number)
	
	  // @factory L.transformation(a: Number, b: Number, c: Number, d: Number)
	  // Instantiates a Transformation object with the given coefficients.
	
	  // @alternative
	  // @factory L.transformation(coefficients: Array): Transformation
	  // Expects an coefficients array of the form
	  // `[a: Number, b: Number, c: Number, d: Number]`.
	
	  function toTransformation(a, b, c, d) {
	  	return new Transformation(a, b, c, d);
	  }
	
	  /*
	   * @namespace CRS
	   * @crs L.CRS.EPSG3857
	   *
	   * The most common CRS for online maps, used by almost all free and commercial
	   * tile providers. Uses Spherical Mercator projection. Set in by default in
	   * Map's `crs` option.
	   */
	
	  var EPSG3857 = extend({}, Earth, {
	  	code: 'EPSG:3857',
	  	projection: SphericalMercator,
	
	  	transformation: (function () {
	  		var scale = 0.5 / (Math.PI * SphericalMercator.R);
	  		return toTransformation(scale, 0.5, -scale, 0.5);
	  	}())
	  });
	
	  var EPSG900913 = extend({}, EPSG3857, {
	  	code: 'EPSG:900913'
	  });
	
	  // @namespace SVG; @section
	  // There are several static functions which can be called without instantiating L.SVG:
	
	  // @function create(name: String): SVGElement
	  // Returns a instance of [SVGElement](https://developer.mozilla.org/docs/Web/API/SVGElement),
	  // corresponding to the class name passed. For example, using 'line' will return
	  // an instance of [SVGLineElement](https://developer.mozilla.org/docs/Web/API/SVGLineElement).
	  function svgCreate(name) {
	  	return document.createElementNS('http://www.w3.org/2000/svg', name);
	  }
	
	  // @function pointsToPath(rings: Point[], closed: Boolean): String
	  // Generates a SVG path string for multiple rings, with each ring turning
	  // into "M..L..L.." instructions
	  function pointsToPath(rings, closed) {
	  	var str = '',
	  	i, j, len, len2, points, p;
	
	  	for (i = 0, len = rings.length; i < len; i++) {
	  		points = rings[i];
	
	  		for (j = 0, len2 = points.length; j < len2; j++) {
	  			p = points[j];
	  			str += (j ? 'L' : 'M') + p.x + ' ' + p.y;
	  		}
	
	  		// closes the ring for polygons; "x" is VML syntax
	  		str += closed ? (Browser.svg ? 'z' : 'x') : '';
	  	}
	
	  	// SVG complains about empty path strings
	  	return str || 'M0 0';
	  }
	
	  /*
	   * @namespace Browser
	   * @aka L.Browser
	   *
	   * A namespace with static properties for browser/feature detection used by Leaflet internally.
	   *
	   * @example
	   *
	   * ```js
	   * if (L.Browser.ielt9) {
	   *   alert('Upgrade your browser, dude!');
	   * }
	   * ```
	   */
	
	  var style = document.documentElement.style;
	
	  // @property ie: Boolean; `true` for all Internet Explorer versions (not Edge).
	  var ie = 'ActiveXObject' in window;
	
	  // @property ielt9: Boolean; `true` for Internet Explorer versions less than 9.
	  var ielt9 = ie && !document.addEventListener;
	
	  // @property edge: Boolean; `true` for the Edge web browser.
	  var edge = 'msLaunchUri' in navigator && !('documentMode' in document);
	
	  // @property webkit: Boolean;
	  // `true` for webkit-based browsers like Chrome and Safari (including mobile versions).
	  var webkit = userAgentContains('webkit');
	
	  // @property android: Boolean
	  // **Deprecated.** `true` for any browser running on an Android platform.
	  var android = userAgentContains('android');
	
	  // @property android23: Boolean; **Deprecated.** `true` for browsers running on Android 2 or Android 3.
	  var android23 = userAgentContains('android 2') || userAgentContains('android 3');
	
	  /* See https://stackoverflow.com/a/17961266 for details on detecting stock Android */
	  var webkitVer = parseInt(/WebKit\/([0-9]+)|$/.exec(navigator.userAgent)[1], 10); // also matches AppleWebKit
	  // @property androidStock: Boolean; **Deprecated.** `true` for the Android stock browser (i.e. not Chrome)
	  var androidStock = android && userAgentContains('Google') && webkitVer < 537 && !('AudioNode' in window);
	
	  // @property opera: Boolean; `true` for the Opera browser
	  var opera = !!window.opera;
	
	  // @property chrome: Boolean; `true` for the Chrome browser.
	  var chrome = !edge && userAgentContains('chrome');
	
	  // @property gecko: Boolean; `true` for gecko-based browsers like Firefox.
	  var gecko = userAgentContains('gecko') && !webkit && !opera && !ie;
	
	  // @property safari: Boolean; `true` for the Safari browser.
	  var safari = !chrome && userAgentContains('safari');
	
	  var phantom = userAgentContains('phantom');
	
	  // @property opera12: Boolean
	  // `true` for the Opera browser supporting CSS transforms (version 12 or later).
	  var opera12 = 'OTransition' in style;
	
	  // @property win: Boolean; `true` when the browser is running in a Windows platform
	  var win = navigator.platform.indexOf('Win') === 0;
	
	  // @property ie3d: Boolean; `true` for all Internet Explorer versions supporting CSS transforms.
	  var ie3d = ie && ('transition' in style);
	
	  // @property webkit3d: Boolean; `true` for webkit-based browsers supporting CSS transforms.
	  var webkit3d = ('WebKitCSSMatrix' in window) && ('m11' in new window.WebKitCSSMatrix()) && !android23;
	
	  // @property gecko3d: Boolean; `true` for gecko-based browsers supporting CSS transforms.
	  var gecko3d = 'MozPerspective' in style;
	
	  // @property any3d: Boolean
	  // `true` for all browsers supporting CSS transforms.
	  var any3d = !window.L_DISABLE_3D && (ie3d || webkit3d || gecko3d) && !opera12 && !phantom;
	
	  // @property mobile: Boolean; `true` for all browsers running in a mobile device.
	  var mobile = typeof orientation !== 'undefined' || userAgentContains('mobile');
	
	  // @property mobileWebkit: Boolean; `true` for all webkit-based browsers in a mobile device.
	  var mobileWebkit = mobile && webkit;
	
	  // @property mobileWebkit3d: Boolean
	  // `true` for all webkit-based browsers in a mobile device supporting CSS transforms.
	  var mobileWebkit3d = mobile && webkit3d;
	
	  // @property msPointer: Boolean
	  // `true` for browsers implementing the Microsoft touch events model (notably IE10).
	  var msPointer = !window.PointerEvent && window.MSPointerEvent;
	
	  // @property pointer: Boolean
	  // `true` for all browsers supporting [pointer events](https://msdn.microsoft.com/en-us/library/dn433244%28v=vs.85%29.aspx).
	  var pointer = !!(window.PointerEvent || msPointer);
	
	  // @property touchNative: Boolean
	  // `true` for all browsers supporting [touch events](https://developer.mozilla.org/docs/Web/API/Touch_events).
	  // **This does not necessarily mean** that the browser is running in a computer with
	  // a touchscreen, it only means that the browser is capable of understanding
	  // touch events.
	  var touchNative = 'ontouchstart' in window || !!window.TouchEvent;
	
	  // @property touch: Boolean
	  // `true` for all browsers supporting either [touch](#browser-touch) or [pointer](#browser-pointer) events.
	  // Note: pointer events will be preferred (if available), and processed for all `touch*` listeners.
	  var touch = !window.L_NO_TOUCH && (touchNative || pointer);
	
	  // @property mobileOpera: Boolean; `true` for the Opera browser in a mobile device.
	  var mobileOpera = mobile && opera;
	
	  // @property mobileGecko: Boolean
	  // `true` for gecko-based browsers running in a mobile device.
	  var mobileGecko = mobile && gecko;
	
	  // @property retina: Boolean
	  // `true` for browsers on a high-resolution "retina" screen or on any screen when browser's display zoom is more than 100%.
	  var retina = (window.devicePixelRatio || (window.screen.deviceXDPI / window.screen.logicalXDPI)) > 1;
	
	  // @property passiveEvents: Boolean
	  // `true` for browsers that support passive events.
	  var passiveEvents = (function () {
	  	var supportsPassiveOption = false;
	  	try {
	  		var opts = Object.defineProperty({}, 'passive', {
	  			get: function () { // eslint-disable-line getter-return
	  				supportsPassiveOption = true;
	  			}
	  		});
	  		window.addEventListener('testPassiveEventSupport', falseFn, opts);
	  		window.removeEventListener('testPassiveEventSupport', falseFn, opts);
	  	} catch (e) {
	  		// Errors can safely be ignored since this is only a browser support test.
	  	}
	  	return supportsPassiveOption;
	  }());
	
	  // @property canvas: Boolean
	  // `true` when the browser supports [`<canvas>`](https://developer.mozilla.org/docs/Web/API/Canvas_API).
	  var canvas$1 = (function () {
	  	return !!document.createElement('canvas').getContext;
	  }());
	
	  // @property svg: Boolean
	  // `true` when the browser supports [SVG](https://developer.mozilla.org/docs/Web/SVG).
	  var svg$1 = !!(document.createElementNS && svgCreate('svg').createSVGRect);
	
	  var inlineSvg = !!svg$1 && (function () {
	  	var div = document.createElement('div');
	  	div.innerHTML = '<svg/>';
	  	return (div.firstChild && div.firstChild.namespaceURI) === 'http://www.w3.org/2000/svg';
	  })();
	
	  // @property vml: Boolean
	  // `true` if the browser supports [VML](https://en.wikipedia.org/wiki/Vector_Markup_Language).
	  var vml = !svg$1 && (function () {
	  	try {
	  		var div = document.createElement('div');
	  		div.innerHTML = '<v:shape adj="1"/>';
	
	  		var shape = div.firstChild;
	  		shape.style.behavior = 'url(#default#VML)';
	
	  		return shape && (typeof shape.adj === 'object');
	
	  	} catch (e) {
	  		return false;
	  	}
	  }());
	
	
	  // @property mac: Boolean; `true` when the browser is running in a Mac platform
	  var mac = navigator.platform.indexOf('Mac') === 0;
	
	  // @property mac: Boolean; `true` when the browser is running in a Linux platform
	  var linux = navigator.platform.indexOf('Linux') === 0;
	
	  function userAgentContains(str) {
	  	return navigator.userAgent.toLowerCase().indexOf(str) >= 0;
	  }
	
	
	  var Browser = {
	  	ie: ie,
	  	ielt9: ielt9,
	  	edge: edge,
	  	webkit: webkit,
	  	android: android,
	  	android23: android23,
	  	androidStock: androidStock,
	  	opera: opera,
	  	chrome: chrome,
	  	gecko: gecko,
	  	safari: safari,
	  	phantom: phantom,
	  	opera12: opera12,
	  	win: win,
	  	ie3d: ie3d,
	  	webkit3d: webkit3d,
	  	gecko3d: gecko3d,
	  	any3d: any3d,
	  	mobile: mobile,
	  	mobileWebkit: mobileWebkit,
	  	mobileWebkit3d: mobileWebkit3d,
	  	msPointer: msPointer,
	  	pointer: pointer,
	  	touch: touch,
	  	touchNative: touchNative,
	  	mobileOpera: mobileOpera,
	  	mobileGecko: mobileGecko,
	  	retina: retina,
	  	passiveEvents: passiveEvents,
	  	canvas: canvas$1,
	  	svg: svg$1,
	  	vml: vml,
	  	inlineSvg: inlineSvg,
	  	mac: mac,
	  	linux: linux
	  };
	
	  /*
	   * Extends L.DomEvent to provide touch support for Internet Explorer and Windows-based devices.
	   */
	
	  var POINTER_DOWN =   Browser.msPointer ? 'MSPointerDown'   : 'pointerdown';
	  var POINTER_MOVE =   Browser.msPointer ? 'MSPointerMove'   : 'pointermove';
	  var POINTER_UP =     Browser.msPointer ? 'MSPointerUp'     : 'pointerup';
	  var POINTER_CANCEL = Browser.msPointer ? 'MSPointerCancel' : 'pointercancel';
	  var pEvent = {
	  	touchstart  : POINTER_DOWN,
	  	touchmove   : POINTER_MOVE,
	  	touchend    : POINTER_UP,
	  	touchcancel : POINTER_CANCEL
	  };
	  var handle = {
	  	touchstart  : _onPointerStart,
	  	touchmove   : _handlePointer,
	  	touchend    : _handlePointer,
	  	touchcancel : _handlePointer
	  };
	  var _pointers = {};
	  var _pointerDocListener = false;
	
	  // Provides a touch events wrapper for (ms)pointer events.
	  // ref https://www.w3.org/TR/pointerevents/ https://www.w3.org/Bugs/Public/show_bug.cgi?id=22890
	
	  function addPointerListener(obj, type, handler) {
	  	if (type === 'touchstart') {
	  		_addPointerDocListener();
	  	}
	  	if (!handle[type]) {
	  		console.warn('wrong event specified:', type);
	  		return falseFn;
	  	}
	  	handler = handle[type].bind(this, handler);
	  	obj.addEventListener(pEvent[type], handler, false);
	  	return handler;
	  }
	
	  function removePointerListener(obj, type, handler) {
	  	if (!pEvent[type]) {
	  		console.warn('wrong event specified:', type);
	  		return;
	  	}
	  	obj.removeEventListener(pEvent[type], handler, false);
	  }
	
	  function _globalPointerDown(e) {
	  	_pointers[e.pointerId] = e;
	  }
	
	  function _globalPointerMove(e) {
	  	if (_pointers[e.pointerId]) {
	  		_pointers[e.pointerId] = e;
	  	}
	  }
	
	  function _globalPointerUp(e) {
	  	delete _pointers[e.pointerId];
	  }
	
	  function _addPointerDocListener() {
	  	// need to keep track of what pointers and how many are active to provide e.touches emulation
	  	if (!_pointerDocListener) {
	  		// we listen document as any drags that end by moving the touch off the screen get fired there
	  		document.addEventListener(POINTER_DOWN, _globalPointerDown, true);
	  		document.addEventListener(POINTER_MOVE, _globalPointerMove, true);
	  		document.addEventListener(POINTER_UP, _globalPointerUp, true);
	  		document.addEventListener(POINTER_CANCEL, _globalPointerUp, true);
	
	  		_pointerDocListener = true;
	  	}
	  }
	
	  function _handlePointer(handler, e) {
	  	if (e.pointerType === (e.MSPOINTER_TYPE_MOUSE || 'mouse')) { return; }
	
	  	e.touches = [];
	  	for (var i in _pointers) {
	  		e.touches.push(_pointers[i]);
	  	}
	  	e.changedTouches = [e];
	
	  	handler(e);
	  }
	
	  function _onPointerStart(handler, e) {
	  	// IE10 specific: MsTouch needs preventDefault. See #2000
	  	if (e.MSPOINTER_TYPE_TOUCH && e.pointerType === e.MSPOINTER_TYPE_TOUCH) {
	  		preventDefault(e);
	  	}
	  	_handlePointer(handler, e);
	  }
	
	  /*
	   * Extends the event handling code with double tap support for mobile browsers.
	   *
	   * Note: currently most browsers fire native dblclick, with only a few exceptions
	   * (see https://github.com/Leaflet/Leaflet/issues/7012#issuecomment-595087386)
	   */
	
	  function makeDblclick(event) {
	  	// in modern browsers `type` cannot be just overridden:
	  	// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Errors/Getter_only
	  	var newEvent = {},
	  	    prop, i;
	  	for (i in event) {
	  		prop = event[i];
	  		newEvent[i] = prop && prop.bind ? prop.bind(event) : prop;
	  	}
	  	event = newEvent;
	  	newEvent.type = 'dblclick';
	  	newEvent.detail = 2;
	  	newEvent.isTrusted = false;
	  	newEvent._simulated = true; // for debug purposes
	  	return newEvent;
	  }
	
	  var delay = 200;
	  function addDoubleTapListener(obj, handler) {
	  	// Most browsers handle double tap natively
	  	obj.addEventListener('dblclick', handler);
	
	  	// On some platforms the browser doesn't fire native dblclicks for touch events.
	  	// It seems that in all such cases `detail` property of `click` event is always `1`.
	  	// So here we rely on that fact to avoid excessive 'dblclick' simulation when not needed.
	  	var last = 0,
	  	    detail;
	  	function simDblclick(e) {
	  		if (e.detail !== 1) {
	  			detail = e.detail; // keep in sync to avoid false dblclick in some cases
	  			return;
	  		}
	
	  		if (e.pointerType === 'mouse' ||
	  			(e.sourceCapabilities && !e.sourceCapabilities.firesTouchEvents)) {
	
	  			return;
	  		}
	
	  		// When clicking on an <input>, the browser generates a click on its
	  		// <label> (and vice versa) triggering two clicks in quick succession.
	  		// This ignores clicks on elements which are a label with a 'for'
	  		// attribute (or children of such a label), but not children of
	  		// a <input>.
	  		var path = getPropagationPath(e);
	  		if (path.some(function (el) {
	  			return el instanceof HTMLLabelElement && el.attributes.for;
	  		}) &&
	  			!path.some(function (el) {
	  				return (
	  					el instanceof HTMLInputElement ||
	  					el instanceof HTMLSelectElement
	  				);
	  			})
	  		) {
	  			return;
	  		}
	
	  		var now = Date.now();
	  		if (now - last <= delay) {
	  			detail++;
	  			if (detail === 2) {
	  				handler(makeDblclick(e));
	  			}
	  		} else {
	  			detail = 1;
	  		}
	  		last = now;
	  	}
	
	  	obj.addEventListener('click', simDblclick);
	
	  	return {
	  		dblclick: handler,
	  		simDblclick: simDblclick
	  	};
	  }
	
	  function removeDoubleTapListener(obj, handlers) {
	  	obj.removeEventListener('dblclick', handlers.dblclick);
	  	obj.removeEventListener('click', handlers.simDblclick);
	  }
	
	  /*
	   * @namespace DomUtil
	   *
	   * Utility functions to work with the [DOM](https://developer.mozilla.org/docs/Web/API/Document_Object_Model)
	   * tree, used by Leaflet internally.
	   *
	   * Most functions expecting or returning a `HTMLElement` also work for
	   * SVG elements. The only difference is that classes refer to CSS classes
	   * in HTML and SVG classes in SVG.
	   */
	
	
	  // @property TRANSFORM: String
	  // Vendor-prefixed transform style name (e.g. `'webkitTransform'` for WebKit).
	  var TRANSFORM = testProp(
	  	['transform', 'webkitTransform', 'OTransform', 'MozTransform', 'msTransform']);
	
	  // webkitTransition comes first because some browser versions that drop vendor prefix don't do
	  // the same for the transitionend event, in particular the Android 4.1 stock browser
	
	  // @property TRANSITION: String
	  // Vendor-prefixed transition style name.
	  var TRANSITION = testProp(
	  	['webkitTransition', 'transition', 'OTransition', 'MozTransition', 'msTransition']);
	
	  // @property TRANSITION_END: String
	  // Vendor-prefixed transitionend event name.
	  var TRANSITION_END =
	  	TRANSITION === 'webkitTransition' || TRANSITION === 'OTransition' ? TRANSITION + 'End' : 'transitionend';
	
	
	  // @function get(id: String|HTMLElement): HTMLElement
	  // Returns an element given its DOM id, or returns the element itself
	  // if it was passed directly.
	  function get(id) {
	  	return typeof id === 'string' ? document.getElementById(id) : id;
	  }
	
	  // @function getStyle(el: HTMLElement, styleAttrib: String): String
	  // Returns the value for a certain style attribute on an element,
	  // including computed values or values set through CSS.
	  function getStyle(el, style) {
	  	var value = el.style[style] || (el.currentStyle && el.currentStyle[style]);
	
	  	if ((!value || value === 'auto') && document.defaultView) {
	  		var css = document.defaultView.getComputedStyle(el, null);
	  		value = css ? css[style] : null;
	  	}
	  	return value === 'auto' ? null : value;
	  }
	
	  // @function create(tagName: String, className?: String, container?: HTMLElement): HTMLElement
	  // Creates an HTML element with `tagName`, sets its class to `className`, and optionally appends it to `container` element.
	  function create$1(tagName, className, container) {
	  	var el = document.createElement(tagName);
	  	el.className = className || '';
	
	  	if (container) {
	  		container.appendChild(el);
	  	}
	  	return el;
	  }
	
	  // @function remove(el: HTMLElement)
	  // Removes `el` from its parent element
	  function remove(el) {
	  	var parent = el.parentNode;
	  	if (parent) {
	  		parent.removeChild(el);
	  	}
	  }
	
	  // @function empty(el: HTMLElement)
	  // Removes all of `el`'s children elements from `el`
	  function empty(el) {
	  	while (el.firstChild) {
	  		el.removeChild(el.firstChild);
	  	}
	  }
	
	  // @function toFront(el: HTMLElement)
	  // Makes `el` the last child of its parent, so it renders in front of the other children.
	  function toFront(el) {
	  	var parent = el.parentNode;
	  	if (parent && parent.lastChild !== el) {
	  		parent.appendChild(el);
	  	}
	  }
	
	  // @function toBack(el: HTMLElement)
	  // Makes `el` the first child of its parent, so it renders behind the other children.
	  function toBack(el) {
	  	var parent = el.parentNode;
	  	if (parent && parent.firstChild !== el) {
	  		parent.insertBefore(el, parent.firstChild);
	  	}
	  }
	
	  // @function hasClass(el: HTMLElement, name: String): Boolean
	  // Returns `true` if the element's class attribute contains `name`.
	  function hasClass(el, name) {
	  	if (el.classList !== undefined) {
	  		return el.classList.contains(name);
	  	}
	  	var className = getClass(el);
	  	return className.length > 0 && new RegExp('(^|\\s)' + name + '(\\s|$)').test(className);
	  }
	
	  // @function addClass(el: HTMLElement, name: String)
	  // Adds `name` to the element's class attribute.
	  function addClass(el, name) {
	  	if (el.classList !== undefined) {
	  		var classes = splitWords(name);
	  		for (var i = 0, len = classes.length; i < len; i++) {
	  			el.classList.add(classes[i]);
	  		}
	  	} else if (!hasClass(el, name)) {
	  		var className = getClass(el);
	  		setClass(el, (className ? className + ' ' : '') + name);
	  	}
	  }
	
	  // @function removeClass(el: HTMLElement, name: String)
	  // Removes `name` from the element's class attribute.
	  function removeClass(el, name) {
	  	if (el.classList !== undefined) {
	  		el.classList.remove(name);
	  	} else {
	  		setClass(el, trim((' ' + getClass(el) + ' ').replace(' ' + name + ' ', ' ')));
	  	}
	  }
	
	  // @function setClass(el: HTMLElement, name: String)
	  // Sets the element's class.
	  function setClass(el, name) {
	  	if (el.className.baseVal === undefined) {
	  		el.className = name;
	  	} else {
	  		// in case of SVG element
	  		el.className.baseVal = name;
	  	}
	  }
	
	  // @function getClass(el: HTMLElement): String
	  // Returns the element's class.
	  function getClass(el) {
	  	// Check if the element is an SVGElementInstance and use the correspondingElement instead
	  	// (Required for linked SVG elements in IE11.)
	  	if (el.correspondingElement) {
	  		el = el.correspondingElement;
	  	}
	  	return el.className.baseVal === undefined ? el.className : el.className.baseVal;
	  }
	
	  // @function setOpacity(el: HTMLElement, opacity: Number)
	  // Set the opacity of an element (including old IE support).
	  // `opacity` must be a number from `0` to `1`.
	  function setOpacity(el, value) {
	  	if ('opacity' in el.style) {
	  		el.style.opacity = value;
	  	} else if ('filter' in el.style) {
	  		_setOpacityIE(el, value);
	  	}
	  }
	
	  function _setOpacityIE(el, value) {
	  	var filter = false,
	  	    filterName = 'DXImageTransform.Microsoft.Alpha';
	
	  	// filters collection throws an error if we try to retrieve a filter that doesn't exist
	  	try {
	  		filter = el.filters.item(filterName);
	  	} catch (e) {
	  		// don't set opacity to 1 if we haven't already set an opacity,
	  		// it isn't needed and breaks transparent pngs.
	  		if (value === 1) { return; }
	  	}
	
	  	value = Math.round(value * 100);
	
	  	if (filter) {
	  		filter.Enabled = (value !== 100);
	  		filter.Opacity = value;
	  	} else {
	  		el.style.filter += ' progid:' + filterName + '(opacity=' + value + ')';
	  	}
	  }
	
	  // @function testProp(props: String[]): String|false
	  // Goes through the array of style names and returns the first name
	  // that is a valid style name for an element. If no such name is found,
	  // it returns false. Useful for vendor-prefixed styles like `transform`.
	  function testProp(props) {
	  	var style = document.documentElement.style;
	
	  	for (var i = 0; i < props.length; i++) {
	  		if (props[i] in style) {
	  			return props[i];
	  		}
	  	}
	  	return false;
	  }
	
	  // @function setTransform(el: HTMLElement, offset: Point, scale?: Number)
	  // Resets the 3D CSS transform of `el` so it is translated by `offset` pixels
	  // and optionally scaled by `scale`. Does not have an effect if the
	  // browser doesn't support 3D CSS transforms.
	  function setTransform(el, offset, scale) {
	  	var pos = offset || new Point(0, 0);
	
	  	el.style[TRANSFORM] =
	  		(Browser.ie3d ?
	  			'translate(' + pos.x + 'px,' + pos.y + 'px)' :
	  			'translate3d(' + pos.x + 'px,' + pos.y + 'px,0)') +
	  		(scale ? ' scale(' + scale + ')' : '');
	  }
	
	  // @function setPosition(el: HTMLElement, position: Point)
	  // Sets the position of `el` to coordinates specified by `position`,
	  // using CSS translate or top/left positioning depending on the browser
	  // (used by Leaflet internally to position its layers).
	  function setPosition(el, point) {
	
	  	/*eslint-disable */
	  	el._leaflet_pos = point;
	  	/* eslint-enable */
	
	  	if (Browser.any3d) {
	  		setTransform(el, point);
	  	} else {
	  		el.style.left = point.x + 'px';
	  		el.style.top = point.y + 'px';
	  	}
	  }
	
	  // @function getPosition(el: HTMLElement): Point
	  // Returns the coordinates of an element previously positioned with setPosition.
	  function getPosition(el) {
	  	// this method is only used for elements previously positioned using setPosition,
	  	// so it's safe to cache the position for performance
	
	  	return el._leaflet_pos || new Point(0, 0);
	  }
	
	  // @function disableTextSelection()
	  // Prevents the user from generating `selectstart` DOM events, usually generated
	  // when the user drags the mouse through a page with text. Used internally
	  // by Leaflet to override the behaviour of any click-and-drag interaction on
	  // the map. Affects drag interactions on the whole document.
	
	  // @function enableTextSelection()
	  // Cancels the effects of a previous [`L.DomUtil.disableTextSelection`](#domutil-disabletextselection).
	  var disableTextSelection;
	  var enableTextSelection;
	  var _userSelect;
	  if ('onselectstart' in document) {
	  	disableTextSelection = function () {
	  		on(window, 'selectstart', preventDefault);
	  	};
	  	enableTextSelection = function () {
	  		off(window, 'selectstart', preventDefault);
	  	};
	  } else {
	  	var userSelectProperty = testProp(
	  		['userSelect', 'WebkitUserSelect', 'OUserSelect', 'MozUserSelect', 'msUserSelect']);
	
	  	disableTextSelection = function () {
	  		if (userSelectProperty) {
	  			var style = document.documentElement.style;
	  			_userSelect = style[userSelectProperty];
	  			style[userSelectProperty] = 'none';
	  		}
	  	};
	  	enableTextSelection = function () {
	  		if (userSelectProperty) {
	  			document.documentElement.style[userSelectProperty] = _userSelect;
	  			_userSelect = undefined;
	  		}
	  	};
	  }
	
	  // @function disableImageDrag()
	  // As [`L.DomUtil.disableTextSelection`](#domutil-disabletextselection), but
	  // for `dragstart` DOM events, usually generated when the user drags an image.
	  function disableImageDrag() {
	  	on(window, 'dragstart', preventDefault);
	  }
	
	  // @function enableImageDrag()
	  // Cancels the effects of a previous [`L.DomUtil.disableImageDrag`](#domutil-disabletextselection).
	  function enableImageDrag() {
	  	off(window, 'dragstart', preventDefault);
	  }
	
	  var _outlineElement, _outlineStyle;
	  // @function preventOutline(el: HTMLElement)
	  // Makes the [outline](https://developer.mozilla.org/docs/Web/CSS/outline)
	  // of the element `el` invisible. Used internally by Leaflet to prevent
	  // focusable elements from displaying an outline when the user performs a
	  // drag interaction on them.
	  function preventOutline(element) {
	  	while (element.tabIndex === -1) {
	  		element = element.parentNode;
	  	}
	  	if (!element.style) { return; }
	  	restoreOutline();
	  	_outlineElement = element;
	  	_outlineStyle = element.style.outlineStyle;
	  	element.style.outlineStyle = 'none';
	  	on(window, 'keydown', restoreOutline);
	  }
	
	  // @function restoreOutline()
	  // Cancels the effects of a previous [`L.DomUtil.preventOutline`]().
	  function restoreOutline() {
	  	if (!_outlineElement) { return; }
	  	_outlineElement.style.outlineStyle = _outlineStyle;
	  	_outlineElement = undefined;
	  	_outlineStyle = undefined;
	  	off(window, 'keydown', restoreOutline);
	  }
	
	  // @function getSizedParentNode(el: HTMLElement): HTMLElement
	  // Finds the closest parent node which size (width and height) is not null.
	  function getSizedParentNode(element) {
	  	do {
	  		element = element.parentNode;
	  	} while ((!element.offsetWidth || !element.offsetHeight) && element !== document.body);
	  	return element;
	  }
	
	  // @function getScale(el: HTMLElement): Object
	  // Computes the CSS scale currently applied on the element.
	  // Returns an object with `x` and `y` members as horizontal and vertical scales respectively,
	  // and `boundingClientRect` as the result of [`getBoundingClientRect()`](https://developer.mozilla.org/en-US/docs/Web/API/Element/getBoundingClientRect).
	  function getScale(element) {
	  	var rect = element.getBoundingClientRect(); // Read-only in old browsers.
	
	  	return {
	  		x: rect.width / element.offsetWidth || 1,
	  		y: rect.height / element.offsetHeight || 1,
	  		boundingClientRect: rect
	  	};
	  }
	
	  var DomUtil = {
	    __proto__: null,
	    TRANSFORM: TRANSFORM,
	    TRANSITION: TRANSITION,
	    TRANSITION_END: TRANSITION_END,
	    get: get,
	    getStyle: getStyle,
	    create: create$1,
	    remove: remove,
	    empty: empty,
	    toFront: toFront,
	    toBack: toBack,
	    hasClass: hasClass,
	    addClass: addClass,
	    removeClass: removeClass,
	    setClass: setClass,
	    getClass: getClass,
	    setOpacity: setOpacity,
	    testProp: testProp,
	    setTransform: setTransform,
	    setPosition: setPosition,
	    getPosition: getPosition,
	    get disableTextSelection () { return disableTextSelection; },
	    get enableTextSelection () { return enableTextSelection; },
	    disableImageDrag: disableImageDrag,
	    enableImageDrag: enableImageDrag,
	    preventOutline: preventOutline,
	    restoreOutline: restoreOutline,
	    getSizedParentNode: getSizedParentNode,
	    getScale: getScale
	  };
	
	  /*
	   * @namespace DomEvent
	   * Utility functions to work with the [DOM events](https://developer.mozilla.org/docs/Web/API/Event), used by Leaflet internally.
	   */
	
	  // Inspired by John Resig, Dean Edwards and YUI addEvent implementations.
	
	  // @function on(el: HTMLElement, types: String, fn: Function, context?: Object): this
	  // Adds a listener function (`fn`) to a particular DOM event type of the
	  // element `el`. You can optionally specify the context of the listener
	  // (object the `this` keyword will point to). You can also pass several
	  // space-separated types (e.g. `'click dblclick'`).
	
	  // @alternative
	  // @function on(el: HTMLElement, eventMap: Object, context?: Object): this
	  // Adds a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
	  function on(obj, types, fn, context) {
	
	  	if (types && typeof types === 'object') {
	  		for (var type in types) {
	  			addOne(obj, type, types[type], fn);
	  		}
	  	} else {
	  		types = splitWords(types);
	
	  		for (var i = 0, len = types.length; i < len; i++) {
	  			addOne(obj, types[i], fn, context);
	  		}
	  	}
	
	  	return this;
	  }
	
	  var eventsKey = '_leaflet_events';
	
	  // @function off(el: HTMLElement, types: String, fn: Function, context?: Object): this
	  // Removes a previously added listener function.
	  // Note that if you passed a custom context to on, you must pass the same
	  // context to `off` in order to remove the listener.
	
	  // @alternative
	  // @function off(el: HTMLElement, eventMap: Object, context?: Object): this
	  // Removes a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
	
	  // @alternative
	  // @function off(el: HTMLElement, types: String): this
	  // Removes all previously added listeners of given types.
	
	  // @alternative
	  // @function off(el: HTMLElement): this
	  // Removes all previously added listeners from given HTMLElement
	  function off(obj, types, fn, context) {
	
	  	if (arguments.length === 1) {
	  		batchRemove(obj);
	  		delete obj[eventsKey];
	
	  	} else if (types && typeof types === 'object') {
	  		for (var type in types) {
	  			removeOne(obj, type, types[type], fn);
	  		}
	
	  	} else {
	  		types = splitWords(types);
	
	  		if (arguments.length === 2) {
	  			batchRemove(obj, function (type) {
	  				return indexOf(types, type) !== -1;
	  			});
	  		} else {
	  			for (var i = 0, len = types.length; i < len; i++) {
	  				removeOne(obj, types[i], fn, context);
	  			}
	  		}
	  	}
	
	  	return this;
	  }
	
	  function batchRemove(obj, filterFn) {
	  	for (var id in obj[eventsKey]) {
	  		var type = id.split(/\d/)[0];
	  		if (!filterFn || filterFn(type)) {
	  			removeOne(obj, type, null, null, id);
	  		}
	  	}
	  }
	
	  var mouseSubst = {
	  	mouseenter: 'mouseover',
	  	mouseleave: 'mouseout',
	  	wheel: !('onwheel' in window) && 'mousewheel'
	  };
	
	  function addOne(obj, type, fn, context) {
	  	var id = type + stamp(fn) + (context ? '_' + stamp(context) : '');
	
	  	if (obj[eventsKey] && obj[eventsKey][id]) { return this; }
	
	  	var handler = function (e) {
	  		return fn.call(context || obj, e || window.event);
	  	};
	
	  	var originalHandler = handler;
	
	  	if (!Browser.touchNative && Browser.pointer && type.indexOf('touch') === 0) {
	  		// Needs DomEvent.Pointer.js
	  		handler = addPointerListener(obj, type, handler);
	
	  	} else if (Browser.touch && (type === 'dblclick')) {
	  		handler = addDoubleTapListener(obj, handler);
	
	  	} else if ('addEventListener' in obj) {
	
	  		if (type === 'touchstart' || type === 'touchmove' || type === 'wheel' ||  type === 'mousewheel') {
	  			obj.addEventListener(mouseSubst[type] || type, handler, Browser.passiveEvents ? {passive: false} : false);
	
	  		} else if (type === 'mouseenter' || type === 'mouseleave') {
	  			handler = function (e) {
	  				e = e || window.event;
	  				if (isExternalTarget(obj, e)) {
	  					originalHandler(e);
	  				}
	  			};
	  			obj.addEventListener(mouseSubst[type], handler, false);
	
	  		} else {
	  			obj.addEventListener(type, originalHandler, false);
	  		}
	
	  	} else {
	  		obj.attachEvent('on' + type, handler);
	  	}
	
	  	obj[eventsKey] = obj[eventsKey] || {};
	  	obj[eventsKey][id] = handler;
	  }
	
	  function removeOne(obj, type, fn, context, id) {
	  	id = id || type + stamp(fn) + (context ? '_' + stamp(context) : '');
	  	var handler = obj[eventsKey] && obj[eventsKey][id];
	
	  	if (!handler) { return this; }
	
	  	if (!Browser.touchNative && Browser.pointer && type.indexOf('touch') === 0) {
	  		removePointerListener(obj, type, handler);
	
	  	} else if (Browser.touch && (type === 'dblclick')) {
	  		removeDoubleTapListener(obj, handler);
	
	  	} else if ('removeEventListener' in obj) {
	
	  		obj.removeEventListener(mouseSubst[type] || type, handler, false);
	
	  	} else {
	  		obj.detachEvent('on' + type, handler);
	  	}
	
	  	obj[eventsKey][id] = null;
	  }
	
	  // @function stopPropagation(ev: DOMEvent): this
	  // Stop the given event from propagation to parent elements. Used inside the listener functions:
	  // ```js
	  // L.DomEvent.on(div, 'click', function (ev) {
	  // 	L.DomEvent.stopPropagation(ev);
	  // });
	  // ```
	  function stopPropagation(e) {
	
	  	if (e.stopPropagation) {
	  		e.stopPropagation();
	  	} else if (e.originalEvent) {  // In case of Leaflet event.
	  		e.originalEvent._stopped = true;
	  	} else {
	  		e.cancelBubble = true;
	  	}
	
	  	return this;
	  }
	
	  // @function disableScrollPropagation(el: HTMLElement): this
	  // Adds `stopPropagation` to the element's `'wheel'` events (plus browser variants).
	  function disableScrollPropagation(el) {
	  	addOne(el, 'wheel', stopPropagation);
	  	return this;
	  }
	
	  // @function disableClickPropagation(el: HTMLElement): this
	  // Adds `stopPropagation` to the element's `'click'`, `'dblclick'`, `'contextmenu'`,
	  // `'mousedown'` and `'touchstart'` events (plus browser variants).
	  function disableClickPropagation(el) {
	  	on(el, 'mousedown touchstart dblclick contextmenu', stopPropagation);
	  	el['_leaflet_disable_click'] = true;
	  	return this;
	  }
	
	  // @function preventDefault(ev: DOMEvent): this
	  // Prevents the default action of the DOM Event `ev` from happening (such as
	  // following a link in the href of the a element, or doing a POST request
	  // with page reload when a `<form>` is submitted).
	  // Use it inside listener functions.
	  function preventDefault(e) {
	  	if (e.preventDefault) {
	  		e.preventDefault();
	  	} else {
	  		e.returnValue = false;
	  	}
	  	return this;
	  }
	
	  // @function stop(ev: DOMEvent): this
	  // Does `stopPropagation` and `preventDefault` at the same time.
	  function stop(e) {
	  	preventDefault(e);
	  	stopPropagation(e);
	  	return this;
	  }
	
	  // @function getPropagationPath(ev: DOMEvent): Array
	  // Compatibility polyfill for [`Event.composedPath()`](https://developer.mozilla.org/en-US/docs/Web/API/Event/composedPath).
	  // Returns an array containing the `HTMLElement`s that the given DOM event
	  // should propagate to (if not stopped).
	  function getPropagationPath(ev) {
	  	if (ev.composedPath) {
	  		return ev.composedPath();
	  	}
	
	  	var path = [];
	  	var el = ev.target;
	
	  	while (el) {
	  		path.push(el);
	  		el = el.parentNode;
	  	}
	  	return path;
	  }
	
	
	  // @function getMousePosition(ev: DOMEvent, container?: HTMLElement): Point
	  // Gets normalized mouse position from a DOM event relative to the
	  // `container` (border excluded) or to the whole page if not specified.
	  function getMousePosition(e, container) {
	  	if (!container) {
	  		return new Point(e.clientX, e.clientY);
	  	}
	
	  	var scale = getScale(container),
	  	    offset = scale.boundingClientRect; // left and top  values are in page scale (like the event clientX/Y)
	
	  	return new Point(
	  		// offset.left/top values are in page scale (like clientX/Y),
	  		// whereas clientLeft/Top (border width) values are the original values (before CSS scale applies).
	  		(e.clientX - offset.left) / scale.x - container.clientLeft,
	  		(e.clientY - offset.top) / scale.y - container.clientTop
	  	);
	  }
	
	
	  //  except , Safari and
	  // We need double the scroll pixels (see #7403 and #4538) for all Browsers
	  // except OSX (Mac) -> 3x, Chrome running on Linux 1x
	
	  var wheelPxFactor =
	  	(Browser.linux && Browser.chrome) ? window.devicePixelRatio :
	  	Browser.mac ? window.devicePixelRatio * 3 :
	  	window.devicePixelRatio > 0 ? 2 * window.devicePixelRatio : 1;
	  // @function getWheelDelta(ev: DOMEvent): Number
	  // Gets normalized wheel delta from a wheel DOM event, in vertical
	  // pixels scrolled (negative if scrolling down).
	  // Events from pointing devices without precise scrolling are mapped to
	  // a best guess of 60 pixels.
	  function getWheelDelta(e) {
	  	return (Browser.edge) ? e.wheelDeltaY / 2 : // Don't trust window-geometry-based delta
	  	       (e.deltaY && e.deltaMode === 0) ? -e.deltaY / wheelPxFactor : // Pixels
	  	       (e.deltaY && e.deltaMode === 1) ? -e.deltaY * 20 : // Lines
	  	       (e.deltaY && e.deltaMode === 2) ? -e.deltaY * 60 : // Pages
	  	       (e.deltaX || e.deltaZ) ? 0 :	// Skip horizontal/depth wheel events
	  	       e.wheelDelta ? (e.wheelDeltaY || e.wheelDelta) / 2 : // Legacy IE pixels
	  	       (e.detail && Math.abs(e.detail) < 32765) ? -e.detail * 20 : // Legacy Moz lines
	  	       e.detail ? e.detail / -32765 * 60 : // Legacy Moz pages
	  	       0;
	  }
	
	  // check if element really left/entered the event target (for mouseenter/mouseleave)
	  function isExternalTarget(el, e) {
	
	  	var related = e.relatedTarget;
	
	  	if (!related) { return true; }
	
	  	try {
	  		while (related && (related !== el)) {
	  			related = related.parentNode;
	  		}
	  	} catch (err) {
	  		return false;
	  	}
	  	return (related !== el);
	  }
	
	  var DomEvent = {
	    __proto__: null,
	    on: on,
	    off: off,
	    stopPropagation: stopPropagation,
	    disableScrollPropagation: disableScrollPropagation,
	    disableClickPropagation: disableClickPropagation,
	    preventDefault: preventDefault,
	    stop: stop,
	    getPropagationPath: getPropagationPath,
	    getMousePosition: getMousePosition,
	    getWheelDelta: getWheelDelta,
	    isExternalTarget: isExternalTarget,
	    addListener: on,
	    removeListener: off
	  };
	
	  /*
	   * @class PosAnimation
	   * @aka L.PosAnimation
	   * @inherits Evented
	   * Used internally for panning animations, utilizing CSS3 Transitions for modern browsers and a timer fallback for IE6-9.
	   *
	   * @example
	   * ```js
	   * var myPositionMarker = L.marker([48.864716, 2.294694]).addTo(map);
	   *
	   * myPositionMarker.on("click", function() {
	   * 	var pos = map.latLngToLayerPoint(myPositionMarker.getLatLng());
	   * 	pos.y -= 25;
	   * 	var fx = new L.PosAnimation();
	   *
	   * 	fx.once('end',function() {
	   * 		pos.y += 25;
	   * 		fx.run(myPositionMarker._icon, pos, 0.8);
	   * 	});
	   *
	   * 	fx.run(myPositionMarker._icon, pos, 0.3);
	   * });
	   *
	   * ```
	   *
	   * @constructor L.PosAnimation()
	   * Creates a `PosAnimation` object.
	   *
	   */
	
	  var PosAnimation = Evented.extend({
	
	  	// @method run(el: HTMLElement, newPos: Point, duration?: Number, easeLinearity?: Number)
	  	// Run an animation of a given element to a new position, optionally setting
	  	// duration in seconds (`0.25` by default) and easing linearity factor (3rd
	  	// argument of the [cubic bezier curve](https://cubic-bezier.com/#0,0,.5,1),
	  	// `0.5` by default).
	  	run: function (el, newPos, duration, easeLinearity) {
	  		this.stop();
	
	  		this._el = el;
	  		this._inProgress = true;
	  		this._duration = duration || 0.25;
	  		this._easeOutPower = 1 / Math.max(easeLinearity || 0.5, 0.2);
	
	  		this._startPos = getPosition(el);
	  		this._offset = newPos.subtract(this._startPos);
	  		this._startTime = +new Date();
	
	  		// @event start: Event
	  		// Fired when the animation starts
	  		this.fire('start');
	
	  		this._animate();
	  	},
	
	  	// @method stop()
	  	// Stops the animation (if currently running).
	  	stop: function () {
	  		if (!this._inProgress) { return; }
	
	  		this._step(true);
	  		this._complete();
	  	},
	
	  	_animate: function () {
	  		// animation loop
	  		this._animId = requestAnimFrame(this._animate, this);
	  		this._step();
	  	},
	
	  	_step: function (round) {
	  		var elapsed = (+new Date()) - this._startTime,
	  		    duration = this._duration * 1000;
	
	  		if (elapsed < duration) {
	  			this._runFrame(this._easeOut(elapsed / duration), round);
	  		} else {
	  			this._runFrame(1);
	  			this._complete();
	  		}
	  	},
	
	  	_runFrame: function (progress, round) {
	  		var pos = this._startPos.add(this._offset.multiplyBy(progress));
	  		if (round) {
	  			pos._round();
	  		}
	  		setPosition(this._el, pos);
	
	  		// @event step: Event
	  		// Fired continuously during the animation.
	  		this.fire('step');
	  	},
	
	  	_complete: function () {
	  		cancelAnimFrame(this._animId);
	
	  		this._inProgress = false;
	  		// @event end: Event
	  		// Fired when the animation ends.
	  		this.fire('end');
	  	},
	
	  	_easeOut: function (t) {
	  		return 1 - Math.pow(1 - t, this._easeOutPower);
	  	}
	  });
	
	  /*
	   * @class Map
	   * @aka L.Map
	   * @inherits Evented
	   *
	   * The central class of the API — it is used to create a map on a page and manipulate it.
	   *
	   * @example
	   *
	   * ```js
	   * // initialize the map on the "map" div with a given center and zoom
	   * var map = L.map('map', {
	   * 	center: [51.505, -0.09],
	   * 	zoom: 13
	   * });
	   * ```
	   *
	   */
	
	  var Map = Evented.extend({
	
	  	options: {
	  		// @section Map State Options
	  		// @option crs: CRS = L.CRS.EPSG3857
	  		// The [Coordinate Reference System](#crs) to use. Don't change this if you're not
	  		// sure what it means.
	  		crs: EPSG3857,
	
	  		// @option center: LatLng = undefined
	  		// Initial geographic center of the map
	  		center: undefined,
	
	  		// @option zoom: Number = undefined
	  		// Initial map zoom level
	  		zoom: undefined,
	
	  		// @option minZoom: Number = *
	  		// Minimum zoom level of the map.
	  		// If not specified and at least one `GridLayer` or `TileLayer` is in the map,
	  		// the lowest of their `minZoom` options will be used instead.
	  		minZoom: undefined,
	
	  		// @option maxZoom: Number = *
	  		// Maximum zoom level of the map.
	  		// If not specified and at least one `GridLayer` or `TileLayer` is in the map,
	  		// the highest of their `maxZoom` options will be used instead.
	  		maxZoom: undefined,
	
	  		// @option layers: Layer[] = []
	  		// Array of layers that will be added to the map initially
	  		layers: [],
	
	  		// @option maxBounds: LatLngBounds = null
	  		// When this option is set, the map restricts the view to the given
	  		// geographical bounds, bouncing the user back if the user tries to pan
	  		// outside the view. To set the restriction dynamically, use
	  		// [`setMaxBounds`](#map-setmaxbounds) method.
	  		maxBounds: undefined,
	
	  		// @option renderer: Renderer = *
	  		// The default method for drawing vector layers on the map. `L.SVG`
	  		// or `L.Canvas` by default depending on browser support.
	  		renderer: undefined,
	
	
	  		// @section Animation Options
	  		// @option zoomAnimation: Boolean = true
	  		// Whether the map zoom animation is enabled. By default it's enabled
	  		// in all browsers that support CSS3 Transitions except Android.
	  		zoomAnimation: true,
	
	  		// @option zoomAnimationThreshold: Number = 4
	  		// Won't animate zoom if the zoom difference exceeds this value.
	  		zoomAnimationThreshold: 4,
	
	  		// @option fadeAnimation: Boolean = true
	  		// Whether the tile fade animation is enabled. By default it's enabled
	  		// in all browsers that support CSS3 Transitions except Android.
	  		fadeAnimation: true,
	
	  		// @option markerZoomAnimation: Boolean = true
	  		// Whether markers animate their zoom with the zoom animation, if disabled
	  		// they will disappear for the length of the animation. By default it's
	  		// enabled in all browsers that support CSS3 Transitions except Android.
	  		markerZoomAnimation: true,
	
	  		// @option transform3DLimit: Number = 2^23
	  		// Defines the maximum size of a CSS translation transform. The default
	  		// value should not be changed unless a web browser positions layers in
	  		// the wrong place after doing a large `panBy`.
	  		transform3DLimit: 8388608, // Precision limit of a 32-bit float
	
	  		// @section Interaction Options
	  		// @option zoomSnap: Number = 1
	  		// Forces the map's zoom level to always be a multiple of this, particularly
	  		// right after a [`fitBounds()`](#map-fitbounds) or a pinch-zoom.
	  		// By default, the zoom level snaps to the nearest integer; lower values
	  		// (e.g. `0.5` or `0.1`) allow for greater granularity. A value of `0`
	  		// means the zoom level will not be snapped after `fitBounds` or a pinch-zoom.
	  		zoomSnap: 1,
	
	  		// @option zoomDelta: Number = 1
	  		// Controls how much the map's zoom level will change after a
	  		// [`zoomIn()`](#map-zoomin), [`zoomOut()`](#map-zoomout), pressing `+`
	  		// or `-` on the keyboard, or using the [zoom controls](#control-zoom).
	  		// Values smaller than `1` (e.g. `0.5`) allow for greater granularity.
	  		zoomDelta: 1,
	
	  		// @option trackResize: Boolean = true
	  		// Whether the map automatically handles browser window resize to update itself.
	  		trackResize: true
	  	},
	
	  	initialize: function (id, options) { // (HTMLElement or String, Object)
	  		options = setOptions(this, options);
	
	  		// Make sure to assign internal flags at the beginning,
	  		// to avoid inconsistent state in some edge cases.
	  		this._handlers = [];
	  		this._layers = {};
	  		this._zoomBoundLayers = {};
	  		this._sizeChanged = true;
	
	  		this._initContainer(id);
	  		this._initLayout();
	
	  		// hack for https://github.com/Leaflet/Leaflet/issues/1980
	  		this._onResize = bind(this._onResize, this);
	
	  		this._initEvents();
	
	  		if (options.maxBounds) {
	  			this.setMaxBounds(options.maxBounds);
	  		}
	
	  		if (options.zoom !== undefined) {
	  			this._zoom = this._limitZoom(options.zoom);
	  		}
	
	  		if (options.center && options.zoom !== undefined) {
	  			this.setView(toLatLng(options.center), options.zoom, {reset: true});
	  		}
	
	  		this.callInitHooks();
	
	  		// don't animate on browsers without hardware-accelerated transitions or old Android/Opera
	  		this._zoomAnimated = TRANSITION && Browser.any3d && !Browser.mobileOpera &&
	  				this.options.zoomAnimation;
	
	  		// zoom transitions run with the same duration for all layers, so if one of transitionend events
	  		// happens after starting zoom animation (propagating to the map pane), we know that it ended globally
	  		if (this._zoomAnimated) {
	  			this._createAnimProxy();
	  			on(this._proxy, TRANSITION_END, this._catchTransitionEnd, this);
	  		}
	
	  		this._addLayers(this.options.layers);
	  	},
	
	
	  	// @section Methods for modifying map state
	
	  	// @method setView(center: LatLng, zoom: Number, options?: Zoom/pan options): this
	  	// Sets the view of the map (geographical center and zoom) with the given
	  	// animation options.
	  	setView: function (center, zoom, options) {
	
	  		zoom = zoom === undefined ? this._zoom : this._limitZoom(zoom);
	  		center = this._limitCenter(toLatLng(center), zoom, this.options.maxBounds);
	  		options = options || {};
	
	  		this._stop();
	
	  		if (this._loaded && !options.reset && options !== true) {
	
	  			if (options.animate !== undefined) {
	  				options.zoom = extend({animate: options.animate}, options.zoom);
	  				options.pan = extend({animate: options.animate, duration: options.duration}, options.pan);
	  			}
	
	  			// try animating pan or zoom
	  			var moved = (this._zoom !== zoom) ?
	  				this._tryAnimatedZoom && this._tryAnimatedZoom(center, zoom, options.zoom) :
	  				this._tryAnimatedPan(center, options.pan);
	
	  			if (moved) {
	  				// prevent resize handler call, the view will refresh after animation anyway
	  				clearTimeout(this._sizeTimer);
	  				return this;
	  			}
	  		}
	
	  		// animation didn't start, just reset the map view
	  		this._resetView(center, zoom, options.pan && options.pan.noMoveStart);
	
	  		return this;
	  	},
	
	  	// @method setZoom(zoom: Number, options?: Zoom/pan options): this
	  	// Sets the zoom of the map.
	  	setZoom: function (zoom, options) {
	  		if (!this._loaded) {
	  			this._zoom = zoom;
	  			return this;
	  		}
	  		return this.setView(this.getCenter(), zoom, {zoom: options});
	  	},
	
	  	// @method zoomIn(delta?: Number, options?: Zoom options): this
	  	// Increases the zoom of the map by `delta` ([`zoomDelta`](#map-zoomdelta) by default).
	  	zoomIn: function (delta, options) {
	  		delta = delta || (Browser.any3d ? this.options.zoomDelta : 1);
	  		return this.setZoom(this._zoom + delta, options);
	  	},
	
	  	// @method zoomOut(delta?: Number, options?: Zoom options): this
	  	// Decreases the zoom of the map by `delta` ([`zoomDelta`](#map-zoomdelta) by default).
	  	zoomOut: function (delta, options) {
	  		delta = delta || (Browser.any3d ? this.options.zoomDelta : 1);
	  		return this.setZoom(this._zoom - delta, options);
	  	},
	
	  	// @method setZoomAround(latlng: LatLng, zoom: Number, options: Zoom options): this
	  	// Zooms the map while keeping a specified geographical point on the map
	  	// stationary (e.g. used internally for scroll zoom and double-click zoom).
	  	// @alternative
	  	// @method setZoomAround(offset: Point, zoom: Number, options: Zoom options): this
	  	// Zooms the map while keeping a specified pixel on the map (relative to the top-left corner) stationary.
	  	setZoomAround: function (latlng, zoom, options) {
	  		var scale = this.getZoomScale(zoom),
	  		    viewHalf = this.getSize().divideBy(2),
	  		    containerPoint = latlng instanceof Point ? latlng : this.latLngToContainerPoint(latlng),
	
	  		    centerOffset = containerPoint.subtract(viewHalf).multiplyBy(1 - 1 / scale),
	  		    newCenter = this.containerPointToLatLng(viewHalf.add(centerOffset));
	
	  		return this.setView(newCenter, zoom, {zoom: options});
	  	},
	
	  	_getBoundsCenterZoom: function (bounds, options) {
	
	  		options = options || {};
	  		bounds = bounds.getBounds ? bounds.getBounds() : toLatLngBounds(bounds);
	
	  		var paddingTL = toPoint(options.paddingTopLeft || options.padding || [0, 0]),
	  		    paddingBR = toPoint(options.paddingBottomRight || options.padding || [0, 0]),
	
	  		    zoom = this.getBoundsZoom(bounds, false, paddingTL.add(paddingBR));
	
	  		zoom = (typeof options.maxZoom === 'number') ? Math.min(options.maxZoom, zoom) : zoom;
	
	  		if (zoom === Infinity) {
	  			return {
	  				center: bounds.getCenter(),
	  				zoom: zoom
	  			};
	  		}
	
	  		var paddingOffset = paddingBR.subtract(paddingTL).divideBy(2),
	
	  		    swPoint = this.project(bounds.getSouthWest(), zoom),
	  		    nePoint = this.project(bounds.getNorthEast(), zoom),
	  		    center = this.unproject(swPoint.add(nePoint).divideBy(2).add(paddingOffset), zoom);
	
	  		return {
	  			center: center,
	  			zoom: zoom
	  		};
	  	},
	
	  	// @method fitBounds(bounds: LatLngBounds, options?: fitBounds options): this
	  	// Sets a map view that contains the given geographical bounds with the
	  	// maximum zoom level possible.
	  	fitBounds: function (bounds, options) {
	
	  		bounds = toLatLngBounds(bounds);
	
	  		if (!bounds.isValid()) {
	  			throw new Error('Bounds are not valid.');
	  		}
	
	  		var target = this._getBoundsCenterZoom(bounds, options);
	  		return this.setView(target.center, target.zoom, options);
	  	},
	
	  	// @method fitWorld(options?: fitBounds options): this
	  	// Sets a map view that mostly contains the whole world with the maximum
	  	// zoom level possible.
	  	fitWorld: function (options) {
	  		return this.fitBounds([[-90, -180], [90, 180]], options);
	  	},
	
	  	// @method panTo(latlng: LatLng, options?: Pan options): this
	  	// Pans the map to a given center.
	  	panTo: function (center, options) { // (LatLng)
	  		return this.setView(center, this._zoom, {pan: options});
	  	},
	
	  	// @method panBy(offset: Point, options?: Pan options): this
	  	// Pans the map by a given number of pixels (animated).
	  	panBy: function (offset, options) {
	  		offset = toPoint(offset).round();
	  		options = options || {};
	
	  		if (!offset.x && !offset.y) {
	  			return this.fire('moveend');
	  		}
	  		// If we pan too far, Chrome gets issues with tiles
	  		// and makes them disappear or appear in the wrong place (slightly offset) #2602
	  		if (options.animate !== true && !this.getSize().contains(offset)) {
	  			this._resetView(this.unproject(this.project(this.getCenter()).add(offset)), this.getZoom());
	  			return this;
	  		}
	
	  		if (!this._panAnim) {
	  			this._panAnim = new PosAnimation();
	
	  			this._panAnim.on({
	  				'step': this._onPanTransitionStep,
	  				'end': this._onPanTransitionEnd
	  			}, this);
	  		}
	
	  		// don't fire movestart if animating inertia
	  		if (!options.noMoveStart) {
	  			this.fire('movestart');
	  		}
	
	  		// animate pan unless animate: false specified
	  		if (options.animate !== false) {
	  			addClass(this._mapPane, 'leaflet-pan-anim');
	
	  			var newPos = this._getMapPanePos().subtract(offset).round();
	  			this._panAnim.run(this._mapPane, newPos, options.duration || 0.25, options.easeLinearity);
	  		} else {
	  			this._rawPanBy(offset);
	  			this.fire('move').fire('moveend');
	  		}
	
	  		return this;
	  	},
	
	  	// @method flyTo(latlng: LatLng, zoom?: Number, options?: Zoom/pan options): this
	  	// Sets the view of the map (geographical center and zoom) performing a smooth
	  	// pan-zoom animation.
	  	flyTo: function (targetCenter, targetZoom, options) {
	
	  		options = options || {};
	  		if (options.animate === false || !Browser.any3d) {
	  			return this.setView(targetCenter, targetZoom, options);
	  		}
	
	  		this._stop();
	
	  		var from = this.project(this.getCenter()),
	  		    to = this.project(targetCenter),
	  		    size = this.getSize(),
	  		    startZoom = this._zoom;
	
	  		targetCenter = toLatLng(targetCenter);
	  		targetZoom = targetZoom === undefined ? startZoom : targetZoom;
	
	  		var w0 = Math.max(size.x, size.y),
	  		    w1 = w0 * this.getZoomScale(startZoom, targetZoom),
	  		    u1 = (to.distanceTo(from)) || 1,
	  		    rho = 1.42,
	  		    rho2 = rho * rho;
	
	  		function r(i) {
	  			var s1 = i ? -1 : 1,
	  			    s2 = i ? w1 : w0,
	  			    t1 = w1 * w1 - w0 * w0 + s1 * rho2 * rho2 * u1 * u1,
	  			    b1 = 2 * s2 * rho2 * u1,
	  			    b = t1 / b1,
	  			    sq = Math.sqrt(b * b + 1) - b;
	
	  			    // workaround for floating point precision bug when sq = 0, log = -Infinite,
	  			    // thus triggering an infinite loop in flyTo
	  			    var log = sq < 0.000000001 ? -18 : Math.log(sq);
	
	  			return log;
	  		}
	
	  		function sinh(n) { return (Math.exp(n) - Math.exp(-n)) / 2; }
	  		function cosh(n) { return (Math.exp(n) + Math.exp(-n)) / 2; }
	  		function tanh(n) { return sinh(n) / cosh(n); }
	
	  		var r0 = r(0);
	
	  		function w(s) { return w0 * (cosh(r0) / cosh(r0 + rho * s)); }
	  		function u(s) { return w0 * (cosh(r0) * tanh(r0 + rho * s) - sinh(r0)) / rho2; }
	
	  		function easeOut(t) { return 1 - Math.pow(1 - t, 1.5); }
	
	  		var start = Date.now(),
	  		    S = (r(1) - r0) / rho,
	  		    duration = options.duration ? 1000 * options.duration : 1000 * S * 0.8;
	
	  		function frame() {
	  			var t = (Date.now() - start) / duration,
	  			    s = easeOut(t) * S;
	
	  			if (t <= 1) {
	  				this._flyToFrame = requestAnimFrame(frame, this);
	
	  				this._move(
	  					this.unproject(from.add(to.subtract(from).multiplyBy(u(s) / u1)), startZoom),
	  					this.getScaleZoom(w0 / w(s), startZoom),
	  					{flyTo: true});
	
	  			} else {
	  				this
	  					._move(targetCenter, targetZoom)
	  					._moveEnd(true);
	  			}
	  		}
	
	  		this._moveStart(true, options.noMoveStart);
	
	  		frame.call(this);
	  		return this;
	  	},
	
	  	// @method flyToBounds(bounds: LatLngBounds, options?: fitBounds options): this
	  	// Sets the view of the map with a smooth animation like [`flyTo`](#map-flyto),
	  	// but takes a bounds parameter like [`fitBounds`](#map-fitbounds).
	  	flyToBounds: function (bounds, options) {
	  		var target = this._getBoundsCenterZoom(bounds, options);
	  		return this.flyTo(target.center, target.zoom, options);
	  	},
	
	  	// @method setMaxBounds(bounds: LatLngBounds): this
	  	// Restricts the map view to the given bounds (see the [maxBounds](#map-maxbounds) option).
	  	setMaxBounds: function (bounds) {
	  		bounds = toLatLngBounds(bounds);
	
	  		if (this.listens('moveend', this._panInsideMaxBounds)) {
	  			this.off('moveend', this._panInsideMaxBounds);
	  		}
	
	  		if (!bounds.isValid()) {
	  			this.options.maxBounds = null;
	  			return this;
	  		}
	
	  		this.options.maxBounds = bounds;
	
	  		if (this._loaded) {
	  			this._panInsideMaxBounds();
	  		}
	
	  		return this.on('moveend', this._panInsideMaxBounds);
	  	},
	
	  	// @method setMinZoom(zoom: Number): this
	  	// Sets the lower limit for the available zoom levels (see the [minZoom](#map-minzoom) option).
	  	setMinZoom: function (zoom) {
	  		var oldZoom = this.options.minZoom;
	  		this.options.minZoom = zoom;
	
	  		if (this._loaded && oldZoom !== zoom) {
	  			this.fire('zoomlevelschange');
	
	  			if (this.getZoom() < this.options.minZoom) {
	  				return this.setZoom(zoom);
	  			}
	  		}
	
	  		return this;
	  	},
	
	  	// @method setMaxZoom(zoom: Number): this
	  	// Sets the upper limit for the available zoom levels (see the [maxZoom](#map-maxzoom) option).
	  	setMaxZoom: function (zoom) {
	  		var oldZoom = this.options.maxZoom;
	  		this.options.maxZoom = zoom;
	
	  		if (this._loaded && oldZoom !== zoom) {
	  			this.fire('zoomlevelschange');
	
	  			if (this.getZoom() > this.options.maxZoom) {
	  				return this.setZoom(zoom);
	  			}
	  		}
	
	  		return this;
	  	},
	
	  	// @method panInsideBounds(bounds: LatLngBounds, options?: Pan options): this
	  	// Pans the map to the closest view that would lie inside the given bounds (if it's not already), controlling the animation using the options specific, if any.
	  	panInsideBounds: function (bounds, options) {
	  		this._enforcingBounds = true;
	  		var center = this.getCenter(),
	  		    newCenter = this._limitCenter(center, this._zoom, toLatLngBounds(bounds));
	
	  		if (!center.equals(newCenter)) {
	  			this.panTo(newCenter, options);
	  		}
	
	  		this._enforcingBounds = false;
	  		return this;
	  	},
	
	  	// @method panInside(latlng: LatLng, options?: padding options): this
	  	// Pans the map the minimum amount to make the `latlng` visible. Use
	  	// padding options to fit the display to more restricted bounds.
	  	// If `latlng` is already within the (optionally padded) display bounds,
	  	// the map will not be panned.
	  	panInside: function (latlng, options) {
	  		options = options || {};
	
	  		var paddingTL = toPoint(options.paddingTopLeft || options.padding || [0, 0]),
	  		    paddingBR = toPoint(options.paddingBottomRight || options.padding || [0, 0]),
	  		    pixelCenter = this.project(this.getCenter()),
	  		    pixelPoint = this.project(latlng),
	  		    pixelBounds = this.getPixelBounds(),
	  		    paddedBounds = toBounds([pixelBounds.min.add(paddingTL), pixelBounds.max.subtract(paddingBR)]),
	  		    paddedSize = paddedBounds.getSize();
	
	  		if (!paddedBounds.contains(pixelPoint)) {
	  			this._enforcingBounds = true;
	  			var centerOffset = pixelPoint.subtract(paddedBounds.getCenter());
	  			var offset = paddedBounds.extend(pixelPoint).getSize().subtract(paddedSize);
	  			pixelCenter.x += centerOffset.x < 0 ? -offset.x : offset.x;
	  			pixelCenter.y += centerOffset.y < 0 ? -offset.y : offset.y;
	  			this.panTo(this.unproject(pixelCenter), options);
	  			this._enforcingBounds = false;
	  		}
	  		return this;
	  	},
	
	  	// @method invalidateSize(options: Zoom/pan options): this
	  	// Checks if the map container size changed and updates the map if so —
	  	// call it after you've changed the map size dynamically, also animating
	  	// pan by default. If `options.pan` is `false`, panning will not occur.
	  	// If `options.debounceMoveend` is `true`, it will delay `moveend` event so
	  	// that it doesn't happen often even if the method is called many
	  	// times in a row.
	
	  	// @alternative
	  	// @method invalidateSize(animate: Boolean): this
	  	// Checks if the map container size changed and updates the map if so —
	  	// call it after you've changed the map size dynamically, also animating
	  	// pan by default.
	  	invalidateSize: function (options) {
	  		if (!this._loaded) { return this; }
	
	  		options = extend({
	  			animate: false,
	  			pan: true
	  		}, options === true ? {animate: true} : options);
	
	  		var oldSize = this.getSize();
	  		this._sizeChanged = true;
	  		this._lastCenter = null;
	
	  		var newSize = this.getSize(),
	  		    oldCenter = oldSize.divideBy(2).round(),
	  		    newCenter = newSize.divideBy(2).round(),
	  		    offset = oldCenter.subtract(newCenter);
	
	  		if (!offset.x && !offset.y) { return this; }
	
	  		if (options.animate && options.pan) {
	  			this.panBy(offset);
	
	  		} else {
	  			if (options.pan) {
	  				this._rawPanBy(offset);
	  			}
	
	  			this.fire('move');
	
	  			if (options.debounceMoveend) {
	  				clearTimeout(this._sizeTimer);
	  				this._sizeTimer = setTimeout(bind(this.fire, this, 'moveend'), 200);
	  			} else {
	  				this.fire('moveend');
	  			}
	  		}
	
	  		// @section Map state change events
	  		// @event resize: ResizeEvent
	  		// Fired when the map is resized.
	  		return this.fire('resize', {
	  			oldSize: oldSize,
	  			newSize: newSize
	  		});
	  	},
	
	  	// @section Methods for modifying map state
	  	// @method stop(): this
	  	// Stops the currently running `panTo` or `flyTo` animation, if any.
	  	stop: function () {
	  		this.setZoom(this._limitZoom(this._zoom));
	  		if (!this.options.zoomSnap) {
	  			this.fire('viewreset');
	  		}
	  		return this._stop();
	  	},
	
	  	// @section Geolocation methods
	  	// @method locate(options?: Locate options): this
	  	// Tries to locate the user using the Geolocation API, firing a [`locationfound`](#map-locationfound)
	  	// event with location data on success or a [`locationerror`](#map-locationerror) event on failure,
	  	// and optionally sets the map view to the user's location with respect to
	  	// detection accuracy (or to the world view if geolocation failed).
	  	// Note that, if your page doesn't use HTTPS, this method will fail in
	  	// modern browsers ([Chrome 50 and newer](https://sites.google.com/a/chromium.org/dev/Home/chromium-security/deprecating-powerful-features-on-insecure-origins))
	  	// See `Locate options` for more details.
	  	locate: function (options) {
	
	  		options = this._locateOptions = extend({
	  			timeout: 10000,
	  			watch: false
	  			// setView: false
	  			// maxZoom: <Number>
	  			// maximumAge: 0
	  			// enableHighAccuracy: false
	  		}, options);
	
	  		if (!('geolocation' in navigator)) {
	  			this._handleGeolocationError({
	  				code: 0,
	  				message: 'Geolocation not supported.'
	  			});
	  			return this;
	  		}
	
	  		var onResponse = bind(this._handleGeolocationResponse, this),
	  		    onError = bind(this._handleGeolocationError, this);
	
	  		if (options.watch) {
	  			this._locationWatchId =
	  			        navigator.geolocation.watchPosition(onResponse, onError, options);
	  		} else {
	  			navigator.geolocation.getCurrentPosition(onResponse, onError, options);
	  		}
	  		return this;
	  	},
	
	  	// @method stopLocate(): this
	  	// Stops watching location previously initiated by `map.locate({watch: true})`
	  	// and aborts resetting the map view if map.locate was called with
	  	// `{setView: true}`.
	  	stopLocate: function () {
	  		if (navigator.geolocation && navigator.geolocation.clearWatch) {
	  			navigator.geolocation.clearWatch(this._locationWatchId);
	  		}
	  		if (this._locateOptions) {
	  			this._locateOptions.setView = false;
	  		}
	  		return this;
	  	},
	
	  	_handleGeolocationError: function (error) {
	  		if (!this._container._leaflet_id) { return; }
	
	  		var c = error.code,
	  		    message = error.message ||
	  		            (c === 1 ? 'permission denied' :
	  		            (c === 2 ? 'position unavailable' : 'timeout'));
	
	  		if (this._locateOptions.setView && !this._loaded) {
	  			this.fitWorld();
	  		}
	
	  		// @section Location events
	  		// @event locationerror: ErrorEvent
	  		// Fired when geolocation (using the [`locate`](#map-locate) method) failed.
	  		this.fire('locationerror', {
	  			code: c,
	  			message: 'Geolocation error: ' + message + '.'
	  		});
	  	},
	
	  	_handleGeolocationResponse: function (pos) {
	  		if (!this._container._leaflet_id) { return; }
	
	  		var lat = pos.coords.latitude,
	  		    lng = pos.coords.longitude,
	  		    latlng = new LatLng(lat, lng),
	  		    bounds = latlng.toBounds(pos.coords.accuracy * 2),
	  		    options = this._locateOptions;
	
	  		if (options.setView) {
	  			var zoom = this.getBoundsZoom(bounds);
	  			this.setView(latlng, options.maxZoom ? Math.min(zoom, options.maxZoom) : zoom);
	  		}
	
	  		var data = {
	  			latlng: latlng,
	  			bounds: bounds,
	  			timestamp: pos.timestamp
	  		};
	
	  		for (var i in pos.coords) {
	  			if (typeof pos.coords[i] === 'number') {
	  				data[i] = pos.coords[i];
	  			}
	  		}
	
	  		// @event locationfound: LocationEvent
	  		// Fired when geolocation (using the [`locate`](#map-locate) method)
	  		// went successfully.
	  		this.fire('locationfound', data);
	  	},
	
	  	// TODO Appropriate docs section?
	  	// @section Other Methods
	  	// @method addHandler(name: String, HandlerClass: Function): this
	  	// Adds a new `Handler` to the map, given its name and constructor function.
	  	addHandler: function (name, HandlerClass) {
	  		if (!HandlerClass) { return this; }
	
	  		var handler = this[name] = new HandlerClass(this);
	
	  		this._handlers.push(handler);
	
	  		if (this.options[name]) {
	  			handler.enable();
	  		}
	
	  		return this;
	  	},
	
	  	// @method remove(): this
	  	// Destroys the map and clears all related event listeners.
	  	remove: function () {
	
	  		this._initEvents(true);
	  		if (this.options.maxBounds) { this.off('moveend', this._panInsideMaxBounds); }
	
	  		if (this._containerId !== this._container._leaflet_id) {
	  			throw new Error('Map container is being reused by another instance');
	  		}
	
	  		try {
	  			// throws error in IE6-8
	  			delete this._container._leaflet_id;
	  			delete this._containerId;
	  		} catch (e) {
	  			/*eslint-disable */
	  			this._container._leaflet_id = undefined;
	  			/* eslint-enable */
	  			this._containerId = undefined;
	  		}
	
	  		if (this._locationWatchId !== undefined) {
	  			this.stopLocate();
	  		}
	
	  		this._stop();
	
	  		remove(this._mapPane);
	
	  		if (this._clearControlPos) {
	  			this._clearControlPos();
	  		}
	  		if (this._resizeRequest) {
	  			cancelAnimFrame(this._resizeRequest);
	  			this._resizeRequest = null;
	  		}
	
	  		this._clearHandlers();
	
	  		if (this._loaded) {
	  			// @section Map state change events
	  			// @event unload: Event
	  			// Fired when the map is destroyed with [remove](#map-remove) method.
	  			this.fire('unload');
	  		}
	
	  		var i;
	  		for (i in this._layers) {
	  			this._layers[i].remove();
	  		}
	  		for (i in this._panes) {
	  			remove(this._panes[i]);
	  		}
	
	  		this._layers = [];
	  		this._panes = [];
	  		delete this._mapPane;
	  		delete this._renderer;
	
	  		return this;
	  	},
	
	  	// @section Other Methods
	  	// @method createPane(name: String, container?: HTMLElement): HTMLElement
	  	// Creates a new [map pane](#map-pane) with the given name if it doesn't exist already,
	  	// then returns it. The pane is created as a child of `container`, or
	  	// as a child of the main map pane if not set.
	  	createPane: function (name, container) {
	  		var className = 'leaflet-pane' + (name ? ' leaflet-' + name.replace('Pane', '') + '-pane' : ''),
	  		    pane = create$1('div', className, container || this._mapPane);
	
	  		if (name) {
	  			this._panes[name] = pane;
	  		}
	  		return pane;
	  	},
	
	  	// @section Methods for Getting Map State
	
	  	// @method getCenter(): LatLng
	  	// Returns the geographical center of the map view
	  	getCenter: function () {
	  		this._checkIfLoaded();
	
	  		if (this._lastCenter && !this._moved()) {
	  			return this._lastCenter.clone();
	  		}
	  		return this.layerPointToLatLng(this._getCenterLayerPoint());
	  	},
	
	  	// @method getZoom(): Number
	  	// Returns the current zoom level of the map view
	  	getZoom: function () {
	  		return this._zoom;
	  	},
	
	  	// @method getBounds(): LatLngBounds
	  	// Returns the geographical bounds visible in the current map view
	  	getBounds: function () {
	  		var bounds = this.getPixelBounds(),
	  		    sw = this.unproject(bounds.getBottomLeft()),
	  		    ne = this.unproject(bounds.getTopRight());
	
	  		return new LatLngBounds(sw, ne);
	  	},
	
	  	// @method getMinZoom(): Number
	  	// Returns the minimum zoom level of the map (if set in the `minZoom` option of the map or of any layers), or `0` by default.
	  	getMinZoom: function () {
	  		return this.options.minZoom === undefined ? this._layersMinZoom || 0 : this.options.minZoom;
	  	},
	
	  	// @method getMaxZoom(): Number
	  	// Returns the maximum zoom level of the map (if set in the `maxZoom` option of the map or of any layers).
	  	getMaxZoom: function () {
	  		return this.options.maxZoom === undefined ?
	  			(this._layersMaxZoom === undefined ? Infinity : this._layersMaxZoom) :
	  			this.options.maxZoom;
	  	},
	
	  	// @method getBoundsZoom(bounds: LatLngBounds, inside?: Boolean, padding?: Point): Number
	  	// Returns the maximum zoom level on which the given bounds fit to the map
	  	// view in its entirety. If `inside` (optional) is set to `true`, the method
	  	// instead returns the minimum zoom level on which the map view fits into
	  	// the given bounds in its entirety.
	  	getBoundsZoom: function (bounds, inside, padding) { // (LatLngBounds[, Boolean, Point]) -> Number
	  		bounds = toLatLngBounds(bounds);
	  		padding = toPoint(padding || [0, 0]);
	
	  		var zoom = this.getZoom() || 0,
	  		    min = this.getMinZoom(),
	  		    max = this.getMaxZoom(),
	  		    nw = bounds.getNorthWest(),
	  		    se = bounds.getSouthEast(),
	  		    size = this.getSize().subtract(padding),
	  		    boundsSize = toBounds(this.project(se, zoom), this.project(nw, zoom)).getSize(),
	  		    snap = Browser.any3d ? this.options.zoomSnap : 1,
	  		    scalex = size.x / boundsSize.x,
	  		    scaley = size.y / boundsSize.y,
	  		    scale = inside ? Math.max(scalex, scaley) : Math.min(scalex, scaley);
	
	  		zoom = this.getScaleZoom(scale, zoom);
	
	  		if (snap) {
	  			zoom = Math.round(zoom / (snap / 100)) * (snap / 100); // don't jump if within 1% of a snap level
	  			zoom = inside ? Math.ceil(zoom / snap) * snap : Math.floor(zoom / snap) * snap;
	  		}
	
	  		return Math.max(min, Math.min(max, zoom));
	  	},
	
	  	// @method getSize(): Point
	  	// Returns the current size of the map container (in pixels).
	  	getSize: function () {
	  		if (!this._size || this._sizeChanged) {
	  			this._size = new Point(
	  				this._container.clientWidth || 0,
	  				this._container.clientHeight || 0);
	
	  			this._sizeChanged = false;
	  		}
	  		return this._size.clone();
	  	},
	
	  	// @method getPixelBounds(): Bounds
	  	// Returns the bounds of the current map view in projected pixel
	  	// coordinates (sometimes useful in layer and overlay implementations).
	  	getPixelBounds: function (center, zoom) {
	  		var topLeftPoint = this._getTopLeftPoint(center, zoom);
	  		return new Bounds(topLeftPoint, topLeftPoint.add(this.getSize()));
	  	},
	
	  	// TODO: Check semantics - isn't the pixel origin the 0,0 coord relative to
	  	// the map pane? "left point of the map layer" can be confusing, specially
	  	// since there can be negative offsets.
	  	// @method getPixelOrigin(): Point
	  	// Returns the projected pixel coordinates of the top left point of
	  	// the map layer (useful in custom layer and overlay implementations).
	  	getPixelOrigin: function () {
	  		this._checkIfLoaded();
	  		return this._pixelOrigin;
	  	},
	
	  	// @method getPixelWorldBounds(zoom?: Number): Bounds
	  	// Returns the world's bounds in pixel coordinates for zoom level `zoom`.
	  	// If `zoom` is omitted, the map's current zoom level is used.
	  	getPixelWorldBounds: function (zoom) {
	  		return this.options.crs.getProjectedBounds(zoom === undefined ? this.getZoom() : zoom);
	  	},
	
	  	// @section Other Methods
	
	  	// @method getPane(pane: String|HTMLElement): HTMLElement
	  	// Returns a [map pane](#map-pane), given its name or its HTML element (its identity).
	  	getPane: function (pane) {
	  		return typeof pane === 'string' ? this._panes[pane] : pane;
	  	},
	
	  	// @method getPanes(): Object
	  	// Returns a plain object containing the names of all [panes](#map-pane) as keys and
	  	// the panes as values.
	  	getPanes: function () {
	  		return this._panes;
	  	},
	
	  	// @method getContainer: HTMLElement
	  	// Returns the HTML element that contains the map.
	  	getContainer: function () {
	  		return this._container;
	  	},
	
	
	  	// @section Conversion Methods
	
	  	// @method getZoomScale(toZoom: Number, fromZoom: Number): Number
	  	// Returns the scale factor to be applied to a map transition from zoom level
	  	// `fromZoom` to `toZoom`. Used internally to help with zoom animations.
	  	getZoomScale: function (toZoom, fromZoom) {
	  		// TODO replace with universal implementation after refactoring projections
	  		var crs = this.options.crs;
	  		fromZoom = fromZoom === undefined ? this._zoom : fromZoom;
	  		return crs.scale(toZoom) / crs.scale(fromZoom);
	  	},
	
	  	// @method getScaleZoom(scale: Number, fromZoom: Number): Number
	  	// Returns the zoom level that the map would end up at, if it is at `fromZoom`
	  	// level and everything is scaled by a factor of `scale`. Inverse of
	  	// [`getZoomScale`](#map-getZoomScale).
	  	getScaleZoom: function (scale, fromZoom) {
	  		var crs = this.options.crs;
	  		fromZoom = fromZoom === undefined ? this._zoom : fromZoom;
	  		var zoom = crs.zoom(scale * crs.scale(fromZoom));
	  		return isNaN(zoom) ? Infinity : zoom;
	  	},
	
	  	// @method project(latlng: LatLng, zoom: Number): Point
	  	// Projects a geographical coordinate `LatLng` according to the projection
	  	// of the map's CRS, then scales it according to `zoom` and the CRS's
	  	// `Transformation`. The result is pixel coordinate relative to
	  	// the CRS origin.
	  	project: function (latlng, zoom) {
	  		zoom = zoom === undefined ? this._zoom : zoom;
	  		return this.options.crs.latLngToPoint(toLatLng(latlng), zoom);
	  	},
	
	  	// @method unproject(point: Point, zoom: Number): LatLng
	  	// Inverse of [`project`](#map-project).
	  	unproject: function (point, zoom) {
	  		zoom = zoom === undefined ? this._zoom : zoom;
	  		return this.options.crs.pointToLatLng(toPoint(point), zoom);
	  	},
	
	  	// @method layerPointToLatLng(point: Point): LatLng
	  	// Given a pixel coordinate relative to the [origin pixel](#map-getpixelorigin),
	  	// returns the corresponding geographical coordinate (for the current zoom level).
	  	layerPointToLatLng: function (point) {
	  		var projectedPoint = toPoint(point).add(this.getPixelOrigin());
	  		return this.unproject(projectedPoint);
	  	},
	
	  	// @method latLngToLayerPoint(latlng: LatLng): Point
	  	// Given a geographical coordinate, returns the corresponding pixel coordinate
	  	// relative to the [origin pixel](#map-getpixelorigin).
	  	latLngToLayerPoint: function (latlng) {
	  		var projectedPoint = this.project(toLatLng(latlng))._round();
	  		return projectedPoint._subtract(this.getPixelOrigin());
	  	},
	
	  	// @method wrapLatLng(latlng: LatLng): LatLng
	  	// Returns a `LatLng` where `lat` and `lng` has been wrapped according to the
	  	// map's CRS's `wrapLat` and `wrapLng` properties, if they are outside the
	  	// CRS's bounds.
	  	// By default this means longitude is wrapped around the dateline so its
	  	// value is between -180 and +180 degrees.
	  	wrapLatLng: function (latlng) {
	  		return this.options.crs.wrapLatLng(toLatLng(latlng));
	  	},
	
	  	// @method wrapLatLngBounds(bounds: LatLngBounds): LatLngBounds
	  	// Returns a `LatLngBounds` with the same size as the given one, ensuring that
	  	// its center is within the CRS's bounds.
	  	// By default this means the center longitude is wrapped around the dateline so its
	  	// value is between -180 and +180 degrees, and the majority of the bounds
	  	// overlaps the CRS's bounds.
	  	wrapLatLngBounds: function (latlng) {
	  		return this.options.crs.wrapLatLngBounds(toLatLngBounds(latlng));
	  	},
	
	  	// @method distance(latlng1: LatLng, latlng2: LatLng): Number
	  	// Returns the distance between two geographical coordinates according to
	  	// the map's CRS. By default this measures distance in meters.
	  	distance: function (latlng1, latlng2) {
	  		return this.options.crs.distance(toLatLng(latlng1), toLatLng(latlng2));
	  	},
	
	  	// @method containerPointToLayerPoint(point: Point): Point
	  	// Given a pixel coordinate relative to the map container, returns the corresponding
	  	// pixel coordinate relative to the [origin pixel](#map-getpixelorigin).
	  	containerPointToLayerPoint: function (point) { // (Point)
	  		return toPoint(point).subtract(this._getMapPanePos());
	  	},
	
	  	// @method layerPointToContainerPoint(point: Point): Point
	  	// Given a pixel coordinate relative to the [origin pixel](#map-getpixelorigin),
	  	// returns the corresponding pixel coordinate relative to the map container.
	  	layerPointToContainerPoint: function (point) { // (Point)
	  		return toPoint(point).add(this._getMapPanePos());
	  	},
	
	  	// @method containerPointToLatLng(point: Point): LatLng
	  	// Given a pixel coordinate relative to the map container, returns
	  	// the corresponding geographical coordinate (for the current zoom level).
	  	containerPointToLatLng: function (point) {
	  		var layerPoint = this.containerPointToLayerPoint(toPoint(point));
	  		return this.layerPointToLatLng(layerPoint);
	  	},
	
	  	// @method latLngToContainerPoint(latlng: LatLng): Point
	  	// Given a geographical coordinate, returns the corresponding pixel coordinate
	  	// relative to the map container.
	  	latLngToContainerPoint: function (latlng) {
	  		return this.layerPointToContainerPoint(this.latLngToLayerPoint(toLatLng(latlng)));
	  	},
	
	  	// @method mouseEventToContainerPoint(ev: MouseEvent): Point
	  	// Given a MouseEvent object, returns the pixel coordinate relative to the
	  	// map container where the event took place.
	  	mouseEventToContainerPoint: function (e) {
	  		return getMousePosition(e, this._container);
	  	},
	
	  	// @method mouseEventToLayerPoint(ev: MouseEvent): Point
	  	// Given a MouseEvent object, returns the pixel coordinate relative to
	  	// the [origin pixel](#map-getpixelorigin) where the event took place.
	  	mouseEventToLayerPoint: function (e) {
	  		return this.containerPointToLayerPoint(this.mouseEventToContainerPoint(e));
	  	},
	
	  	// @method mouseEventToLatLng(ev: MouseEvent): LatLng
	  	// Given a MouseEvent object, returns geographical coordinate where the
	  	// event took place.
	  	mouseEventToLatLng: function (e) { // (MouseEvent)
	  		return this.layerPointToLatLng(this.mouseEventToLayerPoint(e));
	  	},
	
	
	  	// map initialization methods
	
	  	_initContainer: function (id) {
	  		var container = this._container = get(id);
	
	  		if (!container) {
	  			throw new Error('Map container not found.');
	  		} else if (container._leaflet_id) {
	  			throw new Error('Map container is already initialized.');
	  		}
	
	  		on(container, 'scroll', this._onScroll, this);
	  		this._containerId = stamp(container);
	  	},
	
	  	_initLayout: function () {
	  		var container = this._container;
	
	  		this._fadeAnimated = this.options.fadeAnimation && Browser.any3d;
	
	  		addClass(container, 'leaflet-container' +
	  			(Browser.touch ? ' leaflet-touch' : '') +
	  			(Browser.retina ? ' leaflet-retina' : '') +
	  			(Browser.ielt9 ? ' leaflet-oldie' : '') +
	  			(Browser.safari ? ' leaflet-safari' : '') +
	  			(this._fadeAnimated ? ' leaflet-fade-anim' : ''));
	
	  		var position = getStyle(container, 'position');
	
	  		if (position !== 'absolute' && position !== 'relative' && position !== 'fixed' && position !== 'sticky') {
	  			container.style.position = 'relative';
	  		}
	
	  		this._initPanes();
	
	  		if (this._initControlPos) {
	  			this._initControlPos();
	  		}
	  	},
	
	  	_initPanes: function () {
	  		var panes = this._panes = {};
	  		this._paneRenderers = {};
	
	  		// @section
	  		//
	  		// Panes are DOM elements used to control the ordering of layers on the map. You
	  		// can access panes with [`map.getPane`](#map-getpane) or
	  		// [`map.getPanes`](#map-getpanes) methods. New panes can be created with the
	  		// [`map.createPane`](#map-createpane) method.
	  		//
	  		// Every map has the following default panes that differ only in zIndex.
	  		//
	  		// @pane mapPane: HTMLElement = 'auto'
	  		// Pane that contains all other map panes
	
	  		this._mapPane = this.createPane('mapPane', this._container);
	  		setPosition(this._mapPane, new Point(0, 0));
	
	  		// @pane tilePane: HTMLElement = 200
	  		// Pane for `GridLayer`s and `TileLayer`s
	  		this.createPane('tilePane');
	  		// @pane overlayPane: HTMLElement = 400
	  		// Pane for vectors (`Path`s, like `Polyline`s and `Polygon`s), `ImageOverlay`s and `VideoOverlay`s
	  		this.createPane('overlayPane');
	  		// @pane shadowPane: HTMLElement = 500
	  		// Pane for overlay shadows (e.g. `Marker` shadows)
	  		this.createPane('shadowPane');
	  		// @pane markerPane: HTMLElement = 600
	  		// Pane for `Icon`s of `Marker`s
	  		this.createPane('markerPane');
	  		// @pane tooltipPane: HTMLElement = 650
	  		// Pane for `Tooltip`s.
	  		this.createPane('tooltipPane');
	  		// @pane popupPane: HTMLElement = 700
	  		// Pane for `Popup`s.
	  		this.createPane('popupPane');
	
	  		if (!this.options.markerZoomAnimation) {
	  			addClass(panes.markerPane, 'leaflet-zoom-hide');
	  			addClass(panes.shadowPane, 'leaflet-zoom-hide');
	  		}
	  	},
	
	
	  	// private methods that modify map state
	
	  	// @section Map state change events
	  	_resetView: function (center, zoom, noMoveStart) {
	  		setPosition(this._mapPane, new Point(0, 0));
	
	  		var loading = !this._loaded;
	  		this._loaded = true;
	  		zoom = this._limitZoom(zoom);
	
	  		this.fire('viewprereset');
	
	  		var zoomChanged = this._zoom !== zoom;
	  		this
	  			._moveStart(zoomChanged, noMoveStart)
	  			._move(center, zoom)
	  			._moveEnd(zoomChanged);
	
	  		// @event viewreset: Event
	  		// Fired when the map needs to redraw its content (this usually happens
	  		// on map zoom or load). Very useful for creating custom overlays.
	  		this.fire('viewreset');
	
	  		// @event load: Event
	  		// Fired when the map is initialized (when its center and zoom are set
	  		// for the first time).
	  		if (loading) {
	  			this.fire('load');
	  		}
	  	},
	
	  	_moveStart: function (zoomChanged, noMoveStart) {
	  		// @event zoomstart: Event
	  		// Fired when the map zoom is about to change (e.g. before zoom animation).
	  		// @event movestart: Event
	  		// Fired when the view of the map starts changing (e.g. user starts dragging the map).
	  		if (zoomChanged) {
	  			this.fire('zoomstart');
	  		}
	  		if (!noMoveStart) {
	  			this.fire('movestart');
	  		}
	  		return this;
	  	},
	
	  	_move: function (center, zoom, data, supressEvent) {
	  		if (zoom === undefined) {
	  			zoom = this._zoom;
	  		}
	  		var zoomChanged = this._zoom !== zoom;
	
	  		this._zoom = zoom;
	  		this._lastCenter = center;
	  		this._pixelOrigin = this._getNewPixelOrigin(center);
	
	  		if (!supressEvent) {
	  			// @event zoom: Event
	  			// Fired repeatedly during any change in zoom level,
	  			// including zoom and fly animations.
	  			if (zoomChanged || (data && data.pinch)) {	// Always fire 'zoom' if pinching because #3530
	  				this.fire('zoom', data);
	  			}
	
	  			// @event move: Event
	  			// Fired repeatedly during any movement of the map,
	  			// including pan and fly animations.
	  			this.fire('move', data);
	  		} else if (data && data.pinch) {	// Always fire 'zoom' if pinching because #3530
	  			this.fire('zoom', data);
	  		}
	  		return this;
	  	},
	
	  	_moveEnd: function (zoomChanged) {
	  		// @event zoomend: Event
	  		// Fired when the map zoom changed, after any animations.
	  		if (zoomChanged) {
	  			this.fire('zoomend');
	  		}
	
	  		// @event moveend: Event
	  		// Fired when the center of the map stops changing
	  		// (e.g. user stopped dragging the map or after non-centered zoom).
	  		return this.fire('moveend');
	  	},
	
	  	_stop: function () {
	  		cancelAnimFrame(this._flyToFrame);
	  		if (this._panAnim) {
	  			this._panAnim.stop();
	  		}
	  		return this;
	  	},
	
	  	_rawPanBy: function (offset) {
	  		setPosition(this._mapPane, this._getMapPanePos().subtract(offset));
	  	},
	
	  	_getZoomSpan: function () {
	  		return this.getMaxZoom() - this.getMinZoom();
	  	},
	
	  	_panInsideMaxBounds: function () {
	  		if (!this._enforcingBounds) {
	  			this.panInsideBounds(this.options.maxBounds);
	  		}
	  	},
	
	  	_checkIfLoaded: function () {
	  		if (!this._loaded) {
	  			throw new Error('Set map center and zoom first.');
	  		}
	  	},
	
	  	// DOM event handling
	
	  	// @section Interaction events
	  	_initEvents: function (remove) {
	  		this._targets = {};
	  		this._targets[stamp(this._container)] = this;
	
	  		var onOff = remove ? off : on;
	
	  		// @event click: MouseEvent
	  		// Fired when the user clicks (or taps) the map.
	  		// @event dblclick: MouseEvent
	  		// Fired when the user double-clicks (or double-taps) the map.
	  		// @event mousedown: MouseEvent
	  		// Fired when the user pushes the mouse button on the map.
	  		// @event mouseup: MouseEvent
	  		// Fired when the user releases the mouse button on the map.
	  		// @event mouseover: MouseEvent
	  		// Fired when the mouse enters the map.
	  		// @event mouseout: MouseEvent
	  		// Fired when the mouse leaves the map.
	  		// @event mousemove: MouseEvent
	  		// Fired while the mouse moves over the map.
	  		// @event contextmenu: MouseEvent
	  		// Fired when the user pushes the right mouse button on the map, prevents
	  		// default browser context menu from showing if there are listeners on
	  		// this event. Also fired on mobile when the user holds a single touch
	  		// for a second (also called long press).
	  		// @event keypress: KeyboardEvent
	  		// Fired when the user presses a key from the keyboard that produces a character value while the map is focused.
	  		// @event keydown: KeyboardEvent
	  		// Fired when the user presses a key from the keyboard while the map is focused. Unlike the `keypress` event,
	  		// the `keydown` event is fired for keys that produce a character value and for keys
	  		// that do not produce a character value.
	  		// @event keyup: KeyboardEvent
	  		// Fired when the user releases a key from the keyboard while the map is focused.
	  		onOff(this._container, 'click dblclick mousedown mouseup ' +
	  			'mouseover mouseout mousemove contextmenu keypress keydown keyup', this._handleDOMEvent, this);
	
	  		if (this.options.trackResize) {
	  			onOff(window, 'resize', this._onResize, this);
	  		}
	
	  		if (Browser.any3d && this.options.transform3DLimit) {
	  			(remove ? this.off : this.on).call(this, 'moveend', this._onMoveEnd);
	  		}
	  	},
	
	  	_onResize: function () {
	  		cancelAnimFrame(this._resizeRequest);
	  		this._resizeRequest = requestAnimFrame(
	  		        function () { this.invalidateSize({debounceMoveend: true}); }, this);
	  	},
	
	  	_onScroll: function () {
	  		this._container.scrollTop  = 0;
	  		this._container.scrollLeft = 0;
	  	},
	
	  	_onMoveEnd: function () {
	  		var pos = this._getMapPanePos();
	  		if (Math.max(Math.abs(pos.x), Math.abs(pos.y)) >= this.options.transform3DLimit) {
	  			// https://bugzilla.mozilla.org/show_bug.cgi?id=1203873 but Webkit also have
	  			// a pixel offset on very high values, see: https://jsfiddle.net/dg6r5hhb/
	  			this._resetView(this.getCenter(), this.getZoom());
	  		}
	  	},
	
	  	_findEventTargets: function (e, type) {
	  		var targets = [],
	  		    target,
	  		    isHover = type === 'mouseout' || type === 'mouseover',
	  		    src = e.target || e.srcElement,
	  		    dragging = false;
	
	  		while (src) {
	  			target = this._targets[stamp(src)];
	  			if (target && (type === 'click' || type === 'preclick') && this._draggableMoved(target)) {
	  				// Prevent firing click after you just dragged an object.
	  				dragging = true;
	  				break;
	  			}
	  			if (target && target.listens(type, true)) {
	  				if (isHover && !isExternalTarget(src, e)) { break; }
	  				targets.push(target);
	  				if (isHover) { break; }
	  			}
	  			if (src === this._container) { break; }
	  			src = src.parentNode;
	  		}
	  		if (!targets.length && !dragging && !isHover && this.listens(type, true)) {
	  			targets = [this];
	  		}
	  		return targets;
	  	},
	
	  	_isClickDisabled: function (el) {
	  		while (el && el !== this._container) {
	  			if (el['_leaflet_disable_click']) { return true; }
	  			el = el.parentNode;
	  		}
	  	},
	
	  	_handleDOMEvent: function (e) {
	  		var el = (e.target || e.srcElement);
	  		if (!this._loaded || el['_leaflet_disable_events'] || e.type === 'click' && this._isClickDisabled(el)) {
	  			return;
	  		}
	
	  		var type = e.type;
	
	  		if (type === 'mousedown') {
	  			// prevents outline when clicking on keyboard-focusable element
	  			preventOutline(el);
	  		}
	
	  		this._fireDOMEvent(e, type);
	  	},
	
	  	_mouseEvents: ['click', 'dblclick', 'mouseover', 'mouseout', 'contextmenu'],
	
	  	_fireDOMEvent: function (e, type, canvasTargets) {
	
	  		if (e.type === 'click') {
	  			// Fire a synthetic 'preclick' event which propagates up (mainly for closing popups).
	  			// @event preclick: MouseEvent
	  			// Fired before mouse click on the map (sometimes useful when you
	  			// want something to happen on click before any existing click
	  			// handlers start running).
	  			var synth = extend({}, e);
	  			synth.type = 'preclick';
	  			this._fireDOMEvent(synth, synth.type, canvasTargets);
	  		}
	
	  		// Find the layer the event is propagating from and its parents.
	  		var targets = this._findEventTargets(e, type);
	
	  		if (canvasTargets) {
	  			var filtered = []; // pick only targets with listeners
	  			for (var i = 0; i < canvasTargets.length; i++) {
	  				if (canvasTargets[i].listens(type, true)) {
	  					filtered.push(canvasTargets[i]);
	  				}
	  			}
	  			targets = filtered.concat(targets);
	  		}
	
	  		if (!targets.length) { return; }
	
	  		if (type === 'contextmenu') {
	  			preventDefault(e);
	  		}
	
	  		var target = targets[0];
	  		var data = {
	  			originalEvent: e
	  		};
	
	  		if (e.type !== 'keypress' && e.type !== 'keydown' && e.type !== 'keyup') {
	  			var isMarker = target.getLatLng && (!target._radius || target._radius <= 10);
	  			data.containerPoint = isMarker ?
	  				this.latLngToContainerPoint(target.getLatLng()) : this.mouseEventToContainerPoint(e);
	  			data.layerPoint = this.containerPointToLayerPoint(data.containerPoint);
	  			data.latlng = isMarker ? target.getLatLng() : this.layerPointToLatLng(data.layerPoint);
	  		}
	
	  		for (i = 0; i < targets.length; i++) {
	  			targets[i].fire(type, data, true);
	  			if (data.originalEvent._stopped ||
	  				(targets[i].options.bubblingMouseEvents === false && indexOf(this._mouseEvents, type) !== -1)) { return; }
	  		}
	  	},
	
	  	_draggableMoved: function (obj) {
	  		obj = obj.dragging && obj.dragging.enabled() ? obj : this;
	  		return (obj.dragging && obj.dragging.moved()) || (this.boxZoom && this.boxZoom.moved());
	  	},
	
	  	_clearHandlers: function () {
	  		for (var i = 0, len = this._handlers.length; i < len; i++) {
	  			this._handlers[i].disable();
	  		}
	  	},
	
	  	// @section Other Methods
	
	  	// @method whenReady(fn: Function, context?: Object): this
	  	// Runs the given function `fn` when the map gets initialized with
	  	// a view (center and zoom) and at least one layer, or immediately
	  	// if it's already initialized, optionally passing a function context.
	  	whenReady: function (callback, context) {
	  		if (this._loaded) {
	  			callback.call(context || this, {target: this});
	  		} else {
	  			this.on('load', callback, context);
	  		}
	  		return this;
	  	},
	
	
	  	// private methods for getting map state
	
	  	_getMapPanePos: function () {
	  		return getPosition(this._mapPane) || new Point(0, 0);
	  	},
	
	  	_moved: function () {
	  		var pos = this._getMapPanePos();
	  		return pos && !pos.equals([0, 0]);
	  	},
	
	  	_getTopLeftPoint: function (center, zoom) {
	  		var pixelOrigin = center && zoom !== undefined ?
	  			this._getNewPixelOrigin(center, zoom) :
	  			this.getPixelOrigin();
	  		return pixelOrigin.subtract(this._getMapPanePos());
	  	},
	
	  	_getNewPixelOrigin: function (center, zoom) {
	  		var viewHalf = this.getSize()._divideBy(2);
	  		return this.project(center, zoom)._subtract(viewHalf)._add(this._getMapPanePos())._round();
	  	},
	
	  	_latLngToNewLayerPoint: function (latlng, zoom, center) {
	  		var topLeft = this._getNewPixelOrigin(center, zoom);
	  		return this.project(latlng, zoom)._subtract(topLeft);
	  	},
	
	  	_latLngBoundsToNewLayerBounds: function (latLngBounds, zoom, center) {
	  		var topLeft = this._getNewPixelOrigin(center, zoom);
	  		return toBounds([
	  			this.project(latLngBounds.getSouthWest(), zoom)._subtract(topLeft),
	  			this.project(latLngBounds.getNorthWest(), zoom)._subtract(topLeft),
	  			this.project(latLngBounds.getSouthEast(), zoom)._subtract(topLeft),
	  			this.project(latLngBounds.getNorthEast(), zoom)._subtract(topLeft)
	  		]);
	  	},
	
	  	// layer point of the current center
	  	_getCenterLayerPoint: function () {
	  		return this.containerPointToLayerPoint(this.getSize()._divideBy(2));
	  	},
	
	  	// offset of the specified place to the current center in pixels
	  	_getCenterOffset: function (latlng) {
	  		return this.latLngToLayerPoint(latlng).subtract(this._getCenterLayerPoint());
	  	},
	
	  	// adjust center for view to get inside bounds
	  	_limitCenter: function (center, zoom, bounds) {
	
	  		if (!bounds) { return center; }
	
	  		var centerPoint = this.project(center, zoom),
	  		    viewHalf = this.getSize().divideBy(2),
	  		    viewBounds = new Bounds(centerPoint.subtract(viewHalf), centerPoint.add(viewHalf)),
	  		    offset = this._getBoundsOffset(viewBounds, bounds, zoom);
	
	  		// If offset is less than a pixel, ignore.
	  		// This prevents unstable projections from getting into
	  		// an infinite loop of tiny offsets.
	  		if (Math.abs(offset.x) <= 1 && Math.abs(offset.y) <= 1) {
	  			return center;
	  		}
	
	  		return this.unproject(centerPoint.add(offset), zoom);
	  	},
	
	  	// adjust offset for view to get inside bounds
	  	_limitOffset: function (offset, bounds) {
	  		if (!bounds) { return offset; }
	
	  		var viewBounds = this.getPixelBounds(),
	  		    newBounds = new Bounds(viewBounds.min.add(offset), viewBounds.max.add(offset));
	
	  		return offset.add(this._getBoundsOffset(newBounds, bounds));
	  	},
	
	  	// returns offset needed for pxBounds to get inside maxBounds at a specified zoom
	  	_getBoundsOffset: function (pxBounds, maxBounds, zoom) {
	  		var projectedMaxBounds = toBounds(
	  		        this.project(maxBounds.getNorthEast(), zoom),
	  		        this.project(maxBounds.getSouthWest(), zoom)
	  		    ),
	  		    minOffset = projectedMaxBounds.min.subtract(pxBounds.min),
	  		    maxOffset = projectedMaxBounds.max.subtract(pxBounds.max),
	
	  		    dx = this._rebound(minOffset.x, -maxOffset.x),
	  		    dy = this._rebound(minOffset.y, -maxOffset.y);
	
	  		return new Point(dx, dy);
	  	},
	
	  	_rebound: function (left, right) {
	  		return left + right > 0 ?
	  			Math.round(left - right) / 2 :
	  			Math.max(0, Math.ceil(left)) - Math.max(0, Math.floor(right));
	  	},
	
	  	_limitZoom: function (zoom) {
	  		var min = this.getMinZoom(),
	  		    max = this.getMaxZoom(),
	  		    snap = Browser.any3d ? this.options.zoomSnap : 1;
	  		if (snap) {
	  			zoom = Math.round(zoom / snap) * snap;
	  		}
	  		return Math.max(min, Math.min(max, zoom));
	  	},
	
	  	_onPanTransitionStep: function () {
	  		this.fire('move');
	  	},
	
	  	_onPanTransitionEnd: function () {
	  		removeClass(this._mapPane, 'leaflet-pan-anim');
	  		this.fire('moveend');
	  	},
	
	  	_tryAnimatedPan: function (center, options) {
	  		// difference between the new and current centers in pixels
	  		var offset = this._getCenterOffset(center)._trunc();
	
	  		// don't animate too far unless animate: true specified in options
	  		if ((options && options.animate) !== true && !this.getSize().contains(offset)) { return false; }
	
	  		this.panBy(offset, options);
	
	  		return true;
	  	},
	
	  	_createAnimProxy: function () {
	
	  		var proxy = this._proxy = create$1('div', 'leaflet-proxy leaflet-zoom-animated');
	  		this._panes.mapPane.appendChild(proxy);
	
	  		this.on('zoomanim', function (e) {
	  			var prop = TRANSFORM,
	  			    transform = this._proxy.style[prop];
	
	  			setTransform(this._proxy, this.project(e.center, e.zoom), this.getZoomScale(e.zoom, 1));
	
	  			// workaround for case when transform is the same and so transitionend event is not fired
	  			if (transform === this._proxy.style[prop] && this._animatingZoom) {
	  				this._onZoomTransitionEnd();
	  			}
	  		}, this);
	
	  		this.on('load moveend', this._animMoveEnd, this);
	
	  		this._on('unload', this._destroyAnimProxy, this);
	  	},
	
	  	_destroyAnimProxy: function () {
	  		remove(this._proxy);
	  		this.off('load moveend', this._animMoveEnd, this);
	  		delete this._proxy;
	  	},
	
	  	_animMoveEnd: function () {
	  		var c = this.getCenter(),
	  		    z = this.getZoom();
	  		setTransform(this._proxy, this.project(c, z), this.getZoomScale(z, 1));
	  	},
	
	  	_catchTransitionEnd: function (e) {
	  		if (this._animatingZoom && e.propertyName.indexOf('transform') >= 0) {
	  			this._onZoomTransitionEnd();
	  		}
	  	},
	
	  	_nothingToAnimate: function () {
	  		return !this._container.getElementsByClassName('leaflet-zoom-animated').length;
	  	},
	
	  	_tryAnimatedZoom: function (center, zoom, options) {
	
	  		if (this._animatingZoom) { return true; }
	
	  		options = options || {};
	
	  		// don't animate if disabled, not supported or zoom difference is too large
	  		if (!this._zoomAnimated || options.animate === false || this._nothingToAnimate() ||
	  		        Math.abs(zoom - this._zoom) > this.options.zoomAnimationThreshold) { return false; }
	
	  		// offset is the pixel coords of the zoom origin relative to the current center
	  		var scale = this.getZoomScale(zoom),
	  		    offset = this._getCenterOffset(center)._divideBy(1 - 1 / scale);
	
	  		// don't animate if the zoom origin isn't within one screen from the current center, unless forced
	  		if (options.animate !== true && !this.getSize().contains(offset)) { return false; }
	
	  		requestAnimFrame(function () {
	  			this
	  			    ._moveStart(true, options.noMoveStart || false)
	  			    ._animateZoom(center, zoom, true);
	  		}, this);
	
	  		return true;
	  	},
	
	  	_animateZoom: function (center, zoom, startAnim, noUpdate) {
	  		if (!this._mapPane) { return; }
	
	  		if (startAnim) {
	  			this._animatingZoom = true;
	
	  			// remember what center/zoom to set after animation
	  			this._animateToCenter = center;
	  			this._animateToZoom = zoom;
	
	  			addClass(this._mapPane, 'leaflet-zoom-anim');
	  		}
	
	  		// @section Other Events
	  		// @event zoomanim: ZoomAnimEvent
	  		// Fired at least once per zoom animation. For continuous zoom, like pinch zooming, fired once per frame during zoom.
	  		this.fire('zoomanim', {
	  			center: center,
	  			zoom: zoom,
	  			noUpdate: noUpdate
	  		});
	
	  		if (!this._tempFireZoomEvent) {
	  			this._tempFireZoomEvent = this._zoom !== this._animateToZoom;
	  		}
	
	  		this._move(this._animateToCenter, this._animateToZoom, undefined, true);
	
	  		// Work around webkit not firing 'transitionend', see https://github.com/Leaflet/Leaflet/issues/3689, 2693
	  		setTimeout(bind(this._onZoomTransitionEnd, this), 250);
	  	},
	
	  	_onZoomTransitionEnd: function () {
	  		if (!this._animatingZoom) { return; }
	
	  		if (this._mapPane) {
	  			removeClass(this._mapPane, 'leaflet-zoom-anim');
	  		}
	
	  		this._animatingZoom = false;
	
	  		this._move(this._animateToCenter, this._animateToZoom, undefined, true);
	
	  		if (this._tempFireZoomEvent) {
	  			this.fire('zoom');
	  		}
	  		delete this._tempFireZoomEvent;
	
	  		this.fire('move');
	
	  		this._moveEnd(true);
	  	}
	  });
	
	  // @section
	
	  // @factory L.map(id: String, options?: Map options)
	  // Instantiates a map object given the DOM ID of a `<div>` element
	  // and optionally an object literal with `Map options`.
	  //
	  // @alternative
	  // @factory L.map(el: HTMLElement, options?: Map options)
	  // Instantiates a map object given an instance of a `<div>` HTML element
	  // and optionally an object literal with `Map options`.
	  function createMap(id, options) {
	  	return new Map(id, options);
	  }
	
	  /*
	   * @class Control
	   * @aka L.Control
	   * @inherits Class
	   *
	   * L.Control is a base class for implementing map controls. Handles positioning.
	   * All other controls extend from this class.
	   */
	
	  var Control = Class.extend({
	  	// @section
	  	// @aka Control Options
	  	options: {
	  		// @option position: String = 'topright'
	  		// The position of the control (one of the map corners). Possible values are `'topleft'`,
	  		// `'topright'`, `'bottomleft'` or `'bottomright'`
	  		position: 'topright'
	  	},
	
	  	initialize: function (options) {
	  		setOptions(this, options);
	  	},
	
	  	/* @section
	  	 * Classes extending L.Control will inherit the following methods:
	  	 *
	  	 * @method getPosition: string
	  	 * Returns the position of the control.
	  	 */
	  	getPosition: function () {
	  		return this.options.position;
	  	},
	
	  	// @method setPosition(position: string): this
	  	// Sets the position of the control.
	  	setPosition: function (position) {
	  		var map = this._map;
	
	  		if (map) {
	  			map.removeControl(this);
	  		}
	
	  		this.options.position = position;
	
	  		if (map) {
	  			map.addControl(this);
	  		}
	
	  		return this;
	  	},
	
	  	// @method getContainer: HTMLElement
	  	// Returns the HTMLElement that contains the control.
	  	getContainer: function () {
	  		return this._container;
	  	},
	
	  	// @method addTo(map: Map): this
	  	// Adds the control to the given map.
	  	addTo: function (map) {
	  		this.remove();
	  		this._map = map;
	
	  		var container = this._container = this.onAdd(map),
	  		    pos = this.getPosition(),
	  		    corner = map._controlCorners[pos];
	
	  		addClass(container, 'leaflet-control');
	
	  		if (pos.indexOf('bottom') !== -1) {
	  			corner.insertBefore(container, corner.firstChild);
	  		} else {
	  			corner.appendChild(container);
	  		}
	
	  		this._map.on('unload', this.remove, this);
	
	  		return this;
	  	},
	
	  	// @method remove: this
	  	// Removes the control from the map it is currently active on.
	  	remove: function () {
	  		if (!this._map) {
	  			return this;
	  		}
	
	  		remove(this._container);
	
	  		if (this.onRemove) {
	  			this.onRemove(this._map);
	  		}
	
	  		this._map.off('unload', this.remove, this);
	  		this._map = null;
	
	  		return this;
	  	},
	
	  	_refocusOnMap: function (e) {
	  		// if map exists and event is not a keyboard event
	  		if (this._map && e && e.screenX > 0 && e.screenY > 0) {
	  			this._map.getContainer().focus();
	  		}
	  	}
	  });
	
	  var control = function (options) {
	  	return new Control(options);
	  };
	
	  /* @section Extension methods
	   * @uninheritable
	   *
	   * Every control should extend from `L.Control` and (re-)implement the following methods.
	   *
	   * @method onAdd(map: Map): HTMLElement
	   * Should return the container DOM element for the control and add listeners on relevant map events. Called on [`control.addTo(map)`](#control-addTo).
	   *
	   * @method onRemove(map: Map)
	   * Optional method. Should contain all clean up code that removes the listeners previously added in [`onAdd`](#control-onadd). Called on [`control.remove()`](#control-remove).
	   */
	
	  /* @namespace Map
	   * @section Methods for Layers and Controls
	   */
	  Map.include({
	  	// @method addControl(control: Control): this
	  	// Adds the given control to the map
	  	addControl: function (control) {
	  		control.addTo(this);
	  		return this;
	  	},
	
	  	// @method removeControl(control: Control): this
	  	// Removes the given control from the map
	  	removeControl: function (control) {
	  		control.remove();
	  		return this;
	  	},
	
	  	_initControlPos: function () {
	  		var corners = this._controlCorners = {},
	  		    l = 'leaflet-',
	  		    container = this._controlContainer =
	  		            create$1('div', l + 'control-container', this._container);
	
	  		function createCorner(vSide, hSide) {
	  			var className = l + vSide + ' ' + l + hSide;
	
	  			corners[vSide + hSide] = create$1('div', className, container);
	  		}
	
	  		createCorner('top', 'left');
	  		createCorner('top', 'right');
	  		createCorner('bottom', 'left');
	  		createCorner('bottom', 'right');
	  	},
	
	  	_clearControlPos: function () {
	  		for (var i in this._controlCorners) {
	  			remove(this._controlCorners[i]);
	  		}
	  		remove(this._controlContainer);
	  		delete this._controlCorners;
	  		delete this._controlContainer;
	  	}
	  });
	
	  /*
	   * @class Control.Layers
	   * @aka L.Control.Layers
	   * @inherits Control
	   *
	   * The layers control gives users the ability to switch between different base layers and switch overlays on/off (check out the [detailed example](https://leafletjs.com/examples/layers-control/)). Extends `Control`.
	   *
	   * @example
	   *
	   * ```js
	   * var baseLayers = {
	   * 	"Mapbox": mapbox,
	   * 	"OpenStreetMap": osm
	   * };
	   *
	   * var overlays = {
	   * 	"Marker": marker,
	   * 	"Roads": roadsLayer
	   * };
	   *
	   * L.control.layers(baseLayers, overlays).addTo(map);
	   * ```
	   *
	   * The `baseLayers` and `overlays` parameters are object literals with layer names as keys and `Layer` objects as values:
	   *
	   * ```js
	   * {
	   *     "<someName1>": layer1,
	   *     "<someName2>": layer2
	   * }
	   * ```
	   *
	   * The layer names can contain HTML, which allows you to add additional styling to the items:
	   *
	   * ```js
	   * {"<img src='my-layer-icon' /> <span class='my-layer-item'>My Layer</span>": myLayer}
	   * ```
	   */
	
	  var Layers = Control.extend({
	  	// @section
	  	// @aka Control.Layers options
	  	options: {
	  		// @option collapsed: Boolean = true
	  		// If `true`, the control will be collapsed into an icon and expanded on mouse hover, touch, or keyboard activation.
	  		collapsed: true,
	  		position: 'topright',
	
	  		// @option autoZIndex: Boolean = true
	  		// If `true`, the control will assign zIndexes in increasing order to all of its layers so that the order is preserved when switching them on/off.
	  		autoZIndex: true,
	
	  		// @option hideSingleBase: Boolean = false
	  		// If `true`, the base layers in the control will be hidden when there is only one.
	  		hideSingleBase: false,
	
	  		// @option sortLayers: Boolean = false
	  		// Whether to sort the layers. When `false`, layers will keep the order
	  		// in which they were added to the control.
	  		sortLayers: false,
	
	  		// @option sortFunction: Function = *
	  		// A [compare function](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/sort)
	  		// that will be used for sorting the layers, when `sortLayers` is `true`.
	  		// The function receives both the `L.Layer` instances and their names, as in
	  		// `sortFunction(layerA, layerB, nameA, nameB)`.
	  		// By default, it sorts layers alphabetically by their name.
	  		sortFunction: function (layerA, layerB, nameA, nameB) {
	  			return nameA < nameB ? -1 : (nameB < nameA ? 1 : 0);
	  		}
	  	},
	
	  	initialize: function (baseLayers, overlays, options) {
	  		setOptions(this, options);
	
	  		this._layerControlInputs = [];
	  		this._layers = [];
	  		this._lastZIndex = 0;
	  		this._handlingClick = false;
	  		this._preventClick = false;
	
	  		for (var i in baseLayers) {
	  			this._addLayer(baseLayers[i], i);
	  		}
	
	  		for (i in overlays) {
	  			this._addLayer(overlays[i], i, true);
	  		}
	  	},
	
	  	onAdd: function (map) {
	  		this._initLayout();
	  		this._update();
	
	  		this._map = map;
	  		map.on('zoomend', this._checkDisabledLayers, this);
	
	  		for (var i = 0; i < this._layers.length; i++) {
	  			this._layers[i].layer.on('add remove', this._onLayerChange, this);
	  		}
	
	  		return this._container;
	  	},
	
	  	addTo: function (map) {
	  		Control.prototype.addTo.call(this, map);
	  		// Trigger expand after Layers Control has been inserted into DOM so that is now has an actual height.
	  		return this._expandIfNotCollapsed();
	  	},
	
	  	onRemove: function () {
	  		this._map.off('zoomend', this._checkDisabledLayers, this);
	
	  		for (var i = 0; i < this._layers.length; i++) {
	  			this._layers[i].layer.off('add remove', this._onLayerChange, this);
	  		}
	  	},
	
	  	// @method addBaseLayer(layer: Layer, name: String): this
	  	// Adds a base layer (radio button entry) with the given name to the control.
	  	addBaseLayer: function (layer, name) {
	  		this._addLayer(layer, name);
	  		return (this._map) ? this._update() : this;
	  	},
	
	  	// @method addOverlay(layer: Layer, name: String): this
	  	// Adds an overlay (checkbox entry) with the given name to the control.
	  	addOverlay: function (layer, name) {
	  		this._addLayer(layer, name, true);
	  		return (this._map) ? this._update() : this;
	  	},
	
	  	// @method removeLayer(layer: Layer): this
	  	// Remove the given layer from the control.
	  	removeLayer: function (layer) {
	  		layer.off('add remove', this._onLayerChange, this);
	
	  		var obj = this._getLayer(stamp(layer));
	  		if (obj) {
	  			this._layers.splice(this._layers.indexOf(obj), 1);
	  		}
	  		return (this._map) ? this._update() : this;
	  	},
	
	  	// @method expand(): this
	  	// Expand the control container if collapsed.
	  	expand: function () {
	  		addClass(this._container, 'leaflet-control-layers-expanded');
	  		this._section.style.height = null;
	  		var acceptableHeight = this._map.getSize().y - (this._container.offsetTop + 50);
	  		if (acceptableHeight < this._section.clientHeight) {
	  			addClass(this._section, 'leaflet-control-layers-scrollbar');
	  			this._section.style.height = acceptableHeight + 'px';
	  		} else {
	  			removeClass(this._section, 'leaflet-control-layers-scrollbar');
	  		}
	  		this._checkDisabledLayers();
	  		return this;
	  	},
	
	  	// @method collapse(): this
	  	// Collapse the control container if expanded.
	  	collapse: function () {
	  		removeClass(this._container, 'leaflet-control-layers-expanded');
	  		return this;
	  	},
	
	  	_initLayout: function () {
	  		var className = 'leaflet-control-layers',
	  		    container = this._container = create$1('div', className),
	  		    collapsed = this.options.collapsed;
	
	  		// makes this work on IE touch devices by stopping it from firing a mouseout event when the touch is released
	  		container.setAttribute('aria-haspopup', true);
	
	  		disableClickPropagation(container);
	  		disableScrollPropagation(container);
	
	  		var section = this._section = create$1('section', className + '-list');
	
	  		if (collapsed) {
	  			this._map.on('click', this.collapse, this);
	
	  			on(container, {
	  				mouseenter: this._expandSafely,
	  				mouseleave: this.collapse
	  			}, this);
	  		}
	
	  		var link = this._layersLink = create$1('a', className + '-toggle', container);
	  		link.href = '#';
	  		link.title = 'Layers';
	  		link.setAttribute('role', 'button');
	
	  		on(link, {
	  			keydown: function (e) {
	  				if (e.keyCode === 13) {
	  					this._expandSafely();
	  				}
	  			},
	  			// Certain screen readers intercept the key event and instead send a click event
	  			click: function (e) {
	  				preventDefault(e);
	  				this._expandSafely();
	  			}
	  		}, this);
	
	  		if (!collapsed) {
	  			this.expand();
	  		}
	
	  		this._baseLayersList = create$1('div', className + '-base', section);
	  		this._separator = create$1('div', className + '-separator', section);
	  		this._overlaysList = create$1('div', className + '-overlays', section);
	
	  		container.appendChild(section);
	  	},
	
	  	_getLayer: function (id) {
	  		for (var i = 0; i < this._layers.length; i++) {
	
	  			if (this._layers[i] && stamp(this._layers[i].layer) === id) {
	  				return this._layers[i];
	  			}
	  		}
	  	},
	
	  	_addLayer: function (layer, name, overlay) {
	  		if (this._map) {
	  			layer.on('add remove', this._onLayerChange, this);
	  		}
	
	  		this._layers.push({
	  			layer: layer,
	  			name: name,
	  			overlay: overlay
	  		});
	
	  		if (this.options.sortLayers) {
	  			this._layers.sort(bind(function (a, b) {
	  				return this.options.sortFunction(a.layer, b.layer, a.name, b.name);
	  			}, this));
	  		}
	
	  		if (this.options.autoZIndex && layer.setZIndex) {
	  			this._lastZIndex++;
	  			layer.setZIndex(this._lastZIndex);
	  		}
	
	  		this._expandIfNotCollapsed();
	  	},
	
	  	_update: function () {
	  		if (!this._container) { return this; }
	
	  		empty(this._baseLayersList);
	  		empty(this._overlaysList);
	
	  		this._layerControlInputs = [];
	  		var baseLayersPresent, overlaysPresent, i, obj, baseLayersCount = 0;
	
	  		for (i = 0; i < this._layers.length; i++) {
	  			obj = this._layers[i];
	  			this._addItem(obj);
	  			overlaysPresent = overlaysPresent || obj.overlay;
	  			baseLayersPresent = baseLayersPresent || !obj.overlay;
	  			baseLayersCount += !obj.overlay ? 1 : 0;
	  		}
	
	  		// Hide base layers section if there's only one layer.
	  		if (this.options.hideSingleBase) {
	  			baseLayersPresent = baseLayersPresent && baseLayersCount > 1;
	  			this._baseLayersList.style.display = baseLayersPresent ? '' : 'none';
	  		}
	
	  		this._separator.style.display = overlaysPresent && baseLayersPresent ? '' : 'none';
	
	  		return this;
	  	},
	
	  	_onLayerChange: function (e) {
	  		if (!this._handlingClick) {
	  			this._update();
	  		}
	
	  		var obj = this._getLayer(stamp(e.target));
	
	  		// @namespace Map
	  		// @section Layer events
	  		// @event baselayerchange: LayersControlEvent
	  		// Fired when the base layer is changed through the [layers control](#control-layers).
	  		// @event overlayadd: LayersControlEvent
	  		// Fired when an overlay is selected through the [layers control](#control-layers).
	  		// @event overlayremove: LayersControlEvent
	  		// Fired when an overlay is deselected through the [layers control](#control-layers).
	  		// @namespace Control.Layers
	  		var type = obj.overlay ?
	  			(e.type === 'add' ? 'overlayadd' : 'overlayremove') :
	  			(e.type === 'add' ? 'baselayerchange' : null);
	
	  		if (type) {
	  			this._map.fire(type, obj);
	  		}
	  	},
	
	  	// IE7 bugs out if you create a radio dynamically, so you have to do it this hacky way (see https://stackoverflow.com/a/119079)
	  	_createRadioElement: function (name, checked) {
	
	  		var radioHtml = '<input type="radio" class="leaflet-control-layers-selector" name="' +
	  				name + '"' + (checked ? ' checked="checked"' : '') + '/>';
	
	  		var radioFragment = document.createElement('div');
	  		radioFragment.innerHTML = radioHtml;
	
	  		return radioFragment.firstChild;
	  	},
	
	  	_addItem: function (obj) {
	  		var label = document.createElement('label'),
	  		    checked = this._map.hasLayer(obj.layer),
	  		    input;
	
	  		if (obj.overlay) {
	  			input = document.createElement('input');
	  			input.type = 'checkbox';
	  			input.className = 'leaflet-control-layers-selector';
	  			input.defaultChecked = checked;
	  		} else {
	  			input = this._createRadioElement('leaflet-base-layers_' + stamp(this), checked);
	  		}
	
	  		this._layerControlInputs.push(input);
	  		input.layerId = stamp(obj.layer);
	
	  		on(input, 'click', this._onInputClick, this);
	
	  		var name = document.createElement('span');
	  		name.innerHTML = ' ' + obj.name;
	
	  		// Helps from preventing layer control flicker when checkboxes are disabled
	  		// https://github.com/Leaflet/Leaflet/issues/2771
	  		var holder = document.createElement('span');
	
	  		label.appendChild(holder);
	  		holder.appendChild(input);
	  		holder.appendChild(name);
	
	  		var container = obj.overlay ? this._overlaysList : this._baseLayersList;
	  		container.appendChild(label);
	
	  		this._checkDisabledLayers();
	  		return label;
	  	},
	
	  	_onInputClick: function () {
	  		// expanding the control on mobile with a click can cause adding a layer - we don't want this
	  		if (this._preventClick) {
	  			return;
	  		}
	
	  		var inputs = this._layerControlInputs,
	  		    input, layer;
	  		var addedLayers = [],
	  		    removedLayers = [];
	
	  		this._handlingClick = true;
	
	  		for (var i = inputs.length - 1; i >= 0; i--) {
	  			input = inputs[i];
	  			layer = this._getLayer(input.layerId).layer;
	
	  			if (input.checked) {
	  				addedLayers.push(layer);
	  			} else if (!input.checked) {
	  				removedLayers.push(layer);
	  			}
	  		}
	
	  		// Bugfix issue 2318: Should remove all old layers before readding new ones
	  		for (i = 0; i < removedLayers.length; i++) {
	  			if (this._map.hasLayer(removedLayers[i])) {
	  				this._map.removeLayer(removedLayers[i]);
	  			}
	  		}
	  		for (i = 0; i < addedLayers.length; i++) {
	  			if (!this._map.hasLayer(addedLayers[i])) {
	  				this._map.addLayer(addedLayers[i]);
	  			}
	  		}
	
	  		this._handlingClick = false;
	
	  		this._refocusOnMap();
	  	},
	
	  	_checkDisabledLayers: function () {
	  		var inputs = this._layerControlInputs,
	  		    input,
	  		    layer,
	  		    zoom = this._map.getZoom();
	
	  		for (var i = inputs.length - 1; i >= 0; i--) {
	  			input = inputs[i];
	  			layer = this._getLayer(input.layerId).layer;
	  			input.disabled = (layer.options.minZoom !== undefined && zoom < layer.options.minZoom) ||
	  			                 (layer.options.maxZoom !== undefined && zoom > layer.options.maxZoom);
	
	  		}
	  	},
	
	  	_expandIfNotCollapsed: function () {
	  		if (this._map && !this.options.collapsed) {
	  			this.expand();
	  		}
	  		return this;
	  	},
	
	  	_expandSafely: function () {
	  		var section = this._section;
	  		this._preventClick = true;
	  		on(section, 'click', preventDefault);
	  		this.expand();
	  		var that = this;
	  		setTimeout(function () {
	  			off(section, 'click', preventDefault);
	  			that._preventClick = false;
	  		});
	  	}
	
	  });
	
	
	  // @factory L.control.layers(baselayers?: Object, overlays?: Object, options?: Control.Layers options)
	  // Creates a layers control with the given layers. Base layers will be switched with radio buttons, while overlays will be switched with checkboxes. Note that all base layers should be passed in the base layers object, but only one should be added to the map during map instantiation.
	  var layers = function (baseLayers, overlays, options) {
	  	return new Layers(baseLayers, overlays, options);
	  };
	
	  /*
	   * @class Control.Zoom
	   * @aka L.Control.Zoom
	   * @inherits Control
	   *
	   * A basic zoom control with two buttons (zoom in and zoom out). It is put on the map by default unless you set its [`zoomControl` option](#map-zoomcontrol) to `false`. Extends `Control`.
	   */
	
	  var Zoom = Control.extend({
	  	// @section
	  	// @aka Control.Zoom options
	  	options: {
	  		position: 'topleft',
	
	  		// @option zoomInText: String = '<span aria-hidden="true">+</span>'
	  		// The text set on the 'zoom in' button.
	  		zoomInText: '<span aria-hidden="true">+</span>',
	
	  		// @option zoomInTitle: String = 'Zoom in'
	  		// The title set on the 'zoom in' button.
	  		zoomInTitle: 'Zoom in',
	
	  		// @option zoomOutText: String = '<span aria-hidden="true">&#x2212;</span>'
	  		// The text set on the 'zoom out' button.
	  		zoomOutText: '<span aria-hidden="true">&#x2212;</span>',
	
	  		// @option zoomOutTitle: String = 'Zoom out'
	  		// The title set on the 'zoom out' button.
	  		zoomOutTitle: 'Zoom out'
	  	},
	
	  	onAdd: function (map) {
	  		var zoomName = 'leaflet-control-zoom',
	  		    container = create$1('div', zoomName + ' leaflet-bar'),
	  		    options = this.options;
	
	  		this._zoomInButton  = this._createButton(options.zoomInText, options.zoomInTitle,
	  		        zoomName + '-in',  container, this._zoomIn);
	  		this._zoomOutButton = this._createButton(options.zoomOutText, options.zoomOutTitle,
	  		        zoomName + '-out', container, this._zoomOut);
	
	  		this._updateDisabled();
	  		map.on('zoomend zoomlevelschange', this._updateDisabled, this);
	
	  		return container;
	  	},
	
	  	onRemove: function (map) {
	  		map.off('zoomend zoomlevelschange', this._updateDisabled, this);
	  	},
	
	  	disable: function () {
	  		this._disabled = true;
	  		this._updateDisabled();
	  		return this;
	  	},
	
	  	enable: function () {
	  		this._disabled = false;
	  		this._updateDisabled();
	  		return this;
	  	},
	
	  	_zoomIn: function (e) {
	  		if (!this._disabled && this._map._zoom < this._map.getMaxZoom()) {
	  			this._map.zoomIn(this._map.options.zoomDelta * (e.shiftKey ? 3 : 1));
	  		}
	  	},
	
	  	_zoomOut: function (e) {
	  		if (!this._disabled && this._map._zoom > this._map.getMinZoom()) {
	  			this._map.zoomOut(this._map.options.zoomDelta * (e.shiftKey ? 3 : 1));
	  		}
	  	},
	
	  	_createButton: function (html, title, className, container, fn) {
	  		var link = create$1('a', className, container);
	  		link.innerHTML = html;
	  		link.href = '#';
	  		link.title = title;
	
	  		/*
	  		 * Will force screen readers like VoiceOver to read this as "Zoom in - button"
	  		 */
	  		link.setAttribute('role', 'button');
	  		link.setAttribute('aria-label', title);
	
	  		disableClickPropagation(link);
	  		on(link, 'click', stop);
	  		on(link, 'click', fn, this);
	  		on(link, 'click', this._refocusOnMap, this);
	
	  		return link;
	  	},
	
	  	_updateDisabled: function () {
	  		var map = this._map,
	  		    className = 'leaflet-disabled';
	
	  		removeClass(this._zoomInButton, className);
	  		removeClass(this._zoomOutButton, className);
	  		this._zoomInButton.setAttribute('aria-disabled', 'false');
	  		this._zoomOutButton.setAttribute('aria-disabled', 'false');
	
	  		if (this._disabled || map._zoom === map.getMinZoom()) {
	  			addClass(this._zoomOutButton, className);
	  			this._zoomOutButton.setAttribute('aria-disabled', 'true');
	  		}
	  		if (this._disabled || map._zoom === map.getMaxZoom()) {
	  			addClass(this._zoomInButton, className);
	  			this._zoomInButton.setAttribute('aria-disabled', 'true');
	  		}
	  	}
	  });
	
	  // @namespace Map
	  // @section Control options
	  // @option zoomControl: Boolean = true
	  // Whether a [zoom control](#control-zoom) is added to the map by default.
	  Map.mergeOptions({
	  	zoomControl: true
	  });
	
	  Map.addInitHook(function () {
	  	if (this.options.zoomControl) {
	  		// @section Controls
	  		// @property zoomControl: Control.Zoom
	  		// The default zoom control (only available if the
	  		// [`zoomControl` option](#map-zoomcontrol) was `true` when creating the map).
	  		this.zoomControl = new Zoom();
	  		this.addControl(this.zoomControl);
	  	}
	  });
	
	  // @namespace Control.Zoom
	  // @factory L.control.zoom(options: Control.Zoom options)
	  // Creates a zoom control
	  var zoom = function (options) {
	  	return new Zoom(options);
	  };
	
	  /*
	   * @class Control.Scale
	   * @aka L.Control.Scale
	   * @inherits Control
	   *
	   * A simple scale control that shows the scale of the current center of screen in metric (m/km) and imperial (mi/ft) systems. Extends `Control`.
	   *
	   * @example
	   *
	   * ```js
	   * L.control.scale().addTo(map);
	   * ```
	   */
	
	  var Scale = Control.extend({
	  	// @section
	  	// @aka Control.Scale options
	  	options: {
	  		position: 'bottomleft',
	
	  		// @option maxWidth: Number = 100
	  		// Maximum width of the control in pixels. The width is set dynamically to show round values (e.g. 100, 200, 500).
	  		maxWidth: 100,
	
	  		// @option metric: Boolean = True
	  		// Whether to show the metric scale line (m/km).
	  		metric: true,
	
	  		// @option imperial: Boolean = True
	  		// Whether to show the imperial scale line (mi/ft).
	  		imperial: true
	
	  		// @option updateWhenIdle: Boolean = false
	  		// If `true`, the control is updated on [`moveend`](#map-moveend), otherwise it's always up-to-date (updated on [`move`](#map-move)).
	  	},
	
	  	onAdd: function (map) {
	  		var className = 'leaflet-control-scale',
	  		    container = create$1('div', className),
	  		    options = this.options;
	
	  		this._addScales(options, className + '-line', container);
	
	  		map.on(options.updateWhenIdle ? 'moveend' : 'move', this._update, this);
	  		map.whenReady(this._update, this);
	
	  		return container;
	  	},
	
	  	onRemove: function (map) {
	  		map.off(this.options.updateWhenIdle ? 'moveend' : 'move', this._update, this);
	  	},
	
	  	_addScales: function (options, className, container) {
	  		if (options.metric) {
	  			this._mScale = create$1('div', className, container);
	  		}
	  		if (options.imperial) {
	  			this._iScale = create$1('div', className, container);
	  		}
	  	},
	
	  	_update: function () {
	  		var map = this._map,
	  		    y = map.getSize().y / 2;
	
	  		var maxMeters = map.distance(
	  			map.containerPointToLatLng([0, y]),
	  			map.containerPointToLatLng([this.options.maxWidth, y]));
	
	  		this._updateScales(maxMeters);
	  	},
	
	  	_updateScales: function (maxMeters) {
	  		if (this.options.metric && maxMeters) {
	  			this._updateMetric(maxMeters);
	  		}
	  		if (this.options.imperial && maxMeters) {
	  			this._updateImperial(maxMeters);
	  		}
	  	},
	
	  	_updateMetric: function (maxMeters) {
	  		var meters = this._getRoundNum(maxMeters),
	  		    label = meters < 1000 ? meters + ' m' : (meters / 1000) + ' km';
	
	  		this._updateScale(this._mScale, label, meters / maxMeters);
	  	},
	
	  	_updateImperial: function (maxMeters) {
	  		var maxFeet = maxMeters * 3.2808399,
	  		    maxMiles, miles, feet;
	
	  		if (maxFeet > 5280) {
	  			maxMiles = maxFeet / 5280;
	  			miles = this._getRoundNum(maxMiles);
	  			this._updateScale(this._iScale, miles + ' mi', miles / maxMiles);
	
	  		} else {
	  			feet = this._getRoundNum(maxFeet);
	  			this._updateScale(this._iScale, feet + ' ft', feet / maxFeet);
	  		}
	  	},
	
	  	_updateScale: function (scale, text, ratio) {
	  		scale.style.width = Math.round(this.options.maxWidth * ratio) + 'px';
	  		scale.innerHTML = text;
	  	},
	
	  	_getRoundNum: function (num) {
	  		var pow10 = Math.pow(10, (Math.floor(num) + '').length - 1),
	  		    d = num / pow10;
	
	  		d = d >= 10 ? 10 :
	  		    d >= 5 ? 5 :
	  		    d >= 3 ? 3 :
	  		    d >= 2 ? 2 : 1;
	
	  		return pow10 * d;
	  	}
	  });
	
	
	  // @factory L.control.scale(options?: Control.Scale options)
	  // Creates an scale control with the given options.
	  var scale = function (options) {
	  	return new Scale(options);
	  };
	
	  var ukrainianFlag = '<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="12" height="8" viewBox="0 0 12 8" class="leaflet-attribution-flag"><path fill="#4C7BE1" d="M0 0h12v4H0z"/><path fill="#FFD500" d="M0 4h12v3H0z"/><path fill="#E0BC00" d="M0 7h12v1H0z"/></svg>';
	
	
	  /*
	   * @class Control.Attribution
	   * @aka L.Control.Attribution
	   * @inherits Control
	   *
	   * The attribution control allows you to display attribution data in a small text box on a map. It is put on the map by default unless you set its [`attributionControl` option](#map-attributioncontrol) to `false`, and it fetches attribution texts from layers with the [`getAttribution` method](#layer-getattribution) automatically. Extends Control.
	   */
	
	  var Attribution = Control.extend({
	  	// @section
	  	// @aka Control.Attribution options
	  	options: {
	  		position: 'bottomright',
	
	  		// @option prefix: String|false = 'Leaflet'
	  		// The HTML text shown before the attributions. Pass `false` to disable.
	  		prefix: '<a href="https://leafletjs.com" title="A JavaScript library for interactive maps">' + (Browser.inlineSvg ? ukrainianFlag + ' ' : '') + 'Leaflet</a>'
	  	},
	
	  	initialize: function (options) {
	  		setOptions(this, options);
	
	  		this._attributions = {};
	  	},
	
	  	onAdd: function (map) {
	  		map.attributionControl = this;
	  		this._container = create$1('div', 'leaflet-control-attribution');
	  		disableClickPropagation(this._container);
	
	  		// TODO ugly, refactor
	  		for (var i in map._layers) {
	  			if (map._layers[i].getAttribution) {
	  				this.addAttribution(map._layers[i].getAttribution());
	  			}
	  		}
	
	  		this._update();
	
	  		map.on('layeradd', this._addAttribution, this);
	
	  		return this._container;
	  	},
	
	  	onRemove: function (map) {
	  		map.off('layeradd', this._addAttribution, this);
	  	},
	
	  	_addAttribution: function (ev) {
	  		if (ev.layer.getAttribution) {
	  			this.addAttribution(ev.layer.getAttribution());
	  			ev.layer.once('remove', function () {
	  				this.removeAttribution(ev.layer.getAttribution());
	  			}, this);
	  		}
	  	},
	
	  	// @method setPrefix(prefix: String|false): this
	  	// The HTML text shown before the attributions. Pass `false` to disable.
	  	setPrefix: function (prefix) {
	  		this.options.prefix = prefix;
	  		this._update();
	  		return this;
	  	},
	
	  	// @method addAttribution(text: String): this
	  	// Adds an attribution text (e.g. `'&copy; OpenStreetMap contributors'`).
	  	addAttribution: function (text) {
	  		if (!text) { return this; }
	
	  		if (!this._attributions[text]) {
	  			this._attributions[text] = 0;
	  		}
	  		this._attributions[text]++;
	
	  		this._update();
	
	  		return this;
	  	},
	
	  	// @method removeAttribution(text: String): this
	  	// Removes an attribution text.
	  	removeAttribution: function (text) {
	  		if (!text) { return this; }
	
	  		if (this._attributions[text]) {
	  			this._attributions[text]--;
	  			this._update();
	  		}
	
	  		return this;
	  	},
	
	  	_update: function () {
	  		if (!this._map) { return; }
	
	  		var attribs = [];
	
	  		for (var i in this._attributions) {
	  			if (this._attributions[i]) {
	  				attribs.push(i);
	  			}
	  		}
	
	  		var prefixAndAttribs = [];
	
	  		if (this.options.prefix) {
	  			prefixAndAttribs.push(this.options.prefix);
	  		}
	  		if (attribs.length) {
	  			prefixAndAttribs.push(attribs.join(', '));
	  		}
	
	  		this._container.innerHTML = prefixAndAttribs.join(' <span aria-hidden="true">|</span> ');
	  	}
	  });
	
	  // @namespace Map
	  // @section Control options
	  // @option attributionControl: Boolean = true
	  // Whether a [attribution control](#control-attribution) is added to the map by default.
	  Map.mergeOptions({
	  	attributionControl: true
	  });
	
	  Map.addInitHook(function () {
	  	if (this.options.attributionControl) {
	  		new Attribution().addTo(this);
	  	}
	  });
	
	  // @namespace Control.Attribution
	  // @factory L.control.attribution(options: Control.Attribution options)
	  // Creates an attribution control.
	  var attribution = function (options) {
	  	return new Attribution(options);
	  };
	
	  Control.Layers = Layers;
	  Control.Zoom = Zoom;
	  Control.Scale = Scale;
	  Control.Attribution = Attribution;
	
	  control.layers = layers;
	  control.zoom = zoom;
	  control.scale = scale;
	  control.attribution = attribution;
	
	  /*
	  	L.Handler is a base class for handler classes that are used internally to inject
	  	interaction features like dragging to classes like Map and Marker.
	  */
	
	  // @class Handler
	  // @aka L.Handler
	  // Abstract class for map interaction handlers
	
	  var Handler = Class.extend({
	  	initialize: function (map) {
	  		this._map = map;
	  	},
	
	  	// @method enable(): this
	  	// Enables the handler
	  	enable: function () {
	  		if (this._enabled) { return this; }
	
	  		this._enabled = true;
	  		this.addHooks();
	  		return this;
	  	},
	
	  	// @method disable(): this
	  	// Disables the handler
	  	disable: function () {
	  		if (!this._enabled) { return this; }
	
	  		this._enabled = false;
	  		this.removeHooks();
	  		return this;
	  	},
	
	  	// @method enabled(): Boolean
	  	// Returns `true` if the handler is enabled
	  	enabled: function () {
	  		return !!this._enabled;
	  	}
	
	  	// @section Extension methods
	  	// Classes inheriting from `Handler` must implement the two following methods:
	  	// @method addHooks()
	  	// Called when the handler is enabled, should add event hooks.
	  	// @method removeHooks()
	  	// Called when the handler is disabled, should remove the event hooks added previously.
	  });
	
	  // @section There is static function which can be called without instantiating L.Handler:
	  // @function addTo(map: Map, name: String): this
	  // Adds a new Handler to the given map with the given name.
	  Handler.addTo = function (map, name) {
	  	map.addHandler(name, this);
	  	return this;
	  };
	
	  var Mixin = {Events: Events};
	
	  /*
	   * @class Draggable
	   * @aka L.Draggable
	   * @inherits Evented
	   *
	   * A class for making DOM elements draggable (including touch support).
	   * Used internally for map and marker dragging. Only works for elements
	   * that were positioned with [`L.DomUtil.setPosition`](#domutil-setposition).
	   *
	   * @example
	   * ```js
	   * var draggable = new L.Draggable(elementToDrag);
	   * draggable.enable();
	   * ```
	   */
	
	  var START = Browser.touch ? 'touchstart mousedown' : 'mousedown';
	
	  var Draggable = Evented.extend({
	
	  	options: {
	  		// @section
	  		// @aka Draggable options
	  		// @option clickTolerance: Number = 3
	  		// The max number of pixels a user can shift the mouse pointer during a click
	  		// for it to be considered a valid click (as opposed to a mouse drag).
	  		clickTolerance: 3
	  	},
	
	  	// @constructor L.Draggable(el: HTMLElement, dragHandle?: HTMLElement, preventOutline?: Boolean, options?: Draggable options)
	  	// Creates a `Draggable` object for moving `el` when you start dragging the `dragHandle` element (equals `el` itself by default).
	  	initialize: function (element, dragStartTarget, preventOutline, options) {
	  		setOptions(this, options);
	
	  		this._element = element;
	  		this._dragStartTarget = dragStartTarget || element;
	  		this._preventOutline = preventOutline;
	  	},
	
	  	// @method enable()
	  	// Enables the dragging ability
	  	enable: function () {
	  		if (this._enabled) { return; }
	
	  		on(this._dragStartTarget, START, this._onDown, this);
	
	  		this._enabled = true;
	  	},
	
	  	// @method disable()
	  	// Disables the dragging ability
	  	disable: function () {
	  		if (!this._enabled) { return; }
	
	  		// If we're currently dragging this draggable,
	  		// disabling it counts as first ending the drag.
	  		if (Draggable._dragging === this) {
	  			this.finishDrag(true);
	  		}
	
	  		off(this._dragStartTarget, START, this._onDown, this);
	
	  		this._enabled = false;
	  		this._moved = false;
	  	},
	
	  	_onDown: function (e) {
	  		// Ignore the event if disabled; this happens in IE11
	  		// under some circumstances, see #3666.
	  		if (!this._enabled) { return; }
	
	  		this._moved = false;
	
	  		if (hasClass(this._element, 'leaflet-zoom-anim')) { return; }
	
	  		if (e.touches && e.touches.length !== 1) {
	  			// Finish dragging to avoid conflict with touchZoom
	  			if (Draggable._dragging === this) {
	  				this.finishDrag();
	  			}
	  			return;
	  		}
	
	  		if (Draggable._dragging || e.shiftKey || ((e.which !== 1) && (e.button !== 1) && !e.touches)) { return; }
	  		Draggable._dragging = this;  // Prevent dragging multiple objects at once.
	
	  		if (this._preventOutline) {
	  			preventOutline(this._element);
	  		}
	
	  		disableImageDrag();
	  		disableTextSelection();
	
	  		if (this._moving) { return; }
	
	  		// @event down: Event
	  		// Fired when a drag is about to start.
	  		this.fire('down');
	
	  		var first = e.touches ? e.touches[0] : e,
	  		    sizedParent = getSizedParentNode(this._element);
	
	  		this._startPoint = new Point(first.clientX, first.clientY);
	  		this._startPos = getPosition(this._element);
	
	  		// Cache the scale, so that we can continuously compensate for it during drag (_onMove).
	  		this._parentScale = getScale(sizedParent);
	
	  		var mouseevent = e.type === 'mousedown';
	  		on(document, mouseevent ? 'mousemove' : 'touchmove', this._onMove, this);
	  		on(document, mouseevent ? 'mouseup' : 'touchend touchcancel', this._onUp, this);
	  	},
	
	  	_onMove: function (e) {
	  		// Ignore the event if disabled; this happens in IE11
	  		// under some circumstances, see #3666.
	  		if (!this._enabled) { return; }
	
	  		if (e.touches && e.touches.length > 1) {
	  			this._moved = true;
	  			return;
	  		}
	
	  		var first = (e.touches && e.touches.length === 1 ? e.touches[0] : e),
	  		    offset = new Point(first.clientX, first.clientY)._subtract(this._startPoint);
	
	  		if (!offset.x && !offset.y) { return; }
	  		if (Math.abs(offset.x) + Math.abs(offset.y) < this.options.clickTolerance) { return; }
	
	  		// We assume that the parent container's position, border and scale do not change for the duration of the drag.
	  		// Therefore there is no need to account for the position and border (they are eliminated by the subtraction)
	  		// and we can use the cached value for the scale.
	  		offset.x /= this._parentScale.x;
	  		offset.y /= this._parentScale.y;
	
	  		preventDefault(e);
	
	  		if (!this._moved) {
	  			// @event dragstart: Event
	  			// Fired when a drag starts
	  			this.fire('dragstart');
	
	  			this._moved = true;
	
	  			addClass(document.body, 'leaflet-dragging');
	
	  			this._lastTarget = e.target || e.srcElement;
	  			// IE and Edge do not give the <use> element, so fetch it
	  			// if necessary
	  			if (window.SVGElementInstance && this._lastTarget instanceof window.SVGElementInstance) {
	  				this._lastTarget = this._lastTarget.correspondingUseElement;
	  			}
	  			addClass(this._lastTarget, 'leaflet-drag-target');
	  		}
	
	  		this._newPos = this._startPos.add(offset);
	  		this._moving = true;
	
	  		this._lastEvent = e;
	  		this._updatePosition();
	  	},
	
	  	_updatePosition: function () {
	  		var e = {originalEvent: this._lastEvent};
	
	  		// @event predrag: Event
	  		// Fired continuously during dragging *before* each corresponding
	  		// update of the element's position.
	  		this.fire('predrag', e);
	  		setPosition(this._element, this._newPos);
	
	  		// @event drag: Event
	  		// Fired continuously during dragging.
	  		this.fire('drag', e);
	  	},
	
	  	_onUp: function () {
	  		// Ignore the event if disabled; this happens in IE11
	  		// under some circumstances, see #3666.
	  		if (!this._enabled) { return; }
	  		this.finishDrag();
	  	},
	
	  	finishDrag: function (noInertia) {
	  		removeClass(document.body, 'leaflet-dragging');
	
	  		if (this._lastTarget) {
	  			removeClass(this._lastTarget, 'leaflet-drag-target');
	  			this._lastTarget = null;
	  		}
	
	  		off(document, 'mousemove touchmove', this._onMove, this);
	  		off(document, 'mouseup touchend touchcancel', this._onUp, this);
	
	  		enableImageDrag();
	  		enableTextSelection();
	
	  		var fireDragend = this._moved && this._moving;
	
	  		this._moving = false;
	  		Draggable._dragging = false;
	
	  		if (fireDragend) {
	  			// @event dragend: DragEndEvent
	  			// Fired when the drag ends.
	  			this.fire('dragend', {
	  				noInertia: noInertia,
	  				distance: this._newPos.distanceTo(this._startPos)
	  			});
	  		}
	  	}
	
	  });
	
	  /*
	   * @namespace PolyUtil
	   * Various utility functions for polygon geometries.
	   */
	
	  /* @function clipPolygon(points: Point[], bounds: Bounds, round?: Boolean): Point[]
	   * Clips the polygon geometry defined by the given `points` by the given bounds (using the [Sutherland-Hodgman algorithm](https://en.wikipedia.org/wiki/Sutherland%E2%80%93Hodgman_algorithm)).
	   * Used by Leaflet to only show polygon points that are on the screen or near, increasing
	   * performance. Note that polygon points needs different algorithm for clipping
	   * than polyline, so there's a separate method for it.
	   */
	  function clipPolygon(points, bounds, round) {
	  	var clippedPoints,
	  	    edges = [1, 4, 2, 8],
	  	    i, j, k,
	  	    a, b,
	  	    len, edge, p;
	
	  	for (i = 0, len = points.length; i < len; i++) {
	  		points[i]._code = _getBitCode(points[i], bounds);
	  	}
	
	  	// for each edge (left, bottom, right, top)
	  	for (k = 0; k < 4; k++) {
	  		edge = edges[k];
	  		clippedPoints = [];
	
	  		for (i = 0, len = points.length, j = len - 1; i < len; j = i++) {
	  			a = points[i];
	  			b = points[j];
	
	  			// if a is inside the clip window
	  			if (!(a._code & edge)) {
	  				// if b is outside the clip window (a->b goes out of screen)
	  				if (b._code & edge) {
	  					p = _getEdgeIntersection(b, a, edge, bounds, round);
	  					p._code = _getBitCode(p, bounds);
	  					clippedPoints.push(p);
	  				}
	  				clippedPoints.push(a);
	
	  			// else if b is inside the clip window (a->b enters the screen)
	  			} else if (!(b._code & edge)) {
	  				p = _getEdgeIntersection(b, a, edge, bounds, round);
	  				p._code = _getBitCode(p, bounds);
	  				clippedPoints.push(p);
	  			}
	  		}
	  		points = clippedPoints;
	  	}
	
	  	return points;
	  }
	
	  /* @function polygonCenter(latlngs: LatLng[], crs: CRS): LatLng
	   * Returns the center ([centroid](http://en.wikipedia.org/wiki/Centroid)) of the passed LatLngs (first ring) from a polygon.
	   */
	  function polygonCenter(latlngs, crs) {
	  	var i, j, p1, p2, f, area, x, y, center;
	
	  	if (!latlngs || latlngs.length === 0) {
	  		throw new Error('latlngs not passed');
	  	}
	
	  	if (!isFlat(latlngs)) {
	  		console.warn('latlngs are not flat! Only the first ring will be used');
	  		latlngs = latlngs[0];
	  	}
	
	  	var centroidLatLng = toLatLng([0, 0]);
	
	  	var bounds = toLatLngBounds(latlngs);
	  	var areaBounds = bounds.getNorthWest().distanceTo(bounds.getSouthWest()) * bounds.getNorthEast().distanceTo(bounds.getNorthWest());
	  	// tests showed that below 1700 rounding errors are happening
	  	if (areaBounds < 1700) {
	  		// getting a inexact center, to move the latlngs near to [0, 0] to prevent rounding errors
	  		centroidLatLng = centroid(latlngs);
	  	}
	
	  	var len = latlngs.length;
	  	var points = [];
	  	for (i = 0; i < len; i++) {
	  		var latlng = toLatLng(latlngs[i]);
	  		points.push(crs.project(toLatLng([latlng.lat - centroidLatLng.lat, latlng.lng - centroidLatLng.lng])));
	  	}
	
	  	area = x = y = 0;
	
	  	// polygon centroid algorithm;
	  	for (i = 0, j = len - 1; i < len; j = i++) {
	  		p1 = points[i];
	  		p2 = points[j];
	
	  		f = p1.y * p2.x - p2.y * p1.x;
	  		x += (p1.x + p2.x) * f;
	  		y += (p1.y + p2.y) * f;
	  		area += f * 3;
	  	}
	
	  	if (area === 0) {
	  		// Polygon is so small that all points are on same pixel.
	  		center = points[0];
	  	} else {
	  		center = [x / area, y / area];
	  	}
	
	  	var latlngCenter = crs.unproject(toPoint(center));
	  	return toLatLng([latlngCenter.lat + centroidLatLng.lat, latlngCenter.lng + centroidLatLng.lng]);
	  }
	
	  /* @function centroid(latlngs: LatLng[]): LatLng
	   * Returns the 'center of mass' of the passed LatLngs.
	   */
	  function centroid(coords) {
	  	var latSum = 0;
	  	var lngSum = 0;
	  	var len = 0;
	  	for (var i = 0; i < coords.length; i++) {
	  		var latlng = toLatLng(coords[i]);
	  		latSum += latlng.lat;
	  		lngSum += latlng.lng;
	  		len++;
	  	}
	  	return toLatLng([latSum / len, lngSum / len]);
	  }
	
	  var PolyUtil = {
	    __proto__: null,
	    clipPolygon: clipPolygon,
	    polygonCenter: polygonCenter,
	    centroid: centroid
	  };
	
	  /*
	   * @namespace LineUtil
	   *
	   * Various utility functions for polyline points processing, used by Leaflet internally to make polylines lightning-fast.
	   */
	
	  // Simplify polyline with vertex reduction and Douglas-Peucker simplification.
	  // Improves rendering performance dramatically by lessening the number of points to draw.
	
	  // @function simplify(points: Point[], tolerance: Number): Point[]
	  // Dramatically reduces the number of points in a polyline while retaining
	  // its shape and returns a new array of simplified points, using the
	  // [Ramer-Douglas-Peucker algorithm](https://en.wikipedia.org/wiki/Ramer-Douglas-Peucker_algorithm).
	  // Used for a huge performance boost when processing/displaying Leaflet polylines for
	  // each zoom level and also reducing visual noise. tolerance affects the amount of
	  // simplification (lesser value means higher quality but slower and with more points).
	  // Also released as a separated micro-library [Simplify.js](https://mourner.github.io/simplify-js/).
	  function simplify(points, tolerance) {
	  	if (!tolerance || !points.length) {
	  		return points.slice();
	  	}
	
	  	var sqTolerance = tolerance * tolerance;
	
	  	    // stage 1: vertex reduction
	  	    points = _reducePoints(points, sqTolerance);
	
	  	    // stage 2: Douglas-Peucker simplification
	  	    points = _simplifyDP(points, sqTolerance);
	
	  	return points;
	  }
	
	  // @function pointToSegmentDistance(p: Point, p1: Point, p2: Point): Number
	  // Returns the distance between point `p` and segment `p1` to `p2`.
	  function pointToSegmentDistance(p, p1, p2) {
	  	return Math.sqrt(_sqClosestPointOnSegment(p, p1, p2, true));
	  }
	
	  // @function closestPointOnSegment(p: Point, p1: Point, p2: Point): Number
	  // Returns the closest point from a point `p` on a segment `p1` to `p2`.
	  function closestPointOnSegment(p, p1, p2) {
	  	return _sqClosestPointOnSegment(p, p1, p2);
	  }
	
	  // Ramer-Douglas-Peucker simplification, see https://en.wikipedia.org/wiki/Ramer-Douglas-Peucker_algorithm
	  function _simplifyDP(points, sqTolerance) {
	
	  	var len = points.length,
	  	    ArrayConstructor = typeof Uint8Array !== undefined + '' ? Uint8Array : Array,
	  	    markers = new ArrayConstructor(len);
	
	  	    markers[0] = markers[len - 1] = 1;
	
	  	_simplifyDPStep(points, markers, sqTolerance, 0, len - 1);
	
	  	var i,
	  	    newPoints = [];
	
	  	for (i = 0; i < len; i++) {
	  		if (markers[i]) {
	  			newPoints.push(points[i]);
	  		}
	  	}
	
	  	return newPoints;
	  }
	
	  function _simplifyDPStep(points, markers, sqTolerance, first, last) {
	
	  	var maxSqDist = 0,
	  	index, i, sqDist;
	
	  	for (i = first + 1; i <= last - 1; i++) {
	  		sqDist = _sqClosestPointOnSegment(points[i], points[first], points[last], true);
	
	  		if (sqDist > maxSqDist) {
	  			index = i;
	  			maxSqDist = sqDist;
	  		}
	  	}
	
	  	if (maxSqDist > sqTolerance) {
	  		markers[index] = 1;
	
	  		_simplifyDPStep(points, markers, sqTolerance, first, index);
	  		_simplifyDPStep(points, markers, sqTolerance, index, last);
	  	}
	  }
	
	  // reduce points that are too close to each other to a single point
	  function _reducePoints(points, sqTolerance) {
	  	var reducedPoints = [points[0]];
	
	  	for (var i = 1, prev = 0, len = points.length; i < len; i++) {
	  		if (_sqDist(points[i], points[prev]) > sqTolerance) {
	  			reducedPoints.push(points[i]);
	  			prev = i;
	  		}
	  	}
	  	if (prev < len - 1) {
	  		reducedPoints.push(points[len - 1]);
	  	}
	  	return reducedPoints;
	  }
	
	  var _lastCode;
	
	  // @function clipSegment(a: Point, b: Point, bounds: Bounds, useLastCode?: Boolean, round?: Boolean): Point[]|Boolean
	  // Clips the segment a to b by rectangular bounds with the
	  // [Cohen-Sutherland algorithm](https://en.wikipedia.org/wiki/Cohen%E2%80%93Sutherland_algorithm)
	  // (modifying the segment points directly!). Used by Leaflet to only show polyline
	  // points that are on the screen or near, increasing performance.
	  function clipSegment(a, b, bounds, useLastCode, round) {
	  	var codeA = useLastCode ? _lastCode : _getBitCode(a, bounds),
	  	    codeB = _getBitCode(b, bounds),
	
	  	    codeOut, p, newCode;
	
	  	    // save 2nd code to avoid calculating it on the next segment
	  	    _lastCode = codeB;
	
	  	while (true) {
	  		// if a,b is inside the clip window (trivial accept)
	  		if (!(codeA | codeB)) {
	  			return [a, b];
	  		}
	
	  		// if a,b is outside the clip window (trivial reject)
	  		if (codeA & codeB) {
	  			return false;
	  		}
	
	  		// other cases
	  		codeOut = codeA || codeB;
	  		p = _getEdgeIntersection(a, b, codeOut, bounds, round);
	  		newCode = _getBitCode(p, bounds);
	
	  		if (codeOut === codeA) {
	  			a = p;
	  			codeA = newCode;
	  		} else {
	  			b = p;
	  			codeB = newCode;
	  		}
	  	}
	  }
	
	  function _getEdgeIntersection(a, b, code, bounds, round) {
	  	var dx = b.x - a.x,
	  	    dy = b.y - a.y,
	  	    min = bounds.min,
	  	    max = bounds.max,
	  	    x, y;
	
	  	if (code & 8) { // top
	  		x = a.x + dx * (max.y - a.y) / dy;
	  		y = max.y;
	
	  	} else if (code & 4) { // bottom
	  		x = a.x + dx * (min.y - a.y) / dy;
	  		y = min.y;
	
	  	} else if (code & 2) { // right
	  		x = max.x;
	  		y = a.y + dy * (max.x - a.x) / dx;
	
	  	} else if (code & 1) { // left
	  		x = min.x;
	  		y = a.y + dy * (min.x - a.x) / dx;
	  	}
	
	  	return new Point(x, y, round);
	  }
	
	  function _getBitCode(p, bounds) {
	  	var code = 0;
	
	  	if (p.x < bounds.min.x) { // left
	  		code |= 1;
	  	} else if (p.x > bounds.max.x) { // right
	  		code |= 2;
	  	}
	
	  	if (p.y < bounds.min.y) { // bottom
	  		code |= 4;
	  	} else if (p.y > bounds.max.y) { // top
	  		code |= 8;
	  	}
	
	  	return code;
	  }
	
	  // square distance (to avoid unnecessary Math.sqrt calls)
	  function _sqDist(p1, p2) {
	  	var dx = p2.x - p1.x,
	  	    dy = p2.y - p1.y;
	  	return dx * dx + dy * dy;
	  }
	
	  // return closest point on segment or distance to that point
	  function _sqClosestPointOnSegment(p, p1, p2, sqDist) {
	  	var x = p1.x,
	  	    y = p1.y,
	  	    dx = p2.x - x,
	  	    dy = p2.y - y,
	  	    dot = dx * dx + dy * dy,
	  	    t;
	
	  	if (dot > 0) {
	  		t = ((p.x - x) * dx + (p.y - y) * dy) / dot;
	
	  		if (t > 1) {
	  			x = p2.x;
	  			y = p2.y;
	  		} else if (t > 0) {
	  			x += dx * t;
	  			y += dy * t;
	  		}
	  	}
	
	  	dx = p.x - x;
	  	dy = p.y - y;
	
	  	return sqDist ? dx * dx + dy * dy : new Point(x, y);
	  }
	
	
	  // @function isFlat(latlngs: LatLng[]): Boolean
	  // Returns true if `latlngs` is a flat array, false is nested.
	  function isFlat(latlngs) {
	  	return !isArray(latlngs[0]) || (typeof latlngs[0][0] !== 'object' && typeof latlngs[0][0] !== 'undefined');
	  }
	
	  function _flat(latlngs) {
	  	console.warn('Deprecated use of _flat, please use L.LineUtil.isFlat instead.');
	  	return isFlat(latlngs);
	  }
	
	  /* @function polylineCenter(latlngs: LatLng[], crs: CRS): LatLng
	   * Returns the center ([centroid](http://en.wikipedia.org/wiki/Centroid)) of the passed LatLngs (first ring) from a polyline.
	   */
	  function polylineCenter(latlngs, crs) {
	  	var i, halfDist, segDist, dist, p1, p2, ratio, center;
	
	  	if (!latlngs || latlngs.length === 0) {
	  		throw new Error('latlngs not passed');
	  	}
	
	  	if (!isFlat(latlngs)) {
	  		console.warn('latlngs are not flat! Only the first ring will be used');
	  		latlngs = latlngs[0];
	  	}
	
	  	var centroidLatLng = toLatLng([0, 0]);
	
	  	var bounds = toLatLngBounds(latlngs);
	  	var areaBounds = bounds.getNorthWest().distanceTo(bounds.getSouthWest()) * bounds.getNorthEast().distanceTo(bounds.getNorthWest());
	  	// tests showed that below 1700 rounding errors are happening
	  	if (areaBounds < 1700) {
	  		// getting a inexact center, to move the latlngs near to [0, 0] to prevent rounding errors
	  		centroidLatLng = centroid(latlngs);
	  	}
	
	  	var len = latlngs.length;
	  	var points = [];
	  	for (i = 0; i < len; i++) {
	  		var latlng = toLatLng(latlngs[i]);
	  		points.push(crs.project(toLatLng([latlng.lat - centroidLatLng.lat, latlng.lng - centroidLatLng.lng])));
	  	}
	
	  	for (i = 0, halfDist = 0; i < len - 1; i++) {
	  		halfDist += points[i].distanceTo(points[i + 1]) / 2;
	  	}
	
	  	// The line is so small in the current view that all points are on the same pixel.
	  	if (halfDist === 0) {
	  		center = points[0];
	  	} else {
	  		for (i = 0, dist = 0; i < len - 1; i++) {
	  			p1 = points[i];
	  			p2 = points[i + 1];
	  			segDist = p1.distanceTo(p2);
	  			dist += segDist;
	
	  			if (dist > halfDist) {
	  				ratio = (dist - halfDist) / segDist;
	  				center = [
	  					p2.x - ratio * (p2.x - p1.x),
	  					p2.y - ratio * (p2.y - p1.y)
	  				];
	  				break;
	  			}
	  		}
	  	}
	
	  	var latlngCenter = crs.unproject(toPoint(center));
	  	return toLatLng([latlngCenter.lat + centroidLatLng.lat, latlngCenter.lng + centroidLatLng.lng]);
	  }
	
	  var LineUtil = {
	    __proto__: null,
	    simplify: simplify,
	    pointToSegmentDistance: pointToSegmentDistance,
	    closestPointOnSegment: closestPointOnSegment,
	    clipSegment: clipSegment,
	    _getEdgeIntersection: _getEdgeIntersection,
	    _getBitCode: _getBitCode,
	    _sqClosestPointOnSegment: _sqClosestPointOnSegment,
	    isFlat: isFlat,
	    _flat: _flat,
	    polylineCenter: polylineCenter
	  };
	
	  /*
	   * @namespace Projection
	   * @section
	   * Leaflet comes with a set of already defined Projections out of the box:
	   *
	   * @projection L.Projection.LonLat
	   *
	   * Equirectangular, or Plate Carree projection — the most simple projection,
	   * mostly used by GIS enthusiasts. Directly maps `x` as longitude, and `y` as
	   * latitude. Also suitable for flat worlds, e.g. game maps. Used by the
	   * `EPSG:4326` and `Simple` CRS.
	   */
	
	  var LonLat = {
	  	project: function (latlng) {
	  		return new Point(latlng.lng, latlng.lat);
	  	},
	
	  	unproject: function (point) {
	  		return new LatLng(point.y, point.x);
	  	},
	
	  	bounds: new Bounds([-180, -90], [180, 90])
	  };
	
	  /*
	   * @namespace Projection
	   * @projection L.Projection.Mercator
	   *
	   * Elliptical Mercator projection — more complex than Spherical Mercator. Assumes that Earth is an ellipsoid. Used by the EPSG:3395 CRS.
	   */
	
	  var Mercator = {
	  	R: 6378137,
	  	R_MINOR: 6356752.314245179,
	
	  	bounds: new Bounds([-20037508.34279, -15496570.73972], [20037508.34279, 18764656.23138]),
	
	  	project: function (latlng) {
	  		var d = Math.PI / 180,
	  		    r = this.R,
	  		    y = latlng.lat * d,
	  		    tmp = this.R_MINOR / r,
	  		    e = Math.sqrt(1 - tmp * tmp),
	  		    con = e * Math.sin(y);
	
	  		var ts = Math.tan(Math.PI / 4 - y / 2) / Math.pow((1 - con) / (1 + con), e / 2);
	  		y = -r * Math.log(Math.max(ts, 1E-10));
	
	  		return new Point(latlng.lng * d * r, y);
	  	},
	
	  	unproject: function (point) {
	  		var d = 180 / Math.PI,
	  		    r = this.R,
	  		    tmp = this.R_MINOR / r,
	  		    e = Math.sqrt(1 - tmp * tmp),
	  		    ts = Math.exp(-point.y / r),
	  		    phi = Math.PI / 2 - 2 * Math.atan(ts);
	
	  		for (var i = 0, dphi = 0.1, con; i < 15 && Math.abs(dphi) > 1e-7; i++) {
	  			con = e * Math.sin(phi);
	  			con = Math.pow((1 - con) / (1 + con), e / 2);
	  			dphi = Math.PI / 2 - 2 * Math.atan(ts * con) - phi;
	  			phi += dphi;
	  		}
	
	  		return new LatLng(phi * d, point.x * d / r);
	  	}
	  };
	
	  /*
	   * @class Projection
	
	   * An object with methods for projecting geographical coordinates of the world onto
	   * a flat surface (and back). See [Map projection](https://en.wikipedia.org/wiki/Map_projection).
	
	   * @property bounds: Bounds
	   * The bounds (specified in CRS units) where the projection is valid
	
	   * @method project(latlng: LatLng): Point
	   * Projects geographical coordinates into a 2D point.
	   * Only accepts actual `L.LatLng` instances, not arrays.
	
	   * @method unproject(point: Point): LatLng
	   * The inverse of `project`. Projects a 2D point into a geographical location.
	   * Only accepts actual `L.Point` instances, not arrays.
	
	   * Note that the projection instances do not inherit from Leaflet's `Class` object,
	   * and can't be instantiated. Also, new classes can't inherit from them,
	   * and methods can't be added to them with the `include` function.
	
	   */
	
	  var index = {
	    __proto__: null,
	    LonLat: LonLat,
	    Mercator: Mercator,
	    SphericalMercator: SphericalMercator
	  };
	
	  /*
	   * @namespace CRS
	   * @crs L.CRS.EPSG3395
	   *
	   * Rarely used by some commercial tile providers. Uses Elliptical Mercator projection.
	   */
	  var EPSG3395 = extend({}, Earth, {
	  	code: 'EPSG:3395',
	  	projection: Mercator,
	
	  	transformation: (function () {
	  		var scale = 0.5 / (Math.PI * Mercator.R);
	  		return toTransformation(scale, 0.5, -scale, 0.5);
	  	}())
	  });
	
	  /*
	   * @namespace CRS
	   * @crs L.CRS.EPSG4326
	   *
	   * A common CRS among GIS enthusiasts. Uses simple Equirectangular projection.
	   *
	   * Leaflet 1.0.x complies with the [TMS coordinate scheme for EPSG:4326](https://wiki.osgeo.org/wiki/Tile_Map_Service_Specification#global-geodetic),
	   * which is a breaking change from 0.7.x behaviour.  If you are using a `TileLayer`
	   * with this CRS, ensure that there are two 256x256 pixel tiles covering the
	   * whole earth at zoom level zero, and that the tile coordinate origin is (-180,+90),
	   * or (-180,-90) for `TileLayer`s with [the `tms` option](#tilelayer-tms) set.
	   */
	
	  var EPSG4326 = extend({}, Earth, {
	  	code: 'EPSG:4326',
	  	projection: LonLat,
	  	transformation: toTransformation(1 / 180, 1, -1 / 180, 0.5)
	  });
	
	  /*
	   * @namespace CRS
	   * @crs L.CRS.Simple
	   *
	   * A simple CRS that maps longitude and latitude into `x` and `y` directly.
	   * May be used for maps of flat surfaces (e.g. game maps). Note that the `y`
	   * axis should still be inverted (going from bottom to top). `distance()` returns
	   * simple euclidean distance.
	   */
	
	  var Simple = extend({}, CRS, {
	  	projection: LonLat,
	  	transformation: toTransformation(1, 0, -1, 0),
	
	  	scale: function (zoom) {
	  		return Math.pow(2, zoom);
	  	},
	
	  	zoom: function (scale) {
	  		return Math.log(scale) / Math.LN2;
	  	},
	
	  	distance: function (latlng1, latlng2) {
	  		var dx = latlng2.lng - latlng1.lng,
	  		    dy = latlng2.lat - latlng1.lat;
	
	  		return Math.sqrt(dx * dx + dy * dy);
	  	},
	
	  	infinite: true
	  });
	
	  CRS.Earth = Earth;
	  CRS.EPSG3395 = EPSG3395;
	  CRS.EPSG3857 = EPSG3857;
	  CRS.EPSG900913 = EPSG900913;
	  CRS.EPSG4326 = EPSG4326;
	  CRS.Simple = Simple;
	
	  /*
	   * @class Layer
	   * @inherits Evented
	   * @aka L.Layer
	   * @aka ILayer
	   *
	   * A set of methods from the Layer base class that all Leaflet layers use.
	   * Inherits all methods, options and events from `L.Evented`.
	   *
	   * @example
	   *
	   * ```js
	   * var layer = L.marker(latlng).addTo(map);
	   * layer.addTo(map);
	   * layer.remove();
	   * ```
	   *
	   * @event add: Event
	   * Fired after the layer is added to a map
	   *
	   * @event remove: Event
	   * Fired after the layer is removed from a map
	   */
	
	
	  var Layer = Evented.extend({
	
	  	// Classes extending `L.Layer` will inherit the following options:
	  	options: {
	  		// @option pane: String = 'overlayPane'
	  		// By default the layer will be added to the map's [overlay pane](#map-overlaypane). Overriding this option will cause the layer to be placed on another pane by default.
	  		pane: 'overlayPane',
	
	  		// @option attribution: String = null
	  		// String to be shown in the attribution control, e.g. "© OpenStreetMap contributors". It describes the layer data and is often a legal obligation towards copyright holders and tile providers.
	  		attribution: null,
	
	  		bubblingMouseEvents: true
	  	},
	
	  	/* @section
	  	 * Classes extending `L.Layer` will inherit the following methods:
	  	 *
	  	 * @method addTo(map: Map|LayerGroup): this
	  	 * Adds the layer to the given map or layer group.
	  	 */
	  	addTo: function (map) {
	  		map.addLayer(this);
	  		return this;
	  	},
	
	  	// @method remove: this
	  	// Removes the layer from the map it is currently active on.
	  	remove: function () {
	  		return this.removeFrom(this._map || this._mapToAdd);
	  	},
	
	  	// @method removeFrom(map: Map): this
	  	// Removes the layer from the given map
	  	//
	  	// @alternative
	  	// @method removeFrom(group: LayerGroup): this
	  	// Removes the layer from the given `LayerGroup`
	  	removeFrom: function (obj) {
	  		if (obj) {
	  			obj.removeLayer(this);
	  		}
	  		return this;
	  	},
	
	  	// @method getPane(name? : String): HTMLElement
	  	// Returns the `HTMLElement` representing the named pane on the map. If `name` is omitted, returns the pane for this layer.
	  	getPane: function (name) {
	  		return this._map.getPane(name ? (this.options[name] || name) : this.options.pane);
	  	},
	
	  	addInteractiveTarget: function (targetEl) {
	  		this._map._targets[stamp(targetEl)] = this;
	  		return this;
	  	},
	
	  	removeInteractiveTarget: function (targetEl) {
	  		delete this._map._targets[stamp(targetEl)];
	  		return this;
	  	},
	
	  	// @method getAttribution: String
	  	// Used by the `attribution control`, returns the [attribution option](#gridlayer-attribution).
	  	getAttribution: function () {
	  		return this.options.attribution;
	  	},
	
	  	_layerAdd: function (e) {
	  		var map = e.target;
	
	  		// check in case layer gets added and then removed before the map is ready
	  		if (!map.hasLayer(this)) { return; }
	
	  		this._map = map;
	  		this._zoomAnimated = map._zoomAnimated;
	
	  		if (this.getEvents) {
	  			var events = this.getEvents();
	  			map.on(events, this);
	  			this.once('remove', function () {
	  				map.off(events, this);
	  			}, this);
	  		}
	
	  		this.onAdd(map);
	
	  		this.fire('add');
	  		map.fire('layeradd', {layer: this});
	  	}
	  });
	
	  /* @section Extension methods
	   * @uninheritable
	   *
	   * Every layer should extend from `L.Layer` and (re-)implement the following methods.
	   *
	   * @method onAdd(map: Map): this
	   * Should contain code that creates DOM elements for the layer, adds them to `map panes` where they should belong and puts listeners on relevant map events. Called on [`map.addLayer(layer)`](#map-addlayer).
	   *
	   * @method onRemove(map: Map): this
	   * Should contain all clean up code that removes the layer's elements from the DOM and removes listeners previously added in [`onAdd`](#layer-onadd). Called on [`map.removeLayer(layer)`](#map-removelayer).
	   *
	   * @method getEvents(): Object
	   * This optional method should return an object like `{ viewreset: this._reset }` for [`addEventListener`](#evented-addeventlistener). The event handlers in this object will be automatically added and removed from the map with your layer.
	   *
	   * @method getAttribution(): String
	   * This optional method should return a string containing HTML to be shown on the `Attribution control` whenever the layer is visible.
	   *
	   * @method beforeAdd(map: Map): this
	   * Optional method. Called on [`map.addLayer(layer)`](#map-addlayer), before the layer is added to the map, before events are initialized, without waiting until the map is in a usable state. Use for early initialization only.
	   */
	
	
	  /* @namespace Map
	   * @section Layer events
	   *
	   * @event layeradd: LayerEvent
	   * Fired when a new layer is added to the map.
	   *
	   * @event layerremove: LayerEvent
	   * Fired when some layer is removed from the map
	   *
	   * @section Methods for Layers and Controls
	   */
	  Map.include({
	  	// @method addLayer(layer: Layer): this
	  	// Adds the given layer to the map
	  	addLayer: function (layer) {
	  		if (!layer._layerAdd) {
	  			throw new Error('The provided object is not a Layer.');
	  		}
	
	  		var id = stamp(layer);
	  		if (this._layers[id]) { return this; }
	  		this._layers[id] = layer;
	
	  		layer._mapToAdd = this;
	
	  		if (layer.beforeAdd) {
	  			layer.beforeAdd(this);
	  		}
	
	  		this.whenReady(layer._layerAdd, layer);
	
	  		return this;
	  	},
	
	  	// @method removeLayer(layer: Layer): this
	  	// Removes the given layer from the map.
	  	removeLayer: function (layer) {
	  		var id = stamp(layer);
	
	  		if (!this._layers[id]) { return this; }
	
	  		if (this._loaded) {
	  			layer.onRemove(this);
	  		}
	
	  		delete this._layers[id];
	
	  		if (this._loaded) {
	  			this.fire('layerremove', {layer: layer});
	  			layer.fire('remove');
	  		}
	
	  		layer._map = layer._mapToAdd = null;
	
	  		return this;
	  	},
	
	  	// @method hasLayer(layer: Layer): Boolean
	  	// Returns `true` if the given layer is currently added to the map
	  	hasLayer: function (layer) {
	  		return stamp(layer) in this._layers;
	  	},
	
	  	/* @method eachLayer(fn: Function, context?: Object): this
	  	 * Iterates over the layers of the map, optionally specifying context of the iterator function.
	  	 * ```
	  	 * map.eachLayer(function(layer){
	  	 *     layer.bindPopup('Hello');
	  	 * });
	  	 * ```
	  	 */
	  	eachLayer: function (method, context) {
	  		for (var i in this._layers) {
	  			method.call(context, this._layers[i]);
	  		}
	  		return this;
	  	},
	
	  	_addLayers: function (layers) {
	  		layers = layers ? (isArray(layers) ? layers : [layers]) : [];
	
	  		for (var i = 0, len = layers.length; i < len; i++) {
	  			this.addLayer(layers[i]);
	  		}
	  	},
	
	  	_addZoomLimit: function (layer) {
	  		if (!isNaN(layer.options.maxZoom) || !isNaN(layer.options.minZoom)) {
	  			this._zoomBoundLayers[stamp(layer)] = layer;
	  			this._updateZoomLevels();
	  		}
	  	},
	
	  	_removeZoomLimit: function (layer) {
	  		var id = stamp(layer);
	
	  		if (this._zoomBoundLayers[id]) {
	  			delete this._zoomBoundLayers[id];
	  			this._updateZoomLevels();
	  		}
	  	},
	
	  	_updateZoomLevels: function () {
	  		var minZoom = Infinity,
	  		    maxZoom = -Infinity,
	  		    oldZoomSpan = this._getZoomSpan();
	
	  		for (var i in this._zoomBoundLayers) {
	  			var options = this._zoomBoundLayers[i].options;
	
	  			minZoom = options.minZoom === undefined ? minZoom : Math.min(minZoom, options.minZoom);
	  			maxZoom = options.maxZoom === undefined ? maxZoom : Math.max(maxZoom, options.maxZoom);
	  		}
	
	  		this._layersMaxZoom = maxZoom === -Infinity ? undefined : maxZoom;
	  		this._layersMinZoom = minZoom === Infinity ? undefined : minZoom;
	
	  		// @section Map state change events
	  		// @event zoomlevelschange: Event
	  		// Fired when the number of zoomlevels on the map is changed due
	  		// to adding or removing a layer.
	  		if (oldZoomSpan !== this._getZoomSpan()) {
	  			this.fire('zoomlevelschange');
	  		}
	
	  		if (this.options.maxZoom === undefined && this._layersMaxZoom && this.getZoom() > this._layersMaxZoom) {
	  			this.setZoom(this._layersMaxZoom);
	  		}
	  		if (this.options.minZoom === undefined && this._layersMinZoom && this.getZoom() < this._layersMinZoom) {
	  			this.setZoom(this._layersMinZoom);
	  		}
	  	}
	  });
	
	  /*
	   * @class LayerGroup
	   * @aka L.LayerGroup
	   * @inherits Interactive layer
	   *
	   * Used to group several layers and handle them as one. If you add it to the map,
	   * any layers added or removed from the group will be added/removed on the map as
	   * well. Extends `Layer`.
	   *
	   * @example
	   *
	   * ```js
	   * L.layerGroup([marker1, marker2])
	   * 	.addLayer(polyline)
	   * 	.addTo(map);
	   * ```
	   */
	
	  var LayerGroup = Layer.extend({
	
	  	initialize: function (layers, options) {
	  		setOptions(this, options);
	
	  		this._layers = {};
	
	  		var i, len;
	
	  		if (layers) {
	  			for (i = 0, len = layers.length; i < len; i++) {
	  				this.addLayer(layers[i]);
	  			}
	  		}
	  	},
	
	  	// @method addLayer(layer: Layer): this
	  	// Adds the given layer to the group.
	  	addLayer: function (layer) {
	  		var id = this.getLayerId(layer);
	
	  		this._layers[id] = layer;
	
	  		if (this._map) {
	  			this._map.addLayer(layer);
	  		}
	
	  		return this;
	  	},
	
	  	// @method removeLayer(layer: Layer): this
	  	// Removes the given layer from the group.
	  	// @alternative
	  	// @method removeLayer(id: Number): this
	  	// Removes the layer with the given internal ID from the group.
	  	removeLayer: function (layer) {
	  		var id = layer in this._layers ? layer : this.getLayerId(layer);
	
	  		if (this._map && this._layers[id]) {
	  			this._map.removeLayer(this._layers[id]);
	  		}
	
	  		delete this._layers[id];
	
	  		return this;
	  	},
	
	  	// @method hasLayer(layer: Layer): Boolean
	  	// Returns `true` if the given layer is currently added to the group.
	  	// @alternative
	  	// @method hasLayer(id: Number): Boolean
	  	// Returns `true` if the given internal ID is currently added to the group.
	  	hasLayer: function (layer) {
	  		var layerId = typeof layer === 'number' ? layer : this.getLayerId(layer);
	  		return layerId in this._layers;
	  	},
	
	  	// @method clearLayers(): this
	  	// Removes all the layers from the group.
	  	clearLayers: function () {
	  		return this.eachLayer(this.removeLayer, this);
	  	},
	
	  	// @method invoke(methodName: String, …): this
	  	// Calls `methodName` on every layer contained in this group, passing any
	  	// additional parameters. Has no effect if the layers contained do not
	  	// implement `methodName`.
	  	invoke: function (methodName) {
	  		var args = Array.prototype.slice.call(arguments, 1),
	  		    i, layer;
	
	  		for (i in this._layers) {
	  			layer = this._layers[i];
	
	  			if (layer[methodName]) {
	  				layer[methodName].apply(layer, args);
	  			}
	  		}
	
	  		return this;
	  	},
	
	  	onAdd: function (map) {
	  		this.eachLayer(map.addLayer, map);
	  	},
	
	  	onRemove: function (map) {
	  		this.eachLayer(map.removeLayer, map);
	  	},
	
	  	// @method eachLayer(fn: Function, context?: Object): this
	  	// Iterates over the layers of the group, optionally specifying context of the iterator function.
	  	// ```js
	  	// group.eachLayer(function (layer) {
	  	// 	layer.bindPopup('Hello');
	  	// });
	  	// ```
	  	eachLayer: function (method, context) {
	  		for (var i in this._layers) {
	  			method.call(context, this._layers[i]);
	  		}
	  		return this;
	  	},
	
	  	// @method getLayer(id: Number): Layer
	  	// Returns the layer with the given internal ID.
	  	getLayer: function (id) {
	  		return this._layers[id];
	  	},
	
	  	// @method getLayers(): Layer[]
	  	// Returns an array of all the layers added to the group.
	  	getLayers: function () {
	  		var layers = [];
	  		this.eachLayer(layers.push, layers);
	  		return layers;
	  	},
	
	  	// @method setZIndex(zIndex: Number): this
	  	// Calls `setZIndex` on every layer contained in this group, passing the z-index.
	  	setZIndex: function (zIndex) {
	  		return this.invoke('setZIndex', zIndex);
	  	},
	
	  	// @method getLayerId(layer: Layer): Number
	  	// Returns the internal ID for a layer
	  	getLayerId: function (layer) {
	  		return stamp(layer);
	  	}
	  });
	
	
	  // @factory L.layerGroup(layers?: Layer[], options?: Object)
	  // Create a layer group, optionally given an initial set of layers and an `options` object.
	  var layerGroup = function (layers, options) {
	  	return new LayerGroup(layers, options);
	  };
	
	  /*
	   * @class FeatureGroup
	   * @aka L.FeatureGroup
	   * @inherits LayerGroup
	   *
	   * Extended `LayerGroup` that makes it easier to do the same thing to all its member layers:
	   *  * [`bindPopup`](#layer-bindpopup) binds a popup to all of the layers at once (likewise with [`bindTooltip`](#layer-bindtooltip))
	   *  * Events are propagated to the `FeatureGroup`, so if the group has an event
	   * handler, it will handle events from any of the layers. This includes mouse events
	   * and custom events.
	   *  * Has `layeradd` and `layerremove` events
	   *
	   * @example
	   *
	   * ```js
	   * L.featureGroup([marker1, marker2, polyline])
	   * 	.bindPopup('Hello world!')
	   * 	.on('click', function() { alert('Clicked on a member of the group!'); })
	   * 	.addTo(map);
	   * ```
	   */
	
	  var FeatureGroup = LayerGroup.extend({
	
	  	addLayer: function (layer) {
	  		if (this.hasLayer(layer)) {
	  			return this;
	  		}
	
	  		layer.addEventParent(this);
	
	  		LayerGroup.prototype.addLayer.call(this, layer);
	
	  		// @event layeradd: LayerEvent
	  		// Fired when a layer is added to this `FeatureGroup`
	  		return this.fire('layeradd', {layer: layer});
	  	},
	
	  	removeLayer: function (layer) {
	  		if (!this.hasLayer(layer)) {
	  			return this;
	  		}
	  		if (layer in this._layers) {
	  			layer = this._layers[layer];
	  		}
	
	  		layer.removeEventParent(this);
	
	  		LayerGroup.prototype.removeLayer.call(this, layer);
	
	  		// @event layerremove: LayerEvent
	  		// Fired when a layer is removed from this `FeatureGroup`
	  		return this.fire('layerremove', {layer: layer});
	  	},
	
	  	// @method setStyle(style: Path options): this
	  	// Sets the given path options to each layer of the group that has a `setStyle` method.
	  	setStyle: function (style) {
	  		return this.invoke('setStyle', style);
	  	},
	
	  	// @method bringToFront(): this
	  	// Brings the layer group to the top of all other layers
	  	bringToFront: function () {
	  		return this.invoke('bringToFront');
	  	},
	
	  	// @method bringToBack(): this
	  	// Brings the layer group to the back of all other layers
	  	bringToBack: function () {
	  		return this.invoke('bringToBack');
	  	},
	
	  	// @method getBounds(): LatLngBounds
	  	// Returns the LatLngBounds of the Feature Group (created from bounds and coordinates of its children).
	  	getBounds: function () {
	  		var bounds = new LatLngBounds();
	
	  		for (var id in this._layers) {
	  			var layer = this._layers[id];
	  			bounds.extend(layer.getBounds ? layer.getBounds() : layer.getLatLng());
	  		}
	  		return bounds;
	  	}
	  });
	
	  // @factory L.featureGroup(layers?: Layer[], options?: Object)
	  // Create a feature group, optionally given an initial set of layers and an `options` object.
	  var featureGroup = function (layers, options) {
	  	return new FeatureGroup(layers, options);
	  };
	
	  /*
	   * @class Icon
	   * @aka L.Icon
	   *
	   * Represents an icon to provide when creating a marker.
	   *
	   * @example
	   *
	   * ```js
	   * var myIcon = L.icon({
	   *     iconUrl: 'my-icon.png',
	   *     iconRetinaUrl: 'my-icon@2x.png',
	   *     iconSize: [38, 95],
	   *     iconAnchor: [22, 94],
	   *     popupAnchor: [-3, -76],
	   *     shadowUrl: 'my-icon-shadow.png',
	   *     shadowRetinaUrl: 'my-icon-shadow@2x.png',
	   *     shadowSize: [68, 95],
	   *     shadowAnchor: [22, 94]
	   * });
	   *
	   * L.marker([50.505, 30.57], {icon: myIcon}).addTo(map);
	   * ```
	   *
	   * `L.Icon.Default` extends `L.Icon` and is the blue icon Leaflet uses for markers by default.
	   *
	   */
	
	  var Icon = Class.extend({
	
	  	/* @section
	  	 * @aka Icon options
	  	 *
	  	 * @option iconUrl: String = null
	  	 * **(required)** The URL to the icon image (absolute or relative to your script path).
	  	 *
	  	 * @option iconRetinaUrl: String = null
	  	 * The URL to a retina sized version of the icon image (absolute or relative to your
	  	 * script path). Used for Retina screen devices.
	  	 *
	  	 * @option iconSize: Point = null
	  	 * Size of the icon image in pixels.
	  	 *
	  	 * @option iconAnchor: Point = null
	  	 * The coordinates of the "tip" of the icon (relative to its top left corner). The icon
	  	 * will be aligned so that this point is at the marker's geographical location. Centered
	  	 * by default if size is specified, also can be set in CSS with negative margins.
	  	 *
	  	 * @option popupAnchor: Point = [0, 0]
	  	 * The coordinates of the point from which popups will "open", relative to the icon anchor.
	  	 *
	  	 * @option tooltipAnchor: Point = [0, 0]
	  	 * The coordinates of the point from which tooltips will "open", relative to the icon anchor.
	  	 *
	  	 * @option shadowUrl: String = null
	  	 * The URL to the icon shadow image. If not specified, no shadow image will be created.
	  	 *
	  	 * @option shadowRetinaUrl: String = null
	  	 *
	  	 * @option shadowSize: Point = null
	  	 * Size of the shadow image in pixels.
	  	 *
	  	 * @option shadowAnchor: Point = null
	  	 * The coordinates of the "tip" of the shadow (relative to its top left corner) (the same
	  	 * as iconAnchor if not specified).
	  	 *
	  	 * @option className: String = ''
	  	 * A custom class name to assign to both icon and shadow images. Empty by default.
	  	 */
	
	  	options: {
	  		popupAnchor: [0, 0],
	  		tooltipAnchor: [0, 0],
	
	  		// @option crossOrigin: Boolean|String = false
	  		// Whether the crossOrigin attribute will be added to the tiles.
	  		// If a String is provided, all tiles will have their crossOrigin attribute set to the String provided. This is needed if you want to access tile pixel data.
	  		// Refer to [CORS Settings](https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_settings_attributes) for valid String values.
	  		crossOrigin: false
	  	},
	
	  	initialize: function (options) {
	  		setOptions(this, options);
	  	},
	
	  	// @method createIcon(oldIcon?: HTMLElement): HTMLElement
	  	// Called internally when the icon has to be shown, returns a `<img>` HTML element
	  	// styled according to the options.
	  	createIcon: function (oldIcon) {
	  		return this._createIcon('icon', oldIcon);
	  	},
	
	  	// @method createShadow(oldIcon?: HTMLElement): HTMLElement
	  	// As `createIcon`, but for the shadow beneath it.
	  	createShadow: function (oldIcon) {
	  		return this._createIcon('shadow', oldIcon);
	  	},
	
	  	_createIcon: function (name, oldIcon) {
	  		var src = this._getIconUrl(name);
	
	  		if (!src) {
	  			if (name === 'icon') {
	  				throw new Error('iconUrl not set in Icon options (see the docs).');
	  			}
	  			return null;
	  		}
	
	  		var img = this._createImg(src, oldIcon && oldIcon.tagName === 'IMG' ? oldIcon : null);
	  		this._setIconStyles(img, name);
	
	  		if (this.options.crossOrigin || this.options.crossOrigin === '') {
	  			img.crossOrigin = this.options.crossOrigin === true ? '' : this.options.crossOrigin;
	  		}
	
	  		return img;
	  	},
	
	  	_setIconStyles: function (img, name) {
	  		var options = this.options;
	  		var sizeOption = options[name + 'Size'];
	
	  		if (typeof sizeOption === 'number') {
	  			sizeOption = [sizeOption, sizeOption];
	  		}
	
	  		var size = toPoint(sizeOption),
	  		    anchor = toPoint(name === 'shadow' && options.shadowAnchor || options.iconAnchor ||
	  		            size && size.divideBy(2, true));
	
	  		img.className = 'leaflet-marker-' + name + ' ' + (options.className || '');
	
	  		if (anchor) {
	  			img.style.marginLeft = (-anchor.x) + 'px';
	  			img.style.marginTop  = (-anchor.y) + 'px';
	  		}
	
	  		if (size) {
	  			img.style.width  = size.x + 'px';
	  			img.style.height = size.y + 'px';
	  		}
	  	},
	
	  	_createImg: function (src, el) {
	  		el = el || document.createElement('img');
	  		el.src = src;
	  		return el;
	  	},
	
	  	_getIconUrl: function (name) {
	  		return Browser.retina && this.options[name + 'RetinaUrl'] || this.options[name + 'Url'];
	  	}
	  });
	
	
	  // @factory L.icon(options: Icon options)
	  // Creates an icon instance with the given options.
	  function icon(options) {
	  	return new Icon(options);
	  }
	
	  /*
	   * @miniclass Icon.Default (Icon)
	   * @aka L.Icon.Default
	   * @section
	   *
	   * A trivial subclass of `Icon`, represents the icon to use in `Marker`s when
	   * no icon is specified. Points to the blue marker image distributed with Leaflet
	   * releases.
	   *
	   * In order to customize the default icon, just change the properties of `L.Icon.Default.prototype.options`
	   * (which is a set of `Icon options`).
	   *
	   * If you want to _completely_ replace the default icon, override the
	   * `L.Marker.prototype.options.icon` with your own icon instead.
	   */
	
	  var IconDefault = Icon.extend({
	
	  	options: {
	  		iconUrl:       'marker-icon.png',
	  		iconRetinaUrl: 'marker-icon-2x.png',
	  		shadowUrl:     'marker-shadow.png',
	  		iconSize:    [25, 41],
	  		iconAnchor:  [12, 41],
	  		popupAnchor: [1, -34],
	  		tooltipAnchor: [16, -28],
	  		shadowSize:  [41, 41]
	  	},
	
	  	_getIconUrl: function (name) {
	  		if (typeof IconDefault.imagePath !== 'string') {	// Deprecated, backwards-compatibility only
	  			IconDefault.imagePath = this._detectIconPath();
	  		}
	
	  		// @option imagePath: String
	  		// `Icon.Default` will try to auto-detect the location of the
	  		// blue icon images. If you are placing these images in a non-standard
	  		// way, set this option to point to the right path.
	  		return (this.options.imagePath || IconDefault.imagePath) + Icon.prototype._getIconUrl.call(this, name);
	  	},
	
	  	_stripUrl: function (path) {	// separate function to use in tests
	  		var strip = function (str, re, idx) {
	  			var match = re.exec(str);
	  			return match && match[idx];
	  		};
	  		path = strip(path, /^url\((['"])?(.+)\1\)$/, 2);
	  		return path && strip(path, /^(.*)marker-icon\.png$/, 1);
	  	},
	
	  	_detectIconPath: function () {
	  		var el = create$1('div',  'leaflet-default-icon-path', document.body);
	  		var path = getStyle(el, 'background-image') ||
	  		           getStyle(el, 'backgroundImage');	// IE8
	
	  		document.body.removeChild(el);
	  		path = this._stripUrl(path);
	  		if (path) { return path; }
	  		var link = document.querySelector('link[href$="leaflet.css"]');
	  		if (!link) { return ''; }
	  		return link.href.substring(0, link.href.length - 'leaflet.css'.length - 1);
	  	}
	  });
	
	  /*
	   * L.Handler.MarkerDrag is used internally by L.Marker to make the markers draggable.
	   */
	
	
	  /* @namespace Marker
	   * @section Interaction handlers
	   *
	   * Interaction handlers are properties of a marker instance that allow you to control interaction behavior in runtime, enabling or disabling certain features such as dragging (see `Handler` methods). Example:
	   *
	   * ```js
	   * marker.dragging.disable();
	   * ```
	   *
	   * @property dragging: Handler
	   * Marker dragging handler (by both mouse and touch). Only valid when the marker is on the map (Otherwise set [`marker.options.draggable`](#marker-draggable)).
	   */
	
	  var MarkerDrag = Handler.extend({
	  	initialize: function (marker) {
	  		this._marker = marker;
	  	},
	
	  	addHooks: function () {
	  		var icon = this._marker._icon;
	
	  		if (!this._draggable) {
	  			this._draggable = new Draggable(icon, icon, true);
	  		}
	
	  		this._draggable.on({
	  			dragstart: this._onDragStart,
	  			predrag: this._onPreDrag,
	  			drag: this._onDrag,
	  			dragend: this._onDragEnd
	  		}, this).enable();
	
	  		addClass(icon, 'leaflet-marker-draggable');
	  	},
	
	  	removeHooks: function () {
	  		this._draggable.off({
	  			dragstart: this._onDragStart,
	  			predrag: this._onPreDrag,
	  			drag: this._onDrag,
	  			dragend: this._onDragEnd
	  		}, this).disable();
	
	  		if (this._marker._icon) {
	  			removeClass(this._marker._icon, 'leaflet-marker-draggable');
	  		}
	  	},
	
	  	moved: function () {
	  		return this._draggable && this._draggable._moved;
	  	},
	
	  	_adjustPan: function (e) {
	  		var marker = this._marker,
	  		    map = marker._map,
	  		    speed = this._marker.options.autoPanSpeed,
	  		    padding = this._marker.options.autoPanPadding,
	  		    iconPos = getPosition(marker._icon),
	  		    bounds = map.getPixelBounds(),
	  		    origin = map.getPixelOrigin();
	
	  		var panBounds = toBounds(
	  			bounds.min._subtract(origin).add(padding),
	  			bounds.max._subtract(origin).subtract(padding)
	  		);
	
	  		if (!panBounds.contains(iconPos)) {
	  			// Compute incremental movement
	  			var movement = toPoint(
	  				(Math.max(panBounds.max.x, iconPos.x) - panBounds.max.x) / (bounds.max.x - panBounds.max.x) -
	  				(Math.min(panBounds.min.x, iconPos.x) - panBounds.min.x) / (bounds.min.x - panBounds.min.x),
	
	  				(Math.max(panBounds.max.y, iconPos.y) - panBounds.max.y) / (bounds.max.y - panBounds.max.y) -
	  				(Math.min(panBounds.min.y, iconPos.y) - panBounds.min.y) / (bounds.min.y - panBounds.min.y)
	  			).multiplyBy(speed);
	
	  			map.panBy(movement, {animate: false});
	
	  			this._draggable._newPos._add(movement);
	  			this._draggable._startPos._add(movement);
	
	  			setPosition(marker._icon, this._draggable._newPos);
	  			this._onDrag(e);
	
	  			this._panRequest = requestAnimFrame(this._adjustPan.bind(this, e));
	  		}
	  	},
	
	  	_onDragStart: function () {
	  		// @section Dragging events
	  		// @event dragstart: Event
	  		// Fired when the user starts dragging the marker.
	
	  		// @event movestart: Event
	  		// Fired when the marker starts moving (because of dragging).
	
	  		this._oldLatLng = this._marker.getLatLng();
	
	  		// When using ES6 imports it could not be set when `Popup` was not imported as well
	  		this._marker.closePopup && this._marker.closePopup();
	
	  		this._marker
	  			.fire('movestart')
	  			.fire('dragstart');
	  	},
	
	  	_onPreDrag: function (e) {
	  		if (this._marker.options.autoPan) {
	  			cancelAnimFrame(this._panRequest);
	  			this._panRequest = requestAnimFrame(this._adjustPan.bind(this, e));
	  		}
	  	},
	
	  	_onDrag: function (e) {
	  		var marker = this._marker,
	  		    shadow = marker._shadow,
	  		    iconPos = getPosition(marker._icon),
	  		    latlng = marker._map.layerPointToLatLng(iconPos);
	
	  		// update shadow position
	  		if (shadow) {
	  			setPosition(shadow, iconPos);
	  		}
	
	  		marker._latlng = latlng;
	  		e.latlng = latlng;
	  		e.oldLatLng = this._oldLatLng;
	
	  		// @event drag: Event
	  		// Fired repeatedly while the user drags the marker.
	  		marker
	  		    .fire('move', e)
	  		    .fire('drag', e);
	  	},
	
	  	_onDragEnd: function (e) {
	  		// @event dragend: DragEndEvent
	  		// Fired when the user stops dragging the marker.
	
	  		 cancelAnimFrame(this._panRequest);
	
	  		// @event moveend: Event
	  		// Fired when the marker stops moving (because of dragging).
	  		delete this._oldLatLng;
	  		this._marker
	  		    .fire('moveend')
	  		    .fire('dragend', e);
	  	}
	  });
	
	  /*
	   * @class Marker
	   * @inherits Interactive layer
	   * @aka L.Marker
	   * L.Marker is used to display clickable/draggable icons on the map. Extends `Layer`.
	   *
	   * @example
	   *
	   * ```js
	   * L.marker([50.5, 30.5]).addTo(map);
	   * ```
	   */
	
	  var Marker = Layer.extend({
	
	  	// @section
	  	// @aka Marker options
	  	options: {
	  		// @option icon: Icon = *
	  		// Icon instance to use for rendering the marker.
	  		// See [Icon documentation](#L.Icon) for details on how to customize the marker icon.
	  		// If not specified, a common instance of `L.Icon.Default` is used.
	  		icon: new IconDefault(),
	
	  		// Option inherited from "Interactive layer" abstract class
	  		interactive: true,
	
	  		// @option keyboard: Boolean = true
	  		// Whether the marker can be tabbed to with a keyboard and clicked by pressing enter.
	  		keyboard: true,
	
	  		// @option title: String = ''
	  		// Text for the browser tooltip that appear on marker hover (no tooltip by default).
	  		// [Useful for accessibility](https://leafletjs.com/examples/accessibility/#markers-must-be-labelled).
	  		title: '',
	
	  		// @option alt: String = 'Marker'
	  		// Text for the `alt` attribute of the icon image.
	  		// [Useful for accessibility](https://leafletjs.com/examples/accessibility/#markers-must-be-labelled).
	  		alt: 'Marker',
	
	  		// @option zIndexOffset: Number = 0
	  		// By default, marker images zIndex is set automatically based on its latitude. Use this option if you want to put the marker on top of all others (or below), specifying a high value like `1000` (or high negative value, respectively).
	  		zIndexOffset: 0,
	
	  		// @option opacity: Number = 1.0
	  		// The opacity of the marker.
	  		opacity: 1,
	
	  		// @option riseOnHover: Boolean = false
	  		// If `true`, the marker will get on top of others when you hover the mouse over it.
	  		riseOnHover: false,
	
	  		// @option riseOffset: Number = 250
	  		// The z-index offset used for the `riseOnHover` feature.
	  		riseOffset: 250,
	
	  		// @option pane: String = 'markerPane'
	  		// `Map pane` where the markers icon will be added.
	  		pane: 'markerPane',
	
	  		// @option shadowPane: String = 'shadowPane'
	  		// `Map pane` where the markers shadow will be added.
	  		shadowPane: 'shadowPane',
	
	  		// @option bubblingMouseEvents: Boolean = false
	  		// When `true`, a mouse event on this marker will trigger the same event on the map
	  		// (unless [`L.DomEvent.stopPropagation`](#domevent-stoppropagation) is used).
	  		bubblingMouseEvents: false,
	
	  		// @option autoPanOnFocus: Boolean = true
	  		// When `true`, the map will pan whenever the marker is focused (via
	  		// e.g. pressing `tab` on the keyboard) to ensure the marker is
	  		// visible within the map's bounds
	  		autoPanOnFocus: true,
	
	  		// @section Draggable marker options
	  		// @option draggable: Boolean = false
	  		// Whether the marker is draggable with mouse/touch or not.
	  		draggable: false,
	
	  		// @option autoPan: Boolean = false
	  		// Whether to pan the map when dragging this marker near its edge or not.
	  		autoPan: false,
	
	  		// @option autoPanPadding: Point = Point(50, 50)
	  		// Distance (in pixels to the left/right and to the top/bottom) of the
	  		// map edge to start panning the map.
	  		autoPanPadding: [50, 50],
	
	  		// @option autoPanSpeed: Number = 10
	  		// Number of pixels the map should pan by.
	  		autoPanSpeed: 10
	  	},
	
	  	/* @section
	  	 *
	  	 * In addition to [shared layer methods](#Layer) like `addTo()` and `remove()` and [popup methods](#Popup) like bindPopup() you can also use the following methods:
	  	 */
	
	  	initialize: function (latlng, options) {
	  		setOptions(this, options);
	  		this._latlng = toLatLng(latlng);
	  	},
	
	  	onAdd: function (map) {
	  		this._zoomAnimated = this._zoomAnimated && map.options.markerZoomAnimation;
	
	  		if (this._zoomAnimated) {
	  			map.on('zoomanim', this._animateZoom, this);
	  		}
	
	  		this._initIcon();
	  		this.update();
	  	},
	
	  	onRemove: function (map) {
	  		if (this.dragging && this.dragging.enabled()) {
	  			this.options.draggable = true;
	  			this.dragging.removeHooks();
	  		}
	  		delete this.dragging;
	
	  		if (this._zoomAnimated) {
	  			map.off('zoomanim', this._animateZoom, this);
	  		}
	
	  		this._removeIcon();
	  		this._removeShadow();
	  	},
	
	  	getEvents: function () {
	  		return {
	  			zoom: this.update,
	  			viewreset: this.update
	  		};
	  	},
	
	  	// @method getLatLng: LatLng
	  	// Returns the current geographical position of the marker.
	  	getLatLng: function () {
	  		return this._latlng;
	  	},
	
	  	// @method setLatLng(latlng: LatLng): this
	  	// Changes the marker position to the given point.
	  	setLatLng: function (latlng) {
	  		var oldLatLng = this._latlng;
	  		this._latlng = toLatLng(latlng);
	  		this.update();
	
	  		// @event move: Event
	  		// Fired when the marker is moved via [`setLatLng`](#marker-setlatlng) or by [dragging](#marker-dragging). Old and new coordinates are included in event arguments as `oldLatLng`, `latlng`.
	  		return this.fire('move', {oldLatLng: oldLatLng, latlng: this._latlng});
	  	},
	
	  	// @method setZIndexOffset(offset: Number): this
	  	// Changes the [zIndex offset](#marker-zindexoffset) of the marker.
	  	setZIndexOffset: function (offset) {
	  		this.options.zIndexOffset = offset;
	  		return this.update();
	  	},
	
	  	// @method getIcon: Icon
	  	// Returns the current icon used by the marker
	  	getIcon: function () {
	  		return this.options.icon;
	  	},
	
	  	// @method setIcon(icon: Icon): this
	  	// Changes the marker icon.
	  	setIcon: function (icon) {
	
	  		this.options.icon = icon;
	
	  		if (this._map) {
	  			this._initIcon();
	  			this.update();
	  		}
	
	  		if (this._popup) {
	  			this.bindPopup(this._popup, this._popup.options);
	  		}
	
	  		return this;
	  	},
	
	  	getElement: function () {
	  		return this._icon;
	  	},
	
	  	update: function () {
	
	  		if (this._icon && this._map) {
	  			var pos = this._map.latLngToLayerPoint(this._latlng).round();
	  			this._setPos(pos);
	  		}
	
	  		return this;
	  	},
	
	  	_initIcon: function () {
	  		var options = this.options,
	  		    classToAdd = 'leaflet-zoom-' + (this._zoomAnimated ? 'animated' : 'hide');
	
	  		var icon = options.icon.createIcon(this._icon),
	  		    addIcon = false;
	
	  		// if we're not reusing the icon, remove the old one and init new one
	  		if (icon !== this._icon) {
	  			if (this._icon) {
	  				this._removeIcon();
	  			}
	  			addIcon = true;
	
	  			if (options.title) {
	  				icon.title = options.title;
	  			}
	
	  			if (icon.tagName === 'IMG') {
	  				icon.alt = options.alt || '';
	  			}
	  		}
	
	  		addClass(icon, classToAdd);
	
	  		if (options.keyboard) {
	  			icon.tabIndex = '0';
	  			icon.setAttribute('role', 'button');
	  		}
	
	  		this._icon = icon;
	
	  		if (options.riseOnHover) {
	  			this.on({
	  				mouseover: this._bringToFront,
	  				mouseout: this._resetZIndex
	  			});
	  		}
	
	  		if (this.options.autoPanOnFocus) {
	  			on(icon, 'focus', this._panOnFocus, this);
	  		}
	
	  		var newShadow = options.icon.createShadow(this._shadow),
	  		    addShadow = false;
	
	  		if (newShadow !== this._shadow) {
	  			this._removeShadow();
	  			addShadow = true;
	  		}
	
	  		if (newShadow) {
	  			addClass(newShadow, classToAdd);
	  			newShadow.alt = '';
	  		}
	  		this._shadow = newShadow;
	
	
	  		if (options.opacity < 1) {
	  			this._updateOpacity();
	  		}
	
	
	  		if (addIcon) {
	  			this.getPane().appendChild(this._icon);
	  		}
	  		this._initInteraction();
	  		if (newShadow && addShadow) {
	  			this.getPane(options.shadowPane).appendChild(this._shadow);
	  		}
	  	},
	
	  	_removeIcon: function () {
	  		if (this.options.riseOnHover) {
	  			this.off({
	  				mouseover: this._bringToFront,
	  				mouseout: this._resetZIndex
	  			});
	  		}
	
	  		if (this.options.autoPanOnFocus) {
	  			off(this._icon, 'focus', this._panOnFocus, this);
	  		}
	
	  		remove(this._icon);
	  		this.removeInteractiveTarget(this._icon);
	
	  		this._icon = null;
	  	},
	
	  	_removeShadow: function () {
	  		if (this._shadow) {
	  			remove(this._shadow);
	  		}
	  		this._shadow = null;
	  	},
	
	  	_setPos: function (pos) {
	
	  		if (this._icon) {
	  			setPosition(this._icon, pos);
	  		}
	
	  		if (this._shadow) {
	  			setPosition(this._shadow, pos);
	  		}
	
	  		this._zIndex = pos.y + this.options.zIndexOffset;
	
	  		this._resetZIndex();
	  	},
	
	  	_updateZIndex: function (offset) {
	  		if (this._icon) {
	  			this._icon.style.zIndex = this._zIndex + offset;
	  		}
	  	},
	
	  	_animateZoom: function (opt) {
	  		var pos = this._map._latLngToNewLayerPoint(this._latlng, opt.zoom, opt.center).round();
	
	  		this._setPos(pos);
	  	},
	
	  	_initInteraction: function () {
	
	  		if (!this.options.interactive) { return; }
	
	  		addClass(this._icon, 'leaflet-interactive');
	
	  		this.addInteractiveTarget(this._icon);
	
	  		if (MarkerDrag) {
	  			var draggable = this.options.draggable;
	  			if (this.dragging) {
	  				draggable = this.dragging.enabled();
	  				this.dragging.disable();
	  			}
	
	  			this.dragging = new MarkerDrag(this);
	
	  			if (draggable) {
	  				this.dragging.enable();
	  			}
	  		}
	  	},
	
	  	// @method setOpacity(opacity: Number): this
	  	// Changes the opacity of the marker.
	  	setOpacity: function (opacity) {
	  		this.options.opacity = opacity;
	  		if (this._map) {
	  			this._updateOpacity();
	  		}
	
	  		return this;
	  	},
	
	  	_updateOpacity: function () {
	  		var opacity = this.options.opacity;
	
	  		if (this._icon) {
	  			setOpacity(this._icon, opacity);
	  		}
	
	  		if (this._shadow) {
	  			setOpacity(this._shadow, opacity);
	  		}
	  	},
	
	  	_bringToFront: function () {
	  		this._updateZIndex(this.options.riseOffset);
	  	},
	
	  	_resetZIndex: function () {
	  		this._updateZIndex(0);
	  	},
	
	  	_panOnFocus: function () {
	  		var map = this._map;
	  		if (!map) { return; }
	
	  		var iconOpts = this.options.icon.options;
	  		var size = iconOpts.iconSize ? toPoint(iconOpts.iconSize) : toPoint(0, 0);
	  		var anchor = iconOpts.iconAnchor ? toPoint(iconOpts.iconAnchor) : toPoint(0, 0);
	
	  		map.panInside(this._latlng, {
	  			paddingTopLeft: anchor,
	  			paddingBottomRight: size.subtract(anchor)
	  		});
	  	},
	
	  	_getPopupAnchor: function () {
	  		return this.options.icon.options.popupAnchor;
	  	},
	
	  	_getTooltipAnchor: function () {
	  		return this.options.icon.options.tooltipAnchor;
	  	}
	  });
	
	
	  // factory L.marker(latlng: LatLng, options? : Marker options)
	
	  // @factory L.marker(latlng: LatLng, options? : Marker options)
	  // Instantiates a Marker object given a geographical point and optionally an options object.
	  function marker(latlng, options) {
	  	return new Marker(latlng, options);
	  }
	
	  /*
	   * @class Path
	   * @aka L.Path
	   * @inherits Interactive layer
	   *
	   * An abstract class that contains options and constants shared between vector
	   * overlays (Polygon, Polyline, Circle). Do not use it directly. Extends `Layer`.
	   */
	
	  var Path = Layer.extend({
	
	  	// @section
	  	// @aka Path options
	  	options: {
	  		// @option stroke: Boolean = true
	  		// Whether to draw stroke along the path. Set it to `false` to disable borders on polygons or circles.
	  		stroke: true,
	
	  		// @option color: String = '#3388ff'
	  		// Stroke color
	  		color: '#3388ff',
	
	  		// @option weight: Number = 3
	  		// Stroke width in pixels
	  		weight: 3,
	
	  		// @option opacity: Number = 1.0
	  		// Stroke opacity
	  		opacity: 1,
	
	  		// @option lineCap: String= 'round'
	  		// A string that defines [shape to be used at the end](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-linecap) of the stroke.
	  		lineCap: 'round',
	
	  		// @option lineJoin: String = 'round'
	  		// A string that defines [shape to be used at the corners](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-linejoin) of the stroke.
	  		lineJoin: 'round',
	
	  		// @option dashArray: String = null
	  		// A string that defines the stroke [dash pattern](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-dasharray). Doesn't work on `Canvas`-powered layers in [some old browsers](https://developer.mozilla.org/docs/Web/API/CanvasRenderingContext2D/setLineDash#Browser_compatibility).
	  		dashArray: null,
	
	  		// @option dashOffset: String = null
	  		// A string that defines the [distance into the dash pattern to start the dash](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-dashoffset). Doesn't work on `Canvas`-powered layers in [some old browsers](https://developer.mozilla.org/docs/Web/API/CanvasRenderingContext2D/setLineDash#Browser_compatibility).
	  		dashOffset: null,
	
	  		// @option fill: Boolean = depends
	  		// Whether to fill the path with color. Set it to `false` to disable filling on polygons or circles.
	  		fill: false,
	
	  		// @option fillColor: String = *
	  		// Fill color. Defaults to the value of the [`color`](#path-color) option
	  		fillColor: null,
	
	  		// @option fillOpacity: Number = 0.2
	  		// Fill opacity.
	  		fillOpacity: 0.2,
	
	  		// @option fillRule: String = 'evenodd'
	  		// A string that defines [how the inside of a shape](https://developer.mozilla.org/docs/Web/SVG/Attribute/fill-rule) is determined.
	  		fillRule: 'evenodd',
	
	  		// className: '',
	
	  		// Option inherited from "Interactive layer" abstract class
	  		interactive: true,
	
	  		// @option bubblingMouseEvents: Boolean = true
	  		// When `true`, a mouse event on this path will trigger the same event on the map
	  		// (unless [`L.DomEvent.stopPropagation`](#domevent-stoppropagation) is used).
	  		bubblingMouseEvents: true
	  	},
	
	  	beforeAdd: function (map) {
	  		// Renderer is set here because we need to call renderer.getEvents
	  		// before this.getEvents.
	  		this._renderer = map.getRenderer(this);
	  	},
	
	  	onAdd: function () {
	  		this._renderer._initPath(this);
	  		this._reset();
	  		this._renderer._addPath(this);
	  	},
	
	  	onRemove: function () {
	  		this._renderer._removePath(this);
	  	},
	
	  	// @method redraw(): this
	  	// Redraws the layer. Sometimes useful after you changed the coordinates that the path uses.
	  	redraw: function () {
	  		if (this._map) {
	  			this._renderer._updatePath(this);
	  		}
	  		return this;
	  	},
	
	  	// @method setStyle(style: Path options): this
	  	// Changes the appearance of a Path based on the options in the `Path options` object.
	  	setStyle: function (style) {
	  		setOptions(this, style);
	  		if (this._renderer) {
	  			this._renderer._updateStyle(this);
	  			if (this.options.stroke && style && Object.prototype.hasOwnProperty.call(style, 'weight')) {
	  				this._updateBounds();
	  			}
	  		}
	  		return this;
	  	},
	
	  	// @method bringToFront(): this
	  	// Brings the layer to the top of all path layers.
	  	bringToFront: function () {
	  		if (this._renderer) {
	  			this._renderer._bringToFront(this);
	  		}
	  		return this;
	  	},
	
	  	// @method bringToBack(): this
	  	// Brings the layer to the bottom of all path layers.
	  	bringToBack: function () {
	  		if (this._renderer) {
	  			this._renderer._bringToBack(this);
	  		}
	  		return this;
	  	},
	
	  	getElement: function () {
	  		return this._path;
	  	},
	
	  	_reset: function () {
	  		// defined in child classes
	  		this._project();
	  		this._update();
	  	},
	
	  	_clickTolerance: function () {
	  		// used when doing hit detection for Canvas layers
	  		return (this.options.stroke ? this.options.weight / 2 : 0) +
	  		  (this._renderer.options.tolerance || 0);
	  	}
	  });
	
	  /*
	   * @class CircleMarker
	   * @aka L.CircleMarker
	   * @inherits Path
	   *
	   * A circle of a fixed size with radius specified in pixels. Extends `Path`.
	   */
	
	  var CircleMarker = Path.extend({
	
	  	// @section
	  	// @aka CircleMarker options
	  	options: {
	  		fill: true,
	
	  		// @option radius: Number = 10
	  		// Radius of the circle marker, in pixels
	  		radius: 10
	  	},
	
	  	initialize: function (latlng, options) {
	  		setOptions(this, options);
	  		this._latlng = toLatLng(latlng);
	  		this._radius = this.options.radius;
	  	},
	
	  	// @method setLatLng(latLng: LatLng): this
	  	// Sets the position of a circle marker to a new location.
	  	setLatLng: function (latlng) {
	  		var oldLatLng = this._latlng;
	  		this._latlng = toLatLng(latlng);
	  		this.redraw();
	
	  		// @event move: Event
	  		// Fired when the marker is moved via [`setLatLng`](#circlemarker-setlatlng). Old and new coordinates are included in event arguments as `oldLatLng`, `latlng`.
	  		return this.fire('move', {oldLatLng: oldLatLng, latlng: this._latlng});
	  	},
	
	  	// @method getLatLng(): LatLng
	  	// Returns the current geographical position of the circle marker
	  	getLatLng: function () {
	  		return this._latlng;
	  	},
	
	  	// @method setRadius(radius: Number): this
	  	// Sets the radius of a circle marker. Units are in pixels.
	  	setRadius: function (radius) {
	  		this.options.radius = this._radius = radius;
	  		return this.redraw();
	  	},
	
	  	// @method getRadius(): Number
	  	// Returns the current radius of the circle
	  	getRadius: function () {
	  		return this._radius;
	  	},
	
	  	setStyle : function (options) {
	  		var radius = options && options.radius || this._radius;
	  		Path.prototype.setStyle.call(this, options);
	  		this.setRadius(radius);
	  		return this;
	  	},
	
	  	_project: function () {
	  		this._point = this._map.latLngToLayerPoint(this._latlng);
	  		this._updateBounds();
	  	},
	
	  	_updateBounds: function () {
	  		var r = this._radius,
	  		    r2 = this._radiusY || r,
	  		    w = this._clickTolerance(),
	  		    p = [r + w, r2 + w];
	  		this._pxBounds = new Bounds(this._point.subtract(p), this._point.add(p));
	  	},
	
	  	_update: function () {
	  		if (this._map) {
	  			this._updatePath();
	  		}
	  	},
	
	  	_updatePath: function () {
	  		this._renderer._updateCircle(this);
	  	},
	
	  	_empty: function () {
	  		return this._radius && !this._renderer._bounds.intersects(this._pxBounds);
	  	},
	
	  	// Needed by the `Canvas` renderer for interactivity
	  	_containsPoint: function (p) {
	  		return p.distanceTo(this._point) <= this._radius + this._clickTolerance();
	  	}
	  });
	
	
	  // @factory L.circleMarker(latlng: LatLng, options?: CircleMarker options)
	  // Instantiates a circle marker object given a geographical point, and an optional options object.
	  function circleMarker(latlng, options) {
	  	return new CircleMarker(latlng, options);
	  }
	
	  /*
	   * @class Circle
	   * @aka L.Circle
	   * @inherits CircleMarker
	   *
	   * A class for drawing circle overlays on a map. Extends `CircleMarker`.
	   *
	   * It's an approximation and starts to diverge from a real circle closer to poles (due to projection distortion).
	   *
	   * @example
	   *
	   * ```js
	   * L.circle([50.5, 30.5], {radius: 200}).addTo(map);
	   * ```
	   */
	
	  var Circle = CircleMarker.extend({
	
	  	initialize: function (latlng, options, legacyOptions) {
	  		if (typeof options === 'number') {
	  			// Backwards compatibility with 0.7.x factory (latlng, radius, options?)
	  			options = extend({}, legacyOptions, {radius: options});
	  		}
	  		setOptions(this, options);
	  		this._latlng = toLatLng(latlng);
	
	  		if (isNaN(this.options.radius)) { throw new Error('Circle radius cannot be NaN'); }
	
	  		// @section
	  		// @aka Circle options
	  		// @option radius: Number; Radius of the circle, in meters.
	  		this._mRadius = this.options.radius;
	  	},
	
	  	// @method setRadius(radius: Number): this
	  	// Sets the radius of a circle. Units are in meters.
	  	setRadius: function (radius) {
	  		this._mRadius = radius;
	  		return this.redraw();
	  	},
	
	  	// @method getRadius(): Number
	  	// Returns the current radius of a circle. Units are in meters.
	  	getRadius: function () {
	  		return this._mRadius;
	  	},
	
	  	// @method getBounds(): LatLngBounds
	  	// Returns the `LatLngBounds` of the path.
	  	getBounds: function () {
	  		var half = [this._radius, this._radiusY || this._radius];
	
	  		return new LatLngBounds(
	  			this._map.layerPointToLatLng(this._point.subtract(half)),
	  			this._map.layerPointToLatLng(this._point.add(half)));
	  	},
	
	  	setStyle: Path.prototype.setStyle,
	
	  	_project: function () {
	
	  		var lng = this._latlng.lng,
	  		    lat = this._latlng.lat,
	  		    map = this._map,
	  		    crs = map.options.crs;
	
	  		if (crs.distance === Earth.distance) {
	  			var d = Math.PI / 180,
	  			    latR = (this._mRadius / Earth.R) / d,
	  			    top = map.project([lat + latR, lng]),
	  			    bottom = map.project([lat - latR, lng]),
	  			    p = top.add(bottom).divideBy(2),
	  			    lat2 = map.unproject(p).lat,
	  			    lngR = Math.acos((Math.cos(latR * d) - Math.sin(lat * d) * Math.sin(lat2 * d)) /
	  			            (Math.cos(lat * d) * Math.cos(lat2 * d))) / d;
	
	  			if (isNaN(lngR) || lngR === 0) {
	  				lngR = latR / Math.cos(Math.PI / 180 * lat); // Fallback for edge case, #2425
	  			}
	
	  			this._point = p.subtract(map.getPixelOrigin());
	  			this._radius = isNaN(lngR) ? 0 : p.x - map.project([lat2, lng - lngR]).x;
	  			this._radiusY = p.y - top.y;
	
	  		} else {
	  			var latlng2 = crs.unproject(crs.project(this._latlng).subtract([this._mRadius, 0]));
	
	  			this._point = map.latLngToLayerPoint(this._latlng);
	  			this._radius = this._point.x - map.latLngToLayerPoint(latlng2).x;
	  		}
	
	  		this._updateBounds();
	  	}
	  });
	
	  // @factory L.circle(latlng: LatLng, options?: Circle options)
	  // Instantiates a circle object given a geographical point, and an options object
	  // which contains the circle radius.
	  // @alternative
	  // @factory L.circle(latlng: LatLng, radius: Number, options?: Circle options)
	  // Obsolete way of instantiating a circle, for compatibility with 0.7.x code.
	  // Do not use in new applications or plugins.
	  function circle(latlng, options, legacyOptions) {
	  	return new Circle(latlng, options, legacyOptions);
	  }
	
	  /*
	   * @class Polyline
	   * @aka L.Polyline
	   * @inherits Path
	   *
	   * A class for drawing polyline overlays on a map. Extends `Path`.
	   *
	   * @example
	   *
	   * ```js
	   * // create a red polyline from an array of LatLng points
	   * var latlngs = [
	   * 	[45.51, -122.68],
	   * 	[37.77, -122.43],
	   * 	[34.04, -118.2]
	   * ];
	   *
	   * var polyline = L.polyline(latlngs, {color: 'red'}).addTo(map);
	   *
	   * // zoom the map to the polyline
	   * map.fitBounds(polyline.getBounds());
	   * ```
	   *
	   * You can also pass a multi-dimensional array to represent a `MultiPolyline` shape:
	   *
	   * ```js
	   * // create a red polyline from an array of arrays of LatLng points
	   * var latlngs = [
	   * 	[[45.51, -122.68],
	   * 	 [37.77, -122.43],
	   * 	 [34.04, -118.2]],
	   * 	[[40.78, -73.91],
	   * 	 [41.83, -87.62],
	   * 	 [32.76, -96.72]]
	   * ];
	   * ```
	   */
	
	
	  var Polyline = Path.extend({
	
	  	// @section
	  	// @aka Polyline options
	  	options: {
	  		// @option smoothFactor: Number = 1.0
	  		// How much to simplify the polyline on each zoom level. More means
	  		// better performance and smoother look, and less means more accurate representation.
	  		smoothFactor: 1.0,
	
	  		// @option noClip: Boolean = false
	  		// Disable polyline clipping.
	  		noClip: false
	  	},
	
	  	initialize: function (latlngs, options) {
	  		setOptions(this, options);
	  		this._setLatLngs(latlngs);
	  	},
	
	  	// @method getLatLngs(): LatLng[]
	  	// Returns an array of the points in the path, or nested arrays of points in case of multi-polyline.
	  	getLatLngs: function () {
	  		return this._latlngs;
	  	},
	
	  	// @method setLatLngs(latlngs: LatLng[]): this
	  	// Replaces all the points in the polyline with the given array of geographical points.
	  	setLatLngs: function (latlngs) {
	  		this._setLatLngs(latlngs);
	  		return this.redraw();
	  	},
	
	  	// @method isEmpty(): Boolean
	  	// Returns `true` if the Polyline has no LatLngs.
	  	isEmpty: function () {
	  		return !this._latlngs.length;
	  	},
	
	  	// @method closestLayerPoint(p: Point): Point
	  	// Returns the point closest to `p` on the Polyline.
	  	closestLayerPoint: function (p) {
	  		var minDistance = Infinity,
	  		    minPoint = null,
	  		    closest = _sqClosestPointOnSegment,
	  		    p1, p2;
	
	  		for (var j = 0, jLen = this._parts.length; j < jLen; j++) {
	  			var points = this._parts[j];
	
	  			for (var i = 1, len = points.length; i < len; i++) {
	  				p1 = points[i - 1];
	  				p2 = points[i];
	
	  				var sqDist = closest(p, p1, p2, true);
	
	  				if (sqDist < minDistance) {
	  					minDistance = sqDist;
	  					minPoint = closest(p, p1, p2);
	  				}
	  			}
	  		}
	  		if (minPoint) {
	  			minPoint.distance = Math.sqrt(minDistance);
	  		}
	  		return minPoint;
	  	},
	
	  	// @method getCenter(): LatLng
	  	// Returns the center ([centroid](https://en.wikipedia.org/wiki/Centroid)) of the polyline.
	  	getCenter: function () {
	  		// throws error when not yet added to map as this center calculation requires projected coordinates
	  		if (!this._map) {
	  			throw new Error('Must add layer to map before using getCenter()');
	  		}
	  		return polylineCenter(this._defaultShape(), this._map.options.crs);
	  	},
	
	  	// @method getBounds(): LatLngBounds
	  	// Returns the `LatLngBounds` of the path.
	  	getBounds: function () {
	  		return this._bounds;
	  	},
	
	  	// @method addLatLng(latlng: LatLng, latlngs?: LatLng[]): this
	  	// Adds a given point to the polyline. By default, adds to the first ring of
	  	// the polyline in case of a multi-polyline, but can be overridden by passing
	  	// a specific ring as a LatLng array (that you can earlier access with [`getLatLngs`](#polyline-getlatlngs)).
	  	addLatLng: function (latlng, latlngs) {
	  		latlngs = latlngs || this._defaultShape();
	  		latlng = toLatLng(latlng);
	  		latlngs.push(latlng);
	  		this._bounds.extend(latlng);
	  		return this.redraw();
	  	},
	
	  	_setLatLngs: function (latlngs) {
	  		this._bounds = new LatLngBounds();
	  		this._latlngs = this._convertLatLngs(latlngs);
	  	},
	
	  	_defaultShape: function () {
	  		return isFlat(this._latlngs) ? this._latlngs : this._latlngs[0];
	  	},
	
	  	// recursively convert latlngs input into actual LatLng instances; calculate bounds along the way
	  	_convertLatLngs: function (latlngs) {
	  		var result = [],
	  		    flat = isFlat(latlngs);
	
	  		for (var i = 0, len = latlngs.length; i < len; i++) {
	  			if (flat) {
	  				result[i] = toLatLng(latlngs[i]);
	  				this._bounds.extend(result[i]);
	  			} else {
	  				result[i] = this._convertLatLngs(latlngs[i]);
	  			}
	  		}
	
	  		return result;
	  	},
	
	  	_project: function () {
	  		var pxBounds = new Bounds();
	  		this._rings = [];
	  		this._projectLatlngs(this._latlngs, this._rings, pxBounds);
	
	  		if (this._bounds.isValid() && pxBounds.isValid()) {
	  			this._rawPxBounds = pxBounds;
	  			this._updateBounds();
	  		}
	  	},
	
	  	_updateBounds: function () {
	  		var w = this._clickTolerance(),
	  		    p = new Point(w, w);
	
	  		if (!this._rawPxBounds) {
	  			return;
	  		}
	
	  		this._pxBounds = new Bounds([
	  			this._rawPxBounds.min.subtract(p),
	  			this._rawPxBounds.max.add(p)
	  		]);
	  	},
	
	  	// recursively turns latlngs into a set of rings with projected coordinates
	  	_projectLatlngs: function (latlngs, result, projectedBounds) {
	  		var flat = latlngs[0] instanceof LatLng,
	  		    len = latlngs.length,
	  		    i, ring;
	
	  		if (flat) {
	  			ring = [];
	  			for (i = 0; i < len; i++) {
	  				ring[i] = this._map.latLngToLayerPoint(latlngs[i]);
	  				projectedBounds.extend(ring[i]);
	  			}
	  			result.push(ring);
	  		} else {
	  			for (i = 0; i < len; i++) {
	  				this._projectLatlngs(latlngs[i], result, projectedBounds);
	  			}
	  		}
	  	},
	
	  	// clip polyline by renderer bounds so that we have less to render for performance
	  	_clipPoints: function () {
	  		var bounds = this._renderer._bounds;
	
	  		this._parts = [];
	  		if (!this._pxBounds || !this._pxBounds.intersects(bounds)) {
	  			return;
	  		}
	
	  		if (this.options.noClip) {
	  			this._parts = this._rings;
	  			return;
	  		}
	
	  		var parts = this._parts,
	  		    i, j, k, len, len2, segment, points;
	
	  		for (i = 0, k = 0, len = this._rings.length; i < len; i++) {
	  			points = this._rings[i];
	
	  			for (j = 0, len2 = points.length; j < len2 - 1; j++) {
	  				segment = clipSegment(points[j], points[j + 1], bounds, j, true);
	
	  				if (!segment) { continue; }
	
	  				parts[k] = parts[k] || [];
	  				parts[k].push(segment[0]);
	
	  				// if segment goes out of screen, or it's the last one, it's the end of the line part
	  				if ((segment[1] !== points[j + 1]) || (j === len2 - 2)) {
	  					parts[k].push(segment[1]);
	  					k++;
	  				}
	  			}
	  		}
	  	},
	
	  	// simplify each clipped part of the polyline for performance
	  	_simplifyPoints: function () {
	  		var parts = this._parts,
	  		    tolerance = this.options.smoothFactor;
	
	  		for (var i = 0, len = parts.length; i < len; i++) {
	  			parts[i] = simplify(parts[i], tolerance);
	  		}
	  	},
	
	  	_update: function () {
	  		if (!this._map) { return; }
	
	  		this._clipPoints();
	  		this._simplifyPoints();
	  		this._updatePath();
	  	},
	
	  	_updatePath: function () {
	  		this._renderer._updatePoly(this);
	  	},
	
	  	// Needed by the `Canvas` renderer for interactivity
	  	_containsPoint: function (p, closed) {
	  		var i, j, k, len, len2, part,
	  		    w = this._clickTolerance();
	
	  		if (!this._pxBounds || !this._pxBounds.contains(p)) { return false; }
	
	  		// hit detection for polylines
	  		for (i = 0, len = this._parts.length; i < len; i++) {
	  			part = this._parts[i];
	
	  			for (j = 0, len2 = part.length, k = len2 - 1; j < len2; k = j++) {
	  				if (!closed && (j === 0)) { continue; }
	
	  				if (pointToSegmentDistance(p, part[k], part[j]) <= w) {
	  					return true;
	  				}
	  			}
	  		}
	  		return false;
	  	}
	  });
	
	  // @factory L.polyline(latlngs: LatLng[], options?: Polyline options)
	  // Instantiates a polyline object given an array of geographical points and
	  // optionally an options object. You can create a `Polyline` object with
	  // multiple separate lines (`MultiPolyline`) by passing an array of arrays
	  // of geographic points.
	  function polyline(latlngs, options) {
	  	return new Polyline(latlngs, options);
	  }
	
	  // Retrocompat. Allow plugins to support Leaflet versions before and after 1.1.
	  Polyline._flat = _flat;
	
	  /*
	   * @class Polygon
	   * @aka L.Polygon
	   * @inherits Polyline
	   *
	   * A class for drawing polygon overlays on a map. Extends `Polyline`.
	   *
	   * Note that points you pass when creating a polygon shouldn't have an additional last point equal to the first one — it's better to filter out such points.
	   *
	   *
	   * @example
	   *
	   * ```js
	   * // create a red polygon from an array of LatLng points
	   * var latlngs = [[37, -109.05],[41, -109.03],[41, -102.05],[37, -102.04]];
	   *
	   * var polygon = L.polygon(latlngs, {color: 'red'}).addTo(map);
	   *
	   * // zoom the map to the polygon
	   * map.fitBounds(polygon.getBounds());
	   * ```
	   *
	   * You can also pass an array of arrays of latlngs, with the first array representing the outer shape and the other arrays representing holes in the outer shape:
	   *
	   * ```js
	   * var latlngs = [
	   *   [[37, -109.05],[41, -109.03],[41, -102.05],[37, -102.04]], // outer ring
	   *   [[37.29, -108.58],[40.71, -108.58],[40.71, -102.50],[37.29, -102.50]] // hole
	   * ];
	   * ```
	   *
	   * Additionally, you can pass a multi-dimensional array to represent a MultiPolygon shape.
	   *
	   * ```js
	   * var latlngs = [
	   *   [ // first polygon
	   *     [[37, -109.05],[41, -109.03],[41, -102.05],[37, -102.04]], // outer ring
	   *     [[37.29, -108.58],[40.71, -108.58],[40.71, -102.50],[37.29, -102.50]] // hole
	   *   ],
	   *   [ // second polygon
	   *     [[41, -111.03],[45, -111.04],[45, -104.05],[41, -104.05]]
	   *   ]
	   * ];
	   * ```
	   */
	
	  var Polygon = Polyline.extend({
	
	  	options: {
	  		fill: true
	  	},
	
	  	isEmpty: function () {
	  		return !this._latlngs.length || !this._latlngs[0].length;
	  	},
	
	  	// @method getCenter(): LatLng
	  	// Returns the center ([centroid](http://en.wikipedia.org/wiki/Centroid)) of the Polygon.
	  	getCenter: function () {
	  		// throws error when not yet added to map as this center calculation requires projected coordinates
	  		if (!this._map) {
	  			throw new Error('Must add layer to map before using getCenter()');
	  		}
	  		return polygonCenter(this._defaultShape(), this._map.options.crs);
	  	},
	
	  	_convertLatLngs: function (latlngs) {
	  		var result = Polyline.prototype._convertLatLngs.call(this, latlngs),
	  		    len = result.length;
	
	  		// remove last point if it equals first one
	  		if (len >= 2 && result[0] instanceof LatLng && result[0].equals(result[len - 1])) {
	  			result.pop();
	  		}
	  		return result;
	  	},
	
	  	_setLatLngs: function (latlngs) {
	  		Polyline.prototype._setLatLngs.call(this, latlngs);
	  		if (isFlat(this._latlngs)) {
	  			this._latlngs = [this._latlngs];
	  		}
	  	},
	
	  	_defaultShape: function () {
	  		return isFlat(this._latlngs[0]) ? this._latlngs[0] : this._latlngs[0][0];
	  	},
	
	  	_clipPoints: function () {
	  		// polygons need a different clipping algorithm so we redefine that
	
	  		var bounds = this._renderer._bounds,
	  		    w = this.options.weight,
	  		    p = new Point(w, w);
	
	  		// increase clip padding by stroke width to avoid stroke on clip edges
	  		bounds = new Bounds(bounds.min.subtract(p), bounds.max.add(p));
	
	  		this._parts = [];
	  		if (!this._pxBounds || !this._pxBounds.intersects(bounds)) {
	  			return;
	  		}
	
	  		if (this.options.noClip) {
	  			this._parts = this._rings;
	  			return;
	  		}
	
	  		for (var i = 0, len = this._rings.length, clipped; i < len; i++) {
	  			clipped = clipPolygon(this._rings[i], bounds, true);
	  			if (clipped.length) {
	  				this._parts.push(clipped);
	  			}
	  		}
	  	},
	
	  	_updatePath: function () {
	  		this._renderer._updatePoly(this, true);
	  	},
	
	  	// Needed by the `Canvas` renderer for interactivity
	  	_containsPoint: function (p) {
	  		var inside = false,
	  		    part, p1, p2, i, j, k, len, len2;
	
	  		if (!this._pxBounds || !this._pxBounds.contains(p)) { return false; }
	
	  		// ray casting algorithm for detecting if point is in polygon
	  		for (i = 0, len = this._parts.length; i < len; i++) {
	  			part = this._parts[i];
	
	  			for (j = 0, len2 = part.length, k = len2 - 1; j < len2; k = j++) {
	  				p1 = part[j];
	  				p2 = part[k];
	
	  				if (((p1.y > p.y) !== (p2.y > p.y)) && (p.x < (p2.x - p1.x) * (p.y - p1.y) / (p2.y - p1.y) + p1.x)) {
	  					inside = !inside;
	  				}
	  			}
	  		}
	
	  		// also check if it's on polygon stroke
	  		return inside || Polyline.prototype._containsPoint.call(this, p, true);
	  	}
	
	  });
	
	
	  // @factory L.polygon(latlngs: LatLng[], options?: Polyline options)
	  function polygon(latlngs, options) {
	  	return new Polygon(latlngs, options);
	  }
	
	  /*
	   * @class GeoJSON
	   * @aka L.GeoJSON
	   * @inherits FeatureGroup
	   *
	   * Represents a GeoJSON object or an array of GeoJSON objects. Allows you to parse
	   * GeoJSON data and display it on the map. Extends `FeatureGroup`.
	   *
	   * @example
	   *
	   * ```js
	   * L.geoJSON(data, {
	   * 	style: function (feature) {
	   * 		return {color: feature.properties.color};
	   * 	}
	   * }).bindPopup(function (layer) {
	   * 	return layer.feature.properties.description;
	   * }).addTo(map);
	   * ```
	   */
	
	  var GeoJSON = FeatureGroup.extend({
	
	  	/* @section
	  	 * @aka GeoJSON options
	  	 *
	  	 * @option pointToLayer: Function = *
	  	 * A `Function` defining how GeoJSON points spawn Leaflet layers. It is internally
	  	 * called when data is added, passing the GeoJSON point feature and its `LatLng`.
	  	 * The default is to spawn a default `Marker`:
	  	 * ```js
	  	 * function(geoJsonPoint, latlng) {
	  	 * 	return L.marker(latlng);
	  	 * }
	  	 * ```
	  	 *
	  	 * @option style: Function = *
	  	 * A `Function` defining the `Path options` for styling GeoJSON lines and polygons,
	  	 * called internally when data is added.
	  	 * The default value is to not override any defaults:
	  	 * ```js
	  	 * function (geoJsonFeature) {
	  	 * 	return {}
	  	 * }
	  	 * ```
	  	 *
	  	 * @option onEachFeature: Function = *
	  	 * A `Function` that will be called once for each created `Feature`, after it has
	  	 * been created and styled. Useful for attaching events and popups to features.
	  	 * The default is to do nothing with the newly created layers:
	  	 * ```js
	  	 * function (feature, layer) {}
	  	 * ```
	  	 *
	  	 * @option filter: Function = *
	  	 * A `Function` that will be used to decide whether to include a feature or not.
	  	 * The default is to include all features:
	  	 * ```js
	  	 * function (geoJsonFeature) {
	  	 * 	return true;
	  	 * }
	  	 * ```
	  	 * Note: dynamically changing the `filter` option will have effect only on newly
	  	 * added data. It will _not_ re-evaluate already included features.
	  	 *
	  	 * @option coordsToLatLng: Function = *
	  	 * A `Function` that will be used for converting GeoJSON coordinates to `LatLng`s.
	  	 * The default is the `coordsToLatLng` static method.
	  	 *
	  	 * @option markersInheritOptions: Boolean = false
	  	 * Whether default Markers for "Point" type Features inherit from group options.
	  	 */
	
	  	initialize: function (geojson, options) {
	  		setOptions(this, options);
	
	  		this._layers = {};
	
	  		if (geojson) {
	  			this.addData(geojson);
	  		}
	  	},
	
	  	// @method addData( <GeoJSON> data ): this
	  	// Adds a GeoJSON object to the layer.
	  	addData: function (geojson) {
	  		var features = isArray(geojson) ? geojson : geojson.features,
	  		    i, len, feature;
	
	  		if (features) {
	  			for (i = 0, len = features.length; i < len; i++) {
	  				// only add this if geometry or geometries are set and not null
	  				feature = features[i];
	  				if (feature.geometries || feature.geometry || feature.features || feature.coordinates) {
	  					this.addData(feature);
	  				}
	  			}
	  			return this;
	  		}
	
	  		var options = this.options;
	
	  		if (options.filter && !options.filter(geojson)) { return this; }
	
	  		var layer = geometryToLayer(geojson, options);
	  		if (!layer) {
	  			return this;
	  		}
	  		layer.feature = asFeature(geojson);
	
	  		layer.defaultOptions = layer.options;
	  		this.resetStyle(layer);
	
	  		if (options.onEachFeature) {
	  			options.onEachFeature(geojson, layer);
	  		}
	
	  		return this.addLayer(layer);
	  	},
	
	  	// @method resetStyle( <Path> layer? ): this
	  	// Resets the given vector layer's style to the original GeoJSON style, useful for resetting style after hover events.
	  	// If `layer` is omitted, the style of all features in the current layer is reset.
	  	resetStyle: function (layer) {
	  		if (layer === undefined) {
	  			return this.eachLayer(this.resetStyle, this);
	  		}
	  		// reset any custom styles
	  		layer.options = extend({}, layer.defaultOptions);
	  		this._setLayerStyle(layer, this.options.style);
	  		return this;
	  	},
	
	  	// @method setStyle( <Function> style ): this
	  	// Changes styles of GeoJSON vector layers with the given style function.
	  	setStyle: function (style) {
	  		return this.eachLayer(function (layer) {
	  			this._setLayerStyle(layer, style);
	  		}, this);
	  	},
	
	  	_setLayerStyle: function (layer, style) {
	  		if (layer.setStyle) {
	  			if (typeof style === 'function') {
	  				style = style(layer.feature);
	  			}
	  			layer.setStyle(style);
	  		}
	  	}
	  });
	
	  // @section
	  // There are several static functions which can be called without instantiating L.GeoJSON:
	
	  // @function geometryToLayer(featureData: Object, options?: GeoJSON options): Layer
	  // Creates a `Layer` from a given GeoJSON feature. Can use a custom
	  // [`pointToLayer`](#geojson-pointtolayer) and/or [`coordsToLatLng`](#geojson-coordstolatlng)
	  // functions if provided as options.
	  function geometryToLayer(geojson, options) {
	
	  	var geometry = geojson.type === 'Feature' ? geojson.geometry : geojson,
	  	    coords = geometry ? geometry.coordinates : null,
	  	    layers = [],
	  	    pointToLayer = options && options.pointToLayer,
	  	    _coordsToLatLng = options && options.coordsToLatLng || coordsToLatLng,
	  	    latlng, latlngs, i, len;
	
	  	if (!coords && !geometry) {
	  		return null;
	  	}
	
	  	switch (geometry.type) {
	  	case 'Point':
	  		latlng = _coordsToLatLng(coords);
	  		return _pointToLayer(pointToLayer, geojson, latlng, options);
	
	  	case 'MultiPoint':
	  		for (i = 0, len = coords.length; i < len; i++) {
	  			latlng = _coordsToLatLng(coords[i]);
	  			layers.push(_pointToLayer(pointToLayer, geojson, latlng, options));
	  		}
	  		return new FeatureGroup(layers);
	
	  	case 'LineString':
	  	case 'MultiLineString':
	  		latlngs = coordsToLatLngs(coords, geometry.type === 'LineString' ? 0 : 1, _coordsToLatLng);
	  		return new Polyline(latlngs, options);
	
	  	case 'Polygon':
	  	case 'MultiPolygon':
	  		latlngs = coordsToLatLngs(coords, geometry.type === 'Polygon' ? 1 : 2, _coordsToLatLng);
	  		return new Polygon(latlngs, options);
	
	  	case 'GeometryCollection':
	  		for (i = 0, len = geometry.geometries.length; i < len; i++) {
	  			var geoLayer = geometryToLayer({
	  				geometry: geometry.geometries[i],
	  				type: 'Feature',
	  				properties: geojson.properties
	  			}, options);
	
	  			if (geoLayer) {
	  				layers.push(geoLayer);
	  			}
	  		}
	  		return new FeatureGroup(layers);
	
	  	case 'FeatureCollection':
	  		for (i = 0, len = geometry.features.length; i < len; i++) {
	  			var featureLayer = geometryToLayer(geometry.features[i], options);
	
	  			if (featureLayer) {
	  				layers.push(featureLayer);
	  			}
	  		}
	  		return new FeatureGroup(layers);
	
	  	default:
	  		throw new Error('Invalid GeoJSON object.');
	  	}
	  }
	
	  function _pointToLayer(pointToLayerFn, geojson, latlng, options) {
	  	return pointToLayerFn ?
	  		pointToLayerFn(geojson, latlng) :
	  		new Marker(latlng, options && options.markersInheritOptions && options);
	  }
	
	  // @function coordsToLatLng(coords: Array): LatLng
	  // Creates a `LatLng` object from an array of 2 numbers (longitude, latitude)
	  // or 3 numbers (longitude, latitude, altitude) used in GeoJSON for points.
	  function coordsToLatLng(coords) {
	  	return new LatLng(coords[1], coords[0], coords[2]);
	  }
	
	  // @function coordsToLatLngs(coords: Array, levelsDeep?: Number, coordsToLatLng?: Function): Array
	  // Creates a multidimensional array of `LatLng`s from a GeoJSON coordinates array.
	  // `levelsDeep` specifies the nesting level (0 is for an array of points, 1 for an array of arrays of points, etc., 0 by default).
	  // Can use a custom [`coordsToLatLng`](#geojson-coordstolatlng) function.
	  function coordsToLatLngs(coords, levelsDeep, _coordsToLatLng) {
	  	var latlngs = [];
	
	  	for (var i = 0, len = coords.length, latlng; i < len; i++) {
	  		latlng = levelsDeep ?
	  			coordsToLatLngs(coords[i], levelsDeep - 1, _coordsToLatLng) :
	  			(_coordsToLatLng || coordsToLatLng)(coords[i]);
	
	  		latlngs.push(latlng);
	  	}
	
	  	return latlngs;
	  }
	
	  // @function latLngToCoords(latlng: LatLng, precision?: Number|false): Array
	  // Reverse of [`coordsToLatLng`](#geojson-coordstolatlng)
	  // Coordinates values are rounded with [`formatNum`](#util-formatnum) function.
	  function latLngToCoords(latlng, precision) {
	  	latlng = toLatLng(latlng);
	  	return latlng.alt !== undefined ?
	  		[formatNum(latlng.lng, precision), formatNum(latlng.lat, precision), formatNum(latlng.alt, precision)] :
	  		[formatNum(latlng.lng, precision), formatNum(latlng.lat, precision)];
	  }
	
	  // @function latLngsToCoords(latlngs: Array, levelsDeep?: Number, closed?: Boolean, precision?: Number|false): Array
	  // Reverse of [`coordsToLatLngs`](#geojson-coordstolatlngs)
	  // `closed` determines whether the first point should be appended to the end of the array to close the feature, only used when `levelsDeep` is 0. False by default.
	  // Coordinates values are rounded with [`formatNum`](#util-formatnum) function.
	  function latLngsToCoords(latlngs, levelsDeep, closed, precision) {
	  	var coords = [];
	
	  	for (var i = 0, len = latlngs.length; i < len; i++) {
	  		// Check for flat arrays required to ensure unbalanced arrays are correctly converted in recursion
	  		coords.push(levelsDeep ?
	  			latLngsToCoords(latlngs[i], isFlat(latlngs[i]) ? 0 : levelsDeep - 1, closed, precision) :
	  			latLngToCoords(latlngs[i], precision));
	  	}
	
	  	if (!levelsDeep && closed && coords.length > 0) {
	  		coords.push(coords[0].slice());
	  	}
	
	  	return coords;
	  }
	
	  function getFeature(layer, newGeometry) {
	  	return layer.feature ?
	  		extend({}, layer.feature, {geometry: newGeometry}) :
	  		asFeature(newGeometry);
	  }
	
	  // @function asFeature(geojson: Object): Object
	  // Normalize GeoJSON geometries/features into GeoJSON features.
	  function asFeature(geojson) {
	  	if (geojson.type === 'Feature' || geojson.type === 'FeatureCollection') {
	  		return geojson;
	  	}
	
	  	return {
	  		type: 'Feature',
	  		properties: {},
	  		geometry: geojson
	  	};
	  }
	
	  var PointToGeoJSON = {
	  	toGeoJSON: function (precision) {
	  		return getFeature(this, {
	  			type: 'Point',
	  			coordinates: latLngToCoords(this.getLatLng(), precision)
	  		});
	  	}
	  };
	
	  // @namespace Marker
	  // @section Other methods
	  // @method toGeoJSON(precision?: Number|false): Object
	  // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
	  // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the marker (as a GeoJSON `Point` Feature).
	  Marker.include(PointToGeoJSON);
	
	  // @namespace CircleMarker
	  // @method toGeoJSON(precision?: Number|false): Object
	  // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
	  // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the circle marker (as a GeoJSON `Point` Feature).
	  Circle.include(PointToGeoJSON);
	  CircleMarker.include(PointToGeoJSON);
	
	
	  // @namespace Polyline
	  // @method toGeoJSON(precision?: Number|false): Object
	  // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
	  // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the polyline (as a GeoJSON `LineString` or `MultiLineString` Feature).
	  Polyline.include({
	  	toGeoJSON: function (precision) {
	  		var multi = !isFlat(this._latlngs);
	
	  		var coords = latLngsToCoords(this._latlngs, multi ? 1 : 0, false, precision);
	
	  		return getFeature(this, {
	  			type: (multi ? 'Multi' : '') + 'LineString',
	  			coordinates: coords
	  		});
	  	}
	  });
	
	  // @namespace Polygon
	  // @method toGeoJSON(precision?: Number|false): Object
	  // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
	  // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the polygon (as a GeoJSON `Polygon` or `MultiPolygon` Feature).
	  Polygon.include({
	  	toGeoJSON: function (precision) {
	  		var holes = !isFlat(this._latlngs),
	  		    multi = holes && !isFlat(this._latlngs[0]);
	
	  		var coords = latLngsToCoords(this._latlngs, multi ? 2 : holes ? 1 : 0, true, precision);
	
	  		if (!holes) {
	  			coords = [coords];
	  		}
	
	  		return getFeature(this, {
	  			type: (multi ? 'Multi' : '') + 'Polygon',
	  			coordinates: coords
	  		});
	  	}
	  });
	
	
	  // @namespace LayerGroup
	  LayerGroup.include({
	  	toMultiPoint: function (precision) {
	  		var coords = [];
	
	  		this.eachLayer(function (layer) {
	  			coords.push(layer.toGeoJSON(precision).geometry.coordinates);
	  		});
	
	  		return getFeature(this, {
	  			type: 'MultiPoint',
	  			coordinates: coords
	  		});
	  	},
	
	  	// @method toGeoJSON(precision?: Number|false): Object
	  	// Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
	  	// Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the layer group (as a GeoJSON `FeatureCollection`, `GeometryCollection`, or `MultiPoint`).
	  	toGeoJSON: function (precision) {
	
	  		var type = this.feature && this.feature.geometry && this.feature.geometry.type;
	
	  		if (type === 'MultiPoint') {
	  			return this.toMultiPoint(precision);
	  		}
	
	  		var isGeometryCollection = type === 'GeometryCollection',
	  		    jsons = [];
	
	  		this.eachLayer(function (layer) {
	  			if (layer.toGeoJSON) {
	  				var json = layer.toGeoJSON(precision);
	  				if (isGeometryCollection) {
	  					jsons.push(json.geometry);
	  				} else {
	  					var feature = asFeature(json);
	  					// Squash nested feature collections
	  					if (feature.type === 'FeatureCollection') {
	  						jsons.push.apply(jsons, feature.features);
	  					} else {
	  						jsons.push(feature);
	  					}
	  				}
	  			}
	  		});
	
	  		if (isGeometryCollection) {
	  			return getFeature(this, {
	  				geometries: jsons,
	  				type: 'GeometryCollection'
	  			});
	  		}
	
	  		return {
	  			type: 'FeatureCollection',
	  			features: jsons
	  		};
	  	}
	  });
	
	  // @namespace GeoJSON
	  // @factory L.geoJSON(geojson?: Object, options?: GeoJSON options)
	  // Creates a GeoJSON layer. Optionally accepts an object in
	  // [GeoJSON format](https://tools.ietf.org/html/rfc7946) to display on the map
	  // (you can alternatively add it later with `addData` method) and an `options` object.
	  function geoJSON(geojson, options) {
	  	return new GeoJSON(geojson, options);
	  }
	
	  // Backward compatibility.
	  var geoJson = geoJSON;
	
	  /*
	   * @class ImageOverlay
	   * @aka L.ImageOverlay
	   * @inherits Interactive layer
	   *
	   * Used to load and display a single image over specific bounds of the map. Extends `Layer`.
	   *
	   * @example
	   *
	   * ```js
	   * var imageUrl = 'https://maps.lib.utexas.edu/maps/historical/newark_nj_1922.jpg',
	   * 	imageBounds = [[40.712216, -74.22655], [40.773941, -74.12544]];
	   * L.imageOverlay(imageUrl, imageBounds).addTo(map);
	   * ```
	   */
	
	  var ImageOverlay = Layer.extend({
	
	  	// @section
	  	// @aka ImageOverlay options
	  	options: {
	  		// @option opacity: Number = 1.0
	  		// The opacity of the image overlay.
	  		opacity: 1,
	
	  		// @option alt: String = ''
	  		// Text for the `alt` attribute of the image (useful for accessibility).
	  		alt: '',
	
	  		// @option interactive: Boolean = false
	  		// If `true`, the image overlay will emit [mouse events](#interactive-layer) when clicked or hovered.
	  		interactive: false,
	
	  		// @option crossOrigin: Boolean|String = false
	  		// Whether the crossOrigin attribute will be added to the image.
	  		// If a String is provided, the image will have its crossOrigin attribute set to the String provided. This is needed if you want to access image pixel data.
	  		// Refer to [CORS Settings](https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_settings_attributes) for valid String values.
	  		crossOrigin: false,
	
	  		// @option errorOverlayUrl: String = ''
	  		// URL to the overlay image to show in place of the overlay that failed to load.
	  		errorOverlayUrl: '',
	
	  		// @option zIndex: Number = 1
	  		// The explicit [zIndex](https://developer.mozilla.org/docs/Web/CSS/CSS_Positioning/Understanding_z_index) of the overlay layer.
	  		zIndex: 1,
	
	  		// @option className: String = ''
	  		// A custom class name to assign to the image. Empty by default.
	  		className: ''
	  	},
	
	  	initialize: function (url, bounds, options) { // (String, LatLngBounds, Object)
	  		this._url = url;
	  		this._bounds = toLatLngBounds(bounds);
	
	  		setOptions(this, options);
	  	},
	
	  	onAdd: function () {
	  		if (!this._image) {
	  			this._initImage();
	
	  			if (this.options.opacity < 1) {
	  				this._updateOpacity();
	  			}
	  		}
	
	  		if (this.options.interactive) {
	  			addClass(this._image, 'leaflet-interactive');
	  			this.addInteractiveTarget(this._image);
	  		}
	
	  		this.getPane().appendChild(this._image);
	  		this._reset();
	  	},
	
	  	onRemove: function () {
	  		remove(this._image);
	  		if (this.options.interactive) {
	  			this.removeInteractiveTarget(this._image);
	  		}
	  	},
	
	  	// @method setOpacity(opacity: Number): this
	  	// Sets the opacity of the overlay.
	  	setOpacity: function (opacity) {
	  		this.options.opacity = opacity;
	
	  		if (this._image) {
	  			this._updateOpacity();
	  		}
	  		return this;
	  	},
	
	  	setStyle: function (styleOpts) {
	  		if (styleOpts.opacity) {
	  			this.setOpacity(styleOpts.opacity);
	  		}
	  		return this;
	  	},
	
	  	// @method bringToFront(): this
	  	// Brings the layer to the top of all overlays.
	  	bringToFront: function () {
	  		if (this._map) {
	  			toFront(this._image);
	  		}
	  		return this;
	  	},
	
	  	// @method bringToBack(): this
	  	// Brings the layer to the bottom of all overlays.
	  	bringToBack: function () {
	  		if (this._map) {
	  			toBack(this._image);
	  		}
	  		return this;
	  	},
	
	  	// @method setUrl(url: String): this
	  	// Changes the URL of the image.
	  	setUrl: function (url) {
	  		this._url = url;
	
	  		if (this._image) {
	  			this._image.src = url;
	  		}
	  		return this;
	  	},
	
	  	// @method setBounds(bounds: LatLngBounds): this
	  	// Update the bounds that this ImageOverlay covers
	  	setBounds: function (bounds) {
	  		this._bounds = toLatLngBounds(bounds);
	
	  		if (this._map) {
	  			this._reset();
	  		}
	  		return this;
	  	},
	
	  	getEvents: function () {
	  		var events = {
	  			zoom: this._reset,
	  			viewreset: this._reset
	  		};
	
	  		if (this._zoomAnimated) {
	  			events.zoomanim = this._animateZoom;
	  		}
	
	  		return events;
	  	},
	
	  	// @method setZIndex(value: Number): this
	  	// Changes the [zIndex](#imageoverlay-zindex) of the image overlay.
	  	setZIndex: function (value) {
	  		this.options.zIndex = value;
	  		this._updateZIndex();
	  		return this;
	  	},
	
	  	// @method getBounds(): LatLngBounds
	  	// Get the bounds that this ImageOverlay covers
	  	getBounds: function () {
	  		return this._bounds;
	  	},
	
	  	// @method getElement(): HTMLElement
	  	// Returns the instance of [`HTMLImageElement`](https://developer.mozilla.org/docs/Web/API/HTMLImageElement)
	  	// used by this overlay.
	  	getElement: function () {
	  		return this._image;
	  	},
	
	  	_initImage: function () {
	  		var wasElementSupplied = this._url.tagName === 'IMG';
	  		var img = this._image = wasElementSupplied ? this._url : create$1('img');
	
	  		addClass(img, 'leaflet-image-layer');
	  		if (this._zoomAnimated) { addClass(img, 'leaflet-zoom-animated'); }
	  		if (this.options.className) { addClass(img, this.options.className); }
	
	  		img.onselectstart = falseFn;
	  		img.onmousemove = falseFn;
	
	  		// @event load: Event
	  		// Fired when the ImageOverlay layer has loaded its image
	  		img.onload = bind(this.fire, this, 'load');
	  		img.onerror = bind(this._overlayOnError, this, 'error');
	
	  		if (this.options.crossOrigin || this.options.crossOrigin === '') {
	  			img.crossOrigin = this.options.crossOrigin === true ? '' : this.options.crossOrigin;
	  		}
	
	  		if (this.options.zIndex) {
	  			this._updateZIndex();
	  		}
	
	  		if (wasElementSupplied) {
	  			this._url = img.src;
	  			return;
	  		}
	
	  		img.src = this._url;
	  		img.alt = this.options.alt;
	  	},
	
	  	_animateZoom: function (e) {
	  		var scale = this._map.getZoomScale(e.zoom),
	  		    offset = this._map._latLngBoundsToNewLayerBounds(this._bounds, e.zoom, e.center).min;
	
	  		setTransform(this._image, offset, scale);
	  	},
	
	  	_reset: function () {
	  		var image = this._image,
	  		    bounds = new Bounds(
	  		        this._map.latLngToLayerPoint(this._bounds.getNorthWest()),
	  		        this._map.latLngToLayerPoint(this._bounds.getSouthEast())),
	  		    size = bounds.getSize();
	
	  		setPosition(image, bounds.min);
	
	  		image.style.width  = size.x + 'px';
	  		image.style.height = size.y + 'px';
	  	},
	
	  	_updateOpacity: function () {
	  		setOpacity(this._image, this.options.opacity);
	  	},
	
	  	_updateZIndex: function () {
	  		if (this._image && this.options.zIndex !== undefined && this.options.zIndex !== null) {
	  			this._image.style.zIndex = this.options.zIndex;
	  		}
	  	},
	
	  	_overlayOnError: function () {
	  		// @event error: Event
	  		// Fired when the ImageOverlay layer fails to load its image
	  		this.fire('error');
	
	  		var errorUrl = this.options.errorOverlayUrl;
	  		if (errorUrl && this._url !== errorUrl) {
	  			this._url = errorUrl;
	  			this._image.src = errorUrl;
	  		}
	  	},
	
	  	// @method getCenter(): LatLng
	  	// Returns the center of the ImageOverlay.
	  	getCenter: function () {
	  		return this._bounds.getCenter();
	  	}
	  });
	
	  // @factory L.imageOverlay(imageUrl: String, bounds: LatLngBounds, options?: ImageOverlay options)
	  // Instantiates an image overlay object given the URL of the image and the
	  // geographical bounds it is tied to.
	  var imageOverlay = function (url, bounds, options) {
	  	return new ImageOverlay(url, bounds, options);
	  };
	
	  /*
	   * @class VideoOverlay
	   * @aka L.VideoOverlay
	   * @inherits ImageOverlay
	   *
	   * Used to load and display a video player over specific bounds of the map. Extends `ImageOverlay`.
	   *
	   * A video overlay uses the [`<video>`](https://developer.mozilla.org/docs/Web/HTML/Element/video)
	   * HTML5 element.
	   *
	   * @example
	   *
	   * ```js
	   * var videoUrl = 'https://www.mapbox.com/bites/00188/patricia_nasa.webm',
	   * 	videoBounds = [[ 32, -130], [ 13, -100]];
	   * L.videoOverlay(videoUrl, videoBounds ).addTo(map);
	   * ```
	   */
	
	  var VideoOverlay = ImageOverlay.extend({
	
	  	// @section
	  	// @aka VideoOverlay options
	  	options: {
	  		// @option autoplay: Boolean = true
	  		// Whether the video starts playing automatically when loaded.
	  		// On some browsers autoplay will only work with `muted: true`
	  		autoplay: true,
	
	  		// @option loop: Boolean = true
	  		// Whether the video will loop back to the beginning when played.
	  		loop: true,
	
	  		// @option keepAspectRatio: Boolean = true
	  		// Whether the video will save aspect ratio after the projection.
	  		// Relevant for supported browsers. See [browser compatibility](https://developer.mozilla.org/en-US/docs/Web/CSS/object-fit)
	  		keepAspectRatio: true,
	
	  		// @option muted: Boolean = false
	  		// Whether the video starts on mute when loaded.
	  		muted: false,
	
	  		// @option playsInline: Boolean = true
	  		// Mobile browsers will play the video right where it is instead of open it up in fullscreen mode.
	  		playsInline: true
	  	},
	
	  	_initImage: function () {
	  		var wasElementSupplied = this._url.tagName === 'VIDEO';
	  		var vid = this._image = wasElementSupplied ? this._url : create$1('video');
	
	  		addClass(vid, 'leaflet-image-layer');
	  		if (this._zoomAnimated) { addClass(vid, 'leaflet-zoom-animated'); }
	  		if (this.options.className) { addClass(vid, this.options.className); }
	
	  		vid.onselectstart = falseFn;
	  		vid.onmousemove = falseFn;
	
	  		// @event load: Event
	  		// Fired when the video has finished loading the first frame
	  		vid.onloadeddata = bind(this.fire, this, 'load');
	
	  		if (wasElementSupplied) {
	  			var sourceElements = vid.getElementsByTagName('source');
	  			var sources = [];
	  			for (var j = 0; j < sourceElements.length; j++) {
	  				sources.push(sourceElements[j].src);
	  			}
	
	  			this._url = (sourceElements.length > 0) ? sources : [vid.src];
	  			return;
	  		}
	
	  		if (!isArray(this._url)) { this._url = [this._url]; }
	
	  		if (!this.options.keepAspectRatio && Object.prototype.hasOwnProperty.call(vid.style, 'objectFit')) {
	  			vid.style['objectFit'] = 'fill';
	  		}
	  		vid.autoplay = !!this.options.autoplay;
	  		vid.loop = !!this.options.loop;
	  		vid.muted = !!this.options.muted;
	  		vid.playsInline = !!this.options.playsInline;
	  		for (var i = 0; i < this._url.length; i++) {
	  			var source = create$1('source');
	  			source.src = this._url[i];
	  			vid.appendChild(source);
	  		}
	  	}
	
	  	// @method getElement(): HTMLVideoElement
	  	// Returns the instance of [`HTMLVideoElement`](https://developer.mozilla.org/docs/Web/API/HTMLVideoElement)
	  	// used by this overlay.
	  });
	
	
	  // @factory L.videoOverlay(video: String|Array|HTMLVideoElement, bounds: LatLngBounds, options?: VideoOverlay options)
	  // Instantiates an image overlay object given the URL of the video (or array of URLs, or even a video element) and the
	  // geographical bounds it is tied to.
	
	  function videoOverlay(video, bounds, options) {
	  	return new VideoOverlay(video, bounds, options);
	  }
	
	  /*
	   * @class SVGOverlay
	   * @aka L.SVGOverlay
	   * @inherits ImageOverlay
	   *
	   * Used to load, display and provide DOM access to an SVG file over specific bounds of the map. Extends `ImageOverlay`.
	   *
	   * An SVG overlay uses the [`<svg>`](https://developer.mozilla.org/docs/Web/SVG/Element/svg) element.
	   *
	   * @example
	   *
	   * ```js
	   * var svgElement = document.createElementNS("http://www.w3.org/2000/svg", "svg");
	   * svgElement.setAttribute('xmlns', "http://www.w3.org/2000/svg");
	   * svgElement.setAttribute('viewBox', "0 0 200 200");
	   * svgElement.innerHTML = '<rect width="200" height="200"/><rect x="75" y="23" width="50" height="50" style="fill:red"/><rect x="75" y="123" width="50" height="50" style="fill:#0013ff"/>';
	   * var svgElementBounds = [ [ 32, -130 ], [ 13, -100 ] ];
	   * L.svgOverlay(svgElement, svgElementBounds).addTo(map);
	   * ```
	   */
	
	  var SVGOverlay = ImageOverlay.extend({
	  	_initImage: function () {
	  		var el = this._image = this._url;
	
	  		addClass(el, 'leaflet-image-layer');
	  		if (this._zoomAnimated) { addClass(el, 'leaflet-zoom-animated'); }
	  		if (this.options.className) { addClass(el, this.options.className); }
	
	  		el.onselectstart = falseFn;
	  		el.onmousemove = falseFn;
	  	}
	
	  	// @method getElement(): SVGElement
	  	// Returns the instance of [`SVGElement`](https://developer.mozilla.org/docs/Web/API/SVGElement)
	  	// used by this overlay.
	  });
	
	
	  // @factory L.svgOverlay(svg: String|SVGElement, bounds: LatLngBounds, options?: SVGOverlay options)
	  // Instantiates an image overlay object given an SVG element and the geographical bounds it is tied to.
	  // A viewBox attribute is required on the SVG element to zoom in and out properly.
	
	  function svgOverlay(el, bounds, options) {
	  	return new SVGOverlay(el, bounds, options);
	  }
	
	  /*
	   * @class DivOverlay
	   * @inherits Interactive layer
	   * @aka L.DivOverlay
	   * Base model for L.Popup and L.Tooltip. Inherit from it for custom overlays like plugins.
	   */
	
	  // @namespace DivOverlay
	  var DivOverlay = Layer.extend({
	
	  	// @section
	  	// @aka DivOverlay options
	  	options: {
	  		// @option interactive: Boolean = false
	  		// If true, the popup/tooltip will listen to the mouse events.
	  		interactive: false,
	
	  		// @option offset: Point = Point(0, 0)
	  		// The offset of the overlay position.
	  		offset: [0, 0],
	
	  		// @option className: String = ''
	  		// A custom CSS class name to assign to the overlay.
	  		className: '',
	
	  		// @option pane: String = undefined
	  		// `Map pane` where the overlay will be added.
	  		pane: undefined,
	
	  		// @option content: String|HTMLElement|Function = ''
	  		// Sets the HTML content of the overlay while initializing. If a function is passed the source layer will be
	  		// passed to the function. The function should return a `String` or `HTMLElement` to be used in the overlay.
	  		content: ''
	  	},
	
	  	initialize: function (options, source) {
	  		if (options && (options instanceof LatLng || isArray(options))) {
	  			this._latlng = toLatLng(options);
	  			setOptions(this, source);
	  		} else {
	  			setOptions(this, options);
	  			this._source = source;
	  		}
	  		if (this.options.content) {
	  			this._content = this.options.content;
	  		}
	  	},
	
	  	// @method openOn(map: Map): this
	  	// Adds the overlay to the map.
	  	// Alternative to `map.openPopup(popup)`/`.openTooltip(tooltip)`.
	  	openOn: function (map) {
	  		map = arguments.length ? map : this._source._map; // experimental, not the part of public api
	  		if (!map.hasLayer(this)) {
	  			map.addLayer(this);
	  		}
	  		return this;
	  	},
	
	  	// @method close(): this
	  	// Closes the overlay.
	  	// Alternative to `map.closePopup(popup)`/`.closeTooltip(tooltip)`
	  	// and `layer.closePopup()`/`.closeTooltip()`.
	  	close: function () {
	  		if (this._map) {
	  			this._map.removeLayer(this);
	  		}
	  		return this;
	  	},
	
	  	// @method toggle(layer?: Layer): this
	  	// Opens or closes the overlay bound to layer depending on its current state.
	  	// Argument may be omitted only for overlay bound to layer.
	  	// Alternative to `layer.togglePopup()`/`.toggleTooltip()`.
	  	toggle: function (layer) {
	  		if (this._map) {
	  			this.close();
	  		} else {
	  			if (arguments.length) {
	  				this._source = layer;
	  			} else {
	  				layer = this._source;
	  			}
	  			this._prepareOpen();
	
	  			// open the overlay on the map
	  			this.openOn(layer._map);
	  		}
	  		return this;
	  	},
	
	  	onAdd: function (map) {
	  		this._zoomAnimated = map._zoomAnimated;
	
	  		if (!this._container) {
	  			this._initLayout();
	  		}
	
	  		if (map._fadeAnimated) {
	  			setOpacity(this._container, 0);
	  		}
	
	  		clearTimeout(this._removeTimeout);
	  		this.getPane().appendChild(this._container);
	  		this.update();
	
	  		if (map._fadeAnimated) {
	  			setOpacity(this._container, 1);
	  		}
	
	  		this.bringToFront();
	
	  		if (this.options.interactive) {
	  			addClass(this._container, 'leaflet-interactive');
	  			this.addInteractiveTarget(this._container);
	  		}
	  	},
	
	  	onRemove: function (map) {
	  		if (map._fadeAnimated) {
	  			setOpacity(this._container, 0);
	  			this._removeTimeout = setTimeout(bind(remove, undefined, this._container), 200);
	  		} else {
	  			remove(this._container);
	  		}
	
	  		if (this.options.interactive) {
	  			removeClass(this._container, 'leaflet-interactive');
	  			this.removeInteractiveTarget(this._container);
	  		}
	  	},
	
	  	// @namespace DivOverlay
	  	// @method getLatLng: LatLng
	  	// Returns the geographical point of the overlay.
	  	getLatLng: function () {
	  		return this._latlng;
	  	},
	
	  	// @method setLatLng(latlng: LatLng): this
	  	// Sets the geographical point where the overlay will open.
	  	setLatLng: function (latlng) {
	  		this._latlng = toLatLng(latlng);
	  		if (this._map) {
	  			this._updatePosition();
	  			this._adjustPan();
	  		}
	  		return this;
	  	},
	
	  	// @method getContent: String|HTMLElement
	  	// Returns the content of the overlay.
	  	getContent: function () {
	  		return this._content;
	  	},
	
	  	// @method setContent(htmlContent: String|HTMLElement|Function): this
	  	// Sets the HTML content of the overlay. If a function is passed the source layer will be passed to the function.
	  	// The function should return a `String` or `HTMLElement` to be used in the overlay.
	  	setContent: function (content) {
	  		this._content = content;
	  		this.update();
	  		return this;
	  	},
	
	  	// @method getElement: String|HTMLElement
	  	// Returns the HTML container of the overlay.
	  	getElement: function () {
	  		return this._container;
	  	},
	
	  	// @method update: null
	  	// Updates the overlay content, layout and position. Useful for updating the overlay after something inside changed, e.g. image loaded.
	  	update: function () {
	  		if (!this._map) { return; }
	
	  		this._container.style.visibility = 'hidden';
	
	  		this._updateContent();
	  		this._updateLayout();
	  		this._updatePosition();
	
	  		this._container.style.visibility = '';
	
	  		this._adjustPan();
	  	},
	
	  	getEvents: function () {
	  		var events = {
	  			zoom: this._updatePosition,
	  			viewreset: this._updatePosition
	  		};
	
	  		if (this._zoomAnimated) {
	  			events.zoomanim = this._animateZoom;
	  		}
	  		return events;
	  	},
	
	  	// @method isOpen: Boolean
	  	// Returns `true` when the overlay is visible on the map.
	  	isOpen: function () {
	  		return !!this._map && this._map.hasLayer(this);
	  	},
	
	  	// @method bringToFront: this
	  	// Brings this overlay in front of other overlays (in the same map pane).
	  	bringToFront: function () {
	  		if (this._map) {
	  			toFront(this._container);
	  		}
	  		return this;
	  	},
	
	  	// @method bringToBack: this
	  	// Brings this overlay to the back of other overlays (in the same map pane).
	  	bringToBack: function () {
	  		if (this._map) {
	  			toBack(this._container);
	  		}
	  		return this;
	  	},
	
	  	// prepare bound overlay to open: update latlng pos / content source (for FeatureGroup)
	  	_prepareOpen: function (latlng) {
	  		var source = this._source;
	  		if (!source._map) { return false; }
	
	  		if (source instanceof FeatureGroup) {
	  			source = null;
	  			var layers = this._source._layers;
	  			for (var id in layers) {
	  				if (layers[id]._map) {
	  					source = layers[id];
	  					break;
	  				}
	  			}
	  			if (!source) { return false; } // Unable to get source layer.
	
	  			// set overlay source to this layer
	  			this._source = source;
	  		}
	
	  		if (!latlng) {
	  			if (source.getCenter) {
	  				latlng = source.getCenter();
	  			} else if (source.getLatLng) {
	  				latlng = source.getLatLng();
	  			} else if (source.getBounds) {
	  				latlng = source.getBounds().getCenter();
	  			} else {
	  				throw new Error('Unable to get source layer LatLng.');
	  			}
	  		}
	  		this.setLatLng(latlng);
	
	  		if (this._map) {
	  			// update the overlay (content, layout, etc...)
	  			this.update();
	  		}
	
	  		return true;
	  	},
	
	  	_updateContent: function () {
	  		if (!this._content) { return; }
	
	  		var node = this._contentNode;
	  		var content = (typeof this._content === 'function') ? this._content(this._source || this) : this._content;
	
	  		if (typeof content === 'string') {
	  			node.innerHTML = content;
	  		} else {
	  			while (node.hasChildNodes()) {
	  				node.removeChild(node.firstChild);
	  			}
	  			node.appendChild(content);
	  		}
	
	  		// @namespace DivOverlay
	  		// @section DivOverlay events
	  		// @event contentupdate: Event
	  		// Fired when the content of the overlay is updated
	  		this.fire('contentupdate');
	  	},
	
	  	_updatePosition: function () {
	  		if (!this._map) { return; }
	
	  		var pos = this._map.latLngToLayerPoint(this._latlng),
	  		    offset = toPoint(this.options.offset),
	  		    anchor = this._getAnchor();
	
	  		if (this._zoomAnimated) {
	  			setPosition(this._container, pos.add(anchor));
	  		} else {
	  			offset = offset.add(pos).add(anchor);
	  		}
	
	  		var bottom = this._containerBottom = -offset.y,
	  		    left = this._containerLeft = -Math.round(this._containerWidth / 2) + offset.x;
	
	  		// bottom position the overlay in case the height of the overlay changes (images loading etc)
	  		this._container.style.bottom = bottom + 'px';
	  		this._container.style.left = left + 'px';
	  	},
	
	  	_getAnchor: function () {
	  		return [0, 0];
	  	}
	
	  });
	
	  Map.include({
	  	_initOverlay: function (OverlayClass, content, latlng, options) {
	  		var overlay = content;
	  		if (!(overlay instanceof OverlayClass)) {
	  			overlay = new OverlayClass(options).setContent(content);
	  		}
	  		if (latlng) {
	  			overlay.setLatLng(latlng);
	  		}
	  		return overlay;
	  	}
	  });
	
	
	  Layer.include({
	  	_initOverlay: function (OverlayClass, old, content, options) {
	  		var overlay = content;
	  		if (overlay instanceof OverlayClass) {
	  			setOptions(overlay, options);
	  			overlay._source = this;
	  		} else {
	  			overlay = (old && !options) ? old : new OverlayClass(options, this);
	  			overlay.setContent(content);
	  		}
	  		return overlay;
	  	}
	  });
	
	  /*
	   * @class Popup
	   * @inherits DivOverlay
	   * @aka L.Popup
	   * Used to open popups in certain places of the map. Use [Map.openPopup](#map-openpopup) to
	   * open popups while making sure that only one popup is open at one time
	   * (recommended for usability), or use [Map.addLayer](#map-addlayer) to open as many as you want.
	   *
	   * @example
	   *
	   * If you want to just bind a popup to marker click and then open it, it's really easy:
	   *
	   * ```js
	   * marker.bindPopup(popupContent).openPopup();
	   * ```
	   * Path overlays like polylines also have a `bindPopup` method.
	   *
	   * A popup can be also standalone:
	   *
	   * ```js
	   * var popup = L.popup()
	   * 	.setLatLng(latlng)
	   * 	.setContent('<p>Hello world!<br />This is a nice popup.</p>')
	   * 	.openOn(map);
	   * ```
	   * or
	   * ```js
	   * var popup = L.popup(latlng, {content: '<p>Hello world!<br />This is a nice popup.</p>')
	   * 	.openOn(map);
	   * ```
	   */
	
	
	  // @namespace Popup
	  var Popup = DivOverlay.extend({
	
	  	// @section
	  	// @aka Popup options
	  	options: {
	  		// @option pane: String = 'popupPane'
	  		// `Map pane` where the popup will be added.
	  		pane: 'popupPane',
	
	  		// @option offset: Point = Point(0, 7)
	  		// The offset of the popup position.
	  		offset: [0, 7],
	
	  		// @option maxWidth: Number = 300
	  		// Max width of the popup, in pixels.
	  		maxWidth: 300,
	
	  		// @option minWidth: Number = 50
	  		// Min width of the popup, in pixels.
	  		minWidth: 50,
	
	  		// @option maxHeight: Number = null
	  		// If set, creates a scrollable container of the given height
	  		// inside a popup if its content exceeds it.
	  		// The scrollable container can be styled using the
	  		// `leaflet-popup-scrolled` CSS class selector.
	  		maxHeight: null,
	
	  		// @option autoPan: Boolean = true
	  		// Set it to `false` if you don't want the map to do panning animation
	  		// to fit the opened popup.
	  		autoPan: true,
	
	  		// @option autoPanPaddingTopLeft: Point = null
	  		// The margin between the popup and the top left corner of the map
	  		// view after autopanning was performed.
	  		autoPanPaddingTopLeft: null,
	
	  		// @option autoPanPaddingBottomRight: Point = null
	  		// The margin between the popup and the bottom right corner of the map
	  		// view after autopanning was performed.
	  		autoPanPaddingBottomRight: null,
	
	  		// @option autoPanPadding: Point = Point(5, 5)
	  		// Equivalent of setting both top left and bottom right autopan padding to the same value.
	  		autoPanPadding: [5, 5],
	
	  		// @option keepInView: Boolean = false
	  		// Set it to `true` if you want to prevent users from panning the popup
	  		// off of the screen while it is open.
	  		keepInView: false,
	
	  		// @option closeButton: Boolean = true
	  		// Controls the presence of a close button in the popup.
	  		closeButton: true,
	
	  		// @option autoClose: Boolean = true
	  		// Set it to `false` if you want to override the default behavior of
	  		// the popup closing when another popup is opened.
	  		autoClose: true,
	
	  		// @option closeOnEscapeKey: Boolean = true
	  		// Set it to `false` if you want to override the default behavior of
	  		// the ESC key for closing of the popup.
	  		closeOnEscapeKey: true,
	
	  		// @option closeOnClick: Boolean = *
	  		// Set it if you want to override the default behavior of the popup closing when user clicks
	  		// on the map. Defaults to the map's [`closePopupOnClick`](#map-closepopuponclick) option.
	
	  		// @option className: String = ''
	  		// A custom CSS class name to assign to the popup.
	  		className: ''
	  	},
	
	  	// @namespace Popup
	  	// @method openOn(map: Map): this
	  	// Alternative to `map.openPopup(popup)`.
	  	// Adds the popup to the map and closes the previous one.
	  	openOn: function (map) {
	  		map = arguments.length ? map : this._source._map; // experimental, not the part of public api
	
	  		if (!map.hasLayer(this) && map._popup && map._popup.options.autoClose) {
	  			map.removeLayer(map._popup);
	  		}
	  		map._popup = this;
	
	  		return DivOverlay.prototype.openOn.call(this, map);
	  	},
	
	  	onAdd: function (map) {
	  		DivOverlay.prototype.onAdd.call(this, map);
	
	  		// @namespace Map
	  		// @section Popup events
	  		// @event popupopen: PopupEvent
	  		// Fired when a popup is opened in the map
	  		map.fire('popupopen', {popup: this});
	
	  		if (this._source) {
	  			// @namespace Layer
	  			// @section Popup events
	  			// @event popupopen: PopupEvent
	  			// Fired when a popup bound to this layer is opened
	  			this._source.fire('popupopen', {popup: this}, true);
	  			// For non-path layers, we toggle the popup when clicking
	  			// again the layer, so prevent the map to reopen it.
	  			if (!(this._source instanceof Path)) {
	  				this._source.on('preclick', stopPropagation);
	  			}
	  		}
	  	},
	
	  	onRemove: function (map) {
	  		DivOverlay.prototype.onRemove.call(this, map);
	
	  		// @namespace Map
	  		// @section Popup events
	  		// @event popupclose: PopupEvent
	  		// Fired when a popup in the map is closed
	  		map.fire('popupclose', {popup: this});
	
	  		if (this._source) {
	  			// @namespace Layer
	  			// @section Popup events
	  			// @event popupclose: PopupEvent
	  			// Fired when a popup bound to this layer is closed
	  			this._source.fire('popupclose', {popup: this}, true);
	  			if (!(this._source instanceof Path)) {
	  				this._source.off('preclick', stopPropagation);
	  			}
	  		}
	  	},
	
	  	getEvents: function () {
	  		var events = DivOverlay.prototype.getEvents.call(this);
	
	  		if (this.options.closeOnClick !== undefined ? this.options.closeOnClick : this._map.options.closePopupOnClick) {
	  			events.preclick = this.close;
	  		}
	
	  		if (this.options.keepInView) {
	  			events.moveend = this._adjustPan;
	  		}
	
	  		return events;
	  	},
	
	  	_initLayout: function () {
	  		var prefix = 'leaflet-popup',
	  		    container = this._container = create$1('div',
	  			prefix + ' ' + (this.options.className || '') +
	  			' leaflet-zoom-animated');
	
	  		var wrapper = this._wrapper = create$1('div', prefix + '-content-wrapper', container);
	  		this._contentNode = create$1('div', prefix + '-content', wrapper);
	
	  		disableClickPropagation(container);
	  		disableScrollPropagation(this._contentNode);
	  		on(container, 'contextmenu', stopPropagation);
	
	  		this._tipContainer = create$1('div', prefix + '-tip-container', container);
	  		this._tip = create$1('div', prefix + '-tip', this._tipContainer);
	
	  		if (this.options.closeButton) {
	  			var closeButton = this._closeButton = create$1('a', prefix + '-close-button', container);
	  			closeButton.setAttribute('role', 'button'); // overrides the implicit role=link of <a> elements #7399
	  			closeButton.setAttribute('aria-label', 'Close popup');
	  			closeButton.href = '#close';
	  			closeButton.innerHTML = '<span aria-hidden="true">&#215;</span>';
	
	  			on(closeButton, 'click', function (ev) {
	  				preventDefault(ev);
	  				this.close();
	  			}, this);
	  		}
	  	},
	
	  	_updateLayout: function () {
	  		var container = this._contentNode,
	  		    style = container.style;
	
	  		style.width = '';
	  		style.whiteSpace = 'nowrap';
	
	  		var width = container.offsetWidth;
	  		width = Math.min(width, this.options.maxWidth);
	  		width = Math.max(width, this.options.minWidth);
	
	  		style.width = (width + 1) + 'px';
	  		style.whiteSpace = '';
	
	  		style.height = '';
	
	  		var height = container.offsetHeight,
	  		    maxHeight = this.options.maxHeight,
	  		    scrolledClass = 'leaflet-popup-scrolled';
	
	  		if (maxHeight && height > maxHeight) {
	  			style.height = maxHeight + 'px';
	  			addClass(container, scrolledClass);
	  		} else {
	  			removeClass(container, scrolledClass);
	  		}
	
	  		this._containerWidth = this._container.offsetWidth;
	  	},
	
	  	_animateZoom: function (e) {
	  		var pos = this._map._latLngToNewLayerPoint(this._latlng, e.zoom, e.center),
	  		    anchor = this._getAnchor();
	  		setPosition(this._container, pos.add(anchor));
	  	},
	
	  	_adjustPan: function () {
	  		if (!this.options.autoPan) { return; }
	  		if (this._map._panAnim) { this._map._panAnim.stop(); }
	
	  		// We can endlessly recurse if keepInView is set and the view resets.
	  		// Let's guard against that by exiting early if we're responding to our own autopan.
	  		if (this._autopanning) {
	  			this._autopanning = false;
	  			return;
	  		}
	
	  		var map = this._map,
	  		    marginBottom = parseInt(getStyle(this._container, 'marginBottom'), 10) || 0,
	  		    containerHeight = this._container.offsetHeight + marginBottom,
	  		    containerWidth = this._containerWidth,
	  		    layerPos = new Point(this._containerLeft, -containerHeight - this._containerBottom);
	
	  		layerPos._add(getPosition(this._container));
	
	  		var containerPos = map.layerPointToContainerPoint(layerPos),
	  		    padding = toPoint(this.options.autoPanPadding),
	  		    paddingTL = toPoint(this.options.autoPanPaddingTopLeft || padding),
	  		    paddingBR = toPoint(this.options.autoPanPaddingBottomRight || padding),
	  		    size = map.getSize(),
	  		    dx = 0,
	  		    dy = 0;
	
	  		if (containerPos.x + containerWidth + paddingBR.x > size.x) { // right
	  			dx = containerPos.x + containerWidth - size.x + paddingBR.x;
	  		}
	  		if (containerPos.x - dx - paddingTL.x < 0) { // left
	  			dx = containerPos.x - paddingTL.x;
	  		}
	  		if (containerPos.y + containerHeight + paddingBR.y > size.y) { // bottom
	  			dy = containerPos.y + containerHeight - size.y + paddingBR.y;
	  		}
	  		if (containerPos.y - dy - paddingTL.y < 0) { // top
	  			dy = containerPos.y - paddingTL.y;
	  		}
	
	  		// @namespace Map
	  		// @section Popup events
	  		// @event autopanstart: Event
	  		// Fired when the map starts autopanning when opening a popup.
	  		if (dx || dy) {
	  			// Track that we're autopanning, as this function will be re-ran on moveend
	  			if (this.options.keepInView) {
	  				this._autopanning = true;
	  			}
	
	  			map
	  			    .fire('autopanstart')
	  			    .panBy([dx, dy]);
	  		}
	  	},
	
	  	_getAnchor: function () {
	  		// Where should we anchor the popup on the source layer?
	  		return toPoint(this._source && this._source._getPopupAnchor ? this._source._getPopupAnchor() : [0, 0]);
	  	}
	
	  });
	
	  // @namespace Popup
	  // @factory L.popup(options?: Popup options, source?: Layer)
	  // Instantiates a `Popup` object given an optional `options` object that describes its appearance and location and an optional `source` object that is used to tag the popup with a reference to the Layer to which it refers.
	  // @alternative
	  // @factory L.popup(latlng: LatLng, options?: Popup options)
	  // Instantiates a `Popup` object given `latlng` where the popup will open and an optional `options` object that describes its appearance and location.
	  var popup = function (options, source) {
	  	return new Popup(options, source);
	  };
	
	
	  /* @namespace Map
	   * @section Interaction Options
	   * @option closePopupOnClick: Boolean = true
	   * Set it to `false` if you don't want popups to close when user clicks the map.
	   */
	  Map.mergeOptions({
	  	closePopupOnClick: true
	  });
	
	
	  // @namespace Map
	  // @section Methods for Layers and Controls
	  Map.include({
	  	// @method openPopup(popup: Popup): this
	  	// Opens the specified popup while closing the previously opened (to make sure only one is opened at one time for usability).
	  	// @alternative
	  	// @method openPopup(content: String|HTMLElement, latlng: LatLng, options?: Popup options): this
	  	// Creates a popup with the specified content and options and opens it in the given point on a map.
	  	openPopup: function (popup, latlng, options) {
	  		this._initOverlay(Popup, popup, latlng, options)
	  		  .openOn(this);
	
	  		return this;
	  	},
	
	  	// @method closePopup(popup?: Popup): this
	  	// Closes the popup previously opened with [openPopup](#map-openpopup) (or the given one).
	  	closePopup: function (popup) {
	  		popup = arguments.length ? popup : this._popup;
	  		if (popup) {
	  			popup.close();
	  		}
	  		return this;
	  	}
	  });
	
	  /*
	   * @namespace Layer
	   * @section Popup methods example
	   *
	   * All layers share a set of methods convenient for binding popups to it.
	   *
	   * ```js
	   * var layer = L.Polygon(latlngs).bindPopup('Hi There!').addTo(map);
	   * layer.openPopup();
	   * layer.closePopup();
	   * ```
	   *
	   * Popups will also be automatically opened when the layer is clicked on and closed when the layer is removed from the map or another popup is opened.
	   */
	
	  // @section Popup methods
	  Layer.include({
	
	  	// @method bindPopup(content: String|HTMLElement|Function|Popup, options?: Popup options): this
	  	// Binds a popup to the layer with the passed `content` and sets up the
	  	// necessary event listeners. If a `Function` is passed it will receive
	  	// the layer as the first argument and should return a `String` or `HTMLElement`.
	  	bindPopup: function (content, options) {
	  		this._popup = this._initOverlay(Popup, this._popup, content, options);
	  		if (!this._popupHandlersAdded) {
	  			this.on({
	  				click: this._openPopup,
	  				keypress: this._onKeyPress,
	  				remove: this.closePopup,
	  				move: this._movePopup
	  			});
	  			this._popupHandlersAdded = true;
	  		}
	
	  		return this;
	  	},
	
	  	// @method unbindPopup(): this
	  	// Removes the popup previously bound with `bindPopup`.
	  	unbindPopup: function () {
	  		if (this._popup) {
	  			this.off({
	  				click: this._openPopup,
	  				keypress: this._onKeyPress,
	  				remove: this.closePopup,
	  				move: this._movePopup
	  			});
	  			this._popupHandlersAdded = false;
	  			this._popup = null;
	  		}
	  		return this;
	  	},
	
	  	// @method openPopup(latlng?: LatLng): this
	  	// Opens the bound popup at the specified `latlng` or at the default popup anchor if no `latlng` is passed.
	  	openPopup: function (latlng) {
	  		if (this._popup) {
	  			if (!(this instanceof FeatureGroup)) {
	  				this._popup._source = this;
	  			}
	  			if (this._popup._prepareOpen(latlng || this._latlng)) {
	  				// open the popup on the map
	  				this._popup.openOn(this._map);
	  			}
	  		}
	  		return this;
	  	},
	
	  	// @method closePopup(): this
	  	// Closes the popup bound to this layer if it is open.
	  	closePopup: function () {
	  		if (this._popup) {
	  			this._popup.close();
	  		}
	  		return this;
	  	},
	
	  	// @method togglePopup(): this
	  	// Opens or closes the popup bound to this layer depending on its current state.
	  	togglePopup: function () {
	  		if (this._popup) {
	  			this._popup.toggle(this);
	  		}
	  		return this;
	  	},
	
	  	// @method isPopupOpen(): boolean
	  	// Returns `true` if the popup bound to this layer is currently open.
	  	isPopupOpen: function () {
	  		return (this._popup ? this._popup.isOpen() : false);
	  	},
	
	  	// @method setPopupContent(content: String|HTMLElement|Popup): this
	  	// Sets the content of the popup bound to this layer.
	  	setPopupContent: function (content) {
	  		if (this._popup) {
	  			this._popup.setContent(content);
	  		}
	  		return this;
	  	},
	
	  	// @method getPopup(): Popup
	  	// Returns the popup bound to this layer.
	  	getPopup: function () {
	  		return this._popup;
	  	},
	
	  	_openPopup: function (e) {
	  		if (!this._popup || !this._map) {
	  			return;
	  		}
	  		// prevent map click
	  		stop(e);
	
	  		var target = e.layer || e.target;
	  		if (this._popup._source === target && !(target instanceof Path)) {
	  			// treat it like a marker and figure out
	  			// if we should toggle it open/closed
	  			if (this._map.hasLayer(this._popup)) {
	  				this.closePopup();
	  			} else {
	  				this.openPopup(e.latlng);
	  			}
	  			return;
	  		}
	  		this._popup._source = target;
	  		this.openPopup(e.latlng);
	  	},
	
	  	_movePopup: function (e) {
	  		this._popup.setLatLng(e.latlng);
	  	},
	
	  	_onKeyPress: function (e) {
	  		if (e.originalEvent.keyCode === 13) {
	  			this._openPopup(e);
	  		}
	  	}
	  });
	
	  /*
	   * @class Tooltip
	   * @inherits DivOverlay
	   * @aka L.Tooltip
	   * Used to display small texts on top of map layers.
	   *
	   * @example
	   * If you want to just bind a tooltip to marker:
	   *
	   * ```js
	   * marker.bindTooltip("my tooltip text").openTooltip();
	   * ```
	   * Path overlays like polylines also have a `bindTooltip` method.
	   *
	   * A tooltip can be also standalone:
	   *
	   * ```js
	   * var tooltip = L.tooltip()
	   * 	.setLatLng(latlng)
	   * 	.setContent('Hello world!<br />This is a nice tooltip.')
	   * 	.addTo(map);
	   * ```
	   * or
	   * ```js
	   * var tooltip = L.tooltip(latlng, {content: 'Hello world!<br />This is a nice tooltip.'})
	   * 	.addTo(map);
	   * ```
	   *
	   *
	   * Note about tooltip offset. Leaflet takes two options in consideration
	   * for computing tooltip offsetting:
	   * - the `offset` Tooltip option: it defaults to [0, 0], and it's specific to one tooltip.
	   *   Add a positive x offset to move the tooltip to the right, and a positive y offset to
	   *   move it to the bottom. Negatives will move to the left and top.
	   * - the `tooltipAnchor` Icon option: this will only be considered for Marker. You
	   *   should adapt this value if you use a custom icon.
	   */
	
	
	  // @namespace Tooltip
	  var Tooltip = DivOverlay.extend({
	
	  	// @section
	  	// @aka Tooltip options
	  	options: {
	  		// @option pane: String = 'tooltipPane'
	  		// `Map pane` where the tooltip will be added.
	  		pane: 'tooltipPane',
	
	  		// @option offset: Point = Point(0, 0)
	  		// Optional offset of the tooltip position.
	  		offset: [0, 0],
	
	  		// @option direction: String = 'auto'
	  		// Direction where to open the tooltip. Possible values are: `right`, `left`,
	  		// `top`, `bottom`, `center`, `auto`.
	  		// `auto` will dynamically switch between `right` and `left` according to the tooltip
	  		// position on the map.
	  		direction: 'auto',
	
	  		// @option permanent: Boolean = false
	  		// Whether to open the tooltip permanently or only on mouseover.
	  		permanent: false,
	
	  		// @option sticky: Boolean = false
	  		// If true, the tooltip will follow the mouse instead of being fixed at the feature center.
	  		sticky: false,
	
	  		// @option opacity: Number = 0.9
	  		// Tooltip container opacity.
	  		opacity: 0.9
	  	},
	
	  	onAdd: function (map) {
	  		DivOverlay.prototype.onAdd.call(this, map);
	  		this.setOpacity(this.options.opacity);
	
	  		// @namespace Map
	  		// @section Tooltip events
	  		// @event tooltipopen: TooltipEvent
	  		// Fired when a tooltip is opened in the map.
	  		map.fire('tooltipopen', {tooltip: this});
	
	  		if (this._source) {
	  			this.addEventParent(this._source);
	
	  			// @namespace Layer
	  			// @section Tooltip events
	  			// @event tooltipopen: TooltipEvent
	  			// Fired when a tooltip bound to this layer is opened.
	  			this._source.fire('tooltipopen', {tooltip: this}, true);
	  		}
	  	},
	
	  	onRemove: function (map) {
	  		DivOverlay.prototype.onRemove.call(this, map);
	
	  		// @namespace Map
	  		// @section Tooltip events
	  		// @event tooltipclose: TooltipEvent
	  		// Fired when a tooltip in the map is closed.
	  		map.fire('tooltipclose', {tooltip: this});
	
	  		if (this._source) {
	  			this.removeEventParent(this._source);
	
	  			// @namespace Layer
	  			// @section Tooltip events
	  			// @event tooltipclose: TooltipEvent
	  			// Fired when a tooltip bound to this layer is closed.
	  			this._source.fire('tooltipclose', {tooltip: this}, true);
	  		}
	  	},
	
	  	getEvents: function () {
	  		var events = DivOverlay.prototype.getEvents.call(this);
	
	  		if (!this.options.permanent) {
	  			events.preclick = this.close;
	  		}
	
	  		return events;
	  	},
	
	  	_initLayout: function () {
	  		var prefix = 'leaflet-tooltip',
	  		    className = prefix + ' ' + (this.options.className || '') + ' leaflet-zoom-' + (this._zoomAnimated ? 'animated' : 'hide');
	
	  		this._contentNode = this._container = create$1('div', className);
	
	  		this._container.setAttribute('role', 'tooltip');
	  		this._container.setAttribute('id', 'leaflet-tooltip-' + stamp(this));
	  	},
	
	  	_updateLayout: function () {},
	
	  	_adjustPan: function () {},
	
	  	_setPosition: function (pos) {
	  		var subX, subY,
	  		    map = this._map,
	  		    container = this._container,
	  		    centerPoint = map.latLngToContainerPoint(map.getCenter()),
	  		    tooltipPoint = map.layerPointToContainerPoint(pos),
	  		    direction = this.options.direction,
	  		    tooltipWidth = container.offsetWidth,
	  		    tooltipHeight = container.offsetHeight,
	  		    offset = toPoint(this.options.offset),
	  		    anchor = this._getAnchor();
	
	  		if (direction === 'top') {
	  			subX = tooltipWidth / 2;
	  			subY = tooltipHeight;
	  		} else if (direction === 'bottom') {
	  			subX = tooltipWidth / 2;
	  			subY = 0;
	  		} else if (direction === 'center') {
	  			subX = tooltipWidth / 2;
	  			subY = tooltipHeight / 2;
	  		} else if (direction === 'right') {
	  			subX = 0;
	  			subY = tooltipHeight / 2;
	  		} else if (direction === 'left') {
	  			subX = tooltipWidth;
	  			subY = tooltipHeight / 2;
	  		} else if (tooltipPoint.x < centerPoint.x) {
	  			direction = 'right';
	  			subX = 0;
	  			subY = tooltipHeight / 2;
	  		} else {
	  			direction = 'left';
	  			subX = tooltipWidth + (offset.x + anchor.x) * 2;
	  			subY = tooltipHeight / 2;
	  		}
	
	  		pos = pos.subtract(toPoint(subX, subY, true)).add(offset).add(anchor);
	
	  		removeClass(container, 'leaflet-tooltip-right');
	  		removeClass(container, 'leaflet-tooltip-left');
	  		removeClass(container, 'leaflet-tooltip-top');
	  		removeClass(container, 'leaflet-tooltip-bottom');
	  		addClass(container, 'leaflet-tooltip-' + direction);
	  		setPosition(container, pos);
	  	},
	
	  	_updatePosition: function () {
	  		var pos = this._map.latLngToLayerPoint(this._latlng);
	  		this._setPosition(pos);
	  	},
	
	  	setOpacity: function (opacity) {
	  		this.options.opacity = opacity;
	
	  		if (this._container) {
	  			setOpacity(this._container, opacity);
	  		}
	  	},
	
	  	_animateZoom: function (e) {
	  		var pos = this._map._latLngToNewLayerPoint(this._latlng, e.zoom, e.center);
	  		this._setPosition(pos);
	  	},
	
	  	_getAnchor: function () {
	  		// Where should we anchor the tooltip on the source layer?
	  		return toPoint(this._source && this._source._getTooltipAnchor && !this.options.sticky ? this._source._getTooltipAnchor() : [0, 0]);
	  	}
	
	  });
	
	  // @namespace Tooltip
	  // @factory L.tooltip(options?: Tooltip options, source?: Layer)
	  // Instantiates a `Tooltip` object given an optional `options` object that describes its appearance and location and an optional `source` object that is used to tag the tooltip with a reference to the Layer to which it refers.
	  // @alternative
	  // @factory L.tooltip(latlng: LatLng, options?: Tooltip options)
	  // Instantiates a `Tooltip` object given `latlng` where the tooltip will open and an optional `options` object that describes its appearance and location.
	  var tooltip = function (options, source) {
	  	return new Tooltip(options, source);
	  };
	
	  // @namespace Map
	  // @section Methods for Layers and Controls
	  Map.include({
	
	  	// @method openTooltip(tooltip: Tooltip): this
	  	// Opens the specified tooltip.
	  	// @alternative
	  	// @method openTooltip(content: String|HTMLElement, latlng: LatLng, options?: Tooltip options): this
	  	// Creates a tooltip with the specified content and options and open it.
	  	openTooltip: function (tooltip, latlng, options) {
	  		this._initOverlay(Tooltip, tooltip, latlng, options)
	  		  .openOn(this);
	
	  		return this;
	  	},
	
	  	// @method closeTooltip(tooltip: Tooltip): this
	  	// Closes the tooltip given as parameter.
	  	closeTooltip: function (tooltip) {
	  		tooltip.close();
	  		return this;
	  	}
	
	  });
	
	  /*
	   * @namespace Layer
	   * @section Tooltip methods example
	   *
	   * All layers share a set of methods convenient for binding tooltips to it.
	   *
	   * ```js
	   * var layer = L.Polygon(latlngs).bindTooltip('Hi There!').addTo(map);
	   * layer.openTooltip();
	   * layer.closeTooltip();
	   * ```
	   */
	
	  // @section Tooltip methods
	  Layer.include({
	
	  	// @method bindTooltip(content: String|HTMLElement|Function|Tooltip, options?: Tooltip options): this
	  	// Binds a tooltip to the layer with the passed `content` and sets up the
	  	// necessary event listeners. If a `Function` is passed it will receive
	  	// the layer as the first argument and should return a `String` or `HTMLElement`.
	  	bindTooltip: function (content, options) {
	
	  		if (this._tooltip && this.isTooltipOpen()) {
	  			this.unbindTooltip();
	  		}
	
	  		this._tooltip = this._initOverlay(Tooltip, this._tooltip, content, options);
	  		this._initTooltipInteractions();
	
	  		if (this._tooltip.options.permanent && this._map && this._map.hasLayer(this)) {
	  			this.openTooltip();
	  		}
	
	  		return this;
	  	},
	
	  	// @method unbindTooltip(): this
	  	// Removes the tooltip previously bound with `bindTooltip`.
	  	unbindTooltip: function () {
	  		if (this._tooltip) {
	  			this._initTooltipInteractions(true);
	  			this.closeTooltip();
	  			this._tooltip = null;
	  		}
	  		return this;
	  	},
	
	  	_initTooltipInteractions: function (remove) {
	  		if (!remove && this._tooltipHandlersAdded) { return; }
	  		var onOff = remove ? 'off' : 'on',
	  		    events = {
	  			remove: this.closeTooltip,
	  			move: this._moveTooltip
	  		    };
	  		if (!this._tooltip.options.permanent) {
	  			events.mouseover = this._openTooltip;
	  			events.mouseout = this.closeTooltip;
	  			events.click = this._openTooltip;
	  			if (this._map) {
	  				this._addFocusListeners();
	  			} else {
	  				events.add = this._addFocusListeners;
	  			}
	  		} else {
	  			events.add = this._openTooltip;
	  		}
	  		if (this._tooltip.options.sticky) {
	  			events.mousemove = this._moveTooltip;
	  		}
	  		this[onOff](events);
	  		this._tooltipHandlersAdded = !remove;
	  	},
	
	  	// @method openTooltip(latlng?: LatLng): this
	  	// Opens the bound tooltip at the specified `latlng` or at the default tooltip anchor if no `latlng` is passed.
	  	openTooltip: function (latlng) {
	  		if (this._tooltip) {
	  			if (!(this instanceof FeatureGroup)) {
	  				this._tooltip._source = this;
	  			}
	  			if (this._tooltip._prepareOpen(latlng)) {
	  				// open the tooltip on the map
	  				this._tooltip.openOn(this._map);
	
	  				if (this.getElement) {
	  					this._setAriaDescribedByOnLayer(this);
	  				} else if (this.eachLayer) {
	  					this.eachLayer(this._setAriaDescribedByOnLayer, this);
	  				}
	  			}
	  		}
	  		return this;
	  	},
	
	  	// @method closeTooltip(): this
	  	// Closes the tooltip bound to this layer if it is open.
	  	closeTooltip: function () {
	  		if (this._tooltip) {
	  			return this._tooltip.close();
	  		}
	  	},
	
	  	// @method toggleTooltip(): this
	  	// Opens or closes the tooltip bound to this layer depending on its current state.
	  	toggleTooltip: function () {
	  		if (this._tooltip) {
	  			this._tooltip.toggle(this);
	  		}
	  		return this;
	  	},
	
	  	// @method isTooltipOpen(): boolean
	  	// Returns `true` if the tooltip bound to this layer is currently open.
	  	isTooltipOpen: function () {
	  		return this._tooltip.isOpen();
	  	},
	
	  	// @method setTooltipContent(content: String|HTMLElement|Tooltip): this
	  	// Sets the content of the tooltip bound to this layer.
	  	setTooltipContent: function (content) {
	  		if (this._tooltip) {
	  			this._tooltip.setContent(content);
	  		}
	  		return this;
	  	},
	
	  	// @method getTooltip(): Tooltip
	  	// Returns the tooltip bound to this layer.
	  	getTooltip: function () {
	  		return this._tooltip;
	  	},
	
	  	_addFocusListeners: function () {
	  		if (this.getElement) {
	  			this._addFocusListenersOnLayer(this);
	  		} else if (this.eachLayer) {
	  			this.eachLayer(this._addFocusListenersOnLayer, this);
	  		}
	  	},
	
	  	_addFocusListenersOnLayer: function (layer) {
	  		var el = typeof layer.getElement === 'function' && layer.getElement();
	  		if (el) {
	  			on(el, 'focus', function () {
	  				this._tooltip._source = layer;
	  				this.openTooltip();
	  			}, this);
	  			on(el, 'blur', this.closeTooltip, this);
	  		}
	  	},
	
	  	_setAriaDescribedByOnLayer: function (layer) {
	  		var el = typeof layer.getElement === 'function' && layer.getElement();
	  		if (el) {
	  			el.setAttribute('aria-describedby', this._tooltip._container.id);
	  		}
	  	},
	
	
	  	_openTooltip: function (e) {
	  		if (!this._tooltip || !this._map) {
	  			return;
	  		}
	
	  		// If the map is moving, we will show the tooltip after it's done.
	  		if (this._map.dragging && this._map.dragging.moving() && !this._openOnceFlag) {
	  			this._openOnceFlag = true;
	  			var that = this;
	  			this._map.once('moveend', function () {
	  				that._openOnceFlag = false;
	  				that._openTooltip(e);
	  			});
	  			return;
	  		}
	
	  		this._tooltip._source = e.layer || e.target;
	
	  		this.openTooltip(this._tooltip.options.sticky ? e.latlng : undefined);
	  	},
	
	  	_moveTooltip: function (e) {
	  		var latlng = e.latlng, containerPoint, layerPoint;
	  		if (this._tooltip.options.sticky && e.originalEvent) {
	  			containerPoint = this._map.mouseEventToContainerPoint(e.originalEvent);
	  			layerPoint = this._map.containerPointToLayerPoint(containerPoint);
	  			latlng = this._map.layerPointToLatLng(layerPoint);
	  		}
	  		this._tooltip.setLatLng(latlng);
	  	}
	  });
	
	  /*
	   * @class DivIcon
	   * @aka L.DivIcon
	   * @inherits Icon
	   *
	   * Represents a lightweight icon for markers that uses a simple `<div>`
	   * element instead of an image. Inherits from `Icon` but ignores the `iconUrl` and shadow options.
	   *
	   * @example
	   * ```js
	   * var myIcon = L.divIcon({className: 'my-div-icon'});
	   * // you can set .my-div-icon styles in CSS
	   *
	   * L.marker([50.505, 30.57], {icon: myIcon}).addTo(map);
	   * ```
	   *
	   * By default, it has a 'leaflet-div-icon' CSS class and is styled as a little white square with a shadow.
	   */
	
	  var DivIcon = Icon.extend({
	  	options: {
	  		// @section
	  		// @aka DivIcon options
	  		iconSize: [12, 12], // also can be set through CSS
	
	  		// iconAnchor: (Point),
	  		// popupAnchor: (Point),
	
	  		// @option html: String|HTMLElement = ''
	  		// Custom HTML code to put inside the div element, empty by default. Alternatively,
	  		// an instance of `HTMLElement`.
	  		html: false,
	
	  		// @option bgPos: Point = [0, 0]
	  		// Optional relative position of the background, in pixels
	  		bgPos: null,
	
	  		className: 'leaflet-div-icon'
	  	},
	
	  	createIcon: function (oldIcon) {
	  		var div = (oldIcon && oldIcon.tagName === 'DIV') ? oldIcon : document.createElement('div'),
	  		    options = this.options;
	
	  		if (options.html instanceof Element) {
	  			empty(div);
	  			div.appendChild(options.html);
	  		} else {
	  			div.innerHTML = options.html !== false ? options.html : '';
	  		}
	
	  		if (options.bgPos) {
	  			var bgPos = toPoint(options.bgPos);
	  			div.style.backgroundPosition = (-bgPos.x) + 'px ' + (-bgPos.y) + 'px';
	  		}
	  		this._setIconStyles(div, 'icon');
	
	  		return div;
	  	},
	
	  	createShadow: function () {
	  		return null;
	  	}
	  });
	
	  // @factory L.divIcon(options: DivIcon options)
	  // Creates a `DivIcon` instance with the given options.
	  function divIcon(options) {
	  	return new DivIcon(options);
	  }
	
	  Icon.Default = IconDefault;
	
	  /*
	   * @class GridLayer
	   * @inherits Layer
	   * @aka L.GridLayer
	   *
	   * Generic class for handling a tiled grid of HTML elements. This is the base class for all tile layers and replaces `TileLayer.Canvas`.
	   * GridLayer can be extended to create a tiled grid of HTML elements like `<canvas>`, `<img>` or `<div>`. GridLayer will handle creating and animating these DOM elements for you.
	   *
	   *
	   * @section Synchronous usage
	   * @example
	   *
	   * To create a custom layer, extend GridLayer and implement the `createTile()` method, which will be passed a `Point` object with the `x`, `y`, and `z` (zoom level) coordinates to draw your tile.
	   *
	   * ```js
	   * var CanvasLayer = L.GridLayer.extend({
	   *     createTile: function(coords){
	   *         // create a <canvas> element for drawing
	   *         var tile = L.DomUtil.create('canvas', 'leaflet-tile');
	   *
	   *         // setup tile width and height according to the options
	   *         var size = this.getTileSize();
	   *         tile.width = size.x;
	   *         tile.height = size.y;
	   *
	   *         // get a canvas context and draw something on it using coords.x, coords.y and coords.z
	   *         var ctx = tile.getContext('2d');
	   *
	   *         // return the tile so it can be rendered on screen
	   *         return tile;
	   *     }
	   * });
	   * ```
	   *
	   * @section Asynchronous usage
	   * @example
	   *
	   * Tile creation can also be asynchronous, this is useful when using a third-party drawing library. Once the tile is finished drawing it can be passed to the `done()` callback.
	   *
	   * ```js
	   * var CanvasLayer = L.GridLayer.extend({
	   *     createTile: function(coords, done){
	   *         var error;
	   *
	   *         // create a <canvas> element for drawing
	   *         var tile = L.DomUtil.create('canvas', 'leaflet-tile');
	   *
	   *         // setup tile width and height according to the options
	   *         var size = this.getTileSize();
	   *         tile.width = size.x;
	   *         tile.height = size.y;
	   *
	   *         // draw something asynchronously and pass the tile to the done() callback
	   *         setTimeout(function() {
	   *             done(error, tile);
	   *         }, 1000);
	   *
	   *         return tile;
	   *     }
	   * });
	   * ```
	   *
	   * @section
	   */
	
	
	  var GridLayer = Layer.extend({
	
	  	// @section
	  	// @aka GridLayer options
	  	options: {
	  		// @option tileSize: Number|Point = 256
	  		// Width and height of tiles in the grid. Use a number if width and height are equal, or `L.point(width, height)` otherwise.
	  		tileSize: 256,
	
	  		// @option opacity: Number = 1.0
	  		// Opacity of the tiles. Can be used in the `createTile()` function.
	  		opacity: 1,
	
	  		// @option updateWhenIdle: Boolean = (depends)
	  		// Load new tiles only when panning ends.
	  		// `true` by default on mobile browsers, in order to avoid too many requests and keep smooth navigation.
	  		// `false` otherwise in order to display new tiles _during_ panning, since it is easy to pan outside the
	  		// [`keepBuffer`](#gridlayer-keepbuffer) option in desktop browsers.
	  		updateWhenIdle: Browser.mobile,
	
	  		// @option updateWhenZooming: Boolean = true
	  		// By default, a smooth zoom animation (during a [touch zoom](#map-touchzoom) or a [`flyTo()`](#map-flyto)) will update grid layers every integer zoom level. Setting this option to `false` will update the grid layer only when the smooth animation ends.
	  		updateWhenZooming: true,
	
	  		// @option updateInterval: Number = 200
	  		// Tiles will not update more than once every `updateInterval` milliseconds when panning.
	  		updateInterval: 200,
	
	  		// @option zIndex: Number = 1
	  		// The explicit zIndex of the tile layer.
	  		zIndex: 1,
	
	  		// @option bounds: LatLngBounds = undefined
	  		// If set, tiles will only be loaded inside the set `LatLngBounds`.
	  		bounds: null,
	
	  		// @option minZoom: Number = 0
	  		// The minimum zoom level down to which this layer will be displayed (inclusive).
	  		minZoom: 0,
	
	  		// @option maxZoom: Number = undefined
	  		// The maximum zoom level up to which this layer will be displayed (inclusive).
	  		maxZoom: undefined,
	
	  		// @option maxNativeZoom: Number = undefined
	  		// Maximum zoom number the tile source has available. If it is specified,
	  		// the tiles on all zoom levels higher than `maxNativeZoom` will be loaded
	  		// from `maxNativeZoom` level and auto-scaled.
	  		maxNativeZoom: undefined,
	
	  		// @option minNativeZoom: Number = undefined
	  		// Minimum zoom number the tile source has available. If it is specified,
	  		// the tiles on all zoom levels lower than `minNativeZoom` will be loaded
	  		// from `minNativeZoom` level and auto-scaled.
	  		minNativeZoom: undefined,
	
	  		// @option noWrap: Boolean = false
	  		// Whether the layer is wrapped around the antimeridian. If `true`, the
	  		// GridLayer will only be displayed once at low zoom levels. Has no
	  		// effect when the [map CRS](#map-crs) doesn't wrap around. Can be used
	  		// in combination with [`bounds`](#gridlayer-bounds) to prevent requesting
	  		// tiles outside the CRS limits.
	  		noWrap: false,
	
	  		// @option pane: String = 'tilePane'
	  		// `Map pane` where the grid layer will be added.
	  		pane: 'tilePane',
	
	  		// @option className: String = ''
	  		// A custom class name to assign to the tile layer. Empty by default.
	  		className: '',
	
	  		// @option keepBuffer: Number = 2
	  		// When panning the map, keep this many rows and columns of tiles before unloading them.
	  		keepBuffer: 2
	  	},
	
	  	initialize: function (options) {
	  		setOptions(this, options);
	  	},
	
	  	onAdd: function () {
	  		this._initContainer();
	
	  		this._levels = {};
	  		this._tiles = {};
	
	  		this._resetView(); // implicit _update() call
	  	},
	
	  	beforeAdd: function (map) {
	  		map._addZoomLimit(this);
	  	},
	
	  	onRemove: function (map) {
	  		this._removeAllTiles();
	  		remove(this._container);
	  		map._removeZoomLimit(this);
	  		this._container = null;
	  		this._tileZoom = undefined;
	  	},
	
	  	// @method bringToFront: this
	  	// Brings the tile layer to the top of all tile layers.
	  	bringToFront: function () {
	  		if (this._map) {
	  			toFront(this._container);
	  			this._setAutoZIndex(Math.max);
	  		}
	  		return this;
	  	},
	
	  	// @method bringToBack: this
	  	// Brings the tile layer to the bottom of all tile layers.
	  	bringToBack: function () {
	  		if (this._map) {
	  			toBack(this._container);
	  			this._setAutoZIndex(Math.min);
	  		}
	  		return this;
	  	},
	
	  	// @method getContainer: HTMLElement
	  	// Returns the HTML element that contains the tiles for this layer.
	  	getContainer: function () {
	  		return this._container;
	  	},
	
	  	// @method setOpacity(opacity: Number): this
	  	// Changes the [opacity](#gridlayer-opacity) of the grid layer.
	  	setOpacity: function (opacity) {
	  		this.options.opacity = opacity;
	  		this._updateOpacity();
	  		return this;
	  	},
	
	  	// @method setZIndex(zIndex: Number): this
	  	// Changes the [zIndex](#gridlayer-zindex) of the grid layer.
	  	setZIndex: function (zIndex) {
	  		this.options.zIndex = zIndex;
	  		this._updateZIndex();
	
	  		return this;
	  	},
	
	  	// @method isLoading: Boolean
	  	// Returns `true` if any tile in the grid layer has not finished loading.
	  	isLoading: function () {
	  		return this._loading;
	  	},
	
	  	// @method redraw: this
	  	// Causes the layer to clear all the tiles and request them again.
	  	redraw: function () {
	  		if (this._map) {
	  			this._removeAllTiles();
	  			var tileZoom = this._clampZoom(this._map.getZoom());
	  			if (tileZoom !== this._tileZoom) {
	  				this._tileZoom = tileZoom;
	  				this._updateLevels();
	  			}
	  			this._update();
	  		}
	  		return this;
	  	},
	
	  	getEvents: function () {
	  		var events = {
	  			viewprereset: this._invalidateAll,
	  			viewreset: this._resetView,
	  			zoom: this._resetView,
	  			moveend: this._onMoveEnd
	  		};
	
	  		if (!this.options.updateWhenIdle) {
	  			// update tiles on move, but not more often than once per given interval
	  			if (!this._onMove) {
	  				this._onMove = throttle(this._onMoveEnd, this.options.updateInterval, this);
	  			}
	
	  			events.move = this._onMove;
	  		}
	
	  		if (this._zoomAnimated) {
	  			events.zoomanim = this._animateZoom;
	  		}
	
	  		return events;
	  	},
	
	  	// @section Extension methods
	  	// Layers extending `GridLayer` shall reimplement the following method.
	  	// @method createTile(coords: Object, done?: Function): HTMLElement
	  	// Called only internally, must be overridden by classes extending `GridLayer`.
	  	// Returns the `HTMLElement` corresponding to the given `coords`. If the `done` callback
	  	// is specified, it must be called when the tile has finished loading and drawing.
	  	createTile: function () {
	  		return document.createElement('div');
	  	},
	
	  	// @section
	  	// @method getTileSize: Point
	  	// Normalizes the [tileSize option](#gridlayer-tilesize) into a point. Used by the `createTile()` method.
	  	getTileSize: function () {
	  		var s = this.options.tileSize;
	  		return s instanceof Point ? s : new Point(s, s);
	  	},
	
	  	_updateZIndex: function () {
	  		if (this._container && this.options.zIndex !== undefined && this.options.zIndex !== null) {
	  			this._container.style.zIndex = this.options.zIndex;
	  		}
	  	},
	
	  	_setAutoZIndex: function (compare) {
	  		// go through all other layers of the same pane, set zIndex to max + 1 (front) or min - 1 (back)
	
	  		var layers = this.getPane().children,
	  		    edgeZIndex = -compare(-Infinity, Infinity); // -Infinity for max, Infinity for min
	
	  		for (var i = 0, len = layers.length, zIndex; i < len; i++) {
	
	  			zIndex = layers[i].style.zIndex;
	
	  			if (layers[i] !== this._container && zIndex) {
	  				edgeZIndex = compare(edgeZIndex, +zIndex);
	  			}
	  		}
	
	  		if (isFinite(edgeZIndex)) {
	  			this.options.zIndex = edgeZIndex + compare(-1, 1);
	  			this._updateZIndex();
	  		}
	  	},
	
	  	_updateOpacity: function () {
	  		if (!this._map) { return; }
	
	  		// IE doesn't inherit filter opacity properly, so we're forced to set it on tiles
	  		if (Browser.ielt9) { return; }
	
	  		setOpacity(this._container, this.options.opacity);
	
	  		var now = +new Date(),
	  		    nextFrame = false,
	  		    willPrune = false;
	
	  		for (var key in this._tiles) {
	  			var tile = this._tiles[key];
	  			if (!tile.current || !tile.loaded) { continue; }
	
	  			var fade = Math.min(1, (now - tile.loaded) / 200);
	
	  			setOpacity(tile.el, fade);
	  			if (fade < 1) {
	  				nextFrame = true;
	  			} else {
	  				if (tile.active) {
	  					willPrune = true;
	  				} else {
	  					this._onOpaqueTile(tile);
	  				}
	  				tile.active = true;
	  			}
	  		}
	
	  		if (willPrune && !this._noPrune) { this._pruneTiles(); }
	
	  		if (nextFrame) {
	  			cancelAnimFrame(this._fadeFrame);
	  			this._fadeFrame = requestAnimFrame(this._updateOpacity, this);
	  		}
	  	},
	
	  	_onOpaqueTile: falseFn,
	
	  	_initContainer: function () {
	  		if (this._container) { return; }
	
	  		this._container = create$1('div', 'leaflet-layer ' + (this.options.className || ''));
	  		this._updateZIndex();
	
	  		if (this.options.opacity < 1) {
	  			this._updateOpacity();
	  		}
	
	  		this.getPane().appendChild(this._container);
	  	},
	
	  	_updateLevels: function () {
	
	  		var zoom = this._tileZoom,
	  		    maxZoom = this.options.maxZoom;
	
	  		if (zoom === undefined) { return undefined; }
	
	  		for (var z in this._levels) {
	  			z = Number(z);
	  			if (this._levels[z].el.children.length || z === zoom) {
	  				this._levels[z].el.style.zIndex = maxZoom - Math.abs(zoom - z);
	  				this._onUpdateLevel(z);
	  			} else {
	  				remove(this._levels[z].el);
	  				this._removeTilesAtZoom(z);
	  				this._onRemoveLevel(z);
	  				delete this._levels[z];
	  			}
	  		}
	
	  		var level = this._levels[zoom],
	  		    map = this._map;
	
	  		if (!level) {
	  			level = this._levels[zoom] = {};
	
	  			level.el = create$1('div', 'leaflet-tile-container leaflet-zoom-animated', this._container);
	  			level.el.style.zIndex = maxZoom;
	
	  			level.origin = map.project(map.unproject(map.getPixelOrigin()), zoom).round();
	  			level.zoom = zoom;
	
	  			this._setZoomTransform(level, map.getCenter(), map.getZoom());
	
	  			// force the browser to consider the newly added element for transition
	  			falseFn(level.el.offsetWidth);
	
	  			this._onCreateLevel(level);
	  		}
	
	  		this._level = level;
	
	  		return level;
	  	},
	
	  	_onUpdateLevel: falseFn,
	
	  	_onRemoveLevel: falseFn,
	
	  	_onCreateLevel: falseFn,
	
	  	_pruneTiles: function () {
	  		if (!this._map) {
	  			return;
	  		}
	
	  		var key, tile;
	
	  		var zoom = this._map.getZoom();
	  		if (zoom > this.options.maxZoom ||
	  			zoom < this.options.minZoom) {
	  			this._removeAllTiles();
	  			return;
	  		}
	
	  		for (key in this._tiles) {
	  			tile = this._tiles[key];
	  			tile.retain = tile.current;
	  		}
	
	  		for (key in this._tiles) {
	  			tile = this._tiles[key];
	  			if (tile.current && !tile.active) {
	  				var coords = tile.coords;
	  				if (!this._retainParent(coords.x, coords.y, coords.z, coords.z - 5)) {
	  					this._retainChildren(coords.x, coords.y, coords.z, coords.z + 2);
	  				}
	  			}
	  		}
	
	  		for (key in this._tiles) {
	  			if (!this._tiles[key].retain) {
	  				this._removeTile(key);
	  			}
	  		}
	  	},
	
	  	_removeTilesAtZoom: function (zoom) {
	  		for (var key in this._tiles) {
	  			if (this._tiles[key].coords.z !== zoom) {
	  				continue;
	  			}
	  			this._removeTile(key);
	  		}
	  	},
	
	  	_removeAllTiles: function () {
	  		for (var key in this._tiles) {
	  			this._removeTile(key);
	  		}
	  	},
	
	  	_invalidateAll: function () {
	  		for (var z in this._levels) {
	  			remove(this._levels[z].el);
	  			this._onRemoveLevel(Number(z));
	  			delete this._levels[z];
	  		}
	  		this._removeAllTiles();
	
	  		this._tileZoom = undefined;
	  	},
	
	  	_retainParent: function (x, y, z, minZoom) {
	  		var x2 = Math.floor(x / 2),
	  		    y2 = Math.floor(y / 2),
	  		    z2 = z - 1,
	  		    coords2 = new Point(+x2, +y2);
	  		coords2.z = +z2;
	
	  		var key = this._tileCoordsToKey(coords2),
	  		    tile = this._tiles[key];
	
	  		if (tile && tile.active) {
	  			tile.retain = true;
	  			return true;
	
	  		} else if (tile && tile.loaded) {
	  			tile.retain = true;
	  		}
	
	  		if (z2 > minZoom) {
	  			return this._retainParent(x2, y2, z2, minZoom);
	  		}
	
	  		return false;
	  	},
	
	  	_retainChildren: function (x, y, z, maxZoom) {
	
	  		for (var i = 2 * x; i < 2 * x + 2; i++) {
	  			for (var j = 2 * y; j < 2 * y + 2; j++) {
	
	  				var coords = new Point(i, j);
	  				coords.z = z + 1;
	
	  				var key = this._tileCoordsToKey(coords),
	  				    tile = this._tiles[key];
	
	  				if (tile && tile.active) {
	  					tile.retain = true;
	  					continue;
	
	  				} else if (tile && tile.loaded) {
	  					tile.retain = true;
	  				}
	
	  				if (z + 1 < maxZoom) {
	  					this._retainChildren(i, j, z + 1, maxZoom);
	  				}
	  			}
	  		}
	  	},
	
	  	_resetView: function (e) {
	  		var animating = e && (e.pinch || e.flyTo);
	  		this._setView(this._map.getCenter(), this._map.getZoom(), animating, animating);
	  	},
	
	  	_animateZoom: function (e) {
	  		this._setView(e.center, e.zoom, true, e.noUpdate);
	  	},
	
	  	_clampZoom: function (zoom) {
	  		var options = this.options;
	
	  		if (undefined !== options.minNativeZoom && zoom < options.minNativeZoom) {
	  			return options.minNativeZoom;
	  		}
	
	  		if (undefined !== options.maxNativeZoom && options.maxNativeZoom < zoom) {
	  			return options.maxNativeZoom;
	  		}
	
	  		return zoom;
	  	},
	
	  	_setView: function (center, zoom, noPrune, noUpdate) {
	  		var tileZoom = Math.round(zoom);
	  		if ((this.options.maxZoom !== undefined && tileZoom > this.options.maxZoom) ||
	  		    (this.options.minZoom !== undefined && tileZoom < this.options.minZoom)) {
	  			tileZoom = undefined;
	  		} else {
	  			tileZoom = this._clampZoom(tileZoom);
	  		}
	
	  		var tileZoomChanged = this.options.updateWhenZooming && (tileZoom !== this._tileZoom);
	
	  		if (!noUpdate || tileZoomChanged) {
	
	  			this._tileZoom = tileZoom;
	
	  			if (this._abortLoading) {
	  				this._abortLoading();
	  			}
	
	  			this._updateLevels();
	  			this._resetGrid();
	
	  			if (tileZoom !== undefined) {
	  				this._update(center);
	  			}
	
	  			if (!noPrune) {
	  				this._pruneTiles();
	  			}
	
	  			// Flag to prevent _updateOpacity from pruning tiles during
	  			// a zoom anim or a pinch gesture
	  			this._noPrune = !!noPrune;
	  		}
	
	  		this._setZoomTransforms(center, zoom);
	  	},
	
	  	_setZoomTransforms: function (center, zoom) {
	  		for (var i in this._levels) {
	  			this._setZoomTransform(this._levels[i], center, zoom);
	  		}
	  	},
	
	  	_setZoomTransform: function (level, center, zoom) {
	  		var scale = this._map.getZoomScale(zoom, level.zoom),
	  		    translate = level.origin.multiplyBy(scale)
	  		        .subtract(this._map._getNewPixelOrigin(center, zoom)).round();
	
	  		if (Browser.any3d) {
	  			setTransform(level.el, translate, scale);
	  		} else {
	  			setPosition(level.el, translate);
	  		}
	  	},
	
	  	_resetGrid: function () {
	  		var map = this._map,
	  		    crs = map.options.crs,
	  		    tileSize = this._tileSize = this.getTileSize(),
	  		    tileZoom = this._tileZoom;
	
	  		var bounds = this._map.getPixelWorldBounds(this._tileZoom);
	  		if (bounds) {
	  			this._globalTileRange = this._pxBoundsToTileRange(bounds);
	  		}
	
	  		this._wrapX = crs.wrapLng && !this.options.noWrap && [
	  			Math.floor(map.project([0, crs.wrapLng[0]], tileZoom).x / tileSize.x),
	  			Math.ceil(map.project([0, crs.wrapLng[1]], tileZoom).x / tileSize.y)
	  		];
	  		this._wrapY = crs.wrapLat && !this.options.noWrap && [
	  			Math.floor(map.project([crs.wrapLat[0], 0], tileZoom).y / tileSize.x),
	  			Math.ceil(map.project([crs.wrapLat[1], 0], tileZoom).y / tileSize.y)
	  		];
	  	},
	
	  	_onMoveEnd: function () {
	  		if (!this._map || this._map._animatingZoom) { return; }
	
	  		this._update();
	  	},
	
	  	_getTiledPixelBounds: function (center) {
	  		var map = this._map,
	  		    mapZoom = map._animatingZoom ? Math.max(map._animateToZoom, map.getZoom()) : map.getZoom(),
	  		    scale = map.getZoomScale(mapZoom, this._tileZoom),
	  		    pixelCenter = map.project(center, this._tileZoom).floor(),
	  		    halfSize = map.getSize().divideBy(scale * 2);
	
	  		return new Bounds(pixelCenter.subtract(halfSize), pixelCenter.add(halfSize));
	  	},
	
	  	// Private method to load tiles in the grid's active zoom level according to map bounds
	  	_update: function (center) {
	  		var map = this._map;
	  		if (!map) { return; }
	  		var zoom = this._clampZoom(map.getZoom());
	
	  		if (center === undefined) { center = map.getCenter(); }
	  		if (this._tileZoom === undefined) { return; }	// if out of minzoom/maxzoom
	
	  		var pixelBounds = this._getTiledPixelBounds(center),
	  		    tileRange = this._pxBoundsToTileRange(pixelBounds),
	  		    tileCenter = tileRange.getCenter(),
	  		    queue = [],
	  		    margin = this.options.keepBuffer,
	  		    noPruneRange = new Bounds(tileRange.getBottomLeft().subtract([margin, -margin]),
	  		                              tileRange.getTopRight().add([margin, -margin]));
	
	  		// Sanity check: panic if the tile range contains Infinity somewhere.
	  		if (!(isFinite(tileRange.min.x) &&
	  		      isFinite(tileRange.min.y) &&
	  		      isFinite(tileRange.max.x) &&
	  		      isFinite(tileRange.max.y))) { throw new Error('Attempted to load an infinite number of tiles'); }
	
	  		for (var key in this._tiles) {
	  			var c = this._tiles[key].coords;
	  			if (c.z !== this._tileZoom || !noPruneRange.contains(new Point(c.x, c.y))) {
	  				this._tiles[key].current = false;
	  			}
	  		}
	
	  		// _update just loads more tiles. If the tile zoom level differs too much
	  		// from the map's, let _setView reset levels and prune old tiles.
	  		if (Math.abs(zoom - this._tileZoom) > 1) { this._setView(center, zoom); return; }
	
	  		// create a queue of coordinates to load tiles from
	  		for (var j = tileRange.min.y; j <= tileRange.max.y; j++) {
	  			for (var i = tileRange.min.x; i <= tileRange.max.x; i++) {
	  				var coords = new Point(i, j);
	  				coords.z = this._tileZoom;
	
	  				if (!this._isValidTile(coords)) { continue; }
	
	  				var tile = this._tiles[this._tileCoordsToKey(coords)];
	  				if (tile) {
	  					tile.current = true;
	  				} else {
	  					queue.push(coords);
	  				}
	  			}
	  		}
	
	  		// sort tile queue to load tiles in order of their distance to center
	  		queue.sort(function (a, b) {
	  			return a.distanceTo(tileCenter) - b.distanceTo(tileCenter);
	  		});
	
	  		if (queue.length !== 0) {
	  			// if it's the first batch of tiles to load
	  			if (!this._loading) {
	  				this._loading = true;
	  				// @event loading: Event
	  				// Fired when the grid layer starts loading tiles.
	  				this.fire('loading');
	  			}
	
	  			// create DOM fragment to append tiles in one batch
	  			var fragment = document.createDocumentFragment();
	
	  			for (i = 0; i < queue.length; i++) {
	  				this._addTile(queue[i], fragment);
	  			}
	
	  			this._level.el.appendChild(fragment);
	  		}
	  	},
	
	  	_isValidTile: function (coords) {
	  		var crs = this._map.options.crs;
	
	  		if (!crs.infinite) {
	  			// don't load tile if it's out of bounds and not wrapped
	  			var bounds = this._globalTileRange;
	  			if ((!crs.wrapLng && (coords.x < bounds.min.x || coords.x > bounds.max.x)) ||
	  			    (!crs.wrapLat && (coords.y < bounds.min.y || coords.y > bounds.max.y))) { return false; }
	  		}
	
	  		if (!this.options.bounds) { return true; }
	
	  		// don't load tile if it doesn't intersect the bounds in options
	  		var tileBounds = this._tileCoordsToBounds(coords);
	  		return toLatLngBounds(this.options.bounds).overlaps(tileBounds);
	  	},
	
	  	_keyToBounds: function (key) {
	  		return this._tileCoordsToBounds(this._keyToTileCoords(key));
	  	},
	
	  	_tileCoordsToNwSe: function (coords) {
	  		var map = this._map,
	  		    tileSize = this.getTileSize(),
	  		    nwPoint = coords.scaleBy(tileSize),
	  		    sePoint = nwPoint.add(tileSize),
	  		    nw = map.unproject(nwPoint, coords.z),
	  		    se = map.unproject(sePoint, coords.z);
	  		return [nw, se];
	  	},
	
	  	// converts tile coordinates to its geographical bounds
	  	_tileCoordsToBounds: function (coords) {
	  		var bp = this._tileCoordsToNwSe(coords),
	  		    bounds = new LatLngBounds(bp[0], bp[1]);
	
	  		if (!this.options.noWrap) {
	  			bounds = this._map.wrapLatLngBounds(bounds);
	  		}
	  		return bounds;
	  	},
	  	// converts tile coordinates to key for the tile cache
	  	_tileCoordsToKey: function (coords) {
	  		return coords.x + ':' + coords.y + ':' + coords.z;
	  	},
	
	  	// converts tile cache key to coordinates
	  	_keyToTileCoords: function (key) {
	  		var k = key.split(':'),
	  		    coords = new Point(+k[0], +k[1]);
	  		coords.z = +k[2];
	  		return coords;
	  	},
	
	  	_removeTile: function (key) {
	  		var tile = this._tiles[key];
	  		if (!tile) { return; }
	
	  		remove(tile.el);
	
	  		delete this._tiles[key];
	
	  		// @event tileunload: TileEvent
	  		// Fired when a tile is removed (e.g. when a tile goes off the screen).
	  		this.fire('tileunload', {
	  			tile: tile.el,
	  			coords: this._keyToTileCoords(key)
	  		});
	  	},
	
	  	_initTile: function (tile) {
	  		addClass(tile, 'leaflet-tile');
	
	  		var tileSize = this.getTileSize();
	  		tile.style.width = tileSize.x + 'px';
	  		tile.style.height = tileSize.y + 'px';
	
	  		tile.onselectstart = falseFn;
	  		tile.onmousemove = falseFn;
	
	  		// update opacity on tiles in IE7-8 because of filter inheritance problems
	  		if (Browser.ielt9 && this.options.opacity < 1) {
	  			setOpacity(tile, this.options.opacity);
	  		}
	  	},
	
	  	_addTile: function (coords, container) {
	  		var tilePos = this._getTilePos(coords),
	  		    key = this._tileCoordsToKey(coords);
	
	  		var tile = this.createTile(this._wrapCoords(coords), bind(this._tileReady, this, coords));
	
	  		this._initTile(tile);
	
	  		// if createTile is defined with a second argument ("done" callback),
	  		// we know that tile is async and will be ready later; otherwise
	  		if (this.createTile.length < 2) {
	  			// mark tile as ready, but delay one frame for opacity animation to happen
	  			requestAnimFrame(bind(this._tileReady, this, coords, null, tile));
	  		}
	
	  		setPosition(tile, tilePos);
	
	  		// save tile in cache
	  		this._tiles[key] = {
	  			el: tile,
	  			coords: coords,
	  			current: true
	  		};
	
	  		container.appendChild(tile);
	  		// @event tileloadstart: TileEvent
	  		// Fired when a tile is requested and starts loading.
	  		this.fire('tileloadstart', {
	  			tile: tile,
	  			coords: coords
	  		});
	  	},
	
	  	_tileReady: function (coords, err, tile) {
	  		if (err) {
	  			// @event tileerror: TileErrorEvent
	  			// Fired when there is an error loading a tile.
	  			this.fire('tileerror', {
	  				error: err,
	  				tile: tile,
	  				coords: coords
	  			});
	  		}
	
	  		var key = this._tileCoordsToKey(coords);
	
	  		tile = this._tiles[key];
	  		if (!tile) { return; }
	
	  		tile.loaded = +new Date();
	  		if (this._map._fadeAnimated) {
	  			setOpacity(tile.el, 0);
	  			cancelAnimFrame(this._fadeFrame);
	  			this._fadeFrame = requestAnimFrame(this._updateOpacity, this);
	  		} else {
	  			tile.active = true;
	  			this._pruneTiles();
	  		}
	
	  		if (!err) {
	  			addClass(tile.el, 'leaflet-tile-loaded');
	
	  			// @event tileload: TileEvent
	  			// Fired when a tile loads.
	  			this.fire('tileload', {
	  				tile: tile.el,
	  				coords: coords
	  			});
	  		}
	
	  		if (this._noTilesToLoad()) {
	  			this._loading = false;
	  			// @event load: Event
	  			// Fired when the grid layer loaded all visible tiles.
	  			this.fire('load');
	
	  			if (Browser.ielt9 || !this._map._fadeAnimated) {
	  				requestAnimFrame(this._pruneTiles, this);
	  			} else {
	  				// Wait a bit more than 0.2 secs (the duration of the tile fade-in)
	  				// to trigger a pruning.
	  				setTimeout(bind(this._pruneTiles, this), 250);
	  			}
	  		}
	  	},
	
	  	_getTilePos: function (coords) {
	  		return coords.scaleBy(this.getTileSize()).subtract(this._level.origin);
	  	},
	
	  	_wrapCoords: function (coords) {
	  		var newCoords = new Point(
	  			this._wrapX ? wrapNum(coords.x, this._wrapX) : coords.x,
	  			this._wrapY ? wrapNum(coords.y, this._wrapY) : coords.y);
	  		newCoords.z = coords.z;
	  		return newCoords;
	  	},
	
	  	_pxBoundsToTileRange: function (bounds) {
	  		var tileSize = this.getTileSize();
	  		return new Bounds(
	  			bounds.min.unscaleBy(tileSize).floor(),
	  			bounds.max.unscaleBy(tileSize).ceil().subtract([1, 1]));
	  	},
	
	  	_noTilesToLoad: function () {
	  		for (var key in this._tiles) {
	  			if (!this._tiles[key].loaded) { return false; }
	  		}
	  		return true;
	  	}
	  });
	
	  // @factory L.gridLayer(options?: GridLayer options)
	  // Creates a new instance of GridLayer with the supplied options.
	  function gridLayer(options) {
	  	return new GridLayer(options);
	  }
	
	  /*
	   * @class TileLayer
	   * @inherits GridLayer
	   * @aka L.TileLayer
	   * Used to load and display tile layers on the map. Note that most tile servers require attribution, which you can set under `Layer`. Extends `GridLayer`.
	   *
	   * @example
	   *
	   * ```js
	   * L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png?{foo}', {foo: 'bar', attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'}).addTo(map);
	   * ```
	   *
	   * @section URL template
	   * @example
	   *
	   * A string of the following form:
	   *
	   * ```
	   * 'https://{s}.somedomain.com/blabla/{z}/{x}/{y}{r}.png'
	   * ```
	   *
	   * `{s}` means one of the available subdomains (used sequentially to help with browser parallel requests per domain limitation; subdomain values are specified in options; `a`, `b` or `c` by default, can be omitted), `{z}` — zoom level, `{x}` and `{y}` — tile coordinates. `{r}` can be used to add "&commat;2x" to the URL to load retina tiles.
	   *
	   * You can use custom keys in the template, which will be [evaluated](#util-template) from TileLayer options, like this:
	   *
	   * ```
	   * L.tileLayer('https://{s}.somedomain.com/{foo}/{z}/{x}/{y}.png', {foo: 'bar'});
	   * ```
	   */
	
	
	  var TileLayer = GridLayer.extend({
	
	  	// @section
	  	// @aka TileLayer options
	  	options: {
	  		// @option minZoom: Number = 0
	  		// The minimum zoom level down to which this layer will be displayed (inclusive).
	  		minZoom: 0,
	
	  		// @option maxZoom: Number = 18
	  		// The maximum zoom level up to which this layer will be displayed (inclusive).
	  		maxZoom: 18,
	
	  		// @option subdomains: String|String[] = 'abc'
	  		// Subdomains of the tile service. Can be passed in the form of one string (where each letter is a subdomain name) or an array of strings.
	  		subdomains: 'abc',
	
	  		// @option errorTileUrl: String = ''
	  		// URL to the tile image to show in place of the tile that failed to load.
	  		errorTileUrl: '',
	
	  		// @option zoomOffset: Number = 0
	  		// The zoom number used in tile URLs will be offset with this value.
	  		zoomOffset: 0,
	
	  		// @option tms: Boolean = false
	  		// If `true`, inverses Y axis numbering for tiles (turn this on for [TMS](https://en.wikipedia.org/wiki/Tile_Map_Service) services).
	  		tms: false,
	
	  		// @option zoomReverse: Boolean = false
	  		// If set to true, the zoom number used in tile URLs will be reversed (`maxZoom - zoom` instead of `zoom`)
	  		zoomReverse: false,
	
	  		// @option detectRetina: Boolean = false
	  		// If `true` and user is on a retina display, it will request four tiles of half the specified size and a bigger zoom level in place of one to utilize the high resolution.
	  		detectRetina: false,
	
	  		// @option crossOrigin: Boolean|String = false
	  		// Whether the crossOrigin attribute will be added to the tiles.
	  		// If a String is provided, all tiles will have their crossOrigin attribute set to the String provided. This is needed if you want to access tile pixel data.
	  		// Refer to [CORS Settings](https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_settings_attributes) for valid String values.
	  		crossOrigin: false,
	
	  		// @option referrerPolicy: Boolean|String = false
	  		// Whether the referrerPolicy attribute will be added to the tiles.
	  		// If a String is provided, all tiles will have their referrerPolicy attribute set to the String provided.
	  		// This may be needed if your map's rendering context has a strict default but your tile provider expects a valid referrer
	  		// (e.g. to validate an API token).
	  		// Refer to [HTMLImageElement.referrerPolicy](https://developer.mozilla.org/en-US/docs/Web/API/HTMLImageElement/referrerPolicy) for valid String values.
	  		referrerPolicy: false
	  	},
	
	  	initialize: function (url, options) {
	
	  		this._url = url;
	
	  		options = setOptions(this, options);
	
	  		// detecting retina displays, adjusting tileSize and zoom levels
	  		if (options.detectRetina && Browser.retina && options.maxZoom > 0) {
	
	  			options.tileSize = Math.floor(options.tileSize / 2);
	
	  			if (!options.zoomReverse) {
	  				options.zoomOffset++;
	  				options.maxZoom = Math.max(options.minZoom, options.maxZoom - 1);
	  			} else {
	  				options.zoomOffset--;
	  				options.minZoom = Math.min(options.maxZoom, options.minZoom + 1);
	  			}
	
	  			options.minZoom = Math.max(0, options.minZoom);
	  		} else if (!options.zoomReverse) {
	  			// make sure maxZoom is gte minZoom
	  			options.maxZoom = Math.max(options.minZoom, options.maxZoom);
	  		} else {
	  			// make sure minZoom is lte maxZoom
	  			options.minZoom = Math.min(options.maxZoom, options.minZoom);
	  		}
	
	  		if (typeof options.subdomains === 'string') {
	  			options.subdomains = options.subdomains.split('');
	  		}
	
	  		this.on('tileunload', this._onTileRemove);
	  	},
	
	  	// @method setUrl(url: String, noRedraw?: Boolean): this
	  	// Updates the layer's URL template and redraws it (unless `noRedraw` is set to `true`).
	  	// If the URL does not change, the layer will not be redrawn unless
	  	// the noRedraw parameter is set to false.
	  	setUrl: function (url, noRedraw) {
	  		if (this._url === url && noRedraw === undefined) {
	  			noRedraw = true;
	  		}
	
	  		this._url = url;
	
	  		if (!noRedraw) {
	  			this.redraw();
	  		}
	  		return this;
	  	},
	
	  	// @method createTile(coords: Object, done?: Function): HTMLElement
	  	// Called only internally, overrides GridLayer's [`createTile()`](#gridlayer-createtile)
	  	// to return an `<img>` HTML element with the appropriate image URL given `coords`. The `done`
	  	// callback is called when the tile has been loaded.
	  	createTile: function (coords, done) {
	  		var tile = document.createElement('img');
	
	  		on(tile, 'load', bind(this._tileOnLoad, this, done, tile));
	  		on(tile, 'error', bind(this._tileOnError, this, done, tile));
	
	  		if (this.options.crossOrigin || this.options.crossOrigin === '') {
	  			tile.crossOrigin = this.options.crossOrigin === true ? '' : this.options.crossOrigin;
	  		}
	
	  		// for this new option we follow the documented behavior
	  		// more closely by only setting the property when string
	  		if (typeof this.options.referrerPolicy === 'string') {
	  			tile.referrerPolicy = this.options.referrerPolicy;
	  		}
	
	  		// The alt attribute is set to the empty string,
	  		// allowing screen readers to ignore the decorative image tiles.
	  		// https://www.w3.org/WAI/tutorials/images/decorative/
	  		// https://www.w3.org/TR/html-aria/#el-img-empty-alt
	  		tile.alt = '';
	
	  		tile.src = this.getTileUrl(coords);
	
	  		return tile;
	  	},
	
	  	// @section Extension methods
	  	// @uninheritable
	  	// Layers extending `TileLayer` might reimplement the following method.
	  	// @method getTileUrl(coords: Object): String
	  	// Called only internally, returns the URL for a tile given its coordinates.
	  	// Classes extending `TileLayer` can override this function to provide custom tile URL naming schemes.
	  	getTileUrl: function (coords) {
	  		var data = {
	  			r: Browser.retina ? '@2x' : '',
	  			s: this._getSubdomain(coords),
	  			x: coords.x,
	  			y: coords.y,
	  			z: this._getZoomForUrl()
	  		};
	  		if (this._map && !this._map.options.crs.infinite) {
	  			var invertedY = this._globalTileRange.max.y - coords.y;
	  			if (this.options.tms) {
	  				data['y'] = invertedY;
	  			}
	  			data['-y'] = invertedY;
	  		}
	
	  		return template(this._url, extend(data, this.options));
	  	},
	
	  	_tileOnLoad: function (done, tile) {
	  		// For https://github.com/Leaflet/Leaflet/issues/3332
	  		if (Browser.ielt9) {
	  			setTimeout(bind(done, this, null, tile), 0);
	  		} else {
	  			done(null, tile);
	  		}
	  	},
	
	  	_tileOnError: function (done, tile, e) {
	  		var errorUrl = this.options.errorTileUrl;
	  		if (errorUrl && tile.getAttribute('src') !== errorUrl) {
	  			tile.src = errorUrl;
	  		}
	  		done(e, tile);
	  	},
	
	  	_onTileRemove: function (e) {
	  		e.tile.onload = null;
	  	},
	
	  	_getZoomForUrl: function () {
	  		var zoom = this._tileZoom,
	  		maxZoom = this.options.maxZoom,
	  		zoomReverse = this.options.zoomReverse,
	  		zoomOffset = this.options.zoomOffset;
	
	  		if (zoomReverse) {
	  			zoom = maxZoom - zoom;
	  		}
	
	  		return zoom + zoomOffset;
	  	},
	
	  	_getSubdomain: function (tilePoint) {
	  		var index = Math.abs(tilePoint.x + tilePoint.y) % this.options.subdomains.length;
	  		return this.options.subdomains[index];
	  	},
	
	  	// stops loading all tiles in the background layer
	  	_abortLoading: function () {
	  		var i, tile;
	  		for (i in this._tiles) {
	  			if (this._tiles[i].coords.z !== this._tileZoom) {
	  				tile = this._tiles[i].el;
	
	  				tile.onload = falseFn;
	  				tile.onerror = falseFn;
	
	  				if (!tile.complete) {
	  					tile.src = emptyImageUrl;
	  					var coords = this._tiles[i].coords;
	  					remove(tile);
	  					delete this._tiles[i];
	  					// @event tileabort: TileEvent
	  					// Fired when a tile was loading but is now not wanted.
	  					this.fire('tileabort', {
	  						tile: tile,
	  						coords: coords
	  					});
	  				}
	  			}
	  		}
	  	},
	
	  	_removeTile: function (key) {
	  		var tile = this._tiles[key];
	  		if (!tile) { return; }
	
	  		// Cancels any pending http requests associated with the tile
	  		tile.el.setAttribute('src', emptyImageUrl);
	
	  		return GridLayer.prototype._removeTile.call(this, key);
	  	},
	
	  	_tileReady: function (coords, err, tile) {
	  		if (!this._map || (tile && tile.getAttribute('src') === emptyImageUrl)) {
	  			return;
	  		}
	
	  		return GridLayer.prototype._tileReady.call(this, coords, err, tile);
	  	}
	  });
	
	
	  // @factory L.tilelayer(urlTemplate: String, options?: TileLayer options)
	  // Instantiates a tile layer object given a `URL template` and optionally an options object.
	
	  function tileLayer(url, options) {
	  	return new TileLayer(url, options);
	  }
	
	  /*
	   * @class TileLayer.WMS
	   * @inherits TileLayer
	   * @aka L.TileLayer.WMS
	   * Used to display [WMS](https://en.wikipedia.org/wiki/Web_Map_Service) services as tile layers on the map. Extends `TileLayer`.
	   *
	   * @example
	   *
	   * ```js
	   * var nexrad = L.tileLayer.wms("http://mesonet.agron.iastate.edu/cgi-bin/wms/nexrad/n0r.cgi", {
	   * 	layers: 'nexrad-n0r-900913',
	   * 	format: 'image/png',
	   * 	transparent: true,
	   * 	attribution: "Weather data © 2012 IEM Nexrad"
	   * });
	   * ```
	   */
	
	  var TileLayerWMS = TileLayer.extend({
	
	  	// @section
	  	// @aka TileLayer.WMS options
	  	// If any custom options not documented here are used, they will be sent to the
	  	// WMS server as extra parameters in each request URL. This can be useful for
	  	// [non-standard vendor WMS parameters](https://docs.geoserver.org/stable/en/user/services/wms/vendor.html).
	  	defaultWmsParams: {
	  		service: 'WMS',
	  		request: 'GetMap',
	
	  		// @option layers: String = ''
	  		// **(required)** Comma-separated list of WMS layers to show.
	  		layers: '',
	
	  		// @option styles: String = ''
	  		// Comma-separated list of WMS styles.
	  		styles: '',
	
	  		// @option format: String = 'image/jpeg'
	  		// WMS image format (use `'image/png'` for layers with transparency).
	  		format: 'image/jpeg',
	
	  		// @option transparent: Boolean = false
	  		// If `true`, the WMS service will return images with transparency.
	  		transparent: false,
	
	  		// @option version: String = '1.1.1'
	  		// Version of the WMS service to use
	  		version: '1.1.1'
	  	},
	
	  	options: {
	  		// @option crs: CRS = null
	  		// Coordinate Reference System to use for the WMS requests, defaults to
	  		// map CRS. Don't change this if you're not sure what it means.
	  		crs: null,
	
	  		// @option uppercase: Boolean = false
	  		// If `true`, WMS request parameter keys will be uppercase.
	  		uppercase: false
	  	},
	
	  	initialize: function (url, options) {
	
	  		this._url = url;
	
	  		var wmsParams = extend({}, this.defaultWmsParams);
	
	  		// all keys that are not TileLayer options go to WMS params
	  		for (var i in options) {
	  			if (!(i in this.options)) {
	  				wmsParams[i] = options[i];
	  			}
	  		}
	
	  		options = setOptions(this, options);
	
	  		var realRetina = options.detectRetina && Browser.retina ? 2 : 1;
	  		var tileSize = this.getTileSize();
	  		wmsParams.width = tileSize.x * realRetina;
	  		wmsParams.height = tileSize.y * realRetina;
	
	  		this.wmsParams = wmsParams;
	  	},
	
	  	onAdd: function (map) {
	
	  		this._crs = this.options.crs || map.options.crs;
	  		this._wmsVersion = parseFloat(this.wmsParams.version);
	
	  		var projectionKey = this._wmsVersion >= 1.3 ? 'crs' : 'srs';
	  		this.wmsParams[projectionKey] = this._crs.code;
	
	  		TileLayer.prototype.onAdd.call(this, map);
	  	},
	
	  	getTileUrl: function (coords) {
	
	  		var tileBounds = this._tileCoordsToNwSe(coords),
	  		    crs = this._crs,
	  		    bounds = toBounds(crs.project(tileBounds[0]), crs.project(tileBounds[1])),
	  		    min = bounds.min,
	  		    max = bounds.max,
	  		    bbox = (this._wmsVersion >= 1.3 && this._crs === EPSG4326 ?
	  		    [min.y, min.x, max.y, max.x] :
	  		    [min.x, min.y, max.x, max.y]).join(','),
	  		    url = TileLayer.prototype.getTileUrl.call(this, coords);
	  		return url +
	  			getParamString(this.wmsParams, url, this.options.uppercase) +
	  			(this.options.uppercase ? '&BBOX=' : '&bbox=') + bbox;
	  	},
	
	  	// @method setParams(params: Object, noRedraw?: Boolean): this
	  	// Merges an object with the new parameters and re-requests tiles on the current screen (unless `noRedraw` was set to true).
	  	setParams: function (params, noRedraw) {
	
	  		extend(this.wmsParams, params);
	
	  		if (!noRedraw) {
	  			this.redraw();
	  		}
	
	  		return this;
	  	}
	  });
	
	
	  // @factory L.tileLayer.wms(baseUrl: String, options: TileLayer.WMS options)
	  // Instantiates a WMS tile layer object given a base URL of the WMS service and a WMS parameters/options object.
	  function tileLayerWMS(url, options) {
	  	return new TileLayerWMS(url, options);
	  }
	
	  TileLayer.WMS = TileLayerWMS;
	  tileLayer.wms = tileLayerWMS;
	
	  /*
	   * @class Renderer
	   * @inherits Layer
	   * @aka L.Renderer
	   *
	   * Base class for vector renderer implementations (`SVG`, `Canvas`). Handles the
	   * DOM container of the renderer, its bounds, and its zoom animation.
	   *
	   * A `Renderer` works as an implicit layer group for all `Path`s - the renderer
	   * itself can be added or removed to the map. All paths use a renderer, which can
	   * be implicit (the map will decide the type of renderer and use it automatically)
	   * or explicit (using the [`renderer`](#path-renderer) option of the path).
	   *
	   * Do not use this class directly, use `SVG` and `Canvas` instead.
	   *
	   * @event update: Event
	   * Fired when the renderer updates its bounds, center and zoom, for example when
	   * its map has moved
	   */
	
	  var Renderer = Layer.extend({
	
	  	// @section
	  	// @aka Renderer options
	  	options: {
	  		// @option padding: Number = 0.1
	  		// How much to extend the clip area around the map view (relative to its size)
	  		// e.g. 0.1 would be 10% of map view in each direction
	  		padding: 0.1
	  	},
	
	  	initialize: function (options) {
	  		setOptions(this, options);
	  		stamp(this);
	  		this._layers = this._layers || {};
	  	},
	
	  	onAdd: function () {
	  		if (!this._container) {
	  			this._initContainer(); // defined by renderer implementations
	
	  			// always keep transform-origin as 0 0
	  			addClass(this._container, 'leaflet-zoom-animated');
	  		}
	
	  		this.getPane().appendChild(this._container);
	  		this._update();
	  		this.on('update', this._updatePaths, this);
	  	},
	
	  	onRemove: function () {
	  		this.off('update', this._updatePaths, this);
	  		this._destroyContainer();
	  	},
	
	  	getEvents: function () {
	  		var events = {
	  			viewreset: this._reset,
	  			zoom: this._onZoom,
	  			moveend: this._update,
	  			zoomend: this._onZoomEnd
	  		};
	  		if (this._zoomAnimated) {
	  			events.zoomanim = this._onAnimZoom;
	  		}
	  		return events;
	  	},
	
	  	_onAnimZoom: function (ev) {
	  		this._updateTransform(ev.center, ev.zoom);
	  	},
	
	  	_onZoom: function () {
	  		this._updateTransform(this._map.getCenter(), this._map.getZoom());
	  	},
	
	  	_updateTransform: function (center, zoom) {
	  		var scale = this._map.getZoomScale(zoom, this._zoom),
	  		    viewHalf = this._map.getSize().multiplyBy(0.5 + this.options.padding),
	  		    currentCenterPoint = this._map.project(this._center, zoom),
	
	  		    topLeftOffset = viewHalf.multiplyBy(-scale).add(currentCenterPoint)
	  				  .subtract(this._map._getNewPixelOrigin(center, zoom));
	
	  		if (Browser.any3d) {
	  			setTransform(this._container, topLeftOffset, scale);
	  		} else {
	  			setPosition(this._container, topLeftOffset);
	  		}
	  	},
	
	  	_reset: function () {
	  		this._update();
	  		this._updateTransform(this._center, this._zoom);
	
	  		for (var id in this._layers) {
	  			this._layers[id]._reset();
	  		}
	  	},
	
	  	_onZoomEnd: function () {
	  		for (var id in this._layers) {
	  			this._layers[id]._project();
	  		}
	  	},
	
	  	_updatePaths: function () {
	  		for (var id in this._layers) {
	  			this._layers[id]._update();
	  		}
	  	},
	
	  	_update: function () {
	  		// Update pixel bounds of renderer container (for positioning/sizing/clipping later)
	  		// Subclasses are responsible of firing the 'update' event.
	  		var p = this.options.padding,
	  		    size = this._map.getSize(),
	  		    min = this._map.containerPointToLayerPoint(size.multiplyBy(-p)).round();
	
	  		this._bounds = new Bounds(min, min.add(size.multiplyBy(1 + p * 2)).round());
	
	  		this._center = this._map.getCenter();
	  		this._zoom = this._map.getZoom();
	  	}
	  });
	
	  /*
	   * @class Canvas
	   * @inherits Renderer
	   * @aka L.Canvas
	   *
	   * Allows vector layers to be displayed with [`<canvas>`](https://developer.mozilla.org/docs/Web/API/Canvas_API).
	   * Inherits `Renderer`.
	   *
	   * Due to [technical limitations](https://caniuse.com/canvas), Canvas is not
	   * available in all web browsers, notably IE8, and overlapping geometries might
	   * not display properly in some edge cases.
	   *
	   * @example
	   *
	   * Use Canvas by default for all paths in the map:
	   *
	   * ```js
	   * var map = L.map('map', {
	   * 	renderer: L.canvas()
	   * });
	   * ```
	   *
	   * Use a Canvas renderer with extra padding for specific vector geometries:
	   *
	   * ```js
	   * var map = L.map('map');
	   * var myRenderer = L.canvas({ padding: 0.5 });
	   * var line = L.polyline( coordinates, { renderer: myRenderer } );
	   * var circle = L.circle( center, { renderer: myRenderer } );
	   * ```
	   */
	
	  var Canvas = Renderer.extend({
	
	  	// @section
	  	// @aka Canvas options
	  	options: {
	  		// @option tolerance: Number = 0
	  		// How much to extend the click tolerance around a path/object on the map.
	  		tolerance: 0
	  	},
	
	  	getEvents: function () {
	  		var events = Renderer.prototype.getEvents.call(this);
	  		events.viewprereset = this._onViewPreReset;
	  		return events;
	  	},
	
	  	_onViewPreReset: function () {
	  		// Set a flag so that a viewprereset+moveend+viewreset only updates&redraws once
	  		this._postponeUpdatePaths = true;
	  	},
	
	  	onAdd: function () {
	  		Renderer.prototype.onAdd.call(this);
	
	  		// Redraw vectors since canvas is cleared upon removal,
	  		// in case of removing the renderer itself from the map.
	  		this._draw();
	  	},
	
	  	_initContainer: function () {
	  		var container = this._container = document.createElement('canvas');
	
	  		on(container, 'mousemove', this._onMouseMove, this);
	  		on(container, 'click dblclick mousedown mouseup contextmenu', this._onClick, this);
	  		on(container, 'mouseout', this._handleMouseOut, this);
	  		container['_leaflet_disable_events'] = true;
	
	  		this._ctx = container.getContext('2d');
	  	},
	
	  	_destroyContainer: function () {
	  		cancelAnimFrame(this._redrawRequest);
	  		delete this._ctx;
	  		remove(this._container);
	  		off(this._container);
	  		delete this._container;
	  	},
	
	  	_updatePaths: function () {
	  		if (this._postponeUpdatePaths) { return; }
	
	  		var layer;
	  		this._redrawBounds = null;
	  		for (var id in this._layers) {
	  			layer = this._layers[id];
	  			layer._update();
	  		}
	  		this._redraw();
	  	},
	
	  	_update: function () {
	  		if (this._map._animatingZoom && this._bounds) { return; }
	
	  		Renderer.prototype._update.call(this);
	
	  		var b = this._bounds,
	  		    container = this._container,
	  		    size = b.getSize(),
	  		    m = Browser.retina ? 2 : 1;
	
	  		setPosition(container, b.min);
	
	  		// set canvas size (also clearing it); use double size on retina
	  		container.width = m * size.x;
	  		container.height = m * size.y;
	  		container.style.width = size.x + 'px';
	  		container.style.height = size.y + 'px';
	
	  		if (Browser.retina) {
	  			this._ctx.scale(2, 2);
	  		}
	
	  		// translate so we use the same path coordinates after canvas element moves
	  		this._ctx.translate(-b.min.x, -b.min.y);
	
	  		// Tell paths to redraw themselves
	  		this.fire('update');
	  	},
	
	  	_reset: function () {
	  		Renderer.prototype._reset.call(this);
	
	  		if (this._postponeUpdatePaths) {
	  			this._postponeUpdatePaths = false;
	  			this._updatePaths();
	  		}
	  	},
	
	  	_initPath: function (layer) {
	  		this._updateDashArray(layer);
	  		this._layers[stamp(layer)] = layer;
	
	  		var order = layer._order = {
	  			layer: layer,
	  			prev: this._drawLast,
	  			next: null
	  		};
	  		if (this._drawLast) { this._drawLast.next = order; }
	  		this._drawLast = order;
	  		this._drawFirst = this._drawFirst || this._drawLast;
	  	},
	
	  	_addPath: function (layer) {
	  		this._requestRedraw(layer);
	  	},
	
	  	_removePath: function (layer) {
	  		var order = layer._order;
	  		var next = order.next;
	  		var prev = order.prev;
	
	  		if (next) {
	  			next.prev = prev;
	  		} else {
	  			this._drawLast = prev;
	  		}
	  		if (prev) {
	  			prev.next = next;
	  		} else {
	  			this._drawFirst = next;
	  		}
	
	  		delete layer._order;
	
	  		delete this._layers[stamp(layer)];
	
	  		this._requestRedraw(layer);
	  	},
	
	  	_updatePath: function (layer) {
	  		// Redraw the union of the layer's old pixel
	  		// bounds and the new pixel bounds.
	  		this._extendRedrawBounds(layer);
	  		layer._project();
	  		layer._update();
	  		// The redraw will extend the redraw bounds
	  		// with the new pixel bounds.
	  		this._requestRedraw(layer);
	  	},
	
	  	_updateStyle: function (layer) {
	  		this._updateDashArray(layer);
	  		this._requestRedraw(layer);
	  	},
	
	  	_updateDashArray: function (layer) {
	  		if (typeof layer.options.dashArray === 'string') {
	  			var parts = layer.options.dashArray.split(/[, ]+/),
	  			    dashArray = [],
	  			    dashValue,
	  			    i;
	  			for (i = 0; i < parts.length; i++) {
	  				dashValue = Number(parts[i]);
	  				// Ignore dash array containing invalid lengths
	  				if (isNaN(dashValue)) { return; }
	  				dashArray.push(dashValue);
	  			}
	  			layer.options._dashArray = dashArray;
	  		} else {
	  			layer.options._dashArray = layer.options.dashArray;
	  		}
	  	},
	
	  	_requestRedraw: function (layer) {
	  		if (!this._map) { return; }
	
	  		this._extendRedrawBounds(layer);
	  		this._redrawRequest = this._redrawRequest || requestAnimFrame(this._redraw, this);
	  	},
	
	  	_extendRedrawBounds: function (layer) {
	  		if (layer._pxBounds) {
	  			var padding = (layer.options.weight || 0) + 1;
	  			this._redrawBounds = this._redrawBounds || new Bounds();
	  			this._redrawBounds.extend(layer._pxBounds.min.subtract([padding, padding]));
	  			this._redrawBounds.extend(layer._pxBounds.max.add([padding, padding]));
	  		}
	  	},
	
	  	_redraw: function () {
	  		this._redrawRequest = null;
	
	  		if (this._redrawBounds) {
	  			this._redrawBounds.min._floor();
	  			this._redrawBounds.max._ceil();
	  		}
	
	  		this._clear(); // clear layers in redraw bounds
	  		this._draw(); // draw layers
	
	  		this._redrawBounds = null;
	  	},
	
	  	_clear: function () {
	  		var bounds = this._redrawBounds;
	  		if (bounds) {
	  			var size = bounds.getSize();
	  			this._ctx.clearRect(bounds.min.x, bounds.min.y, size.x, size.y);
	  		} else {
	  			this._ctx.save();
	  			this._ctx.setTransform(1, 0, 0, 1, 0, 0);
	  			this._ctx.clearRect(0, 0, this._container.width, this._container.height);
	  			this._ctx.restore();
	  		}
	  	},
	
	  	_draw: function () {
	  		var layer, bounds = this._redrawBounds;
	  		this._ctx.save();
	  		if (bounds) {
	  			var size = bounds.getSize();
	  			this._ctx.beginPath();
	  			this._ctx.rect(bounds.min.x, bounds.min.y, size.x, size.y);
	  			this._ctx.clip();
	  		}
	
	  		this._drawing = true;
	
	  		for (var order = this._drawFirst; order; order = order.next) {
	  			layer = order.layer;
	  			if (!bounds || (layer._pxBounds && layer._pxBounds.intersects(bounds))) {
	  				layer._updatePath();
	  			}
	  		}
	
	  		this._drawing = false;
	
	  		this._ctx.restore();  // Restore state before clipping.
	  	},
	
	  	_updatePoly: function (layer, closed) {
	  		if (!this._drawing) { return; }
	
	  		var i, j, len2, p,
	  		    parts = layer._parts,
	  		    len = parts.length,
	  		    ctx = this._ctx;
	
	  		if (!len) { return; }
	
	  		ctx.beginPath();
	
	  		for (i = 0; i < len; i++) {
	  			for (j = 0, len2 = parts[i].length; j < len2; j++) {
	  				p = parts[i][j];
	  				ctx[j ? 'lineTo' : 'moveTo'](p.x, p.y);
	  			}
	  			if (closed) {
	  				ctx.closePath();
	  			}
	  		}
	
	  		this._fillStroke(ctx, layer);
	
	  		// TODO optimization: 1 fill/stroke for all features with equal style instead of 1 for each feature
	  	},
	
	  	_updateCircle: function (layer) {
	
	  		if (!this._drawing || layer._empty()) { return; }
	
	  		var p = layer._point,
	  		    ctx = this._ctx,
	  		    r = Math.max(Math.round(layer._radius), 1),
	  		    s = (Math.max(Math.round(layer._radiusY), 1) || r) / r;
	
	  		if (s !== 1) {
	  			ctx.save();
	  			ctx.scale(1, s);
	  		}
	
	  		ctx.beginPath();
	  		ctx.arc(p.x, p.y / s, r, 0, Math.PI * 2, false);
	
	  		if (s !== 1) {
	  			ctx.restore();
	  		}
	
	  		this._fillStroke(ctx, layer);
	  	},
	
	  	_fillStroke: function (ctx, layer) {
	  		var options = layer.options;
	
	  		if (options.fill) {
	  			ctx.globalAlpha = options.fillOpacity;
	  			ctx.fillStyle = options.fillColor || options.color;
	  			ctx.fill(options.fillRule || 'evenodd');
	  		}
	
	  		if (options.stroke && options.weight !== 0) {
	  			if (ctx.setLineDash) {
	  				ctx.setLineDash(layer.options && layer.options._dashArray || []);
	  			}
	  			ctx.globalAlpha = options.opacity;
	  			ctx.lineWidth = options.weight;
	  			ctx.strokeStyle = options.color;
	  			ctx.lineCap = options.lineCap;
	  			ctx.lineJoin = options.lineJoin;
	  			ctx.stroke();
	  		}
	  	},
	
	  	// Canvas obviously doesn't have mouse events for individual drawn objects,
	  	// so we emulate that by calculating what's under the mouse on mousemove/click manually
	
	  	_onClick: function (e) {
	  		var point = this._map.mouseEventToLayerPoint(e), layer, clickedLayer;
	
	  		for (var order = this._drawFirst; order; order = order.next) {
	  			layer = order.layer;
	  			if (layer.options.interactive && layer._containsPoint(point)) {
	  				if (!(e.type === 'click' || e.type === 'preclick') || !this._map._draggableMoved(layer)) {
	  					clickedLayer = layer;
	  				}
	  			}
	  		}
	  		this._fireEvent(clickedLayer ? [clickedLayer] : false, e);
	  	},
	
	  	_onMouseMove: function (e) {
	  		if (!this._map || this._map.dragging.moving() || this._map._animatingZoom) { return; }
	
	  		var point = this._map.mouseEventToLayerPoint(e);
	  		this._handleMouseHover(e, point);
	  	},
	
	
	  	_handleMouseOut: function (e) {
	  		var layer = this._hoveredLayer;
	  		if (layer) {
	  			// if we're leaving the layer, fire mouseout
	  			removeClass(this._container, 'leaflet-interactive');
	  			this._fireEvent([layer], e, 'mouseout');
	  			this._hoveredLayer = null;
	  			this._mouseHoverThrottled = false;
	  		}
	  	},
	
	  	_handleMouseHover: function (e, point) {
	  		if (this._mouseHoverThrottled) {
	  			return;
	  		}
	
	  		var layer, candidateHoveredLayer;
	
	  		for (var order = this._drawFirst; order; order = order.next) {
	  			layer = order.layer;
	  			if (layer.options.interactive && layer._containsPoint(point)) {
	  				candidateHoveredLayer = layer;
	  			}
	  		}
	
	  		if (candidateHoveredLayer !== this._hoveredLayer) {
	  			this._handleMouseOut(e);
	
	  			if (candidateHoveredLayer) {
	  				addClass(this._container, 'leaflet-interactive'); // change cursor
	  				this._fireEvent([candidateHoveredLayer], e, 'mouseover');
	  				this._hoveredLayer = candidateHoveredLayer;
	  			}
	  		}
	
	  		this._fireEvent(this._hoveredLayer ? [this._hoveredLayer] : false, e);
	
	  		this._mouseHoverThrottled = true;
	  		setTimeout(bind(function () {
	  			this._mouseHoverThrottled = false;
	  		}, this), 32);
	  	},
	
	  	_fireEvent: function (layers, e, type) {
	  		this._map._fireDOMEvent(e, type || e.type, layers);
	  	},
	
	  	_bringToFront: function (layer) {
	  		var order = layer._order;
	
	  		if (!order) { return; }
	
	  		var next = order.next;
	  		var prev = order.prev;
	
	  		if (next) {
	  			next.prev = prev;
	  		} else {
	  			// Already last
	  			return;
	  		}
	  		if (prev) {
	  			prev.next = next;
	  		} else if (next) {
	  			// Update first entry unless this is the
	  			// single entry
	  			this._drawFirst = next;
	  		}
	
	  		order.prev = this._drawLast;
	  		this._drawLast.next = order;
	
	  		order.next = null;
	  		this._drawLast = order;
	
	  		this._requestRedraw(layer);
	  	},
	
	  	_bringToBack: function (layer) {
	  		var order = layer._order;
	
	  		if (!order) { return; }
	
	  		var next = order.next;
	  		var prev = order.prev;
	
	  		if (prev) {
	  			prev.next = next;
	  		} else {
	  			// Already first
	  			return;
	  		}
	  		if (next) {
	  			next.prev = prev;
	  		} else if (prev) {
	  			// Update last entry unless this is the
	  			// single entry
	  			this._drawLast = prev;
	  		}
	
	  		order.prev = null;
	
	  		order.next = this._drawFirst;
	  		this._drawFirst.prev = order;
	  		this._drawFirst = order;
	
	  		this._requestRedraw(layer);
	  	}
	  });
	
	  // @factory L.canvas(options?: Renderer options)
	  // Creates a Canvas renderer with the given options.
	  function canvas(options) {
	  	return Browser.canvas ? new Canvas(options) : null;
	  }
	
	  /*
	   * Thanks to Dmitry Baranovsky and his Raphael library for inspiration!
	   */
	
	
	  var vmlCreate = (function () {
	  	try {
	  		document.namespaces.add('lvml', 'urn:schemas-microsoft-com:vml');
	  		return function (name) {
	  			return document.createElement('<lvml:' + name + ' class="lvml">');
	  		};
	  	} catch (e) {
	  		// Do not return fn from catch block so `e` can be garbage collected
	  		// See https://github.com/Leaflet/Leaflet/pull/7279
	  	}
	  	return function (name) {
	  		return document.createElement('<' + name + ' xmlns="urn:schemas-microsoft.com:vml" class="lvml">');
	  	};
	  })();
	
	
	  /*
	   * @class SVG
	   *
	   *
	   * VML was deprecated in 2012, which means VML functionality exists only for backwards compatibility
	   * with old versions of Internet Explorer.
	   */
	
	  // mixin to redefine some SVG methods to handle VML syntax which is similar but with some differences
	  var vmlMixin = {
	
	  	_initContainer: function () {
	  		this._container = create$1('div', 'leaflet-vml-container');
	  	},
	
	  	_update: function () {
	  		if (this._map._animatingZoom) { return; }
	  		Renderer.prototype._update.call(this);
	  		this.fire('update');
	  	},
	
	  	_initPath: function (layer) {
	  		var container = layer._container = vmlCreate('shape');
	
	  		addClass(container, 'leaflet-vml-shape ' + (this.options.className || ''));
	
	  		container.coordsize = '1 1';
	
	  		layer._path = vmlCreate('path');
	  		container.appendChild(layer._path);
	
	  		this._updateStyle(layer);
	  		this._layers[stamp(layer)] = layer;
	  	},
	
	  	_addPath: function (layer) {
	  		var container = layer._container;
	  		this._container.appendChild(container);
	
	  		if (layer.options.interactive) {
	  			layer.addInteractiveTarget(container);
	  		}
	  	},
	
	  	_removePath: function (layer) {
	  		var container = layer._container;
	  		remove(container);
	  		layer.removeInteractiveTarget(container);
	  		delete this._layers[stamp(layer)];
	  	},
	
	  	_updateStyle: function (layer) {
	  		var stroke = layer._stroke,
	  		    fill = layer._fill,
	  		    options = layer.options,
	  		    container = layer._container;
	
	  		container.stroked = !!options.stroke;
	  		container.filled = !!options.fill;
	
	  		if (options.stroke) {
	  			if (!stroke) {
	  				stroke = layer._stroke = vmlCreate('stroke');
	  			}
	  			container.appendChild(stroke);
	  			stroke.weight = options.weight + 'px';
	  			stroke.color = options.color;
	  			stroke.opacity = options.opacity;
	
	  			if (options.dashArray) {
	  				stroke.dashStyle = isArray(options.dashArray) ?
	  				    options.dashArray.join(' ') :
	  				    options.dashArray.replace(/( *, *)/g, ' ');
	  			} else {
	  				stroke.dashStyle = '';
	  			}
	  			stroke.endcap = options.lineCap.replace('butt', 'flat');
	  			stroke.joinstyle = options.lineJoin;
	
	  		} else if (stroke) {
	  			container.removeChild(stroke);
	  			layer._stroke = null;
	  		}
	
	  		if (options.fill) {
	  			if (!fill) {
	  				fill = layer._fill = vmlCreate('fill');
	  			}
	  			container.appendChild(fill);
	  			fill.color = options.fillColor || options.color;
	  			fill.opacity = options.fillOpacity;
	
	  		} else if (fill) {
	  			container.removeChild(fill);
	  			layer._fill = null;
	  		}
	  	},
	
	  	_updateCircle: function (layer) {
	  		var p = layer._point.round(),
	  		    r = Math.round(layer._radius),
	  		    r2 = Math.round(layer._radiusY || r);
	
	  		this._setPath(layer, layer._empty() ? 'M0 0' :
	  			'AL ' + p.x + ',' + p.y + ' ' + r + ',' + r2 + ' 0,' + (65535 * 360));
	  	},
	
	  	_setPath: function (layer, path) {
	  		layer._path.v = path;
	  	},
	
	  	_bringToFront: function (layer) {
	  		toFront(layer._container);
	  	},
	
	  	_bringToBack: function (layer) {
	  		toBack(layer._container);
	  	}
	  };
	
	  var create = Browser.vml ? vmlCreate : svgCreate;
	
	  /*
	   * @class SVG
	   * @inherits Renderer
	   * @aka L.SVG
	   *
	   * Allows vector layers to be displayed with [SVG](https://developer.mozilla.org/docs/Web/SVG).
	   * Inherits `Renderer`.
	   *
	   * Due to [technical limitations](https://caniuse.com/svg), SVG is not
	   * available in all web browsers, notably Android 2.x and 3.x.
	   *
	   * Although SVG is not available on IE7 and IE8, these browsers support
	   * [VML](https://en.wikipedia.org/wiki/Vector_Markup_Language)
	   * (a now deprecated technology), and the SVG renderer will fall back to VML in
	   * this case.
	   *
	   * @example
	   *
	   * Use SVG by default for all paths in the map:
	   *
	   * ```js
	   * var map = L.map('map', {
	   * 	renderer: L.svg()
	   * });
	   * ```
	   *
	   * Use a SVG renderer with extra padding for specific vector geometries:
	   *
	   * ```js
	   * var map = L.map('map');
	   * var myRenderer = L.svg({ padding: 0.5 });
	   * var line = L.polyline( coordinates, { renderer: myRenderer } );
	   * var circle = L.circle( center, { renderer: myRenderer } );
	   * ```
	   */
	
	  var SVG = Renderer.extend({
	
	  	_initContainer: function () {
	  		this._container = create('svg');
	
	  		// makes it possible to click through svg root; we'll reset it back in individual paths
	  		this._container.setAttribute('pointer-events', 'none');
	
	  		this._rootGroup = create('g');
	  		this._container.appendChild(this._rootGroup);
	  	},
	
	  	_destroyContainer: function () {
	  		remove(this._container);
	  		off(this._container);
	  		delete this._container;
	  		delete this._rootGroup;
	  		delete this._svgSize;
	  	},
	
	  	_update: function () {
	  		if (this._map._animatingZoom && this._bounds) { return; }
	
	  		Renderer.prototype._update.call(this);
	
	  		var b = this._bounds,
	  		    size = b.getSize(),
	  		    container = this._container;
	
	  		// set size of svg-container if changed
	  		if (!this._svgSize || !this._svgSize.equals(size)) {
	  			this._svgSize = size;
	  			container.setAttribute('width', size.x);
	  			container.setAttribute('height', size.y);
	  		}
	
	  		// movement: update container viewBox so that we don't have to change coordinates of individual layers
	  		setPosition(container, b.min);
	  		container.setAttribute('viewBox', [b.min.x, b.min.y, size.x, size.y].join(' '));
	
	  		this.fire('update');
	  	},
	
	  	// methods below are called by vector layers implementations
	
	  	_initPath: function (layer) {
	  		var path = layer._path = create('path');
	
	  		// @namespace Path
	  		// @option className: String = null
	  		// Custom class name set on an element. Only for SVG renderer.
	  		if (layer.options.className) {
	  			addClass(path, layer.options.className);
	  		}
	
	  		if (layer.options.interactive) {
	  			addClass(path, 'leaflet-interactive');
	  		}
	
	  		this._updateStyle(layer);
	  		this._layers[stamp(layer)] = layer;
	  	},
	
	  	_addPath: function (layer) {
	  		if (!this._rootGroup) { this._initContainer(); }
	  		this._rootGroup.appendChild(layer._path);
	  		layer.addInteractiveTarget(layer._path);
	  	},
	
	  	_removePath: function (layer) {
	  		remove(layer._path);
	  		layer.removeInteractiveTarget(layer._path);
	  		delete this._layers[stamp(layer)];
	  	},
	
	  	_updatePath: function (layer) {
	  		layer._project();
	  		layer._update();
	  	},
	
	  	_updateStyle: function (layer) {
	  		var path = layer._path,
	  		    options = layer.options;
	
	  		if (!path) { return; }
	
	  		if (options.stroke) {
	  			path.setAttribute('stroke', options.color);
	  			path.setAttribute('stroke-opacity', options.opacity);
	  			path.setAttribute('stroke-width', options.weight);
	  			path.setAttribute('stroke-linecap', options.lineCap);
	  			path.setAttribute('stroke-linejoin', options.lineJoin);
	
	  			if (options.dashArray) {
	  				path.setAttribute('stroke-dasharray', options.dashArray);
	  			} else {
	  				path.removeAttribute('stroke-dasharray');
	  			}
	
	  			if (options.dashOffset) {
	  				path.setAttribute('stroke-dashoffset', options.dashOffset);
	  			} else {
	  				path.removeAttribute('stroke-dashoffset');
	  			}
	  		} else {
	  			path.setAttribute('stroke', 'none');
	  		}
	
	  		if (options.fill) {
	  			path.setAttribute('fill', options.fillColor || options.color);
	  			path.setAttribute('fill-opacity', options.fillOpacity);
	  			path.setAttribute('fill-rule', options.fillRule || 'evenodd');
	  		} else {
	  			path.setAttribute('fill', 'none');
	  		}
	  	},
	
	  	_updatePoly: function (layer, closed) {
	  		this._setPath(layer, pointsToPath(layer._parts, closed));
	  	},
	
	  	_updateCircle: function (layer) {
	  		var p = layer._point,
	  		    r = Math.max(Math.round(layer._radius), 1),
	  		    r2 = Math.max(Math.round(layer._radiusY), 1) || r,
	  		    arc = 'a' + r + ',' + r2 + ' 0 1,0 ';
	
	  		// drawing a circle with two half-arcs
	  		var d = layer._empty() ? 'M0 0' :
	  			'M' + (p.x - r) + ',' + p.y +
	  			arc + (r * 2) + ',0 ' +
	  			arc + (-r * 2) + ',0 ';
	
	  		this._setPath(layer, d);
	  	},
	
	  	_setPath: function (layer, path) {
	  		layer._path.setAttribute('d', path);
	  	},
	
	  	// SVG does not have the concept of zIndex so we resort to changing the DOM order of elements
	  	_bringToFront: function (layer) {
	  		toFront(layer._path);
	  	},
	
	  	_bringToBack: function (layer) {
	  		toBack(layer._path);
	  	}
	  });
	
	  if (Browser.vml) {
	  	SVG.include(vmlMixin);
	  }
	
	  // @namespace SVG
	  // @factory L.svg(options?: Renderer options)
	  // Creates a SVG renderer with the given options.
	  function svg(options) {
	  	return Browser.svg || Browser.vml ? new SVG(options) : null;
	  }
	
	  Map.include({
	  	// @namespace Map; @method getRenderer(layer: Path): Renderer
	  	// Returns the instance of `Renderer` that should be used to render the given
	  	// `Path`. It will ensure that the `renderer` options of the map and paths
	  	// are respected, and that the renderers do exist on the map.
	  	getRenderer: function (layer) {
	  		// @namespace Path; @option renderer: Renderer
	  		// Use this specific instance of `Renderer` for this path. Takes
	  		// precedence over the map's [default renderer](#map-renderer).
	  		var renderer = layer.options.renderer || this._getPaneRenderer(layer.options.pane) || this.options.renderer || this._renderer;
	
	  		if (!renderer) {
	  			renderer = this._renderer = this._createRenderer();
	  		}
	
	  		if (!this.hasLayer(renderer)) {
	  			this.addLayer(renderer);
	  		}
	  		return renderer;
	  	},
	
	  	_getPaneRenderer: function (name) {
	  		if (name === 'overlayPane' || name === undefined) {
	  			return false;
	  		}
	
	  		var renderer = this._paneRenderers[name];
	  		if (renderer === undefined) {
	  			renderer = this._createRenderer({pane: name});
	  			this._paneRenderers[name] = renderer;
	  		}
	  		return renderer;
	  	},
	
	  	_createRenderer: function (options) {
	  		// @namespace Map; @option preferCanvas: Boolean = false
	  		// Whether `Path`s should be rendered on a `Canvas` renderer.
	  		// By default, all `Path`s are rendered in a `SVG` renderer.
	  		return (this.options.preferCanvas && canvas(options)) || svg(options);
	  	}
	  });
	
	  /*
	   * L.Rectangle extends Polygon and creates a rectangle when passed a LatLngBounds object.
	   */
	
	  /*
	   * @class Rectangle
	   * @aka L.Rectangle
	   * @inherits Polygon
	   *
	   * A class for drawing rectangle overlays on a map. Extends `Polygon`.
	   *
	   * @example
	   *
	   * ```js
	   * // define rectangle geographical bounds
	   * var bounds = [[54.559322, -5.767822], [56.1210604, -3.021240]];
	   *
	   * // create an orange rectangle
	   * L.rectangle(bounds, {color: "#ff7800", weight: 1}).addTo(map);
	   *
	   * // zoom the map to the rectangle bounds
	   * map.fitBounds(bounds);
	   * ```
	   *
	   */
	
	
	  var Rectangle = Polygon.extend({
	  	initialize: function (latLngBounds, options) {
	  		Polygon.prototype.initialize.call(this, this._boundsToLatLngs(latLngBounds), options);
	  	},
	
	  	// @method setBounds(latLngBounds: LatLngBounds): this
	  	// Redraws the rectangle with the passed bounds.
	  	setBounds: function (latLngBounds) {
	  		return this.setLatLngs(this._boundsToLatLngs(latLngBounds));
	  	},
	
	  	_boundsToLatLngs: function (latLngBounds) {
	  		latLngBounds = toLatLngBounds(latLngBounds);
	  		return [
	  			latLngBounds.getSouthWest(),
	  			latLngBounds.getNorthWest(),
	  			latLngBounds.getNorthEast(),
	  			latLngBounds.getSouthEast()
	  		];
	  	}
	  });
	
	
	  // @factory L.rectangle(latLngBounds: LatLngBounds, options?: Polyline options)
	  function rectangle(latLngBounds, options) {
	  	return new Rectangle(latLngBounds, options);
	  }
	
	  SVG.create = create;
	  SVG.pointsToPath = pointsToPath;
	
	  GeoJSON.geometryToLayer = geometryToLayer;
	  GeoJSON.coordsToLatLng = coordsToLatLng;
	  GeoJSON.coordsToLatLngs = coordsToLatLngs;
	  GeoJSON.latLngToCoords = latLngToCoords;
	  GeoJSON.latLngsToCoords = latLngsToCoords;
	  GeoJSON.getFeature = getFeature;
	  GeoJSON.asFeature = asFeature;
	
	  /*
	   * L.Handler.BoxZoom is used to add shift-drag zoom interaction to the map
	   * (zoom to a selected bounding box), enabled by default.
	   */
	
	  // @namespace Map
	  // @section Interaction Options
	  Map.mergeOptions({
	  	// @option boxZoom: Boolean = true
	  	// Whether the map can be zoomed to a rectangular area specified by
	  	// dragging the mouse while pressing the shift key.
	  	boxZoom: true
	  });
	
	  var BoxZoom = Handler.extend({
	  	initialize: function (map) {
	  		this._map = map;
	  		this._container = map._container;
	  		this._pane = map._panes.overlayPane;
	  		this._resetStateTimeout = 0;
	  		map.on('unload', this._destroy, this);
	  	},
	
	  	addHooks: function () {
	  		on(this._container, 'mousedown', this._onMouseDown, this);
	  	},
	
	  	removeHooks: function () {
	  		off(this._container, 'mousedown', this._onMouseDown, this);
	  	},
	
	  	moved: function () {
	  		return this._moved;
	  	},
	
	  	_destroy: function () {
	  		remove(this._pane);
	  		delete this._pane;
	  	},
	
	  	_resetState: function () {
	  		this._resetStateTimeout = 0;
	  		this._moved = false;
	  	},
	
	  	_clearDeferredResetState: function () {
	  		if (this._resetStateTimeout !== 0) {
	  			clearTimeout(this._resetStateTimeout);
	  			this._resetStateTimeout = 0;
	  		}
	  	},
	
	  	_onMouseDown: function (e) {
	  		if (!e.shiftKey || ((e.which !== 1) && (e.button !== 1))) { return false; }
	
	  		// Clear the deferred resetState if it hasn't executed yet, otherwise it
	  		// will interrupt the interaction and orphan a box element in the container.
	  		this._clearDeferredResetState();
	  		this._resetState();
	
	  		disableTextSelection();
	  		disableImageDrag();
	
	  		this._startPoint = this._map.mouseEventToContainerPoint(e);
	
	  		on(document, {
	  			contextmenu: stop,
	  			mousemove: this._onMouseMove,
	  			mouseup: this._onMouseUp,
	  			keydown: this._onKeyDown
	  		}, this);
	  	},
	
	  	_onMouseMove: function (e) {
	  		if (!this._moved) {
	  			this._moved = true;
	
	  			this._box = create$1('div', 'leaflet-zoom-box', this._container);
	  			addClass(this._container, 'leaflet-crosshair');
	
	  			this._map.fire('boxzoomstart');
	  		}
	
	  		this._point = this._map.mouseEventToContainerPoint(e);
	
	  		var bounds = new Bounds(this._point, this._startPoint),
	  		    size = bounds.getSize();
	
	  		setPosition(this._box, bounds.min);
	
	  		this._box.style.width  = size.x + 'px';
	  		this._box.style.height = size.y + 'px';
	  	},
	
	  	_finish: function () {
	  		if (this._moved) {
	  			remove(this._box);
	  			removeClass(this._container, 'leaflet-crosshair');
	  		}
	
	  		enableTextSelection();
	  		enableImageDrag();
	
	  		off(document, {
	  			contextmenu: stop,
	  			mousemove: this._onMouseMove,
	  			mouseup: this._onMouseUp,
	  			keydown: this._onKeyDown
	  		}, this);
	  	},
	
	  	_onMouseUp: function (e) {
	  		if ((e.which !== 1) && (e.button !== 1)) { return; }
	
	  		this._finish();
	
	  		if (!this._moved) { return; }
	  		// Postpone to next JS tick so internal click event handling
	  		// still see it as "moved".
	  		this._clearDeferredResetState();
	  		this._resetStateTimeout = setTimeout(bind(this._resetState, this), 0);
	
	  		var bounds = new LatLngBounds(
	  		        this._map.containerPointToLatLng(this._startPoint),
	  		        this._map.containerPointToLatLng(this._point));
	
	  		this._map
	  			.fitBounds(bounds)
	  			.fire('boxzoomend', {boxZoomBounds: bounds});
	  	},
	
	  	_onKeyDown: function (e) {
	  		if (e.keyCode === 27) {
	  			this._finish();
	  			this._clearDeferredResetState();
	  			this._resetState();
	  		}
	  	}
	  });
	
	  // @section Handlers
	  // @property boxZoom: Handler
	  // Box (shift-drag with mouse) zoom handler.
	  Map.addInitHook('addHandler', 'boxZoom', BoxZoom);
	
	  /*
	   * L.Handler.DoubleClickZoom is used to handle double-click zoom on the map, enabled by default.
	   */
	
	  // @namespace Map
	  // @section Interaction Options
	
	  Map.mergeOptions({
	  	// @option doubleClickZoom: Boolean|String = true
	  	// Whether the map can be zoomed in by double clicking on it and
	  	// zoomed out by double clicking while holding shift. If passed
	  	// `'center'`, double-click zoom will zoom to the center of the
	  	//  view regardless of where the mouse was.
	  	doubleClickZoom: true
	  });
	
	  var DoubleClickZoom = Handler.extend({
	  	addHooks: function () {
	  		this._map.on('dblclick', this._onDoubleClick, this);
	  	},
	
	  	removeHooks: function () {
	  		this._map.off('dblclick', this._onDoubleClick, this);
	  	},
	
	  	_onDoubleClick: function (e) {
	  		var map = this._map,
	  		    oldZoom = map.getZoom(),
	  		    delta = map.options.zoomDelta,
	  		    zoom = e.originalEvent.shiftKey ? oldZoom - delta : oldZoom + delta;
	
	  		if (map.options.doubleClickZoom === 'center') {
	  			map.setZoom(zoom);
	  		} else {
	  			map.setZoomAround(e.containerPoint, zoom);
	  		}
	  	}
	  });
	
	  // @section Handlers
	  //
	  // Map properties include interaction handlers that allow you to control
	  // interaction behavior in runtime, enabling or disabling certain features such
	  // as dragging or touch zoom (see `Handler` methods). For example:
	  //
	  // ```js
	  // map.doubleClickZoom.disable();
	  // ```
	  //
	  // @property doubleClickZoom: Handler
	  // Double click zoom handler.
	  Map.addInitHook('addHandler', 'doubleClickZoom', DoubleClickZoom);
	
	  /*
	   * L.Handler.MapDrag is used to make the map draggable (with panning inertia), enabled by default.
	   */
	
	  // @namespace Map
	  // @section Interaction Options
	  Map.mergeOptions({
	  	// @option dragging: Boolean = true
	  	// Whether the map is draggable with mouse/touch or not.
	  	dragging: true,
	
	  	// @section Panning Inertia Options
	  	// @option inertia: Boolean = *
	  	// If enabled, panning of the map will have an inertia effect where
	  	// the map builds momentum while dragging and continues moving in
	  	// the same direction for some time. Feels especially nice on touch
	  	// devices. Enabled by default.
	  	inertia: true,
	
	  	// @option inertiaDeceleration: Number = 3000
	  	// The rate with which the inertial movement slows down, in pixels/second².
	  	inertiaDeceleration: 3400, // px/s^2
	
	  	// @option inertiaMaxSpeed: Number = Infinity
	  	// Max speed of the inertial movement, in pixels/second.
	  	inertiaMaxSpeed: Infinity, // px/s
	
	  	// @option easeLinearity: Number = 0.2
	  	easeLinearity: 0.2,
	
	  	// TODO refactor, move to CRS
	  	// @option worldCopyJump: Boolean = false
	  	// With this option enabled, the map tracks when you pan to another "copy"
	  	// of the world and seamlessly jumps to the original one so that all overlays
	  	// like markers and vector layers are still visible.
	  	worldCopyJump: false,
	
	  	// @option maxBoundsViscosity: Number = 0.0
	  	// If `maxBounds` is set, this option will control how solid the bounds
	  	// are when dragging the map around. The default value of `0.0` allows the
	  	// user to drag outside the bounds at normal speed, higher values will
	  	// slow down map dragging outside bounds, and `1.0` makes the bounds fully
	  	// solid, preventing the user from dragging outside the bounds.
	  	maxBoundsViscosity: 0.0
	  });
	
	  var Drag = Handler.extend({
	  	addHooks: function () {
	  		if (!this._draggable) {
	  			var map = this._map;
	
	  			this._draggable = new Draggable(map._mapPane, map._container);
	
	  			this._draggable.on({
	  				dragstart: this._onDragStart,
	  				drag: this._onDrag,
	  				dragend: this._onDragEnd
	  			}, this);
	
	  			this._draggable.on('predrag', this._onPreDragLimit, this);
	  			if (map.options.worldCopyJump) {
	  				this._draggable.on('predrag', this._onPreDragWrap, this);
	  				map.on('zoomend', this._onZoomEnd, this);
	
	  				map.whenReady(this._onZoomEnd, this);
	  			}
	  		}
	  		addClass(this._map._container, 'leaflet-grab leaflet-touch-drag');
	  		this._draggable.enable();
	  		this._positions = [];
	  		this._times = [];
	  	},
	
	  	removeHooks: function () {
	  		removeClass(this._map._container, 'leaflet-grab');
	  		removeClass(this._map._container, 'leaflet-touch-drag');
	  		this._draggable.disable();
	  	},
	
	  	moved: function () {
	  		return this._draggable && this._draggable._moved;
	  	},
	
	  	moving: function () {
	  		return this._draggable && this._draggable._moving;
	  	},
	
	  	_onDragStart: function () {
	  		var map = this._map;
	
	  		map._stop();
	  		if (this._map.options.maxBounds && this._map.options.maxBoundsViscosity) {
	  			var bounds = toLatLngBounds(this._map.options.maxBounds);
	
	  			this._offsetLimit = toBounds(
	  				this._map.latLngToContainerPoint(bounds.getNorthWest()).multiplyBy(-1),
	  				this._map.latLngToContainerPoint(bounds.getSouthEast()).multiplyBy(-1)
	  					.add(this._map.getSize()));
	
	  			this._viscosity = Math.min(1.0, Math.max(0.0, this._map.options.maxBoundsViscosity));
	  		} else {
	  			this._offsetLimit = null;
	  		}
	
	  		map
	  		    .fire('movestart')
	  		    .fire('dragstart');
	
	  		if (map.options.inertia) {
	  			this._positions = [];
	  			this._times = [];
	  		}
	  	},
	
	  	_onDrag: function (e) {
	  		if (this._map.options.inertia) {
	  			var time = this._lastTime = +new Date(),
	  			    pos = this._lastPos = this._draggable._absPos || this._draggable._newPos;
	
	  			this._positions.push(pos);
	  			this._times.push(time);
	
	  			this._prunePositions(time);
	  		}
	
	  		this._map
	  		    .fire('move', e)
	  		    .fire('drag', e);
	  	},
	
	  	_prunePositions: function (time) {
	  		while (this._positions.length > 1 && time - this._times[0] > 50) {
	  			this._positions.shift();
	  			this._times.shift();
	  		}
	  	},
	
	  	_onZoomEnd: function () {
	  		var pxCenter = this._map.getSize().divideBy(2),
	  		    pxWorldCenter = this._map.latLngToLayerPoint([0, 0]);
	
	  		this._initialWorldOffset = pxWorldCenter.subtract(pxCenter).x;
	  		this._worldWidth = this._map.getPixelWorldBounds().getSize().x;
	  	},
	
	  	_viscousLimit: function (value, threshold) {
	  		return value - (value - threshold) * this._viscosity;
	  	},
	
	  	_onPreDragLimit: function () {
	  		if (!this._viscosity || !this._offsetLimit) { return; }
	
	  		var offset = this._draggable._newPos.subtract(this._draggable._startPos);
	
	  		var limit = this._offsetLimit;
	  		if (offset.x < limit.min.x) { offset.x = this._viscousLimit(offset.x, limit.min.x); }
	  		if (offset.y < limit.min.y) { offset.y = this._viscousLimit(offset.y, limit.min.y); }
	  		if (offset.x > limit.max.x) { offset.x = this._viscousLimit(offset.x, limit.max.x); }
	  		if (offset.y > limit.max.y) { offset.y = this._viscousLimit(offset.y, limit.max.y); }
	
	  		this._draggable._newPos = this._draggable._startPos.add(offset);
	  	},
	
	  	_onPreDragWrap: function () {
	  		// TODO refactor to be able to adjust map pane position after zoom
	  		var worldWidth = this._worldWidth,
	  		    halfWidth = Math.round(worldWidth / 2),
	  		    dx = this._initialWorldOffset,
	  		    x = this._draggable._newPos.x,
	  		    newX1 = (x - halfWidth + dx) % worldWidth + halfWidth - dx,
	  		    newX2 = (x + halfWidth + dx) % worldWidth - halfWidth - dx,
	  		    newX = Math.abs(newX1 + dx) < Math.abs(newX2 + dx) ? newX1 : newX2;
	
	  		this._draggable._absPos = this._draggable._newPos.clone();
	  		this._draggable._newPos.x = newX;
	  	},
	
	  	_onDragEnd: function (e) {
	  		var map = this._map,
	  		    options = map.options,
	
	  		    noInertia = !options.inertia || e.noInertia || this._times.length < 2;
	
	  		map.fire('dragend', e);
	
	  		if (noInertia) {
	  			map.fire('moveend');
	
	  		} else {
	  			this._prunePositions(+new Date());
	
	  			var direction = this._lastPos.subtract(this._positions[0]),
	  			    duration = (this._lastTime - this._times[0]) / 1000,
	  			    ease = options.easeLinearity,
	
	  			    speedVector = direction.multiplyBy(ease / duration),
	  			    speed = speedVector.distanceTo([0, 0]),
	
	  			    limitedSpeed = Math.min(options.inertiaMaxSpeed, speed),
	  			    limitedSpeedVector = speedVector.multiplyBy(limitedSpeed / speed),
	
	  			    decelerationDuration = limitedSpeed / (options.inertiaDeceleration * ease),
	  			    offset = limitedSpeedVector.multiplyBy(-decelerationDuration / 2).round();
	
	  			if (!offset.x && !offset.y) {
	  				map.fire('moveend');
	
	  			} else {
	  				offset = map._limitOffset(offset, map.options.maxBounds);
	
	  				requestAnimFrame(function () {
	  					map.panBy(offset, {
	  						duration: decelerationDuration,
	  						easeLinearity: ease,
	  						noMoveStart: true,
	  						animate: true
	  					});
	  				});
	  			}
	  		}
	  	}
	  });
	
	  // @section Handlers
	  // @property dragging: Handler
	  // Map dragging handler (by both mouse and touch).
	  Map.addInitHook('addHandler', 'dragging', Drag);
	
	  /*
	   * L.Map.Keyboard is handling keyboard interaction with the map, enabled by default.
	   */
	
	  // @namespace Map
	  // @section Keyboard Navigation Options
	  Map.mergeOptions({
	  	// @option keyboard: Boolean = true
	  	// Makes the map focusable and allows users to navigate the map with keyboard
	  	// arrows and `+`/`-` keys.
	  	keyboard: true,
	
	  	// @option keyboardPanDelta: Number = 80
	  	// Amount of pixels to pan when pressing an arrow key.
	  	keyboardPanDelta: 80
	  });
	
	  var Keyboard = Handler.extend({
	
	  	keyCodes: {
	  		left:    [37],
	  		right:   [39],
	  		down:    [40],
	  		up:      [38],
	  		zoomIn:  [187, 107, 61, 171],
	  		zoomOut: [189, 109, 54, 173]
	  	},
	
	  	initialize: function (map) {
	  		this._map = map;
	
	  		this._setPanDelta(map.options.keyboardPanDelta);
	  		this._setZoomDelta(map.options.zoomDelta);
	  	},
	
	  	addHooks: function () {
	  		var container = this._map._container;
	
	  		// make the container focusable by tabbing
	  		if (container.tabIndex <= 0) {
	  			container.tabIndex = '0';
	  		}
	
	  		on(container, {
	  			focus: this._onFocus,
	  			blur: this._onBlur,
	  			mousedown: this._onMouseDown
	  		}, this);
	
	  		this._map.on({
	  			focus: this._addHooks,
	  			blur: this._removeHooks
	  		}, this);
	  	},
	
	  	removeHooks: function () {
	  		this._removeHooks();
	
	  		off(this._map._container, {
	  			focus: this._onFocus,
	  			blur: this._onBlur,
	  			mousedown: this._onMouseDown
	  		}, this);
	
	  		this._map.off({
	  			focus: this._addHooks,
	  			blur: this._removeHooks
	  		}, this);
	  	},
	
	  	_onMouseDown: function () {
	  		if (this._focused) { return; }
	
	  		var body = document.body,
	  		    docEl = document.documentElement,
	  		    top = body.scrollTop || docEl.scrollTop,
	  		    left = body.scrollLeft || docEl.scrollLeft;
	
	  		this._map._container.focus();
	
	  		window.scrollTo(left, top);
	  	},
	
	  	_onFocus: function () {
	  		this._focused = true;
	  		this._map.fire('focus');
	  	},
	
	  	_onBlur: function () {
	  		this._focused = false;
	  		this._map.fire('blur');
	  	},
	
	  	_setPanDelta: function (panDelta) {
	  		var keys = this._panKeys = {},
	  		    codes = this.keyCodes,
	  		    i, len;
	
	  		for (i = 0, len = codes.left.length; i < len; i++) {
	  			keys[codes.left[i]] = [-1 * panDelta, 0];
	  		}
	  		for (i = 0, len = codes.right.length; i < len; i++) {
	  			keys[codes.right[i]] = [panDelta, 0];
	  		}
	  		for (i = 0, len = codes.down.length; i < len; i++) {
	  			keys[codes.down[i]] = [0, panDelta];
	  		}
	  		for (i = 0, len = codes.up.length; i < len; i++) {
	  			keys[codes.up[i]] = [0, -1 * panDelta];
	  		}
	  	},
	
	  	_setZoomDelta: function (zoomDelta) {
	  		var keys = this._zoomKeys = {},
	  		    codes = this.keyCodes,
	  		    i, len;
	
	  		for (i = 0, len = codes.zoomIn.length; i < len; i++) {
	  			keys[codes.zoomIn[i]] = zoomDelta;
	  		}
	  		for (i = 0, len = codes.zoomOut.length; i < len; i++) {
	  			keys[codes.zoomOut[i]] = -zoomDelta;
	  		}
	  	},
	
	  	_addHooks: function () {
	  		on(document, 'keydown', this._onKeyDown, this);
	  	},
	
	  	_removeHooks: function () {
	  		off(document, 'keydown', this._onKeyDown, this);
	  	},
	
	  	_onKeyDown: function (e) {
	  		if (e.altKey || e.ctrlKey || e.metaKey) { return; }
	
	  		var key = e.keyCode,
	  		    map = this._map,
	  		    offset;
	
	  		if (key in this._panKeys) {
	  			if (!map._panAnim || !map._panAnim._inProgress) {
	  				offset = this._panKeys[key];
	  				if (e.shiftKey) {
	  					offset = toPoint(offset).multiplyBy(3);
	  				}
	
	  				if (map.options.maxBounds) {
	  					offset = map._limitOffset(toPoint(offset), map.options.maxBounds);
	  				}
	
	  				if (map.options.worldCopyJump) {
	  					var newLatLng = map.wrapLatLng(map.unproject(map.project(map.getCenter()).add(offset)));
	  					map.panTo(newLatLng);
	  				} else {
	  					map.panBy(offset);
	  				}
	  			}
	  		} else if (key in this._zoomKeys) {
	  			map.setZoom(map.getZoom() + (e.shiftKey ? 3 : 1) * this._zoomKeys[key]);
	
	  		} else if (key === 27 && map._popup && map._popup.options.closeOnEscapeKey) {
	  			map.closePopup();
	
	  		} else {
	  			return;
	  		}
	
	  		stop(e);
	  	}
	  });
	
	  // @section Handlers
	  // @section Handlers
	  // @property keyboard: Handler
	  // Keyboard navigation handler.
	  Map.addInitHook('addHandler', 'keyboard', Keyboard);
	
	  /*
	   * L.Handler.ScrollWheelZoom is used by L.Map to enable mouse scroll wheel zoom on the map.
	   */
	
	  // @namespace Map
	  // @section Interaction Options
	  Map.mergeOptions({
	  	// @section Mouse wheel options
	  	// @option scrollWheelZoom: Boolean|String = true
	  	// Whether the map can be zoomed by using the mouse wheel. If passed `'center'`,
	  	// it will zoom to the center of the view regardless of where the mouse was.
	  	scrollWheelZoom: true,
	
	  	// @option wheelDebounceTime: Number = 40
	  	// Limits the rate at which a wheel can fire (in milliseconds). By default
	  	// user can't zoom via wheel more often than once per 40 ms.
	  	wheelDebounceTime: 40,
	
	  	// @option wheelPxPerZoomLevel: Number = 60
	  	// How many scroll pixels (as reported by [L.DomEvent.getWheelDelta](#domevent-getwheeldelta))
	  	// mean a change of one full zoom level. Smaller values will make wheel-zooming
	  	// faster (and vice versa).
	  	wheelPxPerZoomLevel: 60
	  });
	
	  var ScrollWheelZoom = Handler.extend({
	  	addHooks: function () {
	  		on(this._map._container, 'wheel', this._onWheelScroll, this);
	
	  		this._delta = 0;
	  	},
	
	  	removeHooks: function () {
	  		off(this._map._container, 'wheel', this._onWheelScroll, this);
	  	},
	
	  	_onWheelScroll: function (e) {
	  		var delta = getWheelDelta(e);
	
	  		var debounce = this._map.options.wheelDebounceTime;
	
	  		this._delta += delta;
	  		this._lastMousePos = this._map.mouseEventToContainerPoint(e);
	
	  		if (!this._startTime) {
	  			this._startTime = +new Date();
	  		}
	
	  		var left = Math.max(debounce - (+new Date() - this._startTime), 0);
	
	  		clearTimeout(this._timer);
	  		this._timer = setTimeout(bind(this._performZoom, this), left);
	
	  		stop(e);
	  	},
	
	  	_performZoom: function () {
	  		var map = this._map,
	  		    zoom = map.getZoom(),
	  		    snap = this._map.options.zoomSnap || 0;
	
	  		map._stop(); // stop panning and fly animations if any
	
	  		// map the delta with a sigmoid function to -4..4 range leaning on -1..1
	  		var d2 = this._delta / (this._map.options.wheelPxPerZoomLevel * 4),
	  		    d3 = 4 * Math.log(2 / (1 + Math.exp(-Math.abs(d2)))) / Math.LN2,
	  		    d4 = snap ? Math.ceil(d3 / snap) * snap : d3,
	  		    delta = map._limitZoom(zoom + (this._delta > 0 ? d4 : -d4)) - zoom;
	
	  		this._delta = 0;
	  		this._startTime = null;
	
	  		if (!delta) { return; }
	
	  		if (map.options.scrollWheelZoom === 'center') {
	  			map.setZoom(zoom + delta);
	  		} else {
	  			map.setZoomAround(this._lastMousePos, zoom + delta);
	  		}
	  	}
	  });
	
	  // @section Handlers
	  // @property scrollWheelZoom: Handler
	  // Scroll wheel zoom handler.
	  Map.addInitHook('addHandler', 'scrollWheelZoom', ScrollWheelZoom);
	
	  /*
	   * L.Map.TapHold is used to simulate `contextmenu` event on long hold,
	   * which otherwise is not fired by mobile Safari.
	   */
	
	  var tapHoldDelay = 600;
	
	  // @namespace Map
	  // @section Interaction Options
	  Map.mergeOptions({
	  	// @section Touch interaction options
	  	// @option tapHold: Boolean
	  	// Enables simulation of `contextmenu` event, default is `true` for mobile Safari.
	  	tapHold: Browser.touchNative && Browser.safari && Browser.mobile,
	
	  	// @option tapTolerance: Number = 15
	  	// The max number of pixels a user can shift his finger during touch
	  	// for it to be considered a valid tap.
	  	tapTolerance: 15
	  });
	
	  var TapHold = Handler.extend({
	  	addHooks: function () {
	  		on(this._map._container, 'touchstart', this._onDown, this);
	  	},
	
	  	removeHooks: function () {
	  		off(this._map._container, 'touchstart', this._onDown, this);
	  	},
	
	  	_onDown: function (e) {
	  		clearTimeout(this._holdTimeout);
	  		if (e.touches.length !== 1) { return; }
	
	  		var first = e.touches[0];
	  		this._startPos = this._newPos = new Point(first.clientX, first.clientY);
	
	  		this._holdTimeout = setTimeout(bind(function () {
	  			this._cancel();
	  			if (!this._isTapValid()) { return; }
	
	  			// prevent simulated mouse events https://w3c.github.io/touch-events/#mouse-events
	  			on(document, 'touchend', preventDefault);
	  			on(document, 'touchend touchcancel', this._cancelClickPrevent);
	  			this._simulateEvent('contextmenu', first);
	  		}, this), tapHoldDelay);
	
	  		on(document, 'touchend touchcancel contextmenu', this._cancel, this);
	  		on(document, 'touchmove', this._onMove, this);
	  	},
	
	  	_cancelClickPrevent: function cancelClickPrevent() {
	  		off(document, 'touchend', preventDefault);
	  		off(document, 'touchend touchcancel', cancelClickPrevent);
	  	},
	
	  	_cancel: function () {
	  		clearTimeout(this._holdTimeout);
	  		off(document, 'touchend touchcancel contextmenu', this._cancel, this);
	  		off(document, 'touchmove', this._onMove, this);
	  	},
	
	  	_onMove: function (e) {
	  		var first = e.touches[0];
	  		this._newPos = new Point(first.clientX, first.clientY);
	  	},
	
	  	_isTapValid: function () {
	  		return this._newPos.distanceTo(this._startPos) <= this._map.options.tapTolerance;
	  	},
	
	  	_simulateEvent: function (type, e) {
	  		var simulatedEvent = new MouseEvent(type, {
	  			bubbles: true,
	  			cancelable: true,
	  			view: window,
	  			// detail: 1,
	  			screenX: e.screenX,
	  			screenY: e.screenY,
	  			clientX: e.clientX,
	  			clientY: e.clientY,
	  			// button: 2,
	  			// buttons: 2
	  		});
	
	  		simulatedEvent._simulated = true;
	
	  		e.target.dispatchEvent(simulatedEvent);
	  	}
	  });
	
	  // @section Handlers
	  // @property tapHold: Handler
	  // Long tap handler to simulate `contextmenu` event (useful in mobile Safari).
	  Map.addInitHook('addHandler', 'tapHold', TapHold);
	
	  /*
	   * L.Handler.TouchZoom is used by L.Map to add pinch zoom on supported mobile browsers.
	   */
	
	  // @namespace Map
	  // @section Interaction Options
	  Map.mergeOptions({
	  	// @section Touch interaction options
	  	// @option touchZoom: Boolean|String = *
	  	// Whether the map can be zoomed by touch-dragging with two fingers. If
	  	// passed `'center'`, it will zoom to the center of the view regardless of
	  	// where the touch events (fingers) were. Enabled for touch-capable web
	  	// browsers.
	  	touchZoom: Browser.touch,
	
	  	// @option bounceAtZoomLimits: Boolean = true
	  	// Set it to false if you don't want the map to zoom beyond min/max zoom
	  	// and then bounce back when pinch-zooming.
	  	bounceAtZoomLimits: true
	  });
	
	  var TouchZoom = Handler.extend({
	  	addHooks: function () {
	  		addClass(this._map._container, 'leaflet-touch-zoom');
	  		on(this._map._container, 'touchstart', this._onTouchStart, this);
	  	},
	
	  	removeHooks: function () {
	  		removeClass(this._map._container, 'leaflet-touch-zoom');
	  		off(this._map._container, 'touchstart', this._onTouchStart, this);
	  	},
	
	  	_onTouchStart: function (e) {
	  		var map = this._map;
	  		if (!e.touches || e.touches.length !== 2 || map._animatingZoom || this._zooming) { return; }
	
	  		var p1 = map.mouseEventToContainerPoint(e.touches[0]),
	  		    p2 = map.mouseEventToContainerPoint(e.touches[1]);
	
	  		this._centerPoint = map.getSize()._divideBy(2);
	  		this._startLatLng = map.containerPointToLatLng(this._centerPoint);
	  		if (map.options.touchZoom !== 'center') {
	  			this._pinchStartLatLng = map.containerPointToLatLng(p1.add(p2)._divideBy(2));
	  		}
	
	  		this._startDist = p1.distanceTo(p2);
	  		this._startZoom = map.getZoom();
	
	  		this._moved = false;
	  		this._zooming = true;
	
	  		map._stop();
	
	  		on(document, 'touchmove', this._onTouchMove, this);
	  		on(document, 'touchend touchcancel', this._onTouchEnd, this);
	
	  		preventDefault(e);
	  	},
	
	  	_onTouchMove: function (e) {
	  		if (!e.touches || e.touches.length !== 2 || !this._zooming) { return; }
	
	  		var map = this._map,
	  		    p1 = map.mouseEventToContainerPoint(e.touches[0]),
	  		    p2 = map.mouseEventToContainerPoint(e.touches[1]),
	  		    scale = p1.distanceTo(p2) / this._startDist;
	
	  		this._zoom = map.getScaleZoom(scale, this._startZoom);
	
	  		if (!map.options.bounceAtZoomLimits && (
	  			(this._zoom < map.getMinZoom() && scale < 1) ||
	  			(this._zoom > map.getMaxZoom() && scale > 1))) {
	  			this._zoom = map._limitZoom(this._zoom);
	  		}
	
	  		if (map.options.touchZoom === 'center') {
	  			this._center = this._startLatLng;
	  			if (scale === 1) { return; }
	  		} else {
	  			// Get delta from pinch to center, so centerLatLng is delta applied to initial pinchLatLng
	  			var delta = p1._add(p2)._divideBy(2)._subtract(this._centerPoint);
	  			if (scale === 1 && delta.x === 0 && delta.y === 0) { return; }
	  			this._center = map.unproject(map.project(this._pinchStartLatLng, this._zoom).subtract(delta), this._zoom);
	  		}
	
	  		if (!this._moved) {
	  			map._moveStart(true, false);
	  			this._moved = true;
	  		}
	
	  		cancelAnimFrame(this._animRequest);
	
	  		var moveFn = bind(map._move, map, this._center, this._zoom, {pinch: true, round: false}, undefined);
	  		this._animRequest = requestAnimFrame(moveFn, this, true);
	
	  		preventDefault(e);
	  	},
	
	  	_onTouchEnd: function () {
	  		if (!this._moved || !this._zooming) {
	  			this._zooming = false;
	  			return;
	  		}
	
	  		this._zooming = false;
	  		cancelAnimFrame(this._animRequest);
	
	  		off(document, 'touchmove', this._onTouchMove, this);
	  		off(document, 'touchend touchcancel', this._onTouchEnd, this);
	
	  		// Pinch updates GridLayers' levels only when zoomSnap is off, so zoomSnap becomes noUpdate.
	  		if (this._map.options.zoomAnimation) {
	  			this._map._animateZoom(this._center, this._map._limitZoom(this._zoom), true, this._map.options.zoomSnap);
	  		} else {
	  			this._map._resetView(this._center, this._map._limitZoom(this._zoom));
	  		}
	  	}
	  });
	
	  // @section Handlers
	  // @property touchZoom: Handler
	  // Touch zoom handler.
	  Map.addInitHook('addHandler', 'touchZoom', TouchZoom);
	
	  Map.BoxZoom = BoxZoom;
	  Map.DoubleClickZoom = DoubleClickZoom;
	  Map.Drag = Drag;
	  Map.Keyboard = Keyboard;
	  Map.ScrollWheelZoom = ScrollWheelZoom;
	  Map.TapHold = TapHold;
	  Map.TouchZoom = TouchZoom;
	
	  exports.Bounds = Bounds;
	  exports.Browser = Browser;
	  exports.CRS = CRS;
	  exports.Canvas = Canvas;
	  exports.Circle = Circle;
	  exports.CircleMarker = CircleMarker;
	  exports.Class = Class;
	  exports.Control = Control;
	  exports.DivIcon = DivIcon;
	  exports.DivOverlay = DivOverlay;
	  exports.DomEvent = DomEvent;
	  exports.DomUtil = DomUtil;
	  exports.Draggable = Draggable;
	  exports.Evented = Evented;
	  exports.FeatureGroup = FeatureGroup;
	  exports.GeoJSON = GeoJSON;
	  exports.GridLayer = GridLayer;
	  exports.Handler = Handler;
	  exports.Icon = Icon;
	  exports.ImageOverlay = ImageOverlay;
	  exports.LatLng = LatLng;
	  exports.LatLngBounds = LatLngBounds;
	  exports.Layer = Layer;
	  exports.LayerGroup = LayerGroup;
	  exports.LineUtil = LineUtil;
	  exports.Map = Map;
	  exports.Marker = Marker;
	  exports.Mixin = Mixin;
	  exports.Path = Path;
	  exports.Point = Point;
	  exports.PolyUtil = PolyUtil;
	  exports.Polygon = Polygon;
	  exports.Polyline = Polyline;
	  exports.Popup = Popup;
	  exports.PosAnimation = PosAnimation;
	  exports.Projection = index;
	  exports.Rectangle = Rectangle;
	  exports.Renderer = Renderer;
	  exports.SVG = SVG;
	  exports.SVGOverlay = SVGOverlay;
	  exports.TileLayer = TileLayer;
	  exports.Tooltip = Tooltip;
	  exports.Transformation = Transformation;
	  exports.Util = Util;
	  exports.VideoOverlay = VideoOverlay;
	  exports.bind = bind;
	  exports.bounds = toBounds;
	  exports.canvas = canvas;
	  exports.circle = circle;
	  exports.circleMarker = circleMarker;
	  exports.control = control;
	  exports.divIcon = divIcon;
	  exports.extend = extend;
	  exports.featureGroup = featureGroup;
	  exports.geoJSON = geoJSON;
	  exports.geoJson = geoJson;
	  exports.gridLayer = gridLayer;
	  exports.icon = icon;
	  exports.imageOverlay = imageOverlay;
	  exports.latLng = toLatLng;
	  exports.latLngBounds = toLatLngBounds;
	  exports.layerGroup = layerGroup;
	  exports.map = createMap;
	  exports.marker = marker;
	  exports.point = toPoint;
	  exports.polygon = polygon;
	  exports.polyline = polyline;
	  exports.popup = popup;
	  exports.rectangle = rectangle;
	  exports.setOptions = setOptions;
	  exports.stamp = stamp;
	  exports.svg = svg;
	  exports.svgOverlay = svgOverlay;
	  exports.tileLayer = tileLayer;
	  exports.tooltip = tooltip;
	  exports.transformation = toTransformation;
	  exports.version = version;
	  exports.videoOverlay = videoOverlay;
	
	  var oldL = window.L;
	  exports.noConflict = function() {
	  	window.L = oldL;
	  	return this;
	  }
	  // Always export us to window global (see #2364)
	  window.L = exports;
	
	}));
	//# sourceMappingURL=leaflet-src.js.map


/***/ }),
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */
/***/ (function(module, exports) {

	module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 197 */
/***/ (function(module, exports) {

	module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(44);
	var TAG = __webpack_require__(10)('toStringTag');
	// ES3 wrong here
	var ARG = cof(function () { return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function (it, key) {
	  try {
	    return it[key];
	  } catch (e) { /* empty */ }
	};
	
	module.exports = function (it) {
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};


/***/ }),
/* 202 */
/***/ (function(module, exports) {

	module.exports = {};


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

	var def = __webpack_require__(16).f;
	var has = __webpack_require__(36);
	var TAG = __webpack_require__(10)('toStringTag');
	
	module.exports = function (it, tag, stat) {
	  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
	};


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(3);
	var defined = __webpack_require__(67);
	var fails = __webpack_require__(6);
	var spaces = __webpack_require__(724);
	var space = '[' + spaces + ']';
	var non = '\u200b\u0085';
	var ltrim = RegExp('^' + space + space + '*');
	var rtrim = RegExp(space + space + '*$');
	
	var exporter = function (KEY, exec, ALIAS) {
	  var exp = {};
	  var FORCE = fails(function () {
	    return !!spaces[KEY]() || non[KEY]() != non;
	  });
	  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
	  if (ALIAS) exp[ALIAS] = fn;
	  $export($export.P + $export.F * FORCE, 'String', exp);
	};
	
	// 1 -> String#trimLeft
	// 2 -> String#trimRight
	// 3 -> String#trim
	var trim = exporter.trim = function (string, TYPE) {
	  string = String(defined(string));
	  if (TYPE & 1) string = string.replace(ltrim, '');
	  if (TYPE & 2) string = string.replace(rtrim, '');
	  return string;
	};
	
	module.exports = exporter;


/***/ }),
/* 205 */
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['$q', '$http', '$translate', 'apiService', 'lbDialogService', '$state'];
	
	var settingsService = function settingsService($q, $http, $translate, apiService, lbDialogService, $state) {
	  var service = {};
	
	  service.settings = null;
	  service.getAny = getAny;
	  service.get = get;
	  service.clear = clear;
	  service.isOneWayFare = isOneWayFare;
	  service.getRailCards = getRailCards;
	  service.currencyCode = currencyCode;
	  service.getHotelPaymentNarrativesByIds = getHotelPaymentNarrativesByIds;
	  service.isUnusedCreditEnabled = isUnusedCreditEnabled;
	  service.isDefaultCostCenter = isDefaultCostCenter;
	
	  var isFetching = false; // flag to indicate whether get() is already running
	  var deferred = undefined; // promise to return if get() is already running
	
	  function getAny() {
	    if (service.settings) {
	      var deferredGetAny = $q.defer();
	      deferredGetAny.resolve(service.settings);
	      return deferredGetAny.promise;
	    } else {
	      return get();
	    }
	  }
	
	  function get(force) {
	    if (isFetching) return deferred.promise;
	
	    isFetching = true;
	    deferred = $q.defer();
	    var apiUrl = apiService.getUrl('settings') + (force ? '?force=true' : '');
	
	    $http.get(apiUrl).success(function (data) {
	      service.settings = data;
	      data.Locale = 'en-US';
	      data.Countries = [{
	        Code: 'US',
	        Name: 'United States of America',
	        Valid: true,
	        DisplayOrder: 1
	      }, {
	        Code: 'AF',
	        Name: 'Afghanistan',
	        Valid: true,
	        DisplayOrder: 2
	      }, {
	        Code: 'AX',
	        Name: 'Åland Islands',
	        Valid: true,
	        DisplayOrder: 3
	      }, {
	        Code: 'AL',
	        Name: 'Albania',
	        Valid: true,
	        DisplayOrder: 4
	      }, {
	        Code: 'DZ',
	        Name: 'Algeria',
	        Valid: true,
	        DisplayOrder: 5
	      }, {
	        Code: 'AS',
	        Name: 'American Samoa',
	        Valid: true,
	        DisplayOrder: 6
	      }, {
	        Code: 'AD',
	        Name: 'Andorra',
	        Valid: true,
	        DisplayOrder: 7
	      }, {
	        Code: 'AO',
	        Name: 'Angola',
	        Valid: true,
	        DisplayOrder: 8
	      }, {
	        Code: 'AI',
	        Name: 'Anguilla',
	        Valid: true,
	        DisplayOrder: 9
	      }, {
	        Code: 'AQ',
	        Name: 'Antarctica',
	        Valid: true,
	        DisplayOrder: 10
	      }, {
	        Code: 'AG',
	        Name: 'Antigua and Barbuda',
	        Valid: true,
	        DisplayOrder: 11
	      }, {
	        Code: 'AR',
	        Name: 'Argentina',
	        Valid: true,
	        DisplayOrder: 12
	      }, {
	        Code: 'AM',
	        Name: 'Armenia',
	        Valid: true,
	        DisplayOrder: 13
	      }, {
	        Code: 'AW',
	        Name: 'Aruba',
	        Valid: true,
	        DisplayOrder: 14
	      }, {
	        Code: 'AU',
	        Name: 'Australia',
	        Valid: true,
	        DisplayOrder: 15
	      }, {
	        Code: 'AT',
	        Name: 'Austria',
	        Valid: true,
	        DisplayOrder: 16
	      }, {
	        Code: 'AZ',
	        Name: 'Azerbaijan',
	        Valid: true,
	        DisplayOrder: 17
	      }, {
	        Code: 'BS',
	        Name: 'Bahamas',
	        Valid: true,
	        DisplayOrder: 18
	      }, {
	        Code: 'BH',
	        Name: 'Bahrain',
	        Valid: true,
	        DisplayOrder: 19
	      }, {
	        Code: 'BD',
	        Name: 'Bangladesh',
	        Valid: true,
	        DisplayOrder: 20
	      }, {
	        Code: 'BB',
	        Name: 'Barbados',
	        Valid: true,
	        DisplayOrder: 21
	      }, {
	        Code: 'BY',
	        Name: 'Belarus',
	        Valid: true,
	        DisplayOrder: 22
	      }, {
	        Code: 'BE',
	        Name: 'Belgium',
	        Valid: true,
	        DisplayOrder: 23
	      }, {
	        Code: 'BZ',
	        Name: 'Belize',
	        Valid: true,
	        DisplayOrder: 24
	      }, {
	        Code: 'BJ',
	        Name: 'Benin',
	        Valid: true,
	        DisplayOrder: 25
	      }, {
	        Code: 'BM',
	        Name: 'Bermuda',
	        Valid: true,
	        DisplayOrder: 26
	      }, {
	        Code: 'BT',
	        Name: 'Bhutan',
	        Valid: true,
	        DisplayOrder: 27
	      }, {
	        Code: 'BO',
	        Name: 'Bolivia (Plurinational State of)',
	        Valid: true,
	        DisplayOrder: 28
	      }, {
	        Code: 'BQ',
	        Name: 'Bonaire, Sint Eustatius and Saba',
	        Valid: true,
	        DisplayOrder: 29
	      }, {
	        Code: 'BA',
	        Name: 'Bosnia and Herzegovina',
	        Valid: true,
	        DisplayOrder: 30
	      }, {
	        Code: 'BW',
	        Name: 'Botswana',
	        Valid: true,
	        DisplayOrder: 31
	      }, {
	        Code: 'BV',
	        Name: 'Bouvet Island',
	        Valid: true,
	        DisplayOrder: 32
	      }, {
	        Code: 'BR',
	        Name: 'Brazil',
	        Valid: true,
	        DisplayOrder: 33
	      }, {
	        Code: 'IO',
	        Name: 'British Indian Ocean Territory',
	        Valid: true,
	        DisplayOrder: 34
	      }, {
	        Code: 'BN',
	        Name: 'Brunei Darussalam',
	        Valid: true,
	        DisplayOrder: 35
	      }, {
	        Code: 'BG',
	        Name: 'Bulgaria',
	        Valid: true,
	        DisplayOrder: 36
	      }, {
	        Code: 'BF',
	        Name: 'Burkina Faso',
	        Valid: true,
	        DisplayOrder: 37
	      }, {
	        Code: 'BI',
	        Name: 'Burundi',
	        Valid: true,
	        DisplayOrder: 38
	      }, {
	        Code: 'CV',
	        Name: 'Cabo Verde',
	        Valid: true,
	        DisplayOrder: 39
	      }, {
	        Code: 'KH',
	        Name: 'Cambodia',
	        Valid: true,
	        DisplayOrder: 40
	      }, {
	        Code: 'CM',
	        Name: 'Cameroon',
	        Valid: true,
	        DisplayOrder: 41
	      }, {
	        Code: 'CA',
	        Name: 'Canada',
	        Valid: true,
	        DisplayOrder: 42
	      }, {
	        Code: 'KY',
	        Name: 'Cayman Islands',
	        Valid: true,
	        DisplayOrder: 43
	      }, {
	        Code: 'CF',
	        Name: 'Central African Republic',
	        Valid: true,
	        DisplayOrder: 44
	      }, {
	        Code: 'TD',
	        Name: 'Chad',
	        Valid: true,
	        DisplayOrder: 45
	      }, {
	        Code: 'CL',
	        Name: 'Chile',
	        Valid: true,
	        DisplayOrder: 46
	      }, {
	        Code: 'CN',
	        Name: 'China',
	        Valid: true,
	        DisplayOrder: 47
	      }, {
	        Code: 'CX',
	        Name: 'Christmas Island',
	        Valid: true,
	        DisplayOrder: 48
	      }, {
	        Code: 'CC',
	        Name: 'Cocos (Keeling) Islands',
	        Valid: true,
	        DisplayOrder: 49
	      }, {
	        Code: 'CO',
	        Name: 'Colombia',
	        Valid: true,
	        DisplayOrder: 50
	      }, {
	        Code: 'KM',
	        Name: 'Comoros',
	        Valid: true,
	        DisplayOrder: 51
	      }, {
	        Code: 'CG',
	        Name: 'Congo',
	        Valid: true,
	        DisplayOrder: 52
	      }, {
	        Code: 'CD',
	        Name: 'Congo (Democratic Republic of the)',
	        Valid: true,
	        DisplayOrder: 53
	      }, {
	        Code: 'CK',
	        Name: 'Cook Islands',
	        Valid: true,
	        DisplayOrder: 54
	      }, {
	        Code: 'CR',
	        Name: 'Costa Rica',
	        Valid: true,
	        DisplayOrder: 55
	      }, {
	        Code: 'CI',
	        Name: "Côte d'Ivoire",
	        Valid: true,
	        DisplayOrder: 56
	      }, {
	        Code: 'HR',
	        Name: 'Croatia',
	        Valid: true,
	        DisplayOrder: 57
	      }, {
	        Code: 'CU',
	        Name: 'Cuba',
	        Valid: true,
	        DisplayOrder: 58
	      }, {
	        Code: 'CW',
	        Name: 'Curaçao',
	        Valid: true,
	        DisplayOrder: 59
	      }, {
	        Code: 'CY',
	        Name: 'Cyprus',
	        Valid: true,
	        DisplayOrder: 60
	      }, {
	        Code: 'CZ',
	        Name: 'Czechia',
	        Valid: true,
	        DisplayOrder: 61
	      }, {
	        Code: 'DK',
	        Name: 'Denmark',
	        Valid: true,
	        DisplayOrder: 62
	      }, {
	        Code: 'DJ',
	        Name: 'Djibouti',
	        Valid: true,
	        DisplayOrder: 63
	      }, {
	        Code: 'DM',
	        Name: 'Dominica',
	        Valid: true,
	        DisplayOrder: 64
	      }, {
	        Code: 'DO',
	        Name: 'Dominican Republic',
	        Valid: true,
	        DisplayOrder: 65
	      }, {
	        Code: 'EC',
	        Name: 'Ecuador',
	        Valid: true,
	        DisplayOrder: 66
	      }, {
	        Code: 'EG',
	        Name: 'Egypt',
	        Valid: true,
	        DisplayOrder: 67
	      }, {
	        Code: 'SV',
	        Name: 'El Salvador',
	        Valid: true,
	        DisplayOrder: 68
	      }, {
	        Code: 'GQ',
	        Name: 'Equatorial Guinea',
	        Valid: true,
	        DisplayOrder: 69
	      }, {
	        Code: 'ER',
	        Name: 'Eritrea',
	        Valid: true,
	        DisplayOrder: 70
	      }, {
	        Code: 'EE',
	        Name: 'Estonia',
	        Valid: true,
	        DisplayOrder: 71
	      }, {
	        Code: 'ET',
	        Name: 'Ethiopia',
	        Valid: true,
	        DisplayOrder: 72
	      }, {
	        Code: 'FK',
	        Name: 'Falkland Islands (Malvinas)',
	        Valid: true,
	        DisplayOrder: 73
	      }, {
	        Code: 'FO',
	        Name: 'Faroe Islands',
	        Valid: true,
	        DisplayOrder: 74
	      }, {
	        Code: 'FJ',
	        Name: 'Fiji',
	        Valid: true,
	        DisplayOrder: 75
	      }, {
	        Code: 'FI',
	        Name: 'Finland',
	        Valid: true,
	        DisplayOrder: 76
	      }, {
	        Code: 'FR',
	        Name: 'France',
	        Valid: true,
	        DisplayOrder: 77
	      }, {
	        Code: 'GF',
	        Name: 'French Guiana',
	        Valid: true,
	        DisplayOrder: 78
	      }, {
	        Code: 'PF',
	        Name: 'French Polynesia',
	        Valid: true,
	        DisplayOrder: 79
	      }, {
	        Code: 'TF',
	        Name: 'French Southern Territories',
	        Valid: true,
	        DisplayOrder: 80
	      }, {
	        Code: 'GA',
	        Name: 'Gabon',
	        Valid: true,
	        DisplayOrder: 81
	      }, {
	        Code: 'GM',
	        Name: 'Gambia',
	        Valid: true,
	        DisplayOrder: 82
	      }, {
	        Code: 'GE',
	        Name: 'Georgia',
	        Valid: true,
	        DisplayOrder: 83
	      }, {
	        Code: 'DE',
	        Name: 'Germany',
	        Valid: true,
	        DisplayOrder: 84
	      }, {
	        Code: 'GH',
	        Name: 'Ghana',
	        Valid: true,
	        DisplayOrder: 85
	      }, {
	        Code: 'GI',
	        Name: 'Gibraltar',
	        Valid: true,
	        DisplayOrder: 86
	      }, {
	        Code: 'GR',
	        Name: 'Greece',
	        Valid: true,
	        DisplayOrder: 87
	      }, {
	        Code: 'GL',
	        Name: 'Greenland',
	        Valid: true,
	        DisplayOrder: 88
	      }, {
	        Code: 'GD',
	        Name: 'Grenada',
	        Valid: true,
	        DisplayOrder: 89
	      }, {
	        Code: 'GP',
	        Name: 'Guadeloupe',
	        Valid: true,
	        DisplayOrder: 90
	      }, {
	        Code: 'GU',
	        Name: 'Guam',
	        Valid: true,
	        DisplayOrder: 91
	      }, {
	        Code: 'GT',
	        Name: 'Guatemala',
	        Valid: true,
	        DisplayOrder: 92
	      }, {
	        Code: 'GG',
	        Name: 'Guernsey',
	        Valid: true,
	        DisplayOrder: 93
	      }, {
	        Code: 'GN',
	        Name: 'Guinea',
	        Valid: true,
	        DisplayOrder: 94
	      }, {
	        Code: 'GW',
	        Name: 'Guinea-Bissau',
	        Valid: true,
	        DisplayOrder: 95
	      }, {
	        Code: 'GY',
	        Name: 'Guyana',
	        Valid: true,
	        DisplayOrder: 96
	      }, {
	        Code: 'HT',
	        Name: 'Haiti',
	        Valid: true,
	        DisplayOrder: 97
	      }, {
	        Code: 'HM',
	        Name: 'Heard Island and McDonald Islands',
	        Valid: true,
	        DisplayOrder: 98
	      }, {
	        Code: 'VA',
	        Name: 'Holy See',
	        Valid: true,
	        DisplayOrder: 99
	      }, {
	        Code: 'HN',
	        Name: 'Honduras',
	        Valid: true,
	        DisplayOrder: 100
	      }, {
	        Code: 'HK',
	        Name: 'Hong Kong',
	        Valid: true,
	        DisplayOrder: 101
	      }, {
	        Code: 'HU',
	        Name: 'Hungary',
	        Valid: true,
	        DisplayOrder: 102
	      }, {
	        Code: 'IS',
	        Name: 'Iceland',
	        Valid: true,
	        DisplayOrder: 103
	      }, {
	        Code: 'IN',
	        Name: 'India',
	        Valid: true,
	        DisplayOrder: 104
	      }, {
	        Code: 'ID',
	        Name: 'Indonesia',
	        Valid: true,
	        DisplayOrder: 105
	      }, {
	        Code: 'IR',
	        Name: 'Iran (Islamic Republic of)',
	        Valid: true,
	        DisplayOrder: 106
	      }, {
	        Code: 'IQ',
	        Name: 'Iraq',
	        Valid: true,
	        DisplayOrder: 107
	      }, {
	        Code: 'IE',
	        Name: 'Ireland',
	        Valid: true,
	        DisplayOrder: 108
	      }, {
	        Code: 'IM',
	        Name: 'Isle of Man',
	        Valid: true,
	        DisplayOrder: 109
	      }, {
	        Code: 'IL',
	        Name: 'Israel',
	        Valid: true,
	        DisplayOrder: 110
	      }, {
	        Code: 'IT',
	        Name: 'Italy',
	        Valid: true,
	        DisplayOrder: 111
	      }, {
	        Code: 'JM',
	        Name: 'Jamaica',
	        Valid: true,
	        DisplayOrder: 112
	      }, {
	        Code: 'JP',
	        Name: 'Japan',
	        Valid: true,
	        DisplayOrder: 113
	      }, {
	        Code: 'JE',
	        Name: 'Jersey',
	        Valid: true,
	        DisplayOrder: 114
	      }, {
	        Code: 'JO',
	        Name: 'Jordan',
	        Valid: true,
	        DisplayOrder: 115
	      }, {
	        Code: 'KZ',
	        Name: 'Kazakhstan',
	        Valid: true,
	        DisplayOrder: 116
	      }, {
	        Code: 'KE',
	        Name: 'Kenya',
	        Valid: true,
	        DisplayOrder: 117
	      }, {
	        Code: 'KI',
	        Name: 'Kiribati',
	        Valid: true,
	        DisplayOrder: 118
	      }, {
	        Code: 'KP',
	        Name: "Korea (Democratic People's Republic of)",
	        Valid: true,
	        DisplayOrder: 119
	      }, {
	        Code: 'KR',
	        Name: 'Korea (Republic of)',
	        Valid: true,
	        DisplayOrder: 120
	      }, {
	        Code: 'KW',
	        Name: 'Kuwait',
	        Valid: true,
	        DisplayOrder: 121
	      }, {
	        Code: 'KG',
	        Name: 'Kyrgyzstan',
	        Valid: true,
	        DisplayOrder: 122
	      }, {
	        Code: 'LA',
	        Name: "Lao People's Democratic Republic",
	        Valid: true,
	        DisplayOrder: 123
	      }, {
	        Code: 'LV',
	        Name: 'Latvia',
	        Valid: true,
	        DisplayOrder: 124
	      }, {
	        Code: 'LB',
	        Name: 'Lebanon',
	        Valid: true,
	        DisplayOrder: 125
	      }, {
	        Code: 'LS',
	        Name: 'Lesotho',
	        Valid: true,
	        DisplayOrder: 126
	      }, {
	        Code: 'LR',
	        Name: 'Liberia',
	        Valid: true,
	        DisplayOrder: 127
	      }, {
	        Code: 'LY',
	        Name: 'Libya',
	        Valid: true,
	        DisplayOrder: 128
	      }, {
	        Code: 'LI',
	        Name: 'Liechtenstein',
	        Valid: true,
	        DisplayOrder: 129
	      }, {
	        Code: 'LT',
	        Name: 'Lithuania',
	        Valid: true,
	        DisplayOrder: 130
	      }, {
	        Code: 'LU',
	        Name: 'Luxembourg',
	        Valid: true,
	        DisplayOrder: 131
	      }, {
	        Code: 'MO',
	        Name: 'Macao',
	        Valid: true,
	        DisplayOrder: 132
	      }, {
	        Code: 'MK',
	        Name: 'Macedonia (the former Yugoslav Republic of)',
	        Valid: true,
	        DisplayOrder: 133
	      }, {
	        Code: 'MG',
	        Name: 'Madagascar',
	        Valid: true,
	        DisplayOrder: 134
	      }, {
	        Code: 'MW',
	        Name: 'Malawi',
	        Valid: true,
	        DisplayOrder: 135
	      }, {
	        Code: 'MY',
	        Name: 'Malaysia',
	        Valid: true,
	        DisplayOrder: 136
	      }, {
	        Code: 'MV',
	        Name: 'Maldives',
	        Valid: true,
	        DisplayOrder: 137
	      }, {
	        Code: 'ML',
	        Name: 'Mali',
	        Valid: true,
	        DisplayOrder: 138
	      }, {
	        Code: 'MT',
	        Name: 'Malta',
	        Valid: true,
	        DisplayOrder: 139
	      }, {
	        Code: 'MH',
	        Name: 'Marshall Islands',
	        Valid: true,
	        DisplayOrder: 140
	      }, {
	        Code: 'MQ',
	        Name: 'Martinique',
	        Valid: true,
	        DisplayOrder: 141
	      }, {
	        Code: 'MR',
	        Name: 'Mauritania',
	        Valid: true,
	        DisplayOrder: 142
	      }, {
	        Code: 'MU',
	        Name: 'Mauritius',
	        Valid: true,
	        DisplayOrder: 143
	      }, {
	        Code: 'YT',
	        Name: 'Mayotte',
	        Valid: true,
	        DisplayOrder: 144
	      }, {
	        Code: 'MX',
	        Name: 'Mexico',
	        Valid: true,
	        DisplayOrder: 145
	      }, {
	        Code: 'FM',
	        Name: 'Micronesia (Federated States of)',
	        Valid: true,
	        DisplayOrder: 146
	      }, {
	        Code: 'MD',
	        Name: 'Moldova (Republic of)',
	        Valid: true,
	        DisplayOrder: 147
	      }, {
	        Code: 'MC',
	        Name: 'Monaco',
	        Valid: true,
	        DisplayOrder: 148
	      }, {
	        Code: 'MN',
	        Name: 'Mongolia',
	        Valid: true,
	        DisplayOrder: 149
	      }, {
	        Code: 'ME',
	        Name: 'Montenegro',
	        Valid: true,
	        DisplayOrder: 150
	      }, {
	        Code: 'MS',
	        Name: 'Montserrat',
	        Valid: true,
	        DisplayOrder: 151
	      }, {
	        Code: 'MA',
	        Name: 'Morocco',
	        Valid: true,
	        DisplayOrder: 152
	      }, {
	        Code: 'MZ',
	        Name: 'Mozambique',
	        Valid: true,
	        DisplayOrder: 153
	      }, {
	        Code: 'MM',
	        Name: 'Myanmar',
	        Valid: true,
	        DisplayOrder: 154
	      }, {
	        Code: 'NA',
	        Name: 'Namibia',
	        Valid: true,
	        DisplayOrder: 155
	      }, {
	        Code: 'NR',
	        Name: 'Nauru',
	        Valid: true,
	        DisplayOrder: 156
	      }, {
	        Code: 'NP',
	        Name: 'Nepal',
	        Valid: true,
	        DisplayOrder: 157
	      }, {
	        Code: 'NL',
	        Name: 'Netherlands',
	        Valid: true,
	        DisplayOrder: 158
	      }, {
	        Code: 'NC',
	        Name: 'New Caledonia',
	        Valid: true,
	        DisplayOrder: 159
	      }, {
	        Code: 'NZ',
	        Name: 'New Zealand',
	        Valid: true,
	        DisplayOrder: 160
	      }, {
	        Code: 'NI',
	        Name: 'Nicaragua',
	        Valid: true,
	        DisplayOrder: 161
	      }, {
	        Code: 'NE',
	        Name: 'Niger',
	        Valid: true,
	        DisplayOrder: 162
	      }, {
	        Code: 'NG',
	        Name: 'Nigeria',
	        Valid: true,
	        DisplayOrder: 163
	      }, {
	        Code: 'NU',
	        Name: 'Niue',
	        Valid: true,
	        DisplayOrder: 164
	      }, {
	        Code: 'NF',
	        Name: 'Norfolk Island',
	        Valid: true,
	        DisplayOrder: 165
	      }, {
	        Code: 'MP',
	        Name: 'Northern Mariana Islands',
	        Valid: true,
	        DisplayOrder: 166
	      }, {
	        Code: 'NO',
	        Name: 'Norway',
	        Valid: true,
	        DisplayOrder: 167
	      }, {
	        Code: 'OM',
	        Name: 'Oman',
	        Valid: true,
	        DisplayOrder: 168
	      }, {
	        Code: 'PK',
	        Name: 'Pakistan',
	        Valid: true,
	        DisplayOrder: 169
	      }, {
	        Code: 'PW',
	        Name: 'Palau',
	        Valid: true,
	        DisplayOrder: 170
	      }, {
	        Code: 'PS',
	        Name: 'Palestine, State of',
	        Valid: true,
	        DisplayOrder: 171
	      }, {
	        Code: 'PA',
	        Name: 'Panama',
	        Valid: true,
	        DisplayOrder: 172
	      }, {
	        Code: 'PG',
	        Name: 'Papua New Guinea',
	        Valid: true,
	        DisplayOrder: 173
	      }, {
	        Code: 'PY',
	        Name: 'Paraguay',
	        Valid: true,
	        DisplayOrder: 174
	      }, {
	        Code: 'PE',
	        Name: 'Peru',
	        Valid: true,
	        DisplayOrder: 175
	      }, {
	        Code: 'PH',
	        Name: 'Philippines',
	        Valid: true,
	        DisplayOrder: 176
	      }, {
	        Code: 'PN',
	        Name: 'Pitcairn',
	        Valid: true,
	        DisplayOrder: 177
	      }, {
	        Code: 'PL',
	        Name: 'Poland',
	        Valid: true,
	        DisplayOrder: 178
	      }, {
	        Code: 'PT',
	        Name: 'Portugal',
	        Valid: true,
	        DisplayOrder: 179
	      }, {
	        Code: 'PR',
	        Name: 'Puerto Rico',
	        Valid: true,
	        DisplayOrder: 180
	      }, {
	        Code: 'QA',
	        Name: 'Qatar',
	        Valid: true,
	        DisplayOrder: 181
	      }, {
	        Code: 'RE',
	        Name: 'Réunion',
	        Valid: true,
	        DisplayOrder: 182
	      }, {
	        Code: 'RO',
	        Name: 'Romania',
	        Valid: true,
	        DisplayOrder: 183
	      }, {
	        Code: 'RU',
	        Name: 'Russian Federation',
	        Valid: true,
	        DisplayOrder: 184
	      }, {
	        Code: 'RW',
	        Name: 'Rwanda',
	        Valid: true,
	        DisplayOrder: 185
	      }, {
	        Code: 'BL',
	        Name: 'Saint Barthélemy',
	        Valid: true,
	        DisplayOrder: 186
	      }, {
	        Code: 'SH',
	        Name: 'Saint Helena, Ascension and Tristan da Cunha',
	        Valid: true,
	        DisplayOrder: 187
	      }, {
	        Code: 'KN',
	        Name: 'Saint Kitts and Nevis',
	        Valid: true,
	        DisplayOrder: 188
	      }, {
	        Code: 'LC',
	        Name: 'Saint Lucia',
	        Valid: true,
	        DisplayOrder: 189
	      }, {
	        Code: 'MF',
	        Name: 'Saint Martin (French part)',
	        Valid: true,
	        DisplayOrder: 190
	      }, {
	        Code: 'PM',
	        Name: 'Saint Pierre and Miquelon',
	        Valid: true,
	        DisplayOrder: 191
	      }, {
	        Code: 'VC',
	        Name: 'Saint Vincent and the Grenadines',
	        Valid: true,
	        DisplayOrder: 192
	      }, {
	        Code: 'WS',
	        Name: 'Samoa',
	        Valid: true,
	        DisplayOrder: 193
	      }, {
	        Code: 'SM',
	        Name: 'San Marino',
	        Valid: true,
	        DisplayOrder: 194
	      }, {
	        Code: 'ST',
	        Name: 'Sao Tome and Principe',
	        Valid: true,
	        DisplayOrder: 195
	      }, {
	        Code: 'SA',
	        Name: 'Saudi Arabia',
	        Valid: true,
	        DisplayOrder: 196
	      }, {
	        Code: 'SN',
	        Name: 'Senegal',
	        Valid: true,
	        DisplayOrder: 197
	      }, {
	        Code: 'RS',
	        Name: 'Serbia',
	        Valid: true,
	        DisplayOrder: 198
	      }, {
	        Code: 'SC',
	        Name: 'Seychelles',
	        Valid: true,
	        DisplayOrder: 199
	      }, {
	        Code: 'SL',
	        Name: 'Sierra Leone',
	        Valid: true,
	        DisplayOrder: 200
	      }, {
	        Code: 'SG',
	        Name: 'Singapore',
	        Valid: true,
	        DisplayOrder: 201
	      }, {
	        Code: 'SX',
	        Name: 'Sint Maarten (Dutch part)',
	        Valid: true,
	        DisplayOrder: 202
	      }, {
	        Code: 'SK',
	        Name: 'Slovakia',
	        Valid: true,
	        DisplayOrder: 203
	      }, {
	        Code: 'SI',
	        Name: 'Slovenia',
	        Valid: true,
	        DisplayOrder: 204
	      }, {
	        Code: 'SB',
	        Name: 'Solomon Islands',
	        Valid: true,
	        DisplayOrder: 205
	      }, {
	        Code: 'SO',
	        Name: 'Somalia',
	        Valid: true,
	        DisplayOrder: 206
	      }, {
	        Code: 'ZA',
	        Name: 'South Africa',
	        Valid: true,
	        DisplayOrder: 207
	      }, {
	        Code: 'GS',
	        Name: 'South Georgia and the South Sandwich Islands',
	        Valid: true,
	        DisplayOrder: 208
	      }, {
	        Code: 'SS',
	        Name: 'South Sudan',
	        Valid: true,
	        DisplayOrder: 209
	      }, {
	        Code: 'ES',
	        Name: 'Spain',
	        Valid: true,
	        DisplayOrder: 210
	      }, {
	        Code: 'LK',
	        Name: 'Sri Lanka',
	        Valid: true,
	        DisplayOrder: 211
	      }, {
	        Code: 'SD',
	        Name: 'Sudan',
	        Valid: true,
	        DisplayOrder: 212
	      }, {
	        Code: 'SR',
	        Name: 'Suriname',
	        Valid: true,
	        DisplayOrder: 213
	      }, {
	        Code: 'SJ',
	        Name: 'Svalbard and Jan Mayen',
	        Valid: true,
	        DisplayOrder: 214
	      }, {
	        Code: 'SZ',
	        Name: 'Swaziland',
	        Valid: true,
	        DisplayOrder: 215
	      }, {
	        Code: 'SE',
	        Name: 'Sweden',
	        Valid: true,
	        DisplayOrder: 216
	      }, {
	        Code: 'CH',
	        Name: 'Switzerland',
	        Valid: true,
	        DisplayOrder: 217
	      }, {
	        Code: 'SY',
	        Name: 'Syrian Arab Republic',
	        Valid: true,
	        DisplayOrder: 218
	      }, {
	        Code: 'TW',
	        Name: 'Taiwan, Province of China',
	        Valid: true,
	        DisplayOrder: 219
	      }, {
	        Code: 'TJ',
	        Name: 'Tajikistan',
	        Valid: true,
	        DisplayOrder: 220
	      }, {
	        Code: 'TZ',
	        Name: 'Tanzania, United Republic of',
	        Valid: true,
	        DisplayOrder: 221
	      }, {
	        Code: 'TH',
	        Name: 'Thailand',
	        Valid: true,
	        DisplayOrder: 222
	      }, {
	        Code: 'TL',
	        Name: 'Timor-Leste',
	        Valid: true,
	        DisplayOrder: 223
	      }, {
	        Code: 'TG',
	        Name: 'Togo',
	        Valid: true,
	        DisplayOrder: 224
	      }, {
	        Code: 'TK',
	        Name: 'Tokelau',
	        Valid: true,
	        DisplayOrder: 225
	      }, {
	        Code: 'TO',
	        Name: 'Tonga',
	        Valid: true,
	        DisplayOrder: 226
	      }, {
	        Code: 'TT',
	        Name: 'Trinidad and Tobago',
	        Valid: true,
	        DisplayOrder: 227
	      }, {
	        Code: 'TN',
	        Name: 'Tunisia',
	        Valid: true,
	        DisplayOrder: 228
	      }, {
	        Code: 'TR',
	        Name: 'Turkey',
	        Valid: true,
	        DisplayOrder: 229
	      }, {
	        Code: 'TM',
	        Name: 'Turkmenistan',
	        Valid: true,
	        DisplayOrder: 230
	      }, {
	        Code: 'TC',
	        Name: 'Turks and Caicos Islands',
	        Valid: true,
	        DisplayOrder: 231
	      }, {
	        Code: 'TV',
	        Name: 'Tuvalu',
	        Valid: true,
	        DisplayOrder: 232
	      }, {
	        Code: 'UG',
	        Name: 'Uganda',
	        Valid: true,
	        DisplayOrder: 233
	      }, {
	        Code: 'UA',
	        Name: 'Ukraine',
	        Valid: true,
	        DisplayOrder: 234
	      }, {
	        Code: 'AE',
	        Name: 'United Arab Emirates',
	        Valid: true,
	        DisplayOrder: 235
	      }, {
	        Code: 'GB',
	        Name: 'United Kingdom of Great Britain and Northern Ireland',
	        Valid: true,
	        DisplayOrder: 236
	      }, {
	        Code: 'UM',
	        Name: 'United States Minor Outlying Islands',
	        Valid: true,
	        DisplayOrder: 237
	      }, {
	        Code: 'UY',
	        Name: 'Uruguay',
	        Valid: true,
	        DisplayOrder: 238
	      }, {
	        Code: 'UZ',
	        Name: 'Uzbekistan',
	        Valid: true,
	        DisplayOrder: 239
	      }, {
	        Code: 'VU',
	        Name: 'Vanuatu',
	        Valid: true,
	        DisplayOrder: 240
	      }, {
	        Code: 'VE',
	        Name: 'Venezuela (Bolivarian Republic of)',
	        Valid: true,
	        DisplayOrder: 241
	      }, {
	        Code: 'VN',
	        Name: 'Viet Nam',
	        Valid: true,
	        DisplayOrder: 242
	      }, {
	        Code: 'VG',
	        Name: 'Virgin Islands (British)',
	        Valid: true,
	        DisplayOrder: 243
	      }, {
	        Code: 'VI',
	        Name: 'Virgin Islands (U.S.)',
	        Valid: true,
	        DisplayOrder: 244
	      }, {
	        Code: 'WF',
	        Name: 'Wallis and Futuna',
	        Valid: true,
	        DisplayOrder: 245
	      }, {
	        Code: 'EH',
	        Name: 'Western Sahara',
	        Valid: true,
	        DisplayOrder: 246
	      }, {
	        Code: 'YE',
	        Name: 'Yemen',
	        Valid: true,
	        DisplayOrder: 247
	      }, {
	        Code: 'ZM',
	        Name: 'Zambia',
	        Valid: true,
	        DisplayOrder: 248
	      }, {
	        Code: 'ZW',
	        Name: 'Zimbabwe',
	        Valid: true,
	        DisplayOrder: 249
	      }], data.GuestTravellersSuffixes = [{
	        Code: 'CFRE',
	        Name: 'CFRE',
	        Valid: true,
	        DisplayOrder: 1
	      }, {
	        Code: 'CLU',
	        Name: 'CLU',
	        Valid: true,
	        DisplayOrder: 2
	      }, {
	        Code: 'CPA',
	        Name: 'CPA',
	        Valid: true,
	        DisplayOrder: 3
	      }, {
	        Code: 'DC',
	        Name: 'D.C.',
	        Valid: true,
	        DisplayOrder: 4
	      }, {
	        Code: 'DD',
	        Name: 'D.D.',
	        Valid: true,
	        DisplayOrder: 5
	      }, {
	        Code: 'DDS',
	        Name: 'D.D.S.',
	        Valid: true,
	        DisplayOrder: 6
	      }, {
	        Code: 'DMD',
	        Name: 'D.M.D.',
	        Valid: true,
	        DisplayOrder: 7
	      }, {
	        Code: 'DO',
	        Name: 'D.O.',
	        Valid: true,
	        DisplayOrder: 8
	      }, {
	        Code: 'DVM',
	        Name: 'D.V.M.',
	        Valid: true,
	        DisplayOrder: 9
	      }, {
	        Code: 'EDD',
	        Name: 'Ed.D.',
	        Valid: true,
	        DisplayOrder: 10
	      }, {
	        Code: 'ESQ',
	        Name: 'Esq.',
	        Valid: true,
	        DisplayOrder: 11
	      }, {
	        Code: 'II',
	        Name: 'II',
	        Valid: true,
	        DisplayOrder: 12
	      }, {
	        Code: 'III',
	        Name: 'III',
	        Valid: true,
	        DisplayOrder: 13
	      }, {
	        Code: 'IV',
	        Name: 'IV',
	        Valid: true,
	        DisplayOrder: 14
	      }, {
	        Code: 'JD',
	        Name: 'J.D.',
	        Valid: true,
	        DisplayOrder: 15
	      }, {
	        Code: 'JR',
	        Name: 'Jr.',
	        Valid: true,
	        DisplayOrder: 16
	      }, {
	        Code: 'LLD',
	        Name: 'LL.D.',
	        Valid: true,
	        DisplayOrder: 17
	      }, {
	        Code: 'MD',
	        Name: 'M.D.',
	        Valid: true,
	        DisplayOrder: 18
	      }, {
	        Code: 'OD',
	        Name: 'O.D.',
	        Valid: true,
	        DisplayOrder: 19
	      }, {
	        Code: 'PC',
	        Name: 'P.C.',
	        Valid: true,
	        DisplayOrder: 20
	      }, {
	        Code: 'PE',
	        Name: 'P.E.',
	        Valid: true,
	        DisplayOrder: 21
	      }, {
	        Code: 'PHD',
	        Name: 'Ph.D.',
	        Valid: true,
	        DisplayOrder: 22
	      }, {
	        Code: 'RET',
	        Name: 'Ret.',
	        Valid: true,
	        DisplayOrder: 23
	      }, {
	        Code: 'RN',
	        Name: 'R.N.',
	        Valid: true,
	        DisplayOrder: 24
	      }, {
	        Code: 'RNC',
	        Name: 'R.N.C.',
	        Valid: true,
	        DisplayOrder: 25
	      }, {
	        Code: 'SR',
	        Name: 'Sr.',
	        Valid: true,
	        DisplayOrder: 26
	      }];
	
	      if (data.Locale) {
	        setLocation(data.Locale);
	      }
	      isFetching = false; // reset flag
	      deferred.resolve(service.settings); // resolve the promise with the data
	    }).error(function (error) {
	      isFetching = false;
	      lbDialogService.show({
	        title: 'Interal Error',
	        message: 'There was an error loading the settings. Please refresh the page.',
	        warningLevel: 'warning',
	        showCancelButton: false,
	        submitButtonText: 'Refresh Page'
	      }).then(function () {
	        location.reload();
	      });
	      deferred.reject(error);
	    });
	
	    return deferred.promise;
	  }
	
	  function clear() {
	    service.settings = null;
	  }
	
	  function setLocation(locationCode) {
	    window.localStorage.setItem('i18nCode', locationCode);
	    $translate.use(locationCode);
	  }
	
	  function isOneWayFare(origin, destination) {
	    return _.some(service.settings.FlightConfiguration.OneWayFareRules, function (rule) {
	      return rule.Origin === origin.CountryCode && rule.Destination === destination.CountryCode;
	    });
	  }
	
	  function getRailCards() {
	    if (!service.settings.RailConfiguration || !service.settings.RailConfiguration.RailCard) {
	      return undefined;
	    }
	
	    return service.settings.RailConfiguration.RailCard;
	  }
	
	  function currencyCode() {
	    return service.settings.Currency.Code;
	  }
	
	  function getHotelPaymentNarrativesByIds(codes) {
	    return _.filter(service.settings.HotelConfiguration.PaymentNarratives, function (narrative) {
	      return _.includes(codes, narrative.PaymentCode);
	    });
	  }
	
	  function isUnusedCreditEnabled() {
	    return service.settings.FlightConfiguration.EnableUnusedCredit;
	  }
	
	  function isDefaultCostCenter(value) {
	    return !(value && value != 'No Cost Center' && value != 'No Cost Centre' && value != 'N/A');
	  }
	
	  return service;
	};
	
	settingsService.$inject = $inject;
	
	exports['default'] = settingsService;
	module.exports = exports['default'];

/***/ }),
/* 312 */,
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 21.2.5.3 get RegExp.prototype.flags
	var anObject = __webpack_require__(4);
	module.exports = function () {
	  var that = anObject(this);
	  var result = '';
	  if (that.global) result += 'g';
	  if (that.ignoreCase) result += 'i';
	  if (that.multiline) result += 'm';
	  if (that.unicode) result += 'u';
	  if (that.sticky) result += 'y';
	  return result;
	};


/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(44);
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};


/***/ }),
/* 315 */
/***/ (function(module, exports) {

	exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

	var core = __webpack_require__(45);
	var global = __webpack_require__(5);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	
	(module.exports = function (key, value) {
	  return store[key] || (store[key] = value !== undefined ? value : {});
	})('versions', []).push({
	  version: core.version,
	  mode: __webpack_require__(93) ? 'pure' : 'global',
	  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
	});


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.3.20 SpeciesConstructor(O, defaultConstructor)
	var anObject = __webpack_require__(4);
	var aFunction = __webpack_require__(23);
	var SPECIES = __webpack_require__(10)('species');
	module.exports = function (O, D) {
	  var C = anObject(O).constructor;
	  var S;
	  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
	};


/***/ }),
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global, module) {/**
	 * @license
	 * Lodash <https://lodash.com/>
	 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	;(function() {
	
	  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
	  var undefined;
	
	  /** Used as the semantic version number. */
	  var VERSION = '4.17.21';
	
	  /** Used as the size to enable large array optimizations. */
	  var LARGE_ARRAY_SIZE = 200;
	
	  /** Error message constants. */
	  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
	      FUNC_ERROR_TEXT = 'Expected a function',
	      INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';
	
	  /** Used to stand-in for `undefined` hash values. */
	  var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	  /** Used as the maximum memoize cache size. */
	  var MAX_MEMOIZE_SIZE = 500;
	
	  /** Used as the internal argument placeholder. */
	  var PLACEHOLDER = '__lodash_placeholder__';
	
	  /** Used to compose bitmasks for cloning. */
	  var CLONE_DEEP_FLAG = 1,
	      CLONE_FLAT_FLAG = 2,
	      CLONE_SYMBOLS_FLAG = 4;
	
	  /** Used to compose bitmasks for value comparisons. */
	  var COMPARE_PARTIAL_FLAG = 1,
	      COMPARE_UNORDERED_FLAG = 2;
	
	  /** Used to compose bitmasks for function metadata. */
	  var WRAP_BIND_FLAG = 1,
	      WRAP_BIND_KEY_FLAG = 2,
	      WRAP_CURRY_BOUND_FLAG = 4,
	      WRAP_CURRY_FLAG = 8,
	      WRAP_CURRY_RIGHT_FLAG = 16,
	      WRAP_PARTIAL_FLAG = 32,
	      WRAP_PARTIAL_RIGHT_FLAG = 64,
	      WRAP_ARY_FLAG = 128,
	      WRAP_REARG_FLAG = 256,
	      WRAP_FLIP_FLAG = 512;
	
	  /** Used as default options for `_.truncate`. */
	  var DEFAULT_TRUNC_LENGTH = 30,
	      DEFAULT_TRUNC_OMISSION = '...';
	
	  /** Used to detect hot functions by number of calls within a span of milliseconds. */
	  var HOT_COUNT = 800,
	      HOT_SPAN = 16;
	
	  /** Used to indicate the type of lazy iteratees. */
	  var LAZY_FILTER_FLAG = 1,
	      LAZY_MAP_FLAG = 2,
	      LAZY_WHILE_FLAG = 3;
	
	  /** Used as references for various `Number` constants. */
	  var INFINITY = 1 / 0,
	      MAX_SAFE_INTEGER = 9007199254740991,
	      MAX_INTEGER = 1.7976931348623157e+308,
	      NAN = 0 / 0;
	
	  /** Used as references for the maximum length and index of an array. */
	  var MAX_ARRAY_LENGTH = 4294967295,
	      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
	      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
	
	  /** Used to associate wrap methods with their bit flags. */
	  var wrapFlags = [
	    ['ary', WRAP_ARY_FLAG],
	    ['bind', WRAP_BIND_FLAG],
	    ['bindKey', WRAP_BIND_KEY_FLAG],
	    ['curry', WRAP_CURRY_FLAG],
	    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
	    ['flip', WRAP_FLIP_FLAG],
	    ['partial', WRAP_PARTIAL_FLAG],
	    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
	    ['rearg', WRAP_REARG_FLAG]
	  ];
	
	  /** `Object#toString` result references. */
	  var argsTag = '[object Arguments]',
	      arrayTag = '[object Array]',
	      asyncTag = '[object AsyncFunction]',
	      boolTag = '[object Boolean]',
	      dateTag = '[object Date]',
	      domExcTag = '[object DOMException]',
	      errorTag = '[object Error]',
	      funcTag = '[object Function]',
	      genTag = '[object GeneratorFunction]',
	      mapTag = '[object Map]',
	      numberTag = '[object Number]',
	      nullTag = '[object Null]',
	      objectTag = '[object Object]',
	      promiseTag = '[object Promise]',
	      proxyTag = '[object Proxy]',
	      regexpTag = '[object RegExp]',
	      setTag = '[object Set]',
	      stringTag = '[object String]',
	      symbolTag = '[object Symbol]',
	      undefinedTag = '[object Undefined]',
	      weakMapTag = '[object WeakMap]',
	      weakSetTag = '[object WeakSet]';
	
	  var arrayBufferTag = '[object ArrayBuffer]',
	      dataViewTag = '[object DataView]',
	      float32Tag = '[object Float32Array]',
	      float64Tag = '[object Float64Array]',
	      int8Tag = '[object Int8Array]',
	      int16Tag = '[object Int16Array]',
	      int32Tag = '[object Int32Array]',
	      uint8Tag = '[object Uint8Array]',
	      uint8ClampedTag = '[object Uint8ClampedArray]',
	      uint16Tag = '[object Uint16Array]',
	      uint32Tag = '[object Uint32Array]';
	
	  /** Used to match empty string literals in compiled template source. */
	  var reEmptyStringLeading = /\b__p \+= '';/g,
	      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
	      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
	
	  /** Used to match HTML entities and HTML characters. */
	  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
	      reUnescapedHtml = /[&<>"']/g,
	      reHasEscapedHtml = RegExp(reEscapedHtml.source),
	      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
	
	  /** Used to match template delimiters. */
	  var reEscape = /<%-([\s\S]+?)%>/g,
	      reEvaluate = /<%([\s\S]+?)%>/g,
	      reInterpolate = /<%=([\s\S]+?)%>/g;
	
	  /** Used to match property names within property paths. */
	  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	      reIsPlainProp = /^\w*$/,
	      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	  /**
	   * Used to match `RegExp`
	   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	   */
	  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
	      reHasRegExpChar = RegExp(reRegExpChar.source);
	
	  /** Used to match leading whitespace. */
	  var reTrimStart = /^\s+/;
	
	  /** Used to match a single whitespace character. */
	  var reWhitespace = /\s/;
	
	  /** Used to match wrap detail comments. */
	  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
	      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
	      reSplitDetails = /,? & /;
	
	  /** Used to match words composed of alphanumeric characters. */
	  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
	
	  /**
	   * Used to validate the `validate` option in `_.template` variable.
	   *
	   * Forbids characters which could potentially change the meaning of the function argument definition:
	   * - "()," (modification of function parameters)
	   * - "=" (default value)
	   * - "[]{}" (destructuring of function parameters)
	   * - "/" (beginning of a comment)
	   * - whitespace
	   */
	  var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
	
	  /** Used to match backslashes in property paths. */
	  var reEscapeChar = /\\(\\)?/g;
	
	  /**
	   * Used to match
	   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
	   */
	  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
	
	  /** Used to match `RegExp` flags from their coerced string values. */
	  var reFlags = /\w*$/;
	
	  /** Used to detect bad signed hexadecimal string values. */
	  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	  /** Used to detect binary string values. */
	  var reIsBinary = /^0b[01]+$/i;
	
	  /** Used to detect host constructors (Safari). */
	  var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	  /** Used to detect octal string values. */
	  var reIsOctal = /^0o[0-7]+$/i;
	
	  /** Used to detect unsigned integer values. */
	  var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	  /** Used to match Latin Unicode letters (excluding mathematical operators). */
	  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
	
	  /** Used to ensure capturing order of template delimiters. */
	  var reNoMatch = /($^)/;
	
	  /** Used to match unescaped characters in compiled string literals. */
	  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
	
	  /** Used to compose unicode character classes. */
	  var rsAstralRange = '\\ud800-\\udfff',
	      rsComboMarksRange = '\\u0300-\\u036f',
	      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	      rsComboSymbolsRange = '\\u20d0-\\u20ff',
	      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
	      rsDingbatRange = '\\u2700-\\u27bf',
	      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
	      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
	      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
	      rsPunctuationRange = '\\u2000-\\u206f',
	      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
	      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
	      rsVarRange = '\\ufe0e\\ufe0f',
	      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
	
	  /** Used to compose unicode capture groups. */
	  var rsApos = "['\u2019]",
	      rsAstral = '[' + rsAstralRange + ']',
	      rsBreak = '[' + rsBreakRange + ']',
	      rsCombo = '[' + rsComboRange + ']',
	      rsDigits = '\\d+',
	      rsDingbat = '[' + rsDingbatRange + ']',
	      rsLower = '[' + rsLowerRange + ']',
	      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
	      rsFitz = '\\ud83c[\\udffb-\\udfff]',
	      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	      rsNonAstral = '[^' + rsAstralRange + ']',
	      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	      rsUpper = '[' + rsUpperRange + ']',
	      rsZWJ = '\\u200d';
	
	  /** Used to compose unicode regexes. */
	  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
	      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
	      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
	      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
	      reOptMod = rsModifier + '?',
	      rsOptVar = '[' + rsVarRange + ']?',
	      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
	      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
	      rsSeq = rsOptVar + reOptMod + rsOptJoin,
	      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
	      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
	
	  /** Used to match apostrophes. */
	  var reApos = RegExp(rsApos, 'g');
	
	  /**
	   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
	   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
	   */
	  var reComboMark = RegExp(rsCombo, 'g');
	
	  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
	  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
	
	  /** Used to match complex or compound words. */
	  var reUnicodeWord = RegExp([
	    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
	    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
	    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
	    rsUpper + '+' + rsOptContrUpper,
	    rsOrdUpper,
	    rsOrdLower,
	    rsDigits,
	    rsEmoji
	  ].join('|'), 'g');
	
	  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
	  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');
	
	  /** Used to detect strings that need a more robust regexp to match words. */
	  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
	
	  /** Used to assign default `context` object properties. */
	  var contextProps = [
	    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
	    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
	    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
	    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
	    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
	  ];
	
	  /** Used to make template sourceURLs easier to identify. */
	  var templateCounter = -1;
	
	  /** Used to identify `toStringTag` values of typed arrays. */
	  var typedArrayTags = {};
	  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	  typedArrayTags[uint32Tag] = true;
	  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	  typedArrayTags[setTag] = typedArrayTags[stringTag] =
	  typedArrayTags[weakMapTag] = false;
	
	  /** Used to identify `toStringTag` values supported by `_.clone`. */
	  var cloneableTags = {};
	  cloneableTags[argsTag] = cloneableTags[arrayTag] =
	  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	  cloneableTags[boolTag] = cloneableTags[dateTag] =
	  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	  cloneableTags[int32Tag] = cloneableTags[mapTag] =
	  cloneableTags[numberTag] = cloneableTags[objectTag] =
	  cloneableTags[regexpTag] = cloneableTags[setTag] =
	  cloneableTags[stringTag] = cloneableTags[symbolTag] =
	  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	  cloneableTags[errorTag] = cloneableTags[funcTag] =
	  cloneableTags[weakMapTag] = false;
	
	  /** Used to map Latin Unicode letters to basic Latin letters. */
	  var deburredLetters = {
	    // Latin-1 Supplement block.
	    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
	    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
	    '\xc7': 'C',  '\xe7': 'c',
	    '\xd0': 'D',  '\xf0': 'd',
	    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
	    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
	    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
	    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
	    '\xd1': 'N',  '\xf1': 'n',
	    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
	    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
	    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
	    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
	    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
	    '\xc6': 'Ae', '\xe6': 'ae',
	    '\xde': 'Th', '\xfe': 'th',
	    '\xdf': 'ss',
	    // Latin Extended-A block.
	    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
	    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
	    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
	    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
	    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
	    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
	    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
	    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
	    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
	    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
	    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
	    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
	    '\u0134': 'J',  '\u0135': 'j',
	    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
	    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
	    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
	    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
	    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
	    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
	    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
	    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
	    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
	    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
	    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
	    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
	    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
	    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
	    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
	    '\u0174': 'W',  '\u0175': 'w',
	    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
	    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
	    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
	    '\u0132': 'IJ', '\u0133': 'ij',
	    '\u0152': 'Oe', '\u0153': 'oe',
	    '\u0149': "'n", '\u017f': 's'
	  };
	
	  /** Used to map characters to HTML entities. */
	  var htmlEscapes = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#39;'
	  };
	
	  /** Used to map HTML entities to characters. */
	  var htmlUnescapes = {
	    '&amp;': '&',
	    '&lt;': '<',
	    '&gt;': '>',
	    '&quot;': '"',
	    '&#39;': "'"
	  };
	
	  /** Used to escape characters for inclusion in compiled string literals. */
	  var stringEscapes = {
	    '\\': '\\',
	    "'": "'",
	    '\n': 'n',
	    '\r': 'r',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };
	
	  /** Built-in method references without a dependency on `root`. */
	  var freeParseFloat = parseFloat,
	      freeParseInt = parseInt;
	
	  /** Detect free variable `global` from Node.js. */
	  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	  /** Detect free variable `self`. */
	  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	  /** Used as a reference to the global object. */
	  var root = freeGlobal || freeSelf || Function('return this')();
	
	  /** Detect free variable `exports`. */
	  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	  /** Detect free variable `module`. */
	  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	  /** Detect the popular CommonJS extension `module.exports`. */
	  var moduleExports = freeModule && freeModule.exports === freeExports;
	
	  /** Detect free variable `process` from Node.js. */
	  var freeProcess = moduleExports && freeGlobal.process;
	
	  /** Used to access faster Node.js helpers. */
	  var nodeUtil = (function() {
	    try {
	      // Use `util.types` for Node.js 10+.
	      var types = freeModule && freeModule.require && freeModule.require('util').types;
	
	      if (types) {
	        return types;
	      }
	
	      // Legacy `process.binding('util')` for Node.js < 10.
	      return freeProcess && freeProcess.binding && freeProcess.binding('util');
	    } catch (e) {}
	  }());
	
	  /* Node.js helper references. */
	  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
	      nodeIsDate = nodeUtil && nodeUtil.isDate,
	      nodeIsMap = nodeUtil && nodeUtil.isMap,
	      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
	      nodeIsSet = nodeUtil && nodeUtil.isSet,
	      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * A faster alternative to `Function#apply`, this function invokes `func`
	   * with the `this` binding of `thisArg` and the arguments of `args`.
	   *
	   * @private
	   * @param {Function} func The function to invoke.
	   * @param {*} thisArg The `this` binding of `func`.
	   * @param {Array} args The arguments to invoke `func` with.
	   * @returns {*} Returns the result of `func`.
	   */
	  function apply(func, thisArg, args) {
	    switch (args.length) {
	      case 0: return func.call(thisArg);
	      case 1: return func.call(thisArg, args[0]);
	      case 2: return func.call(thisArg, args[0], args[1]);
	      case 3: return func.call(thisArg, args[0], args[1], args[2]);
	    }
	    return func.apply(thisArg, args);
	  }
	
	  /**
	   * A specialized version of `baseAggregator` for arrays.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} setter The function to set `accumulator` values.
	   * @param {Function} iteratee The iteratee to transform keys.
	   * @param {Object} accumulator The initial aggregated object.
	   * @returns {Function} Returns `accumulator`.
	   */
	  function arrayAggregator(array, setter, iteratee, accumulator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      var value = array[index];
	      setter(accumulator, value, iteratee(value), array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.forEach` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEach(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (iteratee(array[index], index, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.forEachRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEachRight(array, iteratee) {
	    var length = array == null ? 0 : array.length;
	
	    while (length--) {
	      if (iteratee(array[length], length, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.every` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if all elements pass the predicate check,
	   *  else `false`.
	   */
	  function arrayEvery(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (!predicate(array[index], index, array)) {
	        return false;
	      }
	    }
	    return true;
	  }
	
	  /**
	   * A specialized version of `_.filter` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {Array} Returns the new filtered array.
	   */
	  function arrayFilter(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (predicate(value, index, array)) {
	        result[resIndex++] = value;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.includes` for arrays without support for
	   * specifying an index to search from.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludes(array, value) {
	    var length = array == null ? 0 : array.length;
	    return !!length && baseIndexOf(array, value, 0) > -1;
	  }
	
	  /**
	   * This function is like `arrayIncludes` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludesWith(array, value, comparator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (comparator(value, array[index])) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * A specialized version of `_.map` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the new mapped array.
	   */
	  function arrayMap(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        result = Array(length);
	
	    while (++index < length) {
	      result[index] = iteratee(array[index], index, array);
	    }
	    return result;
	  }
	
	  /**
	   * Appends the elements of `values` to `array`.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {Array} values The values to append.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayPush(array, values) {
	    var index = -1,
	        length = values.length,
	        offset = array.length;
	
	    while (++index < length) {
	      array[offset + index] = values[index];
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.reduce` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the first element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduce(array, iteratee, accumulator, initAccum) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    if (initAccum && length) {
	      accumulator = array[++index];
	    }
	    while (++index < length) {
	      accumulator = iteratee(accumulator, array[index], index, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.reduceRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the last element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
	    var length = array == null ? 0 : array.length;
	    if (initAccum && length) {
	      accumulator = array[--length];
	    }
	    while (length--) {
	      accumulator = iteratee(accumulator, array[length], length, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.some` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if any element passes the predicate check,
	   *  else `false`.
	   */
	  function arraySome(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (predicate(array[index], index, array)) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * Gets the size of an ASCII `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  var asciiSize = baseProperty('length');
	
	  /**
	   * Converts an ASCII `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function asciiToArray(string) {
	    return string.split('');
	  }
	
	  /**
	   * Splits an ASCII `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function asciiWords(string) {
	    return string.match(reAsciiWord) || [];
	  }
	
	  /**
	   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
	   * without support for iteratee shorthands, which iterates over `collection`
	   * using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the found element or its key, else `undefined`.
	   */
	  function baseFindKey(collection, predicate, eachFunc) {
	    var result;
	    eachFunc(collection, function(value, key, collection) {
	      if (predicate(value, key, collection)) {
	        result = key;
	        return false;
	      }
	    });
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.findIndex` and `_.findLastIndex` without
	   * support for iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {number} fromIndex The index to search from.
	   * @param {boolean} [fromRight] Specify iterating from right to left.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseFindIndex(array, predicate, fromIndex, fromRight) {
	    var length = array.length,
	        index = fromIndex + (fromRight ? 1 : -1);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (predicate(array[index], index, array)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOf(array, value, fromIndex) {
	    return value === value
	      ? strictIndexOf(array, value, fromIndex)
	      : baseFindIndex(array, baseIsNaN, fromIndex);
	  }
	
	  /**
	   * This function is like `baseIndexOf` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOfWith(array, value, fromIndex, comparator) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (comparator(array[index], value)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.isNaN` without support for number objects.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	   */
	  function baseIsNaN(value) {
	    return value !== value;
	  }
	
	  /**
	   * The base implementation of `_.mean` and `_.meanBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the mean.
	   */
	  function baseMean(array, iteratee) {
	    var length = array == null ? 0 : array.length;
	    return length ? (baseSum(array, iteratee) / length) : NAN;
	  }
	
	  /**
	   * The base implementation of `_.property` without support for deep paths.
	   *
	   * @private
	   * @param {string} key The key of the property to get.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function baseProperty(key) {
	    return function(object) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.propertyOf` without support for deep paths.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function basePropertyOf(object) {
	    return function(key) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.reduce` and `_.reduceRight`, without support
	   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} accumulator The initial value.
	   * @param {boolean} initAccum Specify using the first or last element of
	   *  `collection` as the initial value.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the accumulated value.
	   */
	  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
	    eachFunc(collection, function(value, index, collection) {
	      accumulator = initAccum
	        ? (initAccum = false, value)
	        : iteratee(accumulator, value, index, collection);
	    });
	    return accumulator;
	  }
	
	  /**
	   * The base implementation of `_.sortBy` which uses `comparer` to define the
	   * sort order of `array` and replaces criteria objects with their corresponding
	   * values.
	   *
	   * @private
	   * @param {Array} array The array to sort.
	   * @param {Function} comparer The function to define sort order.
	   * @returns {Array} Returns `array`.
	   */
	  function baseSortBy(array, comparer) {
	    var length = array.length;
	
	    array.sort(comparer);
	    while (length--) {
	      array[length] = array[length].value;
	    }
	    return array;
	  }
	
	  /**
	   * The base implementation of `_.sum` and `_.sumBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the sum.
	   */
	  function baseSum(array, iteratee) {
	    var result,
	        index = -1,
	        length = array.length;
	
	    while (++index < length) {
	      var current = iteratee(array[index]);
	      if (current !== undefined) {
	        result = result === undefined ? current : (result + current);
	      }
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.times` without support for iteratee shorthands
	   * or max array length checks.
	   *
	   * @private
	   * @param {number} n The number of times to invoke `iteratee`.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the array of results.
	   */
	  function baseTimes(n, iteratee) {
	    var index = -1,
	        result = Array(n);
	
	    while (++index < n) {
	      result[index] = iteratee(index);
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
	   * of key-value pairs for `object` corresponding to the property names of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the key-value pairs.
	   */
	  function baseToPairs(object, props) {
	    return arrayMap(props, function(key) {
	      return [key, object[key]];
	    });
	  }
	
	  /**
	   * The base implementation of `_.trim`.
	   *
	   * @private
	   * @param {string} string The string to trim.
	   * @returns {string} Returns the trimmed string.
	   */
	  function baseTrim(string) {
	    return string
	      ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
	      : string;
	  }
	
	  /**
	   * The base implementation of `_.unary` without support for storing metadata.
	   *
	   * @private
	   * @param {Function} func The function to cap arguments for.
	   * @returns {Function} Returns the new capped function.
	   */
	  function baseUnary(func) {
	    return function(value) {
	      return func(value);
	    };
	  }
	
	  /**
	   * The base implementation of `_.values` and `_.valuesIn` which creates an
	   * array of `object` property values corresponding to the property names
	   * of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the array of property values.
	   */
	  function baseValues(object, props) {
	    return arrayMap(props, function(key) {
	      return object[key];
	    });
	  }
	
	  /**
	   * Checks if a `cache` value for `key` exists.
	   *
	   * @private
	   * @param {Object} cache The cache to query.
	   * @param {string} key The key of the entry to check.
	   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	   */
	  function cacheHas(cache, key) {
	    return cache.has(key);
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the first unmatched string symbol.
	   */
	  function charsStartIndex(strSymbols, chrSymbols) {
	    var index = -1,
	        length = strSymbols.length;
	
	    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the last unmatched string symbol.
	   */
	  function charsEndIndex(strSymbols, chrSymbols) {
	    var index = strSymbols.length;
	
	    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Gets the number of `placeholder` occurrences in `array`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} placeholder The placeholder to search for.
	   * @returns {number} Returns the placeholder count.
	   */
	  function countHolders(array, placeholder) {
	    var length = array.length,
	        result = 0;
	
	    while (length--) {
	      if (array[length] === placeholder) {
	        ++result;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
	   * letters to basic Latin letters.
	   *
	   * @private
	   * @param {string} letter The matched letter to deburr.
	   * @returns {string} Returns the deburred letter.
	   */
	  var deburrLetter = basePropertyOf(deburredLetters);
	
	  /**
	   * Used by `_.escape` to convert characters to HTML entities.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  var escapeHtmlChar = basePropertyOf(htmlEscapes);
	
	  /**
	   * Used by `_.template` to escape characters for inclusion in compiled string literals.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeStringChar(chr) {
	    return '\\' + stringEscapes[chr];
	  }
	
	  /**
	   * Gets the value at `key` of `object`.
	   *
	   * @private
	   * @param {Object} [object] The object to query.
	   * @param {string} key The key of the property to get.
	   * @returns {*} Returns the property value.
	   */
	  function getValue(object, key) {
	    return object == null ? undefined : object[key];
	  }
	
	  /**
	   * Checks if `string` contains Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
	   */
	  function hasUnicode(string) {
	    return reHasUnicode.test(string);
	  }
	
	  /**
	   * Checks if `string` contains a word composed of Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a word is found, else `false`.
	   */
	  function hasUnicodeWord(string) {
	    return reHasUnicodeWord.test(string);
	  }
	
	  /**
	   * Converts `iterator` to an array.
	   *
	   * @private
	   * @param {Object} iterator The iterator to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function iteratorToArray(iterator) {
	    var data,
	        result = [];
	
	    while (!(data = iterator.next()).done) {
	      result.push(data.value);
	    }
	    return result;
	  }
	
	  /**
	   * Converts `map` to its key-value pairs.
	   *
	   * @private
	   * @param {Object} map The map to convert.
	   * @returns {Array} Returns the key-value pairs.
	   */
	  function mapToArray(map) {
	    var index = -1,
	        result = Array(map.size);
	
	    map.forEach(function(value, key) {
	      result[++index] = [key, value];
	    });
	    return result;
	  }
	
	  /**
	   * Creates a unary function that invokes `func` with its argument transformed.
	   *
	   * @private
	   * @param {Function} func The function to wrap.
	   * @param {Function} transform The argument transform.
	   * @returns {Function} Returns the new function.
	   */
	  function overArg(func, transform) {
	    return function(arg) {
	      return func(transform(arg));
	    };
	  }
	
	  /**
	   * Replaces all `placeholder` elements in `array` with an internal placeholder
	   * and returns an array of their indexes.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {*} placeholder The placeholder to replace.
	   * @returns {Array} Returns the new array of placeholder indexes.
	   */
	  function replaceHolders(array, placeholder) {
	    var index = -1,
	        length = array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (value === placeholder || value === PLACEHOLDER) {
	        array[index] = PLACEHOLDER;
	        result[resIndex++] = index;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Converts `set` to an array of its values.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the values.
	   */
	  function setToArray(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = value;
	    });
	    return result;
	  }
	
	  /**
	   * Converts `set` to its value-value pairs.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the value-value pairs.
	   */
	  function setToPairs(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = [value, value];
	    });
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.indexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictIndexOf(array, value, fromIndex) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * A specialized version of `_.lastIndexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictLastIndexOf(array, value, fromIndex) {
	    var index = fromIndex + 1;
	    while (index--) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return index;
	  }
	
	  /**
	   * Gets the number of symbols in `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the string size.
	   */
	  function stringSize(string) {
	    return hasUnicode(string)
	      ? unicodeSize(string)
	      : asciiSize(string);
	  }
	
	  /**
	   * Converts `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function stringToArray(string) {
	    return hasUnicode(string)
	      ? unicodeToArray(string)
	      : asciiToArray(string);
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
	   * character of `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the index of the last non-whitespace character.
	   */
	  function trimmedEndIndex(string) {
	    var index = string.length;
	
	    while (index-- && reWhitespace.test(string.charAt(index))) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.unescape` to convert HTML entities to characters.
	   *
	   * @private
	   * @param {string} chr The matched character to unescape.
	   * @returns {string} Returns the unescaped character.
	   */
	  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
	
	  /**
	   * Gets the size of a Unicode `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  function unicodeSize(string) {
	    var result = reUnicode.lastIndex = 0;
	    while (reUnicode.test(string)) {
	      ++result;
	    }
	    return result;
	  }
	
	  /**
	   * Converts a Unicode `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function unicodeToArray(string) {
	    return string.match(reUnicode) || [];
	  }
	
	  /**
	   * Splits a Unicode `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function unicodeWords(string) {
	    return string.match(reUnicodeWord) || [];
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Create a new pristine `lodash` function using the `context` object.
	   *
	   * @static
	   * @memberOf _
	   * @since 1.1.0
	   * @category Util
	   * @param {Object} [context=root] The context object.
	   * @returns {Function} Returns a new `lodash` function.
	   * @example
	   *
	   * _.mixin({ 'foo': _.constant('foo') });
	   *
	   * var lodash = _.runInContext();
	   * lodash.mixin({ 'bar': lodash.constant('bar') });
	   *
	   * _.isFunction(_.foo);
	   * // => true
	   * _.isFunction(_.bar);
	   * // => false
	   *
	   * lodash.isFunction(lodash.foo);
	   * // => false
	   * lodash.isFunction(lodash.bar);
	   * // => true
	   *
	   * // Create a suped-up `defer` in Node.js.
	   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
	   */
	  var runInContext = (function runInContext(context) {
	    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
	
	    /** Built-in constructor references. */
	    var Array = context.Array,
	        Date = context.Date,
	        Error = context.Error,
	        Function = context.Function,
	        Math = context.Math,
	        Object = context.Object,
	        RegExp = context.RegExp,
	        String = context.String,
	        TypeError = context.TypeError;
	
	    /** Used for built-in method references. */
	    var arrayProto = Array.prototype,
	        funcProto = Function.prototype,
	        objectProto = Object.prototype;
	
	    /** Used to detect overreaching core-js shims. */
	    var coreJsData = context['__core-js_shared__'];
	
	    /** Used to resolve the decompiled source of functions. */
	    var funcToString = funcProto.toString;
	
	    /** Used to check objects for own properties. */
	    var hasOwnProperty = objectProto.hasOwnProperty;
	
	    /** Used to generate unique IDs. */
	    var idCounter = 0;
	
	    /** Used to detect methods masquerading as native. */
	    var maskSrcKey = (function() {
	      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	      return uid ? ('Symbol(src)_1.' + uid) : '';
	    }());
	
	    /**
	     * Used to resolve the
	     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	     * of values.
	     */
	    var nativeObjectToString = objectProto.toString;
	
	    /** Used to infer the `Object` constructor. */
	    var objectCtorString = funcToString.call(Object);
	
	    /** Used to restore the original `_` reference in `_.noConflict`. */
	    var oldDash = root._;
	
	    /** Used to detect if a method is native. */
	    var reIsNative = RegExp('^' +
	      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	    );
	
	    /** Built-in value references. */
	    var Buffer = moduleExports ? context.Buffer : undefined,
	        Symbol = context.Symbol,
	        Uint8Array = context.Uint8Array,
	        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
	        getPrototype = overArg(Object.getPrototypeOf, Object),
	        objectCreate = Object.create,
	        propertyIsEnumerable = objectProto.propertyIsEnumerable,
	        splice = arrayProto.splice,
	        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
	        symIterator = Symbol ? Symbol.iterator : undefined,
	        symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	    var defineProperty = (function() {
	      try {
	        var func = getNative(Object, 'defineProperty');
	        func({}, '', {});
	        return func;
	      } catch (e) {}
	    }());
	
	    /** Mocked built-ins. */
	    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
	        ctxNow = Date && Date.now !== root.Date.now && Date.now,
	        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
	
	    /* Built-in method references for those with the same name as other `lodash` methods. */
	    var nativeCeil = Math.ceil,
	        nativeFloor = Math.floor,
	        nativeGetSymbols = Object.getOwnPropertySymbols,
	        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
	        nativeIsFinite = context.isFinite,
	        nativeJoin = arrayProto.join,
	        nativeKeys = overArg(Object.keys, Object),
	        nativeMax = Math.max,
	        nativeMin = Math.min,
	        nativeNow = Date.now,
	        nativeParseInt = context.parseInt,
	        nativeRandom = Math.random,
	        nativeReverse = arrayProto.reverse;
	
	    /* Built-in method references that are verified to be native. */
	    var DataView = getNative(context, 'DataView'),
	        Map = getNative(context, 'Map'),
	        Promise = getNative(context, 'Promise'),
	        Set = getNative(context, 'Set'),
	        WeakMap = getNative(context, 'WeakMap'),
	        nativeCreate = getNative(Object, 'create');
	
	    /** Used to store function metadata. */
	    var metaMap = WeakMap && new WeakMap;
	
	    /** Used to lookup unminified function names. */
	    var realNames = {};
	
	    /** Used to detect maps, sets, and weakmaps. */
	    var dataViewCtorString = toSource(DataView),
	        mapCtorString = toSource(Map),
	        promiseCtorString = toSource(Promise),
	        setCtorString = toSource(Set),
	        weakMapCtorString = toSource(WeakMap);
	
	    /** Used to convert symbols to primitives and strings. */
	    var symbolProto = Symbol ? Symbol.prototype : undefined,
	        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
	        symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` object which wraps `value` to enable implicit method
	     * chain sequences. Methods that operate on and return arrays, collections,
	     * and functions can be chained together. Methods that retrieve a single value
	     * or may return a primitive value will automatically end the chain sequence
	     * and return the unwrapped value. Otherwise, the value must be unwrapped
	     * with `_#value`.
	     *
	     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
	     * enabled using `_.chain`.
	     *
	     * The execution of chained methods is lazy, that is, it's deferred until
	     * `_#value` is implicitly or explicitly called.
	     *
	     * Lazy evaluation allows several methods to support shortcut fusion.
	     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
	     * the creation of intermediate arrays and can greatly reduce the number of
	     * iteratee executions. Sections of a chain sequence qualify for shortcut
	     * fusion if the section is applied to an array and iteratees accept only
	     * one argument. The heuristic for whether a section qualifies for shortcut
	     * fusion is subject to change.
	     *
	     * Chaining is supported in custom builds as long as the `_#value` method is
	     * directly or indirectly included in the build.
	     *
	     * In addition to lodash methods, wrappers have `Array` and `String` methods.
	     *
	     * The wrapper `Array` methods are:
	     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
	     *
	     * The wrapper `String` methods are:
	     * `replace` and `split`
	     *
	     * The wrapper methods that support shortcut fusion are:
	     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
	     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
	     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
	     *
	     * The chainable wrapper methods are:
	     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
	     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
	     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
	     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
	     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
	     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
	     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
	     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
	     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
	     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
	     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
	     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
	     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
	     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
	     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
	     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
	     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
	     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
	     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
	     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
	     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
	     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
	     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
	     * `zipObject`, `zipObjectDeep`, and `zipWith`
	     *
	     * The wrapper methods that are **not** chainable by default are:
	     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
	     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
	     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
	     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
	     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
	     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
	     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
	     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
	     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
	     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
	     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
	     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
	     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
	     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
	     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
	     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
	     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
	     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
	     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
	     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
	     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
	     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
	     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
	     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
	     * `upperFirst`, `value`, and `words`
	     *
	     * @name _
	     * @constructor
	     * @category Seq
	     * @param {*} value The value to wrap in a `lodash` instance.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2, 3]);
	     *
	     * // Returns an unwrapped value.
	     * wrapped.reduce(_.add);
	     * // => 6
	     *
	     * // Returns a wrapped value.
	     * var squares = wrapped.map(square);
	     *
	     * _.isArray(squares);
	     * // => false
	     *
	     * _.isArray(squares.value());
	     * // => true
	     */
	    function lodash(value) {
	      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
	        if (value instanceof LodashWrapper) {
	          return value;
	        }
	        if (hasOwnProperty.call(value, '__wrapped__')) {
	          return wrapperClone(value);
	        }
	      }
	      return new LodashWrapper(value);
	    }
	
	    /**
	     * The base implementation of `_.create` without support for assigning
	     * properties to the created object.
	     *
	     * @private
	     * @param {Object} proto The object to inherit from.
	     * @returns {Object} Returns the new object.
	     */
	    var baseCreate = (function() {
	      function object() {}
	      return function(proto) {
	        if (!isObject(proto)) {
	          return {};
	        }
	        if (objectCreate) {
	          return objectCreate(proto);
	        }
	        object.prototype = proto;
	        var result = new object;
	        object.prototype = undefined;
	        return result;
	      };
	    }());
	
	    /**
	     * The function whose prototype chain sequence wrappers inherit from.
	     *
	     * @private
	     */
	    function baseLodash() {
	      // No operation performed.
	    }
	
	    /**
	     * The base constructor for creating `lodash` wrapper objects.
	     *
	     * @private
	     * @param {*} value The value to wrap.
	     * @param {boolean} [chainAll] Enable explicit method chain sequences.
	     */
	    function LodashWrapper(value, chainAll) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__chain__ = !!chainAll;
	      this.__index__ = 0;
	      this.__values__ = undefined;
	    }
	
	    /**
	     * By default, the template delimiters used by lodash are like those in
	     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
	     * following template settings to use alternative delimiters.
	     *
	     * @static
	     * @memberOf _
	     * @type {Object}
	     */
	    lodash.templateSettings = {
	
	      /**
	       * Used to detect `data` property values to be HTML-escaped.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'escape': reEscape,
	
	      /**
	       * Used to detect code to be evaluated.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'evaluate': reEvaluate,
	
	      /**
	       * Used to detect `data` property values to inject.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'interpolate': reInterpolate,
	
	      /**
	       * Used to reference the data object in the template text.
	       *
	       * @memberOf _.templateSettings
	       * @type {string}
	       */
	      'variable': '',
	
	      /**
	       * Used to import variables into the compiled template.
	       *
	       * @memberOf _.templateSettings
	       * @type {Object}
	       */
	      'imports': {
	
	        /**
	         * A reference to the `lodash` function.
	         *
	         * @memberOf _.templateSettings.imports
	         * @type {Function}
	         */
	        '_': lodash
	      }
	    };
	
	    // Ensure wrappers are instances of `baseLodash`.
	    lodash.prototype = baseLodash.prototype;
	    lodash.prototype.constructor = lodash;
	
	    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
	    LodashWrapper.prototype.constructor = LodashWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
	     *
	     * @private
	     * @constructor
	     * @param {*} value The value to wrap.
	     */
	    function LazyWrapper(value) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__dir__ = 1;
	      this.__filtered__ = false;
	      this.__iteratees__ = [];
	      this.__takeCount__ = MAX_ARRAY_LENGTH;
	      this.__views__ = [];
	    }
	
	    /**
	     * Creates a clone of the lazy wrapper object.
	     *
	     * @private
	     * @name clone
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the cloned `LazyWrapper` object.
	     */
	    function lazyClone() {
	      var result = new LazyWrapper(this.__wrapped__);
	      result.__actions__ = copyArray(this.__actions__);
	      result.__dir__ = this.__dir__;
	      result.__filtered__ = this.__filtered__;
	      result.__iteratees__ = copyArray(this.__iteratees__);
	      result.__takeCount__ = this.__takeCount__;
	      result.__views__ = copyArray(this.__views__);
	      return result;
	    }
	
	    /**
	     * Reverses the direction of lazy iteration.
	     *
	     * @private
	     * @name reverse
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the new reversed `LazyWrapper` object.
	     */
	    function lazyReverse() {
	      if (this.__filtered__) {
	        var result = new LazyWrapper(this);
	        result.__dir__ = -1;
	        result.__filtered__ = true;
	      } else {
	        result = this.clone();
	        result.__dir__ *= -1;
	      }
	      return result;
	    }
	
	    /**
	     * Extracts the unwrapped value from its lazy wrapper.
	     *
	     * @private
	     * @name value
	     * @memberOf LazyWrapper
	     * @returns {*} Returns the unwrapped value.
	     */
	    function lazyValue() {
	      var array = this.__wrapped__.value(),
	          dir = this.__dir__,
	          isArr = isArray(array),
	          isRight = dir < 0,
	          arrLength = isArr ? array.length : 0,
	          view = getView(0, arrLength, this.__views__),
	          start = view.start,
	          end = view.end,
	          length = end - start,
	          index = isRight ? end : (start - 1),
	          iteratees = this.__iteratees__,
	          iterLength = iteratees.length,
	          resIndex = 0,
	          takeCount = nativeMin(length, this.__takeCount__);
	
	      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
	        return baseWrapperValue(array, this.__actions__);
	      }
	      var result = [];
	
	      outer:
	      while (length-- && resIndex < takeCount) {
	        index += dir;
	
	        var iterIndex = -1,
	            value = array[index];
	
	        while (++iterIndex < iterLength) {
	          var data = iteratees[iterIndex],
	              iteratee = data.iteratee,
	              type = data.type,
	              computed = iteratee(value);
	
	          if (type == LAZY_MAP_FLAG) {
	            value = computed;
	          } else if (!computed) {
	            if (type == LAZY_FILTER_FLAG) {
	              continue outer;
	            } else {
	              break outer;
	            }
	          }
	        }
	        result[resIndex++] = value;
	      }
	      return result;
	    }
	
	    // Ensure `LazyWrapper` is an instance of `baseLodash`.
	    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
	    LazyWrapper.prototype.constructor = LazyWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a hash object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Hash(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the hash.
	     *
	     * @private
	     * @name clear
	     * @memberOf Hash
	     */
	    function hashClear() {
	      this.__data__ = nativeCreate ? nativeCreate(null) : {};
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the hash.
	     *
	     * @private
	     * @name delete
	     * @memberOf Hash
	     * @param {Object} hash The hash to modify.
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function hashDelete(key) {
	      var result = this.has(key) && delete this.__data__[key];
	      this.size -= result ? 1 : 0;
	      return result;
	    }
	
	    /**
	     * Gets the hash value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Hash
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function hashGet(key) {
	      var data = this.__data__;
	      if (nativeCreate) {
	        var result = data[key];
	        return result === HASH_UNDEFINED ? undefined : result;
	      }
	      return hasOwnProperty.call(data, key) ? data[key] : undefined;
	    }
	
	    /**
	     * Checks if a hash value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Hash
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function hashHas(key) {
	      var data = this.__data__;
	      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	    }
	
	    /**
	     * Sets the hash `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Hash
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the hash instance.
	     */
	    function hashSet(key, value) {
	      var data = this.__data__;
	      this.size += this.has(key) ? 0 : 1;
	      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	      return this;
	    }
	
	    // Add methods to `Hash`.
	    Hash.prototype.clear = hashClear;
	    Hash.prototype['delete'] = hashDelete;
	    Hash.prototype.get = hashGet;
	    Hash.prototype.has = hashHas;
	    Hash.prototype.set = hashSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an list cache object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function ListCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the list cache.
	     *
	     * @private
	     * @name clear
	     * @memberOf ListCache
	     */
	    function listCacheClear() {
	      this.__data__ = [];
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the list cache.
	     *
	     * @private
	     * @name delete
	     * @memberOf ListCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function listCacheDelete(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        return false;
	      }
	      var lastIndex = data.length - 1;
	      if (index == lastIndex) {
	        data.pop();
	      } else {
	        splice.call(data, index, 1);
	      }
	      --this.size;
	      return true;
	    }
	
	    /**
	     * Gets the list cache value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf ListCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function listCacheGet(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      return index < 0 ? undefined : data[index][1];
	    }
	
	    /**
	     * Checks if a list cache value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf ListCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function listCacheHas(key) {
	      return assocIndexOf(this.__data__, key) > -1;
	    }
	
	    /**
	     * Sets the list cache `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf ListCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the list cache instance.
	     */
	    function listCacheSet(key, value) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        ++this.size;
	        data.push([key, value]);
	      } else {
	        data[index][1] = value;
	      }
	      return this;
	    }
	
	    // Add methods to `ListCache`.
	    ListCache.prototype.clear = listCacheClear;
	    ListCache.prototype['delete'] = listCacheDelete;
	    ListCache.prototype.get = listCacheGet;
	    ListCache.prototype.has = listCacheHas;
	    ListCache.prototype.set = listCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a map cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function MapCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the map.
	     *
	     * @private
	     * @name clear
	     * @memberOf MapCache
	     */
	    function mapCacheClear() {
	      this.size = 0;
	      this.__data__ = {
	        'hash': new Hash,
	        'map': new (Map || ListCache),
	        'string': new Hash
	      };
	    }
	
	    /**
	     * Removes `key` and its value from the map.
	     *
	     * @private
	     * @name delete
	     * @memberOf MapCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function mapCacheDelete(key) {
	      var result = getMapData(this, key)['delete'](key);
	      this.size -= result ? 1 : 0;
	      return result;
	    }
	
	    /**
	     * Gets the map value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf MapCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function mapCacheGet(key) {
	      return getMapData(this, key).get(key);
	    }
	
	    /**
	     * Checks if a map value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf MapCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function mapCacheHas(key) {
	      return getMapData(this, key).has(key);
	    }
	
	    /**
	     * Sets the map `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf MapCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the map cache instance.
	     */
	    function mapCacheSet(key, value) {
	      var data = getMapData(this, key),
	          size = data.size;
	
	      data.set(key, value);
	      this.size += data.size == size ? 0 : 1;
	      return this;
	    }
	
	    // Add methods to `MapCache`.
	    MapCache.prototype.clear = mapCacheClear;
	    MapCache.prototype['delete'] = mapCacheDelete;
	    MapCache.prototype.get = mapCacheGet;
	    MapCache.prototype.has = mapCacheHas;
	    MapCache.prototype.set = mapCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     *
	     * Creates an array cache object to store unique values.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [values] The values to cache.
	     */
	    function SetCache(values) {
	      var index = -1,
	          length = values == null ? 0 : values.length;
	
	      this.__data__ = new MapCache;
	      while (++index < length) {
	        this.add(values[index]);
	      }
	    }
	
	    /**
	     * Adds `value` to the array cache.
	     *
	     * @private
	     * @name add
	     * @memberOf SetCache
	     * @alias push
	     * @param {*} value The value to cache.
	     * @returns {Object} Returns the cache instance.
	     */
	    function setCacheAdd(value) {
	      this.__data__.set(value, HASH_UNDEFINED);
	      return this;
	    }
	
	    /**
	     * Checks if `value` is in the array cache.
	     *
	     * @private
	     * @name has
	     * @memberOf SetCache
	     * @param {*} value The value to search for.
	     * @returns {number} Returns `true` if `value` is found, else `false`.
	     */
	    function setCacheHas(value) {
	      return this.__data__.has(value);
	    }
	
	    // Add methods to `SetCache`.
	    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	    SetCache.prototype.has = setCacheHas;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a stack cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Stack(entries) {
	      var data = this.__data__ = new ListCache(entries);
	      this.size = data.size;
	    }
	
	    /**
	     * Removes all key-value entries from the stack.
	     *
	     * @private
	     * @name clear
	     * @memberOf Stack
	     */
	    function stackClear() {
	      this.__data__ = new ListCache;
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the stack.
	     *
	     * @private
	     * @name delete
	     * @memberOf Stack
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function stackDelete(key) {
	      var data = this.__data__,
	          result = data['delete'](key);
	
	      this.size = data.size;
	      return result;
	    }
	
	    /**
	     * Gets the stack value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Stack
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function stackGet(key) {
	      return this.__data__.get(key);
	    }
	
	    /**
	     * Checks if a stack value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Stack
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function stackHas(key) {
	      return this.__data__.has(key);
	    }
	
	    /**
	     * Sets the stack `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Stack
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the stack cache instance.
	     */
	    function stackSet(key, value) {
	      var data = this.__data__;
	      if (data instanceof ListCache) {
	        var pairs = data.__data__;
	        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	          pairs.push([key, value]);
	          this.size = ++data.size;
	          return this;
	        }
	        data = this.__data__ = new MapCache(pairs);
	      }
	      data.set(key, value);
	      this.size = data.size;
	      return this;
	    }
	
	    // Add methods to `Stack`.
	    Stack.prototype.clear = stackClear;
	    Stack.prototype['delete'] = stackDelete;
	    Stack.prototype.get = stackGet;
	    Stack.prototype.has = stackHas;
	    Stack.prototype.set = stackSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of the enumerable property names of the array-like `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @param {boolean} inherited Specify returning inherited property names.
	     * @returns {Array} Returns the array of property names.
	     */
	    function arrayLikeKeys(value, inherited) {
	      var isArr = isArray(value),
	          isArg = !isArr && isArguments(value),
	          isBuff = !isArr && !isArg && isBuffer(value),
	          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	          skipIndexes = isArr || isArg || isBuff || isType,
	          result = skipIndexes ? baseTimes(value.length, String) : [],
	          length = result.length;
	
	      for (var key in value) {
	        if ((inherited || hasOwnProperty.call(value, key)) &&
	            !(skipIndexes && (
	               // Safari 9 has enumerable `arguments.length` in strict mode.
	               key == 'length' ||
	               // Node.js 0.10 has enumerable non-index properties on buffers.
	               (isBuff && (key == 'offset' || key == 'parent')) ||
	               // PhantomJS 2 has enumerable non-index properties on typed arrays.
	               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	               // Skip index properties.
	               isIndex(key, length)
	            ))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `_.sample` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @returns {*} Returns the random element.
	     */
	    function arraySample(array) {
	      var length = array.length;
	      return length ? array[baseRandom(0, length - 1)] : undefined;
	    }
	
	    /**
	     * A specialized version of `_.sampleSize` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function arraySampleSize(array, n) {
	      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
	    }
	
	    /**
	     * A specialized version of `_.shuffle` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function arrayShuffle(array) {
	      return shuffleSelf(copyArray(array));
	    }
	
	    /**
	     * This function is like `assignValue` except that it doesn't assign
	     * `undefined` values.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignMergeValue(object, key, value) {
	      if ((value !== undefined && !eq(object[key], value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }
	
	    /**
	     * Assigns `value` to `key` of `object` if the existing value is not equivalent
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignValue(object, key, value) {
	      var objValue = object[key];
	      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }
	
	    /**
	     * Gets the index at which the `key` is found in `array` of key-value pairs.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {*} key The key to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     */
	    function assocIndexOf(array, key) {
	      var length = array.length;
	      while (length--) {
	        if (eq(array[length][0], key)) {
	          return length;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * Aggregates elements of `collection` on `accumulator` with keys transformed
	     * by `iteratee` and values set by `setter`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform keys.
	     * @param {Object} accumulator The initial aggregated object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseAggregator(collection, setter, iteratee, accumulator) {
	      baseEach(collection, function(value, key, collection) {
	        setter(accumulator, value, iteratee(value), collection);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.assign` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssign(object, source) {
	      return object && copyObject(source, keys(source), object);
	    }
	
	    /**
	     * The base implementation of `_.assignIn` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssignIn(object, source) {
	      return object && copyObject(source, keysIn(source), object);
	    }
	
	    /**
	     * The base implementation of `assignValue` and `assignMergeValue` without
	     * value checks.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function baseAssignValue(object, key, value) {
	      if (key == '__proto__' && defineProperty) {
	        defineProperty(object, key, {
	          'configurable': true,
	          'enumerable': true,
	          'value': value,
	          'writable': true
	        });
	      } else {
	        object[key] = value;
	      }
	    }
	
	    /**
	     * The base implementation of `_.at` without support for individual paths.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Array} Returns the picked elements.
	     */
	    function baseAt(object, paths) {
	      var index = -1,
	          length = paths.length,
	          result = Array(length),
	          skip = object == null;
	
	      while (++index < length) {
	        result[index] = skip ? undefined : get(object, paths[index]);
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.clamp` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     */
	    function baseClamp(number, lower, upper) {
	      if (number === number) {
	        if (upper !== undefined) {
	          number = number <= upper ? number : upper;
	        }
	        if (lower !== undefined) {
	          number = number >= lower ? number : lower;
	        }
	      }
	      return number;
	    }
	
	    /**
	     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	     * traversed objects.
	     *
	     * @private
	     * @param {*} value The value to clone.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Deep clone
	     *  2 - Flatten inherited properties
	     *  4 - Clone symbols
	     * @param {Function} [customizer] The function to customize cloning.
	     * @param {string} [key] The key of `value`.
	     * @param {Object} [object] The parent object of `value`.
	     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	     * @returns {*} Returns the cloned value.
	     */
	    function baseClone(value, bitmask, customizer, key, object, stack) {
	      var result,
	          isDeep = bitmask & CLONE_DEEP_FLAG,
	          isFlat = bitmask & CLONE_FLAT_FLAG,
	          isFull = bitmask & CLONE_SYMBOLS_FLAG;
	
	      if (customizer) {
	        result = object ? customizer(value, key, object, stack) : customizer(value);
	      }
	      if (result !== undefined) {
	        return result;
	      }
	      if (!isObject(value)) {
	        return value;
	      }
	      var isArr = isArray(value);
	      if (isArr) {
	        result = initCloneArray(value);
	        if (!isDeep) {
	          return copyArray(value, result);
	        }
	      } else {
	        var tag = getTag(value),
	            isFunc = tag == funcTag || tag == genTag;
	
	        if (isBuffer(value)) {
	          return cloneBuffer(value, isDeep);
	        }
	        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	          result = (isFlat || isFunc) ? {} : initCloneObject(value);
	          if (!isDeep) {
	            return isFlat
	              ? copySymbolsIn(value, baseAssignIn(result, value))
	              : copySymbols(value, baseAssign(result, value));
	          }
	        } else {
	          if (!cloneableTags[tag]) {
	            return object ? value : {};
	          }
	          result = initCloneByTag(value, tag, isDeep);
	        }
	      }
	      // Check for circular references and return its corresponding clone.
	      stack || (stack = new Stack);
	      var stacked = stack.get(value);
	      if (stacked) {
	        return stacked;
	      }
	      stack.set(value, result);
	
	      if (isSet(value)) {
	        value.forEach(function(subValue) {
	          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
	        });
	      } else if (isMap(value)) {
	        value.forEach(function(subValue, key) {
	          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
	        });
	      }
	
	      var keysFunc = isFull
	        ? (isFlat ? getAllKeysIn : getAllKeys)
	        : (isFlat ? keysIn : keys);
	
	      var props = isArr ? undefined : keysFunc(value);
	      arrayEach(props || value, function(subValue, key) {
	        if (props) {
	          key = subValue;
	          subValue = value[key];
	        }
	        // Recursively populate clone (susceptible to call stack limits).
	        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.conforms` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseConforms(source) {
	      var props = keys(source);
	      return function(object) {
	        return baseConformsTo(object, source, props);
	      };
	    }
	
	    /**
	     * The base implementation of `_.conformsTo` which accepts `props` to check.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     */
	    function baseConformsTo(object, source, props) {
	      var length = props.length;
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (length--) {
	        var key = props[length],
	            predicate = source[key],
	            value = object[key];
	
	        if ((value === undefined && !(key in object)) || !predicate(value)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.delay` and `_.defer` which accepts `args`
	     * to provide to `func`.
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {Array} args The arguments to provide to `func`.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    function baseDelay(func, wait, args) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return setTimeout(function() { func.apply(undefined, args); }, wait);
	    }
	
	    /**
	     * The base implementation of methods like `_.difference` without support
	     * for excluding multiple arrays or iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Array} values The values to exclude.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     */
	    function baseDifference(array, values, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          isCommon = true,
	          length = array.length,
	          result = [],
	          valuesLength = values.length;
	
	      if (!length) {
	        return result;
	      }
	      if (iteratee) {
	        values = arrayMap(values, baseUnary(iteratee));
	      }
	      if (comparator) {
	        includes = arrayIncludesWith;
	        isCommon = false;
	      }
	      else if (values.length >= LARGE_ARRAY_SIZE) {
	        includes = cacheHas;
	        isCommon = false;
	        values = new SetCache(values);
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee == null ? value : iteratee(value);
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var valuesIndex = valuesLength;
	          while (valuesIndex--) {
	            if (values[valuesIndex] === computed) {
	              continue outer;
	            }
	          }
	          result.push(value);
	        }
	        else if (!includes(values, computed, comparator)) {
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.forEach` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEach = createBaseEach(baseForOwn);
	
	    /**
	     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEachRight = createBaseEach(baseForOwnRight, true);
	
	    /**
	     * The base implementation of `_.every` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`
	     */
	    function baseEvery(collection, predicate) {
	      var result = true;
	      baseEach(collection, function(value, index, collection) {
	        result = !!predicate(value, index, collection);
	        return result;
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of methods like `_.max` and `_.min` which accepts a
	     * `comparator` to determine the extremum value.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The iteratee invoked per iteration.
	     * @param {Function} comparator The comparator used to compare values.
	     * @returns {*} Returns the extremum value.
	     */
	    function baseExtremum(array, iteratee, comparator) {
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        var value = array[index],
	            current = iteratee(value);
	
	        if (current != null && (computed === undefined
	              ? (current === current && !isSymbol(current))
	              : comparator(current, computed)
	            )) {
	          var computed = current,
	              result = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.fill` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     */
	    function baseFill(array, value, start, end) {
	      var length = array.length;
	
	      start = toInteger(start);
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = (end === undefined || end > length) ? length : toInteger(end);
	      if (end < 0) {
	        end += length;
	      }
	      end = start > end ? 0 : toLength(end);
	      while (start < end) {
	        array[start++] = value;
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.filter` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     */
	    function baseFilter(collection, predicate) {
	      var result = [];
	      baseEach(collection, function(value, index, collection) {
	        if (predicate(value, index, collection)) {
	          result.push(value);
	        }
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.flatten` with support for restricting flattening.
	     *
	     * @private
	     * @param {Array} array The array to flatten.
	     * @param {number} depth The maximum recursion depth.
	     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	     * @param {Array} [result=[]] The initial result value.
	     * @returns {Array} Returns the new flattened array.
	     */
	    function baseFlatten(array, depth, predicate, isStrict, result) {
	      var index = -1,
	          length = array.length;
	
	      predicate || (predicate = isFlattenable);
	      result || (result = []);
	
	      while (++index < length) {
	        var value = array[index];
	        if (depth > 0 && predicate(value)) {
	          if (depth > 1) {
	            // Recursively flatten arrays (susceptible to call stack limits).
	            baseFlatten(value, depth - 1, predicate, isStrict, result);
	          } else {
	            arrayPush(result, value);
	          }
	        } else if (!isStrict) {
	          result[result.length] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `baseForOwn` which iterates over `object`
	     * properties returned by `keysFunc` and invokes `iteratee` for each property.
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseFor = createBaseFor();
	
	    /**
	     * This function is like `baseFor` except that it iterates over properties
	     * in the opposite order.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseForRight = createBaseFor(true);
	
	    /**
	     * The base implementation of `_.forOwn` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwn(object, iteratee) {
	      return object && baseFor(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwnRight(object, iteratee) {
	      return object && baseForRight(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.functions` which creates an array of
	     * `object` function property names filtered from `props`.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Array} props The property names to filter.
	     * @returns {Array} Returns the function names.
	     */
	    function baseFunctions(object, props) {
	      return arrayFilter(props, function(key) {
	        return isFunction(object[key]);
	      });
	    }
	
	    /**
	     * The base implementation of `_.get` without support for default values.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseGet(object, path) {
	      path = castPath(path, object);
	
	      var index = 0,
	          length = path.length;
	
	      while (object != null && index < length) {
	        object = object[toKey(path[index++])];
	      }
	      return (index && index == length) ? object : undefined;
	    }
	
	    /**
	     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @param {Function} symbolsFunc The function to get the symbols of `object`.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	      var result = keysFunc(object);
	      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	    }
	
	    /**
	     * The base implementation of `getTag` without fallbacks for buggy environments.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    function baseGetTag(value) {
	      if (value == null) {
	        return value === undefined ? undefinedTag : nullTag;
	      }
	      return (symToStringTag && symToStringTag in Object(value))
	        ? getRawTag(value)
	        : objectToString(value);
	    }
	
	    /**
	     * The base implementation of `_.gt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     */
	    function baseGt(value, other) {
	      return value > other;
	    }
	
	    /**
	     * The base implementation of `_.has` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHas(object, key) {
	      return object != null && hasOwnProperty.call(object, key);
	    }
	
	    /**
	     * The base implementation of `_.hasIn` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHasIn(object, key) {
	      return object != null && key in Object(object);
	    }
	
	    /**
	     * The base implementation of `_.inRange` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to check.
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     */
	    function baseInRange(number, start, end) {
	      return number >= nativeMin(start, end) && number < nativeMax(start, end);
	    }
	
	    /**
	     * The base implementation of methods like `_.intersection`, without support
	     * for iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of shared values.
	     */
	    function baseIntersection(arrays, iteratee, comparator) {
	      var includes = comparator ? arrayIncludesWith : arrayIncludes,
	          length = arrays[0].length,
	          othLength = arrays.length,
	          othIndex = othLength,
	          caches = Array(othLength),
	          maxLength = Infinity,
	          result = [];
	
	      while (othIndex--) {
	        var array = arrays[othIndex];
	        if (othIndex && iteratee) {
	          array = arrayMap(array, baseUnary(iteratee));
	        }
	        maxLength = nativeMin(array.length, maxLength);
	        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
	          ? new SetCache(othIndex && array)
	          : undefined;
	      }
	      array = arrays[0];
	
	      var index = -1,
	          seen = caches[0];
	
	      outer:
	      while (++index < length && result.length < maxLength) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (!(seen
	              ? cacheHas(seen, computed)
	              : includes(result, computed, comparator)
	            )) {
	          othIndex = othLength;
	          while (--othIndex) {
	            var cache = caches[othIndex];
	            if (!(cache
	                  ? cacheHas(cache, computed)
	                  : includes(arrays[othIndex], computed, comparator))
	                ) {
	              continue outer;
	            }
	          }
	          if (seen) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.invert` and `_.invertBy` which inverts
	     * `object` with values transformed by `iteratee` and set by `setter`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform values.
	     * @param {Object} accumulator The initial inverted object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseInverter(object, setter, iteratee, accumulator) {
	      baseForOwn(object, function(value, key, object) {
	        setter(accumulator, iteratee(value), key, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.invoke` without support for individual
	     * method arguments.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {Array} args The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     */
	    function baseInvoke(object, path, args) {
	      path = castPath(path, object);
	      object = parent(object, path);
	      var func = object == null ? object : object[toKey(last(path))];
	      return func == null ? undefined : apply(func, object, args);
	    }
	
	    /**
	     * The base implementation of `_.isArguments`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     */
	    function baseIsArguments(value) {
	      return isObjectLike(value) && baseGetTag(value) == argsTag;
	    }
	
	    /**
	     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     */
	    function baseIsArrayBuffer(value) {
	      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
	    }
	
	    /**
	     * The base implementation of `_.isDate` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     */
	    function baseIsDate(value) {
	      return isObjectLike(value) && baseGetTag(value) == dateTag;
	    }
	
	    /**
	     * The base implementation of `_.isEqual` which supports partial comparisons
	     * and tracks traversed objects.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Unordered comparison
	     *  2 - Partial comparison
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     */
	    function baseIsEqual(value, other, bitmask, customizer, stack) {
	      if (value === other) {
	        return true;
	      }
	      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	        return value !== value && other !== other;
	      }
	      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	    }
	
	    /**
	     * A specialized version of `baseIsEqual` for arrays and objects which performs
	     * deep comparisons and tracks traversed objects enabling objects with circular
	     * references to be compared.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	      var objIsArr = isArray(object),
	          othIsArr = isArray(other),
	          objTag = objIsArr ? arrayTag : getTag(object),
	          othTag = othIsArr ? arrayTag : getTag(other);
	
	      objTag = objTag == argsTag ? objectTag : objTag;
	      othTag = othTag == argsTag ? objectTag : othTag;
	
	      var objIsObj = objTag == objectTag,
	          othIsObj = othTag == objectTag,
	          isSameTag = objTag == othTag;
	
	      if (isSameTag && isBuffer(object)) {
	        if (!isBuffer(other)) {
	          return false;
	        }
	        objIsArr = true;
	        objIsObj = false;
	      }
	      if (isSameTag && !objIsObj) {
	        stack || (stack = new Stack);
	        return (objIsArr || isTypedArray(object))
	          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	      }
	      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	        if (objIsWrapped || othIsWrapped) {
	          var objUnwrapped = objIsWrapped ? object.value() : object,
	              othUnwrapped = othIsWrapped ? other.value() : other;
	
	          stack || (stack = new Stack);
	          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	        }
	      }
	      if (!isSameTag) {
	        return false;
	      }
	      stack || (stack = new Stack);
	      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	    }
	
	    /**
	     * The base implementation of `_.isMap` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     */
	    function baseIsMap(value) {
	      return isObjectLike(value) && getTag(value) == mapTag;
	    }
	
	    /**
	     * The base implementation of `_.isMatch` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Array} matchData The property names, values, and compare flags to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     */
	    function baseIsMatch(object, source, matchData, customizer) {
	      var index = matchData.length,
	          length = index,
	          noCustomizer = !customizer;
	
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (index--) {
	        var data = matchData[index];
	        if ((noCustomizer && data[2])
	              ? data[1] !== object[data[0]]
	              : !(data[0] in object)
	            ) {
	          return false;
	        }
	      }
	      while (++index < length) {
	        data = matchData[index];
	        var key = data[0],
	            objValue = object[key],
	            srcValue = data[1];
	
	        if (noCustomizer && data[2]) {
	          if (objValue === undefined && !(key in object)) {
	            return false;
	          }
	        } else {
	          var stack = new Stack;
	          if (customizer) {
	            var result = customizer(objValue, srcValue, key, object, source, stack);
	          }
	          if (!(result === undefined
	                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	                : result
	              )) {
	            return false;
	          }
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.isNative` without bad shim checks.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     */
	    function baseIsNative(value) {
	      if (!isObject(value) || isMasked(value)) {
	        return false;
	      }
	      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	      return pattern.test(toSource(value));
	    }
	
	    /**
	     * The base implementation of `_.isRegExp` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     */
	    function baseIsRegExp(value) {
	      return isObjectLike(value) && baseGetTag(value) == regexpTag;
	    }
	
	    /**
	     * The base implementation of `_.isSet` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     */
	    function baseIsSet(value) {
	      return isObjectLike(value) && getTag(value) == setTag;
	    }
	
	    /**
	     * The base implementation of `_.isTypedArray` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     */
	    function baseIsTypedArray(value) {
	      return isObjectLike(value) &&
	        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	    }
	
	    /**
	     * The base implementation of `_.iteratee`.
	     *
	     * @private
	     * @param {*} [value=_.identity] The value to convert to an iteratee.
	     * @returns {Function} Returns the iteratee.
	     */
	    function baseIteratee(value) {
	      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	      if (typeof value == 'function') {
	        return value;
	      }
	      if (value == null) {
	        return identity;
	      }
	      if (typeof value == 'object') {
	        return isArray(value)
	          ? baseMatchesProperty(value[0], value[1])
	          : baseMatches(value);
	      }
	      return property(value);
	    }
	
	    /**
	     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeys(object) {
	      if (!isPrototype(object)) {
	        return nativeKeys(object);
	      }
	      var result = [];
	      for (var key in Object(object)) {
	        if (hasOwnProperty.call(object, key) && key != 'constructor') {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeysIn(object) {
	      if (!isObject(object)) {
	        return nativeKeysIn(object);
	      }
	      var isProto = isPrototype(object),
	          result = [];
	
	      for (var key in object) {
	        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.lt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     */
	    function baseLt(value, other) {
	      return value < other;
	    }
	
	    /**
	     * The base implementation of `_.map` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     */
	    function baseMap(collection, iteratee) {
	      var index = -1,
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value, key, collection) {
	        result[++index] = iteratee(value, key, collection);
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.matches` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatches(source) {
	      var matchData = getMatchData(source);
	      if (matchData.length == 1 && matchData[0][2]) {
	        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	      }
	      return function(object) {
	        return object === source || baseIsMatch(object, source, matchData);
	      };
	    }
	
	    /**
	     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	     *
	     * @private
	     * @param {string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatchesProperty(path, srcValue) {
	      if (isKey(path) && isStrictComparable(srcValue)) {
	        return matchesStrictComparable(toKey(path), srcValue);
	      }
	      return function(object) {
	        var objValue = get(object, path);
	        return (objValue === undefined && objValue === srcValue)
	          ? hasIn(object, path)
	          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	      };
	    }
	
	    /**
	     * The base implementation of `_.merge` without support for multiple sources.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} [customizer] The function to customize merged values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMerge(object, source, srcIndex, customizer, stack) {
	      if (object === source) {
	        return;
	      }
	      baseFor(source, function(srcValue, key) {
	        stack || (stack = new Stack);
	        if (isObject(srcValue)) {
	          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
	        }
	        else {
	          var newValue = customizer
	            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
	            : undefined;
	
	          if (newValue === undefined) {
	            newValue = srcValue;
	          }
	          assignMergeValue(object, key, newValue);
	        }
	      }, keysIn);
	    }
	
	    /**
	     * A specialized version of `baseMerge` for arrays and objects which performs
	     * deep merges and tracks traversed objects enabling objects with circular
	     * references to be merged.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {string} key The key of the value to merge.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} mergeFunc The function to merge values.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
	      var objValue = safeGet(object, key),
	          srcValue = safeGet(source, key),
	          stacked = stack.get(srcValue);
	
	      if (stacked) {
	        assignMergeValue(object, key, stacked);
	        return;
	      }
	      var newValue = customizer
	        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
	        : undefined;
	
	      var isCommon = newValue === undefined;
	
	      if (isCommon) {
	        var isArr = isArray(srcValue),
	            isBuff = !isArr && isBuffer(srcValue),
	            isTyped = !isArr && !isBuff && isTypedArray(srcValue);
	
	        newValue = srcValue;
	        if (isArr || isBuff || isTyped) {
	          if (isArray(objValue)) {
	            newValue = objValue;
	          }
	          else if (isArrayLikeObject(objValue)) {
	            newValue = copyArray(objValue);
	          }
	          else if (isBuff) {
	            isCommon = false;
	            newValue = cloneBuffer(srcValue, true);
	          }
	          else if (isTyped) {
	            isCommon = false;
	            newValue = cloneTypedArray(srcValue, true);
	          }
	          else {
	            newValue = [];
	          }
	        }
	        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	          newValue = objValue;
	          if (isArguments(objValue)) {
	            newValue = toPlainObject(objValue);
	          }
	          else if (!isObject(objValue) || isFunction(objValue)) {
	            newValue = initCloneObject(srcValue);
	          }
	        }
	        else {
	          isCommon = false;
	        }
	      }
	      if (isCommon) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, newValue);
	        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
	        stack['delete'](srcValue);
	      }
	      assignMergeValue(object, key, newValue);
	    }
	
	    /**
	     * The base implementation of `_.nth` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {number} n The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     */
	    function baseNth(array, n) {
	      var length = array.length;
	      if (!length) {
	        return;
	      }
	      n += n < 0 ? length : 0;
	      return isIndex(n, length) ? array[n] : undefined;
	    }
	
	    /**
	     * The base implementation of `_.orderBy` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	     * @param {string[]} orders The sort orders of `iteratees`.
	     * @returns {Array} Returns the new sorted array.
	     */
	    function baseOrderBy(collection, iteratees, orders) {
	      if (iteratees.length) {
	        iteratees = arrayMap(iteratees, function(iteratee) {
	          if (isArray(iteratee)) {
	            return function(value) {
	              return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
	            }
	          }
	          return iteratee;
	        });
	      } else {
	        iteratees = [identity];
	      }
	
	      var index = -1;
	      iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
	
	      var result = baseMap(collection, function(value, key, collection) {
	        var criteria = arrayMap(iteratees, function(iteratee) {
	          return iteratee(value);
	        });
	        return { 'criteria': criteria, 'index': ++index, 'value': value };
	      });
	
	      return baseSortBy(result, function(object, other) {
	        return compareMultiple(object, other, orders);
	      });
	    }
	
	    /**
	     * The base implementation of `_.pick` without support for individual
	     * property identifiers.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Object} Returns the new object.
	     */
	    function basePick(object, paths) {
	      return basePickBy(object, paths, function(value, path) {
	        return hasIn(object, path);
	      });
	    }
	
	    /**
	     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @param {Function} predicate The function invoked per property.
	     * @returns {Object} Returns the new object.
	     */
	    function basePickBy(object, paths, predicate) {
	      var index = -1,
	          length = paths.length,
	          result = {};
	
	      while (++index < length) {
	        var path = paths[index],
	            value = baseGet(object, path);
	
	        if (predicate(value, path)) {
	          baseSet(result, castPath(path, object), value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseProperty` which supports deep paths.
	     *
	     * @private
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     */
	    function basePropertyDeep(path) {
	      return function(object) {
	        return baseGet(object, path);
	      };
	    }
	
	    /**
	     * The base implementation of `_.pullAllBy` without support for iteratee
	     * shorthands.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAll(array, values, iteratee, comparator) {
	      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
	          index = -1,
	          length = values.length,
	          seen = array;
	
	      if (array === values) {
	        values = copyArray(values);
	      }
	      if (iteratee) {
	        seen = arrayMap(array, baseUnary(iteratee));
	      }
	      while (++index < length) {
	        var fromIndex = 0,
	            value = values[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
	          if (seen !== array) {
	            splice.call(seen, fromIndex, 1);
	          }
	          splice.call(array, fromIndex, 1);
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.pullAt` without support for individual
	     * indexes or capturing the removed elements.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {number[]} indexes The indexes of elements to remove.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAt(array, indexes) {
	      var length = array ? indexes.length : 0,
	          lastIndex = length - 1;
	
	      while (length--) {
	        var index = indexes[length];
	        if (length == lastIndex || index !== previous) {
	          var previous = index;
	          if (isIndex(index)) {
	            splice.call(array, index, 1);
	          } else {
	            baseUnset(array, index);
	          }
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.random` without support for returning
	     * floating-point numbers.
	     *
	     * @private
	     * @param {number} lower The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the random number.
	     */
	    function baseRandom(lower, upper) {
	      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
	    }
	
	    /**
	     * The base implementation of `_.range` and `_.rangeRight` which doesn't
	     * coerce arguments.
	     *
	     * @private
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} step The value to increment or decrement by.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the range of numbers.
	     */
	    function baseRange(start, end, step, fromRight) {
	      var index = -1,
	          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
	          result = Array(length);
	
	      while (length--) {
	        result[fromRight ? length : ++index] = start;
	        start += step;
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.repeat` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {string} string The string to repeat.
	     * @param {number} n The number of times to repeat the string.
	     * @returns {string} Returns the repeated string.
	     */
	    function baseRepeat(string, n) {
	      var result = '';
	      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
	        return result;
	      }
	      // Leverage the exponentiation by squaring algorithm for a faster repeat.
	      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
	      do {
	        if (n % 2) {
	          result += string;
	        }
	        n = nativeFloor(n / 2);
	        if (n) {
	          string += string;
	        }
	      } while (n);
	
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     */
	    function baseRest(func, start) {
	      return setToString(overRest(func, start, identity), func + '');
	    }
	
	    /**
	     * The base implementation of `_.sample`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     */
	    function baseSample(collection) {
	      return arraySample(values(collection));
	    }
	
	    /**
	     * The base implementation of `_.sampleSize` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function baseSampleSize(collection, n) {
	      var array = values(collection);
	      return shuffleSelf(array, baseClamp(n, 0, array.length));
	    }
	
	    /**
	     * The base implementation of `_.set`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseSet(object, path, value, customizer) {
	      if (!isObject(object)) {
	        return object;
	      }
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length,
	          lastIndex = length - 1,
	          nested = object;
	
	      while (nested != null && ++index < length) {
	        var key = toKey(path[index]),
	            newValue = value;
	
	        if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
	          return object;
	        }
	
	        if (index != lastIndex) {
	          var objValue = nested[key];
	          newValue = customizer ? customizer(objValue, key, nested) : undefined;
	          if (newValue === undefined) {
	            newValue = isObject(objValue)
	              ? objValue
	              : (isIndex(path[index + 1]) ? [] : {});
	          }
	        }
	        assignValue(nested, key, newValue);
	        nested = nested[key];
	      }
	      return object;
	    }
	
	    /**
	     * The base implementation of `setData` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetData = !metaMap ? identity : function(func, data) {
	      metaMap.set(func, data);
	      return func;
	    };
	
	    /**
	     * The base implementation of `setToString` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetToString = !defineProperty ? identity : function(func, string) {
	      return defineProperty(func, 'toString', {
	        'configurable': true,
	        'enumerable': false,
	        'value': constant(string),
	        'writable': true
	      });
	    };
	
	    /**
	     * The base implementation of `_.shuffle`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function baseShuffle(collection) {
	      return shuffleSelf(values(collection));
	    }
	
	    /**
	     * The base implementation of `_.slice` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseSlice(array, start, end) {
	      var index = -1,
	          length = array.length;
	
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = end > length ? length : end;
	      if (end < 0) {
	        end += length;
	      }
	      length = start > end ? 0 : ((end - start) >>> 0);
	      start >>>= 0;
	
	      var result = Array(length);
	      while (++index < length) {
	        result[index] = array[index + start];
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.some` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     */
	    function baseSome(collection, predicate) {
	      var result;
	
	      baseEach(collection, function(value, index, collection) {
	        result = predicate(value, index, collection);
	        return !result;
	      });
	      return !!result;
	    }
	
	    /**
	     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
	     * performs a binary search of `array` to determine the index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndex(array, value, retHighest) {
	      var low = 0,
	          high = array == null ? low : array.length;
	
	      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
	        while (low < high) {
	          var mid = (low + high) >>> 1,
	              computed = array[mid];
	
	          if (computed !== null && !isSymbol(computed) &&
	              (retHighest ? (computed <= value) : (computed < value))) {
	            low = mid + 1;
	          } else {
	            high = mid;
	          }
	        }
	        return high;
	      }
	      return baseSortedIndexBy(array, value, identity, retHighest);
	    }
	
	    /**
	     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
	     * which invokes `iteratee` for `value` and each element of `array` to compute
	     * their sort ranking. The iteratee is invoked with one argument; (value).
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} iteratee The iteratee invoked per element.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndexBy(array, value, iteratee, retHighest) {
	      var low = 0,
	          high = array == null ? 0 : array.length;
	      if (high === 0) {
	        return 0;
	      }
	
	      value = iteratee(value);
	      var valIsNaN = value !== value,
	          valIsNull = value === null,
	          valIsSymbol = isSymbol(value),
	          valIsUndefined = value === undefined;
	
	      while (low < high) {
	        var mid = nativeFloor((low + high) / 2),
	            computed = iteratee(array[mid]),
	            othIsDefined = computed !== undefined,
	            othIsNull = computed === null,
	            othIsReflexive = computed === computed,
	            othIsSymbol = isSymbol(computed);
	
	        if (valIsNaN) {
	          var setLow = retHighest || othIsReflexive;
	        } else if (valIsUndefined) {
	          setLow = othIsReflexive && (retHighest || othIsDefined);
	        } else if (valIsNull) {
	          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
	        } else if (valIsSymbol) {
	          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
	        } else if (othIsNull || othIsSymbol) {
	          setLow = false;
	        } else {
	          setLow = retHighest ? (computed <= value) : (computed < value);
	        }
	        if (setLow) {
	          low = mid + 1;
	        } else {
	          high = mid;
	        }
	      }
	      return nativeMin(high, MAX_ARRAY_INDEX);
	    }
	
	    /**
	     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
	     * support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseSortedUniq(array, iteratee) {
	      var index = -1,
	          length = array.length,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        if (!index || !eq(computed, seen)) {
	          var seen = computed;
	          result[resIndex++] = value === 0 ? 0 : value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.toNumber` which doesn't ensure correct
	     * conversions of binary, hexadecimal, or octal string values.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     */
	    function baseToNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      return +value;
	    }
	
	    /**
	     * The base implementation of `_.toString` which doesn't convert nullish
	     * values to empty strings.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {string} Returns the string.
	     */
	    function baseToString(value) {
	      // Exit early for strings to avoid a performance hit in some environments.
	      if (typeof value == 'string') {
	        return value;
	      }
	      if (isArray(value)) {
	        // Recursively convert values (susceptible to call stack limits).
	        return arrayMap(value, baseToString) + '';
	      }
	      if (isSymbol(value)) {
	        return symbolToString ? symbolToString.call(value) : '';
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseUniq(array, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          length = array.length,
	          isCommon = true,
	          result = [],
	          seen = result;
	
	      if (comparator) {
	        isCommon = false;
	        includes = arrayIncludesWith;
	      }
	      else if (length >= LARGE_ARRAY_SIZE) {
	        var set = iteratee ? null : createSet(array);
	        if (set) {
	          return setToArray(set);
	        }
	        isCommon = false;
	        includes = cacheHas;
	        seen = new SetCache;
	      }
	      else {
	        seen = iteratee ? [] : result;
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var seenIndex = seen.length;
	          while (seenIndex--) {
	            if (seen[seenIndex] === computed) {
	              continue outer;
	            }
	          }
	          if (iteratee) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	        else if (!includes(seen, computed, comparator)) {
	          if (seen !== result) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.unset`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The property path to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     */
	    function baseUnset(object, path) {
	      path = castPath(path, object);
	      object = parent(object, path);
	      return object == null || delete object[toKey(last(path))];
	    }
	
	    /**
	     * The base implementation of `_.update`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to update.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseUpdate(object, path, updater, customizer) {
	      return baseSet(object, path, updater(baseGet(object, path)), customizer);
	    }
	
	    /**
	     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
	     * without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {Function} predicate The function invoked per iteration.
	     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseWhile(array, predicate, isDrop, fromRight) {
	      var length = array.length,
	          index = fromRight ? length : -1;
	
	      while ((fromRight ? index-- : ++index < length) &&
	        predicate(array[index], index, array)) {}
	
	      return isDrop
	        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
	        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
	    }
	
	    /**
	     * The base implementation of `wrapperValue` which returns the result of
	     * performing a sequence of actions on the unwrapped `value`, where each
	     * successive action is supplied the return value of the previous.
	     *
	     * @private
	     * @param {*} value The unwrapped value.
	     * @param {Array} actions Actions to perform to resolve the unwrapped value.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseWrapperValue(value, actions) {
	      var result = value;
	      if (result instanceof LazyWrapper) {
	        result = result.value();
	      }
	      return arrayReduce(actions, function(result, action) {
	        return action.func.apply(action.thisArg, arrayPush([result], action.args));
	      }, result);
	    }
	
	    /**
	     * The base implementation of methods like `_.xor`, without support for
	     * iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of values.
	     */
	    function baseXor(arrays, iteratee, comparator) {
	      var length = arrays.length;
	      if (length < 2) {
	        return length ? baseUniq(arrays[0]) : [];
	      }
	      var index = -1,
	          result = Array(length);
	
	      while (++index < length) {
	        var array = arrays[index],
	            othIndex = -1;
	
	        while (++othIndex < length) {
	          if (othIndex != index) {
	            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
	          }
	        }
	      }
	      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
	    }
	
	    /**
	     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
	     *
	     * @private
	     * @param {Array} props The property identifiers.
	     * @param {Array} values The property values.
	     * @param {Function} assignFunc The function to assign values.
	     * @returns {Object} Returns the new object.
	     */
	    function baseZipObject(props, values, assignFunc) {
	      var index = -1,
	          length = props.length,
	          valsLength = values.length,
	          result = {};
	
	      while (++index < length) {
	        var value = index < valsLength ? values[index] : undefined;
	        assignFunc(result, props[index], value);
	      }
	      return result;
	    }
	
	    /**
	     * Casts `value` to an empty array if it's not an array like object.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Array|Object} Returns the cast array-like object.
	     */
	    function castArrayLikeObject(value) {
	      return isArrayLikeObject(value) ? value : [];
	    }
	
	    /**
	     * Casts `value` to `identity` if it's not a function.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Function} Returns cast function.
	     */
	    function castFunction(value) {
	      return typeof value == 'function' ? value : identity;
	    }
	
	    /**
	     * Casts `value` to a path array if it's not one.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {Array} Returns the cast property path array.
	     */
	    function castPath(value, object) {
	      if (isArray(value)) {
	        return value;
	      }
	      return isKey(value, object) ? [value] : stringToPath(toString(value));
	    }
	
	    /**
	     * A `baseRest` alias which can be replaced with `identity` by module
	     * replacement plugins.
	     *
	     * @private
	     * @type {Function}
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    var castRest = baseRest;
	
	    /**
	     * Casts `array` to a slice if it's needed.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {number} start The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the cast slice.
	     */
	    function castSlice(array, start, end) {
	      var length = array.length;
	      end = end === undefined ? length : end;
	      return (!start && end >= length) ? array : baseSlice(array, start, end);
	    }
	
	    /**
	     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
	     *
	     * @private
	     * @param {number|Object} id The timer id or timeout object of the timer to clear.
	     */
	    var clearTimeout = ctxClearTimeout || function(id) {
	      return root.clearTimeout(id);
	    };
	
	    /**
	     * Creates a clone of  `buffer`.
	     *
	     * @private
	     * @param {Buffer} buffer The buffer to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Buffer} Returns the cloned buffer.
	     */
	    function cloneBuffer(buffer, isDeep) {
	      if (isDeep) {
	        return buffer.slice();
	      }
	      var length = buffer.length,
	          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
	
	      buffer.copy(result);
	      return result;
	    }
	
	    /**
	     * Creates a clone of `arrayBuffer`.
	     *
	     * @private
	     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	     * @returns {ArrayBuffer} Returns the cloned array buffer.
	     */
	    function cloneArrayBuffer(arrayBuffer) {
	      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	      return result;
	    }
	
	    /**
	     * Creates a clone of `dataView`.
	     *
	     * @private
	     * @param {Object} dataView The data view to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned data view.
	     */
	    function cloneDataView(dataView, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	    }
	
	    /**
	     * Creates a clone of `regexp`.
	     *
	     * @private
	     * @param {Object} regexp The regexp to clone.
	     * @returns {Object} Returns the cloned regexp.
	     */
	    function cloneRegExp(regexp) {
	      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	      result.lastIndex = regexp.lastIndex;
	      return result;
	    }
	
	    /**
	     * Creates a clone of the `symbol` object.
	     *
	     * @private
	     * @param {Object} symbol The symbol object to clone.
	     * @returns {Object} Returns the cloned symbol object.
	     */
	    function cloneSymbol(symbol) {
	      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	    }
	
	    /**
	     * Creates a clone of `typedArray`.
	     *
	     * @private
	     * @param {Object} typedArray The typed array to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned typed array.
	     */
	    function cloneTypedArray(typedArray, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	    }
	
	    /**
	     * Compares values to sort them in ascending order.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {number} Returns the sort order indicator for `value`.
	     */
	    function compareAscending(value, other) {
	      if (value !== other) {
	        var valIsDefined = value !== undefined,
	            valIsNull = value === null,
	            valIsReflexive = value === value,
	            valIsSymbol = isSymbol(value);
	
	        var othIsDefined = other !== undefined,
	            othIsNull = other === null,
	            othIsReflexive = other === other,
	            othIsSymbol = isSymbol(other);
	
	        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
	            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
	            (valIsNull && othIsDefined && othIsReflexive) ||
	            (!valIsDefined && othIsReflexive) ||
	            !valIsReflexive) {
	          return 1;
	        }
	        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
	            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
	            (othIsNull && valIsDefined && valIsReflexive) ||
	            (!othIsDefined && valIsReflexive) ||
	            !othIsReflexive) {
	          return -1;
	        }
	      }
	      return 0;
	    }
	
	    /**
	     * Used by `_.orderBy` to compare multiple properties of a value to another
	     * and stable sort them.
	     *
	     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
	     * specify an order of "desc" for descending or "asc" for ascending sort order
	     * of corresponding values.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {boolean[]|string[]} orders The order to sort by for each property.
	     * @returns {number} Returns the sort order indicator for `object`.
	     */
	    function compareMultiple(object, other, orders) {
	      var index = -1,
	          objCriteria = object.criteria,
	          othCriteria = other.criteria,
	          length = objCriteria.length,
	          ordersLength = orders.length;
	
	      while (++index < length) {
	        var result = compareAscending(objCriteria[index], othCriteria[index]);
	        if (result) {
	          if (index >= ordersLength) {
	            return result;
	          }
	          var order = orders[index];
	          return result * (order == 'desc' ? -1 : 1);
	        }
	      }
	      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	      // that causes it, under certain circumstances, to provide the same value for
	      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	      // for more details.
	      //
	      // This also ensures a stable sort in V8 and other engines.
	      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
	      return object.index - other.index;
	    }
	
	    /**
	     * Creates an array that is the composition of partially applied arguments,
	     * placeholders, and provided arguments into a single array of arguments.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to prepend to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgs(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersLength = holders.length,
	          leftIndex = -1,
	          leftLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(leftLength + rangeLength),
	          isUncurried = !isCurried;
	
	      while (++leftIndex < leftLength) {
	        result[leftIndex] = partials[leftIndex];
	      }
	      while (++argsIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[holders[argsIndex]] = args[argsIndex];
	        }
	      }
	      while (rangeLength--) {
	        result[leftIndex++] = args[argsIndex++];
	      }
	      return result;
	    }
	
	    /**
	     * This function is like `composeArgs` except that the arguments composition
	     * is tailored for `_.partialRight`.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to append to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgsRight(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersIndex = -1,
	          holdersLength = holders.length,
	          rightIndex = -1,
	          rightLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(rangeLength + rightLength),
	          isUncurried = !isCurried;
	
	      while (++argsIndex < rangeLength) {
	        result[argsIndex] = args[argsIndex];
	      }
	      var offset = argsIndex;
	      while (++rightIndex < rightLength) {
	        result[offset + rightIndex] = partials[rightIndex];
	      }
	      while (++holdersIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[offset + holders[holdersIndex]] = args[argsIndex++];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Copies the values of `source` to `array`.
	     *
	     * @private
	     * @param {Array} source The array to copy values from.
	     * @param {Array} [array=[]] The array to copy values to.
	     * @returns {Array} Returns `array`.
	     */
	    function copyArray(source, array) {
	      var index = -1,
	          length = source.length;
	
	      array || (array = Array(length));
	      while (++index < length) {
	        array[index] = source[index];
	      }
	      return array;
	    }
	
	    /**
	     * Copies properties of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy properties from.
	     * @param {Array} props The property identifiers to copy.
	     * @param {Object} [object={}] The object to copy properties to.
	     * @param {Function} [customizer] The function to customize copied values.
	     * @returns {Object} Returns `object`.
	     */
	    function copyObject(source, props, object, customizer) {
	      var isNew = !object;
	      object || (object = {});
	
	      var index = -1,
	          length = props.length;
	
	      while (++index < length) {
	        var key = props[index];
	
	        var newValue = customizer
	          ? customizer(object[key], source[key], key, object, source)
	          : undefined;
	
	        if (newValue === undefined) {
	          newValue = source[key];
	        }
	        if (isNew) {
	          baseAssignValue(object, key, newValue);
	        } else {
	          assignValue(object, key, newValue);
	        }
	      }
	      return object;
	    }
	
	    /**
	     * Copies own symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbols(source, object) {
	      return copyObject(source, getSymbols(source), object);
	    }
	
	    /**
	     * Copies own and inherited symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbolsIn(source, object) {
	      return copyObject(source, getSymbolsIn(source), object);
	    }
	
	    /**
	     * Creates a function like `_.groupBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} [initializer] The accumulator object initializer.
	     * @returns {Function} Returns the new aggregator function.
	     */
	    function createAggregator(setter, initializer) {
	      return function(collection, iteratee) {
	        var func = isArray(collection) ? arrayAggregator : baseAggregator,
	            accumulator = initializer ? initializer() : {};
	
	        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
	      };
	    }
	
	    /**
	     * Creates a function like `_.assign`.
	     *
	     * @private
	     * @param {Function} assigner The function to assign values.
	     * @returns {Function} Returns the new assigner function.
	     */
	    function createAssigner(assigner) {
	      return baseRest(function(object, sources) {
	        var index = -1,
	            length = sources.length,
	            customizer = length > 1 ? sources[length - 1] : undefined,
	            guard = length > 2 ? sources[2] : undefined;
	
	        customizer = (assigner.length > 3 && typeof customizer == 'function')
	          ? (length--, customizer)
	          : undefined;
	
	        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	          customizer = length < 3 ? undefined : customizer;
	          length = 1;
	        }
	        object = Object(object);
	        while (++index < length) {
	          var source = sources[index];
	          if (source) {
	            assigner(object, source, index, customizer);
	          }
	        }
	        return object;
	      });
	    }
	
	    /**
	     * Creates a `baseEach` or `baseEachRight` function.
	     *
	     * @private
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseEach(eachFunc, fromRight) {
	      return function(collection, iteratee) {
	        if (collection == null) {
	          return collection;
	        }
	        if (!isArrayLike(collection)) {
	          return eachFunc(collection, iteratee);
	        }
	        var length = collection.length,
	            index = fromRight ? length : -1,
	            iterable = Object(collection);
	
	        while ((fromRight ? index-- : ++index < length)) {
	          if (iteratee(iterable[index], index, iterable) === false) {
	            break;
	          }
	        }
	        return collection;
	      };
	    }
	
	    /**
	     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseFor(fromRight) {
	      return function(object, iteratee, keysFunc) {
	        var index = -1,
	            iterable = Object(object),
	            props = keysFunc(object),
	            length = props.length;
	
	        while (length--) {
	          var key = props[fromRight ? length : ++index];
	          if (iteratee(iterable[key], key, iterable) === false) {
	            break;
	          }
	        }
	        return object;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the optional `this`
	     * binding of `thisArg`.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createBind(func, bitmask, thisArg) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return fn.apply(isBind ? thisArg : this, arguments);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.lowerFirst`.
	     *
	     * @private
	     * @param {string} methodName The name of the `String` case method to use.
	     * @returns {Function} Returns the new case function.
	     */
	    function createCaseFirst(methodName) {
	      return function(string) {
	        string = toString(string);
	
	        var strSymbols = hasUnicode(string)
	          ? stringToArray(string)
	          : undefined;
	
	        var chr = strSymbols
	          ? strSymbols[0]
	          : string.charAt(0);
	
	        var trailing = strSymbols
	          ? castSlice(strSymbols, 1).join('')
	          : string.slice(1);
	
	        return chr[methodName]() + trailing;
	      };
	    }
	
	    /**
	     * Creates a function like `_.camelCase`.
	     *
	     * @private
	     * @param {Function} callback The function to combine each word.
	     * @returns {Function} Returns the new compounder function.
	     */
	    function createCompounder(callback) {
	      return function(string) {
	        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
	      };
	    }
	
	    /**
	     * Creates a function that produces an instance of `Ctor` regardless of
	     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
	     *
	     * @private
	     * @param {Function} Ctor The constructor to wrap.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCtor(Ctor) {
	      return function() {
	        // Use a `switch` statement to work with class constructors. See
	        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
	        // for more details.
	        var args = arguments;
	        switch (args.length) {
	          case 0: return new Ctor;
	          case 1: return new Ctor(args[0]);
	          case 2: return new Ctor(args[0], args[1]);
	          case 3: return new Ctor(args[0], args[1], args[2]);
	          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
	          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
	          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
	          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
	        }
	        var thisBinding = baseCreate(Ctor.prototype),
	            result = Ctor.apply(thisBinding, args);
	
	        // Mimic the constructor's `return` behavior.
	        // See https://es5.github.io/#x13.2.2 for more details.
	        return isObject(result) ? result : thisBinding;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to enable currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {number} arity The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCurry(func, bitmask, arity) {
	      var Ctor = createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length,
	            placeholder = getHolder(wrapper);
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
	          ? []
	          : replaceHolders(args, placeholder);
	
	        length -= holders.length;
	        if (length < arity) {
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, undefined,
	            args, holders, undefined, undefined, arity - length);
	        }
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return apply(fn, this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.find` or `_.findLast` function.
	     *
	     * @private
	     * @param {Function} findIndexFunc The function to find the collection index.
	     * @returns {Function} Returns the new find function.
	     */
	    function createFind(findIndexFunc) {
	      return function(collection, predicate, fromIndex) {
	        var iterable = Object(collection);
	        if (!isArrayLike(collection)) {
	          var iteratee = getIteratee(predicate, 3);
	          collection = keys(collection);
	          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
	        }
	        var index = findIndexFunc(collection, predicate, fromIndex);
	        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
	      };
	    }
	
	    /**
	     * Creates a `_.flow` or `_.flowRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new flow function.
	     */
	    function createFlow(fromRight) {
	      return flatRest(function(funcs) {
	        var length = funcs.length,
	            index = length,
	            prereq = LodashWrapper.prototype.thru;
	
	        if (fromRight) {
	          funcs.reverse();
	        }
	        while (index--) {
	          var func = funcs[index];
	          if (typeof func != 'function') {
	            throw new TypeError(FUNC_ERROR_TEXT);
	          }
	          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
	            var wrapper = new LodashWrapper([], true);
	          }
	        }
	        index = wrapper ? index : length;
	        while (++index < length) {
	          func = funcs[index];
	
	          var funcName = getFuncName(func),
	              data = funcName == 'wrapper' ? getData(func) : undefined;
	
	          if (data && isLaziable(data[0]) &&
	                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
	                !data[4].length && data[9] == 1
	              ) {
	            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
	          } else {
	            wrapper = (func.length == 1 && isLaziable(func))
	              ? wrapper[funcName]()
	              : wrapper.thru(func);
	          }
	        }
	        return function() {
	          var args = arguments,
	              value = args[0];
	
	          if (wrapper && args.length == 1 && isArray(value)) {
	            return wrapper.plant(value).value();
	          }
	          var index = 0,
	              result = length ? funcs[index].apply(this, args) : value;
	
	          while (++index < length) {
	            result = funcs[index].call(this, result);
	          }
	          return result;
	        };
	      });
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with optional `this`
	     * binding of `thisArg`, partial application, and currying.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [partialsRight] The arguments to append to those provided
	     *  to the new function.
	     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
	      var isAry = bitmask & WRAP_ARY_FLAG,
	          isBind = bitmask & WRAP_BIND_FLAG,
	          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
	          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
	          isFlip = bitmask & WRAP_FLIP_FLAG,
	          Ctor = isBindKey ? undefined : createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length;
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        if (isCurried) {
	          var placeholder = getHolder(wrapper),
	              holdersCount = countHolders(args, placeholder);
	        }
	        if (partials) {
	          args = composeArgs(args, partials, holders, isCurried);
	        }
	        if (partialsRight) {
	          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
	        }
	        length -= holdersCount;
	        if (isCurried && length < arity) {
	          var newHolders = replaceHolders(args, placeholder);
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
	            args, newHolders, argPos, ary, arity - length
	          );
	        }
	        var thisBinding = isBind ? thisArg : this,
	            fn = isBindKey ? thisBinding[func] : func;
	
	        length = args.length;
	        if (argPos) {
	          args = reorder(args, argPos);
	        } else if (isFlip && length > 1) {
	          args.reverse();
	        }
	        if (isAry && ary < length) {
	          args.length = ary;
	        }
	        if (this && this !== root && this instanceof wrapper) {
	          fn = Ctor || createCtor(fn);
	        }
	        return fn.apply(thisBinding, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.invertBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} toIteratee The function to resolve iteratees.
	     * @returns {Function} Returns the new inverter function.
	     */
	    function createInverter(setter, toIteratee) {
	      return function(object, iteratee) {
	        return baseInverter(object, setter, toIteratee(iteratee), {});
	      };
	    }
	
	    /**
	     * Creates a function that performs a mathematical operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @param {number} [defaultValue] The value used for `undefined` arguments.
	     * @returns {Function} Returns the new mathematical operation function.
	     */
	    function createMathOperation(operator, defaultValue) {
	      return function(value, other) {
	        var result;
	        if (value === undefined && other === undefined) {
	          return defaultValue;
	        }
	        if (value !== undefined) {
	          result = value;
	        }
	        if (other !== undefined) {
	          if (result === undefined) {
	            return other;
	          }
	          if (typeof value == 'string' || typeof other == 'string') {
	            value = baseToString(value);
	            other = baseToString(other);
	          } else {
	            value = baseToNumber(value);
	            other = baseToNumber(other);
	          }
	          result = operator(value, other);
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function like `_.over`.
	     *
	     * @private
	     * @param {Function} arrayFunc The function to iterate over iteratees.
	     * @returns {Function} Returns the new over function.
	     */
	    function createOver(arrayFunc) {
	      return flatRest(function(iteratees) {
	        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
	        return baseRest(function(args) {
	          var thisArg = this;
	          return arrayFunc(iteratees, function(iteratee) {
	            return apply(iteratee, thisArg, args);
	          });
	        });
	      });
	    }
	
	    /**
	     * Creates the padding for `string` based on `length`. The `chars` string
	     * is truncated if the number of characters exceeds `length`.
	     *
	     * @private
	     * @param {number} length The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padding for `string`.
	     */
	    function createPadding(length, chars) {
	      chars = chars === undefined ? ' ' : baseToString(chars);
	
	      var charsLength = chars.length;
	      if (charsLength < 2) {
	        return charsLength ? baseRepeat(chars, length) : chars;
	      }
	      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
	      return hasUnicode(chars)
	        ? castSlice(stringToArray(result), 0, length).join('')
	        : result.slice(0, length);
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the `this` binding
	     * of `thisArg` and `partials` prepended to the arguments it receives.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {Array} partials The arguments to prepend to those provided to
	     *  the new function.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createPartial(func, bitmask, thisArg, partials) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var argsIndex = -1,
	            argsLength = arguments.length,
	            leftIndex = -1,
	            leftLength = partials.length,
	            args = Array(leftLength + argsLength),
	            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	
	        while (++leftIndex < leftLength) {
	          args[leftIndex] = partials[leftIndex];
	        }
	        while (argsLength--) {
	          args[leftIndex++] = arguments[++argsIndex];
	        }
	        return apply(fn, isBind ? thisArg : this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.range` or `_.rangeRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new range function.
	     */
	    function createRange(fromRight) {
	      return function(start, end, step) {
	        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
	          end = step = undefined;
	        }
	        // Ensure the sign of `-0` is preserved.
	        start = toFinite(start);
	        if (end === undefined) {
	          end = start;
	          start = 0;
	        } else {
	          end = toFinite(end);
	        }
	        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
	        return baseRange(start, end, step, fromRight);
	      };
	    }
	
	    /**
	     * Creates a function that performs a relational operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @returns {Function} Returns the new relational operation function.
	     */
	    function createRelationalOperation(operator) {
	      return function(value, other) {
	        if (!(typeof value == 'string' && typeof other == 'string')) {
	          value = toNumber(value);
	          other = toNumber(other);
	        }
	        return operator(value, other);
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to continue currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {Function} wrapFunc The function to create the `func` wrapper.
	     * @param {*} placeholder The placeholder value.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
	      var isCurry = bitmask & WRAP_CURRY_FLAG,
	          newHolders = isCurry ? holders : undefined,
	          newHoldersRight = isCurry ? undefined : holders,
	          newPartials = isCurry ? partials : undefined,
	          newPartialsRight = isCurry ? undefined : partials;
	
	      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
	      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
	
	      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
	        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
	      }
	      var newData = [
	        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
	        newHoldersRight, argPos, ary, arity
	      ];
	
	      var result = wrapFunc.apply(undefined, newData);
	      if (isLaziable(func)) {
	        setData(result, newData);
	      }
	      result.placeholder = placeholder;
	      return setWrapToString(result, func, bitmask);
	    }
	
	    /**
	     * Creates a function like `_.round`.
	     *
	     * @private
	     * @param {string} methodName The name of the `Math` method to use when rounding.
	     * @returns {Function} Returns the new round function.
	     */
	    function createRound(methodName) {
	      var func = Math[methodName];
	      return function(number, precision) {
	        number = toNumber(number);
	        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
	        if (precision && nativeIsFinite(number)) {
	          // Shift with exponential notation to avoid floating-point issues.
	          // See [MDN](https://mdn.io/round#Examples) for more details.
	          var pair = (toString(number) + 'e').split('e'),
	              value = func(pair[0] + 'e' + (+pair[1] + precision));
	
	          pair = (toString(value) + 'e').split('e');
	          return +(pair[0] + 'e' + (+pair[1] - precision));
	        }
	        return func(number);
	      };
	    }
	
	    /**
	     * Creates a set object of `values`.
	     *
	     * @private
	     * @param {Array} values The values to add to the set.
	     * @returns {Object} Returns the new set.
	     */
	    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
	      return new Set(values);
	    };
	
	    /**
	     * Creates a `_.toPairs` or `_.toPairsIn` function.
	     *
	     * @private
	     * @param {Function} keysFunc The function to get the keys of a given object.
	     * @returns {Function} Returns the new pairs function.
	     */
	    function createToPairs(keysFunc) {
	      return function(object) {
	        var tag = getTag(object);
	        if (tag == mapTag) {
	          return mapToArray(object);
	        }
	        if (tag == setTag) {
	          return setToPairs(object);
	        }
	        return baseToPairs(object, keysFunc(object));
	      };
	    }
	
	    /**
	     * Creates a function that either curries or invokes `func` with optional
	     * `this` binding and partially applied arguments.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags.
	     *    1 - `_.bind`
	     *    2 - `_.bindKey`
	     *    4 - `_.curry` or `_.curryRight` of a bound function
	     *    8 - `_.curry`
	     *   16 - `_.curryRight`
	     *   32 - `_.partial`
	     *   64 - `_.partialRight`
	     *  128 - `_.rearg`
	     *  256 - `_.ary`
	     *  512 - `_.flip`
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to be partially applied.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
	      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
	      if (!isBindKey && typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var length = partials ? partials.length : 0;
	      if (!length) {
	        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
	        partials = holders = undefined;
	      }
	      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
	      arity = arity === undefined ? arity : toInteger(arity);
	      length -= holders ? holders.length : 0;
	
	      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
	        var partialsRight = partials,
	            holdersRight = holders;
	
	        partials = holders = undefined;
	      }
	      var data = isBindKey ? undefined : getData(func);
	
	      var newData = [
	        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
	        argPos, ary, arity
	      ];
	
	      if (data) {
	        mergeData(newData, data);
	      }
	      func = newData[0];
	      bitmask = newData[1];
	      thisArg = newData[2];
	      partials = newData[3];
	      holders = newData[4];
	      arity = newData[9] = newData[9] === undefined
	        ? (isBindKey ? 0 : func.length)
	        : nativeMax(newData[9] - length, 0);
	
	      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
	        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
	      }
	      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
	        var result = createBind(func, bitmask, thisArg);
	      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
	        result = createCurry(func, bitmask, arity);
	      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
	        result = createPartial(func, bitmask, thisArg, partials);
	      } else {
	        result = createHybrid.apply(undefined, newData);
	      }
	      var setter = data ? baseSetData : setData;
	      return setWrapToString(setter(result, newData), func, bitmask);
	    }
	
	    /**
	     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
	     * of source objects to the destination object for all destination properties
	     * that resolve to `undefined`.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to assign.
	     * @param {Object} object The parent object of `objValue`.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsAssignIn(objValue, srcValue, key, object) {
	      if (objValue === undefined ||
	          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	        return srcValue;
	      }
	      return objValue;
	    }
	
	    /**
	     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
	     * objects into destination objects that are passed thru.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to merge.
	     * @param {Object} object The parent object of `objValue`.
	     * @param {Object} source The parent object of `srcValue`.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
	      if (isObject(objValue) && isObject(srcValue)) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, objValue);
	        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
	        stack['delete'](srcValue);
	      }
	      return objValue;
	    }
	
	    /**
	     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
	     * objects.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {string} key The key of the property to inspect.
	     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
	     */
	    function customOmitClone(value) {
	      return isPlainObject(value) ? undefined : value;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for arrays with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Array} array The array to compare.
	     * @param {Array} other The other array to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `array` and `other` objects.
	     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	     */
	    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          arrLength = array.length,
	          othLength = other.length;
	
	      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	        return false;
	      }
	      // Check that cyclic values are equal.
	      var arrStacked = stack.get(array);
	      var othStacked = stack.get(other);
	      if (arrStacked && othStacked) {
	        return arrStacked == other && othStacked == array;
	      }
	      var index = -1,
	          result = true,
	          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	      stack.set(array, other);
	      stack.set(other, array);
	
	      // Ignore non-index properties.
	      while (++index < arrLength) {
	        var arrValue = array[index],
	            othValue = other[index];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, arrValue, index, other, array, stack)
	            : customizer(arrValue, othValue, index, array, other, stack);
	        }
	        if (compared !== undefined) {
	          if (compared) {
	            continue;
	          }
	          result = false;
	          break;
	        }
	        // Recursively compare arrays (susceptible to call stack limits).
	        if (seen) {
	          if (!arraySome(other, function(othValue, othIndex) {
	                if (!cacheHas(seen, othIndex) &&
	                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	                  return seen.push(othIndex);
	                }
	              })) {
	            result = false;
	            break;
	          }
	        } else if (!(
	              arrValue === othValue ||
	                equalFunc(arrValue, othValue, bitmask, customizer, stack)
	            )) {
	          result = false;
	          break;
	        }
	      }
	      stack['delete'](array);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for comparing objects of
	     * the same `toStringTag`.
	     *
	     * **Note:** This function only supports comparing values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {string} tag The `toStringTag` of the objects to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	      switch (tag) {
	        case dataViewTag:
	          if ((object.byteLength != other.byteLength) ||
	              (object.byteOffset != other.byteOffset)) {
	            return false;
	          }
	          object = object.buffer;
	          other = other.buffer;
	
	        case arrayBufferTag:
	          if ((object.byteLength != other.byteLength) ||
	              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	            return false;
	          }
	          return true;
	
	        case boolTag:
	        case dateTag:
	        case numberTag:
	          // Coerce booleans to `1` or `0` and dates to milliseconds.
	          // Invalid dates are coerced to `NaN`.
	          return eq(+object, +other);
	
	        case errorTag:
	          return object.name == other.name && object.message == other.message;
	
	        case regexpTag:
	        case stringTag:
	          // Coerce regexes to strings and treat strings, primitives and objects,
	          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	          // for more details.
	          return object == (other + '');
	
	        case mapTag:
	          var convert = mapToArray;
	
	        case setTag:
	          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	          convert || (convert = setToArray);
	
	          if (object.size != other.size && !isPartial) {
	            return false;
	          }
	          // Assume cyclic values are equal.
	          var stacked = stack.get(object);
	          if (stacked) {
	            return stacked == other;
	          }
	          bitmask |= COMPARE_UNORDERED_FLAG;
	
	          // Recursively compare objects (susceptible to call stack limits).
	          stack.set(object, other);
	          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	          stack['delete'](object);
	          return result;
	
	        case symbolTag:
	          if (symbolValueOf) {
	            return symbolValueOf.call(object) == symbolValueOf.call(other);
	          }
	      }
	      return false;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for objects with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          objProps = getAllKeys(object),
	          objLength = objProps.length,
	          othProps = getAllKeys(other),
	          othLength = othProps.length;
	
	      if (objLength != othLength && !isPartial) {
	        return false;
	      }
	      var index = objLength;
	      while (index--) {
	        var key = objProps[index];
	        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	          return false;
	        }
	      }
	      // Check that cyclic values are equal.
	      var objStacked = stack.get(object);
	      var othStacked = stack.get(other);
	      if (objStacked && othStacked) {
	        return objStacked == other && othStacked == object;
	      }
	      var result = true;
	      stack.set(object, other);
	      stack.set(other, object);
	
	      var skipCtor = isPartial;
	      while (++index < objLength) {
	        key = objProps[index];
	        var objValue = object[key],
	            othValue = other[key];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, objValue, key, other, object, stack)
	            : customizer(objValue, othValue, key, object, other, stack);
	        }
	        // Recursively compare objects (susceptible to call stack limits).
	        if (!(compared === undefined
	              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	              : compared
	            )) {
	          result = false;
	          break;
	        }
	        skipCtor || (skipCtor = key == 'constructor');
	      }
	      if (result && !skipCtor) {
	        var objCtor = object.constructor,
	            othCtor = other.constructor;
	
	        // Non `Object` object instances with different constructors are not equal.
	        if (objCtor != othCtor &&
	            ('constructor' in object && 'constructor' in other) &&
	            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	          result = false;
	        }
	      }
	      stack['delete'](object);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseRest` which flattens the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    function flatRest(func) {
	      return setToString(overRest(func, undefined, flatten), func + '');
	    }
	
	    /**
	     * Creates an array of own enumerable property names and symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeys(object) {
	      return baseGetAllKeys(object, keys, getSymbols);
	    }
	
	    /**
	     * Creates an array of own and inherited enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeysIn(object) {
	      return baseGetAllKeys(object, keysIn, getSymbolsIn);
	    }
	
	    /**
	     * Gets metadata for `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {*} Returns the metadata for `func`.
	     */
	    var getData = !metaMap ? noop : function(func) {
	      return metaMap.get(func);
	    };
	
	    /**
	     * Gets the name of `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {string} Returns the function name.
	     */
	    function getFuncName(func) {
	      var result = (func.name + ''),
	          array = realNames[result],
	          length = hasOwnProperty.call(realNames, result) ? array.length : 0;
	
	      while (length--) {
	        var data = array[length],
	            otherFunc = data.func;
	        if (otherFunc == null || otherFunc == func) {
	          return data.name;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Gets the argument placeholder value for `func`.
	     *
	     * @private
	     * @param {Function} func The function to inspect.
	     * @returns {*} Returns the placeholder value.
	     */
	    function getHolder(func) {
	      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
	      return object.placeholder;
	    }
	
	    /**
	     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
	     * this function returns the custom method, otherwise it returns `baseIteratee`.
	     * If arguments are provided, the chosen function is invoked with them and
	     * its result is returned.
	     *
	     * @private
	     * @param {*} [value] The value to convert to an iteratee.
	     * @param {number} [arity] The arity of the created iteratee.
	     * @returns {Function} Returns the chosen function or its result.
	     */
	    function getIteratee() {
	      var result = lodash.iteratee || iteratee;
	      result = result === iteratee ? baseIteratee : result;
	      return arguments.length ? result(arguments[0], arguments[1]) : result;
	    }
	
	    /**
	     * Gets the data for `map`.
	     *
	     * @private
	     * @param {Object} map The map to query.
	     * @param {string} key The reference key.
	     * @returns {*} Returns the map data.
	     */
	    function getMapData(map, key) {
	      var data = map.__data__;
	      return isKeyable(key)
	        ? data[typeof key == 'string' ? 'string' : 'hash']
	        : data.map;
	    }
	
	    /**
	     * Gets the property names, values, and compare flags of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the match data of `object`.
	     */
	    function getMatchData(object) {
	      var result = keys(object),
	          length = result.length;
	
	      while (length--) {
	        var key = result[length],
	            value = object[key];
	
	        result[length] = [key, value, isStrictComparable(value)];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the native function at `key` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the method to get.
	     * @returns {*} Returns the function if it's native, else `undefined`.
	     */
	    function getNative(object, key) {
	      var value = getValue(object, key);
	      return baseIsNative(value) ? value : undefined;
	    }
	
	    /**
	     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the raw `toStringTag`.
	     */
	    function getRawTag(value) {
	      var isOwn = hasOwnProperty.call(value, symToStringTag),
	          tag = value[symToStringTag];
	
	      try {
	        value[symToStringTag] = undefined;
	        var unmasked = true;
	      } catch (e) {}
	
	      var result = nativeObjectToString.call(value);
	      if (unmasked) {
	        if (isOwn) {
	          value[symToStringTag] = tag;
	        } else {
	          delete value[symToStringTag];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array of the own enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	      if (object == null) {
	        return [];
	      }
	      object = Object(object);
	      return arrayFilter(nativeGetSymbols(object), function(symbol) {
	        return propertyIsEnumerable.call(object, symbol);
	      });
	    };
	
	    /**
	     * Creates an array of the own and inherited enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
	      var result = [];
	      while (object) {
	        arrayPush(result, getSymbols(object));
	        object = getPrototype(object);
	      }
	      return result;
	    };
	
	    /**
	     * Gets the `toStringTag` of `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    var getTag = baseGetTag;
	
	    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	        (Map && getTag(new Map) != mapTag) ||
	        (Promise && getTag(Promise.resolve()) != promiseTag) ||
	        (Set && getTag(new Set) != setTag) ||
	        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	      getTag = function(value) {
	        var result = baseGetTag(value),
	            Ctor = result == objectTag ? value.constructor : undefined,
	            ctorString = Ctor ? toSource(Ctor) : '';
	
	        if (ctorString) {
	          switch (ctorString) {
	            case dataViewCtorString: return dataViewTag;
	            case mapCtorString: return mapTag;
	            case promiseCtorString: return promiseTag;
	            case setCtorString: return setTag;
	            case weakMapCtorString: return weakMapTag;
	          }
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Gets the view, applying any `transforms` to the `start` and `end` positions.
	     *
	     * @private
	     * @param {number} start The start of the view.
	     * @param {number} end The end of the view.
	     * @param {Array} transforms The transformations to apply to the view.
	     * @returns {Object} Returns an object containing the `start` and `end`
	     *  positions of the view.
	     */
	    function getView(start, end, transforms) {
	      var index = -1,
	          length = transforms.length;
	
	      while (++index < length) {
	        var data = transforms[index],
	            size = data.size;
	
	        switch (data.type) {
	          case 'drop':      start += size; break;
	          case 'dropRight': end -= size; break;
	          case 'take':      end = nativeMin(end, start + size); break;
	          case 'takeRight': start = nativeMax(start, end - size); break;
	        }
	      }
	      return { 'start': start, 'end': end };
	    }
	
	    /**
	     * Extracts wrapper details from the `source` body comment.
	     *
	     * @private
	     * @param {string} source The source to inspect.
	     * @returns {Array} Returns the wrapper details.
	     */
	    function getWrapDetails(source) {
	      var match = source.match(reWrapDetails);
	      return match ? match[1].split(reSplitDetails) : [];
	    }
	
	    /**
	     * Checks if `path` exists on `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @param {Function} hasFunc The function to check properties.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     */
	    function hasPath(object, path, hasFunc) {
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length,
	          result = false;
	
	      while (++index < length) {
	        var key = toKey(path[index]);
	        if (!(result = object != null && hasFunc(object, key))) {
	          break;
	        }
	        object = object[key];
	      }
	      if (result || ++index != length) {
	        return result;
	      }
	      length = object == null ? 0 : object.length;
	      return !!length && isLength(length) && isIndex(key, length) &&
	        (isArray(object) || isArguments(object));
	    }
	
	    /**
	     * Initializes an array clone.
	     *
	     * @private
	     * @param {Array} array The array to clone.
	     * @returns {Array} Returns the initialized clone.
	     */
	    function initCloneArray(array) {
	      var length = array.length,
	          result = new array.constructor(length);
	
	      // Add properties assigned by `RegExp#exec`.
	      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	        result.index = array.index;
	        result.input = array.input;
	      }
	      return result;
	    }
	
	    /**
	     * Initializes an object clone.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneObject(object) {
	      return (typeof object.constructor == 'function' && !isPrototype(object))
	        ? baseCreate(getPrototype(object))
	        : {};
	    }
	
	    /**
	     * Initializes an object clone based on its `toStringTag`.
	     *
	     * **Note:** This function only supports cloning values with tags of
	     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @param {string} tag The `toStringTag` of the object to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneByTag(object, tag, isDeep) {
	      var Ctor = object.constructor;
	      switch (tag) {
	        case arrayBufferTag:
	          return cloneArrayBuffer(object);
	
	        case boolTag:
	        case dateTag:
	          return new Ctor(+object);
	
	        case dataViewTag:
	          return cloneDataView(object, isDeep);
	
	        case float32Tag: case float64Tag:
	        case int8Tag: case int16Tag: case int32Tag:
	        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	          return cloneTypedArray(object, isDeep);
	
	        case mapTag:
	          return new Ctor;
	
	        case numberTag:
	        case stringTag:
	          return new Ctor(object);
	
	        case regexpTag:
	          return cloneRegExp(object);
	
	        case setTag:
	          return new Ctor;
	
	        case symbolTag:
	          return cloneSymbol(object);
	      }
	    }
	
	    /**
	     * Inserts wrapper `details` in a comment at the top of the `source` body.
	     *
	     * @private
	     * @param {string} source The source to modify.
	     * @returns {Array} details The details to insert.
	     * @returns {string} Returns the modified source.
	     */
	    function insertWrapDetails(source, details) {
	      var length = details.length;
	      if (!length) {
	        return source;
	      }
	      var lastIndex = length - 1;
	      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
	      details = details.join(length > 2 ? ', ' : ' ');
	      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
	    }
	
	    /**
	     * Checks if `value` is a flattenable `arguments` object or array.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	     */
	    function isFlattenable(value) {
	      return isArray(value) || isArguments(value) ||
	        !!(spreadableSymbol && value && value[spreadableSymbol]);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like index.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	     */
	    function isIndex(value, length) {
	      var type = typeof value;
	      length = length == null ? MAX_SAFE_INTEGER : length;
	
	      return !!length &&
	        (type == 'number' ||
	          (type != 'symbol' && reIsUint.test(value))) &&
	            (value > -1 && value % 1 == 0 && value < length);
	    }
	
	    /**
	     * Checks if the given arguments are from an iteratee call.
	     *
	     * @private
	     * @param {*} value The potential iteratee value argument.
	     * @param {*} index The potential iteratee index or key argument.
	     * @param {*} object The potential iteratee object argument.
	     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	     *  else `false`.
	     */
	    function isIterateeCall(value, index, object) {
	      if (!isObject(object)) {
	        return false;
	      }
	      var type = typeof index;
	      if (type == 'number'
	            ? (isArrayLike(object) && isIndex(index, object.length))
	            : (type == 'string' && index in object)
	          ) {
	        return eq(object[index], value);
	      }
	      return false;
	    }
	
	    /**
	     * Checks if `value` is a property name and not a property path.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	     */
	    function isKey(value, object) {
	      if (isArray(value)) {
	        return false;
	      }
	      var type = typeof value;
	      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	          value == null || isSymbol(value)) {
	        return true;
	      }
	      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	        (object != null && value in Object(object));
	    }
	
	    /**
	     * Checks if `value` is suitable for use as unique object key.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	     */
	    function isKeyable(value) {
	      var type = typeof value;
	      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	        ? (value !== '__proto__')
	        : (value === null);
	    }
	
	    /**
	     * Checks if `func` has a lazy counterpart.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
	     *  else `false`.
	     */
	    function isLaziable(func) {
	      var funcName = getFuncName(func),
	          other = lodash[funcName];
	
	      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
	        return false;
	      }
	      if (func === other) {
	        return true;
	      }
	      var data = getData(other);
	      return !!data && func === data[0];
	    }
	
	    /**
	     * Checks if `func` has its source masked.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	     */
	    function isMasked(func) {
	      return !!maskSrcKey && (maskSrcKey in func);
	    }
	
	    /**
	     * Checks if `func` is capable of being masked.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
	     */
	    var isMaskable = coreJsData ? isFunction : stubFalse;
	
	    /**
	     * Checks if `value` is likely a prototype object.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	     */
	    function isPrototype(value) {
	      var Ctor = value && value.constructor,
	          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	      return value === proto;
	    }
	
	    /**
	     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` if suitable for strict
	     *  equality comparisons, else `false`.
	     */
	    function isStrictComparable(value) {
	      return value === value && !isObject(value);
	    }
	
	    /**
	     * A specialized version of `matchesProperty` for source values suitable
	     * for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {string} key The key of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function matchesStrictComparable(key, srcValue) {
	      return function(object) {
	        if (object == null) {
	          return false;
	        }
	        return object[key] === srcValue &&
	          (srcValue !== undefined || (key in Object(object)));
	      };
	    }
	
	    /**
	     * A specialized version of `_.memoize` which clears the memoized function's
	     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	     *
	     * @private
	     * @param {Function} func The function to have its output memoized.
	     * @returns {Function} Returns the new memoized function.
	     */
	    function memoizeCapped(func) {
	      var result = memoize(func, function(key) {
	        if (cache.size === MAX_MEMOIZE_SIZE) {
	          cache.clear();
	        }
	        return key;
	      });
	
	      var cache = result.cache;
	      return result;
	    }
	
	    /**
	     * Merges the function metadata of `source` into `data`.
	     *
	     * Merging metadata reduces the number of wrappers used to invoke a function.
	     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
	     * may be applied regardless of execution order. Methods like `_.ary` and
	     * `_.rearg` modify function arguments, making the order in which they are
	     * executed important, preventing the merging of metadata. However, we make
	     * an exception for a safe combined case where curried functions have `_.ary`
	     * and or `_.rearg` applied.
	     *
	     * @private
	     * @param {Array} data The destination metadata.
	     * @param {Array} source The source metadata.
	     * @returns {Array} Returns `data`.
	     */
	    function mergeData(data, source) {
	      var bitmask = data[1],
	          srcBitmask = source[1],
	          newBitmask = bitmask | srcBitmask,
	          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
	
	      var isCombo =
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
	        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));
	
	      // Exit early if metadata can't be merged.
	      if (!(isCommon || isCombo)) {
	        return data;
	      }
	      // Use source `thisArg` if available.
	      if (srcBitmask & WRAP_BIND_FLAG) {
	        data[2] = source[2];
	        // Set when currying a bound function.
	        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
	      }
	      // Compose partial arguments.
	      var value = source[3];
	      if (value) {
	        var partials = data[3];
	        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
	        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
	      }
	      // Compose partial right arguments.
	      value = source[5];
	      if (value) {
	        partials = data[5];
	        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
	        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
	      }
	      // Use source `argPos` if available.
	      value = source[7];
	      if (value) {
	        data[7] = value;
	      }
	      // Use source `ary` if it's smaller.
	      if (srcBitmask & WRAP_ARY_FLAG) {
	        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
	      }
	      // Use source `arity` if one is not provided.
	      if (data[9] == null) {
	        data[9] = source[9];
	      }
	      // Use source `func` and merge bitmasks.
	      data[0] = source[0];
	      data[1] = newBitmask;
	
	      return data;
	    }
	
	    /**
	     * This function is like
	     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * except that it includes inherited enumerable properties.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function nativeKeysIn(object) {
	      var result = [];
	      if (object != null) {
	        for (var key in Object(object)) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a string using `Object.prototype.toString`.
	     *
	     * @private
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     */
	    function objectToString(value) {
	      return nativeObjectToString.call(value);
	    }
	
	    /**
	     * A specialized version of `baseRest` which transforms the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @param {Function} transform The rest array transform.
	     * @returns {Function} Returns the new function.
	     */
	    function overRest(func, start, transform) {
	      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	      return function() {
	        var args = arguments,
	            index = -1,
	            length = nativeMax(args.length - start, 0),
	            array = Array(length);
	
	        while (++index < length) {
	          array[index] = args[start + index];
	        }
	        index = -1;
	        var otherArgs = Array(start + 1);
	        while (++index < start) {
	          otherArgs[index] = args[index];
	        }
	        otherArgs[start] = transform(array);
	        return apply(func, this, otherArgs);
	      };
	    }
	
	    /**
	     * Gets the parent value at `path` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array} path The path to get the parent value of.
	     * @returns {*} Returns the parent value.
	     */
	    function parent(object, path) {
	      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
	    }
	
	    /**
	     * Reorder `array` according to the specified indexes where the element at
	     * the first index is assigned as the first element, the element at
	     * the second index is assigned as the second element, and so on.
	     *
	     * @private
	     * @param {Array} array The array to reorder.
	     * @param {Array} indexes The arranged array indexes.
	     * @returns {Array} Returns `array`.
	     */
	    function reorder(array, indexes) {
	      var arrLength = array.length,
	          length = nativeMin(indexes.length, arrLength),
	          oldArray = copyArray(array);
	
	      while (length--) {
	        var index = indexes[length];
	        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
	      }
	      return array;
	    }
	
	    /**
	     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the property to get.
	     * @returns {*} Returns the property value.
	     */
	    function safeGet(object, key) {
	      if (key === 'constructor' && typeof object[key] === 'function') {
	        return;
	      }
	
	      if (key == '__proto__') {
	        return;
	      }
	
	      return object[key];
	    }
	
	    /**
	     * Sets metadata for `func`.
	     *
	     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
	     * period of time, it will trip its breaker and transition to an identity
	     * function to avoid garbage collection pauses in V8. See
	     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
	     * for more details.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var setData = shortOut(baseSetData);
	
	    /**
	     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    var setTimeout = ctxSetTimeout || function(func, wait) {
	      return root.setTimeout(func, wait);
	    };
	
	    /**
	     * Sets the `toString` method of `func` to return `string`.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var setToString = shortOut(baseSetToString);
	
	    /**
	     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
	     * with wrapper details in a comment at the top of the source body.
	     *
	     * @private
	     * @param {Function} wrapper The function to modify.
	     * @param {Function} reference The reference function.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Function} Returns `wrapper`.
	     */
	    function setWrapToString(wrapper, reference, bitmask) {
	      var source = (reference + '');
	      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
	    }
	
	    /**
	     * Creates a function that'll short out and invoke `identity` instead
	     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	     * milliseconds.
	     *
	     * @private
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new shortable function.
	     */
	    function shortOut(func) {
	      var count = 0,
	          lastCalled = 0;
	
	      return function() {
	        var stamp = nativeNow(),
	            remaining = HOT_SPAN - (stamp - lastCalled);
	
	        lastCalled = stamp;
	        if (remaining > 0) {
	          if (++count >= HOT_COUNT) {
	            return arguments[0];
	          }
	        } else {
	          count = 0;
	        }
	        return func.apply(undefined, arguments);
	      };
	    }
	
	    /**
	     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @param {number} [size=array.length] The size of `array`.
	     * @returns {Array} Returns `array`.
	     */
	    function shuffleSelf(array, size) {
	      var index = -1,
	          length = array.length,
	          lastIndex = length - 1;
	
	      size = size === undefined ? length : size;
	      while (++index < size) {
	        var rand = baseRandom(index, lastIndex),
	            value = array[rand];
	
	        array[rand] = array[index];
	        array[index] = value;
	      }
	      array.length = size;
	      return array;
	    }
	
	    /**
	     * Converts `string` to a property path array.
	     *
	     * @private
	     * @param {string} string The string to convert.
	     * @returns {Array} Returns the property path array.
	     */
	    var stringToPath = memoizeCapped(function(string) {
	      var result = [];
	      if (string.charCodeAt(0) === 46 /* . */) {
	        result.push('');
	      }
	      string.replace(rePropName, function(match, number, quote, subString) {
	        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
	      });
	      return result;
	    });
	
	    /**
	     * Converts `value` to a string key if it's not a string or symbol.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {string|symbol} Returns the key.
	     */
	    function toKey(value) {
	      if (typeof value == 'string' || isSymbol(value)) {
	        return value;
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * Converts `func` to its source code.
	     *
	     * @private
	     * @param {Function} func The function to convert.
	     * @returns {string} Returns the source code.
	     */
	    function toSource(func) {
	      if (func != null) {
	        try {
	          return funcToString.call(func);
	        } catch (e) {}
	        try {
	          return (func + '');
	        } catch (e) {}
	      }
	      return '';
	    }
	
	    /**
	     * Updates wrapper `details` based on `bitmask` flags.
	     *
	     * @private
	     * @returns {Array} details The details to modify.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Array} Returns `details`.
	     */
	    function updateWrapDetails(details, bitmask) {
	      arrayEach(wrapFlags, function(pair) {
	        var value = '_.' + pair[0];
	        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
	          details.push(value);
	        }
	      });
	      return details.sort();
	    }
	
	    /**
	     * Creates a clone of `wrapper`.
	     *
	     * @private
	     * @param {Object} wrapper The wrapper to clone.
	     * @returns {Object} Returns the cloned wrapper.
	     */
	    function wrapperClone(wrapper) {
	      if (wrapper instanceof LazyWrapper) {
	        return wrapper.clone();
	      }
	      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
	      result.__actions__ = copyArray(wrapper.__actions__);
	      result.__index__  = wrapper.__index__;
	      result.__values__ = wrapper.__values__;
	      return result;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of elements split into groups the length of `size`.
	     * If `array` can't be split evenly, the final chunk will be the remaining
	     * elements.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to process.
	     * @param {number} [size=1] The length of each chunk
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the new array of chunks.
	     * @example
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 2);
	     * // => [['a', 'b'], ['c', 'd']]
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 3);
	     * // => [['a', 'b', 'c'], ['d']]
	     */
	    function chunk(array, size, guard) {
	      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
	        size = 1;
	      } else {
	        size = nativeMax(toInteger(size), 0);
	      }
	      var length = array == null ? 0 : array.length;
	      if (!length || size < 1) {
	        return [];
	      }
	      var index = 0,
	          resIndex = 0,
	          result = Array(nativeCeil(length / size));
	
	      while (index < length) {
	        result[resIndex++] = baseSlice(array, index, (index += size));
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array with all falsey values removed. The values `false`, `null`,
	     * `0`, `""`, `undefined`, and `NaN` are falsey.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to compact.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.compact([0, 1, false, 2, '', 3]);
	     * // => [1, 2, 3]
	     */
	    function compact(array) {
	      var index = -1,
	          length = array == null ? 0 : array.length,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index];
	        if (value) {
	          result[resIndex++] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates a new array concatenating `array` with any additional arrays
	     * and/or values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to concatenate.
	     * @param {...*} [values] The values to concatenate.
	     * @returns {Array} Returns the new concatenated array.
	     * @example
	     *
	     * var array = [1];
	     * var other = _.concat(array, 2, [3], [[4]]);
	     *
	     * console.log(other);
	     * // => [1, 2, 3, [4]]
	     *
	     * console.log(array);
	     * // => [1]
	     */
	    function concat() {
	      var length = arguments.length;
	      if (!length) {
	        return [];
	      }
	      var args = Array(length - 1),
	          array = arguments[0],
	          index = length;
	
	      while (index--) {
	        args[index - 1] = arguments[index];
	      }
	      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
	    }
	
	    /**
	     * Creates an array of `array` values not included in the other given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * **Note:** Unlike `_.pullAll`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.without, _.xor
	     * @example
	     *
	     * _.difference([2, 1], [2, 3]);
	     * // => [1]
	     */
	    var difference = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `iteratee` which
	     * is invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var differenceBy = baseRest(function(array, values) {
	      var iteratee = last(values);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `comparator`
	     * which is invoked to compare elements of `array` to `values`. The order and
	     * references of result values are determined by the first array. The comparator
	     * is invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     *
	     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }]
	     */
	    var differenceWith = baseRest(function(array, values) {
	      var comparator = last(values);
	      if (isArrayLikeObject(comparator)) {
	        comparator = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.drop([1, 2, 3]);
	     * // => [2, 3]
	     *
	     * _.drop([1, 2, 3], 2);
	     * // => [3]
	     *
	     * _.drop([1, 2, 3], 5);
	     * // => []
	     *
	     * _.drop([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function drop(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropRight([1, 2, 3]);
	     * // => [1, 2]
	     *
	     * _.dropRight([1, 2, 3], 2);
	     * // => [1]
	     *
	     * _.dropRight([1, 2, 3], 5);
	     * // => []
	     *
	     * _.dropRight([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function dropRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the end.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.dropRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropRightWhile(users, ['active', false]);
	     * // => objects for ['barney']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropRightWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the beginning.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.dropWhile(users, function(o) { return !o.active; });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropWhile(users, ['active', false]);
	     * // => objects for ['pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true)
	        : [];
	    }
	
	    /**
	     * Fills elements of `array` with `value` from `start` up to, but not
	     * including, `end`.
	     *
	     * **Note:** This method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Array
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.fill(array, 'a');
	     * console.log(array);
	     * // => ['a', 'a', 'a']
	     *
	     * _.fill(Array(3), 2);
	     * // => [2, 2, 2]
	     *
	     * _.fill([4, 6, 8, 10], '*', 1, 3);
	     * // => [4, '*', '*', 10]
	     */
	    function fill(array, value, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
	        start = 0;
	        end = length;
	      }
	      return baseFill(array, value, start, end);
	    }
	
	    /**
	     * This method is like `_.find` except that it returns the index of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.findIndex(users, function(o) { return o.user == 'barney'; });
	     * // => 0
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findIndex(users, { 'user': 'fred', 'active': false });
	     * // => 1
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findIndex(users, ['active', false]);
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findIndex(users, 'active');
	     * // => 2
	     */
	    function findIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index);
	    }
	
	    /**
	     * This method is like `_.findIndex` except that it iterates over elements
	     * of `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
	     * // => 2
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
	     * // => 0
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastIndex(users, ['active', false]);
	     * // => 2
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastIndex(users, 'active');
	     * // => 0
	     */
	    function findLastIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length - 1;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = fromIndex < 0
	          ? nativeMax(length + index, 0)
	          : nativeMin(index, length - 1);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
	    }
	
	    /**
	     * Flattens `array` a single level deep.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flatten([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, [3, [4]], 5]
	     */
	    function flatten(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, 1) : [];
	    }
	
	    /**
	     * Recursively flattens `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flattenDeep([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, 3, 4, 5]
	     */
	    function flattenDeep(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, INFINITY) : [];
	    }
	
	    /**
	     * Recursively flatten `array` up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * var array = [1, [2, [3, [4]], 5]];
	     *
	     * _.flattenDepth(array, 1);
	     * // => [1, 2, [3, [4]], 5]
	     *
	     * _.flattenDepth(array, 2);
	     * // => [1, 2, 3, [4], 5]
	     */
	    function flattenDepth(array, depth) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(array, depth);
	    }
	
	    /**
	     * The inverse of `_.toPairs`; this method returns an object composed
	     * from key-value `pairs`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} pairs The key-value pairs.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.fromPairs([['a', 1], ['b', 2]]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function fromPairs(pairs) {
	      var index = -1,
	          length = pairs == null ? 0 : pairs.length,
	          result = {};
	
	      while (++index < length) {
	        var pair = pairs[index];
	        result[pair[0]] = pair[1];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias first
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the first element of `array`.
	     * @example
	     *
	     * _.head([1, 2, 3]);
	     * // => 1
	     *
	     * _.head([]);
	     * // => undefined
	     */
	    function head(array) {
	      return (array && array.length) ? array[0] : undefined;
	    }
	
	    /**
	     * Gets the index at which the first occurrence of `value` is found in `array`
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. If `fromIndex` is negative, it's used as the
	     * offset from the end of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.indexOf([1, 2, 1, 2], 2);
	     * // => 1
	     *
	     * // Search from the `fromIndex`.
	     * _.indexOf([1, 2, 1, 2], 2, 2);
	     * // => 3
	     */
	    function indexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseIndexOf(array, value, index);
	    }
	
	    /**
	     * Gets all but the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.initial([1, 2, 3]);
	     * // => [1, 2]
	     */
	    function initial(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 0, -1) : [];
	    }
	
	    /**
	     * Creates an array of unique values that are included in all given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersection([2, 1], [2, 3]);
	     * // => [2]
	     */
	    var intersection = baseRest(function(arrays) {
	      var mapped = arrayMap(arrays, castArrayLikeObject);
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped)
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `iteratee`
	     * which is invoked for each element of each `arrays` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [2.1]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }]
	     */
	    var intersectionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      if (iteratee === last(mapped)) {
	        iteratee = undefined;
	      } else {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `comparator`
	     * which is invoked to compare elements of `arrays`. The order and references
	     * of result values are determined by the first array. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.intersectionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }]
	     */
	    var intersectionWith = baseRest(function(arrays) {
	      var comparator = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      if (comparator) {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Converts all elements in `array` into a string separated by `separator`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to convert.
	     * @param {string} [separator=','] The element separator.
	     * @returns {string} Returns the joined string.
	     * @example
	     *
	     * _.join(['a', 'b', 'c'], '~');
	     * // => 'a~b~c'
	     */
	    function join(array, separator) {
	      return array == null ? '' : nativeJoin.call(array, separator);
	    }
	
	    /**
	     * Gets the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the last element of `array`.
	     * @example
	     *
	     * _.last([1, 2, 3]);
	     * // => 3
	     */
	    function last(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? array[length - 1] : undefined;
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it iterates over elements of
	     * `array` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.lastIndexOf([1, 2, 1, 2], 2);
	     * // => 3
	     *
	     * // Search from the `fromIndex`.
	     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
	     * // => 1
	     */
	    function lastIndexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
	      }
	      return value === value
	        ? strictLastIndexOf(array, value, index)
	        : baseFindIndex(array, baseIsNaN, index, true);
	    }
	
	    /**
	     * Gets the element at index `n` of `array`. If `n` is negative, the nth
	     * element from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.11.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=0] The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     *
	     * _.nth(array, 1);
	     * // => 'b'
	     *
	     * _.nth(array, -2);
	     * // => 'c';
	     */
	    function nth(array, n) {
	      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
	    }
	
	    /**
	     * Removes all given values from `array` using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
	     * to remove elements from an array by predicate.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...*} [values] The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pull(array, 'a', 'c');
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    var pull = baseRest(pullAll);
	
	    /**
	     * This method is like `_.pull` except that it accepts an array of values to remove.
	     *
	     * **Note:** Unlike `_.difference`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pullAll(array, ['a', 'c']);
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    function pullAll(array, values) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values)
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `iteratee` which is
	     * invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The iteratee is invoked with one argument: (value).
	     *
	     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
	     *
	     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
	     * console.log(array);
	     * // => [{ 'x': 2 }]
	     */
	    function pullAllBy(array, values, iteratee) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, getIteratee(iteratee, 2))
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `comparator` which
	     * is invoked to compare elements of `array` to `values`. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
	     *
	     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
	     * console.log(array);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
	     */
	    function pullAllWith(array, values, comparator) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, undefined, comparator)
	        : array;
	    }
	
	    /**
	     * Removes elements from `array` corresponding to `indexes` and returns an
	     * array of removed elements.
	     *
	     * **Note:** Unlike `_.at`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     * var pulled = _.pullAt(array, [1, 3]);
	     *
	     * console.log(array);
	     * // => ['a', 'c']
	     *
	     * console.log(pulled);
	     * // => ['b', 'd']
	     */
	    var pullAt = flatRest(function(array, indexes) {
	      var length = array == null ? 0 : array.length,
	          result = baseAt(array, indexes);
	
	      basePullAt(array, arrayMap(indexes, function(index) {
	        return isIndex(index, length) ? +index : index;
	      }).sort(compareAscending));
	
	      return result;
	    });
	
	    /**
	     * Removes all elements from `array` that `predicate` returns truthy for
	     * and returns an array of the removed elements. The predicate is invoked
	     * with three arguments: (value, index, array).
	     *
	     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
	     * to pull elements from an array by value.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = [1, 2, 3, 4];
	     * var evens = _.remove(array, function(n) {
	     *   return n % 2 == 0;
	     * });
	     *
	     * console.log(array);
	     * // => [1, 3]
	     *
	     * console.log(evens);
	     * // => [2, 4]
	     */
	    function remove(array, predicate) {
	      var result = [];
	      if (!(array && array.length)) {
	        return result;
	      }
	      var index = -1,
	          indexes = [],
	          length = array.length;
	
	      predicate = getIteratee(predicate, 3);
	      while (++index < length) {
	        var value = array[index];
	        if (predicate(value, index, array)) {
	          result.push(value);
	          indexes.push(index);
	        }
	      }
	      basePullAt(array, indexes);
	      return result;
	    }
	
	    /**
	     * Reverses `array` so that the first element becomes the last, the second
	     * element becomes the second to last, and so on.
	     *
	     * **Note:** This method mutates `array` and is based on
	     * [`Array#reverse`](https://mdn.io/Array/reverse).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.reverse(array);
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function reverse(array) {
	      return array == null ? array : nativeReverse.call(array);
	    }
	
	    /**
	     * Creates a slice of `array` from `start` up to, but not including, `end`.
	     *
	     * **Note:** This method is used instead of
	     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
	     * returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function slice(array, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
	        start = 0;
	        end = length;
	      }
	      else {
	        start = start == null ? 0 : toInteger(start);
	        end = end === undefined ? length : toInteger(end);
	      }
	      return baseSlice(array, start, end);
	    }
	
	    /**
	     * Uses a binary search to determine the lowest index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedIndex([30, 50], 40);
	     * // => 1
	     */
	    function sortedIndex(array, value) {
	      return baseSortedIndex(array, value);
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 0
	     */
	    function sortedIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 1
	     */
	    function sortedIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value);
	        if (index < length && eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it returns the highest
	     * index at which `value` should be inserted into `array` in order to
	     * maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
	     * // => 4
	     */
	    function sortedLastIndex(array, value) {
	      return baseSortedIndex(array, value, true);
	    }
	
	    /**
	     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 1
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 1
	     */
	    function sortedLastIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
	    }
	
	    /**
	     * This method is like `_.lastIndexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 3
	     */
	    function sortedLastIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value, true) - 1;
	        if (eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.uniq` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniq([1, 1, 2]);
	     * // => [1, 2]
	     */
	    function sortedUniq(array) {
	      return (array && array.length)
	        ? baseSortedUniq(array)
	        : [];
	    }
	
	    /**
	     * This method is like `_.uniqBy` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
	     * // => [1.1, 2.3]
	     */
	    function sortedUniqBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSortedUniq(array, getIteratee(iteratee, 2))
	        : [];
	    }
	
	    /**
	     * Gets all but the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.tail([1, 2, 3]);
	     * // => [2, 3]
	     */
	    function tail(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 1, length) : [];
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.take([1, 2, 3]);
	     * // => [1]
	     *
	     * _.take([1, 2, 3], 2);
	     * // => [1, 2]
	     *
	     * _.take([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.take([1, 2, 3], 0);
	     * // => []
	     */
	    function take(array, n, guard) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeRight([1, 2, 3]);
	     * // => [3]
	     *
	     * _.takeRight([1, 2, 3], 2);
	     * // => [2, 3]
	     *
	     * _.takeRight([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.takeRight([1, 2, 3], 0);
	     * // => []
	     */
	    function takeRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the end. Elements are
	     * taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.takeRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeRightWhile(users, ['active', false]);
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeRightWhile(users, 'active');
	     * // => []
	     */
	    function takeRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), false, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the beginning. Elements
	     * are taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.takeWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeWhile(users, ['active', false]);
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeWhile(users, 'active');
	     * // => []
	     */
	    function takeWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3))
	        : [];
	    }
	
	    /**
	     * Creates an array of unique values, in order, from all given arrays using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.union([2], [1, 2]);
	     * // => [2, 1]
	     */
	    var union = baseRest(function(arrays) {
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which uniqueness is computed. Result values are chosen from the first
	     * array in which the value occurs. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    var unionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `comparator` which
	     * is invoked to compare elements of `arrays`. Result values are chosen from
	     * the first array in which the value occurs. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.unionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var unionWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
	    });
	
	    /**
	     * Creates a duplicate-free version of an array, using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons, in which only the first occurrence of each element
	     * is kept. The order of result values is determined by the order they occur
	     * in the array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniq([2, 1, 2]);
	     * // => [2, 1]
	     */
	    function uniq(array) {
	      return (array && array.length) ? baseUniq(array) : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * uniqueness is computed. The order of result values is determined by the
	     * order they occur in the array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    function uniqBy(array, iteratee) {
	      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `comparator` which
	     * is invoked to compare elements of `array`. The order of result values is
	     * determined by the order they occur in the array.The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.uniqWith(objects, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
	     */
	    function uniqWith(array, comparator) {
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts an array of grouped
	     * elements and creates an array regrouping the elements to their pre-zip
	     * configuration.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.2.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     *
	     * _.unzip(zipped);
	     * // => [['a', 'b'], [1, 2], [true, false]]
	     */
	    function unzip(array) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var length = 0;
	      array = arrayFilter(array, function(group) {
	        if (isArrayLikeObject(group)) {
	          length = nativeMax(group.length, length);
	          return true;
	        }
	      });
	      return baseTimes(length, function(index) {
	        return arrayMap(array, baseProperty(index));
	      });
	    }
	
	    /**
	     * This method is like `_.unzip` except that it accepts `iteratee` to specify
	     * how regrouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  regrouped values.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
	     * // => [[1, 10, 100], [2, 20, 200]]
	     *
	     * _.unzipWith(zipped, _.add);
	     * // => [3, 30, 300]
	     */
	    function unzipWith(array, iteratee) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var result = unzip(array);
	      if (iteratee == null) {
	        return result;
	      }
	      return arrayMap(result, function(group) {
	        return apply(iteratee, undefined, group);
	      });
	    }
	
	    /**
	     * Creates an array excluding all given values using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.pull`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...*} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.xor
	     * @example
	     *
	     * _.without([2, 1, 2, 3], 1, 2);
	     * // => [3]
	     */
	    var without = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, values)
	        : [];
	    });
	
	    /**
	     * Creates an array of unique values that is the
	     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
	     * of the given arrays. The order of result values is determined by the order
	     * they occur in the arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.without
	     * @example
	     *
	     * _.xor([2, 1], [2, 3]);
	     * // => [1, 3]
	     */
	    var xor = baseRest(function(arrays) {
	      return baseXor(arrayFilter(arrays, isArrayLikeObject));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which by which they're compared. The order of result values is determined
	     * by the order they occur in the arrays. The iteratee is invoked with one
	     * argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2, 3.4]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var xorBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `comparator` which is
	     * invoked to compare elements of `arrays`. The order of result values is
	     * determined by the order they occur in the arrays. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.xorWith(objects, others, _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var xorWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
	    });
	
	    /**
	     * Creates an array of grouped elements, the first of which contains the
	     * first elements of the given arrays, the second of which contains the
	     * second elements of the given arrays, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     */
	    var zip = baseRest(unzip);
	
	    /**
	     * This method is like `_.fromPairs` except that it accepts two arrays,
	     * one of property identifiers and one of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.4.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObject(['a', 'b'], [1, 2]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function zipObject(props, values) {
	      return baseZipObject(props || [], values || [], assignValue);
	    }
	
	    /**
	     * This method is like `_.zipObject` except that it supports property paths.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
	     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
	     */
	    function zipObjectDeep(props, values) {
	      return baseZipObject(props || [], values || [], baseSet);
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts `iteratee` to specify
	     * how grouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  grouped values.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
	     *   return a + b + c;
	     * });
	     * // => [111, 222]
	     */
	    var zipWith = baseRest(function(arrays) {
	      var length = arrays.length,
	          iteratee = length > 1 ? arrays[length - 1] : undefined;
	
	      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
	      return unzipWith(arrays, iteratee);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
	     * chain sequences enabled. The result of such sequences must be unwrapped
	     * with `_#value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Seq
	     * @param {*} value The value to wrap.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36 },
	     *   { 'user': 'fred',    'age': 40 },
	     *   { 'user': 'pebbles', 'age': 1 }
	     * ];
	     *
	     * var youngest = _
	     *   .chain(users)
	     *   .sortBy('age')
	     *   .map(function(o) {
	     *     return o.user + ' is ' + o.age;
	     *   })
	     *   .head()
	     *   .value();
	     * // => 'pebbles is 1'
	     */
	    function chain(value) {
	      var result = lodash(value);
	      result.__chain__ = true;
	      return result;
	    }
	
	    /**
	     * This method invokes `interceptor` and returns `value`. The interceptor
	     * is invoked with one argument; (value). The purpose of this method is to
	     * "tap into" a method chain sequence in order to modify intermediate results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * _([1, 2, 3])
	     *  .tap(function(array) {
	     *    // Mutate input array.
	     *    array.pop();
	     *  })
	     *  .reverse()
	     *  .value();
	     * // => [2, 1]
	     */
	    function tap(value, interceptor) {
	      interceptor(value);
	      return value;
	    }
	
	    /**
	     * This method is like `_.tap` except that it returns the result of `interceptor`.
	     * The purpose of this method is to "pass thru" values replacing intermediate
	     * results in a method chain sequence.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns the result of `interceptor`.
	     * @example
	     *
	     * _('  abc  ')
	     *  .chain()
	     *  .trim()
	     *  .thru(function(value) {
	     *    return [value];
	     *  })
	     *  .value();
	     * // => ['abc']
	     */
	    function thru(value, interceptor) {
	      return interceptor(value);
	    }
	
	    /**
	     * This method is the wrapper version of `_.at`.
	     *
	     * @name at
	     * @memberOf _
	     * @since 1.0.0
	     * @category Seq
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _(object).at(['a[0].b.c', 'a[1]']).value();
	     * // => [3, 4]
	     */
	    var wrapperAt = flatRest(function(paths) {
	      var length = paths.length,
	          start = length ? paths[0] : 0,
	          value = this.__wrapped__,
	          interceptor = function(object) { return baseAt(object, paths); };
	
	      if (length > 1 || this.__actions__.length ||
	          !(value instanceof LazyWrapper) || !isIndex(start)) {
	        return this.thru(interceptor);
	      }
	      value = value.slice(start, +start + (length ? 1 : 0));
	      value.__actions__.push({
	        'func': thru,
	        'args': [interceptor],
	        'thisArg': undefined
	      });
	      return new LodashWrapper(value, this.__chain__).thru(function(array) {
	        if (length && !array.length) {
	          array.push(undefined);
	        }
	        return array;
	      });
	    });
	
	    /**
	     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
	     *
	     * @name chain
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * // A sequence without explicit chaining.
	     * _(users).head();
	     * // => { 'user': 'barney', 'age': 36 }
	     *
	     * // A sequence with explicit chaining.
	     * _(users)
	     *   .chain()
	     *   .head()
	     *   .pick('user')
	     *   .value();
	     * // => { 'user': 'barney' }
	     */
	    function wrapperChain() {
	      return chain(this);
	    }
	
	    /**
	     * Executes the chain sequence and returns the wrapped result.
	     *
	     * @name commit
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2];
	     * var wrapped = _(array).push(3);
	     *
	     * console.log(array);
	     * // => [1, 2]
	     *
	     * wrapped = wrapped.commit();
	     * console.log(array);
	     * // => [1, 2, 3]
	     *
	     * wrapped.last();
	     * // => 3
	     *
	     * console.log(array);
	     * // => [1, 2, 3]
	     */
	    function wrapperCommit() {
	      return new LodashWrapper(this.value(), this.__chain__);
	    }
	
	    /**
	     * Gets the next value on a wrapped object following the
	     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
	     *
	     * @name next
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the next iterator value.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 1 }
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 2 }
	     *
	     * wrapped.next();
	     * // => { 'done': true, 'value': undefined }
	     */
	    function wrapperNext() {
	      if (this.__values__ === undefined) {
	        this.__values__ = toArray(this.value());
	      }
	      var done = this.__index__ >= this.__values__.length,
	          value = done ? undefined : this.__values__[this.__index__++];
	
	      return { 'done': done, 'value': value };
	    }
	
	    /**
	     * Enables the wrapper to be iterable.
	     *
	     * @name Symbol.iterator
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the wrapper object.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped[Symbol.iterator]() === wrapped;
	     * // => true
	     *
	     * Array.from(wrapped);
	     * // => [1, 2]
	     */
	    function wrapperToIterator() {
	      return this;
	    }
	
	    /**
	     * Creates a clone of the chain sequence planting `value` as the wrapped value.
	     *
	     * @name plant
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @param {*} value The value to plant.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2]).map(square);
	     * var other = wrapped.plant([3, 4]);
	     *
	     * other.value();
	     * // => [9, 16]
	     *
	     * wrapped.value();
	     * // => [1, 4]
	     */
	    function wrapperPlant(value) {
	      var result,
	          parent = this;
	
	      while (parent instanceof baseLodash) {
	        var clone = wrapperClone(parent);
	        clone.__index__ = 0;
	        clone.__values__ = undefined;
	        if (result) {
	          previous.__wrapped__ = clone;
	        } else {
	          result = clone;
	        }
	        var previous = clone;
	        parent = parent.__wrapped__;
	      }
	      previous.__wrapped__ = value;
	      return result;
	    }
	
	    /**
	     * This method is the wrapper version of `_.reverse`.
	     *
	     * **Note:** This method mutates the wrapped array.
	     *
	     * @name reverse
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _(array).reverse().value()
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function wrapperReverse() {
	      var value = this.__wrapped__;
	      if (value instanceof LazyWrapper) {
	        var wrapped = value;
	        if (this.__actions__.length) {
	          wrapped = new LazyWrapper(this);
	        }
	        wrapped = wrapped.reverse();
	        wrapped.__actions__.push({
	          'func': thru,
	          'args': [reverse],
	          'thisArg': undefined
	        });
	        return new LodashWrapper(wrapped, this.__chain__);
	      }
	      return this.thru(reverse);
	    }
	
	    /**
	     * Executes the chain sequence to resolve the unwrapped value.
	     *
	     * @name value
	     * @memberOf _
	     * @since 0.1.0
	     * @alias toJSON, valueOf
	     * @category Seq
	     * @returns {*} Returns the resolved unwrapped value.
	     * @example
	     *
	     * _([1, 2, 3]).value();
	     * // => [1, 2, 3]
	     */
	    function wrapperValue() {
	      return baseWrapperValue(this.__wrapped__, this.__actions__);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the number of times the key was returned by `iteratee`. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.countBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': 1, '6': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.countBy(['one', 'two', 'three'], 'length');
	     * // => { '3': 2, '5': 1 }
	     */
	    var countBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        ++result[key];
	      } else {
	        baseAssignValue(result, key, 1);
	      }
	    });
	
	    /**
	     * Checks if `predicate` returns truthy for **all** elements of `collection`.
	     * Iteration is stopped once `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * **Note:** This method returns `true` for
	     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
	     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
	     * elements of empty collections.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.every([true, 1, null, 'yes'], Boolean);
	     * // => false
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.every(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.every(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.every(users, 'active');
	     * // => false
	     */
	    function every(collection, predicate, guard) {
	      var func = isArray(collection) ? arrayEvery : baseEvery;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning an array of all elements
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * **Note:** Unlike `_.remove`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.reject
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * _.filter(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, { 'age': 36, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.filter(users, 'active');
	     * // => objects for ['barney']
	     *
	     * // Combining several predicates using `_.overEvery` or `_.overSome`.
	     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
	     * // => objects for ['fred', 'barney']
	     */
	    function filter(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning the first element
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': true },
	     *   { 'user': 'fred',    'age': 40, 'active': false },
	     *   { 'user': 'pebbles', 'age': 1,  'active': true }
	     * ];
	     *
	     * _.find(users, function(o) { return o.age < 40; });
	     * // => object for 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.find(users, { 'age': 1, 'active': true });
	     * // => object for 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.find(users, ['active', false]);
	     * // => object for 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.find(users, 'active');
	     * // => object for 'barney'
	     */
	    var find = createFind(findIndex);
	
	    /**
	     * This method is like `_.find` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=collection.length-1] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * _.findLast([1, 2, 3, 4], function(n) {
	     *   return n % 2 == 1;
	     * });
	     * // => 3
	     */
	    var findLast = createFind(findLastIndex);
	
	    /**
	     * Creates a flattened array of values by running each element in `collection`
	     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
	     * with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [n, n];
	     * }
	     *
	     * _.flatMap([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMap(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), 1);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDeep([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMapDeep(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), INFINITY);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDepth([1, 2], duplicate, 2);
	     * // => [[1, 1], [2, 2]]
	     */
	    function flatMapDepth(collection, iteratee, depth) {
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(map(collection, iteratee), depth);
	    }
	
	    /**
	     * Iterates over elements of `collection` and invokes `iteratee` for each element.
	     * The iteratee is invoked with three arguments: (value, index|key, collection).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * **Note:** As with other "Collections" methods, objects with a "length"
	     * property are iterated like arrays. To avoid this behavior use `_.forIn`
	     * or `_.forOwn` for object iteration.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias each
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEachRight
	     * @example
	     *
	     * _.forEach([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `1` then `2`.
	     *
	     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forEach(collection, iteratee) {
	      var func = isArray(collection) ? arrayEach : baseEach;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forEach` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @alias eachRight
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEach
	     * @example
	     *
	     * _.forEachRight([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `2` then `1`.
	     */
	    function forEachRight(collection, iteratee) {
	      var func = isArray(collection) ? arrayEachRight : baseEachRight;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The order of grouped values
	     * is determined by the order they occur in `collection`. The corresponding
	     * value of each key is an array of elements responsible for generating the
	     * key. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': [4.2], '6': [6.1, 6.3] }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.groupBy(['one', 'two', 'three'], 'length');
	     * // => { '3': ['one', 'two'], '5': ['three'] }
	     */
	    var groupBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        result[key].push(value);
	      } else {
	        baseAssignValue(result, key, [value]);
	      }
	    });
	
	    /**
	     * Checks if `value` is in `collection`. If `collection` is a string, it's
	     * checked for a substring of `value`, otherwise
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * is used for equality comparisons. If `fromIndex` is negative, it's used as
	     * the offset from the end of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {boolean} Returns `true` if `value` is found, else `false`.
	     * @example
	     *
	     * _.includes([1, 2, 3], 1);
	     * // => true
	     *
	     * _.includes([1, 2, 3], 1, 2);
	     * // => false
	     *
	     * _.includes({ 'a': 1, 'b': 2 }, 1);
	     * // => true
	     *
	     * _.includes('abcd', 'bc');
	     * // => true
	     */
	    function includes(collection, value, fromIndex, guard) {
	      collection = isArrayLike(collection) ? collection : values(collection);
	      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;
	
	      var length = collection.length;
	      if (fromIndex < 0) {
	        fromIndex = nativeMax(length + fromIndex, 0);
	      }
	      return isString(collection)
	        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
	        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
	    }
	
	    /**
	     * Invokes the method at `path` of each element in `collection`, returning
	     * an array of the results of each invoked method. Any additional arguments
	     * are provided to each invoked method. If `path` is a function, it's invoked
	     * for, and `this` bound to, each element in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|string} path The path of the method to invoke or
	     *  the function invoked per iteration.
	     * @param {...*} [args] The arguments to invoke each method with.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
	     * // => [[1, 5, 7], [1, 2, 3]]
	     *
	     * _.invokeMap([123, 456], String.prototype.split, '');
	     * // => [['1', '2', '3'], ['4', '5', '6']]
	     */
	    var invokeMap = baseRest(function(collection, path, args) {
	      var index = -1,
	          isFunc = typeof path == 'function',
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value) {
	        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
	      });
	      return result;
	    });
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the last element responsible for generating the key. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * var array = [
	     *   { 'dir': 'left', 'code': 97 },
	     *   { 'dir': 'right', 'code': 100 }
	     * ];
	     *
	     * _.keyBy(array, function(o) {
	     *   return String.fromCharCode(o.code);
	     * });
	     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	     *
	     * _.keyBy(array, 'dir');
	     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
	     */
	    var keyBy = createAggregator(function(result, value, key) {
	      baseAssignValue(result, key, value);
	    });
	
	    /**
	     * Creates an array of values by running each element in `collection` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	     *
	     * The guarded methods are:
	     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
	     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
	     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
	     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * _.map([4, 8], square);
	     * // => [16, 64]
	     *
	     * _.map({ 'a': 4, 'b': 8 }, square);
	     * // => [16, 64] (iteration order is not guaranteed)
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, 'user');
	     * // => ['barney', 'fred']
	     */
	    function map(collection, iteratee) {
	      var func = isArray(collection) ? arrayMap : baseMap;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.sortBy` except that it allows specifying the sort
	     * orders of the iteratees to sort by. If `orders` is unspecified, all values
	     * are sorted in ascending order. Otherwise, specify an order of "desc" for
	     * descending or "asc" for ascending sort order of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @param {string[]} [orders] The sort orders of `iteratees`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 34 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 36 }
	     * ];
	     *
	     * // Sort by `user` in ascending order and by `age` in descending order.
	     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     */
	    function orderBy(collection, iteratees, orders, guard) {
	      if (collection == null) {
	        return [];
	      }
	      if (!isArray(iteratees)) {
	        iteratees = iteratees == null ? [] : [iteratees];
	      }
	      orders = guard ? undefined : orders;
	      if (!isArray(orders)) {
	        orders = orders == null ? [] : [orders];
	      }
	      return baseOrderBy(collection, iteratees, orders);
	    }
	
	    /**
	     * Creates an array of elements split into two groups, the first of which
	     * contains elements `predicate` returns truthy for, the second of which
	     * contains elements `predicate` returns falsey for. The predicate is
	     * invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of grouped elements.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': false },
	     *   { 'user': 'fred',    'age': 40, 'active': true },
	     *   { 'user': 'pebbles', 'age': 1,  'active': false }
	     * ];
	     *
	     * _.partition(users, function(o) { return o.active; });
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.partition(users, { 'age': 1, 'active': false });
	     * // => objects for [['pebbles'], ['barney', 'fred']]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.partition(users, ['active', false]);
	     * // => objects for [['barney', 'pebbles'], ['fred']]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.partition(users, 'active');
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     */
	    var partition = createAggregator(function(result, value, key) {
	      result[key ? 0 : 1].push(value);
	    }, function() { return [[], []]; });
	
	    /**
	     * Reduces `collection` to a value which is the accumulated result of running
	     * each element in `collection` thru `iteratee`, where each successive
	     * invocation is supplied the return value of the previous. If `accumulator`
	     * is not given, the first element of `collection` is used as the initial
	     * value. The iteratee is invoked with four arguments:
	     * (accumulator, value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.reduce`, `_.reduceRight`, and `_.transform`.
	     *
	     * The guarded methods are:
	     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
	     * and `sortBy`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduceRight
	     * @example
	     *
	     * _.reduce([1, 2], function(sum, n) {
	     *   return sum + n;
	     * }, 0);
	     * // => 3
	     *
	     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     *   return result;
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
	     */
	    function reduce(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduce : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
	    }
	
	    /**
	     * This method is like `_.reduce` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduce
	     * @example
	     *
	     * var array = [[0, 1], [2, 3], [4, 5]];
	     *
	     * _.reduceRight(array, function(flattened, other) {
	     *   return flattened.concat(other);
	     * }, []);
	     * // => [4, 5, 2, 3, 0, 1]
	     */
	    function reduceRight(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduceRight : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
	    }
	
	    /**
	     * The opposite of `_.filter`; this method returns the elements of `collection`
	     * that `predicate` does **not** return truthy for.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.filter
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': true }
	     * ];
	     *
	     * _.reject(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.reject(users, { 'age': 40, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.reject(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.reject(users, 'active');
	     * // => objects for ['barney']
	     */
	    function reject(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, negate(getIteratee(predicate, 3)));
	    }
	
	    /**
	     * Gets a random element from `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     * @example
	     *
	     * _.sample([1, 2, 3, 4]);
	     * // => 2
	     */
	    function sample(collection) {
	      var func = isArray(collection) ? arraySample : baseSample;
	      return func(collection);
	    }
	
	    /**
	     * Gets `n` random elements at unique keys from `collection` up to the
	     * size of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} [n=1] The number of elements to sample.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the random elements.
	     * @example
	     *
	     * _.sampleSize([1, 2, 3], 2);
	     * // => [3, 1]
	     *
	     * _.sampleSize([1, 2, 3], 4);
	     * // => [2, 3, 1]
	     */
	    function sampleSize(collection, n, guard) {
	      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
	      return func(collection, n);
	    }
	
	    /**
	     * Creates an array of shuffled values, using a version of the
	     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     * @example
	     *
	     * _.shuffle([1, 2, 3, 4]);
	     * // => [4, 1, 3, 2]
	     */
	    function shuffle(collection) {
	      var func = isArray(collection) ? arrayShuffle : baseShuffle;
	      return func(collection);
	    }
	
	    /**
	     * Gets the size of `collection` by returning its length for array-like
	     * values or the number of own enumerable string keyed properties for objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @returns {number} Returns the collection size.
	     * @example
	     *
	     * _.size([1, 2, 3]);
	     * // => 3
	     *
	     * _.size({ 'a': 1, 'b': 2 });
	     * // => 2
	     *
	     * _.size('pebbles');
	     * // => 7
	     */
	    function size(collection) {
	      if (collection == null) {
	        return 0;
	      }
	      if (isArrayLike(collection)) {
	        return isString(collection) ? stringSize(collection) : collection.length;
	      }
	      var tag = getTag(collection);
	      if (tag == mapTag || tag == setTag) {
	        return collection.size;
	      }
	      return baseKeys(collection).length;
	    }
	
	    /**
	     * Checks if `predicate` returns truthy for **any** element of `collection`.
	     * Iteration is stopped once `predicate` returns truthy. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.some([null, 0, 'yes', false], Boolean);
	     * // => true
	     *
	     * var users = [
	     *   { 'user': 'barney', 'active': true },
	     *   { 'user': 'fred',   'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.some(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.some(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.some(users, 'active');
	     * // => true
	     */
	    function some(collection, predicate, guard) {
	      var func = isArray(collection) ? arraySome : baseSome;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Creates an array of elements, sorted in ascending order by the results of
	     * running each element in a collection thru each iteratee. This method
	     * performs a stable sort, that is, it preserves the original sort order of
	     * equal elements. The iteratees are invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 30 },
	     *   { 'user': 'barney', 'age': 34 }
	     * ];
	     *
	     * _.sortBy(users, [function(o) { return o.user; }]);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
	     *
	     * _.sortBy(users, ['user', 'age']);
	     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
	     */
	    var sortBy = baseRest(function(collection, iteratees) {
	      if (collection == null) {
	        return [];
	      }
	      var length = iteratees.length;
	      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
	        iteratees = [];
	      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
	        iteratees = [iteratees[0]];
	      }
	      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Gets the timestamp of the number of milliseconds that have elapsed since
	     * the Unix epoch (1 January 1970 00:00:00 UTC).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Date
	     * @returns {number} Returns the timestamp.
	     * @example
	     *
	     * _.defer(function(stamp) {
	     *   console.log(_.now() - stamp);
	     * }, _.now());
	     * // => Logs the number of milliseconds it took for the deferred invocation.
	     */
	    var now = ctxNow || function() {
	      return root.Date.now();
	    };
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The opposite of `_.before`; this method creates a function that invokes
	     * `func` once it's called `n` or more times.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {number} n The number of calls before `func` is invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var saves = ['profile', 'settings'];
	     *
	     * var done = _.after(saves.length, function() {
	     *   console.log('done saving!');
	     * });
	     *
	     * _.forEach(saves, function(type) {
	     *   asyncSave({ 'type': type, 'complete': done });
	     * });
	     * // => Logs 'done saving!' after the two async saves have completed.
	     */
	    function after(n, func) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n < 1) {
	          return func.apply(this, arguments);
	        }
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func`, with up to `n` arguments,
	     * ignoring any additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @param {number} [n=func.length] The arity cap.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
	     * // => [6, 8, 10]
	     */
	    function ary(func, n, guard) {
	      n = guard ? undefined : n;
	      n = (func && n == null) ? func.length : n;
	      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
	    }
	
	    /**
	     * Creates a function that invokes `func`, with the `this` binding and arguments
	     * of the created function, while it's called less than `n` times. Subsequent
	     * calls to the created function return the result of the last `func` invocation.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {number} n The number of calls at which `func` is no longer invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * jQuery(element).on('click', _.before(5, addContactToList));
	     * // => Allows adding up to 4 contacts to the list.
	     */
	    function before(n, func) {
	      var result;
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n > 0) {
	          result = func.apply(this, arguments);
	        }
	        if (n <= 1) {
	          func = undefined;
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of `thisArg`
	     * and `partials` prepended to the arguments it receives.
	     *
	     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
	     * property of bound functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to bind.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * function greet(greeting, punctuation) {
	     *   return greeting + ' ' + this.user + punctuation;
	     * }
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * var bound = _.bind(greet, object, 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bind(greet, object, _, '!');
	     * bound('hi');
	     * // => 'hi fred!'
	     */
	    var bind = baseRest(function(func, thisArg, partials) {
	      var bitmask = WRAP_BIND_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bind));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(func, bitmask, thisArg, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes the method at `object[key]` with `partials`
	     * prepended to the arguments it receives.
	     *
	     * This method differs from `_.bind` by allowing bound functions to reference
	     * methods that may be redefined or don't yet exist. See
	     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
	     * for more details.
	     *
	     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Function
	     * @param {Object} object The object to invoke the method on.
	     * @param {string} key The key of the method.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * var object = {
	     *   'user': 'fred',
	     *   'greet': function(greeting, punctuation) {
	     *     return greeting + ' ' + this.user + punctuation;
	     *   }
	     * };
	     *
	     * var bound = _.bindKey(object, 'greet', 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * object.greet = function(greeting, punctuation) {
	     *   return greeting + 'ya ' + this.user + punctuation;
	     * };
	     *
	     * bound('!');
	     * // => 'hiya fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bindKey(object, 'greet', _, '!');
	     * bound('hi');
	     * // => 'hiya fred!'
	     */
	    var bindKey = baseRest(function(object, key, partials) {
	      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bindKey));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(key, bitmask, object, partials, holders);
	    });
	
	    /**
	     * Creates a function that accepts arguments of `func` and either invokes
	     * `func` returning its result, if at least `arity` number of arguments have
	     * been provided, or returns a function that accepts the remaining `func`
	     * arguments, and so on. The arity of `func` may be specified if `func.length`
	     * is not sufficient.
	     *
	     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curry(abc);
	     *
	     * curried(1)(2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(1)(_, 3)(2);
	     * // => [1, 2, 3]
	     */
	    function curry(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curry.placeholder;
	      return result;
	    }
	
	    /**
	     * This method is like `_.curry` except that arguments are applied to `func`
	     * in the manner of `_.partialRight` instead of `_.partial`.
	     *
	     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curryRight(abc);
	     *
	     * curried(3)(2)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(2, 3)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(3)(1, _)(2);
	     * // => [1, 2, 3]
	     */
	    function curryRight(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curryRight.placeholder;
	      return result;
	    }
	
	    /**
	     * Creates a debounced function that delays invoking `func` until after `wait`
	     * milliseconds have elapsed since the last time the debounced function was
	     * invoked. The debounced function comes with a `cancel` method to cancel
	     * delayed `func` invocations and a `flush` method to immediately invoke them.
	     * Provide `options` to indicate whether `func` should be invoked on the
	     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	     * with the last arguments provided to the debounced function. Subsequent
	     * calls to the debounced function return the result of the last `func`
	     * invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the debounced function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.debounce` and `_.throttle`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to debounce.
	     * @param {number} [wait=0] The number of milliseconds to delay.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=false]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {number} [options.maxWait]
	     *  The maximum time `func` is allowed to be delayed before it's invoked.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new debounced function.
	     * @example
	     *
	     * // Avoid costly calculations while the window size is in flux.
	     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	     *
	     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	     * jQuery(element).on('click', _.debounce(sendMail, 300, {
	     *   'leading': true,
	     *   'trailing': false
	     * }));
	     *
	     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	     * var source = new EventSource('/stream');
	     * jQuery(source).on('message', debounced);
	     *
	     * // Cancel the trailing debounced invocation.
	     * jQuery(window).on('popstate', debounced.cancel);
	     */
	    function debounce(func, wait, options) {
	      var lastArgs,
	          lastThis,
	          maxWait,
	          result,
	          timerId,
	          lastCallTime,
	          lastInvokeTime = 0,
	          leading = false,
	          maxing = false,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      wait = toNumber(wait) || 0;
	      if (isObject(options)) {
	        leading = !!options.leading;
	        maxing = 'maxWait' in options;
	        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	
	      function invokeFunc(time) {
	        var args = lastArgs,
	            thisArg = lastThis;
	
	        lastArgs = lastThis = undefined;
	        lastInvokeTime = time;
	        result = func.apply(thisArg, args);
	        return result;
	      }
	
	      function leadingEdge(time) {
	        // Reset any `maxWait` timer.
	        lastInvokeTime = time;
	        // Start the timer for the trailing edge.
	        timerId = setTimeout(timerExpired, wait);
	        // Invoke the leading edge.
	        return leading ? invokeFunc(time) : result;
	      }
	
	      function remainingWait(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime,
	            timeWaiting = wait - timeSinceLastCall;
	
	        return maxing
	          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
	          : timeWaiting;
	      }
	
	      function shouldInvoke(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime;
	
	        // Either this is the first call, activity has stopped and we're at the
	        // trailing edge, the system time has gone backwards and we're treating
	        // it as the trailing edge, or we've hit the `maxWait` limit.
	        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	      }
	
	      function timerExpired() {
	        var time = now();
	        if (shouldInvoke(time)) {
	          return trailingEdge(time);
	        }
	        // Restart the timer.
	        timerId = setTimeout(timerExpired, remainingWait(time));
	      }
	
	      function trailingEdge(time) {
	        timerId = undefined;
	
	        // Only invoke if we have `lastArgs` which means `func` has been
	        // debounced at least once.
	        if (trailing && lastArgs) {
	          return invokeFunc(time);
	        }
	        lastArgs = lastThis = undefined;
	        return result;
	      }
	
	      function cancel() {
	        if (timerId !== undefined) {
	          clearTimeout(timerId);
	        }
	        lastInvokeTime = 0;
	        lastArgs = lastCallTime = lastThis = timerId = undefined;
	      }
	
	      function flush() {
	        return timerId === undefined ? result : trailingEdge(now());
	      }
	
	      function debounced() {
	        var time = now(),
	            isInvoking = shouldInvoke(time);
	
	        lastArgs = arguments;
	        lastThis = this;
	        lastCallTime = time;
	
	        if (isInvoking) {
	          if (timerId === undefined) {
	            return leadingEdge(lastCallTime);
	          }
	          if (maxing) {
	            // Handle invocations in a tight loop.
	            clearTimeout(timerId);
	            timerId = setTimeout(timerExpired, wait);
	            return invokeFunc(lastCallTime);
	          }
	        }
	        if (timerId === undefined) {
	          timerId = setTimeout(timerExpired, wait);
	        }
	        return result;
	      }
	      debounced.cancel = cancel;
	      debounced.flush = flush;
	      return debounced;
	    }
	
	    /**
	     * Defers invoking the `func` until the current call stack has cleared. Any
	     * additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to defer.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.defer(function(text) {
	     *   console.log(text);
	     * }, 'deferred');
	     * // => Logs 'deferred' after one millisecond.
	     */
	    var defer = baseRest(function(func, args) {
	      return baseDelay(func, 1, args);
	    });
	
	    /**
	     * Invokes `func` after `wait` milliseconds. Any additional arguments are
	     * provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.delay(function(text) {
	     *   console.log(text);
	     * }, 1000, 'later');
	     * // => Logs 'later' after one second.
	     */
	    var delay = baseRest(function(func, wait, args) {
	      return baseDelay(func, toNumber(wait) || 0, args);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments reversed.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to flip arguments for.
	     * @returns {Function} Returns the new flipped function.
	     * @example
	     *
	     * var flipped = _.flip(function() {
	     *   return _.toArray(arguments);
	     * });
	     *
	     * flipped('a', 'b', 'c', 'd');
	     * // => ['d', 'c', 'b', 'a']
	     */
	    function flip(func) {
	      return createWrap(func, WRAP_FLIP_FLAG);
	    }
	
	    /**
	     * Creates a function that memoizes the result of `func`. If `resolver` is
	     * provided, it determines the cache key for storing the result based on the
	     * arguments provided to the memoized function. By default, the first argument
	     * provided to the memoized function is used as the map cache key. The `func`
	     * is invoked with the `this` binding of the memoized function.
	     *
	     * **Note:** The cache is exposed as the `cache` property on the memoized
	     * function. Its creation may be customized by replacing the `_.memoize.Cache`
	     * constructor with one whose instances implement the
	     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to have its output memoized.
	     * @param {Function} [resolver] The function to resolve the cache key.
	     * @returns {Function} Returns the new memoized function.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     * var other = { 'c': 3, 'd': 4 };
	     *
	     * var values = _.memoize(_.values);
	     * values(object);
	     * // => [1, 2]
	     *
	     * values(other);
	     * // => [3, 4]
	     *
	     * object.a = 2;
	     * values(object);
	     * // => [1, 2]
	     *
	     * // Modify the result cache.
	     * values.cache.set(object, ['a', 'b']);
	     * values(object);
	     * // => ['a', 'b']
	     *
	     * // Replace `_.memoize.Cache`.
	     * _.memoize.Cache = WeakMap;
	     */
	    function memoize(func, resolver) {
	      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var memoized = function() {
	        var args = arguments,
	            key = resolver ? resolver.apply(this, args) : args[0],
	            cache = memoized.cache;
	
	        if (cache.has(key)) {
	          return cache.get(key);
	        }
	        var result = func.apply(this, args);
	        memoized.cache = cache.set(key, result) || cache;
	        return result;
	      };
	      memoized.cache = new (memoize.Cache || MapCache);
	      return memoized;
	    }
	
	    // Expose `MapCache`.
	    memoize.Cache = MapCache;
	
	    /**
	     * Creates a function that negates the result of the predicate `func`. The
	     * `func` predicate is invoked with the `this` binding and arguments of the
	     * created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} predicate The predicate to negate.
	     * @returns {Function} Returns the new negated function.
	     * @example
	     *
	     * function isEven(n) {
	     *   return n % 2 == 0;
	     * }
	     *
	     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
	     * // => [1, 3, 5]
	     */
	    function negate(predicate) {
	      if (typeof predicate != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return function() {
	        var args = arguments;
	        switch (args.length) {
	          case 0: return !predicate.call(this);
	          case 1: return !predicate.call(this, args[0]);
	          case 2: return !predicate.call(this, args[0], args[1]);
	          case 3: return !predicate.call(this, args[0], args[1], args[2]);
	        }
	        return !predicate.apply(this, args);
	      };
	    }
	
	    /**
	     * Creates a function that is restricted to invoking `func` once. Repeat calls
	     * to the function return the value of the first invocation. The `func` is
	     * invoked with the `this` binding and arguments of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var initialize = _.once(createApplication);
	     * initialize();
	     * initialize();
	     * // => `createApplication` is invoked once
	     */
	    function once(func) {
	      return before(2, func);
	    }
	
	    /**
	     * Creates a function that invokes `func` with its arguments transformed.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to wrap.
	     * @param {...(Function|Function[])} [transforms=[_.identity]]
	     *  The argument transforms.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function doubled(n) {
	     *   return n * 2;
	     * }
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var func = _.overArgs(function(x, y) {
	     *   return [x, y];
	     * }, [square, doubled]);
	     *
	     * func(9, 3);
	     * // => [81, 6]
	     *
	     * func(10, 5);
	     * // => [100, 10]
	     */
	    var overArgs = castRest(function(func, transforms) {
	      transforms = (transforms.length == 1 && isArray(transforms[0]))
	        ? arrayMap(transforms[0], baseUnary(getIteratee()))
	        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
	
	      var funcsLength = transforms.length;
	      return baseRest(function(args) {
	        var index = -1,
	            length = nativeMin(args.length, funcsLength);
	
	        while (++index < length) {
	          args[index] = transforms[index].call(this, args[index]);
	        }
	        return apply(func, this, args);
	      });
	    });
	
	    /**
	     * Creates a function that invokes `func` with `partials` prepended to the
	     * arguments it receives. This method is like `_.bind` except it does **not**
	     * alter the `this` binding.
	     *
	     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.2.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var sayHelloTo = _.partial(greet, 'hello');
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     *
	     * // Partially applied with placeholders.
	     * var greetFred = _.partial(greet, _, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     */
	    var partial = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partial));
	      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * This method is like `_.partial` except that partially applied arguments
	     * are appended to the arguments it receives.
	     *
	     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var greetFred = _.partialRight(greet, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     *
	     * // Partially applied with placeholders.
	     * var sayHelloTo = _.partialRight(greet, 'hello', _);
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     */
	    var partialRight = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partialRight));
	      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments arranged according
	     * to the specified `indexes` where the argument value at the first index is
	     * provided as the first argument, the argument value at the second index is
	     * provided as the second argument, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to rearrange arguments for.
	     * @param {...(number|number[])} indexes The arranged argument indexes.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var rearged = _.rearg(function(a, b, c) {
	     *   return [a, b, c];
	     * }, [2, 0, 1]);
	     *
	     * rearged('b', 'c', 'a')
	     * // => ['a', 'b', 'c']
	     */
	    var rearg = flatRest(function(func, indexes) {
	      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
	    });
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * created function and arguments from `start` and beyond provided as
	     * an array.
	     *
	     * **Note:** This method is based on the
	     * [rest parameter](https://mdn.io/rest_parameters).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.rest(function(what, names) {
	     *   return what + ' ' + _.initial(names).join(', ') +
	     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	     * });
	     *
	     * say('hello', 'fred', 'barney', 'pebbles');
	     * // => 'hello fred, barney, & pebbles'
	     */
	    function rest(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start === undefined ? start : toInteger(start);
	      return baseRest(func, start);
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * create function and an array of arguments much like
	     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
	     *
	     * **Note:** This method is based on the
	     * [spread operator](https://mdn.io/spread_operator).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Function
	     * @param {Function} func The function to spread arguments over.
	     * @param {number} [start=0] The start position of the spread.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.spread(function(who, what) {
	     *   return who + ' says ' + what;
	     * });
	     *
	     * say(['fred', 'hello']);
	     * // => 'fred says hello'
	     *
	     * var numbers = Promise.all([
	     *   Promise.resolve(40),
	     *   Promise.resolve(36)
	     * ]);
	     *
	     * numbers.then(_.spread(function(x, y) {
	     *   return x + y;
	     * }));
	     * // => a Promise of 76
	     */
	    function spread(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start == null ? 0 : nativeMax(toInteger(start), 0);
	      return baseRest(function(args) {
	        var array = args[start],
	            otherArgs = castSlice(args, 0, start);
	
	        if (array) {
	          arrayPush(otherArgs, array);
	        }
	        return apply(func, this, otherArgs);
	      });
	    }
	
	    /**
	     * Creates a throttled function that only invokes `func` at most once per
	     * every `wait` milliseconds. The throttled function comes with a `cancel`
	     * method to cancel delayed `func` invocations and a `flush` method to
	     * immediately invoke them. Provide `options` to indicate whether `func`
	     * should be invoked on the leading and/or trailing edge of the `wait`
	     * timeout. The `func` is invoked with the last arguments provided to the
	     * throttled function. Subsequent calls to the throttled function return the
	     * result of the last `func` invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the throttled function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.throttle` and `_.debounce`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to throttle.
	     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=true]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new throttled function.
	     * @example
	     *
	     * // Avoid excessively updating the position while scrolling.
	     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	     *
	     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	     * jQuery(element).on('click', throttled);
	     *
	     * // Cancel the trailing throttled invocation.
	     * jQuery(window).on('popstate', throttled.cancel);
	     */
	    function throttle(func, wait, options) {
	      var leading = true,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      if (isObject(options)) {
	        leading = 'leading' in options ? !!options.leading : leading;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	      return debounce(func, wait, {
	        'leading': leading,
	        'maxWait': wait,
	        'trailing': trailing
	      });
	    }
	
	    /**
	     * Creates a function that accepts up to one argument, ignoring any
	     * additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.unary(parseInt));
	     * // => [6, 8, 10]
	     */
	    function unary(func) {
	      return ary(func, 1);
	    }
	
	    /**
	     * Creates a function that provides `value` to `wrapper` as its first
	     * argument. Any additional arguments provided to the function are appended
	     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
	     * binding of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {*} value The value to wrap.
	     * @param {Function} [wrapper=identity] The wrapper function.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var p = _.wrap(_.escape, function(func, text) {
	     *   return '<p>' + func(text) + '</p>';
	     * });
	     *
	     * p('fred, barney, & pebbles');
	     * // => '<p>fred, barney, &amp; pebbles</p>'
	     */
	    function wrap(value, wrapper) {
	      return partial(castFunction(wrapper), value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Casts `value` as an array if it's not one.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Lang
	     * @param {*} value The value to inspect.
	     * @returns {Array} Returns the cast array.
	     * @example
	     *
	     * _.castArray(1);
	     * // => [1]
	     *
	     * _.castArray({ 'a': 1 });
	     * // => [{ 'a': 1 }]
	     *
	     * _.castArray('abc');
	     * // => ['abc']
	     *
	     * _.castArray(null);
	     * // => [null]
	     *
	     * _.castArray(undefined);
	     * // => [undefined]
	     *
	     * _.castArray();
	     * // => []
	     *
	     * var array = [1, 2, 3];
	     * console.log(_.castArray(array) === array);
	     * // => true
	     */
	    function castArray() {
	      if (!arguments.length) {
	        return [];
	      }
	      var value = arguments[0];
	      return isArray(value) ? value : [value];
	    }
	
	    /**
	     * Creates a shallow clone of `value`.
	     *
	     * **Note:** This method is loosely based on the
	     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
	     * and supports cloning arrays, array buffers, booleans, date objects, maps,
	     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
	     * arrays. The own enumerable properties of `arguments` objects are cloned
	     * as plain objects. An empty object is returned for uncloneable values such
	     * as error objects, functions, DOM nodes, and WeakMaps.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeep
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var shallow = _.clone(objects);
	     * console.log(shallow[0] === objects[0]);
	     * // => true
	     */
	    function clone(value) {
	      return baseClone(value, CLONE_SYMBOLS_FLAG);
	    }
	
	    /**
	     * This method is like `_.clone` except that it accepts `customizer` which
	     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
	     * cloning is handled by the method instead. The `customizer` is invoked with
	     * up to four arguments; (value [, index|key, object, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeepWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(false);
	     *   }
	     * }
	     *
	     * var el = _.cloneWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 0
	     */
	    function cloneWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
	    }
	
	    /**
	     * This method is like `_.clone` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.clone
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var deep = _.cloneDeep(objects);
	     * console.log(deep[0] === objects[0]);
	     * // => false
	     */
	    function cloneDeep(value) {
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
	    }
	
	    /**
	     * This method is like `_.cloneWith` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.cloneWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(true);
	     *   }
	     * }
	     *
	     * var el = _.cloneDeepWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 20
	     */
	    function cloneDeepWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
	    }
	
	    /**
	     * Checks if `object` conforms to `source` by invoking the predicate
	     * properties of `source` with the corresponding property values of `object`.
	     *
	     * **Note:** This method is equivalent to `_.conforms` when `source` is
	     * partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
	     * // => true
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
	     * // => false
	     */
	    function conformsTo(object, source) {
	      return source == null || baseConformsTo(object, source, keys(source));
	    }
	
	    /**
	     * Performs a
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * comparison between two values to determine if they are equivalent.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.eq(object, object);
	     * // => true
	     *
	     * _.eq(object, other);
	     * // => false
	     *
	     * _.eq('a', 'a');
	     * // => true
	     *
	     * _.eq('a', Object('a'));
	     * // => false
	     *
	     * _.eq(NaN, NaN);
	     * // => true
	     */
	    function eq(value, other) {
	      return value === other || (value !== value && other !== other);
	    }
	
	    /**
	     * Checks if `value` is greater than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     * @see _.lt
	     * @example
	     *
	     * _.gt(3, 1);
	     * // => true
	     *
	     * _.gt(3, 3);
	     * // => false
	     *
	     * _.gt(1, 3);
	     * // => false
	     */
	    var gt = createRelationalOperation(baseGt);
	
	    /**
	     * Checks if `value` is greater than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than or equal to
	     *  `other`, else `false`.
	     * @see _.lte
	     * @example
	     *
	     * _.gte(3, 1);
	     * // => true
	     *
	     * _.gte(3, 3);
	     * // => true
	     *
	     * _.gte(1, 3);
	     * // => false
	     */
	    var gte = createRelationalOperation(function(value, other) {
	      return value >= other;
	    });
	
	    /**
	     * Checks if `value` is likely an `arguments` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArguments(function() { return arguments; }());
	     * // => true
	     *
	     * _.isArguments([1, 2, 3]);
	     * // => false
	     */
	    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	        !propertyIsEnumerable.call(value, 'callee');
	    };
	
	    /**
	     * Checks if `value` is classified as an `Array` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	     * @example
	     *
	     * _.isArray([1, 2, 3]);
	     * // => true
	     *
	     * _.isArray(document.body.children);
	     * // => false
	     *
	     * _.isArray('abc');
	     * // => false
	     *
	     * _.isArray(_.noop);
	     * // => false
	     */
	    var isArray = Array.isArray;
	
	    /**
	     * Checks if `value` is classified as an `ArrayBuffer` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     * @example
	     *
	     * _.isArrayBuffer(new ArrayBuffer(2));
	     * // => true
	     *
	     * _.isArrayBuffer(new Array(2));
	     * // => false
	     */
	    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
	
	    /**
	     * Checks if `value` is array-like. A value is considered array-like if it's
	     * not a function and has a `value.length` that's an integer greater than or
	     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	     * @example
	     *
	     * _.isArrayLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLike(document.body.children);
	     * // => true
	     *
	     * _.isArrayLike('abc');
	     * // => true
	     *
	     * _.isArrayLike(_.noop);
	     * // => false
	     */
	    function isArrayLike(value) {
	      return value != null && isLength(value.length) && !isFunction(value);
	    }
	
	    /**
	     * This method is like `_.isArrayLike` except that it also checks if `value`
	     * is an object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array-like object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArrayLikeObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLikeObject(document.body.children);
	     * // => true
	     *
	     * _.isArrayLikeObject('abc');
	     * // => false
	     *
	     * _.isArrayLikeObject(_.noop);
	     * // => false
	     */
	    function isArrayLikeObject(value) {
	      return isObjectLike(value) && isArrayLike(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a boolean primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
	     * @example
	     *
	     * _.isBoolean(false);
	     * // => true
	     *
	     * _.isBoolean(null);
	     * // => false
	     */
	    function isBoolean(value) {
	      return value === true || value === false ||
	        (isObjectLike(value) && baseGetTag(value) == boolTag);
	    }
	
	    /**
	     * Checks if `value` is a buffer.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	     * @example
	     *
	     * _.isBuffer(new Buffer(2));
	     * // => true
	     *
	     * _.isBuffer(new Uint8Array(2));
	     * // => false
	     */
	    var isBuffer = nativeIsBuffer || stubFalse;
	
	    /**
	     * Checks if `value` is classified as a `Date` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     * @example
	     *
	     * _.isDate(new Date);
	     * // => true
	     *
	     * _.isDate('Mon April 23 2012');
	     * // => false
	     */
	    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
	
	    /**
	     * Checks if `value` is likely a DOM element.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
	     * @example
	     *
	     * _.isElement(document.body);
	     * // => true
	     *
	     * _.isElement('<body>');
	     * // => false
	     */
	    function isElement(value) {
	      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
	    }
	
	    /**
	     * Checks if `value` is an empty object, collection, map, or set.
	     *
	     * Objects are considered empty if they have no own enumerable string keyed
	     * properties.
	     *
	     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
	     * jQuery-like collections are considered empty if they have a `length` of `0`.
	     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	     * @example
	     *
	     * _.isEmpty(null);
	     * // => true
	     *
	     * _.isEmpty(true);
	     * // => true
	     *
	     * _.isEmpty(1);
	     * // => true
	     *
	     * _.isEmpty([1, 2, 3]);
	     * // => false
	     *
	     * _.isEmpty({ 'a': 1 });
	     * // => false
	     */
	    function isEmpty(value) {
	      if (value == null) {
	        return true;
	      }
	      if (isArrayLike(value) &&
	          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
	            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
	        return !value.length;
	      }
	      var tag = getTag(value);
	      if (tag == mapTag || tag == setTag) {
	        return !value.size;
	      }
	      if (isPrototype(value)) {
	        return !baseKeys(value).length;
	      }
	      for (var key in value) {
	        if (hasOwnProperty.call(value, key)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * Performs a deep comparison between two values to determine if they are
	     * equivalent.
	     *
	     * **Note:** This method supports comparing arrays, array buffers, booleans,
	     * date objects, error objects, maps, numbers, `Object` objects, regexes,
	     * sets, strings, symbols, and typed arrays. `Object` objects are compared
	     * by their own, not inherited, enumerable properties. Functions and DOM
	     * nodes are compared by strict equality, i.e. `===`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.isEqual(object, other);
	     * // => true
	     *
	     * object === other;
	     * // => false
	     */
	    function isEqual(value, other) {
	      return baseIsEqual(value, other);
	    }
	
	    /**
	     * This method is like `_.isEqual` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with up to
	     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, othValue) {
	     *   if (isGreeting(objValue) && isGreeting(othValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var array = ['hello', 'goodbye'];
	     * var other = ['hi', 'goodbye'];
	     *
	     * _.isEqualWith(array, other, customizer);
	     * // => true
	     */
	    function isEqualWith(value, other, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      var result = customizer ? customizer(value, other) : undefined;
	      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
	    }
	
	    /**
	     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
	     * `SyntaxError`, `TypeError`, or `URIError` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
	     * @example
	     *
	     * _.isError(new Error);
	     * // => true
	     *
	     * _.isError(Error);
	     * // => false
	     */
	    function isError(value) {
	      if (!isObjectLike(value)) {
	        return false;
	      }
	      var tag = baseGetTag(value);
	      return tag == errorTag || tag == domExcTag ||
	        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
	    }
	
	    /**
	     * Checks if `value` is a finite primitive number.
	     *
	     * **Note:** This method is based on
	     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
	     * @example
	     *
	     * _.isFinite(3);
	     * // => true
	     *
	     * _.isFinite(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isFinite(Infinity);
	     * // => false
	     *
	     * _.isFinite('3');
	     * // => false
	     */
	    function isFinite(value) {
	      return typeof value == 'number' && nativeIsFinite(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Function` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	     * @example
	     *
	     * _.isFunction(_);
	     * // => true
	     *
	     * _.isFunction(/abc/);
	     * // => false
	     */
	    function isFunction(value) {
	      if (!isObject(value)) {
	        return false;
	      }
	      // The use of `Object#toString` avoids issues with the `typeof` operator
	      // in Safari 9 which returns 'object' for typed arrays and other constructors.
	      var tag = baseGetTag(value);
	      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	    }
	
	    /**
	     * Checks if `value` is an integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
	     * @example
	     *
	     * _.isInteger(3);
	     * // => true
	     *
	     * _.isInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isInteger(Infinity);
	     * // => false
	     *
	     * _.isInteger('3');
	     * // => false
	     */
	    function isInteger(value) {
	      return typeof value == 'number' && value == toInteger(value);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like length.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	     * @example
	     *
	     * _.isLength(3);
	     * // => true
	     *
	     * _.isLength(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isLength(Infinity);
	     * // => false
	     *
	     * _.isLength('3');
	     * // => false
	     */
	    function isLength(value) {
	      return typeof value == 'number' &&
	        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is the
	     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	     * @example
	     *
	     * _.isObject({});
	     * // => true
	     *
	     * _.isObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isObject(_.noop);
	     * // => true
	     *
	     * _.isObject(null);
	     * // => false
	     */
	    function isObject(value) {
	      var type = typeof value;
	      return value != null && (type == 'object' || type == 'function');
	    }
	
	    /**
	     * Checks if `value` is object-like. A value is object-like if it's not `null`
	     * and has a `typeof` result of "object".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	     * @example
	     *
	     * _.isObjectLike({});
	     * // => true
	     *
	     * _.isObjectLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isObjectLike(_.noop);
	     * // => false
	     *
	     * _.isObjectLike(null);
	     * // => false
	     */
	    function isObjectLike(value) {
	      return value != null && typeof value == 'object';
	    }
	
	    /**
	     * Checks if `value` is classified as a `Map` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     * @example
	     *
	     * _.isMap(new Map);
	     * // => true
	     *
	     * _.isMap(new WeakMap);
	     * // => false
	     */
	    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
	
	    /**
	     * Performs a partial deep comparison between `object` and `source` to
	     * determine if `object` contains equivalent property values.
	     *
	     * **Note:** This method is equivalent to `_.matches` when `source` is
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.isMatch(object, { 'b': 2 });
	     * // => true
	     *
	     * _.isMatch(object, { 'b': 1 });
	     * // => false
	     */
	    function isMatch(object, source) {
	      return object === source || baseIsMatch(object, source, getMatchData(source));
	    }
	
	    /**
	     * This method is like `_.isMatch` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with five
	     * arguments: (objValue, srcValue, index|key, object, source).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var object = { 'greeting': 'hello' };
	     * var source = { 'greeting': 'hi' };
	     *
	     * _.isMatchWith(object, source, customizer);
	     * // => true
	     */
	    function isMatchWith(object, source, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseIsMatch(object, source, getMatchData(source), customizer);
	    }
	
	    /**
	     * Checks if `value` is `NaN`.
	     *
	     * **Note:** This method is based on
	     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
	     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
	     * `undefined` and other non-number values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	     * @example
	     *
	     * _.isNaN(NaN);
	     * // => true
	     *
	     * _.isNaN(new Number(NaN));
	     * // => true
	     *
	     * isNaN(undefined);
	     * // => true
	     *
	     * _.isNaN(undefined);
	     * // => false
	     */
	    function isNaN(value) {
	      // An `NaN` primitive is the only value that is not equal to itself.
	      // Perform the `toStringTag` check first to avoid errors with some
	      // ActiveX objects in IE.
	      return isNumber(value) && value != +value;
	    }
	
	    /**
	     * Checks if `value` is a pristine native function.
	     *
	     * **Note:** This method can't reliably detect native functions in the presence
	     * of the core-js package because core-js circumvents this kind of detection.
	     * Despite multiple requests, the core-js maintainer has made it clear: any
	     * attempt to fix the detection will be obstructed. As a result, we're left
	     * with little choice but to throw an error. Unfortunately, this also affects
	     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
	     * which rely on core-js.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     * @example
	     *
	     * _.isNative(Array.prototype.push);
	     * // => true
	     *
	     * _.isNative(_);
	     * // => false
	     */
	    function isNative(value) {
	      if (isMaskable(value)) {
	        throw new Error(CORE_ERROR_TEXT);
	      }
	      return baseIsNative(value);
	    }
	
	    /**
	     * Checks if `value` is `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
	     * @example
	     *
	     * _.isNull(null);
	     * // => true
	     *
	     * _.isNull(void 0);
	     * // => false
	     */
	    function isNull(value) {
	      return value === null;
	    }
	
	    /**
	     * Checks if `value` is `null` or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
	     * @example
	     *
	     * _.isNil(null);
	     * // => true
	     *
	     * _.isNil(void 0);
	     * // => true
	     *
	     * _.isNil(NaN);
	     * // => false
	     */
	    function isNil(value) {
	      return value == null;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Number` primitive or object.
	     *
	     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
	     * classified as numbers, use the `_.isFinite` method.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
	     * @example
	     *
	     * _.isNumber(3);
	     * // => true
	     *
	     * _.isNumber(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isNumber(Infinity);
	     * // => true
	     *
	     * _.isNumber('3');
	     * // => false
	     */
	    function isNumber(value) {
	      return typeof value == 'number' ||
	        (isObjectLike(value) && baseGetTag(value) == numberTag);
	    }
	
	    /**
	     * Checks if `value` is a plain object, that is, an object created by the
	     * `Object` constructor or one with a `[[Prototype]]` of `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.8.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * _.isPlainObject(new Foo);
	     * // => false
	     *
	     * _.isPlainObject([1, 2, 3]);
	     * // => false
	     *
	     * _.isPlainObject({ 'x': 0, 'y': 0 });
	     * // => true
	     *
	     * _.isPlainObject(Object.create(null));
	     * // => true
	     */
	    function isPlainObject(value) {
	      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	        return false;
	      }
	      var proto = getPrototype(value);
	      if (proto === null) {
	        return true;
	      }
	      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	        funcToString.call(Ctor) == objectCtorString;
	    }
	
	    /**
	     * Checks if `value` is classified as a `RegExp` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     * @example
	     *
	     * _.isRegExp(/abc/);
	     * // => true
	     *
	     * _.isRegExp('/abc/');
	     * // => false
	     */
	    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
	
	    /**
	     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
	     * double precision number which isn't the result of a rounded unsafe integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
	     * @example
	     *
	     * _.isSafeInteger(3);
	     * // => true
	     *
	     * _.isSafeInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isSafeInteger(Infinity);
	     * // => false
	     *
	     * _.isSafeInteger('3');
	     * // => false
	     */
	    function isSafeInteger(value) {
	      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Set` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     * @example
	     *
	     * _.isSet(new Set);
	     * // => true
	     *
	     * _.isSet(new WeakSet);
	     * // => false
	     */
	    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
	
	    /**
	     * Checks if `value` is classified as a `String` primitive or object.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
	     * @example
	     *
	     * _.isString('abc');
	     * // => true
	     *
	     * _.isString(1);
	     * // => false
	     */
	    function isString(value) {
	      return typeof value == 'string' ||
	        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Symbol` primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	     * @example
	     *
	     * _.isSymbol(Symbol.iterator);
	     * // => true
	     *
	     * _.isSymbol('abc');
	     * // => false
	     */
	    function isSymbol(value) {
	      return typeof value == 'symbol' ||
	        (isObjectLike(value) && baseGetTag(value) == symbolTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a typed array.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     * @example
	     *
	     * _.isTypedArray(new Uint8Array);
	     * // => true
	     *
	     * _.isTypedArray([]);
	     * // => false
	     */
	    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	    /**
	     * Checks if `value` is `undefined`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
	     * @example
	     *
	     * _.isUndefined(void 0);
	     * // => true
	     *
	     * _.isUndefined(null);
	     * // => false
	     */
	    function isUndefined(value) {
	      return value === undefined;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakMap` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
	     * @example
	     *
	     * _.isWeakMap(new WeakMap);
	     * // => true
	     *
	     * _.isWeakMap(new Map);
	     * // => false
	     */
	    function isWeakMap(value) {
	      return isObjectLike(value) && getTag(value) == weakMapTag;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakSet` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
	     * @example
	     *
	     * _.isWeakSet(new WeakSet);
	     * // => true
	     *
	     * _.isWeakSet(new Set);
	     * // => false
	     */
	    function isWeakSet(value) {
	      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
	    }
	
	    /**
	     * Checks if `value` is less than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     * @see _.gt
	     * @example
	     *
	     * _.lt(1, 3);
	     * // => true
	     *
	     * _.lt(3, 3);
	     * // => false
	     *
	     * _.lt(3, 1);
	     * // => false
	     */
	    var lt = createRelationalOperation(baseLt);
	
	    /**
	     * Checks if `value` is less than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than or equal to
	     *  `other`, else `false`.
	     * @see _.gte
	     * @example
	     *
	     * _.lte(1, 3);
	     * // => true
	     *
	     * _.lte(3, 3);
	     * // => true
	     *
	     * _.lte(3, 1);
	     * // => false
	     */
	    var lte = createRelationalOperation(function(value, other) {
	      return value <= other;
	    });
	
	    /**
	     * Converts `value` to an array.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the converted array.
	     * @example
	     *
	     * _.toArray({ 'a': 1, 'b': 2 });
	     * // => [1, 2]
	     *
	     * _.toArray('abc');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toArray(1);
	     * // => []
	     *
	     * _.toArray(null);
	     * // => []
	     */
	    function toArray(value) {
	      if (!value) {
	        return [];
	      }
	      if (isArrayLike(value)) {
	        return isString(value) ? stringToArray(value) : copyArray(value);
	      }
	      if (symIterator && value[symIterator]) {
	        return iteratorToArray(value[symIterator]());
	      }
	      var tag = getTag(value),
	          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);
	
	      return func(value);
	    }
	
	    /**
	     * Converts `value` to a finite number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.12.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted number.
	     * @example
	     *
	     * _.toFinite(3.2);
	     * // => 3.2
	     *
	     * _.toFinite(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toFinite(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toFinite('3.2');
	     * // => 3.2
	     */
	    function toFinite(value) {
	      if (!value) {
	        return value === 0 ? value : 0;
	      }
	      value = toNumber(value);
	      if (value === INFINITY || value === -INFINITY) {
	        var sign = (value < 0 ? -1 : 1);
	        return sign * MAX_INTEGER;
	      }
	      return value === value ? value : 0;
	    }
	
	    /**
	     * Converts `value` to an integer.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toInteger(3.2);
	     * // => 3
	     *
	     * _.toInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toInteger(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toInteger('3.2');
	     * // => 3
	     */
	    function toInteger(value) {
	      var result = toFinite(value),
	          remainder = result % 1;
	
	      return result === result ? (remainder ? result - remainder : result) : 0;
	    }
	
	    /**
	     * Converts `value` to an integer suitable for use as the length of an
	     * array-like object.
	     *
	     * **Note:** This method is based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toLength(3.2);
	     * // => 3
	     *
	     * _.toLength(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toLength(Infinity);
	     * // => 4294967295
	     *
	     * _.toLength('3.2');
	     * // => 3
	     */
	    function toLength(value) {
	      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
	    }
	
	    /**
	     * Converts `value` to a number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     * @example
	     *
	     * _.toNumber(3.2);
	     * // => 3.2
	     *
	     * _.toNumber(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toNumber(Infinity);
	     * // => Infinity
	     *
	     * _.toNumber('3.2');
	     * // => 3.2
	     */
	    function toNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      if (isObject(value)) {
	        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	        value = isObject(other) ? (other + '') : other;
	      }
	      if (typeof value != 'string') {
	        return value === 0 ? value : +value;
	      }
	      value = baseTrim(value);
	      var isBinary = reIsBinary.test(value);
	      return (isBinary || reIsOctal.test(value))
	        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	        : (reIsBadHex.test(value) ? NAN : +value);
	    }
	
	    /**
	     * Converts `value` to a plain object flattening inherited enumerable string
	     * keyed properties of `value` to own properties of the plain object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Object} Returns the converted plain object.
	     * @example
	     *
	     * function Foo() {
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.assign({ 'a': 1 }, new Foo);
	     * // => { 'a': 1, 'b': 2 }
	     *
	     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	     * // => { 'a': 1, 'b': 2, 'c': 3 }
	     */
	    function toPlainObject(value) {
	      return copyObject(value, keysIn(value));
	    }
	
	    /**
	     * Converts `value` to a safe integer. A safe integer can be compared and
	     * represented correctly.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toSafeInteger(3.2);
	     * // => 3
	     *
	     * _.toSafeInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toSafeInteger(Infinity);
	     * // => 9007199254740991
	     *
	     * _.toSafeInteger('3.2');
	     * // => 3
	     */
	    function toSafeInteger(value) {
	      return value
	        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
	        : (value === 0 ? value : 0);
	    }
	
	    /**
	     * Converts `value` to a string. An empty string is returned for `null`
	     * and `undefined` values. The sign of `-0` is preserved.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.toString(null);
	     * // => ''
	     *
	     * _.toString(-0);
	     * // => '-0'
	     *
	     * _.toString([1, 2, 3]);
	     * // => '1,2,3'
	     */
	    function toString(value) {
	      return value == null ? '' : baseToString(value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Assigns own enumerable string keyed properties of source objects to the
	     * destination object. Source objects are applied from left to right.
	     * Subsequent sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object` and is loosely based on
	     * [`Object.assign`](https://mdn.io/Object/assign).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assignIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assign({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var assign = createAssigner(function(object, source) {
	      if (isPrototype(source) || isArrayLike(source)) {
	        copyObject(source, keys(source), object);
	        return;
	      }
	      for (var key in source) {
	        if (hasOwnProperty.call(source, key)) {
	          assignValue(object, key, source[key]);
	        }
	      }
	    });
	
	    /**
	     * This method is like `_.assign` except that it iterates over own and
	     * inherited source properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extend
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assign
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
	     */
	    var assignIn = createAssigner(function(object, source) {
	      copyObject(source, keysIn(source), object);
	    });
	
	    /**
	     * This method is like `_.assignIn` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extendWith
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignInWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keysIn(source), object, customizer);
	    });
	
	    /**
	     * This method is like `_.assign` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignInWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keys(source), object, customizer);
	    });
	
	    /**
	     * Creates an array of values corresponding to `paths` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Array} Returns the picked values.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _.at(object, ['a[0].b.c', 'a[1]']);
	     * // => [3, 4]
	     */
	    var at = flatRest(baseAt);
	
	    /**
	     * Creates an object that inherits from the `prototype` object. If a
	     * `properties` object is given, its own enumerable string keyed properties
	     * are assigned to the created object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Object
	     * @param {Object} prototype The object to inherit from.
	     * @param {Object} [properties] The properties to assign to the object.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * function Shape() {
	     *   this.x = 0;
	     *   this.y = 0;
	     * }
	     *
	     * function Circle() {
	     *   Shape.call(this);
	     * }
	     *
	     * Circle.prototype = _.create(Shape.prototype, {
	     *   'constructor': Circle
	     * });
	     *
	     * var circle = new Circle;
	     * circle instanceof Circle;
	     * // => true
	     *
	     * circle instanceof Shape;
	     * // => true
	     */
	    function create(prototype, properties) {
	      var result = baseCreate(prototype);
	      return properties == null ? result : baseAssign(result, properties);
	    }
	
	    /**
	     * Assigns own and inherited enumerable string keyed properties of source
	     * objects to the destination object for all destination properties that
	     * resolve to `undefined`. Source objects are applied from left to right.
	     * Once a property is set, additional values of the same property are ignored.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaultsDeep
	     * @example
	     *
	     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var defaults = baseRest(function(object, sources) {
	      object = Object(object);
	
	      var index = -1;
	      var length = sources.length;
	      var guard = length > 2 ? sources[2] : undefined;
	
	      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	        length = 1;
	      }
	
	      while (++index < length) {
	        var source = sources[index];
	        var props = keysIn(source);
	        var propsIndex = -1;
	        var propsLength = props.length;
	
	        while (++propsIndex < propsLength) {
	          var key = props[propsIndex];
	          var value = object[key];
	
	          if (value === undefined ||
	              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	            object[key] = source[key];
	          }
	        }
	      }
	
	      return object;
	    });
	
	    /**
	     * This method is like `_.defaults` except that it recursively assigns
	     * default properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaults
	     * @example
	     *
	     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
	     * // => { 'a': { 'b': 2, 'c': 3 } }
	     */
	    var defaultsDeep = baseRest(function(args) {
	      args.push(undefined, customDefaultsMerge);
	      return apply(mergeWith, undefined, args);
	    });
	
	    /**
	     * This method is like `_.find` except that it returns the key of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findKey(users, function(o) { return o.age < 40; });
	     * // => 'barney' (iteration order is not guaranteed)
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findKey(users, { 'age': 1, 'active': true });
	     * // => 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findKey(users, 'active');
	     * // => 'barney'
	     */
	    function findKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
	    }
	
	    /**
	     * This method is like `_.findKey` except that it iterates over elements of
	     * a collection in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findLastKey(users, function(o) { return o.age < 40; });
	     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastKey(users, { 'age': 36, 'active': true });
	     * // => 'barney'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastKey(users, 'active');
	     * // => 'pebbles'
	     */
	    function findLastKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
	    }
	
	    /**
	     * Iterates over own and inherited enumerable string keyed properties of an
	     * object and invokes `iteratee` for each property. The iteratee is invoked
	     * with three arguments: (value, key, object). Iteratee functions may exit
	     * iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forInRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forIn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
	     */
	    function forIn(object, iteratee) {
	      return object == null
	        ? object
	        : baseFor(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * This method is like `_.forIn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forInRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
	     */
	    function forInRight(object, iteratee) {
	      return object == null
	        ? object
	        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * Iterates over own enumerable string keyed properties of an object and
	     * invokes `iteratee` for each property. The iteratee is invoked with three
	     * arguments: (value, key, object). Iteratee functions may exit iteration
	     * early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwnRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forOwn(object, iteratee) {
	      return object && baseForOwn(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forOwn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwnRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
	     */
	    function forOwnRight(object, iteratee) {
	      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an array of function property names from own enumerable properties
	     * of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functionsIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functions(new Foo);
	     * // => ['a', 'b']
	     */
	    function functions(object) {
	      return object == null ? [] : baseFunctions(object, keys(object));
	    }
	
	    /**
	     * Creates an array of function property names from own and inherited
	     * enumerable properties of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functions
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functionsIn(new Foo);
	     * // => ['a', 'b', 'c']
	     */
	    function functionsIn(object) {
	      return object == null ? [] : baseFunctions(object, keysIn(object));
	    }
	
	    /**
	     * Gets the value at `path` of `object`. If the resolved value is
	     * `undefined`, the `defaultValue` is returned in its place.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.get(object, 'a[0].b.c');
	     * // => 3
	     *
	     * _.get(object, ['a', '0', 'b', 'c']);
	     * // => 3
	     *
	     * _.get(object, 'a.b.c', 'default');
	     * // => 'default'
	     */
	    function get(object, path, defaultValue) {
	      var result = object == null ? undefined : baseGet(object, path);
	      return result === undefined ? defaultValue : result;
	    }
	
	    /**
	     * Checks if `path` is a direct property of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = { 'a': { 'b': 2 } };
	     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.has(object, 'a');
	     * // => true
	     *
	     * _.has(object, 'a.b');
	     * // => true
	     *
	     * _.has(object, ['a', 'b']);
	     * // => true
	     *
	     * _.has(other, 'a');
	     * // => false
	     */
	    function has(object, path) {
	      return object != null && hasPath(object, path, baseHas);
	    }
	
	    /**
	     * Checks if `path` is a direct or inherited property of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.hasIn(object, 'a');
	     * // => true
	     *
	     * _.hasIn(object, 'a.b');
	     * // => true
	     *
	     * _.hasIn(object, ['a', 'b']);
	     * // => true
	     *
	     * _.hasIn(object, 'b');
	     * // => false
	     */
	    function hasIn(object, path) {
	      return object != null && hasPath(object, path, baseHasIn);
	    }
	
	    /**
	     * Creates an object composed of the inverted keys and values of `object`.
	     * If `object` contains duplicate values, subsequent values overwrite
	     * property assignments of previous values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invert(object);
	     * // => { '1': 'c', '2': 'b' }
	     */
	    var invert = createInverter(function(result, value, key) {
	      if (value != null &&
	          typeof value.toString != 'function') {
	        value = nativeObjectToString.call(value);
	      }
	
	      result[value] = key;
	    }, constant(identity));
	
	    /**
	     * This method is like `_.invert` except that the inverted object is generated
	     * from the results of running each element of `object` thru `iteratee`. The
	     * corresponding inverted value of each inverted key is an array of keys
	     * responsible for generating the inverted value. The iteratee is invoked
	     * with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invertBy(object);
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     *
	     * _.invertBy(object, function(value) {
	     *   return 'group' + value;
	     * });
	     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
	     */
	    var invertBy = createInverter(function(result, value, key) {
	      if (value != null &&
	          typeof value.toString != 'function') {
	        value = nativeObjectToString.call(value);
	      }
	
	      if (hasOwnProperty.call(result, value)) {
	        result[value].push(key);
	      } else {
	        result[value] = [key];
	      }
	    }, getIteratee);
	
	    /**
	     * Invokes the method at `path` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
	     *
	     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
	     * // => [2, 3]
	     */
	    var invoke = baseRest(baseInvoke);
	
	    /**
	     * Creates an array of the own enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects. See the
	     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * for more details.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keys(new Foo);
	     * // => ['a', 'b'] (iteration order is not guaranteed)
	     *
	     * _.keys('hi');
	     * // => ['0', '1']
	     */
	    function keys(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keysIn(new Foo);
	     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	     */
	    function keysIn(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	    }
	
	    /**
	     * The opposite of `_.mapValues`; this method creates an object with the
	     * same values as `object` and keys generated by running each own enumerable
	     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
	     * with three arguments: (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapValues
	     * @example
	     *
	     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   return key + value;
	     * });
	     * // => { 'a1': 1, 'b2': 2 }
	     */
	    function mapKeys(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, iteratee(value, key, object), value);
	      });
	      return result;
	    }
	
	    /**
	     * Creates an object with the same keys as `object` and values generated
	     * by running each own enumerable string keyed property of `object` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapKeys
	     * @example
	     *
	     * var users = {
	     *   'fred':    { 'user': 'fred',    'age': 40 },
	     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	     * };
	     *
	     * _.mapValues(users, function(o) { return o.age; });
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.mapValues(users, 'age');
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     */
	    function mapValues(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, key, iteratee(value, key, object));
	      });
	      return result;
	    }
	
	    /**
	     * This method is like `_.assign` except that it recursively merges own and
	     * inherited enumerable string keyed properties of source objects into the
	     * destination object. Source properties that resolve to `undefined` are
	     * skipped if a destination value exists. Array and plain object properties
	     * are merged recursively. Other objects and value types are overridden by
	     * assignment. Source objects are applied from left to right. Subsequent
	     * sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {
	     *   'a': [{ 'b': 2 }, { 'd': 4 }]
	     * };
	     *
	     * var other = {
	     *   'a': [{ 'c': 3 }, { 'e': 5 }]
	     * };
	     *
	     * _.merge(object, other);
	     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
	     */
	    var merge = createAssigner(function(object, source, srcIndex) {
	      baseMerge(object, source, srcIndex);
	    });
	
	    /**
	     * This method is like `_.merge` except that it accepts `customizer` which
	     * is invoked to produce the merged values of the destination and source
	     * properties. If `customizer` returns `undefined`, merging is handled by the
	     * method instead. The `customizer` is invoked with six arguments:
	     * (objValue, srcValue, key, object, source, stack).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} customizer The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (_.isArray(objValue)) {
	     *     return objValue.concat(srcValue);
	     *   }
	     * }
	     *
	     * var object = { 'a': [1], 'b': [2] };
	     * var other = { 'a': [3], 'b': [4] };
	     *
	     * _.mergeWith(object, other, customizer);
	     * // => { 'a': [1, 3], 'b': [2, 4] }
	     */
	    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
	      baseMerge(object, source, srcIndex, customizer);
	    });
	
	    /**
	     * The opposite of `_.pick`; this method creates an object composed of the
	     * own and inherited enumerable property paths of `object` that are not omitted.
	     *
	     * **Note:** This method is considerably slower than `_.pick`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to omit.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omit(object, ['a', 'c']);
	     * // => { 'b': '2' }
	     */
	    var omit = flatRest(function(object, paths) {
	      var result = {};
	      if (object == null) {
	        return result;
	      }
	      var isDeep = false;
	      paths = arrayMap(paths, function(path) {
	        path = castPath(path, object);
	        isDeep || (isDeep = path.length > 1);
	        return path;
	      });
	      copyObject(object, getAllKeysIn(object), result);
	      if (isDeep) {
	        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
	      }
	      var length = paths.length;
	      while (length--) {
	        baseUnset(result, paths[length]);
	      }
	      return result;
	    });
	
	    /**
	     * The opposite of `_.pickBy`; this method creates an object composed of
	     * the own and inherited enumerable string keyed properties of `object` that
	     * `predicate` doesn't return truthy for. The predicate is invoked with two
	     * arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omitBy(object, _.isNumber);
	     * // => { 'b': '2' }
	     */
	    function omitBy(object, predicate) {
	      return pickBy(object, negate(getIteratee(predicate)));
	    }
	
	    /**
	     * Creates an object composed of the picked `object` properties.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pick(object, ['a', 'c']);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var pick = flatRest(function(object, paths) {
	      return object == null ? {} : basePick(object, paths);
	    });
	
	    /**
	     * Creates an object composed of the `object` properties `predicate` returns
	     * truthy for. The predicate is invoked with two arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pickBy(object, _.isNumber);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    function pickBy(object, predicate) {
	      if (object == null) {
	        return {};
	      }
	      var props = arrayMap(getAllKeysIn(object), function(prop) {
	        return [prop];
	      });
	      predicate = getIteratee(predicate);
	      return basePickBy(object, props, function(value, path) {
	        return predicate(value, path[0]);
	      });
	    }
	
	    /**
	     * This method is like `_.get` except that if the resolved value is a
	     * function it's invoked with the `this` binding of its parent object and
	     * its result is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to resolve.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
	     *
	     * _.result(object, 'a[0].b.c1');
	     * // => 3
	     *
	     * _.result(object, 'a[0].b.c2');
	     * // => 4
	     *
	     * _.result(object, 'a[0].b.c3', 'default');
	     * // => 'default'
	     *
	     * _.result(object, 'a[0].b.c3', _.constant('default'));
	     * // => 'default'
	     */
	    function result(object, path, defaultValue) {
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length;
	
	      // Ensure the loop is entered when path is empty.
	      if (!length) {
	        length = 1;
	        object = undefined;
	      }
	      while (++index < length) {
	        var value = object == null ? undefined : object[toKey(path[index])];
	        if (value === undefined) {
	          index = length;
	          value = defaultValue;
	        }
	        object = isFunction(value) ? value.call(object) : value;
	      }
	      return object;
	    }
	
	    /**
	     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
	     * it's created. Arrays are created for missing index properties while objects
	     * are created for all other missing properties. Use `_.setWith` to customize
	     * `path` creation.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.set(object, 'a[0].b.c', 4);
	     * console.log(object.a[0].b.c);
	     * // => 4
	     *
	     * _.set(object, ['x', '0', 'y', 'z'], 5);
	     * console.log(object.x[0].y.z);
	     * // => 5
	     */
	    function set(object, path, value) {
	      return object == null ? object : baseSet(object, path, value);
	    }
	
	    /**
	     * This method is like `_.set` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.setWith(object, '[0][1]', 'a', Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function setWith(object, path, value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseSet(object, path, value, customizer);
	    }
	
	    /**
	     * Creates an array of own enumerable string keyed-value pairs for `object`
	     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
	     * entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entries
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairs(new Foo);
	     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
	     */
	    var toPairs = createToPairs(keys);
	
	    /**
	     * Creates an array of own and inherited enumerable string keyed-value pairs
	     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
	     * or set, its entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entriesIn
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairsIn(new Foo);
	     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
	     */
	    var toPairsIn = createToPairs(keysIn);
	
	    /**
	     * An alternative to `_.reduce`; this method transforms `object` to a new
	     * `accumulator` object which is the result of running each of its own
	     * enumerable string keyed properties thru `iteratee`, with each invocation
	     * potentially mutating the `accumulator` object. If `accumulator` is not
	     * provided, a new object with the same `[[Prototype]]` will be used. The
	     * iteratee is invoked with four arguments: (accumulator, value, key, object).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The custom accumulator value.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * _.transform([2, 3, 4], function(result, n) {
	     *   result.push(n *= n);
	     *   return n % 2 == 0;
	     * }, []);
	     * // => [4, 9]
	     *
	     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     */
	    function transform(object, iteratee, accumulator) {
	      var isArr = isArray(object),
	          isArrLike = isArr || isBuffer(object) || isTypedArray(object);
	
	      iteratee = getIteratee(iteratee, 4);
	      if (accumulator == null) {
	        var Ctor = object && object.constructor;
	        if (isArrLike) {
	          accumulator = isArr ? new Ctor : [];
	        }
	        else if (isObject(object)) {
	          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
	        }
	        else {
	          accumulator = {};
	        }
	      }
	      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
	        return iteratee(accumulator, value, index, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * Removes the property at `path` of `object`.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
	     * _.unset(object, 'a[0].b.c');
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     *
	     * _.unset(object, ['a', '0', 'b', 'c']);
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     */
	    function unset(object, path) {
	      return object == null ? true : baseUnset(object, path);
	    }
	
	    /**
	     * This method is like `_.set` except that accepts `updater` to produce the
	     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
	     * is invoked with one argument: (value).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
	     * console.log(object.a[0].b.c);
	     * // => 9
	     *
	     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
	     * console.log(object.x[0].y.z);
	     * // => 0
	     */
	    function update(object, path, updater) {
	      return object == null ? object : baseUpdate(object, path, castFunction(updater));
	    }
	
	    /**
	     * This method is like `_.update` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function updateWith(object, path, updater, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
	    }
	
	    /**
	     * Creates an array of the own enumerable string keyed property values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.values(new Foo);
	     * // => [1, 2] (iteration order is not guaranteed)
	     *
	     * _.values('hi');
	     * // => ['h', 'i']
	     */
	    function values(object) {
	      return object == null ? [] : baseValues(object, keys(object));
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable string keyed property
	     * values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.valuesIn(new Foo);
	     * // => [1, 2, 3] (iteration order is not guaranteed)
	     */
	    function valuesIn(object) {
	      return object == null ? [] : baseValues(object, keysIn(object));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Clamps `number` within the inclusive `lower` and `upper` bounds.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Number
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     * @example
	     *
	     * _.clamp(-10, -5, 5);
	     * // => -5
	     *
	     * _.clamp(10, -5, 5);
	     * // => 5
	     */
	    function clamp(number, lower, upper) {
	      if (upper === undefined) {
	        upper = lower;
	        lower = undefined;
	      }
	      if (upper !== undefined) {
	        upper = toNumber(upper);
	        upper = upper === upper ? upper : 0;
	      }
	      if (lower !== undefined) {
	        lower = toNumber(lower);
	        lower = lower === lower ? lower : 0;
	      }
	      return baseClamp(toNumber(number), lower, upper);
	    }
	
	    /**
	     * Checks if `n` is between `start` and up to, but not including, `end`. If
	     * `end` is not specified, it's set to `start` with `start` then set to `0`.
	     * If `start` is greater than `end` the params are swapped to support
	     * negative ranges.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.3.0
	     * @category Number
	     * @param {number} number The number to check.
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     * @see _.range, _.rangeRight
	     * @example
	     *
	     * _.inRange(3, 2, 4);
	     * // => true
	     *
	     * _.inRange(4, 8);
	     * // => true
	     *
	     * _.inRange(4, 2);
	     * // => false
	     *
	     * _.inRange(2, 2);
	     * // => false
	     *
	     * _.inRange(1.2, 2);
	     * // => true
	     *
	     * _.inRange(5.2, 4);
	     * // => false
	     *
	     * _.inRange(-3, -2, -6);
	     * // => true
	     */
	    function inRange(number, start, end) {
	      start = toFinite(start);
	      if (end === undefined) {
	        end = start;
	        start = 0;
	      } else {
	        end = toFinite(end);
	      }
	      number = toNumber(number);
	      return baseInRange(number, start, end);
	    }
	
	    /**
	     * Produces a random number between the inclusive `lower` and `upper` bounds.
	     * If only one argument is provided a number between `0` and the given number
	     * is returned. If `floating` is `true`, or either `lower` or `upper` are
	     * floats, a floating-point number is returned instead of an integer.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Number
	     * @param {number} [lower=0] The lower bound.
	     * @param {number} [upper=1] The upper bound.
	     * @param {boolean} [floating] Specify returning a floating-point number.
	     * @returns {number} Returns the random number.
	     * @example
	     *
	     * _.random(0, 5);
	     * // => an integer between 0 and 5
	     *
	     * _.random(5);
	     * // => also an integer between 0 and 5
	     *
	     * _.random(5, true);
	     * // => a floating-point number between 0 and 5
	     *
	     * _.random(1.2, 5.2);
	     * // => a floating-point number between 1.2 and 5.2
	     */
	    function random(lower, upper, floating) {
	      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
	        upper = floating = undefined;
	      }
	      if (floating === undefined) {
	        if (typeof upper == 'boolean') {
	          floating = upper;
	          upper = undefined;
	        }
	        else if (typeof lower == 'boolean') {
	          floating = lower;
	          lower = undefined;
	        }
	      }
	      if (lower === undefined && upper === undefined) {
	        lower = 0;
	        upper = 1;
	      }
	      else {
	        lower = toFinite(lower);
	        if (upper === undefined) {
	          upper = lower;
	          lower = 0;
	        } else {
	          upper = toFinite(upper);
	        }
	      }
	      if (lower > upper) {
	        var temp = lower;
	        lower = upper;
	        upper = temp;
	      }
	      if (floating || lower % 1 || upper % 1) {
	        var rand = nativeRandom();
	        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
	      }
	      return baseRandom(lower, upper);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the camel cased string.
	     * @example
	     *
	     * _.camelCase('Foo Bar');
	     * // => 'fooBar'
	     *
	     * _.camelCase('--foo-bar--');
	     * // => 'fooBar'
	     *
	     * _.camelCase('__FOO_BAR__');
	     * // => 'fooBar'
	     */
	    var camelCase = createCompounder(function(result, word, index) {
	      word = word.toLowerCase();
	      return result + (index ? capitalize(word) : word);
	    });
	
	    /**
	     * Converts the first character of `string` to upper case and the remaining
	     * to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to capitalize.
	     * @returns {string} Returns the capitalized string.
	     * @example
	     *
	     * _.capitalize('FRED');
	     * // => 'Fred'
	     */
	    function capitalize(string) {
	      return upperFirst(toString(string).toLowerCase());
	    }
	
	    /**
	     * Deburrs `string` by converting
	     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
	     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
	     * letters to basic Latin letters and removing
	     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to deburr.
	     * @returns {string} Returns the deburred string.
	     * @example
	     *
	     * _.deburr('déjà vu');
	     * // => 'deja vu'
	     */
	    function deburr(string) {
	      string = toString(string);
	      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
	    }
	
	    /**
	     * Checks if `string` ends with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=string.length] The position to search up to.
	     * @returns {boolean} Returns `true` if `string` ends with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.endsWith('abc', 'c');
	     * // => true
	     *
	     * _.endsWith('abc', 'b');
	     * // => false
	     *
	     * _.endsWith('abc', 'b', 2);
	     * // => true
	     */
	    function endsWith(string, target, position) {
	      string = toString(string);
	      target = baseToString(target);
	
	      var length = string.length;
	      position = position === undefined
	        ? length
	        : baseClamp(toInteger(position), 0, length);
	
	      var end = position;
	      position -= target.length;
	      return position >= 0 && string.slice(position, end) == target;
	    }
	
	    /**
	     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
	     * corresponding HTML entities.
	     *
	     * **Note:** No other characters are escaped. To escape additional
	     * characters use a third-party library like [_he_](https://mths.be/he).
	     *
	     * Though the ">" character is escaped for symmetry, characters like
	     * ">" and "/" don't need escaping in HTML and have no special meaning
	     * unless they're part of a tag or unquoted attribute value. See
	     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
	     * (under "semi-related fun fact") for more details.
	     *
	     * When working with HTML you should always
	     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
	     * XSS vectors.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escape('fred, barney, & pebbles');
	     * // => 'fred, barney, &amp; pebbles'
	     */
	    function escape(string) {
	      string = toString(string);
	      return (string && reHasUnescapedHtml.test(string))
	        ? string.replace(reUnescapedHtml, escapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
	     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escapeRegExp('[lodash](https://lodash.com/)');
	     * // => '\[lodash\]\(https://lodash\.com/\)'
	     */
	    function escapeRegExp(string) {
	      string = toString(string);
	      return (string && reHasRegExpChar.test(string))
	        ? string.replace(reRegExpChar, '\\$&')
	        : string;
	    }
	
	    /**
	     * Converts `string` to
	     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the kebab cased string.
	     * @example
	     *
	     * _.kebabCase('Foo Bar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('fooBar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('__FOO_BAR__');
	     * // => 'foo-bar'
	     */
	    var kebabCase = createCompounder(function(result, word, index) {
	      return result + (index ? '-' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts `string`, as space separated words, to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.lowerCase('--Foo-Bar--');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('fooBar');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('__FOO_BAR__');
	     * // => 'foo bar'
	     */
	    var lowerCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts the first character of `string` to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.lowerFirst('Fred');
	     * // => 'fred'
	     *
	     * _.lowerFirst('FRED');
	     * // => 'fRED'
	     */
	    var lowerFirst = createCaseFirst('toLowerCase');
	
	    /**
	     * Pads `string` on the left and right sides if it's shorter than `length`.
	     * Padding characters are truncated if they can't be evenly divided by `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.pad('abc', 8);
	     * // => '  abc   '
	     *
	     * _.pad('abc', 8, '_-');
	     * // => '_-abc_-_'
	     *
	     * _.pad('abc', 3);
	     * // => 'abc'
	     */
	    function pad(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      if (!length || strLength >= length) {
	        return string;
	      }
	      var mid = (length - strLength) / 2;
	      return (
	        createPadding(nativeFloor(mid), chars) +
	        string +
	        createPadding(nativeCeil(mid), chars)
	      );
	    }
	
	    /**
	     * Pads `string` on the right side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padEnd('abc', 6);
	     * // => 'abc   '
	     *
	     * _.padEnd('abc', 6, '_-');
	     * // => 'abc_-_'
	     *
	     * _.padEnd('abc', 3);
	     * // => 'abc'
	     */
	    function padEnd(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (string + createPadding(length - strLength, chars))
	        : string;
	    }
	
	    /**
	     * Pads `string` on the left side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padStart('abc', 6);
	     * // => '   abc'
	     *
	     * _.padStart('abc', 6, '_-');
	     * // => '_-_abc'
	     *
	     * _.padStart('abc', 3);
	     * // => 'abc'
	     */
	    function padStart(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (createPadding(length - strLength, chars) + string)
	        : string;
	    }
	
	    /**
	     * Converts `string` to an integer of the specified radix. If `radix` is
	     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
	     * hexadecimal, in which case a `radix` of `16` is used.
	     *
	     * **Note:** This method aligns with the
	     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category String
	     * @param {string} string The string to convert.
	     * @param {number} [radix=10] The radix to interpret `value` by.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.parseInt('08');
	     * // => 8
	     *
	     * _.map(['6', '08', '10'], _.parseInt);
	     * // => [6, 8, 10]
	     */
	    function parseInt(string, radix, guard) {
	      if (guard || radix == null) {
	        radix = 0;
	      } else if (radix) {
	        radix = +radix;
	      }
	      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
	    }
	
	    /**
	     * Repeats the given string `n` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to repeat.
	     * @param {number} [n=1] The number of times to repeat the string.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the repeated string.
	     * @example
	     *
	     * _.repeat('*', 3);
	     * // => '***'
	     *
	     * _.repeat('abc', 2);
	     * // => 'abcabc'
	     *
	     * _.repeat('abc', 0);
	     * // => ''
	     */
	    function repeat(string, n, guard) {
	      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      return baseRepeat(toString(string), n);
	    }
	
	    /**
	     * Replaces matches for `pattern` in `string` with `replacement`.
	     *
	     * **Note:** This method is based on
	     * [`String#replace`](https://mdn.io/String/replace).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to modify.
	     * @param {RegExp|string} pattern The pattern to replace.
	     * @param {Function|string} replacement The match replacement.
	     * @returns {string} Returns the modified string.
	     * @example
	     *
	     * _.replace('Hi Fred', 'Fred', 'Barney');
	     * // => 'Hi Barney'
	     */
	    function replace() {
	      var args = arguments,
	          string = toString(args[0]);
	
	      return args.length < 3 ? string : string.replace(args[1], args[2]);
	    }
	
	    /**
	     * Converts `string` to
	     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the snake cased string.
	     * @example
	     *
	     * _.snakeCase('Foo Bar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('fooBar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('--FOO-BAR--');
	     * // => 'foo_bar'
	     */
	    var snakeCase = createCompounder(function(result, word, index) {
	      return result + (index ? '_' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Splits `string` by `separator`.
	     *
	     * **Note:** This method is based on
	     * [`String#split`](https://mdn.io/String/split).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to split.
	     * @param {RegExp|string} separator The separator pattern to split by.
	     * @param {number} [limit] The length to truncate results to.
	     * @returns {Array} Returns the string segments.
	     * @example
	     *
	     * _.split('a-b-c', '-', 2);
	     * // => ['a', 'b']
	     */
	    function split(string, separator, limit) {
	      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
	        separator = limit = undefined;
	      }
	      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
	      if (!limit) {
	        return [];
	      }
	      string = toString(string);
	      if (string && (
	            typeof separator == 'string' ||
	            (separator != null && !isRegExp(separator))
	          )) {
	        separator = baseToString(separator);
	        if (!separator && hasUnicode(string)) {
	          return castSlice(stringToArray(string), 0, limit);
	        }
	      }
	      return string.split(separator, limit);
	    }
	
	    /**
	     * Converts `string` to
	     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.1.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the start cased string.
	     * @example
	     *
	     * _.startCase('--foo-bar--');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('fooBar');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('__FOO_BAR__');
	     * // => 'FOO BAR'
	     */
	    var startCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + upperFirst(word);
	    });
	
	    /**
	     * Checks if `string` starts with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=0] The position to search from.
	     * @returns {boolean} Returns `true` if `string` starts with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.startsWith('abc', 'a');
	     * // => true
	     *
	     * _.startsWith('abc', 'b');
	     * // => false
	     *
	     * _.startsWith('abc', 'b', 1);
	     * // => true
	     */
	    function startsWith(string, target, position) {
	      string = toString(string);
	      position = position == null
	        ? 0
	        : baseClamp(toInteger(position), 0, string.length);
	
	      target = baseToString(target);
	      return string.slice(position, position + target.length) == target;
	    }
	
	    /**
	     * Creates a compiled template function that can interpolate data properties
	     * in "interpolate" delimiters, HTML-escape interpolated data properties in
	     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
	     * properties may be accessed as free variables in the template. If a setting
	     * object is given, it takes precedence over `_.templateSettings` values.
	     *
	     * **Note:** In the development build `_.template` utilizes
	     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
	     * for easier debugging.
	     *
	     * For more information on precompiling templates see
	     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
	     *
	     * For more information on Chrome extension sandboxes see
	     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The template string.
	     * @param {Object} [options={}] The options object.
	     * @param {RegExp} [options.escape=_.templateSettings.escape]
	     *  The HTML "escape" delimiter.
	     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
	     *  The "evaluate" delimiter.
	     * @param {Object} [options.imports=_.templateSettings.imports]
	     *  An object to import into the template as free variables.
	     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
	     *  The "interpolate" delimiter.
	     * @param {string} [options.sourceURL='lodash.templateSources[n]']
	     *  The sourceURL of the compiled template.
	     * @param {string} [options.variable='obj']
	     *  The data object variable name.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the compiled template function.
	     * @example
	     *
	     * // Use the "interpolate" delimiter to create a compiled template.
	     * var compiled = _.template('hello <%= user %>!');
	     * compiled({ 'user': 'fred' });
	     * // => 'hello fred!'
	     *
	     * // Use the HTML "escape" delimiter to escape data property values.
	     * var compiled = _.template('<b><%- value %></b>');
	     * compiled({ 'value': '<script>' });
	     * // => '<b>&lt;script&gt;</b>'
	     *
	     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
	     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the internal `print` function in "evaluate" delimiters.
	     * var compiled = _.template('<% print("hello " + user); %>!');
	     * compiled({ 'user': 'barney' });
	     * // => 'hello barney!'
	     *
	     * // Use the ES template literal delimiter as an "interpolate" delimiter.
	     * // Disable support by replacing the "interpolate" delimiter.
	     * var compiled = _.template('hello ${ user }!');
	     * compiled({ 'user': 'pebbles' });
	     * // => 'hello pebbles!'
	     *
	     * // Use backslashes to treat delimiters as plain text.
	     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
	     * compiled({ 'value': 'ignored' });
	     * // => '<%- value %>'
	     *
	     * // Use the `imports` option to import `jQuery` as `jq`.
	     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
	     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
	     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
	     * compiled(data);
	     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
	     *
	     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
	     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
	     * compiled.source;
	     * // => function(data) {
	     * //   var __t, __p = '';
	     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
	     * //   return __p;
	     * // }
	     *
	     * // Use custom template delimiters.
	     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
	     * var compiled = _.template('hello {{ user }}!');
	     * compiled({ 'user': 'mustache' });
	     * // => 'hello mustache!'
	     *
	     * // Use the `source` property to inline compiled templates for meaningful
	     * // line numbers in error messages and stack traces.
	     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
	     *   var JST = {\
	     *     "main": ' + _.template(mainText).source + '\
	     *   };\
	     * ');
	     */
	    function template(string, options, guard) {
	      // Based on John Resig's `tmpl` implementation
	      // (http://ejohn.org/blog/javascript-micro-templating/)
	      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
	      var settings = lodash.templateSettings;
	
	      if (guard && isIterateeCall(string, options, guard)) {
	        options = undefined;
	      }
	      string = toString(string);
	      options = assignInWith({}, options, settings, customDefaultsAssignIn);
	
	      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
	          importsKeys = keys(imports),
	          importsValues = baseValues(imports, importsKeys);
	
	      var isEscaping,
	          isEvaluating,
	          index = 0,
	          interpolate = options.interpolate || reNoMatch,
	          source = "__p += '";
	
	      // Compile the regexp to match each delimiter.
	      var reDelimiters = RegExp(
	        (options.escape || reNoMatch).source + '|' +
	        interpolate.source + '|' +
	        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
	        (options.evaluate || reNoMatch).source + '|$'
	      , 'g');
	
	      // Use a sourceURL for easier debugging.
	      // The sourceURL gets injected into the source that's eval-ed, so be careful
	      // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
	      // and escape the comment, thus injecting code that gets evaled.
	      var sourceURL = '//# sourceURL=' +
	        (hasOwnProperty.call(options, 'sourceURL')
	          ? (options.sourceURL + '').replace(/\s/g, ' ')
	          : ('lodash.templateSources[' + (++templateCounter) + ']')
	        ) + '\n';
	
	      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
	        interpolateValue || (interpolateValue = esTemplateValue);
	
	        // Escape characters that can't be included in string literals.
	        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
	
	        // Replace delimiters with snippets.
	        if (escapeValue) {
	          isEscaping = true;
	          source += "' +\n__e(" + escapeValue + ") +\n'";
	        }
	        if (evaluateValue) {
	          isEvaluating = true;
	          source += "';\n" + evaluateValue + ";\n__p += '";
	        }
	        if (interpolateValue) {
	          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
	        }
	        index = offset + match.length;
	
	        // The JS engine embedded in Adobe products needs `match` returned in
	        // order to produce the correct `offset` value.
	        return match;
	      });
	
	      source += "';\n";
	
	      // If `variable` is not specified wrap a with-statement around the generated
	      // code to add the data object to the top of the scope chain.
	      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
	      if (!variable) {
	        source = 'with (obj) {\n' + source + '\n}\n';
	      }
	      // Throw an error if a forbidden character was found in `variable`, to prevent
	      // potential command injection attacks.
	      else if (reForbiddenIdentifierChars.test(variable)) {
	        throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
	      }
	
	      // Cleanup code by stripping empty strings.
	      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
	        .replace(reEmptyStringMiddle, '$1')
	        .replace(reEmptyStringTrailing, '$1;');
	
	      // Frame code as the function body.
	      source = 'function(' + (variable || 'obj') + ') {\n' +
	        (variable
	          ? ''
	          : 'obj || (obj = {});\n'
	        ) +
	        "var __t, __p = ''" +
	        (isEscaping
	           ? ', __e = _.escape'
	           : ''
	        ) +
	        (isEvaluating
	          ? ', __j = Array.prototype.join;\n' +
	            "function print() { __p += __j.call(arguments, '') }\n"
	          : ';\n'
	        ) +
	        source +
	        'return __p\n}';
	
	      var result = attempt(function() {
	        return Function(importsKeys, sourceURL + 'return ' + source)
	          .apply(undefined, importsValues);
	      });
	
	      // Provide the compiled function's source by its `toString` method or
	      // the `source` property as a convenience for inlining compiled templates.
	      result.source = source;
	      if (isError(result)) {
	        throw result;
	      }
	      return result;
	    }
	
	    /**
	     * Converts `string`, as a whole, to lower case just like
	     * [String#toLowerCase](https://mdn.io/toLowerCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.toLower('--Foo-Bar--');
	     * // => '--foo-bar--'
	     *
	     * _.toLower('fooBar');
	     * // => 'foobar'
	     *
	     * _.toLower('__FOO_BAR__');
	     * // => '__foo_bar__'
	     */
	    function toLower(value) {
	      return toString(value).toLowerCase();
	    }
	
	    /**
	     * Converts `string`, as a whole, to upper case just like
	     * [String#toUpperCase](https://mdn.io/toUpperCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.toUpper('--foo-bar--');
	     * // => '--FOO-BAR--'
	     *
	     * _.toUpper('fooBar');
	     * // => 'FOOBAR'
	     *
	     * _.toUpper('__foo_bar__');
	     * // => '__FOO_BAR__'
	     */
	    function toUpper(value) {
	      return toString(value).toUpperCase();
	    }
	
	    /**
	     * Removes leading and trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trim('  abc  ');
	     * // => 'abc'
	     *
	     * _.trim('-_-abc-_-', '_-');
	     * // => 'abc'
	     *
	     * _.map(['  foo  ', '  bar  '], _.trim);
	     * // => ['foo', 'bar']
	     */
	    function trim(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return baseTrim(string);
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          chrSymbols = stringToArray(chars),
	          start = charsStartIndex(strSymbols, chrSymbols),
	          end = charsEndIndex(strSymbols, chrSymbols) + 1;
	
	      return castSlice(strSymbols, start, end).join('');
	    }
	
	    /**
	     * Removes trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimEnd('  abc  ');
	     * // => '  abc'
	     *
	     * _.trimEnd('-_-abc-_-', '_-');
	     * // => '-_-abc'
	     */
	    function trimEnd(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.slice(0, trimmedEndIndex(string) + 1);
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
	
	      return castSlice(strSymbols, 0, end).join('');
	    }
	
	    /**
	     * Removes leading whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimStart('  abc  ');
	     * // => 'abc  '
	     *
	     * _.trimStart('-_-abc-_-', '_-');
	     * // => 'abc-_-'
	     */
	    function trimStart(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrimStart, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          start = charsStartIndex(strSymbols, stringToArray(chars));
	
	      return castSlice(strSymbols, start).join('');
	    }
	
	    /**
	     * Truncates `string` if it's longer than the given maximum string length.
	     * The last characters of the truncated string are replaced with the omission
	     * string which defaults to "...".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to truncate.
	     * @param {Object} [options={}] The options object.
	     * @param {number} [options.length=30] The maximum string length.
	     * @param {string} [options.omission='...'] The string to indicate text is omitted.
	     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
	     * @returns {string} Returns the truncated string.
	     * @example
	     *
	     * _.truncate('hi-diddly-ho there, neighborino');
	     * // => 'hi-diddly-ho there, neighbo...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': ' '
	     * });
	     * // => 'hi-diddly-ho there,...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': /,? +/
	     * });
	     * // => 'hi-diddly-ho there...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'omission': ' [...]'
	     * });
	     * // => 'hi-diddly-ho there, neig [...]'
	     */
	    function truncate(string, options) {
	      var length = DEFAULT_TRUNC_LENGTH,
	          omission = DEFAULT_TRUNC_OMISSION;
	
	      if (isObject(options)) {
	        var separator = 'separator' in options ? options.separator : separator;
	        length = 'length' in options ? toInteger(options.length) : length;
	        omission = 'omission' in options ? baseToString(options.omission) : omission;
	      }
	      string = toString(string);
	
	      var strLength = string.length;
	      if (hasUnicode(string)) {
	        var strSymbols = stringToArray(string);
	        strLength = strSymbols.length;
	      }
	      if (length >= strLength) {
	        return string;
	      }
	      var end = length - stringSize(omission);
	      if (end < 1) {
	        return omission;
	      }
	      var result = strSymbols
	        ? castSlice(strSymbols, 0, end).join('')
	        : string.slice(0, end);
	
	      if (separator === undefined) {
	        return result + omission;
	      }
	      if (strSymbols) {
	        end += (result.length - end);
	      }
	      if (isRegExp(separator)) {
	        if (string.slice(end).search(separator)) {
	          var match,
	              substring = result;
	
	          if (!separator.global) {
	            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
	          }
	          separator.lastIndex = 0;
	          while ((match = separator.exec(substring))) {
	            var newEnd = match.index;
	          }
	          result = result.slice(0, newEnd === undefined ? end : newEnd);
	        }
	      } else if (string.indexOf(baseToString(separator), end) != end) {
	        var index = result.lastIndexOf(separator);
	        if (index > -1) {
	          result = result.slice(0, index);
	        }
	      }
	      return result + omission;
	    }
	
	    /**
	     * The inverse of `_.escape`; this method converts the HTML entities
	     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
	     * their corresponding characters.
	     *
	     * **Note:** No other HTML entities are unescaped. To unescape additional
	     * HTML entities use a third-party library like [_he_](https://mths.be/he).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.6.0
	     * @category String
	     * @param {string} [string=''] The string to unescape.
	     * @returns {string} Returns the unescaped string.
	     * @example
	     *
	     * _.unescape('fred, barney, &amp; pebbles');
	     * // => 'fred, barney, & pebbles'
	     */
	    function unescape(string) {
	      string = toString(string);
	      return (string && reHasEscapedHtml.test(string))
	        ? string.replace(reEscapedHtml, unescapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Converts `string`, as space separated words, to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.upperCase('--foo-bar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('fooBar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('__foo_bar__');
	     * // => 'FOO BAR'
	     */
	    var upperCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toUpperCase();
	    });
	
	    /**
	     * Converts the first character of `string` to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.upperFirst('fred');
	     * // => 'Fred'
	     *
	     * _.upperFirst('FRED');
	     * // => 'FRED'
	     */
	    var upperFirst = createCaseFirst('toUpperCase');
	
	    /**
	     * Splits `string` into an array of its words.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {RegExp|string} [pattern] The pattern to match words.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the words of `string`.
	     * @example
	     *
	     * _.words('fred, barney, & pebbles');
	     * // => ['fred', 'barney', 'pebbles']
	     *
	     * _.words('fred, barney, & pebbles', /[^, ]+/g);
	     * // => ['fred', 'barney', '&', 'pebbles']
	     */
	    function words(string, pattern, guard) {
	      string = toString(string);
	      pattern = guard ? undefined : pattern;
	
	      if (pattern === undefined) {
	        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
	      }
	      return string.match(pattern) || [];
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Attempts to invoke `func`, returning either the result or the caught error
	     * object. Any additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Function} func The function to attempt.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {*} Returns the `func` result or error object.
	     * @example
	     *
	     * // Avoid throwing errors for invalid selectors.
	     * var elements = _.attempt(function(selector) {
	     *   return document.querySelectorAll(selector);
	     * }, '>_>');
	     *
	     * if (_.isError(elements)) {
	     *   elements = [];
	     * }
	     */
	    var attempt = baseRest(function(func, args) {
	      try {
	        return apply(func, undefined, args);
	      } catch (e) {
	        return isError(e) ? e : new Error(e);
	      }
	    });
	
	    /**
	     * Binds methods of an object to the object itself, overwriting the existing
	     * method.
	     *
	     * **Note:** This method doesn't set the "length" property of bound functions.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Object} object The object to bind and assign the bound methods to.
	     * @param {...(string|string[])} methodNames The object method names to bind.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var view = {
	     *   'label': 'docs',
	     *   'click': function() {
	     *     console.log('clicked ' + this.label);
	     *   }
	     * };
	     *
	     * _.bindAll(view, ['click']);
	     * jQuery(element).on('click', view.click);
	     * // => Logs 'clicked docs' when clicked.
	     */
	    var bindAll = flatRest(function(object, methodNames) {
	      arrayEach(methodNames, function(key) {
	        key = toKey(key);
	        baseAssignValue(object, key, bind(object[key], object));
	      });
	      return object;
	    });
	
	    /**
	     * Creates a function that iterates over `pairs` and invokes the corresponding
	     * function of the first predicate to return truthy. The predicate-function
	     * pairs are invoked with the `this` binding and arguments of the created
	     * function.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Array} pairs The predicate-function pairs.
	     * @returns {Function} Returns the new composite function.
	     * @example
	     *
	     * var func = _.cond([
	     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
	     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
	     *   [_.stubTrue,                      _.constant('no match')]
	     * ]);
	     *
	     * func({ 'a': 1, 'b': 2 });
	     * // => 'matches A'
	     *
	     * func({ 'a': 0, 'b': 1 });
	     * // => 'matches B'
	     *
	     * func({ 'a': '1', 'b': '2' });
	     * // => 'no match'
	     */
	    function cond(pairs) {
	      var length = pairs == null ? 0 : pairs.length,
	          toIteratee = getIteratee();
	
	      pairs = !length ? [] : arrayMap(pairs, function(pair) {
	        if (typeof pair[1] != 'function') {
	          throw new TypeError(FUNC_ERROR_TEXT);
	        }
	        return [toIteratee(pair[0]), pair[1]];
	      });
	
	      return baseRest(function(args) {
	        var index = -1;
	        while (++index < length) {
	          var pair = pairs[index];
	          if (apply(pair[0], this, args)) {
	            return apply(pair[1], this, args);
	          }
	        }
	      });
	    }
	
	    /**
	     * Creates a function that invokes the predicate properties of `source` with
	     * the corresponding property values of a given object, returning `true` if
	     * all predicates return truthy, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.conformsTo` with
	     * `source` partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 2, 'b': 1 },
	     *   { 'a': 1, 'b': 2 }
	     * ];
	     *
	     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
	     * // => [{ 'a': 1, 'b': 2 }]
	     */
	    function conforms(source) {
	      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that returns `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {*} value The value to return from the new function.
	     * @returns {Function} Returns the new constant function.
	     * @example
	     *
	     * var objects = _.times(2, _.constant({ 'a': 1 }));
	     *
	     * console.log(objects);
	     * // => [{ 'a': 1 }, { 'a': 1 }]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => true
	     */
	    function constant(value) {
	      return function() {
	        return value;
	      };
	    }
	
	    /**
	     * Checks `value` to determine whether a default value should be returned in
	     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
	     * or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Util
	     * @param {*} value The value to check.
	     * @param {*} defaultValue The default value.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * _.defaultTo(1, 10);
	     * // => 1
	     *
	     * _.defaultTo(undefined, 10);
	     * // => 10
	     */
	    function defaultTo(value, defaultValue) {
	      return (value == null || value !== value) ? defaultValue : value;
	    }
	
	    /**
	     * Creates a function that returns the result of invoking the given functions
	     * with the `this` binding of the created function, where each successive
	     * invocation is supplied the return value of the previous.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flowRight
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flow([_.add, square]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flow = createFlow();
	
	    /**
	     * This method is like `_.flow` except that it creates a function that
	     * invokes the given functions from right to left.
	     *
	     * @static
	     * @since 3.0.0
	     * @memberOf _
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flow
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flowRight([square, _.add]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flowRight = createFlow(true);
	
	    /**
	     * This method returns the first argument it receives.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {*} value Any value.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     *
	     * console.log(_.identity(object) === object);
	     * // => true
	     */
	    function identity(value) {
	      return value;
	    }
	
	    /**
	     * Creates a function that invokes `func` with the arguments of the created
	     * function. If `func` is a property name, the created function returns the
	     * property value for a given element. If `func` is an array or object, the
	     * created function returns `true` for elements that contain the equivalent
	     * source properties, otherwise it returns `false`.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Util
	     * @param {*} [func=_.identity] The value to convert to a callback.
	     * @returns {Function} Returns the callback.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
	     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, _.iteratee(['user', 'fred']));
	     * // => [{ 'user': 'fred', 'age': 40 }]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, _.iteratee('user'));
	     * // => ['barney', 'fred']
	     *
	     * // Create custom iteratee shorthands.
	     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
	     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
	     *     return func.test(string);
	     *   };
	     * });
	     *
	     * _.filter(['abc', 'def'], /ef/);
	     * // => ['def']
	     */
	    function iteratee(func) {
	      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between a given
	     * object and `source`, returning `true` if the given object has equivalent
	     * property values, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.isMatch` with `source`
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * **Note:** Multiple values can be checked by combining several matchers
	     * using `_.overSome`
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
	     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
	     *
	     * // Checking for several possible values
	     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
	     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
	     */
	    function matches(source) {
	      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between the
	     * value at `path` of a given object to `srcValue`, returning `true` if the
	     * object value is equivalent, else `false`.
	     *
	     * **Note:** Partial comparisons will match empty array and empty object
	     * `srcValue` values against any array or object value, respectively. See
	     * `_.isEqual` for a list of supported value comparisons.
	     *
	     * **Note:** Multiple values can be checked by combining several matchers
	     * using `_.overSome`
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.find(objects, _.matchesProperty('a', 4));
	     * // => { 'a': 4, 'b': 5, 'c': 6 }
	     *
	     * // Checking for several possible values
	     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
	     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
	     */
	    function matchesProperty(path, srcValue) {
	      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that invokes the method at `path` of a given object.
	     * Any additional arguments are provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': _.constant(2) } },
	     *   { 'a': { 'b': _.constant(1) } }
	     * ];
	     *
	     * _.map(objects, _.method('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(objects, _.method(['a', 'b']));
	     * // => [2, 1]
	     */
	    var method = baseRest(function(path, args) {
	      return function(object) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * The opposite of `_.method`; this method creates a function that invokes
	     * the method at a given path of `object`. Any additional arguments are
	     * provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var array = _.times(3, _.constant),
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
	     * // => [2, 0]
	     */
	    var methodOf = baseRest(function(object, args) {
	      return function(path) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * Adds all own enumerable string keyed function properties of a source
	     * object to the destination object. If `object` is a function, then methods
	     * are added to its prototype as well.
	     *
	     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
	     * avoid conflicts caused by modifying the original.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Function|Object} [object=lodash] The destination object.
	     * @param {Object} source The object of functions to add.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
	     * @returns {Function|Object} Returns `object`.
	     * @example
	     *
	     * function vowels(string) {
	     *   return _.filter(string, function(v) {
	     *     return /[aeiou]/i.test(v);
	     *   });
	     * }
	     *
	     * _.mixin({ 'vowels': vowels });
	     * _.vowels('fred');
	     * // => ['e']
	     *
	     * _('fred').vowels().value();
	     * // => ['e']
	     *
	     * _.mixin({ 'vowels': vowels }, { 'chain': false });
	     * _('fred').vowels();
	     * // => ['e']
	     */
	    function mixin(object, source, options) {
	      var props = keys(source),
	          methodNames = baseFunctions(source, props);
	
	      if (options == null &&
	          !(isObject(source) && (methodNames.length || !props.length))) {
	        options = source;
	        source = object;
	        object = this;
	        methodNames = baseFunctions(source, keys(source));
	      }
	      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
	          isFunc = isFunction(object);
	
	      arrayEach(methodNames, function(methodName) {
	        var func = source[methodName];
	        object[methodName] = func;
	        if (isFunc) {
	          object.prototype[methodName] = function() {
	            var chainAll = this.__chain__;
	            if (chain || chainAll) {
	              var result = object(this.__wrapped__),
	                  actions = result.__actions__ = copyArray(this.__actions__);
	
	              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
	              result.__chain__ = chainAll;
	              return result;
	            }
	            return func.apply(object, arrayPush([this.value()], arguments));
	          };
	        }
	      });
	
	      return object;
	    }
	
	    /**
	     * Reverts the `_` variable to its previous value and returns a reference to
	     * the `lodash` function.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @returns {Function} Returns the `lodash` function.
	     * @example
	     *
	     * var lodash = _.noConflict();
	     */
	    function noConflict() {
	      if (root._ === this) {
	        root._ = oldDash;
	      }
	      return this;
	    }
	
	    /**
	     * This method returns `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Util
	     * @example
	     *
	     * _.times(2, _.noop);
	     * // => [undefined, undefined]
	     */
	    function noop() {
	      // No operation performed.
	    }
	
	    /**
	     * Creates a function that gets the argument at index `n`. If `n` is negative,
	     * the nth argument from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [n=0] The index of the argument to return.
	     * @returns {Function} Returns the new pass-thru function.
	     * @example
	     *
	     * var func = _.nthArg(1);
	     * func('a', 'b', 'c', 'd');
	     * // => 'b'
	     *
	     * var func = _.nthArg(-2);
	     * func('a', 'b', 'c', 'd');
	     * // => 'c'
	     */
	    function nthArg(n) {
	      n = toInteger(n);
	      return baseRest(function(args) {
	        return baseNth(args, n);
	      });
	    }
	
	    /**
	     * Creates a function that invokes `iteratees` with the arguments it receives
	     * and returns their results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to invoke.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.over([Math.max, Math.min]);
	     *
	     * func(1, 2, 3, 4);
	     * // => [4, 1]
	     */
	    var over = createOver(arrayMap);
	
	    /**
	     * Creates a function that checks if **all** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * Following shorthands are possible for providing predicates.
	     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
	     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overEvery([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => false
	     *
	     * func(NaN);
	     * // => false
	     */
	    var overEvery = createOver(arrayEvery);
	
	    /**
	     * Creates a function that checks if **any** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * Following shorthands are possible for providing predicates.
	     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
	     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overSome([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => true
	     *
	     * func(NaN);
	     * // => false
	     *
	     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
	     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
	     */
	    var overSome = createOver(arraySome);
	
	    /**
	     * Creates a function that returns the value at `path` of a given object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': 2 } },
	     *   { 'a': { 'b': 1 } }
	     * ];
	     *
	     * _.map(objects, _.property('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	     * // => [1, 2]
	     */
	    function property(path) {
	      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	    }
	
	    /**
	     * The opposite of `_.property`; this method creates a function that returns
	     * the value at a given path of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var array = [0, 1, 2],
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
	     * // => [2, 0]
	     */
	    function propertyOf(object) {
	      return function(path) {
	        return object == null ? undefined : baseGet(object, path);
	      };
	    }
	
	    /**
	     * Creates an array of numbers (positive and/or negative) progressing from
	     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
	     * `start` is specified without an `end` or `step`. If `end` is not specified,
	     * it's set to `start` with `start` then set to `0`.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.rangeRight
	     * @example
	     *
	     * _.range(4);
	     * // => [0, 1, 2, 3]
	     *
	     * _.range(-4);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 5);
	     * // => [1, 2, 3, 4]
	     *
	     * _.range(0, 20, 5);
	     * // => [0, 5, 10, 15]
	     *
	     * _.range(0, -4, -1);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.range(0);
	     * // => []
	     */
	    var range = createRange();
	
	    /**
	     * This method is like `_.range` except that it populates values in
	     * descending order.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.range
	     * @example
	     *
	     * _.rangeRight(4);
	     * // => [3, 2, 1, 0]
	     *
	     * _.rangeRight(-4);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 5);
	     * // => [4, 3, 2, 1]
	     *
	     * _.rangeRight(0, 20, 5);
	     * // => [15, 10, 5, 0]
	     *
	     * _.rangeRight(0, -4, -1);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.rangeRight(0);
	     * // => []
	     */
	    var rangeRight = createRange(true);
	
	    /**
	     * This method returns a new empty array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Array} Returns the new empty array.
	     * @example
	     *
	     * var arrays = _.times(2, _.stubArray);
	     *
	     * console.log(arrays);
	     * // => [[], []]
	     *
	     * console.log(arrays[0] === arrays[1]);
	     * // => false
	     */
	    function stubArray() {
	      return [];
	    }
	
	    /**
	     * This method returns `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `false`.
	     * @example
	     *
	     * _.times(2, _.stubFalse);
	     * // => [false, false]
	     */
	    function stubFalse() {
	      return false;
	    }
	
	    /**
	     * This method returns a new empty object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Object} Returns the new empty object.
	     * @example
	     *
	     * var objects = _.times(2, _.stubObject);
	     *
	     * console.log(objects);
	     * // => [{}, {}]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => false
	     */
	    function stubObject() {
	      return {};
	    }
	
	    /**
	     * This method returns an empty string.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {string} Returns the empty string.
	     * @example
	     *
	     * _.times(2, _.stubString);
	     * // => ['', '']
	     */
	    function stubString() {
	      return '';
	    }
	
	    /**
	     * This method returns `true`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `true`.
	     * @example
	     *
	     * _.times(2, _.stubTrue);
	     * // => [true, true]
	     */
	    function stubTrue() {
	      return true;
	    }
	
	    /**
	     * Invokes the iteratee `n` times, returning an array of the results of
	     * each invocation. The iteratee is invoked with one argument; (index).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} n The number of times to invoke `iteratee`.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.times(3, String);
	     * // => ['0', '1', '2']
	     *
	     *  _.times(4, _.constant(0));
	     * // => [0, 0, 0, 0]
	     */
	    function times(n, iteratee) {
	      n = toInteger(n);
	      if (n < 1 || n > MAX_SAFE_INTEGER) {
	        return [];
	      }
	      var index = MAX_ARRAY_LENGTH,
	          length = nativeMin(n, MAX_ARRAY_LENGTH);
	
	      iteratee = getIteratee(iteratee);
	      n -= MAX_ARRAY_LENGTH;
	
	      var result = baseTimes(length, iteratee);
	      while (++index < n) {
	        iteratee(index);
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a property path array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the new property path array.
	     * @example
	     *
	     * _.toPath('a.b.c');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toPath('a[0].b.c');
	     * // => ['a', '0', 'b', 'c']
	     */
	    function toPath(value) {
	      if (isArray(value)) {
	        return arrayMap(value, toKey);
	      }
	      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
	    }
	
	    /**
	     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {string} [prefix=''] The value to prefix the ID with.
	     * @returns {string} Returns the unique ID.
	     * @example
	     *
	     * _.uniqueId('contact_');
	     * // => 'contact_104'
	     *
	     * _.uniqueId();
	     * // => '105'
	     */
	    function uniqueId(prefix) {
	      var id = ++idCounter;
	      return toString(prefix) + id;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Adds two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {number} augend The first number in an addition.
	     * @param {number} addend The second number in an addition.
	     * @returns {number} Returns the total.
	     * @example
	     *
	     * _.add(6, 4);
	     * // => 10
	     */
	    var add = createMathOperation(function(augend, addend) {
	      return augend + addend;
	    }, 0);
	
	    /**
	     * Computes `number` rounded up to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round up.
	     * @param {number} [precision=0] The precision to round up to.
	     * @returns {number} Returns the rounded up number.
	     * @example
	     *
	     * _.ceil(4.006);
	     * // => 5
	     *
	     * _.ceil(6.004, 2);
	     * // => 6.01
	     *
	     * _.ceil(6040, -2);
	     * // => 6100
	     */
	    var ceil = createRound('ceil');
	
	    /**
	     * Divide two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} dividend The first number in a division.
	     * @param {number} divisor The second number in a division.
	     * @returns {number} Returns the quotient.
	     * @example
	     *
	     * _.divide(6, 4);
	     * // => 1.5
	     */
	    var divide = createMathOperation(function(dividend, divisor) {
	      return dividend / divisor;
	    }, 1);
	
	    /**
	     * Computes `number` rounded down to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round down.
	     * @param {number} [precision=0] The precision to round down to.
	     * @returns {number} Returns the rounded down number.
	     * @example
	     *
	     * _.floor(4.006);
	     * // => 4
	     *
	     * _.floor(0.046, 2);
	     * // => 0.04
	     *
	     * _.floor(4060, -2);
	     * // => 4000
	     */
	    var floor = createRound('floor');
	
	    /**
	     * Computes the maximum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * _.max([4, 2, 8, 6]);
	     * // => 8
	     *
	     * _.max([]);
	     * // => undefined
	     */
	    function max(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseGt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.max` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.maxBy(objects, function(o) { return o.n; });
	     * // => { 'n': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.maxBy(objects, 'n');
	     * // => { 'n': 2 }
	     */
	    function maxBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
	        : undefined;
	    }
	
	    /**
	     * Computes the mean of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * _.mean([4, 2, 8, 6]);
	     * // => 5
	     */
	    function mean(array) {
	      return baseMean(array, identity);
	    }
	
	    /**
	     * This method is like `_.mean` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be averaged.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.meanBy(objects, function(o) { return o.n; });
	     * // => 5
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.meanBy(objects, 'n');
	     * // => 5
	     */
	    function meanBy(array, iteratee) {
	      return baseMean(array, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * Computes the minimum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * _.min([4, 2, 8, 6]);
	     * // => 2
	     *
	     * _.min([]);
	     * // => undefined
	     */
	    function min(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseLt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.min` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.minBy(objects, function(o) { return o.n; });
	     * // => { 'n': 1 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.minBy(objects, 'n');
	     * // => { 'n': 1 }
	     */
	    function minBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
	        : undefined;
	    }
	
	    /**
	     * Multiply two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} multiplier The first number in a multiplication.
	     * @param {number} multiplicand The second number in a multiplication.
	     * @returns {number} Returns the product.
	     * @example
	     *
	     * _.multiply(6, 4);
	     * // => 24
	     */
	    var multiply = createMathOperation(function(multiplier, multiplicand) {
	      return multiplier * multiplicand;
	    }, 1);
	
	    /**
	     * Computes `number` rounded to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round.
	     * @param {number} [precision=0] The precision to round to.
	     * @returns {number} Returns the rounded number.
	     * @example
	     *
	     * _.round(4.006);
	     * // => 4
	     *
	     * _.round(4.006, 2);
	     * // => 4.01
	     *
	     * _.round(4060, -2);
	     * // => 4100
	     */
	    var round = createRound('round');
	
	    /**
	     * Subtract two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {number} minuend The first number in a subtraction.
	     * @param {number} subtrahend The second number in a subtraction.
	     * @returns {number} Returns the difference.
	     * @example
	     *
	     * _.subtract(6, 4);
	     * // => 2
	     */
	    var subtract = createMathOperation(function(minuend, subtrahend) {
	      return minuend - subtrahend;
	    }, 0);
	
	    /**
	     * Computes the sum of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * _.sum([4, 2, 8, 6]);
	     * // => 20
	     */
	    function sum(array) {
	      return (array && array.length)
	        ? baseSum(array, identity)
	        : 0;
	    }
	
	    /**
	     * This method is like `_.sum` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be summed.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.sumBy(objects, function(o) { return o.n; });
	     * // => 20
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sumBy(objects, 'n');
	     * // => 20
	     */
	    function sumBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSum(array, getIteratee(iteratee, 2))
	        : 0;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return wrapped values in chain sequences.
	    lodash.after = after;
	    lodash.ary = ary;
	    lodash.assign = assign;
	    lodash.assignIn = assignIn;
	    lodash.assignInWith = assignInWith;
	    lodash.assignWith = assignWith;
	    lodash.at = at;
	    lodash.before = before;
	    lodash.bind = bind;
	    lodash.bindAll = bindAll;
	    lodash.bindKey = bindKey;
	    lodash.castArray = castArray;
	    lodash.chain = chain;
	    lodash.chunk = chunk;
	    lodash.compact = compact;
	    lodash.concat = concat;
	    lodash.cond = cond;
	    lodash.conforms = conforms;
	    lodash.constant = constant;
	    lodash.countBy = countBy;
	    lodash.create = create;
	    lodash.curry = curry;
	    lodash.curryRight = curryRight;
	    lodash.debounce = debounce;
	    lodash.defaults = defaults;
	    lodash.defaultsDeep = defaultsDeep;
	    lodash.defer = defer;
	    lodash.delay = delay;
	    lodash.difference = difference;
	    lodash.differenceBy = differenceBy;
	    lodash.differenceWith = differenceWith;
	    lodash.drop = drop;
	    lodash.dropRight = dropRight;
	    lodash.dropRightWhile = dropRightWhile;
	    lodash.dropWhile = dropWhile;
	    lodash.fill = fill;
	    lodash.filter = filter;
	    lodash.flatMap = flatMap;
	    lodash.flatMapDeep = flatMapDeep;
	    lodash.flatMapDepth = flatMapDepth;
	    lodash.flatten = flatten;
	    lodash.flattenDeep = flattenDeep;
	    lodash.flattenDepth = flattenDepth;
	    lodash.flip = flip;
	    lodash.flow = flow;
	    lodash.flowRight = flowRight;
	    lodash.fromPairs = fromPairs;
	    lodash.functions = functions;
	    lodash.functionsIn = functionsIn;
	    lodash.groupBy = groupBy;
	    lodash.initial = initial;
	    lodash.intersection = intersection;
	    lodash.intersectionBy = intersectionBy;
	    lodash.intersectionWith = intersectionWith;
	    lodash.invert = invert;
	    lodash.invertBy = invertBy;
	    lodash.invokeMap = invokeMap;
	    lodash.iteratee = iteratee;
	    lodash.keyBy = keyBy;
	    lodash.keys = keys;
	    lodash.keysIn = keysIn;
	    lodash.map = map;
	    lodash.mapKeys = mapKeys;
	    lodash.mapValues = mapValues;
	    lodash.matches = matches;
	    lodash.matchesProperty = matchesProperty;
	    lodash.memoize = memoize;
	    lodash.merge = merge;
	    lodash.mergeWith = mergeWith;
	    lodash.method = method;
	    lodash.methodOf = methodOf;
	    lodash.mixin = mixin;
	    lodash.negate = negate;
	    lodash.nthArg = nthArg;
	    lodash.omit = omit;
	    lodash.omitBy = omitBy;
	    lodash.once = once;
	    lodash.orderBy = orderBy;
	    lodash.over = over;
	    lodash.overArgs = overArgs;
	    lodash.overEvery = overEvery;
	    lodash.overSome = overSome;
	    lodash.partial = partial;
	    lodash.partialRight = partialRight;
	    lodash.partition = partition;
	    lodash.pick = pick;
	    lodash.pickBy = pickBy;
	    lodash.property = property;
	    lodash.propertyOf = propertyOf;
	    lodash.pull = pull;
	    lodash.pullAll = pullAll;
	    lodash.pullAllBy = pullAllBy;
	    lodash.pullAllWith = pullAllWith;
	    lodash.pullAt = pullAt;
	    lodash.range = range;
	    lodash.rangeRight = rangeRight;
	    lodash.rearg = rearg;
	    lodash.reject = reject;
	    lodash.remove = remove;
	    lodash.rest = rest;
	    lodash.reverse = reverse;
	    lodash.sampleSize = sampleSize;
	    lodash.set = set;
	    lodash.setWith = setWith;
	    lodash.shuffle = shuffle;
	    lodash.slice = slice;
	    lodash.sortBy = sortBy;
	    lodash.sortedUniq = sortedUniq;
	    lodash.sortedUniqBy = sortedUniqBy;
	    lodash.split = split;
	    lodash.spread = spread;
	    lodash.tail = tail;
	    lodash.take = take;
	    lodash.takeRight = takeRight;
	    lodash.takeRightWhile = takeRightWhile;
	    lodash.takeWhile = takeWhile;
	    lodash.tap = tap;
	    lodash.throttle = throttle;
	    lodash.thru = thru;
	    lodash.toArray = toArray;
	    lodash.toPairs = toPairs;
	    lodash.toPairsIn = toPairsIn;
	    lodash.toPath = toPath;
	    lodash.toPlainObject = toPlainObject;
	    lodash.transform = transform;
	    lodash.unary = unary;
	    lodash.union = union;
	    lodash.unionBy = unionBy;
	    lodash.unionWith = unionWith;
	    lodash.uniq = uniq;
	    lodash.uniqBy = uniqBy;
	    lodash.uniqWith = uniqWith;
	    lodash.unset = unset;
	    lodash.unzip = unzip;
	    lodash.unzipWith = unzipWith;
	    lodash.update = update;
	    lodash.updateWith = updateWith;
	    lodash.values = values;
	    lodash.valuesIn = valuesIn;
	    lodash.without = without;
	    lodash.words = words;
	    lodash.wrap = wrap;
	    lodash.xor = xor;
	    lodash.xorBy = xorBy;
	    lodash.xorWith = xorWith;
	    lodash.zip = zip;
	    lodash.zipObject = zipObject;
	    lodash.zipObjectDeep = zipObjectDeep;
	    lodash.zipWith = zipWith;
	
	    // Add aliases.
	    lodash.entries = toPairs;
	    lodash.entriesIn = toPairsIn;
	    lodash.extend = assignIn;
	    lodash.extendWith = assignInWith;
	
	    // Add methods to `lodash.prototype`.
	    mixin(lodash, lodash);
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return unwrapped values in chain sequences.
	    lodash.add = add;
	    lodash.attempt = attempt;
	    lodash.camelCase = camelCase;
	    lodash.capitalize = capitalize;
	    lodash.ceil = ceil;
	    lodash.clamp = clamp;
	    lodash.clone = clone;
	    lodash.cloneDeep = cloneDeep;
	    lodash.cloneDeepWith = cloneDeepWith;
	    lodash.cloneWith = cloneWith;
	    lodash.conformsTo = conformsTo;
	    lodash.deburr = deburr;
	    lodash.defaultTo = defaultTo;
	    lodash.divide = divide;
	    lodash.endsWith = endsWith;
	    lodash.eq = eq;
	    lodash.escape = escape;
	    lodash.escapeRegExp = escapeRegExp;
	    lodash.every = every;
	    lodash.find = find;
	    lodash.findIndex = findIndex;
	    lodash.findKey = findKey;
	    lodash.findLast = findLast;
	    lodash.findLastIndex = findLastIndex;
	    lodash.findLastKey = findLastKey;
	    lodash.floor = floor;
	    lodash.forEach = forEach;
	    lodash.forEachRight = forEachRight;
	    lodash.forIn = forIn;
	    lodash.forInRight = forInRight;
	    lodash.forOwn = forOwn;
	    lodash.forOwnRight = forOwnRight;
	    lodash.get = get;
	    lodash.gt = gt;
	    lodash.gte = gte;
	    lodash.has = has;
	    lodash.hasIn = hasIn;
	    lodash.head = head;
	    lodash.identity = identity;
	    lodash.includes = includes;
	    lodash.indexOf = indexOf;
	    lodash.inRange = inRange;
	    lodash.invoke = invoke;
	    lodash.isArguments = isArguments;
	    lodash.isArray = isArray;
	    lodash.isArrayBuffer = isArrayBuffer;
	    lodash.isArrayLike = isArrayLike;
	    lodash.isArrayLikeObject = isArrayLikeObject;
	    lodash.isBoolean = isBoolean;
	    lodash.isBuffer = isBuffer;
	    lodash.isDate = isDate;
	    lodash.isElement = isElement;
	    lodash.isEmpty = isEmpty;
	    lodash.isEqual = isEqual;
	    lodash.isEqualWith = isEqualWith;
	    lodash.isError = isError;
	    lodash.isFinite = isFinite;
	    lodash.isFunction = isFunction;
	    lodash.isInteger = isInteger;
	    lodash.isLength = isLength;
	    lodash.isMap = isMap;
	    lodash.isMatch = isMatch;
	    lodash.isMatchWith = isMatchWith;
	    lodash.isNaN = isNaN;
	    lodash.isNative = isNative;
	    lodash.isNil = isNil;
	    lodash.isNull = isNull;
	    lodash.isNumber = isNumber;
	    lodash.isObject = isObject;
	    lodash.isObjectLike = isObjectLike;
	    lodash.isPlainObject = isPlainObject;
	    lodash.isRegExp = isRegExp;
	    lodash.isSafeInteger = isSafeInteger;
	    lodash.isSet = isSet;
	    lodash.isString = isString;
	    lodash.isSymbol = isSymbol;
	    lodash.isTypedArray = isTypedArray;
	    lodash.isUndefined = isUndefined;
	    lodash.isWeakMap = isWeakMap;
	    lodash.isWeakSet = isWeakSet;
	    lodash.join = join;
	    lodash.kebabCase = kebabCase;
	    lodash.last = last;
	    lodash.lastIndexOf = lastIndexOf;
	    lodash.lowerCase = lowerCase;
	    lodash.lowerFirst = lowerFirst;
	    lodash.lt = lt;
	    lodash.lte = lte;
	    lodash.max = max;
	    lodash.maxBy = maxBy;
	    lodash.mean = mean;
	    lodash.meanBy = meanBy;
	    lodash.min = min;
	    lodash.minBy = minBy;
	    lodash.stubArray = stubArray;
	    lodash.stubFalse = stubFalse;
	    lodash.stubObject = stubObject;
	    lodash.stubString = stubString;
	    lodash.stubTrue = stubTrue;
	    lodash.multiply = multiply;
	    lodash.nth = nth;
	    lodash.noConflict = noConflict;
	    lodash.noop = noop;
	    lodash.now = now;
	    lodash.pad = pad;
	    lodash.padEnd = padEnd;
	    lodash.padStart = padStart;
	    lodash.parseInt = parseInt;
	    lodash.random = random;
	    lodash.reduce = reduce;
	    lodash.reduceRight = reduceRight;
	    lodash.repeat = repeat;
	    lodash.replace = replace;
	    lodash.result = result;
	    lodash.round = round;
	    lodash.runInContext = runInContext;
	    lodash.sample = sample;
	    lodash.size = size;
	    lodash.snakeCase = snakeCase;
	    lodash.some = some;
	    lodash.sortedIndex = sortedIndex;
	    lodash.sortedIndexBy = sortedIndexBy;
	    lodash.sortedIndexOf = sortedIndexOf;
	    lodash.sortedLastIndex = sortedLastIndex;
	    lodash.sortedLastIndexBy = sortedLastIndexBy;
	    lodash.sortedLastIndexOf = sortedLastIndexOf;
	    lodash.startCase = startCase;
	    lodash.startsWith = startsWith;
	    lodash.subtract = subtract;
	    lodash.sum = sum;
	    lodash.sumBy = sumBy;
	    lodash.template = template;
	    lodash.times = times;
	    lodash.toFinite = toFinite;
	    lodash.toInteger = toInteger;
	    lodash.toLength = toLength;
	    lodash.toLower = toLower;
	    lodash.toNumber = toNumber;
	    lodash.toSafeInteger = toSafeInteger;
	    lodash.toString = toString;
	    lodash.toUpper = toUpper;
	    lodash.trim = trim;
	    lodash.trimEnd = trimEnd;
	    lodash.trimStart = trimStart;
	    lodash.truncate = truncate;
	    lodash.unescape = unescape;
	    lodash.uniqueId = uniqueId;
	    lodash.upperCase = upperCase;
	    lodash.upperFirst = upperFirst;
	
	    // Add aliases.
	    lodash.each = forEach;
	    lodash.eachRight = forEachRight;
	    lodash.first = head;
	
	    mixin(lodash, (function() {
	      var source = {};
	      baseForOwn(lodash, function(func, methodName) {
	        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
	          source[methodName] = func;
	        }
	      });
	      return source;
	    }()), { 'chain': false });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The semantic version number.
	     *
	     * @static
	     * @memberOf _
	     * @type {string}
	     */
	    lodash.VERSION = VERSION;
	
	    // Assign default placeholders.
	    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
	      lodash[methodName].placeholder = lodash;
	    });
	
	    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
	    arrayEach(['drop', 'take'], function(methodName, index) {
	      LazyWrapper.prototype[methodName] = function(n) {
	        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
	
	        var result = (this.__filtered__ && !index)
	          ? new LazyWrapper(this)
	          : this.clone();
	
	        if (result.__filtered__) {
	          result.__takeCount__ = nativeMin(n, result.__takeCount__);
	        } else {
	          result.__views__.push({
	            'size': nativeMin(n, MAX_ARRAY_LENGTH),
	            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
	          });
	        }
	        return result;
	      };
	
	      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
	        return this.reverse()[methodName](n).reverse();
	      };
	    });
	
	    // Add `LazyWrapper` methods that accept an `iteratee` value.
	    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
	      var type = index + 1,
	          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
	
	      LazyWrapper.prototype[methodName] = function(iteratee) {
	        var result = this.clone();
	        result.__iteratees__.push({
	          'iteratee': getIteratee(iteratee, 3),
	          'type': type
	        });
	        result.__filtered__ = result.__filtered__ || isFilter;
	        return result;
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.head` and `_.last`.
	    arrayEach(['head', 'last'], function(methodName, index) {
	      var takeName = 'take' + (index ? 'Right' : '');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this[takeName](1).value()[0];
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
	    arrayEach(['initial', 'tail'], function(methodName, index) {
	      var dropName = 'drop' + (index ? '' : 'Right');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
	      };
	    });
	
	    LazyWrapper.prototype.compact = function() {
	      return this.filter(identity);
	    };
	
	    LazyWrapper.prototype.find = function(predicate) {
	      return this.filter(predicate).head();
	    };
	
	    LazyWrapper.prototype.findLast = function(predicate) {
	      return this.reverse().find(predicate);
	    };
	
	    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
	      if (typeof path == 'function') {
	        return new LazyWrapper(this);
	      }
	      return this.map(function(value) {
	        return baseInvoke(value, path, args);
	      });
	    });
	
	    LazyWrapper.prototype.reject = function(predicate) {
	      return this.filter(negate(getIteratee(predicate)));
	    };
	
	    LazyWrapper.prototype.slice = function(start, end) {
	      start = toInteger(start);
	
	      var result = this;
	      if (result.__filtered__ && (start > 0 || end < 0)) {
	        return new LazyWrapper(result);
	      }
	      if (start < 0) {
	        result = result.takeRight(-start);
	      } else if (start) {
	        result = result.drop(start);
	      }
	      if (end !== undefined) {
	        end = toInteger(end);
	        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
	      }
	      return result;
	    };
	
	    LazyWrapper.prototype.takeRightWhile = function(predicate) {
	      return this.reverse().takeWhile(predicate).reverse();
	    };
	
	    LazyWrapper.prototype.toArray = function() {
	      return this.take(MAX_ARRAY_LENGTH);
	    };
	
	    // Add `LazyWrapper` methods to `lodash.prototype`.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
	          isTaker = /^(?:head|last)$/.test(methodName),
	          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
	          retUnwrapped = isTaker || /^find/.test(methodName);
	
	      if (!lodashFunc) {
	        return;
	      }
	      lodash.prototype[methodName] = function() {
	        var value = this.__wrapped__,
	            args = isTaker ? [1] : arguments,
	            isLazy = value instanceof LazyWrapper,
	            iteratee = args[0],
	            useLazy = isLazy || isArray(value);
	
	        var interceptor = function(value) {
	          var result = lodashFunc.apply(lodash, arrayPush([value], args));
	          return (isTaker && chainAll) ? result[0] : result;
	        };
	
	        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
	          // Avoid lazy use if the iteratee has a "length" value other than `1`.
	          isLazy = useLazy = false;
	        }
	        var chainAll = this.__chain__,
	            isHybrid = !!this.__actions__.length,
	            isUnwrapped = retUnwrapped && !chainAll,
	            onlyLazy = isLazy && !isHybrid;
	
	        if (!retUnwrapped && useLazy) {
	          value = onlyLazy ? value : new LazyWrapper(this);
	          var result = func.apply(value, args);
	          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
	          return new LodashWrapper(result, chainAll);
	        }
	        if (isUnwrapped && onlyLazy) {
	          return func.apply(this, args);
	        }
	        result = this.thru(interceptor);
	        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
	      };
	    });
	
	    // Add `Array` methods to `lodash.prototype`.
	    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
	      var func = arrayProto[methodName],
	          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
	          retUnwrapped = /^(?:pop|shift)$/.test(methodName);
	
	      lodash.prototype[methodName] = function() {
	        var args = arguments;
	        if (retUnwrapped && !this.__chain__) {
	          var value = this.value();
	          return func.apply(isArray(value) ? value : [], args);
	        }
	        return this[chainName](function(value) {
	          return func.apply(isArray(value) ? value : [], args);
	        });
	      };
	    });
	
	    // Map minified method names to their real names.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var lodashFunc = lodash[methodName];
	      if (lodashFunc) {
	        var key = lodashFunc.name + '';
	        if (!hasOwnProperty.call(realNames, key)) {
	          realNames[key] = [];
	        }
	        realNames[key].push({ 'name': methodName, 'func': lodashFunc });
	      }
	    });
	
	    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
	      'name': 'wrapper',
	      'func': undefined
	    }];
	
	    // Add methods to `LazyWrapper`.
	    LazyWrapper.prototype.clone = lazyClone;
	    LazyWrapper.prototype.reverse = lazyReverse;
	    LazyWrapper.prototype.value = lazyValue;
	
	    // Add chain sequence methods to the `lodash` wrapper.
	    lodash.prototype.at = wrapperAt;
	    lodash.prototype.chain = wrapperChain;
	    lodash.prototype.commit = wrapperCommit;
	    lodash.prototype.next = wrapperNext;
	    lodash.prototype.plant = wrapperPlant;
	    lodash.prototype.reverse = wrapperReverse;
	    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
	
	    // Add lazy aliases.
	    lodash.prototype.first = lodash.prototype.head;
	
	    if (symIterator) {
	      lodash.prototype[symIterator] = wrapperToIterator;
	    }
	    return lodash;
	  });
	
	  /*--------------------------------------------------------------------------*/
	
	  // Export lodash.
	  var _ = runInContext();
	
	  // Some AMD build optimizers, like r.js, check for condition patterns like:
	  if (true) {
	    // Expose Lodash on the global object to prevent errors when Lodash is
	    // loaded by a script tag in the presence of an AMD loader.
	    // See http://requirejs.org/docs/errors.html#mismatch for more details.
	    // Use `_.noConflict` to remove Lodash from the global object.
	    root._ = _;
	
	    // Define as an anonymous module so, through path mapping, it can be
	    // referenced as the "underscore" module.
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return _;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	  // Check for `exports` after `define` in case a build optimizer adds it.
	  else if (freeModule) {
	    // Export for Node.js.
	    (freeModule.exports = _)._ = _;
	    // Export for CommonJS support.
	    freeExports._ = _;
	  }
	  else {
	    // Export to the global object.
	    root._ = _;
	  }
	}.call(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(453)(module)))

/***/ }),
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */
/***/ (function(module, exports) {

	module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */
/***/ (function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var lbDateInput = angular.module('app.lbDateInput', []);
	
	lbDateInput.component('lbDateInput', {
	  controllerAs: 'vm',
	  controller: ['$rootScope', 'moment', 'ENUMS', 'dateTimeService', controller],
	  template: __webpack_require__(1708),
	  bindings: {
	    name: '@',
	    date: '=',
	    minDate: '<',
	    maxDate: '<',
	    required: '<',
	    'class': '@',
	    rangeFrom: '<',
	    rangeTo: '<',
	    parent: '@',
	    change: '&',
	    disabled: '<'
	  }
	});
	
	function controller($rootScope, moment, ENUMS, dateTimeService) {
	  var vm = this;
	  var DATE_FORMAT = dateTimeService.getFormat(ENUMS.dateTimeFormats.DATE_MEDIUM);
	
	  vm.openDatePicker = function ($event) {
	    if ($event.handleObj.type !== 'focus') return;
	    var settings = {
	      input: $event.currentTarget,
	      parent: vm.parent,
	      minDate: moment(vm.minDate, DATE_FORMAT),
	      maxDate: vm.maxDate ? moment(vm.maxDate, DATE_FORMAT) : moment().add(330, 'days'),
	      defaultDate: moment(vm.date, DATE_FORMAT),
	      rangeFrom: moment(vm.rangeFrom, DATE_FORMAT),
	      rangeTo: moment(vm.rangeTo, DATE_FORMAT),
	      callBack: dateCallBack
	    };
	    $rootScope.$broadcast('openDatePicker', settings);
	    $event.currentTarget.blur();
	  };
	
	  function dateCallBack(selection) {
	    if (selection) {
	      selection.date = moment(selection.date);
	      vm.date = selection.date.format(DATE_FORMAT);
	      if (vm.change) vm.change({ obj: selection });
	    }
	    $rootScope.$broadcast('closeDatePicker');
	  }
	}
	
	exports['default'] = lbDateInput;
	module.exports = exports['default'];

/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(39);
	var toLength = __webpack_require__(11);
	var toAbsoluteIndex = __webpack_require__(142);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};


/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(5);
	var $export = __webpack_require__(3);
	var redefine = __webpack_require__(26);
	var redefineAll = __webpack_require__(140);
	var meta = __webpack_require__(94);
	var forOf = __webpack_require__(135);
	var anInstance = __webpack_require__(134);
	var isObject = __webpack_require__(7);
	var fails = __webpack_require__(6);
	var $iterDetect = __webpack_require__(460);
	var setToStringTag = __webpack_require__(203);
	var inheritIfRequired = __webpack_require__(711);
	
	module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
	  var Base = global[NAME];
	  var C = Base;
	  var ADDER = IS_MAP ? 'set' : 'add';
	  var proto = C && C.prototype;
	  var O = {};
	  var fixMethod = function (KEY) {
	    var fn = proto[KEY];
	    redefine(proto, KEY,
	      KEY == 'delete' ? function (a) {
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'has' ? function has(a) {
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'get' ? function get(a) {
	        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
	        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
	    );
	  };
	  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
	    new C().entries().next();
	  }))) {
	    // create collection constructor
	    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
	    redefineAll(C.prototype, methods);
	    meta.NEED = true;
	  } else {
	    var instance = new C();
	    // early implementations not supports chaining
	    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
	    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
	    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
	    // most early implementations doesn't supports iterables, most modern - not close it correctly
	    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
	    // for early implementations -0 and +0 not the same
	    var BUGGY_ZERO = !IS_WEAK && fails(function () {
	      // V8 ~ Chromium 42- fails only with 5+ elements
	      var $instance = new C();
	      var index = 5;
	      while (index--) $instance[ADDER](index, index);
	      return !$instance.has(-0);
	    });
	    if (!ACCEPT_ITERABLES) {
	      C = wrapper(function (target, iterable) {
	        anInstance(target, C, NAME);
	        var that = inheritIfRequired(new Base(), target, C);
	        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	        return that;
	      });
	      C.prototype = proto;
	      proto.constructor = C;
	    }
	    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
	      fixMethod('delete');
	      fixMethod('has');
	      IS_MAP && fixMethod('get');
	    }
	    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
	    // weak collections should not contains .clear method
	    if (IS_WEAK && proto.clear) delete proto.clear;
	  }
	
	  setToStringTag(C, NAME);
	
	  O[NAME] = C;
	  $export($export.G + $export.W + $export.F * (C != Base), O);
	
	  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);
	
	  return C;
	};


/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	__webpack_require__(1119);
	var redefine = __webpack_require__(26);
	var hide = __webpack_require__(25);
	var fails = __webpack_require__(6);
	var defined = __webpack_require__(67);
	var wks = __webpack_require__(10);
	var regexpExec = __webpack_require__(719);
	
	var SPECIES = wks('species');
	
	var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
	  // #replace needs built-in support for named groups.
	  // #match works fine because it just return the exec results, even if it has
	  // a "grops" property.
	  var re = /./;
	  re.exec = function () {
	    var result = [];
	    result.groups = { a: '7' };
	    return result;
	  };
	  return ''.replace(re, '$<a>') !== '7';
	});
	
	var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = (function () {
	  // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
	  var re = /(?:)/;
	  var originalExec = re.exec;
	  re.exec = function () { return originalExec.apply(this, arguments); };
	  var result = 'ab'.split(re);
	  return result.length === 2 && result[0] === 'a' && result[1] === 'b';
	})();
	
	module.exports = function (KEY, length, exec) {
	  var SYMBOL = wks(KEY);
	
	  var DELEGATES_TO_SYMBOL = !fails(function () {
	    // String methods call symbol-named RegEp methods
	    var O = {};
	    O[SYMBOL] = function () { return 7; };
	    return ''[KEY](O) != 7;
	  });
	
	  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL ? !fails(function () {
	    // Symbol-named RegExp methods call .exec
	    var execCalled = false;
	    var re = /a/;
	    re.exec = function () { execCalled = true; return null; };
	    if (KEY === 'split') {
	      // RegExp[@@split] doesn't call the regex's exec method, but first creates
	      // a new one. We need to return the patched regex when creating the new one.
	      re.constructor = {};
	      re.constructor[SPECIES] = function () { return re; };
	    }
	    re[SYMBOL]('');
	    return !execCalled;
	  }) : undefined;
	
	  if (
	    !DELEGATES_TO_SYMBOL ||
	    !DELEGATES_TO_EXEC ||
	    (KEY === 'replace' && !REPLACE_SUPPORTS_NAMED_GROUPS) ||
	    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
	  ) {
	    var nativeRegExpMethod = /./[SYMBOL];
	    var fns = exec(
	      defined,
	      SYMBOL,
	      ''[KEY],
	      function maybeCallNative(nativeMethod, regexp, str, arg2, forceStringMethod) {
	        if (regexp.exec === regexpExec) {
	          if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
	            // The native String method already delegates to @@method (this
	            // polyfilled function), leasing to infinite recursion.
	            // We avoid it by directly calling the native @@method method.
	            return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
	          }
	          return { done: true, value: nativeMethod.call(str, regexp, arg2) };
	        }
	        return { done: false };
	      }
	    );
	    var strfn = fns[0];
	    var rxfn = fns[1];
	
	    redefine(String.prototype, KEY, strfn);
	    hide(RegExp.prototype, SYMBOL, length == 2
	      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
	      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
	      ? function (string, arg) { return rxfn.call(string, this, arg); }
	      // 21.2.5.6 RegExp.prototype[@@match](string)
	      // 21.2.5.9 RegExp.prototype[@@search](string)
	      : function (string) { return rxfn.call(string, this); }
	    );
	  }
	};


/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(44);
	module.exports = Array.isArray || function isArray(arg) {
	  return cof(arg) == 'Array';
	};


/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.2.8 IsRegExp(argument)
	var isObject = __webpack_require__(7);
	var cof = __webpack_require__(44);
	var MATCH = __webpack_require__(10)('match');
	module.exports = function (it) {
	  var isRegExp;
	  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
	};


/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

	var ITERATOR = __webpack_require__(10)('iterator');
	var SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function () { SAFE_CLOSING = true; };
	  // eslint-disable-next-line no-throw-literal
	  Array.from(riter, function () { throw 2; });
	} catch (e) { /* empty */ }
	
	module.exports = function (exec, skipClosing) {
	  if (!skipClosing && !SAFE_CLOSING) return false;
	  var safe = false;
	  try {
	    var arr = [7];
	    var iter = arr[ITERATOR]();
	    iter.next = function () { return { done: safe = true }; };
	    arr[ITERATOR] = function () { return iter; };
	    exec(arr);
	  } catch (e) { /* empty */ }
	  return safe;
	};


/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// Forced replacement prototype accessors methods
	module.exports = __webpack_require__(93) || !__webpack_require__(6)(function () {
	  var K = Math.random();
	  // In FF throws only define methods
	  // eslint-disable-next-line no-undef, no-useless-call
	  __defineSetter__.call(null, K, function () { /* empty */ });
	  delete __webpack_require__(5)[K];
	});


/***/ }),
/* 462 */
/***/ (function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var classof = __webpack_require__(201);
	var builtinExec = RegExp.prototype.exec;
	
	 // `RegExpExec` abstract operation
	// https://tc39.github.io/ecma262/#sec-regexpexec
	module.exports = function (R, S) {
	  var exec = R.exec;
	  if (typeof exec === 'function') {
	    var result = exec.call(R, S);
	    if (typeof result !== 'object') {
	      throw new TypeError('RegExp exec method returned something other than an Object or null');
	    }
	    return result;
	  }
	  if (classof(R) !== 'RegExp') {
	    throw new TypeError('RegExp#exec called on incompatible receiver');
	  }
	  return builtinExec.call(R, S);
	};


/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-setmap-offrom/
	var $export = __webpack_require__(3);
	var aFunction = __webpack_require__(23);
	var ctx = __webpack_require__(46);
	var forOf = __webpack_require__(135);
	
	module.exports = function (COLLECTION) {
	  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
	    var mapFn = arguments[1];
	    var mapping, A, n, cb;
	    aFunction(this);
	    mapping = mapFn !== undefined;
	    if (mapping) aFunction(mapFn);
	    if (source == undefined) return new this();
	    A = [];
	    if (mapping) {
	      n = 0;
	      cb = ctx(mapFn, arguments[2], 2);
	      forOf(source, false, function (nextItem) {
	        A.push(cb(nextItem, n++));
	      });
	    } else {
	      forOf(source, false, A.push, A);
	    }
	    return new this(A);
	  } });
	};


/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-setmap-offrom/
	var $export = __webpack_require__(3);
	
	module.exports = function (COLLECTION) {
	  $export($export.S, COLLECTION, { of: function of() {
	    var length = arguments.length;
	    var A = new Array(length);
	    while (length--) A[length] = arguments[length];
	    return new this(A);
	  } });
	};


/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(48);
	var defined = __webpack_require__(67);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(defined(that));
	    var i = toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};


/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(5);
	var hide = __webpack_require__(25);
	var uid = __webpack_require__(143);
	var TYPED = uid('typed_array');
	var VIEW = uid('view');
	var ABV = !!(global.ArrayBuffer && global.DataView);
	var CONSTR = ABV;
	var i = 0;
	var l = 9;
	var Typed;
	
	var TypedArrayConstructors = (
	  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
	).split(',');
	
	while (i < l) {
	  if (Typed = global[TypedArrayConstructors[i++]]) {
	    hide(Typed.prototype, TYPED, true);
	    hide(Typed.prototype, VIEW, true);
	  } else CONSTR = false;
	}
	
	module.exports = {
	  ABV: ABV,
	  CONSTR: CONSTR,
	  TYPED: TYPED,
	  VIEW: VIEW
	};


/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(5);
	var navigator = global.navigator;
	
	module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var lbLocationSelect = angular.module('app.lbLocationSelect', []);
	
	lbLocationSelect.controller('lbLocationSelectCtrl', __webpack_require__(1213));
	lbLocationSelect.component('lbLocationSelect', __webpack_require__(1212));
	
	exports['default'] = lbLocationSelect;
	module.exports = exports['default'];

/***/ }),
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = resolveDependencies;
	exports.resolveService = resolveService;
	
	function resolveDependencies(dependencyResolver) {
	  return ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
	    return $q(function (resolve) {
	      return dependencyResolver(function () {
	        for (var _len = arguments.length, dependencies = Array(_len), _key = 0; _key < _len; _key++) {
	          dependencies[_key] = arguments[_key];
	        }
	
	        return resolve($ocLazyLoad.inject(dependencies));
	      });
	    });
	  }];
	}
	
	function resolveService(name) {
	  for (var _len2 = arguments.length, dependencies = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	    dependencies[_key2 - 1] = arguments[_key2];
	  }
	
	  return ['$injector'].concat(dependencies, [function ($injector) {
	    return $injector.get(name);
	  }]);
	}

/***/ }),
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i]; return arr2; } else { return Array.from(arr); } }
	
	var $inject = ['$rootScope', '$q', '$http', 'moment', 'APP_CONFIG', 'locationService', 'apiService', 'ENUMS', 'locationsSearchService', 'dateTimeService', 'settingsService'];
	
	var itinerariesService = function itinerariesService($rootScope, $q, $http, moment, APP_CONFIG, locationService, apiService, ENUMS, locationsSearchService, dateTimeService, settingsService) {
	  var service = {
	    itinerary: undefined,
	    bookingCompleted: false,
	    get: get,
	    set: set,
	    lazyGet: lazyGet,
	    getItinerarySearch: getItinerarySearch,
	    save: save,
	    post: post,
	    find: find,
	    findOffline: findOffline,
	    findPnr: findPnr,
	    findPassenger: findPassenger,
	    reset: reset,
	    getCurrentSearch: getCurrentSearch,
	    getStayLength: getStayLength,
	    searchItineraries: searchItineraries,
	    approveItinerary: approveItinerary,
	    confirmItinerary: confirmItinerary, // LOBT-2525 Frontend - My Bookings Confirm booking on hold
	    declineItinerary: declineItinerary,
	    IataSearch: IataSearch,
	    locationSearch: locationSearch,
	    addItems: addItems,
	    updateSearch: updateSearch,
	    postSearch: postSearch,
	    getPolicyOptions: getPolicyOptions,
	    getTimePolicyOptions: getTimePolicyOptions,
	    getFlyAmericaPolicyOptions: getFlyAmericaPolicyOptions,
	    deleteSector: deleteSector,
	    groupPost: groupPost,
	    nextStage: nextStage,
	    totalPaxInCurrentSearch: totalPaxInCurrentSearch,
	    invalidSeatsForSector: invalidSeatsForSector,
	    isUsingRailCard: isUsingRailCard,
	    getLoyaltyPrograms: getLoyaltyPrograms,
	    getCarSupplierLocationsByCityCode: getCarSupplierLocationsByCityCode,
	    getCarSupplierLocations: getCarSupplierLocations,
	    getFareRules: getFareRules,
	    postMembership: postMembership,
	    postMemberships: postMemberships,
	    deleteMembership: deleteMembership,
	    getApprovers: getApprovers,
	    getCompanyReferences: getCompanyReferences,
	    getDepartments: getDepartments,
	    getCostCentres: getCostCentres,
	    putFlight: putFlight,
	    putFlights: putFlights,
	    putAncillary: putAncillary,
	    putRail: putRail,
	    computePaxFlightTotalAmount: computePaxFlightTotalAmount,
	    computePaxSectors: computePaxSectors,
	    deletePax: deletePax,
	    computeItinerary: computeItinerary,
	    getValidated: getValidated,
	    postModify: postModify,
	    postModifyCurrent: postModifyCurrent,
	    hotelPriceCheck: hotelPriceCheck,
	    getDates: getDates,
	    selectPickUpLocationByAirportCode: selectPickUpLocationByAirportCode,
	    getModifyHotel: getModifyHotel,
	    reeBookFailedHotel: reeBookFailedHotel,
	    getModifyCar: getModifyCar,
	    postRecentSearch: postRecentSearch,
	    intlMultiCityCheck: intlMultiCityCheck,
	    intlMultiCityCheckSegments: intlMultiCityCheckSegments,
	    repeatingCityCheckSegments: repeatingCityCheckSegments,
	    areSameCompanyReferences: areSameCompanyReferences,
	    setPrevNextMethods: setPrevNextMethods,
	    getModificationsSettings: getModificationsSettings
	  };
	
	  function getCurrentSearch() {
	    var currentSearchType = locationService.currentSearchType;
	    var currentSearchIndex = locationService.searchIndex[currentSearchType];
	    return service.itinerary.Search[currentSearchType + 's'][currentSearchIndex];
	  }
	
	  function getDates(options) {
	    if (shouldGetCarSearchDates(options)) {
	      return getCarSearchDates(options);
	    } else {
	      return getDefaultDates(options);
	    }
	  }
	
	  var shouldGetCarSearchDates = function shouldGetCarSearchDates(options) {
	    return options && options.searchType === ENUMS.itinerarySearchTypes.CAR_SEARCH && service.itinerary && service.itinerary.Flights && service.itinerary.Flights[0];
	  };
	
	  var getCarSearchDates = function getCarSearchDates(options) {
	    var flights = service.itinerary.Flights;
	    var arrivalDate = moment(flights[0].Arrival.Date, 'YYYY-MM-DD HH:mm:ss');
	    var pickUpDate = arrivalDate.format(options.dateFormat || 'll');
	    var pickUpTime = arrivalDate.format(options.timeFormat || 'h:mm a');
	    var dropOffDate = pickUpDate;
	    var dropOffTime = moment('5:00 PM', 'h:mm A').format(options.timeFormat || 'h:mm a');
	    if (flights[1]) {
	      var departureDate = moment(flights[1].Departure.Date, 'YYYY-MM-DD HH:mm:ss');
	      dropOffDate = departureDate.format(options.dateFormat || 'll');
	      dropOffTime = departureDate.format(options.timeFormat || 'h:mm a');
	    }
	    return {
	      pickUpDate: pickUpDate,
	      dropOffDate: dropOffDate,
	      pickUpTime: pickUpTime,
	      dropOffTime: dropOffTime
	    };
	  };
	
	  var getDefaultDates = function getDefaultDates(options) {
	    var pickUpTime = moment('9:00 AM', 'h:mm A').format(options.timeFormat || 'h:mm a');
	    var dropOffTime = moment('5:00 PM', 'h:mm A').format(options.timeFormat || 'h:mm a');
	    var pickUpDate = new Date();
	    var dropOffDate = new Date();
	    dropOffDate.setDate(pickUpDate.getDate() + 1);
	    if (service.itinerary && service.itinerary.sectors) {
	      var earliestSectorDate = service.itinerary.sectors[0].date;
	      pickUpDate = moment(earliestSectorDate).format(options.dateFormat || 'll');
	      dropOffDate = goForwardInTime(pickUpDate, 1, options.dateFormat || 'll');
	    }
	    return {
	      pickUpDate: pickUpDate,
	      dropOffDate: dropOffDate,
	      pickUpTime: pickUpTime,
	      dropOffTime: dropOffTime
	    };
	  };
	
	  function selectPickUpLocationByAirportCode() {
	    var airportCode = service.itinerary && service.itinerary.Flights && service.itinerary.Flights.length ? service.itinerary.Flights[0].Arrival.Code : '';
	    return locationsSearchService.get({ term: airportCode, maxRows: 10, searchTypes: 'Airport' }).then(function (searchResults) {
	      return _.find(searchResults, function (option) {
	        return option.Iata === airportCode;
	      });
	    });
	  }
	
	  function goForwardInTime(current, increaseBy, dateFormat) {
	    if (current) {
	      return moment(current, dateFormat).add(increaseBy, 'day').format(dateFormat);
	    } else {
	      return moment().add(increaseBy, 'day').format(dateFormat);
	    }
	  }
	
	  function getStayLength(hotelSearch) {
	    var checkinMoment = moment(hotelSearch.DateFrom);
	    var checkoutMoment = moment(hotelSearch.DateTo);
	
	    return checkoutMoment.diff(checkinMoment, 'days');
	  }
	
	  function getPolicyOptions() {
	    return getCurrentSearch().Policy;
	  }
	
	  function getFlyAmericaPolicyOptions() {
	    return getCurrentSearch().FlyAmericaActPolicies;
	  }
	
	  function getTimePolicyOptions() {
	    return getCurrentSearch().LessThanXDayPolicies;
	  }
	
	  // LOBT-2493 Prebooking seat javascript error
	  // strange problem, that only is thrown in Chrome, getCurrentSearch().Passengers is undefined
	  // when the app navigates to the seat selection page
	  function totalPaxInCurrentSearch() {
	    var currentSearch = getCurrentSearch();
	
	    // we can just default the passenger length to 1, but outside of this function, some maths are applied
	    // it's the passenger count * item amount for the segment, giving a total amount, which is a problem if we default to 1
	    // when booking the flight, the total amount is correct, so don't know if it's just a red herring in js
	    // also verifed that when you have a guest traveler, the dollar amount is correct for the two travelers
	    return currentSearch !== undefined ? currentSearch.Passengers.filter(function (p) {
	      return !p.IsLapChild || p.IsLapChild === false;
	    }).length : 1;
	  }
	
	  function updateSearch(searchType, searchIndex, search) {
	    if (Number.isInteger(searchIndex)) {
	      if (searchType === 'Cars' || searchType === 'Hotels' || searchType === 'GroundTransports') {
	        service.itinerary.Search[searchType][searchIndex] = search;
	      } else {
	        _.merge(service.itinerary.Search[searchType][searchIndex], search);
	      }
	    } else if (_.isArray(search)) {
	      _.forEach(search, function (newSearch, searchIndex) {
	        _.merge(service.itinerary.Search[searchType][searchIndex], newSearch);
	      });
	    }
	
	    set(service.itinerary);
	
	    return service.itinerary.Search;
	  }
	
	  function postSearch(updatedSearch) {
	    var deferred = $q.defer();
	
	    $http.post(APP_CONFIG.api.url + 'Itinerary/' + service.itinerary.Identifier + '/search', updatedSearch).success(function (search) {
	      service.itinerary.Search = search;
	      deferred.resolve(search);
	    }).error(function () {
	      deferred.reject();
	    });
	
	    return deferred.promise;
	  }
	
	  function getItinerarySearch(itineraryId) {
	    return service.lazyGet(itineraryId).then(function (itinerary) {
	      return itinerary.Search;
	    });
	  }
	
	  function set(itinerary, selectedItems) {
	    service.itinerary = Array.isArray(itinerary) ? itinerary[0] : itinerary;
	    if (selectedItems && itinerary && itinerary.Search && itinerary.Search.Flights && itinerary.Search.Flights.length === selectedItems.length) {
	      selectedItems.forEach(function (item, index) {
	        if (item && item.Flight) {
	          itinerary.Search.Flights[index].anchoredFlight = item.Flight.Identifier;
	        }
	      });
	    }
	    sessionStorage.setItem('itineraryId', service.itinerary.Identifier);
	  }
	
	  function get(itineraryId) {
	    if (!itineraryId) {
	      itineraryId = getSessionItineraryId();
	    }
	
	    return fetchItinerary(itineraryId).then(function (itinerary) {
	      service.set(itinerary, false);
	      return itinerary;
	    });
	  }
	  function getValidated(itineraryId, clearCache) {
	    if (!itineraryId) {
	      itineraryId = getSessionItineraryId();
	    }
	
	    return fetchItineraryValidated(itineraryId, clearCache).then(function (itinerary) {
	      service.set(itinerary, false);
	      return itinerary;
	    });
	  }
	
	  function lazyGet(itineraryId) {
	    if (!itineraryId) {
	      itineraryId = getSessionItineraryId();
	      if (!itineraryId) {
	        return $q.reject(new Error('No Itinerary'));
	      }
	      if (service.itinerary && service.itinerary.Identifier === itineraryId) {
	        return $q.resolve(service.itinerary);
	      }
	    }
	
	    return fetchItinerary(itineraryId).then(function (itinerary) {
	      service.set(itinerary);
	      return itinerary;
	    });
	  }
	
	  function getSessionItineraryId() {
	    return sessionStorage.getItem('itineraryId') || window.itineraryId;
	  }
	
	  function fetchItinerary(itineraryId) {
	    var apiUrl = apiService.getUrl('itinerary', {
	      itineraryId: itineraryId
	    });
	
	    return $http.get(apiUrl, {}).then(function (_ref) {
	      var data = _ref.data;
	
	      if (!data) {
	        throw new Error('No Itinerary');
	      }
	      var itineraryData = _.isArray(data) ? data[0] : data;
	      return itineraryData;
	    });
	  }
	  function fetchItineraryValidated(itineraryId, clearCache) {
	    var apiUrl = apiService.getUrl('itinerary', {
	      itineraryId: itineraryId
	    });
	
	    return $http.get(apiUrl + ('/validate?clearCache=' + clearCache), {}).then(function (_ref2) {
	      var data = _ref2.data;
	
	      if (!data) {
	        throw new Error('No Itinerary');
	      }
	      var itineraryData = _.isArray(data) ? data[0] : data;
	      return itineraryData;
	    });
	  }
	
	  function searchItineraries(params) {
	    var deferred = $q.defer();
	
	    $http.get(APP_CONFIG.api.itinerary, {
	      params: params
	    }).success(function (data) {
	      deferred.resolve(data);
	    }).error(function () {
	      deferred.reject();
	    });
	
	    return deferred.promise;
	  }
	
	  function post(data, id, skipNext, selectedItems) {
	    var deferred = $q.defer();
	
	    var url = id ? '' + APP_CONFIG.api.itinerary + id : APP_CONFIG.api.itinerary;
	
	    $http.post(url, data).success(function (data) {
	      service.set(data, selectedItems);
	      if (!skipNext) {
	        nextStage(selectedItems);
	      } else {
	        deferred.resolve(data);
	      }
	    }).error(function () {
	      deferred.reject();
	    });
	
	    return deferred.promise;
	  }
	  function postRecentSearch(data, id, skipNext) {
	    var deferred = $q.defer();
	
	    var url = APP_CONFIG.api.itinerary + 'RecentSearch/' + id;
	
	    $http.post(url, data).success(function (data) {
	      service.set(data);
	      if (!skipNext) {
	        nextStage();
	      } else {
	        deferred.resolve(data);
	      }
	    }).error(function () {
	      deferred.reject();
	    });
	
	    return deferred.promise;
	  }
	
	  function reeBookFailedHotel(itineraryIdentifier, passenger) {
	    var deferred = $q.defer();
	
	    $http.post(APP_CONFIG.api.url + 'Itinerary/' + itineraryIdentifier + '/rebook', passenger).then(function (response) {
	      service.set(response.data);
	      deferred.resolve(response.data);
	    })['catch'](function (error) {
	      deferred.reject(error);
	    });
	
	    return deferred.promise;
	  }
	
	  function postModify(passengerId, ignorePending, modifyData) {
	    var deferred = $q.defer();
	
	    $http.post(APP_CONFIG.api.url + 'Itinerary/modify/' + passengerId + '/' + ignorePending, modifyData).success(function (data) {
	      service.set(data);
	      deferred.resolve(data);
	    }).error(function () {
	      deferred.reject();
	    });
	
	    return deferred.promise;
	  }
	
	  function postModifyCurrent(passengerId, modifyData) {
	    var deferred = $q.defer();
	
	    $http.post(APP_CONFIG.api.url + 'Itinerary/modify-current/' + passengerId, modifyData).success(function (data) {
	      service.set(data);
	      deferred.resolve(data);
	    }).error(function () {
	      deferred.reject();
	    });
	
	    return deferred.promise;
	  }
	
	  function save(data, id) {
	    var deferred = $q.defer();
	
	    var url = '' + APP_CONFIG.api.itinerary + id;
	
	    $http.put(url, data).success(function (data) {
	      deferred.resolve(data);
	    }).error(function () {
	      deferred.reject();
	    });
	
	    return deferred.promise;
	  }
	
	  function find(itineraryId, passengerId, pcc) {
	    var deferred = $q.defer();
	
	    $http.get('' + APP_CONFIG.api.itinerary + itineraryId + '/Passenger/' + passengerId + '/' + pcc, {}).success(function (data) {
	      service.set(data);
	      deferred.resolve(data);
	    }).error(function () {
	      deferred.reject();
	    });
	
	    return deferred.promise;
	  }
	
	  function findPnr(pnr, livePnrData) {
	    var deferred = $q.defer();
	    $http.get(APP_CONFIG.api.itinerary + 'passenger-booking/' + pnr + (livePnrData === true ? '?livePnrData=true' : ''), {}).then(function (_ref3) {
	      var data = _ref3.data;
	
	      service.set(data.Passenger);
	      if (data.Passenger && data.Modifications) {
	        service.itinerary.Modifications = data.Modifications;
	      }
	      deferred.resolve(data);
	    }, function (error) {
	      deferred.reject(error);
	    });
	    return deferred.promise;
	  }
	  function findPassenger(passengerId, livePnrData) {
	    var deferred = $q.defer();
	    $http.get(APP_CONFIG.api.itinerary + 'passenger-booking/' + passengerId + (livePnrData === true ? '?livePnrData=true' : ''), {}).then(function (_ref4) {
	      var data = _ref4.data;
	
	      service.set(data.Passenger);
	      if (data.Passenger && data.Modifications) {
	        service.itinerary.Modifications = data.Modifications;
	      }
	      deferred.resolve(data);
	    }, function (error) {
	      deferred.reject(error);
	    });
	    return deferred.promise;
	  }
	
	  function findOffline(pnr, pcc) {
	    var deferred = $q.defer();
	
	    $http.get(APP_CONFIG.api.itinerary + 'Passenger/' + pnr + '/' + pcc, {}).success(function (data) {
	      service.set(data);
	      deferred.resolve(data);
	    }).error(function () {
	      deferred.reject();
	    });
	
	    return deferred.promise;
	  }
	
	  function reset() {
	    sessionStorage.removeItem('itineraryId');
	    service.itinerary = {};
	  }
	
	  function approveItinerary(itineraryParams) {
	    return $http.post(buildQuery(itineraryParams) + '/approve');
	  }
	
	  // LOBT-2525 Frontend - My Bookings Confirm booking on hold
	  function confirmItinerary(itineraryId, passengerId) {
	    return $http.put(APP_CONFIG.api.url + 'itinerary/' + itineraryId + '/passenger/' + passengerId + '/confirm');
	  }
	  // LOBT-2525 Frontend - My Bookings Confirm booking on hold
	
	  function declineItinerary(itineraryParams, reason) {
	    var wrappedReason = '"' + reason + '"';
	    return $http.post(buildQuery(itineraryParams) + '/decline', wrappedReason, {
	      headers: {
	        'Content-Type': 'application/json'
	      }
	    });
	  }
	
	  function getFareRules(params) {
	    var deferred = $q.defer();
	
	    $http.get(APP_CONFIG.api.url + 'itinerary/' + params.itineraryId + '/passenger/' + params.passengerId + '/' + params.sectorType + '/' + params.sectorId + '/farerules').success(function (data) {
	      deferred.resolve(data);
	    }).error(function () {
	      deferred.reject();
	    });
	
	    return deferred.promise;
	  }
	
	  function IataSearch(params) {
	    var deferred = $q.defer();
	
	    $http.get('http://localhost:3004/iata', {
	      params: params
	    }).success(function (data) {
	      deferred.resolve(data);
	    }).error(function () {
	      deferred.reject();
	    });
	
	    return deferred.promise;
	  }
	
	  function locationSearch(params) {
	    var deferred = $q.defer();
	
	    $http.get('' + APP_CONFIG.api.url + params.type + '/locations/' + params.maxRows + '/' + params.term, {
	      desc: 'retrieving Airport locations from the server'
	    }).success(function (data) {
	      deferred.resolve(data);
	    }).error(function () {
	      deferred.reject();
	    });
	
	    return deferred.promise;
	  }
	
	  function buildQuery(params) {
	    return APP_CONFIG.api.url + 'Approval/' + params.itineraryId + '/' + params.passengerId + '/' + params.approverId;
	  }
	
	  function groupPost(id, items, type) {
	    var searchIndexKey = undefined;
	    var searchIndexIncrement = 1;
	
	    switch (type) {
	      case 'Hotels':
	        searchIndexKey = 'Hotel';
	
	        break;
	
	      case 'Flights':
	        searchIndexKey = 'Flight';
	
	        searchIndexIncrement = service.itinerary.Search.Flights.length;
	
	        break;
	
	      case 'Rails':
	        searchIndexKey = 'Rail';
	
	        searchIndexIncrement = service.itinerary.Search.Rails.length;
	
	        break;
	
	      case 'Cars':
	        searchIndexKey = 'Car';
	
	        break;
	      case 'GroundTrans':
	        searchIndexKey = 'Ground';
	
	        break;
	
	      default:
	        console.warn('No postType supplied');
	    }
	    // TODO switch if type is GroundTransports
	    return $http.post(APP_CONFIG.api.url + 'Itinerary/' + id + '/passenger', items).then(function (_ref5) {
	      var passengers = _ref5.data;
	
	      if (searchIndexKey === 'Flight' && service.itinerary.Search.Flights.length === 2 && service.itinerary.Search.Cars.length > 0) {
	        return service.get(service.itinerary.Id);
	      } else {
	        service.itinerary.Passengers = passengers;
	      }
	    }).then(function () {
	      return locationService.increaseSearchIndex(searchIndexKey, searchIndexIncrement);
	    });
	  }
	
	  function hotelPriceCheck(request) {
	    return $http.post(APP_CONFIG.api.url + 'Hotel/PriceCheck', request);
	  }
	
	  function deleteSector(itineraryId, passengerId, sectorId, sectorType) {
	    var postType = undefined;
	
	    switch (sectorType) {
	      case 'Flights':
	        postType = 'flight';
	        break;
	      case 'Hotels':
	        postType = 'hotel';
	        break;
	      case 'Rails':
	        postType = 'rail';
	        break;
	      case 'Cars':
	        postType = 'car';
	        break;
	      case 'GroundTransports':
	        postType = 'ground';
	        break;
	      default:
	        console.warn('No postType supplied');
	    }
	
	    var deferred = $q.defer();
	
	    $http['delete'](APP_CONFIG.api.url + 'Itinerary/' + itineraryId + '/passenger/' + passengerId + '/' + postType + '/' + sectorId).success(function () {
	      service.get(itineraryId).then(function () {
	        deferred.resolve();
	      });
	    }).error(function () {
	      deferred.reject();
	    });
	
	    return deferred.promise;
	  }
	
	  function addItems(items, type) {
	    var passengers = service.itinerary.Passengers;
	
	    angular.forEach(service.itinerary.Search.Passengers, function (passenger) {
	      var id = passenger.Identifier;
	      var targetPassenger = _.find(passengers, function (o) {
	        return o.Identifier === id;
	      });
	
	      targetPassenger[type] = _.concat(targetPassenger[type], items);
	    });
	
	    return {
	      itineraryId: service.itinerary.Identifier,
	      items: items,
	      type: type
	    };
	  }
	
	  function nextStage(selectedItems) {
	    locationService.nextPage(service.itinerary.Search, selectedItems);
	  }
	
	  function invalidSeatsForSector(sector) {
	    var invalidSeats = [];
	
	    if (sector.Seat && sector.Seat.Status === 'Failed') {
	      invalidSeats.push(sector.Seat);
	    }
	
	    _.forEach(sector.Stops, function (stop) {
	      if (stop.Seat.Status === 'Failed') {
	        invalidSeats.push(stop.Seat);
	      }
	    });
	
	    return invalidSeats;
	  }
	
	  function isUsingRailCard() {
	    return service.itinerary && service.itinerary.Search && _.some(service.itinerary.Search.Rails, function (railSearch) {
	      return railSearch.RailCardCode;
	    });
	  }
	
	  function getLoyaltyPrograms(query, code, sectorType) {
	    var deferred = $q.defer();
	
	    $http.get(APP_CONFIG.api.loyaltyPrograms, {
	      params: { q: query, code: code, sectorType: sectorType }
	    }).success(function (data) {
	      if (data) {
	        var mappedData = data.map(function (data) {
	          data.TypeTitleValue = data.Type + ':' + data.Title + ':' + data.Value;
	          return data;
	        });
	        deferred.resolve(mappedData);
	      } else {
	        deferred.reject();
	      }
	    }).error(function () {
	      deferred.reject();
	    });
	
	    return deferred.promise;
	  }
	
	  function getCarSupplierLocationsByCityCode(cityCode) {
	    var path = 'api/Car/depots?citycode=' + cityCode;
	    return $http.get(APP_CONFIG.api.root + path);
	  }
	  function getCarSupplierLocations(latitude, longitude) {
	    var path = 'api/Car/depots?latitude=' + latitude + '&longitude=' + longitude;
	    return $http.get(APP_CONFIG.api.root + path);
	  }
	
	  function postMembership(traveler, membership) {
	    return $http.post(APP_CONFIG.api.root + 'api/itinerary/' + traveler.ItineraryIdentifier + '/passenger/' + traveler.Identifier + '/membership', membership);
	  }
	
	  function postMemberships(traveler, memberships) {
	    return $http.post(APP_CONFIG.api.root + 'api/itinerary/' + traveler.ItineraryIdentifier + '/passenger/' + traveler.Identifier + '/memberships', memberships);
	  }
	
	  function deleteMembership(traveler, membership) {
	    var data = {};
	    angular.copy(membership, data);
	    delete data.traveler;
	    delete data.requestDelete;
	    return $http({
	      method: 'DELETE',
	      url: APP_CONFIG.api.root + 'api/itinerary/' + traveler.ItineraryIdentifier + '/passenger/' + traveler.Identifier + '/membership',
	      data: data
	    });
	  }
	
	  function getApprovers(itineraryId) {
	    var deferred = $q.defer();
	
	    var path = 'api/itinerary/' + itineraryId + '/approvers/';
	    $http.get(APP_CONFIG.api.root + path).success(function (data) {
	      if (data) {
	        var approvers = data.map(function (approver) {
	          approver.fullName = approver.FirstName + ' ' + approver.LastName;
	          return approver;
	        });
	        deferred.resolve(approvers);
	      } else {
	        deferred.reject();
	      }
	    });
	
	    return deferred.promise;
	  }
	
	  function getCompanyReferences(itineraryId) {
	    var deferred = $q.defer();
	
	    var path = 'api/itinerary/' + itineraryId + '/CompanyReference/';
	    $http.get(APP_CONFIG.api.root + path).success(function (data) {
	      if (data) {
	        deferred.resolve(data);
	      } else {
	        deferred.reject();
	      }
	    });
	
	    return deferred.promise;
	  }
	
	  function getDepartments(itineraryId) {
	    var deferred = $q.defer();
	
	    var path = 'api/itinerary/' + itineraryId + '/Department/';
	    $http.get(APP_CONFIG.api.root + path).success(function (data) {
	      if (data) {
	        deferred.resolve(data);
	      } else {
	        deferred.reject();
	      }
	    });
	
	    return deferred.promise;
	  }
	
	  function getCostCentres(itineraryId) {
	    var deferred = $q.defer();
	
	    var path = 'api/itinerary/' + itineraryId + '/CostCentre/';
	    $http.get(APP_CONFIG.api.root + path).success(function (data) {
	      if (data) {
	        deferred.resolve(data);
	      } else {
	        deferred.reject();
	      }
	    });
	
	    return deferred.promise;
	  }
	
	  function putFlight(itineraryId, paxId, flightSectorId, flightSector) {
	    var deferred = $q.defer();
	
	    $http.put(APP_CONFIG.api.url + 'Itinerary/' + itineraryId + '/Passenger/' + paxId + '/Flight/' + flightSectorId, flightSector).success(function (response) {
	      deferred.resolve(response);
	    }).error(function () {
	      deferred.reject();
	    });
	
	    return deferred.promise;
	  }
	
	  function putFlights(flightRequests) {
	    var deferred = $q.defer();
	
	    $http.put(APP_CONFIG.api.url + 'Itinerary/PutPassengerFlights', flightRequests).success(function (response) {
	      deferred.resolve(response);
	    }).error(function () {
	      deferred.reject();
	    });
	
	    return deferred.promise;
	  }
	  function putAncillary(itineraryId, paxId, flightSectorId, flightSector) {
	    var deferred = $q.defer();
	
	    $http.put(APP_CONFIG.api.url + 'Itinerary/' + itineraryId + '/Passenger/' + paxId + '/Flight/' + flightSectorId + '/ancillary', flightSector).success(function (response) {
	      deferred.resolve(response);
	    }).error(function () {
	      deferred.reject();
	    });
	
	    return deferred.promise;
	  }
	
	  function putRail(itineraryId, paxId, railSectorId, railSector) {
	    var deferred = $q.defer();
	
	    $http.put(APP_CONFIG.api.url + 'Itinerary/' + itineraryId + '/Passenger/' + paxId + '/Rail/' + railSectorId, railSector).success(function (response) {
	      deferred.resolve(response);
	    }).error(function () {
	      deferred.reject();
	    });
	
	    return deferred.promise;
	  }
	
	  function computeCarbonEmissions(flight) {
	    if (flight.CarbonEmissions) {
	      flight.totalCarbonEmissions = flight.CarbonEmissions;
	      if (flight.Stops) {
	        flight.totalCarbonEmissions += _.sumBy(flight.Stops, function (stop) {
	          return stop.CarbonEmissions ? stop.CarbonEmissions : 0;
	        });
	      }
	    }
	    return flight;
	  }
	
	  function computeBaggageOptions(flight) {
	    var baggage = [];
	    var ancillaryService = flight.AncillaryServices;
	
	    for (var i = 0; i < ancillaryService.length; i++) {
	      if (ancillaryService[i].Type === 'Baggage') {
	        baggage.push(ancillaryService[i]);
	      }
	    }
	
	    flight.baggageOptions = baggage.length > 0 ? [{ Description: 'No baggage required', Code: 'empty' }].concat(baggage) : baggage;
	    return flight;
	  }
	
	  function computeSelectedBaggage(flight) {
	    var baggage = null;
	    var ancillaryServices = flight.AncillaryServices;
	
	    _.forEach(ancillaryServices, function (ancillaryService) {
	      if (ancillaryService.Type === 'Baggage' && ancillaryService.QuantitySelected > 0) baggage = ancillaryService;
	    });
	
	    baggage = baggage || {
	      Description: 'Select Additional Baggage',
	      Code: 'empty'
	    };
	
	    flight.selectedBaggage = baggage;
	    flight.cachedBaggage = flight.selectedBaggage;
	    return flight;
	  }
	
	  function computeTravelServiceOptions(flight) {
	    var travelService = [];
	    var ancillaryService = flight.AncillaryServices;
	
	    for (var i = 0; i < ancillaryService.length; i++) {
	      if (ancillaryService[i].Type === 'TravelService') {
	        travelService.push(ancillaryService[i]);
	      }
	    }
	
	    flight.TravelServiceOptions = travelService.length > 0 ? [{ Description: 'No Travel service required', Code: 'empty' }].concat(travelService) : travelService;
	    return flight;
	  }
	
	  function computeSelectedTravelService(flight) {
	    var travelService = null;
	
	    var ancillaryServices = flight.AncillaryServices;
	    _.forEach(ancillaryServices, function (ancillaryService) {
	      if (ancillaryService.Type === 'TravelService' && ancillaryService.QuantitySelected > 0) {
	        travelService = ancillaryService;
	      }
	    });
	
	    travelService = travelService || {
	      Description: 'Select Travel Service',
	      Code: 'empty'
	    };
	
	    flight.selectedTravelService = travelService;
	    flight.cachedTravelService = flight.selectedTravelService;
	    return flight;
	  }
	
	  function computeSeatOptions(flight) {
	    var ancillaryServices = flight.AncillaryServices;
	    var stops = flight.Stops;
	    var flights = [];
	
	    var fullFlight = flight;
	    var totalStops = stops.length;
	
	    var seats = _.filter(ancillaryServices, function (service) {
	      return service.Type === 'Seat';
	    });
	
	    var prevLocationCode = totalStops ? stops[0].ArrivalCode : fullFlight.Arrival.Code;
	
	    if (seats.length) {
	      flights.push({
	        Flight: {
	          Origin: fullFlight.Departure.Code,
	          Destination: prevLocationCode,
	          TravelIdentifier: generateId(fullFlight.FlightIdentifier, 0)
	        },
	        Seats: seats
	      });
	    }
	
	    _.forEach(stops, function (stop, stopIndex) {
	      var stopSeats = _.filter(stop.AncillaryServices, function (service) {
	        return service.Type === 'Seat';
	      });
	
	      if (stopSeats.length) {
	        var isLastStop = stopIndex === totalStops - 1;
	        var nextLocationCode = isLastStop ? fullFlight.Arrival.Code : stops[totalStops - 1].ArrivalCode;
	
	        flights.push({
	          Flight: {
	            Origin: prevLocationCode,
	            Destination: nextLocationCode,
	            TravelIdentifier: generateId(stop.FlightIdentifier, stopIndex + 1)
	          },
	          Seats: stopSeats
	        });
	      }
	    });
	
	    function generateId(flightId, flightIndex) {
	      return fullFlight.PassengerIdentifier + flightIndex + flightId;
	    }
	
	    flight.seatOptions = flights;
	    return flight;
	  }
	
	  function computeSeatPreferences(rail) {
	    var seatPreferenceTypes = ENUMS.railSeatPreferenceTypes;
	
	    rail.SeatPreferences = {};
	
	    _.forIn(seatPreferenceTypes, function (preferenceType) {
	      rail.SeatPreferences[preferenceType] = _.filter(rail.AncillaryServices, function (service) {
	        return service.Type === preferenceType;
	      });
	
	      rail.SeatPreferences[preferenceType] = _.orderBy(rail.SeatPreferences[preferenceType], function (service) {
	        return service.Code === 'No Preference' ? 0 : 1;
	      });
	    });
	
	    return rail;
	  }
	
	  function computeSeatsTotalAmount(flight) {
	    flight.seatsTotalAmount = _.reduce(flight.seatOptions, function (total, options) {
	      var selectedSeat = _.find(options.Seats, function (seat) {
	        return seat.QuantitySelected === 1;
	      });
	
	      return total + (selectedSeat ? selectedSeat.Amount : 0);
	    }, 0);
	
	    if (!!!flight.seatsTotalAmount) {
	      var seatAmountCollection = flight.Stops.map(function (stop) {
	        return stop.Seat.SeatAmount;
	      });
	      seatAmountCollection.push(0);
	      flight.seatsTotalAmount = flight.Seat.SeatAmount + seatAmountCollection.reduce(function (a, b) {
	        return a + b;
	      });
	    }
	
	    if (!!!flight.seatsTotalAmount && !!flight.Seat.SeatNumber) {
	      flight.seatsTotalAmount = flight.Seat.SeatAmount;
	    }
	
	    return flight;
	  }
	
	  function computeFlightTotalAmount(flight) {
	    var ancillaryServices = flight.AncillaryServices;
	    var feeAmount = flight.FeeAmount;
	    var amount = flight.Amount;
	    var stops = flight.Stops;
	    var seatsTotalAmount = flight.seatsTotalAmount;
	    var originalTicketAmount = flight.OriginalTicketAmount;
	    var flightTotalAmount = 0;
	
	    _.forEach(ancillaryServices, function (service) {
	      flightTotalAmount += service.QuantitySelected * service.Amount;
	    });
	
	    _.forEach(stops, function (stop) {
	      _.forEach(stop.AncillaryServices, function (service) {
	        flightTotalAmount += service.QuantitySelected * service.Amount;
	      });
	    });
	
	    flight.flightBaseAmount = flightTotalAmount + amount + feeAmount;
	    flight.flightTotalAmount = flight.flightBaseAmount + seatsTotalAmount;
	    return flight;
	  }
	
	  function computeFlightSector(sector) {
	    return _.flowRight(computeFlightTotalAmount, computeSeatsTotalAmount, computeSeatOptions, computeSelectedBaggage, computeBaggageOptions, computeCarbonEmissions, computeTravelServiceOptions, computeSelectedTravelService)(sector);
	  }
	
	  function computePaxFlightTotalAmount(pax) {
	    var CreditsUsed = 0;
	    var flights = pax.Flights;
	
	    _.forEach(flights, function (flight) {
	      CreditsUsed += flight.CreditsUsed;
	    });
	
	    return CreditsUsed;
	  }
	
	  function computePaxSectors(pax) {
	    var flights = pax.Flights;
	    var rails = pax.Rails;
	    var hotels = pax.Hotels;
	    var cars = pax.Cars;
	    var grounds = pax.GroundTransports;
	
	    var noTimezoneDateFormat = 'YYYY-MM-DDTHH:mm';
	    var sortingDateFormat = 'YYYYMMDDHHmm';
	    var groupingDateFormat = 'YYYYMMDD';
	    var groupingDateDisplayFormat = dateTimeService.getFormat(ENUMS.dateTimeFormats.DATE_MEDIUM);
	
	    var sectorsArray = [].concat(flights || [], rails || [], hotels || [], cars || [], grounds || []);
	
	    for (var x = 0; x < sectorsArray.length; x++) {
	      var parsedDate = null;
	
	      try {
	        if (sectorsArray[x].Departure && sectorsArray[x].Departure.Date) {
	          parsedDate = moment(sectorsArray[x].Departure.Date, noTimezoneDateFormat);
	        } else if (sectorsArray[x].DateFrom) {
	          parsedDate = moment(sectorsArray[x].DateFrom, noTimezoneDateFormat);
	        } else if (sectorsArray[x].PickUp && sectorsArray[x].PickUp.Date) {
	          parsedDate = moment(sectorsArray[x].PickUp.Date, noTimezoneDateFormat);
	        } else if (sectorsArray[x].StartDateTime) {
	          parsedDate = moment(sectorsArray[x].StartDateTime);
	        }
	      } catch (err) {}
	
	      sectorsArray[x].groupByDate = parsedDate ? parsedDate.format(sortingDateFormat) : null;
	    }
	
	    sectorsArray.sort(function (sectorA, sectorB) {
	      return sectorA.groupByDate > sectorB.groupByDate ? 1 : -1;
	    });
	
	    var groupByDateString = null;
	    var groupId = 0;
	    var unorderedSectors = [];
	
	    for (var y = 0; y < sectorsArray.length; y++) {
	      var groupByDate = sectorsArray[y].groupByDate;
	      var trimmedGroupByDate = null;
	      var groupCopy = {};
	
	      if (groupByDate) {
	        trimmedGroupByDate = groupByDate.substring(0, groupByDate.length - 4);
	      }
	
	      if (trimmedGroupByDate && groupByDateString !== trimmedGroupByDate) {
	        groupId++;
	        groupByDateString = trimmedGroupByDate;
	        sectorsArray[y].groupByDateString = moment(groupByDateString, groupingDateFormat).format(groupingDateDisplayFormat);
	      }
	
	      groupCopy = sectorsArray[y];
	      groupCopy.groupId = groupId;
	      unorderedSectors.push(groupCopy);
	    }
	
	    var matchGroupIds = function matchGroupIds(array) {
	      var x = [];
	      angular.forEach(array, function (obj) {
	        x.push(obj.groupId);
	      });
	      return x;
	    };
	
	    var onlyUnique = function onlyUnique(value, index, self) {
	      return self.indexOf(value) === index;
	    };
	
	    var spiltArray = function spiltArray(array, argumentArray) {
	      var result = [];
	      var argumentIndex = 0;
	      angular.forEach(array, function (obj) {
	        if (obj.groupId !== argumentArray[argumentIndex]) {
	          argumentIndex++;
	        }
	        if (!result[argumentIndex]) {
	          result[argumentIndex] = [obj];
	        } else {
	          result[argumentIndex].push(obj);
	        }
	      });
	      return result;
	    };
	
	    var reorderParentChild = function reorderParentChild(parent) {
	      var ParentReordered = [];
	
	      angular.forEach(parent, function (obj) {
	        var flights = pluckNamedObjectFromArray(obj, 'Flight');
	        var rails = pluckNamedObjectFromArray(obj, 'Rail');
	        var hotels = pluckNamedObjectFromArray(obj, 'Hotel');
	        var cars = pluckNamedObjectFromArray(obj, 'Car');
	        var grounds = pluckNamedObjectFromArray(obj, 'Ground');
	        var childReordered = flights.concat(rails, hotels, cars, grounds);
	        ParentReordered.push(childReordered);
	      });
	
	      return ParentReordered;
	    };
	
	    var pluckNamedObjectFromArray = function pluckNamedObjectFromArray(array, match) {
	      var matches = [];
	      angular.forEach(array, function (obj) {
	        if (match === 'Flight' && obj.Carrier && !obj.RailNumber) {
	          matches.push(obj);
	        }
	        if (match === 'Rail' && obj.RailNumber) {
	          matches.push(obj);
	        }
	        if (match === 'Hotel' && obj.HotelName) {
	          matches.push(obj);
	        }
	        if (match === 'Car' && obj.PickUp) {
	          matches.push(obj);
	        }
	        if (match === 'Ground' && obj.StartDateTime) {
	          matches.push(obj);
	        }
	      });
	      return matches;
	    };
	
	    var moveAttributeToIndex = function moveAttributeToIndex(array, attr) {
	      var val = '';
	
	      angular.forEach(array, function (childArray, key) {
	        angular.forEach(childArray, function (obj, index) {
	          if (obj[attr]) {
	            val = obj[attr];
	            delete array[key][index][attr];
	          }
	          array[key][0][attr] = val;
	        });
	      });
	
	      return array;
	    };
	
	    var groupsToOrder = matchGroupIds(unorderedSectors);
	    var uniqueGroups = groupsToOrder.filter(onlyUnique);
	    var groupByDay = spiltArray(unorderedSectors, uniqueGroups);
	    var reorderSectorsInDay = reorderParentChild(groupByDay);
	    var moveGroupDate = moveAttributeToIndex(reorderSectorsInDay, 'groupByDateString');
	
	    pax.Sectors = [].concat.apply([], moveGroupDate);
	    return pax;
	  }
	
	  function computePaxFlightTotal(pax) {
	    var flights = pax.Flights;
	    var flightTotal = 0;
	    var flightBaseTotal = 0;
	
	    _.forEach(flights, function (flight) {
	      // flightTotal += flight.TotalAmount;
	      flightTotal += flight.flightTotalAmount;
	      flightBaseTotal += flight.flightBaseAmount;
	    });
	
	    pax.FlightTotal = flightTotal;
	    pax.FlightBaseTotal = flightBaseTotal;
	    return pax;
	  }
	
	  function computePaxRailTotal(pax) {
	    var rails = pax.Rails;
	    var railTotal = 0;
	
	    _.forEach(rails, function (rail) {
	      railTotal += rail.TotalAmount;
	    });
	
	    pax.RailTotal = railTotal;
	    return pax;
	  }
	
	  function computePaxHotelTotal(pax) {
	    var hotels = pax.Hotels;
	    var hotelTotal = 0;
	
	    _.forEach(hotels, function (hotel) {
	      hotelTotal += hotel.TotalAmount;
	    });
	
	    pax.HotelTotal = hotelTotal;
	    return pax;
	  }
	
	  function computePaxCarTotal(pax) {
	    var cars = pax.Cars;
	    var carTotal = 0;
	
	    _.forEach(cars, function (car) {
	      carTotal += car.TotalAmount;
	    });
	
	    pax.CarTotal = carTotal;
	    return pax;
	  }
	  function computePaxGroundTotal(pax) {
	    var grounds = pax.GroundTransports;
	    var groundTotal = 0;
	
	    _.forEach(grounds, function (ground) {
	      groundTotal += ground.TotalAmount;
	    });
	
	    pax.groundTotal = groundTotal;
	    return pax;
	  }
	  function computePaxAmount(pax) {
	    var flightTotal = pax.FlightTotal;
	    var RailTotal = pax.RailTotal;
	    var hotelTotal = pax.HotelTotal;
	    var carTotal = pax.CarTotal;
	    var groundTotal = pax.groundTotal;
	
	    pax.BaseAmount = Number(pax.FlightBaseTotal) + Number(RailTotal) + Number(hotelTotal) + Number(carTotal) + Number(groundTotal);
	    pax.Amount = Number(flightTotal) + Number(RailTotal) + Number(hotelTotal) + Number(carTotal) + Number(groundTotal);
	
	    return pax;
	  }
	
	  function computePaxFlightLostSavingsTotal(pax) {
	    var flights = pax.Flights;
	    var lostSavingsTotal = 0;
	
	    _.forEach(flights, function (flight) {
	      lostSavingsTotal += flight.LostSavingsAmount;
	    });
	
	    pax.RailLostSavingsTotal = lostSavingsTotal;
	    return pax;
	  }
	
	  function computeRailLostSavingsTotal(pax) {
	    var rails = pax.Rails;
	    var lostSavingsTotal = 0;
	
	    _.forEach(rails, function (rail) {
	      lostSavingsTotal += rail.LostSavingsAmount;
	    });
	
	    pax.RailLostSavingsTotal = lostSavingsTotal;
	    return pax;
	  }
	
	  function computeHotelLostSavingsTotal(pax) {
	    var hotels = pax.Hotels;
	    var lostSavingsTotal = 0;
	
	    _.forEach(hotels, function (hotel) {
	      lostSavingsTotal += hotel.LostSavingsAmount;
	    });
	
	    pax.CarLostSavingsTotal = lostSavingsTotal;
	    return pax;
	  }
	
	  function computeCarLostSavingsTotal(pax) {
	    var cars = pax.Cars;
	    var lostSavingsTotal = 0;
	
	    _.forEach(cars, function (car) {
	      if (typeof car.LostSavingsAmount === 'number') {
	        lostSavingsTotal += car.LostSavingsAmount;
	      }
	    });
	
	    pax.CarLostSavingsTotal = lostSavingsTotal;
	    return pax;
	  }
	
	  function computeLostSavingsAmount(pax) {
	    pax.LostSavingsAmount = Number(pax.FlightLostSavingsTotal) + Number(pax.RailLostSavingsTotal) + Number(pax.HotelLostSavingsTotal) + Number(pax.CarLostSavingsTotal);
	
	    return pax;
	  }
	
	  function computeCreditsUsed(pax) {
	    var flights = pax.Flights;
	    var creditsUsedTotal = 0;
	
	    if (Array.isArray(flights) && flights.length) {
	      _.forEach(flights, function (flight) {
	        if (typeof flight.CreditsUsed === 'number') {
	          creditsUsedTotal += flight.CreditsUsed;
	        }
	      });
	    }
	
	    pax.CreditsUsed = creditsUsedTotal;
	    return pax;
	  }
	
	  function computeHasFlightSectors(pax) {
	    var hasFlights = false;
	    if (!!pax && !!pax.Sectors && pax.Sectors.length > 0) {
	      if (pax.Pnr) {
	        return false;
	      }
	
	      for (var i = 0; i < pax.Sectors.length; i++) {
	        hasFlights = !!pax.Sectors[i].FlightNumber || hasFlights;
	      }
	    }
	
	    pax.hasFlights = true;
	    return pax;
	  }
	
	  function deletePax(paxId, itineraryId) {
	    var deferred = $q.defer();
	
	    $http['delete'](APP_CONFIG.api.url + 'Itinerary/' + itineraryId + '/passenger/' + paxId).success(function () {
	      service.get(itineraryId).then(function (itinerary) {
	        deferred.resolve(itinerary);
	      });
	    }).error(function () {
	      deferred.reject();
	    });
	
	    return deferred.promise;
	  }
	
	  function computePax(pax) {
	    pax.Flights = pax.Flights.map(function (flight) {
	      return computeFlightSector(flight);
	    });
	
	    pax.Rails = pax.Rails.map(function (rail) {
	      return computeRailSector(rail);
	    });
	
	    return pax;
	  }
	
	  function computeTicketOptions(sector) {
	    var ancillaryServices = sector.AncillaryServices;
	
	    var options = _.filter(ancillaryServices, function (service) {
	      return service.Type === 'Ticketing';
	    });
	
	    sector.ticketOptions = _.map(options, function (option) {
	      if (option.Description === 'Collection') {
	        option.Description = 'Pickup on departure - ' + sector.Departure.Location + ' (' + sector.Departure.Code + ')';
	      }
	
	      return option;
	    });
	
	    return sector;
	  }
	
	  function computeItineraryTotal(itinerary) {
	    var travelers = itinerary.Passengers;
	    var itineraryTotal = 0;
	
	    if (Array.isArray(travelers)) {
	      _.forEach(travelers, function (traveler) {
	        if (typeof traveler.Amount === 'number') {
	          itineraryTotal += traveler.Amount;
	        }
	      });
	    }
	
	    itinerary.ItineraryTotal = itineraryTotal;
	
	    return itinerary;
	  }
	
	  function computeCreditsUsedTotal(itinerary) {
	    var travelers = itinerary.Passengers;
	    var totalCreditsUsed = 0;
	
	    if (Array.isArray(travelers)) {
	      _.forEach(travelers, function (traveler) {
	        if (typeof traveler.CreditsUsed === 'number') {
	          totalCreditsUsed += traveler.CreditsUsed;
	        }
	      });
	    }
	
	    itinerary.CreditsUsedTotal = totalCreditsUsed;
	
	    return itinerary;
	  }
	
	  function computeLostSavingsTotal(itinerary) {
	    var travelers = itinerary.Passengers;
	    var lostSavingsTotal = 0;
	
	    if (Array.isArray(travelers)) {
	      _.forEach(travelers, function (traveler) {
	        if (typeof traveler.LostSavingsAmount === 'number') {
	          lostSavingsTotal += traveler.LostSavingsAmount;
	        }
	      });
	    }
	
	    itinerary.LostSavingsTotal = lostSavingsTotal;
	
	    return itinerary;
	  }
	
	  function computeNonRefundableContent(itinerary) {
	    var travelers = itinerary.Passengers;
	    var NonRefundable = false;
	
	    if (Array.isArray(travelers)) {
	      _.forEach(travelers, function (traveler) {
	        var continueLoop = true;
	        _.forEach(traveler.Sectors, function (sector) {
	          if (sector.Refundable === false) {
	            NonRefundable = true;
	            continueLoop = false;
	            return false;
	          }
	        });
	
	        return continueLoop;
	      });
	    }
	
	    itinerary.NonRefundableContent = NonRefundable;
	
	    return itinerary;
	  }
	
	  function computeRailSector(sector) {
	    return _.flowRight(computeTicketOptions, computeSeatPreferences)(sector);
	  }
	
	  function computeItinerary(itinerary) {
	    if (!itinerary.Passengers && itinerary.Passengers.length === 0) {
	      return itinerary;
	    }
	
	    itinerary.Passengers.map(function (pax) {
	      return _.flowRight(computeHasFlightSectors, computeCreditsUsed, computeLostSavingsAmount, computeCarLostSavingsTotal, computeHotelLostSavingsTotal, computeRailLostSavingsTotal, computePaxFlightLostSavingsTotal, computePaxAmount, computePaxCarTotal, computePaxGroundTotal, computePaxHotelTotal, computePaxRailTotal, computePaxFlightTotal, computePaxSectors, computePax)(pax);
	    });
	
	    return _.flowRight(computeNonRefundableContent, computeLostSavingsTotal, computeCreditsUsedTotal, computeItineraryTotal)(itinerary);
	  }
	  function getModifyHotel(sectorIdentifier) {
	    var modifyHotel = null;
	    if (!service.itinerary || !service.itinerary.Passengers) return null;
	    service.itinerary.Passengers.forEach(function (pax) {
	      if (pax.Hotels && pax.Hotels.length > 0) {
	        pax.Hotels.forEach(function (hotel) {
	          if (hotel.Identifier == sectorIdentifier) {
	            modifyHotel = hotel;
	          }
	        });
	      }
	    });
	    return modifyHotel;
	  }
	
	  function getModifyCar(sectorIdentifier) {
	    var modifyCar = null;
	    if (!service.itinerary || !service.itinerary.Passengers) return null;
	    service.itinerary.Passengers.forEach(function (pax) {
	      if (pax.Cars && pax.Cars.length > 0) {
	        pax.Cars.forEach(function (car) {
	          if (car.Identifier == sectorIdentifier) {
	            modifyCar = car;
	          }
	        });
	      }
	    });
	    return modifyCar;
	  }
	
	  function intlMultiCityCheck(requestFlights, selectedPassengers, flightsChange) {
	    var multiCityValidationError = false;
	    if (!service.itinerary || !service.itinerary.Passengers) return multiCityValidationError;
	    if (!flightsChange || flightsChange.length === 0) {
	      flightsChange = [];
	      if (service.itinerary.Search && service.itinerary.Search.Cancel) {
	        flightsChange = service.itinerary.Search && service.itinerary.Search.Cancel;
	      }
	    }
	
	    var passengersObjects = selectedPassengers && selectedPassengers.length > 0 ? service.itinerary.Passengers.filter(function (PaxObj) {
	      return selectedPassengers.find(function (paxId) {
	        return paxId === PaxObj.Identifier;
	      });
	    }) : service.itinerary.Passengers;
	
	    passengersObjects.forEach(function (pax) {
	      var flights = pax.Flights.filter(function (flight) {
	        return flightsChange.indexOf(flight.Identifier) === -1;
	      }).map(function (flight) {
	        return {
	          Depart: flight.Departure.Code,
	          Arrive: flight.Arrival.Code,
	          Intl: flight.Departure.IsInternational || flight.Arrival.IsInternational
	        };
	      });
	      var allPaxFlights = [].concat(_toConsumableArray(requestFlights), _toConsumableArray(flights));
	      if (intlMultiCityCheckSegments(allPaxFlights)) {
	        multiCityValidationError = true;
	      }
	    });
	    return multiCityValidationError;
	  }
	  function intlMultiCityCheckSegments(allPaxFlights) {
	    var multiCityValidationError = false;
	    var hasIntl = allPaxFlights.find(function (flight) {
	      return flight.Intl === true;
	    });
	
	    if (hasIntl && allPaxFlights.length > 2) {
	      multiCityValidationError = true;
	    }
	    if (hasIntl && allPaxFlights.length === 2 && (allPaxFlights[0].Depart !== allPaxFlights[1].Arrive || allPaxFlights[1].Depart !== allPaxFlights[0].Arrive)) {
	      multiCityValidationError = true;
	    }
	    return multiCityValidationError;
	  }
	
	  function repeatingCityCheckSegments(allPaxFlights) {
	    if (allPaxFlights.length < 2) {
	      return false;
	    }
	    for (var s = 0; s < allPaxFlights.length; s++) {
	      if (allPaxFlights.filter(function (flight) {
	        return flight.Depart === allPaxFlights[s].Depart;
	      }).length > 1) {
	        return true;
	      }
	      if (allPaxFlights.filter(function (flight) {
	        return flight.Arrive === allPaxFlights[s].Arrive;
	      }).length > 1) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  function areSameCompanyReferences(travelers) {
	    var flattenedTravelers = travelers.map(function (x) {
	      return x.Configurations.CompanyReferences;
	    });
	
	    function compareArrays(array1, array2) {
	      if (array1.length !== array2.length) {
	        return false;
	      }
	
	      for (var i = 0; i < array1.length; i++) {
	        if (array1[i] !== array2[i]) {
	          return false;
	        }
	      }
	
	      return true;
	    }
	
	    function compareObjects(obj1, obj2) {
	      // Both can be undefined
	      if (!obj1 && !obj2) {
	        return true;
	      }
	
	      // One can be undefined and the other doesn't
	      if (!obj1 && obj2 || obj1 && !obj2) {
	        return false;
	      }
	
	      var keys1 = Object.keys(obj1);
	      var keys2 = Object.keys(obj2);
	
	      if (keys1.length !== keys2.length) {
	        return false;
	      }
	
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = keys1[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var key = _step.value;
	
	          // We have to remove the hash key since it's always different
	          if (key === '$$hashKey') {
	            continue;
	          }
	          if (obj1[key] !== obj2[key]) {
	            return false;
	          }
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator['return']) {
	            _iterator['return']();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      return true;
	    }
	
	    // Iterate over each CompanyReference and check if they have any difference
	    for (var traveler1 = 0; traveler1 < flattenedTravelers.length; traveler1++) {
	      var traveler1CompanyReferences = flattenedTravelers[traveler1];
	      for (var traveler2 = traveler1 + 1; traveler2 < flattenedTravelers.length; traveler2++) {
	        var traveler2CompanyReferences = flattenedTravelers[traveler2];
	
	        var _loop = function (traveler1CompanyReference) {
	          var traveler1CompanyReference = traveler1CompanyReferences[traveler1CompanyReference];
	
	          var match = traveler2CompanyReferences.some(function (x) {
	            return x.Code === traveler1CompanyReference.Code && x.Title === traveler1CompanyReference.Title && x.Value === traveler1CompanyReference.Value && compareObjects(traveler1CompanyReference.ValueDescription, x.ValueDescription);
	          });
	
	          if (!match) {
	            return {
	              v: false
	            }; // If the item doesn't match, means there was an update in one traveler
	          }
	        };
	
	        for (var traveler1CompanyReference = 0; traveler1CompanyReference < traveler1CompanyReferences.length; traveler1CompanyReference++) {
	          var _ret = _loop(traveler1CompanyReference);
	
	          if (typeof _ret === 'object') return _ret.v;
	        }
	      }
	    }
	
	    // If no matches were found, return false
	    return true;
	  }
	
	  function setPrevNextMethods($scope, settingsService, page, modalScope) {
	    var prev, next;
	    var pages = [];
	    pages.push({
	      Name: 'paymentMethod',
	      prev: settingsService.settings.Department.Enabled ? $scope.modalDepartment : $scope.modalCostCentre,
	      enabled: true,
	      model: $scope.modalPaymentMethod
	    });
	    pages.push({
	      Name: 'unusedTicketCredit',
	      enabled: settingsService.isUnusedCreditEnabled() && $scope.hasUnusedTicketCredit(modalScope),
	      model: $scope.modalUnusedCredit
	    });
	    var isModifying = $scope.isModifyItinerary();
	    pages.push({
	      Name: 'companyReference',
	      enabled: !isModifying && $scope.itinerary.travelerConfigurations.companyReferences && $scope.itinerary.travelerConfigurations.companyReferences.length > 0,
	      model: $scope.modalCompanyReference
	    });
	    pages.push({
	      Name: 'approvers',
	      enabled: !isModifying,
	      model: $scope.modalApprovers
	    });
	
	    var pageIndex = pages.indexOf(pages.find(function (p) {
	      return p.Name == page;
	    }));
	    if (pageIndex == -1) {
	      modalScope.modals = {
	        PreviousMethod: prev,
	        NextMethod: next
	      };
	      return;
	    }
	    prev = pages[pageIndex].prev;
	    next = pages[pageIndex].next;
	    for (var p = pageIndex - 1; p >= 0; p--) {
	      if (!pages[p] || !pages[p].enabled) continue;
	      prev = pages[p].model;
	      break;
	    }
	    for (var p = pageIndex + 1; p < pages.length; p++) {
	      if (!pages[p] || !pages[p].enabled) continue;
	      next = pages[p].model;
	      break;
	    }
	    modalScope.modals = {
	      PreviousMethod: !prev ? null : prev,
	      NextMethod: !next ? null : next
	    };
	    return;
	  }
	  function getModificationsSettings() {
	    if (service.itinerary && service.itinerary.Modifications) {
	      return service.itinerary.Modifications;
	    }
	    return settingsService.settings.Modifications;
	  }
	
	  return service;
	};
	
	itinerariesService.$inject = $inject;
	
	exports['default'] = itinerariesService;
	module.exports = exports['default'];

/***/ }),
/* 694 */,
/* 695 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['$q', 'moment', 'itinerariesService', 'settingsService', 'ENUMS', 'dateTimeService'];
	
	var searchFormService = function searchFormService($q, moment, itinerariesService, settingsService, ENUMS, dateTimeService) {
	  var service = {
	    activeSearchTypes: {
	      Flights: { active: false, showForm: false, enabled: true },
	      Hotels: { active: false, showForm: false, enabled: true },
	      Cars: { active: false, showForm: false, enabled: true },
	      Rail: { active: false, showForm: false, enabled: true },
	      Ground: { active: false, showForm: false, enabled: true }
	    },
	    railOptions: {
	      'return': true,
	      openReturn: false
	    },
	    flightLegs: 2,
	    updateSearchChoices: updateSearchChoices,
	    updateFlightLegs: updateFlightLegs,
	    updateRailReturn: updateRailReturn,
	    updateRailOpenReturn: updateRailOpenReturn,
	    validateThenPostForm: validateThenPostForm,
	    prepRailFormData: prepRailFormData,
	    prepCarFormData: prepCarFormData,
	    prepHotelFormData: prepHotelFormData,
	    getLocationCodeHotel: getLocationCodeHotel,
	    prepGroundFormData: prepGroundFormData,
	    getFlightData: getFlightData,
	    getRailLocationName: getRailLocationName
	  };
	
	  var DATE_FORMAT = dateTimeService.getFormat(ENUMS.dateTimeFormats.DATE_MEDIUM);
	  var TIME_FORMAT = dateTimeService.getFormat(ENUMS.dateTimeFormats.TIME_LONG);
	  var DATE_FORMAT_API = 'YYYY-MM-DD[T]HH:mm:ss';
	
	  function prepCarFormData(searchForm) {
	    var pickUpDate = searchForm.pickUpDate.$modelValue;
	    var pickUpTime = searchForm.pickUpTime.$modelValue;
	    var pickUpDateTime = moment(pickUpDate + pickUpTime, DATE_FORMAT + TIME_FORMAT).format(DATE_FORMAT_API);
	
	    var dropOffDate = searchForm.dropOffDate.$modelValue;
	    var dropOffTime = searchForm.dropOffTime.$modelValue;
	    var dropOffDateTime = moment(dropOffDate + dropOffTime, DATE_FORMAT + TIME_FORMAT).format(DATE_FORMAT_API);
	
	    var hideDropOff = searchForm.hideDropOff.$modelValue;
	    var pickupPoi = searchForm.selectCarPickUpLocation.$modelValue;
	    var dropoffPoi = searchForm.dropOffLocation.$modelValue;
	
	    var pickUpOtherLocation = searchForm.pickUpOtherLocation ? searchForm.pickUpOtherLocation.$modelValue : undefined;
	    var dropOffOtherLocation = searchForm.dropOffOtherLocation ? searchForm.dropOffOtherLocation.$modelValue : undefined;
	    if (hideDropOff === true) {
	      dropoffPoi = pickupPoi;
	      dropOffOtherLocation = pickUpOtherLocation;
	    }
	    var searchObject = {
	      PickUp: generateCarSearchPayload(pickUpDateTime, pickupPoi, pickUpOtherLocation),
	      DropOff: generateCarSearchPayload(dropOffDateTime, dropoffPoi, dropOffOtherLocation)
	    };
	
	    return searchObject;
	  }
	  /**
	   * This is called before HotelSearchController
	   * i.e. It's only called when performing another search from the Hotel search page
	   * @param {*} searchForm
	   */
	  function prepHotelFormData(searchForm) {
	    var locationInput = arguments.length <= 1 || arguments[1] === undefined ? null : arguments[1];
	
	    var checkInDate = searchForm.checkInDate.$modelValue;
	    var checkOutDate = searchForm.checkOutDate.$modelValue;
	    var location = searchForm.hotelLocation.$modelValue || locationInput;
	    var radius = searchForm.radius ? searchForm.radius.$modelValue.value : 15;
	
	    var payload = generateHotelSearchPayload(checkInDate, checkOutDate, location, radius);
	    return payload;
	  }
	  /**
	   * Generates payload, defaulting in some values from location
	   * @param {*} checkInDate
	   * @param {*} checkOutDate
	   * @param {*} location
	   * @param {*} radius
	   */
	  function generateHotelSearchPayload(checkInDate, checkOutDate, location, radius) {
	    var checkIn = moment(checkInDate, DATE_FORMAT).format(DATE_FORMAT_API);
	    var checkOut = moment(checkOutDate, DATE_FORMAT).format(DATE_FORMAT_API);
	
	    return {
	      DateFrom: checkIn,
	      DateTo: checkOut,
	      Location: {
	        City: location.City ? location.City.Name : '',
	        Country: location.Country ? location.Country.Name : '',
	        CountryCode: location.Country ? location.Country.Code : '',
	        Location: location.Address,
	        IsInternational: '',
	        Code: getLocationCodeHotel(location), // Iata is used for POI lookup, code is used with airport lookup
	        Name: location.Title,
	        Type: location.Type,
	        Latitude: location.Latitude,
	        Longitude: location.Longitude,
	        RadiusDistance: radius
	      }
	    };
	  }
	  function generateCarSearchPayload(dateValue, location, OtherLocation) {
	    var ret = {
	      Date: dateValue,
	      Location: location.Title,
	      Code: location.Iata,
	      IsInternational: '',
	      City: location.City ? location.City.Name : '',
	      CityCode: location.City ? location.City.Code : '',
	      Country: location.Country ? location.Country.Name : '',
	      CountryCode: location.Country ? location.Country.Code : '',
	      IsInternational: '',
	      Name: location.Title,
	      Type: location.Type,
	      Latitude: location.Latitude,
	      Longitude: location.Longitude
	    };
	
	    if (OtherLocation && location.Type !== 'Airport') {
	      var depot = {};
	
	      depot.Address = OtherLocation.addressLabel;
	      depot.Code = OtherLocation.code;
	      depot.FullCode = OtherLocation.fullCode;
	      depot.Supplier = OtherLocation.supplierId;
	      ret.Depot = depot;
	      ret.Code = OtherLocation.fullCode;
	      if (OtherLocation.fullCode && OtherLocation.fullCode.length > 3) {
	        ret.Code = OtherLocation.fullCode.substr(0, 3);
	      }
	      ret.CityCode = ret.Code;
	
	      ret.Location = OtherLocation.addressLabel;
	    }
	
	    return ret;
	  }
	  /**
	   * Based on different types of locations, get 3-letter code relevant to hotel search
	   * @param {location object} location
	   */
	  function getLocationCodeHotel(location) {
	    if (location.City && location.City.Code) {
	      return location.City.Code;
	    }
	
	    if (location.Iata) {
	      return location.Iata;
	    }
	
	    return location.Code;
	  }
	  function updateSearchChoices(choice) {
	    var t = service.activeSearchTypes;
	    var r = service.railOptions;
	
	    switch (choice) {
	      case 'Flights':
	        if (!t.Rail.active && !t.Hotels.active && !t.Cars.active) {
	          t.Flights.active = true;
	          t.Flights.showForm = true;
	        } else {
	          t.Flights.active = !t.Flights.active;
	          t.Flights.showForm = !t.Flights.showForm;
	        }
	
	        if (t.Flights.active) {
	          r.openReturn = false;
	          r['return'] = true;
	
	          t.Rail.active = false;
	          t.Rail.showForm = false;
	          t.Hotels.showForm = false;
	          t.Cars.showForm = false;
	        } else {
	          t.Hotels.showForm = t.Hotels.active;
	          t.Cars.showForm = t.Cars.active;
	        }
	
	        if ((t.Cars.active || t.Hotels.active) && service.flightLegs === 1) {
	          t.Cars.active = t.Cars.active;
	          t.Cars.showForm = t.Cars.active;
	          t.Hotels.active = t.Hotels.active;
	          t.Hotels.showForm = t.Hotels.active;
	          t.Flights.active = t.Flights.active;
	          t.Flights.showForm = t.Flights.active;
	        }
	
	        if (t.Flights.active || t.Rail.active || t.Hotels.active || t.Cars.active) {
	          t.Ground.active = false;
	          t.Ground.showForm = false;
	        }
	        break;
	
	      case 'Rail':
	        if (!t.Flights.active && !t.Hotels.active && !t.Cars.active) {
	          t.Rail.active = true;
	          t.Rail.showForm = true;
	        } else {
	          t.Rail.active = !t.Rail.active;
	          t.Rail.showForm = !t.Rail.showForm;
	        }
	
	        if (t.Rail.active) {
	          t.Flights.active = false;
	          t.Flights.showForm = false;
	          t.Hotels.showForm = false;
	          t.Cars.active = false;
	          t.Cars.showForm = false;
	        } else {
	          t.Hotels.showForm = t.Hotels.active;
	        }
	
	        if (service.railOptions.openReturn) {
	          t.Hotels.active = false;
	          t.Hotels.showForm = false;
	        }
	
	        if (t.Flights.active || t.Rail.active || t.Hotels.active || t.Cars.active) {
	          t.Ground.active = false;
	          t.Ground.showForm = false;
	        }
	        break;
	
	      case 'Hotels':
	        var hotelActive = t.Hotels.active;
	
	        if (!t.Flights.active && !t.Rail.active && !t.Cars.active) {
	          t.Hotels.active = true;
	          t.Hotels.showForm = true;
	        } else {
	          t.Hotels.active = !t.Hotels.active;
	          t.Hotels.showForm = !t.Hotels.showForm;
	        }
	
	        if (t.Flights.active) {
	          t.Hotels.showForm = false;
	        }
	
	        if (!t.Cars.active && service.flightLegs === 1) {
	          t.Hotels.active = t.Hotels.active;
	          t.Hotels.showForm = t.Hotels.active;
	        }
	
	        if (t.Flights.active && service.flightLegs === 1) {
	          t.Hotels.active = t.Hotels.active;
	          t.Hotels.showForm = t.Hotels.active;
	          t.Flights.active = t.Flights.active;
	          t.Flights.showForm = true;
	        }
	
	        if (t.Rail.active) {
	          t.Hotels.active = true;
	          t.Hotels.showForm = true;
	          if (!r['return'] || r.openReturn) {
	            r.openReturn = false;
	            r['return'] = true;
	            t.Rail.active = false;
	            t.Rail.showForm = false;
	            t.Hotels.active = true;
	            t.Hotels.showForm = true;
	          } else {
	            if (hotelActive) {
	              t.Hotels.active = false;
	              t.Hotels.showForm = false;
	            } else {
	              t.Hotels.active = true;
	              t.Hotels.showForm = false;
	            }
	          }
	        }
	
	        if (t.Flights.active || t.Rail.active || t.Hotels.active || t.Cars.active) {
	          t.Ground.active = false;
	          t.Ground.showForm = false;
	        }
	        break;
	
	      case 'Cars':
	        if (!t.Flights.active && !t.Rail.active && !t.Hotels.active) {
	          t.Cars.active = true;
	          t.Cars.showForm = true;
	        } else {
	          t.Cars.active = !t.Cars.active;
	          t.Cars.showForm = !t.Cars.showForm;
	        }
	
	        if (t.Flights.active || t.Rail.active) {
	          t.Cars.showForm = false;
	        }
	
	        if (t.Rail.active) {
	          r.openReturn = false;
	          r['return'] = true;
	          t.Rail.active = false;
	          t.Rail.showForm = false;
	          t.Cars.active = true;
	          t.Cars.showForm = true;
	          t.Hotels.showForm = t.Hotels.active;
	        }
	
	        if (t.Flights.active && service.flightLegs === 1) {
	          t.Cars.active = t.Cars.active;
	          t.Cars.showForm = t.Cars.active;
	          t.Flights.active = true;
	          t.Flights.showForm = true;
	        }
	
	        if (t.Flights.active || t.Rail.active || t.Hotels.active || t.Cars.active) {
	          t.Ground.active = false;
	          t.Ground.showForm = false;
	        }
	
	        break;
	      case 'Ground':
	        if (!t.Flights.active && !t.Rail.active && !t.Hotels.active && !t.Cars.active) {
	          t.Ground.active = true;
	          t.Ground.showForm = true;
	        } else {
	          t.Ground.active = !t.Ground.active;
	          t.Ground.showForm = !t.Ground.showForm;
	        }
	
	        if (t.Ground.active) {
	          t.Flights.active = false;
	          t.Flights.showForm = false;
	          t.Rail.active = false;
	          t.Rail.showForm = false;
	          t.Hotels.active = false;
	          t.Hotels.showForm = false;
	          t.Cars.active = false;
	          t.Cars.showForm = false;
	        }
	
	        break;
	      default:
	        console.warn('NO CART ITEM TYPE FOUND!');
	    }
	  }
	  function updateFlightLegs(legs) {
	    var t = service.activeSearchTypes;
	    service.flightLegs = legs;
	
	    if (t.Flights.active) {
	      if (service.flightLegs <= 1) {
	        t.Hotels.active = t.Hotels.active;
	        t.Hotels.showForm = t.Hotels.active;
	        t.Cars.active = t.Cars.active;
	        t.Cars.showForm = t.Cars.active;
	      }
	
	      if (service.flightLegs > 1) {
	        t.Hotels.active = t.Hotels.active;
	        t.Hotels.showForm = false;
	        t.Cars.active = t.Cars.active;
	        t.Cars.showForm = false;
	      }
	    }
	  }
	  function updateRailReturn() {
	    var t = service.activeSearchTypes;
	
	    if (!service.railOptions['return']) {
	      t.Hotels.active = false;
	      t.Hotels.showForm = false;
	      t.Cars.active = false;
	      t.Cars.showForm = false;
	    }
	  }
	  function updateRailOpenReturn() {
	    var t = service.activeSearchTypes;
	
	    if (service.railOptions.openReturn) {
	      t.Hotels.active = false;
	      t.Hotels.showForm = false;
	    }
	  }
	  function validateThenPostForm(searchForm, travellers) {
	    var DATE_FORMAT_MEDIUM = dateTimeService.getFormat(ENUMS.dateTimeFormats.DATE_MEDIUM).replace(',', '[,]');
	
	    var deferred = $q.defer();
	
	    if (searchForm.$invalid) {
	      deferred.reject();
	    }
	
	    var t = service.activeSearchTypes;
	
	    var orderNumber = searchForm.orderNumber ? searchForm.orderNumber.$modelValue : undefined;
	    if (orderNumber) {
	      orderNumber = orderNumber.hasOwnProperty('Value') ? orderNumber.Value : orderNumber;
	    }
	
	    var searchParams = {
	      search: {
	        Passengers: travellers,
	        Reason: searchForm.reasonForTravel ? searchForm.reasonForTravel.$modelValue.Value : undefined,
	        OrderNumber: orderNumber,
	        IsMultiPaxPnr: searchForm.IsMultPaxPnr && searchForm.IsMultPaxPnr.$modelValue === true ? true : false
	      }
	    };
	    if (t.Flights.showForm) {
	      var flightsAmount = searchForm.flightSearch.flightsAmount.$modelValue;
	
	      for (var i = 0; i < flightsAmount; i++) {
	        var flightDate = searchForm.flightSearch['flight' + (i + 1) + 'Date'].$modelValue;
	        var flightTime = searchForm.flightSearch['flight' + (i + 1) + 'Time'].$modelValue;
	        var flightDateTime = moment(flightDate + flightTime, DATE_FORMAT_MEDIUM + TIME_FORMAT).format(DATE_FORMAT_API);
	
	        var destination = searchForm.flightSearch['flight' + (i + 1) + 'Arrival'].$modelValue;
	        var destinationCode = destination.Value;
	        var destinationName = destination.City + ', ' + destination.Country;
	        var originCode = searchForm.flightSearch['flight' + (i + 1) + 'Departure'].$modelValue.Value;
	
	        searchParams = addFlight(searchParams, flightDateTime, originCode, destinationCode);
	
	        if (t.Hotels.active && flightsAmount > 0) {
	          var checkOut = undefined;
	          var checkIn = undefined;
	
	          if (i != flightsAmount - 1) {
	            checkOut = searchForm.flightSearch['flight' + (i + 2) + 'Date'].$modelValue;
	            checkIn = flightDate;
	
	            var _location = {
	              Title: destinationName,
	              Code: destinationCode,
	              Type: 'Airport'
	            };
	
	            var selectedLocation = _location;
	
	            if (searchForm.hotelLocation && searchForm.hotelLocation.$modelValue) {
	              var hotelLocation = searchForm.hotelLocation.$modelValue;
	              if (hotelLocation.Iata !== _location.Code || hotelLocation.Type !== _location.Type) {
	                selectedLocation = hotelLocation;
	              }
	            }
	
	            searchParams = addHotel(searchParams, checkIn, checkOut, selectedLocation);
	
	            if (searchForm.radius && searchForm.radius.$modelValue && searchForm.radius.$modelValue.value) {
	              searchParams.search.Hotels[0].Location.RadiusDistance = searchForm.radius.$modelValue.value;
	            }
	          }
	        }
	
	        if (t.Cars.active && flightsAmount > 0) {
	          var nextFlightDate = undefined;
	          var nextFlightTime = undefined;
	          var dropOffDateTime = searchForm.dropOffDate.$modelValue + ' ' + searchForm.dropOffTime.$modelValue;
	          var dropOffCode = undefined;
	
	          if (i != flightsAmount - 1) {
	            nextFlightDate = searchForm.flightSearch['flight' + (i + 2) + 'Date'].$modelValue;
	            nextFlightTime = searchForm.flightSearch['flight' + (i + 2) + 'Time'].$modelValue;
	            dropOffDateTime = moment(nextFlightDate + nextFlightTime, DATE_FORMAT_MEDIUM + TIME_FORMAT).format(DATE_FORMAT_API);
	            dropOffCode = searchForm.flightSearch['flight' + (i + 2) + 'Departure'].$modelValue.Value;
	
	            var searchObject = {
	              PickUp: {
	                Date: flightDateTime,
	                Code: destinationCode
	              },
	              DropOff: {
	                Date: dropOffDateTime,
	                Code: dropOffCode
	              }
	            };
	
	            searchParams = addCar(searchParams, searchObject);
	          }
	        }
	      }
	    }
	
	    if (t.Rail.showForm) {
	      searchParams = service.prepRailFormData(searchForm, searchParams);
	
	      if (t.Hotels.active) {
	        var checkIn = searchForm.outboundDate.$modelValue;
	        var checkOut = searchForm.returnDate ? searchForm.returnDate.$modelValue : moment(checkIn, DATE_FORMAT).add(1, 'd').format(DATE_FORMAT);
	
	        var selectedLocation = searchForm.railTo1 && searchForm.railTo1.$modelValue;
	
	        if (searchForm.hotelLocation && searchForm.hotelLocation.$modelValue) {
	          selectedLocation = searchForm.hotelLocation.$modelValue;
	        }
	
	        if (selectedLocation) {
	          searchParams = addHotel(searchParams, checkIn, checkOut, selectedLocation);
	        }
	
	        if (searchForm.radius && searchForm.radius.$modelValue && searchForm.radius.$modelValue.value) {
	          searchParams.search.Hotels[0].Location.RadiusDistance = searchForm.radius.$modelValue.value;
	        }
	      }
	    }
	
	    if (t.Hotels.showForm) {
	      var checkInDate = searchForm.checkInDate.$modelValue;
	      var checkOutDate = searchForm.checkOutDate.$modelValue;
	      searchParams = addHotel(searchParams, checkInDate, checkOutDate, searchForm.hotelLocation.$modelValue);
	      try {
	        searchParams.search.Hotels[0].Location.RadiusDistance = searchForm.radius.$modelValue.value;
	      } catch (e) {}
	    }
	
	    if (t.Cars.showForm) {
	      var searchObject = prepCarFormData(searchForm);
	      searchParams = addCar(searchParams, searchObject);
	    }
	
	    if (t.Ground.showForm) {
	      var searchObject = prepGroundFormData(searchForm);
	      searchParams = addGround(searchParams, searchObject);
	    }
	
	    searchParams.search.CompanyReferences = addCompanyReferences(searchForm);
	
	    itinerariesService.post(searchParams).then(function (itineraryResponse) {
	      deferred.resolve(itineraryResponse);
	    })['catch'](function (err) {
	      deferred.reject();
	    });
	
	    return deferred.promise;
	  }
	  function addCompanyReferences(searchForm) {
	    var i = 0;
	    var ret = [];
	    while (searchForm['companyReference_code_' + i]) {
	      var reference = searchForm['companyReference_code_' + i].$modelValue;
	      var item = {
	        Code: reference.Code,
	        Title: reference.Title,
	        ValueDescription: reference.Value,
	        Value: reference.Value,
	        PlacementType: 'HomeSearch'
	      };
	      if (reference.ValueDescription && reference.ValueDescription.Description) {
	        item.ValueDescription = reference.ValueDescription.Description;
	        item.Value = reference.ValueDescription.Value;
	      }
	      ret.push(item);
	      i++;
	    }
	
	    return ret;
	  }
	  function getFlightData(searchForm) {
	    var flights = [];
	    for (var i = 0; i < searchForm.flightSearch.flightsAmount.$modelValue; i++) {
	      flights.push(prepFlightData(searchForm, i));
	    }
	    return flights;
	  }
	  function prepFlightData(searchForm, i) {
	    var DATE_FORMAT_MEDIUM = dateTimeService.getFormat(ENUMS.dateTimeFormats.DATE_MEDIUM).replace(',', '[,]');
	    var flightDate = searchForm.flightSearch['flight' + (i + 1) + 'Date'].$modelValue;
	    var flightTime = searchForm.flightSearch['flight' + (i + 1) + 'Time'].$modelValue;
	    var flightDateTime = moment(flightDate + flightTime, DATE_FORMAT_MEDIUM + TIME_FORMAT).format(DATE_FORMAT_API);
	
	    var destination = searchForm.flightSearch['flight' + (i + 1) + 'Arrival'].$modelValue;
	    var destinationCode = destination.Value;
	    var destinationName = destination.City + ', ' + destination.Country;
	    var originCode = searchForm.flightSearch['flight' + (i + 1) + 'Departure'].$modelValue.Value;
	    return {
	      Origin: {
	        Code: originCode
	      },
	      Destination: {
	        Code: destinationCode
	      },
	      Date: flightDateTime
	    };
	  }
	  function addFlight(searchParams, dateTime, originCode, destinationCode) {
	    searchParams.search.Flights = searchParams.search.Flights || [];
	    searchParams.search.Flights.push({
	      Origin: {
	        Code: originCode
	      },
	      Destination: {
	        Code: destinationCode
	      },
	      Date: dateTime
	    });
	
	    return searchParams;
	  }
	  /**
	   * Purpose of this function is to create a single Hotel object, adding it to the searchParams object
	   * the Hotel object maps to the TravelCTMOBT.Api.Models.*.SearchHotel model in the back end
	   * @param {*} searchParams
	   * @param {*} checkIn
	   * @param {*} checkOut
	   * @param {*} location
	   */
	  function addHotel(searchParams, checkIn, checkOut, location) {
	    searchParams.search.Hotels = searchParams.search.Hotels || [];
	
	    var hotelPayload = generateHotelSearchPayload(checkIn, checkOut, location, null);
	    searchParams.search.Hotels.push(hotelPayload);
	
	    return searchParams;
	  }
	  function addCar(searchParams, searchObject) {
	    searchParams.search.Cars = searchParams.search.Cars || [];
	    searchParams.search.Cars.push(searchObject);
	
	    return searchParams;
	  }
	  function addGround(searchParams, searchObject) {
	    searchParams.search.GroundTransports = searchParams.search.GroundTransports || [];
	    searchParams.search.GroundTransports.push(searchObject);
	
	    return searchParams;
	  }
	  function prepRailFormData(searchForm, searchParams) {
	    searchParams.search.Rails = [convertRailData({
	      railFrom: searchForm.railFrom1,
	      railTo: searchForm.railTo1,
	      date: searchForm.outboundDate,
	      time: searchForm.outboundTime,
	      openReturn: searchForm.openReturn,
	      railCardCode: searchForm.railCardCode
	    })];
	
	    if (searchForm.railReturn.$modelValue) {
	      searchParams.search.Rails.push(convertRailData({
	        railFrom: searchForm.railFrom2,
	        railTo: searchForm.railTo2,
	        date: searchForm.returnDate,
	        time: searchForm.returnTime,
	        openReturn: searchForm.openReturn,
	        railCardCode: searchForm.railCardCode
	      }));
	    }
	
	    return searchParams;
	  }
	  function convertRailData(railInfo) {
	    var DATE_FORMAT_MEDIUM = dateTimeService.getFormat(ENUMS.dateTimeFormats.DATE_MEDIUM).replace(',', '[,]');
	    var fromLocationText = getRailLocationName(railInfo.railFrom.$modelValue),
	        toLocationText = getRailLocationName(railInfo.railTo.$modelValue),
	        fromCity = '',
	        toCity = '';
	
	    var fromCountryCode = '',
	        fromCountryName = '',
	        toCountryCode = '',
	        toCountryName = '',
	        fromCode = '',
	        toCode = '';
	
	    if (railInfo.railFrom.$modelValue.City) {
	      fromCity = railInfo.railFrom.$modelValue.City.Name;
	    }
	
	    if (railInfo.railTo.$modelValue.City) {
	      toCity = railInfo.railTo.$modelValue.City.Name;
	    }
	
	    if (railInfo.railFrom.$modelValue.Country) {
	      fromCountryCode = railInfo.railFrom.$modelValue.Country.Code;
	      fromCountryName = railInfo.railFrom.$modelValue.Country.Name;
	    }
	
	    if (railInfo.railTo.$modelValue.Country) {
	      toCountryCode = railInfo.railTo.$modelValue.Country.Code;
	      toCountryName = railInfo.railTo.$modelValue.Country.Name;
	    }
	
	    if (railInfo.railFrom.$modelValue.Iata) {
	      fromCode = railInfo.railFrom.$modelValue.Iata;
	    } else {
	      fromCode = railInfo.railFrom.$modelValue.Code;
	    }
	
	    if (railInfo.railTo.$modelValue.Iata) {
	      toCode = railInfo.railTo.$modelValue.Iata;
	    } else {
	      toCode = railInfo.railTo.$modelValue.Code;
	    }
	
	    var from = {
	      Code: fromCode,
	      City: fromCity,
	      Country: fromCountryName,
	      CountryCode: fromCountryCode,
	      Location: fromLocationText
	    };
	
	    var to = {
	      Code: toCode,
	      City: toCity,
	      Country: toCountryName,
	      CountryCode: toCountryCode,
	      Location: toLocationText
	    };
	
	    var date = railInfo.date.$modelValue + ' ' + railInfo.time.$modelValue;
	    var dateParsed = moment(date, DATE_FORMAT_MEDIUM + TIME_FORMAT).format(DATE_FORMAT_API);
	
	    var railCardCode = null;
	    var openReturn = railInfo.openReturn.$modelValue;
	
	    if (railInfo.railCard && railInfo.railCard.$modelValue) {
	      railCardCode = railInfo.railCard.$modelValue.InternalCode;
	    }
	
	    var result = {
	      Origin: from,
	      Destination: to,
	      Date: dateParsed,
	      RailCardCode: railCardCode,
	      OpenReturn: openReturn
	    };
	
	    return result;
	  }
	  function getRailLocationName(location) {
	    if (location.Title) return location.Title;
	    if (location.Description) return location.Description;
	    if (location.City && location.City.Name) {
	      var val = location.City.Nam;
	      if (location.Name) {
	        val += ' - ' + location.Name;
	      }
	      return val;
	    }
	    if (location.Name) return location.Name;
	
	    return location.Title;
	  }
	  function prepGroundFormData(searchForm) {
	    var pickUpDateTime = moment(searchForm.pickUpDateBlackCar.$modelValue, DATE_FORMAT + TIME_FORMAT).utc();
	    var time = moment(searchForm.pickUpTimeBlackCar.$modelValue);
	
	    pickUpDateTime.millisecond(time.millisecond());
	    pickUpDateTime.second(time.second());
	    pickUpDateTime.minute(time.minute());
	    pickUpDateTime.hour(time.hour());
	
	    var routes = _.map(_.filter(searchForm.locationsBlackCar.$modelValue, function (location) {
	      return location.value && !location.value.asDirected;
	    }), function (location) {
	      var loc = {
	        type: 'Address',
	        street: location.value.Address,
	        town: location.value.City ? location.value.City.Name : null,
	        country: location.value.Country ? location.value.Country.Code : null,
	        latitude: location.value.Latitude,
	        longitude: location.value.Longitude,
	        county: location.value.State && location.value.State.Code ? location.value.State.Code : location.value.State && location.value.State.Name ? location.value.State.Name : null,
	        PostalCode: location.value.PostalCode,
	        buildNumber: location.buildNumber,
	        isPrivateCarrier: location.value.Type === 'Airport' ? location.isPrivateCarrier : false,
	        GooglePlaceId: location.value.GooglePlaceId
	      };
	
	      if (location.value.Type === 'Airport' || loc.isPrivateCarrier) {
	        var flightDateTime = moment(searchForm.pickUpDateBlackCar.$modelValue, DATE_FORMAT + TIME_FORMAT).utc();
	        var _time = moment(location.flightTime);
	        flightDateTime.millisecond(_time.millisecond());
	        flightDateTime.second(_time.second());
	        flightDateTime.minute(_time.minute());
	        flightDateTime.hour(_time.hour());
	
	        loc.type = 'Airport';
	        loc.airport = location.value.Iata;
	        loc.airline = location.carrierCode;
	        loc.flightNumber = location.flightNumber;
	        loc.flightDateTime = flightDateTime;
	      }
	      if (location.value.Type === 'RailStation') {
	        var flightDateTime = moment(searchForm.pickUpDateBlackCar.$modelValue, DATE_FORMAT + TIME_FORMAT).utc();
	        var _time2 = moment(location.flightTime);
	        flightDateTime.millisecond(_time2.millisecond());
	        flightDateTime.second(_time2.second());
	        flightDateTime.minute(_time2.minute());
	        flightDateTime.hour(_time2.hour());
	
	        loc.type = 'TrainStation';
	        loc.trainStation = location.value.Iata;
	        loc.trainCarrier = location.carrierCode;
	        loc.trainNumber = location.flightNumber;
	        loc.trainDateTime = flightDateTime;
	      }
	
	      return loc;
	    });
	
	    return {
	      passengerCount: searchForm.passengerCountBlackCar.$modelValue,
	      vehicleTypes: searchForm.typeBlackCar.$modelValue,
	      startDateTime: pickUpDateTime.format(),
	      route: routes,
	      asDirectedDuration: _.some(searchForm.locationsBlackCar.$modelValue, function (location) {
	        return location.value && location.value.asDirected;
	      }) ? searchForm.asDirectedDuration.$modelValue : null
	    };
	  }
	  function parseDateTime(dateValue, timeValue) {
	    var date = moment.utc(dateValue);
	    var time = moment(timeValue);
	    date.millisecond(time.millisecond());
	    date.second(time.second());
	    date.minute(time.minute());
	    date.hour(time.hour());
	    return date;
	  }
	
	  return service;
	};
	
	searchFormService.$inject = $inject;
	
	exports['default'] = searchFormService;
	module.exports = exports['default'];

/***/ }),
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var at = __webpack_require__(466)(true);
	
	 // `AdvanceStringIndex` abstract operation
	// https://tc39.github.io/ecma262/#sec-advancestringindex
	module.exports = function (S, index, unicode) {
	  return index + (unicode ? at(S, index).length : 1);
	};


/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	'use strict';
	var toObject = __webpack_require__(17);
	var toAbsoluteIndex = __webpack_require__(142);
	var toLength = __webpack_require__(11);
	module.exports = function fill(value /* , start = 0, end = @length */) {
	  var O = toObject(this);
	  var length = toLength(O.length);
	  var aLen = arguments.length;
	  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
	  var end = aLen > 2 ? arguments[2] : undefined;
	  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
	  while (endPos > index) O[index++] = value;
	  return O;
	};


/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

	// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
	var speciesConstructor = __webpack_require__(1364);
	
	module.exports = function (original, length) {
	  return new (speciesConstructor(original))(length);
	};


/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $defineProperty = __webpack_require__(16);
	var createDesc = __webpack_require__(139);
	
	module.exports = function (object, index, value) {
	  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
	  else object[index] = value;
	};


/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(7);
	var document = __webpack_require__(5).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ }),
/* 708 */
/***/ (function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');


/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

	var MATCH = __webpack_require__(10)('match');
	module.exports = function (KEY) {
	  var re = /./;
	  try {
	    '/./'[KEY](re);
	  } catch (e) {
	    try {
	      re[MATCH] = false;
	      return !'/./'[KEY](re);
	    } catch (f) { /* empty */ }
	  } return true;
	};


/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

	var document = __webpack_require__(5).document;
	module.exports = document && document.documentElement;


/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(7);
	var setPrototypeOf = __webpack_require__(720).set;
	module.exports = function (that, target, C) {
	  var S = target.constructor;
	  var P;
	  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
	    setPrototypeOf(that, P);
	  } return that;
	};


/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

	// check on default Array iterator
	var Iterators = __webpack_require__(202);
	var ITERATOR = __webpack_require__(10)('iterator');
	var ArrayProto = Array.prototype;
	
	module.exports = function (it) {
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};


/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var create = __webpack_require__(136);
	var descriptor = __webpack_require__(139);
	var setToStringTag = __webpack_require__(203);
	var IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(25)(IteratorPrototype, __webpack_require__(10)('iterator'), function () { return this; });
	
	module.exports = function (Constructor, NAME, next) {
	  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
	  setToStringTag(Constructor, NAME + ' Iterator');
	};


/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(93);
	var $export = __webpack_require__(3);
	var redefine = __webpack_require__(26);
	var hide = __webpack_require__(25);
	var Iterators = __webpack_require__(202);
	var $iterCreate = __webpack_require__(713);
	var setToStringTag = __webpack_require__(203);
	var getPrototypeOf = __webpack_require__(38);
	var ITERATOR = __webpack_require__(10)('iterator');
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';
	
	var returnThis = function () { return this; };
	
	module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function (kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS: return function keys() { return new Constructor(this, kind); };
	      case VALUES: return function values() { return new Constructor(this, kind); };
	    } return function entries() { return new Constructor(this, kind); };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = $native || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  // Fix native
	  if ($anyNative) {
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() { return $native.call(this); };
	  }
	  // Define iterator
	  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};


/***/ }),
/* 715 */
/***/ (function(module, exports) {

	// 20.2.2.14 Math.expm1(x)
	var $expm1 = Math.expm1;
	module.exports = (!$expm1
	  // Old FF bug
	  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
	  // Tor Browser bug
	  || $expm1(-2e-17) != -2e-17
	) ? function expm1(x) {
	  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
	} : $expm1;


/***/ }),
/* 716 */
/***/ (function(module, exports) {

	// 20.2.2.28 Math.sign(x)
	module.exports = Math.sign || function sign(x) {
	  // eslint-disable-next-line no-self-compare
	  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
	};


/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(5);
	var macrotask = __webpack_require__(725).set;
	var Observer = global.MutationObserver || global.WebKitMutationObserver;
	var process = global.process;
	var Promise = global.Promise;
	var isNode = __webpack_require__(44)(process) == 'process';
	
	module.exports = function () {
	  var head, last, notify;
	
	  var flush = function () {
	    var parent, fn;
	    if (isNode && (parent = process.domain)) parent.exit();
	    while (head) {
	      fn = head.fn;
	      head = head.next;
	      try {
	        fn();
	      } catch (e) {
	        if (head) notify();
	        else last = undefined;
	        throw e;
	      }
	    } last = undefined;
	    if (parent) parent.enter();
	  };
	
	  // Node.js
	  if (isNode) {
	    notify = function () {
	      process.nextTick(flush);
	    };
	  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
	  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
	    var toggle = true;
	    var node = document.createTextNode('');
	    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
	    notify = function () {
	      node.data = toggle = !toggle;
	    };
	  // environments with maybe non-completely correct, but existent Promise
	  } else if (Promise && Promise.resolve) {
	    // Promise.resolve without an argument throws an error in LG WebOS 2
	    var promise = Promise.resolve(undefined);
	    notify = function () {
	      promise.then(flush);
	    };
	  // for other environments - macrotask based on:
	  // - setImmediate
	  // - MessageChannel
	  // - window.postMessag
	  // - onreadystatechange
	  // - setTimeout
	  } else {
	    notify = function () {
	      // strange IE + webpack dev server bug - use .call(global)
	      macrotask.call(global, flush);
	    };
	  }
	
	  return function (fn) {
	    var task = { fn: fn, next: undefined };
	    if (last) last.next = task;
	    if (!head) {
	      head = task;
	      notify();
	    } last = task;
	  };
	};


/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 25.4.1.5 NewPromiseCapability(C)
	var aFunction = __webpack_require__(23);
	
	function PromiseCapability(C) {
	  var resolve, reject;
	  this.promise = new C(function ($$resolve, $$reject) {
	    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
	    resolve = $$resolve;
	    reject = $$reject;
	  });
	  this.resolve = aFunction(resolve);
	  this.reject = aFunction(reject);
	}
	
	module.exports.f = function (C) {
	  return new PromiseCapability(C);
	};


/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var regexpFlags = __webpack_require__(313);
	
	var nativeExec = RegExp.prototype.exec;
	// This always refers to the native implementation, because the
	// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
	// which loads this file before patching the method.
	var nativeReplace = String.prototype.replace;
	
	var patchedExec = nativeExec;
	
	var LAST_INDEX = 'lastIndex';
	
	var UPDATES_LAST_INDEX_WRONG = (function () {
	  var re1 = /a/,
	      re2 = /b*/g;
	  nativeExec.call(re1, 'a');
	  nativeExec.call(re2, 'a');
	  return re1[LAST_INDEX] !== 0 || re2[LAST_INDEX] !== 0;
	})();
	
	// nonparticipating capturing group, copied from es5-shim's String#split patch.
	var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;
	
	var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED;
	
	if (PATCH) {
	  patchedExec = function exec(str) {
	    var re = this;
	    var lastIndex, reCopy, match, i;
	
	    if (NPCG_INCLUDED) {
	      reCopy = new RegExp('^' + re.source + '$(?!\\s)', regexpFlags.call(re));
	    }
	    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re[LAST_INDEX];
	
	    match = nativeExec.call(re, str);
	
	    if (UPDATES_LAST_INDEX_WRONG && match) {
	      re[LAST_INDEX] = re.global ? match.index + match[0].length : lastIndex;
	    }
	    if (NPCG_INCLUDED && match && match.length > 1) {
	      // Fix browsers whose `exec` methods don't consistently return `undefined`
	      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
	      // eslint-disable-next-line no-loop-func
	      nativeReplace.call(match[0], reCopy, function () {
	        for (i = 1; i < arguments.length - 2; i++) {
	          if (arguments[i] === undefined) match[i] = undefined;
	        }
	      });
	    }
	
	    return match;
	  };
	}
	
	module.exports = patchedExec;


/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var isObject = __webpack_require__(7);
	var anObject = __webpack_require__(4);
	var check = function (O, proto) {
	  anObject(O);
	  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
	};
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
	    function (test, buggy, set) {
	      try {
	        set = __webpack_require__(46)(Function.call, __webpack_require__(37).f(Object.prototype, '__proto__').set, 2);
	        set(test, []);
	        buggy = !(test instanceof Array);
	      } catch (e) { buggy = true; }
	      return function setPrototypeOf(O, proto) {
	        check(O, proto);
	        if (buggy) O.__proto__ = proto;
	        else set(O, proto);
	        return O;
	      };
	    }({}, false) : undefined),
	  check: check
	};


/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(316)('keys');
	var uid = __webpack_require__(143);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};


/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

	// helper for String#{startsWith, endsWith, includes}
	var isRegExp = __webpack_require__(459);
	var defined = __webpack_require__(67);
	
	module.exports = function (that, searchString, NAME) {
	  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
	  return String(defined(that));
	};


/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var toInteger = __webpack_require__(48);
	var defined = __webpack_require__(67);
	
	module.exports = function repeat(count) {
	  var str = String(defined(this));
	  var res = '';
	  var n = toInteger(count);
	  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
	  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
	  return res;
	};


/***/ }),
/* 724 */
/***/ (function(module, exports) {

	module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
	  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(46);
	var invoke = __webpack_require__(1097);
	var html = __webpack_require__(710);
	var cel = __webpack_require__(707);
	var global = __webpack_require__(5);
	var process = global.process;
	var setTask = global.setImmediate;
	var clearTask = global.clearImmediate;
	var MessageChannel = global.MessageChannel;
	var Dispatch = global.Dispatch;
	var counter = 0;
	var queue = {};
	var ONREADYSTATECHANGE = 'onreadystatechange';
	var defer, channel, port;
	var run = function () {
	  var id = +this;
	  // eslint-disable-next-line no-prototype-builtins
	  if (queue.hasOwnProperty(id)) {
	    var fn = queue[id];
	    delete queue[id];
	    fn();
	  }
	};
	var listener = function (event) {
	  run.call(event.data);
	};
	// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
	if (!setTask || !clearTask) {
	  setTask = function setImmediate(fn) {
	    var args = [];
	    var i = 1;
	    while (arguments.length > i) args.push(arguments[i++]);
	    queue[++counter] = function () {
	      // eslint-disable-next-line no-new-func
	      invoke(typeof fn == 'function' ? fn : Function(fn), args);
	    };
	    defer(counter);
	    return counter;
	  };
	  clearTask = function clearImmediate(id) {
	    delete queue[id];
	  };
	  // Node.js 0.8-
	  if (__webpack_require__(44)(process) == 'process') {
	    defer = function (id) {
	      process.nextTick(ctx(run, id, 1));
	    };
	  // Sphere (JS game engine) Dispatch API
	  } else if (Dispatch && Dispatch.now) {
	    defer = function (id) {
	      Dispatch.now(ctx(run, id, 1));
	    };
	  // Browsers with MessageChannel, includes WebWorkers
	  } else if (MessageChannel) {
	    channel = new MessageChannel();
	    port = channel.port2;
	    channel.port1.onmessage = listener;
	    defer = ctx(port.postMessage, port, 1);
	  // Browsers with postMessage, skip WebWorkers
	  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
	  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
	    defer = function (id) {
	      global.postMessage(id + '', '*');
	    };
	    global.addEventListener('message', listener, false);
	  // IE8-
	  } else if (ONREADYSTATECHANGE in cel('script')) {
	    defer = function (id) {
	      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
	        html.removeChild(this);
	        run.call(id);
	      };
	    };
	  // Rest old browsers
	  } else {
	    defer = function (id) {
	      setTimeout(ctx(run, id, 1), 0);
	    };
	  }
	}
	module.exports = {
	  set: setTask,
	  clear: clearTask
	};


/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(5);
	var DESCRIPTORS = __webpack_require__(14);
	var LIBRARY = __webpack_require__(93);
	var $typed = __webpack_require__(467);
	var hide = __webpack_require__(25);
	var redefineAll = __webpack_require__(140);
	var fails = __webpack_require__(6);
	var anInstance = __webpack_require__(134);
	var toInteger = __webpack_require__(48);
	var toLength = __webpack_require__(11);
	var toIndex = __webpack_require__(1116);
	var gOPN = __webpack_require__(137).f;
	var dP = __webpack_require__(16).f;
	var arrayFill = __webpack_require__(704);
	var setToStringTag = __webpack_require__(203);
	var ARRAY_BUFFER = 'ArrayBuffer';
	var DATA_VIEW = 'DataView';
	var PROTOTYPE = 'prototype';
	var WRONG_LENGTH = 'Wrong length!';
	var WRONG_INDEX = 'Wrong index!';
	var $ArrayBuffer = global[ARRAY_BUFFER];
	var $DataView = global[DATA_VIEW];
	var Math = global.Math;
	var RangeError = global.RangeError;
	// eslint-disable-next-line no-shadow-restricted-names
	var Infinity = global.Infinity;
	var BaseBuffer = $ArrayBuffer;
	var abs = Math.abs;
	var pow = Math.pow;
	var floor = Math.floor;
	var log = Math.log;
	var LN2 = Math.LN2;
	var BUFFER = 'buffer';
	var BYTE_LENGTH = 'byteLength';
	var BYTE_OFFSET = 'byteOffset';
	var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
	var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
	var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;
	
	// IEEE754 conversions based on https://github.com/feross/ieee754
	function packIEEE754(value, mLen, nBytes) {
	  var buffer = new Array(nBytes);
	  var eLen = nBytes * 8 - mLen - 1;
	  var eMax = (1 << eLen) - 1;
	  var eBias = eMax >> 1;
	  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
	  var i = 0;
	  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
	  var e, m, c;
	  value = abs(value);
	  // eslint-disable-next-line no-self-compare
	  if (value != value || value === Infinity) {
	    // eslint-disable-next-line no-self-compare
	    m = value != value ? 1 : 0;
	    e = eMax;
	  } else {
	    e = floor(log(value) / LN2);
	    if (value * (c = pow(2, -e)) < 1) {
	      e--;
	      c *= 2;
	    }
	    if (e + eBias >= 1) {
	      value += rt / c;
	    } else {
	      value += rt * pow(2, 1 - eBias);
	    }
	    if (value * c >= 2) {
	      e++;
	      c /= 2;
	    }
	    if (e + eBias >= eMax) {
	      m = 0;
	      e = eMax;
	    } else if (e + eBias >= 1) {
	      m = (value * c - 1) * pow(2, mLen);
	      e = e + eBias;
	    } else {
	      m = value * pow(2, eBias - 1) * pow(2, mLen);
	      e = 0;
	    }
	  }
	  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
	  e = e << mLen | m;
	  eLen += mLen;
	  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
	  buffer[--i] |= s * 128;
	  return buffer;
	}
	function unpackIEEE754(buffer, mLen, nBytes) {
	  var eLen = nBytes * 8 - mLen - 1;
	  var eMax = (1 << eLen) - 1;
	  var eBias = eMax >> 1;
	  var nBits = eLen - 7;
	  var i = nBytes - 1;
	  var s = buffer[i--];
	  var e = s & 127;
	  var m;
	  s >>= 7;
	  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
	  m = e & (1 << -nBits) - 1;
	  e >>= -nBits;
	  nBits += mLen;
	  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
	  if (e === 0) {
	    e = 1 - eBias;
	  } else if (e === eMax) {
	    return m ? NaN : s ? -Infinity : Infinity;
	  } else {
	    m = m + pow(2, mLen);
	    e = e - eBias;
	  } return (s ? -1 : 1) * m * pow(2, e - mLen);
	}
	
	function unpackI32(bytes) {
	  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
	}
	function packI8(it) {
	  return [it & 0xff];
	}
	function packI16(it) {
	  return [it & 0xff, it >> 8 & 0xff];
	}
	function packI32(it) {
	  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
	}
	function packF64(it) {
	  return packIEEE754(it, 52, 8);
	}
	function packF32(it) {
	  return packIEEE754(it, 23, 4);
	}
	
	function addGetter(C, key, internal) {
	  dP(C[PROTOTYPE], key, { get: function () { return this[internal]; } });
	}
	
	function get(view, bytes, index, isLittleEndian) {
	  var numIndex = +index;
	  var intIndex = toIndex(numIndex);
	  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
	  var store = view[$BUFFER]._b;
	  var start = intIndex + view[$OFFSET];
	  var pack = store.slice(start, start + bytes);
	  return isLittleEndian ? pack : pack.reverse();
	}
	function set(view, bytes, index, conversion, value, isLittleEndian) {
	  var numIndex = +index;
	  var intIndex = toIndex(numIndex);
	  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
	  var store = view[$BUFFER]._b;
	  var start = intIndex + view[$OFFSET];
	  var pack = conversion(+value);
	  for (var i = 0; i < bytes; i++) store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
	}
	
	if (!$typed.ABV) {
	  $ArrayBuffer = function ArrayBuffer(length) {
	    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
	    var byteLength = toIndex(length);
	    this._b = arrayFill.call(new Array(byteLength), 0);
	    this[$LENGTH] = byteLength;
	  };
	
	  $DataView = function DataView(buffer, byteOffset, byteLength) {
	    anInstance(this, $DataView, DATA_VIEW);
	    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
	    var bufferLength = buffer[$LENGTH];
	    var offset = toInteger(byteOffset);
	    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
	    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
	    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
	    this[$BUFFER] = buffer;
	    this[$OFFSET] = offset;
	    this[$LENGTH] = byteLength;
	  };
	
	  if (DESCRIPTORS) {
	    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
	    addGetter($DataView, BUFFER, '_b');
	    addGetter($DataView, BYTE_LENGTH, '_l');
	    addGetter($DataView, BYTE_OFFSET, '_o');
	  }
	
	  redefineAll($DataView[PROTOTYPE], {
	    getInt8: function getInt8(byteOffset) {
	      return get(this, 1, byteOffset)[0] << 24 >> 24;
	    },
	    getUint8: function getUint8(byteOffset) {
	      return get(this, 1, byteOffset)[0];
	    },
	    getInt16: function getInt16(byteOffset /* , littleEndian */) {
	      var bytes = get(this, 2, byteOffset, arguments[1]);
	      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
	    },
	    getUint16: function getUint16(byteOffset /* , littleEndian */) {
	      var bytes = get(this, 2, byteOffset, arguments[1]);
	      return bytes[1] << 8 | bytes[0];
	    },
	    getInt32: function getInt32(byteOffset /* , littleEndian */) {
	      return unpackI32(get(this, 4, byteOffset, arguments[1]));
	    },
	    getUint32: function getUint32(byteOffset /* , littleEndian */) {
	      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
	    },
	    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
	      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
	    },
	    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
	      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
	    },
	    setInt8: function setInt8(byteOffset, value) {
	      set(this, 1, byteOffset, packI8, value);
	    },
	    setUint8: function setUint8(byteOffset, value) {
	      set(this, 1, byteOffset, packI8, value);
	    },
	    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
	      set(this, 2, byteOffset, packI16, value, arguments[2]);
	    },
	    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
	      set(this, 2, byteOffset, packI16, value, arguments[2]);
	    },
	    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packI32, value, arguments[2]);
	    },
	    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packI32, value, arguments[2]);
	    },
	    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packF32, value, arguments[2]);
	    },
	    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
	      set(this, 8, byteOffset, packF64, value, arguments[2]);
	    }
	  });
	} else {
	  if (!fails(function () {
	    $ArrayBuffer(1);
	  }) || !fails(function () {
	    new $ArrayBuffer(-1); // eslint-disable-line no-new
	  }) || fails(function () {
	    new $ArrayBuffer(); // eslint-disable-line no-new
	    new $ArrayBuffer(1.5); // eslint-disable-line no-new
	    new $ArrayBuffer(NaN); // eslint-disable-line no-new
	    return $ArrayBuffer.name != ARRAY_BUFFER;
	  })) {
	    $ArrayBuffer = function ArrayBuffer(length) {
	      anInstance(this, $ArrayBuffer);
	      return new BaseBuffer(toIndex(length));
	    };
	    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
	    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
	      if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
	    }
	    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
	  }
	  // iOS Safari 7.x bug
	  var view = new $DataView(new $ArrayBuffer(2));
	  var $setInt8 = $DataView[PROTOTYPE].setInt8;
	  view.setInt8(0, 2147483648);
	  view.setInt8(1, 2147483649);
	  if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
	    setInt8: function setInt8(byteOffset, value) {
	      $setInt8.call(this, byteOffset, value << 24 >> 24);
	    },
	    setUint8: function setUint8(byteOffset, value) {
	      $setInt8.call(this, byteOffset, value << 24 >> 24);
	    }
	  }, true);
	}
	setToStringTag($ArrayBuffer, ARRAY_BUFFER);
	setToStringTag($DataView, DATA_VIEW);
	hide($DataView[PROTOTYPE], $typed.VIEW, true);
	exports[ARRAY_BUFFER] = $ArrayBuffer;
	exports[DATA_VIEW] = $DataView;


/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(5);
	var core = __webpack_require__(45);
	var LIBRARY = __webpack_require__(93);
	var wksExt = __webpack_require__(1117);
	var defineProperty = __webpack_require__(16).f;
	module.exports = function (name) {
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
	};


/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

	var classof = __webpack_require__(201);
	var ITERATOR = __webpack_require__(10)('iterator');
	var Iterators = __webpack_require__(202);
	module.exports = __webpack_require__(45).getIteratorMethod = function (it) {
	  if (it != undefined) return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};


/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(92);
	var step = __webpack_require__(1100);
	var Iterators = __webpack_require__(202);
	var toIObject = __webpack_require__(39);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(714)(Array, 'Array', function (iterated, kind) {
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return step(1);
	  }
	  if (kind == 'keys') return step(0, index);
	  if (kind == 'values') return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');


/***/ }),
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */,
/* 812 */,
/* 813 */,
/* 814 */,
/* 815 */,
/* 816 */,
/* 817 */,
/* 818 */,
/* 819 */,
/* 820 */,
/* 821 */,
/* 822 */,
/* 823 */,
/* 824 */,
/* 825 */,
/* 826 */,
/* 827 */,
/* 828 */,
/* 829 */,
/* 830 */,
/* 831 */,
/* 832 */,
/* 833 */,
/* 834 */,
/* 835 */,
/* 836 */,
/* 837 */,
/* 838 */,
/* 839 */,
/* 840 */,
/* 841 */,
/* 842 */,
/* 843 */,
/* 844 */,
/* 845 */,
/* 846 */,
/* 847 */,
/* 848 */,
/* 849 */,
/* 850 */,
/* 851 */,
/* 852 */,
/* 853 */,
/* 854 */,
/* 855 */,
/* 856 */,
/* 857 */,
/* 858 */,
/* 859 */,
/* 860 */,
/* 861 */,
/* 862 */,
/* 863 */,
/* 864 */,
/* 865 */,
/* 866 */,
/* 867 */,
/* 868 */,
/* 869 */,
/* 870 */,
/* 871 */,
/* 872 */,
/* 873 */,
/* 874 */,
/* 875 */,
/* 876 */,
/* 877 */,
/* 878 */,
/* 879 */,
/* 880 */,
/* 881 */,
/* 882 */,
/* 883 */,
/* 884 */,
/* 885 */,
/* 886 */,
/* 887 */,
/* 888 */,
/* 889 */,
/* 890 */,
/* 891 */,
/* 892 */,
/* 893 */,
/* 894 */,
/* 895 */,
/* 896 */,
/* 897 */,
/* 898 */,
/* 899 */,
/* 900 */,
/* 901 */,
/* 902 */,
/* 903 */,
/* 904 */,
/* 905 */,
/* 906 */,
/* 907 */,
/* 908 */,
/* 909 */,
/* 910 */,
/* 911 */,
/* 912 */,
/* 913 */,
/* 914 */,
/* 915 */,
/* 916 */,
/* 917 */,
/* 918 */,
/* 919 */,
/* 920 */,
/* 921 */,
/* 922 */,
/* 923 */,
/* 924 */,
/* 925 */,
/* 926 */,
/* 927 */,
/* 928 */,
/* 929 */,
/* 930 */,
/* 931 */,
/* 932 */,
/* 933 */,
/* 934 */,
/* 935 */,
/* 936 */,
/* 937 */,
/* 938 */,
/* 939 */,
/* 940 */,
/* 941 */,
/* 942 */,
/* 943 */,
/* 944 */,
/* 945 */,
/* 946 */,
/* 947 */,
/* 948 */,
/* 949 */,
/* 950 */,
/* 951 */,
/* 952 */,
/* 953 */,
/* 954 */,
/* 955 */,
/* 956 */,
/* 957 */,
/* 958 */,
/* 959 */,
/* 960 */,
/* 961 */,
/* 962 */,
/* 963 */,
/* 964 */,
/* 965 */,
/* 966 */,
/* 967 */,
/* 968 */,
/* 969 */,
/* 970 */,
/* 971 */,
/* 972 */,
/* 973 */,
/* 974 */,
/* 975 */,
/* 976 */,
/* 977 */,
/* 978 */,
/* 979 */,
/* 980 */,
/* 981 */,
/* 982 */,
/* 983 */,
/* 984 */,
/* 985 */,
/* 986 */,
/* 987 */,
/* 988 */,
/* 989 */,
/* 990 */,
/* 991 */,
/* 992 */,
/* 993 */,
/* 994 */,
/* 995 */,
/* 996 */,
/* 997 */,
/* 998 */,
/* 999 */,
/* 1000 */,
/* 1001 */,
/* 1002 */,
/* 1003 */,
/* 1004 */,
/* 1005 */,
/* 1006 */,
/* 1007 */,
/* 1008 */,
/* 1009 */,
/* 1010 */,
/* 1011 */,
/* 1012 */,
/* 1013 */,
/* 1014 */,
/* 1015 */,
/* 1016 */,
/* 1017 */,
/* 1018 */,
/* 1019 */,
/* 1020 */,
/* 1021 */,
/* 1022 */,
/* 1023 */,
/* 1024 */,
/* 1025 */,
/* 1026 */,
/* 1027 */,
/* 1028 */,
/* 1029 */,
/* 1030 */,
/* 1031 */,
/* 1032 */,
/* 1033 */,
/* 1034 */,
/* 1035 */,
/* 1036 */,
/* 1037 */,
/* 1038 */,
/* 1039 */,
/* 1040 */,
/* 1041 */,
/* 1042 */,
/* 1043 */,
/* 1044 */,
/* 1045 */,
/* 1046 */,
/* 1047 */,
/* 1048 */,
/* 1049 */,
/* 1050 */,
/* 1051 */,
/* 1052 */,
/* 1053 */,
/* 1054 */,
/* 1055 */,
/* 1056 */,
/* 1057 */,
/* 1058 */,
/* 1059 */,
/* 1060 */,
/* 1061 */,
/* 1062 */,
/* 1063 */,
/* 1064 */,
/* 1065 */,
/* 1066 */,
/* 1067 */,
/* 1068 */,
/* 1069 */,
/* 1070 */,
/* 1071 */,
/* 1072 */,
/* 1073 */,
/* 1074 */,
/* 1075 */,
/* 1076 */,
/* 1077 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1128);
	module.exports = 'ngAnimate';


/***/ }),
/* 1078 */,
/* 1079 */,
/* 1080 */,
/* 1081 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = [];
	
	var cssClassNameFilter = function cssClassNameFilter() {
	  return function (str) {
	    if (!str) return '';
	
	    return str.replace(/(?:^\w|[A-Z]|\b\w)/g, function (letter, index) {
	      return index === 0 ? letter.toLowerCase() : letter.toUpperCase();
	    }).replace(/\s+/g, '');
	  };
	};
	
	cssClassNameFilter.$inject = $inject;
	
	exports['default'] = cssClassNameFilter;
	module.exports = exports['default'];

/***/ }),
/* 1082 */,
/* 1083 */
/***/ (function(module, exports) {

	// Start Case Is A Cool Thing
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var startCaseFilter = function startCaseFilter() {
	  return function (string) {
	    return _.startCase(string);
	  };
	};
	
	// Title Case Is Also a Cool Thing
	var titleCaseFilter = function titleCaseFilter() {
	  return function (string) {
	    if (!string) return '';
	
	    var smallWords = /^(a|an|and|as|at|but|by|en|for|if|in|nor|of|on|or|per|the|to|vs?\.?|via)$/i;
	    string = string.toLowerCase();
	
	    return string.replace(/[A-Za-z0-9\u00C0-\u00FF]+[^\s-]*/g, function (match, index, title) {
	      if (index > 0 && index + match.length !== title.length && match.search(smallWords) > -1 && title.charAt(index - 2) !== ':' && (title.charAt(index + match.length) !== '-' || title.charAt(index - 1) === '-') && title.charAt(index - 1).search(/[^\s-]/) < 0) {
	        return match.toLowerCase();
	      }
	
	      if (match.substr(1).search(/[A-Z]|\../) > -1) {
	        return match;
	      }
	
	      return match.charAt(0).toUpperCase() + match.substr(1);
	    });
	  };
	};
	
	// Returns the length of a string.
	var stringLengthFilter = function stringLengthFilter() {
	  return function (string) {
	    return string == null ? 0 : string.length;
	  };
	};
	
	exports['default'] = {
	  startCaseFilter: startCaseFilter,
	  titleCaseFilter: titleCaseFilter,
	  stringLengthFilter: stringLengthFilter
	};
	module.exports = exports['default'];

/***/ }),
/* 1084 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['$state', 'lbDialogService'];
	
	var locationService = function locationService($state, lbDialogService) {
	  var searchDefaults = {
	    Hotel: 0,
	    Car: 0,
	    Rail: 0,
	    Flight: 0,
	    GroundTransport: 0
	  };
	
	  var service = {
	    currentSearchType: undefined,
	    searchIndex: searchDefaults,
	    reset: reset,
	    updateCurrentSearchType: updateCurrentSearchType,
	    getCurrentSearchType: getCurrentSearchType,
	    increaseSearchIndex: increaseSearchIndex,
	    nextPage: nextPage,
	    gotoSection: gotoSection,
	    cancelBooking: cancelBooking,
	    getCurrentSearchSegment: getCurrentSearchSegment
	  };
	
	  var sessionSearchIndex = JSON.parse(sessionStorage.getItem('locationService:searchIndex'));
	
	  if (sessionSearchIndex) {
	    service.searchIndex = sessionSearchIndex;
	  }
	
	  function reset() {
	    service.currentSearchType = undefined;
	    service.searchIndex = searchDefaults;
	
	    sessionStorage.removeItem('locationService:currentSearchType');
	    sessionStorage.removeItem('locationService:searchIndex');
	  }
	
	  function updateCurrentSearchType(type) {
	    service.currentSearchType = type;
	    sessionStorage.setItem('locationService:currentSearchType', service.currentSearchType);
	  }
	
	  function getCurrentSearchType() {
	    if (service.currentSearchType) {
	      return service.currentSearchType;
	    }
	    var sessionServiceType = sessionStorage.getItem('locationService:currentSearchType');
	    service.currentSearchType = sessionServiceType;
	    return sessionServiceType;
	  }
	
	  function increaseSearchIndex(type, increment) {
	    increment = increment || 1;
	
	    var newIndex = service.searchIndex[type] + increment;
	
	    setSearchIndex(type, newIndex);
	  }
	
	  function setSearchIndex(type, value) {
	    service.searchIndex[type] = value;
	    sessionStorage.setItem('locationService:searchIndex', JSON.stringify(service.searchIndex));
	  }
	
	  function nextPage(searchObj, selectedItems) {
	    var searchTypes = searchObj.SearchTypes;
	    var type = service.currentSearchType;
	    var nextType = type;
	    if (type) {
	      var searchTypeCompleted = searchObj[type + 's'].length === service.searchIndex[type];
	
	      if (searchTypeCompleted) {
	        setSearchIndex(type, 0);
	
	        var searchTypeIndex = searchTypes.indexOf(type);
	        var nextSearchTypeIndex = searchTypeIndex + 1;
	
	        if (nextSearchTypeIndex < searchTypes.length) {
	          nextType = searchTypes[nextSearchTypeIndex];
	        } else {
	          nextType = 'Itinerary';
	        }
	      }
	    } else {
	      nextType = searchObj.SearchTypes[0];
	    }
	
	    gotoSection(nextType, selectedItems);
	  }
	
	  function gotoSection(section, selectedItems) {
	    if (section == 'Itinerary') {
	      var msie = document.documentMode;
	
	      if (msie === 9) {
	        window.location.href = '/#/itinerary';
	        location.reload(true);
	      } else {
	        $state.go('app.itinerary', {}, { reload: true });
	      }
	      return;
	    }
	    switch (section) {
	      case 'Flight':
	        $state.go('app.booking.segment.flights', { selectedItems: selectedItems }, { reload: true });
	        break;
	      case 'Rail':
	        $state.go('app.booking.segment.rail', {}, { reload: true });
	        break;
	      case 'Hotel':
	        $state.go('app.booking.segment.hotels', {}, { reload: true });
	        break;
	      case 'GroundTransport':
	        $state.go('app.booking.segment.groundtransportation', {}, { reload: true });
	        break;
	      case 'Car':
	        $state.go('app.booking.segment.cars', {}, { reload: true });
	        break;
	      default:
	        service.reset();
	        console.warn('NO NEXTPAGE FOUND!');
	    }
	  }
	
	  function cancelBooking() {
	    var isModification = arguments.length <= 0 || arguments[0] === undefined ? false : arguments[0];
	
	    var dialogOptions = {
	      title: isModification ? 'This will cancel the current modifications' : 'This will cancel the existing booking.',
	      message: 'Are you sure you want to do this?',
	      warningLevel: 'warning',
	      submitButtonText: 'OK'
	    };
	
	    lbDialogService.show(dialogOptions).then(function () {
	      $state.go('app.home');
	    });
	  }
	
	  function getCurrentSearchSegment(search) {
	    var currentSearchType = service.getCurrentSearchType();
	    var currentSearchIndex = service.searchIndex[currentSearchType];
	
	    return search[currentSearchType + 's'][currentSearchIndex];
	  }
	
	  return service;
	};
	
	locationService.$inject = $inject;
	
	exports['default'] = locationService;
	module.exports = exports['default'];

/***/ }),
/* 1085 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['moment', '$http', 'APP_CONFIG'];
	
	var seatMapService = function seatMapService(moment, $http, APP_CONFIG) {
	  var service = {
	    init: init,
	    get: get,
	    putSeat: bookSeat,
	    saveSeat: saveSeat,
	    formatDates: formatDates,
	    setActiveSeatMap: setActiveSeatMap,
	    deactivateSeat: deactivateSeat,
	    findIdentifierIn: findIdentifierIn,
	    setActive: setActive,
	    buildDeck: buildDeck,
	    resetSeatMap: resetSeatMap,
	    cleanActiveSeats: cleanActiveSeats,
	    findSeat: findSeat,
	    showLegs: showLegs,
	    lookUpSeatNumber: lookUpSeatNumber,
	    findReplaceFlight: findReplaceFlight,
	    isExitRowLeft: isExitRowLeft,
	    isExitRowRight: isExitRowRight,
	    hasFacilities: hasFacilities,
	    paxArray: [],
	    activePax: undefined,
	    activeFlight: undefined,
	    activeTransport: undefined,
	    activeSeatMap: undefined,
	    activeDeck: undefined,
	    activeSeat: undefined,
	    showKey: false,
	    showSeatSelector: false,
	    savingSeatSelection: false,
	    error: false
	  };
	
	  function init(passengers, paxId) {
	    service.paxArray = [];
	    service.activePax = undefined;
	    service.activeFlight = undefined;
	    service.activeSeatMap = undefined;
	    service.activeDeck = undefined;
	    service.activeSeat = undefined;
	    service.showKey = false;
	    service.savingSeatSelection = false;
	    service.error = false;
	
	    passengers.forEach(function (pax) {
	      if (pax.Flights.length > 0) {
	        pax.Flights = service.formatDates(pax.Flights);
	        if (pax.Identifier === paxId) {
	          service.paxArray.unshift(pax);
	        } else {
	          service.paxArray.push(pax);
	        }
	      }
	    });
	  }
	
	  function get(itineraryId, passengerId, flightId) {
	    var itineraryUrl = APP_CONFIG.MOCK_DATA.active ? APP_CONFIG.MOCK_DATA.itinerary : APP_CONFIG.api.itinerary;
	
	    return $http.get('' + itineraryUrl + itineraryId + '/passenger/' + passengerId + '/flight/' + flightId + '/seatmap', {}).then(function (_ref) {
	      var data = _ref.data;
	      return data;
	    });
	  }
	
	  function bookSeat(seat, flight, transport, payment) {
	    return putSeat(seat, flight, transport, payment, 'seat');
	  }
	
	  function saveSeat(seat, flight, transport, payment) {
	    return putSeat(seat, flight, transport, payment, 'seatitinerary');
	  }
	
	  function putSeat(seat, flight, transport, payment, endpoint) {
	    var itineraryUrl = APP_CONFIG.MOCK_DATA.active ? APP_CONFIG.MOCK_DATA.itinerary : APP_CONFIG.api.itinerary;
	
	    var seatRequest = buildSeatRequest(seat, flight, transport, payment);
	
	    return $http.put('' + itineraryUrl + flight.ItineraryIdentifier + '/passenger/' + flight.PassengerIdentifier + '/flight/' + flight.Identifier + '/' + endpoint, seatRequest).then(function (_ref2) {
	      var data = _ref2.data;
	
	      service.paxArray.forEach(function (pax) {
	        return pax.Flights.forEach(function (paxFlight) {
	          if (paxFlight !== flight && paxFlight.showStops) {
	            paxFlight.showStops = false;
	            paxFlight.seatmaps = false;
	            service.showLegs(paxFlight);
	          }
	        });
	      });
	      return data;
	    });
	  }
	
	  function buildSeatRequest(seat, flight, transport, payment) {
	    var seatObj = {
	      PaymentMethod: null,
	      Seats: {
	        SeatNumber: seat.Id,
	        Carrier: transport.Operator,
	        FlightNumber: transport.Id,
	        OriginLocationCode: transport.Origin,
	        LocationCode: transport.Destination
	      }
	    };
	
	    if (payment) {
	      var thisSeat = seatObj.Seats;
	
	      thisSeat.SeatAmount = seat.Price.Amount;
	      thisSeat.TaxAmount = seat.Price.SeatTaxAmount;
	      thisSeat.SeatCurrencyCode = seat.Price.CurrencyCode;
	      thisSeat.BaseCurrency = {
	        Code: seat.Price.CurrencyCode,
	        TaxAmount: seat.Price.SeatTaxAmount,
	        FeeAmount: 0,
	        Amount: seat.Price.Amount,
	        TotalAmount: seat.Price.Amount
	      };
	
	      seatObj.PaymentMethod = {
	        SectorGroupIdentifier: flight.GroupIdentifier,
	        SectorIdentifier: flight.Identifier,
	        Type: 'Seat'
	      };
	
	      if (payment.PaymentType === 'Card') {
	        seatObj.PaymentMethod.Card = payment;
	      }
	
	      if (payment.PaymentType === 'Invoice') {
	        seatObj.PaymentMethod.Invoice = {
	          Reference: 'Invoice'
	        };
	      }
	    }
	
	    return seatObj;
	  }
	
	  function formatDates(flights) {
	    return flights.map(function (flight) {
	      flight.dateFormatted = moment(flight.Departure.Date, 'YYYY-MM-DD').format('ddd, MMM M');
	      return flight;
	    });
	  }
	
	  function setActiveSeatMap(seatMap) {
	    service.deactivateSeat();
	    service.activeSeatMap = seatMap;
	  }
	
	  function deactivateSeat() {
	    if (service.activeSeat) {
	      service.activeSeat.active = false;
	    }
	
	    service.activeSeat = undefined;
	  }
	
	  function findIdentifierIn(id, obj, prop) {
	    var result = undefined;
	
	    obj[prop].every(function (x) {
	      if (x.Identifier === id) {
	        result = x;
	        return false;
	      }
	
	      return true;
	    });
	
	    return result;
	  }
	
	  function setActive(data, target) {
	    if (service[target]) {
	      service[target].active = false;
	    }
	
	    data.active = true;
	    service[target] = data;
	
	    return data;
	  }
	
	  function buildDeck(deck) {
	    var formatted = [];
	
	    deck.Cabins.forEach(function (cabin) {
	      cabin.formattedRows = buildRows(cabin.Rows);
	      cabin.maxRowItems = maxRowItems(cabin.formattedRows);
	      formatted.push(cabin);
	    });
	
	    return formatted;
	  }
	
	  function buildRows(rows) {
	    return _.flowRight(functionalRowFormat, purgeEmptyRows, combiningFunctionTypes, addAisles)(rows);
	  }
	
	  function addAisles(rows) {
	    var results = [];
	
	    rows.forEach(function (row, rowIndex) {
	      var insertAt = [];
	
	      results.push({ Id: row.Id, ExitRow: row.ExitRow, OverWing: row.ExitRow, Items: angular.copy(row.Items) });
	
	      row.Items.forEach(function (item, itemIndex) {
	        if (item.RowLocation === 'WindowAisle' || item.RowLocation === 'Aisle') {
	          insertAt.push({ itemIndex: itemIndex + 1 });
	        }
	      });
	
	      if (insertAt.length > 0) {
	        results[rowIndex].Items.splice(insertAt[0].itemIndex, 0, { FunctionType: 'Aisle' });
	      }
	
	      if (insertAt.length > 1 && insertAt[insertAt.length - 1].itemIndex - insertAt[0].itemIndex > 1) {
	        results[rowIndex].Items.splice(insertAt[insertAt.length - 1].itemIndex, 0, { FunctionType: 'Aisle' });
	      }
	    });
	
	    return results;
	  }
	
	  function combiningFunctionTypes(rows) {
	    var results = [];
	    var rowIndex = 0;
	
	    rows.forEach(function (row) {
	      results.push({ Id: row.Id, ExitRow: row.ExitRow, OverWing: row.ExitRow, Items: [] });
	      var functionalItemBlock = undefined;
	      var prevItem = undefined;
	
	      row.Items.forEach(function (item) {
	        results[rowIndex].Items.push(item);
	
	        var isFunctionalItem = isFunctionalItemFn(item);
	
	        if (isFunctionalItem && prevItem && prevItem.FunctionType === item.FunctionType && prevItem.Location === item.Location) {
	          item.hide = true;
	          if (functionalItemBlock) {
	            functionalItemBlock.expandRight += 1;
	          } else {
	            functionalItemBlock = prevItem;
	            functionalItemBlock.expandRight = 2;
	          }
	          functionalItemBlock.RowLocation = item.RowLocation;
	        } else {
	          prevItem = undefined;
	          functionalItemBlock = undefined;
	        }
	
	        if (isFunctionalItem) {
	          prevItem = item;
	        }
	      });
	
	      rowIndex = rowIndex + 1;
	    });
	
	    return results;
	  }
	
	  function expandRowVertical(rows) {
	    var prevRow = undefined;
	
	    rows.forEach(function (row) {
	      row.Items.forEach(function (item, itemIndex) {
	        var isFunctionalItem = isFunctionalItemFn(item);
	
	        if (prevRow) {
	          var prevRowItem = prevRow.Items[itemIndex];
	          if (prevRowItem && isFunctionalItem && item.FunctionType === prevRowItem.FunctionType && item.expandRight === prevRowItem.expandRight) {
	            prevRowItem.expandDown = 2; // Limit to 2 as any more looks stupid when rendered.
	            item.hide = true;
	          }
	        }
	      });
	
	      prevRow = row;
	    });
	
	    return rows;
	  }
	
	  function purgeEmptyRows(rows) {
	    rows.forEach(function (row) {
	      var hide = true;
	      var noSeats = true;
	
	      row.Items.forEach(function (item) {
	        if (!item.hide) {
	          hide = false;
	        }
	
	        if (item.hasOwnProperty('Available')) {
	          noSeats = false;
	        }
	      });
	
	      row.noSeats = noSeats;
	      row.hide = hide;
	    });
	
	    return rows;
	  }
	
	  function functionalRowFormat(rows) {
	    rows.forEach(function (row) {
	      if (row.noSeats && !row.hide) {
	        (function () {
	          var centreItem = {
	            FunctionType: 'Combined',
	            Location: 'Centre',
	            types: []
	          };
	
	          var indexes = [];
	
	          row.Items.forEach(function (item, index) {
	            if (item.Location === 'Centre' && item.FunctionType != 'Storage') {
	              centreItem.types.push(item.FunctionType);
	              indexes.push(index);
	            }
	          });
	
	          _.pullAt(row.Items, indexes);
	          centreItem.types = _.uniq(centreItem.types);
	
	          if (centreItem.types.length > 0) {
	            row.Items.push(centreItem);
	          }
	        })();
	      }
	    });
	
	    return rows;
	  }
	
	  function maxRowItems(rows) {
	    var max = 0;
	
	    rows.forEach(function (row) {
	      if (row.Items.length > max) {
	        max = row.Items.length;
	      }
	    });
	
	    return max;
	  }
	
	  function isFunctionalItemFn(item) {
	    return item.hasOwnProperty('FunctionType') && item.FunctionType !== 'Aisle' && item.FunctionType !== 'NoSeat';
	  }
	
	  function resetSeatMap() {
	    service.activeSeatMap = undefined;
	
	    if (service.activeDeck) {
	      service.activeDeck.active = false;
	      service.activeDeck = undefined;
	    }
	  }
	
	  function cleanActiveSeats(seats) {
	    seats.Decks.forEach(function (deck) {
	      deck.Cabins.forEach(function (cabin) {
	        if (cabin.formattedRows) {
	          cabin.formattedRows.forEach(function (row) {
	            row.Items.map(function (seat) {
	              seat.active = false;
	              return seat;
	            });
	          });
	        }
	      });
	    });
	  }
	
	  function findSeat(deck, seatNumber) {
	    deck.Cabins.forEach(function (cabin) {
	      cabin.formattedRows.forEach(function (row) {
	        row.Items.map(function (seat) {
	          if (seat.Id === seatNumber) {
	            seat.active = true;
	          }
	          return seat;
	        });
	      });
	    });
	  }
	
	  function refreshLegs(flight) {}
	
	  function showLegs(flight) {
	    if (!flight.showStops) {
	      flight.showStops = true;
	      flight.loadingSeatMaps = true;
	
	      return service.get(flight.ItineraryIdentifier, flight.PassengerIdentifier, flight.Identifier).then(function (data) {
	        flight.loadingSeatMaps = false;
	        flight.seatmaps = true;
	        flight.transports = data.Transport;
	      });
	    }
	  }
	
	  function lookUpSeatNumber(journey, transport) {
	    var origin = transport.Origin;
	
	    if (journey.Seat.OriginLocationCode === origin) {
	      return journey.Seat.SeatNumber;
	    }
	
	    var seat = undefined;
	
	    journey.Stops.forEach(function (stop) {
	      if (stop.DepartsCode === origin) {
	        seat = stop.Seat.SeatNumber;
	      }
	    });
	
	    return seat;
	  }
	
	  function findReplaceFlight(newFlight, paxArray) {
	    var pax = _.find(paxArray, function (pax) {
	      return pax.Identifier === newFlight.PassengerIdentifier;
	    });
	    var flight = _.find(pax.Flights, function (flight) {
	      return flight.Identifier === newFlight.Identifier;
	    });
	
	    _.merge(flight, newFlight);
	  }
	  function isExitRowLeft(row) {
	    if (row.ExitRow) return true;
	    if (row.Items && row.Items.some(function (item) {
	      return item.FunctionType === 'ExitDoor' && item.Location === 'Left';
	    })) return true;
	
	    return false;
	  }
	  function isExitRowRight(row) {
	    if (row.ExitRow) return true;
	    if (row.Items && row.Items.some(function (item) {
	      return item.FunctionType === 'ExitDoor' && item.Location === 'Right';
	    })) return true;
	    return false;
	  }
	  function hasFacilities(row) {
	    if (row.Items && row.Items.some(function (item) {
	      return item.FunctionType != 'ExitDoor' && item.FunctionType != 'Aisle';
	    })) return true;
	    return false;
	  }
	  return service;
	};
	
	seatMapService.$inject = $inject;
	
	exports['default'] = seatMapService;
	module.exports = exports['default'];

/***/ }),
/* 1086 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* angular-moment.js / v1.0.0 / (c) 2013, 2014, 2015, 2016 Uri Shaked / MIT Licence */
	
	'use strict';
	
	'format amd';
	/* global define */
	(function () {
	  'use strict';
	
	  function isUndefinedOrNull(val) {
	    return angular.isUndefined(val) || val === null;
	  }
	
	  function requireMoment() {
	    try {
	      return __webpack_require__(1124); // Using nw.js or browserify?
	    } catch (e) {
	      throw new Error('Please install moment via npm. Please reference to: https://github.com/urish/angular-moment'); // Add wiki/troubleshooting section?
	    }
	  }
	
	  function angularMoment(angular, moment) {
	    if (typeof moment === 'undefined') {
	      if (true) {
	        moment = requireMoment();
	      } else {
	        throw new Error('Moment cannot be found by angular-moment! Please reference to: https://github.com/urish/angular-moment'); // Add wiki/troubleshooting section?
	      }
	    }
	
	    /**
	     * @ngdoc overview
	     * @name angularMoment
	     *
	     * @description
	     * angularMoment module provides moment.js functionality for angular.js apps.
	     */
	    angular.module('angularMoment', [])
	
	    /**
	     * @ngdoc object
	     * @name angularMoment.config:angularMomentConfig
	     *
	     * @description
	     * Common configuration of the angularMoment module
	     */
	    .constant('angularMomentConfig', {
	      /**
	       * @ngdoc property
	       * @name angularMoment.config.angularMomentConfig#preprocess
	       * @propertyOf angularMoment.config:angularMomentConfig
	       * @returns {function} A preprocessor function that will be applied on all incoming dates
	       *
	       * @description
	       * Defines a preprocessor function to apply on all input dates (e.g. the input of `am-time-ago`,
	       * `amCalendar`, etc.). The function must return a `moment` object.
	       *
	       * @example
	       *   // Causes angular-moment to always treat the input values as unix timestamps
	       *   angularMomentConfig.preprocess = function(value) {
	       * 	   return moment.unix(value);
	       *   }
	       */
	      preprocess: null,
	
	      /**
	       * @ngdoc property
	       * @name angularMoment.config.angularMomentConfig#timezone
	       * @propertyOf angularMoment.config:angularMomentConfig
	       * @returns {string} The default timezone
	       *
	       * @description
	       * The default timezone (e.g. 'Europe/London'). Empty string by default (does not apply
	       * any timezone shift).
	       *
	       * NOTE: This option requires moment-timezone >= 0.3.0.
	       */
	      timezone: null,
	
	      /**
	       * @ngdoc property
	       * @name angularMoment.config.angularMomentConfig#format
	       * @propertyOf angularMoment.config:angularMomentConfig
	       * @returns {string} The pre-conversion format of the date
	       *
	       * @description
	       * Specify the format of the input date. Essentially it's a
	       * default and saves you from specifying a format in every
	       * element. Overridden by element attr. Null by default.
	       */
	      format: null,
	
	      /**
	       * @ngdoc property
	       * @name angularMoment.config.angularMomentConfig#statefulFilters
	       * @propertyOf angularMoment.config:angularMomentConfig
	       * @returns {boolean} Whether angular-moment filters should be stateless (or not)
	       *
	       * @description
	       * Specifies whether the filters included with angular-moment are stateful.
	       * Stateful filters will automatically re-evaluate whenever you change the timezone
	       * or locale settings, but may negatively impact performance. true by default.
	       */
	      statefulFilters: true
	    })
	
	    /**
	     * @ngdoc object
	     * @name angularMoment.object:moment
	     *
	     * @description
	     * moment global (as provided by the moment.js library)
	     */
	    .constant('moment', moment)
	
	    /**
	     * @ngdoc object
	     * @name angularMoment.config:amTimeAgoConfig
	     * @module angularMoment
	     *
	     * @description
	     * configuration specific to the amTimeAgo directive
	     */
	    .constant('amTimeAgoConfig', {
	      /**
	       * @ngdoc property
	       * @name angularMoment.config.amTimeAgoConfig#withoutSuffix
	       * @propertyOf angularMoment.config:amTimeAgoConfig
	       * @returns {boolean} Whether to include a suffix in am-time-ago directive
	       *
	       * @description
	       * Defaults to false.
	       */
	      withoutSuffix: false,
	
	      /**
	       * @ngdoc property
	       * @name angularMoment.config.amTimeAgoConfig#serverTime
	       * @propertyOf angularMoment.config:amTimeAgoConfig
	       * @returns {number} Server time in milliseconds since the epoch
	       *
	       * @description
	       * If set, time ago will be calculated relative to the given value.
	       * If null, local time will be used. Defaults to null.
	       */
	      serverTime: null,
	
	      /**
	       * @ngdoc property
	       * @name angularMoment.config.amTimeAgoConfig#titleFormat
	       * @propertyOf angularMoment.config:amTimeAgoConfig
	       * @returns {string} The format of the date to be displayed in the title of the element. If null,
	       *        the directive set the title of the element.
	       *
	       * @description
	       * The format of the date used for the title of the element. null by default.
	       */
	      titleFormat: null,
	
	      /**
	       * @ngdoc property
	       * @name angularMoment.config.amTimeAgoConfig#fullDateThreshold
	       * @propertyOf angularMoment.config:amTimeAgoConfig
	       * @returns {number} The minimum number of days for showing a full date instead of relative time
	       *
	       * @description
	       * The threshold for displaying a full date. The default is null, which means the date will always
	       * be relative, and full date will never be displayed.
	       */
	      fullDateThreshold: null,
	
	      /**
	       * @ngdoc property
	       * @name angularMoment.config.amTimeAgoConfig#fullDateFormat
	       * @propertyOf angularMoment.config:amTimeAgoConfig
	       * @returns {string} The format to use when displaying a full date.
	       *
	       * @description
	       * Specify the format of the date when displayed as full date. null by default.
	       */
	      fullDateFormat: null,
	
	      fullDateThresholdUnit: 'day'
	    })
	
	    /**
	     * @ngdoc directive
	     * @name angularMoment.directive:amTimeAgo
	     * @module angularMoment
	     *
	     * @restrict A
	     */
	    .directive('amTimeAgo', ['$window', 'moment', 'amMoment', 'amTimeAgoConfig', function ($window, moment, amMoment, amTimeAgoConfig) {
	      return function (scope, element, attr) {
	        var activeTimeout = null;
	        var currentValue;
	        var withoutSuffix = amTimeAgoConfig.withoutSuffix;
	        var titleFormat = amTimeAgoConfig.titleFormat;
	        var fullDateThreshold = amTimeAgoConfig.fullDateThreshold;
	        var fullDateFormat = amTimeAgoConfig.fullDateFormat;
	        var fullDateThresholdUnit = amTimeAgoConfig.fullDateThresholdUnit;
	
	        var localDate = new Date().getTime();
	        var modelName = attr.amTimeAgo;
	        var currentFrom;
	        var isTimeElement = 'TIME' === element[0].nodeName.toUpperCase();
	        var setTitleTime = !element.attr('title');
	
	        function getNow() {
	          var now;
	          if (currentFrom) {
	            now = currentFrom;
	          } else if (amTimeAgoConfig.serverTime) {
	            var localNow = new Date().getTime();
	            var nowMillis = localNow - localDate + amTimeAgoConfig.serverTime;
	            now = moment(nowMillis);
	          } else {
	            now = moment();
	          }
	          return now;
	        }
	
	        function cancelTimer() {
	          if (activeTimeout) {
	            $window.clearTimeout(activeTimeout);
	            activeTimeout = null;
	          }
	        }
	
	        function updateTime(momentInstance) {
	          var timeAgo = getNow().diff(momentInstance, fullDateThresholdUnit);
	          var showFullDate = fullDateThreshold && timeAgo >= fullDateThreshold;
	
	          if (showFullDate) {
	            element.text(momentInstance.format(fullDateFormat));
	          } else {
	            element.text(momentInstance.from(getNow(), withoutSuffix));
	          }
	
	          if (titleFormat && setTitleTime) {
	            element.attr('title', momentInstance.format(titleFormat));
	          }
	
	          if (!showFullDate) {
	            var howOld = Math.abs(getNow().diff(momentInstance, 'minute'));
	            var secondsUntilUpdate = 3600;
	            if (howOld < 1) {
	              secondsUntilUpdate = 1;
	            } else if (howOld < 60) {
	              secondsUntilUpdate = 30;
	            } else if (howOld < 180) {
	              secondsUntilUpdate = 300;
	            }
	
	            activeTimeout = $window.setTimeout(function () {
	              updateTime(momentInstance);
	            }, secondsUntilUpdate * 1000);
	          }
	        }
	
	        function updateDateTimeAttr(value) {
	          if (isTimeElement) {
	            element.attr('datetime', value);
	          }
	        }
	
	        function updateMoment() {
	          cancelTimer();
	          if (currentValue) {
	            var momentValue = amMoment.preprocessDate(currentValue);
	            updateTime(momentValue);
	            updateDateTimeAttr(momentValue.toISOString());
	          }
	        }
	
	        scope.$watch(modelName, function (value) {
	          if (isUndefinedOrNull(value) || value === '') {
	            cancelTimer();
	            if (currentValue) {
	              element.text('');
	              updateDateTimeAttr('');
	              currentValue = null;
	            }
	            return;
	          }
	
	          currentValue = value;
	          updateMoment();
	        });
	
	        if (angular.isDefined(attr.amFrom)) {
	          scope.$watch(attr.amFrom, function (value) {
	            if (isUndefinedOrNull(value) || value === '') {
	              currentFrom = null;
	            } else {
	              currentFrom = moment(value);
	            }
	            updateMoment();
	          });
	        }
	
	        if (angular.isDefined(attr.amWithoutSuffix)) {
	          scope.$watch(attr.amWithoutSuffix, function (value) {
	            if (typeof value === 'boolean') {
	              withoutSuffix = value;
	              updateMoment();
	            } else {
	              withoutSuffix = amTimeAgoConfig.withoutSuffix;
	            }
	          });
	        }
	
	        attr.$observe('amFullDateThreshold', function (newValue) {
	          fullDateThreshold = newValue;
	          updateMoment();
	        });
	
	        attr.$observe('amFullDateFormat', function (newValue) {
	          fullDateFormat = newValue;
	          updateMoment();
	        });
	
	        attr.$observe('amFullDateThresholdUnit', function (newValue) {
	          fullDateThresholdUnit = newValue;
	          updateMoment();
	        });
	
	        scope.$on('$destroy', function () {
	          cancelTimer();
	        });
	
	        scope.$on('amMoment:localeChanged', function () {
	          updateMoment();
	        });
	      };
	    }])
	
	    /**
	     * @ngdoc service
	     * @name angularMoment.service.amMoment
	     * @module angularMoment
	     */
	    .service('amMoment', ['moment', '$rootScope', '$log', 'angularMomentConfig', function (moment, $rootScope, $log, angularMomentConfig) {
	      var defaultTimezone = null;
	
	      /**
	       * @ngdoc function
	       * @name angularMoment.service.amMoment#changeLocale
	       * @methodOf angularMoment.service.amMoment
	       *
	       * @description
	       * Changes the locale for moment.js and updates all the am-time-ago directive instances
	       * with the new locale. Also broadcasts an `amMoment:localeChanged` event on $rootScope.
	       *
	       * @param {string} locale Locale code (e.g. en, es, ru, pt-br, etc.)
	       * @param {object} customization object of locale strings to override
	       */
	      this.changeLocale = function (locale, customization) {
	        var result = moment.locale(locale, customization);
	        if (angular.isDefined(locale)) {
	          $rootScope.$broadcast('amMoment:localeChanged');
	        }
	        return result;
	      };
	
	      /**
	       * @ngdoc function
	       * @name angularMoment.service.amMoment#changeTimezone
	       * @methodOf angularMoment.service.amMoment
	       *
	       * @description
	       * Changes the default timezone for amCalendar, amDateFormat and amTimeAgo. Also broadcasts an
	       * `amMoment:timezoneChanged` event on $rootScope.
	       *
	       * Note: this method works only if moment-timezone > 0.3.0 is loaded
	       *
	       * @param {string} timezone Timezone name (e.g. UTC)
	       */
	      this.changeTimezone = function (timezone) {
	        if (moment.tz && moment.tz.setDefault) {
	          moment.tz.setDefault(timezone);
	          $rootScope.$broadcast('amMoment:timezoneChanged');
	        } else {
	          $log.warn('angular-moment: changeTimezone() works only with moment-timezone.js v0.3.0 or greater.');
	        }
	        angularMomentConfig.timezone = timezone;
	        defaultTimezone = timezone;
	      };
	
	      /**
	       * @ngdoc function
	       * @name angularMoment.service.amMoment#preprocessDate
	       * @methodOf angularMoment.service.amMoment
	       *
	       * @description
	       * Preprocess a given value and convert it into a Moment instance appropriate for use in the
	       * am-time-ago directive and the filters. The behavior of this function can be overriden by
	       * setting `angularMomentConfig.preprocess`.
	       *
	       * @param {*} value The value to be preprocessed
	       * @return {Moment} A `moment` object
	       */
	      this.preprocessDate = function (value) {
	        // Configure the default timezone if needed
	        if (defaultTimezone !== angularMomentConfig.timezone) {
	          this.changeTimezone(angularMomentConfig.timezone);
	        }
	
	        if (angularMomentConfig.preprocess) {
	          return angularMomentConfig.preprocess(value);
	        }
	
	        if (!isNaN(parseFloat(value)) && isFinite(value)) {
	          // Milliseconds since the epoch
	          return moment(parseInt(value, 10));
	        }
	
	        // else just returns the value as-is.
	        return moment(value);
	      };
	    }])
	
	    /**
	     * @ngdoc filter
	     * @name angularMoment.filter:amParse
	     * @module angularMoment
	     */
	    .filter('amParse', ['moment', function (moment) {
	      return function (value, format) {
	        return moment(value, format);
	      };
	    }])
	
	    /**
	     * @ngdoc filter
	     * @name angularMoment.filter:amFromUnix
	     * @module angularMoment
	     */
	    .filter('amFromUnix', ['moment', function (moment) {
	      return function (value) {
	        return moment.unix(value);
	      };
	    }])
	
	    /**
	     * @ngdoc filter
	     * @name angularMoment.filter:amUtc
	     * @module angularMoment
	     */
	    .filter('amUtc', ['moment', function (moment) {
	      return function (value) {
	        return moment.utc(value);
	      };
	    }])
	
	    /**
	     * @ngdoc filter
	     * @name angularMoment.filter:amUtcOffset
	     * @module angularMoment
	     *
	     * @description
	     * Adds a UTC offset to the given timezone object. The offset can be a number of minutes, or a string such as
	     * '+0300', '-0300' or 'Z'.
	     */
	    .filter('amUtcOffset', ['amMoment', function (amMoment) {
	      function amUtcOffset(value, offset) {
	        return amMoment.preprocessDate(value).utcOffset(offset);
	      }
	
	      return amUtcOffset;
	    }])
	
	    /**
	     * @ngdoc filter
	     * @name angularMoment.filter:amLocal
	     * @module angularMoment
	     */
	    .filter('amLocal', ['moment', function (moment) {
	      return function (value) {
	        return moment.isMoment(value) ? value.local() : null;
	      };
	    }])
	
	    /**
	     * @ngdoc filter
	     * @name angularMoment.filter:amTimezone
	     * @module angularMoment
	     *
	     * @description
	     * Apply a timezone onto a given moment object, e.g. 'America/Phoenix').
	     *
	     * You need to include moment-timezone.js for timezone support.
	     */
	    .filter('amTimezone', ['amMoment', 'angularMomentConfig', '$log', function (amMoment, angularMomentConfig, $log) {
	      function amTimezone(value, timezone) {
	        var aMoment = amMoment.preprocessDate(value);
	
	        if (!timezone) {
	          return aMoment;
	        }
	
	        if (aMoment.tz) {
	          return aMoment.tz(timezone);
	        } else {
	          $log.warn('angular-moment: named timezone specified but moment.tz() is undefined. Did you forget to include moment-timezone.js ?');
	          return aMoment;
	        }
	      }
	
	      return amTimezone;
	    }])
	
	    /**
	     * @ngdoc filter
	     * @name angularMoment.filter:amCalendar
	     * @module angularMoment
	     */
	    .filter('amCalendar', ['moment', 'amMoment', 'angularMomentConfig', function (moment, amMoment, angularMomentConfig) {
	      function amCalendarFilter(value, referenceTime, formats) {
	        if (isUndefinedOrNull(value)) {
	          return '';
	        }
	
	        var date = amMoment.preprocessDate(value);
	        return date.isValid() ? date.calendar(referenceTime, formats) : '';
	      }
	
	      // Since AngularJS 1.3, filters have to explicitly define being stateful
	      // (this is no longer the default).
	      amCalendarFilter.$stateful = angularMomentConfig.statefulFilters;
	
	      return amCalendarFilter;
	    }])
	
	    /**
	     * @ngdoc filter
	     * @name angularMoment.filter:amDifference
	     * @module angularMoment
	     */
	    .filter('amDifference', ['moment', 'amMoment', 'angularMomentConfig', function (moment, amMoment, angularMomentConfig) {
	      function amDifferenceFilter(value, otherValue, unit, usePrecision) {
	        if (isUndefinedOrNull(value)) {
	          return '';
	        }
	
	        var date = amMoment.preprocessDate(value);
	        var date2 = !isUndefinedOrNull(otherValue) ? amMoment.preprocessDate(otherValue) : moment();
	
	        if (!date.isValid() || !date2.isValid()) {
	          return '';
	        }
	
	        return date.diff(date2, unit, usePrecision);
	      }
	
	      amDifferenceFilter.$stateful = angularMomentConfig.statefulFilters;
	
	      return amDifferenceFilter;
	    }])
	
	    /**
	     * @ngdoc filter
	     * @name angularMoment.filter:amDateFormat
	     * @module angularMoment
	     * @function
	     */
	    .filter('amDateFormat', ['moment', 'amMoment', 'angularMomentConfig', function (moment, amMoment, angularMomentConfig) {
	      function amDateFormatFilter(value, format) {
	        if (isUndefinedOrNull(value)) {
	          return '';
	        }
	
	        var date = amMoment.preprocessDate(value);
	        if (!date.isValid()) {
	          return '';
	        }
	
	        return date.format(format);
	      }
	
	      amDateFormatFilter.$stateful = angularMomentConfig.statefulFilters;
	
	      return amDateFormatFilter;
	    }])
	
	    /**
	     * @ngdoc filter
	     * @name angularMoment.filter:amDurationFormat
	     * @module angularMoment
	     * @function
	     */
	    .filter('amDurationFormat', ['moment', 'angularMomentConfig', function (moment, angularMomentConfig) {
	      function amDurationFormatFilter(value, format, suffix) {
	        if (isUndefinedOrNull(value)) {
	          return '';
	        }
	
	        return moment.duration(value, format).humanize(suffix);
	      }
	
	      amDurationFormatFilter.$stateful = angularMomentConfig.statefulFilters;
	
	      return amDurationFormatFilter;
	    }])
	
	    /**
	     * @ngdoc filter
	     * @name angularMoment.filter:amTimeAgo
	     * @module angularMoment
	     * @function
	     */
	    .filter('amTimeAgo', ['moment', 'amMoment', 'angularMomentConfig', function (moment, amMoment, angularMomentConfig) {
	      function amTimeAgoFilter(value, suffix, from) {
	        var date, dateFrom;
	
	        if (isUndefinedOrNull(value)) {
	          return '';
	        }
	
	        value = amMoment.preprocessDate(value);
	        date = moment(value);
	        if (!date.isValid()) {
	          return '';
	        }
	
	        dateFrom = moment(from);
	        if (!isUndefinedOrNull(from) && dateFrom.isValid()) {
	          return date.from(dateFrom, suffix);
	        }
	
	        return date.fromNow(suffix);
	      }
	
	      amTimeAgoFilter.$stateful = angularMomentConfig.statefulFilters;
	
	      return amTimeAgoFilter;
	    }])
	
	    /**
	     * @ngdoc filter
	     * @name angularMoment.filter:amSubtract
	     * @module angularMoment
	     * @function
	     */
	    .filter('amSubtract', ['moment', 'angularMomentConfig', function (moment, angularMomentConfig) {
	      function amSubtractFilter(value, amount, type) {
	        if (isUndefinedOrNull(value)) {
	          return '';
	        }
	
	        return moment(value).subtract(parseInt(amount, 10), type);
	      }
	
	      amSubtractFilter.$stateful = angularMomentConfig.statefulFilters;
	
	      return amSubtractFilter;
	    }])
	
	    /**
	     * @ngdoc filter
	     * @name angularMoment.filter:amAdd
	     * @module angularMoment
	     * @function
	     */
	    .filter('amAdd', ['moment', 'angularMomentConfig', function (moment, angularMomentConfig) {
	      function amAddFilter(value, amount, type) {
	        if (isUndefinedOrNull(value)) {
	          return '';
	        }
	
	        return moment(value).add(parseInt(amount, 10), type);
	      }
	
	      amAddFilter.$stateful = angularMomentConfig.statefulFilters;
	
	      return amAddFilter;
	    }])
	
	    /**
	     * @ngdoc filter
	     * @name angularMoment.filter:amStartOf
	     * @module angularMoment
	     * @function
	     */
	    .filter('amStartOf', ['moment', 'angularMomentConfig', function (moment, angularMomentConfig) {
	      function amStartOfFilter(value, type) {
	        if (isUndefinedOrNull(value)) {
	          return '';
	        }
	
	        return moment(value).startOf(type);
	      }
	
	      amStartOfFilter.$stateful = angularMomentConfig.statefulFilters;
	
	      return amStartOfFilter;
	    }])
	
	    /**
	     * @ngdoc filter
	     * @name angularMoment.filter:amEndOf
	     * @module angularMoment
	     * @function
	     */
	    .filter('amEndOf', ['moment', 'angularMomentConfig', function (moment, angularMomentConfig) {
	      function amEndOfFilter(value, type) {
	        if (isUndefinedOrNull(value)) {
	          return '';
	        }
	
	        return moment(value).endOf(type);
	      }
	
	      amEndOfFilter.$stateful = angularMomentConfig.statefulFilters;
	
	      return amEndOfFilter;
	    }]);
	
	    return 'angularMoment';
	  }
	
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(8), __webpack_require__(1124)], __WEBPACK_AMD_DEFINE_FACTORY__ = (angularMoment), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof module !== 'undefined' && module && module.exports && typeof require === 'function') {
	    module.exports = angularMoment(require('angular'), require('moment'));
	  } else {
	    angularMoment(angular, (typeof global !== 'undefined' ? global : window).moment);
	  }
	})();

/***/ }),
/* 1087 */
/***/ (function(module, exports, __webpack_require__) {

	var cof = __webpack_require__(44);
	module.exports = function (it, msg) {
	  if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
	  return +it;
	};


/***/ }),
/* 1088 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	'use strict';
	var toObject = __webpack_require__(17);
	var toAbsoluteIndex = __webpack_require__(142);
	var toLength = __webpack_require__(11);
	
	module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
	  var O = toObject(this);
	  var len = toLength(O.length);
	  var to = toAbsoluteIndex(target, len);
	  var from = toAbsoluteIndex(start, len);
	  var end = arguments.length > 2 ? arguments[2] : undefined;
	  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
	  var inc = 1;
	  if (from < to && to < from + count) {
	    inc = -1;
	    from += count - 1;
	    to += count - 1;
	  }
	  while (count-- > 0) {
	    if (from in O) O[to] = O[from];
	    else delete O[to];
	    to += inc;
	    from += inc;
	  } return O;
	};


/***/ }),
/* 1089 */
/***/ (function(module, exports, __webpack_require__) {

	var forOf = __webpack_require__(135);
	
	module.exports = function (iter, ITERATOR) {
	  var result = [];
	  forOf(iter, false, result.push, result, ITERATOR);
	  return result;
	};


/***/ }),
/* 1090 */
/***/ (function(module, exports, __webpack_require__) {

	var aFunction = __webpack_require__(23);
	var toObject = __webpack_require__(17);
	var IObject = __webpack_require__(314);
	var toLength = __webpack_require__(11);
	
	module.exports = function (that, callbackfn, aLen, memo, isRight) {
	  aFunction(callbackfn);
	  var O = toObject(that);
	  var self = IObject(O);
	  var length = toLength(O.length);
	  var index = isRight ? length - 1 : 0;
	  var i = isRight ? -1 : 1;
	  if (aLen < 2) for (;;) {
	    if (index in self) {
	      memo = self[index];
	      index += i;
	      break;
	    }
	    index += i;
	    if (isRight ? index < 0 : length <= index) {
	      throw TypeError('Reduce of empty array with no initial value');
	    }
	  }
	  for (;isRight ? index >= 0 : length > index; index += i) if (index in self) {
	    memo = callbackfn(memo, self[index], index, O);
	  }
	  return memo;
	};


/***/ }),
/* 1091 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var aFunction = __webpack_require__(23);
	var isObject = __webpack_require__(7);
	var invoke = __webpack_require__(1097);
	var arraySlice = [].slice;
	var factories = {};
	
	var construct = function (F, len, args) {
	  if (!(len in factories)) {
	    for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
	    // eslint-disable-next-line no-new-func
	    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
	  } return factories[len](F, args);
	};
	
	module.exports = Function.bind || function bind(that /* , ...args */) {
	  var fn = aFunction(this);
	  var partArgs = arraySlice.call(arguments, 1);
	  var bound = function (/* args... */) {
	    var args = partArgs.concat(arraySlice.call(arguments));
	    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
	  };
	  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
	  return bound;
	};


/***/ }),
/* 1092 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var dP = __webpack_require__(16).f;
	var create = __webpack_require__(136);
	var redefineAll = __webpack_require__(140);
	var ctx = __webpack_require__(46);
	var anInstance = __webpack_require__(134);
	var forOf = __webpack_require__(135);
	var $iterDefine = __webpack_require__(714);
	var step = __webpack_require__(1100);
	var setSpecies = __webpack_require__(141);
	var DESCRIPTORS = __webpack_require__(14);
	var fastKey = __webpack_require__(94).fastKey;
	var validate = __webpack_require__(144);
	var SIZE = DESCRIPTORS ? '_s' : 'size';
	
	var getEntry = function (that, key) {
	  // fast case
	  var index = fastKey(key);
	  var entry;
	  if (index !== 'F') return that._i[index];
	  // frozen object case
	  for (entry = that._f; entry; entry = entry.n) {
	    if (entry.k == key) return entry;
	  }
	};
	
	module.exports = {
	  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
	    var C = wrapper(function (that, iterable) {
	      anInstance(that, C, NAME, '_i');
	      that._t = NAME;         // collection type
	      that._i = create(null); // index
	      that._f = undefined;    // first entry
	      that._l = undefined;    // last entry
	      that[SIZE] = 0;         // size
	      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.1.3.1 Map.prototype.clear()
	      // 23.2.3.2 Set.prototype.clear()
	      clear: function clear() {
	        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
	          entry.r = true;
	          if (entry.p) entry.p = entry.p.n = undefined;
	          delete data[entry.i];
	        }
	        that._f = that._l = undefined;
	        that[SIZE] = 0;
	      },
	      // 23.1.3.3 Map.prototype.delete(key)
	      // 23.2.3.4 Set.prototype.delete(value)
	      'delete': function (key) {
	        var that = validate(this, NAME);
	        var entry = getEntry(that, key);
	        if (entry) {
	          var next = entry.n;
	          var prev = entry.p;
	          delete that._i[entry.i];
	          entry.r = true;
	          if (prev) prev.n = next;
	          if (next) next.p = prev;
	          if (that._f == entry) that._f = next;
	          if (that._l == entry) that._l = prev;
	          that[SIZE]--;
	        } return !!entry;
	      },
	      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
	      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
	      forEach: function forEach(callbackfn /* , that = undefined */) {
	        validate(this, NAME);
	        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
	        var entry;
	        while (entry = entry ? entry.n : this._f) {
	          f(entry.v, entry.k, this);
	          // revert to the last existing entry
	          while (entry && entry.r) entry = entry.p;
	        }
	      },
	      // 23.1.3.7 Map.prototype.has(key)
	      // 23.2.3.7 Set.prototype.has(value)
	      has: function has(key) {
	        return !!getEntry(validate(this, NAME), key);
	      }
	    });
	    if (DESCRIPTORS) dP(C.prototype, 'size', {
	      get: function () {
	        return validate(this, NAME)[SIZE];
	      }
	    });
	    return C;
	  },
	  def: function (that, key, value) {
	    var entry = getEntry(that, key);
	    var prev, index;
	    // change existing entry
	    if (entry) {
	      entry.v = value;
	    // create new entry
	    } else {
	      that._l = entry = {
	        i: index = fastKey(key, true), // <- index
	        k: key,                        // <- key
	        v: value,                      // <- value
	        p: prev = that._l,             // <- previous entry
	        n: undefined,                  // <- next entry
	        r: false                       // <- removed
	      };
	      if (!that._f) that._f = entry;
	      if (prev) prev.n = entry;
	      that[SIZE]++;
	      // add to index
	      if (index !== 'F') that._i[index] = entry;
	    } return that;
	  },
	  getEntry: getEntry,
	  setStrong: function (C, NAME, IS_MAP) {
	    // add .keys, .values, .entries, [@@iterator]
	    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
	    $iterDefine(C, NAME, function (iterated, kind) {
	      this._t = validate(iterated, NAME); // target
	      this._k = kind;                     // kind
	      this._l = undefined;                // previous
	    }, function () {
	      var that = this;
	      var kind = that._k;
	      var entry = that._l;
	      // revert to the last existing entry
	      while (entry && entry.r) entry = entry.p;
	      // get next entry
	      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
	        // or finish the iteration
	        that._t = undefined;
	        return step(1);
	      }
	      // return step by kind
	      if (kind == 'keys') return step(0, entry.k);
	      if (kind == 'values') return step(0, entry.v);
	      return step(0, [entry.k, entry.v]);
	    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);
	
	    // add [@@species], 23.1.2.2, 23.2.2.2
	    setSpecies(NAME);
	  }
	};


/***/ }),
/* 1093 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var classof = __webpack_require__(201);
	var from = __webpack_require__(1089);
	module.exports = function (NAME) {
	  return function toJSON() {
	    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
	    return from(this);
	  };
	};


/***/ }),
/* 1094 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var redefineAll = __webpack_require__(140);
	var getWeak = __webpack_require__(94).getWeak;
	var anObject = __webpack_require__(4);
	var isObject = __webpack_require__(7);
	var anInstance = __webpack_require__(134);
	var forOf = __webpack_require__(135);
	var createArrayMethod = __webpack_require__(66);
	var $has = __webpack_require__(36);
	var validate = __webpack_require__(144);
	var arrayFind = createArrayMethod(5);
	var arrayFindIndex = createArrayMethod(6);
	var id = 0;
	
	// fallback for uncaught frozen keys
	var uncaughtFrozenStore = function (that) {
	  return that._l || (that._l = new UncaughtFrozenStore());
	};
	var UncaughtFrozenStore = function () {
	  this.a = [];
	};
	var findUncaughtFrozen = function (store, key) {
	  return arrayFind(store.a, function (it) {
	    return it[0] === key;
	  });
	};
	UncaughtFrozenStore.prototype = {
	  get: function (key) {
	    var entry = findUncaughtFrozen(this, key);
	    if (entry) return entry[1];
	  },
	  has: function (key) {
	    return !!findUncaughtFrozen(this, key);
	  },
	  set: function (key, value) {
	    var entry = findUncaughtFrozen(this, key);
	    if (entry) entry[1] = value;
	    else this.a.push([key, value]);
	  },
	  'delete': function (key) {
	    var index = arrayFindIndex(this.a, function (it) {
	      return it[0] === key;
	    });
	    if (~index) this.a.splice(index, 1);
	    return !!~index;
	  }
	};
	
	module.exports = {
	  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
	    var C = wrapper(function (that, iterable) {
	      anInstance(that, C, NAME, '_i');
	      that._t = NAME;      // collection type
	      that._i = id++;      // collection id
	      that._l = undefined; // leak store for uncaught frozen objects
	      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.3.3.2 WeakMap.prototype.delete(key)
	      // 23.4.3.3 WeakSet.prototype.delete(value)
	      'delete': function (key) {
	        if (!isObject(key)) return false;
	        var data = getWeak(key);
	        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
	        return data && $has(data, this._i) && delete data[this._i];
	      },
	      // 23.3.3.4 WeakMap.prototype.has(key)
	      // 23.4.3.4 WeakSet.prototype.has(value)
	      has: function has(key) {
	        if (!isObject(key)) return false;
	        var data = getWeak(key);
	        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
	        return data && $has(data, this._i);
	      }
	    });
	    return C;
	  },
	  def: function (that, key, value) {
	    var data = getWeak(anObject(key), true);
	    if (data === true) uncaughtFrozenStore(that).set(key, value);
	    else data[that._i] = value;
	    return that;
	  },
	  ufstore: uncaughtFrozenStore
	};


/***/ }),
/* 1095 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
	var isArray = __webpack_require__(458);
	var isObject = __webpack_require__(7);
	var toLength = __webpack_require__(11);
	var ctx = __webpack_require__(46);
	var IS_CONCAT_SPREADABLE = __webpack_require__(10)('isConcatSpreadable');
	
	function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
	  var targetIndex = start;
	  var sourceIndex = 0;
	  var mapFn = mapper ? ctx(mapper, thisArg, 3) : false;
	  var element, spreadable;
	
	  while (sourceIndex < sourceLen) {
	    if (sourceIndex in source) {
	      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];
	
	      spreadable = false;
	      if (isObject(element)) {
	        spreadable = element[IS_CONCAT_SPREADABLE];
	        spreadable = spreadable !== undefined ? !!spreadable : isArray(element);
	      }
	
	      if (spreadable && depth > 0) {
	        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
	      } else {
	        if (targetIndex >= 0x1fffffffffffff) throw TypeError();
	        target[targetIndex] = element;
	      }
	
	      targetIndex++;
	    }
	    sourceIndex++;
	  }
	  return targetIndex;
	}
	
	module.exports = flattenIntoArray;


/***/ }),
/* 1096 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(14) && !__webpack_require__(6)(function () {
	  return Object.defineProperty(__webpack_require__(707)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 1097 */
/***/ (function(module, exports) {

	// fast apply, http://jsperf.lnkit.com/fast-apply/5
	module.exports = function (fn, args, that) {
	  var un = that === undefined;
	  switch (args.length) {
	    case 0: return un ? fn()
	                      : fn.call(that);
	    case 1: return un ? fn(args[0])
	                      : fn.call(that, args[0]);
	    case 2: return un ? fn(args[0], args[1])
	                      : fn.call(that, args[0], args[1]);
	    case 3: return un ? fn(args[0], args[1], args[2])
	                      : fn.call(that, args[0], args[1], args[2]);
	    case 4: return un ? fn(args[0], args[1], args[2], args[3])
	                      : fn.call(that, args[0], args[1], args[2], args[3]);
	  } return fn.apply(that, args);
	};


/***/ }),
/* 1098 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var isObject = __webpack_require__(7);
	var floor = Math.floor;
	module.exports = function isInteger(it) {
	  return !isObject(it) && isFinite(it) && floor(it) === it;
	};


/***/ }),
/* 1099 */
/***/ (function(module, exports, __webpack_require__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(4);
	module.exports = function (iterator, fn, value, entries) {
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch (e) {
	    var ret = iterator['return'];
	    if (ret !== undefined) anObject(ret.call(iterator));
	    throw e;
	  }
	};


/***/ }),
/* 1100 */
/***/ (function(module, exports) {

	module.exports = function (done, value) {
	  return { value: value, done: !!done };
	};


/***/ }),
/* 1101 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.16 Math.fround(x)
	var sign = __webpack_require__(716);
	var pow = Math.pow;
	var EPSILON = pow(2, -52);
	var EPSILON32 = pow(2, -23);
	var MAX32 = pow(2, 127) * (2 - EPSILON32);
	var MIN32 = pow(2, -126);
	
	var roundTiesToEven = function (n) {
	  return n + 1 / EPSILON - 1 / EPSILON;
	};
	
	module.exports = Math.fround || function fround(x) {
	  var $abs = Math.abs(x);
	  var $sign = sign(x);
	  var a, result;
	  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
	  a = (1 + EPSILON32 / EPSILON) * $abs;
	  result = a - (a - $abs);
	  // eslint-disable-next-line no-self-compare
	  if (result > MAX32 || result != result) return $sign * Infinity;
	  return $sign * result;
	};


/***/ }),
/* 1102 */
/***/ (function(module, exports) {

	// 20.2.2.20 Math.log1p(x)
	module.exports = Math.log1p || function log1p(x) {
	  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
	};


/***/ }),
/* 1103 */
/***/ (function(module, exports) {

	// https://rwaldron.github.io/proposal-math-extensions/
	module.exports = Math.scale || function scale(x, inLow, inHigh, outLow, outHigh) {
	  if (
	    arguments.length === 0
	      // eslint-disable-next-line no-self-compare
	      || x != x
	      // eslint-disable-next-line no-self-compare
	      || inLow != inLow
	      // eslint-disable-next-line no-self-compare
	      || inHigh != inHigh
	      // eslint-disable-next-line no-self-compare
	      || outLow != outLow
	      // eslint-disable-next-line no-self-compare
	      || outHigh != outHigh
	  ) return NaN;
	  if (x === Infinity || x === -Infinity) return x;
	  return (x - inLow) * (outHigh - outLow) / (inHigh - inLow) + outLow;
	};


/***/ }),
/* 1104 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var DESCRIPTORS = __webpack_require__(14);
	var getKeys = __webpack_require__(138);
	var gOPS = __webpack_require__(462);
	var pIE = __webpack_require__(315);
	var toObject = __webpack_require__(17);
	var IObject = __webpack_require__(314);
	var $assign = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(6)(function () {
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line no-undef
	  var S = Symbol();
	  var K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function (k) { B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
	  var T = toObject(target);
	  var aLen = arguments.length;
	  var index = 1;
	  var getSymbols = gOPS.f;
	  var isEnum = pIE.f;
	  while (aLen > index) {
	    var S = IObject(arguments[index++]);
	    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) {
	      key = keys[j++];
	      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
	    }
	  } return T;
	} : $assign;


/***/ }),
/* 1105 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(16);
	var anObject = __webpack_require__(4);
	var getKeys = __webpack_require__(138);
	
	module.exports = __webpack_require__(14) ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};


/***/ }),
/* 1106 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(39);
	var gOPN = __webpack_require__(137).f;
	var toString = {}.toString;
	
	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function (it) {
	  try {
	    return gOPN(it);
	  } catch (e) {
	    return windowNames.slice();
	  }
	};
	
	module.exports.f = function getOwnPropertyNames(it) {
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};


/***/ }),
/* 1107 */
/***/ (function(module, exports, __webpack_require__) {

	var has = __webpack_require__(36);
	var toIObject = __webpack_require__(39);
	var arrayIndexOf = __webpack_require__(455)(false);
	var IE_PROTO = __webpack_require__(721)('IE_PROTO');
	
	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};


/***/ }),
/* 1108 */
/***/ (function(module, exports, __webpack_require__) {

	var DESCRIPTORS = __webpack_require__(14);
	var getKeys = __webpack_require__(138);
	var toIObject = __webpack_require__(39);
	var isEnum = __webpack_require__(315).f;
	module.exports = function (isEntries) {
	  return function (it) {
	    var O = toIObject(it);
	    var keys = getKeys(O);
	    var length = keys.length;
	    var i = 0;
	    var result = [];
	    var key;
	    while (length > i) {
	      key = keys[i++];
	      if (!DESCRIPTORS || isEnum.call(O, key)) {
	        result.push(isEntries ? [key, O[key]] : O[key]);
	      }
	    }
	    return result;
	  };
	};


/***/ }),
/* 1109 */
/***/ (function(module, exports, __webpack_require__) {

	// all object keys, includes non-enumerable and symbols
	var gOPN = __webpack_require__(137);
	var gOPS = __webpack_require__(462);
	var anObject = __webpack_require__(4);
	var Reflect = __webpack_require__(5).Reflect;
	module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
	  var keys = gOPN.f(anObject(it));
	  var getSymbols = gOPS.f;
	  return getSymbols ? keys.concat(getSymbols(it)) : keys;
	};


/***/ }),
/* 1110 */
/***/ (function(module, exports, __webpack_require__) {

	var $parseFloat = __webpack_require__(5).parseFloat;
	var $trim = __webpack_require__(204).trim;
	
	module.exports = 1 / $parseFloat(__webpack_require__(724) + '-0') !== -Infinity ? function parseFloat(str) {
	  var string = $trim(String(str), 3);
	  var result = $parseFloat(string);
	  return result === 0 && string.charAt(0) == '-' ? -0 : result;
	} : $parseFloat;


/***/ }),
/* 1111 */
/***/ (function(module, exports, __webpack_require__) {

	var $parseInt = __webpack_require__(5).parseInt;
	var $trim = __webpack_require__(204).trim;
	var ws = __webpack_require__(724);
	var hex = /^[-+]?0[xX]/;
	
	module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
	  var string = $trim(String(str), 3);
	  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
	} : $parseInt;


/***/ }),
/* 1112 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return { e: false, v: exec() };
	  } catch (e) {
	    return { e: true, v: e };
	  }
	};


/***/ }),
/* 1113 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(4);
	var isObject = __webpack_require__(7);
	var newPromiseCapability = __webpack_require__(718);
	
	module.exports = function (C, x) {
	  anObject(C);
	  if (isObject(x) && x.constructor === C) return x;
	  var promiseCapability = newPromiseCapability.f(C);
	  var resolve = promiseCapability.resolve;
	  resolve(x);
	  return promiseCapability.promise;
	};


/***/ }),
/* 1114 */
/***/ (function(module, exports) {

	// 7.2.9 SameValue(x, y)
	module.exports = Object.is || function is(x, y) {
	  // eslint-disable-next-line no-self-compare
	  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
	};


/***/ }),
/* 1115 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-string-pad-start-end
	var toLength = __webpack_require__(11);
	var repeat = __webpack_require__(723);
	var defined = __webpack_require__(67);
	
	module.exports = function (that, maxLength, fillString, left) {
	  var S = String(defined(that));
	  var stringLength = S.length;
	  var fillStr = fillString === undefined ? ' ' : String(fillString);
	  var intMaxLength = toLength(maxLength);
	  if (intMaxLength <= stringLength || fillStr == '') return S;
	  var fillLen = intMaxLength - stringLength;
	  var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
	  if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
	  return left ? stringFiller + S : S + stringFiller;
	};


/***/ }),
/* 1116 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/ecma262/#sec-toindex
	var toInteger = __webpack_require__(48);
	var toLength = __webpack_require__(11);
	module.exports = function (it) {
	  if (it === undefined) return 0;
	  var number = toInteger(it);
	  var length = toLength(number);
	  if (number !== length) throw RangeError('Wrong length!');
	  return length;
	};


/***/ }),
/* 1117 */
/***/ (function(module, exports, __webpack_require__) {

	exports.f = __webpack_require__(10);


/***/ }),
/* 1118 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(1092);
	var validate = __webpack_require__(144);
	var MAP = 'Map';
	
	// 23.1 Map Objects
	module.exports = __webpack_require__(456)(MAP, function (get) {
	  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.1.3.6 Map.prototype.get(key)
	  get: function get(key) {
	    var entry = strong.getEntry(validate(this, MAP), key);
	    return entry && entry.v;
	  },
	  // 23.1.3.9 Map.prototype.set(key, value)
	  set: function set(key, value) {
	    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
	  }
	}, strong, true);


/***/ }),
/* 1119 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var regexpExec = __webpack_require__(719);
	__webpack_require__(3)({
	  target: 'RegExp',
	  proto: true,
	  forced: regexpExec !== /./.exec
	}, {
	  exec: regexpExec
	});


/***/ }),
/* 1120 */
/***/ (function(module, exports, __webpack_require__) {

	// 21.2.5.3 get RegExp.prototype.flags()
	if (__webpack_require__(14) && /./g.flags != 'g') __webpack_require__(16).f(RegExp.prototype, 'flags', {
	  configurable: true,
	  get: __webpack_require__(313)
	});


/***/ }),
/* 1121 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(1092);
	var validate = __webpack_require__(144);
	var SET = 'Set';
	
	// 23.2 Set Objects
	module.exports = __webpack_require__(456)(SET, function (get) {
	  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.2.3.1 Set.prototype.add(value)
	  add: function add(value) {
	    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
	  }
	}, strong);


/***/ }),
/* 1122 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(5);
	var each = __webpack_require__(66)(0);
	var redefine = __webpack_require__(26);
	var meta = __webpack_require__(94);
	var assign = __webpack_require__(1104);
	var weak = __webpack_require__(1094);
	var isObject = __webpack_require__(7);
	var validate = __webpack_require__(144);
	var NATIVE_WEAK_MAP = __webpack_require__(144);
	var IS_IE11 = !global.ActiveXObject && 'ActiveXObject' in global;
	var WEAK_MAP = 'WeakMap';
	var getWeak = meta.getWeak;
	var isExtensible = Object.isExtensible;
	var uncaughtFrozenStore = weak.ufstore;
	var InternalMap;
	
	var wrapper = function (get) {
	  return function WeakMap() {
	    return get(this, arguments.length > 0 ? arguments[0] : undefined);
	  };
	};
	
	var methods = {
	  // 23.3.3.3 WeakMap.prototype.get(key)
	  get: function get(key) {
	    if (isObject(key)) {
	      var data = getWeak(key);
	      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
	      return data ? data[this._i] : undefined;
	    }
	  },
	  // 23.3.3.5 WeakMap.prototype.set(key, value)
	  set: function set(key, value) {
	    return weak.def(validate(this, WEAK_MAP), key, value);
	  }
	};
	
	// 23.3 WeakMap Objects
	var $WeakMap = module.exports = __webpack_require__(456)(WEAK_MAP, wrapper, methods, weak, true, true);
	
	// IE11 WeakMap frozen keys fix
	if (NATIVE_WEAK_MAP && IS_IE11) {
	  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
	  assign(InternalMap.prototype, methods);
	  meta.NEED = true;
	  each(['delete', 'has', 'get', 'set'], function (key) {
	    var proto = $WeakMap.prototype;
	    var method = proto[key];
	    redefine(proto, key, function (a, b) {
	      // store frozen objects on internal weakmap shim
	      if (isObject(a) && !isExtensible(a)) {
	        if (!this._f) this._f = new InternalMap();
	        var result = this._f[key](a, b);
	        return key == 'set' ? this : result;
	      // store all the rest on native weakmap
	      } return method.call(this, a, b);
	    });
	  });
	}


/***/ }),
/* 1123 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1124 */
/***/ (function(module, exports, __webpack_require__) {

	var require;/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
	//! version : 2.30.1
	//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
	//! license : MIT
	//! momentjs.com
	
	;(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    global.moment = factory()
	}(this, (function () { 'use strict';
	
	    var hookCallback;
	
	    function hooks() {
	        return hookCallback.apply(null, arguments);
	    }
	
	    // This is done to register the method called with moment()
	    // without creating circular dependencies.
	    function setHookCallback(callback) {
	        hookCallback = callback;
	    }
	
	    function isArray(input) {
	        return (
	            input instanceof Array ||
	            Object.prototype.toString.call(input) === '[object Array]'
	        );
	    }
	
	    function isObject(input) {
	        // IE8 will treat undefined and null as object if it wasn't for
	        // input != null
	        return (
	            input != null &&
	            Object.prototype.toString.call(input) === '[object Object]'
	        );
	    }
	
	    function hasOwnProp(a, b) {
	        return Object.prototype.hasOwnProperty.call(a, b);
	    }
	
	    function isObjectEmpty(obj) {
	        if (Object.getOwnPropertyNames) {
	            return Object.getOwnPropertyNames(obj).length === 0;
	        } else {
	            var k;
	            for (k in obj) {
	                if (hasOwnProp(obj, k)) {
	                    return false;
	                }
	            }
	            return true;
	        }
	    }
	
	    function isUndefined(input) {
	        return input === void 0;
	    }
	
	    function isNumber(input) {
	        return (
	            typeof input === 'number' ||
	            Object.prototype.toString.call(input) === '[object Number]'
	        );
	    }
	
	    function isDate(input) {
	        return (
	            input instanceof Date ||
	            Object.prototype.toString.call(input) === '[object Date]'
	        );
	    }
	
	    function map(arr, fn) {
	        var res = [],
	            i,
	            arrLen = arr.length;
	        for (i = 0; i < arrLen; ++i) {
	            res.push(fn(arr[i], i));
	        }
	        return res;
	    }
	
	    function extend(a, b) {
	        for (var i in b) {
	            if (hasOwnProp(b, i)) {
	                a[i] = b[i];
	            }
	        }
	
	        if (hasOwnProp(b, 'toString')) {
	            a.toString = b.toString;
	        }
	
	        if (hasOwnProp(b, 'valueOf')) {
	            a.valueOf = b.valueOf;
	        }
	
	        return a;
	    }
	
	    function createUTC(input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, true).utc();
	    }
	
	    function defaultParsingFlags() {
	        // We need to deep clone this object.
	        return {
	            empty: false,
	            unusedTokens: [],
	            unusedInput: [],
	            overflow: -2,
	            charsLeftOver: 0,
	            nullInput: false,
	            invalidEra: null,
	            invalidMonth: null,
	            invalidFormat: false,
	            userInvalidated: false,
	            iso: false,
	            parsedDateParts: [],
	            era: null,
	            meridiem: null,
	            rfc2822: false,
	            weekdayMismatch: false,
	        };
	    }
	
	    function getParsingFlags(m) {
	        if (m._pf == null) {
	            m._pf = defaultParsingFlags();
	        }
	        return m._pf;
	    }
	
	    var some;
	    if (Array.prototype.some) {
	        some = Array.prototype.some;
	    } else {
	        some = function (fun) {
	            var t = Object(this),
	                len = t.length >>> 0,
	                i;
	
	            for (i = 0; i < len; i++) {
	                if (i in t && fun.call(this, t[i], i, t)) {
	                    return true;
	                }
	            }
	
	            return false;
	        };
	    }
	
	    function isValid(m) {
	        var flags = null,
	            parsedParts = false,
	            isNowValid = m._d && !isNaN(m._d.getTime());
	        if (isNowValid) {
	            flags = getParsingFlags(m);
	            parsedParts = some.call(flags.parsedDateParts, function (i) {
	                return i != null;
	            });
	            isNowValid =
	                flags.overflow < 0 &&
	                !flags.empty &&
	                !flags.invalidEra &&
	                !flags.invalidMonth &&
	                !flags.invalidWeekday &&
	                !flags.weekdayMismatch &&
	                !flags.nullInput &&
	                !flags.invalidFormat &&
	                !flags.userInvalidated &&
	                (!flags.meridiem || (flags.meridiem && parsedParts));
	            if (m._strict) {
	                isNowValid =
	                    isNowValid &&
	                    flags.charsLeftOver === 0 &&
	                    flags.unusedTokens.length === 0 &&
	                    flags.bigHour === undefined;
	            }
	        }
	        if (Object.isFrozen == null || !Object.isFrozen(m)) {
	            m._isValid = isNowValid;
	        } else {
	            return isNowValid;
	        }
	        return m._isValid;
	    }
	
	    function createInvalid(flags) {
	        var m = createUTC(NaN);
	        if (flags != null) {
	            extend(getParsingFlags(m), flags);
	        } else {
	            getParsingFlags(m).userInvalidated = true;
	        }
	
	        return m;
	    }
	
	    // Plugins that add properties should also add the key here (null value),
	    // so we can properly clone ourselves.
	    var momentProperties = (hooks.momentProperties = []),
	        updateInProgress = false;
	
	    function copyConfig(to, from) {
	        var i,
	            prop,
	            val,
	            momentPropertiesLen = momentProperties.length;
	
	        if (!isUndefined(from._isAMomentObject)) {
	            to._isAMomentObject = from._isAMomentObject;
	        }
	        if (!isUndefined(from._i)) {
	            to._i = from._i;
	        }
	        if (!isUndefined(from._f)) {
	            to._f = from._f;
	        }
	        if (!isUndefined(from._l)) {
	            to._l = from._l;
	        }
	        if (!isUndefined(from._strict)) {
	            to._strict = from._strict;
	        }
	        if (!isUndefined(from._tzm)) {
	            to._tzm = from._tzm;
	        }
	        if (!isUndefined(from._isUTC)) {
	            to._isUTC = from._isUTC;
	        }
	        if (!isUndefined(from._offset)) {
	            to._offset = from._offset;
	        }
	        if (!isUndefined(from._pf)) {
	            to._pf = getParsingFlags(from);
	        }
	        if (!isUndefined(from._locale)) {
	            to._locale = from._locale;
	        }
	
	        if (momentPropertiesLen > 0) {
	            for (i = 0; i < momentPropertiesLen; i++) {
	                prop = momentProperties[i];
	                val = from[prop];
	                if (!isUndefined(val)) {
	                    to[prop] = val;
	                }
	            }
	        }
	
	        return to;
	    }
	
	    // Moment prototype object
	    function Moment(config) {
	        copyConfig(this, config);
	        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
	        if (!this.isValid()) {
	            this._d = new Date(NaN);
	        }
	        // Prevent infinite loop in case updateOffset creates new moment
	        // objects.
	        if (updateInProgress === false) {
	            updateInProgress = true;
	            hooks.updateOffset(this);
	            updateInProgress = false;
	        }
	    }
	
	    function isMoment(obj) {
	        return (
	            obj instanceof Moment || (obj != null && obj._isAMomentObject != null)
	        );
	    }
	
	    function warn(msg) {
	        if (
	            hooks.suppressDeprecationWarnings === false &&
	            typeof console !== 'undefined' &&
	            console.warn
	        ) {
	            console.warn('Deprecation warning: ' + msg);
	        }
	    }
	
	    function deprecate(msg, fn) {
	        var firstTime = true;
	
	        return extend(function () {
	            if (hooks.deprecationHandler != null) {
	                hooks.deprecationHandler(null, msg);
	            }
	            if (firstTime) {
	                var args = [],
	                    arg,
	                    i,
	                    key,
	                    argLen = arguments.length;
	                for (i = 0; i < argLen; i++) {
	                    arg = '';
	                    if (typeof arguments[i] === 'object') {
	                        arg += '\n[' + i + '] ';
	                        for (key in arguments[0]) {
	                            if (hasOwnProp(arguments[0], key)) {
	                                arg += key + ': ' + arguments[0][key] + ', ';
	                            }
	                        }
	                        arg = arg.slice(0, -2); // Remove trailing comma and space
	                    } else {
	                        arg = arguments[i];
	                    }
	                    args.push(arg);
	                }
	                warn(
	                    msg +
	                        '\nArguments: ' +
	                        Array.prototype.slice.call(args).join('') +
	                        '\n' +
	                        new Error().stack
	                );
	                firstTime = false;
	            }
	            return fn.apply(this, arguments);
	        }, fn);
	    }
	
	    var deprecations = {};
	
	    function deprecateSimple(name, msg) {
	        if (hooks.deprecationHandler != null) {
	            hooks.deprecationHandler(name, msg);
	        }
	        if (!deprecations[name]) {
	            warn(msg);
	            deprecations[name] = true;
	        }
	    }
	
	    hooks.suppressDeprecationWarnings = false;
	    hooks.deprecationHandler = null;
	
	    function isFunction(input) {
	        return (
	            (typeof Function !== 'undefined' && input instanceof Function) ||
	            Object.prototype.toString.call(input) === '[object Function]'
	        );
	    }
	
	    function set(config) {
	        var prop, i;
	        for (i in config) {
	            if (hasOwnProp(config, i)) {
	                prop = config[i];
	                if (isFunction(prop)) {
	                    this[i] = prop;
	                } else {
	                    this['_' + i] = prop;
	                }
	            }
	        }
	        this._config = config;
	        // Lenient ordinal parsing accepts just a number in addition to
	        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        this._dayOfMonthOrdinalParseLenient = new RegExp(
	            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
	                '|' +
	                /\d{1,2}/.source
	        );
	    }
	
	    function mergeConfigs(parentConfig, childConfig) {
	        var res = extend({}, parentConfig),
	            prop;
	        for (prop in childConfig) {
	            if (hasOwnProp(childConfig, prop)) {
	                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
	                    res[prop] = {};
	                    extend(res[prop], parentConfig[prop]);
	                    extend(res[prop], childConfig[prop]);
	                } else if (childConfig[prop] != null) {
	                    res[prop] = childConfig[prop];
	                } else {
	                    delete res[prop];
	                }
	            }
	        }
	        for (prop in parentConfig) {
	            if (
	                hasOwnProp(parentConfig, prop) &&
	                !hasOwnProp(childConfig, prop) &&
	                isObject(parentConfig[prop])
	            ) {
	                // make sure changes to properties don't modify parent config
	                res[prop] = extend({}, res[prop]);
	            }
	        }
	        return res;
	    }
	
	    function Locale(config) {
	        if (config != null) {
	            this.set(config);
	        }
	    }
	
	    var keys;
	
	    if (Object.keys) {
	        keys = Object.keys;
	    } else {
	        keys = function (obj) {
	            var i,
	                res = [];
	            for (i in obj) {
	                if (hasOwnProp(obj, i)) {
	                    res.push(i);
	                }
	            }
	            return res;
	        };
	    }
	
	    var defaultCalendar = {
	        sameDay: '[Today at] LT',
	        nextDay: '[Tomorrow at] LT',
	        nextWeek: 'dddd [at] LT',
	        lastDay: '[Yesterday at] LT',
	        lastWeek: '[Last] dddd [at] LT',
	        sameElse: 'L',
	    };
	
	    function calendar(key, mom, now) {
	        var output = this._calendar[key] || this._calendar['sameElse'];
	        return isFunction(output) ? output.call(mom, now) : output;
	    }
	
	    function zeroFill(number, targetLength, forceSign) {
	        var absNumber = '' + Math.abs(number),
	            zerosToFill = targetLength - absNumber.length,
	            sign = number >= 0;
	        return (
	            (sign ? (forceSign ? '+' : '') : '-') +
	            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) +
	            absNumber
	        );
	    }
	
	    var formattingTokens =
	            /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
	        localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
	        formatFunctions = {},
	        formatTokenFunctions = {};
	
	    // token:    'M'
	    // padded:   ['MM', 2]
	    // ordinal:  'Mo'
	    // callback: function () { this.month() + 1 }
	    function addFormatToken(token, padded, ordinal, callback) {
	        var func = callback;
	        if (typeof callback === 'string') {
	            func = function () {
	                return this[callback]();
	            };
	        }
	        if (token) {
	            formatTokenFunctions[token] = func;
	        }
	        if (padded) {
	            formatTokenFunctions[padded[0]] = function () {
	                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
	            };
	        }
	        if (ordinal) {
	            formatTokenFunctions[ordinal] = function () {
	                return this.localeData().ordinal(
	                    func.apply(this, arguments),
	                    token
	                );
	            };
	        }
	    }
	
	    function removeFormattingTokens(input) {
	        if (input.match(/\[[\s\S]/)) {
	            return input.replace(/^\[|\]$/g, '');
	        }
	        return input.replace(/\\/g, '');
	    }
	
	    function makeFormatFunction(format) {
	        var array = format.match(formattingTokens),
	            i,
	            length;
	
	        for (i = 0, length = array.length; i < length; i++) {
	            if (formatTokenFunctions[array[i]]) {
	                array[i] = formatTokenFunctions[array[i]];
	            } else {
	                array[i] = removeFormattingTokens(array[i]);
	            }
	        }
	
	        return function (mom) {
	            var output = '',
	                i;
	            for (i = 0; i < length; i++) {
	                output += isFunction(array[i])
	                    ? array[i].call(mom, format)
	                    : array[i];
	            }
	            return output;
	        };
	    }
	
	    // format date using native date object
	    function formatMoment(m, format) {
	        if (!m.isValid()) {
	            return m.localeData().invalidDate();
	        }
	
	        format = expandFormat(format, m.localeData());
	        formatFunctions[format] =
	            formatFunctions[format] || makeFormatFunction(format);
	
	        return formatFunctions[format](m);
	    }
	
	    function expandFormat(format, locale) {
	        var i = 5;
	
	        function replaceLongDateFormatTokens(input) {
	            return locale.longDateFormat(input) || input;
	        }
	
	        localFormattingTokens.lastIndex = 0;
	        while (i >= 0 && localFormattingTokens.test(format)) {
	            format = format.replace(
	                localFormattingTokens,
	                replaceLongDateFormatTokens
	            );
	            localFormattingTokens.lastIndex = 0;
	            i -= 1;
	        }
	
	        return format;
	    }
	
	    var defaultLongDateFormat = {
	        LTS: 'h:mm:ss A',
	        LT: 'h:mm A',
	        L: 'MM/DD/YYYY',
	        LL: 'MMMM D, YYYY',
	        LLL: 'MMMM D, YYYY h:mm A',
	        LLLL: 'dddd, MMMM D, YYYY h:mm A',
	    };
	
	    function longDateFormat(key) {
	        var format = this._longDateFormat[key],
	            formatUpper = this._longDateFormat[key.toUpperCase()];
	
	        if (format || !formatUpper) {
	            return format;
	        }
	
	        this._longDateFormat[key] = formatUpper
	            .match(formattingTokens)
	            .map(function (tok) {
	                if (
	                    tok === 'MMMM' ||
	                    tok === 'MM' ||
	                    tok === 'DD' ||
	                    tok === 'dddd'
	                ) {
	                    return tok.slice(1);
	                }
	                return tok;
	            })
	            .join('');
	
	        return this._longDateFormat[key];
	    }
	
	    var defaultInvalidDate = 'Invalid date';
	
	    function invalidDate() {
	        return this._invalidDate;
	    }
	
	    var defaultOrdinal = '%d',
	        defaultDayOfMonthOrdinalParse = /\d{1,2}/;
	
	    function ordinal(number) {
	        return this._ordinal.replace('%d', number);
	    }
	
	    var defaultRelativeTime = {
	        future: 'in %s',
	        past: '%s ago',
	        s: 'a few seconds',
	        ss: '%d seconds',
	        m: 'a minute',
	        mm: '%d minutes',
	        h: 'an hour',
	        hh: '%d hours',
	        d: 'a day',
	        dd: '%d days',
	        w: 'a week',
	        ww: '%d weeks',
	        M: 'a month',
	        MM: '%d months',
	        y: 'a year',
	        yy: '%d years',
	    };
	
	    function relativeTime(number, withoutSuffix, string, isFuture) {
	        var output = this._relativeTime[string];
	        return isFunction(output)
	            ? output(number, withoutSuffix, string, isFuture)
	            : output.replace(/%d/i, number);
	    }
	
	    function pastFuture(diff, output) {
	        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
	        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
	    }
	
	    var aliases = {
	        D: 'date',
	        dates: 'date',
	        date: 'date',
	        d: 'day',
	        days: 'day',
	        day: 'day',
	        e: 'weekday',
	        weekdays: 'weekday',
	        weekday: 'weekday',
	        E: 'isoWeekday',
	        isoweekdays: 'isoWeekday',
	        isoweekday: 'isoWeekday',
	        DDD: 'dayOfYear',
	        dayofyears: 'dayOfYear',
	        dayofyear: 'dayOfYear',
	        h: 'hour',
	        hours: 'hour',
	        hour: 'hour',
	        ms: 'millisecond',
	        milliseconds: 'millisecond',
	        millisecond: 'millisecond',
	        m: 'minute',
	        minutes: 'minute',
	        minute: 'minute',
	        M: 'month',
	        months: 'month',
	        month: 'month',
	        Q: 'quarter',
	        quarters: 'quarter',
	        quarter: 'quarter',
	        s: 'second',
	        seconds: 'second',
	        second: 'second',
	        gg: 'weekYear',
	        weekyears: 'weekYear',
	        weekyear: 'weekYear',
	        GG: 'isoWeekYear',
	        isoweekyears: 'isoWeekYear',
	        isoweekyear: 'isoWeekYear',
	        w: 'week',
	        weeks: 'week',
	        week: 'week',
	        W: 'isoWeek',
	        isoweeks: 'isoWeek',
	        isoweek: 'isoWeek',
	        y: 'year',
	        years: 'year',
	        year: 'year',
	    };
	
	    function normalizeUnits(units) {
	        return typeof units === 'string'
	            ? aliases[units] || aliases[units.toLowerCase()]
	            : undefined;
	    }
	
	    function normalizeObjectUnits(inputObject) {
	        var normalizedInput = {},
	            normalizedProp,
	            prop;
	
	        for (prop in inputObject) {
	            if (hasOwnProp(inputObject, prop)) {
	                normalizedProp = normalizeUnits(prop);
	                if (normalizedProp) {
	                    normalizedInput[normalizedProp] = inputObject[prop];
	                }
	            }
	        }
	
	        return normalizedInput;
	    }
	
	    var priorities = {
	        date: 9,
	        day: 11,
	        weekday: 11,
	        isoWeekday: 11,
	        dayOfYear: 4,
	        hour: 13,
	        millisecond: 16,
	        minute: 14,
	        month: 8,
	        quarter: 7,
	        second: 15,
	        weekYear: 1,
	        isoWeekYear: 1,
	        week: 5,
	        isoWeek: 5,
	        year: 1,
	    };
	
	    function getPrioritizedUnits(unitsObj) {
	        var units = [],
	            u;
	        for (u in unitsObj) {
	            if (hasOwnProp(unitsObj, u)) {
	                units.push({ unit: u, priority: priorities[u] });
	            }
	        }
	        units.sort(function (a, b) {
	            return a.priority - b.priority;
	        });
	        return units;
	    }
	
	    var match1 = /\d/, //       0 - 9
	        match2 = /\d\d/, //      00 - 99
	        match3 = /\d{3}/, //     000 - 999
	        match4 = /\d{4}/, //    0000 - 9999
	        match6 = /[+-]?\d{6}/, // -999999 - 999999
	        match1to2 = /\d\d?/, //       0 - 99
	        match3to4 = /\d\d\d\d?/, //     999 - 9999
	        match5to6 = /\d\d\d\d\d\d?/, //   99999 - 999999
	        match1to3 = /\d{1,3}/, //       0 - 999
	        match1to4 = /\d{1,4}/, //       0 - 9999
	        match1to6 = /[+-]?\d{1,6}/, // -999999 - 999999
	        matchUnsigned = /\d+/, //       0 - inf
	        matchSigned = /[+-]?\d+/, //    -inf - inf
	        matchOffset = /Z|[+-]\d\d:?\d\d/gi, // +00:00 -00:00 +0000 -0000 or Z
	        matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, // +00 -00 +00:00 -00:00 +0000 -0000 or Z
	        matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // 123456789 123456789.123
	        // any word (or two) characters or numbers including two/three word month in arabic.
	        // includes scottish gaelic two word and hyphenated months
	        matchWord =
	            /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
	        match1to2NoLeadingZero = /^[1-9]\d?/, //         1-99
	        match1to2HasZero = /^([1-9]\d|\d)/, //           0-99
	        regexes;
	
	    regexes = {};
	
	    function addRegexToken(token, regex, strictRegex) {
	        regexes[token] = isFunction(regex)
	            ? regex
	            : function (isStrict, localeData) {
	                  return isStrict && strictRegex ? strictRegex : regex;
	              };
	    }
	
	    function getParseRegexForToken(token, config) {
	        if (!hasOwnProp(regexes, token)) {
	            return new RegExp(unescapeFormat(token));
	        }
	
	        return regexes[token](config._strict, config._locale);
	    }
	
	    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
	    function unescapeFormat(s) {
	        return regexEscape(
	            s
	                .replace('\\', '')
	                .replace(
	                    /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
	                    function (matched, p1, p2, p3, p4) {
	                        return p1 || p2 || p3 || p4;
	                    }
	                )
	        );
	    }
	
	    function regexEscape(s) {
	        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	    }
	
	    function absFloor(number) {
	        if (number < 0) {
	            // -0 -> 0
	            return Math.ceil(number) || 0;
	        } else {
	            return Math.floor(number);
	        }
	    }
	
	    function toInt(argumentForCoercion) {
	        var coercedNumber = +argumentForCoercion,
	            value = 0;
	
	        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
	            value = absFloor(coercedNumber);
	        }
	
	        return value;
	    }
	
	    var tokens = {};
	
	    function addParseToken(token, callback) {
	        var i,
	            func = callback,
	            tokenLen;
	        if (typeof token === 'string') {
	            token = [token];
	        }
	        if (isNumber(callback)) {
	            func = function (input, array) {
	                array[callback] = toInt(input);
	            };
	        }
	        tokenLen = token.length;
	        for (i = 0; i < tokenLen; i++) {
	            tokens[token[i]] = func;
	        }
	    }
	
	    function addWeekParseToken(token, callback) {
	        addParseToken(token, function (input, array, config, token) {
	            config._w = config._w || {};
	            callback(input, config._w, config, token);
	        });
	    }
	
	    function addTimeToArrayFromToken(token, input, config) {
	        if (input != null && hasOwnProp(tokens, token)) {
	            tokens[token](input, config._a, config, token);
	        }
	    }
	
	    function isLeapYear(year) {
	        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
	    }
	
	    var YEAR = 0,
	        MONTH = 1,
	        DATE = 2,
	        HOUR = 3,
	        MINUTE = 4,
	        SECOND = 5,
	        MILLISECOND = 6,
	        WEEK = 7,
	        WEEKDAY = 8;
	
	    // FORMATTING
	
	    addFormatToken('Y', 0, 0, function () {
	        var y = this.year();
	        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
	    });
	
	    addFormatToken(0, ['YY', 2], 0, function () {
	        return this.year() % 100;
	    });
	
	    addFormatToken(0, ['YYYY', 4], 0, 'year');
	    addFormatToken(0, ['YYYYY', 5], 0, 'year');
	    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');
	
	    // PARSING
	
	    addRegexToken('Y', matchSigned);
	    addRegexToken('YY', match1to2, match2);
	    addRegexToken('YYYY', match1to4, match4);
	    addRegexToken('YYYYY', match1to6, match6);
	    addRegexToken('YYYYYY', match1to6, match6);
	
	    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
	    addParseToken('YYYY', function (input, array) {
	        array[YEAR] =
	            input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
	    });
	    addParseToken('YY', function (input, array) {
	        array[YEAR] = hooks.parseTwoDigitYear(input);
	    });
	    addParseToken('Y', function (input, array) {
	        array[YEAR] = parseInt(input, 10);
	    });
	
	    // HELPERS
	
	    function daysInYear(year) {
	        return isLeapYear(year) ? 366 : 365;
	    }
	
	    // HOOKS
	
	    hooks.parseTwoDigitYear = function (input) {
	        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
	    };
	
	    // MOMENTS
	
	    var getSetYear = makeGetSet('FullYear', true);
	
	    function getIsLeapYear() {
	        return isLeapYear(this.year());
	    }
	
	    function makeGetSet(unit, keepTime) {
	        return function (value) {
	            if (value != null) {
	                set$1(this, unit, value);
	                hooks.updateOffset(this, keepTime);
	                return this;
	            } else {
	                return get(this, unit);
	            }
	        };
	    }
	
	    function get(mom, unit) {
	        if (!mom.isValid()) {
	            return NaN;
	        }
	
	        var d = mom._d,
	            isUTC = mom._isUTC;
	
	        switch (unit) {
	            case 'Milliseconds':
	                return isUTC ? d.getUTCMilliseconds() : d.getMilliseconds();
	            case 'Seconds':
	                return isUTC ? d.getUTCSeconds() : d.getSeconds();
	            case 'Minutes':
	                return isUTC ? d.getUTCMinutes() : d.getMinutes();
	            case 'Hours':
	                return isUTC ? d.getUTCHours() : d.getHours();
	            case 'Date':
	                return isUTC ? d.getUTCDate() : d.getDate();
	            case 'Day':
	                return isUTC ? d.getUTCDay() : d.getDay();
	            case 'Month':
	                return isUTC ? d.getUTCMonth() : d.getMonth();
	            case 'FullYear':
	                return isUTC ? d.getUTCFullYear() : d.getFullYear();
	            default:
	                return NaN; // Just in case
	        }
	    }
	
	    function set$1(mom, unit, value) {
	        var d, isUTC, year, month, date;
	
	        if (!mom.isValid() || isNaN(value)) {
	            return;
	        }
	
	        d = mom._d;
	        isUTC = mom._isUTC;
	
	        switch (unit) {
	            case 'Milliseconds':
	                return void (isUTC
	                    ? d.setUTCMilliseconds(value)
	                    : d.setMilliseconds(value));
	            case 'Seconds':
	                return void (isUTC ? d.setUTCSeconds(value) : d.setSeconds(value));
	            case 'Minutes':
	                return void (isUTC ? d.setUTCMinutes(value) : d.setMinutes(value));
	            case 'Hours':
	                return void (isUTC ? d.setUTCHours(value) : d.setHours(value));
	            case 'Date':
	                return void (isUTC ? d.setUTCDate(value) : d.setDate(value));
	            // case 'Day': // Not real
	            //    return void (isUTC ? d.setUTCDay(value) : d.setDay(value));
	            // case 'Month': // Not used because we need to pass two variables
	            //     return void (isUTC ? d.setUTCMonth(value) : d.setMonth(value));
	            case 'FullYear':
	                break; // See below ...
	            default:
	                return; // Just in case
	        }
	
	        year = value;
	        month = mom.month();
	        date = mom.date();
	        date = date === 29 && month === 1 && !isLeapYear(year) ? 28 : date;
	        void (isUTC
	            ? d.setUTCFullYear(year, month, date)
	            : d.setFullYear(year, month, date));
	    }
	
	    // MOMENTS
	
	    function stringGet(units) {
	        units = normalizeUnits(units);
	        if (isFunction(this[units])) {
	            return this[units]();
	        }
	        return this;
	    }
	
	    function stringSet(units, value) {
	        if (typeof units === 'object') {
	            units = normalizeObjectUnits(units);
	            var prioritized = getPrioritizedUnits(units),
	                i,
	                prioritizedLen = prioritized.length;
	            for (i = 0; i < prioritizedLen; i++) {
	                this[prioritized[i].unit](units[prioritized[i].unit]);
	            }
	        } else {
	            units = normalizeUnits(units);
	            if (isFunction(this[units])) {
	                return this[units](value);
	            }
	        }
	        return this;
	    }
	
	    function mod(n, x) {
	        return ((n % x) + x) % x;
	    }
	
	    var indexOf;
	
	    if (Array.prototype.indexOf) {
	        indexOf = Array.prototype.indexOf;
	    } else {
	        indexOf = function (o) {
	            // I know
	            var i;
	            for (i = 0; i < this.length; ++i) {
	                if (this[i] === o) {
	                    return i;
	                }
	            }
	            return -1;
	        };
	    }
	
	    function daysInMonth(year, month) {
	        if (isNaN(year) || isNaN(month)) {
	            return NaN;
	        }
	        var modMonth = mod(month, 12);
	        year += (month - modMonth) / 12;
	        return modMonth === 1
	            ? isLeapYear(year)
	                ? 29
	                : 28
	            : 31 - ((modMonth % 7) % 2);
	    }
	
	    // FORMATTING
	
	    addFormatToken('M', ['MM', 2], 'Mo', function () {
	        return this.month() + 1;
	    });
	
	    addFormatToken('MMM', 0, 0, function (format) {
	        return this.localeData().monthsShort(this, format);
	    });
	
	    addFormatToken('MMMM', 0, 0, function (format) {
	        return this.localeData().months(this, format);
	    });
	
	    // PARSING
	
	    addRegexToken('M', match1to2, match1to2NoLeadingZero);
	    addRegexToken('MM', match1to2, match2);
	    addRegexToken('MMM', function (isStrict, locale) {
	        return locale.monthsShortRegex(isStrict);
	    });
	    addRegexToken('MMMM', function (isStrict, locale) {
	        return locale.monthsRegex(isStrict);
	    });
	
	    addParseToken(['M', 'MM'], function (input, array) {
	        array[MONTH] = toInt(input) - 1;
	    });
	
	    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
	        var month = config._locale.monthsParse(input, token, config._strict);
	        // if we didn't find a month name, mark the date as invalid.
	        if (month != null) {
	            array[MONTH] = month;
	        } else {
	            getParsingFlags(config).invalidMonth = input;
	        }
	    });
	
	    // LOCALES
	
	    var defaultLocaleMonths =
	            'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	                '_'
	            ),
	        defaultLocaleMonthsShort =
	            'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
	        defaultMonthsShortRegex = matchWord,
	        defaultMonthsRegex = matchWord;
	
	    function localeMonths(m, format) {
	        if (!m) {
	            return isArray(this._months)
	                ? this._months
	                : this._months['standalone'];
	        }
	        return isArray(this._months)
	            ? this._months[m.month()]
	            : this._months[
	                  (this._months.isFormat || MONTHS_IN_FORMAT).test(format)
	                      ? 'format'
	                      : 'standalone'
	              ][m.month()];
	    }
	
	    function localeMonthsShort(m, format) {
	        if (!m) {
	            return isArray(this._monthsShort)
	                ? this._monthsShort
	                : this._monthsShort['standalone'];
	        }
	        return isArray(this._monthsShort)
	            ? this._monthsShort[m.month()]
	            : this._monthsShort[
	                  MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'
	              ][m.month()];
	    }
	
	    function handleStrictParse(monthName, format, strict) {
	        var i,
	            ii,
	            mom,
	            llc = monthName.toLocaleLowerCase();
	        if (!this._monthsParse) {
	            // this is not used
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	            for (i = 0; i < 12; ++i) {
	                mom = createUTC([2000, i]);
	                this._shortMonthsParse[i] = this.monthsShort(
	                    mom,
	                    ''
	                ).toLocaleLowerCase();
	                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeMonthsParse(monthName, format, strict) {
	        var i, mom, regex;
	
	        if (this._monthsParseExact) {
	            return handleStrictParse.call(this, monthName, format, strict);
	        }
	
	        if (!this._monthsParse) {
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	        }
	
	        // TODO: add sorting
	        // Sorting makes sure if one month (or abbr) is a prefix of another
	        // see sorting in computeMonthsParse
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            if (strict && !this._longMonthsParse[i]) {
	                this._longMonthsParse[i] = new RegExp(
	                    '^' + this.months(mom, '').replace('.', '') + '$',
	                    'i'
	                );
	                this._shortMonthsParse[i] = new RegExp(
	                    '^' + this.monthsShort(mom, '').replace('.', '') + '$',
	                    'i'
	                );
	            }
	            if (!strict && !this._monthsParse[i]) {
	                regex =
	                    '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
	                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (
	                strict &&
	                format === 'MMMM' &&
	                this._longMonthsParse[i].test(monthName)
	            ) {
	                return i;
	            } else if (
	                strict &&
	                format === 'MMM' &&
	                this._shortMonthsParse[i].test(monthName)
	            ) {
	                return i;
	            } else if (!strict && this._monthsParse[i].test(monthName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function setMonth(mom, value) {
	        if (!mom.isValid()) {
	            // No op
	            return mom;
	        }
	
	        if (typeof value === 'string') {
	            if (/^\d+$/.test(value)) {
	                value = toInt(value);
	            } else {
	                value = mom.localeData().monthsParse(value);
	                // TODO: Another silent failure?
	                if (!isNumber(value)) {
	                    return mom;
	                }
	            }
	        }
	
	        var month = value,
	            date = mom.date();
	
	        date = date < 29 ? date : Math.min(date, daysInMonth(mom.year(), month));
	        void (mom._isUTC
	            ? mom._d.setUTCMonth(month, date)
	            : mom._d.setMonth(month, date));
	        return mom;
	    }
	
	    function getSetMonth(value) {
	        if (value != null) {
	            setMonth(this, value);
	            hooks.updateOffset(this, true);
	            return this;
	        } else {
	            return get(this, 'Month');
	        }
	    }
	
	    function getDaysInMonth() {
	        return daysInMonth(this.year(), this.month());
	    }
	
	    function monthsShortRegex(isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsShortStrictRegex;
	            } else {
	                return this._monthsShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsShortRegex')) {
	                this._monthsShortRegex = defaultMonthsShortRegex;
	            }
	            return this._monthsShortStrictRegex && isStrict
	                ? this._monthsShortStrictRegex
	                : this._monthsShortRegex;
	        }
	    }
	
	    function monthsRegex(isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsStrictRegex;
	            } else {
	                return this._monthsRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                this._monthsRegex = defaultMonthsRegex;
	            }
	            return this._monthsStrictRegex && isStrict
	                ? this._monthsStrictRegex
	                : this._monthsRegex;
	        }
	    }
	
	    function computeMonthsParse() {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var shortPieces = [],
	            longPieces = [],
	            mixedPieces = [],
	            i,
	            mom,
	            shortP,
	            longP;
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            shortP = regexEscape(this.monthsShort(mom, ''));
	            longP = regexEscape(this.months(mom, ''));
	            shortPieces.push(shortP);
	            longPieces.push(longP);
	            mixedPieces.push(longP);
	            mixedPieces.push(shortP);
	        }
	        // Sorting makes sure if one month (or abbr) is a prefix of another it
	        // will match the longer piece.
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	
	        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._monthsShortRegex = this._monthsRegex;
	        this._monthsStrictRegex = new RegExp(
	            '^(' + longPieces.join('|') + ')',
	            'i'
	        );
	        this._monthsShortStrictRegex = new RegExp(
	            '^(' + shortPieces.join('|') + ')',
	            'i'
	        );
	    }
	
	    function createDate(y, m, d, h, M, s, ms) {
	        // can't just apply() to create a date:
	        // https://stackoverflow.com/q/181348
	        var date;
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            date = new Date(y + 400, m, d, h, M, s, ms);
	            if (isFinite(date.getFullYear())) {
	                date.setFullYear(y);
	            }
	        } else {
	            date = new Date(y, m, d, h, M, s, ms);
	        }
	
	        return date;
	    }
	
	    function createUTCDate(y) {
	        var date, args;
	        // the Date.UTC function remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            args = Array.prototype.slice.call(arguments);
	            // preserve leap years using a full 400 year cycle, then reset
	            args[0] = y + 400;
	            date = new Date(Date.UTC.apply(null, args));
	            if (isFinite(date.getUTCFullYear())) {
	                date.setUTCFullYear(y);
	            }
	        } else {
	            date = new Date(Date.UTC.apply(null, arguments));
	        }
	
	        return date;
	    }
	
	    // start-of-first-week - start-of-year
	    function firstWeekOffset(year, dow, doy) {
	        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
	            fwd = 7 + dow - doy,
	            // first-week day local weekday -- which local weekday is fwd
	            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
	
	        return -fwdlw + fwd - 1;
	    }
	
	    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
	    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
	        var localWeekday = (7 + weekday - dow) % 7,
	            weekOffset = firstWeekOffset(year, dow, doy),
	            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
	            resYear,
	            resDayOfYear;
	
	        if (dayOfYear <= 0) {
	            resYear = year - 1;
	            resDayOfYear = daysInYear(resYear) + dayOfYear;
	        } else if (dayOfYear > daysInYear(year)) {
	            resYear = year + 1;
	            resDayOfYear = dayOfYear - daysInYear(year);
	        } else {
	            resYear = year;
	            resDayOfYear = dayOfYear;
	        }
	
	        return {
	            year: resYear,
	            dayOfYear: resDayOfYear,
	        };
	    }
	
	    function weekOfYear(mom, dow, doy) {
	        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
	            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
	            resWeek,
	            resYear;
	
	        if (week < 1) {
	            resYear = mom.year() - 1;
	            resWeek = week + weeksInYear(resYear, dow, doy);
	        } else if (week > weeksInYear(mom.year(), dow, doy)) {
	            resWeek = week - weeksInYear(mom.year(), dow, doy);
	            resYear = mom.year() + 1;
	        } else {
	            resYear = mom.year();
	            resWeek = week;
	        }
	
	        return {
	            week: resWeek,
	            year: resYear,
	        };
	    }
	
	    function weeksInYear(year, dow, doy) {
	        var weekOffset = firstWeekOffset(year, dow, doy),
	            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
	        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
	    }
	
	    // FORMATTING
	
	    addFormatToken('w', ['ww', 2], 'wo', 'week');
	    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');
	
	    // PARSING
	
	    addRegexToken('w', match1to2, match1to2NoLeadingZero);
	    addRegexToken('ww', match1to2, match2);
	    addRegexToken('W', match1to2, match1to2NoLeadingZero);
	    addRegexToken('WW', match1to2, match2);
	
	    addWeekParseToken(
	        ['w', 'ww', 'W', 'WW'],
	        function (input, week, config, token) {
	            week[token.substr(0, 1)] = toInt(input);
	        }
	    );
	
	    // HELPERS
	
	    // LOCALES
	
	    function localeWeek(mom) {
	        return weekOfYear(mom, this._week.dow, this._week.doy).week;
	    }
	
	    var defaultLocaleWeek = {
	        dow: 0, // Sunday is the first day of the week.
	        doy: 6, // The week that contains Jan 6th is the first week of the year.
	    };
	
	    function localeFirstDayOfWeek() {
	        return this._week.dow;
	    }
	
	    function localeFirstDayOfYear() {
	        return this._week.doy;
	    }
	
	    // MOMENTS
	
	    function getSetWeek(input) {
	        var week = this.localeData().week(this);
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    function getSetISOWeek(input) {
	        var week = weekOfYear(this, 1, 4).week;
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('d', 0, 'do', 'day');
	
	    addFormatToken('dd', 0, 0, function (format) {
	        return this.localeData().weekdaysMin(this, format);
	    });
	
	    addFormatToken('ddd', 0, 0, function (format) {
	        return this.localeData().weekdaysShort(this, format);
	    });
	
	    addFormatToken('dddd', 0, 0, function (format) {
	        return this.localeData().weekdays(this, format);
	    });
	
	    addFormatToken('e', 0, 0, 'weekday');
	    addFormatToken('E', 0, 0, 'isoWeekday');
	
	    // PARSING
	
	    addRegexToken('d', match1to2);
	    addRegexToken('e', match1to2);
	    addRegexToken('E', match1to2);
	    addRegexToken('dd', function (isStrict, locale) {
	        return locale.weekdaysMinRegex(isStrict);
	    });
	    addRegexToken('ddd', function (isStrict, locale) {
	        return locale.weekdaysShortRegex(isStrict);
	    });
	    addRegexToken('dddd', function (isStrict, locale) {
	        return locale.weekdaysRegex(isStrict);
	    });
	
	    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
	        var weekday = config._locale.weekdaysParse(input, token, config._strict);
	        // if we didn't get a weekday name, mark the date as invalid
	        if (weekday != null) {
	            week.d = weekday;
	        } else {
	            getParsingFlags(config).invalidWeekday = input;
	        }
	    });
	
	    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
	        week[token] = toInt(input);
	    });
	
	    // HELPERS
	
	    function parseWeekday(input, locale) {
	        if (typeof input !== 'string') {
	            return input;
	        }
	
	        if (!isNaN(input)) {
	            return parseInt(input, 10);
	        }
	
	        input = locale.weekdaysParse(input);
	        if (typeof input === 'number') {
	            return input;
	        }
	
	        return null;
	    }
	
	    function parseIsoWeekday(input, locale) {
	        if (typeof input === 'string') {
	            return locale.weekdaysParse(input) % 7 || 7;
	        }
	        return isNaN(input) ? null : input;
	    }
	
	    // LOCALES
	    function shiftWeekdays(ws, n) {
	        return ws.slice(n, 7).concat(ws.slice(0, n));
	    }
	
	    var defaultLocaleWeekdays =
	            'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        defaultWeekdaysRegex = matchWord,
	        defaultWeekdaysShortRegex = matchWord,
	        defaultWeekdaysMinRegex = matchWord;
	
	    function localeWeekdays(m, format) {
	        var weekdays = isArray(this._weekdays)
	            ? this._weekdays
	            : this._weekdays[
	                  m && m !== true && this._weekdays.isFormat.test(format)
	                      ? 'format'
	                      : 'standalone'
	              ];
	        return m === true
	            ? shiftWeekdays(weekdays, this._week.dow)
	            : m
	              ? weekdays[m.day()]
	              : weekdays;
	    }
	
	    function localeWeekdaysShort(m) {
	        return m === true
	            ? shiftWeekdays(this._weekdaysShort, this._week.dow)
	            : m
	              ? this._weekdaysShort[m.day()]
	              : this._weekdaysShort;
	    }
	
	    function localeWeekdaysMin(m) {
	        return m === true
	            ? shiftWeekdays(this._weekdaysMin, this._week.dow)
	            : m
	              ? this._weekdaysMin[m.day()]
	              : this._weekdaysMin;
	    }
	
	    function handleStrictParse$1(weekdayName, format, strict) {
	        var i,
	            ii,
	            mom,
	            llc = weekdayName.toLocaleLowerCase();
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._minWeekdaysParse = [];
	
	            for (i = 0; i < 7; ++i) {
	                mom = createUTC([2000, 1]).day(i);
	                this._minWeekdaysParse[i] = this.weekdaysMin(
	                    mom,
	                    ''
	                ).toLocaleLowerCase();
	                this._shortWeekdaysParse[i] = this.weekdaysShort(
	                    mom,
	                    ''
	                ).toLocaleLowerCase();
	                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeWeekdaysParse(weekdayName, format, strict) {
	        var i, mom, regex;
	
	        if (this._weekdaysParseExact) {
	            return handleStrictParse$1.call(this, weekdayName, format, strict);
	        }
	
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._minWeekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._fullWeekdaysParse = [];
	        }
	
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	
	            mom = createUTC([2000, 1]).day(i);
	            if (strict && !this._fullWeekdaysParse[i]) {
	                this._fullWeekdaysParse[i] = new RegExp(
	                    '^' + this.weekdays(mom, '').replace('.', '\\.?') + '$',
	                    'i'
	                );
	                this._shortWeekdaysParse[i] = new RegExp(
	                    '^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$',
	                    'i'
	                );
	                this._minWeekdaysParse[i] = new RegExp(
	                    '^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$',
	                    'i'
	                );
	            }
	            if (!this._weekdaysParse[i]) {
	                regex =
	                    '^' +
	                    this.weekdays(mom, '') +
	                    '|^' +
	                    this.weekdaysShort(mom, '') +
	                    '|^' +
	                    this.weekdaysMin(mom, '');
	                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (
	                strict &&
	                format === 'dddd' &&
	                this._fullWeekdaysParse[i].test(weekdayName)
	            ) {
	                return i;
	            } else if (
	                strict &&
	                format === 'ddd' &&
	                this._shortWeekdaysParse[i].test(weekdayName)
	            ) {
	                return i;
	            } else if (
	                strict &&
	                format === 'dd' &&
	                this._minWeekdaysParse[i].test(weekdayName)
	            ) {
	                return i;
	            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function getSetDayOfWeek(input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	
	        var day = get(this, 'Day');
	        if (input != null) {
	            input = parseWeekday(input, this.localeData());
	            return this.add(input - day, 'd');
	        } else {
	            return day;
	        }
	    }
	
	    function getSetLocaleDayOfWeek(input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
	        return input == null ? weekday : this.add(input - weekday, 'd');
	    }
	
	    function getSetISODayOfWeek(input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	
	        // behaves the same as moment#day except
	        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
	        // as a setter, sunday should belong to the previous week.
	
	        if (input != null) {
	            var weekday = parseIsoWeekday(input, this.localeData());
	            return this.day(this.day() % 7 ? weekday : weekday - 7);
	        } else {
	            return this.day() || 7;
	        }
	    }
	
	    function weekdaysRegex(isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysStrictRegex;
	            } else {
	                return this._weekdaysRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                this._weekdaysRegex = defaultWeekdaysRegex;
	            }
	            return this._weekdaysStrictRegex && isStrict
	                ? this._weekdaysStrictRegex
	                : this._weekdaysRegex;
	        }
	    }
	
	    function weekdaysShortRegex(isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysShortStrictRegex;
	            } else {
	                return this._weekdaysShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
	                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
	            }
	            return this._weekdaysShortStrictRegex && isStrict
	                ? this._weekdaysShortStrictRegex
	                : this._weekdaysShortRegex;
	        }
	    }
	
	    function weekdaysMinRegex(isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysMinStrictRegex;
	            } else {
	                return this._weekdaysMinRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
	                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
	            }
	            return this._weekdaysMinStrictRegex && isStrict
	                ? this._weekdaysMinStrictRegex
	                : this._weekdaysMinRegex;
	        }
	    }
	
	    function computeWeekdaysParse() {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var minPieces = [],
	            shortPieces = [],
	            longPieces = [],
	            mixedPieces = [],
	            i,
	            mom,
	            minp,
	            shortp,
	            longp;
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, 1]).day(i);
	            minp = regexEscape(this.weekdaysMin(mom, ''));
	            shortp = regexEscape(this.weekdaysShort(mom, ''));
	            longp = regexEscape(this.weekdays(mom, ''));
	            minPieces.push(minp);
	            shortPieces.push(shortp);
	            longPieces.push(longp);
	            mixedPieces.push(minp);
	            mixedPieces.push(shortp);
	            mixedPieces.push(longp);
	        }
	        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
	        // will match the longer piece.
	        minPieces.sort(cmpLenRev);
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	
	        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._weekdaysShortRegex = this._weekdaysRegex;
	        this._weekdaysMinRegex = this._weekdaysRegex;
	
	        this._weekdaysStrictRegex = new RegExp(
	            '^(' + longPieces.join('|') + ')',
	            'i'
	        );
	        this._weekdaysShortStrictRegex = new RegExp(
	            '^(' + shortPieces.join('|') + ')',
	            'i'
	        );
	        this._weekdaysMinStrictRegex = new RegExp(
	            '^(' + minPieces.join('|') + ')',
	            'i'
	        );
	    }
	
	    // FORMATTING
	
	    function hFormat() {
	        return this.hours() % 12 || 12;
	    }
	
	    function kFormat() {
	        return this.hours() || 24;
	    }
	
	    addFormatToken('H', ['HH', 2], 0, 'hour');
	    addFormatToken('h', ['hh', 2], 0, hFormat);
	    addFormatToken('k', ['kk', 2], 0, kFormat);
	
	    addFormatToken('hmm', 0, 0, function () {
	        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('hmmss', 0, 0, function () {
	        return (
	            '' +
	            hFormat.apply(this) +
	            zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2)
	        );
	    });
	
	    addFormatToken('Hmm', 0, 0, function () {
	        return '' + this.hours() + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('Hmmss', 0, 0, function () {
	        return (
	            '' +
	            this.hours() +
	            zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2)
	        );
	    });
	
	    function meridiem(token, lowercase) {
	        addFormatToken(token, 0, 0, function () {
	            return this.localeData().meridiem(
	                this.hours(),
	                this.minutes(),
	                lowercase
	            );
	        });
	    }
	
	    meridiem('a', true);
	    meridiem('A', false);
	
	    // PARSING
	
	    function matchMeridiem(isStrict, locale) {
	        return locale._meridiemParse;
	    }
	
	    addRegexToken('a', matchMeridiem);
	    addRegexToken('A', matchMeridiem);
	    addRegexToken('H', match1to2, match1to2HasZero);
	    addRegexToken('h', match1to2, match1to2NoLeadingZero);
	    addRegexToken('k', match1to2, match1to2NoLeadingZero);
	    addRegexToken('HH', match1to2, match2);
	    addRegexToken('hh', match1to2, match2);
	    addRegexToken('kk', match1to2, match2);
	
	    addRegexToken('hmm', match3to4);
	    addRegexToken('hmmss', match5to6);
	    addRegexToken('Hmm', match3to4);
	    addRegexToken('Hmmss', match5to6);
	
	    addParseToken(['H', 'HH'], HOUR);
	    addParseToken(['k', 'kk'], function (input, array, config) {
	        var kInput = toInt(input);
	        array[HOUR] = kInput === 24 ? 0 : kInput;
	    });
	    addParseToken(['a', 'A'], function (input, array, config) {
	        config._isPm = config._locale.isPM(input);
	        config._meridiem = input;
	    });
	    addParseToken(['h', 'hh'], function (input, array, config) {
	        array[HOUR] = toInt(input);
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmmss', function (input, array, config) {
	        var pos1 = input.length - 4,
	            pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('Hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	    });
	    addParseToken('Hmmss', function (input, array, config) {
	        var pos1 = input.length - 4,
	            pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	    });
	
	    // LOCALES
	
	    function localeIsPM(input) {
	        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
	        // Using charAt should be more compatible.
	        return (input + '').toLowerCase().charAt(0) === 'p';
	    }
	
	    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
	        // Setting the hour should keep the time, because the user explicitly
	        // specified which hour they want. So trying to maintain the same hour (in
	        // a new timezone) makes sense. Adding/subtracting hours does not follow
	        // this rule.
	        getSetHour = makeGetSet('Hours', true);
	
	    function localeMeridiem(hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'pm' : 'PM';
	        } else {
	            return isLower ? 'am' : 'AM';
	        }
	    }
	
	    var baseConfig = {
	        calendar: defaultCalendar,
	        longDateFormat: defaultLongDateFormat,
	        invalidDate: defaultInvalidDate,
	        ordinal: defaultOrdinal,
	        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
	        relativeTime: defaultRelativeTime,
	
	        months: defaultLocaleMonths,
	        monthsShort: defaultLocaleMonthsShort,
	
	        week: defaultLocaleWeek,
	
	        weekdays: defaultLocaleWeekdays,
	        weekdaysMin: defaultLocaleWeekdaysMin,
	        weekdaysShort: defaultLocaleWeekdaysShort,
	
	        meridiemParse: defaultLocaleMeridiemParse,
	    };
	
	    // internal storage for locale config files
	    var locales = {},
	        localeFamilies = {},
	        globalLocale;
	
	    function commonPrefix(arr1, arr2) {
	        var i,
	            minl = Math.min(arr1.length, arr2.length);
	        for (i = 0; i < minl; i += 1) {
	            if (arr1[i] !== arr2[i]) {
	                return i;
	            }
	        }
	        return minl;
	    }
	
	    function normalizeLocale(key) {
	        return key ? key.toLowerCase().replace('_', '-') : key;
	    }
	
	    // pick the locale from the array
	    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
	    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
	    function chooseLocale(names) {
	        var i = 0,
	            j,
	            next,
	            locale,
	            split;
	
	        while (i < names.length) {
	            split = normalizeLocale(names[i]).split('-');
	            j = split.length;
	            next = normalizeLocale(names[i + 1]);
	            next = next ? next.split('-') : null;
	            while (j > 0) {
	                locale = loadLocale(split.slice(0, j).join('-'));
	                if (locale) {
	                    return locale;
	                }
	                if (
	                    next &&
	                    next.length >= j &&
	                    commonPrefix(split, next) >= j - 1
	                ) {
	                    //the next array item is better than a shallower substring of this one
	                    break;
	                }
	                j--;
	            }
	            i++;
	        }
	        return globalLocale;
	    }
	
	    function isLocaleNameSane(name) {
	        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
	        // Ensure name is available and function returns boolean
	        return !!(name && name.match('^[^/\\\\]*$'));
	    }
	
	    function loadLocale(name) {
	        var oldLocale = null,
	            aliasedRequire;
	        // TODO: Find a better way to register and load all the locales in Node
	        if (
	            locales[name] === undefined &&
	            typeof module !== 'undefined' &&
	            module &&
	            module.exports &&
	            isLocaleNameSane(name)
	        ) {
	            try {
	                oldLocale = globalLocale._abbr;
	                aliasedRequire = require;
	                !(function webpackMissingModule() { var e = new Error("Cannot find module \"./locale\""); e.code = 'MODULE_NOT_FOUND'; throw e; }());
	                getSetGlobalLocale(oldLocale);
	            } catch (e) {
	                // mark as not found to avoid repeating expensive file require call causing high CPU
	                // when trying to find en-US, en_US, en-us for every format call
	                locales[name] = null; // null means not found
	            }
	        }
	        return locales[name];
	    }
	
	    // This function will load locale and then set the global locale.  If
	    // no arguments are passed in, it will simply return the current global
	    // locale key.
	    function getSetGlobalLocale(key, values) {
	        var data;
	        if (key) {
	            if (isUndefined(values)) {
	                data = getLocale(key);
	            } else {
	                data = defineLocale(key, values);
	            }
	
	            if (data) {
	                // moment.duration._locale = moment._locale = data;
	                globalLocale = data;
	            } else {
	                if (typeof console !== 'undefined' && console.warn) {
	                    //warn user if arguments are passed but the locale could not be set
	                    console.warn(
	                        'Locale ' + key + ' not found. Did you forget to load it?'
	                    );
	                }
	            }
	        }
	
	        return globalLocale._abbr;
	    }
	
	    function defineLocale(name, config) {
	        if (config !== null) {
	            var locale,
	                parentConfig = baseConfig;
	            config.abbr = name;
	            if (locales[name] != null) {
	                deprecateSimple(
	                    'defineLocaleOverride',
	                    'use moment.updateLocale(localeName, config) to change ' +
	                        'an existing locale. moment.defineLocale(localeName, ' +
	                        'config) should only be used for creating a new locale ' +
	                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.'
	                );
	                parentConfig = locales[name]._config;
	            } else if (config.parentLocale != null) {
	                if (locales[config.parentLocale] != null) {
	                    parentConfig = locales[config.parentLocale]._config;
	                } else {
	                    locale = loadLocale(config.parentLocale);
	                    if (locale != null) {
	                        parentConfig = locale._config;
	                    } else {
	                        if (!localeFamilies[config.parentLocale]) {
	                            localeFamilies[config.parentLocale] = [];
	                        }
	                        localeFamilies[config.parentLocale].push({
	                            name: name,
	                            config: config,
	                        });
	                        return null;
	                    }
	                }
	            }
	            locales[name] = new Locale(mergeConfigs(parentConfig, config));
	
	            if (localeFamilies[name]) {
	                localeFamilies[name].forEach(function (x) {
	                    defineLocale(x.name, x.config);
	                });
	            }
	
	            // backwards compat for now: also set the locale
	            // make sure we set the locale AFTER all child locales have been
	            // created, so we won't end up with the child locale set.
	            getSetGlobalLocale(name);
	
	            return locales[name];
	        } else {
	            // useful for testing
	            delete locales[name];
	            return null;
	        }
	    }
	
	    function updateLocale(name, config) {
	        if (config != null) {
	            var locale,
	                tmpLocale,
	                parentConfig = baseConfig;
	
	            if (locales[name] != null && locales[name].parentLocale != null) {
	                // Update existing child locale in-place to avoid memory-leaks
	                locales[name].set(mergeConfigs(locales[name]._config, config));
	            } else {
	                // MERGE
	                tmpLocale = loadLocale(name);
	                if (tmpLocale != null) {
	                    parentConfig = tmpLocale._config;
	                }
	                config = mergeConfigs(parentConfig, config);
	                if (tmpLocale == null) {
	                    // updateLocale is called for creating a new locale
	                    // Set abbr so it will have a name (getters return
	                    // undefined otherwise).
	                    config.abbr = name;
	                }
	                locale = new Locale(config);
	                locale.parentLocale = locales[name];
	                locales[name] = locale;
	            }
	
	            // backwards compat for now: also set the locale
	            getSetGlobalLocale(name);
	        } else {
	            // pass null for config to unupdate, useful for tests
	            if (locales[name] != null) {
	                if (locales[name].parentLocale != null) {
	                    locales[name] = locales[name].parentLocale;
	                    if (name === getSetGlobalLocale()) {
	                        getSetGlobalLocale(name);
	                    }
	                } else if (locales[name] != null) {
	                    delete locales[name];
	                }
	            }
	        }
	        return locales[name];
	    }
	
	    // returns locale data
	    function getLocale(key) {
	        var locale;
	
	        if (key && key._locale && key._locale._abbr) {
	            key = key._locale._abbr;
	        }
	
	        if (!key) {
	            return globalLocale;
	        }
	
	        if (!isArray(key)) {
	            //short-circuit everything else
	            locale = loadLocale(key);
	            if (locale) {
	                return locale;
	            }
	            key = [key];
	        }
	
	        return chooseLocale(key);
	    }
	
	    function listLocales() {
	        return keys(locales);
	    }
	
	    function checkOverflow(m) {
	        var overflow,
	            a = m._a;
	
	        if (a && getParsingFlags(m).overflow === -2) {
	            overflow =
	                a[MONTH] < 0 || a[MONTH] > 11
	                    ? MONTH
	                    : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH])
	                      ? DATE
	                      : a[HOUR] < 0 ||
	                          a[HOUR] > 24 ||
	                          (a[HOUR] === 24 &&
	                              (a[MINUTE] !== 0 ||
	                                  a[SECOND] !== 0 ||
	                                  a[MILLISECOND] !== 0))
	                        ? HOUR
	                        : a[MINUTE] < 0 || a[MINUTE] > 59
	                          ? MINUTE
	                          : a[SECOND] < 0 || a[SECOND] > 59
	                            ? SECOND
	                            : a[MILLISECOND] < 0 || a[MILLISECOND] > 999
	                              ? MILLISECOND
	                              : -1;
	
	            if (
	                getParsingFlags(m)._overflowDayOfYear &&
	                (overflow < YEAR || overflow > DATE)
	            ) {
	                overflow = DATE;
	            }
	            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
	                overflow = WEEK;
	            }
	            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
	                overflow = WEEKDAY;
	            }
	
	            getParsingFlags(m).overflow = overflow;
	        }
	
	        return m;
	    }
	
	    // iso 8601 regex
	    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
	    var extendedIsoRegex =
	            /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
	        basicIsoRegex =
	            /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
	        tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
	        isoDates = [
	            ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
	            ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
	            ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
	            ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
	            ['YYYY-DDD', /\d{4}-\d{3}/],
	            ['YYYY-MM', /\d{4}-\d\d/, false],
	            ['YYYYYYMMDD', /[+-]\d{10}/],
	            ['YYYYMMDD', /\d{8}/],
	            ['GGGG[W]WWE', /\d{4}W\d{3}/],
	            ['GGGG[W]WW', /\d{4}W\d{2}/, false],
	            ['YYYYDDD', /\d{7}/],
	            ['YYYYMM', /\d{6}/, false],
	            ['YYYY', /\d{4}/, false],
	        ],
	        // iso time formats and regexes
	        isoTimes = [
	            ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
	            ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
	            ['HH:mm:ss', /\d\d:\d\d:\d\d/],
	            ['HH:mm', /\d\d:\d\d/],
	            ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
	            ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
	            ['HHmmss', /\d\d\d\d\d\d/],
	            ['HHmm', /\d\d\d\d/],
	            ['HH', /\d\d/],
	        ],
	        aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
	        // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
	        rfc2822 =
	            /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
	        obsOffsets = {
	            UT: 0,
	            GMT: 0,
	            EDT: -4 * 60,
	            EST: -5 * 60,
	            CDT: -5 * 60,
	            CST: -6 * 60,
	            MDT: -6 * 60,
	            MST: -7 * 60,
	            PDT: -7 * 60,
	            PST: -8 * 60,
	        };
	
	    // date from iso format
	    function configFromISO(config) {
	        var i,
	            l,
	            string = config._i,
	            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
	            allowTime,
	            dateFormat,
	            timeFormat,
	            tzFormat,
	            isoDatesLen = isoDates.length,
	            isoTimesLen = isoTimes.length;
	
	        if (match) {
	            getParsingFlags(config).iso = true;
	            for (i = 0, l = isoDatesLen; i < l; i++) {
	                if (isoDates[i][1].exec(match[1])) {
	                    dateFormat = isoDates[i][0];
	                    allowTime = isoDates[i][2] !== false;
	                    break;
	                }
	            }
	            if (dateFormat == null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[3]) {
	                for (i = 0, l = isoTimesLen; i < l; i++) {
	                    if (isoTimes[i][1].exec(match[3])) {
	                        // match[2] should be 'T' or space
	                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
	                        break;
	                    }
	                }
	                if (timeFormat == null) {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            if (!allowTime && timeFormat != null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[4]) {
	                if (tzRegex.exec(match[4])) {
	                    tzFormat = 'Z';
	                } else {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
	            configFromStringAndFormat(config);
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    function extractFromRFC2822Strings(
	        yearStr,
	        monthStr,
	        dayStr,
	        hourStr,
	        minuteStr,
	        secondStr
	    ) {
	        var result = [
	            untruncateYear(yearStr),
	            defaultLocaleMonthsShort.indexOf(monthStr),
	            parseInt(dayStr, 10),
	            parseInt(hourStr, 10),
	            parseInt(minuteStr, 10),
	        ];
	
	        if (secondStr) {
	            result.push(parseInt(secondStr, 10));
	        }
	
	        return result;
	    }
	
	    function untruncateYear(yearStr) {
	        var year = parseInt(yearStr, 10);
	        if (year <= 49) {
	            return 2000 + year;
	        } else if (year <= 999) {
	            return 1900 + year;
	        }
	        return year;
	    }
	
	    function preprocessRFC2822(s) {
	        // Remove comments and folding whitespace and replace multiple-spaces with a single space
	        return s
	            .replace(/\([^()]*\)|[\n\t]/g, ' ')
	            .replace(/(\s\s+)/g, ' ')
	            .replace(/^\s\s*/, '')
	            .replace(/\s\s*$/, '');
	    }
	
	    function checkWeekday(weekdayStr, parsedInput, config) {
	        if (weekdayStr) {
	            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
	            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
	                weekdayActual = new Date(
	                    parsedInput[0],
	                    parsedInput[1],
	                    parsedInput[2]
	                ).getDay();
	            if (weekdayProvided !== weekdayActual) {
	                getParsingFlags(config).weekdayMismatch = true;
	                config._isValid = false;
	                return false;
	            }
	        }
	        return true;
	    }
	
	    function calculateOffset(obsOffset, militaryOffset, numOffset) {
	        if (obsOffset) {
	            return obsOffsets[obsOffset];
	        } else if (militaryOffset) {
	            // the only allowed military tz is Z
	            return 0;
	        } else {
	            var hm = parseInt(numOffset, 10),
	                m = hm % 100,
	                h = (hm - m) / 100;
	            return h * 60 + m;
	        }
	    }
	
	    // date and time from ref 2822 format
	    function configFromRFC2822(config) {
	        var match = rfc2822.exec(preprocessRFC2822(config._i)),
	            parsedArray;
	        if (match) {
	            parsedArray = extractFromRFC2822Strings(
	                match[4],
	                match[3],
	                match[2],
	                match[5],
	                match[6],
	                match[7]
	            );
	            if (!checkWeekday(match[1], parsedArray, config)) {
	                return;
	            }
	
	            config._a = parsedArray;
	            config._tzm = calculateOffset(match[8], match[9], match[10]);
	
	            config._d = createUTCDate.apply(null, config._a);
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	
	            getParsingFlags(config).rfc2822 = true;
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
	    function configFromString(config) {
	        var matched = aspNetJsonRegex.exec(config._i);
	        if (matched !== null) {
	            config._d = new Date(+matched[1]);
	            return;
	        }
	
	        configFromISO(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        configFromRFC2822(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        if (config._strict) {
	            config._isValid = false;
	        } else {
	            // Final attempt, use Input Fallback
	            hooks.createFromInputFallback(config);
	        }
	    }
	
	    hooks.createFromInputFallback = deprecate(
	        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
	            'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
	            'discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.',
	        function (config) {
	            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
	        }
	    );
	
	    // Pick the first defined of two or three arguments.
	    function defaults(a, b, c) {
	        if (a != null) {
	            return a;
	        }
	        if (b != null) {
	            return b;
	        }
	        return c;
	    }
	
	    function currentDateArray(config) {
	        // hooks is actually the exported moment object
	        var nowValue = new Date(hooks.now());
	        if (config._useUTC) {
	            return [
	                nowValue.getUTCFullYear(),
	                nowValue.getUTCMonth(),
	                nowValue.getUTCDate(),
	            ];
	        }
	        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
	    }
	
	    // convert an array to a date.
	    // the array should mirror the parameters below
	    // note: all values past the year are optional and will default to the lowest possible value.
	    // [year, month, day , hour, minute, second, millisecond]
	    function configFromArray(config) {
	        var i,
	            date,
	            input = [],
	            currentDate,
	            expectedWeekday,
	            yearToUse;
	
	        if (config._d) {
	            return;
	        }
	
	        currentDate = currentDateArray(config);
	
	        //compute day of the year from weeks and weekdays
	        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
	            dayOfYearFromWeekInfo(config);
	        }
	
	        //if the day of the year is set, figure out what it is
	        if (config._dayOfYear != null) {
	            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
	
	            if (
	                config._dayOfYear > daysInYear(yearToUse) ||
	                config._dayOfYear === 0
	            ) {
	                getParsingFlags(config)._overflowDayOfYear = true;
	            }
	
	            date = createUTCDate(yearToUse, 0, config._dayOfYear);
	            config._a[MONTH] = date.getUTCMonth();
	            config._a[DATE] = date.getUTCDate();
	        }
	
	        // Default to current date.
	        // * if no year, month, day of month are given, default to today
	        // * if day of month is given, default month and year
	        // * if month is given, default only year
	        // * if year is given, don't default anything
	        for (i = 0; i < 3 && config._a[i] == null; ++i) {
	            config._a[i] = input[i] = currentDate[i];
	        }
	
	        // Zero out whatever was not defaulted, including time
	        for (; i < 7; i++) {
	            config._a[i] = input[i] =
	                config._a[i] == null ? (i === 2 ? 1 : 0) : config._a[i];
	        }
	
	        // Check for 24:00:00.000
	        if (
	            config._a[HOUR] === 24 &&
	            config._a[MINUTE] === 0 &&
	            config._a[SECOND] === 0 &&
	            config._a[MILLISECOND] === 0
	        ) {
	            config._nextDay = true;
	            config._a[HOUR] = 0;
	        }
	
	        config._d = (config._useUTC ? createUTCDate : createDate).apply(
	            null,
	            input
	        );
	        expectedWeekday = config._useUTC
	            ? config._d.getUTCDay()
	            : config._d.getDay();
	
	        // Apply timezone offset from input. The actual utcOffset can be changed
	        // with parseZone.
	        if (config._tzm != null) {
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	        }
	
	        if (config._nextDay) {
	            config._a[HOUR] = 24;
	        }
	
	        // check for mismatching day of week
	        if (
	            config._w &&
	            typeof config._w.d !== 'undefined' &&
	            config._w.d !== expectedWeekday
	        ) {
	            getParsingFlags(config).weekdayMismatch = true;
	        }
	    }
	
	    function dayOfYearFromWeekInfo(config) {
	        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
	
	        w = config._w;
	        if (w.GG != null || w.W != null || w.E != null) {
	            dow = 1;
	            doy = 4;
	
	            // TODO: We need to take the current isoWeekYear, but that depends on
	            // how we interpret now (local, utc, fixed offset). So create
	            // a now version of current config (take local/utc/offset flags, and
	            // create now).
	            weekYear = defaults(
	                w.GG,
	                config._a[YEAR],
	                weekOfYear(createLocal(), 1, 4).year
	            );
	            week = defaults(w.W, 1);
	            weekday = defaults(w.E, 1);
	            if (weekday < 1 || weekday > 7) {
	                weekdayOverflow = true;
	            }
	        } else {
	            dow = config._locale._week.dow;
	            doy = config._locale._week.doy;
	
	            curWeek = weekOfYear(createLocal(), dow, doy);
	
	            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
	
	            // Default to current week.
	            week = defaults(w.w, curWeek.week);
	
	            if (w.d != null) {
	                // weekday -- low day numbers are considered next week
	                weekday = w.d;
	                if (weekday < 0 || weekday > 6) {
	                    weekdayOverflow = true;
	                }
	            } else if (w.e != null) {
	                // local weekday -- counting starts from beginning of week
	                weekday = w.e + dow;
	                if (w.e < 0 || w.e > 6) {
	                    weekdayOverflow = true;
	                }
	            } else {
	                // default to beginning of week
	                weekday = dow;
	            }
	        }
	        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
	            getParsingFlags(config)._overflowWeeks = true;
	        } else if (weekdayOverflow != null) {
	            getParsingFlags(config)._overflowWeekday = true;
	        } else {
	            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
	            config._a[YEAR] = temp.year;
	            config._dayOfYear = temp.dayOfYear;
	        }
	    }
	
	    // constant that refers to the ISO standard
	    hooks.ISO_8601 = function () {};
	
	    // constant that refers to the RFC 2822 form
	    hooks.RFC_2822 = function () {};
	
	    // date from string and format string
	    function configFromStringAndFormat(config) {
	        // TODO: Move this to another part of the creation flow to prevent circular deps
	        if (config._f === hooks.ISO_8601) {
	            configFromISO(config);
	            return;
	        }
	        if (config._f === hooks.RFC_2822) {
	            configFromRFC2822(config);
	            return;
	        }
	        config._a = [];
	        getParsingFlags(config).empty = true;
	
	        // This array is used to make a Date, either with `new Date` or `Date.UTC`
	        var string = '' + config._i,
	            i,
	            parsedInput,
	            tokens,
	            token,
	            skipped,
	            stringLength = string.length,
	            totalParsedInputLength = 0,
	            era,
	            tokenLen;
	
	        tokens =
	            expandFormat(config._f, config._locale).match(formattingTokens) || [];
	        tokenLen = tokens.length;
	        for (i = 0; i < tokenLen; i++) {
	            token = tokens[i];
	            parsedInput = (string.match(getParseRegexForToken(token, config)) ||
	                [])[0];
	            if (parsedInput) {
	                skipped = string.substr(0, string.indexOf(parsedInput));
	                if (skipped.length > 0) {
	                    getParsingFlags(config).unusedInput.push(skipped);
	                }
	                string = string.slice(
	                    string.indexOf(parsedInput) + parsedInput.length
	                );
	                totalParsedInputLength += parsedInput.length;
	            }
	            // don't parse if it's not a known token
	            if (formatTokenFunctions[token]) {
	                if (parsedInput) {
	                    getParsingFlags(config).empty = false;
	                } else {
	                    getParsingFlags(config).unusedTokens.push(token);
	                }
	                addTimeToArrayFromToken(token, parsedInput, config);
	            } else if (config._strict && !parsedInput) {
	                getParsingFlags(config).unusedTokens.push(token);
	            }
	        }
	
	        // add remaining unparsed input length to the string
	        getParsingFlags(config).charsLeftOver =
	            stringLength - totalParsedInputLength;
	        if (string.length > 0) {
	            getParsingFlags(config).unusedInput.push(string);
	        }
	
	        // clear _12h flag if hour is <= 12
	        if (
	            config._a[HOUR] <= 12 &&
	            getParsingFlags(config).bigHour === true &&
	            config._a[HOUR] > 0
	        ) {
	            getParsingFlags(config).bigHour = undefined;
	        }
	
	        getParsingFlags(config).parsedDateParts = config._a.slice(0);
	        getParsingFlags(config).meridiem = config._meridiem;
	        // handle meridiem
	        config._a[HOUR] = meridiemFixWrap(
	            config._locale,
	            config._a[HOUR],
	            config._meridiem
	        );
	
	        // handle era
	        era = getParsingFlags(config).era;
	        if (era !== null) {
	            config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
	        }
	
	        configFromArray(config);
	        checkOverflow(config);
	    }
	
	    function meridiemFixWrap(locale, hour, meridiem) {
	        var isPm;
	
	        if (meridiem == null) {
	            // nothing to do
	            return hour;
	        }
	        if (locale.meridiemHour != null) {
	            return locale.meridiemHour(hour, meridiem);
	        } else if (locale.isPM != null) {
	            // Fallback
	            isPm = locale.isPM(meridiem);
	            if (isPm && hour < 12) {
	                hour += 12;
	            }
	            if (!isPm && hour === 12) {
	                hour = 0;
	            }
	            return hour;
	        } else {
	            // this is not supposed to happen
	            return hour;
	        }
	    }
	
	    // date from string and array of format strings
	    function configFromStringAndArray(config) {
	        var tempConfig,
	            bestMoment,
	            scoreToBeat,
	            i,
	            currentScore,
	            validFormatFound,
	            bestFormatIsValid = false,
	            configfLen = config._f.length;
	
	        if (configfLen === 0) {
	            getParsingFlags(config).invalidFormat = true;
	            config._d = new Date(NaN);
	            return;
	        }
	
	        for (i = 0; i < configfLen; i++) {
	            currentScore = 0;
	            validFormatFound = false;
	            tempConfig = copyConfig({}, config);
	            if (config._useUTC != null) {
	                tempConfig._useUTC = config._useUTC;
	            }
	            tempConfig._f = config._f[i];
	            configFromStringAndFormat(tempConfig);
	
	            if (isValid(tempConfig)) {
	                validFormatFound = true;
	            }
	
	            // if there is any input that was not parsed add a penalty for that format
	            currentScore += getParsingFlags(tempConfig).charsLeftOver;
	
	            //or tokens
	            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
	
	            getParsingFlags(tempConfig).score = currentScore;
	
	            if (!bestFormatIsValid) {
	                if (
	                    scoreToBeat == null ||
	                    currentScore < scoreToBeat ||
	                    validFormatFound
	                ) {
	                    scoreToBeat = currentScore;
	                    bestMoment = tempConfig;
	                    if (validFormatFound) {
	                        bestFormatIsValid = true;
	                    }
	                }
	            } else {
	                if (currentScore < scoreToBeat) {
	                    scoreToBeat = currentScore;
	                    bestMoment = tempConfig;
	                }
	            }
	        }
	
	        extend(config, bestMoment || tempConfig);
	    }
	
	    function configFromObject(config) {
	        if (config._d) {
	            return;
	        }
	
	        var i = normalizeObjectUnits(config._i),
	            dayOrDate = i.day === undefined ? i.date : i.day;
	        config._a = map(
	            [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
	            function (obj) {
	                return obj && parseInt(obj, 10);
	            }
	        );
	
	        configFromArray(config);
	    }
	
	    function createFromConfig(config) {
	        var res = new Moment(checkOverflow(prepareConfig(config)));
	        if (res._nextDay) {
	            // Adding is smart enough around DST
	            res.add(1, 'd');
	            res._nextDay = undefined;
	        }
	
	        return res;
	    }
	
	    function prepareConfig(config) {
	        var input = config._i,
	            format = config._f;
	
	        config._locale = config._locale || getLocale(config._l);
	
	        if (input === null || (format === undefined && input === '')) {
	            return createInvalid({ nullInput: true });
	        }
	
	        if (typeof input === 'string') {
	            config._i = input = config._locale.preparse(input);
	        }
	
	        if (isMoment(input)) {
	            return new Moment(checkOverflow(input));
	        } else if (isDate(input)) {
	            config._d = input;
	        } else if (isArray(format)) {
	            configFromStringAndArray(config);
	        } else if (format) {
	            configFromStringAndFormat(config);
	        } else {
	            configFromInput(config);
	        }
	
	        if (!isValid(config)) {
	            config._d = null;
	        }
	
	        return config;
	    }
	
	    function configFromInput(config) {
	        var input = config._i;
	        if (isUndefined(input)) {
	            config._d = new Date(hooks.now());
	        } else if (isDate(input)) {
	            config._d = new Date(input.valueOf());
	        } else if (typeof input === 'string') {
	            configFromString(config);
	        } else if (isArray(input)) {
	            config._a = map(input.slice(0), function (obj) {
	                return parseInt(obj, 10);
	            });
	            configFromArray(config);
	        } else if (isObject(input)) {
	            configFromObject(config);
	        } else if (isNumber(input)) {
	            // from milliseconds
	            config._d = new Date(input);
	        } else {
	            hooks.createFromInputFallback(config);
	        }
	    }
	
	    function createLocalOrUTC(input, format, locale, strict, isUTC) {
	        var c = {};
	
	        if (format === true || format === false) {
	            strict = format;
	            format = undefined;
	        }
	
	        if (locale === true || locale === false) {
	            strict = locale;
	            locale = undefined;
	        }
	
	        if (
	            (isObject(input) && isObjectEmpty(input)) ||
	            (isArray(input) && input.length === 0)
	        ) {
	            input = undefined;
	        }
	        // object construction must be done this way.
	        // https://github.com/moment/moment/issues/1423
	        c._isAMomentObject = true;
	        c._useUTC = c._isUTC = isUTC;
	        c._l = locale;
	        c._i = input;
	        c._f = format;
	        c._strict = strict;
	
	        return createFromConfig(c);
	    }
	
	    function createLocal(input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, false);
	    }
	
	    var prototypeMin = deprecate(
	            'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
	            function () {
	                var other = createLocal.apply(null, arguments);
	                if (this.isValid() && other.isValid()) {
	                    return other < this ? this : other;
	                } else {
	                    return createInvalid();
	                }
	            }
	        ),
	        prototypeMax = deprecate(
	            'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
	            function () {
	                var other = createLocal.apply(null, arguments);
	                if (this.isValid() && other.isValid()) {
	                    return other > this ? this : other;
	                } else {
	                    return createInvalid();
	                }
	            }
	        );
	
	    // Pick a moment m from moments so that m[fn](other) is true for all
	    // other. This relies on the function fn to be transitive.
	    //
	    // moments should either be an array of moment objects or an array, whose
	    // first element is an array of moment objects.
	    function pickBy(fn, moments) {
	        var res, i;
	        if (moments.length === 1 && isArray(moments[0])) {
	            moments = moments[0];
	        }
	        if (!moments.length) {
	            return createLocal();
	        }
	        res = moments[0];
	        for (i = 1; i < moments.length; ++i) {
	            if (!moments[i].isValid() || moments[i][fn](res)) {
	                res = moments[i];
	            }
	        }
	        return res;
	    }
	
	    // TODO: Use [].sort instead?
	    function min() {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isBefore', args);
	    }
	
	    function max() {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isAfter', args);
	    }
	
	    var now = function () {
	        return Date.now ? Date.now() : +new Date();
	    };
	
	    var ordering = [
	        'year',
	        'quarter',
	        'month',
	        'week',
	        'day',
	        'hour',
	        'minute',
	        'second',
	        'millisecond',
	    ];
	
	    function isDurationValid(m) {
	        var key,
	            unitHasDecimal = false,
	            i,
	            orderLen = ordering.length;
	        for (key in m) {
	            if (
	                hasOwnProp(m, key) &&
	                !(
	                    indexOf.call(ordering, key) !== -1 &&
	                    (m[key] == null || !isNaN(m[key]))
	                )
	            ) {
	                return false;
	            }
	        }
	
	        for (i = 0; i < orderLen; ++i) {
	            if (m[ordering[i]]) {
	                if (unitHasDecimal) {
	                    return false; // only allow non-integers for smallest unit
	                }
	                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
	                    unitHasDecimal = true;
	                }
	            }
	        }
	
	        return true;
	    }
	
	    function isValid$1() {
	        return this._isValid;
	    }
	
	    function createInvalid$1() {
	        return createDuration(NaN);
	    }
	
	    function Duration(duration) {
	        var normalizedInput = normalizeObjectUnits(duration),
	            years = normalizedInput.year || 0,
	            quarters = normalizedInput.quarter || 0,
	            months = normalizedInput.month || 0,
	            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
	            days = normalizedInput.day || 0,
	            hours = normalizedInput.hour || 0,
	            minutes = normalizedInput.minute || 0,
	            seconds = normalizedInput.second || 0,
	            milliseconds = normalizedInput.millisecond || 0;
	
	        this._isValid = isDurationValid(normalizedInput);
	
	        // representation for dateAddRemove
	        this._milliseconds =
	            +milliseconds +
	            seconds * 1e3 + // 1000
	            minutes * 6e4 + // 1000 * 60
	            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
	        // Because of dateAddRemove treats 24 hours as different from a
	        // day when working around DST, we need to store them separately
	        this._days = +days + weeks * 7;
	        // It is impossible to translate months into days without knowing
	        // which months you are are talking about, so we have to store
	        // it separately.
	        this._months = +months + quarters * 3 + years * 12;
	
	        this._data = {};
	
	        this._locale = getLocale();
	
	        this._bubble();
	    }
	
	    function isDuration(obj) {
	        return obj instanceof Duration;
	    }
	
	    function absRound(number) {
	        if (number < 0) {
	            return Math.round(-1 * number) * -1;
	        } else {
	            return Math.round(number);
	        }
	    }
	
	    // compare two arrays, return the number of differences
	    function compareArrays(array1, array2, dontConvert) {
	        var len = Math.min(array1.length, array2.length),
	            lengthDiff = Math.abs(array1.length - array2.length),
	            diffs = 0,
	            i;
	        for (i = 0; i < len; i++) {
	            if (
	                (dontConvert && array1[i] !== array2[i]) ||
	                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))
	            ) {
	                diffs++;
	            }
	        }
	        return diffs + lengthDiff;
	    }
	
	    // FORMATTING
	
	    function offset(token, separator) {
	        addFormatToken(token, 0, 0, function () {
	            var offset = this.utcOffset(),
	                sign = '+';
	            if (offset < 0) {
	                offset = -offset;
	                sign = '-';
	            }
	            return (
	                sign +
	                zeroFill(~~(offset / 60), 2) +
	                separator +
	                zeroFill(~~offset % 60, 2)
	            );
	        });
	    }
	
	    offset('Z', ':');
	    offset('ZZ', '');
	
	    // PARSING
	
	    addRegexToken('Z', matchShortOffset);
	    addRegexToken('ZZ', matchShortOffset);
	    addParseToken(['Z', 'ZZ'], function (input, array, config) {
	        config._useUTC = true;
	        config._tzm = offsetFromString(matchShortOffset, input);
	    });
	
	    // HELPERS
	
	    // timezone chunker
	    // '+10:00' > ['10',  '00']
	    // '-1530'  > ['-15', '30']
	    var chunkOffset = /([\+\-]|\d\d)/gi;
	
	    function offsetFromString(matcher, string) {
	        var matches = (string || '').match(matcher),
	            chunk,
	            parts,
	            minutes;
	
	        if (matches === null) {
	            return null;
	        }
	
	        chunk = matches[matches.length - 1] || [];
	        parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
	        minutes = +(parts[1] * 60) + toInt(parts[2]);
	
	        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
	    }
	
	    // Return a moment from input, that is local/utc/zone equivalent to model.
	    function cloneWithOffset(input, model) {
	        var res, diff;
	        if (model._isUTC) {
	            res = model.clone();
	            diff =
	                (isMoment(input) || isDate(input)
	                    ? input.valueOf()
	                    : createLocal(input).valueOf()) - res.valueOf();
	            // Use low-level api, because this fn is low-level api.
	            res._d.setTime(res._d.valueOf() + diff);
	            hooks.updateOffset(res, false);
	            return res;
	        } else {
	            return createLocal(input).local();
	        }
	    }
	
	    function getDateOffset(m) {
	        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
	        // https://github.com/moment/moment/pull/1871
	        return -Math.round(m._d.getTimezoneOffset());
	    }
	
	    // HOOKS
	
	    // This function will be called whenever a moment is mutated.
	    // It is intended to keep the offset in sync with the timezone.
	    hooks.updateOffset = function () {};
	
	    // MOMENTS
	
	    // keepLocalTime = true means only change the timezone, without
	    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
	    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
	    // +0200, so we adjust the time as needed, to be valid.
	    //
	    // Keeping the time actually adds/subtracts (one hour)
	    // from the actual represented time. That is why we call updateOffset
	    // a second time. In case it wants us to change the offset again
	    // _changeInProgress == true case, then we have to adjust, because
	    // there is no such time in the given timezone.
	    function getSetOffset(input, keepLocalTime, keepMinutes) {
	        var offset = this._offset || 0,
	            localAdjust;
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        if (input != null) {
	            if (typeof input === 'string') {
	                input = offsetFromString(matchShortOffset, input);
	                if (input === null) {
	                    return this;
	                }
	            } else if (Math.abs(input) < 16 && !keepMinutes) {
	                input = input * 60;
	            }
	            if (!this._isUTC && keepLocalTime) {
	                localAdjust = getDateOffset(this);
	            }
	            this._offset = input;
	            this._isUTC = true;
	            if (localAdjust != null) {
	                this.add(localAdjust, 'm');
	            }
	            if (offset !== input) {
	                if (!keepLocalTime || this._changeInProgress) {
	                    addSubtract(
	                        this,
	                        createDuration(input - offset, 'm'),
	                        1,
	                        false
	                    );
	                } else if (!this._changeInProgress) {
	                    this._changeInProgress = true;
	                    hooks.updateOffset(this, true);
	                    this._changeInProgress = null;
	                }
	            }
	            return this;
	        } else {
	            return this._isUTC ? offset : getDateOffset(this);
	        }
	    }
	
	    function getSetZone(input, keepLocalTime) {
	        if (input != null) {
	            if (typeof input !== 'string') {
	                input = -input;
	            }
	
	            this.utcOffset(input, keepLocalTime);
	
	            return this;
	        } else {
	            return -this.utcOffset();
	        }
	    }
	
	    function setOffsetToUTC(keepLocalTime) {
	        return this.utcOffset(0, keepLocalTime);
	    }
	
	    function setOffsetToLocal(keepLocalTime) {
	        if (this._isUTC) {
	            this.utcOffset(0, keepLocalTime);
	            this._isUTC = false;
	
	            if (keepLocalTime) {
	                this.subtract(getDateOffset(this), 'm');
	            }
	        }
	        return this;
	    }
	
	    function setOffsetToParsedOffset() {
	        if (this._tzm != null) {
	            this.utcOffset(this._tzm, false, true);
	        } else if (typeof this._i === 'string') {
	            var tZone = offsetFromString(matchOffset, this._i);
	            if (tZone != null) {
	                this.utcOffset(tZone);
	            } else {
	                this.utcOffset(0, true);
	            }
	        }
	        return this;
	    }
	
	    function hasAlignedHourOffset(input) {
	        if (!this.isValid()) {
	            return false;
	        }
	        input = input ? createLocal(input).utcOffset() : 0;
	
	        return (this.utcOffset() - input) % 60 === 0;
	    }
	
	    function isDaylightSavingTime() {
	        return (
	            this.utcOffset() > this.clone().month(0).utcOffset() ||
	            this.utcOffset() > this.clone().month(5).utcOffset()
	        );
	    }
	
	    function isDaylightSavingTimeShifted() {
	        if (!isUndefined(this._isDSTShifted)) {
	            return this._isDSTShifted;
	        }
	
	        var c = {},
	            other;
	
	        copyConfig(c, this);
	        c = prepareConfig(c);
	
	        if (c._a) {
	            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
	            this._isDSTShifted =
	                this.isValid() && compareArrays(c._a, other.toArray()) > 0;
	        } else {
	            this._isDSTShifted = false;
	        }
	
	        return this._isDSTShifted;
	    }
	
	    function isLocal() {
	        return this.isValid() ? !this._isUTC : false;
	    }
	
	    function isUtcOffset() {
	        return this.isValid() ? this._isUTC : false;
	    }
	
	    function isUtc() {
	        return this.isValid() ? this._isUTC && this._offset === 0 : false;
	    }
	
	    // ASP.NET json date format regex
	    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
	        // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
	        // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
	        // and further modified to allow for strings containing both week and day
	        isoRegex =
	            /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
	
	    function createDuration(input, key) {
	        var duration = input,
	            // matching against regexp is expensive, do it on demand
	            match = null,
	            sign,
	            ret,
	            diffRes;
	
	        if (isDuration(input)) {
	            duration = {
	                ms: input._milliseconds,
	                d: input._days,
	                M: input._months,
	            };
	        } else if (isNumber(input) || !isNaN(+input)) {
	            duration = {};
	            if (key) {
	                duration[key] = +input;
	            } else {
	                duration.milliseconds = +input;
	            }
	        } else if ((match = aspNetRegex.exec(input))) {
	            sign = match[1] === '-' ? -1 : 1;
	            duration = {
	                y: 0,
	                d: toInt(match[DATE]) * sign,
	                h: toInt(match[HOUR]) * sign,
	                m: toInt(match[MINUTE]) * sign,
	                s: toInt(match[SECOND]) * sign,
	                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign, // the millisecond decimal point is included in the match
	            };
	        } else if ((match = isoRegex.exec(input))) {
	            sign = match[1] === '-' ? -1 : 1;
	            duration = {
	                y: parseIso(match[2], sign),
	                M: parseIso(match[3], sign),
	                w: parseIso(match[4], sign),
	                d: parseIso(match[5], sign),
	                h: parseIso(match[6], sign),
	                m: parseIso(match[7], sign),
	                s: parseIso(match[8], sign),
	            };
	        } else if (duration == null) {
	            // checks for null or undefined
	            duration = {};
	        } else if (
	            typeof duration === 'object' &&
	            ('from' in duration || 'to' in duration)
	        ) {
	            diffRes = momentsDifference(
	                createLocal(duration.from),
	                createLocal(duration.to)
	            );
	
	            duration = {};
	            duration.ms = diffRes.milliseconds;
	            duration.M = diffRes.months;
	        }
	
	        ret = new Duration(duration);
	
	        if (isDuration(input) && hasOwnProp(input, '_locale')) {
	            ret._locale = input._locale;
	        }
	
	        if (isDuration(input) && hasOwnProp(input, '_isValid')) {
	            ret._isValid = input._isValid;
	        }
	
	        return ret;
	    }
	
	    createDuration.fn = Duration.prototype;
	    createDuration.invalid = createInvalid$1;
	
	    function parseIso(inp, sign) {
	        // We'd normally use ~~inp for this, but unfortunately it also
	        // converts floats to ints.
	        // inp may be undefined, so careful calling replace on it.
	        var res = inp && parseFloat(inp.replace(',', '.'));
	        // apply sign while we're at it
	        return (isNaN(res) ? 0 : res) * sign;
	    }
	
	    function positiveMomentsDifference(base, other) {
	        var res = {};
	
	        res.months =
	            other.month() - base.month() + (other.year() - base.year()) * 12;
	        if (base.clone().add(res.months, 'M').isAfter(other)) {
	            --res.months;
	        }
	
	        res.milliseconds = +other - +base.clone().add(res.months, 'M');
	
	        return res;
	    }
	
	    function momentsDifference(base, other) {
	        var res;
	        if (!(base.isValid() && other.isValid())) {
	            return { milliseconds: 0, months: 0 };
	        }
	
	        other = cloneWithOffset(other, base);
	        if (base.isBefore(other)) {
	            res = positiveMomentsDifference(base, other);
	        } else {
	            res = positiveMomentsDifference(other, base);
	            res.milliseconds = -res.milliseconds;
	            res.months = -res.months;
	        }
	
	        return res;
	    }
	
	    // TODO: remove 'name' arg after deprecation is removed
	    function createAdder(direction, name) {
	        return function (val, period) {
	            var dur, tmp;
	            //invert the arguments, but complain about it
	            if (period !== null && !isNaN(+period)) {
	                deprecateSimple(
	                    name,
	                    'moment().' +
	                        name +
	                        '(period, number) is deprecated. Please use moment().' +
	                        name +
	                        '(number, period). ' +
	                        'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.'
	                );
	                tmp = val;
	                val = period;
	                period = tmp;
	            }
	
	            dur = createDuration(val, period);
	            addSubtract(this, dur, direction);
	            return this;
	        };
	    }
	
	    function addSubtract(mom, duration, isAdding, updateOffset) {
	        var milliseconds = duration._milliseconds,
	            days = absRound(duration._days),
	            months = absRound(duration._months);
	
	        if (!mom.isValid()) {
	            // No op
	            return;
	        }
	
	        updateOffset = updateOffset == null ? true : updateOffset;
	
	        if (months) {
	            setMonth(mom, get(mom, 'Month') + months * isAdding);
	        }
	        if (days) {
	            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
	        }
	        if (milliseconds) {
	            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
	        }
	        if (updateOffset) {
	            hooks.updateOffset(mom, days || months);
	        }
	    }
	
	    var add = createAdder(1, 'add'),
	        subtract = createAdder(-1, 'subtract');
	
	    function isString(input) {
	        return typeof input === 'string' || input instanceof String;
	    }
	
	    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
	    function isMomentInput(input) {
	        return (
	            isMoment(input) ||
	            isDate(input) ||
	            isString(input) ||
	            isNumber(input) ||
	            isNumberOrStringArray(input) ||
	            isMomentInputObject(input) ||
	            input === null ||
	            input === undefined
	        );
	    }
	
	    function isMomentInputObject(input) {
	        var objectTest = isObject(input) && !isObjectEmpty(input),
	            propertyTest = false,
	            properties = [
	                'years',
	                'year',
	                'y',
	                'months',
	                'month',
	                'M',
	                'days',
	                'day',
	                'd',
	                'dates',
	                'date',
	                'D',
	                'hours',
	                'hour',
	                'h',
	                'minutes',
	                'minute',
	                'm',
	                'seconds',
	                'second',
	                's',
	                'milliseconds',
	                'millisecond',
	                'ms',
	            ],
	            i,
	            property,
	            propertyLen = properties.length;
	
	        for (i = 0; i < propertyLen; i += 1) {
	            property = properties[i];
	            propertyTest = propertyTest || hasOwnProp(input, property);
	        }
	
	        return objectTest && propertyTest;
	    }
	
	    function isNumberOrStringArray(input) {
	        var arrayTest = isArray(input),
	            dataTypeTest = false;
	        if (arrayTest) {
	            dataTypeTest =
	                input.filter(function (item) {
	                    return !isNumber(item) && isString(input);
	                }).length === 0;
	        }
	        return arrayTest && dataTypeTest;
	    }
	
	    function isCalendarSpec(input) {
	        var objectTest = isObject(input) && !isObjectEmpty(input),
	            propertyTest = false,
	            properties = [
	                'sameDay',
	                'nextDay',
	                'lastDay',
	                'nextWeek',
	                'lastWeek',
	                'sameElse',
	            ],
	            i,
	            property;
	
	        for (i = 0; i < properties.length; i += 1) {
	            property = properties[i];
	            propertyTest = propertyTest || hasOwnProp(input, property);
	        }
	
	        return objectTest && propertyTest;
	    }
	
	    function getCalendarFormat(myMoment, now) {
	        var diff = myMoment.diff(now, 'days', true);
	        return diff < -6
	            ? 'sameElse'
	            : diff < -1
	              ? 'lastWeek'
	              : diff < 0
	                ? 'lastDay'
	                : diff < 1
	                  ? 'sameDay'
	                  : diff < 2
	                    ? 'nextDay'
	                    : diff < 7
	                      ? 'nextWeek'
	                      : 'sameElse';
	    }
	
	    function calendar$1(time, formats) {
	        // Support for single parameter, formats only overload to the calendar function
	        if (arguments.length === 1) {
	            if (!arguments[0]) {
	                time = undefined;
	                formats = undefined;
	            } else if (isMomentInput(arguments[0])) {
	                time = arguments[0];
	                formats = undefined;
	            } else if (isCalendarSpec(arguments[0])) {
	                formats = arguments[0];
	                time = undefined;
	            }
	        }
	        // We want to compare the start of today, vs this.
	        // Getting start-of-today depends on whether we're local/utc/offset or not.
	        var now = time || createLocal(),
	            sod = cloneWithOffset(now, this).startOf('day'),
	            format = hooks.calendarFormat(this, sod) || 'sameElse',
	            output =
	                formats &&
	                (isFunction(formats[format])
	                    ? formats[format].call(this, now)
	                    : formats[format]);
	
	        return this.format(
	            output || this.localeData().calendar(format, this, createLocal(now))
	        );
	    }
	
	    function clone() {
	        return new Moment(this);
	    }
	
	    function isAfter(input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() > localInput.valueOf();
	        } else {
	            return localInput.valueOf() < this.clone().startOf(units).valueOf();
	        }
	    }
	
	    function isBefore(input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() < localInput.valueOf();
	        } else {
	            return this.clone().endOf(units).valueOf() < localInput.valueOf();
	        }
	    }
	
	    function isBetween(from, to, units, inclusivity) {
	        var localFrom = isMoment(from) ? from : createLocal(from),
	            localTo = isMoment(to) ? to : createLocal(to);
	        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
	            return false;
	        }
	        inclusivity = inclusivity || '()';
	        return (
	            (inclusivity[0] === '('
	                ? this.isAfter(localFrom, units)
	                : !this.isBefore(localFrom, units)) &&
	            (inclusivity[1] === ')'
	                ? this.isBefore(localTo, units)
	                : !this.isAfter(localTo, units))
	        );
	    }
	
	    function isSame(input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input),
	            inputMs;
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() === localInput.valueOf();
	        } else {
	            inputMs = localInput.valueOf();
	            return (
	                this.clone().startOf(units).valueOf() <= inputMs &&
	                inputMs <= this.clone().endOf(units).valueOf()
	            );
	        }
	    }
	
	    function isSameOrAfter(input, units) {
	        return this.isSame(input, units) || this.isAfter(input, units);
	    }
	
	    function isSameOrBefore(input, units) {
	        return this.isSame(input, units) || this.isBefore(input, units);
	    }
	
	    function diff(input, units, asFloat) {
	        var that, zoneDelta, output;
	
	        if (!this.isValid()) {
	            return NaN;
	        }
	
	        that = cloneWithOffset(input, this);
	
	        if (!that.isValid()) {
	            return NaN;
	        }
	
	        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
	
	        units = normalizeUnits(units);
	
	        switch (units) {
	            case 'year':
	                output = monthDiff(this, that) / 12;
	                break;
	            case 'month':
	                output = monthDiff(this, that);
	                break;
	            case 'quarter':
	                output = monthDiff(this, that) / 3;
	                break;
	            case 'second':
	                output = (this - that) / 1e3;
	                break; // 1000
	            case 'minute':
	                output = (this - that) / 6e4;
	                break; // 1000 * 60
	            case 'hour':
	                output = (this - that) / 36e5;
	                break; // 1000 * 60 * 60
	            case 'day':
	                output = (this - that - zoneDelta) / 864e5;
	                break; // 1000 * 60 * 60 * 24, negate dst
	            case 'week':
	                output = (this - that - zoneDelta) / 6048e5;
	                break; // 1000 * 60 * 60 * 24 * 7, negate dst
	            default:
	                output = this - that;
	        }
	
	        return asFloat ? output : absFloor(output);
	    }
	
	    function monthDiff(a, b) {
	        if (a.date() < b.date()) {
	            // end-of-month calculations work correct when the start month has more
	            // days than the end month.
	            return -monthDiff(b, a);
	        }
	        // difference in months
	        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
	            // b is in (anchor - 1 month, anchor + 1 month)
	            anchor = a.clone().add(wholeMonthDiff, 'months'),
	            anchor2,
	            adjust;
	
	        if (b - anchor < 0) {
	            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor - anchor2);
	        } else {
	            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor2 - anchor);
	        }
	
	        //check for negative zero, return zero if negative zero
	        return -(wholeMonthDiff + adjust) || 0;
	    }
	
	    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
	    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
	
	    function toString() {
	        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
	    }
	
	    function toISOString(keepOffset) {
	        if (!this.isValid()) {
	            return null;
	        }
	        var utc = keepOffset !== true,
	            m = utc ? this.clone().utc() : this;
	        if (m.year() < 0 || m.year() > 9999) {
	            return formatMoment(
	                m,
	                utc
	                    ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
	                    : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ'
	            );
	        }
	        if (isFunction(Date.prototype.toISOString)) {
	            // native implementation is ~50x faster, use it when we can
	            if (utc) {
	                return this.toDate().toISOString();
	            } else {
	                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000)
	                    .toISOString()
	                    .replace('Z', formatMoment(m, 'Z'));
	            }
	        }
	        return formatMoment(
	            m,
	            utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ'
	        );
	    }
	
	    /**
	     * Return a human readable representation of a moment that can
	     * also be evaluated to get a new moment which is the same
	     *
	     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
	     */
	    function inspect() {
	        if (!this.isValid()) {
	            return 'moment.invalid(/* ' + this._i + ' */)';
	        }
	        var func = 'moment',
	            zone = '',
	            prefix,
	            year,
	            datetime,
	            suffix;
	        if (!this.isLocal()) {
	            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
	            zone = 'Z';
	        }
	        prefix = '[' + func + '("]';
	        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
	        datetime = '-MM-DD[T]HH:mm:ss.SSS';
	        suffix = zone + '[")]';
	
	        return this.format(prefix + year + datetime + suffix);
	    }
	
	    function format(inputString) {
	        if (!inputString) {
	            inputString = this.isUtc()
	                ? hooks.defaultFormatUtc
	                : hooks.defaultFormat;
	        }
	        var output = formatMoment(this, inputString);
	        return this.localeData().postformat(output);
	    }
	
	    function from(time, withoutSuffix) {
	        if (
	            this.isValid() &&
	            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
	        ) {
	            return createDuration({ to: this, from: time })
	                .locale(this.locale())
	                .humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function fromNow(withoutSuffix) {
	        return this.from(createLocal(), withoutSuffix);
	    }
	
	    function to(time, withoutSuffix) {
	        if (
	            this.isValid() &&
	            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
	        ) {
	            return createDuration({ from: this, to: time })
	                .locale(this.locale())
	                .humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function toNow(withoutSuffix) {
	        return this.to(createLocal(), withoutSuffix);
	    }
	
	    // If passed a locale key, it will set the locale for this
	    // instance.  Otherwise, it will return the locale configuration
	    // variables for this instance.
	    function locale(key) {
	        var newLocaleData;
	
	        if (key === undefined) {
	            return this._locale._abbr;
	        } else {
	            newLocaleData = getLocale(key);
	            if (newLocaleData != null) {
	                this._locale = newLocaleData;
	            }
	            return this;
	        }
	    }
	
	    var lang = deprecate(
	        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
	        function (key) {
	            if (key === undefined) {
	                return this.localeData();
	            } else {
	                return this.locale(key);
	            }
	        }
	    );
	
	    function localeData() {
	        return this._locale;
	    }
	
	    var MS_PER_SECOND = 1000,
	        MS_PER_MINUTE = 60 * MS_PER_SECOND,
	        MS_PER_HOUR = 60 * MS_PER_MINUTE,
	        MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;
	
	    // actual modulo - handles negative numbers (for dates before 1970):
	    function mod$1(dividend, divisor) {
	        return ((dividend % divisor) + divisor) % divisor;
	    }
	
	    function localStartOfDate(y, m, d) {
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
	        } else {
	            return new Date(y, m, d).valueOf();
	        }
	    }
	
	    function utcStartOfDate(y, m, d) {
	        // Date.UTC remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
	        } else {
	            return Date.UTC(y, m, d);
	        }
	    }
	
	    function startOf(units) {
	        var time, startOfDate;
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond' || !this.isValid()) {
	            return this;
	        }
	
	        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
	
	        switch (units) {
	            case 'year':
	                time = startOfDate(this.year(), 0, 1);
	                break;
	            case 'quarter':
	                time = startOfDate(
	                    this.year(),
	                    this.month() - (this.month() % 3),
	                    1
	                );
	                break;
	            case 'month':
	                time = startOfDate(this.year(), this.month(), 1);
	                break;
	            case 'week':
	                time = startOfDate(
	                    this.year(),
	                    this.month(),
	                    this.date() - this.weekday()
	                );
	                break;
	            case 'isoWeek':
	                time = startOfDate(
	                    this.year(),
	                    this.month(),
	                    this.date() - (this.isoWeekday() - 1)
	                );
	                break;
	            case 'day':
	            case 'date':
	                time = startOfDate(this.year(), this.month(), this.date());
	                break;
	            case 'hour':
	                time = this._d.valueOf();
	                time -= mod$1(
	                    time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
	                    MS_PER_HOUR
	                );
	                break;
	            case 'minute':
	                time = this._d.valueOf();
	                time -= mod$1(time, MS_PER_MINUTE);
	                break;
	            case 'second':
	                time = this._d.valueOf();
	                time -= mod$1(time, MS_PER_SECOND);
	                break;
	        }
	
	        this._d.setTime(time);
	        hooks.updateOffset(this, true);
	        return this;
	    }
	
	    function endOf(units) {
	        var time, startOfDate;
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond' || !this.isValid()) {
	            return this;
	        }
	
	        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
	
	        switch (units) {
	            case 'year':
	                time = startOfDate(this.year() + 1, 0, 1) - 1;
	                break;
	            case 'quarter':
	                time =
	                    startOfDate(
	                        this.year(),
	                        this.month() - (this.month() % 3) + 3,
	                        1
	                    ) - 1;
	                break;
	            case 'month':
	                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
	                break;
	            case 'week':
	                time =
	                    startOfDate(
	                        this.year(),
	                        this.month(),
	                        this.date() - this.weekday() + 7
	                    ) - 1;
	                break;
	            case 'isoWeek':
	                time =
	                    startOfDate(
	                        this.year(),
	                        this.month(),
	                        this.date() - (this.isoWeekday() - 1) + 7
	                    ) - 1;
	                break;
	            case 'day':
	            case 'date':
	                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
	                break;
	            case 'hour':
	                time = this._d.valueOf();
	                time +=
	                    MS_PER_HOUR -
	                    mod$1(
	                        time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
	                        MS_PER_HOUR
	                    ) -
	                    1;
	                break;
	            case 'minute':
	                time = this._d.valueOf();
	                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
	                break;
	            case 'second':
	                time = this._d.valueOf();
	                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
	                break;
	        }
	
	        this._d.setTime(time);
	        hooks.updateOffset(this, true);
	        return this;
	    }
	
	    function valueOf() {
	        return this._d.valueOf() - (this._offset || 0) * 60000;
	    }
	
	    function unix() {
	        return Math.floor(this.valueOf() / 1000);
	    }
	
	    function toDate() {
	        return new Date(this.valueOf());
	    }
	
	    function toArray() {
	        var m = this;
	        return [
	            m.year(),
	            m.month(),
	            m.date(),
	            m.hour(),
	            m.minute(),
	            m.second(),
	            m.millisecond(),
	        ];
	    }
	
	    function toObject() {
	        var m = this;
	        return {
	            years: m.year(),
	            months: m.month(),
	            date: m.date(),
	            hours: m.hours(),
	            minutes: m.minutes(),
	            seconds: m.seconds(),
	            milliseconds: m.milliseconds(),
	        };
	    }
	
	    function toJSON() {
	        // new Date(NaN).toJSON() === null
	        return this.isValid() ? this.toISOString() : null;
	    }
	
	    function isValid$2() {
	        return isValid(this);
	    }
	
	    function parsingFlags() {
	        return extend({}, getParsingFlags(this));
	    }
	
	    function invalidAt() {
	        return getParsingFlags(this).overflow;
	    }
	
	    function creationData() {
	        return {
	            input: this._i,
	            format: this._f,
	            locale: this._locale,
	            isUTC: this._isUTC,
	            strict: this._strict,
	        };
	    }
	
	    addFormatToken('N', 0, 0, 'eraAbbr');
	    addFormatToken('NN', 0, 0, 'eraAbbr');
	    addFormatToken('NNN', 0, 0, 'eraAbbr');
	    addFormatToken('NNNN', 0, 0, 'eraName');
	    addFormatToken('NNNNN', 0, 0, 'eraNarrow');
	
	    addFormatToken('y', ['y', 1], 'yo', 'eraYear');
	    addFormatToken('y', ['yy', 2], 0, 'eraYear');
	    addFormatToken('y', ['yyy', 3], 0, 'eraYear');
	    addFormatToken('y', ['yyyy', 4], 0, 'eraYear');
	
	    addRegexToken('N', matchEraAbbr);
	    addRegexToken('NN', matchEraAbbr);
	    addRegexToken('NNN', matchEraAbbr);
	    addRegexToken('NNNN', matchEraName);
	    addRegexToken('NNNNN', matchEraNarrow);
	
	    addParseToken(
	        ['N', 'NN', 'NNN', 'NNNN', 'NNNNN'],
	        function (input, array, config, token) {
	            var era = config._locale.erasParse(input, token, config._strict);
	            if (era) {
	                getParsingFlags(config).era = era;
	            } else {
	                getParsingFlags(config).invalidEra = input;
	            }
	        }
	    );
	
	    addRegexToken('y', matchUnsigned);
	    addRegexToken('yy', matchUnsigned);
	    addRegexToken('yyy', matchUnsigned);
	    addRegexToken('yyyy', matchUnsigned);
	    addRegexToken('yo', matchEraYearOrdinal);
	
	    addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
	    addParseToken(['yo'], function (input, array, config, token) {
	        var match;
	        if (config._locale._eraYearOrdinalRegex) {
	            match = input.match(config._locale._eraYearOrdinalRegex);
	        }
	
	        if (config._locale.eraYearOrdinalParse) {
	            array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
	        } else {
	            array[YEAR] = parseInt(input, 10);
	        }
	    });
	
	    function localeEras(m, format) {
	        var i,
	            l,
	            date,
	            eras = this._eras || getLocale('en')._eras;
	        for (i = 0, l = eras.length; i < l; ++i) {
	            switch (typeof eras[i].since) {
	                case 'string':
	                    // truncate time
	                    date = hooks(eras[i].since).startOf('day');
	                    eras[i].since = date.valueOf();
	                    break;
	            }
	
	            switch (typeof eras[i].until) {
	                case 'undefined':
	                    eras[i].until = +Infinity;
	                    break;
	                case 'string':
	                    // truncate time
	                    date = hooks(eras[i].until).startOf('day').valueOf();
	                    eras[i].until = date.valueOf();
	                    break;
	            }
	        }
	        return eras;
	    }
	
	    function localeErasParse(eraName, format, strict) {
	        var i,
	            l,
	            eras = this.eras(),
	            name,
	            abbr,
	            narrow;
	        eraName = eraName.toUpperCase();
	
	        for (i = 0, l = eras.length; i < l; ++i) {
	            name = eras[i].name.toUpperCase();
	            abbr = eras[i].abbr.toUpperCase();
	            narrow = eras[i].narrow.toUpperCase();
	
	            if (strict) {
	                switch (format) {
	                    case 'N':
	                    case 'NN':
	                    case 'NNN':
	                        if (abbr === eraName) {
	                            return eras[i];
	                        }
	                        break;
	
	                    case 'NNNN':
	                        if (name === eraName) {
	                            return eras[i];
	                        }
	                        break;
	
	                    case 'NNNNN':
	                        if (narrow === eraName) {
	                            return eras[i];
	                        }
	                        break;
	                }
	            } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
	                return eras[i];
	            }
	        }
	    }
	
	    function localeErasConvertYear(era, year) {
	        var dir = era.since <= era.until ? +1 : -1;
	        if (year === undefined) {
	            return hooks(era.since).year();
	        } else {
	            return hooks(era.since).year() + (year - era.offset) * dir;
	        }
	    }
	
	    function getEraName() {
	        var i,
	            l,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (eras[i].since <= val && val <= eras[i].until) {
	                return eras[i].name;
	            }
	            if (eras[i].until <= val && val <= eras[i].since) {
	                return eras[i].name;
	            }
	        }
	
	        return '';
	    }
	
	    function getEraNarrow() {
	        var i,
	            l,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (eras[i].since <= val && val <= eras[i].until) {
	                return eras[i].narrow;
	            }
	            if (eras[i].until <= val && val <= eras[i].since) {
	                return eras[i].narrow;
	            }
	        }
	
	        return '';
	    }
	
	    function getEraAbbr() {
	        var i,
	            l,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (eras[i].since <= val && val <= eras[i].until) {
	                return eras[i].abbr;
	            }
	            if (eras[i].until <= val && val <= eras[i].since) {
	                return eras[i].abbr;
	            }
	        }
	
	        return '';
	    }
	
	    function getEraYear() {
	        var i,
	            l,
	            dir,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            dir = eras[i].since <= eras[i].until ? +1 : -1;
	
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (
	                (eras[i].since <= val && val <= eras[i].until) ||
	                (eras[i].until <= val && val <= eras[i].since)
	            ) {
	                return (
	                    (this.year() - hooks(eras[i].since).year()) * dir +
	                    eras[i].offset
	                );
	            }
	        }
	
	        return this.year();
	    }
	
	    function erasNameRegex(isStrict) {
	        if (!hasOwnProp(this, '_erasNameRegex')) {
	            computeErasParse.call(this);
	        }
	        return isStrict ? this._erasNameRegex : this._erasRegex;
	    }
	
	    function erasAbbrRegex(isStrict) {
	        if (!hasOwnProp(this, '_erasAbbrRegex')) {
	            computeErasParse.call(this);
	        }
	        return isStrict ? this._erasAbbrRegex : this._erasRegex;
	    }
	
	    function erasNarrowRegex(isStrict) {
	        if (!hasOwnProp(this, '_erasNarrowRegex')) {
	            computeErasParse.call(this);
	        }
	        return isStrict ? this._erasNarrowRegex : this._erasRegex;
	    }
	
	    function matchEraAbbr(isStrict, locale) {
	        return locale.erasAbbrRegex(isStrict);
	    }
	
	    function matchEraName(isStrict, locale) {
	        return locale.erasNameRegex(isStrict);
	    }
	
	    function matchEraNarrow(isStrict, locale) {
	        return locale.erasNarrowRegex(isStrict);
	    }
	
	    function matchEraYearOrdinal(isStrict, locale) {
	        return locale._eraYearOrdinalRegex || matchUnsigned;
	    }
	
	    function computeErasParse() {
	        var abbrPieces = [],
	            namePieces = [],
	            narrowPieces = [],
	            mixedPieces = [],
	            i,
	            l,
	            erasName,
	            erasAbbr,
	            erasNarrow,
	            eras = this.eras();
	
	        for (i = 0, l = eras.length; i < l; ++i) {
	            erasName = regexEscape(eras[i].name);
	            erasAbbr = regexEscape(eras[i].abbr);
	            erasNarrow = regexEscape(eras[i].narrow);
	
	            namePieces.push(erasName);
	            abbrPieces.push(erasAbbr);
	            narrowPieces.push(erasNarrow);
	            mixedPieces.push(erasName);
	            mixedPieces.push(erasAbbr);
	            mixedPieces.push(erasNarrow);
	        }
	
	        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
	        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
	        this._erasNarrowRegex = new RegExp(
	            '^(' + narrowPieces.join('|') + ')',
	            'i'
	        );
	    }
	
	    // FORMATTING
	
	    addFormatToken(0, ['gg', 2], 0, function () {
	        return this.weekYear() % 100;
	    });
	
	    addFormatToken(0, ['GG', 2], 0, function () {
	        return this.isoWeekYear() % 100;
	    });
	
	    function addWeekYearFormatToken(token, getter) {
	        addFormatToken(0, [token, token.length], 0, getter);
	    }
	
	    addWeekYearFormatToken('gggg', 'weekYear');
	    addWeekYearFormatToken('ggggg', 'weekYear');
	    addWeekYearFormatToken('GGGG', 'isoWeekYear');
	    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
	
	    // ALIASES
	
	    // PARSING
	
	    addRegexToken('G', matchSigned);
	    addRegexToken('g', matchSigned);
	    addRegexToken('GG', match1to2, match2);
	    addRegexToken('gg', match1to2, match2);
	    addRegexToken('GGGG', match1to4, match4);
	    addRegexToken('gggg', match1to4, match4);
	    addRegexToken('GGGGG', match1to6, match6);
	    addRegexToken('ggggg', match1to6, match6);
	
	    addWeekParseToken(
	        ['gggg', 'ggggg', 'GGGG', 'GGGGG'],
	        function (input, week, config, token) {
	            week[token.substr(0, 2)] = toInt(input);
	        }
	    );
	
	    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
	        week[token] = hooks.parseTwoDigitYear(input);
	    });
	
	    // MOMENTS
	
	    function getSetWeekYear(input) {
	        return getSetWeekYearHelper.call(
	            this,
	            input,
	            this.week(),
	            this.weekday() + this.localeData()._week.dow,
	            this.localeData()._week.dow,
	            this.localeData()._week.doy
	        );
	    }
	
	    function getSetISOWeekYear(input) {
	        return getSetWeekYearHelper.call(
	            this,
	            input,
	            this.isoWeek(),
	            this.isoWeekday(),
	            1,
	            4
	        );
	    }
	
	    function getISOWeeksInYear() {
	        return weeksInYear(this.year(), 1, 4);
	    }
	
	    function getISOWeeksInISOWeekYear() {
	        return weeksInYear(this.isoWeekYear(), 1, 4);
	    }
	
	    function getWeeksInYear() {
	        var weekInfo = this.localeData()._week;
	        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
	    }
	
	    function getWeeksInWeekYear() {
	        var weekInfo = this.localeData()._week;
	        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
	    }
	
	    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
	        var weeksTarget;
	        if (input == null) {
	            return weekOfYear(this, dow, doy).year;
	        } else {
	            weeksTarget = weeksInYear(input, dow, doy);
	            if (week > weeksTarget) {
	                week = weeksTarget;
	            }
	            return setWeekAll.call(this, input, week, weekday, dow, doy);
	        }
	    }
	
	    function setWeekAll(weekYear, week, weekday, dow, doy) {
	        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
	            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
	
	        this.year(date.getUTCFullYear());
	        this.month(date.getUTCMonth());
	        this.date(date.getUTCDate());
	        return this;
	    }
	
	    // FORMATTING
	
	    addFormatToken('Q', 0, 'Qo', 'quarter');
	
	    // PARSING
	
	    addRegexToken('Q', match1);
	    addParseToken('Q', function (input, array) {
	        array[MONTH] = (toInt(input) - 1) * 3;
	    });
	
	    // MOMENTS
	
	    function getSetQuarter(input) {
	        return input == null
	            ? Math.ceil((this.month() + 1) / 3)
	            : this.month((input - 1) * 3 + (this.month() % 3));
	    }
	
	    // FORMATTING
	
	    addFormatToken('D', ['DD', 2], 'Do', 'date');
	
	    // PARSING
	
	    addRegexToken('D', match1to2, match1to2NoLeadingZero);
	    addRegexToken('DD', match1to2, match2);
	    addRegexToken('Do', function (isStrict, locale) {
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        return isStrict
	            ? locale._dayOfMonthOrdinalParse || locale._ordinalParse
	            : locale._dayOfMonthOrdinalParseLenient;
	    });
	
	    addParseToken(['D', 'DD'], DATE);
	    addParseToken('Do', function (input, array) {
	        array[DATE] = toInt(input.match(match1to2)[0]);
	    });
	
	    // MOMENTS
	
	    var getSetDayOfMonth = makeGetSet('Date', true);
	
	    // FORMATTING
	
	    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');
	
	    // PARSING
	
	    addRegexToken('DDD', match1to3);
	    addRegexToken('DDDD', match3);
	    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
	        config._dayOfYear = toInt(input);
	    });
	
	    // HELPERS
	
	    // MOMENTS
	
	    function getSetDayOfYear(input) {
	        var dayOfYear =
	            Math.round(
	                (this.clone().startOf('day') - this.clone().startOf('year')) / 864e5
	            ) + 1;
	        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('m', ['mm', 2], 0, 'minute');
	
	    // PARSING
	
	    addRegexToken('m', match1to2, match1to2HasZero);
	    addRegexToken('mm', match1to2, match2);
	    addParseToken(['m', 'mm'], MINUTE);
	
	    // MOMENTS
	
	    var getSetMinute = makeGetSet('Minutes', false);
	
	    // FORMATTING
	
	    addFormatToken('s', ['ss', 2], 0, 'second');
	
	    // PARSING
	
	    addRegexToken('s', match1to2, match1to2HasZero);
	    addRegexToken('ss', match1to2, match2);
	    addParseToken(['s', 'ss'], SECOND);
	
	    // MOMENTS
	
	    var getSetSecond = makeGetSet('Seconds', false);
	
	    // FORMATTING
	
	    addFormatToken('S', 0, 0, function () {
	        return ~~(this.millisecond() / 100);
	    });
	
	    addFormatToken(0, ['SS', 2], 0, function () {
	        return ~~(this.millisecond() / 10);
	    });
	
	    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
	    addFormatToken(0, ['SSSS', 4], 0, function () {
	        return this.millisecond() * 10;
	    });
	    addFormatToken(0, ['SSSSS', 5], 0, function () {
	        return this.millisecond() * 100;
	    });
	    addFormatToken(0, ['SSSSSS', 6], 0, function () {
	        return this.millisecond() * 1000;
	    });
	    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
	        return this.millisecond() * 10000;
	    });
	    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
	        return this.millisecond() * 100000;
	    });
	    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
	        return this.millisecond() * 1000000;
	    });
	
	    // PARSING
	
	    addRegexToken('S', match1to3, match1);
	    addRegexToken('SS', match1to3, match2);
	    addRegexToken('SSS', match1to3, match3);
	
	    var token, getSetMillisecond;
	    for (token = 'SSSS'; token.length <= 9; token += 'S') {
	        addRegexToken(token, matchUnsigned);
	    }
	
	    function parseMs(input, array) {
	        array[MILLISECOND] = toInt(('0.' + input) * 1000);
	    }
	
	    for (token = 'S'; token.length <= 9; token += 'S') {
	        addParseToken(token, parseMs);
	    }
	
	    getSetMillisecond = makeGetSet('Milliseconds', false);
	
	    // FORMATTING
	
	    addFormatToken('z', 0, 0, 'zoneAbbr');
	    addFormatToken('zz', 0, 0, 'zoneName');
	
	    // MOMENTS
	
	    function getZoneAbbr() {
	        return this._isUTC ? 'UTC' : '';
	    }
	
	    function getZoneName() {
	        return this._isUTC ? 'Coordinated Universal Time' : '';
	    }
	
	    var proto = Moment.prototype;
	
	    proto.add = add;
	    proto.calendar = calendar$1;
	    proto.clone = clone;
	    proto.diff = diff;
	    proto.endOf = endOf;
	    proto.format = format;
	    proto.from = from;
	    proto.fromNow = fromNow;
	    proto.to = to;
	    proto.toNow = toNow;
	    proto.get = stringGet;
	    proto.invalidAt = invalidAt;
	    proto.isAfter = isAfter;
	    proto.isBefore = isBefore;
	    proto.isBetween = isBetween;
	    proto.isSame = isSame;
	    proto.isSameOrAfter = isSameOrAfter;
	    proto.isSameOrBefore = isSameOrBefore;
	    proto.isValid = isValid$2;
	    proto.lang = lang;
	    proto.locale = locale;
	    proto.localeData = localeData;
	    proto.max = prototypeMax;
	    proto.min = prototypeMin;
	    proto.parsingFlags = parsingFlags;
	    proto.set = stringSet;
	    proto.startOf = startOf;
	    proto.subtract = subtract;
	    proto.toArray = toArray;
	    proto.toObject = toObject;
	    proto.toDate = toDate;
	    proto.toISOString = toISOString;
	    proto.inspect = inspect;
	    if (typeof Symbol !== 'undefined' && Symbol.for != null) {
	        proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
	            return 'Moment<' + this.format() + '>';
	        };
	    }
	    proto.toJSON = toJSON;
	    proto.toString = toString;
	    proto.unix = unix;
	    proto.valueOf = valueOf;
	    proto.creationData = creationData;
	    proto.eraName = getEraName;
	    proto.eraNarrow = getEraNarrow;
	    proto.eraAbbr = getEraAbbr;
	    proto.eraYear = getEraYear;
	    proto.year = getSetYear;
	    proto.isLeapYear = getIsLeapYear;
	    proto.weekYear = getSetWeekYear;
	    proto.isoWeekYear = getSetISOWeekYear;
	    proto.quarter = proto.quarters = getSetQuarter;
	    proto.month = getSetMonth;
	    proto.daysInMonth = getDaysInMonth;
	    proto.week = proto.weeks = getSetWeek;
	    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
	    proto.weeksInYear = getWeeksInYear;
	    proto.weeksInWeekYear = getWeeksInWeekYear;
	    proto.isoWeeksInYear = getISOWeeksInYear;
	    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
	    proto.date = getSetDayOfMonth;
	    proto.day = proto.days = getSetDayOfWeek;
	    proto.weekday = getSetLocaleDayOfWeek;
	    proto.isoWeekday = getSetISODayOfWeek;
	    proto.dayOfYear = getSetDayOfYear;
	    proto.hour = proto.hours = getSetHour;
	    proto.minute = proto.minutes = getSetMinute;
	    proto.second = proto.seconds = getSetSecond;
	    proto.millisecond = proto.milliseconds = getSetMillisecond;
	    proto.utcOffset = getSetOffset;
	    proto.utc = setOffsetToUTC;
	    proto.local = setOffsetToLocal;
	    proto.parseZone = setOffsetToParsedOffset;
	    proto.hasAlignedHourOffset = hasAlignedHourOffset;
	    proto.isDST = isDaylightSavingTime;
	    proto.isLocal = isLocal;
	    proto.isUtcOffset = isUtcOffset;
	    proto.isUtc = isUtc;
	    proto.isUTC = isUtc;
	    proto.zoneAbbr = getZoneAbbr;
	    proto.zoneName = getZoneName;
	    proto.dates = deprecate(
	        'dates accessor is deprecated. Use date instead.',
	        getSetDayOfMonth
	    );
	    proto.months = deprecate(
	        'months accessor is deprecated. Use month instead',
	        getSetMonth
	    );
	    proto.years = deprecate(
	        'years accessor is deprecated. Use year instead',
	        getSetYear
	    );
	    proto.zone = deprecate(
	        'moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/',
	        getSetZone
	    );
	    proto.isDSTShifted = deprecate(
	        'isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information',
	        isDaylightSavingTimeShifted
	    );
	
	    function createUnix(input) {
	        return createLocal(input * 1000);
	    }
	
	    function createInZone() {
	        return createLocal.apply(null, arguments).parseZone();
	    }
	
	    function preParsePostFormat(string) {
	        return string;
	    }
	
	    var proto$1 = Locale.prototype;
	
	    proto$1.calendar = calendar;
	    proto$1.longDateFormat = longDateFormat;
	    proto$1.invalidDate = invalidDate;
	    proto$1.ordinal = ordinal;
	    proto$1.preparse = preParsePostFormat;
	    proto$1.postformat = preParsePostFormat;
	    proto$1.relativeTime = relativeTime;
	    proto$1.pastFuture = pastFuture;
	    proto$1.set = set;
	    proto$1.eras = localeEras;
	    proto$1.erasParse = localeErasParse;
	    proto$1.erasConvertYear = localeErasConvertYear;
	    proto$1.erasAbbrRegex = erasAbbrRegex;
	    proto$1.erasNameRegex = erasNameRegex;
	    proto$1.erasNarrowRegex = erasNarrowRegex;
	
	    proto$1.months = localeMonths;
	    proto$1.monthsShort = localeMonthsShort;
	    proto$1.monthsParse = localeMonthsParse;
	    proto$1.monthsRegex = monthsRegex;
	    proto$1.monthsShortRegex = monthsShortRegex;
	    proto$1.week = localeWeek;
	    proto$1.firstDayOfYear = localeFirstDayOfYear;
	    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
	
	    proto$1.weekdays = localeWeekdays;
	    proto$1.weekdaysMin = localeWeekdaysMin;
	    proto$1.weekdaysShort = localeWeekdaysShort;
	    proto$1.weekdaysParse = localeWeekdaysParse;
	
	    proto$1.weekdaysRegex = weekdaysRegex;
	    proto$1.weekdaysShortRegex = weekdaysShortRegex;
	    proto$1.weekdaysMinRegex = weekdaysMinRegex;
	
	    proto$1.isPM = localeIsPM;
	    proto$1.meridiem = localeMeridiem;
	
	    function get$1(format, index, field, setter) {
	        var locale = getLocale(),
	            utc = createUTC().set(setter, index);
	        return locale[field](utc, format);
	    }
	
	    function listMonthsImpl(format, index, field) {
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	
	        if (index != null) {
	            return get$1(format, index, field, 'month');
	        }
	
	        var i,
	            out = [];
	        for (i = 0; i < 12; i++) {
	            out[i] = get$1(format, i, field, 'month');
	        }
	        return out;
	    }
	
	    // ()
	    // (5)
	    // (fmt, 5)
	    // (fmt)
	    // (true)
	    // (true, 5)
	    // (true, fmt, 5)
	    // (true, fmt)
	    function listWeekdaysImpl(localeSorted, format, index, field) {
	        if (typeof localeSorted === 'boolean') {
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        } else {
	            format = localeSorted;
	            index = format;
	            localeSorted = false;
	
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        }
	
	        var locale = getLocale(),
	            shift = localeSorted ? locale._week.dow : 0,
	            i,
	            out = [];
	
	        if (index != null) {
	            return get$1(format, (index + shift) % 7, field, 'day');
	        }
	
	        for (i = 0; i < 7; i++) {
	            out[i] = get$1(format, (i + shift) % 7, field, 'day');
	        }
	        return out;
	    }
	
	    function listMonths(format, index) {
	        return listMonthsImpl(format, index, 'months');
	    }
	
	    function listMonthsShort(format, index) {
	        return listMonthsImpl(format, index, 'monthsShort');
	    }
	
	    function listWeekdays(localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
	    }
	
	    function listWeekdaysShort(localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
	    }
	
	    function listWeekdaysMin(localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
	    }
	
	    getSetGlobalLocale('en', {
	        eras: [
	            {
	                since: '0001-01-01',
	                until: +Infinity,
	                offset: 1,
	                name: 'Anno Domini',
	                narrow: 'AD',
	                abbr: 'AD',
	            },
	            {
	                since: '0000-12-31',
	                until: -Infinity,
	                offset: 1,
	                name: 'Before Christ',
	                narrow: 'BC',
	                abbr: 'BC',
	            },
	        ],
	        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    toInt((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                          ? 'st'
	                          : b === 2
	                            ? 'nd'
	                            : b === 3
	                              ? 'rd'
	                              : 'th';
	            return number + output;
	        },
	    });
	
	    // Side effect imports
	
	    hooks.lang = deprecate(
	        'moment.lang is deprecated. Use moment.locale instead.',
	        getSetGlobalLocale
	    );
	    hooks.langData = deprecate(
	        'moment.langData is deprecated. Use moment.localeData instead.',
	        getLocale
	    );
	
	    var mathAbs = Math.abs;
	
	    function abs() {
	        var data = this._data;
	
	        this._milliseconds = mathAbs(this._milliseconds);
	        this._days = mathAbs(this._days);
	        this._months = mathAbs(this._months);
	
	        data.milliseconds = mathAbs(data.milliseconds);
	        data.seconds = mathAbs(data.seconds);
	        data.minutes = mathAbs(data.minutes);
	        data.hours = mathAbs(data.hours);
	        data.months = mathAbs(data.months);
	        data.years = mathAbs(data.years);
	
	        return this;
	    }
	
	    function addSubtract$1(duration, input, value, direction) {
	        var other = createDuration(input, value);
	
	        duration._milliseconds += direction * other._milliseconds;
	        duration._days += direction * other._days;
	        duration._months += direction * other._months;
	
	        return duration._bubble();
	    }
	
	    // supports only 2.0-style add(1, 's') or add(duration)
	    function add$1(input, value) {
	        return addSubtract$1(this, input, value, 1);
	    }
	
	    // supports only 2.0-style subtract(1, 's') or subtract(duration)
	    function subtract$1(input, value) {
	        return addSubtract$1(this, input, value, -1);
	    }
	
	    function absCeil(number) {
	        if (number < 0) {
	            return Math.floor(number);
	        } else {
	            return Math.ceil(number);
	        }
	    }
	
	    function bubble() {
	        var milliseconds = this._milliseconds,
	            days = this._days,
	            months = this._months,
	            data = this._data,
	            seconds,
	            minutes,
	            hours,
	            years,
	            monthsFromDays;
	
	        // if we have a mix of positive and negative values, bubble down first
	        // check: https://github.com/moment/moment/issues/2166
	        if (
	            !(
	                (milliseconds >= 0 && days >= 0 && months >= 0) ||
	                (milliseconds <= 0 && days <= 0 && months <= 0)
	            )
	        ) {
	            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
	            days = 0;
	            months = 0;
	        }
	
	        // The following code bubbles up values, see the tests for
	        // examples of what that means.
	        data.milliseconds = milliseconds % 1000;
	
	        seconds = absFloor(milliseconds / 1000);
	        data.seconds = seconds % 60;
	
	        minutes = absFloor(seconds / 60);
	        data.minutes = minutes % 60;
	
	        hours = absFloor(minutes / 60);
	        data.hours = hours % 24;
	
	        days += absFloor(hours / 24);
	
	        // convert days to months
	        monthsFromDays = absFloor(daysToMonths(days));
	        months += monthsFromDays;
	        days -= absCeil(monthsToDays(monthsFromDays));
	
	        // 12 months -> 1 year
	        years = absFloor(months / 12);
	        months %= 12;
	
	        data.days = days;
	        data.months = months;
	        data.years = years;
	
	        return this;
	    }
	
	    function daysToMonths(days) {
	        // 400 years have 146097 days (taking into account leap year rules)
	        // 400 years have 12 months === 4800
	        return (days * 4800) / 146097;
	    }
	
	    function monthsToDays(months) {
	        // the reverse of daysToMonths
	        return (months * 146097) / 4800;
	    }
	
	    function as(units) {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        var days,
	            months,
	            milliseconds = this._milliseconds;
	
	        units = normalizeUnits(units);
	
	        if (units === 'month' || units === 'quarter' || units === 'year') {
	            days = this._days + milliseconds / 864e5;
	            months = this._months + daysToMonths(days);
	            switch (units) {
	                case 'month':
	                    return months;
	                case 'quarter':
	                    return months / 3;
	                case 'year':
	                    return months / 12;
	            }
	        } else {
	            // handle milliseconds separately because of floating point math errors (issue #1867)
	            days = this._days + Math.round(monthsToDays(this._months));
	            switch (units) {
	                case 'week':
	                    return days / 7 + milliseconds / 6048e5;
	                case 'day':
	                    return days + milliseconds / 864e5;
	                case 'hour':
	                    return days * 24 + milliseconds / 36e5;
	                case 'minute':
	                    return days * 1440 + milliseconds / 6e4;
	                case 'second':
	                    return days * 86400 + milliseconds / 1000;
	                // Math.floor prevents floating point math errors here
	                case 'millisecond':
	                    return Math.floor(days * 864e5) + milliseconds;
	                default:
	                    throw new Error('Unknown unit ' + units);
	            }
	        }
	    }
	
	    function makeAs(alias) {
	        return function () {
	            return this.as(alias);
	        };
	    }
	
	    var asMilliseconds = makeAs('ms'),
	        asSeconds = makeAs('s'),
	        asMinutes = makeAs('m'),
	        asHours = makeAs('h'),
	        asDays = makeAs('d'),
	        asWeeks = makeAs('w'),
	        asMonths = makeAs('M'),
	        asQuarters = makeAs('Q'),
	        asYears = makeAs('y'),
	        valueOf$1 = asMilliseconds;
	
	    function clone$1() {
	        return createDuration(this);
	    }
	
	    function get$2(units) {
	        units = normalizeUnits(units);
	        return this.isValid() ? this[units + 's']() : NaN;
	    }
	
	    function makeGetter(name) {
	        return function () {
	            return this.isValid() ? this._data[name] : NaN;
	        };
	    }
	
	    var milliseconds = makeGetter('milliseconds'),
	        seconds = makeGetter('seconds'),
	        minutes = makeGetter('minutes'),
	        hours = makeGetter('hours'),
	        days = makeGetter('days'),
	        months = makeGetter('months'),
	        years = makeGetter('years');
	
	    function weeks() {
	        return absFloor(this.days() / 7);
	    }
	
	    var round = Math.round,
	        thresholds = {
	            ss: 44, // a few seconds to seconds
	            s: 45, // seconds to minute
	            m: 45, // minutes to hour
	            h: 22, // hours to day
	            d: 26, // days to month/week
	            w: null, // weeks to month
	            M: 11, // months to year
	        };
	
	    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
	    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
	        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
	    }
	
	    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
	        var duration = createDuration(posNegDuration).abs(),
	            seconds = round(duration.as('s')),
	            minutes = round(duration.as('m')),
	            hours = round(duration.as('h')),
	            days = round(duration.as('d')),
	            months = round(duration.as('M')),
	            weeks = round(duration.as('w')),
	            years = round(duration.as('y')),
	            a =
	                (seconds <= thresholds.ss && ['s', seconds]) ||
	                (seconds < thresholds.s && ['ss', seconds]) ||
	                (minutes <= 1 && ['m']) ||
	                (minutes < thresholds.m && ['mm', minutes]) ||
	                (hours <= 1 && ['h']) ||
	                (hours < thresholds.h && ['hh', hours]) ||
	                (days <= 1 && ['d']) ||
	                (days < thresholds.d && ['dd', days]);
	
	        if (thresholds.w != null) {
	            a =
	                a ||
	                (weeks <= 1 && ['w']) ||
	                (weeks < thresholds.w && ['ww', weeks]);
	        }
	        a = a ||
	            (months <= 1 && ['M']) ||
	            (months < thresholds.M && ['MM', months]) ||
	            (years <= 1 && ['y']) || ['yy', years];
	
	        a[2] = withoutSuffix;
	        a[3] = +posNegDuration > 0;
	        a[4] = locale;
	        return substituteTimeAgo.apply(null, a);
	    }
	
	    // This function allows you to set the rounding function for relative time strings
	    function getSetRelativeTimeRounding(roundingFunction) {
	        if (roundingFunction === undefined) {
	            return round;
	        }
	        if (typeof roundingFunction === 'function') {
	            round = roundingFunction;
	            return true;
	        }
	        return false;
	    }
	
	    // This function allows you to set a threshold for relative time strings
	    function getSetRelativeTimeThreshold(threshold, limit) {
	        if (thresholds[threshold] === undefined) {
	            return false;
	        }
	        if (limit === undefined) {
	            return thresholds[threshold];
	        }
	        thresholds[threshold] = limit;
	        if (threshold === 's') {
	            thresholds.ss = limit - 1;
	        }
	        return true;
	    }
	
	    function humanize(argWithSuffix, argThresholds) {
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var withSuffix = false,
	            th = thresholds,
	            locale,
	            output;
	
	        if (typeof argWithSuffix === 'object') {
	            argThresholds = argWithSuffix;
	            argWithSuffix = false;
	        }
	        if (typeof argWithSuffix === 'boolean') {
	            withSuffix = argWithSuffix;
	        }
	        if (typeof argThresholds === 'object') {
	            th = Object.assign({}, thresholds, argThresholds);
	            if (argThresholds.s != null && argThresholds.ss == null) {
	                th.ss = argThresholds.s - 1;
	            }
	        }
	
	        locale = this.localeData();
	        output = relativeTime$1(this, !withSuffix, th, locale);
	
	        if (withSuffix) {
	            output = locale.pastFuture(+this, output);
	        }
	
	        return locale.postformat(output);
	    }
	
	    var abs$1 = Math.abs;
	
	    function sign(x) {
	        return (x > 0) - (x < 0) || +x;
	    }
	
	    function toISOString$1() {
	        // for ISO strings we do not use the normal bubbling rules:
	        //  * milliseconds bubble up until they become hours
	        //  * days do not bubble at all
	        //  * months bubble up until they become years
	        // This is because there is no context-free conversion between hours and days
	        // (think of clock changes)
	        // and also not between days and months (28-31 days per month)
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var seconds = abs$1(this._milliseconds) / 1000,
	            days = abs$1(this._days),
	            months = abs$1(this._months),
	            minutes,
	            hours,
	            years,
	            s,
	            total = this.asSeconds(),
	            totalSign,
	            ymSign,
	            daysSign,
	            hmsSign;
	
	        if (!total) {
	            // this is the same as C#'s (Noda) and python (isodate)...
	            // but not other JS (goog.date)
	            return 'P0D';
	        }
	
	        // 3600 seconds -> 60 minutes -> 1 hour
	        minutes = absFloor(seconds / 60);
	        hours = absFloor(minutes / 60);
	        seconds %= 60;
	        minutes %= 60;
	
	        // 12 months -> 1 year
	        years = absFloor(months / 12);
	        months %= 12;
	
	        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
	        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
	
	        totalSign = total < 0 ? '-' : '';
	        ymSign = sign(this._months) !== sign(total) ? '-' : '';
	        daysSign = sign(this._days) !== sign(total) ? '-' : '';
	        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
	
	        return (
	            totalSign +
	            'P' +
	            (years ? ymSign + years + 'Y' : '') +
	            (months ? ymSign + months + 'M' : '') +
	            (days ? daysSign + days + 'D' : '') +
	            (hours || minutes || seconds ? 'T' : '') +
	            (hours ? hmsSign + hours + 'H' : '') +
	            (minutes ? hmsSign + minutes + 'M' : '') +
	            (seconds ? hmsSign + s + 'S' : '')
	        );
	    }
	
	    var proto$2 = Duration.prototype;
	
	    proto$2.isValid = isValid$1;
	    proto$2.abs = abs;
	    proto$2.add = add$1;
	    proto$2.subtract = subtract$1;
	    proto$2.as = as;
	    proto$2.asMilliseconds = asMilliseconds;
	    proto$2.asSeconds = asSeconds;
	    proto$2.asMinutes = asMinutes;
	    proto$2.asHours = asHours;
	    proto$2.asDays = asDays;
	    proto$2.asWeeks = asWeeks;
	    proto$2.asMonths = asMonths;
	    proto$2.asQuarters = asQuarters;
	    proto$2.asYears = asYears;
	    proto$2.valueOf = valueOf$1;
	    proto$2._bubble = bubble;
	    proto$2.clone = clone$1;
	    proto$2.get = get$2;
	    proto$2.milliseconds = milliseconds;
	    proto$2.seconds = seconds;
	    proto$2.minutes = minutes;
	    proto$2.hours = hours;
	    proto$2.days = days;
	    proto$2.weeks = weeks;
	    proto$2.months = months;
	    proto$2.years = years;
	    proto$2.humanize = humanize;
	    proto$2.toISOString = toISOString$1;
	    proto$2.toString = toISOString$1;
	    proto$2.toJSON = toISOString$1;
	    proto$2.locale = locale;
	    proto$2.localeData = localeData;
	
	    proto$2.toIsoString = deprecate(
	        'toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)',
	        toISOString$1
	    );
	    proto$2.lang = lang;
	
	    // FORMATTING
	
	    addFormatToken('X', 0, 0, 'unix');
	    addFormatToken('x', 0, 0, 'valueOf');
	
	    // PARSING
	
	    addRegexToken('x', matchSigned);
	    addRegexToken('X', matchTimestamp);
	    addParseToken('X', function (input, array, config) {
	        config._d = new Date(parseFloat(input) * 1000);
	    });
	    addParseToken('x', function (input, array, config) {
	        config._d = new Date(toInt(input));
	    });
	
	    //! moment.js
	
	    hooks.version = '2.30.1';
	
	    setHookCallback(createLocal);
	
	    hooks.fn = proto;
	    hooks.min = min;
	    hooks.max = max;
	    hooks.now = now;
	    hooks.utc = createUTC;
	    hooks.unix = createUnix;
	    hooks.months = listMonths;
	    hooks.isDate = isDate;
	    hooks.locale = getSetGlobalLocale;
	    hooks.invalid = createInvalid;
	    hooks.duration = createDuration;
	    hooks.isMoment = isMoment;
	    hooks.weekdays = listWeekdays;
	    hooks.parseZone = createInZone;
	    hooks.localeData = getLocale;
	    hooks.isDuration = isDuration;
	    hooks.monthsShort = listMonthsShort;
	    hooks.weekdaysMin = listWeekdaysMin;
	    hooks.defineLocale = defineLocale;
	    hooks.updateLocale = updateLocale;
	    hooks.locales = listLocales;
	    hooks.weekdaysShort = listWeekdaysShort;
	    hooks.normalizeUnits = normalizeUnits;
	    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
	    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
	    hooks.calendarFormat = getCalendarFormat;
	    hooks.prototype = proto;
	
	    // currently HTML5 input type only supports 24-hour formats
	    hooks.HTML5_FMT = {
	        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm', // <input type="datetime-local" />
	        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss', // <input type="datetime-local" step="1" />
	        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS', // <input type="datetime-local" step="0.001" />
	        DATE: 'YYYY-MM-DD', // <input type="date" />
	        TIME: 'HH:mm', // <input type="time" />
	        TIME_SECONDS: 'HH:mm:ss', // <input type="time" step="1" />
	        TIME_MS: 'HH:mm:ss.SSS', // <input type="time" step="0.001" />
	        WEEK: 'GGGG-[W]WW', // <input type="week" />
	        MONTH: 'YYYY-MM', // <input type="month" />
	    };
	
	    return hooks;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(453)(module)))

/***/ }),
/* 1125 */,
/* 1126 */
/***/ (function(module, exports) {

	/**
	 * oclazyload - Load modules on demand (lazy load) with angularJS
	 * @version v1.0.10
	 * @link https://github.com/ocombe/ocLazyLoad
	 * @license MIT
	 * @author Olivier Combe <olivier.combe@gmail.com>
	 */
	(function (angular, window) {
	    'use strict';
	
	    var regModules = ['ng', 'oc.lazyLoad'],
	        regInvokes = {},
	        regConfigs = [],
	        modulesToLoad = [],
	        // modules to load from angular.module or other sources
	    realModules = [],
	        // real modules called from angular.module
	    recordDeclarations = [],
	        broadcast = angular.noop,
	        runBlocks = {},
	        justLoaded = [];
	
	    var ocLazyLoad = angular.module('oc.lazyLoad', ['ng']);
	
	    ocLazyLoad.provider('$ocLazyLoad', ["$controllerProvider", "$provide", "$compileProvider", "$filterProvider", "$injector", "$animateProvider", function ($controllerProvider, $provide, $compileProvider, $filterProvider, $injector, $animateProvider) {
	        var modules = {},
	            providers = {
	            $controllerProvider: $controllerProvider,
	            $compileProvider: $compileProvider,
	            $filterProvider: $filterProvider,
	            $provide: $provide, // other things (constant, decorator, provider, factory, service)
	            $injector: $injector,
	            $animateProvider: $animateProvider
	        },
	            debug = false,
	            events = false,
	            moduleCache = [],
	            modulePromises = {};
	
	        moduleCache.push = function (value) {
	            if (this.indexOf(value) === -1) {
	                Array.prototype.push.apply(this, arguments);
	            }
	        };
	
	        this.config = function (config) {
	            // If we want to define modules configs
	            if (angular.isDefined(config.modules)) {
	                if (angular.isArray(config.modules)) {
	                    angular.forEach(config.modules, function (moduleConfig) {
	                        modules[moduleConfig.name] = moduleConfig;
	                    });
	                } else {
	                    modules[config.modules.name] = config.modules;
	                }
	            }
	
	            if (angular.isDefined(config.debug)) {
	                debug = config.debug;
	            }
	
	            if (angular.isDefined(config.events)) {
	                events = config.events;
	            }
	        };
	
	        /**
	         * Get the list of existing registered modules
	         * @param element
	         */
	        this._init = function _init(element) {
	            // this is probably useless now because we override angular.bootstrap
	            if (modulesToLoad.length === 0) {
	                var elements = [element],
	                    names = ['ng:app', 'ng-app', 'x-ng-app', 'data-ng-app'],
	                    NG_APP_CLASS_REGEXP = /\sng[:\-]app(:\s*([\w\d_]+);?)?\s/,
	                    append = function append(elm) {
	                    return elm && elements.push(elm);
	                };
	
	                angular.forEach(names, function (name) {
	                    names[name] = true;
	                    append(document.getElementById(name));
	                    name = name.replace(':', '\\:');
	                    if (typeof element[0] !== 'undefined' && element[0].querySelectorAll) {
	                        angular.forEach(element[0].querySelectorAll('.' + name), append);
	                        angular.forEach(element[0].querySelectorAll('.' + name + '\\:'), append);
	                        angular.forEach(element[0].querySelectorAll('[' + name + ']'), append);
	                    }
	                });
	
	                angular.forEach(elements, function (elm) {
	                    if (modulesToLoad.length === 0) {
	                        var className = ' ' + element.className + ' ';
	                        var match = NG_APP_CLASS_REGEXP.exec(className);
	                        if (match) {
	                            modulesToLoad.push((match[2] || '').replace(/\s+/g, ','));
	                        } else {
	                            angular.forEach(elm.attributes, function (attr) {
	                                if (modulesToLoad.length === 0 && names[attr.name]) {
	                                    modulesToLoad.push(attr.value);
	                                }
	                            });
	                        }
	                    }
	                });
	            }
	
	            if (modulesToLoad.length === 0 && !((window.jasmine || window.mocha) && angular.isDefined(angular.mock))) {
	                console.error('No module found during bootstrap, unable to init ocLazyLoad. You should always use the ng-app directive or angular.boostrap when you use ocLazyLoad.');
	            }
	
	            var addReg = function addReg(moduleName) {
	                if (regModules.indexOf(moduleName) === -1) {
	                    // register existing modules
	                    regModules.push(moduleName);
	                    var mainModule = angular.module(moduleName);
	
	                    // register existing components (directives, services, ...)
	                    _invokeQueue(null, mainModule._invokeQueue, moduleName);
	                    _invokeQueue(null, mainModule._configBlocks, moduleName); // angular 1.3+
	
	                    angular.forEach(mainModule.requires, addReg);
	                }
	            };
	
	            angular.forEach(modulesToLoad, function (moduleName) {
	                addReg(moduleName);
	            });
	
	            modulesToLoad = []; // reset for next bootstrap
	            recordDeclarations.pop(); // wait for the next lazy load
	        };
	
	        /**
	         * Like JSON.stringify but that doesn't throw on circular references
	         * @param obj
	         */
	        var stringify = function stringify(obj) {
	            try {
	                return JSON.stringify(obj);
	            } catch (e) {
	                var cache = [];
	                return JSON.stringify(obj, function (key, value) {
	                    if (angular.isObject(value) && value !== null) {
	                        if (cache.indexOf(value) !== -1) {
	                            // Circular reference found, discard key
	                            return;
	                        }
	                        // Store value in our collection
	                        cache.push(value);
	                    }
	                    return value;
	                });
	            }
	        };
	
	        var hashCode = function hashCode(str) {
	            var hash = 0,
	                i,
	                chr,
	                len;
	            if (str.length == 0) {
	                return hash;
	            }
	            for (i = 0, len = str.length; i < len; i++) {
	                chr = str.charCodeAt(i);
	                hash = (hash << 5) - hash + chr;
	                hash |= 0; // Convert to 32bit integer
	            }
	            return hash;
	        };
	
	        function _register(providers, registerModules, params) {
	            if (registerModules) {
	                var k,
	                    moduleName,
	                    moduleFn,
	                    tempRunBlocks = [];
	                for (k = registerModules.length - 1; k >= 0; k--) {
	                    moduleName = registerModules[k];
	                    if (!angular.isString(moduleName)) {
	                        moduleName = getModuleName(moduleName);
	                    }
	                    if (!moduleName || justLoaded.indexOf(moduleName) !== -1 || modules[moduleName] && realModules.indexOf(moduleName) === -1) {
	                        continue;
	                    }
	                    // new if not registered
	                    var newModule = regModules.indexOf(moduleName) === -1;
	                    moduleFn = ngModuleFct(moduleName);
	                    if (newModule) {
	                        regModules.push(moduleName);
	                        _register(providers, moduleFn.requires, params);
	                    }
	                    if (moduleFn._runBlocks.length > 0) {
	                        // new run blocks detected! Replace the old ones (if existing)
	                        runBlocks[moduleName] = [];
	                        while (moduleFn._runBlocks.length > 0) {
	                            runBlocks[moduleName].push(moduleFn._runBlocks.shift());
	                        }
	                    }
	                    if (angular.isDefined(runBlocks[moduleName]) && (newModule || params.rerun)) {
	                        tempRunBlocks = tempRunBlocks.concat(runBlocks[moduleName]);
	                    }
	                    _invokeQueue(providers, moduleFn._invokeQueue, moduleName, params.reconfig);
	                    _invokeQueue(providers, moduleFn._configBlocks, moduleName, params.reconfig); // angular 1.3+
	                    broadcast(newModule ? 'ocLazyLoad.moduleLoaded' : 'ocLazyLoad.moduleReloaded', moduleName);
	                    registerModules.pop();
	                    justLoaded.push(moduleName);
	                }
	                // execute the run blocks at the end
	                var instanceInjector = providers.getInstanceInjector();
	                angular.forEach(tempRunBlocks, function (fn) {
	                    instanceInjector.invoke(fn);
	                });
	            }
	        }
	
	        function _registerInvokeList(args, moduleName) {
	            var invokeList = args[2][0],
	                type = args[1],
	                newInvoke = false;
	            if (angular.isUndefined(regInvokes[moduleName])) {
	                regInvokes[moduleName] = {};
	            }
	            if (angular.isUndefined(regInvokes[moduleName][type])) {
	                regInvokes[moduleName][type] = {};
	            }
	            var onInvoke = function onInvoke(invokeName, invoke) {
	                if (!regInvokes[moduleName][type].hasOwnProperty(invokeName)) {
	                    regInvokes[moduleName][type][invokeName] = [];
	                }
	                if (checkHashes(invoke, regInvokes[moduleName][type][invokeName])) {
	                    newInvoke = true;
	                    regInvokes[moduleName][type][invokeName].push(invoke);
	                    broadcast('ocLazyLoad.componentLoaded', [moduleName, type, invokeName]);
	                }
	            };
	
	            function checkHashes(potentialNew, invokes) {
	                var isNew = true,
	                    newHash;
	                if (invokes.length) {
	                    newHash = signature(potentialNew);
	                    angular.forEach(invokes, function (invoke) {
	                        isNew = isNew && signature(invoke) !== newHash;
	                    });
	                }
	                return isNew;
	            }
	
	            function signature(data) {
	                if (angular.isArray(data)) {
	                    // arrays are objects, we need to test for it first
	                    return hashCode(data.toString());
	                } else if (angular.isObject(data)) {
	                    // constants & values for example
	                    return hashCode(stringify(data));
	                } else {
	                    if (angular.isDefined(data) && data !== null) {
	                        return hashCode(data.toString());
	                    } else {
	                        // null & undefined constants
	                        return data;
	                    }
	                }
	            }
	
	            if (angular.isString(invokeList)) {
	                onInvoke(invokeList, args[2][1]);
	            } else if (angular.isObject(invokeList)) {
	                angular.forEach(invokeList, function (invoke, key) {
	                    if (angular.isString(invoke)) {
	                        // decorators for example
	                        onInvoke(invoke, invokeList[1]);
	                    } else {
	                        // components registered as object lists {"componentName": function() {}}
	                        onInvoke(key, invoke);
	                    }
	                });
	            } else {
	                return false;
	            }
	            return newInvoke;
	        }
	
	        function _invokeQueue(providers, queue, moduleName, reconfig) {
	            if (!queue) {
	                return;
	            }
	
	            var i, len, args, provider;
	            for (i = 0, len = queue.length; i < len; i++) {
	                args = queue[i];
	                if (angular.isArray(args)) {
	                    if (providers !== null) {
	                        if (providers.hasOwnProperty(args[0])) {
	                            provider = providers[args[0]];
	                        } else {
	                            throw new Error('unsupported provider ' + args[0]);
	                        }
	                    }
	                    var isNew = _registerInvokeList(args, moduleName);
	                    if (args[1] !== 'invoke') {
	                        if (isNew && angular.isDefined(provider)) {
	                            provider[args[1]].apply(provider, args[2]);
	                        }
	                    } else {
	                        // config block
	                        var callInvoke = function callInvoke(fct) {
	                            var invoked = regConfigs.indexOf(moduleName + '-' + fct);
	                            if (invoked === -1 || reconfig) {
	                                if (invoked === -1) {
	                                    regConfigs.push(moduleName + '-' + fct);
	                                }
	                                if (angular.isDefined(provider)) {
	                                    provider[args[1]].apply(provider, args[2]);
	                                }
	                            }
	                        };
	                        if (angular.isFunction(args[2][0])) {
	                            callInvoke(args[2][0]);
	                        } else if (angular.isArray(args[2][0])) {
	                            for (var j = 0, jlen = args[2][0].length; j < jlen; j++) {
	                                if (angular.isFunction(args[2][0][j])) {
	                                    callInvoke(args[2][0][j]);
	                                }
	                            }
	                        }
	                    }
	                }
	            }
	        }
	
	        function getModuleName(module) {
	            var moduleName = null;
	            if (angular.isString(module)) {
	                moduleName = module;
	            } else if (angular.isObject(module) && module.hasOwnProperty('name') && angular.isString(module.name)) {
	                moduleName = module.name;
	            }
	            return moduleName;
	        }
	
	        function moduleExists(moduleName) {
	            if (!angular.isString(moduleName)) {
	                return false;
	            }
	            try {
	                return ngModuleFct(moduleName);
	            } catch (e) {
	                if (/No module/.test(e) || e.message.indexOf('$injector:nomod') > -1) {
	                    return false;
	                }
	            }
	        }
	
	        this.$get = ["$log", "$rootElement", "$rootScope", "$cacheFactory", "$q", function ($log, $rootElement, $rootScope, $cacheFactory, $q) {
	            var instanceInjector,
	                filesCache = $cacheFactory('ocLazyLoad');
	
	            if (!debug) {
	                $log = {};
	                $log['error'] = angular.noop;
	                $log['warn'] = angular.noop;
	                $log['info'] = angular.noop;
	            }
	
	            // Make this lazy because when $get() is called the instance injector hasn't been assigned to the rootElement yet
	            providers.getInstanceInjector = function () {
	                return instanceInjector ? instanceInjector : instanceInjector = $rootElement.data('$injector') || angular.injector();
	            };
	
	            broadcast = function broadcast(eventName, params) {
	                if (events) {
	                    $rootScope.$broadcast(eventName, params);
	                }
	                if (debug) {
	                    $log.info(eventName, params);
	                }
	            };
	
	            function reject(e) {
	                var deferred = $q.defer();
	                $log.error(e.message);
	                deferred.reject(e);
	                return deferred.promise;
	            }
	
	            return {
	                _broadcast: broadcast,
	
	                _$log: $log,
	
	                /**
	                 * Returns the files cache used by the loaders to store the files currently loading
	                 * @returns {*}
	                 */
	                _getFilesCache: function getFilesCache() {
	                    return filesCache;
	                },
	
	                /**
	                 * Let the service know that it should monitor angular.module because files are loading
	                 * @param watch boolean
	                 */
	                toggleWatch: function toggleWatch(watch) {
	                    if (watch) {
	                        recordDeclarations.push(true);
	                    } else {
	                        recordDeclarations.pop();
	                    }
	                },
	
	                /**
	                 * Let you get a module config object
	                 * @param moduleName String the name of the module
	                 * @returns {*}
	                 */
	                getModuleConfig: function getModuleConfig(moduleName) {
	                    if (!angular.isString(moduleName)) {
	                        throw new Error('You need to give the name of the module to get');
	                    }
	                    if (!modules[moduleName]) {
	                        return null;
	                    }
	                    return angular.copy(modules[moduleName]);
	                },
	
	                /**
	                 * Let you define a module config object
	                 * @param moduleConfig Object the module config object
	                 * @returns {*}
	                 */
	                setModuleConfig: function setModuleConfig(moduleConfig) {
	                    if (!angular.isObject(moduleConfig)) {
	                        throw new Error('You need to give the module config object to set');
	                    }
	                    modules[moduleConfig.name] = moduleConfig;
	                    return moduleConfig;
	                },
	
	                /**
	                 * Returns the list of loaded modules
	                 * @returns {string[]}
	                 */
	                getModules: function getModules() {
	                    return regModules;
	                },
	
	                /**
	                 * Let you check if a module has been loaded into Angular or not
	                 * @param modulesNames String/Object a module name, or a list of module names
	                 * @returns {boolean}
	                 */
	                isLoaded: function isLoaded(modulesNames) {
	                    var moduleLoaded = function moduleLoaded(module) {
	                        var isLoaded = regModules.indexOf(module) > -1;
	                        if (!isLoaded) {
	                            isLoaded = !!moduleExists(module);
	                        }
	                        return isLoaded;
	                    };
	                    if (angular.isString(modulesNames)) {
	                        modulesNames = [modulesNames];
	                    }
	                    if (angular.isArray(modulesNames)) {
	                        var i, len;
	                        for (i = 0, len = modulesNames.length; i < len; i++) {
	                            if (!moduleLoaded(modulesNames[i])) {
	                                return false;
	                            }
	                        }
	                        return true;
	                    } else {
	                        throw new Error('You need to define the module(s) name(s)');
	                    }
	                },
	
	                /**
	                 * Given a module, return its name
	                 * @param module
	                 * @returns {String}
	                 */
	                _getModuleName: getModuleName,
	
	                /**
	                 * Returns a module if it exists
	                 * @param moduleName
	                 * @returns {module}
	                 */
	                _getModule: function getModule(moduleName) {
	                    try {
	                        return ngModuleFct(moduleName);
	                    } catch (e) {
	                        // this error message really suxx
	                        if (/No module/.test(e) || e.message.indexOf('$injector:nomod') > -1) {
	                            e.message = 'The module "' + stringify(moduleName) + '" that you are trying to load does not exist. ' + e.message;
	                        }
	                        throw e;
	                    }
	                },
	
	                /**
	                 * Check if a module exists and returns it if it does
	                 * @param moduleName
	                 * @returns {boolean}
	                 */
	                moduleExists: moduleExists,
	
	                /**
	                 * Load the dependencies, and might try to load new files depending on the config
	                 * @param moduleName (String or Array of Strings)
	                 * @param localParams
	                 * @returns {*}
	                 * @private
	                 */
	                _loadDependencies: function _loadDependencies(moduleName, localParams) {
	                    var loadedModule,
	                        requires,
	                        diff,
	                        promisesList = [],
	                        self = this;
	
	                    moduleName = self._getModuleName(moduleName);
	
	                    if (moduleName === null) {
	                        return $q.when();
	                    } else {
	                        try {
	                            loadedModule = self._getModule(moduleName);
	                        } catch (e) {
	                            return reject(e);
	                        }
	                        // get unloaded requires
	                        requires = self.getRequires(loadedModule);
	                    }
	
	                    angular.forEach(requires, function (requireEntry) {
	                        // If no configuration is provided, try and find one from a previous load.
	                        // If there isn't one, bail and let the normal flow run
	                        if (angular.isString(requireEntry)) {
	                            var config = self.getModuleConfig(requireEntry);
	                            if (config === null) {
	                                moduleCache.push(requireEntry); // We don't know about this module, but something else might, so push it anyway.
	                                return;
	                            }
	                            requireEntry = config;
	                            // ignore the name because it's probably not a real module name
	                            config.name = undefined;
	                        }
	
	                        // Check if this dependency has been loaded previously
	                        if (self.moduleExists(requireEntry.name)) {
	                            // compare against the already loaded module to see if the new definition adds any new files
	                            diff = requireEntry.files.filter(function (n) {
	                                return self.getModuleConfig(requireEntry.name).files.indexOf(n) < 0;
	                            });
	
	                            // If the module was redefined, advise via the console
	                            if (diff.length !== 0) {
	                                self._$log.warn('Module "', moduleName, '" attempted to redefine configuration for dependency. "', requireEntry.name, '"\n Additional Files Loaded:', diff);
	                            }
	
	                            // Push everything to the file loader, it will weed out the duplicates.
	                            if (angular.isDefined(self.filesLoader)) {
	                                // if a files loader is defined
	                                promisesList.push(self.filesLoader(requireEntry, localParams).then(function () {
	                                    return self._loadDependencies(requireEntry);
	                                }));
	                            } else {
	                                return reject(new Error('Error: New dependencies need to be loaded from external files (' + requireEntry.files + '), but no loader has been defined.'));
	                            }
	                            return;
	                        } else if (angular.isArray(requireEntry)) {
	                            var files = [];
	                            angular.forEach(requireEntry, function (entry) {
	                                // let's check if the entry is a file name or a config name
	                                var config = self.getModuleConfig(entry);
	                                if (config === null) {
	                                    files.push(entry);
	                                } else if (config.files) {
	                                    files = files.concat(config.files);
	                                }
	                            });
	                            if (files.length > 0) {
	                                requireEntry = {
	                                    files: files
	                                };
	                            }
	                        } else if (angular.isObject(requireEntry)) {
	                            if (requireEntry.hasOwnProperty('name') && requireEntry['name']) {
	                                // The dependency doesn't exist in the module cache and is a new configuration, so store and push it.
	                                self.setModuleConfig(requireEntry);
	                                moduleCache.push(requireEntry['name']);
	                            }
	                        }
	
	                        // Check if the dependency has any files that need to be loaded. If there are, push a new promise to the promise list.
	                        if (angular.isDefined(requireEntry.files) && requireEntry.files.length !== 0) {
	                            if (angular.isDefined(self.filesLoader)) {
	                                // if a files loader is defined
	                                promisesList.push(self.filesLoader(requireEntry, localParams).then(function () {
	                                    return self._loadDependencies(requireEntry);
	                                }));
	                            } else {
	                                return reject(new Error('Error: the module "' + requireEntry.name + '" is defined in external files (' + requireEntry.files + '), but no loader has been defined.'));
	                            }
	                        }
	                    });
	
	                    // Create a wrapper promise to watch the promise list and resolve it once everything is done.
	                    return $q.all(promisesList);
	                },
	
	                /**
	                 * Inject new modules into Angular
	                 * @param moduleName
	                 * @param localParams
	                 * @param real
	                 */
	                inject: function inject(moduleName) {
	                    var localParams = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	                    var real = arguments.length <= 2 || arguments[2] === undefined ? false : arguments[2];
	
	                    var self = this,
	                        deferred = $q.defer();
	                    if (angular.isDefined(moduleName) && moduleName !== null) {
	                        if (angular.isArray(moduleName)) {
	                            var promisesList = [];
	                            angular.forEach(moduleName, function (module) {
	                                promisesList.push(self.inject(module, localParams, real));
	                            });
	                            return $q.all(promisesList);
	                        } else {
	                            self._addToLoadList(self._getModuleName(moduleName), true, real);
	                        }
	                    }
	                    if (modulesToLoad.length > 0) {
	                        var res = modulesToLoad.slice(); // clean copy
	                        var loadNext = function loadNext(moduleName) {
	                            moduleCache.push(moduleName);
	                            modulePromises[moduleName] = deferred.promise;
	                            self._loadDependencies(moduleName, localParams).then(function success() {
	                                try {
	                                    justLoaded = [];
	                                    _register(providers, moduleCache, localParams);
	                                } catch (e) {
	                                    self._$log.error(e.message);
	                                    deferred.reject(e);
	                                    return;
	                                }
	
	                                if (modulesToLoad.length > 0) {
	                                    loadNext(modulesToLoad.shift()); // load the next in list
	                                } else {
	                                        deferred.resolve(res); // everything has been loaded, resolve
	                                    }
	                            }, function error(err) {
	                                deferred.reject(err);
	                            });
	                        };
	
	                        // load the first in list
	                        loadNext(modulesToLoad.shift());
	                    } else if (localParams && localParams.name && modulePromises[localParams.name]) {
	                        return modulePromises[localParams.name];
	                    } else {
	                        deferred.resolve();
	                    }
	                    return deferred.promise;
	                },
	
	                /**
	                 * Get the list of required modules/services/... for this module
	                 * @param module
	                 * @returns {Array}
	                 */
	                getRequires: function getRequires(module) {
	                    var requires = [];
	                    angular.forEach(module.requires, function (requireModule) {
	                        if (regModules.indexOf(requireModule) === -1) {
	                            requires.push(requireModule);
	                        }
	                    });
	                    return requires;
	                },
	
	                /**
	                 * Invoke the new modules & component by their providers
	                 * @param providers
	                 * @param queue
	                 * @param moduleName
	                 * @param reconfig
	                 * @private
	                 */
	                _invokeQueue: _invokeQueue,
	
	                /**
	                 * Check if a module has been invoked and registers it if not
	                 * @param args
	                 * @param moduleName
	                 * @returns {boolean} is new
	                 */
	                _registerInvokeList: _registerInvokeList,
	
	                /**
	                 * Register a new module and loads it, executing the run/config blocks if needed
	                 * @param providers
	                 * @param registerModules
	                 * @param params
	                 * @private
	                 */
	                _register: _register,
	
	                /**
	                 * Add a module name to the list of modules that will be loaded in the next inject
	                 * @param name
	                 * @param force
	                 * @private
	                 */
	                _addToLoadList: _addToLoadList,
	
	                /**
	                 * Unregister modules (you shouldn't have to use this)
	                 * @param modules
	                 */
	                _unregister: function _unregister(modules) {
	                    if (angular.isDefined(modules)) {
	                        if (angular.isArray(modules)) {
	                            angular.forEach(modules, function (module) {
	                                regInvokes[module] = undefined;
	                            });
	                        }
	                    }
	                }
	            };
	        }];
	
	        // Let's get the list of loaded modules & components
	        this._init(angular.element(window.document));
	    }]);
	
	    var bootstrapFct = angular.bootstrap;
	    angular.bootstrap = function (element, modules, config) {
	        // Clean state from previous bootstrap
	        regModules = ['ng', 'oc.lazyLoad'];
	        regInvokes = {};
	        regConfigs = [];
	        modulesToLoad = [];
	        realModules = [];
	        recordDeclarations = [];
	        broadcast = angular.noop;
	        runBlocks = {};
	        justLoaded = [];
	        // we use slice to make a clean copy
	        angular.forEach(modules.slice(), function (module) {
	            _addToLoadList(module, true, true);
	        });
	        return bootstrapFct(element, modules, config);
	    };
	
	    var _addToLoadList = function _addToLoadList(name, force, real) {
	        if ((recordDeclarations.length > 0 || force) && angular.isString(name) && modulesToLoad.indexOf(name) === -1) {
	            modulesToLoad.push(name);
	            if (real) {
	                realModules.push(name);
	            }
	        }
	    };
	
	    var ngModuleFct = angular.module;
	    angular.module = function (name, requires, configFn) {
	        _addToLoadList(name, false, true);
	        return ngModuleFct(name, requires, configFn);
	    };
	
	    // CommonJS package manager support:
	    if (typeof module !== 'undefined' && typeof exports !== 'undefined' && module.exports === exports) {
	        module.exports = 'oc.lazyLoad';
	    }
	})(angular, window);
	(function (angular) {
	    'use strict';
	
	    angular.module('oc.lazyLoad').directive('ocLazyLoad', ["$ocLazyLoad", "$compile", "$animate", "$parse", "$timeout", function ($ocLazyLoad, $compile, $animate, $parse, $timeout) {
	        return {
	            restrict: 'A',
	            terminal: true,
	            priority: 1000,
	            compile: function compile(element, attrs) {
	                // we store the content and remove it before compilation
	                var content = element[0].innerHTML;
	                element.html('');
	
	                return function ($scope, $element, $attr) {
	                    var model = $parse($attr.ocLazyLoad);
	                    $scope.$watch(function () {
	                        return model($scope) || $attr.ocLazyLoad; // it can be a module name (string), an object, an array, or a scope reference to any of this
	                    }, function (moduleName) {
	                        if (angular.isDefined(moduleName)) {
	                            $ocLazyLoad.load(moduleName).then(function () {
	                                // Attach element contents to DOM and then compile them.
	                                // This prevents an issue where IE invalidates saved element objects (HTMLCollections)
	                                // of the compiled contents when attaching to the parent DOM.
	                                $animate.enter(content, $element);
	                                // get the new content & compile it
	                                $compile($element.contents())($scope);
	                            });
	                        }
	                    }, true);
	                };
	            }
	        };
	    }]);
	})(angular);
	(function (angular) {
	    'use strict';
	
	    angular.module('oc.lazyLoad').config(["$provide", function ($provide) {
	        $provide.decorator('$ocLazyLoad', ["$delegate", "$q", "$window", "$interval", function ($delegate, $q, $window, $interval) {
	            var uaCssChecked = false,
	                useCssLoadPatch = false,
	                anchor = $window.document.getElementsByTagName('head')[0] || $window.document.getElementsByTagName('body')[0];
	
	            /**
	             * Load a js/css file
	             * @param type
	             * @param path
	             * @param params
	             * @returns promise
	             */
	            $delegate.buildElement = function buildElement(type, path, params) {
	                var deferred = $q.defer(),
	                    el,
	                    loaded,
	                    filesCache = $delegate._getFilesCache(),
	                    cacheBuster = function cacheBuster(url) {
	                    var dc = new Date().getTime();
	                    if (url.indexOf('?') >= 0) {
	                        if (url.substring(0, url.length - 1) === '&') {
	                            return url + '_dc=' + dc;
	                        }
	                        return url + '&_dc=' + dc;
	                    } else {
	                        return url + '?_dc=' + dc;
	                    }
	                };
	
	                // Store the promise early so the file load can be detected by other parallel lazy loads
	                // (ie: multiple routes on one page) a 'true' value isn't sufficient
	                // as it causes false positive load results.
	                if (angular.isUndefined(filesCache.get(path))) {
	                    filesCache.put(path, deferred.promise);
	                }
	
	                // Switch in case more content types are added later
	                switch (type) {
	                    case 'css':
	                        el = $window.document.createElement('link');
	                        el.type = 'text/css';
	                        el.rel = 'stylesheet';
	                        el.href = params.cache === false ? cacheBuster(path) : path;
	                        break;
	                    case 'js':
	                        el = $window.document.createElement('script');
	                        el.src = params.cache === false ? cacheBuster(path) : path;
	                        break;
	                    default:
	                        filesCache.remove(path);
	                        deferred.reject(new Error('Requested type "' + type + '" is not known. Could not inject "' + path + '"'));
	                        break;
	                }
	                el.onload = el['onreadystatechange'] = function (e) {
	                    if (el['readyState'] && !/^c|loade/.test(el['readyState']) || loaded) return;
	                    el.onload = el['onreadystatechange'] = null;
	                    loaded = 1;
	                    $delegate._broadcast('ocLazyLoad.fileLoaded', path);
	                    deferred.resolve(el);
	                };
	                el.onerror = function () {
	                    filesCache.remove(path);
	                    deferred.reject(new Error('Unable to load ' + path));
	                };
	                el.async = params.serie ? 0 : 1;
	
	                var insertBeforeElem = anchor.lastChild;
	                if (params.insertBefore) {
	                    var element = angular.element(angular.isDefined(window.jQuery) ? params.insertBefore : document.querySelector(params.insertBefore));
	                    if (element && element.length > 0) {
	                        insertBeforeElem = element[0];
	                    }
	                }
	                insertBeforeElem.parentNode.insertBefore(el, insertBeforeElem);
	
	                /*
	                 The event load or readystatechange doesn't fire in:
	                 - PhantomJS 1.9 (headless webkit browser)
	                 - iOS < 6       (default mobile browser)
	                 - Android < 4.4 (default mobile browser)
	                 - Safari < 6    (desktop browser)
	                 */
	                if (type == 'css') {
	                    if (!uaCssChecked) {
	                        var ua = $window.navigator.userAgent.toLowerCase();
	
	                        if (ua.indexOf('phantomjs/1.9') > -1) {
	                            // PhantomJS ~1.9
	                            useCssLoadPatch = true;
	                        } else if (/iP(hone|od|ad)/.test($window.navigator.platform)) {
	                            // iOS < 6
	                            var v = $window.navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/);
	                            var iOSVersion = parseFloat([parseInt(v[1], 10), parseInt(v[2], 10), parseInt(v[3] || 0, 10)].join('.'));
	                            useCssLoadPatch = iOSVersion < 6;
	                        } else if (ua.indexOf('android') > -1) {
	                            // Android < 4.4
	                            var androidVersion = parseFloat(ua.slice(ua.indexOf('android') + 8));
	                            useCssLoadPatch = androidVersion < 4.4;
	                        } else if (ua.indexOf('safari') > -1) {
	                            // Safari < 6
	                            var versionMatch = ua.match(/version\/([\.\d]+)/i);
	                            useCssLoadPatch = versionMatch && versionMatch[1] && parseFloat(versionMatch[1]) < 6;
	                        }
	                    }
	
	                    if (useCssLoadPatch) {
	                        var tries = 1000; // * 20 = 20000 miliseconds
	                        var interval = $interval(function () {
	                            try {
	                                el.sheet.cssRules;
	                                $interval.cancel(interval);
	                                el.onload();
	                            } catch (e) {
	                                if (--tries <= 0) {
	                                    el.onerror();
	                                }
	                            }
	                        }, 20);
	                    }
	                }
	
	                return deferred.promise;
	            };
	
	            return $delegate;
	        }]);
	    }]);
	})(angular);
	(function (angular) {
	    'use strict';
	
	    angular.module('oc.lazyLoad').config(["$provide", function ($provide) {
	        $provide.decorator('$ocLazyLoad', ["$delegate", "$q", function ($delegate, $q) {
	            /**
	             * The function that loads new files
	             * @param config
	             * @param params
	             * @returns {*}
	             */
	            $delegate.filesLoader = function filesLoader(config) {
	                var params = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	                var cssFiles = [],
	                    templatesFiles = [],
	                    jsFiles = [],
	                    promises = [],
	                    cachePromise = null,
	                    filesCache = $delegate._getFilesCache();
	
	                $delegate.toggleWatch(true); // start watching angular.module calls
	
	                angular.extend(params, config);
	
	                var pushFile = function pushFile(path) {
	                    var file_type = null,
	                        m;
	                    if (angular.isObject(path)) {
	                        file_type = path.type;
	                        path = path.path;
	                    }
	                    cachePromise = filesCache.get(path);
	                    if (angular.isUndefined(cachePromise) || params.cache === false) {
	
	                        // always check for requirejs syntax just in case
	                        if ((m = /^(css|less|html|htm|js)?(?=!)/.exec(path)) !== null) {
	                            // Detect file type using preceding type declaration (ala requireJS)
	                            file_type = m[1];
	                            path = path.substr(m[1].length + 1, path.length); // Strip the type from the path
	                        }
	
	                        if (!file_type) {
	                            if ((m = /[.](css|less|html|htm|js)?((\?|#).*)?$/.exec(path)) !== null) {
	                                // Detect file type via file extension
	                                file_type = m[1];
	                            } else if (!$delegate.jsLoader.hasOwnProperty('ocLazyLoadLoader') && $delegate.jsLoader.hasOwnProperty('requirejs')) {
	                                // requirejs
	                                file_type = 'js';
	                            } else {
	                                $delegate._$log.error('File type could not be determined. ' + path);
	                                return;
	                            }
	                        }
	
	                        if ((file_type === 'css' || file_type === 'less') && cssFiles.indexOf(path) === -1) {
	                            cssFiles.push(path);
	                        } else if ((file_type === 'html' || file_type === 'htm') && templatesFiles.indexOf(path) === -1) {
	                            templatesFiles.push(path);
	                        } else if (file_type === 'js' || jsFiles.indexOf(path) === -1) {
	                            jsFiles.push(path);
	                        } else {
	                            $delegate._$log.error('File type is not valid. ' + path);
	                        }
	                    } else if (cachePromise) {
	                        promises.push(cachePromise);
	                    }
	                };
	
	                if (params.serie) {
	                    pushFile(params.files.shift());
	                } else {
	                    angular.forEach(params.files, function (path) {
	                        pushFile(path);
	                    });
	                }
	
	                if (cssFiles.length > 0) {
	                    var cssDeferred = $q.defer();
	                    $delegate.cssLoader(cssFiles, function (err) {
	                        if (angular.isDefined(err) && $delegate.cssLoader.hasOwnProperty('ocLazyLoadLoader')) {
	                            $delegate._$log.error(err);
	                            cssDeferred.reject(err);
	                        } else {
	                            cssDeferred.resolve();
	                        }
	                    }, params);
	                    promises.push(cssDeferred.promise);
	                }
	
	                if (templatesFiles.length > 0) {
	                    var templatesDeferred = $q.defer();
	                    $delegate.templatesLoader(templatesFiles, function (err) {
	                        if (angular.isDefined(err) && $delegate.templatesLoader.hasOwnProperty('ocLazyLoadLoader')) {
	                            $delegate._$log.error(err);
	                            templatesDeferred.reject(err);
	                        } else {
	                            templatesDeferred.resolve();
	                        }
	                    }, params);
	                    promises.push(templatesDeferred.promise);
	                }
	
	                if (jsFiles.length > 0) {
	                    var jsDeferred = $q.defer();
	                    $delegate.jsLoader(jsFiles, function (err) {
	                        if (angular.isDefined(err) && ($delegate.jsLoader.hasOwnProperty("ocLazyLoadLoader") || $delegate.jsLoader.hasOwnProperty("requirejs"))) {
	                            $delegate._$log.error(err);
	                            jsDeferred.reject(err);
	                        } else {
	                            jsDeferred.resolve();
	                        }
	                    }, params);
	                    promises.push(jsDeferred.promise);
	                }
	
	                if (promises.length === 0) {
	                    var deferred = $q.defer(),
	                        err = "Error: no file to load has been found, if you're trying to load an existing module you should use the 'inject' method instead of 'load'.";
	                    $delegate._$log.error(err);
	                    deferred.reject(err);
	                    return deferred.promise;
	                } else if (params.serie && params.files.length > 0) {
	                    return $q.all(promises).then(function () {
	                        return $delegate.filesLoader(config, params);
	                    });
	                } else {
	                    return $q.all(promises)['finally'](function (res) {
	                        $delegate.toggleWatch(false); // stop watching angular.module calls
	                        return res;
	                    });
	                }
	            };
	
	            /**
	             * Load a module or a list of modules into Angular
	             * @param module Mixed the name of a predefined module config object, or a module config object, or an array of either
	             * @param params Object optional parameters
	             * @returns promise
	             */
	            $delegate.load = function (originalModule) {
	                var originalParams = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	                var self = this,
	                    config = null,
	                    deferredList = [],
	                    deferred = $q.defer(),
	                    errText;
	
	                // clean copy
	                var module = angular.copy(originalModule);
	                var params = angular.copy(originalParams);
	
	                // If module is an array, break it down
	                if (angular.isArray(module)) {
	                    // Resubmit each entry as a single module
	                    angular.forEach(module, function (m) {
	                        deferredList.push(self.load(m, params));
	                    });
	
	                    // Resolve the promise once everything has loaded
	                    $q.all(deferredList).then(function (res) {
	                        deferred.resolve(res);
	                    }, function (err) {
	                        deferred.reject(err);
	                    });
	
	                    return deferred.promise;
	                }
	
	                // Get or Set a configuration depending on what was passed in
	                if (angular.isString(module)) {
	                    config = self.getModuleConfig(module);
	                    if (!config) {
	                        config = {
	                            files: [module]
	                        };
	                    }
	                } else if (angular.isObject(module)) {
	                    // case {type: 'js', path: lazyLoadUrl + 'testModule.fakejs'}
	                    if (angular.isDefined(module.path) && angular.isDefined(module.type)) {
	                        config = {
	                            files: [module]
	                        };
	                    } else {
	                        config = self.setModuleConfig(module);
	                    }
	                }
	
	                if (config === null) {
	                    var moduleName = self._getModuleName(module);
	                    errText = 'Module "' + (moduleName || 'unknown') + '" is not configured, cannot load.';
	                    $delegate._$log.error(errText);
	                    deferred.reject(new Error(errText));
	                    return deferred.promise;
	                } else {
	                    // deprecated
	                    if (angular.isDefined(config.template)) {
	                        if (angular.isUndefined(config.files)) {
	                            config.files = [];
	                        }
	                        if (angular.isString(config.template)) {
	                            config.files.push(config.template);
	                        } else if (angular.isArray(config.template)) {
	                            config.files.concat(config.template);
	                        }
	                    }
	                }
	
	                var localParams = angular.extend({}, params, config);
	
	                // if someone used an external loader and called the load function with just the module name
	                if (angular.isUndefined(config.files) && angular.isDefined(config.name) && $delegate.moduleExists(config.name)) {
	                    return $delegate.inject(config.name, localParams, true);
	                }
	
	                $delegate.filesLoader(config, localParams).then(function () {
	                    $delegate.inject(null, localParams).then(function (res) {
	                        deferred.resolve(res);
	                    }, function (err) {
	                        deferred.reject(err);
	                    });
	                }, function (err) {
	                    deferred.reject(err);
	                });
	
	                return deferred.promise;
	            };
	
	            // return the patched service
	            return $delegate;
	        }]);
	    }]);
	})(angular);
	(function (angular) {
	    'use strict';
	
	    angular.module('oc.lazyLoad').config(["$provide", function ($provide) {
	        $provide.decorator('$ocLazyLoad', ["$delegate", "$q", function ($delegate, $q) {
	            /**
	             * cssLoader function
	             * @type Function
	             * @param paths array list of css files to load
	             * @param callback to call when everything is loaded. We use a callback and not a promise
	             * @param params object config parameters
	             * because the user can overwrite cssLoader and it will probably not use promises :(
	             */
	            $delegate.cssLoader = function (paths, callback, params) {
	                var promises = [];
	                angular.forEach(paths, function (path) {
	                    promises.push($delegate.buildElement('css', path, params));
	                });
	                $q.all(promises).then(function () {
	                    callback();
	                }, function (err) {
	                    callback(err);
	                });
	            };
	            $delegate.cssLoader.ocLazyLoadLoader = true;
	
	            return $delegate;
	        }]);
	    }]);
	})(angular);
	(function (angular) {
	    'use strict';
	
	    angular.module('oc.lazyLoad').config(["$provide", function ($provide) {
	        $provide.decorator('$ocLazyLoad', ["$delegate", "$q", function ($delegate, $q) {
	            /**
	             * jsLoader function
	             * @type Function
	             * @param paths array list of js files to load
	             * @param callback to call when everything is loaded. We use a callback and not a promise
	             * @param params object config parameters
	             * because the user can overwrite jsLoader and it will probably not use promises :(
	             */
	            $delegate.jsLoader = function (paths, callback, params) {
	                var promises = [];
	                angular.forEach(paths, function (path) {
	                    promises.push($delegate.buildElement('js', path, params));
	                });
	                $q.all(promises).then(function () {
	                    callback();
	                }, function (err) {
	                    callback(err);
	                });
	            };
	            $delegate.jsLoader.ocLazyLoadLoader = true;
	
	            return $delegate;
	        }]);
	    }]);
	})(angular);
	(function (angular) {
	    'use strict';
	
	    angular.module('oc.lazyLoad').config(["$provide", function ($provide) {
	        $provide.decorator('$ocLazyLoad', ["$delegate", "$templateCache", "$q", "$http", function ($delegate, $templateCache, $q, $http) {
	            /**
	             * templatesLoader function
	             * @type Function
	             * @param paths array list of css files to load
	             * @param callback to call when everything is loaded. We use a callback and not a promise
	             * @param params object config parameters for $http
	             * because the user can overwrite templatesLoader and it will probably not use promises :(
	             */
	            $delegate.templatesLoader = function (paths, callback, params) {
	                var promises = [],
	                    filesCache = $delegate._getFilesCache();
	
	                angular.forEach(paths, function (url) {
	                    var deferred = $q.defer();
	                    promises.push(deferred.promise);
	                    $http.get(url, params).then(function (response) {
	                        var data = response.data;
	                        if (angular.isString(data) && data.length > 0) {
	                            angular.forEach(angular.element(data), function (node) {
	                                if (node.nodeName === 'SCRIPT' && node.type === 'text/ng-template') {
	                                    $templateCache.put(node.id, node.innerHTML);
	                                }
	                            });
	                        }
	                        if (angular.isUndefined(filesCache.get(url))) {
	                            filesCache.put(url, true);
	                        }
	                        deferred.resolve();
	                    })['catch'](function (response) {
	                        deferred.reject(new Error('Unable to load template file "' + url + '": ' + response.data));
	                    });
	                });
	                return $q.all(promises).then(function () {
	                    callback();
	                }, function (err) {
	                    callback(err);
	                });
	            };
	            $delegate.templatesLoader.ocLazyLoadLoader = true;
	
	            return $delegate;
	        }]);
	    }]);
	})(angular);
	// Array.indexOf polyfill for IE8
	if (!Array.prototype.indexOf) {
	        Array.prototype.indexOf = function (searchElement, fromIndex) {
	                var k;
	
	                // 1. Let O be the result of calling ToObject passing
	                //    the this value as the argument.
	                if (this == null) {
	                        throw new TypeError('"this" is null or not defined');
	                }
	
	                var O = Object(this);
	
	                // 2. Let lenValue be the result of calling the Get
	                //    internal method of O with the argument "length".
	                // 3. Let len be ToUint32(lenValue).
	                var len = O.length >>> 0;
	
	                // 4. If len is 0, return -1.
	                if (len === 0) {
	                        return -1;
	                }
	
	                // 5. If argument fromIndex was passed let n be
	                //    ToInteger(fromIndex); else let n be 0.
	                var n = +fromIndex || 0;
	
	                if (Math.abs(n) === Infinity) {
	                        n = 0;
	                }
	
	                // 6. If n >= len, return -1.
	                if (n >= len) {
	                        return -1;
	                }
	
	                // 7. If n >= 0, then Let k be n.
	                // 8. Else, n<0, Let k be len - abs(n).
	                //    If k is less than 0, then let k be 0.
	                k = Math.max(n >= 0 ? n : len - Math.abs(n), 0);
	
	                // 9. Repeat, while k < len
	                while (k < len) {
	                        // a. Let Pk be ToString(k).
	                        //   This is implicit for LHS operands of the in operator
	                        // b. Let kPresent be the result of calling the
	                        //    HasProperty internal method of O with argument Pk.
	                        //   This step can be combined with c
	                        // c. If kPresent is true, then
	                        //    i.  Let elementK be the result of calling the Get
	                        //        internal method of O with the argument ToString(k).
	                        //   ii.  Let same be the result of applying the
	                        //        Strict Equality Comparison Algorithm to
	                        //        searchElement and elementK.
	                        //  iii.  If same is true, return k.
	                        if (k in O && O[k] === searchElement) {
	                                return k;
	                        }
	                        k++;
	                }
	                return -1;
	        };
	}

/***/ }),
/* 1127 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__.p = window.resourceBaseUrl;


/***/ }),
/* 1128 */
/***/ (function(module, exports) {

	/**
	 * @license AngularJS v1.5.6
	 * (c) 2010-2016 Google, Inc. http://angularjs.org
	 * License: MIT
	 */
	(function(window, angular) {'use strict';
	
	/* jshint ignore:start */
	var noop        = angular.noop;
	var copy        = angular.copy;
	var extend      = angular.extend;
	var jqLite      = angular.element;
	var forEach     = angular.forEach;
	var isArray     = angular.isArray;
	var isString    = angular.isString;
	var isObject    = angular.isObject;
	var isUndefined = angular.isUndefined;
	var isDefined   = angular.isDefined;
	var isFunction  = angular.isFunction;
	var isElement   = angular.isElement;
	
	var ELEMENT_NODE = 1;
	var COMMENT_NODE = 8;
	
	var ADD_CLASS_SUFFIX = '-add';
	var REMOVE_CLASS_SUFFIX = '-remove';
	var EVENT_CLASS_PREFIX = 'ng-';
	var ACTIVE_CLASS_SUFFIX = '-active';
	var PREPARE_CLASS_SUFFIX = '-prepare';
	
	var NG_ANIMATE_CLASSNAME = 'ng-animate';
	var NG_ANIMATE_CHILDREN_DATA = '$$ngAnimateChildren';
	
	// Detect proper transitionend/animationend event names.
	var CSS_PREFIX = '', TRANSITION_PROP, TRANSITIONEND_EVENT, ANIMATION_PROP, ANIMATIONEND_EVENT;
	
	// If unprefixed events are not supported but webkit-prefixed are, use the latter.
	// Otherwise, just use W3C names, browsers not supporting them at all will just ignore them.
	// Note: Chrome implements `window.onwebkitanimationend` and doesn't implement `window.onanimationend`
	// but at the same time dispatches the `animationend` event and not `webkitAnimationEnd`.
	// Register both events in case `window.onanimationend` is not supported because of that,
	// do the same for `transitionend` as Safari is likely to exhibit similar behavior.
	// Also, the only modern browser that uses vendor prefixes for transitions/keyframes is webkit
	// therefore there is no reason to test anymore for other vendor prefixes:
	// http://caniuse.com/#search=transition
	if (isUndefined(window.ontransitionend) && isDefined(window.onwebkittransitionend)) {
	  CSS_PREFIX = '-webkit-';
	  TRANSITION_PROP = 'WebkitTransition';
	  TRANSITIONEND_EVENT = 'webkitTransitionEnd transitionend';
	} else {
	  TRANSITION_PROP = 'transition';
	  TRANSITIONEND_EVENT = 'transitionend';
	}
	
	if (isUndefined(window.onanimationend) && isDefined(window.onwebkitanimationend)) {
	  CSS_PREFIX = '-webkit-';
	  ANIMATION_PROP = 'WebkitAnimation';
	  ANIMATIONEND_EVENT = 'webkitAnimationEnd animationend';
	} else {
	  ANIMATION_PROP = 'animation';
	  ANIMATIONEND_EVENT = 'animationend';
	}
	
	var DURATION_KEY = 'Duration';
	var PROPERTY_KEY = 'Property';
	var DELAY_KEY = 'Delay';
	var TIMING_KEY = 'TimingFunction';
	var ANIMATION_ITERATION_COUNT_KEY = 'IterationCount';
	var ANIMATION_PLAYSTATE_KEY = 'PlayState';
	var SAFE_FAST_FORWARD_DURATION_VALUE = 9999;
	
	var ANIMATION_DELAY_PROP = ANIMATION_PROP + DELAY_KEY;
	var ANIMATION_DURATION_PROP = ANIMATION_PROP + DURATION_KEY;
	var TRANSITION_DELAY_PROP = TRANSITION_PROP + DELAY_KEY;
	var TRANSITION_DURATION_PROP = TRANSITION_PROP + DURATION_KEY;
	
	var isPromiseLike = function(p) {
	  return p && p.then ? true : false;
	};
	
	var ngMinErr = angular.$$minErr('ng');
	function assertArg(arg, name, reason) {
	  if (!arg) {
	    throw ngMinErr('areq', "Argument '{0}' is {1}", (name || '?'), (reason || "required"));
	  }
	  return arg;
	}
	
	function mergeClasses(a,b) {
	  if (!a && !b) return '';
	  if (!a) return b;
	  if (!b) return a;
	  if (isArray(a)) a = a.join(' ');
	  if (isArray(b)) b = b.join(' ');
	  return a + ' ' + b;
	}
	
	function packageStyles(options) {
	  var styles = {};
	  if (options && (options.to || options.from)) {
	    styles.to = options.to;
	    styles.from = options.from;
	  }
	  return styles;
	}
	
	function pendClasses(classes, fix, isPrefix) {
	  var className = '';
	  classes = isArray(classes)
	      ? classes
	      : classes && isString(classes) && classes.length
	          ? classes.split(/\s+/)
	          : [];
	  forEach(classes, function(klass, i) {
	    if (klass && klass.length > 0) {
	      className += (i > 0) ? ' ' : '';
	      className += isPrefix ? fix + klass
	                            : klass + fix;
	    }
	  });
	  return className;
	}
	
	function removeFromArray(arr, val) {
	  var index = arr.indexOf(val);
	  if (val >= 0) {
	    arr.splice(index, 1);
	  }
	}
	
	function stripCommentsFromElement(element) {
	  if (element instanceof jqLite) {
	    switch (element.length) {
	      case 0:
	        return element;
	        break;
	
	      case 1:
	        // there is no point of stripping anything if the element
	        // is the only element within the jqLite wrapper.
	        // (it's important that we retain the element instance.)
	        if (element[0].nodeType === ELEMENT_NODE) {
	          return element;
	        }
	        break;
	
	      default:
	        return jqLite(extractElementNode(element));
	        break;
	    }
	  }
	
	  if (element.nodeType === ELEMENT_NODE) {
	    return jqLite(element);
	  }
	}
	
	function extractElementNode(element) {
	  if (!element[0]) return element;
	  for (var i = 0; i < element.length; i++) {
	    var elm = element[i];
	    if (elm.nodeType == ELEMENT_NODE) {
	      return elm;
	    }
	  }
	}
	
	function $$addClass($$jqLite, element, className) {
	  forEach(element, function(elm) {
	    $$jqLite.addClass(elm, className);
	  });
	}
	
	function $$removeClass($$jqLite, element, className) {
	  forEach(element, function(elm) {
	    $$jqLite.removeClass(elm, className);
	  });
	}
	
	function applyAnimationClassesFactory($$jqLite) {
	  return function(element, options) {
	    if (options.addClass) {
	      $$addClass($$jqLite, element, options.addClass);
	      options.addClass = null;
	    }
	    if (options.removeClass) {
	      $$removeClass($$jqLite, element, options.removeClass);
	      options.removeClass = null;
	    }
	  }
	}
	
	function prepareAnimationOptions(options) {
	  options = options || {};
	  if (!options.$$prepared) {
	    var domOperation = options.domOperation || noop;
	    options.domOperation = function() {
	      options.$$domOperationFired = true;
	      domOperation();
	      domOperation = noop;
	    };
	    options.$$prepared = true;
	  }
	  return options;
	}
	
	function applyAnimationStyles(element, options) {
	  applyAnimationFromStyles(element, options);
	  applyAnimationToStyles(element, options);
	}
	
	function applyAnimationFromStyles(element, options) {
	  if (options.from) {
	    element.css(options.from);
	    options.from = null;
	  }
	}
	
	function applyAnimationToStyles(element, options) {
	  if (options.to) {
	    element.css(options.to);
	    options.to = null;
	  }
	}
	
	function mergeAnimationDetails(element, oldAnimation, newAnimation) {
	  var target = oldAnimation.options || {};
	  var newOptions = newAnimation.options || {};
	
	  var toAdd = (target.addClass || '') + ' ' + (newOptions.addClass || '');
	  var toRemove = (target.removeClass || '') + ' ' + (newOptions.removeClass || '');
	  var classes = resolveElementClasses(element.attr('class'), toAdd, toRemove);
	
	  if (newOptions.preparationClasses) {
	    target.preparationClasses = concatWithSpace(newOptions.preparationClasses, target.preparationClasses);
	    delete newOptions.preparationClasses;
	  }
	
	  // noop is basically when there is no callback; otherwise something has been set
	  var realDomOperation = target.domOperation !== noop ? target.domOperation : null;
	
	  extend(target, newOptions);
	
	  // TODO(matsko or sreeramu): proper fix is to maintain all animation callback in array and call at last,but now only leave has the callback so no issue with this.
	  if (realDomOperation) {
	    target.domOperation = realDomOperation;
	  }
	
	  if (classes.addClass) {
	    target.addClass = classes.addClass;
	  } else {
	    target.addClass = null;
	  }
	
	  if (classes.removeClass) {
	    target.removeClass = classes.removeClass;
	  } else {
	    target.removeClass = null;
	  }
	
	  oldAnimation.addClass = target.addClass;
	  oldAnimation.removeClass = target.removeClass;
	
	  return target;
	}
	
	function resolveElementClasses(existing, toAdd, toRemove) {
	  var ADD_CLASS = 1;
	  var REMOVE_CLASS = -1;
	
	  var flags = {};
	  existing = splitClassesToLookup(existing);
	
	  toAdd = splitClassesToLookup(toAdd);
	  forEach(toAdd, function(value, key) {
	    flags[key] = ADD_CLASS;
	  });
	
	  toRemove = splitClassesToLookup(toRemove);
	  forEach(toRemove, function(value, key) {
	    flags[key] = flags[key] === ADD_CLASS ? null : REMOVE_CLASS;
	  });
	
	  var classes = {
	    addClass: '',
	    removeClass: ''
	  };
	
	  forEach(flags, function(val, klass) {
	    var prop, allow;
	    if (val === ADD_CLASS) {
	      prop = 'addClass';
	      allow = !existing[klass];
	    } else if (val === REMOVE_CLASS) {
	      prop = 'removeClass';
	      allow = existing[klass];
	    }
	    if (allow) {
	      if (classes[prop].length) {
	        classes[prop] += ' ';
	      }
	      classes[prop] += klass;
	    }
	  });
	
	  function splitClassesToLookup(classes) {
	    if (isString(classes)) {
	      classes = classes.split(' ');
	    }
	
	    var obj = {};
	    forEach(classes, function(klass) {
	      // sometimes the split leaves empty string values
	      // incase extra spaces were applied to the options
	      if (klass.length) {
	        obj[klass] = true;
	      }
	    });
	    return obj;
	  }
	
	  return classes;
	}
	
	function getDomNode(element) {
	  return (element instanceof angular.element) ? element[0] : element;
	}
	
	function applyGeneratedPreparationClasses(element, event, options) {
	  var classes = '';
	  if (event) {
	    classes = pendClasses(event, EVENT_CLASS_PREFIX, true);
	  }
	  if (options.addClass) {
	    classes = concatWithSpace(classes, pendClasses(options.addClass, ADD_CLASS_SUFFIX));
	  }
	  if (options.removeClass) {
	    classes = concatWithSpace(classes, pendClasses(options.removeClass, REMOVE_CLASS_SUFFIX));
	  }
	  if (classes.length) {
	    options.preparationClasses = classes;
	    element.addClass(classes);
	  }
	}
	
	function clearGeneratedClasses(element, options) {
	  if (options.preparationClasses) {
	    element.removeClass(options.preparationClasses);
	    options.preparationClasses = null;
	  }
	  if (options.activeClasses) {
	    element.removeClass(options.activeClasses);
	    options.activeClasses = null;
	  }
	}
	
	function blockTransitions(node, duration) {
	  // we use a negative delay value since it performs blocking
	  // yet it doesn't kill any existing transitions running on the
	  // same element which makes this safe for class-based animations
	  var value = duration ? '-' + duration + 's' : '';
	  applyInlineStyle(node, [TRANSITION_DELAY_PROP, value]);
	  return [TRANSITION_DELAY_PROP, value];
	}
	
	function blockKeyframeAnimations(node, applyBlock) {
	  var value = applyBlock ? 'paused' : '';
	  var key = ANIMATION_PROP + ANIMATION_PLAYSTATE_KEY;
	  applyInlineStyle(node, [key, value]);
	  return [key, value];
	}
	
	function applyInlineStyle(node, styleTuple) {
	  var prop = styleTuple[0];
	  var value = styleTuple[1];
	  node.style[prop] = value;
	}
	
	function concatWithSpace(a,b) {
	  if (!a) return b;
	  if (!b) return a;
	  return a + ' ' + b;
	}
	
	var $$rAFSchedulerFactory = ['$$rAF', function($$rAF) {
	  var queue, cancelFn;
	
	  function scheduler(tasks) {
	    // we make a copy since RAFScheduler mutates the state
	    // of the passed in array variable and this would be difficult
	    // to track down on the outside code
	    queue = queue.concat(tasks);
	    nextTick();
	  }
	
	  queue = scheduler.queue = [];
	
	  /* waitUntilQuiet does two things:
	   * 1. It will run the FINAL `fn` value only when an uncanceled RAF has passed through
	   * 2. It will delay the next wave of tasks from running until the quiet `fn` has run.
	   *
	   * The motivation here is that animation code can request more time from the scheduler
	   * before the next wave runs. This allows for certain DOM properties such as classes to
	   * be resolved in time for the next animation to run.
	   */
	  scheduler.waitUntilQuiet = function(fn) {
	    if (cancelFn) cancelFn();
	
	    cancelFn = $$rAF(function() {
	      cancelFn = null;
	      fn();
	      nextTick();
	    });
	  };
	
	  return scheduler;
	
	  function nextTick() {
	    if (!queue.length) return;
	
	    var items = queue.shift();
	    for (var i = 0; i < items.length; i++) {
	      items[i]();
	    }
	
	    if (!cancelFn) {
	      $$rAF(function() {
	        if (!cancelFn) nextTick();
	      });
	    }
	  }
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngAnimateChildren
	 * @restrict AE
	 * @element ANY
	 *
	 * @description
	 *
	 * ngAnimateChildren allows you to specify that children of this element should animate even if any
	 * of the children's parents are currently animating. By default, when an element has an active `enter`, `leave`, or `move`
	 * (structural) animation, child elements that also have an active structural animation are not animated.
	 *
	 * Note that even if `ngAnimteChildren` is set, no child animations will run when the parent element is removed from the DOM (`leave` animation).
	 *
	 *
	 * @param {string} ngAnimateChildren If the value is empty, `true` or `on`,
	 *     then child animations are allowed. If the value is `false`, child animations are not allowed.
	 *
	 * @example
	 * <example module="ngAnimateChildren" name="ngAnimateChildren" deps="angular-animate.js" animations="true">
	     <file name="index.html">
	       <div ng-controller="mainController as main">
	         <label>Show container? <input type="checkbox" ng-model="main.enterElement" /></label>
	         <label>Animate children? <input type="checkbox" ng-model="main.animateChildren" /></label>
	         <hr>
	         <div ng-animate-children="{{main.animateChildren}}">
	           <div ng-if="main.enterElement" class="container">
	             List of items:
	             <div ng-repeat="item in [0, 1, 2, 3]" class="item">Item {{item}}</div>
	           </div>
	         </div>
	       </div>
	     </file>
	     <file name="animations.css">
	
	      .container.ng-enter,
	      .container.ng-leave {
	        transition: all ease 1.5s;
	      }
	
	      .container.ng-enter,
	      .container.ng-leave-active {
	        opacity: 0;
	      }
	
	      .container.ng-leave,
	      .container.ng-enter-active {
	        opacity: 1;
	      }
	
	      .item {
	        background: firebrick;
	        color: #FFF;
	        margin-bottom: 10px;
	      }
	
	      .item.ng-enter,
	      .item.ng-leave {
	        transition: transform 1.5s ease;
	      }
	
	      .item.ng-enter {
	        transform: translateX(50px);
	      }
	
	      .item.ng-enter-active {
	        transform: translateX(0);
	      }
	    </file>
	    <file name="script.js">
	      angular.module('ngAnimateChildren', ['ngAnimate'])
	        .controller('mainController', function() {
	          this.animateChildren = false;
	          this.enterElement = false;
	        });
	    </file>
	  </example>
	 */
	var $$AnimateChildrenDirective = ['$interpolate', function($interpolate) {
	  return {
	    link: function(scope, element, attrs) {
	      var val = attrs.ngAnimateChildren;
	      if (angular.isString(val) && val.length === 0) { //empty attribute
	        element.data(NG_ANIMATE_CHILDREN_DATA, true);
	      } else {
	        // Interpolate and set the value, so that it is available to
	        // animations that run right after compilation
	        setData($interpolate(val)(scope));
	        attrs.$observe('ngAnimateChildren', setData);
	      }
	
	      function setData(value) {
	        value = value === 'on' || value === 'true';
	        element.data(NG_ANIMATE_CHILDREN_DATA, value);
	      }
	    }
	  };
	}];
	
	var ANIMATE_TIMER_KEY = '$$animateCss';
	
	/**
	 * @ngdoc service
	 * @name $animateCss
	 * @kind object
	 *
	 * @description
	 * The `$animateCss` service is a useful utility to trigger customized CSS-based transitions/keyframes
	 * from a JavaScript-based animation or directly from a directive. The purpose of `$animateCss` is NOT
	 * to side-step how `$animate` and ngAnimate work, but the goal is to allow pre-existing animations or
	 * directives to create more complex animations that can be purely driven using CSS code.
	 *
	 * Note that only browsers that support CSS transitions and/or keyframe animations are capable of
	 * rendering animations triggered via `$animateCss` (bad news for IE9 and lower).
	 *
	 * ## Usage
	 * Once again, `$animateCss` is designed to be used inside of a registered JavaScript animation that
	 * is powered by ngAnimate. It is possible to use `$animateCss` directly inside of a directive, however,
	 * any automatic control over cancelling animations and/or preventing animations from being run on
	 * child elements will not be handled by Angular. For this to work as expected, please use `$animate` to
	 * trigger the animation and then setup a JavaScript animation that injects `$animateCss` to trigger
	 * the CSS animation.
	 *
	 * The example below shows how we can create a folding animation on an element using `ng-if`:
	 *
	 * ```html
	 * <!-- notice the `fold-animation` CSS class -->
	 * <div ng-if="onOff" class="fold-animation">
	 *   This element will go BOOM
	 * </div>
	 * <button ng-click="onOff=true">Fold In</button>
	 * ```
	 *
	 * Now we create the **JavaScript animation** that will trigger the CSS transition:
	 *
	 * ```js
	 * ngModule.animation('.fold-animation', ['$animateCss', function($animateCss) {
	 *   return {
	 *     enter: function(element, doneFn) {
	 *       var height = element[0].offsetHeight;
	 *       return $animateCss(element, {
	 *         from: { height:'0px' },
	 *         to: { height:height + 'px' },
	 *         duration: 1 // one second
	 *       });
	 *     }
	 *   }
	 * }]);
	 * ```
	 *
	 * ## More Advanced Uses
	 *
	 * `$animateCss` is the underlying code that ngAnimate uses to power **CSS-based animations** behind the scenes. Therefore CSS hooks
	 * like `.ng-EVENT`, `.ng-EVENT-active`, `.ng-EVENT-stagger` are all features that can be triggered using `$animateCss` via JavaScript code.
	 *
	 * This also means that just about any combination of adding classes, removing classes, setting styles, dynamically setting a keyframe animation,
	 * applying a hardcoded duration or delay value, changing the animation easing or applying a stagger animation are all options that work with
	 * `$animateCss`. The service itself is smart enough to figure out the combination of options and examine the element styling properties in order
	 * to provide a working animation that will run in CSS.
	 *
	 * The example below showcases a more advanced version of the `.fold-animation` from the example above:
	 *
	 * ```js
	 * ngModule.animation('.fold-animation', ['$animateCss', function($animateCss) {
	 *   return {
	 *     enter: function(element, doneFn) {
	 *       var height = element[0].offsetHeight;
	 *       return $animateCss(element, {
	 *         addClass: 'red large-text pulse-twice',
	 *         easing: 'ease-out',
	 *         from: { height:'0px' },
	 *         to: { height:height + 'px' },
	 *         duration: 1 // one second
	 *       });
	 *     }
	 *   }
	 * }]);
	 * ```
	 *
	 * Since we're adding/removing CSS classes then the CSS transition will also pick those up:
	 *
	 * ```css
	 * /&#42; since a hardcoded duration value of 1 was provided in the JavaScript animation code,
	 * the CSS classes below will be transitioned despite them being defined as regular CSS classes &#42;/
	 * .red { background:red; }
	 * .large-text { font-size:20px; }
	 *
	 * /&#42; we can also use a keyframe animation and $animateCss will make it work alongside the transition &#42;/
	 * .pulse-twice {
	 *   animation: 0.5s pulse linear 2;
	 *   -webkit-animation: 0.5s pulse linear 2;
	 * }
	 *
	 * @keyframes pulse {
	 *   from { transform: scale(0.5); }
	 *   to { transform: scale(1.5); }
	 * }
	 *
	 * @-webkit-keyframes pulse {
	 *   from { -webkit-transform: scale(0.5); }
	 *   to { -webkit-transform: scale(1.5); }
	 * }
	 * ```
	 *
	 * Given this complex combination of CSS classes, styles and options, `$animateCss` will figure everything out and make the animation happen.
	 *
	 * ## How the Options are handled
	 *
	 * `$animateCss` is very versatile and intelligent when it comes to figuring out what configurations to apply to the element to ensure the animation
	 * works with the options provided. Say for example we were adding a class that contained a keyframe value and we wanted to also animate some inline
	 * styles using the `from` and `to` properties.
	 *
	 * ```js
	 * var animator = $animateCss(element, {
	 *   from: { background:'red' },
	 *   to: { background:'blue' }
	 * });
	 * animator.start();
	 * ```
	 *
	 * ```css
	 * .rotating-animation {
	 *   animation:0.5s rotate linear;
	 *   -webkit-animation:0.5s rotate linear;
	 * }
	 *
	 * @keyframes rotate {
	 *   from { transform: rotate(0deg); }
	 *   to { transform: rotate(360deg); }
	 * }
	 *
	 * @-webkit-keyframes rotate {
	 *   from { -webkit-transform: rotate(0deg); }
	 *   to { -webkit-transform: rotate(360deg); }
	 * }
	 * ```
	 *
	 * The missing pieces here are that we do not have a transition set (within the CSS code nor within the `$animateCss` options) and the duration of the animation is
	 * going to be detected from what the keyframe styles on the CSS class are. In this event, `$animateCss` will automatically create an inline transition
	 * style matching the duration detected from the keyframe style (which is present in the CSS class that is being added) and then prepare both the transition
	 * and keyframe animations to run in parallel on the element. Then when the animation is underway the provided `from` and `to` CSS styles will be applied
	 * and spread across the transition and keyframe animation.
	 *
	 * ## What is returned
	 *
	 * `$animateCss` works in two stages: a preparation phase and an animation phase. Therefore when `$animateCss` is first called it will NOT actually
	 * start the animation. All that is going on here is that the element is being prepared for the animation (which means that the generated CSS classes are
	 * added and removed on the element). Once `$animateCss` is called it will return an object with the following properties:
	 *
	 * ```js
	 * var animator = $animateCss(element, { ... });
	 * ```
	 *
	 * Now what do the contents of our `animator` variable look like:
	 *
	 * ```js
	 * {
	 *   // starts the animation
	 *   start: Function,
	 *
	 *   // ends (aborts) the animation
	 *   end: Function
	 * }
	 * ```
	 *
	 * To actually start the animation we need to run `animation.start()` which will then return a promise that we can hook into to detect when the animation ends.
	 * If we choose not to run the animation then we MUST run `animation.end()` to perform a cleanup on the element (since some CSS classes and styles may have been
	 * applied to the element during the preparation phase). Note that all other properties such as duration, delay, transitions and keyframes are just properties
	 * and that changing them will not reconfigure the parameters of the animation.
	 *
	 * ### runner.done() vs runner.then()
	 * It is documented that `animation.start()` will return a promise object and this is true, however, there is also an additional method available on the
	 * runner called `.done(callbackFn)`. The done method works the same as `.finally(callbackFn)`, however, it does **not trigger a digest to occur**.
	 * Therefore, for performance reasons, it's always best to use `runner.done(callback)` instead of `runner.then()`, `runner.catch()` or `runner.finally()`
	 * unless you really need a digest to kick off afterwards.
	 *
	 * Keep in mind that, to make this easier, ngAnimate has tweaked the JS animations API to recognize when a runner instance is returned from $animateCss
	 * (so there is no need to call `runner.done(doneFn)` inside of your JavaScript animation code).
	 * Check the {@link ngAnimate.$animateCss#usage animation code above} to see how this works.
	 *
	 * @param {DOMElement} element the element that will be animated
	 * @param {object} options the animation-related options that will be applied during the animation
	 *
	 * * `event` - The DOM event (e.g. enter, leave, move). When used, a generated CSS class of `ng-EVENT` and `ng-EVENT-active` will be applied
	 * to the element during the animation. Multiple events can be provided when spaces are used as a separator. (Note that this will not perform any DOM operation.)
	 * * `structural` - Indicates that the `ng-` prefix will be added to the event class. Setting to `false` or omitting will turn `ng-EVENT` and
	 * `ng-EVENT-active` in `EVENT` and `EVENT-active`. Unused if `event` is omitted.
	 * * `easing` - The CSS easing value that will be applied to the transition or keyframe animation (or both).
	 * * `transitionStyle` - The raw CSS transition style that will be used (e.g. `1s linear all`).
	 * * `keyframeStyle` - The raw CSS keyframe animation style that will be used (e.g. `1s my_animation linear`).
	 * * `from` - The starting CSS styles (a key/value object) that will be applied at the start of the animation.
	 * * `to` - The ending CSS styles (a key/value object) that will be applied across the animation via a CSS transition.
	 * * `addClass` - A space separated list of CSS classes that will be added to the element and spread across the animation.
	 * * `removeClass` - A space separated list of CSS classes that will be removed from the element and spread across the animation.
	 * * `duration` - A number value representing the total duration of the transition and/or keyframe (note that a value of 1 is 1000ms). If a value of `0`
	 * is provided then the animation will be skipped entirely.
	 * * `delay` - A number value representing the total delay of the transition and/or keyframe (note that a value of 1 is 1000ms). If a value of `true` is
	 * used then whatever delay value is detected from the CSS classes will be mirrored on the elements styles (e.g. by setting delay true then the style value
	 * of the element will be `transition-delay: DETECTED_VALUE`). Using `true` is useful when you want the CSS classes and inline styles to all share the same
	 * CSS delay value.
	 * * `stagger` - A numeric time value representing the delay between successively animated elements
	 * ({@link ngAnimate#css-staggering-animations Click here to learn how CSS-based staggering works in ngAnimate.})
	 * * `staggerIndex` - The numeric index representing the stagger item (e.g. a value of 5 is equal to the sixth item in the stagger; therefore when a
	 *   `stagger` option value of `0.1` is used then there will be a stagger delay of `600ms`)
	 * * `applyClassesEarly` - Whether or not the classes being added or removed will be used when detecting the animation. This is set by `$animate` when enter/leave/move animations are fired to ensure that the CSS classes are resolved in time. (Note that this will prevent any transitions from occurring on the classes being added and removed.)
	 * * `cleanupStyles` - Whether or not the provided `from` and `to` styles will be removed once
	 *    the animation is closed. This is useful for when the styles are used purely for the sake of
	 *    the animation and do not have a lasting visual effect on the element (e.g. a collapse and open animation).
	 *    By default this value is set to `false`.
	 *
	 * @return {object} an object with start and end methods and details about the animation.
	 *
	 * * `start` - The method to start the animation. This will return a `Promise` when called.
	 * * `end` - This method will cancel the animation and remove all applied CSS classes and styles.
	 */
	var ONE_SECOND = 1000;
	var BASE_TEN = 10;
	
	var ELAPSED_TIME_MAX_DECIMAL_PLACES = 3;
	var CLOSING_TIME_BUFFER = 1.5;
	
	var DETECT_CSS_PROPERTIES = {
	  transitionDuration:      TRANSITION_DURATION_PROP,
	  transitionDelay:         TRANSITION_DELAY_PROP,
	  transitionProperty:      TRANSITION_PROP + PROPERTY_KEY,
	  animationDuration:       ANIMATION_DURATION_PROP,
	  animationDelay:          ANIMATION_DELAY_PROP,
	  animationIterationCount: ANIMATION_PROP + ANIMATION_ITERATION_COUNT_KEY
	};
	
	var DETECT_STAGGER_CSS_PROPERTIES = {
	  transitionDuration:      TRANSITION_DURATION_PROP,
	  transitionDelay:         TRANSITION_DELAY_PROP,
	  animationDuration:       ANIMATION_DURATION_PROP,
	  animationDelay:          ANIMATION_DELAY_PROP
	};
	
	function getCssKeyframeDurationStyle(duration) {
	  return [ANIMATION_DURATION_PROP, duration + 's'];
	}
	
	function getCssDelayStyle(delay, isKeyframeAnimation) {
	  var prop = isKeyframeAnimation ? ANIMATION_DELAY_PROP : TRANSITION_DELAY_PROP;
	  return [prop, delay + 's'];
	}
	
	function computeCssStyles($window, element, properties) {
	  var styles = Object.create(null);
	  var detectedStyles = $window.getComputedStyle(element) || {};
	  forEach(properties, function(formalStyleName, actualStyleName) {
	    var val = detectedStyles[formalStyleName];
	    if (val) {
	      var c = val.charAt(0);
	
	      // only numerical-based values have a negative sign or digit as the first value
	      if (c === '-' || c === '+' || c >= 0) {
	        val = parseMaxTime(val);
	      }
	
	      // by setting this to null in the event that the delay is not set or is set directly as 0
	      // then we can still allow for negative values to be used later on and not mistake this
	      // value for being greater than any other negative value.
	      if (val === 0) {
	        val = null;
	      }
	      styles[actualStyleName] = val;
	    }
	  });
	
	  return styles;
	}
	
	function parseMaxTime(str) {
	  var maxValue = 0;
	  var values = str.split(/\s*,\s*/);
	  forEach(values, function(value) {
	    // it's always safe to consider only second values and omit `ms` values since
	    // getComputedStyle will always handle the conversion for us
	    if (value.charAt(value.length - 1) == 's') {
	      value = value.substring(0, value.length - 1);
	    }
	    value = parseFloat(value) || 0;
	    maxValue = maxValue ? Math.max(value, maxValue) : value;
	  });
	  return maxValue;
	}
	
	function truthyTimingValue(val) {
	  return val === 0 || val != null;
	}
	
	function getCssTransitionDurationStyle(duration, applyOnlyDuration) {
	  var style = TRANSITION_PROP;
	  var value = duration + 's';
	  if (applyOnlyDuration) {
	    style += DURATION_KEY;
	  } else {
	    value += ' linear all';
	  }
	  return [style, value];
	}
	
	function createLocalCacheLookup() {
	  var cache = Object.create(null);
	  return {
	    flush: function() {
	      cache = Object.create(null);
	    },
	
	    count: function(key) {
	      var entry = cache[key];
	      return entry ? entry.total : 0;
	    },
	
	    get: function(key) {
	      var entry = cache[key];
	      return entry && entry.value;
	    },
	
	    put: function(key, value) {
	      if (!cache[key]) {
	        cache[key] = { total: 1, value: value };
	      } else {
	        cache[key].total++;
	      }
	    }
	  };
	}
	
	// we do not reassign an already present style value since
	// if we detect the style property value again we may be
	// detecting styles that were added via the `from` styles.
	// We make use of `isDefined` here since an empty string
	// or null value (which is what getPropertyValue will return
	// for a non-existing style) will still be marked as a valid
	// value for the style (a falsy value implies that the style
	// is to be removed at the end of the animation). If we had a simple
	// "OR" statement then it would not be enough to catch that.
	function registerRestorableStyles(backup, node, properties) {
	  forEach(properties, function(prop) {
	    backup[prop] = isDefined(backup[prop])
	        ? backup[prop]
	        : node.style.getPropertyValue(prop);
	  });
	}
	
	var $AnimateCssProvider = ['$animateProvider', function($animateProvider) {
	  var gcsLookup = createLocalCacheLookup();
	  var gcsStaggerLookup = createLocalCacheLookup();
	
	  this.$get = ['$window', '$$jqLite', '$$AnimateRunner', '$timeout',
	               '$$forceReflow', '$sniffer', '$$rAFScheduler', '$$animateQueue',
	       function($window,   $$jqLite,   $$AnimateRunner,   $timeout,
	                $$forceReflow,   $sniffer,   $$rAFScheduler, $$animateQueue) {
	
	    var applyAnimationClasses = applyAnimationClassesFactory($$jqLite);
	
	    var parentCounter = 0;
	    function gcsHashFn(node, extraClasses) {
	      var KEY = "$$ngAnimateParentKey";
	      var parentNode = node.parentNode;
	      var parentID = parentNode[KEY] || (parentNode[KEY] = ++parentCounter);
	      return parentID + '-' + node.getAttribute('class') + '-' + extraClasses;
	    }
	
	    function computeCachedCssStyles(node, className, cacheKey, properties) {
	      var timings = gcsLookup.get(cacheKey);
	
	      if (!timings) {
	        timings = computeCssStyles($window, node, properties);
	        if (timings.animationIterationCount === 'infinite') {
	          timings.animationIterationCount = 1;
	        }
	      }
	
	      // we keep putting this in multiple times even though the value and the cacheKey are the same
	      // because we're keeping an internal tally of how many duplicate animations are detected.
	      gcsLookup.put(cacheKey, timings);
	      return timings;
	    }
	
	    function computeCachedCssStaggerStyles(node, className, cacheKey, properties) {
	      var stagger;
	
	      // if we have one or more existing matches of matching elements
	      // containing the same parent + CSS styles (which is how cacheKey works)
	      // then staggering is possible
	      if (gcsLookup.count(cacheKey) > 0) {
	        stagger = gcsStaggerLookup.get(cacheKey);
	
	        if (!stagger) {
	          var staggerClassName = pendClasses(className, '-stagger');
	
	          $$jqLite.addClass(node, staggerClassName);
	
	          stagger = computeCssStyles($window, node, properties);
	
	          // force the conversion of a null value to zero incase not set
	          stagger.animationDuration = Math.max(stagger.animationDuration, 0);
	          stagger.transitionDuration = Math.max(stagger.transitionDuration, 0);
	
	          $$jqLite.removeClass(node, staggerClassName);
	
	          gcsStaggerLookup.put(cacheKey, stagger);
	        }
	      }
	
	      return stagger || {};
	    }
	
	    var cancelLastRAFRequest;
	    var rafWaitQueue = [];
	    function waitUntilQuiet(callback) {
	      rafWaitQueue.push(callback);
	      $$rAFScheduler.waitUntilQuiet(function() {
	        gcsLookup.flush();
	        gcsStaggerLookup.flush();
	
	        // DO NOT REMOVE THIS LINE OR REFACTOR OUT THE `pageWidth` variable.
	        // PLEASE EXAMINE THE `$$forceReflow` service to understand why.
	        var pageWidth = $$forceReflow();
	
	        // we use a for loop to ensure that if the queue is changed
	        // during this looping then it will consider new requests
	        for (var i = 0; i < rafWaitQueue.length; i++) {
	          rafWaitQueue[i](pageWidth);
	        }
	        rafWaitQueue.length = 0;
	      });
	    }
	
	    function computeTimings(node, className, cacheKey) {
	      var timings = computeCachedCssStyles(node, className, cacheKey, DETECT_CSS_PROPERTIES);
	      var aD = timings.animationDelay;
	      var tD = timings.transitionDelay;
	      timings.maxDelay = aD && tD
	          ? Math.max(aD, tD)
	          : (aD || tD);
	      timings.maxDuration = Math.max(
	          timings.animationDuration * timings.animationIterationCount,
	          timings.transitionDuration);
	
	      return timings;
	    }
	
	    return function init(element, initialOptions) {
	      // all of the animation functions should create
	      // a copy of the options data, however, if a
	      // parent service has already created a copy then
	      // we should stick to using that
	      var options = initialOptions || {};
	      if (!options.$$prepared) {
	        options = prepareAnimationOptions(copy(options));
	      }
	
	      var restoreStyles = {};
	      var node = getDomNode(element);
	      if (!node
	          || !node.parentNode
	          || !$$animateQueue.enabled()) {
	        return closeAndReturnNoopAnimator();
	      }
	
	      var temporaryStyles = [];
	      var classes = element.attr('class');
	      var styles = packageStyles(options);
	      var animationClosed;
	      var animationPaused;
	      var animationCompleted;
	      var runner;
	      var runnerHost;
	      var maxDelay;
	      var maxDelayTime;
	      var maxDuration;
	      var maxDurationTime;
	      var startTime;
	      var events = [];
	
	      if (options.duration === 0 || (!$sniffer.animations && !$sniffer.transitions)) {
	        return closeAndReturnNoopAnimator();
	      }
	
	      var method = options.event && isArray(options.event)
	            ? options.event.join(' ')
	            : options.event;
	
	      var isStructural = method && options.structural;
	      var structuralClassName = '';
	      var addRemoveClassName = '';
	
	      if (isStructural) {
	        structuralClassName = pendClasses(method, EVENT_CLASS_PREFIX, true);
	      } else if (method) {
	        structuralClassName = method;
	      }
	
	      if (options.addClass) {
	        addRemoveClassName += pendClasses(options.addClass, ADD_CLASS_SUFFIX);
	      }
	
	      if (options.removeClass) {
	        if (addRemoveClassName.length) {
	          addRemoveClassName += ' ';
	        }
	        addRemoveClassName += pendClasses(options.removeClass, REMOVE_CLASS_SUFFIX);
	      }
	
	      // there may be a situation where a structural animation is combined together
	      // with CSS classes that need to resolve before the animation is computed.
	      // However this means that there is no explicit CSS code to block the animation
	      // from happening (by setting 0s none in the class name). If this is the case
	      // we need to apply the classes before the first rAF so we know to continue if
	      // there actually is a detected transition or keyframe animation
	      if (options.applyClassesEarly && addRemoveClassName.length) {
	        applyAnimationClasses(element, options);
	      }
	
	      var preparationClasses = [structuralClassName, addRemoveClassName].join(' ').trim();
	      var fullClassName = classes + ' ' + preparationClasses;
	      var activeClasses = pendClasses(preparationClasses, ACTIVE_CLASS_SUFFIX);
	      var hasToStyles = styles.to && Object.keys(styles.to).length > 0;
	      var containsKeyframeAnimation = (options.keyframeStyle || '').length > 0;
	
	      // there is no way we can trigger an animation if no styles and
	      // no classes are being applied which would then trigger a transition,
	      // unless there a is raw keyframe value that is applied to the element.
	      if (!containsKeyframeAnimation
	           && !hasToStyles
	           && !preparationClasses) {
	        return closeAndReturnNoopAnimator();
	      }
	
	      var cacheKey, stagger;
	      if (options.stagger > 0) {
	        var staggerVal = parseFloat(options.stagger);
	        stagger = {
	          transitionDelay: staggerVal,
	          animationDelay: staggerVal,
	          transitionDuration: 0,
	          animationDuration: 0
	        };
	      } else {
	        cacheKey = gcsHashFn(node, fullClassName);
	        stagger = computeCachedCssStaggerStyles(node, preparationClasses, cacheKey, DETECT_STAGGER_CSS_PROPERTIES);
	      }
	
	      if (!options.$$skipPreparationClasses) {
	        $$jqLite.addClass(element, preparationClasses);
	      }
	
	      var applyOnlyDuration;
	
	      if (options.transitionStyle) {
	        var transitionStyle = [TRANSITION_PROP, options.transitionStyle];
	        applyInlineStyle(node, transitionStyle);
	        temporaryStyles.push(transitionStyle);
	      }
	
	      if (options.duration >= 0) {
	        applyOnlyDuration = node.style[TRANSITION_PROP].length > 0;
	        var durationStyle = getCssTransitionDurationStyle(options.duration, applyOnlyDuration);
	
	        // we set the duration so that it will be picked up by getComputedStyle later
	        applyInlineStyle(node, durationStyle);
	        temporaryStyles.push(durationStyle);
	      }
	
	      if (options.keyframeStyle) {
	        var keyframeStyle = [ANIMATION_PROP, options.keyframeStyle];
	        applyInlineStyle(node, keyframeStyle);
	        temporaryStyles.push(keyframeStyle);
	      }
	
	      var itemIndex = stagger
	          ? options.staggerIndex >= 0
	              ? options.staggerIndex
	              : gcsLookup.count(cacheKey)
	          : 0;
	
	      var isFirst = itemIndex === 0;
	
	      // this is a pre-emptive way of forcing the setup classes to be added and applied INSTANTLY
	      // without causing any combination of transitions to kick in. By adding a negative delay value
	      // it forces the setup class' transition to end immediately. We later then remove the negative
	      // transition delay to allow for the transition to naturally do it's thing. The beauty here is
	      // that if there is no transition defined then nothing will happen and this will also allow
	      // other transitions to be stacked on top of each other without any chopping them out.
	      if (isFirst && !options.skipBlocking) {
	        blockTransitions(node, SAFE_FAST_FORWARD_DURATION_VALUE);
	      }
	
	      var timings = computeTimings(node, fullClassName, cacheKey);
	      var relativeDelay = timings.maxDelay;
	      maxDelay = Math.max(relativeDelay, 0);
	      maxDuration = timings.maxDuration;
	
	      var flags = {};
	      flags.hasTransitions          = timings.transitionDuration > 0;
	      flags.hasAnimations           = timings.animationDuration > 0;
	      flags.hasTransitionAll        = flags.hasTransitions && timings.transitionProperty == 'all';
	      flags.applyTransitionDuration = hasToStyles && (
	                                        (flags.hasTransitions && !flags.hasTransitionAll)
	                                         || (flags.hasAnimations && !flags.hasTransitions));
	      flags.applyAnimationDuration  = options.duration && flags.hasAnimations;
	      flags.applyTransitionDelay    = truthyTimingValue(options.delay) && (flags.applyTransitionDuration || flags.hasTransitions);
	      flags.applyAnimationDelay     = truthyTimingValue(options.delay) && flags.hasAnimations;
	      flags.recalculateTimingStyles = addRemoveClassName.length > 0;
	
	      if (flags.applyTransitionDuration || flags.applyAnimationDuration) {
	        maxDuration = options.duration ? parseFloat(options.duration) : maxDuration;
	
	        if (flags.applyTransitionDuration) {
	          flags.hasTransitions = true;
	          timings.transitionDuration = maxDuration;
	          applyOnlyDuration = node.style[TRANSITION_PROP + PROPERTY_KEY].length > 0;
	          temporaryStyles.push(getCssTransitionDurationStyle(maxDuration, applyOnlyDuration));
	        }
	
	        if (flags.applyAnimationDuration) {
	          flags.hasAnimations = true;
	          timings.animationDuration = maxDuration;
	          temporaryStyles.push(getCssKeyframeDurationStyle(maxDuration));
	        }
	      }
	
	      if (maxDuration === 0 && !flags.recalculateTimingStyles) {
	        return closeAndReturnNoopAnimator();
	      }
	
	      if (options.delay != null) {
	        var delayStyle;
	        if (typeof options.delay !== "boolean") {
	          delayStyle = parseFloat(options.delay);
	          // number in options.delay means we have to recalculate the delay for the closing timeout
	          maxDelay = Math.max(delayStyle, 0);
	        }
	
	        if (flags.applyTransitionDelay) {
	          temporaryStyles.push(getCssDelayStyle(delayStyle));
	        }
	
	        if (flags.applyAnimationDelay) {
	          temporaryStyles.push(getCssDelayStyle(delayStyle, true));
	        }
	      }
	
	      // we need to recalculate the delay value since we used a pre-emptive negative
	      // delay value and the delay value is required for the final event checking. This
	      // property will ensure that this will happen after the RAF phase has passed.
	      if (options.duration == null && timings.transitionDuration > 0) {
	        flags.recalculateTimingStyles = flags.recalculateTimingStyles || isFirst;
	      }
	
	      maxDelayTime = maxDelay * ONE_SECOND;
	      maxDurationTime = maxDuration * ONE_SECOND;
	      if (!options.skipBlocking) {
	        flags.blockTransition = timings.transitionDuration > 0;
	        flags.blockKeyframeAnimation = timings.animationDuration > 0 &&
	                                       stagger.animationDelay > 0 &&
	                                       stagger.animationDuration === 0;
	      }
	
	      if (options.from) {
	        if (options.cleanupStyles) {
	          registerRestorableStyles(restoreStyles, node, Object.keys(options.from));
	        }
	        applyAnimationFromStyles(element, options);
	      }
	
	      if (flags.blockTransition || flags.blockKeyframeAnimation) {
	        applyBlocking(maxDuration);
	      } else if (!options.skipBlocking) {
	        blockTransitions(node, false);
	      }
	
	      // TODO(matsko): for 1.5 change this code to have an animator object for better debugging
	      return {
	        $$willAnimate: true,
	        end: endFn,
	        start: function() {
	          if (animationClosed) return;
	
	          runnerHost = {
	            end: endFn,
	            cancel: cancelFn,
	            resume: null, //this will be set during the start() phase
	            pause: null
	          };
	
	          runner = new $$AnimateRunner(runnerHost);
	
	          waitUntilQuiet(start);
	
	          // we don't have access to pause/resume the animation
	          // since it hasn't run yet. AnimateRunner will therefore
	          // set noop functions for resume and pause and they will
	          // later be overridden once the animation is triggered
	          return runner;
	        }
	      };
	
	      function endFn() {
	        close();
	      }
	
	      function cancelFn() {
	        close(true);
	      }
	
	      function close(rejected) { // jshint ignore:line
	        // if the promise has been called already then we shouldn't close
	        // the animation again
	        if (animationClosed || (animationCompleted && animationPaused)) return;
	        animationClosed = true;
	        animationPaused = false;
	
	        if (!options.$$skipPreparationClasses) {
	          $$jqLite.removeClass(element, preparationClasses);
	        }
	        $$jqLite.removeClass(element, activeClasses);
	
	        blockKeyframeAnimations(node, false);
	        blockTransitions(node, false);
	
	        forEach(temporaryStyles, function(entry) {
	          // There is only one way to remove inline style properties entirely from elements.
	          // By using `removeProperty` this works, but we need to convert camel-cased CSS
	          // styles down to hyphenated values.
	          node.style[entry[0]] = '';
	        });
	
	        applyAnimationClasses(element, options);
	        applyAnimationStyles(element, options);
	
	        if (Object.keys(restoreStyles).length) {
	          forEach(restoreStyles, function(value, prop) {
	            value ? node.style.setProperty(prop, value)
	                  : node.style.removeProperty(prop);
	          });
	        }
	
	        // the reason why we have this option is to allow a synchronous closing callback
	        // that is fired as SOON as the animation ends (when the CSS is removed) or if
	        // the animation never takes off at all. A good example is a leave animation since
	        // the element must be removed just after the animation is over or else the element
	        // will appear on screen for one animation frame causing an overbearing flicker.
	        if (options.onDone) {
	          options.onDone();
	        }
	
	        if (events && events.length) {
	          // Remove the transitionend / animationend listener(s)
	          element.off(events.join(' '), onAnimationProgress);
	        }
	
	        //Cancel the fallback closing timeout and remove the timer data
	        var animationTimerData = element.data(ANIMATE_TIMER_KEY);
	        if (animationTimerData) {
	          $timeout.cancel(animationTimerData[0].timer);
	          element.removeData(ANIMATE_TIMER_KEY);
	        }
	
	        // if the preparation function fails then the promise is not setup
	        if (runner) {
	          runner.complete(!rejected);
	        }
	      }
	
	      function applyBlocking(duration) {
	        if (flags.blockTransition) {
	          blockTransitions(node, duration);
	        }
	
	        if (flags.blockKeyframeAnimation) {
	          blockKeyframeAnimations(node, !!duration);
	        }
	      }
	
	      function closeAndReturnNoopAnimator() {
	        runner = new $$AnimateRunner({
	          end: endFn,
	          cancel: cancelFn
	        });
	
	        // should flush the cache animation
	        waitUntilQuiet(noop);
	        close();
	
	        return {
	          $$willAnimate: false,
	          start: function() {
	            return runner;
	          },
	          end: endFn
	        };
	      }
	
	      function onAnimationProgress(event) {
	        event.stopPropagation();
	        var ev = event.originalEvent || event;
	
	        // we now always use `Date.now()` due to the recent changes with
	        // event.timeStamp in Firefox, Webkit and Chrome (see #13494 for more info)
	        var timeStamp = ev.$manualTimeStamp || Date.now();
	
	        /* Firefox (or possibly just Gecko) likes to not round values up
	         * when a ms measurement is used for the animation */
	        var elapsedTime = parseFloat(ev.elapsedTime.toFixed(ELAPSED_TIME_MAX_DECIMAL_PLACES));
	
	        /* $manualTimeStamp is a mocked timeStamp value which is set
	         * within browserTrigger(). This is only here so that tests can
	         * mock animations properly. Real events fallback to event.timeStamp,
	         * or, if they don't, then a timeStamp is automatically created for them.
	         * We're checking to see if the timeStamp surpasses the expected delay,
	         * but we're using elapsedTime instead of the timeStamp on the 2nd
	         * pre-condition since animationPauseds sometimes close off early */
	        if (Math.max(timeStamp - startTime, 0) >= maxDelayTime && elapsedTime >= maxDuration) {
	          // we set this flag to ensure that if the transition is paused then, when resumed,
	          // the animation will automatically close itself since transitions cannot be paused.
	          animationCompleted = true;
	          close();
	        }
	      }
	
	      function start() {
	        if (animationClosed) return;
	        if (!node.parentNode) {
	          close();
	          return;
	        }
	
	        // even though we only pause keyframe animations here the pause flag
	        // will still happen when transitions are used. Only the transition will
	        // not be paused since that is not possible. If the animation ends when
	        // paused then it will not complete until unpaused or cancelled.
	        var playPause = function(playAnimation) {
	          if (!animationCompleted) {
	            animationPaused = !playAnimation;
	            if (timings.animationDuration) {
	              var value = blockKeyframeAnimations(node, animationPaused);
	              animationPaused
	                  ? temporaryStyles.push(value)
	                  : removeFromArray(temporaryStyles, value);
	            }
	          } else if (animationPaused && playAnimation) {
	            animationPaused = false;
	            close();
	          }
	        };
	
	        // checking the stagger duration prevents an accidentally cascade of the CSS delay style
	        // being inherited from the parent. If the transition duration is zero then we can safely
	        // rely that the delay value is an intentional stagger delay style.
	        var maxStagger = itemIndex > 0
	                         && ((timings.transitionDuration && stagger.transitionDuration === 0) ||
	                            (timings.animationDuration && stagger.animationDuration === 0))
	                         && Math.max(stagger.animationDelay, stagger.transitionDelay);
	        if (maxStagger) {
	          $timeout(triggerAnimationStart,
	                   Math.floor(maxStagger * itemIndex * ONE_SECOND),
	                   false);
	        } else {
	          triggerAnimationStart();
	        }
	
	        // this will decorate the existing promise runner with pause/resume methods
	        runnerHost.resume = function() {
	          playPause(true);
	        };
	
	        runnerHost.pause = function() {
	          playPause(false);
	        };
	
	        function triggerAnimationStart() {
	          // just incase a stagger animation kicks in when the animation
	          // itself was cancelled entirely
	          if (animationClosed) return;
	
	          applyBlocking(false);
	
	          forEach(temporaryStyles, function(entry) {
	            var key = entry[0];
	            var value = entry[1];
	            node.style[key] = value;
	          });
	
	          applyAnimationClasses(element, options);
	          $$jqLite.addClass(element, activeClasses);
	
	          if (flags.recalculateTimingStyles) {
	            fullClassName = node.className + ' ' + preparationClasses;
	            cacheKey = gcsHashFn(node, fullClassName);
	
	            timings = computeTimings(node, fullClassName, cacheKey);
	            relativeDelay = timings.maxDelay;
	            maxDelay = Math.max(relativeDelay, 0);
	            maxDuration = timings.maxDuration;
	
	            if (maxDuration === 0) {
	              close();
	              return;
	            }
	
	            flags.hasTransitions = timings.transitionDuration > 0;
	            flags.hasAnimations = timings.animationDuration > 0;
	          }
	
	          if (flags.applyAnimationDelay) {
	            relativeDelay = typeof options.delay !== "boolean" && truthyTimingValue(options.delay)
	                  ? parseFloat(options.delay)
	                  : relativeDelay;
	
	            maxDelay = Math.max(relativeDelay, 0);
	            timings.animationDelay = relativeDelay;
	            delayStyle = getCssDelayStyle(relativeDelay, true);
	            temporaryStyles.push(delayStyle);
	            node.style[delayStyle[0]] = delayStyle[1];
	          }
	
	          maxDelayTime = maxDelay * ONE_SECOND;
	          maxDurationTime = maxDuration * ONE_SECOND;
	
	          if (options.easing) {
	            var easeProp, easeVal = options.easing;
	            if (flags.hasTransitions) {
	              easeProp = TRANSITION_PROP + TIMING_KEY;
	              temporaryStyles.push([easeProp, easeVal]);
	              node.style[easeProp] = easeVal;
	            }
	            if (flags.hasAnimations) {
	              easeProp = ANIMATION_PROP + TIMING_KEY;
	              temporaryStyles.push([easeProp, easeVal]);
	              node.style[easeProp] = easeVal;
	            }
	          }
	
	          if (timings.transitionDuration) {
	            events.push(TRANSITIONEND_EVENT);
	          }
	
	          if (timings.animationDuration) {
	            events.push(ANIMATIONEND_EVENT);
	          }
	
	          startTime = Date.now();
	          var timerTime = maxDelayTime + CLOSING_TIME_BUFFER * maxDurationTime;
	          var endTime = startTime + timerTime;
	
	          var animationsData = element.data(ANIMATE_TIMER_KEY) || [];
	          var setupFallbackTimer = true;
	          if (animationsData.length) {
	            var currentTimerData = animationsData[0];
	            setupFallbackTimer = endTime > currentTimerData.expectedEndTime;
	            if (setupFallbackTimer) {
	              $timeout.cancel(currentTimerData.timer);
	            } else {
	              animationsData.push(close);
	            }
	          }
	
	          if (setupFallbackTimer) {
	            var timer = $timeout(onAnimationExpired, timerTime, false);
	            animationsData[0] = {
	              timer: timer,
	              expectedEndTime: endTime
	            };
	            animationsData.push(close);
	            element.data(ANIMATE_TIMER_KEY, animationsData);
	          }
	
	          if (events.length) {
	            element.on(events.join(' '), onAnimationProgress);
	          }
	
	          if (options.to) {
	            if (options.cleanupStyles) {
	              registerRestorableStyles(restoreStyles, node, Object.keys(options.to));
	            }
	            applyAnimationToStyles(element, options);
	          }
	        }
	
	        function onAnimationExpired() {
	          var animationsData = element.data(ANIMATE_TIMER_KEY);
	
	          // this will be false in the event that the element was
	          // removed from the DOM (via a leave animation or something
	          // similar)
	          if (animationsData) {
	            for (var i = 1; i < animationsData.length; i++) {
	              animationsData[i]();
	            }
	            element.removeData(ANIMATE_TIMER_KEY);
	          }
	        }
	      }
	    };
	  }];
	}];
	
	var $$AnimateCssDriverProvider = ['$$animationProvider', function($$animationProvider) {
	  $$animationProvider.drivers.push('$$animateCssDriver');
	
	  var NG_ANIMATE_SHIM_CLASS_NAME = 'ng-animate-shim';
	  var NG_ANIMATE_ANCHOR_CLASS_NAME = 'ng-anchor';
	
	  var NG_OUT_ANCHOR_CLASS_NAME = 'ng-anchor-out';
	  var NG_IN_ANCHOR_CLASS_NAME = 'ng-anchor-in';
	
	  function isDocumentFragment(node) {
	    return node.parentNode && node.parentNode.nodeType === 11;
	  }
	
	  this.$get = ['$animateCss', '$rootScope', '$$AnimateRunner', '$rootElement', '$sniffer', '$$jqLite', '$document',
	       function($animateCss,   $rootScope,   $$AnimateRunner,   $rootElement,   $sniffer,   $$jqLite,   $document) {
	
	    // only browsers that support these properties can render animations
	    if (!$sniffer.animations && !$sniffer.transitions) return noop;
	
	    var bodyNode = $document[0].body;
	    var rootNode = getDomNode($rootElement);
	
	    var rootBodyElement = jqLite(
	      // this is to avoid using something that exists outside of the body
	      // we also special case the doc fragment case because our unit test code
	      // appends the $rootElement to the body after the app has been bootstrapped
	      isDocumentFragment(rootNode) || bodyNode.contains(rootNode) ? rootNode : bodyNode
	    );
	
	    var applyAnimationClasses = applyAnimationClassesFactory($$jqLite);
	
	    return function initDriverFn(animationDetails) {
	      return animationDetails.from && animationDetails.to
	          ? prepareFromToAnchorAnimation(animationDetails.from,
	                                         animationDetails.to,
	                                         animationDetails.classes,
	                                         animationDetails.anchors)
	          : prepareRegularAnimation(animationDetails);
	    };
	
	    function filterCssClasses(classes) {
	      //remove all the `ng-` stuff
	      return classes.replace(/\bng-\S+\b/g, '');
	    }
	
	    function getUniqueValues(a, b) {
	      if (isString(a)) a = a.split(' ');
	      if (isString(b)) b = b.split(' ');
	      return a.filter(function(val) {
	        return b.indexOf(val) === -1;
	      }).join(' ');
	    }
	
	    function prepareAnchoredAnimation(classes, outAnchor, inAnchor) {
	      var clone = jqLite(getDomNode(outAnchor).cloneNode(true));
	      var startingClasses = filterCssClasses(getClassVal(clone));
	
	      outAnchor.addClass(NG_ANIMATE_SHIM_CLASS_NAME);
	      inAnchor.addClass(NG_ANIMATE_SHIM_CLASS_NAME);
	
	      clone.addClass(NG_ANIMATE_ANCHOR_CLASS_NAME);
	
	      rootBodyElement.append(clone);
	
	      var animatorIn, animatorOut = prepareOutAnimation();
	
	      // the user may not end up using the `out` animation and
	      // only making use of the `in` animation or vice-versa.
	      // In either case we should allow this and not assume the
	      // animation is over unless both animations are not used.
	      if (!animatorOut) {
	        animatorIn = prepareInAnimation();
	        if (!animatorIn) {
	          return end();
	        }
	      }
	
	      var startingAnimator = animatorOut || animatorIn;
	
	      return {
	        start: function() {
	          var runner;
	
	          var currentAnimation = startingAnimator.start();
	          currentAnimation.done(function() {
	            currentAnimation = null;
	            if (!animatorIn) {
	              animatorIn = prepareInAnimation();
	              if (animatorIn) {
	                currentAnimation = animatorIn.start();
	                currentAnimation.done(function() {
	                  currentAnimation = null;
	                  end();
	                  runner.complete();
	                });
	                return currentAnimation;
	              }
	            }
	            // in the event that there is no `in` animation
	            end();
	            runner.complete();
	          });
	
	          runner = new $$AnimateRunner({
	            end: endFn,
	            cancel: endFn
	          });
	
	          return runner;
	
	          function endFn() {
	            if (currentAnimation) {
	              currentAnimation.end();
	            }
	          }
	        }
	      };
	
	      function calculateAnchorStyles(anchor) {
	        var styles = {};
	
	        var coords = getDomNode(anchor).getBoundingClientRect();
	
	        // we iterate directly since safari messes up and doesn't return
	        // all the keys for the coords object when iterated
	        forEach(['width','height','top','left'], function(key) {
	          var value = coords[key];
	          switch (key) {
	            case 'top':
	              value += bodyNode.scrollTop;
	              break;
	            case 'left':
	              value += bodyNode.scrollLeft;
	              break;
	          }
	          styles[key] = Math.floor(value) + 'px';
	        });
	        return styles;
	      }
	
	      function prepareOutAnimation() {
	        var animator = $animateCss(clone, {
	          addClass: NG_OUT_ANCHOR_CLASS_NAME,
	          delay: true,
	          from: calculateAnchorStyles(outAnchor)
	        });
	
	        // read the comment within `prepareRegularAnimation` to understand
	        // why this check is necessary
	        return animator.$$willAnimate ? animator : null;
	      }
	
	      function getClassVal(element) {
	        return element.attr('class') || '';
	      }
	
	      function prepareInAnimation() {
	        var endingClasses = filterCssClasses(getClassVal(inAnchor));
	        var toAdd = getUniqueValues(endingClasses, startingClasses);
	        var toRemove = getUniqueValues(startingClasses, endingClasses);
	
	        var animator = $animateCss(clone, {
	          to: calculateAnchorStyles(inAnchor),
	          addClass: NG_IN_ANCHOR_CLASS_NAME + ' ' + toAdd,
	          removeClass: NG_OUT_ANCHOR_CLASS_NAME + ' ' + toRemove,
	          delay: true
	        });
	
	        // read the comment within `prepareRegularAnimation` to understand
	        // why this check is necessary
	        return animator.$$willAnimate ? animator : null;
	      }
	
	      function end() {
	        clone.remove();
	        outAnchor.removeClass(NG_ANIMATE_SHIM_CLASS_NAME);
	        inAnchor.removeClass(NG_ANIMATE_SHIM_CLASS_NAME);
	      }
	    }
	
	    function prepareFromToAnchorAnimation(from, to, classes, anchors) {
	      var fromAnimation = prepareRegularAnimation(from, noop);
	      var toAnimation = prepareRegularAnimation(to, noop);
	
	      var anchorAnimations = [];
	      forEach(anchors, function(anchor) {
	        var outElement = anchor['out'];
	        var inElement = anchor['in'];
	        var animator = prepareAnchoredAnimation(classes, outElement, inElement);
	        if (animator) {
	          anchorAnimations.push(animator);
	        }
	      });
	
	      // no point in doing anything when there are no elements to animate
	      if (!fromAnimation && !toAnimation && anchorAnimations.length === 0) return;
	
	      return {
	        start: function() {
	          var animationRunners = [];
	
	          if (fromAnimation) {
	            animationRunners.push(fromAnimation.start());
	          }
	
	          if (toAnimation) {
	            animationRunners.push(toAnimation.start());
	          }
	
	          forEach(anchorAnimations, function(animation) {
	            animationRunners.push(animation.start());
	          });
	
	          var runner = new $$AnimateRunner({
	            end: endFn,
	            cancel: endFn // CSS-driven animations cannot be cancelled, only ended
	          });
	
	          $$AnimateRunner.all(animationRunners, function(status) {
	            runner.complete(status);
	          });
	
	          return runner;
	
	          function endFn() {
	            forEach(animationRunners, function(runner) {
	              runner.end();
	            });
	          }
	        }
	      };
	    }
	
	    function prepareRegularAnimation(animationDetails) {
	      var element = animationDetails.element;
	      var options = animationDetails.options || {};
	
	      if (animationDetails.structural) {
	        options.event = animationDetails.event;
	        options.structural = true;
	        options.applyClassesEarly = true;
	
	        // we special case the leave animation since we want to ensure that
	        // the element is removed as soon as the animation is over. Otherwise
	        // a flicker might appear or the element may not be removed at all
	        if (animationDetails.event === 'leave') {
	          options.onDone = options.domOperation;
	        }
	      }
	
	      // We assign the preparationClasses as the actual animation event since
	      // the internals of $animateCss will just suffix the event token values
	      // with `-active` to trigger the animation.
	      if (options.preparationClasses) {
	        options.event = concatWithSpace(options.event, options.preparationClasses);
	      }
	
	      var animator = $animateCss(element, options);
	
	      // the driver lookup code inside of $$animation attempts to spawn a
	      // driver one by one until a driver returns a.$$willAnimate animator object.
	      // $animateCss will always return an object, however, it will pass in
	      // a flag as a hint as to whether an animation was detected or not
	      return animator.$$willAnimate ? animator : null;
	    }
	  }];
	}];
	
	// TODO(matsko): use caching here to speed things up for detection
	// TODO(matsko): add documentation
	//  by the time...
	
	var $$AnimateJsProvider = ['$animateProvider', function($animateProvider) {
	  this.$get = ['$injector', '$$AnimateRunner', '$$jqLite',
	       function($injector,   $$AnimateRunner,   $$jqLite) {
	
	    var applyAnimationClasses = applyAnimationClassesFactory($$jqLite);
	         // $animateJs(element, 'enter');
	    return function(element, event, classes, options) {
	      var animationClosed = false;
	
	      // the `classes` argument is optional and if it is not used
	      // then the classes will be resolved from the element's className
	      // property as well as options.addClass/options.removeClass.
	      if (arguments.length === 3 && isObject(classes)) {
	        options = classes;
	        classes = null;
	      }
	
	      options = prepareAnimationOptions(options);
	      if (!classes) {
	        classes = element.attr('class') || '';
	        if (options.addClass) {
	          classes += ' ' + options.addClass;
	        }
	        if (options.removeClass) {
	          classes += ' ' + options.removeClass;
	        }
	      }
	
	      var classesToAdd = options.addClass;
	      var classesToRemove = options.removeClass;
	
	      // the lookupAnimations function returns a series of animation objects that are
	      // matched up with one or more of the CSS classes. These animation objects are
	      // defined via the module.animation factory function. If nothing is detected then
	      // we don't return anything which then makes $animation query the next driver.
	      var animations = lookupAnimations(classes);
	      var before, after;
	      if (animations.length) {
	        var afterFn, beforeFn;
	        if (event == 'leave') {
	          beforeFn = 'leave';
	          afterFn = 'afterLeave'; // TODO(matsko): get rid of this
	        } else {
	          beforeFn = 'before' + event.charAt(0).toUpperCase() + event.substr(1);
	          afterFn = event;
	        }
	
	        if (event !== 'enter' && event !== 'move') {
	          before = packageAnimations(element, event, options, animations, beforeFn);
	        }
	        after  = packageAnimations(element, event, options, animations, afterFn);
	      }
	
	      // no matching animations
	      if (!before && !after) return;
	
	      function applyOptions() {
	        options.domOperation();
	        applyAnimationClasses(element, options);
	      }
	
	      function close() {
	        animationClosed = true;
	        applyOptions();
	        applyAnimationStyles(element, options);
	      }
	
	      var runner;
	
	      return {
	        $$willAnimate: true,
	        end: function() {
	          if (runner) {
	            runner.end();
	          } else {
	            close();
	            runner = new $$AnimateRunner();
	            runner.complete(true);
	          }
	          return runner;
	        },
	        start: function() {
	          if (runner) {
	            return runner;
	          }
	
	          runner = new $$AnimateRunner();
	          var closeActiveAnimations;
	          var chain = [];
	
	          if (before) {
	            chain.push(function(fn) {
	              closeActiveAnimations = before(fn);
	            });
	          }
	
	          if (chain.length) {
	            chain.push(function(fn) {
	              applyOptions();
	              fn(true);
	            });
	          } else {
	            applyOptions();
	          }
	
	          if (after) {
	            chain.push(function(fn) {
	              closeActiveAnimations = after(fn);
	            });
	          }
	
	          runner.setHost({
	            end: function() {
	              endAnimations();
	            },
	            cancel: function() {
	              endAnimations(true);
	            }
	          });
	
	          $$AnimateRunner.chain(chain, onComplete);
	          return runner;
	
	          function onComplete(success) {
	            close(success);
	            runner.complete(success);
	          }
	
	          function endAnimations(cancelled) {
	            if (!animationClosed) {
	              (closeActiveAnimations || noop)(cancelled);
	              onComplete(cancelled);
	            }
	          }
	        }
	      };
	
	      function executeAnimationFn(fn, element, event, options, onDone) {
	        var args;
	        switch (event) {
	          case 'animate':
	            args = [element, options.from, options.to, onDone];
	            break;
	
	          case 'setClass':
	            args = [element, classesToAdd, classesToRemove, onDone];
	            break;
	
	          case 'addClass':
	            args = [element, classesToAdd, onDone];
	            break;
	
	          case 'removeClass':
	            args = [element, classesToRemove, onDone];
	            break;
	
	          default:
	            args = [element, onDone];
	            break;
	        }
	
	        args.push(options);
	
	        var value = fn.apply(fn, args);
	        if (value) {
	          if (isFunction(value.start)) {
	            value = value.start();
	          }
	
	          if (value instanceof $$AnimateRunner) {
	            value.done(onDone);
	          } else if (isFunction(value)) {
	            // optional onEnd / onCancel callback
	            return value;
	          }
	        }
	
	        return noop;
	      }
	
	      function groupEventedAnimations(element, event, options, animations, fnName) {
	        var operations = [];
	        forEach(animations, function(ani) {
	          var animation = ani[fnName];
	          if (!animation) return;
	
	          // note that all of these animations will run in parallel
	          operations.push(function() {
	            var runner;
	            var endProgressCb;
	
	            var resolved = false;
	            var onAnimationComplete = function(rejected) {
	              if (!resolved) {
	                resolved = true;
	                (endProgressCb || noop)(rejected);
	                runner.complete(!rejected);
	              }
	            };
	
	            runner = new $$AnimateRunner({
	              end: function() {
	                onAnimationComplete();
	              },
	              cancel: function() {
	                onAnimationComplete(true);
	              }
	            });
	
	            endProgressCb = executeAnimationFn(animation, element, event, options, function(result) {
	              var cancelled = result === false;
	              onAnimationComplete(cancelled);
	            });
	
	            return runner;
	          });
	        });
	
	        return operations;
	      }
	
	      function packageAnimations(element, event, options, animations, fnName) {
	        var operations = groupEventedAnimations(element, event, options, animations, fnName);
	        if (operations.length === 0) {
	          var a,b;
	          if (fnName === 'beforeSetClass') {
	            a = groupEventedAnimations(element, 'removeClass', options, animations, 'beforeRemoveClass');
	            b = groupEventedAnimations(element, 'addClass', options, animations, 'beforeAddClass');
	          } else if (fnName === 'setClass') {
	            a = groupEventedAnimations(element, 'removeClass', options, animations, 'removeClass');
	            b = groupEventedAnimations(element, 'addClass', options, animations, 'addClass');
	          }
	
	          if (a) {
	            operations = operations.concat(a);
	          }
	          if (b) {
	            operations = operations.concat(b);
	          }
	        }
	
	        if (operations.length === 0) return;
	
	        // TODO(matsko): add documentation
	        return function startAnimation(callback) {
	          var runners = [];
	          if (operations.length) {
	            forEach(operations, function(animateFn) {
	              runners.push(animateFn());
	            });
	          }
	
	          runners.length ? $$AnimateRunner.all(runners, callback) : callback();
	
	          return function endFn(reject) {
	            forEach(runners, function(runner) {
	              reject ? runner.cancel() : runner.end();
	            });
	          };
	        };
	      }
	    };
	
	    function lookupAnimations(classes) {
	      classes = isArray(classes) ? classes : classes.split(' ');
	      var matches = [], flagMap = {};
	      for (var i=0; i < classes.length; i++) {
	        var klass = classes[i],
	            animationFactory = $animateProvider.$$registeredAnimations[klass];
	        if (animationFactory && !flagMap[klass]) {
	          matches.push($injector.get(animationFactory));
	          flagMap[klass] = true;
	        }
	      }
	      return matches;
	    }
	  }];
	}];
	
	var $$AnimateJsDriverProvider = ['$$animationProvider', function($$animationProvider) {
	  $$animationProvider.drivers.push('$$animateJsDriver');
	  this.$get = ['$$animateJs', '$$AnimateRunner', function($$animateJs, $$AnimateRunner) {
	    return function initDriverFn(animationDetails) {
	      if (animationDetails.from && animationDetails.to) {
	        var fromAnimation = prepareAnimation(animationDetails.from);
	        var toAnimation = prepareAnimation(animationDetails.to);
	        if (!fromAnimation && !toAnimation) return;
	
	        return {
	          start: function() {
	            var animationRunners = [];
	
	            if (fromAnimation) {
	              animationRunners.push(fromAnimation.start());
	            }
	
	            if (toAnimation) {
	              animationRunners.push(toAnimation.start());
	            }
	
	            $$AnimateRunner.all(animationRunners, done);
	
	            var runner = new $$AnimateRunner({
	              end: endFnFactory(),
	              cancel: endFnFactory()
	            });
	
	            return runner;
	
	            function endFnFactory() {
	              return function() {
	                forEach(animationRunners, function(runner) {
	                  // at this point we cannot cancel animations for groups just yet. 1.5+
	                  runner.end();
	                });
	              };
	            }
	
	            function done(status) {
	              runner.complete(status);
	            }
	          }
	        };
	      } else {
	        return prepareAnimation(animationDetails);
	      }
	    };
	
	    function prepareAnimation(animationDetails) {
	      // TODO(matsko): make sure to check for grouped animations and delegate down to normal animations
	      var element = animationDetails.element;
	      var event = animationDetails.event;
	      var options = animationDetails.options;
	      var classes = animationDetails.classes;
	      return $$animateJs(element, event, classes, options);
	    }
	  }];
	}];
	
	var NG_ANIMATE_ATTR_NAME = 'data-ng-animate';
	var NG_ANIMATE_PIN_DATA = '$ngAnimatePin';
	var $$AnimateQueueProvider = ['$animateProvider', function($animateProvider) {
	  var PRE_DIGEST_STATE = 1;
	  var RUNNING_STATE = 2;
	  var ONE_SPACE = ' ';
	
	  var rules = this.rules = {
	    skip: [],
	    cancel: [],
	    join: []
	  };
	
	  function makeTruthyCssClassMap(classString) {
	    if (!classString) {
	      return null;
	    }
	
	    var keys = classString.split(ONE_SPACE);
	    var map = Object.create(null);
	
	    forEach(keys, function(key) {
	      map[key] = true;
	    });
	    return map;
	  }
	
	  function hasMatchingClasses(newClassString, currentClassString) {
	    if (newClassString && currentClassString) {
	      var currentClassMap = makeTruthyCssClassMap(currentClassString);
	      return newClassString.split(ONE_SPACE).some(function(className) {
	        return currentClassMap[className];
	      });
	    }
	  }
	
	  function isAllowed(ruleType, element, currentAnimation, previousAnimation) {
	    return rules[ruleType].some(function(fn) {
	      return fn(element, currentAnimation, previousAnimation);
	    });
	  }
	
	  function hasAnimationClasses(animation, and) {
	    var a = (animation.addClass || '').length > 0;
	    var b = (animation.removeClass || '').length > 0;
	    return and ? a && b : a || b;
	  }
	
	  rules.join.push(function(element, newAnimation, currentAnimation) {
	    // if the new animation is class-based then we can just tack that on
	    return !newAnimation.structural && hasAnimationClasses(newAnimation);
	  });
	
	  rules.skip.push(function(element, newAnimation, currentAnimation) {
	    // there is no need to animate anything if no classes are being added and
	    // there is no structural animation that will be triggered
	    return !newAnimation.structural && !hasAnimationClasses(newAnimation);
	  });
	
	  rules.skip.push(function(element, newAnimation, currentAnimation) {
	    // why should we trigger a new structural animation if the element will
	    // be removed from the DOM anyway?
	    return currentAnimation.event == 'leave' && newAnimation.structural;
	  });
	
	  rules.skip.push(function(element, newAnimation, currentAnimation) {
	    // if there is an ongoing current animation then don't even bother running the class-based animation
	    return currentAnimation.structural && currentAnimation.state === RUNNING_STATE && !newAnimation.structural;
	  });
	
	  rules.cancel.push(function(element, newAnimation, currentAnimation) {
	    // there can never be two structural animations running at the same time
	    return currentAnimation.structural && newAnimation.structural;
	  });
	
	  rules.cancel.push(function(element, newAnimation, currentAnimation) {
	    // if the previous animation is already running, but the new animation will
	    // be triggered, but the new animation is structural
	    return currentAnimation.state === RUNNING_STATE && newAnimation.structural;
	  });
	
	  rules.cancel.push(function(element, newAnimation, currentAnimation) {
	    // cancel the animation if classes added / removed in both animation cancel each other out,
	    // but only if the current animation isn't structural
	
	    if (currentAnimation.structural) return false;
	
	    var nA = newAnimation.addClass;
	    var nR = newAnimation.removeClass;
	    var cA = currentAnimation.addClass;
	    var cR = currentAnimation.removeClass;
	
	    // early detection to save the global CPU shortage :)
	    if ((isUndefined(nA) && isUndefined(nR)) || (isUndefined(cA) && isUndefined(cR))) {
	      return false;
	    }
	
	    return hasMatchingClasses(nA, cR) || hasMatchingClasses(nR, cA);
	  });
	
	  this.$get = ['$$rAF', '$rootScope', '$rootElement', '$document', '$$HashMap',
	               '$$animation', '$$AnimateRunner', '$templateRequest', '$$jqLite', '$$forceReflow',
	       function($$rAF,   $rootScope,   $rootElement,   $document,   $$HashMap,
	                $$animation,   $$AnimateRunner,   $templateRequest,   $$jqLite,   $$forceReflow) {
	
	    var activeAnimationsLookup = new $$HashMap();
	    var disabledElementsLookup = new $$HashMap();
	    var animationsEnabled = null;
	
	    function postDigestTaskFactory() {
	      var postDigestCalled = false;
	      return function(fn) {
	        // we only issue a call to postDigest before
	        // it has first passed. This prevents any callbacks
	        // from not firing once the animation has completed
	        // since it will be out of the digest cycle.
	        if (postDigestCalled) {
	          fn();
	        } else {
	          $rootScope.$$postDigest(function() {
	            postDigestCalled = true;
	            fn();
	          });
	        }
	      };
	    }
	
	    // Wait until all directive and route-related templates are downloaded and
	    // compiled. The $templateRequest.totalPendingRequests variable keeps track of
	    // all of the remote templates being currently downloaded. If there are no
	    // templates currently downloading then the watcher will still fire anyway.
	    var deregisterWatch = $rootScope.$watch(
	      function() { return $templateRequest.totalPendingRequests === 0; },
	      function(isEmpty) {
	        if (!isEmpty) return;
	        deregisterWatch();
	
	        // Now that all templates have been downloaded, $animate will wait until
	        // the post digest queue is empty before enabling animations. By having two
	        // calls to $postDigest calls we can ensure that the flag is enabled at the
	        // very end of the post digest queue. Since all of the animations in $animate
	        // use $postDigest, it's important that the code below executes at the end.
	        // This basically means that the page is fully downloaded and compiled before
	        // any animations are triggered.
	        $rootScope.$$postDigest(function() {
	          $rootScope.$$postDigest(function() {
	            // we check for null directly in the event that the application already called
	            // .enabled() with whatever arguments that it provided it with
	            if (animationsEnabled === null) {
	              animationsEnabled = true;
	            }
	          });
	        });
	      }
	    );
	
	    var callbackRegistry = {};
	
	    // remember that the classNameFilter is set during the provider/config
	    // stage therefore we can optimize here and setup a helper function
	    var classNameFilter = $animateProvider.classNameFilter();
	    var isAnimatableClassName = !classNameFilter
	              ? function() { return true; }
	              : function(className) {
	                return classNameFilter.test(className);
	              };
	
	    var applyAnimationClasses = applyAnimationClassesFactory($$jqLite);
	
	    function normalizeAnimationDetails(element, animation) {
	      return mergeAnimationDetails(element, animation, {});
	    }
	
	    // IE9-11 has no method "contains" in SVG element and in Node.prototype. Bug #10259.
	    var contains = window.Node.prototype.contains || function(arg) {
	      // jshint bitwise: false
	      return this === arg || !!(this.compareDocumentPosition(arg) & 16);
	      // jshint bitwise: true
	    };
	
	    function findCallbacks(parent, element, event) {
	      var targetNode = getDomNode(element);
	      var targetParentNode = getDomNode(parent);
	
	      var matches = [];
	      var entries = callbackRegistry[event];
	      if (entries) {
	        forEach(entries, function(entry) {
	          if (contains.call(entry.node, targetNode)) {
	            matches.push(entry.callback);
	          } else if (event === 'leave' && contains.call(entry.node, targetParentNode)) {
	            matches.push(entry.callback);
	          }
	        });
	      }
	
	      return matches;
	    }
	
	    function filterFromRegistry(list, matchContainer, matchCallback) {
	      var containerNode = extractElementNode(matchContainer);
	      return list.filter(function(entry) {
	        var isMatch = entry.node === containerNode &&
	                        (!matchCallback || entry.callback === matchCallback);
	        return !isMatch;
	      });
	    }
	
	    function cleanupEventListeners(phase, element) {
	      if (phase === 'close' && !element[0].parentNode) {
	        // If the element is not attached to a parentNode, it has been removed by
	        // the domOperation, and we can safely remove the event callbacks
	        $animate.off(element);
	      }
	    }
	
	    var $animate = {
	      on: function(event, container, callback) {
	        var node = extractElementNode(container);
	        callbackRegistry[event] = callbackRegistry[event] || [];
	        callbackRegistry[event].push({
	          node: node,
	          callback: callback
	        });
	
	        // Remove the callback when the element is removed from the DOM
	        jqLite(container).on('$destroy', function() {
	          var animationDetails = activeAnimationsLookup.get(node);
	
	          if (!animationDetails) {
	            // If there's an animation ongoing, the callback calling code will remove
	            // the event listeners. If we'd remove here, the callbacks would be removed
	            // before the animation ends
	            $animate.off(event, container, callback);
	          }
	        });
	      },
	
	      off: function(event, container, callback) {
	        if (arguments.length === 1 && !angular.isString(arguments[0])) {
	          container = arguments[0];
	          for (var eventType in callbackRegistry) {
	            callbackRegistry[eventType] = filterFromRegistry(callbackRegistry[eventType], container);
	          }
	
	          return;
	        }
	
	        var entries = callbackRegistry[event];
	        if (!entries) return;
	
	        callbackRegistry[event] = arguments.length === 1
	            ? null
	            : filterFromRegistry(entries, container, callback);
	      },
	
	      pin: function(element, parentElement) {
	        assertArg(isElement(element), 'element', 'not an element');
	        assertArg(isElement(parentElement), 'parentElement', 'not an element');
	        element.data(NG_ANIMATE_PIN_DATA, parentElement);
	      },
	
	      push: function(element, event, options, domOperation) {
	        options = options || {};
	        options.domOperation = domOperation;
	        return queueAnimation(element, event, options);
	      },
	
	      // this method has four signatures:
	      //  () - global getter
	      //  (bool) - global setter
	      //  (element) - element getter
	      //  (element, bool) - element setter<F37>
	      enabled: function(element, bool) {
	        var argCount = arguments.length;
	
	        if (argCount === 0) {
	          // () - Global getter
	          bool = !!animationsEnabled;
	        } else {
	          var hasElement = isElement(element);
	
	          if (!hasElement) {
	            // (bool) - Global setter
	            bool = animationsEnabled = !!element;
	          } else {
	            var node = getDomNode(element);
	            var recordExists = disabledElementsLookup.get(node);
	
	            if (argCount === 1) {
	              // (element) - Element getter
	              bool = !recordExists;
	            } else {
	              // (element, bool) - Element setter
	              disabledElementsLookup.put(node, !bool);
	            }
	          }
	        }
	
	        return bool;
	      }
	    };
	
	    return $animate;
	
	    function queueAnimation(element, event, initialOptions) {
	      // we always make a copy of the options since
	      // there should never be any side effects on
	      // the input data when running `$animateCss`.
	      var options = copy(initialOptions);
	
	      var node, parent;
	      element = stripCommentsFromElement(element);
	      if (element) {
	        node = getDomNode(element);
	        parent = element.parent();
	      }
	
	      options = prepareAnimationOptions(options);
	
	      // we create a fake runner with a working promise.
	      // These methods will become available after the digest has passed
	      var runner = new $$AnimateRunner();
	
	      // this is used to trigger callbacks in postDigest mode
	      var runInNextPostDigestOrNow = postDigestTaskFactory();
	
	      if (isArray(options.addClass)) {
	        options.addClass = options.addClass.join(' ');
	      }
	
	      if (options.addClass && !isString(options.addClass)) {
	        options.addClass = null;
	      }
	
	      if (isArray(options.removeClass)) {
	        options.removeClass = options.removeClass.join(' ');
	      }
	
	      if (options.removeClass && !isString(options.removeClass)) {
	        options.removeClass = null;
	      }
	
	      if (options.from && !isObject(options.from)) {
	        options.from = null;
	      }
	
	      if (options.to && !isObject(options.to)) {
	        options.to = null;
	      }
	
	      // there are situations where a directive issues an animation for
	      // a jqLite wrapper that contains only comment nodes... If this
	      // happens then there is no way we can perform an animation
	      if (!node) {
	        close();
	        return runner;
	      }
	
	      var className = [node.className, options.addClass, options.removeClass].join(' ');
	      if (!isAnimatableClassName(className)) {
	        close();
	        return runner;
	      }
	
	      var isStructural = ['enter', 'move', 'leave'].indexOf(event) >= 0;
	
	      var documentHidden = $document[0].hidden;
	
	      // this is a hard disable of all animations for the application or on
	      // the element itself, therefore  there is no need to continue further
	      // past this point if not enabled
	      // Animations are also disabled if the document is currently hidden (page is not visible
	      // to the user), because browsers slow down or do not flush calls to requestAnimationFrame
	      var skipAnimations = !animationsEnabled || documentHidden || disabledElementsLookup.get(node);
	      var existingAnimation = (!skipAnimations && activeAnimationsLookup.get(node)) || {};
	      var hasExistingAnimation = !!existingAnimation.state;
	
	      // there is no point in traversing the same collection of parent ancestors if a followup
	      // animation will be run on the same element that already did all that checking work
	      if (!skipAnimations && (!hasExistingAnimation || existingAnimation.state != PRE_DIGEST_STATE)) {
	        skipAnimations = !areAnimationsAllowed(element, parent, event);
	      }
	
	      if (skipAnimations) {
	        // Callbacks should fire even if the document is hidden (regression fix for issue #14120)
	        if (documentHidden) notifyProgress(runner, event, 'start');
	        close();
	        if (documentHidden) notifyProgress(runner, event, 'close');
	        return runner;
	      }
	
	      if (isStructural) {
	        closeChildAnimations(element);
	      }
	
	      var newAnimation = {
	        structural: isStructural,
	        element: element,
	        event: event,
	        addClass: options.addClass,
	        removeClass: options.removeClass,
	        close: close,
	        options: options,
	        runner: runner
	      };
	
	      if (hasExistingAnimation) {
	        var skipAnimationFlag = isAllowed('skip', element, newAnimation, existingAnimation);
	        if (skipAnimationFlag) {
	          if (existingAnimation.state === RUNNING_STATE) {
	            close();
	            return runner;
	          } else {
	            mergeAnimationDetails(element, existingAnimation, newAnimation);
	            return existingAnimation.runner;
	          }
	        }
	        var cancelAnimationFlag = isAllowed('cancel', element, newAnimation, existingAnimation);
	        if (cancelAnimationFlag) {
	          if (existingAnimation.state === RUNNING_STATE) {
	            // this will end the animation right away and it is safe
	            // to do so since the animation is already running and the
	            // runner callback code will run in async
	            existingAnimation.runner.end();
	          } else if (existingAnimation.structural) {
	            // this means that the animation is queued into a digest, but
	            // hasn't started yet. Therefore it is safe to run the close
	            // method which will call the runner methods in async.
	            existingAnimation.close();
	          } else {
	            // this will merge the new animation options into existing animation options
	            mergeAnimationDetails(element, existingAnimation, newAnimation);
	
	            return existingAnimation.runner;
	          }
	        } else {
	          // a joined animation means that this animation will take over the existing one
	          // so an example would involve a leave animation taking over an enter. Then when
	          // the postDigest kicks in the enter will be ignored.
	          var joinAnimationFlag = isAllowed('join', element, newAnimation, existingAnimation);
	          if (joinAnimationFlag) {
	            if (existingAnimation.state === RUNNING_STATE) {
	              normalizeAnimationDetails(element, newAnimation);
	            } else {
	              applyGeneratedPreparationClasses(element, isStructural ? event : null, options);
	
	              event = newAnimation.event = existingAnimation.event;
	              options = mergeAnimationDetails(element, existingAnimation, newAnimation);
	
	              //we return the same runner since only the option values of this animation will
	              //be fed into the `existingAnimation`.
	              return existingAnimation.runner;
	            }
	          }
	        }
	      } else {
	        // normalization in this case means that it removes redundant CSS classes that
	        // already exist (addClass) or do not exist (removeClass) on the element
	        normalizeAnimationDetails(element, newAnimation);
	      }
	
	      // when the options are merged and cleaned up we may end up not having to do
	      // an animation at all, therefore we should check this before issuing a post
	      // digest callback. Structural animations will always run no matter what.
	      var isValidAnimation = newAnimation.structural;
	      if (!isValidAnimation) {
	        // animate (from/to) can be quickly checked first, otherwise we check if any classes are present
	        isValidAnimation = (newAnimation.event === 'animate' && Object.keys(newAnimation.options.to || {}).length > 0)
	                            || hasAnimationClasses(newAnimation);
	      }
	
	      if (!isValidAnimation) {
	        close();
	        clearElementAnimationState(element);
	        return runner;
	      }
	
	      // the counter keeps track of cancelled animations
	      var counter = (existingAnimation.counter || 0) + 1;
	      newAnimation.counter = counter;
	
	      markElementAnimationState(element, PRE_DIGEST_STATE, newAnimation);
	
	      $rootScope.$$postDigest(function() {
	        var animationDetails = activeAnimationsLookup.get(node);
	        var animationCancelled = !animationDetails;
	        animationDetails = animationDetails || {};
	
	        // if addClass/removeClass is called before something like enter then the
	        // registered parent element may not be present. The code below will ensure
	        // that a final value for parent element is obtained
	        var parentElement = element.parent() || [];
	
	        // animate/structural/class-based animations all have requirements. Otherwise there
	        // is no point in performing an animation. The parent node must also be set.
	        var isValidAnimation = parentElement.length > 0
	                                && (animationDetails.event === 'animate'
	                                    || animationDetails.structural
	                                    || hasAnimationClasses(animationDetails));
	
	        // this means that the previous animation was cancelled
	        // even if the follow-up animation is the same event
	        if (animationCancelled || animationDetails.counter !== counter || !isValidAnimation) {
	          // if another animation did not take over then we need
	          // to make sure that the domOperation and options are
	          // handled accordingly
	          if (animationCancelled) {
	            applyAnimationClasses(element, options);
	            applyAnimationStyles(element, options);
	          }
	
	          // if the event changed from something like enter to leave then we do
	          // it, otherwise if it's the same then the end result will be the same too
	          if (animationCancelled || (isStructural && animationDetails.event !== event)) {
	            options.domOperation();
	            runner.end();
	          }
	
	          // in the event that the element animation was not cancelled or a follow-up animation
	          // isn't allowed to animate from here then we need to clear the state of the element
	          // so that any future animations won't read the expired animation data.
	          if (!isValidAnimation) {
	            clearElementAnimationState(element);
	          }
	
	          return;
	        }
	
	        // this combined multiple class to addClass / removeClass into a setClass event
	        // so long as a structural event did not take over the animation
	        event = !animationDetails.structural && hasAnimationClasses(animationDetails, true)
	            ? 'setClass'
	            : animationDetails.event;
	
	        markElementAnimationState(element, RUNNING_STATE);
	        var realRunner = $$animation(element, event, animationDetails.options);
	
	        // this will update the runner's flow-control events based on
	        // the `realRunner` object.
	        runner.setHost(realRunner);
	        notifyProgress(runner, event, 'start', {});
	
	        realRunner.done(function(status) {
	          close(!status);
	          var animationDetails = activeAnimationsLookup.get(node);
	          if (animationDetails && animationDetails.counter === counter) {
	            clearElementAnimationState(getDomNode(element));
	          }
	          notifyProgress(runner, event, 'close', {});
	        });
	      });
	
	      return runner;
	
	      function notifyProgress(runner, event, phase, data) {
	        runInNextPostDigestOrNow(function() {
	          var callbacks = findCallbacks(parent, element, event);
	          if (callbacks.length) {
	            // do not optimize this call here to RAF because
	            // we don't know how heavy the callback code here will
	            // be and if this code is buffered then this can
	            // lead to a performance regression.
	            $$rAF(function() {
	              forEach(callbacks, function(callback) {
	                callback(element, phase, data);
	              });
	              cleanupEventListeners(phase, element);
	            });
	          } else {
	            cleanupEventListeners(phase, element);
	          }
	        });
	        runner.progress(event, phase, data);
	      }
	
	      function close(reject) { // jshint ignore:line
	        clearGeneratedClasses(element, options);
	        applyAnimationClasses(element, options);
	        applyAnimationStyles(element, options);
	        options.domOperation();
	        runner.complete(!reject);
	      }
	    }
	
	    function closeChildAnimations(element) {
	      var node = getDomNode(element);
	      var children = node.querySelectorAll('[' + NG_ANIMATE_ATTR_NAME + ']');
	      forEach(children, function(child) {
	        var state = parseInt(child.getAttribute(NG_ANIMATE_ATTR_NAME));
	        var animationDetails = activeAnimationsLookup.get(child);
	        if (animationDetails) {
	          switch (state) {
	            case RUNNING_STATE:
	              animationDetails.runner.end();
	              /* falls through */
	            case PRE_DIGEST_STATE:
	              activeAnimationsLookup.remove(child);
	              break;
	          }
	        }
	      });
	    }
	
	    function clearElementAnimationState(element) {
	      var node = getDomNode(element);
	      node.removeAttribute(NG_ANIMATE_ATTR_NAME);
	      activeAnimationsLookup.remove(node);
	    }
	
	    function isMatchingElement(nodeOrElmA, nodeOrElmB) {
	      return getDomNode(nodeOrElmA) === getDomNode(nodeOrElmB);
	    }
	
	    /**
	     * This fn returns false if any of the following is true:
	     * a) animations on any parent element are disabled, and animations on the element aren't explicitly allowed
	     * b) a parent element has an ongoing structural animation, and animateChildren is false
	     * c) the element is not a child of the body
	     * d) the element is not a child of the $rootElement
	     */
	    function areAnimationsAllowed(element, parentElement, event) {
	      var bodyElement = jqLite($document[0].body);
	      var bodyElementDetected = isMatchingElement(element, bodyElement) || element[0].nodeName === 'HTML';
	      var rootElementDetected = isMatchingElement(element, $rootElement);
	      var parentAnimationDetected = false;
	      var animateChildren;
	      var elementDisabled = disabledElementsLookup.get(getDomNode(element));
	
	      var parentHost = jqLite.data(element[0], NG_ANIMATE_PIN_DATA);
	      if (parentHost) {
	        parentElement = parentHost;
	      }
	
	      parentElement = getDomNode(parentElement);
	
	      while (parentElement) {
	        if (!rootElementDetected) {
	          // angular doesn't want to attempt to animate elements outside of the application
	          // therefore we need to ensure that the rootElement is an ancestor of the current element
	          rootElementDetected = isMatchingElement(parentElement, $rootElement);
	        }
	
	        if (parentElement.nodeType !== ELEMENT_NODE) {
	          // no point in inspecting the #document element
	          break;
	        }
	
	        var details = activeAnimationsLookup.get(parentElement) || {};
	        // either an enter, leave or move animation will commence
	        // therefore we can't allow any animations to take place
	        // but if a parent animation is class-based then that's ok
	        if (!parentAnimationDetected) {
	          var parentElementDisabled = disabledElementsLookup.get(parentElement);
	
	          if (parentElementDisabled === true && elementDisabled !== false) {
	            // disable animations if the user hasn't explicitly enabled animations on the
	            // current element
	            elementDisabled = true;
	            // element is disabled via parent element, no need to check anything else
	            break;
	          } else if (parentElementDisabled === false) {
	            elementDisabled = false;
	          }
	          parentAnimationDetected = details.structural;
	        }
	
	        if (isUndefined(animateChildren) || animateChildren === true) {
	          var value = jqLite.data(parentElement, NG_ANIMATE_CHILDREN_DATA);
	          if (isDefined(value)) {
	            animateChildren = value;
	          }
	        }
	
	        // there is no need to continue traversing at this point
	        if (parentAnimationDetected && animateChildren === false) break;
	
	        if (!bodyElementDetected) {
	          // we also need to ensure that the element is or will be a part of the body element
	          // otherwise it is pointless to even issue an animation to be rendered
	          bodyElementDetected = isMatchingElement(parentElement, bodyElement);
	        }
	
	        if (bodyElementDetected && rootElementDetected) {
	          // If both body and root have been found, any other checks are pointless,
	          // as no animation data should live outside the application
	          break;
	        }
	
	        if (!rootElementDetected) {
	          // If no rootElement is detected, check if the parentElement is pinned to another element
	          parentHost = jqLite.data(parentElement, NG_ANIMATE_PIN_DATA);
	          if (parentHost) {
	            // The pin target element becomes the next parent element
	            parentElement = getDomNode(parentHost);
	            continue;
	          }
	        }
	
	        parentElement = parentElement.parentNode;
	      }
	
	      var allowAnimation = (!parentAnimationDetected || animateChildren) && elementDisabled !== true;
	      return allowAnimation && rootElementDetected && bodyElementDetected;
	    }
	
	    function markElementAnimationState(element, state, details) {
	      details = details || {};
	      details.state = state;
	
	      var node = getDomNode(element);
	      node.setAttribute(NG_ANIMATE_ATTR_NAME, state);
	
	      var oldValue = activeAnimationsLookup.get(node);
	      var newValue = oldValue
	          ? extend(oldValue, details)
	          : details;
	      activeAnimationsLookup.put(node, newValue);
	    }
	  }];
	}];
	
	var $$AnimationProvider = ['$animateProvider', function($animateProvider) {
	  var NG_ANIMATE_REF_ATTR = 'ng-animate-ref';
	
	  var drivers = this.drivers = [];
	
	  var RUNNER_STORAGE_KEY = '$$animationRunner';
	
	  function setRunner(element, runner) {
	    element.data(RUNNER_STORAGE_KEY, runner);
	  }
	
	  function removeRunner(element) {
	    element.removeData(RUNNER_STORAGE_KEY);
	  }
	
	  function getRunner(element) {
	    return element.data(RUNNER_STORAGE_KEY);
	  }
	
	  this.$get = ['$$jqLite', '$rootScope', '$injector', '$$AnimateRunner', '$$HashMap', '$$rAFScheduler',
	       function($$jqLite,   $rootScope,   $injector,   $$AnimateRunner,   $$HashMap,   $$rAFScheduler) {
	
	    var animationQueue = [];
	    var applyAnimationClasses = applyAnimationClassesFactory($$jqLite);
	
	    function sortAnimations(animations) {
	      var tree = { children: [] };
	      var i, lookup = new $$HashMap();
	
	      // this is done first beforehand so that the hashmap
	      // is filled with a list of the elements that will be animated
	      for (i = 0; i < animations.length; i++) {
	        var animation = animations[i];
	        lookup.put(animation.domNode, animations[i] = {
	          domNode: animation.domNode,
	          fn: animation.fn,
	          children: []
	        });
	      }
	
	      for (i = 0; i < animations.length; i++) {
	        processNode(animations[i]);
	      }
	
	      return flatten(tree);
	
	      function processNode(entry) {
	        if (entry.processed) return entry;
	        entry.processed = true;
	
	        var elementNode = entry.domNode;
	        var parentNode = elementNode.parentNode;
	        lookup.put(elementNode, entry);
	
	        var parentEntry;
	        while (parentNode) {
	          parentEntry = lookup.get(parentNode);
	          if (parentEntry) {
	            if (!parentEntry.processed) {
	              parentEntry = processNode(parentEntry);
	            }
	            break;
	          }
	          parentNode = parentNode.parentNode;
	        }
	
	        (parentEntry || tree).children.push(entry);
	        return entry;
	      }
	
	      function flatten(tree) {
	        var result = [];
	        var queue = [];
	        var i;
	
	        for (i = 0; i < tree.children.length; i++) {
	          queue.push(tree.children[i]);
	        }
	
	        var remainingLevelEntries = queue.length;
	        var nextLevelEntries = 0;
	        var row = [];
	
	        for (i = 0; i < queue.length; i++) {
	          var entry = queue[i];
	          if (remainingLevelEntries <= 0) {
	            remainingLevelEntries = nextLevelEntries;
	            nextLevelEntries = 0;
	            result.push(row);
	            row = [];
	          }
	          row.push(entry.fn);
	          entry.children.forEach(function(childEntry) {
	            nextLevelEntries++;
	            queue.push(childEntry);
	          });
	          remainingLevelEntries--;
	        }
	
	        if (row.length) {
	          result.push(row);
	        }
	
	        return result;
	      }
	    }
	
	    // TODO(matsko): document the signature in a better way
	    return function(element, event, options) {
	      options = prepareAnimationOptions(options);
	      var isStructural = ['enter', 'move', 'leave'].indexOf(event) >= 0;
	
	      // there is no animation at the current moment, however
	      // these runner methods will get later updated with the
	      // methods leading into the driver's end/cancel methods
	      // for now they just stop the animation from starting
	      var runner = new $$AnimateRunner({
	        end: function() { close(); },
	        cancel: function() { close(true); }
	      });
	
	      if (!drivers.length) {
	        close();
	        return runner;
	      }
	
	      setRunner(element, runner);
	
	      var classes = mergeClasses(element.attr('class'), mergeClasses(options.addClass, options.removeClass));
	      var tempClasses = options.tempClasses;
	      if (tempClasses) {
	        classes += ' ' + tempClasses;
	        options.tempClasses = null;
	      }
	
	      var prepareClassName;
	      if (isStructural) {
	        prepareClassName = 'ng-' + event + PREPARE_CLASS_SUFFIX;
	        $$jqLite.addClass(element, prepareClassName);
	      }
	
	      animationQueue.push({
	        // this data is used by the postDigest code and passed into
	        // the driver step function
	        element: element,
	        classes: classes,
	        event: event,
	        structural: isStructural,
	        options: options,
	        beforeStart: beforeStart,
	        close: close
	      });
	
	      element.on('$destroy', handleDestroyedElement);
	
	      // we only want there to be one function called within the post digest
	      // block. This way we can group animations for all the animations that
	      // were apart of the same postDigest flush call.
	      if (animationQueue.length > 1) return runner;
	
	      $rootScope.$$postDigest(function() {
	        var animations = [];
	        forEach(animationQueue, function(entry) {
	          // the element was destroyed early on which removed the runner
	          // form its storage. This means we can't animate this element
	          // at all and it already has been closed due to destruction.
	          if (getRunner(entry.element)) {
	            animations.push(entry);
	          } else {
	            entry.close();
	          }
	        });
	
	        // now any future animations will be in another postDigest
	        animationQueue.length = 0;
	
	        var groupedAnimations = groupAnimations(animations);
	        var toBeSortedAnimations = [];
	
	        forEach(groupedAnimations, function(animationEntry) {
	          toBeSortedAnimations.push({
	            domNode: getDomNode(animationEntry.from ? animationEntry.from.element : animationEntry.element),
	            fn: function triggerAnimationStart() {
	              // it's important that we apply the `ng-animate` CSS class and the
	              // temporary classes before we do any driver invoking since these
	              // CSS classes may be required for proper CSS detection.
	              animationEntry.beforeStart();
	
	              var startAnimationFn, closeFn = animationEntry.close;
	
	              // in the event that the element was removed before the digest runs or
	              // during the RAF sequencing then we should not trigger the animation.
	              var targetElement = animationEntry.anchors
	                  ? (animationEntry.from.element || animationEntry.to.element)
	                  : animationEntry.element;
	
	              if (getRunner(targetElement)) {
	                var operation = invokeFirstDriver(animationEntry);
	                if (operation) {
	                  startAnimationFn = operation.start;
	                }
	              }
	
	              if (!startAnimationFn) {
	                closeFn();
	              } else {
	                var animationRunner = startAnimationFn();
	                animationRunner.done(function(status) {
	                  closeFn(!status);
	                });
	                updateAnimationRunners(animationEntry, animationRunner);
	              }
	            }
	          });
	        });
	
	        // we need to sort each of the animations in order of parent to child
	        // relationships. This ensures that the child classes are applied at the
	        // right time.
	        $$rAFScheduler(sortAnimations(toBeSortedAnimations));
	      });
	
	      return runner;
	
	      // TODO(matsko): change to reference nodes
	      function getAnchorNodes(node) {
	        var SELECTOR = '[' + NG_ANIMATE_REF_ATTR + ']';
	        var items = node.hasAttribute(NG_ANIMATE_REF_ATTR)
	              ? [node]
	              : node.querySelectorAll(SELECTOR);
	        var anchors = [];
	        forEach(items, function(node) {
	          var attr = node.getAttribute(NG_ANIMATE_REF_ATTR);
	          if (attr && attr.length) {
	            anchors.push(node);
	          }
	        });
	        return anchors;
	      }
	
	      function groupAnimations(animations) {
	        var preparedAnimations = [];
	        var refLookup = {};
	        forEach(animations, function(animation, index) {
	          var element = animation.element;
	          var node = getDomNode(element);
	          var event = animation.event;
	          var enterOrMove = ['enter', 'move'].indexOf(event) >= 0;
	          var anchorNodes = animation.structural ? getAnchorNodes(node) : [];
	
	          if (anchorNodes.length) {
	            var direction = enterOrMove ? 'to' : 'from';
	
	            forEach(anchorNodes, function(anchor) {
	              var key = anchor.getAttribute(NG_ANIMATE_REF_ATTR);
	              refLookup[key] = refLookup[key] || {};
	              refLookup[key][direction] = {
	                animationID: index,
	                element: jqLite(anchor)
	              };
	            });
	          } else {
	            preparedAnimations.push(animation);
	          }
	        });
	
	        var usedIndicesLookup = {};
	        var anchorGroups = {};
	        forEach(refLookup, function(operations, key) {
	          var from = operations.from;
	          var to = operations.to;
	
	          if (!from || !to) {
	            // only one of these is set therefore we can't have an
	            // anchor animation since all three pieces are required
	            var index = from ? from.animationID : to.animationID;
	            var indexKey = index.toString();
	            if (!usedIndicesLookup[indexKey]) {
	              usedIndicesLookup[indexKey] = true;
	              preparedAnimations.push(animations[index]);
	            }
	            return;
	          }
	
	          var fromAnimation = animations[from.animationID];
	          var toAnimation = animations[to.animationID];
	          var lookupKey = from.animationID.toString();
	          if (!anchorGroups[lookupKey]) {
	            var group = anchorGroups[lookupKey] = {
	              structural: true,
	              beforeStart: function() {
	                fromAnimation.beforeStart();
	                toAnimation.beforeStart();
	              },
	              close: function() {
	                fromAnimation.close();
	                toAnimation.close();
	              },
	              classes: cssClassesIntersection(fromAnimation.classes, toAnimation.classes),
	              from: fromAnimation,
	              to: toAnimation,
	              anchors: [] // TODO(matsko): change to reference nodes
	            };
	
	            // the anchor animations require that the from and to elements both have at least
	            // one shared CSS class which effectively marries the two elements together to use
	            // the same animation driver and to properly sequence the anchor animation.
	            if (group.classes.length) {
	              preparedAnimations.push(group);
	            } else {
	              preparedAnimations.push(fromAnimation);
	              preparedAnimations.push(toAnimation);
	            }
	          }
	
	          anchorGroups[lookupKey].anchors.push({
	            'out': from.element, 'in': to.element
	          });
	        });
	
	        return preparedAnimations;
	      }
	
	      function cssClassesIntersection(a,b) {
	        a = a.split(' ');
	        b = b.split(' ');
	        var matches = [];
	
	        for (var i = 0; i < a.length; i++) {
	          var aa = a[i];
	          if (aa.substring(0,3) === 'ng-') continue;
	
	          for (var j = 0; j < b.length; j++) {
	            if (aa === b[j]) {
	              matches.push(aa);
	              break;
	            }
	          }
	        }
	
	        return matches.join(' ');
	      }
	
	      function invokeFirstDriver(animationDetails) {
	        // we loop in reverse order since the more general drivers (like CSS and JS)
	        // may attempt more elements, but custom drivers are more particular
	        for (var i = drivers.length - 1; i >= 0; i--) {
	          var driverName = drivers[i];
	          if (!$injector.has(driverName)) continue; // TODO(matsko): remove this check
	
	          var factory = $injector.get(driverName);
	          var driver = factory(animationDetails);
	          if (driver) {
	            return driver;
	          }
	        }
	      }
	
	      function beforeStart() {
	        element.addClass(NG_ANIMATE_CLASSNAME);
	        if (tempClasses) {
	          $$jqLite.addClass(element, tempClasses);
	        }
	        if (prepareClassName) {
	          $$jqLite.removeClass(element, prepareClassName);
	          prepareClassName = null;
	        }
	      }
	
	      function updateAnimationRunners(animation, newRunner) {
	        if (animation.from && animation.to) {
	          update(animation.from.element);
	          update(animation.to.element);
	        } else {
	          update(animation.element);
	        }
	
	        function update(element) {
	          var runner = getRunner(element);
	          if (runner) runner.setHost(newRunner);
	        }
	      }
	
	      function handleDestroyedElement() {
	        var runner = getRunner(element);
	        if (runner && (event !== 'leave' || !options.$$domOperationFired)) {
	          runner.end();
	        }
	      }
	
	      function close(rejected) { // jshint ignore:line
	        element.off('$destroy', handleDestroyedElement);
	        removeRunner(element);
	
	        applyAnimationClasses(element, options);
	        applyAnimationStyles(element, options);
	        options.domOperation();
	
	        if (tempClasses) {
	          $$jqLite.removeClass(element, tempClasses);
	        }
	
	        element.removeClass(NG_ANIMATE_CLASSNAME);
	        runner.complete(!rejected);
	      }
	    };
	  }];
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngAnimateSwap
	 * @restrict A
	 * @scope
	 *
	 * @description
	 *
	 * ngAnimateSwap is a animation-oriented directive that allows for the container to
	 * be removed and entered in whenever the associated expression changes. A
	 * common usecase for this directive is a rotating banner or slider component which
	 * contains one image being present at a time. When the active image changes
	 * then the old image will perform a `leave` animation and the new element
	 * will be inserted via an `enter` animation.
	 *
	 * @animations
	 * | Animation                        | Occurs                               |
	 * |----------------------------------|--------------------------------------|
	 * | {@link ng.$animate#enter enter}  | when the new element is inserted to the DOM  |
	 * | {@link ng.$animate#leave leave}  | when the old element is removed from the DOM |
	 *
	 * @example
	 * <example name="ngAnimateSwap-directive" module="ngAnimateSwapExample"
	 *          deps="angular-animate.js"
	 *          animations="true" fixBase="true">
	 *   <file name="index.html">
	 *     <div class="container" ng-controller="AppCtrl">
	 *       <div ng-animate-swap="number" class="cell swap-animation" ng-class="colorClass(number)">
	 *         {{ number }}
	 *       </div>
	 *     </div>
	 *   </file>
	 *   <file name="script.js">
	 *     angular.module('ngAnimateSwapExample', ['ngAnimate'])
	 *       .controller('AppCtrl', ['$scope', '$interval', function($scope, $interval) {
	 *         $scope.number = 0;
	 *         $interval(function() {
	 *           $scope.number++;
	 *         }, 1000);
	 *
	 *         var colors = ['red','blue','green','yellow','orange'];
	 *         $scope.colorClass = function(number) {
	 *           return colors[number % colors.length];
	 *         };
	 *       }]);
	 *   </file>
	 *  <file name="animations.css">
	 *  .container {
	 *    height:250px;
	 *    width:250px;
	 *    position:relative;
	 *    overflow:hidden;
	 *    border:2px solid black;
	 *  }
	 *  .container .cell {
	 *    font-size:150px;
	 *    text-align:center;
	 *    line-height:250px;
	 *    position:absolute;
	 *    top:0;
	 *    left:0;
	 *    right:0;
	 *    border-bottom:2px solid black;
	 *  }
	 *  .swap-animation.ng-enter, .swap-animation.ng-leave {
	 *    transition:0.5s linear all;
	 *  }
	 *  .swap-animation.ng-enter {
	 *    top:-250px;
	 *  }
	 *  .swap-animation.ng-enter-active {
	 *    top:0px;
	 *  }
	 *  .swap-animation.ng-leave {
	 *    top:0px;
	 *  }
	 *  .swap-animation.ng-leave-active {
	 *    top:250px;
	 *  }
	 *  .red { background:red; }
	 *  .green { background:green; }
	 *  .blue { background:blue; }
	 *  .yellow { background:yellow; }
	 *  .orange { background:orange; }
	 *  </file>
	 * </example>
	 */
	var ngAnimateSwapDirective = ['$animate', '$rootScope', function($animate, $rootScope) {
	  return {
	    restrict: 'A',
	    transclude: 'element',
	    terminal: true,
	    priority: 600, // we use 600 here to ensure that the directive is caught before others
	    link: function(scope, $element, attrs, ctrl, $transclude) {
	      var previousElement, previousScope;
	      scope.$watchCollection(attrs.ngAnimateSwap || attrs['for'], function(value) {
	        if (previousElement) {
	          $animate.leave(previousElement);
	        }
	        if (previousScope) {
	          previousScope.$destroy();
	          previousScope = null;
	        }
	        if (value || value === 0) {
	          previousScope = scope.$new();
	          $transclude(previousScope, function(element) {
	            previousElement = element;
	            $animate.enter(element, null, $element);
	          });
	        }
	      });
	    }
	  };
	}];
	
	/* global angularAnimateModule: true,
	
	   ngAnimateSwapDirective,
	   $$AnimateAsyncRunFactory,
	   $$rAFSchedulerFactory,
	   $$AnimateChildrenDirective,
	   $$AnimateQueueProvider,
	   $$AnimationProvider,
	   $AnimateCssProvider,
	   $$AnimateCssDriverProvider,
	   $$AnimateJsProvider,
	   $$AnimateJsDriverProvider,
	*/
	
	/**
	 * @ngdoc module
	 * @name ngAnimate
	 * @description
	 *
	 * The `ngAnimate` module provides support for CSS-based animations (keyframes and transitions) as well as JavaScript-based animations via
	 * callback hooks. Animations are not enabled by default, however, by including `ngAnimate` the animation hooks are enabled for an Angular app.
	 *
	 * <div doc-module-components="ngAnimate"></div>
	 *
	 * # Usage
	 * Simply put, there are two ways to make use of animations when ngAnimate is used: by using **CSS** and **JavaScript**. The former works purely based
	 * using CSS (by using matching CSS selectors/styles) and the latter triggers animations that are registered via `module.animation()`. For
	 * both CSS and JS animations the sole requirement is to have a matching `CSS class` that exists both in the registered animation and within
	 * the HTML element that the animation will be triggered on.
	 *
	 * ## Directive Support
	 * The following directives are "animation aware":
	 *
	 * | Directive                                                                                                | Supported Animations                                                     |
	 * |----------------------------------------------------------------------------------------------------------|--------------------------------------------------------------------------|
	 * | {@link ng.directive:ngRepeat#animations ngRepeat}                                                        | enter, leave and move                                                    |
	 * | {@link ngRoute.directive:ngView#animations ngView}                                                       | enter and leave                                                          |
	 * | {@link ng.directive:ngInclude#animations ngInclude}                                                      | enter and leave                                                          |
	 * | {@link ng.directive:ngSwitch#animations ngSwitch}                                                        | enter and leave                                                          |
	 * | {@link ng.directive:ngIf#animations ngIf}                                                                | enter and leave                                                          |
	 * | {@link ng.directive:ngClass#animations ngClass}                                                          | add and remove (the CSS class(es) present)                               |
	 * | {@link ng.directive:ngShow#animations ngShow} & {@link ng.directive:ngHide#animations ngHide}            | add and remove (the ng-hide class value)                                 |
	 * | {@link ng.directive:form#animation-hooks form} & {@link ng.directive:ngModel#animation-hooks ngModel}    | add and remove (dirty, pristine, valid, invalid & all other validations) |
	 * | {@link module:ngMessages#animations ngMessages}                                                          | add and remove (ng-active & ng-inactive)                                 |
	 * | {@link module:ngMessages#animations ngMessage}                                                           | enter and leave                                                          |
	 *
	 * (More information can be found by visiting each the documentation associated with each directive.)
	 *
	 * ## CSS-based Animations
	 *
	 * CSS-based animations with ngAnimate are unique since they require no JavaScript code at all. By using a CSS class that we reference between our HTML
	 * and CSS code we can create an animation that will be picked up by Angular when an the underlying directive performs an operation.
	 *
	 * The example below shows how an `enter` animation can be made possible on an element using `ng-if`:
	 *
	 * ```html
	 * <div ng-if="bool" class="fade">
	 *    Fade me in out
	 * </div>
	 * <button ng-click="bool=true">Fade In!</button>
	 * <button ng-click="bool=false">Fade Out!</button>
	 * ```
	 *
	 * Notice the CSS class **fade**? We can now create the CSS transition code that references this class:
	 *
	 * ```css
	 * /&#42; The starting CSS styles for the enter animation &#42;/
	 * .fade.ng-enter {
	 *   transition:0.5s linear all;
	 *   opacity:0;
	 * }
	 *
	 * /&#42; The finishing CSS styles for the enter animation &#42;/
	 * .fade.ng-enter.ng-enter-active {
	 *   opacity:1;
	 * }
	 * ```
	 *
	 * The key thing to remember here is that, depending on the animation event (which each of the directives above trigger depending on what's going on) two
	 * generated CSS classes will be applied to the element; in the example above we have `.ng-enter` and `.ng-enter-active`. For CSS transitions, the transition
	 * code **must** be defined within the starting CSS class (in this case `.ng-enter`). The destination class is what the transition will animate towards.
	 *
	 * If for example we wanted to create animations for `leave` and `move` (ngRepeat triggers move) then we can do so using the same CSS naming conventions:
	 *
	 * ```css
	 * /&#42; now the element will fade out before it is removed from the DOM &#42;/
	 * .fade.ng-leave {
	 *   transition:0.5s linear all;
	 *   opacity:1;
	 * }
	 * .fade.ng-leave.ng-leave-active {
	 *   opacity:0;
	 * }
	 * ```
	 *
	 * We can also make use of **CSS Keyframes** by referencing the keyframe animation within the starting CSS class:
	 *
	 * ```css
	 * /&#42; there is no need to define anything inside of the destination
	 * CSS class since the keyframe will take charge of the animation &#42;/
	 * .fade.ng-leave {
	 *   animation: my_fade_animation 0.5s linear;
	 *   -webkit-animation: my_fade_animation 0.5s linear;
	 * }
	 *
	 * @keyframes my_fade_animation {
	 *   from { opacity:1; }
	 *   to { opacity:0; }
	 * }
	 *
	 * @-webkit-keyframes my_fade_animation {
	 *   from { opacity:1; }
	 *   to { opacity:0; }
	 * }
	 * ```
	 *
	 * Feel free also mix transitions and keyframes together as well as any other CSS classes on the same element.
	 *
	 * ### CSS Class-based Animations
	 *
	 * Class-based animations (animations that are triggered via `ngClass`, `ngShow`, `ngHide` and some other directives) have a slightly different
	 * naming convention. Class-based animations are basic enough that a standard transition or keyframe can be referenced on the class being added
	 * and removed.
	 *
	 * For example if we wanted to do a CSS animation for `ngHide` then we place an animation on the `.ng-hide` CSS class:
	 *
	 * ```html
	 * <div ng-show="bool" class="fade">
	 *   Show and hide me
	 * </div>
	 * <button ng-click="bool=!bool">Toggle</button>
	 *
	 * <style>
	 * .fade.ng-hide {
	 *   transition:0.5s linear all;
	 *   opacity:0;
	 * }
	 * </style>
	 * ```
	 *
	 * All that is going on here with ngShow/ngHide behind the scenes is the `.ng-hide` class is added/removed (when the hidden state is valid). Since
	 * ngShow and ngHide are animation aware then we can match up a transition and ngAnimate handles the rest.
	 *
	 * In addition the addition and removal of the CSS class, ngAnimate also provides two helper methods that we can use to further decorate the animation
	 * with CSS styles.
	 *
	 * ```html
	 * <div ng-class="{on:onOff}" class="highlight">
	 *   Highlight this box
	 * </div>
	 * <button ng-click="onOff=!onOff">Toggle</button>
	 *
	 * <style>
	 * .highlight {
	 *   transition:0.5s linear all;
	 * }
	 * .highlight.on-add {
	 *   background:white;
	 * }
	 * .highlight.on {
	 *   background:yellow;
	 * }
	 * .highlight.on-remove {
	 *   background:black;
	 * }
	 * </style>
	 * ```
	 *
	 * We can also make use of CSS keyframes by placing them within the CSS classes.
	 *
	 *
	 * ### CSS Staggering Animations
	 * A Staggering animation is a collection of animations that are issued with a slight delay in between each successive operation resulting in a
	 * curtain-like effect. The ngAnimate module (versions >=1.2) supports staggering animations and the stagger effect can be
	 * performed by creating a **ng-EVENT-stagger** CSS class and attaching that class to the base CSS class used for
	 * the animation. The style property expected within the stagger class can either be a **transition-delay** or an
	 * **animation-delay** property (or both if your animation contains both transitions and keyframe animations).
	 *
	 * ```css
	 * .my-animation.ng-enter {
	 *   /&#42; standard transition code &#42;/
	 *   transition: 1s linear all;
	 *   opacity:0;
	 * }
	 * .my-animation.ng-enter-stagger {
	 *   /&#42; this will have a 100ms delay between each successive leave animation &#42;/
	 *   transition-delay: 0.1s;
	 *
	 *   /&#42; As of 1.4.4, this must always be set: it signals ngAnimate
	 *     to not accidentally inherit a delay property from another CSS class &#42;/
	 *   transition-duration: 0s;
	 * }
	 * .my-animation.ng-enter.ng-enter-active {
	 *   /&#42; standard transition styles &#42;/
	 *   opacity:1;
	 * }
	 * ```
	 *
	 * Staggering animations work by default in ngRepeat (so long as the CSS class is defined). Outside of ngRepeat, to use staggering animations
	 * on your own, they can be triggered by firing multiple calls to the same event on $animate. However, the restrictions surrounding this
	 * are that each of the elements must have the same CSS className value as well as the same parent element. A stagger operation
	 * will also be reset if one or more animation frames have passed since the multiple calls to `$animate` were fired.
	 *
	 * The following code will issue the **ng-leave-stagger** event on the element provided:
	 *
	 * ```js
	 * var kids = parent.children();
	 *
	 * $animate.leave(kids[0]); //stagger index=0
	 * $animate.leave(kids[1]); //stagger index=1
	 * $animate.leave(kids[2]); //stagger index=2
	 * $animate.leave(kids[3]); //stagger index=3
	 * $animate.leave(kids[4]); //stagger index=4
	 *
	 * window.requestAnimationFrame(function() {
	 *   //stagger has reset itself
	 *   $animate.leave(kids[5]); //stagger index=0
	 *   $animate.leave(kids[6]); //stagger index=1
	 *
	 *   $scope.$digest();
	 * });
	 * ```
	 *
	 * Stagger animations are currently only supported within CSS-defined animations.
	 *
	 * ### The `ng-animate` CSS class
	 *
	 * When ngAnimate is animating an element it will apply the `ng-animate` CSS class to the element for the duration of the animation.
	 * This is a temporary CSS class and it will be removed once the animation is over (for both JavaScript and CSS-based animations).
	 *
	 * Therefore, animations can be applied to an element using this temporary class directly via CSS.
	 *
	 * ```css
	 * .zipper.ng-animate {
	 *   transition:0.5s linear all;
	 * }
	 * .zipper.ng-enter {
	 *   opacity:0;
	 * }
	 * .zipper.ng-enter.ng-enter-active {
	 *   opacity:1;
	 * }
	 * .zipper.ng-leave {
	 *   opacity:1;
	 * }
	 * .zipper.ng-leave.ng-leave-active {
	 *   opacity:0;
	 * }
	 * ```
	 *
	 * (Note that the `ng-animate` CSS class is reserved and it cannot be applied on an element directly since ngAnimate will always remove
	 * the CSS class once an animation has completed.)
	 *
	 *
	 * ### The `ng-[event]-prepare` class
	 *
	 * This is a special class that can be used to prevent unwanted flickering / flash of content before
	 * the actual animation starts. The class is added as soon as an animation is initialized, but removed
	 * before the actual animation starts (after waiting for a $digest).
	 * It is also only added for *structural* animations (`enter`, `move`, and `leave`).
	 *
	 * In practice, flickering can appear when nesting elements with structural animations such as `ngIf`
	 * into elements that have class-based animations such as `ngClass`.
	 *
	 * ```html
	 * <div ng-class="{red: myProp}">
	 *   <div ng-class="{blue: myProp}">
	 *     <div class="message" ng-if="myProp"></div>
	 *   </div>
	 * </div>
	 * ```
	 *
	 * It is possible that during the `enter` animation, the `.message` div will be briefly visible before it starts animating.
	 * In that case, you can add styles to the CSS that make sure the element stays hidden before the animation starts:
	 *
	 * ```css
	 * .message.ng-enter-prepare {
	 *   opacity: 0;
	 * }
	 *
	 * ```
	 *
	 * ## JavaScript-based Animations
	 *
	 * ngAnimate also allows for animations to be consumed by JavaScript code. The approach is similar to CSS-based animations (where there is a shared
	 * CSS class that is referenced in our HTML code) but in addition we need to register the JavaScript animation on the module. By making use of the
	 * `module.animation()` module function we can register the animation.
	 *
	 * Let's see an example of a enter/leave animation using `ngRepeat`:
	 *
	 * ```html
	 * <div ng-repeat="item in items" class="slide">
	 *   {{ item }}
	 * </div>
	 * ```
	 *
	 * See the **slide** CSS class? Let's use that class to define an animation that we'll structure in our module code by using `module.animation`:
	 *
	 * ```js
	 * myModule.animation('.slide', [function() {
	 *   return {
	 *     // make note that other events (like addClass/removeClass)
	 *     // have different function input parameters
	 *     enter: function(element, doneFn) {
	 *       jQuery(element).fadeIn(1000, doneFn);
	 *
	 *       // remember to call doneFn so that angular
	 *       // knows that the animation has concluded
	 *     },
	 *
	 *     move: function(element, doneFn) {
	 *       jQuery(element).fadeIn(1000, doneFn);
	 *     },
	 *
	 *     leave: function(element, doneFn) {
	 *       jQuery(element).fadeOut(1000, doneFn);
	 *     }
	 *   }
	 * }]);
	 * ```
	 *
	 * The nice thing about JS-based animations is that we can inject other services and make use of advanced animation libraries such as
	 * greensock.js and velocity.js.
	 *
	 * If our animation code class-based (meaning that something like `ngClass`, `ngHide` and `ngShow` triggers it) then we can still define
	 * our animations inside of the same registered animation, however, the function input arguments are a bit different:
	 *
	 * ```html
	 * <div ng-class="color" class="colorful">
	 *   this box is moody
	 * </div>
	 * <button ng-click="color='red'">Change to red</button>
	 * <button ng-click="color='blue'">Change to blue</button>
	 * <button ng-click="color='green'">Change to green</button>
	 * ```
	 *
	 * ```js
	 * myModule.animation('.colorful', [function() {
	 *   return {
	 *     addClass: function(element, className, doneFn) {
	 *       // do some cool animation and call the doneFn
	 *     },
	 *     removeClass: function(element, className, doneFn) {
	 *       // do some cool animation and call the doneFn
	 *     },
	 *     setClass: function(element, addedClass, removedClass, doneFn) {
	 *       // do some cool animation and call the doneFn
	 *     }
	 *   }
	 * }]);
	 * ```
	 *
	 * ## CSS + JS Animations Together
	 *
	 * AngularJS 1.4 and higher has taken steps to make the amalgamation of CSS and JS animations more flexible. However, unlike earlier versions of Angular,
	 * defining CSS and JS animations to work off of the same CSS class will not work anymore. Therefore the example below will only result in **JS animations taking
	 * charge of the animation**:
	 *
	 * ```html
	 * <div ng-if="bool" class="slide">
	 *   Slide in and out
	 * </div>
	 * ```
	 *
	 * ```js
	 * myModule.animation('.slide', [function() {
	 *   return {
	 *     enter: function(element, doneFn) {
	 *       jQuery(element).slideIn(1000, doneFn);
	 *     }
	 *   }
	 * }]);
	 * ```
	 *
	 * ```css
	 * .slide.ng-enter {
	 *   transition:0.5s linear all;
	 *   transform:translateY(-100px);
	 * }
	 * .slide.ng-enter.ng-enter-active {
	 *   transform:translateY(0);
	 * }
	 * ```
	 *
	 * Does this mean that CSS and JS animations cannot be used together? Do JS-based animations always have higher priority? We can make up for the
	 * lack of CSS animations by using the `$animateCss` service to trigger our own tweaked-out, CSS-based animations directly from
	 * our own JS-based animation code:
	 *
	 * ```js
	 * myModule.animation('.slide', ['$animateCss', function($animateCss) {
	 *   return {
	 *     enter: function(element) {
	*        // this will trigger `.slide.ng-enter` and `.slide.ng-enter-active`.
	 *       return $animateCss(element, {
	 *         event: 'enter',
	 *         structural: true
	 *       });
	 *     }
	 *   }
	 * }]);
	 * ```
	 *
	 * The nice thing here is that we can save bandwidth by sticking to our CSS-based animation code and we don't need to rely on a 3rd-party animation framework.
	 *
	 * The `$animateCss` service is very powerful since we can feed in all kinds of extra properties that will be evaluated and fed into a CSS transition or
	 * keyframe animation. For example if we wanted to animate the height of an element while adding and removing classes then we can do so by providing that
	 * data into `$animateCss` directly:
	 *
	 * ```js
	 * myModule.animation('.slide', ['$animateCss', function($animateCss) {
	 *   return {
	 *     enter: function(element) {
	 *       return $animateCss(element, {
	 *         event: 'enter',
	 *         structural: true,
	 *         addClass: 'maroon-setting',
	 *         from: { height:0 },
	 *         to: { height: 200 }
	 *       });
	 *     }
	 *   }
	 * }]);
	 * ```
	 *
	 * Now we can fill in the rest via our transition CSS code:
	 *
	 * ```css
	 * /&#42; the transition tells ngAnimate to make the animation happen &#42;/
	 * .slide.ng-enter { transition:0.5s linear all; }
	 *
	 * /&#42; this extra CSS class will be absorbed into the transition
	 * since the $animateCss code is adding the class &#42;/
	 * .maroon-setting { background:red; }
	 * ```
	 *
	 * And `$animateCss` will figure out the rest. Just make sure to have the `done()` callback fire the `doneFn` function to signal when the animation is over.
	 *
	 * To learn more about what's possible be sure to visit the {@link ngAnimate.$animateCss $animateCss service}.
	 *
	 * ## Animation Anchoring (via `ng-animate-ref`)
	 *
	 * ngAnimate in AngularJS 1.4 comes packed with the ability to cross-animate elements between
	 * structural areas of an application (like views) by pairing up elements using an attribute
	 * called `ng-animate-ref`.
	 *
	 * Let's say for example we have two views that are managed by `ng-view` and we want to show
	 * that there is a relationship between two components situated in within these views. By using the
	 * `ng-animate-ref` attribute we can identify that the two components are paired together and we
	 * can then attach an animation, which is triggered when the view changes.
	 *
	 * Say for example we have the following template code:
	 *
	 * ```html
	 * <!-- index.html -->
	 * <div ng-view class="view-animation">
	 * </div>
	 *
	 * <!-- home.html -->
	 * <a href="#/banner-page">
	 *   <img src="./banner.jpg" class="banner" ng-animate-ref="banner">
	 * </a>
	 *
	 * <!-- banner-page.html -->
	 * <img src="./banner.jpg" class="banner" ng-animate-ref="banner">
	 * ```
	 *
	 * Now, when the view changes (once the link is clicked), ngAnimate will examine the
	 * HTML contents to see if there is a match reference between any components in the view
	 * that is leaving and the view that is entering. It will scan both the view which is being
	 * removed (leave) and inserted (enter) to see if there are any paired DOM elements that
	 * contain a matching ref value.
	 *
	 * The two images match since they share the same ref value. ngAnimate will now create a
	 * transport element (which is a clone of the first image element) and it will then attempt
	 * to animate to the position of the second image element in the next view. For the animation to
	 * work a special CSS class called `ng-anchor` will be added to the transported element.
	 *
	 * We can now attach a transition onto the `.banner.ng-anchor` CSS class and then
	 * ngAnimate will handle the entire transition for us as well as the addition and removal of
	 * any changes of CSS classes between the elements:
	 *
	 * ```css
	 * .banner.ng-anchor {
	 *   /&#42; this animation will last for 1 second since there are
	 *          two phases to the animation (an `in` and an `out` phase) &#42;/
	 *   transition:0.5s linear all;
	 * }
	 * ```
	 *
	 * We also **must** include animations for the views that are being entered and removed
	 * (otherwise anchoring wouldn't be possible since the new view would be inserted right away).
	 *
	 * ```css
	 * .view-animation.ng-enter, .view-animation.ng-leave {
	 *   transition:0.5s linear all;
	 *   position:fixed;
	 *   left:0;
	 *   top:0;
	 *   width:100%;
	 * }
	 * .view-animation.ng-enter {
	 *   transform:translateX(100%);
	 * }
	 * .view-animation.ng-leave,
	 * .view-animation.ng-enter.ng-enter-active {
	 *   transform:translateX(0%);
	 * }
	 * .view-animation.ng-leave.ng-leave-active {
	 *   transform:translateX(-100%);
	 * }
	 * ```
	 *
	 * Now we can jump back to the anchor animation. When the animation happens, there are two stages that occur:
	 * an `out` and an `in` stage. The `out` stage happens first and that is when the element is animated away
	 * from its origin. Once that animation is over then the `in` stage occurs which animates the
	 * element to its destination. The reason why there are two animations is to give enough time
	 * for the enter animation on the new element to be ready.
	 *
	 * The example above sets up a transition for both the in and out phases, but we can also target the out or
	 * in phases directly via `ng-anchor-out` and `ng-anchor-in`.
	 *
	 * ```css
	 * .banner.ng-anchor-out {
	 *   transition: 0.5s linear all;
	 *
	 *   /&#42; the scale will be applied during the out animation,
	 *          but will be animated away when the in animation runs &#42;/
	 *   transform: scale(1.2);
	 * }
	 *
	 * .banner.ng-anchor-in {
	 *   transition: 1s linear all;
	 * }
	 * ```
	 *
	 *
	 *
	 *
	 * ### Anchoring Demo
	 *
	  <example module="anchoringExample"
	           name="anchoringExample"
	           id="anchoringExample"
	           deps="angular-animate.js;angular-route.js"
	           animations="true">
	    <file name="index.html">
	      <a href="#/">Home</a>
	      <hr />
	      <div class="view-container">
	        <div ng-view class="view"></div>
	      </div>
	    </file>
	    <file name="script.js">
	      angular.module('anchoringExample', ['ngAnimate', 'ngRoute'])
	        .config(['$routeProvider', function($routeProvider) {
	          $routeProvider.when('/', {
	            templateUrl: 'home.html',
	            controller: 'HomeController as home'
	          });
	          $routeProvider.when('/profile/:id', {
	            templateUrl: 'profile.html',
	            controller: 'ProfileController as profile'
	          });
	        }])
	        .run(['$rootScope', function($rootScope) {
	          $rootScope.records = [
	            { id:1, title: "Miss Beulah Roob" },
	            { id:2, title: "Trent Morissette" },
	            { id:3, title: "Miss Ava Pouros" },
	            { id:4, title: "Rod Pouros" },
	            { id:5, title: "Abdul Rice" },
	            { id:6, title: "Laurie Rutherford Sr." },
	            { id:7, title: "Nakia McLaughlin" },
	            { id:8, title: "Jordon Blanda DVM" },
	            { id:9, title: "Rhoda Hand" },
	            { id:10, title: "Alexandrea Sauer" }
	          ];
	        }])
	        .controller('HomeController', [function() {
	          //empty
	        }])
	        .controller('ProfileController', ['$rootScope', '$routeParams', function($rootScope, $routeParams) {
	          var index = parseInt($routeParams.id, 10);
	          var record = $rootScope.records[index - 1];
	
	          this.title = record.title;
	          this.id = record.id;
	        }]);
	    </file>
	    <file name="home.html">
	      <h2>Welcome to the home page</h1>
	      <p>Please click on an element</p>
	      <a class="record"
	         ng-href="#/profile/{{ record.id }}"
	         ng-animate-ref="{{ record.id }}"
	         ng-repeat="record in records">
	        {{ record.title }}
	      </a>
	    </file>
	    <file name="profile.html">
	      <div class="profile record" ng-animate-ref="{{ profile.id }}">
	        {{ profile.title }}
	      </div>
	    </file>
	    <file name="animations.css">
	      .record {
	        display:block;
	        font-size:20px;
	      }
	      .profile {
	        background:black;
	        color:white;
	        font-size:100px;
	      }
	      .view-container {
	        position:relative;
	      }
	      .view-container > .view.ng-animate {
	        position:absolute;
	        top:0;
	        left:0;
	        width:100%;
	        min-height:500px;
	      }
	      .view.ng-enter, .view.ng-leave,
	      .record.ng-anchor {
	        transition:0.5s linear all;
	      }
	      .view.ng-enter {
	        transform:translateX(100%);
	      }
	      .view.ng-enter.ng-enter-active, .view.ng-leave {
	        transform:translateX(0%);
	      }
	      .view.ng-leave.ng-leave-active {
	        transform:translateX(-100%);
	      }
	      .record.ng-anchor-out {
	        background:red;
	      }
	    </file>
	  </example>
	 *
	 * ### How is the element transported?
	 *
	 * When an anchor animation occurs, ngAnimate will clone the starting element and position it exactly where the starting
	 * element is located on screen via absolute positioning. The cloned element will be placed inside of the root element
	 * of the application (where ng-app was defined) and all of the CSS classes of the starting element will be applied. The
	 * element will then animate into the `out` and `in` animations and will eventually reach the coordinates and match
	 * the dimensions of the destination element. During the entire animation a CSS class of `.ng-animate-shim` will be applied
	 * to both the starting and destination elements in order to hide them from being visible (the CSS styling for the class
	 * is: `visibility:hidden`). Once the anchor reaches its destination then it will be removed and the destination element
	 * will become visible since the shim class will be removed.
	 *
	 * ### How is the morphing handled?
	 *
	 * CSS Anchoring relies on transitions and keyframes and the internal code is intelligent enough to figure out
	 * what CSS classes differ between the starting element and the destination element. These different CSS classes
	 * will be added/removed on the anchor element and a transition will be applied (the transition that is provided
	 * in the anchor class). Long story short, ngAnimate will figure out what classes to add and remove which will
	 * make the transition of the element as smooth and automatic as possible. Be sure to use simple CSS classes that
	 * do not rely on DOM nesting structure so that the anchor element appears the same as the starting element (since
	 * the cloned element is placed inside of root element which is likely close to the body element).
	 *
	 * Note that if the root element is on the `<html>` element then the cloned node will be placed inside of body.
	 *
	 *
	 * ## Using $animate in your directive code
	 *
	 * So far we've explored how to feed in animations into an Angular application, but how do we trigger animations within our own directives in our application?
	 * By injecting the `$animate` service into our directive code, we can trigger structural and class-based hooks which can then be consumed by animations. Let's
	 * imagine we have a greeting box that shows and hides itself when the data changes
	 *
	 * ```html
	 * <greeting-box active="onOrOff">Hi there</greeting-box>
	 * ```
	 *
	 * ```js
	 * ngModule.directive('greetingBox', ['$animate', function($animate) {
	 *   return function(scope, element, attrs) {
	 *     attrs.$observe('active', function(value) {
	 *       value ? $animate.addClass(element, 'on') : $animate.removeClass(element, 'on');
	 *     });
	 *   });
	 * }]);
	 * ```
	 *
	 * Now the `on` CSS class is added and removed on the greeting box component. Now if we add a CSS class on top of the greeting box element
	 * in our HTML code then we can trigger a CSS or JS animation to happen.
	 *
	 * ```css
	 * /&#42; normally we would create a CSS class to reference on the element &#42;/
	 * greeting-box.on { transition:0.5s linear all; background:green; color:white; }
	 * ```
	 *
	 * The `$animate` service contains a variety of other methods like `enter`, `leave`, `animate` and `setClass`. To learn more about what's
	 * possible be sure to visit the {@link ng.$animate $animate service API page}.
	 *
	 *
	 * ## Callbacks and Promises
	 *
	 * When `$animate` is called it returns a promise that can be used to capture when the animation has ended. Therefore if we were to trigger
	 * an animation (within our directive code) then we can continue performing directive and scope related activities after the animation has
	 * ended by chaining onto the returned promise that animation method returns.
	 *
	 * ```js
	 * // somewhere within the depths of the directive
	 * $animate.enter(element, parent).then(function() {
	 *   //the animation has completed
	 * });
	 * ```
	 *
	 * (Note that earlier versions of Angular prior to v1.4 required the promise code to be wrapped using `$scope.$apply(...)`. This is not the case
	 * anymore.)
	 *
	 * In addition to the animation promise, we can also make use of animation-related callbacks within our directives and controller code by registering
	 * an event listener using the `$animate` service. Let's say for example that an animation was triggered on our view
	 * routing controller to hook into that:
	 *
	 * ```js
	 * ngModule.controller('HomePageController', ['$animate', function($animate) {
	 *   $animate.on('enter', ngViewElement, function(element) {
	 *     // the animation for this route has completed
	 *   }]);
	 * }])
	 * ```
	 *
	 * (Note that you will need to trigger a digest within the callback to get angular to notice any scope-related changes.)
	 */
	
	/**
	 * @ngdoc service
	 * @name $animate
	 * @kind object
	 *
	 * @description
	 * The ngAnimate `$animate` service documentation is the same for the core `$animate` service.
	 *
	 * Click here {@link ng.$animate to learn more about animations with `$animate`}.
	 */
	angular.module('ngAnimate', [])
	  .directive('ngAnimateSwap', ngAnimateSwapDirective)
	
	  .directive('ngAnimateChildren', $$AnimateChildrenDirective)
	  .factory('$$rAFScheduler', $$rAFSchedulerFactory)
	
	  .provider('$$animateQueue', $$AnimateQueueProvider)
	  .provider('$$animation', $$AnimationProvider)
	
	  .provider('$animateCss', $AnimateCssProvider)
	  .provider('$$animateCssDriver', $$AnimateCssDriverProvider)
	
	  .provider('$$animateJs', $$AnimateJsProvider)
	  .provider('$$animateJsDriver', $$AnimateJsDriverProvider);
	
	
	})(window, window.angular);


/***/ }),
/* 1129 */
/***/ (function(module, exports) {

	/**
	 * @license AngularJS v1.5.6
	 * (c) 2010-2016 Google, Inc. http://angularjs.org
	 * License: MIT
	 */
	(function(window, angular) {'use strict';
	
	/**
	 * @ngdoc module
	 * @name ngCookies
	 * @description
	 *
	 * # ngCookies
	 *
	 * The `ngCookies` module provides a convenient wrapper for reading and writing browser cookies.
	 *
	 *
	 * <div doc-module-components="ngCookies"></div>
	 *
	 * See {@link ngCookies.$cookies `$cookies`} for usage.
	 */
	
	
	angular.module('ngCookies', ['ng']).
	  /**
	   * @ngdoc provider
	   * @name $cookiesProvider
	   * @description
	   * Use `$cookiesProvider` to change the default behavior of the {@link ngCookies.$cookies $cookies} service.
	   * */
	   provider('$cookies', [function $CookiesProvider() {
	    /**
	     * @ngdoc property
	     * @name $cookiesProvider#defaults
	     * @description
	     *
	     * Object containing default options to pass when setting cookies.
	     *
	     * The object may have following properties:
	     *
	     * - **path** - `{string}` - The cookie will be available only for this path and its
	     *   sub-paths. By default, this is the URL that appears in your `<base>` tag.
	     * - **domain** - `{string}` - The cookie will be available only for this domain and
	     *   its sub-domains. For security reasons the user agent will not accept the cookie
	     *   if the current domain is not a sub-domain of this domain or equal to it.
	     * - **expires** - `{string|Date}` - String of the form "Wdy, DD Mon YYYY HH:MM:SS GMT"
	     *   or a Date object indicating the exact date/time this cookie will expire.
	     * - **secure** - `{boolean}` - If `true`, then the cookie will only be available through a
	     *   secured connection.
	     *
	     * Note: By default, the address that appears in your `<base>` tag will be used as the path.
	     * This is important so that cookies will be visible for all routes when html5mode is enabled.
	     *
	     **/
	    var defaults = this.defaults = {};
	
	    function calcOptions(options) {
	      return options ? angular.extend({}, defaults, options) : defaults;
	    }
	
	    /**
	     * @ngdoc service
	     * @name $cookies
	     *
	     * @description
	     * Provides read/write access to browser's cookies.
	     *
	     * <div class="alert alert-info">
	     * Up until Angular 1.3, `$cookies` exposed properties that represented the
	     * current browser cookie values. In version 1.4, this behavior has changed, and
	     * `$cookies` now provides a standard api of getters, setters etc.
	     * </div>
	     *
	     * Requires the {@link ngCookies `ngCookies`} module to be installed.
	     *
	     * @example
	     *
	     * ```js
	     * angular.module('cookiesExample', ['ngCookies'])
	     *   .controller('ExampleController', ['$cookies', function($cookies) {
	     *     // Retrieving a cookie
	     *     var favoriteCookie = $cookies.get('myFavorite');
	     *     // Setting a cookie
	     *     $cookies.put('myFavorite', 'oatmeal');
	     *   }]);
	     * ```
	     */
	    this.$get = ['$$cookieReader', '$$cookieWriter', function($$cookieReader, $$cookieWriter) {
	      return {
	        /**
	         * @ngdoc method
	         * @name $cookies#get
	         *
	         * @description
	         * Returns the value of given cookie key
	         *
	         * @param {string} key Id to use for lookup.
	         * @returns {string} Raw cookie value.
	         */
	        get: function(key) {
	          return $$cookieReader()[key];
	        },
	
	        /**
	         * @ngdoc method
	         * @name $cookies#getObject
	         *
	         * @description
	         * Returns the deserialized value of given cookie key
	         *
	         * @param {string} key Id to use for lookup.
	         * @returns {Object} Deserialized cookie value.
	         */
	        getObject: function(key) {
	          var value = this.get(key);
	          return value ? angular.fromJson(value) : value;
	        },
	
	        /**
	         * @ngdoc method
	         * @name $cookies#getAll
	         *
	         * @description
	         * Returns a key value object with all the cookies
	         *
	         * @returns {Object} All cookies
	         */
	        getAll: function() {
	          return $$cookieReader();
	        },
	
	        /**
	         * @ngdoc method
	         * @name $cookies#put
	         *
	         * @description
	         * Sets a value for given cookie key
	         *
	         * @param {string} key Id for the `value`.
	         * @param {string} value Raw value to be stored.
	         * @param {Object=} options Options object.
	         *    See {@link ngCookies.$cookiesProvider#defaults $cookiesProvider.defaults}
	         */
	        put: function(key, value, options) {
	          $$cookieWriter(key, value, calcOptions(options));
	        },
	
	        /**
	         * @ngdoc method
	         * @name $cookies#putObject
	         *
	         * @description
	         * Serializes and sets a value for given cookie key
	         *
	         * @param {string} key Id for the `value`.
	         * @param {Object} value Value to be stored.
	         * @param {Object=} options Options object.
	         *    See {@link ngCookies.$cookiesProvider#defaults $cookiesProvider.defaults}
	         */
	        putObject: function(key, value, options) {
	          this.put(key, angular.toJson(value), options);
	        },
	
	        /**
	         * @ngdoc method
	         * @name $cookies#remove
	         *
	         * @description
	         * Remove given cookie
	         *
	         * @param {string} key Id of the key-value pair to delete.
	         * @param {Object=} options Options object.
	         *    See {@link ngCookies.$cookiesProvider#defaults $cookiesProvider.defaults}
	         */
	        remove: function(key, options) {
	          $$cookieWriter(key, undefined, calcOptions(options));
	        }
	      };
	    }];
	  }]);
	
	angular.module('ngCookies').
	/**
	 * @ngdoc service
	 * @name $cookieStore
	 * @deprecated
	 * @requires $cookies
	 *
	 * @description
	 * Provides a key-value (string-object) storage, that is backed by session cookies.
	 * Objects put or retrieved from this storage are automatically serialized or
	 * deserialized by angular's toJson/fromJson.
	 *
	 * Requires the {@link ngCookies `ngCookies`} module to be installed.
	 *
	 * <div class="alert alert-danger">
	 * **Note:** The $cookieStore service is **deprecated**.
	 * Please use the {@link ngCookies.$cookies `$cookies`} service instead.
	 * </div>
	 *
	 * @example
	 *
	 * ```js
	 * angular.module('cookieStoreExample', ['ngCookies'])
	 *   .controller('ExampleController', ['$cookieStore', function($cookieStore) {
	 *     // Put cookie
	 *     $cookieStore.put('myFavorite','oatmeal');
	 *     // Get cookie
	 *     var favoriteCookie = $cookieStore.get('myFavorite');
	 *     // Removing a cookie
	 *     $cookieStore.remove('myFavorite');
	 *   }]);
	 * ```
	 */
	 factory('$cookieStore', ['$cookies', function($cookies) {
	
	    return {
	      /**
	       * @ngdoc method
	       * @name $cookieStore#get
	       *
	       * @description
	       * Returns the value of given cookie key
	       *
	       * @param {string} key Id to use for lookup.
	       * @returns {Object} Deserialized cookie value, undefined if the cookie does not exist.
	       */
	      get: function(key) {
	        return $cookies.getObject(key);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $cookieStore#put
	       *
	       * @description
	       * Sets a value for given cookie key
	       *
	       * @param {string} key Id for the `value`.
	       * @param {Object} value Value to be stored.
	       */
	      put: function(key, value) {
	        $cookies.putObject(key, value);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $cookieStore#remove
	       *
	       * @description
	       * Remove given cookie
	       *
	       * @param {string} key Id of the key-value pair to delete.
	       */
	      remove: function(key) {
	        $cookies.remove(key);
	      }
	    };
	
	  }]);
	
	/**
	 * @name $$cookieWriter
	 * @requires $document
	 *
	 * @description
	 * This is a private service for writing cookies
	 *
	 * @param {string} name Cookie name
	 * @param {string=} value Cookie value (if undefined, cookie will be deleted)
	 * @param {Object=} options Object with options that need to be stored for the cookie.
	 */
	function $$CookieWriter($document, $log, $browser) {
	  var cookiePath = $browser.baseHref();
	  var rawDocument = $document[0];
	
	  function buildCookieString(name, value, options) {
	    var path, expires;
	    options = options || {};
	    expires = options.expires;
	    path = angular.isDefined(options.path) ? options.path : cookiePath;
	    if (angular.isUndefined(value)) {
	      expires = 'Thu, 01 Jan 1970 00:00:00 GMT';
	      value = '';
	    }
	    if (angular.isString(expires)) {
	      expires = new Date(expires);
	    }
	
	    var str = encodeURIComponent(name) + '=' + encodeURIComponent(value);
	    str += path ? ';path=' + path : '';
	    str += options.domain ? ';domain=' + options.domain : '';
	    str += expires ? ';expires=' + expires.toUTCString() : '';
	    str += options.secure ? ';secure' : '';
	
	    // per http://www.ietf.org/rfc/rfc2109.txt browser must allow at minimum:
	    // - 300 cookies
	    // - 20 cookies per unique domain
	    // - 4096 bytes per cookie
	    var cookieLength = str.length + 1;
	    if (cookieLength > 4096) {
	      $log.warn("Cookie '" + name +
	        "' possibly not set or overflowed because it was too large (" +
	        cookieLength + " > 4096 bytes)!");
	    }
	
	    return str;
	  }
	
	  return function(name, value, options) {
	    rawDocument.cookie = buildCookieString(name, value, options);
	  };
	}
	
	$$CookieWriter.$inject = ['$document', '$log', '$browser'];
	
	angular.module('ngCookies').provider('$$cookieWriter', function $$CookieWriterProvider() {
	  this.$get = $$CookieWriter;
	});
	
	
	})(window, window.angular);


/***/ }),
/* 1130 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1129);
	module.exports = 'ngCookies';


/***/ }),
/* 1131 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* globals define */
	(function (root, factory) {
	  'use strict';
	  if (typeof module !== 'undefined' && module.exports) {
	    if (typeof angular === 'undefined') {
	      factory(__webpack_require__(8));
	    } else {
	      factory(angular);
	    }
	    module.exports = 'angular-google-analytics';
	  } else if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(8)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else {
	    factory(root.angular);
	  }
	}(this, function (angular, undefined) {
	  'use strict';
	  angular.module('angular-google-analytics', [])
	    .provider('Analytics', function () {
	      var accounts,
	          analyticsJS = true,
	          cookieConfig = 'auto', // DEPRECATED
	          created = false,
	          crossDomainLinker = false,
	          crossLinkDomains,
	          currency = 'USD',
	          debugMode = false,
	          delayScriptTag = false,
	          displayFeatures = false,
	          disableAnalytics = false,
	          domainName,
	          ecommerce = false,
	          enhancedEcommerce = false,
	          enhancedLinkAttribution = false,
	          experimentId,
	          ignoreFirstPageLoad = false,
	          logAllCalls = false,
	          hybridMobileSupport = false,
	          offlineMode = false,
	          pageEvent = '$routeChangeSuccess',
	          readFromRoute = false,
	          removeRegExp,
	          testMode = false,
	          traceDebuggingMode = false,
	          trackPrefix = '',
	          trackRoutes = true,
	          trackUrlParams = false;
	
	      this.log = [];
	      this.offlineQueue = [];
	
	      /**
	       * Configuration Methods
	       **/
	
	      this.setAccount = function (tracker) {
	        if (angular.isUndefined(tracker) || tracker === false) {
	          accounts = undefined;
	        } else if (angular.isArray(tracker)) {
	          accounts = tracker;
	        } else if (angular.isObject(tracker)) {
	          accounts = [tracker];
	        } else {
	          // In order to preserve an existing behavior with how the _trackEvent function works,
	          // the trackEvent property must be set to true when there is only a single tracker.
	          accounts = [{ tracker: tracker, trackEvent: true }];
	        }
	        return this;
	      };
	
	      this.trackPages = function (val) {
	        trackRoutes = !!val;
	        return this;
	      };
	
	      this.trackPrefix = function (prefix) {
	        trackPrefix = prefix;
	        return this;
	      };
	
	      this.setDomainName = function (domain) {
	        domainName = domain;
	        return this;
	      };
	
	      this.useDisplayFeatures = function (val) {
	        displayFeatures = !!val;
	        return this;
	      };
	
	      this.useAnalytics = function (val) {
	        analyticsJS = !!val;
	        return this;
	      };
	
	      this.useEnhancedLinkAttribution = function (val) {
	        enhancedLinkAttribution = !!val;
	        return this;
	      };
	
	      this.useCrossDomainLinker = function (val) {
	        crossDomainLinker = !!val;
	        return this;
	      };
	
	      this.setCrossLinkDomains = function (domains) {
	        crossLinkDomains = domains;
	        return this;
	      };
	
	      this.setPageEvent = function (name) {
	        pageEvent = name;
	        return this;
	      };
	
	      /* DEPRECATED */
	      this.setCookieConfig = function (config) {
	        cookieConfig = config;
	        return this;
	      };
	
	      this.useECommerce = function (val, enhanced) {
	        ecommerce = !!val;
	        enhancedEcommerce = !!enhanced;
	        return this;
	      };
	
	      this.setCurrency = function (currencyCode) {
	        currency = currencyCode;
	        return this;
	      };
	
	      this.setRemoveRegExp = function (regex) {
	        if (regex instanceof RegExp) {
	          removeRegExp = regex;
	        }
	        return this;
	      };
	
	      this.setExperimentId = function (id) {
	        experimentId = id;
	        return this;
	      };
	
	      this.ignoreFirstPageLoad = function (val) {
	        ignoreFirstPageLoad = !!val;
	        return this;
	      };
	
	      this.trackUrlParams = function (val) {
	        trackUrlParams = !!val;
	        return this;
	      };
	
	      this.disableAnalytics = function (val) {
	        disableAnalytics = !!val;
	        return this;
	      };
	
	      this.setHybridMobileSupport = function (val) {
	        hybridMobileSupport = !!val;
	        return this;
	      };
	
	      this.startOffline = function (val) {
	        offlineMode = !!val;
	        if (offlineMode === true) {
	          this.delayScriptTag(true);
	        }
	        return this;
	      };
	
	      this.delayScriptTag = function (val) {
	        delayScriptTag = !!val;
	        return this;
	      };
	
	      this.logAllCalls = function (val) {
	        logAllCalls = !!val;
	        return this;
	      };
	
	      this.enterTestMode = function () {
	        testMode = true;
	        return this;
	      };
	
	      this.enterDebugMode = function (enableTraceDebugging) {
	        debugMode = true;
	        traceDebuggingMode = !!enableTraceDebugging;
	        return this;
	      };
	      
	      // Enable reading page url from route object
	      this.readFromRoute = function(val) {
	        readFromRoute = !!val;
	        return this;
	      };
	
	      /**
	       * Public Service
	       */
	      this.$get = ['$document', // To read page title 
	                   '$location', //
	                   '$log',      //
	                   '$rootScope',//
	                   '$window',   //
	                   '$injector', // To access ngRoute module without declaring a fixed dependency
	                   function ($document, $location, $log, $rootScope, $window, $injector) {
	        var that = this;
	
	        /**
	         * Side-effect Free Helper Methods
	         **/
	
	        var isPropertyDefined = function (key, config) {
	          return angular.isObject(config) && angular.isDefined(config[key]);
	        };
	
	        var isPropertySetTo = function (key, config, value) {
	          return isPropertyDefined(key, config) && config[key] === value;
	        };
	
	        var generateCommandName = function (commandName, config) {
	          if (angular.isString(config)) {
	            return config + '.' + commandName;
	          }
	          return isPropertyDefined('name', config) ? (config.name + '.' + commandName) : commandName;
	        };
	        
	        // Try to read route configuration and log warning if not possible
	        var $route = {};
	        if (readFromRoute) {
	          if (!$injector.has('$route')) {
	            $log.warn('$route service is not available. Make sure you have included ng-route in your application dependencies.');
	          } else {
	            $route = $injector.get('$route');
	          }
	        }
	
	        // Get url for current page 
	        var getUrl = function () {
	          // Using ngRoute provided tracking urls
	          if (readFromRoute && $route.current && ('pageTrack' in $route.current)) {
	            return $route.current.pageTrack;
	          }
	           
	          // Otherwise go the old way
	          var url = trackUrlParams ? $location.url() : $location.path(); 
	          return removeRegExp ? url.replace(removeRegExp, '') : url;
	        };
	
	        var getUtmParams = function () {
	          var utmToCampaignVar = {
	            utm_source: 'campaignSource',
	            utm_medium: 'campaignMedium',
	            utm_term: 'campaignTerm',
	            utm_content: 'campaignContent',
	            utm_campaign: 'campaignName'
	          };
	          var object = {};
	
	          angular.forEach($location.search(), function (value, key) {
	            var campaignVar = utmToCampaignVar[key];
	
	            if (angular.isDefined(campaignVar)) {
	              object[campaignVar] = value;
	            }
	          });
	
	          return object;
	        };
	
	        /**
	         * get ActionFieldObject
	         * https://developers.google.com/analytics/devguides/collection/analyticsjs/enhanced-ecommerce#action-data
	         * @param id
	         * @param affliation
	         * @param revenue
	         * @param tax
	         * @param shipping
	         * @param coupon
	         * @param list
	         * @param step
	         * @param option
	         */
	        var getActionFieldObject = function (id, affiliation, revenue, tax, shipping, coupon, list, step, option) {
	          var obj = {};
	          if (id) { obj.id = id; }
	          if (affiliation) { obj.affiliation = affiliation; }
	          if (revenue) { obj.revenue = revenue; }
	          if (tax) { obj.tax = tax; }
	          if (shipping) { obj.shipping = shipping; }
	          if (coupon) { obj.coupon = coupon; }
	          if (list) { obj.list = list; }
	          if (step) { obj.step = step; }
	          if (option) { obj.option = option; }
	          return obj;
	        };
	
	        /**
	         * Private Methods
	         */
	
	        var _getProtocol = function (httpPostfix, httpsPostfix) {
	          var protocol = '',
	              isSslEnabled = document.location.protocol === 'https:',
	              isChromeExtension = document.location.protocol === 'chrome-extension:',
	              isHybridApplication = analyticsJS === true && hybridMobileSupport === true;
	          httpPostfix = angular.isString(httpPostfix) ? httpPostfix : '';
	          httpsPostfix = angular.isString(httpsPostfix) ? httpsPostfix : '';
	          if (httpPostfix !== '') {
	            protocol = 'http:' + httpPostfix;
	          }
	          if (isChromeExtension || isHybridApplication || (isSslEnabled && httpsPostfix !== '')) {
	            protocol = 'https:' + httpsPostfix;
	          }
	          return protocol;
	        };
	
	        var _gaJs = function (fn) {
	          if (!analyticsJS && $window._gaq && typeof fn === 'function') {
	            fn();
	          }
	        };
	
	        var _gaq = function () {
	          var args = Array.prototype.slice.call(arguments);
	          if (offlineMode === true) {
	            that.offlineQueue.push([_gaq, args]);
	            return;
	          }
	          if (!$window._gaq) {
	            $window._gaq = [];
	          }
	          if (logAllCalls === true) {
	            that._log.apply(that, args);
	          }
	          $window._gaq.push(args);
	        };
	
	        var _analyticsJs = function (fn) {
	          if (analyticsJS && $window.ga && typeof fn === 'function') {
	            fn();
	          }
	        };
	
	        var _ga = function () {
	          var args = Array.prototype.slice.call(arguments);
	          if (offlineMode === true) {
	            that.offlineQueue.push([_ga, args]);
	            return;
	          }
	          if (typeof $window.ga !== 'function') {
	            that._log('warn', 'ga function not set on window');
	            return;
	          }
	          if (logAllCalls === true) {
	            that._log.apply(that, args);
	          }
	          $window.ga.apply(null, args);
	        };
	
	        var _gaMultipleTrackers = function (includeFn) {
	          // Drop the includeFn from the arguments and preserve the original command name
	          var args = Array.prototype.slice.call(arguments, 1),
	              commandName = args[0],
	              trackers = [];
	          if (typeof includeFn === 'function') {
	            accounts.forEach(function (account) {
	              if (includeFn(account)) {
	                trackers.push(account);
	              }
	            });
	          } else {
	            // No include function indicates that all accounts are to be used
	            trackers = accounts;
	          }
	
	          // To preserve backwards compatibility fallback to _ga method if no account
	          // matches the specified includeFn. This preserves existing behaviors by
	          // performing the single tracker operation.
	          if (trackers.length === 0) {
	            _ga.apply(that, args);
	            return;
	          }
	
	          trackers.forEach(function (tracker) {
	            // Check tracker 'select' function, if it exists, for whether the tracker should be used with the current command.
	            // If the 'select' function returns false then the tracker will not be used with the current command.
	            if (isPropertyDefined('select', tracker) && typeof tracker.select === 'function' && !tracker.select(args)) {
	              return;
	            }
	            args[0] = generateCommandName(commandName, tracker);
	            _ga.apply(that, args);
	          });
	        };
	
	        this._log = function () {
	          var args = Array.prototype.slice.call(arguments);
	          if (args.length > 0) {
	            if (args.length > 1) {
	              switch (args[0]) {
	                case 'debug':
	                case 'error':
	                case 'info':
	                case 'log':
	                case 'warn':
	                  $log[args[0]](args.slice(1));
	                  break;
	              }
	            }
	            that.log.push(args);
	          }
	        };
	
	        /* DEPRECATED */
	        this._createScriptTag = function () {
	          that._registerScriptTags();
	          that._registerTrackers();
	        };
	
	        /* DEPRECATED */
	        this._createAnalyticsScriptTag = function () {
	          that._registerScriptTags();
	          that._registerTrackers();
	        };
	
	        this._registerScriptTags = function () {
	          var document = $document[0],
	              protocol = _getProtocol(),
	              scriptSource;
	
	          if (created === true) {
	            that._log('warn', 'Script tags already created');
	            return;
	          }
	
	          if (disableAnalytics === true) {
	            accounts.forEach(function (trackerObj) {
	              that._log('info', 'Analytics disabled: ' + trackerObj.tracker);
	              $window['ga-disable-' + trackerObj.tracker] = true;
	            });
	          }
	
	          //
	          // Universal Analytics
	          //
	          if (analyticsJS === true) {
	            scriptSource = protocol + '//www.google-analytics.com/' + (debugMode ? 'analytics_debug.js' : 'analytics.js');
	            if (testMode !== true) {
	              // If not in test mode inject the Google Analytics tag
	              (function (i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function (){
	                (i[r].q=i[r].q||[]).push(arguments);},i[r].l=1*new Date();a=s.createElement(o),
	                m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m);
	              })(window,document,'script',scriptSource,'ga');
	            } else {
	              if (typeof $window.ga !== 'function') {
	                // In test mode create a ga function if none exists that is a noop sink.
	                $window.ga = function () {};
	              }
	              // Log script injection.
	              that._log('inject', scriptSource);
	            }
	
	            if (traceDebuggingMode) {
	              $window.ga_debug = { trace: true };
	            }
	
	            if (experimentId) {
	              var expScript = document.createElement('script'),
	                  s = document.getElementsByTagName('script')[0];
	              expScript.src = protocol + '//www.google-analytics.com/cx/api.js?experiment=' + experimentId;
	              s.parentNode.insertBefore(expScript, s);
	            }
	          //
	          // Classic Analytics
	          //
	          } else {
	            scriptSource = _getProtocol('//www', '//ssl') + '.google-analytics.com/ga.js';
	            if (displayFeatures === true) {
	              scriptSource = protocol + '//stats.g.doubleclick.net/dc.js';
	            }
	
	            if (testMode !== true) {
	              // If not in test mode inject the Google Analytics tag
	              (function () {
	                var ga = document.createElement('script'); ga.type = 'text/javascript'; ga.async = true;
	                ga.src = scriptSource;
	                var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(ga, s);
	              })();
	            } else {
	              // Log the source location for validation
	              that._log('inject', scriptSource);
	            }
	          }
	
	          created = true;
	          return true;
	        };
	
	        this._registerTrackers = function () {
	          if (!accounts || accounts.length < 1) {
	            that._log('warn', 'No accounts to register');
	            return;
	          }
	
	          //
	          // Universal Analytics
	          //
	          if (analyticsJS === true) {
	            accounts.forEach(function (trackerObj) {
	              trackerObj.crossDomainLinker = isPropertyDefined('crossDomainLinker', trackerObj) ? trackerObj.crossDomainLinker : crossDomainLinker;
	              trackerObj.crossLinkDomains = isPropertyDefined('crossLinkDomains', trackerObj) ? trackerObj.crossLinkDomains : crossLinkDomains;
	              trackerObj.displayFeatures = isPropertyDefined('displayFeatures', trackerObj) ? trackerObj.displayFeatures : displayFeatures;
	              trackerObj.enhancedLinkAttribution = isPropertyDefined('enhancedLinkAttribution', trackerObj) ? trackerObj.enhancedLinkAttribution : enhancedLinkAttribution;
	              trackerObj.set = isPropertyDefined('set', trackerObj) ? trackerObj.set : {};
	              trackerObj.trackEcommerce = isPropertyDefined('trackEcommerce', trackerObj) ? trackerObj.trackEcommerce : ecommerce;
	              trackerObj.trackEvent = isPropertyDefined('trackEvent', trackerObj) ? trackerObj.trackEvent : false;
	
	              // Logic to choose the account fields to be used.
	              // cookieConfig is being deprecated for a tracker specific property: fields.
	              var fields = {};
	              if (isPropertyDefined('fields', trackerObj)) {
	                fields = trackerObj.fields;
	              } else if (isPropertyDefined('cookieConfig', trackerObj)) {
	                if (angular.isString(trackerObj.cookieConfig)) {
	                  fields.cookieDomain = trackerObj.cookieConfig;
	                } else {
	                  fields = trackerObj.cookieConfig;
	                }
	              } else if (angular.isString(cookieConfig)) {
	                fields.cookieDomain = cookieConfig;
	              } else if (cookieConfig) {
	                fields = cookieConfig;
	              }
	              if (trackerObj.crossDomainLinker === true) {
	                fields.allowLinker = true;
	              }
	              if (isPropertyDefined('name', trackerObj)) {
	                fields.name = trackerObj.name;
	              }
	              trackerObj.fields = fields;
	
	              _ga('create', trackerObj.tracker, trackerObj.fields);
	
	              // Hybrid mobile application support
	              // https://developers.google.com/analytics/devguides/collection/analyticsjs/tasks
	              if (hybridMobileSupport === true) {
	                _ga(generateCommandName('set', trackerObj), 'checkProtocolTask', null);
	              }
	
	              // Send all custom set commands from the trackerObj.set property
	              for (var key in trackerObj.set) {
	                if (trackerObj.set.hasOwnProperty(key)) {
	                  _ga(generateCommandName('set', trackerObj), key, trackerObj.set[key]);
	                }
	              }
	
	              if (trackerObj.crossDomainLinker === true) {
	                _ga(generateCommandName('require', trackerObj), 'linker');
	                if (angular.isDefined(trackerObj.crossLinkDomains)) {
	                  _ga(generateCommandName('linker:autoLink', trackerObj), trackerObj.crossLinkDomains);
	                }
	              }
	
	              if (trackerObj.displayFeatures) {
	                _ga(generateCommandName('require', trackerObj), 'displayfeatures');
	              }
	
	              if (trackerObj.trackEcommerce) {
	                if (!enhancedEcommerce) {
	                  _ga(generateCommandName('require', trackerObj), 'ecommerce');
	                } else {
	                  _ga(generateCommandName('require', trackerObj), 'ec');
	                  _ga(generateCommandName('set', trackerObj), '&cu', currency);
	                }
	              }
	
	              if (trackerObj.enhancedLinkAttribution) {
	                _ga(generateCommandName('require', trackerObj), 'linkid');
	              }
	
	              if (trackRoutes && !ignoreFirstPageLoad) {
	                _ga(generateCommandName('send', trackerObj), 'pageview', trackPrefix + getUrl());
	              }
	            });
	          //
	          // Classic Analytics
	          //
	          } else {
	            if (accounts.length > 1) {
	              that._log('warn', 'Multiple trackers are not supported with ga.js. Using first tracker only');
	              accounts = accounts.slice(0, 1);
	            }
	
	            _gaq('_setAccount', accounts[0].tracker);
	            if(domainName) {
	              _gaq('_setDomainName', domainName);
	            }
	            if (enhancedLinkAttribution) {
	              _gaq('_require', 'inpage_linkid', '//www.google-analytics.com/plugins/ga/inpage_linkid.js');
	            }
	            if (trackRoutes && !ignoreFirstPageLoad) {
	              if (removeRegExp) {
	                _gaq('_trackPageview', getUrl());
	              } else {
	                _gaq('_trackPageview');
	              }
	            }
	          }
	
	          return true;
	        };
	
	        this._ecommerceEnabled = function (warn, command) {
	          var result = ecommerce && !enhancedEcommerce;
	          if (warn === true && result === false) {
	            if (ecommerce && enhancedEcommerce) {
	              that._log('warn', command + ' is not available when Enhanced Ecommerce is enabled with analytics.js');
	            } else {
	              that._log('warn', 'Ecommerce must be enabled to use ' + command + ' with analytics.js');
	            }
	          }
	          return result;
	        };
	
	        this._enhancedEcommerceEnabled = function (warn, command) {
	          var result = ecommerce && enhancedEcommerce;
	          if (warn === true && result === false) {
	            that._log('warn', 'Enhanced Ecommerce must be enabled to use ' + command + ' with analytics.js');
	          }
	          return result;
	        };
	
	        /**
	         * Track page
	         https://developers.google.com/analytics/devguides/collection/gajs/
	         https://developers.google.com/analytics/devguides/collection/analyticsjs/pages
	         * @param url
	         * @param title
	         * @param custom
	         * @private
	         */
	        this._trackPage = function (url, title, custom) {
	          url = url ? url : getUrl();
	          title = title ? title : $document[0].title;
	          _gaJs(function () {
	            // http://stackoverflow.com/questions/7322288/how-can-i-set-a-page-title-with-google-analytics
	            _gaq('_set', 'title', title);
	            _gaq('_trackPageview', (trackPrefix + url));
	          });
	          _analyticsJs(function () {
	            var opt_fieldObject = {
	              'page': trackPrefix + url,
	              'title': title
	            };
	            angular.extend(opt_fieldObject, getUtmParams());
	            if (angular.isObject(custom)) {
	              angular.extend(opt_fieldObject, custom);
	            }
	            _gaMultipleTrackers(undefined, 'send', 'pageview', opt_fieldObject);
	          });
	        };
	
	        /**
	         * Track event
	         https://developers.google.com/analytics/devguides/collection/gajs/eventTrackerGuide
	         https://developers.google.com/analytics/devguides/collection/analyticsjs/events
	         * @param category
	         * @param action
	         * @param label
	         * @param value
	         * @param noninteraction
	         * @param custom
	         * @private
	         */
	        this._trackEvent = function (category, action, label, value, noninteraction, custom) {
	          _gaJs(function () {
	            _gaq('_trackEvent', category, action, label, value, !!noninteraction);
	          });
	          _analyticsJs(function () {
	            var opt_fieldObject = {};
	            var includeFn = function (trackerObj) {
	              return isPropertySetTo('trackEvent', trackerObj, true);
	            };
	
	            if (angular.isDefined(noninteraction)) {
	              opt_fieldObject.nonInteraction = !!noninteraction;
	            }
	            if (angular.isObject(custom)) {
	              angular.extend(opt_fieldObject, custom);
	            }
	            if (!angular.isDefined(opt_fieldObject.page)) {
	              opt_fieldObject.page = getUrl();
	            }
	            _gaMultipleTrackers(includeFn, 'send', 'event', category, action, label, value, opt_fieldObject);
	          });
	        };
	
	        /**
	         * Add transaction
	         * https://developers.google.com/analytics/devguides/collection/gajs/methods/gaJSApiEcommerce#_gat.GA_Tracker_._addTrans
	         * https://developers.google.com/analytics/devguides/collection/analyticsjs/ecommerce#addTrans
	         * @param transactionId
	         * @param affiliation
	         * @param total
	         * @param tax
	         * @param shipping
	         * @param city
	         * @param state
	         * @param country
	         * @private
	         */
	        this._addTrans = function (transactionId, affiliation, total, tax, shipping, city, state, country, currency) {
	          _gaJs(function () {
	            _gaq('_addTrans', transactionId, affiliation, total, tax, shipping, city, state, country);
	          });
	          _analyticsJs(function () {
	            if (that._ecommerceEnabled(true, 'addTrans')) {
	              var includeFn = function (trackerObj) {
	                return isPropertySetTo('trackEcommerce', trackerObj, true);
	              };
	
	              _gaMultipleTrackers(
	                includeFn,
	                'ecommerce:addTransaction',
	                {
	                  id: transactionId,
	                  affiliation: affiliation,
	                  revenue: total,
	                  tax: tax,
	                  shipping: shipping,
	                  currency: currency || 'USD'
	                });
	            }
	          });
	        };
	
	        /**
	         * Add item to transaction
	         * https://developers.google.com/analytics/devguides/collection/gajs/methods/gaJSApiEcommerce#_gat.GA_Tracker_._addItem
	         * https://developers.google.com/analytics/devguides/collection/analyticsjs/ecommerce#addItem
	         * @param transactionId
	         * @param sku
	         * @param name
	         * @param category
	         * @param price
	         * @param quantity
	         * @private
	         */
	        this._addItem = function (transactionId, sku, name, category, price, quantity) {
	          _gaJs(function () {
	            _gaq('_addItem', transactionId, sku, name, category, price, quantity);
	          });
	          _analyticsJs(function () {
	            if (that._ecommerceEnabled(true, 'addItem')) {
	              var includeFn = function (trackerObj) {
	                return isPropertySetTo('trackEcommerce', trackerObj, true);
	              };
	
	              _gaMultipleTrackers(
	                includeFn,
	                'ecommerce:addItem',
	                {
	                  id: transactionId,
	                  name: name,
	                  sku: sku,
	                  category: category,
	                  price: price,
	                  quantity: quantity
	                });
	            }
	          });
	        };
	
	        /**
	         * Track transaction
	         * https://developers.google.com/analytics/devguides/collection/gajs/methods/gaJSApiEcommerce#_gat.GA_Tracker_._trackTrans
	         * https://developers.google.com/analytics/devguides/collection/analyticsjs/ecommerce#sendingData
	         * @private
	         */
	        this._trackTrans = function () {
	          _gaJs(function () {
	            _gaq('_trackTrans');
	          });
	          _analyticsJs(function () {
	            if (that._ecommerceEnabled(true, 'trackTrans')) {
	              var includeFn = function (trackerObj) {
	                return isPropertySetTo('trackEcommerce', trackerObj, true);
	              };
	
	              _gaMultipleTrackers(includeFn, 'ecommerce:send');
	            }
	          });
	        };
	
	        /**
	         * Clear transaction
	         * https://developers.google.com/analytics/devguides/collection/analyticsjs/ecommerce#clearingData
	         * @private
	         */
	        this._clearTrans = function () {
	          _analyticsJs(function () {
	            if (that._ecommerceEnabled(true, 'clearTrans')) {
	              var includeFn = function (trackerObj) {
	                return isPropertySetTo('trackEcommerce', trackerObj, true);
	              };
	
	              _gaMultipleTrackers(includeFn, 'ecommerce:clear');
	            }
	          });
	        };
	
	        /**
	         * Enhanced Ecommerce
	         */
	
	        /**
	         * Add Product
	         * https://developers.google.com/analytics/devguides/collection/analyticsjs/enhanced-ecommerce#product-data
	         * @param productId
	         * @param name
	         * @param category
	         * @param brand
	         * @param variant
	         * @param price
	         * @param quantity
	         * @param coupon
	         * @param position
	         * @param custom
	         * @private
	         */
	        this._addProduct = function (productId, name, category, brand, variant, price, quantity, coupon, position, custom) {
	          _gaJs(function () {
	            _gaq('_addProduct', productId, name, category, brand, variant, price, quantity, coupon, position);
	          });
	          _analyticsJs(function () {
	            if (that._enhancedEcommerceEnabled(true, 'addProduct')) {
	              var includeFn = function (trackerObj) {
	                return isPropertySetTo('trackEcommerce', trackerObj, true);
	              };
	              var details = {
	                id: productId,
	                name: name,
	                category: category,
	                brand: brand,
	                variant: variant,
	                price: price,
	                quantity: quantity,
	                coupon: coupon,
	                position: position
	              };
	              if (angular.isObject(custom)) {
	                angular.extend(details, custom);
	              }
	              _gaMultipleTrackers(includeFn, 'ec:addProduct', details);
	            }
	          });
	        };
	
	        /**
	         * Add Impression
	         * https://developers.google.com/analytics/devguides/collection/analyticsjs/enhanced-ecommerce#impression-data
	         * @param id
	         * @param name
	         * @param list
	         * @param brand
	         * @param category
	         * @param variant
	         * @param position
	         * @param price
	         * @private
	         */
	        this._addImpression = function (id, name, list, brand, category, variant, position, price){
	          _gaJs(function () {
	            _gaq('_addImpression', id, name, list, brand, category, variant, position, price);
	          });
	          _analyticsJs(function () {
	            if (that._enhancedEcommerceEnabled(true, 'addImpression')) {
	              var includeFn = function (trackerObj) {
	                return isPropertySetTo('trackEcommerce', trackerObj, true);
	              };
	
	              _gaMultipleTrackers(
	                includeFn,
	                'ec:addImpression',
	                {
	                  id: id,
	                  name: name,
	                  category: category,
	                  brand: brand,
	                  variant: variant,
	                  list: list,
	                  position: position,
	                  price: price
	                });
	            }
	          });
	        };
	
	        /**
	         * Add Promo
	         * https://developers.google.com/analytics/devguides/collection/analyticsjs/enhanced-ecommerce
	         * @param productId
	         * @param name
	         * @param creative
	         * @param position
	         * @private
	         */
	        this._addPromo = function (productId, name, creative, position) {
	          _gaJs(function () {
	            _gaq('_addPromo', productId, name, creative, position);
	          });
	          _analyticsJs(function () {
	            if (that._enhancedEcommerceEnabled(true, 'addPromo')) {
	              var includeFn = function (trackerObj) {
	                return isPropertySetTo('trackEcommerce', trackerObj, true);
	              };
	
	              _gaMultipleTrackers(
	                includeFn,
	                'ec:addPromo',
	                {
	                  id: productId,
	                  name: name,
	                  creative: creative,
	                  position: position
	                });
	            }
	          });
	        };
	
	        /**
	         * Set Action
	         * https://developers.google.com/analytics/devguides/collection/analyticsjs/enhanced-ecommerce#measuring-actions
	         * https://developers.google.com/analytics/devguides/collection/analyticsjs/enhanced-ecommerce#action-types
	         * @param action
	         * @param obj
	         * @private
	         */
	        this._setAction = function (action, obj){
	          _gaJs(function () {
	            _gaq('_setAction', action, obj);
	          });
	          _analyticsJs(function () {
	            if (that._enhancedEcommerceEnabled(true, 'setAction')) {
	              var includeFn = function (trackerObj) {
	                return isPropertySetTo('trackEcommerce', trackerObj, true);
	              };
	
	              _gaMultipleTrackers(includeFn, 'ec:setAction', action, obj);
	            }
	          });
	        };
	
	        /**
	         * Track Transaction
	         * https://developers.google.com/analytics/devguides/collection/analyticsjs/enhanced-ecommerce#measuring-transactions
	         * @param transactionId
	         * @param affiliation
	         * @param revenue
	         * @param tax
	         * @param shipping
	         * @param coupon
	         * @param list
	         * @param step
	         * @param option
	         * @private
	         */
	        this._trackTransaction = function (transactionId, affiliation, revenue, tax, shipping, coupon, list, step, option) {
	          this._setAction('purchase', getActionFieldObject(transactionId, affiliation, revenue, tax, shipping, coupon, list, step, option));
	        };
	
	        /**
	         * Track Refund
	         * https://developers.google.com/analytics/devguides/collection/analyticsjs/enhanced-ecommerce#measuring-refunds
	         * @param transactionId
	         * @private
	         */
	        this._trackRefund = function (transactionId) {
	          this._setAction('refund', getActionFieldObject(transactionId));
	        };
	
	        /**
	         * Track Checkout
	         * https://developers.google.com/analytics/devguides/collection/analyticsjs/enhanced-ecommerce#measuring-checkout
	         * @param step
	         * @param option
	         * @private
	         */
	        this._trackCheckOut = function (step, option) {
	          this._setAction('checkout', getActionFieldObject(null, null, null, null, null, null, null, step, option));
	        };
	
	        /**
	         * Track detail
	         * @private
	         */
	        this._trackDetail = function () {
	          this._setAction('detail');
	          this._pageView();
	        };
	
	        /**
	         * Track add/remove to cart
	         * https://developers.google.com/analytics/devguides/collection/analyticsjs/enhanced-ecommerce#add-remove-cart
	         * @param action
	         * @param list
	         * @private
	         */
	        this._trackCart = function (action, listName) {
	          if (['add', 'remove'].indexOf(action) !== -1) {
	            this._setAction(action, { list: listName });
	            this._trackEvent('UX', 'click', action + (action === 'add' ? ' to cart' : ' from cart'));
	          }
	        };
	
	        /**
	         * Track promo click
	         * https://developers.google.com/analytics/devguides/collection/analyticsjs/enhanced-ecommerce#measuring-promo-clicks
	         * @param promotionName
	         * @private
	         */
	        this._promoClick = function (promotionName) {
	          this._setAction('promo_click');
	          this._trackEvent('Internal Promotions', 'click', promotionName);
	        };
	
	        /**
	         * Track product click
	         * https://developers.google.com/analytics/devguides/collection/analyticsjs/enhanced-ecommerce#measuring-promo-clicks
	         * @param promotionName
	         * @private
	         */
	        this._productClick = function (listName) {
	          this._setAction('click', getActionFieldObject(null, null, null, null, null, null, listName, null, null));
	          this._trackEvent('UX', 'click', listName);
	        };
	
	        /**
	         * Send page view
	         * @param trackerName
	         * @private
	         */
	        this._pageView = function (trackerName) {
	          _analyticsJs(function () {
	            _ga(generateCommandName('send', trackerName), 'pageview');
	          });
	        };
	
	        /**
	         * Send custom events
	         * https://developers.google.com/analytics/devguides/collection/analyticsjs/user-timings#implementation
	         * https://developers.google.com/analytics/devguides/collection/analyticsjs/social-interactions#implementation
	         * @private
	         */
	        this._send = function () {
	          var args = Array.prototype.slice.call(arguments);
	          args.unshift('send');
	          _analyticsJs(function () {
	            _ga.apply(that, args);
	          });
	        };
	
	        /**
	         * Set custom dimensions, metrics or experiment
	         * https://developers.google.com/analytics/devguides/collection/analyticsjs/custom-dims-mets
	         * https://developers.google.com/analytics/devguides/collection/analyticsjs/field-reference#customs
	         * @param name (Required)
	         * @param value (Required)
	         * @param trackerName (Optional)
	         * @private
	         */
	        this._set = function (name, value, trackerName) {
	          _analyticsJs(function () {
	            _ga(generateCommandName('set', trackerName), name, value);
	          });
	        };
	
	        /**
	         * Track user timings
	         * @param timingCategory (Required): A string for categorizing all user timing variables into logical groups(e.g jQuery).
	         * @param timingVar (Required): A string to identify the variable being recorded(e.g. JavaScript Load).
	         * @param timingValue (Required): The number of milliseconds in elapsed time to report to Google Analytics(e.g. 20).
	         * @param timingLabel (Optional): A string that can be used to add flexibility in visualizing user timings in the reports(e.g. Google CDN).
	         * @private
	         */
	        this._trackTimings = function (timingCategory, timingVar, timingValue, timingLabel) {
	          _analyticsJs(function () {
	            _gaMultipleTrackers(undefined, 'send', 'timing', timingCategory, timingVar, timingValue, timingLabel);
	          });
	        };
	
	        /**
	         * Exception tracking
	         * https://developers.google.com/analytics/devguides/collection/analyticsjs/exceptions
	         * @param description (Optional): A description of the exception.
	         * @param isFatal (Optional): true if the exception was fatal, false otherwise.
	         * @private
	         */
	        this._trackException = function (description, isFatal) {
	          _analyticsJs(function () {
	            _gaMultipleTrackers(undefined, 'send', 'exception', { exDescription: description, exFatal: !!isFatal});
	          });
	        };
	
	        // creates the Google Analytics tracker
	        if (!delayScriptTag) {
	          this._registerScriptTags();
	          this._registerTrackers();
	        }
	
	        // activates page tracking
	        if (trackRoutes) {
	          $rootScope.$on(pageEvent, function () {
	            // Apply $route based filtering if configured
	            if (readFromRoute) {
	              // Avoid tracking undefined routes, routes without template (e.g. redirect routes)
	              // and those explicitly marked as 'do not track'
	              if (!$route.current || !$route.current.templateUrl || $route.current.doNotTrack) {
	                return;
	              }
	            }
	            
	            that._trackPage();
	          });
	        }
	
	        return {
	          log: that.log,
	          offlineQueue: that.offlineQueue,
	          configuration: {
	            accounts: accounts,
	            universalAnalytics: analyticsJS,
	            crossDomainLinker: crossDomainLinker,
	            crossLinkDomains: crossLinkDomains,
	            currency: currency,
	            debugMode: debugMode,
	            delayScriptTag: delayScriptTag,
	            disableAnalytics: disableAnalytics,
	            displayFeatures: displayFeatures,
	            domainName: domainName,
	            ecommerce: that._ecommerceEnabled(),
	            enhancedEcommerce: that._enhancedEcommerceEnabled(),
	            enhancedLinkAttribution: enhancedLinkAttribution,
	            experimentId: experimentId,
	            hybridMobileSupport: hybridMobileSupport,
	            ignoreFirstPageLoad: ignoreFirstPageLoad,
	            logAllCalls: logAllCalls,
	            pageEvent: pageEvent,
	            readFromRoute: readFromRoute,
	            removeRegExp: removeRegExp,
	            testMode: testMode,
	            traceDebuggingMode: traceDebuggingMode,
	            trackPrefix: trackPrefix,
	            trackRoutes: trackRoutes,
	            trackUrlParams: trackUrlParams
	          },
	          getUrl: getUrl,
	          /* DEPRECATED */
	          setCookieConfig: function (config) {
	            that._log('warn', 'DEPRECATION WARNING: setCookieConfig method is deprecated. Please use tracker fields instead.');
	            return that._setCookieConfig.apply(that, arguments);
	          },
	          /* DEPRECATED */
	          getCookieConfig: function () {
	            that._log('warn', 'DEPRECATION WARNING: getCookieConfig method is deprecated. Please use tracker fields instead.');
	            return cookieConfig;
	          },
	          /* DEPRECATED */
	          createAnalyticsScriptTag: function (config) {
	            that._log('warn', 'DEPRECATION WARNING: createAnalyticsScriptTag method is deprecated. Please use registerScriptTags and registerTrackers methods instead.');
	            if (config) {
	              cookieConfig = config;
	            }
	            return that._createAnalyticsScriptTag();
	          },
	          /* DEPRECATED */
	          createScriptTag: function () {
	            that._log('warn', 'DEPRECATION WARNING: createScriptTag method is deprecated. Please use registerScriptTags and registerTrackers methods instead.');
	            return that._createScriptTag();
	          },
	          registerScriptTags: function () {
	            return that._registerScriptTags();
	          },
	          registerTrackers: function () {
	            return that._registerTrackers();
	          },
	          offline: function (mode) {
	            if (mode === true && offlineMode === false) {
	              // Go to offline mode
	              offlineMode = true;
	            }
	            if (mode === false && offlineMode === true) {
	              // Go to online mode and process the offline queue
	              offlineMode = false;
	              while (that.offlineQueue.length > 0) {
	                var obj = that.offlineQueue.shift();
	                obj[0].apply(that, obj[1]);
	              }
	            }
	            return offlineMode;
	          },
	          trackPage: function (url, title, custom) {
	            that._trackPage.apply(that, arguments);
	          },
	          trackEvent: function (category, action, label, value, noninteraction, custom) {
	            that._trackEvent.apply(that, arguments);
	          },
	          addTrans: function (transactionId, affiliation, total, tax, shipping, city, state, country, currency) {
	            that._addTrans.apply(that, arguments);
	          },
	          addItem: function (transactionId, sku, name, category, price, quantity) {
	            that._addItem.apply(that, arguments);
	          },
	          trackTrans: function () {
	            that._trackTrans.apply(that, arguments);
	          },
	          clearTrans: function () {
	            that._clearTrans.apply(that, arguments);
	          },
	          addProduct: function (productId, name, category, brand, variant, price, quantity, coupon, position, custom) {
	            that._addProduct.apply(that, arguments);
	          },
	          addPromo: function (productId, name, creative, position) {
	            that._addPromo.apply(that, arguments);
	          },
	          addImpression: function (productId, name, list, brand, category, variant, position, price) {
	            that._addImpression.apply(that, arguments);
	          },
	          productClick: function (listName) {
	            that._productClick.apply(that, arguments);
	          },
	          promoClick : function (promotionName) {
	            that._promoClick.apply(that, arguments);
	          },
	          trackDetail: function () {
	            that._trackDetail.apply(that, arguments);
	          },
	          trackCart: function (action, list) {
	            that._trackCart.apply(that, arguments);
	          },
	          trackCheckout: function (step, option) {
	            that._trackCheckOut.apply(that, arguments);
	          },
	          trackTimings: function (timingCategory, timingVar, timingValue, timingLabel) {
	            that._trackTimings.apply(that, arguments);
	          },
	          trackTransaction: function (transactionId, affiliation, revenue, tax, shipping, coupon, list, step, option) {
	            that._trackTransaction.apply(that, arguments);
	          },
	          trackException: function (description, isFatal) {
	            that._trackException.apply(that, arguments);
	          },
	          setAction: function (action, obj) {
	            that._setAction.apply(that, arguments);
	          },
	          pageView: function () {
	            that._pageView.apply(that, arguments);
	          },
	          send: function (obj) {
	            that._send.apply(that, arguments);
	          },
	          set: function (name, value, trackerName) {
	            that._set.apply(that, arguments);
	          }
	        };
	      }];
	    })
	
	    .directive('gaTrackEvent', ['Analytics', '$parse', function (Analytics, $parse) {
	      return {
	        restrict: 'A',
	        link: function (scope, element, attrs) {
	          var options = $parse(attrs.gaTrackEvent);
	          element.bind('click', function () {
	            if(attrs.gaTrackEventIf){
	              if(!scope.$eval(attrs.gaTrackEventIf)){
	                return; // Cancel this event if we don't pass the ga-track-event-if condition
	              }
	            }
	            if (options.length > 1) {
	              Analytics.trackEvent.apply(Analytics, options(scope));
	            }
	          });
	        }
	      };
	    }]);
	  return angular.module('angular-google-analytics');
	}));


/***/ }),
/* 1132 */
/***/ (function(module, exports) {

	/**
	 * @license AngularJS v1.5.6
	 * (c) 2010-2016 Google, Inc. http://angularjs.org
	 * License: MIT
	 */
	(function(window, angular) {'use strict';
	
	/* jshint ignore:start */
	// this code is in the core, but not in angular-messages.js
	var isArray = angular.isArray;
	var forEach = angular.forEach;
	var isString = angular.isString;
	var jqLite = angular.element;
	/* jshint ignore:end */
	
	/**
	 * @ngdoc module
	 * @name ngMessages
	 * @description
	 *
	 * The `ngMessages` module provides enhanced support for displaying messages within templates
	 * (typically within forms or when rendering message objects that return key/value data).
	 * Instead of relying on JavaScript code and/or complex ng-if statements within your form template to
	 * show and hide error messages specific to the state of an input field, the `ngMessages` and
	 * `ngMessage` directives are designed to handle the complexity, inheritance and priority
	 * sequencing based on the order of how the messages are defined in the template.
	 *
	 * Currently, the ngMessages module only contains the code for the `ngMessages`, `ngMessagesInclude`
	 * `ngMessage` and `ngMessageExp` directives.
	 *
	 * # Usage
	 * The `ngMessages` directive allows keys in a key/value collection to be associated with a child element
	 * (or 'message') that will show or hide based on the truthiness of that key's value in the collection. A common use
	 * case for `ngMessages` is to display error messages for inputs using the `$error` object exposed by the
	 * {@link ngModel ngModel} directive.
	 *
	 * The child elements of the `ngMessages` directive are matched to the collection keys by a `ngMessage` or
	 * `ngMessageExp` directive. The value of these attributes must match a key in the collection that is provided by
	 * the `ngMessages` directive.
	 *
	 * Consider the following example, which illustrates a typical use case of `ngMessages`. Within the form `myForm` we
	 * have a text input named `myField` which is bound to the scope variable `field` using the {@link ngModel ngModel}
	 * directive.
	 *
	 * The `myField` field is a required input of type `email` with a maximum length of 15 characters.
	 *
	 * ```html
	 * <form name="myForm">
	 *   <label>
	 *     Enter text:
	 *     <input type="email" ng-model="field" name="myField" required maxlength="15" />
	 *   </label>
	 *   <div ng-messages="myForm.myField.$error" role="alert">
	 *     <div ng-message="required">Please enter a value for this field.</div>
	 *     <div ng-message="email">This field must be a valid email address.</div>
	 *     <div ng-message="maxlength">This field can be at most 15 characters long.</div>
	 *   </div>
	 * </form>
	 * ```
	 *
	 * In order to show error messages corresponding to `myField` we first create an element with an `ngMessages` attribute
	 * set to the `$error` object owned by the `myField` input in our `myForm` form.
	 *
	 * Within this element we then create separate elements for each of the possible errors that `myField` could have.
	 * The `ngMessage` attribute is used to declare which element(s) will appear for which error - for example,
	 * setting `ng-message="required"` specifies that this particular element should be displayed when there
	 * is no value present for the required field `myField` (because the key `required` will be `true` in the object
	 * `myForm.myField.$error`).
	 *
	 * ### Message order
	 *
	 * By default, `ngMessages` will only display one message for a particular key/value collection at any time. If more
	 * than one message (or error) key is currently true, then which message is shown is determined by the order of messages
	 * in the HTML template code (messages declared first are prioritised). This mechanism means the developer does not have
	 * to prioritise messages using custom JavaScript code.
	 *
	 * Given the following error object for our example (which informs us that the field `myField` currently has both the
	 * `required` and `email` errors):
	 *
	 * ```javascript
	 * <!-- keep in mind that ngModel automatically sets these error flags -->
	 * myField.$error = { required : true, email: true, maxlength: false };
	 * ```
	 * The `required` message will be displayed to the user since it appears before the `email` message in the DOM.
	 * Once the user types a single character, the `required` message will disappear (since the field now has a value)
	 * but the `email` message will be visible because it is still applicable.
	 *
	 * ### Displaying multiple messages at the same time
	 *
	 * While `ngMessages` will by default only display one error element at a time, the `ng-messages-multiple` attribute can
	 * be applied to the `ngMessages` container element to cause it to display all applicable error messages at once:
	 *
	 * ```html
	 * <!-- attribute-style usage -->
	 * <div ng-messages="myForm.myField.$error" ng-messages-multiple>...</div>
	 *
	 * <!-- element-style usage -->
	 * <ng-messages for="myForm.myField.$error" multiple>...</ng-messages>
	 * ```
	 *
	 * ## Reusing and Overriding Messages
	 * In addition to prioritization, ngMessages also allows for including messages from a remote or an inline
	 * template. This allows for generic collection of messages to be reused across multiple parts of an
	 * application.
	 *
	 * ```html
	 * <script type="text/ng-template" id="error-messages">
	 *   <div ng-message="required">This field is required</div>
	 *   <div ng-message="minlength">This field is too short</div>
	 * </script>
	 *
	 * <div ng-messages="myForm.myField.$error" role="alert">
	 *   <div ng-messages-include="error-messages"></div>
	 * </div>
	 * ```
	 *
	 * However, including generic messages may not be useful enough to match all input fields, therefore,
	 * `ngMessages` provides the ability to override messages defined in the remote template by redefining
	 * them within the directive container.
	 *
	 * ```html
	 * <!-- a generic template of error messages known as "my-custom-messages" -->
	 * <script type="text/ng-template" id="my-custom-messages">
	 *   <div ng-message="required">This field is required</div>
	 *   <div ng-message="minlength">This field is too short</div>
	 * </script>
	 *
	 * <form name="myForm">
	 *   <label>
	 *     Email address
	 *     <input type="email"
	 *            id="email"
	 *            name="myEmail"
	 *            ng-model="email"
	 *            minlength="5"
	 *            required />
	 *   </label>
	 *   <!-- any ng-message elements that appear BEFORE the ng-messages-include will
	 *        override the messages present in the ng-messages-include template -->
	 *   <div ng-messages="myForm.myEmail.$error" role="alert">
	 *     <!-- this required message has overridden the template message -->
	 *     <div ng-message="required">You did not enter your email address</div>
	 *
	 *     <!-- this is a brand new message and will appear last in the prioritization -->
	 *     <div ng-message="email">Your email address is invalid</div>
	 *
	 *     <!-- and here are the generic error messages -->
	 *     <div ng-messages-include="my-custom-messages"></div>
	 *   </div>
	 * </form>
	 * ```
	 *
	 * In the example HTML code above the message that is set on required will override the corresponding
	 * required message defined within the remote template. Therefore, with particular input fields (such
	 * email addresses, date fields, autocomplete inputs, etc...), specialized error messages can be applied
	 * while more generic messages can be used to handle other, more general input errors.
	 *
	 * ## Dynamic Messaging
	 * ngMessages also supports using expressions to dynamically change key values. Using arrays and
	 * repeaters to list messages is also supported. This means that the code below will be able to
	 * fully adapt itself and display the appropriate message when any of the expression data changes:
	 *
	 * ```html
	 * <form name="myForm">
	 *   <label>
	 *     Email address
	 *     <input type="email"
	 *            name="myEmail"
	 *            ng-model="email"
	 *            minlength="5"
	 *            required />
	 *   </label>
	 *   <div ng-messages="myForm.myEmail.$error" role="alert">
	 *     <div ng-message="required">You did not enter your email address</div>
	 *     <div ng-repeat="errorMessage in errorMessages">
	 *       <!-- use ng-message-exp for a message whose key is given by an expression -->
	 *       <div ng-message-exp="errorMessage.type">{{ errorMessage.text }}</div>
	 *     </div>
	 *   </div>
	 * </form>
	 * ```
	 *
	 * The `errorMessage.type` expression can be a string value or it can be an array so
	 * that multiple errors can be associated with a single error message:
	 *
	 * ```html
	 *   <label>
	 *     Email address
	 *     <input type="email"
	 *            ng-model="data.email"
	 *            name="myEmail"
	 *            ng-minlength="5"
	 *            ng-maxlength="100"
	 *            required />
	 *   </label>
	 *   <div ng-messages="myForm.myEmail.$error" role="alert">
	 *     <div ng-message-exp="'required'">You did not enter your email address</div>
	 *     <div ng-message-exp="['minlength', 'maxlength']">
	 *       Your email must be between 5 and 100 characters long
	 *     </div>
	 *   </div>
	 * ```
	 *
	 * Feel free to use other structural directives such as ng-if and ng-switch to further control
	 * what messages are active and when. Be careful, if you place ng-message on the same element
	 * as these structural directives, Angular may not be able to determine if a message is active
	 * or not. Therefore it is best to place the ng-message on a child element of the structural
	 * directive.
	 *
	 * ```html
	 * <div ng-messages="myForm.myEmail.$error" role="alert">
	 *   <div ng-if="showRequiredError">
	 *     <div ng-message="required">Please enter something</div>
	 *   </div>
	 * </div>
	 * ```
	 *
	 * ## Animations
	 * If the `ngAnimate` module is active within the application then the `ngMessages`, `ngMessage` and
	 * `ngMessageExp` directives will trigger animations whenever any messages are added and removed from
	 * the DOM by the `ngMessages` directive.
	 *
	 * Whenever the `ngMessages` directive contains one or more visible messages then the `.ng-active` CSS
	 * class will be added to the element. The `.ng-inactive` CSS class will be applied when there are no
	 * messages present. Therefore, CSS transitions and keyframes as well as JavaScript animations can
	 * hook into the animations whenever these classes are added/removed.
	 *
	 * Let's say that our HTML code for our messages container looks like so:
	 *
	 * ```html
	 * <div ng-messages="myMessages" class="my-messages" role="alert">
	 *   <div ng-message="alert" class="some-message">...</div>
	 *   <div ng-message="fail" class="some-message">...</div>
	 * </div>
	 * ```
	 *
	 * Then the CSS animation code for the message container looks like so:
	 *
	 * ```css
	 * .my-messages {
	 *   transition:1s linear all;
	 * }
	 * .my-messages.ng-active {
	 *   // messages are visible
	 * }
	 * .my-messages.ng-inactive {
	 *   // messages are hidden
	 * }
	 * ```
	 *
	 * Whenever an inner message is attached (becomes visible) or removed (becomes hidden) then the enter
	 * and leave animation is triggered for each particular element bound to the `ngMessage` directive.
	 *
	 * Therefore, the CSS code for the inner messages looks like so:
	 *
	 * ```css
	 * .some-message {
	 *   transition:1s linear all;
	 * }
	 *
	 * .some-message.ng-enter {}
	 * .some-message.ng-enter.ng-enter-active {}
	 *
	 * .some-message.ng-leave {}
	 * .some-message.ng-leave.ng-leave-active {}
	 * ```
	 *
	 * {@link ngAnimate Click here} to learn how to use JavaScript animations or to learn more about ngAnimate.
	 */
	angular.module('ngMessages', [])
	
	   /**
	    * @ngdoc directive
	    * @module ngMessages
	    * @name ngMessages
	    * @restrict AE
	    *
	    * @description
	    * `ngMessages` is a directive that is designed to show and hide messages based on the state
	    * of a key/value object that it listens on. The directive itself complements error message
	    * reporting with the `ngModel` $error object (which stores a key/value state of validation errors).
	    *
	    * `ngMessages` manages the state of internal messages within its container element. The internal
	    * messages use the `ngMessage` directive and will be inserted/removed from the page depending
	    * on if they're present within the key/value object. By default, only one message will be displayed
	    * at a time and this depends on the prioritization of the messages within the template. (This can
	    * be changed by using the `ng-messages-multiple` or `multiple` attribute on the directive container.)
	    *
	    * A remote template can also be used to promote message reusability and messages can also be
	    * overridden.
	    *
	    * {@link module:ngMessages Click here} to learn more about `ngMessages` and `ngMessage`.
	    *
	    * @usage
	    * ```html
	    * <!-- using attribute directives -->
	    * <ANY ng-messages="expression" role="alert">
	    *   <ANY ng-message="stringValue">...</ANY>
	    *   <ANY ng-message="stringValue1, stringValue2, ...">...</ANY>
	    *   <ANY ng-message-exp="expressionValue">...</ANY>
	    * </ANY>
	    *
	    * <!-- or by using element directives -->
	    * <ng-messages for="expression" role="alert">
	    *   <ng-message when="stringValue">...</ng-message>
	    *   <ng-message when="stringValue1, stringValue2, ...">...</ng-message>
	    *   <ng-message when-exp="expressionValue">...</ng-message>
	    * </ng-messages>
	    * ```
	    *
	    * @param {string} ngMessages an angular expression evaluating to a key/value object
	    *                 (this is typically the $error object on an ngModel instance).
	    * @param {string=} ngMessagesMultiple|multiple when set, all messages will be displayed with true
	    *
	    * @example
	    * <example name="ngMessages-directive" module="ngMessagesExample"
	    *          deps="angular-messages.js"
	    *          animations="true" fixBase="true">
	    *   <file name="index.html">
	    *     <form name="myForm">
	    *       <label>
	    *         Enter your name:
	    *         <input type="text"
	    *                name="myName"
	    *                ng-model="name"
	    *                ng-minlength="5"
	    *                ng-maxlength="20"
	    *                required />
	    *       </label>
	    *       <pre>myForm.myName.$error = {{ myForm.myName.$error | json }}</pre>
	    *
	    *       <div ng-messages="myForm.myName.$error" style="color:maroon" role="alert">
	    *         <div ng-message="required">You did not enter a field</div>
	    *         <div ng-message="minlength">Your field is too short</div>
	    *         <div ng-message="maxlength">Your field is too long</div>
	    *       </div>
	    *     </form>
	    *   </file>
	    *   <file name="script.js">
	    *     angular.module('ngMessagesExample', ['ngMessages']);
	    *   </file>
	    * </example>
	    */
	   .directive('ngMessages', ['$animate', function($animate) {
	     var ACTIVE_CLASS = 'ng-active';
	     var INACTIVE_CLASS = 'ng-inactive';
	
	     return {
	       require: 'ngMessages',
	       restrict: 'AE',
	       controller: ['$element', '$scope', '$attrs', function($element, $scope, $attrs) {
	         var ctrl = this;
	         var latestKey = 0;
	         var nextAttachId = 0;
	
	         this.getAttachId = function getAttachId() { return nextAttachId++; };
	
	         var messages = this.messages = {};
	         var renderLater, cachedCollection;
	
	         this.render = function(collection) {
	           collection = collection || {};
	
	           renderLater = false;
	           cachedCollection = collection;
	
	           // this is true if the attribute is empty or if the attribute value is truthy
	           var multiple = isAttrTruthy($scope, $attrs.ngMessagesMultiple) ||
	                          isAttrTruthy($scope, $attrs.multiple);
	
	           var unmatchedMessages = [];
	           var matchedKeys = {};
	           var messageItem = ctrl.head;
	           var messageFound = false;
	           var totalMessages = 0;
	
	           // we use != instead of !== to allow for both undefined and null values
	           while (messageItem != null) {
	             totalMessages++;
	             var messageCtrl = messageItem.message;
	
	             var messageUsed = false;
	             if (!messageFound) {
	               forEach(collection, function(value, key) {
	                 if (!messageUsed && truthy(value) && messageCtrl.test(key)) {
	                   // this is to prevent the same error name from showing up twice
	                   if (matchedKeys[key]) return;
	                   matchedKeys[key] = true;
	
	                   messageUsed = true;
	                   messageCtrl.attach();
	                 }
	               });
	             }
	
	             if (messageUsed) {
	               // unless we want to display multiple messages then we should
	               // set a flag here to avoid displaying the next message in the list
	               messageFound = !multiple;
	             } else {
	               unmatchedMessages.push(messageCtrl);
	             }
	
	             messageItem = messageItem.next;
	           }
	
	           forEach(unmatchedMessages, function(messageCtrl) {
	             messageCtrl.detach();
	           });
	
	           unmatchedMessages.length !== totalMessages
	              ? $animate.setClass($element, ACTIVE_CLASS, INACTIVE_CLASS)
	              : $animate.setClass($element, INACTIVE_CLASS, ACTIVE_CLASS);
	         };
	
	         $scope.$watchCollection($attrs.ngMessages || $attrs['for'], ctrl.render);
	
	         // If the element is destroyed, proactively destroy all the currently visible messages
	         $element.on('$destroy', function() {
	           forEach(messages, function(item) {
	             item.message.detach();
	           });
	         });
	
	         this.reRender = function() {
	           if (!renderLater) {
	             renderLater = true;
	             $scope.$evalAsync(function() {
	               if (renderLater) {
	                 cachedCollection && ctrl.render(cachedCollection);
	               }
	             });
	           }
	         };
	
	         this.register = function(comment, messageCtrl) {
	           var nextKey = latestKey.toString();
	           messages[nextKey] = {
	             message: messageCtrl
	           };
	           insertMessageNode($element[0], comment, nextKey);
	           comment.$$ngMessageNode = nextKey;
	           latestKey++;
	
	           ctrl.reRender();
	         };
	
	         this.deregister = function(comment) {
	           var key = comment.$$ngMessageNode;
	           delete comment.$$ngMessageNode;
	           removeMessageNode($element[0], comment, key);
	           delete messages[key];
	           ctrl.reRender();
	         };
	
	         function findPreviousMessage(parent, comment) {
	           var prevNode = comment;
	           var parentLookup = [];
	
	           while (prevNode && prevNode !== parent) {
	             var prevKey = prevNode.$$ngMessageNode;
	             if (prevKey && prevKey.length) {
	               return messages[prevKey];
	             }
	
	             // dive deeper into the DOM and examine its children for any ngMessage
	             // comments that may be in an element that appears deeper in the list
	             if (prevNode.childNodes.length && parentLookup.indexOf(prevNode) == -1) {
	               parentLookup.push(prevNode);
	               prevNode = prevNode.childNodes[prevNode.childNodes.length - 1];
	             } else if (prevNode.previousSibling) {
	               prevNode = prevNode.previousSibling;
	             } else {
	               prevNode = prevNode.parentNode;
	               parentLookup.push(prevNode);
	             }
	           }
	         }
	
	         function insertMessageNode(parent, comment, key) {
	           var messageNode = messages[key];
	           if (!ctrl.head) {
	             ctrl.head = messageNode;
	           } else {
	             var match = findPreviousMessage(parent, comment);
	             if (match) {
	               messageNode.next = match.next;
	               match.next = messageNode;
	             } else {
	               messageNode.next = ctrl.head;
	               ctrl.head = messageNode;
	             }
	           }
	         }
	
	         function removeMessageNode(parent, comment, key) {
	           var messageNode = messages[key];
	
	           var match = findPreviousMessage(parent, comment);
	           if (match) {
	             match.next = messageNode.next;
	           } else {
	             ctrl.head = messageNode.next;
	           }
	         }
	       }]
	     };
	
	     function isAttrTruthy(scope, attr) {
	      return (isString(attr) && attr.length === 0) || //empty attribute
	             truthy(scope.$eval(attr));
	     }
	
	     function truthy(val) {
	       return isString(val) ? val.length : !!val;
	     }
	   }])
	
	   /**
	    * @ngdoc directive
	    * @name ngMessagesInclude
	    * @restrict AE
	    * @scope
	    *
	    * @description
	    * `ngMessagesInclude` is a directive with the purpose to import existing ngMessage template
	    * code from a remote template and place the downloaded template code into the exact spot
	    * that the ngMessagesInclude directive is placed within the ngMessages container. This allows
	    * for a series of pre-defined messages to be reused and also allows for the developer to
	    * determine what messages are overridden due to the placement of the ngMessagesInclude directive.
	    *
	    * @usage
	    * ```html
	    * <!-- using attribute directives -->
	    * <ANY ng-messages="expression" role="alert">
	    *   <ANY ng-messages-include="remoteTplString">...</ANY>
	    * </ANY>
	    *
	    * <!-- or by using element directives -->
	    * <ng-messages for="expression" role="alert">
	    *   <ng-messages-include src="expressionValue1">...</ng-messages-include>
	    * </ng-messages>
	    * ```
	    *
	    * {@link module:ngMessages Click here} to learn more about `ngMessages` and `ngMessage`.
	    *
	    * @param {string} ngMessagesInclude|src a string value corresponding to the remote template.
	    */
	   .directive('ngMessagesInclude',
	     ['$templateRequest', '$document', '$compile', function($templateRequest, $document, $compile) {
	
	     return {
	       restrict: 'AE',
	       require: '^^ngMessages', // we only require this for validation sake
	       link: function($scope, element, attrs) {
	         var src = attrs.ngMessagesInclude || attrs.src;
	         $templateRequest(src).then(function(html) {
	           if ($scope.$$destroyed) return;
	
	           $compile(html)($scope, function(contents) {
	             element.after(contents);
	
	             // the anchor is placed for debugging purposes
	             var comment = $compile.$$createComment ?
	                 $compile.$$createComment('ngMessagesInclude', src) :
	                 $document[0].createComment(' ngMessagesInclude: ' + src + ' ');
	             var anchor = jqLite(comment);
	             element.after(anchor);
	
	             // we don't want to pollute the DOM anymore by keeping an empty directive element
	             element.remove();
	           });
	         });
	       }
	     };
	   }])
	
	   /**
	    * @ngdoc directive
	    * @name ngMessage
	    * @restrict AE
	    * @scope
	    *
	    * @description
	    * `ngMessage` is a directive with the purpose to show and hide a particular message.
	    * For `ngMessage` to operate, a parent `ngMessages` directive on a parent DOM element
	    * must be situated since it determines which messages are visible based on the state
	    * of the provided key/value map that `ngMessages` listens on.
	    *
	    * More information about using `ngMessage` can be found in the
	    * {@link module:ngMessages `ngMessages` module documentation}.
	    *
	    * @usage
	    * ```html
	    * <!-- using attribute directives -->
	    * <ANY ng-messages="expression" role="alert">
	    *   <ANY ng-message="stringValue">...</ANY>
	    *   <ANY ng-message="stringValue1, stringValue2, ...">...</ANY>
	    * </ANY>
	    *
	    * <!-- or by using element directives -->
	    * <ng-messages for="expression" role="alert">
	    *   <ng-message when="stringValue">...</ng-message>
	    *   <ng-message when="stringValue1, stringValue2, ...">...</ng-message>
	    * </ng-messages>
	    * ```
	    *
	    * @param {expression} ngMessage|when a string value corresponding to the message key.
	    */
	  .directive('ngMessage', ngMessageDirectiveFactory())
	
	
	   /**
	    * @ngdoc directive
	    * @name ngMessageExp
	    * @restrict AE
	    * @priority 1
	    * @scope
	    *
	    * @description
	    * `ngMessageExp` is a directive with the purpose to show and hide a particular message.
	    * For `ngMessageExp` to operate, a parent `ngMessages` directive on a parent DOM element
	    * must be situated since it determines which messages are visible based on the state
	    * of the provided key/value map that `ngMessages` listens on.
	    *
	    * @usage
	    * ```html
	    * <!-- using attribute directives -->
	    * <ANY ng-messages="expression">
	    *   <ANY ng-message-exp="expressionValue">...</ANY>
	    * </ANY>
	    *
	    * <!-- or by using element directives -->
	    * <ng-messages for="expression">
	    *   <ng-message when-exp="expressionValue">...</ng-message>
	    * </ng-messages>
	    * ```
	    *
	    * {@link module:ngMessages Click here} to learn more about `ngMessages` and `ngMessage`.
	    *
	    * @param {expression} ngMessageExp|whenExp an expression value corresponding to the message key.
	    */
	  .directive('ngMessageExp', ngMessageDirectiveFactory());
	
	function ngMessageDirectiveFactory() {
	  return ['$animate', function($animate) {
	    return {
	      restrict: 'AE',
	      transclude: 'element',
	      priority: 1, // must run before ngBind, otherwise the text is set on the comment
	      terminal: true,
	      require: '^^ngMessages',
	      link: function(scope, element, attrs, ngMessagesCtrl, $transclude) {
	        var commentNode = element[0];
	
	        var records;
	        var staticExp = attrs.ngMessage || attrs.when;
	        var dynamicExp = attrs.ngMessageExp || attrs.whenExp;
	        var assignRecords = function(items) {
	          records = items
	              ? (isArray(items)
	                    ? items
	                    : items.split(/[\s,]+/))
	              : null;
	          ngMessagesCtrl.reRender();
	        };
	
	        if (dynamicExp) {
	          assignRecords(scope.$eval(dynamicExp));
	          scope.$watchCollection(dynamicExp, assignRecords);
	        } else {
	          assignRecords(staticExp);
	        }
	
	        var currentElement, messageCtrl;
	        ngMessagesCtrl.register(commentNode, messageCtrl = {
	          test: function(name) {
	            return contains(records, name);
	          },
	          attach: function() {
	            if (!currentElement) {
	              $transclude(scope, function(elm) {
	                $animate.enter(elm, null, element);
	                currentElement = elm;
	
	                // Each time we attach this node to a message we get a new id that we can match
	                // when we are destroying the node later.
	                var $$attachId = currentElement.$$attachId = ngMessagesCtrl.getAttachId();
	
	                // in the event that the element or a parent element is destroyed
	                // by another structural directive then it's time
	                // to deregister the message from the controller
	                currentElement.on('$destroy', function() {
	                  if (currentElement && currentElement.$$attachId === $$attachId) {
	                    ngMessagesCtrl.deregister(commentNode);
	                    messageCtrl.detach();
	                  }
	                });
	              });
	            }
	          },
	          detach: function() {
	            if (currentElement) {
	              var elm = currentElement;
	              currentElement = null;
	              $animate.leave(elm);
	            }
	          }
	        });
	      }
	    };
	  }];
	
	  function contains(collection, key) {
	    if (collection) {
	      return isArray(collection)
	          ? collection.indexOf(key) >= 0
	          : collection.hasOwnProperty(key);
	    }
	  }
	}
	
	
	})(window, window.angular);


/***/ }),
/* 1133 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1132);
	module.exports = 'ngMessages';


/***/ }),
/* 1134 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * angular-translate - v2.19.1 - 2024-01-21
	 * 
	 * Copyright (c) 2024 The angular-translate team, Pascal Precht; Licensed MIT
	 */
	(function (root, factory) {
	  if (true) {
	    // AMD. Register as an anonymous module unless amdModuleId is set
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	      return (factory());
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof module === 'object' && module.exports) {
	    // Node. Does not work with strict CommonJS, but
	    // only CommonJS-like environments that support module.exports,
	    // like Node.
	    module.exports = factory();
	  } else {
	    factory();
	  }
	}(this, function () {
	
	/**
	 * @ngdoc overview
	 * @name pascalprecht.translate
	 *
	 * @description
	 * The main module which holds everything together.
	 */
	runTranslate.$inject = ['$translate'];
	$translate.$inject = ['$STORAGE_KEY', '$windowProvider', '$translateSanitizationProvider', 'pascalprechtTranslateOverrider'];
	$translateDefaultInterpolation.$inject = ['$interpolate', '$translateSanitization'];
	translateDirective.$inject = ['$translate', '$interpolate', '$compile', '$parse', '$rootScope'];
	translateAttrDirective.$inject = ['$translate', '$rootScope'];
	translateCloakDirective.$inject = ['$translate', '$rootScope'];
	translateFilterFactory.$inject = ['$parse', '$translate'];
	$translationCache.$inject = ['$cacheFactory'];
	angular.module('pascalprecht.translate', ['ng'])
	  .run(runTranslate);
	
	function runTranslate($translate) {
	
	  'use strict';
	
	  var key = $translate.storageKey(),
	    storage = $translate.storage();
	
	  var fallbackFromIncorrectStorageValue = function () {
	    var preferred = $translate.preferredLanguage();
	    if (angular.isString(preferred)) {
	      $translate.use(preferred);
	      // $translate.use() will also remember the language.
	      // So, we don't need to call storage.put() here.
	    } else {
	      storage.put(key, $translate.use());
	    }
	  };
	
	  fallbackFromIncorrectStorageValue.displayName = 'fallbackFromIncorrectStorageValue';
	
	  if (storage) {
	    if (!storage.get(key)) {
	      fallbackFromIncorrectStorageValue();
	    } else {
	      $translate.use(storage.get(key))['catch'](fallbackFromIncorrectStorageValue);
	    }
	  } else if (angular.isString($translate.preferredLanguage())) {
	    $translate.use($translate.preferredLanguage());
	  }
	}
	
	runTranslate.displayName = 'runTranslate';
	
	/**
	 * @ngdoc object
	 * @name pascalprecht.translate.$translateSanitizationProvider
	 *
	 * @description
	 *
	 * Configurations for $translateSanitization
	 */
	angular.module('pascalprecht.translate').provider('$translateSanitization', $translateSanitizationProvider);
	
	function $translateSanitizationProvider () {
	
	  'use strict';
	
	  var $sanitize,
	      $sce,
	      currentStrategy = null, // TODO change to either 'sanitize', 'escape' or ['sanitize', 'escapeParameters'] in 3.0.
	      hasConfiguredStrategy = false,
	      hasShownNoStrategyConfiguredWarning = false,
	      strategies;
	
	  /**
	   * Definition of a sanitization strategy function
	   * @callback StrategyFunction
	   * @param {string|object} value - value to be sanitized (either a string or an interpolated value map)
	   * @param {string} mode - either 'text' for a string (translation) or 'params' for the interpolated params
	   * @return {string|object}
	   */
	
	  /**
	   * @ngdoc property
	   * @name strategies
	   * @propertyOf pascalprecht.translate.$translateSanitizationProvider
	   *
	   * @description
	   * Following strategies are built-in:
	   * <dl>
	   *   <dt>sanitize</dt>
	   *   <dd>Sanitizes HTML in the translation text using $sanitize</dd>
	   *   <dt>escape</dt>
	   *   <dd>Escapes HTML in the translation</dd>
	   *   <dt>sanitizeParameters</dt>
	   *   <dd>Sanitizes HTML in the values of the interpolation parameters using $sanitize</dd>
	   *   <dt>escapeParameters</dt>
	   *   <dd>Escapes HTML in the values of the interpolation parameters</dd>
	   *   <dt>escaped</dt>
	   *   <dd>Support legacy strategy name 'escaped' for backwards compatibility (will be removed in 3.0)</dd>
	   * </dl>
	   *
	   */
	
	  strategies = {
	    sanitize: function (value, mode/*, context*/) {
	      if (mode === 'text') {
	        value = htmlSanitizeValue(value);
	      }
	      return value;
	    },
	    escape: function (value, mode/*, context*/) {
	      if (mode === 'text') {
	        value = htmlEscapeValue(value);
	      }
	      return value;
	    },
	    sanitizeParameters: function (value, mode/*, context*/) {
	      if (mode === 'params') {
	        value = mapInterpolationParameters(value, htmlSanitizeValue);
	      }
	      return value;
	    },
	    escapeParameters: function (value, mode/*, context*/) {
	      if (mode === 'params') {
	        value = mapInterpolationParameters(value, htmlEscapeValue);
	      }
	      return value;
	    },
	    sce: function (value, mode, context) {
	      if (mode === 'text') {
	        value = htmlTrustValue(value);
	      } else if (mode === 'params') {
	        if (context !== 'filter') {
	          // do html escape in filter context #1101
	          value = mapInterpolationParameters(value, htmlEscapeValue);
	        }
	      }
	      return value;
	    },
	    sceParameters: function (value, mode/*, context*/) {
	      if (mode === 'params') {
	        value = mapInterpolationParameters(value, htmlTrustValue);
	      }
	      return value;
	    }
	  };
	  // Support legacy strategy name 'escaped' for backwards compatibility.
	  // TODO should be removed in 3.0
	  strategies.escaped = strategies.escapeParameters;
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateSanitizationProvider#addStrategy
	   * @methodOf pascalprecht.translate.$translateSanitizationProvider
	   *
	   * @description
	   * Adds a sanitization strategy to the list of known strategies.
	   *
	   * @param {string} strategyName - unique key for a strategy
	   * @param {StrategyFunction} strategyFunction - strategy function
	   * @returns {object} this
	   */
	  this.addStrategy = function (strategyName, strategyFunction) {
	    strategies[strategyName] = strategyFunction;
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateSanitizationProvider#removeStrategy
	   * @methodOf pascalprecht.translate.$translateSanitizationProvider
	   *
	   * @description
	   * Removes a sanitization strategy from the list of known strategies.
	   *
	   * @param {string} strategyName - unique key for a strategy
	   * @returns {object} this
	   */
	  this.removeStrategy = function (strategyName) {
	    delete strategies[strategyName];
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateSanitizationProvider#useStrategy
	   * @methodOf pascalprecht.translate.$translateSanitizationProvider
	   *
	   * @description
	   * Selects a sanitization strategy. When an array is provided the strategies will be executed in order.
	   *
	   * @param {string|StrategyFunction|array} strategy The sanitization strategy / strategies which should be used. Either a name of an existing strategy, a custom strategy function, or an array consisting of multiple names and / or custom functions.
	   * @returns {object} this
	   */
	  this.useStrategy = function (strategy) {
	    hasConfiguredStrategy = true;
	    currentStrategy = strategy;
	    return this;
	  };
	
	  /**
	   * @ngdoc object
	   * @name pascalprecht.translate.$translateSanitization
	   * @requires $injector
	   * @requires $log
	   *
	   * @description
	   * Sanitizes interpolation parameters and translated texts.
	   *
	   */
	  this.$get = ['$injector', '$log', function ($injector, $log) {
	
	    var cachedStrategyMap = {};
	
	    var applyStrategies = function (value, mode, context, selectedStrategies) {
	      angular.forEach(selectedStrategies, function (selectedStrategy) {
	        if (angular.isFunction(selectedStrategy)) {
	          value = selectedStrategy(value, mode, context);
	        } else if (angular.isFunction(strategies[selectedStrategy])) {
	          value = strategies[selectedStrategy](value, mode, context);
	        } else if (angular.isString(strategies[selectedStrategy])) {
	          if (!cachedStrategyMap[strategies[selectedStrategy]]) {
	            try {
	              cachedStrategyMap[strategies[selectedStrategy]] = $injector.get(strategies[selectedStrategy]);
	            } catch (e) {
	              cachedStrategyMap[strategies[selectedStrategy]] = function() {};
	              throw new Error('pascalprecht.translate.$translateSanitization: Unknown sanitization strategy: \'' + selectedStrategy + '\'');
	            }
	          }
	          value = cachedStrategyMap[strategies[selectedStrategy]](value, mode, context);
	        } else {
	          throw new Error('pascalprecht.translate.$translateSanitization: Unknown sanitization strategy: \'' + selectedStrategy + '\'');
	        }
	      });
	      return value;
	    };
	
	    // TODO: should be removed in 3.0
	    var showNoStrategyConfiguredWarning = function () {
	      if (!hasConfiguredStrategy && !hasShownNoStrategyConfiguredWarning) {
	        $log.warn('pascalprecht.translate.$translateSanitization: No sanitization strategy has been configured. This can have serious security implications. See http://angular-translate.github.io/docs/#/guide/19_security for details.');
	        hasShownNoStrategyConfiguredWarning = true;
	      }
	    };
	
	    if ($injector.has('$sanitize')) {
	      $sanitize = $injector.get('$sanitize');
	    }
	    if ($injector.has('$sce')) {
	      $sce = $injector.get('$sce');
	    }
	
	    return {
	      /**
	       * @ngdoc function
	       * @name pascalprecht.translate.$translateSanitization#useStrategy
	       * @methodOf pascalprecht.translate.$translateSanitization
	       *
	       * @description
	       * Selects a sanitization strategy. When an array is provided the strategies will be executed in order.
	       *
	       * @param {string|StrategyFunction|array} strategy The sanitization strategy / strategies which should be used. Either a name of an existing strategy, a custom strategy function, or an array consisting of multiple names and / or custom functions.
	       */
	      useStrategy: (function (self) {
	        return function (strategy) {
	          self.useStrategy(strategy);
	        };
	      })(this),
	
	      /**
	       * @ngdoc function
	       * @name pascalprecht.translate.$translateSanitization#sanitize
	       * @methodOf pascalprecht.translate.$translateSanitization
	       *
	       * @description
	       * Sanitizes a value.
	       *
	       * @param {string|object} value The value which should be sanitized.
	       * @param {string} mode The current sanitization mode, either 'params' or 'text'.
	       * @param {string|StrategyFunction|array} [strategy] Optional custom strategy which should be used instead of the currently selected strategy.
	       * @param {string} [context] The context of this call: filter, service. Default is service
	       * @returns {string|object} sanitized value
	       */
	      sanitize: function (value, mode, strategy, context) {
	        if (!currentStrategy) {
	          showNoStrategyConfiguredWarning();
	        }
	
	        if (!strategy && strategy !== null) {
	          strategy = currentStrategy;
	        }
	
	        if (!strategy) {
	          return value;
	        }
	
	        if (!context) {
	          context = 'service';
	        }
	
	        var selectedStrategies = angular.isArray(strategy) ? strategy : [strategy];
	        return applyStrategies(value, mode, context, selectedStrategies);
	      }
	    };
	  }];
	
	  var htmlEscapeValue = function (value) {
	    var element = angular.element('<div></div>');
	    element.text(value); // not chainable, see #1044
	    return element.html();
	  };
	
	  var htmlSanitizeValue = function (value) {
	    if (!$sanitize) {
	      throw new Error('pascalprecht.translate.$translateSanitization: Error cannot find $sanitize service. Either include the ngSanitize module (https://docs.angularjs.org/api/ngSanitize) or use a sanitization strategy which does not depend on $sanitize, such as \'escape\'.');
	    }
	    return $sanitize(value);
	  };
	
	  var htmlTrustValue = function (value) {
	    if (!$sce) {
	      throw new Error('pascalprecht.translate.$translateSanitization: Error cannot find $sce service.');
	    }
	    return $sce.trustAsHtml(value);
	  };
	
	  var mapInterpolationParameters = function (value, iteratee, stack) {
	    if (angular.isDate(value)) {
	      return value;
	    } else if (angular.isObject(value)) {
	      var result = angular.isArray(value) ? [] : {};
	
	      if (!stack) {
	        stack = [];
	      } else {
	        if (stack.indexOf(value) > -1) {
	          throw new Error('pascalprecht.translate.$translateSanitization: Error cannot interpolate parameter due recursive object');
	        }
	      }
	
	      stack.push(value);
	      angular.forEach(value, function (propertyValue, propertyKey) {
	
	        /* Skipping function properties. */
	        if (angular.isFunction(propertyValue)) {
	          return;
	        }
	
	        result[propertyKey] = mapInterpolationParameters(propertyValue, iteratee, stack);
	      });
	      stack.splice(-1, 1); // remove last
	
	      return result;
	    } else if (angular.isNumber(value)) {
	      return value;
	    } else if (value === true || value === false) {
	      return value;
	    } else if (!angular.isUndefined(value) && value !== null) {
	      return iteratee(value);
	    } else {
	      return value;
	    }
	  };
	}
	
	/**
	 * @ngdoc object
	 * @name pascalprecht.translate.$translateProvider
	 * @description
	 *
	 * $translateProvider allows developers to register translation-tables, asynchronous loaders
	 * and similar to configure translation behavior directly inside of a module.
	 *
	 */
	angular.module('pascalprecht.translate')
	  .constant('pascalprechtTranslateOverrider', {})
	  .provider('$translate', $translate);
	
	function $translate($STORAGE_KEY, $windowProvider, $translateSanitizationProvider, pascalprechtTranslateOverrider) {
	
	  'use strict';
	
	  var $translationTable = {},
	    $preferredLanguage,
	    $availableLanguageKeys = [],
	    $languageKeyAliases,
	    $fallbackLanguage,
	    $fallbackWasString,
	    $uses,
	    $nextLang,
	    $storageFactory,
	    $storageKey = $STORAGE_KEY,
	    $storagePrefix,
	    $missingTranslationHandlerFactory,
	    $interpolationFactory,
	    $interpolatorFactories = [],
	    $loaderFactory,
	    $cloakClassName = 'translate-cloak',
	    $loaderOptions,
	    $notFoundIndicatorLeft,
	    $notFoundIndicatorRight,
	    $postCompilingEnabled = false,
	    $forceAsyncReloadEnabled = false,
	    $allowNamespaces = true,
	    $nestedObjectDelimeter = '.',
	    $isReady = false,
	    $keepContent = false,
	    loaderCache,
	    directivePriority = 0,
	    statefulFilter = true,
	    postProcessFn,
	    uniformLanguageTagResolver = 'default',
	    languageTagResolver = {
	      'default' : function (tag) {
	        return (tag || '').split('-').join('_');
	      },
	      java : function (tag) {
	        var temp = (tag || '').split('-').join('_');
	        var parts = temp.split('_');
	        return parts.length > 1 ? (parts[0].toLowerCase() + '_' + parts[1].toUpperCase()) : temp;
	      },
	      bcp47 : function (tag) {
	        var temp = (tag || '').split('_').join('-');
	        var parts = temp.split('-');
	
	        switch (parts.length) {
	          case 1: // language only
	            parts[0] = parts[0].toLowerCase();
	            break;
	          case 2: // language-script or language-region
	            parts[0] = parts[0].toLowerCase();
	            if (parts[1].length === 4) { // parts[1] is script
	              parts[1] = parts[1].charAt(0).toUpperCase() + parts[1].slice(1).toLowerCase();
	            } else { // parts[1] is region
	              parts[1] = parts[1].toUpperCase();
	            }
	            break;
	          case 3: // language-script-region
	            parts[0] = parts[0].toLowerCase();
	            parts[1] = parts[1].charAt(0).toUpperCase() + parts[1].slice(1).toLowerCase();
	            parts[2] = parts[2].toUpperCase();
	            break;
	          default:
	            return temp;
	        }
	
	        return parts.join('-');
	      },
	      'iso639-1' : function (tag) {
	        var temp = (tag || '').split('_').join('-');
	        var parts = temp.split('-');
	        return parts[0].toLowerCase();
	      }
	    };
	
	  var version = '2.19.1';
	
	  // tries to determine the browsers language
	  var getFirstBrowserLanguage = function () {
	
	    // internal purpose only
	    if (angular.isFunction(pascalprechtTranslateOverrider.getLocale)) {
	      return pascalprechtTranslateOverrider.getLocale();
	    }
	
	    var nav = $windowProvider.$get().navigator,
	      browserLanguagePropertyKeys = ['language', 'browserLanguage', 'systemLanguage', 'userLanguage'],
	      i,
	      language;
	
	    // support for HTML 5.1 "navigator.languages"
	    if (angular.isArray(nav.languages)) {
	      for (i = 0; i < nav.languages.length; i++) {
	        language = nav.languages[i];
	        if (language && language.length) {
	          return language;
	        }
	      }
	    }
	
	    // support for other well known properties in browsers
	    for (i = 0; i < browserLanguagePropertyKeys.length; i++) {
	      language = nav[browserLanguagePropertyKeys[i]];
	      if (language && language.length) {
	        return language;
	      }
	    }
	
	    return null;
	  };
	  getFirstBrowserLanguage.displayName = 'angular-translate/service: getFirstBrowserLanguage';
	
	  // tries to determine the browsers locale
	  var getLocale = function () {
	    var locale = getFirstBrowserLanguage() || '';
	    if (languageTagResolver[uniformLanguageTagResolver]) {
	      locale = languageTagResolver[uniformLanguageTagResolver](locale);
	    }
	    return locale;
	  };
	  getLocale.displayName = 'angular-translate/service: getLocale';
	
	  /**
	   * @name indexOf
	   * @private
	   *
	   * @description
	   * indexOf polyfill. Kinda sorta.
	   *
	   * @param {array} array Array to search in.
	   * @param {string} searchElement Element to search for.
	   *
	   * @returns {int} Index of search element.
	   */
	  var indexOf = function (array, searchElement) {
	    for (var i = 0, len = array.length; i < len; i++) {
	      if (array[i] === searchElement) {
	        return i;
	      }
	    }
	    return -1;
	  };
	
	  /**
	   * @name trim
	   * @private
	   *
	   * @description
	   * trim polyfill
	   *
	   * @returns {string} The string stripped of whitespace from both ends
	   */
	  var trim = function () {
	    return this.toString().replace(/^\s+|\s+$/g, '');
	  };
	
	  /**
	   * @name lowercase
	   * @private
	   *
	   * @description
	   * Return the lowercase string only if the type is string
	   *
	   * @returns {string} The string all in lowercase
	   */
	  var lowercase = function (string) {
	    return angular.isString(string) ? string.toLowerCase() : string;
	  };
	
	  var negotiateLocale = function (preferred) {
	    if (!preferred) {
	      return;
	    }
	
	    var avail = [],
	      locale = lowercase(preferred),
	      i = 0,
	      n = $availableLanguageKeys.length;
	
	    for (; i < n; i++) {
	      avail.push(lowercase($availableLanguageKeys[i]));
	    }
	
	    // Check for an exact match in our list of available keys
	    i = indexOf(avail, locale);
	    if (i > -1) {
	      return $availableLanguageKeys[i];
	    }
	
	    if ($languageKeyAliases) {
	      var alias;
	      for (var langKeyAlias in $languageKeyAliases) {
	        if ($languageKeyAliases.hasOwnProperty(langKeyAlias)) {
	          var hasWildcardKey = false;
	          var hasExactKey = Object.prototype.hasOwnProperty.call($languageKeyAliases, langKeyAlias) &&
	            lowercase(langKeyAlias) === lowercase(preferred);
	
	          if (langKeyAlias.slice(-1) === '*') {
	            hasWildcardKey = lowercase(langKeyAlias.slice(0, -1)) === lowercase(preferred.slice(0, langKeyAlias.length - 1));
	          }
	          if (hasExactKey || hasWildcardKey) {
	            alias = $languageKeyAliases[langKeyAlias];
	            if (indexOf(avail, lowercase(alias)) > -1) {
	              return alias;
	            }
	          }
	        }
	      }
	    }
	
	    // Check for a language code without region
	    var parts = preferred.split('_');
	
	    if (parts.length > 1 && indexOf(avail, lowercase(parts[0])) > -1) {
	      return parts[0];
	    }
	
	    // If everything fails, return undefined.
	    return;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#translations
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Registers a new translation table for specific language key.
	   *
	   * To register a translation table for specific language, pass a defined language
	   * key as first parameter.
	   *
	   * <pre>
	   *  // register translation table for language: 'de_DE'
	   *  $translateProvider.translations('de_DE', {
	   *    'GREETING': 'Hallo Welt!'
	   *  });
	   *
	   *  // register another one
	   *  $translateProvider.translations('en_US', {
	   *    'GREETING': 'Hello world!'
	   *  });
	   * </pre>
	   *
	   * When registering multiple translation tables for for the same language key,
	   * the actual translation table gets extended. This allows you to define module
	   * specific translation which only get added, once a specific module is loaded in
	   * your app.
	   *
	   * Invoking this method with no arguments returns the translation table which was
	   * registered with no language key. Invoking it with a language key returns the
	   * related translation table.
	   *
	   * @param {string} langKey A language key.
	   * @param {object} translationTable A plain old JavaScript object that represents a translation table.
	   *
	   */
	  var translations = function (langKey, translationTable) {
	
	    if (!langKey && !translationTable) {
	      return $translationTable;
	    }
	
	    if (langKey && !translationTable) {
	      if (angular.isString(langKey)) {
	        return $translationTable[langKey];
	      }
	    } else {
	      if (!angular.isObject($translationTable[langKey])) {
	        $translationTable[langKey] = {};
	      }
	      angular.extend($translationTable[langKey], flatObject(translationTable));
	    }
	    return this;
	  };
	
	  this.translations = translations;
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#cloakClassName
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   *
	   * Let's you change the class name for `translate-cloak` directive.
	   * Default class name is `translate-cloak`.
	   *
	   * @param {string} name translate-cloak class name
	   */
	  this.cloakClassName = function (name) {
	    if (!name) {
	      return $cloakClassName;
	    }
	    $cloakClassName = name;
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#allowNamespaces
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Let's you disable namespaces, if you don't need nested translation
	   * object files. Disabling namespaces can improve performance.
	   *
	   * Default value is `true`. Namespaces are enabled by default.
	   *
	   * @param {boolean} namespacesEnabled - namespaces are enabled or not
	   */
	  this.allowNamespaces = function (namespacesEnabled) {
	    if (namespacesEnabled === undefined) {
	      return $allowNamespaces;
	    }
	    $allowNamespaces = namespacesEnabled;
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#nestedObjectDelimeter
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   *
	   * Let's you change the delimiter for namespaced translations.
	   * Default delimiter is `.`.
	   *
	   * @param {string} delimiter namespace separator
	   */
	  this.nestedObjectDelimeter = function (delimiter) {
	    if (!delimiter) {
	      return $nestedObjectDelimeter;
	    }
	    $nestedObjectDelimeter = delimiter;
	    return this;
	  };
	
	  /**
	   * @name flatObject
	   * @private
	   *
	   * @description
	   * Flats an object. This function is used to flatten given translation data with
	   * namespaces, so they are later accessible via dot notation.
	   */
	  var flatObject = function (data, path, result, prevKey) {
	    var key, keyWithPath, keyWithShortPath, val;
	
	    if (!path) {
	      path = [];
	    }
	    if (!result) {
	      result = {};
	    }
	    if (!$allowNamespaces) {
	      return data;
	    }
	    for (key in data) {
	      if (!Object.prototype.hasOwnProperty.call(data, key)) {
	        continue;
	      }
	      val = data[key];
	      if (angular.isObject(val)) {
	        flatObject(val, path.concat(key), result, key);
	      } else {
	        keyWithPath = path.length ? ('' + path.join($nestedObjectDelimeter) + $nestedObjectDelimeter + key) : key;
	        if (path.length && key === prevKey) {
	          // Create shortcut path (foo.bar == foo.bar.bar)
	          keyWithShortPath = '' + path.join($nestedObjectDelimeter);
	          // Link it to original path
	          result[keyWithShortPath] = '@:' + keyWithPath;
	        }
	        result[keyWithPath] = val;
	      }
	    }
	    return result;
	  };
	  flatObject.displayName = 'flatObject';
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#addInterpolation
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Adds interpolation services to angular-translate, so it can manage them.
	   *
	   * @param {object} factory Interpolation service factory
	   */
	  this.addInterpolation = function (factory) {
	    $interpolatorFactories.push(factory);
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useMessageFormatInterpolation
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells angular-translate to use interpolation functionality of messageformat.js.
	   * This is useful when having high level pluralization and gender selection.
	   */
	  this.useMessageFormatInterpolation = function () {
	    return this.useInterpolation('$translateMessageFormatInterpolation');
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useInterpolation
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells angular-translate which interpolation style to use as default, application-wide.
	   * Simply pass a factory/service name. The interpolation service has to implement
	   * the correct interface.
	   *
	   * @param {string} factory Interpolation service name.
	   */
	  this.useInterpolation = function (factory) {
	    $interpolationFactory = factory;
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useSanitizeStrategy
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Simply sets a sanitation strategy type.
	   *
	   * @param {string} value Strategy type.
	   */
	  this.useSanitizeValueStrategy = function (value) {
	    $translateSanitizationProvider.useStrategy(value);
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#preferredLanguage
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells the module which of the registered translation tables to use for translation
	   * at initial startup by passing a language key. Similar to `$translateProvider#use`
	   * only that it says which language to **prefer**.
	   * It is recommended to call this after {@link pascalprecht.translate.$translate#fallbackLanguage fallbackLanguage()}.
	   *
	   * @param {string} langKey A language key.
	   */
	  this.preferredLanguage = function (langKey) {
	    if (langKey) {
	      setupPreferredLanguage(langKey);
	      return this;
	    }
	    return $preferredLanguage;
	  };
	  var setupPreferredLanguage = function (langKey) {
	    if (langKey) {
	      $preferredLanguage = langKey;
	    }
	    return $preferredLanguage;
	  };
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#translationNotFoundIndicator
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Sets an indicator which is used when a translation isn't found. E.g. when
	   * setting the indicator as 'X' and one tries to translate a translation id
	   * called `NOT_FOUND`, this will result in `X NOT_FOUND X`.
	   *
	   * Internally this methods sets a left indicator and a right indicator using
	   * `$translateProvider.translationNotFoundIndicatorLeft()` and
	   * `$translateProvider.translationNotFoundIndicatorRight()`.
	   *
	   * **Note**: These methods automatically add a whitespace between the indicators
	   * and the translation id.
	   *
	   * @param {string} indicator An indicator, could be any string.
	   */
	  this.translationNotFoundIndicator = function (indicator) {
	    this.translationNotFoundIndicatorLeft(indicator);
	    this.translationNotFoundIndicatorRight(indicator);
	    return this;
	  };
	
	  /**
	   * ngdoc function
	   * @name pascalprecht.translate.$translateProvider#translationNotFoundIndicatorLeft
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Sets an indicator which is used when a translation isn't found left to the
	   * translation id.
	   *
	   * @param {string} indicator An indicator.
	   */
	  this.translationNotFoundIndicatorLeft = function (indicator) {
	    if (!indicator) {
	      return $notFoundIndicatorLeft;
	    }
	    $notFoundIndicatorLeft = indicator;
	    return this;
	  };
	
	  /**
	   * ngdoc function
	   * @name pascalprecht.translate.$translateProvider#translationNotFoundIndicatorLeft
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Sets an indicator which is used when a translation isn't found right to the
	   * translation id.
	   *
	   * @param {string} indicator An indicator.
	   */
	  this.translationNotFoundIndicatorRight = function (indicator) {
	    if (!indicator) {
	      return $notFoundIndicatorRight;
	    }
	    $notFoundIndicatorRight = indicator;
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#fallbackLanguage
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells the module which of the registered translation tables to use when missing translations
	   * at initial startup by passing a language key. Similar to `$translateProvider#use`
	   * only that it says which language to **fallback**.
	   *
	   * @param {string||array} langKey A language key.
	   *
	   */
	  this.fallbackLanguage = function (langKey) {
	    fallbackStack(langKey);
	    return this;
	  };
	
	  var fallbackStack = function (langKey) {
	    if (langKey) {
	      if (angular.isString(langKey)) {
	        $fallbackWasString = true;
	        $fallbackLanguage = [langKey];
	      } else if (angular.isArray(langKey)) {
	        $fallbackWasString = false;
	        $fallbackLanguage = langKey;
	      }
	      if (angular.isString($preferredLanguage) && indexOf($fallbackLanguage, $preferredLanguage) < 0) {
	        $fallbackLanguage.push($preferredLanguage);
	      }
	
	      return this;
	    } else {
	      if ($fallbackWasString) {
	        return $fallbackLanguage[0];
	      } else {
	        return $fallbackLanguage;
	      }
	    }
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#use
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Set which translation table to use for translation by given language key. When
	   * trying to 'use' a language which isn't provided, it'll throw an error.
	   *
	   * You actually don't have to use this method since `$translateProvider#preferredLanguage`
	   * does the job too.
	   *
	   * @param {string} langKey A language key.
	   */
	  this.use = function (langKey) {
	    if (langKey) {
	      if (!$translationTable[langKey] && (!$loaderFactory)) {
	        // only throw an error, when not loading translation data asynchronously
	        throw new Error('$translateProvider couldn\'t find translationTable for langKey: \'' + langKey + '\'');
	      }
	      $uses = langKey;
	      return this;
	    }
	    return $uses;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#resolveClientLocale
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * This returns the current browser/client's language key. The result is processed with the configured uniform tag resolver.
	   *
	   * @returns {string} the current client/browser language key
	   */
	  this.resolveClientLocale = function () {
	    return getLocale();
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#storageKey
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells the module which key must represent the choosed language by a user in the storage.
	   *
	   * @param {string} key A key for the storage.
	   */
	  var storageKey = function (key) {
	    if (!key) {
	      if ($storagePrefix) {
	        return $storagePrefix + $storageKey;
	      }
	      return $storageKey;
	    }
	    $storageKey = key;
	    return this;
	  };
	
	  this.storageKey = storageKey;
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useUrlLoader
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells angular-translate to use `$translateUrlLoader` extension service as loader.
	   *
	   * @param {string} url Url
	   * @param {Object=} options Optional configuration object
	   */
	  this.useUrlLoader = function (url, options) {
	    return this.useLoader('$translateUrlLoader', angular.extend({url : url}, options));
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useStaticFilesLoader
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells angular-translate to use `$translateStaticFilesLoader` extension service as loader.
	   *
	   * @param {Object=} options Optional configuration object
	   */
	  this.useStaticFilesLoader = function (options) {
	    return this.useLoader('$translateStaticFilesLoader', options);
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useLoader
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells angular-translate to use any other service as loader.
	   *
	   * @param {string} loaderFactory Factory name to use
	   * @param {Object=} options Optional configuration object
	   */
	  this.useLoader = function (loaderFactory, options) {
	    $loaderFactory = loaderFactory;
	    $loaderOptions = options || {};
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useLocalStorage
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells angular-translate to use `$translateLocalStorage` service as storage layer.
	   *
	   */
	  this.useLocalStorage = function () {
	    return this.useStorage('$translateLocalStorage');
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useCookieStorage
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells angular-translate to use `$translateCookieStorage` service as storage layer.
	   */
	  this.useCookieStorage = function () {
	    return this.useStorage('$translateCookieStorage');
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useStorage
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells angular-translate to use custom service as storage layer.
	   */
	  this.useStorage = function (storageFactory) {
	    $storageFactory = storageFactory;
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#storagePrefix
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Sets prefix for storage key.
	   *
	   * @param {string} prefix Storage key prefix
	   */
	  this.storagePrefix = function (prefix) {
	    if (!prefix) {
	      return prefix;
	    }
	    $storagePrefix = prefix;
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useMissingTranslationHandlerLog
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells angular-translate to use built-in log handler when trying to translate
	   * a translation Id which doesn't exist.
	   *
	   * This is actually a shortcut method for `useMissingTranslationHandler()`.
	   *
	   */
	  this.useMissingTranslationHandlerLog = function () {
	    return this.useMissingTranslationHandler('$translateMissingTranslationHandlerLog');
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useMissingTranslationHandler
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Expects a factory name which later gets instantiated with `$injector`.
	   * This method can be used to tell angular-translate to use a custom
	   * missingTranslationHandler. Just build a factory which returns a function
	   * and expects a translation id as argument.
	   *
	   * Example:
	   * <pre>
	   *  app.config(function ($translateProvider) {
	   *    $translateProvider.useMissingTranslationHandler('customHandler');
	   *  });
	   *
	   *  app.factory('customHandler', function (dep1, dep2) {
	   *    return function (translationId) {
	   *      // something with translationId and dep1 and dep2
	   *    };
	   *  });
	   * </pre>
	   *
	   * @param {string} factory Factory name
	   */
	  this.useMissingTranslationHandler = function (factory) {
	    $missingTranslationHandlerFactory = factory;
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#usePostCompiling
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * If post compiling is enabled, all translated values will be processed
	   * again with AngularJS' $compile.
	   *
	   * Example:
	   * <pre>
	   *  app.config(function ($translateProvider) {
	   *    $translateProvider.usePostCompiling(true);
	   *  });
	   * </pre>
	   *
	   * @param {string} factory Factory name
	   */
	  this.usePostCompiling = function (value) {
	    $postCompilingEnabled = !(!value);
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#forceAsyncReload
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * If force async reload is enabled, async loader will always be called
	   * even if $translationTable already contains the language key, adding
	   * possible new entries to the $translationTable.
	   *
	   * Example:
	   * <pre>
	   *  app.config(function ($translateProvider) {
	   *    $translateProvider.forceAsyncReload(true);
	   *  });
	   * </pre>
	   *
	   * @param {boolean} value - valid values are true or false
	   */
	  this.forceAsyncReload = function (value) {
	    $forceAsyncReloadEnabled = !(!value);
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#uniformLanguageTag
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells angular-translate which language tag should be used as a result when determining
	   * the current browser language.
	   *
	   * This setting must be set before invoking {@link pascalprecht.translate.$translateProvider#methods_determinePreferredLanguage determinePreferredLanguage()}.
	   *
	   * <pre>
	   * $translateProvider
	   *   .uniformLanguageTag('bcp47')
	   *   .determinePreferredLanguage()
	   * </pre>
	   *
	   * The resolver currently supports:
	   * * default
	   *     (traditionally: hyphens will be converted into underscores, i.e. en-US => en_US)
	   *     en-US => en_US
	   *     en_US => en_US
	   *     en-us => en_us
	   * * java
	   *     like default, but the second part will be always in uppercase
	   *     en-US => en_US
	   *     en_US => en_US
	   *     en-us => en_US
	   * * BCP 47 (RFC 4646 & 4647)
	   *     EN => en
	   *     en-US => en-US
	   *     en_US => en-US
	   *     en-us => en-US
	   *     sr-latn => sr-Latn
	   *     sr-latn-rs => sr-Latn-RS
	   *
	   * See also:
	   * * http://en.wikipedia.org/wiki/IETF_language_tag
	   * * http://www.w3.org/International/core/langtags/
	   * * http://tools.ietf.org/html/bcp47
	   *
	   * @param {string|object} options - options (or standard)
	   * @param {string} options.standard - valid values are 'default', 'bcp47', 'java'
	   */
	  this.uniformLanguageTag = function (options) {
	
	    if (!options) {
	      options = {};
	    } else if (angular.isString(options)) {
	      options = {
	        standard : options
	      };
	    }
	
	    uniformLanguageTagResolver = options.standard;
	
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#determinePreferredLanguage
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells angular-translate to try to determine on its own which language key
	   * to set as preferred language. When `fn` is given, angular-translate uses it
	   * to determine a language key, otherwise it uses the built-in `getLocale()`
	   * method.
	   *
	   * The `getLocale()` returns a language key in the format `[lang]_[country]` or
	   * `[lang]` depending on what the browser provides.
	   *
	   * Use this method at your own risk, since not all browsers return a valid
	   * locale (see {@link pascalprecht.translate.$translateProvider#methods_uniformLanguageTag uniformLanguageTag()}).
	   *
	   * @param {Function=} fn Function to determine a browser's locale
	   */
	  this.determinePreferredLanguage = function (fn) {
	
	    var locale = (fn && angular.isFunction(fn)) ? fn() : getLocale();
	
	    if (!$availableLanguageKeys.length) {
	      $preferredLanguage = locale;
	    } else {
	      $preferredLanguage = negotiateLocale(locale) || locale;
	    }
	
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#registerAvailableLanguageKeys
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Registers a set of language keys the app will work with. Use this method in
	   * combination with
	   * {@link pascalprecht.translate.$translateProvider#determinePreferredLanguage determinePreferredLanguage}.
	   * When available languages keys are registered, angular-translate
	   * tries to find the best fitting language key depending on the browsers locale,
	   * considering your language key convention.
	   *
	   * @param {object} languageKeys Array of language keys the your app will use
	   * @param {object=} aliases Alias map.
	   */
	  this.registerAvailableLanguageKeys = function (languageKeys, aliases) {
	    if (languageKeys) {
	      $availableLanguageKeys = languageKeys;
	      if (aliases) {
	        $languageKeyAliases = aliases;
	      }
	      return this;
	    }
	    return $availableLanguageKeys;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useLoaderCache
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Registers a cache for internal $http based loaders.
	   * {@link pascalprecht.translate.$translationCache $translationCache}.
	   * When false the cache will be disabled (default). When true or undefined
	   * the cache will be a default (see $cacheFactory). When an object it will
	   * be treat as a cache object itself: the usage is $http({cache: cache})
	   *
	   * @param {object} cache boolean, string or cache-object
	   */
	  this.useLoaderCache = function (cache) {
	    if (cache === false) {
	      // disable cache
	      loaderCache = undefined;
	    } else if (cache === true) {
	      // enable cache using AJS defaults
	      loaderCache = true;
	    } else if (typeof(cache) === 'undefined') {
	      // enable cache using default
	      loaderCache = '$translationCache';
	    } else if (cache) {
	      // enable cache using given one (see $cacheFactory)
	      loaderCache = cache;
	    }
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#directivePriority
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Sets the default priority of the translate directive. The standard value is `0`.
	   * Calling this function without an argument will return the current value.
	   *
	   * @param {number} priority for the translate-directive
	   */
	  this.directivePriority = function (priority) {
	    if (priority === undefined) {
	      // getter
	      return directivePriority;
	    } else {
	      // setter with chaining
	      directivePriority = priority;
	      return this;
	    }
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#statefulFilter
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Since AngularJS 1.3, filters which are not stateless (depending at the scope)
	   * have to explicit define this behavior.
	   * Sets whether the translate filter should be stateful or stateless. The standard value is `true`
	   * meaning being stateful.
	   * Calling this function without an argument will return the current value.
	   *
	   * @param {boolean} state - defines the state of the filter
	   */
	  this.statefulFilter = function (state) {
	    if (state === undefined) {
	      // getter
	      return statefulFilter;
	    } else {
	      // setter with chaining
	      statefulFilter = state;
	      return this;
	    }
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#postProcess
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * The post processor will be intercept right after the translation result. It can modify the result.
	   *
	   * @param {object} fn Function or service name (string) to be called after the translation value has been set / resolved. The function itself will enrich every value being processed and then continue the normal resolver process
	   */
	  this.postProcess = function (fn) {
	    if (fn) {
	      postProcessFn = fn;
	    } else {
	      postProcessFn = undefined;
	    }
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#keepContent
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * If keepContent is set to true than translate directive will always use innerHTML
	   * as a default translation
	   *
	   * Example:
	   * <pre>
	   *  app.config(function ($translateProvider) {
	   *    $translateProvider.keepContent(true);
	   *  });
	   * </pre>
	   *
	   * @param {boolean} value - valid values are true or false
	   */
	  this.keepContent = function (value) {
	    $keepContent = !(!value);
	    return this;
	  };
	
	  /**
	   * @ngdoc object
	   * @name pascalprecht.translate.$translate
	   * @requires $interpolate
	   * @requires $log
	   * @requires $rootScope
	   * @requires $q
	   *
	   * @description
	   * The `$translate` service is the actual core of angular-translate. It expects a translation id
	   * and optional interpolate parameters to translate contents.
	   *
	   * <pre>
	   *  $translate('HEADLINE_TEXT').then(function (translation) {
	   *    $scope.translatedText = translation;
	   *  });
	   * </pre>
	   *
	   * @param {string|array} translationId A token which represents a translation id
	   *                                     This can be optionally an array of translation ids which
	   *                                     results that the function returns an object where each key
	   *                                     is the translation id and the value the translation.
	   * @param {object=} [interpolateParams={}] An object hash for dynamic values
	   * @param {string=} [interpolationId=undefined] The id of the interpolation to use (use default unless set via useInterpolation())
	   * @param {string=} [defaultTranslationText=undefined] the optional default translation text that is written as
	   *                                        as default text in case it is not found in any configured language
	   * @param {string=} [forceLanguage=false] A language to be used instead of the current language
	   * @param {string=} [sanitizeStrategy=undefined] force sanitize strategy for this call instead of using the configured one (use default unless set)
	   * @returns {object} promise
	   */
	  this.$get = ['$log', '$injector', '$rootScope', '$q', function ($log, $injector, $rootScope, $q) {
	
	    var Storage,
	      defaultInterpolator = $injector.get($interpolationFactory || '$translateDefaultInterpolation'),
	      pendingLoader = false,
	      interpolatorHashMap = {},
	      langPromises = {},
	      fallbackIndex,
	      startFallbackIteration;
	
	    var $translate = function (translationId, interpolateParams, interpolationId, defaultTranslationText, forceLanguage, sanitizeStrategy) {
	      if (!$uses && $preferredLanguage) {
	        $uses = $preferredLanguage;
	      }
	      var uses = (forceLanguage && forceLanguage !== $uses) ? // we don't want to re-negotiate $uses
	        (negotiateLocale(forceLanguage) || forceLanguage) : $uses;
	
	      // Check forceLanguage is present
	      if (forceLanguage) {
	        loadTranslationsIfMissing(forceLanguage);
	      }
	
	      // Duck detection: If the first argument is an array, a bunch of translations was requested.
	      // The result is an object.
	      if (angular.isArray(translationId)) {
	        // Inspired by Q.allSettled by Kris Kowal
	        // https://github.com/kriskowal/q/blob/b0fa72980717dc202ffc3cbf03b936e10ebbb9d7/q.js#L1553-1563
	        // This transforms all promises regardless resolved or rejected
	        var translateAll = function (translationIds) {
	          var results = {}; // storing the actual results
	          var promises = []; // promises to wait for
	          // Wraps the promise a) being always resolved and b) storing the link id->value
	          var translate = function (translationId) {
	            var deferred = $q.defer();
	            var regardless = function (value) {
	              results[translationId] = value;
	              deferred.resolve([translationId, value]);
	            };
	            // we don't care whether the promise was resolved or rejected; just store the values
	            $translate(translationId, interpolateParams, interpolationId, defaultTranslationText, forceLanguage, sanitizeStrategy).then(regardless, regardless);
	            return deferred.promise;
	          };
	          for (var i = 0, c = translationIds.length; i < c; i++) {
	            promises.push(translate(translationIds[i]));
	          }
	          // wait for all (including storing to results)
	          return $q.all(promises).then(function () {
	            // return the results
	            return results;
	          });
	        };
	        return translateAll(translationId);
	      }
	
	      var deferred = $q.defer();
	
	      // trim off any whitespace
	      if (translationId) {
	        translationId = trim.apply(translationId);
	      } else {
	        throw new TypeError('translationId must be a not empty string');
	      }
	
	      var promiseToWaitFor = (function () {
	        var promise = langPromises[uses] || langPromises[$preferredLanguage];
	
	        fallbackIndex = 0;
	
	        if ($storageFactory && !promise) {
	          // looks like there's no pending promise for $preferredLanguage or
	          // $uses. Maybe there's one pending for a language that comes from
	          // storage.
	          var langKey = Storage.get($storageKey);
	          promise = langPromises[langKey];
	
	          if ($fallbackLanguage && $fallbackLanguage.length) {
	            var index = indexOf($fallbackLanguage, langKey);
	            // maybe the language from storage is also defined as fallback language
	            // we increase the fallback language index to not search in that language
	            // as fallback, since it's probably the first used language
	            // in that case the index starts after the first element
	            fallbackIndex = (index === 0) ? 1 : 0;
	
	            // but we can make sure to ALWAYS fallback to preferred language at least
	            if (indexOf($fallbackLanguage, $preferredLanguage) < 0) {
	              $fallbackLanguage.push($preferredLanguage);
	            }
	          }
	        }
	        return promise;
	      }());
	
	      if (!promiseToWaitFor) {
	        // no promise to wait for? okay. Then there's no loader registered
	        // nor is a one pending for language that comes from storage.
	        // We can just translate.
	        determineTranslation(translationId, interpolateParams, interpolationId, defaultTranslationText, uses, sanitizeStrategy).then(deferred.resolve, deferred.reject);
	      } else {
	        var promiseResolved = function () {
	          // $uses may have changed while waiting
	          if (!forceLanguage) {
	            uses = $uses;
	          }
	          determineTranslation(translationId, interpolateParams, interpolationId, defaultTranslationText, uses, sanitizeStrategy).then(deferred.resolve, deferred.reject);
	        };
	        promiseResolved.displayName = 'promiseResolved';
	
	        promiseToWaitFor['finally'](promiseResolved)['catch'](angular.noop); // we don't care about errors here, already handled
	      }
	      return deferred.promise;
	    };
	
	    /**
	     * @name applyNotFoundIndicators
	     * @private
	     *
	     * @description
	     * Applies not fount indicators to given translation id, if needed.
	     * This function gets only executed, if a translation id doesn't exist,
	     * which is why a translation id is expected as argument.
	     *
	     * @param {string} translationId Translation id.
	     * @returns {string} Same as given translation id but applied with not found
	     * indicators.
	     */
	    var applyNotFoundIndicators = function (translationId) {
	      // applying notFoundIndicators
	      if ($notFoundIndicatorLeft) {
	        translationId = [$notFoundIndicatorLeft, translationId].join(' ');
	      }
	      if ($notFoundIndicatorRight) {
	        translationId = [translationId, $notFoundIndicatorRight].join(' ');
	      }
	      return translationId;
	    };
	
	    /**
	     * @name useLanguage
	     * @private
	     *
	     * @description
	     * Makes actual use of a language by setting a given language key as used
	     * language and informs registered interpolators to also use the given
	     * key as locale.
	     *
	     * @param {string} key Locale key.
	     */
	    var useLanguage = function (key) {
	      $uses = key;
	
	      // make sure to store new language key before triggering success event
	      if ($storageFactory) {
	        Storage.put($translate.storageKey(), $uses);
	      }
	
	      $rootScope.$emit('$translateChangeSuccess', {language : key});
	
	      // inform default interpolator
	      defaultInterpolator.setLocale($uses);
	
	      var eachInterpolator = function (interpolator, id) {
	        interpolatorHashMap[id].setLocale($uses);
	      };
	      eachInterpolator.displayName = 'eachInterpolatorLocaleSetter';
	
	      // inform all others too!
	      angular.forEach(interpolatorHashMap, eachInterpolator);
	      $rootScope.$emit('$translateChangeEnd', {language : key});
	    };
	
	    /**
	     * @name loadAsync
	     * @private
	     *
	     * @description
	     * Kicks off registered async loader using `$injector` and applies existing
	     * loader options. When resolved, it updates translation tables accordingly
	     * or rejects with given language key.
	     *
	     * @param {string} key Language key.
	     * @return {Promise} A promise.
	     */
	    var loadAsync = function (key) {
	      if (!key) {
	        throw 'No language key specified for loading.';
	      }
	
	      var deferred = $q.defer();
	
	      $rootScope.$emit('$translateLoadingStart', {language : key});
	      pendingLoader = true;
	
	      var cache = loaderCache;
	      if (typeof(cache) === 'string') {
	        // getting on-demand instance of loader
	        cache = $injector.get(cache);
	      }
	
	      var loaderOptions = angular.extend({}, $loaderOptions, {
	        key : key,
	        $http : angular.extend({}, {
	          cache : cache
	        }, $loaderOptions.$http)
	      });
	
	      var onLoaderSuccess = function (data) {
	        var translationTable = {};
	        $rootScope.$emit('$translateLoadingSuccess', {language : key});
	
	        if (angular.isArray(data)) {
	          angular.forEach(data, function (table) {
	            angular.extend(translationTable, flatObject(table));
	          });
	        } else {
	          angular.extend(translationTable, flatObject(data));
	        }
	        pendingLoader = false;
	        deferred.resolve({
	          key : key,
	          table : translationTable
	        });
	        $rootScope.$emit('$translateLoadingEnd', {language : key});
	      };
	      onLoaderSuccess.displayName = 'onLoaderSuccess';
	
	      var onLoaderError = function (key) {
	        $rootScope.$emit('$translateLoadingError', {language : key});
	        deferred.reject(key);
	        $rootScope.$emit('$translateLoadingEnd', {language : key});
	      };
	      onLoaderError.displayName = 'onLoaderError';
	
	      $injector.get($loaderFactory)(loaderOptions)
	        .then(onLoaderSuccess, onLoaderError);
	
	      return deferred.promise;
	    };
	
	    if ($storageFactory) {
	      Storage = $injector.get($storageFactory);
	
	      if (!Storage.get || !Storage.put) {
	        throw new Error('Couldn\'t use storage \'' + $storageFactory + '\', missing get() or put() method!');
	      }
	    }
	
	    // if we have additional interpolations that were added via
	    // $translateProvider.addInterpolation(), we have to map'em
	    if ($interpolatorFactories.length) {
	      var eachInterpolationFactory = function (interpolatorFactory) {
	        var interpolator = $injector.get(interpolatorFactory);
	        // setting initial locale for each interpolation service
	        interpolator.setLocale($preferredLanguage || $uses);
	        // make'em recognizable through id
	        interpolatorHashMap[interpolator.getInterpolationIdentifier()] = interpolator;
	      };
	      eachInterpolationFactory.displayName = 'interpolationFactoryAdder';
	
	      angular.forEach($interpolatorFactories, eachInterpolationFactory);
	    }
	
	    /**
	     * @name getTranslationTable
	     * @private
	     *
	     * @description
	     * Returns a promise that resolves to the translation table
	     * or is rejected if an error occurred.
	     *
	     * @param langKey
	     * @returns {Q.promise}
	     */
	    var getTranslationTable = function (langKey) {
	      var deferred = $q.defer();
	      if (Object.prototype.hasOwnProperty.call($translationTable, langKey)) {
	        deferred.resolve($translationTable[langKey]);
	      } else if (langPromises[langKey]) {
	        var onResolve = function (data) {
	          translations(data.key, data.table);
	          deferred.resolve(data.table);
	        };
	        onResolve.displayName = 'translationTableResolver';
	        langPromises[langKey].then(onResolve, deferred.reject);
	      } else {
	        deferred.reject();
	      }
	      return deferred.promise;
	    };
	
	    /**
	     * @name getFallbackTranslation
	     * @private
	     *
	     * @description
	     * Returns a promise that will resolve to the translation
	     * or be rejected if no translation was found for the language.
	     * This function is currently only used for fallback language translation.
	     *
	     * @param langKey The language to translate to.
	     * @param translationId
	     * @param interpolateParams
	     * @param Interpolator
	     * @param sanitizeStrategy
	     * @returns {Q.promise}
	     */
	    var getFallbackTranslation = function (langKey, translationId, interpolateParams, Interpolator, sanitizeStrategy) {
	      var deferred = $q.defer();
	
	      var onResolve = function (translationTable) {
	        if (Object.prototype.hasOwnProperty.call(translationTable, translationId) && translationTable[translationId] !== null) {
	          Interpolator.setLocale(langKey);
	          var translation = translationTable[translationId];
	          if (translation.substr(0, 2) === '@:') {
	            getFallbackTranslation(langKey, translation.substr(2), interpolateParams, Interpolator, sanitizeStrategy)
	              .then(deferred.resolve, deferred.reject);
	          } else {
	            var interpolatedValue = Interpolator.interpolate(translationTable[translationId], interpolateParams, 'service', sanitizeStrategy, translationId);
	            interpolatedValue = applyPostProcessing(translationId, translationTable[translationId], interpolatedValue, interpolateParams, langKey);
	
	            deferred.resolve(interpolatedValue);
	
	          }
	          Interpolator.setLocale($uses);
	        } else {
	          deferred.reject();
	        }
	      };
	      onResolve.displayName = 'fallbackTranslationResolver';
	
	      getTranslationTable(langKey).then(onResolve, deferred.reject);
	
	      return deferred.promise;
	    };
	
	    /**
	     * @name getFallbackTranslationInstant
	     * @private
	     *
	     * @description
	     * Returns a translation
	     * This function is currently only used for fallback language translation.
	     *
	     * @param langKey The language to translate to.
	     * @param translationId
	     * @param interpolateParams
	     * @param Interpolator
	     * @param sanitizeStrategy sanitize strategy override
	     *
	     * @returns {string} translation
	     */
	    var getFallbackTranslationInstant = function (langKey, translationId, interpolateParams, Interpolator, sanitizeStrategy) {
	      var result, translationTable = $translationTable[langKey];
	
	      if (translationTable && Object.prototype.hasOwnProperty.call(translationTable, translationId) && translationTable[translationId] !== null) {
	        Interpolator.setLocale(langKey);
	        result = Interpolator.interpolate(translationTable[translationId], interpolateParams, 'filter', sanitizeStrategy, translationId);
	        result = applyPostProcessing(translationId, translationTable[translationId], result, interpolateParams, langKey, sanitizeStrategy);
	        // workaround for TrustedValueHolderType
	        if (!angular.isString(result) && angular.isFunction(result.$$unwrapTrustedValue)) {
	          var result2 = result.$$unwrapTrustedValue();
	          if (result2.substr(0, 2) === '@:') {
	            return getFallbackTranslationInstant(langKey, result2.substr(2), interpolateParams, Interpolator, sanitizeStrategy);
	          }
	        } else if (result.substr(0, 2) === '@:') {
	          return getFallbackTranslationInstant(langKey, result.substr(2), interpolateParams, Interpolator, sanitizeStrategy);
	        }
	        Interpolator.setLocale($uses);
	      }
	
	      return result;
	    };
	
	
	    /**
	     * @name translateByHandler
	     * @private
	     *
	     * Translate by missing translation handler.
	     *
	     * @param translationId
	     * @param interpolateParams
	     * @param defaultTranslationText
	     * @param sanitizeStrategy sanitize strategy override
	     *
	     * @returns translation created by $missingTranslationHandler or translationId is $missingTranslationHandler is
	     * absent
	     */
	    var translateByHandler = function (translationId, interpolateParams, defaultTranslationText, sanitizeStrategy) {
	      // If we have a handler factory - we might also call it here to determine if it provides
	      // a default text for a translationid that can't be found anywhere in our tables
	      if ($missingTranslationHandlerFactory) {
	        return $injector.get($missingTranslationHandlerFactory)(translationId, $uses, interpolateParams, defaultTranslationText, sanitizeStrategy);
	      } else {
	        return translationId;
	      }
	    };
	
	    /**
	     * @name resolveForFallbackLanguage
	     * @private
	     *
	     * Recursive helper function for fallbackTranslation that will sequentially look
	     * for a translation in the fallbackLanguages starting with fallbackLanguageIndex.
	     *
	     * @param fallbackLanguageIndex
	     * @param translationId
	     * @param interpolateParams
	     * @param Interpolator
	     * @param defaultTranslationText
	     * @param sanitizeStrategy
	     * @returns {Q.promise} Promise that will resolve to the translation.
	     */
	    var resolveForFallbackLanguage = function (fallbackLanguageIndex, translationId, interpolateParams, Interpolator, defaultTranslationText, sanitizeStrategy) {
	      var deferred = $q.defer();
	
	      if (fallbackLanguageIndex < $fallbackLanguage.length) {
	        var langKey = $fallbackLanguage[fallbackLanguageIndex];
	        getFallbackTranslation(langKey, translationId, interpolateParams, Interpolator, sanitizeStrategy).then(
	          function (data) {
	            deferred.resolve(data);
	          },
	          function () {
	            // Look in the next fallback language for a translation.
	            // It delays the resolving by passing another promise to resolve.
	            return resolveForFallbackLanguage(fallbackLanguageIndex + 1, translationId, interpolateParams, Interpolator, defaultTranslationText, sanitizeStrategy).then(deferred.resolve, deferred.reject);
	          }
	        );
	      } else {
	        // No translation found in any fallback language
	        // if a default translation text is set in the directive, then return this as a result
	        if (defaultTranslationText) {
	          deferred.resolve(defaultTranslationText);
	        } else {
	          var missingTranslationHandlerTranslation = translateByHandler(translationId, interpolateParams, defaultTranslationText);
	
	          // if no default translation is set and an error handler is defined, send it to the handler
	          // and then return the result if it isn't undefined
	          if ($missingTranslationHandlerFactory && missingTranslationHandlerTranslation) {
	            deferred.resolve(missingTranslationHandlerTranslation);
	          } else {
	            deferred.reject(applyNotFoundIndicators(translationId));
	          }
	        }
	      }
	      return deferred.promise;
	    };
	
	    /**
	     * @name resolveForFallbackLanguageInstant
	     * @private
	     *
	     * Recursive helper function for fallbackTranslation that will sequentially look
	     * for a translation in the fallbackLanguages starting with fallbackLanguageIndex.
	     *
	     * @param fallbackLanguageIndex
	     * @param translationId
	     * @param interpolateParams
	     * @param Interpolator
	     * @param sanitizeStrategy
	     * @returns {string} translation
	     */
	    var resolveForFallbackLanguageInstant = function (fallbackLanguageIndex, translationId, interpolateParams, Interpolator, sanitizeStrategy) {
	      var result;
	
	      if (fallbackLanguageIndex < $fallbackLanguage.length) {
	        var langKey = $fallbackLanguage[fallbackLanguageIndex];
	        result = getFallbackTranslationInstant(langKey, translationId, interpolateParams, Interpolator, sanitizeStrategy);
	        if (!result && result !== '') {
	          result = resolveForFallbackLanguageInstant(fallbackLanguageIndex + 1, translationId, interpolateParams, Interpolator);
	        }
	      }
	      return result;
	    };
	
	    /**
	     * Translates with the usage of the fallback languages.
	     *
	     * @param translationId
	     * @param interpolateParams
	     * @param Interpolator
	     * @param defaultTranslationText
	     * @param sanitizeStrategy
	     * @returns {Q.promise} Promise, that resolves to the translation.
	     */
	    var fallbackTranslation = function (translationId, interpolateParams, Interpolator, defaultTranslationText, sanitizeStrategy) {
	      // Start with the fallbackLanguage with index 0
	      return resolveForFallbackLanguage((startFallbackIteration > 0 ? startFallbackIteration : fallbackIndex), translationId, interpolateParams, Interpolator, defaultTranslationText, sanitizeStrategy);
	    };
	
	    /**
	     * Translates with the usage of the fallback languages.
	     *
	     * @param translationId
	     * @param interpolateParams
	     * @param Interpolator
	     * @param sanitizeStrategy
	     * @returns {String} translation
	     */
	    var fallbackTranslationInstant = function (translationId, interpolateParams, Interpolator, sanitizeStrategy) {
	      // Start with the fallbackLanguage with index 0
	      return resolveForFallbackLanguageInstant((startFallbackIteration > 0 ? startFallbackIteration : fallbackIndex), translationId, interpolateParams, Interpolator, sanitizeStrategy);
	    };
	
	    var determineTranslation = function (translationId, interpolateParams, interpolationId, defaultTranslationText, uses, sanitizeStrategy) {
	
	      var deferred = $q.defer();
	
	      var table = uses ? $translationTable[uses] : $translationTable,
	        Interpolator = (interpolationId) ? interpolatorHashMap[interpolationId] : defaultInterpolator;
	
	      // if the translation id exists, we can just interpolate it
	      if (table && Object.prototype.hasOwnProperty.call(table, translationId) && table[translationId] !== null) {
	        var translation = table[translationId];
	
	        // If using link, rerun $translate with linked translationId and return it
	        if (translation.substr(0, 2) === '@:') {
	
	          $translate(translation.substr(2), interpolateParams, interpolationId, defaultTranslationText, uses, sanitizeStrategy)
	            .then(deferred.resolve, deferred.reject);
	        } else {
	          //
	          var resolvedTranslation = Interpolator.interpolate(translation, interpolateParams, 'service', sanitizeStrategy, translationId);
	          resolvedTranslation = applyPostProcessing(translationId, translation, resolvedTranslation, interpolateParams, uses);
	          deferred.resolve(resolvedTranslation);
	        }
	      } else {
	        var missingTranslationHandlerTranslation;
	        // for logging purposes only (as in $translateMissingTranslationHandlerLog), value is not returned to promise
	        if ($missingTranslationHandlerFactory && !pendingLoader) {
	          missingTranslationHandlerTranslation = translateByHandler(translationId, interpolateParams, defaultTranslationText);
	        }
	
	        // since we couldn't translate the inital requested translation id,
	        // we try it now with one or more fallback languages, if fallback language(s) is
	        // configured.
	        if (uses && $fallbackLanguage && $fallbackLanguage.length) {
	          fallbackTranslation(translationId, interpolateParams, Interpolator, defaultTranslationText, sanitizeStrategy)
	            .then(function (translation) {
	              deferred.resolve(translation);
	            }, function (_translationId) {
	              deferred.reject(applyNotFoundIndicators(_translationId));
	            });
	        } else if ($missingTranslationHandlerFactory && !pendingLoader && missingTranslationHandlerTranslation) {
	          // looks like the requested translation id doesn't exists.
	          // Now, if there is a registered handler for missing translations and no
	          // asyncLoader is pending, we execute the handler
	          if (defaultTranslationText) {
	            deferred.resolve(defaultTranslationText);
	          } else {
	            deferred.resolve(missingTranslationHandlerTranslation);
	          }
	        } else {
	          if (defaultTranslationText) {
	            deferred.resolve(defaultTranslationText);
	          } else {
	            deferred.reject(applyNotFoundIndicators(translationId));
	          }
	        }
	      }
	      return deferred.promise;
	    };
	
	    var determineTranslationInstant = function (translationId, interpolateParams, interpolationId, uses, sanitizeStrategy) {
	
	      var result, table = uses ? $translationTable[uses] : $translationTable,
	        Interpolator = defaultInterpolator;
	
	      // if the interpolation id exists use custom interpolator
	      if (interpolatorHashMap && Object.prototype.hasOwnProperty.call(interpolatorHashMap, interpolationId)) {
	        Interpolator = interpolatorHashMap[interpolationId];
	      }
	
	      // if the translation id exists, we can just interpolate it
	      if (table && Object.prototype.hasOwnProperty.call(table, translationId) && table[translationId] !== null) {
	        var translation = table[translationId];
	
	        // If using link, rerun $translate with linked translationId and return it
	        if (translation.substr(0, 2) === '@:') {
	          result = determineTranslationInstant(translation.substr(2), interpolateParams, interpolationId, uses, sanitizeStrategy);
	        } else {
	          result = Interpolator.interpolate(translation, interpolateParams, 'filter', sanitizeStrategy, translationId);
	          result = applyPostProcessing(translationId, translation, result, interpolateParams, uses, sanitizeStrategy);
	        }
	      } else {
	        var missingTranslationHandlerTranslation;
	        // for logging purposes only (as in $translateMissingTranslationHandlerLog), value is not returned to promise
	        if ($missingTranslationHandlerFactory && !pendingLoader) {
	          missingTranslationHandlerTranslation = translateByHandler(translationId, interpolateParams, sanitizeStrategy);
	        }
	
	        // since we couldn't translate the inital requested translation id,
	        // we try it now with one or more fallback languages, if fallback language(s) is
	        // configured.
	        if (uses && $fallbackLanguage && $fallbackLanguage.length) {
	          fallbackIndex = 0;
	          result = fallbackTranslationInstant(translationId, interpolateParams, Interpolator, sanitizeStrategy);
	        } else if ($missingTranslationHandlerFactory && !pendingLoader && missingTranslationHandlerTranslation) {
	          // looks like the requested translation id doesn't exists.
	          // Now, if there is a registered handler for missing translations and no
	          // asyncLoader is pending, we execute the handler
	          result = missingTranslationHandlerTranslation;
	        } else {
	          result = applyNotFoundIndicators(translationId);
	        }
	      }
	
	      return result;
	    };
	
	    var clearNextLangAndPromise = function (key) {
	      if ($nextLang === key) {
	        $nextLang = undefined;
	      }
	      langPromises[key] = undefined;
	    };
	
	    var applyPostProcessing = function (translationId, translation, resolvedTranslation, interpolateParams, uses, sanitizeStrategy) {
	      var fn = postProcessFn;
	
	      if (fn) {
	
	        if (typeof(fn) === 'string') {
	          // getting on-demand instance
	          fn = $injector.get(fn);
	        }
	        if (fn) {
	          return fn(translationId, translation, resolvedTranslation, interpolateParams, uses, sanitizeStrategy);
	        }
	      }
	
	      return resolvedTranslation;
	    };
	
	    var loadTranslationsIfMissing = function (key) {
	      if (!$translationTable[key] && $loaderFactory && !langPromises[key]) {
	        langPromises[key] = loadAsync(key).then(function (translation) {
	          translations(translation.key, translation.table);
	          return translation;
	        });
	      }
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#preferredLanguage
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns the language key for the preferred language.
	     *
	     * @param {string} langKey language String or Array to be used as preferredLanguage (changing at runtime)
	     *
	     * @return {string} preferred language key
	     */
	    $translate.preferredLanguage = function (langKey) {
	      if (langKey) {
	        setupPreferredLanguage(langKey);
	      }
	      return $preferredLanguage;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#cloakClassName
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns the configured class name for `translate-cloak` directive.
	     *
	     * @return {string} cloakClassName
	     */
	    $translate.cloakClassName = function () {
	      return $cloakClassName;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#allowNamespaces
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns if namespaces are enabled
	     *
	     * @return {boolean} allowNamespaces value
	     */
	    $translate.allowNamespaces = function () {
	      return $allowNamespaces;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#nestedObjectDelimeter
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns the configured delimiter for nested namespaces.
	     *
	     * @return {string} nestedObjectDelimeter
	     */
	    $translate.nestedObjectDelimeter = function () {
	      return $nestedObjectDelimeter;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#fallbackLanguage
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns the language key for the fallback languages or sets a new fallback stack.
	     * It is recommended to call this before {@link pascalprecht.translate.$translateProvider#preferredLanguage preferredLanguage()}.
	     *
	     * @param {string=} langKey language String or Array of fallback languages to be used (to change stack at runtime)
	     *
	     * @return {string||array} fallback language key
	     */
	    $translate.fallbackLanguage = function (langKey) {
	      if (langKey !== undefined && langKey !== null) {
	        fallbackStack(langKey);
	
	        // as we might have an async loader initiated and a new translation language might have been defined
	        // we need to add the promise to the stack also. So - iterate.
	        if ($loaderFactory) {
	          if ($fallbackLanguage && $fallbackLanguage.length) {
	            for (var i = 0, len = $fallbackLanguage.length; i < len; i++) {
	              if (!langPromises[$fallbackLanguage[i]]) {
	                langPromises[$fallbackLanguage[i]] = loadAsync($fallbackLanguage[i]);
	              }
	            }
	          }
	        }
	        $translate.use($translate.use());
	      }
	      if ($fallbackWasString) {
	        return $fallbackLanguage[0];
	      } else {
	        return $fallbackLanguage;
	      }
	
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#useFallbackLanguage
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Sets the first key of the fallback language stack to be used for translation.
	     * Therefore all languages in the fallback array BEFORE this key will be skipped!
	     *
	     * @param {string=} langKey Contains the langKey the iteration shall start with. Set to false if you want to
	     * get back to the whole stack
	     */
	    $translate.useFallbackLanguage = function (langKey) {
	      if (langKey !== undefined && langKey !== null) {
	        if (!langKey) {
	          startFallbackIteration = 0;
	        } else {
	          var langKeyPosition = indexOf($fallbackLanguage, langKey);
	          if (langKeyPosition > -1) {
	            startFallbackIteration = langKeyPosition;
	          }
	        }
	
	      }
	
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#proposedLanguage
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns the language key of language that is currently loaded asynchronously.
	     *
	     * @return {string} language key
	     */
	    $translate.proposedLanguage = function () {
	      return $nextLang;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#storage
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns registered storage.
	     *
	     * @return {object} Storage
	     */
	    $translate.storage = function () {
	      return Storage;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#negotiateLocale
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns a language key based on available languages and language aliases. If a
	     * language key cannot be resolved, returns undefined.
	     *
	     * If no or a falsy key is given, returns undefined.
	     *
	     * @param {string} [key] Language key
	     * @return {string|undefined} Language key or undefined if no language key is found.
	     */
	    $translate.negotiateLocale = negotiateLocale;
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#use
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Tells angular-translate which language to use by given language key. This method is
	     * used to change language at runtime. It also takes care of storing the language
	     * key in a configured store to let your app remember the choosed language.
	     *
	     * When trying to 'use' a language which isn't available it tries to load it
	     * asynchronously with registered loaders.
	     *
	     * Returns promise object with loaded language file data or string of the currently used language.
	     *
	     * If no or a falsy key is given it returns the currently used language key.
	     * The returned string will be ```undefined``` if setting up $translate hasn't finished.
	     * @example
	     * $translate.use("en_US").then(function(data){
	       *   $scope.text = $translate("HELLO");
	       * });
	     *
	     * @param {string=} key Language key
	     * @return {object|string} Promise with loaded language data or the language key if a falsy param was given.
	     */
	    $translate.use = function (key) {
	      if (!key) {
	        return $uses;
	      }
	
	      var deferred = $q.defer();
	      deferred.promise.then(null, angular.noop); // AJS "Possibly unhandled rejection"
	
	      $rootScope.$emit('$translateChangeStart', {language : key});
	
	      // Try to get the aliased language key
	      var aliasedKey = negotiateLocale(key);
	      // Ensure only registered language keys will be loaded
	      if ($availableLanguageKeys.length > 0 && !aliasedKey) {
	        return $q.reject(key);
	      }
	
	      if (aliasedKey) {
	        key = aliasedKey;
	      }
	
	      // if there isn't a translation table for the language we've requested,
	      // we load it asynchronously
	      $nextLang = key;
	      if (($forceAsyncReloadEnabled || !$translationTable[key]) && $loaderFactory && !langPromises[key]) {
	        langPromises[key] = loadAsync(key).then(function (translation) {
	          translations(translation.key, translation.table);
	          deferred.resolve(translation.key);
	          if ($nextLang === key) {
	            useLanguage(translation.key);
	          }
	          return translation;
	        }, function (key) {
	          $rootScope.$emit('$translateChangeError', {language : key});
	          deferred.reject(key);
	          $rootScope.$emit('$translateChangeEnd', {language : key});
	          return $q.reject(key);
	        });
	        langPromises[key]['finally'](function () {
	          clearNextLangAndPromise(key);
	        })['catch'](angular.noop); // we don't care about errors (clearing)
	      } else if (langPromises[key]) {
	        // we are already loading this asynchronously
	        // resolve our new deferred when the old langPromise is resolved
	        langPromises[key].then(function (translation) {
	          if ($nextLang === translation.key) {
	            useLanguage(translation.key);
	          }
	          deferred.resolve(translation.key);
	          return translation;
	        }, function (key) {
	          // find first available fallback language if that request has failed
	          if (!$uses && $fallbackLanguage && $fallbackLanguage.length > 0 && $fallbackLanguage[0] !== key) {
	            return $translate.use($fallbackLanguage[0]).then(deferred.resolve, deferred.reject);
	          } else {
	            return deferred.reject(key);
	          }
	        });
	      } else {
	        deferred.resolve(key);
	        useLanguage(key);
	      }
	
	      return deferred.promise;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#resolveClientLocale
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * This returns the current browser/client's language key. The result is processed with the configured uniform tag resolver.
	     *
	     * @returns {string} the current client/browser language key
	     */
	    $translate.resolveClientLocale = function () {
	      return getLocale();
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#storageKey
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns the key for the storage.
	     *
	     * @return {string} storage key
	     */
	    $translate.storageKey = function () {
	      return storageKey();
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#isPostCompilingEnabled
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns whether post compiling is enabled or not
	     *
	     * @return {bool} storage key
	     */
	    $translate.isPostCompilingEnabled = function () {
	      return $postCompilingEnabled;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#isForceAsyncReloadEnabled
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns whether force async reload is enabled or not
	     *
	     * @return {boolean} forceAsyncReload value
	     */
	    $translate.isForceAsyncReloadEnabled = function () {
	      return $forceAsyncReloadEnabled;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#isKeepContent
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns whether keepContent or not
	     *
	     * @return {boolean} keepContent value
	     */
	    $translate.isKeepContent = function () {
	      return $keepContent;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#refresh
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Refreshes a translation table pointed by the given langKey. If langKey is not specified,
	     * the module will drop all existent translation tables and load new version of those which
	     * are currently in use.
	     *
	     * Refresh means that the module will drop target translation table and try to load it again.
	     *
	     * In case there are no loaders registered the refresh() method will throw an Error.
	     *
	     * If the module is able to refresh translation tables refresh() method will broadcast
	     * $translateRefreshStart and $translateRefreshEnd events.
	     *
	     * @example
	     * // this will drop all currently existent translation tables and reload those which are
	     * // currently in use
	     * $translate.refresh();
	     * // this will refresh a translation table for the en_US language
	     * $translate.refresh('en_US');
	     *
	     * @param {string} langKey A language key of the table, which has to be refreshed
	     *
	     * @return {promise} Promise, which will be resolved in case a translation tables refreshing
	     * process is finished successfully, and reject if not.
	     */
	    $translate.refresh = function (langKey) {
	      if (!$loaderFactory) {
	        throw new Error('Couldn\'t refresh translation table, no loader registered!');
	      }
	
	      $rootScope.$emit('$translateRefreshStart', {language : langKey});
	
	      var deferred = $q.defer(), updatedLanguages = {};
	
	      //private helper
	      function loadNewData(languageKey) {
	        var promise = loadAsync(languageKey);
	        //update the load promise cache for this language
	        langPromises[languageKey] = promise;
	        //register a data handler for the promise
	        promise.then(function (data) {
	            //clear the cache for this language
	            $translationTable[languageKey] = {};
	            //add the new data for this language
	            translations(languageKey, data.table);
	            //track that we updated this language
	            updatedLanguages[languageKey] = true;
	          },
	          //handle rejection to appease the $q validation
	          angular.noop);
	        return promise;
	      }
	
	      //set up post-processing
	      deferred.promise.then(
	        function () {
	          for (var key in $translationTable) {
	            if ($translationTable.hasOwnProperty(key)) {
	              //delete cache entries that were not updated
	              if (!(key in updatedLanguages)) {
	                delete $translationTable[key];
	              }
	            }
	          }
	          if ($uses) {
	            useLanguage($uses);
	          }
	        },
	        //handle rejection to appease the $q validation
	        angular.noop
	      )['finally'](
	        function () {
	          $rootScope.$emit('$translateRefreshEnd', {language : langKey});
	        }
	      );
	
	      if (!langKey) {
	        // if there's no language key specified we refresh ALL THE THINGS!
	        var languagesToReload = $fallbackLanguage && $fallbackLanguage.slice() || [];
	        if ($uses && languagesToReload.indexOf($uses) === -1) {
	          languagesToReload.push($uses);
	        }
	        $q.all(languagesToReload.map(loadNewData)).then(deferred.resolve, deferred.reject);
	
	      } else if ($translationTable[langKey]) {
	        //just refresh the specified language cache
	        loadNewData(langKey).then(deferred.resolve, deferred.reject);
	
	      } else {
	        deferred.reject();
	      }
	
	      return deferred.promise;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#instant
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns a translation instantly from the internal state of loaded translation. All rules
	     * regarding the current language, the preferred language of even fallback languages will be
	     * used except any promise handling. If a language was not found, an asynchronous loading
	     * will be invoked in the background.
	     *
	     * @param {string|array} translationId A token which represents a translation id
	     *                                     This can be optionally an array of translation ids which
	     *                                     results that the function's promise returns an object where
	     *                                     each key is the translation id and the value the translation.
	     * @param {object=} [interpolateParams={}] Params
	     * @param {string=} [interpolationId=undefined] The id of the interpolation to use (use default unless set via useInterpolation())
	     * @param {string=} [forceLanguage=false] A language to be used instead of the current language
	     * @param {string=} [sanitizeStrategy=undefined] force sanitize strategy for this call instead of using the configured one (use default unless set)
	     *
	     * @return {string|object} translation
	     */
	    $translate.instant = function (translationId, interpolateParams, interpolationId, forceLanguage, sanitizeStrategy) {
	
	      // we don't want to re-negotiate $uses
	      var uses = (forceLanguage && forceLanguage !== $uses) ? // we don't want to re-negotiate $uses
	        (negotiateLocale(forceLanguage) || forceLanguage) : $uses;
	
	      // Detect undefined and null values to shorten the execution and prevent exceptions
	      if (translationId === null || angular.isUndefined(translationId)) {
	        return translationId;
	      }
	
	      // Check forceLanguage is present
	      if (forceLanguage) {
	        loadTranslationsIfMissing(forceLanguage);
	      }
	
	      // Duck detection: If the first argument is an array, a bunch of translations was requested.
	      // The result is an object.
	      if (angular.isArray(translationId)) {
	        var results = {};
	        for (var i = 0, c = translationId.length; i < c; i++) {
	          results[translationId[i]] = $translate.instant(translationId[i], interpolateParams, interpolationId, forceLanguage, sanitizeStrategy);
	        }
	        return results;
	      }
	
	      // We discarded unacceptable values. So we just need to verify if translationId is empty String
	      if (angular.isString(translationId) && translationId.length < 1) {
	        return translationId;
	      }
	
	      // trim off any whitespace
	      if (translationId) {
	        translationId = trim.apply(translationId);
	      }
	
	      var result, possibleLangKeys = [];
	      if ($preferredLanguage) {
	        possibleLangKeys.push($preferredLanguage);
	      }
	      if (uses) {
	        possibleLangKeys.push(uses);
	      }
	      if ($fallbackLanguage && $fallbackLanguage.length) {
	        possibleLangKeys = possibleLangKeys.concat($fallbackLanguage);
	      }
	      for (var j = 0, d = possibleLangKeys.length; j < d; j++) {
	        var possibleLangKey = possibleLangKeys[j];
	        if ($translationTable[possibleLangKey]) {
	          if (typeof $translationTable[possibleLangKey][translationId] !== 'undefined') {
	            result = determineTranslationInstant(translationId, interpolateParams, interpolationId, uses, sanitizeStrategy);
	          }
	        }
	        if (typeof result !== 'undefined') {
	          break;
	        }
	      }
	
	      if (!result && result !== '') {
	        if ($notFoundIndicatorLeft || $notFoundIndicatorRight) {
	          result = applyNotFoundIndicators(translationId);
	        } else {
	          // Return translation of default interpolator if not found anything.
	          result = defaultInterpolator.interpolate(translationId, interpolateParams, 'filter', sanitizeStrategy);
	
	          // looks like the requested translation id doesn't exists.
	          // Now, if there is a registered handler for missing translations and no
	          // asyncLoader is pending, we execute the handler
	          var missingTranslationHandlerTranslation;
	          if ($missingTranslationHandlerFactory && !pendingLoader) {
	            missingTranslationHandlerTranslation = translateByHandler(translationId, interpolateParams, sanitizeStrategy);
	          }
	
	          if ($missingTranslationHandlerFactory && !pendingLoader && missingTranslationHandlerTranslation) {
	            result = missingTranslationHandlerTranslation;
	          }
	        }
	      }
	
	      return result;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#versionInfo
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns the current version information for the angular-translate library
	     *
	     * @return {string} angular-translate version
	     */
	    $translate.versionInfo = function () {
	      return version;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#loaderCache
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns the defined loaderCache.
	     *
	     * @return {boolean|string|object} current value of loaderCache
	     */
	    $translate.loaderCache = function () {
	      return loaderCache;
	    };
	
	    // internal purpose only
	    $translate.directivePriority = function () {
	      return directivePriority;
	    };
	
	    // internal purpose only
	    $translate.statefulFilter = function () {
	      return statefulFilter;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#isReady
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns whether the service is "ready" to translate (i.e. loading 1st language).
	     *
	     * See also {@link pascalprecht.translate.$translate#methods_onReady onReady()}.
	     *
	     * @return {boolean} current value of ready
	     */
	    $translate.isReady = function () {
	      return $isReady;
	    };
	
	    var $onReadyDeferred = $q.defer();
	    $onReadyDeferred.promise.then(function () {
	      $isReady = true;
	    });
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#onReady
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Calls the function provided or resolved the returned promise after the service is "ready" to translate (i.e. loading 1st language).
	     *
	     * See also {@link pascalprecht.translate.$translate#methods_isReady isReady()}.
	     *
	     * @param {Function=} fn Function to invoke when service is ready
	     * @return {object} Promise resolved when service is ready
	     */
	    $translate.onReady = function (fn) {
	      var deferred = $q.defer();
	      if (angular.isFunction(fn)) {
	        deferred.promise.then(fn);
	      }
	      if ($isReady) {
	        deferred.resolve();
	      } else {
	        $onReadyDeferred.promise.then(deferred.resolve);
	      }
	      return deferred.promise;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#getAvailableLanguageKeys
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * This function simply returns the registered language keys being defined before in the config phase
	     * With this, an application can use the array to provide a language selection dropdown or similar
	     * without any additional effort
	     *
	     * @returns {object} returns the list of possibly registered language keys and mapping or null if not defined
	     */
	    $translate.getAvailableLanguageKeys = function () {
	      if ($availableLanguageKeys.length > 0) {
	        return $availableLanguageKeys;
	      }
	      return null;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#getTranslationTable
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns translation table by the given language key.
	     *
	     * Unless a language is provided it returns a translation table of the current one.
	     * Note: If translation dictionary is currently downloading or in progress
	     * it will return null.
	     *
	     * @param {string} langKey A token which represents a translation id
	     *
	     * @return {object} a copy of angular-translate $translationTable
	     */
	    $translate.getTranslationTable = function (langKey) {
	      langKey = langKey || $translate.use();
	      if (langKey && $translationTable[langKey]) {
	        return angular.copy($translationTable[langKey]);
	      }
	      return null;
	    };
	
	    // Whenever $translateReady is being fired, this will ensure the state of $isReady
	    var globalOnReadyListener = $rootScope.$on('$translateReady', function () {
	      $onReadyDeferred.resolve();
	      globalOnReadyListener(); // one time only
	      globalOnReadyListener = null;
	    });
	    var globalOnChangeListener = $rootScope.$on('$translateChangeEnd', function () {
	      $onReadyDeferred.resolve();
	      globalOnChangeListener(); // one time only
	      globalOnChangeListener = null;
	    });
	
	    if ($loaderFactory) {
	
	      // If at least one async loader is defined and there are no
	      // (default) translations available we should try to load them.
	      if (angular.equals($translationTable, {})) {
	        if ($translate.use()) {
	          $translate.use($translate.use());
	        }
	      }
	
	      // Also, if there are any fallback language registered, we start
	      // loading them asynchronously as soon as we can.
	      if ($fallbackLanguage && $fallbackLanguage.length) {
	        var processAsyncResult = function (translation) {
	          translations(translation.key, translation.table);
	          $rootScope.$emit('$translateChangeEnd', {language : translation.key});
	          return translation;
	        };
	        for (var i = 0, len = $fallbackLanguage.length; i < len; i++) {
	          var fallbackLanguageId = $fallbackLanguage[i];
	          if ($forceAsyncReloadEnabled || !$translationTable[fallbackLanguageId]) {
	            langPromises[fallbackLanguageId] = loadAsync(fallbackLanguageId).then(processAsyncResult);
	          }
	        }
	      }
	    } else {
	      $rootScope.$emit('$translateReady', {language : $translate.use()});
	    }
	
	    return $translate;
	  }];
	}
	
	$translate.displayName = 'displayName';
	
	/**
	 * @ngdoc object
	 * @name pascalprecht.translate.$translateDefaultInterpolation
	 * @requires $interpolate
	 *
	 * @description
	 * Uses angular's `$interpolate` services to interpolate strings against some values.
	 *
	 * Be aware to configure a proper sanitization strategy.
	 *
	 * See also:
	 * * {@link pascalprecht.translate.$translateSanitization}
	 *
	 * @return {object} $translateDefaultInterpolation Interpolator service
	 */
	angular.module('pascalprecht.translate').factory('$translateDefaultInterpolation', $translateDefaultInterpolation);
	
	function $translateDefaultInterpolation ($interpolate, $translateSanitization) {
	
	  'use strict';
	
	  var $translateInterpolator = {},
	      $locale,
	      $identifier = 'default';
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateDefaultInterpolation#setLocale
	   * @methodOf pascalprecht.translate.$translateDefaultInterpolation
	   *
	   * @description
	   * Sets current locale (this is currently not use in this interpolation).
	   *
	   * @param {string} locale Language key or locale.
	   */
	  $translateInterpolator.setLocale = function (locale) {
	    $locale = locale;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateDefaultInterpolation#getInterpolationIdentifier
	   * @methodOf pascalprecht.translate.$translateDefaultInterpolation
	   *
	   * @description
	   * Returns an identifier for this interpolation service.
	   *
	   * @returns {string} $identifier
	   */
	  $translateInterpolator.getInterpolationIdentifier = function () {
	    return $identifier;
	  };
	
	  /**
	   * @deprecated will be removed in 3.0
	   * @see {@link pascalprecht.translate.$translateSanitization}
	   */
	  $translateInterpolator.useSanitizeValueStrategy = function (value) {
	    $translateSanitization.useStrategy(value);
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateDefaultInterpolation#interpolate
	   * @methodOf pascalprecht.translate.$translateDefaultInterpolation
	   *
	   * @description
	   * Interpolates given value agains given interpolate params using angulars
	   * `$interpolate` service.
	   *
	   * Since AngularJS 1.5, `value` must not be a string but can be anything input.
	   *
	   * @param {string} value translation
	   * @param {object} [interpolationParams={}] interpolation params
	   * @param {string} [context=undefined] current context (filter, directive, service)
	   * @param {string} [sanitizeStrategy=undefined] sanitize strategy (use default unless set)
	   * @param {string} translationId current translationId
	   *
	   * @returns {string} interpolated string
	   */
	  $translateInterpolator.interpolate = function (value, interpolationParams, context, sanitizeStrategy, translationId) { // jshint ignore:line
	    interpolationParams = interpolationParams || {};
	    interpolationParams = $translateSanitization.sanitize(interpolationParams, 'params', sanitizeStrategy, context);
	
	    var interpolatedText;
	    if (angular.isNumber(value)) {
	      // numbers are safe
	      interpolatedText = '' + value;
	    } else if (angular.isString(value)) {
	      // strings must be interpolated (that's the job here)
	      interpolatedText = $interpolate(value)(interpolationParams);
	      interpolatedText = $translateSanitization.sanitize(interpolatedText, 'text', sanitizeStrategy, context);
	    } else {
	      // neither a number or a string, cant interpolate => empty string
	      interpolatedText = '';
	    }
	
	    return interpolatedText;
	  };
	
	  return $translateInterpolator;
	}
	
	$translateDefaultInterpolation.displayName = '$translateDefaultInterpolation';
	
	angular.module('pascalprecht.translate').constant('$STORAGE_KEY', 'NG_TRANSLATE_LANG_KEY');
	
	angular.module('pascalprecht.translate')
	/**
	 * @ngdoc directive
	 * @name pascalprecht.translate.directive:translate
	 * @requires $interpolate,
	 * @requires $compile,
	 * @requires $parse,
	 * @requires $rootScope
	 * @restrict AE
	 *
	 * @description
	 * Translates given translation id either through attribute or DOM content.
	 * Internally it uses $translate service to translate the translation id. It possible to
	 * pass an optional `translate-values` object literal as string into translation id.
	 *
	 * @param {string=} translate Translation id which could be either string or interpolated string.
	 * @param {string=} translate-values Values to pass into translation id. Can be passed as object literal string or interpolated object.
	 * @param {string=} translate-attr-ATTR translate Translation id and put it into ATTR attribute.
	 * @param {string=} translate-default will be used unless translation was successful
	 * @param {string=} translate-sanitize-strategy defines locally sanitize strategy
	 * @param {boolean=} translate-compile (default true if present) defines locally activation of {@link pascalprecht.translate.$translateProvider#methods_usePostCompiling}
	 * @param {boolean=} translate-keep-content (default true if present) defines that in case a KEY could not be translated, that the existing content is left in the innerHTML}
	 *
	 * @example
	   <example module="ngView">
	    <file name="index.html">
	      <div ng-controller="TranslateCtrl">
	
	        <pre translate="TRANSLATION_ID"></pre>
	        <pre translate>TRANSLATION_ID</pre>
	        <pre translate translate-attr-title="TRANSLATION_ID"></pre>
	        <pre translate="{{translationId}}"></pre>
	        <pre translate>{{translationId}}</pre>
	        <pre translate="WITH_VALUES" translate-values="{value: 5}"></pre>
	        <pre translate translate-values="{value: 5}">WITH_VALUES</pre>
	        <pre translate="WITH_VALUES" translate-values="{{values}}"></pre>
	        <pre translate translate-values="{{values}}">WITH_VALUES</pre>
	        <pre translate translate-attr-title="WITH_VALUES" translate-values="{{values}}"></pre>
	        <pre translate="WITH_CAMEL_CASE_KEY" translate-value-camel-case-key="Hi"></pre>
	
	      </div>
	    </file>
	    <file name="script.js">
	      angular.module('ngView', ['pascalprecht.translate'])
	
	      .config(function ($translateProvider) {
	
	        $translateProvider.translations('en',{
	          'TRANSLATION_ID': 'Hello there!',
	          'WITH_VALUES': 'The following value is dynamic: {{value}}',
	          'WITH_CAMEL_CASE_KEY': 'The interpolation key is camel cased: {{camelCaseKey}}'
	        }).preferredLanguage('en');
	
	      });
	
	      angular.module('ngView').controller('TranslateCtrl', function ($scope) {
	        $scope.translationId = 'TRANSLATION_ID';
	
	        $scope.values = {
	          value: 78
	        };
	      });
	    </file>
	    <file name="scenario.js">
	      it('should translate', function () {
	        inject(function ($rootScope, $compile) {
	          $rootScope.translationId = 'TRANSLATION_ID';
	
	          element = $compile('<p translate="TRANSLATION_ID"></p>')($rootScope);
	          $rootScope.$digest();
	          expect(element.text()).toBe('Hello there!');
	
	          element = $compile('<p translate="{{translationId}}"></p>')($rootScope);
	          $rootScope.$digest();
	          expect(element.text()).toBe('Hello there!');
	
	          element = $compile('<p translate>TRANSLATION_ID</p>')($rootScope);
	          $rootScope.$digest();
	          expect(element.text()).toBe('Hello there!');
	
	          element = $compile('<p translate>{{translationId}}</p>')($rootScope);
	          $rootScope.$digest();
	          expect(element.text()).toBe('Hello there!');
	
	          element = $compile('<p translate translate-attr-title="TRANSLATION_ID"></p>')($rootScope);
	          $rootScope.$digest();
	          expect(element.attr('title')).toBe('Hello there!');
	
	          element = $compile('<p translate="WITH_CAMEL_CASE_KEY" translate-value-camel-case-key="Hello"></p>')($rootScope);
	          $rootScope.$digest();
	          expect(element.text()).toBe('The interpolation key is camel cased: Hello');
	        });
	      });
	    </file>
	   </example>
	 */
	.directive('translate', translateDirective);
	function translateDirective($translate, $interpolate, $compile, $parse, $rootScope) {
	
	  'use strict';
	
	  /**
	   * @name trim
	   * @private
	   *
	   * @description
	   * trim polyfill
	   *
	   * @returns {string} The string stripped of whitespace from both ends
	   */
	  var trim = function() {
	    return this.toString().replace(/^\s+|\s+$/g, '');
	  };
	
	  /**
	   * @name lowercase
	   * @private
	   *
	   * @description
	   * Return the lowercase string only if the type is string
	   *
	   * @returns {string} The string all in lowercase
	   */
	  var lowercase = function (string) {
	    return angular.isString(string) ? string.toLowerCase() : string;
	  };
	
	  return {
	    restrict: 'AE',
	    scope: true,
	    priority: $translate.directivePriority(),
	    compile: function (tElement, tAttr) {
	
	      var translateValuesExist = (tAttr.translateValues) ?
	        tAttr.translateValues : undefined;
	
	      var translateInterpolation = (tAttr.translateInterpolation) ?
	        tAttr.translateInterpolation : undefined;
	
	      var translateSanitizeStrategyExist = (tAttr.translateSanitizeStrategy) ?
	        tAttr.translateSanitizeStrategy : undefined;
	
	      var translateValueExist = tElement[0].outerHTML.match(/translate-value-+/i);
	
	      var interpolateRegExp = '^(.*)(' + $interpolate.startSymbol() + '.*' + $interpolate.endSymbol() + ')(.*)',
	          watcherRegExp = '^(.*)' + $interpolate.startSymbol() + '(.*)' + $interpolate.endSymbol() + '(.*)';
	
	      return function linkFn(scope, iElement, iAttr) {
	
	        scope.interpolateParams = {};
	        scope.preText = '';
	        scope.postText = '';
	        scope.translateNamespace = getTranslateNamespace(scope);
	        var translationIds = {};
	
	        var initInterpolationParams = function (interpolateParams, iAttr, tAttr) {
	          // initial setup
	          if (iAttr.translateValues) {
	            angular.extend(interpolateParams, $parse(iAttr.translateValues)(scope.$parent));
	          }
	          // initially fetch all attributes if existing and fill the params
	          if (translateValueExist) {
	            for (var attr in tAttr) {
	              if (Object.prototype.hasOwnProperty.call(iAttr, attr) && attr.substr(0, 14) === 'translateValue' && attr !== 'translateValues') {
	                var attributeName = lowercase(attr.substr(14, 1)) + attr.substr(15);
	                interpolateParams[attributeName] = tAttr[attr];
	              }
	            }
	          }
	        };
	
	        // Ensures any change of the attribute "translate" containing the id will
	        // be re-stored to the scope's "translationId".
	        // If the attribute has no content, the element's text value (white spaces trimmed off) will be used.
	        var observeElementTranslation = function (translationId) {
	
	          // Remove any old watcher
	          if (angular.isFunction(observeElementTranslation._unwatchOld)) {
	            observeElementTranslation._unwatchOld();
	            observeElementTranslation._unwatchOld = undefined;
	          }
	
	          if (angular.equals(translationId , '') || !angular.isDefined(translationId)) {
	            var iElementText = trim.apply(iElement.text()).replace(/\n/g, ' ');
	
	            // Resolve translation id by inner html if required
	            var interpolateMatches = iElementText.match(interpolateRegExp);
	            // Interpolate translation id if required
	            if (angular.isArray(interpolateMatches)) {
	              scope.preText = interpolateMatches[1];
	              scope.postText = interpolateMatches[3];
	              translationIds.translate = $interpolate(interpolateMatches[2])(scope.$parent);
	              var watcherMatches = iElementText.match(watcherRegExp);
	              if (angular.isArray(watcherMatches) && watcherMatches[2] && watcherMatches[2].length) {
	                observeElementTranslation._unwatchOld = scope.$watch(watcherMatches[2], function (newValue) {
	                  translationIds.translate = newValue;
	                  updateTranslations();
	                });
	              }
	            } else {
	              // do not assigne the translation id if it is empty.
	              translationIds.translate = !iElementText ? undefined : iElementText;
	            }
	          } else {
	            translationIds.translate = translationId;
	          }
	          updateTranslations();
	        };
	
	        var observeAttributeTranslation = function (translateAttr) {
	          iAttr.$observe(translateAttr, function (translationId) {
	            translationIds[translateAttr] = translationId;
	            updateTranslations();
	          });
	        };
	
	        // initial setup with values
	        initInterpolationParams(scope.interpolateParams, iAttr, tAttr);
	
	        var firstAttributeChangedEvent = true;
	        iAttr.$observe('translate', function (translationId) {
	          if (typeof translationId === 'undefined') {
	            // case of element "<translate>xyz</translate>"
	            observeElementTranslation('');
	          } else {
	            // case of regular attribute
	            if (translationId !== '' || !firstAttributeChangedEvent) {
	              translationIds.translate = translationId;
	              updateTranslations();
	            }
	          }
	          firstAttributeChangedEvent = false;
	        });
	
	        for (var translateAttr in iAttr) {
	          if (iAttr.hasOwnProperty(translateAttr) && translateAttr.substr(0, 13) === 'translateAttr' && translateAttr.length > 13) {
	            observeAttributeTranslation(translateAttr);
	          }
	        }
	
	        iAttr.$observe('translateDefault', function (value) {
	          scope.defaultText = value;
	          updateTranslations();
	        });
	
	        if (translateSanitizeStrategyExist) {
	          iAttr.$observe('translateSanitizeStrategy', function (value) {
	            scope.sanitizeStrategy = $parse(value)(scope.$parent);
	            updateTranslations();
	          });
	        }
	
	        if (translateValuesExist) {
	          iAttr.$observe('translateValues', function (interpolateParams) {
	            if (interpolateParams) {
	              scope.$parent.$watch(function () {
	                angular.extend(scope.interpolateParams, $parse(interpolateParams)(scope.$parent));
	              });
	            }
	          });
	        }
	
	        if (translateValueExist) {
	          var observeValueAttribute = function (attrName) {
	            iAttr.$observe(attrName, function (value) {
	              var attributeName = lowercase(attrName.substr(14, 1)) + attrName.substr(15);
	              scope.interpolateParams[attributeName] = value;
	            });
	          };
	          for (var attr in iAttr) {
	            if (Object.prototype.hasOwnProperty.call(iAttr, attr) && attr.substr(0, 14) === 'translateValue' && attr !== 'translateValues') {
	              observeValueAttribute(attr);
	            }
	          }
	        }
	
	        // Master update function
	        var updateTranslations = function () {
	          for (var key in translationIds) {
	            if (translationIds.hasOwnProperty(key) && translationIds[key] !== undefined) {
	              updateTranslation(key, translationIds[key], scope, scope.interpolateParams, scope.defaultText, scope.translateNamespace);
	            }
	          }
	        };
	
	        // Put translation processing function outside loop
	        var updateTranslation = function(translateAttr, translationId, scope, interpolateParams, defaultTranslationText, translateNamespace) {
	          if (translationId) {
	            // if translation id starts with '.' and translateNamespace given, prepend namespace
	            if (translateNamespace && translationId.charAt(0) === '.') {
	              translationId = translateNamespace + translationId;
	            }
	
	            $translate(translationId, interpolateParams, translateInterpolation, defaultTranslationText, scope.translateLanguage, scope.sanitizeStrategy)
	              .then(function (translation) {
	                applyTranslation(translation, scope, true, translateAttr);
	              }, function (translationId) {
	                applyTranslation(translationId, scope, false, translateAttr);
	              });
	          } else {
	            // as an empty string cannot be translated, we can solve this using successful=false
	            applyTranslation(translationId, scope, false, translateAttr);
	          }
	        };
	
	        var applyTranslation = function (value, scope, successful, translateAttr) {
	          if (!successful) {
	            if (typeof scope.defaultText !== 'undefined') {
	              value = scope.defaultText;
	            }
	          }
	          if (translateAttr === 'translate') {
	            // default translate into innerHTML
	            if (successful || (!successful && !$translate.isKeepContent() && typeof iAttr.translateKeepContent === 'undefined')) {
	              iElement.empty().append(scope.preText + value + scope.postText);
	            }
	            var globallyEnabled = $translate.isPostCompilingEnabled();
	            var locallyDefined = typeof tAttr.translateCompile !== 'undefined';
	            var locallyEnabled = locallyDefined && tAttr.translateCompile !== 'false';
	            if ((globallyEnabled && !locallyDefined) || locallyEnabled) {
	              $compile(iElement.contents())(scope);
	            }
	          } else {
	            // translate attribute
	            var attributeName = iAttr.$attr[translateAttr];
	            if (attributeName.substr(0, 5) === 'data-') {
	              // ensure html5 data prefix is stripped
	              attributeName = attributeName.substr(5);
	            }
	            attributeName = attributeName.substr(15);
	            iElement.attr(attributeName, value);
	          }
	        };
	
	        if (translateValuesExist || translateValueExist || iAttr.translateDefault) {
	          scope.$watch('interpolateParams', updateTranslations, true);
	        }
	
	        // Replaced watcher on translateLanguage with event listener
	        scope.$on('translateLanguageChanged', updateTranslations);
	
	        // Ensures the text will be refreshed after the current language was changed
	        // w/ $translate.use(...)
	        var unbind = $rootScope.$on('$translateChangeSuccess', updateTranslations);
	
	        // ensure translation will be looked up at least one
	        if (iElement.text().length) {
	          if (iAttr.translate) {
	            observeElementTranslation(iAttr.translate);
	          } else {
	            observeElementTranslation('');
	          }
	        } else if (iAttr.translate) {
	          // ensure attribute will be not skipped
	          observeElementTranslation(iAttr.translate);
	        }
	        updateTranslations();
	        scope.$on('$destroy', unbind);
	      };
	    }
	  };
	}
	
	/**
	 * Returns the scope's namespace.
	 * @private
	 * @param scope
	 * @returns {string}
	 */
	function getTranslateNamespace(scope) {
	  'use strict';
	  if (scope.translateNamespace) {
	    return scope.translateNamespace;
	  }
	  if (scope.$parent) {
	    return getTranslateNamespace(scope.$parent);
	  }
	}
	
	translateDirective.displayName = 'translateDirective';
	
	angular.module('pascalprecht.translate')
	/**
	 * @ngdoc directive
	 * @name pascalprecht.translate.directive:translate-attr
	 * @restrict A
	 *
	 * @description
	 * Translates attributes like translate-attr-ATTR, but with an object like ng-class.
	 * Internally it uses `translate` service to translate translation id. It possible to
	 * pass an optional `translate-values` object literal as string into translation id.
	 *
	 * @param {string=} translate-attr Object literal mapping attributes to translation ids.
	 * @param {string=} translate-values Values to pass into the translation ids. Can be passed as object literal string.
	 * @param {string=} translate-sanitize-strategy defines locally sanitize strategy
	 *
	 * @example
	   <example module="ngView">
	    <file name="index.html">
	      <div ng-controller="TranslateCtrl">
	
	        <input translate-attr="{ placeholder: translationId, title: 'WITH_VALUES' }" translate-values="{value: 5}" />
	
	      </div>
	    </file>
	    <file name="script.js">
	      angular.module('ngView', ['pascalprecht.translate'])
	
	      .config(function ($translateProvider) {
	
	        $translateProvider.translations('en',{
	          'TRANSLATION_ID': 'Hello there!',
	          'WITH_VALUES': 'The following value is dynamic: {{value}}',
	        }).preferredLanguage('en');
	
	      });
	
	      angular.module('ngView').controller('TranslateCtrl', function ($scope) {
	        $scope.translationId = 'TRANSLATION_ID';
	
	        $scope.values = {
	          value: 78
	        };
	      });
	    </file>
	    <file name="scenario.js">
	      it('should translate', function () {
	        inject(function ($rootScope, $compile) {
	          $rootScope.translationId = 'TRANSLATION_ID';
	
	          element = $compile('<input translate-attr="{ placeholder: translationId, title: 'WITH_VALUES' }" translate-values="{ value: 5 }" />')($rootScope);
	          $rootScope.$digest();
	          expect(element.attr('placeholder)).toBe('Hello there!');
	          expect(element.attr('title)).toBe('The following value is dynamic: 5');
	        });
	      });
	    </file>
	   </example>
	 */
	.directive('translateAttr', translateAttrDirective);
	function translateAttrDirective($translate, $rootScope) {
	
	  'use strict';
	
	  return {
	    restrict: 'A',
	    priority: $translate.directivePriority(),
	    link: function linkFn(scope, element, attr) {
	
	      var translateAttr,
	          translateValues,
	          translateSanitizeStrategy,
	          previousAttributes = {};
	
	      // Main update translations function
	      var updateTranslations = function () {
	        angular.forEach(translateAttr, function (translationId, attributeName) {
	          if (!translationId) {
	            return;
	          }
	          previousAttributes[attributeName] = true;
	
	          // if translation id starts with '.' and translateNamespace given, prepend namespace
	          if (scope.translateNamespace && translationId.charAt(0) === '.') {
	            translationId = scope.translateNamespace + translationId;
	          }
	          $translate(translationId, translateValues, attr.translateInterpolation, undefined, scope.translateLanguage, translateSanitizeStrategy)
	            .then(function (translation) {
	              element.attr(attributeName, translation);
	            }, function (translationId) {
	              element.attr(attributeName, translationId);
	            });
	        });
	
	        // Removing unused attributes that were previously used
	        angular.forEach(previousAttributes, function (flag, attributeName) {
	          if (!translateAttr[attributeName]) {
	            element.removeAttr(attributeName);
	            delete previousAttributes[attributeName];
	          }
	        });
	      };
	
	      // Watch for attribute changes
	      watchAttribute(
	        scope,
	        attr.translateAttr,
	        function (newValue) { translateAttr = newValue; },
	        updateTranslations
	      );
	      // Watch for value changes
	      watchAttribute(
	        scope,
	        attr.translateValues,
	        function (newValue) { translateValues = newValue; },
	        updateTranslations
	      );
	      // Watch for sanitize strategy changes
	      watchAttribute(
	        scope,
	        attr.translateSanitizeStrategy,
	        function (newValue) { translateSanitizeStrategy = newValue; },
	        updateTranslations
	      );
	
	      if (attr.translateValues) {
	        scope.$watch(attr.translateValues, updateTranslations, true);
	      }
	
	      // Replaced watcher on translateLanguage with event listener
	      scope.$on('translateLanguageChanged', updateTranslations);
	
	      // Ensures the text will be refreshed after the current language was changed
	      // w/ $translate.use(...)
	      var unbind = $rootScope.$on('$translateChangeSuccess', updateTranslations);
	
	      updateTranslations();
	      scope.$on('$destroy', unbind);
	    }
	  };
	}
	
	function watchAttribute(scope, attribute, valueCallback, changeCallback) {
	  'use strict';
	  if (!attribute) {
	    return;
	  }
	  if (attribute.substr(0, 2) === '::') {
	    attribute = attribute.substr(2);
	  } else {
	    scope.$watch(attribute, function(newValue) {
	      valueCallback(newValue);
	      changeCallback();
	    }, true);
	  }
	  valueCallback(scope.$eval(attribute));
	}
	
	translateAttrDirective.displayName = 'translateAttrDirective';
	
	angular.module('pascalprecht.translate')
	/**
	 * @ngdoc directive
	 * @name pascalprecht.translate.directive:translateCloak
	 * @requires $translate
	 * @restrict A
	 *
	 * $description
	 * Adds a `translate-cloak` class name to the given element where this directive
	 * is applied initially and removes it, once a loader has finished loading.
	 *
	 * This directive can be used to prevent initial flickering when loading translation
	 * data asynchronously.
	 *
	 * The class name is defined in
	 * {@link pascalprecht.translate.$translateProvider#cloakClassName $translate.cloakClassName()}.
	 *
	 * @param {string=} translate-cloak If a translationId is provided, it will be used for showing
	 *                                  or hiding the cloak. Basically it relies on the translation
	 *                                  resolve.
	 */
	.directive('translateCloak', translateCloakDirective);
	
	function translateCloakDirective($translate, $rootScope) {
	
	  'use strict';
	
	  return {
	    compile : function (tElement) {
	      var applyCloak = function (element) {
	          element.addClass($translate.cloakClassName());
	        },
	        removeCloak = function (element) {
	          element.removeClass($translate.cloakClassName());
	        };
	      applyCloak(tElement);
	
	      return function linkFn(scope, iElement, iAttr) {
	        //Create bound functions that incorporate the active DOM element.
	        var iRemoveCloak = removeCloak.bind(this, iElement), iApplyCloak = applyCloak.bind(this, iElement);
	        if (iAttr.translateCloak && iAttr.translateCloak.length) {
	          // Register a watcher for the defined translation allowing a fine tuned cloak
	          iAttr.$observe('translateCloak', function (translationId) {
	            $translate(translationId).then(iRemoveCloak, iApplyCloak);
	          });
	          $rootScope.$on('$translateChangeSuccess', function () {
	            $translate(iAttr.translateCloak).then(iRemoveCloak, iApplyCloak);
	          });
	        } else {
	          $translate.onReady(iRemoveCloak);
	        }
	      };
	    }
	  };
	}
	
	translateCloakDirective.displayName = 'translateCloakDirective';
	
	angular.module('pascalprecht.translate')
	/**
	 * @ngdoc directive
	 * @name pascalprecht.translate.directive:translateNamespace
	 * @restrict A
	 *
	 * @description
	 * Translates given translation id either through attribute or DOM content.
	 * Internally it uses `translate` filter to translate translation id. It is possible to
	 * pass an optional `translate-values` object literal as string into translation id.
	 *
	 * @param {string=} translate namespace name which could be either string or interpolated string.
	 *
	 * @example
	   <example module="ngView">
	    <file name="index.html">
	      <div translate-namespace="CONTENT">
	
	        <div>
	            <h1 translate>.HEADERS.TITLE</h1>
	            <h1 translate>.HEADERS.WELCOME</h1>
	        </div>
	
	        <div translate-namespace=".HEADERS">
	            <h1 translate>.TITLE</h1>
	            <h1 translate>.WELCOME</h1>
	        </div>
	
	      </div>
	    </file>
	    <file name="script.js">
	      angular.module('ngView', ['pascalprecht.translate'])
	
	      .config(function ($translateProvider) {
	
	        $translateProvider.translations('en',{
	          'TRANSLATION_ID': 'Hello there!',
	          'CONTENT': {
	            'HEADERS': {
	                TITLE: 'Title'
	            }
	          },
	          'CONTENT.HEADERS.WELCOME': 'Welcome'
	        }).preferredLanguage('en');
	
	      });
	
	    </file>
	   </example>
	 */
	.directive('translateNamespace', translateNamespaceDirective);
	
	function translateNamespaceDirective() {
	
	  'use strict';
	
	  return {
	    restrict: 'A',
	    scope: true,
	    compile: function () {
	      return {
	        pre: function (scope, iElement, iAttrs) {
	          scope.translateNamespace = _getTranslateNamespace(scope);
	
	          if (scope.translateNamespace && iAttrs.translateNamespace.charAt(0) === '.') {
	            scope.translateNamespace += iAttrs.translateNamespace;
	          } else {
	            scope.translateNamespace = iAttrs.translateNamespace;
	          }
	        }
	      };
	    }
	  };
	}
	
	/**
	 * Returns the scope's namespace.
	 * @private
	 * @param scope
	 * @returns {string}
	 */
	function _getTranslateNamespace(scope) {
	  'use strict';
	  if (scope.translateNamespace) {
	    return scope.translateNamespace;
	  }
	  if (scope.$parent) {
	    return _getTranslateNamespace(scope.$parent);
	  }
	}
	
	translateNamespaceDirective.displayName = 'translateNamespaceDirective';
	
	angular.module('pascalprecht.translate')
	/**
	 * @ngdoc directive
	 * @name pascalprecht.translate.directive:translateLanguage
	 * @restrict A
	 *
	 * @description
	 * Forces the language to the directives in the underlying scope.
	 *
	 * @param {string=} translate language that will be negotiated.
	 *
	 * @example
	   <example module="ngView">
	    <file name="index.html">
	      <div>
	
	        <div>
	            <h1 translate>HELLO</h1>
	        </div>
	
	        <div translate-language="de">
	            <h1 translate>HELLO</h1>
	        </div>
	
	      </div>
	    </file>
	    <file name="script.js">
	      angular.module('ngView', ['pascalprecht.translate'])
	
	      .config(function ($translateProvider) {
	
	        $translateProvider
	          .translations('en',{
	            'HELLO': 'Hello world!'
	          })
	          .translations('de',{
	            'HELLO': 'Hallo Welt!'
	          })
	          .preferredLanguage('en');
	
	      });
	
	    </file>
	   </example>
	 */
	.directive('translateLanguage', translateLanguageDirective);
	
	function translateLanguageDirective() {
	
	  'use strict';
	
	  return {
	    restrict: 'A',
	    scope: true,
	    compile: function () {
	      return function linkFn(scope, iElement, iAttrs) {
	
	        iAttrs.$observe('translateLanguage', function (newTranslateLanguage) {
	          scope.translateLanguage = newTranslateLanguage;
	        });
	
	        scope.$watch('translateLanguage', function(){
	          scope.$broadcast('translateLanguageChanged');
	        });
	      };
	    }
	  };
	}
	
	translateLanguageDirective.displayName = 'translateLanguageDirective';
	
	angular.module('pascalprecht.translate')
	/**
	 * @ngdoc filter
	 * @name pascalprecht.translate.filter:translate
	 * @requires $parse
	 * @requires pascalprecht.translate.$translate
	 * @function
	 *
	 * @description
	 * Uses `$translate` service to translate contents. Accepts interpolate parameters
	 * to pass dynamized values though translation.
	 *
	 * @param {string} translationId A translation id to be translated.
	 * @param {*=} interpolateParams Optional object literal (as hash or string) to pass values into translation.
	 *
	 * @returns {string} Translated text.
	 *
	 * @example
	   <example module="ngView">
	    <file name="index.html">
	      <div ng-controller="TranslateCtrl">
	
	        <pre>{{ 'TRANSLATION_ID' | translate }}</pre>
	        <pre>{{ translationId | translate }}</pre>
	        <pre>{{ 'WITH_VALUES' | translate:'{value: 5}' }}</pre>
	        <pre>{{ 'WITH_VALUES' | translate:values }}</pre>
	
	      </div>
	    </file>
	    <file name="script.js">
	      angular.module('ngView', ['pascalprecht.translate'])
	
	      .config(function ($translateProvider) {
	
	        $translateProvider.translations('en', {
	          'TRANSLATION_ID': 'Hello there!',
	          'WITH_VALUES': 'The following value is dynamic: {{value}}'
	        });
	        $translateProvider.preferredLanguage('en');
	
	      });
	
	      angular.module('ngView').controller('TranslateCtrl', function ($scope) {
	        $scope.translationId = 'TRANSLATION_ID';
	
	        $scope.values = {
	          value: 78
	        };
	      });
	    </file>
	   </example>
	 */
	.filter('translate', translateFilterFactory);
	
	function translateFilterFactory($parse, $translate) {
	
	  'use strict';
	
	  var translateFilter = function (translationId, interpolateParams, interpolation, forceLanguage) {
	    if (!angular.isObject(interpolateParams)) {
	      var ctx = this || {
	        '__SCOPE_IS_NOT_AVAILABLE': 'More info at https://github.com/angular/angular.js/commit/8863b9d04c722b278fa93c5d66ad1e578ad6eb1f'
	        };
	      interpolateParams = $parse(interpolateParams)(ctx);
	    }
	
	    return $translate.instant(translationId, interpolateParams, interpolation, forceLanguage);
	  };
	
	  if ($translate.statefulFilter()) {
	    translateFilter.$stateful = true;
	  }
	
	  return translateFilter;
	}
	
	translateFilterFactory.displayName = 'translateFilterFactory';
	
	angular.module('pascalprecht.translate')
	
	/**
	 * @ngdoc object
	 * @name pascalprecht.translate.$translationCache
	 * @requires $cacheFactory
	 *
	 * @description
	 * The first time a translation table is used, it is loaded in the translation cache for quick retrieval. You
	 * can load translation tables directly into the cache by consuming the
	 * `$translationCache` service directly.
	 *
	 * @return {object} $cacheFactory object.
	 */
	  .factory('$translationCache', $translationCache);
	
	function $translationCache($cacheFactory) {
	
	  'use strict';
	
	  return $cacheFactory('translations');
	}
	
	$translationCache.displayName = '$translationCache';
	return 'pascalprecht.translate';
	
	}));


/***/ }),
/* 1135 */
/***/ (function(module, exports) {

	/**
	 * State-based routing for AngularJS
	 * @version v0.2.18
	 * @link http://angular-ui.github.com/
	 * @license MIT License, http://www.opensource.org/licenses/MIT
	 */
	
	/* commonjs package manager support (eg componentjs) */
	if (typeof module !== "undefined" && typeof exports !== "undefined" && module.exports === exports){
	  module.exports = 'ui.router';
	}
	
	(function (window, angular, undefined) {
	/*jshint globalstrict:true*/
	/*global angular:false*/
	'use strict';
	
	var isDefined = angular.isDefined,
	    isFunction = angular.isFunction,
	    isString = angular.isString,
	    isObject = angular.isObject,
	    isArray = angular.isArray,
	    forEach = angular.forEach,
	    extend = angular.extend,
	    copy = angular.copy,
	    toJson = angular.toJson;
	
	function inherit(parent, extra) {
	  return extend(new (extend(function() {}, { prototype: parent }))(), extra);
	}
	
	function merge(dst) {
	  forEach(arguments, function(obj) {
	    if (obj !== dst) {
	      forEach(obj, function(value, key) {
	        if (!dst.hasOwnProperty(key)) dst[key] = value;
	      });
	    }
	  });
	  return dst;
	}
	
	/**
	 * Finds the common ancestor path between two states.
	 *
	 * @param {Object} first The first state.
	 * @param {Object} second The second state.
	 * @return {Array} Returns an array of state names in descending order, not including the root.
	 */
	function ancestors(first, second) {
	  var path = [];
	
	  for (var n in first.path) {
	    if (first.path[n] !== second.path[n]) break;
	    path.push(first.path[n]);
	  }
	  return path;
	}
	
	/**
	 * IE8-safe wrapper for `Object.keys()`.
	 *
	 * @param {Object} object A JavaScript object.
	 * @return {Array} Returns the keys of the object as an array.
	 */
	function objectKeys(object) {
	  if (Object.keys) {
	    return Object.keys(object);
	  }
	  var result = [];
	
	  forEach(object, function(val, key) {
	    result.push(key);
	  });
	  return result;
	}
	
	/**
	 * IE8-safe wrapper for `Array.prototype.indexOf()`.
	 *
	 * @param {Array} array A JavaScript array.
	 * @param {*} value A value to search the array for.
	 * @return {Number} Returns the array index value of `value`, or `-1` if not present.
	 */
	function indexOf(array, value) {
	  if (Array.prototype.indexOf) {
	    return array.indexOf(value, Number(arguments[2]) || 0);
	  }
	  var len = array.length >>> 0, from = Number(arguments[2]) || 0;
	  from = (from < 0) ? Math.ceil(from) : Math.floor(from);
	
	  if (from < 0) from += len;
	
	  for (; from < len; from++) {
	    if (from in array && array[from] === value) return from;
	  }
	  return -1;
	}
	
	/**
	 * Merges a set of parameters with all parameters inherited between the common parents of the
	 * current state and a given destination state.
	 *
	 * @param {Object} currentParams The value of the current state parameters ($stateParams).
	 * @param {Object} newParams The set of parameters which will be composited with inherited params.
	 * @param {Object} $current Internal definition of object representing the current state.
	 * @param {Object} $to Internal definition of object representing state to transition to.
	 */
	function inheritParams(currentParams, newParams, $current, $to) {
	  var parents = ancestors($current, $to), parentParams, inherited = {}, inheritList = [];
	
	  for (var i in parents) {
	    if (!parents[i] || !parents[i].params) continue;
	    parentParams = objectKeys(parents[i].params);
	    if (!parentParams.length) continue;
	
	    for (var j in parentParams) {
	      if (indexOf(inheritList, parentParams[j]) >= 0) continue;
	      inheritList.push(parentParams[j]);
	      inherited[parentParams[j]] = currentParams[parentParams[j]];
	    }
	  }
	  return extend({}, inherited, newParams);
	}
	
	/**
	 * Performs a non-strict comparison of the subset of two objects, defined by a list of keys.
	 *
	 * @param {Object} a The first object.
	 * @param {Object} b The second object.
	 * @param {Array} keys The list of keys within each object to compare. If the list is empty or not specified,
	 *                     it defaults to the list of keys in `a`.
	 * @return {Boolean} Returns `true` if the keys match, otherwise `false`.
	 */
	function equalForKeys(a, b, keys) {
	  if (!keys) {
	    keys = [];
	    for (var n in a) keys.push(n); // Used instead of Object.keys() for IE8 compatibility
	  }
	
	  for (var i=0; i<keys.length; i++) {
	    var k = keys[i];
	    if (a[k] != b[k]) return false; // Not '===', values aren't necessarily normalized
	  }
	  return true;
	}
	
	/**
	 * Returns the subset of an object, based on a list of keys.
	 *
	 * @param {Array} keys
	 * @param {Object} values
	 * @return {Boolean} Returns a subset of `values`.
	 */
	function filterByKeys(keys, values) {
	  var filtered = {};
	
	  forEach(keys, function (name) {
	    filtered[name] = values[name];
	  });
	  return filtered;
	}
	
	// like _.indexBy
	// when you know that your index values will be unique, or you want last-one-in to win
	function indexBy(array, propName) {
	  var result = {};
	  forEach(array, function(item) {
	    result[item[propName]] = item;
	  });
	  return result;
	}
	
	// extracted from underscore.js
	// Return a copy of the object only containing the whitelisted properties.
	function pick(obj) {
	  var copy = {};
	  var keys = Array.prototype.concat.apply(Array.prototype, Array.prototype.slice.call(arguments, 1));
	  forEach(keys, function(key) {
	    if (key in obj) copy[key] = obj[key];
	  });
	  return copy;
	}
	
	// extracted from underscore.js
	// Return a copy of the object omitting the blacklisted properties.
	function omit(obj) {
	  var copy = {};
	  var keys = Array.prototype.concat.apply(Array.prototype, Array.prototype.slice.call(arguments, 1));
	  for (var key in obj) {
	    if (indexOf(keys, key) == -1) copy[key] = obj[key];
	  }
	  return copy;
	}
	
	function pluck(collection, key) {
	  var result = isArray(collection) ? [] : {};
	
	  forEach(collection, function(val, i) {
	    result[i] = isFunction(key) ? key(val) : val[key];
	  });
	  return result;
	}
	
	function filter(collection, callback) {
	  var array = isArray(collection);
	  var result = array ? [] : {};
	  forEach(collection, function(val, i) {
	    if (callback(val, i)) {
	      result[array ? result.length : i] = val;
	    }
	  });
	  return result;
	}
	
	function map(collection, callback) {
	  var result = isArray(collection) ? [] : {};
	
	  forEach(collection, function(val, i) {
	    result[i] = callback(val, i);
	  });
	  return result;
	}
	
	/**
	 * @ngdoc overview
	 * @name ui.router.util
	 *
	 * @description
	 * # ui.router.util sub-module
	 *
	 * This module is a dependency of other sub-modules. Do not include this module as a dependency
	 * in your angular app (use {@link ui.router} module instead).
	 *
	 */
	angular.module('ui.router.util', ['ng']);
	
	/**
	 * @ngdoc overview
	 * @name ui.router.router
	 * 
	 * @requires ui.router.util
	 *
	 * @description
	 * # ui.router.router sub-module
	 *
	 * This module is a dependency of other sub-modules. Do not include this module as a dependency
	 * in your angular app (use {@link ui.router} module instead).
	 */
	angular.module('ui.router.router', ['ui.router.util']);
	
	/**
	 * @ngdoc overview
	 * @name ui.router.state
	 * 
	 * @requires ui.router.router
	 * @requires ui.router.util
	 *
	 * @description
	 * # ui.router.state sub-module
	 *
	 * This module is a dependency of the main ui.router module. Do not include this module as a dependency
	 * in your angular app (use {@link ui.router} module instead).
	 * 
	 */
	angular.module('ui.router.state', ['ui.router.router', 'ui.router.util']);
	
	/**
	 * @ngdoc overview
	 * @name ui.router
	 *
	 * @requires ui.router.state
	 *
	 * @description
	 * # ui.router
	 * 
	 * ## The main module for ui.router 
	 * There are several sub-modules included with the ui.router module, however only this module is needed
	 * as a dependency within your angular app. The other modules are for organization purposes. 
	 *
	 * The modules are:
	 * * ui.router - the main "umbrella" module
	 * * ui.router.router - 
	 * 
	 * *You'll need to include **only** this module as the dependency within your angular app.*
	 * 
	 * <pre>
	 * <!doctype html>
	 * <html ng-app="myApp">
	 * <head>
	 *   <script src="js/angular.js"></script>
	 *   <!-- Include the ui-router script -->
	 *   <script src="js/angular-ui-router.min.js"></script>
	 *   <script>
	 *     // ...and add 'ui.router' as a dependency
	 *     var myApp = angular.module('myApp', ['ui.router']);
	 *   </script>
	 * </head>
	 * <body>
	 * </body>
	 * </html>
	 * </pre>
	 */
	angular.module('ui.router', ['ui.router.state']);
	
	angular.module('ui.router.compat', ['ui.router']);
	
	/**
	 * @ngdoc object
	 * @name ui.router.util.$resolve
	 *
	 * @requires $q
	 * @requires $injector
	 *
	 * @description
	 * Manages resolution of (acyclic) graphs of promises.
	 */
	$Resolve.$inject = ['$q', '$injector'];
	function $Resolve(  $q,    $injector) {
	  
	  var VISIT_IN_PROGRESS = 1,
	      VISIT_DONE = 2,
	      NOTHING = {},
	      NO_DEPENDENCIES = [],
	      NO_LOCALS = NOTHING,
	      NO_PARENT = extend($q.when(NOTHING), { $$promises: NOTHING, $$values: NOTHING });
	  
	
	  /**
	   * @ngdoc function
	   * @name ui.router.util.$resolve#study
	   * @methodOf ui.router.util.$resolve
	   *
	   * @description
	   * Studies a set of invocables that are likely to be used multiple times.
	   * <pre>
	   * $resolve.study(invocables)(locals, parent, self)
	   * </pre>
	   * is equivalent to
	   * <pre>
	   * $resolve.resolve(invocables, locals, parent, self)
	   * </pre>
	   * but the former is more efficient (in fact `resolve` just calls `study` 
	   * internally).
	   *
	   * @param {object} invocables Invocable objects
	   * @return {function} a function to pass in locals, parent and self
	   */
	  this.study = function (invocables) {
	    if (!isObject(invocables)) throw new Error("'invocables' must be an object");
	    var invocableKeys = objectKeys(invocables || {});
	    
	    // Perform a topological sort of invocables to build an ordered plan
	    var plan = [], cycle = [], visited = {};
	    function visit(value, key) {
	      if (visited[key] === VISIT_DONE) return;
	      
	      cycle.push(key);
	      if (visited[key] === VISIT_IN_PROGRESS) {
	        cycle.splice(0, indexOf(cycle, key));
	        throw new Error("Cyclic dependency: " + cycle.join(" -> "));
	      }
	      visited[key] = VISIT_IN_PROGRESS;
	      
	      if (isString(value)) {
	        plan.push(key, [ function() { return $injector.get(value); }], NO_DEPENDENCIES);
	      } else {
	        var params = $injector.annotate(value);
	        forEach(params, function (param) {
	          if (param !== key && invocables.hasOwnProperty(param)) visit(invocables[param], param);
	        });
	        plan.push(key, value, params);
	      }
	      
	      cycle.pop();
	      visited[key] = VISIT_DONE;
	    }
	    forEach(invocables, visit);
	    invocables = cycle = visited = null; // plan is all that's required
	    
	    function isResolve(value) {
	      return isObject(value) && value.then && value.$$promises;
	    }
	    
	    return function (locals, parent, self) {
	      if (isResolve(locals) && self === undefined) {
	        self = parent; parent = locals; locals = null;
	      }
	      if (!locals) locals = NO_LOCALS;
	      else if (!isObject(locals)) {
	        throw new Error("'locals' must be an object");
	      }       
	      if (!parent) parent = NO_PARENT;
	      else if (!isResolve(parent)) {
	        throw new Error("'parent' must be a promise returned by $resolve.resolve()");
	      }
	      
	      // To complete the overall resolution, we have to wait for the parent
	      // promise and for the promise for each invokable in our plan.
	      var resolution = $q.defer(),
	          result = resolution.promise,
	          promises = result.$$promises = {},
	          values = extend({}, locals),
	          wait = 1 + plan.length/3,
	          merged = false;
	          
	      function done() {
	        // Merge parent values we haven't got yet and publish our own $$values
	        if (!--wait) {
	          if (!merged) merge(values, parent.$$values); 
	          result.$$values = values;
	          result.$$promises = result.$$promises || true; // keep for isResolve()
	          delete result.$$inheritedValues;
	          resolution.resolve(values);
	        }
	      }
	      
	      function fail(reason) {
	        result.$$failure = reason;
	        resolution.reject(reason);
	      }
	
	      // Short-circuit if parent has already failed
	      if (isDefined(parent.$$failure)) {
	        fail(parent.$$failure);
	        return result;
	      }
	      
	      if (parent.$$inheritedValues) {
	        merge(values, omit(parent.$$inheritedValues, invocableKeys));
	      }
	
	      // Merge parent values if the parent has already resolved, or merge
	      // parent promises and wait if the parent resolve is still in progress.
	      extend(promises, parent.$$promises);
	      if (parent.$$values) {
	        merged = merge(values, omit(parent.$$values, invocableKeys));
	        result.$$inheritedValues = omit(parent.$$values, invocableKeys);
	        done();
	      } else {
	        if (parent.$$inheritedValues) {
	          result.$$inheritedValues = omit(parent.$$inheritedValues, invocableKeys);
	        }        
	        parent.then(done, fail);
	      }
	      
	      // Process each invocable in the plan, but ignore any where a local of the same name exists.
	      for (var i=0, ii=plan.length; i<ii; i+=3) {
	        if (locals.hasOwnProperty(plan[i])) done();
	        else invoke(plan[i], plan[i+1], plan[i+2]);
	      }
	      
	      function invoke(key, invocable, params) {
	        // Create a deferred for this invocation. Failures will propagate to the resolution as well.
	        var invocation = $q.defer(), waitParams = 0;
	        function onfailure(reason) {
	          invocation.reject(reason);
	          fail(reason);
	        }
	        // Wait for any parameter that we have a promise for (either from parent or from this
	        // resolve; in that case study() will have made sure it's ordered before us in the plan).
	        forEach(params, function (dep) {
	          if (promises.hasOwnProperty(dep) && !locals.hasOwnProperty(dep)) {
	            waitParams++;
	            promises[dep].then(function (result) {
	              values[dep] = result;
	              if (!(--waitParams)) proceed();
	            }, onfailure);
	          }
	        });
	        if (!waitParams) proceed();
	        function proceed() {
	          if (isDefined(result.$$failure)) return;
	          try {
	            invocation.resolve($injector.invoke(invocable, self, values));
	            invocation.promise.then(function (result) {
	              values[key] = result;
	              done();
	            }, onfailure);
	          } catch (e) {
	            onfailure(e);
	          }
	        }
	        // Publish promise synchronously; invocations further down in the plan may depend on it.
	        promises[key] = invocation.promise;
	      }
	      
	      return result;
	    };
	  };
	  
	  /**
	   * @ngdoc function
	   * @name ui.router.util.$resolve#resolve
	   * @methodOf ui.router.util.$resolve
	   *
	   * @description
	   * Resolves a set of invocables. An invocable is a function to be invoked via 
	   * `$injector.invoke()`, and can have an arbitrary number of dependencies. 
	   * An invocable can either return a value directly,
	   * or a `$q` promise. If a promise is returned it will be resolved and the 
	   * resulting value will be used instead. Dependencies of invocables are resolved 
	   * (in this order of precedence)
	   *
	   * - from the specified `locals`
	   * - from another invocable that is part of this `$resolve` call
	   * - from an invocable that is inherited from a `parent` call to `$resolve` 
	   *   (or recursively
	   * - from any ancestor `$resolve` of that parent).
	   *
	   * The return value of `$resolve` is a promise for an object that contains 
	   * (in this order of precedence)
	   *
	   * - any `locals` (if specified)
	   * - the resolved return values of all injectables
	   * - any values inherited from a `parent` call to `$resolve` (if specified)
	   *
	   * The promise will resolve after the `parent` promise (if any) and all promises 
	   * returned by injectables have been resolved. If any invocable 
	   * (or `$injector.invoke`) throws an exception, or if a promise returned by an 
	   * invocable is rejected, the `$resolve` promise is immediately rejected with the 
	   * same error. A rejection of a `parent` promise (if specified) will likewise be 
	   * propagated immediately. Once the `$resolve` promise has been rejected, no 
	   * further invocables will be called.
	   * 
	   * Cyclic dependencies between invocables are not permitted and will cause `$resolve`
	   * to throw an error. As a special case, an injectable can depend on a parameter 
	   * with the same name as the injectable, which will be fulfilled from the `parent` 
	   * injectable of the same name. This allows inherited values to be decorated. 
	   * Note that in this case any other injectable in the same `$resolve` with the same
	   * dependency would see the decorated value, not the inherited value.
	   *
	   * Note that missing dependencies -- unlike cyclic dependencies -- will cause an 
	   * (asynchronous) rejection of the `$resolve` promise rather than a (synchronous) 
	   * exception.
	   *
	   * Invocables are invoked eagerly as soon as all dependencies are available. 
	   * This is true even for dependencies inherited from a `parent` call to `$resolve`.
	   *
	   * As a special case, an invocable can be a string, in which case it is taken to 
	   * be a service name to be passed to `$injector.get()`. This is supported primarily 
	   * for backwards-compatibility with the `resolve` property of `$routeProvider` 
	   * routes.
	   *
	   * @param {object} invocables functions to invoke or 
	   * `$injector` services to fetch.
	   * @param {object} locals  values to make available to the injectables
	   * @param {object} parent  a promise returned by another call to `$resolve`.
	   * @param {object} self  the `this` for the invoked methods
	   * @return {object} Promise for an object that contains the resolved return value
	   * of all invocables, as well as any inherited and local values.
	   */
	  this.resolve = function (invocables, locals, parent, self) {
	    return this.study(invocables)(locals, parent, self);
	  };
	}
	
	angular.module('ui.router.util').service('$resolve', $Resolve);
	
	
	/**
	 * @ngdoc object
	 * @name ui.router.util.$templateFactory
	 *
	 * @requires $http
	 * @requires $templateCache
	 * @requires $injector
	 *
	 * @description
	 * Service. Manages loading of templates.
	 */
	$TemplateFactory.$inject = ['$http', '$templateCache', '$injector'];
	function $TemplateFactory(  $http,   $templateCache,   $injector) {
	
	  /**
	   * @ngdoc function
	   * @name ui.router.util.$templateFactory#fromConfig
	   * @methodOf ui.router.util.$templateFactory
	   *
	   * @description
	   * Creates a template from a configuration object. 
	   *
	   * @param {object} config Configuration object for which to load a template. 
	   * The following properties are search in the specified order, and the first one 
	   * that is defined is used to create the template:
	   *
	   * @param {string|object} config.template html string template or function to 
	   * load via {@link ui.router.util.$templateFactory#fromString fromString}.
	   * @param {string|object} config.templateUrl url to load or a function returning 
	   * the url to load via {@link ui.router.util.$templateFactory#fromUrl fromUrl}.
	   * @param {Function} config.templateProvider function to invoke via 
	   * {@link ui.router.util.$templateFactory#fromProvider fromProvider}.
	   * @param {object} params  Parameters to pass to the template function.
	   * @param {object} locals Locals to pass to `invoke` if the template is loaded 
	   * via a `templateProvider`. Defaults to `{ params: params }`.
	   *
	   * @return {string|object}  The template html as a string, or a promise for 
	   * that string,or `null` if no template is configured.
	   */
	  this.fromConfig = function (config, params, locals) {
	    return (
	      isDefined(config.template) ? this.fromString(config.template, params) :
	      isDefined(config.templateUrl) ? this.fromUrl(config.templateUrl, params) :
	      isDefined(config.templateProvider) ? this.fromProvider(config.templateProvider, params, locals) :
	      null
	    );
	  };
	
	  /**
	   * @ngdoc function
	   * @name ui.router.util.$templateFactory#fromString
	   * @methodOf ui.router.util.$templateFactory
	   *
	   * @description
	   * Creates a template from a string or a function returning a string.
	   *
	   * @param {string|object} template html template as a string or function that 
	   * returns an html template as a string.
	   * @param {object} params Parameters to pass to the template function.
	   *
	   * @return {string|object} The template html as a string, or a promise for that 
	   * string.
	   */
	  this.fromString = function (template, params) {
	    return isFunction(template) ? template(params) : template;
	  };
	
	  /**
	   * @ngdoc function
	   * @name ui.router.util.$templateFactory#fromUrl
	   * @methodOf ui.router.util.$templateFactory
	   * 
	   * @description
	   * Loads a template from the a URL via `$http` and `$templateCache`.
	   *
	   * @param {string|Function} url url of the template to load, or a function 
	   * that returns a url.
	   * @param {Object} params Parameters to pass to the url function.
	   * @return {string|Promise.<string>} The template html as a string, or a promise 
	   * for that string.
	   */
	  this.fromUrl = function (url, params) {
	    if (isFunction(url)) url = url(params);
	    if (url == null) return null;
	    else return $http
	        .get(url, { cache: $templateCache, headers: { Accept: 'text/html' }})
	        .then(function(response) { return response.data; });
	  };
	
	  /**
	   * @ngdoc function
	   * @name ui.router.util.$templateFactory#fromProvider
	   * @methodOf ui.router.util.$templateFactory
	   *
	   * @description
	   * Creates a template by invoking an injectable provider function.
	   *
	   * @param {Function} provider Function to invoke via `$injector.invoke`
	   * @param {Object} params Parameters for the template.
	   * @param {Object} locals Locals to pass to `invoke`. Defaults to 
	   * `{ params: params }`.
	   * @return {string|Promise.<string>} The template html as a string, or a promise 
	   * for that string.
	   */
	  this.fromProvider = function (provider, params, locals) {
	    return $injector.invoke(provider, null, locals || { params: params });
	  };
	}
	
	angular.module('ui.router.util').service('$templateFactory', $TemplateFactory);
	
	var $$UMFP; // reference to $UrlMatcherFactoryProvider
	
	/**
	 * @ngdoc object
	 * @name ui.router.util.type:UrlMatcher
	 *
	 * @description
	 * Matches URLs against patterns and extracts named parameters from the path or the search
	 * part of the URL. A URL pattern consists of a path pattern, optionally followed by '?' and a list
	 * of search parameters. Multiple search parameter names are separated by '&'. Search parameters
	 * do not influence whether or not a URL is matched, but their values are passed through into
	 * the matched parameters returned by {@link ui.router.util.type:UrlMatcher#methods_exec exec}.
	 *
	 * Path parameter placeholders can be specified using simple colon/catch-all syntax or curly brace
	 * syntax, which optionally allows a regular expression for the parameter to be specified:
	 *
	 * * `':'` name - colon placeholder
	 * * `'*'` name - catch-all placeholder
	 * * `'{' name '}'` - curly placeholder
	 * * `'{' name ':' regexp|type '}'` - curly placeholder with regexp or type name. Should the
	 *   regexp itself contain curly braces, they must be in matched pairs or escaped with a backslash.
	 *
	 * Parameter names may contain only word characters (latin letters, digits, and underscore) and
	 * must be unique within the pattern (across both path and search parameters). For colon
	 * placeholders or curly placeholders without an explicit regexp, a path parameter matches any
	 * number of characters other than '/'. For catch-all placeholders the path parameter matches
	 * any number of characters.
	 *
	 * Examples:
	 *
	 * * `'/hello/'` - Matches only if the path is exactly '/hello/'. There is no special treatment for
	 *   trailing slashes, and patterns have to match the entire path, not just a prefix.
	 * * `'/user/:id'` - Matches '/user/bob' or '/user/1234!!!' or even '/user/' but not '/user' or
	 *   '/user/bob/details'. The second path segment will be captured as the parameter 'id'.
	 * * `'/user/{id}'` - Same as the previous example, but using curly brace syntax.
	 * * `'/user/{id:[^/]*}'` - Same as the previous example.
	 * * `'/user/{id:[0-9a-fA-F]{1,8}}'` - Similar to the previous example, but only matches if the id
	 *   parameter consists of 1 to 8 hex digits.
	 * * `'/files/{path:.*}'` - Matches any URL starting with '/files/' and captures the rest of the
	 *   path into the parameter 'path'.
	 * * `'/files/*path'` - ditto.
	 * * `'/calendar/{start:date}'` - Matches "/calendar/2014-11-12" (because the pattern defined
	 *   in the built-in  `date` Type matches `2014-11-12`) and provides a Date object in $stateParams.start
	 *
	 * @param {string} pattern  The pattern to compile into a matcher.
	 * @param {Object} config  A configuration object hash:
	 * @param {Object=} parentMatcher Used to concatenate the pattern/config onto
	 *   an existing UrlMatcher
	 *
	 * * `caseInsensitive` - `true` if URL matching should be case insensitive, otherwise `false`, the default value (for backward compatibility) is `false`.
	 * * `strict` - `false` if matching against a URL with a trailing slash should be treated as equivalent to a URL without a trailing slash, the default value is `true`.
	 *
	 * @property {string} prefix  A static prefix of this pattern. The matcher guarantees that any
	 *   URL matching this matcher (i.e. any string for which {@link ui.router.util.type:UrlMatcher#methods_exec exec()} returns
	 *   non-null) will start with this prefix.
	 *
	 * @property {string} source  The pattern that was passed into the constructor
	 *
	 * @property {string} sourcePath  The path portion of the source property
	 *
	 * @property {string} sourceSearch  The search portion of the source property
	 *
	 * @property {string} regex  The constructed regex that will be used to match against the url when
	 *   it is time to determine which url will match.
	 *
	 * @returns {Object}  New `UrlMatcher` object
	 */
	function UrlMatcher(pattern, config, parentMatcher) {
	  config = extend({ params: {} }, isObject(config) ? config : {});
	
	  // Find all placeholders and create a compiled pattern, using either classic or curly syntax:
	  //   '*' name
	  //   ':' name
	  //   '{' name '}'
	  //   '{' name ':' regexp '}'
	  // The regular expression is somewhat complicated due to the need to allow curly braces
	  // inside the regular expression. The placeholder regexp breaks down as follows:
	  //    ([:*])([\w\[\]]+)              - classic placeholder ($1 / $2) (search version has - for snake-case)
	  //    \{([\w\[\]]+)(?:\:\s*( ... ))?\}  - curly brace placeholder ($3) with optional regexp/type ... ($4) (search version has - for snake-case
	  //    (?: ... | ... | ... )+         - the regexp consists of any number of atoms, an atom being either
	  //    [^{}\\]+                       - anything other than curly braces or backslash
	  //    \\.                            - a backslash escape
	  //    \{(?:[^{}\\]+|\\.)*\}          - a matched set of curly braces containing other atoms
	  var placeholder       = /([:*])([\w\[\]]+)|\{([\w\[\]]+)(?:\:\s*((?:[^{}\\]+|\\.|\{(?:[^{}\\]+|\\.)*\})+))?\}/g,
	      searchPlaceholder = /([:]?)([\w\[\].-]+)|\{([\w\[\].-]+)(?:\:\s*((?:[^{}\\]+|\\.|\{(?:[^{}\\]+|\\.)*\})+))?\}/g,
	      compiled = '^', last = 0, m,
	      segments = this.segments = [],
	      parentParams = parentMatcher ? parentMatcher.params : {},
	      params = this.params = parentMatcher ? parentMatcher.params.$$new() : new $$UMFP.ParamSet(),
	      paramNames = [];
	
	  function addParameter(id, type, config, location) {
	    paramNames.push(id);
	    if (parentParams[id]) return parentParams[id];
	    if (!/^\w+([-.]+\w+)*(?:\[\])?$/.test(id)) throw new Error("Invalid parameter name '" + id + "' in pattern '" + pattern + "'");
	    if (params[id]) throw new Error("Duplicate parameter name '" + id + "' in pattern '" + pattern + "'");
	    params[id] = new $$UMFP.Param(id, type, config, location);
	    return params[id];
	  }
	
	  function quoteRegExp(string, pattern, squash, optional) {
	    var surroundPattern = ['',''], result = string.replace(/[\\\[\]\^$*+?.()|{}]/g, "\\$&");
	    if (!pattern) return result;
	    switch(squash) {
	      case false: surroundPattern = ['(', ')' + (optional ? "?" : "")]; break;
	      case true:
	        result = result.replace(/\/$/, '');
	        surroundPattern = ['(?:\/(', ')|\/)?'];
	      break;
	      default:    surroundPattern = ['(' + squash + "|", ')?']; break;
	    }
	    return result + surroundPattern[0] + pattern + surroundPattern[1];
	  }
	
	  this.source = pattern;
	
	  // Split into static segments separated by path parameter placeholders.
	  // The number of segments is always 1 more than the number of parameters.
	  function matchDetails(m, isSearch) {
	    var id, regexp, segment, type, cfg, arrayMode;
	    id          = m[2] || m[3]; // IE[78] returns '' for unmatched groups instead of null
	    cfg         = config.params[id];
	    segment     = pattern.substring(last, m.index);
	    regexp      = isSearch ? m[4] : m[4] || (m[1] == '*' ? '.*' : null);
	
	    if (regexp) {
	      type      = $$UMFP.type(regexp) || inherit($$UMFP.type("string"), { pattern: new RegExp(regexp, config.caseInsensitive ? 'i' : undefined) });
	    }
	
	    return {
	      id: id, regexp: regexp, segment: segment, type: type, cfg: cfg
	    };
	  }
	
	  var p, param, segment;
	  while ((m = placeholder.exec(pattern))) {
	    p = matchDetails(m, false);
	    if (p.segment.indexOf('?') >= 0) break; // we're into the search part
	
	    param = addParameter(p.id, p.type, p.cfg, "path");
	    compiled += quoteRegExp(p.segment, param.type.pattern.source, param.squash, param.isOptional);
	    segments.push(p.segment);
	    last = placeholder.lastIndex;
	  }
	  segment = pattern.substring(last);
	
	  // Find any search parameter names and remove them from the last segment
	  var i = segment.indexOf('?');
	
	  if (i >= 0) {
	    var search = this.sourceSearch = segment.substring(i);
	    segment = segment.substring(0, i);
	    this.sourcePath = pattern.substring(0, last + i);
	
	    if (search.length > 0) {
	      last = 0;
	      while ((m = searchPlaceholder.exec(search))) {
	        p = matchDetails(m, true);
	        param = addParameter(p.id, p.type, p.cfg, "search");
	        last = placeholder.lastIndex;
	        // check if ?&
	      }
	    }
	  } else {
	    this.sourcePath = pattern;
	    this.sourceSearch = '';
	  }
	
	  compiled += quoteRegExp(segment) + (config.strict === false ? '\/?' : '') + '$';
	  segments.push(segment);
	
	  this.regexp = new RegExp(compiled, config.caseInsensitive ? 'i' : undefined);
	  this.prefix = segments[0];
	  this.$$paramNames = paramNames;
	}
	
	/**
	 * @ngdoc function
	 * @name ui.router.util.type:UrlMatcher#concat
	 * @methodOf ui.router.util.type:UrlMatcher
	 *
	 * @description
	 * Returns a new matcher for a pattern constructed by appending the path part and adding the
	 * search parameters of the specified pattern to this pattern. The current pattern is not
	 * modified. This can be understood as creating a pattern for URLs that are relative to (or
	 * suffixes of) the current pattern.
	 *
	 * @example
	 * The following two matchers are equivalent:
	 * <pre>
	 * new UrlMatcher('/user/{id}?q').concat('/details?date');
	 * new UrlMatcher('/user/{id}/details?q&date');
	 * </pre>
	 *
	 * @param {string} pattern  The pattern to append.
	 * @param {Object} config  An object hash of the configuration for the matcher.
	 * @returns {UrlMatcher}  A matcher for the concatenated pattern.
	 */
	UrlMatcher.prototype.concat = function (pattern, config) {
	  // Because order of search parameters is irrelevant, we can add our own search
	  // parameters to the end of the new pattern. Parse the new pattern by itself
	  // and then join the bits together, but it's much easier to do this on a string level.
	  var defaultConfig = {
	    caseInsensitive: $$UMFP.caseInsensitive(),
	    strict: $$UMFP.strictMode(),
	    squash: $$UMFP.defaultSquashPolicy()
	  };
	  return new UrlMatcher(this.sourcePath + pattern + this.sourceSearch, extend(defaultConfig, config), this);
	};
	
	UrlMatcher.prototype.toString = function () {
	  return this.source;
	};
	
	/**
	 * @ngdoc function
	 * @name ui.router.util.type:UrlMatcher#exec
	 * @methodOf ui.router.util.type:UrlMatcher
	 *
	 * @description
	 * Tests the specified path against this matcher, and returns an object containing the captured
	 * parameter values, or null if the path does not match. The returned object contains the values
	 * of any search parameters that are mentioned in the pattern, but their value may be null if
	 * they are not present in `searchParams`. This means that search parameters are always treated
	 * as optional.
	 *
	 * @example
	 * <pre>
	 * new UrlMatcher('/user/{id}?q&r').exec('/user/bob', {
	 *   x: '1', q: 'hello'
	 * });
	 * // returns { id: 'bob', q: 'hello', r: null }
	 * </pre>
	 *
	 * @param {string} path  The URL path to match, e.g. `$location.path()`.
	 * @param {Object} searchParams  URL search parameters, e.g. `$location.search()`.
	 * @returns {Object}  The captured parameter values.
	 */
	UrlMatcher.prototype.exec = function (path, searchParams) {
	  var m = this.regexp.exec(path);
	  if (!m) return null;
	  searchParams = searchParams || {};
	
	  var paramNames = this.parameters(), nTotal = paramNames.length,
	    nPath = this.segments.length - 1,
	    values = {}, i, j, cfg, paramName;
	
	  if (nPath !== m.length - 1) throw new Error("Unbalanced capture group in route '" + this.source + "'");
	
	  function decodePathArray(string) {
	    function reverseString(str) { return str.split("").reverse().join(""); }
	    function unquoteDashes(str) { return str.replace(/\\-/g, "-"); }
	
	    var split = reverseString(string).split(/-(?!\\)/);
	    var allReversed = map(split, reverseString);
	    return map(allReversed, unquoteDashes).reverse();
	  }
	
	  var param, paramVal;
	  for (i = 0; i < nPath; i++) {
	    paramName = paramNames[i];
	    param = this.params[paramName];
	    paramVal = m[i+1];
	    // if the param value matches a pre-replace pair, replace the value before decoding.
	    for (j = 0; j < param.replace.length; j++) {
	      if (param.replace[j].from === paramVal) paramVal = param.replace[j].to;
	    }
	    if (paramVal && param.array === true) paramVal = decodePathArray(paramVal);
	    if (isDefined(paramVal)) paramVal = param.type.decode(paramVal);
	    values[paramName] = param.value(paramVal);
	  }
	  for (/**/; i < nTotal; i++) {
	    paramName = paramNames[i];
	    values[paramName] = this.params[paramName].value(searchParams[paramName]);
	    param = this.params[paramName];
	    paramVal = searchParams[paramName];
	    for (j = 0; j < param.replace.length; j++) {
	      if (param.replace[j].from === paramVal) paramVal = param.replace[j].to;
	    }
	    if (isDefined(paramVal)) paramVal = param.type.decode(paramVal);
	    values[paramName] = param.value(paramVal);
	  }
	
	  return values;
	};
	
	/**
	 * @ngdoc function
	 * @name ui.router.util.type:UrlMatcher#parameters
	 * @methodOf ui.router.util.type:UrlMatcher
	 *
	 * @description
	 * Returns the names of all path and search parameters of this pattern in an unspecified order.
	 *
	 * @returns {Array.<string>}  An array of parameter names. Must be treated as read-only. If the
	 *    pattern has no parameters, an empty array is returned.
	 */
	UrlMatcher.prototype.parameters = function (param) {
	  if (!isDefined(param)) return this.$$paramNames;
	  return this.params[param] || null;
	};
	
	/**
	 * @ngdoc function
	 * @name ui.router.util.type:UrlMatcher#validates
	 * @methodOf ui.router.util.type:UrlMatcher
	 *
	 * @description
	 * Checks an object hash of parameters to validate their correctness according to the parameter
	 * types of this `UrlMatcher`.
	 *
	 * @param {Object} params The object hash of parameters to validate.
	 * @returns {boolean} Returns `true` if `params` validates, otherwise `false`.
	 */
	UrlMatcher.prototype.validates = function (params) {
	  return this.params.$$validates(params);
	};
	
	/**
	 * @ngdoc function
	 * @name ui.router.util.type:UrlMatcher#format
	 * @methodOf ui.router.util.type:UrlMatcher
	 *
	 * @description
	 * Creates a URL that matches this pattern by substituting the specified values
	 * for the path and search parameters. Null values for path parameters are
	 * treated as empty strings.
	 *
	 * @example
	 * <pre>
	 * new UrlMatcher('/user/{id}?q').format({ id:'bob', q:'yes' });
	 * // returns '/user/bob?q=yes'
	 * </pre>
	 *
	 * @param {Object} values  the values to substitute for the parameters in this pattern.
	 * @returns {string}  the formatted URL (path and optionally search part).
	 */
	UrlMatcher.prototype.format = function (values) {
	  values = values || {};
	  var segments = this.segments, params = this.parameters(), paramset = this.params;
	  if (!this.validates(values)) return null;
	
	  var i, search = false, nPath = segments.length - 1, nTotal = params.length, result = segments[0];
	
	  function encodeDashes(str) { // Replace dashes with encoded "\-"
	    return encodeURIComponent(str).replace(/-/g, function(c) { return '%5C%' + c.charCodeAt(0).toString(16).toUpperCase(); });
	  }
	
	  for (i = 0; i < nTotal; i++) {
	    var isPathParam = i < nPath;
	    var name = params[i], param = paramset[name], value = param.value(values[name]);
	    var isDefaultValue = param.isOptional && param.type.equals(param.value(), value);
	    var squash = isDefaultValue ? param.squash : false;
	    var encoded = param.type.encode(value);
	
	    if (isPathParam) {
	      var nextSegment = segments[i + 1];
	      var isFinalPathParam = i + 1 === nPath;
	
	      if (squash === false) {
	        if (encoded != null) {
	          if (isArray(encoded)) {
	            result += map(encoded, encodeDashes).join("-");
	          } else {
	            result += encodeURIComponent(encoded);
	          }
	        }
	        result += nextSegment;
	      } else if (squash === true) {
	        var capture = result.match(/\/$/) ? /\/?(.*)/ : /(.*)/;
	        result += nextSegment.match(capture)[1];
	      } else if (isString(squash)) {
	        result += squash + nextSegment;
	      }
	
	      if (isFinalPathParam && param.squash === true && result.slice(-1) === '/') result = result.slice(0, -1);
	    } else {
	      if (encoded == null || (isDefaultValue && squash !== false)) continue;
	      if (!isArray(encoded)) encoded = [ encoded ];
	      if (encoded.length === 0) continue;
	      encoded = map(encoded, encodeURIComponent).join('&' + name + '=');
	      result += (search ? '&' : '?') + (name + '=' + encoded);
	      search = true;
	    }
	  }
	
	  return result;
	};
	
	/**
	 * @ngdoc object
	 * @name ui.router.util.type:Type
	 *
	 * @description
	 * Implements an interface to define custom parameter types that can be decoded from and encoded to
	 * string parameters matched in a URL. Used by {@link ui.router.util.type:UrlMatcher `UrlMatcher`}
	 * objects when matching or formatting URLs, or comparing or validating parameter values.
	 *
	 * See {@link ui.router.util.$urlMatcherFactory#methods_type `$urlMatcherFactory#type()`} for more
	 * information on registering custom types.
	 *
	 * @param {Object} config  A configuration object which contains the custom type definition.  The object's
	 *        properties will override the default methods and/or pattern in `Type`'s public interface.
	 * @example
	 * <pre>
	 * {
	 *   decode: function(val) { return parseInt(val, 10); },
	 *   encode: function(val) { return val && val.toString(); },
	 *   equals: function(a, b) { return this.is(a) && a === b; },
	 *   is: function(val) { return angular.isNumber(val) isFinite(val) && val % 1 === 0; },
	 *   pattern: /\d+/
	 * }
	 * </pre>
	 *
	 * @property {RegExp} pattern The regular expression pattern used to match values of this type when
	 *           coming from a substring of a URL.
	 *
	 * @returns {Object}  Returns a new `Type` object.
	 */
	function Type(config) {
	  extend(this, config);
	}
	
	/**
	 * @ngdoc function
	 * @name ui.router.util.type:Type#is
	 * @methodOf ui.router.util.type:Type
	 *
	 * @description
	 * Detects whether a value is of a particular type. Accepts a native (decoded) value
	 * and determines whether it matches the current `Type` object.
	 *
	 * @param {*} val  The value to check.
	 * @param {string} key  Optional. If the type check is happening in the context of a specific
	 *        {@link ui.router.util.type:UrlMatcher `UrlMatcher`} object, this is the name of the
	 *        parameter in which `val` is stored. Can be used for meta-programming of `Type` objects.
	 * @returns {Boolean}  Returns `true` if the value matches the type, otherwise `false`.
	 */
	Type.prototype.is = function(val, key) {
	  return true;
	};
	
	/**
	 * @ngdoc function
	 * @name ui.router.util.type:Type#encode
	 * @methodOf ui.router.util.type:Type
	 *
	 * @description
	 * Encodes a custom/native type value to a string that can be embedded in a URL. Note that the
	 * return value does *not* need to be URL-safe (i.e. passed through `encodeURIComponent()`), it
	 * only needs to be a representation of `val` that has been coerced to a string.
	 *
	 * @param {*} val  The value to encode.
	 * @param {string} key  The name of the parameter in which `val` is stored. Can be used for
	 *        meta-programming of `Type` objects.
	 * @returns {string}  Returns a string representation of `val` that can be encoded in a URL.
	 */
	Type.prototype.encode = function(val, key) {
	  return val;
	};
	
	/**
	 * @ngdoc function
	 * @name ui.router.util.type:Type#decode
	 * @methodOf ui.router.util.type:Type
	 *
	 * @description
	 * Converts a parameter value (from URL string or transition param) to a custom/native value.
	 *
	 * @param {string} val  The URL parameter value to decode.
	 * @param {string} key  The name of the parameter in which `val` is stored. Can be used for
	 *        meta-programming of `Type` objects.
	 * @returns {*}  Returns a custom representation of the URL parameter value.
	 */
	Type.prototype.decode = function(val, key) {
	  return val;
	};
	
	/**
	 * @ngdoc function
	 * @name ui.router.util.type:Type#equals
	 * @methodOf ui.router.util.type:Type
	 *
	 * @description
	 * Determines whether two decoded values are equivalent.
	 *
	 * @param {*} a  A value to compare against.
	 * @param {*} b  A value to compare against.
	 * @returns {Boolean}  Returns `true` if the values are equivalent/equal, otherwise `false`.
	 */
	Type.prototype.equals = function(a, b) {
	  return a == b;
	};
	
	Type.prototype.$subPattern = function() {
	  var sub = this.pattern.toString();
	  return sub.substr(1, sub.length - 2);
	};
	
	Type.prototype.pattern = /.*/;
	
	Type.prototype.toString = function() { return "{Type:" + this.name + "}"; };
	
	/** Given an encoded string, or a decoded object, returns a decoded object */
	Type.prototype.$normalize = function(val) {
	  return this.is(val) ? val : this.decode(val);
	};
	
	/*
	 * Wraps an existing custom Type as an array of Type, depending on 'mode'.
	 * e.g.:
	 * - urlmatcher pattern "/path?{queryParam[]:int}"
	 * - url: "/path?queryParam=1&queryParam=2
	 * - $stateParams.queryParam will be [1, 2]
	 * if `mode` is "auto", then
	 * - url: "/path?queryParam=1 will create $stateParams.queryParam: 1
	 * - url: "/path?queryParam=1&queryParam=2 will create $stateParams.queryParam: [1, 2]
	 */
	Type.prototype.$asArray = function(mode, isSearch) {
	  if (!mode) return this;
	  if (mode === "auto" && !isSearch) throw new Error("'auto' array mode is for query parameters only");
	
	  function ArrayType(type, mode) {
	    function bindTo(type, callbackName) {
	      return function() {
	        return type[callbackName].apply(type, arguments);
	      };
	    }
	
	    // Wrap non-array value as array
	    function arrayWrap(val) { return isArray(val) ? val : (isDefined(val) ? [ val ] : []); }
	    // Unwrap array value for "auto" mode. Return undefined for empty array.
	    function arrayUnwrap(val) {
	      switch(val.length) {
	        case 0: return undefined;
	        case 1: return mode === "auto" ? val[0] : val;
	        default: return val;
	      }
	    }
	    function falsey(val) { return !val; }
	
	    // Wraps type (.is/.encode/.decode) functions to operate on each value of an array
	    function arrayHandler(callback, allTruthyMode) {
	      return function handleArray(val) {
	        if (isArray(val) && val.length === 0) return val;
	        val = arrayWrap(val);
	        var result = map(val, callback);
	        if (allTruthyMode === true)
	          return filter(result, falsey).length === 0;
	        return arrayUnwrap(result);
	      };
	    }
	
	    // Wraps type (.equals) functions to operate on each value of an array
	    function arrayEqualsHandler(callback) {
	      return function handleArray(val1, val2) {
	        var left = arrayWrap(val1), right = arrayWrap(val2);
	        if (left.length !== right.length) return false;
	        for (var i = 0; i < left.length; i++) {
	          if (!callback(left[i], right[i])) return false;
	        }
	        return true;
	      };
	    }
	
	    this.encode = arrayHandler(bindTo(type, 'encode'));
	    this.decode = arrayHandler(bindTo(type, 'decode'));
	    this.is     = arrayHandler(bindTo(type, 'is'), true);
	    this.equals = arrayEqualsHandler(bindTo(type, 'equals'));
	    this.pattern = type.pattern;
	    this.$normalize = arrayHandler(bindTo(type, '$normalize'));
	    this.name = type.name;
	    this.$arrayMode = mode;
	  }
	
	  return new ArrayType(this, mode);
	};
	
	
	
	/**
	 * @ngdoc object
	 * @name ui.router.util.$urlMatcherFactory
	 *
	 * @description
	 * Factory for {@link ui.router.util.type:UrlMatcher `UrlMatcher`} instances. The factory
	 * is also available to providers under the name `$urlMatcherFactoryProvider`.
	 */
	function $UrlMatcherFactory() {
	  $$UMFP = this;
	
	  var isCaseInsensitive = false, isStrictMode = true, defaultSquashPolicy = false;
	
	  // Use tildes to pre-encode slashes.
	  // If the slashes are simply URLEncoded, the browser can choose to pre-decode them,
	  // and bidirectional encoding/decoding fails.
	  // Tilde was chosen because it's not a RFC 3986 section 2.2 Reserved Character
	  function valToString(val) { return val != null ? val.toString().replace(/~/g, "~~").replace(/\//g, "~2F") : val; }
	  function valFromString(val) { return val != null ? val.toString().replace(/~2F/g, "/").replace(/~~/g, "~") : val; }
	
	  var $types = {}, enqueue = true, typeQueue = [], injector, defaultTypes = {
	    "string": {
	      encode: valToString,
	      decode: valFromString,
	      // TODO: in 1.0, make string .is() return false if value is undefined/null by default.
	      // In 0.2.x, string params are optional by default for backwards compat
	      is: function(val) { return val == null || !isDefined(val) || typeof val === "string"; },
	      pattern: /[^/]*/
	    },
	    "int": {
	      encode: valToString,
	      decode: function(val) { return parseInt(val, 10); },
	      is: function(val) { return isDefined(val) && this.decode(val.toString()) === val; },
	      pattern: /\d+/
	    },
	    "bool": {
	      encode: function(val) { return val ? 1 : 0; },
	      decode: function(val) { return parseInt(val, 10) !== 0; },
	      is: function(val) { return val === true || val === false; },
	      pattern: /0|1/
	    },
	    "date": {
	      encode: function (val) {
	        if (!this.is(val))
	          return undefined;
	        return [ val.getFullYear(),
	          ('0' + (val.getMonth() + 1)).slice(-2),
	          ('0' + val.getDate()).slice(-2)
	        ].join("-");
	      },
	      decode: function (val) {
	        if (this.is(val)) return val;
	        var match = this.capture.exec(val);
	        return match ? new Date(match[1], match[2] - 1, match[3]) : undefined;
	      },
	      is: function(val) { return val instanceof Date && !isNaN(val.valueOf()); },
	      equals: function (a, b) { return this.is(a) && this.is(b) && a.toISOString() === b.toISOString(); },
	      pattern: /[0-9]{4}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[1-2][0-9]|3[0-1])/,
	      capture: /([0-9]{4})-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])/
	    },
	    "json": {
	      encode: angular.toJson,
	      decode: angular.fromJson,
	      is: angular.isObject,
	      equals: angular.equals,
	      pattern: /[^/]*/
	    },
	    "any": { // does not encode/decode
	      encode: angular.identity,
	      decode: angular.identity,
	      equals: angular.equals,
	      pattern: /.*/
	    }
	  };
	
	  function getDefaultConfig() {
	    return {
	      strict: isStrictMode,
	      caseInsensitive: isCaseInsensitive
	    };
	  }
	
	  function isInjectable(value) {
	    return (isFunction(value) || (isArray(value) && isFunction(value[value.length - 1])));
	  }
	
	  /**
	   * [Internal] Get the default value of a parameter, which may be an injectable function.
	   */
	  $UrlMatcherFactory.$$getDefaultValue = function(config) {
	    if (!isInjectable(config.value)) return config.value;
	    if (!injector) throw new Error("Injectable functions cannot be called at configuration time");
	    return injector.invoke(config.value);
	  };
	
	  /**
	   * @ngdoc function
	   * @name ui.router.util.$urlMatcherFactory#caseInsensitive
	   * @methodOf ui.router.util.$urlMatcherFactory
	   *
	   * @description
	   * Defines whether URL matching should be case sensitive (the default behavior), or not.
	   *
	   * @param {boolean} value `false` to match URL in a case sensitive manner; otherwise `true`;
	   * @returns {boolean} the current value of caseInsensitive
	   */
	  this.caseInsensitive = function(value) {
	    if (isDefined(value))
	      isCaseInsensitive = value;
	    return isCaseInsensitive;
	  };
	
	  /**
	   * @ngdoc function
	   * @name ui.router.util.$urlMatcherFactory#strictMode
	   * @methodOf ui.router.util.$urlMatcherFactory
	   *
	   * @description
	   * Defines whether URLs should match trailing slashes, or not (the default behavior).
	   *
	   * @param {boolean=} value `false` to match trailing slashes in URLs, otherwise `true`.
	   * @returns {boolean} the current value of strictMode
	   */
	  this.strictMode = function(value) {
	    if (isDefined(value))
	      isStrictMode = value;
	    return isStrictMode;
	  };
	
	  /**
	   * @ngdoc function
	   * @name ui.router.util.$urlMatcherFactory#defaultSquashPolicy
	   * @methodOf ui.router.util.$urlMatcherFactory
	   *
	   * @description
	   * Sets the default behavior when generating or matching URLs with default parameter values.
	   *
	   * @param {string} value A string that defines the default parameter URL squashing behavior.
	   *    `nosquash`: When generating an href with a default parameter value, do not squash the parameter value from the URL
	   *    `slash`: When generating an href with a default parameter value, squash (remove) the parameter value, and, if the
	   *             parameter is surrounded by slashes, squash (remove) one slash from the URL
	   *    any other string, e.g. "~": When generating an href with a default parameter value, squash (remove)
	   *             the parameter value from the URL and replace it with this string.
	   */
	  this.defaultSquashPolicy = function(value) {
	    if (!isDefined(value)) return defaultSquashPolicy;
	    if (value !== true && value !== false && !isString(value))
	      throw new Error("Invalid squash policy: " + value + ". Valid policies: false, true, arbitrary-string");
	    defaultSquashPolicy = value;
	    return value;
	  };
	
	  /**
	   * @ngdoc function
	   * @name ui.router.util.$urlMatcherFactory#compile
	   * @methodOf ui.router.util.$urlMatcherFactory
	   *
	   * @description
	   * Creates a {@link ui.router.util.type:UrlMatcher `UrlMatcher`} for the specified pattern.
	   *
	   * @param {string} pattern  The URL pattern.
	   * @param {Object} config  The config object hash.
	   * @returns {UrlMatcher}  The UrlMatcher.
	   */
	  this.compile = function (pattern, config) {
	    return new UrlMatcher(pattern, extend(getDefaultConfig(), config));
	  };
	
	  /**
	   * @ngdoc function
	   * @name ui.router.util.$urlMatcherFactory#isMatcher
	   * @methodOf ui.router.util.$urlMatcherFactory
	   *
	   * @description
	   * Returns true if the specified object is a `UrlMatcher`, or false otherwise.
	   *
	   * @param {Object} object  The object to perform the type check against.
	   * @returns {Boolean}  Returns `true` if the object matches the `UrlMatcher` interface, by
	   *          implementing all the same methods.
	   */
	  this.isMatcher = function (o) {
	    if (!isObject(o)) return false;
	    var result = true;
	
	    forEach(UrlMatcher.prototype, function(val, name) {
	      if (isFunction(val)) {
	        result = result && (isDefined(o[name]) && isFunction(o[name]));
	      }
	    });
	    return result;
	  };
	
	  /**
	   * @ngdoc function
	   * @name ui.router.util.$urlMatcherFactory#type
	   * @methodOf ui.router.util.$urlMatcherFactory
	   *
	   * @description
	   * Registers a custom {@link ui.router.util.type:Type `Type`} object that can be used to
	   * generate URLs with typed parameters.
	   *
	   * @param {string} name  The type name.
	   * @param {Object|Function} definition   The type definition. See
	   *        {@link ui.router.util.type:Type `Type`} for information on the values accepted.
	   * @param {Object|Function} definitionFn (optional) A function that is injected before the app
	   *        runtime starts.  The result of this function is merged into the existing `definition`.
	   *        See {@link ui.router.util.type:Type `Type`} for information on the values accepted.
	   *
	   * @returns {Object}  Returns `$urlMatcherFactoryProvider`.
	   *
	   * @example
	   * This is a simple example of a custom type that encodes and decodes items from an
	   * array, using the array index as the URL-encoded value:
	   *
	   * <pre>
	   * var list = ['John', 'Paul', 'George', 'Ringo'];
	   *
	   * $urlMatcherFactoryProvider.type('listItem', {
	   *   encode: function(item) {
	   *     // Represent the list item in the URL using its corresponding index
	   *     return list.indexOf(item);
	   *   },
	   *   decode: function(item) {
	   *     // Look up the list item by index
	   *     return list[parseInt(item, 10)];
	   *   },
	   *   is: function(item) {
	   *     // Ensure the item is valid by checking to see that it appears
	   *     // in the list
	   *     return list.indexOf(item) > -1;
	   *   }
	   * });
	   *
	   * $stateProvider.state('list', {
	   *   url: "/list/{item:listItem}",
	   *   controller: function($scope, $stateParams) {
	   *     console.log($stateParams.item);
	   *   }
	   * });
	   *
	   * // ...
	   *
	   * // Changes URL to '/list/3', logs "Ringo" to the console
	   * $state.go('list', { item: "Ringo" });
	   * </pre>
	   *
	   * This is a more complex example of a type that relies on dependency injection to
	   * interact with services, and uses the parameter name from the URL to infer how to
	   * handle encoding and decoding parameter values:
	   *
	   * <pre>
	   * // Defines a custom type that gets a value from a service,
	   * // where each service gets different types of values from
	   * // a backend API:
	   * $urlMatcherFactoryProvider.type('dbObject', {}, function(Users, Posts) {
	   *
	   *   // Matches up services to URL parameter names
	   *   var services = {
	   *     user: Users,
	   *     post: Posts
	   *   };
	   *
	   *   return {
	   *     encode: function(object) {
	   *       // Represent the object in the URL using its unique ID
	   *       return object.id;
	   *     },
	   *     decode: function(value, key) {
	   *       // Look up the object by ID, using the parameter
	   *       // name (key) to call the correct service
	   *       return services[key].findById(value);
	   *     },
	   *     is: function(object, key) {
	   *       // Check that object is a valid dbObject
	   *       return angular.isObject(object) && object.id && services[key];
	   *     }
	   *     equals: function(a, b) {
	   *       // Check the equality of decoded objects by comparing
	   *       // their unique IDs
	   *       return a.id === b.id;
	   *     }
	   *   };
	   * });
	   *
	   * // In a config() block, you can then attach URLs with
	   * // type-annotated parameters:
	   * $stateProvider.state('users', {
	   *   url: "/users",
	   *   // ...
	   * }).state('users.item', {
	   *   url: "/{user:dbObject}",
	   *   controller: function($scope, $stateParams) {
	   *     // $stateParams.user will now be an object returned from
	   *     // the Users service
	   *   },
	   *   // ...
	   * });
	   * </pre>
	   */
	  this.type = function (name, definition, definitionFn) {
	    if (!isDefined(definition)) return $types[name];
	    if ($types.hasOwnProperty(name)) throw new Error("A type named '" + name + "' has already been defined.");
	
	    $types[name] = new Type(extend({ name: name }, definition));
	    if (definitionFn) {
	      typeQueue.push({ name: name, def: definitionFn });
	      if (!enqueue) flushTypeQueue();
	    }
	    return this;
	  };
	
	  // `flushTypeQueue()` waits until `$urlMatcherFactory` is injected before invoking the queued `definitionFn`s
	  function flushTypeQueue() {
	    while(typeQueue.length) {
	      var type = typeQueue.shift();
	      if (type.pattern) throw new Error("You cannot override a type's .pattern at runtime.");
	      angular.extend($types[type.name], injector.invoke(type.def));
	    }
	  }
	
	  // Register default types. Store them in the prototype of $types.
	  forEach(defaultTypes, function(type, name) { $types[name] = new Type(extend({name: name}, type)); });
	  $types = inherit($types, {});
	
	  /* No need to document $get, since it returns this */
	  this.$get = ['$injector', function ($injector) {
	    injector = $injector;
	    enqueue = false;
	    flushTypeQueue();
	
	    forEach(defaultTypes, function(type, name) {
	      if (!$types[name]) $types[name] = new Type(type);
	    });
	    return this;
	  }];
	
	  this.Param = function Param(id, type, config, location) {
	    var self = this;
	    config = unwrapShorthand(config);
	    type = getType(config, type, location);
	    var arrayMode = getArrayMode();
	    type = arrayMode ? type.$asArray(arrayMode, location === "search") : type;
	    if (type.name === "string" && !arrayMode && location === "path" && config.value === undefined)
	      config.value = ""; // for 0.2.x; in 0.3.0+ do not automatically default to ""
	    var isOptional = config.value !== undefined;
	    var squash = getSquashPolicy(config, isOptional);
	    var replace = getReplace(config, arrayMode, isOptional, squash);
	
	    function unwrapShorthand(config) {
	      var keys = isObject(config) ? objectKeys(config) : [];
	      var isShorthand = indexOf(keys, "value") === -1 && indexOf(keys, "type") === -1 &&
	                        indexOf(keys, "squash") === -1 && indexOf(keys, "array") === -1;
	      if (isShorthand) config = { value: config };
	      config.$$fn = isInjectable(config.value) ? config.value : function () { return config.value; };
	      return config;
	    }
	
	    function getType(config, urlType, location) {
	      if (config.type && urlType) throw new Error("Param '"+id+"' has two type configurations.");
	      if (urlType) return urlType;
	      if (!config.type) return (location === "config" ? $types.any : $types.string);
	
	      if (angular.isString(config.type))
	        return $types[config.type];
	      if (config.type instanceof Type)
	        return config.type;
	      return new Type(config.type);
	    }
	
	    // array config: param name (param[]) overrides default settings.  explicit config overrides param name.
	    function getArrayMode() {
	      var arrayDefaults = { array: (location === "search" ? "auto" : false) };
	      var arrayParamNomenclature = id.match(/\[\]$/) ? { array: true } : {};
	      return extend(arrayDefaults, arrayParamNomenclature, config).array;
	    }
	
	    /**
	     * returns false, true, or the squash value to indicate the "default parameter url squash policy".
	     */
	    function getSquashPolicy(config, isOptional) {
	      var squash = config.squash;
	      if (!isOptional || squash === false) return false;
	      if (!isDefined(squash) || squash == null) return defaultSquashPolicy;
	      if (squash === true || isString(squash)) return squash;
	      throw new Error("Invalid squash policy: '" + squash + "'. Valid policies: false, true, or arbitrary string");
	    }
	
	    function getReplace(config, arrayMode, isOptional, squash) {
	      var replace, configuredKeys, defaultPolicy = [
	        { from: "",   to: (isOptional || arrayMode ? undefined : "") },
	        { from: null, to: (isOptional || arrayMode ? undefined : "") }
	      ];
	      replace = isArray(config.replace) ? config.replace : [];
	      if (isString(squash))
	        replace.push({ from: squash, to: undefined });
	      configuredKeys = map(replace, function(item) { return item.from; } );
	      return filter(defaultPolicy, function(item) { return indexOf(configuredKeys, item.from) === -1; }).concat(replace);
	    }
	
	    /**
	     * [Internal] Get the default value of a parameter, which may be an injectable function.
	     */
	    function $$getDefaultValue() {
	      if (!injector) throw new Error("Injectable functions cannot be called at configuration time");
	      var defaultValue = injector.invoke(config.$$fn);
	      if (defaultValue !== null && defaultValue !== undefined && !self.type.is(defaultValue))
	        throw new Error("Default value (" + defaultValue + ") for parameter '" + self.id + "' is not an instance of Type (" + self.type.name + ")");
	      return defaultValue;
	    }
	
	    /**
	     * [Internal] Gets the decoded representation of a value if the value is defined, otherwise, returns the
	     * default value, which may be the result of an injectable function.
	     */
	    function $value(value) {
	      function hasReplaceVal(val) { return function(obj) { return obj.from === val; }; }
	      function $replace(value) {
	        var replacement = map(filter(self.replace, hasReplaceVal(value)), function(obj) { return obj.to; });
	        return replacement.length ? replacement[0] : value;
	      }
	      value = $replace(value);
	      return !isDefined(value) ? $$getDefaultValue() : self.type.$normalize(value);
	    }
	
	    function toString() { return "{Param:" + id + " " + type + " squash: '" + squash + "' optional: " + isOptional + "}"; }
	
	    extend(this, {
	      id: id,
	      type: type,
	      location: location,
	      array: arrayMode,
	      squash: squash,
	      replace: replace,
	      isOptional: isOptional,
	      value: $value,
	      dynamic: undefined,
	      config: config,
	      toString: toString
	    });
	  };
	
	  function ParamSet(params) {
	    extend(this, params || {});
	  }
	
	  ParamSet.prototype = {
	    $$new: function() {
	      return inherit(this, extend(new ParamSet(), { $$parent: this}));
	    },
	    $$keys: function () {
	      var keys = [], chain = [], parent = this,
	        ignore = objectKeys(ParamSet.prototype);
	      while (parent) { chain.push(parent); parent = parent.$$parent; }
	      chain.reverse();
	      forEach(chain, function(paramset) {
	        forEach(objectKeys(paramset), function(key) {
	            if (indexOf(keys, key) === -1 && indexOf(ignore, key) === -1) keys.push(key);
	        });
	      });
	      return keys;
	    },
	    $$values: function(paramValues) {
	      var values = {}, self = this;
	      forEach(self.$$keys(), function(key) {
	        values[key] = self[key].value(paramValues && paramValues[key]);
	      });
	      return values;
	    },
	    $$equals: function(paramValues1, paramValues2) {
	      var equal = true, self = this;
	      forEach(self.$$keys(), function(key) {
	        var left = paramValues1 && paramValues1[key], right = paramValues2 && paramValues2[key];
	        if (!self[key].type.equals(left, right)) equal = false;
	      });
	      return equal;
	    },
	    $$validates: function $$validate(paramValues) {
	      var keys = this.$$keys(), i, param, rawVal, normalized, encoded;
	      for (i = 0; i < keys.length; i++) {
	        param = this[keys[i]];
	        rawVal = paramValues[keys[i]];
	        if ((rawVal === undefined || rawVal === null) && param.isOptional)
	          break; // There was no parameter value, but the param is optional
	        normalized = param.type.$normalize(rawVal);
	        if (!param.type.is(normalized))
	          return false; // The value was not of the correct Type, and could not be decoded to the correct Type
	        encoded = param.type.encode(normalized);
	        if (angular.isString(encoded) && !param.type.pattern.exec(encoded))
	          return false; // The value was of the correct type, but when encoded, did not match the Type's regexp
	      }
	      return true;
	    },
	    $$parent: undefined
	  };
	
	  this.ParamSet = ParamSet;
	}
	
	// Register as a provider so it's available to other providers
	angular.module('ui.router.util').provider('$urlMatcherFactory', $UrlMatcherFactory);
	angular.module('ui.router.util').run(['$urlMatcherFactory', function($urlMatcherFactory) { }]);
	
	/**
	 * @ngdoc object
	 * @name ui.router.router.$urlRouterProvider
	 *
	 * @requires ui.router.util.$urlMatcherFactoryProvider
	 * @requires $locationProvider
	 *
	 * @description
	 * `$urlRouterProvider` has the responsibility of watching `$location`. 
	 * When `$location` changes it runs through a list of rules one by one until a 
	 * match is found. `$urlRouterProvider` is used behind the scenes anytime you specify 
	 * a url in a state configuration. All urls are compiled into a UrlMatcher object.
	 *
	 * There are several methods on `$urlRouterProvider` that make it useful to use directly
	 * in your module config.
	 */
	$UrlRouterProvider.$inject = ['$locationProvider', '$urlMatcherFactoryProvider'];
	function $UrlRouterProvider(   $locationProvider,   $urlMatcherFactory) {
	  var rules = [], otherwise = null, interceptDeferred = false, listener;
	
	  // Returns a string that is a prefix of all strings matching the RegExp
	  function regExpPrefix(re) {
	    var prefix = /^\^((?:\\[^a-zA-Z0-9]|[^\\\[\]\^$*+?.()|{}]+)*)/.exec(re.source);
	    return (prefix != null) ? prefix[1].replace(/\\(.)/g, "$1") : '';
	  }
	
	  // Interpolates matched values into a String.replace()-style pattern
	  function interpolate(pattern, match) {
	    return pattern.replace(/\$(\$|\d{1,2})/, function (m, what) {
	      return match[what === '$' ? 0 : Number(what)];
	    });
	  }
	
	  /**
	   * @ngdoc function
	   * @name ui.router.router.$urlRouterProvider#rule
	   * @methodOf ui.router.router.$urlRouterProvider
	   *
	   * @description
	   * Defines rules that are used by `$urlRouterProvider` to find matches for
	   * specific URLs.
	   *
	   * @example
	   * <pre>
	   * var app = angular.module('app', ['ui.router.router']);
	   *
	   * app.config(function ($urlRouterProvider) {
	   *   // Here's an example of how you might allow case insensitive urls
	   *   $urlRouterProvider.rule(function ($injector, $location) {
	   *     var path = $location.path(),
	   *         normalized = path.toLowerCase();
	   *
	   *     if (path !== normalized) {
	   *       return normalized;
	   *     }
	   *   });
	   * });
	   * </pre>
	   *
	   * @param {function} rule Handler function that takes `$injector` and `$location`
	   * services as arguments. You can use them to return a valid path as a string.
	   *
	   * @return {object} `$urlRouterProvider` - `$urlRouterProvider` instance
	   */
	  this.rule = function (rule) {
	    if (!isFunction(rule)) throw new Error("'rule' must be a function");
	    rules.push(rule);
	    return this;
	  };
	
	  /**
	   * @ngdoc object
	   * @name ui.router.router.$urlRouterProvider#otherwise
	   * @methodOf ui.router.router.$urlRouterProvider
	   *
	   * @description
	   * Defines a path that is used when an invalid route is requested.
	   *
	   * @example
	   * <pre>
	   * var app = angular.module('app', ['ui.router.router']);
	   *
	   * app.config(function ($urlRouterProvider) {
	   *   // if the path doesn't match any of the urls you configured
	   *   // otherwise will take care of routing the user to the
	   *   // specified url
	   *   $urlRouterProvider.otherwise('/index');
	   *
	   *   // Example of using function rule as param
	   *   $urlRouterProvider.otherwise(function ($injector, $location) {
	   *     return '/a/valid/url';
	   *   });
	   * });
	   * </pre>
	   *
	   * @param {string|function} rule The url path you want to redirect to or a function 
	   * rule that returns the url path. The function version is passed two params: 
	   * `$injector` and `$location` services, and must return a url string.
	   *
	   * @return {object} `$urlRouterProvider` - `$urlRouterProvider` instance
	   */
	  this.otherwise = function (rule) {
	    if (isString(rule)) {
	      var redirect = rule;
	      rule = function () { return redirect; };
	    }
	    else if (!isFunction(rule)) throw new Error("'rule' must be a function");
	    otherwise = rule;
	    return this;
	  };
	
	
	  function handleIfMatch($injector, handler, match) {
	    if (!match) return false;
	    var result = $injector.invoke(handler, handler, { $match: match });
	    return isDefined(result) ? result : true;
	  }
	
	  /**
	   * @ngdoc function
	   * @name ui.router.router.$urlRouterProvider#when
	   * @methodOf ui.router.router.$urlRouterProvider
	   *
	   * @description
	   * Registers a handler for a given url matching. 
	   * 
	   * If the handler is a string, it is
	   * treated as a redirect, and is interpolated according to the syntax of match
	   * (i.e. like `String.replace()` for `RegExp`, or like a `UrlMatcher` pattern otherwise).
	   *
	   * If the handler is a function, it is injectable. It gets invoked if `$location`
	   * matches. You have the option of inject the match object as `$match`.
	   *
	   * The handler can return
	   *
	   * - **falsy** to indicate that the rule didn't match after all, then `$urlRouter`
	   *   will continue trying to find another one that matches.
	   * - **string** which is treated as a redirect and passed to `$location.url()`
	   * - **void** or any **truthy** value tells `$urlRouter` that the url was handled.
	   *
	   * @example
	   * <pre>
	   * var app = angular.module('app', ['ui.router.router']);
	   *
	   * app.config(function ($urlRouterProvider) {
	   *   $urlRouterProvider.when($state.url, function ($match, $stateParams) {
	   *     if ($state.$current.navigable !== state ||
	   *         !equalForKeys($match, $stateParams) {
	   *      $state.transitionTo(state, $match, false);
	   *     }
	   *   });
	   * });
	   * </pre>
	   *
	   * @param {string|object} what The incoming path that you want to redirect.
	   * @param {string|function} handler The path you want to redirect your user to.
	   */
	  this.when = function (what, handler) {
	    var redirect, handlerIsString = isString(handler);
	    if (isString(what)) what = $urlMatcherFactory.compile(what);
	
	    if (!handlerIsString && !isFunction(handler) && !isArray(handler))
	      throw new Error("invalid 'handler' in when()");
	
	    var strategies = {
	      matcher: function (what, handler) {
	        if (handlerIsString) {
	          redirect = $urlMatcherFactory.compile(handler);
	          handler = ['$match', function ($match) { return redirect.format($match); }];
	        }
	        return extend(function ($injector, $location) {
	          return handleIfMatch($injector, handler, what.exec($location.path(), $location.search()));
	        }, {
	          prefix: isString(what.prefix) ? what.prefix : ''
	        });
	      },
	      regex: function (what, handler) {
	        if (what.global || what.sticky) throw new Error("when() RegExp must not be global or sticky");
	
	        if (handlerIsString) {
	          redirect = handler;
	          handler = ['$match', function ($match) { return interpolate(redirect, $match); }];
	        }
	        return extend(function ($injector, $location) {
	          return handleIfMatch($injector, handler, what.exec($location.path()));
	        }, {
	          prefix: regExpPrefix(what)
	        });
	      }
	    };
	
	    var check = { matcher: $urlMatcherFactory.isMatcher(what), regex: what instanceof RegExp };
	
	    for (var n in check) {
	      if (check[n]) return this.rule(strategies[n](what, handler));
	    }
	
	    throw new Error("invalid 'what' in when()");
	  };
	
	  /**
	   * @ngdoc function
	   * @name ui.router.router.$urlRouterProvider#deferIntercept
	   * @methodOf ui.router.router.$urlRouterProvider
	   *
	   * @description
	   * Disables (or enables) deferring location change interception.
	   *
	   * If you wish to customize the behavior of syncing the URL (for example, if you wish to
	   * defer a transition but maintain the current URL), call this method at configuration time.
	   * Then, at run time, call `$urlRouter.listen()` after you have configured your own
	   * `$locationChangeSuccess` event handler.
	   *
	   * @example
	   * <pre>
	   * var app = angular.module('app', ['ui.router.router']);
	   *
	   * app.config(function ($urlRouterProvider) {
	   *
	   *   // Prevent $urlRouter from automatically intercepting URL changes;
	   *   // this allows you to configure custom behavior in between
	   *   // location changes and route synchronization:
	   *   $urlRouterProvider.deferIntercept();
	   *
	   * }).run(function ($rootScope, $urlRouter, UserService) {
	   *
	   *   $rootScope.$on('$locationChangeSuccess', function(e) {
	   *     // UserService is an example service for managing user state
	   *     if (UserService.isLoggedIn()) return;
	   *
	   *     // Prevent $urlRouter's default handler from firing
	   *     e.preventDefault();
	   *
	   *     UserService.handleLogin().then(function() {
	   *       // Once the user has logged in, sync the current URL
	   *       // to the router:
	   *       $urlRouter.sync();
	   *     });
	   *   });
	   *
	   *   // Configures $urlRouter's listener *after* your custom listener
	   *   $urlRouter.listen();
	   * });
	   * </pre>
	   *
	   * @param {boolean} defer Indicates whether to defer location change interception. Passing
	            no parameter is equivalent to `true`.
	   */
	  this.deferIntercept = function (defer) {
	    if (defer === undefined) defer = true;
	    interceptDeferred = defer;
	  };
	
	  /**
	   * @ngdoc object
	   * @name ui.router.router.$urlRouter
	   *
	   * @requires $location
	   * @requires $rootScope
	   * @requires $injector
	   * @requires $browser
	   *
	   * @description
	   *
	   */
	  this.$get = $get;
	  $get.$inject = ['$location', '$rootScope', '$injector', '$browser', '$sniffer'];
	  function $get(   $location,   $rootScope,   $injector,   $browser,   $sniffer) {
	
	    var baseHref = $browser.baseHref(), location = $location.url(), lastPushedUrl;
	
	    function appendBasePath(url, isHtml5, absolute) {
	      if (baseHref === '/') return url;
	      if (isHtml5) return baseHref.slice(0, -1) + url;
	      if (absolute) return baseHref.slice(1) + url;
	      return url;
	    }
	
	    // TODO: Optimize groups of rules with non-empty prefix into some sort of decision tree
	    function update(evt) {
	      if (evt && evt.defaultPrevented) return;
	      var ignoreUpdate = lastPushedUrl && $location.url() === lastPushedUrl;
	      lastPushedUrl = undefined;
	      // TODO: Re-implement this in 1.0 for https://github.com/angular-ui/ui-router/issues/1573
	      //if (ignoreUpdate) return true;
	
	      function check(rule) {
	        var handled = rule($injector, $location);
	
	        if (!handled) return false;
	        if (isString(handled)) $location.replace().url(handled);
	        return true;
	      }
	      var n = rules.length, i;
	
	      for (i = 0; i < n; i++) {
	        if (check(rules[i])) return;
	      }
	      // always check otherwise last to allow dynamic updates to the set of rules
	      if (otherwise) check(otherwise);
	    }
	
	    function listen() {
	      listener = listener || $rootScope.$on('$locationChangeSuccess', update);
	      return listener;
	    }
	
	    if (!interceptDeferred) listen();
	
	    return {
	      /**
	       * @ngdoc function
	       * @name ui.router.router.$urlRouter#sync
	       * @methodOf ui.router.router.$urlRouter
	       *
	       * @description
	       * Triggers an update; the same update that happens when the address bar url changes, aka `$locationChangeSuccess`.
	       * This method is useful when you need to use `preventDefault()` on the `$locationChangeSuccess` event,
	       * perform some custom logic (route protection, auth, config, redirection, etc) and then finally proceed
	       * with the transition by calling `$urlRouter.sync()`.
	       *
	       * @example
	       * <pre>
	       * angular.module('app', ['ui.router'])
	       *   .run(function($rootScope, $urlRouter) {
	       *     $rootScope.$on('$locationChangeSuccess', function(evt) {
	       *       // Halt state change from even starting
	       *       evt.preventDefault();
	       *       // Perform custom logic
	       *       var meetsRequirement = ...
	       *       // Continue with the update and state transition if logic allows
	       *       if (meetsRequirement) $urlRouter.sync();
	       *     });
	       * });
	       * </pre>
	       */
	      sync: function() {
	        update();
	      },
	
	      listen: function() {
	        return listen();
	      },
	
	      update: function(read) {
	        if (read) {
	          location = $location.url();
	          return;
	        }
	        if ($location.url() === location) return;
	
	        $location.url(location);
	        $location.replace();
	      },
	
	      push: function(urlMatcher, params, options) {
	         var url = urlMatcher.format(params || {});
	
	        // Handle the special hash param, if needed
	        if (url !== null && params && params['#']) {
	            url += '#' + params['#'];
	        }
	
	        $location.url(url);
	        lastPushedUrl = options && options.$$avoidResync ? $location.url() : undefined;
	        if (options && options.replace) $location.replace();
	      },
	
	      /**
	       * @ngdoc function
	       * @name ui.router.router.$urlRouter#href
	       * @methodOf ui.router.router.$urlRouter
	       *
	       * @description
	       * A URL generation method that returns the compiled URL for a given
	       * {@link ui.router.util.type:UrlMatcher `UrlMatcher`}, populated with the provided parameters.
	       *
	       * @example
	       * <pre>
	       * $bob = $urlRouter.href(new UrlMatcher("/about/:person"), {
	       *   person: "bob"
	       * });
	       * // $bob == "/about/bob";
	       * </pre>
	       *
	       * @param {UrlMatcher} urlMatcher The `UrlMatcher` object which is used as the template of the URL to generate.
	       * @param {object=} params An object of parameter values to fill the matcher's required parameters.
	       * @param {object=} options Options object. The options are:
	       *
	       * - **`absolute`** - {boolean=false},  If true will generate an absolute url, e.g. "http://www.example.com/fullurl".
	       *
	       * @returns {string} Returns the fully compiled URL, or `null` if `params` fail validation against `urlMatcher`
	       */
	      href: function(urlMatcher, params, options) {
	        if (!urlMatcher.validates(params)) return null;
	
	        var isHtml5 = $locationProvider.html5Mode();
	        if (angular.isObject(isHtml5)) {
	          isHtml5 = isHtml5.enabled;
	        }
	
	        isHtml5 = isHtml5 && $sniffer.history;
	        
	        var url = urlMatcher.format(params);
	        options = options || {};
	
	        if (!isHtml5 && url !== null) {
	          url = "#" + $locationProvider.hashPrefix() + url;
	        }
	
	        // Handle special hash param, if needed
	        if (url !== null && params && params['#']) {
	          url += '#' + params['#'];
	        }
	
	        url = appendBasePath(url, isHtml5, options.absolute);
	
	        if (!options.absolute || !url) {
	          return url;
	        }
	
	        var slash = (!isHtml5 && url ? '/' : ''), port = $location.port();
	        port = (port === 80 || port === 443 ? '' : ':' + port);
	
	        return [$location.protocol(), '://', $location.host(), port, slash, url].join('');
	      }
	    };
	  }
	}
	
	angular.module('ui.router.router').provider('$urlRouter', $UrlRouterProvider);
	
	/**
	 * @ngdoc object
	 * @name ui.router.state.$stateProvider
	 *
	 * @requires ui.router.router.$urlRouterProvider
	 * @requires ui.router.util.$urlMatcherFactoryProvider
	 *
	 * @description
	 * The new `$stateProvider` works similar to Angular's v1 router, but it focuses purely
	 * on state.
	 *
	 * A state corresponds to a "place" in the application in terms of the overall UI and
	 * navigation. A state describes (via the controller / template / view properties) what
	 * the UI looks like and does at that place.
	 *
	 * States often have things in common, and the primary way of factoring out these
	 * commonalities in this model is via the state hierarchy, i.e. parent/child states aka
	 * nested states.
	 *
	 * The `$stateProvider` provides interfaces to declare these states for your app.
	 */
	$StateProvider.$inject = ['$urlRouterProvider', '$urlMatcherFactoryProvider'];
	function $StateProvider(   $urlRouterProvider,   $urlMatcherFactory) {
	
	  var root, states = {}, $state, queue = {}, abstractKey = 'abstract';
	
	  // Builds state properties from definition passed to registerState()
	  var stateBuilder = {
	
	    // Derive parent state from a hierarchical name only if 'parent' is not explicitly defined.
	    // state.children = [];
	    // if (parent) parent.children.push(state);
	    parent: function(state) {
	      if (isDefined(state.parent) && state.parent) return findState(state.parent);
	      // regex matches any valid composite state name
	      // would match "contact.list" but not "contacts"
	      var compositeName = /^(.+)\.[^.]+$/.exec(state.name);
	      return compositeName ? findState(compositeName[1]) : root;
	    },
	
	    // inherit 'data' from parent and override by own values (if any)
	    data: function(state) {
	      if (state.parent && state.parent.data) {
	        state.data = state.self.data = inherit(state.parent.data, state.data);
	      }
	      return state.data;
	    },
	
	    // Build a URLMatcher if necessary, either via a relative or absolute URL
	    url: function(state) {
	      var url = state.url, config = { params: state.params || {} };
	
	      if (isString(url)) {
	        if (url.charAt(0) == '^') return $urlMatcherFactory.compile(url.substring(1), config);
	        return (state.parent.navigable || root).url.concat(url, config);
	      }
	
	      if (!url || $urlMatcherFactory.isMatcher(url)) return url;
	      throw new Error("Invalid url '" + url + "' in state '" + state + "'");
	    },
	
	    // Keep track of the closest ancestor state that has a URL (i.e. is navigable)
	    navigable: function(state) {
	      return state.url ? state : (state.parent ? state.parent.navigable : null);
	    },
	
	    // Own parameters for this state. state.url.params is already built at this point. Create and add non-url params
	    ownParams: function(state) {
	      var params = state.url && state.url.params || new $$UMFP.ParamSet();
	      forEach(state.params || {}, function(config, id) {
	        if (!params[id]) params[id] = new $$UMFP.Param(id, null, config, "config");
	      });
	      return params;
	    },
	
	    // Derive parameters for this state and ensure they're a super-set of parent's parameters
	    params: function(state) {
	      var ownParams = pick(state.ownParams, state.ownParams.$$keys());
	      return state.parent && state.parent.params ? extend(state.parent.params.$$new(), ownParams) : new $$UMFP.ParamSet();
	    },
	
	    // If there is no explicit multi-view configuration, make one up so we don't have
	    // to handle both cases in the view directive later. Note that having an explicit
	    // 'views' property will mean the default unnamed view properties are ignored. This
	    // is also a good time to resolve view names to absolute names, so everything is a
	    // straight lookup at link time.
	    views: function(state) {
	      var views = {};
	
	      forEach(isDefined(state.views) ? state.views : { '': state }, function (view, name) {
	        if (name.indexOf('@') < 0) name += '@' + state.parent.name;
	        views[name] = view;
	      });
	      return views;
	    },
	
	    // Keep a full path from the root down to this state as this is needed for state activation.
	    path: function(state) {
	      return state.parent ? state.parent.path.concat(state) : []; // exclude root from path
	    },
	
	    // Speed up $state.contains() as it's used a lot
	    includes: function(state) {
	      var includes = state.parent ? extend({}, state.parent.includes) : {};
	      includes[state.name] = true;
	      return includes;
	    },
	
	    $delegates: {}
	  };
	
	  function isRelative(stateName) {
	    return stateName.indexOf(".") === 0 || stateName.indexOf("^") === 0;
	  }
	
	  function findState(stateOrName, base) {
	    if (!stateOrName) return undefined;
	
	    var isStr = isString(stateOrName),
	        name  = isStr ? stateOrName : stateOrName.name,
	        path  = isRelative(name);
	
	    if (path) {
	      if (!base) throw new Error("No reference point given for path '"  + name + "'");
	      base = findState(base);
	      
	      var rel = name.split("."), i = 0, pathLength = rel.length, current = base;
	
	      for (; i < pathLength; i++) {
	        if (rel[i] === "" && i === 0) {
	          current = base;
	          continue;
	        }
	        if (rel[i] === "^") {
	          if (!current.parent) throw new Error("Path '" + name + "' not valid for state '" + base.name + "'");
	          current = current.parent;
	          continue;
	        }
	        break;
	      }
	      rel = rel.slice(i).join(".");
	      name = current.name + (current.name && rel ? "." : "") + rel;
	    }
	    var state = states[name];
	
	    if (state && (isStr || (!isStr && (state === stateOrName || state.self === stateOrName)))) {
	      return state;
	    }
	    return undefined;
	  }
	
	  function queueState(parentName, state) {
	    if (!queue[parentName]) {
	      queue[parentName] = [];
	    }
	    queue[parentName].push(state);
	  }
	
	  function flushQueuedChildren(parentName) {
	    var queued = queue[parentName] || [];
	    while(queued.length) {
	      registerState(queued.shift());
	    }
	  }
	
	  function registerState(state) {
	    // Wrap a new object around the state so we can store our private details easily.
	    state = inherit(state, {
	      self: state,
	      resolve: state.resolve || {},
	      toString: function() { return this.name; }
	    });
	
	    var name = state.name;
	    if (!isString(name) || name.indexOf('@') >= 0) throw new Error("State must have a valid name");
	    if (states.hasOwnProperty(name)) throw new Error("State '" + name + "' is already defined");
	
	    // Get parent name
	    var parentName = (name.indexOf('.') !== -1) ? name.substring(0, name.lastIndexOf('.'))
	        : (isString(state.parent)) ? state.parent
	        : (isObject(state.parent) && isString(state.parent.name)) ? state.parent.name
	        : '';
	
	    // If parent is not registered yet, add state to queue and register later
	    if (parentName && !states[parentName]) {
	      return queueState(parentName, state.self);
	    }
	
	    for (var key in stateBuilder) {
	      if (isFunction(stateBuilder[key])) state[key] = stateBuilder[key](state, stateBuilder.$delegates[key]);
	    }
	    states[name] = state;
	
	    // Register the state in the global state list and with $urlRouter if necessary.
	    if (!state[abstractKey] && state.url) {
	      $urlRouterProvider.when(state.url, ['$match', '$stateParams', function ($match, $stateParams) {
	        if ($state.$current.navigable != state || !equalForKeys($match, $stateParams)) {
	          $state.transitionTo(state, $match, { inherit: true, location: false });
	        }
	      }]);
	    }
	
	    // Register any queued children
	    flushQueuedChildren(name);
	
	    return state;
	  }
	
	  // Checks text to see if it looks like a glob.
	  function isGlob (text) {
	    return text.indexOf('*') > -1;
	  }
	
	  // Returns true if glob matches current $state name.
	  function doesStateMatchGlob (glob) {
	    var globSegments = glob.split('.'),
	        segments = $state.$current.name.split('.');
	
	    //match single stars
	    for (var i = 0, l = globSegments.length; i < l; i++) {
	      if (globSegments[i] === '*') {
	        segments[i] = '*';
	      }
	    }
	
	    //match greedy starts
	    if (globSegments[0] === '**') {
	       segments = segments.slice(indexOf(segments, globSegments[1]));
	       segments.unshift('**');
	    }
	    //match greedy ends
	    if (globSegments[globSegments.length - 1] === '**') {
	       segments.splice(indexOf(segments, globSegments[globSegments.length - 2]) + 1, Number.MAX_VALUE);
	       segments.push('**');
	    }
	
	    if (globSegments.length != segments.length) {
	      return false;
	    }
	
	    return segments.join('') === globSegments.join('');
	  }
	
	
	  // Implicit root state that is always active
	  root = registerState({
	    name: '',
	    url: '^',
	    views: null,
	    'abstract': true
	  });
	  root.navigable = null;
	
	
	  /**
	   * @ngdoc function
	   * @name ui.router.state.$stateProvider#decorator
	   * @methodOf ui.router.state.$stateProvider
	   *
	   * @description
	   * Allows you to extend (carefully) or override (at your own peril) the 
	   * `stateBuilder` object used internally by `$stateProvider`. This can be used 
	   * to add custom functionality to ui-router, for example inferring templateUrl 
	   * based on the state name.
	   *
	   * When passing only a name, it returns the current (original or decorated) builder
	   * function that matches `name`.
	   *
	   * The builder functions that can be decorated are listed below. Though not all
	   * necessarily have a good use case for decoration, that is up to you to decide.
	   *
	   * In addition, users can attach custom decorators, which will generate new 
	   * properties within the state's internal definition. There is currently no clear 
	   * use-case for this beyond accessing internal states (i.e. $state.$current), 
	   * however, expect this to become increasingly relevant as we introduce additional 
	   * meta-programming features.
	   *
	   * **Warning**: Decorators should not be interdependent because the order of 
	   * execution of the builder functions in non-deterministic. Builder functions 
	   * should only be dependent on the state definition object and super function.
	   *
	   *
	   * Existing builder functions and current return values:
	   *
	   * - **parent** `{object}` - returns the parent state object.
	   * - **data** `{object}` - returns state data, including any inherited data that is not
	   *   overridden by own values (if any).
	   * - **url** `{object}` - returns a {@link ui.router.util.type:UrlMatcher UrlMatcher}
	   *   or `null`.
	   * - **navigable** `{object}` - returns closest ancestor state that has a URL (aka is 
	   *   navigable).
	   * - **params** `{object}` - returns an array of state params that are ensured to 
	   *   be a super-set of parent's params.
	   * - **views** `{object}` - returns a views object where each key is an absolute view 
	   *   name (i.e. "viewName@stateName") and each value is the config object 
	   *   (template, controller) for the view. Even when you don't use the views object 
	   *   explicitly on a state config, one is still created for you internally.
	   *   So by decorating this builder function you have access to decorating template 
	   *   and controller properties.
	   * - **ownParams** `{object}` - returns an array of params that belong to the state, 
	   *   not including any params defined by ancestor states.
	   * - **path** `{string}` - returns the full path from the root down to this state. 
	   *   Needed for state activation.
	   * - **includes** `{object}` - returns an object that includes every state that 
	   *   would pass a `$state.includes()` test.
	   *
	   * @example
	   * <pre>
	   * // Override the internal 'views' builder with a function that takes the state
	   * // definition, and a reference to the internal function being overridden:
	   * $stateProvider.decorator('views', function (state, parent) {
	   *   var result = {},
	   *       views = parent(state);
	   *
	   *   angular.forEach(views, function (config, name) {
	   *     var autoName = (state.name + '.' + name).replace('.', '/');
	   *     config.templateUrl = config.templateUrl || '/partials/' + autoName + '.html';
	   *     result[name] = config;
	   *   });
	   *   return result;
	   * });
	   *
	   * $stateProvider.state('home', {
	   *   views: {
	   *     'contact.list': { controller: 'ListController' },
	   *     'contact.item': { controller: 'ItemController' }
	   *   }
	   * });
	   *
	   * // ...
	   *
	   * $state.go('home');
	   * // Auto-populates list and item views with /partials/home/contact/list.html,
	   * // and /partials/home/contact/item.html, respectively.
	   * </pre>
	   *
	   * @param {string} name The name of the builder function to decorate. 
	   * @param {object} func A function that is responsible for decorating the original 
	   * builder function. The function receives two parameters:
	   *
	   *   - `{object}` - state - The state config object.
	   *   - `{object}` - super - The original builder function.
	   *
	   * @return {object} $stateProvider - $stateProvider instance
	   */
	  this.decorator = decorator;
	  function decorator(name, func) {
	    /*jshint validthis: true */
	    if (isString(name) && !isDefined(func)) {
	      return stateBuilder[name];
	    }
	    if (!isFunction(func) || !isString(name)) {
	      return this;
	    }
	    if (stateBuilder[name] && !stateBuilder.$delegates[name]) {
	      stateBuilder.$delegates[name] = stateBuilder[name];
	    }
	    stateBuilder[name] = func;
	    return this;
	  }
	
	  /**
	   * @ngdoc function
	   * @name ui.router.state.$stateProvider#state
	   * @methodOf ui.router.state.$stateProvider
	   *
	   * @description
	   * Registers a state configuration under a given state name. The stateConfig object
	   * has the following acceptable properties.
	   *
	   * @param {string} name A unique state name, e.g. "home", "about", "contacts".
	   * To create a parent/child state use a dot, e.g. "about.sales", "home.newest".
	   * @param {object} stateConfig State configuration object.
	   * @param {string|function=} stateConfig.template
	   * <a id='template'></a>
	   *   html template as a string or a function that returns
	   *   an html template as a string which should be used by the uiView directives. This property 
	   *   takes precedence over templateUrl.
	   *   
	   *   If `template` is a function, it will be called with the following parameters:
	   *
	   *   - {array.&lt;object&gt;} - state parameters extracted from the current $location.path() by
	   *     applying the current state
	   *
	   * <pre>template:
	   *   "<h1>inline template definition</h1>" +
	   *   "<div ui-view></div>"</pre>
	   * <pre>template: function(params) {
	   *       return "<h1>generated template</h1>"; }</pre>
	   * </div>
	   *
	   * @param {string|function=} stateConfig.templateUrl
	   * <a id='templateUrl'></a>
	   *
	   *   path or function that returns a path to an html
	   *   template that should be used by uiView.
	   *   
	   *   If `templateUrl` is a function, it will be called with the following parameters:
	   *
	   *   - {array.&lt;object&gt;} - state parameters extracted from the current $location.path() by 
	   *     applying the current state
	   *
	   * <pre>templateUrl: "home.html"</pre>
	   * <pre>templateUrl: function(params) {
	   *     return myTemplates[params.pageId]; }</pre>
	   *
	   * @param {function=} stateConfig.templateProvider
	   * <a id='templateProvider'></a>
	   *    Provider function that returns HTML content string.
	   * <pre> templateProvider:
	   *       function(MyTemplateService, params) {
	   *         return MyTemplateService.getTemplate(params.pageId);
	   *       }</pre>
	   *
	   * @param {string|function=} stateConfig.controller
	   * <a id='controller'></a>
	   *
	   *  Controller fn that should be associated with newly
	   *   related scope or the name of a registered controller if passed as a string.
	   *   Optionally, the ControllerAs may be declared here.
	   * <pre>controller: "MyRegisteredController"</pre>
	   * <pre>controller:
	   *     "MyRegisteredController as fooCtrl"}</pre>
	   * <pre>controller: function($scope, MyService) {
	   *     $scope.data = MyService.getData(); }</pre>
	   *
	   * @param {function=} stateConfig.controllerProvider
	   * <a id='controllerProvider'></a>
	   *
	   * Injectable provider function that returns the actual controller or string.
	   * <pre>controllerProvider:
	   *   function(MyResolveData) {
	   *     if (MyResolveData.foo)
	   *       return "FooCtrl"
	   *     else if (MyResolveData.bar)
	   *       return "BarCtrl";
	   *     else return function($scope) {
	   *       $scope.baz = "Qux";
	   *     }
	   *   }</pre>
	   *
	   * @param {string=} stateConfig.controllerAs
	   * <a id='controllerAs'></a>
	   * 
	   * A controller alias name. If present the controller will be
	   *   published to scope under the controllerAs name.
	   * <pre>controllerAs: "myCtrl"</pre>
	   *
	   * @param {string|object=} stateConfig.parent
	   * <a id='parent'></a>
	   * Optionally specifies the parent state of this state.
	   *
	   * <pre>parent: 'parentState'</pre>
	   * <pre>parent: parentState // JS variable</pre>
	   *
	   * @param {object=} stateConfig.resolve
	   * <a id='resolve'></a>
	   *
	   * An optional map&lt;string, function&gt; of dependencies which
	   *   should be injected into the controller. If any of these dependencies are promises, 
	   *   the router will wait for them all to be resolved before the controller is instantiated.
	   *   If all the promises are resolved successfully, the $stateChangeSuccess event is fired
	   *   and the values of the resolved promises are injected into any controllers that reference them.
	   *   If any  of the promises are rejected the $stateChangeError event is fired.
	   *
	   *   The map object is:
	   *   
	   *   - key - {string}: name of dependency to be injected into controller
	   *   - factory - {string|function}: If string then it is alias for service. Otherwise if function, 
	   *     it is injected and return value it treated as dependency. If result is a promise, it is 
	   *     resolved before its value is injected into controller.
	   *
	   * <pre>resolve: {
	   *     myResolve1:
	   *       function($http, $stateParams) {
	   *         return $http.get("/api/foos/"+stateParams.fooID);
	   *       }
	   *     }</pre>
	   *
	   * @param {string=} stateConfig.url
	   * <a id='url'></a>
	   *
	   *   A url fragment with optional parameters. When a state is navigated or
	   *   transitioned to, the `$stateParams` service will be populated with any 
	   *   parameters that were passed.
	   *
	   *   (See {@link ui.router.util.type:UrlMatcher UrlMatcher} `UrlMatcher`} for
	   *   more details on acceptable patterns )
	   *
	   * examples:
	   * <pre>url: "/home"
	   * url: "/users/:userid"
	   * url: "/books/{bookid:[a-zA-Z_-]}"
	   * url: "/books/{categoryid:int}"
	   * url: "/books/{publishername:string}/{categoryid:int}"
	   * url: "/messages?before&after"
	   * url: "/messages?{before:date}&{after:date}"
	   * url: "/messages/:mailboxid?{before:date}&{after:date}"
	   * </pre>
	   *
	   * @param {object=} stateConfig.views
	   * <a id='views'></a>
	   * an optional map&lt;string, object&gt; which defined multiple views, or targets views
	   * manually/explicitly.
	   *
	   * Examples:
	   *
	   * Targets three named `ui-view`s in the parent state's template
	   * <pre>views: {
	   *     header: {
	   *       controller: "headerCtrl",
	   *       templateUrl: "header.html"
	   *     }, body: {
	   *       controller: "bodyCtrl",
	   *       templateUrl: "body.html"
	   *     }, footer: {
	   *       controller: "footCtrl",
	   *       templateUrl: "footer.html"
	   *     }
	   *   }</pre>
	   *
	   * Targets named `ui-view="header"` from grandparent state 'top''s template, and named `ui-view="body" from parent state's template.
	   * <pre>views: {
	   *     'header@top': {
	   *       controller: "msgHeaderCtrl",
	   *       templateUrl: "msgHeader.html"
	   *     }, 'body': {
	   *       controller: "messagesCtrl",
	   *       templateUrl: "messages.html"
	   *     }
	   *   }</pre>
	   *
	   * @param {boolean=} [stateConfig.abstract=false]
	   * <a id='abstract'></a>
	   * An abstract state will never be directly activated,
	   *   but can provide inherited properties to its common children states.
	   * <pre>abstract: true</pre>
	   *
	   * @param {function=} stateConfig.onEnter
	   * <a id='onEnter'></a>
	   *
	   * Callback function for when a state is entered. Good way
	   *   to trigger an action or dispatch an event, such as opening a dialog.
	   * If minifying your scripts, make sure to explicitly annotate this function,
	   * because it won't be automatically annotated by your build tools.
	   *
	   * <pre>onEnter: function(MyService, $stateParams) {
	   *     MyService.foo($stateParams.myParam);
	   * }</pre>
	   *
	   * @param {function=} stateConfig.onExit
	   * <a id='onExit'></a>
	   *
	   * Callback function for when a state is exited. Good way to
	   *   trigger an action or dispatch an event, such as opening a dialog.
	   * If minifying your scripts, make sure to explicitly annotate this function,
	   * because it won't be automatically annotated by your build tools.
	   *
	   * <pre>onExit: function(MyService, $stateParams) {
	   *     MyService.cleanup($stateParams.myParam);
	   * }</pre>
	   *
	   * @param {boolean=} [stateConfig.reloadOnSearch=true]
	   * <a id='reloadOnSearch'></a>
	   *
	   * If `false`, will not retrigger the same state
	   *   just because a search/query parameter has changed (via $location.search() or $location.hash()). 
	   *   Useful for when you'd like to modify $location.search() without triggering a reload.
	   * <pre>reloadOnSearch: false</pre>
	   *
	   * @param {object=} stateConfig.data
	   * <a id='data'></a>
	   *
	   * Arbitrary data object, useful for custom configuration.  The parent state's `data` is
	   *   prototypally inherited.  In other words, adding a data property to a state adds it to
	   *   the entire subtree via prototypal inheritance.
	   *
	   * <pre>data: {
	   *     requiredRole: 'foo'
	   * } </pre>
	   *
	   * @param {object=} stateConfig.params
	   * <a id='params'></a>
	   *
	   * A map which optionally configures parameters declared in the `url`, or
	   *   defines additional non-url parameters.  For each parameter being
	   *   configured, add a configuration object keyed to the name of the parameter.
	   *
	   *   Each parameter configuration object may contain the following properties:
	   *
	   *   - ** value ** - {object|function=}: specifies the default value for this
	   *     parameter.  This implicitly sets this parameter as optional.
	   *
	   *     When UI-Router routes to a state and no value is
	   *     specified for this parameter in the URL or transition, the
	   *     default value will be used instead.  If `value` is a function,
	   *     it will be injected and invoked, and the return value used.
	   *
	   *     *Note*: `undefined` is treated as "no default value" while `null`
	   *     is treated as "the default value is `null`".
	   *
	   *     *Shorthand*: If you only need to configure the default value of the
	   *     parameter, you may use a shorthand syntax.   In the **`params`**
	   *     map, instead mapping the param name to a full parameter configuration
	   *     object, simply set map it to the default parameter value, e.g.:
	   *
	   * <pre>// define a parameter's default value
	   * params: {
	   *     param1: { value: "defaultValue" }
	   * }
	   * // shorthand default values
	   * params: {
	   *     param1: "defaultValue",
	   *     param2: "param2Default"
	   * }</pre>
	   *
	   *   - ** array ** - {boolean=}: *(default: false)* If true, the param value will be
	   *     treated as an array of values.  If you specified a Type, the value will be
	   *     treated as an array of the specified Type.  Note: query parameter values
	   *     default to a special `"auto"` mode.
	   *
	   *     For query parameters in `"auto"` mode, if multiple  values for a single parameter
	   *     are present in the URL (e.g.: `/foo?bar=1&bar=2&bar=3`) then the values
	   *     are mapped to an array (e.g.: `{ foo: [ '1', '2', '3' ] }`).  However, if
	   *     only one value is present (e.g.: `/foo?bar=1`) then the value is treated as single
	   *     value (e.g.: `{ foo: '1' }`).
	   *
	   * <pre>params: {
	   *     param1: { array: true }
	   * }</pre>
	   *
	   *   - ** squash ** - {bool|string=}: `squash` configures how a default parameter value is represented in the URL when
	   *     the current parameter value is the same as the default value. If `squash` is not set, it uses the
	   *     configured default squash policy.
	   *     (See {@link ui.router.util.$urlMatcherFactory#methods_defaultSquashPolicy `defaultSquashPolicy()`})
	   *
	   *   There are three squash settings:
	   *
	   *     - false: The parameter's default value is not squashed.  It is encoded and included in the URL
	   *     - true: The parameter's default value is omitted from the URL.  If the parameter is preceeded and followed
	   *       by slashes in the state's `url` declaration, then one of those slashes are omitted.
	   *       This can allow for cleaner looking URLs.
	   *     - `"<arbitrary string>"`: The parameter's default value is replaced with an arbitrary placeholder of  your choice.
	   *
	   * <pre>params: {
	   *     param1: {
	   *       value: "defaultId",
	   *       squash: true
	   * } }
	   * // squash "defaultValue" to "~"
	   * params: {
	   *     param1: {
	   *       value: "defaultValue",
	   *       squash: "~"
	   * } }
	   * </pre>
	   *
	   *
	   * @example
	   * <pre>
	   * // Some state name examples
	   *
	   * // stateName can be a single top-level name (must be unique).
	   * $stateProvider.state("home", {});
	   *
	   * // Or it can be a nested state name. This state is a child of the
	   * // above "home" state.
	   * $stateProvider.state("home.newest", {});
	   *
	   * // Nest states as deeply as needed.
	   * $stateProvider.state("home.newest.abc.xyz.inception", {});
	   *
	   * // state() returns $stateProvider, so you can chain state declarations.
	   * $stateProvider
	   *   .state("home", {})
	   *   .state("about", {})
	   *   .state("contacts", {});
	   * </pre>
	   *
	   */
	  this.state = state;
	  function state(name, definition) {
	    /*jshint validthis: true */
	    if (isObject(name)) definition = name;
	    else definition.name = name;
	    registerState(definition);
	    return this;
	  }
	
	  /**
	   * @ngdoc object
	   * @name ui.router.state.$state
	   *
	   * @requires $rootScope
	   * @requires $q
	   * @requires ui.router.state.$view
	   * @requires $injector
	   * @requires ui.router.util.$resolve
	   * @requires ui.router.state.$stateParams
	   * @requires ui.router.router.$urlRouter
	   *
	   * @property {object} params A param object, e.g. {sectionId: section.id)}, that 
	   * you'd like to test against the current active state.
	   * @property {object} current A reference to the state's config object. However 
	   * you passed it in. Useful for accessing custom data.
	   * @property {object} transition Currently pending transition. A promise that'll 
	   * resolve or reject.
	   *
	   * @description
	   * `$state` service is responsible for representing states as well as transitioning
	   * between them. It also provides interfaces to ask for current state or even states
	   * you're coming from.
	   */
	  this.$get = $get;
	  $get.$inject = ['$rootScope', '$q', '$view', '$injector', '$resolve', '$stateParams', '$urlRouter', '$location', '$urlMatcherFactory'];
	  function $get(   $rootScope,   $q,   $view,   $injector,   $resolve,   $stateParams,   $urlRouter,   $location,   $urlMatcherFactory) {
	
	    var TransitionSuperseded = $q.reject(new Error('transition superseded'));
	    var TransitionPrevented = $q.reject(new Error('transition prevented'));
	    var TransitionAborted = $q.reject(new Error('transition aborted'));
	    var TransitionFailed = $q.reject(new Error('transition failed'));
	
	    // Handles the case where a state which is the target of a transition is not found, and the user
	    // can optionally retry or defer the transition
	    function handleRedirect(redirect, state, params, options) {
	      /**
	       * @ngdoc event
	       * @name ui.router.state.$state#$stateNotFound
	       * @eventOf ui.router.state.$state
	       * @eventType broadcast on root scope
	       * @description
	       * Fired when a requested state **cannot be found** using the provided state name during transition.
	       * The event is broadcast allowing any handlers a single chance to deal with the error (usually by
	       * lazy-loading the unfound state). A special `unfoundState` object is passed to the listener handler,
	       * you can see its three properties in the example. You can use `event.preventDefault()` to abort the
	       * transition and the promise returned from `go` will be rejected with a `'transition aborted'` value.
	       *
	       * @param {Object} event Event object.
	       * @param {Object} unfoundState Unfound State information. Contains: `to, toParams, options` properties.
	       * @param {State} fromState Current state object.
	       * @param {Object} fromParams Current state params.
	       *
	       * @example
	       *
	       * <pre>
	       * // somewhere, assume lazy.state has not been defined
	       * $state.go("lazy.state", {a:1, b:2}, {inherit:false});
	       *
	       * // somewhere else
	       * $scope.$on('$stateNotFound',
	       * function(event, unfoundState, fromState, fromParams){
	       *     console.log(unfoundState.to); // "lazy.state"
	       *     console.log(unfoundState.toParams); // {a:1, b:2}
	       *     console.log(unfoundState.options); // {inherit:false} + default options
	       * })
	       * </pre>
	       */
	      var evt = $rootScope.$broadcast('$stateNotFound', redirect, state, params);
	
	      if (evt.defaultPrevented) {
	        $urlRouter.update();
	        return TransitionAborted;
	      }
	
	      if (!evt.retry) {
	        return null;
	      }
	
	      // Allow the handler to return a promise to defer state lookup retry
	      if (options.$retry) {
	        $urlRouter.update();
	        return TransitionFailed;
	      }
	      var retryTransition = $state.transition = $q.when(evt.retry);
	
	      retryTransition.then(function() {
	        if (retryTransition !== $state.transition) return TransitionSuperseded;
	        redirect.options.$retry = true;
	        return $state.transitionTo(redirect.to, redirect.toParams, redirect.options);
	      }, function() {
	        return TransitionAborted;
	      });
	      $urlRouter.update();
	
	      return retryTransition;
	    }
	
	    root.locals = { resolve: null, globals: { $stateParams: {} } };
	
	    $state = {
	      params: {},
	      current: root.self,
	      $current: root,
	      transition: null
	    };
	
	    /**
	     * @ngdoc function
	     * @name ui.router.state.$state#reload
	     * @methodOf ui.router.state.$state
	     *
	     * @description
	     * A method that force reloads the current state. All resolves are re-resolved,
	     * controllers reinstantiated, and events re-fired.
	     *
	     * @example
	     * <pre>
	     * var app angular.module('app', ['ui.router']);
	     *
	     * app.controller('ctrl', function ($scope, $state) {
	     *   $scope.reload = function(){
	     *     $state.reload();
	     *   }
	     * });
	     * </pre>
	     *
	     * `reload()` is just an alias for:
	     * <pre>
	     * $state.transitionTo($state.current, $stateParams, { 
	     *   reload: true, inherit: false, notify: true
	     * });
	     * </pre>
	     *
	     * @param {string=|object=} state - A state name or a state object, which is the root of the resolves to be re-resolved.
	     * @example
	     * <pre>
	     * //assuming app application consists of 3 states: 'contacts', 'contacts.detail', 'contacts.detail.item' 
	     * //and current state is 'contacts.detail.item'
	     * var app angular.module('app', ['ui.router']);
	     *
	     * app.controller('ctrl', function ($scope, $state) {
	     *   $scope.reload = function(){
	     *     //will reload 'contact.detail' and 'contact.detail.item' states
	     *     $state.reload('contact.detail');
	     *   }
	     * });
	     * </pre>
	     *
	     * `reload()` is just an alias for:
	     * <pre>
	     * $state.transitionTo($state.current, $stateParams, { 
	     *   reload: true, inherit: false, notify: true
	     * });
	     * </pre>
	
	     * @returns {promise} A promise representing the state of the new transition. See
	     * {@link ui.router.state.$state#methods_go $state.go}.
	     */
	    $state.reload = function reload(state) {
	      return $state.transitionTo($state.current, $stateParams, { reload: state || true, inherit: false, notify: true});
	    };
	
	    /**
	     * @ngdoc function
	     * @name ui.router.state.$state#go
	     * @methodOf ui.router.state.$state
	     *
	     * @description
	     * Convenience method for transitioning to a new state. `$state.go` calls 
	     * `$state.transitionTo` internally but automatically sets options to 
	     * `{ location: true, inherit: true, relative: $state.$current, notify: true }`. 
	     * This allows you to easily use an absolute or relative to path and specify 
	     * only the parameters you'd like to update (while letting unspecified parameters 
	     * inherit from the currently active ancestor states).
	     *
	     * @example
	     * <pre>
	     * var app = angular.module('app', ['ui.router']);
	     *
	     * app.controller('ctrl', function ($scope, $state) {
	     *   $scope.changeState = function () {
	     *     $state.go('contact.detail');
	     *   };
	     * });
	     * </pre>
	     * <img src='../ngdoc_assets/StateGoExamples.png'/>
	     *
	     * @param {string} to Absolute state name or relative state path. Some examples:
	     *
	     * - `$state.go('contact.detail')` - will go to the `contact.detail` state
	     * - `$state.go('^')` - will go to a parent state
	     * - `$state.go('^.sibling')` - will go to a sibling state
	     * - `$state.go('.child.grandchild')` - will go to grandchild state
	     *
	     * @param {object=} params A map of the parameters that will be sent to the state, 
	     * will populate $stateParams. Any parameters that are not specified will be inherited from currently 
	     * defined parameters. Only parameters specified in the state definition can be overridden, new 
	     * parameters will be ignored. This allows, for example, going to a sibling state that shares parameters
	     * specified in a parent state. Parameter inheritance only works between common ancestor states, I.e.
	     * transitioning to a sibling will get you the parameters for all parents, transitioning to a child
	     * will get you all current parameters, etc.
	     * @param {object=} options Options object. The options are:
	     *
	     * - **`location`** - {boolean=true|string=} - If `true` will update the url in the location bar, if `false`
	     *    will not. If string, must be `"replace"`, which will update url and also replace last history record.
	     * - **`inherit`** - {boolean=true}, If `true` will inherit url parameters from current url.
	     * - **`relative`** - {object=$state.$current}, When transitioning with relative path (e.g '^'), 
	     *    defines which state to be relative from.
	     * - **`notify`** - {boolean=true}, If `true` will broadcast $stateChangeStart and $stateChangeSuccess events.
	     * - **`reload`** (v0.2.5) - {boolean=false|string|object}, If `true` will force transition even if no state or params
	     *    have changed.  It will reload the resolves and views of the current state and parent states.
	     *    If `reload` is a string (or state object), the state object is fetched (by name, or object reference); and \
	     *    the transition reloads the resolves and views for that matched state, and all its children states.
	     *
	     * @returns {promise} A promise representing the state of the new transition.
	     *
	     * Possible success values:
	     *
	     * - $state.current
	     *
	     * <br/>Possible rejection values:
	     *
	     * - 'transition superseded' - when a newer transition has been started after this one
	     * - 'transition prevented' - when `event.preventDefault()` has been called in a `$stateChangeStart` listener
	     * - 'transition aborted' - when `event.preventDefault()` has been called in a `$stateNotFound` listener or
	     *   when a `$stateNotFound` `event.retry` promise errors.
	     * - 'transition failed' - when a state has been unsuccessfully found after 2 tries.
	     * - *resolve error* - when an error has occurred with a `resolve`
	     *
	     */
	    $state.go = function go(to, params, options) {
	      return $state.transitionTo(to, params, extend({ inherit: true, relative: $state.$current }, options));
	    };
	
	    /**
	     * @ngdoc function
	     * @name ui.router.state.$state#transitionTo
	     * @methodOf ui.router.state.$state
	     *
	     * @description
	     * Low-level method for transitioning to a new state. {@link ui.router.state.$state#methods_go $state.go}
	     * uses `transitionTo` internally. `$state.go` is recommended in most situations.
	     *
	     * @example
	     * <pre>
	     * var app = angular.module('app', ['ui.router']);
	     *
	     * app.controller('ctrl', function ($scope, $state) {
	     *   $scope.changeState = function () {
	     *     $state.transitionTo('contact.detail');
	     *   };
	     * });
	     * </pre>
	     *
	     * @param {string} to State name.
	     * @param {object=} toParams A map of the parameters that will be sent to the state,
	     * will populate $stateParams.
	     * @param {object=} options Options object. The options are:
	     *
	     * - **`location`** - {boolean=true|string=} - If `true` will update the url in the location bar, if `false`
	     *    will not. If string, must be `"replace"`, which will update url and also replace last history record.
	     * - **`inherit`** - {boolean=false}, If `true` will inherit url parameters from current url.
	     * - **`relative`** - {object=}, When transitioning with relative path (e.g '^'), 
	     *    defines which state to be relative from.
	     * - **`notify`** - {boolean=true}, If `true` will broadcast $stateChangeStart and $stateChangeSuccess events.
	     * - **`reload`** (v0.2.5) - {boolean=false|string=|object=}, If `true` will force transition even if the state or params 
	     *    have not changed, aka a reload of the same state. It differs from reloadOnSearch because you'd
	     *    use this when you want to force a reload when *everything* is the same, including search params.
	     *    if String, then will reload the state with the name given in reload, and any children.
	     *    if Object, then a stateObj is expected, will reload the state found in stateObj, and any children.
	     *
	     * @returns {promise} A promise representing the state of the new transition. See
	     * {@link ui.router.state.$state#methods_go $state.go}.
	     */
	    $state.transitionTo = function transitionTo(to, toParams, options) {
	      toParams = toParams || {};
	      options = extend({
	        location: true, inherit: false, relative: null, notify: true, reload: false, $retry: false
	      }, options || {});
	
	      var from = $state.$current, fromParams = $state.params, fromPath = from.path;
	      var evt, toState = findState(to, options.relative);
	
	      // Store the hash param for later (since it will be stripped out by various methods)
	      var hash = toParams['#'];
	
	      if (!isDefined(toState)) {
	        var redirect = { to: to, toParams: toParams, options: options };
	        var redirectResult = handleRedirect(redirect, from.self, fromParams, options);
	
	        if (redirectResult) {
	          return redirectResult;
	        }
	
	        // Always retry once if the $stateNotFound was not prevented
	        // (handles either redirect changed or state lazy-definition)
	        to = redirect.to;
	        toParams = redirect.toParams;
	        options = redirect.options;
	        toState = findState(to, options.relative);
	
	        if (!isDefined(toState)) {
	          if (!options.relative) throw new Error("No such state '" + to + "'");
	          throw new Error("Could not resolve '" + to + "' from state '" + options.relative + "'");
	        }
	      }
	      if (toState[abstractKey]) throw new Error("Cannot transition to abstract state '" + to + "'");
	      if (options.inherit) toParams = inheritParams($stateParams, toParams || {}, $state.$current, toState);
	      if (!toState.params.$$validates(toParams)) return TransitionFailed;
	
	      toParams = toState.params.$$values(toParams);
	      to = toState;
	
	      var toPath = to.path;
	
	      // Starting from the root of the path, keep all levels that haven't changed
	      var keep = 0, state = toPath[keep], locals = root.locals, toLocals = [];
	
	      if (!options.reload) {
	        while (state && state === fromPath[keep] && state.ownParams.$$equals(toParams, fromParams)) {
	          locals = toLocals[keep] = state.locals;
	          keep++;
	          state = toPath[keep];
	        }
	      } else if (isString(options.reload) || isObject(options.reload)) {
	        if (isObject(options.reload) && !options.reload.name) {
	          throw new Error('Invalid reload state object');
	        }
	        
	        var reloadState = options.reload === true ? fromPath[0] : findState(options.reload);
	        if (options.reload && !reloadState) {
	          throw new Error("No such reload state '" + (isString(options.reload) ? options.reload : options.reload.name) + "'");
	        }
	
	        while (state && state === fromPath[keep] && state !== reloadState) {
	          locals = toLocals[keep] = state.locals;
	          keep++;
	          state = toPath[keep];
	        }
	      }
	
	      // If we're going to the same state and all locals are kept, we've got nothing to do.
	      // But clear 'transition', as we still want to cancel any other pending transitions.
	      // TODO: We may not want to bump 'transition' if we're called from a location change
	      // that we've initiated ourselves, because we might accidentally abort a legitimate
	      // transition initiated from code?
	      if (shouldSkipReload(to, toParams, from, fromParams, locals, options)) {
	        if (hash) toParams['#'] = hash;
	        $state.params = toParams;
	        copy($state.params, $stateParams);
	        copy(filterByKeys(to.params.$$keys(), $stateParams), to.locals.globals.$stateParams);
	        if (options.location && to.navigable && to.navigable.url) {
	          $urlRouter.push(to.navigable.url, toParams, {
	            $$avoidResync: true, replace: options.location === 'replace'
	          });
	          $urlRouter.update(true);
	        }
	        $state.transition = null;
	        return $q.when($state.current);
	      }
	
	      // Filter parameters before we pass them to event handlers etc.
	      toParams = filterByKeys(to.params.$$keys(), toParams || {});
	      
	      // Re-add the saved hash before we start returning things or broadcasting $stateChangeStart
	      if (hash) toParams['#'] = hash;
	      
	      // Broadcast start event and cancel the transition if requested
	      if (options.notify) {
	        /**
	         * @ngdoc event
	         * @name ui.router.state.$state#$stateChangeStart
	         * @eventOf ui.router.state.$state
	         * @eventType broadcast on root scope
	         * @description
	         * Fired when the state transition **begins**. You can use `event.preventDefault()`
	         * to prevent the transition from happening and then the transition promise will be
	         * rejected with a `'transition prevented'` value.
	         *
	         * @param {Object} event Event object.
	         * @param {State} toState The state being transitioned to.
	         * @param {Object} toParams The params supplied to the `toState`.
	         * @param {State} fromState The current state, pre-transition.
	         * @param {Object} fromParams The params supplied to the `fromState`.
	         *
	         * @example
	         *
	         * <pre>
	         * $rootScope.$on('$stateChangeStart',
	         * function(event, toState, toParams, fromState, fromParams){
	         *     event.preventDefault();
	         *     // transitionTo() promise will be rejected with
	         *     // a 'transition prevented' error
	         * })
	         * </pre>
	         */
	        if ($rootScope.$broadcast('$stateChangeStart', to.self, toParams, from.self, fromParams, options).defaultPrevented) {
	          $rootScope.$broadcast('$stateChangeCancel', to.self, toParams, from.self, fromParams);
	          //Don't update and resync url if there's been a new transition started. see issue #2238, #600
	          if ($state.transition == null) $urlRouter.update();
	          return TransitionPrevented;
	        }
	      }
	
	      // Resolve locals for the remaining states, but don't update any global state just
	      // yet -- if anything fails to resolve the current state needs to remain untouched.
	      // We also set up an inheritance chain for the locals here. This allows the view directive
	      // to quickly look up the correct definition for each view in the current state. Even
	      // though we create the locals object itself outside resolveState(), it is initially
	      // empty and gets filled asynchronously. We need to keep track of the promise for the
	      // (fully resolved) current locals, and pass this down the chain.
	      var resolved = $q.when(locals);
	
	      for (var l = keep; l < toPath.length; l++, state = toPath[l]) {
	        locals = toLocals[l] = inherit(locals);
	        resolved = resolveState(state, toParams, state === to, resolved, locals, options);
	      }
	
	      // Once everything is resolved, we are ready to perform the actual transition
	      // and return a promise for the new state. We also keep track of what the
	      // current promise is, so that we can detect overlapping transitions and
	      // keep only the outcome of the last transition.
	      var transition = $state.transition = resolved.then(function () {
	        var l, entering, exiting;
	
	        if ($state.transition !== transition) return TransitionSuperseded;
	
	        // Exit 'from' states not kept
	        for (l = fromPath.length - 1; l >= keep; l--) {
	          exiting = fromPath[l];
	          if (exiting.self.onExit) {
	            $injector.invoke(exiting.self.onExit, exiting.self, exiting.locals.globals);
	          }
	          exiting.locals = null;
	        }
	
	        // Enter 'to' states not kept
	        for (l = keep; l < toPath.length; l++) {
	          entering = toPath[l];
	          entering.locals = toLocals[l];
	          if (entering.self.onEnter) {
	            $injector.invoke(entering.self.onEnter, entering.self, entering.locals.globals);
	          }
	        }
	
	        // Run it again, to catch any transitions in callbacks
	        if ($state.transition !== transition) return TransitionSuperseded;
	
	        // Update globals in $state
	        $state.$current = to;
	        $state.current = to.self;
	        $state.params = toParams;
	        copy($state.params, $stateParams);
	        $state.transition = null;
	
	        if (options.location && to.navigable) {
	          $urlRouter.push(to.navigable.url, to.navigable.locals.globals.$stateParams, {
	            $$avoidResync: true, replace: options.location === 'replace'
	          });
	        }
	
	        if (options.notify) {
	        /**
	         * @ngdoc event
	         * @name ui.router.state.$state#$stateChangeSuccess
	         * @eventOf ui.router.state.$state
	         * @eventType broadcast on root scope
	         * @description
	         * Fired once the state transition is **complete**.
	         *
	         * @param {Object} event Event object.
	         * @param {State} toState The state being transitioned to.
	         * @param {Object} toParams The params supplied to the `toState`.
	         * @param {State} fromState The current state, pre-transition.
	         * @param {Object} fromParams The params supplied to the `fromState`.
	         */
	          $rootScope.$broadcast('$stateChangeSuccess', to.self, toParams, from.self, fromParams);
	        }
	        $urlRouter.update(true);
	
	        return $state.current;
	      }, function (error) {
	        if ($state.transition !== transition) return TransitionSuperseded;
	
	        $state.transition = null;
	        /**
	         * @ngdoc event
	         * @name ui.router.state.$state#$stateChangeError
	         * @eventOf ui.router.state.$state
	         * @eventType broadcast on root scope
	         * @description
	         * Fired when an **error occurs** during transition. It's important to note that if you
	         * have any errors in your resolve functions (javascript errors, non-existent services, etc)
	         * they will not throw traditionally. You must listen for this $stateChangeError event to
	         * catch **ALL** errors.
	         *
	         * @param {Object} event Event object.
	         * @param {State} toState The state being transitioned to.
	         * @param {Object} toParams The params supplied to the `toState`.
	         * @param {State} fromState The current state, pre-transition.
	         * @param {Object} fromParams The params supplied to the `fromState`.
	         * @param {Error} error The resolve error object.
	         */
	        evt = $rootScope.$broadcast('$stateChangeError', to.self, toParams, from.self, fromParams, error);
	
	        if (!evt.defaultPrevented) {
	            $urlRouter.update();
	        }
	
	        return $q.reject(error);
	      });
	
	      return transition;
	    };
	
	    /**
	     * @ngdoc function
	     * @name ui.router.state.$state#is
	     * @methodOf ui.router.state.$state
	     *
	     * @description
	     * Similar to {@link ui.router.state.$state#methods_includes $state.includes},
	     * but only checks for the full state name. If params is supplied then it will be
	     * tested for strict equality against the current active params object, so all params
	     * must match with none missing and no extras.
	     *
	     * @example
	     * <pre>
	     * $state.$current.name = 'contacts.details.item';
	     *
	     * // absolute name
	     * $state.is('contact.details.item'); // returns true
	     * $state.is(contactDetailItemStateObject); // returns true
	     *
	     * // relative name (. and ^), typically from a template
	     * // E.g. from the 'contacts.details' template
	     * <div ng-class="{highlighted: $state.is('.item')}">Item</div>
	     * </pre>
	     *
	     * @param {string|object} stateOrName The state name (absolute or relative) or state object you'd like to check.
	     * @param {object=} params A param object, e.g. `{sectionId: section.id}`, that you'd like
	     * to test against the current active state.
	     * @param {object=} options An options object.  The options are:
	     *
	     * - **`relative`** - {string|object} -  If `stateOrName` is a relative state name and `options.relative` is set, .is will
	     * test relative to `options.relative` state (or name).
	     *
	     * @returns {boolean} Returns true if it is the state.
	     */
	    $state.is = function is(stateOrName, params, options) {
	      options = extend({ relative: $state.$current }, options || {});
	      var state = findState(stateOrName, options.relative);
	
	      if (!isDefined(state)) { return undefined; }
	      if ($state.$current !== state) { return false; }
	      return params ? equalForKeys(state.params.$$values(params), $stateParams) : true;
	    };
	
	    /**
	     * @ngdoc function
	     * @name ui.router.state.$state#includes
	     * @methodOf ui.router.state.$state
	     *
	     * @description
	     * A method to determine if the current active state is equal to or is the child of the
	     * state stateName. If any params are passed then they will be tested for a match as well.
	     * Not all the parameters need to be passed, just the ones you'd like to test for equality.
	     *
	     * @example
	     * Partial and relative names
	     * <pre>
	     * $state.$current.name = 'contacts.details.item';
	     *
	     * // Using partial names
	     * $state.includes("contacts"); // returns true
	     * $state.includes("contacts.details"); // returns true
	     * $state.includes("contacts.details.item"); // returns true
	     * $state.includes("contacts.list"); // returns false
	     * $state.includes("about"); // returns false
	     *
	     * // Using relative names (. and ^), typically from a template
	     * // E.g. from the 'contacts.details' template
	     * <div ng-class="{highlighted: $state.includes('.item')}">Item</div>
	     * </pre>
	     *
	     * Basic globbing patterns
	     * <pre>
	     * $state.$current.name = 'contacts.details.item.url';
	     *
	     * $state.includes("*.details.*.*"); // returns true
	     * $state.includes("*.details.**"); // returns true
	     * $state.includes("**.item.**"); // returns true
	     * $state.includes("*.details.item.url"); // returns true
	     * $state.includes("*.details.*.url"); // returns true
	     * $state.includes("*.details.*"); // returns false
	     * $state.includes("item.**"); // returns false
	     * </pre>
	     *
	     * @param {string} stateOrName A partial name, relative name, or glob pattern
	     * to be searched for within the current state name.
	     * @param {object=} params A param object, e.g. `{sectionId: section.id}`,
	     * that you'd like to test against the current active state.
	     * @param {object=} options An options object.  The options are:
	     *
	     * - **`relative`** - {string|object=} -  If `stateOrName` is a relative state reference and `options.relative` is set,
	     * .includes will test relative to `options.relative` state (or name).
	     *
	     * @returns {boolean} Returns true if it does include the state
	     */
	    $state.includes = function includes(stateOrName, params, options) {
	      options = extend({ relative: $state.$current }, options || {});
	      if (isString(stateOrName) && isGlob(stateOrName)) {
	        if (!doesStateMatchGlob(stateOrName)) {
	          return false;
	        }
	        stateOrName = $state.$current.name;
	      }
	
	      var state = findState(stateOrName, options.relative);
	      if (!isDefined(state)) { return undefined; }
	      if (!isDefined($state.$current.includes[state.name])) { return false; }
	      return params ? equalForKeys(state.params.$$values(params), $stateParams, objectKeys(params)) : true;
	    };
	
	
	    /**
	     * @ngdoc function
	     * @name ui.router.state.$state#href
	     * @methodOf ui.router.state.$state
	     *
	     * @description
	     * A url generation method that returns the compiled url for the given state populated with the given params.
	     *
	     * @example
	     * <pre>
	     * expect($state.href("about.person", { person: "bob" })).toEqual("/about/bob");
	     * </pre>
	     *
	     * @param {string|object} stateOrName The state name or state object you'd like to generate a url from.
	     * @param {object=} params An object of parameter values to fill the state's required parameters.
	     * @param {object=} options Options object. The options are:
	     *
	     * - **`lossy`** - {boolean=true} -  If true, and if there is no url associated with the state provided in the
	     *    first parameter, then the constructed href url will be built from the first navigable ancestor (aka
	     *    ancestor with a valid url).
	     * - **`inherit`** - {boolean=true}, If `true` will inherit url parameters from current url.
	     * - **`relative`** - {object=$state.$current}, When transitioning with relative path (e.g '^'), 
	     *    defines which state to be relative from.
	     * - **`absolute`** - {boolean=false},  If true will generate an absolute url, e.g. "http://www.example.com/fullurl".
	     * 
	     * @returns {string} compiled state url
	     */
	    $state.href = function href(stateOrName, params, options) {
	      options = extend({
	        lossy:    true,
	        inherit:  true,
	        absolute: false,
	        relative: $state.$current
	      }, options || {});
	
	      var state = findState(stateOrName, options.relative);
	
	      if (!isDefined(state)) return null;
	      if (options.inherit) params = inheritParams($stateParams, params || {}, $state.$current, state);
	      
	      var nav = (state && options.lossy) ? state.navigable : state;
	
	      if (!nav || nav.url === undefined || nav.url === null) {
	        return null;
	      }
	      return $urlRouter.href(nav.url, filterByKeys(state.params.$$keys().concat('#'), params || {}), {
	        absolute: options.absolute
	      });
	    };
	
	    /**
	     * @ngdoc function
	     * @name ui.router.state.$state#get
	     * @methodOf ui.router.state.$state
	     *
	     * @description
	     * Returns the state configuration object for any specific state or all states.
	     *
	     * @param {string|object=} stateOrName (absolute or relative) If provided, will only get the config for
	     * the requested state. If not provided, returns an array of ALL state configs.
	     * @param {string|object=} context When stateOrName is a relative state reference, the state will be retrieved relative to context.
	     * @returns {Object|Array} State configuration object or array of all objects.
	     */
	    $state.get = function (stateOrName, context) {
	      if (arguments.length === 0) return map(objectKeys(states), function(name) { return states[name].self; });
	      var state = findState(stateOrName, context || $state.$current);
	      return (state && state.self) ? state.self : null;
	    };
	
	    function resolveState(state, params, paramsAreFiltered, inherited, dst, options) {
	      // Make a restricted $stateParams with only the parameters that apply to this state if
	      // necessary. In addition to being available to the controller and onEnter/onExit callbacks,
	      // we also need $stateParams to be available for any $injector calls we make during the
	      // dependency resolution process.
	      var $stateParams = (paramsAreFiltered) ? params : filterByKeys(state.params.$$keys(), params);
	      var locals = { $stateParams: $stateParams };
	
	      // Resolve 'global' dependencies for the state, i.e. those not specific to a view.
	      // We're also including $stateParams in this; that way the parameters are restricted
	      // to the set that should be visible to the state, and are independent of when we update
	      // the global $state and $stateParams values.
	      dst.resolve = $resolve.resolve(state.resolve, locals, dst.resolve, state);
	      var promises = [dst.resolve.then(function (globals) {
	        dst.globals = globals;
	      })];
	      if (inherited) promises.push(inherited);
	
	      function resolveViews() {
	        var viewsPromises = [];
	
	        // Resolve template and dependencies for all views.
	        forEach(state.views, function (view, name) {
	          var injectables = (view.resolve && view.resolve !== state.resolve ? view.resolve : {});
	          injectables.$template = [ function () {
	            return $view.load(name, { view: view, locals: dst.globals, params: $stateParams, notify: options.notify }) || '';
	          }];
	
	          viewsPromises.push($resolve.resolve(injectables, dst.globals, dst.resolve, state).then(function (result) {
	            // References to the controller (only instantiated at link time)
	            if (isFunction(view.controllerProvider) || isArray(view.controllerProvider)) {
	              var injectLocals = angular.extend({}, injectables, dst.globals);
	              result.$$controller = $injector.invoke(view.controllerProvider, null, injectLocals);
	            } else {
	              result.$$controller = view.controller;
	            }
	            // Provide access to the state itself for internal use
	            result.$$state = state;
	            result.$$controllerAs = view.controllerAs;
	            dst[name] = result;
	          }));
	        });
	
	        return $q.all(viewsPromises).then(function(){
	          return dst.globals;
	        });
	      }
	
	      // Wait for all the promises and then return the activation object
	      return $q.all(promises).then(resolveViews).then(function (values) {
	        return dst;
	      });
	    }
	
	    return $state;
	  }
	
	  function shouldSkipReload(to, toParams, from, fromParams, locals, options) {
	    // Return true if there are no differences in non-search (path/object) params, false if there are differences
	    function nonSearchParamsEqual(fromAndToState, fromParams, toParams) {
	      // Identify whether all the parameters that differ between `fromParams` and `toParams` were search params.
	      function notSearchParam(key) {
	        return fromAndToState.params[key].location != "search";
	      }
	      var nonQueryParamKeys = fromAndToState.params.$$keys().filter(notSearchParam);
	      var nonQueryParams = pick.apply({}, [fromAndToState.params].concat(nonQueryParamKeys));
	      var nonQueryParamSet = new $$UMFP.ParamSet(nonQueryParams);
	      return nonQueryParamSet.$$equals(fromParams, toParams);
	    }
	
	    // If reload was not explicitly requested
	    // and we're transitioning to the same state we're already in
	    // and    the locals didn't change
	    //     or they changed in a way that doesn't merit reloading
	    //        (reloadOnParams:false, or reloadOnSearch.false and only search params changed)
	    // Then return true.
	    if (!options.reload && to === from &&
	      (locals === from.locals || (to.self.reloadOnSearch === false && nonSearchParamsEqual(from, fromParams, toParams)))) {
	      return true;
	    }
	  }
	}
	
	angular.module('ui.router.state')
	  .factory('$stateParams', function () { return {}; })
	  .provider('$state', $StateProvider);
	
	
	$ViewProvider.$inject = [];
	function $ViewProvider() {
	
	  this.$get = $get;
	  /**
	   * @ngdoc object
	   * @name ui.router.state.$view
	   *
	   * @requires ui.router.util.$templateFactory
	   * @requires $rootScope
	   *
	   * @description
	   *
	   */
	  $get.$inject = ['$rootScope', '$templateFactory'];
	  function $get(   $rootScope,   $templateFactory) {
	    return {
	      // $view.load('full.viewName', { template: ..., controller: ..., resolve: ..., async: false, params: ... })
	      /**
	       * @ngdoc function
	       * @name ui.router.state.$view#load
	       * @methodOf ui.router.state.$view
	       *
	       * @description
	       *
	       * @param {string} name name
	       * @param {object} options option object.
	       */
	      load: function load(name, options) {
	        var result, defaults = {
	          template: null, controller: null, view: null, locals: null, notify: true, async: true, params: {}
	        };
	        options = extend(defaults, options);
	
	        if (options.view) {
	          result = $templateFactory.fromConfig(options.view, options.params, options.locals);
	        }
	        return result;
	      }
	    };
	  }
	}
	
	angular.module('ui.router.state').provider('$view', $ViewProvider);
	
	/**
	 * @ngdoc object
	 * @name ui.router.state.$uiViewScrollProvider
	 *
	 * @description
	 * Provider that returns the {@link ui.router.state.$uiViewScroll} service function.
	 */
	function $ViewScrollProvider() {
	
	  var useAnchorScroll = false;
	
	  /**
	   * @ngdoc function
	   * @name ui.router.state.$uiViewScrollProvider#useAnchorScroll
	   * @methodOf ui.router.state.$uiViewScrollProvider
	   *
	   * @description
	   * Reverts back to using the core [`$anchorScroll`](http://docs.angularjs.org/api/ng.$anchorScroll) service for
	   * scrolling based on the url anchor.
	   */
	  this.useAnchorScroll = function () {
	    useAnchorScroll = true;
	  };
	
	  /**
	   * @ngdoc object
	   * @name ui.router.state.$uiViewScroll
	   *
	   * @requires $anchorScroll
	   * @requires $timeout
	   *
	   * @description
	   * When called with a jqLite element, it scrolls the element into view (after a
	   * `$timeout` so the DOM has time to refresh).
	   *
	   * If you prefer to rely on `$anchorScroll` to scroll the view to the anchor,
	   * this can be enabled by calling {@link ui.router.state.$uiViewScrollProvider#methods_useAnchorScroll `$uiViewScrollProvider.useAnchorScroll()`}.
	   */
	  this.$get = ['$anchorScroll', '$timeout', function ($anchorScroll, $timeout) {
	    if (useAnchorScroll) {
	      return $anchorScroll;
	    }
	
	    return function ($element) {
	      return $timeout(function () {
	        $element[0].scrollIntoView();
	      }, 0, false);
	    };
	  }];
	}
	
	angular.module('ui.router.state').provider('$uiViewScroll', $ViewScrollProvider);
	
	var ngMajorVer = angular.version.major;
	var ngMinorVer = angular.version.minor;
	/**
	 * @ngdoc directive
	 * @name ui.router.state.directive:ui-view
	 *
	 * @requires ui.router.state.$state
	 * @requires $compile
	 * @requires $controller
	 * @requires $injector
	 * @requires ui.router.state.$uiViewScroll
	 * @requires $document
	 *
	 * @restrict ECA
	 *
	 * @description
	 * The ui-view directive tells $state where to place your templates.
	 *
	 * @param {string=} name A view name. The name should be unique amongst the other views in the
	 * same state. You can have views of the same name that live in different states.
	 *
	 * @param {string=} autoscroll It allows you to set the scroll behavior of the browser window
	 * when a view is populated. By default, $anchorScroll is overridden by ui-router's custom scroll
	 * service, {@link ui.router.state.$uiViewScroll}. This custom service let's you
	 * scroll ui-view elements into view when they are populated during a state activation.
	 *
	 * @param {string=} noanimation If truthy, the non-animated renderer will be selected (no animations
	 * will be applied to the ui-view)
	 *
	 * *Note: To revert back to old [`$anchorScroll`](http://docs.angularjs.org/api/ng.$anchorScroll)
	 * functionality, call `$uiViewScrollProvider.useAnchorScroll()`.*
	 *
	 * @param {string=} onload Expression to evaluate whenever the view updates.
	 * 
	 * @example
	 * A view can be unnamed or named. 
	 * <pre>
	 * <!-- Unnamed -->
	 * <div ui-view></div> 
	 * 
	 * <!-- Named -->
	 * <div ui-view="viewName"></div>
	 * </pre>
	 *
	 * You can only have one unnamed view within any template (or root html). If you are only using a 
	 * single view and it is unnamed then you can populate it like so:
	 * <pre>
	 * <div ui-view></div> 
	 * $stateProvider.state("home", {
	 *   template: "<h1>HELLO!</h1>"
	 * })
	 * </pre>
	 * 
	 * The above is a convenient shortcut equivalent to specifying your view explicitly with the {@link ui.router.state.$stateProvider#views `views`}
	 * config property, by name, in this case an empty name:
	 * <pre>
	 * $stateProvider.state("home", {
	 *   views: {
	 *     "": {
	 *       template: "<h1>HELLO!</h1>"
	 *     }
	 *   }    
	 * })
	 * </pre>
	 * 
	 * But typically you'll only use the views property if you name your view or have more than one view 
	 * in the same template. There's not really a compelling reason to name a view if its the only one, 
	 * but you could if you wanted, like so:
	 * <pre>
	 * <div ui-view="main"></div>
	 * </pre> 
	 * <pre>
	 * $stateProvider.state("home", {
	 *   views: {
	 *     "main": {
	 *       template: "<h1>HELLO!</h1>"
	 *     }
	 *   }    
	 * })
	 * </pre>
	 * 
	 * Really though, you'll use views to set up multiple views:
	 * <pre>
	 * <div ui-view></div>
	 * <div ui-view="chart"></div> 
	 * <div ui-view="data"></div> 
	 * </pre>
	 * 
	 * <pre>
	 * $stateProvider.state("home", {
	 *   views: {
	 *     "": {
	 *       template: "<h1>HELLO!</h1>"
	 *     },
	 *     "chart": {
	 *       template: "<chart_thing/>"
	 *     },
	 *     "data": {
	 *       template: "<data_thing/>"
	 *     }
	 *   }    
	 * })
	 * </pre>
	 *
	 * Examples for `autoscroll`:
	 *
	 * <pre>
	 * <!-- If autoscroll present with no expression,
	 *      then scroll ui-view into view -->
	 * <ui-view autoscroll/>
	 *
	 * <!-- If autoscroll present with valid expression,
	 *      then scroll ui-view into view if expression evaluates to true -->
	 * <ui-view autoscroll='true'/>
	 * <ui-view autoscroll='false'/>
	 * <ui-view autoscroll='scopeVariable'/>
	 * </pre>
	 */
	$ViewDirective.$inject = ['$state', '$injector', '$uiViewScroll', '$interpolate'];
	function $ViewDirective(   $state,   $injector,   $uiViewScroll,   $interpolate) {
	
	  function getService() {
	    return ($injector.has) ? function(service) {
	      return $injector.has(service) ? $injector.get(service) : null;
	    } : function(service) {
	      try {
	        return $injector.get(service);
	      } catch (e) {
	        return null;
	      }
	    };
	  }
	
	  var service = getService(),
	      $animator = service('$animator'),
	      $animate = service('$animate');
	
	  // Returns a set of DOM manipulation functions based on which Angular version
	  // it should use
	  function getRenderer(attrs, scope) {
	    var statics = {
	      enter: function (element, target, cb) { target.after(element); cb(); },
	      leave: function (element, cb) { element.remove(); cb(); }
	    };
	
	    if (!!attrs.noanimation) return statics;
	
	    function animEnabled(element) {
	      if (ngMajorVer === 1 && ngMinorVer >= 4) return !!$animate.enabled(element);
	      if (ngMajorVer === 1 && ngMinorVer >= 2) return !!$animate.enabled();
	      return (!!$animator);
	    }
	
	    // ng 1.2+
	    if ($animate) {
	      return {
	        enter: function(element, target, cb) {
	          if (!animEnabled(element)) {
	            statics.enter(element, target, cb);
	          } else if (angular.version.minor > 2) {
	            $animate.enter(element, null, target).then(cb);
	          } else {
	            $animate.enter(element, null, target, cb);
	          }
	        },
	        leave: function(element, cb) {
	          if (!animEnabled(element)) {
	            statics.leave(element, cb);
	          } else if (angular.version.minor > 2) {
	            $animate.leave(element).then(cb);
	          } else {
	            $animate.leave(element, cb);
	          }
	        }
	      };
	    }
	
	    // ng 1.1.5
	    if ($animator) {
	      var animate = $animator && $animator(scope, attrs);
	
	      return {
	        enter: function(element, target, cb) {animate.enter(element, null, target); cb(); },
	        leave: function(element, cb) { animate.leave(element); cb(); }
	      };
	    }
	
	    return statics;
	  }
	
	  var directive = {
	    restrict: 'ECA',
	    terminal: true,
	    priority: 400,
	    transclude: 'element',
	    compile: function (tElement, tAttrs, $transclude) {
	      return function (scope, $element, attrs) {
	        var previousEl, currentEl, currentScope, latestLocals,
	            onloadExp     = attrs.onload || '',
	            autoScrollExp = attrs.autoscroll,
	            renderer      = getRenderer(attrs, scope);
	
	        scope.$on('$stateChangeSuccess', function() {
	          updateView(false);
	        });
	
	        updateView(true);
	
	        function cleanupLastView() {
	          var _previousEl = previousEl;
	          var _currentScope = currentScope;
	
	          if (_currentScope) {
	            _currentScope._willBeDestroyed = true;
	          }
	
	          function cleanOld() {
	            if (_previousEl) {
	              _previousEl.remove();
	            }
	
	            if (_currentScope) {
	              _currentScope.$destroy();
	            }
	          }
	
	          if (currentEl) {
	            renderer.leave(currentEl, function() {
	              cleanOld();
	              previousEl = null;
	            });
	
	            previousEl = currentEl;
	          } else {
	            cleanOld();
	            previousEl = null;
	          }
	
	          currentEl = null;
	          currentScope = null;
	        }
	
	        function updateView(firstTime) {
	          var newScope,
	              name            = getUiViewName(scope, attrs, $element, $interpolate),
	              previousLocals  = name && $state.$current && $state.$current.locals[name];
	
	          if (!firstTime && previousLocals === latestLocals || scope._willBeDestroyed) return; // nothing to do
	          newScope = scope.$new();
	          latestLocals = $state.$current.locals[name];
	
	          /**
	           * @ngdoc event
	           * @name ui.router.state.directive:ui-view#$viewContentLoading
	           * @eventOf ui.router.state.directive:ui-view
	           * @eventType emits on ui-view directive scope
	           * @description
	           *
	           * Fired once the view **begins loading**, *before* the DOM is rendered.
	           *
	           * @param {Object} event Event object.
	           * @param {string} viewName Name of the view.
	           */
	          newScope.$emit('$viewContentLoading', name);
	
	          var clone = $transclude(newScope, function(clone) {
	            renderer.enter(clone, $element, function onUiViewEnter() {
	              if(currentScope) {
	                currentScope.$emit('$viewContentAnimationEnded');
	              }
	
	              if (angular.isDefined(autoScrollExp) && !autoScrollExp || scope.$eval(autoScrollExp)) {
	                $uiViewScroll(clone);
	              }
	            });
	            cleanupLastView();
	          });
	
	          currentEl = clone;
	          currentScope = newScope;
	          /**
	           * @ngdoc event
	           * @name ui.router.state.directive:ui-view#$viewContentLoaded
	           * @eventOf ui.router.state.directive:ui-view
	           * @eventType emits on ui-view directive scope
	           * @description
	           * Fired once the view is **loaded**, *after* the DOM is rendered.
	           *
	           * @param {Object} event Event object.
	           * @param {string} viewName Name of the view.
	           */
	          currentScope.$emit('$viewContentLoaded', name);
	          currentScope.$eval(onloadExp);
	        }
	      };
	    }
	  };
	
	  return directive;
	}
	
	$ViewDirectiveFill.$inject = ['$compile', '$controller', '$state', '$interpolate'];
	function $ViewDirectiveFill (  $compile,   $controller,   $state,   $interpolate) {
	  return {
	    restrict: 'ECA',
	    priority: -400,
	    compile: function (tElement) {
	      var initial = tElement.html();
	      return function (scope, $element, attrs) {
	        var current = $state.$current,
	            name = getUiViewName(scope, attrs, $element, $interpolate),
	            locals  = current && current.locals[name];
	
	        if (! locals) {
	          return;
	        }
	
	        $element.data('$uiView', { name: name, state: locals.$$state });
	        $element.html(locals.$template ? locals.$template : initial);
	
	        var link = $compile($element.contents());
	
	        if (locals.$$controller) {
	          locals.$scope = scope;
	          locals.$element = $element;
	          var controller = $controller(locals.$$controller, locals);
	          if (locals.$$controllerAs) {
	            scope[locals.$$controllerAs] = controller;
	          }
	          $element.data('$ngControllerController', controller);
	          $element.children().data('$ngControllerController', controller);
	        }
	
	        link(scope);
	      };
	    }
	  };
	}
	
	/**
	 * Shared ui-view code for both directives:
	 * Given scope, element, and its attributes, return the view's name
	 */
	function getUiViewName(scope, attrs, element, $interpolate) {
	  var name = $interpolate(attrs.uiView || attrs.name || '')(scope);
	  var inherited = element.inheritedData('$uiView');
	  return name.indexOf('@') >= 0 ?  name :  (name + '@' + (inherited ? inherited.state.name : ''));
	}
	
	angular.module('ui.router.state').directive('uiView', $ViewDirective);
	angular.module('ui.router.state').directive('uiView', $ViewDirectiveFill);
	
	function parseStateRef(ref, current) {
	  var preparsed = ref.match(/^\s*({[^}]*})\s*$/), parsed;
	  if (preparsed) ref = current + '(' + preparsed[1] + ')';
	  parsed = ref.replace(/\n/g, " ").match(/^([^(]+?)\s*(\((.*)\))?$/);
	  if (!parsed || parsed.length !== 4) throw new Error("Invalid state ref '" + ref + "'");
	  return { state: parsed[1], paramExpr: parsed[3] || null };
	}
	
	function stateContext(el) {
	  var stateData = el.parent().inheritedData('$uiView');
	
	  if (stateData && stateData.state && stateData.state.name) {
	    return stateData.state;
	  }
	}
	
	function getTypeInfo(el) {
	  // SVGAElement does not use the href attribute, but rather the 'xlinkHref' attribute.
	  var isSvg = Object.prototype.toString.call(el.prop('href')) === '[object SVGAnimatedString]';
	  var isForm = el[0].nodeName === "FORM";
	
	  return {
	    attr: isForm ? "action" : (isSvg ? 'xlink:href' : 'href'),
	    isAnchor: el.prop("tagName").toUpperCase() === "A",
	    clickable: !isForm
	  };
	}
	
	function clickHook(el, $state, $timeout, type, current) {
	  return function(e) {
	    var button = e.which || e.button, target = current();
	
	    if (!(button > 1 || e.ctrlKey || e.metaKey || e.shiftKey || el.attr('target'))) {
	      // HACK: This is to allow ng-clicks to be processed before the transition is initiated:
	      var transition = $timeout(function() {
	        $state.go(target.state, target.params, target.options);
	      });
	      e.preventDefault();
	
	      // if the state has no URL, ignore one preventDefault from the <a> directive.
	      var ignorePreventDefaultCount = type.isAnchor && !target.href ? 1: 0;
	
	      e.preventDefault = function() {
	        if (ignorePreventDefaultCount-- <= 0) $timeout.cancel(transition);
	      };
	    }
	  };
	}
	
	function defaultOpts(el, $state) {
	  return { relative: stateContext(el) || $state.$current, inherit: true };
	}
	
	/**
	 * @ngdoc directive
	 * @name ui.router.state.directive:ui-sref
	 *
	 * @requires ui.router.state.$state
	 * @requires $timeout
	 *
	 * @restrict A
	 *
	 * @description
	 * A directive that binds a link (`<a>` tag) to a state. If the state has an associated
	 * URL, the directive will automatically generate & update the `href` attribute via
	 * the {@link ui.router.state.$state#methods_href $state.href()} method. Clicking
	 * the link will trigger a state transition with optional parameters.
	 *
	 * Also middle-clicking, right-clicking, and ctrl-clicking on the link will be
	 * handled natively by the browser.
	 *
	 * You can also use relative state paths within ui-sref, just like the relative
	 * paths passed to `$state.go()`. You just need to be aware that the path is relative
	 * to the state that the link lives in, in other words the state that loaded the
	 * template containing the link.
	 *
	 * You can specify options to pass to {@link ui.router.state.$state#go $state.go()}
	 * using the `ui-sref-opts` attribute. Options are restricted to `location`, `inherit`,
	 * and `reload`.
	 *
	 * @example
	 * Here's an example of how you'd use ui-sref and how it would compile. If you have the
	 * following template:
	 * <pre>
	 * <a ui-sref="home">Home</a> | <a ui-sref="about">About</a> | <a ui-sref="{page: 2}">Next page</a>
	 *
	 * <ul>
	 *     <li ng-repeat="contact in contacts">
	 *         <a ui-sref="contacts.detail({ id: contact.id })">{{ contact.name }}</a>
	 *     </li>
	 * </ul>
	 * </pre>
	 *
	 * Then the compiled html would be (assuming Html5Mode is off and current state is contacts):
	 * <pre>
	 * <a href="#/home" ui-sref="home">Home</a> | <a href="#/about" ui-sref="about">About</a> | <a href="#/contacts?page=2" ui-sref="{page: 2}">Next page</a>
	 *
	 * <ul>
	 *     <li ng-repeat="contact in contacts">
	 *         <a href="#/contacts/1" ui-sref="contacts.detail({ id: contact.id })">Joe</a>
	 *     </li>
	 *     <li ng-repeat="contact in contacts">
	 *         <a href="#/contacts/2" ui-sref="contacts.detail({ id: contact.id })">Alice</a>
	 *     </li>
	 *     <li ng-repeat="contact in contacts">
	 *         <a href="#/contacts/3" ui-sref="contacts.detail({ id: contact.id })">Bob</a>
	 *     </li>
	 * </ul>
	 *
	 * <a ui-sref="home" ui-sref-opts="{reload: true}">Home</a>
	 * </pre>
	 *
	 * @param {string} ui-sref 'stateName' can be any valid absolute or relative state
	 * @param {Object} ui-sref-opts options to pass to {@link ui.router.state.$state#go $state.go()}
	 */
	$StateRefDirective.$inject = ['$state', '$timeout'];
	function $StateRefDirective($state, $timeout) {
	  return {
	    restrict: 'A',
	    require: ['?^uiSrefActive', '?^uiSrefActiveEq'],
	    link: function(scope, element, attrs, uiSrefActive) {
	      var ref    = parseStateRef(attrs.uiSref, $state.current.name);
	      var def    = { state: ref.state, href: null, params: null };
	      var type   = getTypeInfo(element);
	      var active = uiSrefActive[1] || uiSrefActive[0];
	
	      def.options = extend(defaultOpts(element, $state), attrs.uiSrefOpts ? scope.$eval(attrs.uiSrefOpts) : {});
	
	      var update = function(val) {
	        if (val) def.params = angular.copy(val);
	        def.href = $state.href(ref.state, def.params, def.options);
	
	        if (active) active.$$addStateInfo(ref.state, def.params);
	        if (def.href !== null) attrs.$set(type.attr, def.href);
	      };
	
	      if (ref.paramExpr) {
	        scope.$watch(ref.paramExpr, function(val) { if (val !== def.params) update(val); }, true);
	        def.params = angular.copy(scope.$eval(ref.paramExpr));
	      }
	      update();
	
	      if (!type.clickable) return;
	      element.bind("click", clickHook(element, $state, $timeout, type, function() { return def; }));
	    }
	  };
	}
	
	/**
	 * @ngdoc directive
	 * @name ui.router.state.directive:ui-state
	 *
	 * @requires ui.router.state.uiSref
	 *
	 * @restrict A
	 *
	 * @description
	 * Much like ui-sref, but will accept named $scope properties to evaluate for a state definition,
	 * params and override options.
	 *
	 * @param {string} ui-state 'stateName' can be any valid absolute or relative state
	 * @param {Object} ui-state-params params to pass to {@link ui.router.state.$state#href $state.href()}
	 * @param {Object} ui-state-opts options to pass to {@link ui.router.state.$state#go $state.go()}
	 */
	$StateRefDynamicDirective.$inject = ['$state', '$timeout'];
	function $StateRefDynamicDirective($state, $timeout) {
	  return {
	    restrict: 'A',
	    require: ['?^uiSrefActive', '?^uiSrefActiveEq'],
	    link: function(scope, element, attrs, uiSrefActive) {
	      var type   = getTypeInfo(element);
	      var active = uiSrefActive[1] || uiSrefActive[0];
	      var group  = [attrs.uiState, attrs.uiStateParams || null, attrs.uiStateOpts || null];
	      var watch  = '[' + group.map(function(val) { return val || 'null'; }).join(', ') + ']';
	      var def    = { state: null, params: null, options: null, href: null };
	
	      function runStateRefLink (group) {
	        def.state = group[0]; def.params = group[1]; def.options = group[2];
	        def.href = $state.href(def.state, def.params, def.options);
	
	        if (active) active.$$addStateInfo(def.state, def.params);
	        if (def.href) attrs.$set(type.attr, def.href);
	      }
	
	      scope.$watch(watch, runStateRefLink, true);
	      runStateRefLink(scope.$eval(watch));
	
	      if (!type.clickable) return;
	      element.bind("click", clickHook(element, $state, $timeout, type, function() { return def; }));
	    }
	  };
	}
	
	
	/**
	 * @ngdoc directive
	 * @name ui.router.state.directive:ui-sref-active
	 *
	 * @requires ui.router.state.$state
	 * @requires ui.router.state.$stateParams
	 * @requires $interpolate
	 *
	 * @restrict A
	 *
	 * @description
	 * A directive working alongside ui-sref to add classes to an element when the
	 * related ui-sref directive's state is active, and removing them when it is inactive.
	 * The primary use-case is to simplify the special appearance of navigation menus
	 * relying on `ui-sref`, by having the "active" state's menu button appear different,
	 * distinguishing it from the inactive menu items.
	 *
	 * ui-sref-active can live on the same element as ui-sref or on a parent element. The first
	 * ui-sref-active found at the same level or above the ui-sref will be used.
	 *
	 * Will activate when the ui-sref's target state or any child state is active. If you
	 * need to activate only when the ui-sref target state is active and *not* any of
	 * it's children, then you will use
	 * {@link ui.router.state.directive:ui-sref-active-eq ui-sref-active-eq}
	 *
	 * @example
	 * Given the following template:
	 * <pre>
	 * <ul>
	 *   <li ui-sref-active="active" class="item">
	 *     <a href ui-sref="app.user({user: 'bilbobaggins'})">@bilbobaggins</a>
	 *   </li>
	 * </ul>
	 * </pre>
	 *
	 *
	 * When the app state is "app.user" (or any children states), and contains the state parameter "user" with value "bilbobaggins",
	 * the resulting HTML will appear as (note the 'active' class):
	 * <pre>
	 * <ul>
	 *   <li ui-sref-active="active" class="item active">
	 *     <a ui-sref="app.user({user: 'bilbobaggins'})" href="/users/bilbobaggins">@bilbobaggins</a>
	 *   </li>
	 * </ul>
	 * </pre>
	 *
	 * The class name is interpolated **once** during the directives link time (any further changes to the
	 * interpolated value are ignored).
	 *
	 * Multiple classes may be specified in a space-separated format:
	 * <pre>
	 * <ul>
	 *   <li ui-sref-active='class1 class2 class3'>
	 *     <a ui-sref="app.user">link</a>
	 *   </li>
	 * </ul>
	 * </pre>
	 *
	 * It is also possible to pass ui-sref-active an expression that evaluates
	 * to an object hash, whose keys represent active class names and whose
	 * values represent the respective state names/globs.
	 * ui-sref-active will match if the current active state **includes** any of
	 * the specified state names/globs, even the abstract ones.
	 *
	 * @Example
	 * Given the following template, with "admin" being an abstract state:
	 * <pre>
	 * <div ui-sref-active="{'active': 'admin.*'}">
	 *   <a ui-sref-active="active" ui-sref="admin.roles">Roles</a>
	 * </div>
	 * </pre>
	 *
	 * When the current state is "admin.roles" the "active" class will be applied
	 * to both the <div> and <a> elements. It is important to note that the state
	 * names/globs passed to ui-sref-active shadow the state provided by ui-sref.
	 */
	
	/**
	 * @ngdoc directive
	 * @name ui.router.state.directive:ui-sref-active-eq
	 *
	 * @requires ui.router.state.$state
	 * @requires ui.router.state.$stateParams
	 * @requires $interpolate
	 *
	 * @restrict A
	 *
	 * @description
	 * The same as {@link ui.router.state.directive:ui-sref-active ui-sref-active} but will only activate
	 * when the exact target state used in the `ui-sref` is active; no child states.
	 *
	 */
	$StateRefActiveDirective.$inject = ['$state', '$stateParams', '$interpolate'];
	function $StateRefActiveDirective($state, $stateParams, $interpolate) {
	  return  {
	    restrict: "A",
	    controller: ['$scope', '$element', '$attrs', '$timeout', function ($scope, $element, $attrs, $timeout) {
	      var states = [], activeClasses = {}, activeEqClass, uiSrefActive;
	
	      // There probably isn't much point in $observing this
	      // uiSrefActive and uiSrefActiveEq share the same directive object with some
	      // slight difference in logic routing
	      activeEqClass = $interpolate($attrs.uiSrefActiveEq || '', false)($scope);
	
	      try {
	        uiSrefActive = $scope.$eval($attrs.uiSrefActive);
	      } catch (e) {
	        // Do nothing. uiSrefActive is not a valid expression.
	        // Fall back to using $interpolate below
	      }
	      uiSrefActive = uiSrefActive || $interpolate($attrs.uiSrefActive || '', false)($scope);
	      if (isObject(uiSrefActive)) {
	        forEach(uiSrefActive, function(stateOrName, activeClass) {
	          if (isString(stateOrName)) {
	            var ref = parseStateRef(stateOrName, $state.current.name);
	            addState(ref.state, $scope.$eval(ref.paramExpr), activeClass);
	          }
	        });
	      }
	
	      // Allow uiSref to communicate with uiSrefActive[Equals]
	      this.$$addStateInfo = function (newState, newParams) {
	        // we already got an explicit state provided by ui-sref-active, so we
	        // shadow the one that comes from ui-sref
	        if (isObject(uiSrefActive) && states.length > 0) {
	          return;
	        }
	        addState(newState, newParams, uiSrefActive);
	        update();
	      };
	
	      $scope.$on('$stateChangeSuccess', update);
	
	      function addState(stateName, stateParams, activeClass) {
	        var state = $state.get(stateName, stateContext($element));
	        var stateHash = createStateHash(stateName, stateParams);
	
	        states.push({
	          state: state || { name: stateName },
	          params: stateParams,
	          hash: stateHash
	        });
	
	        activeClasses[stateHash] = activeClass;
	      }
	
	      /**
	       * @param {string} state
	       * @param {Object|string} [params]
	       * @return {string}
	       */
	      function createStateHash(state, params) {
	        if (!isString(state)) {
	          throw new Error('state should be a string');
	        }
	        if (isObject(params)) {
	          return state + toJson(params);
	        }
	        params = $scope.$eval(params);
	        if (isObject(params)) {
	          return state + toJson(params);
	        }
	        return state;
	      }
	
	      // Update route state
	      function update() {
	        for (var i = 0; i < states.length; i++) {
	          if (anyMatch(states[i].state, states[i].params)) {
	            addClass($element, activeClasses[states[i].hash]);
	          } else {
	            removeClass($element, activeClasses[states[i].hash]);
	          }
	
	          if (exactMatch(states[i].state, states[i].params)) {
	            addClass($element, activeEqClass);
	          } else {
	            removeClass($element, activeEqClass);
	          }
	        }
	      }
	
	      function addClass(el, className) { $timeout(function () { el.addClass(className); }); }
	      function removeClass(el, className) { el.removeClass(className); }
	      function anyMatch(state, params) { return $state.includes(state.name, params); }
	      function exactMatch(state, params) { return $state.is(state.name, params); }
	
	      update();
	    }]
	  };
	}
	
	angular.module('ui.router.state')
	  .directive('uiSref', $StateRefDirective)
	  .directive('uiSrefActive', $StateRefActiveDirective)
	  .directive('uiSrefActiveEq', $StateRefActiveDirective)
	  .directive('uiState', $StateRefDynamicDirective);
	
	/**
	 * @ngdoc filter
	 * @name ui.router.state.filter:isState
	 *
	 * @requires ui.router.state.$state
	 *
	 * @description
	 * Translates to {@link ui.router.state.$state#methods_is $state.is("stateName")}.
	 */
	$IsStateFilter.$inject = ['$state'];
	function $IsStateFilter($state) {
	  var isFilter = function (state, params) {
	    return $state.is(state, params);
	  };
	  isFilter.$stateful = true;
	  return isFilter;
	}
	
	/**
	 * @ngdoc filter
	 * @name ui.router.state.filter:includedByState
	 *
	 * @requires ui.router.state.$state
	 *
	 * @description
	 * Translates to {@link ui.router.state.$state#methods_includes $state.includes('fullOrPartialStateName')}.
	 */
	$IncludedByStateFilter.$inject = ['$state'];
	function $IncludedByStateFilter($state) {
	  var includesFilter = function (state, params, options) {
	    return $state.includes(state, params, options);
	  };
	  includesFilter.$stateful = true;
	  return  includesFilter;
	}
	
	angular.module('ui.router.state')
	  .filter('isState', $IsStateFilter)
	  .filter('includedByState', $IncludedByStateFilter);
	})(window, window.angular);

/***/ }),
/* 1136 */,
/* 1137 */
/***/ (function(module, exports) {

	/**
	 * @license AngularJS v1.5.6
	 * (c) 2010-2016 Google, Inc. http://angularjs.org
	 * License: MIT
	 */
	(function(window) {'use strict';
	
	/**
	 * @description
	 *
	 * This object provides a utility for producing rich Error messages within
	 * Angular. It can be called as follows:
	 *
	 * var exampleMinErr = minErr('example');
	 * throw exampleMinErr('one', 'This {0} is {1}', foo, bar);
	 *
	 * The above creates an instance of minErr in the example namespace. The
	 * resulting error will have a namespaced error code of example.one.  The
	 * resulting error will replace {0} with the value of foo, and {1} with the
	 * value of bar. The object is not restricted in the number of arguments it can
	 * take.
	 *
	 * If fewer arguments are specified than necessary for interpolation, the extra
	 * interpolation markers will be preserved in the final string.
	 *
	 * Since data will be parsed statically during a build step, some restrictions
	 * are applied with respect to how minErr instances are created and called.
	 * Instances should have names of the form namespaceMinErr for a minErr created
	 * using minErr('namespace') . Error codes, namespaces and template strings
	 * should all be static strings, not variables or general expressions.
	 *
	 * @param {string} module The namespace to use for the new minErr instance.
	 * @param {function} ErrorConstructor Custom error constructor to be instantiated when returning
	 *   error from returned function, for cases when a particular type of error is useful.
	 * @returns {function(code:string, template:string, ...templateArgs): Error} minErr instance
	 */
	
	function minErr(module, ErrorConstructor) {
	  ErrorConstructor = ErrorConstructor || Error;
	  return function() {
	    var SKIP_INDEXES = 2;
	
	    var templateArgs = arguments,
	      code = templateArgs[0],
	      message = '[' + (module ? module + ':' : '') + code + '] ',
	      template = templateArgs[1],
	      paramPrefix, i;
	
	    message += template.replace(/\{\d+\}/g, function(match) {
	      var index = +match.slice(1, -1),
	        shiftedIndex = index + SKIP_INDEXES;
	
	      if (shiftedIndex < templateArgs.length) {
	        return toDebugString(templateArgs[shiftedIndex]);
	      }
	
	      return match;
	    });
	
	    message += '\nhttp://errors.angularjs.org/1.5.6/' +
	      (module ? module + '/' : '') + code;
	
	    for (i = SKIP_INDEXES, paramPrefix = '?'; i < templateArgs.length; i++, paramPrefix = '&') {
	      message += paramPrefix + 'p' + (i - SKIP_INDEXES) + '=' +
	        encodeURIComponent(toDebugString(templateArgs[i]));
	    }
	
	    return new ErrorConstructor(message);
	  };
	}
	
	/* We need to tell jshint what variables are being exported */
	/* global angular: true,
	  msie: true,
	  jqLite: true,
	  jQuery: true,
	  slice: true,
	  splice: true,
	  push: true,
	  toString: true,
	  ngMinErr: true,
	  angularModule: true,
	  uid: true,
	  REGEX_STRING_REGEXP: true,
	  VALIDITY_STATE_PROPERTY: true,
	
	  lowercase: true,
	  uppercase: true,
	  manualLowercase: true,
	  manualUppercase: true,
	  nodeName_: true,
	  isArrayLike: true,
	  forEach: true,
	  forEachSorted: true,
	  reverseParams: true,
	  nextUid: true,
	  setHashKey: true,
	  extend: true,
	  toInt: true,
	  inherit: true,
	  merge: true,
	  noop: true,
	  identity: true,
	  valueFn: true,
	  isUndefined: true,
	  isDefined: true,
	  isObject: true,
	  isBlankObject: true,
	  isString: true,
	  isNumber: true,
	  isDate: true,
	  isArray: true,
	  isFunction: true,
	  isRegExp: true,
	  isWindow: true,
	  isScope: true,
	  isFile: true,
	  isFormData: true,
	  isBlob: true,
	  isBoolean: true,
	  isPromiseLike: true,
	  trim: true,
	  escapeForRegexp: true,
	  isElement: true,
	  makeMap: true,
	  includes: true,
	  arrayRemove: true,
	  copy: true,
	  shallowCopy: true,
	  equals: true,
	  csp: true,
	  jq: true,
	  concat: true,
	  sliceArgs: true,
	  bind: true,
	  toJsonReplacer: true,
	  toJson: true,
	  fromJson: true,
	  convertTimezoneToLocal: true,
	  timezoneToOffset: true,
	  startingTag: true,
	  tryDecodeURIComponent: true,
	  parseKeyValue: true,
	  toKeyValue: true,
	  encodeUriSegment: true,
	  encodeUriQuery: true,
	  angularInit: true,
	  bootstrap: true,
	  getTestability: true,
	  snake_case: true,
	  bindJQuery: true,
	  assertArg: true,
	  assertArgFn: true,
	  assertNotHasOwnProperty: true,
	  getter: true,
	  getBlockNodes: true,
	  hasOwnProperty: true,
	  createMap: true,
	
	  NODE_TYPE_ELEMENT: true,
	  NODE_TYPE_ATTRIBUTE: true,
	  NODE_TYPE_TEXT: true,
	  NODE_TYPE_COMMENT: true,
	  NODE_TYPE_DOCUMENT: true,
	  NODE_TYPE_DOCUMENT_FRAGMENT: true,
	*/
	
	////////////////////////////////////
	
	/**
	 * @ngdoc module
	 * @name ng
	 * @module ng
	 * @installation
	 * @description
	 *
	 * # ng (core module)
	 * The ng module is loaded by default when an AngularJS application is started. The module itself
	 * contains the essential components for an AngularJS application to function. The table below
	 * lists a high level breakdown of each of the services/factories, filters, directives and testing
	 * components available within this core module.
	 *
	 * <div doc-module-components="ng"></div>
	 */
	
	var REGEX_STRING_REGEXP = /^\/(.+)\/([a-z]*)$/;
	
	// The name of a form control's ValidityState property.
	// This is used so that it's possible for internal tests to create mock ValidityStates.
	var VALIDITY_STATE_PROPERTY = 'validity';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	var lowercase = function(string) {return isString(string) ? string.toLowerCase() : string;};
	var uppercase = function(string) {return isString(string) ? string.toUpperCase() : string;};
	
	
	var manualLowercase = function(s) {
	  /* jshint bitwise: false */
	  return isString(s)
	      ? s.replace(/[A-Z]/g, function(ch) {return String.fromCharCode(ch.charCodeAt(0) | 32);})
	      : s;
	};
	var manualUppercase = function(s) {
	  /* jshint bitwise: false */
	  return isString(s)
	      ? s.replace(/[a-z]/g, function(ch) {return String.fromCharCode(ch.charCodeAt(0) & ~32);})
	      : s;
	};
	
	
	// String#toLowerCase and String#toUpperCase don't produce correct results in browsers with Turkish
	// locale, for this reason we need to detect this case and redefine lowercase/uppercase methods
	// with correct but slower alternatives. See https://github.com/angular/angular.js/issues/11387
	if ('i' !== 'I'.toLowerCase()) {
	  lowercase = manualLowercase;
	  uppercase = manualUppercase;
	}
	
	
	var
	    msie,             // holds major version number for IE, or NaN if UA is not IE.
	    jqLite,           // delay binding since jQuery could be loaded after us.
	    jQuery,           // delay binding
	    slice             = [].slice,
	    splice            = [].splice,
	    push              = [].push,
	    toString          = Object.prototype.toString,
	    getPrototypeOf    = Object.getPrototypeOf,
	    ngMinErr          = minErr('ng'),
	
	    /** @name angular */
	    angular           = window.angular || (window.angular = {}),
	    angularModule,
	    uid               = 0;
	
	/**
	 * documentMode is an IE-only property
	 * http://msdn.microsoft.com/en-us/library/ie/cc196988(v=vs.85).aspx
	 */
	msie = window.document.documentMode;
	
	
	/**
	 * @private
	 * @param {*} obj
	 * @return {boolean} Returns true if `obj` is an array or array-like object (NodeList, Arguments,
	 *                   String ...)
	 */
	function isArrayLike(obj) {
	
	  // `null`, `undefined` and `window` are not array-like
	  if (obj == null || isWindow(obj)) return false;
	
	  // arrays, strings and jQuery/jqLite objects are array like
	  // * jqLite is either the jQuery or jqLite constructor function
	  // * we have to check the existence of jqLite first as this method is called
	  //   via the forEach method when constructing the jqLite object in the first place
	  if (isArray(obj) || isString(obj) || (jqLite && obj instanceof jqLite)) return true;
	
	  // Support: iOS 8.2 (not reproducible in simulator)
	  // "length" in obj used to prevent JIT error (gh-11508)
	  var length = "length" in Object(obj) && obj.length;
	
	  // NodeList objects (with `item` method) and
	  // other objects with suitable length characteristics are array-like
	  return isNumber(length) &&
	    (length >= 0 && ((length - 1) in obj || obj instanceof Array) || typeof obj.item == 'function');
	
	}
	
	/**
	 * @ngdoc function
	 * @name angular.forEach
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Invokes the `iterator` function once for each item in `obj` collection, which can be either an
	 * object or an array. The `iterator` function is invoked with `iterator(value, key, obj)`, where `value`
	 * is the value of an object property or an array element, `key` is the object property key or
	 * array element index and obj is the `obj` itself. Specifying a `context` for the function is optional.
	 *
	 * It is worth noting that `.forEach` does not iterate over inherited properties because it filters
	 * using the `hasOwnProperty` method.
	 *
	 * Unlike ES262's
	 * [Array.prototype.forEach](http://www.ecma-international.org/ecma-262/5.1/#sec-15.4.4.18),
	 * providing 'undefined' or 'null' values for `obj` will not throw a TypeError, but rather just
	 * return the value provided.
	 *
	   ```js
	     var values = {name: 'misko', gender: 'male'};
	     var log = [];
	     angular.forEach(values, function(value, key) {
	       this.push(key + ': ' + value);
	     }, log);
	     expect(log).toEqual(['name: misko', 'gender: male']);
	   ```
	 *
	 * @param {Object|Array} obj Object to iterate over.
	 * @param {Function} iterator Iterator function.
	 * @param {Object=} context Object to become context (`this`) for the iterator function.
	 * @returns {Object|Array} Reference to `obj`.
	 */
	
	function forEach(obj, iterator, context) {
	  var key, length;
	  if (obj) {
	    if (isFunction(obj)) {
	      for (key in obj) {
	        // Need to check if hasOwnProperty exists,
	        // as on IE8 the result of querySelectorAll is an object without a hasOwnProperty function
	        if (key != 'prototype' && key != 'length' && key != 'name' && (!obj.hasOwnProperty || obj.hasOwnProperty(key))) {
	          iterator.call(context, obj[key], key, obj);
	        }
	      }
	    } else if (isArray(obj) || isArrayLike(obj)) {
	      var isPrimitive = typeof obj !== 'object';
	      for (key = 0, length = obj.length; key < length; key++) {
	        if (isPrimitive || key in obj) {
	          iterator.call(context, obj[key], key, obj);
	        }
	      }
	    } else if (obj.forEach && obj.forEach !== forEach) {
	        obj.forEach(iterator, context, obj);
	    } else if (isBlankObject(obj)) {
	      // createMap() fast path --- Safe to avoid hasOwnProperty check because prototype chain is empty
	      for (key in obj) {
	        iterator.call(context, obj[key], key, obj);
	      }
	    } else if (typeof obj.hasOwnProperty === 'function') {
	      // Slow path for objects inheriting Object.prototype, hasOwnProperty check needed
	      for (key in obj) {
	        if (obj.hasOwnProperty(key)) {
	          iterator.call(context, obj[key], key, obj);
	        }
	      }
	    } else {
	      // Slow path for objects which do not have a method `hasOwnProperty`
	      for (key in obj) {
	        if (hasOwnProperty.call(obj, key)) {
	          iterator.call(context, obj[key], key, obj);
	        }
	      }
	    }
	  }
	  return obj;
	}
	
	function forEachSorted(obj, iterator, context) {
	  var keys = Object.keys(obj).sort();
	  for (var i = 0; i < keys.length; i++) {
	    iterator.call(context, obj[keys[i]], keys[i]);
	  }
	  return keys;
	}
	
	
	/**
	 * when using forEach the params are value, key, but it is often useful to have key, value.
	 * @param {function(string, *)} iteratorFn
	 * @returns {function(*, string)}
	 */
	function reverseParams(iteratorFn) {
	  return function(value, key) {iteratorFn(key, value);};
	}
	
	/**
	 * A consistent way of creating unique IDs in angular.
	 *
	 * Using simple numbers allows us to generate 28.6 million unique ids per second for 10 years before
	 * we hit number precision issues in JavaScript.
	 *
	 * Math.pow(2,53) / 60 / 60 / 24 / 365 / 10 = 28.6M
	 *
	 * @returns {number} an unique alpha-numeric string
	 */
	function nextUid() {
	  return ++uid;
	}
	
	
	/**
	 * Set or clear the hashkey for an object.
	 * @param obj object
	 * @param h the hashkey (!truthy to delete the hashkey)
	 */
	function setHashKey(obj, h) {
	  if (h) {
	    obj.$$hashKey = h;
	  } else {
	    delete obj.$$hashKey;
	  }
	}
	
	
	function baseExtend(dst, objs, deep) {
	  var h = dst.$$hashKey;
	
	  for (var i = 0, ii = objs.length; i < ii; ++i) {
	    var obj = objs[i];
	    if (!isObject(obj) && !isFunction(obj)) continue;
	    var keys = Object.keys(obj);
	    for (var j = 0, jj = keys.length; j < jj; j++) {
	      var key = keys[j];
	      var src = obj[key];
	
	      if (deep && isObject(src)) {
	        if (isDate(src)) {
	          dst[key] = new Date(src.valueOf());
	        } else if (isRegExp(src)) {
	          dst[key] = new RegExp(src);
	        } else if (src.nodeName) {
	          dst[key] = src.cloneNode(true);
	        } else if (isElement(src)) {
	          dst[key] = src.clone();
	        } else {
	          if (!isObject(dst[key])) dst[key] = isArray(src) ? [] : {};
	          baseExtend(dst[key], [src], true);
	        }
	      } else {
	        dst[key] = src;
	      }
	    }
	  }
	
	  setHashKey(dst, h);
	  return dst;
	}
	
	/**
	 * @ngdoc function
	 * @name angular.extend
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Extends the destination object `dst` by copying own enumerable properties from the `src` object(s)
	 * to `dst`. You can specify multiple `src` objects. If you want to preserve original objects, you can do so
	 * by passing an empty object as the target: `var object = angular.extend({}, object1, object2)`.
	 *
	 * **Note:** Keep in mind that `angular.extend` does not support recursive merge (deep copy). Use
	 * {@link angular.merge} for this.
	 *
	 * @param {Object} dst Destination object.
	 * @param {...Object} src Source object(s).
	 * @returns {Object} Reference to `dst`.
	 */
	function extend(dst) {
	  return baseExtend(dst, slice.call(arguments, 1), false);
	}
	
	
	/**
	* @ngdoc function
	* @name angular.merge
	* @module ng
	* @kind function
	*
	* @description
	* Deeply extends the destination object `dst` by copying own enumerable properties from the `src` object(s)
	* to `dst`. You can specify multiple `src` objects. If you want to preserve original objects, you can do so
	* by passing an empty object as the target: `var object = angular.merge({}, object1, object2)`.
	*
	* Unlike {@link angular.extend extend()}, `merge()` recursively descends into object properties of source
	* objects, performing a deep copy.
	*
	* @param {Object} dst Destination object.
	* @param {...Object} src Source object(s).
	* @returns {Object} Reference to `dst`.
	*/
	function merge(dst) {
	  return baseExtend(dst, slice.call(arguments, 1), true);
	}
	
	
	
	function toInt(str) {
	  return parseInt(str, 10);
	}
	
	
	function inherit(parent, extra) {
	  return extend(Object.create(parent), extra);
	}
	
	/**
	 * @ngdoc function
	 * @name angular.noop
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * A function that performs no operations. This function can be useful when writing code in the
	 * functional style.
	   ```js
	     function foo(callback) {
	       var result = calculateResult();
	       (callback || angular.noop)(result);
	     }
	   ```
	 */
	function noop() {}
	noop.$inject = [];
	
	
	/**
	 * @ngdoc function
	 * @name angular.identity
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * A function that returns its first argument. This function is useful when writing code in the
	 * functional style.
	 *
	   ```js
	   function transformer(transformationFn, value) {
	     return (transformationFn || angular.identity)(value);
	   };
	
	   // E.g.
	   function getResult(fn, input) {
	     return (fn || angular.identity)(input);
	   };
	
	   getResult(function(n) { return n * 2; }, 21);   // returns 42
	   getResult(null, 21);                            // returns 21
	   getResult(undefined, 21);                       // returns 21
	   ```
	 *
	 * @param {*} value to be returned.
	 * @returns {*} the value passed in.
	 */
	function identity($) {return $;}
	identity.$inject = [];
	
	
	function valueFn(value) {return function valueRef() {return value;};}
	
	function hasCustomToString(obj) {
	  return isFunction(obj.toString) && obj.toString !== toString;
	}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isUndefined
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is undefined.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is undefined.
	 */
	function isUndefined(value) {return typeof value === 'undefined';}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isDefined
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is defined.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is defined.
	 */
	function isDefined(value) {return typeof value !== 'undefined';}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isObject
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is an `Object`. Unlike `typeof` in JavaScript, `null`s are not
	 * considered to be objects. Note that JavaScript arrays are objects.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is an `Object` but not `null`.
	 */
	function isObject(value) {
	  // http://jsperf.com/isobject4
	  return value !== null && typeof value === 'object';
	}
	
	
	/**
	 * Determine if a value is an object with a null prototype
	 *
	 * @returns {boolean} True if `value` is an `Object` with a null prototype
	 */
	function isBlankObject(value) {
	  return value !== null && typeof value === 'object' && !getPrototypeOf(value);
	}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isString
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is a `String`.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a `String`.
	 */
	function isString(value) {return typeof value === 'string';}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isNumber
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is a `Number`.
	 *
	 * This includes the "special" numbers `NaN`, `+Infinity` and `-Infinity`.
	 *
	 * If you wish to exclude these then you can use the native
	 * [`isFinite'](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/isFinite)
	 * method.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a `Number`.
	 */
	function isNumber(value) {return typeof value === 'number';}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isDate
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a value is a date.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a `Date`.
	 */
	function isDate(value) {
	  return toString.call(value) === '[object Date]';
	}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isArray
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is an `Array`.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is an `Array`.
	 */
	var isArray = Array.isArray;
	
	/**
	 * @ngdoc function
	 * @name angular.isFunction
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is a `Function`.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a `Function`.
	 */
	function isFunction(value) {return typeof value === 'function';}
	
	
	/**
	 * Determines if a value is a regular expression object.
	 *
	 * @private
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a `RegExp`.
	 */
	function isRegExp(value) {
	  return toString.call(value) === '[object RegExp]';
	}
	
	
	/**
	 * Checks if `obj` is a window object.
	 *
	 * @private
	 * @param {*} obj Object to check
	 * @returns {boolean} True if `obj` is a window obj.
	 */
	function isWindow(obj) {
	  return obj && obj.window === obj;
	}
	
	
	function isScope(obj) {
	  return obj && obj.$evalAsync && obj.$watch;
	}
	
	
	function isFile(obj) {
	  return toString.call(obj) === '[object File]';
	}
	
	
	function isFormData(obj) {
	  return toString.call(obj) === '[object FormData]';
	}
	
	
	function isBlob(obj) {
	  return toString.call(obj) === '[object Blob]';
	}
	
	
	function isBoolean(value) {
	  return typeof value === 'boolean';
	}
	
	
	function isPromiseLike(obj) {
	  return obj && isFunction(obj.then);
	}
	
	
	var TYPED_ARRAY_REGEXP = /^\[object (?:Uint8|Uint8Clamped|Uint16|Uint32|Int8|Int16|Int32|Float32|Float64)Array\]$/;
	function isTypedArray(value) {
	  return value && isNumber(value.length) && TYPED_ARRAY_REGEXP.test(toString.call(value));
	}
	
	function isArrayBuffer(obj) {
	  return toString.call(obj) === '[object ArrayBuffer]';
	}
	
	
	var trim = function(value) {
	  return isString(value) ? value.trim() : value;
	};
	
	// Copied from:
	// http://docs.closure-library.googlecode.com/git/local_closure_goog_string_string.js.source.html#line1021
	// Prereq: s is a string.
	var escapeForRegexp = function(s) {
	  return s.replace(/([-()\[\]{}+?*.$\^|,:#<!\\])/g, '\\$1').
	           replace(/\x08/g, '\\x08');
	};
	
	
	/**
	 * @ngdoc function
	 * @name angular.isElement
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is a DOM element (or wrapped jQuery element).
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a DOM element (or wrapped jQuery element).
	 */
	function isElement(node) {
	  return !!(node &&
	    (node.nodeName  // We are a direct element.
	    || (node.prop && node.attr && node.find)));  // We have an on and find method part of jQuery API.
	}
	
	/**
	 * @param str 'key1,key2,...'
	 * @returns {object} in the form of {key1:true, key2:true, ...}
	 */
	function makeMap(str) {
	  var obj = {}, items = str.split(','), i;
	  for (i = 0; i < items.length; i++) {
	    obj[items[i]] = true;
	  }
	  return obj;
	}
	
	
	function nodeName_(element) {
	  return lowercase(element.nodeName || (element[0] && element[0].nodeName));
	}
	
	function includes(array, obj) {
	  return Array.prototype.indexOf.call(array, obj) != -1;
	}
	
	function arrayRemove(array, value) {
	  var index = array.indexOf(value);
	  if (index >= 0) {
	    array.splice(index, 1);
	  }
	  return index;
	}
	
	/**
	 * @ngdoc function
	 * @name angular.copy
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Creates a deep copy of `source`, which should be an object or an array.
	 *
	 * * If no destination is supplied, a copy of the object or array is created.
	 * * If a destination is provided, all of its elements (for arrays) or properties (for objects)
	 *   are deleted and then all elements/properties from the source are copied to it.
	 * * If `source` is not an object or array (inc. `null` and `undefined`), `source` is returned.
	 * * If `source` is identical to 'destination' an exception will be thrown.
	 *
	 * @param {*} source The source that will be used to make a copy.
	 *                   Can be any type, including primitives, `null`, and `undefined`.
	 * @param {(Object|Array)=} destination Destination into which the source is copied. If
	 *     provided, must be of the same type as `source`.
	 * @returns {*} The copy or updated `destination`, if `destination` was specified.
	 *
	 * @example
	 <example module="copyExample">
	 <file name="index.html">
	 <div ng-controller="ExampleController">
	 <form novalidate class="simple-form">
	 Name: <input type="text" ng-model="user.name" /><br />
	 E-mail: <input type="email" ng-model="user.email" /><br />
	 Gender: <input type="radio" ng-model="user.gender" value="male" />male
	 <input type="radio" ng-model="user.gender" value="female" />female<br />
	 <button ng-click="reset()">RESET</button>
	 <button ng-click="update(user)">SAVE</button>
	 </form>
	 <pre>form = {{user | json}}</pre>
	 <pre>master = {{master | json}}</pre>
	 </div>
	
	 <script>
	  angular.module('copyExample', [])
	    .controller('ExampleController', ['$scope', function($scope) {
	      $scope.master= {};
	
	      $scope.update = function(user) {
	        // Example with 1 argument
	        $scope.master= angular.copy(user);
	      };
	
	      $scope.reset = function() {
	        // Example with 2 arguments
	        angular.copy($scope.master, $scope.user);
	      };
	
	      $scope.reset();
	    }]);
	 </script>
	 </file>
	 </example>
	 */
	function copy(source, destination) {
	  var stackSource = [];
	  var stackDest = [];
	
	  if (destination) {
	    if (isTypedArray(destination) || isArrayBuffer(destination)) {
	      throw ngMinErr('cpta', "Can't copy! TypedArray destination cannot be mutated.");
	    }
	    if (source === destination) {
	      throw ngMinErr('cpi', "Can't copy! Source and destination are identical.");
	    }
	
	    // Empty the destination object
	    if (isArray(destination)) {
	      destination.length = 0;
	    } else {
	      forEach(destination, function(value, key) {
	        if (key !== '$$hashKey') {
	          delete destination[key];
	        }
	      });
	    }
	
	    stackSource.push(source);
	    stackDest.push(destination);
	    return copyRecurse(source, destination);
	  }
	
	  return copyElement(source);
	
	  function copyRecurse(source, destination) {
	    var h = destination.$$hashKey;
	    var key;
	    if (isArray(source)) {
	      for (var i = 0, ii = source.length; i < ii; i++) {
	        destination.push(copyElement(source[i]));
	      }
	    } else if (isBlankObject(source)) {
	      // createMap() fast path --- Safe to avoid hasOwnProperty check because prototype chain is empty
	      for (key in source) {
	        destination[key] = copyElement(source[key]);
	      }
	    } else if (source && typeof source.hasOwnProperty === 'function') {
	      // Slow path, which must rely on hasOwnProperty
	      for (key in source) {
	        if (source.hasOwnProperty(key)) {
	          destination[key] = copyElement(source[key]);
	        }
	      }
	    } else {
	      // Slowest path --- hasOwnProperty can't be called as a method
	      for (key in source) {
	        if (hasOwnProperty.call(source, key)) {
	          destination[key] = copyElement(source[key]);
	        }
	      }
	    }
	    setHashKey(destination, h);
	    return destination;
	  }
	
	  function copyElement(source) {
	    // Simple values
	    if (!isObject(source)) {
	      return source;
	    }
	
	    // Already copied values
	    var index = stackSource.indexOf(source);
	    if (index !== -1) {
	      return stackDest[index];
	    }
	
	    if (isWindow(source) || isScope(source)) {
	      throw ngMinErr('cpws',
	        "Can't copy! Making copies of Window or Scope instances is not supported.");
	    }
	
	    var needsRecurse = false;
	    var destination = copyType(source);
	
	    if (destination === undefined) {
	      destination = isArray(source) ? [] : Object.create(getPrototypeOf(source));
	      needsRecurse = true;
	    }
	
	    stackSource.push(source);
	    stackDest.push(destination);
	
	    return needsRecurse
	      ? copyRecurse(source, destination)
	      : destination;
	  }
	
	  function copyType(source) {
	    switch (toString.call(source)) {
	      case '[object Int8Array]':
	      case '[object Int16Array]':
	      case '[object Int32Array]':
	      case '[object Float32Array]':
	      case '[object Float64Array]':
	      case '[object Uint8Array]':
	      case '[object Uint8ClampedArray]':
	      case '[object Uint16Array]':
	      case '[object Uint32Array]':
	        return new source.constructor(copyElement(source.buffer));
	
	      case '[object ArrayBuffer]':
	        //Support: IE10
	        if (!source.slice) {
	          var copied = new ArrayBuffer(source.byteLength);
	          new Uint8Array(copied).set(new Uint8Array(source));
	          return copied;
	        }
	        return source.slice(0);
	
	      case '[object Boolean]':
	      case '[object Number]':
	      case '[object String]':
	      case '[object Date]':
	        return new source.constructor(source.valueOf());
	
	      case '[object RegExp]':
	        var re = new RegExp(source.source, source.toString().match(/[^\/]*$/)[0]);
	        re.lastIndex = source.lastIndex;
	        return re;
	
	      case '[object Blob]':
	        return new source.constructor([source], {type: source.type});
	    }
	
	    if (isFunction(source.cloneNode)) {
	      return source.cloneNode(true);
	    }
	  }
	}
	
	/**
	 * Creates a shallow copy of an object, an array or a primitive.
	 *
	 * Assumes that there are no proto properties for objects.
	 */
	function shallowCopy(src, dst) {
	  if (isArray(src)) {
	    dst = dst || [];
	
	    for (var i = 0, ii = src.length; i < ii; i++) {
	      dst[i] = src[i];
	    }
	  } else if (isObject(src)) {
	    dst = dst || {};
	
	    for (var key in src) {
	      if (!(key.charAt(0) === '$' && key.charAt(1) === '$')) {
	        dst[key] = src[key];
	      }
	    }
	  }
	
	  return dst || src;
	}
	
	
	/**
	 * @ngdoc function
	 * @name angular.equals
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if two objects or two values are equivalent. Supports value types, regular
	 * expressions, arrays and objects.
	 *
	 * Two objects or values are considered equivalent if at least one of the following is true:
	 *
	 * * Both objects or values pass `===` comparison.
	 * * Both objects or values are of the same type and all of their properties are equal by
	 *   comparing them with `angular.equals`.
	 * * Both values are NaN. (In JavaScript, NaN == NaN => false. But we consider two NaN as equal)
	 * * Both values represent the same regular expression (In JavaScript,
	 *   /abc/ == /abc/ => false. But we consider two regular expressions as equal when their textual
	 *   representation matches).
	 *
	 * During a property comparison, properties of `function` type and properties with names
	 * that begin with `$` are ignored.
	 *
	 * Scope and DOMWindow objects are being compared only by identify (`===`).
	 *
	 * @param {*} o1 Object or value to compare.
	 * @param {*} o2 Object or value to compare.
	 * @returns {boolean} True if arguments are equal.
	 *
	 * @example
	   <example module="equalsExample" name="equalsExample">
	     <file name="index.html">
	      <div ng-controller="ExampleController">
	        <form novalidate>
	          <h3>User 1</h3>
	          Name: <input type="text" ng-model="user1.name">
	          Age: <input type="number" ng-model="user1.age">
	
	          <h3>User 2</h3>
	          Name: <input type="text" ng-model="user2.name">
	          Age: <input type="number" ng-model="user2.age">
	
	          <div>
	            <br/>
	            <input type="button" value="Compare" ng-click="compare()">
	          </div>
	          User 1: <pre>{{user1 | json}}</pre>
	          User 2: <pre>{{user2 | json}}</pre>
	          Equal: <pre>{{result}}</pre>
	        </form>
	      </div>
	    </file>
	    <file name="script.js">
	        angular.module('equalsExample', []).controller('ExampleController', ['$scope', function($scope) {
	          $scope.user1 = {};
	          $scope.user2 = {};
	          $scope.result;
	          $scope.compare = function() {
	            $scope.result = angular.equals($scope.user1, $scope.user2);
	          };
	        }]);
	    </file>
	  </example>
	 */
	function equals(o1, o2) {
	  if (o1 === o2) return true;
	  if (o1 === null || o2 === null) return false;
	  if (o1 !== o1 && o2 !== o2) return true; // NaN === NaN
	  var t1 = typeof o1, t2 = typeof o2, length, key, keySet;
	  if (t1 == t2 && t1 == 'object') {
	    if (isArray(o1)) {
	      if (!isArray(o2)) return false;
	      if ((length = o1.length) == o2.length) {
	        for (key = 0; key < length; key++) {
	          if (!equals(o1[key], o2[key])) return false;
	        }
	        return true;
	      }
	    } else if (isDate(o1)) {
	      if (!isDate(o2)) return false;
	      return equals(o1.getTime(), o2.getTime());
	    } else if (isRegExp(o1)) {
	      if (!isRegExp(o2)) return false;
	      return o1.toString() == o2.toString();
	    } else {
	      if (isScope(o1) || isScope(o2) || isWindow(o1) || isWindow(o2) ||
	        isArray(o2) || isDate(o2) || isRegExp(o2)) return false;
	      keySet = createMap();
	      for (key in o1) {
	        if (key.charAt(0) === '$' || isFunction(o1[key])) continue;
	        if (!equals(o1[key], o2[key])) return false;
	        keySet[key] = true;
	      }
	      for (key in o2) {
	        if (!(key in keySet) &&
	            key.charAt(0) !== '$' &&
	            isDefined(o2[key]) &&
	            !isFunction(o2[key])) return false;
	      }
	      return true;
	    }
	  }
	  return false;
	}
	
	var csp = function() {
	  if (!isDefined(csp.rules)) {
	
	
	    var ngCspElement = (window.document.querySelector('[ng-csp]') ||
	                    window.document.querySelector('[data-ng-csp]'));
	
	    if (ngCspElement) {
	      var ngCspAttribute = ngCspElement.getAttribute('ng-csp') ||
	                    ngCspElement.getAttribute('data-ng-csp');
	      csp.rules = {
	        noUnsafeEval: !ngCspAttribute || (ngCspAttribute.indexOf('no-unsafe-eval') !== -1),
	        noInlineStyle: !ngCspAttribute || (ngCspAttribute.indexOf('no-inline-style') !== -1)
	      };
	    } else {
	      csp.rules = {
	        noUnsafeEval: noUnsafeEval(),
	        noInlineStyle: false
	      };
	    }
	  }
	
	  return csp.rules;
	
	  function noUnsafeEval() {
	    try {
	      /* jshint -W031, -W054 */
	      new Function('');
	      /* jshint +W031, +W054 */
	      return false;
	    } catch (e) {
	      return true;
	    }
	  }
	};
	
	/**
	 * @ngdoc directive
	 * @module ng
	 * @name ngJq
	 *
	 * @element ANY
	 * @param {string=} ngJq the name of the library available under `window`
	 * to be used for angular.element
	 * @description
	 * Use this directive to force the angular.element library.  This should be
	 * used to force either jqLite by leaving ng-jq blank or setting the name of
	 * the jquery variable under window (eg. jQuery).
	 *
	 * Since angular looks for this directive when it is loaded (doesn't wait for the
	 * DOMContentLoaded event), it must be placed on an element that comes before the script
	 * which loads angular. Also, only the first instance of `ng-jq` will be used and all
	 * others ignored.
	 *
	 * @example
	 * This example shows how to force jqLite using the `ngJq` directive to the `html` tag.
	 ```html
	 <!doctype html>
	 <html ng-app ng-jq>
	 ...
	 ...
	 </html>
	 ```
	 * @example
	 * This example shows how to use a jQuery based library of a different name.
	 * The library name must be available at the top most 'window'.
	 ```html
	 <!doctype html>
	 <html ng-app ng-jq="jQueryLib">
	 ...
	 ...
	 </html>
	 ```
	 */
	var jq = function() {
	  if (isDefined(jq.name_)) return jq.name_;
	  var el;
	  var i, ii = ngAttrPrefixes.length, prefix, name;
	  for (i = 0; i < ii; ++i) {
	    prefix = ngAttrPrefixes[i];
	    if (el = window.document.querySelector('[' + prefix.replace(':', '\\:') + 'jq]')) {
	      name = el.getAttribute(prefix + 'jq');
	      break;
	    }
	  }
	
	  return (jq.name_ = name);
	};
	
	function concat(array1, array2, index) {
	  return array1.concat(slice.call(array2, index));
	}
	
	function sliceArgs(args, startIndex) {
	  return slice.call(args, startIndex || 0);
	}
	
	
	/* jshint -W101 */
	/**
	 * @ngdoc function
	 * @name angular.bind
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Returns a function which calls function `fn` bound to `self` (`self` becomes the `this` for
	 * `fn`). You can supply optional `args` that are prebound to the function. This feature is also
	 * known as [partial application](http://en.wikipedia.org/wiki/Partial_application), as
	 * distinguished from [function currying](http://en.wikipedia.org/wiki/Currying#Contrast_with_partial_function_application).
	 *
	 * @param {Object} self Context which `fn` should be evaluated in.
	 * @param {function()} fn Function to be bound.
	 * @param {...*} args Optional arguments to be prebound to the `fn` function call.
	 * @returns {function()} Function that wraps the `fn` with all the specified bindings.
	 */
	/* jshint +W101 */
	function bind(self, fn) {
	  var curryArgs = arguments.length > 2 ? sliceArgs(arguments, 2) : [];
	  if (isFunction(fn) && !(fn instanceof RegExp)) {
	    return curryArgs.length
	      ? function() {
	          return arguments.length
	            ? fn.apply(self, concat(curryArgs, arguments, 0))
	            : fn.apply(self, curryArgs);
	        }
	      : function() {
	          return arguments.length
	            ? fn.apply(self, arguments)
	            : fn.call(self);
	        };
	  } else {
	    // In IE, native methods are not functions so they cannot be bound (note: they don't need to be).
	    return fn;
	  }
	}
	
	
	function toJsonReplacer(key, value) {
	  var val = value;
	
	  if (typeof key === 'string' && key.charAt(0) === '$' && key.charAt(1) === '$') {
	    val = undefined;
	  } else if (isWindow(value)) {
	    val = '$WINDOW';
	  } else if (value &&  window.document === value) {
	    val = '$DOCUMENT';
	  } else if (isScope(value)) {
	    val = '$SCOPE';
	  }
	
	  return val;
	}
	
	
	/**
	 * @ngdoc function
	 * @name angular.toJson
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Serializes input into a JSON-formatted string. Properties with leading $$ characters will be
	 * stripped since angular uses this notation internally.
	 *
	 * @param {Object|Array|Date|string|number} obj Input to be serialized into JSON.
	 * @param {boolean|number} [pretty=2] If set to true, the JSON output will contain newlines and whitespace.
	 *    If set to an integer, the JSON output will contain that many spaces per indentation.
	 * @returns {string|undefined} JSON-ified string representing `obj`.
	 * @knownIssue
	 *
	 * The Safari browser throws a `RangeError` instead of returning `null` when it tries to stringify a `Date`
	 * object with an invalid date value. The only reliable way to prevent this is to monkeypatch the
	 * `Date.prototype.toJSON` method as follows:
	 *
	 * ```
	 * var _DatetoJSON = Date.prototype.toJSON;
	 * Date.prototype.toJSON = function() {
	 *   try {
	 *     return _DatetoJSON.call(this);
	 *   } catch(e) {
	 *     if (e instanceof RangeError) {
	 *       return null;
	 *     }
	 *     throw e;
	 *   }
	 * };
	 * ```
	 *
	 * See https://github.com/angular/angular.js/pull/14221 for more information.
	 */
	function toJson(obj, pretty) {
	  if (isUndefined(obj)) return undefined;
	  if (!isNumber(pretty)) {
	    pretty = pretty ? 2 : null;
	  }
	  return JSON.stringify(obj, toJsonReplacer, pretty);
	}
	
	
	/**
	 * @ngdoc function
	 * @name angular.fromJson
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Deserializes a JSON string.
	 *
	 * @param {string} json JSON string to deserialize.
	 * @returns {Object|Array|string|number} Deserialized JSON string.
	 */
	function fromJson(json) {
	  return isString(json)
	      ? JSON.parse(json)
	      : json;
	}
	
	
	var ALL_COLONS = /:/g;
	function timezoneToOffset(timezone, fallback) {
	  // IE/Edge do not "understand" colon (`:`) in timezone
	  timezone = timezone.replace(ALL_COLONS, '');
	  var requestedTimezoneOffset = Date.parse('Jan 01, 1970 00:00:00 ' + timezone) / 60000;
	  return isNaN(requestedTimezoneOffset) ? fallback : requestedTimezoneOffset;
	}
	
	
	function addDateMinutes(date, minutes) {
	  date = new Date(date.getTime());
	  date.setMinutes(date.getMinutes() + minutes);
	  return date;
	}
	
	
	function convertTimezoneToLocal(date, timezone, reverse) {
	  reverse = reverse ? -1 : 1;
	  var dateTimezoneOffset = date.getTimezoneOffset();
	  var timezoneOffset = timezoneToOffset(timezone, dateTimezoneOffset);
	  return addDateMinutes(date, reverse * (timezoneOffset - dateTimezoneOffset));
	}
	
	
	/**
	 * @returns {string} Returns the string representation of the element.
	 */
	function startingTag(element) {
	  element = jqLite(element).clone();
	  try {
	    // turns out IE does not let you set .html() on elements which
	    // are not allowed to have children. So we just ignore it.
	    element.empty();
	  } catch (e) {}
	  var elemHtml = jqLite('<div>').append(element).html();
	  try {
	    return element[0].nodeType === NODE_TYPE_TEXT ? lowercase(elemHtml) :
	        elemHtml.
	          match(/^(<[^>]+>)/)[1].
	          replace(/^<([\w\-]+)/, function(match, nodeName) {return '<' + lowercase(nodeName);});
	  } catch (e) {
	    return lowercase(elemHtml);
	  }
	
	}
	
	
	/////////////////////////////////////////////////
	
	/**
	 * Tries to decode the URI component without throwing an exception.
	 *
	 * @private
	 * @param str value potential URI component to check.
	 * @returns {boolean} True if `value` can be decoded
	 * with the decodeURIComponent function.
	 */
	function tryDecodeURIComponent(value) {
	  try {
	    return decodeURIComponent(value);
	  } catch (e) {
	    // Ignore any invalid uri component.
	  }
	}
	
	
	/**
	 * Parses an escaped url query string into key-value pairs.
	 * @returns {Object.<string,boolean|Array>}
	 */
	function parseKeyValue(/**string*/keyValue) {
	  var obj = {};
	  forEach((keyValue || "").split('&'), function(keyValue) {
	    var splitPoint, key, val;
	    if (keyValue) {
	      key = keyValue = keyValue.replace(/\+/g,'%20');
	      splitPoint = keyValue.indexOf('=');
	      if (splitPoint !== -1) {
	        key = keyValue.substring(0, splitPoint);
	        val = keyValue.substring(splitPoint + 1);
	      }
	      key = tryDecodeURIComponent(key);
	      if (isDefined(key)) {
	        val = isDefined(val) ? tryDecodeURIComponent(val) : true;
	        if (!hasOwnProperty.call(obj, key)) {
	          obj[key] = val;
	        } else if (isArray(obj[key])) {
	          obj[key].push(val);
	        } else {
	          obj[key] = [obj[key],val];
	        }
	      }
	    }
	  });
	  return obj;
	}
	
	function toKeyValue(obj) {
	  var parts = [];
	  forEach(obj, function(value, key) {
	    if (isArray(value)) {
	      forEach(value, function(arrayValue) {
	        parts.push(encodeUriQuery(key, true) +
	                   (arrayValue === true ? '' : '=' + encodeUriQuery(arrayValue, true)));
	      });
	    } else {
	    parts.push(encodeUriQuery(key, true) +
	               (value === true ? '' : '=' + encodeUriQuery(value, true)));
	    }
	  });
	  return parts.length ? parts.join('&') : '';
	}
	
	
	/**
	 * We need our custom method because encodeURIComponent is too aggressive and doesn't follow
	 * http://www.ietf.org/rfc/rfc3986.txt with regards to the character set (pchar) allowed in path
	 * segments:
	 *    segment       = *pchar
	 *    pchar         = unreserved / pct-encoded / sub-delims / ":" / "@"
	 *    pct-encoded   = "%" HEXDIG HEXDIG
	 *    unreserved    = ALPHA / DIGIT / "-" / "." / "_" / "~"
	 *    sub-delims    = "!" / "$" / "&" / "'" / "(" / ")"
	 *                     / "*" / "+" / "," / ";" / "="
	 */
	function encodeUriSegment(val) {
	  return encodeUriQuery(val, true).
	             replace(/%26/gi, '&').
	             replace(/%3D/gi, '=').
	             replace(/%2B/gi, '+');
	}
	
	
	/**
	 * This method is intended for encoding *key* or *value* parts of query component. We need a custom
	 * method because encodeURIComponent is too aggressive and encodes stuff that doesn't have to be
	 * encoded per http://tools.ietf.org/html/rfc3986:
	 *    query       = *( pchar / "/" / "?" )
	 *    pchar         = unreserved / pct-encoded / sub-delims / ":" / "@"
	 *    unreserved    = ALPHA / DIGIT / "-" / "." / "_" / "~"
	 *    pct-encoded   = "%" HEXDIG HEXDIG
	 *    sub-delims    = "!" / "$" / "&" / "'" / "(" / ")"
	 *                     / "*" / "+" / "," / ";" / "="
	 */
	function encodeUriQuery(val, pctEncodeSpaces) {
	  return encodeURIComponent(val).
	             replace(/%40/gi, '@').
	             replace(/%3A/gi, ':').
	             replace(/%24/g, '$').
	             replace(/%2C/gi, ',').
	             replace(/%3B/gi, ';').
	             replace(/%20/g, (pctEncodeSpaces ? '%20' : '+'));
	}
	
	var ngAttrPrefixes = ['ng-', 'data-ng-', 'ng:', 'x-ng-'];
	
	function getNgAttribute(element, ngAttr) {
	  var attr, i, ii = ngAttrPrefixes.length;
	  for (i = 0; i < ii; ++i) {
	    attr = ngAttrPrefixes[i] + ngAttr;
	    if (isString(attr = element.getAttribute(attr))) {
	      return attr;
	    }
	  }
	  return null;
	}
	
	/**
	 * @ngdoc directive
	 * @name ngApp
	 * @module ng
	 *
	 * @element ANY
	 * @param {angular.Module} ngApp an optional application
	 *   {@link angular.module module} name to load.
	 * @param {boolean=} ngStrictDi if this attribute is present on the app element, the injector will be
	 *   created in "strict-di" mode. This means that the application will fail to invoke functions which
	 *   do not use explicit function annotation (and are thus unsuitable for minification), as described
	 *   in {@link guide/di the Dependency Injection guide}, and useful debugging info will assist in
	 *   tracking down the root of these bugs.
	 *
	 * @description
	 *
	 * Use this directive to **auto-bootstrap** an AngularJS application. The `ngApp` directive
	 * designates the **root element** of the application and is typically placed near the root element
	 * of the page - e.g. on the `<body>` or `<html>` tags.
	 *
	 * There are a few things to keep in mind when using `ngApp`:
	 * - only one AngularJS application can be auto-bootstrapped per HTML document. The first `ngApp`
	 *   found in the document will be used to define the root element to auto-bootstrap as an
	 *   application. To run multiple applications in an HTML document you must manually bootstrap them using
	 *   {@link angular.bootstrap} instead.
	 * - AngularJS applications cannot be nested within each other.
	 * - Do not use a directive that uses {@link ng.$compile#transclusion transclusion} on the same element as `ngApp`.
	 *   This includes directives such as {@link ng.ngIf `ngIf`}, {@link ng.ngInclude `ngInclude`} and
	 *   {@link ngRoute.ngView `ngView`}.
	 *   Doing this misplaces the app {@link ng.$rootElement `$rootElement`} and the app's {@link auto.$injector injector},
	 *   causing animations to stop working and making the injector inaccessible from outside the app.
	 *
	 * You can specify an **AngularJS module** to be used as the root module for the application.  This
	 * module will be loaded into the {@link auto.$injector} when the application is bootstrapped. It
	 * should contain the application code needed or have dependencies on other modules that will
	 * contain the code. See {@link angular.module} for more information.
	 *
	 * In the example below if the `ngApp` directive were not placed on the `html` element then the
	 * document would not be compiled, the `AppController` would not be instantiated and the `{{ a+b }}`
	 * would not be resolved to `3`.
	 *
	 * `ngApp` is the easiest, and most common way to bootstrap an application.
	 *
	 <example module="ngAppDemo">
	   <file name="index.html">
	   <div ng-controller="ngAppDemoController">
	     I can add: {{a}} + {{b}} =  {{ a+b }}
	   </div>
	   </file>
	   <file name="script.js">
	   angular.module('ngAppDemo', []).controller('ngAppDemoController', function($scope) {
	     $scope.a = 1;
	     $scope.b = 2;
	   });
	   </file>
	 </example>
	 *
	 * Using `ngStrictDi`, you would see something like this:
	 *
	 <example ng-app-included="true">
	   <file name="index.html">
	   <div ng-app="ngAppStrictDemo" ng-strict-di>
	       <div ng-controller="GoodController1">
	           I can add: {{a}} + {{b}} =  {{ a+b }}
	
	           <p>This renders because the controller does not fail to
	              instantiate, by using explicit annotation style (see
	              script.js for details)
	           </p>
	       </div>
	
	       <div ng-controller="GoodController2">
	           Name: <input ng-model="name"><br />
	           Hello, {{name}}!
	
	           <p>This renders because the controller does not fail to
	              instantiate, by using explicit annotation style
	              (see script.js for details)
	           </p>
	       </div>
	
	       <div ng-controller="BadController">
	           I can add: {{a}} + {{b}} =  {{ a+b }}
	
	           <p>The controller could not be instantiated, due to relying
	              on automatic function annotations (which are disabled in
	              strict mode). As such, the content of this section is not
	              interpolated, and there should be an error in your web console.
	           </p>
	       </div>
	   </div>
	   </file>
	   <file name="script.js">
	   angular.module('ngAppStrictDemo', [])
	     // BadController will fail to instantiate, due to relying on automatic function annotation,
	     // rather than an explicit annotation
	     .controller('BadController', function($scope) {
	       $scope.a = 1;
	       $scope.b = 2;
	     })
	     // Unlike BadController, GoodController1 and GoodController2 will not fail to be instantiated,
	     // due to using explicit annotations using the array style and $inject property, respectively.
	     .controller('GoodController1', ['$scope', function($scope) {
	       $scope.a = 1;
	       $scope.b = 2;
	     }])
	     .controller('GoodController2', GoodController2);
	     function GoodController2($scope) {
	       $scope.name = "World";
	     }
	     GoodController2.$inject = ['$scope'];
	   </file>
	   <file name="style.css">
	   div[ng-controller] {
	       margin-bottom: 1em;
	       -webkit-border-radius: 4px;
	       border-radius: 4px;
	       border: 1px solid;
	       padding: .5em;
	   }
	   div[ng-controller^=Good] {
	       border-color: #d6e9c6;
	       background-color: #dff0d8;
	       color: #3c763d;
	   }
	   div[ng-controller^=Bad] {
	       border-color: #ebccd1;
	       background-color: #f2dede;
	       color: #a94442;
	       margin-bottom: 0;
	   }
	   </file>
	 </example>
	 */
	function angularInit(element, bootstrap) {
	  var appElement,
	      module,
	      config = {};
	
	  // The element `element` has priority over any other element.
	  forEach(ngAttrPrefixes, function(prefix) {
	    var name = prefix + 'app';
	
	    if (!appElement && element.hasAttribute && element.hasAttribute(name)) {
	      appElement = element;
	      module = element.getAttribute(name);
	    }
	  });
	  forEach(ngAttrPrefixes, function(prefix) {
	    var name = prefix + 'app';
	    var candidate;
	
	    if (!appElement && (candidate = element.querySelector('[' + name.replace(':', '\\:') + ']'))) {
	      appElement = candidate;
	      module = candidate.getAttribute(name);
	    }
	  });
	  if (appElement) {
	    config.strictDi = getNgAttribute(appElement, "strict-di") !== null;
	    bootstrap(appElement, module ? [module] : [], config);
	  }
	}
	
	/**
	 * @ngdoc function
	 * @name angular.bootstrap
	 * @module ng
	 * @description
	 * Use this function to manually start up angular application.
	 *
	 * For more information, see the {@link guide/bootstrap Bootstrap guide}.
	 *
	 * Angular will detect if it has been loaded into the browser more than once and only allow the
	 * first loaded script to be bootstrapped and will report a warning to the browser console for
	 * each of the subsequent scripts. This prevents strange results in applications, where otherwise
	 * multiple instances of Angular try to work on the DOM.
	 *
	 * <div class="alert alert-warning">
	 * **Note:** Protractor based end-to-end tests cannot use this function to bootstrap manually.
	 * They must use {@link ng.directive:ngApp ngApp}.
	 * </div>
	 *
	 * <div class="alert alert-warning">
	 * **Note:** Do not bootstrap the app on an element with a directive that uses {@link ng.$compile#transclusion transclusion},
	 * such as {@link ng.ngIf `ngIf`}, {@link ng.ngInclude `ngInclude`} and {@link ngRoute.ngView `ngView`}.
	 * Doing this misplaces the app {@link ng.$rootElement `$rootElement`} and the app's {@link auto.$injector injector},
	 * causing animations to stop working and making the injector inaccessible from outside the app.
	 * </div>
	 *
	 * ```html
	 * <!doctype html>
	 * <html>
	 * <body>
	 * <div ng-controller="WelcomeController">
	 *   {{greeting}}
	 * </div>
	 *
	 * <script src="angular.js"></script>
	 * <script>
	 *   var app = angular.module('demo', [])
	 *   .controller('WelcomeController', function($scope) {
	 *       $scope.greeting = 'Welcome!';
	 *   });
	 *   angular.bootstrap(document, ['demo']);
	 * </script>
	 * </body>
	 * </html>
	 * ```
	 *
	 * @param {DOMElement} element DOM element which is the root of angular application.
	 * @param {Array<String|Function|Array>=} modules an array of modules to load into the application.
	 *     Each item in the array should be the name of a predefined module or a (DI annotated)
	 *     function that will be invoked by the injector as a `config` block.
	 *     See: {@link angular.module modules}
	 * @param {Object=} config an object for defining configuration options for the application. The
	 *     following keys are supported:
	 *
	 * * `strictDi` - disable automatic function annotation for the application. This is meant to
	 *   assist in finding bugs which break minified code. Defaults to `false`.
	 *
	 * @returns {auto.$injector} Returns the newly created injector for this app.
	 */
	function bootstrap(element, modules, config) {
	  if (!isObject(config)) config = {};
	  var defaultConfig = {
	    strictDi: false
	  };
	  config = extend(defaultConfig, config);
	  var doBootstrap = function() {
	    element = jqLite(element);
	
	    if (element.injector()) {
	      var tag = (element[0] === window.document) ? 'document' : startingTag(element);
	      // Encode angle brackets to prevent input from being sanitized to empty string #8683.
	      throw ngMinErr(
	          'btstrpd',
	          "App already bootstrapped with this element '{0}'",
	          tag.replace(/</,'&lt;').replace(/>/,'&gt;'));
	    }
	
	    modules = modules || [];
	    modules.unshift(['$provide', function($provide) {
	      $provide.value('$rootElement', element);
	    }]);
	
	    if (config.debugInfoEnabled) {
	      // Pushing so that this overrides `debugInfoEnabled` setting defined in user's `modules`.
	      modules.push(['$compileProvider', function($compileProvider) {
	        $compileProvider.debugInfoEnabled(true);
	      }]);
	    }
	
	    modules.unshift('ng');
	    var injector = createInjector(modules, config.strictDi);
	    injector.invoke(['$rootScope', '$rootElement', '$compile', '$injector',
	       function bootstrapApply(scope, element, compile, injector) {
	        scope.$apply(function() {
	          element.data('$injector', injector);
	          compile(element)(scope);
	        });
	      }]
	    );
	    return injector;
	  };
	
	  var NG_ENABLE_DEBUG_INFO = /^NG_ENABLE_DEBUG_INFO!/;
	  var NG_DEFER_BOOTSTRAP = /^NG_DEFER_BOOTSTRAP!/;
	
	  if (window && NG_ENABLE_DEBUG_INFO.test(window.name)) {
	    config.debugInfoEnabled = true;
	    window.name = window.name.replace(NG_ENABLE_DEBUG_INFO, '');
	  }
	
	  if (window && !NG_DEFER_BOOTSTRAP.test(window.name)) {
	    return doBootstrap();
	  }
	
	  window.name = window.name.replace(NG_DEFER_BOOTSTRAP, '');
	  angular.resumeBootstrap = function(extraModules) {
	    forEach(extraModules, function(module) {
	      modules.push(module);
	    });
	    return doBootstrap();
	  };
	
	  if (isFunction(angular.resumeDeferredBootstrap)) {
	    angular.resumeDeferredBootstrap();
	  }
	}
	
	/**
	 * @ngdoc function
	 * @name angular.reloadWithDebugInfo
	 * @module ng
	 * @description
	 * Use this function to reload the current application with debug information turned on.
	 * This takes precedence over a call to `$compileProvider.debugInfoEnabled(false)`.
	 *
	 * See {@link ng.$compileProvider#debugInfoEnabled} for more.
	 */
	function reloadWithDebugInfo() {
	  window.name = 'NG_ENABLE_DEBUG_INFO!' + window.name;
	  window.location.reload();
	}
	
	/**
	 * @name angular.getTestability
	 * @module ng
	 * @description
	 * Get the testability service for the instance of Angular on the given
	 * element.
	 * @param {DOMElement} element DOM element which is the root of angular application.
	 */
	function getTestability(rootElement) {
	  var injector = angular.element(rootElement).injector();
	  if (!injector) {
	    throw ngMinErr('test',
	      'no injector found for element argument to getTestability');
	  }
	  return injector.get('$$testability');
	}
	
	var SNAKE_CASE_REGEXP = /[A-Z]/g;
	function snake_case(name, separator) {
	  separator = separator || '_';
	  return name.replace(SNAKE_CASE_REGEXP, function(letter, pos) {
	    return (pos ? separator : '') + letter.toLowerCase();
	  });
	}
	
	var bindJQueryFired = false;
	function bindJQuery() {
	  var originalCleanData;
	
	  if (bindJQueryFired) {
	    return;
	  }
	
	  // bind to jQuery if present;
	  var jqName = jq();
	  jQuery = isUndefined(jqName) ? window.jQuery :   // use jQuery (if present)
	           !jqName             ? undefined     :   // use jqLite
	                                 window[jqName];   // use jQuery specified by `ngJq`
	
	  // Use jQuery if it exists with proper functionality, otherwise default to us.
	  // Angular 1.2+ requires jQuery 1.7+ for on()/off() support.
	  // Angular 1.3+ technically requires at least jQuery 2.1+ but it may work with older
	  // versions. It will not work for sure with jQuery <1.7, though.
	  if (jQuery && jQuery.fn.on) {
	    jqLite = jQuery;
	    extend(jQuery.fn, {
	      scope: JQLitePrototype.scope,
	      isolateScope: JQLitePrototype.isolateScope,
	      controller: JQLitePrototype.controller,
	      injector: JQLitePrototype.injector,
	      inheritedData: JQLitePrototype.inheritedData
	    });
	
	    // All nodes removed from the DOM via various jQuery APIs like .remove()
	    // are passed through jQuery.cleanData. Monkey-patch this method to fire
	    // the $destroy event on all removed nodes.
	    originalCleanData = jQuery.cleanData;
	    jQuery.cleanData = function(elems) {
	      var events;
	      for (var i = 0, elem; (elem = elems[i]) != null; i++) {
	        events = jQuery._data(elem, "events");
	        if (events && events.$destroy) {
	          jQuery(elem).triggerHandler('$destroy');
	        }
	      }
	      originalCleanData(elems);
	    };
	  } else {
	    jqLite = JQLite;
	  }
	
	  angular.element = jqLite;
	
	  // Prevent double-proxying.
	  bindJQueryFired = true;
	}
	
	/**
	 * throw error if the argument is falsy.
	 */
	function assertArg(arg, name, reason) {
	  if (!arg) {
	    throw ngMinErr('areq', "Argument '{0}' is {1}", (name || '?'), (reason || "required"));
	  }
	  return arg;
	}
	
	function assertArgFn(arg, name, acceptArrayAnnotation) {
	  if (acceptArrayAnnotation && isArray(arg)) {
	      arg = arg[arg.length - 1];
	  }
	
	  assertArg(isFunction(arg), name, 'not a function, got ' +
	      (arg && typeof arg === 'object' ? arg.constructor.name || 'Object' : typeof arg));
	  return arg;
	}
	
	/**
	 * throw error if the name given is hasOwnProperty
	 * @param  {String} name    the name to test
	 * @param  {String} context the context in which the name is used, such as module or directive
	 */
	function assertNotHasOwnProperty(name, context) {
	  if (name === 'hasOwnProperty') {
	    throw ngMinErr('badname', "hasOwnProperty is not a valid {0} name", context);
	  }
	}
	
	/**
	 * Return the value accessible from the object by path. Any undefined traversals are ignored
	 * @param {Object} obj starting object
	 * @param {String} path path to traverse
	 * @param {boolean} [bindFnToScope=true]
	 * @returns {Object} value as accessible by path
	 */
	//TODO(misko): this function needs to be removed
	function getter(obj, path, bindFnToScope) {
	  if (!path) return obj;
	  var keys = path.split('.');
	  var key;
	  var lastInstance = obj;
	  var len = keys.length;
	
	  for (var i = 0; i < len; i++) {
	    key = keys[i];
	    if (obj) {
	      obj = (lastInstance = obj)[key];
	    }
	  }
	  if (!bindFnToScope && isFunction(obj)) {
	    return bind(lastInstance, obj);
	  }
	  return obj;
	}
	
	/**
	 * Return the DOM siblings between the first and last node in the given array.
	 * @param {Array} array like object
	 * @returns {Array} the inputted object or a jqLite collection containing the nodes
	 */
	function getBlockNodes(nodes) {
	  // TODO(perf): update `nodes` instead of creating a new object?
	  var node = nodes[0];
	  var endNode = nodes[nodes.length - 1];
	  var blockNodes;
	
	  for (var i = 1; node !== endNode && (node = node.nextSibling); i++) {
	    if (blockNodes || nodes[i] !== node) {
	      if (!blockNodes) {
	        blockNodes = jqLite(slice.call(nodes, 0, i));
	      }
	      blockNodes.push(node);
	    }
	  }
	
	  return blockNodes || nodes;
	}
	
	
	/**
	 * Creates a new object without a prototype. This object is useful for lookup without having to
	 * guard against prototypically inherited properties via hasOwnProperty.
	 *
	 * Related micro-benchmarks:
	 * - http://jsperf.com/object-create2
	 * - http://jsperf.com/proto-map-lookup/2
	 * - http://jsperf.com/for-in-vs-object-keys2
	 *
	 * @returns {Object}
	 */
	function createMap() {
	  return Object.create(null);
	}
	
	var NODE_TYPE_ELEMENT = 1;
	var NODE_TYPE_ATTRIBUTE = 2;
	var NODE_TYPE_TEXT = 3;
	var NODE_TYPE_COMMENT = 8;
	var NODE_TYPE_DOCUMENT = 9;
	var NODE_TYPE_DOCUMENT_FRAGMENT = 11;
	
	/**
	 * @ngdoc type
	 * @name angular.Module
	 * @module ng
	 * @description
	 *
	 * Interface for configuring angular {@link angular.module modules}.
	 */
	
	function setupModuleLoader(window) {
	
	  var $injectorMinErr = minErr('$injector');
	  var ngMinErr = minErr('ng');
	
	  function ensure(obj, name, factory) {
	    return obj[name] || (obj[name] = factory());
	  }
	
	  var angular = ensure(window, 'angular', Object);
	
	  // We need to expose `angular.$$minErr` to modules such as `ngResource` that reference it during bootstrap
	  angular.$$minErr = angular.$$minErr || minErr;
	
	  return ensure(angular, 'module', function() {
	    /** @type {Object.<string, angular.Module>} */
	    var modules = {};
	
	    /**
	     * @ngdoc function
	     * @name angular.module
	     * @module ng
	     * @description
	     *
	     * The `angular.module` is a global place for creating, registering and retrieving Angular
	     * modules.
	     * All modules (angular core or 3rd party) that should be available to an application must be
	     * registered using this mechanism.
	     *
	     * Passing one argument retrieves an existing {@link angular.Module},
	     * whereas passing more than one argument creates a new {@link angular.Module}
	     *
	     *
	     * # Module
	     *
	     * A module is a collection of services, directives, controllers, filters, and configuration information.
	     * `angular.module` is used to configure the {@link auto.$injector $injector}.
	     *
	     * ```js
	     * // Create a new module
	     * var myModule = angular.module('myModule', []);
	     *
	     * // register a new service
	     * myModule.value('appName', 'MyCoolApp');
	     *
	     * // configure existing services inside initialization blocks.
	     * myModule.config(['$locationProvider', function($locationProvider) {
	     *   // Configure existing providers
	     *   $locationProvider.hashPrefix('!');
	     * }]);
	     * ```
	     *
	     * Then you can create an injector and load your modules like this:
	     *
	     * ```js
	     * var injector = angular.injector(['ng', 'myModule'])
	     * ```
	     *
	     * However it's more likely that you'll just use
	     * {@link ng.directive:ngApp ngApp} or
	     * {@link angular.bootstrap} to simplify this process for you.
	     *
	     * @param {!string} name The name of the module to create or retrieve.
	     * @param {!Array.<string>=} requires If specified then new module is being created. If
	     *        unspecified then the module is being retrieved for further configuration.
	     * @param {Function=} configFn Optional configuration function for the module. Same as
	     *        {@link angular.Module#config Module#config()}.
	     * @returns {angular.Module} new module with the {@link angular.Module} api.
	     */
	    return function module(name, requires, configFn) {
	      var assertNotHasOwnProperty = function(name, context) {
	        if (name === 'hasOwnProperty') {
	          throw ngMinErr('badname', 'hasOwnProperty is not a valid {0} name', context);
	        }
	      };
	
	      assertNotHasOwnProperty(name, 'module');
	      if (requires && modules.hasOwnProperty(name)) {
	        modules[name] = null;
	      }
	      return ensure(modules, name, function() {
	        if (!requires) {
	          throw $injectorMinErr('nomod', "Module '{0}' is not available! You either misspelled " +
	             "the module name or forgot to load it. If registering a module ensure that you " +
	             "specify the dependencies as the second argument.", name);
	        }
	
	        /** @type {!Array.<Array.<*>>} */
	        var invokeQueue = [];
	
	        /** @type {!Array.<Function>} */
	        var configBlocks = [];
	
	        /** @type {!Array.<Function>} */
	        var runBlocks = [];
	
	        var config = invokeLater('$injector', 'invoke', 'push', configBlocks);
	
	        /** @type {angular.Module} */
	        var moduleInstance = {
	          // Private state
	          _invokeQueue: invokeQueue,
	          _configBlocks: configBlocks,
	          _runBlocks: runBlocks,
	
	          /**
	           * @ngdoc property
	           * @name angular.Module#requires
	           * @module ng
	           *
	           * @description
	           * Holds the list of modules which the injector will load before the current module is
	           * loaded.
	           */
	          requires: requires,
	
	          /**
	           * @ngdoc property
	           * @name angular.Module#name
	           * @module ng
	           *
	           * @description
	           * Name of the module.
	           */
	          name: name,
	
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#provider
	           * @module ng
	           * @param {string} name service name
	           * @param {Function} providerType Construction function for creating new instance of the
	           *                                service.
	           * @description
	           * See {@link auto.$provide#provider $provide.provider()}.
	           */
	          provider: invokeLaterAndSetModuleName('$provide', 'provider'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#factory
	           * @module ng
	           * @param {string} name service name
	           * @param {Function} providerFunction Function for creating new instance of the service.
	           * @description
	           * See {@link auto.$provide#factory $provide.factory()}.
	           */
	          factory: invokeLaterAndSetModuleName('$provide', 'factory'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#service
	           * @module ng
	           * @param {string} name service name
	           * @param {Function} constructor A constructor function that will be instantiated.
	           * @description
	           * See {@link auto.$provide#service $provide.service()}.
	           */
	          service: invokeLaterAndSetModuleName('$provide', 'service'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#value
	           * @module ng
	           * @param {string} name service name
	           * @param {*} object Service instance object.
	           * @description
	           * See {@link auto.$provide#value $provide.value()}.
	           */
	          value: invokeLater('$provide', 'value'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#constant
	           * @module ng
	           * @param {string} name constant name
	           * @param {*} object Constant value.
	           * @description
	           * Because the constants are fixed, they get applied before other provide methods.
	           * See {@link auto.$provide#constant $provide.constant()}.
	           */
	          constant: invokeLater('$provide', 'constant', 'unshift'),
	
	           /**
	           * @ngdoc method
	           * @name angular.Module#decorator
	           * @module ng
	           * @param {string} name The name of the service to decorate.
	           * @param {Function} decorFn This function will be invoked when the service needs to be
	           *                           instantiated and should return the decorated service instance.
	           * @description
	           * See {@link auto.$provide#decorator $provide.decorator()}.
	           */
	          decorator: invokeLaterAndSetModuleName('$provide', 'decorator'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#animation
	           * @module ng
	           * @param {string} name animation name
	           * @param {Function} animationFactory Factory function for creating new instance of an
	           *                                    animation.
	           * @description
	           *
	           * **NOTE**: animations take effect only if the **ngAnimate** module is loaded.
	           *
	           *
	           * Defines an animation hook that can be later used with
	           * {@link $animate $animate} service and directives that use this service.
	           *
	           * ```js
	           * module.animation('.animation-name', function($inject1, $inject2) {
	           *   return {
	           *     eventName : function(element, done) {
	           *       //code to run the animation
	           *       //once complete, then run done()
	           *       return function cancellationFunction(element) {
	           *         //code to cancel the animation
	           *       }
	           *     }
	           *   }
	           * })
	           * ```
	           *
	           * See {@link ng.$animateProvider#register $animateProvider.register()} and
	           * {@link ngAnimate ngAnimate module} for more information.
	           */
	          animation: invokeLaterAndSetModuleName('$animateProvider', 'register'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#filter
	           * @module ng
	           * @param {string} name Filter name - this must be a valid angular expression identifier
	           * @param {Function} filterFactory Factory function for creating new instance of filter.
	           * @description
	           * See {@link ng.$filterProvider#register $filterProvider.register()}.
	           *
	           * <div class="alert alert-warning">
	           * **Note:** Filter names must be valid angular {@link expression} identifiers, such as `uppercase` or `orderBy`.
	           * Names with special characters, such as hyphens and dots, are not allowed. If you wish to namespace
	           * your filters, then you can use capitalization (`myappSubsectionFilterx`) or underscores
	           * (`myapp_subsection_filterx`).
	           * </div>
	           */
	          filter: invokeLaterAndSetModuleName('$filterProvider', 'register'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#controller
	           * @module ng
	           * @param {string|Object} name Controller name, or an object map of controllers where the
	           *    keys are the names and the values are the constructors.
	           * @param {Function} constructor Controller constructor function.
	           * @description
	           * See {@link ng.$controllerProvider#register $controllerProvider.register()}.
	           */
	          controller: invokeLaterAndSetModuleName('$controllerProvider', 'register'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#directive
	           * @module ng
	           * @param {string|Object} name Directive name, or an object map of directives where the
	           *    keys are the names and the values are the factories.
	           * @param {Function} directiveFactory Factory function for creating new instance of
	           * directives.
	           * @description
	           * See {@link ng.$compileProvider#directive $compileProvider.directive()}.
	           */
	          directive: invokeLaterAndSetModuleName('$compileProvider', 'directive'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#component
	           * @module ng
	           * @param {string} name Name of the component in camel-case (i.e. myComp which will match as my-comp)
	           * @param {Object} options Component definition object (a simplified
	           *    {@link ng.$compile#directive-definition-object directive definition object})
	           *
	           * @description
	           * See {@link ng.$compileProvider#component $compileProvider.component()}.
	           */
	          component: invokeLaterAndSetModuleName('$compileProvider', 'component'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#config
	           * @module ng
	           * @param {Function} configFn Execute this function on module load. Useful for service
	           *    configuration.
	           * @description
	           * Use this method to register work which needs to be performed on module loading.
	           * For more about how to configure services, see
	           * {@link providers#provider-recipe Provider Recipe}.
	           */
	          config: config,
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#run
	           * @module ng
	           * @param {Function} initializationFn Execute this function after injector creation.
	           *    Useful for application initialization.
	           * @description
	           * Use this method to register work which should be performed when the injector is done
	           * loading all modules.
	           */
	          run: function(block) {
	            runBlocks.push(block);
	            return this;
	          }
	        };
	
	        if (configFn) {
	          config(configFn);
	        }
	
	        return moduleInstance;
	
	        /**
	         * @param {string} provider
	         * @param {string} method
	         * @param {String=} insertMethod
	         * @returns {angular.Module}
	         */
	        function invokeLater(provider, method, insertMethod, queue) {
	          if (!queue) queue = invokeQueue;
	          return function() {
	            queue[insertMethod || 'push']([provider, method, arguments]);
	            return moduleInstance;
	          };
	        }
	
	        /**
	         * @param {string} provider
	         * @param {string} method
	         * @returns {angular.Module}
	         */
	        function invokeLaterAndSetModuleName(provider, method) {
	          return function(recipeName, factoryFunction) {
	            if (factoryFunction && isFunction(factoryFunction)) factoryFunction.$$moduleName = name;
	            invokeQueue.push([provider, method, arguments]);
	            return moduleInstance;
	          };
	        }
	      });
	    };
	  });
	
	}
	
	/* global: toDebugString: true */
	
	function serializeObject(obj) {
	  var seen = [];
	
	  return JSON.stringify(obj, function(key, val) {
	    val = toJsonReplacer(key, val);
	    if (isObject(val)) {
	
	      if (seen.indexOf(val) >= 0) return '...';
	
	      seen.push(val);
	    }
	    return val;
	  });
	}
	
	function toDebugString(obj) {
	  if (typeof obj === 'function') {
	    return obj.toString().replace(/ \{[\s\S]*$/, '');
	  } else if (isUndefined(obj)) {
	    return 'undefined';
	  } else if (typeof obj !== 'string') {
	    return serializeObject(obj);
	  }
	  return obj;
	}
	
	/* global angularModule: true,
	  version: true,
	
	  $CompileProvider,
	
	  htmlAnchorDirective,
	  inputDirective,
	  inputDirective,
	  formDirective,
	  scriptDirective,
	  selectDirective,
	  styleDirective,
	  optionDirective,
	  ngBindDirective,
	  ngBindHtmlDirective,
	  ngBindTemplateDirective,
	  ngClassDirective,
	  ngClassEvenDirective,
	  ngClassOddDirective,
	  ngCloakDirective,
	  ngControllerDirective,
	  ngFormDirective,
	  ngHideDirective,
	  ngIfDirective,
	  ngIncludeDirective,
	  ngIncludeFillContentDirective,
	  ngInitDirective,
	  ngNonBindableDirective,
	  ngPluralizeDirective,
	  ngRepeatDirective,
	  ngShowDirective,
	  ngStyleDirective,
	  ngSwitchDirective,
	  ngSwitchWhenDirective,
	  ngSwitchDefaultDirective,
	  ngOptionsDirective,
	  ngTranscludeDirective,
	  ngModelDirective,
	  ngListDirective,
	  ngChangeDirective,
	  patternDirective,
	  patternDirective,
	  requiredDirective,
	  requiredDirective,
	  minlengthDirective,
	  minlengthDirective,
	  maxlengthDirective,
	  maxlengthDirective,
	  ngValueDirective,
	  ngModelOptionsDirective,
	  ngAttributeAliasDirectives,
	  ngEventDirectives,
	
	  $AnchorScrollProvider,
	  $AnimateProvider,
	  $CoreAnimateCssProvider,
	  $$CoreAnimateJsProvider,
	  $$CoreAnimateQueueProvider,
	  $$AnimateRunnerFactoryProvider,
	  $$AnimateAsyncRunFactoryProvider,
	  $BrowserProvider,
	  $CacheFactoryProvider,
	  $ControllerProvider,
	  $DateProvider,
	  $DocumentProvider,
	  $ExceptionHandlerProvider,
	  $FilterProvider,
	  $$ForceReflowProvider,
	  $InterpolateProvider,
	  $IntervalProvider,
	  $$HashMapProvider,
	  $HttpProvider,
	  $HttpParamSerializerProvider,
	  $HttpParamSerializerJQLikeProvider,
	  $HttpBackendProvider,
	  $xhrFactoryProvider,
	  $LocationProvider,
	  $LogProvider,
	  $ParseProvider,
	  $RootScopeProvider,
	  $QProvider,
	  $$QProvider,
	  $$SanitizeUriProvider,
	  $SceProvider,
	  $SceDelegateProvider,
	  $SnifferProvider,
	  $TemplateCacheProvider,
	  $TemplateRequestProvider,
	  $$TestabilityProvider,
	  $TimeoutProvider,
	  $$RAFProvider,
	  $WindowProvider,
	  $$jqLiteProvider,
	  $$CookieReaderProvider
	*/
	
	
	/**
	 * @ngdoc object
	 * @name angular.version
	 * @module ng
	 * @description
	 * An object that contains information about the current AngularJS version.
	 *
	 * This object has the following properties:
	 *
	 * - `full` – `{string}` – Full version string, such as "0.9.18".
	 * - `major` – `{number}` – Major version number, such as "0".
	 * - `minor` – `{number}` – Minor version number, such as "9".
	 * - `dot` – `{number}` – Dot version number, such as "18".
	 * - `codeName` – `{string}` – Code name of the release, such as "jiggling-armfat".
	 */
	var version = {
	  full: '1.5.6',    // all of these placeholder strings will be replaced by grunt's
	  major: 1,    // package task
	  minor: 5,
	  dot: 6,
	  codeName: 'arrow-stringification'
	};
	
	
	function publishExternalAPI(angular) {
	  extend(angular, {
	    'bootstrap': bootstrap,
	    'copy': copy,
	    'extend': extend,
	    'merge': merge,
	    'equals': equals,
	    'element': jqLite,
	    'forEach': forEach,
	    'injector': createInjector,
	    'noop': noop,
	    'bind': bind,
	    'toJson': toJson,
	    'fromJson': fromJson,
	    'identity': identity,
	    'isUndefined': isUndefined,
	    'isDefined': isDefined,
	    'isString': isString,
	    'isFunction': isFunction,
	    'isObject': isObject,
	    'isNumber': isNumber,
	    'isElement': isElement,
	    'isArray': isArray,
	    'version': version,
	    'isDate': isDate,
	    'lowercase': lowercase,
	    'uppercase': uppercase,
	    'callbacks': {counter: 0},
	    'getTestability': getTestability,
	    '$$minErr': minErr,
	    '$$csp': csp,
	    'reloadWithDebugInfo': reloadWithDebugInfo
	  });
	
	  angularModule = setupModuleLoader(window);
	
	  angularModule('ng', ['ngLocale'], ['$provide',
	    function ngModule($provide) {
	      // $$sanitizeUriProvider needs to be before $compileProvider as it is used by it.
	      $provide.provider({
	        $$sanitizeUri: $$SanitizeUriProvider
	      });
	      $provide.provider('$compile', $CompileProvider).
	        directive({
	            a: htmlAnchorDirective,
	            input: inputDirective,
	            textarea: inputDirective,
	            form: formDirective,
	            script: scriptDirective,
	            select: selectDirective,
	            style: styleDirective,
	            option: optionDirective,
	            ngBind: ngBindDirective,
	            ngBindHtml: ngBindHtmlDirective,
	            ngBindTemplate: ngBindTemplateDirective,
	            ngClass: ngClassDirective,
	            ngClassEven: ngClassEvenDirective,
	            ngClassOdd: ngClassOddDirective,
	            ngCloak: ngCloakDirective,
	            ngController: ngControllerDirective,
	            ngForm: ngFormDirective,
	            ngHide: ngHideDirective,
	            ngIf: ngIfDirective,
	            ngInclude: ngIncludeDirective,
	            ngInit: ngInitDirective,
	            ngNonBindable: ngNonBindableDirective,
	            ngPluralize: ngPluralizeDirective,
	            ngRepeat: ngRepeatDirective,
	            ngShow: ngShowDirective,
	            ngStyle: ngStyleDirective,
	            ngSwitch: ngSwitchDirective,
	            ngSwitchWhen: ngSwitchWhenDirective,
	            ngSwitchDefault: ngSwitchDefaultDirective,
	            ngOptions: ngOptionsDirective,
	            ngTransclude: ngTranscludeDirective,
	            ngModel: ngModelDirective,
	            ngList: ngListDirective,
	            ngChange: ngChangeDirective,
	            pattern: patternDirective,
	            ngPattern: patternDirective,
	            required: requiredDirective,
	            ngRequired: requiredDirective,
	            minlength: minlengthDirective,
	            ngMinlength: minlengthDirective,
	            maxlength: maxlengthDirective,
	            ngMaxlength: maxlengthDirective,
	            ngValue: ngValueDirective,
	            ngModelOptions: ngModelOptionsDirective
	        }).
	        directive({
	          ngInclude: ngIncludeFillContentDirective
	        }).
	        directive(ngAttributeAliasDirectives).
	        directive(ngEventDirectives);
	      $provide.provider({
	        $anchorScroll: $AnchorScrollProvider,
	        $animate: $AnimateProvider,
	        $animateCss: $CoreAnimateCssProvider,
	        $$animateJs: $$CoreAnimateJsProvider,
	        $$animateQueue: $$CoreAnimateQueueProvider,
	        $$AnimateRunner: $$AnimateRunnerFactoryProvider,
	        $$animateAsyncRun: $$AnimateAsyncRunFactoryProvider,
	        $browser: $BrowserProvider,
	        $cacheFactory: $CacheFactoryProvider,
	        $controller: $ControllerProvider,
	        $document: $DocumentProvider,
	        $exceptionHandler: $ExceptionHandlerProvider,
	        $filter: $FilterProvider,
	        $$forceReflow: $$ForceReflowProvider,
	        $interpolate: $InterpolateProvider,
	        $interval: $IntervalProvider,
	        $http: $HttpProvider,
	        $httpParamSerializer: $HttpParamSerializerProvider,
	        $httpParamSerializerJQLike: $HttpParamSerializerJQLikeProvider,
	        $httpBackend: $HttpBackendProvider,
	        $xhrFactory: $xhrFactoryProvider,
	        $location: $LocationProvider,
	        $log: $LogProvider,
	        $parse: $ParseProvider,
	        $rootScope: $RootScopeProvider,
	        $q: $QProvider,
	        $$q: $$QProvider,
	        $sce: $SceProvider,
	        $sceDelegate: $SceDelegateProvider,
	        $sniffer: $SnifferProvider,
	        $templateCache: $TemplateCacheProvider,
	        $templateRequest: $TemplateRequestProvider,
	        $$testability: $$TestabilityProvider,
	        $timeout: $TimeoutProvider,
	        $window: $WindowProvider,
	        $$rAF: $$RAFProvider,
	        $$jqLite: $$jqLiteProvider,
	        $$HashMap: $$HashMapProvider,
	        $$cookieReader: $$CookieReaderProvider
	      });
	    }
	  ]);
	}
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 *     Any commits to this file should be reviewed with security in mind.  *
	 *   Changes to this file can potentially create security vulnerabilities. *
	 *          An approval from 2 Core members with history of modifying      *
	 *                         this file is required.                          *
	 *                                                                         *
	 *  Does the change somehow allow for arbitrary javascript to be executed? *
	 *    Or allows for someone to change the prototype of built-in objects?   *
	 *     Or gives undesired access to variables likes document or window?    *
	 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */
	
	/* global JQLitePrototype: true,
	  addEventListenerFn: true,
	  removeEventListenerFn: true,
	  BOOLEAN_ATTR: true,
	  ALIASED_ATTR: true,
	*/
	
	//////////////////////////////////
	//JQLite
	//////////////////////////////////
	
	/**
	 * @ngdoc function
	 * @name angular.element
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Wraps a raw DOM element or HTML string as a [jQuery](http://jquery.com) element.
	 *
	 * If jQuery is available, `angular.element` is an alias for the
	 * [jQuery](http://api.jquery.com/jQuery/) function. If jQuery is not available, `angular.element`
	 * delegates to Angular's built-in subset of jQuery, called "jQuery lite" or **jqLite**.
	 *
	 * jqLite is a tiny, API-compatible subset of jQuery that allows
	 * Angular to manipulate the DOM in a cross-browser compatible way. jqLite implements only the most
	 * commonly needed functionality with the goal of having a very small footprint.
	 *
	 * To use `jQuery`, simply ensure it is loaded before the `angular.js` file. You can also use the
	 * {@link ngJq `ngJq`} directive to specify that jqlite should be used over jQuery, or to use a
	 * specific version of jQuery if multiple versions exist on the page.
	 *
	 * <div class="alert alert-info">**Note:** All element references in Angular are always wrapped with jQuery or
	 * jqLite (such as the element argument in a directive's compile / link function). They are never raw DOM references.</div>
	 *
	 * <div class="alert alert-warning">**Note:** Keep in mind that this function will not find elements
	 * by tag name / CSS selector. For lookups by tag name, try instead `angular.element(document).find(...)`
	 * or `$document.find()`, or use the standard DOM APIs, e.g. `document.querySelectorAll()`.</div>
	 *
	 * ## Angular's jqLite
	 * jqLite provides only the following jQuery methods:
	 *
	 * - [`addClass()`](http://api.jquery.com/addClass/)
	 * - [`after()`](http://api.jquery.com/after/)
	 * - [`append()`](http://api.jquery.com/append/)
	 * - [`attr()`](http://api.jquery.com/attr/) - Does not support functions as parameters
	 * - [`bind()`](http://api.jquery.com/bind/) - Does not support namespaces, selectors or eventData
	 * - [`children()`](http://api.jquery.com/children/) - Does not support selectors
	 * - [`clone()`](http://api.jquery.com/clone/)
	 * - [`contents()`](http://api.jquery.com/contents/)
	 * - [`css()`](http://api.jquery.com/css/) - Only retrieves inline-styles, does not call `getComputedStyle()`.
	 *   As a setter, does not convert numbers to strings or append 'px', and also does not have automatic property prefixing.
	 * - [`data()`](http://api.jquery.com/data/)
	 * - [`detach()`](http://api.jquery.com/detach/)
	 * - [`empty()`](http://api.jquery.com/empty/)
	 * - [`eq()`](http://api.jquery.com/eq/)
	 * - [`find()`](http://api.jquery.com/find/) - Limited to lookups by tag name
	 * - [`hasClass()`](http://api.jquery.com/hasClass/)
	 * - [`html()`](http://api.jquery.com/html/)
	 * - [`next()`](http://api.jquery.com/next/) - Does not support selectors
	 * - [`on()`](http://api.jquery.com/on/) - Does not support namespaces, selectors or eventData
	 * - [`off()`](http://api.jquery.com/off/) - Does not support namespaces, selectors or event object as parameter
	 * - [`one()`](http://api.jquery.com/one/) - Does not support namespaces or selectors
	 * - [`parent()`](http://api.jquery.com/parent/) - Does not support selectors
	 * - [`prepend()`](http://api.jquery.com/prepend/)
	 * - [`prop()`](http://api.jquery.com/prop/)
	 * - [`ready()`](http://api.jquery.com/ready/)
	 * - [`remove()`](http://api.jquery.com/remove/)
	 * - [`removeAttr()`](http://api.jquery.com/removeAttr/)
	 * - [`removeClass()`](http://api.jquery.com/removeClass/)
	 * - [`removeData()`](http://api.jquery.com/removeData/)
	 * - [`replaceWith()`](http://api.jquery.com/replaceWith/)
	 * - [`text()`](http://api.jquery.com/text/)
	 * - [`toggleClass()`](http://api.jquery.com/toggleClass/) - Does not support a function as first argument
	 * - [`triggerHandler()`](http://api.jquery.com/triggerHandler/) - Passes a dummy event object to handlers
	 * - [`unbind()`](http://api.jquery.com/unbind/) - Does not support namespaces or event object as parameter
	 * - [`val()`](http://api.jquery.com/val/)
	 * - [`wrap()`](http://api.jquery.com/wrap/)
	 *
	 * ## jQuery/jqLite Extras
	 * Angular also provides the following additional methods and events to both jQuery and jqLite:
	 *
	 * ### Events
	 * - `$destroy` - AngularJS intercepts all jqLite/jQuery's DOM destruction apis and fires this event
	 *    on all DOM nodes being removed.  This can be used to clean up any 3rd party bindings to the DOM
	 *    element before it is removed.
	 *
	 * ### Methods
	 * - `controller(name)` - retrieves the controller of the current element or its parent. By default
	 *   retrieves controller associated with the `ngController` directive. If `name` is provided as
	 *   camelCase directive name, then the controller for this directive will be retrieved (e.g.
	 *   `'ngModel'`).
	 * - `injector()` - retrieves the injector of the current element or its parent.
	 * - `scope()` - retrieves the {@link ng.$rootScope.Scope scope} of the current
	 *   element or its parent. Requires {@link guide/production#disabling-debug-data Debug Data} to
	 *   be enabled.
	 * - `isolateScope()` - retrieves an isolate {@link ng.$rootScope.Scope scope} if one is attached directly to the
	 *   current element. This getter should be used only on elements that contain a directive which starts a new isolate
	 *   scope. Calling `scope()` on this element always returns the original non-isolate scope.
	 *   Requires {@link guide/production#disabling-debug-data Debug Data} to be enabled.
	 * - `inheritedData()` - same as `data()`, but walks up the DOM until a value is found or the top
	 *   parent element is reached.
	 *
	 * @knownIssue You cannot spy on `angular.element` if you are using Jasmine version 1.x. See
	 * https://github.com/angular/angular.js/issues/14251 for more information.
	 *
	 * @param {string|DOMElement} element HTML string or DOMElement to be wrapped into jQuery.
	 * @returns {Object} jQuery object.
	 */
	
	JQLite.expando = 'ng339';
	
	var jqCache = JQLite.cache = {},
	    jqId = 1,
	    addEventListenerFn = function(element, type, fn) {
	      element.addEventListener(type, fn, false);
	    },
	    removeEventListenerFn = function(element, type, fn) {
	      element.removeEventListener(type, fn, false);
	    };
	
	/*
	 * !!! This is an undocumented "private" function !!!
	 */
	JQLite._data = function(node) {
	  //jQuery always returns an object on cache miss
	  return this.cache[node[this.expando]] || {};
	};
	
	function jqNextId() { return ++jqId; }
	
	
	var SPECIAL_CHARS_REGEXP = /([\:\-\_]+(.))/g;
	var MOZ_HACK_REGEXP = /^moz([A-Z])/;
	var MOUSE_EVENT_MAP= { mouseleave: "mouseout", mouseenter: "mouseover"};
	var jqLiteMinErr = minErr('jqLite');
	
	/**
	 * Converts snake_case to camelCase.
	 * Also there is special case for Moz prefix starting with upper case letter.
	 * @param name Name to normalize
	 */
	function camelCase(name) {
	  return name.
	    replace(SPECIAL_CHARS_REGEXP, function(_, separator, letter, offset) {
	      return offset ? letter.toUpperCase() : letter;
	    }).
	    replace(MOZ_HACK_REGEXP, 'Moz$1');
	}
	
	var SINGLE_TAG_REGEXP = /^<([\w-]+)\s*\/?>(?:<\/\1>|)$/;
	var HTML_REGEXP = /<|&#?\w+;/;
	var TAG_NAME_REGEXP = /<([\w:-]+)/;
	var XHTML_TAG_REGEXP = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:-]+)[^>]*)\/>/gi;
	
	var wrapMap = {
	  'option': [1, '<select multiple="multiple">', '</select>'],
	
	  'thead': [1, '<table>', '</table>'],
	  'col': [2, '<table><colgroup>', '</colgroup></table>'],
	  'tr': [2, '<table><tbody>', '</tbody></table>'],
	  'td': [3, '<table><tbody><tr>', '</tr></tbody></table>'],
	  '_default': [0, "", ""]
	};
	
	wrapMap.optgroup = wrapMap.option;
	wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
	wrapMap.th = wrapMap.td;
	
	
	function jqLiteIsTextNode(html) {
	  return !HTML_REGEXP.test(html);
	}
	
	function jqLiteAcceptsData(node) {
	  // The window object can accept data but has no nodeType
	  // Otherwise we are only interested in elements (1) and documents (9)
	  var nodeType = node.nodeType;
	  return nodeType === NODE_TYPE_ELEMENT || !nodeType || nodeType === NODE_TYPE_DOCUMENT;
	}
	
	function jqLiteHasData(node) {
	  for (var key in jqCache[node.ng339]) {
	    return true;
	  }
	  return false;
	}
	
	function jqLiteCleanData(nodes) {
	  for (var i = 0, ii = nodes.length; i < ii; i++) {
	    jqLiteRemoveData(nodes[i]);
	  }
	}
	
	function jqLiteBuildFragment(html, context) {
	  var tmp, tag, wrap,
	      fragment = context.createDocumentFragment(),
	      nodes = [], i;
	
	  if (jqLiteIsTextNode(html)) {
	    // Convert non-html into a text node
	    nodes.push(context.createTextNode(html));
	  } else {
	    // Convert html into DOM nodes
	    tmp = tmp || fragment.appendChild(context.createElement("div"));
	    tag = (TAG_NAME_REGEXP.exec(html) || ["", ""])[1].toLowerCase();
	    wrap = wrapMap[tag] || wrapMap._default;
	    tmp.innerHTML = wrap[1] + html.replace(XHTML_TAG_REGEXP, "<$1></$2>") + wrap[2];
	
	    // Descend through wrappers to the right content
	    i = wrap[0];
	    while (i--) {
	      tmp = tmp.lastChild;
	    }
	
	    nodes = concat(nodes, tmp.childNodes);
	
	    tmp = fragment.firstChild;
	    tmp.textContent = "";
	  }
	
	  // Remove wrapper from fragment
	  fragment.textContent = "";
	  fragment.innerHTML = ""; // Clear inner HTML
	  forEach(nodes, function(node) {
	    fragment.appendChild(node);
	  });
	
	  return fragment;
	}
	
	function jqLiteParseHTML(html, context) {
	  context = context || window.document;
	  var parsed;
	
	  if ((parsed = SINGLE_TAG_REGEXP.exec(html))) {
	    return [context.createElement(parsed[1])];
	  }
	
	  if ((parsed = jqLiteBuildFragment(html, context))) {
	    return parsed.childNodes;
	  }
	
	  return [];
	}
	
	function jqLiteWrapNode(node, wrapper) {
	  var parent = node.parentNode;
	
	  if (parent) {
	    parent.replaceChild(wrapper, node);
	  }
	
	  wrapper.appendChild(node);
	}
	
	
	// IE9-11 has no method "contains" in SVG element and in Node.prototype. Bug #10259.
	var jqLiteContains = window.Node.prototype.contains || function(arg) {
	  // jshint bitwise: false
	  return !!(this.compareDocumentPosition(arg) & 16);
	  // jshint bitwise: true
	};
	
	/////////////////////////////////////////////
	function JQLite(element) {
	  if (element instanceof JQLite) {
	    return element;
	  }
	
	  var argIsString;
	
	  if (isString(element)) {
	    element = trim(element);
	    argIsString = true;
	  }
	  if (!(this instanceof JQLite)) {
	    if (argIsString && element.charAt(0) != '<') {
	      throw jqLiteMinErr('nosel', 'Looking up elements via selectors is not supported by jqLite! See: http://docs.angularjs.org/api/angular.element');
	    }
	    return new JQLite(element);
	  }
	
	  if (argIsString) {
	    jqLiteAddNodes(this, jqLiteParseHTML(element));
	  } else {
	    jqLiteAddNodes(this, element);
	  }
	}
	
	function jqLiteClone(element) {
	  return element.cloneNode(true);
	}
	
	function jqLiteDealoc(element, onlyDescendants) {
	  if (!onlyDescendants) jqLiteRemoveData(element);
	
	  if (element.querySelectorAll) {
	    var descendants = element.querySelectorAll('*');
	    for (var i = 0, l = descendants.length; i < l; i++) {
	      jqLiteRemoveData(descendants[i]);
	    }
	  }
	}
	
	function jqLiteOff(element, type, fn, unsupported) {
	  if (isDefined(unsupported)) throw jqLiteMinErr('offargs', 'jqLite#off() does not support the `selector` argument');
	
	  var expandoStore = jqLiteExpandoStore(element);
	  var events = expandoStore && expandoStore.events;
	  var handle = expandoStore && expandoStore.handle;
	
	  if (!handle) return; //no listeners registered
	
	  if (!type) {
	    for (type in events) {
	      if (type !== '$destroy') {
	        removeEventListenerFn(element, type, handle);
	      }
	      delete events[type];
	    }
	  } else {
	
	    var removeHandler = function(type) {
	      var listenerFns = events[type];
	      if (isDefined(fn)) {
	        arrayRemove(listenerFns || [], fn);
	      }
	      if (!(isDefined(fn) && listenerFns && listenerFns.length > 0)) {
	        removeEventListenerFn(element, type, handle);
	        delete events[type];
	      }
	    };
	
	    forEach(type.split(' '), function(type) {
	      removeHandler(type);
	      if (MOUSE_EVENT_MAP[type]) {
	        removeHandler(MOUSE_EVENT_MAP[type]);
	      }
	    });
	  }
	}
	
	function jqLiteRemoveData(element, name) {
	  var expandoId = element.ng339;
	  var expandoStore = expandoId && jqCache[expandoId];
	
	  if (expandoStore) {
	    if (name) {
	      delete expandoStore.data[name];
	      return;
	    }
	
	    if (expandoStore.handle) {
	      if (expandoStore.events.$destroy) {
	        expandoStore.handle({}, '$destroy');
	      }
	      jqLiteOff(element);
	    }
	    delete jqCache[expandoId];
	    element.ng339 = undefined; // don't delete DOM expandos. IE and Chrome don't like it
	  }
	}
	
	
	function jqLiteExpandoStore(element, createIfNecessary) {
	  var expandoId = element.ng339,
	      expandoStore = expandoId && jqCache[expandoId];
	
	  if (createIfNecessary && !expandoStore) {
	    element.ng339 = expandoId = jqNextId();
	    expandoStore = jqCache[expandoId] = {events: {}, data: {}, handle: undefined};
	  }
	
	  return expandoStore;
	}
	
	
	function jqLiteData(element, key, value) {
	  if (jqLiteAcceptsData(element)) {
	
	    var isSimpleSetter = isDefined(value);
	    var isSimpleGetter = !isSimpleSetter && key && !isObject(key);
	    var massGetter = !key;
	    var expandoStore = jqLiteExpandoStore(element, !isSimpleGetter);
	    var data = expandoStore && expandoStore.data;
	
	    if (isSimpleSetter) { // data('key', value)
	      data[key] = value;
	    } else {
	      if (massGetter) {  // data()
	        return data;
	      } else {
	        if (isSimpleGetter) { // data('key')
	          // don't force creation of expandoStore if it doesn't exist yet
	          return data && data[key];
	        } else { // mass-setter: data({key1: val1, key2: val2})
	          extend(data, key);
	        }
	      }
	    }
	  }
	}
	
	function jqLiteHasClass(element, selector) {
	  if (!element.getAttribute) return false;
	  return ((" " + (element.getAttribute('class') || '') + " ").replace(/[\n\t]/g, " ").
	      indexOf(" " + selector + " ") > -1);
	}
	
	function jqLiteRemoveClass(element, cssClasses) {
	  if (cssClasses && element.setAttribute) {
	    forEach(cssClasses.split(' '), function(cssClass) {
	      element.setAttribute('class', trim(
	          (" " + (element.getAttribute('class') || '') + " ")
	          .replace(/[\n\t]/g, " ")
	          .replace(" " + trim(cssClass) + " ", " "))
	      );
	    });
	  }
	}
	
	function jqLiteAddClass(element, cssClasses) {
	  if (cssClasses && element.setAttribute) {
	    var existingClasses = (' ' + (element.getAttribute('class') || '') + ' ')
	                            .replace(/[\n\t]/g, " ");
	
	    forEach(cssClasses.split(' '), function(cssClass) {
	      cssClass = trim(cssClass);
	      if (existingClasses.indexOf(' ' + cssClass + ' ') === -1) {
	        existingClasses += cssClass + ' ';
	      }
	    });
	
	    element.setAttribute('class', trim(existingClasses));
	  }
	}
	
	
	function jqLiteAddNodes(root, elements) {
	  // THIS CODE IS VERY HOT. Don't make changes without benchmarking.
	
	  if (elements) {
	
	    // if a Node (the most common case)
	    if (elements.nodeType) {
	      root[root.length++] = elements;
	    } else {
	      var length = elements.length;
	
	      // if an Array or NodeList and not a Window
	      if (typeof length === 'number' && elements.window !== elements) {
	        if (length) {
	          for (var i = 0; i < length; i++) {
	            root[root.length++] = elements[i];
	          }
	        }
	      } else {
	        root[root.length++] = elements;
	      }
	    }
	  }
	}
	
	
	function jqLiteController(element, name) {
	  return jqLiteInheritedData(element, '$' + (name || 'ngController') + 'Controller');
	}
	
	function jqLiteInheritedData(element, name, value) {
	  // if element is the document object work with the html element instead
	  // this makes $(document).scope() possible
	  if (element.nodeType == NODE_TYPE_DOCUMENT) {
	    element = element.documentElement;
	  }
	  var names = isArray(name) ? name : [name];
	
	  while (element) {
	    for (var i = 0, ii = names.length; i < ii; i++) {
	      if (isDefined(value = jqLite.data(element, names[i]))) return value;
	    }
	
	    // If dealing with a document fragment node with a host element, and no parent, use the host
	    // element as the parent. This enables directives within a Shadow DOM or polyfilled Shadow DOM
	    // to lookup parent controllers.
	    element = element.parentNode || (element.nodeType === NODE_TYPE_DOCUMENT_FRAGMENT && element.host);
	  }
	}
	
	function jqLiteEmpty(element) {
	  jqLiteDealoc(element, true);
	  while (element.firstChild) {
	    element.removeChild(element.firstChild);
	  }
	}
	
	function jqLiteRemove(element, keepData) {
	  if (!keepData) jqLiteDealoc(element);
	  var parent = element.parentNode;
	  if (parent) parent.removeChild(element);
	}
	
	
	function jqLiteDocumentLoaded(action, win) {
	  win = win || window;
	  if (win.document.readyState === 'complete') {
	    // Force the action to be run async for consistent behavior
	    // from the action's point of view
	    // i.e. it will definitely not be in a $apply
	    win.setTimeout(action);
	  } else {
	    // No need to unbind this handler as load is only ever called once
	    jqLite(win).on('load', action);
	  }
	}
	
	//////////////////////////////////////////
	// Functions which are declared directly.
	//////////////////////////////////////////
	var JQLitePrototype = JQLite.prototype = {
	  ready: function(fn) {
	    var fired = false;
	
	    function trigger() {
	      if (fired) return;
	      fired = true;
	      fn();
	    }
	
	    // check if document is already loaded
	    if (window.document.readyState === 'complete') {
	      window.setTimeout(trigger);
	    } else {
	      this.on('DOMContentLoaded', trigger); // works for modern browsers and IE9
	      // we can not use jqLite since we are not done loading and jQuery could be loaded later.
	      // jshint -W064
	      JQLite(window).on('load', trigger); // fallback to window.onload for others
	      // jshint +W064
	    }
	  },
	  toString: function() {
	    var value = [];
	    forEach(this, function(e) { value.push('' + e);});
	    return '[' + value.join(', ') + ']';
	  },
	
	  eq: function(index) {
	      return (index >= 0) ? jqLite(this[index]) : jqLite(this[this.length + index]);
	  },
	
	  length: 0,
	  push: push,
	  sort: [].sort,
	  splice: [].splice
	};
	
	//////////////////////////////////////////
	// Functions iterating getter/setters.
	// these functions return self on setter and
	// value on get.
	//////////////////////////////////////////
	var BOOLEAN_ATTR = {};
	forEach('multiple,selected,checked,disabled,readOnly,required,open'.split(','), function(value) {
	  BOOLEAN_ATTR[lowercase(value)] = value;
	});
	var BOOLEAN_ELEMENTS = {};
	forEach('input,select,option,textarea,button,form,details'.split(','), function(value) {
	  BOOLEAN_ELEMENTS[value] = true;
	});
	var ALIASED_ATTR = {
	  'ngMinlength': 'minlength',
	  'ngMaxlength': 'maxlength',
	  'ngMin': 'min',
	  'ngMax': 'max',
	  'ngPattern': 'pattern'
	};
	
	function getBooleanAttrName(element, name) {
	  // check dom last since we will most likely fail on name
	  var booleanAttr = BOOLEAN_ATTR[name.toLowerCase()];
	
	  // booleanAttr is here twice to minimize DOM access
	  return booleanAttr && BOOLEAN_ELEMENTS[nodeName_(element)] && booleanAttr;
	}
	
	function getAliasedAttrName(name) {
	  return ALIASED_ATTR[name];
	}
	
	forEach({
	  data: jqLiteData,
	  removeData: jqLiteRemoveData,
	  hasData: jqLiteHasData,
	  cleanData: jqLiteCleanData
	}, function(fn, name) {
	  JQLite[name] = fn;
	});
	
	forEach({
	  data: jqLiteData,
	  inheritedData: jqLiteInheritedData,
	
	  scope: function(element) {
	    // Can't use jqLiteData here directly so we stay compatible with jQuery!
	    return jqLite.data(element, '$scope') || jqLiteInheritedData(element.parentNode || element, ['$isolateScope', '$scope']);
	  },
	
	  isolateScope: function(element) {
	    // Can't use jqLiteData here directly so we stay compatible with jQuery!
	    return jqLite.data(element, '$isolateScope') || jqLite.data(element, '$isolateScopeNoTemplate');
	  },
	
	  controller: jqLiteController,
	
	  injector: function(element) {
	    return jqLiteInheritedData(element, '$injector');
	  },
	
	  removeAttr: function(element, name) {
	    element.removeAttribute(name);
	  },
	
	  hasClass: jqLiteHasClass,
	
	  css: function(element, name, value) {
	    name = camelCase(name);
	
	    if (isDefined(value)) {
	      element.style[name] = value;
	    } else {
	      return element.style[name];
	    }
	  },
	
	  attr: function(element, name, value) {
	    var nodeType = element.nodeType;
	    if (nodeType === NODE_TYPE_TEXT || nodeType === NODE_TYPE_ATTRIBUTE || nodeType === NODE_TYPE_COMMENT) {
	      return;
	    }
	    var lowercasedName = lowercase(name);
	    if (BOOLEAN_ATTR[lowercasedName]) {
	      if (isDefined(value)) {
	        if (!!value) {
	          element[name] = true;
	          element.setAttribute(name, lowercasedName);
	        } else {
	          element[name] = false;
	          element.removeAttribute(lowercasedName);
	        }
	      } else {
	        return (element[name] ||
	                 (element.attributes.getNamedItem(name) || noop).specified)
	               ? lowercasedName
	               : undefined;
	      }
	    } else if (isDefined(value)) {
	      element.setAttribute(name, value);
	    } else if (element.getAttribute) {
	      // the extra argument "2" is to get the right thing for a.href in IE, see jQuery code
	      // some elements (e.g. Document) don't have get attribute, so return undefined
	      var ret = element.getAttribute(name, 2);
	      // normalize non-existing attributes to undefined (as jQuery)
	      return ret === null ? undefined : ret;
	    }
	  },
	
	  prop: function(element, name, value) {
	    if (isDefined(value)) {
	      element[name] = value;
	    } else {
	      return element[name];
	    }
	  },
	
	  text: (function() {
	    getText.$dv = '';
	    return getText;
	
	    function getText(element, value) {
	      if (isUndefined(value)) {
	        var nodeType = element.nodeType;
	        return (nodeType === NODE_TYPE_ELEMENT || nodeType === NODE_TYPE_TEXT) ? element.textContent : '';
	      }
	      element.textContent = value;
	    }
	  })(),
	
	  val: function(element, value) {
	    if (isUndefined(value)) {
	      if (element.multiple && nodeName_(element) === 'select') {
	        var result = [];
	        forEach(element.options, function(option) {
	          if (option.selected) {
	            result.push(option.value || option.text);
	          }
	        });
	        return result.length === 0 ? null : result;
	      }
	      return element.value;
	    }
	    element.value = value;
	  },
	
	  html: function(element, value) {
	    if (isUndefined(value)) {
	      return element.innerHTML;
	    }
	    jqLiteDealoc(element, true);
	    element.innerHTML = value;
	  },
	
	  empty: jqLiteEmpty
	}, function(fn, name) {
	  /**
	   * Properties: writes return selection, reads return first value
	   */
	  JQLite.prototype[name] = function(arg1, arg2) {
	    var i, key;
	    var nodeCount = this.length;
	
	    // jqLiteHasClass has only two arguments, but is a getter-only fn, so we need to special-case it
	    // in a way that survives minification.
	    // jqLiteEmpty takes no arguments but is a setter.
	    if (fn !== jqLiteEmpty &&
	        (isUndefined((fn.length == 2 && (fn !== jqLiteHasClass && fn !== jqLiteController)) ? arg1 : arg2))) {
	      if (isObject(arg1)) {
	
	        // we are a write, but the object properties are the key/values
	        for (i = 0; i < nodeCount; i++) {
	          if (fn === jqLiteData) {
	            // data() takes the whole object in jQuery
	            fn(this[i], arg1);
	          } else {
	            for (key in arg1) {
	              fn(this[i], key, arg1[key]);
	            }
	          }
	        }
	        // return self for chaining
	        return this;
	      } else {
	        // we are a read, so read the first child.
	        // TODO: do we still need this?
	        var value = fn.$dv;
	        // Only if we have $dv do we iterate over all, otherwise it is just the first element.
	        var jj = (isUndefined(value)) ? Math.min(nodeCount, 1) : nodeCount;
	        for (var j = 0; j < jj; j++) {
	          var nodeValue = fn(this[j], arg1, arg2);
	          value = value ? value + nodeValue : nodeValue;
	        }
	        return value;
	      }
	    } else {
	      // we are a write, so apply to all children
	      for (i = 0; i < nodeCount; i++) {
	        fn(this[i], arg1, arg2);
	      }
	      // return self for chaining
	      return this;
	    }
	  };
	});
	
	function createEventHandler(element, events) {
	  var eventHandler = function(event, type) {
	    // jQuery specific api
	    event.isDefaultPrevented = function() {
	      return event.defaultPrevented;
	    };
	
	    var eventFns = events[type || event.type];
	    var eventFnsLength = eventFns ? eventFns.length : 0;
	
	    if (!eventFnsLength) return;
	
	    if (isUndefined(event.immediatePropagationStopped)) {
	      var originalStopImmediatePropagation = event.stopImmediatePropagation;
	      event.stopImmediatePropagation = function() {
	        event.immediatePropagationStopped = true;
	
	        if (event.stopPropagation) {
	          event.stopPropagation();
	        }
	
	        if (originalStopImmediatePropagation) {
	          originalStopImmediatePropagation.call(event);
	        }
	      };
	    }
	
	    event.isImmediatePropagationStopped = function() {
	      return event.immediatePropagationStopped === true;
	    };
	
	    // Some events have special handlers that wrap the real handler
	    var handlerWrapper = eventFns.specialHandlerWrapper || defaultHandlerWrapper;
	
	    // Copy event handlers in case event handlers array is modified during execution.
	    if ((eventFnsLength > 1)) {
	      eventFns = shallowCopy(eventFns);
	    }
	
	    for (var i = 0; i < eventFnsLength; i++) {
	      if (!event.isImmediatePropagationStopped()) {
	        handlerWrapper(element, event, eventFns[i]);
	      }
	    }
	  };
	
	  // TODO: this is a hack for angularMocks/clearDataCache that makes it possible to deregister all
	  //       events on `element`
	  eventHandler.elem = element;
	  return eventHandler;
	}
	
	function defaultHandlerWrapper(element, event, handler) {
	  handler.call(element, event);
	}
	
	function specialMouseHandlerWrapper(target, event, handler) {
	  // Refer to jQuery's implementation of mouseenter & mouseleave
	  // Read about mouseenter and mouseleave:
	  // http://www.quirksmode.org/js/events_mouse.html#link8
	  var related = event.relatedTarget;
	  // For mousenter/leave call the handler if related is outside the target.
	  // NB: No relatedTarget if the mouse left/entered the browser window
	  if (!related || (related !== target && !jqLiteContains.call(target, related))) {
	    handler.call(target, event);
	  }
	}
	
	//////////////////////////////////////////
	// Functions iterating traversal.
	// These functions chain results into a single
	// selector.
	//////////////////////////////////////////
	forEach({
	  removeData: jqLiteRemoveData,
	
	  on: function jqLiteOn(element, type, fn, unsupported) {
	    if (isDefined(unsupported)) throw jqLiteMinErr('onargs', 'jqLite#on() does not support the `selector` or `eventData` parameters');
	
	    // Do not add event handlers to non-elements because they will not be cleaned up.
	    if (!jqLiteAcceptsData(element)) {
	      return;
	    }
	
	    var expandoStore = jqLiteExpandoStore(element, true);
	    var events = expandoStore.events;
	    var handle = expandoStore.handle;
	
	    if (!handle) {
	      handle = expandoStore.handle = createEventHandler(element, events);
	    }
	
	    // http://jsperf.com/string-indexof-vs-split
	    var types = type.indexOf(' ') >= 0 ? type.split(' ') : [type];
	    var i = types.length;
	
	    var addHandler = function(type, specialHandlerWrapper, noEventListener) {
	      var eventFns = events[type];
	
	      if (!eventFns) {
	        eventFns = events[type] = [];
	        eventFns.specialHandlerWrapper = specialHandlerWrapper;
	        if (type !== '$destroy' && !noEventListener) {
	          addEventListenerFn(element, type, handle);
	        }
	      }
	
	      eventFns.push(fn);
	    };
	
	    while (i--) {
	      type = types[i];
	      if (MOUSE_EVENT_MAP[type]) {
	        addHandler(MOUSE_EVENT_MAP[type], specialMouseHandlerWrapper);
	        addHandler(type, undefined, true);
	      } else {
	        addHandler(type);
	      }
	    }
	  },
	
	  off: jqLiteOff,
	
	  one: function(element, type, fn) {
	    element = jqLite(element);
	
	    //add the listener twice so that when it is called
	    //you can remove the original function and still be
	    //able to call element.off(ev, fn) normally
	    element.on(type, function onFn() {
	      element.off(type, fn);
	      element.off(type, onFn);
	    });
	    element.on(type, fn);
	  },
	
	  replaceWith: function(element, replaceNode) {
	    var index, parent = element.parentNode;
	    jqLiteDealoc(element);
	    forEach(new JQLite(replaceNode), function(node) {
	      if (index) {
	        parent.insertBefore(node, index.nextSibling);
	      } else {
	        parent.replaceChild(node, element);
	      }
	      index = node;
	    });
	  },
	
	  children: function(element) {
	    var children = [];
	    forEach(element.childNodes, function(element) {
	      if (element.nodeType === NODE_TYPE_ELEMENT) {
	        children.push(element);
	      }
	    });
	    return children;
	  },
	
	  contents: function(element) {
	    return element.contentDocument || element.childNodes || [];
	  },
	
	  append: function(element, node) {
	    var nodeType = element.nodeType;
	    if (nodeType !== NODE_TYPE_ELEMENT && nodeType !== NODE_TYPE_DOCUMENT_FRAGMENT) return;
	
	    node = new JQLite(node);
	
	    for (var i = 0, ii = node.length; i < ii; i++) {
	      var child = node[i];
	      element.appendChild(child);
	    }
	  },
	
	  prepend: function(element, node) {
	    if (element.nodeType === NODE_TYPE_ELEMENT) {
	      var index = element.firstChild;
	      forEach(new JQLite(node), function(child) {
	        element.insertBefore(child, index);
	      });
	    }
	  },
	
	  wrap: function(element, wrapNode) {
	    jqLiteWrapNode(element, jqLite(wrapNode).eq(0).clone()[0]);
	  },
	
	  remove: jqLiteRemove,
	
	  detach: function(element) {
	    jqLiteRemove(element, true);
	  },
	
	  after: function(element, newElement) {
	    var index = element, parent = element.parentNode;
	    newElement = new JQLite(newElement);
	
	    for (var i = 0, ii = newElement.length; i < ii; i++) {
	      var node = newElement[i];
	      parent.insertBefore(node, index.nextSibling);
	      index = node;
	    }
	  },
	
	  addClass: jqLiteAddClass,
	  removeClass: jqLiteRemoveClass,
	
	  toggleClass: function(element, selector, condition) {
	    if (selector) {
	      forEach(selector.split(' '), function(className) {
	        var classCondition = condition;
	        if (isUndefined(classCondition)) {
	          classCondition = !jqLiteHasClass(element, className);
	        }
	        (classCondition ? jqLiteAddClass : jqLiteRemoveClass)(element, className);
	      });
	    }
	  },
	
	  parent: function(element) {
	    var parent = element.parentNode;
	    return parent && parent.nodeType !== NODE_TYPE_DOCUMENT_FRAGMENT ? parent : null;
	  },
	
	  next: function(element) {
	    return element.nextElementSibling;
	  },
	
	  find: function(element, selector) {
	    if (element.getElementsByTagName) {
	      return element.getElementsByTagName(selector);
	    } else {
	      return [];
	    }
	  },
	
	  clone: jqLiteClone,
	
	  triggerHandler: function(element, event, extraParameters) {
	
	    var dummyEvent, eventFnsCopy, handlerArgs;
	    var eventName = event.type || event;
	    var expandoStore = jqLiteExpandoStore(element);
	    var events = expandoStore && expandoStore.events;
	    var eventFns = events && events[eventName];
	
	    if (eventFns) {
	      // Create a dummy event to pass to the handlers
	      dummyEvent = {
	        preventDefault: function() { this.defaultPrevented = true; },
	        isDefaultPrevented: function() { return this.defaultPrevented === true; },
	        stopImmediatePropagation: function() { this.immediatePropagationStopped = true; },
	        isImmediatePropagationStopped: function() { return this.immediatePropagationStopped === true; },
	        stopPropagation: noop,
	        type: eventName,
	        target: element
	      };
	
	      // If a custom event was provided then extend our dummy event with it
	      if (event.type) {
	        dummyEvent = extend(dummyEvent, event);
	      }
	
	      // Copy event handlers in case event handlers array is modified during execution.
	      eventFnsCopy = shallowCopy(eventFns);
	      handlerArgs = extraParameters ? [dummyEvent].concat(extraParameters) : [dummyEvent];
	
	      forEach(eventFnsCopy, function(fn) {
	        if (!dummyEvent.isImmediatePropagationStopped()) {
	          fn.apply(element, handlerArgs);
	        }
	      });
	    }
	  }
	}, function(fn, name) {
	  /**
	   * chaining functions
	   */
	  JQLite.prototype[name] = function(arg1, arg2, arg3) {
	    var value;
	
	    for (var i = 0, ii = this.length; i < ii; i++) {
	      if (isUndefined(value)) {
	        value = fn(this[i], arg1, arg2, arg3);
	        if (isDefined(value)) {
	          // any function which returns a value needs to be wrapped
	          value = jqLite(value);
	        }
	      } else {
	        jqLiteAddNodes(value, fn(this[i], arg1, arg2, arg3));
	      }
	    }
	    return isDefined(value) ? value : this;
	  };
	
	  // bind legacy bind/unbind to on/off
	  JQLite.prototype.bind = JQLite.prototype.on;
	  JQLite.prototype.unbind = JQLite.prototype.off;
	});
	
	
	// Provider for private $$jqLite service
	function $$jqLiteProvider() {
	  this.$get = function $$jqLite() {
	    return extend(JQLite, {
	      hasClass: function(node, classes) {
	        if (node.attr) node = node[0];
	        return jqLiteHasClass(node, classes);
	      },
	      addClass: function(node, classes) {
	        if (node.attr) node = node[0];
	        return jqLiteAddClass(node, classes);
	      },
	      removeClass: function(node, classes) {
	        if (node.attr) node = node[0];
	        return jqLiteRemoveClass(node, classes);
	      }
	    });
	  };
	}
	
	/**
	 * Computes a hash of an 'obj'.
	 * Hash of a:
	 *  string is string
	 *  number is number as string
	 *  object is either result of calling $$hashKey function on the object or uniquely generated id,
	 *         that is also assigned to the $$hashKey property of the object.
	 *
	 * @param obj
	 * @returns {string} hash string such that the same input will have the same hash string.
	 *         The resulting string key is in 'type:hashKey' format.
	 */
	function hashKey(obj, nextUidFn) {
	  var key = obj && obj.$$hashKey;
	
	  if (key) {
	    if (typeof key === 'function') {
	      key = obj.$$hashKey();
	    }
	    return key;
	  }
	
	  var objType = typeof obj;
	  if (objType == 'function' || (objType == 'object' && obj !== null)) {
	    key = obj.$$hashKey = objType + ':' + (nextUidFn || nextUid)();
	  } else {
	    key = objType + ':' + obj;
	  }
	
	  return key;
	}
	
	/**
	 * HashMap which can use objects as keys
	 */
	function HashMap(array, isolatedUid) {
	  if (isolatedUid) {
	    var uid = 0;
	    this.nextUid = function() {
	      return ++uid;
	    };
	  }
	  forEach(array, this.put, this);
	}
	HashMap.prototype = {
	  /**
	   * Store key value pair
	   * @param key key to store can be any type
	   * @param value value to store can be any type
	   */
	  put: function(key, value) {
	    this[hashKey(key, this.nextUid)] = value;
	  },
	
	  /**
	   * @param key
	   * @returns {Object} the value for the key
	   */
	  get: function(key) {
	    return this[hashKey(key, this.nextUid)];
	  },
	
	  /**
	   * Remove the key/value pair
	   * @param key
	   */
	  remove: function(key) {
	    var value = this[key = hashKey(key, this.nextUid)];
	    delete this[key];
	    return value;
	  }
	};
	
	var $$HashMapProvider = [function() {
	  this.$get = [function() {
	    return HashMap;
	  }];
	}];
	
	/**
	 * @ngdoc function
	 * @module ng
	 * @name angular.injector
	 * @kind function
	 *
	 * @description
	 * Creates an injector object that can be used for retrieving services as well as for
	 * dependency injection (see {@link guide/di dependency injection}).
	 *
	 * @param {Array.<string|Function>} modules A list of module functions or their aliases. See
	 *     {@link angular.module}. The `ng` module must be explicitly added.
	 * @param {boolean=} [strictDi=false] Whether the injector should be in strict mode, which
	 *     disallows argument name annotation inference.
	 * @returns {injector} Injector object. See {@link auto.$injector $injector}.
	 *
	 * @example
	 * Typical usage
	 * ```js
	 *   // create an injector
	 *   var $injector = angular.injector(['ng']);
	 *
	 *   // use the injector to kick off your application
	 *   // use the type inference to auto inject arguments, or use implicit injection
	 *   $injector.invoke(function($rootScope, $compile, $document) {
	 *     $compile($document)($rootScope);
	 *     $rootScope.$digest();
	 *   });
	 * ```
	 *
	 * Sometimes you want to get access to the injector of a currently running Angular app
	 * from outside Angular. Perhaps, you want to inject and compile some markup after the
	 * application has been bootstrapped. You can do this using the extra `injector()` added
	 * to JQuery/jqLite elements. See {@link angular.element}.
	 *
	 * *This is fairly rare but could be the case if a third party library is injecting the
	 * markup.*
	 *
	 * In the following example a new block of HTML containing a `ng-controller`
	 * directive is added to the end of the document body by JQuery. We then compile and link
	 * it into the current AngularJS scope.
	 *
	 * ```js
	 * var $div = $('<div ng-controller="MyCtrl">{{content.label}}</div>');
	 * $(document.body).append($div);
	 *
	 * angular.element(document).injector().invoke(function($compile) {
	 *   var scope = angular.element($div).scope();
	 *   $compile($div)(scope);
	 * });
	 * ```
	 */
	
	
	/**
	 * @ngdoc module
	 * @name auto
	 * @installation
	 * @description
	 *
	 * Implicit module which gets automatically added to each {@link auto.$injector $injector}.
	 */
	
	var ARROW_ARG = /^([^\(]+?)=>/;
	var FN_ARGS = /^[^\(]*\(\s*([^\)]*)\)/m;
	var FN_ARG_SPLIT = /,/;
	var FN_ARG = /^\s*(_?)(\S+?)\1\s*$/;
	var STRIP_COMMENTS = /((\/\/.*$)|(\/\*[\s\S]*?\*\/))/mg;
	var $injectorMinErr = minErr('$injector');
	
	function stringifyFn(fn) {
	  // Support: Chrome 50-51 only
	  // Creating a new string by adding `' '` at the end, to hack around some bug in Chrome v50/51
	  // (See https://github.com/angular/angular.js/issues/14487.)
	  // TODO (gkalpak): Remove workaround when Chrome v52 is released
	  return Function.prototype.toString.call(fn) + ' ';
	}
	
	function extractArgs(fn) {
	  var fnText = stringifyFn(fn).replace(STRIP_COMMENTS, ''),
	      args = fnText.match(ARROW_ARG) || fnText.match(FN_ARGS);
	  return args;
	}
	
	function anonFn(fn) {
	  // For anonymous functions, showing at the very least the function signature can help in
	  // debugging.
	  var args = extractArgs(fn);
	  if (args) {
	    return 'function(' + (args[1] || '').replace(/[\s\r\n]+/, ' ') + ')';
	  }
	  return 'fn';
	}
	
	function annotate(fn, strictDi, name) {
	  var $inject,
	      argDecl,
	      last;
	
	  if (typeof fn === 'function') {
	    if (!($inject = fn.$inject)) {
	      $inject = [];
	      if (fn.length) {
	        if (strictDi) {
	          if (!isString(name) || !name) {
	            name = fn.name || anonFn(fn);
	          }
	          throw $injectorMinErr('strictdi',
	            '{0} is not using explicit annotation and cannot be invoked in strict mode', name);
	        }
	        argDecl = extractArgs(fn);
	        forEach(argDecl[1].split(FN_ARG_SPLIT), function(arg) {
	          arg.replace(FN_ARG, function(all, underscore, name) {
	            $inject.push(name);
	          });
	        });
	      }
	      fn.$inject = $inject;
	    }
	  } else if (isArray(fn)) {
	    last = fn.length - 1;
	    assertArgFn(fn[last], 'fn');
	    $inject = fn.slice(0, last);
	  } else {
	    assertArgFn(fn, 'fn', true);
	  }
	  return $inject;
	}
	
	///////////////////////////////////////
	
	/**
	 * @ngdoc service
	 * @name $injector
	 *
	 * @description
	 *
	 * `$injector` is used to retrieve object instances as defined by
	 * {@link auto.$provide provider}, instantiate types, invoke methods,
	 * and load modules.
	 *
	 * The following always holds true:
	 *
	 * ```js
	 *   var $injector = angular.injector();
	 *   expect($injector.get('$injector')).toBe($injector);
	 *   expect($injector.invoke(function($injector) {
	 *     return $injector;
	 *   })).toBe($injector);
	 * ```
	 *
	 * # Injection Function Annotation
	 *
	 * JavaScript does not have annotations, and annotations are needed for dependency injection. The
	 * following are all valid ways of annotating function with injection arguments and are equivalent.
	 *
	 * ```js
	 *   // inferred (only works if code not minified/obfuscated)
	 *   $injector.invoke(function(serviceA){});
	 *
	 *   // annotated
	 *   function explicit(serviceA) {};
	 *   explicit.$inject = ['serviceA'];
	 *   $injector.invoke(explicit);
	 *
	 *   // inline
	 *   $injector.invoke(['serviceA', function(serviceA){}]);
	 * ```
	 *
	 * ## Inference
	 *
	 * In JavaScript calling `toString()` on a function returns the function definition. The definition
	 * can then be parsed and the function arguments can be extracted. This method of discovering
	 * annotations is disallowed when the injector is in strict mode.
	 * *NOTE:* This does not work with minification, and obfuscation tools since these tools change the
	 * argument names.
	 *
	 * ## `$inject` Annotation
	 * By adding an `$inject` property onto a function the injection parameters can be specified.
	 *
	 * ## Inline
	 * As an array of injection names, where the last item in the array is the function to call.
	 */
	
	/**
	 * @ngdoc method
	 * @name $injector#get
	 *
	 * @description
	 * Return an instance of the service.
	 *
	 * @param {string} name The name of the instance to retrieve.
	 * @param {string=} caller An optional string to provide the origin of the function call for error messages.
	 * @return {*} The instance.
	 */
	
	/**
	 * @ngdoc method
	 * @name $injector#invoke
	 *
	 * @description
	 * Invoke the method and supply the method arguments from the `$injector`.
	 *
	 * @param {Function|Array.<string|Function>} fn The injectable function to invoke. Function parameters are
	 *   injected according to the {@link guide/di $inject Annotation} rules.
	 * @param {Object=} self The `this` for the invoked method.
	 * @param {Object=} locals Optional object. If preset then any argument names are read from this
	 *                         object first, before the `$injector` is consulted.
	 * @returns {*} the value returned by the invoked `fn` function.
	 */
	
	/**
	 * @ngdoc method
	 * @name $injector#has
	 *
	 * @description
	 * Allows the user to query if the particular service exists.
	 *
	 * @param {string} name Name of the service to query.
	 * @returns {boolean} `true` if injector has given service.
	 */
	
	/**
	 * @ngdoc method
	 * @name $injector#instantiate
	 * @description
	 * Create a new instance of JS type. The method takes a constructor function, invokes the new
	 * operator, and supplies all of the arguments to the constructor function as specified by the
	 * constructor annotation.
	 *
	 * @param {Function} Type Annotated constructor function.
	 * @param {Object=} locals Optional object. If preset then any argument names are read from this
	 * object first, before the `$injector` is consulted.
	 * @returns {Object} new instance of `Type`.
	 */
	
	/**
	 * @ngdoc method
	 * @name $injector#annotate
	 *
	 * @description
	 * Returns an array of service names which the function is requesting for injection. This API is
	 * used by the injector to determine which services need to be injected into the function when the
	 * function is invoked. There are three ways in which the function can be annotated with the needed
	 * dependencies.
	 *
	 * # Argument names
	 *
	 * The simplest form is to extract the dependencies from the arguments of the function. This is done
	 * by converting the function into a string using `toString()` method and extracting the argument
	 * names.
	 * ```js
	 *   // Given
	 *   function MyController($scope, $route) {
	 *     // ...
	 *   }
	 *
	 *   // Then
	 *   expect(injector.annotate(MyController)).toEqual(['$scope', '$route']);
	 * ```
	 *
	 * You can disallow this method by using strict injection mode.
	 *
	 * This method does not work with code minification / obfuscation. For this reason the following
	 * annotation strategies are supported.
	 *
	 * # The `$inject` property
	 *
	 * If a function has an `$inject` property and its value is an array of strings, then the strings
	 * represent names of services to be injected into the function.
	 * ```js
	 *   // Given
	 *   var MyController = function(obfuscatedScope, obfuscatedRoute) {
	 *     // ...
	 *   }
	 *   // Define function dependencies
	 *   MyController['$inject'] = ['$scope', '$route'];
	 *
	 *   // Then
	 *   expect(injector.annotate(MyController)).toEqual(['$scope', '$route']);
	 * ```
	 *
	 * # The array notation
	 *
	 * It is often desirable to inline Injected functions and that's when setting the `$inject` property
	 * is very inconvenient. In these situations using the array notation to specify the dependencies in
	 * a way that survives minification is a better choice:
	 *
	 * ```js
	 *   // We wish to write this (not minification / obfuscation safe)
	 *   injector.invoke(function($compile, $rootScope) {
	 *     // ...
	 *   });
	 *
	 *   // We are forced to write break inlining
	 *   var tmpFn = function(obfuscatedCompile, obfuscatedRootScope) {
	 *     // ...
	 *   };
	 *   tmpFn.$inject = ['$compile', '$rootScope'];
	 *   injector.invoke(tmpFn);
	 *
	 *   // To better support inline function the inline annotation is supported
	 *   injector.invoke(['$compile', '$rootScope', function(obfCompile, obfRootScope) {
	 *     // ...
	 *   }]);
	 *
	 *   // Therefore
	 *   expect(injector.annotate(
	 *      ['$compile', '$rootScope', function(obfus_$compile, obfus_$rootScope) {}])
	 *    ).toEqual(['$compile', '$rootScope']);
	 * ```
	 *
	 * @param {Function|Array.<string|Function>} fn Function for which dependent service names need to
	 * be retrieved as described above.
	 *
	 * @param {boolean=} [strictDi=false] Disallow argument name annotation inference.
	 *
	 * @returns {Array.<string>} The names of the services which the function requires.
	 */
	
	
	
	
	/**
	 * @ngdoc service
	 * @name $provide
	 *
	 * @description
	 *
	 * The {@link auto.$provide $provide} service has a number of methods for registering components
	 * with the {@link auto.$injector $injector}. Many of these functions are also exposed on
	 * {@link angular.Module}.
	 *
	 * An Angular **service** is a singleton object created by a **service factory**.  These **service
	 * factories** are functions which, in turn, are created by a **service provider**.
	 * The **service providers** are constructor functions. When instantiated they must contain a
	 * property called `$get`, which holds the **service factory** function.
	 *
	 * When you request a service, the {@link auto.$injector $injector} is responsible for finding the
	 * correct **service provider**, instantiating it and then calling its `$get` **service factory**
	 * function to get the instance of the **service**.
	 *
	 * Often services have no configuration options and there is no need to add methods to the service
	 * provider.  The provider will be no more than a constructor function with a `$get` property. For
	 * these cases the {@link auto.$provide $provide} service has additional helper methods to register
	 * services without specifying a provider.
	 *
	 * * {@link auto.$provide#provider provider(name, provider)} - registers a **service provider** with the
	 *     {@link auto.$injector $injector}
	 * * {@link auto.$provide#constant constant(name, obj)} - registers a value/object that can be accessed by
	 *     providers and services.
	 * * {@link auto.$provide#value value(name, obj)} - registers a value/object that can only be accessed by
	 *     services, not providers.
	 * * {@link auto.$provide#factory factory(name, fn)} - registers a service **factory function**
	 *     that will be wrapped in a **service provider** object, whose `$get` property will contain the
	 *     given factory function.
	 * * {@link auto.$provide#service service(name, Fn)} - registers a **constructor function**
	 *     that will be wrapped in a **service provider** object, whose `$get` property will instantiate
	 *      a new object using the given constructor function.
	 * * {@link auto.$provide#decorator decorator(name, decorFn)} - registers a **decorator function** that
	 *      will be able to modify or replace the implementation of another service.
	 *
	 * See the individual methods for more information and examples.
	 */
	
	/**
	 * @ngdoc method
	 * @name $provide#provider
	 * @description
	 *
	 * Register a **provider function** with the {@link auto.$injector $injector}. Provider functions
	 * are constructor functions, whose instances are responsible for "providing" a factory for a
	 * service.
	 *
	 * Service provider names start with the name of the service they provide followed by `Provider`.
	 * For example, the {@link ng.$log $log} service has a provider called
	 * {@link ng.$logProvider $logProvider}.
	 *
	 * Service provider objects can have additional methods which allow configuration of the provider
	 * and its service. Importantly, you can configure what kind of service is created by the `$get`
	 * method, or how that service will act. For example, the {@link ng.$logProvider $logProvider} has a
	 * method {@link ng.$logProvider#debugEnabled debugEnabled}
	 * which lets you specify whether the {@link ng.$log $log} service will log debug messages to the
	 * console or not.
	 *
	 * @param {string} name The name of the instance. NOTE: the provider will be available under `name +
	                        'Provider'` key.
	 * @param {(Object|function())} provider If the provider is:
	 *
	 *   - `Object`: then it should have a `$get` method. The `$get` method will be invoked using
	 *     {@link auto.$injector#invoke $injector.invoke()} when an instance needs to be created.
	 *   - `Constructor`: a new instance of the provider will be created using
	 *     {@link auto.$injector#instantiate $injector.instantiate()}, then treated as `object`.
	 *
	 * @returns {Object} registered provider instance
	
	 * @example
	 *
	 * The following example shows how to create a simple event tracking service and register it using
	 * {@link auto.$provide#provider $provide.provider()}.
	 *
	 * ```js
	 *  // Define the eventTracker provider
	 *  function EventTrackerProvider() {
	 *    var trackingUrl = '/track';
	 *
	 *    // A provider method for configuring where the tracked events should been saved
	 *    this.setTrackingUrl = function(url) {
	 *      trackingUrl = url;
	 *    };
	 *
	 *    // The service factory function
	 *    this.$get = ['$http', function($http) {
	 *      var trackedEvents = {};
	 *      return {
	 *        // Call this to track an event
	 *        event: function(event) {
	 *          var count = trackedEvents[event] || 0;
	 *          count += 1;
	 *          trackedEvents[event] = count;
	 *          return count;
	 *        },
	 *        // Call this to save the tracked events to the trackingUrl
	 *        save: function() {
	 *          $http.post(trackingUrl, trackedEvents);
	 *        }
	 *      };
	 *    }];
	 *  }
	 *
	 *  describe('eventTracker', function() {
	 *    var postSpy;
	 *
	 *    beforeEach(module(function($provide) {
	 *      // Register the eventTracker provider
	 *      $provide.provider('eventTracker', EventTrackerProvider);
	 *    }));
	 *
	 *    beforeEach(module(function(eventTrackerProvider) {
	 *      // Configure eventTracker provider
	 *      eventTrackerProvider.setTrackingUrl('/custom-track');
	 *    }));
	 *
	 *    it('tracks events', inject(function(eventTracker) {
	 *      expect(eventTracker.event('login')).toEqual(1);
	 *      expect(eventTracker.event('login')).toEqual(2);
	 *    }));
	 *
	 *    it('saves to the tracking url', inject(function(eventTracker, $http) {
	 *      postSpy = spyOn($http, 'post');
	 *      eventTracker.event('login');
	 *      eventTracker.save();
	 *      expect(postSpy).toHaveBeenCalled();
	 *      expect(postSpy.mostRecentCall.args[0]).not.toEqual('/track');
	 *      expect(postSpy.mostRecentCall.args[0]).toEqual('/custom-track');
	 *      expect(postSpy.mostRecentCall.args[1]).toEqual({ 'login': 1 });
	 *    }));
	 *  });
	 * ```
	 */
	
	/**
	 * @ngdoc method
	 * @name $provide#factory
	 * @description
	 *
	 * Register a **service factory**, which will be called to return the service instance.
	 * This is short for registering a service where its provider consists of only a `$get` property,
	 * which is the given service factory function.
	 * You should use {@link auto.$provide#factory $provide.factory(getFn)} if you do not need to
	 * configure your service in a provider.
	 *
	 * @param {string} name The name of the instance.
	 * @param {Function|Array.<string|Function>} $getFn The injectable $getFn for the instance creation.
	 *                      Internally this is a short hand for `$provide.provider(name, {$get: $getFn})`.
	 * @returns {Object} registered provider instance
	 *
	 * @example
	 * Here is an example of registering a service
	 * ```js
	 *   $provide.factory('ping', ['$http', function($http) {
	 *     return function ping() {
	 *       return $http.send('/ping');
	 *     };
	 *   }]);
	 * ```
	 * You would then inject and use this service like this:
	 * ```js
	 *   someModule.controller('Ctrl', ['ping', function(ping) {
	 *     ping();
	 *   }]);
	 * ```
	 */
	
	
	/**
	 * @ngdoc method
	 * @name $provide#service
	 * @description
	 *
	 * Register a **service constructor**, which will be invoked with `new` to create the service
	 * instance.
	 * This is short for registering a service where its provider's `$get` property is a factory
	 * function that returns an instance instantiated by the injector from the service constructor
	 * function.
	 *
	 * Internally it looks a bit like this:
	 *
	 * ```
	 * {
	 *   $get: function() {
	 *     return $injector.instantiate(constructor);
	 *   }
	 * }
	 * ```
	 *
	 *
	 * You should use {@link auto.$provide#service $provide.service(class)} if you define your service
	 * as a type/class.
	 *
	 * @param {string} name The name of the instance.
	 * @param {Function|Array.<string|Function>} constructor An injectable class (constructor function)
	 *     that will be instantiated.
	 * @returns {Object} registered provider instance
	 *
	 * @example
	 * Here is an example of registering a service using
	 * {@link auto.$provide#service $provide.service(class)}.
	 * ```js
	 *   var Ping = function($http) {
	 *     this.$http = $http;
	 *   };
	 *
	 *   Ping.$inject = ['$http'];
	 *
	 *   Ping.prototype.send = function() {
	 *     return this.$http.get('/ping');
	 *   };
	 *   $provide.service('ping', Ping);
	 * ```
	 * You would then inject and use this service like this:
	 * ```js
	 *   someModule.controller('Ctrl', ['ping', function(ping) {
	 *     ping.send();
	 *   }]);
	 * ```
	 */
	
	
	/**
	 * @ngdoc method
	 * @name $provide#value
	 * @description
	 *
	 * Register a **value service** with the {@link auto.$injector $injector}, such as a string, a
	 * number, an array, an object or a function. This is short for registering a service where its
	 * provider's `$get` property is a factory function that takes no arguments and returns the **value
	 * service**. That also means it is not possible to inject other services into a value service.
	 *
	 * Value services are similar to constant services, except that they cannot be injected into a
	 * module configuration function (see {@link angular.Module#config}) but they can be overridden by
	 * an Angular {@link auto.$provide#decorator decorator}.
	 *
	 * @param {string} name The name of the instance.
	 * @param {*} value The value.
	 * @returns {Object} registered provider instance
	 *
	 * @example
	 * Here are some examples of creating value services.
	 * ```js
	 *   $provide.value('ADMIN_USER', 'admin');
	 *
	 *   $provide.value('RoleLookup', { admin: 0, writer: 1, reader: 2 });
	 *
	 *   $provide.value('halfOf', function(value) {
	 *     return value / 2;
	 *   });
	 * ```
	 */
	
	
	/**
	 * @ngdoc method
	 * @name $provide#constant
	 * @description
	 *
	 * Register a **constant service** with the {@link auto.$injector $injector}, such as a string,
	 * a number, an array, an object or a function. Like the {@link auto.$provide#value value}, it is not
	 * possible to inject other services into a constant.
	 *
	 * But unlike {@link auto.$provide#value value}, a constant can be
	 * injected into a module configuration function (see {@link angular.Module#config}) and it cannot
	 * be overridden by an Angular {@link auto.$provide#decorator decorator}.
	 *
	 * @param {string} name The name of the constant.
	 * @param {*} value The constant value.
	 * @returns {Object} registered instance
	 *
	 * @example
	 * Here a some examples of creating constants:
	 * ```js
	 *   $provide.constant('SHARD_HEIGHT', 306);
	 *
	 *   $provide.constant('MY_COLOURS', ['red', 'blue', 'grey']);
	 *
	 *   $provide.constant('double', function(value) {
	 *     return value * 2;
	 *   });
	 * ```
	 */
	
	
	/**
	 * @ngdoc method
	 * @name $provide#decorator
	 * @description
	 *
	 * Register a **decorator function** with the {@link auto.$injector $injector}. A decorator function
	 * intercepts the creation of a service, allowing it to override or modify the behavior of the
	 * service. The return value of the decorator function may be the original service, or a new service
	 * that replaces (or wraps and delegates to) the original service.
	 *
	 * You can find out more about using decorators in the {@link guide/decorators} guide.
	 *
	 * @param {string} name The name of the service to decorate.
	 * @param {Function|Array.<string|Function>} decorator This function will be invoked when the service needs to be
	 *    provided and should return the decorated service instance. The function is called using
	 *    the {@link auto.$injector#invoke injector.invoke} method and is therefore fully injectable.
	 *    Local injection arguments:
	 *
	 *    * `$delegate` - The original service instance, which can be replaced, monkey patched, configured,
	 *      decorated or delegated to.
	 *
	 * @example
	 * Here we decorate the {@link ng.$log $log} service to convert warnings to errors by intercepting
	 * calls to {@link ng.$log#error $log.warn()}.
	 * ```js
	 *   $provide.decorator('$log', ['$delegate', function($delegate) {
	 *     $delegate.warn = $delegate.error;
	 *     return $delegate;
	 *   }]);
	 * ```
	 */
	
	
	function createInjector(modulesToLoad, strictDi) {
	  strictDi = (strictDi === true);
	  var INSTANTIATING = {},
	      providerSuffix = 'Provider',
	      path = [],
	      loadedModules = new HashMap([], true),
	      providerCache = {
	        $provide: {
	            provider: supportObject(provider),
	            factory: supportObject(factory),
	            service: supportObject(service),
	            value: supportObject(value),
	            constant: supportObject(constant),
	            decorator: decorator
	          }
	      },
	      providerInjector = (providerCache.$injector =
	          createInternalInjector(providerCache, function(serviceName, caller) {
	            if (angular.isString(caller)) {
	              path.push(caller);
	            }
	            throw $injectorMinErr('unpr', "Unknown provider: {0}", path.join(' <- '));
	          })),
	      instanceCache = {},
	      protoInstanceInjector =
	          createInternalInjector(instanceCache, function(serviceName, caller) {
	            var provider = providerInjector.get(serviceName + providerSuffix, caller);
	            return instanceInjector.invoke(
	                provider.$get, provider, undefined, serviceName);
	          }),
	      instanceInjector = protoInstanceInjector;
	
	  providerCache['$injector' + providerSuffix] = { $get: valueFn(protoInstanceInjector) };
	  var runBlocks = loadModules(modulesToLoad);
	  instanceInjector = protoInstanceInjector.get('$injector');
	  instanceInjector.strictDi = strictDi;
	  forEach(runBlocks, function(fn) { if (fn) instanceInjector.invoke(fn); });
	
	  return instanceInjector;
	
	  ////////////////////////////////////
	  // $provider
	  ////////////////////////////////////
	
	  function supportObject(delegate) {
	    return function(key, value) {
	      if (isObject(key)) {
	        forEach(key, reverseParams(delegate));
	      } else {
	        return delegate(key, value);
	      }
	    };
	  }
	
	  function provider(name, provider_) {
	    assertNotHasOwnProperty(name, 'service');
	    if (isFunction(provider_) || isArray(provider_)) {
	      provider_ = providerInjector.instantiate(provider_);
	    }
	    if (!provider_.$get) {
	      throw $injectorMinErr('pget', "Provider '{0}' must define $get factory method.", name);
	    }
	    return providerCache[name + providerSuffix] = provider_;
	  }
	
	  function enforceReturnValue(name, factory) {
	    return function enforcedReturnValue() {
	      var result = instanceInjector.invoke(factory, this);
	      if (isUndefined(result)) {
	        throw $injectorMinErr('undef', "Provider '{0}' must return a value from $get factory method.", name);
	      }
	      return result;
	    };
	  }
	
	  function factory(name, factoryFn, enforce) {
	    return provider(name, {
	      $get: enforce !== false ? enforceReturnValue(name, factoryFn) : factoryFn
	    });
	  }
	
	  function service(name, constructor) {
	    return factory(name, ['$injector', function($injector) {
	      return $injector.instantiate(constructor);
	    }]);
	  }
	
	  function value(name, val) { return factory(name, valueFn(val), false); }
	
	  function constant(name, value) {
	    assertNotHasOwnProperty(name, 'constant');
	    providerCache[name] = value;
	    instanceCache[name] = value;
	  }
	
	  function decorator(serviceName, decorFn) {
	    var origProvider = providerInjector.get(serviceName + providerSuffix),
	        orig$get = origProvider.$get;
	
	    origProvider.$get = function() {
	      var origInstance = instanceInjector.invoke(orig$get, origProvider);
	      return instanceInjector.invoke(decorFn, null, {$delegate: origInstance});
	    };
	  }
	
	  ////////////////////////////////////
	  // Module Loading
	  ////////////////////////////////////
	  function loadModules(modulesToLoad) {
	    assertArg(isUndefined(modulesToLoad) || isArray(modulesToLoad), 'modulesToLoad', 'not an array');
	    var runBlocks = [], moduleFn;
	    forEach(modulesToLoad, function(module) {
	      if (loadedModules.get(module)) return;
	      loadedModules.put(module, true);
	
	      function runInvokeQueue(queue) {
	        var i, ii;
	        for (i = 0, ii = queue.length; i < ii; i++) {
	          var invokeArgs = queue[i],
	              provider = providerInjector.get(invokeArgs[0]);
	
	          provider[invokeArgs[1]].apply(provider, invokeArgs[2]);
	        }
	      }
	
	      try {
	        if (isString(module)) {
	          moduleFn = angularModule(module);
	          runBlocks = runBlocks.concat(loadModules(moduleFn.requires)).concat(moduleFn._runBlocks);
	          runInvokeQueue(moduleFn._invokeQueue);
	          runInvokeQueue(moduleFn._configBlocks);
	        } else if (isFunction(module)) {
	            runBlocks.push(providerInjector.invoke(module));
	        } else if (isArray(module)) {
	            runBlocks.push(providerInjector.invoke(module));
	        } else {
	          assertArgFn(module, 'module');
	        }
	      } catch (e) {
	        if (isArray(module)) {
	          module = module[module.length - 1];
	        }
	        if (e.message && e.stack && e.stack.indexOf(e.message) == -1) {
	          // Safari & FF's stack traces don't contain error.message content
	          // unlike those of Chrome and IE
	          // So if stack doesn't contain message, we create a new string that contains both.
	          // Since error.stack is read-only in Safari, I'm overriding e and not e.stack here.
	          /* jshint -W022 */
	          e = e.message + '\n' + e.stack;
	        }
	        throw $injectorMinErr('modulerr', "Failed to instantiate module {0} due to:\n{1}",
	                  module, e.stack || e.message || e);
	      }
	    });
	    return runBlocks;
	  }
	
	  ////////////////////////////////////
	  // internal Injector
	  ////////////////////////////////////
	
	  function createInternalInjector(cache, factory) {
	
	    function getService(serviceName, caller) {
	      if (cache.hasOwnProperty(serviceName)) {
	        if (cache[serviceName] === INSTANTIATING) {
	          throw $injectorMinErr('cdep', 'Circular dependency found: {0}',
	                    serviceName + ' <- ' + path.join(' <- '));
	        }
	        return cache[serviceName];
	      } else {
	        try {
	          path.unshift(serviceName);
	          cache[serviceName] = INSTANTIATING;
	          return cache[serviceName] = factory(serviceName, caller);
	        } catch (err) {
	          if (cache[serviceName] === INSTANTIATING) {
	            delete cache[serviceName];
	          }
	          throw err;
	        } finally {
	          path.shift();
	        }
	      }
	    }
	
	
	    function injectionArgs(fn, locals, serviceName) {
	      var args = [],
	          $inject = createInjector.$$annotate(fn, strictDi, serviceName);
	
	      for (var i = 0, length = $inject.length; i < length; i++) {
	        var key = $inject[i];
	        if (typeof key !== 'string') {
	          throw $injectorMinErr('itkn',
	                  'Incorrect injection token! Expected service name as string, got {0}', key);
	        }
	        args.push(locals && locals.hasOwnProperty(key) ? locals[key] :
	                                                         getService(key, serviceName));
	      }
	      return args;
	    }
	
	    function isClass(func) {
	      // IE 9-11 do not support classes and IE9 leaks with the code below.
	      if (msie <= 11) {
	        return false;
	      }
	      // Workaround for MS Edge.
	      // Check https://connect.microsoft.com/IE/Feedback/Details/2211653
	      return typeof func === 'function'
	        && /^(?:class\s|constructor\()/.test(stringifyFn(func));
	    }
	
	    function invoke(fn, self, locals, serviceName) {
	      if (typeof locals === 'string') {
	        serviceName = locals;
	        locals = null;
	      }
	
	      var args = injectionArgs(fn, locals, serviceName);
	      if (isArray(fn)) {
	        fn = fn[fn.length - 1];
	      }
	
	      if (!isClass(fn)) {
	        // http://jsperf.com/angularjs-invoke-apply-vs-switch
	        // #5388
	        return fn.apply(self, args);
	      } else {
	        args.unshift(null);
	        return new (Function.prototype.bind.apply(fn, args))();
	      }
	    }
	
	
	    function instantiate(Type, locals, serviceName) {
	      // Check if Type is annotated and use just the given function at n-1 as parameter
	      // e.g. someModule.factory('greeter', ['$window', function(renamed$window) {}]);
	      var ctor = (isArray(Type) ? Type[Type.length - 1] : Type);
	      var args = injectionArgs(Type, locals, serviceName);
	      // Empty object at position 0 is ignored for invocation with `new`, but required.
	      args.unshift(null);
	      return new (Function.prototype.bind.apply(ctor, args))();
	    }
	
	
	    return {
	      invoke: invoke,
	      instantiate: instantiate,
	      get: getService,
	      annotate: createInjector.$$annotate,
	      has: function(name) {
	        return providerCache.hasOwnProperty(name + providerSuffix) || cache.hasOwnProperty(name);
	      }
	    };
	  }
	}
	
	createInjector.$$annotate = annotate;
	
	/**
	 * @ngdoc provider
	 * @name $anchorScrollProvider
	 *
	 * @description
	 * Use `$anchorScrollProvider` to disable automatic scrolling whenever
	 * {@link ng.$location#hash $location.hash()} changes.
	 */
	function $AnchorScrollProvider() {
	
	  var autoScrollingEnabled = true;
	
	  /**
	   * @ngdoc method
	   * @name $anchorScrollProvider#disableAutoScrolling
	   *
	   * @description
	   * By default, {@link ng.$anchorScroll $anchorScroll()} will automatically detect changes to
	   * {@link ng.$location#hash $location.hash()} and scroll to the element matching the new hash.<br />
	   * Use this method to disable automatic scrolling.
	   *
	   * If automatic scrolling is disabled, one must explicitly call
	   * {@link ng.$anchorScroll $anchorScroll()} in order to scroll to the element related to the
	   * current hash.
	   */
	  this.disableAutoScrolling = function() {
	    autoScrollingEnabled = false;
	  };
	
	  /**
	   * @ngdoc service
	   * @name $anchorScroll
	   * @kind function
	   * @requires $window
	   * @requires $location
	   * @requires $rootScope
	   *
	   * @description
	   * When called, it scrolls to the element related to the specified `hash` or (if omitted) to the
	   * current value of {@link ng.$location#hash $location.hash()}, according to the rules specified
	   * in the
	   * [HTML5 spec](http://www.w3.org/html/wg/drafts/html/master/browsers.html#an-indicated-part-of-the-document).
	   *
	   * It also watches the {@link ng.$location#hash $location.hash()} and automatically scrolls to
	   * match any anchor whenever it changes. This can be disabled by calling
	   * {@link ng.$anchorScrollProvider#disableAutoScrolling $anchorScrollProvider.disableAutoScrolling()}.
	   *
	   * Additionally, you can use its {@link ng.$anchorScroll#yOffset yOffset} property to specify a
	   * vertical scroll-offset (either fixed or dynamic).
	   *
	   * @param {string=} hash The hash specifying the element to scroll to. If omitted, the value of
	   *                       {@link ng.$location#hash $location.hash()} will be used.
	   *
	   * @property {(number|function|jqLite)} yOffset
	   * If set, specifies a vertical scroll-offset. This is often useful when there are fixed
	   * positioned elements at the top of the page, such as navbars, headers etc.
	   *
	   * `yOffset` can be specified in various ways:
	   * - **number**: A fixed number of pixels to be used as offset.<br /><br />
	   * - **function**: A getter function called everytime `$anchorScroll()` is executed. Must return
	   *   a number representing the offset (in pixels).<br /><br />
	   * - **jqLite**: A jqLite/jQuery element to be used for specifying the offset. The distance from
	   *   the top of the page to the element's bottom will be used as offset.<br />
	   *   **Note**: The element will be taken into account only as long as its `position` is set to
	   *   `fixed`. This option is useful, when dealing with responsive navbars/headers that adjust
	   *   their height and/or positioning according to the viewport's size.
	   *
	   * <br />
	   * <div class="alert alert-warning">
	   * In order for `yOffset` to work properly, scrolling should take place on the document's root and
	   * not some child element.
	   * </div>
	   *
	   * @example
	     <example module="anchorScrollExample">
	       <file name="index.html">
	         <div id="scrollArea" ng-controller="ScrollController">
	           <a ng-click="gotoBottom()">Go to bottom</a>
	           <a id="bottom"></a> You're at the bottom!
	         </div>
	       </file>
	       <file name="script.js">
	         angular.module('anchorScrollExample', [])
	           .controller('ScrollController', ['$scope', '$location', '$anchorScroll',
	             function ($scope, $location, $anchorScroll) {
	               $scope.gotoBottom = function() {
	                 // set the location.hash to the id of
	                 // the element you wish to scroll to.
	                 $location.hash('bottom');
	
	                 // call $anchorScroll()
	                 $anchorScroll();
	               };
	             }]);
	       </file>
	       <file name="style.css">
	         #scrollArea {
	           height: 280px;
	           overflow: auto;
	         }
	
	         #bottom {
	           display: block;
	           margin-top: 2000px;
	         }
	       </file>
	     </example>
	   *
	   * <hr />
	   * The example below illustrates the use of a vertical scroll-offset (specified as a fixed value).
	   * See {@link ng.$anchorScroll#yOffset $anchorScroll.yOffset} for more details.
	   *
	   * @example
	     <example module="anchorScrollOffsetExample">
	       <file name="index.html">
	         <div class="fixed-header" ng-controller="headerCtrl">
	           <a href="" ng-click="gotoAnchor(x)" ng-repeat="x in [1,2,3,4,5]">
	             Go to anchor {{x}}
	           </a>
	         </div>
	         <div id="anchor{{x}}" class="anchor" ng-repeat="x in [1,2,3,4,5]">
	           Anchor {{x}} of 5
	         </div>
	       </file>
	       <file name="script.js">
	         angular.module('anchorScrollOffsetExample', [])
	           .run(['$anchorScroll', function($anchorScroll) {
	             $anchorScroll.yOffset = 50;   // always scroll by 50 extra pixels
	           }])
	           .controller('headerCtrl', ['$anchorScroll', '$location', '$scope',
	             function ($anchorScroll, $location, $scope) {
	               $scope.gotoAnchor = function(x) {
	                 var newHash = 'anchor' + x;
	                 if ($location.hash() !== newHash) {
	                   // set the $location.hash to `newHash` and
	                   // $anchorScroll will automatically scroll to it
	                   $location.hash('anchor' + x);
	                 } else {
	                   // call $anchorScroll() explicitly,
	                   // since $location.hash hasn't changed
	                   $anchorScroll();
	                 }
	               };
	             }
	           ]);
	       </file>
	       <file name="style.css">
	         body {
	           padding-top: 50px;
	         }
	
	         .anchor {
	           border: 2px dashed DarkOrchid;
	           padding: 10px 10px 200px 10px;
	         }
	
	         .fixed-header {
	           background-color: rgba(0, 0, 0, 0.2);
	           height: 50px;
	           position: fixed;
	           top: 0; left: 0; right: 0;
	         }
	
	         .fixed-header > a {
	           display: inline-block;
	           margin: 5px 15px;
	         }
	       </file>
	     </example>
	   */
	  this.$get = ['$window', '$location', '$rootScope', function($window, $location, $rootScope) {
	    var document = $window.document;
	
	    // Helper function to get first anchor from a NodeList
	    // (using `Array#some()` instead of `angular#forEach()` since it's more performant
	    //  and working in all supported browsers.)
	    function getFirstAnchor(list) {
	      var result = null;
	      Array.prototype.some.call(list, function(element) {
	        if (nodeName_(element) === 'a') {
	          result = element;
	          return true;
	        }
	      });
	      return result;
	    }
	
	    function getYOffset() {
	
	      var offset = scroll.yOffset;
	
	      if (isFunction(offset)) {
	        offset = offset();
	      } else if (isElement(offset)) {
	        var elem = offset[0];
	        var style = $window.getComputedStyle(elem);
	        if (style.position !== 'fixed') {
	          offset = 0;
	        } else {
	          offset = elem.getBoundingClientRect().bottom;
	        }
	      } else if (!isNumber(offset)) {
	        offset = 0;
	      }
	
	      return offset;
	    }
	
	    function scrollTo(elem) {
	      if (elem) {
	        elem.scrollIntoView();
	
	        var offset = getYOffset();
	
	        if (offset) {
	          // `offset` is the number of pixels we should scroll UP in order to align `elem` properly.
	          // This is true ONLY if the call to `elem.scrollIntoView()` initially aligns `elem` at the
	          // top of the viewport.
	          //
	          // IF the number of pixels from the top of `elem` to the end of the page's content is less
	          // than the height of the viewport, then `elem.scrollIntoView()` will align the `elem` some
	          // way down the page.
	          //
	          // This is often the case for elements near the bottom of the page.
	          //
	          // In such cases we do not need to scroll the whole `offset` up, just the difference between
	          // the top of the element and the offset, which is enough to align the top of `elem` at the
	          // desired position.
	          var elemTop = elem.getBoundingClientRect().top;
	          $window.scrollBy(0, elemTop - offset);
	        }
	      } else {
	        $window.scrollTo(0, 0);
	      }
	    }
	
	    function scroll(hash) {
	      hash = isString(hash) ? hash : $location.hash();
	      var elm;
	
	      // empty hash, scroll to the top of the page
	      if (!hash) scrollTo(null);
	
	      // element with given id
	      else if ((elm = document.getElementById(hash))) scrollTo(elm);
	
	      // first anchor with given name :-D
	      else if ((elm = getFirstAnchor(document.getElementsByName(hash)))) scrollTo(elm);
	
	      // no element and hash == 'top', scroll to the top of the page
	      else if (hash === 'top') scrollTo(null);
	    }
	
	    // does not scroll when user clicks on anchor link that is currently on
	    // (no url change, no $location.hash() change), browser native does scroll
	    if (autoScrollingEnabled) {
	      $rootScope.$watch(function autoScrollWatch() {return $location.hash();},
	        function autoScrollWatchAction(newVal, oldVal) {
	          // skip the initial scroll if $location.hash is empty
	          if (newVal === oldVal && newVal === '') return;
	
	          jqLiteDocumentLoaded(function() {
	            $rootScope.$evalAsync(scroll);
	          });
	        });
	    }
	
	    return scroll;
	  }];
	}
	
	var $animateMinErr = minErr('$animate');
	var ELEMENT_NODE = 1;
	var NG_ANIMATE_CLASSNAME = 'ng-animate';
	
	function mergeClasses(a,b) {
	  if (!a && !b) return '';
	  if (!a) return b;
	  if (!b) return a;
	  if (isArray(a)) a = a.join(' ');
	  if (isArray(b)) b = b.join(' ');
	  return a + ' ' + b;
	}
	
	function extractElementNode(element) {
	  for (var i = 0; i < element.length; i++) {
	    var elm = element[i];
	    if (elm.nodeType === ELEMENT_NODE) {
	      return elm;
	    }
	  }
	}
	
	function splitClasses(classes) {
	  if (isString(classes)) {
	    classes = classes.split(' ');
	  }
	
	  // Use createMap() to prevent class assumptions involving property names in
	  // Object.prototype
	  var obj = createMap();
	  forEach(classes, function(klass) {
	    // sometimes the split leaves empty string values
	    // incase extra spaces were applied to the options
	    if (klass.length) {
	      obj[klass] = true;
	    }
	  });
	  return obj;
	}
	
	// if any other type of options value besides an Object value is
	// passed into the $animate.method() animation then this helper code
	// will be run which will ignore it. While this patch is not the
	// greatest solution to this, a lot of existing plugins depend on
	// $animate to either call the callback (< 1.2) or return a promise
	// that can be changed. This helper function ensures that the options
	// are wiped clean incase a callback function is provided.
	function prepareAnimateOptions(options) {
	  return isObject(options)
	      ? options
	      : {};
	}
	
	var $$CoreAnimateJsProvider = function() {
	  this.$get = noop;
	};
	
	// this is prefixed with Core since it conflicts with
	// the animateQueueProvider defined in ngAnimate/animateQueue.js
	var $$CoreAnimateQueueProvider = function() {
	  var postDigestQueue = new HashMap();
	  var postDigestElements = [];
	
	  this.$get = ['$$AnimateRunner', '$rootScope',
	       function($$AnimateRunner,   $rootScope) {
	    return {
	      enabled: noop,
	      on: noop,
	      off: noop,
	      pin: noop,
	
	      push: function(element, event, options, domOperation) {
	        domOperation        && domOperation();
	
	        options = options || {};
	        options.from        && element.css(options.from);
	        options.to          && element.css(options.to);
	
	        if (options.addClass || options.removeClass) {
	          addRemoveClassesPostDigest(element, options.addClass, options.removeClass);
	        }
	
	        var runner = new $$AnimateRunner(); // jshint ignore:line
	
	        // since there are no animations to run the runner needs to be
	        // notified that the animation call is complete.
	        runner.complete();
	        return runner;
	      }
	    };
	
	
	    function updateData(data, classes, value) {
	      var changed = false;
	      if (classes) {
	        classes = isString(classes) ? classes.split(' ') :
	                  isArray(classes) ? classes : [];
	        forEach(classes, function(className) {
	          if (className) {
	            changed = true;
	            data[className] = value;
	          }
	        });
	      }
	      return changed;
	    }
	
	    function handleCSSClassChanges() {
	      forEach(postDigestElements, function(element) {
	        var data = postDigestQueue.get(element);
	        if (data) {
	          var existing = splitClasses(element.attr('class'));
	          var toAdd = '';
	          var toRemove = '';
	          forEach(data, function(status, className) {
	            var hasClass = !!existing[className];
	            if (status !== hasClass) {
	              if (status) {
	                toAdd += (toAdd.length ? ' ' : '') + className;
	              } else {
	                toRemove += (toRemove.length ? ' ' : '') + className;
	              }
	            }
	          });
	
	          forEach(element, function(elm) {
	            toAdd    && jqLiteAddClass(elm, toAdd);
	            toRemove && jqLiteRemoveClass(elm, toRemove);
	          });
	          postDigestQueue.remove(element);
	        }
	      });
	      postDigestElements.length = 0;
	    }
	
	
	    function addRemoveClassesPostDigest(element, add, remove) {
	      var data = postDigestQueue.get(element) || {};
	
	      var classesAdded = updateData(data, add, true);
	      var classesRemoved = updateData(data, remove, false);
	
	      if (classesAdded || classesRemoved) {
	
	        postDigestQueue.put(element, data);
	        postDigestElements.push(element);
	
	        if (postDigestElements.length === 1) {
	          $rootScope.$$postDigest(handleCSSClassChanges);
	        }
	      }
	    }
	  }];
	};
	
	/**
	 * @ngdoc provider
	 * @name $animateProvider
	 *
	 * @description
	 * Default implementation of $animate that doesn't perform any animations, instead just
	 * synchronously performs DOM updates and resolves the returned runner promise.
	 *
	 * In order to enable animations the `ngAnimate` module has to be loaded.
	 *
	 * To see the functional implementation check out `src/ngAnimate/animate.js`.
	 */
	var $AnimateProvider = ['$provide', function($provide) {
	  var provider = this;
	
	  this.$$registeredAnimations = Object.create(null);
	
	   /**
	   * @ngdoc method
	   * @name $animateProvider#register
	   *
	   * @description
	   * Registers a new injectable animation factory function. The factory function produces the
	   * animation object which contains callback functions for each event that is expected to be
	   * animated.
	   *
	   *   * `eventFn`: `function(element, ... , doneFunction, options)`
	   *   The element to animate, the `doneFunction` and the options fed into the animation. Depending
	   *   on the type of animation additional arguments will be injected into the animation function. The
	   *   list below explains the function signatures for the different animation methods:
	   *
	   *   - setClass: function(element, addedClasses, removedClasses, doneFunction, options)
	   *   - addClass: function(element, addedClasses, doneFunction, options)
	   *   - removeClass: function(element, removedClasses, doneFunction, options)
	   *   - enter, leave, move: function(element, doneFunction, options)
	   *   - animate: function(element, fromStyles, toStyles, doneFunction, options)
	   *
	   *   Make sure to trigger the `doneFunction` once the animation is fully complete.
	   *
	   * ```js
	   *   return {
	   *     //enter, leave, move signature
	   *     eventFn : function(element, done, options) {
	   *       //code to run the animation
	   *       //once complete, then run done()
	   *       return function endFunction(wasCancelled) {
	   *         //code to cancel the animation
	   *       }
	   *     }
	   *   }
	   * ```
	   *
	   * @param {string} name The name of the animation (this is what the class-based CSS value will be compared to).
	   * @param {Function} factory The factory function that will be executed to return the animation
	   *                           object.
	   */
	  this.register = function(name, factory) {
	    if (name && name.charAt(0) !== '.') {
	      throw $animateMinErr('notcsel', "Expecting class selector starting with '.' got '{0}'.", name);
	    }
	
	    var key = name + '-animation';
	    provider.$$registeredAnimations[name.substr(1)] = key;
	    $provide.factory(key, factory);
	  };
	
	  /**
	   * @ngdoc method
	   * @name $animateProvider#classNameFilter
	   *
	   * @description
	   * Sets and/or returns the CSS class regular expression that is checked when performing
	   * an animation. Upon bootstrap the classNameFilter value is not set at all and will
	   * therefore enable $animate to attempt to perform an animation on any element that is triggered.
	   * When setting the `classNameFilter` value, animations will only be performed on elements
	   * that successfully match the filter expression. This in turn can boost performance
	   * for low-powered devices as well as applications containing a lot of structural operations.
	   * @param {RegExp=} expression The className expression which will be checked against all animations
	   * @return {RegExp} The current CSS className expression value. If null then there is no expression value
	   */
	  this.classNameFilter = function(expression) {
	    if (arguments.length === 1) {
	      this.$$classNameFilter = (expression instanceof RegExp) ? expression : null;
	      if (this.$$classNameFilter) {
	        var reservedRegex = new RegExp("(\\s+|\\/)" + NG_ANIMATE_CLASSNAME + "(\\s+|\\/)");
	        if (reservedRegex.test(this.$$classNameFilter.toString())) {
	          throw $animateMinErr('nongcls','$animateProvider.classNameFilter(regex) prohibits accepting a regex value which matches/contains the "{0}" CSS class.', NG_ANIMATE_CLASSNAME);
	
	        }
	      }
	    }
	    return this.$$classNameFilter;
	  };
	
	  this.$get = ['$$animateQueue', function($$animateQueue) {
	    function domInsert(element, parentElement, afterElement) {
	      // if for some reason the previous element was removed
	      // from the dom sometime before this code runs then let's
	      // just stick to using the parent element as the anchor
	      if (afterElement) {
	        var afterNode = extractElementNode(afterElement);
	        if (afterNode && !afterNode.parentNode && !afterNode.previousElementSibling) {
	          afterElement = null;
	        }
	      }
	      afterElement ? afterElement.after(element) : parentElement.prepend(element);
	    }
	
	    /**
	     * @ngdoc service
	     * @name $animate
	     * @description The $animate service exposes a series of DOM utility methods that provide support
	     * for animation hooks. The default behavior is the application of DOM operations, however,
	     * when an animation is detected (and animations are enabled), $animate will do the heavy lifting
	     * to ensure that animation runs with the triggered DOM operation.
	     *
	     * By default $animate doesn't trigger any animations. This is because the `ngAnimate` module isn't
	     * included and only when it is active then the animation hooks that `$animate` triggers will be
	     * functional. Once active then all structural `ng-` directives will trigger animations as they perform
	     * their DOM-related operations (enter, leave and move). Other directives such as `ngClass`,
	     * `ngShow`, `ngHide` and `ngMessages` also provide support for animations.
	     *
	     * It is recommended that the`$animate` service is always used when executing DOM-related procedures within directives.
	     *
	     * To learn more about enabling animation support, click here to visit the
	     * {@link ngAnimate ngAnimate module page}.
	     */
	    return {
	      // we don't call it directly since non-existant arguments may
	      // be interpreted as null within the sub enabled function
	
	      /**
	       *
	       * @ngdoc method
	       * @name $animate#on
	       * @kind function
	       * @description Sets up an event listener to fire whenever the animation event (enter, leave, move, etc...)
	       *    has fired on the given element or among any of its children. Once the listener is fired, the provided callback
	       *    is fired with the following params:
	       *
	       * ```js
	       * $animate.on('enter', container,
	       *    function callback(element, phase) {
	       *      // cool we detected an enter animation within the container
	       *    }
	       * );
	       * ```
	       *
	       * @param {string} event the animation event that will be captured (e.g. enter, leave, move, addClass, removeClass, etc...)
	       * @param {DOMElement} container the container element that will capture each of the animation events that are fired on itself
	       *     as well as among its children
	       * @param {Function} callback the callback function that will be fired when the listener is triggered
	       *
	       * The arguments present in the callback function are:
	       * * `element` - The captured DOM element that the animation was fired on.
	       * * `phase` - The phase of the animation. The two possible phases are **start** (when the animation starts) and **close** (when it ends).
	       */
	      on: $$animateQueue.on,
	
	      /**
	       *
	       * @ngdoc method
	       * @name $animate#off
	       * @kind function
	       * @description Deregisters an event listener based on the event which has been associated with the provided element. This method
	       * can be used in three different ways depending on the arguments:
	       *
	       * ```js
	       * // remove all the animation event listeners listening for `enter`
	       * $animate.off('enter');
	       *
	       * // remove listeners for all animation events from the container element
	       * $animate.off(container);
	       *
	       * // remove all the animation event listeners listening for `enter` on the given element and its children
	       * $animate.off('enter', container);
	       *
	       * // remove the event listener function provided by `callback` that is set
	       * // to listen for `enter` on the given `container` as well as its children
	       * $animate.off('enter', container, callback);
	       * ```
	       *
	       * @param {string|DOMElement} event|container the animation event (e.g. enter, leave, move,
	       * addClass, removeClass, etc...), or the container element. If it is the element, all other
	       * arguments are ignored.
	       * @param {DOMElement=} container the container element the event listener was placed on
	       * @param {Function=} callback the callback function that was registered as the listener
	       */
	      off: $$animateQueue.off,
	
	      /**
	       * @ngdoc method
	       * @name $animate#pin
	       * @kind function
	       * @description Associates the provided element with a host parent element to allow the element to be animated even if it exists
	       *    outside of the DOM structure of the Angular application. By doing so, any animation triggered via `$animate` can be issued on the
	       *    element despite being outside the realm of the application or within another application. Say for example if the application
	       *    was bootstrapped on an element that is somewhere inside of the `<body>` tag, but we wanted to allow for an element to be situated
	       *    as a direct child of `document.body`, then this can be achieved by pinning the element via `$animate.pin(element)`. Keep in mind
	       *    that calling `$animate.pin(element, parentElement)` will not actually insert into the DOM anywhere; it will just create the association.
	       *
	       *    Note that this feature is only active when the `ngAnimate` module is used.
	       *
	       * @param {DOMElement} element the external element that will be pinned
	       * @param {DOMElement} parentElement the host parent element that will be associated with the external element
	       */
	      pin: $$animateQueue.pin,
	
	      /**
	       *
	       * @ngdoc method
	       * @name $animate#enabled
	       * @kind function
	       * @description Used to get and set whether animations are enabled or not on the entire application or on an element and its children. This
	       * function can be called in four ways:
	       *
	       * ```js
	       * // returns true or false
	       * $animate.enabled();
	       *
	       * // changes the enabled state for all animations
	       * $animate.enabled(false);
	       * $animate.enabled(true);
	       *
	       * // returns true or false if animations are enabled for an element
	       * $animate.enabled(element);
	       *
	       * // changes the enabled state for an element and its children
	       * $animate.enabled(element, true);
	       * $animate.enabled(element, false);
	       * ```
	       *
	       * @param {DOMElement=} element the element that will be considered for checking/setting the enabled state
	       * @param {boolean=} enabled whether or not the animations will be enabled for the element
	       *
	       * @return {boolean} whether or not animations are enabled
	       */
	      enabled: $$animateQueue.enabled,
	
	      /**
	       * @ngdoc method
	       * @name $animate#cancel
	       * @kind function
	       * @description Cancels the provided animation.
	       *
	       * @param {Promise} animationPromise The animation promise that is returned when an animation is started.
	       */
	      cancel: function(runner) {
	        runner.end && runner.end();
	      },
	
	      /**
	       *
	       * @ngdoc method
	       * @name $animate#enter
	       * @kind function
	       * @description Inserts the element into the DOM either after the `after` element (if provided) or
	       *   as the first child within the `parent` element and then triggers an animation.
	       *   A promise is returned that will be resolved during the next digest once the animation
	       *   has completed.
	       *
	       * @param {DOMElement} element the element which will be inserted into the DOM
	       * @param {DOMElement} parent the parent element which will append the element as
	       *   a child (so long as the after element is not present)
	       * @param {DOMElement=} after the sibling element after which the element will be appended
	       * @param {object=} options an optional collection of options/styles that will be applied to the element
	       *
	       * @return {Promise} the animation callback promise
	       */
	      enter: function(element, parent, after, options) {
	        parent = parent && jqLite(parent);
	        after = after && jqLite(after);
	        parent = parent || after.parent();
	        domInsert(element, parent, after);
	        return $$animateQueue.push(element, 'enter', prepareAnimateOptions(options));
	      },
	
	      /**
	       *
	       * @ngdoc method
	       * @name $animate#move
	       * @kind function
	       * @description Inserts (moves) the element into its new position in the DOM either after
	       *   the `after` element (if provided) or as the first child within the `parent` element
	       *   and then triggers an animation. A promise is returned that will be resolved
	       *   during the next digest once the animation has completed.
	       *
	       * @param {DOMElement} element the element which will be moved into the new DOM position
	       * @param {DOMElement} parent the parent element which will append the element as
	       *   a child (so long as the after element is not present)
	       * @param {DOMElement=} after the sibling element after which the element will be appended
	       * @param {object=} options an optional collection of options/styles that will be applied to the element
	       *
	       * @return {Promise} the animation callback promise
	       */
	      move: function(element, parent, after, options) {
	        parent = parent && jqLite(parent);
	        after = after && jqLite(after);
	        parent = parent || after.parent();
	        domInsert(element, parent, after);
	        return $$animateQueue.push(element, 'move', prepareAnimateOptions(options));
	      },
	
	      /**
	       * @ngdoc method
	       * @name $animate#leave
	       * @kind function
	       * @description Triggers an animation and then removes the element from the DOM.
	       * When the function is called a promise is returned that will be resolved during the next
	       * digest once the animation has completed.
	       *
	       * @param {DOMElement} element the element which will be removed from the DOM
	       * @param {object=} options an optional collection of options/styles that will be applied to the element
	       *
	       * @return {Promise} the animation callback promise
	       */
	      leave: function(element, options) {
	        return $$animateQueue.push(element, 'leave', prepareAnimateOptions(options), function() {
	          element.remove();
	        });
	      },
	
	      /**
	       * @ngdoc method
	       * @name $animate#addClass
	       * @kind function
	       *
	       * @description Triggers an addClass animation surrounding the addition of the provided CSS class(es). Upon
	       *   execution, the addClass operation will only be handled after the next digest and it will not trigger an
	       *   animation if element already contains the CSS class or if the class is removed at a later step.
	       *   Note that class-based animations are treated differently compared to structural animations
	       *   (like enter, move and leave) since the CSS classes may be added/removed at different points
	       *   depending if CSS or JavaScript animations are used.
	       *
	       * @param {DOMElement} element the element which the CSS classes will be applied to
	       * @param {string} className the CSS class(es) that will be added (multiple classes are separated via spaces)
	       * @param {object=} options an optional collection of options/styles that will be applied to the element
	       *
	       * @return {Promise} the animation callback promise
	       */
	      addClass: function(element, className, options) {
	        options = prepareAnimateOptions(options);
	        options.addClass = mergeClasses(options.addclass, className);
	        return $$animateQueue.push(element, 'addClass', options);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $animate#removeClass
	       * @kind function
	       *
	       * @description Triggers a removeClass animation surrounding the removal of the provided CSS class(es). Upon
	       *   execution, the removeClass operation will only be handled after the next digest and it will not trigger an
	       *   animation if element does not contain the CSS class or if the class is added at a later step.
	       *   Note that class-based animations are treated differently compared to structural animations
	       *   (like enter, move and leave) since the CSS classes may be added/removed at different points
	       *   depending if CSS or JavaScript animations are used.
	       *
	       * @param {DOMElement} element the element which the CSS classes will be applied to
	       * @param {string} className the CSS class(es) that will be removed (multiple classes are separated via spaces)
	       * @param {object=} options an optional collection of options/styles that will be applied to the element
	       *
	       * @return {Promise} the animation callback promise
	       */
	      removeClass: function(element, className, options) {
	        options = prepareAnimateOptions(options);
	        options.removeClass = mergeClasses(options.removeClass, className);
	        return $$animateQueue.push(element, 'removeClass', options);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $animate#setClass
	       * @kind function
	       *
	       * @description Performs both the addition and removal of a CSS classes on an element and (during the process)
	       *    triggers an animation surrounding the class addition/removal. Much like `$animate.addClass` and
	       *    `$animate.removeClass`, `setClass` will only evaluate the classes being added/removed once a digest has
	       *    passed. Note that class-based animations are treated differently compared to structural animations
	       *    (like enter, move and leave) since the CSS classes may be added/removed at different points
	       *    depending if CSS or JavaScript animations are used.
	       *
	       * @param {DOMElement} element the element which the CSS classes will be applied to
	       * @param {string} add the CSS class(es) that will be added (multiple classes are separated via spaces)
	       * @param {string} remove the CSS class(es) that will be removed (multiple classes are separated via spaces)
	       * @param {object=} options an optional collection of options/styles that will be applied to the element
	       *
	       * @return {Promise} the animation callback promise
	       */
	      setClass: function(element, add, remove, options) {
	        options = prepareAnimateOptions(options);
	        options.addClass = mergeClasses(options.addClass, add);
	        options.removeClass = mergeClasses(options.removeClass, remove);
	        return $$animateQueue.push(element, 'setClass', options);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $animate#animate
	       * @kind function
	       *
	       * @description Performs an inline animation on the element which applies the provided to and from CSS styles to the element.
	       * If any detected CSS transition, keyframe or JavaScript matches the provided className value, then the animation will take
	       * on the provided styles. For example, if a transition animation is set for the given classNamem, then the provided `from` and
	       * `to` styles will be applied alongside the given transition. If the CSS style provided in `from` does not have a corresponding
	       * style in `to`, the style in `from` is applied immediately, and no animation is run.
	       * If a JavaScript animation is detected then the provided styles will be given in as function parameters into the `animate`
	       * method (or as part of the `options` parameter):
	       *
	       * ```js
	       * ngModule.animation('.my-inline-animation', function() {
	       *   return {
	       *     animate : function(element, from, to, done, options) {
	       *       //animation
	       *       done();
	       *     }
	       *   }
	       * });
	       * ```
	       *
	       * @param {DOMElement} element the element which the CSS styles will be applied to
	       * @param {object} from the from (starting) CSS styles that will be applied to the element and across the animation.
	       * @param {object} to the to (destination) CSS styles that will be applied to the element and across the animation.
	       * @param {string=} className an optional CSS class that will be applied to the element for the duration of the animation. If
	       *    this value is left as empty then a CSS class of `ng-inline-animate` will be applied to the element.
	       *    (Note that if no animation is detected then this value will not be applied to the element.)
	       * @param {object=} options an optional collection of options/styles that will be applied to the element
	       *
	       * @return {Promise} the animation callback promise
	       */
	      animate: function(element, from, to, className, options) {
	        options = prepareAnimateOptions(options);
	        options.from = options.from ? extend(options.from, from) : from;
	        options.to   = options.to   ? extend(options.to, to)     : to;
	
	        className = className || 'ng-inline-animate';
	        options.tempClasses = mergeClasses(options.tempClasses, className);
	        return $$animateQueue.push(element, 'animate', options);
	      }
	    };
	  }];
	}];
	
	var $$AnimateAsyncRunFactoryProvider = function() {
	  this.$get = ['$$rAF', function($$rAF) {
	    var waitQueue = [];
	
	    function waitForTick(fn) {
	      waitQueue.push(fn);
	      if (waitQueue.length > 1) return;
	      $$rAF(function() {
	        for (var i = 0; i < waitQueue.length; i++) {
	          waitQueue[i]();
	        }
	        waitQueue = [];
	      });
	    }
	
	    return function() {
	      var passed = false;
	      waitForTick(function() {
	        passed = true;
	      });
	      return function(callback) {
	        passed ? callback() : waitForTick(callback);
	      };
	    };
	  }];
	};
	
	var $$AnimateRunnerFactoryProvider = function() {
	  this.$get = ['$q', '$sniffer', '$$animateAsyncRun', '$document', '$timeout',
	       function($q,   $sniffer,   $$animateAsyncRun,   $document,   $timeout) {
	
	    var INITIAL_STATE = 0;
	    var DONE_PENDING_STATE = 1;
	    var DONE_COMPLETE_STATE = 2;
	
	    AnimateRunner.chain = function(chain, callback) {
	      var index = 0;
	
	      next();
	      function next() {
	        if (index === chain.length) {
	          callback(true);
	          return;
	        }
	
	        chain[index](function(response) {
	          if (response === false) {
	            callback(false);
	            return;
	          }
	          index++;
	          next();
	        });
	      }
	    };
	
	    AnimateRunner.all = function(runners, callback) {
	      var count = 0;
	      var status = true;
	      forEach(runners, function(runner) {
	        runner.done(onProgress);
	      });
	
	      function onProgress(response) {
	        status = status && response;
	        if (++count === runners.length) {
	          callback(status);
	        }
	      }
	    };
	
	    function AnimateRunner(host) {
	      this.setHost(host);
	
	      var rafTick = $$animateAsyncRun();
	      var timeoutTick = function(fn) {
	        $timeout(fn, 0, false);
	      };
	
	      this._doneCallbacks = [];
	      this._tick = function(fn) {
	        var doc = $document[0];
	
	        // the document may not be ready or attached
	        // to the module for some internal tests
	        if (doc && doc.hidden) {
	          timeoutTick(fn);
	        } else {
	          rafTick(fn);
	        }
	      };
	      this._state = 0;
	    }
	
	    AnimateRunner.prototype = {
	      setHost: function(host) {
	        this.host = host || {};
	      },
	
	      done: function(fn) {
	        if (this._state === DONE_COMPLETE_STATE) {
	          fn();
	        } else {
	          this._doneCallbacks.push(fn);
	        }
	      },
	
	      progress: noop,
	
	      getPromise: function() {
	        if (!this.promise) {
	          var self = this;
	          this.promise = $q(function(resolve, reject) {
	            self.done(function(status) {
	              status === false ? reject() : resolve();
	            });
	          });
	        }
	        return this.promise;
	      },
	
	      then: function(resolveHandler, rejectHandler) {
	        return this.getPromise().then(resolveHandler, rejectHandler);
	      },
	
	      'catch': function(handler) {
	        return this.getPromise()['catch'](handler);
	      },
	
	      'finally': function(handler) {
	        return this.getPromise()['finally'](handler);
	      },
	
	      pause: function() {
	        if (this.host.pause) {
	          this.host.pause();
	        }
	      },
	
	      resume: function() {
	        if (this.host.resume) {
	          this.host.resume();
	        }
	      },
	
	      end: function() {
	        if (this.host.end) {
	          this.host.end();
	        }
	        this._resolve(true);
	      },
	
	      cancel: function() {
	        if (this.host.cancel) {
	          this.host.cancel();
	        }
	        this._resolve(false);
	      },
	
	      complete: function(response) {
	        var self = this;
	        if (self._state === INITIAL_STATE) {
	          self._state = DONE_PENDING_STATE;
	          self._tick(function() {
	            self._resolve(response);
	          });
	        }
	      },
	
	      _resolve: function(response) {
	        if (this._state !== DONE_COMPLETE_STATE) {
	          forEach(this._doneCallbacks, function(fn) {
	            fn(response);
	          });
	          this._doneCallbacks.length = 0;
	          this._state = DONE_COMPLETE_STATE;
	        }
	      }
	    };
	
	    return AnimateRunner;
	  }];
	};
	
	/**
	 * @ngdoc service
	 * @name $animateCss
	 * @kind object
	 *
	 * @description
	 * This is the core version of `$animateCss`. By default, only when the `ngAnimate` is included,
	 * then the `$animateCss` service will actually perform animations.
	 *
	 * Click here {@link ngAnimate.$animateCss to read the documentation for $animateCss}.
	 */
	var $CoreAnimateCssProvider = function() {
	  this.$get = ['$$rAF', '$q', '$$AnimateRunner', function($$rAF, $q, $$AnimateRunner) {
	
	    return function(element, initialOptions) {
	      // all of the animation functions should create
	      // a copy of the options data, however, if a
	      // parent service has already created a copy then
	      // we should stick to using that
	      var options = initialOptions || {};
	      if (!options.$$prepared) {
	        options = copy(options);
	      }
	
	      // there is no point in applying the styles since
	      // there is no animation that goes on at all in
	      // this version of $animateCss.
	      if (options.cleanupStyles) {
	        options.from = options.to = null;
	      }
	
	      if (options.from) {
	        element.css(options.from);
	        options.from = null;
	      }
	
	      /* jshint newcap: false */
	      var closed, runner = new $$AnimateRunner();
	      return {
	        start: run,
	        end: run
	      };
	
	      function run() {
	        $$rAF(function() {
	          applyAnimationContents();
	          if (!closed) {
	            runner.complete();
	          }
	          closed = true;
	        });
	        return runner;
	      }
	
	      function applyAnimationContents() {
	        if (options.addClass) {
	          element.addClass(options.addClass);
	          options.addClass = null;
	        }
	        if (options.removeClass) {
	          element.removeClass(options.removeClass);
	          options.removeClass = null;
	        }
	        if (options.to) {
	          element.css(options.to);
	          options.to = null;
	        }
	      }
	    };
	  }];
	};
	
	/* global stripHash: true */
	
	/**
	 * ! This is a private undocumented service !
	 *
	 * @name $browser
	 * @requires $log
	 * @description
	 * This object has two goals:
	 *
	 * - hide all the global state in the browser caused by the window object
	 * - abstract away all the browser specific features and inconsistencies
	 *
	 * For tests we provide {@link ngMock.$browser mock implementation} of the `$browser`
	 * service, which can be used for convenient testing of the application without the interaction with
	 * the real browser apis.
	 */
	/**
	 * @param {object} window The global window object.
	 * @param {object} document jQuery wrapped document.
	 * @param {object} $log window.console or an object with the same interface.
	 * @param {object} $sniffer $sniffer service
	 */
	function Browser(window, document, $log, $sniffer) {
	  var self = this,
	      location = window.location,
	      history = window.history,
	      setTimeout = window.setTimeout,
	      clearTimeout = window.clearTimeout,
	      pendingDeferIds = {};
	
	  self.isMock = false;
	
	  var outstandingRequestCount = 0;
	  var outstandingRequestCallbacks = [];
	
	  // TODO(vojta): remove this temporary api
	  self.$$completeOutstandingRequest = completeOutstandingRequest;
	  self.$$incOutstandingRequestCount = function() { outstandingRequestCount++; };
	
	  /**
	   * Executes the `fn` function(supports currying) and decrements the `outstandingRequestCallbacks`
	   * counter. If the counter reaches 0, all the `outstandingRequestCallbacks` are executed.
	   */
	  function completeOutstandingRequest(fn) {
	    try {
	      fn.apply(null, sliceArgs(arguments, 1));
	    } finally {
	      outstandingRequestCount--;
	      if (outstandingRequestCount === 0) {
	        while (outstandingRequestCallbacks.length) {
	          try {
	            outstandingRequestCallbacks.pop()();
	          } catch (e) {
	            $log.error(e);
	          }
	        }
	      }
	    }
	  }
	
	  function getHash(url) {
	    var index = url.indexOf('#');
	    return index === -1 ? '' : url.substr(index);
	  }
	
	  /**
	   * @private
	   * Note: this method is used only by scenario runner
	   * TODO(vojta): prefix this method with $$ ?
	   * @param {function()} callback Function that will be called when no outstanding request
	   */
	  self.notifyWhenNoOutstandingRequests = function(callback) {
	    if (outstandingRequestCount === 0) {
	      callback();
	    } else {
	      outstandingRequestCallbacks.push(callback);
	    }
	  };
	
	  //////////////////////////////////////////////////////////////
	  // URL API
	  //////////////////////////////////////////////////////////////
	
	  var cachedState, lastHistoryState,
	      lastBrowserUrl = location.href,
	      baseElement = document.find('base'),
	      pendingLocation = null,
	      getCurrentState = !$sniffer.history ? noop : function getCurrentState() {
	        try {
	          return history.state;
	        } catch (e) {
	          // MSIE can reportedly throw when there is no state (UNCONFIRMED).
	        }
	      };
	
	  cacheState();
	  lastHistoryState = cachedState;
	
	  /**
	   * @name $browser#url
	   *
	   * @description
	   * GETTER:
	   * Without any argument, this method just returns current value of location.href.
	   *
	   * SETTER:
	   * With at least one argument, this method sets url to new value.
	   * If html5 history api supported, pushState/replaceState is used, otherwise
	   * location.href/location.replace is used.
	   * Returns its own instance to allow chaining
	   *
	   * NOTE: this api is intended for use only by the $location service. Please use the
	   * {@link ng.$location $location service} to change url.
	   *
	   * @param {string} url New url (when used as setter)
	   * @param {boolean=} replace Should new url replace current history record?
	   * @param {object=} state object to use with pushState/replaceState
	   */
	  self.url = function(url, replace, state) {
	    // In modern browsers `history.state` is `null` by default; treating it separately
	    // from `undefined` would cause `$browser.url('/foo')` to change `history.state`
	    // to undefined via `pushState`. Instead, let's change `undefined` to `null` here.
	    if (isUndefined(state)) {
	      state = null;
	    }
	
	    // Android Browser BFCache causes location, history reference to become stale.
	    if (location !== window.location) location = window.location;
	    if (history !== window.history) history = window.history;
	
	    // setter
	    if (url) {
	      var sameState = lastHistoryState === state;
	
	      // Don't change anything if previous and current URLs and states match. This also prevents
	      // IE<10 from getting into redirect loop when in LocationHashbangInHtml5Url mode.
	      // See https://github.com/angular/angular.js/commit/ffb2701
	      if (lastBrowserUrl === url && (!$sniffer.history || sameState)) {
	        return self;
	      }
	      var sameBase = lastBrowserUrl && stripHash(lastBrowserUrl) === stripHash(url);
	      lastBrowserUrl = url;
	      lastHistoryState = state;
	      // Don't use history API if only the hash changed
	      // due to a bug in IE10/IE11 which leads
	      // to not firing a `hashchange` nor `popstate` event
	      // in some cases (see #9143).
	      if ($sniffer.history && (!sameBase || !sameState)) {
	        history[replace ? 'replaceState' : 'pushState'](state, '', url);
	        cacheState();
	        // Do the assignment again so that those two variables are referentially identical.
	        lastHistoryState = cachedState;
	      } else {
	        if (!sameBase) {
	          pendingLocation = url;
	        }
	        if (replace) {
	          location.replace(url);
	        } else if (!sameBase) {
	          location.href = url;
	        } else {
	          location.hash = getHash(url);
	        }
	        if (location.href !== url) {
	          pendingLocation = url;
	        }
	      }
	      if (pendingLocation) {
	        pendingLocation = url;
	      }
	      return self;
	    // getter
	    } else {
	      // - pendingLocation is needed as browsers don't allow to read out
	      //   the new location.href if a reload happened or if there is a bug like in iOS 9 (see
	      //   https://openradar.appspot.com/22186109).
	      // - the replacement is a workaround for https://bugzilla.mozilla.org/show_bug.cgi?id=407172
	      return pendingLocation || location.href.replace(/%27/g,"'");
	    }
	  };
	
	  /**
	   * @name $browser#state
	   *
	   * @description
	   * This method is a getter.
	   *
	   * Return history.state or null if history.state is undefined.
	   *
	   * @returns {object} state
	   */
	  self.state = function() {
	    return cachedState;
	  };
	
	  var urlChangeListeners = [],
	      urlChangeInit = false;
	
	  function cacheStateAndFireUrlChange() {
	    pendingLocation = null;
	    cacheState();
	    fireUrlChange();
	  }
	
	  // This variable should be used *only* inside the cacheState function.
	  var lastCachedState = null;
	  function cacheState() {
	    // This should be the only place in $browser where `history.state` is read.
	    cachedState = getCurrentState();
	    cachedState = isUndefined(cachedState) ? null : cachedState;
	
	    // Prevent callbacks fo fire twice if both hashchange & popstate were fired.
	    if (equals(cachedState, lastCachedState)) {
	      cachedState = lastCachedState;
	    }
	    lastCachedState = cachedState;
	  }
	
	  function fireUrlChange() {
	    if (lastBrowserUrl === self.url() && lastHistoryState === cachedState) {
	      return;
	    }
	
	    lastBrowserUrl = self.url();
	    lastHistoryState = cachedState;
	    forEach(urlChangeListeners, function(listener) {
	      listener(self.url(), cachedState);
	    });
	  }
	
	  /**
	   * @name $browser#onUrlChange
	   *
	   * @description
	   * Register callback function that will be called, when url changes.
	   *
	   * It's only called when the url is changed from outside of angular:
	   * - user types different url into address bar
	   * - user clicks on history (forward/back) button
	   * - user clicks on a link
	   *
	   * It's not called when url is changed by $browser.url() method
	   *
	   * The listener gets called with new url as parameter.
	   *
	   * NOTE: this api is intended for use only by the $location service. Please use the
	   * {@link ng.$location $location service} to monitor url changes in angular apps.
	   *
	   * @param {function(string)} listener Listener function to be called when url changes.
	   * @return {function(string)} Returns the registered listener fn - handy if the fn is anonymous.
	   */
	  self.onUrlChange = function(callback) {
	    // TODO(vojta): refactor to use node's syntax for events
	    if (!urlChangeInit) {
	      // We listen on both (hashchange/popstate) when available, as some browsers (e.g. Opera)
	      // don't fire popstate when user change the address bar and don't fire hashchange when url
	      // changed by push/replaceState
	
	      // html5 history api - popstate event
	      if ($sniffer.history) jqLite(window).on('popstate', cacheStateAndFireUrlChange);
	      // hashchange event
	      jqLite(window).on('hashchange', cacheStateAndFireUrlChange);
	
	      urlChangeInit = true;
	    }
	
	    urlChangeListeners.push(callback);
	    return callback;
	  };
	
	  /**
	   * @private
	   * Remove popstate and hashchange handler from window.
	   *
	   * NOTE: this api is intended for use only by $rootScope.
	   */
	  self.$$applicationDestroyed = function() {
	    jqLite(window).off('hashchange popstate', cacheStateAndFireUrlChange);
	  };
	
	  /**
	   * Checks whether the url has changed outside of Angular.
	   * Needs to be exported to be able to check for changes that have been done in sync,
	   * as hashchange/popstate events fire in async.
	   */
	  self.$$checkUrlChange = fireUrlChange;
	
	  //////////////////////////////////////////////////////////////
	  // Misc API
	  //////////////////////////////////////////////////////////////
	
	  /**
	   * @name $browser#baseHref
	   *
	   * @description
	   * Returns current <base href>
	   * (always relative - without domain)
	   *
	   * @returns {string} The current base href
	   */
	  self.baseHref = function() {
	    var href = baseElement.attr('href');
	    return href ? href.replace(/^(https?\:)?\/\/[^\/]*/, '') : '';
	  };
	
	  /**
	   * @name $browser#defer
	   * @param {function()} fn A function, who's execution should be deferred.
	   * @param {number=} [delay=0] of milliseconds to defer the function execution.
	   * @returns {*} DeferId that can be used to cancel the task via `$browser.defer.cancel()`.
	   *
	   * @description
	   * Executes a fn asynchronously via `setTimeout(fn, delay)`.
	   *
	   * Unlike when calling `setTimeout` directly, in test this function is mocked and instead of using
	   * `setTimeout` in tests, the fns are queued in an array, which can be programmatically flushed
	   * via `$browser.defer.flush()`.
	   *
	   */
	  self.defer = function(fn, delay) {
	    var timeoutId;
	    outstandingRequestCount++;
	    timeoutId = setTimeout(function() {
	      delete pendingDeferIds[timeoutId];
	      completeOutstandingRequest(fn);
	    }, delay || 0);
	    pendingDeferIds[timeoutId] = true;
	    return timeoutId;
	  };
	
	
	  /**
	   * @name $browser#defer.cancel
	   *
	   * @description
	   * Cancels a deferred task identified with `deferId`.
	   *
	   * @param {*} deferId Token returned by the `$browser.defer` function.
	   * @returns {boolean} Returns `true` if the task hasn't executed yet and was successfully
	   *                    canceled.
	   */
	  self.defer.cancel = function(deferId) {
	    if (pendingDeferIds[deferId]) {
	      delete pendingDeferIds[deferId];
	      clearTimeout(deferId);
	      completeOutstandingRequest(noop);
	      return true;
	    }
	    return false;
	  };
	
	}
	
	function $BrowserProvider() {
	  this.$get = ['$window', '$log', '$sniffer', '$document',
	      function($window, $log, $sniffer, $document) {
	        return new Browser($window, $document, $log, $sniffer);
	      }];
	}
	
	/**
	 * @ngdoc service
	 * @name $cacheFactory
	 *
	 * @description
	 * Factory that constructs {@link $cacheFactory.Cache Cache} objects and gives access to
	 * them.
	 *
	 * ```js
	 *
	 *  var cache = $cacheFactory('cacheId');
	 *  expect($cacheFactory.get('cacheId')).toBe(cache);
	 *  expect($cacheFactory.get('noSuchCacheId')).not.toBeDefined();
	 *
	 *  cache.put("key", "value");
	 *  cache.put("another key", "another value");
	 *
	 *  // We've specified no options on creation
	 *  expect(cache.info()).toEqual({id: 'cacheId', size: 2});
	 *
	 * ```
	 *
	 *
	 * @param {string} cacheId Name or id of the newly created cache.
	 * @param {object=} options Options object that specifies the cache behavior. Properties:
	 *
	 *   - `{number=}` `capacity` — turns the cache into LRU cache.
	 *
	 * @returns {object} Newly created cache object with the following set of methods:
	 *
	 * - `{object}` `info()` — Returns id, size, and options of cache.
	 * - `{{*}}` `put({string} key, {*} value)` — Puts a new key-value pair into the cache and returns
	 *   it.
	 * - `{{*}}` `get({string} key)` — Returns cached value for `key` or undefined for cache miss.
	 * - `{void}` `remove({string} key)` — Removes a key-value pair from the cache.
	 * - `{void}` `removeAll()` — Removes all cached values.
	 * - `{void}` `destroy()` — Removes references to this cache from $cacheFactory.
	 *
	 * @example
	   <example module="cacheExampleApp">
	     <file name="index.html">
	       <div ng-controller="CacheController">
	         <input ng-model="newCacheKey" placeholder="Key">
	         <input ng-model="newCacheValue" placeholder="Value">
	         <button ng-click="put(newCacheKey, newCacheValue)">Cache</button>
	
	         <p ng-if="keys.length">Cached Values</p>
	         <div ng-repeat="key in keys">
	           <span ng-bind="key"></span>
	           <span>: </span>
	           <b ng-bind="cache.get(key)"></b>
	         </div>
	
	         <p>Cache Info</p>
	         <div ng-repeat="(key, value) in cache.info()">
	           <span ng-bind="key"></span>
	           <span>: </span>
	           <b ng-bind="value"></b>
	         </div>
	       </div>
	     </file>
	     <file name="script.js">
	       angular.module('cacheExampleApp', []).
	         controller('CacheController', ['$scope', '$cacheFactory', function($scope, $cacheFactory) {
	           $scope.keys = [];
	           $scope.cache = $cacheFactory('cacheId');
	           $scope.put = function(key, value) {
	             if (angular.isUndefined($scope.cache.get(key))) {
	               $scope.keys.push(key);
	             }
	             $scope.cache.put(key, angular.isUndefined(value) ? null : value);
	           };
	         }]);
	     </file>
	     <file name="style.css">
	       p {
	         margin: 10px 0 3px;
	       }
	     </file>
	   </example>
	 */
	function $CacheFactoryProvider() {
	
	  this.$get = function() {
	    var caches = {};
	
	    function cacheFactory(cacheId, options) {
	      if (cacheId in caches) {
	        throw minErr('$cacheFactory')('iid', "CacheId '{0}' is already taken!", cacheId);
	      }
	
	      var size = 0,
	          stats = extend({}, options, {id: cacheId}),
	          data = createMap(),
	          capacity = (options && options.capacity) || Number.MAX_VALUE,
	          lruHash = createMap(),
	          freshEnd = null,
	          staleEnd = null;
	
	      /**
	       * @ngdoc type
	       * @name $cacheFactory.Cache
	       *
	       * @description
	       * A cache object used to store and retrieve data, primarily used by
	       * {@link $http $http} and the {@link ng.directive:script script} directive to cache
	       * templates and other data.
	       *
	       * ```js
	       *  angular.module('superCache')
	       *    .factory('superCache', ['$cacheFactory', function($cacheFactory) {
	       *      return $cacheFactory('super-cache');
	       *    }]);
	       * ```
	       *
	       * Example test:
	       *
	       * ```js
	       *  it('should behave like a cache', inject(function(superCache) {
	       *    superCache.put('key', 'value');
	       *    superCache.put('another key', 'another value');
	       *
	       *    expect(superCache.info()).toEqual({
	       *      id: 'super-cache',
	       *      size: 2
	       *    });
	       *
	       *    superCache.remove('another key');
	       *    expect(superCache.get('another key')).toBeUndefined();
	       *
	       *    superCache.removeAll();
	       *    expect(superCache.info()).toEqual({
	       *      id: 'super-cache',
	       *      size: 0
	       *    });
	       *  }));
	       * ```
	       */
	      return caches[cacheId] = {
	
	        /**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#put
	         * @kind function
	         *
	         * @description
	         * Inserts a named entry into the {@link $cacheFactory.Cache Cache} object to be
	         * retrieved later, and incrementing the size of the cache if the key was not already
	         * present in the cache. If behaving like an LRU cache, it will also remove stale
	         * entries from the set.
	         *
	         * It will not insert undefined values into the cache.
	         *
	         * @param {string} key the key under which the cached data is stored.
	         * @param {*} value the value to store alongside the key. If it is undefined, the key
	         *    will not be stored.
	         * @returns {*} the value stored.
	         */
	        put: function(key, value) {
	          if (isUndefined(value)) return;
	          if (capacity < Number.MAX_VALUE) {
	            var lruEntry = lruHash[key] || (lruHash[key] = {key: key});
	
	            refresh(lruEntry);
	          }
	
	          if (!(key in data)) size++;
	          data[key] = value;
	
	          if (size > capacity) {
	            this.remove(staleEnd.key);
	          }
	
	          return value;
	        },
	
	        /**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#get
	         * @kind function
	         *
	         * @description
	         * Retrieves named data stored in the {@link $cacheFactory.Cache Cache} object.
	         *
	         * @param {string} key the key of the data to be retrieved
	         * @returns {*} the value stored.
	         */
	        get: function(key) {
	          if (capacity < Number.MAX_VALUE) {
	            var lruEntry = lruHash[key];
	
	            if (!lruEntry) return;
	
	            refresh(lruEntry);
	          }
	
	          return data[key];
	        },
	
	
	        /**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#remove
	         * @kind function
	         *
	         * @description
	         * Removes an entry from the {@link $cacheFactory.Cache Cache} object.
	         *
	         * @param {string} key the key of the entry to be removed
	         */
	        remove: function(key) {
	          if (capacity < Number.MAX_VALUE) {
	            var lruEntry = lruHash[key];
	
	            if (!lruEntry) return;
	
	            if (lruEntry == freshEnd) freshEnd = lruEntry.p;
	            if (lruEntry == staleEnd) staleEnd = lruEntry.n;
	            link(lruEntry.n,lruEntry.p);
	
	            delete lruHash[key];
	          }
	
	          if (!(key in data)) return;
	
	          delete data[key];
	          size--;
	        },
	
	
	        /**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#removeAll
	         * @kind function
	         *
	         * @description
	         * Clears the cache object of any entries.
	         */
	        removeAll: function() {
	          data = createMap();
	          size = 0;
	          lruHash = createMap();
	          freshEnd = staleEnd = null;
	        },
	
	
	        /**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#destroy
	         * @kind function
	         *
	         * @description
	         * Destroys the {@link $cacheFactory.Cache Cache} object entirely,
	         * removing it from the {@link $cacheFactory $cacheFactory} set.
	         */
	        destroy: function() {
	          data = null;
	          stats = null;
	          lruHash = null;
	          delete caches[cacheId];
	        },
	
	
	        /**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#info
	         * @kind function
	         *
	         * @description
	         * Retrieve information regarding a particular {@link $cacheFactory.Cache Cache}.
	         *
	         * @returns {object} an object with the following properties:
	         *   <ul>
	         *     <li>**id**: the id of the cache instance</li>
	         *     <li>**size**: the number of entries kept in the cache instance</li>
	         *     <li>**...**: any additional properties from the options object when creating the
	         *       cache.</li>
	         *   </ul>
	         */
	        info: function() {
	          return extend({}, stats, {size: size});
	        }
	      };
	
	
	      /**
	       * makes the `entry` the freshEnd of the LRU linked list
	       */
	      function refresh(entry) {
	        if (entry != freshEnd) {
	          if (!staleEnd) {
	            staleEnd = entry;
	          } else if (staleEnd == entry) {
	            staleEnd = entry.n;
	          }
	
	          link(entry.n, entry.p);
	          link(entry, freshEnd);
	          freshEnd = entry;
	          freshEnd.n = null;
	        }
	      }
	
	
	      /**
	       * bidirectionally links two entries of the LRU linked list
	       */
	      function link(nextEntry, prevEntry) {
	        if (nextEntry != prevEntry) {
	          if (nextEntry) nextEntry.p = prevEntry; //p stands for previous, 'prev' didn't minify
	          if (prevEntry) prevEntry.n = nextEntry; //n stands for next, 'next' didn't minify
	        }
	      }
	    }
	
	
	  /**
	   * @ngdoc method
	   * @name $cacheFactory#info
	   *
	   * @description
	   * Get information about all the caches that have been created
	   *
	   * @returns {Object} - key-value map of `cacheId` to the result of calling `cache#info`
	   */
	    cacheFactory.info = function() {
	      var info = {};
	      forEach(caches, function(cache, cacheId) {
	        info[cacheId] = cache.info();
	      });
	      return info;
	    };
	
	
	  /**
	   * @ngdoc method
	   * @name $cacheFactory#get
	   *
	   * @description
	   * Get access to a cache object by the `cacheId` used when it was created.
	   *
	   * @param {string} cacheId Name or id of a cache to access.
	   * @returns {object} Cache object identified by the cacheId or undefined if no such cache.
	   */
	    cacheFactory.get = function(cacheId) {
	      return caches[cacheId];
	    };
	
	
	    return cacheFactory;
	  };
	}
	
	/**
	 * @ngdoc service
	 * @name $templateCache
	 *
	 * @description
	 * The first time a template is used, it is loaded in the template cache for quick retrieval. You
	 * can load templates directly into the cache in a `script` tag, or by consuming the
	 * `$templateCache` service directly.
	 *
	 * Adding via the `script` tag:
	 *
	 * ```html
	 *   <script type="text/ng-template" id="templateId.html">
	 *     <p>This is the content of the template</p>
	 *   </script>
	 * ```
	 *
	 * **Note:** the `script` tag containing the template does not need to be included in the `head` of
	 * the document, but it must be a descendent of the {@link ng.$rootElement $rootElement} (IE,
	 * element with ng-app attribute), otherwise the template will be ignored.
	 *
	 * Adding via the `$templateCache` service:
	 *
	 * ```js
	 * var myApp = angular.module('myApp', []);
	 * myApp.run(function($templateCache) {
	 *   $templateCache.put('templateId.html', 'This is the content of the template');
	 * });
	 * ```
	 *
	 * To retrieve the template later, simply use it in your HTML:
	 * ```html
	 * <div ng-include=" 'templateId.html' "></div>
	 * ```
	 *
	 * or get it via Javascript:
	 * ```js
	 * $templateCache.get('templateId.html')
	 * ```
	 *
	 * See {@link ng.$cacheFactory $cacheFactory}.
	 *
	 */
	function $TemplateCacheProvider() {
	  this.$get = ['$cacheFactory', function($cacheFactory) {
	    return $cacheFactory('templates');
	  }];
	}
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 *     Any commits to this file should be reviewed with security in mind.  *
	 *   Changes to this file can potentially create security vulnerabilities. *
	 *          An approval from 2 Core members with history of modifying      *
	 *                         this file is required.                          *
	 *                                                                         *
	 *  Does the change somehow allow for arbitrary javascript to be executed? *
	 *    Or allows for someone to change the prototype of built-in objects?   *
	 *     Or gives undesired access to variables likes document or window?    *
	 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */
	
	/* ! VARIABLE/FUNCTION NAMING CONVENTIONS THAT APPLY TO THIS FILE!
	 *
	 * DOM-related variables:
	 *
	 * - "node" - DOM Node
	 * - "element" - DOM Element or Node
	 * - "$node" or "$element" - jqLite-wrapped node or element
	 *
	 *
	 * Compiler related stuff:
	 *
	 * - "linkFn" - linking fn of a single directive
	 * - "nodeLinkFn" - function that aggregates all linking fns for a particular node
	 * - "childLinkFn" -  function that aggregates all linking fns for child nodes of a particular node
	 * - "compositeLinkFn" - function that aggregates all linking fns for a compilation root (nodeList)
	 */
	
	
	/**
	 * @ngdoc service
	 * @name $compile
	 * @kind function
	 *
	 * @description
	 * Compiles an HTML string or DOM into a template and produces a template function, which
	 * can then be used to link {@link ng.$rootScope.Scope `scope`} and the template together.
	 *
	 * The compilation is a process of walking the DOM tree and matching DOM elements to
	 * {@link ng.$compileProvider#directive directives}.
	 *
	 * <div class="alert alert-warning">
	 * **Note:** This document is an in-depth reference of all directive options.
	 * For a gentle introduction to directives with examples of common use cases,
	 * see the {@link guide/directive directive guide}.
	 * </div>
	 *
	 * ## Comprehensive Directive API
	 *
	 * There are many different options for a directive.
	 *
	 * The difference resides in the return value of the factory function.
	 * You can either return a "Directive Definition Object" (see below) that defines the directive properties,
	 * or just the `postLink` function (all other properties will have the default values).
	 *
	 * <div class="alert alert-success">
	 * **Best Practice:** It's recommended to use the "directive definition object" form.
	 * </div>
	 *
	 * Here's an example directive declared with a Directive Definition Object:
	 *
	 * ```js
	 *   var myModule = angular.module(...);
	 *
	 *   myModule.directive('directiveName', function factory(injectables) {
	 *     var directiveDefinitionObject = {
	 *       priority: 0,
	 *       template: '<div></div>', // or // function(tElement, tAttrs) { ... },
	 *       // or
	 *       // templateUrl: 'directive.html', // or // function(tElement, tAttrs) { ... },
	 *       transclude: false,
	 *       restrict: 'A',
	 *       templateNamespace: 'html',
	 *       scope: false,
	 *       controller: function($scope, $element, $attrs, $transclude, otherInjectables) { ... },
	 *       controllerAs: 'stringIdentifier',
	 *       bindToController: false,
	 *       require: 'siblingDirectiveName', // or // ['^parentDirectiveName', '?optionalDirectiveName', '?^optionalParent'],
	 *       compile: function compile(tElement, tAttrs, transclude) {
	 *         return {
	 *           pre: function preLink(scope, iElement, iAttrs, controller) { ... },
	 *           post: function postLink(scope, iElement, iAttrs, controller) { ... }
	 *         }
	 *         // or
	 *         // return function postLink( ... ) { ... }
	 *       },
	 *       // or
	 *       // link: {
	 *       //  pre: function preLink(scope, iElement, iAttrs, controller) { ... },
	 *       //  post: function postLink(scope, iElement, iAttrs, controller) { ... }
	 *       // }
	 *       // or
	 *       // link: function postLink( ... ) { ... }
	 *     };
	 *     return directiveDefinitionObject;
	 *   });
	 * ```
	 *
	 * <div class="alert alert-warning">
	 * **Note:** Any unspecified options will use the default value. You can see the default values below.
	 * </div>
	 *
	 * Therefore the above can be simplified as:
	 *
	 * ```js
	 *   var myModule = angular.module(...);
	 *
	 *   myModule.directive('directiveName', function factory(injectables) {
	 *     var directiveDefinitionObject = {
	 *       link: function postLink(scope, iElement, iAttrs) { ... }
	 *     };
	 *     return directiveDefinitionObject;
	 *     // or
	 *     // return function postLink(scope, iElement, iAttrs) { ... }
	 *   });
	 * ```
	 *
	 *
	 *
	 * ### Directive Definition Object
	 *
	 * The directive definition object provides instructions to the {@link ng.$compile
	 * compiler}. The attributes are:
	 *
	 * #### `multiElement`
	 * When this property is set to true, the HTML compiler will collect DOM nodes between
	 * nodes with the attributes `directive-name-start` and `directive-name-end`, and group them
	 * together as the directive elements. It is recommended that this feature be used on directives
	 * which are not strictly behavioral (such as {@link ngClick}), and which
	 * do not manipulate or replace child nodes (such as {@link ngInclude}).
	 *
	 * #### `priority`
	 * When there are multiple directives defined on a single DOM element, sometimes it
	 * is necessary to specify the order in which the directives are applied. The `priority` is used
	 * to sort the directives before their `compile` functions get called. Priority is defined as a
	 * number. Directives with greater numerical `priority` are compiled first. Pre-link functions
	 * are also run in priority order, but post-link functions are run in reverse order. The order
	 * of directives with the same priority is undefined. The default priority is `0`.
	 *
	 * #### `terminal`
	 * If set to true then the current `priority` will be the last set of directives
	 * which will execute (any directives at the current priority will still execute
	 * as the order of execution on same `priority` is undefined). Note that expressions
	 * and other directives used in the directive's template will also be excluded from execution.
	 *
	 * #### `scope`
	 * The scope property can be `true`, an object or a falsy value:
	 *
	 * * **falsy:** No scope will be created for the directive. The directive will use its parent's scope.
	 *
	 * * **`true`:** A new child scope that prototypically inherits from its parent will be created for
	 * the directive's element. If multiple directives on the same element request a new scope,
	 * only one new scope is created. The new scope rule does not apply for the root of the template
	 * since the root of the template always gets a new scope.
	 *
	 * * **`{...}` (an object hash):** A new "isolate" scope is created for the directive's element. The
	 * 'isolate' scope differs from normal scope in that it does not prototypically inherit from its parent
	 * scope. This is useful when creating reusable components, which should not accidentally read or modify
	 * data in the parent scope.
	 *
	 * The 'isolate' scope object hash defines a set of local scope properties derived from attributes on the
	 * directive's element. These local properties are useful for aliasing values for templates. The keys in
	 * the object hash map to the name of the property on the isolate scope; the values define how the property
	 * is bound to the parent scope, via matching attributes on the directive's element:
	 *
	 * * `@` or `@attr` - bind a local scope property to the value of DOM attribute. The result is
	 *   always a string since DOM attributes are strings. If no `attr` name is specified then the
	 *   attribute name is assumed to be the same as the local name. Given `<my-component
	 *   my-attr="hello {{name}}">` and the isolate scope definition `scope: { localName:'@myAttr' }`,
	 *   the directive's scope property `localName` will reflect the interpolated value of `hello
	 *   {{name}}`. As the `name` attribute changes so will the `localName` property on the directive's
	 *   scope. The `name` is read from the parent scope (not the directive's scope).
	 *
	 * * `=` or `=attr` - set up a bidirectional binding between a local scope property and an expression
	 *   passed via the attribute `attr`. The expression is evaluated in the context of the parent scope.
	 *   If no `attr` name is specified then the attribute name is assumed to be the same as the local
	 *   name. Given `<my-component my-attr="parentModel">` and the isolate scope definition `scope: {
	 *   localModel: '=myAttr' }`, the property `localModel` on the directive's scope will reflect the
	 *   value of `parentModel` on the parent scope. Changes to `parentModel` will be reflected in
	 *   `localModel` and vice versa. Optional attributes should be marked as such with a question mark:
	 *   `=?` or `=?attr`. If the binding expression is non-assignable, or if the attribute isn't
	 *   optional and doesn't exist, an exception ({@link error/$compile/nonassign `$compile:nonassign`})
	 *   will be thrown upon discovering changes to the local value, since it will be impossible to sync
	 *   them back to the parent scope. By default, the {@link ng.$rootScope.Scope#$watch `$watch`}
	 *   method is used for tracking changes, and the equality check is based on object identity.
	 *   However, if an object literal or an array literal is passed as the binding expression, the
	 *   equality check is done by value (using the {@link angular.equals} function). It's also possible
	 *   to watch the evaluated value shallowly with {@link ng.$rootScope.Scope#$watchCollection
	 *   `$watchCollection`}: use `=*` or `=*attr` (`=*?` or `=*?attr` if the attribute is optional).
	 *
	  * * `<` or `<attr` - set up a one-way (one-directional) binding between a local scope property and an
	 *   expression passed via the attribute `attr`. The expression is evaluated in the context of the
	 *   parent scope. If no `attr` name is specified then the attribute name is assumed to be the same as the
	 *   local name. You can also make the binding optional by adding `?`: `<?` or `<?attr`.
	 *
	 *   For example, given `<my-component my-attr="parentModel">` and directive definition of
	 *   `scope: { localModel:'<myAttr' }`, then the isolated scope property `localModel` will reflect the
	 *   value of `parentModel` on the parent scope. Any changes to `parentModel` will be reflected
	 *   in `localModel`, but changes in `localModel` will not reflect in `parentModel`. There are however
	 *   two caveats:
	 *     1. one-way binding does not copy the value from the parent to the isolate scope, it simply
	 *     sets the same value. That means if your bound value is an object, changes to its properties
	 *     in the isolated scope will be reflected in the parent scope (because both reference the same object).
	 *     2. one-way binding watches changes to the **identity** of the parent value. That means the
	 *     {@link ng.$rootScope.Scope#$watch `$watch`} on the parent value only fires if the reference
	 *     to the value has changed. In most cases, this should not be of concern, but can be important
	 *     to know if you one-way bind to an object, and then replace that object in the isolated scope.
	 *     If you now change a property of the object in your parent scope, the change will not be
	 *     propagated to the isolated scope, because the identity of the object on the parent scope
	 *     has not changed. Instead you must assign a new object.
	 *
	 *   One-way binding is useful if you do not plan to propagate changes to your isolated scope bindings
	 *   back to the parent. However, it does not make this completely impossible.
	 *
	 * * `&` or `&attr` - provides a way to execute an expression in the context of the parent scope. If
	 *   no `attr` name is specified then the attribute name is assumed to be the same as the local name.
	 *   Given `<my-component my-attr="count = count + value">` and the isolate scope definition `scope: {
	 *   localFn:'&myAttr' }`, the isolate scope property `localFn` will point to a function wrapper for
	 *   the `count = count + value` expression. Often it's desirable to pass data from the isolated scope
	 *   via an expression to the parent scope. This can be done by passing a map of local variable names
	 *   and values into the expression wrapper fn. For example, if the expression is `increment(amount)`
	 *   then we can specify the amount value by calling the `localFn` as `localFn({amount: 22})`.
	 *
	 * In general it's possible to apply more than one directive to one element, but there might be limitations
	 * depending on the type of scope required by the directives. The following points will help explain these limitations.
	 * For simplicity only two directives are taken into account, but it is also applicable for several directives:
	 *
	 * * **no scope** + **no scope** => Two directives which don't require their own scope will use their parent's scope
	 * * **child scope** + **no scope** =>  Both directives will share one single child scope
	 * * **child scope** + **child scope** =>  Both directives will share one single child scope
	 * * **isolated scope** + **no scope** =>  The isolated directive will use it's own created isolated scope. The other directive will use
	 * its parent's scope
	 * * **isolated scope** + **child scope** =>  **Won't work!** Only one scope can be related to one element. Therefore these directives cannot
	 * be applied to the same element.
	 * * **isolated scope** + **isolated scope**  =>  **Won't work!** Only one scope can be related to one element. Therefore these directives
	 * cannot be applied to the same element.
	 *
	 *
	 * #### `bindToController`
	 * This property is used to bind scope properties directly to the controller. It can be either
	 * `true` or an object hash with the same format as the `scope` property. Additionally, a controller
	 * alias must be set, either by using `controllerAs: 'myAlias'` or by specifying the alias in the controller
	 * definition: `controller: 'myCtrl as myAlias'`.
	 *
	 * When an isolate scope is used for a directive (see above), `bindToController: true` will
	 * allow a component to have its properties bound to the controller, rather than to scope.
	 *
	 * After the controller is instantiated, the initial values of the isolate scope bindings will be bound to the controller
	 * properties. You can access these bindings once they have been initialized by providing a controller method called
	 * `$onInit`, which is called after all the controllers on an element have been constructed and had their bindings
	 * initialized.
	 *
	 * <div class="alert alert-warning">
	 * **Deprecation warning:** although bindings for non-ES6 class controllers are currently
	 * bound to `this` before the controller constructor is called, this use is now deprecated. Please place initialization
	 * code that relies upon bindings inside a `$onInit` method on the controller, instead.
	 * </div>
	 *
	 * It is also possible to set `bindToController` to an object hash with the same format as the `scope` property.
	 * This will set up the scope bindings to the controller directly. Note that `scope` can still be used
	 * to define which kind of scope is created. By default, no scope is created. Use `scope: {}` to create an isolate
	 * scope (useful for component directives).
	 *
	 * If both `bindToController` and `scope` are defined and have object hashes, `bindToController` overrides `scope`.
	 *
	 *
	 * #### `controller`
	 * Controller constructor function. The controller is instantiated before the
	 * pre-linking phase and can be accessed by other directives (see
	 * `require` attribute). This allows the directives to communicate with each other and augment
	 * each other's behavior. The controller is injectable (and supports bracket notation) with the following locals:
	 *
	 * * `$scope` - Current scope associated with the element
	 * * `$element` - Current element
	 * * `$attrs` - Current attributes object for the element
	 * * `$transclude` - A transclude linking function pre-bound to the correct transclusion scope:
	 *   `function([scope], cloneLinkingFn, futureParentElement, slotName)`:
	 *    * `scope`: (optional) override the scope.
	 *    * `cloneLinkingFn`: (optional) argument to create clones of the original transcluded content.
	 *    * `futureParentElement` (optional):
	 *        * defines the parent to which the `cloneLinkingFn` will add the cloned elements.
	 *        * default: `$element.parent()` resp. `$element` for `transclude:'element'` resp. `transclude:true`.
	 *        * only needed for transcludes that are allowed to contain non html elements (e.g. SVG elements)
	 *          and when the `cloneLinkinFn` is passed,
	 *          as those elements need to created and cloned in a special way when they are defined outside their
	 *          usual containers (e.g. like `<svg>`).
	 *        * See also the `directive.templateNamespace` property.
	 *    * `slotName`: (optional) the name of the slot to transclude. If falsy (e.g. `null`, `undefined` or `''`)
	 *      then the default translusion is provided.
	 *    The `$transclude` function also has a method on it, `$transclude.isSlotFilled(slotName)`, which returns
	 *    `true` if the specified slot contains content (i.e. one or more DOM nodes).
	 *
	 * The controller can provide the following methods that act as life-cycle hooks:
	 * * `$onInit()` - Called on each controller after all the controllers on an element have been constructed and
	 *   had their bindings initialized (and before the pre &amp; post linking functions for the directives on
	 *   this element). This is a good place to put initialization code for your controller.
	 * * `$onChanges(changesObj)` - Called whenever one-way (`<`) or interpolation (`@`) bindings are updated. The
	 *   `changesObj` is a hash whose keys are the names of the bound properties that have changed, and the values are an
	 *   object of the form `{ currentValue, previousValue, isFirstChange() }`. Use this hook to trigger updates within a
	 *   component such as cloning the bound value to prevent accidental mutation of the outer value.
	 * * `$onDestroy()` - Called on a controller when its containing scope is destroyed. Use this hook for releasing
	 *   external resources, watches and event handlers. Note that components have their `$onDestroy()` hooks called in
	 *   the same order as the `$scope.$broadcast` events are triggered, which is top down. This means that parent
	 *   components will have their `$onDestroy()` hook called before child components.
	 * * `$postLink()` - Called after this controller's element and its children have been linked. Similar to the post-link
	 *   function this hook can be used to set up DOM event handlers and do direct DOM manipulation.
	 *   Note that child elements that contain `templateUrl` directives will not have been compiled and linked since
	 *   they are waiting for their template to load asynchronously and their own compilation and linking has been
	 *   suspended until that occurs.
	 *
	 *
	 * #### `require`
	 * Require another directive and inject its controller as the fourth argument to the linking function. The
	 * `require` property can be a string, an array or an object:
	 * * a **string** containing the name of the directive to pass to the linking function
	 * * an **array** containing the names of directives to pass to the linking function. The argument passed to the
	 * linking function will be an array of controllers in the same order as the names in the `require` property
	 * * an **object** whose property values are the names of the directives to pass to the linking function. The argument
	 * passed to the linking function will also be an object with matching keys, whose values will hold the corresponding
	 * controllers.
	 *
	 * If the `require` property is an object and `bindToController` is truthy, then the required controllers are
	 * bound to the controller using the keys of the `require` property. This binding occurs after all the controllers
	 * have been constructed but before `$onInit` is called.
	 * If the name of the required controller is the same as the local name (the key), the name can be
	 * omitted. For example, `{parentDir: '^^'}` is equivalent to `{parentDir: '^^parentDir'}`.
	 * See the {@link $compileProvider#component} helper for an example of how this can be used.
	 * If no such required directive(s) can be found, or if the directive does not have a controller, then an error is
	 * raised (unless no link function is specified and the required controllers are not being bound to the directive
	 * controller, in which case error checking is skipped). The name can be prefixed with:
	 *
	 * * (no prefix) - Locate the required controller on the current element. Throw an error if not found.
	 * * `?` - Attempt to locate the required controller or pass `null` to the `link` fn if not found.
	 * * `^` - Locate the required controller by searching the element and its parents. Throw an error if not found.
	 * * `^^` - Locate the required controller by searching the element's parents. Throw an error if not found.
	 * * `?^` - Attempt to locate the required controller by searching the element and its parents or pass
	 *   `null` to the `link` fn if not found.
	 * * `?^^` - Attempt to locate the required controller by searching the element's parents, or pass
	 *   `null` to the `link` fn if not found.
	 *
	 *
	 * #### `controllerAs`
	 * Identifier name for a reference to the controller in the directive's scope.
	 * This allows the controller to be referenced from the directive template. This is especially
	 * useful when a directive is used as component, i.e. with an `isolate` scope. It's also possible
	 * to use it in a directive without an `isolate` / `new` scope, but you need to be aware that the
	 * `controllerAs` reference might overwrite a property that already exists on the parent scope.
	 *
	 *
	 * #### `restrict`
	 * String of subset of `EACM` which restricts the directive to a specific directive
	 * declaration style. If omitted, the defaults (elements and attributes) are used.
	 *
	 * * `E` - Element name (default): `<my-directive></my-directive>`
	 * * `A` - Attribute (default): `<div my-directive="exp"></div>`
	 * * `C` - Class: `<div class="my-directive: exp;"></div>`
	 * * `M` - Comment: `<!-- directive: my-directive exp -->`
	 *
	 *
	 * #### `templateNamespace`
	 * String representing the document type used by the markup in the template.
	 * AngularJS needs this information as those elements need to be created and cloned
	 * in a special way when they are defined outside their usual containers like `<svg>` and `<math>`.
	 *
	 * * `html` - All root nodes in the template are HTML. Root nodes may also be
	 *   top-level elements such as `<svg>` or `<math>`.
	 * * `svg` - The root nodes in the template are SVG elements (excluding `<math>`).
	 * * `math` - The root nodes in the template are MathML elements (excluding `<svg>`).
	 *
	 * If no `templateNamespace` is specified, then the namespace is considered to be `html`.
	 *
	 * #### `template`
	 * HTML markup that may:
	 * * Replace the contents of the directive's element (default).
	 * * Replace the directive's element itself (if `replace` is true - DEPRECATED).
	 * * Wrap the contents of the directive's element (if `transclude` is true).
	 *
	 * Value may be:
	 *
	 * * A string. For example `<div red-on-hover>{{delete_str}}</div>`.
	 * * A function which takes two arguments `tElement` and `tAttrs` (described in the `compile`
	 *   function api below) and returns a string value.
	 *
	 *
	 * #### `templateUrl`
	 * This is similar to `template` but the template is loaded from the specified URL, asynchronously.
	 *
	 * Because template loading is asynchronous the compiler will suspend compilation of directives on that element
	 * for later when the template has been resolved.  In the meantime it will continue to compile and link
	 * sibling and parent elements as though this element had not contained any directives.
	 *
	 * The compiler does not suspend the entire compilation to wait for templates to be loaded because this
	 * would result in the whole app "stalling" until all templates are loaded asynchronously - even in the
	 * case when only one deeply nested directive has `templateUrl`.
	 *
	 * Template loading is asynchronous even if the template has been preloaded into the {@link $templateCache}
	 *
	 * You can specify `templateUrl` as a string representing the URL or as a function which takes two
	 * arguments `tElement` and `tAttrs` (described in the `compile` function api below) and returns
	 * a string value representing the url.  In either case, the template URL is passed through {@link
	 * $sce#getTrustedResourceUrl $sce.getTrustedResourceUrl}.
	 *
	 *
	 * #### `replace` ([*DEPRECATED*!], will be removed in next major release - i.e. v2.0)
	 * specify what the template should replace. Defaults to `false`.
	 *
	 * * `true` - the template will replace the directive's element.
	 * * `false` - the template will replace the contents of the directive's element.
	 *
	 * The replacement process migrates all of the attributes / classes from the old element to the new
	 * one. See the {@link guide/directive#template-expanding-directive
	 * Directives Guide} for an example.
	 *
	 * There are very few scenarios where element replacement is required for the application function,
	 * the main one being reusable custom components that are used within SVG contexts
	 * (because SVG doesn't work with custom elements in the DOM tree).
	 *
	 * #### `transclude`
	 * Extract the contents of the element where the directive appears and make it available to the directive.
	 * The contents are compiled and provided to the directive as a **transclusion function**. See the
	 * {@link $compile#transclusion Transclusion} section below.
	 *
	 *
	 * #### `compile`
	 *
	 * ```js
	 *   function compile(tElement, tAttrs, transclude) { ... }
	 * ```
	 *
	 * The compile function deals with transforming the template DOM. Since most directives do not do
	 * template transformation, it is not used often. The compile function takes the following arguments:
	 *
	 *   * `tElement` - template element - The element where the directive has been declared. It is
	 *     safe to do template transformation on the element and child elements only.
	 *
	 *   * `tAttrs` - template attributes - Normalized list of attributes declared on this element shared
	 *     between all directive compile functions.
	 *
	 *   * `transclude` -  [*DEPRECATED*!] A transclude linking function: `function(scope, cloneLinkingFn)`
	 *
	 * <div class="alert alert-warning">
	 * **Note:** The template instance and the link instance may be different objects if the template has
	 * been cloned. For this reason it is **not** safe to do anything other than DOM transformations that
	 * apply to all cloned DOM nodes within the compile function. Specifically, DOM listener registration
	 * should be done in a linking function rather than in a compile function.
	 * </div>
	
	 * <div class="alert alert-warning">
	 * **Note:** The compile function cannot handle directives that recursively use themselves in their
	 * own templates or compile functions. Compiling these directives results in an infinite loop and
	 * stack overflow errors.
	 *
	 * This can be avoided by manually using $compile in the postLink function to imperatively compile
	 * a directive's template instead of relying on automatic template compilation via `template` or
	 * `templateUrl` declaration or manual compilation inside the compile function.
	 * </div>
	 *
	 * <div class="alert alert-danger">
	 * **Note:** The `transclude` function that is passed to the compile function is deprecated, as it
	 *   e.g. does not know about the right outer scope. Please use the transclude function that is passed
	 *   to the link function instead.
	 * </div>
	
	 * A compile function can have a return value which can be either a function or an object.
	 *
	 * * returning a (post-link) function - is equivalent to registering the linking function via the
	 *   `link` property of the config object when the compile function is empty.
	 *
	 * * returning an object with function(s) registered via `pre` and `post` properties - allows you to
	 *   control when a linking function should be called during the linking phase. See info about
	 *   pre-linking and post-linking functions below.
	 *
	 *
	 * #### `link`
	 * This property is used only if the `compile` property is not defined.
	 *
	 * ```js
	 *   function link(scope, iElement, iAttrs, controller, transcludeFn) { ... }
	 * ```
	 *
	 * The link function is responsible for registering DOM listeners as well as updating the DOM. It is
	 * executed after the template has been cloned. This is where most of the directive logic will be
	 * put.
	 *
	 *   * `scope` - {@link ng.$rootScope.Scope Scope} - The scope to be used by the
	 *     directive for registering {@link ng.$rootScope.Scope#$watch watches}.
	 *
	 *   * `iElement` - instance element - The element where the directive is to be used. It is safe to
	 *     manipulate the children of the element only in `postLink` function since the children have
	 *     already been linked.
	 *
	 *   * `iAttrs` - instance attributes - Normalized list of attributes declared on this element shared
	 *     between all directive linking functions.
	 *
	 *   * `controller` - the directive's required controller instance(s) - Instances are shared
	 *     among all directives, which allows the directives to use the controllers as a communication
	 *     channel. The exact value depends on the directive's `require` property:
	 *       * no controller(s) required: the directive's own controller, or `undefined` if it doesn't have one
	 *       * `string`: the controller instance
	 *       * `array`: array of controller instances
	 *
	 *     If a required controller cannot be found, and it is optional, the instance is `null`,
	 *     otherwise the {@link error:$compile:ctreq Missing Required Controller} error is thrown.
	 *
	 *     Note that you can also require the directive's own controller - it will be made available like
	 *     any other controller.
	 *
	 *   * `transcludeFn` - A transclude linking function pre-bound to the correct transclusion scope.
	 *     This is the same as the `$transclude`
	 *     parameter of directive controllers, see there for details.
	 *     `function([scope], cloneLinkingFn, futureParentElement)`.
	 *
	 * #### Pre-linking function
	 *
	 * Executed before the child elements are linked. Not safe to do DOM transformation since the
	 * compiler linking function will fail to locate the correct elements for linking.
	 *
	 * #### Post-linking function
	 *
	 * Executed after the child elements are linked.
	 *
	 * Note that child elements that contain `templateUrl` directives will not have been compiled
	 * and linked since they are waiting for their template to load asynchronously and their own
	 * compilation and linking has been suspended until that occurs.
	 *
	 * It is safe to do DOM transformation in the post-linking function on elements that are not waiting
	 * for their async templates to be resolved.
	 *
	 *
	 * ### Transclusion
	 *
	 * Transclusion is the process of extracting a collection of DOM elements from one part of the DOM and
	 * copying them to another part of the DOM, while maintaining their connection to the original AngularJS
	 * scope from where they were taken.
	 *
	 * Transclusion is used (often with {@link ngTransclude}) to insert the
	 * original contents of a directive's element into a specified place in the template of the directive.
	 * The benefit of transclusion, over simply moving the DOM elements manually, is that the transcluded
	 * content has access to the properties on the scope from which it was taken, even if the directive
	 * has isolated scope.
	 * See the {@link guide/directive#creating-a-directive-that-wraps-other-elements Directives Guide}.
	 *
	 * This makes it possible for the widget to have private state for its template, while the transcluded
	 * content has access to its originating scope.
	 *
	 * <div class="alert alert-warning">
	 * **Note:** When testing an element transclude directive you must not place the directive at the root of the
	 * DOM fragment that is being compiled. See {@link guide/unit-testing#testing-transclusion-directives
	 * Testing Transclusion Directives}.
	 * </div>
	 *
	 * There are three kinds of transclusion depending upon whether you want to transclude just the contents of the
	 * directive's element, the entire element or multiple parts of the element contents:
	 *
	 * * `true` - transclude the content (i.e. the child nodes) of the directive's element.
	 * * `'element'` - transclude the whole of the directive's element including any directives on this
	 *   element that defined at a lower priority than this directive. When used, the `template`
	 *   property is ignored.
	 * * **`{...}` (an object hash):** - map elements of the content onto transclusion "slots" in the template.
	 *
	 * **Mult-slot transclusion** is declared by providing an object for the `transclude` property.
	 *
	 * This object is a map where the keys are the name of the slot to fill and the value is an element selector
	 * used to match the HTML to the slot. The element selector should be in normalized form (e.g. `myElement`)
	 * and will match the standard element variants (e.g. `my-element`, `my:element`, `data-my-element`, etc).
	 *
	 * For further information check out the guide on {@link guide/directive#matching-directives Matching Directives}
	 *
	 * If the element selector is prefixed with a `?` then that slot is optional.
	 *
	 * For example, the transclude object `{ slotA: '?myCustomElement' }` maps `<my-custom-element>` elements to
	 * the `slotA` slot, which can be accessed via the `$transclude` function or via the {@link ngTransclude} directive.
	 *
	 * Slots that are not marked as optional (`?`) will trigger a compile time error if there are no matching elements
	 * in the transclude content. If you wish to know if an optional slot was filled with content, then you can call
	 * `$transclude.isSlotFilled(slotName)` on the transclude function passed to the directive's link function and
	 * injectable into the directive's controller.
	 *
	 *
	 * #### Transclusion Functions
	 *
	 * When a directive requests transclusion, the compiler extracts its contents and provides a **transclusion
	 * function** to the directive's `link` function and `controller`. This transclusion function is a special
	 * **linking function** that will return the compiled contents linked to a new transclusion scope.
	 *
	 * <div class="alert alert-info">
	 * If you are just using {@link ngTransclude} then you don't need to worry about this function, since
	 * ngTransclude will deal with it for us.
	 * </div>
	 *
	 * If you want to manually control the insertion and removal of the transcluded content in your directive
	 * then you must use this transclude function. When you call a transclude function it returns a a jqLite/JQuery
	 * object that contains the compiled DOM, which is linked to the correct transclusion scope.
	 *
	 * When you call a transclusion function you can pass in a **clone attach function**. This function accepts
	 * two parameters, `function(clone, scope) { ... }`, where the `clone` is a fresh compiled copy of your transcluded
	 * content and the `scope` is the newly created transclusion scope, to which the clone is bound.
	 *
	 * <div class="alert alert-info">
	 * **Best Practice**: Always provide a `cloneFn` (clone attach function) when you call a transclude function
	 * since you then get a fresh clone of the original DOM and also have access to the new transclusion scope.
	 * </div>
	 *
	 * It is normal practice to attach your transcluded content (`clone`) to the DOM inside your **clone
	 * attach function**:
	 *
	 * ```js
	 * var transcludedContent, transclusionScope;
	 *
	 * $transclude(function(clone, scope) {
	 *   element.append(clone);
	 *   transcludedContent = clone;
	 *   transclusionScope = scope;
	 * });
	 * ```
	 *
	 * Later, if you want to remove the transcluded content from your DOM then you should also destroy the
	 * associated transclusion scope:
	 *
	 * ```js
	 * transcludedContent.remove();
	 * transclusionScope.$destroy();
	 * ```
	 *
	 * <div class="alert alert-info">
	 * **Best Practice**: if you intend to add and remove transcluded content manually in your directive
	 * (by calling the transclude function to get the DOM and calling `element.remove()` to remove it),
	 * then you are also responsible for calling `$destroy` on the transclusion scope.
	 * </div>
	 *
	 * The built-in DOM manipulation directives, such as {@link ngIf}, {@link ngSwitch} and {@link ngRepeat}
	 * automatically destroy their transcluded clones as necessary so you do not need to worry about this if
	 * you are simply using {@link ngTransclude} to inject the transclusion into your directive.
	 *
	 *
	 * #### Transclusion Scopes
	 *
	 * When you call a transclude function it returns a DOM fragment that is pre-bound to a **transclusion
	 * scope**. This scope is special, in that it is a child of the directive's scope (and so gets destroyed
	 * when the directive's scope gets destroyed) but it inherits the properties of the scope from which it
	 * was taken.
	 *
	 * For example consider a directive that uses transclusion and isolated scope. The DOM hierarchy might look
	 * like this:
	 *
	 * ```html
	 * <div ng-app>
	 *   <div isolate>
	 *     <div transclusion>
	 *     </div>
	 *   </div>
	 * </div>
	 * ```
	 *
	 * The `$parent` scope hierarchy will look like this:
	 *
	   ```
	   - $rootScope
	     - isolate
	       - transclusion
	   ```
	 *
	 * but the scopes will inherit prototypically from different scopes to their `$parent`.
	 *
	   ```
	   - $rootScope
	     - transclusion
	   - isolate
	   ```
	 *
	 *
	 * ### Attributes
	 *
	 * The {@link ng.$compile.directive.Attributes Attributes} object - passed as a parameter in the
	 * `link()` or `compile()` functions. It has a variety of uses.
	 *
	 * * *Accessing normalized attribute names:* Directives like 'ngBind' can be expressed in many ways:
	 *   'ng:bind', `data-ng-bind`, or 'x-ng-bind'. The attributes object allows for normalized access
	 *   to the attributes.
	 *
	 * * *Directive inter-communication:* All directives share the same instance of the attributes
	 *   object which allows the directives to use the attributes object as inter directive
	 *   communication.
	 *
	 * * *Supports interpolation:* Interpolation attributes are assigned to the attribute object
	 *   allowing other directives to read the interpolated value.
	 *
	 * * *Observing interpolated attributes:* Use `$observe` to observe the value changes of attributes
	 *   that contain interpolation (e.g. `src="{{bar}}"`). Not only is this very efficient but it's also
	 *   the only way to easily get the actual value because during the linking phase the interpolation
	 *   hasn't been evaluated yet and so the value is at this time set to `undefined`.
	 *
	 * ```js
	 * function linkingFn(scope, elm, attrs, ctrl) {
	 *   // get the attribute value
	 *   console.log(attrs.ngModel);
	 *
	 *   // change the attribute
	 *   attrs.$set('ngModel', 'new value');
	 *
	 *   // observe changes to interpolated attribute
	 *   attrs.$observe('ngModel', function(value) {
	 *     console.log('ngModel has changed value to ' + value);
	 *   });
	 * }
	 * ```
	 *
	 * ## Example
	 *
	 * <div class="alert alert-warning">
	 * **Note**: Typically directives are registered with `module.directive`. The example below is
	 * to illustrate how `$compile` works.
	 * </div>
	 *
	 <example module="compileExample">
	   <file name="index.html">
	    <script>
	      angular.module('compileExample', [], function($compileProvider) {
	        // configure new 'compile' directive by passing a directive
	        // factory function. The factory function injects the '$compile'
	        $compileProvider.directive('compile', function($compile) {
	          // directive factory creates a link function
	          return function(scope, element, attrs) {
	            scope.$watch(
	              function(scope) {
	                 // watch the 'compile' expression for changes
	                return scope.$eval(attrs.compile);
	              },
	              function(value) {
	                // when the 'compile' expression changes
	                // assign it into the current DOM
	                element.html(value);
	
	                // compile the new DOM and link it to the current
	                // scope.
	                // NOTE: we only compile .childNodes so that
	                // we don't get into infinite loop compiling ourselves
	                $compile(element.contents())(scope);
	              }
	            );
	          };
	        });
	      })
	      .controller('GreeterController', ['$scope', function($scope) {
	        $scope.name = 'Angular';
	        $scope.html = 'Hello {{name}}';
	      }]);
	    </script>
	    <div ng-controller="GreeterController">
	      <input ng-model="name"> <br/>
	      <textarea ng-model="html"></textarea> <br/>
	      <div compile="html"></div>
	    </div>
	   </file>
	   <file name="protractor.js" type="protractor">
	     it('should auto compile', function() {
	       var textarea = $('textarea');
	       var output = $('div[compile]');
	       // The initial state reads 'Hello Angular'.
	       expect(output.getText()).toBe('Hello Angular');
	       textarea.clear();
	       textarea.sendKeys('{{name}}!');
	       expect(output.getText()).toBe('Angular!');
	     });
	   </file>
	 </example>
	
	 *
	 *
	 * @param {string|DOMElement} element Element or HTML string to compile into a template function.
	 * @param {function(angular.Scope, cloneAttachFn=)} transclude function available to directives - DEPRECATED.
	 *
	 * <div class="alert alert-danger">
	 * **Note:** Passing a `transclude` function to the $compile function is deprecated, as it
	 *   e.g. will not use the right outer scope. Please pass the transclude function as a
	 *   `parentBoundTranscludeFn` to the link function instead.
	 * </div>
	 *
	 * @param {number} maxPriority only apply directives lower than given priority (Only effects the
	 *                 root element(s), not their children)
	 * @returns {function(scope, cloneAttachFn=, options=)} a link function which is used to bind template
	 * (a DOM element/tree) to a scope. Where:
	 *
	 *  * `scope` - A {@link ng.$rootScope.Scope Scope} to bind to.
	 *  * `cloneAttachFn` - If `cloneAttachFn` is provided, then the link function will clone the
	 *  `template` and call the `cloneAttachFn` function allowing the caller to attach the
	 *  cloned elements to the DOM document at the appropriate place. The `cloneAttachFn` is
	 *  called as: <br/> `cloneAttachFn(clonedElement, scope)` where:
	 *
	 *      * `clonedElement` - is a clone of the original `element` passed into the compiler.
	 *      * `scope` - is the current scope with which the linking function is working with.
	 *
	 *  * `options` - An optional object hash with linking options. If `options` is provided, then the following
	 *  keys may be used to control linking behavior:
	 *
	 *      * `parentBoundTranscludeFn` - the transclude function made available to
	 *        directives; if given, it will be passed through to the link functions of
	 *        directives found in `element` during compilation.
	 *      * `transcludeControllers` - an object hash with keys that map controller names
	 *        to a hash with the key `instance`, which maps to the controller instance;
	 *        if given, it will make the controllers available to directives on the compileNode:
	 *        ```
	 *        {
	 *          parent: {
	 *            instance: parentControllerInstance
	 *          }
	 *        }
	 *        ```
	 *      * `futureParentElement` - defines the parent to which the `cloneAttachFn` will add
	 *        the cloned elements; only needed for transcludes that are allowed to contain non html
	 *        elements (e.g. SVG elements). See also the directive.controller property.
	 *
	 * Calling the linking function returns the element of the template. It is either the original
	 * element passed in, or the clone of the element if the `cloneAttachFn` is provided.
	 *
	 * After linking the view is not updated until after a call to $digest which typically is done by
	 * Angular automatically.
	 *
	 * If you need access to the bound view, there are two ways to do it:
	 *
	 * - If you are not asking the linking function to clone the template, create the DOM element(s)
	 *   before you send them to the compiler and keep this reference around.
	 *   ```js
	 *     var element = $compile('<p>{{total}}</p>')(scope);
	 *   ```
	 *
	 * - if on the other hand, you need the element to be cloned, the view reference from the original
	 *   example would not point to the clone, but rather to the original template that was cloned. In
	 *   this case, you can access the clone via the cloneAttachFn:
	 *   ```js
	 *     var templateElement = angular.element('<p>{{total}}</p>'),
	 *         scope = ....;
	 *
	 *     var clonedElement = $compile(templateElement)(scope, function(clonedElement, scope) {
	 *       //attach the clone to DOM document at the right place
	 *     });
	 *
	 *     //now we have reference to the cloned DOM via `clonedElement`
	 *   ```
	 *
	 *
	 * For information on how the compiler works, see the
	 * {@link guide/compiler Angular HTML Compiler} section of the Developer Guide.
	 */
	
	var $compileMinErr = minErr('$compile');
	
	function UNINITIALIZED_VALUE() {}
	var _UNINITIALIZED_VALUE = new UNINITIALIZED_VALUE();
	
	/**
	 * @ngdoc provider
	 * @name $compileProvider
	 *
	 * @description
	 */
	$CompileProvider.$inject = ['$provide', '$$sanitizeUriProvider'];
	function $CompileProvider($provide, $$sanitizeUriProvider) {
	  var hasDirectives = {},
	      Suffix = 'Directive',
	      COMMENT_DIRECTIVE_REGEXP = /^\s*directive\:\s*([\w\-]+)\s+(.*)$/,
	      CLASS_DIRECTIVE_REGEXP = /(([\w\-]+)(?:\:([^;]+))?;?)/,
	      ALL_OR_NOTHING_ATTRS = makeMap('ngSrc,ngSrcset,src,srcset'),
	      REQUIRE_PREFIX_REGEXP = /^(?:(\^\^?)?(\?)?(\^\^?)?)?/;
	
	  // Ref: http://developers.whatwg.org/webappapis.html#event-handler-idl-attributes
	  // The assumption is that future DOM event attribute names will begin with
	  // 'on' and be composed of only English letters.
	  var EVENT_HANDLER_ATTR_REGEXP = /^(on[a-z]+|formaction)$/;
	  var bindingCache = createMap();
	
	  function parseIsolateBindings(scope, directiveName, isController) {
	    var LOCAL_REGEXP = /^\s*([@&<]|=(\*?))(\??)\s*(\w*)\s*$/;
	
	    var bindings = createMap();
	
	    forEach(scope, function(definition, scopeName) {
	      if (definition in bindingCache) {
	        bindings[scopeName] = bindingCache[definition];
	        return;
	      }
	      var match = definition.match(LOCAL_REGEXP);
	
	      if (!match) {
	        throw $compileMinErr('iscp',
	            "Invalid {3} for directive '{0}'." +
	            " Definition: {... {1}: '{2}' ...}",
	            directiveName, scopeName, definition,
	            (isController ? "controller bindings definition" :
	            "isolate scope definition"));
	      }
	
	      bindings[scopeName] = {
	        mode: match[1][0],
	        collection: match[2] === '*',
	        optional: match[3] === '?',
	        attrName: match[4] || scopeName
	      };
	      if (match[4]) {
	        bindingCache[definition] = bindings[scopeName];
	      }
	    });
	
	    return bindings;
	  }
	
	  function parseDirectiveBindings(directive, directiveName) {
	    var bindings = {
	      isolateScope: null,
	      bindToController: null
	    };
	    if (isObject(directive.scope)) {
	      if (directive.bindToController === true) {
	        bindings.bindToController = parseIsolateBindings(directive.scope,
	                                                         directiveName, true);
	        bindings.isolateScope = {};
	      } else {
	        bindings.isolateScope = parseIsolateBindings(directive.scope,
	                                                     directiveName, false);
	      }
	    }
	    if (isObject(directive.bindToController)) {
	      bindings.bindToController =
	          parseIsolateBindings(directive.bindToController, directiveName, true);
	    }
	    if (isObject(bindings.bindToController)) {
	      var controller = directive.controller;
	      var controllerAs = directive.controllerAs;
	      if (!controller) {
	        // There is no controller, there may or may not be a controllerAs property
	        throw $compileMinErr('noctrl',
	              "Cannot bind to controller without directive '{0}'s controller.",
	              directiveName);
	      } else if (!identifierForController(controller, controllerAs)) {
	        // There is a controller, but no identifier or controllerAs property
	        throw $compileMinErr('noident',
	              "Cannot bind to controller without identifier for directive '{0}'.",
	              directiveName);
	      }
	    }
	    return bindings;
	  }
	
	  function assertValidDirectiveName(name) {
	    var letter = name.charAt(0);
	    if (!letter || letter !== lowercase(letter)) {
	      throw $compileMinErr('baddir', "Directive/Component name '{0}' is invalid. The first character must be a lowercase letter", name);
	    }
	    if (name !== name.trim()) {
	      throw $compileMinErr('baddir',
	            "Directive/Component name '{0}' is invalid. The name should not contain leading or trailing whitespaces",
	            name);
	    }
	  }
	
	  function getDirectiveRequire(directive) {
	    var require = directive.require || (directive.controller && directive.name);
	
	    if (!isArray(require) && isObject(require)) {
	      forEach(require, function(value, key) {
	        var match = value.match(REQUIRE_PREFIX_REGEXP);
	        var name = value.substring(match[0].length);
	        if (!name) require[key] = match[0] + key;
	      });
	    }
	
	    return require;
	  }
	
	  /**
	   * @ngdoc method
	   * @name $compileProvider#directive
	   * @kind function
	   *
	   * @description
	   * Register a new directive with the compiler.
	   *
	   * @param {string|Object} name Name of the directive in camel-case (i.e. <code>ngBind</code> which
	   *    will match as <code>ng-bind</code>), or an object map of directives where the keys are the
	   *    names and the values are the factories.
	   * @param {Function|Array} directiveFactory An injectable directive factory function. See the
	   *    {@link guide/directive directive guide} and the {@link $compile compile API} for more info.
	   * @returns {ng.$compileProvider} Self for chaining.
	   */
	  this.directive = function registerDirective(name, directiveFactory) {
	    assertNotHasOwnProperty(name, 'directive');
	    if (isString(name)) {
	      assertValidDirectiveName(name);
	      assertArg(directiveFactory, 'directiveFactory');
	      if (!hasDirectives.hasOwnProperty(name)) {
	        hasDirectives[name] = [];
	        $provide.factory(name + Suffix, ['$injector', '$exceptionHandler',
	          function($injector, $exceptionHandler) {
	            var directives = [];
	            forEach(hasDirectives[name], function(directiveFactory, index) {
	              try {
	                var directive = $injector.invoke(directiveFactory);
	                if (isFunction(directive)) {
	                  directive = { compile: valueFn(directive) };
	                } else if (!directive.compile && directive.link) {
	                  directive.compile = valueFn(directive.link);
	                }
	                directive.priority = directive.priority || 0;
	                directive.index = index;
	                directive.name = directive.name || name;
	                directive.require = getDirectiveRequire(directive);
	                directive.restrict = directive.restrict || 'EA';
	                directive.$$moduleName = directiveFactory.$$moduleName;
	                directives.push(directive);
	              } catch (e) {
	                $exceptionHandler(e);
	              }
	            });
	            return directives;
	          }]);
	      }
	      hasDirectives[name].push(directiveFactory);
	    } else {
	      forEach(name, reverseParams(registerDirective));
	    }
	    return this;
	  };
	
	  /**
	   * @ngdoc method
	   * @name $compileProvider#component
	   * @module ng
	   * @param {string} name Name of the component in camelCase (i.e. `myComp` which will match `<my-comp>`)
	   * @param {Object} options Component definition object (a simplified
	   *    {@link ng.$compile#directive-definition-object directive definition object}),
	   *    with the following properties (all optional):
	   *
	   *    - `controller` – `{(string|function()=}` – controller constructor function that should be
	   *      associated with newly created scope or the name of a {@link ng.$compile#-controller-
	   *      registered controller} if passed as a string. An empty `noop` function by default.
	   *    - `controllerAs` – `{string=}` – identifier name for to reference the controller in the component's scope.
	   *      If present, the controller will be published to scope under the `controllerAs` name.
	   *      If not present, this will default to be `$ctrl`.
	   *    - `template` – `{string=|function()=}` – html template as a string or a function that
	   *      returns an html template as a string which should be used as the contents of this component.
	   *      Empty string by default.
	   *
	   *      If `template` is a function, then it is {@link auto.$injector#invoke injected} with
	   *      the following locals:
	   *
	   *      - `$element` - Current element
	   *      - `$attrs` - Current attributes object for the element
	   *
	   *    - `templateUrl` – `{string=|function()=}` – path or function that returns a path to an html
	   *      template that should be used  as the contents of this component.
	   *
	   *      If `templateUrl` is a function, then it is {@link auto.$injector#invoke injected} with
	   *      the following locals:
	   *
	   *      - `$element` - Current element
	   *      - `$attrs` - Current attributes object for the element
	   *
	   *    - `bindings` – `{object=}` – defines bindings between DOM attributes and component properties.
	   *      Component properties are always bound to the component controller and not to the scope.
	   *      See {@link ng.$compile#-bindtocontroller- `bindToController`}.
	   *    - `transclude` – `{boolean=}` – whether {@link $compile#transclusion content transclusion} is enabled.
	   *      Disabled by default.
	   *    - `require` - `{Object<string, string>=}` - requires the controllers of other directives and binds them to
	   *      this component's controller. The object keys specify the property names under which the required
	   *      controllers (object values) will be bound. See {@link ng.$compile#-require- `require`}.
	   *    - `$...` – additional properties to attach to the directive factory function and the controller
	   *      constructor function. (This is used by the component router to annotate)
	   *
	   * @returns {ng.$compileProvider} the compile provider itself, for chaining of function calls.
	   * @description
	   * Register a **component definition** with the compiler. This is a shorthand for registering a special
	   * type of directive, which represents a self-contained UI component in your application. Such components
	   * are always isolated (i.e. `scope: {}`) and are always restricted to elements (i.e. `restrict: 'E'`).
	   *
	   * Component definitions are very simple and do not require as much configuration as defining general
	   * directives. Component definitions usually consist only of a template and a controller backing it.
	   *
	   * In order to make the definition easier, components enforce best practices like use of `controllerAs`,
	   * `bindToController`. They always have **isolate scope** and are restricted to elements.
	   *
	   * Here are a few examples of how you would usually define components:
	   *
	   * ```js
	   *   var myMod = angular.module(...);
	   *   myMod.component('myComp', {
	   *     template: '<div>My name is {{$ctrl.name}}</div>',
	   *     controller: function() {
	   *       this.name = 'shahar';
	   *     }
	   *   });
	   *
	   *   myMod.component('myComp', {
	   *     template: '<div>My name is {{$ctrl.name}}</div>',
	   *     bindings: {name: '@'}
	   *   });
	   *
	   *   myMod.component('myComp', {
	   *     templateUrl: 'views/my-comp.html',
	   *     controller: 'MyCtrl',
	   *     controllerAs: 'ctrl',
	   *     bindings: {name: '@'}
	   *   });
	   *
	   * ```
	   * For more examples, and an in-depth guide, see the {@link guide/component component guide}.
	   *
	   * <br />
	   * See also {@link ng.$compileProvider#directive $compileProvider.directive()}.
	   */
	  this.component = function registerComponent(name, options) {
	    var controller = options.controller || function() {};
	
	    function factory($injector) {
	      function makeInjectable(fn) {
	        if (isFunction(fn) || isArray(fn)) {
	          return function(tElement, tAttrs) {
	            return $injector.invoke(fn, this, {$element: tElement, $attrs: tAttrs});
	          };
	        } else {
	          return fn;
	        }
	      }
	
	      var template = (!options.template && !options.templateUrl ? '' : options.template);
	      var ddo = {
	        controller: controller,
	        controllerAs: identifierForController(options.controller) || options.controllerAs || '$ctrl',
	        template: makeInjectable(template),
	        templateUrl: makeInjectable(options.templateUrl),
	        transclude: options.transclude,
	        scope: {},
	        bindToController: options.bindings || {},
	        restrict: 'E',
	        require: options.require
	      };
	
	      // Copy annotations (starting with $) over to the DDO
	      forEach(options, function(val, key) {
	        if (key.charAt(0) === '$') ddo[key] = val;
	      });
	
	      return ddo;
	    }
	
	    // TODO(pete) remove the following `forEach` before we release 1.6.0
	    // The component-router@0.2.0 looks for the annotations on the controller constructor
	    // Nothing in Angular looks for annotations on the factory function but we can't remove
	    // it from 1.5.x yet.
	
	    // Copy any annotation properties (starting with $) over to the factory and controller constructor functions
	    // These could be used by libraries such as the new component router
	    forEach(options, function(val, key) {
	      if (key.charAt(0) === '$') {
	        factory[key] = val;
	        // Don't try to copy over annotations to named controller
	        if (isFunction(controller)) controller[key] = val;
	      }
	    });
	
	    factory.$inject = ['$injector'];
	
	    return this.directive(name, factory);
	  };
	
	
	  /**
	   * @ngdoc method
	   * @name $compileProvider#aHrefSanitizationWhitelist
	   * @kind function
	   *
	   * @description
	   * Retrieves or overrides the default regular expression that is used for whitelisting of safe
	   * urls during a[href] sanitization.
	   *
	   * The sanitization is a security measure aimed at preventing XSS attacks via html links.
	   *
	   * Any url about to be assigned to a[href] via data-binding is first normalized and turned into
	   * an absolute url. Afterwards, the url is matched against the `aHrefSanitizationWhitelist`
	   * regular expression. If a match is found, the original url is written into the dom. Otherwise,
	   * the absolute url is prefixed with `'unsafe:'` string and only then is it written into the DOM.
	   *
	   * @param {RegExp=} regexp New regexp to whitelist urls with.
	   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
	   *    chaining otherwise.
	   */
	  this.aHrefSanitizationWhitelist = function(regexp) {
	    if (isDefined(regexp)) {
	      $$sanitizeUriProvider.aHrefSanitizationWhitelist(regexp);
	      return this;
	    } else {
	      return $$sanitizeUriProvider.aHrefSanitizationWhitelist();
	    }
	  };
	
	
	  /**
	   * @ngdoc method
	   * @name $compileProvider#imgSrcSanitizationWhitelist
	   * @kind function
	   *
	   * @description
	   * Retrieves or overrides the default regular expression that is used for whitelisting of safe
	   * urls during img[src] sanitization.
	   *
	   * The sanitization is a security measure aimed at prevent XSS attacks via html links.
	   *
	   * Any url about to be assigned to img[src] via data-binding is first normalized and turned into
	   * an absolute url. Afterwards, the url is matched against the `imgSrcSanitizationWhitelist`
	   * regular expression. If a match is found, the original url is written into the dom. Otherwise,
	   * the absolute url is prefixed with `'unsafe:'` string and only then is it written into the DOM.
	   *
	   * @param {RegExp=} regexp New regexp to whitelist urls with.
	   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
	   *    chaining otherwise.
	   */
	  this.imgSrcSanitizationWhitelist = function(regexp) {
	    if (isDefined(regexp)) {
	      $$sanitizeUriProvider.imgSrcSanitizationWhitelist(regexp);
	      return this;
	    } else {
	      return $$sanitizeUriProvider.imgSrcSanitizationWhitelist();
	    }
	  };
	
	  /**
	   * @ngdoc method
	   * @name  $compileProvider#debugInfoEnabled
	   *
	   * @param {boolean=} enabled update the debugInfoEnabled state if provided, otherwise just return the
	   * current debugInfoEnabled state
	   * @returns {*} current value if used as getter or itself (chaining) if used as setter
	   *
	   * @kind function
	   *
	   * @description
	   * Call this method to enable/disable various debug runtime information in the compiler such as adding
	   * binding information and a reference to the current scope on to DOM elements.
	   * If enabled, the compiler will add the following to DOM elements that have been bound to the scope
	   * * `ng-binding` CSS class
	   * * `$binding` data property containing an array of the binding expressions
	   *
	   * You may want to disable this in production for a significant performance boost. See
	   * {@link guide/production#disabling-debug-data Disabling Debug Data} for more.
	   *
	   * The default value is true.
	   */
	  var debugInfoEnabled = true;
	  this.debugInfoEnabled = function(enabled) {
	    if (isDefined(enabled)) {
	      debugInfoEnabled = enabled;
	      return this;
	    }
	    return debugInfoEnabled;
	  };
	
	
	  var TTL = 10;
	  /**
	   * @ngdoc method
	   * @name $compileProvider#onChangesTtl
	   * @description
	   *
	   * Sets the number of times `$onChanges` hooks can trigger new changes before giving up and
	   * assuming that the model is unstable.
	   *
	   * The current default is 10 iterations.
	   *
	   * In complex applications it's possible that dependencies between `$onChanges` hooks and bindings will result
	   * in several iterations of calls to these hooks. However if an application needs more than the default 10
	   * iterations to stabilize then you should investigate what is causing the model to continuously change during
	   * the `$onChanges` hook execution.
	   *
	   * Increasing the TTL could have performance implications, so you should not change it without proper justification.
	   *
	   * @param {number} limit The number of `$onChanges` hook iterations.
	   * @returns {number|object} the current limit (or `this` if called as a setter for chaining)
	   */
	  this.onChangesTtl = function(value) {
	    if (arguments.length) {
	      TTL = value;
	      return this;
	    }
	    return TTL;
	  };
	
	  this.$get = [
	            '$injector', '$interpolate', '$exceptionHandler', '$templateRequest', '$parse',
	            '$controller', '$rootScope', '$sce', '$animate', '$$sanitizeUri',
	    function($injector,   $interpolate,   $exceptionHandler,   $templateRequest,   $parse,
	             $controller,   $rootScope,   $sce,   $animate,   $$sanitizeUri) {
	
	    var SIMPLE_ATTR_NAME = /^\w/;
	    var specialAttrHolder = window.document.createElement('div');
	
	
	
	    var onChangesTtl = TTL;
	    // The onChanges hooks should all be run together in a single digest
	    // When changes occur, the call to trigger their hooks will be added to this queue
	    var onChangesQueue;
	
	    // This function is called in a $$postDigest to trigger all the onChanges hooks in a single digest
	    function flushOnChangesQueue() {
	      try {
	        if (!(--onChangesTtl)) {
	          // We have hit the TTL limit so reset everything
	          onChangesQueue = undefined;
	          throw $compileMinErr('infchng', '{0} $onChanges() iterations reached. Aborting!\n', TTL);
	        }
	        // We must run this hook in an apply since the $$postDigest runs outside apply
	        $rootScope.$apply(function() {
	          for (var i = 0, ii = onChangesQueue.length; i < ii; ++i) {
	            onChangesQueue[i]();
	          }
	          // Reset the queue to trigger a new schedule next time there is a change
	          onChangesQueue = undefined;
	        });
	      } finally {
	        onChangesTtl++;
	      }
	    }
	
	
	    function Attributes(element, attributesToCopy) {
	      if (attributesToCopy) {
	        var keys = Object.keys(attributesToCopy);
	        var i, l, key;
	
	        for (i = 0, l = keys.length; i < l; i++) {
	          key = keys[i];
	          this[key] = attributesToCopy[key];
	        }
	      } else {
	        this.$attr = {};
	      }
	
	      this.$$element = element;
	    }
	
	    Attributes.prototype = {
	      /**
	       * @ngdoc method
	       * @name $compile.directive.Attributes#$normalize
	       * @kind function
	       *
	       * @description
	       * Converts an attribute name (e.g. dash/colon/underscore-delimited string, optionally prefixed with `x-` or
	       * `data-`) to its normalized, camelCase form.
	       *
	       * Also there is special case for Moz prefix starting with upper case letter.
	       *
	       * For further information check out the guide on {@link guide/directive#matching-directives Matching Directives}
	       *
	       * @param {string} name Name to normalize
	       */
	      $normalize: directiveNormalize,
	
	
	      /**
	       * @ngdoc method
	       * @name $compile.directive.Attributes#$addClass
	       * @kind function
	       *
	       * @description
	       * Adds the CSS class value specified by the classVal parameter to the element. If animations
	       * are enabled then an animation will be triggered for the class addition.
	       *
	       * @param {string} classVal The className value that will be added to the element
	       */
	      $addClass: function(classVal) {
	        if (classVal && classVal.length > 0) {
	          $animate.addClass(this.$$element, classVal);
	        }
	      },
	
	      /**
	       * @ngdoc method
	       * @name $compile.directive.Attributes#$removeClass
	       * @kind function
	       *
	       * @description
	       * Removes the CSS class value specified by the classVal parameter from the element. If
	       * animations are enabled then an animation will be triggered for the class removal.
	       *
	       * @param {string} classVal The className value that will be removed from the element
	       */
	      $removeClass: function(classVal) {
	        if (classVal && classVal.length > 0) {
	          $animate.removeClass(this.$$element, classVal);
	        }
	      },
	
	      /**
	       * @ngdoc method
	       * @name $compile.directive.Attributes#$updateClass
	       * @kind function
	       *
	       * @description
	       * Adds and removes the appropriate CSS class values to the element based on the difference
	       * between the new and old CSS class values (specified as newClasses and oldClasses).
	       *
	       * @param {string} newClasses The current CSS className value
	       * @param {string} oldClasses The former CSS className value
	       */
	      $updateClass: function(newClasses, oldClasses) {
	        var toAdd = tokenDifference(newClasses, oldClasses);
	        if (toAdd && toAdd.length) {
	          $animate.addClass(this.$$element, toAdd);
	        }
	
	        var toRemove = tokenDifference(oldClasses, newClasses);
	        if (toRemove && toRemove.length) {
	          $animate.removeClass(this.$$element, toRemove);
	        }
	      },
	
	      /**
	       * Set a normalized attribute on the element in a way such that all directives
	       * can share the attribute. This function properly handles boolean attributes.
	       * @param {string} key Normalized key. (ie ngAttribute)
	       * @param {string|boolean} value The value to set. If `null` attribute will be deleted.
	       * @param {boolean=} writeAttr If false, does not write the value to DOM element attribute.
	       *     Defaults to true.
	       * @param {string=} attrName Optional none normalized name. Defaults to key.
	       */
	      $set: function(key, value, writeAttr, attrName) {
	        // TODO: decide whether or not to throw an error if "class"
	        //is set through this function since it may cause $updateClass to
	        //become unstable.
	
	        var node = this.$$element[0],
	            booleanKey = getBooleanAttrName(node, key),
	            aliasedKey = getAliasedAttrName(key),
	            observer = key,
	            nodeName;
	
	        if (booleanKey) {
	          this.$$element.prop(key, value);
	          attrName = booleanKey;
	        } else if (aliasedKey) {
	          this[aliasedKey] = value;
	          observer = aliasedKey;
	        }
	
	        this[key] = value;
	
	        // translate normalized key to actual key
	        if (attrName) {
	          this.$attr[key] = attrName;
	        } else {
	          attrName = this.$attr[key];
	          if (!attrName) {
	            this.$attr[key] = attrName = snake_case(key, '-');
	          }
	        }
	
	        nodeName = nodeName_(this.$$element);
	
	        if ((nodeName === 'a' && (key === 'href' || key === 'xlinkHref')) ||
	            (nodeName === 'img' && key === 'src')) {
	          // sanitize a[href] and img[src] values
	          this[key] = value = $$sanitizeUri(value, key === 'src');
	        } else if (nodeName === 'img' && key === 'srcset' && isDefined(value)) {
	          // sanitize img[srcset] values
	          var result = "";
	
	          // first check if there are spaces because it's not the same pattern
	          var trimmedSrcset = trim(value);
	          //                (   999x   ,|   999w   ,|   ,|,   )
	          var srcPattern = /(\s+\d+x\s*,|\s+\d+w\s*,|\s+,|,\s+)/;
	          var pattern = /\s/.test(trimmedSrcset) ? srcPattern : /(,)/;
	
	          // split srcset into tuple of uri and descriptor except for the last item
	          var rawUris = trimmedSrcset.split(pattern);
	
	          // for each tuples
	          var nbrUrisWith2parts = Math.floor(rawUris.length / 2);
	          for (var i = 0; i < nbrUrisWith2parts; i++) {
	            var innerIdx = i * 2;
	            // sanitize the uri
	            result += $$sanitizeUri(trim(rawUris[innerIdx]), true);
	            // add the descriptor
	            result += (" " + trim(rawUris[innerIdx + 1]));
	          }
	
	          // split the last item into uri and descriptor
	          var lastTuple = trim(rawUris[i * 2]).split(/\s/);
	
	          // sanitize the last uri
	          result += $$sanitizeUri(trim(lastTuple[0]), true);
	
	          // and add the last descriptor if any
	          if (lastTuple.length === 2) {
	            result += (" " + trim(lastTuple[1]));
	          }
	          this[key] = value = result;
	        }
	
	        if (writeAttr !== false) {
	          if (value === null || isUndefined(value)) {
	            this.$$element.removeAttr(attrName);
	          } else {
	            if (SIMPLE_ATTR_NAME.test(attrName)) {
	              this.$$element.attr(attrName, value);
	            } else {
	              setSpecialAttr(this.$$element[0], attrName, value);
	            }
	          }
	        }
	
	        // fire observers
	        var $$observers = this.$$observers;
	        $$observers && forEach($$observers[observer], function(fn) {
	          try {
	            fn(value);
	          } catch (e) {
	            $exceptionHandler(e);
	          }
	        });
	      },
	
	
	      /**
	       * @ngdoc method
	       * @name $compile.directive.Attributes#$observe
	       * @kind function
	       *
	       * @description
	       * Observes an interpolated attribute.
	       *
	       * The observer function will be invoked once during the next `$digest` following
	       * compilation. The observer is then invoked whenever the interpolated value
	       * changes.
	       *
	       * @param {string} key Normalized key. (ie ngAttribute) .
	       * @param {function(interpolatedValue)} fn Function that will be called whenever
	                the interpolated value of the attribute changes.
	       *        See the {@link guide/interpolation#how-text-and-attribute-bindings-work Interpolation
	       *        guide} for more info.
	       * @returns {function()} Returns a deregistration function for this observer.
	       */
	      $observe: function(key, fn) {
	        var attrs = this,
	            $$observers = (attrs.$$observers || (attrs.$$observers = createMap())),
	            listeners = ($$observers[key] || ($$observers[key] = []));
	
	        listeners.push(fn);
	        $rootScope.$evalAsync(function() {
	          if (!listeners.$$inter && attrs.hasOwnProperty(key) && !isUndefined(attrs[key])) {
	            // no one registered attribute interpolation function, so lets call it manually
	            fn(attrs[key]);
	          }
	        });
	
	        return function() {
	          arrayRemove(listeners, fn);
	        };
	      }
	    };
	
	    function setSpecialAttr(element, attrName, value) {
	      // Attributes names that do not start with letters (such as `(click)`) cannot be set using `setAttribute`
	      // so we have to jump through some hoops to get such an attribute
	      // https://github.com/angular/angular.js/pull/13318
	      specialAttrHolder.innerHTML = "<span " + attrName + ">";
	      var attributes = specialAttrHolder.firstChild.attributes;
	      var attribute = attributes[0];
	      // We have to remove the attribute from its container element before we can add it to the destination element
	      attributes.removeNamedItem(attribute.name);
	      attribute.value = value;
	      element.attributes.setNamedItem(attribute);
	    }
	
	    function safeAddClass($element, className) {
	      try {
	        $element.addClass(className);
	      } catch (e) {
	        // ignore, since it means that we are trying to set class on
	        // SVG element, where class name is read-only.
	      }
	    }
	
	
	    var startSymbol = $interpolate.startSymbol(),
	        endSymbol = $interpolate.endSymbol(),
	        denormalizeTemplate = (startSymbol == '{{' && endSymbol  == '}}')
	            ? identity
	            : function denormalizeTemplate(template) {
	              return template.replace(/\{\{/g, startSymbol).replace(/}}/g, endSymbol);
	        },
	        NG_ATTR_BINDING = /^ngAttr[A-Z]/;
	    var MULTI_ELEMENT_DIR_RE = /^(.+)Start$/;
	
	    compile.$$addBindingInfo = debugInfoEnabled ? function $$addBindingInfo($element, binding) {
	      var bindings = $element.data('$binding') || [];
	
	      if (isArray(binding)) {
	        bindings = bindings.concat(binding);
	      } else {
	        bindings.push(binding);
	      }
	
	      $element.data('$binding', bindings);
	    } : noop;
	
	    compile.$$addBindingClass = debugInfoEnabled ? function $$addBindingClass($element) {
	      safeAddClass($element, 'ng-binding');
	    } : noop;
	
	    compile.$$addScopeInfo = debugInfoEnabled ? function $$addScopeInfo($element, scope, isolated, noTemplate) {
	      var dataName = isolated ? (noTemplate ? '$isolateScopeNoTemplate' : '$isolateScope') : '$scope';
	      $element.data(dataName, scope);
	    } : noop;
	
	    compile.$$addScopeClass = debugInfoEnabled ? function $$addScopeClass($element, isolated) {
	      safeAddClass($element, isolated ? 'ng-isolate-scope' : 'ng-scope');
	    } : noop;
	
	    compile.$$createComment = function(directiveName, comment) {
	      var content = '';
	      if (debugInfoEnabled) {
	        content = ' ' + (directiveName || '') + ': ';
	        if (comment) content += comment + ' ';
	      }
	      return window.document.createComment(content);
	    };
	
	    return compile;
	
	    //================================
	
	    function compile($compileNodes, transcludeFn, maxPriority, ignoreDirective,
	                        previousCompileContext) {
	      if (!($compileNodes instanceof jqLite)) {
	        // jquery always rewraps, whereas we need to preserve the original selector so that we can
	        // modify it.
	        $compileNodes = jqLite($compileNodes);
	      }
	
	      var NOT_EMPTY = /\S+/;
	
	      // We can not compile top level text elements since text nodes can be merged and we will
	      // not be able to attach scope data to them, so we will wrap them in <span>
	      for (var i = 0, len = $compileNodes.length; i < len; i++) {
	        var domNode = $compileNodes[i];
	
	        if (domNode.nodeType === NODE_TYPE_TEXT && domNode.nodeValue.match(NOT_EMPTY) /* non-empty */) {
	          jqLiteWrapNode(domNode, $compileNodes[i] = window.document.createElement('span'));
	        }
	      }
	
	      var compositeLinkFn =
	              compileNodes($compileNodes, transcludeFn, $compileNodes,
	                           maxPriority, ignoreDirective, previousCompileContext);
	      compile.$$addScopeClass($compileNodes);
	      var namespace = null;
	      return function publicLinkFn(scope, cloneConnectFn, options) {
	        assertArg(scope, 'scope');
	
	        if (previousCompileContext && previousCompileContext.needsNewScope) {
	          // A parent directive did a replace and a directive on this element asked
	          // for transclusion, which caused us to lose a layer of element on which
	          // we could hold the new transclusion scope, so we will create it manually
	          // here.
	          scope = scope.$parent.$new();
	        }
	
	        options = options || {};
	        var parentBoundTranscludeFn = options.parentBoundTranscludeFn,
	          transcludeControllers = options.transcludeControllers,
	          futureParentElement = options.futureParentElement;
	
	        // When `parentBoundTranscludeFn` is passed, it is a
	        // `controllersBoundTransclude` function (it was previously passed
	        // as `transclude` to directive.link) so we must unwrap it to get
	        // its `boundTranscludeFn`
	        if (parentBoundTranscludeFn && parentBoundTranscludeFn.$$boundTransclude) {
	          parentBoundTranscludeFn = parentBoundTranscludeFn.$$boundTransclude;
	        }
	
	        if (!namespace) {
	          namespace = detectNamespaceForChildElements(futureParentElement);
	        }
	        var $linkNode;
	        if (namespace !== 'html') {
	          // When using a directive with replace:true and templateUrl the $compileNodes
	          // (or a child element inside of them)
	          // might change, so we need to recreate the namespace adapted compileNodes
	          // for call to the link function.
	          // Note: This will already clone the nodes...
	          $linkNode = jqLite(
	            wrapTemplate(namespace, jqLite('<div>').append($compileNodes).html())
	          );
	        } else if (cloneConnectFn) {
	          // important!!: we must call our jqLite.clone() since the jQuery one is trying to be smart
	          // and sometimes changes the structure of the DOM.
	          $linkNode = JQLitePrototype.clone.call($compileNodes);
	        } else {
	          $linkNode = $compileNodes;
	        }
	
	        if (transcludeControllers) {
	          for (var controllerName in transcludeControllers) {
	            $linkNode.data('$' + controllerName + 'Controller', transcludeControllers[controllerName].instance);
	          }
	        }
	
	        compile.$$addScopeInfo($linkNode, scope);
	
	        if (cloneConnectFn) cloneConnectFn($linkNode, scope);
	        if (compositeLinkFn) compositeLinkFn(scope, $linkNode, $linkNode, parentBoundTranscludeFn);
	        return $linkNode;
	      };
	    }
	
	    function detectNamespaceForChildElements(parentElement) {
	      // TODO: Make this detect MathML as well...
	      var node = parentElement && parentElement[0];
	      if (!node) {
	        return 'html';
	      } else {
	        return nodeName_(node) !== 'foreignobject' && toString.call(node).match(/SVG/) ? 'svg' : 'html';
	      }
	    }
	
	    /**
	     * Compile function matches each node in nodeList against the directives. Once all directives
	     * for a particular node are collected their compile functions are executed. The compile
	     * functions return values - the linking functions - are combined into a composite linking
	     * function, which is the a linking function for the node.
	     *
	     * @param {NodeList} nodeList an array of nodes or NodeList to compile
	     * @param {function(angular.Scope, cloneAttachFn=)} transcludeFn A linking function, where the
	     *        scope argument is auto-generated to the new child of the transcluded parent scope.
	     * @param {DOMElement=} $rootElement If the nodeList is the root of the compilation tree then
	     *        the rootElement must be set the jqLite collection of the compile root. This is
	     *        needed so that the jqLite collection items can be replaced with widgets.
	     * @param {number=} maxPriority Max directive priority.
	     * @returns {Function} A composite linking function of all of the matched directives or null.
	     */
	    function compileNodes(nodeList, transcludeFn, $rootElement, maxPriority, ignoreDirective,
	                            previousCompileContext) {
	      var linkFns = [],
	          attrs, directives, nodeLinkFn, childNodes, childLinkFn, linkFnFound, nodeLinkFnFound;
	
	      for (var i = 0; i < nodeList.length; i++) {
	        attrs = new Attributes();
	
	        // we must always refer to nodeList[i] since the nodes can be replaced underneath us.
	        directives = collectDirectives(nodeList[i], [], attrs, i === 0 ? maxPriority : undefined,
	                                        ignoreDirective);
	
	        nodeLinkFn = (directives.length)
	            ? applyDirectivesToNode(directives, nodeList[i], attrs, transcludeFn, $rootElement,
	                                      null, [], [], previousCompileContext)
	            : null;
	
	        if (nodeLinkFn && nodeLinkFn.scope) {
	          compile.$$addScopeClass(attrs.$$element);
	        }
	
	        childLinkFn = (nodeLinkFn && nodeLinkFn.terminal ||
	                      !(childNodes = nodeList[i].childNodes) ||
	                      !childNodes.length)
	            ? null
	            : compileNodes(childNodes,
	                 nodeLinkFn ? (
	                  (nodeLinkFn.transcludeOnThisElement || !nodeLinkFn.templateOnThisElement)
	                     && nodeLinkFn.transclude) : transcludeFn);
	
	        if (nodeLinkFn || childLinkFn) {
	          linkFns.push(i, nodeLinkFn, childLinkFn);
	          linkFnFound = true;
	          nodeLinkFnFound = nodeLinkFnFound || nodeLinkFn;
	        }
	
	        //use the previous context only for the first element in the virtual group
	        previousCompileContext = null;
	      }
	
	      // return a linking function if we have found anything, null otherwise
	      return linkFnFound ? compositeLinkFn : null;
	
	      function compositeLinkFn(scope, nodeList, $rootElement, parentBoundTranscludeFn) {
	        var nodeLinkFn, childLinkFn, node, childScope, i, ii, idx, childBoundTranscludeFn;
	        var stableNodeList;
	
	
	        if (nodeLinkFnFound) {
	          // copy nodeList so that if a nodeLinkFn removes or adds an element at this DOM level our
	          // offsets don't get screwed up
	          var nodeListLength = nodeList.length;
	          stableNodeList = new Array(nodeListLength);
	
	          // create a sparse array by only copying the elements which have a linkFn
	          for (i = 0; i < linkFns.length; i+=3) {
	            idx = linkFns[i];
	            stableNodeList[idx] = nodeList[idx];
	          }
	        } else {
	          stableNodeList = nodeList;
	        }
	
	        for (i = 0, ii = linkFns.length; i < ii;) {
	          node = stableNodeList[linkFns[i++]];
	          nodeLinkFn = linkFns[i++];
	          childLinkFn = linkFns[i++];
	
	          if (nodeLinkFn) {
	            if (nodeLinkFn.scope) {
	              childScope = scope.$new();
	              compile.$$addScopeInfo(jqLite(node), childScope);
	            } else {
	              childScope = scope;
	            }
	
	            if (nodeLinkFn.transcludeOnThisElement) {
	              childBoundTranscludeFn = createBoundTranscludeFn(
	                  scope, nodeLinkFn.transclude, parentBoundTranscludeFn);
	
	            } else if (!nodeLinkFn.templateOnThisElement && parentBoundTranscludeFn) {
	              childBoundTranscludeFn = parentBoundTranscludeFn;
	
	            } else if (!parentBoundTranscludeFn && transcludeFn) {
	              childBoundTranscludeFn = createBoundTranscludeFn(scope, transcludeFn);
	
	            } else {
	              childBoundTranscludeFn = null;
	            }
	
	            nodeLinkFn(childLinkFn, childScope, node, $rootElement, childBoundTranscludeFn);
	
	          } else if (childLinkFn) {
	            childLinkFn(scope, node.childNodes, undefined, parentBoundTranscludeFn);
	          }
	        }
	      }
	    }
	
	    function createBoundTranscludeFn(scope, transcludeFn, previousBoundTranscludeFn) {
	      function boundTranscludeFn(transcludedScope, cloneFn, controllers, futureParentElement, containingScope) {
	
	        if (!transcludedScope) {
	          transcludedScope = scope.$new(false, containingScope);
	          transcludedScope.$$transcluded = true;
	        }
	
	        return transcludeFn(transcludedScope, cloneFn, {
	          parentBoundTranscludeFn: previousBoundTranscludeFn,
	          transcludeControllers: controllers,
	          futureParentElement: futureParentElement
	        });
	      }
	
	      // We need  to attach the transclusion slots onto the `boundTranscludeFn`
	      // so that they are available inside the `controllersBoundTransclude` function
	      var boundSlots = boundTranscludeFn.$$slots = createMap();
	      for (var slotName in transcludeFn.$$slots) {
	        if (transcludeFn.$$slots[slotName]) {
	          boundSlots[slotName] = createBoundTranscludeFn(scope, transcludeFn.$$slots[slotName], previousBoundTranscludeFn);
	        } else {
	          boundSlots[slotName] = null;
	        }
	      }
	
	      return boundTranscludeFn;
	    }
	
	    /**
	     * Looks for directives on the given node and adds them to the directive collection which is
	     * sorted.
	     *
	     * @param node Node to search.
	     * @param directives An array to which the directives are added to. This array is sorted before
	     *        the function returns.
	     * @param attrs The shared attrs object which is used to populate the normalized attributes.
	     * @param {number=} maxPriority Max directive priority.
	     */
	    function collectDirectives(node, directives, attrs, maxPriority, ignoreDirective) {
	      var nodeType = node.nodeType,
	          attrsMap = attrs.$attr,
	          match,
	          className;
	
	      switch (nodeType) {
	        case NODE_TYPE_ELEMENT: /* Element */
	          // use the node name: <directive>
	          addDirective(directives,
	              directiveNormalize(nodeName_(node)), 'E', maxPriority, ignoreDirective);
	
	          // iterate over the attributes
	          for (var attr, name, nName, ngAttrName, value, isNgAttr, nAttrs = node.attributes,
	                   j = 0, jj = nAttrs && nAttrs.length; j < jj; j++) {
	            var attrStartName = false;
	            var attrEndName = false;
	
	            attr = nAttrs[j];
	            name = attr.name;
	            value = trim(attr.value);
	
	            // support ngAttr attribute binding
	            ngAttrName = directiveNormalize(name);
	            if (isNgAttr = NG_ATTR_BINDING.test(ngAttrName)) {
	              name = name.replace(PREFIX_REGEXP, '')
	                .substr(8).replace(/_(.)/g, function(match, letter) {
	                  return letter.toUpperCase();
	                });
	            }
	
	            var multiElementMatch = ngAttrName.match(MULTI_ELEMENT_DIR_RE);
	            if (multiElementMatch && directiveIsMultiElement(multiElementMatch[1])) {
	              attrStartName = name;
	              attrEndName = name.substr(0, name.length - 5) + 'end';
	              name = name.substr(0, name.length - 6);
	            }
	
	            nName = directiveNormalize(name.toLowerCase());
	            attrsMap[nName] = name;
	            if (isNgAttr || !attrs.hasOwnProperty(nName)) {
	                attrs[nName] = value;
	                if (getBooleanAttrName(node, nName)) {
	                  attrs[nName] = true; // presence means true
	                }
	            }
	            addAttrInterpolateDirective(node, directives, value, nName, isNgAttr);
	            addDirective(directives, nName, 'A', maxPriority, ignoreDirective, attrStartName,
	                          attrEndName);
	          }
	
	          // use class as directive
	          className = node.className;
	          if (isObject(className)) {
	              // Maybe SVGAnimatedString
	              className = className.animVal;
	          }
	          if (isString(className) && className !== '') {
	            while (match = CLASS_DIRECTIVE_REGEXP.exec(className)) {
	              nName = directiveNormalize(match[2]);
	              if (addDirective(directives, nName, 'C', maxPriority, ignoreDirective)) {
	                attrs[nName] = trim(match[3]);
	              }
	              className = className.substr(match.index + match[0].length);
	            }
	          }
	          break;
	        case NODE_TYPE_TEXT: /* Text Node */
	          if (msie === 11) {
	            // Workaround for #11781
	            while (node.parentNode && node.nextSibling && node.nextSibling.nodeType === NODE_TYPE_TEXT) {
	              node.nodeValue = node.nodeValue + node.nextSibling.nodeValue;
	              node.parentNode.removeChild(node.nextSibling);
	            }
	          }
	          addTextInterpolateDirective(directives, node.nodeValue);
	          break;
	        case NODE_TYPE_COMMENT: /* Comment */
	          try {
	            match = COMMENT_DIRECTIVE_REGEXP.exec(node.nodeValue);
	            if (match) {
	              nName = directiveNormalize(match[1]);
	              if (addDirective(directives, nName, 'M', maxPriority, ignoreDirective)) {
	                attrs[nName] = trim(match[2]);
	              }
	            }
	          } catch (e) {
	            // turns out that under some circumstances IE9 throws errors when one attempts to read
	            // comment's node value.
	            // Just ignore it and continue. (Can't seem to reproduce in test case.)
	          }
	          break;
	      }
	
	      directives.sort(byPriority);
	      return directives;
	    }
	
	    /**
	     * Given a node with an directive-start it collects all of the siblings until it finds
	     * directive-end.
	     * @param node
	     * @param attrStart
	     * @param attrEnd
	     * @returns {*}
	     */
	    function groupScan(node, attrStart, attrEnd) {
	      var nodes = [];
	      var depth = 0;
	      if (attrStart && node.hasAttribute && node.hasAttribute(attrStart)) {
	        do {
	          if (!node) {
	            throw $compileMinErr('uterdir',
	                      "Unterminated attribute, found '{0}' but no matching '{1}' found.",
	                      attrStart, attrEnd);
	          }
	          if (node.nodeType == NODE_TYPE_ELEMENT) {
	            if (node.hasAttribute(attrStart)) depth++;
	            if (node.hasAttribute(attrEnd)) depth--;
	          }
	          nodes.push(node);
	          node = node.nextSibling;
	        } while (depth > 0);
	      } else {
	        nodes.push(node);
	      }
	
	      return jqLite(nodes);
	    }
	
	    /**
	     * Wrapper for linking function which converts normal linking function into a grouped
	     * linking function.
	     * @param linkFn
	     * @param attrStart
	     * @param attrEnd
	     * @returns {Function}
	     */
	    function groupElementsLinkFnWrapper(linkFn, attrStart, attrEnd) {
	      return function groupedElementsLink(scope, element, attrs, controllers, transcludeFn) {
	        element = groupScan(element[0], attrStart, attrEnd);
	        return linkFn(scope, element, attrs, controllers, transcludeFn);
	      };
	    }
	
	    /**
	     * A function generator that is used to support both eager and lazy compilation
	     * linking function.
	     * @param eager
	     * @param $compileNodes
	     * @param transcludeFn
	     * @param maxPriority
	     * @param ignoreDirective
	     * @param previousCompileContext
	     * @returns {Function}
	     */
	    function compilationGenerator(eager, $compileNodes, transcludeFn, maxPriority, ignoreDirective, previousCompileContext) {
	      var compiled;
	
	      if (eager) {
	        return compile($compileNodes, transcludeFn, maxPriority, ignoreDirective, previousCompileContext);
	      }
	      return function lazyCompilation() {
	        if (!compiled) {
	          compiled = compile($compileNodes, transcludeFn, maxPriority, ignoreDirective, previousCompileContext);
	
	          // Null out all of these references in order to make them eligible for garbage collection
	          // since this is a potentially long lived closure
	          $compileNodes = transcludeFn = previousCompileContext = null;
	        }
	        return compiled.apply(this, arguments);
	      };
	    }
	
	    /**
	     * Once the directives have been collected, their compile functions are executed. This method
	     * is responsible for inlining directive templates as well as terminating the application
	     * of the directives if the terminal directive has been reached.
	     *
	     * @param {Array} directives Array of collected directives to execute their compile function.
	     *        this needs to be pre-sorted by priority order.
	     * @param {Node} compileNode The raw DOM node to apply the compile functions to
	     * @param {Object} templateAttrs The shared attribute function
	     * @param {function(angular.Scope, cloneAttachFn=)} transcludeFn A linking function, where the
	     *                                                  scope argument is auto-generated to the new
	     *                                                  child of the transcluded parent scope.
	     * @param {JQLite} jqCollection If we are working on the root of the compile tree then this
	     *                              argument has the root jqLite array so that we can replace nodes
	     *                              on it.
	     * @param {Object=} originalReplaceDirective An optional directive that will be ignored when
	     *                                           compiling the transclusion.
	     * @param {Array.<Function>} preLinkFns
	     * @param {Array.<Function>} postLinkFns
	     * @param {Object} previousCompileContext Context used for previous compilation of the current
	     *                                        node
	     * @returns {Function} linkFn
	     */
	    function applyDirectivesToNode(directives, compileNode, templateAttrs, transcludeFn,
	                                   jqCollection, originalReplaceDirective, preLinkFns, postLinkFns,
	                                   previousCompileContext) {
	      previousCompileContext = previousCompileContext || {};
	
	      var terminalPriority = -Number.MAX_VALUE,
	          newScopeDirective = previousCompileContext.newScopeDirective,
	          controllerDirectives = previousCompileContext.controllerDirectives,
	          newIsolateScopeDirective = previousCompileContext.newIsolateScopeDirective,
	          templateDirective = previousCompileContext.templateDirective,
	          nonTlbTranscludeDirective = previousCompileContext.nonTlbTranscludeDirective,
	          hasTranscludeDirective = false,
	          hasTemplate = false,
	          hasElementTranscludeDirective = previousCompileContext.hasElementTranscludeDirective,
	          $compileNode = templateAttrs.$$element = jqLite(compileNode),
	          directive,
	          directiveName,
	          $template,
	          replaceDirective = originalReplaceDirective,
	          childTranscludeFn = transcludeFn,
	          linkFn,
	          didScanForMultipleTransclusion = false,
	          mightHaveMultipleTransclusionError = false,
	          directiveValue;
	
	      // executes all directives on the current element
	      for (var i = 0, ii = directives.length; i < ii; i++) {
	        directive = directives[i];
	        var attrStart = directive.$$start;
	        var attrEnd = directive.$$end;
	
	        // collect multiblock sections
	        if (attrStart) {
	          $compileNode = groupScan(compileNode, attrStart, attrEnd);
	        }
	        $template = undefined;
	
	        if (terminalPriority > directive.priority) {
	          break; // prevent further processing of directives
	        }
	
	        if (directiveValue = directive.scope) {
	
	          // skip the check for directives with async templates, we'll check the derived sync
	          // directive when the template arrives
	          if (!directive.templateUrl) {
	            if (isObject(directiveValue)) {
	              // This directive is trying to add an isolated scope.
	              // Check that there is no scope of any kind already
	              assertNoDuplicate('new/isolated scope', newIsolateScopeDirective || newScopeDirective,
	                                directive, $compileNode);
	              newIsolateScopeDirective = directive;
	            } else {
	              // This directive is trying to add a child scope.
	              // Check that there is no isolated scope already
	              assertNoDuplicate('new/isolated scope', newIsolateScopeDirective, directive,
	                                $compileNode);
	            }
	          }
	
	          newScopeDirective = newScopeDirective || directive;
	        }
	
	        directiveName = directive.name;
	
	        // If we encounter a condition that can result in transclusion on the directive,
	        // then scan ahead in the remaining directives for others that may cause a multiple
	        // transclusion error to be thrown during the compilation process.  If a matching directive
	        // is found, then we know that when we encounter a transcluded directive, we need to eagerly
	        // compile the `transclude` function rather than doing it lazily in order to throw
	        // exceptions at the correct time
	        if (!didScanForMultipleTransclusion && ((directive.replace && (directive.templateUrl || directive.template))
	            || (directive.transclude && !directive.$$tlb))) {
	                var candidateDirective;
	
	                for (var scanningIndex = i + 1; candidateDirective = directives[scanningIndex++];) {
	                    if ((candidateDirective.transclude && !candidateDirective.$$tlb)
	                        || (candidateDirective.replace && (candidateDirective.templateUrl || candidateDirective.template))) {
	                        mightHaveMultipleTransclusionError = true;
	                        break;
	                    }
	                }
	
	                didScanForMultipleTransclusion = true;
	        }
	
	        if (!directive.templateUrl && directive.controller) {
	          directiveValue = directive.controller;
	          controllerDirectives = controllerDirectives || createMap();
	          assertNoDuplicate("'" + directiveName + "' controller",
	              controllerDirectives[directiveName], directive, $compileNode);
	          controllerDirectives[directiveName] = directive;
	        }
	
	        if (directiveValue = directive.transclude) {
	          hasTranscludeDirective = true;
	
	          // Special case ngIf and ngRepeat so that we don't complain about duplicate transclusion.
	          // This option should only be used by directives that know how to safely handle element transclusion,
	          // where the transcluded nodes are added or replaced after linking.
	          if (!directive.$$tlb) {
	            assertNoDuplicate('transclusion', nonTlbTranscludeDirective, directive, $compileNode);
	            nonTlbTranscludeDirective = directive;
	          }
	
	          if (directiveValue == 'element') {
	            hasElementTranscludeDirective = true;
	            terminalPriority = directive.priority;
	            $template = $compileNode;
	            $compileNode = templateAttrs.$$element =
	                jqLite(compile.$$createComment(directiveName, templateAttrs[directiveName]));
	            compileNode = $compileNode[0];
	            replaceWith(jqCollection, sliceArgs($template), compileNode);
	
	            // Support: Chrome < 50
	            // https://github.com/angular/angular.js/issues/14041
	
	            // In the versions of V8 prior to Chrome 50, the document fragment that is created
	            // in the `replaceWith` function is improperly garbage collected despite still
	            // being referenced by the `parentNode` property of all of the child nodes.  By adding
	            // a reference to the fragment via a different property, we can avoid that incorrect
	            // behavior.
	            // TODO: remove this line after Chrome 50 has been released
	            $template[0].$$parentNode = $template[0].parentNode;
	
	            childTranscludeFn = compilationGenerator(mightHaveMultipleTransclusionError, $template, transcludeFn, terminalPriority,
	                                        replaceDirective && replaceDirective.name, {
	                                          // Don't pass in:
	                                          // - controllerDirectives - otherwise we'll create duplicates controllers
	                                          // - newIsolateScopeDirective or templateDirective - combining templates with
	                                          //   element transclusion doesn't make sense.
	                                          //
	                                          // We need only nonTlbTranscludeDirective so that we prevent putting transclusion
	                                          // on the same element more than once.
	                                          nonTlbTranscludeDirective: nonTlbTranscludeDirective
	                                        });
	          } else {
	
	            var slots = createMap();
	
	            $template = jqLite(jqLiteClone(compileNode)).contents();
	
	            if (isObject(directiveValue)) {
	
	              // We have transclusion slots,
	              // collect them up, compile them and store their transclusion functions
	              $template = [];
	
	              var slotMap = createMap();
	              var filledSlots = createMap();
	
	              // Parse the element selectors
	              forEach(directiveValue, function(elementSelector, slotName) {
	                // If an element selector starts with a ? then it is optional
	                var optional = (elementSelector.charAt(0) === '?');
	                elementSelector = optional ? elementSelector.substring(1) : elementSelector;
	
	                slotMap[elementSelector] = slotName;
	
	                // We explicitly assign `null` since this implies that a slot was defined but not filled.
	                // Later when calling boundTransclusion functions with a slot name we only error if the
	                // slot is `undefined`
	                slots[slotName] = null;
	
	                // filledSlots contains `true` for all slots that are either optional or have been
	                // filled. This is used to check that we have not missed any required slots
	                filledSlots[slotName] = optional;
	              });
	
	              // Add the matching elements into their slot
	              forEach($compileNode.contents(), function(node) {
	                var slotName = slotMap[directiveNormalize(nodeName_(node))];
	                if (slotName) {
	                  filledSlots[slotName] = true;
	                  slots[slotName] = slots[slotName] || [];
	                  slots[slotName].push(node);
	                } else {
	                  $template.push(node);
	                }
	              });
	
	              // Check for required slots that were not filled
	              forEach(filledSlots, function(filled, slotName) {
	                if (!filled) {
	                  throw $compileMinErr('reqslot', 'Required transclusion slot `{0}` was not filled.', slotName);
	                }
	              });
	
	              for (var slotName in slots) {
	                if (slots[slotName]) {
	                  // Only define a transclusion function if the slot was filled
	                  slots[slotName] = compilationGenerator(mightHaveMultipleTransclusionError, slots[slotName], transcludeFn);
	                }
	              }
	            }
	
	            $compileNode.empty(); // clear contents
	            childTranscludeFn = compilationGenerator(mightHaveMultipleTransclusionError, $template, transcludeFn, undefined,
	                undefined, { needsNewScope: directive.$$isolateScope || directive.$$newScope});
	            childTranscludeFn.$$slots = slots;
	          }
	        }
	
	        if (directive.template) {
	          hasTemplate = true;
	          assertNoDuplicate('template', templateDirective, directive, $compileNode);
	          templateDirective = directive;
	
	          directiveValue = (isFunction(directive.template))
	              ? directive.template($compileNode, templateAttrs)
	              : directive.template;
	
	          directiveValue = denormalizeTemplate(directiveValue);
	
	          if (directive.replace) {
	            replaceDirective = directive;
	            if (jqLiteIsTextNode(directiveValue)) {
	              $template = [];
	            } else {
	              $template = removeComments(wrapTemplate(directive.templateNamespace, trim(directiveValue)));
	            }
	            compileNode = $template[0];
	
	            if ($template.length != 1 || compileNode.nodeType !== NODE_TYPE_ELEMENT) {
	              throw $compileMinErr('tplrt',
	                  "Template for directive '{0}' must have exactly one root element. {1}",
	                  directiveName, '');
	            }
	
	            replaceWith(jqCollection, $compileNode, compileNode);
	
	            var newTemplateAttrs = {$attr: {}};
	
	            // combine directives from the original node and from the template:
	            // - take the array of directives for this element
	            // - split it into two parts, those that already applied (processed) and those that weren't (unprocessed)
	            // - collect directives from the template and sort them by priority
	            // - combine directives as: processed + template + unprocessed
	            var templateDirectives = collectDirectives(compileNode, [], newTemplateAttrs);
	            var unprocessedDirectives = directives.splice(i + 1, directives.length - (i + 1));
	
	            if (newIsolateScopeDirective || newScopeDirective) {
	              // The original directive caused the current element to be replaced but this element
	              // also needs to have a new scope, so we need to tell the template directives
	              // that they would need to get their scope from further up, if they require transclusion
	              markDirectiveScope(templateDirectives, newIsolateScopeDirective, newScopeDirective);
	            }
	            directives = directives.concat(templateDirectives).concat(unprocessedDirectives);
	            mergeTemplateAttributes(templateAttrs, newTemplateAttrs);
	
	            ii = directives.length;
	          } else {
	            $compileNode.html(directiveValue);
	          }
	        }
	
	        if (directive.templateUrl) {
	          hasTemplate = true;
	          assertNoDuplicate('template', templateDirective, directive, $compileNode);
	          templateDirective = directive;
	
	          if (directive.replace) {
	            replaceDirective = directive;
	          }
	
	          /* jshint -W021 */
	          nodeLinkFn = compileTemplateUrl(directives.splice(i, directives.length - i), $compileNode,
	          /* jshint +W021 */
	              templateAttrs, jqCollection, hasTranscludeDirective && childTranscludeFn, preLinkFns, postLinkFns, {
	                controllerDirectives: controllerDirectives,
	                newScopeDirective: (newScopeDirective !== directive) && newScopeDirective,
	                newIsolateScopeDirective: newIsolateScopeDirective,
	                templateDirective: templateDirective,
	                nonTlbTranscludeDirective: nonTlbTranscludeDirective
	              });
	          ii = directives.length;
	        } else if (directive.compile) {
	          try {
	            linkFn = directive.compile($compileNode, templateAttrs, childTranscludeFn);
	            var context = directive.$$originalDirective || directive;
	            if (isFunction(linkFn)) {
	              addLinkFns(null, bind(context, linkFn), attrStart, attrEnd);
	            } else if (linkFn) {
	              addLinkFns(bind(context, linkFn.pre), bind(context, linkFn.post), attrStart, attrEnd);
	            }
	          } catch (e) {
	            $exceptionHandler(e, startingTag($compileNode));
	          }
	        }
	
	        if (directive.terminal) {
	          nodeLinkFn.terminal = true;
	          terminalPriority = Math.max(terminalPriority, directive.priority);
	        }
	
	      }
	
	      nodeLinkFn.scope = newScopeDirective && newScopeDirective.scope === true;
	      nodeLinkFn.transcludeOnThisElement = hasTranscludeDirective;
	      nodeLinkFn.templateOnThisElement = hasTemplate;
	      nodeLinkFn.transclude = childTranscludeFn;
	
	      previousCompileContext.hasElementTranscludeDirective = hasElementTranscludeDirective;
	
	      // might be normal or delayed nodeLinkFn depending on if templateUrl is present
	      return nodeLinkFn;
	
	      ////////////////////
	
	      function addLinkFns(pre, post, attrStart, attrEnd) {
	        if (pre) {
	          if (attrStart) pre = groupElementsLinkFnWrapper(pre, attrStart, attrEnd);
	          pre.require = directive.require;
	          pre.directiveName = directiveName;
	          if (newIsolateScopeDirective === directive || directive.$$isolateScope) {
	            pre = cloneAndAnnotateFn(pre, {isolateScope: true});
	          }
	          preLinkFns.push(pre);
	        }
	        if (post) {
	          if (attrStart) post = groupElementsLinkFnWrapper(post, attrStart, attrEnd);
	          post.require = directive.require;
	          post.directiveName = directiveName;
	          if (newIsolateScopeDirective === directive || directive.$$isolateScope) {
	            post = cloneAndAnnotateFn(post, {isolateScope: true});
	          }
	          postLinkFns.push(post);
	        }
	      }
	
	      function nodeLinkFn(childLinkFn, scope, linkNode, $rootElement, boundTranscludeFn) {
	        var i, ii, linkFn, isolateScope, controllerScope, elementControllers, transcludeFn, $element,
	            attrs, scopeBindingInfo;
	
	        if (compileNode === linkNode) {
	          attrs = templateAttrs;
	          $element = templateAttrs.$$element;
	        } else {
	          $element = jqLite(linkNode);
	          attrs = new Attributes($element, templateAttrs);
	        }
	
	        controllerScope = scope;
	        if (newIsolateScopeDirective) {
	          isolateScope = scope.$new(true);
	        } else if (newScopeDirective) {
	          controllerScope = scope.$parent;
	        }
	
	        if (boundTranscludeFn) {
	          // track `boundTranscludeFn` so it can be unwrapped if `transcludeFn`
	          // is later passed as `parentBoundTranscludeFn` to `publicLinkFn`
	          transcludeFn = controllersBoundTransclude;
	          transcludeFn.$$boundTransclude = boundTranscludeFn;
	          // expose the slots on the `$transclude` function
	          transcludeFn.isSlotFilled = function(slotName) {
	            return !!boundTranscludeFn.$$slots[slotName];
	          };
	        }
	
	        if (controllerDirectives) {
	          elementControllers = setupControllers($element, attrs, transcludeFn, controllerDirectives, isolateScope, scope, newIsolateScopeDirective);
	        }
	
	        if (newIsolateScopeDirective) {
	          // Initialize isolate scope bindings for new isolate scope directive.
	          compile.$$addScopeInfo($element, isolateScope, true, !(templateDirective && (templateDirective === newIsolateScopeDirective ||
	              templateDirective === newIsolateScopeDirective.$$originalDirective)));
	          compile.$$addScopeClass($element, true);
	          isolateScope.$$isolateBindings =
	              newIsolateScopeDirective.$$isolateBindings;
	          scopeBindingInfo = initializeDirectiveBindings(scope, attrs, isolateScope,
	                                        isolateScope.$$isolateBindings,
	                                        newIsolateScopeDirective);
	          if (scopeBindingInfo.removeWatches) {
	            isolateScope.$on('$destroy', scopeBindingInfo.removeWatches);
	          }
	        }
	
	        // Initialize bindToController bindings
	        for (var name in elementControllers) {
	          var controllerDirective = controllerDirectives[name];
	          var controller = elementControllers[name];
	          var bindings = controllerDirective.$$bindings.bindToController;
	
	          if (controller.identifier && bindings) {
	            controller.bindingInfo =
	              initializeDirectiveBindings(controllerScope, attrs, controller.instance, bindings, controllerDirective);
	          } else {
	            controller.bindingInfo = {};
	          }
	
	          var controllerResult = controller();
	          if (controllerResult !== controller.instance) {
	            // If the controller constructor has a return value, overwrite the instance
	            // from setupControllers
	            controller.instance = controllerResult;
	            $element.data('$' + controllerDirective.name + 'Controller', controllerResult);
	            controller.bindingInfo.removeWatches && controller.bindingInfo.removeWatches();
	            controller.bindingInfo =
	              initializeDirectiveBindings(controllerScope, attrs, controller.instance, bindings, controllerDirective);
	          }
	        }
	
	        // Bind the required controllers to the controller, if `require` is an object and `bindToController` is truthy
	        forEach(controllerDirectives, function(controllerDirective, name) {
	          var require = controllerDirective.require;
	          if (controllerDirective.bindToController && !isArray(require) && isObject(require)) {
	            extend(elementControllers[name].instance, getControllers(name, require, $element, elementControllers));
	          }
	        });
	
	        // Handle the init and destroy lifecycle hooks on all controllers that have them
	        forEach(elementControllers, function(controller) {
	          var controllerInstance = controller.instance;
	          if (isFunction(controllerInstance.$onChanges)) {
	            controllerInstance.$onChanges(controller.bindingInfo.initialChanges);
	          }
	          if (isFunction(controllerInstance.$onInit)) {
	            controllerInstance.$onInit();
	          }
	          if (isFunction(controllerInstance.$onDestroy)) {
	            controllerScope.$on('$destroy', function callOnDestroyHook() {
	              controllerInstance.$onDestroy();
	            });
	          }
	        });
	
	        // PRELINKING
	        for (i = 0, ii = preLinkFns.length; i < ii; i++) {
	          linkFn = preLinkFns[i];
	          invokeLinkFn(linkFn,
	              linkFn.isolateScope ? isolateScope : scope,
	              $element,
	              attrs,
	              linkFn.require && getControllers(linkFn.directiveName, linkFn.require, $element, elementControllers),
	              transcludeFn
	          );
	        }
	
	        // RECURSION
	        // We only pass the isolate scope, if the isolate directive has a template,
	        // otherwise the child elements do not belong to the isolate directive.
	        var scopeToChild = scope;
	        if (newIsolateScopeDirective && (newIsolateScopeDirective.template || newIsolateScopeDirective.templateUrl === null)) {
	          scopeToChild = isolateScope;
	        }
	        childLinkFn && childLinkFn(scopeToChild, linkNode.childNodes, undefined, boundTranscludeFn);
	
	        // POSTLINKING
	        for (i = postLinkFns.length - 1; i >= 0; i--) {
	          linkFn = postLinkFns[i];
	          invokeLinkFn(linkFn,
	              linkFn.isolateScope ? isolateScope : scope,
	              $element,
	              attrs,
	              linkFn.require && getControllers(linkFn.directiveName, linkFn.require, $element, elementControllers),
	              transcludeFn
	          );
	        }
	
	        // Trigger $postLink lifecycle hooks
	        forEach(elementControllers, function(controller) {
	          var controllerInstance = controller.instance;
	          if (isFunction(controllerInstance.$postLink)) {
	            controllerInstance.$postLink();
	          }
	        });
	
	        // This is the function that is injected as `$transclude`.
	        // Note: all arguments are optional!
	        function controllersBoundTransclude(scope, cloneAttachFn, futureParentElement, slotName) {
	          var transcludeControllers;
	          // No scope passed in:
	          if (!isScope(scope)) {
	            slotName = futureParentElement;
	            futureParentElement = cloneAttachFn;
	            cloneAttachFn = scope;
	            scope = undefined;
	          }
	
	          if (hasElementTranscludeDirective) {
	            transcludeControllers = elementControllers;
	          }
	          if (!futureParentElement) {
	            futureParentElement = hasElementTranscludeDirective ? $element.parent() : $element;
	          }
	          if (slotName) {
	            // slotTranscludeFn can be one of three things:
	            //  * a transclude function - a filled slot
	            //  * `null` - an optional slot that was not filled
	            //  * `undefined` - a slot that was not declared (i.e. invalid)
	            var slotTranscludeFn = boundTranscludeFn.$$slots[slotName];
	            if (slotTranscludeFn) {
	              return slotTranscludeFn(scope, cloneAttachFn, transcludeControllers, futureParentElement, scopeToChild);
	            } else if (isUndefined(slotTranscludeFn)) {
	              throw $compileMinErr('noslot',
	               'No parent directive that requires a transclusion with slot name "{0}". ' +
	               'Element: {1}',
	               slotName, startingTag($element));
	            }
	          } else {
	            return boundTranscludeFn(scope, cloneAttachFn, transcludeControllers, futureParentElement, scopeToChild);
	          }
	        }
	      }
	    }
	
	    function getControllers(directiveName, require, $element, elementControllers) {
	      var value;
	
	      if (isString(require)) {
	        var match = require.match(REQUIRE_PREFIX_REGEXP);
	        var name = require.substring(match[0].length);
	        var inheritType = match[1] || match[3];
	        var optional = match[2] === '?';
	
	        //If only parents then start at the parent element
	        if (inheritType === '^^') {
	          $element = $element.parent();
	        //Otherwise attempt getting the controller from elementControllers in case
	        //the element is transcluded (and has no data) and to avoid .data if possible
	        } else {
	          value = elementControllers && elementControllers[name];
	          value = value && value.instance;
	        }
	
	        if (!value) {
	          var dataName = '$' + name + 'Controller';
	          value = inheritType ? $element.inheritedData(dataName) : $element.data(dataName);
	        }
	
	        if (!value && !optional) {
	          throw $compileMinErr('ctreq',
	              "Controller '{0}', required by directive '{1}', can't be found!",
	              name, directiveName);
	        }
	      } else if (isArray(require)) {
	        value = [];
	        for (var i = 0, ii = require.length; i < ii; i++) {
	          value[i] = getControllers(directiveName, require[i], $element, elementControllers);
	        }
	      } else if (isObject(require)) {
	        value = {};
	        forEach(require, function(controller, property) {
	          value[property] = getControllers(directiveName, controller, $element, elementControllers);
	        });
	      }
	
	      return value || null;
	    }
	
	    function setupControllers($element, attrs, transcludeFn, controllerDirectives, isolateScope, scope, newIsolateScopeDirective) {
	      var elementControllers = createMap();
	      for (var controllerKey in controllerDirectives) {
	        var directive = controllerDirectives[controllerKey];
	        var locals = {
	          $scope: directive === newIsolateScopeDirective || directive.$$isolateScope ? isolateScope : scope,
	          $element: $element,
	          $attrs: attrs,
	          $transclude: transcludeFn
	        };
	
	        var controller = directive.controller;
	        if (controller == '@') {
	          controller = attrs[directive.name];
	        }
	
	        var controllerInstance = $controller(controller, locals, true, directive.controllerAs);
	
	        // For directives with element transclusion the element is a comment.
	        // In this case .data will not attach any data.
	        // Instead, we save the controllers for the element in a local hash and attach to .data
	        // later, once we have the actual element.
	        elementControllers[directive.name] = controllerInstance;
	        $element.data('$' + directive.name + 'Controller', controllerInstance.instance);
	      }
	      return elementControllers;
	    }
	
	    // Depending upon the context in which a directive finds itself it might need to have a new isolated
	    // or child scope created. For instance:
	    // * if the directive has been pulled into a template because another directive with a higher priority
	    // asked for element transclusion
	    // * if the directive itself asks for transclusion but it is at the root of a template and the original
	    // element was replaced. See https://github.com/angular/angular.js/issues/12936
	    function markDirectiveScope(directives, isolateScope, newScope) {
	      for (var j = 0, jj = directives.length; j < jj; j++) {
	        directives[j] = inherit(directives[j], {$$isolateScope: isolateScope, $$newScope: newScope});
	      }
	    }
	
	    /**
	     * looks up the directive and decorates it with exception handling and proper parameters. We
	     * call this the boundDirective.
	     *
	     * @param {string} name name of the directive to look up.
	     * @param {string} location The directive must be found in specific format.
	     *   String containing any of theses characters:
	     *
	     *   * `E`: element name
	     *   * `A': attribute
	     *   * `C`: class
	     *   * `M`: comment
	     * @returns {boolean} true if directive was added.
	     */
	    function addDirective(tDirectives, name, location, maxPriority, ignoreDirective, startAttrName,
	                          endAttrName) {
	      if (name === ignoreDirective) return null;
	      var match = null;
	      if (hasDirectives.hasOwnProperty(name)) {
	        for (var directive, directives = $injector.get(name + Suffix),
	            i = 0, ii = directives.length; i < ii; i++) {
	          try {
	            directive = directives[i];
	            if ((isUndefined(maxPriority) || maxPriority > directive.priority) &&
	                 directive.restrict.indexOf(location) != -1) {
	              if (startAttrName) {
	                directive = inherit(directive, {$$start: startAttrName, $$end: endAttrName});
	              }
	              if (!directive.$$bindings) {
	                var bindings = directive.$$bindings =
	                    parseDirectiveBindings(directive, directive.name);
	                if (isObject(bindings.isolateScope)) {
	                  directive.$$isolateBindings = bindings.isolateScope;
	                }
	              }
	              tDirectives.push(directive);
	              match = directive;
	            }
	          } catch (e) { $exceptionHandler(e); }
	        }
	      }
	      return match;
	    }
	
	
	    /**
	     * looks up the directive and returns true if it is a multi-element directive,
	     * and therefore requires DOM nodes between -start and -end markers to be grouped
	     * together.
	     *
	     * @param {string} name name of the directive to look up.
	     * @returns true if directive was registered as multi-element.
	     */
	    function directiveIsMultiElement(name) {
	      if (hasDirectives.hasOwnProperty(name)) {
	        for (var directive, directives = $injector.get(name + Suffix),
	            i = 0, ii = directives.length; i < ii; i++) {
	          directive = directives[i];
	          if (directive.multiElement) {
	            return true;
	          }
	        }
	      }
	      return false;
	    }
	
	    /**
	     * When the element is replaced with HTML template then the new attributes
	     * on the template need to be merged with the existing attributes in the DOM.
	     * The desired effect is to have both of the attributes present.
	     *
	     * @param {object} dst destination attributes (original DOM)
	     * @param {object} src source attributes (from the directive template)
	     */
	    function mergeTemplateAttributes(dst, src) {
	      var srcAttr = src.$attr,
	          dstAttr = dst.$attr,
	          $element = dst.$$element;
	
	      // reapply the old attributes to the new element
	      forEach(dst, function(value, key) {
	        if (key.charAt(0) != '$') {
	          if (src[key] && src[key] !== value) {
	            value += (key === 'style' ? ';' : ' ') + src[key];
	          }
	          dst.$set(key, value, true, srcAttr[key]);
	        }
	      });
	
	      // copy the new attributes on the old attrs object
	      forEach(src, function(value, key) {
	        if (key == 'class') {
	          safeAddClass($element, value);
	          dst['class'] = (dst['class'] ? dst['class'] + ' ' : '') + value;
	        } else if (key == 'style') {
	          $element.attr('style', $element.attr('style') + ';' + value);
	          dst['style'] = (dst['style'] ? dst['style'] + ';' : '') + value;
	          // `dst` will never contain hasOwnProperty as DOM parser won't let it.
	          // You will get an "InvalidCharacterError: DOM Exception 5" error if you
	          // have an attribute like "has-own-property" or "data-has-own-property", etc.
	        } else if (key.charAt(0) != '$' && !dst.hasOwnProperty(key)) {
	          dst[key] = value;
	          dstAttr[key] = srcAttr[key];
	        }
	      });
	    }
	
	
	    function compileTemplateUrl(directives, $compileNode, tAttrs,
	        $rootElement, childTranscludeFn, preLinkFns, postLinkFns, previousCompileContext) {
	      var linkQueue = [],
	          afterTemplateNodeLinkFn,
	          afterTemplateChildLinkFn,
	          beforeTemplateCompileNode = $compileNode[0],
	          origAsyncDirective = directives.shift(),
	          derivedSyncDirective = inherit(origAsyncDirective, {
	            templateUrl: null, transclude: null, replace: null, $$originalDirective: origAsyncDirective
	          }),
	          templateUrl = (isFunction(origAsyncDirective.templateUrl))
	              ? origAsyncDirective.templateUrl($compileNode, tAttrs)
	              : origAsyncDirective.templateUrl,
	          templateNamespace = origAsyncDirective.templateNamespace;
	
	      $compileNode.empty();
	
	      $templateRequest(templateUrl)
	        .then(function(content) {
	          var compileNode, tempTemplateAttrs, $template, childBoundTranscludeFn;
	
	          content = denormalizeTemplate(content);
	
	          if (origAsyncDirective.replace) {
	            if (jqLiteIsTextNode(content)) {
	              $template = [];
	            } else {
	              $template = removeComments(wrapTemplate(templateNamespace, trim(content)));
	            }
	            compileNode = $template[0];
	
	            if ($template.length != 1 || compileNode.nodeType !== NODE_TYPE_ELEMENT) {
	              throw $compileMinErr('tplrt',
	                  "Template for directive '{0}' must have exactly one root element. {1}",
	                  origAsyncDirective.name, templateUrl);
	            }
	
	            tempTemplateAttrs = {$attr: {}};
	            replaceWith($rootElement, $compileNode, compileNode);
	            var templateDirectives = collectDirectives(compileNode, [], tempTemplateAttrs);
	
	            if (isObject(origAsyncDirective.scope)) {
	              // the original directive that caused the template to be loaded async required
	              // an isolate scope
	              markDirectiveScope(templateDirectives, true);
	            }
	            directives = templateDirectives.concat(directives);
	            mergeTemplateAttributes(tAttrs, tempTemplateAttrs);
	          } else {
	            compileNode = beforeTemplateCompileNode;
	            $compileNode.html(content);
	          }
	
	          directives.unshift(derivedSyncDirective);
	
	          afterTemplateNodeLinkFn = applyDirectivesToNode(directives, compileNode, tAttrs,
	              childTranscludeFn, $compileNode, origAsyncDirective, preLinkFns, postLinkFns,
	              previousCompileContext);
	          forEach($rootElement, function(node, i) {
	            if (node == compileNode) {
	              $rootElement[i] = $compileNode[0];
	            }
	          });
	          afterTemplateChildLinkFn = compileNodes($compileNode[0].childNodes, childTranscludeFn);
	
	          while (linkQueue.length) {
	            var scope = linkQueue.shift(),
	                beforeTemplateLinkNode = linkQueue.shift(),
	                linkRootElement = linkQueue.shift(),
	                boundTranscludeFn = linkQueue.shift(),
	                linkNode = $compileNode[0];
	
	            if (scope.$$destroyed) continue;
	
	            if (beforeTemplateLinkNode !== beforeTemplateCompileNode) {
	              var oldClasses = beforeTemplateLinkNode.className;
	
	              if (!(previousCompileContext.hasElementTranscludeDirective &&
	                  origAsyncDirective.replace)) {
	                // it was cloned therefore we have to clone as well.
	                linkNode = jqLiteClone(compileNode);
	              }
	              replaceWith(linkRootElement, jqLite(beforeTemplateLinkNode), linkNode);
	
	              // Copy in CSS classes from original node
	              safeAddClass(jqLite(linkNode), oldClasses);
	            }
	            if (afterTemplateNodeLinkFn.transcludeOnThisElement) {
	              childBoundTranscludeFn = createBoundTranscludeFn(scope, afterTemplateNodeLinkFn.transclude, boundTranscludeFn);
	            } else {
	              childBoundTranscludeFn = boundTranscludeFn;
	            }
	            afterTemplateNodeLinkFn(afterTemplateChildLinkFn, scope, linkNode, $rootElement,
	              childBoundTranscludeFn);
	          }
	          linkQueue = null;
	        });
	
	      return function delayedNodeLinkFn(ignoreChildLinkFn, scope, node, rootElement, boundTranscludeFn) {
	        var childBoundTranscludeFn = boundTranscludeFn;
	        if (scope.$$destroyed) return;
	        if (linkQueue) {
	          linkQueue.push(scope,
	                         node,
	                         rootElement,
	                         childBoundTranscludeFn);
	        } else {
	          if (afterTemplateNodeLinkFn.transcludeOnThisElement) {
	            childBoundTranscludeFn = createBoundTranscludeFn(scope, afterTemplateNodeLinkFn.transclude, boundTranscludeFn);
	          }
	          afterTemplateNodeLinkFn(afterTemplateChildLinkFn, scope, node, rootElement, childBoundTranscludeFn);
	        }
	      };
	    }
	
	
	    /**
	     * Sorting function for bound directives.
	     */
	    function byPriority(a, b) {
	      var diff = b.priority - a.priority;
	      if (diff !== 0) return diff;
	      if (a.name !== b.name) return (a.name < b.name) ? -1 : 1;
	      return a.index - b.index;
	    }
	
	    function assertNoDuplicate(what, previousDirective, directive, element) {
	
	      function wrapModuleNameIfDefined(moduleName) {
	        return moduleName ?
	          (' (module: ' + moduleName + ')') :
	          '';
	      }
	
	      if (previousDirective) {
	        throw $compileMinErr('multidir', 'Multiple directives [{0}{1}, {2}{3}] asking for {4} on: {5}',
	            previousDirective.name, wrapModuleNameIfDefined(previousDirective.$$moduleName),
	            directive.name, wrapModuleNameIfDefined(directive.$$moduleName), what, startingTag(element));
	      }
	    }
	
	
	    function addTextInterpolateDirective(directives, text) {
	      var interpolateFn = $interpolate(text, true);
	      if (interpolateFn) {
	        directives.push({
	          priority: 0,
	          compile: function textInterpolateCompileFn(templateNode) {
	            var templateNodeParent = templateNode.parent(),
	                hasCompileParent = !!templateNodeParent.length;
	
	            // When transcluding a template that has bindings in the root
	            // we don't have a parent and thus need to add the class during linking fn.
	            if (hasCompileParent) compile.$$addBindingClass(templateNodeParent);
	
	            return function textInterpolateLinkFn(scope, node) {
	              var parent = node.parent();
	              if (!hasCompileParent) compile.$$addBindingClass(parent);
	              compile.$$addBindingInfo(parent, interpolateFn.expressions);
	              scope.$watch(interpolateFn, function interpolateFnWatchAction(value) {
	                node[0].nodeValue = value;
	              });
	            };
	          }
	        });
	      }
	    }
	
	
	    function wrapTemplate(type, template) {
	      type = lowercase(type || 'html');
	      switch (type) {
	      case 'svg':
	      case 'math':
	        var wrapper = window.document.createElement('div');
	        wrapper.innerHTML = '<' + type + '>' + template + '</' + type + '>';
	        return wrapper.childNodes[0].childNodes;
	      default:
	        return template;
	      }
	    }
	
	
	    function getTrustedContext(node, attrNormalizedName) {
	      if (attrNormalizedName == "srcdoc") {
	        return $sce.HTML;
	      }
	      var tag = nodeName_(node);
	      // maction[xlink:href] can source SVG.  It's not limited to <maction>.
	      if (attrNormalizedName == "xlinkHref" ||
	          (tag == "form" && attrNormalizedName == "action") ||
	          (tag != "img" && (attrNormalizedName == "src" ||
	                            attrNormalizedName == "ngSrc"))) {
	        return $sce.RESOURCE_URL;
	      }
	    }
	
	
	    function addAttrInterpolateDirective(node, directives, value, name, allOrNothing) {
	      var trustedContext = getTrustedContext(node, name);
	      allOrNothing = ALL_OR_NOTHING_ATTRS[name] || allOrNothing;
	
	      var interpolateFn = $interpolate(value, true, trustedContext, allOrNothing);
	
	      // no interpolation found -> ignore
	      if (!interpolateFn) return;
	
	
	      if (name === "multiple" && nodeName_(node) === "select") {
	        throw $compileMinErr("selmulti",
	            "Binding to the 'multiple' attribute is not supported. Element: {0}",
	            startingTag(node));
	      }
	
	      directives.push({
	        priority: 100,
	        compile: function() {
	            return {
	              pre: function attrInterpolatePreLinkFn(scope, element, attr) {
	                var $$observers = (attr.$$observers || (attr.$$observers = createMap()));
	
	                if (EVENT_HANDLER_ATTR_REGEXP.test(name)) {
	                  throw $compileMinErr('nodomevents',
	                      "Interpolations for HTML DOM event attributes are disallowed.  Please use the " +
	                          "ng- versions (such as ng-click instead of onclick) instead.");
	                }
	
	                // If the attribute has changed since last $interpolate()ed
	                var newValue = attr[name];
	                if (newValue !== value) {
	                  // we need to interpolate again since the attribute value has been updated
	                  // (e.g. by another directive's compile function)
	                  // ensure unset/empty values make interpolateFn falsy
	                  interpolateFn = newValue && $interpolate(newValue, true, trustedContext, allOrNothing);
	                  value = newValue;
	                }
	
	                // if attribute was updated so that there is no interpolation going on we don't want to
	                // register any observers
	                if (!interpolateFn) return;
	
	                // initialize attr object so that it's ready in case we need the value for isolate
	                // scope initialization, otherwise the value would not be available from isolate
	                // directive's linking fn during linking phase
	                attr[name] = interpolateFn(scope);
	
	                ($$observers[name] || ($$observers[name] = [])).$$inter = true;
	                (attr.$$observers && attr.$$observers[name].$$scope || scope).
	                  $watch(interpolateFn, function interpolateFnWatchAction(newValue, oldValue) {
	                    //special case for class attribute addition + removal
	                    //so that class changes can tap into the animation
	                    //hooks provided by the $animate service. Be sure to
	                    //skip animations when the first digest occurs (when
	                    //both the new and the old values are the same) since
	                    //the CSS classes are the non-interpolated values
	                    if (name === 'class' && newValue != oldValue) {
	                      attr.$updateClass(newValue, oldValue);
	                    } else {
	                      attr.$set(name, newValue);
	                    }
	                  });
	              }
	            };
	          }
	      });
	    }
	
	
	    /**
	     * This is a special jqLite.replaceWith, which can replace items which
	     * have no parents, provided that the containing jqLite collection is provided.
	     *
	     * @param {JqLite=} $rootElement The root of the compile tree. Used so that we can replace nodes
	     *                               in the root of the tree.
	     * @param {JqLite} elementsToRemove The jqLite element which we are going to replace. We keep
	     *                                  the shell, but replace its DOM node reference.
	     * @param {Node} newNode The new DOM node.
	     */
	    function replaceWith($rootElement, elementsToRemove, newNode) {
	      var firstElementToRemove = elementsToRemove[0],
	          removeCount = elementsToRemove.length,
	          parent = firstElementToRemove.parentNode,
	          i, ii;
	
	      if ($rootElement) {
	        for (i = 0, ii = $rootElement.length; i < ii; i++) {
	          if ($rootElement[i] == firstElementToRemove) {
	            $rootElement[i++] = newNode;
	            for (var j = i, j2 = j + removeCount - 1,
	                     jj = $rootElement.length;
	                 j < jj; j++, j2++) {
	              if (j2 < jj) {
	                $rootElement[j] = $rootElement[j2];
	              } else {
	                delete $rootElement[j];
	              }
	            }
	            $rootElement.length -= removeCount - 1;
	
	            // If the replaced element is also the jQuery .context then replace it
	            // .context is a deprecated jQuery api, so we should set it only when jQuery set it
	            // http://api.jquery.com/context/
	            if ($rootElement.context === firstElementToRemove) {
	              $rootElement.context = newNode;
	            }
	            break;
	          }
	        }
	      }
	
	      if (parent) {
	        parent.replaceChild(newNode, firstElementToRemove);
	      }
	
	      // Append all the `elementsToRemove` to a fragment. This will...
	      // - remove them from the DOM
	      // - allow them to still be traversed with .nextSibling
	      // - allow a single fragment.qSA to fetch all elements being removed
	      var fragment = window.document.createDocumentFragment();
	      for (i = 0; i < removeCount; i++) {
	        fragment.appendChild(elementsToRemove[i]);
	      }
	
	      if (jqLite.hasData(firstElementToRemove)) {
	        // Copy over user data (that includes Angular's $scope etc.). Don't copy private
	        // data here because there's no public interface in jQuery to do that and copying over
	        // event listeners (which is the main use of private data) wouldn't work anyway.
	        jqLite.data(newNode, jqLite.data(firstElementToRemove));
	
	        // Remove $destroy event listeners from `firstElementToRemove`
	        jqLite(firstElementToRemove).off('$destroy');
	      }
	
	      // Cleanup any data/listeners on the elements and children.
	      // This includes invoking the $destroy event on any elements with listeners.
	      jqLite.cleanData(fragment.querySelectorAll('*'));
	
	      // Update the jqLite collection to only contain the `newNode`
	      for (i = 1; i < removeCount; i++) {
	        delete elementsToRemove[i];
	      }
	      elementsToRemove[0] = newNode;
	      elementsToRemove.length = 1;
	    }
	
	
	    function cloneAndAnnotateFn(fn, annotation) {
	      return extend(function() { return fn.apply(null, arguments); }, fn, annotation);
	    }
	
	
	    function invokeLinkFn(linkFn, scope, $element, attrs, controllers, transcludeFn) {
	      try {
	        linkFn(scope, $element, attrs, controllers, transcludeFn);
	      } catch (e) {
	        $exceptionHandler(e, startingTag($element));
	      }
	    }
	
	
	    // Set up $watches for isolate scope and controller bindings. This process
	    // only occurs for isolate scopes and new scopes with controllerAs.
	    function initializeDirectiveBindings(scope, attrs, destination, bindings, directive) {
	      var removeWatchCollection = [];
	      var initialChanges = {};
	      var changes;
	      forEach(bindings, function initializeBinding(definition, scopeName) {
	        var attrName = definition.attrName,
	        optional = definition.optional,
	        mode = definition.mode, // @, =, or &
	        lastValue,
	        parentGet, parentSet, compare, removeWatch;
	
	        switch (mode) {
	
	          case '@':
	            if (!optional && !hasOwnProperty.call(attrs, attrName)) {
	              destination[scopeName] = attrs[attrName] = void 0;
	            }
	            attrs.$observe(attrName, function(value) {
	              if (isString(value) || isBoolean(value)) {
	                var oldValue = destination[scopeName];
	                recordChanges(scopeName, value, oldValue);
	                destination[scopeName] = value;
	              }
	            });
	            attrs.$$observers[attrName].$$scope = scope;
	            lastValue = attrs[attrName];
	            if (isString(lastValue)) {
	              // If the attribute has been provided then we trigger an interpolation to ensure
	              // the value is there for use in the link fn
	              destination[scopeName] = $interpolate(lastValue)(scope);
	            } else if (isBoolean(lastValue)) {
	              // If the attributes is one of the BOOLEAN_ATTR then Angular will have converted
	              // the value to boolean rather than a string, so we special case this situation
	              destination[scopeName] = lastValue;
	            }
	            initialChanges[scopeName] = new SimpleChange(_UNINITIALIZED_VALUE, destination[scopeName]);
	            break;
	
	          case '=':
	            if (!hasOwnProperty.call(attrs, attrName)) {
	              if (optional) break;
	              attrs[attrName] = void 0;
	            }
	            if (optional && !attrs[attrName]) break;
	
	            parentGet = $parse(attrs[attrName]);
	            if (parentGet.literal) {
	              compare = equals;
	            } else {
	              compare = function simpleCompare(a, b) { return a === b || (a !== a && b !== b); };
	            }
	            parentSet = parentGet.assign || function() {
	              // reset the change, or we will throw this exception on every $digest
	              lastValue = destination[scopeName] = parentGet(scope);
	              throw $compileMinErr('nonassign',
	                  "Expression '{0}' in attribute '{1}' used with directive '{2}' is non-assignable!",
	                  attrs[attrName], attrName, directive.name);
	            };
	            lastValue = destination[scopeName] = parentGet(scope);
	            var parentValueWatch = function parentValueWatch(parentValue) {
	              if (!compare(parentValue, destination[scopeName])) {
	                // we are out of sync and need to copy
	                if (!compare(parentValue, lastValue)) {
	                  // parent changed and it has precedence
	                  destination[scopeName] = parentValue;
	                } else {
	                  // if the parent can be assigned then do so
	                  parentSet(scope, parentValue = destination[scopeName]);
	                }
	              }
	              return lastValue = parentValue;
	            };
	            parentValueWatch.$stateful = true;
	            if (definition.collection) {
	              removeWatch = scope.$watchCollection(attrs[attrName], parentValueWatch);
	            } else {
	              removeWatch = scope.$watch($parse(attrs[attrName], parentValueWatch), null, parentGet.literal);
	            }
	            removeWatchCollection.push(removeWatch);
	            break;
	
	          case '<':
	            if (!hasOwnProperty.call(attrs, attrName)) {
	              if (optional) break;
	              attrs[attrName] = void 0;
	            }
	            if (optional && !attrs[attrName]) break;
	
	            parentGet = $parse(attrs[attrName]);
	
	            var initialValue = destination[scopeName] = parentGet(scope);
	            initialChanges[scopeName] = new SimpleChange(_UNINITIALIZED_VALUE, destination[scopeName]);
	
	            removeWatch = scope.$watch(parentGet, function parentValueWatchAction(newValue, oldValue) {
	              if (oldValue === newValue) {
	                if (oldValue === initialValue) return;
	                oldValue = initialValue;
	              }
	              recordChanges(scopeName, newValue, oldValue);
	              destination[scopeName] = newValue;
	            }, parentGet.literal);
	
	            removeWatchCollection.push(removeWatch);
	            break;
	
	          case '&':
	            // Don't assign Object.prototype method to scope
	            parentGet = attrs.hasOwnProperty(attrName) ? $parse(attrs[attrName]) : noop;
	
	            // Don't assign noop to destination if expression is not valid
	            if (parentGet === noop && optional) break;
	
	            destination[scopeName] = function(locals) {
	              return parentGet(scope, locals);
	            };
	            break;
	        }
	      });
	
	      function recordChanges(key, currentValue, previousValue) {
	        if (isFunction(destination.$onChanges) && currentValue !== previousValue) {
	          // If we have not already scheduled the top level onChangesQueue handler then do so now
	          if (!onChangesQueue) {
	            scope.$$postDigest(flushOnChangesQueue);
	            onChangesQueue = [];
	          }
	          // If we have not already queued a trigger of onChanges for this controller then do so now
	          if (!changes) {
	            changes = {};
	            onChangesQueue.push(triggerOnChangesHook);
	          }
	          // If the has been a change on this property already then we need to reuse the previous value
	          if (changes[key]) {
	            previousValue = changes[key].previousValue;
	          }
	          // Store this change
	          changes[key] = new SimpleChange(previousValue, currentValue);
	        }
	      }
	
	      function triggerOnChangesHook() {
	        destination.$onChanges(changes);
	        // Now clear the changes so that we schedule onChanges when more changes arrive
	        changes = undefined;
	      }
	
	      return {
	        initialChanges: initialChanges,
	        removeWatches: removeWatchCollection.length && function removeWatches() {
	          for (var i = 0, ii = removeWatchCollection.length; i < ii; ++i) {
	            removeWatchCollection[i]();
	          }
	        }
	      };
	    }
	  }];
	}
	
	function SimpleChange(previous, current) {
	  this.previousValue = previous;
	  this.currentValue = current;
	}
	SimpleChange.prototype.isFirstChange = function() { return this.previousValue === _UNINITIALIZED_VALUE; };
	
	
	var PREFIX_REGEXP = /^((?:x|data)[\:\-_])/i;
	/**
	 * Converts all accepted directives format into proper directive name.
	 * @param name Name to normalize
	 */
	function directiveNormalize(name) {
	  return camelCase(name.replace(PREFIX_REGEXP, ''));
	}
	
	/**
	 * @ngdoc type
	 * @name $compile.directive.Attributes
	 *
	 * @description
	 * A shared object between directive compile / linking functions which contains normalized DOM
	 * element attributes. The values reflect current binding state `{{ }}`. The normalization is
	 * needed since all of these are treated as equivalent in Angular:
	 *
	 * ```
	 *    <span ng:bind="a" ng-bind="a" data-ng-bind="a" x-ng-bind="a">
	 * ```
	 */
	
	/**
	 * @ngdoc property
	 * @name $compile.directive.Attributes#$attr
	 *
	 * @description
	 * A map of DOM element attribute names to the normalized name. This is
	 * needed to do reverse lookup from normalized name back to actual name.
	 */
	
	
	/**
	 * @ngdoc method
	 * @name $compile.directive.Attributes#$set
	 * @kind function
	 *
	 * @description
	 * Set DOM element attribute value.
	 *
	 *
	 * @param {string} name Normalized element attribute name of the property to modify. The name is
	 *          reverse-translated using the {@link ng.$compile.directive.Attributes#$attr $attr}
	 *          property to the original name.
	 * @param {string} value Value to set the attribute to. The value can be an interpolated string.
	 */
	
	
	
	/**
	 * Closure compiler type information
	 */
	
	function nodesetLinkingFn(
	  /* angular.Scope */ scope,
	  /* NodeList */ nodeList,
	  /* Element */ rootElement,
	  /* function(Function) */ boundTranscludeFn
	) {}
	
	function directiveLinkingFn(
	  /* nodesetLinkingFn */ nodesetLinkingFn,
	  /* angular.Scope */ scope,
	  /* Node */ node,
	  /* Element */ rootElement,
	  /* function(Function) */ boundTranscludeFn
	) {}
	
	function tokenDifference(str1, str2) {
	  var values = '',
	      tokens1 = str1.split(/\s+/),
	      tokens2 = str2.split(/\s+/);
	
	  outer:
	  for (var i = 0; i < tokens1.length; i++) {
	    var token = tokens1[i];
	    for (var j = 0; j < tokens2.length; j++) {
	      if (token == tokens2[j]) continue outer;
	    }
	    values += (values.length > 0 ? ' ' : '') + token;
	  }
	  return values;
	}
	
	function removeComments(jqNodes) {
	  jqNodes = jqLite(jqNodes);
	  var i = jqNodes.length;
	
	  if (i <= 1) {
	    return jqNodes;
	  }
	
	  while (i--) {
	    var node = jqNodes[i];
	    if (node.nodeType === NODE_TYPE_COMMENT) {
	      splice.call(jqNodes, i, 1);
	    }
	  }
	  return jqNodes;
	}
	
	var $controllerMinErr = minErr('$controller');
	
	
	var CNTRL_REG = /^(\S+)(\s+as\s+([\w$]+))?$/;
	function identifierForController(controller, ident) {
	  if (ident && isString(ident)) return ident;
	  if (isString(controller)) {
	    var match = CNTRL_REG.exec(controller);
	    if (match) return match[3];
	  }
	}
	
	
	/**
	 * @ngdoc provider
	 * @name $controllerProvider
	 * @description
	 * The {@link ng.$controller $controller service} is used by Angular to create new
	 * controllers.
	 *
	 * This provider allows controller registration via the
	 * {@link ng.$controllerProvider#register register} method.
	 */
	function $ControllerProvider() {
	  var controllers = {},
	      globals = false;
	
	  /**
	   * @ngdoc method
	   * @name $controllerProvider#has
	   * @param {string} name Controller name to check.
	   */
	  this.has = function(name) {
	    return controllers.hasOwnProperty(name);
	  };
	
	  /**
	   * @ngdoc method
	   * @name $controllerProvider#register
	   * @param {string|Object} name Controller name, or an object map of controllers where the keys are
	   *    the names and the values are the constructors.
	   * @param {Function|Array} constructor Controller constructor fn (optionally decorated with DI
	   *    annotations in the array notation).
	   */
	  this.register = function(name, constructor) {
	    assertNotHasOwnProperty(name, 'controller');
	    if (isObject(name)) {
	      extend(controllers, name);
	    } else {
	      controllers[name] = constructor;
	    }
	  };
	
	  /**
	   * @ngdoc method
	   * @name $controllerProvider#allowGlobals
	   * @description If called, allows `$controller` to find controller constructors on `window`
	   */
	  this.allowGlobals = function() {
	    globals = true;
	  };
	
	
	  this.$get = ['$injector', '$window', function($injector, $window) {
	
	    /**
	     * @ngdoc service
	     * @name $controller
	     * @requires $injector
	     *
	     * @param {Function|string} constructor If called with a function then it's considered to be the
	     *    controller constructor function. Otherwise it's considered to be a string which is used
	     *    to retrieve the controller constructor using the following steps:
	     *
	     *    * check if a controller with given name is registered via `$controllerProvider`
	     *    * check if evaluating the string on the current scope returns a constructor
	     *    * if $controllerProvider#allowGlobals, check `window[constructor]` on the global
	     *      `window` object (not recommended)
	     *
	     *    The string can use the `controller as property` syntax, where the controller instance is published
	     *    as the specified property on the `scope`; the `scope` must be injected into `locals` param for this
	     *    to work correctly.
	     *
	     * @param {Object} locals Injection locals for Controller.
	     * @return {Object} Instance of given controller.
	     *
	     * @description
	     * `$controller` service is responsible for instantiating controllers.
	     *
	     * It's just a simple call to {@link auto.$injector $injector}, but extracted into
	     * a service, so that one can override this service with [BC version](https://gist.github.com/1649788).
	     */
	    return function $controller(expression, locals, later, ident) {
	      // PRIVATE API:
	      //   param `later` --- indicates that the controller's constructor is invoked at a later time.
	      //                     If true, $controller will allocate the object with the correct
	      //                     prototype chain, but will not invoke the controller until a returned
	      //                     callback is invoked.
	      //   param `ident` --- An optional label which overrides the label parsed from the controller
	      //                     expression, if any.
	      var instance, match, constructor, identifier;
	      later = later === true;
	      if (ident && isString(ident)) {
	        identifier = ident;
	      }
	
	      if (isString(expression)) {
	        match = expression.match(CNTRL_REG);
	        if (!match) {
	          throw $controllerMinErr('ctrlfmt',
	            "Badly formed controller string '{0}'. " +
	            "Must match `__name__ as __id__` or `__name__`.", expression);
	        }
	        constructor = match[1],
	        identifier = identifier || match[3];
	        expression = controllers.hasOwnProperty(constructor)
	            ? controllers[constructor]
	            : getter(locals.$scope, constructor, true) ||
	                (globals ? getter($window, constructor, true) : undefined);
	
	        assertArgFn(expression, constructor, true);
	      }
	
	      if (later) {
	        // Instantiate controller later:
	        // This machinery is used to create an instance of the object before calling the
	        // controller's constructor itself.
	        //
	        // This allows properties to be added to the controller before the constructor is
	        // invoked. Primarily, this is used for isolate scope bindings in $compile.
	        //
	        // This feature is not intended for use by applications, and is thus not documented
	        // publicly.
	        // Object creation: http://jsperf.com/create-constructor/2
	        var controllerPrototype = (isArray(expression) ?
	          expression[expression.length - 1] : expression).prototype;
	        instance = Object.create(controllerPrototype || null);
	
	        if (identifier) {
	          addIdentifier(locals, identifier, instance, constructor || expression.name);
	        }
	
	        var instantiate;
	        return instantiate = extend(function $controllerInit() {
	          var result = $injector.invoke(expression, instance, locals, constructor);
	          if (result !== instance && (isObject(result) || isFunction(result))) {
	            instance = result;
	            if (identifier) {
	              // If result changed, re-assign controllerAs value to scope.
	              addIdentifier(locals, identifier, instance, constructor || expression.name);
	            }
	          }
	          return instance;
	        }, {
	          instance: instance,
	          identifier: identifier
	        });
	      }
	
	      instance = $injector.instantiate(expression, locals, constructor);
	
	      if (identifier) {
	        addIdentifier(locals, identifier, instance, constructor || expression.name);
	      }
	
	      return instance;
	    };
	
	    function addIdentifier(locals, identifier, instance, name) {
	      if (!(locals && isObject(locals.$scope))) {
	        throw minErr('$controller')('noscp',
	          "Cannot export controller '{0}' as '{1}'! No $scope object provided via `locals`.",
	          name, identifier);
	      }
	
	      locals.$scope[identifier] = instance;
	    }
	  }];
	}
	
	/**
	 * @ngdoc service
	 * @name $document
	 * @requires $window
	 *
	 * @description
	 * A {@link angular.element jQuery or jqLite} wrapper for the browser's `window.document` object.
	 *
	 * @example
	   <example module="documentExample">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	         <p>$document title: <b ng-bind="title"></b></p>
	         <p>window.document title: <b ng-bind="windowTitle"></b></p>
	       </div>
	     </file>
	     <file name="script.js">
	       angular.module('documentExample', [])
	         .controller('ExampleController', ['$scope', '$document', function($scope, $document) {
	           $scope.title = $document[0].title;
	           $scope.windowTitle = angular.element(window.document)[0].title;
	         }]);
	     </file>
	   </example>
	 */
	function $DocumentProvider() {
	  this.$get = ['$window', function(window) {
	    return jqLite(window.document);
	  }];
	}
	
	/**
	 * @ngdoc service
	 * @name $exceptionHandler
	 * @requires ng.$log
	 *
	 * @description
	 * Any uncaught exception in angular expressions is delegated to this service.
	 * The default implementation simply delegates to `$log.error` which logs it into
	 * the browser console.
	 *
	 * In unit tests, if `angular-mocks.js` is loaded, this service is overridden by
	 * {@link ngMock.$exceptionHandler mock $exceptionHandler} which aids in testing.
	 *
	 * ## Example:
	 *
	 * ```js
	 *   angular.module('exceptionOverride', []).factory('$exceptionHandler', function() {
	 *     return function(exception, cause) {
	 *       exception.message += ' (caused by "' + cause + '")';
	 *       throw exception;
	 *     };
	 *   });
	 * ```
	 *
	 * This example will override the normal action of `$exceptionHandler`, to make angular
	 * exceptions fail hard when they happen, instead of just logging to the console.
	 *
	 * <hr />
	 * Note, that code executed in event-listeners (even those registered using jqLite's `on`/`bind`
	 * methods) does not delegate exceptions to the {@link ng.$exceptionHandler $exceptionHandler}
	 * (unless executed during a digest).
	 *
	 * If you wish, you can manually delegate exceptions, e.g.
	 * `try { ... } catch(e) { $exceptionHandler(e); }`
	 *
	 * @param {Error} exception Exception associated with the error.
	 * @param {string=} cause optional information about the context in which
	 *       the error was thrown.
	 *
	 */
	function $ExceptionHandlerProvider() {
	  this.$get = ['$log', function($log) {
	    return function(exception, cause) {
	      $log.error.apply($log, arguments);
	    };
	  }];
	}
	
	var $$ForceReflowProvider = function() {
	  this.$get = ['$document', function($document) {
	    return function(domNode) {
	      //the line below will force the browser to perform a repaint so
	      //that all the animated elements within the animation frame will
	      //be properly updated and drawn on screen. This is required to
	      //ensure that the preparation animation is properly flushed so that
	      //the active state picks up from there. DO NOT REMOVE THIS LINE.
	      //DO NOT OPTIMIZE THIS LINE. THE MINIFIER WILL REMOVE IT OTHERWISE WHICH
	      //WILL RESULT IN AN UNPREDICTABLE BUG THAT IS VERY HARD TO TRACK DOWN AND
	      //WILL TAKE YEARS AWAY FROM YOUR LIFE.
	      if (domNode) {
	        if (!domNode.nodeType && domNode instanceof jqLite) {
	          domNode = domNode[0];
	        }
	      } else {
	        domNode = $document[0].body;
	      }
	      return domNode.offsetWidth + 1;
	    };
	  }];
	};
	
	var APPLICATION_JSON = 'application/json';
	var CONTENT_TYPE_APPLICATION_JSON = {'Content-Type': APPLICATION_JSON + ';charset=utf-8'};
	var JSON_START = /^\[|^\{(?!\{)/;
	var JSON_ENDS = {
	  '[': /]$/,
	  '{': /}$/
	};
	var JSON_PROTECTION_PREFIX = /^\)\]\}',?\n/;
	var $httpMinErr = minErr('$http');
	var $httpMinErrLegacyFn = function(method) {
	  return function() {
	    throw $httpMinErr('legacy', 'The method `{0}` on the promise returned from `$http` has been disabled.', method);
	  };
	};
	
	function serializeValue(v) {
	  if (isObject(v)) {
	    return isDate(v) ? v.toISOString() : toJson(v);
	  }
	  return v;
	}
	
	
	function $HttpParamSerializerProvider() {
	  /**
	   * @ngdoc service
	   * @name $httpParamSerializer
	   * @description
	   *
	   * Default {@link $http `$http`} params serializer that converts objects to strings
	   * according to the following rules:
	   *
	   * * `{'foo': 'bar'}` results in `foo=bar`
	   * * `{'foo': Date.now()}` results in `foo=2015-04-01T09%3A50%3A49.262Z` (`toISOString()` and encoded representation of a Date object)
	   * * `{'foo': ['bar', 'baz']}` results in `foo=bar&foo=baz` (repeated key for each array element)
	   * * `{'foo': {'bar':'baz'}}` results in `foo=%7B%22bar%22%3A%22baz%22%7D"` (stringified and encoded representation of an object)
	   *
	   * Note that serializer will sort the request parameters alphabetically.
	   * */
	
	  this.$get = function() {
	    return function ngParamSerializer(params) {
	      if (!params) return '';
	      var parts = [];
	      forEachSorted(params, function(value, key) {
	        if (value === null || isUndefined(value)) return;
	        if (isArray(value)) {
	          forEach(value, function(v) {
	            parts.push(encodeUriQuery(key)  + '=' + encodeUriQuery(serializeValue(v)));
	          });
	        } else {
	          parts.push(encodeUriQuery(key) + '=' + encodeUriQuery(serializeValue(value)));
	        }
	      });
	
	      return parts.join('&');
	    };
	  };
	}
	
	function $HttpParamSerializerJQLikeProvider() {
	  /**
	   * @ngdoc service
	   * @name $httpParamSerializerJQLike
	   * @description
	   *
	   * Alternative {@link $http `$http`} params serializer that follows
	   * jQuery's [`param()`](http://api.jquery.com/jquery.param/) method logic.
	   * The serializer will also sort the params alphabetically.
	   *
	   * To use it for serializing `$http` request parameters, set it as the `paramSerializer` property:
	   *
	   * ```js
	   * $http({
	   *   url: myUrl,
	   *   method: 'GET',
	   *   params: myParams,
	   *   paramSerializer: '$httpParamSerializerJQLike'
	   * });
	   * ```
	   *
	   * It is also possible to set it as the default `paramSerializer` in the
	   * {@link $httpProvider#defaults `$httpProvider`}.
	   *
	   * Additionally, you can inject the serializer and use it explicitly, for example to serialize
	   * form data for submission:
	   *
	   * ```js
	   * .controller(function($http, $httpParamSerializerJQLike) {
	   *   //...
	   *
	   *   $http({
	   *     url: myUrl,
	   *     method: 'POST',
	   *     data: $httpParamSerializerJQLike(myData),
	   *     headers: {
	   *       'Content-Type': 'application/x-www-form-urlencoded'
	   *     }
	   *   });
	   *
	   * });
	   * ```
	   *
	   * */
	  this.$get = function() {
	    return function jQueryLikeParamSerializer(params) {
	      if (!params) return '';
	      var parts = [];
	      serialize(params, '', true);
	      return parts.join('&');
	
	      function serialize(toSerialize, prefix, topLevel) {
	        if (toSerialize === null || isUndefined(toSerialize)) return;
	        if (isArray(toSerialize)) {
	          forEach(toSerialize, function(value, index) {
	            serialize(value, prefix + '[' + (isObject(value) ? index : '') + ']');
	          });
	        } else if (isObject(toSerialize) && !isDate(toSerialize)) {
	          forEachSorted(toSerialize, function(value, key) {
	            serialize(value, prefix +
	                (topLevel ? '' : '[') +
	                key +
	                (topLevel ? '' : ']'));
	          });
	        } else {
	          parts.push(encodeUriQuery(prefix) + '=' + encodeUriQuery(serializeValue(toSerialize)));
	        }
	      }
	    };
	  };
	}
	
	function defaultHttpResponseTransform(data, headers) {
	  if (isString(data)) {
	    // Strip json vulnerability protection prefix and trim whitespace
	    var tempData = data.replace(JSON_PROTECTION_PREFIX, '').trim();
	
	    if (tempData) {
	      var contentType = headers('Content-Type');
	      if ((contentType && (contentType.indexOf(APPLICATION_JSON) === 0)) || isJsonLike(tempData)) {
	        data = fromJson(tempData);
	      }
	    }
	  }
	
	  return data;
	}
	
	function isJsonLike(str) {
	    var jsonStart = str.match(JSON_START);
	    return jsonStart && JSON_ENDS[jsonStart[0]].test(str);
	}
	
	/**
	 * Parse headers into key value object
	 *
	 * @param {string} headers Raw headers as a string
	 * @returns {Object} Parsed headers as key value object
	 */
	function parseHeaders(headers) {
	  var parsed = createMap(), i;
	
	  function fillInParsed(key, val) {
	    if (key) {
	      parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
	    }
	  }
	
	  if (isString(headers)) {
	    forEach(headers.split('\n'), function(line) {
	      i = line.indexOf(':');
	      fillInParsed(lowercase(trim(line.substr(0, i))), trim(line.substr(i + 1)));
	    });
	  } else if (isObject(headers)) {
	    forEach(headers, function(headerVal, headerKey) {
	      fillInParsed(lowercase(headerKey), trim(headerVal));
	    });
	  }
	
	  return parsed;
	}
	
	
	/**
	 * Returns a function that provides access to parsed headers.
	 *
	 * Headers are lazy parsed when first requested.
	 * @see parseHeaders
	 *
	 * @param {(string|Object)} headers Headers to provide access to.
	 * @returns {function(string=)} Returns a getter function which if called with:
	 *
	 *   - if called with single an argument returns a single header value or null
	 *   - if called with no arguments returns an object containing all headers.
	 */
	function headersGetter(headers) {
	  var headersObj;
	
	  return function(name) {
	    if (!headersObj) headersObj =  parseHeaders(headers);
	
	    if (name) {
	      var value = headersObj[lowercase(name)];
	      if (value === void 0) {
	        value = null;
	      }
	      return value;
	    }
	
	    return headersObj;
	  };
	}
	
	
	/**
	 * Chain all given functions
	 *
	 * This function is used for both request and response transforming
	 *
	 * @param {*} data Data to transform.
	 * @param {function(string=)} headers HTTP headers getter fn.
	 * @param {number} status HTTP status code of the response.
	 * @param {(Function|Array.<Function>)} fns Function or an array of functions.
	 * @returns {*} Transformed data.
	 */
	function transformData(data, headers, status, fns) {
	  if (isFunction(fns)) {
	    return fns(data, headers, status);
	  }
	
	  forEach(fns, function(fn) {
	    data = fn(data, headers, status);
	  });
	
	  return data;
	}
	
	
	function isSuccess(status) {
	  return 200 <= status && status < 300;
	}
	
	
	/**
	 * @ngdoc provider
	 * @name $httpProvider
	 * @description
	 * Use `$httpProvider` to change the default behavior of the {@link ng.$http $http} service.
	 * */
	function $HttpProvider() {
	  /**
	   * @ngdoc property
	   * @name $httpProvider#defaults
	   * @description
	   *
	   * Object containing default values for all {@link ng.$http $http} requests.
	   *
	   * - **`defaults.cache`** - {boolean|Object} - A boolean value or object created with
	   * {@link ng.$cacheFactory `$cacheFactory`} to enable or disable caching of HTTP responses
	   * by default. See {@link $http#caching $http Caching} for more information.
	   *
	   * - **`defaults.xsrfCookieName`** - {string} - Name of cookie containing the XSRF token.
	   * Defaults value is `'XSRF-TOKEN'`.
	   *
	   * - **`defaults.xsrfHeaderName`** - {string} - Name of HTTP header to populate with the
	   * XSRF token. Defaults value is `'X-XSRF-TOKEN'`.
	   *
	   * - **`defaults.headers`** - {Object} - Default headers for all $http requests.
	   * Refer to {@link ng.$http#setting-http-headers $http} for documentation on
	   * setting default headers.
	   *     - **`defaults.headers.common`**
	   *     - **`defaults.headers.post`**
	   *     - **`defaults.headers.put`**
	   *     - **`defaults.headers.patch`**
	   *
	   *
	   * - **`defaults.paramSerializer`** - `{string|function(Object<string,string>):string}` - A function
	   *  used to the prepare string representation of request parameters (specified as an object).
	   *  If specified as string, it is interpreted as a function registered with the {@link auto.$injector $injector}.
	   *  Defaults to {@link ng.$httpParamSerializer $httpParamSerializer}.
	   *
	   **/
	  var defaults = this.defaults = {
	    // transform incoming response data
	    transformResponse: [defaultHttpResponseTransform],
	
	    // transform outgoing request data
	    transformRequest: [function(d) {
	      return isObject(d) && !isFile(d) && !isBlob(d) && !isFormData(d) ? toJson(d) : d;
	    }],
	
	    // default headers
	    headers: {
	      common: {
	        'Accept': 'application/json, text/plain, */*'
	      },
	      post:   shallowCopy(CONTENT_TYPE_APPLICATION_JSON),
	      put:    shallowCopy(CONTENT_TYPE_APPLICATION_JSON),
	      patch:  shallowCopy(CONTENT_TYPE_APPLICATION_JSON)
	    },
	
	    xsrfCookieName: 'XSRF-TOKEN',
	    xsrfHeaderName: 'X-XSRF-TOKEN',
	
	    paramSerializer: '$httpParamSerializer'
	  };
	
	  var useApplyAsync = false;
	  /**
	   * @ngdoc method
	   * @name $httpProvider#useApplyAsync
	   * @description
	   *
	   * Configure $http service to combine processing of multiple http responses received at around
	   * the same time via {@link ng.$rootScope.Scope#$applyAsync $rootScope.$applyAsync}. This can result in
	   * significant performance improvement for bigger applications that make many HTTP requests
	   * concurrently (common during application bootstrap).
	   *
	   * Defaults to false. If no value is specified, returns the current configured value.
	   *
	   * @param {boolean=} value If true, when requests are loaded, they will schedule a deferred
	   *    "apply" on the next tick, giving time for subsequent requests in a roughly ~10ms window
	   *    to load and share the same digest cycle.
	   *
	   * @returns {boolean|Object} If a value is specified, returns the $httpProvider for chaining.
	   *    otherwise, returns the current configured value.
	   **/
	  this.useApplyAsync = function(value) {
	    if (isDefined(value)) {
	      useApplyAsync = !!value;
	      return this;
	    }
	    return useApplyAsync;
	  };
	
	  var useLegacyPromise = true;
	  /**
	   * @ngdoc method
	   * @name $httpProvider#useLegacyPromiseExtensions
	   * @description
	   *
	   * Configure `$http` service to return promises without the shorthand methods `success` and `error`.
	   * This should be used to make sure that applications work without these methods.
	   *
	   * Defaults to true. If no value is specified, returns the current configured value.
	   *
	   * @param {boolean=} value If true, `$http` will return a promise with the deprecated legacy `success` and `error` methods.
	   *
	   * @returns {boolean|Object} If a value is specified, returns the $httpProvider for chaining.
	   *    otherwise, returns the current configured value.
	   **/
	  this.useLegacyPromiseExtensions = function(value) {
	    if (isDefined(value)) {
	      useLegacyPromise = !!value;
	      return this;
	    }
	    return useLegacyPromise;
	  };
	
	  /**
	   * @ngdoc property
	   * @name $httpProvider#interceptors
	   * @description
	   *
	   * Array containing service factories for all synchronous or asynchronous {@link ng.$http $http}
	   * pre-processing of request or postprocessing of responses.
	   *
	   * These service factories are ordered by request, i.e. they are applied in the same order as the
	   * array, on request, but reverse order, on response.
	   *
	   * {@link ng.$http#interceptors Interceptors detailed info}
	   **/
	  var interceptorFactories = this.interceptors = [];
	
	  this.$get = ['$httpBackend', '$$cookieReader', '$cacheFactory', '$rootScope', '$q', '$injector',
	      function($httpBackend, $$cookieReader, $cacheFactory, $rootScope, $q, $injector) {
	
	    var defaultCache = $cacheFactory('$http');
	
	    /**
	     * Make sure that default param serializer is exposed as a function
	     */
	    defaults.paramSerializer = isString(defaults.paramSerializer) ?
	      $injector.get(defaults.paramSerializer) : defaults.paramSerializer;
	
	    /**
	     * Interceptors stored in reverse order. Inner interceptors before outer interceptors.
	     * The reversal is needed so that we can build up the interception chain around the
	     * server request.
	     */
	    var reversedInterceptors = [];
	
	    forEach(interceptorFactories, function(interceptorFactory) {
	      reversedInterceptors.unshift(isString(interceptorFactory)
	          ? $injector.get(interceptorFactory) : $injector.invoke(interceptorFactory));
	    });
	
	    /**
	     * @ngdoc service
	     * @kind function
	     * @name $http
	     * @requires ng.$httpBackend
	     * @requires $cacheFactory
	     * @requires $rootScope
	     * @requires $q
	     * @requires $injector
	     *
	     * @description
	     * The `$http` service is a core Angular service that facilitates communication with the remote
	     * HTTP servers via the browser's [XMLHttpRequest](https://developer.mozilla.org/en/xmlhttprequest)
	     * object or via [JSONP](http://en.wikipedia.org/wiki/JSONP).
	     *
	     * For unit testing applications that use `$http` service, see
	     * {@link ngMock.$httpBackend $httpBackend mock}.
	     *
	     * For a higher level of abstraction, please check out the {@link ngResource.$resource
	     * $resource} service.
	     *
	     * The $http API is based on the {@link ng.$q deferred/promise APIs} exposed by
	     * the $q service. While for simple usage patterns this doesn't matter much, for advanced usage
	     * it is important to familiarize yourself with these APIs and the guarantees they provide.
	     *
	     *
	     * ## General usage
	     * The `$http` service is a function which takes a single argument — a {@link $http#usage configuration object} —
	     * that is used to generate an HTTP request and returns  a {@link ng.$q promise}.
	     *
	     * ```js
	     *   // Simple GET request example:
	     *   $http({
	     *     method: 'GET',
	     *     url: '/someUrl'
	     *   }).then(function successCallback(response) {
	     *       // this callback will be called asynchronously
	     *       // when the response is available
	     *     }, function errorCallback(response) {
	     *       // called asynchronously if an error occurs
	     *       // or server returns response with an error status.
	     *     });
	     * ```
	     *
	     * The response object has these properties:
	     *
	     *   - **data** – `{string|Object}` – The response body transformed with the transform
	     *     functions.
	     *   - **status** – `{number}` – HTTP status code of the response.
	     *   - **headers** – `{function([headerName])}` – Header getter function.
	     *   - **config** – `{Object}` – The configuration object that was used to generate the request.
	     *   - **statusText** – `{string}` – HTTP status text of the response.
	     *
	     * A response status code between 200 and 299 is considered a success status and will result in
	     * the success callback being called. Any response status code outside of that range is
	     * considered an error status and will result in the error callback being called.
	     * Also, status codes less than -1 are normalized to zero. -1 usually means the request was
	     * aborted, e.g. using a `config.timeout`.
	     * Note that if the response is a redirect, XMLHttpRequest will transparently follow it, meaning
	     * that the outcome (success or error) will be determined by the final response status code.
	     *
	     *
	     * ## Shortcut methods
	     *
	     * Shortcut methods are also available. All shortcut methods require passing in the URL, and
	     * request data must be passed in for POST/PUT requests. An optional config can be passed as the
	     * last argument.
	     *
	     * ```js
	     *   $http.get('/someUrl', config).then(successCallback, errorCallback);
	     *   $http.post('/someUrl', data, config).then(successCallback, errorCallback);
	     * ```
	     *
	     * Complete list of shortcut methods:
	     *
	     * - {@link ng.$http#get $http.get}
	     * - {@link ng.$http#head $http.head}
	     * - {@link ng.$http#post $http.post}
	     * - {@link ng.$http#put $http.put}
	     * - {@link ng.$http#delete $http.delete}
	     * - {@link ng.$http#jsonp $http.jsonp}
	     * - {@link ng.$http#patch $http.patch}
	     *
	     *
	     * ## Writing Unit Tests that use $http
	     * When unit testing (using {@link ngMock ngMock}), it is necessary to call
	     * {@link ngMock.$httpBackend#flush $httpBackend.flush()} to flush each pending
	     * request using trained responses.
	     *
	     * ```
	     * $httpBackend.expectGET(...);
	     * $http.get(...);
	     * $httpBackend.flush();
	     * ```
	     *
	     * ## Deprecation Notice
	     * <div class="alert alert-danger">
	     *   The `$http` legacy promise methods `success` and `error` have been deprecated.
	     *   Use the standard `then` method instead.
	     *   If {@link $httpProvider#useLegacyPromiseExtensions `$httpProvider.useLegacyPromiseExtensions`} is set to
	     *   `false` then these methods will throw {@link $http:legacy `$http/legacy`} error.
	     * </div>
	     *
	     * ## Setting HTTP Headers
	     *
	     * The $http service will automatically add certain HTTP headers to all requests. These defaults
	     * can be fully configured by accessing the `$httpProvider.defaults.headers` configuration
	     * object, which currently contains this default configuration:
	     *
	     * - `$httpProvider.defaults.headers.common` (headers that are common for all requests):
	     *   - `Accept: application/json, text/plain, * / *`
	     * - `$httpProvider.defaults.headers.post`: (header defaults for POST requests)
	     *   - `Content-Type: application/json`
	     * - `$httpProvider.defaults.headers.put` (header defaults for PUT requests)
	     *   - `Content-Type: application/json`
	     *
	     * To add or overwrite these defaults, simply add or remove a property from these configuration
	     * objects. To add headers for an HTTP method other than POST or PUT, simply add a new object
	     * with the lowercased HTTP method name as the key, e.g.
	     * `$httpProvider.defaults.headers.get = { 'My-Header' : 'value' }`.
	     *
	     * The defaults can also be set at runtime via the `$http.defaults` object in the same
	     * fashion. For example:
	     *
	     * ```
	     * module.run(function($http) {
	     *   $http.defaults.headers.common.Authorization = 'Basic YmVlcDpib29w';
	     * });
	     * ```
	     *
	     * In addition, you can supply a `headers` property in the config object passed when
	     * calling `$http(config)`, which overrides the defaults without changing them globally.
	     *
	     * To explicitly remove a header automatically added via $httpProvider.defaults.headers on a per request basis,
	     * Use the `headers` property, setting the desired header to `undefined`. For example:
	     *
	     * ```js
	     * var req = {
	     *  method: 'POST',
	     *  url: 'http://example.com',
	     *  headers: {
	     *    'Content-Type': undefined
	     *  },
	     *  data: { test: 'test' }
	     * }
	     *
	     * $http(req).then(function(){...}, function(){...});
	     * ```
	     *
	     * ## Transforming Requests and Responses
	     *
	     * Both requests and responses can be transformed using transformation functions: `transformRequest`
	     * and `transformResponse`. These properties can be a single function that returns
	     * the transformed value (`function(data, headersGetter, status)`) or an array of such transformation functions,
	     * which allows you to `push` or `unshift` a new transformation function into the transformation chain.
	     *
	     * <div class="alert alert-warning">
	     * **Note:** Angular does not make a copy of the `data` parameter before it is passed into the `transformRequest` pipeline.
	     * That means changes to the properties of `data` are not local to the transform function (since Javascript passes objects by reference).
	     * For example, when calling `$http.get(url, $scope.myObject)`, modifications to the object's properties in a transformRequest
	     * function will be reflected on the scope and in any templates where the object is data-bound.
	     * To prevent this, transform functions should have no side-effects.
	     * If you need to modify properties, it is recommended to make a copy of the data, or create new object to return.
	     * </div>
	     *
	     * ### Default Transformations
	     *
	     * The `$httpProvider` provider and `$http` service expose `defaults.transformRequest` and
	     * `defaults.transformResponse` properties. If a request does not provide its own transformations
	     * then these will be applied.
	     *
	     * You can augment or replace the default transformations by modifying these properties by adding to or
	     * replacing the array.
	     *
	     * Angular provides the following default transformations:
	     *
	     * Request transformations (`$httpProvider.defaults.transformRequest` and `$http.defaults.transformRequest`):
	     *
	     * - If the `data` property of the request configuration object contains an object, serialize it
	     *   into JSON format.
	     *
	     * Response transformations (`$httpProvider.defaults.transformResponse` and `$http.defaults.transformResponse`):
	     *
	     *  - If XSRF prefix is detected, strip it (see Security Considerations section below).
	     *  - If JSON response is detected, deserialize it using a JSON parser.
	     *
	     *
	     * ### Overriding the Default Transformations Per Request
	     *
	     * If you wish override the request/response transformations only for a single request then provide
	     * `transformRequest` and/or `transformResponse` properties on the configuration object passed
	     * into `$http`.
	     *
	     * Note that if you provide these properties on the config object the default transformations will be
	     * overwritten. If you wish to augment the default transformations then you must include them in your
	     * local transformation array.
	     *
	     * The following code demonstrates adding a new response transformation to be run after the default response
	     * transformations have been run.
	     *
	     * ```js
	     * function appendTransform(defaults, transform) {
	     *
	     *   // We can't guarantee that the default transformation is an array
	     *   defaults = angular.isArray(defaults) ? defaults : [defaults];
	     *
	     *   // Append the new transformation to the defaults
	     *   return defaults.concat(transform);
	     * }
	     *
	     * $http({
	     *   url: '...',
	     *   method: 'GET',
	     *   transformResponse: appendTransform($http.defaults.transformResponse, function(value) {
	     *     return doTransform(value);
	     *   })
	     * });
	     * ```
	     *
	     *
	     * ## Caching
	     *
	     * {@link ng.$http `$http`} responses are not cached by default. To enable caching, you must
	     * set the config.cache value or the default cache value to TRUE or to a cache object (created
	     * with {@link ng.$cacheFactory `$cacheFactory`}). If defined, the value of config.cache takes
	     * precedence over the default cache value.
	     *
	     * In order to:
	     *   * cache all responses - set the default cache value to TRUE or to a cache object
	     *   * cache a specific response - set config.cache value to TRUE or to a cache object
	     *
	     * If caching is enabled, but neither the default cache nor config.cache are set to a cache object,
	     * then the default `$cacheFactory($http)` object is used.
	     *
	     * The default cache value can be set by updating the
	     * {@link ng.$http#defaults `$http.defaults.cache`} property or the
	     * {@link $httpProvider#defaults `$httpProvider.defaults.cache`} property.
	     *
	     * When caching is enabled, {@link ng.$http `$http`} stores the response from the server using
	     * the relevant cache object. The next time the same request is made, the response is returned
	     * from the cache without sending a request to the server.
	     *
	     * Take note that:
	     *
	     *   * Only GET and JSONP requests are cached.
	     *   * The cache key is the request URL including search parameters; headers are not considered.
	     *   * Cached responses are returned asynchronously, in the same way as responses from the server.
	     *   * If multiple identical requests are made using the same cache, which is not yet populated,
	     *     one request will be made to the server and remaining requests will return the same response.
	     *   * A cache-control header on the response does not affect if or how responses are cached.
	     *
	     *
	     * ## Interceptors
	     *
	     * Before you start creating interceptors, be sure to understand the
	     * {@link ng.$q $q and deferred/promise APIs}.
	     *
	     * For purposes of global error handling, authentication, or any kind of synchronous or
	     * asynchronous pre-processing of request or postprocessing of responses, it is desirable to be
	     * able to intercept requests before they are handed to the server and
	     * responses before they are handed over to the application code that
	     * initiated these requests. The interceptors leverage the {@link ng.$q
	     * promise APIs} to fulfill this need for both synchronous and asynchronous pre-processing.
	     *
	     * The interceptors are service factories that are registered with the `$httpProvider` by
	     * adding them to the `$httpProvider.interceptors` array. The factory is called and
	     * injected with dependencies (if specified) and returns the interceptor.
	     *
	     * There are two kinds of interceptors (and two kinds of rejection interceptors):
	     *
	     *   * `request`: interceptors get called with a http {@link $http#usage config} object. The function is free to
	     *     modify the `config` object or create a new one. The function needs to return the `config`
	     *     object directly, or a promise containing the `config` or a new `config` object.
	     *   * `requestError`: interceptor gets called when a previous interceptor threw an error or
	     *     resolved with a rejection.
	     *   * `response`: interceptors get called with http `response` object. The function is free to
	     *     modify the `response` object or create a new one. The function needs to return the `response`
	     *     object directly, or as a promise containing the `response` or a new `response` object.
	     *   * `responseError`: interceptor gets called when a previous interceptor threw an error or
	     *     resolved with a rejection.
	     *
	     *
	     * ```js
	     *   // register the interceptor as a service
	     *   $provide.factory('myHttpInterceptor', function($q, dependency1, dependency2) {
	     *     return {
	     *       // optional method
	     *       'request': function(config) {
	     *         // do something on success
	     *         return config;
	     *       },
	     *
	     *       // optional method
	     *      'requestError': function(rejection) {
	     *         // do something on error
	     *         if (canRecover(rejection)) {
	     *           return responseOrNewPromise
	     *         }
	     *         return $q.reject(rejection);
	     *       },
	     *
	     *
	     *
	     *       // optional method
	     *       'response': function(response) {
	     *         // do something on success
	     *         return response;
	     *       },
	     *
	     *       // optional method
	     *      'responseError': function(rejection) {
	     *         // do something on error
	     *         if (canRecover(rejection)) {
	     *           return responseOrNewPromise
	     *         }
	     *         return $q.reject(rejection);
	     *       }
	     *     };
	     *   });
	     *
	     *   $httpProvider.interceptors.push('myHttpInterceptor');
	     *
	     *
	     *   // alternatively, register the interceptor via an anonymous factory
	     *   $httpProvider.interceptors.push(function($q, dependency1, dependency2) {
	     *     return {
	     *      'request': function(config) {
	     *          // same as above
	     *       },
	     *
	     *       'response': function(response) {
	     *          // same as above
	     *       }
	     *     };
	     *   });
	     * ```
	     *
	     * ## Security Considerations
	     *
	     * When designing web applications, consider security threats from:
	     *
	     * - [JSON vulnerability](http://haacked.com/archive/2008/11/20/anatomy-of-a-subtle-json-vulnerability.aspx)
	     * - [XSRF](http://en.wikipedia.org/wiki/Cross-site_request_forgery)
	     *
	     * Both server and the client must cooperate in order to eliminate these threats. Angular comes
	     * pre-configured with strategies that address these issues, but for this to work backend server
	     * cooperation is required.
	     *
	     * ### JSON Vulnerability Protection
	     *
	     * A [JSON vulnerability](http://haacked.com/archive/2008/11/20/anatomy-of-a-subtle-json-vulnerability.aspx)
	     * allows third party website to turn your JSON resource URL into
	     * [JSONP](http://en.wikipedia.org/wiki/JSONP) request under some conditions. To
	     * counter this your server can prefix all JSON requests with following string `")]}',\n"`.
	     * Angular will automatically strip the prefix before processing it as JSON.
	     *
	     * For example if your server needs to return:
	     * ```js
	     * ['one','two']
	     * ```
	     *
	     * which is vulnerable to attack, your server can return:
	     * ```js
	     * )]}',
	     * ['one','two']
	     * ```
	     *
	     * Angular will strip the prefix, before processing the JSON.
	     *
	     *
	     * ### Cross Site Request Forgery (XSRF) Protection
	     *
	     * [XSRF](http://en.wikipedia.org/wiki/Cross-site_request_forgery) is an attack technique by
	     * which the attacker can trick an authenticated user into unknowingly executing actions on your
	     * website. Angular provides a mechanism to counter XSRF. When performing XHR requests, the
	     * $http service reads a token from a cookie (by default, `XSRF-TOKEN`) and sets it as an HTTP
	     * header (`X-XSRF-TOKEN`). Since only JavaScript that runs on your domain could read the
	     * cookie, your server can be assured that the XHR came from JavaScript running on your domain.
	     * The header will not be set for cross-domain requests.
	     *
	     * To take advantage of this, your server needs to set a token in a JavaScript readable session
	     * cookie called `XSRF-TOKEN` on the first HTTP GET request. On subsequent XHR requests the
	     * server can verify that the cookie matches `X-XSRF-TOKEN` HTTP header, and therefore be sure
	     * that only JavaScript running on your domain could have sent the request. The token must be
	     * unique for each user and must be verifiable by the server (to prevent the JavaScript from
	     * making up its own tokens). We recommend that the token is a digest of your site's
	     * authentication cookie with a [salt](https://en.wikipedia.org/wiki/Salt_(cryptography&#41;)
	     * for added security.
	     *
	     * The name of the headers can be specified using the xsrfHeaderName and xsrfCookieName
	     * properties of either $httpProvider.defaults at config-time, $http.defaults at run-time,
	     * or the per-request config object.
	     *
	     * In order to prevent collisions in environments where multiple Angular apps share the
	     * same domain or subdomain, we recommend that each application uses unique cookie name.
	     *
	     * @param {object} config Object describing the request to be made and how it should be
	     *    processed. The object has following properties:
	     *
	     *    - **method** – `{string}` – HTTP method (e.g. 'GET', 'POST', etc)
	     *    - **url** – `{string}` – Absolute or relative URL of the resource that is being requested.
	     *    - **params** – `{Object.<string|Object>}` – Map of strings or objects which will be serialized
	     *      with the `paramSerializer` and appended as GET parameters.
	     *    - **data** – `{string|Object}` – Data to be sent as the request message data.
	     *    - **headers** – `{Object}` – Map of strings or functions which return strings representing
	     *      HTTP headers to send to the server. If the return value of a function is null, the
	     *      header will not be sent. Functions accept a config object as an argument.
	     *    - **eventHandlers** - `{Object}` - Event listeners to be bound to the XMLHttpRequest object.
	     *      To bind events to the XMLHttpRequest upload object, use `uploadEventHandlers`.
	     *      The handler will be called in the context of a `$apply` block.
	     *    - **uploadEventHandlers** - `{Object}` - Event listeners to be bound to the XMLHttpRequest upload
	     *      object. To bind events to the XMLHttpRequest object, use `eventHandlers`.
	     *      The handler will be called in the context of a `$apply` block.
	     *    - **xsrfHeaderName** – `{string}` – Name of HTTP header to populate with the XSRF token.
	     *    - **xsrfCookieName** – `{string}` – Name of cookie containing the XSRF token.
	     *    - **transformRequest** –
	     *      `{function(data, headersGetter)|Array.<function(data, headersGetter)>}` –
	     *      transform function or an array of such functions. The transform function takes the http
	     *      request body and headers and returns its transformed (typically serialized) version.
	     *      See {@link ng.$http#overriding-the-default-transformations-per-request
	     *      Overriding the Default Transformations}
	     *    - **transformResponse** –
	     *      `{function(data, headersGetter, status)|Array.<function(data, headersGetter, status)>}` –
	     *      transform function or an array of such functions. The transform function takes the http
	     *      response body, headers and status and returns its transformed (typically deserialized) version.
	     *      See {@link ng.$http#overriding-the-default-transformations-per-request
	     *      Overriding the Default Transformations}
	     *    - **paramSerializer** - `{string|function(Object<string,string>):string}` - A function used to
	     *      prepare the string representation of request parameters (specified as an object).
	     *      If specified as string, it is interpreted as function registered with the
	     *      {@link $injector $injector}, which means you can create your own serializer
	     *      by registering it as a {@link auto.$provide#service service}.
	     *      The default serializer is the {@link $httpParamSerializer $httpParamSerializer};
	     *      alternatively, you can use the {@link $httpParamSerializerJQLike $httpParamSerializerJQLike}
	     *    - **cache** – `{boolean|Object}` – A boolean value or object created with
	     *      {@link ng.$cacheFactory `$cacheFactory`} to enable or disable caching of the HTTP response.
	     *      See {@link $http#caching $http Caching} for more information.
	     *    - **timeout** – `{number|Promise}` – timeout in milliseconds, or {@link ng.$q promise}
	     *      that should abort the request when resolved.
	     *    - **withCredentials** - `{boolean}` - whether to set the `withCredentials` flag on the
	     *      XHR object. See [requests with credentials](https://developer.mozilla.org/docs/Web/HTTP/Access_control_CORS#Requests_with_credentials)
	     *      for more information.
	     *    - **responseType** - `{string}` - see
	     *      [XMLHttpRequest.responseType](https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest#xmlhttprequest-responsetype).
	     *
	     * @returns {HttpPromise} Returns a {@link ng.$q `Promise}` that will be resolved to a response object
	     *                        when the request succeeds or fails.
	     *
	     *
	     * @property {Array.<Object>} pendingRequests Array of config objects for currently pending
	     *   requests. This is primarily meant to be used for debugging purposes.
	     *
	     *
	     * @example
	<example module="httpExample">
	<file name="index.html">
	  <div ng-controller="FetchController">
	    <select ng-model="method" aria-label="Request method">
	      <option>GET</option>
	      <option>JSONP</option>
	    </select>
	    <input type="text" ng-model="url" size="80" aria-label="URL" />
	    <button id="fetchbtn" ng-click="fetch()">fetch</button><br>
	    <button id="samplegetbtn" ng-click="updateModel('GET', 'http-hello.html')">Sample GET</button>
	    <button id="samplejsonpbtn"
	      ng-click="updateModel('JSONP',
	                    'https://angularjs.org/greet.php?callback=JSON_CALLBACK&name=Super%20Hero')">
	      Sample JSONP
	    </button>
	    <button id="invalidjsonpbtn"
	      ng-click="updateModel('JSONP', 'https://angularjs.org/doesntexist&callback=JSON_CALLBACK')">
	        Invalid JSONP
	      </button>
	    <pre>http status code: {{status}}</pre>
	    <pre>http response data: {{data}}</pre>
	  </div>
	</file>
	<file name="script.js">
	  angular.module('httpExample', [])
	    .controller('FetchController', ['$scope', '$http', '$templateCache',
	      function($scope, $http, $templateCache) {
	        $scope.method = 'GET';
	        $scope.url = 'http-hello.html';
	
	        $scope.fetch = function() {
	          $scope.code = null;
	          $scope.response = null;
	
	          $http({method: $scope.method, url: $scope.url, cache: $templateCache}).
	            then(function(response) {
	              $scope.status = response.status;
	              $scope.data = response.data;
	            }, function(response) {
	              $scope.data = response.data || "Request failed";
	              $scope.status = response.status;
	          });
	        };
	
	        $scope.updateModel = function(method, url) {
	          $scope.method = method;
	          $scope.url = url;
	        };
	      }]);
	</file>
	<file name="http-hello.html">
	  Hello, $http!
	</file>
	<file name="protractor.js" type="protractor">
	  var status = element(by.binding('status'));
	  var data = element(by.binding('data'));
	  var fetchBtn = element(by.id('fetchbtn'));
	  var sampleGetBtn = element(by.id('samplegetbtn'));
	  var sampleJsonpBtn = element(by.id('samplejsonpbtn'));
	  var invalidJsonpBtn = element(by.id('invalidjsonpbtn'));
	
	  it('should make an xhr GET request', function() {
	    sampleGetBtn.click();
	    fetchBtn.click();
	    expect(status.getText()).toMatch('200');
	    expect(data.getText()).toMatch(/Hello, \$http!/);
	  });
	
	// Commented out due to flakes. See https://github.com/angular/angular.js/issues/9185
	// it('should make a JSONP request to angularjs.org', function() {
	//   sampleJsonpBtn.click();
	//   fetchBtn.click();
	//   expect(status.getText()).toMatch('200');
	//   expect(data.getText()).toMatch(/Super Hero!/);
	// });
	
	  it('should make JSONP request to invalid URL and invoke the error handler',
	      function() {
	    invalidJsonpBtn.click();
	    fetchBtn.click();
	    expect(status.getText()).toMatch('0');
	    expect(data.getText()).toMatch('Request failed');
	  });
	</file>
	</example>
	     */
	    function $http(requestConfig) {
	
	      if (!isObject(requestConfig)) {
	        throw minErr('$http')('badreq', 'Http request configuration must be an object.  Received: {0}', requestConfig);
	      }
	
	      if (!isString(requestConfig.url)) {
	        throw minErr('$http')('badreq', 'Http request configuration url must be a string.  Received: {0}', requestConfig.url);
	      }
	
	      var config = extend({
	        method: 'get',
	        transformRequest: defaults.transformRequest,
	        transformResponse: defaults.transformResponse,
	        paramSerializer: defaults.paramSerializer
	      }, requestConfig);
	
	      config.headers = mergeHeaders(requestConfig);
	      config.method = uppercase(config.method);
	      config.paramSerializer = isString(config.paramSerializer) ?
	        $injector.get(config.paramSerializer) : config.paramSerializer;
	
	      var serverRequest = function(config) {
	        var headers = config.headers;
	        var reqData = transformData(config.data, headersGetter(headers), undefined, config.transformRequest);
	
	        // strip content-type if data is undefined
	        if (isUndefined(reqData)) {
	          forEach(headers, function(value, header) {
	            if (lowercase(header) === 'content-type') {
	                delete headers[header];
	            }
	          });
	        }
	
	        if (isUndefined(config.withCredentials) && !isUndefined(defaults.withCredentials)) {
	          config.withCredentials = defaults.withCredentials;
	        }
	
	        // send request
	        return sendReq(config, reqData).then(transformResponse, transformResponse);
	      };
	
	      var chain = [serverRequest, undefined];
	      var promise = $q.when(config);
	
	      // apply interceptors
	      forEach(reversedInterceptors, function(interceptor) {
	        if (interceptor.request || interceptor.requestError) {
	          chain.unshift(interceptor.request, interceptor.requestError);
	        }
	        if (interceptor.response || interceptor.responseError) {
	          chain.push(interceptor.response, interceptor.responseError);
	        }
	      });
	
	      while (chain.length) {
	        var thenFn = chain.shift();
	        var rejectFn = chain.shift();
	
	        promise = promise.then(thenFn, rejectFn);
	      }
	
	      if (useLegacyPromise) {
	        promise.success = function(fn) {
	          assertArgFn(fn, 'fn');
	
	          promise.then(function(response) {
	            fn(response.data, response.status, response.headers, config);
	          });
	          return promise;
	        };
	
	        promise.error = function(fn) {
	          assertArgFn(fn, 'fn');
	
	          promise.then(null, function(response) {
	            fn(response.data, response.status, response.headers, config);
	          });
	          return promise;
	        };
	      } else {
	        promise.success = $httpMinErrLegacyFn('success');
	        promise.error = $httpMinErrLegacyFn('error');
	      }
	
	      return promise;
	
	      function transformResponse(response) {
	        // make a copy since the response must be cacheable
	        var resp = extend({}, response);
	        resp.data = transformData(response.data, response.headers, response.status,
	                                  config.transformResponse);
	        return (isSuccess(response.status))
	          ? resp
	          : $q.reject(resp);
	      }
	
	      function executeHeaderFns(headers, config) {
	        var headerContent, processedHeaders = {};
	
	        forEach(headers, function(headerFn, header) {
	          if (isFunction(headerFn)) {
	            headerContent = headerFn(config);
	            if (headerContent != null) {
	              processedHeaders[header] = headerContent;
	            }
	          } else {
	            processedHeaders[header] = headerFn;
	          }
	        });
	
	        return processedHeaders;
	      }
	
	      function mergeHeaders(config) {
	        var defHeaders = defaults.headers,
	            reqHeaders = extend({}, config.headers),
	            defHeaderName, lowercaseDefHeaderName, reqHeaderName;
	
	        defHeaders = extend({}, defHeaders.common, defHeaders[lowercase(config.method)]);
	
	        // using for-in instead of forEach to avoid unnecessary iteration after header has been found
	        defaultHeadersIteration:
	        for (defHeaderName in defHeaders) {
	          lowercaseDefHeaderName = lowercase(defHeaderName);
	
	          for (reqHeaderName in reqHeaders) {
	            if (lowercase(reqHeaderName) === lowercaseDefHeaderName) {
	              continue defaultHeadersIteration;
	            }
	          }
	
	          reqHeaders[defHeaderName] = defHeaders[defHeaderName];
	        }
	
	        // execute if header value is a function for merged headers
	        return executeHeaderFns(reqHeaders, shallowCopy(config));
	      }
	    }
	
	    $http.pendingRequests = [];
	
	    /**
	     * @ngdoc method
	     * @name $http#get
	     *
	     * @description
	     * Shortcut method to perform `GET` request.
	     *
	     * @param {string} url Relative or absolute URL specifying the destination of the request
	     * @param {Object=} config Optional configuration object
	     * @returns {HttpPromise} Future object
	     */
	
	    /**
	     * @ngdoc method
	     * @name $http#delete
	     *
	     * @description
	     * Shortcut method to perform `DELETE` request.
	     *
	     * @param {string} url Relative or absolute URL specifying the destination of the request
	     * @param {Object=} config Optional configuration object
	     * @returns {HttpPromise} Future object
	     */
	
	    /**
	     * @ngdoc method
	     * @name $http#head
	     *
	     * @description
	     * Shortcut method to perform `HEAD` request.
	     *
	     * @param {string} url Relative or absolute URL specifying the destination of the request
	     * @param {Object=} config Optional configuration object
	     * @returns {HttpPromise} Future object
	     */
	
	    /**
	     * @ngdoc method
	     * @name $http#jsonp
	     *
	     * @description
	     * Shortcut method to perform `JSONP` request.
	     *
	     * @param {string} url Relative or absolute URL specifying the destination of the request.
	     *                     The name of the callback should be the string `JSON_CALLBACK`.
	     * @param {Object=} config Optional configuration object
	     * @returns {HttpPromise} Future object
	     */
	    createShortMethods('get', 'delete', 'head', 'jsonp');
	
	    /**
	     * @ngdoc method
	     * @name $http#post
	     *
	     * @description
	     * Shortcut method to perform `POST` request.
	     *
	     * @param {string} url Relative or absolute URL specifying the destination of the request
	     * @param {*} data Request content
	     * @param {Object=} config Optional configuration object
	     * @returns {HttpPromise} Future object
	     */
	
	    /**
	     * @ngdoc method
	     * @name $http#put
	     *
	     * @description
	     * Shortcut method to perform `PUT` request.
	     *
	     * @param {string} url Relative or absolute URL specifying the destination of the request
	     * @param {*} data Request content
	     * @param {Object=} config Optional configuration object
	     * @returns {HttpPromise} Future object
	     */
	
	     /**
	      * @ngdoc method
	      * @name $http#patch
	      *
	      * @description
	      * Shortcut method to perform `PATCH` request.
	      *
	      * @param {string} url Relative or absolute URL specifying the destination of the request
	      * @param {*} data Request content
	      * @param {Object=} config Optional configuration object
	      * @returns {HttpPromise} Future object
	      */
	    createShortMethodsWithData('post', 'put', 'patch');
	
	        /**
	         * @ngdoc property
	         * @name $http#defaults
	         *
	         * @description
	         * Runtime equivalent of the `$httpProvider.defaults` property. Allows configuration of
	         * default headers, withCredentials as well as request and response transformations.
	         *
	         * See "Setting HTTP Headers" and "Transforming Requests and Responses" sections above.
	         */
	    $http.defaults = defaults;
	
	
	    return $http;
	
	
	    function createShortMethods(names) {
	      forEach(arguments, function(name) {
	        $http[name] = function(url, config) {
	          return $http(extend({}, config || {}, {
	            method: name,
	            url: url
	          }));
	        };
	      });
	    }
	
	
	    function createShortMethodsWithData(name) {
	      forEach(arguments, function(name) {
	        $http[name] = function(url, data, config) {
	          return $http(extend({}, config || {}, {
	            method: name,
	            url: url,
	            data: data
	          }));
	        };
	      });
	    }
	
	
	    /**
	     * Makes the request.
	     *
	     * !!! ACCESSES CLOSURE VARS:
	     * $httpBackend, defaults, $log, $rootScope, defaultCache, $http.pendingRequests
	     */
	    function sendReq(config, reqData) {
	      var deferred = $q.defer(),
	          promise = deferred.promise,
	          cache,
	          cachedResp,
	          reqHeaders = config.headers,
	          url = buildUrl(config.url, config.paramSerializer(config.params));
	
	      $http.pendingRequests.push(config);
	      promise.then(removePendingReq, removePendingReq);
	
	
	      if ((config.cache || defaults.cache) && config.cache !== false &&
	          (config.method === 'GET' || config.method === 'JSONP')) {
	        cache = isObject(config.cache) ? config.cache
	              : isObject(defaults.cache) ? defaults.cache
	              : defaultCache;
	      }
	
	      if (cache) {
	        cachedResp = cache.get(url);
	        if (isDefined(cachedResp)) {
	          if (isPromiseLike(cachedResp)) {
	            // cached request has already been sent, but there is no response yet
	            cachedResp.then(resolvePromiseWithResult, resolvePromiseWithResult);
	          } else {
	            // serving from cache
	            if (isArray(cachedResp)) {
	              resolvePromise(cachedResp[1], cachedResp[0], shallowCopy(cachedResp[2]), cachedResp[3]);
	            } else {
	              resolvePromise(cachedResp, 200, {}, 'OK');
	            }
	          }
	        } else {
	          // put the promise for the non-transformed response into cache as a placeholder
	          cache.put(url, promise);
	        }
	      }
	
	
	      // if we won't have the response in cache, set the xsrf headers and
	      // send the request to the backend
	      if (isUndefined(cachedResp)) {
	        var xsrfValue = urlIsSameOrigin(config.url)
	            ? $$cookieReader()[config.xsrfCookieName || defaults.xsrfCookieName]
	            : undefined;
	        if (xsrfValue) {
	          reqHeaders[(config.xsrfHeaderName || defaults.xsrfHeaderName)] = xsrfValue;
	        }
	
	        $httpBackend(config.method, url, reqData, done, reqHeaders, config.timeout,
	            config.withCredentials, config.responseType,
	            createApplyHandlers(config.eventHandlers),
	            createApplyHandlers(config.uploadEventHandlers));
	      }
	
	      return promise;
	
	      function createApplyHandlers(eventHandlers) {
	        if (eventHandlers) {
	          var applyHandlers = {};
	          forEach(eventHandlers, function(eventHandler, key) {
	            applyHandlers[key] = function(event) {
	              if (useApplyAsync) {
	                $rootScope.$applyAsync(callEventHandler);
	              } else if ($rootScope.$$phase) {
	                callEventHandler();
	              } else {
	                $rootScope.$apply(callEventHandler);
	              }
	
	              function callEventHandler() {
	                eventHandler(event);
	              }
	            };
	          });
	          return applyHandlers;
	        }
	      }
	
	
	      /**
	       * Callback registered to $httpBackend():
	       *  - caches the response if desired
	       *  - resolves the raw $http promise
	       *  - calls $apply
	       */
	      function done(status, response, headersString, statusText) {
	        if (cache) {
	          if (isSuccess(status)) {
	            cache.put(url, [status, response, parseHeaders(headersString), statusText]);
	          } else {
	            // remove promise from the cache
	            cache.remove(url);
	          }
	        }
	
	        function resolveHttpPromise() {
	          resolvePromise(response, status, headersString, statusText);
	        }
	
	        if (useApplyAsync) {
	          $rootScope.$applyAsync(resolveHttpPromise);
	        } else {
	          resolveHttpPromise();
	          if (!$rootScope.$$phase) $rootScope.$apply();
	        }
	      }
	
	
	      /**
	       * Resolves the raw $http promise.
	       */
	      function resolvePromise(response, status, headers, statusText) {
	        //status: HTTP response status code, 0, -1 (aborted by timeout / promise)
	        status = status >= -1 ? status : 0;
	
	        (isSuccess(status) ? deferred.resolve : deferred.reject)({
	          data: response,
	          status: status,
	          headers: headersGetter(headers),
	          config: config,
	          statusText: statusText
	        });
	      }
	
	      function resolvePromiseWithResult(result) {
	        resolvePromise(result.data, result.status, shallowCopy(result.headers()), result.statusText);
	      }
	
	      function removePendingReq() {
	        var idx = $http.pendingRequests.indexOf(config);
	        if (idx !== -1) $http.pendingRequests.splice(idx, 1);
	      }
	    }
	
	
	    function buildUrl(url, serializedParams) {
	      if (serializedParams.length > 0) {
	        url += ((url.indexOf('?') == -1) ? '?' : '&') + serializedParams;
	      }
	      return url;
	    }
	  }];
	}
	
	/**
	 * @ngdoc service
	 * @name $xhrFactory
	 *
	 * @description
	 * Factory function used to create XMLHttpRequest objects.
	 *
	 * Replace or decorate this service to create your own custom XMLHttpRequest objects.
	 *
	 * ```
	 * angular.module('myApp', [])
	 * .factory('$xhrFactory', function() {
	 *   return function createXhr(method, url) {
	 *     return new window.XMLHttpRequest({mozSystem: true});
	 *   };
	 * });
	 * ```
	 *
	 * @param {string} method HTTP method of the request (GET, POST, PUT, ..)
	 * @param {string} url URL of the request.
	 */
	function $xhrFactoryProvider() {
	  this.$get = function() {
	    return function createXhr() {
	      return new window.XMLHttpRequest();
	    };
	  };
	}
	
	/**
	 * @ngdoc service
	 * @name $httpBackend
	 * @requires $window
	 * @requires $document
	 * @requires $xhrFactory
	 *
	 * @description
	 * HTTP backend used by the {@link ng.$http service} that delegates to
	 * XMLHttpRequest object or JSONP and deals with browser incompatibilities.
	 *
	 * You should never need to use this service directly, instead use the higher-level abstractions:
	 * {@link ng.$http $http} or {@link ngResource.$resource $resource}.
	 *
	 * During testing this implementation is swapped with {@link ngMock.$httpBackend mock
	 * $httpBackend} which can be trained with responses.
	 */
	function $HttpBackendProvider() {
	  this.$get = ['$browser', '$window', '$document', '$xhrFactory', function($browser, $window, $document, $xhrFactory) {
	    return createHttpBackend($browser, $xhrFactory, $browser.defer, $window.angular.callbacks, $document[0]);
	  }];
	}
	
	function createHttpBackend($browser, createXhr, $browserDefer, callbacks, rawDocument) {
	  // TODO(vojta): fix the signature
	  return function(method, url, post, callback, headers, timeout, withCredentials, responseType, eventHandlers, uploadEventHandlers) {
	    $browser.$$incOutstandingRequestCount();
	    url = url || $browser.url();
	
	    if (lowercase(method) == 'jsonp') {
	      var callbackId = '_' + (callbacks.counter++).toString(36);
	      callbacks[callbackId] = function(data) {
	        callbacks[callbackId].data = data;
	        callbacks[callbackId].called = true;
	      };
	
	      var jsonpDone = jsonpReq(url.replace('JSON_CALLBACK', 'angular.callbacks.' + callbackId),
	          callbackId, function(status, text) {
	        completeRequest(callback, status, callbacks[callbackId].data, "", text);
	        callbacks[callbackId] = noop;
	      });
	    } else {
	
	      var xhr = createXhr(method, url);
	
	      xhr.open(method, url, true);
	      forEach(headers, function(value, key) {
	        if (isDefined(value)) {
	            xhr.setRequestHeader(key, value);
	        }
	      });
	
	      xhr.onload = function requestLoaded() {
	        var statusText = xhr.statusText || '';
	
	        // responseText is the old-school way of retrieving response (supported by IE9)
	        // response/responseType properties were introduced in XHR Level2 spec (supported by IE10)
	        var response = ('response' in xhr) ? xhr.response : xhr.responseText;
	
	        // normalize IE9 bug (http://bugs.jquery.com/ticket/1450)
	        var status = xhr.status === 1223 ? 204 : xhr.status;
	
	        // fix status code when it is 0 (0 status is undocumented).
	        // Occurs when accessing file resources or on Android 4.1 stock browser
	        // while retrieving files from application cache.
	        if (status === 0) {
	          status = response ? 200 : urlResolve(url).protocol == 'file' ? 404 : 0;
	        }
	
	        completeRequest(callback,
	            status,
	            response,
	            xhr.getAllResponseHeaders(),
	            statusText);
	      };
	
	      var requestError = function() {
	        // The response is always empty
	        // See https://xhr.spec.whatwg.org/#request-error-steps and https://fetch.spec.whatwg.org/#concept-network-error
	        completeRequest(callback, -1, null, null, '');
	      };
	
	      xhr.onerror = requestError;
	      xhr.onabort = requestError;
	
	      forEach(eventHandlers, function(value, key) {
	          xhr.addEventListener(key, value);
	      });
	
	      forEach(uploadEventHandlers, function(value, key) {
	        xhr.upload.addEventListener(key, value);
	      });
	
	      if (withCredentials) {
	        xhr.withCredentials = true;
	      }
	
	      if (responseType) {
	        try {
	          xhr.responseType = responseType;
	        } catch (e) {
	          // WebKit added support for the json responseType value on 09/03/2013
	          // https://bugs.webkit.org/show_bug.cgi?id=73648. Versions of Safari prior to 7 are
	          // known to throw when setting the value "json" as the response type. Other older
	          // browsers implementing the responseType
	          //
	          // The json response type can be ignored if not supported, because JSON payloads are
	          // parsed on the client-side regardless.
	          if (responseType !== 'json') {
	            throw e;
	          }
	        }
	      }
	
	      xhr.send(isUndefined(post) ? null : post);
	    }
	
	    if (timeout > 0) {
	      var timeoutId = $browserDefer(timeoutRequest, timeout);
	    } else if (isPromiseLike(timeout)) {
	      timeout.then(timeoutRequest);
	    }
	
	
	    function timeoutRequest() {
	      jsonpDone && jsonpDone();
	      xhr && xhr.abort();
	    }
	
	    function completeRequest(callback, status, response, headersString, statusText) {
	      // cancel timeout and subsequent timeout promise resolution
	      if (isDefined(timeoutId)) {
	        $browserDefer.cancel(timeoutId);
	      }
	      jsonpDone = xhr = null;
	
	      callback(status, response, headersString, statusText);
	      $browser.$$completeOutstandingRequest(noop);
	    }
	  };
	
	  function jsonpReq(url, callbackId, done) {
	    // we can't use jQuery/jqLite here because jQuery does crazy stuff with script elements, e.g.:
	    // - fetches local scripts via XHR and evals them
	    // - adds and immediately removes script elements from the document
	    var script = rawDocument.createElement('script'), callback = null;
	    script.type = "text/javascript";
	    script.src = url;
	    script.async = true;
	
	    callback = function(event) {
	      removeEventListenerFn(script, "load", callback);
	      removeEventListenerFn(script, "error", callback);
	      rawDocument.body.removeChild(script);
	      script = null;
	      var status = -1;
	      var text = "unknown";
	
	      if (event) {
	        if (event.type === "load" && !callbacks[callbackId].called) {
	          event = { type: "error" };
	        }
	        text = event.type;
	        status = event.type === "error" ? 404 : 200;
	      }
	
	      if (done) {
	        done(status, text);
	      }
	    };
	
	    addEventListenerFn(script, "load", callback);
	    addEventListenerFn(script, "error", callback);
	    rawDocument.body.appendChild(script);
	    return callback;
	  }
	}
	
	var $interpolateMinErr = angular.$interpolateMinErr = minErr('$interpolate');
	$interpolateMinErr.throwNoconcat = function(text) {
	  throw $interpolateMinErr('noconcat',
	      "Error while interpolating: {0}\nStrict Contextual Escaping disallows " +
	      "interpolations that concatenate multiple expressions when a trusted value is " +
	      "required.  See http://docs.angularjs.org/api/ng.$sce", text);
	};
	
	$interpolateMinErr.interr = function(text, err) {
	  return $interpolateMinErr('interr', "Can't interpolate: {0}\n{1}", text, err.toString());
	};
	
	/**
	 * @ngdoc provider
	 * @name $interpolateProvider
	 *
	 * @description
	 *
	 * Used for configuring the interpolation markup. Defaults to `{{` and `}}`.
	 *
	 * <div class="alert alert-danger">
	 * This feature is sometimes used to mix different markup languages, e.g. to wrap an Angular
	 * template within a Python Jinja template (or any other template language). Mixing templating
	 * languages is **very dangerous**. The embedding template language will not safely escape Angular
	 * expressions, so any user-controlled values in the template will cause Cross Site Scripting (XSS)
	 * security bugs!
	 * </div>
	 *
	 * @example
	<example name="custom-interpolation-markup" module="customInterpolationApp">
	<file name="index.html">
	<script>
	  var customInterpolationApp = angular.module('customInterpolationApp', []);
	
	  customInterpolationApp.config(function($interpolateProvider) {
	    $interpolateProvider.startSymbol('//');
	    $interpolateProvider.endSymbol('//');
	  });
	
	
	  customInterpolationApp.controller('DemoController', function() {
	      this.label = "This binding is brought you by // interpolation symbols.";
	  });
	</script>
	<div ng-controller="DemoController as demo">
	    //demo.label//
	</div>
	</file>
	<file name="protractor.js" type="protractor">
	  it('should interpolate binding with custom symbols', function() {
	    expect(element(by.binding('demo.label')).getText()).toBe('This binding is brought you by // interpolation symbols.');
	  });
	</file>
	</example>
	 */
	function $InterpolateProvider() {
	  var startSymbol = '{{';
	  var endSymbol = '}}';
	
	  /**
	   * @ngdoc method
	   * @name $interpolateProvider#startSymbol
	   * @description
	   * Symbol to denote start of expression in the interpolated string. Defaults to `{{`.
	   *
	   * @param {string=} value new value to set the starting symbol to.
	   * @returns {string|self} Returns the symbol when used as getter and self if used as setter.
	   */
	  this.startSymbol = function(value) {
	    if (value) {
	      startSymbol = value;
	      return this;
	    } else {
	      return startSymbol;
	    }
	  };
	
	  /**
	   * @ngdoc method
	   * @name $interpolateProvider#endSymbol
	   * @description
	   * Symbol to denote the end of expression in the interpolated string. Defaults to `}}`.
	   *
	   * @param {string=} value new value to set the ending symbol to.
	   * @returns {string|self} Returns the symbol when used as getter and self if used as setter.
	   */
	  this.endSymbol = function(value) {
	    if (value) {
	      endSymbol = value;
	      return this;
	    } else {
	      return endSymbol;
	    }
	  };
	
	
	  this.$get = ['$parse', '$exceptionHandler', '$sce', function($parse, $exceptionHandler, $sce) {
	    var startSymbolLength = startSymbol.length,
	        endSymbolLength = endSymbol.length,
	        escapedStartRegexp = new RegExp(startSymbol.replace(/./g, escape), 'g'),
	        escapedEndRegexp = new RegExp(endSymbol.replace(/./g, escape), 'g');
	
	    function escape(ch) {
	      return '\\\\\\' + ch;
	    }
	
	    function unescapeText(text) {
	      return text.replace(escapedStartRegexp, startSymbol).
	        replace(escapedEndRegexp, endSymbol);
	    }
	
	    function stringify(value) {
	      if (value == null) { // null || undefined
	        return '';
	      }
	      switch (typeof value) {
	        case 'string':
	          break;
	        case 'number':
	          value = '' + value;
	          break;
	        default:
	          value = toJson(value);
	      }
	
	      return value;
	    }
	
	    //TODO: this is the same as the constantWatchDelegate in parse.js
	    function constantWatchDelegate(scope, listener, objectEquality, constantInterp) {
	      var unwatch;
	      return unwatch = scope.$watch(function constantInterpolateWatch(scope) {
	        unwatch();
	        return constantInterp(scope);
	      }, listener, objectEquality);
	    }
	
	    /**
	     * @ngdoc service
	     * @name $interpolate
	     * @kind function
	     *
	     * @requires $parse
	     * @requires $sce
	     *
	     * @description
	     *
	     * Compiles a string with markup into an interpolation function. This service is used by the
	     * HTML {@link ng.$compile $compile} service for data binding. See
	     * {@link ng.$interpolateProvider $interpolateProvider} for configuring the
	     * interpolation markup.
	     *
	     *
	     * ```js
	     *   var $interpolate = ...; // injected
	     *   var exp = $interpolate('Hello {{name | uppercase}}!');
	     *   expect(exp({name:'Angular'})).toEqual('Hello ANGULAR!');
	     * ```
	     *
	     * `$interpolate` takes an optional fourth argument, `allOrNothing`. If `allOrNothing` is
	     * `true`, the interpolation function will return `undefined` unless all embedded expressions
	     * evaluate to a value other than `undefined`.
	     *
	     * ```js
	     *   var $interpolate = ...; // injected
	     *   var context = {greeting: 'Hello', name: undefined };
	     *
	     *   // default "forgiving" mode
	     *   var exp = $interpolate('{{greeting}} {{name}}!');
	     *   expect(exp(context)).toEqual('Hello !');
	     *
	     *   // "allOrNothing" mode
	     *   exp = $interpolate('{{greeting}} {{name}}!', false, null, true);
	     *   expect(exp(context)).toBeUndefined();
	     *   context.name = 'Angular';
	     *   expect(exp(context)).toEqual('Hello Angular!');
	     * ```
	     *
	     * `allOrNothing` is useful for interpolating URLs. `ngSrc` and `ngSrcset` use this behavior.
	     *
	     * ####Escaped Interpolation
	     * $interpolate provides a mechanism for escaping interpolation markers. Start and end markers
	     * can be escaped by preceding each of their characters with a REVERSE SOLIDUS U+005C (backslash).
	     * It will be rendered as a regular start/end marker, and will not be interpreted as an expression
	     * or binding.
	     *
	     * This enables web-servers to prevent script injection attacks and defacing attacks, to some
	     * degree, while also enabling code examples to work without relying on the
	     * {@link ng.directive:ngNonBindable ngNonBindable} directive.
	     *
	     * **For security purposes, it is strongly encouraged that web servers escape user-supplied data,
	     * replacing angle brackets (&lt;, &gt;) with &amp;lt; and &amp;gt; respectively, and replacing all
	     * interpolation start/end markers with their escaped counterparts.**
	     *
	     * Escaped interpolation markers are only replaced with the actual interpolation markers in rendered
	     * output when the $interpolate service processes the text. So, for HTML elements interpolated
	     * by {@link ng.$compile $compile}, or otherwise interpolated with the `mustHaveExpression` parameter
	     * set to `true`, the interpolated text must contain an unescaped interpolation expression. As such,
	     * this is typically useful only when user-data is used in rendering a template from the server, or
	     * when otherwise untrusted data is used by a directive.
	     *
	     * <example>
	     *  <file name="index.html">
	     *    <div ng-init="username='A user'">
	     *      <p ng-init="apptitle='Escaping demo'">{{apptitle}}: \{\{ username = "defaced value"; \}\}
	     *        </p>
	     *      <p><strong>{{username}}</strong> attempts to inject code which will deface the
	     *        application, but fails to accomplish their task, because the server has correctly
	     *        escaped the interpolation start/end markers with REVERSE SOLIDUS U+005C (backslash)
	     *        characters.</p>
	     *      <p>Instead, the result of the attempted script injection is visible, and can be removed
	     *        from the database by an administrator.</p>
	     *    </div>
	     *  </file>
	     * </example>
	     *
	     * @knownIssue
	     * It is currently not possible for an interpolated expression to contain the interpolation end
	     * symbol. For example, `{{ '}}' }}` will be incorrectly interpreted as `{{ ' }}` + `' }}`, i.e.
	     * an interpolated expression consisting of a single-quote (`'`) and the `' }}` string.
	     *
	     * @knownIssue
	     * All directives and components must use the standard `{{` `}}` interpolation symbols
	     * in their templates. If you change the application interpolation symbols the {@link $compile}
	     * service will attempt to denormalize the standard symbols to the custom symbols.
	     * The denormalization process is not clever enough to know not to replace instances of the standard
	     * symbols where they would not normally be treated as interpolation symbols. For example in the following
	     * code snippet the closing braces of the literal object will get incorrectly denormalized:
	     *
	     * ```
	     * <div data-context='{"context":{"id":3,"type":"page"}}">
	     * ```
	     *
	     * The workaround is to ensure that such instances are separated by whitespace:
	     * ```
	     * <div data-context='{"context":{"id":3,"type":"page"} }">
	     * ```
	     *
	     * See https://github.com/angular/angular.js/pull/14610#issuecomment-219401099 for more information.
	     *
	     * @param {string} text The text with markup to interpolate.
	     * @param {boolean=} mustHaveExpression if set to true then the interpolation string must have
	     *    embedded expression in order to return an interpolation function. Strings with no
	     *    embedded expression will return null for the interpolation function.
	     * @param {string=} trustedContext when provided, the returned function passes the interpolated
	     *    result through {@link ng.$sce#getTrusted $sce.getTrusted(interpolatedResult,
	     *    trustedContext)} before returning it.  Refer to the {@link ng.$sce $sce} service that
	     *    provides Strict Contextual Escaping for details.
	     * @param {boolean=} allOrNothing if `true`, then the returned function returns undefined
	     *    unless all embedded expressions evaluate to a value other than `undefined`.
	     * @returns {function(context)} an interpolation function which is used to compute the
	     *    interpolated string. The function has these parameters:
	     *
	     * - `context`: evaluation context for all expressions embedded in the interpolated text
	     */
	    function $interpolate(text, mustHaveExpression, trustedContext, allOrNothing) {
	      // Provide a quick exit and simplified result function for text with no interpolation
	      if (!text.length || text.indexOf(startSymbol) === -1) {
	        var constantInterp;
	        if (!mustHaveExpression) {
	          var unescapedText = unescapeText(text);
	          constantInterp = valueFn(unescapedText);
	          constantInterp.exp = text;
	          constantInterp.expressions = [];
	          constantInterp.$$watchDelegate = constantWatchDelegate;
	        }
	        return constantInterp;
	      }
	
	      allOrNothing = !!allOrNothing;
	      var startIndex,
	          endIndex,
	          index = 0,
	          expressions = [],
	          parseFns = [],
	          textLength = text.length,
	          exp,
	          concat = [],
	          expressionPositions = [];
	
	      while (index < textLength) {
	        if (((startIndex = text.indexOf(startSymbol, index)) != -1) &&
	             ((endIndex = text.indexOf(endSymbol, startIndex + startSymbolLength)) != -1)) {
	          if (index !== startIndex) {
	            concat.push(unescapeText(text.substring(index, startIndex)));
	          }
	          exp = text.substring(startIndex + startSymbolLength, endIndex);
	          expressions.push(exp);
	          parseFns.push($parse(exp, parseStringifyInterceptor));
	          index = endIndex + endSymbolLength;
	          expressionPositions.push(concat.length);
	          concat.push('');
	        } else {
	          // we did not find an interpolation, so we have to add the remainder to the separators array
	          if (index !== textLength) {
	            concat.push(unescapeText(text.substring(index)));
	          }
	          break;
	        }
	      }
	
	      // Concatenating expressions makes it hard to reason about whether some combination of
	      // concatenated values are unsafe to use and could easily lead to XSS.  By requiring that a
	      // single expression be used for iframe[src], object[src], etc., we ensure that the value
	      // that's used is assigned or constructed by some JS code somewhere that is more testable or
	      // make it obvious that you bound the value to some user controlled value.  This helps reduce
	      // the load when auditing for XSS issues.
	      if (trustedContext && concat.length > 1) {
	          $interpolateMinErr.throwNoconcat(text);
	      }
	
	      if (!mustHaveExpression || expressions.length) {
	        var compute = function(values) {
	          for (var i = 0, ii = expressions.length; i < ii; i++) {
	            if (allOrNothing && isUndefined(values[i])) return;
	            concat[expressionPositions[i]] = values[i];
	          }
	          return concat.join('');
	        };
	
	        var getValue = function(value) {
	          return trustedContext ?
	            $sce.getTrusted(trustedContext, value) :
	            $sce.valueOf(value);
	        };
	
	        return extend(function interpolationFn(context) {
	            var i = 0;
	            var ii = expressions.length;
	            var values = new Array(ii);
	
	            try {
	              for (; i < ii; i++) {
	                values[i] = parseFns[i](context);
	              }
	
	              return compute(values);
	            } catch (err) {
	              $exceptionHandler($interpolateMinErr.interr(text, err));
	            }
	
	          }, {
	          // all of these properties are undocumented for now
	          exp: text, //just for compatibility with regular watchers created via $watch
	          expressions: expressions,
	          $$watchDelegate: function(scope, listener) {
	            var lastValue;
	            return scope.$watchGroup(parseFns, function interpolateFnWatcher(values, oldValues) {
	              var currValue = compute(values);
	              if (isFunction(listener)) {
	                listener.call(this, currValue, values !== oldValues ? lastValue : currValue, scope);
	              }
	              lastValue = currValue;
	            });
	          }
	        });
	      }
	
	      function parseStringifyInterceptor(value) {
	        try {
	          value = getValue(value);
	          return allOrNothing && !isDefined(value) ? value : stringify(value);
	        } catch (err) {
	          $exceptionHandler($interpolateMinErr.interr(text, err));
	        }
	      }
	    }
	
	
	    /**
	     * @ngdoc method
	     * @name $interpolate#startSymbol
	     * @description
	     * Symbol to denote the start of expression in the interpolated string. Defaults to `{{`.
	     *
	     * Use {@link ng.$interpolateProvider#startSymbol `$interpolateProvider.startSymbol`} to change
	     * the symbol.
	     *
	     * @returns {string} start symbol.
	     */
	    $interpolate.startSymbol = function() {
	      return startSymbol;
	    };
	
	
	    /**
	     * @ngdoc method
	     * @name $interpolate#endSymbol
	     * @description
	     * Symbol to denote the end of expression in the interpolated string. Defaults to `}}`.
	     *
	     * Use {@link ng.$interpolateProvider#endSymbol `$interpolateProvider.endSymbol`} to change
	     * the symbol.
	     *
	     * @returns {string} end symbol.
	     */
	    $interpolate.endSymbol = function() {
	      return endSymbol;
	    };
	
	    return $interpolate;
	  }];
	}
	
	function $IntervalProvider() {
	  this.$get = ['$rootScope', '$window', '$q', '$$q', '$browser',
	       function($rootScope,   $window,   $q,   $$q,   $browser) {
	    var intervals = {};
	
	
	     /**
	      * @ngdoc service
	      * @name $interval
	      *
	      * @description
	      * Angular's wrapper for `window.setInterval`. The `fn` function is executed every `delay`
	      * milliseconds.
	      *
	      * The return value of registering an interval function is a promise. This promise will be
	      * notified upon each tick of the interval, and will be resolved after `count` iterations, or
	      * run indefinitely if `count` is not defined. The value of the notification will be the
	      * number of iterations that have run.
	      * To cancel an interval, call `$interval.cancel(promise)`.
	      *
	      * In tests you can use {@link ngMock.$interval#flush `$interval.flush(millis)`} to
	      * move forward by `millis` milliseconds and trigger any functions scheduled to run in that
	      * time.
	      *
	      * <div class="alert alert-warning">
	      * **Note**: Intervals created by this service must be explicitly destroyed when you are finished
	      * with them.  In particular they are not automatically destroyed when a controller's scope or a
	      * directive's element are destroyed.
	      * You should take this into consideration and make sure to always cancel the interval at the
	      * appropriate moment.  See the example below for more details on how and when to do this.
	      * </div>
	      *
	      * @param {function()} fn A function that should be called repeatedly.
	      * @param {number} delay Number of milliseconds between each function call.
	      * @param {number=} [count=0] Number of times to repeat. If not set, or 0, will repeat
	      *   indefinitely.
	      * @param {boolean=} [invokeApply=true] If set to `false` skips model dirty checking, otherwise
	      *   will invoke `fn` within the {@link ng.$rootScope.Scope#$apply $apply} block.
	      * @param {...*=} Pass additional parameters to the executed function.
	      * @returns {promise} A promise which will be notified on each iteration.
	      *
	      * @example
	      * <example module="intervalExample">
	      * <file name="index.html">
	      *   <script>
	      *     angular.module('intervalExample', [])
	      *       .controller('ExampleController', ['$scope', '$interval',
	      *         function($scope, $interval) {
	      *           $scope.format = 'M/d/yy h:mm:ss a';
	      *           $scope.blood_1 = 100;
	      *           $scope.blood_2 = 120;
	      *
	      *           var stop;
	      *           $scope.fight = function() {
	      *             // Don't start a new fight if we are already fighting
	      *             if ( angular.isDefined(stop) ) return;
	      *
	      *             stop = $interval(function() {
	      *               if ($scope.blood_1 > 0 && $scope.blood_2 > 0) {
	      *                 $scope.blood_1 = $scope.blood_1 - 3;
	      *                 $scope.blood_2 = $scope.blood_2 - 4;
	      *               } else {
	      *                 $scope.stopFight();
	      *               }
	      *             }, 100);
	      *           };
	      *
	      *           $scope.stopFight = function() {
	      *             if (angular.isDefined(stop)) {
	      *               $interval.cancel(stop);
	      *               stop = undefined;
	      *             }
	      *           };
	      *
	      *           $scope.resetFight = function() {
	      *             $scope.blood_1 = 100;
	      *             $scope.blood_2 = 120;
	      *           };
	      *
	      *           $scope.$on('$destroy', function() {
	      *             // Make sure that the interval is destroyed too
	      *             $scope.stopFight();
	      *           });
	      *         }])
	      *       // Register the 'myCurrentTime' directive factory method.
	      *       // We inject $interval and dateFilter service since the factory method is DI.
	      *       .directive('myCurrentTime', ['$interval', 'dateFilter',
	      *         function($interval, dateFilter) {
	      *           // return the directive link function. (compile function not needed)
	      *           return function(scope, element, attrs) {
	      *             var format,  // date format
	      *                 stopTime; // so that we can cancel the time updates
	      *
	      *             // used to update the UI
	      *             function updateTime() {
	      *               element.text(dateFilter(new Date(), format));
	      *             }
	      *
	      *             // watch the expression, and update the UI on change.
	      *             scope.$watch(attrs.myCurrentTime, function(value) {
	      *               format = value;
	      *               updateTime();
	      *             });
	      *
	      *             stopTime = $interval(updateTime, 1000);
	      *
	      *             // listen on DOM destroy (removal) event, and cancel the next UI update
	      *             // to prevent updating time after the DOM element was removed.
	      *             element.on('$destroy', function() {
	      *               $interval.cancel(stopTime);
	      *             });
	      *           }
	      *         }]);
	      *   </script>
	      *
	      *   <div>
	      *     <div ng-controller="ExampleController">
	      *       <label>Date format: <input ng-model="format"></label> <hr/>
	      *       Current time is: <span my-current-time="format"></span>
	      *       <hr/>
	      *       Blood 1 : <font color='red'>{{blood_1}}</font>
	      *       Blood 2 : <font color='red'>{{blood_2}}</font>
	      *       <button type="button" data-ng-click="fight()">Fight</button>
	      *       <button type="button" data-ng-click="stopFight()">StopFight</button>
	      *       <button type="button" data-ng-click="resetFight()">resetFight</button>
	      *     </div>
	      *   </div>
	      *
	      * </file>
	      * </example>
	      */
	    function interval(fn, delay, count, invokeApply) {
	      var hasParams = arguments.length > 4,
	          args = hasParams ? sliceArgs(arguments, 4) : [],
	          setInterval = $window.setInterval,
	          clearInterval = $window.clearInterval,
	          iteration = 0,
	          skipApply = (isDefined(invokeApply) && !invokeApply),
	          deferred = (skipApply ? $$q : $q).defer(),
	          promise = deferred.promise;
	
	      count = isDefined(count) ? count : 0;
	
	      promise.$$intervalId = setInterval(function tick() {
	        if (skipApply) {
	          $browser.defer(callback);
	        } else {
	          $rootScope.$evalAsync(callback);
	        }
	        deferred.notify(iteration++);
	
	        if (count > 0 && iteration >= count) {
	          deferred.resolve(iteration);
	          clearInterval(promise.$$intervalId);
	          delete intervals[promise.$$intervalId];
	        }
	
	        if (!skipApply) $rootScope.$apply();
	
	      }, delay);
	
	      intervals[promise.$$intervalId] = deferred;
	
	      return promise;
	
	      function callback() {
	        if (!hasParams) {
	          fn(iteration);
	        } else {
	          fn.apply(null, args);
	        }
	      }
	    }
	
	
	     /**
	      * @ngdoc method
	      * @name $interval#cancel
	      *
	      * @description
	      * Cancels a task associated with the `promise`.
	      *
	      * @param {Promise=} promise returned by the `$interval` function.
	      * @returns {boolean} Returns `true` if the task was successfully canceled.
	      */
	    interval.cancel = function(promise) {
	      if (promise && promise.$$intervalId in intervals) {
	        intervals[promise.$$intervalId].reject('canceled');
	        $window.clearInterval(promise.$$intervalId);
	        delete intervals[promise.$$intervalId];
	        return true;
	      }
	      return false;
	    };
	
	    return interval;
	  }];
	}
	
	/**
	 * @ngdoc service
	 * @name $locale
	 *
	 * @description
	 * $locale service provides localization rules for various Angular components. As of right now the
	 * only public api is:
	 *
	 * * `id` – `{string}` – locale id formatted as `languageId-countryId` (e.g. `en-us`)
	 */
	
	var PATH_MATCH = /^([^\?#]*)(\?([^#]*))?(#(.*))?$/,
	    DEFAULT_PORTS = {'http': 80, 'https': 443, 'ftp': 21};
	var $locationMinErr = minErr('$location');
	
	
	/**
	 * Encode path using encodeUriSegment, ignoring forward slashes
	 *
	 * @param {string} path Path to encode
	 * @returns {string}
	 */
	function encodePath(path) {
	  var segments = path.split('/'),
	      i = segments.length;
	
	  while (i--) {
	    segments[i] = encodeUriSegment(segments[i]);
	  }
	
	  return segments.join('/');
	}
	
	function parseAbsoluteUrl(absoluteUrl, locationObj) {
	  var parsedUrl = urlResolve(absoluteUrl);
	
	  locationObj.$$protocol = parsedUrl.protocol;
	  locationObj.$$host = parsedUrl.hostname;
	  locationObj.$$port = toInt(parsedUrl.port) || DEFAULT_PORTS[parsedUrl.protocol] || null;
	}
	
	
	function parseAppUrl(relativeUrl, locationObj) {
	  var prefixed = (relativeUrl.charAt(0) !== '/');
	  if (prefixed) {
	    relativeUrl = '/' + relativeUrl;
	  }
	  var match = urlResolve(relativeUrl);
	  locationObj.$$path = decodeURIComponent(prefixed && match.pathname.charAt(0) === '/' ?
	      match.pathname.substring(1) : match.pathname);
	  locationObj.$$search = parseKeyValue(match.search);
	  locationObj.$$hash = decodeURIComponent(match.hash);
	
	  // make sure path starts with '/';
	  if (locationObj.$$path && locationObj.$$path.charAt(0) != '/') {
	    locationObj.$$path = '/' + locationObj.$$path;
	  }
	}
	
	function startsWith(haystack, needle) {
	  return haystack.lastIndexOf(needle, 0) === 0;
	}
	
	/**
	 *
	 * @param {string} base
	 * @param {string} url
	 * @returns {string} returns text from `url` after `base` or `undefined` if it does not begin with
	 *                   the expected string.
	 */
	function stripBaseUrl(base, url) {
	  if (startsWith(url, base)) {
	    return url.substr(base.length);
	  }
	}
	
	
	function stripHash(url) {
	  var index = url.indexOf('#');
	  return index == -1 ? url : url.substr(0, index);
	}
	
	function trimEmptyHash(url) {
	  return url.replace(/(#.+)|#$/, '$1');
	}
	
	
	function stripFile(url) {
	  return url.substr(0, stripHash(url).lastIndexOf('/') + 1);
	}
	
	/* return the server only (scheme://host:port) */
	function serverBase(url) {
	  return url.substring(0, url.indexOf('/', url.indexOf('//') + 2));
	}
	
	
	/**
	 * LocationHtml5Url represents an url
	 * This object is exposed as $location service when HTML5 mode is enabled and supported
	 *
	 * @constructor
	 * @param {string} appBase application base URL
	 * @param {string} appBaseNoFile application base URL stripped of any filename
	 * @param {string} basePrefix url path prefix
	 */
	function LocationHtml5Url(appBase, appBaseNoFile, basePrefix) {
	  this.$$html5 = true;
	  basePrefix = basePrefix || '';
	  parseAbsoluteUrl(appBase, this);
	
	
	  /**
	   * Parse given html5 (regular) url string into properties
	   * @param {string} url HTML5 url
	   * @private
	   */
	  this.$$parse = function(url) {
	    var pathUrl = stripBaseUrl(appBaseNoFile, url);
	    if (!isString(pathUrl)) {
	      throw $locationMinErr('ipthprfx', 'Invalid url "{0}", missing path prefix "{1}".', url,
	          appBaseNoFile);
	    }
	
	    parseAppUrl(pathUrl, this);
	
	    if (!this.$$path) {
	      this.$$path = '/';
	    }
	
	    this.$$compose();
	  };
	
	  /**
	   * Compose url and update `absUrl` property
	   * @private
	   */
	  this.$$compose = function() {
	    var search = toKeyValue(this.$$search),
	        hash = this.$$hash ? '#' + encodeUriSegment(this.$$hash) : '';
	
	    this.$$url = encodePath(this.$$path) + (search ? '?' + search : '') + hash;
	    this.$$absUrl = appBaseNoFile + this.$$url.substr(1); // first char is always '/'
	  };
	
	  this.$$parseLinkUrl = function(url, relHref) {
	    if (relHref && relHref[0] === '#') {
	      // special case for links to hash fragments:
	      // keep the old url and only replace the hash fragment
	      this.hash(relHref.slice(1));
	      return true;
	    }
	    var appUrl, prevAppUrl;
	    var rewrittenUrl;
	
	    if (isDefined(appUrl = stripBaseUrl(appBase, url))) {
	      prevAppUrl = appUrl;
	      if (isDefined(appUrl = stripBaseUrl(basePrefix, appUrl))) {
	        rewrittenUrl = appBaseNoFile + (stripBaseUrl('/', appUrl) || appUrl);
	      } else {
	        rewrittenUrl = appBase + prevAppUrl;
	      }
	    } else if (isDefined(appUrl = stripBaseUrl(appBaseNoFile, url))) {
	      rewrittenUrl = appBaseNoFile + appUrl;
	    } else if (appBaseNoFile == url + '/') {
	      rewrittenUrl = appBaseNoFile;
	    }
	    if (rewrittenUrl) {
	      this.$$parse(rewrittenUrl);
	    }
	    return !!rewrittenUrl;
	  };
	}
	
	
	/**
	 * LocationHashbangUrl represents url
	 * This object is exposed as $location service when developer doesn't opt into html5 mode.
	 * It also serves as the base class for html5 mode fallback on legacy browsers.
	 *
	 * @constructor
	 * @param {string} appBase application base URL
	 * @param {string} appBaseNoFile application base URL stripped of any filename
	 * @param {string} hashPrefix hashbang prefix
	 */
	function LocationHashbangUrl(appBase, appBaseNoFile, hashPrefix) {
	
	  parseAbsoluteUrl(appBase, this);
	
	
	  /**
	   * Parse given hashbang url into properties
	   * @param {string} url Hashbang url
	   * @private
	   */
	  this.$$parse = function(url) {
	    var withoutBaseUrl = stripBaseUrl(appBase, url) || stripBaseUrl(appBaseNoFile, url);
	    var withoutHashUrl;
	
	    if (!isUndefined(withoutBaseUrl) && withoutBaseUrl.charAt(0) === '#') {
	
	      // The rest of the url starts with a hash so we have
	      // got either a hashbang path or a plain hash fragment
	      withoutHashUrl = stripBaseUrl(hashPrefix, withoutBaseUrl);
	      if (isUndefined(withoutHashUrl)) {
	        // There was no hashbang prefix so we just have a hash fragment
	        withoutHashUrl = withoutBaseUrl;
	      }
	
	    } else {
	      // There was no hashbang path nor hash fragment:
	      // If we are in HTML5 mode we use what is left as the path;
	      // Otherwise we ignore what is left
	      if (this.$$html5) {
	        withoutHashUrl = withoutBaseUrl;
	      } else {
	        withoutHashUrl = '';
	        if (isUndefined(withoutBaseUrl)) {
	          appBase = url;
	          this.replace();
	        }
	      }
	    }
	
	    parseAppUrl(withoutHashUrl, this);
	
	    this.$$path = removeWindowsDriveName(this.$$path, withoutHashUrl, appBase);
	
	    this.$$compose();
	
	    /*
	     * In Windows, on an anchor node on documents loaded from
	     * the filesystem, the browser will return a pathname
	     * prefixed with the drive name ('/C:/path') when a
	     * pathname without a drive is set:
	     *  * a.setAttribute('href', '/foo')
	     *   * a.pathname === '/C:/foo' //true
	     *
	     * Inside of Angular, we're always using pathnames that
	     * do not include drive names for routing.
	     */
	    function removeWindowsDriveName(path, url, base) {
	      /*
	      Matches paths for file protocol on windows,
	      such as /C:/foo/bar, and captures only /foo/bar.
	      */
	      var windowsFilePathExp = /^\/[A-Z]:(\/.*)/;
	
	      var firstPathSegmentMatch;
	
	      //Get the relative path from the input URL.
	      if (startsWith(url, base)) {
	        url = url.replace(base, '');
	      }
	
	      // The input URL intentionally contains a first path segment that ends with a colon.
	      if (windowsFilePathExp.exec(url)) {
	        return path;
	      }
	
	      firstPathSegmentMatch = windowsFilePathExp.exec(path);
	      return firstPathSegmentMatch ? firstPathSegmentMatch[1] : path;
	    }
	  };
	
	  /**
	   * Compose hashbang url and update `absUrl` property
	   * @private
	   */
	  this.$$compose = function() {
	    var search = toKeyValue(this.$$search),
	        hash = this.$$hash ? '#' + encodeUriSegment(this.$$hash) : '';
	
	    this.$$url = encodePath(this.$$path) + (search ? '?' + search : '') + hash;
	    this.$$absUrl = appBase + (this.$$url ? hashPrefix + this.$$url : '');
	  };
	
	  this.$$parseLinkUrl = function(url, relHref) {
	    if (stripHash(appBase) == stripHash(url)) {
	      this.$$parse(url);
	      return true;
	    }
	    return false;
	  };
	}
	
	
	/**
	 * LocationHashbangUrl represents url
	 * This object is exposed as $location service when html5 history api is enabled but the browser
	 * does not support it.
	 *
	 * @constructor
	 * @param {string} appBase application base URL
	 * @param {string} appBaseNoFile application base URL stripped of any filename
	 * @param {string} hashPrefix hashbang prefix
	 */
	function LocationHashbangInHtml5Url(appBase, appBaseNoFile, hashPrefix) {
	  this.$$html5 = true;
	  LocationHashbangUrl.apply(this, arguments);
	
	  this.$$parseLinkUrl = function(url, relHref) {
	    if (relHref && relHref[0] === '#') {
	      // special case for links to hash fragments:
	      // keep the old url and only replace the hash fragment
	      this.hash(relHref.slice(1));
	      return true;
	    }
	
	    var rewrittenUrl;
	    var appUrl;
	
	    if (appBase == stripHash(url)) {
	      rewrittenUrl = url;
	    } else if ((appUrl = stripBaseUrl(appBaseNoFile, url))) {
	      rewrittenUrl = appBase + hashPrefix + appUrl;
	    } else if (appBaseNoFile === url + '/') {
	      rewrittenUrl = appBaseNoFile;
	    }
	    if (rewrittenUrl) {
	      this.$$parse(rewrittenUrl);
	    }
	    return !!rewrittenUrl;
	  };
	
	  this.$$compose = function() {
	    var search = toKeyValue(this.$$search),
	        hash = this.$$hash ? '#' + encodeUriSegment(this.$$hash) : '';
	
	    this.$$url = encodePath(this.$$path) + (search ? '?' + search : '') + hash;
	    // include hashPrefix in $$absUrl when $$url is empty so IE9 does not reload page because of removal of '#'
	    this.$$absUrl = appBase + hashPrefix + this.$$url;
	  };
	
	}
	
	
	var locationPrototype = {
	
	  /**
	   * Are we in html5 mode?
	   * @private
	   */
	  $$html5: false,
	
	  /**
	   * Has any change been replacing?
	   * @private
	   */
	  $$replace: false,
	
	  /**
	   * @ngdoc method
	   * @name $location#absUrl
	   *
	   * @description
	   * This method is getter only.
	   *
	   * Return full url representation with all segments encoded according to rules specified in
	   * [RFC 3986](http://www.ietf.org/rfc/rfc3986.txt).
	   *
	   *
	   * ```js
	   * // given url http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var absUrl = $location.absUrl();
	   * // => "http://example.com/#/some/path?foo=bar&baz=xoxo"
	   * ```
	   *
	   * @return {string} full url
	   */
	  absUrl: locationGetter('$$absUrl'),
	
	  /**
	   * @ngdoc method
	   * @name $location#url
	   *
	   * @description
	   * This method is getter / setter.
	   *
	   * Return url (e.g. `/path?a=b#hash`) when called without any parameter.
	   *
	   * Change path, search and hash, when called with parameter and return `$location`.
	   *
	   *
	   * ```js
	   * // given url http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var url = $location.url();
	   * // => "/some/path?foo=bar&baz=xoxo"
	   * ```
	   *
	   * @param {string=} url New url without base prefix (e.g. `/path?a=b#hash`)
	   * @return {string} url
	   */
	  url: function(url) {
	    if (isUndefined(url)) {
	      return this.$$url;
	    }
	
	    var match = PATH_MATCH.exec(url);
	    if (match[1] || url === '') this.path(decodeURIComponent(match[1]));
	    if (match[2] || match[1] || url === '') this.search(match[3] || '');
	    this.hash(match[5] || '');
	
	    return this;
	  },
	
	  /**
	   * @ngdoc method
	   * @name $location#protocol
	   *
	   * @description
	   * This method is getter only.
	   *
	   * Return protocol of current url.
	   *
	   *
	   * ```js
	   * // given url http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var protocol = $location.protocol();
	   * // => "http"
	   * ```
	   *
	   * @return {string} protocol of current url
	   */
	  protocol: locationGetter('$$protocol'),
	
	  /**
	   * @ngdoc method
	   * @name $location#host
	   *
	   * @description
	   * This method is getter only.
	   *
	   * Return host of current url.
	   *
	   * Note: compared to the non-angular version `location.host` which returns `hostname:port`, this returns the `hostname` portion only.
	   *
	   *
	   * ```js
	   * // given url http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var host = $location.host();
	   * // => "example.com"
	   *
	   * // given url http://user:password@example.com:8080/#/some/path?foo=bar&baz=xoxo
	   * host = $location.host();
	   * // => "example.com"
	   * host = location.host;
	   * // => "example.com:8080"
	   * ```
	   *
	   * @return {string} host of current url.
	   */
	  host: locationGetter('$$host'),
	
	  /**
	   * @ngdoc method
	   * @name $location#port
	   *
	   * @description
	   * This method is getter only.
	   *
	   * Return port of current url.
	   *
	   *
	   * ```js
	   * // given url http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var port = $location.port();
	   * // => 80
	   * ```
	   *
	   * @return {Number} port
	   */
	  port: locationGetter('$$port'),
	
	  /**
	   * @ngdoc method
	   * @name $location#path
	   *
	   * @description
	   * This method is getter / setter.
	   *
	   * Return path of current url when called without any parameter.
	   *
	   * Change path when called with parameter and return `$location`.
	   *
	   * Note: Path should always begin with forward slash (/), this method will add the forward slash
	   * if it is missing.
	   *
	   *
	   * ```js
	   * // given url http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var path = $location.path();
	   * // => "/some/path"
	   * ```
	   *
	   * @param {(string|number)=} path New path
	   * @return {(string|object)} path if called with no parameters, or `$location` if called with a parameter
	   */
	  path: locationGetterSetter('$$path', function(path) {
	    path = path !== null ? path.toString() : '';
	    return path.charAt(0) == '/' ? path : '/' + path;
	  }),
	
	  /**
	   * @ngdoc method
	   * @name $location#search
	   *
	   * @description
	   * This method is getter / setter.
	   *
	   * Return search part (as object) of current url when called without any parameter.
	   *
	   * Change search part when called with parameter and return `$location`.
	   *
	   *
	   * ```js
	   * // given url http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var searchObject = $location.search();
	   * // => {foo: 'bar', baz: 'xoxo'}
	   *
	   * // set foo to 'yipee'
	   * $location.search('foo', 'yipee');
	   * // $location.search() => {foo: 'yipee', baz: 'xoxo'}
	   * ```
	   *
	   * @param {string|Object.<string>|Object.<Array.<string>>} search New search params - string or
	   * hash object.
	   *
	   * When called with a single argument the method acts as a setter, setting the `search` component
	   * of `$location` to the specified value.
	   *
	   * If the argument is a hash object containing an array of values, these values will be encoded
	   * as duplicate search parameters in the url.
	   *
	   * @param {(string|Number|Array<string>|boolean)=} paramValue If `search` is a string or number, then `paramValue`
	   * will override only a single search property.
	   *
	   * If `paramValue` is an array, it will override the property of the `search` component of
	   * `$location` specified via the first argument.
	   *
	   * If `paramValue` is `null`, the property specified via the first argument will be deleted.
	   *
	   * If `paramValue` is `true`, the property specified via the first argument will be added with no
	   * value nor trailing equal sign.
	   *
	   * @return {Object} If called with no arguments returns the parsed `search` object. If called with
	   * one or more arguments returns `$location` object itself.
	   */
	  search: function(search, paramValue) {
	    switch (arguments.length) {
	      case 0:
	        return this.$$search;
	      case 1:
	        if (isString(search) || isNumber(search)) {
	          search = search.toString();
	          this.$$search = parseKeyValue(search);
	        } else if (isObject(search)) {
	          search = copy(search, {});
	          // remove object undefined or null properties
	          forEach(search, function(value, key) {
	            if (value == null) delete search[key];
	          });
	
	          this.$$search = search;
	        } else {
	          throw $locationMinErr('isrcharg',
	              'The first argument of the `$location#search()` call must be a string or an object.');
	        }
	        break;
	      default:
	        if (isUndefined(paramValue) || paramValue === null) {
	          delete this.$$search[search];
	        } else {
	          this.$$search[search] = paramValue;
	        }
	    }
	
	    this.$$compose();
	    return this;
	  },
	
	  /**
	   * @ngdoc method
	   * @name $location#hash
	   *
	   * @description
	   * This method is getter / setter.
	   *
	   * Returns the hash fragment when called without any parameters.
	   *
	   * Changes the hash fragment when called with a parameter and returns `$location`.
	   *
	   *
	   * ```js
	   * // given url http://example.com/#/some/path?foo=bar&baz=xoxo#hashValue
	   * var hash = $location.hash();
	   * // => "hashValue"
	   * ```
	   *
	   * @param {(string|number)=} hash New hash fragment
	   * @return {string} hash
	   */
	  hash: locationGetterSetter('$$hash', function(hash) {
	    return hash !== null ? hash.toString() : '';
	  }),
	
	  /**
	   * @ngdoc method
	   * @name $location#replace
	   *
	   * @description
	   * If called, all changes to $location during the current `$digest` will replace the current history
	   * record, instead of adding a new one.
	   */
	  replace: function() {
	    this.$$replace = true;
	    return this;
	  }
	};
	
	forEach([LocationHashbangInHtml5Url, LocationHashbangUrl, LocationHtml5Url], function(Location) {
	  Location.prototype = Object.create(locationPrototype);
	
	  /**
	   * @ngdoc method
	   * @name $location#state
	   *
	   * @description
	   * This method is getter / setter.
	   *
	   * Return the history state object when called without any parameter.
	   *
	   * Change the history state object when called with one parameter and return `$location`.
	   * The state object is later passed to `pushState` or `replaceState`.
	   *
	   * NOTE: This method is supported only in HTML5 mode and only in browsers supporting
	   * the HTML5 History API (i.e. methods `pushState` and `replaceState`). If you need to support
	   * older browsers (like IE9 or Android < 4.0), don't use this method.
	   *
	   * @param {object=} state State object for pushState or replaceState
	   * @return {object} state
	   */
	  Location.prototype.state = function(state) {
	    if (!arguments.length) {
	      return this.$$state;
	    }
	
	    if (Location !== LocationHtml5Url || !this.$$html5) {
	      throw $locationMinErr('nostate', 'History API state support is available only ' +
	        'in HTML5 mode and only in browsers supporting HTML5 History API');
	    }
	    // The user might modify `stateObject` after invoking `$location.state(stateObject)`
	    // but we're changing the $$state reference to $browser.state() during the $digest
	    // so the modification window is narrow.
	    this.$$state = isUndefined(state) ? null : state;
	
	    return this;
	  };
	});
	
	
	function locationGetter(property) {
	  return function() {
	    return this[property];
	  };
	}
	
	
	function locationGetterSetter(property, preprocess) {
	  return function(value) {
	    if (isUndefined(value)) {
	      return this[property];
	    }
	
	    this[property] = preprocess(value);
	    this.$$compose();
	
	    return this;
	  };
	}
	
	
	/**
	 * @ngdoc service
	 * @name $location
	 *
	 * @requires $rootElement
	 *
	 * @description
	 * The $location service parses the URL in the browser address bar (based on the
	 * [window.location](https://developer.mozilla.org/en/window.location)) and makes the URL
	 * available to your application. Changes to the URL in the address bar are reflected into
	 * $location service and changes to $location are reflected into the browser address bar.
	 *
	 * **The $location service:**
	 *
	 * - Exposes the current URL in the browser address bar, so you can
	 *   - Watch and observe the URL.
	 *   - Change the URL.
	 * - Synchronizes the URL with the browser when the user
	 *   - Changes the address bar.
	 *   - Clicks the back or forward button (or clicks a History link).
	 *   - Clicks on a link.
	 * - Represents the URL object as a set of methods (protocol, host, port, path, search, hash).
	 *
	 * For more information see {@link guide/$location Developer Guide: Using $location}
	 */
	
	/**
	 * @ngdoc provider
	 * @name $locationProvider
	 * @description
	 * Use the `$locationProvider` to configure how the application deep linking paths are stored.
	 */
	function $LocationProvider() {
	  var hashPrefix = '',
	      html5Mode = {
	        enabled: false,
	        requireBase: true,
	        rewriteLinks: true
	      };
	
	  /**
	   * @ngdoc method
	   * @name $locationProvider#hashPrefix
	   * @description
	   * @param {string=} prefix Prefix for hash part (containing path and search)
	   * @returns {*} current value if used as getter or itself (chaining) if used as setter
	   */
	  this.hashPrefix = function(prefix) {
	    if (isDefined(prefix)) {
	      hashPrefix = prefix;
	      return this;
	    } else {
	      return hashPrefix;
	    }
	  };
	
	  /**
	   * @ngdoc method
	   * @name $locationProvider#html5Mode
	   * @description
	   * @param {(boolean|Object)=} mode If boolean, sets `html5Mode.enabled` to value.
	   *   If object, sets `enabled`, `requireBase` and `rewriteLinks` to respective values. Supported
	   *   properties:
	   *   - **enabled** – `{boolean}` – (default: false) If true, will rely on `history.pushState` to
	   *     change urls where supported. Will fall back to hash-prefixed paths in browsers that do not
	   *     support `pushState`.
	   *   - **requireBase** - `{boolean}` - (default: `true`) When html5Mode is enabled, specifies
	   *     whether or not a <base> tag is required to be present. If `enabled` and `requireBase` are
	   *     true, and a base tag is not present, an error will be thrown when `$location` is injected.
	   *     See the {@link guide/$location $location guide for more information}
	   *   - **rewriteLinks** - `{boolean}` - (default: `true`) When html5Mode is enabled,
	   *     enables/disables url rewriting for relative links.
	   *
	   * @returns {Object} html5Mode object if used as getter or itself (chaining) if used as setter
	   */
	  this.html5Mode = function(mode) {
	    if (isBoolean(mode)) {
	      html5Mode.enabled = mode;
	      return this;
	    } else if (isObject(mode)) {
	
	      if (isBoolean(mode.enabled)) {
	        html5Mode.enabled = mode.enabled;
	      }
	
	      if (isBoolean(mode.requireBase)) {
	        html5Mode.requireBase = mode.requireBase;
	      }
	
	      if (isBoolean(mode.rewriteLinks)) {
	        html5Mode.rewriteLinks = mode.rewriteLinks;
	      }
	
	      return this;
	    } else {
	      return html5Mode;
	    }
	  };
	
	  /**
	   * @ngdoc event
	   * @name $location#$locationChangeStart
	   * @eventType broadcast on root scope
	   * @description
	   * Broadcasted before a URL will change.
	   *
	   * This change can be prevented by calling
	   * `preventDefault` method of the event. See {@link ng.$rootScope.Scope#$on} for more
	   * details about event object. Upon successful change
	   * {@link ng.$location#$locationChangeSuccess $locationChangeSuccess} is fired.
	   *
	   * The `newState` and `oldState` parameters may be defined only in HTML5 mode and when
	   * the browser supports the HTML5 History API.
	   *
	   * @param {Object} angularEvent Synthetic event object.
	   * @param {string} newUrl New URL
	   * @param {string=} oldUrl URL that was before it was changed.
	   * @param {string=} newState New history state object
	   * @param {string=} oldState History state object that was before it was changed.
	   */
	
	  /**
	   * @ngdoc event
	   * @name $location#$locationChangeSuccess
	   * @eventType broadcast on root scope
	   * @description
	   * Broadcasted after a URL was changed.
	   *
	   * The `newState` and `oldState` parameters may be defined only in HTML5 mode and when
	   * the browser supports the HTML5 History API.
	   *
	   * @param {Object} angularEvent Synthetic event object.
	   * @param {string} newUrl New URL
	   * @param {string=} oldUrl URL that was before it was changed.
	   * @param {string=} newState New history state object
	   * @param {string=} oldState History state object that was before it was changed.
	   */
	
	  this.$get = ['$rootScope', '$browser', '$sniffer', '$rootElement', '$window',
	      function($rootScope, $browser, $sniffer, $rootElement, $window) {
	    var $location,
	        LocationMode,
	        baseHref = $browser.baseHref(), // if base[href] is undefined, it defaults to ''
	        initialUrl = $browser.url(),
	        appBase;
	
	    if (html5Mode.enabled) {
	      if (!baseHref && html5Mode.requireBase) {
	        throw $locationMinErr('nobase',
	          "$location in HTML5 mode requires a <base> tag to be present!");
	      }
	      appBase = serverBase(initialUrl) + (baseHref || '/');
	      LocationMode = $sniffer.history ? LocationHtml5Url : LocationHashbangInHtml5Url;
	    } else {
	      appBase = stripHash(initialUrl);
	      LocationMode = LocationHashbangUrl;
	    }
	    var appBaseNoFile = stripFile(appBase);
	
	    $location = new LocationMode(appBase, appBaseNoFile, '#' + hashPrefix);
	    $location.$$parseLinkUrl(initialUrl, initialUrl);
	
	    $location.$$state = $browser.state();
	
	    var IGNORE_URI_REGEXP = /^\s*(javascript|mailto):/i;
	
	    function setBrowserUrlWithFallback(url, replace, state) {
	      var oldUrl = $location.url();
	      var oldState = $location.$$state;
	      try {
	        $browser.url(url, replace, state);
	
	        // Make sure $location.state() returns referentially identical (not just deeply equal)
	        // state object; this makes possible quick checking if the state changed in the digest
	        // loop. Checking deep equality would be too expensive.
	        $location.$$state = $browser.state();
	      } catch (e) {
	        // Restore old values if pushState fails
	        $location.url(oldUrl);
	        $location.$$state = oldState;
	
	        throw e;
	      }
	    }
	
	    $rootElement.on('click', function(event) {
	      // TODO(vojta): rewrite link when opening in new tab/window (in legacy browser)
	      // currently we open nice url link and redirect then
	
	      if (!html5Mode.rewriteLinks || event.ctrlKey || event.metaKey || event.shiftKey || event.which == 2 || event.button == 2) return;
	
	      var elm = jqLite(event.target);
	
	      // traverse the DOM up to find first A tag
	      while (nodeName_(elm[0]) !== 'a') {
	        // ignore rewriting if no A tag (reached root element, or no parent - removed from document)
	        if (elm[0] === $rootElement[0] || !(elm = elm.parent())[0]) return;
	      }
	
	      var absHref = elm.prop('href');
	      // get the actual href attribute - see
	      // http://msdn.microsoft.com/en-us/library/ie/dd347148(v=vs.85).aspx
	      var relHref = elm.attr('href') || elm.attr('xlink:href');
	
	      if (isObject(absHref) && absHref.toString() === '[object SVGAnimatedString]') {
	        // SVGAnimatedString.animVal should be identical to SVGAnimatedString.baseVal, unless during
	        // an animation.
	        absHref = urlResolve(absHref.animVal).href;
	      }
	
	      // Ignore when url is started with javascript: or mailto:
	      if (IGNORE_URI_REGEXP.test(absHref)) return;
	
	      if (absHref && !elm.attr('target') && !event.isDefaultPrevented()) {
	        if ($location.$$parseLinkUrl(absHref, relHref)) {
	          // We do a preventDefault for all urls that are part of the angular application,
	          // in html5mode and also without, so that we are able to abort navigation without
	          // getting double entries in the location history.
	          event.preventDefault();
	          // update location manually
	          if ($location.absUrl() != $browser.url()) {
	            $rootScope.$apply();
	            // hack to work around FF6 bug 684208 when scenario runner clicks on links
	            $window.angular['ff-684208-preventDefault'] = true;
	          }
	        }
	      }
	    });
	
	
	    // rewrite hashbang url <> html5 url
	    if (trimEmptyHash($location.absUrl()) != trimEmptyHash(initialUrl)) {
	      $browser.url($location.absUrl(), true);
	    }
	
	    var initializing = true;
	
	    // update $location when $browser url changes
	    $browser.onUrlChange(function(newUrl, newState) {
	
	      if (isUndefined(stripBaseUrl(appBaseNoFile, newUrl))) {
	        // If we are navigating outside of the app then force a reload
	        $window.location.href = newUrl;
	        return;
	      }
	
	      $rootScope.$evalAsync(function() {
	        var oldUrl = $location.absUrl();
	        var oldState = $location.$$state;
	        var defaultPrevented;
	        newUrl = trimEmptyHash(newUrl);
	        $location.$$parse(newUrl);
	        $location.$$state = newState;
	
	        defaultPrevented = $rootScope.$broadcast('$locationChangeStart', newUrl, oldUrl,
	            newState, oldState).defaultPrevented;
	
	        // if the location was changed by a `$locationChangeStart` handler then stop
	        // processing this location change
	        if ($location.absUrl() !== newUrl) return;
	
	        if (defaultPrevented) {
	          $location.$$parse(oldUrl);
	          $location.$$state = oldState;
	          setBrowserUrlWithFallback(oldUrl, false, oldState);
	        } else {
	          initializing = false;
	          afterLocationChange(oldUrl, oldState);
	        }
	      });
	      if (!$rootScope.$$phase) $rootScope.$digest();
	    });
	
	    // update browser
	    $rootScope.$watch(function $locationWatch() {
	      var oldUrl = trimEmptyHash($browser.url());
	      var newUrl = trimEmptyHash($location.absUrl());
	      var oldState = $browser.state();
	      var currentReplace = $location.$$replace;
	      var urlOrStateChanged = oldUrl !== newUrl ||
	        ($location.$$html5 && $sniffer.history && oldState !== $location.$$state);
	
	      if (initializing || urlOrStateChanged) {
	        initializing = false;
	
	        $rootScope.$evalAsync(function() {
	          var newUrl = $location.absUrl();
	          var defaultPrevented = $rootScope.$broadcast('$locationChangeStart', newUrl, oldUrl,
	              $location.$$state, oldState).defaultPrevented;
	
	          // if the location was changed by a `$locationChangeStart` handler then stop
	          // processing this location change
	          if ($location.absUrl() !== newUrl) return;
	
	          if (defaultPrevented) {
	            $location.$$parse(oldUrl);
	            $location.$$state = oldState;
	          } else {
	            if (urlOrStateChanged) {
	              setBrowserUrlWithFallback(newUrl, currentReplace,
	                                        oldState === $location.$$state ? null : $location.$$state);
	            }
	            afterLocationChange(oldUrl, oldState);
	          }
	        });
	      }
	
	      $location.$$replace = false;
	
	      // we don't need to return anything because $evalAsync will make the digest loop dirty when
	      // there is a change
	    });
	
	    return $location;
	
	    function afterLocationChange(oldUrl, oldState) {
	      $rootScope.$broadcast('$locationChangeSuccess', $location.absUrl(), oldUrl,
	        $location.$$state, oldState);
	    }
	}];
	}
	
	/**
	 * @ngdoc service
	 * @name $log
	 * @requires $window
	 *
	 * @description
	 * Simple service for logging. Default implementation safely writes the message
	 * into the browser's console (if present).
	 *
	 * The main purpose of this service is to simplify debugging and troubleshooting.
	 *
	 * The default is to log `debug` messages. You can use
	 * {@link ng.$logProvider ng.$logProvider#debugEnabled} to change this.
	 *
	 * @example
	   <example module="logExample">
	     <file name="script.js">
	       angular.module('logExample', [])
	         .controller('LogController', ['$scope', '$log', function($scope, $log) {
	           $scope.$log = $log;
	           $scope.message = 'Hello World!';
	         }]);
	     </file>
	     <file name="index.html">
	       <div ng-controller="LogController">
	         <p>Reload this page with open console, enter text and hit the log button...</p>
	         <label>Message:
	         <input type="text" ng-model="message" /></label>
	         <button ng-click="$log.log(message)">log</button>
	         <button ng-click="$log.warn(message)">warn</button>
	         <button ng-click="$log.info(message)">info</button>
	         <button ng-click="$log.error(message)">error</button>
	         <button ng-click="$log.debug(message)">debug</button>
	       </div>
	     </file>
	   </example>
	 */
	
	/**
	 * @ngdoc provider
	 * @name $logProvider
	 * @description
	 * Use the `$logProvider` to configure how the application logs messages
	 */
	function $LogProvider() {
	  var debug = true,
	      self = this;
	
	  /**
	   * @ngdoc method
	   * @name $logProvider#debugEnabled
	   * @description
	   * @param {boolean=} flag enable or disable debug level messages
	   * @returns {*} current value if used as getter or itself (chaining) if used as setter
	   */
	  this.debugEnabled = function(flag) {
	    if (isDefined(flag)) {
	      debug = flag;
	    return this;
	    } else {
	      return debug;
	    }
	  };
	
	  this.$get = ['$window', function($window) {
	    return {
	      /**
	       * @ngdoc method
	       * @name $log#log
	       *
	       * @description
	       * Write a log message
	       */
	      log: consoleLog('log'),
	
	      /**
	       * @ngdoc method
	       * @name $log#info
	       *
	       * @description
	       * Write an information message
	       */
	      info: consoleLog('info'),
	
	      /**
	       * @ngdoc method
	       * @name $log#warn
	       *
	       * @description
	       * Write a warning message
	       */
	      warn: consoleLog('warn'),
	
	      /**
	       * @ngdoc method
	       * @name $log#error
	       *
	       * @description
	       * Write an error message
	       */
	      error: consoleLog('error'),
	
	      /**
	       * @ngdoc method
	       * @name $log#debug
	       *
	       * @description
	       * Write a debug message
	       */
	      debug: (function() {
	        var fn = consoleLog('debug');
	
	        return function() {
	          if (debug) {
	            fn.apply(self, arguments);
	          }
	        };
	      }())
	    };
	
	    function formatError(arg) {
	      if (arg instanceof Error) {
	        if (arg.stack) {
	          arg = (arg.message && arg.stack.indexOf(arg.message) === -1)
	              ? 'Error: ' + arg.message + '\n' + arg.stack
	              : arg.stack;
	        } else if (arg.sourceURL) {
	          arg = arg.message + '\n' + arg.sourceURL + ':' + arg.line;
	        }
	      }
	      return arg;
	    }
	
	    function consoleLog(type) {
	      var console = $window.console || {},
	          logFn = console[type] || console.log || noop,
	          hasApply = false;
	
	      // Note: reading logFn.apply throws an error in IE11 in IE8 document mode.
	      // The reason behind this is that console.log has type "object" in IE8...
	      try {
	        hasApply = !!logFn.apply;
	      } catch (e) {}
	
	      if (hasApply) {
	        return function() {
	          var args = [];
	          forEach(arguments, function(arg) {
	            args.push(formatError(arg));
	          });
	          return logFn.apply(console, args);
	        };
	      }
	
	      // we are IE which either doesn't have window.console => this is noop and we do nothing,
	      // or we are IE where console.log doesn't have apply so we log at least first 2 args
	      return function(arg1, arg2) {
	        logFn(arg1, arg2 == null ? '' : arg2);
	      };
	    }
	  }];
	}
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 *     Any commits to this file should be reviewed with security in mind.  *
	 *   Changes to this file can potentially create security vulnerabilities. *
	 *          An approval from 2 Core members with history of modifying      *
	 *                         this file is required.                          *
	 *                                                                         *
	 *  Does the change somehow allow for arbitrary javascript to be executed? *
	 *    Or allows for someone to change the prototype of built-in objects?   *
	 *     Or gives undesired access to variables likes document or window?    *
	 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */
	
	var $parseMinErr = minErr('$parse');
	
	// Sandboxing Angular Expressions
	// ------------------------------
	// Angular expressions are generally considered safe because these expressions only have direct
	// access to `$scope` and locals. However, one can obtain the ability to execute arbitrary JS code by
	// obtaining a reference to native JS functions such as the Function constructor.
	//
	// As an example, consider the following Angular expression:
	//
	//   {}.toString.constructor('alert("evil JS code")')
	//
	// This sandboxing technique is not perfect and doesn't aim to be. The goal is to prevent exploits
	// against the expression language, but not to prevent exploits that were enabled by exposing
	// sensitive JavaScript or browser APIs on Scope. Exposing such objects on a Scope is never a good
	// practice and therefore we are not even trying to protect against interaction with an object
	// explicitly exposed in this way.
	//
	// In general, it is not possible to access a Window object from an angular expression unless a
	// window or some DOM object that has a reference to window is published onto a Scope.
	// Similarly we prevent invocations of function known to be dangerous, as well as assignments to
	// native objects.
	//
	// See https://docs.angularjs.org/guide/security
	
	
	function ensureSafeMemberName(name, fullExpression) {
	  if (name === "__defineGetter__" || name === "__defineSetter__"
	      || name === "__lookupGetter__" || name === "__lookupSetter__"
	      || name === "__proto__") {
	    throw $parseMinErr('isecfld',
	        'Attempting to access a disallowed field in Angular expressions! '
	        + 'Expression: {0}', fullExpression);
	  }
	  return name;
	}
	
	function getStringValue(name) {
	  // Property names must be strings. This means that non-string objects cannot be used
	  // as keys in an object. Any non-string object, including a number, is typecasted
	  // into a string via the toString method.
	  // -- MDN, https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Operators/Property_accessors#Property_names
	  //
	  // So, to ensure that we are checking the same `name` that JavaScript would use, we cast it
	  // to a string. It's not always possible. If `name` is an object and its `toString` method is
	  // 'broken' (doesn't return a string, isn't a function, etc.), an error will be thrown:
	  //
	  // TypeError: Cannot convert object to primitive value
	  //
	  // For performance reasons, we don't catch this error here and allow it to propagate up the call
	  // stack. Note that you'll get the same error in JavaScript if you try to access a property using
	  // such a 'broken' object as a key.
	  return name + '';
	}
	
	function ensureSafeObject(obj, fullExpression) {
	  // nifty check if obj is Function that is fast and works across iframes and other contexts
	  if (obj) {
	    if (obj.constructor === obj) {
	      throw $parseMinErr('isecfn',
	          'Referencing Function in Angular expressions is disallowed! Expression: {0}',
	          fullExpression);
	    } else if (// isWindow(obj)
	        obj.window === obj) {
	      throw $parseMinErr('isecwindow',
	          'Referencing the Window in Angular expressions is disallowed! Expression: {0}',
	          fullExpression);
	    } else if (// isElement(obj)
	        obj.children && (obj.nodeName || (obj.prop && obj.attr && obj.find))) {
	      throw $parseMinErr('isecdom',
	          'Referencing DOM nodes in Angular expressions is disallowed! Expression: {0}',
	          fullExpression);
	    } else if (// block Object so that we can't get hold of dangerous Object.* methods
	        obj === Object) {
	      throw $parseMinErr('isecobj',
	          'Referencing Object in Angular expressions is disallowed! Expression: {0}',
	          fullExpression);
	    }
	  }
	  return obj;
	}
	
	var CALL = Function.prototype.call;
	var APPLY = Function.prototype.apply;
	var BIND = Function.prototype.bind;
	
	function ensureSafeFunction(obj, fullExpression) {
	  if (obj) {
	    if (obj.constructor === obj) {
	      throw $parseMinErr('isecfn',
	        'Referencing Function in Angular expressions is disallowed! Expression: {0}',
	        fullExpression);
	    } else if (obj === CALL || obj === APPLY || obj === BIND) {
	      throw $parseMinErr('isecff',
	        'Referencing call, apply or bind in Angular expressions is disallowed! Expression: {0}',
	        fullExpression);
	    }
	  }
	}
	
	function ensureSafeAssignContext(obj, fullExpression) {
	  if (obj) {
	    if (obj === (0).constructor || obj === (false).constructor || obj === ''.constructor ||
	        obj === {}.constructor || obj === [].constructor || obj === Function.constructor) {
	      throw $parseMinErr('isecaf',
	        'Assigning to a constructor is disallowed! Expression: {0}', fullExpression);
	    }
	  }
	}
	
	var OPERATORS = createMap();
	forEach('+ - * / % === !== == != < > <= >= && || ! = |'.split(' '), function(operator) { OPERATORS[operator] = true; });
	var ESCAPE = {"n":"\n", "f":"\f", "r":"\r", "t":"\t", "v":"\v", "'":"'", '"':'"'};
	
	
	/////////////////////////////////////////
	
	
	/**
	 * @constructor
	 */
	var Lexer = function(options) {
	  this.options = options;
	};
	
	Lexer.prototype = {
	  constructor: Lexer,
	
	  lex: function(text) {
	    this.text = text;
	    this.index = 0;
	    this.tokens = [];
	
	    while (this.index < this.text.length) {
	      var ch = this.text.charAt(this.index);
	      if (ch === '"' || ch === "'") {
	        this.readString(ch);
	      } else if (this.isNumber(ch) || ch === '.' && this.isNumber(this.peek())) {
	        this.readNumber();
	      } else if (this.isIdentifierStart(this.peekMultichar())) {
	        this.readIdent();
	      } else if (this.is(ch, '(){}[].,;:?')) {
	        this.tokens.push({index: this.index, text: ch});
	        this.index++;
	      } else if (this.isWhitespace(ch)) {
	        this.index++;
	      } else {
	        var ch2 = ch + this.peek();
	        var ch3 = ch2 + this.peek(2);
	        var op1 = OPERATORS[ch];
	        var op2 = OPERATORS[ch2];
	        var op3 = OPERATORS[ch3];
	        if (op1 || op2 || op3) {
	          var token = op3 ? ch3 : (op2 ? ch2 : ch);
	          this.tokens.push({index: this.index, text: token, operator: true});
	          this.index += token.length;
	        } else {
	          this.throwError('Unexpected next character ', this.index, this.index + 1);
	        }
	      }
	    }
	    return this.tokens;
	  },
	
	  is: function(ch, chars) {
	    return chars.indexOf(ch) !== -1;
	  },
	
	  peek: function(i) {
	    var num = i || 1;
	    return (this.index + num < this.text.length) ? this.text.charAt(this.index + num) : false;
	  },
	
	  isNumber: function(ch) {
	    return ('0' <= ch && ch <= '9') && typeof ch === "string";
	  },
	
	  isWhitespace: function(ch) {
	    // IE treats non-breaking space as \u00A0
	    return (ch === ' ' || ch === '\r' || ch === '\t' ||
	            ch === '\n' || ch === '\v' || ch === '\u00A0');
	  },
	
	  isIdentifierStart: function(ch) {
	    return this.options.isIdentifierStart ?
	        this.options.isIdentifierStart(ch, this.codePointAt(ch)) :
	        this.isValidIdentifierStart(ch);
	  },
	
	  isValidIdentifierStart: function(ch) {
	    return ('a' <= ch && ch <= 'z' ||
	            'A' <= ch && ch <= 'Z' ||
	            '_' === ch || ch === '$');
	  },
	
	  isIdentifierContinue: function(ch) {
	    return this.options.isIdentifierContinue ?
	        this.options.isIdentifierContinue(ch, this.codePointAt(ch)) :
	        this.isValidIdentifierContinue(ch);
	  },
	
	  isValidIdentifierContinue: function(ch, cp) {
	    return this.isValidIdentifierStart(ch, cp) || this.isNumber(ch);
	  },
	
	  codePointAt: function(ch) {
	    if (ch.length === 1) return ch.charCodeAt(0);
	    /*jshint bitwise: false*/
	    return (ch.charCodeAt(0) << 10) + ch.charCodeAt(1) - 0x35FDC00;
	    /*jshint bitwise: true*/
	  },
	
	  peekMultichar: function() {
	    var ch = this.text.charAt(this.index);
	    var peek = this.peek();
	    if (!peek) {
	      return ch;
	    }
	    var cp1 = ch.charCodeAt(0);
	    var cp2 = peek.charCodeAt(0);
	    if (cp1 >= 0xD800 && cp1 <= 0xDBFF && cp2 >= 0xDC00 && cp2 <= 0xDFFF) {
	      return ch + peek;
	    }
	    return ch;
	  },
	
	  isExpOperator: function(ch) {
	    return (ch === '-' || ch === '+' || this.isNumber(ch));
	  },
	
	  throwError: function(error, start, end) {
	    end = end || this.index;
	    var colStr = (isDefined(start)
	            ? 's ' + start +  '-' + this.index + ' [' + this.text.substring(start, end) + ']'
	            : ' ' + end);
	    throw $parseMinErr('lexerr', 'Lexer Error: {0} at column{1} in expression [{2}].',
	        error, colStr, this.text);
	  },
	
	  readNumber: function() {
	    var number = '';
	    var start = this.index;
	    while (this.index < this.text.length) {
	      var ch = lowercase(this.text.charAt(this.index));
	      if (ch == '.' || this.isNumber(ch)) {
	        number += ch;
	      } else {
	        var peekCh = this.peek();
	        if (ch == 'e' && this.isExpOperator(peekCh)) {
	          number += ch;
	        } else if (this.isExpOperator(ch) &&
	            peekCh && this.isNumber(peekCh) &&
	            number.charAt(number.length - 1) == 'e') {
	          number += ch;
	        } else if (this.isExpOperator(ch) &&
	            (!peekCh || !this.isNumber(peekCh)) &&
	            number.charAt(number.length - 1) == 'e') {
	          this.throwError('Invalid exponent');
	        } else {
	          break;
	        }
	      }
	      this.index++;
	    }
	    this.tokens.push({
	      index: start,
	      text: number,
	      constant: true,
	      value: Number(number)
	    });
	  },
	
	  readIdent: function() {
	    var start = this.index;
	    this.index += this.peekMultichar().length;
	    while (this.index < this.text.length) {
	      var ch = this.peekMultichar();
	      if (!this.isIdentifierContinue(ch)) {
	        break;
	      }
	      this.index += ch.length;
	    }
	    this.tokens.push({
	      index: start,
	      text: this.text.slice(start, this.index),
	      identifier: true
	    });
	  },
	
	  readString: function(quote) {
	    var start = this.index;
	    this.index++;
	    var string = '';
	    var rawString = quote;
	    var escape = false;
	    while (this.index < this.text.length) {
	      var ch = this.text.charAt(this.index);
	      rawString += ch;
	      if (escape) {
	        if (ch === 'u') {
	          var hex = this.text.substring(this.index + 1, this.index + 5);
	          if (!hex.match(/[\da-f]{4}/i)) {
	            this.throwError('Invalid unicode escape [\\u' + hex + ']');
	          }
	          this.index += 4;
	          string += String.fromCharCode(parseInt(hex, 16));
	        } else {
	          var rep = ESCAPE[ch];
	          string = string + (rep || ch);
	        }
	        escape = false;
	      } else if (ch === '\\') {
	        escape = true;
	      } else if (ch === quote) {
	        this.index++;
	        this.tokens.push({
	          index: start,
	          text: rawString,
	          constant: true,
	          value: string
	        });
	        return;
	      } else {
	        string += ch;
	      }
	      this.index++;
	    }
	    this.throwError('Unterminated quote', start);
	  }
	};
	
	var AST = function(lexer, options) {
	  this.lexer = lexer;
	  this.options = options;
	};
	
	AST.Program = 'Program';
	AST.ExpressionStatement = 'ExpressionStatement';
	AST.AssignmentExpression = 'AssignmentExpression';
	AST.ConditionalExpression = 'ConditionalExpression';
	AST.LogicalExpression = 'LogicalExpression';
	AST.BinaryExpression = 'BinaryExpression';
	AST.UnaryExpression = 'UnaryExpression';
	AST.CallExpression = 'CallExpression';
	AST.MemberExpression = 'MemberExpression';
	AST.Identifier = 'Identifier';
	AST.Literal = 'Literal';
	AST.ArrayExpression = 'ArrayExpression';
	AST.Property = 'Property';
	AST.ObjectExpression = 'ObjectExpression';
	AST.ThisExpression = 'ThisExpression';
	AST.LocalsExpression = 'LocalsExpression';
	
	// Internal use only
	AST.NGValueParameter = 'NGValueParameter';
	
	AST.prototype = {
	  ast: function(text) {
	    this.text = text;
	    this.tokens = this.lexer.lex(text);
	
	    var value = this.program();
	
	    if (this.tokens.length !== 0) {
	      this.throwError('is an unexpected token', this.tokens[0]);
	    }
	
	    return value;
	  },
	
	  program: function() {
	    var body = [];
	    while (true) {
	      if (this.tokens.length > 0 && !this.peek('}', ')', ';', ']'))
	        body.push(this.expressionStatement());
	      if (!this.expect(';')) {
	        return { type: AST.Program, body: body};
	      }
	    }
	  },
	
	  expressionStatement: function() {
	    return { type: AST.ExpressionStatement, expression: this.filterChain() };
	  },
	
	  filterChain: function() {
	    var left = this.expression();
	    var token;
	    while ((token = this.expect('|'))) {
	      left = this.filter(left);
	    }
	    return left;
	  },
	
	  expression: function() {
	    return this.assignment();
	  },
	
	  assignment: function() {
	    var result = this.ternary();
	    if (this.expect('=')) {
	      result = { type: AST.AssignmentExpression, left: result, right: this.assignment(), operator: '='};
	    }
	    return result;
	  },
	
	  ternary: function() {
	    var test = this.logicalOR();
	    var alternate;
	    var consequent;
	    if (this.expect('?')) {
	      alternate = this.expression();
	      if (this.consume(':')) {
	        consequent = this.expression();
	        return { type: AST.ConditionalExpression, test: test, alternate: alternate, consequent: consequent};
	      }
	    }
	    return test;
	  },
	
	  logicalOR: function() {
	    var left = this.logicalAND();
	    while (this.expect('||')) {
	      left = { type: AST.LogicalExpression, operator: '||', left: left, right: this.logicalAND() };
	    }
	    return left;
	  },
	
	  logicalAND: function() {
	    var left = this.equality();
	    while (this.expect('&&')) {
	      left = { type: AST.LogicalExpression, operator: '&&', left: left, right: this.equality()};
	    }
	    return left;
	  },
	
	  equality: function() {
	    var left = this.relational();
	    var token;
	    while ((token = this.expect('==','!=','===','!=='))) {
	      left = { type: AST.BinaryExpression, operator: token.text, left: left, right: this.relational() };
	    }
	    return left;
	  },
	
	  relational: function() {
	    var left = this.additive();
	    var token;
	    while ((token = this.expect('<', '>', '<=', '>='))) {
	      left = { type: AST.BinaryExpression, operator: token.text, left: left, right: this.additive() };
	    }
	    return left;
	  },
	
	  additive: function() {
	    var left = this.multiplicative();
	    var token;
	    while ((token = this.expect('+','-'))) {
	      left = { type: AST.BinaryExpression, operator: token.text, left: left, right: this.multiplicative() };
	    }
	    return left;
	  },
	
	  multiplicative: function() {
	    var left = this.unary();
	    var token;
	    while ((token = this.expect('*','/','%'))) {
	      left = { type: AST.BinaryExpression, operator: token.text, left: left, right: this.unary() };
	    }
	    return left;
	  },
	
	  unary: function() {
	    var token;
	    if ((token = this.expect('+', '-', '!'))) {
	      return { type: AST.UnaryExpression, operator: token.text, prefix: true, argument: this.unary() };
	    } else {
	      return this.primary();
	    }
	  },
	
	  primary: function() {
	    var primary;
	    if (this.expect('(')) {
	      primary = this.filterChain();
	      this.consume(')');
	    } else if (this.expect('[')) {
	      primary = this.arrayDeclaration();
	    } else if (this.expect('{')) {
	      primary = this.object();
	    } else if (this.selfReferential.hasOwnProperty(this.peek().text)) {
	      primary = copy(this.selfReferential[this.consume().text]);
	    } else if (this.options.literals.hasOwnProperty(this.peek().text)) {
	      primary = { type: AST.Literal, value: this.options.literals[this.consume().text]};
	    } else if (this.peek().identifier) {
	      primary = this.identifier();
	    } else if (this.peek().constant) {
	      primary = this.constant();
	    } else {
	      this.throwError('not a primary expression', this.peek());
	    }
	
	    var next;
	    while ((next = this.expect('(', '[', '.'))) {
	      if (next.text === '(') {
	        primary = {type: AST.CallExpression, callee: primary, arguments: this.parseArguments() };
	        this.consume(')');
	      } else if (next.text === '[') {
	        primary = { type: AST.MemberExpression, object: primary, property: this.expression(), computed: true };
	        this.consume(']');
	      } else if (next.text === '.') {
	        primary = { type: AST.MemberExpression, object: primary, property: this.identifier(), computed: false };
	      } else {
	        this.throwError('IMPOSSIBLE');
	      }
	    }
	    return primary;
	  },
	
	  filter: function(baseExpression) {
	    var args = [baseExpression];
	    var result = {type: AST.CallExpression, callee: this.identifier(), arguments: args, filter: true};
	
	    while (this.expect(':')) {
	      args.push(this.expression());
	    }
	
	    return result;
	  },
	
	  parseArguments: function() {
	    var args = [];
	    if (this.peekToken().text !== ')') {
	      do {
	        args.push(this.expression());
	      } while (this.expect(','));
	    }
	    return args;
	  },
	
	  identifier: function() {
	    var token = this.consume();
	    if (!token.identifier) {
	      this.throwError('is not a valid identifier', token);
	    }
	    return { type: AST.Identifier, name: token.text };
	  },
	
	  constant: function() {
	    // TODO check that it is a constant
	    return { type: AST.Literal, value: this.consume().value };
	  },
	
	  arrayDeclaration: function() {
	    var elements = [];
	    if (this.peekToken().text !== ']') {
	      do {
	        if (this.peek(']')) {
	          // Support trailing commas per ES5.1.
	          break;
	        }
	        elements.push(this.expression());
	      } while (this.expect(','));
	    }
	    this.consume(']');
	
	    return { type: AST.ArrayExpression, elements: elements };
	  },
	
	  object: function() {
	    var properties = [], property;
	    if (this.peekToken().text !== '}') {
	      do {
	        if (this.peek('}')) {
	          // Support trailing commas per ES5.1.
	          break;
	        }
	        property = {type: AST.Property, kind: 'init'};
	        if (this.peek().constant) {
	          property.key = this.constant();
	          property.computed = false;
	          this.consume(':');
	          property.value = this.expression();
	        } else if (this.peek().identifier) {
	          property.key = this.identifier();
	          property.computed = false;
	          if (this.peek(':')) {
	            this.consume(':');
	            property.value = this.expression();
	          } else {
	            property.value = property.key;
	          }
	        } else if (this.peek('[')) {
	          this.consume('[');
	          property.key = this.expression();
	          this.consume(']');
	          property.computed = true;
	          this.consume(':');
	          property.value = this.expression();
	        } else {
	          this.throwError("invalid key", this.peek());
	        }
	        properties.push(property);
	      } while (this.expect(','));
	    }
	    this.consume('}');
	
	    return {type: AST.ObjectExpression, properties: properties };
	  },
	
	  throwError: function(msg, token) {
	    throw $parseMinErr('syntax',
	        'Syntax Error: Token \'{0}\' {1} at column {2} of the expression [{3}] starting at [{4}].',
	          token.text, msg, (token.index + 1), this.text, this.text.substring(token.index));
	  },
	
	  consume: function(e1) {
	    if (this.tokens.length === 0) {
	      throw $parseMinErr('ueoe', 'Unexpected end of expression: {0}', this.text);
	    }
	
	    var token = this.expect(e1);
	    if (!token) {
	      this.throwError('is unexpected, expecting [' + e1 + ']', this.peek());
	    }
	    return token;
	  },
	
	  peekToken: function() {
	    if (this.tokens.length === 0) {
	      throw $parseMinErr('ueoe', 'Unexpected end of expression: {0}', this.text);
	    }
	    return this.tokens[0];
	  },
	
	  peek: function(e1, e2, e3, e4) {
	    return this.peekAhead(0, e1, e2, e3, e4);
	  },
	
	  peekAhead: function(i, e1, e2, e3, e4) {
	    if (this.tokens.length > i) {
	      var token = this.tokens[i];
	      var t = token.text;
	      if (t === e1 || t === e2 || t === e3 || t === e4 ||
	          (!e1 && !e2 && !e3 && !e4)) {
	        return token;
	      }
	    }
	    return false;
	  },
	
	  expect: function(e1, e2, e3, e4) {
	    var token = this.peek(e1, e2, e3, e4);
	    if (token) {
	      this.tokens.shift();
	      return token;
	    }
	    return false;
	  },
	
	  selfReferential: {
	    'this': {type: AST.ThisExpression },
	    '$locals': {type: AST.LocalsExpression }
	  }
	};
	
	function ifDefined(v, d) {
	  return typeof v !== 'undefined' ? v : d;
	}
	
	function plusFn(l, r) {
	  if (typeof l === 'undefined') return r;
	  if (typeof r === 'undefined') return l;
	  return l + r;
	}
	
	function isStateless($filter, filterName) {
	  var fn = $filter(filterName);
	  return !fn.$stateful;
	}
	
	function findConstantAndWatchExpressions(ast, $filter) {
	  var allConstants;
	  var argsToWatch;
	  switch (ast.type) {
	  case AST.Program:
	    allConstants = true;
	    forEach(ast.body, function(expr) {
	      findConstantAndWatchExpressions(expr.expression, $filter);
	      allConstants = allConstants && expr.expression.constant;
	    });
	    ast.constant = allConstants;
	    break;
	  case AST.Literal:
	    ast.constant = true;
	    ast.toWatch = [];
	    break;
	  case AST.UnaryExpression:
	    findConstantAndWatchExpressions(ast.argument, $filter);
	    ast.constant = ast.argument.constant;
	    ast.toWatch = ast.argument.toWatch;
	    break;
	  case AST.BinaryExpression:
	    findConstantAndWatchExpressions(ast.left, $filter);
	    findConstantAndWatchExpressions(ast.right, $filter);
	    ast.constant = ast.left.constant && ast.right.constant;
	    ast.toWatch = ast.left.toWatch.concat(ast.right.toWatch);
	    break;
	  case AST.LogicalExpression:
	    findConstantAndWatchExpressions(ast.left, $filter);
	    findConstantAndWatchExpressions(ast.right, $filter);
	    ast.constant = ast.left.constant && ast.right.constant;
	    ast.toWatch = ast.constant ? [] : [ast];
	    break;
	  case AST.ConditionalExpression:
	    findConstantAndWatchExpressions(ast.test, $filter);
	    findConstantAndWatchExpressions(ast.alternate, $filter);
	    findConstantAndWatchExpressions(ast.consequent, $filter);
	    ast.constant = ast.test.constant && ast.alternate.constant && ast.consequent.constant;
	    ast.toWatch = ast.constant ? [] : [ast];
	    break;
	  case AST.Identifier:
	    ast.constant = false;
	    ast.toWatch = [ast];
	    break;
	  case AST.MemberExpression:
	    findConstantAndWatchExpressions(ast.object, $filter);
	    if (ast.computed) {
	      findConstantAndWatchExpressions(ast.property, $filter);
	    }
	    ast.constant = ast.object.constant && (!ast.computed || ast.property.constant);
	    ast.toWatch = [ast];
	    break;
	  case AST.CallExpression:
	    allConstants = ast.filter ? isStateless($filter, ast.callee.name) : false;
	    argsToWatch = [];
	    forEach(ast.arguments, function(expr) {
	      findConstantAndWatchExpressions(expr, $filter);
	      allConstants = allConstants && expr.constant;
	      if (!expr.constant) {
	        argsToWatch.push.apply(argsToWatch, expr.toWatch);
	      }
	    });
	    ast.constant = allConstants;
	    ast.toWatch = ast.filter && isStateless($filter, ast.callee.name) ? argsToWatch : [ast];
	    break;
	  case AST.AssignmentExpression:
	    findConstantAndWatchExpressions(ast.left, $filter);
	    findConstantAndWatchExpressions(ast.right, $filter);
	    ast.constant = ast.left.constant && ast.right.constant;
	    ast.toWatch = [ast];
	    break;
	  case AST.ArrayExpression:
	    allConstants = true;
	    argsToWatch = [];
	    forEach(ast.elements, function(expr) {
	      findConstantAndWatchExpressions(expr, $filter);
	      allConstants = allConstants && expr.constant;
	      if (!expr.constant) {
	        argsToWatch.push.apply(argsToWatch, expr.toWatch);
	      }
	    });
	    ast.constant = allConstants;
	    ast.toWatch = argsToWatch;
	    break;
	  case AST.ObjectExpression:
	    allConstants = true;
	    argsToWatch = [];
	    forEach(ast.properties, function(property) {
	      findConstantAndWatchExpressions(property.value, $filter);
	      allConstants = allConstants && property.value.constant && !property.computed;
	      if (!property.value.constant) {
	        argsToWatch.push.apply(argsToWatch, property.value.toWatch);
	      }
	    });
	    ast.constant = allConstants;
	    ast.toWatch = argsToWatch;
	    break;
	  case AST.ThisExpression:
	    ast.constant = false;
	    ast.toWatch = [];
	    break;
	  case AST.LocalsExpression:
	    ast.constant = false;
	    ast.toWatch = [];
	    break;
	  }
	}
	
	function getInputs(body) {
	  if (body.length != 1) return;
	  var lastExpression = body[0].expression;
	  var candidate = lastExpression.toWatch;
	  if (candidate.length !== 1) return candidate;
	  return candidate[0] !== lastExpression ? candidate : undefined;
	}
	
	function isAssignable(ast) {
	  return ast.type === AST.Identifier || ast.type === AST.MemberExpression;
	}
	
	function assignableAST(ast) {
	  if (ast.body.length === 1 && isAssignable(ast.body[0].expression)) {
	    return {type: AST.AssignmentExpression, left: ast.body[0].expression, right: {type: AST.NGValueParameter}, operator: '='};
	  }
	}
	
	function isLiteral(ast) {
	  return ast.body.length === 0 ||
	      ast.body.length === 1 && (
	      ast.body[0].expression.type === AST.Literal ||
	      ast.body[0].expression.type === AST.ArrayExpression ||
	      ast.body[0].expression.type === AST.ObjectExpression);
	}
	
	function isConstant(ast) {
	  return ast.constant;
	}
	
	function ASTCompiler(astBuilder, $filter) {
	  this.astBuilder = astBuilder;
	  this.$filter = $filter;
	}
	
	ASTCompiler.prototype = {
	  compile: function(expression, expensiveChecks) {
	    var self = this;
	    var ast = this.astBuilder.ast(expression);
	    this.state = {
	      nextId: 0,
	      filters: {},
	      expensiveChecks: expensiveChecks,
	      fn: {vars: [], body: [], own: {}},
	      assign: {vars: [], body: [], own: {}},
	      inputs: []
	    };
	    findConstantAndWatchExpressions(ast, self.$filter);
	    var extra = '';
	    var assignable;
	    this.stage = 'assign';
	    if ((assignable = assignableAST(ast))) {
	      this.state.computing = 'assign';
	      var result = this.nextId();
	      this.recurse(assignable, result);
	      this.return_(result);
	      extra = 'fn.assign=' + this.generateFunction('assign', 's,v,l');
	    }
	    var toWatch = getInputs(ast.body);
	    self.stage = 'inputs';
	    forEach(toWatch, function(watch, key) {
	      var fnKey = 'fn' + key;
	      self.state[fnKey] = {vars: [], body: [], own: {}};
	      self.state.computing = fnKey;
	      var intoId = self.nextId();
	      self.recurse(watch, intoId);
	      self.return_(intoId);
	      self.state.inputs.push(fnKey);
	      watch.watchId = key;
	    });
	    this.state.computing = 'fn';
	    this.stage = 'main';
	    this.recurse(ast);
	    var fnString =
	      // The build and minification steps remove the string "use strict" from the code, but this is done using a regex.
	      // This is a workaround for this until we do a better job at only removing the prefix only when we should.
	      '"' + this.USE + ' ' + this.STRICT + '";\n' +
	      this.filterPrefix() +
	      'var fn=' + this.generateFunction('fn', 's,l,a,i') +
	      extra +
	      this.watchFns() +
	      'return fn;';
	
	    /* jshint -W054 */
	    var fn = (new Function('$filter',
	        'ensureSafeMemberName',
	        'ensureSafeObject',
	        'ensureSafeFunction',
	        'getStringValue',
	        'ensureSafeAssignContext',
	        'ifDefined',
	        'plus',
	        'text',
	        fnString))(
	          this.$filter,
	          ensureSafeMemberName,
	          ensureSafeObject,
	          ensureSafeFunction,
	          getStringValue,
	          ensureSafeAssignContext,
	          ifDefined,
	          plusFn,
	          expression);
	    /* jshint +W054 */
	    this.state = this.stage = undefined;
	    fn.literal = isLiteral(ast);
	    fn.constant = isConstant(ast);
	    return fn;
	  },
	
	  USE: 'use',
	
	  STRICT: 'strict',
	
	  watchFns: function() {
	    var result = [];
	    var fns = this.state.inputs;
	    var self = this;
	    forEach(fns, function(name) {
	      result.push('var ' + name + '=' + self.generateFunction(name, 's'));
	    });
	    if (fns.length) {
	      result.push('fn.inputs=[' + fns.join(',') + '];');
	    }
	    return result.join('');
	  },
	
	  generateFunction: function(name, params) {
	    return 'function(' + params + '){' +
	        this.varsPrefix(name) +
	        this.body(name) +
	        '};';
	  },
	
	  filterPrefix: function() {
	    var parts = [];
	    var self = this;
	    forEach(this.state.filters, function(id, filter) {
	      parts.push(id + '=$filter(' + self.escape(filter) + ')');
	    });
	    if (parts.length) return 'var ' + parts.join(',') + ';';
	    return '';
	  },
	
	  varsPrefix: function(section) {
	    return this.state[section].vars.length ? 'var ' + this.state[section].vars.join(',') + ';' : '';
	  },
	
	  body: function(section) {
	    return this.state[section].body.join('');
	  },
	
	  recurse: function(ast, intoId, nameId, recursionFn, create, skipWatchIdCheck) {
	    var left, right, self = this, args, expression, computed;
	    recursionFn = recursionFn || noop;
	    if (!skipWatchIdCheck && isDefined(ast.watchId)) {
	      intoId = intoId || this.nextId();
	      this.if_('i',
	        this.lazyAssign(intoId, this.computedMember('i', ast.watchId)),
	        this.lazyRecurse(ast, intoId, nameId, recursionFn, create, true)
	      );
	      return;
	    }
	    switch (ast.type) {
	    case AST.Program:
	      forEach(ast.body, function(expression, pos) {
	        self.recurse(expression.expression, undefined, undefined, function(expr) { right = expr; });
	        if (pos !== ast.body.length - 1) {
	          self.current().body.push(right, ';');
	        } else {
	          self.return_(right);
	        }
	      });
	      break;
	    case AST.Literal:
	      expression = this.escape(ast.value);
	      this.assign(intoId, expression);
	      recursionFn(expression);
	      break;
	    case AST.UnaryExpression:
	      this.recurse(ast.argument, undefined, undefined, function(expr) { right = expr; });
	      expression = ast.operator + '(' + this.ifDefined(right, 0) + ')';
	      this.assign(intoId, expression);
	      recursionFn(expression);
	      break;
	    case AST.BinaryExpression:
	      this.recurse(ast.left, undefined, undefined, function(expr) { left = expr; });
	      this.recurse(ast.right, undefined, undefined, function(expr) { right = expr; });
	      if (ast.operator === '+') {
	        expression = this.plus(left, right);
	      } else if (ast.operator === '-') {
	        expression = this.ifDefined(left, 0) + ast.operator + this.ifDefined(right, 0);
	      } else {
	        expression = '(' + left + ')' + ast.operator + '(' + right + ')';
	      }
	      this.assign(intoId, expression);
	      recursionFn(expression);
	      break;
	    case AST.LogicalExpression:
	      intoId = intoId || this.nextId();
	      self.recurse(ast.left, intoId);
	      self.if_(ast.operator === '&&' ? intoId : self.not(intoId), self.lazyRecurse(ast.right, intoId));
	      recursionFn(intoId);
	      break;
	    case AST.ConditionalExpression:
	      intoId = intoId || this.nextId();
	      self.recurse(ast.test, intoId);
	      self.if_(intoId, self.lazyRecurse(ast.alternate, intoId), self.lazyRecurse(ast.consequent, intoId));
	      recursionFn(intoId);
	      break;
	    case AST.Identifier:
	      intoId = intoId || this.nextId();
	      if (nameId) {
	        nameId.context = self.stage === 'inputs' ? 's' : this.assign(this.nextId(), this.getHasOwnProperty('l', ast.name) + '?l:s');
	        nameId.computed = false;
	        nameId.name = ast.name;
	      }
	      ensureSafeMemberName(ast.name);
	      self.if_(self.stage === 'inputs' || self.not(self.getHasOwnProperty('l', ast.name)),
	        function() {
	          self.if_(self.stage === 'inputs' || 's', function() {
	            if (create && create !== 1) {
	              self.if_(
	                self.not(self.nonComputedMember('s', ast.name)),
	                self.lazyAssign(self.nonComputedMember('s', ast.name), '{}'));
	            }
	            self.assign(intoId, self.nonComputedMember('s', ast.name));
	          });
	        }, intoId && self.lazyAssign(intoId, self.nonComputedMember('l', ast.name))
	        );
	      if (self.state.expensiveChecks || isPossiblyDangerousMemberName(ast.name)) {
	        self.addEnsureSafeObject(intoId);
	      }
	      recursionFn(intoId);
	      break;
	    case AST.MemberExpression:
	      left = nameId && (nameId.context = this.nextId()) || this.nextId();
	      intoId = intoId || this.nextId();
	      self.recurse(ast.object, left, undefined, function() {
	        self.if_(self.notNull(left), function() {
	          if (create && create !== 1) {
	            self.addEnsureSafeAssignContext(left);
	          }
	          if (ast.computed) {
	            right = self.nextId();
	            self.recurse(ast.property, right);
	            self.getStringValue(right);
	            self.addEnsureSafeMemberName(right);
	            if (create && create !== 1) {
	              self.if_(self.not(self.computedMember(left, right)), self.lazyAssign(self.computedMember(left, right), '{}'));
	            }
	            expression = self.ensureSafeObject(self.computedMember(left, right));
	            self.assign(intoId, expression);
	            if (nameId) {
	              nameId.computed = true;
	              nameId.name = right;
	            }
	          } else {
	            ensureSafeMemberName(ast.property.name);
	            if (create && create !== 1) {
	              self.if_(self.not(self.nonComputedMember(left, ast.property.name)), self.lazyAssign(self.nonComputedMember(left, ast.property.name), '{}'));
	            }
	            expression = self.nonComputedMember(left, ast.property.name);
	            if (self.state.expensiveChecks || isPossiblyDangerousMemberName(ast.property.name)) {
	              expression = self.ensureSafeObject(expression);
	            }
	            self.assign(intoId, expression);
	            if (nameId) {
	              nameId.computed = false;
	              nameId.name = ast.property.name;
	            }
	          }
	        }, function() {
	          self.assign(intoId, 'undefined');
	        });
	        recursionFn(intoId);
	      }, !!create);
	      break;
	    case AST.CallExpression:
	      intoId = intoId || this.nextId();
	      if (ast.filter) {
	        right = self.filter(ast.callee.name);
	        args = [];
	        forEach(ast.arguments, function(expr) {
	          var argument = self.nextId();
	          self.recurse(expr, argument);
	          args.push(argument);
	        });
	        expression = right + '(' + args.join(',') + ')';
	        self.assign(intoId, expression);
	        recursionFn(intoId);
	      } else {
	        right = self.nextId();
	        left = {};
	        args = [];
	        self.recurse(ast.callee, right, left, function() {
	          self.if_(self.notNull(right), function() {
	            self.addEnsureSafeFunction(right);
	            forEach(ast.arguments, function(expr) {
	              self.recurse(expr, self.nextId(), undefined, function(argument) {
	                args.push(self.ensureSafeObject(argument));
	              });
	            });
	            if (left.name) {
	              if (!self.state.expensiveChecks) {
	                self.addEnsureSafeObject(left.context);
	              }
	              expression = self.member(left.context, left.name, left.computed) + '(' + args.join(',') + ')';
	            } else {
	              expression = right + '(' + args.join(',') + ')';
	            }
	            expression = self.ensureSafeObject(expression);
	            self.assign(intoId, expression);
	          }, function() {
	            self.assign(intoId, 'undefined');
	          });
	          recursionFn(intoId);
	        });
	      }
	      break;
	    case AST.AssignmentExpression:
	      right = this.nextId();
	      left = {};
	      if (!isAssignable(ast.left)) {
	        throw $parseMinErr('lval', 'Trying to assign a value to a non l-value');
	      }
	      this.recurse(ast.left, undefined, left, function() {
	        self.if_(self.notNull(left.context), function() {
	          self.recurse(ast.right, right);
	          self.addEnsureSafeObject(self.member(left.context, left.name, left.computed));
	          self.addEnsureSafeAssignContext(left.context);
	          expression = self.member(left.context, left.name, left.computed) + ast.operator + right;
	          self.assign(intoId, expression);
	          recursionFn(intoId || expression);
	        });
	      }, 1);
	      break;
	    case AST.ArrayExpression:
	      args = [];
	      forEach(ast.elements, function(expr) {
	        self.recurse(expr, self.nextId(), undefined, function(argument) {
	          args.push(argument);
	        });
	      });
	      expression = '[' + args.join(',') + ']';
	      this.assign(intoId, expression);
	      recursionFn(expression);
	      break;
	    case AST.ObjectExpression:
	      args = [];
	      computed = false;
	      forEach(ast.properties, function(property) {
	        if (property.computed) {
	          computed = true;
	        }
	      });
	      if (computed) {
	        intoId = intoId || this.nextId();
	        this.assign(intoId, '{}');
	        forEach(ast.properties, function(property) {
	          if (property.computed) {
	            left = self.nextId();
	            self.recurse(property.key, left);
	          } else {
	            left = property.key.type === AST.Identifier ?
	                       property.key.name :
	                       ('' + property.key.value);
	          }
	          right = self.nextId();
	          self.recurse(property.value, right);
	          self.assign(self.member(intoId, left, property.computed), right);
	        });
	      } else {
	        forEach(ast.properties, function(property) {
	          self.recurse(property.value, ast.constant ? undefined : self.nextId(), undefined, function(expr) {
	            args.push(self.escape(
	                property.key.type === AST.Identifier ? property.key.name :
	                  ('' + property.key.value)) +
	                ':' + expr);
	          });
	        });
	        expression = '{' + args.join(',') + '}';
	        this.assign(intoId, expression);
	      }
	      recursionFn(intoId || expression);
	      break;
	    case AST.ThisExpression:
	      this.assign(intoId, 's');
	      recursionFn('s');
	      break;
	    case AST.LocalsExpression:
	      this.assign(intoId, 'l');
	      recursionFn('l');
	      break;
	    case AST.NGValueParameter:
	      this.assign(intoId, 'v');
	      recursionFn('v');
	      break;
	    }
	  },
	
	  getHasOwnProperty: function(element, property) {
	    var key = element + '.' + property;
	    var own = this.current().own;
	    if (!own.hasOwnProperty(key)) {
	      own[key] = this.nextId(false, element + '&&(' + this.escape(property) + ' in ' + element + ')');
	    }
	    return own[key];
	  },
	
	  assign: function(id, value) {
	    if (!id) return;
	    this.current().body.push(id, '=', value, ';');
	    return id;
	  },
	
	  filter: function(filterName) {
	    if (!this.state.filters.hasOwnProperty(filterName)) {
	      this.state.filters[filterName] = this.nextId(true);
	    }
	    return this.state.filters[filterName];
	  },
	
	  ifDefined: function(id, defaultValue) {
	    return 'ifDefined(' + id + ',' + this.escape(defaultValue) + ')';
	  },
	
	  plus: function(left, right) {
	    return 'plus(' + left + ',' + right + ')';
	  },
	
	  return_: function(id) {
	    this.current().body.push('return ', id, ';');
	  },
	
	  if_: function(test, alternate, consequent) {
	    if (test === true) {
	      alternate();
	    } else {
	      var body = this.current().body;
	      body.push('if(', test, '){');
	      alternate();
	      body.push('}');
	      if (consequent) {
	        body.push('else{');
	        consequent();
	        body.push('}');
	      }
	    }
	  },
	
	  not: function(expression) {
	    return '!(' + expression + ')';
	  },
	
	  notNull: function(expression) {
	    return expression + '!=null';
	  },
	
	  nonComputedMember: function(left, right) {
	    var SAFE_IDENTIFIER = /[$_a-zA-Z][$_a-zA-Z0-9]*/;
	    var UNSAFE_CHARACTERS = /[^$_a-zA-Z0-9]/g;
	    if (SAFE_IDENTIFIER.test(right)) {
	      return left + '.' + right;
	    } else {
	      return left  + '["' + right.replace(UNSAFE_CHARACTERS, this.stringEscapeFn) + '"]';
	    }
	  },
	
	  computedMember: function(left, right) {
	    return left + '[' + right + ']';
	  },
	
	  member: function(left, right, computed) {
	    if (computed) return this.computedMember(left, right);
	    return this.nonComputedMember(left, right);
	  },
	
	  addEnsureSafeObject: function(item) {
	    this.current().body.push(this.ensureSafeObject(item), ';');
	  },
	
	  addEnsureSafeMemberName: function(item) {
	    this.current().body.push(this.ensureSafeMemberName(item), ';');
	  },
	
	  addEnsureSafeFunction: function(item) {
	    this.current().body.push(this.ensureSafeFunction(item), ';');
	  },
	
	  addEnsureSafeAssignContext: function(item) {
	    this.current().body.push(this.ensureSafeAssignContext(item), ';');
	  },
	
	  ensureSafeObject: function(item) {
	    return 'ensureSafeObject(' + item + ',text)';
	  },
	
	  ensureSafeMemberName: function(item) {
	    return 'ensureSafeMemberName(' + item + ',text)';
	  },
	
	  ensureSafeFunction: function(item) {
	    return 'ensureSafeFunction(' + item + ',text)';
	  },
	
	  getStringValue: function(item) {
	    this.assign(item, 'getStringValue(' + item + ')');
	  },
	
	  ensureSafeAssignContext: function(item) {
	    return 'ensureSafeAssignContext(' + item + ',text)';
	  },
	
	  lazyRecurse: function(ast, intoId, nameId, recursionFn, create, skipWatchIdCheck) {
	    var self = this;
	    return function() {
	      self.recurse(ast, intoId, nameId, recursionFn, create, skipWatchIdCheck);
	    };
	  },
	
	  lazyAssign: function(id, value) {
	    var self = this;
	    return function() {
	      self.assign(id, value);
	    };
	  },
	
	  stringEscapeRegex: /[^ a-zA-Z0-9]/g,
	
	  stringEscapeFn: function(c) {
	    return '\\u' + ('0000' + c.charCodeAt(0).toString(16)).slice(-4);
	  },
	
	  escape: function(value) {
	    if (isString(value)) return "'" + value.replace(this.stringEscapeRegex, this.stringEscapeFn) + "'";
	    if (isNumber(value)) return value.toString();
	    if (value === true) return 'true';
	    if (value === false) return 'false';
	    if (value === null) return 'null';
	    if (typeof value === 'undefined') return 'undefined';
	
	    throw $parseMinErr('esc', 'IMPOSSIBLE');
	  },
	
	  nextId: function(skip, init) {
	    var id = 'v' + (this.state.nextId++);
	    if (!skip) {
	      this.current().vars.push(id + (init ? '=' + init : ''));
	    }
	    return id;
	  },
	
	  current: function() {
	    return this.state[this.state.computing];
	  }
	};
	
	
	function ASTInterpreter(astBuilder, $filter) {
	  this.astBuilder = astBuilder;
	  this.$filter = $filter;
	}
	
	ASTInterpreter.prototype = {
	  compile: function(expression, expensiveChecks) {
	    var self = this;
	    var ast = this.astBuilder.ast(expression);
	    this.expression = expression;
	    this.expensiveChecks = expensiveChecks;
	    findConstantAndWatchExpressions(ast, self.$filter);
	    var assignable;
	    var assign;
	    if ((assignable = assignableAST(ast))) {
	      assign = this.recurse(assignable);
	    }
	    var toWatch = getInputs(ast.body);
	    var inputs;
	    if (toWatch) {
	      inputs = [];
	      forEach(toWatch, function(watch, key) {
	        var input = self.recurse(watch);
	        watch.input = input;
	        inputs.push(input);
	        watch.watchId = key;
	      });
	    }
	    var expressions = [];
	    forEach(ast.body, function(expression) {
	      expressions.push(self.recurse(expression.expression));
	    });
	    var fn = ast.body.length === 0 ? noop :
	             ast.body.length === 1 ? expressions[0] :
	             function(scope, locals) {
	               var lastValue;
	               forEach(expressions, function(exp) {
	                 lastValue = exp(scope, locals);
	               });
	               return lastValue;
	             };
	    if (assign) {
	      fn.assign = function(scope, value, locals) {
	        return assign(scope, locals, value);
	      };
	    }
	    if (inputs) {
	      fn.inputs = inputs;
	    }
	    fn.literal = isLiteral(ast);
	    fn.constant = isConstant(ast);
	    return fn;
	  },
	
	  recurse: function(ast, context, create) {
	    var left, right, self = this, args, expression;
	    if (ast.input) {
	      return this.inputs(ast.input, ast.watchId);
	    }
	    switch (ast.type) {
	    case AST.Literal:
	      return this.value(ast.value, context);
	    case AST.UnaryExpression:
	      right = this.recurse(ast.argument);
	      return this['unary' + ast.operator](right, context);
	    case AST.BinaryExpression:
	      left = this.recurse(ast.left);
	      right = this.recurse(ast.right);
	      return this['binary' + ast.operator](left, right, context);
	    case AST.LogicalExpression:
	      left = this.recurse(ast.left);
	      right = this.recurse(ast.right);
	      return this['binary' + ast.operator](left, right, context);
	    case AST.ConditionalExpression:
	      return this['ternary?:'](
	        this.recurse(ast.test),
	        this.recurse(ast.alternate),
	        this.recurse(ast.consequent),
	        context
	      );
	    case AST.Identifier:
	      ensureSafeMemberName(ast.name, self.expression);
	      return self.identifier(ast.name,
	                             self.expensiveChecks || isPossiblyDangerousMemberName(ast.name),
	                             context, create, self.expression);
	    case AST.MemberExpression:
	      left = this.recurse(ast.object, false, !!create);
	      if (!ast.computed) {
	        ensureSafeMemberName(ast.property.name, self.expression);
	        right = ast.property.name;
	      }
	      if (ast.computed) right = this.recurse(ast.property);
	      return ast.computed ?
	        this.computedMember(left, right, context, create, self.expression) :
	        this.nonComputedMember(left, right, self.expensiveChecks, context, create, self.expression);
	    case AST.CallExpression:
	      args = [];
	      forEach(ast.arguments, function(expr) {
	        args.push(self.recurse(expr));
	      });
	      if (ast.filter) right = this.$filter(ast.callee.name);
	      if (!ast.filter) right = this.recurse(ast.callee, true);
	      return ast.filter ?
	        function(scope, locals, assign, inputs) {
	          var values = [];
	          for (var i = 0; i < args.length; ++i) {
	            values.push(args[i](scope, locals, assign, inputs));
	          }
	          var value = right.apply(undefined, values, inputs);
	          return context ? {context: undefined, name: undefined, value: value} : value;
	        } :
	        function(scope, locals, assign, inputs) {
	          var rhs = right(scope, locals, assign, inputs);
	          var value;
	          if (rhs.value != null) {
	            ensureSafeObject(rhs.context, self.expression);
	            ensureSafeFunction(rhs.value, self.expression);
	            var values = [];
	            for (var i = 0; i < args.length; ++i) {
	              values.push(ensureSafeObject(args[i](scope, locals, assign, inputs), self.expression));
	            }
	            value = ensureSafeObject(rhs.value.apply(rhs.context, values), self.expression);
	          }
	          return context ? {value: value} : value;
	        };
	    case AST.AssignmentExpression:
	      left = this.recurse(ast.left, true, 1);
	      right = this.recurse(ast.right);
	      return function(scope, locals, assign, inputs) {
	        var lhs = left(scope, locals, assign, inputs);
	        var rhs = right(scope, locals, assign, inputs);
	        ensureSafeObject(lhs.value, self.expression);
	        ensureSafeAssignContext(lhs.context);
	        lhs.context[lhs.name] = rhs;
	        return context ? {value: rhs} : rhs;
	      };
	    case AST.ArrayExpression:
	      args = [];
	      forEach(ast.elements, function(expr) {
	        args.push(self.recurse(expr));
	      });
	      return function(scope, locals, assign, inputs) {
	        var value = [];
	        for (var i = 0; i < args.length; ++i) {
	          value.push(args[i](scope, locals, assign, inputs));
	        }
	        return context ? {value: value} : value;
	      };
	    case AST.ObjectExpression:
	      args = [];
	      forEach(ast.properties, function(property) {
	        if (property.computed) {
	          args.push({key: self.recurse(property.key),
	                     computed: true,
	                     value: self.recurse(property.value)
	          });
	        } else {
	          args.push({key: property.key.type === AST.Identifier ?
	                          property.key.name :
	                          ('' + property.key.value),
	                     computed: false,
	                     value: self.recurse(property.value)
	          });
	        }
	      });
	      return function(scope, locals, assign, inputs) {
	        var value = {};
	        for (var i = 0; i < args.length; ++i) {
	          if (args[i].computed) {
	            value[args[i].key(scope, locals, assign, inputs)] = args[i].value(scope, locals, assign, inputs);
	          } else {
	            value[args[i].key] = args[i].value(scope, locals, assign, inputs);
	          }
	        }
	        return context ? {value: value} : value;
	      };
	    case AST.ThisExpression:
	      return function(scope) {
	        return context ? {value: scope} : scope;
	      };
	    case AST.LocalsExpression:
	      return function(scope, locals) {
	        return context ? {value: locals} : locals;
	      };
	    case AST.NGValueParameter:
	      return function(scope, locals, assign) {
	        return context ? {value: assign} : assign;
	      };
	    }
	  },
	
	  'unary+': function(argument, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = argument(scope, locals, assign, inputs);
	      if (isDefined(arg)) {
	        arg = +arg;
	      } else {
	        arg = 0;
	      }
	      return context ? {value: arg} : arg;
	    };
	  },
	  'unary-': function(argument, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = argument(scope, locals, assign, inputs);
	      if (isDefined(arg)) {
	        arg = -arg;
	      } else {
	        arg = 0;
	      }
	      return context ? {value: arg} : arg;
	    };
	  },
	  'unary!': function(argument, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = !argument(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary+': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var lhs = left(scope, locals, assign, inputs);
	      var rhs = right(scope, locals, assign, inputs);
	      var arg = plusFn(lhs, rhs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary-': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var lhs = left(scope, locals, assign, inputs);
	      var rhs = right(scope, locals, assign, inputs);
	      var arg = (isDefined(lhs) ? lhs : 0) - (isDefined(rhs) ? rhs : 0);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary*': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) * right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary/': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) / right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary%': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) % right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary===': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) === right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary!==': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) !== right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary==': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) == right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary!=': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) != right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary<': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) < right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary>': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) > right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary<=': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) <= right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary>=': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) >= right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary&&': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) && right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary||': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) || right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'ternary?:': function(test, alternate, consequent, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = test(scope, locals, assign, inputs) ? alternate(scope, locals, assign, inputs) : consequent(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  value: function(value, context) {
	    return function() { return context ? {context: undefined, name: undefined, value: value} : value; };
	  },
	  identifier: function(name, expensiveChecks, context, create, expression) {
	    return function(scope, locals, assign, inputs) {
	      var base = locals && (name in locals) ? locals : scope;
	      if (create && create !== 1 && base && !(base[name])) {
	        base[name] = {};
	      }
	      var value = base ? base[name] : undefined;
	      if (expensiveChecks) {
	        ensureSafeObject(value, expression);
	      }
	      if (context) {
	        return {context: base, name: name, value: value};
	      } else {
	        return value;
	      }
	    };
	  },
	  computedMember: function(left, right, context, create, expression) {
	    return function(scope, locals, assign, inputs) {
	      var lhs = left(scope, locals, assign, inputs);
	      var rhs;
	      var value;
	      if (lhs != null) {
	        rhs = right(scope, locals, assign, inputs);
	        rhs = getStringValue(rhs);
	        ensureSafeMemberName(rhs, expression);
	        if (create && create !== 1) {
	          ensureSafeAssignContext(lhs);
	          if (lhs && !(lhs[rhs])) {
	            lhs[rhs] = {};
	          }
	        }
	        value = lhs[rhs];
	        ensureSafeObject(value, expression);
	      }
	      if (context) {
	        return {context: lhs, name: rhs, value: value};
	      } else {
	        return value;
	      }
	    };
	  },
	  nonComputedMember: function(left, right, expensiveChecks, context, create, expression) {
	    return function(scope, locals, assign, inputs) {
	      var lhs = left(scope, locals, assign, inputs);
	      if (create && create !== 1) {
	        ensureSafeAssignContext(lhs);
	        if (lhs && !(lhs[right])) {
	          lhs[right] = {};
	        }
	      }
	      var value = lhs != null ? lhs[right] : undefined;
	      if (expensiveChecks || isPossiblyDangerousMemberName(right)) {
	        ensureSafeObject(value, expression);
	      }
	      if (context) {
	        return {context: lhs, name: right, value: value};
	      } else {
	        return value;
	      }
	    };
	  },
	  inputs: function(input, watchId) {
	    return function(scope, value, locals, inputs) {
	      if (inputs) return inputs[watchId];
	      return input(scope, value, locals);
	    };
	  }
	};
	
	/**
	 * @constructor
	 */
	var Parser = function(lexer, $filter, options) {
	  this.lexer = lexer;
	  this.$filter = $filter;
	  this.options = options;
	  this.ast = new AST(lexer, options);
	  this.astCompiler = options.csp ? new ASTInterpreter(this.ast, $filter) :
	                                   new ASTCompiler(this.ast, $filter);
	};
	
	Parser.prototype = {
	  constructor: Parser,
	
	  parse: function(text) {
	    return this.astCompiler.compile(text, this.options.expensiveChecks);
	  }
	};
	
	function isPossiblyDangerousMemberName(name) {
	  return name == 'constructor';
	}
	
	var objectValueOf = Object.prototype.valueOf;
	
	function getValueOf(value) {
	  return isFunction(value.valueOf) ? value.valueOf() : objectValueOf.call(value);
	}
	
	///////////////////////////////////
	
	/**
	 * @ngdoc service
	 * @name $parse
	 * @kind function
	 *
	 * @description
	 *
	 * Converts Angular {@link guide/expression expression} into a function.
	 *
	 * ```js
	 *   var getter = $parse('user.name');
	 *   var setter = getter.assign;
	 *   var context = {user:{name:'angular'}};
	 *   var locals = {user:{name:'local'}};
	 *
	 *   expect(getter(context)).toEqual('angular');
	 *   setter(context, 'newValue');
	 *   expect(context.user.name).toEqual('newValue');
	 *   expect(getter(context, locals)).toEqual('local');
	 * ```
	 *
	 *
	 * @param {string} expression String expression to compile.
	 * @returns {function(context, locals)} a function which represents the compiled expression:
	 *
	 *    * `context` – `{object}` – an object against which any expressions embedded in the strings
	 *      are evaluated against (typically a scope object).
	 *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
	 *      `context`.
	 *
	 *    The returned function also has the following properties:
	 *      * `literal` – `{boolean}` – whether the expression's top-level node is a JavaScript
	 *        literal.
	 *      * `constant` – `{boolean}` – whether the expression is made entirely of JavaScript
	 *        constant literals.
	 *      * `assign` – `{?function(context, value)}` – if the expression is assignable, this will be
	 *        set to a function to change its value on the given context.
	 *
	 */
	
	
	/**
	 * @ngdoc provider
	 * @name $parseProvider
	 *
	 * @description
	 * `$parseProvider` can be used for configuring the default behavior of the {@link ng.$parse $parse}
	 *  service.
	 */
	function $ParseProvider() {
	  var cacheDefault = createMap();
	  var cacheExpensive = createMap();
	  var literals = {
	    'true': true,
	    'false': false,
	    'null': null,
	    'undefined': undefined
	  };
	  var identStart, identContinue;
	
	  /**
	   * @ngdoc method
	   * @name $parseProvider#addLiteral
	   * @description
	   *
	   * Configure $parse service to add literal values that will be present as literal at expressions.
	   *
	   * @param {string} literalName Token for the literal value. The literal name value must be a valid literal name.
	   * @param {*} literalValue Value for this literal. All literal values must be primitives or `undefined`.
	   *
	   **/
	  this.addLiteral = function(literalName, literalValue) {
	    literals[literalName] = literalValue;
	  };
	
	 /**
	  * @ngdoc method
	  * @name $parseProvider#setIdentifierFns
	  * @description
	  *
	  * Allows defining the set of characters that are allowed in Angular expressions. The function
	  * `identifierStart` will get called to know if a given character is a valid character to be the
	  * first character for an identifier. The function `identifierContinue` will get called to know if
	  * a given character is a valid character to be a follow-up identifier character. The functions
	  * `identifierStart` and `identifierContinue` will receive as arguments the single character to be
	  * identifier and the character code point. These arguments will be `string` and `numeric`. Keep in
	  * mind that the `string` parameter can be two characters long depending on the character
	  * representation. It is expected for the function to return `true` or `false`, whether that
	  * character is allowed or not.
	  *
	  * Since this function will be called extensivelly, keep the implementation of these functions fast,
	  * as the performance of these functions have a direct impact on the expressions parsing speed.
	  *
	  * @param {function=} identifierStart The function that will decide whether the given character is
	  *   a valid identifier start character.
	  * @param {function=} identifierContinue The function that will decide whether the given character is
	  *   a valid identifier continue character.
	  */
	  this.setIdentifierFns = function(identifierStart, identifierContinue) {
	    identStart = identifierStart;
	    identContinue = identifierContinue;
	    return this;
	  };
	
	  this.$get = ['$filter', function($filter) {
	    var noUnsafeEval = csp().noUnsafeEval;
	    var $parseOptions = {
	          csp: noUnsafeEval,
	          expensiveChecks: false,
	          literals: copy(literals),
	          isIdentifierStart: isFunction(identStart) && identStart,
	          isIdentifierContinue: isFunction(identContinue) && identContinue
	        },
	        $parseOptionsExpensive = {
	          csp: noUnsafeEval,
	          expensiveChecks: true,
	          literals: copy(literals),
	          isIdentifierStart: isFunction(identStart) && identStart,
	          isIdentifierContinue: isFunction(identContinue) && identContinue
	        };
	    var runningChecksEnabled = false;
	
	    $parse.$$runningExpensiveChecks = function() {
	      return runningChecksEnabled;
	    };
	
	    return $parse;
	
	    function $parse(exp, interceptorFn, expensiveChecks) {
	      var parsedExpression, oneTime, cacheKey;
	
	      expensiveChecks = expensiveChecks || runningChecksEnabled;
	
	      switch (typeof exp) {
	        case 'string':
	          exp = exp.trim();
	          cacheKey = exp;
	
	          var cache = (expensiveChecks ? cacheExpensive : cacheDefault);
	          parsedExpression = cache[cacheKey];
	
	          if (!parsedExpression) {
	            if (exp.charAt(0) === ':' && exp.charAt(1) === ':') {
	              oneTime = true;
	              exp = exp.substring(2);
	            }
	            var parseOptions = expensiveChecks ? $parseOptionsExpensive : $parseOptions;
	            var lexer = new Lexer(parseOptions);
	            var parser = new Parser(lexer, $filter, parseOptions);
	            parsedExpression = parser.parse(exp);
	            if (parsedExpression.constant) {
	              parsedExpression.$$watchDelegate = constantWatchDelegate;
	            } else if (oneTime) {
	              parsedExpression.$$watchDelegate = parsedExpression.literal ?
	                  oneTimeLiteralWatchDelegate : oneTimeWatchDelegate;
	            } else if (parsedExpression.inputs) {
	              parsedExpression.$$watchDelegate = inputsWatchDelegate;
	            }
	            if (expensiveChecks) {
	              parsedExpression = expensiveChecksInterceptor(parsedExpression);
	            }
	            cache[cacheKey] = parsedExpression;
	          }
	          return addInterceptor(parsedExpression, interceptorFn);
	
	        case 'function':
	          return addInterceptor(exp, interceptorFn);
	
	        default:
	          return addInterceptor(noop, interceptorFn);
	      }
	    }
	
	    function expensiveChecksInterceptor(fn) {
	      if (!fn) return fn;
	      expensiveCheckFn.$$watchDelegate = fn.$$watchDelegate;
	      expensiveCheckFn.assign = expensiveChecksInterceptor(fn.assign);
	      expensiveCheckFn.constant = fn.constant;
	      expensiveCheckFn.literal = fn.literal;
	      for (var i = 0; fn.inputs && i < fn.inputs.length; ++i) {
	        fn.inputs[i] = expensiveChecksInterceptor(fn.inputs[i]);
	      }
	      expensiveCheckFn.inputs = fn.inputs;
	
	      return expensiveCheckFn;
	
	      function expensiveCheckFn(scope, locals, assign, inputs) {
	        var expensiveCheckOldValue = runningChecksEnabled;
	        runningChecksEnabled = true;
	        try {
	          return fn(scope, locals, assign, inputs);
	        } finally {
	          runningChecksEnabled = expensiveCheckOldValue;
	        }
	      }
	    }
	
	    function expressionInputDirtyCheck(newValue, oldValueOfValue) {
	
	      if (newValue == null || oldValueOfValue == null) { // null/undefined
	        return newValue === oldValueOfValue;
	      }
	
	      if (typeof newValue === 'object') {
	
	        // attempt to convert the value to a primitive type
	        // TODO(docs): add a note to docs that by implementing valueOf even objects and arrays can
	        //             be cheaply dirty-checked
	        newValue = getValueOf(newValue);
	
	        if (typeof newValue === 'object') {
	          // objects/arrays are not supported - deep-watching them would be too expensive
	          return false;
	        }
	
	        // fall-through to the primitive equality check
	      }
	
	      //Primitive or NaN
	      return newValue === oldValueOfValue || (newValue !== newValue && oldValueOfValue !== oldValueOfValue);
	    }
	
	    function inputsWatchDelegate(scope, listener, objectEquality, parsedExpression, prettyPrintExpression) {
	      var inputExpressions = parsedExpression.inputs;
	      var lastResult;
	
	      if (inputExpressions.length === 1) {
	        var oldInputValueOf = expressionInputDirtyCheck; // init to something unique so that equals check fails
	        inputExpressions = inputExpressions[0];
	        return scope.$watch(function expressionInputWatch(scope) {
	          var newInputValue = inputExpressions(scope);
	          if (!expressionInputDirtyCheck(newInputValue, oldInputValueOf)) {
	            lastResult = parsedExpression(scope, undefined, undefined, [newInputValue]);
	            oldInputValueOf = newInputValue && getValueOf(newInputValue);
	          }
	          return lastResult;
	        }, listener, objectEquality, prettyPrintExpression);
	      }
	
	      var oldInputValueOfValues = [];
	      var oldInputValues = [];
	      for (var i = 0, ii = inputExpressions.length; i < ii; i++) {
	        oldInputValueOfValues[i] = expressionInputDirtyCheck; // init to something unique so that equals check fails
	        oldInputValues[i] = null;
	      }
	
	      return scope.$watch(function expressionInputsWatch(scope) {
	        var changed = false;
	
	        for (var i = 0, ii = inputExpressions.length; i < ii; i++) {
	          var newInputValue = inputExpressions[i](scope);
	          if (changed || (changed = !expressionInputDirtyCheck(newInputValue, oldInputValueOfValues[i]))) {
	            oldInputValues[i] = newInputValue;
	            oldInputValueOfValues[i] = newInputValue && getValueOf(newInputValue);
	          }
	        }
	
	        if (changed) {
	          lastResult = parsedExpression(scope, undefined, undefined, oldInputValues);
	        }
	
	        return lastResult;
	      }, listener, objectEquality, prettyPrintExpression);
	    }
	
	    function oneTimeWatchDelegate(scope, listener, objectEquality, parsedExpression) {
	      var unwatch, lastValue;
	      return unwatch = scope.$watch(function oneTimeWatch(scope) {
	        return parsedExpression(scope);
	      }, function oneTimeListener(value, old, scope) {
	        lastValue = value;
	        if (isFunction(listener)) {
	          listener.apply(this, arguments);
	        }
	        if (isDefined(value)) {
	          scope.$$postDigest(function() {
	            if (isDefined(lastValue)) {
	              unwatch();
	            }
	          });
	        }
	      }, objectEquality);
	    }
	
	    function oneTimeLiteralWatchDelegate(scope, listener, objectEquality, parsedExpression) {
	      var unwatch, lastValue;
	      return unwatch = scope.$watch(function oneTimeWatch(scope) {
	        return parsedExpression(scope);
	      }, function oneTimeListener(value, old, scope) {
	        lastValue = value;
	        if (isFunction(listener)) {
	          listener.call(this, value, old, scope);
	        }
	        if (isAllDefined(value)) {
	          scope.$$postDigest(function() {
	            if (isAllDefined(lastValue)) unwatch();
	          });
	        }
	      }, objectEquality);
	
	      function isAllDefined(value) {
	        var allDefined = true;
	        forEach(value, function(val) {
	          if (!isDefined(val)) allDefined = false;
	        });
	        return allDefined;
	      }
	    }
	
	    function constantWatchDelegate(scope, listener, objectEquality, parsedExpression) {
	      var unwatch;
	      return unwatch = scope.$watch(function constantWatch(scope) {
	        unwatch();
	        return parsedExpression(scope);
	      }, listener, objectEquality);
	    }
	
	    function addInterceptor(parsedExpression, interceptorFn) {
	      if (!interceptorFn) return parsedExpression;
	      var watchDelegate = parsedExpression.$$watchDelegate;
	      var useInputs = false;
	
	      var regularWatch =
	          watchDelegate !== oneTimeLiteralWatchDelegate &&
	          watchDelegate !== oneTimeWatchDelegate;
	
	      var fn = regularWatch ? function regularInterceptedExpression(scope, locals, assign, inputs) {
	        var value = useInputs && inputs ? inputs[0] : parsedExpression(scope, locals, assign, inputs);
	        return interceptorFn(value, scope, locals);
	      } : function oneTimeInterceptedExpression(scope, locals, assign, inputs) {
	        var value = parsedExpression(scope, locals, assign, inputs);
	        var result = interceptorFn(value, scope, locals);
	        // we only return the interceptor's result if the
	        // initial value is defined (for bind-once)
	        return isDefined(value) ? result : value;
	      };
	
	      // Propagate $$watchDelegates other then inputsWatchDelegate
	      if (parsedExpression.$$watchDelegate &&
	          parsedExpression.$$watchDelegate !== inputsWatchDelegate) {
	        fn.$$watchDelegate = parsedExpression.$$watchDelegate;
	      } else if (!interceptorFn.$stateful) {
	        // If there is an interceptor, but no watchDelegate then treat the interceptor like
	        // we treat filters - it is assumed to be a pure function unless flagged with $stateful
	        fn.$$watchDelegate = inputsWatchDelegate;
	        useInputs = !parsedExpression.inputs;
	        fn.inputs = parsedExpression.inputs ? parsedExpression.inputs : [parsedExpression];
	      }
	
	      return fn;
	    }
	  }];
	}
	
	/**
	 * @ngdoc service
	 * @name $q
	 * @requires $rootScope
	 *
	 * @description
	 * A service that helps you run functions asynchronously, and use their return values (or exceptions)
	 * when they are done processing.
	 *
	 * This is an implementation of promises/deferred objects inspired by
	 * [Kris Kowal's Q](https://github.com/kriskowal/q).
	 *
	 * $q can be used in two fashions --- one which is more similar to Kris Kowal's Q or jQuery's Deferred
	 * implementations, and the other which resembles ES6 (ES2015) promises to some degree.
	 *
	 * # $q constructor
	 *
	 * The streamlined ES6 style promise is essentially just using $q as a constructor which takes a `resolver`
	 * function as the first argument. This is similar to the native Promise implementation from ES6,
	 * see [MDN](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise).
	 *
	 * While the constructor-style use is supported, not all of the supporting methods from ES6 promises are
	 * available yet.
	 *
	 * It can be used like so:
	 *
	 * ```js
	 *   // for the purpose of this example let's assume that variables `$q` and `okToGreet`
	 *   // are available in the current lexical scope (they could have been injected or passed in).
	 *
	 *   function asyncGreet(name) {
	 *     // perform some asynchronous operation, resolve or reject the promise when appropriate.
	 *     return $q(function(resolve, reject) {
	 *       setTimeout(function() {
	 *         if (okToGreet(name)) {
	 *           resolve('Hello, ' + name + '!');
	 *         } else {
	 *           reject('Greeting ' + name + ' is not allowed.');
	 *         }
	 *       }, 1000);
	 *     });
	 *   }
	 *
	 *   var promise = asyncGreet('Robin Hood');
	 *   promise.then(function(greeting) {
	 *     alert('Success: ' + greeting);
	 *   }, function(reason) {
	 *     alert('Failed: ' + reason);
	 *   });
	 * ```
	 *
	 * Note: progress/notify callbacks are not currently supported via the ES6-style interface.
	 *
	 * Note: unlike ES6 behavior, an exception thrown in the constructor function will NOT implicitly reject the promise.
	 *
	 * However, the more traditional CommonJS-style usage is still available, and documented below.
	 *
	 * [The CommonJS Promise proposal](http://wiki.commonjs.org/wiki/Promises) describes a promise as an
	 * interface for interacting with an object that represents the result of an action that is
	 * performed asynchronously, and may or may not be finished at any given point in time.
	 *
	 * From the perspective of dealing with error handling, deferred and promise APIs are to
	 * asynchronous programming what `try`, `catch` and `throw` keywords are to synchronous programming.
	 *
	 * ```js
	 *   // for the purpose of this example let's assume that variables `$q` and `okToGreet`
	 *   // are available in the current lexical scope (they could have been injected or passed in).
	 *
	 *   function asyncGreet(name) {
	 *     var deferred = $q.defer();
	 *
	 *     setTimeout(function() {
	 *       deferred.notify('About to greet ' + name + '.');
	 *
	 *       if (okToGreet(name)) {
	 *         deferred.resolve('Hello, ' + name + '!');
	 *       } else {
	 *         deferred.reject('Greeting ' + name + ' is not allowed.');
	 *       }
	 *     }, 1000);
	 *
	 *     return deferred.promise;
	 *   }
	 *
	 *   var promise = asyncGreet('Robin Hood');
	 *   promise.then(function(greeting) {
	 *     alert('Success: ' + greeting);
	 *   }, function(reason) {
	 *     alert('Failed: ' + reason);
	 *   }, function(update) {
	 *     alert('Got notification: ' + update);
	 *   });
	 * ```
	 *
	 * At first it might not be obvious why this extra complexity is worth the trouble. The payoff
	 * comes in the way of guarantees that promise and deferred APIs make, see
	 * https://github.com/kriskowal/uncommonjs/blob/master/promises/specification.md.
	 *
	 * Additionally the promise api allows for composition that is very hard to do with the
	 * traditional callback ([CPS](http://en.wikipedia.org/wiki/Continuation-passing_style)) approach.
	 * For more on this please see the [Q documentation](https://github.com/kriskowal/q) especially the
	 * section on serial or parallel joining of promises.
	 *
	 * # The Deferred API
	 *
	 * A new instance of deferred is constructed by calling `$q.defer()`.
	 *
	 * The purpose of the deferred object is to expose the associated Promise instance as well as APIs
	 * that can be used for signaling the successful or unsuccessful completion, as well as the status
	 * of the task.
	 *
	 * **Methods**
	 *
	 * - `resolve(value)` – resolves the derived promise with the `value`. If the value is a rejection
	 *   constructed via `$q.reject`, the promise will be rejected instead.
	 * - `reject(reason)` – rejects the derived promise with the `reason`. This is equivalent to
	 *   resolving it with a rejection constructed via `$q.reject`.
	 * - `notify(value)` - provides updates on the status of the promise's execution. This may be called
	 *   multiple times before the promise is either resolved or rejected.
	 *
	 * **Properties**
	 *
	 * - promise – `{Promise}` – promise object associated with this deferred.
	 *
	 *
	 * # The Promise API
	 *
	 * A new promise instance is created when a deferred instance is created and can be retrieved by
	 * calling `deferred.promise`.
	 *
	 * The purpose of the promise object is to allow for interested parties to get access to the result
	 * of the deferred task when it completes.
	 *
	 * **Methods**
	 *
	 * - `then(successCallback, errorCallback, notifyCallback)` – regardless of when the promise was or
	 *   will be resolved or rejected, `then` calls one of the success or error callbacks asynchronously
	 *   as soon as the result is available. The callbacks are called with a single argument: the result
	 *   or rejection reason. Additionally, the notify callback may be called zero or more times to
	 *   provide a progress indication, before the promise is resolved or rejected.
	 *
	 *   This method *returns a new promise* which is resolved or rejected via the return value of the
	 *   `successCallback`, `errorCallback` (unless that value is a promise, in which case it is resolved
	 *   with the value which is resolved in that promise using
	 *   [promise chaining](http://www.html5rocks.com/en/tutorials/es6/promises/#toc-promises-queues)).
	 *   It also notifies via the return value of the `notifyCallback` method. The promise cannot be
	 *   resolved or rejected from the notifyCallback method.
	 *
	 * - `catch(errorCallback)` – shorthand for `promise.then(null, errorCallback)`
	 *
	 * - `finally(callback, notifyCallback)` – allows you to observe either the fulfillment or rejection of a promise,
	 *   but to do so without modifying the final value. This is useful to release resources or do some
	 *   clean-up that needs to be done whether the promise was rejected or resolved. See the [full
	 *   specification](https://github.com/kriskowal/q/wiki/API-Reference#promisefinallycallback) for
	 *   more information.
	 *
	 * # Chaining promises
	 *
	 * Because calling the `then` method of a promise returns a new derived promise, it is easily
	 * possible to create a chain of promises:
	 *
	 * ```js
	 *   promiseB = promiseA.then(function(result) {
	 *     return result + 1;
	 *   });
	 *
	 *   // promiseB will be resolved immediately after promiseA is resolved and its value
	 *   // will be the result of promiseA incremented by 1
	 * ```
	 *
	 * It is possible to create chains of any length and since a promise can be resolved with another
	 * promise (which will defer its resolution further), it is possible to pause/defer resolution of
	 * the promises at any point in the chain. This makes it possible to implement powerful APIs like
	 * $http's response interceptors.
	 *
	 *
	 * # Differences between Kris Kowal's Q and $q
	 *
	 *  There are two main differences:
	 *
	 * - $q is integrated with the {@link ng.$rootScope.Scope} Scope model observation
	 *   mechanism in angular, which means faster propagation of resolution or rejection into your
	 *   models and avoiding unnecessary browser repaints, which would result in flickering UI.
	 * - Q has many more features than $q, but that comes at a cost of bytes. $q is tiny, but contains
	 *   all the important functionality needed for common async tasks.
	 *
	 * # Testing
	 *
	 *  ```js
	 *    it('should simulate promise', inject(function($q, $rootScope) {
	 *      var deferred = $q.defer();
	 *      var promise = deferred.promise;
	 *      var resolvedValue;
	 *
	 *      promise.then(function(value) { resolvedValue = value; });
	 *      expect(resolvedValue).toBeUndefined();
	 *
	 *      // Simulate resolving of promise
	 *      deferred.resolve(123);
	 *      // Note that the 'then' function does not get called synchronously.
	 *      // This is because we want the promise API to always be async, whether or not
	 *      // it got called synchronously or asynchronously.
	 *      expect(resolvedValue).toBeUndefined();
	 *
	 *      // Propagate promise resolution to 'then' functions using $apply().
	 *      $rootScope.$apply();
	 *      expect(resolvedValue).toEqual(123);
	 *    }));
	 *  ```
	 *
	 * @param {function(function, function)} resolver Function which is responsible for resolving or
	 *   rejecting the newly created promise. The first parameter is a function which resolves the
	 *   promise, the second parameter is a function which rejects the promise.
	 *
	 * @returns {Promise} The newly created promise.
	 */
	function $QProvider() {
	
	  this.$get = ['$rootScope', '$exceptionHandler', function($rootScope, $exceptionHandler) {
	    return qFactory(function(callback) {
	      $rootScope.$evalAsync(callback);
	    }, $exceptionHandler);
	  }];
	}
	
	function $$QProvider() {
	  this.$get = ['$browser', '$exceptionHandler', function($browser, $exceptionHandler) {
	    return qFactory(function(callback) {
	      $browser.defer(callback);
	    }, $exceptionHandler);
	  }];
	}
	
	/**
	 * Constructs a promise manager.
	 *
	 * @param {function(function)} nextTick Function for executing functions in the next turn.
	 * @param {function(...*)} exceptionHandler Function into which unexpected exceptions are passed for
	 *     debugging purposes.
	 * @returns {object} Promise manager.
	 */
	function qFactory(nextTick, exceptionHandler) {
	  var $qMinErr = minErr('$q', TypeError);
	
	  /**
	   * @ngdoc method
	   * @name ng.$q#defer
	   * @kind function
	   *
	   * @description
	   * Creates a `Deferred` object which represents a task which will finish in the future.
	   *
	   * @returns {Deferred} Returns a new instance of deferred.
	   */
	  var defer = function() {
	    var d = new Deferred();
	    //Necessary to support unbound execution :/
	    d.resolve = simpleBind(d, d.resolve);
	    d.reject = simpleBind(d, d.reject);
	    d.notify = simpleBind(d, d.notify);
	    return d;
	  };
	
	  function Promise() {
	    this.$$state = { status: 0 };
	  }
	
	  extend(Promise.prototype, {
	    then: function(onFulfilled, onRejected, progressBack) {
	      if (isUndefined(onFulfilled) && isUndefined(onRejected) && isUndefined(progressBack)) {
	        return this;
	      }
	      var result = new Deferred();
	
	      this.$$state.pending = this.$$state.pending || [];
	      this.$$state.pending.push([result, onFulfilled, onRejected, progressBack]);
	      if (this.$$state.status > 0) scheduleProcessQueue(this.$$state);
	
	      return result.promise;
	    },
	
	    "catch": function(callback) {
	      return this.then(null, callback);
	    },
	
	    "finally": function(callback, progressBack) {
	      return this.then(function(value) {
	        return handleCallback(value, true, callback);
	      }, function(error) {
	        return handleCallback(error, false, callback);
	      }, progressBack);
	    }
	  });
	
	  //Faster, more basic than angular.bind http://jsperf.com/angular-bind-vs-custom-vs-native
	  function simpleBind(context, fn) {
	    return function(value) {
	      fn.call(context, value);
	    };
	  }
	
	  function processQueue(state) {
	    var fn, deferred, pending;
	
	    pending = state.pending;
	    state.processScheduled = false;
	    state.pending = undefined;
	    for (var i = 0, ii = pending.length; i < ii; ++i) {
	      deferred = pending[i][0];
	      fn = pending[i][state.status];
	      try {
	        if (isFunction(fn)) {
	          deferred.resolve(fn(state.value));
	        } else if (state.status === 1) {
	          deferred.resolve(state.value);
	        } else {
	          deferred.reject(state.value);
	        }
	      } catch (e) {
	        deferred.reject(e);
	        exceptionHandler(e);
	      }
	    }
	  }
	
	  function scheduleProcessQueue(state) {
	    if (state.processScheduled || !state.pending) return;
	    state.processScheduled = true;
	    nextTick(function() { processQueue(state); });
	  }
	
	  function Deferred() {
	    this.promise = new Promise();
	  }
	
	  extend(Deferred.prototype, {
	    resolve: function(val) {
	      if (this.promise.$$state.status) return;
	      if (val === this.promise) {
	        this.$$reject($qMinErr(
	          'qcycle',
	          "Expected promise to be resolved with value other than itself '{0}'",
	          val));
	      } else {
	        this.$$resolve(val);
	      }
	
	    },
	
	    $$resolve: function(val) {
	      var then;
	      var that = this;
	      var done = false;
	      try {
	        if ((isObject(val) || isFunction(val))) then = val && val.then;
	        if (isFunction(then)) {
	          this.promise.$$state.status = -1;
	          then.call(val, resolvePromise, rejectPromise, simpleBind(this, this.notify));
	        } else {
	          this.promise.$$state.value = val;
	          this.promise.$$state.status = 1;
	          scheduleProcessQueue(this.promise.$$state);
	        }
	      } catch (e) {
	        rejectPromise(e);
	        exceptionHandler(e);
	      }
	
	      function resolvePromise(val) {
	        if (done) return;
	        done = true;
	        that.$$resolve(val);
	      }
	      function rejectPromise(val) {
	        if (done) return;
	        done = true;
	        that.$$reject(val);
	      }
	    },
	
	    reject: function(reason) {
	      if (this.promise.$$state.status) return;
	      this.$$reject(reason);
	    },
	
	    $$reject: function(reason) {
	      this.promise.$$state.value = reason;
	      this.promise.$$state.status = 2;
	      scheduleProcessQueue(this.promise.$$state);
	    },
	
	    notify: function(progress) {
	      var callbacks = this.promise.$$state.pending;
	
	      if ((this.promise.$$state.status <= 0) && callbacks && callbacks.length) {
	        nextTick(function() {
	          var callback, result;
	          for (var i = 0, ii = callbacks.length; i < ii; i++) {
	            result = callbacks[i][0];
	            callback = callbacks[i][3];
	            try {
	              result.notify(isFunction(callback) ? callback(progress) : progress);
	            } catch (e) {
	              exceptionHandler(e);
	            }
	          }
	        });
	      }
	    }
	  });
	
	  /**
	   * @ngdoc method
	   * @name $q#reject
	   * @kind function
	   *
	   * @description
	   * Creates a promise that is resolved as rejected with the specified `reason`. This api should be
	   * used to forward rejection in a chain of promises. If you are dealing with the last promise in
	   * a promise chain, you don't need to worry about it.
	   *
	   * When comparing deferreds/promises to the familiar behavior of try/catch/throw, think of
	   * `reject` as the `throw` keyword in JavaScript. This also means that if you "catch" an error via
	   * a promise error callback and you want to forward the error to the promise derived from the
	   * current promise, you have to "rethrow" the error by returning a rejection constructed via
	   * `reject`.
	   *
	   * ```js
	   *   promiseB = promiseA.then(function(result) {
	   *     // success: do something and resolve promiseB
	   *     //          with the old or a new result
	   *     return result;
	   *   }, function(reason) {
	   *     // error: handle the error if possible and
	   *     //        resolve promiseB with newPromiseOrValue,
	   *     //        otherwise forward the rejection to promiseB
	   *     if (canHandle(reason)) {
	   *      // handle the error and recover
	   *      return newPromiseOrValue;
	   *     }
	   *     return $q.reject(reason);
	   *   });
	   * ```
	   *
	   * @param {*} reason Constant, message, exception or an object representing the rejection reason.
	   * @returns {Promise} Returns a promise that was already resolved as rejected with the `reason`.
	   */
	  var reject = function(reason) {
	    var result = new Deferred();
	    result.reject(reason);
	    return result.promise;
	  };
	
	  var makePromise = function makePromise(value, resolved) {
	    var result = new Deferred();
	    if (resolved) {
	      result.resolve(value);
	    } else {
	      result.reject(value);
	    }
	    return result.promise;
	  };
	
	  var handleCallback = function handleCallback(value, isResolved, callback) {
	    var callbackOutput = null;
	    try {
	      if (isFunction(callback)) callbackOutput = callback();
	    } catch (e) {
	      return makePromise(e, false);
	    }
	    if (isPromiseLike(callbackOutput)) {
	      return callbackOutput.then(function() {
	        return makePromise(value, isResolved);
	      }, function(error) {
	        return makePromise(error, false);
	      });
	    } else {
	      return makePromise(value, isResolved);
	    }
	  };
	
	  /**
	   * @ngdoc method
	   * @name $q#when
	   * @kind function
	   *
	   * @description
	   * Wraps an object that might be a value or a (3rd party) then-able promise into a $q promise.
	   * This is useful when you are dealing with an object that might or might not be a promise, or if
	   * the promise comes from a source that can't be trusted.
	   *
	   * @param {*} value Value or a promise
	   * @param {Function=} successCallback
	   * @param {Function=} errorCallback
	   * @param {Function=} progressCallback
	   * @returns {Promise} Returns a promise of the passed value or promise
	   */
	
	
	  var when = function(value, callback, errback, progressBack) {
	    var result = new Deferred();
	    result.resolve(value);
	    return result.promise.then(callback, errback, progressBack);
	  };
	
	  /**
	   * @ngdoc method
	   * @name $q#resolve
	   * @kind function
	   *
	   * @description
	   * Alias of {@link ng.$q#when when} to maintain naming consistency with ES6.
	   *
	   * @param {*} value Value or a promise
	   * @param {Function=} successCallback
	   * @param {Function=} errorCallback
	   * @param {Function=} progressCallback
	   * @returns {Promise} Returns a promise of the passed value or promise
	   */
	  var resolve = when;
	
	  /**
	   * @ngdoc method
	   * @name $q#all
	   * @kind function
	   *
	   * @description
	   * Combines multiple promises into a single promise that is resolved when all of the input
	   * promises are resolved.
	   *
	   * @param {Array.<Promise>|Object.<Promise>} promises An array or hash of promises.
	   * @returns {Promise} Returns a single promise that will be resolved with an array/hash of values,
	   *   each value corresponding to the promise at the same index/key in the `promises` array/hash.
	   *   If any of the promises is resolved with a rejection, this resulting promise will be rejected
	   *   with the same rejection value.
	   */
	
	  function all(promises) {
	    var deferred = new Deferred(),
	        counter = 0,
	        results = isArray(promises) ? [] : {};
	
	    forEach(promises, function(promise, key) {
	      counter++;
	      when(promise).then(function(value) {
	        if (results.hasOwnProperty(key)) return;
	        results[key] = value;
	        if (!(--counter)) deferred.resolve(results);
	      }, function(reason) {
	        if (results.hasOwnProperty(key)) return;
	        deferred.reject(reason);
	      });
	    });
	
	    if (counter === 0) {
	      deferred.resolve(results);
	    }
	
	    return deferred.promise;
	  }
	
	  var $Q = function Q(resolver) {
	    if (!isFunction(resolver)) {
	      throw $qMinErr('norslvr', "Expected resolverFn, got '{0}'", resolver);
	    }
	
	    var deferred = new Deferred();
	
	    function resolveFn(value) {
	      deferred.resolve(value);
	    }
	
	    function rejectFn(reason) {
	      deferred.reject(reason);
	    }
	
	    resolver(resolveFn, rejectFn);
	
	    return deferred.promise;
	  };
	
	  // Let's make the instanceof operator work for promises, so that
	  // `new $q(fn) instanceof $q` would evaluate to true.
	  $Q.prototype = Promise.prototype;
	
	  $Q.defer = defer;
	  $Q.reject = reject;
	  $Q.when = when;
	  $Q.resolve = resolve;
	  $Q.all = all;
	
	  return $Q;
	}
	
	function $$RAFProvider() { //rAF
	  this.$get = ['$window', '$timeout', function($window, $timeout) {
	    var requestAnimationFrame = $window.requestAnimationFrame ||
	                                $window.webkitRequestAnimationFrame;
	
	    var cancelAnimationFrame = $window.cancelAnimationFrame ||
	                               $window.webkitCancelAnimationFrame ||
	                               $window.webkitCancelRequestAnimationFrame;
	
	    var rafSupported = !!requestAnimationFrame;
	    var raf = rafSupported
	      ? function(fn) {
	          var id = requestAnimationFrame(fn);
	          return function() {
	            cancelAnimationFrame(id);
	          };
	        }
	      : function(fn) {
	          var timer = $timeout(fn, 16.66, false); // 1000 / 60 = 16.666
	          return function() {
	            $timeout.cancel(timer);
	          };
	        };
	
	    raf.supported = rafSupported;
	
	    return raf;
	  }];
	}
	
	/**
	 * DESIGN NOTES
	 *
	 * The design decisions behind the scope are heavily favored for speed and memory consumption.
	 *
	 * The typical use of scope is to watch the expressions, which most of the time return the same
	 * value as last time so we optimize the operation.
	 *
	 * Closures construction is expensive in terms of speed as well as memory:
	 *   - No closures, instead use prototypical inheritance for API
	 *   - Internal state needs to be stored on scope directly, which means that private state is
	 *     exposed as $$____ properties
	 *
	 * Loop operations are optimized by using while(count--) { ... }
	 *   - This means that in order to keep the same order of execution as addition we have to add
	 *     items to the array at the beginning (unshift) instead of at the end (push)
	 *
	 * Child scopes are created and removed often
	 *   - Using an array would be slow since inserts in the middle are expensive; so we use linked lists
	 *
	 * There are fewer watches than observers. This is why you don't want the observer to be implemented
	 * in the same way as watch. Watch requires return of the initialization function which is expensive
	 * to construct.
	 */
	
	
	/**
	 * @ngdoc provider
	 * @name $rootScopeProvider
	 * @description
	 *
	 * Provider for the $rootScope service.
	 */
	
	/**
	 * @ngdoc method
	 * @name $rootScopeProvider#digestTtl
	 * @description
	 *
	 * Sets the number of `$digest` iterations the scope should attempt to execute before giving up and
	 * assuming that the model is unstable.
	 *
	 * The current default is 10 iterations.
	 *
	 * In complex applications it's possible that the dependencies between `$watch`s will result in
	 * several digest iterations. However if an application needs more than the default 10 digest
	 * iterations for its model to stabilize then you should investigate what is causing the model to
	 * continuously change during the digest.
	 *
	 * Increasing the TTL could have performance implications, so you should not change it without
	 * proper justification.
	 *
	 * @param {number} limit The number of digest iterations.
	 */
	
	
	/**
	 * @ngdoc service
	 * @name $rootScope
	 * @description
	 *
	 * Every application has a single root {@link ng.$rootScope.Scope scope}.
	 * All other scopes are descendant scopes of the root scope. Scopes provide separation
	 * between the model and the view, via a mechanism for watching the model for changes.
	 * They also provide event emission/broadcast and subscription facility. See the
	 * {@link guide/scope developer guide on scopes}.
	 */
	function $RootScopeProvider() {
	  var TTL = 10;
	  var $rootScopeMinErr = minErr('$rootScope');
	  var lastDirtyWatch = null;
	  var applyAsyncId = null;
	
	  this.digestTtl = function(value) {
	    if (arguments.length) {
	      TTL = value;
	    }
	    return TTL;
	  };
	
	  function createChildScopeClass(parent) {
	    function ChildScope() {
	      this.$$watchers = this.$$nextSibling =
	          this.$$childHead = this.$$childTail = null;
	      this.$$listeners = {};
	      this.$$listenerCount = {};
	      this.$$watchersCount = 0;
	      this.$id = nextUid();
	      this.$$ChildScope = null;
	    }
	    ChildScope.prototype = parent;
	    return ChildScope;
	  }
	
	  this.$get = ['$exceptionHandler', '$parse', '$browser',
	      function($exceptionHandler, $parse, $browser) {
	
	    function destroyChildScope($event) {
	        $event.currentScope.$$destroyed = true;
	    }
	
	    function cleanUpScope($scope) {
	
	      if (msie === 9) {
	        // There is a memory leak in IE9 if all child scopes are not disconnected
	        // completely when a scope is destroyed. So this code will recurse up through
	        // all this scopes children
	        //
	        // See issue https://github.com/angular/angular.js/issues/10706
	        $scope.$$childHead && cleanUpScope($scope.$$childHead);
	        $scope.$$nextSibling && cleanUpScope($scope.$$nextSibling);
	      }
	
	      // The code below works around IE9 and V8's memory leaks
	      //
	      // See:
	      // - https://code.google.com/p/v8/issues/detail?id=2073#c26
	      // - https://github.com/angular/angular.js/issues/6794#issuecomment-38648909
	      // - https://github.com/angular/angular.js/issues/1313#issuecomment-10378451
	
	      $scope.$parent = $scope.$$nextSibling = $scope.$$prevSibling = $scope.$$childHead =
	          $scope.$$childTail = $scope.$root = $scope.$$watchers = null;
	    }
	
	    /**
	     * @ngdoc type
	     * @name $rootScope.Scope
	     *
	     * @description
	     * A root scope can be retrieved using the {@link ng.$rootScope $rootScope} key from the
	     * {@link auto.$injector $injector}. Child scopes are created using the
	     * {@link ng.$rootScope.Scope#$new $new()} method. (Most scopes are created automatically when
	     * compiled HTML template is executed.) See also the {@link guide/scope Scopes guide} for
	     * an in-depth introduction and usage examples.
	     *
	     *
	     * # Inheritance
	     * A scope can inherit from a parent scope, as in this example:
	     * ```js
	         var parent = $rootScope;
	         var child = parent.$new();
	
	         parent.salutation = "Hello";
	         expect(child.salutation).toEqual('Hello');
	
	         child.salutation = "Welcome";
	         expect(child.salutation).toEqual('Welcome');
	         expect(parent.salutation).toEqual('Hello');
	     * ```
	     *
	     * When interacting with `Scope` in tests, additional helper methods are available on the
	     * instances of `Scope` type. See {@link ngMock.$rootScope.Scope ngMock Scope} for additional
	     * details.
	     *
	     *
	     * @param {Object.<string, function()>=} providers Map of service factory which need to be
	     *                                       provided for the current scope. Defaults to {@link ng}.
	     * @param {Object.<string, *>=} instanceCache Provides pre-instantiated services which should
	     *                              append/override services provided by `providers`. This is handy
	     *                              when unit-testing and having the need to override a default
	     *                              service.
	     * @returns {Object} Newly created scope.
	     *
	     */
	    function Scope() {
	      this.$id = nextUid();
	      this.$$phase = this.$parent = this.$$watchers =
	                     this.$$nextSibling = this.$$prevSibling =
	                     this.$$childHead = this.$$childTail = null;
	      this.$root = this;
	      this.$$destroyed = false;
	      this.$$listeners = {};
	      this.$$listenerCount = {};
	      this.$$watchersCount = 0;
	      this.$$isolateBindings = null;
	    }
	
	    /**
	     * @ngdoc property
	     * @name $rootScope.Scope#$id
	     *
	     * @description
	     * Unique scope ID (monotonically increasing) useful for debugging.
	     */
	
	     /**
	      * @ngdoc property
	      * @name $rootScope.Scope#$parent
	      *
	      * @description
	      * Reference to the parent scope.
	      */
	
	      /**
	       * @ngdoc property
	       * @name $rootScope.Scope#$root
	       *
	       * @description
	       * Reference to the root scope.
	       */
	
	    Scope.prototype = {
	      constructor: Scope,
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$new
	       * @kind function
	       *
	       * @description
	       * Creates a new child {@link ng.$rootScope.Scope scope}.
	       *
	       * The parent scope will propagate the {@link ng.$rootScope.Scope#$digest $digest()} event.
	       * The scope can be removed from the scope hierarchy using {@link ng.$rootScope.Scope#$destroy $destroy()}.
	       *
	       * {@link ng.$rootScope.Scope#$destroy $destroy()} must be called on a scope when it is
	       * desired for the scope and its child scopes to be permanently detached from the parent and
	       * thus stop participating in model change detection and listener notification by invoking.
	       *
	       * @param {boolean} isolate If true, then the scope does not prototypically inherit from the
	       *         parent scope. The scope is isolated, as it can not see parent scope properties.
	       *         When creating widgets, it is useful for the widget to not accidentally read parent
	       *         state.
	       *
	       * @param {Scope} [parent=this] The {@link ng.$rootScope.Scope `Scope`} that will be the `$parent`
	       *                              of the newly created scope. Defaults to `this` scope if not provided.
	       *                              This is used when creating a transclude scope to correctly place it
	       *                              in the scope hierarchy while maintaining the correct prototypical
	       *                              inheritance.
	       *
	       * @returns {Object} The newly created child scope.
	       *
	       */
	      $new: function(isolate, parent) {
	        var child;
	
	        parent = parent || this;
	
	        if (isolate) {
	          child = new Scope();
	          child.$root = this.$root;
	        } else {
	          // Only create a child scope class if somebody asks for one,
	          // but cache it to allow the VM to optimize lookups.
	          if (!this.$$ChildScope) {
	            this.$$ChildScope = createChildScopeClass(this);
	          }
	          child = new this.$$ChildScope();
	        }
	        child.$parent = parent;
	        child.$$prevSibling = parent.$$childTail;
	        if (parent.$$childHead) {
	          parent.$$childTail.$$nextSibling = child;
	          parent.$$childTail = child;
	        } else {
	          parent.$$childHead = parent.$$childTail = child;
	        }
	
	        // When the new scope is not isolated or we inherit from `this`, and
	        // the parent scope is destroyed, the property `$$destroyed` is inherited
	        // prototypically. In all other cases, this property needs to be set
	        // when the parent scope is destroyed.
	        // The listener needs to be added after the parent is set
	        if (isolate || parent != this) child.$on('$destroy', destroyChildScope);
	
	        return child;
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$watch
	       * @kind function
	       *
	       * @description
	       * Registers a `listener` callback to be executed whenever the `watchExpression` changes.
	       *
	       * - The `watchExpression` is called on every call to {@link ng.$rootScope.Scope#$digest
	       *   $digest()} and should return the value that will be watched. (`watchExpression` should not change
	       *   its value when executed multiple times with the same input because it may be executed multiple
	       *   times by {@link ng.$rootScope.Scope#$digest $digest()}. That is, `watchExpression` should be
	       *   [idempotent](http://en.wikipedia.org/wiki/Idempotence).
	       * - The `listener` is called only when the value from the current `watchExpression` and the
	       *   previous call to `watchExpression` are not equal (with the exception of the initial run,
	       *   see below). Inequality is determined according to reference inequality,
	       *   [strict comparison](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Comparison_Operators)
	       *    via the `!==` Javascript operator, unless `objectEquality == true`
	       *   (see next point)
	       * - When `objectEquality == true`, inequality of the `watchExpression` is determined
	       *   according to the {@link angular.equals} function. To save the value of the object for
	       *   later comparison, the {@link angular.copy} function is used. This therefore means that
	       *   watching complex objects will have adverse memory and performance implications.
	       * - The watch `listener` may change the model, which may trigger other `listener`s to fire.
	       *   This is achieved by rerunning the watchers until no changes are detected. The rerun
	       *   iteration limit is 10 to prevent an infinite loop deadlock.
	       *
	       *
	       * If you want to be notified whenever {@link ng.$rootScope.Scope#$digest $digest} is called,
	       * you can register a `watchExpression` function with no `listener`. (Be prepared for
	       * multiple calls to your `watchExpression` because it will execute multiple times in a
	       * single {@link ng.$rootScope.Scope#$digest $digest} cycle if a change is detected.)
	       *
	       * After a watcher is registered with the scope, the `listener` fn is called asynchronously
	       * (via {@link ng.$rootScope.Scope#$evalAsync $evalAsync}) to initialize the
	       * watcher. In rare cases, this is undesirable because the listener is called when the result
	       * of `watchExpression` didn't change. To detect this scenario within the `listener` fn, you
	       * can compare the `newVal` and `oldVal`. If these two values are identical (`===`) then the
	       * listener was called due to initialization.
	       *
	       *
	       *
	       * # Example
	       * ```js
	           // let's assume that scope was dependency injected as the $rootScope
	           var scope = $rootScope;
	           scope.name = 'misko';
	           scope.counter = 0;
	
	           expect(scope.counter).toEqual(0);
	           scope.$watch('name', function(newValue, oldValue) {
	             scope.counter = scope.counter + 1;
	           });
	           expect(scope.counter).toEqual(0);
	
	           scope.$digest();
	           // the listener is always called during the first $digest loop after it was registered
	           expect(scope.counter).toEqual(1);
	
	           scope.$digest();
	           // but now it will not be called unless the value changes
	           expect(scope.counter).toEqual(1);
	
	           scope.name = 'adam';
	           scope.$digest();
	           expect(scope.counter).toEqual(2);
	
	
	
	           // Using a function as a watchExpression
	           var food;
	           scope.foodCounter = 0;
	           expect(scope.foodCounter).toEqual(0);
	           scope.$watch(
	             // This function returns the value being watched. It is called for each turn of the $digest loop
	             function() { return food; },
	             // This is the change listener, called when the value returned from the above function changes
	             function(newValue, oldValue) {
	               if ( newValue !== oldValue ) {
	                 // Only increment the counter if the value changed
	                 scope.foodCounter = scope.foodCounter + 1;
	               }
	             }
	           );
	           // No digest has been run so the counter will be zero
	           expect(scope.foodCounter).toEqual(0);
	
	           // Run the digest but since food has not changed count will still be zero
	           scope.$digest();
	           expect(scope.foodCounter).toEqual(0);
	
	           // Update food and run digest.  Now the counter will increment
	           food = 'cheeseburger';
	           scope.$digest();
	           expect(scope.foodCounter).toEqual(1);
	
	       * ```
	       *
	       *
	       *
	       * @param {(function()|string)} watchExpression Expression that is evaluated on each
	       *    {@link ng.$rootScope.Scope#$digest $digest} cycle. A change in the return value triggers
	       *    a call to the `listener`.
	       *
	       *    - `string`: Evaluated as {@link guide/expression expression}
	       *    - `function(scope)`: called with current `scope` as a parameter.
	       * @param {function(newVal, oldVal, scope)} listener Callback called whenever the value
	       *    of `watchExpression` changes.
	       *
	       *    - `newVal` contains the current value of the `watchExpression`
	       *    - `oldVal` contains the previous value of the `watchExpression`
	       *    - `scope` refers to the current scope
	       * @param {boolean=} [objectEquality=false] Compare for object equality using {@link angular.equals} instead of
	       *     comparing for reference equality.
	       * @returns {function()} Returns a deregistration function for this listener.
	       */
	      $watch: function(watchExp, listener, objectEquality, prettyPrintExpression) {
	        var get = $parse(watchExp);
	
	        if (get.$$watchDelegate) {
	          return get.$$watchDelegate(this, listener, objectEquality, get, watchExp);
	        }
	        var scope = this,
	            array = scope.$$watchers,
	            watcher = {
	              fn: listener,
	              last: initWatchVal,
	              get: get,
	              exp: prettyPrintExpression || watchExp,
	              eq: !!objectEquality
	            };
	
	        lastDirtyWatch = null;
	
	        if (!isFunction(listener)) {
	          watcher.fn = noop;
	        }
	
	        if (!array) {
	          array = scope.$$watchers = [];
	        }
	        // we use unshift since we use a while loop in $digest for speed.
	        // the while loop reads in reverse order.
	        array.unshift(watcher);
	        incrementWatchersCount(this, 1);
	
	        return function deregisterWatch() {
	          if (arrayRemove(array, watcher) >= 0) {
	            incrementWatchersCount(scope, -1);
	          }
	          lastDirtyWatch = null;
	        };
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$watchGroup
	       * @kind function
	       *
	       * @description
	       * A variant of {@link ng.$rootScope.Scope#$watch $watch()} where it watches an array of `watchExpressions`.
	       * If any one expression in the collection changes the `listener` is executed.
	       *
	       * - The items in the `watchExpressions` array are observed via standard $watch operation and are examined on every
	       *   call to $digest() to see if any items changes.
	       * - The `listener` is called whenever any expression in the `watchExpressions` array changes.
	       *
	       * @param {Array.<string|Function(scope)>} watchExpressions Array of expressions that will be individually
	       * watched using {@link ng.$rootScope.Scope#$watch $watch()}
	       *
	       * @param {function(newValues, oldValues, scope)} listener Callback called whenever the return value of any
	       *    expression in `watchExpressions` changes
	       *    The `newValues` array contains the current values of the `watchExpressions`, with the indexes matching
	       *    those of `watchExpression`
	       *    and the `oldValues` array contains the previous values of the `watchExpressions`, with the indexes matching
	       *    those of `watchExpression`
	       *    The `scope` refers to the current scope.
	       * @returns {function()} Returns a de-registration function for all listeners.
	       */
	      $watchGroup: function(watchExpressions, listener) {
	        var oldValues = new Array(watchExpressions.length);
	        var newValues = new Array(watchExpressions.length);
	        var deregisterFns = [];
	        var self = this;
	        var changeReactionScheduled = false;
	        var firstRun = true;
	
	        if (!watchExpressions.length) {
	          // No expressions means we call the listener ASAP
	          var shouldCall = true;
	          self.$evalAsync(function() {
	            if (shouldCall) listener(newValues, newValues, self);
	          });
	          return function deregisterWatchGroup() {
	            shouldCall = false;
	          };
	        }
	
	        if (watchExpressions.length === 1) {
	          // Special case size of one
	          return this.$watch(watchExpressions[0], function watchGroupAction(value, oldValue, scope) {
	            newValues[0] = value;
	            oldValues[0] = oldValue;
	            listener(newValues, (value === oldValue) ? newValues : oldValues, scope);
	          });
	        }
	
	        forEach(watchExpressions, function(expr, i) {
	          var unwatchFn = self.$watch(expr, function watchGroupSubAction(value, oldValue) {
	            newValues[i] = value;
	            oldValues[i] = oldValue;
	            if (!changeReactionScheduled) {
	              changeReactionScheduled = true;
	              self.$evalAsync(watchGroupAction);
	            }
	          });
	          deregisterFns.push(unwatchFn);
	        });
	
	        function watchGroupAction() {
	          changeReactionScheduled = false;
	
	          if (firstRun) {
	            firstRun = false;
	            listener(newValues, newValues, self);
	          } else {
	            listener(newValues, oldValues, self);
	          }
	        }
	
	        return function deregisterWatchGroup() {
	          while (deregisterFns.length) {
	            deregisterFns.shift()();
	          }
	        };
	      },
	
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$watchCollection
	       * @kind function
	       *
	       * @description
	       * Shallow watches the properties of an object and fires whenever any of the properties change
	       * (for arrays, this implies watching the array items; for object maps, this implies watching
	       * the properties). If a change is detected, the `listener` callback is fired.
	       *
	       * - The `obj` collection is observed via standard $watch operation and is examined on every
	       *   call to $digest() to see if any items have been added, removed, or moved.
	       * - The `listener` is called whenever anything within the `obj` has changed. Examples include
	       *   adding, removing, and moving items belonging to an object or array.
	       *
	       *
	       * # Example
	       * ```js
	          $scope.names = ['igor', 'matias', 'misko', 'james'];
	          $scope.dataCount = 4;
	
	          $scope.$watchCollection('names', function(newNames, oldNames) {
	            $scope.dataCount = newNames.length;
	          });
	
	          expect($scope.dataCount).toEqual(4);
	          $scope.$digest();
	
	          //still at 4 ... no changes
	          expect($scope.dataCount).toEqual(4);
	
	          $scope.names.pop();
	          $scope.$digest();
	
	          //now there's been a change
	          expect($scope.dataCount).toEqual(3);
	       * ```
	       *
	       *
	       * @param {string|function(scope)} obj Evaluated as {@link guide/expression expression}. The
	       *    expression value should evaluate to an object or an array which is observed on each
	       *    {@link ng.$rootScope.Scope#$digest $digest} cycle. Any shallow change within the
	       *    collection will trigger a call to the `listener`.
	       *
	       * @param {function(newCollection, oldCollection, scope)} listener a callback function called
	       *    when a change is detected.
	       *    - The `newCollection` object is the newly modified data obtained from the `obj` expression
	       *    - The `oldCollection` object is a copy of the former collection data.
	       *      Due to performance considerations, the`oldCollection` value is computed only if the
	       *      `listener` function declares two or more arguments.
	       *    - The `scope` argument refers to the current scope.
	       *
	       * @returns {function()} Returns a de-registration function for this listener. When the
	       *    de-registration function is executed, the internal watch operation is terminated.
	       */
	      $watchCollection: function(obj, listener) {
	        $watchCollectionInterceptor.$stateful = true;
	
	        var self = this;
	        // the current value, updated on each dirty-check run
	        var newValue;
	        // a shallow copy of the newValue from the last dirty-check run,
	        // updated to match newValue during dirty-check run
	        var oldValue;
	        // a shallow copy of the newValue from when the last change happened
	        var veryOldValue;
	        // only track veryOldValue if the listener is asking for it
	        var trackVeryOldValue = (listener.length > 1);
	        var changeDetected = 0;
	        var changeDetector = $parse(obj, $watchCollectionInterceptor);
	        var internalArray = [];
	        var internalObject = {};
	        var initRun = true;
	        var oldLength = 0;
	
	        function $watchCollectionInterceptor(_value) {
	          newValue = _value;
	          var newLength, key, bothNaN, newItem, oldItem;
	
	          // If the new value is undefined, then return undefined as the watch may be a one-time watch
	          if (isUndefined(newValue)) return;
	
	          if (!isObject(newValue)) { // if primitive
	            if (oldValue !== newValue) {
	              oldValue = newValue;
	              changeDetected++;
	            }
	          } else if (isArrayLike(newValue)) {
	            if (oldValue !== internalArray) {
	              // we are transitioning from something which was not an array into array.
	              oldValue = internalArray;
	              oldLength = oldValue.length = 0;
	              changeDetected++;
	            }
	
	            newLength = newValue.length;
	
	            if (oldLength !== newLength) {
	              // if lengths do not match we need to trigger change notification
	              changeDetected++;
	              oldValue.length = oldLength = newLength;
	            }
	            // copy the items to oldValue and look for changes.
	            for (var i = 0; i < newLength; i++) {
	              oldItem = oldValue[i];
	              newItem = newValue[i];
	
	              bothNaN = (oldItem !== oldItem) && (newItem !== newItem);
	              if (!bothNaN && (oldItem !== newItem)) {
	                changeDetected++;
	                oldValue[i] = newItem;
	              }
	            }
	          } else {
	            if (oldValue !== internalObject) {
	              // we are transitioning from something which was not an object into object.
	              oldValue = internalObject = {};
	              oldLength = 0;
	              changeDetected++;
	            }
	            // copy the items to oldValue and look for changes.
	            newLength = 0;
	            for (key in newValue) {
	              if (hasOwnProperty.call(newValue, key)) {
	                newLength++;
	                newItem = newValue[key];
	                oldItem = oldValue[key];
	
	                if (key in oldValue) {
	                  bothNaN = (oldItem !== oldItem) && (newItem !== newItem);
	                  if (!bothNaN && (oldItem !== newItem)) {
	                    changeDetected++;
	                    oldValue[key] = newItem;
	                  }
	                } else {
	                  oldLength++;
	                  oldValue[key] = newItem;
	                  changeDetected++;
	                }
	              }
	            }
	            if (oldLength > newLength) {
	              // we used to have more keys, need to find them and destroy them.
	              changeDetected++;
	              for (key in oldValue) {
	                if (!hasOwnProperty.call(newValue, key)) {
	                  oldLength--;
	                  delete oldValue[key];
	                }
	              }
	            }
	          }
	          return changeDetected;
	        }
	
	        function $watchCollectionAction() {
	          if (initRun) {
	            initRun = false;
	            listener(newValue, newValue, self);
	          } else {
	            listener(newValue, veryOldValue, self);
	          }
	
	          // make a copy for the next time a collection is changed
	          if (trackVeryOldValue) {
	            if (!isObject(newValue)) {
	              //primitive
	              veryOldValue = newValue;
	            } else if (isArrayLike(newValue)) {
	              veryOldValue = new Array(newValue.length);
	              for (var i = 0; i < newValue.length; i++) {
	                veryOldValue[i] = newValue[i];
	              }
	            } else { // if object
	              veryOldValue = {};
	              for (var key in newValue) {
	                if (hasOwnProperty.call(newValue, key)) {
	                  veryOldValue[key] = newValue[key];
	                }
	              }
	            }
	          }
	        }
	
	        return this.$watch(changeDetector, $watchCollectionAction);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$digest
	       * @kind function
	       *
	       * @description
	       * Processes all of the {@link ng.$rootScope.Scope#$watch watchers} of the current scope and
	       * its children. Because a {@link ng.$rootScope.Scope#$watch watcher}'s listener can change
	       * the model, the `$digest()` keeps calling the {@link ng.$rootScope.Scope#$watch watchers}
	       * until no more listeners are firing. This means that it is possible to get into an infinite
	       * loop. This function will throw `'Maximum iteration limit exceeded.'` if the number of
	       * iterations exceeds 10.
	       *
	       * Usually, you don't call `$digest()` directly in
	       * {@link ng.directive:ngController controllers} or in
	       * {@link ng.$compileProvider#directive directives}.
	       * Instead, you should call {@link ng.$rootScope.Scope#$apply $apply()} (typically from within
	       * a {@link ng.$compileProvider#directive directive}), which will force a `$digest()`.
	       *
	       * If you want to be notified whenever `$digest()` is called,
	       * you can register a `watchExpression` function with
	       * {@link ng.$rootScope.Scope#$watch $watch()} with no `listener`.
	       *
	       * In unit tests, you may need to call `$digest()` to simulate the scope life cycle.
	       *
	       * # Example
	       * ```js
	           var scope = ...;
	           scope.name = 'misko';
	           scope.counter = 0;
	
	           expect(scope.counter).toEqual(0);
	           scope.$watch('name', function(newValue, oldValue) {
	             scope.counter = scope.counter + 1;
	           });
	           expect(scope.counter).toEqual(0);
	
	           scope.$digest();
	           // the listener is always called during the first $digest loop after it was registered
	           expect(scope.counter).toEqual(1);
	
	           scope.$digest();
	           // but now it will not be called unless the value changes
	           expect(scope.counter).toEqual(1);
	
	           scope.name = 'adam';
	           scope.$digest();
	           expect(scope.counter).toEqual(2);
	       * ```
	       *
	       */
	      $digest: function() {
	        var watch, value, last, fn, get,
	            watchers,
	            length,
	            dirty, ttl = TTL,
	            next, current, target = this,
	            watchLog = [],
	            logIdx, asyncTask;
	
	        beginPhase('$digest');
	        // Check for changes to browser url that happened in sync before the call to $digest
	        $browser.$$checkUrlChange();
	
	        if (this === $rootScope && applyAsyncId !== null) {
	          // If this is the root scope, and $applyAsync has scheduled a deferred $apply(), then
	          // cancel the scheduled $apply and flush the queue of expressions to be evaluated.
	          $browser.defer.cancel(applyAsyncId);
	          flushApplyAsync();
	        }
	
	        lastDirtyWatch = null;
	
	        do { // "while dirty" loop
	          dirty = false;
	          current = target;
	
	          // It's safe for asyncQueuePosition to be a local variable here because this loop can't
	          // be reentered recursively. Calling $digest from a function passed to $applyAsync would
	          // lead to a '$digest already in progress' error.
	          for (var asyncQueuePosition = 0; asyncQueuePosition < asyncQueue.length; asyncQueuePosition++) {
	            try {
	              asyncTask = asyncQueue[asyncQueuePosition];
	              asyncTask.scope.$eval(asyncTask.expression, asyncTask.locals);
	            } catch (e) {
	              $exceptionHandler(e);
	            }
	            lastDirtyWatch = null;
	          }
	          asyncQueue.length = 0;
	
	          traverseScopesLoop:
	          do { // "traverse the scopes" loop
	            if ((watchers = current.$$watchers)) {
	              // process our watches
	              length = watchers.length;
	              while (length--) {
	                try {
	                  watch = watchers[length];
	                  // Most common watches are on primitives, in which case we can short
	                  // circuit it with === operator, only when === fails do we use .equals
	                  if (watch) {
	                    get = watch.get;
	                    if ((value = get(current)) !== (last = watch.last) &&
	                        !(watch.eq
	                            ? equals(value, last)
	                            : (typeof value === 'number' && typeof last === 'number'
	                               && isNaN(value) && isNaN(last)))) {
	                      dirty = true;
	                      lastDirtyWatch = watch;
	                      watch.last = watch.eq ? copy(value, null) : value;
	                      fn = watch.fn;
	                      fn(value, ((last === initWatchVal) ? value : last), current);
	                      if (ttl < 5) {
	                        logIdx = 4 - ttl;
	                        if (!watchLog[logIdx]) watchLog[logIdx] = [];
	                        watchLog[logIdx].push({
	                          msg: isFunction(watch.exp) ? 'fn: ' + (watch.exp.name || watch.exp.toString()) : watch.exp,
	                          newVal: value,
	                          oldVal: last
	                        });
	                      }
	                    } else if (watch === lastDirtyWatch) {
	                      // If the most recently dirty watcher is now clean, short circuit since the remaining watchers
	                      // have already been tested.
	                      dirty = false;
	                      break traverseScopesLoop;
	                    }
	                  }
	                } catch (e) {
	                  $exceptionHandler(e);
	                }
	              }
	            }
	
	            // Insanity Warning: scope depth-first traversal
	            // yes, this code is a bit crazy, but it works and we have tests to prove it!
	            // this piece should be kept in sync with the traversal in $broadcast
	            if (!(next = ((current.$$watchersCount && current.$$childHead) ||
	                (current !== target && current.$$nextSibling)))) {
	              while (current !== target && !(next = current.$$nextSibling)) {
	                current = current.$parent;
	              }
	            }
	          } while ((current = next));
	
	          // `break traverseScopesLoop;` takes us to here
	
	          if ((dirty || asyncQueue.length) && !(ttl--)) {
	            clearPhase();
	            throw $rootScopeMinErr('infdig',
	                '{0} $digest() iterations reached. Aborting!\n' +
	                'Watchers fired in the last 5 iterations: {1}',
	                TTL, watchLog);
	          }
	
	        } while (dirty || asyncQueue.length);
	
	        clearPhase();
	
	        // postDigestQueuePosition isn't local here because this loop can be reentered recursively.
	        while (postDigestQueuePosition < postDigestQueue.length) {
	          try {
	            postDigestQueue[postDigestQueuePosition++]();
	          } catch (e) {
	            $exceptionHandler(e);
	          }
	        }
	        postDigestQueue.length = postDigestQueuePosition = 0;
	      },
	
	
	      /**
	       * @ngdoc event
	       * @name $rootScope.Scope#$destroy
	       * @eventType broadcast on scope being destroyed
	       *
	       * @description
	       * Broadcasted when a scope and its children are being destroyed.
	       *
	       * Note that, in AngularJS, there is also a `$destroy` jQuery event, which can be used to
	       * clean up DOM bindings before an element is removed from the DOM.
	       */
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$destroy
	       * @kind function
	       *
	       * @description
	       * Removes the current scope (and all of its children) from the parent scope. Removal implies
	       * that calls to {@link ng.$rootScope.Scope#$digest $digest()} will no longer
	       * propagate to the current scope and its children. Removal also implies that the current
	       * scope is eligible for garbage collection.
	       *
	       * The `$destroy()` is usually used by directives such as
	       * {@link ng.directive:ngRepeat ngRepeat} for managing the
	       * unrolling of the loop.
	       *
	       * Just before a scope is destroyed, a `$destroy` event is broadcasted on this scope.
	       * Application code can register a `$destroy` event handler that will give it a chance to
	       * perform any necessary cleanup.
	       *
	       * Note that, in AngularJS, there is also a `$destroy` jQuery event, which can be used to
	       * clean up DOM bindings before an element is removed from the DOM.
	       */
	      $destroy: function() {
	        // We can't destroy a scope that has been already destroyed.
	        if (this.$$destroyed) return;
	        var parent = this.$parent;
	
	        this.$broadcast('$destroy');
	        this.$$destroyed = true;
	
	        if (this === $rootScope) {
	          //Remove handlers attached to window when $rootScope is removed
	          $browser.$$applicationDestroyed();
	        }
	
	        incrementWatchersCount(this, -this.$$watchersCount);
	        for (var eventName in this.$$listenerCount) {
	          decrementListenerCount(this, this.$$listenerCount[eventName], eventName);
	        }
	
	        // sever all the references to parent scopes (after this cleanup, the current scope should
	        // not be retained by any of our references and should be eligible for garbage collection)
	        if (parent && parent.$$childHead == this) parent.$$childHead = this.$$nextSibling;
	        if (parent && parent.$$childTail == this) parent.$$childTail = this.$$prevSibling;
	        if (this.$$prevSibling) this.$$prevSibling.$$nextSibling = this.$$nextSibling;
	        if (this.$$nextSibling) this.$$nextSibling.$$prevSibling = this.$$prevSibling;
	
	        // Disable listeners, watchers and apply/digest methods
	        this.$destroy = this.$digest = this.$apply = this.$evalAsync = this.$applyAsync = noop;
	        this.$on = this.$watch = this.$watchGroup = function() { return noop; };
	        this.$$listeners = {};
	
	        // Disconnect the next sibling to prevent `cleanUpScope` destroying those too
	        this.$$nextSibling = null;
	        cleanUpScope(this);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$eval
	       * @kind function
	       *
	       * @description
	       * Executes the `expression` on the current scope and returns the result. Any exceptions in
	       * the expression are propagated (uncaught). This is useful when evaluating Angular
	       * expressions.
	       *
	       * # Example
	       * ```js
	           var scope = ng.$rootScope.Scope();
	           scope.a = 1;
	           scope.b = 2;
	
	           expect(scope.$eval('a+b')).toEqual(3);
	           expect(scope.$eval(function(scope){ return scope.a + scope.b; })).toEqual(3);
	       * ```
	       *
	       * @param {(string|function())=} expression An angular expression to be executed.
	       *
	       *    - `string`: execute using the rules as defined in  {@link guide/expression expression}.
	       *    - `function(scope)`: execute the function with the current `scope` parameter.
	       *
	       * @param {(object)=} locals Local variables object, useful for overriding values in scope.
	       * @returns {*} The result of evaluating the expression.
	       */
	      $eval: function(expr, locals) {
	        return $parse(expr)(this, locals);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$evalAsync
	       * @kind function
	       *
	       * @description
	       * Executes the expression on the current scope at a later point in time.
	       *
	       * The `$evalAsync` makes no guarantees as to when the `expression` will be executed, only
	       * that:
	       *
	       *   - it will execute after the function that scheduled the evaluation (preferably before DOM
	       *     rendering).
	       *   - at least one {@link ng.$rootScope.Scope#$digest $digest cycle} will be performed after
	       *     `expression` execution.
	       *
	       * Any exceptions from the execution of the expression are forwarded to the
	       * {@link ng.$exceptionHandler $exceptionHandler} service.
	       *
	       * __Note:__ if this function is called outside of a `$digest` cycle, a new `$digest` cycle
	       * will be scheduled. However, it is encouraged to always call code that changes the model
	       * from within an `$apply` call. That includes code evaluated via `$evalAsync`.
	       *
	       * @param {(string|function())=} expression An angular expression to be executed.
	       *
	       *    - `string`: execute using the rules as defined in {@link guide/expression expression}.
	       *    - `function(scope)`: execute the function with the current `scope` parameter.
	       *
	       * @param {(object)=} locals Local variables object, useful for overriding values in scope.
	       */
	      $evalAsync: function(expr, locals) {
	        // if we are outside of an $digest loop and this is the first time we are scheduling async
	        // task also schedule async auto-flush
	        if (!$rootScope.$$phase && !asyncQueue.length) {
	          $browser.defer(function() {
	            if (asyncQueue.length) {
	              $rootScope.$digest();
	            }
	          });
	        }
	
	        asyncQueue.push({scope: this, expression: $parse(expr), locals: locals});
	      },
	
	      $$postDigest: function(fn) {
	        postDigestQueue.push(fn);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$apply
	       * @kind function
	       *
	       * @description
	       * `$apply()` is used to execute an expression in angular from outside of the angular
	       * framework. (For example from browser DOM events, setTimeout, XHR or third party libraries).
	       * Because we are calling into the angular framework we need to perform proper scope life
	       * cycle of {@link ng.$exceptionHandler exception handling},
	       * {@link ng.$rootScope.Scope#$digest executing watches}.
	       *
	       * ## Life cycle
	       *
	       * # Pseudo-Code of `$apply()`
	       * ```js
	           function $apply(expr) {
	             try {
	               return $eval(expr);
	             } catch (e) {
	               $exceptionHandler(e);
	             } finally {
	               $root.$digest();
	             }
	           }
	       * ```
	       *
	       *
	       * Scope's `$apply()` method transitions through the following stages:
	       *
	       * 1. The {@link guide/expression expression} is executed using the
	       *    {@link ng.$rootScope.Scope#$eval $eval()} method.
	       * 2. Any exceptions from the execution of the expression are forwarded to the
	       *    {@link ng.$exceptionHandler $exceptionHandler} service.
	       * 3. The {@link ng.$rootScope.Scope#$watch watch} listeners are fired immediately after the
	       *    expression was executed using the {@link ng.$rootScope.Scope#$digest $digest()} method.
	       *
	       *
	       * @param {(string|function())=} exp An angular expression to be executed.
	       *
	       *    - `string`: execute using the rules as defined in {@link guide/expression expression}.
	       *    - `function(scope)`: execute the function with current `scope` parameter.
	       *
	       * @returns {*} The result of evaluating the expression.
	       */
	      $apply: function(expr) {
	        try {
	          beginPhase('$apply');
	          try {
	            return this.$eval(expr);
	          } finally {
	            clearPhase();
	          }
	        } catch (e) {
	          $exceptionHandler(e);
	        } finally {
	          try {
	            $rootScope.$digest();
	          } catch (e) {
	            $exceptionHandler(e);
	            throw e;
	          }
	        }
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$applyAsync
	       * @kind function
	       *
	       * @description
	       * Schedule the invocation of $apply to occur at a later time. The actual time difference
	       * varies across browsers, but is typically around ~10 milliseconds.
	       *
	       * This can be used to queue up multiple expressions which need to be evaluated in the same
	       * digest.
	       *
	       * @param {(string|function())=} exp An angular expression to be executed.
	       *
	       *    - `string`: execute using the rules as defined in {@link guide/expression expression}.
	       *    - `function(scope)`: execute the function with current `scope` parameter.
	       */
	      $applyAsync: function(expr) {
	        var scope = this;
	        expr && applyAsyncQueue.push($applyAsyncExpression);
	        expr = $parse(expr);
	        scheduleApplyAsync();
	
	        function $applyAsyncExpression() {
	          scope.$eval(expr);
	        }
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$on
	       * @kind function
	       *
	       * @description
	       * Listens on events of a given type. See {@link ng.$rootScope.Scope#$emit $emit} for
	       * discussion of event life cycle.
	       *
	       * The event listener function format is: `function(event, args...)`. The `event` object
	       * passed into the listener has the following attributes:
	       *
	       *   - `targetScope` - `{Scope}`: the scope on which the event was `$emit`-ed or
	       *     `$broadcast`-ed.
	       *   - `currentScope` - `{Scope}`: the scope that is currently handling the event. Once the
	       *     event propagates through the scope hierarchy, this property is set to null.
	       *   - `name` - `{string}`: name of the event.
	       *   - `stopPropagation` - `{function=}`: calling `stopPropagation` function will cancel
	       *     further event propagation (available only for events that were `$emit`-ed).
	       *   - `preventDefault` - `{function}`: calling `preventDefault` sets `defaultPrevented` flag
	       *     to true.
	       *   - `defaultPrevented` - `{boolean}`: true if `preventDefault` was called.
	       *
	       * @param {string} name Event name to listen on.
	       * @param {function(event, ...args)} listener Function to call when the event is emitted.
	       * @returns {function()} Returns a deregistration function for this listener.
	       */
	      $on: function(name, listener) {
	        var namedListeners = this.$$listeners[name];
	        if (!namedListeners) {
	          this.$$listeners[name] = namedListeners = [];
	        }
	        namedListeners.push(listener);
	
	        var current = this;
	        do {
	          if (!current.$$listenerCount[name]) {
	            current.$$listenerCount[name] = 0;
	          }
	          current.$$listenerCount[name]++;
	        } while ((current = current.$parent));
	
	        var self = this;
	        return function() {
	          var indexOfListener = namedListeners.indexOf(listener);
	          if (indexOfListener !== -1) {
	            namedListeners[indexOfListener] = null;
	            decrementListenerCount(self, 1, name);
	          }
	        };
	      },
	
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$emit
	       * @kind function
	       *
	       * @description
	       * Dispatches an event `name` upwards through the scope hierarchy notifying the
	       * registered {@link ng.$rootScope.Scope#$on} listeners.
	       *
	       * The event life cycle starts at the scope on which `$emit` was called. All
	       * {@link ng.$rootScope.Scope#$on listeners} listening for `name` event on this scope get
	       * notified. Afterwards, the event traverses upwards toward the root scope and calls all
	       * registered listeners along the way. The event will stop propagating if one of the listeners
	       * cancels it.
	       *
	       * Any exception emitted from the {@link ng.$rootScope.Scope#$on listeners} will be passed
	       * onto the {@link ng.$exceptionHandler $exceptionHandler} service.
	       *
	       * @param {string} name Event name to emit.
	       * @param {...*} args Optional one or more arguments which will be passed onto the event listeners.
	       * @return {Object} Event object (see {@link ng.$rootScope.Scope#$on}).
	       */
	      $emit: function(name, args) {
	        var empty = [],
	            namedListeners,
	            scope = this,
	            stopPropagation = false,
	            event = {
	              name: name,
	              targetScope: scope,
	              stopPropagation: function() {stopPropagation = true;},
	              preventDefault: function() {
	                event.defaultPrevented = true;
	              },
	              defaultPrevented: false
	            },
	            listenerArgs = concat([event], arguments, 1),
	            i, length;
	
	        do {
	          namedListeners = scope.$$listeners[name] || empty;
	          event.currentScope = scope;
	          for (i = 0, length = namedListeners.length; i < length; i++) {
	
	            // if listeners were deregistered, defragment the array
	            if (!namedListeners[i]) {
	              namedListeners.splice(i, 1);
	              i--;
	              length--;
	              continue;
	            }
	            try {
	              //allow all listeners attached to the current scope to run
	              namedListeners[i].apply(null, listenerArgs);
	            } catch (e) {
	              $exceptionHandler(e);
	            }
	          }
	          //if any listener on the current scope stops propagation, prevent bubbling
	          if (stopPropagation) {
	            event.currentScope = null;
	            return event;
	          }
	          //traverse upwards
	          scope = scope.$parent;
	        } while (scope);
	
	        event.currentScope = null;
	
	        return event;
	      },
	
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$broadcast
	       * @kind function
	       *
	       * @description
	       * Dispatches an event `name` downwards to all child scopes (and their children) notifying the
	       * registered {@link ng.$rootScope.Scope#$on} listeners.
	       *
	       * The event life cycle starts at the scope on which `$broadcast` was called. All
	       * {@link ng.$rootScope.Scope#$on listeners} listening for `name` event on this scope get
	       * notified. Afterwards, the event propagates to all direct and indirect scopes of the current
	       * scope and calls all registered listeners along the way. The event cannot be canceled.
	       *
	       * Any exception emitted from the {@link ng.$rootScope.Scope#$on listeners} will be passed
	       * onto the {@link ng.$exceptionHandler $exceptionHandler} service.
	       *
	       * @param {string} name Event name to broadcast.
	       * @param {...*} args Optional one or more arguments which will be passed onto the event listeners.
	       * @return {Object} Event object, see {@link ng.$rootScope.Scope#$on}
	       */
	      $broadcast: function(name, args) {
	        var target = this,
	            current = target,
	            next = target,
	            event = {
	              name: name,
	              targetScope: target,
	              preventDefault: function() {
	                event.defaultPrevented = true;
	              },
	              defaultPrevented: false
	            };
	
	        if (!target.$$listenerCount[name]) return event;
	
	        var listenerArgs = concat([event], arguments, 1),
	            listeners, i, length;
	
	        //down while you can, then up and next sibling or up and next sibling until back at root
	        while ((current = next)) {
	          event.currentScope = current;
	          listeners = current.$$listeners[name] || [];
	          for (i = 0, length = listeners.length; i < length; i++) {
	            // if listeners were deregistered, defragment the array
	            if (!listeners[i]) {
	              listeners.splice(i, 1);
	              i--;
	              length--;
	              continue;
	            }
	
	            try {
	              listeners[i].apply(null, listenerArgs);
	            } catch (e) {
	              $exceptionHandler(e);
	            }
	          }
	
	          // Insanity Warning: scope depth-first traversal
	          // yes, this code is a bit crazy, but it works and we have tests to prove it!
	          // this piece should be kept in sync with the traversal in $digest
	          // (though it differs due to having the extra check for $$listenerCount)
	          if (!(next = ((current.$$listenerCount[name] && current.$$childHead) ||
	              (current !== target && current.$$nextSibling)))) {
	            while (current !== target && !(next = current.$$nextSibling)) {
	              current = current.$parent;
	            }
	          }
	        }
	
	        event.currentScope = null;
	        return event;
	      }
	    };
	
	    var $rootScope = new Scope();
	
	    //The internal queues. Expose them on the $rootScope for debugging/testing purposes.
	    var asyncQueue = $rootScope.$$asyncQueue = [];
	    var postDigestQueue = $rootScope.$$postDigestQueue = [];
	    var applyAsyncQueue = $rootScope.$$applyAsyncQueue = [];
	
	    var postDigestQueuePosition = 0;
	
	    return $rootScope;
	
	
	    function beginPhase(phase) {
	      if ($rootScope.$$phase) {
	        throw $rootScopeMinErr('inprog', '{0} already in progress', $rootScope.$$phase);
	      }
	
	      $rootScope.$$phase = phase;
	    }
	
	    function clearPhase() {
	      $rootScope.$$phase = null;
	    }
	
	    function incrementWatchersCount(current, count) {
	      do {
	        current.$$watchersCount += count;
	      } while ((current = current.$parent));
	    }
	
	    function decrementListenerCount(current, count, name) {
	      do {
	        current.$$listenerCount[name] -= count;
	
	        if (current.$$listenerCount[name] === 0) {
	          delete current.$$listenerCount[name];
	        }
	      } while ((current = current.$parent));
	    }
	
	    /**
	     * function used as an initial value for watchers.
	     * because it's unique we can easily tell it apart from other values
	     */
	    function initWatchVal() {}
	
	    function flushApplyAsync() {
	      while (applyAsyncQueue.length) {
	        try {
	          applyAsyncQueue.shift()();
	        } catch (e) {
	          $exceptionHandler(e);
	        }
	      }
	      applyAsyncId = null;
	    }
	
	    function scheduleApplyAsync() {
	      if (applyAsyncId === null) {
	        applyAsyncId = $browser.defer(function() {
	          $rootScope.$apply(flushApplyAsync);
	        });
	      }
	    }
	  }];
	}
	
	/**
	 * @ngdoc service
	 * @name $rootElement
	 *
	 * @description
	 * The root element of Angular application. This is either the element where {@link
	 * ng.directive:ngApp ngApp} was declared or the element passed into
	 * {@link angular.bootstrap}. The element represents the root element of application. It is also the
	 * location where the application's {@link auto.$injector $injector} service gets
	 * published, and can be retrieved using `$rootElement.injector()`.
	 */
	
	
	// the implementation is in angular.bootstrap
	
	/**
	 * @description
	 * Private service to sanitize uris for links and images. Used by $compile and $sanitize.
	 */
	function $$SanitizeUriProvider() {
	  var aHrefSanitizationWhitelist = /^\s*(https?|ftp|mailto|tel|file):/,
	    imgSrcSanitizationWhitelist = /^\s*((https?|ftp|file|blob):|data:image\/)/;
	
	  /**
	   * @description
	   * Retrieves or overrides the default regular expression that is used for whitelisting of safe
	   * urls during a[href] sanitization.
	   *
	   * The sanitization is a security measure aimed at prevent XSS attacks via html links.
	   *
	   * Any url about to be assigned to a[href] via data-binding is first normalized and turned into
	   * an absolute url. Afterwards, the url is matched against the `aHrefSanitizationWhitelist`
	   * regular expression. If a match is found, the original url is written into the dom. Otherwise,
	   * the absolute url is prefixed with `'unsafe:'` string and only then is it written into the DOM.
	   *
	   * @param {RegExp=} regexp New regexp to whitelist urls with.
	   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
	   *    chaining otherwise.
	   */
	  this.aHrefSanitizationWhitelist = function(regexp) {
	    if (isDefined(regexp)) {
	      aHrefSanitizationWhitelist = regexp;
	      return this;
	    }
	    return aHrefSanitizationWhitelist;
	  };
	
	
	  /**
	   * @description
	   * Retrieves or overrides the default regular expression that is used for whitelisting of safe
	   * urls during img[src] sanitization.
	   *
	   * The sanitization is a security measure aimed at prevent XSS attacks via html links.
	   *
	   * Any url about to be assigned to img[src] via data-binding is first normalized and turned into
	   * an absolute url. Afterwards, the url is matched against the `imgSrcSanitizationWhitelist`
	   * regular expression. If a match is found, the original url is written into the dom. Otherwise,
	   * the absolute url is prefixed with `'unsafe:'` string and only then is it written into the DOM.
	   *
	   * @param {RegExp=} regexp New regexp to whitelist urls with.
	   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
	   *    chaining otherwise.
	   */
	  this.imgSrcSanitizationWhitelist = function(regexp) {
	    if (isDefined(regexp)) {
	      imgSrcSanitizationWhitelist = regexp;
	      return this;
	    }
	    return imgSrcSanitizationWhitelist;
	  };
	
	  this.$get = function() {
	    return function sanitizeUri(uri, isImage) {
	      var regex = isImage ? imgSrcSanitizationWhitelist : aHrefSanitizationWhitelist;
	      var normalizedVal;
	      normalizedVal = urlResolve(uri).href;
	      if (normalizedVal !== '' && !normalizedVal.match(regex)) {
	        return 'unsafe:' + normalizedVal;
	      }
	      return uri;
	    };
	  };
	}
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 *     Any commits to this file should be reviewed with security in mind.  *
	 *   Changes to this file can potentially create security vulnerabilities. *
	 *          An approval from 2 Core members with history of modifying      *
	 *                         this file is required.                          *
	 *                                                                         *
	 *  Does the change somehow allow for arbitrary javascript to be executed? *
	 *    Or allows for someone to change the prototype of built-in objects?   *
	 *     Or gives undesired access to variables likes document or window?    *
	 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */
	
	var $sceMinErr = minErr('$sce');
	
	var SCE_CONTEXTS = {
	  HTML: 'html',
	  CSS: 'css',
	  URL: 'url',
	  // RESOURCE_URL is a subtype of URL used in contexts where a privileged resource is sourced from a
	  // url.  (e.g. ng-include, script src, templateUrl)
	  RESOURCE_URL: 'resourceUrl',
	  JS: 'js'
	};
	
	// Helper functions follow.
	
	function adjustMatcher(matcher) {
	  if (matcher === 'self') {
	    return matcher;
	  } else if (isString(matcher)) {
	    // Strings match exactly except for 2 wildcards - '*' and '**'.
	    // '*' matches any character except those from the set ':/.?&'.
	    // '**' matches any character (like .* in a RegExp).
	    // More than 2 *'s raises an error as it's ill defined.
	    if (matcher.indexOf('***') > -1) {
	      throw $sceMinErr('iwcard',
	          'Illegal sequence *** in string matcher.  String: {0}', matcher);
	    }
	    matcher = escapeForRegexp(matcher).
	                  replace('\\*\\*', '.*').
	                  replace('\\*', '[^:/.?&;]*');
	    return new RegExp('^' + matcher + '$');
	  } else if (isRegExp(matcher)) {
	    // The only other type of matcher allowed is a Regexp.
	    // Match entire URL / disallow partial matches.
	    // Flags are reset (i.e. no global, ignoreCase or multiline)
	    return new RegExp('^' + matcher.source + '$');
	  } else {
	    throw $sceMinErr('imatcher',
	        'Matchers may only be "self", string patterns or RegExp objects');
	  }
	}
	
	
	function adjustMatchers(matchers) {
	  var adjustedMatchers = [];
	  if (isDefined(matchers)) {
	    forEach(matchers, function(matcher) {
	      adjustedMatchers.push(adjustMatcher(matcher));
	    });
	  }
	  return adjustedMatchers;
	}
	
	
	/**
	 * @ngdoc service
	 * @name $sceDelegate
	 * @kind function
	 *
	 * @description
	 *
	 * `$sceDelegate` is a service that is used by the `$sce` service to provide {@link ng.$sce Strict
	 * Contextual Escaping (SCE)} services to AngularJS.
	 *
	 * Typically, you would configure or override the {@link ng.$sceDelegate $sceDelegate} instead of
	 * the `$sce` service to customize the way Strict Contextual Escaping works in AngularJS.  This is
	 * because, while the `$sce` provides numerous shorthand methods, etc., you really only need to
	 * override 3 core functions (`trustAs`, `getTrusted` and `valueOf`) to replace the way things
	 * work because `$sce` delegates to `$sceDelegate` for these operations.
	 *
	 * Refer {@link ng.$sceDelegateProvider $sceDelegateProvider} to configure this service.
	 *
	 * The default instance of `$sceDelegate` should work out of the box with little pain.  While you
	 * can override it completely to change the behavior of `$sce`, the common case would
	 * involve configuring the {@link ng.$sceDelegateProvider $sceDelegateProvider} instead by setting
	 * your own whitelists and blacklists for trusting URLs used for loading AngularJS resources such as
	 * templates.  Refer {@link ng.$sceDelegateProvider#resourceUrlWhitelist
	 * $sceDelegateProvider.resourceUrlWhitelist} and {@link
	 * ng.$sceDelegateProvider#resourceUrlBlacklist $sceDelegateProvider.resourceUrlBlacklist}
	 */
	
	/**
	 * @ngdoc provider
	 * @name $sceDelegateProvider
	 * @description
	 *
	 * The `$sceDelegateProvider` provider allows developers to configure the {@link ng.$sceDelegate
	 * $sceDelegate} service.  This allows one to get/set the whitelists and blacklists used to ensure
	 * that the URLs used for sourcing Angular templates are safe.  Refer {@link
	 * ng.$sceDelegateProvider#resourceUrlWhitelist $sceDelegateProvider.resourceUrlWhitelist} and
	 * {@link ng.$sceDelegateProvider#resourceUrlBlacklist $sceDelegateProvider.resourceUrlBlacklist}
	 *
	 * For the general details about this service in Angular, read the main page for {@link ng.$sce
	 * Strict Contextual Escaping (SCE)}.
	 *
	 * **Example**:  Consider the following case. <a name="example"></a>
	 *
	 * - your app is hosted at url `http://myapp.example.com/`
	 * - but some of your templates are hosted on other domains you control such as
	 *   `http://srv01.assets.example.com/`,  `http://srv02.assets.example.com/`, etc.
	 * - and you have an open redirect at `http://myapp.example.com/clickThru?...`.
	 *
	 * Here is what a secure configuration for this scenario might look like:
	 *
	 * ```
	 *  angular.module('myApp', []).config(function($sceDelegateProvider) {
	 *    $sceDelegateProvider.resourceUrlWhitelist([
	 *      // Allow same origin resource loads.
	 *      'self',
	 *      // Allow loading from our assets domain.  Notice the difference between * and **.
	 *      'http://srv*.assets.example.com/**'
	 *    ]);
	 *
	 *    // The blacklist overrides the whitelist so the open redirect here is blocked.
	 *    $sceDelegateProvider.resourceUrlBlacklist([
	 *      'http://myapp.example.com/clickThru**'
	 *    ]);
	 *  });
	 * ```
	 */
	
	function $SceDelegateProvider() {
	  this.SCE_CONTEXTS = SCE_CONTEXTS;
	
	  // Resource URLs can also be trusted by policy.
	  var resourceUrlWhitelist = ['self'],
	      resourceUrlBlacklist = [];
	
	  /**
	   * @ngdoc method
	   * @name $sceDelegateProvider#resourceUrlWhitelist
	   * @kind function
	   *
	   * @param {Array=} whitelist When provided, replaces the resourceUrlWhitelist with the value
	   *    provided.  This must be an array or null.  A snapshot of this array is used so further
	   *    changes to the array are ignored.
	   *
	   *    Follow {@link ng.$sce#resourceUrlPatternItem this link} for a description of the items
	   *    allowed in this array.
	   *
	   *    <div class="alert alert-warning">
	   *    **Note:** an empty whitelist array will block all URLs!
	   *    </div>
	   *
	   * @return {Array} the currently set whitelist array.
	   *
	   * The **default value** when no whitelist has been explicitly set is `['self']` allowing only
	   * same origin resource requests.
	   *
	   * @description
	   * Sets/Gets the whitelist of trusted resource URLs.
	   */
	  this.resourceUrlWhitelist = function(value) {
	    if (arguments.length) {
	      resourceUrlWhitelist = adjustMatchers(value);
	    }
	    return resourceUrlWhitelist;
	  };
	
	  /**
	   * @ngdoc method
	   * @name $sceDelegateProvider#resourceUrlBlacklist
	   * @kind function
	   *
	   * @param {Array=} blacklist When provided, replaces the resourceUrlBlacklist with the value
	   *    provided.  This must be an array or null.  A snapshot of this array is used so further
	   *    changes to the array are ignored.
	   *
	   *    Follow {@link ng.$sce#resourceUrlPatternItem this link} for a description of the items
	   *    allowed in this array.
	   *
	   *    The typical usage for the blacklist is to **block
	   *    [open redirects](http://cwe.mitre.org/data/definitions/601.html)** served by your domain as
	   *    these would otherwise be trusted but actually return content from the redirected domain.
	   *
	   *    Finally, **the blacklist overrides the whitelist** and has the final say.
	   *
	   * @return {Array} the currently set blacklist array.
	   *
	   * The **default value** when no whitelist has been explicitly set is the empty array (i.e. there
	   * is no blacklist.)
	   *
	   * @description
	   * Sets/Gets the blacklist of trusted resource URLs.
	   */
	
	  this.resourceUrlBlacklist = function(value) {
	    if (arguments.length) {
	      resourceUrlBlacklist = adjustMatchers(value);
	    }
	    return resourceUrlBlacklist;
	  };
	
	  this.$get = ['$injector', function($injector) {
	
	    var htmlSanitizer = function htmlSanitizer(html) {
	      throw $sceMinErr('unsafe', 'Attempting to use an unsafe value in a safe context.');
	    };
	
	    if ($injector.has('$sanitize')) {
	      htmlSanitizer = $injector.get('$sanitize');
	    }
	
	
	    function matchUrl(matcher, parsedUrl) {
	      if (matcher === 'self') {
	        return urlIsSameOrigin(parsedUrl);
	      } else {
	        // definitely a regex.  See adjustMatchers()
	        return !!matcher.exec(parsedUrl.href);
	      }
	    }
	
	    function isResourceUrlAllowedByPolicy(url) {
	      var parsedUrl = urlResolve(url.toString());
	      var i, n, allowed = false;
	      // Ensure that at least one item from the whitelist allows this url.
	      for (i = 0, n = resourceUrlWhitelist.length; i < n; i++) {
	        if (matchUrl(resourceUrlWhitelist[i], parsedUrl)) {
	          allowed = true;
	          break;
	        }
	      }
	      if (allowed) {
	        // Ensure that no item from the blacklist blocked this url.
	        for (i = 0, n = resourceUrlBlacklist.length; i < n; i++) {
	          if (matchUrl(resourceUrlBlacklist[i], parsedUrl)) {
	            allowed = false;
	            break;
	          }
	        }
	      }
	      return allowed;
	    }
	
	    function generateHolderType(Base) {
	      var holderType = function TrustedValueHolderType(trustedValue) {
	        this.$$unwrapTrustedValue = function() {
	          return trustedValue;
	        };
	      };
	      if (Base) {
	        holderType.prototype = new Base();
	      }
	      holderType.prototype.valueOf = function sceValueOf() {
	        return this.$$unwrapTrustedValue();
	      };
	      holderType.prototype.toString = function sceToString() {
	        return this.$$unwrapTrustedValue().toString();
	      };
	      return holderType;
	    }
	
	    var trustedValueHolderBase = generateHolderType(),
	        byType = {};
	
	    byType[SCE_CONTEXTS.HTML] = generateHolderType(trustedValueHolderBase);
	    byType[SCE_CONTEXTS.CSS] = generateHolderType(trustedValueHolderBase);
	    byType[SCE_CONTEXTS.URL] = generateHolderType(trustedValueHolderBase);
	    byType[SCE_CONTEXTS.JS] = generateHolderType(trustedValueHolderBase);
	    byType[SCE_CONTEXTS.RESOURCE_URL] = generateHolderType(byType[SCE_CONTEXTS.URL]);
	
	    /**
	     * @ngdoc method
	     * @name $sceDelegate#trustAs
	     *
	     * @description
	     * Returns an object that is trusted by angular for use in specified strict
	     * contextual escaping contexts (such as ng-bind-html, ng-include, any src
	     * attribute interpolation, any dom event binding attribute interpolation
	     * such as for onclick,  etc.) that uses the provided value.
	     * See {@link ng.$sce $sce} for enabling strict contextual escaping.
	     *
	     * @param {string} type The kind of context in which this value is safe for use.  e.g. url,
	     *   resourceUrl, html, js and css.
	     * @param {*} value The value that that should be considered trusted/safe.
	     * @returns {*} A value that can be used to stand in for the provided `value` in places
	     * where Angular expects a $sce.trustAs() return value.
	     */
	    function trustAs(type, trustedValue) {
	      var Constructor = (byType.hasOwnProperty(type) ? byType[type] : null);
	      if (!Constructor) {
	        throw $sceMinErr('icontext',
	            'Attempted to trust a value in invalid context. Context: {0}; Value: {1}',
	            type, trustedValue);
	      }
	      if (trustedValue === null || isUndefined(trustedValue) || trustedValue === '') {
	        return trustedValue;
	      }
	      // All the current contexts in SCE_CONTEXTS happen to be strings.  In order to avoid trusting
	      // mutable objects, we ensure here that the value passed in is actually a string.
	      if (typeof trustedValue !== 'string') {
	        throw $sceMinErr('itype',
	            'Attempted to trust a non-string value in a content requiring a string: Context: {0}',
	            type);
	      }
	      return new Constructor(trustedValue);
	    }
	
	    /**
	     * @ngdoc method
	     * @name $sceDelegate#valueOf
	     *
	     * @description
	     * If the passed parameter had been returned by a prior call to {@link ng.$sceDelegate#trustAs
	     * `$sceDelegate.trustAs`}, returns the value that had been passed to {@link
	     * ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}.
	     *
	     * If the passed parameter is not a value that had been returned by {@link
	     * ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}, returns it as-is.
	     *
	     * @param {*} value The result of a prior {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}
	     *      call or anything else.
	     * @returns {*} The `value` that was originally provided to {@link ng.$sceDelegate#trustAs
	     *     `$sceDelegate.trustAs`} if `value` is the result of such a call.  Otherwise, returns
	     *     `value` unchanged.
	     */
	    function valueOf(maybeTrusted) {
	      if (maybeTrusted instanceof trustedValueHolderBase) {
	        return maybeTrusted.$$unwrapTrustedValue();
	      } else {
	        return maybeTrusted;
	      }
	    }
	
	    /**
	     * @ngdoc method
	     * @name $sceDelegate#getTrusted
	     *
	     * @description
	     * Takes the result of a {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs`} call and
	     * returns the originally supplied value if the queried context type is a supertype of the
	     * created type.  If this condition isn't satisfied, throws an exception.
	     *
	     * <div class="alert alert-danger">
	     * Disabling auto-escaping is extremely dangerous, it usually creates a Cross Site Scripting
	     * (XSS) vulnerability in your application.
	     * </div>
	     *
	     * @param {string} type The kind of context in which this value is to be used.
	     * @param {*} maybeTrusted The result of a prior {@link ng.$sceDelegate#trustAs
	     *     `$sceDelegate.trustAs`} call.
	     * @returns {*} The value the was originally provided to {@link ng.$sceDelegate#trustAs
	     *     `$sceDelegate.trustAs`} if valid in this context.  Otherwise, throws an exception.
	     */
	    function getTrusted(type, maybeTrusted) {
	      if (maybeTrusted === null || isUndefined(maybeTrusted) || maybeTrusted === '') {
	        return maybeTrusted;
	      }
	      var constructor = (byType.hasOwnProperty(type) ? byType[type] : null);
	      if (constructor && maybeTrusted instanceof constructor) {
	        return maybeTrusted.$$unwrapTrustedValue();
	      }
	      // If we get here, then we may only take one of two actions.
	      // 1. sanitize the value for the requested type, or
	      // 2. throw an exception.
	      if (type === SCE_CONTEXTS.RESOURCE_URL) {
	        if (isResourceUrlAllowedByPolicy(maybeTrusted)) {
	          return maybeTrusted;
	        } else {
	          throw $sceMinErr('insecurl',
	              'Blocked loading resource from url not allowed by $sceDelegate policy.  URL: {0}',
	              maybeTrusted.toString());
	        }
	      } else if (type === SCE_CONTEXTS.HTML) {
	        return htmlSanitizer(maybeTrusted);
	      }
	      throw $sceMinErr('unsafe', 'Attempting to use an unsafe value in a safe context.');
	    }
	
	    return { trustAs: trustAs,
	             getTrusted: getTrusted,
	             valueOf: valueOf };
	  }];
	}
	
	
	/**
	 * @ngdoc provider
	 * @name $sceProvider
	 * @description
	 *
	 * The $sceProvider provider allows developers to configure the {@link ng.$sce $sce} service.
	 * -   enable/disable Strict Contextual Escaping (SCE) in a module
	 * -   override the default implementation with a custom delegate
	 *
	 * Read more about {@link ng.$sce Strict Contextual Escaping (SCE)}.
	 */
	
	/* jshint maxlen: false*/
	
	/**
	 * @ngdoc service
	 * @name $sce
	 * @kind function
	 *
	 * @description
	 *
	 * `$sce` is a service that provides Strict Contextual Escaping services to AngularJS.
	 *
	 * # Strict Contextual Escaping
	 *
	 * Strict Contextual Escaping (SCE) is a mode in which AngularJS requires bindings in certain
	 * contexts to result in a value that is marked as safe to use for that context.  One example of
	 * such a context is binding arbitrary html controlled by the user via `ng-bind-html`.  We refer
	 * to these contexts as privileged or SCE contexts.
	 *
	 * As of version 1.2, Angular ships with SCE enabled by default.
	 *
	 * Note:  When enabled (the default), IE<11 in quirks mode is not supported.  In this mode, IE<11 allow
	 * one to execute arbitrary javascript by the use of the expression() syntax.  Refer
	 * <http://blogs.msdn.com/b/ie/archive/2008/10/16/ending-expressions.aspx> to learn more about them.
	 * You can ensure your document is in standards mode and not quirks mode by adding `<!doctype html>`
	 * to the top of your HTML document.
	 *
	 * SCE assists in writing code in a way that (a) is secure by default and (b) makes auditing for
	 * security vulnerabilities such as XSS, clickjacking, etc. a lot easier.
	 *
	 * Here's an example of a binding in a privileged context:
	 *
	 * ```
	 * <input ng-model="userHtml" aria-label="User input">
	 * <div ng-bind-html="userHtml"></div>
	 * ```
	 *
	 * Notice that `ng-bind-html` is bound to `userHtml` controlled by the user.  With SCE
	 * disabled, this application allows the user to render arbitrary HTML into the DIV.
	 * In a more realistic example, one may be rendering user comments, blog articles, etc. via
	 * bindings.  (HTML is just one example of a context where rendering user controlled input creates
	 * security vulnerabilities.)
	 *
	 * For the case of HTML, you might use a library, either on the client side, or on the server side,
	 * to sanitize unsafe HTML before binding to the value and rendering it in the document.
	 *
	 * How would you ensure that every place that used these types of bindings was bound to a value that
	 * was sanitized by your library (or returned as safe for rendering by your server?)  How can you
	 * ensure that you didn't accidentally delete the line that sanitized the value, or renamed some
	 * properties/fields and forgot to update the binding to the sanitized value?
	 *
	 * To be secure by default, you want to ensure that any such bindings are disallowed unless you can
	 * determine that something explicitly says it's safe to use a value for binding in that
	 * context.  You can then audit your code (a simple grep would do) to ensure that this is only done
	 * for those values that you can easily tell are safe - because they were received from your server,
	 * sanitized by your library, etc.  You can organize your codebase to help with this - perhaps
	 * allowing only the files in a specific directory to do this.  Ensuring that the internal API
	 * exposed by that code doesn't markup arbitrary values as safe then becomes a more manageable task.
	 *
	 * In the case of AngularJS' SCE service, one uses {@link ng.$sce#trustAs $sce.trustAs}
	 * (and shorthand methods such as {@link ng.$sce#trustAsHtml $sce.trustAsHtml}, etc.) to
	 * obtain values that will be accepted by SCE / privileged contexts.
	 *
	 *
	 * ## How does it work?
	 *
	 * In privileged contexts, directives and code will bind to the result of {@link ng.$sce#getTrusted
	 * $sce.getTrusted(context, value)} rather than to the value directly.  Directives use {@link
	 * ng.$sce#parseAs $sce.parseAs} rather than `$parse` to watch attribute bindings, which performs the
	 * {@link ng.$sce#getTrusted $sce.getTrusted} behind the scenes on non-constant literals.
	 *
	 * As an example, {@link ng.directive:ngBindHtml ngBindHtml} uses {@link
	 * ng.$sce#parseAsHtml $sce.parseAsHtml(binding expression)}.  Here's the actual code (slightly
	 * simplified):
	 *
	 * ```
	 * var ngBindHtmlDirective = ['$sce', function($sce) {
	 *   return function(scope, element, attr) {
	 *     scope.$watch($sce.parseAsHtml(attr.ngBindHtml), function(value) {
	 *       element.html(value || '');
	 *     });
	 *   };
	 * }];
	 * ```
	 *
	 * ## Impact on loading templates
	 *
	 * This applies both to the {@link ng.directive:ngInclude `ng-include`} directive as well as
	 * `templateUrl`'s specified by {@link guide/directive directives}.
	 *
	 * By default, Angular only loads templates from the same domain and protocol as the application
	 * document.  This is done by calling {@link ng.$sce#getTrustedResourceUrl
	 * $sce.getTrustedResourceUrl} on the template URL.  To load templates from other domains and/or
	 * protocols, you may either {@link ng.$sceDelegateProvider#resourceUrlWhitelist whitelist
	 * them} or {@link ng.$sce#trustAsResourceUrl wrap it} into a trusted value.
	 *
	 * *Please note*:
	 * The browser's
	 * [Same Origin Policy](https://code.google.com/p/browsersec/wiki/Part2#Same-origin_policy_for_XMLHttpRequest)
	 * and [Cross-Origin Resource Sharing (CORS)](http://www.w3.org/TR/cors/)
	 * policy apply in addition to this and may further restrict whether the template is successfully
	 * loaded.  This means that without the right CORS policy, loading templates from a different domain
	 * won't work on all browsers.  Also, loading templates from `file://` URL does not work on some
	 * browsers.
	 *
	 * ## This feels like too much overhead
	 *
	 * It's important to remember that SCE only applies to interpolation expressions.
	 *
	 * If your expressions are constant literals, they're automatically trusted and you don't need to
	 * call `$sce.trustAs` on them (remember to include the `ngSanitize` module) (e.g.
	 * `<div ng-bind-html="'<b>implicitly trusted</b>'"></div>`) just works.
	 *
	 * Additionally, `a[href]` and `img[src]` automatically sanitize their URLs and do not pass them
	 * through {@link ng.$sce#getTrusted $sce.getTrusted}.  SCE doesn't play a role here.
	 *
	 * The included {@link ng.$sceDelegate $sceDelegate} comes with sane defaults to allow you to load
	 * templates in `ng-include` from your application's domain without having to even know about SCE.
	 * It blocks loading templates from other domains or loading templates over http from an https
	 * served document.  You can change these by setting your own custom {@link
	 * ng.$sceDelegateProvider#resourceUrlWhitelist whitelists} and {@link
	 * ng.$sceDelegateProvider#resourceUrlBlacklist blacklists} for matching such URLs.
	 *
	 * This significantly reduces the overhead.  It is far easier to pay the small overhead and have an
	 * application that's secure and can be audited to verify that with much more ease than bolting
	 * security onto an application later.
	 *
	 * <a name="contexts"></a>
	 * ## What trusted context types are supported?
	 *
	 * | Context             | Notes          |
	 * |---------------------|----------------|
	 * | `$sce.HTML`         | For HTML that's safe to source into the application.  The {@link ng.directive:ngBindHtml ngBindHtml} directive uses this context for bindings. If an unsafe value is encountered and the {@link ngSanitize $sanitize} module is present this will sanitize the value instead of throwing an error. |
	 * | `$sce.CSS`          | For CSS that's safe to source into the application.  Currently unused.  Feel free to use it in your own directives. |
	 * | `$sce.URL`          | For URLs that are safe to follow as links.  Currently unused (`<a href=` and `<img src=` sanitize their urls and don't constitute an SCE context. |
	 * | `$sce.RESOURCE_URL` | For URLs that are not only safe to follow as links, but whose contents are also safe to include in your application.  Examples include `ng-include`, `src` / `ngSrc` bindings for tags other than `IMG` (e.g. `IFRAME`, `OBJECT`, etc.)  <br><br>Note that `$sce.RESOURCE_URL` makes a stronger statement about the URL than `$sce.URL` does and therefore contexts requiring values trusted for `$sce.RESOURCE_URL` can be used anywhere that values trusted for `$sce.URL` are required. |
	 * | `$sce.JS`           | For JavaScript that is safe to execute in your application's context.  Currently unused.  Feel free to use it in your own directives. |
	 *
	 * ## Format of items in {@link ng.$sceDelegateProvider#resourceUrlWhitelist resourceUrlWhitelist}/{@link ng.$sceDelegateProvider#resourceUrlBlacklist Blacklist} <a name="resourceUrlPatternItem"></a>
	 *
	 *  Each element in these arrays must be one of the following:
	 *
	 *  - **'self'**
	 *    - The special **string**, `'self'`, can be used to match against all URLs of the **same
	 *      domain** as the application document using the **same protocol**.
	 *  - **String** (except the special value `'self'`)
	 *    - The string is matched against the full *normalized / absolute URL* of the resource
	 *      being tested (substring matches are not good enough.)
	 *    - There are exactly **two wildcard sequences** - `*` and `**`.  All other characters
	 *      match themselves.
	 *    - `*`: matches zero or more occurrences of any character other than one of the following 6
	 *      characters: '`:`', '`/`', '`.`', '`?`', '`&`' and '`;`'.  It's a useful wildcard for use
	 *      in a whitelist.
	 *    - `**`: matches zero or more occurrences of *any* character.  As such, it's not
	 *      appropriate for use in a scheme, domain, etc. as it would match too much.  (e.g.
	 *      http://**.example.com/ would match http://evil.com/?ignore=.example.com/ and that might
	 *      not have been the intention.)  Its usage at the very end of the path is ok.  (e.g.
	 *      http://foo.example.com/templates/**).
	 *  - **RegExp** (*see caveat below*)
	 *    - *Caveat*:  While regular expressions are powerful and offer great flexibility,  their syntax
	 *      (and all the inevitable escaping) makes them *harder to maintain*.  It's easy to
	 *      accidentally introduce a bug when one updates a complex expression (imho, all regexes should
	 *      have good test coverage).  For instance, the use of `.` in the regex is correct only in a
	 *      small number of cases.  A `.` character in the regex used when matching the scheme or a
	 *      subdomain could be matched against a `:` or literal `.` that was likely not intended.   It
	 *      is highly recommended to use the string patterns and only fall back to regular expressions
	 *      as a last resort.
	 *    - The regular expression must be an instance of RegExp (i.e. not a string.)  It is
	 *      matched against the **entire** *normalized / absolute URL* of the resource being tested
	 *      (even when the RegExp did not have the `^` and `$` codes.)  In addition, any flags
	 *      present on the RegExp (such as multiline, global, ignoreCase) are ignored.
	 *    - If you are generating your JavaScript from some other templating engine (not
	 *      recommended, e.g. in issue [#4006](https://github.com/angular/angular.js/issues/4006)),
	 *      remember to escape your regular expression (and be aware that you might need more than
	 *      one level of escaping depending on your templating engine and the way you interpolated
	 *      the value.)  Do make use of your platform's escaping mechanism as it might be good
	 *      enough before coding your own.  E.g. Ruby has
	 *      [Regexp.escape(str)](http://www.ruby-doc.org/core-2.0.0/Regexp.html#method-c-escape)
	 *      and Python has [re.escape](http://docs.python.org/library/re.html#re.escape).
	 *      Javascript lacks a similar built in function for escaping.  Take a look at Google
	 *      Closure library's [goog.string.regExpEscape(s)](
	 *      http://docs.closure-library.googlecode.com/git/closure_goog_string_string.js.source.html#line962).
	 *
	 * Refer {@link ng.$sceDelegateProvider $sceDelegateProvider} for an example.
	 *
	 * ## Show me an example using SCE.
	 *
	 * <example module="mySceApp" deps="angular-sanitize.js">
	 * <file name="index.html">
	 *   <div ng-controller="AppController as myCtrl">
	 *     <i ng-bind-html="myCtrl.explicitlyTrustedHtml" id="explicitlyTrustedHtml"></i><br><br>
	 *     <b>User comments</b><br>
	 *     By default, HTML that isn't explicitly trusted (e.g. Alice's comment) is sanitized when
	 *     $sanitize is available.  If $sanitize isn't available, this results in an error instead of an
	 *     exploit.
	 *     <div class="well">
	 *       <div ng-repeat="userComment in myCtrl.userComments">
	 *         <b>{{userComment.name}}</b>:
	 *         <span ng-bind-html="userComment.htmlComment" class="htmlComment"></span>
	 *         <br>
	 *       </div>
	 *     </div>
	 *   </div>
	 * </file>
	 *
	 * <file name="script.js">
	 *   angular.module('mySceApp', ['ngSanitize'])
	 *     .controller('AppController', ['$http', '$templateCache', '$sce',
	 *       function($http, $templateCache, $sce) {
	 *         var self = this;
	 *         $http.get("test_data.json", {cache: $templateCache}).success(function(userComments) {
	 *           self.userComments = userComments;
	 *         });
	 *         self.explicitlyTrustedHtml = $sce.trustAsHtml(
	 *             '<span onmouseover="this.textContent=&quot;Explicitly trusted HTML bypasses ' +
	 *             'sanitization.&quot;">Hover over this text.</span>');
	 *       }]);
	 * </file>
	 *
	 * <file name="test_data.json">
	 * [
	 *   { "name": "Alice",
	 *     "htmlComment":
	 *         "<span onmouseover='this.textContent=\"PWN3D!\"'>Is <i>anyone</i> reading this?</span>"
	 *   },
	 *   { "name": "Bob",
	 *     "htmlComment": "<i>Yes!</i>  Am I the only other one?"
	 *   }
	 * ]
	 * </file>
	 *
	 * <file name="protractor.js" type="protractor">
	 *   describe('SCE doc demo', function() {
	 *     it('should sanitize untrusted values', function() {
	 *       expect(element.all(by.css('.htmlComment')).first().getInnerHtml())
	 *           .toBe('<span>Is <i>anyone</i> reading this?</span>');
	 *     });
	 *
	 *     it('should NOT sanitize explicitly trusted values', function() {
	 *       expect(element(by.id('explicitlyTrustedHtml')).getInnerHtml()).toBe(
	 *           '<span onmouseover="this.textContent=&quot;Explicitly trusted HTML bypasses ' +
	 *           'sanitization.&quot;">Hover over this text.</span>');
	 *     });
	 *   });
	 * </file>
	 * </example>
	 *
	 *
	 *
	 * ## Can I disable SCE completely?
	 *
	 * Yes, you can.  However, this is strongly discouraged.  SCE gives you a lot of security benefits
	 * for little coding overhead.  It will be much harder to take an SCE disabled application and
	 * either secure it on your own or enable SCE at a later stage.  It might make sense to disable SCE
	 * for cases where you have a lot of existing code that was written before SCE was introduced and
	 * you're migrating them a module at a time.
	 *
	 * That said, here's how you can completely disable SCE:
	 *
	 * ```
	 * angular.module('myAppWithSceDisabledmyApp', []).config(function($sceProvider) {
	 *   // Completely disable SCE.  For demonstration purposes only!
	 *   // Do not use in new projects.
	 *   $sceProvider.enabled(false);
	 * });
	 * ```
	 *
	 */
	/* jshint maxlen: 100 */
	
	function $SceProvider() {
	  var enabled = true;
	
	  /**
	   * @ngdoc method
	   * @name $sceProvider#enabled
	   * @kind function
	   *
	   * @param {boolean=} value If provided, then enables/disables SCE.
	   * @return {boolean} true if SCE is enabled, false otherwise.
	   *
	   * @description
	   * Enables/disables SCE and returns the current value.
	   */
	  this.enabled = function(value) {
	    if (arguments.length) {
	      enabled = !!value;
	    }
	    return enabled;
	  };
	
	
	  /* Design notes on the default implementation for SCE.
	   *
	   * The API contract for the SCE delegate
	   * -------------------------------------
	   * The SCE delegate object must provide the following 3 methods:
	   *
	   * - trustAs(contextEnum, value)
	   *     This method is used to tell the SCE service that the provided value is OK to use in the
	   *     contexts specified by contextEnum.  It must return an object that will be accepted by
	   *     getTrusted() for a compatible contextEnum and return this value.
	   *
	   * - valueOf(value)
	   *     For values that were not produced by trustAs(), return them as is.  For values that were
	   *     produced by trustAs(), return the corresponding input value to trustAs.  Basically, if
	   *     trustAs is wrapping the given values into some type, this operation unwraps it when given
	   *     such a value.
	   *
	   * - getTrusted(contextEnum, value)
	   *     This function should return the a value that is safe to use in the context specified by
	   *     contextEnum or throw and exception otherwise.
	   *
	   * NOTE: This contract deliberately does NOT state that values returned by trustAs() must be
	   * opaque or wrapped in some holder object.  That happens to be an implementation detail.  For
	   * instance, an implementation could maintain a registry of all trusted objects by context.  In
	   * such a case, trustAs() would return the same object that was passed in.  getTrusted() would
	   * return the same object passed in if it was found in the registry under a compatible context or
	   * throw an exception otherwise.  An implementation might only wrap values some of the time based
	   * on some criteria.  getTrusted() might return a value and not throw an exception for special
	   * constants or objects even if not wrapped.  All such implementations fulfill this contract.
	   *
	   *
	   * A note on the inheritance model for SCE contexts
	   * ------------------------------------------------
	   * I've used inheritance and made RESOURCE_URL wrapped types a subtype of URL wrapped types.  This
	   * is purely an implementation details.
	   *
	   * The contract is simply this:
	   *
	   *     getTrusted($sce.RESOURCE_URL, value) succeeding implies that getTrusted($sce.URL, value)
	   *     will also succeed.
	   *
	   * Inheritance happens to capture this in a natural way.  In some future, we
	   * may not use inheritance anymore.  That is OK because no code outside of
	   * sce.js and sceSpecs.js would need to be aware of this detail.
	   */
	
	  this.$get = ['$parse', '$sceDelegate', function(
	                $parse,   $sceDelegate) {
	    // Prereq: Ensure that we're not running in IE<11 quirks mode.  In that mode, IE < 11 allow
	    // the "expression(javascript expression)" syntax which is insecure.
	    if (enabled && msie < 8) {
	      throw $sceMinErr('iequirks',
	        'Strict Contextual Escaping does not support Internet Explorer version < 11 in quirks ' +
	        'mode.  You can fix this by adding the text <!doctype html> to the top of your HTML ' +
	        'document.  See http://docs.angularjs.org/api/ng.$sce for more information.');
	    }
	
	    var sce = shallowCopy(SCE_CONTEXTS);
	
	    /**
	     * @ngdoc method
	     * @name $sce#isEnabled
	     * @kind function
	     *
	     * @return {Boolean} true if SCE is enabled, false otherwise.  If you want to set the value, you
	     * have to do it at module config time on {@link ng.$sceProvider $sceProvider}.
	     *
	     * @description
	     * Returns a boolean indicating if SCE is enabled.
	     */
	    sce.isEnabled = function() {
	      return enabled;
	    };
	    sce.trustAs = $sceDelegate.trustAs;
	    sce.getTrusted = $sceDelegate.getTrusted;
	    sce.valueOf = $sceDelegate.valueOf;
	
	    if (!enabled) {
	      sce.trustAs = sce.getTrusted = function(type, value) { return value; };
	      sce.valueOf = identity;
	    }
	
	    /**
	     * @ngdoc method
	     * @name $sce#parseAs
	     *
	     * @description
	     * Converts Angular {@link guide/expression expression} into a function.  This is like {@link
	     * ng.$parse $parse} and is identical when the expression is a literal constant.  Otherwise, it
	     * wraps the expression in a call to {@link ng.$sce#getTrusted $sce.getTrusted(*type*,
	     * *result*)}
	     *
	     * @param {string} type The kind of SCE context in which this result will be used.
	     * @param {string} expression String expression to compile.
	     * @returns {function(context, locals)} a function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the strings
	     *      are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
	     *      `context`.
	     */
	    sce.parseAs = function sceParseAs(type, expr) {
	      var parsed = $parse(expr);
	      if (parsed.literal && parsed.constant) {
	        return parsed;
	      } else {
	        return $parse(expr, function(value) {
	          return sce.getTrusted(type, value);
	        });
	      }
	    };
	
	    /**
	     * @ngdoc method
	     * @name $sce#trustAs
	     *
	     * @description
	     * Delegates to {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}.  As such,
	     * returns an object that is trusted by angular for use in specified strict contextual
	     * escaping contexts (such as ng-bind-html, ng-include, any src attribute
	     * interpolation, any dom event binding attribute interpolation such as for onclick,  etc.)
	     * that uses the provided value.  See * {@link ng.$sce $sce} for enabling strict contextual
	     * escaping.
	     *
	     * @param {string} type The kind of context in which this value is safe for use.  e.g. url,
	     *   resourceUrl, html, js and css.
	     * @param {*} value The value that that should be considered trusted/safe.
	     * @returns {*} A value that can be used to stand in for the provided `value` in places
	     * where Angular expects a $sce.trustAs() return value.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#trustAsHtml
	     *
	     * @description
	     * Shorthand method.  `$sce.trustAsHtml(value)` →
	     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.HTML, value)`}
	     *
	     * @param {*} value The value to trustAs.
	     * @returns {*} An object that can be passed to {@link ng.$sce#getTrustedHtml
	     *     $sce.getTrustedHtml(value)} to obtain the original value.  (privileged directives
	     *     only accept expressions that are either literal constants or are the
	     *     return value of {@link ng.$sce#trustAs $sce.trustAs}.)
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#trustAsUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.trustAsUrl(value)` →
	     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.URL, value)`}
	     *
	     * @param {*} value The value to trustAs.
	     * @returns {*} An object that can be passed to {@link ng.$sce#getTrustedUrl
	     *     $sce.getTrustedUrl(value)} to obtain the original value.  (privileged directives
	     *     only accept expressions that are either literal constants or are the
	     *     return value of {@link ng.$sce#trustAs $sce.trustAs}.)
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#trustAsResourceUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.trustAsResourceUrl(value)` →
	     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.RESOURCE_URL, value)`}
	     *
	     * @param {*} value The value to trustAs.
	     * @returns {*} An object that can be passed to {@link ng.$sce#getTrustedResourceUrl
	     *     $sce.getTrustedResourceUrl(value)} to obtain the original value.  (privileged directives
	     *     only accept expressions that are either literal constants or are the return
	     *     value of {@link ng.$sce#trustAs $sce.trustAs}.)
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#trustAsJs
	     *
	     * @description
	     * Shorthand method.  `$sce.trustAsJs(value)` →
	     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.JS, value)`}
	     *
	     * @param {*} value The value to trustAs.
	     * @returns {*} An object that can be passed to {@link ng.$sce#getTrustedJs
	     *     $sce.getTrustedJs(value)} to obtain the original value.  (privileged directives
	     *     only accept expressions that are either literal constants or are the
	     *     return value of {@link ng.$sce#trustAs $sce.trustAs}.)
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#getTrusted
	     *
	     * @description
	     * Delegates to {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted`}.  As such,
	     * takes the result of a {@link ng.$sce#trustAs `$sce.trustAs`}() call and returns the
	     * originally supplied value if the queried context type is a supertype of the created type.
	     * If this condition isn't satisfied, throws an exception.
	     *
	     * @param {string} type The kind of context in which this value is to be used.
	     * @param {*} maybeTrusted The result of a prior {@link ng.$sce#trustAs `$sce.trustAs`}
	     *                         call.
	     * @returns {*} The value the was originally provided to
	     *              {@link ng.$sce#trustAs `$sce.trustAs`} if valid in this context.
	     *              Otherwise, throws an exception.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#getTrustedHtml
	     *
	     * @description
	     * Shorthand method.  `$sce.getTrustedHtml(value)` →
	     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.HTML, value)`}
	     *
	     * @param {*} value The value to pass to `$sce.getTrusted`.
	     * @returns {*} The return value of `$sce.getTrusted($sce.HTML, value)`
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#getTrustedCss
	     *
	     * @description
	     * Shorthand method.  `$sce.getTrustedCss(value)` →
	     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.CSS, value)`}
	     *
	     * @param {*} value The value to pass to `$sce.getTrusted`.
	     * @returns {*} The return value of `$sce.getTrusted($sce.CSS, value)`
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#getTrustedUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.getTrustedUrl(value)` →
	     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.URL, value)`}
	     *
	     * @param {*} value The value to pass to `$sce.getTrusted`.
	     * @returns {*} The return value of `$sce.getTrusted($sce.URL, value)`
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#getTrustedResourceUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.getTrustedResourceUrl(value)` →
	     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.RESOURCE_URL, value)`}
	     *
	     * @param {*} value The value to pass to `$sceDelegate.getTrusted`.
	     * @returns {*} The return value of `$sce.getTrusted($sce.RESOURCE_URL, value)`
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#getTrustedJs
	     *
	     * @description
	     * Shorthand method.  `$sce.getTrustedJs(value)` →
	     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.JS, value)`}
	     *
	     * @param {*} value The value to pass to `$sce.getTrusted`.
	     * @returns {*} The return value of `$sce.getTrusted($sce.JS, value)`
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#parseAsHtml
	     *
	     * @description
	     * Shorthand method.  `$sce.parseAsHtml(expression string)` →
	     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.HTML, value)`}
	     *
	     * @param {string} expression String expression to compile.
	     * @returns {function(context, locals)} a function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the strings
	     *      are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
	     *      `context`.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#parseAsCss
	     *
	     * @description
	     * Shorthand method.  `$sce.parseAsCss(value)` →
	     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.CSS, value)`}
	     *
	     * @param {string} expression String expression to compile.
	     * @returns {function(context, locals)} a function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the strings
	     *      are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
	     *      `context`.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#parseAsUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.parseAsUrl(value)` →
	     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.URL, value)`}
	     *
	     * @param {string} expression String expression to compile.
	     * @returns {function(context, locals)} a function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the strings
	     *      are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
	     *      `context`.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#parseAsResourceUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.parseAsResourceUrl(value)` →
	     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.RESOURCE_URL, value)`}
	     *
	     * @param {string} expression String expression to compile.
	     * @returns {function(context, locals)} a function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the strings
	     *      are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
	     *      `context`.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#parseAsJs
	     *
	     * @description
	     * Shorthand method.  `$sce.parseAsJs(value)` →
	     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.JS, value)`}
	     *
	     * @param {string} expression String expression to compile.
	     * @returns {function(context, locals)} a function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the strings
	     *      are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
	     *      `context`.
	     */
	
	    // Shorthand delegations.
	    var parse = sce.parseAs,
	        getTrusted = sce.getTrusted,
	        trustAs = sce.trustAs;
	
	    forEach(SCE_CONTEXTS, function(enumValue, name) {
	      var lName = lowercase(name);
	      sce[camelCase("parse_as_" + lName)] = function(expr) {
	        return parse(enumValue, expr);
	      };
	      sce[camelCase("get_trusted_" + lName)] = function(value) {
	        return getTrusted(enumValue, value);
	      };
	      sce[camelCase("trust_as_" + lName)] = function(value) {
	        return trustAs(enumValue, value);
	      };
	    });
	
	    return sce;
	  }];
	}
	
	/**
	 * !!! This is an undocumented "private" service !!!
	 *
	 * @name $sniffer
	 * @requires $window
	 * @requires $document
	 *
	 * @property {boolean} history Does the browser support html5 history api ?
	 * @property {boolean} transitions Does the browser support CSS transition events ?
	 * @property {boolean} animations Does the browser support CSS animation events ?
	 *
	 * @description
	 * This is very simple implementation of testing browser's features.
	 */
	function $SnifferProvider() {
	  this.$get = ['$window', '$document', function($window, $document) {
	    var eventSupport = {},
	        // Chrome Packaged Apps are not allowed to access `history.pushState`. They can be detected by
	        // the presence of `chrome.app.runtime` (see https://developer.chrome.com/apps/api_index)
	        isChromePackagedApp = $window.chrome && $window.chrome.app && $window.chrome.app.runtime,
	        hasHistoryPushState = !isChromePackagedApp && $window.history && $window.history.pushState,
	        android =
	          toInt((/android (\d+)/.exec(lowercase(($window.navigator || {}).userAgent)) || [])[1]),
	        boxee = /Boxee/i.test(($window.navigator || {}).userAgent),
	        document = $document[0] || {},
	        vendorPrefix,
	        vendorRegex = /^(Moz|webkit|ms)(?=[A-Z])/,
	        bodyStyle = document.body && document.body.style,
	        transitions = false,
	        animations = false,
	        match;
	
	    if (bodyStyle) {
	      for (var prop in bodyStyle) {
	        if (match = vendorRegex.exec(prop)) {
	          vendorPrefix = match[0];
	          vendorPrefix = vendorPrefix[0].toUpperCase() + vendorPrefix.substr(1);
	          break;
	        }
	      }
	
	      if (!vendorPrefix) {
	        vendorPrefix = ('WebkitOpacity' in bodyStyle) && 'webkit';
	      }
	
	      transitions = !!(('transition' in bodyStyle) || (vendorPrefix + 'Transition' in bodyStyle));
	      animations  = !!(('animation' in bodyStyle) || (vendorPrefix + 'Animation' in bodyStyle));
	
	      if (android && (!transitions ||  !animations)) {
	        transitions = isString(bodyStyle.webkitTransition);
	        animations = isString(bodyStyle.webkitAnimation);
	      }
	    }
	
	
	    return {
	      // Android has history.pushState, but it does not update location correctly
	      // so let's not use the history API at all.
	      // http://code.google.com/p/android/issues/detail?id=17471
	      // https://github.com/angular/angular.js/issues/904
	
	      // older webkit browser (533.9) on Boxee box has exactly the same problem as Android has
	      // so let's not use the history API also
	      // We are purposefully using `!(android < 4)` to cover the case when `android` is undefined
	      // jshint -W018
	      history: !!(hasHistoryPushState && !(android < 4) && !boxee),
	      // jshint +W018
	      hasEvent: function(event) {
	        // IE9 implements 'input' event it's so fubared that we rather pretend that it doesn't have
	        // it. In particular the event is not fired when backspace or delete key are pressed or
	        // when cut operation is performed.
	        // IE10+ implements 'input' event but it erroneously fires under various situations,
	        // e.g. when placeholder changes, or a form is focused.
	        if (event === 'input' && msie <= 11) return false;
	
	        if (isUndefined(eventSupport[event])) {
	          var divElm = document.createElement('div');
	          eventSupport[event] = 'on' + event in divElm;
	        }
	
	        return eventSupport[event];
	      },
	      csp: csp(),
	      vendorPrefix: vendorPrefix,
	      transitions: transitions,
	      animations: animations,
	      android: android
	    };
	  }];
	}
	
	var $templateRequestMinErr = minErr('$compile');
	
	/**
	 * @ngdoc provider
	 * @name $templateRequestProvider
	 * @description
	 * Used to configure the options passed to the {@link $http} service when making a template request.
	 *
	 * For example, it can be used for specifying the "Accept" header that is sent to the server, when
	 * requesting a template.
	 */
	function $TemplateRequestProvider() {
	
	  var httpOptions;
	
	  /**
	   * @ngdoc method
	   * @name $templateRequestProvider#httpOptions
	   * @description
	   * The options to be passed to the {@link $http} service when making the request.
	   * You can use this to override options such as the "Accept" header for template requests.
	   *
	   * The {@link $templateRequest} will set the `cache` and the `transformResponse` properties of the
	   * options if not overridden here.
	   *
	   * @param {string=} value new value for the {@link $http} options.
	   * @returns {string|self} Returns the {@link $http} options when used as getter and self if used as setter.
	   */
	  this.httpOptions = function(val) {
	    if (val) {
	      httpOptions = val;
	      return this;
	    }
	    return httpOptions;
	  };
	
	  /**
	   * @ngdoc service
	   * @name $templateRequest
	   *
	   * @description
	   * The `$templateRequest` service runs security checks then downloads the provided template using
	   * `$http` and, upon success, stores the contents inside of `$templateCache`. If the HTTP request
	   * fails or the response data of the HTTP request is empty, a `$compile` error will be thrown (the
	   * exception can be thwarted by setting the 2nd parameter of the function to true). Note that the
	   * contents of `$templateCache` are trusted, so the call to `$sce.getTrustedUrl(tpl)` is omitted
	   * when `tpl` is of type string and `$templateCache` has the matching entry.
	   *
	   * If you want to pass custom options to the `$http` service, such as setting the Accept header you
	   * can configure this via {@link $templateRequestProvider#httpOptions}.
	   *
	   * @param {string|TrustedResourceUrl} tpl The HTTP request template URL
	   * @param {boolean=} ignoreRequestError Whether or not to ignore the exception when the request fails or the template is empty
	   *
	   * @return {Promise} a promise for the HTTP response data of the given URL.
	   *
	   * @property {number} totalPendingRequests total amount of pending template requests being downloaded.
	   */
	  this.$get = ['$templateCache', '$http', '$q', '$sce', function($templateCache, $http, $q, $sce) {
	
	    function handleRequestFn(tpl, ignoreRequestError) {
	      handleRequestFn.totalPendingRequests++;
	
	      // We consider the template cache holds only trusted templates, so
	      // there's no need to go through whitelisting again for keys that already
	      // are included in there. This also makes Angular accept any script
	      // directive, no matter its name. However, we still need to unwrap trusted
	      // types.
	      if (!isString(tpl) || isUndefined($templateCache.get(tpl))) {
	        tpl = $sce.getTrustedResourceUrl(tpl);
	      }
	
	      var transformResponse = $http.defaults && $http.defaults.transformResponse;
	
	      if (isArray(transformResponse)) {
	        transformResponse = transformResponse.filter(function(transformer) {
	          return transformer !== defaultHttpResponseTransform;
	        });
	      } else if (transformResponse === defaultHttpResponseTransform) {
	        transformResponse = null;
	      }
	
	      return $http.get(tpl, extend({
	          cache: $templateCache,
	          transformResponse: transformResponse
	        }, httpOptions))
	        ['finally'](function() {
	          handleRequestFn.totalPendingRequests--;
	        })
	        .then(function(response) {
	          $templateCache.put(tpl, response.data);
	          return response.data;
	        }, handleError);
	
	      function handleError(resp) {
	        if (!ignoreRequestError) {
	          throw $templateRequestMinErr('tpload', 'Failed to load template: {0} (HTTP status: {1} {2})',
	            tpl, resp.status, resp.statusText);
	        }
	        return $q.reject(resp);
	      }
	    }
	
	    handleRequestFn.totalPendingRequests = 0;
	
	    return handleRequestFn;
	  }];
	}
	
	function $$TestabilityProvider() {
	  this.$get = ['$rootScope', '$browser', '$location',
	       function($rootScope,   $browser,   $location) {
	
	    /**
	     * @name $testability
	     *
	     * @description
	     * The private $$testability service provides a collection of methods for use when debugging
	     * or by automated test and debugging tools.
	     */
	    var testability = {};
	
	    /**
	     * @name $$testability#findBindings
	     *
	     * @description
	     * Returns an array of elements that are bound (via ng-bind or {{}})
	     * to expressions matching the input.
	     *
	     * @param {Element} element The element root to search from.
	     * @param {string} expression The binding expression to match.
	     * @param {boolean} opt_exactMatch If true, only returns exact matches
	     *     for the expression. Filters and whitespace are ignored.
	     */
	    testability.findBindings = function(element, expression, opt_exactMatch) {
	      var bindings = element.getElementsByClassName('ng-binding');
	      var matches = [];
	      forEach(bindings, function(binding) {
	        var dataBinding = angular.element(binding).data('$binding');
	        if (dataBinding) {
	          forEach(dataBinding, function(bindingName) {
	            if (opt_exactMatch) {
	              var matcher = new RegExp('(^|\\s)' + escapeForRegexp(expression) + '(\\s|\\||$)');
	              if (matcher.test(bindingName)) {
	                matches.push(binding);
	              }
	            } else {
	              if (bindingName.indexOf(expression) != -1) {
	                matches.push(binding);
	              }
	            }
	          });
	        }
	      });
	      return matches;
	    };
	
	    /**
	     * @name $$testability#findModels
	     *
	     * @description
	     * Returns an array of elements that are two-way found via ng-model to
	     * expressions matching the input.
	     *
	     * @param {Element} element The element root to search from.
	     * @param {string} expression The model expression to match.
	     * @param {boolean} opt_exactMatch If true, only returns exact matches
	     *     for the expression.
	     */
	    testability.findModels = function(element, expression, opt_exactMatch) {
	      var prefixes = ['ng-', 'data-ng-', 'ng\\:'];
	      for (var p = 0; p < prefixes.length; ++p) {
	        var attributeEquals = opt_exactMatch ? '=' : '*=';
	        var selector = '[' + prefixes[p] + 'model' + attributeEquals + '"' + expression + '"]';
	        var elements = element.querySelectorAll(selector);
	        if (elements.length) {
	          return elements;
	        }
	      }
	    };
	
	    /**
	     * @name $$testability#getLocation
	     *
	     * @description
	     * Shortcut for getting the location in a browser agnostic way. Returns
	     *     the path, search, and hash. (e.g. /path?a=b#hash)
	     */
	    testability.getLocation = function() {
	      return $location.url();
	    };
	
	    /**
	     * @name $$testability#setLocation
	     *
	     * @description
	     * Shortcut for navigating to a location without doing a full page reload.
	     *
	     * @param {string} url The location url (path, search and hash,
	     *     e.g. /path?a=b#hash) to go to.
	     */
	    testability.setLocation = function(url) {
	      if (url !== $location.url()) {
	        $location.url(url);
	        $rootScope.$digest();
	      }
	    };
	
	    /**
	     * @name $$testability#whenStable
	     *
	     * @description
	     * Calls the callback when $timeout and $http requests are completed.
	     *
	     * @param {function} callback
	     */
	    testability.whenStable = function(callback) {
	      $browser.notifyWhenNoOutstandingRequests(callback);
	    };
	
	    return testability;
	  }];
	}
	
	function $TimeoutProvider() {
	  this.$get = ['$rootScope', '$browser', '$q', '$$q', '$exceptionHandler',
	       function($rootScope,   $browser,   $q,   $$q,   $exceptionHandler) {
	
	    var deferreds = {};
	
	
	     /**
	      * @ngdoc service
	      * @name $timeout
	      *
	      * @description
	      * Angular's wrapper for `window.setTimeout`. The `fn` function is wrapped into a try/catch
	      * block and delegates any exceptions to
	      * {@link ng.$exceptionHandler $exceptionHandler} service.
	      *
	      * The return value of calling `$timeout` is a promise, which will be resolved when
	      * the delay has passed and the timeout function, if provided, is executed.
	      *
	      * To cancel a timeout request, call `$timeout.cancel(promise)`.
	      *
	      * In tests you can use {@link ngMock.$timeout `$timeout.flush()`} to
	      * synchronously flush the queue of deferred functions.
	      *
	      * If you only want a promise that will be resolved after some specified delay
	      * then you can call `$timeout` without the `fn` function.
	      *
	      * @param {function()=} fn A function, whose execution should be delayed.
	      * @param {number=} [delay=0] Delay in milliseconds.
	      * @param {boolean=} [invokeApply=true] If set to `false` skips model dirty checking, otherwise
	      *   will invoke `fn` within the {@link ng.$rootScope.Scope#$apply $apply} block.
	      * @param {...*=} Pass additional parameters to the executed function.
	      * @returns {Promise} Promise that will be resolved when the timeout is reached. The promise
	      *   will be resolved with the return value of the `fn` function.
	      *
	      */
	    function timeout(fn, delay, invokeApply) {
	      if (!isFunction(fn)) {
	        invokeApply = delay;
	        delay = fn;
	        fn = noop;
	      }
	
	      var args = sliceArgs(arguments, 3),
	          skipApply = (isDefined(invokeApply) && !invokeApply),
	          deferred = (skipApply ? $$q : $q).defer(),
	          promise = deferred.promise,
	          timeoutId;
	
	      timeoutId = $browser.defer(function() {
	        try {
	          deferred.resolve(fn.apply(null, args));
	        } catch (e) {
	          deferred.reject(e);
	          $exceptionHandler(e);
	        }
	        finally {
	          delete deferreds[promise.$$timeoutId];
	        }
	
	        if (!skipApply) $rootScope.$apply();
	      }, delay);
	
	      promise.$$timeoutId = timeoutId;
	      deferreds[timeoutId] = deferred;
	
	      return promise;
	    }
	
	
	     /**
	      * @ngdoc method
	      * @name $timeout#cancel
	      *
	      * @description
	      * Cancels a task associated with the `promise`. As a result of this, the promise will be
	      * resolved with a rejection.
	      *
	      * @param {Promise=} promise Promise returned by the `$timeout` function.
	      * @returns {boolean} Returns `true` if the task hasn't executed yet and was successfully
	      *   canceled.
	      */
	    timeout.cancel = function(promise) {
	      if (promise && promise.$$timeoutId in deferreds) {
	        deferreds[promise.$$timeoutId].reject('canceled');
	        delete deferreds[promise.$$timeoutId];
	        return $browser.defer.cancel(promise.$$timeoutId);
	      }
	      return false;
	    };
	
	    return timeout;
	  }];
	}
	
	// NOTE:  The usage of window and document instead of $window and $document here is
	// deliberate.  This service depends on the specific behavior of anchor nodes created by the
	// browser (resolving and parsing URLs) that is unlikely to be provided by mock objects and
	// cause us to break tests.  In addition, when the browser resolves a URL for XHR, it
	// doesn't know about mocked locations and resolves URLs to the real document - which is
	// exactly the behavior needed here.  There is little value is mocking these out for this
	// service.
	var urlParsingNode = window.document.createElement("a");
	var originUrl = urlResolve(window.location.href);
	
	
	/**
	 *
	 * Implementation Notes for non-IE browsers
	 * ----------------------------------------
	 * Assigning a URL to the href property of an anchor DOM node, even one attached to the DOM,
	 * results both in the normalizing and parsing of the URL.  Normalizing means that a relative
	 * URL will be resolved into an absolute URL in the context of the application document.
	 * Parsing means that the anchor node's host, hostname, protocol, port, pathname and related
	 * properties are all populated to reflect the normalized URL.  This approach has wide
	 * compatibility - Safari 1+, Mozilla 1+, Opera 7+,e etc.  See
	 * http://www.aptana.com/reference/html/api/HTMLAnchorElement.html
	 *
	 * Implementation Notes for IE
	 * ---------------------------
	 * IE <= 10 normalizes the URL when assigned to the anchor node similar to the other
	 * browsers.  However, the parsed components will not be set if the URL assigned did not specify
	 * them.  (e.g. if you assign a.href = "foo", then a.protocol, a.host, etc. will be empty.)  We
	 * work around that by performing the parsing in a 2nd step by taking a previously normalized
	 * URL (e.g. by assigning to a.href) and assigning it a.href again.  This correctly populates the
	 * properties such as protocol, hostname, port, etc.
	 *
	 * References:
	 *   http://developer.mozilla.org/en-US/docs/Web/API/HTMLAnchorElement
	 *   http://www.aptana.com/reference/html/api/HTMLAnchorElement.html
	 *   http://url.spec.whatwg.org/#urlutils
	 *   https://github.com/angular/angular.js/pull/2902
	 *   http://james.padolsey.com/javascript/parsing-urls-with-the-dom/
	 *
	 * @kind function
	 * @param {string} url The URL to be parsed.
	 * @description Normalizes and parses a URL.
	 * @returns {object} Returns the normalized URL as a dictionary.
	 *
	 *   | member name   | Description    |
	 *   |---------------|----------------|
	 *   | href          | A normalized version of the provided URL if it was not an absolute URL |
	 *   | protocol      | The protocol including the trailing colon                              |
	 *   | host          | The host and port (if the port is non-default) of the normalizedUrl    |
	 *   | search        | The search params, minus the question mark                             |
	 *   | hash          | The hash string, minus the hash symbol
	 *   | hostname      | The hostname
	 *   | port          | The port, without ":"
	 *   | pathname      | The pathname, beginning with "/"
	 *
	 */
	function urlResolve(url) {
	  var href = url;
	
	  if (msie) {
	    // Normalize before parse.  Refer Implementation Notes on why this is
	    // done in two steps on IE.
	    urlParsingNode.setAttribute("href", href);
	    href = urlParsingNode.href;
	  }
	
	  urlParsingNode.setAttribute('href', href);
	
	  // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
	  return {
	    href: urlParsingNode.href,
	    protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
	    host: urlParsingNode.host,
	    search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
	    hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
	    hostname: urlParsingNode.hostname,
	    port: urlParsingNode.port,
	    pathname: (urlParsingNode.pathname.charAt(0) === '/')
	      ? urlParsingNode.pathname
	      : '/' + urlParsingNode.pathname
	  };
	}
	
	/**
	 * Parse a request URL and determine whether this is a same-origin request as the application document.
	 *
	 * @param {string|object} requestUrl The url of the request as a string that will be resolved
	 * or a parsed URL object.
	 * @returns {boolean} Whether the request is for the same origin as the application document.
	 */
	function urlIsSameOrigin(requestUrl) {
	  var parsed = (isString(requestUrl)) ? urlResolve(requestUrl) : requestUrl;
	  return (parsed.protocol === originUrl.protocol &&
	          parsed.host === originUrl.host);
	}
	
	/**
	 * @ngdoc service
	 * @name $window
	 *
	 * @description
	 * A reference to the browser's `window` object. While `window`
	 * is globally available in JavaScript, it causes testability problems, because
	 * it is a global variable. In angular we always refer to it through the
	 * `$window` service, so it may be overridden, removed or mocked for testing.
	 *
	 * Expressions, like the one defined for the `ngClick` directive in the example
	 * below, are evaluated with respect to the current scope.  Therefore, there is
	 * no risk of inadvertently coding in a dependency on a global value in such an
	 * expression.
	 *
	 * @example
	   <example module="windowExample">
	     <file name="index.html">
	       <script>
	         angular.module('windowExample', [])
	           .controller('ExampleController', ['$scope', '$window', function($scope, $window) {
	             $scope.greeting = 'Hello, World!';
	             $scope.doGreeting = function(greeting) {
	               $window.alert(greeting);
	             };
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <input type="text" ng-model="greeting" aria-label="greeting" />
	         <button ng-click="doGreeting(greeting)">ALERT</button>
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	      it('should display the greeting in the input box', function() {
	       element(by.model('greeting')).sendKeys('Hello, E2E Tests');
	       // If we click the button it will block the test runner
	       // element(':button').click();
	      });
	     </file>
	   </example>
	 */
	function $WindowProvider() {
	  this.$get = valueFn(window);
	}
	
	/**
	 * @name $$cookieReader
	 * @requires $document
	 *
	 * @description
	 * This is a private service for reading cookies used by $http and ngCookies
	 *
	 * @return {Object} a key/value map of the current cookies
	 */
	function $$CookieReader($document) {
	  var rawDocument = $document[0] || {};
	  var lastCookies = {};
	  var lastCookieString = '';
	
	  function safeDecodeURIComponent(str) {
	    try {
	      return decodeURIComponent(str);
	    } catch (e) {
	      return str;
	    }
	  }
	
	  return function() {
	    var cookieArray, cookie, i, index, name;
	    var currentCookieString = rawDocument.cookie || '';
	
	    if (currentCookieString !== lastCookieString) {
	      lastCookieString = currentCookieString;
	      cookieArray = lastCookieString.split('; ');
	      lastCookies = {};
	
	      for (i = 0; i < cookieArray.length; i++) {
	        cookie = cookieArray[i];
	        index = cookie.indexOf('=');
	        if (index > 0) { //ignore nameless cookies
	          name = safeDecodeURIComponent(cookie.substring(0, index));
	          // the first value that is seen for a cookie is the most
	          // specific one.  values for the same cookie name that
	          // follow are for less specific paths.
	          if (isUndefined(lastCookies[name])) {
	            lastCookies[name] = safeDecodeURIComponent(cookie.substring(index + 1));
	          }
	        }
	      }
	    }
	    return lastCookies;
	  };
	}
	
	$$CookieReader.$inject = ['$document'];
	
	function $$CookieReaderProvider() {
	  this.$get = $$CookieReader;
	}
	
	/* global currencyFilter: true,
	 dateFilter: true,
	 filterFilter: true,
	 jsonFilter: true,
	 limitToFilter: true,
	 lowercaseFilter: true,
	 numberFilter: true,
	 orderByFilter: true,
	 uppercaseFilter: true,
	 */
	
	/**
	 * @ngdoc provider
	 * @name $filterProvider
	 * @description
	 *
	 * Filters are just functions which transform input to an output. However filters need to be
	 * Dependency Injected. To achieve this a filter definition consists of a factory function which is
	 * annotated with dependencies and is responsible for creating a filter function.
	 *
	 * <div class="alert alert-warning">
	 * **Note:** Filter names must be valid angular {@link expression} identifiers, such as `uppercase` or `orderBy`.
	 * Names with special characters, such as hyphens and dots, are not allowed. If you wish to namespace
	 * your filters, then you can use capitalization (`myappSubsectionFilterx`) or underscores
	 * (`myapp_subsection_filterx`).
	 * </div>
	 *
	 * ```js
	 *   // Filter registration
	 *   function MyModule($provide, $filterProvider) {
	 *     // create a service to demonstrate injection (not always needed)
	 *     $provide.value('greet', function(name){
	 *       return 'Hello ' + name + '!';
	 *     });
	 *
	 *     // register a filter factory which uses the
	 *     // greet service to demonstrate DI.
	 *     $filterProvider.register('greet', function(greet){
	 *       // return the filter function which uses the greet service
	 *       // to generate salutation
	 *       return function(text) {
	 *         // filters need to be forgiving so check input validity
	 *         return text && greet(text) || text;
	 *       };
	 *     });
	 *   }
	 * ```
	 *
	 * The filter function is registered with the `$injector` under the filter name suffix with
	 * `Filter`.
	 *
	 * ```js
	 *   it('should be the same instance', inject(
	 *     function($filterProvider) {
	 *       $filterProvider.register('reverse', function(){
	 *         return ...;
	 *       });
	 *     },
	 *     function($filter, reverseFilter) {
	 *       expect($filter('reverse')).toBe(reverseFilter);
	 *     });
	 * ```
	 *
	 *
	 * For more information about how angular filters work, and how to create your own filters, see
	 * {@link guide/filter Filters} in the Angular Developer Guide.
	 */
	
	/**
	 * @ngdoc service
	 * @name $filter
	 * @kind function
	 * @description
	 * Filters are used for formatting data displayed to the user.
	 *
	 * The general syntax in templates is as follows:
	 *
	 *         {{ expression [| filter_name[:parameter_value] ... ] }}
	 *
	 * @param {String} name Name of the filter function to retrieve
	 * @return {Function} the filter function
	 * @example
	   <example name="$filter" module="filterExample">
	     <file name="index.html">
	       <div ng-controller="MainCtrl">
	        <h3>{{ originalText }}</h3>
	        <h3>{{ filteredText }}</h3>
	       </div>
	     </file>
	
	     <file name="script.js">
	      angular.module('filterExample', [])
	      .controller('MainCtrl', function($scope, $filter) {
	        $scope.originalText = 'hello';
	        $scope.filteredText = $filter('uppercase')($scope.originalText);
	      });
	     </file>
	   </example>
	  */
	$FilterProvider.$inject = ['$provide'];
	function $FilterProvider($provide) {
	  var suffix = 'Filter';
	
	  /**
	   * @ngdoc method
	   * @name $filterProvider#register
	   * @param {string|Object} name Name of the filter function, or an object map of filters where
	   *    the keys are the filter names and the values are the filter factories.
	   *
	   *    <div class="alert alert-warning">
	   *    **Note:** Filter names must be valid angular {@link expression} identifiers, such as `uppercase` or `orderBy`.
	   *    Names with special characters, such as hyphens and dots, are not allowed. If you wish to namespace
	   *    your filters, then you can use capitalization (`myappSubsectionFilterx`) or underscores
	   *    (`myapp_subsection_filterx`).
	   *    </div>
	    * @param {Function} factory If the first argument was a string, a factory function for the filter to be registered.
	   * @returns {Object} Registered filter instance, or if a map of filters was provided then a map
	   *    of the registered filter instances.
	   */
	  function register(name, factory) {
	    if (isObject(name)) {
	      var filters = {};
	      forEach(name, function(filter, key) {
	        filters[key] = register(key, filter);
	      });
	      return filters;
	    } else {
	      return $provide.factory(name + suffix, factory);
	    }
	  }
	  this.register = register;
	
	  this.$get = ['$injector', function($injector) {
	    return function(name) {
	      return $injector.get(name + suffix);
	    };
	  }];
	
	  ////////////////////////////////////////
	
	  /* global
	    currencyFilter: false,
	    dateFilter: false,
	    filterFilter: false,
	    jsonFilter: false,
	    limitToFilter: false,
	    lowercaseFilter: false,
	    numberFilter: false,
	    orderByFilter: false,
	    uppercaseFilter: false,
	  */
	
	  register('currency', currencyFilter);
	  register('date', dateFilter);
	  register('filter', filterFilter);
	  register('json', jsonFilter);
	  register('limitTo', limitToFilter);
	  register('lowercase', lowercaseFilter);
	  register('number', numberFilter);
	  register('orderBy', orderByFilter);
	  register('uppercase', uppercaseFilter);
	}
	
	/**
	 * @ngdoc filter
	 * @name filter
	 * @kind function
	 *
	 * @description
	 * Selects a subset of items from `array` and returns it as a new array.
	 *
	 * @param {Array} array The source array.
	 * @param {string|Object|function()} expression The predicate to be used for selecting items from
	 *   `array`.
	 *
	 *   Can be one of:
	 *
	 *   - `string`: The string is used for matching against the contents of the `array`. All strings or
	 *     objects with string properties in `array` that match this string will be returned. This also
	 *     applies to nested object properties.
	 *     The predicate can be negated by prefixing the string with `!`.
	 *
	 *   - `Object`: A pattern object can be used to filter specific properties on objects contained
	 *     by `array`. For example `{name:"M", phone:"1"}` predicate will return an array of items
	 *     which have property `name` containing "M" and property `phone` containing "1". A special
	 *     property name `$` can be used (as in `{$:"text"}`) to accept a match against any
	 *     property of the object or its nested object properties. That's equivalent to the simple
	 *     substring match with a `string` as described above. The predicate can be negated by prefixing
	 *     the string with `!`.
	 *     For example `{name: "!M"}` predicate will return an array of items which have property `name`
	 *     not containing "M".
	 *
	 *     Note that a named property will match properties on the same level only, while the special
	 *     `$` property will match properties on the same level or deeper. E.g. an array item like
	 *     `{name: {first: 'John', last: 'Doe'}}` will **not** be matched by `{name: 'John'}`, but
	 *     **will** be matched by `{$: 'John'}`.
	 *
	 *   - `function(value, index, array)`: A predicate function can be used to write arbitrary filters.
	 *     The function is called for each element of the array, with the element, its index, and
	 *     the entire array itself as arguments.
	 *
	 *     The final result is an array of those elements that the predicate returned true for.
	 *
	 * @param {function(actual, expected)|true|undefined} comparator Comparator which is used in
	 *     determining if the expected value (from the filter expression) and actual value (from
	 *     the object in the array) should be considered a match.
	 *
	 *   Can be one of:
	 *
	 *   - `function(actual, expected)`:
	 *     The function will be given the object value and the predicate value to compare and
	 *     should return true if both values should be considered equal.
	 *
	 *   - `true`: A shorthand for `function(actual, expected) { return angular.equals(actual, expected)}`.
	 *     This is essentially strict comparison of expected and actual.
	 *
	 *   - `false|undefined`: A short hand for a function which will look for a substring match in case
	 *     insensitive way.
	 *
	 *     Primitive values are converted to strings. Objects are not compared against primitives,
	 *     unless they have a custom `toString` method (e.g. `Date` objects).
	 *
	 * @example
	   <example>
	     <file name="index.html">
	       <div ng-init="friends = [{name:'John', phone:'555-1276'},
	                                {name:'Mary', phone:'800-BIG-MARY'},
	                                {name:'Mike', phone:'555-4321'},
	                                {name:'Adam', phone:'555-5678'},
	                                {name:'Julie', phone:'555-8765'},
	                                {name:'Juliette', phone:'555-5678'}]"></div>
	
	       <label>Search: <input ng-model="searchText"></label>
	       <table id="searchTextResults">
	         <tr><th>Name</th><th>Phone</th></tr>
	         <tr ng-repeat="friend in friends | filter:searchText">
	           <td>{{friend.name}}</td>
	           <td>{{friend.phone}}</td>
	         </tr>
	       </table>
	       <hr>
	       <label>Any: <input ng-model="search.$"></label> <br>
	       <label>Name only <input ng-model="search.name"></label><br>
	       <label>Phone only <input ng-model="search.phone"></label><br>
	       <label>Equality <input type="checkbox" ng-model="strict"></label><br>
	       <table id="searchObjResults">
	         <tr><th>Name</th><th>Phone</th></tr>
	         <tr ng-repeat="friendObj in friends | filter:search:strict">
	           <td>{{friendObj.name}}</td>
	           <td>{{friendObj.phone}}</td>
	         </tr>
	       </table>
	     </file>
	     <file name="protractor.js" type="protractor">
	       var expectFriendNames = function(expectedNames, key) {
	         element.all(by.repeater(key + ' in friends').column(key + '.name')).then(function(arr) {
	           arr.forEach(function(wd, i) {
	             expect(wd.getText()).toMatch(expectedNames[i]);
	           });
	         });
	       };
	
	       it('should search across all fields when filtering with a string', function() {
	         var searchText = element(by.model('searchText'));
	         searchText.clear();
	         searchText.sendKeys('m');
	         expectFriendNames(['Mary', 'Mike', 'Adam'], 'friend');
	
	         searchText.clear();
	         searchText.sendKeys('76');
	         expectFriendNames(['John', 'Julie'], 'friend');
	       });
	
	       it('should search in specific fields when filtering with a predicate object', function() {
	         var searchAny = element(by.model('search.$'));
	         searchAny.clear();
	         searchAny.sendKeys('i');
	         expectFriendNames(['Mary', 'Mike', 'Julie', 'Juliette'], 'friendObj');
	       });
	       it('should use a equal comparison when comparator is true', function() {
	         var searchName = element(by.model('search.name'));
	         var strict = element(by.model('strict'));
	         searchName.clear();
	         searchName.sendKeys('Julie');
	         strict.click();
	         expectFriendNames(['Julie'], 'friendObj');
	       });
	     </file>
	   </example>
	 */
	function filterFilter() {
	  return function(array, expression, comparator) {
	    if (!isArrayLike(array)) {
	      if (array == null) {
	        return array;
	      } else {
	        throw minErr('filter')('notarray', 'Expected array but received: {0}', array);
	      }
	    }
	
	    var expressionType = getTypeForFilter(expression);
	    var predicateFn;
	    var matchAgainstAnyProp;
	
	    switch (expressionType) {
	      case 'function':
	        predicateFn = expression;
	        break;
	      case 'boolean':
	      case 'null':
	      case 'number':
	      case 'string':
	        matchAgainstAnyProp = true;
	        //jshint -W086
	      case 'object':
	        //jshint +W086
	        predicateFn = createPredicateFn(expression, comparator, matchAgainstAnyProp);
	        break;
	      default:
	        return array;
	    }
	
	    return Array.prototype.filter.call(array, predicateFn);
	  };
	}
	
	// Helper functions for `filterFilter`
	function createPredicateFn(expression, comparator, matchAgainstAnyProp) {
	  var shouldMatchPrimitives = isObject(expression) && ('$' in expression);
	  var predicateFn;
	
	  if (comparator === true) {
	    comparator = equals;
	  } else if (!isFunction(comparator)) {
	    comparator = function(actual, expected) {
	      if (isUndefined(actual)) {
	        // No substring matching against `undefined`
	        return false;
	      }
	      if ((actual === null) || (expected === null)) {
	        // No substring matching against `null`; only match against `null`
	        return actual === expected;
	      }
	      if (isObject(expected) || (isObject(actual) && !hasCustomToString(actual))) {
	        // Should not compare primitives against objects, unless they have custom `toString` method
	        return false;
	      }
	
	      actual = lowercase('' + actual);
	      expected = lowercase('' + expected);
	      return actual.indexOf(expected) !== -1;
	    };
	  }
	
	  predicateFn = function(item) {
	    if (shouldMatchPrimitives && !isObject(item)) {
	      return deepCompare(item, expression.$, comparator, false);
	    }
	    return deepCompare(item, expression, comparator, matchAgainstAnyProp);
	  };
	
	  return predicateFn;
	}
	
	function deepCompare(actual, expected, comparator, matchAgainstAnyProp, dontMatchWholeObject) {
	  var actualType = getTypeForFilter(actual);
	  var expectedType = getTypeForFilter(expected);
	
	  if ((expectedType === 'string') && (expected.charAt(0) === '!')) {
	    return !deepCompare(actual, expected.substring(1), comparator, matchAgainstAnyProp);
	  } else if (isArray(actual)) {
	    // In case `actual` is an array, consider it a match
	    // if ANY of it's items matches `expected`
	    return actual.some(function(item) {
	      return deepCompare(item, expected, comparator, matchAgainstAnyProp);
	    });
	  }
	
	  switch (actualType) {
	    case 'object':
	      var key;
	      if (matchAgainstAnyProp) {
	        for (key in actual) {
	          if ((key.charAt(0) !== '$') && deepCompare(actual[key], expected, comparator, true)) {
	            return true;
	          }
	        }
	        return dontMatchWholeObject ? false : deepCompare(actual, expected, comparator, false);
	      } else if (expectedType === 'object') {
	        for (key in expected) {
	          var expectedVal = expected[key];
	          if (isFunction(expectedVal) || isUndefined(expectedVal)) {
	            continue;
	          }
	
	          var matchAnyProperty = key === '$';
	          var actualVal = matchAnyProperty ? actual : actual[key];
	          if (!deepCompare(actualVal, expectedVal, comparator, matchAnyProperty, matchAnyProperty)) {
	            return false;
	          }
	        }
	        return true;
	      } else {
	        return comparator(actual, expected);
	      }
	      break;
	    case 'function':
	      return false;
	    default:
	      return comparator(actual, expected);
	  }
	}
	
	// Used for easily differentiating between `null` and actual `object`
	function getTypeForFilter(val) {
	  return (val === null) ? 'null' : typeof val;
	}
	
	var MAX_DIGITS = 22;
	var DECIMAL_SEP = '.';
	var ZERO_CHAR = '0';
	
	/**
	 * @ngdoc filter
	 * @name currency
	 * @kind function
	 *
	 * @description
	 * Formats a number as a currency (ie $1,234.56). When no currency symbol is provided, default
	 * symbol for current locale is used.
	 *
	 * @param {number} amount Input to filter.
	 * @param {string=} symbol Currency symbol or identifier to be displayed.
	 * @param {number=} fractionSize Number of decimal places to round the amount to, defaults to default max fraction size for current locale
	 * @returns {string} Formatted number.
	 *
	 *
	 * @example
	   <example module="currencyExample">
	     <file name="index.html">
	       <script>
	         angular.module('currencyExample', [])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.amount = 1234.56;
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <input type="number" ng-model="amount" aria-label="amount"> <br>
	         default currency symbol ($): <span id="currency-default">{{amount | currency}}</span><br>
	         custom currency identifier (USD$): <span id="currency-custom">{{amount | currency:"USD$"}}</span>
	         no fractions (0): <span id="currency-no-fractions">{{amount | currency:"USD$":0}}</span>
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should init with 1234.56', function() {
	         expect(element(by.id('currency-default')).getText()).toBe('$1,234.56');
	         expect(element(by.id('currency-custom')).getText()).toBe('USD$1,234.56');
	         expect(element(by.id('currency-no-fractions')).getText()).toBe('USD$1,235');
	       });
	       it('should update', function() {
	         if (browser.params.browser == 'safari') {
	           // Safari does not understand the minus key. See
	           // https://github.com/angular/protractor/issues/481
	           return;
	         }
	         element(by.model('amount')).clear();
	         element(by.model('amount')).sendKeys('-1234');
	         expect(element(by.id('currency-default')).getText()).toBe('-$1,234.00');
	         expect(element(by.id('currency-custom')).getText()).toBe('-USD$1,234.00');
	         expect(element(by.id('currency-no-fractions')).getText()).toBe('-USD$1,234');
	       });
	     </file>
	   </example>
	 */
	currencyFilter.$inject = ['$locale'];
	function currencyFilter($locale) {
	  var formats = $locale.NUMBER_FORMATS;
	  return function(amount, currencySymbol, fractionSize) {
	    if (isUndefined(currencySymbol)) {
	      currencySymbol = formats.CURRENCY_SYM;
	    }
	
	    if (isUndefined(fractionSize)) {
	      fractionSize = formats.PATTERNS[1].maxFrac;
	    }
	
	    // if null or undefined pass it through
	    return (amount == null)
	        ? amount
	        : formatNumber(amount, formats.PATTERNS[1], formats.GROUP_SEP, formats.DECIMAL_SEP, fractionSize).
	            replace(/\u00A4/g, currencySymbol);
	  };
	}
	
	/**
	 * @ngdoc filter
	 * @name number
	 * @kind function
	 *
	 * @description
	 * Formats a number as text.
	 *
	 * If the input is null or undefined, it will just be returned.
	 * If the input is infinite (Infinity or -Infinity), the Infinity symbol '∞' or '-∞' is returned, respectively.
	 * If the input is not a number an empty string is returned.
	 *
	 *
	 * @param {number|string} number Number to format.
	 * @param {(number|string)=} fractionSize Number of decimal places to round the number to.
	 * If this is not provided then the fraction size is computed from the current locale's number
	 * formatting pattern. In the case of the default locale, it will be 3.
	 * @returns {string} Number rounded to `fractionSize` appropriately formatted based on the current
	 *                   locale (e.g., in the en_US locale it will have "." as the decimal separator and
	 *                   include "," group separators after each third digit).
	 *
	 * @example
	   <example module="numberFilterExample">
	     <file name="index.html">
	       <script>
	         angular.module('numberFilterExample', [])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.val = 1234.56789;
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <label>Enter number: <input ng-model='val'></label><br>
	         Default formatting: <span id='number-default'>{{val | number}}</span><br>
	         No fractions: <span>{{val | number:0}}</span><br>
	         Negative number: <span>{{-val | number:4}}</span>
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should format numbers', function() {
	         expect(element(by.id('number-default')).getText()).toBe('1,234.568');
	         expect(element(by.binding('val | number:0')).getText()).toBe('1,235');
	         expect(element(by.binding('-val | number:4')).getText()).toBe('-1,234.5679');
	       });
	
	       it('should update', function() {
	         element(by.model('val')).clear();
	         element(by.model('val')).sendKeys('3374.333');
	         expect(element(by.id('number-default')).getText()).toBe('3,374.333');
	         expect(element(by.binding('val | number:0')).getText()).toBe('3,374');
	         expect(element(by.binding('-val | number:4')).getText()).toBe('-3,374.3330');
	      });
	     </file>
	   </example>
	 */
	numberFilter.$inject = ['$locale'];
	function numberFilter($locale) {
	  var formats = $locale.NUMBER_FORMATS;
	  return function(number, fractionSize) {
	
	    // if null or undefined pass it through
	    return (number == null)
	        ? number
	        : formatNumber(number, formats.PATTERNS[0], formats.GROUP_SEP, formats.DECIMAL_SEP,
	                       fractionSize);
	  };
	}
	
	/**
	 * Parse a number (as a string) into three components that can be used
	 * for formatting the number.
	 *
	 * (Significant bits of this parse algorithm came from https://github.com/MikeMcl/big.js/)
	 *
	 * @param  {string} numStr The number to parse
	 * @return {object} An object describing this number, containing the following keys:
	 *  - d : an array of digits containing leading zeros as necessary
	 *  - i : the number of the digits in `d` that are to the left of the decimal point
	 *  - e : the exponent for numbers that would need more than `MAX_DIGITS` digits in `d`
	 *
	 */
	function parse(numStr) {
	  var exponent = 0, digits, numberOfIntegerDigits;
	  var i, j, zeros;
	
	  // Decimal point?
	  if ((numberOfIntegerDigits = numStr.indexOf(DECIMAL_SEP)) > -1) {
	    numStr = numStr.replace(DECIMAL_SEP, '');
	  }
	
	  // Exponential form?
	  if ((i = numStr.search(/e/i)) > 0) {
	    // Work out the exponent.
	    if (numberOfIntegerDigits < 0) numberOfIntegerDigits = i;
	    numberOfIntegerDigits += +numStr.slice(i + 1);
	    numStr = numStr.substring(0, i);
	  } else if (numberOfIntegerDigits < 0) {
	    // There was no decimal point or exponent so it is an integer.
	    numberOfIntegerDigits = numStr.length;
	  }
	
	  // Count the number of leading zeros.
	  for (i = 0; numStr.charAt(i) == ZERO_CHAR; i++) {/* jshint noempty: false */}
	
	  if (i == (zeros = numStr.length)) {
	    // The digits are all zero.
	    digits = [0];
	    numberOfIntegerDigits = 1;
	  } else {
	    // Count the number of trailing zeros
	    zeros--;
	    while (numStr.charAt(zeros) == ZERO_CHAR) zeros--;
	
	    // Trailing zeros are insignificant so ignore them
	    numberOfIntegerDigits -= i;
	    digits = [];
	    // Convert string to array of digits without leading/trailing zeros.
	    for (j = 0; i <= zeros; i++, j++) {
	      digits[j] = +numStr.charAt(i);
	    }
	  }
	
	  // If the number overflows the maximum allowed digits then use an exponent.
	  if (numberOfIntegerDigits > MAX_DIGITS) {
	    digits = digits.splice(0, MAX_DIGITS - 1);
	    exponent = numberOfIntegerDigits - 1;
	    numberOfIntegerDigits = 1;
	  }
	
	  return { d: digits, e: exponent, i: numberOfIntegerDigits };
	}
	
	/**
	 * Round the parsed number to the specified number of decimal places
	 * This function changed the parsedNumber in-place
	 */
	function roundNumber(parsedNumber, fractionSize, minFrac, maxFrac) {
	    var digits = parsedNumber.d;
	    var fractionLen = digits.length - parsedNumber.i;
	
	    // determine fractionSize if it is not specified; `+fractionSize` converts it to a number
	    fractionSize = (isUndefined(fractionSize)) ? Math.min(Math.max(minFrac, fractionLen), maxFrac) : +fractionSize;
	
	    // The index of the digit to where rounding is to occur
	    var roundAt = fractionSize + parsedNumber.i;
	    var digit = digits[roundAt];
	
	    if (roundAt > 0) {
	      // Drop fractional digits beyond `roundAt`
	      digits.splice(Math.max(parsedNumber.i, roundAt));
	
	      // Set non-fractional digits beyond `roundAt` to 0
	      for (var j = roundAt; j < digits.length; j++) {
	        digits[j] = 0;
	      }
	    } else {
	      // We rounded to zero so reset the parsedNumber
	      fractionLen = Math.max(0, fractionLen);
	      parsedNumber.i = 1;
	      digits.length = Math.max(1, roundAt = fractionSize + 1);
	      digits[0] = 0;
	      for (var i = 1; i < roundAt; i++) digits[i] = 0;
	    }
	
	    if (digit >= 5) {
	      if (roundAt - 1 < 0) {
	        for (var k = 0; k > roundAt; k--) {
	          digits.unshift(0);
	          parsedNumber.i++;
	        }
	        digits.unshift(1);
	        parsedNumber.i++;
	      } else {
	        digits[roundAt - 1]++;
	      }
	    }
	
	    // Pad out with zeros to get the required fraction length
	    for (; fractionLen < Math.max(0, fractionSize); fractionLen++) digits.push(0);
	
	
	    // Do any carrying, e.g. a digit was rounded up to 10
	    var carry = digits.reduceRight(function(carry, d, i, digits) {
	      d = d + carry;
	      digits[i] = d % 10;
	      return Math.floor(d / 10);
	    }, 0);
	    if (carry) {
	      digits.unshift(carry);
	      parsedNumber.i++;
	    }
	}
	
	/**
	 * Format a number into a string
	 * @param  {number} number       The number to format
	 * @param  {{
	 *           minFrac, // the minimum number of digits required in the fraction part of the number
	 *           maxFrac, // the maximum number of digits required in the fraction part of the number
	 *           gSize,   // number of digits in each group of separated digits
	 *           lgSize,  // number of digits in the last group of digits before the decimal separator
	 *           negPre,  // the string to go in front of a negative number (e.g. `-` or `(`))
	 *           posPre,  // the string to go in front of a positive number
	 *           negSuf,  // the string to go after a negative number (e.g. `)`)
	 *           posSuf   // the string to go after a positive number
	 *         }} pattern
	 * @param  {string} groupSep     The string to separate groups of number (e.g. `,`)
	 * @param  {string} decimalSep   The string to act as the decimal separator (e.g. `.`)
	 * @param  {[type]} fractionSize The size of the fractional part of the number
	 * @return {string}              The number formatted as a string
	 */
	function formatNumber(number, pattern, groupSep, decimalSep, fractionSize) {
	
	  if (!(isString(number) || isNumber(number)) || isNaN(number)) return '';
	
	  var isInfinity = !isFinite(number);
	  var isZero = false;
	  var numStr = Math.abs(number) + '',
	      formattedText = '',
	      parsedNumber;
	
	  if (isInfinity) {
	    formattedText = '\u221e';
	  } else {
	    parsedNumber = parse(numStr);
	
	    roundNumber(parsedNumber, fractionSize, pattern.minFrac, pattern.maxFrac);
	
	    var digits = parsedNumber.d;
	    var integerLen = parsedNumber.i;
	    var exponent = parsedNumber.e;
	    var decimals = [];
	    isZero = digits.reduce(function(isZero, d) { return isZero && !d; }, true);
	
	    // pad zeros for small numbers
	    while (integerLen < 0) {
	      digits.unshift(0);
	      integerLen++;
	    }
	
	    // extract decimals digits
	    if (integerLen > 0) {
	      decimals = digits.splice(integerLen, digits.length);
	    } else {
	      decimals = digits;
	      digits = [0];
	    }
	
	    // format the integer digits with grouping separators
	    var groups = [];
	    if (digits.length >= pattern.lgSize) {
	      groups.unshift(digits.splice(-pattern.lgSize, digits.length).join(''));
	    }
	    while (digits.length > pattern.gSize) {
	      groups.unshift(digits.splice(-pattern.gSize, digits.length).join(''));
	    }
	    if (digits.length) {
	      groups.unshift(digits.join(''));
	    }
	    formattedText = groups.join(groupSep);
	
	    // append the decimal digits
	    if (decimals.length) {
	      formattedText += decimalSep + decimals.join('');
	    }
	
	    if (exponent) {
	      formattedText += 'e+' + exponent;
	    }
	  }
	  if (number < 0 && !isZero) {
	    return pattern.negPre + formattedText + pattern.negSuf;
	  } else {
	    return pattern.posPre + formattedText + pattern.posSuf;
	  }
	}
	
	function padNumber(num, digits, trim, negWrap) {
	  var neg = '';
	  if (num < 0 || (negWrap && num <= 0)) {
	    if (negWrap) {
	      num = -num + 1;
	    } else {
	      num = -num;
	      neg = '-';
	    }
	  }
	  num = '' + num;
	  while (num.length < digits) num = ZERO_CHAR + num;
	  if (trim) {
	    num = num.substr(num.length - digits);
	  }
	  return neg + num;
	}
	
	
	function dateGetter(name, size, offset, trim, negWrap) {
	  offset = offset || 0;
	  return function(date) {
	    var value = date['get' + name]();
	    if (offset > 0 || value > -offset) {
	      value += offset;
	    }
	    if (value === 0 && offset == -12) value = 12;
	    return padNumber(value, size, trim, negWrap);
	  };
	}
	
	function dateStrGetter(name, shortForm, standAlone) {
	  return function(date, formats) {
	    var value = date['get' + name]();
	    var propPrefix = (standAlone ? 'STANDALONE' : '') + (shortForm ? 'SHORT' : '');
	    var get = uppercase(propPrefix + name);
	
	    return formats[get][value];
	  };
	}
	
	function timeZoneGetter(date, formats, offset) {
	  var zone = -1 * offset;
	  var paddedZone = (zone >= 0) ? "+" : "";
	
	  paddedZone += padNumber(Math[zone > 0 ? 'floor' : 'ceil'](zone / 60), 2) +
	                padNumber(Math.abs(zone % 60), 2);
	
	  return paddedZone;
	}
	
	function getFirstThursdayOfYear(year) {
	    // 0 = index of January
	    var dayOfWeekOnFirst = (new Date(year, 0, 1)).getDay();
	    // 4 = index of Thursday (+1 to account for 1st = 5)
	    // 11 = index of *next* Thursday (+1 account for 1st = 12)
	    return new Date(year, 0, ((dayOfWeekOnFirst <= 4) ? 5 : 12) - dayOfWeekOnFirst);
	}
	
	function getThursdayThisWeek(datetime) {
	    return new Date(datetime.getFullYear(), datetime.getMonth(),
	      // 4 = index of Thursday
	      datetime.getDate() + (4 - datetime.getDay()));
	}
	
	function weekGetter(size) {
	   return function(date) {
	      var firstThurs = getFirstThursdayOfYear(date.getFullYear()),
	         thisThurs = getThursdayThisWeek(date);
	
	      var diff = +thisThurs - +firstThurs,
	         result = 1 + Math.round(diff / 6.048e8); // 6.048e8 ms per week
	
	      return padNumber(result, size);
	   };
	}
	
	function ampmGetter(date, formats) {
	  return date.getHours() < 12 ? formats.AMPMS[0] : formats.AMPMS[1];
	}
	
	function eraGetter(date, formats) {
	  return date.getFullYear() <= 0 ? formats.ERAS[0] : formats.ERAS[1];
	}
	
	function longEraGetter(date, formats) {
	  return date.getFullYear() <= 0 ? formats.ERANAMES[0] : formats.ERANAMES[1];
	}
	
	var DATE_FORMATS = {
	  yyyy: dateGetter('FullYear', 4, 0, false, true),
	    yy: dateGetter('FullYear', 2, 0, true, true),
	     y: dateGetter('FullYear', 1, 0, false, true),
	  MMMM: dateStrGetter('Month'),
	   MMM: dateStrGetter('Month', true),
	    MM: dateGetter('Month', 2, 1),
	     M: dateGetter('Month', 1, 1),
	  LLLL: dateStrGetter('Month', false, true),
	    dd: dateGetter('Date', 2),
	     d: dateGetter('Date', 1),
	    HH: dateGetter('Hours', 2),
	     H: dateGetter('Hours', 1),
	    hh: dateGetter('Hours', 2, -12),
	     h: dateGetter('Hours', 1, -12),
	    mm: dateGetter('Minutes', 2),
	     m: dateGetter('Minutes', 1),
	    ss: dateGetter('Seconds', 2),
	     s: dateGetter('Seconds', 1),
	     // while ISO 8601 requires fractions to be prefixed with `.` or `,`
	     // we can be just safely rely on using `sss` since we currently don't support single or two digit fractions
	   sss: dateGetter('Milliseconds', 3),
	  EEEE: dateStrGetter('Day'),
	   EEE: dateStrGetter('Day', true),
	     a: ampmGetter,
	     Z: timeZoneGetter,
	    ww: weekGetter(2),
	     w: weekGetter(1),
	     G: eraGetter,
	     GG: eraGetter,
	     GGG: eraGetter,
	     GGGG: longEraGetter
	};
	
	var DATE_FORMATS_SPLIT = /((?:[^yMLdHhmsaZEwG']+)|(?:'(?:[^']|'')*')|(?:E+|y+|M+|L+|d+|H+|h+|m+|s+|a|Z|G+|w+))(.*)/,
	    NUMBER_STRING = /^\-?\d+$/;
	
	/**
	 * @ngdoc filter
	 * @name date
	 * @kind function
	 *
	 * @description
	 *   Formats `date` to a string based on the requested `format`.
	 *
	 *   `format` string can be composed of the following elements:
	 *
	 *   * `'yyyy'`: 4 digit representation of year (e.g. AD 1 => 0001, AD 2010 => 2010)
	 *   * `'yy'`: 2 digit representation of year, padded (00-99). (e.g. AD 2001 => 01, AD 2010 => 10)
	 *   * `'y'`: 1 digit representation of year, e.g. (AD 1 => 1, AD 199 => 199)
	 *   * `'MMMM'`: Month in year (January-December)
	 *   * `'MMM'`: Month in year (Jan-Dec)
	 *   * `'MM'`: Month in year, padded (01-12)
	 *   * `'M'`: Month in year (1-12)
	 *   * `'LLLL'`: Stand-alone month in year (January-December)
	 *   * `'dd'`: Day in month, padded (01-31)
	 *   * `'d'`: Day in month (1-31)
	 *   * `'EEEE'`: Day in Week,(Sunday-Saturday)
	 *   * `'EEE'`: Day in Week, (Sun-Sat)
	 *   * `'HH'`: Hour in day, padded (00-23)
	 *   * `'H'`: Hour in day (0-23)
	 *   * `'hh'`: Hour in AM/PM, padded (01-12)
	 *   * `'h'`: Hour in AM/PM, (1-12)
	 *   * `'mm'`: Minute in hour, padded (00-59)
	 *   * `'m'`: Minute in hour (0-59)
	 *   * `'ss'`: Second in minute, padded (00-59)
	 *   * `'s'`: Second in minute (0-59)
	 *   * `'sss'`: Millisecond in second, padded (000-999)
	 *   * `'a'`: AM/PM marker
	 *   * `'Z'`: 4 digit (+sign) representation of the timezone offset (-1200-+1200)
	 *   * `'ww'`: Week of year, padded (00-53). Week 01 is the week with the first Thursday of the year
	 *   * `'w'`: Week of year (0-53). Week 1 is the week with the first Thursday of the year
	 *   * `'G'`, `'GG'`, `'GGG'`: The abbreviated form of the era string (e.g. 'AD')
	 *   * `'GGGG'`: The long form of the era string (e.g. 'Anno Domini')
	 *
	 *   `format` string can also be one of the following predefined
	 *   {@link guide/i18n localizable formats}:
	 *
	 *   * `'medium'`: equivalent to `'MMM d, y h:mm:ss a'` for en_US locale
	 *     (e.g. Sep 3, 2010 12:05:08 PM)
	 *   * `'short'`: equivalent to `'M/d/yy h:mm a'` for en_US  locale (e.g. 9/3/10 12:05 PM)
	 *   * `'fullDate'`: equivalent to `'EEEE, MMMM d, y'` for en_US  locale
	 *     (e.g. Friday, September 3, 2010)
	 *   * `'longDate'`: equivalent to `'MMMM d, y'` for en_US  locale (e.g. September 3, 2010)
	 *   * `'mediumDate'`: equivalent to `'MMM d, y'` for en_US  locale (e.g. Sep 3, 2010)
	 *   * `'shortDate'`: equivalent to `'M/d/yy'` for en_US locale (e.g. 9/3/10)
	 *   * `'mediumTime'`: equivalent to `'h:mm:ss a'` for en_US locale (e.g. 12:05:08 PM)
	 *   * `'shortTime'`: equivalent to `'h:mm a'` for en_US locale (e.g. 12:05 PM)
	 *
	 *   `format` string can contain literal values. These need to be escaped by surrounding with single quotes (e.g.
	 *   `"h 'in the morning'"`). In order to output a single quote, escape it - i.e., two single quotes in a sequence
	 *   (e.g. `"h 'o''clock'"`).
	 *
	 * @param {(Date|number|string)} date Date to format either as Date object, milliseconds (string or
	 *    number) or various ISO 8601 datetime string formats (e.g. yyyy-MM-ddTHH:mm:ss.sssZ and its
	 *    shorter versions like yyyy-MM-ddTHH:mmZ, yyyy-MM-dd or yyyyMMddTHHmmssZ). If no timezone is
	 *    specified in the string input, the time is considered to be in the local timezone.
	 * @param {string=} format Formatting rules (see Description). If not specified,
	 *    `mediumDate` is used.
	 * @param {string=} timezone Timezone to be used for formatting. It understands UTC/GMT and the
	 *    continental US time zone abbreviations, but for general use, use a time zone offset, for
	 *    example, `'+0430'` (4 hours, 30 minutes east of the Greenwich meridian)
	 *    If not specified, the timezone of the browser will be used.
	 * @returns {string} Formatted string or the input if input is not recognized as date/millis.
	 *
	 * @example
	   <example>
	     <file name="index.html">
	       <span ng-non-bindable>{{1288323623006 | date:'medium'}}</span>:
	           <span>{{1288323623006 | date:'medium'}}</span><br>
	       <span ng-non-bindable>{{1288323623006 | date:'yyyy-MM-dd HH:mm:ss Z'}}</span>:
	          <span>{{1288323623006 | date:'yyyy-MM-dd HH:mm:ss Z'}}</span><br>
	       <span ng-non-bindable>{{1288323623006 | date:'MM/dd/yyyy @ h:mma'}}</span>:
	          <span>{{'1288323623006' | date:'MM/dd/yyyy @ h:mma'}}</span><br>
	       <span ng-non-bindable>{{1288323623006 | date:"MM/dd/yyyy 'at' h:mma"}}</span>:
	          <span>{{'1288323623006' | date:"MM/dd/yyyy 'at' h:mma"}}</span><br>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should format date', function() {
	         expect(element(by.binding("1288323623006 | date:'medium'")).getText()).
	            toMatch(/Oct 2\d, 2010 \d{1,2}:\d{2}:\d{2} (AM|PM)/);
	         expect(element(by.binding("1288323623006 | date:'yyyy-MM-dd HH:mm:ss Z'")).getText()).
	            toMatch(/2010\-10\-2\d \d{2}:\d{2}:\d{2} (\-|\+)?\d{4}/);
	         expect(element(by.binding("'1288323623006' | date:'MM/dd/yyyy @ h:mma'")).getText()).
	            toMatch(/10\/2\d\/2010 @ \d{1,2}:\d{2}(AM|PM)/);
	         expect(element(by.binding("'1288323623006' | date:\"MM/dd/yyyy 'at' h:mma\"")).getText()).
	            toMatch(/10\/2\d\/2010 at \d{1,2}:\d{2}(AM|PM)/);
	       });
	     </file>
	   </example>
	 */
	dateFilter.$inject = ['$locale'];
	function dateFilter($locale) {
	
	
	  var R_ISO8601_STR = /^(\d{4})-?(\d\d)-?(\d\d)(?:T(\d\d)(?::?(\d\d)(?::?(\d\d)(?:\.(\d+))?)?)?(Z|([+-])(\d\d):?(\d\d))?)?$/;
	                     // 1        2       3         4          5          6          7          8  9     10      11
	  function jsonStringToDate(string) {
	    var match;
	    if (match = string.match(R_ISO8601_STR)) {
	      var date = new Date(0),
	          tzHour = 0,
	          tzMin  = 0,
	          dateSetter = match[8] ? date.setUTCFullYear : date.setFullYear,
	          timeSetter = match[8] ? date.setUTCHours : date.setHours;
	
	      if (match[9]) {
	        tzHour = toInt(match[9] + match[10]);
	        tzMin = toInt(match[9] + match[11]);
	      }
	      dateSetter.call(date, toInt(match[1]), toInt(match[2]) - 1, toInt(match[3]));
	      var h = toInt(match[4] || 0) - tzHour;
	      var m = toInt(match[5] || 0) - tzMin;
	      var s = toInt(match[6] || 0);
	      var ms = Math.round(parseFloat('0.' + (match[7] || 0)) * 1000);
	      timeSetter.call(date, h, m, s, ms);
	      return date;
	    }
	    return string;
	  }
	
	
	  return function(date, format, timezone) {
	    var text = '',
	        parts = [],
	        fn, match;
	
	    format = format || 'mediumDate';
	    format = $locale.DATETIME_FORMATS[format] || format;
	    if (isString(date)) {
	      date = NUMBER_STRING.test(date) ? toInt(date) : jsonStringToDate(date);
	    }
	
	    if (isNumber(date)) {
	      date = new Date(date);
	    }
	
	    if (!isDate(date) || !isFinite(date.getTime())) {
	      return date;
	    }
	
	    while (format) {
	      match = DATE_FORMATS_SPLIT.exec(format);
	      if (match) {
	        parts = concat(parts, match, 1);
	        format = parts.pop();
	      } else {
	        parts.push(format);
	        format = null;
	      }
	    }
	
	    var dateTimezoneOffset = date.getTimezoneOffset();
	    if (timezone) {
	      dateTimezoneOffset = timezoneToOffset(timezone, dateTimezoneOffset);
	      date = convertTimezoneToLocal(date, timezone, true);
	    }
	    forEach(parts, function(value) {
	      fn = DATE_FORMATS[value];
	      text += fn ? fn(date, $locale.DATETIME_FORMATS, dateTimezoneOffset)
	                 : value === "''" ? "'" : value.replace(/(^'|'$)/g, '').replace(/''/g, "'");
	    });
	
	    return text;
	  };
	}
	
	
	/**
	 * @ngdoc filter
	 * @name json
	 * @kind function
	 *
	 * @description
	 *   Allows you to convert a JavaScript object into JSON string.
	 *
	 *   This filter is mostly useful for debugging. When using the double curly {{value}} notation
	 *   the binding is automatically converted to JSON.
	 *
	 * @param {*} object Any JavaScript object (including arrays and primitive types) to filter.
	 * @param {number=} spacing The number of spaces to use per indentation, defaults to 2.
	 * @returns {string} JSON string.
	 *
	 *
	 * @example
	   <example>
	     <file name="index.html">
	       <pre id="default-spacing">{{ {'name':'value'} | json }}</pre>
	       <pre id="custom-spacing">{{ {'name':'value'} | json:4 }}</pre>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should jsonify filtered objects', function() {
	         expect(element(by.id('default-spacing')).getText()).toMatch(/\{\n  "name": ?"value"\n}/);
	         expect(element(by.id('custom-spacing')).getText()).toMatch(/\{\n    "name": ?"value"\n}/);
	       });
	     </file>
	   </example>
	 *
	 */
	function jsonFilter() {
	  return function(object, spacing) {
	    if (isUndefined(spacing)) {
	        spacing = 2;
	    }
	    return toJson(object, spacing);
	  };
	}
	
	
	/**
	 * @ngdoc filter
	 * @name lowercase
	 * @kind function
	 * @description
	 * Converts string to lowercase.
	 * @see angular.lowercase
	 */
	var lowercaseFilter = valueFn(lowercase);
	
	
	/**
	 * @ngdoc filter
	 * @name uppercase
	 * @kind function
	 * @description
	 * Converts string to uppercase.
	 * @see angular.uppercase
	 */
	var uppercaseFilter = valueFn(uppercase);
	
	/**
	 * @ngdoc filter
	 * @name limitTo
	 * @kind function
	 *
	 * @description
	 * Creates a new array or string containing only a specified number of elements. The elements
	 * are taken from either the beginning or the end of the source array, string or number, as specified by
	 * the value and sign (positive or negative) of `limit`. If a number is used as input, it is
	 * converted to a string.
	 *
	 * @param {Array|string|number} input Source array, string or number to be limited.
	 * @param {string|number} limit The length of the returned array or string. If the `limit` number
	 *     is positive, `limit` number of items from the beginning of the source array/string are copied.
	 *     If the number is negative, `limit` number  of items from the end of the source array/string
	 *     are copied. The `limit` will be trimmed if it exceeds `array.length`. If `limit` is undefined,
	 *     the input will be returned unchanged.
	 * @param {(string|number)=} begin Index at which to begin limitation. As a negative index, `begin`
	 *     indicates an offset from the end of `input`. Defaults to `0`.
	 * @returns {Array|string} A new sub-array or substring of length `limit` or less if input array
	 *     had less than `limit` elements.
	 *
	 * @example
	   <example module="limitToExample">
	     <file name="index.html">
	       <script>
	         angular.module('limitToExample', [])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.numbers = [1,2,3,4,5,6,7,8,9];
	             $scope.letters = "abcdefghi";
	             $scope.longNumber = 2345432342;
	             $scope.numLimit = 3;
	             $scope.letterLimit = 3;
	             $scope.longNumberLimit = 3;
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <label>
	            Limit {{numbers}} to:
	            <input type="number" step="1" ng-model="numLimit">
	         </label>
	         <p>Output numbers: {{ numbers | limitTo:numLimit }}</p>
	         <label>
	            Limit {{letters}} to:
	            <input type="number" step="1" ng-model="letterLimit">
	         </label>
	         <p>Output letters: {{ letters | limitTo:letterLimit }}</p>
	         <label>
	            Limit {{longNumber}} to:
	            <input type="number" step="1" ng-model="longNumberLimit">
	         </label>
	         <p>Output long number: {{ longNumber | limitTo:longNumberLimit }}</p>
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       var numLimitInput = element(by.model('numLimit'));
	       var letterLimitInput = element(by.model('letterLimit'));
	       var longNumberLimitInput = element(by.model('longNumberLimit'));
	       var limitedNumbers = element(by.binding('numbers | limitTo:numLimit'));
	       var limitedLetters = element(by.binding('letters | limitTo:letterLimit'));
	       var limitedLongNumber = element(by.binding('longNumber | limitTo:longNumberLimit'));
	
	       it('should limit the number array to first three items', function() {
	         expect(numLimitInput.getAttribute('value')).toBe('3');
	         expect(letterLimitInput.getAttribute('value')).toBe('3');
	         expect(longNumberLimitInput.getAttribute('value')).toBe('3');
	         expect(limitedNumbers.getText()).toEqual('Output numbers: [1,2,3]');
	         expect(limitedLetters.getText()).toEqual('Output letters: abc');
	         expect(limitedLongNumber.getText()).toEqual('Output long number: 234');
	       });
	
	       // There is a bug in safari and protractor that doesn't like the minus key
	       // it('should update the output when -3 is entered', function() {
	       //   numLimitInput.clear();
	       //   numLimitInput.sendKeys('-3');
	       //   letterLimitInput.clear();
	       //   letterLimitInput.sendKeys('-3');
	       //   longNumberLimitInput.clear();
	       //   longNumberLimitInput.sendKeys('-3');
	       //   expect(limitedNumbers.getText()).toEqual('Output numbers: [7,8,9]');
	       //   expect(limitedLetters.getText()).toEqual('Output letters: ghi');
	       //   expect(limitedLongNumber.getText()).toEqual('Output long number: 342');
	       // });
	
	       it('should not exceed the maximum size of input array', function() {
	         numLimitInput.clear();
	         numLimitInput.sendKeys('100');
	         letterLimitInput.clear();
	         letterLimitInput.sendKeys('100');
	         longNumberLimitInput.clear();
	         longNumberLimitInput.sendKeys('100');
	         expect(limitedNumbers.getText()).toEqual('Output numbers: [1,2,3,4,5,6,7,8,9]');
	         expect(limitedLetters.getText()).toEqual('Output letters: abcdefghi');
	         expect(limitedLongNumber.getText()).toEqual('Output long number: 2345432342');
	       });
	     </file>
	   </example>
	*/
	function limitToFilter() {
	  return function(input, limit, begin) {
	    if (Math.abs(Number(limit)) === Infinity) {
	      limit = Number(limit);
	    } else {
	      limit = toInt(limit);
	    }
	    if (isNaN(limit)) return input;
	
	    if (isNumber(input)) input = input.toString();
	    if (!isArray(input) && !isString(input)) return input;
	
	    begin = (!begin || isNaN(begin)) ? 0 : toInt(begin);
	    begin = (begin < 0) ? Math.max(0, input.length + begin) : begin;
	
	    if (limit >= 0) {
	      return input.slice(begin, begin + limit);
	    } else {
	      if (begin === 0) {
	        return input.slice(limit, input.length);
	      } else {
	        return input.slice(Math.max(0, begin + limit), begin);
	      }
	    }
	  };
	}
	
	/**
	 * @ngdoc filter
	 * @name orderBy
	 * @kind function
	 *
	 * @description
	 * Orders a specified `array` by the `expression` predicate. It is ordered alphabetically
	 * for strings and numerically for numbers. Note: if you notice numbers are not being sorted
	 * as expected, make sure they are actually being saved as numbers and not strings.
	 * Array-like values (e.g. NodeLists, jQuery objects, TypedArrays, Strings, etc) are also supported.
	 *
	 * @param {Array} array The array (or array-like object) to sort.
	 * @param {function(*)|string|Array.<(function(*)|string)>=} expression A predicate to be
	 *    used by the comparator to determine the order of elements.
	 *
	 *    Can be one of:
	 *
	 *    - `function`: Getter function. The result of this function will be sorted using the
	 *      `<`, `===`, `>` operator.
	 *    - `string`: An Angular expression. The result of this expression is used to compare elements
	 *      (for example `name` to sort by a property called `name` or `name.substr(0, 3)` to sort by
	 *      3 first characters of a property called `name`). The result of a constant expression
	 *      is interpreted as a property name to be used in comparisons (for example `"special name"`
	 *      to sort object by the value of their `special name` property). An expression can be
	 *      optionally prefixed with `+` or `-` to control ascending or descending sort order
	 *      (for example, `+name` or `-name`). If no property is provided, (e.g. `'+'`) then the array
	 *      element itself is used to compare where sorting.
	 *    - `Array`: An array of function or string predicates. The first predicate in the array
	 *      is used for sorting, but when two items are equivalent, the next predicate is used.
	 *
	 *    If the predicate is missing or empty then it defaults to `'+'`.
	 *
	 * @param {boolean=} reverse Reverse the order of the array.
	 * @returns {Array} Sorted copy of the source array.
	 *
	 *
	 * @example
	 * The example below demonstrates a simple ngRepeat, where the data is sorted
	 * by age in descending order (predicate is set to `'-age'`).
	 * `reverse` is not set, which means it defaults to `false`.
	   <example module="orderByExample">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	         <table class="friend">
	           <tr>
	             <th>Name</th>
	             <th>Phone Number</th>
	             <th>Age</th>
	           </tr>
	           <tr ng-repeat="friend in friends | orderBy:'-age'">
	             <td>{{friend.name}}</td>
	             <td>{{friend.phone}}</td>
	             <td>{{friend.age}}</td>
	           </tr>
	         </table>
	       </div>
	     </file>
	     <file name="script.js">
	       angular.module('orderByExample', [])
	         .controller('ExampleController', ['$scope', function($scope) {
	           $scope.friends =
	               [{name:'John', phone:'555-1212', age:10},
	                {name:'Mary', phone:'555-9876', age:19},
	                {name:'Mike', phone:'555-4321', age:21},
	                {name:'Adam', phone:'555-5678', age:35},
	                {name:'Julie', phone:'555-8765', age:29}];
	         }]);
	     </file>
	   </example>
	 *
	 * The predicate and reverse parameters can be controlled dynamically through scope properties,
	 * as shown in the next example.
	 * @example
	   <example module="orderByExample">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	         <pre>Sorting predicate = {{predicate}}; reverse = {{reverse}}</pre>
	         <hr/>
	         <button ng-click="predicate=''">Set to unsorted</button>
	         <table class="friend">
	           <tr>
	            <th>
	                <button ng-click="order('name')">Name</button>
	                <span class="sortorder" ng-show="predicate === 'name'" ng-class="{reverse:reverse}"></span>
	            </th>
	            <th>
	                <button ng-click="order('phone')">Phone Number</button>
	                <span class="sortorder" ng-show="predicate === 'phone'" ng-class="{reverse:reverse}"></span>
	            </th>
	            <th>
	                <button ng-click="order('age')">Age</button>
	                <span class="sortorder" ng-show="predicate === 'age'" ng-class="{reverse:reverse}"></span>
	            </th>
	           </tr>
	           <tr ng-repeat="friend in friends | orderBy:predicate:reverse">
	             <td>{{friend.name}}</td>
	             <td>{{friend.phone}}</td>
	             <td>{{friend.age}}</td>
	           </tr>
	         </table>
	       </div>
	     </file>
	     <file name="script.js">
	       angular.module('orderByExample', [])
	         .controller('ExampleController', ['$scope', function($scope) {
	           $scope.friends =
	               [{name:'John', phone:'555-1212', age:10},
	                {name:'Mary', phone:'555-9876', age:19},
	                {name:'Mike', phone:'555-4321', age:21},
	                {name:'Adam', phone:'555-5678', age:35},
	                {name:'Julie', phone:'555-8765', age:29}];
	           $scope.predicate = 'age';
	           $scope.reverse = true;
	           $scope.order = function(predicate) {
	             $scope.reverse = ($scope.predicate === predicate) ? !$scope.reverse : false;
	             $scope.predicate = predicate;
	           };
	         }]);
	      </file>
	     <file name="style.css">
	       .sortorder:after {
	         content: '\25b2';
	       }
	       .sortorder.reverse:after {
	         content: '\25bc';
	       }
	     </file>
	   </example>
	 *
	 * It's also possible to call the orderBy filter manually, by injecting `$filter`, retrieving the
	 * filter routine with `$filter('orderBy')`, and calling the returned filter routine with the
	 * desired parameters.
	 *
	 * Example:
	 *
	 * @example
	  <example module="orderByExample">
	    <file name="index.html">
	    <div ng-controller="ExampleController">
	      <pre>Sorting predicate = {{predicate}}; reverse = {{reverse}}</pre>
	      <table class="friend">
	        <tr>
	          <th>
	              <button ng-click="order('name')">Name</button>
	              <span class="sortorder" ng-show="predicate === 'name'" ng-class="{reverse:reverse}"></span>
	          </th>
	          <th>
	              <button ng-click="order('phone')">Phone Number</button>
	              <span class="sortorder" ng-show="predicate === 'phone'" ng-class="{reverse:reverse}"></span>
	          </th>
	          <th>
	              <button ng-click="order('age')">Age</button>
	              <span class="sortorder" ng-show="predicate === 'age'" ng-class="{reverse:reverse}"></span>
	          </th>
	        </tr>
	        <tr ng-repeat="friend in friends">
	          <td>{{friend.name}}</td>
	          <td>{{friend.phone}}</td>
	          <td>{{friend.age}}</td>
	        </tr>
	      </table>
	    </div>
	    </file>
	
	    <file name="script.js">
	      angular.module('orderByExample', [])
	        .controller('ExampleController', ['$scope', '$filter', function($scope, $filter) {
	          var orderBy = $filter('orderBy');
	          $scope.friends = [
	            { name: 'John',    phone: '555-1212',    age: 10 },
	            { name: 'Mary',    phone: '555-9876',    age: 19 },
	            { name: 'Mike',    phone: '555-4321',    age: 21 },
	            { name: 'Adam',    phone: '555-5678',    age: 35 },
	            { name: 'Julie',   phone: '555-8765',    age: 29 }
	          ];
	          $scope.order = function(predicate) {
	            $scope.predicate = predicate;
	            $scope.reverse = ($scope.predicate === predicate) ? !$scope.reverse : false;
	            $scope.friends = orderBy($scope.friends, predicate, $scope.reverse);
	          };
	          $scope.order('age', true);
	        }]);
	    </file>
	
	    <file name="style.css">
	       .sortorder:after {
	         content: '\25b2';
	       }
	       .sortorder.reverse:after {
	         content: '\25bc';
	       }
	    </file>
	</example>
	 */
	orderByFilter.$inject = ['$parse'];
	function orderByFilter($parse) {
	  return function(array, sortPredicate, reverseOrder) {
	
	    if (array == null) return array;
	    if (!isArrayLike(array)) {
	      throw minErr('orderBy')('notarray', 'Expected array but received: {0}', array);
	    }
	
	    if (!isArray(sortPredicate)) { sortPredicate = [sortPredicate]; }
	    if (sortPredicate.length === 0) { sortPredicate = ['+']; }
	
	    var predicates = processPredicates(sortPredicate, reverseOrder);
	    // Add a predicate at the end that evaluates to the element index. This makes the
	    // sort stable as it works as a tie-breaker when all the input predicates cannot
	    // distinguish between two elements.
	    predicates.push({ get: function() { return {}; }, descending: reverseOrder ? -1 : 1});
	
	    // The next three lines are a version of a Swartzian Transform idiom from Perl
	    // (sometimes called the Decorate-Sort-Undecorate idiom)
	    // See https://en.wikipedia.org/wiki/Schwartzian_transform
	    var compareValues = Array.prototype.map.call(array, getComparisonObject);
	    compareValues.sort(doComparison);
	    array = compareValues.map(function(item) { return item.value; });
	
	    return array;
	
	    function getComparisonObject(value, index) {
	      return {
	        value: value,
	        predicateValues: predicates.map(function(predicate) {
	          return getPredicateValue(predicate.get(value), index);
	        })
	      };
	    }
	
	    function doComparison(v1, v2) {
	      var result = 0;
	      for (var index=0, length = predicates.length; index < length; ++index) {
	        result = compare(v1.predicateValues[index], v2.predicateValues[index]) * predicates[index].descending;
	        if (result) break;
	      }
	      return result;
	    }
	  };
	
	  function processPredicates(sortPredicate, reverseOrder) {
	    reverseOrder = reverseOrder ? -1 : 1;
	    return sortPredicate.map(function(predicate) {
	      var descending = 1, get = identity;
	
	      if (isFunction(predicate)) {
	        get = predicate;
	      } else if (isString(predicate)) {
	        if ((predicate.charAt(0) == '+' || predicate.charAt(0) == '-')) {
	          descending = predicate.charAt(0) == '-' ? -1 : 1;
	          predicate = predicate.substring(1);
	        }
	        if (predicate !== '') {
	          get = $parse(predicate);
	          if (get.constant) {
	            var key = get();
	            get = function(value) { return value[key]; };
	          }
	        }
	      }
	      return { get: get, descending: descending * reverseOrder };
	    });
	  }
	
	  function isPrimitive(value) {
	    switch (typeof value) {
	      case 'number': /* falls through */
	      case 'boolean': /* falls through */
	      case 'string':
	        return true;
	      default:
	        return false;
	    }
	  }
	
	  function objectValue(value, index) {
	    // If `valueOf` is a valid function use that
	    if (typeof value.valueOf === 'function') {
	      value = value.valueOf();
	      if (isPrimitive(value)) return value;
	    }
	    // If `toString` is a valid function and not the one from `Object.prototype` use that
	    if (hasCustomToString(value)) {
	      value = value.toString();
	      if (isPrimitive(value)) return value;
	    }
	    // We have a basic object so we use the position of the object in the collection
	    return index;
	  }
	
	  function getPredicateValue(value, index) {
	    var type = typeof value;
	    if (value === null) {
	      type = 'string';
	      value = 'null';
	    } else if (type === 'string') {
	      value = value.toLowerCase();
	    } else if (type === 'object') {
	      value = objectValue(value, index);
	    }
	    return { value: value, type: type };
	  }
	
	  function compare(v1, v2) {
	    var result = 0;
	    if (v1.type === v2.type) {
	      if (v1.value !== v2.value) {
	        result = v1.value < v2.value ? -1 : 1;
	      }
	    } else {
	      result = v1.type < v2.type ? -1 : 1;
	    }
	    return result;
	  }
	}
	
	function ngDirective(directive) {
	  if (isFunction(directive)) {
	    directive = {
	      link: directive
	    };
	  }
	  directive.restrict = directive.restrict || 'AC';
	  return valueFn(directive);
	}
	
	/**
	 * @ngdoc directive
	 * @name a
	 * @restrict E
	 *
	 * @description
	 * Modifies the default behavior of the html A tag so that the default action is prevented when
	 * the href attribute is empty.
	 *
	 * This change permits the easy creation of action links with the `ngClick` directive
	 * without changing the location or causing page reloads, e.g.:
	 * `<a href="" ng-click="list.addItem()">Add Item</a>`
	 */
	var htmlAnchorDirective = valueFn({
	  restrict: 'E',
	  compile: function(element, attr) {
	    if (!attr.href && !attr.xlinkHref) {
	      return function(scope, element) {
	        // If the linked element is not an anchor tag anymore, do nothing
	        if (element[0].nodeName.toLowerCase() !== 'a') return;
	
	        // SVGAElement does not use the href attribute, but rather the 'xlinkHref' attribute.
	        var href = toString.call(element.prop('href')) === '[object SVGAnimatedString]' ?
	                   'xlink:href' : 'href';
	        element.on('click', function(event) {
	          // if we have no href url, then don't navigate anywhere.
	          if (!element.attr(href)) {
	            event.preventDefault();
	          }
	        });
	      };
	    }
	  }
	});
	
	/**
	 * @ngdoc directive
	 * @name ngHref
	 * @restrict A
	 * @priority 99
	 *
	 * @description
	 * Using Angular markup like `{{hash}}` in an href attribute will
	 * make the link go to the wrong URL if the user clicks it before
	 * Angular has a chance to replace the `{{hash}}` markup with its
	 * value. Until Angular replaces the markup the link will be broken
	 * and will most likely return a 404 error. The `ngHref` directive
	 * solves this problem.
	 *
	 * The wrong way to write it:
	 * ```html
	 * <a href="http://www.gravatar.com/avatar/{{hash}}">link1</a>
	 * ```
	 *
	 * The correct way to write it:
	 * ```html
	 * <a ng-href="http://www.gravatar.com/avatar/{{hash}}">link1</a>
	 * ```
	 *
	 * @element A
	 * @param {template} ngHref any string which can contain `{{}}` markup.
	 *
	 * @example
	 * This example shows various combinations of `href`, `ng-href` and `ng-click` attributes
	 * in links and their different behaviors:
	    <example>
	      <file name="index.html">
	        <input ng-model="value" /><br />
	        <a id="link-1" href ng-click="value = 1">link 1</a> (link, don't reload)<br />
	        <a id="link-2" href="" ng-click="value = 2">link 2</a> (link, don't reload)<br />
	        <a id="link-3" ng-href="/{{'123'}}">link 3</a> (link, reload!)<br />
	        <a id="link-4" href="" name="xx" ng-click="value = 4">anchor</a> (link, don't reload)<br />
	        <a id="link-5" name="xxx" ng-click="value = 5">anchor</a> (no link)<br />
	        <a id="link-6" ng-href="{{value}}">link</a> (link, change location)
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should execute ng-click but not reload when href without value', function() {
	          element(by.id('link-1')).click();
	          expect(element(by.model('value')).getAttribute('value')).toEqual('1');
	          expect(element(by.id('link-1')).getAttribute('href')).toBe('');
	        });
	
	        it('should execute ng-click but not reload when href empty string', function() {
	          element(by.id('link-2')).click();
	          expect(element(by.model('value')).getAttribute('value')).toEqual('2');
	          expect(element(by.id('link-2')).getAttribute('href')).toBe('');
	        });
	
	        it('should execute ng-click and change url when ng-href specified', function() {
	          expect(element(by.id('link-3')).getAttribute('href')).toMatch(/\/123$/);
	
	          element(by.id('link-3')).click();
	
	          // At this point, we navigate away from an Angular page, so we need
	          // to use browser.driver to get the base webdriver.
	
	          browser.wait(function() {
	            return browser.driver.getCurrentUrl().then(function(url) {
	              return url.match(/\/123$/);
	            });
	          }, 5000, 'page should navigate to /123');
	        });
	
	        it('should execute ng-click but not reload when href empty string and name specified', function() {
	          element(by.id('link-4')).click();
	          expect(element(by.model('value')).getAttribute('value')).toEqual('4');
	          expect(element(by.id('link-4')).getAttribute('href')).toBe('');
	        });
	
	        it('should execute ng-click but not reload when no href but name specified', function() {
	          element(by.id('link-5')).click();
	          expect(element(by.model('value')).getAttribute('value')).toEqual('5');
	          expect(element(by.id('link-5')).getAttribute('href')).toBe(null);
	        });
	
	        it('should only change url when only ng-href', function() {
	          element(by.model('value')).clear();
	          element(by.model('value')).sendKeys('6');
	          expect(element(by.id('link-6')).getAttribute('href')).toMatch(/\/6$/);
	
	          element(by.id('link-6')).click();
	
	          // At this point, we navigate away from an Angular page, so we need
	          // to use browser.driver to get the base webdriver.
	          browser.wait(function() {
	            return browser.driver.getCurrentUrl().then(function(url) {
	              return url.match(/\/6$/);
	            });
	          }, 5000, 'page should navigate to /6');
	        });
	      </file>
	    </example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngSrc
	 * @restrict A
	 * @priority 99
	 *
	 * @description
	 * Using Angular markup like `{{hash}}` in a `src` attribute doesn't
	 * work right: The browser will fetch from the URL with the literal
	 * text `{{hash}}` until Angular replaces the expression inside
	 * `{{hash}}`. The `ngSrc` directive solves this problem.
	 *
	 * The buggy way to write it:
	 * ```html
	 * <img src="http://www.gravatar.com/avatar/{{hash}}" alt="Description"/>
	 * ```
	 *
	 * The correct way to write it:
	 * ```html
	 * <img ng-src="http://www.gravatar.com/avatar/{{hash}}" alt="Description" />
	 * ```
	 *
	 * @element IMG
	 * @param {template} ngSrc any string which can contain `{{}}` markup.
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngSrcset
	 * @restrict A
	 * @priority 99
	 *
	 * @description
	 * Using Angular markup like `{{hash}}` in a `srcset` attribute doesn't
	 * work right: The browser will fetch from the URL with the literal
	 * text `{{hash}}` until Angular replaces the expression inside
	 * `{{hash}}`. The `ngSrcset` directive solves this problem.
	 *
	 * The buggy way to write it:
	 * ```html
	 * <img srcset="http://www.gravatar.com/avatar/{{hash}} 2x" alt="Description"/>
	 * ```
	 *
	 * The correct way to write it:
	 * ```html
	 * <img ng-srcset="http://www.gravatar.com/avatar/{{hash}} 2x" alt="Description" />
	 * ```
	 *
	 * @element IMG
	 * @param {template} ngSrcset any string which can contain `{{}}` markup.
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngDisabled
	 * @restrict A
	 * @priority 100
	 *
	 * @description
	 *
	 * This directive sets the `disabled` attribute on the element if the
	 * {@link guide/expression expression} inside `ngDisabled` evaluates to truthy.
	 *
	 * A special directive is necessary because we cannot use interpolation inside the `disabled`
	 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
	 *
	 * @example
	    <example>
	      <file name="index.html">
	        <label>Click me to toggle: <input type="checkbox" ng-model="checked"></label><br/>
	        <button ng-model="button" ng-disabled="checked">Button</button>
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should toggle button', function() {
	          expect(element(by.css('button')).getAttribute('disabled')).toBeFalsy();
	          element(by.model('checked')).click();
	          expect(element(by.css('button')).getAttribute('disabled')).toBeTruthy();
	        });
	      </file>
	    </example>
	 *
	 * @element INPUT
	 * @param {expression} ngDisabled If the {@link guide/expression expression} is truthy,
	 *     then the `disabled` attribute will be set on the element
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngChecked
	 * @restrict A
	 * @priority 100
	 *
	 * @description
	 * Sets the `checked` attribute on the element, if the expression inside `ngChecked` is truthy.
	 *
	 * Note that this directive should not be used together with {@link ngModel `ngModel`},
	 * as this can lead to unexpected behavior.
	 *
	 * A special directive is necessary because we cannot use interpolation inside the `checked`
	 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
	 *
	 * @example
	    <example>
	      <file name="index.html">
	        <label>Check me to check both: <input type="checkbox" ng-model="master"></label><br/>
	        <input id="checkSlave" type="checkbox" ng-checked="master" aria-label="Slave input">
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should check both checkBoxes', function() {
	          expect(element(by.id('checkSlave')).getAttribute('checked')).toBeFalsy();
	          element(by.model('master')).click();
	          expect(element(by.id('checkSlave')).getAttribute('checked')).toBeTruthy();
	        });
	      </file>
	    </example>
	 *
	 * @element INPUT
	 * @param {expression} ngChecked If the {@link guide/expression expression} is truthy,
	 *     then the `checked` attribute will be set on the element
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngReadonly
	 * @restrict A
	 * @priority 100
	 *
	 * @description
	 *
	 * Sets the `readOnly` attribute on the element, if the expression inside `ngReadonly` is truthy.
	 *
	 * A special directive is necessary because we cannot use interpolation inside the `readOnly`
	 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
	 *
	 * @example
	    <example>
	      <file name="index.html">
	        <label>Check me to make text readonly: <input type="checkbox" ng-model="checked"></label><br/>
	        <input type="text" ng-readonly="checked" value="I'm Angular" aria-label="Readonly field" />
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should toggle readonly attr', function() {
	          expect(element(by.css('[type="text"]')).getAttribute('readonly')).toBeFalsy();
	          element(by.model('checked')).click();
	          expect(element(by.css('[type="text"]')).getAttribute('readonly')).toBeTruthy();
	        });
	      </file>
	    </example>
	 *
	 * @element INPUT
	 * @param {expression} ngReadonly If the {@link guide/expression expression} is truthy,
	 *     then special attribute "readonly" will be set on the element
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngSelected
	 * @restrict A
	 * @priority 100
	 *
	 * @description
	 *
	 * Sets the `selected` attribute on the element, if the expression inside `ngSelected` is truthy.
	 *
	 * A special directive is necessary because we cannot use interpolation inside the `selected`
	 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
	 *
	 * @example
	    <example>
	      <file name="index.html">
	        <label>Check me to select: <input type="checkbox" ng-model="selected"></label><br/>
	        <select aria-label="ngSelected demo">
	          <option>Hello!</option>
	          <option id="greet" ng-selected="selected">Greetings!</option>
	        </select>
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should select Greetings!', function() {
	          expect(element(by.id('greet')).getAttribute('selected')).toBeFalsy();
	          element(by.model('selected')).click();
	          expect(element(by.id('greet')).getAttribute('selected')).toBeTruthy();
	        });
	      </file>
	    </example>
	 *
	 * @element OPTION
	 * @param {expression} ngSelected If the {@link guide/expression expression} is truthy,
	 *     then special attribute "selected" will be set on the element
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngOpen
	 * @restrict A
	 * @priority 100
	 *
	 * @description
	 *
	 * Sets the `open` attribute on the element, if the expression inside `ngOpen` is truthy.
	 *
	 * A special directive is necessary because we cannot use interpolation inside the `open`
	 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
	 *
	 * @example
	     <example>
	       <file name="index.html">
	         <label>Check me check multiple: <input type="checkbox" ng-model="open"></label><br/>
	         <details id="details" ng-open="open">
	            <summary>Show/Hide me</summary>
	         </details>
	       </file>
	       <file name="protractor.js" type="protractor">
	         it('should toggle open', function() {
	           expect(element(by.id('details')).getAttribute('open')).toBeFalsy();
	           element(by.model('open')).click();
	           expect(element(by.id('details')).getAttribute('open')).toBeTruthy();
	         });
	       </file>
	     </example>
	 *
	 * @element DETAILS
	 * @param {expression} ngOpen If the {@link guide/expression expression} is truthy,
	 *     then special attribute "open" will be set on the element
	 */
	
	var ngAttributeAliasDirectives = {};
	
	// boolean attrs are evaluated
	forEach(BOOLEAN_ATTR, function(propName, attrName) {
	  // binding to multiple is not supported
	  if (propName == "multiple") return;
	
	  function defaultLinkFn(scope, element, attr) {
	    scope.$watch(attr[normalized], function ngBooleanAttrWatchAction(value) {
	      attr.$set(attrName, !!value);
	    });
	  }
	
	  var normalized = directiveNormalize('ng-' + attrName);
	  var linkFn = defaultLinkFn;
	
	  if (propName === 'checked') {
	    linkFn = function(scope, element, attr) {
	      // ensuring ngChecked doesn't interfere with ngModel when both are set on the same input
	      if (attr.ngModel !== attr[normalized]) {
	        defaultLinkFn(scope, element, attr);
	      }
	    };
	  }
	
	  ngAttributeAliasDirectives[normalized] = function() {
	    return {
	      restrict: 'A',
	      priority: 100,
	      link: linkFn
	    };
	  };
	});
	
	// aliased input attrs are evaluated
	forEach(ALIASED_ATTR, function(htmlAttr, ngAttr) {
	  ngAttributeAliasDirectives[ngAttr] = function() {
	    return {
	      priority: 100,
	      link: function(scope, element, attr) {
	        //special case ngPattern when a literal regular expression value
	        //is used as the expression (this way we don't have to watch anything).
	        if (ngAttr === "ngPattern" && attr.ngPattern.charAt(0) == "/") {
	          var match = attr.ngPattern.match(REGEX_STRING_REGEXP);
	          if (match) {
	            attr.$set("ngPattern", new RegExp(match[1], match[2]));
	            return;
	          }
	        }
	
	        scope.$watch(attr[ngAttr], function ngAttrAliasWatchAction(value) {
	          attr.$set(ngAttr, value);
	        });
	      }
	    };
	  };
	});
	
	// ng-src, ng-srcset, ng-href are interpolated
	forEach(['src', 'srcset', 'href'], function(attrName) {
	  var normalized = directiveNormalize('ng-' + attrName);
	  ngAttributeAliasDirectives[normalized] = function() {
	    return {
	      priority: 99, // it needs to run after the attributes are interpolated
	      link: function(scope, element, attr) {
	        var propName = attrName,
	            name = attrName;
	
	        if (attrName === 'href' &&
	            toString.call(element.prop('href')) === '[object SVGAnimatedString]') {
	          name = 'xlinkHref';
	          attr.$attr[name] = 'xlink:href';
	          propName = null;
	        }
	
	        attr.$observe(normalized, function(value) {
	          if (!value) {
	            if (attrName === 'href') {
	              attr.$set(name, null);
	            }
	            return;
	          }
	
	          attr.$set(name, value);
	
	          // on IE, if "ng:src" directive declaration is used and "src" attribute doesn't exist
	          // then calling element.setAttribute('src', 'foo') doesn't do anything, so we need
	          // to set the property as well to achieve the desired effect.
	          // we use attr[attrName] value since $set can sanitize the url.
	          if (msie && propName) element.prop(propName, attr[name]);
	        });
	      }
	    };
	  };
	});
	
	/* global -nullFormCtrl, -SUBMITTED_CLASS, addSetValidityMethod: true
	 */
	var nullFormCtrl = {
	  $addControl: noop,
	  $$renameControl: nullFormRenameControl,
	  $removeControl: noop,
	  $setValidity: noop,
	  $setDirty: noop,
	  $setPristine: noop,
	  $setSubmitted: noop
	},
	SUBMITTED_CLASS = 'ng-submitted';
	
	function nullFormRenameControl(control, name) {
	  control.$name = name;
	}
	
	/**
	 * @ngdoc type
	 * @name form.FormController
	 *
	 * @property {boolean} $pristine True if user has not interacted with the form yet.
	 * @property {boolean} $dirty True if user has already interacted with the form.
	 * @property {boolean} $valid True if all of the containing forms and controls are valid.
	 * @property {boolean} $invalid True if at least one containing control or form is invalid.
	 * @property {boolean} $pending True if at least one containing control or form is pending.
	 * @property {boolean} $submitted True if user has submitted the form even if its invalid.
	 *
	 * @property {Object} $error Is an object hash, containing references to controls or
	 *  forms with failing validators, where:
	 *
	 *  - keys are validation tokens (error names),
	 *  - values are arrays of controls or forms that have a failing validator for given error name.
	 *
	 *  Built-in validation tokens:
	 *
	 *  - `email`
	 *  - `max`
	 *  - `maxlength`
	 *  - `min`
	 *  - `minlength`
	 *  - `number`
	 *  - `pattern`
	 *  - `required`
	 *  - `url`
	 *  - `date`
	 *  - `datetimelocal`
	 *  - `time`
	 *  - `week`
	 *  - `month`
	 *
	 * @description
	 * `FormController` keeps track of all its controls and nested forms as well as the state of them,
	 * such as being valid/invalid or dirty/pristine.
	 *
	 * Each {@link ng.directive:form form} directive creates an instance
	 * of `FormController`.
	 *
	 */
	//asks for $scope to fool the BC controller module
	FormController.$inject = ['$element', '$attrs', '$scope', '$animate', '$interpolate'];
	function FormController(element, attrs, $scope, $animate, $interpolate) {
	  var form = this,
	      controls = [];
	
	  // init state
	  form.$error = {};
	  form.$$success = {};
	  form.$pending = undefined;
	  form.$name = $interpolate(attrs.name || attrs.ngForm || '')($scope);
	  form.$dirty = false;
	  form.$pristine = true;
	  form.$valid = true;
	  form.$invalid = false;
	  form.$submitted = false;
	  form.$$parentForm = nullFormCtrl;
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$rollbackViewValue
	   *
	   * @description
	   * Rollback all form controls pending updates to the `$modelValue`.
	   *
	   * Updates may be pending by a debounced event or because the input is waiting for a some future
	   * event defined in `ng-model-options`. This method is typically needed by the reset button of
	   * a form that uses `ng-model-options` to pend updates.
	   */
	  form.$rollbackViewValue = function() {
	    forEach(controls, function(control) {
	      control.$rollbackViewValue();
	    });
	  };
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$commitViewValue
	   *
	   * @description
	   * Commit all form controls pending updates to the `$modelValue`.
	   *
	   * Updates may be pending by a debounced event or because the input is waiting for a some future
	   * event defined in `ng-model-options`. This method is rarely needed as `NgModelController`
	   * usually handles calling this in response to input events.
	   */
	  form.$commitViewValue = function() {
	    forEach(controls, function(control) {
	      control.$commitViewValue();
	    });
	  };
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$addControl
	   * @param {object} control control object, either a {@link form.FormController} or an
	   * {@link ngModel.NgModelController}
	   *
	   * @description
	   * Register a control with the form. Input elements using ngModelController do this automatically
	   * when they are linked.
	   *
	   * Note that the current state of the control will not be reflected on the new parent form. This
	   * is not an issue with normal use, as freshly compiled and linked controls are in a `$pristine`
	   * state.
	   *
	   * However, if the method is used programmatically, for example by adding dynamically created controls,
	   * or controls that have been previously removed without destroying their corresponding DOM element,
	   * it's the developers responsibility to make sure the current state propagates to the parent form.
	   *
	   * For example, if an input control is added that is already `$dirty` and has `$error` properties,
	   * calling `$setDirty()` and `$validate()` afterwards will propagate the state to the parent form.
	   */
	  form.$addControl = function(control) {
	    // Breaking change - before, inputs whose name was "hasOwnProperty" were quietly ignored
	    // and not added to the scope.  Now we throw an error.
	    assertNotHasOwnProperty(control.$name, 'input');
	    controls.push(control);
	
	    if (control.$name) {
	      form[control.$name] = control;
	    }
	
	    control.$$parentForm = form;
	  };
	
	  // Private API: rename a form control
	  form.$$renameControl = function(control, newName) {
	    var oldName = control.$name;
	
	    if (form[oldName] === control) {
	      delete form[oldName];
	    }
	    form[newName] = control;
	    control.$name = newName;
	  };
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$removeControl
	   * @param {object} control control object, either a {@link form.FormController} or an
	   * {@link ngModel.NgModelController}
	   *
	   * @description
	   * Deregister a control from the form.
	   *
	   * Input elements using ngModelController do this automatically when they are destroyed.
	   *
	   * Note that only the removed control's validation state (`$errors`etc.) will be removed from the
	   * form. `$dirty`, `$submitted` states will not be changed, because the expected behavior can be
	   * different from case to case. For example, removing the only `$dirty` control from a form may or
	   * may not mean that the form is still `$dirty`.
	   */
	  form.$removeControl = function(control) {
	    if (control.$name && form[control.$name] === control) {
	      delete form[control.$name];
	    }
	    forEach(form.$pending, function(value, name) {
	      form.$setValidity(name, null, control);
	    });
	    forEach(form.$error, function(value, name) {
	      form.$setValidity(name, null, control);
	    });
	    forEach(form.$$success, function(value, name) {
	      form.$setValidity(name, null, control);
	    });
	
	    arrayRemove(controls, control);
	    control.$$parentForm = nullFormCtrl;
	  };
	
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$setValidity
	   *
	   * @description
	   * Sets the validity of a form control.
	   *
	   * This method will also propagate to parent forms.
	   */
	  addSetValidityMethod({
	    ctrl: this,
	    $element: element,
	    set: function(object, property, controller) {
	      var list = object[property];
	      if (!list) {
	        object[property] = [controller];
	      } else {
	        var index = list.indexOf(controller);
	        if (index === -1) {
	          list.push(controller);
	        }
	      }
	    },
	    unset: function(object, property, controller) {
	      var list = object[property];
	      if (!list) {
	        return;
	      }
	      arrayRemove(list, controller);
	      if (list.length === 0) {
	        delete object[property];
	      }
	    },
	    $animate: $animate
	  });
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$setDirty
	   *
	   * @description
	   * Sets the form to a dirty state.
	   *
	   * This method can be called to add the 'ng-dirty' class and set the form to a dirty
	   * state (ng-dirty class). This method will also propagate to parent forms.
	   */
	  form.$setDirty = function() {
	    $animate.removeClass(element, PRISTINE_CLASS);
	    $animate.addClass(element, DIRTY_CLASS);
	    form.$dirty = true;
	    form.$pristine = false;
	    form.$$parentForm.$setDirty();
	  };
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$setPristine
	   *
	   * @description
	   * Sets the form to its pristine state.
	   *
	   * This method can be called to remove the 'ng-dirty' class and set the form to its pristine
	   * state (ng-pristine class). This method will also propagate to all the controls contained
	   * in this form.
	   *
	   * Setting a form back to a pristine state is often useful when we want to 'reuse' a form after
	   * saving or resetting it.
	   */
	  form.$setPristine = function() {
	    $animate.setClass(element, PRISTINE_CLASS, DIRTY_CLASS + ' ' + SUBMITTED_CLASS);
	    form.$dirty = false;
	    form.$pristine = true;
	    form.$submitted = false;
	    forEach(controls, function(control) {
	      control.$setPristine();
	    });
	  };
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$setUntouched
	   *
	   * @description
	   * Sets the form to its untouched state.
	   *
	   * This method can be called to remove the 'ng-touched' class and set the form controls to their
	   * untouched state (ng-untouched class).
	   *
	   * Setting a form controls back to their untouched state is often useful when setting the form
	   * back to its pristine state.
	   */
	  form.$setUntouched = function() {
	    forEach(controls, function(control) {
	      control.$setUntouched();
	    });
	  };
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$setSubmitted
	   *
	   * @description
	   * Sets the form to its submitted state.
	   */
	  form.$setSubmitted = function() {
	    $animate.addClass(element, SUBMITTED_CLASS);
	    form.$submitted = true;
	    form.$$parentForm.$setSubmitted();
	  };
	}
	
	/**
	 * @ngdoc directive
	 * @name ngForm
	 * @restrict EAC
	 *
	 * @description
	 * Nestable alias of {@link ng.directive:form `form`} directive. HTML
	 * does not allow nesting of form elements. It is useful to nest forms, for example if the validity of a
	 * sub-group of controls needs to be determined.
	 *
	 * Note: the purpose of `ngForm` is to group controls,
	 * but not to be a replacement for the `<form>` tag with all of its capabilities
	 * (e.g. posting to the server, ...).
	 *
	 * @param {string=} ngForm|name Name of the form. If specified, the form controller will be published into
	 *                       related scope, under this name.
	 *
	 */
	
	 /**
	 * @ngdoc directive
	 * @name form
	 * @restrict E
	 *
	 * @description
	 * Directive that instantiates
	 * {@link form.FormController FormController}.
	 *
	 * If the `name` attribute is specified, the form controller is published onto the current scope under
	 * this name.
	 *
	 * # Alias: {@link ng.directive:ngForm `ngForm`}
	 *
	 * In Angular, forms can be nested. This means that the outer form is valid when all of the child
	 * forms are valid as well. However, browsers do not allow nesting of `<form>` elements, so
	 * Angular provides the {@link ng.directive:ngForm `ngForm`} directive, which behaves identically to
	 * `form` but can be nested. Nested forms can be useful, for example, if the validity of a sub-group
	 * of controls needs to be determined.
	 *
	 * # CSS classes
	 *  - `ng-valid` is set if the form is valid.
	 *  - `ng-invalid` is set if the form is invalid.
	 *  - `ng-pending` is set if the form is pending.
	 *  - `ng-pristine` is set if the form is pristine.
	 *  - `ng-dirty` is set if the form is dirty.
	 *  - `ng-submitted` is set if the form was submitted.
	 *
	 * Keep in mind that ngAnimate can detect each of these classes when added and removed.
	 *
	 *
	 * # Submitting a form and preventing the default action
	 *
	 * Since the role of forms in client-side Angular applications is different than in classical
	 * roundtrip apps, it is desirable for the browser not to translate the form submission into a full
	 * page reload that sends the data to the server. Instead some javascript logic should be triggered
	 * to handle the form submission in an application-specific way.
	 *
	 * For this reason, Angular prevents the default action (form submission to the server) unless the
	 * `<form>` element has an `action` attribute specified.
	 *
	 * You can use one of the following two ways to specify what javascript method should be called when
	 * a form is submitted:
	 *
	 * - {@link ng.directive:ngSubmit ngSubmit} directive on the form element
	 * - {@link ng.directive:ngClick ngClick} directive on the first
	  *  button or input field of type submit (input[type=submit])
	 *
	 * To prevent double execution of the handler, use only one of the {@link ng.directive:ngSubmit ngSubmit}
	 * or {@link ng.directive:ngClick ngClick} directives.
	 * This is because of the following form submission rules in the HTML specification:
	 *
	 * - If a form has only one input field then hitting enter in this field triggers form submit
	 * (`ngSubmit`)
	 * - if a form has 2+ input fields and no buttons or input[type=submit] then hitting enter
	 * doesn't trigger submit
	 * - if a form has one or more input fields and one or more buttons or input[type=submit] then
	 * hitting enter in any of the input fields will trigger the click handler on the *first* button or
	 * input[type=submit] (`ngClick`) *and* a submit handler on the enclosing form (`ngSubmit`)
	 *
	 * Any pending `ngModelOptions` changes will take place immediately when an enclosing form is
	 * submitted. Note that `ngClick` events will occur before the model is updated. Use `ngSubmit`
	 * to have access to the updated model.
	 *
	 * ## Animation Hooks
	 *
	 * Animations in ngForm are triggered when any of the associated CSS classes are added and removed.
	 * These classes are: `.ng-pristine`, `.ng-dirty`, `.ng-invalid` and `.ng-valid` as well as any
	 * other validations that are performed within the form. Animations in ngForm are similar to how
	 * they work in ngClass and animations can be hooked into using CSS transitions, keyframes as well
	 * as JS animations.
	 *
	 * The following example shows a simple way to utilize CSS transitions to style a form element
	 * that has been rendered as invalid after it has been validated:
	 *
	 * <pre>
	 * //be sure to include ngAnimate as a module to hook into more
	 * //advanced animations
	 * .my-form {
	 *   transition:0.5s linear all;
	 *   background: white;
	 * }
	 * .my-form.ng-invalid {
	 *   background: red;
	 *   color:white;
	 * }
	 * </pre>
	 *
	 * @example
	    <example deps="angular-animate.js" animations="true" fixBase="true" module="formExample">
	      <file name="index.html">
	       <script>
	         angular.module('formExample', [])
	           .controller('FormController', ['$scope', function($scope) {
	             $scope.userType = 'guest';
	           }]);
	       </script>
	       <style>
	        .my-form {
	          transition:all linear 0.5s;
	          background: transparent;
	        }
	        .my-form.ng-invalid {
	          background: red;
	        }
	       </style>
	       <form name="myForm" ng-controller="FormController" class="my-form">
	         userType: <input name="input" ng-model="userType" required>
	         <span class="error" ng-show="myForm.input.$error.required">Required!</span><br>
	         <code>userType = {{userType}}</code><br>
	         <code>myForm.input.$valid = {{myForm.input.$valid}}</code><br>
	         <code>myForm.input.$error = {{myForm.input.$error}}</code><br>
	         <code>myForm.$valid = {{myForm.$valid}}</code><br>
	         <code>myForm.$error.required = {{!!myForm.$error.required}}</code><br>
	        </form>
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should initialize to model', function() {
	          var userType = element(by.binding('userType'));
	          var valid = element(by.binding('myForm.input.$valid'));
	
	          expect(userType.getText()).toContain('guest');
	          expect(valid.getText()).toContain('true');
	        });
	
	        it('should be invalid if empty', function() {
	          var userType = element(by.binding('userType'));
	          var valid = element(by.binding('myForm.input.$valid'));
	          var userInput = element(by.model('userType'));
	
	          userInput.clear();
	          userInput.sendKeys('');
	
	          expect(userType.getText()).toEqual('userType =');
	          expect(valid.getText()).toContain('false');
	        });
	      </file>
	    </example>
	 *
	 * @param {string=} name Name of the form. If specified, the form controller will be published into
	 *                       related scope, under this name.
	 */
	var formDirectiveFactory = function(isNgForm) {
	  return ['$timeout', '$parse', function($timeout, $parse) {
	    var formDirective = {
	      name: 'form',
	      restrict: isNgForm ? 'EAC' : 'E',
	      require: ['form', '^^?form'], //first is the form's own ctrl, second is an optional parent form
	      controller: FormController,
	      compile: function ngFormCompile(formElement, attr) {
	        // Setup initial state of the control
	        formElement.addClass(PRISTINE_CLASS).addClass(VALID_CLASS);
	
	        var nameAttr = attr.name ? 'name' : (isNgForm && attr.ngForm ? 'ngForm' : false);
	
	        return {
	          pre: function ngFormPreLink(scope, formElement, attr, ctrls) {
	            var controller = ctrls[0];
	
	            // if `action` attr is not present on the form, prevent the default action (submission)
	            if (!('action' in attr)) {
	              // we can't use jq events because if a form is destroyed during submission the default
	              // action is not prevented. see #1238
	              //
	              // IE 9 is not affected because it doesn't fire a submit event and try to do a full
	              // page reload if the form was destroyed by submission of the form via a click handler
	              // on a button in the form. Looks like an IE9 specific bug.
	              var handleFormSubmission = function(event) {
	                scope.$apply(function() {
	                  controller.$commitViewValue();
	                  controller.$setSubmitted();
	                });
	
	                event.preventDefault();
	              };
	
	              addEventListenerFn(formElement[0], 'submit', handleFormSubmission);
	
	              // unregister the preventDefault listener so that we don't not leak memory but in a
	              // way that will achieve the prevention of the default action.
	              formElement.on('$destroy', function() {
	                $timeout(function() {
	                  removeEventListenerFn(formElement[0], 'submit', handleFormSubmission);
	                }, 0, false);
	              });
	            }
	
	            var parentFormCtrl = ctrls[1] || controller.$$parentForm;
	            parentFormCtrl.$addControl(controller);
	
	            var setter = nameAttr ? getSetter(controller.$name) : noop;
	
	            if (nameAttr) {
	              setter(scope, controller);
	              attr.$observe(nameAttr, function(newValue) {
	                if (controller.$name === newValue) return;
	                setter(scope, undefined);
	                controller.$$parentForm.$$renameControl(controller, newValue);
	                setter = getSetter(controller.$name);
	                setter(scope, controller);
	              });
	            }
	            formElement.on('$destroy', function() {
	              controller.$$parentForm.$removeControl(controller);
	              setter(scope, undefined);
	              extend(controller, nullFormCtrl); //stop propagating child destruction handlers upwards
	            });
	          }
	        };
	      }
	    };
	
	    return formDirective;
	
	    function getSetter(expression) {
	      if (expression === '') {
	        //create an assignable expression, so forms with an empty name can be renamed later
	        return $parse('this[""]').assign;
	      }
	      return $parse(expression).assign || noop;
	    }
	  }];
	};
	
	var formDirective = formDirectiveFactory();
	var ngFormDirective = formDirectiveFactory(true);
	
	/* global VALID_CLASS: false,
	  INVALID_CLASS: false,
	  PRISTINE_CLASS: false,
	  DIRTY_CLASS: false,
	  UNTOUCHED_CLASS: false,
	  TOUCHED_CLASS: false,
	  ngModelMinErr: false,
	*/
	
	// Regex code was initially obtained from SO prior to modification: https://stackoverflow.com/questions/3143070/javascript-regex-iso-datetime#answer-3143231
	var ISO_DATE_REGEXP = /^\d{4,}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+(?:[+-][0-2]\d:[0-5]\d|Z)$/;
	// See valid URLs in RFC3987 (http://tools.ietf.org/html/rfc3987)
	// Note: We are being more lenient, because browsers are too.
	//   1. Scheme
	//   2. Slashes
	//   3. Username
	//   4. Password
	//   5. Hostname
	//   6. Port
	//   7. Path
	//   8. Query
	//   9. Fragment
	//                 1111111111111111 222   333333    44444        555555555555555555555555    666     77777777     8888888     999
	var URL_REGEXP = /^[a-z][a-z\d.+-]*:\/*(?:[^:@]+(?::[^@]+)?@)?(?:[^\s:/?#]+|\[[a-f\d:]+\])(?::\d+)?(?:\/[^?#]*)?(?:\?[^#]*)?(?:#.*)?$/i;
	var EMAIL_REGEXP = /^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i;
	var NUMBER_REGEXP = /^\s*(\-|\+)?(\d+|(\d*(\.\d*)))([eE][+-]?\d+)?\s*$/;
	var DATE_REGEXP = /^(\d{4,})-(\d{2})-(\d{2})$/;
	var DATETIMELOCAL_REGEXP = /^(\d{4,})-(\d\d)-(\d\d)T(\d\d):(\d\d)(?::(\d\d)(\.\d{1,3})?)?$/;
	var WEEK_REGEXP = /^(\d{4,})-W(\d\d)$/;
	var MONTH_REGEXP = /^(\d{4,})-(\d\d)$/;
	var TIME_REGEXP = /^(\d\d):(\d\d)(?::(\d\d)(\.\d{1,3})?)?$/;
	
	var PARTIAL_VALIDATION_EVENTS = 'keydown wheel mousedown';
	var PARTIAL_VALIDATION_TYPES = createMap();
	forEach('date,datetime-local,month,time,week'.split(','), function(type) {
	  PARTIAL_VALIDATION_TYPES[type] = true;
	});
	
	var inputType = {
	
	  /**
	   * @ngdoc input
	   * @name input[text]
	   *
	   * @description
	   * Standard HTML text input with angular data binding, inherited by most of the `input` elements.
	   *
	   *
	   * @param {string} ngModel Assignable angular expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} required Adds `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	   *    minlength.
	   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
	   *    any length.
	   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
	   *    that contains the regular expression body that will be converted to a regular expression
	   *    as in the ngPattern directive.
	   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
	   *    does not match a RegExp found by evaluating the Angular expression given in the attribute value.
	   *    If the expression evaluates to a RegExp object, then this is used directly.
	   *    If the expression evaluates to a string, then it will be converted to a RegExp
	   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	   *    `new RegExp('^abc$')`.<br />
	   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	   *    start at the index of the last search's match, thus not taking the whole input value into
	   *    account.
	   * @param {string=} ngChange Angular expression to be executed when input changes due to user
	   *    interaction with the input element.
	   * @param {boolean=} [ngTrim=true] If set to false Angular will not automatically trim the input.
	   *    This parameter is ignored for input[type=password] controls, which will never trim the
	   *    input.
	   *
	   * @example
	      <example name="text-input-directive" module="textInputExample">
	        <file name="index.html">
	         <script>
	           angular.module('textInputExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.example = {
	                 text: 'guest',
	                 word: /^\s*\w*\s*$/
	               };
	             }]);
	         </script>
	         <form name="myForm" ng-controller="ExampleController">
	           <label>Single word:
	             <input type="text" name="input" ng-model="example.text"
	                    ng-pattern="example.word" required ng-trim="false">
	           </label>
	           <div role="alert">
	             <span class="error" ng-show="myForm.input.$error.required">
	               Required!</span>
	             <span class="error" ng-show="myForm.input.$error.pattern">
	               Single word only!</span>
	           </div>
	           <code>text = {{example.text}}</code><br/>
	           <code>myForm.input.$valid = {{myForm.input.$valid}}</code><br/>
	           <code>myForm.input.$error = {{myForm.input.$error}}</code><br/>
	           <code>myForm.$valid = {{myForm.$valid}}</code><br/>
	           <code>myForm.$error.required = {{!!myForm.$error.required}}</code><br/>
	          </form>
	        </file>
	        <file name="protractor.js" type="protractor">
	          var text = element(by.binding('example.text'));
	          var valid = element(by.binding('myForm.input.$valid'));
	          var input = element(by.model('example.text'));
	
	          it('should initialize to model', function() {
	            expect(text.getText()).toContain('guest');
	            expect(valid.getText()).toContain('true');
	          });
	
	          it('should be invalid if empty', function() {
	            input.clear();
	            input.sendKeys('');
	
	            expect(text.getText()).toEqual('text =');
	            expect(valid.getText()).toContain('false');
	          });
	
	          it('should be invalid if multi word', function() {
	            input.clear();
	            input.sendKeys('hello world');
	
	            expect(valid.getText()).toContain('false');
	          });
	        </file>
	      </example>
	   */
	  'text': textInputType,
	
	    /**
	     * @ngdoc input
	     * @name input[date]
	     *
	     * @description
	     * Input with date validation and transformation. In browsers that do not yet support
	     * the HTML5 date input, a text element will be used. In that case, text must be entered in a valid ISO-8601
	     * date format (yyyy-MM-dd), for example: `2009-01-06`. Since many
	     * modern browsers do not yet support this input type, it is important to provide cues to users on the
	     * expected input format via a placeholder or label.
	     *
	     * The model must always be a Date object, otherwise Angular will throw an error.
	     * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
	     *
	     * The timezone to be used to read/write the `Date` instance in the model can be defined using
	     * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
	     *
	     * @param {string} ngModel Assignable angular expression to data-bind to.
	     * @param {string=} name Property name of the form under which the control is published.
	     * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`. This must be a
	     *   valid ISO date string (yyyy-MM-dd). You can also use interpolation inside this attribute
	     *   (e.g. `min="{{minDate | date:'yyyy-MM-dd'}}"`). Note that `min` will also add native HTML5
	     *   constraint validation.
	     * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`. This must be
	     *   a valid ISO date string (yyyy-MM-dd). You can also use interpolation inside this attribute
	     *   (e.g. `max="{{maxDate | date:'yyyy-MM-dd'}}"`). Note that `max` will also add native HTML5
	     *   constraint validation.
	     * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO date string
	     *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
	     * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO date string
	     *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
	     * @param {string=} required Sets `required` validation error key if the value is not entered.
	     * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	     *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	     *    `required` when you want to data-bind to the `required` attribute.
	     * @param {string=} ngChange Angular expression to be executed when input changes due to user
	     *    interaction with the input element.
	     *
	     * @example
	     <example name="date-input-directive" module="dateInputExample">
	     <file name="index.html">
	       <script>
	          angular.module('dateInputExample', [])
	            .controller('DateController', ['$scope', function($scope) {
	              $scope.example = {
	                value: new Date(2013, 9, 22)
	              };
	            }]);
	       </script>
	       <form name="myForm" ng-controller="DateController as dateCtrl">
	          <label for="exampleInput">Pick a date in 2013:</label>
	          <input type="date" id="exampleInput" name="input" ng-model="example.value"
	              placeholder="yyyy-MM-dd" min="2013-01-01" max="2013-12-31" required />
	          <div role="alert">
	            <span class="error" ng-show="myForm.input.$error.required">
	                Required!</span>
	            <span class="error" ng-show="myForm.input.$error.date">
	                Not a valid date!</span>
	           </div>
	           <tt>value = {{example.value | date: "yyyy-MM-dd"}}</tt><br/>
	           <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	           <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	           <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	           <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	       </form>
	     </file>
	     <file name="protractor.js" type="protractor">
	        var value = element(by.binding('example.value | date: "yyyy-MM-dd"'));
	        var valid = element(by.binding('myForm.input.$valid'));
	        var input = element(by.model('example.value'));
	
	        // currently protractor/webdriver does not support
	        // sending keys to all known HTML5 input controls
	        // for various browsers (see https://github.com/angular/protractor/issues/562).
	        function setInput(val) {
	          // set the value of the element and force validation.
	          var scr = "var ipt = document.getElementById('exampleInput'); " +
	          "ipt.value = '" + val + "';" +
	          "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
	          browser.executeScript(scr);
	        }
	
	        it('should initialize to model', function() {
	          expect(value.getText()).toContain('2013-10-22');
	          expect(valid.getText()).toContain('myForm.input.$valid = true');
	        });
	
	        it('should be invalid if empty', function() {
	          setInput('');
	          expect(value.getText()).toEqual('value =');
	          expect(valid.getText()).toContain('myForm.input.$valid = false');
	        });
	
	        it('should be invalid if over max', function() {
	          setInput('2015-01-01');
	          expect(value.getText()).toContain('');
	          expect(valid.getText()).toContain('myForm.input.$valid = false');
	        });
	     </file>
	     </example>
	     */
	  'date': createDateInputType('date', DATE_REGEXP,
	         createDateParser(DATE_REGEXP, ['yyyy', 'MM', 'dd']),
	         'yyyy-MM-dd'),
	
	   /**
	    * @ngdoc input
	    * @name input[datetime-local]
	    *
	    * @description
	    * Input with datetime validation and transformation. In browsers that do not yet support
	    * the HTML5 date input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
	    * local datetime format (yyyy-MM-ddTHH:mm:ss), for example: `2010-12-28T14:57:00`.
	    *
	    * The model must always be a Date object, otherwise Angular will throw an error.
	    * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
	    *
	    * The timezone to be used to read/write the `Date` instance in the model can be defined using
	    * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
	    *
	    * @param {string} ngModel Assignable angular expression to data-bind to.
	    * @param {string=} name Property name of the form under which the control is published.
	    * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
	    *   This must be a valid ISO datetime format (yyyy-MM-ddTHH:mm:ss). You can also use interpolation
	    *   inside this attribute (e.g. `min="{{minDatetimeLocal | date:'yyyy-MM-ddTHH:mm:ss'}}"`).
	    *   Note that `min` will also add native HTML5 constraint validation.
	    * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
	    *   This must be a valid ISO datetime format (yyyy-MM-ddTHH:mm:ss). You can also use interpolation
	    *   inside this attribute (e.g. `max="{{maxDatetimeLocal | date:'yyyy-MM-ddTHH:mm:ss'}}"`).
	    *   Note that `max` will also add native HTML5 constraint validation.
	    * @param {(date|string)=} ngMin Sets the `min` validation error key to the Date / ISO datetime string
	    *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
	    * @param {(date|string)=} ngMax Sets the `max` validation error key to the Date / ISO datetime string
	    *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
	    * @param {string=} required Sets `required` validation error key if the value is not entered.
	    * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	    *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	    *    `required` when you want to data-bind to the `required` attribute.
	    * @param {string=} ngChange Angular expression to be executed when input changes due to user
	    *    interaction with the input element.
	    *
	    * @example
	    <example name="datetimelocal-input-directive" module="dateExample">
	    <file name="index.html">
	      <script>
	        angular.module('dateExample', [])
	          .controller('DateController', ['$scope', function($scope) {
	            $scope.example = {
	              value: new Date(2010, 11, 28, 14, 57)
	            };
	          }]);
	      </script>
	      <form name="myForm" ng-controller="DateController as dateCtrl">
	        <label for="exampleInput">Pick a date between in 2013:</label>
	        <input type="datetime-local" id="exampleInput" name="input" ng-model="example.value"
	            placeholder="yyyy-MM-ddTHH:mm:ss" min="2001-01-01T00:00:00" max="2013-12-31T00:00:00" required />
	        <div role="alert">
	          <span class="error" ng-show="myForm.input.$error.required">
	              Required!</span>
	          <span class="error" ng-show="myForm.input.$error.datetimelocal">
	              Not a valid date!</span>
	        </div>
	        <tt>value = {{example.value | date: "yyyy-MM-ddTHH:mm:ss"}}</tt><br/>
	        <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	        <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	        <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	        <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	      </form>
	    </file>
	    <file name="protractor.js" type="protractor">
	      var value = element(by.binding('example.value | date: "yyyy-MM-ddTHH:mm:ss"'));
	      var valid = element(by.binding('myForm.input.$valid'));
	      var input = element(by.model('example.value'));
	
	      // currently protractor/webdriver does not support
	      // sending keys to all known HTML5 input controls
	      // for various browsers (https://github.com/angular/protractor/issues/562).
	      function setInput(val) {
	        // set the value of the element and force validation.
	        var scr = "var ipt = document.getElementById('exampleInput'); " +
	        "ipt.value = '" + val + "';" +
	        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
	        browser.executeScript(scr);
	      }
	
	      it('should initialize to model', function() {
	        expect(value.getText()).toContain('2010-12-28T14:57:00');
	        expect(valid.getText()).toContain('myForm.input.$valid = true');
	      });
	
	      it('should be invalid if empty', function() {
	        setInput('');
	        expect(value.getText()).toEqual('value =');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	
	      it('should be invalid if over max', function() {
	        setInput('2015-01-01T23:59:00');
	        expect(value.getText()).toContain('');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	    </file>
	    </example>
	    */
	  'datetime-local': createDateInputType('datetimelocal', DATETIMELOCAL_REGEXP,
	      createDateParser(DATETIMELOCAL_REGEXP, ['yyyy', 'MM', 'dd', 'HH', 'mm', 'ss', 'sss']),
	      'yyyy-MM-ddTHH:mm:ss.sss'),
	
	  /**
	   * @ngdoc input
	   * @name input[time]
	   *
	   * @description
	   * Input with time validation and transformation. In browsers that do not yet support
	   * the HTML5 time input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
	   * local time format (HH:mm:ss), for example: `14:57:00`. Model must be a Date object. This binding will always output a
	   * Date object to the model of January 1, 1970, or local date `new Date(1970, 0, 1, HH, mm, ss)`.
	   *
	   * The model must always be a Date object, otherwise Angular will throw an error.
	   * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
	   *
	   * The timezone to be used to read/write the `Date` instance in the model can be defined using
	   * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
	   *
	   * @param {string} ngModel Assignable angular expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
	   *   This must be a valid ISO time format (HH:mm:ss). You can also use interpolation inside this
	   *   attribute (e.g. `min="{{minTime | date:'HH:mm:ss'}}"`). Note that `min` will also add
	   *   native HTML5 constraint validation.
	   * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
	   *   This must be a valid ISO time format (HH:mm:ss). You can also use interpolation inside this
	   *   attribute (e.g. `max="{{maxTime | date:'HH:mm:ss'}}"`). Note that `max` will also add
	   *   native HTML5 constraint validation.
	   * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO time string the
	   *   `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
	   * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO time string the
	   *   `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
	   * @param {string=} required Sets `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {string=} ngChange Angular expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	   <example name="time-input-directive" module="timeExample">
	   <file name="index.html">
	     <script>
	      angular.module('timeExample', [])
	        .controller('DateController', ['$scope', function($scope) {
	          $scope.example = {
	            value: new Date(1970, 0, 1, 14, 57, 0)
	          };
	        }]);
	     </script>
	     <form name="myForm" ng-controller="DateController as dateCtrl">
	        <label for="exampleInput">Pick a time between 8am and 5pm:</label>
	        <input type="time" id="exampleInput" name="input" ng-model="example.value"
	            placeholder="HH:mm:ss" min="08:00:00" max="17:00:00" required />
	        <div role="alert">
	          <span class="error" ng-show="myForm.input.$error.required">
	              Required!</span>
	          <span class="error" ng-show="myForm.input.$error.time">
	              Not a valid date!</span>
	        </div>
	        <tt>value = {{example.value | date: "HH:mm:ss"}}</tt><br/>
	        <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	        <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	        <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	        <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	     </form>
	   </file>
	   <file name="protractor.js" type="protractor">
	      var value = element(by.binding('example.value | date: "HH:mm:ss"'));
	      var valid = element(by.binding('myForm.input.$valid'));
	      var input = element(by.model('example.value'));
	
	      // currently protractor/webdriver does not support
	      // sending keys to all known HTML5 input controls
	      // for various browsers (https://github.com/angular/protractor/issues/562).
	      function setInput(val) {
	        // set the value of the element and force validation.
	        var scr = "var ipt = document.getElementById('exampleInput'); " +
	        "ipt.value = '" + val + "';" +
	        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
	        browser.executeScript(scr);
	      }
	
	      it('should initialize to model', function() {
	        expect(value.getText()).toContain('14:57:00');
	        expect(valid.getText()).toContain('myForm.input.$valid = true');
	      });
	
	      it('should be invalid if empty', function() {
	        setInput('');
	        expect(value.getText()).toEqual('value =');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	
	      it('should be invalid if over max', function() {
	        setInput('23:59:00');
	        expect(value.getText()).toContain('');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	   </file>
	   </example>
	   */
	  'time': createDateInputType('time', TIME_REGEXP,
	      createDateParser(TIME_REGEXP, ['HH', 'mm', 'ss', 'sss']),
	     'HH:mm:ss.sss'),
	
	   /**
	    * @ngdoc input
	    * @name input[week]
	    *
	    * @description
	    * Input with week-of-the-year validation and transformation to Date. In browsers that do not yet support
	    * the HTML5 week input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
	    * week format (yyyy-W##), for example: `2013-W02`.
	    *
	    * The model must always be a Date object, otherwise Angular will throw an error.
	    * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
	    *
	    * The timezone to be used to read/write the `Date` instance in the model can be defined using
	    * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
	    *
	    * @param {string} ngModel Assignable angular expression to data-bind to.
	    * @param {string=} name Property name of the form under which the control is published.
	    * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
	    *   This must be a valid ISO week format (yyyy-W##). You can also use interpolation inside this
	    *   attribute (e.g. `min="{{minWeek | date:'yyyy-Www'}}"`). Note that `min` will also add
	    *   native HTML5 constraint validation.
	    * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
	    *   This must be a valid ISO week format (yyyy-W##). You can also use interpolation inside this
	    *   attribute (e.g. `max="{{maxWeek | date:'yyyy-Www'}}"`). Note that `max` will also add
	    *   native HTML5 constraint validation.
	    * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO week string
	    *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
	    * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO week string
	    *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
	    * @param {string=} required Sets `required` validation error key if the value is not entered.
	    * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	    *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	    *    `required` when you want to data-bind to the `required` attribute.
	    * @param {string=} ngChange Angular expression to be executed when input changes due to user
	    *    interaction with the input element.
	    *
	    * @example
	    <example name="week-input-directive" module="weekExample">
	    <file name="index.html">
	      <script>
	      angular.module('weekExample', [])
	        .controller('DateController', ['$scope', function($scope) {
	          $scope.example = {
	            value: new Date(2013, 0, 3)
	          };
	        }]);
	      </script>
	      <form name="myForm" ng-controller="DateController as dateCtrl">
	        <label>Pick a date between in 2013:
	          <input id="exampleInput" type="week" name="input" ng-model="example.value"
	                 placeholder="YYYY-W##" min="2012-W32"
	                 max="2013-W52" required />
	        </label>
	        <div role="alert">
	          <span class="error" ng-show="myForm.input.$error.required">
	              Required!</span>
	          <span class="error" ng-show="myForm.input.$error.week">
	              Not a valid date!</span>
	        </div>
	        <tt>value = {{example.value | date: "yyyy-Www"}}</tt><br/>
	        <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	        <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	        <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	        <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	      </form>
	    </file>
	    <file name="protractor.js" type="protractor">
	      var value = element(by.binding('example.value | date: "yyyy-Www"'));
	      var valid = element(by.binding('myForm.input.$valid'));
	      var input = element(by.model('example.value'));
	
	      // currently protractor/webdriver does not support
	      // sending keys to all known HTML5 input controls
	      // for various browsers (https://github.com/angular/protractor/issues/562).
	      function setInput(val) {
	        // set the value of the element and force validation.
	        var scr = "var ipt = document.getElementById('exampleInput'); " +
	        "ipt.value = '" + val + "';" +
	        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
	        browser.executeScript(scr);
	      }
	
	      it('should initialize to model', function() {
	        expect(value.getText()).toContain('2013-W01');
	        expect(valid.getText()).toContain('myForm.input.$valid = true');
	      });
	
	      it('should be invalid if empty', function() {
	        setInput('');
	        expect(value.getText()).toEqual('value =');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	
	      it('should be invalid if over max', function() {
	        setInput('2015-W01');
	        expect(value.getText()).toContain('');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	    </file>
	    </example>
	    */
	  'week': createDateInputType('week', WEEK_REGEXP, weekParser, 'yyyy-Www'),
	
	  /**
	   * @ngdoc input
	   * @name input[month]
	   *
	   * @description
	   * Input with month validation and transformation. In browsers that do not yet support
	   * the HTML5 month input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
	   * month format (yyyy-MM), for example: `2009-01`.
	   *
	   * The model must always be a Date object, otherwise Angular will throw an error.
	   * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
	   * If the model is not set to the first of the month, the next view to model update will set it
	   * to the first of the month.
	   *
	   * The timezone to be used to read/write the `Date` instance in the model can be defined using
	   * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
	   *
	   * @param {string} ngModel Assignable angular expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
	   *   This must be a valid ISO month format (yyyy-MM). You can also use interpolation inside this
	   *   attribute (e.g. `min="{{minMonth | date:'yyyy-MM'}}"`). Note that `min` will also add
	   *   native HTML5 constraint validation.
	   * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
	   *   This must be a valid ISO month format (yyyy-MM). You can also use interpolation inside this
	   *   attribute (e.g. `max="{{maxMonth | date:'yyyy-MM'}}"`). Note that `max` will also add
	   *   native HTML5 constraint validation.
	   * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO week string
	   *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
	   * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO week string
	   *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
	
	   * @param {string=} required Sets `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {string=} ngChange Angular expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	   <example name="month-input-directive" module="monthExample">
	   <file name="index.html">
	     <script>
	      angular.module('monthExample', [])
	        .controller('DateController', ['$scope', function($scope) {
	          $scope.example = {
	            value: new Date(2013, 9, 1)
	          };
	        }]);
	     </script>
	     <form name="myForm" ng-controller="DateController as dateCtrl">
	       <label for="exampleInput">Pick a month in 2013:</label>
	       <input id="exampleInput" type="month" name="input" ng-model="example.value"
	          placeholder="yyyy-MM" min="2013-01" max="2013-12" required />
	       <div role="alert">
	         <span class="error" ng-show="myForm.input.$error.required">
	            Required!</span>
	         <span class="error" ng-show="myForm.input.$error.month">
	            Not a valid month!</span>
	       </div>
	       <tt>value = {{example.value | date: "yyyy-MM"}}</tt><br/>
	       <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	       <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	       <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	       <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	     </form>
	   </file>
	   <file name="protractor.js" type="protractor">
	      var value = element(by.binding('example.value | date: "yyyy-MM"'));
	      var valid = element(by.binding('myForm.input.$valid'));
	      var input = element(by.model('example.value'));
	
	      // currently protractor/webdriver does not support
	      // sending keys to all known HTML5 input controls
	      // for various browsers (https://github.com/angular/protractor/issues/562).
	      function setInput(val) {
	        // set the value of the element and force validation.
	        var scr = "var ipt = document.getElementById('exampleInput'); " +
	        "ipt.value = '" + val + "';" +
	        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
	        browser.executeScript(scr);
	      }
	
	      it('should initialize to model', function() {
	        expect(value.getText()).toContain('2013-10');
	        expect(valid.getText()).toContain('myForm.input.$valid = true');
	      });
	
	      it('should be invalid if empty', function() {
	        setInput('');
	        expect(value.getText()).toEqual('value =');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	
	      it('should be invalid if over max', function() {
	        setInput('2015-01');
	        expect(value.getText()).toContain('');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	   </file>
	   </example>
	   */
	  'month': createDateInputType('month', MONTH_REGEXP,
	     createDateParser(MONTH_REGEXP, ['yyyy', 'MM']),
	     'yyyy-MM'),
	
	  /**
	   * @ngdoc input
	   * @name input[number]
	   *
	   * @description
	   * Text input with number validation and transformation. Sets the `number` validation
	   * error if not a valid number.
	   *
	   * <div class="alert alert-warning">
	   * The model must always be of type `number` otherwise Angular will throw an error.
	   * Be aware that a string containing a number is not enough. See the {@link ngModel:numfmt}
	   * error docs for more information and an example of how to convert your model if necessary.
	   * </div>
	   *
	   * ## Issues with HTML5 constraint validation
	   *
	   * In browsers that follow the
	   * [HTML5 specification](https://html.spec.whatwg.org/multipage/forms.html#number-state-%28type=number%29),
	   * `input[number]` does not work as expected with {@link ngModelOptions `ngModelOptions.allowInvalid`}.
	   * If a non-number is entered in the input, the browser will report the value as an empty string,
	   * which means the view / model values in `ngModel` and subsequently the scope value
	   * will also be an empty string.
	   *
	   *
	   * @param {string} ngModel Assignable angular expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
	   * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
	   * @param {string=} required Sets `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	   *    minlength.
	   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
	   *    any length.
	   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
	   *    that contains the regular expression body that will be converted to a regular expression
	   *    as in the ngPattern directive.
	   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
	   *    does not match a RegExp found by evaluating the Angular expression given in the attribute value.
	   *    If the expression evaluates to a RegExp object, then this is used directly.
	   *    If the expression evaluates to a string, then it will be converted to a RegExp
	   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	   *    `new RegExp('^abc$')`.<br />
	   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	   *    start at the index of the last search's match, thus not taking the whole input value into
	   *    account.
	   * @param {string=} ngChange Angular expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	      <example name="number-input-directive" module="numberExample">
	        <file name="index.html">
	         <script>
	           angular.module('numberExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.example = {
	                 value: 12
	               };
	             }]);
	         </script>
	         <form name="myForm" ng-controller="ExampleController">
	           <label>Number:
	             <input type="number" name="input" ng-model="example.value"
	                    min="0" max="99" required>
	          </label>
	           <div role="alert">
	             <span class="error" ng-show="myForm.input.$error.required">
	               Required!</span>
	             <span class="error" ng-show="myForm.input.$error.number">
	               Not valid number!</span>
	           </div>
	           <tt>value = {{example.value}}</tt><br/>
	           <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	           <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	           <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	           <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	          </form>
	        </file>
	        <file name="protractor.js" type="protractor">
	          var value = element(by.binding('example.value'));
	          var valid = element(by.binding('myForm.input.$valid'));
	          var input = element(by.model('example.value'));
	
	          it('should initialize to model', function() {
	            expect(value.getText()).toContain('12');
	            expect(valid.getText()).toContain('true');
	          });
	
	          it('should be invalid if empty', function() {
	            input.clear();
	            input.sendKeys('');
	            expect(value.getText()).toEqual('value =');
	            expect(valid.getText()).toContain('false');
	          });
	
	          it('should be invalid if over max', function() {
	            input.clear();
	            input.sendKeys('123');
	            expect(value.getText()).toEqual('value =');
	            expect(valid.getText()).toContain('false');
	          });
	        </file>
	      </example>
	   */
	  'number': numberInputType,
	
	
	  /**
	   * @ngdoc input
	   * @name input[url]
	   *
	   * @description
	   * Text input with URL validation. Sets the `url` validation error key if the content is not a
	   * valid URL.
	   *
	   * <div class="alert alert-warning">
	   * **Note:** `input[url]` uses a regex to validate urls that is derived from the regex
	   * used in Chromium. If you need stricter validation, you can use `ng-pattern` or modify
	   * the built-in validators (see the {@link guide/forms Forms guide})
	   * </div>
	   *
	   * @param {string} ngModel Assignable angular expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} required Sets `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	   *    minlength.
	   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
	   *    any length.
	   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
	   *    that contains the regular expression body that will be converted to a regular expression
	   *    as in the ngPattern directive.
	   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
	   *    does not match a RegExp found by evaluating the Angular expression given in the attribute value.
	   *    If the expression evaluates to a RegExp object, then this is used directly.
	   *    If the expression evaluates to a string, then it will be converted to a RegExp
	   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	   *    `new RegExp('^abc$')`.<br />
	   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	   *    start at the index of the last search's match, thus not taking the whole input value into
	   *    account.
	   * @param {string=} ngChange Angular expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	      <example name="url-input-directive" module="urlExample">
	        <file name="index.html">
	         <script>
	           angular.module('urlExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.url = {
	                 text: 'http://google.com'
	               };
	             }]);
	         </script>
	         <form name="myForm" ng-controller="ExampleController">
	           <label>URL:
	             <input type="url" name="input" ng-model="url.text" required>
	           <label>
	           <div role="alert">
	             <span class="error" ng-show="myForm.input.$error.required">
	               Required!</span>
	             <span class="error" ng-show="myForm.input.$error.url">
	               Not valid url!</span>
	           </div>
	           <tt>text = {{url.text}}</tt><br/>
	           <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	           <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	           <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	           <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	           <tt>myForm.$error.url = {{!!myForm.$error.url}}</tt><br/>
	          </form>
	        </file>
	        <file name="protractor.js" type="protractor">
	          var text = element(by.binding('url.text'));
	          var valid = element(by.binding('myForm.input.$valid'));
	          var input = element(by.model('url.text'));
	
	          it('should initialize to model', function() {
	            expect(text.getText()).toContain('http://google.com');
	            expect(valid.getText()).toContain('true');
	          });
	
	          it('should be invalid if empty', function() {
	            input.clear();
	            input.sendKeys('');
	
	            expect(text.getText()).toEqual('text =');
	            expect(valid.getText()).toContain('false');
	          });
	
	          it('should be invalid if not url', function() {
	            input.clear();
	            input.sendKeys('box');
	
	            expect(valid.getText()).toContain('false');
	          });
	        </file>
	      </example>
	   */
	  'url': urlInputType,
	
	
	  /**
	   * @ngdoc input
	   * @name input[email]
	   *
	   * @description
	   * Text input with email validation. Sets the `email` validation error key if not a valid email
	   * address.
	   *
	   * <div class="alert alert-warning">
	   * **Note:** `input[email]` uses a regex to validate email addresses that is derived from the regex
	   * used in Chromium. If you need stricter validation (e.g. requiring a top-level domain), you can
	   * use `ng-pattern` or modify the built-in validators (see the {@link guide/forms Forms guide})
	   * </div>
	   *
	   * @param {string} ngModel Assignable angular expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} required Sets `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	   *    minlength.
	   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
	   *    any length.
	   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
	   *    that contains the regular expression body that will be converted to a regular expression
	   *    as in the ngPattern directive.
	   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
	   *    does not match a RegExp found by evaluating the Angular expression given in the attribute value.
	   *    If the expression evaluates to a RegExp object, then this is used directly.
	   *    If the expression evaluates to a string, then it will be converted to a RegExp
	   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	   *    `new RegExp('^abc$')`.<br />
	   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	   *    start at the index of the last search's match, thus not taking the whole input value into
	   *    account.
	   * @param {string=} ngChange Angular expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	      <example name="email-input-directive" module="emailExample">
	        <file name="index.html">
	         <script>
	           angular.module('emailExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.email = {
	                 text: 'me@example.com'
	               };
	             }]);
	         </script>
	           <form name="myForm" ng-controller="ExampleController">
	             <label>Email:
	               <input type="email" name="input" ng-model="email.text" required>
	             </label>
	             <div role="alert">
	               <span class="error" ng-show="myForm.input.$error.required">
	                 Required!</span>
	               <span class="error" ng-show="myForm.input.$error.email">
	                 Not valid email!</span>
	             </div>
	             <tt>text = {{email.text}}</tt><br/>
	             <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	             <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	             <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	             <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	             <tt>myForm.$error.email = {{!!myForm.$error.email}}</tt><br/>
	           </form>
	         </file>
	        <file name="protractor.js" type="protractor">
	          var text = element(by.binding('email.text'));
	          var valid = element(by.binding('myForm.input.$valid'));
	          var input = element(by.model('email.text'));
	
	          it('should initialize to model', function() {
	            expect(text.getText()).toContain('me@example.com');
	            expect(valid.getText()).toContain('true');
	          });
	
	          it('should be invalid if empty', function() {
	            input.clear();
	            input.sendKeys('');
	            expect(text.getText()).toEqual('text =');
	            expect(valid.getText()).toContain('false');
	          });
	
	          it('should be invalid if not email', function() {
	            input.clear();
	            input.sendKeys('xxx');
	
	            expect(valid.getText()).toContain('false');
	          });
	        </file>
	      </example>
	   */
	  'email': emailInputType,
	
	
	  /**
	   * @ngdoc input
	   * @name input[radio]
	   *
	   * @description
	   * HTML radio button.
	   *
	   * @param {string} ngModel Assignable angular expression to data-bind to.
	   * @param {string} value The value to which the `ngModel` expression should be set when selected.
	   *    Note that `value` only supports `string` values, i.e. the scope model needs to be a string,
	   *    too. Use `ngValue` if you need complex models (`number`, `object`, ...).
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} ngChange Angular expression to be executed when input changes due to user
	   *    interaction with the input element.
	   * @param {string} ngValue Angular expression to which `ngModel` will be be set when the radio
	   *    is selected. Should be used instead of the `value` attribute if you need
	   *    a non-string `ngModel` (`boolean`, `array`, ...).
	   *
	   * @example
	      <example name="radio-input-directive" module="radioExample">
	        <file name="index.html">
	         <script>
	           angular.module('radioExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.color = {
	                 name: 'blue'
	               };
	               $scope.specialValue = {
	                 "id": "12345",
	                 "value": "green"
	               };
	             }]);
	         </script>
	         <form name="myForm" ng-controller="ExampleController">
	           <label>
	             <input type="radio" ng-model="color.name" value="red">
	             Red
	           </label><br/>
	           <label>
	             <input type="radio" ng-model="color.name" ng-value="specialValue">
	             Green
	           </label><br/>
	           <label>
	             <input type="radio" ng-model="color.name" value="blue">
	             Blue
	           </label><br/>
	           <tt>color = {{color.name | json}}</tt><br/>
	          </form>
	          Note that `ng-value="specialValue"` sets radio item's value to be the value of `$scope.specialValue`.
	        </file>
	        <file name="protractor.js" type="protractor">
	          it('should change state', function() {
	            var color = element(by.binding('color.name'));
	
	            expect(color.getText()).toContain('blue');
	
	            element.all(by.model('color.name')).get(0).click();
	
	            expect(color.getText()).toContain('red');
	          });
	        </file>
	      </example>
	   */
	  'radio': radioInputType,
	
	
	  /**
	   * @ngdoc input
	   * @name input[checkbox]
	   *
	   * @description
	   * HTML checkbox.
	   *
	   * @param {string} ngModel Assignable angular expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {expression=} ngTrueValue The value to which the expression should be set when selected.
	   * @param {expression=} ngFalseValue The value to which the expression should be set when not selected.
	   * @param {string=} ngChange Angular expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	      <example name="checkbox-input-directive" module="checkboxExample">
	        <file name="index.html">
	         <script>
	           angular.module('checkboxExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.checkboxModel = {
	                value1 : true,
	                value2 : 'YES'
	              };
	             }]);
	         </script>
	         <form name="myForm" ng-controller="ExampleController">
	           <label>Value1:
	             <input type="checkbox" ng-model="checkboxModel.value1">
	           </label><br/>
	           <label>Value2:
	             <input type="checkbox" ng-model="checkboxModel.value2"
	                    ng-true-value="'YES'" ng-false-value="'NO'">
	            </label><br/>
	           <tt>value1 = {{checkboxModel.value1}}</tt><br/>
	           <tt>value2 = {{checkboxModel.value2}}</tt><br/>
	          </form>
	        </file>
	        <file name="protractor.js" type="protractor">
	          it('should change state', function() {
	            var value1 = element(by.binding('checkboxModel.value1'));
	            var value2 = element(by.binding('checkboxModel.value2'));
	
	            expect(value1.getText()).toContain('true');
	            expect(value2.getText()).toContain('YES');
	
	            element(by.model('checkboxModel.value1')).click();
	            element(by.model('checkboxModel.value2')).click();
	
	            expect(value1.getText()).toContain('false');
	            expect(value2.getText()).toContain('NO');
	          });
	        </file>
	      </example>
	   */
	  'checkbox': checkboxInputType,
	
	  'hidden': noop,
	  'button': noop,
	  'submit': noop,
	  'reset': noop,
	  'file': noop
	};
	
	function stringBasedInputType(ctrl) {
	  ctrl.$formatters.push(function(value) {
	    return ctrl.$isEmpty(value) ? value : value.toString();
	  });
	}
	
	function textInputType(scope, element, attr, ctrl, $sniffer, $browser) {
	  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
	  stringBasedInputType(ctrl);
	}
	
	function baseInputType(scope, element, attr, ctrl, $sniffer, $browser) {
	  var type = lowercase(element[0].type);
	
	  // In composition mode, users are still inputing intermediate text buffer,
	  // hold the listener until composition is done.
	  // More about composition events: https://developer.mozilla.org/en-US/docs/Web/API/CompositionEvent
	  if (!$sniffer.android) {
	    var composing = false;
	
	    element.on('compositionstart', function() {
	      composing = true;
	    });
	
	    element.on('compositionend', function() {
	      composing = false;
	      listener();
	    });
	  }
	
	  var timeout;
	
	  var listener = function(ev) {
	    if (timeout) {
	      $browser.defer.cancel(timeout);
	      timeout = null;
	    }
	    if (composing) return;
	    var value = element.val(),
	        event = ev && ev.type;
	
	    // By default we will trim the value
	    // If the attribute ng-trim exists we will avoid trimming
	    // If input type is 'password', the value is never trimmed
	    if (type !== 'password' && (!attr.ngTrim || attr.ngTrim !== 'false')) {
	      value = trim(value);
	    }
	
	    // If a control is suffering from bad input (due to native validators), browsers discard its
	    // value, so it may be necessary to revalidate (by calling $setViewValue again) even if the
	    // control's value is the same empty value twice in a row.
	    if (ctrl.$viewValue !== value || (value === '' && ctrl.$$hasNativeValidators)) {
	      ctrl.$setViewValue(value, event);
	    }
	  };
	
	  // if the browser does support "input" event, we are fine - except on IE9 which doesn't fire the
	  // input event on backspace, delete or cut
	  if ($sniffer.hasEvent('input')) {
	    element.on('input', listener);
	  } else {
	    var deferListener = function(ev, input, origValue) {
	      if (!timeout) {
	        timeout = $browser.defer(function() {
	          timeout = null;
	          if (!input || input.value !== origValue) {
	            listener(ev);
	          }
	        });
	      }
	    };
	
	    element.on('keydown', function(event) {
	      var key = event.keyCode;
	
	      // ignore
	      //    command            modifiers                   arrows
	      if (key === 91 || (15 < key && key < 19) || (37 <= key && key <= 40)) return;
	
	      deferListener(event, this, this.value);
	    });
	
	    // if user modifies input value using context menu in IE, we need "paste" and "cut" events to catch it
	    if ($sniffer.hasEvent('paste')) {
	      element.on('paste cut', deferListener);
	    }
	  }
	
	  // if user paste into input using mouse on older browser
	  // or form autocomplete on newer browser, we need "change" event to catch it
	  element.on('change', listener);
	
	  // Some native input types (date-family) have the ability to change validity without
	  // firing any input/change events.
	  // For these event types, when native validators are present and the browser supports the type,
	  // check for validity changes on various DOM events.
	  if (PARTIAL_VALIDATION_TYPES[type] && ctrl.$$hasNativeValidators && type === attr.type) {
	    element.on(PARTIAL_VALIDATION_EVENTS, function(ev) {
	      if (!timeout) {
	        var validity = this[VALIDITY_STATE_PROPERTY];
	        var origBadInput = validity.badInput;
	        var origTypeMismatch = validity.typeMismatch;
	        timeout = $browser.defer(function() {
	          timeout = null;
	          if (validity.badInput !== origBadInput || validity.typeMismatch !== origTypeMismatch) {
	            listener(ev);
	          }
	        });
	      }
	    });
	  }
	
	  ctrl.$render = function() {
	    // Workaround for Firefox validation #12102.
	    var value = ctrl.$isEmpty(ctrl.$viewValue) ? '' : ctrl.$viewValue;
	    if (element.val() !== value) {
	      element.val(value);
	    }
	  };
	}
	
	function weekParser(isoWeek, existingDate) {
	  if (isDate(isoWeek)) {
	    return isoWeek;
	  }
	
	  if (isString(isoWeek)) {
	    WEEK_REGEXP.lastIndex = 0;
	    var parts = WEEK_REGEXP.exec(isoWeek);
	    if (parts) {
	      var year = +parts[1],
	          week = +parts[2],
	          hours = 0,
	          minutes = 0,
	          seconds = 0,
	          milliseconds = 0,
	          firstThurs = getFirstThursdayOfYear(year),
	          addDays = (week - 1) * 7;
	
	      if (existingDate) {
	        hours = existingDate.getHours();
	        minutes = existingDate.getMinutes();
	        seconds = existingDate.getSeconds();
	        milliseconds = existingDate.getMilliseconds();
	      }
	
	      return new Date(year, 0, firstThurs.getDate() + addDays, hours, minutes, seconds, milliseconds);
	    }
	  }
	
	  return NaN;
	}
	
	function createDateParser(regexp, mapping) {
	  return function(iso, date) {
	    var parts, map;
	
	    if (isDate(iso)) {
	      return iso;
	    }
	
	    if (isString(iso)) {
	      // When a date is JSON'ified to wraps itself inside of an extra
	      // set of double quotes. This makes the date parsing code unable
	      // to match the date string and parse it as a date.
	      if (iso.charAt(0) == '"' && iso.charAt(iso.length - 1) == '"') {
	        iso = iso.substring(1, iso.length - 1);
	      }
	      if (ISO_DATE_REGEXP.test(iso)) {
	        return new Date(iso);
	      }
	      regexp.lastIndex = 0;
	      parts = regexp.exec(iso);
	
	      if (parts) {
	        parts.shift();
	        if (date) {
	          map = {
	            yyyy: date.getFullYear(),
	            MM: date.getMonth() + 1,
	            dd: date.getDate(),
	            HH: date.getHours(),
	            mm: date.getMinutes(),
	            ss: date.getSeconds(),
	            sss: date.getMilliseconds() / 1000
	          };
	        } else {
	          map = { yyyy: 1970, MM: 1, dd: 1, HH: 0, mm: 0, ss: 0, sss: 0 };
	        }
	
	        forEach(parts, function(part, index) {
	          if (index < mapping.length) {
	            map[mapping[index]] = +part;
	          }
	        });
	        return new Date(map.yyyy, map.MM - 1, map.dd, map.HH, map.mm, map.ss || 0, map.sss * 1000 || 0);
	      }
	    }
	
	    return NaN;
	  };
	}
	
	function createDateInputType(type, regexp, parseDate, format) {
	  return function dynamicDateInputType(scope, element, attr, ctrl, $sniffer, $browser, $filter) {
	    badInputChecker(scope, element, attr, ctrl);
	    baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
	    var timezone = ctrl && ctrl.$options && ctrl.$options.timezone;
	    var previousDate;
	
	    ctrl.$$parserName = type;
	    ctrl.$parsers.push(function(value) {
	      if (ctrl.$isEmpty(value)) return null;
	      if (regexp.test(value)) {
	        // Note: We cannot read ctrl.$modelValue, as there might be a different
	        // parser/formatter in the processing chain so that the model
	        // contains some different data format!
	        var parsedDate = parseDate(value, previousDate);
	        if (timezone) {
	          parsedDate = convertTimezoneToLocal(parsedDate, timezone);
	        }
	        return parsedDate;
	      }
	      return undefined;
	    });
	
	    ctrl.$formatters.push(function(value) {
	      if (value && !isDate(value)) {
	        throw ngModelMinErr('datefmt', 'Expected `{0}` to be a date', value);
	      }
	      if (isValidDate(value)) {
	        previousDate = value;
	        if (previousDate && timezone) {
	          previousDate = convertTimezoneToLocal(previousDate, timezone, true);
	        }
	        return $filter('date')(value, format, timezone);
	      } else {
	        previousDate = null;
	        return '';
	      }
	    });
	
	    if (isDefined(attr.min) || attr.ngMin) {
	      var minVal;
	      ctrl.$validators.min = function(value) {
	        return !isValidDate(value) || isUndefined(minVal) || parseDate(value) >= minVal;
	      };
	      attr.$observe('min', function(val) {
	        minVal = parseObservedDateValue(val);
	        ctrl.$validate();
	      });
	    }
	
	    if (isDefined(attr.max) || attr.ngMax) {
	      var maxVal;
	      ctrl.$validators.max = function(value) {
	        return !isValidDate(value) || isUndefined(maxVal) || parseDate(value) <= maxVal;
	      };
	      attr.$observe('max', function(val) {
	        maxVal = parseObservedDateValue(val);
	        ctrl.$validate();
	      });
	    }
	
	    function isValidDate(value) {
	      // Invalid Date: getTime() returns NaN
	      return value && !(value.getTime && value.getTime() !== value.getTime());
	    }
	
	    function parseObservedDateValue(val) {
	      return isDefined(val) && !isDate(val) ? parseDate(val) || undefined : val;
	    }
	  };
	}
	
	function badInputChecker(scope, element, attr, ctrl) {
	  var node = element[0];
	  var nativeValidation = ctrl.$$hasNativeValidators = isObject(node.validity);
	  if (nativeValidation) {
	    ctrl.$parsers.push(function(value) {
	      var validity = element.prop(VALIDITY_STATE_PROPERTY) || {};
	      return validity.badInput || validity.typeMismatch ? undefined : value;
	    });
	  }
	}
	
	function numberInputType(scope, element, attr, ctrl, $sniffer, $browser) {
	  badInputChecker(scope, element, attr, ctrl);
	  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
	
	  ctrl.$$parserName = 'number';
	  ctrl.$parsers.push(function(value) {
	    if (ctrl.$isEmpty(value))      return null;
	    if (NUMBER_REGEXP.test(value)) return parseFloat(value);
	    return undefined;
	  });
	
	  ctrl.$formatters.push(function(value) {
	    if (!ctrl.$isEmpty(value)) {
	      if (!isNumber(value)) {
	        throw ngModelMinErr('numfmt', 'Expected `{0}` to be a number', value);
	      }
	      value = value.toString();
	    }
	    return value;
	  });
	
	  if (isDefined(attr.min) || attr.ngMin) {
	    var minVal;
	    ctrl.$validators.min = function(value) {
	      return ctrl.$isEmpty(value) || isUndefined(minVal) || value >= minVal;
	    };
	
	    attr.$observe('min', function(val) {
	      if (isDefined(val) && !isNumber(val)) {
	        val = parseFloat(val, 10);
	      }
	      minVal = isNumber(val) && !isNaN(val) ? val : undefined;
	      // TODO(matsko): implement validateLater to reduce number of validations
	      ctrl.$validate();
	    });
	  }
	
	  if (isDefined(attr.max) || attr.ngMax) {
	    var maxVal;
	    ctrl.$validators.max = function(value) {
	      return ctrl.$isEmpty(value) || isUndefined(maxVal) || value <= maxVal;
	    };
	
	    attr.$observe('max', function(val) {
	      if (isDefined(val) && !isNumber(val)) {
	        val = parseFloat(val, 10);
	      }
	      maxVal = isNumber(val) && !isNaN(val) ? val : undefined;
	      // TODO(matsko): implement validateLater to reduce number of validations
	      ctrl.$validate();
	    });
	  }
	}
	
	function urlInputType(scope, element, attr, ctrl, $sniffer, $browser) {
	  // Note: no badInputChecker here by purpose as `url` is only a validation
	  // in browsers, i.e. we can always read out input.value even if it is not valid!
	  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
	  stringBasedInputType(ctrl);
	
	  ctrl.$$parserName = 'url';
	  ctrl.$validators.url = function(modelValue, viewValue) {
	    var value = modelValue || viewValue;
	    return ctrl.$isEmpty(value) || URL_REGEXP.test(value);
	  };
	}
	
	function emailInputType(scope, element, attr, ctrl, $sniffer, $browser) {
	  // Note: no badInputChecker here by purpose as `url` is only a validation
	  // in browsers, i.e. we can always read out input.value even if it is not valid!
	  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
	  stringBasedInputType(ctrl);
	
	  ctrl.$$parserName = 'email';
	  ctrl.$validators.email = function(modelValue, viewValue) {
	    var value = modelValue || viewValue;
	    return ctrl.$isEmpty(value) || EMAIL_REGEXP.test(value);
	  };
	}
	
	function radioInputType(scope, element, attr, ctrl) {
	  // make the name unique, if not defined
	  if (isUndefined(attr.name)) {
	    element.attr('name', nextUid());
	  }
	
	  var listener = function(ev) {
	    if (element[0].checked) {
	      ctrl.$setViewValue(attr.value, ev && ev.type);
	    }
	  };
	
	  element.on('click', listener);
	
	  ctrl.$render = function() {
	    var value = attr.value;
	    element[0].checked = (value == ctrl.$viewValue);
	  };
	
	  attr.$observe('value', ctrl.$render);
	}
	
	function parseConstantExpr($parse, context, name, expression, fallback) {
	  var parseFn;
	  if (isDefined(expression)) {
	    parseFn = $parse(expression);
	    if (!parseFn.constant) {
	      throw ngModelMinErr('constexpr', 'Expected constant expression for `{0}`, but saw ' +
	                                   '`{1}`.', name, expression);
	    }
	    return parseFn(context);
	  }
	  return fallback;
	}
	
	function checkboxInputType(scope, element, attr, ctrl, $sniffer, $browser, $filter, $parse) {
	  var trueValue = parseConstantExpr($parse, scope, 'ngTrueValue', attr.ngTrueValue, true);
	  var falseValue = parseConstantExpr($parse, scope, 'ngFalseValue', attr.ngFalseValue, false);
	
	  var listener = function(ev) {
	    ctrl.$setViewValue(element[0].checked, ev && ev.type);
	  };
	
	  element.on('click', listener);
	
	  ctrl.$render = function() {
	    element[0].checked = ctrl.$viewValue;
	  };
	
	  // Override the standard `$isEmpty` because the $viewValue of an empty checkbox is always set to `false`
	  // This is because of the parser below, which compares the `$modelValue` with `trueValue` to convert
	  // it to a boolean.
	  ctrl.$isEmpty = function(value) {
	    return value === false;
	  };
	
	  ctrl.$formatters.push(function(value) {
	    return equals(value, trueValue);
	  });
	
	  ctrl.$parsers.push(function(value) {
	    return value ? trueValue : falseValue;
	  });
	}
	
	
	/**
	 * @ngdoc directive
	 * @name textarea
	 * @restrict E
	 *
	 * @description
	 * HTML textarea element control with angular data-binding. The data-binding and validation
	 * properties of this element are exactly the same as those of the
	 * {@link ng.directive:input input element}.
	 *
	 * @param {string} ngModel Assignable angular expression to data-bind to.
	 * @param {string=} name Property name of the form under which the control is published.
	 * @param {string=} required Sets `required` validation error key if the value is not entered.
	 * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	 *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	 *    `required` when you want to data-bind to the `required` attribute.
	 * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	 *    minlength.
	 * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	 *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of any
	 *    length.
	 * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
	 *    does not match a RegExp found by evaluating the Angular expression given in the attribute value.
	 *    If the expression evaluates to a RegExp object, then this is used directly.
	 *    If the expression evaluates to a string, then it will be converted to a RegExp
	 *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	 *    `new RegExp('^abc$')`.<br />
	 *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	 *    start at the index of the last search's match, thus not taking the whole input value into
	 *    account.
	 * @param {string=} ngChange Angular expression to be executed when input changes due to user
	 *    interaction with the input element.
	 * @param {boolean=} [ngTrim=true] If set to false Angular will not automatically trim the input.
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name input
	 * @restrict E
	 *
	 * @description
	 * HTML input element control. When used together with {@link ngModel `ngModel`}, it provides data-binding,
	 * input state control, and validation.
	 * Input control follows HTML5 input types and polyfills the HTML5 validation behavior for older browsers.
	 *
	 * <div class="alert alert-warning">
	 * **Note:** Not every feature offered is available for all input types.
	 * Specifically, data binding and event handling via `ng-model` is unsupported for `input[file]`.
	 * </div>
	 *
	 * @param {string} ngModel Assignable angular expression to data-bind to.
	 * @param {string=} name Property name of the form under which the control is published.
	 * @param {string=} required Sets `required` validation error key if the value is not entered.
	 * @param {boolean=} ngRequired Sets `required` attribute if set to true
	 * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	 *    minlength.
	 * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	 *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of any
	 *    length.
	 * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
	 *    value does not match a RegExp found by evaluating the Angular expression given in the attribute value.
	 *    If the expression evaluates to a RegExp object, then this is used directly.
	 *    If the expression evaluates to a string, then it will be converted to a RegExp
	 *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	 *    `new RegExp('^abc$')`.<br />
	 *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	 *    start at the index of the last search's match, thus not taking the whole input value into
	 *    account.
	 * @param {string=} ngChange Angular expression to be executed when input changes due to user
	 *    interaction with the input element.
	 * @param {boolean=} [ngTrim=true] If set to false Angular will not automatically trim the input.
	 *    This parameter is ignored for input[type=password] controls, which will never trim the
	 *    input.
	 *
	 * @example
	    <example name="input-directive" module="inputExample">
	      <file name="index.html">
	       <script>
	          angular.module('inputExample', [])
	            .controller('ExampleController', ['$scope', function($scope) {
	              $scope.user = {name: 'guest', last: 'visitor'};
	            }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <form name="myForm">
	           <label>
	              User name:
	              <input type="text" name="userName" ng-model="user.name" required>
	           </label>
	           <div role="alert">
	             <span class="error" ng-show="myForm.userName.$error.required">
	              Required!</span>
	           </div>
	           <label>
	              Last name:
	              <input type="text" name="lastName" ng-model="user.last"
	              ng-minlength="3" ng-maxlength="10">
	           </label>
	           <div role="alert">
	             <span class="error" ng-show="myForm.lastName.$error.minlength">
	               Too short!</span>
	             <span class="error" ng-show="myForm.lastName.$error.maxlength">
	               Too long!</span>
	           </div>
	         </form>
	         <hr>
	         <tt>user = {{user}}</tt><br/>
	         <tt>myForm.userName.$valid = {{myForm.userName.$valid}}</tt><br/>
	         <tt>myForm.userName.$error = {{myForm.userName.$error}}</tt><br/>
	         <tt>myForm.lastName.$valid = {{myForm.lastName.$valid}}</tt><br/>
	         <tt>myForm.lastName.$error = {{myForm.lastName.$error}}</tt><br/>
	         <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	         <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	         <tt>myForm.$error.minlength = {{!!myForm.$error.minlength}}</tt><br/>
	         <tt>myForm.$error.maxlength = {{!!myForm.$error.maxlength}}</tt><br/>
	       </div>
	      </file>
	      <file name="protractor.js" type="protractor">
	        var user = element(by.exactBinding('user'));
	        var userNameValid = element(by.binding('myForm.userName.$valid'));
	        var lastNameValid = element(by.binding('myForm.lastName.$valid'));
	        var lastNameError = element(by.binding('myForm.lastName.$error'));
	        var formValid = element(by.binding('myForm.$valid'));
	        var userNameInput = element(by.model('user.name'));
	        var userLastInput = element(by.model('user.last'));
	
	        it('should initialize to model', function() {
	          expect(user.getText()).toContain('{"name":"guest","last":"visitor"}');
	          expect(userNameValid.getText()).toContain('true');
	          expect(formValid.getText()).toContain('true');
	        });
	
	        it('should be invalid if empty when required', function() {
	          userNameInput.clear();
	          userNameInput.sendKeys('');
	
	          expect(user.getText()).toContain('{"last":"visitor"}');
	          expect(userNameValid.getText()).toContain('false');
	          expect(formValid.getText()).toContain('false');
	        });
	
	        it('should be valid if empty when min length is set', function() {
	          userLastInput.clear();
	          userLastInput.sendKeys('');
	
	          expect(user.getText()).toContain('{"name":"guest","last":""}');
	          expect(lastNameValid.getText()).toContain('true');
	          expect(formValid.getText()).toContain('true');
	        });
	
	        it('should be invalid if less than required min length', function() {
	          userLastInput.clear();
	          userLastInput.sendKeys('xx');
	
	          expect(user.getText()).toContain('{"name":"guest"}');
	          expect(lastNameValid.getText()).toContain('false');
	          expect(lastNameError.getText()).toContain('minlength');
	          expect(formValid.getText()).toContain('false');
	        });
	
	        it('should be invalid if longer than max length', function() {
	          userLastInput.clear();
	          userLastInput.sendKeys('some ridiculously long name');
	
	          expect(user.getText()).toContain('{"name":"guest"}');
	          expect(lastNameValid.getText()).toContain('false');
	          expect(lastNameError.getText()).toContain('maxlength');
	          expect(formValid.getText()).toContain('false');
	        });
	      </file>
	    </example>
	 */
	var inputDirective = ['$browser', '$sniffer', '$filter', '$parse',
	    function($browser, $sniffer, $filter, $parse) {
	  return {
	    restrict: 'E',
	    require: ['?ngModel'],
	    link: {
	      pre: function(scope, element, attr, ctrls) {
	        if (ctrls[0]) {
	          (inputType[lowercase(attr.type)] || inputType.text)(scope, element, attr, ctrls[0], $sniffer,
	                                                              $browser, $filter, $parse);
	        }
	      }
	    }
	  };
	}];
	
	
	
	var CONSTANT_VALUE_REGEXP = /^(true|false|\d+)$/;
	/**
	 * @ngdoc directive
	 * @name ngValue
	 *
	 * @description
	 * Binds the given expression to the value of `<option>` or {@link input[radio] `input[radio]`},
	 * so that when the element is selected, the {@link ngModel `ngModel`} of that element is set to
	 * the bound value.
	 *
	 * `ngValue` is useful when dynamically generating lists of radio buttons using
	 * {@link ngRepeat `ngRepeat`}, as shown below.
	 *
	 * Likewise, `ngValue` can be used to generate `<option>` elements for
	 * the {@link select `select`} element. In that case however, only strings are supported
	 * for the `value `attribute, so the resulting `ngModel` will always be a string.
	 * Support for `select` models with non-string values is available via `ngOptions`.
	 *
	 * @element input
	 * @param {string=} ngValue angular expression, whose value will be bound to the `value` attribute
	 *   of the `input` element
	 *
	 * @example
	    <example name="ngValue-directive" module="valueExample">
	      <file name="index.html">
	       <script>
	          angular.module('valueExample', [])
	            .controller('ExampleController', ['$scope', function($scope) {
	              $scope.names = ['pizza', 'unicorns', 'robots'];
	              $scope.my = { favorite: 'unicorns' };
	            }]);
	       </script>
	        <form ng-controller="ExampleController">
	          <h2>Which is your favorite?</h2>
	            <label ng-repeat="name in names" for="{{name}}">
	              {{name}}
	              <input type="radio"
	                     ng-model="my.favorite"
	                     ng-value="name"
	                     id="{{name}}"
	                     name="favorite">
	            </label>
	          <div>You chose {{my.favorite}}</div>
	        </form>
	      </file>
	      <file name="protractor.js" type="protractor">
	        var favorite = element(by.binding('my.favorite'));
	
	        it('should initialize to model', function() {
	          expect(favorite.getText()).toContain('unicorns');
	        });
	        it('should bind the values to the inputs', function() {
	          element.all(by.model('my.favorite')).get(0).click();
	          expect(favorite.getText()).toContain('pizza');
	        });
	      </file>
	    </example>
	 */
	var ngValueDirective = function() {
	  return {
	    restrict: 'A',
	    priority: 100,
	    compile: function(tpl, tplAttr) {
	      if (CONSTANT_VALUE_REGEXP.test(tplAttr.ngValue)) {
	        return function ngValueConstantLink(scope, elm, attr) {
	          attr.$set('value', scope.$eval(attr.ngValue));
	        };
	      } else {
	        return function ngValueLink(scope, elm, attr) {
	          scope.$watch(attr.ngValue, function valueWatchAction(value) {
	            attr.$set('value', value);
	          });
	        };
	      }
	    }
	  };
	};
	
	/**
	 * @ngdoc directive
	 * @name ngBind
	 * @restrict AC
	 *
	 * @description
	 * The `ngBind` attribute tells Angular to replace the text content of the specified HTML element
	 * with the value of a given expression, and to update the text content when the value of that
	 * expression changes.
	 *
	 * Typically, you don't use `ngBind` directly, but instead you use the double curly markup like
	 * `{{ expression }}` which is similar but less verbose.
	 *
	 * It is preferable to use `ngBind` instead of `{{ expression }}` if a template is momentarily
	 * displayed by the browser in its raw state before Angular compiles it. Since `ngBind` is an
	 * element attribute, it makes the bindings invisible to the user while the page is loading.
	 *
	 * An alternative solution to this problem would be using the
	 * {@link ng.directive:ngCloak ngCloak} directive.
	 *
	 *
	 * @element ANY
	 * @param {expression} ngBind {@link guide/expression Expression} to evaluate.
	 *
	 * @example
	 * Enter a name in the Live Preview text box; the greeting below the text box changes instantly.
	   <example module="bindExample">
	     <file name="index.html">
	       <script>
	         angular.module('bindExample', [])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.name = 'Whirled';
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <label>Enter name: <input type="text" ng-model="name"></label><br>
	         Hello <span ng-bind="name"></span>!
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-bind', function() {
	         var nameInput = element(by.model('name'));
	
	         expect(element(by.binding('name')).getText()).toBe('Whirled');
	         nameInput.clear();
	         nameInput.sendKeys('world');
	         expect(element(by.binding('name')).getText()).toBe('world');
	       });
	     </file>
	   </example>
	 */
	var ngBindDirective = ['$compile', function($compile) {
	  return {
	    restrict: 'AC',
	    compile: function ngBindCompile(templateElement) {
	      $compile.$$addBindingClass(templateElement);
	      return function ngBindLink(scope, element, attr) {
	        $compile.$$addBindingInfo(element, attr.ngBind);
	        element = element[0];
	        scope.$watch(attr.ngBind, function ngBindWatchAction(value) {
	          element.textContent = isUndefined(value) ? '' : value;
	        });
	      };
	    }
	  };
	}];
	
	
	/**
	 * @ngdoc directive
	 * @name ngBindTemplate
	 *
	 * @description
	 * The `ngBindTemplate` directive specifies that the element
	 * text content should be replaced with the interpolation of the template
	 * in the `ngBindTemplate` attribute.
	 * Unlike `ngBind`, the `ngBindTemplate` can contain multiple `{{` `}}`
	 * expressions. This directive is needed since some HTML elements
	 * (such as TITLE and OPTION) cannot contain SPAN elements.
	 *
	 * @element ANY
	 * @param {string} ngBindTemplate template of form
	 *   <tt>{{</tt> <tt>expression</tt> <tt>}}</tt> to eval.
	 *
	 * @example
	 * Try it here: enter text in text box and watch the greeting change.
	   <example module="bindExample">
	     <file name="index.html">
	       <script>
	         angular.module('bindExample', [])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.salutation = 'Hello';
	             $scope.name = 'World';
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	        <label>Salutation: <input type="text" ng-model="salutation"></label><br>
	        <label>Name: <input type="text" ng-model="name"></label><br>
	        <pre ng-bind-template="{{salutation}} {{name}}!"></pre>
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-bind', function() {
	         var salutationElem = element(by.binding('salutation'));
	         var salutationInput = element(by.model('salutation'));
	         var nameInput = element(by.model('name'));
	
	         expect(salutationElem.getText()).toBe('Hello World!');
	
	         salutationInput.clear();
	         salutationInput.sendKeys('Greetings');
	         nameInput.clear();
	         nameInput.sendKeys('user');
	
	         expect(salutationElem.getText()).toBe('Greetings user!');
	       });
	     </file>
	   </example>
	 */
	var ngBindTemplateDirective = ['$interpolate', '$compile', function($interpolate, $compile) {
	  return {
	    compile: function ngBindTemplateCompile(templateElement) {
	      $compile.$$addBindingClass(templateElement);
	      return function ngBindTemplateLink(scope, element, attr) {
	        var interpolateFn = $interpolate(element.attr(attr.$attr.ngBindTemplate));
	        $compile.$$addBindingInfo(element, interpolateFn.expressions);
	        element = element[0];
	        attr.$observe('ngBindTemplate', function(value) {
	          element.textContent = isUndefined(value) ? '' : value;
	        });
	      };
	    }
	  };
	}];
	
	
	/**
	 * @ngdoc directive
	 * @name ngBindHtml
	 *
	 * @description
	 * Evaluates the expression and inserts the resulting HTML into the element in a secure way. By default,
	 * the resulting HTML content will be sanitized using the {@link ngSanitize.$sanitize $sanitize} service.
	 * To utilize this functionality, ensure that `$sanitize` is available, for example, by including {@link
	 * ngSanitize} in your module's dependencies (not in core Angular). In order to use {@link ngSanitize}
	 * in your module's dependencies, you need to include "angular-sanitize.js" in your application.
	 *
	 * You may also bypass sanitization for values you know are safe. To do so, bind to
	 * an explicitly trusted value via {@link ng.$sce#trustAsHtml $sce.trustAsHtml}.  See the example
	 * under {@link ng.$sce#show-me-an-example-using-sce- Strict Contextual Escaping (SCE)}.
	 *
	 * Note: If a `$sanitize` service is unavailable and the bound value isn't explicitly trusted, you
	 * will have an exception (instead of an exploit.)
	 *
	 * @element ANY
	 * @param {expression} ngBindHtml {@link guide/expression Expression} to evaluate.
	 *
	 * @example
	
	   <example module="bindHtmlExample" deps="angular-sanitize.js">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	        <p ng-bind-html="myHTML"></p>
	       </div>
	     </file>
	
	     <file name="script.js">
	       angular.module('bindHtmlExample', ['ngSanitize'])
	         .controller('ExampleController', ['$scope', function($scope) {
	           $scope.myHTML =
	              'I am an <code>HTML</code>string with ' +
	              '<a href="#">links!</a> and other <em>stuff</em>';
	         }]);
	     </file>
	
	     <file name="protractor.js" type="protractor">
	       it('should check ng-bind-html', function() {
	         expect(element(by.binding('myHTML')).getText()).toBe(
	             'I am an HTMLstring with links! and other stuff');
	       });
	     </file>
	   </example>
	 */
	var ngBindHtmlDirective = ['$sce', '$parse', '$compile', function($sce, $parse, $compile) {
	  return {
	    restrict: 'A',
	    compile: function ngBindHtmlCompile(tElement, tAttrs) {
	      var ngBindHtmlGetter = $parse(tAttrs.ngBindHtml);
	      var ngBindHtmlWatch = $parse(tAttrs.ngBindHtml, function sceValueOf(val) {
	        // Unwrap the value to compare the actual inner safe value, not the wrapper object.
	        return $sce.valueOf(val);
	      });
	      $compile.$$addBindingClass(tElement);
	
	      return function ngBindHtmlLink(scope, element, attr) {
	        $compile.$$addBindingInfo(element, attr.ngBindHtml);
	
	        scope.$watch(ngBindHtmlWatch, function ngBindHtmlWatchAction() {
	          // The watched value is the unwrapped value. To avoid re-escaping, use the direct getter.
	          var value = ngBindHtmlGetter(scope);
	          element.html($sce.getTrustedHtml(value) || '');
	        });
	      };
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngChange
	 *
	 * @description
	 * Evaluate the given expression when the user changes the input.
	 * The expression is evaluated immediately, unlike the JavaScript onchange event
	 * which only triggers at the end of a change (usually, when the user leaves the
	 * form element or presses the return key).
	 *
	 * The `ngChange` expression is only evaluated when a change in the input value causes
	 * a new value to be committed to the model.
	 *
	 * It will not be evaluated:
	 * * if the value returned from the `$parsers` transformation pipeline has not changed
	 * * if the input has continued to be invalid since the model will stay `null`
	 * * if the model is changed programmatically and not by a change to the input value
	 *
	 *
	 * Note, this directive requires `ngModel` to be present.
	 *
	 * @element input
	 * @param {expression} ngChange {@link guide/expression Expression} to evaluate upon change
	 * in input value.
	 *
	 * @example
	 * <example name="ngChange-directive" module="changeExample">
	 *   <file name="index.html">
	 *     <script>
	 *       angular.module('changeExample', [])
	 *         .controller('ExampleController', ['$scope', function($scope) {
	 *           $scope.counter = 0;
	 *           $scope.change = function() {
	 *             $scope.counter++;
	 *           };
	 *         }]);
	 *     </script>
	 *     <div ng-controller="ExampleController">
	 *       <input type="checkbox" ng-model="confirmed" ng-change="change()" id="ng-change-example1" />
	 *       <input type="checkbox" ng-model="confirmed" id="ng-change-example2" />
	 *       <label for="ng-change-example2">Confirmed</label><br />
	 *       <tt>debug = {{confirmed}}</tt><br/>
	 *       <tt>counter = {{counter}}</tt><br/>
	 *     </div>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *     var counter = element(by.binding('counter'));
	 *     var debug = element(by.binding('confirmed'));
	 *
	 *     it('should evaluate the expression if changing from view', function() {
	 *       expect(counter.getText()).toContain('0');
	 *
	 *       element(by.id('ng-change-example1')).click();
	 *
	 *       expect(counter.getText()).toContain('1');
	 *       expect(debug.getText()).toContain('true');
	 *     });
	 *
	 *     it('should not evaluate the expression if changing from model', function() {
	 *       element(by.id('ng-change-example2')).click();
	
	 *       expect(counter.getText()).toContain('0');
	 *       expect(debug.getText()).toContain('true');
	 *     });
	 *   </file>
	 * </example>
	 */
	var ngChangeDirective = valueFn({
	  restrict: 'A',
	  require: 'ngModel',
	  link: function(scope, element, attr, ctrl) {
	    ctrl.$viewChangeListeners.push(function() {
	      scope.$eval(attr.ngChange);
	    });
	  }
	});
	
	function classDirective(name, selector) {
	  name = 'ngClass' + name;
	  return ['$animate', function($animate) {
	    return {
	      restrict: 'AC',
	      link: function(scope, element, attr) {
	        var oldVal;
	
	        scope.$watch(attr[name], ngClassWatchAction, true);
	
	        attr.$observe('class', function(value) {
	          ngClassWatchAction(scope.$eval(attr[name]));
	        });
	
	
	        if (name !== 'ngClass') {
	          scope.$watch('$index', function($index, old$index) {
	            // jshint bitwise: false
	            var mod = $index & 1;
	            if (mod !== (old$index & 1)) {
	              var classes = arrayClasses(scope.$eval(attr[name]));
	              mod === selector ?
	                addClasses(classes) :
	                removeClasses(classes);
	            }
	          });
	        }
	
	        function addClasses(classes) {
	          var newClasses = digestClassCounts(classes, 1);
	          attr.$addClass(newClasses);
	        }
	
	        function removeClasses(classes) {
	          var newClasses = digestClassCounts(classes, -1);
	          attr.$removeClass(newClasses);
	        }
	
	        function digestClassCounts(classes, count) {
	          // Use createMap() to prevent class assumptions involving property
	          // names in Object.prototype
	          var classCounts = element.data('$classCounts') || createMap();
	          var classesToUpdate = [];
	          forEach(classes, function(className) {
	            if (count > 0 || classCounts[className]) {
	              classCounts[className] = (classCounts[className] || 0) + count;
	              if (classCounts[className] === +(count > 0)) {
	                classesToUpdate.push(className);
	              }
	            }
	          });
	          element.data('$classCounts', classCounts);
	          return classesToUpdate.join(' ');
	        }
	
	        function updateClasses(oldClasses, newClasses) {
	          var toAdd = arrayDifference(newClasses, oldClasses);
	          var toRemove = arrayDifference(oldClasses, newClasses);
	          toAdd = digestClassCounts(toAdd, 1);
	          toRemove = digestClassCounts(toRemove, -1);
	          if (toAdd && toAdd.length) {
	            $animate.addClass(element, toAdd);
	          }
	          if (toRemove && toRemove.length) {
	            $animate.removeClass(element, toRemove);
	          }
	        }
	
	        function ngClassWatchAction(newVal) {
	          // jshint bitwise: false
	          if (selector === true || (scope.$index & 1) === selector) {
	          // jshint bitwise: true
	            var newClasses = arrayClasses(newVal || []);
	            if (!oldVal) {
	              addClasses(newClasses);
	            } else if (!equals(newVal,oldVal)) {
	              var oldClasses = arrayClasses(oldVal);
	              updateClasses(oldClasses, newClasses);
	            }
	          }
	          if (isArray(newVal)) {
	            oldVal = newVal.map(function(v) { return shallowCopy(v); });
	          } else {
	            oldVal = shallowCopy(newVal);
	          }
	        }
	      }
	    };
	
	    function arrayDifference(tokens1, tokens2) {
	      var values = [];
	
	      outer:
	      for (var i = 0; i < tokens1.length; i++) {
	        var token = tokens1[i];
	        for (var j = 0; j < tokens2.length; j++) {
	          if (token == tokens2[j]) continue outer;
	        }
	        values.push(token);
	      }
	      return values;
	    }
	
	    function arrayClasses(classVal) {
	      var classes = [];
	      if (isArray(classVal)) {
	        forEach(classVal, function(v) {
	          classes = classes.concat(arrayClasses(v));
	        });
	        return classes;
	      } else if (isString(classVal)) {
	        return classVal.split(' ');
	      } else if (isObject(classVal)) {
	        forEach(classVal, function(v, k) {
	          if (v) {
	            classes = classes.concat(k.split(' '));
	          }
	        });
	        return classes;
	      }
	      return classVal;
	    }
	  }];
	}
	
	/**
	 * @ngdoc directive
	 * @name ngClass
	 * @restrict AC
	 *
	 * @description
	 * The `ngClass` directive allows you to dynamically set CSS classes on an HTML element by databinding
	 * an expression that represents all classes to be added.
	 *
	 * The directive operates in three different ways, depending on which of three types the expression
	 * evaluates to:
	 *
	 * 1. If the expression evaluates to a string, the string should be one or more space-delimited class
	 * names.
	 *
	 * 2. If the expression evaluates to an object, then for each key-value pair of the
	 * object with a truthy value the corresponding key is used as a class name.
	 *
	 * 3. If the expression evaluates to an array, each element of the array should either be a string as in
	 * type 1 or an object as in type 2. This means that you can mix strings and objects together in an array
	 * to give you more control over what CSS classes appear. See the code below for an example of this.
	 *
	 *
	 * The directive won't add duplicate classes if a particular class was already set.
	 *
	 * When the expression changes, the previously added classes are removed and only then are the
	 * new classes added.
	 *
	 * @animations
	 * | Animation                        | Occurs                              |
	 * |----------------------------------|-------------------------------------|
	 * | {@link ng.$animate#addClass addClass}       | just before the class is applied to the element   |
	 * | {@link ng.$animate#removeClass removeClass} | just before the class is removed from the element |
	 *
	 * @element ANY
	 * @param {expression} ngClass {@link guide/expression Expression} to eval. The result
	 *   of the evaluation can be a string representing space delimited class
	 *   names, an array, or a map of class names to boolean values. In the case of a map, the
	 *   names of the properties whose values are truthy will be added as css classes to the
	 *   element.
	 *
	 * @example Example that demonstrates basic bindings via ngClass directive.
	   <example>
	     <file name="index.html">
	       <p ng-class="{strike: deleted, bold: important, 'has-error': error}">Map Syntax Example</p>
	       <label>
	          <input type="checkbox" ng-model="deleted">
	          deleted (apply "strike" class)
	       </label><br>
	       <label>
	          <input type="checkbox" ng-model="important">
	          important (apply "bold" class)
	       </label><br>
	       <label>
	          <input type="checkbox" ng-model="error">
	          error (apply "has-error" class)
	       </label>
	       <hr>
	       <p ng-class="style">Using String Syntax</p>
	       <input type="text" ng-model="style"
	              placeholder="Type: bold strike red" aria-label="Type: bold strike red">
	       <hr>
	       <p ng-class="[style1, style2, style3]">Using Array Syntax</p>
	       <input ng-model="style1"
	              placeholder="Type: bold, strike or red" aria-label="Type: bold, strike or red"><br>
	       <input ng-model="style2"
	              placeholder="Type: bold, strike or red" aria-label="Type: bold, strike or red 2"><br>
	       <input ng-model="style3"
	              placeholder="Type: bold, strike or red" aria-label="Type: bold, strike or red 3"><br>
	       <hr>
	       <p ng-class="[style4, {orange: warning}]">Using Array and Map Syntax</p>
	       <input ng-model="style4" placeholder="Type: bold, strike" aria-label="Type: bold, strike"><br>
	       <label><input type="checkbox" ng-model="warning"> warning (apply "orange" class)</label>
	     </file>
	     <file name="style.css">
	       .strike {
	           text-decoration: line-through;
	       }
	       .bold {
	           font-weight: bold;
	       }
	       .red {
	           color: red;
	       }
	       .has-error {
	           color: red;
	           background-color: yellow;
	       }
	       .orange {
	           color: orange;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       var ps = element.all(by.css('p'));
	
	       it('should let you toggle the class', function() {
	
	         expect(ps.first().getAttribute('class')).not.toMatch(/bold/);
	         expect(ps.first().getAttribute('class')).not.toMatch(/has-error/);
	
	         element(by.model('important')).click();
	         expect(ps.first().getAttribute('class')).toMatch(/bold/);
	
	         element(by.model('error')).click();
	         expect(ps.first().getAttribute('class')).toMatch(/has-error/);
	       });
	
	       it('should let you toggle string example', function() {
	         expect(ps.get(1).getAttribute('class')).toBe('');
	         element(by.model('style')).clear();
	         element(by.model('style')).sendKeys('red');
	         expect(ps.get(1).getAttribute('class')).toBe('red');
	       });
	
	       it('array example should have 3 classes', function() {
	         expect(ps.get(2).getAttribute('class')).toBe('');
	         element(by.model('style1')).sendKeys('bold');
	         element(by.model('style2')).sendKeys('strike');
	         element(by.model('style3')).sendKeys('red');
	         expect(ps.get(2).getAttribute('class')).toBe('bold strike red');
	       });
	
	       it('array with map example should have 2 classes', function() {
	         expect(ps.last().getAttribute('class')).toBe('');
	         element(by.model('style4')).sendKeys('bold');
	         element(by.model('warning')).click();
	         expect(ps.last().getAttribute('class')).toBe('bold orange');
	       });
	     </file>
	   </example>
	
	   ## Animations
	
	   The example below demonstrates how to perform animations using ngClass.
	
	   <example module="ngAnimate" deps="angular-animate.js" animations="true">
	     <file name="index.html">
	      <input id="setbtn" type="button" value="set" ng-click="myVar='my-class'">
	      <input id="clearbtn" type="button" value="clear" ng-click="myVar=''">
	      <br>
	      <span class="base-class" ng-class="myVar">Sample Text</span>
	     </file>
	     <file name="style.css">
	       .base-class {
	         transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
	       }
	
	       .base-class.my-class {
	         color: red;
	         font-size:3em;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-class', function() {
	         expect(element(by.css('.base-class')).getAttribute('class')).not.
	           toMatch(/my-class/);
	
	         element(by.id('setbtn')).click();
	
	         expect(element(by.css('.base-class')).getAttribute('class')).
	           toMatch(/my-class/);
	
	         element(by.id('clearbtn')).click();
	
	         expect(element(by.css('.base-class')).getAttribute('class')).not.
	           toMatch(/my-class/);
	       });
	     </file>
	   </example>
	
	
	   ## ngClass and pre-existing CSS3 Transitions/Animations
	   The ngClass directive still supports CSS3 Transitions/Animations even if they do not follow the ngAnimate CSS naming structure.
	   Upon animation ngAnimate will apply supplementary CSS classes to track the start and end of an animation, but this will not hinder
	   any pre-existing CSS transitions already on the element. To get an idea of what happens during a class-based animation, be sure
	   to view the step by step details of {@link $animate#addClass $animate.addClass} and
	   {@link $animate#removeClass $animate.removeClass}.
	 */
	var ngClassDirective = classDirective('', true);
	
	/**
	 * @ngdoc directive
	 * @name ngClassOdd
	 * @restrict AC
	 *
	 * @description
	 * The `ngClassOdd` and `ngClassEven` directives work exactly as
	 * {@link ng.directive:ngClass ngClass}, except they work in
	 * conjunction with `ngRepeat` and take effect only on odd (even) rows.
	 *
	 * This directive can be applied only within the scope of an
	 * {@link ng.directive:ngRepeat ngRepeat}.
	 *
	 * @element ANY
	 * @param {expression} ngClassOdd {@link guide/expression Expression} to eval. The result
	 *   of the evaluation can be a string representing space delimited class names or an array.
	 *
	 * @example
	   <example>
	     <file name="index.html">
	        <ol ng-init="names=['John', 'Mary', 'Cate', 'Suz']">
	          <li ng-repeat="name in names">
	           <span ng-class-odd="'odd'" ng-class-even="'even'">
	             {{name}}
	           </span>
	          </li>
	        </ol>
	     </file>
	     <file name="style.css">
	       .odd {
	         color: red;
	       }
	       .even {
	         color: blue;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-class-odd and ng-class-even', function() {
	         expect(element(by.repeater('name in names').row(0).column('name')).getAttribute('class')).
	           toMatch(/odd/);
	         expect(element(by.repeater('name in names').row(1).column('name')).getAttribute('class')).
	           toMatch(/even/);
	       });
	     </file>
	   </example>
	 */
	var ngClassOddDirective = classDirective('Odd', 0);
	
	/**
	 * @ngdoc directive
	 * @name ngClassEven
	 * @restrict AC
	 *
	 * @description
	 * The `ngClassOdd` and `ngClassEven` directives work exactly as
	 * {@link ng.directive:ngClass ngClass}, except they work in
	 * conjunction with `ngRepeat` and take effect only on odd (even) rows.
	 *
	 * This directive can be applied only within the scope of an
	 * {@link ng.directive:ngRepeat ngRepeat}.
	 *
	 * @element ANY
	 * @param {expression} ngClassEven {@link guide/expression Expression} to eval. The
	 *   result of the evaluation can be a string representing space delimited class names or an array.
	 *
	 * @example
	   <example>
	     <file name="index.html">
	        <ol ng-init="names=['John', 'Mary', 'Cate', 'Suz']">
	          <li ng-repeat="name in names">
	           <span ng-class-odd="'odd'" ng-class-even="'even'">
	             {{name}} &nbsp; &nbsp; &nbsp;
	           </span>
	          </li>
	        </ol>
	     </file>
	     <file name="style.css">
	       .odd {
	         color: red;
	       }
	       .even {
	         color: blue;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-class-odd and ng-class-even', function() {
	         expect(element(by.repeater('name in names').row(0).column('name')).getAttribute('class')).
	           toMatch(/odd/);
	         expect(element(by.repeater('name in names').row(1).column('name')).getAttribute('class')).
	           toMatch(/even/);
	       });
	     </file>
	   </example>
	 */
	var ngClassEvenDirective = classDirective('Even', 1);
	
	/**
	 * @ngdoc directive
	 * @name ngCloak
	 * @restrict AC
	 *
	 * @description
	 * The `ngCloak` directive is used to prevent the Angular html template from being briefly
	 * displayed by the browser in its raw (uncompiled) form while your application is loading. Use this
	 * directive to avoid the undesirable flicker effect caused by the html template display.
	 *
	 * The directive can be applied to the `<body>` element, but the preferred usage is to apply
	 * multiple `ngCloak` directives to small portions of the page to permit progressive rendering
	 * of the browser view.
	 *
	 * `ngCloak` works in cooperation with the following css rule embedded within `angular.js` and
	 * `angular.min.js`.
	 * For CSP mode please add `angular-csp.css` to your html file (see {@link ng.directive:ngCsp ngCsp}).
	 *
	 * ```css
	 * [ng\:cloak], [ng-cloak], [data-ng-cloak], [x-ng-cloak], .ng-cloak, .x-ng-cloak {
	 *   display: none !important;
	 * }
	 * ```
	 *
	 * When this css rule is loaded by the browser, all html elements (including their children) that
	 * are tagged with the `ngCloak` directive are hidden. When Angular encounters this directive
	 * during the compilation of the template it deletes the `ngCloak` element attribute, making
	 * the compiled element visible.
	 *
	 * For the best result, the `angular.js` script must be loaded in the head section of the html
	 * document; alternatively, the css rule above must be included in the external stylesheet of the
	 * application.
	 *
	 * @element ANY
	 *
	 * @example
	   <example>
	     <file name="index.html">
	        <div id="template1" ng-cloak>{{ 'hello' }}</div>
	        <div id="template2" class="ng-cloak">{{ 'world' }}</div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should remove the template directive and css class', function() {
	         expect($('#template1').getAttribute('ng-cloak')).
	           toBeNull();
	         expect($('#template2').getAttribute('ng-cloak')).
	           toBeNull();
	       });
	     </file>
	   </example>
	 *
	 */
	var ngCloakDirective = ngDirective({
	  compile: function(element, attr) {
	    attr.$set('ngCloak', undefined);
	    element.removeClass('ng-cloak');
	  }
	});
	
	/**
	 * @ngdoc directive
	 * @name ngController
	 *
	 * @description
	 * The `ngController` directive attaches a controller class to the view. This is a key aspect of how angular
	 * supports the principles behind the Model-View-Controller design pattern.
	 *
	 * MVC components in angular:
	 *
	 * * Model — Models are the properties of a scope; scopes are attached to the DOM where scope properties
	 *   are accessed through bindings.
	 * * View — The template (HTML with data bindings) that is rendered into the View.
	 * * Controller — The `ngController` directive specifies a Controller class; the class contains business
	 *   logic behind the application to decorate the scope with functions and values
	 *
	 * Note that you can also attach controllers to the DOM by declaring it in a route definition
	 * via the {@link ngRoute.$route $route} service. A common mistake is to declare the controller
	 * again using `ng-controller` in the template itself.  This will cause the controller to be attached
	 * and executed twice.
	 *
	 * @element ANY
	 * @scope
	 * @priority 500
	 * @param {expression} ngController Name of a constructor function registered with the current
	 * {@link ng.$controllerProvider $controllerProvider} or an {@link guide/expression expression}
	 * that on the current scope evaluates to a constructor function.
	 *
	 * The controller instance can be published into a scope property by specifying
	 * `ng-controller="as propertyName"`.
	 *
	 * If the current `$controllerProvider` is configured to use globals (via
	 * {@link ng.$controllerProvider#allowGlobals `$controllerProvider.allowGlobals()` }), this may
	 * also be the name of a globally accessible constructor function (not recommended).
	 *
	 * @example
	 * Here is a simple form for editing user contact information. Adding, removing, clearing, and
	 * greeting are methods declared on the controller (see source tab). These methods can
	 * easily be called from the angular markup. Any changes to the data are automatically reflected
	 * in the View without the need for a manual update.
	 *
	 * Two different declaration styles are included below:
	 *
	 * * one binds methods and properties directly onto the controller using `this`:
	 * `ng-controller="SettingsController1 as settings"`
	 * * one injects `$scope` into the controller:
	 * `ng-controller="SettingsController2"`
	 *
	 * The second option is more common in the Angular community, and is generally used in boilerplates
	 * and in this guide. However, there are advantages to binding properties directly to the controller
	 * and avoiding scope.
	 *
	 * * Using `controller as` makes it obvious which controller you are accessing in the template when
	 * multiple controllers apply to an element.
	 * * If you are writing your controllers as classes you have easier access to the properties and
	 * methods, which will appear on the scope, from inside the controller code.
	 * * Since there is always a `.` in the bindings, you don't have to worry about prototypal
	 * inheritance masking primitives.
	 *
	 * This example demonstrates the `controller as` syntax.
	 *
	 * <example name="ngControllerAs" module="controllerAsExample">
	 *   <file name="index.html">
	 *    <div id="ctrl-as-exmpl" ng-controller="SettingsController1 as settings">
	 *      <label>Name: <input type="text" ng-model="settings.name"/></label>
	 *      <button ng-click="settings.greet()">greet</button><br/>
	 *      Contact:
	 *      <ul>
	 *        <li ng-repeat="contact in settings.contacts">
	 *          <select ng-model="contact.type" aria-label="Contact method" id="select_{{$index}}">
	 *             <option>phone</option>
	 *             <option>email</option>
	 *          </select>
	 *          <input type="text" ng-model="contact.value" aria-labelledby="select_{{$index}}" />
	 *          <button ng-click="settings.clearContact(contact)">clear</button>
	 *          <button ng-click="settings.removeContact(contact)" aria-label="Remove">X</button>
	 *        </li>
	 *        <li><button ng-click="settings.addContact()">add</button></li>
	 *     </ul>
	 *    </div>
	 *   </file>
	 *   <file name="app.js">
	 *    angular.module('controllerAsExample', [])
	 *      .controller('SettingsController1', SettingsController1);
	 *
	 *    function SettingsController1() {
	 *      this.name = "John Smith";
	 *      this.contacts = [
	 *        {type: 'phone', value: '408 555 1212'},
	 *        {type: 'email', value: 'john.smith@example.org'} ];
	 *    }
	 *
	 *    SettingsController1.prototype.greet = function() {
	 *      alert(this.name);
	 *    };
	 *
	 *    SettingsController1.prototype.addContact = function() {
	 *      this.contacts.push({type: 'email', value: 'yourname@example.org'});
	 *    };
	 *
	 *    SettingsController1.prototype.removeContact = function(contactToRemove) {
	 *     var index = this.contacts.indexOf(contactToRemove);
	 *      this.contacts.splice(index, 1);
	 *    };
	 *
	 *    SettingsController1.prototype.clearContact = function(contact) {
	 *      contact.type = 'phone';
	 *      contact.value = '';
	 *    };
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *     it('should check controller as', function() {
	 *       var container = element(by.id('ctrl-as-exmpl'));
	 *         expect(container.element(by.model('settings.name'))
	 *           .getAttribute('value')).toBe('John Smith');
	 *
	 *       var firstRepeat =
	 *           container.element(by.repeater('contact in settings.contacts').row(0));
	 *       var secondRepeat =
	 *           container.element(by.repeater('contact in settings.contacts').row(1));
	 *
	 *       expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *           .toBe('408 555 1212');
	 *
	 *       expect(secondRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *           .toBe('john.smith@example.org');
	 *
	 *       firstRepeat.element(by.buttonText('clear')).click();
	 *
	 *       expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *           .toBe('');
	 *
	 *       container.element(by.buttonText('add')).click();
	 *
	 *       expect(container.element(by.repeater('contact in settings.contacts').row(2))
	 *           .element(by.model('contact.value'))
	 *           .getAttribute('value'))
	 *           .toBe('yourname@example.org');
	 *     });
	 *   </file>
	 * </example>
	 *
	 * This example demonstrates the "attach to `$scope`" style of controller.
	 *
	 * <example name="ngController" module="controllerExample">
	 *  <file name="index.html">
	 *   <div id="ctrl-exmpl" ng-controller="SettingsController2">
	 *     <label>Name: <input type="text" ng-model="name"/></label>
	 *     <button ng-click="greet()">greet</button><br/>
	 *     Contact:
	 *     <ul>
	 *       <li ng-repeat="contact in contacts">
	 *         <select ng-model="contact.type" id="select_{{$index}}">
	 *            <option>phone</option>
	 *            <option>email</option>
	 *         </select>
	 *         <input type="text" ng-model="contact.value" aria-labelledby="select_{{$index}}" />
	 *         <button ng-click="clearContact(contact)">clear</button>
	 *         <button ng-click="removeContact(contact)">X</button>
	 *       </li>
	 *       <li>[ <button ng-click="addContact()">add</button> ]</li>
	 *    </ul>
	 *   </div>
	 *  </file>
	 *  <file name="app.js">
	 *   angular.module('controllerExample', [])
	 *     .controller('SettingsController2', ['$scope', SettingsController2]);
	 *
	 *   function SettingsController2($scope) {
	 *     $scope.name = "John Smith";
	 *     $scope.contacts = [
	 *       {type:'phone', value:'408 555 1212'},
	 *       {type:'email', value:'john.smith@example.org'} ];
	 *
	 *     $scope.greet = function() {
	 *       alert($scope.name);
	 *     };
	 *
	 *     $scope.addContact = function() {
	 *       $scope.contacts.push({type:'email', value:'yourname@example.org'});
	 *     };
	 *
	 *     $scope.removeContact = function(contactToRemove) {
	 *       var index = $scope.contacts.indexOf(contactToRemove);
	 *       $scope.contacts.splice(index, 1);
	 *     };
	 *
	 *     $scope.clearContact = function(contact) {
	 *       contact.type = 'phone';
	 *       contact.value = '';
	 *     };
	 *   }
	 *  </file>
	 *  <file name="protractor.js" type="protractor">
	 *    it('should check controller', function() {
	 *      var container = element(by.id('ctrl-exmpl'));
	 *
	 *      expect(container.element(by.model('name'))
	 *          .getAttribute('value')).toBe('John Smith');
	 *
	 *      var firstRepeat =
	 *          container.element(by.repeater('contact in contacts').row(0));
	 *      var secondRepeat =
	 *          container.element(by.repeater('contact in contacts').row(1));
	 *
	 *      expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *          .toBe('408 555 1212');
	 *      expect(secondRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *          .toBe('john.smith@example.org');
	 *
	 *      firstRepeat.element(by.buttonText('clear')).click();
	 *
	 *      expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *          .toBe('');
	 *
	 *      container.element(by.buttonText('add')).click();
	 *
	 *      expect(container.element(by.repeater('contact in contacts').row(2))
	 *          .element(by.model('contact.value'))
	 *          .getAttribute('value'))
	 *          .toBe('yourname@example.org');
	 *    });
	 *  </file>
	 *</example>
	
	 */
	var ngControllerDirective = [function() {
	  return {
	    restrict: 'A',
	    scope: true,
	    controller: '@',
	    priority: 500
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngCsp
	 *
	 * @element html
	 * @description
	 *
	 * Angular has some features that can break certain
	 * [CSP (Content Security Policy)](https://developer.mozilla.org/en/Security/CSP) rules.
	 *
	 * If you intend to implement these rules then you must tell Angular not to use these features.
	 *
	 * This is necessary when developing things like Google Chrome Extensions or Universal Windows Apps.
	 *
	 *
	 * The following rules affect Angular:
	 *
	 * * `unsafe-eval`: this rule forbids apps to use `eval` or `Function(string)` generated functions
	 * (among other things). Angular makes use of this in the {@link $parse} service to provide a 30%
	 * increase in the speed of evaluating Angular expressions.
	 *
	 * * `unsafe-inline`: this rule forbids apps from inject custom styles into the document. Angular
	 * makes use of this to include some CSS rules (e.g. {@link ngCloak} and {@link ngHide}).
	 * To make these directives work when a CSP rule is blocking inline styles, you must link to the
	 * `angular-csp.css` in your HTML manually.
	 *
	 * If you do not provide `ngCsp` then Angular tries to autodetect if CSP is blocking unsafe-eval
	 * and automatically deactivates this feature in the {@link $parse} service. This autodetection,
	 * however, triggers a CSP error to be logged in the console:
	 *
	 * ```
	 * Refused to evaluate a string as JavaScript because 'unsafe-eval' is not an allowed source of
	 * script in the following Content Security Policy directive: "default-src 'self'". Note that
	 * 'script-src' was not explicitly set, so 'default-src' is used as a fallback.
	 * ```
	 *
	 * This error is harmless but annoying. To prevent the error from showing up, put the `ngCsp`
	 * directive on an element of the HTML document that appears before the `<script>` tag that loads
	 * the `angular.js` file.
	 *
	 * *Note: This directive is only available in the `ng-csp` and `data-ng-csp` attribute form.*
	 *
	 * You can specify which of the CSP related Angular features should be deactivated by providing
	 * a value for the `ng-csp` attribute. The options are as follows:
	 *
	 * * no-inline-style: this stops Angular from injecting CSS styles into the DOM
	 *
	 * * no-unsafe-eval: this stops Angular from optimizing $parse with unsafe eval of strings
	 *
	 * You can use these values in the following combinations:
	 *
	 *
	 * * No declaration means that Angular will assume that you can do inline styles, but it will do
	 * a runtime check for unsafe-eval. E.g. `<body>`. This is backwardly compatible with previous versions
	 * of Angular.
	 *
	 * * A simple `ng-csp` (or `data-ng-csp`) attribute will tell Angular to deactivate both inline
	 * styles and unsafe eval. E.g. `<body ng-csp>`. This is backwardly compatible with previous versions
	 * of Angular.
	 *
	 * * Specifying only `no-unsafe-eval` tells Angular that we must not use eval, but that we can inject
	 * inline styles. E.g. `<body ng-csp="no-unsafe-eval">`.
	 *
	 * * Specifying only `no-inline-style` tells Angular that we must not inject styles, but that we can
	 * run eval - no automatic check for unsafe eval will occur. E.g. `<body ng-csp="no-inline-style">`
	 *
	 * * Specifying both `no-unsafe-eval` and `no-inline-style` tells Angular that we must not inject
	 * styles nor use eval, which is the same as an empty: ng-csp.
	 * E.g.`<body ng-csp="no-inline-style;no-unsafe-eval">`
	 *
	 * @example
	 * This example shows how to apply the `ngCsp` directive to the `html` tag.
	   ```html
	     <!doctype html>
	     <html ng-app ng-csp>
	     ...
	     ...
	     </html>
	   ```
	  * @example
	      // Note: the suffix `.csp` in the example name triggers
	      // csp mode in our http server!
	      <example name="example.csp" module="cspExample" ng-csp="true">
	        <file name="index.html">
	          <div ng-controller="MainController as ctrl">
	            <div>
	              <button ng-click="ctrl.inc()" id="inc">Increment</button>
	              <span id="counter">
	                {{ctrl.counter}}
	              </span>
	            </div>
	
	            <div>
	              <button ng-click="ctrl.evil()" id="evil">Evil</button>
	              <span id="evilError">
	                {{ctrl.evilError}}
	              </span>
	            </div>
	          </div>
	        </file>
	        <file name="script.js">
	           angular.module('cspExample', [])
	             .controller('MainController', function() {
	                this.counter = 0;
	                this.inc = function() {
	                  this.counter++;
	                };
	                this.evil = function() {
	                  // jshint evil:true
	                  try {
	                    eval('1+2');
	                  } catch (e) {
	                    this.evilError = e.message;
	                  }
	                };
	              });
	        </file>
	        <file name="protractor.js" type="protractor">
	          var util, webdriver;
	
	          var incBtn = element(by.id('inc'));
	          var counter = element(by.id('counter'));
	          var evilBtn = element(by.id('evil'));
	          var evilError = element(by.id('evilError'));
	
	          function getAndClearSevereErrors() {
	            return browser.manage().logs().get('browser').then(function(browserLog) {
	              return browserLog.filter(function(logEntry) {
	                return logEntry.level.value > webdriver.logging.Level.WARNING.value;
	              });
	            });
	          }
	
	          function clearErrors() {
	            getAndClearSevereErrors();
	          }
	
	          function expectNoErrors() {
	            getAndClearSevereErrors().then(function(filteredLog) {
	              expect(filteredLog.length).toEqual(0);
	              if (filteredLog.length) {
	                console.log('browser console errors: ' + util.inspect(filteredLog));
	              }
	            });
	          }
	
	          function expectError(regex) {
	            getAndClearSevereErrors().then(function(filteredLog) {
	              var found = false;
	              filteredLog.forEach(function(log) {
	                if (log.message.match(regex)) {
	                  found = true;
	                }
	              });
	              if (!found) {
	                throw new Error('expected an error that matches ' + regex);
	              }
	            });
	          }
	
	          beforeEach(function() {
	            util = require('util');
	            webdriver = require('protractor/node_modules/selenium-webdriver');
	          });
	
	          // For now, we only test on Chrome,
	          // as Safari does not load the page with Protractor's injected scripts,
	          // and Firefox webdriver always disables content security policy (#6358)
	          if (browser.params.browser !== 'chrome') {
	            return;
	          }
	
	          it('should not report errors when the page is loaded', function() {
	            // clear errors so we are not dependent on previous tests
	            clearErrors();
	            // Need to reload the page as the page is already loaded when
	            // we come here
	            browser.driver.getCurrentUrl().then(function(url) {
	              browser.get(url);
	            });
	            expectNoErrors();
	          });
	
	          it('should evaluate expressions', function() {
	            expect(counter.getText()).toEqual('0');
	            incBtn.click();
	            expect(counter.getText()).toEqual('1');
	            expectNoErrors();
	          });
	
	          it('should throw and report an error when using "eval"', function() {
	            evilBtn.click();
	            expect(evilError.getText()).toMatch(/Content Security Policy/);
	            expectError(/Content Security Policy/);
	          });
	        </file>
	      </example>
	  */
	
	// ngCsp is not implemented as a proper directive any more, because we need it be processed while we
	// bootstrap the system (before $parse is instantiated), for this reason we just have
	// the csp() fn that looks for the `ng-csp` attribute anywhere in the current doc
	
	/**
	 * @ngdoc directive
	 * @name ngClick
	 *
	 * @description
	 * The ngClick directive allows you to specify custom behavior when
	 * an element is clicked.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngClick {@link guide/expression Expression} to evaluate upon
	 * click. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example>
	     <file name="index.html">
	      <button ng-click="count = count + 1" ng-init="count=0">
	        Increment
	      </button>
	      <span>
	        count: {{count}}
	      </span>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-click', function() {
	         expect(element(by.binding('count')).getText()).toMatch('0');
	         element(by.css('button')).click();
	         expect(element(by.binding('count')).getText()).toMatch('1');
	       });
	     </file>
	   </example>
	 */
	/*
	 * A collection of directives that allows creation of custom event handlers that are defined as
	 * angular expressions and are compiled and executed within the current scope.
	 */
	var ngEventDirectives = {};
	
	// For events that might fire synchronously during DOM manipulation
	// we need to execute their event handlers asynchronously using $evalAsync,
	// so that they are not executed in an inconsistent state.
	var forceAsyncEvents = {
	  'blur': true,
	  'focus': true
	};
	forEach(
	  'click dblclick mousedown mouseup mouseover mouseout mousemove mouseenter mouseleave keydown keyup keypress submit focus blur copy cut paste'.split(' '),
	  function(eventName) {
	    var directiveName = directiveNormalize('ng-' + eventName);
	    ngEventDirectives[directiveName] = ['$parse', '$rootScope', function($parse, $rootScope) {
	      return {
	        restrict: 'A',
	        compile: function($element, attr) {
	          // We expose the powerful $event object on the scope that provides access to the Window,
	          // etc. that isn't protected by the fast paths in $parse.  We explicitly request better
	          // checks at the cost of speed since event handler expressions are not executed as
	          // frequently as regular change detection.
	          var fn = $parse(attr[directiveName], /* interceptorFn */ null, /* expensiveChecks */ true);
	          return function ngEventHandler(scope, element) {
	            element.on(eventName, function(event) {
	              var callback = function() {
	                fn(scope, {$event:event});
	              };
	              if (forceAsyncEvents[eventName] && $rootScope.$$phase) {
	                scope.$evalAsync(callback);
	              } else {
	                scope.$apply(callback);
	              }
	            });
	          };
	        }
	      };
	    }];
	  }
	);
	
	/**
	 * @ngdoc directive
	 * @name ngDblclick
	 *
	 * @description
	 * The `ngDblclick` directive allows you to specify custom behavior on a dblclick event.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngDblclick {@link guide/expression Expression} to evaluate upon
	 * a dblclick. (The Event object is available as `$event`)
	 *
	 * @example
	   <example>
	     <file name="index.html">
	      <button ng-dblclick="count = count + 1" ng-init="count=0">
	        Increment (on double click)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngMousedown
	 *
	 * @description
	 * The ngMousedown directive allows you to specify custom behavior on mousedown event.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngMousedown {@link guide/expression Expression} to evaluate upon
	 * mousedown. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example>
	     <file name="index.html">
	      <button ng-mousedown="count = count + 1" ng-init="count=0">
	        Increment (on mouse down)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngMouseup
	 *
	 * @description
	 * Specify custom behavior on mouseup event.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngMouseup {@link guide/expression Expression} to evaluate upon
	 * mouseup. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example>
	     <file name="index.html">
	      <button ng-mouseup="count = count + 1" ng-init="count=0">
	        Increment (on mouse up)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngMouseover
	 *
	 * @description
	 * Specify custom behavior on mouseover event.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngMouseover {@link guide/expression Expression} to evaluate upon
	 * mouseover. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example>
	     <file name="index.html">
	      <button ng-mouseover="count = count + 1" ng-init="count=0">
	        Increment (when mouse is over)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngMouseenter
	 *
	 * @description
	 * Specify custom behavior on mouseenter event.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngMouseenter {@link guide/expression Expression} to evaluate upon
	 * mouseenter. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example>
	     <file name="index.html">
	      <button ng-mouseenter="count = count + 1" ng-init="count=0">
	        Increment (when mouse enters)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngMouseleave
	 *
	 * @description
	 * Specify custom behavior on mouseleave event.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngMouseleave {@link guide/expression Expression} to evaluate upon
	 * mouseleave. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example>
	     <file name="index.html">
	      <button ng-mouseleave="count = count + 1" ng-init="count=0">
	        Increment (when mouse leaves)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngMousemove
	 *
	 * @description
	 * Specify custom behavior on mousemove event.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngMousemove {@link guide/expression Expression} to evaluate upon
	 * mousemove. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example>
	     <file name="index.html">
	      <button ng-mousemove="count = count + 1" ng-init="count=0">
	        Increment (when mouse moves)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngKeydown
	 *
	 * @description
	 * Specify custom behavior on keydown event.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngKeydown {@link guide/expression Expression} to evaluate upon
	 * keydown. (Event object is available as `$event` and can be interrogated for keyCode, altKey, etc.)
	 *
	 * @example
	   <example>
	     <file name="index.html">
	      <input ng-keydown="count = count + 1" ng-init="count=0">
	      key down count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngKeyup
	 *
	 * @description
	 * Specify custom behavior on keyup event.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngKeyup {@link guide/expression Expression} to evaluate upon
	 * keyup. (Event object is available as `$event` and can be interrogated for keyCode, altKey, etc.)
	 *
	 * @example
	   <example>
	     <file name="index.html">
	       <p>Typing in the input box below updates the key count</p>
	       <input ng-keyup="count = count + 1" ng-init="count=0"> key up count: {{count}}
	
	       <p>Typing in the input box below updates the keycode</p>
	       <input ng-keyup="event=$event">
	       <p>event keyCode: {{ event.keyCode }}</p>
	       <p>event altKey: {{ event.altKey }}</p>
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngKeypress
	 *
	 * @description
	 * Specify custom behavior on keypress event.
	 *
	 * @element ANY
	 * @param {expression} ngKeypress {@link guide/expression Expression} to evaluate upon
	 * keypress. ({@link guide/expression#-event- Event object is available as `$event`}
	 * and can be interrogated for keyCode, altKey, etc.)
	 *
	 * @example
	   <example>
	     <file name="index.html">
	      <input ng-keypress="count = count + 1" ng-init="count=0">
	      key press count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngSubmit
	 *
	 * @description
	 * Enables binding angular expressions to onsubmit events.
	 *
	 * Additionally it prevents the default action (which for form means sending the request to the
	 * server and reloading the current page), but only if the form does not contain `action`,
	 * `data-action`, or `x-action` attributes.
	 *
	 * <div class="alert alert-warning">
	 * **Warning:** Be careful not to cause "double-submission" by using both the `ngClick` and
	 * `ngSubmit` handlers together. See the
	 * {@link form#submitting-a-form-and-preventing-the-default-action `form` directive documentation}
	 * for a detailed discussion of when `ngSubmit` may be triggered.
	 * </div>
	 *
	 * @element form
	 * @priority 0
	 * @param {expression} ngSubmit {@link guide/expression Expression} to eval.
	 * ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example module="submitExample">
	     <file name="index.html">
	      <script>
	        angular.module('submitExample', [])
	          .controller('ExampleController', ['$scope', function($scope) {
	            $scope.list = [];
	            $scope.text = 'hello';
	            $scope.submit = function() {
	              if ($scope.text) {
	                $scope.list.push(this.text);
	                $scope.text = '';
	              }
	            };
	          }]);
	      </script>
	      <form ng-submit="submit()" ng-controller="ExampleController">
	        Enter text and hit enter:
	        <input type="text" ng-model="text" name="text" />
	        <input type="submit" id="submit" value="Submit" />
	        <pre>list={{list}}</pre>
	      </form>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-submit', function() {
	         expect(element(by.binding('list')).getText()).toBe('list=[]');
	         element(by.css('#submit')).click();
	         expect(element(by.binding('list')).getText()).toContain('hello');
	         expect(element(by.model('text')).getAttribute('value')).toBe('');
	       });
	       it('should ignore empty strings', function() {
	         expect(element(by.binding('list')).getText()).toBe('list=[]');
	         element(by.css('#submit')).click();
	         element(by.css('#submit')).click();
	         expect(element(by.binding('list')).getText()).toContain('hello');
	        });
	     </file>
	   </example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngFocus
	 *
	 * @description
	 * Specify custom behavior on focus event.
	 *
	 * Note: As the `focus` event is executed synchronously when calling `input.focus()`
	 * AngularJS executes the expression using `scope.$evalAsync` if the event is fired
	 * during an `$apply` to ensure a consistent state.
	 *
	 * @element window, input, select, textarea, a
	 * @priority 0
	 * @param {expression} ngFocus {@link guide/expression Expression} to evaluate upon
	 * focus. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	 * See {@link ng.directive:ngClick ngClick}
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngBlur
	 *
	 * @description
	 * Specify custom behavior on blur event.
	 *
	 * A [blur event](https://developer.mozilla.org/en-US/docs/Web/Events/blur) fires when
	 * an element has lost focus.
	 *
	 * Note: As the `blur` event is executed synchronously also during DOM manipulations
	 * (e.g. removing a focussed input),
	 * AngularJS executes the expression using `scope.$evalAsync` if the event is fired
	 * during an `$apply` to ensure a consistent state.
	 *
	 * @element window, input, select, textarea, a
	 * @priority 0
	 * @param {expression} ngBlur {@link guide/expression Expression} to evaluate upon
	 * blur. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	 * See {@link ng.directive:ngClick ngClick}
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngCopy
	 *
	 * @description
	 * Specify custom behavior on copy event.
	 *
	 * @element window, input, select, textarea, a
	 * @priority 0
	 * @param {expression} ngCopy {@link guide/expression Expression} to evaluate upon
	 * copy. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example>
	     <file name="index.html">
	      <input ng-copy="copied=true" ng-init="copied=false; value='copy me'" ng-model="value">
	      copied: {{copied}}
	     </file>
	   </example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngCut
	 *
	 * @description
	 * Specify custom behavior on cut event.
	 *
	 * @element window, input, select, textarea, a
	 * @priority 0
	 * @param {expression} ngCut {@link guide/expression Expression} to evaluate upon
	 * cut. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example>
	     <file name="index.html">
	      <input ng-cut="cut=true" ng-init="cut=false; value='cut me'" ng-model="value">
	      cut: {{cut}}
	     </file>
	   </example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngPaste
	 *
	 * @description
	 * Specify custom behavior on paste event.
	 *
	 * @element window, input, select, textarea, a
	 * @priority 0
	 * @param {expression} ngPaste {@link guide/expression Expression} to evaluate upon
	 * paste. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example>
	     <file name="index.html">
	      <input ng-paste="paste=true" ng-init="paste=false" placeholder='paste here'>
	      pasted: {{paste}}
	     </file>
	   </example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngIf
	 * @restrict A
	 * @multiElement
	 *
	 * @description
	 * The `ngIf` directive removes or recreates a portion of the DOM tree based on an
	 * {expression}. If the expression assigned to `ngIf` evaluates to a false
	 * value then the element is removed from the DOM, otherwise a clone of the
	 * element is reinserted into the DOM.
	 *
	 * `ngIf` differs from `ngShow` and `ngHide` in that `ngIf` completely removes and recreates the
	 * element in the DOM rather than changing its visibility via the `display` css property.  A common
	 * case when this difference is significant is when using css selectors that rely on an element's
	 * position within the DOM, such as the `:first-child` or `:last-child` pseudo-classes.
	 *
	 * Note that when an element is removed using `ngIf` its scope is destroyed and a new scope
	 * is created when the element is restored.  The scope created within `ngIf` inherits from
	 * its parent scope using
	 * [prototypal inheritance](https://github.com/angular/angular.js/wiki/Understanding-Scopes#javascript-prototypal-inheritance).
	 * An important implication of this is if `ngModel` is used within `ngIf` to bind to
	 * a javascript primitive defined in the parent scope. In this case any modifications made to the
	 * variable within the child scope will override (hide) the value in the parent scope.
	 *
	 * Also, `ngIf` recreates elements using their compiled state. An example of this behavior
	 * is if an element's class attribute is directly modified after it's compiled, using something like
	 * jQuery's `.addClass()` method, and the element is later removed. When `ngIf` recreates the element
	 * the added class will be lost because the original compiled state is used to regenerate the element.
	 *
	 * Additionally, you can provide animations via the `ngAnimate` module to animate the `enter`
	 * and `leave` effects.
	 *
	 * @animations
	 * | Animation                        | Occurs                               |
	 * |----------------------------------|-------------------------------------|
	 * | {@link ng.$animate#enter enter}  | just after the `ngIf` contents change and a new DOM element is created and injected into the `ngIf` container |
	 * | {@link ng.$animate#leave leave}  | just before the `ngIf` contents are removed from the DOM |
	 *
	 * @element ANY
	 * @scope
	 * @priority 600
	 * @param {expression} ngIf If the {@link guide/expression expression} is falsy then
	 *     the element is removed from the DOM tree. If it is truthy a copy of the compiled
	 *     element is added to the DOM tree.
	 *
	 * @example
	  <example module="ngAnimate" deps="angular-animate.js" animations="true">
	    <file name="index.html">
	      <label>Click me: <input type="checkbox" ng-model="checked" ng-init="checked=true" /></label><br/>
	      Show when checked:
	      <span ng-if="checked" class="animate-if">
	        This is removed when the checkbox is unchecked.
	      </span>
	    </file>
	    <file name="animations.css">
	      .animate-if {
	        background:white;
	        border:1px solid black;
	        padding:10px;
	      }
	
	      .animate-if.ng-enter, .animate-if.ng-leave {
	        transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
	      }
	
	      .animate-if.ng-enter,
	      .animate-if.ng-leave.ng-leave-active {
	        opacity:0;
	      }
	
	      .animate-if.ng-leave,
	      .animate-if.ng-enter.ng-enter-active {
	        opacity:1;
	      }
	    </file>
	  </example>
	 */
	var ngIfDirective = ['$animate', '$compile', function($animate, $compile) {
	  return {
	    multiElement: true,
	    transclude: 'element',
	    priority: 600,
	    terminal: true,
	    restrict: 'A',
	    $$tlb: true,
	    link: function($scope, $element, $attr, ctrl, $transclude) {
	        var block, childScope, previousElements;
	        $scope.$watch($attr.ngIf, function ngIfWatchAction(value) {
	
	          if (value) {
	            if (!childScope) {
	              $transclude(function(clone, newScope) {
	                childScope = newScope;
	                clone[clone.length++] = $compile.$$createComment('end ngIf', $attr.ngIf);
	                // Note: We only need the first/last node of the cloned nodes.
	                // However, we need to keep the reference to the jqlite wrapper as it might be changed later
	                // by a directive with templateUrl when its template arrives.
	                block = {
	                  clone: clone
	                };
	                $animate.enter(clone, $element.parent(), $element);
	              });
	            }
	          } else {
	            if (previousElements) {
	              previousElements.remove();
	              previousElements = null;
	            }
	            if (childScope) {
	              childScope.$destroy();
	              childScope = null;
	            }
	            if (block) {
	              previousElements = getBlockNodes(block.clone);
	              $animate.leave(previousElements).then(function() {
	                previousElements = null;
	              });
	              block = null;
	            }
	          }
	        });
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngInclude
	 * @restrict ECA
	 *
	 * @description
	 * Fetches, compiles and includes an external HTML fragment.
	 *
	 * By default, the template URL is restricted to the same domain and protocol as the
	 * application document. This is done by calling {@link $sce#getTrustedResourceUrl
	 * $sce.getTrustedResourceUrl} on it. To load templates from other domains or protocols
	 * you may either {@link ng.$sceDelegateProvider#resourceUrlWhitelist whitelist them} or
	 * {@link $sce#trustAsResourceUrl wrap them} as trusted values. Refer to Angular's {@link
	 * ng.$sce Strict Contextual Escaping}.
	 *
	 * In addition, the browser's
	 * [Same Origin Policy](https://code.google.com/p/browsersec/wiki/Part2#Same-origin_policy_for_XMLHttpRequest)
	 * and [Cross-Origin Resource Sharing (CORS)](http://www.w3.org/TR/cors/)
	 * policy may further restrict whether the template is successfully loaded.
	 * For example, `ngInclude` won't work for cross-domain requests on all browsers and for `file://`
	 * access on some browsers.
	 *
	 * @animations
	 * | Animation                        | Occurs                              |
	 * |----------------------------------|-------------------------------------|
	 * | {@link ng.$animate#enter enter}  | when the expression changes, on the new include |
	 * | {@link ng.$animate#leave leave}  | when the expression changes, on the old include |
	 *
	 * The enter and leave animation occur concurrently.
	 *
	 * @scope
	 * @priority 400
	 *
	 * @param {string} ngInclude|src angular expression evaluating to URL. If the source is a string constant,
	 *                 make sure you wrap it in **single** quotes, e.g. `src="'myPartialTemplate.html'"`.
	 * @param {string=} onload Expression to evaluate when a new partial is loaded.
	 *                  <div class="alert alert-warning">
	 *                  **Note:** When using onload on SVG elements in IE11, the browser will try to call
	 *                  a function with the name on the window element, which will usually throw a
	 *                  "function is undefined" error. To fix this, you can instead use `data-onload` or a
	 *                  different form that {@link guide/directive#normalization matches} `onload`.
	 *                  </div>
	   *
	 * @param {string=} autoscroll Whether `ngInclude` should call {@link ng.$anchorScroll
	 *                  $anchorScroll} to scroll the viewport after the content is loaded.
	 *
	 *                  - If the attribute is not set, disable scrolling.
	 *                  - If the attribute is set without value, enable scrolling.
	 *                  - Otherwise enable scrolling only if the expression evaluates to truthy value.
	 *
	 * @example
	  <example module="includeExample" deps="angular-animate.js" animations="true">
	    <file name="index.html">
	     <div ng-controller="ExampleController">
	       <select ng-model="template" ng-options="t.name for t in templates">
	        <option value="">(blank)</option>
	       </select>
	       url of the template: <code>{{template.url}}</code>
	       <hr/>
	       <div class="slide-animate-container">
	         <div class="slide-animate" ng-include="template.url"></div>
	       </div>
	     </div>
	    </file>
	    <file name="script.js">
	      angular.module('includeExample', ['ngAnimate'])
	        .controller('ExampleController', ['$scope', function($scope) {
	          $scope.templates =
	            [ { name: 'template1.html', url: 'template1.html'},
	              { name: 'template2.html', url: 'template2.html'} ];
	          $scope.template = $scope.templates[0];
	        }]);
	     </file>
	    <file name="template1.html">
	      Content of template1.html
	    </file>
	    <file name="template2.html">
	      Content of template2.html
	    </file>
	    <file name="animations.css">
	      .slide-animate-container {
	        position:relative;
	        background:white;
	        border:1px solid black;
	        height:40px;
	        overflow:hidden;
	      }
	
	      .slide-animate {
	        padding:10px;
	      }
	
	      .slide-animate.ng-enter, .slide-animate.ng-leave {
	        transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
	
	        position:absolute;
	        top:0;
	        left:0;
	        right:0;
	        bottom:0;
	        display:block;
	        padding:10px;
	      }
	
	      .slide-animate.ng-enter {
	        top:-50px;
	      }
	      .slide-animate.ng-enter.ng-enter-active {
	        top:0;
	      }
	
	      .slide-animate.ng-leave {
	        top:0;
	      }
	      .slide-animate.ng-leave.ng-leave-active {
	        top:50px;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      var templateSelect = element(by.model('template'));
	      var includeElem = element(by.css('[ng-include]'));
	
	      it('should load template1.html', function() {
	        expect(includeElem.getText()).toMatch(/Content of template1.html/);
	      });
	
	      it('should load template2.html', function() {
	        if (browser.params.browser == 'firefox') {
	          // Firefox can't handle using selects
	          // See https://github.com/angular/protractor/issues/480
	          return;
	        }
	        templateSelect.click();
	        templateSelect.all(by.css('option')).get(2).click();
	        expect(includeElem.getText()).toMatch(/Content of template2.html/);
	      });
	
	      it('should change to blank', function() {
	        if (browser.params.browser == 'firefox') {
	          // Firefox can't handle using selects
	          return;
	        }
	        templateSelect.click();
	        templateSelect.all(by.css('option')).get(0).click();
	        expect(includeElem.isPresent()).toBe(false);
	      });
	    </file>
	  </example>
	 */
	
	
	/**
	 * @ngdoc event
	 * @name ngInclude#$includeContentRequested
	 * @eventType emit on the scope ngInclude was declared in
	 * @description
	 * Emitted every time the ngInclude content is requested.
	 *
	 * @param {Object} angularEvent Synthetic event object.
	 * @param {String} src URL of content to load.
	 */
	
	
	/**
	 * @ngdoc event
	 * @name ngInclude#$includeContentLoaded
	 * @eventType emit on the current ngInclude scope
	 * @description
	 * Emitted every time the ngInclude content is reloaded.
	 *
	 * @param {Object} angularEvent Synthetic event object.
	 * @param {String} src URL of content to load.
	 */
	
	
	/**
	 * @ngdoc event
	 * @name ngInclude#$includeContentError
	 * @eventType emit on the scope ngInclude was declared in
	 * @description
	 * Emitted when a template HTTP request yields an erroneous response (status < 200 || status > 299)
	 *
	 * @param {Object} angularEvent Synthetic event object.
	 * @param {String} src URL of content to load.
	 */
	var ngIncludeDirective = ['$templateRequest', '$anchorScroll', '$animate',
	                  function($templateRequest,   $anchorScroll,   $animate) {
	  return {
	    restrict: 'ECA',
	    priority: 400,
	    terminal: true,
	    transclude: 'element',
	    controller: angular.noop,
	    compile: function(element, attr) {
	      var srcExp = attr.ngInclude || attr.src,
	          onloadExp = attr.onload || '',
	          autoScrollExp = attr.autoscroll;
	
	      return function(scope, $element, $attr, ctrl, $transclude) {
	        var changeCounter = 0,
	            currentScope,
	            previousElement,
	            currentElement;
	
	        var cleanupLastIncludeContent = function() {
	          if (previousElement) {
	            previousElement.remove();
	            previousElement = null;
	          }
	          if (currentScope) {
	            currentScope.$destroy();
	            currentScope = null;
	          }
	          if (currentElement) {
	            $animate.leave(currentElement).then(function() {
	              previousElement = null;
	            });
	            previousElement = currentElement;
	            currentElement = null;
	          }
	        };
	
	        scope.$watch(srcExp, function ngIncludeWatchAction(src) {
	          var afterAnimation = function() {
	            if (isDefined(autoScrollExp) && (!autoScrollExp || scope.$eval(autoScrollExp))) {
	              $anchorScroll();
	            }
	          };
	          var thisChangeId = ++changeCounter;
	
	          if (src) {
	            //set the 2nd param to true to ignore the template request error so that the inner
	            //contents and scope can be cleaned up.
	            $templateRequest(src, true).then(function(response) {
	              if (scope.$$destroyed) return;
	
	              if (thisChangeId !== changeCounter) return;
	              var newScope = scope.$new();
	              ctrl.template = response;
	
	              // Note: This will also link all children of ng-include that were contained in the original
	              // html. If that content contains controllers, ... they could pollute/change the scope.
	              // However, using ng-include on an element with additional content does not make sense...
	              // Note: We can't remove them in the cloneAttchFn of $transclude as that
	              // function is called before linking the content, which would apply child
	              // directives to non existing elements.
	              var clone = $transclude(newScope, function(clone) {
	                cleanupLastIncludeContent();
	                $animate.enter(clone, null, $element).then(afterAnimation);
	              });
	
	              currentScope = newScope;
	              currentElement = clone;
	
	              currentScope.$emit('$includeContentLoaded', src);
	              scope.$eval(onloadExp);
	            }, function() {
	              if (scope.$$destroyed) return;
	
	              if (thisChangeId === changeCounter) {
	                cleanupLastIncludeContent();
	                scope.$emit('$includeContentError', src);
	              }
	            });
	            scope.$emit('$includeContentRequested', src);
	          } else {
	            cleanupLastIncludeContent();
	            ctrl.template = null;
	          }
	        });
	      };
	    }
	  };
	}];
	
	// This directive is called during the $transclude call of the first `ngInclude` directive.
	// It will replace and compile the content of the element with the loaded template.
	// We need this directive so that the element content is already filled when
	// the link function of another directive on the same element as ngInclude
	// is called.
	var ngIncludeFillContentDirective = ['$compile',
	  function($compile) {
	    return {
	      restrict: 'ECA',
	      priority: -400,
	      require: 'ngInclude',
	      link: function(scope, $element, $attr, ctrl) {
	        if (toString.call($element[0]).match(/SVG/)) {
	          // WebKit: https://bugs.webkit.org/show_bug.cgi?id=135698 --- SVG elements do not
	          // support innerHTML, so detect this here and try to generate the contents
	          // specially.
	          $element.empty();
	          $compile(jqLiteBuildFragment(ctrl.template, window.document).childNodes)(scope,
	              function namespaceAdaptedClone(clone) {
	            $element.append(clone);
	          }, {futureParentElement: $element});
	          return;
	        }
	
	        $element.html(ctrl.template);
	        $compile($element.contents())(scope);
	      }
	    };
	  }];
	
	/**
	 * @ngdoc directive
	 * @name ngInit
	 * @restrict AC
	 *
	 * @description
	 * The `ngInit` directive allows you to evaluate an expression in the
	 * current scope.
	 *
	 * <div class="alert alert-danger">
	 * This directive can be abused to add unnecessary amounts of logic into your templates.
	 * There are only a few appropriate uses of `ngInit`, such as for aliasing special properties of
	 * {@link ng.directive:ngRepeat `ngRepeat`}, as seen in the demo below; and for injecting data via
	 * server side scripting. Besides these few cases, you should use {@link guide/controller controllers}
	 * rather than `ngInit` to initialize values on a scope.
	 * </div>
	 *
	 * <div class="alert alert-warning">
	 * **Note**: If you have assignment in `ngInit` along with a {@link ng.$filter `filter`}, make
	 * sure you have parentheses to ensure correct operator precedence:
	 * <pre class="prettyprint">
	 * `<div ng-init="test1 = ($index | toString)"></div>`
	 * </pre>
	 * </div>
	 *
	 * @priority 450
	 *
	 * @element ANY
	 * @param {expression} ngInit {@link guide/expression Expression} to eval.
	 *
	 * @example
	   <example module="initExample">
	     <file name="index.html">
	   <script>
	     angular.module('initExample', [])
	       .controller('ExampleController', ['$scope', function($scope) {
	         $scope.list = [['a', 'b'], ['c', 'd']];
	       }]);
	   </script>
	   <div ng-controller="ExampleController">
	     <div ng-repeat="innerList in list" ng-init="outerIndex = $index">
	       <div ng-repeat="value in innerList" ng-init="innerIndex = $index">
	          <span class="example-init">list[ {{outerIndex}} ][ {{innerIndex}} ] = {{value}};</span>
	       </div>
	     </div>
	   </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should alias index positions', function() {
	         var elements = element.all(by.css('.example-init'));
	         expect(elements.get(0).getText()).toBe('list[ 0 ][ 0 ] = a;');
	         expect(elements.get(1).getText()).toBe('list[ 0 ][ 1 ] = b;');
	         expect(elements.get(2).getText()).toBe('list[ 1 ][ 0 ] = c;');
	         expect(elements.get(3).getText()).toBe('list[ 1 ][ 1 ] = d;');
	       });
	     </file>
	   </example>
	 */
	var ngInitDirective = ngDirective({
	  priority: 450,
	  compile: function() {
	    return {
	      pre: function(scope, element, attrs) {
	        scope.$eval(attrs.ngInit);
	      }
	    };
	  }
	});
	
	/**
	 * @ngdoc directive
	 * @name ngList
	 *
	 * @description
	 * Text input that converts between a delimited string and an array of strings. The default
	 * delimiter is a comma followed by a space - equivalent to `ng-list=", "`. You can specify a custom
	 * delimiter as the value of the `ngList` attribute - for example, `ng-list=" | "`.
	 *
	 * The behaviour of the directive is affected by the use of the `ngTrim` attribute.
	 * * If `ngTrim` is set to `"false"` then whitespace around both the separator and each
	 *   list item is respected. This implies that the user of the directive is responsible for
	 *   dealing with whitespace but also allows you to use whitespace as a delimiter, such as a
	 *   tab or newline character.
	 * * Otherwise whitespace around the delimiter is ignored when splitting (although it is respected
	 *   when joining the list items back together) and whitespace around each list item is stripped
	 *   before it is added to the model.
	 *
	 * ### Example with Validation
	 *
	 * <example name="ngList-directive" module="listExample">
	 *   <file name="app.js">
	 *      angular.module('listExample', [])
	 *        .controller('ExampleController', ['$scope', function($scope) {
	 *          $scope.names = ['morpheus', 'neo', 'trinity'];
	 *        }]);
	 *   </file>
	 *   <file name="index.html">
	 *    <form name="myForm" ng-controller="ExampleController">
	 *      <label>List: <input name="namesInput" ng-model="names" ng-list required></label>
	 *      <span role="alert">
	 *        <span class="error" ng-show="myForm.namesInput.$error.required">
	 *        Required!</span>
	 *      </span>
	 *      <br>
	 *      <tt>names = {{names}}</tt><br/>
	 *      <tt>myForm.namesInput.$valid = {{myForm.namesInput.$valid}}</tt><br/>
	 *      <tt>myForm.namesInput.$error = {{myForm.namesInput.$error}}</tt><br/>
	 *      <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	 *      <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	 *     </form>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *     var listInput = element(by.model('names'));
	 *     var names = element(by.exactBinding('names'));
	 *     var valid = element(by.binding('myForm.namesInput.$valid'));
	 *     var error = element(by.css('span.error'));
	 *
	 *     it('should initialize to model', function() {
	 *       expect(names.getText()).toContain('["morpheus","neo","trinity"]');
	 *       expect(valid.getText()).toContain('true');
	 *       expect(error.getCssValue('display')).toBe('none');
	 *     });
	 *
	 *     it('should be invalid if empty', function() {
	 *       listInput.clear();
	 *       listInput.sendKeys('');
	 *
	 *       expect(names.getText()).toContain('');
	 *       expect(valid.getText()).toContain('false');
	 *       expect(error.getCssValue('display')).not.toBe('none');
	 *     });
	 *   </file>
	 * </example>
	 *
	 * ### Example - splitting on newline
	 * <example name="ngList-directive-newlines">
	 *   <file name="index.html">
	 *    <textarea ng-model="list" ng-list="&#10;" ng-trim="false"></textarea>
	 *    <pre>{{ list | json }}</pre>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *     it("should split the text by newlines", function() {
	 *       var listInput = element(by.model('list'));
	 *       var output = element(by.binding('list | json'));
	 *       listInput.sendKeys('abc\ndef\nghi');
	 *       expect(output.getText()).toContain('[\n  "abc",\n  "def",\n  "ghi"\n]');
	 *     });
	 *   </file>
	 * </example>
	 *
	 * @element input
	 * @param {string=} ngList optional delimiter that should be used to split the value.
	 */
	var ngListDirective = function() {
	  return {
	    restrict: 'A',
	    priority: 100,
	    require: 'ngModel',
	    link: function(scope, element, attr, ctrl) {
	      // We want to control whitespace trimming so we use this convoluted approach
	      // to access the ngList attribute, which doesn't pre-trim the attribute
	      var ngList = element.attr(attr.$attr.ngList) || ', ';
	      var trimValues = attr.ngTrim !== 'false';
	      var separator = trimValues ? trim(ngList) : ngList;
	
	      var parse = function(viewValue) {
	        // If the viewValue is invalid (say required but empty) it will be `undefined`
	        if (isUndefined(viewValue)) return;
	
	        var list = [];
	
	        if (viewValue) {
	          forEach(viewValue.split(separator), function(value) {
	            if (value) list.push(trimValues ? trim(value) : value);
	          });
	        }
	
	        return list;
	      };
	
	      ctrl.$parsers.push(parse);
	      ctrl.$formatters.push(function(value) {
	        if (isArray(value)) {
	          return value.join(ngList);
	        }
	
	        return undefined;
	      });
	
	      // Override the standard $isEmpty because an empty array means the input is empty.
	      ctrl.$isEmpty = function(value) {
	        return !value || !value.length;
	      };
	    }
	  };
	};
	
	/* global VALID_CLASS: true,
	  INVALID_CLASS: true,
	  PRISTINE_CLASS: true,
	  DIRTY_CLASS: true,
	  UNTOUCHED_CLASS: true,
	  TOUCHED_CLASS: true,
	*/
	
	var VALID_CLASS = 'ng-valid',
	    INVALID_CLASS = 'ng-invalid',
	    PRISTINE_CLASS = 'ng-pristine',
	    DIRTY_CLASS = 'ng-dirty',
	    UNTOUCHED_CLASS = 'ng-untouched',
	    TOUCHED_CLASS = 'ng-touched',
	    PENDING_CLASS = 'ng-pending',
	    EMPTY_CLASS = 'ng-empty',
	    NOT_EMPTY_CLASS = 'ng-not-empty';
	
	var ngModelMinErr = minErr('ngModel');
	
	/**
	 * @ngdoc type
	 * @name ngModel.NgModelController
	 *
	 * @property {*} $viewValue The actual value from the control's view. For `input` elements, this is a
	 * String. See {@link ngModel.NgModelController#$setViewValue} for information about when the $viewValue
	 * is set.
	 * @property {*} $modelValue The value in the model that the control is bound to.
	 * @property {Array.<Function>} $parsers Array of functions to execute, as a pipeline, whenever
	       the control reads value from the DOM. The functions are called in array order, each passing
	       its return value through to the next. The last return value is forwarded to the
	       {@link ngModel.NgModelController#$validators `$validators`} collection.
	
	Parsers are used to sanitize / convert the {@link ngModel.NgModelController#$viewValue
	`$viewValue`}.
	
	Returning `undefined` from a parser means a parse error occurred. In that case,
	no {@link ngModel.NgModelController#$validators `$validators`} will run and the `ngModel`
	will be set to `undefined` unless {@link ngModelOptions `ngModelOptions.allowInvalid`}
	is set to `true`. The parse error is stored in `ngModel.$error.parse`.
	
	 *
	 * @property {Array.<Function>} $formatters Array of functions to execute, as a pipeline, whenever
	       the model value changes. The functions are called in reverse array order, each passing the value through to the
	       next. The last return value is used as the actual DOM value.
	       Used to format / convert values for display in the control.
	 * ```js
	 * function formatter(value) {
	 *   if (value) {
	 *     return value.toUpperCase();
	 *   }
	 * }
	 * ngModel.$formatters.push(formatter);
	 * ```
	 *
	 * @property {Object.<string, function>} $validators A collection of validators that are applied
	 *      whenever the model value changes. The key value within the object refers to the name of the
	 *      validator while the function refers to the validation operation. The validation operation is
	 *      provided with the model value as an argument and must return a true or false value depending
	 *      on the response of that validation.
	 *
	 * ```js
	 * ngModel.$validators.validCharacters = function(modelValue, viewValue) {
	 *   var value = modelValue || viewValue;
	 *   return /[0-9]+/.test(value) &&
	 *          /[a-z]+/.test(value) &&
	 *          /[A-Z]+/.test(value) &&
	 *          /\W+/.test(value);
	 * };
	 * ```
	 *
	 * @property {Object.<string, function>} $asyncValidators A collection of validations that are expected to
	 *      perform an asynchronous validation (e.g. a HTTP request). The validation function that is provided
	 *      is expected to return a promise when it is run during the model validation process. Once the promise
	 *      is delivered then the validation status will be set to true when fulfilled and false when rejected.
	 *      When the asynchronous validators are triggered, each of the validators will run in parallel and the model
	 *      value will only be updated once all validators have been fulfilled. As long as an asynchronous validator
	 *      is unfulfilled, its key will be added to the controllers `$pending` property. Also, all asynchronous validators
	 *      will only run once all synchronous validators have passed.
	 *
	 * Please note that if $http is used then it is important that the server returns a success HTTP response code
	 * in order to fulfill the validation and a status level of `4xx` in order to reject the validation.
	 *
	 * ```js
	 * ngModel.$asyncValidators.uniqueUsername = function(modelValue, viewValue) {
	 *   var value = modelValue || viewValue;
	 *
	 *   // Lookup user by username
	 *   return $http.get('/api/users/' + value).
	 *      then(function resolved() {
	 *        //username exists, this means validation fails
	 *        return $q.reject('exists');
	 *      }, function rejected() {
	 *        //username does not exist, therefore this validation passes
	 *        return true;
	 *      });
	 * };
	 * ```
	 *
	 * @property {Array.<Function>} $viewChangeListeners Array of functions to execute whenever the
	 *     view value has changed. It is called with no arguments, and its return value is ignored.
	 *     This can be used in place of additional $watches against the model value.
	 *
	 * @property {Object} $error An object hash with all failing validator ids as keys.
	 * @property {Object} $pending An object hash with all pending validator ids as keys.
	 *
	 * @property {boolean} $untouched True if control has not lost focus yet.
	 * @property {boolean} $touched True if control has lost focus.
	 * @property {boolean} $pristine True if user has not interacted with the control yet.
	 * @property {boolean} $dirty True if user has already interacted with the control.
	 * @property {boolean} $valid True if there is no error.
	 * @property {boolean} $invalid True if at least one error on the control.
	 * @property {string} $name The name attribute of the control.
	 *
	 * @description
	 *
	 * `NgModelController` provides API for the {@link ngModel `ngModel`} directive.
	 * The controller contains services for data-binding, validation, CSS updates, and value formatting
	 * and parsing. It purposefully does not contain any logic which deals with DOM rendering or
	 * listening to DOM events.
	 * Such DOM related logic should be provided by other directives which make use of
	 * `NgModelController` for data-binding to control elements.
	 * Angular provides this DOM logic for most {@link input `input`} elements.
	 * At the end of this page you can find a {@link ngModel.NgModelController#custom-control-example
	 * custom control example} that uses `ngModelController` to bind to `contenteditable` elements.
	 *
	 * @example
	 * ### Custom Control Example
	 * This example shows how to use `NgModelController` with a custom control to achieve
	 * data-binding. Notice how different directives (`contenteditable`, `ng-model`, and `required`)
	 * collaborate together to achieve the desired result.
	 *
	 * `contenteditable` is an HTML5 attribute, which tells the browser to let the element
	 * contents be edited in place by the user.
	 *
	 * We are using the {@link ng.service:$sce $sce} service here and include the {@link ngSanitize $sanitize}
	 * module to automatically remove "bad" content like inline event listener (e.g. `<span onclick="...">`).
	 * However, as we are using `$sce` the model can still decide to provide unsafe content if it marks
	 * that content using the `$sce` service.
	 *
	 * <example name="NgModelController" module="customControl" deps="angular-sanitize.js">
	    <file name="style.css">
	      [contenteditable] {
	        border: 1px solid black;
	        background-color: white;
	        min-height: 20px;
	      }
	
	      .ng-invalid {
	        border: 1px solid red;
	      }
	
	    </file>
	    <file name="script.js">
	      angular.module('customControl', ['ngSanitize']).
	        directive('contenteditable', ['$sce', function($sce) {
	          return {
	            restrict: 'A', // only activate on element attribute
	            require: '?ngModel', // get a hold of NgModelController
	            link: function(scope, element, attrs, ngModel) {
	              if (!ngModel) return; // do nothing if no ng-model
	
	              // Specify how UI should be updated
	              ngModel.$render = function() {
	                element.html($sce.getTrustedHtml(ngModel.$viewValue || ''));
	              };
	
	              // Listen for change events to enable binding
	              element.on('blur keyup change', function() {
	                scope.$evalAsync(read);
	              });
	              read(); // initialize
	
	              // Write data to the model
	              function read() {
	                var html = element.html();
	                // When we clear the content editable the browser leaves a <br> behind
	                // If strip-br attribute is provided then we strip this out
	                if ( attrs.stripBr && html == '<br>' ) {
	                  html = '';
	                }
	                ngModel.$setViewValue(html);
	              }
	            }
	          };
	        }]);
	    </file>
	    <file name="index.html">
	      <form name="myForm">
	       <div contenteditable
	            name="myWidget" ng-model="userContent"
	            strip-br="true"
	            required>Change me!</div>
	        <span ng-show="myForm.myWidget.$error.required">Required!</span>
	       <hr>
	       <textarea ng-model="userContent" aria-label="Dynamic textarea"></textarea>
	      </form>
	    </file>
	    <file name="protractor.js" type="protractor">
	    it('should data-bind and become invalid', function() {
	      if (browser.params.browser == 'safari' || browser.params.browser == 'firefox') {
	        // SafariDriver can't handle contenteditable
	        // and Firefox driver can't clear contenteditables very well
	        return;
	      }
	      var contentEditable = element(by.css('[contenteditable]'));
	      var content = 'Change me!';
	
	      expect(contentEditable.getText()).toEqual(content);
	
	      contentEditable.clear();
	      contentEditable.sendKeys(protractor.Key.BACK_SPACE);
	      expect(contentEditable.getText()).toEqual('');
	      expect(contentEditable.getAttribute('class')).toMatch(/ng-invalid-required/);
	    });
	    </file>
	 * </example>
	 *
	 *
	 */
	var NgModelController = ['$scope', '$exceptionHandler', '$attrs', '$element', '$parse', '$animate', '$timeout', '$rootScope', '$q', '$interpolate',
	    function($scope, $exceptionHandler, $attr, $element, $parse, $animate, $timeout, $rootScope, $q, $interpolate) {
	  this.$viewValue = Number.NaN;
	  this.$modelValue = Number.NaN;
	  this.$$rawModelValue = undefined; // stores the parsed modelValue / model set from scope regardless of validity.
	  this.$validators = {};
	  this.$asyncValidators = {};
	  this.$parsers = [];
	  this.$formatters = [];
	  this.$viewChangeListeners = [];
	  this.$untouched = true;
	  this.$touched = false;
	  this.$pristine = true;
	  this.$dirty = false;
	  this.$valid = true;
	  this.$invalid = false;
	  this.$error = {}; // keep invalid keys here
	  this.$$success = {}; // keep valid keys here
	  this.$pending = undefined; // keep pending keys here
	  this.$name = $interpolate($attr.name || '', false)($scope);
	  this.$$parentForm = nullFormCtrl;
	
	  var parsedNgModel = $parse($attr.ngModel),
	      parsedNgModelAssign = parsedNgModel.assign,
	      ngModelGet = parsedNgModel,
	      ngModelSet = parsedNgModelAssign,
	      pendingDebounce = null,
	      parserValid,
	      ctrl = this;
	
	  this.$$setOptions = function(options) {
	    ctrl.$options = options;
	    if (options && options.getterSetter) {
	      var invokeModelGetter = $parse($attr.ngModel + '()'),
	          invokeModelSetter = $parse($attr.ngModel + '($$$p)');
	
	      ngModelGet = function($scope) {
	        var modelValue = parsedNgModel($scope);
	        if (isFunction(modelValue)) {
	          modelValue = invokeModelGetter($scope);
	        }
	        return modelValue;
	      };
	      ngModelSet = function($scope, newValue) {
	        if (isFunction(parsedNgModel($scope))) {
	          invokeModelSetter($scope, {$$$p: newValue});
	        } else {
	          parsedNgModelAssign($scope, newValue);
	        }
	      };
	    } else if (!parsedNgModel.assign) {
	      throw ngModelMinErr('nonassign', "Expression '{0}' is non-assignable. Element: {1}",
	          $attr.ngModel, startingTag($element));
	    }
	  };
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$render
	   *
	   * @description
	   * Called when the view needs to be updated. It is expected that the user of the ng-model
	   * directive will implement this method.
	   *
	   * The `$render()` method is invoked in the following situations:
	   *
	   * * `$rollbackViewValue()` is called.  If we are rolling back the view value to the last
	   *   committed value then `$render()` is called to update the input control.
	   * * The value referenced by `ng-model` is changed programmatically and both the `$modelValue` and
	   *   the `$viewValue` are different from last time.
	   *
	   * Since `ng-model` does not do a deep watch, `$render()` is only invoked if the values of
	   * `$modelValue` and `$viewValue` are actually different from their previous values. If `$modelValue`
	   * or `$viewValue` are objects (rather than a string or number) then `$render()` will not be
	   * invoked if you only change a property on the objects.
	   */
	  this.$render = noop;
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$isEmpty
	   *
	   * @description
	   * This is called when we need to determine if the value of an input is empty.
	   *
	   * For instance, the required directive does this to work out if the input has data or not.
	   *
	   * The default `$isEmpty` function checks whether the value is `undefined`, `''`, `null` or `NaN`.
	   *
	   * You can override this for input directives whose concept of being empty is different from the
	   * default. The `checkboxInputType` directive does this because in its case a value of `false`
	   * implies empty.
	   *
	   * @param {*} value The value of the input to check for emptiness.
	   * @returns {boolean} True if `value` is "empty".
	   */
	  this.$isEmpty = function(value) {
	    return isUndefined(value) || value === '' || value === null || value !== value;
	  };
	
	  this.$$updateEmptyClasses = function(value) {
	    if (ctrl.$isEmpty(value)) {
	      $animate.removeClass($element, NOT_EMPTY_CLASS);
	      $animate.addClass($element, EMPTY_CLASS);
	    } else {
	      $animate.removeClass($element, EMPTY_CLASS);
	      $animate.addClass($element, NOT_EMPTY_CLASS);
	    }
	  };
	
	
	  var currentValidationRunId = 0;
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$setValidity
	   *
	   * @description
	   * Change the validity state, and notify the form.
	   *
	   * This method can be called within $parsers/$formatters or a custom validation implementation.
	   * However, in most cases it should be sufficient to use the `ngModel.$validators` and
	   * `ngModel.$asyncValidators` collections which will call `$setValidity` automatically.
	   *
	   * @param {string} validationErrorKey Name of the validator. The `validationErrorKey` will be assigned
	   *        to either `$error[validationErrorKey]` or `$pending[validationErrorKey]`
	   *        (for unfulfilled `$asyncValidators`), so that it is available for data-binding.
	   *        The `validationErrorKey` should be in camelCase and will get converted into dash-case
	   *        for class name. Example: `myError` will result in `ng-valid-my-error` and `ng-invalid-my-error`
	   *        class and can be bound to as  `{{someForm.someControl.$error.myError}}` .
	   * @param {boolean} isValid Whether the current state is valid (true), invalid (false), pending (undefined),
	   *                          or skipped (null). Pending is used for unfulfilled `$asyncValidators`.
	   *                          Skipped is used by Angular when validators do not run because of parse errors and
	   *                          when `$asyncValidators` do not run because any of the `$validators` failed.
	   */
	  addSetValidityMethod({
	    ctrl: this,
	    $element: $element,
	    set: function(object, property) {
	      object[property] = true;
	    },
	    unset: function(object, property) {
	      delete object[property];
	    },
	    $animate: $animate
	  });
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$setPristine
	   *
	   * @description
	   * Sets the control to its pristine state.
	   *
	   * This method can be called to remove the `ng-dirty` class and set the control to its pristine
	   * state (`ng-pristine` class). A model is considered to be pristine when the control
	   * has not been changed from when first compiled.
	   */
	  this.$setPristine = function() {
	    ctrl.$dirty = false;
	    ctrl.$pristine = true;
	    $animate.removeClass($element, DIRTY_CLASS);
	    $animate.addClass($element, PRISTINE_CLASS);
	  };
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$setDirty
	   *
	   * @description
	   * Sets the control to its dirty state.
	   *
	   * This method can be called to remove the `ng-pristine` class and set the control to its dirty
	   * state (`ng-dirty` class). A model is considered to be dirty when the control has been changed
	   * from when first compiled.
	   */
	  this.$setDirty = function() {
	    ctrl.$dirty = true;
	    ctrl.$pristine = false;
	    $animate.removeClass($element, PRISTINE_CLASS);
	    $animate.addClass($element, DIRTY_CLASS);
	    ctrl.$$parentForm.$setDirty();
	  };
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$setUntouched
	   *
	   * @description
	   * Sets the control to its untouched state.
	   *
	   * This method can be called to remove the `ng-touched` class and set the control to its
	   * untouched state (`ng-untouched` class). Upon compilation, a model is set as untouched
	   * by default, however this function can be used to restore that state if the model has
	   * already been touched by the user.
	   */
	  this.$setUntouched = function() {
	    ctrl.$touched = false;
	    ctrl.$untouched = true;
	    $animate.setClass($element, UNTOUCHED_CLASS, TOUCHED_CLASS);
	  };
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$setTouched
	   *
	   * @description
	   * Sets the control to its touched state.
	   *
	   * This method can be called to remove the `ng-untouched` class and set the control to its
	   * touched state (`ng-touched` class). A model is considered to be touched when the user has
	   * first focused the control element and then shifted focus away from the control (blur event).
	   */
	  this.$setTouched = function() {
	    ctrl.$touched = true;
	    ctrl.$untouched = false;
	    $animate.setClass($element, TOUCHED_CLASS, UNTOUCHED_CLASS);
	  };
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$rollbackViewValue
	   *
	   * @description
	   * Cancel an update and reset the input element's value to prevent an update to the `$modelValue`,
	   * which may be caused by a pending debounced event or because the input is waiting for a some
	   * future event.
	   *
	   * If you have an input that uses `ng-model-options` to set up debounced updates or updates that
	   * depend on special events such as blur, you can have a situation where there is a period when
	   * the `$viewValue` is out of sync with the ngModel's `$modelValue`.
	   *
	   * In this case, you can use `$rollbackViewValue()` to manually cancel the debounced / future update
	   * and reset the input to the last committed view value.
	   *
	   * It is also possible that you run into difficulties if you try to update the ngModel's `$modelValue`
	   * programmatically before these debounced/future events have resolved/occurred, because Angular's
	   * dirty checking mechanism is not able to tell whether the model has actually changed or not.
	   *
	   * The `$rollbackViewValue()` method should be called before programmatically changing the model of an
	   * input which may have such events pending. This is important in order to make sure that the
	   * input field will be updated with the new model value and any pending operations are cancelled.
	   *
	   * <example name="ng-model-cancel-update" module="cancel-update-example">
	   *   <file name="app.js">
	   *     angular.module('cancel-update-example', [])
	   *
	   *     .controller('CancelUpdateController', ['$scope', function($scope) {
	   *       $scope.model = {};
	   *
	   *       $scope.setEmpty = function(e, value, rollback) {
	   *         if (e.keyCode == 27) {
	   *           e.preventDefault();
	   *           if (rollback) {
	   *             $scope.myForm[value].$rollbackViewValue();
	   *           }
	   *           $scope.model[value] = '';
	   *         }
	   *       };
	   *     }]);
	   *   </file>
	   *   <file name="index.html">
	   *     <div ng-controller="CancelUpdateController">
	   *        <p>Both of these inputs are only updated if they are blurred. Hitting escape should
	   *        empty them. Follow these steps and observe the difference:</p>
	   *       <ol>
	   *         <li>Type something in the input. You will see that the model is not yet updated</li>
	   *         <li>Press the Escape key.
	   *           <ol>
	   *             <li> In the first example, nothing happens, because the model is already '', and no
	   *             update is detected. If you blur the input, the model will be set to the current view.
	   *             </li>
	   *             <li> In the second example, the pending update is cancelled, and the input is set back
	   *             to the last committed view value (''). Blurring the input does nothing.
	   *             </li>
	   *           </ol>
	   *         </li>
	   *       </ol>
	   *
	   *       <form name="myForm" ng-model-options="{ updateOn: 'blur' }">
	   *         <div>
	   *        <p id="inputDescription1">Without $rollbackViewValue():</p>
	   *         <input name="value1" aria-describedby="inputDescription1" ng-model="model.value1"
	   *                ng-keydown="setEmpty($event, 'value1')">
	   *         value1: "{{ model.value1 }}"
	   *         </div>
	   *
	   *         <div>
	   *        <p id="inputDescription2">With $rollbackViewValue():</p>
	   *         <input name="value2" aria-describedby="inputDescription2" ng-model="model.value2"
	   *                ng-keydown="setEmpty($event, 'value2', true)">
	   *         value2: "{{ model.value2 }}"
	   *         </div>
	   *       </form>
	   *     </div>
	   *   </file>
	       <file name="style.css">
	          div {
	            display: table-cell;
	          }
	          div:nth-child(1) {
	            padding-right: 30px;
	          }
	
	        </file>
	   * </example>
	   */
	  this.$rollbackViewValue = function() {
	    $timeout.cancel(pendingDebounce);
	    ctrl.$viewValue = ctrl.$$lastCommittedViewValue;
	    ctrl.$render();
	  };
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$validate
	   *
	   * @description
	   * Runs each of the registered validators (first synchronous validators and then
	   * asynchronous validators).
	   * If the validity changes to invalid, the model will be set to `undefined`,
	   * unless {@link ngModelOptions `ngModelOptions.allowInvalid`} is `true`.
	   * If the validity changes to valid, it will set the model to the last available valid
	   * `$modelValue`, i.e. either the last parsed value or the last value set from the scope.
	   */
	  this.$validate = function() {
	    // ignore $validate before model is initialized
	    if (isNumber(ctrl.$modelValue) && isNaN(ctrl.$modelValue)) {
	      return;
	    }
	
	    var viewValue = ctrl.$$lastCommittedViewValue;
	    // Note: we use the $$rawModelValue as $modelValue might have been
	    // set to undefined during a view -> model update that found validation
	    // errors. We can't parse the view here, since that could change
	    // the model although neither viewValue nor the model on the scope changed
	    var modelValue = ctrl.$$rawModelValue;
	
	    var prevValid = ctrl.$valid;
	    var prevModelValue = ctrl.$modelValue;
	
	    var allowInvalid = ctrl.$options && ctrl.$options.allowInvalid;
	
	    ctrl.$$runValidators(modelValue, viewValue, function(allValid) {
	      // If there was no change in validity, don't update the model
	      // This prevents changing an invalid modelValue to undefined
	      if (!allowInvalid && prevValid !== allValid) {
	        // Note: Don't check ctrl.$valid here, as we could have
	        // external validators (e.g. calculated on the server),
	        // that just call $setValidity and need the model value
	        // to calculate their validity.
	        ctrl.$modelValue = allValid ? modelValue : undefined;
	
	        if (ctrl.$modelValue !== prevModelValue) {
	          ctrl.$$writeModelToScope();
	        }
	      }
	    });
	
	  };
	
	  this.$$runValidators = function(modelValue, viewValue, doneCallback) {
	    currentValidationRunId++;
	    var localValidationRunId = currentValidationRunId;
	
	    // check parser error
	    if (!processParseErrors()) {
	      validationDone(false);
	      return;
	    }
	    if (!processSyncValidators()) {
	      validationDone(false);
	      return;
	    }
	    processAsyncValidators();
	
	    function processParseErrors() {
	      var errorKey = ctrl.$$parserName || 'parse';
	      if (isUndefined(parserValid)) {
	        setValidity(errorKey, null);
	      } else {
	        if (!parserValid) {
	          forEach(ctrl.$validators, function(v, name) {
	            setValidity(name, null);
	          });
	          forEach(ctrl.$asyncValidators, function(v, name) {
	            setValidity(name, null);
	          });
	        }
	        // Set the parse error last, to prevent unsetting it, should a $validators key == parserName
	        setValidity(errorKey, parserValid);
	        return parserValid;
	      }
	      return true;
	    }
	
	    function processSyncValidators() {
	      var syncValidatorsValid = true;
	      forEach(ctrl.$validators, function(validator, name) {
	        var result = validator(modelValue, viewValue);
	        syncValidatorsValid = syncValidatorsValid && result;
	        setValidity(name, result);
	      });
	      if (!syncValidatorsValid) {
	        forEach(ctrl.$asyncValidators, function(v, name) {
	          setValidity(name, null);
	        });
	        return false;
	      }
	      return true;
	    }
	
	    function processAsyncValidators() {
	      var validatorPromises = [];
	      var allValid = true;
	      forEach(ctrl.$asyncValidators, function(validator, name) {
	        var promise = validator(modelValue, viewValue);
	        if (!isPromiseLike(promise)) {
	          throw ngModelMinErr('nopromise',
	            "Expected asynchronous validator to return a promise but got '{0}' instead.", promise);
	        }
	        setValidity(name, undefined);
	        validatorPromises.push(promise.then(function() {
	          setValidity(name, true);
	        }, function() {
	          allValid = false;
	          setValidity(name, false);
	        }));
	      });
	      if (!validatorPromises.length) {
	        validationDone(true);
	      } else {
	        $q.all(validatorPromises).then(function() {
	          validationDone(allValid);
	        }, noop);
	      }
	    }
	
	    function setValidity(name, isValid) {
	      if (localValidationRunId === currentValidationRunId) {
	        ctrl.$setValidity(name, isValid);
	      }
	    }
	
	    function validationDone(allValid) {
	      if (localValidationRunId === currentValidationRunId) {
	
	        doneCallback(allValid);
	      }
	    }
	  };
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$commitViewValue
	   *
	   * @description
	   * Commit a pending update to the `$modelValue`.
	   *
	   * Updates may be pending by a debounced event or because the input is waiting for a some future
	   * event defined in `ng-model-options`. this method is rarely needed as `NgModelController`
	   * usually handles calling this in response to input events.
	   */
	  this.$commitViewValue = function() {
	    var viewValue = ctrl.$viewValue;
	
	    $timeout.cancel(pendingDebounce);
	
	    // If the view value has not changed then we should just exit, except in the case where there is
	    // a native validator on the element. In this case the validation state may have changed even though
	    // the viewValue has stayed empty.
	    if (ctrl.$$lastCommittedViewValue === viewValue && (viewValue !== '' || !ctrl.$$hasNativeValidators)) {
	      return;
	    }
	    ctrl.$$updateEmptyClasses(viewValue);
	    ctrl.$$lastCommittedViewValue = viewValue;
	
	    // change to dirty
	    if (ctrl.$pristine) {
	      this.$setDirty();
	    }
	    this.$$parseAndValidate();
	  };
	
	  this.$$parseAndValidate = function() {
	    var viewValue = ctrl.$$lastCommittedViewValue;
	    var modelValue = viewValue;
	    parserValid = isUndefined(modelValue) ? undefined : true;
	
	    if (parserValid) {
	      for (var i = 0; i < ctrl.$parsers.length; i++) {
	        modelValue = ctrl.$parsers[i](modelValue);
	        if (isUndefined(modelValue)) {
	          parserValid = false;
	          break;
	        }
	      }
	    }
	    if (isNumber(ctrl.$modelValue) && isNaN(ctrl.$modelValue)) {
	      // ctrl.$modelValue has not been touched yet...
	      ctrl.$modelValue = ngModelGet($scope);
	    }
	    var prevModelValue = ctrl.$modelValue;
	    var allowInvalid = ctrl.$options && ctrl.$options.allowInvalid;
	    ctrl.$$rawModelValue = modelValue;
	
	    if (allowInvalid) {
	      ctrl.$modelValue = modelValue;
	      writeToModelIfNeeded();
	    }
	
	    // Pass the $$lastCommittedViewValue here, because the cached viewValue might be out of date.
	    // This can happen if e.g. $setViewValue is called from inside a parser
	    ctrl.$$runValidators(modelValue, ctrl.$$lastCommittedViewValue, function(allValid) {
	      if (!allowInvalid) {
	        // Note: Don't check ctrl.$valid here, as we could have
	        // external validators (e.g. calculated on the server),
	        // that just call $setValidity and need the model value
	        // to calculate their validity.
	        ctrl.$modelValue = allValid ? modelValue : undefined;
	        writeToModelIfNeeded();
	      }
	    });
	
	    function writeToModelIfNeeded() {
	      if (ctrl.$modelValue !== prevModelValue) {
	        ctrl.$$writeModelToScope();
	      }
	    }
	  };
	
	  this.$$writeModelToScope = function() {
	    ngModelSet($scope, ctrl.$modelValue);
	    forEach(ctrl.$viewChangeListeners, function(listener) {
	      try {
	        listener();
	      } catch (e) {
	        $exceptionHandler(e);
	      }
	    });
	  };
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$setViewValue
	   *
	   * @description
	   * Update the view value.
	   *
	   * This method should be called when a control wants to change the view value; typically,
	   * this is done from within a DOM event handler. For example, the {@link ng.directive:input input}
	   * directive calls it when the value of the input changes and {@link ng.directive:select select}
	   * calls it when an option is selected.
	   *
	   * When `$setViewValue` is called, the new `value` will be staged for committing through the `$parsers`
	   * and `$validators` pipelines. If there are no special {@link ngModelOptions} specified then the staged
	   * value sent directly for processing, finally to be applied to `$modelValue` and then the
	   * **expression** specified in the `ng-model` attribute. Lastly, all the registered change listeners,
	   * in the `$viewChangeListeners` list, are called.
	   *
	   * In case the {@link ng.directive:ngModelOptions ngModelOptions} directive is used with `updateOn`
	   * and the `default` trigger is not listed, all those actions will remain pending until one of the
	   * `updateOn` events is triggered on the DOM element.
	   * All these actions will be debounced if the {@link ng.directive:ngModelOptions ngModelOptions}
	   * directive is used with a custom debounce for this particular event.
	   * Note that a `$digest` is only triggered once the `updateOn` events are fired, or if `debounce`
	   * is specified, once the timer runs out.
	   *
	   * When used with standard inputs, the view value will always be a string (which is in some cases
	   * parsed into another type, such as a `Date` object for `input[date]`.)
	   * However, custom controls might also pass objects to this method. In this case, we should make
	   * a copy of the object before passing it to `$setViewValue`. This is because `ngModel` does not
	   * perform a deep watch of objects, it only looks for a change of identity. If you only change
	   * the property of the object then ngModel will not realize that the object has changed and
	   * will not invoke the `$parsers` and `$validators` pipelines. For this reason, you should
	   * not change properties of the copy once it has been passed to `$setViewValue`.
	   * Otherwise you may cause the model value on the scope to change incorrectly.
	   *
	   * <div class="alert alert-info">
	   * In any case, the value passed to the method should always reflect the current value
	   * of the control. For example, if you are calling `$setViewValue` for an input element,
	   * you should pass the input DOM value. Otherwise, the control and the scope model become
	   * out of sync. It's also important to note that `$setViewValue` does not call `$render` or change
	   * the control's DOM value in any way. If we want to change the control's DOM value
	   * programmatically, we should update the `ngModel` scope expression. Its new value will be
	   * picked up by the model controller, which will run it through the `$formatters`, `$render` it
	   * to update the DOM, and finally call `$validate` on it.
	   * </div>
	   *
	   * @param {*} value value from the view.
	   * @param {string} trigger Event that triggered the update.
	   */
	  this.$setViewValue = function(value, trigger) {
	    ctrl.$viewValue = value;
	    if (!ctrl.$options || ctrl.$options.updateOnDefault) {
	      ctrl.$$debounceViewValueCommit(trigger);
	    }
	  };
	
	  this.$$debounceViewValueCommit = function(trigger) {
	    var debounceDelay = 0,
	        options = ctrl.$options,
	        debounce;
	
	    if (options && isDefined(options.debounce)) {
	      debounce = options.debounce;
	      if (isNumber(debounce)) {
	        debounceDelay = debounce;
	      } else if (isNumber(debounce[trigger])) {
	        debounceDelay = debounce[trigger];
	      } else if (isNumber(debounce['default'])) {
	        debounceDelay = debounce['default'];
	      }
	    }
	
	    $timeout.cancel(pendingDebounce);
	    if (debounceDelay) {
	      pendingDebounce = $timeout(function() {
	        ctrl.$commitViewValue();
	      }, debounceDelay);
	    } else if ($rootScope.$$phase) {
	      ctrl.$commitViewValue();
	    } else {
	      $scope.$apply(function() {
	        ctrl.$commitViewValue();
	      });
	    }
	  };
	
	  // model -> value
	  // Note: we cannot use a normal scope.$watch as we want to detect the following:
	  // 1. scope value is 'a'
	  // 2. user enters 'b'
	  // 3. ng-change kicks in and reverts scope value to 'a'
	  //    -> scope value did not change since the last digest as
	  //       ng-change executes in apply phase
	  // 4. view should be changed back to 'a'
	  $scope.$watch(function ngModelWatch() {
	    var modelValue = ngModelGet($scope);
	
	    // if scope model value and ngModel value are out of sync
	    // TODO(perf): why not move this to the action fn?
	    if (modelValue !== ctrl.$modelValue &&
	       // checks for NaN is needed to allow setting the model to NaN when there's an asyncValidator
	       (ctrl.$modelValue === ctrl.$modelValue || modelValue === modelValue)
	    ) {
	      ctrl.$modelValue = ctrl.$$rawModelValue = modelValue;
	      parserValid = undefined;
	
	      var formatters = ctrl.$formatters,
	          idx = formatters.length;
	
	      var viewValue = modelValue;
	      while (idx--) {
	        viewValue = formatters[idx](viewValue);
	      }
	      if (ctrl.$viewValue !== viewValue) {
	        ctrl.$$updateEmptyClasses(viewValue);
	        ctrl.$viewValue = ctrl.$$lastCommittedViewValue = viewValue;
	        ctrl.$render();
	
	        ctrl.$$runValidators(modelValue, viewValue, noop);
	      }
	    }
	
	    return modelValue;
	  });
	}];
	
	
	/**
	 * @ngdoc directive
	 * @name ngModel
	 *
	 * @element input
	 * @priority 1
	 *
	 * @description
	 * The `ngModel` directive binds an `input`,`select`, `textarea` (or custom form control) to a
	 * property on the scope using {@link ngModel.NgModelController NgModelController},
	 * which is created and exposed by this directive.
	 *
	 * `ngModel` is responsible for:
	 *
	 * - Binding the view into the model, which other directives such as `input`, `textarea` or `select`
	 *   require.
	 * - Providing validation behavior (i.e. required, number, email, url).
	 * - Keeping the state of the control (valid/invalid, dirty/pristine, touched/untouched, validation errors).
	 * - Setting related css classes on the element (`ng-valid`, `ng-invalid`, `ng-dirty`, `ng-pristine`, `ng-touched`,
	 *   `ng-untouched`, `ng-empty`, `ng-not-empty`) including animations.
	 * - Registering the control with its parent {@link ng.directive:form form}.
	 *
	 * Note: `ngModel` will try to bind to the property given by evaluating the expression on the
	 * current scope. If the property doesn't already exist on this scope, it will be created
	 * implicitly and added to the scope.
	 *
	 * For best practices on using `ngModel`, see:
	 *
	 *  - [Understanding Scopes](https://github.com/angular/angular.js/wiki/Understanding-Scopes)
	 *
	 * For basic examples, how to use `ngModel`, see:
	 *
	 *  - {@link ng.directive:input input}
	 *    - {@link input[text] text}
	 *    - {@link input[checkbox] checkbox}
	 *    - {@link input[radio] radio}
	 *    - {@link input[number] number}
	 *    - {@link input[email] email}
	 *    - {@link input[url] url}
	 *    - {@link input[date] date}
	 *    - {@link input[datetime-local] datetime-local}
	 *    - {@link input[time] time}
	 *    - {@link input[month] month}
	 *    - {@link input[week] week}
	 *  - {@link ng.directive:select select}
	 *  - {@link ng.directive:textarea textarea}
	 *
	 * # Complex Models (objects or collections)
	 *
	 * By default, `ngModel` watches the model by reference, not value. This is important to know when
	 * binding inputs to models that are objects (e.g. `Date`) or collections (e.g. arrays). If only properties of the
	 * object or collection change, `ngModel` will not be notified and so the input will not be  re-rendered.
	 *
	 * The model must be assigned an entirely new object or collection before a re-rendering will occur.
	 *
	 * Some directives have options that will cause them to use a custom `$watchCollection` on the model expression
	 * - for example, `ngOptions` will do so when a `track by` clause is included in the comprehension expression or
	 * if the select is given the `multiple` attribute.
	 *
	 * The `$watchCollection()` method only does a shallow comparison, meaning that changing properties deeper than the
	 * first level of the object (or only changing the properties of an item in the collection if it's an array) will still
	 * not trigger a re-rendering of the model.
	 *
	 * # CSS classes
	 * The following CSS classes are added and removed on the associated input/select/textarea element
	 * depending on the validity of the model.
	 *
	 *  - `ng-valid`: the model is valid
	 *  - `ng-invalid`: the model is invalid
	 *  - `ng-valid-[key]`: for each valid key added by `$setValidity`
	 *  - `ng-invalid-[key]`: for each invalid key added by `$setValidity`
	 *  - `ng-pristine`: the control hasn't been interacted with yet
	 *  - `ng-dirty`: the control has been interacted with
	 *  - `ng-touched`: the control has been blurred
	 *  - `ng-untouched`: the control hasn't been blurred
	 *  - `ng-pending`: any `$asyncValidators` are unfulfilled
	 *  - `ng-empty`: the view does not contain a value or the value is deemed "empty", as defined
	 *     by the {@link ngModel.NgModelController#$isEmpty} method
	 *  - `ng-not-empty`: the view contains a non-empty value
	 *
	 * Keep in mind that ngAnimate can detect each of these classes when added and removed.
	 *
	 * ## Animation Hooks
	 *
	 * Animations within models are triggered when any of the associated CSS classes are added and removed
	 * on the input element which is attached to the model. These classes include: `.ng-pristine`, `.ng-dirty`,
	 * `.ng-invalid` and `.ng-valid` as well as any other validations that are performed on the model itself.
	 * The animations that are triggered within ngModel are similar to how they work in ngClass and
	 * animations can be hooked into using CSS transitions, keyframes as well as JS animations.
	 *
	 * The following example shows a simple way to utilize CSS transitions to style an input element
	 * that has been rendered as invalid after it has been validated:
	 *
	 * <pre>
	 * //be sure to include ngAnimate as a module to hook into more
	 * //advanced animations
	 * .my-input {
	 *   transition:0.5s linear all;
	 *   background: white;
	 * }
	 * .my-input.ng-invalid {
	 *   background: red;
	 *   color:white;
	 * }
	 * </pre>
	 *
	 * @example
	 * <example deps="angular-animate.js" animations="true" fixBase="true" module="inputExample">
	     <file name="index.html">
	       <script>
	        angular.module('inputExample', [])
	          .controller('ExampleController', ['$scope', function($scope) {
	            $scope.val = '1';
	          }]);
	       </script>
	       <style>
	         .my-input {
	           transition:all linear 0.5s;
	           background: transparent;
	         }
	         .my-input.ng-invalid {
	           color:white;
	           background: red;
	         }
	       </style>
	       <p id="inputDescription">
	        Update input to see transitions when valid/invalid.
	        Integer is a valid value.
	       </p>
	       <form name="testForm" ng-controller="ExampleController">
	         <input ng-model="val" ng-pattern="/^\d+$/" name="anim" class="my-input"
	                aria-describedby="inputDescription" />
	       </form>
	     </file>
	 * </example>
	 *
	 * ## Binding to a getter/setter
	 *
	 * Sometimes it's helpful to bind `ngModel` to a getter/setter function.  A getter/setter is a
	 * function that returns a representation of the model when called with zero arguments, and sets
	 * the internal state of a model when called with an argument. It's sometimes useful to use this
	 * for models that have an internal representation that's different from what the model exposes
	 * to the view.
	 *
	 * <div class="alert alert-success">
	 * **Best Practice:** It's best to keep getters fast because Angular is likely to call them more
	 * frequently than other parts of your code.
	 * </div>
	 *
	 * You use this behavior by adding `ng-model-options="{ getterSetter: true }"` to an element that
	 * has `ng-model` attached to it. You can also add `ng-model-options="{ getterSetter: true }"` to
	 * a `<form>`, which will enable this behavior for all `<input>`s within it. See
	 * {@link ng.directive:ngModelOptions `ngModelOptions`} for more.
	 *
	 * The following example shows how to use `ngModel` with a getter/setter:
	 *
	 * @example
	 * <example name="ngModel-getter-setter" module="getterSetterExample">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	         <form name="userForm">
	           <label>Name:
	             <input type="text" name="userName"
	                    ng-model="user.name"
	                    ng-model-options="{ getterSetter: true }" />
	           </label>
	         </form>
	         <pre>user.name = <span ng-bind="user.name()"></span></pre>
	       </div>
	     </file>
	     <file name="app.js">
	       angular.module('getterSetterExample', [])
	         .controller('ExampleController', ['$scope', function($scope) {
	           var _name = 'Brian';
	           $scope.user = {
	             name: function(newName) {
	              // Note that newName can be undefined for two reasons:
	              // 1. Because it is called as a getter and thus called with no arguments
	              // 2. Because the property should actually be set to undefined. This happens e.g. if the
	              //    input is invalid
	              return arguments.length ? (_name = newName) : _name;
	             }
	           };
	         }]);
	     </file>
	 * </example>
	 */
	var ngModelDirective = ['$rootScope', function($rootScope) {
	  return {
	    restrict: 'A',
	    require: ['ngModel', '^?form', '^?ngModelOptions'],
	    controller: NgModelController,
	    // Prelink needs to run before any input directive
	    // so that we can set the NgModelOptions in NgModelController
	    // before anyone else uses it.
	    priority: 1,
	    compile: function ngModelCompile(element) {
	      // Setup initial state of the control
	      element.addClass(PRISTINE_CLASS).addClass(UNTOUCHED_CLASS).addClass(VALID_CLASS);
	
	      return {
	        pre: function ngModelPreLink(scope, element, attr, ctrls) {
	          var modelCtrl = ctrls[0],
	              formCtrl = ctrls[1] || modelCtrl.$$parentForm;
	
	          modelCtrl.$$setOptions(ctrls[2] && ctrls[2].$options);
	
	          // notify others, especially parent forms
	          formCtrl.$addControl(modelCtrl);
	
	          attr.$observe('name', function(newValue) {
	            if (modelCtrl.$name !== newValue) {
	              modelCtrl.$$parentForm.$$renameControl(modelCtrl, newValue);
	            }
	          });
	
	          scope.$on('$destroy', function() {
	            modelCtrl.$$parentForm.$removeControl(modelCtrl);
	          });
	        },
	        post: function ngModelPostLink(scope, element, attr, ctrls) {
	          var modelCtrl = ctrls[0];
	          if (modelCtrl.$options && modelCtrl.$options.updateOn) {
	            element.on(modelCtrl.$options.updateOn, function(ev) {
	              modelCtrl.$$debounceViewValueCommit(ev && ev.type);
	            });
	          }
	
	          element.on('blur', function() {
	            if (modelCtrl.$touched) return;
	
	            if ($rootScope.$$phase) {
	              scope.$evalAsync(modelCtrl.$setTouched);
	            } else {
	              scope.$apply(modelCtrl.$setTouched);
	            }
	          });
	        }
	      };
	    }
	  };
	}];
	
	var DEFAULT_REGEXP = /(\s+|^)default(\s+|$)/;
	
	/**
	 * @ngdoc directive
	 * @name ngModelOptions
	 *
	 * @description
	 * Allows tuning how model updates are done. Using `ngModelOptions` you can specify a custom list of
	 * events that will trigger a model update and/or a debouncing delay so that the actual update only
	 * takes place when a timer expires; this timer will be reset after another change takes place.
	 *
	 * Given the nature of `ngModelOptions`, the value displayed inside input fields in the view might
	 * be different from the value in the actual model. This means that if you update the model you
	 * should also invoke {@link ngModel.NgModelController `$rollbackViewValue`} on the relevant input field in
	 * order to make sure it is synchronized with the model and that any debounced action is canceled.
	 *
	 * The easiest way to reference the control's {@link ngModel.NgModelController `$rollbackViewValue`}
	 * method is by making sure the input is placed inside a form that has a `name` attribute. This is
	 * important because `form` controllers are published to the related scope under the name in their
	 * `name` attribute.
	 *
	 * Any pending changes will take place immediately when an enclosing form is submitted via the
	 * `submit` event. Note that `ngClick` events will occur before the model is updated. Use `ngSubmit`
	 * to have access to the updated model.
	 *
	 * `ngModelOptions` has an effect on the element it's declared on and its descendants.
	 *
	 * @param {Object} ngModelOptions options to apply to the current model. Valid keys are:
	 *   - `updateOn`: string specifying which event should the input be bound to. You can set several
	 *     events using an space delimited list. There is a special event called `default` that
	 *     matches the default events belonging of the control.
	 *   - `debounce`: integer value which contains the debounce model update value in milliseconds. A
	 *     value of 0 triggers an immediate update. If an object is supplied instead, you can specify a
	 *     custom value for each event. For example:
	 *     `ng-model-options="{ updateOn: 'default blur', debounce: { 'default': 500, 'blur': 0 } }"`
	 *   - `allowInvalid`: boolean value which indicates that the model can be set with values that did
	 *     not validate correctly instead of the default behavior of setting the model to undefined.
	 *   - `getterSetter`: boolean value which determines whether or not to treat functions bound to
	       `ngModel` as getters/setters.
	 *   - `timezone`: Defines the timezone to be used to read/write the `Date` instance in the model for
	 *     `<input type="date">`, `<input type="time">`, ... . It understands UTC/GMT and the
	 *     continental US time zone abbreviations, but for general use, use a time zone offset, for
	 *     example, `'+0430'` (4 hours, 30 minutes east of the Greenwich meridian)
	 *     If not specified, the timezone of the browser will be used.
	 *
	 * @example
	
	  The following example shows how to override immediate updates. Changes on the inputs within the
	  form will update the model only when the control loses focus (blur event). If `escape` key is
	  pressed while the input field is focused, the value is reset to the value in the current model.
	
	  <example name="ngModelOptions-directive-blur" module="optionsExample">
	    <file name="index.html">
	      <div ng-controller="ExampleController">
	        <form name="userForm">
	          <label>Name:
	            <input type="text" name="userName"
	                   ng-model="user.name"
	                   ng-model-options="{ updateOn: 'blur' }"
	                   ng-keyup="cancel($event)" />
	          </label><br />
	          <label>Other data:
	            <input type="text" ng-model="user.data" />
	          </label><br />
	        </form>
	        <pre>user.name = <span ng-bind="user.name"></span></pre>
	        <pre>user.data = <span ng-bind="user.data"></span></pre>
	      </div>
	    </file>
	    <file name="app.js">
	      angular.module('optionsExample', [])
	        .controller('ExampleController', ['$scope', function($scope) {
	          $scope.user = { name: 'John', data: '' };
	
	          $scope.cancel = function(e) {
	            if (e.keyCode == 27) {
	              $scope.userForm.userName.$rollbackViewValue();
	            }
	          };
	        }]);
	    </file>
	    <file name="protractor.js" type="protractor">
	      var model = element(by.binding('user.name'));
	      var input = element(by.model('user.name'));
	      var other = element(by.model('user.data'));
	
	      it('should allow custom events', function() {
	        input.sendKeys(' Doe');
	        input.click();
	        expect(model.getText()).toEqual('John');
	        other.click();
	        expect(model.getText()).toEqual('John Doe');
	      });
	
	      it('should $rollbackViewValue when model changes', function() {
	        input.sendKeys(' Doe');
	        expect(input.getAttribute('value')).toEqual('John Doe');
	        input.sendKeys(protractor.Key.ESCAPE);
	        expect(input.getAttribute('value')).toEqual('John');
	        other.click();
	        expect(model.getText()).toEqual('John');
	      });
	    </file>
	  </example>
	
	  This one shows how to debounce model changes. Model will be updated only 1 sec after last change.
	  If the `Clear` button is pressed, any debounced action is canceled and the value becomes empty.
	
	  <example name="ngModelOptions-directive-debounce" module="optionsExample">
	    <file name="index.html">
	      <div ng-controller="ExampleController">
	        <form name="userForm">
	          <label>Name:
	            <input type="text" name="userName"
	                   ng-model="user.name"
	                   ng-model-options="{ debounce: 1000 }" />
	          </label>
	          <button ng-click="userForm.userName.$rollbackViewValue(); user.name=''">Clear</button>
	          <br />
	        </form>
	        <pre>user.name = <span ng-bind="user.name"></span></pre>
	      </div>
	    </file>
	    <file name="app.js">
	      angular.module('optionsExample', [])
	        .controller('ExampleController', ['$scope', function($scope) {
	          $scope.user = { name: 'Igor' };
	        }]);
	    </file>
	  </example>
	
	  This one shows how to bind to getter/setters:
	
	  <example name="ngModelOptions-directive-getter-setter" module="getterSetterExample">
	    <file name="index.html">
	      <div ng-controller="ExampleController">
	        <form name="userForm">
	          <label>Name:
	            <input type="text" name="userName"
	                   ng-model="user.name"
	                   ng-model-options="{ getterSetter: true }" />
	          </label>
	        </form>
	        <pre>user.name = <span ng-bind="user.name()"></span></pre>
	      </div>
	    </file>
	    <file name="app.js">
	      angular.module('getterSetterExample', [])
	        .controller('ExampleController', ['$scope', function($scope) {
	          var _name = 'Brian';
	          $scope.user = {
	            name: function(newName) {
	              // Note that newName can be undefined for two reasons:
	              // 1. Because it is called as a getter and thus called with no arguments
	              // 2. Because the property should actually be set to undefined. This happens e.g. if the
	              //    input is invalid
	              return arguments.length ? (_name = newName) : _name;
	            }
	          };
	        }]);
	    </file>
	  </example>
	 */
	var ngModelOptionsDirective = function() {
	  return {
	    restrict: 'A',
	    controller: ['$scope', '$attrs', function($scope, $attrs) {
	      var that = this;
	      this.$options = copy($scope.$eval($attrs.ngModelOptions));
	      // Allow adding/overriding bound events
	      if (isDefined(this.$options.updateOn)) {
	        this.$options.updateOnDefault = false;
	        // extract "default" pseudo-event from list of events that can trigger a model update
	        this.$options.updateOn = trim(this.$options.updateOn.replace(DEFAULT_REGEXP, function() {
	          that.$options.updateOnDefault = true;
	          return ' ';
	        }));
	      } else {
	        this.$options.updateOnDefault = true;
	      }
	    }]
	  };
	};
	
	
	
	// helper methods
	function addSetValidityMethod(context) {
	  var ctrl = context.ctrl,
	      $element = context.$element,
	      classCache = {},
	      set = context.set,
	      unset = context.unset,
	      $animate = context.$animate;
	
	  classCache[INVALID_CLASS] = !(classCache[VALID_CLASS] = $element.hasClass(VALID_CLASS));
	
	  ctrl.$setValidity = setValidity;
	
	  function setValidity(validationErrorKey, state, controller) {
	    if (isUndefined(state)) {
	      createAndSet('$pending', validationErrorKey, controller);
	    } else {
	      unsetAndCleanup('$pending', validationErrorKey, controller);
	    }
	    if (!isBoolean(state)) {
	      unset(ctrl.$error, validationErrorKey, controller);
	      unset(ctrl.$$success, validationErrorKey, controller);
	    } else {
	      if (state) {
	        unset(ctrl.$error, validationErrorKey, controller);
	        set(ctrl.$$success, validationErrorKey, controller);
	      } else {
	        set(ctrl.$error, validationErrorKey, controller);
	        unset(ctrl.$$success, validationErrorKey, controller);
	      }
	    }
	    if (ctrl.$pending) {
	      cachedToggleClass(PENDING_CLASS, true);
	      ctrl.$valid = ctrl.$invalid = undefined;
	      toggleValidationCss('', null);
	    } else {
	      cachedToggleClass(PENDING_CLASS, false);
	      ctrl.$valid = isObjectEmpty(ctrl.$error);
	      ctrl.$invalid = !ctrl.$valid;
	      toggleValidationCss('', ctrl.$valid);
	    }
	
	    // re-read the state as the set/unset methods could have
	    // combined state in ctrl.$error[validationError] (used for forms),
	    // where setting/unsetting only increments/decrements the value,
	    // and does not replace it.
	    var combinedState;
	    if (ctrl.$pending && ctrl.$pending[validationErrorKey]) {
	      combinedState = undefined;
	    } else if (ctrl.$error[validationErrorKey]) {
	      combinedState = false;
	    } else if (ctrl.$$success[validationErrorKey]) {
	      combinedState = true;
	    } else {
	      combinedState = null;
	    }
	
	    toggleValidationCss(validationErrorKey, combinedState);
	    ctrl.$$parentForm.$setValidity(validationErrorKey, combinedState, ctrl);
	  }
	
	  function createAndSet(name, value, controller) {
	    if (!ctrl[name]) {
	      ctrl[name] = {};
	    }
	    set(ctrl[name], value, controller);
	  }
	
	  function unsetAndCleanup(name, value, controller) {
	    if (ctrl[name]) {
	      unset(ctrl[name], value, controller);
	    }
	    if (isObjectEmpty(ctrl[name])) {
	      ctrl[name] = undefined;
	    }
	  }
	
	  function cachedToggleClass(className, switchValue) {
	    if (switchValue && !classCache[className]) {
	      $animate.addClass($element, className);
	      classCache[className] = true;
	    } else if (!switchValue && classCache[className]) {
	      $animate.removeClass($element, className);
	      classCache[className] = false;
	    }
	  }
	
	  function toggleValidationCss(validationErrorKey, isValid) {
	    validationErrorKey = validationErrorKey ? '-' + snake_case(validationErrorKey, '-') : '';
	
	    cachedToggleClass(VALID_CLASS + validationErrorKey, isValid === true);
	    cachedToggleClass(INVALID_CLASS + validationErrorKey, isValid === false);
	  }
	}
	
	function isObjectEmpty(obj) {
	  if (obj) {
	    for (var prop in obj) {
	      if (obj.hasOwnProperty(prop)) {
	        return false;
	      }
	    }
	  }
	  return true;
	}
	
	/**
	 * @ngdoc directive
	 * @name ngNonBindable
	 * @restrict AC
	 * @priority 1000
	 *
	 * @description
	 * The `ngNonBindable` directive tells Angular not to compile or bind the contents of the current
	 * DOM element. This is useful if the element contains what appears to be Angular directives and
	 * bindings but which should be ignored by Angular. This could be the case if you have a site that
	 * displays snippets of code, for instance.
	 *
	 * @element ANY
	 *
	 * @example
	 * In this example there are two locations where a simple interpolation binding (`{{}}`) is present,
	 * but the one wrapped in `ngNonBindable` is left alone.
	 *
	 * @example
	    <example>
	      <file name="index.html">
	        <div>Normal: {{1 + 2}}</div>
	        <div ng-non-bindable>Ignored: {{1 + 2}}</div>
	      </file>
	      <file name="protractor.js" type="protractor">
	       it('should check ng-non-bindable', function() {
	         expect(element(by.binding('1 + 2')).getText()).toContain('3');
	         expect(element.all(by.css('div')).last().getText()).toMatch(/1 \+ 2/);
	       });
	      </file>
	    </example>
	 */
	var ngNonBindableDirective = ngDirective({ terminal: true, priority: 1000 });
	
	/* global jqLiteRemove */
	
	var ngOptionsMinErr = minErr('ngOptions');
	
	/**
	 * @ngdoc directive
	 * @name ngOptions
	 * @restrict A
	 *
	 * @description
	 *
	 * The `ngOptions` attribute can be used to dynamically generate a list of `<option>`
	 * elements for the `<select>` element using the array or object obtained by evaluating the
	 * `ngOptions` comprehension expression.
	 *
	 * In many cases, `ngRepeat` can be used on `<option>` elements instead of `ngOptions` to achieve a
	 * similar result. However, `ngOptions` provides some benefits such as reducing memory and
	 * increasing speed by not creating a new scope for each repeated instance, as well as providing
	 * more flexibility in how the `<select>`'s model is assigned via the `select` **`as`** part of the
	 * comprehension expression. `ngOptions` should be used when the `<select>` model needs to be bound
	 *  to a non-string value. This is because an option element can only be bound to string values at
	 * present.
	 *
	 * When an item in the `<select>` menu is selected, the array element or object property
	 * represented by the selected option will be bound to the model identified by the `ngModel`
	 * directive.
	 *
	 * Optionally, a single hard-coded `<option>` element, with the value set to an empty string, can
	 * be nested into the `<select>` element. This element will then represent the `null` or "not selected"
	 * option. See example below for demonstration.
	 *
	 * ## Complex Models (objects or collections)
	 *
	 * By default, `ngModel` watches the model by reference, not value. This is important to know when
	 * binding the select to a model that is an object or a collection.
	 *
	 * One issue occurs if you want to preselect an option. For example, if you set
	 * the model to an object that is equal to an object in your collection, `ngOptions` won't be able to set the selection,
	 * because the objects are not identical. So by default, you should always reference the item in your collection
	 * for preselections, e.g.: `$scope.selected = $scope.collection[3]`.
	 *
	 * Another solution is to use a `track by` clause, because then `ngOptions` will track the identity
	 * of the item not by reference, but by the result of the `track by` expression. For example, if your
	 * collection items have an id property, you would `track by item.id`.
	 *
	 * A different issue with objects or collections is that ngModel won't detect if an object property or
	 * a collection item changes. For that reason, `ngOptions` additionally watches the model using
	 * `$watchCollection`, when the expression contains a `track by` clause or the the select has the `multiple` attribute.
	 * This allows ngOptions to trigger a re-rendering of the options even if the actual object/collection
	 * has not changed identity, but only a property on the object or an item in the collection changes.
	 *
	 * Note that `$watchCollection` does a shallow comparison of the properties of the object (or the items in the collection
	 * if the model is an array). This means that changing a property deeper than the first level inside the
	 * object/collection will not trigger a re-rendering.
	 *
	 * ## `select` **`as`**
	 *
	 * Using `select` **`as`** will bind the result of the `select` expression to the model, but
	 * the value of the `<select>` and `<option>` html elements will be either the index (for array data sources)
	 * or property name (for object data sources) of the value within the collection. If a **`track by`** expression
	 * is used, the result of that expression will be set as the value of the `option` and `select` elements.
	 *
	 *
	 * ### `select` **`as`** and **`track by`**
	 *
	 * <div class="alert alert-warning">
	 * Be careful when using `select` **`as`** and **`track by`** in the same expression.
	 * </div>
	 *
	 * Given this array of items on the $scope:
	 *
	 * ```js
	 * $scope.items = [{
	 *   id: 1,
	 *   label: 'aLabel',
	 *   subItem: { name: 'aSubItem' }
	 * }, {
	 *   id: 2,
	 *   label: 'bLabel',
	 *   subItem: { name: 'bSubItem' }
	 * }];
	 * ```
	 *
	 * This will work:
	 *
	 * ```html
	 * <select ng-options="item as item.label for item in items track by item.id" ng-model="selected"></select>
	 * ```
	 * ```js
	 * $scope.selected = $scope.items[0];
	 * ```
	 *
	 * but this will not work:
	 *
	 * ```html
	 * <select ng-options="item.subItem as item.label for item in items track by item.id" ng-model="selected"></select>
	 * ```
	 * ```js
	 * $scope.selected = $scope.items[0].subItem;
	 * ```
	 *
	 * In both examples, the **`track by`** expression is applied successfully to each `item` in the
	 * `items` array. Because the selected option has been set programmatically in the controller, the
	 * **`track by`** expression is also applied to the `ngModel` value. In the first example, the
	 * `ngModel` value is `items[0]` and the **`track by`** expression evaluates to `items[0].id` with
	 * no issue. In the second example, the `ngModel` value is `items[0].subItem` and the **`track by`**
	 * expression evaluates to `items[0].subItem.id` (which is undefined). As a result, the model value
	 * is not matched against any `<option>` and the `<select>` appears as having no selected value.
	 *
	 *
	 * @param {string} ngModel Assignable angular expression to data-bind to.
	 * @param {string=} name Property name of the form under which the control is published.
	 * @param {string=} required The control is considered valid only if value is entered.
	 * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	 *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	 *    `required` when you want to data-bind to the `required` attribute.
	 * @param {comprehension_expression=} ngOptions in one of the following forms:
	 *
	 *   * for array data sources:
	 *     * `label` **`for`** `value` **`in`** `array`
	 *     * `select` **`as`** `label` **`for`** `value` **`in`** `array`
	 *     * `label` **`group by`** `group` **`for`** `value` **`in`** `array`
	 *     * `label` **`disable when`** `disable` **`for`** `value` **`in`** `array`
	 *     * `label` **`group by`** `group` **`for`** `value` **`in`** `array` **`track by`** `trackexpr`
	 *     * `label` **`disable when`** `disable` **`for`** `value` **`in`** `array` **`track by`** `trackexpr`
	 *     * `label` **`for`** `value` **`in`** `array` | orderBy:`orderexpr` **`track by`** `trackexpr`
	 *        (for including a filter with `track by`)
	 *   * for object data sources:
	 *     * `label` **`for (`**`key` **`,`** `value`**`) in`** `object`
	 *     * `select` **`as`** `label` **`for (`**`key` **`,`** `value`**`) in`** `object`
	 *     * `label` **`group by`** `group` **`for (`**`key`**`,`** `value`**`) in`** `object`
	 *     * `label` **`disable when`** `disable` **`for (`**`key`**`,`** `value`**`) in`** `object`
	 *     * `select` **`as`** `label` **`group by`** `group`
	 *         **`for` `(`**`key`**`,`** `value`**`) in`** `object`
	 *     * `select` **`as`** `label` **`disable when`** `disable`
	 *         **`for` `(`**`key`**`,`** `value`**`) in`** `object`
	 *
	 * Where:
	 *
	 *   * `array` / `object`: an expression which evaluates to an array / object to iterate over.
	 *   * `value`: local variable which will refer to each item in the `array` or each property value
	 *      of `object` during iteration.
	 *   * `key`: local variable which will refer to a property name in `object` during iteration.
	 *   * `label`: The result of this expression will be the label for `<option>` element. The
	 *     `expression` will most likely refer to the `value` variable (e.g. `value.propertyName`).
	 *   * `select`: The result of this expression will be bound to the model of the parent `<select>`
	 *      element. If not specified, `select` expression will default to `value`.
	 *   * `group`: The result of this expression will be used to group options using the `<optgroup>`
	 *      DOM element.
	 *   * `disable`: The result of this expression will be used to disable the rendered `<option>`
	 *      element. Return `true` to disable.
	 *   * `trackexpr`: Used when working with an array of objects. The result of this expression will be
	 *      used to identify the objects in the array. The `trackexpr` will most likely refer to the
	 *     `value` variable (e.g. `value.propertyName`). With this the selection is preserved
	 *      even when the options are recreated (e.g. reloaded from the server).
	 *
	 * @example
	    <example module="selectExample">
	      <file name="index.html">
	        <script>
	        angular.module('selectExample', [])
	          .controller('ExampleController', ['$scope', function($scope) {
	            $scope.colors = [
	              {name:'black', shade:'dark'},
	              {name:'white', shade:'light', notAnOption: true},
	              {name:'red', shade:'dark'},
	              {name:'blue', shade:'dark', notAnOption: true},
	              {name:'yellow', shade:'light', notAnOption: false}
	            ];
	            $scope.myColor = $scope.colors[2]; // red
	          }]);
	        </script>
	        <div ng-controller="ExampleController">
	          <ul>
	            <li ng-repeat="color in colors">
	              <label>Name: <input ng-model="color.name"></label>
	              <label><input type="checkbox" ng-model="color.notAnOption"> Disabled?</label>
	              <button ng-click="colors.splice($index, 1)" aria-label="Remove">X</button>
	            </li>
	            <li>
	              <button ng-click="colors.push({})">add</button>
	            </li>
	          </ul>
	          <hr/>
	          <label>Color (null not allowed):
	            <select ng-model="myColor" ng-options="color.name for color in colors"></select>
	          </label><br/>
	          <label>Color (null allowed):
	          <span  class="nullable">
	            <select ng-model="myColor" ng-options="color.name for color in colors">
	              <option value="">-- choose color --</option>
	            </select>
	          </span></label><br/>
	
	          <label>Color grouped by shade:
	            <select ng-model="myColor" ng-options="color.name group by color.shade for color in colors">
	            </select>
	          </label><br/>
	
	          <label>Color grouped by shade, with some disabled:
	            <select ng-model="myColor"
	                  ng-options="color.name group by color.shade disable when color.notAnOption for color in colors">
	            </select>
	          </label><br/>
	
	
	
	          Select <button ng-click="myColor = { name:'not in list', shade: 'other' }">bogus</button>.
	          <br/>
	          <hr/>
	          Currently selected: {{ {selected_color:myColor} }}
	          <div style="border:solid 1px black; height:20px"
	               ng-style="{'background-color':myColor.name}">
	          </div>
	        </div>
	      </file>
	      <file name="protractor.js" type="protractor">
	         it('should check ng-options', function() {
	           expect(element(by.binding('{selected_color:myColor}')).getText()).toMatch('red');
	           element.all(by.model('myColor')).first().click();
	           element.all(by.css('select[ng-model="myColor"] option')).first().click();
	           expect(element(by.binding('{selected_color:myColor}')).getText()).toMatch('black');
	           element(by.css('.nullable select[ng-model="myColor"]')).click();
	           element.all(by.css('.nullable select[ng-model="myColor"] option')).first().click();
	           expect(element(by.binding('{selected_color:myColor}')).getText()).toMatch('null');
	         });
	      </file>
	    </example>
	 */
	
	// jshint maxlen: false
	//                     //00001111111111000000000002222222222000000000000000000000333333333300000000000000000000000004444444444400000000000005555555555555550000000006666666666666660000000777777777777777000000000000000888888888800000000000000000009999999999
	var NG_OPTIONS_REGEXP = /^\s*([\s\S]+?)(?:\s+as\s+([\s\S]+?))?(?:\s+group\s+by\s+([\s\S]+?))?(?:\s+disable\s+when\s+([\s\S]+?))?\s+for\s+(?:([\$\w][\$\w]*)|(?:\(\s*([\$\w][\$\w]*)\s*,\s*([\$\w][\$\w]*)\s*\)))\s+in\s+([\s\S]+?)(?:\s+track\s+by\s+([\s\S]+?))?$/;
	                        // 1: value expression (valueFn)
	                        // 2: label expression (displayFn)
	                        // 3: group by expression (groupByFn)
	                        // 4: disable when expression (disableWhenFn)
	                        // 5: array item variable name
	                        // 6: object item key variable name
	                        // 7: object item value variable name
	                        // 8: collection expression
	                        // 9: track by expression
	// jshint maxlen: 100
	
	
	var ngOptionsDirective = ['$compile', '$document', '$parse', function($compile, $document, $parse) {
	
	  function parseOptionsExpression(optionsExp, selectElement, scope) {
	
	    var match = optionsExp.match(NG_OPTIONS_REGEXP);
	    if (!(match)) {
	      throw ngOptionsMinErr('iexp',
	        "Expected expression in form of " +
	        "'_select_ (as _label_)? for (_key_,)?_value_ in _collection_'" +
	        " but got '{0}'. Element: {1}",
	        optionsExp, startingTag(selectElement));
	    }
	
	    // Extract the parts from the ngOptions expression
	
	    // The variable name for the value of the item in the collection
	    var valueName = match[5] || match[7];
	    // The variable name for the key of the item in the collection
	    var keyName = match[6];
	
	    // An expression that generates the viewValue for an option if there is a label expression
	    var selectAs = / as /.test(match[0]) && match[1];
	    // An expression that is used to track the id of each object in the options collection
	    var trackBy = match[9];
	    // An expression that generates the viewValue for an option if there is no label expression
	    var valueFn = $parse(match[2] ? match[1] : valueName);
	    var selectAsFn = selectAs && $parse(selectAs);
	    var viewValueFn = selectAsFn || valueFn;
	    var trackByFn = trackBy && $parse(trackBy);
	
	    // Get the value by which we are going to track the option
	    // if we have a trackFn then use that (passing scope and locals)
	    // otherwise just hash the given viewValue
	    var getTrackByValueFn = trackBy ?
	                              function(value, locals) { return trackByFn(scope, locals); } :
	                              function getHashOfValue(value) { return hashKey(value); };
	    var getTrackByValue = function(value, key) {
	      return getTrackByValueFn(value, getLocals(value, key));
	    };
	
	    var displayFn = $parse(match[2] || match[1]);
	    var groupByFn = $parse(match[3] || '');
	    var disableWhenFn = $parse(match[4] || '');
	    var valuesFn = $parse(match[8]);
	
	    var locals = {};
	    var getLocals = keyName ? function(value, key) {
	      locals[keyName] = key;
	      locals[valueName] = value;
	      return locals;
	    } : function(value) {
	      locals[valueName] = value;
	      return locals;
	    };
	
	
	    function Option(selectValue, viewValue, label, group, disabled) {
	      this.selectValue = selectValue;
	      this.viewValue = viewValue;
	      this.label = label;
	      this.group = group;
	      this.disabled = disabled;
	    }
	
	    function getOptionValuesKeys(optionValues) {
	      var optionValuesKeys;
	
	      if (!keyName && isArrayLike(optionValues)) {
	        optionValuesKeys = optionValues;
	      } else {
	        // if object, extract keys, in enumeration order, unsorted
	        optionValuesKeys = [];
	        for (var itemKey in optionValues) {
	          if (optionValues.hasOwnProperty(itemKey) && itemKey.charAt(0) !== '$') {
	            optionValuesKeys.push(itemKey);
	          }
	        }
	      }
	      return optionValuesKeys;
	    }
	
	    return {
	      trackBy: trackBy,
	      getTrackByValue: getTrackByValue,
	      getWatchables: $parse(valuesFn, function(optionValues) {
	        // Create a collection of things that we would like to watch (watchedArray)
	        // so that they can all be watched using a single $watchCollection
	        // that only runs the handler once if anything changes
	        var watchedArray = [];
	        optionValues = optionValues || [];
	
	        var optionValuesKeys = getOptionValuesKeys(optionValues);
	        var optionValuesLength = optionValuesKeys.length;
	        for (var index = 0; index < optionValuesLength; index++) {
	          var key = (optionValues === optionValuesKeys) ? index : optionValuesKeys[index];
	          var value = optionValues[key];
	
	          var locals = getLocals(value, key);
	          var selectValue = getTrackByValueFn(value, locals);
	          watchedArray.push(selectValue);
	
	          // Only need to watch the displayFn if there is a specific label expression
	          if (match[2] || match[1]) {
	            var label = displayFn(scope, locals);
	            watchedArray.push(label);
	          }
	
	          // Only need to watch the disableWhenFn if there is a specific disable expression
	          if (match[4]) {
	            var disableWhen = disableWhenFn(scope, locals);
	            watchedArray.push(disableWhen);
	          }
	        }
	        return watchedArray;
	      }),
	
	      getOptions: function() {
	
	        var optionItems = [];
	        var selectValueMap = {};
	
	        // The option values were already computed in the `getWatchables` fn,
	        // which must have been called to trigger `getOptions`
	        var optionValues = valuesFn(scope) || [];
	        var optionValuesKeys = getOptionValuesKeys(optionValues);
	        var optionValuesLength = optionValuesKeys.length;
	
	        for (var index = 0; index < optionValuesLength; index++) {
	          var key = (optionValues === optionValuesKeys) ? index : optionValuesKeys[index];
	          var value = optionValues[key];
	          var locals = getLocals(value, key);
	          var viewValue = viewValueFn(scope, locals);
	          var selectValue = getTrackByValueFn(viewValue, locals);
	          var label = displayFn(scope, locals);
	          var group = groupByFn(scope, locals);
	          var disabled = disableWhenFn(scope, locals);
	          var optionItem = new Option(selectValue, viewValue, label, group, disabled);
	
	          optionItems.push(optionItem);
	          selectValueMap[selectValue] = optionItem;
	        }
	
	        return {
	          items: optionItems,
	          selectValueMap: selectValueMap,
	          getOptionFromViewValue: function(value) {
	            return selectValueMap[getTrackByValue(value)];
	          },
	          getViewValueFromOption: function(option) {
	            // If the viewValue could be an object that may be mutated by the application,
	            // we need to make a copy and not return the reference to the value on the option.
	            return trackBy ? angular.copy(option.viewValue) : option.viewValue;
	          }
	        };
	      }
	    };
	  }
	
	
	  // we can't just jqLite('<option>') since jqLite is not smart enough
	  // to create it in <select> and IE barfs otherwise.
	  var optionTemplate = window.document.createElement('option'),
	      optGroupTemplate = window.document.createElement('optgroup');
	
	    function ngOptionsPostLink(scope, selectElement, attr, ctrls) {
	
	      var selectCtrl = ctrls[0];
	      var ngModelCtrl = ctrls[1];
	      var multiple = attr.multiple;
	
	      // The emptyOption allows the application developer to provide their own custom "empty"
	      // option when the viewValue does not match any of the option values.
	      var emptyOption;
	      for (var i = 0, children = selectElement.children(), ii = children.length; i < ii; i++) {
	        if (children[i].value === '') {
	          emptyOption = children.eq(i);
	          break;
	        }
	      }
	
	      var providedEmptyOption = !!emptyOption;
	
	      var unknownOption = jqLite(optionTemplate.cloneNode(false));
	      unknownOption.val('?');
	
	      var options;
	      var ngOptions = parseOptionsExpression(attr.ngOptions, selectElement, scope);
	      // This stores the newly created options before they are appended to the select.
	      // Since the contents are removed from the fragment when it is appended,
	      // we only need to create it once.
	      var listFragment = $document[0].createDocumentFragment();
	
	      var renderEmptyOption = function() {
	        if (!providedEmptyOption) {
	          selectElement.prepend(emptyOption);
	        }
	        selectElement.val('');
	        emptyOption.prop('selected', true); // needed for IE
	        emptyOption.attr('selected', true);
	      };
	
	      var removeEmptyOption = function() {
	        if (!providedEmptyOption) {
	          emptyOption.remove();
	        }
	      };
	
	
	      var renderUnknownOption = function() {
	        selectElement.prepend(unknownOption);
	        selectElement.val('?');
	        unknownOption.prop('selected', true); // needed for IE
	        unknownOption.attr('selected', true);
	      };
	
	      var removeUnknownOption = function() {
	        unknownOption.remove();
	      };
	
	      // Update the controller methods for multiple selectable options
	      if (!multiple) {
	
	        selectCtrl.writeValue = function writeNgOptionsValue(value) {
	          var option = options.getOptionFromViewValue(value);
	
	          if (option) {
	            // Don't update the option when it is already selected.
	            // For example, the browser will select the first option by default. In that case,
	            // most properties are set automatically - except the `selected` attribute, which we
	            // set always
	
	            if (selectElement[0].value !== option.selectValue) {
	              removeUnknownOption();
	              removeEmptyOption();
	
	              selectElement[0].value = option.selectValue;
	              option.element.selected = true;
	            }
	
	            option.element.setAttribute('selected', 'selected');
	          } else {
	            if (value === null || providedEmptyOption) {
	              removeUnknownOption();
	              renderEmptyOption();
	            } else {
	              removeEmptyOption();
	              renderUnknownOption();
	            }
	          }
	        };
	
	        selectCtrl.readValue = function readNgOptionsValue() {
	
	          var selectedOption = options.selectValueMap[selectElement.val()];
	
	          if (selectedOption && !selectedOption.disabled) {
	            removeEmptyOption();
	            removeUnknownOption();
	            return options.getViewValueFromOption(selectedOption);
	          }
	          return null;
	        };
	
	        // If we are using `track by` then we must watch the tracked value on the model
	        // since ngModel only watches for object identity change
	        if (ngOptions.trackBy) {
	          scope.$watch(
	            function() { return ngOptions.getTrackByValue(ngModelCtrl.$viewValue); },
	            function() { ngModelCtrl.$render(); }
	          );
	        }
	
	      } else {
	
	        ngModelCtrl.$isEmpty = function(value) {
	          return !value || value.length === 0;
	        };
	
	
	        selectCtrl.writeValue = function writeNgOptionsMultiple(value) {
	          options.items.forEach(function(option) {
	            option.element.selected = false;
	          });
	
	          if (value) {
	            value.forEach(function(item) {
	              var option = options.getOptionFromViewValue(item);
	              if (option) option.element.selected = true;
	            });
	          }
	        };
	
	
	        selectCtrl.readValue = function readNgOptionsMultiple() {
	          var selectedValues = selectElement.val() || [],
	              selections = [];
	
	          forEach(selectedValues, function(value) {
	            var option = options.selectValueMap[value];
	            if (option && !option.disabled) selections.push(options.getViewValueFromOption(option));
	          });
	
	          return selections;
	        };
	
	        // If we are using `track by` then we must watch these tracked values on the model
	        // since ngModel only watches for object identity change
	        if (ngOptions.trackBy) {
	
	          scope.$watchCollection(function() {
	            if (isArray(ngModelCtrl.$viewValue)) {
	              return ngModelCtrl.$viewValue.map(function(value) {
	                return ngOptions.getTrackByValue(value);
	              });
	            }
	          }, function() {
	            ngModelCtrl.$render();
	          });
	
	        }
	      }
	
	
	      if (providedEmptyOption) {
	
	        // we need to remove it before calling selectElement.empty() because otherwise IE will
	        // remove the label from the element. wtf?
	        emptyOption.remove();
	
	        // compile the element since there might be bindings in it
	        $compile(emptyOption)(scope);
	
	        // remove the class, which is added automatically because we recompile the element and it
	        // becomes the compilation root
	        emptyOption.removeClass('ng-scope');
	      } else {
	        emptyOption = jqLite(optionTemplate.cloneNode(false));
	      }
	
	      selectElement.empty();
	
	      // We need to do this here to ensure that the options object is defined
	      // when we first hit it in writeNgOptionsValue
	      updateOptions();
	
	      // We will re-render the option elements if the option values or labels change
	      scope.$watchCollection(ngOptions.getWatchables, updateOptions);
	
	      // ------------------------------------------------------------------ //
	
	      function addOptionElement(option, parent) {
	        var optionElement = optionTemplate.cloneNode(false);
	        parent.appendChild(optionElement);
	        updateOptionElement(option, optionElement);
	      }
	
	
	      function updateOptionElement(option, element) {
	        option.element = element;
	        element.disabled = option.disabled;
	        // NOTE: The label must be set before the value, otherwise IE10/11/EDGE create unresponsive
	        // selects in certain circumstances when multiple selects are next to each other and display
	        // the option list in listbox style, i.e. the select is [multiple], or specifies a [size].
	        // See https://github.com/angular/angular.js/issues/11314 for more info.
	        // This is unfortunately untestable with unit / e2e tests
	        if (option.label !== element.label) {
	          element.label = option.label;
	          element.textContent = option.label;
	        }
	        if (option.value !== element.value) element.value = option.selectValue;
	      }
	
	      function updateOptions() {
	        var previousValue = options && selectCtrl.readValue();
	
	        // We must remove all current options, but cannot simply set innerHTML = null
	        // since the providedEmptyOption might have an ngIf on it that inserts comments which we
	        // must preserve.
	        // Instead, iterate over the current option elements and remove them or their optgroup
	        // parents
	        if (options) {
	
	          for (var i = options.items.length - 1; i >= 0; i--) {
	            var option = options.items[i];
	            if (option.group) {
	              jqLiteRemove(option.element.parentNode);
	            } else {
	              jqLiteRemove(option.element);
	            }
	          }
	        }
	
	        options = ngOptions.getOptions();
	
	        var groupElementMap = {};
	
	        // Ensure that the empty option is always there if it was explicitly provided
	        if (providedEmptyOption) {
	          selectElement.prepend(emptyOption);
	        }
	
	        options.items.forEach(function addOption(option) {
	          var groupElement;
	
	          if (isDefined(option.group)) {
	
	            // This option is to live in a group
	            // See if we have already created this group
	            groupElement = groupElementMap[option.group];
	
	            if (!groupElement) {
	
	              groupElement = optGroupTemplate.cloneNode(false);
	              listFragment.appendChild(groupElement);
	
	              // Update the label on the group element
	              groupElement.label = option.group;
	
	              // Store it for use later
	              groupElementMap[option.group] = groupElement;
	            }
	
	            addOptionElement(option, groupElement);
	
	          } else {
	
	            // This option is not in a group
	            addOptionElement(option, listFragment);
	          }
	        });
	
	        selectElement[0].appendChild(listFragment);
	
	        ngModelCtrl.$render();
	
	        // Check to see if the value has changed due to the update to the options
	        if (!ngModelCtrl.$isEmpty(previousValue)) {
	          var nextValue = selectCtrl.readValue();
	          var isNotPrimitive = ngOptions.trackBy || multiple;
	          if (isNotPrimitive ? !equals(previousValue, nextValue) : previousValue !== nextValue) {
	            ngModelCtrl.$setViewValue(nextValue);
	            ngModelCtrl.$render();
	          }
	        }
	
	      }
	  }
	
	  return {
	    restrict: 'A',
	    terminal: true,
	    require: ['select', 'ngModel'],
	    link: {
	      pre: function ngOptionsPreLink(scope, selectElement, attr, ctrls) {
	        // Deactivate the SelectController.register method to prevent
	        // option directives from accidentally registering themselves
	        // (and unwanted $destroy handlers etc.)
	        ctrls[0].registerOption = noop;
	      },
	      post: ngOptionsPostLink
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngPluralize
	 * @restrict EA
	 *
	 * @description
	 * `ngPluralize` is a directive that displays messages according to en-US localization rules.
	 * These rules are bundled with angular.js, but can be overridden
	 * (see {@link guide/i18n Angular i18n} dev guide). You configure ngPluralize directive
	 * by specifying the mappings between
	 * [plural categories](http://unicode.org/repos/cldr-tmp/trunk/diff/supplemental/language_plural_rules.html)
	 * and the strings to be displayed.
	 *
	 * # Plural categories and explicit number rules
	 * There are two
	 * [plural categories](http://unicode.org/repos/cldr-tmp/trunk/diff/supplemental/language_plural_rules.html)
	 * in Angular's default en-US locale: "one" and "other".
	 *
	 * While a plural category may match many numbers (for example, in en-US locale, "other" can match
	 * any number that is not 1), an explicit number rule can only match one number. For example, the
	 * explicit number rule for "3" matches the number 3. There are examples of plural categories
	 * and explicit number rules throughout the rest of this documentation.
	 *
	 * # Configuring ngPluralize
	 * You configure ngPluralize by providing 2 attributes: `count` and `when`.
	 * You can also provide an optional attribute, `offset`.
	 *
	 * The value of the `count` attribute can be either a string or an {@link guide/expression
	 * Angular expression}; these are evaluated on the current scope for its bound value.
	 *
	 * The `when` attribute specifies the mappings between plural categories and the actual
	 * string to be displayed. The value of the attribute should be a JSON object.
	 *
	 * The following example shows how to configure ngPluralize:
	 *
	 * ```html
	 * <ng-pluralize count="personCount"
	                 when="{'0': 'Nobody is viewing.',
	 *                      'one': '1 person is viewing.',
	 *                      'other': '{} people are viewing.'}">
	 * </ng-pluralize>
	 *```
	 *
	 * In the example, `"0: Nobody is viewing."` is an explicit number rule. If you did not
	 * specify this rule, 0 would be matched to the "other" category and "0 people are viewing"
	 * would be shown instead of "Nobody is viewing". You can specify an explicit number rule for
	 * other numbers, for example 12, so that instead of showing "12 people are viewing", you can
	 * show "a dozen people are viewing".
	 *
	 * You can use a set of closed braces (`{}`) as a placeholder for the number that you want substituted
	 * into pluralized strings. In the previous example, Angular will replace `{}` with
	 * <span ng-non-bindable>`{{personCount}}`</span>. The closed braces `{}` is a placeholder
	 * for <span ng-non-bindable>{{numberExpression}}</span>.
	 *
	 * If no rule is defined for a category, then an empty string is displayed and a warning is generated.
	 * Note that some locales define more categories than `one` and `other`. For example, fr-fr defines `few` and `many`.
	 *
	 * # Configuring ngPluralize with offset
	 * The `offset` attribute allows further customization of pluralized text, which can result in
	 * a better user experience. For example, instead of the message "4 people are viewing this document",
	 * you might display "John, Kate and 2 others are viewing this document".
	 * The offset attribute allows you to offset a number by any desired value.
	 * Let's take a look at an example:
	 *
	 * ```html
	 * <ng-pluralize count="personCount" offset=2
	 *               when="{'0': 'Nobody is viewing.',
	 *                      '1': '{{person1}} is viewing.',
	 *                      '2': '{{person1}} and {{person2}} are viewing.',
	 *                      'one': '{{person1}}, {{person2}} and one other person are viewing.',
	 *                      'other': '{{person1}}, {{person2}} and {} other people are viewing.'}">
	 * </ng-pluralize>
	 * ```
	 *
	 * Notice that we are still using two plural categories(one, other), but we added
	 * three explicit number rules 0, 1 and 2.
	 * When one person, perhaps John, views the document, "John is viewing" will be shown.
	 * When three people view the document, no explicit number rule is found, so
	 * an offset of 2 is taken off 3, and Angular uses 1 to decide the plural category.
	 * In this case, plural category 'one' is matched and "John, Mary and one other person are viewing"
	 * is shown.
	 *
	 * Note that when you specify offsets, you must provide explicit number rules for
	 * numbers from 0 up to and including the offset. If you use an offset of 3, for example,
	 * you must provide explicit number rules for 0, 1, 2 and 3. You must also provide plural strings for
	 * plural categories "one" and "other".
	 *
	 * @param {string|expression} count The variable to be bound to.
	 * @param {string} when The mapping between plural category to its corresponding strings.
	 * @param {number=} offset Offset to deduct from the total number.
	 *
	 * @example
	    <example module="pluralizeExample">
	      <file name="index.html">
	        <script>
	          angular.module('pluralizeExample', [])
	            .controller('ExampleController', ['$scope', function($scope) {
	              $scope.person1 = 'Igor';
	              $scope.person2 = 'Misko';
	              $scope.personCount = 1;
	            }]);
	        </script>
	        <div ng-controller="ExampleController">
	          <label>Person 1:<input type="text" ng-model="person1" value="Igor" /></label><br/>
	          <label>Person 2:<input type="text" ng-model="person2" value="Misko" /></label><br/>
	          <label>Number of People:<input type="text" ng-model="personCount" value="1" /></label><br/>
	
	          <!--- Example with simple pluralization rules for en locale --->
	          Without Offset:
	          <ng-pluralize count="personCount"
	                        when="{'0': 'Nobody is viewing.',
	                               'one': '1 person is viewing.',
	                               'other': '{} people are viewing.'}">
	          </ng-pluralize><br>
	
	          <!--- Example with offset --->
	          With Offset(2):
	          <ng-pluralize count="personCount" offset=2
	                        when="{'0': 'Nobody is viewing.',
	                               '1': '{{person1}} is viewing.',
	                               '2': '{{person1}} and {{person2}} are viewing.',
	                               'one': '{{person1}}, {{person2}} and one other person are viewing.',
	                               'other': '{{person1}}, {{person2}} and {} other people are viewing.'}">
	          </ng-pluralize>
	        </div>
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should show correct pluralized string', function() {
	          var withoutOffset = element.all(by.css('ng-pluralize')).get(0);
	          var withOffset = element.all(by.css('ng-pluralize')).get(1);
	          var countInput = element(by.model('personCount'));
	
	          expect(withoutOffset.getText()).toEqual('1 person is viewing.');
	          expect(withOffset.getText()).toEqual('Igor is viewing.');
	
	          countInput.clear();
	          countInput.sendKeys('0');
	
	          expect(withoutOffset.getText()).toEqual('Nobody is viewing.');
	          expect(withOffset.getText()).toEqual('Nobody is viewing.');
	
	          countInput.clear();
	          countInput.sendKeys('2');
	
	          expect(withoutOffset.getText()).toEqual('2 people are viewing.');
	          expect(withOffset.getText()).toEqual('Igor and Misko are viewing.');
	
	          countInput.clear();
	          countInput.sendKeys('3');
	
	          expect(withoutOffset.getText()).toEqual('3 people are viewing.');
	          expect(withOffset.getText()).toEqual('Igor, Misko and one other person are viewing.');
	
	          countInput.clear();
	          countInput.sendKeys('4');
	
	          expect(withoutOffset.getText()).toEqual('4 people are viewing.');
	          expect(withOffset.getText()).toEqual('Igor, Misko and 2 other people are viewing.');
	        });
	        it('should show data-bound names', function() {
	          var withOffset = element.all(by.css('ng-pluralize')).get(1);
	          var personCount = element(by.model('personCount'));
	          var person1 = element(by.model('person1'));
	          var person2 = element(by.model('person2'));
	          personCount.clear();
	          personCount.sendKeys('4');
	          person1.clear();
	          person1.sendKeys('Di');
	          person2.clear();
	          person2.sendKeys('Vojta');
	          expect(withOffset.getText()).toEqual('Di, Vojta and 2 other people are viewing.');
	        });
	      </file>
	    </example>
	 */
	var ngPluralizeDirective = ['$locale', '$interpolate', '$log', function($locale, $interpolate, $log) {
	  var BRACE = /{}/g,
	      IS_WHEN = /^when(Minus)?(.+)$/;
	
	  return {
	    link: function(scope, element, attr) {
	      var numberExp = attr.count,
	          whenExp = attr.$attr.when && element.attr(attr.$attr.when), // we have {{}} in attrs
	          offset = attr.offset || 0,
	          whens = scope.$eval(whenExp) || {},
	          whensExpFns = {},
	          startSymbol = $interpolate.startSymbol(),
	          endSymbol = $interpolate.endSymbol(),
	          braceReplacement = startSymbol + numberExp + '-' + offset + endSymbol,
	          watchRemover = angular.noop,
	          lastCount;
	
	      forEach(attr, function(expression, attributeName) {
	        var tmpMatch = IS_WHEN.exec(attributeName);
	        if (tmpMatch) {
	          var whenKey = (tmpMatch[1] ? '-' : '') + lowercase(tmpMatch[2]);
	          whens[whenKey] = element.attr(attr.$attr[attributeName]);
	        }
	      });
	      forEach(whens, function(expression, key) {
	        whensExpFns[key] = $interpolate(expression.replace(BRACE, braceReplacement));
	
	      });
	
	      scope.$watch(numberExp, function ngPluralizeWatchAction(newVal) {
	        var count = parseFloat(newVal);
	        var countIsNaN = isNaN(count);
	
	        if (!countIsNaN && !(count in whens)) {
	          // If an explicit number rule such as 1, 2, 3... is defined, just use it.
	          // Otherwise, check it against pluralization rules in $locale service.
	          count = $locale.pluralCat(count - offset);
	        }
	
	        // If both `count` and `lastCount` are NaN, we don't need to re-register a watch.
	        // In JS `NaN !== NaN`, so we have to explicitly check.
	        if ((count !== lastCount) && !(countIsNaN && isNumber(lastCount) && isNaN(lastCount))) {
	          watchRemover();
	          var whenExpFn = whensExpFns[count];
	          if (isUndefined(whenExpFn)) {
	            if (newVal != null) {
	              $log.debug("ngPluralize: no rule defined for '" + count + "' in " + whenExp);
	            }
	            watchRemover = noop;
	            updateElementText();
	          } else {
	            watchRemover = scope.$watch(whenExpFn, updateElementText);
	          }
	          lastCount = count;
	        }
	      });
	
	      function updateElementText(newText) {
	        element.text(newText || '');
	      }
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngRepeat
	 * @multiElement
	 *
	 * @description
	 * The `ngRepeat` directive instantiates a template once per item from a collection. Each template
	 * instance gets its own scope, where the given loop variable is set to the current collection item,
	 * and `$index` is set to the item index or key.
	 *
	 * Special properties are exposed on the local scope of each template instance, including:
	 *
	 * | Variable  | Type            | Details                                                                     |
	 * |-----------|-----------------|-----------------------------------------------------------------------------|
	 * | `$index`  | {@type number}  | iterator offset of the repeated element (0..length-1)                       |
	 * | `$first`  | {@type boolean} | true if the repeated element is first in the iterator.                      |
	 * | `$middle` | {@type boolean} | true if the repeated element is between the first and last in the iterator. |
	 * | `$last`   | {@type boolean} | true if the repeated element is last in the iterator.                       |
	 * | `$even`   | {@type boolean} | true if the iterator position `$index` is even (otherwise false).           |
	 * | `$odd`    | {@type boolean} | true if the iterator position `$index` is odd (otherwise false).            |
	 *
	 * <div class="alert alert-info">
	 *   Creating aliases for these properties is possible with {@link ng.directive:ngInit `ngInit`}.
	 *   This may be useful when, for instance, nesting ngRepeats.
	 * </div>
	 *
	 *
	 * # Iterating over object properties
	 *
	 * It is possible to get `ngRepeat` to iterate over the properties of an object using the following
	 * syntax:
	 *
	 * ```js
	 * <div ng-repeat="(key, value) in myObj"> ... </div>
	 * ```
	 *
	 * However, there are a limitations compared to array iteration:
	 *
	 * - The JavaScript specification does not define the order of keys
	 *   returned for an object, so Angular relies on the order returned by the browser
	 *   when running `for key in myObj`. Browsers generally follow the strategy of providing
	 *   keys in the order in which they were defined, although there are exceptions when keys are deleted
	 *   and reinstated. See the
	 *   [MDN page on `delete` for more info](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/delete#Cross-browser_notes).
	 *
	 * - `ngRepeat` will silently *ignore* object keys starting with `$`, because
	 *   it's a prefix used by Angular for public (`$`) and private (`$$`) properties.
	 *
	 * - The built-in filters {@link ng.orderBy orderBy} and {@link ng.filter filter} do not work with
	 *   objects, and will throw if used with one.
	 *
	 * If you are hitting any of these limitations, the recommended workaround is to convert your object into an array
	 * that is sorted into the order that you prefer before providing it to `ngRepeat`. You could
	 * do this with a filter such as [toArrayFilter](http://ngmodules.org/modules/angular-toArrayFilter)
	 * or implement a `$watch` on the object yourself.
	 *
	 *
	 * # Tracking and Duplicates
	 *
	 * `ngRepeat` uses {@link $rootScope.Scope#$watchCollection $watchCollection} to detect changes in
	 * the collection. When a change happens, ngRepeat then makes the corresponding changes to the DOM:
	 *
	 * * When an item is added, a new instance of the template is added to the DOM.
	 * * When an item is removed, its template instance is removed from the DOM.
	 * * When items are reordered, their respective templates are reordered in the DOM.
	 *
	 * To minimize creation of DOM elements, `ngRepeat` uses a function
	 * to "keep track" of all items in the collection and their corresponding DOM elements.
	 * For example, if an item is added to the collection, ngRepeat will know that all other items
	 * already have DOM elements, and will not re-render them.
	 *
	 * The default tracking function (which tracks items by their identity) does not allow
	 * duplicate items in arrays. This is because when there are duplicates, it is not possible
	 * to maintain a one-to-one mapping between collection items and DOM elements.
	 *
	 * If you do need to repeat duplicate items, you can substitute the default tracking behavior
	 * with your own using the `track by` expression.
	 *
	 * For example, you may track items by the index of each item in the collection, using the
	 * special scope property `$index`:
	 * ```html
	 *    <div ng-repeat="n in [42, 42, 43, 43] track by $index">
	 *      {{n}}
	 *    </div>
	 * ```
	 *
	 * You may also use arbitrary expressions in `track by`, including references to custom functions
	 * on the scope:
	 * ```html
	 *    <div ng-repeat="n in [42, 42, 43, 43] track by myTrackingFunction(n)">
	 *      {{n}}
	 *    </div>
	 * ```
	 *
	 * <div class="alert alert-success">
	 * If you are working with objects that have an identifier property, you should track
	 * by the identifier instead of the whole object. Should you reload your data later, `ngRepeat`
	 * will not have to rebuild the DOM elements for items it has already rendered, even if the
	 * JavaScript objects in the collection have been substituted for new ones. For large collections,
	 * this significantly improves rendering performance. If you don't have a unique identifier,
	 * `track by $index` can also provide a performance boost.
	 * </div>
	 * ```html
	 *    <div ng-repeat="model in collection track by model.id">
	 *      {{model.name}}
	 *    </div>
	 * ```
	 *
	 * When no `track by` expression is provided, it is equivalent to tracking by the built-in
	 * `$id` function, which tracks items by their identity:
	 * ```html
	 *    <div ng-repeat="obj in collection track by $id(obj)">
	 *      {{obj.prop}}
	 *    </div>
	 * ```
	 *
	 * <div class="alert alert-warning">
	 * **Note:** `track by` must always be the last expression:
	 * </div>
	 * ```
	 * <div ng-repeat="model in collection | orderBy: 'id' as filtered_result track by model.id">
	 *     {{model.name}}
	 * </div>
	 * ```
	 *
	 * # Special repeat start and end points
	 * To repeat a series of elements instead of just one parent element, ngRepeat (as well as other ng directives) supports extending
	 * the range of the repeater by defining explicit start and end points by using **ng-repeat-start** and **ng-repeat-end** respectively.
	 * The **ng-repeat-start** directive works the same as **ng-repeat**, but will repeat all the HTML code (including the tag it's defined on)
	 * up to and including the ending HTML tag where **ng-repeat-end** is placed.
	 *
	 * The example below makes use of this feature:
	 * ```html
	 *   <header ng-repeat-start="item in items">
	 *     Header {{ item }}
	 *   </header>
	 *   <div class="body">
	 *     Body {{ item }}
	 *   </div>
	 *   <footer ng-repeat-end>
	 *     Footer {{ item }}
	 *   </footer>
	 * ```
	 *
	 * And with an input of {@type ['A','B']} for the items variable in the example above, the output will evaluate to:
	 * ```html
	 *   <header>
	 *     Header A
	 *   </header>
	 *   <div class="body">
	 *     Body A
	 *   </div>
	 *   <footer>
	 *     Footer A
	 *   </footer>
	 *   <header>
	 *     Header B
	 *   </header>
	 *   <div class="body">
	 *     Body B
	 *   </div>
	 *   <footer>
	 *     Footer B
	 *   </footer>
	 * ```
	 *
	 * The custom start and end points for ngRepeat also support all other HTML directive syntax flavors provided in AngularJS (such
	 * as **data-ng-repeat-start**, **x-ng-repeat-start** and **ng:repeat-start**).
	 *
	 * @animations
	 * | Animation                        | Occurs                              |
	 * |----------------------------------|-------------------------------------|
	 * | {@link ng.$animate#enter enter} | when a new item is added to the list or when an item is revealed after a filter |
	 * | {@link ng.$animate#leave leave} | when an item is removed from the list or when an item is filtered out |
	 * | {@link ng.$animate#move move } | when an adjacent item is filtered out causing a reorder or when the item contents are reordered |
	 *
	 * See the example below for defining CSS animations with ngRepeat.
	 *
	 * @element ANY
	 * @scope
	 * @priority 1000
	 * @param {repeat_expression} ngRepeat The expression indicating how to enumerate a collection. These
	 *   formats are currently supported:
	 *
	 *   * `variable in expression` – where variable is the user defined loop variable and `expression`
	 *     is a scope expression giving the collection to enumerate.
	 *
	 *     For example: `album in artist.albums`.
	 *
	 *   * `(key, value) in expression` – where `key` and `value` can be any user defined identifiers,
	 *     and `expression` is the scope expression giving the collection to enumerate.
	 *
	 *     For example: `(name, age) in {'adam':10, 'amalie':12}`.
	 *
	 *   * `variable in expression track by tracking_expression` – You can also provide an optional tracking expression
	 *     which can be used to associate the objects in the collection with the DOM elements. If no tracking expression
	 *     is specified, ng-repeat associates elements by identity. It is an error to have
	 *     more than one tracking expression value resolve to the same key. (This would mean that two distinct objects are
	 *     mapped to the same DOM element, which is not possible.)
	 *
	 *     Note that the tracking expression must come last, after any filters, and the alias expression.
	 *
	 *     For example: `item in items` is equivalent to `item in items track by $id(item)`. This implies that the DOM elements
	 *     will be associated by item identity in the array.
	 *
	 *     For example: `item in items track by $id(item)`. A built in `$id()` function can be used to assign a unique
	 *     `$$hashKey` property to each item in the array. This property is then used as a key to associated DOM elements
	 *     with the corresponding item in the array by identity. Moving the same object in array would move the DOM
	 *     element in the same way in the DOM.
	 *
	 *     For example: `item in items track by item.id` is a typical pattern when the items come from the database. In this
	 *     case the object identity does not matter. Two objects are considered equivalent as long as their `id`
	 *     property is same.
	 *
	 *     For example: `item in items | filter:searchText track by item.id` is a pattern that might be used to apply a filter
	 *     to items in conjunction with a tracking expression.
	 *
	 *   * `variable in expression as alias_expression` – You can also provide an optional alias expression which will then store the
	 *     intermediate results of the repeater after the filters have been applied. Typically this is used to render a special message
	 *     when a filter is active on the repeater, but the filtered result set is empty.
	 *
	 *     For example: `item in items | filter:x as results` will store the fragment of the repeated items as `results`, but only after
	 *     the items have been processed through the filter.
	 *
	 *     Please note that `as [variable name] is not an operator but rather a part of ngRepeat micro-syntax so it can be used only at the end
	 *     (and not as operator, inside an expression).
	 *
	 *     For example: `item in items | filter : x | orderBy : order | limitTo : limit as results` .
	 *
	 * @example
	 * This example uses `ngRepeat` to display a list of people. A filter is used to restrict the displayed
	 * results by name. New (entering) and removed (leaving) items are animated.
	  <example module="ngRepeat" name="ngRepeat" deps="angular-animate.js" animations="true">
	    <file name="index.html">
	      <div ng-controller="repeatController">
	        I have {{friends.length}} friends. They are:
	        <input type="search" ng-model="q" placeholder="filter friends..." aria-label="filter friends" />
	        <ul class="example-animate-container">
	          <li class="animate-repeat" ng-repeat="friend in friends | filter:q as results">
	            [{{$index + 1}}] {{friend.name}} who is {{friend.age}} years old.
	          </li>
	          <li class="animate-repeat" ng-if="results.length == 0">
	            <strong>No results found...</strong>
	          </li>
	        </ul>
	      </div>
	    </file>
	    <file name="script.js">
	      angular.module('ngRepeat', ['ngAnimate']).controller('repeatController', function($scope) {
	        $scope.friends = [
	          {name:'John', age:25, gender:'boy'},
	          {name:'Jessie', age:30, gender:'girl'},
	          {name:'Johanna', age:28, gender:'girl'},
	          {name:'Joy', age:15, gender:'girl'},
	          {name:'Mary', age:28, gender:'girl'},
	          {name:'Peter', age:95, gender:'boy'},
	          {name:'Sebastian', age:50, gender:'boy'},
	          {name:'Erika', age:27, gender:'girl'},
	          {name:'Patrick', age:40, gender:'boy'},
	          {name:'Samantha', age:60, gender:'girl'}
	        ];
	      });
	    </file>
	    <file name="animations.css">
	      .example-animate-container {
	        background:white;
	        border:1px solid black;
	        list-style:none;
	        margin:0;
	        padding:0 10px;
	      }
	
	      .animate-repeat {
	        line-height:30px;
	        list-style:none;
	        box-sizing:border-box;
	      }
	
	      .animate-repeat.ng-move,
	      .animate-repeat.ng-enter,
	      .animate-repeat.ng-leave {
	        transition:all linear 0.5s;
	      }
	
	      .animate-repeat.ng-leave.ng-leave-active,
	      .animate-repeat.ng-move,
	      .animate-repeat.ng-enter {
	        opacity:0;
	        max-height:0;
	      }
	
	      .animate-repeat.ng-leave,
	      .animate-repeat.ng-move.ng-move-active,
	      .animate-repeat.ng-enter.ng-enter-active {
	        opacity:1;
	        max-height:30px;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      var friends = element.all(by.repeater('friend in friends'));
	
	      it('should render initial data set', function() {
	        expect(friends.count()).toBe(10);
	        expect(friends.get(0).getText()).toEqual('[1] John who is 25 years old.');
	        expect(friends.get(1).getText()).toEqual('[2] Jessie who is 30 years old.');
	        expect(friends.last().getText()).toEqual('[10] Samantha who is 60 years old.');
	        expect(element(by.binding('friends.length')).getText())
	            .toMatch("I have 10 friends. They are:");
	      });
	
	       it('should update repeater when filter predicate changes', function() {
	         expect(friends.count()).toBe(10);
	
	         element(by.model('q')).sendKeys('ma');
	
	         expect(friends.count()).toBe(2);
	         expect(friends.get(0).getText()).toEqual('[1] Mary who is 28 years old.');
	         expect(friends.last().getText()).toEqual('[2] Samantha who is 60 years old.');
	       });
	      </file>
	    </example>
	 */
	var ngRepeatDirective = ['$parse', '$animate', '$compile', function($parse, $animate, $compile) {
	  var NG_REMOVED = '$$NG_REMOVED';
	  var ngRepeatMinErr = minErr('ngRepeat');
	
	  var updateScope = function(scope, index, valueIdentifier, value, keyIdentifier, key, arrayLength) {
	    // TODO(perf): generate setters to shave off ~40ms or 1-1.5%
	    scope[valueIdentifier] = value;
	    if (keyIdentifier) scope[keyIdentifier] = key;
	    scope.$index = index;
	    scope.$first = (index === 0);
	    scope.$last = (index === (arrayLength - 1));
	    scope.$middle = !(scope.$first || scope.$last);
	    // jshint bitwise: false
	    scope.$odd = !(scope.$even = (index&1) === 0);
	    // jshint bitwise: true
	  };
	
	  var getBlockStart = function(block) {
	    return block.clone[0];
	  };
	
	  var getBlockEnd = function(block) {
	    return block.clone[block.clone.length - 1];
	  };
	
	
	  return {
	    restrict: 'A',
	    multiElement: true,
	    transclude: 'element',
	    priority: 1000,
	    terminal: true,
	    $$tlb: true,
	    compile: function ngRepeatCompile($element, $attr) {
	      var expression = $attr.ngRepeat;
	      var ngRepeatEndComment = $compile.$$createComment('end ngRepeat', expression);
	
	      var match = expression.match(/^\s*([\s\S]+?)\s+in\s+([\s\S]+?)(?:\s+as\s+([\s\S]+?))?(?:\s+track\s+by\s+([\s\S]+?))?\s*$/);
	
	      if (!match) {
	        throw ngRepeatMinErr('iexp', "Expected expression in form of '_item_ in _collection_[ track by _id_]' but got '{0}'.",
	            expression);
	      }
	
	      var lhs = match[1];
	      var rhs = match[2];
	      var aliasAs = match[3];
	      var trackByExp = match[4];
	
	      match = lhs.match(/^(?:(\s*[\$\w]+)|\(\s*([\$\w]+)\s*,\s*([\$\w]+)\s*\))$/);
	
	      if (!match) {
	        throw ngRepeatMinErr('iidexp', "'_item_' in '_item_ in _collection_' should be an identifier or '(_key_, _value_)' expression, but got '{0}'.",
	            lhs);
	      }
	      var valueIdentifier = match[3] || match[1];
	      var keyIdentifier = match[2];
	
	      if (aliasAs && (!/^[$a-zA-Z_][$a-zA-Z0-9_]*$/.test(aliasAs) ||
	          /^(null|undefined|this|\$index|\$first|\$middle|\$last|\$even|\$odd|\$parent|\$root|\$id)$/.test(aliasAs))) {
	        throw ngRepeatMinErr('badident', "alias '{0}' is invalid --- must be a valid JS identifier which is not a reserved name.",
	          aliasAs);
	      }
	
	      var trackByExpGetter, trackByIdExpFn, trackByIdArrayFn, trackByIdObjFn;
	      var hashFnLocals = {$id: hashKey};
	
	      if (trackByExp) {
	        trackByExpGetter = $parse(trackByExp);
	      } else {
	        trackByIdArrayFn = function(key, value) {
	          return hashKey(value);
	        };
	        trackByIdObjFn = function(key) {
	          return key;
	        };
	      }
	
	      return function ngRepeatLink($scope, $element, $attr, ctrl, $transclude) {
	
	        if (trackByExpGetter) {
	          trackByIdExpFn = function(key, value, index) {
	            // assign key, value, and $index to the locals so that they can be used in hash functions
	            if (keyIdentifier) hashFnLocals[keyIdentifier] = key;
	            hashFnLocals[valueIdentifier] = value;
	            hashFnLocals.$index = index;
	            return trackByExpGetter($scope, hashFnLocals);
	          };
	        }
	
	        // Store a list of elements from previous run. This is a hash where key is the item from the
	        // iterator, and the value is objects with following properties.
	        //   - scope: bound scope
	        //   - element: previous element.
	        //   - index: position
	        //
	        // We are using no-proto object so that we don't need to guard against inherited props via
	        // hasOwnProperty.
	        var lastBlockMap = createMap();
	
	        //watch props
	        $scope.$watchCollection(rhs, function ngRepeatAction(collection) {
	          var index, length,
	              previousNode = $element[0],     // node that cloned nodes should be inserted after
	                                              // initialized to the comment node anchor
	              nextNode,
	              // Same as lastBlockMap but it has the current state. It will become the
	              // lastBlockMap on the next iteration.
	              nextBlockMap = createMap(),
	              collectionLength,
	              key, value, // key/value of iteration
	              trackById,
	              trackByIdFn,
	              collectionKeys,
	              block,       // last object information {scope, element, id}
	              nextBlockOrder,
	              elementsToRemove;
	
	          if (aliasAs) {
	            $scope[aliasAs] = collection;
	          }
	
	          if (isArrayLike(collection)) {
	            collectionKeys = collection;
	            trackByIdFn = trackByIdExpFn || trackByIdArrayFn;
	          } else {
	            trackByIdFn = trackByIdExpFn || trackByIdObjFn;
	            // if object, extract keys, in enumeration order, unsorted
	            collectionKeys = [];
	            for (var itemKey in collection) {
	              if (hasOwnProperty.call(collection, itemKey) && itemKey.charAt(0) !== '$') {
	                collectionKeys.push(itemKey);
	              }
	            }
	          }
	
	          collectionLength = collectionKeys.length;
	          nextBlockOrder = new Array(collectionLength);
	
	          // locate existing items
	          for (index = 0; index < collectionLength; index++) {
	            key = (collection === collectionKeys) ? index : collectionKeys[index];
	            value = collection[key];
	            trackById = trackByIdFn(key, value, index);
	            if (lastBlockMap[trackById]) {
	              // found previously seen block
	              block = lastBlockMap[trackById];
	              delete lastBlockMap[trackById];
	              nextBlockMap[trackById] = block;
	              nextBlockOrder[index] = block;
	            } else if (nextBlockMap[trackById]) {
	              // if collision detected. restore lastBlockMap and throw an error
	              forEach(nextBlockOrder, function(block) {
	                if (block && block.scope) lastBlockMap[block.id] = block;
	              });
	              throw ngRepeatMinErr('dupes',
	                  "Duplicates in a repeater are not allowed. Use 'track by' expression to specify unique keys. Repeater: {0}, Duplicate key: {1}, Duplicate value: {2}",
	                  expression, trackById, value);
	            } else {
	              // new never before seen block
	              nextBlockOrder[index] = {id: trackById, scope: undefined, clone: undefined};
	              nextBlockMap[trackById] = true;
	            }
	          }
	
	          // remove leftover items
	          for (var blockKey in lastBlockMap) {
	            block = lastBlockMap[blockKey];
	            elementsToRemove = getBlockNodes(block.clone);
	            $animate.leave(elementsToRemove);
	            if (elementsToRemove[0].parentNode) {
	              // if the element was not removed yet because of pending animation, mark it as deleted
	              // so that we can ignore it later
	              for (index = 0, length = elementsToRemove.length; index < length; index++) {
	                elementsToRemove[index][NG_REMOVED] = true;
	              }
	            }
	            block.scope.$destroy();
	          }
	
	          // we are not using forEach for perf reasons (trying to avoid #call)
	          for (index = 0; index < collectionLength; index++) {
	            key = (collection === collectionKeys) ? index : collectionKeys[index];
	            value = collection[key];
	            block = nextBlockOrder[index];
	
	            if (block.scope) {
	              // if we have already seen this object, then we need to reuse the
	              // associated scope/element
	
	              nextNode = previousNode;
	
	              // skip nodes that are already pending removal via leave animation
	              do {
	                nextNode = nextNode.nextSibling;
	              } while (nextNode && nextNode[NG_REMOVED]);
	
	              if (getBlockStart(block) != nextNode) {
	                // existing item which got moved
	                $animate.move(getBlockNodes(block.clone), null, previousNode);
	              }
	              previousNode = getBlockEnd(block);
	              updateScope(block.scope, index, valueIdentifier, value, keyIdentifier, key, collectionLength);
	            } else {
	              // new item which we don't know about
	              $transclude(function ngRepeatTransclude(clone, scope) {
	                block.scope = scope;
	                // http://jsperf.com/clone-vs-createcomment
	                var endNode = ngRepeatEndComment.cloneNode(false);
	                clone[clone.length++] = endNode;
	
	                $animate.enter(clone, null, previousNode);
	                previousNode = endNode;
	                // Note: We only need the first/last node of the cloned nodes.
	                // However, we need to keep the reference to the jqlite wrapper as it might be changed later
	                // by a directive with templateUrl when its template arrives.
	                block.clone = clone;
	                nextBlockMap[block.id] = block;
	                updateScope(block.scope, index, valueIdentifier, value, keyIdentifier, key, collectionLength);
	              });
	            }
	          }
	          lastBlockMap = nextBlockMap;
	        });
	      };
	    }
	  };
	}];
	
	var NG_HIDE_CLASS = 'ng-hide';
	var NG_HIDE_IN_PROGRESS_CLASS = 'ng-hide-animate';
	/**
	 * @ngdoc directive
	 * @name ngShow
	 * @multiElement
	 *
	 * @description
	 * The `ngShow` directive shows or hides the given HTML element based on the expression
	 * provided to the `ngShow` attribute. The element is shown or hidden by removing or adding
	 * the `.ng-hide` CSS class onto the element. The `.ng-hide` CSS class is predefined
	 * in AngularJS and sets the display style to none (using an !important flag).
	 * For CSP mode please add `angular-csp.css` to your html file (see {@link ng.directive:ngCsp ngCsp}).
	 *
	 * ```html
	 * <!-- when $scope.myValue is truthy (element is visible) -->
	 * <div ng-show="myValue"></div>
	 *
	 * <!-- when $scope.myValue is falsy (element is hidden) -->
	 * <div ng-show="myValue" class="ng-hide"></div>
	 * ```
	 *
	 * When the `ngShow` expression evaluates to a falsy value then the `.ng-hide` CSS class is added to the class
	 * attribute on the element causing it to become hidden. When truthy, the `.ng-hide` CSS class is removed
	 * from the element causing the element not to appear hidden.
	 *
	 * ## Why is !important used?
	 *
	 * You may be wondering why !important is used for the `.ng-hide` CSS class. This is because the `.ng-hide` selector
	 * can be easily overridden by heavier selectors. For example, something as simple
	 * as changing the display style on a HTML list item would make hidden elements appear visible.
	 * This also becomes a bigger issue when dealing with CSS frameworks.
	 *
	 * By using !important, the show and hide behavior will work as expected despite any clash between CSS selector
	 * specificity (when !important isn't used with any conflicting styles). If a developer chooses to override the
	 * styling to change how to hide an element then it is just a matter of using !important in their own CSS code.
	 *
	 * ### Overriding `.ng-hide`
	 *
	 * By default, the `.ng-hide` class will style the element with `display: none!important`. If you wish to change
	 * the hide behavior with ngShow/ngHide then this can be achieved by restating the styles for the `.ng-hide`
	 * class CSS. Note that the selector that needs to be used is actually `.ng-hide:not(.ng-hide-animate)` to cope
	 * with extra animation classes that can be added.
	 *
	 * ```css
	 * .ng-hide:not(.ng-hide-animate) {
	 *   /&#42; this is just another form of hiding an element &#42;/
	 *   display: block!important;
	 *   position: absolute;
	 *   top: -9999px;
	 *   left: -9999px;
	 * }
	 * ```
	 *
	 * By default you don't need to override in CSS anything and the animations will work around the display style.
	 *
	 * ## A note about animations with `ngShow`
	 *
	 * Animations in ngShow/ngHide work with the show and hide events that are triggered when the directive expression
	 * is true and false. This system works like the animation system present with ngClass except that
	 * you must also include the !important flag to override the display property
	 * so that you can perform an animation when the element is hidden during the time of the animation.
	 *
	 * ```css
	 * //
	 * //a working example can be found at the bottom of this page
	 * //
	 * .my-element.ng-hide-add, .my-element.ng-hide-remove {
	 *   /&#42; this is required as of 1.3x to properly
	 *      apply all styling in a show/hide animation &#42;/
	 *   transition: 0s linear all;
	 * }
	 *
	 * .my-element.ng-hide-add-active,
	 * .my-element.ng-hide-remove-active {
	 *   /&#42; the transition is defined in the active class &#42;/
	 *   transition: 1s linear all;
	 * }
	 *
	 * .my-element.ng-hide-add { ... }
	 * .my-element.ng-hide-add.ng-hide-add-active { ... }
	 * .my-element.ng-hide-remove { ... }
	 * .my-element.ng-hide-remove.ng-hide-remove-active { ... }
	 * ```
	 *
	 * Keep in mind that, as of AngularJS version 1.3, there is no need to change the display
	 * property to block during animation states--ngAnimate will handle the style toggling automatically for you.
	 *
	 * @animations
	 * | Animation                        | Occurs                              |
	 * |----------------------------------|-------------------------------------|
	 * | {@link $animate#addClass addClass} `.ng-hide`  | after the `ngShow` expression evaluates to a non truthy value and just before the contents are set to hidden |
	 * | {@link $animate#removeClass removeClass}  `.ng-hide`  | after the `ngShow` expression evaluates to a truthy value and just before contents are set to visible |
	 *
	 * @element ANY
	 * @param {expression} ngShow If the {@link guide/expression expression} is truthy
	 *     then the element is shown or hidden respectively.
	 *
	 * @example
	  <example module="ngAnimate" deps="angular-animate.js" animations="true">
	    <file name="index.html">
	      Click me: <input type="checkbox" ng-model="checked" aria-label="Toggle ngHide"><br/>
	      <div>
	        Show:
	        <div class="check-element animate-show" ng-show="checked">
	          <span class="glyphicon glyphicon-thumbs-up"></span> I show up when your checkbox is checked.
	        </div>
	      </div>
	      <div>
	        Hide:
	        <div class="check-element animate-show" ng-hide="checked">
	          <span class="glyphicon glyphicon-thumbs-down"></span> I hide when your checkbox is checked.
	        </div>
	      </div>
	    </file>
	    <file name="glyphicons.css">
	      @import url(../../components/bootstrap-3.1.1/css/bootstrap.css);
	    </file>
	    <file name="animations.css">
	      .animate-show {
	        line-height: 20px;
	        opacity: 1;
	        padding: 10px;
	        border: 1px solid black;
	        background: white;
	      }
	
	      .animate-show.ng-hide-add, .animate-show.ng-hide-remove {
	        transition: all linear 0.5s;
	      }
	
	      .animate-show.ng-hide {
	        line-height: 0;
	        opacity: 0;
	        padding: 0 10px;
	      }
	
	      .check-element {
	        padding: 10px;
	        border: 1px solid black;
	        background: white;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      var thumbsUp = element(by.css('span.glyphicon-thumbs-up'));
	      var thumbsDown = element(by.css('span.glyphicon-thumbs-down'));
	
	      it('should check ng-show / ng-hide', function() {
	        expect(thumbsUp.isDisplayed()).toBeFalsy();
	        expect(thumbsDown.isDisplayed()).toBeTruthy();
	
	        element(by.model('checked')).click();
	
	        expect(thumbsUp.isDisplayed()).toBeTruthy();
	        expect(thumbsDown.isDisplayed()).toBeFalsy();
	      });
	    </file>
	  </example>
	 */
	var ngShowDirective = ['$animate', function($animate) {
	  return {
	    restrict: 'A',
	    multiElement: true,
	    link: function(scope, element, attr) {
	      scope.$watch(attr.ngShow, function ngShowWatchAction(value) {
	        // we're adding a temporary, animation-specific class for ng-hide since this way
	        // we can control when the element is actually displayed on screen without having
	        // to have a global/greedy CSS selector that breaks when other animations are run.
	        // Read: https://github.com/angular/angular.js/issues/9103#issuecomment-58335845
	        $animate[value ? 'removeClass' : 'addClass'](element, NG_HIDE_CLASS, {
	          tempClasses: NG_HIDE_IN_PROGRESS_CLASS
	        });
	      });
	    }
	  };
	}];
	
	
	/**
	 * @ngdoc directive
	 * @name ngHide
	 * @multiElement
	 *
	 * @description
	 * The `ngHide` directive shows or hides the given HTML element based on the expression
	 * provided to the `ngHide` attribute. The element is shown or hidden by removing or adding
	 * the `ng-hide` CSS class onto the element. The `.ng-hide` CSS class is predefined
	 * in AngularJS and sets the display style to none (using an !important flag).
	 * For CSP mode please add `angular-csp.css` to your html file (see {@link ng.directive:ngCsp ngCsp}).
	 *
	 * ```html
	 * <!-- when $scope.myValue is truthy (element is hidden) -->
	 * <div ng-hide="myValue" class="ng-hide"></div>
	 *
	 * <!-- when $scope.myValue is falsy (element is visible) -->
	 * <div ng-hide="myValue"></div>
	 * ```
	 *
	 * When the `ngHide` expression evaluates to a truthy value then the `.ng-hide` CSS class is added to the class
	 * attribute on the element causing it to become hidden. When falsy, the `.ng-hide` CSS class is removed
	 * from the element causing the element not to appear hidden.
	 *
	 * ## Why is !important used?
	 *
	 * You may be wondering why !important is used for the `.ng-hide` CSS class. This is because the `.ng-hide` selector
	 * can be easily overridden by heavier selectors. For example, something as simple
	 * as changing the display style on a HTML list item would make hidden elements appear visible.
	 * This also becomes a bigger issue when dealing with CSS frameworks.
	 *
	 * By using !important, the show and hide behavior will work as expected despite any clash between CSS selector
	 * specificity (when !important isn't used with any conflicting styles). If a developer chooses to override the
	 * styling to change how to hide an element then it is just a matter of using !important in their own CSS code.
	 *
	 * ### Overriding `.ng-hide`
	 *
	 * By default, the `.ng-hide` class will style the element with `display: none!important`. If you wish to change
	 * the hide behavior with ngShow/ngHide then this can be achieved by restating the styles for the `.ng-hide`
	 * class in CSS:
	 *
	 * ```css
	 * .ng-hide {
	 *   /&#42; this is just another form of hiding an element &#42;/
	 *   display: block!important;
	 *   position: absolute;
	 *   top: -9999px;
	 *   left: -9999px;
	 * }
	 * ```
	 *
	 * By default you don't need to override in CSS anything and the animations will work around the display style.
	 *
	 * ## A note about animations with `ngHide`
	 *
	 * Animations in ngShow/ngHide work with the show and hide events that are triggered when the directive expression
	 * is true and false. This system works like the animation system present with ngClass, except that the `.ng-hide`
	 * CSS class is added and removed for you instead of your own CSS class.
	 *
	 * ```css
	 * //
	 * //a working example can be found at the bottom of this page
	 * //
	 * .my-element.ng-hide-add, .my-element.ng-hide-remove {
	 *   transition: 0.5s linear all;
	 * }
	 *
	 * .my-element.ng-hide-add { ... }
	 * .my-element.ng-hide-add.ng-hide-add-active { ... }
	 * .my-element.ng-hide-remove { ... }
	 * .my-element.ng-hide-remove.ng-hide-remove-active { ... }
	 * ```
	 *
	 * Keep in mind that, as of AngularJS version 1.3, there is no need to change the display
	 * property to block during animation states--ngAnimate will handle the style toggling automatically for you.
	 *
	 * @animations
	 * | Animation                        | Occurs                              |
	 * |----------------------------------|-------------------------------------|
	 * | {@link $animate#addClass addClass} `.ng-hide`  | after the `ngHide` expression evaluates to a truthy value and just before the contents are set to hidden |
	 * | {@link $animate#removeClass removeClass}  `.ng-hide`  | after the `ngHide` expression evaluates to a non truthy value and just before contents are set to visible |
	 *
	 *
	 * @element ANY
	 * @param {expression} ngHide If the {@link guide/expression expression} is truthy then
	 *     the element is shown or hidden respectively.
	 *
	 * @example
	  <example module="ngAnimate" deps="angular-animate.js" animations="true">
	    <file name="index.html">
	      Click me: <input type="checkbox" ng-model="checked" aria-label="Toggle ngShow"><br/>
	      <div>
	        Show:
	        <div class="check-element animate-hide" ng-show="checked">
	          <span class="glyphicon glyphicon-thumbs-up"></span> I show up when your checkbox is checked.
	        </div>
	      </div>
	      <div>
	        Hide:
	        <div class="check-element animate-hide" ng-hide="checked">
	          <span class="glyphicon glyphicon-thumbs-down"></span> I hide when your checkbox is checked.
	        </div>
	      </div>
	    </file>
	    <file name="glyphicons.css">
	      @import url(../../components/bootstrap-3.1.1/css/bootstrap.css);
	    </file>
	    <file name="animations.css">
	      .animate-hide {
	        transition: all linear 0.5s;
	        line-height: 20px;
	        opacity: 1;
	        padding: 10px;
	        border: 1px solid black;
	        background: white;
	      }
	
	      .animate-hide.ng-hide {
	        line-height: 0;
	        opacity: 0;
	        padding: 0 10px;
	      }
	
	      .check-element {
	        padding: 10px;
	        border: 1px solid black;
	        background: white;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      var thumbsUp = element(by.css('span.glyphicon-thumbs-up'));
	      var thumbsDown = element(by.css('span.glyphicon-thumbs-down'));
	
	      it('should check ng-show / ng-hide', function() {
	        expect(thumbsUp.isDisplayed()).toBeFalsy();
	        expect(thumbsDown.isDisplayed()).toBeTruthy();
	
	        element(by.model('checked')).click();
	
	        expect(thumbsUp.isDisplayed()).toBeTruthy();
	        expect(thumbsDown.isDisplayed()).toBeFalsy();
	      });
	    </file>
	  </example>
	 */
	var ngHideDirective = ['$animate', function($animate) {
	  return {
	    restrict: 'A',
	    multiElement: true,
	    link: function(scope, element, attr) {
	      scope.$watch(attr.ngHide, function ngHideWatchAction(value) {
	        // The comment inside of the ngShowDirective explains why we add and
	        // remove a temporary class for the show/hide animation
	        $animate[value ? 'addClass' : 'removeClass'](element,NG_HIDE_CLASS, {
	          tempClasses: NG_HIDE_IN_PROGRESS_CLASS
	        });
	      });
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngStyle
	 * @restrict AC
	 *
	 * @description
	 * The `ngStyle` directive allows you to set CSS style on an HTML element conditionally.
	 *
	 * @element ANY
	 * @param {expression} ngStyle
	 *
	 * {@link guide/expression Expression} which evals to an
	 * object whose keys are CSS style names and values are corresponding values for those CSS
	 * keys.
	 *
	 * Since some CSS style names are not valid keys for an object, they must be quoted.
	 * See the 'background-color' style in the example below.
	 *
	 * @example
	   <example>
	     <file name="index.html">
	        <input type="button" value="set color" ng-click="myStyle={color:'red'}">
	        <input type="button" value="set background" ng-click="myStyle={'background-color':'blue'}">
	        <input type="button" value="clear" ng-click="myStyle={}">
	        <br/>
	        <span ng-style="myStyle">Sample Text</span>
	        <pre>myStyle={{myStyle}}</pre>
	     </file>
	     <file name="style.css">
	       span {
	         color: black;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       var colorSpan = element(by.css('span'));
	
	       it('should check ng-style', function() {
	         expect(colorSpan.getCssValue('color')).toBe('rgba(0, 0, 0, 1)');
	         element(by.css('input[value=\'set color\']')).click();
	         expect(colorSpan.getCssValue('color')).toBe('rgba(255, 0, 0, 1)');
	         element(by.css('input[value=clear]')).click();
	         expect(colorSpan.getCssValue('color')).toBe('rgba(0, 0, 0, 1)');
	       });
	     </file>
	   </example>
	 */
	var ngStyleDirective = ngDirective(function(scope, element, attr) {
	  scope.$watch(attr.ngStyle, function ngStyleWatchAction(newStyles, oldStyles) {
	    if (oldStyles && (newStyles !== oldStyles)) {
	      forEach(oldStyles, function(val, style) { element.css(style, '');});
	    }
	    if (newStyles) element.css(newStyles);
	  }, true);
	});
	
	/**
	 * @ngdoc directive
	 * @name ngSwitch
	 * @restrict EA
	 *
	 * @description
	 * The `ngSwitch` directive is used to conditionally swap DOM structure on your template based on a scope expression.
	 * Elements within `ngSwitch` but without `ngSwitchWhen` or `ngSwitchDefault` directives will be preserved at the location
	 * as specified in the template.
	 *
	 * The directive itself works similar to ngInclude, however, instead of downloading template code (or loading it
	 * from the template cache), `ngSwitch` simply chooses one of the nested elements and makes it visible based on which element
	 * matches the value obtained from the evaluated expression. In other words, you define a container element
	 * (where you place the directive), place an expression on the **`on="..."` attribute**
	 * (or the **`ng-switch="..."` attribute**), define any inner elements inside of the directive and place
	 * a when attribute per element. The when attribute is used to inform ngSwitch which element to display when the on
	 * expression is evaluated. If a matching expression is not found via a when attribute then an element with the default
	 * attribute is displayed.
	 *
	 * <div class="alert alert-info">
	 * Be aware that the attribute values to match against cannot be expressions. They are interpreted
	 * as literal string values to match against.
	 * For example, **`ng-switch-when="someVal"`** will match against the string `"someVal"` not against the
	 * value of the expression `$scope.someVal`.
	 * </div>
	
	 * @animations
	 * | Animation                        | Occurs                              |
	 * |----------------------------------|-------------------------------------|
	 * | {@link ng.$animate#enter enter}  | after the ngSwitch contents change and the matched child element is placed inside the container |
	 * | {@link ng.$animate#leave leave}  | after the ngSwitch contents change and just before the former contents are removed from the DOM |
	 *
	 * @usage
	 *
	 * ```
	 * <ANY ng-switch="expression">
	 *   <ANY ng-switch-when="matchValue1">...</ANY>
	 *   <ANY ng-switch-when="matchValue2">...</ANY>
	 *   <ANY ng-switch-default>...</ANY>
	 * </ANY>
	 * ```
	 *
	 *
	 * @scope
	 * @priority 1200
	 * @param {*} ngSwitch|on expression to match against <code>ng-switch-when</code>.
	 * On child elements add:
	 *
	 * * `ngSwitchWhen`: the case statement to match against. If match then this
	 *   case will be displayed. If the same match appears multiple times, all the
	 *   elements will be displayed.
	 * * `ngSwitchDefault`: the default case when no other case match. If there
	 *   are multiple default cases, all of them will be displayed when no other
	 *   case match.
	 *
	 *
	 * @example
	  <example module="switchExample" deps="angular-animate.js" animations="true">
	    <file name="index.html">
	      <div ng-controller="ExampleController">
	        <select ng-model="selection" ng-options="item for item in items">
	        </select>
	        <code>selection={{selection}}</code>
	        <hr/>
	        <div class="animate-switch-container"
	          ng-switch on="selection">
	            <div class="animate-switch" ng-switch-when="settings">Settings Div</div>
	            <div class="animate-switch" ng-switch-when="home">Home Span</div>
	            <div class="animate-switch" ng-switch-default>default</div>
	        </div>
	      </div>
	    </file>
	    <file name="script.js">
	      angular.module('switchExample', ['ngAnimate'])
	        .controller('ExampleController', ['$scope', function($scope) {
	          $scope.items = ['settings', 'home', 'other'];
	          $scope.selection = $scope.items[0];
	        }]);
	    </file>
	    <file name="animations.css">
	      .animate-switch-container {
	        position:relative;
	        background:white;
	        border:1px solid black;
	        height:40px;
	        overflow:hidden;
	      }
	
	      .animate-switch {
	        padding:10px;
	      }
	
	      .animate-switch.ng-animate {
	        transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
	
	        position:absolute;
	        top:0;
	        left:0;
	        right:0;
	        bottom:0;
	      }
	
	      .animate-switch.ng-leave.ng-leave-active,
	      .animate-switch.ng-enter {
	        top:-50px;
	      }
	      .animate-switch.ng-leave,
	      .animate-switch.ng-enter.ng-enter-active {
	        top:0;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      var switchElem = element(by.css('[ng-switch]'));
	      var select = element(by.model('selection'));
	
	      it('should start in settings', function() {
	        expect(switchElem.getText()).toMatch(/Settings Div/);
	      });
	      it('should change to home', function() {
	        select.all(by.css('option')).get(1).click();
	        expect(switchElem.getText()).toMatch(/Home Span/);
	      });
	      it('should select default', function() {
	        select.all(by.css('option')).get(2).click();
	        expect(switchElem.getText()).toMatch(/default/);
	      });
	    </file>
	  </example>
	 */
	var ngSwitchDirective = ['$animate', '$compile', function($animate, $compile) {
	  return {
	    require: 'ngSwitch',
	
	    // asks for $scope to fool the BC controller module
	    controller: ['$scope', function ngSwitchController() {
	     this.cases = {};
	    }],
	    link: function(scope, element, attr, ngSwitchController) {
	      var watchExpr = attr.ngSwitch || attr.on,
	          selectedTranscludes = [],
	          selectedElements = [],
	          previousLeaveAnimations = [],
	          selectedScopes = [];
	
	      var spliceFactory = function(array, index) {
	          return function() { array.splice(index, 1); };
	      };
	
	      scope.$watch(watchExpr, function ngSwitchWatchAction(value) {
	        var i, ii;
	        for (i = 0, ii = previousLeaveAnimations.length; i < ii; ++i) {
	          $animate.cancel(previousLeaveAnimations[i]);
	        }
	        previousLeaveAnimations.length = 0;
	
	        for (i = 0, ii = selectedScopes.length; i < ii; ++i) {
	          var selected = getBlockNodes(selectedElements[i].clone);
	          selectedScopes[i].$destroy();
	          var promise = previousLeaveAnimations[i] = $animate.leave(selected);
	          promise.then(spliceFactory(previousLeaveAnimations, i));
	        }
	
	        selectedElements.length = 0;
	        selectedScopes.length = 0;
	
	        if ((selectedTranscludes = ngSwitchController.cases['!' + value] || ngSwitchController.cases['?'])) {
	          forEach(selectedTranscludes, function(selectedTransclude) {
	            selectedTransclude.transclude(function(caseElement, selectedScope) {
	              selectedScopes.push(selectedScope);
	              var anchor = selectedTransclude.element;
	              caseElement[caseElement.length++] = $compile.$$createComment('end ngSwitchWhen');
	              var block = { clone: caseElement };
	
	              selectedElements.push(block);
	              $animate.enter(caseElement, anchor.parent(), anchor);
	            });
	          });
	        }
	      });
	    }
	  };
	}];
	
	var ngSwitchWhenDirective = ngDirective({
	  transclude: 'element',
	  priority: 1200,
	  require: '^ngSwitch',
	  multiElement: true,
	  link: function(scope, element, attrs, ctrl, $transclude) {
	    ctrl.cases['!' + attrs.ngSwitchWhen] = (ctrl.cases['!' + attrs.ngSwitchWhen] || []);
	    ctrl.cases['!' + attrs.ngSwitchWhen].push({ transclude: $transclude, element: element });
	  }
	});
	
	var ngSwitchDefaultDirective = ngDirective({
	  transclude: 'element',
	  priority: 1200,
	  require: '^ngSwitch',
	  multiElement: true,
	  link: function(scope, element, attr, ctrl, $transclude) {
	    ctrl.cases['?'] = (ctrl.cases['?'] || []);
	    ctrl.cases['?'].push({ transclude: $transclude, element: element });
	   }
	});
	
	/**
	 * @ngdoc directive
	 * @name ngTransclude
	 * @restrict EAC
	 *
	 * @description
	 * Directive that marks the insertion point for the transcluded DOM of the nearest parent directive that uses transclusion.
	 *
	 * You can specify that you want to insert a named transclusion slot, instead of the default slot, by providing the slot name
	 * as the value of the `ng-transclude` or `ng-transclude-slot` attribute.
	 *
	 * If the transcluded content is not empty (i.e. contains one or more DOM nodes, including whitespace text nodes), any existing
	 * content of this element will be removed before the transcluded content is inserted.
	 * If the transcluded content is empty, the existing content is left intact. This lets you provide fallback content in the case
	 * that no transcluded content is provided.
	 *
	 * @element ANY
	 *
	 * @param {string} ngTransclude|ngTranscludeSlot the name of the slot to insert at this point. If this is not provided, is empty
	 *                                               or its value is the same as the name of the attribute then the default slot is used.
	 *
	 * @example
	 * ### Basic transclusion
	 * This example demonstrates basic transclusion of content into a component directive.
	 * <example name="simpleTranscludeExample" module="transcludeExample">
	 *   <file name="index.html">
	 *     <script>
	 *       angular.module('transcludeExample', [])
	 *        .directive('pane', function(){
	 *           return {
	 *             restrict: 'E',
	 *             transclude: true,
	 *             scope: { title:'@' },
	 *             template: '<div style="border: 1px solid black;">' +
	 *                         '<div style="background-color: gray">{{title}}</div>' +
	 *                         '<ng-transclude></ng-transclude>' +
	 *                       '</div>'
	 *           };
	 *       })
	 *       .controller('ExampleController', ['$scope', function($scope) {
	 *         $scope.title = 'Lorem Ipsum';
	 *         $scope.text = 'Neque porro quisquam est qui dolorem ipsum quia dolor...';
	 *       }]);
	 *     </script>
	 *     <div ng-controller="ExampleController">
	 *       <input ng-model="title" aria-label="title"> <br/>
	 *       <textarea ng-model="text" aria-label="text"></textarea> <br/>
	 *       <pane title="{{title}}">{{text}}</pane>
	 *     </div>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *      it('should have transcluded', function() {
	 *        var titleElement = element(by.model('title'));
	 *        titleElement.clear();
	 *        titleElement.sendKeys('TITLE');
	 *        var textElement = element(by.model('text'));
	 *        textElement.clear();
	 *        textElement.sendKeys('TEXT');
	 *        expect(element(by.binding('title')).getText()).toEqual('TITLE');
	 *        expect(element(by.binding('text')).getText()).toEqual('TEXT');
	 *      });
	 *   </file>
	 * </example>
	 *
	 * @example
	 * ### Transclude fallback content
	 * This example shows how to use `NgTransclude` with fallback content, that
	 * is displayed if no transcluded content is provided.
	 *
	 * <example module="transcludeFallbackContentExample">
	 * <file name="index.html">
	 * <script>
	 * angular.module('transcludeFallbackContentExample', [])
	 * .directive('myButton', function(){
	 *             return {
	 *               restrict: 'E',
	 *               transclude: true,
	 *               scope: true,
	 *               template: '<button style="cursor: pointer;">' +
	 *                           '<ng-transclude>' +
	 *                             '<b style="color: red;">Button1</b>' +
	 *                           '</ng-transclude>' +
	 *                         '</button>'
	 *             };
	 *         });
	 * </script>
	 * <!-- fallback button content -->
	 * <my-button id="fallback"></my-button>
	 * <!-- modified button content -->
	 * <my-button id="modified">
	 *   <i style="color: green;">Button2</i>
	 * </my-button>
	 * </file>
	 * <file name="protractor.js" type="protractor">
	 * it('should have different transclude element content', function() {
	 *          expect(element(by.id('fallback')).getText()).toBe('Button1');
	 *          expect(element(by.id('modified')).getText()).toBe('Button2');
	 *        });
	 * </file>
	 * </example>
	 *
	 * @example
	 * ### Multi-slot transclusion
	 * This example demonstrates using multi-slot transclusion in a component directive.
	 * <example name="multiSlotTranscludeExample" module="multiSlotTranscludeExample">
	 *   <file name="index.html">
	 *    <style>
	 *      .title, .footer {
	 *        background-color: gray
	 *      }
	 *    </style>
	 *    <div ng-controller="ExampleController">
	 *      <input ng-model="title" aria-label="title"> <br/>
	 *      <textarea ng-model="text" aria-label="text"></textarea> <br/>
	 *      <pane>
	 *        <pane-title><a ng-href="{{link}}">{{title}}</a></pane-title>
	 *        <pane-body><p>{{text}}</p></pane-body>
	 *      </pane>
	 *    </div>
	 *   </file>
	 *   <file name="app.js">
	 *    angular.module('multiSlotTranscludeExample', [])
	 *     .directive('pane', function(){
	 *        return {
	 *          restrict: 'E',
	 *          transclude: {
	 *            'title': '?paneTitle',
	 *            'body': 'paneBody',
	 *            'footer': '?paneFooter'
	 *          },
	 *          template: '<div style="border: 1px solid black;">' +
	 *                      '<div class="title" ng-transclude="title">Fallback Title</div>' +
	 *                      '<div ng-transclude="body"></div>' +
	 *                      '<div class="footer" ng-transclude="footer">Fallback Footer</div>' +
	 *                    '</div>'
	 *        };
	 *    })
	 *    .controller('ExampleController', ['$scope', function($scope) {
	 *      $scope.title = 'Lorem Ipsum';
	 *      $scope.link = "https://google.com";
	 *      $scope.text = 'Neque porro quisquam est qui dolorem ipsum quia dolor...';
	 *    }]);
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *      it('should have transcluded the title and the body', function() {
	 *        var titleElement = element(by.model('title'));
	 *        titleElement.clear();
	 *        titleElement.sendKeys('TITLE');
	 *        var textElement = element(by.model('text'));
	 *        textElement.clear();
	 *        textElement.sendKeys('TEXT');
	 *        expect(element(by.css('.title')).getText()).toEqual('TITLE');
	 *        expect(element(by.binding('text')).getText()).toEqual('TEXT');
	 *        expect(element(by.css('.footer')).getText()).toEqual('Fallback Footer');
	 *      });
	 *   </file>
	 * </example>
	 */
	var ngTranscludeMinErr = minErr('ngTransclude');
	var ngTranscludeDirective = ngDirective({
	  restrict: 'EAC',
	  link: function($scope, $element, $attrs, controller, $transclude) {
	
	    if ($attrs.ngTransclude === $attrs.$attr.ngTransclude) {
	      // If the attribute is of the form: `ng-transclude="ng-transclude"`
	      // then treat it like the default
	      $attrs.ngTransclude = '';
	    }
	
	    function ngTranscludeCloneAttachFn(clone) {
	      if (clone.length) {
	        $element.empty();
	        $element.append(clone);
	      }
	    }
	
	    if (!$transclude) {
	      throw ngTranscludeMinErr('orphan',
	       'Illegal use of ngTransclude directive in the template! ' +
	       'No parent directive that requires a transclusion found. ' +
	       'Element: {0}',
	       startingTag($element));
	    }
	
	    // If there is no slot name defined or the slot name is not optional
	    // then transclude the slot
	    var slotName = $attrs.ngTransclude || $attrs.ngTranscludeSlot;
	    $transclude(ngTranscludeCloneAttachFn, null, slotName);
	  }
	});
	
	/**
	 * @ngdoc directive
	 * @name script
	 * @restrict E
	 *
	 * @description
	 * Load the content of a `<script>` element into {@link ng.$templateCache `$templateCache`}, so that the
	 * template can be used by {@link ng.directive:ngInclude `ngInclude`},
	 * {@link ngRoute.directive:ngView `ngView`}, or {@link guide/directive directives}. The type of the
	 * `<script>` element must be specified as `text/ng-template`, and a cache name for the template must be
	 * assigned through the element's `id`, which can then be used as a directive's `templateUrl`.
	 *
	 * @param {string} type Must be set to `'text/ng-template'`.
	 * @param {string} id Cache name of the template.
	 *
	 * @example
	  <example>
	    <file name="index.html">
	      <script type="text/ng-template" id="/tpl.html">
	        Content of the template.
	      </script>
	
	      <a ng-click="currentTpl='/tpl.html'" id="tpl-link">Load inlined template</a>
	      <div id="tpl-content" ng-include src="currentTpl"></div>
	    </file>
	    <file name="protractor.js" type="protractor">
	      it('should load template defined inside script tag', function() {
	        element(by.css('#tpl-link')).click();
	        expect(element(by.css('#tpl-content')).getText()).toMatch(/Content of the template/);
	      });
	    </file>
	  </example>
	 */
	var scriptDirective = ['$templateCache', function($templateCache) {
	  return {
	    restrict: 'E',
	    terminal: true,
	    compile: function(element, attr) {
	      if (attr.type == 'text/ng-template') {
	        var templateUrl = attr.id,
	            text = element[0].text;
	
	        $templateCache.put(templateUrl, text);
	      }
	    }
	  };
	}];
	
	var noopNgModelController = { $setViewValue: noop, $render: noop };
	
	function chromeHack(optionElement) {
	  // Workaround for https://code.google.com/p/chromium/issues/detail?id=381459
	  // Adding an <option selected="selected"> element to a <select required="required"> should
	  // automatically select the new element
	  if (optionElement[0].hasAttribute('selected')) {
	    optionElement[0].selected = true;
	  }
	}
	
	/**
	 * @ngdoc type
	 * @name  select.SelectController
	 * @description
	 * The controller for the `<select>` directive. This provides support for reading
	 * and writing the selected value(s) of the control and also coordinates dynamically
	 * added `<option>` elements, perhaps by an `ngRepeat` directive.
	 */
	var SelectController =
	        ['$element', '$scope', function($element, $scope) {
	
	  var self = this,
	      optionsMap = new HashMap();
	
	  // If the ngModel doesn't get provided then provide a dummy noop version to prevent errors
	  self.ngModelCtrl = noopNgModelController;
	
	  // The "unknown" option is one that is prepended to the list if the viewValue
	  // does not match any of the options. When it is rendered the value of the unknown
	  // option is '? XXX ?' where XXX is the hashKey of the value that is not known.
	  //
	  // We can't just jqLite('<option>') since jqLite is not smart enough
	  // to create it in <select> and IE barfs otherwise.
	  self.unknownOption = jqLite(window.document.createElement('option'));
	  self.renderUnknownOption = function(val) {
	    var unknownVal = '? ' + hashKey(val) + ' ?';
	    self.unknownOption.val(unknownVal);
	    $element.prepend(self.unknownOption);
	    $element.val(unknownVal);
	  };
	
	  $scope.$on('$destroy', function() {
	    // disable unknown option so that we don't do work when the whole select is being destroyed
	    self.renderUnknownOption = noop;
	  });
	
	  self.removeUnknownOption = function() {
	    if (self.unknownOption.parent()) self.unknownOption.remove();
	  };
	
	
	  // Read the value of the select control, the implementation of this changes depending
	  // upon whether the select can have multiple values and whether ngOptions is at work.
	  self.readValue = function readSingleValue() {
	    self.removeUnknownOption();
	    return $element.val();
	  };
	
	
	  // Write the value to the select control, the implementation of this changes depending
	  // upon whether the select can have multiple values and whether ngOptions is at work.
	  self.writeValue = function writeSingleValue(value) {
	    if (self.hasOption(value)) {
	      self.removeUnknownOption();
	      $element.val(value);
	      if (value === '') self.emptyOption.prop('selected', true); // to make IE9 happy
	    } else {
	      if (value == null && self.emptyOption) {
	        self.removeUnknownOption();
	        $element.val('');
	      } else {
	        self.renderUnknownOption(value);
	      }
	    }
	  };
	
	
	  // Tell the select control that an option, with the given value, has been added
	  self.addOption = function(value, element) {
	    // Skip comment nodes, as they only pollute the `optionsMap`
	    if (element[0].nodeType === NODE_TYPE_COMMENT) return;
	
	    assertNotHasOwnProperty(value, '"option value"');
	    if (value === '') {
	      self.emptyOption = element;
	    }
	    var count = optionsMap.get(value) || 0;
	    optionsMap.put(value, count + 1);
	    self.ngModelCtrl.$render();
	    chromeHack(element);
	  };
	
	  // Tell the select control that an option, with the given value, has been removed
	  self.removeOption = function(value) {
	    var count = optionsMap.get(value);
	    if (count) {
	      if (count === 1) {
	        optionsMap.remove(value);
	        if (value === '') {
	          self.emptyOption = undefined;
	        }
	      } else {
	        optionsMap.put(value, count - 1);
	      }
	    }
	  };
	
	  // Check whether the select control has an option matching the given value
	  self.hasOption = function(value) {
	    return !!optionsMap.get(value);
	  };
	
	
	  self.registerOption = function(optionScope, optionElement, optionAttrs, interpolateValueFn, interpolateTextFn) {
	
	    if (interpolateValueFn) {
	      // The value attribute is interpolated
	      var oldVal;
	      optionAttrs.$observe('value', function valueAttributeObserveAction(newVal) {
	        if (isDefined(oldVal)) {
	          self.removeOption(oldVal);
	        }
	        oldVal = newVal;
	        self.addOption(newVal, optionElement);
	      });
	    } else if (interpolateTextFn) {
	      // The text content is interpolated
	      optionScope.$watch(interpolateTextFn, function interpolateWatchAction(newVal, oldVal) {
	        optionAttrs.$set('value', newVal);
	        if (oldVal !== newVal) {
	          self.removeOption(oldVal);
	        }
	        self.addOption(newVal, optionElement);
	      });
	    } else {
	      // The value attribute is static
	      self.addOption(optionAttrs.value, optionElement);
	    }
	
	    optionElement.on('$destroy', function() {
	      self.removeOption(optionAttrs.value);
	      self.ngModelCtrl.$render();
	    });
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name select
	 * @restrict E
	 *
	 * @description
	 * HTML `SELECT` element with angular data-binding.
	 *
	 * The `select` directive is used together with {@link ngModel `ngModel`} to provide data-binding
	 * between the scope and the `<select>` control (including setting default values).
	 * It also handles dynamic `<option>` elements, which can be added using the {@link ngRepeat `ngRepeat}` or
	 * {@link ngOptions `ngOptions`} directives.
	 *
	 * When an item in the `<select>` menu is selected, the value of the selected option will be bound
	 * to the model identified by the `ngModel` directive. With static or repeated options, this is
	 * the content of the `value` attribute or the textContent of the `<option>`, if the value attribute is missing.
	 * If you want dynamic value attributes, you can use interpolation inside the value attribute.
	 *
	 * <div class="alert alert-warning">
	 * Note that the value of a `select` directive used without `ngOptions` is always a string.
	 * When the model needs to be bound to a non-string value, you must either explicitly convert it
	 * using a directive (see example below) or use `ngOptions` to specify the set of options.
	 * This is because an option element can only be bound to string values at present.
	 * </div>
	 *
	 * If the viewValue of `ngModel` does not match any of the options, then the control
	 * will automatically add an "unknown" option, which it then removes when the mismatch is resolved.
	 *
	 * Optionally, a single hard-coded `<option>` element, with the value set to an empty string, can
	 * be nested into the `<select>` element. This element will then represent the `null` or "not selected"
	 * option. See example below for demonstration.
	 *
	 * <div class="alert alert-info">
	 * In many cases, `ngRepeat` can be used on `<option>` elements instead of {@link ng.directive:ngOptions
	 * ngOptions} to achieve a similar result. However, `ngOptions` provides some benefits, such as
	 * more flexibility in how the `<select>`'s model is assigned via the `select` **`as`** part of the
	 * comprehension expression, and additionally in reducing memory and increasing speed by not creating
	 * a new scope for each repeated instance.
	 * </div>
	 *
	 *
	 * @param {string} ngModel Assignable angular expression to data-bind to.
	 * @param {string=} name Property name of the form under which the control is published.
	 * @param {string=} multiple Allows multiple options to be selected. The selected values will be
	 *     bound to the model as an array.
	 * @param {string=} required Sets `required` validation error key if the value is not entered.
	 * @param {string=} ngRequired Adds required attribute and required validation constraint to
	 * the element when the ngRequired expression evaluates to true. Use ngRequired instead of required
	 * when you want to data-bind to the required attribute.
	 * @param {string=} ngChange Angular expression to be executed when selected option(s) changes due to user
	 *    interaction with the select element.
	 * @param {string=} ngOptions sets the options that the select is populated with and defines what is
	 * set on the model on selection. See {@link ngOptions `ngOptions`}.
	 *
	 * @example
	 * ### Simple `select` elements with static options
	 *
	 * <example name="static-select" module="staticSelect">
	 * <file name="index.html">
	 * <div ng-controller="ExampleController">
	 *   <form name="myForm">
	 *     <label for="singleSelect"> Single select: </label><br>
	 *     <select name="singleSelect" ng-model="data.singleSelect">
	 *       <option value="option-1">Option 1</option>
	 *       <option value="option-2">Option 2</option>
	 *     </select><br>
	 *
	 *     <label for="singleSelect"> Single select with "not selected" option and dynamic option values: </label><br>
	 *     <select name="singleSelect" id="singleSelect" ng-model="data.singleSelect">
	 *       <option value="">---Please select---</option> <!-- not selected / blank option -->
	 *       <option value="{{data.option1}}">Option 1</option> <!-- interpolation -->
	 *       <option value="option-2">Option 2</option>
	 *     </select><br>
	 *     <button ng-click="forceUnknownOption()">Force unknown option</button><br>
	 *     <tt>singleSelect = {{data.singleSelect}}</tt>
	 *
	 *     <hr>
	 *     <label for="multipleSelect"> Multiple select: </label><br>
	 *     <select name="multipleSelect" id="multipleSelect" ng-model="data.multipleSelect" multiple>
	 *       <option value="option-1">Option 1</option>
	 *       <option value="option-2">Option 2</option>
	 *       <option value="option-3">Option 3</option>
	 *     </select><br>
	 *     <tt>multipleSelect = {{data.multipleSelect}}</tt><br/>
	 *   </form>
	 * </div>
	 * </file>
	 * <file name="app.js">
	 *  angular.module('staticSelect', [])
	 *    .controller('ExampleController', ['$scope', function($scope) {
	 *      $scope.data = {
	 *       singleSelect: null,
	 *       multipleSelect: [],
	 *       option1: 'option-1',
	 *      };
	 *
	 *      $scope.forceUnknownOption = function() {
	 *        $scope.data.singleSelect = 'nonsense';
	 *      };
	 *   }]);
	 * </file>
	 *</example>
	 *
	 * ### Using `ngRepeat` to generate `select` options
	 * <example name="ngrepeat-select" module="ngrepeatSelect">
	 * <file name="index.html">
	 * <div ng-controller="ExampleController">
	 *   <form name="myForm">
	 *     <label for="repeatSelect"> Repeat select: </label>
	 *     <select name="repeatSelect" id="repeatSelect" ng-model="data.repeatSelect">
	 *       <option ng-repeat="option in data.availableOptions" value="{{option.id}}">{{option.name}}</option>
	 *     </select>
	 *   </form>
	 *   <hr>
	 *   <tt>repeatSelect = {{data.repeatSelect}}</tt><br/>
	 * </div>
	 * </file>
	 * <file name="app.js">
	 *  angular.module('ngrepeatSelect', [])
	 *    .controller('ExampleController', ['$scope', function($scope) {
	 *      $scope.data = {
	 *       repeatSelect: null,
	 *       availableOptions: [
	 *         {id: '1', name: 'Option A'},
	 *         {id: '2', name: 'Option B'},
	 *         {id: '3', name: 'Option C'}
	 *       ],
	 *      };
	 *   }]);
	 * </file>
	 *</example>
	 *
	 *
	 * ### Using `select` with `ngOptions` and setting a default value
	 * See the {@link ngOptions ngOptions documentation} for more `ngOptions` usage examples.
	 *
	 * <example name="select-with-default-values" module="defaultValueSelect">
	 * <file name="index.html">
	 * <div ng-controller="ExampleController">
	 *   <form name="myForm">
	 *     <label for="mySelect">Make a choice:</label>
	 *     <select name="mySelect" id="mySelect"
	 *       ng-options="option.name for option in data.availableOptions track by option.id"
	 *       ng-model="data.selectedOption"></select>
	 *   </form>
	 *   <hr>
	 *   <tt>option = {{data.selectedOption}}</tt><br/>
	 * </div>
	 * </file>
	 * <file name="app.js">
	 *  angular.module('defaultValueSelect', [])
	 *    .controller('ExampleController', ['$scope', function($scope) {
	 *      $scope.data = {
	 *       availableOptions: [
	 *         {id: '1', name: 'Option A'},
	 *         {id: '2', name: 'Option B'},
	 *         {id: '3', name: 'Option C'}
	 *       ],
	 *       selectedOption: {id: '3', name: 'Option C'} //This sets the default value of the select in the ui
	 *       };
	 *   }]);
	 * </file>
	 *</example>
	 *
	 *
	 * ### Binding `select` to a non-string value via `ngModel` parsing / formatting
	 *
	 * <example name="select-with-non-string-options" module="nonStringSelect">
	 *   <file name="index.html">
	 *     <select ng-model="model.id" convert-to-number>
	 *       <option value="0">Zero</option>
	 *       <option value="1">One</option>
	 *       <option value="2">Two</option>
	 *     </select>
	 *     {{ model }}
	 *   </file>
	 *   <file name="app.js">
	 *     angular.module('nonStringSelect', [])
	 *       .run(function($rootScope) {
	 *         $rootScope.model = { id: 2 };
	 *       })
	 *       .directive('convertToNumber', function() {
	 *         return {
	 *           require: 'ngModel',
	 *           link: function(scope, element, attrs, ngModel) {
	 *             ngModel.$parsers.push(function(val) {
	 *               return parseInt(val, 10);
	 *             });
	 *             ngModel.$formatters.push(function(val) {
	 *               return '' + val;
	 *             });
	 *           }
	 *         };
	 *       });
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *     it('should initialize to model', function() {
	 *       var select = element(by.css('select'));
	 *       expect(element(by.model('model.id')).$('option:checked').getText()).toEqual('Two');
	 *     });
	 *   </file>
	 * </example>
	 *
	 */
	var selectDirective = function() {
	
	  return {
	    restrict: 'E',
	    require: ['select', '?ngModel'],
	    controller: SelectController,
	    priority: 1,
	    link: {
	      pre: selectPreLink,
	      post: selectPostLink
	    }
	  };
	
	  function selectPreLink(scope, element, attr, ctrls) {
	
	      // if ngModel is not defined, we don't need to do anything
	      var ngModelCtrl = ctrls[1];
	      if (!ngModelCtrl) return;
	
	      var selectCtrl = ctrls[0];
	
	      selectCtrl.ngModelCtrl = ngModelCtrl;
	
	      // When the selected item(s) changes we delegate getting the value of the select control
	      // to the `readValue` method, which can be changed if the select can have multiple
	      // selected values or if the options are being generated by `ngOptions`
	      element.on('change', function() {
	        scope.$apply(function() {
	          ngModelCtrl.$setViewValue(selectCtrl.readValue());
	        });
	      });
	
	      // If the select allows multiple values then we need to modify how we read and write
	      // values from and to the control; also what it means for the value to be empty and
	      // we have to add an extra watch since ngModel doesn't work well with arrays - it
	      // doesn't trigger rendering if only an item in the array changes.
	      if (attr.multiple) {
	
	        // Read value now needs to check each option to see if it is selected
	        selectCtrl.readValue = function readMultipleValue() {
	          var array = [];
	          forEach(element.find('option'), function(option) {
	            if (option.selected) {
	              array.push(option.value);
	            }
	          });
	          return array;
	        };
	
	        // Write value now needs to set the selected property of each matching option
	        selectCtrl.writeValue = function writeMultipleValue(value) {
	          var items = new HashMap(value);
	          forEach(element.find('option'), function(option) {
	            option.selected = isDefined(items.get(option.value));
	          });
	        };
	
	        // we have to do it on each watch since ngModel watches reference, but
	        // we need to work of an array, so we need to see if anything was inserted/removed
	        var lastView, lastViewRef = NaN;
	        scope.$watch(function selectMultipleWatch() {
	          if (lastViewRef === ngModelCtrl.$viewValue && !equals(lastView, ngModelCtrl.$viewValue)) {
	            lastView = shallowCopy(ngModelCtrl.$viewValue);
	            ngModelCtrl.$render();
	          }
	          lastViewRef = ngModelCtrl.$viewValue;
	        });
	
	        // If we are a multiple select then value is now a collection
	        // so the meaning of $isEmpty changes
	        ngModelCtrl.$isEmpty = function(value) {
	          return !value || value.length === 0;
	        };
	
	      }
	    }
	
	    function selectPostLink(scope, element, attrs, ctrls) {
	      // if ngModel is not defined, we don't need to do anything
	      var ngModelCtrl = ctrls[1];
	      if (!ngModelCtrl) return;
	
	      var selectCtrl = ctrls[0];
	
	      // We delegate rendering to the `writeValue` method, which can be changed
	      // if the select can have multiple selected values or if the options are being
	      // generated by `ngOptions`.
	      // This must be done in the postLink fn to prevent $render to be called before
	      // all nodes have been linked correctly.
	      ngModelCtrl.$render = function() {
	        selectCtrl.writeValue(ngModelCtrl.$viewValue);
	      };
	    }
	};
	
	
	// The option directive is purely designed to communicate the existence (or lack of)
	// of dynamically created (and destroyed) option elements to their containing select
	// directive via its controller.
	var optionDirective = ['$interpolate', function($interpolate) {
	  return {
	    restrict: 'E',
	    priority: 100,
	    compile: function(element, attr) {
	      if (isDefined(attr.value)) {
	        // If the value attribute is defined, check if it contains an interpolation
	        var interpolateValueFn = $interpolate(attr.value, true);
	      } else {
	        // If the value attribute is not defined then we fall back to the
	        // text content of the option element, which may be interpolated
	        var interpolateTextFn = $interpolate(element.text(), true);
	        if (!interpolateTextFn) {
	          attr.$set('value', element.text());
	        }
	      }
	
	      return function(scope, element, attr) {
	        // This is an optimization over using ^^ since we don't want to have to search
	        // all the way to the root of the DOM for every single option element
	        var selectCtrlName = '$selectController',
	            parent = element.parent(),
	            selectCtrl = parent.data(selectCtrlName) ||
	              parent.parent().data(selectCtrlName); // in case we are in optgroup
	
	        if (selectCtrl) {
	          selectCtrl.registerOption(scope, element, attr, interpolateValueFn, interpolateTextFn);
	        }
	      };
	    }
	  };
	}];
	
	var styleDirective = valueFn({
	  restrict: 'E',
	  terminal: false
	});
	
	/**
	 * @ngdoc directive
	 * @name ngRequired
	 * @restrict A
	 *
	 * @description
	 *
	 * ngRequired adds the required {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
	 * It is most often used for {@link input `input`} and {@link select `select`} controls, but can also be
	 * applied to custom controls.
	 *
	 * The directive sets the `required` attribute on the element if the Angular expression inside
	 * `ngRequired` evaluates to true. A special directive for setting `required` is necessary because we
	 * cannot use interpolation inside `required`. See the {@link guide/interpolation interpolation guide}
	 * for more info.
	 *
	 * The validator will set the `required` error key to true if the `required` attribute is set and
	 * calling {@link ngModel.NgModelController#$isEmpty `NgModelController.$isEmpty`} with the
	 * {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`} returns `true`. For example, the
	 * `$isEmpty()` implementation for `input[text]` checks the length of the `$viewValue`. When developing
	 * custom controls, `$isEmpty()` can be overwritten to account for a $viewValue that is not string-based.
	 *
	 * @example
	 * <example name="ngRequiredDirective" module="ngRequiredExample">
	 *   <file name="index.html">
	 *     <script>
	 *       angular.module('ngRequiredExample', [])
	 *         .controller('ExampleController', ['$scope', function($scope) {
	 *           $scope.required = true;
	 *         }]);
	 *     </script>
	 *     <div ng-controller="ExampleController">
	 *       <form name="form">
	 *         <label for="required">Toggle required: </label>
	 *         <input type="checkbox" ng-model="required" id="required" />
	 *         <br>
	 *         <label for="input">This input must be filled if `required` is true: </label>
	 *         <input type="text" ng-model="model" id="input" name="input" ng-required="required" /><br>
	 *         <hr>
	 *         required error set? = <code>{{form.input.$error.required}}</code><br>
	 *         model = <code>{{model}}</code>
	 *       </form>
	 *     </div>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	       var required = element(by.binding('form.input.$error.required'));
	       var model = element(by.binding('model'));
	       var input = element(by.id('input'));
	
	       it('should set the required error', function() {
	         expect(required.getText()).toContain('true');
	
	         input.sendKeys('123');
	         expect(required.getText()).not.toContain('true');
	         expect(model.getText()).toContain('123');
	       });
	 *   </file>
	 * </example>
	 */
	var requiredDirective = function() {
	  return {
	    restrict: 'A',
	    require: '?ngModel',
	    link: function(scope, elm, attr, ctrl) {
	      if (!ctrl) return;
	      attr.required = true; // force truthy in case we are on non input element
	
	      ctrl.$validators.required = function(modelValue, viewValue) {
	        return !attr.required || !ctrl.$isEmpty(viewValue);
	      };
	
	      attr.$observe('required', function() {
	        ctrl.$validate();
	      });
	    }
	  };
	};
	
	/**
	 * @ngdoc directive
	 * @name ngPattern
	 *
	 * @description
	 *
	 * ngPattern adds the pattern {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
	 * It is most often used for text-based {@link input `input`} controls, but can also be applied to custom text-based controls.
	 *
	 * The validator sets the `pattern` error key if the {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`}
	 * does not match a RegExp which is obtained by evaluating the Angular expression given in the
	 * `ngPattern` attribute value:
	 * * If the expression evaluates to a RegExp object, then this is used directly.
	 * * If the expression evaluates to a string, then it will be converted to a RegExp after wrapping it
	 * in `^` and `$` characters. For instance, `"abc"` will be converted to `new RegExp('^abc$')`.
	 *
	 * <div class="alert alert-info">
	 * **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	 * start at the index of the last search's match, thus not taking the whole input value into
	 * account.
	 * </div>
	 *
	 * <div class="alert alert-info">
	 * **Note:** This directive is also added when the plain `pattern` attribute is used, with two
	 * differences:
	 * <ol>
	 *   <li>
	 *     `ngPattern` does not set the `pattern` attribute and therefore HTML5 constraint validation is
	 *     not available.
	 *   </li>
	 *   <li>
	 *     The `ngPattern` attribute must be an expression, while the `pattern` value must be
	 *     interpolated.
	 *   </li>
	 * </ol>
	 * </div>
	 *
	 * @example
	 * <example name="ngPatternDirective" module="ngPatternExample">
	 *   <file name="index.html">
	 *     <script>
	 *       angular.module('ngPatternExample', [])
	 *         .controller('ExampleController', ['$scope', function($scope) {
	 *           $scope.regex = '\\d+';
	 *         }]);
	 *     </script>
	 *     <div ng-controller="ExampleController">
	 *       <form name="form">
	 *         <label for="regex">Set a pattern (regex string): </label>
	 *         <input type="text" ng-model="regex" id="regex" />
	 *         <br>
	 *         <label for="input">This input is restricted by the current pattern: </label>
	 *         <input type="text" ng-model="model" id="input" name="input" ng-pattern="regex" /><br>
	 *         <hr>
	 *         input valid? = <code>{{form.input.$valid}}</code><br>
	 *         model = <code>{{model}}</code>
	 *       </form>
	 *     </div>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	       var model = element(by.binding('model'));
	       var input = element(by.id('input'));
	
	       it('should validate the input with the default pattern', function() {
	         input.sendKeys('aaa');
	         expect(model.getText()).not.toContain('aaa');
	
	         input.clear().then(function() {
	           input.sendKeys('123');
	           expect(model.getText()).toContain('123');
	         });
	       });
	 *   </file>
	 * </example>
	 */
	var patternDirective = function() {
	  return {
	    restrict: 'A',
	    require: '?ngModel',
	    link: function(scope, elm, attr, ctrl) {
	      if (!ctrl) return;
	
	      var regexp, patternExp = attr.ngPattern || attr.pattern;
	      attr.$observe('pattern', function(regex) {
	        if (isString(regex) && regex.length > 0) {
	          regex = new RegExp('^' + regex + '$');
	        }
	
	        if (regex && !regex.test) {
	          throw minErr('ngPattern')('noregexp',
	            'Expected {0} to be a RegExp but was {1}. Element: {2}', patternExp,
	            regex, startingTag(elm));
	        }
	
	        regexp = regex || undefined;
	        ctrl.$validate();
	      });
	
	      ctrl.$validators.pattern = function(modelValue, viewValue) {
	        // HTML5 pattern constraint validates the input value, so we validate the viewValue
	        return ctrl.$isEmpty(viewValue) || isUndefined(regexp) || regexp.test(viewValue);
	      };
	    }
	  };
	};
	
	/**
	 * @ngdoc directive
	 * @name ngMaxlength
	 *
	 * @description
	 *
	 * ngMaxlength adds the maxlength {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
	 * It is most often used for text-based {@link input `input`} controls, but can also be applied to custom text-based controls.
	 *
	 * The validator sets the `maxlength` error key if the {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`}
	 * is longer than the integer obtained by evaluating the Angular expression given in the
	 * `ngMaxlength` attribute value.
	 *
	 * <div class="alert alert-info">
	 * **Note:** This directive is also added when the plain `maxlength` attribute is used, with two
	 * differences:
	 * <ol>
	 *   <li>
	 *     `ngMaxlength` does not set the `maxlength` attribute and therefore HTML5 constraint
	 *     validation is not available.
	 *   </li>
	 *   <li>
	 *     The `ngMaxlength` attribute must be an expression, while the `maxlength` value must be
	 *     interpolated.
	 *   </li>
	 * </ol>
	 * </div>
	 *
	 * @example
	 * <example name="ngMaxlengthDirective" module="ngMaxlengthExample">
	 *   <file name="index.html">
	 *     <script>
	 *       angular.module('ngMaxlengthExample', [])
	 *         .controller('ExampleController', ['$scope', function($scope) {
	 *           $scope.maxlength = 5;
	 *         }]);
	 *     </script>
	 *     <div ng-controller="ExampleController">
	 *       <form name="form">
	 *         <label for="maxlength">Set a maxlength: </label>
	 *         <input type="number" ng-model="maxlength" id="maxlength" />
	 *         <br>
	 *         <label for="input">This input is restricted by the current maxlength: </label>
	 *         <input type="text" ng-model="model" id="input" name="input" ng-maxlength="maxlength" /><br>
	 *         <hr>
	 *         input valid? = <code>{{form.input.$valid}}</code><br>
	 *         model = <code>{{model}}</code>
	 *       </form>
	 *     </div>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	       var model = element(by.binding('model'));
	       var input = element(by.id('input'));
	
	       it('should validate the input with the default maxlength', function() {
	         input.sendKeys('abcdef');
	         expect(model.getText()).not.toContain('abcdef');
	
	         input.clear().then(function() {
	           input.sendKeys('abcde');
	           expect(model.getText()).toContain('abcde');
	         });
	       });
	 *   </file>
	 * </example>
	 */
	var maxlengthDirective = function() {
	  return {
	    restrict: 'A',
	    require: '?ngModel',
	    link: function(scope, elm, attr, ctrl) {
	      if (!ctrl) return;
	
	      var maxlength = -1;
	      attr.$observe('maxlength', function(value) {
	        var intVal = toInt(value);
	        maxlength = isNaN(intVal) ? -1 : intVal;
	        ctrl.$validate();
	      });
	      ctrl.$validators.maxlength = function(modelValue, viewValue) {
	        return (maxlength < 0) || ctrl.$isEmpty(viewValue) || (viewValue.length <= maxlength);
	      };
	    }
	  };
	};
	
	/**
	 * @ngdoc directive
	 * @name ngMinlength
	 *
	 * @description
	 *
	 * ngMinlength adds the minlength {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
	 * It is most often used for text-based {@link input `input`} controls, but can also be applied to custom text-based controls.
	 *
	 * The validator sets the `minlength` error key if the {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`}
	 * is shorter than the integer obtained by evaluating the Angular expression given in the
	 * `ngMinlength` attribute value.
	 *
	 * <div class="alert alert-info">
	 * **Note:** This directive is also added when the plain `minlength` attribute is used, with two
	 * differences:
	 * <ol>
	 *   <li>
	 *     `ngMinlength` does not set the `minlength` attribute and therefore HTML5 constraint
	 *     validation is not available.
	 *   </li>
	 *   <li>
	 *     The `ngMinlength` value must be an expression, while the `minlength` value must be
	 *     interpolated.
	 *   </li>
	 * </ol>
	 * </div>
	 *
	 * @example
	 * <example name="ngMinlengthDirective" module="ngMinlengthExample">
	 *   <file name="index.html">
	 *     <script>
	 *       angular.module('ngMinlengthExample', [])
	 *         .controller('ExampleController', ['$scope', function($scope) {
	 *           $scope.minlength = 3;
	 *         }]);
	 *     </script>
	 *     <div ng-controller="ExampleController">
	 *       <form name="form">
	 *         <label for="minlength">Set a minlength: </label>
	 *         <input type="number" ng-model="minlength" id="minlength" />
	 *         <br>
	 *         <label for="input">This input is restricted by the current minlength: </label>
	 *         <input type="text" ng-model="model" id="input" name="input" ng-minlength="minlength" /><br>
	 *         <hr>
	 *         input valid? = <code>{{form.input.$valid}}</code><br>
	 *         model = <code>{{model}}</code>
	 *       </form>
	 *     </div>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	       var model = element(by.binding('model'));
	       var input = element(by.id('input'));
	
	       it('should validate the input with the default minlength', function() {
	         input.sendKeys('ab');
	         expect(model.getText()).not.toContain('ab');
	
	         input.sendKeys('abc');
	         expect(model.getText()).toContain('abc');
	       });
	 *   </file>
	 * </example>
	 */
	var minlengthDirective = function() {
	  return {
	    restrict: 'A',
	    require: '?ngModel',
	    link: function(scope, elm, attr, ctrl) {
	      if (!ctrl) return;
	
	      var minlength = 0;
	      attr.$observe('minlength', function(value) {
	        minlength = toInt(value) || 0;
	        ctrl.$validate();
	      });
	      ctrl.$validators.minlength = function(modelValue, viewValue) {
	        return ctrl.$isEmpty(viewValue) || viewValue.length >= minlength;
	      };
	    }
	  };
	};
	
	if (window.angular.bootstrap) {
	  //AngularJS is already loaded, so we can return here...
	  if (window.console) {
	    console.log('WARNING: Tried to load angular more than once.');
	  }
	  return;
	}
	
	//try to bind to jquery now so that one can write jqLite(document).ready()
	//but we will rebind on bootstrap again.
	bindJQuery();
	
	publishExternalAPI(angular);
	
	angular.module("ngLocale", [], ["$provide", function($provide) {
	var PLURAL_CATEGORY = {ZERO: "zero", ONE: "one", TWO: "two", FEW: "few", MANY: "many", OTHER: "other"};
	function getDecimals(n) {
	  n = n + '';
	  var i = n.indexOf('.');
	  return (i == -1) ? 0 : n.length - i - 1;
	}
	
	function getVF(n, opt_precision) {
	  var v = opt_precision;
	
	  if (undefined === v) {
	    v = Math.min(getDecimals(n), 3);
	  }
	
	  var base = Math.pow(10, v);
	  var f = ((n * base) | 0) % base;
	  return {v: v, f: f};
	}
	
	$provide.value("$locale", {
	  "DATETIME_FORMATS": {
	    "AMPMS": [
	      "AM",
	      "PM"
	    ],
	    "DAY": [
	      "Sunday",
	      "Monday",
	      "Tuesday",
	      "Wednesday",
	      "Thursday",
	      "Friday",
	      "Saturday"
	    ],
	    "ERANAMES": [
	      "Before Christ",
	      "Anno Domini"
	    ],
	    "ERAS": [
	      "BC",
	      "AD"
	    ],
	    "FIRSTDAYOFWEEK": 6,
	    "MONTH": [
	      "January",
	      "February",
	      "March",
	      "April",
	      "May",
	      "June",
	      "July",
	      "August",
	      "September",
	      "October",
	      "November",
	      "December"
	    ],
	    "SHORTDAY": [
	      "Sun",
	      "Mon",
	      "Tue",
	      "Wed",
	      "Thu",
	      "Fri",
	      "Sat"
	    ],
	    "SHORTMONTH": [
	      "Jan",
	      "Feb",
	      "Mar",
	      "Apr",
	      "May",
	      "Jun",
	      "Jul",
	      "Aug",
	      "Sep",
	      "Oct",
	      "Nov",
	      "Dec"
	    ],
	    "STANDALONEMONTH": [
	      "January",
	      "February",
	      "March",
	      "April",
	      "May",
	      "June",
	      "July",
	      "August",
	      "September",
	      "October",
	      "November",
	      "December"
	    ],
	    "WEEKENDRANGE": [
	      5,
	      6
	    ],
	    "fullDate": "EEEE, MMMM d, y",
	    "longDate": "MMMM d, y",
	    "medium": "MMM d, y h:mm:ss a",
	    "mediumDate": "MMM d, y",
	    "mediumTime": "h:mm:ss a",
	    "short": "M/d/yy h:mm a",
	    "shortDate": "M/d/yy",
	    "shortTime": "h:mm a"
	  },
	  "NUMBER_FORMATS": {
	    "CURRENCY_SYM": "$",
	    "DECIMAL_SEP": ".",
	    "GROUP_SEP": ",",
	    "PATTERNS": [
	      {
	        "gSize": 3,
	        "lgSize": 3,
	        "maxFrac": 3,
	        "minFrac": 0,
	        "minInt": 1,
	        "negPre": "-",
	        "negSuf": "",
	        "posPre": "",
	        "posSuf": ""
	      },
	      {
	        "gSize": 3,
	        "lgSize": 3,
	        "maxFrac": 2,
	        "minFrac": 2,
	        "minInt": 1,
	        "negPre": "-\u00a4",
	        "negSuf": "",
	        "posPre": "\u00a4",
	        "posSuf": ""
	      }
	    ]
	  },
	  "id": "en-us",
	  "localeID": "en_US",
	  "pluralCat": function(n, opt_precision) {  var i = n | 0;  var vf = getVF(n, opt_precision);  if (i == 1 && vf.v == 0) {    return PLURAL_CATEGORY.ONE;  }  return PLURAL_CATEGORY.OTHER;}
	});
	}]);
	
	  jqLite(window.document).ready(function() {
	    angularInit(window.document, bootstrap);
	  });
	
	})(window);
	
	!window.angular.$$csp().noInlineStyle && window.angular.element(document.head).prepend('<style type="text/css">@charset "UTF-8";[ng\\:cloak],[ng-cloak],[data-ng-cloak],[x-ng-cloak],.ng-cloak,.x-ng-cloak,.ng-hide:not(.ng-hide-animate){display:none !important;}ng\\:form{display:block;}.ng-animate-shim{visibility:hidden;}.ng-anchor{position:absolute;}</style>');

/***/ }),
/* 1138 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// SVG Icons
	
	var _directivesCompassIcons = __webpack_require__(1286);
	
	var _directivesCompassIcons2 = _interopRequireDefault(_directivesCompassIcons);
	
	var FastClick = __webpack_require__(1682);
	
	__webpack_require__(1362);
	__webpack_require__(1609);
	__webpack_require__(1130);
	__webpack_require__(1135);
	__webpack_require__(1133);
	__webpack_require__(1131);
	__webpack_require__(1134);
	__webpack_require__(387);
	
	__webpack_require__(1358);
	__webpack_require__(1086);
	__webpack_require__(1361);
	__webpack_require__(1356);
	__webpack_require__(1355);
	__webpack_require__(1360);
	__webpack_require__(1357);
	__webpack_require__(1359);
	__webpack_require__(1294);
	
	__webpack_require__(1681);
	
	var app = angular.module('app', ['ngCookies', 'duScroll', 'ngMessages', 'ui.router', 'angular-google-analytics', 'angularMoment', 'ui.select', 'vesparny.fancyModal', __webpack_require__(1230).name, __webpack_require__(1181).name, __webpack_require__(1208).name, __webpack_require__(1238).name, __webpack_require__(1174).name, __webpack_require__(454).name, __webpack_require__(1178).name, __webpack_require__(89).name, __webpack_require__(1190).name, __webpack_require__(1220).name, __webpack_require__(1185).name, __webpack_require__(1241).name, __webpack_require__(1189).name, __webpack_require__(1204).name, __webpack_require__(1248).name, __webpack_require__(1163).name, __webpack_require__(1177).name, __webpack_require__(1162).name, __webpack_require__(1259).name, __webpack_require__(1242).name, __webpack_require__(1148).name, __webpack_require__(1169).name, __webpack_require__(1200).name, __webpack_require__(1151).name, __webpack_require__(1139).name, 'pascalprecht.translate', 'ngSanitize', 'app.lbTooltip', 'ngIdle', 'ngPatternRestrict', __webpack_require__(1126), __webpack_require__(1318)]);
	
	// global polyfills
	if (typeof String.prototype.trim !== 'function') {
	  String.prototype.trim = function () {
	    return this.replace(/^\s+|\s+$/g, '');
	  };
	}
	Object.keys(_directivesCompassIcons2['default']).forEach(function (name) {
	  app.directive(name, _directivesCompassIcons2['default'][name]);
	});
	
	app.directive('lbSequentialTime', __webpack_require__(1293));
	app.directive('lbFutureTime', __webpack_require__(1291));
	app.directive('focusOn', __webpack_require__(1287));
	app.directive('inputMatch', __webpack_require__(1288));
	app.directive('inputUppercase', __webpack_require__(1289));
	app.directive('clickOutside', __webpack_require__(1290));
	app.directive('iframeOnload', __webpack_require__(1292));
	
	app.config(['uiSelectConfig', function (uiSelectConfig) {
	  uiSelectConfig.theme = 'selectize';
	}]);
	
	app.config(['$translateProvider', function ($translateProvider) {
	  var Lang = window.localStorage.getItem('i18nCode') || 'en-AU';
	  $translateProvider.useSanitizeValueStrategy('sanitize').translations('en-AU', __webpack_require__(1689)).translations('en-US', __webpack_require__(1691)).translations('en-GB', __webpack_require__(1690)).fallbackLanguage(['en-AU', 'en-US', 'en-GB']).preferredLanguage(Lang);
	}]);
	
	app.config(['$compileProvider', function ($compileProvider) {
	  $compileProvider.debugInfoEnabled(false);
	}]);
	
	app.config(['IdleProvider', function (IdleProvider) {
	  IdleProvider.autoResume('notIdle');
	  IdleProvider.idle(60 * 20);
	  IdleProvider.timeout(30);
	}]);
	
	app.constant('APP_CONFIG', __webpack_require__(1281));
	app.constant('AUTH_EVENTS', __webpack_require__(1284));
	app.constant('ENUMS', __webpack_require__(1285));
	
	app.filter('sectorGroupsFilter', __webpack_require__(1313));
	app.filter('creditCardNumberFilter', __webpack_require__(1302));
	app.filter('startCaseFilter', __webpack_require__(1083).startCaseFilter);
	app.filter('stringLengthFilter', __webpack_require__(1083).stringLengthFilter);
	app.filter('paddingFilter', __webpack_require__(1311));
	app.filter('noValueFilter', __webpack_require__(1310));
	app.filter('cssClassNameFilter', __webpack_require__(1081));
	app.filter('genericSortingFilter', __webpack_require__(1305));
	app.filter('locationIconFilter', __webpack_require__(1309));
	app.filter('distanceFilter', __webpack_require__(1304));
	app.filter('secondsToTimeFilter', __webpack_require__(1312));
	app.filter('cssClassNameFilter', __webpack_require__(1081));
	app.filter('toAddressFilter', __webpack_require__(1314));
	app.filter('keyToLabelFilter', __webpack_require__(1308));
	app.filter('ancillaryServicesAmountsFilter', __webpack_require__(1299));
	app.filter('hotelProviderBrandFilter', __webpack_require__(1306));
	app.filter('deepCopyFilter', __webpack_require__(1303));
	app.filter('checkinInfoFilter', __webpack_require__(1301));
	
	app.config(__webpack_require__(1317));
	app.config(__webpack_require__(1319));
	app.config(__webpack_require__(1283)(app));
	app.config(__webpack_require__(1282)(app));
	
	app.factory('requestInterceptor', __webpack_require__(1298));
	app.factory('$exceptionHandler', __webpack_require__(1297));
	
	app.service('apiService', __webpack_require__(1321));
	app.service('appInsightsService', __webpack_require__(1322));
	app.service('bookingsService', __webpack_require__(1325));
	app.service('activeBookingService', __webpack_require__(1320));
	app.service('authService', __webpack_require__(1323));
	app.service('itinerariesService', __webpack_require__(693));
	app.service('settingsService', __webpack_require__(311));
	app.service('travelService', __webpack_require__(1350));
	app.service('travelFiltersService', __webpack_require__(1349));
	app.service('flightFilterService', __webpack_require__(1335));
	app.service('flailService', __webpack_require__(1334));
	app.service('cartService', __webpack_require__(1327));
	app.service('carSearchService', __webpack_require__(1326));
	app.service('sectorService', __webpack_require__(1345));
	app.service('sectorChangeService', __webpack_require__(1344));
	app.service('searchFormService', __webpack_require__(695));
	app.service('iataSearchService', __webpack_require__(1337));
	app.service('departmentService', __webpack_require__(1332));
	app.service('locationsSearchService', __webpack_require__(1340));
	app.service('depotSearchService', __webpack_require__(1333));
	app.service('citySearchService', __webpack_require__(1329));
	app.service('locationService', __webpack_require__(1084));
	app.service('companyReferenceListService', __webpack_require__(1330));
	app.service('dateTimeService', __webpack_require__(1331));
	app.service('toggleService', __webpack_require__(1348));
	app.service('stateResolveService', __webpack_require__(1346));
	app.service('seatMapService', __webpack_require__(1085));
	app.service('seatNumberService', __webpack_require__(1343));
	app.service('cdnService', __webpack_require__(1328));
	app.service('lostSavingsService', __webpack_require__(1341));
	app.service('timesService', __webpack_require__(1347));
	app.service('userProfileService', __webpack_require__(1354));
	app.service('userDebtorService', __webpack_require__(1353));
	app.service('guestTravellerService', __webpack_require__(1336));
	app.service('paymentMethodsService', __webpack_require__(1342));
	app.service('unusedTicketsService', __webpack_require__(1352));
	app.service('unusedCreditsService', __webpack_require__(1351));
	app.service('beamerService', __webpack_require__(1324));
	
	app.run(['Analytics', function (Analytics) {
	  // This gets analytics started, must have reference to Analytics
	}]);
	
	app.run(['$rootScope', '$location', function ($rootScope, $location) {
	  $rootScope.enableDebug = $location.search().enabledebug;
	}]);
	
	app.run(['$rootScope', function ($rootScope) {
	  $rootScope.$on('openDatePicker', function (event, settings) {
	    $rootScope.datePickerSettings = settings;
	    $rootScope.showDatePicker = true;
	  });
	
	  $rootScope.$on('closeDatePicker', function () {
	    $rootScope.datePickerSettings = undefined;
	    $rootScope.showDatePicker = false;
	  });
	}]);
	
	app.run(['$rootScope', '$ocLazyLoad', function ($rootScope, $ocLazyLoad) {
	  $rootScope.$on('$stateChangeSuccess', function () {
	    document.body.scrollTop = document.documentElement.scrollTop = 0;
	  });
	
	  FastClick.attach(document.body);
	
	  app.register = $ocLazyLoad.inject.bind($ocLazyLoad);
	}]);
	
	app.run(['$rootScope', '$timeout', 'lbModalService', 'authService', 'AUTH_EVENTS', function ($rootScope, $timeout, lbModalService, authService, AUTH_EVENTS) {
	  $rootScope.$on('IdleStart', function () {
	    $timeout(function () {
	      lbModalService.open('<lb-timeout-modal></lb-timeout-modal>');
	    });
	  });
	
	  $rootScope.$on('IdleTimeout', function () {
	    authService.logout().then(function () {
	      lbModalService.resolve();
	      $rootScope.$broadcast(AUTH_EVENTS.logoutSuccess);
	      $rootScope.$broadcast('closeDatePicker');
	    });
	  });
	}]);
	
	app.run(['$rootScope', '$state', '$fancyModal', 'authService', function ($rootScope, $state, $fancyModal, authService) {
	  return $rootScope.$on('$stateChangeStart', function (event, toState, toParams) {
	    $fancyModal.close();
	    if (!authService.isAuthenticated()) {
	      app.previousSate = {
	        toState: toState,
	        toParams: toParams
	      };
	
	      if (!(toParams.isPublic || toState.data && toState.data.isPublic)) {
	        event.preventDefault();
	        $state.go('landing.login');
	        return;
	      }
	    }
	
	    if (toState.redirectTo) {
	      event.preventDefault();
	      $state.go(toState.redirectTo, toParams);
	      return;
	    }
	    $rootScope.showLoader = !!toState.resolve;
	  });
	}]);
	
	app.run(['$rootScope', '$state', '$window', 'Analytics', 'Idle', 'authService', 'appInsightsService', 'APP_CONFIG', function ($rootScope, $state, $window, Analytics, Idle, authService, appInsightsService, APP_CONFIG) {
	  return $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
	    $rootScope.showLoader = false;
	    var pagePath = $state.href(toState.name, toParams).substr(1);
	
	    $rootScope.bodyClass = toParams.bodyClass || toState.data && toState.data.bodyClass || 'bg';
	    $rootScope.pageTitle = toParams.pageTitle || toState.data && toState.data.pageTitle || 'Lightning Book';
	
	    if (APP_CONFIG.analytics.enabled) {
	      Analytics.set('page', pagePath);
	      Analytics.trackPage(pagePath, $rootScope.pageTitle);
	    }
	
	    if (APP_CONFIG.appInsights.enabled) {
	      appInsightsService.trackPageView(pagePath);
	    }
	
	    if (authService.isAuthenticated()) {
	      if (!Idle.running()) {
	        Idle.watch();
	      }
	    } else {
	      Idle.unwatch();
	    }
	  });
	}]);
	
	app.run(['$rootScope', '$state', 'AUTH_EVENTS', function ($rootScope, $state, AUTH_EVENTS) {
	  return $rootScope.$on(AUTH_EVENTS.loginSuccess, function () {
	    if (app.previousSate && !(app.previousSate.toParams.isPublic || app.previousSate.toState.data && app.previousSate.toState.data.isPublic)) {
	      $state.go(app.previousSate.toState, app.previousSate.toParams);
	    } else {
	      $state.go('app.home');
	    }
	    // $rootScope.$broadcast('loadBeamer');
	  });
	}]);
	
	app.run(['$rootScope', '$state', 'AUTH_EVENTS', function ($rootScope, $state, AUTH_EVENTS) {
	  $rootScope.$on(AUTH_EVENTS.notAuthenticated, function () {
	    $state.go('landing.login');
	  });
	}]);
	
	app.run(['$rootScope', '$state', function ($rootScope, $state) {
	  $rootScope.$on('$stateChangeError', function () {
	    $rootScope.showLoader = false;
	    if ($state.is('authenticate')) {
	      $state.go('landing.login');
	    } else {
	      $state.go('app.home');
	    }
	  });
	}]);
	
	app.run(['$rootScope', 'beamerService', function ($rootScope, beamerService) {
	  $rootScope.$on('loadBeamer', function () {
	    if (!window.beamer_config) return;
	
	    var auth = JSON.parse(localStorage.getItem('oauth'));
	    if (!auth || !auth.access_token) return;
	
	    beamerService.get().then(function (response) {
	      beamerService.setCount(response.count);
	      beamerService.setUrl(response.url);
	      if (response.url) $('#beamerFrame').attr('src', response.url);
	    });
	  });
	
	  $rootScope.$broadcast('loadBeamer');
	}]);
	
	exports['default'] = app;
	module.exports = exports['default'];

/***/ }),
/* 1139 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var lb = angular.module('app.lb', []);
	
	lb.run(['$rootScope', '$state', 'AUTH_EVENTS', function ($rootScope, $state, AUTH_EVENTS) {
	  return $rootScope.$on(AUTH_EVENTS.logoutSuccess, function () {
	    $state.go('landing.login');
	  });
	}]);
	
	exports['default'] = lb;
	module.exports = exports['default'];

/***/ }),
/* 1140 */,
/* 1141 */,
/* 1142 */,
/* 1143 */,
/* 1144 */,
/* 1145 */,
/* 1146 */,
/* 1147 */,
/* 1148 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var lbAgentChatWidget = angular.module('app.lbAgentChatWidget', []);
	
	lbAgentChatWidget.controller('lbAgentChatWidgetCtrl', __webpack_require__(1149));
	lbAgentChatWidget.directive('lbAgentChatWidget', __webpack_require__(1150));
	
	exports['default'] = lbAgentChatWidget;
	module.exports = exports['default'];

/***/ }),
/* 1149 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['$rootScope', '$scope', '$sce', 'authService', 'settingsService', 'AUTH_EVENTS', 'APP_CONFIG'];
	
	var lbaAgentChatWidgetCtrl = function lbaAgentChatWidgetCtrl($rootScope, $scope, $sce, authService, settingsService, AUTH_EVENTS, APP_CONFIG) {
	  var vm = this;
	
	  vm.WidgetState = 'icon'; // open-information, open-iframe
	  vm.transitionState = transitionState;
	  vm.IsEnabled = false;
	  vm.DebtorSupportInformation = {
	    Phone: '',
	    Email: ''
	  };
	  vm.SupportInformation = {
	    Phone: '',
	    Email: ''
	  };
	
	  function transitionState(state) {
	    switch (state) {
	      case 'icon':
	        vm.title = 'Contact Information';
	        vm.IFrameClass = 'widget_IFrame_hidden';
	
	        settingsService.getAny().then(function (settings) {
	          // 24 is the agent chat feature id.
	          vm.feature = settings.AllowedFeatures.filter(function (f) {
	            return f.Id == 24;
	          })[0] || null;
	
	          if (!!vm.feature) {
	            vm.IFrameSrc = $sce.trustAsResourceUrl(vm.feature.Url);
	          }
	
	          if (!!settings.DebtorSupport) {
	            vm.DebtorSupportInformation.Phone = settings.DebtorSupport.Phone;
	            vm.DebtorSupportInformation.Email = settings.DebtorSupport.Email;
	          }
	
	          if (!!settings.SupportInformation) {
	            vm.SupportInformation.Phone = settings.SupportInformation.Phone;
	            vm.SupportInformation.Email = settings.SupportInformation.Email;
	          }
	
	          vm.IsEnabled = vm.IsAuthenticated && (!!vm.feature || !!vm.SupportInformation.Phone || !!vm.SupportInformation.Email || !!vm.DebtorSupportInformation.Phone || !!vm.DebtorSupportInformation.Email);
	        });
	        break;
	
	      case 'open-information':
	        break;
	
	      case 'open-iframe':
	        vm.title = 'Agent Chat';
	        vm.IFrameClass = 'widget_IFrame_visible';
	        break;
	
	      default:
	        break;
	    }
	
	    vm.WidgetState = state;
	  }
	
	  $rootScope.$on(AUTH_EVENTS.logoutSuccess, function () {
	    vm.IsEnabled = false;
	    vm.IsAuthenticated = false;
	  });
	  $rootScope.$on(AUTH_EVENTS.loginSuccess, function () {
	    vm.IsAuthenticated = true;
	    vm.transitionState('icon');
	  });
	
	  vm.IsAuthenticated = authService.isAuthenticated();
	
	  if (vm.IsAuthenticated) {
	    vm.transitionState('icon');
	  }
	};
	
	lbaAgentChatWidgetCtrl.$inject = $inject;
	
	exports['default'] = lbaAgentChatWidgetCtrl;
	module.exports = exports['default'];

/***/ }),
/* 1150 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	__webpack_require__(1615);
	
	var $inject = [];
	var lbAgentChatWidget = function lbAgentChatWidget() {
	  return {
	    controller: 'lbAgentChatWidgetCtrl',
	    controllerAs: 'vm',
	    bindToController: true,
	    template: __webpack_require__(1696)
	  };
	};
	
	lbAgentChatWidget.$inject = $inject;
	
	exports['default'] = lbAgentChatWidget;
	module.exports = exports['default'];

/***/ }),
/* 1151 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var lbBeamer = angular.module('app.lbBeamer', []);
	
	lbBeamer.controller('lbBeamerCtrl', __webpack_require__(1152));
	lbBeamer.directive('lbBeamer', __webpack_require__(1153));
	
	exports['default'] = lbBeamer;
	module.exports = exports['default'];

/***/ }),
/* 1152 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['$rootScope', 'beamerService'];
	
	var lbBeamerCtrl = function lbBeamerCtrl($rootScope, beamerService) {
	  var $ctrl = this;
	  $ctrl.show = false;
	  $ctrl.url = beamerService.getUrl();
	
	  $ctrl.close = function () {
	    $ctrl.show = false;
	  };
	
	  $rootScope.$on('openBeamer', function (event, data) {
	    $ctrl.show = true;
	  });
	
	  window.addEventListener('message', function (event) {
	    if (event.origin !== 'https://app.getbeamer.com') return;
	    var data = {};
	
	    var action = event.data;
	    if (action.includes(':')) {
	      action = event.data.split(':')[0];
	      var dataString = event.data.split(':').slice(1).join(':');
	      data = JSON.parse(dataString);
	    }
	
	    switch (action) {
	      case 'showPicture':
	        showPicture(data.url);
	        break;
	
	      case 'hide':
	        $ctrl.close();
	        $rootScope.$apply();
	        break;
	    }
	  }, false);
	
	  function showPicture(a) {
	    hidePicture();
	    var b = $('<div>').attr('id', 'beamerPicture').attr('class', 'hideable').click(hidePicture),
	        c = $('<div>').attr('class', 'iframeCointaner');
	    a = $('<img>').attr('src', a);
	    c.append(a);
	    b.append(c);
	    $('body').append(b);
	    setTimeout(function () {
	      b.addClass('visible');
	    }, 10);
	  }
	  function hidePicture() {
	    var a = $('#beamerPicture');
	    a && (a.removeClass('visible'), setTimeout(function () {
	      a.remove();
	    }, 250));
	  }
	};
	
	lbBeamerCtrl.$inject = $inject;
	
	exports['default'] = lbBeamerCtrl;
	module.exports = exports['default'];

/***/ }),
/* 1153 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	__webpack_require__(1616);
	
	var $inject = [];
	var lbBeamerDir = function lbBeamerDir() {
	  return {
	    controller: 'lbBeamerCtrl',
	    controllerAs: '$ctrl',
	    bindToController: true,
	    template: __webpack_require__(1697)
	  };
	};
	
	lbBeamerDir.$inject = $inject;
	
	exports['default'] = lbBeamerDir;
	module.exports = exports['default'];

/***/ }),
/* 1154 */,
/* 1155 */,
/* 1156 */,
/* 1157 */,
/* 1158 */,
/* 1159 */,
/* 1160 */,
/* 1161 */,
/* 1162 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	__webpack_require__(1618);
	
	var lbCO2Message = angular.module('app.lbCO2Message', []);
	
	lbCO2Message.component('lbCO2Message', {
	  controllerAs: 'vm',
	  controller: ['settingsService', controller],
	  template: __webpack_require__(1702)
	});
	
	function controller(settingsService) {
	  var vm = this;
	  vm.emissionsAverageDailyKilometers = settingsService.settings.CarConfiguration.EmissionsAverageDailyKilometers;
	  vm.message = 'CO2 emissions data is based on an average use if ' + vm.emissionsAverageDailyKilometers + 'km per day';
	}
	
	exports['default'] = lbCO2Message;
	module.exports = exports['default'];

/***/ }),
/* 1163 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var lbCarHandlingModal = angular.module('app.lbCarHandlingModal', []);
	
	lbCarHandlingModal.controller('lbCarHandlingModalCtrl', __webpack_require__(1165));
	lbCarHandlingModal.component('lbCarHandlingModal', __webpack_require__(1164));
	
	exports['default'] = lbCarHandlingModal;
	module.exports = exports['default'];

/***/ }),
/* 1164 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	__webpack_require__(1619);
	
	var $inject = [];
	
	var lbCarHandlingModal = {
	  controller: 'lbCarHandlingModalCtrl as vm',
	  template: __webpack_require__(1703)
	};
	
	lbCarHandlingModal.$inject = $inject;
	
	exports['default'] = lbCarHandlingModal;
	module.exports = exports['default'];

/***/ }),
/* 1165 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['$scope', 'lbModalService'];
	
	var lbCarHandlingModalCtrl = function lbCarHandlingModalCtrl($scope, lbModalService) {
	  var vm = this;
	
	  var params = lbModalService.params();
	  var deliveryActive = !!params.delivery || params.request === 'delivery';
	  var collectionActive = !!params.collection || params.request === 'collection';
	  var usStates = __webpack_require__(1166);
	
	  vm.usStates = _.map(_.keysIn(usStates), function (stateCode) {
	    return {
	      code: stateCode,
	      name: usStates[stateCode]
	    };
	  });
	
	  vm.collection = {
	    location: params.collection,
	    isValid: !!params.collection,
	    isEnabled: !!params.collectionEnabled,
	    isActive: collectionActive,
	    isEditing: collectionActive,
	    displaySummary: false
	  };
	
	  vm.delivery = {
	    location: params.delivery,
	    isValid: !!params.location,
	    isEnabled: !!params.deliveryEnabled,
	    isActive: deliveryActive,
	    isEditing: deliveryActive,
	    displaySummary: false
	  };
	
	  vm.edit = edit;
	  vm.request = request;
	  vm.cancel = lbModalService.reject;
	  vm.submit = submit;
	
	  if (vm.collection.location && vm.delivery.location && _.isEqual(vm.collection.location, vm.delivery.location)) {
	    if (params.request === 'delivery') {
	      vm.collection.location = vm.delivery.location;
	      vm.collection.isEditing = false;
	    }
	
	    if (params.request === 'collection') {
	      vm.delivery.location = vm.collection.location;
	      vm.delivery.isEditing = false;
	    }
	  }
	
	  function edit(location) {
	    if (location === 'collection') {
	      vm.collection.location = undefined;
	      vm.collection.isEditing = true;
	    }
	
	    if (location === 'delivery') {
	      vm.delivery.location = undefined;
	      vm.delivery.isEditing = true;
	    }
	  }
	
	  function request(location, value) {
	    if (location === 'collection') {
	      if (value) {
	        vm.collection.location = vm.delivery.location;
	        vm.collection.isEditing = !vm.delivery.isActive;
	      } else {
	        vm.collection.location = undefined;
	        vm.collection.isEditing = false;
	        vm.delivery.isEditing = !vm.collection.isActive;
	      }
	    }
	
	    if (location === 'delivery') {
	      if (value) {
	        vm.delivery.location = vm.collection.location;
	        vm.delivery.isEditing = !vm.collection.isActive;
	      } else {
	        vm.delivery.location = undefined;
	        vm.delivery.isEditing = false;
	        vm.collection.isEditing = !vm.delivery.isActive;
	      }
	    }
	  }
	
	  function submit() {
	    var delivery = _.clone(vm.delivery.location);
	    var collection = _.clone(vm.collection.location);
	
	    lbModalService.resolve({ delivery: delivery, collection: collection });
	  }
	};
	
	lbCarHandlingModalCtrl.$inject = $inject;
	
	exports['default'] = lbCarHandlingModalCtrl;
	module.exports = exports['default'];

/***/ }),
/* 1166 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = {
	  AL: 'Alabama',
	  AK: 'Alaska',
	  AS: 'American Samoa',
	  AZ: 'Arizona',
	  AR: 'Arkansas',
	  CA: 'California',
	  CO: 'Colorado',
	  CT: 'Connecticut',
	  DE: 'Delaware',
	  DC: 'District Of Columbia',
	  FM: 'Federated States Of Micronesia',
	  FL: 'Florida',
	  GA: 'Georgia',
	  GU: 'Guam',
	  HI: 'Hawaii',
	  ID: 'Idaho',
	  IL: 'Illinois',
	  IN: 'Indiana',
	  IA: 'Iowa',
	  KS: 'Kansas',
	  KY: 'Kentucky',
	  LA: 'Louisiana',
	  ME: 'Maine',
	  MH: 'Marshall Islands',
	  MD: 'Maryland',
	  MA: 'Massachusetts',
	  MI: 'Michigan',
	  MN: 'Minnesota',
	  MS: 'Mississippi',
	  MO: 'Missouri',
	  MT: 'Montana',
	  NE: 'Nebraska',
	  NV: 'Nevada',
	  NH: 'New Hampshire',
	  NJ: 'New Jersey',
	  NM: 'New Mexico',
	  NY: 'New York',
	  NC: 'North Carolina',
	  ND: 'North Dakota',
	  MP: 'Northern Mariana Islands',
	  OH: 'Ohio',
	  OK: 'Oklahoma',
	  OR: 'Oregon',
	  PW: 'Palau',
	  PA: 'Pennsylvania',
	  PR: 'Puerto Rico',
	  RI: 'Rhode Island',
	  SC: 'South Carolina',
	  SD: 'South Dakota',
	  TN: 'Tennessee',
	  TX: 'Texas',
	  UT: 'Utah',
	  VT: 'Vermont',
	  VI: 'Virgin Islands',
	  VA: 'Virginia',
	  WA: 'Washington',
	  WV: 'West Virginia',
	  WI: 'Wisconsin',
	  WY: 'Wyoming'
	};
	module.exports = exports['default'];

/***/ }),
/* 1167 */,
/* 1168 */,
/* 1169 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	__webpack_require__(1620);
	
	var lbCardIcon = angular.module('app.lbCardIcon', []);
	
	lbCardIcon.component('lbCardIcon', {
	  bindings: {
	    cardType: '<'
	  },
	  controllerAs: 'vm',
	  controller: [controller],
	  template: '<i class="lbCardIcon_{{ vm.cardType }}"></i>'
	});
	
	function controller() {
	  var vm = this;
	}
	
	exports['default'] = lbCardIcon;
	module.exports = exports['default'];

/***/ }),
/* 1170 */,
/* 1171 */,
/* 1172 */,
/* 1173 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = [{ Name: 'Afghanistan', Code: 'AF' }, { Name: 'Åland Islands', Code: 'AX' }, { Name: 'Albania', Code: 'AL' }, { Name: 'Algeria', Code: 'DZ' }, { Name: 'American Samoa', Code: 'AS' }, { Name: 'AndorrA', Code: 'AD' }, { Name: 'Angola', Code: 'AO' }, { Name: 'Anguilla', Code: 'AI' }, { Name: 'Antarctica', Code: 'AQ' }, { Name: 'Antigua and Barbuda', Code: 'AG' }, { Name: 'Argentina', Code: 'AR' }, { Name: 'Armenia', Code: 'AM' }, { Name: 'Aruba', Code: 'AW' }, { Name: 'Australia', Code: 'AU' }, { Name: 'Austria', Code: 'AT' }, { Name: 'Azerbaijan', Code: 'AZ' }, { Name: 'Bahamas', Code: 'BS' }, { Name: 'Bahrain', Code: 'BH' }, { Name: 'Bangladesh', Code: 'BD' }, { Name: 'Barbados', Code: 'BB' }, { Name: 'Belarus', Code: 'BY' }, { Name: 'Belgium', Code: 'BE' }, { Name: 'Belize', Code: 'BZ' }, { Name: 'Benin', Code: 'BJ' }, { Name: 'Bermuda', Code: 'BM' }, { Name: 'Bhutan', Code: 'BT' }, { Name: 'Bolivia', Code: 'BO' }, { Name: 'Bosnia and Herzegovina', Code: 'BA' }, { Name: 'Botswana', Code: 'BW' }, { Name: 'Bouvet Island', Code: 'BV' }, { Name: 'Brazil', Code: 'BR' }, { Name: 'British Indian Ocean Territory', Code: 'IO' }, { Name: 'Brunei Darussalam', Code: 'BN' }, { Name: 'Bulgaria', Code: 'BG' }, { Name: 'Burkina Faso', Code: 'BF' }, { Name: 'Burundi', Code: 'BI' }, { Name: 'Cambodia', Code: 'KH' }, { Name: 'Cameroon', Code: 'CM' }, { Name: 'Canada', Code: 'CA' }, { Name: 'Cape Verde', Code: 'CV' }, { Name: 'Cayman Islands', Code: 'KY' }, { Name: 'Central African Republic', Code: 'CF' }, { Name: 'Chad', Code: 'TD' }, { Name: 'Chile', Code: 'CL' }, { Name: 'China', Code: 'CN' }, { Name: 'Christmas Island', Code: 'CX' }, { Name: 'Cocos (Keeling) Islands', Code: 'CC' }, { Name: 'Colombia', Code: 'CO' }, { Name: 'Comoros', Code: 'KM' }, { Name: 'Congo', Code: 'CG' }, { Name: 'Congo, The Democratic Republic of the', Code: 'CD' }, { Name: 'Cook Islands', Code: 'CK' }, { Name: 'Costa Rica', Code: 'CR' }, { Name: "Cote D'Ivoire", Code: 'CI' }, { Name: 'Croatia', Code: 'HR' }, { Name: 'Cuba', Code: 'CU' }, { Name: 'Cyprus', Code: 'CY' }, { Name: 'Czech Republic', Code: 'CZ' }, { Name: 'Denmark', Code: 'DK' }, { Name: 'Djibouti', Code: 'DJ' }, { Name: 'Dominica', Code: 'DM' }, { Name: 'Dominican Republic', Code: 'DO' }, { Name: 'Ecuador', Code: 'EC' }, { Name: 'Egypt', Code: 'EG' }, { Name: 'El Salvador', Code: 'SV' }, { Name: 'Equatorial Guinea', Code: 'GQ' }, { Name: 'Eritrea', Code: 'ER' }, { Name: 'Estonia', Code: 'EE' }, { Name: 'Ethiopia', Code: 'ET' }, { Name: 'Falkland Islands (Malvinas)', Code: 'FK' }, { Name: 'Faroe Islands', Code: 'FO' }, { Name: 'Fiji', Code: 'FJ' }, { Name: 'Finland', Code: 'FI' }, { Name: 'France', Code: 'FR' }, { Name: 'French Guiana', Code: 'GF' }, { Name: 'French Polynesia', Code: 'PF' }, { Name: 'French Southern Territories', Code: 'TF' }, { Name: 'Gabon', Code: 'GA' }, { Name: 'Gambia', Code: 'GM' }, { Name: 'Georgia', Code: 'GE' }, { Name: 'Germany', Code: 'DE' }, { Name: 'Ghana', Code: 'GH' }, { Name: 'Gibraltar', Code: 'GI' }, { Name: 'Greece', Code: 'GR' }, { Name: 'Greenland', Code: 'GL' }, { Name: 'Grenada', Code: 'GD' }, { Name: 'Guadeloupe', Code: 'GP' }, { Name: 'Guam', Code: 'GU' }, { Name: 'Guatemala', Code: 'GT' }, { Name: 'Guernsey', Code: 'GG' }, { Name: 'Guinea', Code: 'GN' }, { Name: 'Guinea-Bissau', Code: 'GW' }, { Name: 'Guyana', Code: 'GY' }, { Name: 'Haiti', Code: 'HT' }, { Name: 'Heard Island and Mcdonald Islands', Code: 'HM' }, { Name: 'Holy See (Vatican City State)', Code: 'VA' }, { Name: 'Honduras', Code: 'HN' }, { Name: 'Hong Kong', Code: 'HK' }, { Name: 'Hungary', Code: 'HU' }, { Name: 'Iceland', Code: 'IS' }, { Name: 'India', Code: 'IN' }, { Name: 'Indonesia', Code: 'ID' }, { Name: 'Iran, Islamic Republic Of', Code: 'IR' }, { Name: 'Iraq', Code: 'IQ' }, { Name: 'Ireland', Code: 'IE' }, { Name: 'Isle of Man', Code: 'IM' }, { Name: 'Israel', Code: 'IL' }, { Name: 'Italy', Code: 'IT' }, { Name: 'Jamaica', Code: 'JM' }, { Name: 'Japan', Code: 'JP' }, { Name: 'Jersey', Code: 'JE' }, { Name: 'Jordan', Code: 'JO' }, { Name: 'Kazakhstan', Code: 'KZ' }, { Name: 'Kenya', Code: 'KE' }, { Name: 'Kiribati', Code: 'KI' }, { Name: "Korea, Democratic People's Republic of", Code: 'KP' }, { Name: 'Korea, Republic of', Code: 'KR' }, { Name: 'Kuwait', Code: 'KW' }, { Name: 'Kyrgyzstan', Code: 'KG' }, { Name: "Lao People's Democratic Republic", Code: 'LA' }, { Name: 'Latvia', Code: 'LV' }, { Name: 'Lebanon', Code: 'LB' }, { Name: 'Lesotho', Code: 'LS' }, { Name: 'Liberia', Code: 'LR' }, { Name: 'Libyan Arab Jamahiriya', Code: 'LY' }, { Name: 'Liechtenstein', Code: 'LI' }, { Name: 'Lithuania', Code: 'LT' }, { Name: 'Luxembourg', Code: 'LU' }, { Name: 'Macao', Code: 'MO' }, { Name: 'Macedonia, The Former Yugoslav Republic of', Code: 'MK' }, { Name: 'Madagascar', Code: 'MG' }, { Name: 'Malawi', Code: 'MW' }, { Name: 'Malaysia', Code: 'MY' }, { Name: 'Maldives', Code: 'MV' }, { Name: 'Mali', Code: 'ML' }, { Name: 'Malta', Code: 'MT' }, { Name: 'Marshall Islands', Code: 'MH' }, { Name: 'Martinique', Code: 'MQ' }, { Name: 'Mauritania', Code: 'MR' }, { Name: 'Mauritius', Code: 'MU' }, { Name: 'Mayotte', Code: 'YT' }, { Name: 'Mexico', Code: 'MX' }, { Name: 'Micronesia, Federated States of', Code: 'FM' }, { Name: 'Moldova, Republic of', Code: 'MD' }, { Name: 'Monaco', Code: 'MC' }, { Name: 'Mongolia', Code: 'MN' }, { Name: 'Montserrat', Code: 'MS' }, { Name: 'Morocco', Code: 'MA' }, { Name: 'Mozambique', Code: 'MZ' }, { Name: 'Myanmar', Code: 'MM' }, { Name: 'Namibia', Code: 'NA' }, { Name: 'Nauru', Code: 'NR' }, { Name: 'Nepal', Code: 'NP' }, { Name: 'Netherlands', Code: 'NL' }, { Name: 'Netherlands Antilles', Code: 'AN' }, { Name: 'New Caledonia', Code: 'NC' }, { Name: 'New Zealand', Code: 'NZ' }, { Name: 'Nicaragua', Code: 'NI' }, { Name: 'Niger', Code: 'NE' }, { Name: 'Nigeria', Code: 'NG' }, { Name: 'Niue', Code: 'NU' }, { Name: 'Norfolk Island', Code: 'NF' }, { Name: 'Northern Mariana Islands', Code: 'MP' }, { Name: 'Norway', Code: 'NO' }, { Name: 'Oman', Code: 'OM' }, { Name: 'Pakistan', Code: 'PK' }, { Name: 'Palau', Code: 'PW' }, { Name: 'Palestinian Territory, Occupied', Code: 'PS' }, { Name: 'Panama', Code: 'PA' }, { Name: 'Papua New Guinea', Code: 'PG' }, { Name: 'Paraguay', Code: 'PY' }, { Name: 'Peru', Code: 'PE' }, { Name: 'Philippines', Code: 'PH' }, { Name: 'Pitcairn', Code: 'PN' }, { Name: 'Poland', Code: 'PL' }, { Name: 'Portugal', Code: 'PT' }, { Name: 'Puerto Rico', Code: 'PR' }, { Name: 'Qatar', Code: 'QA' }, { Name: 'Reunion', Code: 'RE' }, { Name: 'Romania', Code: 'RO' }, { Name: 'Russian Federation', Code: 'RU' }, { Name: 'RWANDA', Code: 'RW' }, { Name: 'Saint Helena', Code: 'SH' }, { Name: 'Saint Kitts and Nevis', Code: 'KN' }, { Name: 'Saint Lucia', Code: 'LC' }, { Name: 'Saint Pierre and Miquelon', Code: 'PM' }, { Name: 'Saint Vincent and the Grenadines', Code: 'VC' }, { Name: 'Samoa', Code: 'WS' }, { Name: 'San Marino', Code: 'SM' }, { Name: 'Sao Tome and Principe', Code: 'ST' }, { Name: 'Saudi Arabia', Code: 'SA' }, { Name: 'Senegal', Code: 'SN' }, { Name: 'Serbia and Montenegro', Code: 'CS' }, { Name: 'Seychelles', Code: 'SC' }, { Name: 'Sierra Leone', Code: 'SL' }, { Name: 'Singapore', Code: 'SG' }, { Name: 'Slovakia', Code: 'SK' }, { Name: 'Slovenia', Code: 'SI' }, { Name: 'Solomon Islands', Code: 'SB' }, { Name: 'Somalia', Code: 'SO' }, { Name: 'South Africa', Code: 'ZA' }, { Name: 'South Georgia and the South Sandwich Islands', Code: 'GS' }, { Name: 'Spain', Code: 'ES' }, { Name: 'Sri Lanka', Code: 'LK' }, { Name: 'Sudan', Code: 'SD' }, { Name: 'Suriname', Code: 'SR' }, { Name: 'Svalbard and Jan Mayen', Code: 'SJ' }, { Name: 'Swaziland', Code: 'SZ' }, { Name: 'Sweden', Code: 'SE' }, { Name: 'Switzerland', Code: 'CH' }, { Name: 'Syrian Arab Republic', Code: 'SY' }, { Name: 'Taiwan, Province of China', Code: 'TW' }, { Name: 'Tajikistan', Code: 'TJ' }, { Name: 'Tanzania, United Republic of', Code: 'TZ' }, { Name: 'Thailand', Code: 'TH' }, { Name: 'Timor-Leste', Code: 'TL' }, { Name: 'Togo', Code: 'TG' }, { Name: 'Tokelau', Code: 'TK' }, { Name: 'Tonga', Code: 'TO' }, { Name: 'Trinidad and Tobago', Code: 'TT' }, { Name: 'Tunisia', Code: 'TN' }, { Name: 'Turkey', Code: 'TR' }, { Name: 'Turkmenistan', Code: 'TM' }, { Name: 'Turks and Caicos Islands', Code: 'TC' }, { Name: 'Tuvalu', Code: 'TV' }, { Name: 'Uganda', Code: 'UG' }, { Name: 'Ukraine', Code: 'UA' }, { Name: 'United Arab Emirates', Code: 'AE' }, { Name: 'United Kingdom', Code: 'GB' }, { Name: 'United States', Code: 'US' }, { Name: 'United States Minor Outlying Islands', Code: 'UM' }, { Name: 'Uruguay', Code: 'UY' }, { Name: 'Uzbekistan', Code: 'UZ' }, { Name: 'Vanuatu', Code: 'VU' }, { Name: 'Venezuela', Code: 'VE' }, { Name: 'Viet Nam', Code: 'VN' }, { Name: 'Virgin Islands, British', Code: 'VG' }, { Name: 'Virgin Islands, U.S.', Code: 'VI' }, { Name: 'Wallis and Futuna', Code: 'WF' }, { Name: 'Western Sahara', Code: 'EH' }, { Name: 'Yemen', Code: 'YE' }, { Name: 'Zambia', Code: 'ZM' }, { Name: 'Zimbabwe', Code: 'ZW' }];
	module.exports = exports['default'];

/***/ }),
/* 1174 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var lbCountrySelect = angular.module('app.lbCountrySelect', []);
	
	lbCountrySelect.controller('lbCountrySelectCtrl', __webpack_require__(1176));
	lbCountrySelect.component('lbCountrySelect', __webpack_require__(1175));
	
	exports['default'] = lbCountrySelect;
	module.exports = exports['default'];

/***/ }),
/* 1175 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	__webpack_require__(1623);
	
	var $inject = [];
	
	var lbCountrySelect = {
	  controller: 'lbCountrySelectCtrl as vm',
	  template: __webpack_require__(1706),
	  bindings: {
	    country: '=',
	    required: '<',
	    disabled: '<'
	  }
	};
	
	lbCountrySelect.$inject = $inject;
	
	exports['default'] = lbCountrySelect;
	module.exports = exports['default'];

/***/ }),
/* 1176 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = [];
	
	var lbCountrySelectCtrl = function lbCountrySelectCtrl() {
	  var vm = this;
	
	  var DEFAULT_PLACEHOLDER = 'Select a country';
	
	  vm.required = vm.required || false;
	  vm.placeholder = vm.placeholder || DEFAULT_PLACEHOLDER;
	  vm.countries = __webpack_require__(1173);
	  vm.showLoader = false;
	};
	
	lbCountrySelectCtrl.$inject = $inject;
	
	exports['default'] = lbCountrySelectCtrl;
	module.exports = exports['default'];

/***/ }),
/* 1177 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	__webpack_require__(1624);
	
	var lbCurrencyMessage = angular.module('app.lbCurrencyMessage', []);
	
	lbCurrencyMessage.component('lbCurrencyMessage', {
	  controllerAs: 'vm',
	  controller: ['settingsService', controller],
	  template: __webpack_require__(1707)
	});
	
	function controller(settingsService) {
	  var vm = this;
	
	  vm.currencyCode = settingsService.settings.Currency.Code;
	  vm.message = 'ALL PRICES SHOWN HERE IN ' + vm.currencyCode + ' BASED ON THE CURRENT EXCHANGE RATES WE HAVE ON RECORD';
	}
	
	exports['default'] = lbCurrencyMessage;
	module.exports = exports['default'];

/***/ }),
/* 1178 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	__webpack_require__(1625);
	
	var lbDatePicker = angular.module('app.lbDatePicker', ['pickadate']);
	
	lbDatePicker.component('lbDatePicker', {
	  bindings: {
	    settings: '<'
	  },
	  controllerAs: 'vm',
	  controller: ['$document', '$timeout', 'moment', 'ENUMS', 'dateTimeService', controller],
	  template: __webpack_require__(1709)
	});
	
	function controller($document, $timeout, moment, ENUMS, dateTimeService) {
	  var l = document.getElementById('lbDatePickerClose');
	  l.focus();
	
	  var vm = this;
	
	  // This format is used to pass to the pickadate plugin, it's limited in what formates it can take it
	  var DATE_FORMAT = 'MM/DD/YYYY';
	  vm.dateFormat = 'mm/dd/yyyy';
	
	  vm.dateSelected = dateSelected;
	  vm.closeDatePicker = closeDatePicker;
	  vm.date = vm.settings.defaultDate && moment.isMoment(vm.settings.defaultDate) ? vm.settings.defaultDate.format(DATE_FORMAT) : vm.settings.defaultDate;
	  vm.minDateFormatted = vm.settings.minDate && moment.isMoment(vm.settings.minDate) ? vm.settings.minDate.format(DATE_FORMAT) : vm.settings.minDate;
	  vm.maxDateFormatted = vm.settings.maxDate && moment.isMoment(vm.settings.maxDate) ? vm.settings.maxDate.format(DATE_FORMAT) : vm.settings.maxDate;
	  vm.rangeFromFormatted = vm.settings.rangeFrom && moment.isMoment(vm.settings.rangeFrom) ? vm.settings.rangeFrom.format(DATE_FORMAT) : vm.settings.rangeFrom;
	  vm.rangeToFormatted = vm.settings.rangeTo && moment.isMoment(vm.settings.rangeTo) ? vm.settings.rangeTo.format(DATE_FORMAT) : vm.settings.rangeTo;
	
	  $document.on('keydown', function (e) {
	    keyDown(e);
	  });
	
	  function dateSelected(date) {
	    vm.settings.input.focus();
	    vm.settings.input.selectionEnd = vm.settings.input.selectionStart;
	
	    $timeout(function () {
	      $document.unbind('keydown');
	      vm.settings.callBack({
	        target: vm.settings.parent || vm.settings.input.name,
	        date: date
	      });
	    }, 0);
	  }
	
	  function closeDatePicker() {
	    $document.unbind('keydown');
	    vm.settings.callBack(null, vm.settings.input);
	  }
	
	  function keyDown(e) {
	    e.preventDefault();
	
	    switch (e.keyCode) {
	      case 39:
	        // Right arrow key
	        $timeout(function () {
	          vm.date = moment(vm.date, DATE_FORMAT).add(1, 'd').format(DATE_FORMAT);
	        }, 0);
	        break;
	
	      case 40:
	        // Down arrow key
	        $timeout(function () {
	          vm.date = moment(vm.date, DATE_FORMAT).add(7, 'd').format(DATE_FORMAT);
	        }, 0);
	        break;
	
	      case 37:
	        // Left arrow key
	        $timeout(function () {
	          if (vm.settings.minDate == null || moment.isMoment(vm.settings.minDate) && vm.settings.minDate.isSameOrBefore(moment(vm.date, DATE_FORMAT).subtract(1, 'd'), 'day')) vm.date = moment(vm.date, DATE_FORMAT).subtract(1, 'd').format(DATE_FORMAT);
	        }, 0);
	        break;
	
	      case 38:
	        // Up arrow key
	        $timeout(function () {
	          if (vm.settings.minDate == null || moment.isMoment(vm.settings.minDate) && vm.settings.minDate.isSameOrBefore(moment(vm.date, DATE_FORMAT).subtract(7, 'd'), 'day')) {
	            vm.date = moment(vm.date, DATE_FORMAT).subtract(7, 'd').format(DATE_FORMAT);
	          }
	        }, 0);
	        break;
	
	      case 13:
	        // Enter key
	        $timeout(function () {
	          dateSelected(moment(vm.date, DATE_FORMAT));
	        }, 0);
	        break;
	
	      case 9:
	        // Tab key
	        $timeout(function () {
	          dateSelected(moment(vm.date, DATE_FORMAT));
	        }, 0);
	        break;
	
	      default:
	        console.warn('keyCode not assigned');
	    }
	  }
	}
	
	exports['default'] = lbDatePicker;
	module.exports = exports['default'];

/***/ }),
/* 1179 */,
/* 1180 */,
/* 1181 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var lbDialog = angular.module('app.lbDialog', []);
	
	lbDialog.controller('lbDialogCont', __webpack_require__(1182));
	lbDialog.directive('lbDialog', __webpack_require__(1183));
	lbDialog.service('lbDialogService', __webpack_require__(1184));
	
	exports['default'] = lbDialog;
	module.exports = exports['default'];

/***/ }),
/* 1182 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['lbDialogService'];
	
	var lbDialogCont = function lbDialogCont(lbDialogService) {
	  var vm = this;
	
	  vm.lbDialogService = lbDialogService;
	};
	
	lbDialogCont.$inject = $inject;
	
	exports['default'] = lbDialogCont;
	module.exports = exports['default'];

/***/ }),
/* 1183 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	__webpack_require__(1627);
	
	var $inject = [];
	var lbDialog = function lbDialog() {
	  return {
	    controller: 'lbDialogCont',
	    controllerAs: 'vm',
	    bindToController: true,
	    template: __webpack_require__(1711),
	    scope: {}
	  };
	};
	
	lbDialog.$inject = $inject;
	
	exports['default'] = lbDialog;
	module.exports = exports['default'];

/***/ }),
/* 1184 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['$q'];
	
	var lbDialogService = function lbDialogService($q) {
	  var service = {};
	
	  service.visible = false;
	  service.selectedItem = null;
	  service.returnVal = null;
	
	  service.options = {
	    warningLevel: 'info',
	    submitButtonText: 'Submit',
	    showCancelButton: true
	  };
	
	  service.show = show;
	  service.cancel = cancel;
	  service.submit = submit;
	
	  function show(options) {
	    service.selectedItem = null;
	    service.returnVal = null;
	    service.options = {
	      warningLevel: 'info',
	      submitButtonText: 'Submit',
	      showCancelButton: true,
	      selections: []
	    };
	
	    _.assign(service.options, options);
	
	    service.visible = true;
	
	    service.returnVal = $q.defer();
	
	    service.selectedItem = service.options.selections[0];
	
	    return service.returnVal.promise;
	  }
	
	  function submit() {
	    service.visible = false;
	
	    service.returnVal.resolve({
	      message: 'success',
	      reason: service.selectedItem
	    });
	  }
	
	  function cancel() {
	    service.visible = false;
	
	    service.returnVal.reject({
	      message: 'cancel'
	    });
	  }
	
	  return service;
	};
	
	lbDialogService.$inject = $inject;
	
	exports['default'] = lbDialogService;
	module.exports = exports['default'];

/***/ }),
/* 1185 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	__webpack_require__(1628);
	
	var lbErrorModal = angular.module('app.lbErrorModal', []);
	
	lbErrorModal.component('lbErrorModal', {
	  controllerAs: 'vm',
	  controller: ['lbModalService', lbErrorModalCtrl],
	  template: __webpack_require__(1712)
	});
	
	function lbErrorModalCtrl(lbModalService) {
	  var vm = this;
	
	  var DEFAULT_MSG = 'Error';
	  var DEFAULT_ERROR_DESC = 'Whoops, there has been an error. Please try again.';
	  var DEFAULT_ERROR_DESC_INFO = 'We are really sorry about that.';
	  var DEFAULT_ERROR_TOKEN = '000000';
	  var DEFAULT_SUPPORT_MESSAGE = 'We have sent the error code to the Lightning support team to assist you with your current situation.';
	
	  var DEFAULT_REJECTION = {
	    status: '',
	    statusText: '',
	    data: {}
	  };
	
	  var rejection = lbModalService.params().rejection || DEFAULT_REJECTION;
	
	  // HTTP 2 does not support statusText whereas 1.1 does, so we mimic it to ensure compatibility
	  rejection.statusText = (rejection.statusText || '').toString().trim();
	  if (!rejection.statusText) rejection.statusText = (rejection.headers('statustext') || '').toString().trim();
	
	  vm.warnLevel = lbModalService.params().warnLevel || 'warning';
	  vm.errorMessage = DEFAULT_MSG;
	  vm.errorDesc = DEFAULT_ERROR_DESC;
	
	  var statusMatches = rejection.statusText.toString().match(/.*-(.+)/); // greedy match for a hyphen
	  vm.errorToken = (statusMatches ? statusMatches[1] : DEFAULT_ERROR_TOKEN).toString();
	  if (vm.errorToken !== DEFAULT_ERROR_TOKEN) vm.instructions = 'Your error reference code is ' + vm.errorToken + '.';
	  vm.errorSupportMessage = DEFAULT_SUPPORT_MESSAGE;
	
	  vm.close = lbModalService.resolve;
	
	  if (vm.warnLevel === 'info') {
	    vm.errorDesc = DEFAULT_ERROR_DESC_INFO;
	
	    if (rejection.data.Message) {
	      vm.errorMessage = rejection.data.Message;
	    }
	  }
	
	  if (rejection.data.Instructions) {
	    vm.instructions = rejection.data.Instructions;
	  }
	}
	
	exports['default'] = lbErrorModal;
	module.exports = exports['default'];

/***/ }),
/* 1186 */,
/* 1187 */,
/* 1188 */,
/* 1189 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _toArray(arr) { return Array.isArray(arr) ? arr : Array.from(arr); }
	
	__webpack_require__(1630);
	
	var lbFareRulesModal = angular.module('app.lbFareRulesModal', []);
	
	lbFareRulesModal.component('lbFareRulesModal', {
	  controllerAs: 'vm',
	  controller: ['lbModalService', '$scope', controller],
	  template: __webpack_require__(1714)
	});
	
	function controller(lbModalService, $scope) {
	  var vm = this;
	
	  var params = lbModalService.params();
	  var urlReg = /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g;
	
	  vm.carrierName = params.trip.CarrierName;
	  vm.rulesType = params.fareRules.Type;
	  vm.fareRulesText = params.fareRules.Data;
	
	  function formatString(inputString) {
	    return inputString.replace(/\./g, ".<br><br>");
	  }
	
	  $scope.setActiveTab = function (selectedTab) {
	    angular.forEach($scope.tabs, function (tab) {
	      tab.active = tab === selectedTab;
	    });
	  };
	
	  if (params.fare) {
	    vm.fareInfo = {
	      FareBasis: params.fare.Code.filter(onlyUnique),
	      ResBookDesignCode: params.fare.ResBookDesignCode.filter(onlyUnique),
	      Brands: params.fare.Segments.map(function (seg) {
	        return 'BrandId: ' + seg.BrandId + ', BrandName: ' + seg.BrandName;
	      }).filter(onlyUnique)
	    };
	  }
	
	  function parseStringToObjects(inputString) {
	
	    var createObject = function createObject(title, content, active) {
	      return {
	        title: title,
	        content: content.join('\n').trim(),
	        active: active
	      };
	    };
	
	    var sections = inputString.split(/\d{2}: /).slice(1);
	    var result = sections.map(function (section, index) {
	      var _section$trim$split = section.trim().split('\n');
	
	      var _section$trim$split2 = _toArray(_section$trim$split);
	
	      var title = _section$trim$split2[0];
	
	      var contentArray = _section$trim$split2.slice(1);
	
	      var content = contentArray.join('\n').trim();
	      content = formatString(content);
	      return { title: title.trim(), content: content, active: false };
	    });
	
	    var fareDetailsContent = ['<b>FARE BASIS</b> <BR><BR>', vm.fareInfo.FareBasis, '<BR><BR> <b>BRAND NAME</b> <BR><BR>', vm.fareInfo.Brands, '<BR><BR><b> RESERVATION CLASS OF SERVICE</b> <BR><BR>', vm.fareInfo.ResBookDesignCode];
	
	    result.unshift(createObject("FARE DETAILS", fareDetailsContent, true));
	    var penaltiesIndex = result.findIndex(function (tab) {
	      return tab.title === 'PENALTIES';
	    });
	    if (penaltiesIndex > 0) {
	      var penaltiesTab = result[penaltiesIndex];
	      result.splice(penaltiesIndex, 1);
	      result.splice(1, 0, penaltiesTab);
	    }
	    var surchargesIndex = result.findIndex(function (tab) {
	      return tab.title === 'SURCHARGES';
	    });
	    if (surchargesIndex > 1) {
	      var surchargesTab = result[surchargesIndex];
	      result.splice(surchargesIndex, 2);
	      result.splice(2, 0, surchargesTab);
	    }
	
	    return result;
	  }
	
	  $scope.tabs = parseStringToObjects(vm.fareRulesText);
	
	  if (vm.rulesType === 'ExternalUrl') {
	    vm.fareRulesText = vm.fareRulesText.replace(urlReg, replaceLink);
	  }
	
	  function replaceLink(str) {
	    return '<a href="' + str + '" target="_blank" rel="noreferrer noopener">' + 'Click here to view fare rules' + '</a>';
	  }
	
	  vm.close = lbModalService.resolve;
	  function onlyUnique(value, index, array) {
	    return array.indexOf(value) === index;
	  }
	}
	
	exports['default'] = lbFareRulesModal;
	module.exports = exports['default'];

/***/ }),
/* 1190 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var lbFiveStarRating = angular.module('app.lbFiveStarRating', []);
	
	lbFiveStarRating.controller('lbFiveStarRatingController', __webpack_require__(1191));
	lbFiveStarRating.directive('lbFiveStarRating', __webpack_require__(1192));
	
	exports['default'] = lbFiveStarRating;
	module.exports = exports['default'];

/***/ }),
/* 1191 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['$scope'];
	var lbFiveStarRatingController = function lbFiveStarRatingController($scope) {
	  var vm = this;
	  vm.wholeStars = Math.trunc(vm.rating);
	  vm.starThatNeedsHalfStar = Math.ceil(vm.rating) > vm.wholeStars ? Math.ceil(vm.rating) : 0;
	
	  vm.shouldBeWholeStar = function (whichStar) {
	    return vm.wholeStars >= whichStar;
	  };
	
	  vm.shouldBeHalfStar = function (whichStar) {
	    return vm.starThatNeedsHalfStar == whichStar;
	  };
	
	  vm.shouldBeEmptyStar = function (whichStar) {
	    return vm.wholeStars < whichStar && vm.starThatNeedsHalfStar != whichStar;
	  };
	};
	
	lbFiveStarRatingController.$inject = $inject;
	
	exports['default'] = lbFiveStarRatingController;
	module.exports = exports['default'];

/***/ }),
/* 1192 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	__webpack_require__(1631);
	
	var $inject = [];
	
	var lbFiveStarRating = function lbFiveStarRating() {
	  return {
	    template: __webpack_require__(1715),
	    controller: 'lbFiveStarRatingController',
	    controllerAs: 'vm',
	    bindToController: true,
	    scope: {
	      rating: '='
	    }
	  };
	};
	
	lbFiveStarRating.$inject = $inject;
	
	exports['default'] = lbFiveStarRating;
	module.exports = exports['default'];

/***/ }),
/* 1193 */,
/* 1194 */,
/* 1195 */,
/* 1196 */,
/* 1197 */,
/* 1198 */,
/* 1199 */,
/* 1200 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	__webpack_require__(1635);
	
	var lbHeader = angular.module('app.lbHeader', []);
	
	lbHeader.component('lbHeader', {
	  bindings: {},
	  controllerAs: 'vm',
	  controller: ['cartService', '$rootScope', '$location', '$state', '$timeout', 'authService', 'settingsService', 'itinerariesService', 'lbDialogService', 'beamerService', 'AUTH_EVENTS', controller],
	  template: __webpack_require__(1719)
	});
	
	function controller(cartService, $rootScope, $location, $state, $timeout, authService, settingsService, itinerariesService, lbDialogService, beamerService, AUTH_EVENTS) {
	  var vm = this;
	  var settings = settingsService.settings;
	  vm.itinerary = itinerariesService.itinerary;
	  vm.cartService = cartService;
	  vm.showNotifications = !!window.beamer_config;
	  vm.notificationCount = beamerService.getCount();
	  vm.openNotifications = openNotifications;
	  vm.fullName = settings.UserDetails && settings.UserDetails.UserName || '';
	  $timeout(function () {
	    vm.userInitials = (function () {
	      if (!vm.fullName) return 'LB';
	      var nameArr = vm.fullName.split(' ');
	      if (nameArr.length === 1) return nameArr[0][0];
	      var firstInitial = nameArr[0][0];
	      var lastInitial = nameArr[nameArr.length - 1][0];
	      return '' + firstInitial + lastInitial;
	    })();
	  });
	
	  vm.logout = function () {
	    return isActiveCart() ? openAreYouSureModal('', true) : handelLogout();
	  };
	
	  vm.goTo = function (newPath) {
	    return isActiveCart() ? openAreYouSureModal(newPath) : $state.go(newPath);
	  };
	
	  vm.goMain = function () {
	    if (isActiveCart()) return openAreYouSureModal();
	    cartService.clear();
	    itinerariesService.itinerary = null;
	    return $state.go('app.home');
	  };
	
	  vm.getClass = function (newPath) {
	    if (getPnr()) return newPath === '/my-bookings' ? 'active' : '';
	
	    return getCurClassPath(newPath) === newPath ? 'active' : '';
	  };
	
	  function isActiveCart() {
	    return !!cartService.items.length;
	  }
	
	  function getCurClassPath() {
	    var curPath = $location.path();
	    if (curPath.includes('/my-bookings')) return '/my-bookings';
	    switch (curPath.toLowerCase()) {
	      case '/flights':
	      case '/rail':
	      case '/ground':
	      case '/cars':
	      case '/seats':
	      case '/hotels':
	      case '/confirmation':
	      case '/itinerary':
	        return '/';
	      default:
	        return curPath;
	    }
	  }
	
	  function getPnr() {
	    return itinerariesService.itinerary && itinerariesService.itinerary.Passengers && itinerariesService.itinerary.Passengers[0] && itinerariesService.itinerary.Passengers[0].Pnr || null;
	  }
	
	  function openNotifications() {
	    $rootScope.$broadcast('openBeamer');
	    vm.notificationCount = 0;
	  }
	
	  function openAreYouSureModal() {
	    var newPath = arguments.length <= 0 || arguments[0] === undefined ? 'app.home' : arguments[0];
	    var doLogout = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
	
	    lbDialogService.show({
	      title: getPnr() ? 'This will quit the current modifications' : 'This will quit the current booking.',
	      message: 'Are you sure you want to do this?',
	      warningLevel: 'warning',
	      submitButtonText: 'OK'
	    }).then(function () {
	      itinerariesService.itinerary = null;
	      cartService.clear();
	      if (doLogout) {
	        handelLogout();
	      } else {
	        $state.go(newPath);
	      }
	    });
	  }
	
	  function handelLogout() {
	    authService.logout().then(function () {
	      return $rootScope.$broadcast(AUTH_EVENTS.logoutSuccess);
	    });
	  }
	}
	
	exports['default'] = lbHeader;
	module.exports = exports['default'];

/***/ }),
/* 1201 */,
/* 1202 */,
/* 1203 */,
/* 1204 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	__webpack_require__(1637);
	
	var lbHotelPriceCheckModal = angular.module('app.lbHotelPriceCheckModal', []);
	
	lbHotelPriceCheckModal.component('lbHotelPriceCheckModal', {
	  controllerAs: 'vm',
	  controller: ['lbModalService', lbHotelPriceCheckModalCtrl],
	  template: __webpack_require__(1721)
	});
	
	function lbHotelPriceCheckModalCtrl(lbModalService) {
	  var vm = this;
	
	  vm.display = lbModalService.params().display;
	  vm.status = lbModalService.params().status;
	
	  vm.close = lbModalService.resolve;
	}
	
	exports['default'] = lbHotelPriceCheckModal;
	module.exports = exports['default'];

/***/ }),
/* 1205 */,
/* 1206 */,
/* 1207 */,
/* 1208 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var lbLoadingPlaceholder = angular.module('app.lbLoadingPlaceholder', []);
	
	lbLoadingPlaceholder.component('lbLoadingPlaceholder', __webpack_require__(1209));
	lbLoadingPlaceholder.component('lbLoadingPlaceholderItem', __webpack_require__(1210));
	lbLoadingPlaceholder.controller('lbLoadingPlaceholderItemCtrl', __webpack_require__(1211));
	
	exports['default'] = lbLoadingPlaceholder;
	module.exports = exports['default'];

/***/ }),
/* 1209 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	__webpack_require__(1123);
	
	var $inject = [];
	
	var lbLoadingPlaceholder = {
	  template: __webpack_require__(1723),
	  transclude: true
	};
	
	lbLoadingPlaceholder.$inject = $inject;
	
	exports['default'] = lbLoadingPlaceholder;
	module.exports = exports['default'];

/***/ }),
/* 1210 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	__webpack_require__(1123);
	
	var $inject = [];
	
	var lbLoadingPlaceholderItem = {
	  template: __webpack_require__(1724),
	  controller: 'lbLoadingPlaceholderItemCtrl',
	  controllerAs: 'vm',
	  bindings: {
	    total: '<',
	    isHeading: '<',
	    width: '<'
	  }
	};
	
	lbLoadingPlaceholderItem.$inject = $inject;
	
	exports['default'] = lbLoadingPlaceholderItem;
	module.exports = exports['default'];

/***/ }),
/* 1211 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = [];
	
	var lbLoadingPlaceholderItemCtrl = function lbLoadingPlaceholderItemCtrl() {
	  var vm = this;
	
	  vm.items = createItems(vm.total);
	  vm.getItemWidth = getItemWidth;
	
	  function createItems() {
	    var totalItems = arguments.length <= 0 || arguments[0] === undefined ? 1 : arguments[0];
	
	    return _.map(_.times(totalItems), function (item) {
	      return {
	        width: getItemWidth(item)
	      };
	    });
	  }
	
	  function getItemWidth(itemIndex) {
	    return vm.width ? vm.width : itemIndex === 0 ? '100%' : randomWidth();
	  }
	
	  function randomWidth() {
	    return _.random(85, 100) + '%';
	  }
	};
	
	lbLoadingPlaceholderItemCtrl.$inject = $inject;
	
	exports['default'] = lbLoadingPlaceholderItemCtrl;
	module.exports = exports['default'];

/***/ }),
/* 1212 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	__webpack_require__(1639);
	
	var $inject = [];
	
	var lbLocationSelect = {
	  controller: 'lbLocationSelectCtrl as vm',
	  template: __webpack_require__(1725),
	  bindings: {
	    name: '@',
	    location: '=?',
	    airportCode: '=?',
	    required: '<',
	    disabled: '<',
	    placeholder: '<?',
	    sct: '<?',
	    isPublic: '<?'
	  }
	};
	
	lbLocationSelect.$inject = $inject;
	
	exports['default'] = lbLocationSelect;
	module.exports = exports['default'];

/***/ }),
/* 1213 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['iataSearchService'];
	
	var lbLocationSelectCtrl = function lbLocationSelectCtrl(iataSearchService) {
	  var vm = this;
	
	  var MIN_SEARCH_TEXT_LENGTH = 2;
	  var MAX_SEARCH_RESULTS = 10;
	  var DEFAULT_PLACEHOLDER = 'Enter a location';
	
	  vm.required = vm.required || false;
	  vm.isPublic = !!vm.isPublic;
	  vm.placeholder = vm.placeholder || DEFAULT_PLACEHOLDER;
	  vm.locations = [];
	  vm.showLoader = false;
	
	  vm.refreshLocations = refreshLocations;
	  vm.groupBy = groupBy;
	  vm.remove = remove;
	  vm.select = select;
	
	  if (vm.airportCode) {
	    vm.showLoader = true;
	
	    iataSearchService.getMetroGrouped({
	      maxRows: MAX_SEARCH_RESULTS,
	      term: vm.airportCode
	    }, vm.isPublic).then(function (result) {
	      vm.location = _.find(result, { Value: vm.airportCode });
	      vm.showLoader = false;
	    });
	  }
	
	  function refreshLocations(searchText) {
	    if (searchText.length < MIN_SEARCH_TEXT_LENGTH) {
	      return false;
	    }
	
	    vm.showLoader = true;
	
	    iataSearchService.getMetroGrouped({
	      maxRows: MAX_SEARCH_RESULTS,
	      term: searchText
	    }, vm.isPublic).then(function (result) {
	      vm.locations = result;
	      vm.showLoader = false;
	    });
	  }
	
	  function groupBy(item) {
	    return item.groupedBy;
	  }
	
	  function remove() {
	    vm.location = null;
	    vm.airportCode = '';
	  }
	
	  function select(location) {
	    vm.airportCode = location.Value;
	  }
	};
	
	lbLocationSelectCtrl.$inject = $inject;
	
	exports['default'] = lbLocationSelectCtrl;
	module.exports = exports['default'];

/***/ }),
/* 1214 */,
/* 1215 */,
/* 1216 */,
/* 1217 */,
/* 1218 */,
/* 1219 */,
/* 1220 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var lbModal = angular.module('app.lbModal', []);
	
	lbModal.controller('lbModalCtrl', __webpack_require__(1221));
	lbModal.directive('lbModal', __webpack_require__(1222));
	lbModal.service('lbModalService', __webpack_require__(1223));
	
	exports['default'] = lbModal;
	module.exports = exports['default'];

/***/ }),
/* 1221 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['$rootScope'];
	
	var lbModalCtrl = function lbModalCtrl($rootScope) {
	  var vm = this;
	
	  vm.modalContent = null;
	  vm.options = {};
	
	  $rootScope.$on('modals.open', function handleModalOpenEvent(event, modalContent, options) {
	    vm.modalContent = modalContent;
	    vm.options = options;
	  });
	
	  $rootScope.$on('modals.close', function handleModalCloseEvent() {
	    vm.modalContent = null;
	    vm.className = '';
	  });
	};
	
	lbModalCtrl.$inject = $inject;
	
	exports['default'] = lbModalCtrl;
	module.exports = exports['default'];

/***/ }),
/* 1222 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	__webpack_require__(1642);
	
	var $inject = ['$compile'];
	
	var lbModal = function lbModal($compile) {
	  return {
	    bindToController: true,
	    controllerAs: 'vm',
	    controller: 'lbModalCtrl',
	    template: __webpack_require__(1728),
	    scope: {
	      width: '<?',
	      className: '<?'
	    },
	    link: function link(scope, ele, attrs) {
	      scope.$watch('vm.modalContent', function (modalContent) {
	        if (modalContent) {
	          var contentEle = ele[0].querySelector('.lbModal_content');
	          contentEle.innerHTML = modalContent;
	          $compile(contentEle)(scope);
	        }
	      });
	    }
	  };
	};
	
	lbModal.$inject = $inject;
	
	exports['default'] = lbModal;
	module.exports = exports['default'];

/***/ }),
/* 1223 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['$rootScope', '$q'];
	
	var lbModalService = function lbModalService($rootScope, $q) {
	  var service = {};
	
	  var modal = {
	    deferred: null,
	    params: null
	  };
	
	  service.open = open;
	  service.params = params;
	  service.proceedTo = proceedTo;
	  service.reject = reject;
	  service.resolve = resolve;
	
	  function open(type, options, params, pipeResponse) {
	    var previousDeferred = modal.deferred;
	
	    modal.deferred = $q.defer();
	    modal.params = params;
	
	    if (previousDeferred && pipeResponse) {
	      modal.deferred.promise.then(previousDeferred.resolve, previousDeferred.reject);
	    } else if (previousDeferred) {
	      previousDeferred.reject();
	    }
	
	    options = options || {};
	
	    if (options.width) {
	      options.width = options.width + 'px';
	    }
	
	    options.scroll = options.scroll || false;
	
	    $rootScope.$emit('modals.open', type, options);
	
	    return modal.deferred.promise;
	  }
	
	  function params() {
	    return modal.params || {};
	  }
	
	  function proceedTo(type, params) {
	    return open(type, params, true);
	  }
	
	  function reject(reason) {
	    if (!modal.deferred) {
	      return;
	    }
	
	    modal.deferred.reject(reason);
	
	    modal.deferred = modal.params = null;
	
	    $rootScope.$emit('modals.close');
	  }
	
	  function resolve(response) {
	    if (!modal.deferred) {
	      return;
	    }
	
	    modal.deferred.resolve(response);
	
	    modal.deferred = modal.params = null;
	
	    $rootScope.$emit('modals.close');
	  }
	
	  return service;
	};
	
	lbModalService.$inject = $inject;
	
	exports['default'] = lbModalService;
	module.exports = exports['default'];

/***/ }),
/* 1224 */,
/* 1225 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	__webpack_require__(1644);
	
	var $inject = [];
	
	var lbPoiSelect = {
	  controller: 'lbPoiSelectCtrl as vm',
	  template: __webpack_require__(1730),
	  bindings: {
	    name: '@',
	    location: '=',
	    defaultOptions: '<?',
	    required: '<',
	    disabled: '<',
	    showLoader: '<',
	    disablePlaceholder: '<',
	    placeholdertext: '@',
	    iconClassName: '<?',
	    searchtypes: '@',
	    onSelect: '&',
	    companyLocationsOnly: '<'
	  }
	};
	
	lbPoiSelect.$inject = $inject;
	
	exports['default'] = lbPoiSelect;
	module.exports = exports['default'];

/***/ }),
/* 1226 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['locationsSearchService', '$scope'];
	
	var lbPoiSelectCtrl = function lbPoiSelectCtrl(locationsSearchService, $scope) {
	  var vm = this;
	
	  var MIN_SEARCH_TEXT_LENGTH = 2;
	  var MAX_SEARCH_RESULTS = 10;
	  var REFRESH_DELAY = 1000;
	  var placeholdertext = vm.placeholdertext || 'Destination, airport, train station, landmark or hotel';
	
	  vm.allowClear = true;
	  vm.required = vm.required || false;
	  vm.placeholder = vm.disablePlaceholder ? '' : placeholdertext;
	  vm.iconClassName = vm.iconClassName || 'ico-marker';
	  vm.options = [];
	  vm.defaultOptions = vm.defaultOptions || [];
	  vm.showLoader = vm.showLoader || false;
	  vm.refreshDelay = REFRESH_DELAY;
	
	  vm.refreshOptions = refreshOptions;
	  vm.onRemove = onRemove;
	
	  vm.defaultOptions = _.orderBy(vm.defaultOptions, 'Title');
	
	  vm.options = _.clone(vm.defaultOptions);
	
	  $scope.$watch('vm.companyLocationsOnly', function (newValue, oldValue) {
	    if (newValue !== oldValue) {
	      vm.options = [];
	      vm.location = null;
	    }
	    if (newValue === true) {
	      populateCompanyLocations();
	    }
	  });
	
	  function populateCompanyLocations() {
	    if (vm.companyLocationsOnly) {
	      locationsSearchService.getCompanyLocations({
	        maxRows: 0,
	        term: '',
	        searchTypes: ''
	      }).then(function (result) {
	        vm.defaultOptions = _.orderBy(result, 'Title');
	        vm.options = result;
	      });
	    }
	  }
	
	  function refreshOptions(search) {
	    if (search.length <= MIN_SEARCH_TEXT_LENGTH && !vm.companyLocationsOnly) {
	      return vm.defaultOptions;
	    }
	
	    vm.showLoader = true;
	
	    if (vm.companyLocationsOnly) {
	      if (search.length <= MIN_SEARCH_TEXT_LENGTH) {
	        populateCompanyLocations();
	        vm.showLoader = false;
	        return vm.defaultOptions;
	      } else {
	        vm.showLoader = false;
	        vm.options = vm.defaultOptions.filter(function (option) {
	          return option.Title.toLowerCase().indexOf(search.toLowerCase()) > -1;
	        });
	      }
	    } else {
	      return locationsSearchService.get({
	        maxRows: MAX_SEARCH_RESULTS,
	        term: search,
	        searchTypes: vm.searchtypes
	      }).then(function (result) {
	        vm.defaultOptions = _.orderBy(result, 'Title');
	        vm.options = result;
	      })['finally'](function () {
	        vm.showLoader = false;
	      });
	    }
	  }
	
	  function onRemove() {
	    vm.options = _.clone(vm.defaultOptions);
	  }
	};
	
	lbPoiSelectCtrl.$inject = $inject;
	
	exports['default'] = lbPoiSelectCtrl;
	module.exports = exports['default'];

/***/ }),
/* 1227 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = [];
	
	var poiHighlightFilter = function poiHighlightFilter() {
	  function escapeRegexp(queryToEscape) {
	    return ('' + queryToEscape).replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1');
	  }
	
	  function highlight(matchItem, query) {
	    return ('' + matchItem).replace(new RegExp(escapeRegexp(query), 'gi'), '<span' + ' class="ui-select-highlight">$&</span>');
	  }
	
	  function stripStopWords(text) {
	    var tokens = text.split(' ');
	    var stopwords = ['an', 'and', 'as', 'at', 'be', 'by', 'for', 'has', 'here', 'if', 'in', 'is', 'it', 'my', 'of', 'on', 'or', 'that', 'the', 'their', 'them', 'then', 'there', 'these', 'they', 'this', 'those', 'to', 'too', 'up', 'was', 'way', 'we', 'were', 'what', 'where', 'which', 'while', 'who', 'with', 'would', 'you', 'your', 'a', 'i'];
	
	    return tokens.filter(function (value) {
	      return stopwords.indexOf(value.toLowerCase()) === -1;
	    }).join(' ');
	  }
	
	  return function (matchItem, query) {
	    if (!query || !matchItem) {
	      return matchItem;
	    }
	
	    var highlightedMatchItem = highlight(matchItem, query);
	
	    if (highlightedMatchItem === matchItem) {
	      query = stripStopWords(query);
	      highlightedMatchItem = highlight(matchItem, query);
	    }
	
	    return highlightedMatchItem;
	  };
	};
	
	exports['default'] = poiHighlightFilter;
	module.exports = exports['default'];

/***/ }),
/* 1228 */,
/* 1229 */,
/* 1230 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	__webpack_require__(1647);
	
	var lbResolveLoader = angular.module('app.lbResolveLoader', []);
	
	lbResolveLoader.component('lbResolveLoader', {
	    controller: ['$rootScope', lbResolveLoaderCtrl],
	    template: '\n    <div ng-if="$root.showLoader">\n        <div class="lbResolveLoader_mask"></div>\n        <div class="lbResolveLoader">\n            <div class="lbResolveLoader_container">\n                <i class="button_spinner"></i>\n                <span class="lbResolveLoader_text">Loading</span>\n            </div>\n        </div>\n    </div>\n  '
	});
	
	function lbResolveLoaderCtrl($rootScope) {
	    $rootScope.showLoader = true;
	}
	
	exports['default'] = lbResolveLoader;
	module.exports = exports['default'];

/***/ }),
/* 1231 */,
/* 1232 */,
/* 1233 */,
/* 1234 */,
/* 1235 */,
/* 1236 */,
/* 1237 */,
/* 1238 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var lbTimeSelect = angular.module('app.lbTimeSelect', []);
	
	lbTimeSelect.controller('lbTimeSelectCtrl', __webpack_require__(1240));
	lbTimeSelect.component('lbTimeSelect', __webpack_require__(1239));
	
	exports['default'] = lbTimeSelect;
	module.exports = exports['default'];

/***/ }),
/* 1239 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	__webpack_require__(1649);
	
	var $inject = [];
	
	var lbTimeSelect = {
	  controller: 'lbTimeSelectCtrl as vm',
	  template: __webpack_require__(1736),
	  bindings: {
	    date: '<',
	    time: '=',
	    timeFormat: '@',
	    name: '@',
	    required: '<',
	    disabled: '<',
	    sequentialTime: '@',
	    beforeDate: '<',
	    beforeTime: '<',
	    anytime: '@'
	  }
	};
	
	lbTimeSelect.$inject = $inject;
	
	exports['default'] = lbTimeSelect;
	module.exports = exports['default'];

/***/ }),
/* 1240 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['$scope', '$filter', 'timesService', 'ENUMS', 'dateTimeService'];
	
	var lbTimeSelectCtrl = function lbTimeSelectCtrl($scope, $filter, timesService, ENUMS, dateTimeService) {
	  var vm = this;
	
	  var TIME_FORMAT = dateTimeService.getFormat(ENUMS.dateTimeFormats.TIME_LONG);
	
	  vm.times = timesService.getSelectOptions(TIME_FORMAT, true);
	  vm.inputName = vm.name + '.' + vm.index;
	
	  vm.selectedTime = vm.time;
	
	  $scope.$watch('vm.selectedTime', function (selectedTime) {
	    vm.time = selectedTime;
	  });
	};
	
	lbTimeSelectCtrl.$inject = $inject;
	
	exports['default'] = lbTimeSelectCtrl;
	module.exports = exports['default'];

/***/ }),
/* 1241 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	__webpack_require__(1650);
	
	var lbTimeoutModal = angular.module('app.lbTimeoutModal', []);
	
	lbTimeoutModal.component('lbTimeoutModal', {
	  controller: ['lbModalService', 'Idle', lbTimeoutModalCtrl],
	  controllerAs: 'vm',
	  template: __webpack_require__(1737)
	});
	
	function lbTimeoutModalCtrl(lbModalService, Idle) {
	  var vm = this;
	
	  vm.timeoutValue = Idle.getTimeout();
	
	  vm.close = close;
	  vm.getCountdownNoun = getCountdownNoun;
	
	  function getCountdownNoun(countdown) {
	    return countdown === 1 ? 'second' : 'seconds';
	  }
	
	  function close() {
	    lbModalService.resolve();
	    Idle.watch();
	  }
	}
	
	exports['default'] = lbTimeoutModal;
	module.exports = exports['default'];

/***/ }),
/* 1242 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var lbToggle = angular.module('app.lbToggle', []);
	
	lbToggle.controller('lbToggleCtrl', __webpack_require__(1244));
	lbToggle.component('lbToggle', __webpack_require__(1243));
	
	exports['default'] = lbToggle;
	module.exports = exports['default'];

/***/ }),
/* 1243 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	__webpack_require__(1651);
	
	var $inject = [];
	
	var lbToggle = {
	  controller: 'lbToggleCtrl as vm',
	  template: __webpack_require__(1738),
	  bindings: {
	    isActive: '=',
	    onChange: '&'
	  }
	};
	
	lbToggle.$inject = $inject;
	
	exports['default'] = lbToggle;
	module.exports = exports['default'];

/***/ }),
/* 1244 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var $inject = [];
	
	var lbToggleCtrl = function lbToggleCtrl() {
	  var vm = this;
	
	  vm.toggle = toggle;
	
	  function toggle() {
	    vm.isActive = !vm.isActive;
	    vm.onChange({ isActive: vm.isActive });
	  }
	};
	
	lbToggleCtrl.$inject = $inject;
	
	exports["default"] = lbToggleCtrl;
	module.exports = exports["default"];

/***/ }),
/* 1245 */,
/* 1246 */,
/* 1247 */,
/* 1248 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var lbTripOptionsModal = angular.module('app.lbTripOptionsModal', [__webpack_require__(543).name]);
	
	lbTripOptionsModal.controller('lbTripOptionsModalCtrl', __webpack_require__(1258));
	lbTripOptionsModal.component('lbTripOptionsModal', __webpack_require__(1257));
	lbTripOptionsModal.controller('lbTripOptionsHotelFormCtrl', __webpack_require__(1254));
	lbTripOptionsModal.component('lbTripOptionsHotelForm', __webpack_require__(1253));
	lbTripOptionsModal.controller('lbTripOptionsHotelFormItemCtrl', __webpack_require__(1256));
	lbTripOptionsModal.component('lbTripOptionsHotelFormItem', __webpack_require__(1255));
	lbTripOptionsModal.controller('lbTripOptionsCarFormCtrl', __webpack_require__(1250));
	lbTripOptionsModal.component('lbTripOptionsCarForm', __webpack_require__(1249));
	lbTripOptionsModal.controller('lbTripOptionsCarFormItemCtrl', __webpack_require__(1252));
	lbTripOptionsModal.component('lbTripOptionsCarFormItem', __webpack_require__(1251));
	
	exports['default'] = lbTripOptionsModal;
	module.exports = exports['default'];

/***/ }),
/* 1249 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = [];
	
	var lbTripOptionsHotelForm = {
	  controller: 'lbTripOptionsCarFormCtrl as vm',
	  template: __webpack_require__(1740),
	  bindings: {
	    searches: '=',
	    optionsForm: '='
	  }
	};
	
	lbTripOptionsHotelForm.$inject = $inject;
	
	exports['default'] = lbTripOptionsHotelForm;
	module.exports = exports['default'];

/***/ }),
/* 1250 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['$scope', 'moment'];
	
	var lbTripOptionsCarFormCtrl = function lbTripOptionsCarFormCtrl($scope, moment) {
	  var vm = this;
	
	  var apiDateFormat = 'YYYY-MM-DD[T]HH:mm:ss';
	  var displayDateFormat = 'ddd Do MMM, YYYY';
	
	  $scope.$watch('vm.searches', validateSearches, true);
	
	  function validateSearches(searches) {
	    _.forEach(searches, function (search, searchIndex) {
	      var dateFromMoment = moment(search.car.pickUp.Date, displayDateFormat);
	      var dateToMoment = moment(search.car.dropOff.Date, displayDateFormat);
	
	      if (dateToMoment.isBefore(dateFromMoment)) {
	        search.car.dropOff.Date = search.car.pickUp.Date;
	      }
	    });
	  }
	};
	
	lbTripOptionsCarFormCtrl.$inject = $inject;
	
	exports['default'] = lbTripOptionsCarFormCtrl;
	module.exports = exports['default'];

/***/ }),
/* 1251 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = [];
	
	var lbTripOptionsCarFormItem = {
	  controller: 'lbTripOptionsCarFormItemCtrl as vm',
	  template: __webpack_require__(1741),
	  bindings: {
	    search: '<',
	    isLast: '<',
	    index: '<'
	  }
	};
	
	lbTripOptionsCarFormItem.$inject = $inject;
	
	exports['default'] = lbTripOptionsCarFormItem;
	module.exports = exports['default'];

/***/ }),
/* 1252 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['$filter', 'moment', 'ENUMS', 'dateTimeService'];
	
	var lbTripOptionCarFormItemCtrl = function lbTripOptionCarFormItemCtrl($filter, moment, ENUMS, dateTimeService) {
	  var vm = this;
	
	  var timeFormat = dateTimeService.getFormat(ENUMS.dateTimeFormats.TIME_LONG);
	
	  vm.flightDateTimeFormat = 'DD MMM[,] YYYY ' + timeFormat;
	};
	
	lbTripOptionCarFormItemCtrl.$inject = $inject;
	
	exports['default'] = lbTripOptionCarFormItemCtrl;
	module.exports = exports['default'];

/***/ }),
/* 1253 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = [];
	
	var lbTripOptionsHotelForm = {
	  controller: 'lbTripOptionsHotelFormCtrl as vm',
	  template: __webpack_require__(1742),
	  bindings: {
	    searches: '=',
	    optionsForm: '='
	  }
	};
	
	lbTripOptionsHotelForm.$inject = $inject;
	
	exports['default'] = lbTripOptionsHotelForm;
	module.exports = exports['default'];

/***/ }),
/* 1254 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['$scope', 'moment'];
	
	var lbTripOptionsHotelFormCtrl = function lbTripOptionsHotelFormCtrl($scope, moment) {
	  var vm = this;
	
	  var apiDateFormat = 'YYYY-MM-DD[T]HH:mm:ss';
	  var displayDateFormat = 'ddd Do MMM, YYYY';
	
	  $scope.$watch('vm.searches', validateSearches, true);
	
	  function validateSearches(searches) {
	    _.forEach(searches, function (search, searchIndex) {
	      var dateFromMoment = moment(search.hotel.dateFrom, displayDateFormat);
	      var dateToMoment = moment(search.hotel.dateTo, displayDateFormat);
	      var minDateFromMoment = moment(search.hotel.minDateFrom, displayDateFormat);
	
	      if (dateFromMoment.isBefore(minDateFromMoment)) {
	        search.hotel.dateFrom = search.hotel.minDateFrom;
	      }
	
	      if (dateToMoment.isBefore(dateFromMoment)) {
	        search.hotel.dateTo = moment(search.hotel.dateFrom, displayDateFormat).add(1, 'days').format(displayDateFormat);
	      }
	    });
	  }
	};
	
	lbTripOptionsHotelFormCtrl.$inject = $inject;
	
	exports['default'] = lbTripOptionsHotelFormCtrl;
	module.exports = exports['default'];

/***/ }),
/* 1255 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = [];
	
	var lbTripOptionsHotelFormItem = {
	  controller: 'lbTripOptionsHotelFormItemCtrl as vm',
	  template: __webpack_require__(1743),
	  bindings: {
	    search: '<',
	    isLast: '<',
	    index: '<'
	  }
	};
	
	lbTripOptionsHotelFormItem.$inject = $inject;
	
	exports['default'] = lbTripOptionsHotelFormItem;
	module.exports = exports['default'];

/***/ }),
/* 1256 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['$filter', 'moment', 'ENUMS', 'dateTimeService'];
	
	var lbTripOptionsHotelFormItemCtrl = function lbTripOptionsHotelFormItemCtrl($filter, moment, ENUMS, dateTimeService) {
	  var vm = this;
	
	  var dateTimeFormat = dateTimeService.getFormat(ENUMS.dateTimeFormats.DATE_TIME_LONG);
	
	  vm.flightDateTimeFormat = dateTimeFormat;
	};
	
	lbTripOptionsHotelFormItemCtrl.$inject = $inject;
	
	exports['default'] = lbTripOptionsHotelFormItemCtrl;
	module.exports = exports['default'];

/***/ }),
/* 1257 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	__webpack_require__(1653);
	
	var $inject = [];
	
	var lbTripOptionsModal = {
	  controller: 'lbTripOptionsModalCtrl as vm',
	  template: __webpack_require__(1744),
	  bindings: {}
	};
	
	lbTripOptionsModal.$inject = $inject;
	
	exports['default'] = lbTripOptionsModal;
	module.exports = exports['default'];

/***/ }),
/* 1258 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['$filter', 'moment', 'lbModalService', 'itinerariesService', 'ENUMS', 'dateTimeService'];
	
	var lbTripOptionsModalCtrl = function lbTripOptionsModalCtrl($filter, moment, lbModalService, itinerariesService, ENUMS, dateTimeService) {
	  var vm = this;
	
	  vm.itinerary = {};
	  vm.searches = {};
	  vm.options = [];
	  vm.activeOptionIndex = 0;
	  vm.form = {};
	  vm.saving = false;
	  vm.datePickerDateFormat = 'ddd Do MMM, YYYY';
	  vm.apiDateFormat = 'YYYY-MM-DD[T]HH:mm:ss';
	  vm.displayDateFormat = dateTimeService.getFormat(ENUMS.dateTimeFormats.DATE_MEDIUM);
	  vm.displayTimeFormat = dateTimeService.getFormat(ENUMS.dateTimeFormats.TIME_LONG);
	
	  vm.prev = prev;
	  vm.next = next;
	  vm.submit = submit;
	  vm.close = close;
	
	  vm.$onInit = function () {
	    vm.itinerary = lbModalService.params().itinerary;
	    vm.searches.flights = lbModalService.params().flights;
	
	    if (lbModalService.params().hasHotels) {
	      vm.options.push('hotel');
	      vm.searches.hotels = [];
	
	      _.forEach(vm.searches.flights, function (flightSearch, flightSearchIndex) {
	        if (flightSearchIndex < vm.searches.flights.length - 1) {
	          vm.searches.hotels.push(hotelSearch(flightSearchIndex, flightSearch, vm.searches.flights[flightSearchIndex + 1]));
	        }
	      });
	    }
	
	    if (lbModalService.params().hasCars) {
	      vm.options.push('car');
	      vm.searches.cars = [];
	
	      _.forEach(vm.searches.flights, function (flightSearch, flightSearchIndex) {
	        if (flightSearchIndex < vm.searches.flights.length - 1) {
	          vm.searches.cars.push(carSearch(flightSearchIndex, flightSearch, vm.searches.flights[flightSearchIndex + 1]));
	        }
	      });
	    }
	  };
	
	  function hotelSearch(flightSearchIndex, flightSearch, nextFlightSearch) {
	    var hotelSearch = {
	      isActive: false
	    };
	
	    hotelSearch.flight = flightSearch;
	
	    hotelSearch.hotel = {
	      key: 'hotel' + flightSearchIndex,
	      maxDate: moment().add(330, 'days').format(vm.displayDateFormat),
	      minDateFrom: moment(flightSearch.Arrival.Date, vm.apiDateFormat).format(vm.displayDateFormat),
	      dateFrom: moment(flightSearch.Arrival.Date, vm.apiDateFormat).format(vm.displayDateFormat),
	      dateTo: moment(nextFlightSearch.Departure.Date, vm.apiDateFormat).format(vm.displayDateFormat),
	      Location: {
	        Title: flightSearch.Arrival.City,
	        City: {
	          Code: flightSearch.Arrival.Code
	        },
	        Type: 'Airport',
	        Latitude: null,
	        Longitude: null
	      }
	    };
	
	    return hotelSearch;
	  }
	
	  function carSearch(flightSearchIndex, flightSearch, nextFlightSearch) {
	    var carSearch = {
	      isActive: false
	    };
	
	    carSearch.flight = flightSearch;
	
	    carSearch.car = {
	      key: 'car' + flightSearchIndex,
	      pickUp: {
	        maxDate: moment().add(330, 'days').format(vm.displayDateFormat),
	        minDate: moment(flightSearch.Arrival.Date, vm.apiDateFormat).format(vm.displayDateFormat),
	        Date: moment(flightSearch.Arrival.Date, vm.apiDateFormat).format(vm.displayDateFormat),
	        Time: nearestValidSearchTime(flightSearch.Arrival.Date),
	        Location: {
	          Name: flightSearch.Arrival.Location,
	          Value: flightSearch.Arrival.Code
	        }
	      },
	      dropOff: {
	        maxDate: moment().add(330, 'days').format(vm.displayDateFormat),
	        minDate: moment(flightSearch.Arrival.Date, vm.apiDateFormat).add(1, 'days').format(vm.displayDateFormat),
	        Date: moment(nextFlightSearch.Departure.Date, vm.apiDateFormat).format(vm.displayDateFormat),
	        Time: nearestValidSearchTime(nextFlightSearch.Departure.Date),
	        Location: {
	          Name: nextFlightSearch.Departure.Location,
	          Value: nextFlightSearch.Departure.Code
	        }
	      }
	    };
	
	    return carSearch;
	  }
	
	  function nearestValidSearchTime(date) {
	    var start = moment(date, vm.apiDateFormat);
	    var remainder = 30 - start.minute() % 30;
	
	    return moment(start).add(remainder, 'minutes').format(vm.displayTimeFormat);
	  }
	
	  function prev() {
	    vm.activeOptionIndex -= 1;
	  }
	
	  function next() {
	    vm.activeOptionIndex += 1;
	  }
	
	  function submit() {
	    if (vm.form.$invalid) {
	      vm.isDisabled = false;
	      return false;
	    }
	
	    vm.saving = true;
	
	    var updatedItinerarySearch = angular.copy(itinerariesService.itinerary.Search);
	    updatedItinerarySearch.Hotels = buildHotelSearches(vm.searches.hotels);
	    updatedItinerarySearch.Cars = buildCarSearches(vm.searches.cars);
	
	    itinerariesService.postSearch(updatedItinerarySearch).then(function () {
	      lbModalService.resolve();
	    })['finally'](function () {
	      vm.saving = false;
	    });
	  }
	
	  function buildHotelSearches(searches) {
	    var hotelSearches = [];
	
	    _.forEach(searches, function (search) {
	      if (search.isActive) {
	        hotelSearches.push({
	          DateFrom: moment(search.hotel.dateFrom, vm.displayDateFormat).format(vm.apiDateFormat),
	          DateTo: moment(search.hotel.dateTo, vm.displayDateFormat).format(vm.apiDateFormat),
	          Location: {
	            Code: search.hotel.Location.City.Code,
	            Name: search.hotel.Location.Title,
	            Type: search.hotel.Location.Type,
	            Latitude: search.hotel.Location.Latitude,
	            Longitude: search.hotel.Location.Longitude
	          }
	        });
	      }
	    });
	
	    return hotelSearches;
	  }
	
	  function buildCarSearches(searches) {
	    var carSearches = [];
	
	    _.forEach(searches, function (search) {
	      if (search.isActive) {
	        carSearches.push({
	          DropOff: {
	            Code: search.car.dropOff.Location.Value,
	            Date: moment('' + search.car.dropOff.Date + search.car.dropOff.Time, '' + vm.displayDateFormat + vm.displayTimeFormat).format(vm.apiDateFormat),
	            Location: search.car.dropOff.Location.Name,
	            depot: {}
	          },
	          PickUp: {
	            Code: search.car.pickUp.Location.Value,
	            Date: moment('' + search.car.pickUp.Date + search.car.pickUp.Time, '' + vm.displayDateFormat + vm.displayTimeFormat).format(vm.apiDateFormat),
	            Location: search.car.pickUp.Location.Name,
	            depot: {}
	          }
	        });
	      }
	    });
	
	    return carSearches;
	  }
	
	  function close() {
	    lbModalService.reject();
	  }
	};
	
	lbTripOptionsModalCtrl.$inject = $inject;
	
	exports['default'] = lbTripOptionsModalCtrl;
	module.exports = exports['default'];

/***/ }),
/* 1259 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	__webpack_require__(1654);
	
	var lbUutcMessage = angular.module('app.lbUutcMessage', []);
	
	lbUutcMessage.component('lbUutcMessage', {
	  controllerAs: 'vm',
	  controller: [controller],
	  template: __webpack_require__(1745)
	});
	
	function controller() {
	  var vm = this;
	  vm.message = 'Ticket credit should be used before expiration date and is subject to airline fare rules.';
	}
	
	exports['default'] = lbUutcMessage;
	module.exports = exports['default'];

/***/ }),
/* 1260 */,
/* 1261 */,
/* 1262 */,
/* 1263 */,
/* 1264 */,
/* 1265 */,
/* 1266 */,
/* 1267 */,
/* 1268 */,
/* 1269 */,
/* 1270 */,
/* 1271 */,
/* 1272 */,
/* 1273 */,
/* 1274 */,
/* 1275 */,
/* 1276 */,
/* 1277 */,
/* 1278 */,
/* 1279 */,
/* 1280 */,
/* 1281 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var momentFormat = {
	  DATE: 'ddd, MMM D YYYY',
	  DATE_TIME: 'ddd, MMM D YYYY [at] HH:mm',
	  API: 'YYYY-MM-DD[T]HH:mm:ss'
	};
	
	var message = {
	  CONTENT_WARNING: 'Your company will still be charged if booking is not Approved',
	  NO_POLICY_BREAK: 'Within Policy',
	  INSTANT_TICKET_FARE_TOOL_TIP_HEADER: 'Instant Ticket',
	  INSTANT_TICKET_FARE_TOOL_TIP_DESCRIPTION: 'You will be immediately charged on confirming your booking.'
	};
	
	var api = {
	  root: '' + window.apiUrl,
	  url: window.apiUrl + 'api/',
	  sctApiUrl: window.sctApiUrl + 'api/',
	  itinerary: window.apiUrl + 'api/Itinerary/',
	  iataGrouped: window.apiUrl + 'api/Itinerary/IataSearchGrouped',
	  iata: window.apiUrl + 'api/Itinerary/IataSearch',
	  iataSct: window.apiUrl + 'api/Itinerary/IataSearchSct',
	  citySearch: window.apiUrl + 'api/Location/city',
	  depotSearch: window.apiUrl + 'api/Car/depots',
	  travellers: window.apiUrl + 'api/Itinerary/Travellers',
	  itineraryMessaging: window.apiUrl + 'api/ItineraryMessaging',
	  car: window.apiUrl + 'api/car/results',
	  carDetails: window.apiUrl + 'api/car/detail',
	  carLocation: window.apiUrl + 'api/Car/Location',
	  hotels: window.apiUrl + 'api/hotel',
	  hotelPartial: window.apiUrl + 'api/HotelPartial',
	  hotelRates: window.apiUrl + 'api/hotel/rates',
	  hotelCancellationInfo: window.apiUrl + 'api/hotel/CancellationInfo',
	  hotelReviews: window.apiUrl + 'api/hotel/reviews',
	  hotelPolicy: window.apiUrl + 'api/Hotel/CheckPolicy',
	  token: window.apiUrl + 'Token',
	  loyaltyPrograms: window.apiUrl + 'api/Itinerary/loyaltyprograms',
	  flail: window.apiUrl + 'api/Rail/',
	  supplierLocations: window.apiUrl + 'api/supplierLocations/',
	  poi: window.apiUrl + 'api/PointOfInterest',
	  flight: window.apiUrl + 'api/flight',
	  carbonEmissions: window.apiUrl + 'api/CarbonEmissions',
	  companyReferences: window.apiUrl + 'api/Itinerary/companyreferences',
	  version: 14,
	  sctVersion: 1
	};
	
	var API = {
	  userActivity: {
	    url: function url(slugs) {
	      return window.sctApiUrl + 'api/v' + api.sctVersion + '/debtors/' + slugs.debtorId + '/activity';
	    },
	    mockUrl: function mockUrl() {
	      return window.SCT_MOCK_DATA_URL + '/userActivity';
	    },
	    useMockUrl: false
	  },
	  userPeople: {
	    url: function url(slugs) {
	      return slugs.id ? window.sctApiUrl + 'api/v' + api.sctVersion + '/debtors/' + slugs.debtorId + '/travellers/' + slugs.id : window.sctApiUrl + 'api/v' + api.sctVersion + '/debtors/' + slugs.debtorId + '/travellers';
	    },
	    mockUrl: function mockUrl(slugs) {
	      return slugs ? window.SCT_MOCK_DATA_URL + '/userPeople/' + slugs.id : window.SCT_MOCK_DATA_URL + '/userPeople';
	    },
	    useMockUrl: false
	  },
	  userProfile: {
	    url: window.sctApiUrl + 'api/v' + api.sctVersion + '/profile',
	    mockUrl: window.SCT_MOCK_DATA_URL + '/userProfile',
	    useMockUrl: false
	  },
	  userDebtor: {
	    url: function url(slugs) {
	      return window.sctApiUrl + 'api/v' + api.sctVersion + '/debtors/' + slugs.debtorId;
	    },
	    mockUrl: window.SCT_MOCK_DATA_URL + '/userDebtor',
	    useMockUrl: false
	  },
	  fareForecaster: {
	    url: window.apiUrl + 'api/fareforecaster',
	    mockUrl: window.TRAVEL_MOCK_DATA_URL + '/fareforecaster',
	    useMockUrl: false
	  },
	  itinerary: {
	    url: function url(slugs) {
	      return slugs ? window.apiUrl + 'api/Itinerary/' + slugs.itineraryId : window.apiUrl + 'api/Itinerary';
	    },
	    mockUrl: window.TRAVEL_MOCK_DATA_URL + '/Itinerary',
	    useMockUrl: false
	  },
	  costCentres: {
	    url: window.apiUrl + 'api/CostCentres',
	    mockUrl: window.MOCK_DATA_URL + '/CostCentres',
	    useMockUrl: false
	  },
	  department: {
	    url: window.apiUrl + 'api/Department',
	    mockUrl: window.MOCK_DATA_URL + '/departments',
	    useMockUrl: false
	  },
	  departmentCode: {
	    url: window.apiUrl + 'api/Department/departmentCode',
	    mockUrl: window.MOCK_DATA_URL + '/departmentCode',
	    useMockUrl: false
	  },
	  settings: {
	    url: window.apiUrl + 'api/Setting',
	    mockUrl: window.TRAVEL_MOCK_DATA_URL + '/Settings',
	    useMockUrl: false
	  },
	  travel: {
	    url: window.apiUrl + 'api/travel/search/results',
	    mockUrl: window.TRAVEL_MOCK_DATA_URL + '/Results',
	    useMockUrl: false
	  },
	  travelDetail: {
	    url: function url(slugs) {
	      return window.apiUrl + 'api/Travel/' + slugs.travelId + '/' + slugs.type + '/details';
	    },
	    mockUrl: window.TRAVEL_MOCK_DATA_URL + '/TravelDetail',
	    useMockUrl: false
	  },
	  travelFareRules: {
	    url: function url(slugs) {
	      return window.apiUrl + 'api/Travel/' + slugs.travelId + '/' + slugs.type + '/fareclasses/' + slugs.fareId + '/farerules';
	    },
	    mockUrl: window.TRAVEL_MOCK_DATA_URL + '/FareRules',
	    useMockUrl: false
	  },
	  travelSeatMap: {
	    url: function url(slugs) {
	      return window.apiUrl + 'api/SeatMap/search';
	    },
	    mockUrl: window.TRAVEL_MOCK_DATA_URL + '/SeatMap',
	    useMockUrl: false
	  },
	  locations: {
	    url: function url(slugs) {
	      return window.apiUrl + 'api/location/poi';
	    },
	    mockUrl: window.MOCK_DATA_URL + '/location/poi',
	    useMockUrl: false
	  },
	  userInvite: {
	    url: function url(slugs) {
	      return window.sctApiUrl + 'api/v' + api.sctVersion + '/debtors/' + slugs.debtorId + '/invites';
	    },
	    mockUrl: window.SCT_MOCK_DATA_URL + '/userInvite',
	    useMockUrl: false
	  },
	  userRegister: {
	    url: function url(slugs) {
	      return window.sctApiUrl + 'api/v' + api.sctVersion + '/profile/register';
	    },
	    mockUrl: window.SCT_MOCK_DATA_URL + '/userInvite',
	    useMockUrl: false
	  },
	  forgotPassword: {
	    url: function url(slugs) {
	      return window.sctApiUrl + 'api/v' + api.sctVersion + '/resetpassword?email=' + encodeURIComponent(slugs.email);
	    },
	    mockUrl: window.SCT_MOCK_DATA_URL + '/userInvite',
	    useMockUrl: false
	  },
	  resetPassword: {
	    url: function url(slugs) {
	      return window.sctApiUrl + 'api/v' + api.sctVersion + '/resetpassword/' + slugs.token;
	    },
	    mockUrl: window.SCT_MOCK_DATA_URL + '/userInvite',
	    useMockUrl: false
	  },
	  completeInvite: {
	    url: function url(slugs) {
	      return window.sctApiUrl + 'api/v' + api.sctVersion + '/debtors/' + slugs.debtorId + '/invites/' + slugs.token + '/complete';
	    },
	    mockUrl: window.SCT_MOCK_DATA_URL + '/userInvite',
	    useMockUrl: false
	  },
	  userContact: {
	    url: function url(slugs) {
	      return window.sctApiUrl + 'api/v' + api.sctVersion + '/support/getintouch?message=' + encodeURIComponent(slugs.message);
	    },
	    mockUrl: window.SCT_MOCK_DATA_URL + '/userInvite',
	    useMockUrl: false
	  },
	  shareItinerary: {
	    url: function url(slugs) {
	      return window.apiUrl + 'api/ShareItinerary';
	    },
	    mockUrl: window.SCT_MOCK_DATA_URL + '/ShareItinerary',
	    useMockUrl: false
	  },
	  companyreferences: {
	    url: function url(slugs) {
	      return window.apiUrl + 'api/Itinerary/companyreferences';
	    },
	    mockUrl: window.MOCK_DATA_URL + '/Itinerary/companyreferences',
	    useMockUrl: false
	  }
	};
	
	var version = {
	  number: window.lbVersion
	};
	
	var analytics = {
	  enabled: window.ANALYTICS_ENABLED,
	  trackingCode: window.ANALYTICS_CODE
	};
	
	var appInsights = {
	  enabled: window.APPINSIGHTS_ENABLED,
	  key: window.APPINSIGHTS_CODE
	};
	
	var client = {
	  id: window.CLIENT_ID,
	  secret: window.CLIENT_SECRET
	};
	
	var BING_API_CRED = 'AqkExqjquai0sfSevSrsEaOMOzaNLUqDL4xFwXBnjbRJYaLxM_gh2TlGV42cXl1R';
	
	var MOCK_DATA = {
	  active: window.MOCK_DATA,
	  cars: window.MOCK_DATA_URL + '/cars',
	  carDetails: window.MOCK_DATA_URL + '/carDetails',
	  supplierLocations: window.MOCK_DATA_URL + '/supplierLocations',
	  hotels: window.HOTEL_MOCK_DATA_URL + '/hotels',
	  hotelsPartial: window.HOTEL_MOCK_DATA_URL + '/hotelsPartial',
	  rail: window.MOCK_DATA_URL + '/Rail'
	};
	
	var MVC = window.MVC;
	var DISABLE_SEATMAPS = window.DISABLE_SEATMAPS;
	var HTML_INPUT_MAXLEN_LIMIT = 524288; // 524,288 part of the HTML spec
	
	var limits = {
	  remarks: {
	    // LOBT-837 JLF: despite inline amount of 50 we still include a default
	    // in case the way we retreive this value in the future changes
	    maxCharLen: 50 || HTML_INPUT_MAXLEN_LIMIT
	  }
	};
	
	// TODO: Remove this feature flag once bundles are approved and released.
	var bundles = {
	  enabled: false,
	  useMockData: false
	};
	
	exports['default'] = {
	  analytics: analytics,
	  appInsights: appInsights,
	  version: version,
	  bingAPICred: BING_API_CRED,
	  momentFormat: momentFormat,
	  message: message,
	  APP_URL: window.APP_URL,
	  api: api,
	  API: API,
	  client: client,
	  limits: limits,
	  bundles: bundles,
	  MOCK_DATA: MOCK_DATA,
	  MVC: MVC,
	  DISABLE_SEATMAPS: DISABLE_SEATMAPS
	};
	module.exports = exports['default'];

/***/ }),
/* 1282 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	exports['default'] = function (app) {
	  var $inject = ['AnalyticsProvider', 'APP_CONFIG'];
	
	  var GAConfig = function GAConfig(AnalyticsProvider, APP_CONFIG) {
	    if (!APP_CONFIG.analytics.enabled) {
	      return false;
	    }
	
	    AnalyticsProvider.setAccount(APP_CONFIG.analytics.trackingCode);
	    //AnalyticsProvider.setPageEvent('$stateChangeSuccess');
	    AnalyticsProvider.trackPages(false);
	    AnalyticsProvider.useECommerce(true, false);
	
	    if (location.hostname === 'localhost') {
	      AnalyticsProvider.setDomainName('none');
	    }
	  };
	
	  GAConfig.$inject = $inject;
	
	  return GAConfig;
	};
	
	module.exports = exports['default'];

/***/ }),
/* 1283 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	exports['default'] = function (app) {
	  var $inject = ['$httpProvider', 'APP_CONFIG'];
	
	  var HttpProviderConfig = function HttpProviderConfig($httpProvider, APP_CONFIG) {
	    $httpProvider.defaults.useXDomain = true;
	
	    $httpProvider.defaults.headers.common['Content-Type'] = 'application/json; charset=utf-8';
	
	    $httpProvider.defaults.headers.common['X-api-version'] = APP_CONFIG.api.version;
	
	    delete $httpProvider.defaults.headers.common['X-Requested-With'];
	
	    $httpProvider.interceptors.push('requestInterceptor');
	  };
	
	  HttpProviderConfig.$inject = $inject;
	
	  return HttpProviderConfig;
	};
	
	module.exports = exports['default'];

/***/ }),
/* 1284 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var authConstants = {
	  loginSuccess: 'auth-login-success',
	  loginFailed: 'auth-login-failed',
	  logoutSuccess: 'auth-logout-success',
	  sessionTimeout: 'auth-session-timeout',
	  notAuthenticated: 'auth-not-authenticated',
	  notAuthorized: 'auth-not-authorized',
	  sctAuthSuccess: 'sct-auth-success'
	};
	
	exports['default'] = authConstants;
	module.exports = exports['default'];

/***/ }),
/* 1285 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var enums = {
	  itineraryStatus: {
	    BOOKED: 'booked',
	    PARTIALLY_BOOKING: 'partial'
	  },
	  railSeatPreference: {
	    OPTIONAL: 'NR',
	    MANDATORY: 'SA',
	    AUTO: 'AA'
	  },
	  railSeatPreferenceTypes: {
	    POSITION: 'SeatReservationPosition',
	    DIRECTION: 'SeatReservationDirection',
	    COACH_TYPE: 'SeatReservationCoachType',
	    ATTRIBUTE: 'SeatReservationPreferenceAttribute'
	  },
	  itinerarySearchTypes: {
	    BLACK_CAR_SEARCH: 1,
	    CAR_SEARCH: 2,
	    FLIGHT_SEARCH: 3,
	    HOTEL_SEARCH: 4
	  },
	  dateTimeFormats: {
	    DATE_SHORT: 1,
	    DATE_MEDIUM: 2,
	    DATE_LONG: 3,
	    TIME_LONG: 4,
	    DATE_TIME_LONG: 5
	  },
	  itineraryCreationType: {
	    Created: 0,
	    Modification: 1
	  }
	};
	
	exports['default'] = enums;
	module.exports = exports['default'];

/***/ }),
/* 1286 */
/***/ (function(module, exports) {

	// Compass Icon Library https://company-199859.frontify.com/d/bun754Zanu7g/icon-library
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var iconBase = {
	  restrict: 'E',
	  link: function link(scope, e) {
	    e.addClass('lbIcon');
	  }
	};
	
	exports['default'] = {
	  iconChevronUp: function iconChevronUp() {
	    return Object.assign({}, iconBase, {
	      template: '\n        <svg viewBox="0 0 30 16"><path d="M3.45 15.458l11.5-11.5 11.6 11.5c.5.5 1.2.6 1.8.4.6-.3 1-.9 1-1.6 0-.4-.2-.8-.5-1.1L16.15.458c-.6-.6-1.7-.6-2.3 0l-12.7 12.7c-.3.3-.5.7-.5 1.2 0 .1 0 1.197 1.3 1.6.5.1 1.1 0 1.5-.5z"/></svg>\n    '
	    });
	  },
	
	  iconChevronDown: function iconChevronDown() {
	    return Object.assign({}, iconBase, {
	      template: '\n        <svg viewBox="0 0 30 16"><path d="M26.55.542l-11.5 11.5L3.45.542c-.5-.5-1.2-.6-1.8-.4-.6.3-1 .9-1 1.6 0 .4.2.8.5 1.1l12.7 12.7c.6.6 1.7.6 2.3 0l12.7-12.7c.3-.3.5-.7.5-1.2 0-.1 0-1.31-1.3-1.6-.5-.1-1.1 0-1.5.5z"/></svg> \n    '
	    });
	  },
	
	  iconRate: function iconRate() {
	    return Object.assign({}, iconBase, {
	      template: '\n        <svg viewBox="0 0 24 24"><path d="M10.369,20.88l5.82-5.82L17.6,18.672,5.576,23.4.885,11.468ZM9.158,0H0V9.219L10.359,19.507l9.158-9.158ZM3.6,1.954A1.659,1.659,0,1,1,1.954,3.6,1.659,1.659,0,0,1,3.6,1.954Z" transform="translate(3 2.202)"/></svg>\n    '
	    });
	  },
	
	  iconLightning: function iconLightning() {
	    return Object.assign({}, iconBase, {
	      template: '\n        <svg viewBox="0 0 32 32"><rect width="32" height="32"/><path class="cls-2" d="m7.58,3.37l-2.22,13.2,5.7-1.17-1.68,14.6,10.06-19.33-7.25,1.4,1.76-10.07-6.37,1.37Zm13.42,7.16l-6.96,13.72,10.73-.95-4.23-5.28,6.12-.31-5.66-7.18Z"/></svg>\n    '
	    });
	  },
	
	  iconChevronRight: function iconChevronRight() {
	    return Object.assign({}, iconBase, {
	      template: '\n        <svg viewBox="0 0 16 30" ><path d="M.542 3.45l11.5 11.5-11.5 11.6c-.5.5-.6 1.2-.4 1.8.3.6.9 1 1.6 1 .4 0 .8-.2 1.1-.5l12.7-12.7c.6-.6.6-1.7 0-2.3l-12.7-12.7c-.3-.3-.7-.5-1.2-.5-.1 0-1.323.046-1.6 1.3-.1.5 0 1.1.5 1.5z"/></svg>\n    '
	    });
	  },
	
	  iconFilter: function iconFilter() {
	    return Object.assign({}, iconBase, {
	      template: '\n        <svg viewBox="0 0 29 24"><path d="M8.586 21.755H2.08c-.91 0-1.647-.625-1.647-1.394 0-.77.738-1.393 1.647-1.393h6.506c.91 0 1.647.624 1.647 1.393 0 .77-.736 1.394-1.647 1.394zm7.247 0v.45c0 .905-.627 1.64-1.4 1.64-.773 0-1.4-.734-1.4-1.64v-3.688c0-.907.627-1.64 1.4-1.64.773 0 1.4.733 1.4 1.64v.45h10.953c.91 0 1.647.625 1.647 1.394 0 .77-.736 1.394-1.647 1.394H15.833zm-1.153-8.361c-.91 0-1.647-.625-1.647-1.394 0-.77.736-1.394 1.647-1.394h12.106c.91 0 1.647.625 1.647 1.394 0 .77-.738 1.394-1.647 1.394H14.68zm-7.247 0H2.08c-.91 0-1.647-.625-1.647-1.394 0-.77.736-1.394 1.647-1.394h5.353v-.45c0-.907.627-1.64 1.4-1.64.773 0 1.4.733 1.4 1.64v3.688c0 .905-.627 1.64-1.4 1.64-.773 0-1.4-.735-1.4-1.64v-.45zm6.753-8.362H2.08c-.91 0-1.647-.624-1.647-1.393 0-.77.738-1.394 1.647-1.394h12.106c.91 0 1.647.625 1.647 1.394 0 .77-.736 1.393-1.647 1.393zm7.247 0v.451c0 .905-.627 1.64-1.4 1.64-.773 0-1.4-.735-1.4-1.64V1.795c0-.907.627-1.64 1.4-1.64.773 0 1.4.733 1.4 1.64v.45h5.353c.91 0 1.647.625 1.647 1.394 0 .77-.736 1.393-1.647 1.393h-5.353z"/></svg>\n    '
	    });
	  },
	
	  iconSort: function iconSort() {
	    return Object.assign({}, iconBase, {
	      template: '\n        <svg viewBox="0 0 29 26"><path d="M6.164 22.73a1.457 1.457 0 1 1 0 2.914h-4.37a1.457 1.457 0 1 1 0-2.913zM22.556.67a1.668 1.668 0 0 1 1.693 1.69l-.027 16.615h3.026c.948 0 1.425 1.145.755 1.817l-4.432 4.432c-.56.56-1.469.56-2.029 0l-4.432-4.432c-.672-.672-.198-1.817.75-1.817h3.028l.026-16.615A1.668 1.668 0 0 1 22.556.67zM9.077 15.356a1.457 1.457 0 1 1 0 2.913H1.794a1.457 1.457 0 1 1 0-2.913zm1.457-7.375a1.457 1.457 0 1 1 0 2.913h-8.74a1.457 1.457 0 1 1 0-2.913zM13.448.606a1.457 1.457 0 1 1 0 2.913H1.794a1.457 1.457 0 1 1 0-2.913z"/></svg>\n    '
	    });
	  },
	
	  iconPreferred: function iconPreferred() {
	    return Object.assign({}, iconBase, {
	      template: '\n        <svg viewBox="0 0 29 29"><path d="M14.418.5c.763 0 1.487.332 1.986.909l1.799 2.24c.285.354.73.537 1.182.487l2.858-.307a2.543 2.543 0 0 1 2.08.732c.545.548.814 1.314.729 2.082l-.31 2.86c-.05.451.133.898.486 1.183l2.238 1.803c.6.487.95 1.219.95 1.992 0 .773-.35 1.504-.952 1.988l-2.238 1.803a1.325 1.325 0 0 0-.487 1.184l.31 2.86a2.552 2.552 0 0 1-.73 2.082 2.543 2.543 0 0 1-2.08.73l-2.854-.31a1.33 1.33 0 0 0-1.182.488l-1.8 2.24a2.545 2.545 0 0 1-3.97 0l-1.802-2.244a1.328 1.328 0 0 0-1.182-.488l-2.856.311a2.543 2.543 0 0 1-2.08-.732 2.552 2.552 0 0 1-.729-2.082l.31-2.86a1.328 1.328 0 0 0-.486-1.183L1.37 16.466a2.552 2.552 0 0 1 0-3.977l2.24-1.804c.355-.285.538-.732.487-1.184l-.31-2.859a2.552 2.552 0 0 1 .73-2.082 2.543 2.543 0 0 1 2.08-.73l2.854.306c.452.052.898-.132 1.182-.487l1.8-2.24A2.624 2.624 0 0 1 14.418.5zm2.958 9.033c-1.874 0-2.96 1.627-2.96 1.627s-1.084-1.627-2.959-1.627a3.55 3.55 0 0 0-3.55 3.55c0 3.414 3.96 6.675 5.81 8.128l.047.038a1.085 1.085 0 0 0 1.318-.01l.01-.007.01-.01c1.845-1.447 5.825-4.717 5.825-8.139a3.55 3.55 0 0 0-3.55-3.55z"/></svg>\n    '
	    });
	  },
	
	  iconTransferStopover: function iconTransferStopover() {
	    return Object.assign({}, iconBase, {
	      template: '\n        <svg viewBox="0 0 29 26"><path d="M23.498 15.31c.265 0 .441.087.618.262l4.236 4.218c.353.264.353.79 0 1.142l-4.236 4.217a.856.856 0 0 1-1.236 0l-.095-.106a.769.769 0 0 1-.17-.509v-2.827c-3.144.099-5.644-1.273-7.936-4.146a1.294 1.294 0 0 1-.192-1.285 1.308 1.308 0 0 1 2.236-.33c1.822 2.282 3.58 3.256 5.89 3.161l.002-2.92c0-.526.353-.878.883-.878zM24.116.85l4.236 4.218c.353.351.353.878 0 1.142l-4.236 4.218a.806.806 0 0 1-.618.263c-.53 0-.883-.352-.883-.879l-.002-2.858c-2.883-.117-4.957 1.43-7.38 5.296-4.22 6.732-8.696 9.959-13.464 9.4a1.304 1.304 0 0 1-1.046-.777 1.294 1.294 0 0 1 .153-1.29 1.308 1.308 0 0 1 1.198-.513c3.541.414 7.2-2.224 10.944-8.195 2.856-4.558 5.7-6.655 9.597-6.522V1.466a.77.77 0 0 1 .17-.51l.095-.105a.856.856 0 0 1 1.236 0zM11.398 8.658c.495.522.47 1.344-.054 1.836a1.31 1.31 0 0 1-1.845-.054C6.959 7.757 4.5 6.624 2.074 6.909A1.304 1.304 0 0 1 .626 5.77a1.3 1.3 0 0 1 1.143-1.442c3.341-.391 6.568 1.096 9.63 4.33z"/></svg>\n    '
	    });
	  },
	
	  iconClose: function iconClose() {
	    return Object.assign({}, iconBase, {
	      template: '\n        <svg viewBox="0 0 29 29"><path d="M1.839.505A1.747 1.747 0 0 0 .62 3.503l10.992 10.993L.621 25.49a1.747 1.747 0 1 0 2.47 2.47l10.993-10.993L25.076 27.96a1.747 1.747 0 1 0 2.47-2.47L16.554 14.496 27.546 3.503a1.747 1.747 0 1 0-2.47-2.47L14.084 12.026 3.09 1.033A1.747 1.747 0 0 0 1.839.505z"/></svg>\n    '
	    });
	  },
	
	  iconCheapest: function iconCheapest() {
	    return Object.assign({}, iconBase, {
	      template: '\n        <svg viewBox="0 0 29 29"><path d="M14.918.499c.763 0 1.487.332 1.986.909l1.8 2.24c.284.354.73.538 1.181.488l2.86-.308a2.544 2.544 0 0 1 2.078.732c.546.548.815 1.314.73 2.083l-.31 2.86c-.05.451.133.897.486 1.183l2.238 1.802c.6.488.95 1.22.95 1.993 0 .773-.35 1.505-.952 1.989l-2.238 1.802a1.325 1.325 0 0 0-.487 1.184l.31 2.86a2.552 2.552 0 0 1-.73 2.083 2.544 2.544 0 0 1-2.08.73l-2.855-.31a1.33 1.33 0 0 0-1.182.488l-1.8 2.24a2.546 2.546 0 0 1-3.97 0l-1.803-2.244a1.329 1.329 0 0 0-1.182-.488l-2.856.311a2.543 2.543 0 0 1-2.079-.732 2.552 2.552 0 0 1-.73-2.082l.31-2.86a1.328 1.328 0 0 0-.486-1.184l-2.238-1.802a2.552 2.552 0 0 1 0-3.978l2.24-1.803c.355-.285.538-.732.487-1.184l-.31-2.86a2.552 2.552 0 0 1 .73-2.082 2.544 2.544 0 0 1 2.08-.73l2.855.307c.451.051.898-.133 1.182-.488l1.8-2.24a2.625 2.625 0 0 1 1.985-.91zm-.001 6.607c-.727 0-1.212.485-1.212 1.212v.364a.26.26 0 0 1-.243.242c-1.697.364-2.788 2.06-2.424 3.758.243.97.97 1.818 1.94 2.303l3.03 1.212c.363.121.606.606.363.97-.12.242-.363.485-.727.485h-2.909c-.727 0-1.212.484-1.212 1.212 0 .727.485 1.212 1.212 1.212h.727a.26.26 0 0 1 .243.242v.364c0 .727.485 1.212 1.212 1.212s1.212-.485 1.212-1.212v-.364a.26.26 0 0 1 .242-.242c1.697-.364 2.788-2.06 2.425-3.758-.243-.97-.97-1.818-1.94-2.303l-3.03-1.212c-.364-.121-.606-.606-.364-.97.122-.242.364-.485.727-.485h2.91c.727 0 1.212-.484 1.212-1.212 0-.727-.485-1.212-1.212-1.212h-.728a.26.26 0 0 1-.242-.242v-.243c0-.848-.485-1.333-1.212-1.333z"/></svg>\n    '
	    });
	  },
	
	  iconSeat: function iconSeat() {
	    return Object.assign({}, iconBase, {
	      template: '\n        <svg viewBox="0 0 25 28"><path d="M3.162 0A2.545 2.545 0 0 0 .714 3.244L5.79 19.792l.015-.005a2.545 2.545 0 0 0 2.448 1.85h.667l-1.847 4.618A1.273 1.273 0 0 0 8.253 28h14a1.273 1.273 0 0 0 1.181-1.745l-1.85-4.619h.67a2.545 2.545 0 1 0 0-5.09H10.117l-1.171-3.819h6.943a1.273 1.273 0 1 0 0-2.545H8.166l-2.55-8.318A2.545 2.545 0 0 0 3.162 0zm8.5 21.636h7.183l1.53 3.819H10.132l1.528-3.819z"/></g></svg>\n    '
	    });
	  },
	
	  iconAlert: function iconAlert() {
	    return Object.assign({}, iconBase, {
	      template: '\n        <svg viewBox="0 0 29 29"><path d="M14.94.5h.28c7.56 0 13.72 6.16 13.72 13.72 0 7.84-6.16 14.14-14 14.28h-.28C7.1 28.5.94 22.34.94 14.78.94 11 2.34 7.36 5 4.7 7.66 2.04 11.16.5 14.94.5zm-1.5 7.812v7c0 .7.563 1.12 1.5 1.12.75 0 1.5-.42 1.5-1.12v-7c0-.56-.562-1.12-1.5-1.12-.75 0-1.5.42-1.5 1.12zm1.5 13.51a1.82 1.82 0 1 0 0-3.64 1.82 1.82 0 0 0 0 3.64z"/></g></svg>\n    '
	    });
	  }
	};
	module.exports = exports['default'];

/***/ }),
/* 1287 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['$timeout'];
	
	var focusOn = function focusOn($timeout) {
	  return {
	    restrict: 'A',
	    scope: {
	      focusOn: '<',
	      focusOnly: '@'
	    },
	    link: function link($scope, $element, $attr) {
	      $scope.$watch('focusOn', function (_focusVal) {
	        $timeout(function () {
	          if (_focusVal) {
	            $element[0].focus();
	          } else if (!$scope.focusOnly) {
	            $element[0].blur();
	          }
	        });
	      });
	    }
	  };
	};
	
	focusOn.$inject = $inject;
	
	exports['default'] = focusOn;
	module.exports = exports['default'];

/***/ }),
/* 1288 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = [];
	
	var inputMatch = function inputMatch() {
	  return {
	    require: 'ngModel',
	    link: function link(scope, elem, attrs, ctrl) {
	      var firstPassword = '#' + attrs.inputMatch;
	      elem.add(firstPassword).on('keyup', function () {
	        scope.$apply(function () {
	          var v = elem.val() === $(firstPassword).val();
	          ctrl.$setValidity('inputMatch', v);
	        });
	      });
	    }
	  };
	};
	
	inputMatch.$inject = $inject;
	
	exports['default'] = inputMatch;
	module.exports = exports['default'];

/***/ }),
/* 1289 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = [];
	
	var inputUppercase = function inputUppercase() {
	  return {
	    require: 'ngModel',
	    link: function link(scope, elem, attrs, ctrl) {
	      var capInputText = function capInputText(inputText) {
	        var value = (inputText || '').toString().toUpperCase();
	
	        if (value !== inputText) {
	          ctrl.$setViewValue(value);
	          ctrl.$render();
	        }
	
	        return value;
	      };
	
	      // the second line is used to capitalize the initial value.
	      ctrl.$parsers.push(capInputText);
	      capInputText(scope[attrs.ngModel]);
	    }
	  };
	};
	
	inputUppercase.$inject = $inject;
	
	exports['default'] = inputUppercase;
	module.exports = exports['default'];

/***/ }),
/* 1290 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['$document', '$window'];
	var clickOutside = function clickOutside($document, $window) {
	  return {
	    restrict: 'A',
	    scope: {
	      clickOutside: '&'
	    },
	    link: function link(scope, el) {
	      $document.on('click', eventHandler);
	
	      scope.$on('$destroy', function () {
	        $document.off('click', eventHandler);
	      });
	
	      function eventHandler(e) {
	        if (isHidden(el[0])) {
	          return false;
	        }
	
	        if (el !== e.target && !el[0].contains(e.target)) {
	          scope.$apply(function () {
	            scope.$eval(scope.clickOutside);
	          });
	        }
	      }
	
	      function isHidden(element) {
	        var style = $window.getComputedStyle(element);
	        return style.display === 'none';
	      }
	    }
	  };
	};
	
	clickOutside.$inject = $inject;
	
	exports['default'] = clickOutside;
	module.exports = exports['default'];

/***/ }),
/* 1291 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['moment'];
	var lbFutureTime = function lbFutureTime(moment) {
	  return {
	    restrict: 'A',
	    require: 'ngModel',
	    link: function link(scope, elem, attrs, ngModel) {
	      var validate = function validate(viewValue) {
	        var dateCompare = attrs.dateCompare ? moment(attrs.dateCompare, 'DD MMM, YYYY').format('DD/MM/YYYY') : undefined;
	        var today = dateCompare || moment().add(0, 'day').format('DD/MM/YYYY');
	        var selectedDate = moment(attrs.lbFutureTime, 'MMM DD, YYYY').format('DD/MM/YYYY');
	        var timeFormat = attrs.timeFormat;
	        var inFuture = true;
	
	        if (today === selectedDate) {
	          var timeVal = viewValue.value || viewValue;
	          var selectedTime = parseInt(moment(timeVal, timeFormat).format('Hmm'));
	          var nowTime = 0;
	
	          if (attrs.timeCompare) {
	            nowTime = parseInt(moment(attrs.timeCompare, timeFormat).format('Hmm'));
	          } else {
	            nowTime = parseInt(moment().format('Hmm'));
	          }
	
	          inFuture = nowTime < selectedTime;
	        }
	
	        if (attrs.required) {
	          ngModel.$setValidity('lbFutureTime', inFuture);
	        } else {
	          ngModel.$setValidity('lbFutureTime', true);
	        }
	
	        return viewValue;
	      };
	
	      ngModel.$parsers.unshift(validate);
	      ngModel.$formatters.push(validate);
	
	      attrs.$observe('lbFutureTime', function () {
	        return validate(ngModel.$viewValue);
	      });
	
	      attrs.$observe('timeCompare', function () {
	        return validate(ngModel.$viewValue);
	      });
	
	      attrs.$observe('required', function () {
	        if (attrs.required === false) {
	          ngModel.$setValidity('lbFutureTime', true);
	          return ngModel.$viewValue;
	        } else {
	          return validate(ngModel.$viewValue);
	        }
	      });
	    }
	  };
	};
	
	lbFutureTime.$inject = $inject;
	
	exports['default'] = lbFutureTime;
	module.exports = exports['default'];

/***/ }),
/* 1292 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['$timeout', 'moment'];
	
	var lbIFrameOnLoad = function lbIFrameOnLoad($timeout, moment) {
	  return {
	    scope: {
	      callBack: '&iframeOnload'
	    },
	    link: function link(scope, element, attrs) {
	      element.on('load', function () {
	        return scope.callBack();
	      });
	    }
	  };
	};
	
	lbIFrameOnLoad.$inject = $inject;
	
	exports['default'] = lbIFrameOnLoad;
	module.exports = exports['default'];

/***/ }),
/* 1293 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['moment', 'ENUMS', 'dateTimeService'];
	
	var lbSequentialTime = function lbSequentialTime(moment, ENUMS, dateTimeService) {
	  return {
	    restrict: 'A',
	    require: 'ngModel',
	    link: function link(scope, ele, attrs, ctrl) {
	      var validatorName = 'isDateAfterPreviousDate';
	      var timeFormat = attrs.timeFormat;
	      var DATE_FORMAT = dateTimeService.getFormat(ENUMS.dateTimeFormats.DATE_MEDIUM);
	      var attrWatch = undefined;
	
	      attrs.$observe('lbSequentialTime', onEnabledChange);
	
	      function onEnabledChange(newValue) {
	        var isEnabled = newValue === 'true';
	
	        if (isEnabled) {
	          if (!attrWatch) {
	            attrWatch = scope.$watch(watchAttributes, validate, true);
	          }
	        } else {
	          if (angular.isFunction(attrWatch)) {
	            attrWatch();
	            attrWatch = undefined;
	          }
	
	          ctrl.$setValidity(validatorName, true);
	        }
	      }
	
	      function watchAttributes() {
	        return [attrs.lbSequentialTimeDate, ctrl.$viewValue.value, attrs.lbSequentialTimeBeforeDate, attrs.lbSequentialTimeBeforeTime];
	      }
	
	      function validate(attributes) {
	        var date = attributes[0];
	        var time = attributes[1];
	        var beforeDate = attributes[2];
	        var beforeTime = attributes[3];
	
	        var dateTime = moment(date + time, DATE_FORMAT + timeFormat);
	        var beforeDateTime = moment(beforeDate + beforeTime, DATE_FORMAT + timeFormat);
	
	        ctrl.$setValidity(validatorName, beforeDateTime.isBefore(dateTime));
	      }
	    }
	  };
	};
	
	lbSequentialTime.$inject = $inject;
	
	exports['default'] = lbSequentialTime;
	module.exports = exports['default'];

/***/ }),
/* 1294 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var lbTooltip = angular.module('app.lbTooltip', []);
	
	lbTooltip.controller('lbTooltipController', __webpack_require__(1295));
	lbTooltip.directive('lbTooltip', __webpack_require__(1296));
	
	exports['default'] = lbTooltip;
	module.exports = exports['default'];

/***/ }),
/* 1295 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var $inject = [];
	
	var lbTooltipController = function lbTooltipController() {
	  var vm = this;
	};
	
	lbTooltipController.$inject = $inject;
	
	exports["default"] = lbTooltipController;
	module.exports = exports["default"];

/***/ }),
/* 1296 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	__webpack_require__(1680);
	
	var $inject = ['$sanitize'];
	
	var lbTooltip = function lbTooltip($sanitize) {
	  return {
	    controller: 'lbTooltipController',
	    controllerAs: 'vm',
	    bindToController: true,
	    transclude: {
	      tooltipContent: '?tooltipContent'
	    },
	    scope: {
	      tooltipContent: '=',
	      tooltipContentFunc: '=',
	      tooltipLoadingText: '=',
	      tooltipDisplay: '<',
	      tooltipClass: '@',
	      tooltipWidth: '@?',
	      tooltipInline: '=?',
	      tooltipHeader: '=',
	      tooltipDirection: '@?',
	      tooltipArrowPosition: '@?'
	    },
	    link: function link(scope, element, attributes, controller, transclude) {
	      if (scope.vm.tooltipDisplay === undefined) scope.vm.tooltipDisplay = true;
	      scope.el = element[0];
	      scope.vm.tooltipDirection = scope.vm.tooltipDirection || 'top';
	      scope.vm.tooltipArrowPosition = scope.vm.tooltipArrowPosition || 'center';
	      scope.tooltip = document.createElement('div');
	      scope.$tooltip = angular.element(scope.tooltip);
	      scope.$tooltip.addClass(scope.vm.tooltipClass || 'tooltip');
	      scope.$tooltip.addClass('tooltip--' + scope.vm.tooltipDirection);
	      scope.$tooltip.addClass('tooltip--' + scope.vm.tooltipArrowPosition);
	      scope.isAsync = !!scope.vm.tooltipContentFunc;
	      scope.isInline = !!scope.vm.tooltipInline;
	      scope.tooltipWidth = scope.vm.tooltipWidth || 200;
	      var transcludedContent = undefined;
	      var transclusionScope = undefined;
	
	      if (scope.isInline) {
	        element.wrap('<div class="tooltipWrap"></div>');
	        scope.wrap = element.parent();
	      }
	
	      if (scope.tooltipClass) {
	        scope.$tooltip.addClass(scope.tooltipClass);
	      }
	
	      transclude(function (clone) {
	        return element.append(clone);
	      });
	
	      scope.$on('$destroy', function handleDestroyEvent() {
	        scope.el.removeEventListener('mouseenter', handleMouseEnter);
	        scope.el.removeEventListener('mouseleave', handleMouseLeave);
	        scope.$tooltip.remove();
	      });
	
	      if (scope.vm.tooltipDisplay) {
	        scope.el.addEventListener('mouseenter', handleMouseEnter);
	        scope.el.addEventListener('mouseleave', handleMouseLeave);
	      }
	
	      function buildTooltip() {
	        var elDimensions = scope.el.getBoundingClientRect();
	        var elPos = getPosition(scope.el);
	        var leftOffset = elDimensions.width / 2;
	        switch (scope.vm.tooltipArrowPosition) {
	          case 'left':
	            leftOffset = -25;
	            break;
	        }
	        var render = false;
	
	        if (scope.isInline) {
	          scope.docfrag = document.createDocumentFragment();
	          scope.docfrag.appendChild(scope.tooltip);
	          switch (scope.vm.tooltipDirection) {
	            case 'top':
	              scope.$tooltip.css({
	                bottom: elDimensions.height + 'px',
	                left: elDimensions.width / 2 + 'px'
	              });
	              break;
	            case 'bottom':
	              scope.$tooltip.css({
	                top: elDimensions.height + 5 + 'px',
	                left: elDimensions.width / 2 + 'px'
	              });
	              break;
	          }
	        } else {
	          scope.$tooltip.css({
	            bottom: elPos.bottom + 'px',
	            left: elPos.left + leftOffset + 'px',
	            width: scope.tooltipWidth + 'px'
	          });
	        }
	
	        if (!scope.isAsync) {
	          if (scope.vm.tooltipContent) {
	            scope.tooltip.innerHTML = $sanitize(scope.vm.tooltipContent);
	            render = true;
	          } else {
	            transclude(function (clone, tScope) {
	              scope.$tooltip.append(clone);
	              transcludedContent = clone;
	              transclusionScope = tScope;
	            }, scope.$tooltip, 'tooltipContent');
	            if (transclusionScope) {
	              transclusionScope.$apply();
	              render = true;
	            }
	          }
	
	          if (scope.vm.tooltipHeader) {
	            scope.tooltip.innerHTML = "<div class='tooltip-header'>" + scope.vm.tooltipHeader + '</div>' + scope.tooltip.innerHTML;
	          }
	        } else {
	          scope.tooltip.innerHTML = '<span class="tooltip-loading">' + (scope.vm.tooltipLoadingText || 'Loading...') + '</span>';
	          render = true;
	        }
	
	        if (!scope.tooltipCached && scope.isAsync) {
	          scope.$tooltip.addClass('loading');
	
	          scope.vm.tooltipContentFunc().then(function (data) {
	            scope.tooltipCached = true;
	            scope.tooltip.innerHTML = $sanitize(data);
	            scope.data = data;
	            scope.$tooltip.removeClass('loading');
	          });
	        } else if (scope.isAsync) {
	          scope.tooltip.innerHTML = scope.data;
	        }
	
	        if (render) {
	          if (scope.isInline) {
	            scope.wrap.append(scope.docfrag);
	          } else {
	            document.body.appendChild(scope.tooltip);
	          }
	        }
	      }
	
	      function getPosition(el) {
	        var xPos = 0;
	        var yPos = 0;
	
	        while (el) {
	          xPos += el.offsetLeft + el.clientLeft;
	          yPos += el.offsetTop + el.clientTop;
	
	          el = el.offsetParent;
	        }
	
	        return {
	          left: xPos,
	          top: yPos,
	          bottom: document.body.offsetHeight - yPos
	        };
	      }
	
	      function removeTooltip() {
	        scope.$tooltip.removeClass('open');
	        scope.$tooltip.remove();
	        if (transcludedContent) {
	          transcludedContent.remove();
	          transcludedContent = undefined;
	        }
	        if (transclusionScope) {
	          transclusionScope.$destroy();
	          transclusionScope = undefined;
	        }
	      }
	
	      function handleMouseEnter() {
	        buildTooltip();
	      }
	
	      function handleMouseLeave() {
	        removeTooltip();
	      }
	    }
	  };
	};
	
	lbTooltip.$inject = $inject;
	
	exports['default'] = lbTooltip;
	module.exports = exports['default'];

/***/ }),
/* 1297 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['$log', 'appInsightsService', 'APP_CONFIG'];
	
	var exceptionHandler = function exceptionHandler($log, appInsightsService, APP_CONFIG) {
	  return function errorCatcherHandler(exception, cause) {
	    $log.error(exception);
	
	    if (APP_CONFIG.appInsights.enabled) {
	      appInsightsService.trackError(exception);
	    }
	  };
	};
	
	exceptionHandler.$inject = $inject;
	
	exports['default'] = exceptionHandler;
	module.exports = exports['default'];

/***/ }),
/* 1298 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['$q', '$injector', '$rootScope', '$window', 'AUTH_EVENTS', 'APP_CONFIG'];
	
	var requestInterceptor = function requestInterceptor($q, $injector, $rootScope, $window, AUTH_EVENTS, APP_CONFIG) {
	  var factory = {};
	  factory.request = request;
	  factory.response = response;
	  factory.responseError = responseError;
	
	  var inFlightAuthRequest = null;
	
	  function isAPI(url) {
	    return url.startsWith(APP_CONFIG.api.url) || url.startsWith(APP_CONFIG.api.sctApiUrl);
	  }
	
	  function request(config) {
	    var authService = $injector.get('authService');
	    var accessToken = authService.getAccessToken();
	
	    if (isAPI(config.url)) {
	      if (!config.isPublic) {
	        if (accessToken) {
	          config.headers.Authorization = 'Bearer ' + accessToken;
	        } else {
	          $rootScope.$broadcast(AUTH_EVENTS.notAuthenticated);
	        }
	      }
	
	      if ($rootScope.enableDebug) {
	        config.headers['X-Api-Enable-Debug'] = true;
	      }
	    }
	
	    return config;
	  }
	
	  function response(response) {
	    if (isAPI(response.config.url)) {
	      var headers = response.headers();
	      var debugActivityId = headers['x-api-debug-activityid'];
	
	      if (debugActivityId) {
	        $window.LB_DEBUG = $window.LB_DEBUG || [];
	        $window.LB_DEBUG.push({
	          activityId: debugActivityId,
	          requestUrl: response.config.url,
	          responseTime: new Date(Date.now()).toString()
	        });
	      }
	    }
	
	    return response;
	  }
	
	  function responseError(rejection) {
	    if (rejection.config.handleError) {
	      throw rejection;
	    }
	    var deferred = $q.defer();
	
	    if (rejection.status === 401) {
	      (function () {
	        var authService = $injector.get('authService');
	        var refreshToken = authService.getRefreshToken();
	
	        if (refreshToken) {
	          if (!inFlightAuthRequest) {
	            inFlightAuthRequest = authService.refresh(refreshToken);
	          }
	
	          inFlightAuthRequest.then(function () {
	            inFlightAuthRequest = null;
	            var $http = $injector.get('$http');
	            return deferred.resolve($http(rejection.config));
	          }, function () {
	            inFlightAuthRequest = null;
	            authService.logout();
	          });
	        } else {
	          $rootScope.$broadcast(AUTH_EVENTS.notAuthenticated);
	        }
	      })();
	    }
	
	    if (rejection.status >= 500 || rejection.status === 417) {
	      $rootScope.showLoader = false;
	
	      $rootScope.$broadcast('httpError', {
	        rejection: rejection
	      });
	
	      /*
	      TRY AGAIN:
	      const $http = $injector.get('$http');
	      deferred.resolve($http(rejection.config));
	      */
	    }
	
	    if (rejection.status === 412) {
	      var newRejection = _.extend({}, rejection, {
	        data: {
	          Message: 'Sorry, another admin has made a change',
	          Instructions: "To avoid conflicting changes we're going to fetch the latest configuration and refresh your browser."
	        }
	      });
	
	      $rootScope.showLoader = false;
	
	      $rootScope.$broadcast('httpError', {
	        rejection: newRejection,
	        warnLevel: 'info'
	      }, function () {
	        $window.location.reload();
	      });
	
	      rejection.data.errorIntercepted = true;
	    }
	
	    if (rejection.status === 422) {
	      rejection.data = {
	        OriginalMessage: rejection.data,
	        Message: 'We were unable to update your cart',
	        Instructions: 'Please refresh your browser and try again.'
	      };
	
	      $rootScope.showLoader = false;
	
	      $rootScope.$broadcast('httpError', {
	        rejection: rejection,
	        warnLevel: 'info'
	      });
	    }
	
	    if (rejection.status === 400) {
	      rejection.data = {
	        OriginalMessage: rejection.data,
	        Message: 'There was a problem with your request.',
	        Instructions: rejection.data.Message
	      };
	
	      $rootScope.showLoader = false;
	
	      $rootScope.$broadcast('httpError', {
	        rejection: rejection,
	        warnLevel: 'info'
	      });
	    }
	
	    if (rejection.status === 404) {
	      $rootScope.$broadcast('httpError', {
	        rejection: rejection
	      });
	    }
	
	    return $q.reject(rejection);
	  }
	
	  return factory;
	};
	
	requestInterceptor.$inject = $inject;
	
	exports['default'] = requestInterceptor;
	module.exports = exports['default'];

/***/ }),
/* 1299 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['ENUMS'];
	
	var ancillaryServicesAmountsFilter = function ancillaryServicesAmountsFilter(ENUMS) {
	  return function (ancillaryServices) {
	    return _.filter(ancillaryServices, function (service) {
	      return service.QuantitySelected > 0 && !_.findKey(ENUMS.railSeatPreferenceTypes, function (preferenceType) {
	        return preferenceType === service.Type;
	      });
	    });
	  };
	};
	
	ancillaryServicesAmountsFilter.$inject = $inject;
	
	exports['default'] = ancillaryServicesAmountsFilter;
	module.exports = exports['default'];

/***/ }),
/* 1300 */,
/* 1301 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = [];
	
	var checkinInfoFilter = function checkinInfoFilter() {
	  return function (str) {
	    return str ? _.compact(str.split('\r\n')) : [];
	  };
	};
	
	checkinInfoFilter.$inject = $inject;
	
	exports['default'] = checkinInfoFilter;
	module.exports = exports['default'];

/***/ }),
/* 1302 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = [];
	
	var creditCardNumberFilter = function creditCardNumberFilter() {
	  return function (cardNumber) {
	    cardNumber = cardNumber.toString();
	    var cardNumbers = cardNumber.split('');
	    var formattedNumber = '';
	
	    cardNumbers.forEach(function (number, numberIndex) {
	      if (numberIndex !== 0 && numberIndex % 4 === 0) {
	        formattedNumber += '  ';
	      }
	
	      formattedNumber += number;
	    });
	
	    return formattedNumber;
	  };
	};
	
	creditCardNumberFilter.$inject = $inject;
	
	exports['default'] = creditCardNumberFilter;
	module.exports = exports['default'];

/***/ }),
/* 1303 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = [];
	
	var deepCopyFilter = function deepCopyFilter() {
	  return deepCopy;
	
	  function deepCopy(o) {
	    if (typeof o !== 'object' || o === null) return o;
	    var newO = undefined,
	        i = undefined;
	
	    if (o instanceof Array) {
	      var l = undefined;
	      newO = [];
	      for (i = 0, l = o.length; i < l; i++) newO[i] = deepCopy(o[i]);
	      return newO;
	    }
	
	    newO = {};
	    for (i in o) if (o.hasOwnProperty(i)) newO[i] = deepCopy(o[i]);
	
	    return newO;
	  }
	};
	
	deepCopyFilter.$inject = $inject;
	
	exports['default'] = deepCopyFilter;
	module.exports = exports['default'];

/***/ }),
/* 1304 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['settingsService'];
	
	var distanceFilter = function distanceFilter(settingsService) {
	  return function (distance) {
	    var isImperial = settingsService.settings.IsImperialSystem;
	    var unit = isImperial ? 'mi' : 'km';
	    var rounding = 2;
	
	    if (distance < 1 && !isImperial) {
	      var metresInKm = 1000;
	      distance *= metresInKm;
	      unit = 'm';
	      rounding = 0;
	    }
	
	    distance = _.round(distance, rounding);
	
	    return distance + ' ' + unit;
	  };
	};
	
	distanceFilter.$inject = $inject;
	
	exports['default'] = distanceFilter;
	module.exports = exports['default'];

/***/ }),
/* 1305 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['$filter'];
	
	var genericSortingFilter = function genericSortingFilter($filter) {
	  return function (collection, expression) {
	    return $filter('orderBy')(collection, expression);
	  };
	};
	
	genericSortingFilter.$inject = $inject;
	
	exports['default'] = genericSortingFilter;
	module.exports = exports['default'];

/***/ }),
/* 1306 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = [];
	
	var hotelProviderBrandFilter = function hotelProviderBrandFilter() {
	  return function (brand) {
	    var brandParents = {
	      CON: 'CTM'
	    };
	
	    return brandParents[brand] || brand;
	  };
	};
	
	hotelProviderBrandFilter.$inject = $inject;
	
	exports['default'] = hotelProviderBrandFilter;
	module.exports = exports['default'];

/***/ }),
/* 1307 */,
/* 1308 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var $inject = [];
	
	var keyToLabelFilter = function keyToLabelFilter() {
	  return function (s) {
	    return _.startCase(s);
	  };
	};
	
	keyToLabelFilter.$inject = $inject;
	
	exports["default"] = keyToLabelFilter;
	module.exports = exports["default"];

/***/ }),
/* 1309 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = [];
	
	var locationIconFilter = function locationIconFilter() {
	  return function (type) {
	    switch (type) {
	      case 'Airport':
	        return 'ico-flight';
	        break;
	
	      case 'RailStation':
	        return 'ico-rail';
	        break;
	
	      case 'PointOfInterest':
	        return 'ico-ic-poi0';
	        break;
	
	      case 'Hotel':
	        return 'ico-hotel0';
	        break;
	
	      default:
	        return 'ico-marker';
	        break;
	    }
	  };
	};
	
	locationIconFilter.$inject = $inject;
	
	exports['default'] = locationIconFilter;
	module.exports = exports['default'];

/***/ }),
/* 1310 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var $inject = [];
	
	var noValueFilter = function noValueFilter() {
	  return function (input, char) {
	    return input || char;
	  };
	};
	
	noValueFilter.$inject = $inject;
	
	exports["default"] = noValueFilter;
	module.exports = exports["default"];

/***/ }),
/* 1311 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = [];
	
	var zeroPaddingFilter = function zeroPaddingFilter() {
	  return function (input, char, n) {
	    if (input === undefined) {
	      input = '';
	    }
	
	    return _.padStart(input, n, char);
	  };
	};
	
	zeroPaddingFilter.$inject = $inject;
	
	exports['default'] = zeroPaddingFilter;
	module.exports = exports['default'];

/***/ }),
/* 1312 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = [];
	
	var secondsToTimeFilter = function secondsToTimeFilter() {
	  return function (seconds) {
	    if (typeof seconds !== 'number' || seconds < 0) {
	      return '1 mins';
	    }
	
	    var hours = Math.floor(seconds / 3600);
	    var mins = Math.ceil(seconds % 3600 / 60);
	    var times = [];
	
	    if (hours) {
	      times.push(hours + ' h');
	    }
	
	    if (mins) {
	      times.push(mins + ' min');
	    }
	
	    if (times.length === 0) {
	      times.push('1 min');
	    }
	
	    return times.join(' ');
	  };
	};
	
	secondsToTimeFilter.$inject = $inject;
	
	exports['default'] = secondsToTimeFilter;
	module.exports = exports['default'];

/***/ }),
/* 1313 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = [];
	
	var sectorGroupsFilter = function sectorGroupsFilter() {
	  return function (paymentMethods, group) {
	    if (group === 'All') {
	      return paymentMethods;
	    }
	
	    return _.filter(paymentMethods, function (paymentMethod) {
	      return paymentMethod.SegmentTypes.indexOf(group) > -1;
	    });
	  };
	};
	
	sectorGroupsFilter.$inject = $inject;
	
	exports['default'] = sectorGroupsFilter;
	module.exports = exports['default'];

/***/ }),
/* 1314 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = [];
	
	var toAddressFilter = function toAddressFilter() {
	  return function (addressObject) {
	    if (!addressObject) {
	      return '';
	    }
	
	    var addressFields = [];
	
	    if (addressObject.Address) {
	      addressFields.push(addressObject.Address);
	    }
	
	    if (addressObject.City) {
	      addressFields.push(addressObject.City);
	    }
	
	    if (addressObject.State) {
	      addressFields.push(addressObject.State);
	    }
	
	    if (addressObject.Country && addressObject.Country.Name) {
	      addressFields.push(addressObject.Country.Name);
	
	      if (addressObject.Postcode) {
	        addressFields[addressFields.length - 1] = addressFields[addressFields.length - 1] + ' ' + addressObject.Postcode;
	      }
	    } else if (addressObject.Postcode) {
	      addressFields.push(addressObject.Postcode);
	    }
	
	    return addressFields.join(', ');
	  };
	};
	
	toAddressFilter.$inject = $inject;
	
	exports['default'] = toAddressFilter;
	module.exports = exports['default'];

/***/ }),
/* 1315 */,
/* 1316 */,
/* 1317 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = BaseRoutes;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _resolveDependencies = __webpack_require__(688);
	
	var _resolveDependencies2 = _interopRequireDefault(_resolveDependencies);
	
	BaseRoutes.$inject = ['$urlRouterProvider', '$stateProvider'];
	
	function BaseRoutes($urlRouterProvider, $stateProvider) {
	  $urlRouterProvider.when('', '/');
	
	  $stateProvider.state('app.bookSeat', {
	    url: '/seats',
	    template: '<lb-seat-confirmation\n            itinerary-id="$ctrl.itinerariesService.itinerary.Identifier"\n            commit-seat="$ctrl.commitSeat(seat, flight, transport, payment)"\n          >\n            <lb-seat-maps></lb-seat-maps>\n          </lb-seat-confirmation>',
	    controller: ['seatMapService', '$stateParams', '$state', '$scope', '$rootScope', 'itinerariesService', 'locationService', function (seatMapService, $stateParams, $state, $scope, $rootScope, itinerariesService, locationService) {
	      this.itinerariesService = itinerariesService;
	
	      this.commitSeat = function (seat, flight, transport, payment) {
	        return seatMapService.saveSeat(seat, flight, transport, payment);
	      };
	      $scope.$on('exitSeatMap', function () {
	        return locationService.nextPage(itinerariesService.itinerary.Search);
	      });
	      $scope.$on('legSelected', function (event, selectedLeg) {
	        $state.go('app.bookSeat.map', selectedLeg);
	      });
	      $scope.$on('backToSeatMaps', function () {
	        $state.go('app.bookSeat');
	      });
	      $rootScope.$on('$stateChangeSuccess', function (e, toState) {
	        if (toState.name === 'app.bookSeat' && seatMapService.activeTransport) {
	          seatMapService.activeTransport.active = false;
	          seatMapService.activeSeatMap = undefined;
	        }
	      });
	    }],
	    controllerAs: '$ctrl',
	    resolve: {
	      resolveDependencies: (0, _resolveDependencies2['default'])(function (resolve) {
	        __webpack_require__.e/* nsure */(2, function (require) {
	          return resolve(__webpack_require__(586).name, __webpack_require__(584));
	        });
	      }),
	      initialize: ['seatMapService', 'itinerariesService', function (seatMapService, itinerariesService) {
	        seatMapService.init(itinerariesService.itinerary.Passengers);
	      }]
	    },
	    data: {
	      bodyClass: 'bg-seat-maps'
	    }
	  }).state('app.bookSeat.map', {
	    url: '/{activePaxId}/{flightId}/{transportIndex}',
	    template: '<lb-seat-map-container></lb-seat-map-container>',
	    resolve: {
	      resolveDependencies: (0, _resolveDependencies2['default'])(function (resolve) {
	        return __webpack_require__.e/* nsure */(1, function (require) {
	          return resolve(__webpack_require__(585).name);
	        });
	      }),
	      setActiveSeatMap: ['$q', '$stateParams', 'stateResolveService', function ($q, $stateParams, stateResolveService) {
	        var deferred = $q.defer();
	        return stateResolveService.setActiveSeatMap($stateParams, deferred);
	      }]
	    },
	    data: {
	      bodyClass: 'bg-seat-maps'
	    }
	  }).state('app.prebookSeatMaps', {
	    url: '/itinerary/seatmaps',
	    template: '<lb-seat-confirmation\n            itinerary-id="$ctrl.itinerariesService.itinerary.Identifier"\n            commit-seat="$ctrl.commitSeat(seat, flight, transport, payment)"\n          >\n            <lb-seat-maps></lb-seat-maps>\n          </lb-seat-confirmation>',
	    controller: ['seatMapService', '$state', '$scope', '$rootScope', 'itinerariesService', function (seatMapService, $state, $scope, $rootScope, itinerariesService) {
	      this.itinerariesService = itinerariesService;
	
	      this.commitSeat = function (seat, flight, transport, payment) {
	        return seatMapService.saveSeat(seat, flight, transport, payment);
	      };
	      $scope.$on('exitSeatMap', function () {
	        return $state.go('app.itinerary');
	      });
	      $scope.$on('legSelected', function (event, selectedLeg) {
	        $state.go('app.prebookSeatMaps.map', selectedLeg);
	      });
	      $scope.$on('backToSeatMaps', function () {
	        $state.go('app.prebookSeatMaps');
	      });
	      $rootScope.$on('$stateChangeSuccess', function (e, toState) {
	        if (toState.name === 'app.prebookSeatMaps' && seatMapService.activeTransport) {
	          seatMapService.activeTransport.active = false;
	          seatMapService.activeSeatMap = undefined;
	        }
	      });
	    }],
	    controllerAs: '$ctrl',
	    resolve: {
	      resolveDependencies: (0, _resolveDependencies2['default'])(function (resolve) {
	        return __webpack_require__.e/* nsure */(2/* duplicate */, function (require) {
	          return resolve(__webpack_require__(586).name, __webpack_require__(584));
	        });
	      }),
	      initialize: ['seatMapService', 'itinerariesService', function (seatMapService, itinerariesService) {
	        seatMapService.init(itinerariesService.itinerary.Passengers);
	      }]
	    },
	    data: {
	      bodyClass: 'bg-seat-maps'
	    }
	  }).state('app.prebookSeatMaps.map', {
	    url: '/{activePaxId}/{flightId}/{transportIndex}',
	    template: '<lb-seat-map-container></lb-seat-map-container>',
	    resolve: {
	      resolveDependencies: (0, _resolveDependencies2['default'])(function (resolve) {
	        return __webpack_require__.e/* nsure */(1/* duplicate */, function (require) {
	          return resolve(__webpack_require__(585).name);
	        });
	      }),
	      setActiveSeatMap: ['$q', '$stateParams', 'stateResolveService', function ($q, $stateParams, stateResolveService) {
	        var deferred = $q.defer();
	        return stateResolveService.setActiveSeatMap($stateParams, deferred);
	      }]
	    },
	    data: {
	      bodyClass: 'bg-seat-maps'
	    }
	  }).state('app.mybookings.view', {
	    url: '/{itineraryId}/{passengerId}/{pnr}/{offlinePnr}/{pcc}?{live}',
	    template: '<lb-booking-details></lb-booking-details>',
	    resolve: {
	      resolveDependencies: (0, _resolveDependencies2['default'])(function (resolve) {
	        return __webpack_require__.e/* nsure */(3, function (require) {
	          return resolve(__webpack_require__(1080).name);
	        });
	      }),
	      clearActiveBooking: ['activeBookingService', function (activeBookingService) {
	        return activeBookingService.clear();
	      }]
	    },
	    data: {
	      pageTitle: 'Manage Bookings - view details'
	    }
	  }).state('app.mybookings.viewpnr', {
	    url: '/{pnr}?{live}',
	    template: '<lb-booking-details></lb-booking-details>',
	    resolve: {
	      resolveDependencies: (0, _resolveDependencies2['default'])(function (resolve) {
	        return __webpack_require__.e/* nsure */(3/* duplicate */, function (require) {
	          return resolve(__webpack_require__(1080).name);
	        });
	      }),
	      clearActiveBooking: ['activeBookingService', function (activeBookingService) {
	        return activeBookingService.clear();
	      }]
	    },
	    data: {
	      pageTitle: 'Manage Bookings - view details'
	    }
	  }).state('app.itinerary', {
	    url: '/itinerary',
	    template: '<lb-itinerary></lb-itinerary>',
	    resolve: {
	      resolveDependencies: (0, _resolveDependencies2['default'])(function (resolve) {
	        return __webpack_require__.e/* nsure */(6, function (require) {
	          return resolve(__webpack_require__(261).name);
	        });
	      })
	    },
	    data: {
	      bodyClass: 'section-itinerary'
	    }
	  }).state('app.seatmaps', {
	    url: '/seatmaps/{itineraryId}/{paxId}/{source}',
	    template: '<lb-seat-confirmation\n            itinerary-id="$ctrl.$stateParams.itineraryId"\n            commit-seat="$ctrl.seatMapService.putSeat(seat, flight, transport, payment)"\n          >\n            <lb-seat-maps></lb-seat-maps>\n          </lb-seat-confirmation>',
	    controller: ['seatMapService', '$state', '$stateParams', '$scope', '$rootScope', function (seatMapService, $state, $stateParams, $scope, $rootScope) {
	      this.seatMapService = seatMapService;
	      this.$stateParams = $stateParams;
	      $scope.$on('exitSeatMap', function () {
	        return $state.go('app.mybookings.view', {
	          itineraryId: $stateParams.itineraryId,
	          passengerId: $stateParams.paxId,
	          source: $stateParams.source
	        });
	      });
	      $scope.$on('legSelected', function (event, selectedLeg) {
	        $state.go('app.seatmaps.map', selectedLeg);
	      });
	      $scope.$on('backToSeatMaps', function () {
	        $state.go('app.seatmaps', {
	          itineraryId: $stateParams.itineraryId,
	          paxId: $stateParams.paxId,
	          source: $stateParams.source
	        });
	      });
	      $rootScope.$on('$stateChangeSuccess', function (e, toState) {
	        if (toState.name === 'app.seatmaps' && seatMapService.activeTransport) {
	          seatMapService.activeTransport.active = false;
	          seatMapService.activeSeatMap = undefined;
	        }
	      });
	    }],
	    controllerAs: '$ctrl',
	    resolve: {
	      resolveDependencies: (0, _resolveDependencies2['default'])(function (resolve) {
	        return __webpack_require__.e/* nsure */(2/* duplicate */, function (require) {
	          return resolve(__webpack_require__(586).name, __webpack_require__(584));
	        });
	      }),
	      setActivePax: ['$q', '$stateParams', 'stateResolveService', function ($q, $stateParams, stateResolveService) {
	        var deferred = $q.defer();
	        return stateResolveService.setActivePax($stateParams, deferred);
	      }]
	    },
	    data: {
	      bodyClass: 'bg-seat-maps'
	    }
	  }).state('app.seatmaps.map', {
	    url: '/{activePaxId}/{flightId}/{transportIndex}',
	    template: '<lb-seat-map-container></lb-seat-map-container>',
	    resolve: {
	      resolveDependencies: (0, _resolveDependencies2['default'])(function (resolve) {
	        return __webpack_require__.e/* nsure */(1/* duplicate */, function (require) {
	          return resolve(__webpack_require__(585).name);
	        });
	      }),
	      setActiveSeatMap: ['$q', '$stateParams', 'setActivePax', 'stateResolveService', function ($q, $stateParams, setActivePax, stateResolveService) {
	        var deferred = $q.defer();
	        return stateResolveService.setActiveSeatMap($stateParams, deferred);
	      }]
	    },
	    data: {
	      bodyClass: 'bg-seat-maps'
	    }
	  });
	}
	
	module.exports = exports['default'];

/***/ }),
/* 1318 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _resolveDependencies = __webpack_require__(688);
	
	var _resolveDependencies2 = _interopRequireDefault(_resolveDependencies);
	
	var _oclazyload = __webpack_require__(1126);
	
	var _oclazyload2 = _interopRequireDefault(_oclazyload);
	
	var ngModule = angular.module('lb.bookingRoutes', [_oclazyload2['default']]);
	
	ngModule.run(bookingRouteEvents);
	bookingRouteEvents.$inject = ['$rootScope', 'locationService'];
	function bookingRouteEvents($rootScope, locationService) {
	  // TODO migrate to onStart in each route and remove the segmentType data property after updating ui-router version
	  $rootScope.$on('$stateChangeStart', function (_, toState) {
	    if (toState.data && toState.data.segmentType) {
	      locationService.updateCurrentSearchType(toState.data.segmentType);
	    }
	  });
	}
	
	ngModule.config(bookingRoutes);
	bookingRoutes.$inject = ['$stateProvider'];
	function bookingRoutes($stateProvider) {
	  $stateProvider.state('app.booking', {
	    abstract: true,
	    template: '<ui-view/>',
	    resolve: {
	      itinerary: ['itinerariesService', function (itinerariesService) {
	        return itinerariesService.lazyGet();
	      }],
	      itinerarySearch: ['itinerariesService', function (itinerariesService) {
	        return itinerariesService.getItinerarySearch();
	      }]
	    }
	  }).state('app.booking.segment', {
	    abstract: true,
	    template: '<ui-view/>',
	    resolve: {
	      searchSegment: ['itinerarySearch', 'locationService', function (itinerarySearch, locationService) {
	        var segment = locationService.getCurrentSearchSegment(itinerarySearch);
	        if (segment == null) {
	          throw new Error('Invalid Segment');
	        }
	        return segment;
	      }]
	    }
	  }).state('app.booking.segment.flights', {
	    url: '/flights',
	    params: {
	      selectedItems: null
	    },
	    template: '<lb-search-results search-type="\'Travel\'"></lb-search-results>',
	    resolve: {
	      resolveDependencies: (0, _resolveDependencies2['default'])(function (resolve) {
	        return __webpack_require__.e/* nsure */(0, function (require) {
	          return resolve(__webpack_require__(200).name);
	        });
	      })
	    },
	    data: {
	      pageTitle: 'Search Results - Flights',
	      bodyClass: 'bg-flights',
	      segmentType: 'Flight'
	    }
	  }).state('app.booking.segment.rail', {
	    url: '/rail',
	    template: '<lb-search-results search-type="\'Rail\'"></lb-search-results>',
	    resolve: {
	      resolveDependencies: (0, _resolveDependencies2['default'])(function (resolve) {
	        return __webpack_require__.e/* nsure */(0/* duplicate */, function (require) {
	          return resolve(__webpack_require__(200).name);
	        });
	      })
	    },
	    data: {
	      pageTitle: 'Search Results - Rail',
	      bodyClass: 'bg-rail',
	      segmentType: 'Rail'
	    }
	  }).state('app.booking.segment.groundtransportation', {
	    url: '/ground',
	    resolve: {
	      resolveDependencies: (0, _resolveDependencies2['default'])(function (resolve) {
	        return __webpack_require__.e/* nsure */(4, function (require) {
	          return resolve(__webpack_require__(1315));
	        });
	      })
	    },
	    template: '<lb-modify-ground-transportation search-segment="searchSegment" />',
	    controller: ['$scope', 'searchSegment', function ($scope, searchSegment) {
	      return $scope.searchSegment = searchSegment;
	    }],
	    data: {
	      pageTitle: 'Search Results - Ground Transportation',
	      bodyClass: 'bg-cars',
	      segmentType: 'GroundTransport'
	    }
	  }).state('app.booking.segment.cars', {
	    url: '/cars',
	    template: '<lb-search-results search-type="\'Cars\'"></lb-search-results>',
	    resolve: {
	      resolveDependencies: (0, _resolveDependencies2['default'])(function (resolve) {
	        return __webpack_require__.e/* nsure */(0/* duplicate */, function (require) {
	          return resolve(__webpack_require__(200).name);
	        });
	      })
	    },
	    data: {
	      pageTitle: 'Search Results - Car',
	      bodyClass: 'bg-cars',
	      segmentType: 'Car'
	    }
	  }).state('app.booking.segment.hotels', {
	    url: '/hotels',
	    template: '<lb-search-results search-type="\'Hotels\'"></lb-search-results>',
	    resolve: {
	      resolveDependencies: (0, _resolveDependencies2['default'])(function (resolve) {
	        return __webpack_require__.e/* nsure */(0/* duplicate */, function (require) {
	          return resolve(__webpack_require__(200).name);
	        });
	      })
	    },
	    data: {
	      bodyClass: 'bg-hotels',
	      segmentType: 'Hotel'
	    }
	  }).state('app.booking.confirmation', {
	    url: '/confirmation',
	    template: '<lb-booking-confirmation></lb-booking-confirmation>',
	    resolve: {
	      resolveDependencies: (0, _resolveDependencies2['default'])(function (resolve) {
	        return __webpack_require__.e/* nsure */(8, function (require) {
	          return resolve(__webpack_require__(1154).name);
	        });
	      })
	    },
	    data: {
	      pageTitle: 'Booking Confirmation',
	      bodyClass: 'bg-bookingConfirmation'
	    }
	  });
	}
	
	exports['default'] = ngModule.name;
	module.exports = exports['default'];

/***/ }),
/* 1319 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = lbRoutes;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _resolveDependencies = __webpack_require__(688);
	
	var _resolveDependencies2 = _interopRequireDefault(_resolveDependencies);
	
	lbRoutes.$inject = ['$stateProvider', '$urlRouterProvider'];
	
	function lbRoutes($stateProvider, $urlRouterProvider) {
	  $urlRouterProvider.otherwise(function () {
	    return '/';
	  });
	
	  $stateProvider.state('landing', {
	    abstract: true,
	    template: '<ui-view></ui-view>',
	    data: {
	      isPublic: true
	    }
	  }).state('landing.login', {
	    url: '/login',
	    template: '<lb-login></lb-login>',
	    resolve: {
	      resolveDependencies: (0, _resolveDependencies2['default'])(function (resolve) {
	        return __webpack_require__.e/* nsure */(10, function (require) {
	          return resolve(__webpack_require__(1214).name);
	        });
	      })
	    },
	    onEnter: function onEnter() {
	      sessionStorage.clear();
	    },
	    data: {
	      pageTitle: 'Lightning Book - Login',
	      bodyClass: 'bg-login'
	    }
	  }).state('landing.lightningdisabled', {
	    url: '/lightningdisabled',
	    template: '<lb-lightning-disabled></lb-lightning-disabled>',
	    resolve: {
	      resolveDependencies: (0, _resolveDependencies2['default'])(function (resolve) {
	        return __webpack_require__.e/* nsure */(11, function (require) {
	          return resolve(__webpack_require__(1205).name);
	        });
	      })
	    },
	    onEnter: function onEnter() {
	      sessionStorage.clear();
	    },
	    data: {
	      pageTitle: 'Lightning Book - Login disabled',
	      bodyClass: 'lbdisabledColorBg'
	    }
	  }).state('app', {
	    abstract: true,
	    template: '<ui-view/>',
	    resolve: {
	      settings: ['$q', '$window', 'settingsService', '$fancyModal', function ($q, $window, settingsService, $fancyModal) {
	        return $q.when(settingsService.get().then(function (response) {
	          return response;
	        })['catch'](function (error) {
	          return error;
	        }));
	      }]
	    }
	  }).state('app.error', {
	    url: '/error',
	    template: '<lb-error-screen></lb-error-screen>',
	    resolve: {
	      resolveDependencies: (0, _resolveDependencies2['default'])(function (resolve) {
	        return __webpack_require__.e/* nsure */(12, function (require) {
	          return resolve(__webpack_require__(1186).name);
	        });
	      })
	    },
	    data: {
	      pageTitle: 'Page not found',
	      bodyClass: 'bg-error'
	    },
	    params: {
	      prev: null
	    }
	  }).state('app.home', {
	    url: '/',
	    template: '<lb-home></lb-home>',
	    resolve: {
	      resolveDependencies: (0, _resolveDependencies2['default'])(function (resolve) {
	        return __webpack_require__.e/* nsure */(7, function (require) {
	          return resolve(__webpack_require__(1201).name);
	        });
	      })
	    },
	    data: {
	      pageTitle: 'Lightning Book',
	      bodyClass: 'bg-search'
	    }
	  }).state('app.mybookings', {
	    url: '/my-bookings',
	    template: '<lb-my-bookings></lb-my-bookings>',
	    resolve: {
	      resolveDependencies: (0, _resolveDependencies2['default'])(function (resolve) {
	        return __webpack_require__.e/* nsure */(9, function (require) {
	          return resolve(__webpack_require__(1270).name);
	        });
	      })
	    },
	    data: {
	      pageTitle: 'My Bookings',
	      bodyClass: 'bg-myBookings'
	    }
	  });
	}
	
	module.exports = exports['default'];

/***/ }),
/* 1320 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['sectorService'];
	
	var activeBookingService = function activeBookingService(sectorService) {
	  var service = {};
	
	  service.set = set;
	  service.clear = clear;
	  service.findFlightAddSeatSelection = findFlightAddSeatSelection;
	  service.booking = undefined;
	  service.isLoading = false;
	  service.loadedPnr = null;
	  service.checkForActionRequired = checkForActionRequired;
	
	  function set(booking) {
	    service.isLoading = false;
	    if (service.booking) {
	      service.booking.mbActive = false;
	    }
	
	    service.booking = booking;
	    service.booking.currentStatus = sectorService.currentStatus(service.booking);
	    service.booking.sectors = sectorService.reorder(service.booking);
	    service.booking.abridge = sectorService.abridge(service.booking.sectors);
	    service.booking.priceSummary = sectorService.priceSummary(service.booking.sectors, service.booking.currentBooking, service.booking.Configurations);
	
	    var sectorsAreDefined = typeof service.booking.sectors !== 'undefined';
	    service.booking.isDifferentCurrency = sectorsAreDefined ? service.booking.sectors.reduce(function (prev, sector) {
	      return sector.BaseCurrency.Code == sector.CurrencyCode || prev;
	    }, false) : false;
	
	    service.booking.mbActive = true;
	  }
	
	  function clear() {
	    service.booking = null;
	    service.isLoading = false;
	    service.loadedPnr = null;
	  }
	
	  function findFlightAddSeatSelection(activeBooking, activeFlight, seatNumber) {
	    activeBooking.Flights.every(function (flight, index) {
	      if (flight.Identifier === activeFlight.Identifier) {
	        activeBooking.Flights[index].Seat.SeatNumber = seatNumber;
	        return false;
	      }
	
	      return true; // continue loop
	    });
	  }
	
	  function checkForActionRequired() {
	    var errorCodes = ['UC', 'HX', 'HL'];
	    var hasActionRequired = false;
	    var currentItinerary = service.currentItinerary;
	
	    if (currentItinerary) {
	      var allSectors = [].concat(currentItinerary.Air, currentItinerary.Cars, currentItinerary.Hotels, currentItinerary.Rail, currentItinerary.GroundTransports);
	      var hasActionRequired = false;
	
	      angular.forEach(allSectors, function (sector) {
	        if (sector.BookingStatus && errorCodes.includes(sector.BookingStatus.Code)) {
	          hasActionRequired = true;
	        }
	      });
	    }
	    if (service.booking && service.booking && service.booking.ValidationErrors && service.booking.ValidationErrors.find(function (val) {
	      return val.SeverityType === 'Error';
	    })) {
	      hasActionRequired = true;
	    }
	    return hasActionRequired;
	  }
	
	  return service;
	};
	
	activeBookingService.$inject = $inject;
	
	exports['default'] = activeBookingService;
	module.exports = exports['default'];

/***/ }),
/* 1321 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['APP_CONFIG'];
	
	var apiService = function apiService(APP_CONFIG) {
	  var service = {
	    getUrl: getUrl,
	    isMockActive: isMockActive
	  };
	
	  return service;
	
	  function getUrl(name, slugs) {
	    return isMockActive(name) ? getFullUrl(APP_CONFIG.API[name].mockUrl, slugs) : getFullUrl(APP_CONFIG.API[name].url, slugs);
	  }
	
	  function getFullUrl(apiUrl, slugs) {
	    if (_.isFunction(apiUrl)) {
	      return apiUrl(slugs);
	    }
	
	    return apiUrl;
	  }
	
	  function isMockActive(name) {
	    return APP_CONFIG.MOCK_DATA.active || APP_CONFIG.API[name].useMockUrl;
	  }
	};
	
	apiService.$inject = $inject;
	
	exports['default'] = apiService;
	module.exports = exports['default'];

/***/ }),
/* 1322 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var $inject = [];
	
	var appInsightsService = function appInsightsService() {
	  var service = {};
	
	  service.trackPageView = trackPageView;
	  service.trackEvent = trackEvent;
	  service.trackError = trackError;
	
	  function trackPageView(pageName) {
	    appInsights.trackPageView(pageName);
	  }
	
	  function trackEvent(event, data) {
	    appInsights.trackEvent(event, data);
	  }
	
	  function trackError(error) {
	    appInsights.trackException(error);
	  }
	
	  return service;
	};
	
	appInsightsService.$inject = $inject;
	
	exports["default"] = appInsightsService;
	module.exports = exports["default"];

/***/ }),
/* 1323 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['$q', '$http', '$cookies', '$httpParamSerializer', 'moment', 'settingsService', 'userProfileService', 'userDebtorService', 'apiService', 'APP_CONFIG'];
	
	var authService = function authService($q, $http, $cookies, $httpParamSerializer, moment, settingsService, userProfileService, userDebtorService, apiService, APP_CONFIG) {
	  var service = {};
	  service.getFullName = getFullName;
	  service.login = login;
	  service.logout = logout;
	  service.refresh = refresh;
	  service.signUp = signUp;
	  service.reset = reset;
	  service.forgot = forgot;
	  service.storeAuth = storeAuth;
	  service.getOauth = getOauth;
	  service.clearOauth = clearOauth;
	  service.getAccessToken = getAccessToken;
	  service.getRefreshToken = getRefreshToken;
	  service.isAuthenticated = isAuthenticated;
	
	  function getFullName() {
	    return service.getOauth().fullName;
	  }
	
	  function login(username, password) {
	    var data = {
	      client_id: APP_CONFIG.client.id,
	      client_secret: APP_CONFIG.client.secret,
	      grant_type: 'password',
	      username: username,
	      password: password
	    };
	
	    var req = {
	      isPublic: true,
	      withCredentials: true,
	      method: 'POST',
	      url: APP_CONFIG.api.token,
	      headers: {
	        'Content-type': 'application/x-www-form-urlencoded; charset=utf-8'
	      },
	      data: $httpParamSerializer(data)
	    };
	
	    return $http(req).then(function (data, status, header) {
	      var results = [];
	      results.headers = data.headers();
	      $cookies.put('.AspNet.Application', results.headers.lightningbook_web_cookie);
	      storeAuth(data.data);
	    });
	  }
	
	  function storeAuth(auth) {
	    auth.expires_at = moment().add(auth.expires_in, 's').format('x');
	    localStorage.setItem('oauth', JSON.stringify(auth));
	    return getOauth();
	  }
	
	  function getAuth() {
	    auth.expires_at = moment().add(auth.expires_in, 's').format('x');
	    localStorage.setItem('oauth', JSON.stringify(auth));
	    return getOauth();
	  }
	
	  function logout() {
	    var deferred = $q.defer();
	
	    service.clearOauth();
	    settingsService.clear();
	    userProfileService.clear();
	    userDebtorService.clear();
	    deferred.resolve();
	
	    return deferred.promise;
	  }
	
	  function refresh(accessToken) {
	    var data = {
	      client_id: APP_CONFIG.client.id,
	      client_secret: APP_CONFIG.client.secret,
	      grant_type: 'refresh_token',
	      refresh_token: accessToken
	    };
	
	    var req = {
	      method: 'POST',
	      url: APP_CONFIG.api.token,
	      headers: {
	        'Content-type': 'application/x-www-form-urlencoded; charset=utf-8'
	      },
	      data: $httpParamSerializer(data)
	    };
	
	    return $http(req).then(function (data) {
	      var oauth = {};
	      oauth.refresh_token = data.refresh_token;
	      oauth.access_token = data.access_token;
	
	      localStorage.setItem('oauth', JSON.stringify(oauth));
	    });
	  }
	
	  function signUp(registration) {
	    var req = {
	      isPublic: true,
	      withCredentials: true,
	      method: 'POST',
	      url: apiService.getUrl('signUp'),
	      headers: {
	        'Content-type': 'application/json'
	      },
	      data: registration
	    };
	
	    return $http(req);
	  }
	
	  function forgot(email) {
	    var req = {
	      isPublic: true,
	      method: 'POST',
	      url: apiService.getUrl('forgotPassword', { email: email }),
	      headers: {
	        'Content-type': 'application/json'
	      }
	    };
	
	    return $http(req);
	  }
	
	  function reset(token, credentials) {
	    var req = {
	      isPublic: true,
	      method: 'PUT',
	      url: apiService.getUrl('resetPassword', { token: token }),
	      headers: {
	        'Content-type': 'application/json'
	      },
	      data: credentials
	    };
	
	    return $http(req);
	  }
	
	  function getOauth() {
	    var accessToken = $cookies.get('LIGHTNINGBOOK_API_ACCESSTOKEN');
	
	    if (accessToken) {
	      var oauthData = { access_token: accessToken, expires_at: moment().add(14, 'days').format('x') };
	      localStorage.setItem('oauth', JSON.stringify(oauthData));
	    }
	
	    return JSON.parse(localStorage.getItem('oauth'));
	  }
	
	  function clearOauth() {
	    $cookies.remove('LIGHTNINGBOOK_API_ACCESSTOKEN');
	    $cookies.remove('.AspNet.Application');
	
	    var localStorageKeys = Object.keys(localStorage);
	    var auth0Namespace = 'com.auth0.auth';
	
	    localStorageKeys.forEach(function (key) {
	      if (key.includes(auth0Namespace)) {
	        localStorage.removeItem(key);
	      }
	    });
	
	    return localStorage.removeItem('oauth');
	  }
	
	  function getAccessToken() {
	    var oauth = service.getOauth();
	
	    return oauth ? oauth.access_token : '';
	  }
	
	  function getRefreshToken() {
	    var oauth = service.getOauth();
	
	    return oauth ? oauth.refresh_token : '';
	  }
	
	  function isAuthenticated() {
	    var oauth = service.getOauth();
	
	    return oauth && oauth.expires_at && oauth.expires_at > Date.now();
	  }
	
	  return service;
	};
	
	authService.$inject = $inject;
	
	exports['default'] = authService;
	module.exports = exports['default'];

/***/ }),
/* 1324 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['settingsService'];
	
	var beamerService = function beamerService(settingsService) {
	  var service = {
	    get: get,
	    count: 0,
	    url: '',
	    getCount: getCount,
	    setCount: setCount,
	    getUrl: getUrl,
	    setUrl: setUrl
	  };
	
	  function get() {
	    return new Promise(function (resolve, reject) {
	      settingsService.getAny().then(function (settings) {
	        var user = settings.UserDetails || null;
	        if (!user) return resolve({});
	        var data = {
	          userId: user.UserId
	        };
	        if (beamer_config.sendUserDetails.toLowerCase() === 'true') {
	          var nameParts = user.UserName.split(' ');
	          var firstName = nameParts[0];
	          var lastName = nameParts.slice(1).join(' ');
	          data.userFirstName = firstName;
	          data.userLastName = lastName;
	          data.userEmail = user.UserEmail;
	        }
	        $.ajax({
	          url: beamer_config.apiUrl,
	          method: 'GET',
	          headers: {
	            'Beamer-Api-Key': beamer_config.apiKey
	          },
	          data: data,
	          success: function success(response) {
	            resolve(response);
	          },
	          error: function error(_error) {
	            reject(_error);
	          }
	        });
	      });
	    });
	  }
	
	  function getCount() {
	    return service.count;
	  }
	
	  function setCount(count) {
	    service.count = count;
	  }
	
	  function getUrl() {
	    return service.url;
	  }
	
	  function setUrl(url) {
	    service.url = url;
	  }
	
	  return service;
	};
	
	beamerService.$inject = $inject;
	
	exports['default'] = beamerService;
	module.exports = exports['default'];

/***/ }),
/* 1325 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();
	
	var _leaflet = __webpack_require__(178);
	
	var $inject = ['$q', 'itinerariesService', '$http', 'APP_CONFIG', 'moment'];
	
	var bookingsService = function bookingsService($q, itinerariesService, $http, APP_CONFIG, moment) {
	  var service = {};
	  service.bookingsMasterCopy = [];
	  service.bookings = [];
	  service.clear = clear;
	  service.add = add;
	  service.getTotal = getTotal;
	  service.getBooking = getBooking;
	  service.getBookingPnr = getBookingPnr;
	  service.getBookingPassenger = getBookingPassenger;
	  service.getBookingHistory = getBookingHistory;
	  service.getOfflineBooking = getOfflineBooking;
	  service.aggregateItinerarySegments = aggregateItinerarySegments;
	
	  function add(bookings) {
	    var _bookings = [];
	    var deDupe = bookings.filter(function (booking) {
	      return !service.bookingsMasterCopy.find(function (masterBooking) {
	        return booking.Identifier === masterBooking.Identifier;
	      });
	    });
	
	    deDupe.forEach(function (booking) {
	      if (booking.Pnrs && booking.Pnrs.length > 0) {
	        booking.Pnr = booking.Pnrs[0];
	      }
	      _bookings.push(booking);
	    });
	
	    Array.prototype.push.apply(service.bookings, _bookings);
	    Array.prototype.push.apply(service.bookingsMasterCopy, _bookings);
	  }
	
	  function clear() {
	    service.bookingsMasterCopy = [];
	    service.bookings = [];
	  }
	
	  function getTotal() {
	    return service.bookings.length;
	  }
	
	  function getBooking(itineraryId, passengerId, pcc) {
	    var cachedBooking = _.find(service.bookings, function (booking) {
	      return booking.ItineraryIdentifier === itineraryId && booking.Identifier === passengerId;
	    });
	    if (cachedBooking) {
	      return $q.resolve(cachedBooking);
	    }
	    return $q.all([itinerariesService.find(itineraryId, passengerId, pcc), getCurrentBooking(itineraryId, passengerId, pcc)]).then(function (_ref) {
	      var _ref2 = _slicedToArray(_ref, 2);
	
	      var itinerary = _ref2[0];
	      var currentBooking = _ref2[1];
	
	      itinerary.currentBooking = currentBooking;
	      return itinerary;
	    });
	  }
	  function getBookingPnr(pnr, livePnrData) {
	    return itinerariesService.findPnr(pnr, livePnrData).then(function (booking) {
	      if (booking && booking.Passenger && booking.CurrentItinerary) {
	        booking.Passenger.currentBooking = aggregateItinerarySegments(booking.CurrentItinerary);
	      }
	
	      return booking;
	    }, function (error) {
	      return error;
	    });
	  }
	  function getBookingPassenger(passengerId, livePnrData) {
	    return itinerariesService.findPassenger(passengerId, livePnrData).then(function (booking) {
	      if (booking && booking.Passenger && booking.CurrentItinerary) {
	        booking.Passenger.currentBooking = aggregateItinerarySegments(booking.CurrentItinerary);
	      }
	
	      return booking;
	    }, function (error) {
	      return error;
	    });
	  }
	  function getCurrentBooking(itineraryId, passengerId, pcc) {
	    return $http.get('' + APP_CONFIG.api.itinerary + itineraryId + '/current/' + passengerId + '/' + pcc).then(function (_ref3) {
	      var currentItineraries = _ref3.data;
	      return aggregateItinerarySegments(currentItineraries);
	    }, function (error) {
	      if (error.status === 404) {
	        return null;
	      }
	      throw error;
	    });
	  }
	
	  function getOfflineBooking(pnr, pcc) {
	    return $q.all([itinerariesService.findOffline(pnr, pcc), getCurrentOfflineBooking(pnr, pcc)]).then(function (_ref4) {
	      var _ref42 = _slicedToArray(_ref4, 2);
	
	      var itinerary = _ref42[0];
	      var currentBooking = _ref42[1];
	
	      itinerary.currentBooking = currentBooking;
	      return itinerary;
	    });
	  }
	
	  function getCurrentOfflineBooking(pnr, pcc) {
	    return $http.get(APP_CONFIG.api.itinerary + 'current/' + pnr + '/' + pcc).then(function (_ref5) {
	      var currentItineraries = _ref5.data;
	      return aggregateItinerarySegments(currentItineraries);
	    }, function (error) {
	      if (error.status === 404) {
	        return null;
	      }
	      throw error;
	    });
	  }
	
	  //api/Itinerary/{itineraryId:guid}/passenger/{passengerId:guid}/history
	  function getBookingHistory(itineraryId, passengerId) {
	    var deferred = $q.defer();
	
	    var apiUrl = '' + APP_CONFIG.api.itinerary + itineraryId + '/passenger/' + passengerId + '/history';
	    $http.get(apiUrl).success(deferred.resolve);
	
	    return deferred.promise;
	  }
	
	  function aggregateItinerarySegments(currentItinerary) {
	    return [].concat((currentItinerary.Air || []).map(buildFlightViewModel), (currentItinerary.Cars || []).map(buildCarViewModel), (currentItinerary.Hotels || []).map(buildHotelViewModel), (currentItinerary.Rail || []).map(buildRailViewModel), (currentItinerary.GroundTransports || []).map(buildGroundViewModel));
	  }
	
	  function buildFlightViewModel(airDataModel) {
	    return angular.extend({
	      type: 'flight',
	      dateOrder: moment(airDataModel.Start.DateLocal)
	    }, airDataModel);
	  }
	
	  function buildCarViewModel(carDataModel) {
	    return angular.extend({
	      type: 'car',
	      dateOrder: moment(carDataModel.Start.DateLocal)
	    }, carDataModel);
	  }
	
	  function buildHotelViewModel(hotelDataModel) {
	    return angular.extend({
	      type: 'hotel',
	      dateOrder: moment(hotelDataModel.Start.DateLocal).endOf('day')
	    }, hotelDataModel);
	  }
	
	  function buildRailViewModel(railDataModel) {
	    return angular.extend({
	      type: 'rail',
	      dateOrder: moment(railDataModel.Start.DateLocal),
	      transportation: railDataModel.Transportation
	    }, railDataModel);
	  }
	
	  function buildGroundViewModel(groundDataModel) {
	    return angular.extend({
	      type: 'ground',
	      dateOrder: moment(groundDataModel.DateLocal)
	    }, groundDataModel);
	  }
	
	  function asTyped(leg, type) {
	    leg.type = type;
	    return leg;
	  }
	
	  return service;
	};
	
	bookingsService.$inject = $inject;
	
	exports['default'] = bookingsService;
	module.exports = exports['default'];

/***/ }),
/* 1326 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['$q', '$http', '$filter', 'moment', 'APP_CONFIG'];
	
	var carSearchService = function carSearchService($q, $http, $filter, moment, APP_CONFIG) {
	  var service = {};
	
	  var DEFAULT_SORT = {
	    sortBy: '',
	    isReverse: false
	  };
	
	  service.hasResults = false;
	  service.resultsMaster = [];
	  service.activeFilters = {};
	  service.activeSort = DEFAULT_SORT;
	  service.results = {
	    items: [],
	    sorted: [],
	    PickUpDate: undefined,
	    DropOffDate: undefined,
	    SearchIdentifier: undefined
	  };
	
	  service.get = get;
	  service.getDetails = getDetails;
	  service.getUniqueCategories = getUniqueCategories;
	  service.getUniqueClasses = getUniqueClasses;
	  service.getUniqueVendors = getUniqueVendors;
	  service.getUniqueFuelTypes = getUniqueFuelTypes;
	  service.getMaxRate = getMaxRate;
	  service.clearResults = clearResults;
	  service.setResults = setResults;
	  service.getLowestTotal = getLowestTotal;
	  service.bulkAddFilters = bulkAddFilters;
	  service.filter = filter;
	  service.sort = sort;
	  service.CarMessages = [];
	
	  function get(query) {
	    var deferred = $q.defer();
	
	    service.results.PickUpDate = query.PickUp.Date;
	    service.results.DropOffDate = query.DropOff.Date;
	    service.results.SearchIdentifier = query.Identifier;
	
	    var params = {
	      searchIdentifier: query.Identifier,
	      dateFrom: moment(query.PickUp.Date, 'YYYY-MM-DD[T]HH:mm:ss').format('YYYY-MM-DD[T]HH:mm:ss'),
	      dateTo: moment(query.DropOff.Date, 'YYYY-MM-DD[T]HH:mm:ss').format('YYYY-MM-DD[T]HH:mm:ss'),
	      pickupLocationCode: query.PickUp.Code,
	      dropoffLocationCode: query.DropOff.Code
	    };
	
	    if (query.PickUp.Depot && query.PickUp.Depot.Supplier) {
	      var depot = query.PickUp.Depot;
	      params.supplierCode = depot.Supplier;
	      params.pickupLocationCode = depot.FullCode;
	    }
	
	    if (query.DropOff.Depot && query.DropOff.Depot.Supplier) {
	      var depot = query.DropOff.Depot;
	      params.supplierCode = depot.Supplier;
	      params.dropoffLocationCode = depot.FullCode;
	    }
	
	    var carsUrl = APP_CONFIG.MOCK_DATA.active ? APP_CONFIG.MOCK_DATA.cars : APP_CONFIG.api.car;
	
	    $http.get(carsUrl, { params: params }).success(function (data) {
	      service.CarMessages = data.DisplayMessages;
	      deferred.resolve(data.CarResults);
	    }).error(function () {
	      deferred.reject();
	    });
	
	    return deferred.promise;
	  }
	
	  function getDetails(query) {
	    var deferred = $q.defer();
	
	    var params = {
	      currencyCode: query.currencyCode,
	      dateFrom: moment(query.dateFrom, 'YYYY-MM-DD[T]HH:mm:ss').format('YYYY-MM-DD[T]HH:mm:ss'),
	      dateTo: moment(query.dateTo, 'YYYY-MM-DD[T]HH:mm:ss').format('YYYY-MM-DD[T]HH:mm:ss'),
	      dropoffLocationCode: query.dropoffLocationCode,
	      pickupLocationCode: query.pickupLocationCode,
	      rateCode: query.rateCode,
	      searchIdentifier: query.searchIdentifier,
	      supplierCode: query.supplierCode,
	      vehicleCode: query.vehicleCode
	    };
	
	    var carDetailsUrl = APP_CONFIG.MOCK_DATA.active ? APP_CONFIG.MOCK_DATA.carDetails : APP_CONFIG.api.carDetails;
	
	    $http.get(carDetailsUrl, { params: params }).success(function (data) {
	      deferred.resolve(data);
	    }).error(function () {
	      deferred.reject();
	    });
	
	    return deferred.promise;
	  }
	
	  function getUniqueCategories(results) {
	    var uniqueCategories = _.uniqBy(_.compact(results.map(function (result) {
	      if (!result.Category) {
	        return null;
	      }
	
	      return { value: result.Category, label: result.Category.trim() };
	    })), 'value');
	
	    return _.orderBy(uniqueCategories, function (item) {
	      return item.label;
	    });
	  }
	
	  function getUniqueClasses(results) {
	    var uniqueClasses = _.uniqBy(_.compact(results.map(function (result) {
	      if (!result.Class) {
	        return null;
	      }
	
	      return { value: result.Class, label: result.Class.trim() };
	    })), 'value');
	
	    return _.orderBy(uniqueClasses, function (item) {
	      return item.label;
	    });
	  }
	
	  function getUniqueVendors(results) {
	    var uniqueVendors = _.uniqBy(_.compact(results.map(function (result) {
	      var vendorName = result.Vendor.Title;
	
	      return vendorName ? { value: vendorName, label: vendorName } : null;
	    })), 'value');
	
	    return _.orderBy(uniqueVendors, function (item) {
	      return item.label;
	    });
	  }
	
	  function getUniqueFuelTypes(results) {
	    var uniqueFuelTypes = _.uniqBy(_.compact(results.map(function (result) {
	      if (!result.FuelType) {
	        return null;
	      }
	
	      return { value: result.FuelType, label: result.FuelType.trim() };
	    })), 'value');
	
	    return _.orderBy(uniqueFuelTypes, function (item) {
	      return item.label;
	    });
	  }
	
	  function getMaxRate(results) {
	    return Math.ceil(_.max(_.compact(_.map(results, function (result) {
	      return result.DailyRate;
	    }))));
	  }
	
	  function clearResults() {
	    service.hasResults = false;
	    service.resultsMaster = [];
	    service.results.items = [];
	    service.results.from = 0;
	  }
	
	  function setResults(results) {
	    service.hasResults = true;
	    service.resultsMaster = results;
	    service.results.recommended = [];
	    service.results.items = [];
	    service.results.originalItems = [];
	    _.forEach(results, function (result) {
	      if (result.Recommended) {
	        service.results.recommended.push(result);
	      } else {
	        service.results.items.push(result);
	        service.results.originalItems.push(result);
	      }
	    });
	  }
	
	  function getLowestTotal() {
	    var cheapestCar = _.min(service.resultsMaster, function (car) {
	      return car.Total;
	    });
	
	    return Math.round(cheapestCar.Total);
	  }
	
	  function bulkAddFilters(filters) {
	    _.forOwn(filters, function (filter, key) {
	      service.activeFilters[key] = filter;
	    });
	
	    filter();
	  }
	
	  function filter() {
	    process();
	  }
	
	  function sort(orderBy, isReverse) {
	    if (!orderBy) {
	      service.activeSort = DEFAULT_SORT;
	    } else {
	      service.activeSort = { orderBy: orderBy, isReverse: isReverse };
	    }
	
	    process();
	  }
	
	  function process() {
	    var processedResults = angular.copy(service.results.originalItems);
	
	    _.forOwn(service.activeFilters, function (filter) {
	      if (filter.settings.isActive()) {
	        processedResults = $filter(filter.filterName)(processedResults, filter.settings);
	      }
	    });
	
	    service.results.items = $filter('orderBy')(processedResults, service.activeSort.orderBy, service.activeSort.isReverse);
	  }
	
	  /*function applyFilters() {
	    let filteredResults = service.results.master;
	      Object.keys(service.results.activeFilters).forEach(filter => {
	      const filterSettings = service.results.activeFilters[filter];
	        if(filter === 'Price') {
	        let priceFilterSettings = filterSettings[0];
	          if(priceFilterSettings.minValue > priceFilterSettings.defaultMin || priceFilterSettings.maxValue < priceFilterSettings.defaultMax) {
	          filteredResults = $filter('withinRangeFilter')(filteredResults, priceFilterSettings);
	        }
	      } else {
	        const activeFilters = _.filter(filterSettings, (setting) => {
	          return setting.isActive;
	        });
	          if(activeFilters.length) {
	          filteredResults = $filter('inArrayFilter')(filteredResults, activeFilters);
	        }
	      }
	    });
	      service.results.filtered = filteredResults;
	  }*/
	
	  return service;
	};
	
	carSearchService.$inject = $inject;
	
	exports['default'] = carSearchService;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(205)))

/***/ }),
/* 1327 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['$rootScope', '$q', '$timeout', 'moment', 'itinerariesService', 'carSearchService'];
	
	var cartService = function cartService($rootScope, $q, $timeout, moment, itinerariesService, carSearchService) {
	  var service = {
	    items: [],
	    tickets: [],
	    itemCount: 0,
	    checkHotelPaymentMethods: false,
	    add: add,
	    remove: remove,
	    addToItinerary: addToItinerary,
	    cartContainsMatchedFare: cartContainsMatchedFare,
	    getTickets: getTickets,
	    getTotal: getTotal,
	    getMatchingTicket: getMatchingTicket,
	    getMatchingItemTotal: getMatchingItemTotal,
	    addTicket: addTicket,
	    removeTicket: removeTicket,
	    addMultipleTicket: addMultipleTicket,
	    clear: clear
	  };
	
	  function getTotal() {
	    var total = 0;
	
	    service.items.forEach(function (item) {
	      var itemAmount = 0;
	
	      switch (item.type) {
	        case 'flight':
	          if (item.fare.$state && item.fare.$state.displayMatchedOffset) {
	            itemAmount = item.fare.$state.matchedOffset + (item.selectedBundle != null ? item.selectedBundle.price : 0);
	          } else {
	            itemAmount = item.fare.Amount + (item.selectedBundle != null ? item.selectedBundle.price : 0);
	          }
	
	          break;
	
	        case 'rail':
	          itemAmount = item.OffsetAmount === undefined ? item.DisplayFare.Amount : item.OffsetAmount;
	
	          break;
	
	        case 'hotel':
	          itemAmount = item.rate.TotalAmount;
	
	          break;
	
	        case 'car':
	          itemAmount = item.Total;
	
	          break;
	
	        default:
	          console.warn('NO CART ITEM TYPE FOUND!');
	      }
	
	      if (item.type == 'rail' && itinerariesService.itinerary.IsSinglePnr) {
	        total += itemAmount;
	      } else {
	        total += itemAmount * itinerariesService.totalPaxInCurrentSearch();
	      }
	    });
	
	    return total;
	  }
	
	  function getTicketTotal() {
	    return _.reduce(service.tickets, function (total, ticket) {
	      return total + ticket.Value;
	    }, 0);
	  }
	
	  function getTickets() {
	    return _.map(service.tickets, function (ticket) {
	      return _.extend(ticket, {
	        TicketAmount: ticket.Value
	      });
	    });
	  }
	  function setAnchoredFlight(item) {
	    if (!item || item.type !== 'flight') return;
	    var anchoredFlight = item.result.Identifier;
	    var searchIdentifier = item.result.SearchIdentifier;
	    itinerariesService.itinerary.Search.Flights.forEach(function (flight) {
	      var searchItem = flight.Searches.find(function (s) {
	        return s.Identifier == searchIdentifier;
	      });
	      if (searchItem) {
	        flight.anchoredFlight = anchoredFlight;
	        flight.anchoredTripIdentifier = { TripIdentifier: item.result.TripIdentifier, Fare: item, Flight: item.result };
	      }
	    });
	  }
	  function romoveAnchoredFlight(item) {
	    if (!item || item.type !== 'flight') return;
	    var searchIdentifier = item.result.SearchIdentifier;
	    itinerariesService.itinerary.Search.Flights.forEach(function (flight) {
	      var searchItem = flight.Searches.find(function (s) {
	        return s.Identifier == searchIdentifier;
	      });
	      if (searchItem) {
	        flight.anchoredFlight = null;
	        flight.anchoredTripIdentifier = null;
	      }
	    });
	  }
	
	  function add(newItem) {
	    setAnchoredFlight(newItem);
	    if (newItem.hasOwnProperty('OptionAutomatic')) {
	      if (service.items.length) {
	        remove(service.items[0]).then(function () {
	          newItem.type = 'car';
	          newItem.added = true;
	          service.items = [newItem];
	        });
	      } else {
	        newItem.type = 'car';
	        newItem.added = true;
	        service.items = [newItem];
	      }
	    }
	
	    if (newItem.hasOwnProperty('hotel')) {
	      if (service.items.length) {
	        remove(service.items[0]).then(function () {
	          newItem.type = 'hotel';
	          newItem.room.added = true;
	          newItem.rate.added = true;
	          service.items = [newItem];
	        });
	      } else {
	        newItem.type = 'hotel';
	        newItem.room.added = true;
	        newItem.rate.added = true;
	        service.items = [newItem];
	      }
	    }
	  }
	
	  function remove(item) {
	    var deferred = $q.defer();
	    romoveAnchoredFlight(item);
	    switch (item.type) {
	      case 'rail':
	        var removeBoth = false;
	
	        if (service.items.length === 2 && item.OffsetAmount === undefined) {
	          removeBoth = true;
	        }
	
	        _.remove(service.items, function (cartItem) {
	          return cartItem === item;
	        });
	
	        item.DisplayFare.isSelected = false;
	        item.DisplayFare = item.CheapestFare;
	        item.parent.itemInCart = false;
	        item.row.selected = false;
	        item.addedToCart = false;
	
	        $rootScope.$broadcast('cartService:rail:removed');
	
	        deferred.resolve();
	
	        break;
	
	      case 'flight':
	        _.remove(service.items, function (cartItem) {
	          return cartItem === item;
	        });
	
	        if (removeBoth) {
	          remove(service.items[0]);
	        }
	
	        item.isRemoving = false;
	
	        $rootScope.$broadcast('cartService:flight:removed');
	
	        deferred.resolve();
	
	        break;
	
	      case 'hotel':
	        service.items[0].hotel.added = false;
	        service.items[0].room.added = false;
	        service.items[0].rate.added = false;
	
	        delete service.items[0].PolicyCode;
	        delete service.items[0].PolicyTitle;
	        delete service.items[0].PolicyComments;
	        delete service.items[0].LostSavingsAmount;
	
	        item.isRemoving = false;
	
	        clear();
	
	        deferred.resolve();
	
	        break;
	
	      case 'car':
	        service.items[0].added = false;
	
	        delete service.items[0].PolicyCode;
	        delete service.items[0].PolicyTitle;
	        delete service.items[0].PolicyComments;
	        delete service.items[0].LostSavingsAmount;
	        delete service.items[0].Delivery;
	        delete service.items[0].Collection;
	
	        item.isRemoving = false;
	
	        clear();
	
	        deferred.resolve();
	
	        break;
	
	      default:
	        console.warn('NO CART ITEM TYPE FOUND!');
	
	        deferred.reject();
	    }
	
	    return deferred.promise;
	  }
	
	  function addToItinerary(type) {
	    var cleanedItems = {};
	
	    switch (type) {
	      case 'Rails':
	        cleanedItems = service.items.map(function (item) {
	          var railItem = item;
	          var policy = null;
	
	          if (item.DisplayFare) {
	            railItem = item.DisplayFare;
	          }
	
	          if (item.fareOverride) {
	            railItem = item.fareOverride;
	          }
	
	          if (item.DisplayFare && item.DisplayFare.selectedAdditional) {
	            railItem = item.DisplayFare.selectedAdditional;
	          }
	
	          if (item.PolicyCode || item.PolicyViolations && item.PolicyViolations.length > 0) {
	            policy = {
	              Code: item.PolicyCode,
	              Title: item.PolicyTitle,
	              Comments: item.PolicyComments,
	              PolicyViolations: item.PolicyViolations
	            };
	          }
	
	          return {
	            Carrier: item.row.Carrier,
	            RailNumber: item.row.RailNumber,
	            Departure: {
	              Code: item.row.OriginLocationCode,
	              Location: item.row.OriginLocation,
	              Date: item.row.DepartureDateTimeOffset,
	              City: item.row.OriginCity
	            },
	            Arrival: {
	              Code: item.row.DestinationLocationCode,
	              Location: item.row.DestinationLocation,
	              Date: item.row.ArrivalDateTimeOffset,
	              City: item.row.DestinationCity
	            },
	            Detail: {
	              Codes: railItem.ResBookDesignCode.join(),
	              Rates: railItem.Code.join(),
	              RailCardCode: railItem.RailCardCode
	            },
	            SearchIdentifier: item.row.SearchIdentifier,
	            Policy: policy
	          };
	        });
	        break;
	
	      case 'Flights':
	        console.log(service.items);
	        cleanedItems = service.items.map(function (item) {
	          var policy = null;
	          var timePolicy = null;
	          var lostSavingsAmount = null;
	          var flyAmericaActComplianceStatus = null;
	
	          if (item.fare.PolicyException) {
	            policy = {
	              Code: item.fare.PolicyException.PolicyCode,
	              Title: item.fare.PolicyException.PolicyTitle,
	              Comments: item.fare.PolicyException.PolicyComments,
	              PolicyViolations: item.fare.PolicyException.PolicyViolations
	            };
	
	            timePolicy = {
	              Code: item.fare.PolicyException.OutOfTimePolicyCode,
	              Title: item.fare.PolicyException.OutOfTimePolicyTitle,
	              LeadTimeForInPolicyBooking: item.fare.PolicyException.LeadTimeForInPolicyBooking
	            };
	
	            flyAmericaActComplianceStatus = {
	              FlyAmericaActBreakPolicyReason: item.fare.PolicyException.FlyAmericaPolicyTitle,
	              FlyAmericaActBreakPolicyReasonCode: item.fare.PolicyException.FlyAmericaPolicyCode,
	              FlyAmericaActComplianceExceptionReason: item.fare.PolicyException.FlyAmericaActComplianceExceptionReason,
	              FlyAmericaActComplianceType: item.fare.PolicyException.FlyAmericaActComplianceType
	            };
	            lostSavingsAmount = item.fare.PolicyException.LostSavingsAmount;
	          }
	
	          return {
	            Carrier: item.result.Carrier,
	            FlightNumber: item.result.TripNumber,
	            Departure: {
	              Code: item.result.OriginLocationCode,
	              Location: item.result.OriginLocation,
	              City: item.result.OriginCity,
	              Date: item.result.DepartureDateTimeOffset
	            },
	            Arrival: {
	              Code: item.result.DestinationLocationCode,
	              Location: item.result.DestinationLocation,
	              City: item.result.DestinationCity,
	              Date: item.result.ArrivalDateTimeOffset
	            },
	            Detail: {
	              Codes: item.fare.ResBookDesignCode.join(),
	              Rates: item.fare.Code.join(),
	              GdsProvider: item.fare.GdsProvider
	            },
	            SearchIdentifier: item.result.SearchIdentifier,
	            LostSavingsAmount: lostSavingsAmount,
	            Policy: policy,
	            TimePolicy: timePolicy,
	            FlyAmericaActComplianceStatus: flyAmericaActComplianceStatus
	          };
	        });
	        break;
	
	      case 'Cars':
	        cleanedItems = service.items.map(function (C) {
	          var policy = {
	            Code: C.PolicyCode,
	            Title: C.PolicyTitle,
	            Comments: C.PolicyComments,
	            PolicyViolations: C.PolicyViolations
	          };
	          var specialRequests = null;
	          var lostSavingsAmount = null;
	
	          if (C.specialRequests) {
	            specialRequests = C.specialRequests;
	          }
	
	          if (C.LostSavingsAmount) {
	            lostSavingsAmount = C.LostSavingsAmount;
	          }
	
	          return {
	            Supplier: {
	              Code: C.Vendor.Code,
	              Title: C.Vendor.Title
	            },
	            Vehicle: {
	              Code: C.Code,
	              Class: C.Class,
	              Title: C.Title,
	              Category: C.Category
	            },
	            RateCode: C.RateCode,
	            CurrencyCode: C.CurrencyCode,
	            PickUp: {
	              Date: carSearchService.results.PickUpDate,
	              Code: C.PickupLocationCode,
	              Location: C.PickupLocation
	            },
	            DropOff: {
	              Date: carSearchService.results.DropOffDate,
	              Code: C.DropOffLocationCode,
	              Location: C.DropOffLocation
	            },
	            DeliveryAddress: C.DeliveryAddress,
	            CollectionAddress: C.CollectionAddress,
	            SearchIdentifier: carSearchService.results.SearchIdentifier,
	            Amount: C.Total,
	            TaxAmount: 0.0,
	            SpecialRequests: specialRequests,
	            LostSavingsAmount: lostSavingsAmount,
	            Policy: policy
	          };
	        });
	
	        break;
	
	      case 'Hotels':
	        cleanedItems = service.items.map(function (item) {
	          var currentSearch = itinerariesService.getCurrentSearch();
	          var policy = {};
	          var paymentNarrative = null;
	          var specialRequirements = null;
	          var lostSavingsAmount = null;
	
	          if (item.PolicyCode) {
	            policy = {
	              Code: item.PolicyCode,
	              Title: item.PolicyTitle,
	              Comments: item.PolicyComments
	            };
	          }
	          if (item.PolicyViolations) policy.PolicyViolations = item.PolicyViolations;
	
	          if (item.HotelPaymentNarrative) {
	            paymentNarrative = {
	              Code: item.HotelPaymentNarrative.PaymentCode,
	              Title: item.HotelPaymentNarrative.PaymentNarrative,
	              Description: item.HotelPaymentNarrative.PaymentInstructions,
	              ServiceCode: item.HotelPaymentNarrative.ServiceFeeCode
	            };
	          }
	
	          if (item.specialRequirements) {
	            specialRequirements = item.specialRequirements;
	          }
	
	          if (item.LostSavingsAmount) {
	            lostSavingsAmount = item.LostSavingsAmount;
	          }
	
	          return {
	            DateFrom: item.dateFrom,
	            DateTo: item.dateTo,
	            HotelCode: item.room.HotelCode,
	            HotelName: item.hotel.HotelName,
	            ChainCode: item.hotel.ChainCode,
	            RateCode: item.rate.RateCode,
	            RoomName: item.room.RoomName,
	            Location: {
	              Code: item.hotel.HotelCityCode
	            },
	            SpecialRequirements: specialRequirements,
	            BookingPaymentTypeCode: item.rate.BookingPaymentTypeCode,
	            SearchIdentifier: currentSearch.Identifier,
	            Amount: item.rate.TotalAmount,
	            TaxAmount: item.rate.TaxAmount,
	            LostSavingsAmount: lostSavingsAmount,
	            Policy: Object.keys(policy).length ? policy : null,
	            PaymentNarrative: paymentNarrative,
	            DepositPolicy: item.rate.DepositPolicy,
	            BookingPaymentType: item.rate.BookingPaymentType,
	            HotelRateDetails: item.rate.HotelRateDetails
	          };
	        });
	
	        break;
	
	      default:
	        console.warn('NO TYPE FOUND!');
	    }
	
	    return {
	      cleanedItems: cleanedItems,
	      type: type
	    };
	  }
	
	  function cartContainsMatchedFare(matchedFares) {
	    return containsMatchedFare(service.items, matchedFares);
	  }
	
	  function containsMatchedFare(fares, matchedFares) {
	    return _.some(fares, function (cartItem) {
	      return _.some(matchedFares, function (matchedFare) {
	        return matchedFare.Identifier === cartItem.fare.Identifier;
	      });
	    });
	  }
	
	  function getMatchingTicket(ticket) {
	    return _.find(service.tickets, function (selectedTicket) {
	      return ticket.Carrier === selectedTicket.Carrier && ticket.PassengerIdentifier === selectedTicket.PassengerIdentifier;
	    }, 0);
	  }
	
	  function getMatchingItemTotal(ticket) {
	    return _.reduce(service.items, function (total, selectedItem) {
	      var sameCarrier = ticket.Carrier === selectedItem.result.Carrier;
	
	      return total + (sameCarrier ? selectedItem.fare.Amount : 0);
	    }, 0);
	  }
	
	  function addTicket(ticket) {
	    if (ticket.isSelected) {
	      return false;
	    }
	    ticket.isSelected = true;
	    deselectOtherTickets(ticket);
	    service.tickets.push(ticket);
	  }
	
	  function addMultipleTicket(ticket, remove) {
	    if (remove) {
	      ticket.isSelected = false;
	      removeTicket(ticket);
	    } else {
	      ticket.isSelected = true;
	      service.tickets.push(ticket);
	    }
	  }
	
	  function removeTicket(ticket) {
	    ticket.isSelected = false;
	
	    service.tickets = _.reject(service.tickets, function (selectedTicket) {
	      return selectedTicket === ticket;
	    });
	  }
	
	  function deselectOtherTickets(selectedTicket) {
	    for (var i = 0; i < service.tickets.length; i++) {
	      var otherTicket = service.tickets[i];
	      if (otherTicket !== selectedTicket) {
	        otherTicket.isSelected = false;
	        service.tickets.splice(i, 1);
	      }
	    }
	  }
	
	  function clear() {
	    service.items = [];
	    service.tickets = [];
	  }
	
	  return service;
	};
	
	cartService.$inject = $inject;
	
	exports['default'] = cartService;
	module.exports = exports['default'];

/***/ }),
/* 1328 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['$httpParamSerializer'];
	
	var cdnService = function cdnService($httpParamSerializer) {
	  var service = {};
	
	  service.imageResize = imageResize;
	
	  function imageResize(args) {
	    args.options = angular.extend(args.options, {
	      mode: args.mode ? args.mode : 'crop',
	      format: 'jpg',
	      quality: 71
	    });
	
	    if (args.imgPath.includes('?')) {
	      return args.imgPath + '&' + $httpParamSerializer(args.options);
	    } else {
	      return args.imgPath + '?' + $httpParamSerializer(args.options);
	    }
	  }
	
	  return service;
	};
	
	cdnService.$inject = $inject;
	
	exports['default'] = cdnService;
	module.exports = exports['default'];

/***/ }),
/* 1329 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	citySearchService.$inject = ['$http', 'APP_CONFIG'];
	function citySearchService($http, APP_CONFIG) {
	  return {
	    get: function get(params) {
	      return $http.get(APP_CONFIG.api.citySearch, { params: params }).then(function (response) {
	        response.data.forEach(populateViewModelLabels);
	        return response.data;
	      });
	    },
	    getByCode: function getByCode(cityCode) {
	      return $http.get(APP_CONFIG.api.citySearch + '/' + cityCode).then(function (response) {
	        var city = response.data;
	        if (city) {
	          populateViewModelLabels(city);
	          return city;
	        }
	        return null;
	      });
	    }
	  };
	}
	
	function populateViewModelLabels(city) {
	  city.Airports.forEach(function (airport) {
	    airport.Label = airport.Name + ' (' + airport.Value + ')';
	  });
	  city.cityCountry = city.City + ':' + city.Country;
	  city.label = locationLabel(city);
	}
	
	function locationLabel(location) {
	  var label = location.City;
	  if (location.StateCode) {
	    label += ', ' + location.StateCode;
	  }
	  label += ' (' + location.CountryCode + ')';
	  return label;
	}
	
	exports['default'] = citySearchService;
	module.exports = exports['default'];

/***/ }),
/* 1330 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _angularAnimate = __webpack_require__(1077);
	
	var $inject = ['$q', '$http', 'apiService'];
	
	var companyReferenceListService = function companyReferenceListService($q, $http, apiService) {
	  var service = {};
	  service.get = get;
	
	  function get(params) {
	    var apiUrl = apiService.getUrl('companyreferences');
	
	    return $http.get(apiUrl, { params: params }).then(function (response) {
	      return response.data;
	    });
	  }
	
	  return service;
	};
	
	companyReferenceListService.$inject = $inject;
	
	exports['default'] = companyReferenceListService;
	module.exports = exports['default'];

/***/ }),
/* 1331 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['$filter', 'settingsService', 'ENUMS'];
	
	var dateTimeService = function dateTimeService($filter, settingsService, ENUMS) {
	  var service = {};
	
	  var FILE_DATE_FORMAT_SHORT = $filter('translate')('dates.DateFormat');
	  var FILE_DATE_FORMAT_MEDIUM = $filter('translate')('dates.DateFormatMedium');
	  var FILE_DATE_FORMAT_LONG = $filter('translate')('dates.DateFormatLong');
	  var FILE_TIME_FORMAT_LONG = $filter('translate')('dates.TimeFormatLong');
	  var FILE_DATE_TIME_FORMAT_LONG = $filter('translate')('dates.DateTimeFormatLong');
	
	  service.getFormat = getFormat;
	
	  function getFormat(enumValue) {
	    var dateTimeConfiguration = settingsService.settings.DateTimeConfiguration;
	    switch (enumValue) {
	      case ENUMS.dateTimeFormats.DATE_SHORT:
	        return dateTimeConfiguration.DateFormatShort ? dateTimeConfiguration.DateFormatShort : FILE_DATE_FORMAT_SHORT;
	
	      case ENUMS.dateTimeFormats.DATE_MEDIUM:
	        return dateTimeConfiguration.DateFormatMedium ? dateTimeConfiguration.DateFormatMedium : FILE_DATE_FORMAT_MEDIUM;
	
	      case ENUMS.dateTimeFormats.DATE_LONG:
	        return dateTimeConfiguration.DateFormatLong ? dateTimeConfiguration.DateFormatLong : FILE_DATE_FORMAT_LONG;
	
	      case ENUMS.dateTimeFormats.TIME_LONG:
	        return dateTimeConfiguration.TimeFormatLong ? dateTimeConfiguration.TimeFormatLong : FILE_TIME_FORMAT_LONG;
	
	      case ENUMS.dateTimeFormats.DATE_TIME_LONG:
	        return dateTimeConfiguration.DateTimeFormat ? dateTimeConfiguration.DateTimeFormat : FILE_DATE_TIME_FORMAT_LONG;
	
	      default:
	        throw new Error('Invalid dateTime format required in dateTimeService.getFormat');
	    }
	  }
	
	  service.getMinutesFromTime = getMinutesFromTime;
	  function getMinutesFromTime(time) {
	    var timeParts = time.split(':');
	    return parseInt(timeParts[0], 10) * 60 + parseInt(timeParts[1], 10);
	  }
	
	  return service;
	};
	
	dateTimeService.$inject = $inject;
	
	exports['default'] = dateTimeService;
	module.exports = exports['default'];

/***/ }),
/* 1332 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['$q', '$http', 'apiService'];
	
	var departmentService = function departmentService($q, $http, apiService) {
	  var service = {
	    getAllDepartments: getAllDepartments,
	    getDepartments: getDepartments,
	    getCostCentres: getCostCentres
	  };
	
	  function getAllDepartments() {
	    var deferred = $q.defer();
	    var apiUrl = apiService.getUrl('department');
	
	    $http.get(apiUrl).then(function (response) {
	      deferred.resolve(response.data);
	    })['catch'](function () {
	      deferred.reject('there was an error');
	    });
	
	    return deferred.promise;
	  }
	
	  function getDepartments(params) {
	    var deferred = $q.defer();
	    var apiUrl = apiService.getUrl('department');
	
	    $http.get(apiUrl, { params: params }).then(function (response) {
	      deferred.resolve(response.data);
	    })['catch'](function () {
	      deferred.reject('there was an error');
	    });
	
	    return deferred.promise;
	  }
	
	  function getCostCentres(params) {
	    var deferred = $q.defer();
	    var apiUrl = apiService.getUrl('costCentres');
	
	    $http.get(apiUrl, { params: params }).then(function (response) {
	      deferred.resolve(response.data);
	    })['catch'](function () {
	      deferred.reject('there was an error');
	    });
	
	    return deferred.promise;
	  }
	
	  return service;
	};
	
	departmentService.$inject = $inject;
	
	exports['default'] = departmentService;
	module.exports = exports['default'];

/***/ }),
/* 1333 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['$q', '$http', 'APP_CONFIG'];
	
	var depotSearchService = function depotSearchService($q, $http, APP_CONFIG) {
	  var service = {};
	
	  service.get = get;
	
	  function get(params) {
	    var deferred = $q.defer();
	    var url = APP_CONFIG.api.depotSearch;
	
	    $http.get(url, { params: params }).then(function (response) {
	      var data = {
	        carSuppliers: [],
	        suppliers: {},
	        supplierLocations: [],
	        anySupplier: {
	          supplierId: '',
	          supplierLogo: 'https://az867575.vo.msecnd.net/static/blank.gif',
	          supplierName: 'Any Supplier'
	        }
	      };
	
	      response.data.forEach(function (supplier) {
	        var thisSupplier = {
	          supplierId: supplier.Code,
	          supplierLogo: supplier.Logo,
	          supplierName: supplier.Title
	        };
	
	        data.carSuppliers.push(thisSupplier);
	
	        data.suppliers[supplier.Code] = thisSupplier;
	
	        supplier.Depots.forEach(function (depot) {
	          data.supplierLocations.push({
	            addressLabel: depot.Address,
	            addressLine: depot.Street,
	            cityName: depot.City,
	            cityCode: depot.CityCode,
	            fullCode: depot.FullCode,
	            code: depot.Code,
	            latitude: depot.Latitude,
	            locationCode: depot.Code,
	            longtitude: depot.Longitude,
	            stateCode: depot.State,
	            supplierId: depot.Supplier
	          });
	        });
	      });
	
	      data.suppliers.ANY = data.anySupplier;
	
	      data.carSuppliers.push(data.anySupplier);
	
	      deferred.resolve(data);
	    })['catch'](function (err) {
	      deferred.reject(err);
	    });
	
	    return deferred.promise;
	  }
	
	  return service;
	};
	
	depotSearchService.$inject = $inject;
	
	exports['default'] = depotSearchService;
	module.exports = exports['default'];

/***/ }),
/* 1334 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['$http', '$q', '$filter', '$rootScope', 'moment', 'APP_CONFIG', 'cartService', 'settingsService', 'ENUMS', 'dateTimeService'];
	
	var flailService = function flailService($http, $q, $filter, $rootScope, moment, APP_CONFIG, cartService, settingsService, ENUMS, dateTimeService) {
	  var service = {
	    resultsMaster: { flail: [] },
	    resultsMasterCopy: { flail: [] },
	    results: { flail: [] },
	    fareClasses: [],
	    hasResults: false,
	    errorMessage: null,
	    currentFilter: undefined,
	    activeTime: null,
	    displayMessages: [],
	    setActiveTime: setActiveTime,
	    init: init,
	    start: start,
	    getResults: getResults,
	    getFareRules: getFareRules,
	    prepData: prepData,
	    addFilter: addFilter,
	    bulkAddFilters: bulkAddFilters,
	    removeFilter: removeFilter,
	    setFilters: setFilters,
	    sort: sort,
	    itemAddedToCart: itemAddedToCart,
	    BulkRemoveFareClassFilter: BulkRemoveFareClassFilter,
	    checkFareFilters: checkFareFilters,
	    orderClasses: orderClasses,
	    removeOverlappingDateTimeRanges: removeOverlappingDateTimeRanges,
	    getMinutesFromDuration: getMinutesFromDuration
	  };
	
	  var TIME_FORMAT = dateTimeService.getFormat(ENUMS.dateTimeFormats.TIME_LONG);
	
	  function init() {
	    service.resultsMaster = {};
	    service.resultsMasterCopy = {};
	    service.results = { flail: [] };
	    service.fareClasses = [];
	    service.hasResults = false;
	    service.hasBackendError = false;
	    service.errorMessage = [];
	    service.currentFilter = undefined;
	    service.activeTime = null;
	    service.displayMessages = [];
	
	    $rootScope.$on('cartService:rail:removed', service.checkFareFilters);
	  }
	
	  function start(searches) {
	    service.getResults('Rail', searches).then(function () {
	      service.hasResults = true;
	      service.resultsMaster = angular.copy(service.results);
	      service.resultsMasterCopy = angular.copy(service.results);
	    })['catch'](function () {
	      service.hasBackendError = true;
	    });
	  }
	
	  function getResults(type, searches) {
	    var search = searches.Rails[0];
	    var returnSearch = searches.Rails[1];
	
	    var apiUrl = APP_CONFIG.MOCK_DATA.active ? APP_CONFIG.MOCK_DATA[type] : '' + APP_CONFIG.api.url + type + '/search';
	    var params = [];
	
	    for (var i = 0; i < searches.Rails.length; i++) {
	      params.push({
	        SearchIdentifier: searches.Rails[i].Identifier,
	        SearchDate: moment(searches.Rails[i].Date, 'YYYY-MM-DD[T]HH:mm:ss').format('YYYY-MM-DD[T]HH:mm:ss'),
	        OriginLocationCode: searches.Rails[i].Origin.Code,
	        DestinationLocationCode: searches.Rails[i].Destination.Code,
	        PaxCount: searches.Rails[i].Passengers.length,
	        OpenReturn: searches.Rails.length > 1 ? false : searches.Rails[i].OpenReturn,
	        RailCardCode: searches.Rails[0].RailCardCode
	      });
	    }
	
	    var deferred = $q.defer();
	    $http.post(apiUrl, params).success(function (data) {
	      service.displayMessages = data.DisplayMessages;
	      var railResults = data.RailResults;
	      railResults.forEach(function (rail, index) {
	        var orderedData = $filter('orderBy')(rail.Results, 'DepartureTime');
	        service.results.flail[index] = prepData(orderedData);
	        service.errorMessage.push(rail.Response);
	      });
	
	      deferred.resolve(true);
	    }).error(function () {
	      deferred.reject();
	    });
	
	    return deferred.promise;
	  }
	
	  function getFareRules(type, sector, fare) {
	    var deferred = $q.defer();
	
	    if (fare.RemarksCollection) {
	      var fareRuleData = function fareRuleData() {
	        var text = '';
	        if (type == 'Rail' && fare.Code != null && fare.Code.constructor === Array && fare.Code.length != 0 && fare.Class) {
	          text = 'Fare rules for ' + fare.Code[0] + ' fares in ' + fare.Class + ' class apply\n\n';
	        }
	
	        _.forEach(fare.RemarksCollection, function (obj) {
	          text = text + obj.Code + '\n' + obj.Value + '\n\n';
	        });
	        return text;
	      };
	
	      var fareRules = {
	        Type: 'Text',
	        Data: fareRuleData()
	      };
	
	      deferred.resolve(fareRules);
	    } else {
	      var apiUrl = '' + APP_CONFIG.api.url + type + '/FareRules';
	
	      var params = {
	        carrierCode: sector.Carrier,
	        railNumber: sector.RailNumber,
	        departureCode: sector.OriginLocationCode,
	        departureDate: sector.DepartureDateTime,
	        destinationCode: sector.DestinationLocationCode,
	        fareCode: fare.Code[0],
	        searchIdentifier: sector.SearchIdentifier
	      };
	
	      $http.get(apiUrl, { params: params }).success(function (data) {
	        deferred.resolve(data);
	      }).error(function () {
	        deferred.reject();
	      });
	    }
	
	    return deferred.promise;
	  }
	
	  function prepData(data) {
	    var availableFilters = {
	      priceRange: {
	        name: 'priceRange',
	        label: 'Price',
	        labelSuffix: '(' + settingsService.settings.Currency.Code + ')',
	        isResultsFilter: true,
	        settings: {
	          type: 'range',
	          reference: 'Price',
	          filterName: 'flailPriceRangeFilter',
	          defaultMax: 0,
	          defaultMin: 0,
	          maxValue: 0,
	          minValue: 0,
	          step: 1,
	          translateFunc: function translateFunc(value) {
	            return $filter('currency')(value, '', 0);
	          },
	          isActive: function isActive() {
	            return this.minValue > this.defaultMin || this.maxValue < this.defaultMax;
	          },
	          clear: function clear() {
	            this.minValue = this.defaultMin;
	            this.maxValue = this.defaultMax;
	          }
	        }
	      },
	      departureTimeRange: {
	        name: 'departureTimeRange',
	        label: 'Departure Time',
	        isResultsFilter: true,
	        settings: {
	          type: 'range',
	          reference: 'Departure',
	          filterName: 'flailTimeFilter',
	          defaultMax: 1439,
	          defaultMin: 0,
	          maxValue: 1439,
	          minValue: 0,
	          step: 5,
	          translateFunc: translateMinutesTime,
	          isActive: function isActive() {
	            return this.minValue > this.defaultMin || this.maxValue < this.defaultMax;
	          },
	          clear: function clear() {
	            this.minValue = this.defaultMin;
	            this.maxValue = this.defaultMax;
	          }
	        }
	      },
	      arrivalTimeRange: {
	        name: 'arrivalTimeRange',
	        label: 'Arrival Time',
	        isResultsFilter: true,
	        settings: {
	          type: 'range',
	          reference: 'Arrival',
	          filterName: 'flailTimeFilter',
	          defaultMax: 1439,
	          defaultMin: 0,
	          maxValue: 1439,
	          minValue: 0,
	          step: 5,
	          translateFunc: translateMinutesTime,
	          isActive: function isActive() {
	            return this.minValue > this.defaultMin || this.maxValue < this.defaultMax;
	          },
	          clear: function clear() {
	            this.minValue = this.defaultMin;
	            this.maxValue = this.defaultMax;
	          }
	        }
	      },
	      provider: {
	        label: 'Providers',
	        filterName: 'anyInCollectionFilter',
	        isResultsFilter: true,
	        settings: {
	          type: 'multiSelect',
	          reference: 'Provider',
	          selectedReference: 'value',
	          options: [],
	          selected: [],
	          isActive: function isActive() {
	            return this.selected.length > 0;
	          },
	          clear: function clear() {
	            this.selected = [];
	          }
	        }
	      }
	    };
	
	    var obj = {
	      searchResults: data,
	      classes: [],
	      activeFilters: {},
	      filters: {
	        options: availableFilters,
	        layout: [['priceRange', 'departureTimeRange', 'arrivalTimeRange'], ['provider']]
	      }
	    };
	
	    angular.forEach(data, function (item) {
	      var fareClasses = item.FareClasses;
	      item.TotalFares = 0;
	      item.HasAdditionalFares = false;
	
	      angular.forEach(item.Legs, function (leg) {
	        if (leg.TrainName && leg.TrainName.toLowerCase().includes('acela')) {
	          item.HasAcelaOption = true;
	        }
	      });
	
	      angular.forEach(fareClasses, function (fare, key) {
	        if (fare == null) {
	          delete fareClasses[key];
	        } else {
	          fare.Class = key;
	          fare.DisplayFare = _.omit(fare, 'AdditionalFares');
	          fare.CheapestFare = fare.DisplayFare;
	
	          fare.AdditionalFares = _.map(fare.AdditionalFares, function (additionalFare) {
	            additionalFare.Class = key;
	            return additionalFare;
	          });
	
	          fare.AdditionalFares.unshift(fare.DisplayFare);
	
	          if (fare.AdditionalFares.length > 1) {
	            item.HasAdditionalFares = true;
	          }
	
	          item.TotalFares += fare.AdditionalFares.length;
	        }
	      });
	
	      obj.classes = obj.classes.concat(Object.keys(fareClasses));
	      var priceFilterSettings = obj.filters.options.priceRange.settings;
	
	      if (item.MaxRate > priceFilterSettings.maxValue) {
	        priceFilterSettings.maxValue = item.MaxRate;
	        priceFilterSettings.defaultMax = item.MaxRate;
	      }
	
	      item.TripDays = calculateDayChanges(item.DepartureDateTime, item.ArrivalDateTime);
	    });
	
	    availableFilters.provider.settings.options = getCarrierOptions(data);
	
	    buildFareClasses(obj.classes);
	
	    obj.classes = orderClasses(service.fareClasses);
	
	    return obj;
	  }
	
	  function calculateDayChanges(departureDateTime, arrivalDateTime) {
	    var depart = new Date(departureDateTime);
	    var arrive = new Date(arrivalDateTime);
	    if (isNaN(depart.getTime()) || isNaN(arrive.getTime())) return 0;
	
	    var departDate = new Date(depart.getFullYear(), depart.getMonth(), depart.getDate());
	    var arriveDate = new Date(arrive.getFullYear(), arrive.getMonth(), arrive.getDate());
	
	    var diff = arriveDate.getTime() - departDate.getTime();
	    return Math.floor(diff / (1000 * 60 * 60 * 24));
	  }
	
	  function buildFareClasses(classes) {
	    service.fareClasses = service.fareClasses.concat(classes);
	    service.fareClasses = _.uniq(service.fareClasses);
	  }
	
	  function bulkAddFilters(filters, target, index, fareClass) {
	    _.forOwn(filters, function (filter, key) {
	      service.results[target][index].activeFilters[key] = filter;
	    });
	
	    if (fareClass) {
	      service.results[target][index].activeFilters.fareClass = fareClass;
	    }
	
	    service.setFilters(target, index);
	  }
	
	  function addFilter(filter, args, target, index) {
	    service.results[target][index].activeFilters[filter] = args;
	    service.setFilters(target, index);
	  }
	
	  function removeFilter(filter, target, index) {
	    delete service.results[target][index].activeFilters[filter];
	    service.setFilters(target, index);
	  }
	
	  function setFilters(target, index) {
	    service.results[target][index].searchResults = _.clone(service.resultsMaster[target][index].searchResults);
	
	    $filter('flailCleanFilter')(service.results, target, index, ['filtered', 'priceFiltered', 'noMatch']);
	
	    Object.keys(service.results[target][index].activeFilters).forEach(function (filter) {
	      var args = service.results[target][index].activeFilters[filter];
	
	      if (filter === 'flailTimeFilter') {
	        $filter('flailTimeFilter')(service.results, args, target, index, 'DepartureTime');
	      }
	
	      if (filter === 'priceRange' && cartService.items.length === 0) {
	        $filter('flailPriceRangeFilter')(service.results, args.settings, target, index);
	      }
	
	      if (filter === 'departureTimeRange') {
	        var obj = {
	          start: args.settings.minValue,
	          end: args.settings.maxValue
	        };
	
	        $filter('flailTimeFilter')(service.results, obj, target, index, 'DepartureTime');
	      }
	
	      if (filter === 'arrivalTimeRange') {
	        var obj = {
	          start: args.settings.minValue,
	          end: args.settings.maxValue
	        };
	
	        $filter('flailTimeFilter')(service.results, obj, target, index, 'ArrivalTime');
	      }
	
	      if (filter === 'matchingFares') {
	        $filter('matchingFaresFilter')(service.results, args, target, index);
	      }
	
	      if (filter === 'fareClass' && service.results[target][index].itemInCart) {
	        $filter('fareClassFilter')(service.results, args, target, index);
	      }
	
	      if (filter === 'provider') {
	        $filter('flailProviderFilter')(service.results, args, target, index);
	      }
	    });
	  }
	
	  function sort(filterExpression, index) {
	    if (service.currentFilter != filterExpression) {
	      service.currentFilter = filterExpression;
	      $filter('flailGenericFilter')(service.results, filterExpression, index);
	    } else {
	      service.currentFilter = undefined;
	      $filter('flailGenericFilter')(service.results, 'DepartureTime', index);
	    }
	  }
	
	  function translateMinutesTime(mins) {
	    var hours = Math.floor(mins / 60);
	    var minutes = mins % 60;
	
	    if (hours === 24 && minutes === 0) {
	      hours = 23;
	      minutes = 59;
	    }
	
	    if (minutes < 10) {
	      minutes = '0' + minutes;
	    }
	
	    return moment(hours + ':' + minutes, 'H:mm').format(TIME_FORMAT);
	  }
	
	  function itemAddedToCart(parentIndex, row, item, ignoreFareMatching) {
	    angular.forEach(service.results.flail, function (flail, flailIndex) {
	      if (flailIndex != parentIndex && cartService.items.length === 0) {
	        // hide non-matching fares, unless specifically told not to
	        if (!ignoreFareMatching) {
	          addFilter('matchingFares', item.DisplayFare, 'flail', flailIndex);
	        }
	        removeFilter('priceRange', 'flail', flailIndex);
	        flail.filters.options.priceRange.settings.maxValue = flail.filters.options.priceRange.settings.defaultMax;
	        flail.filters.options.priceRange.settings.minValue = flail.filters.options.priceRange.settings.defaultMin;
	      }
	
	      if (!flail.itemInCart) {
	        addFilter('fareClass', item.Class, 'flail', flailIndex);
	      }
	    });
	
	    item.orderBy = parentIndex;
	    item.parent = service.results.flail[parentIndex];
	    item.row = row;
	    service.results.flail[parentIndex].itemInCart = true;
	    service.results.flail[parentIndex].currentRow = row;
	    service.results.flail[parentIndex].currentItem = item;
	    item.row.selected = true;
	    item.addedToCart = true;
	    item.type = 'rail';
	
	    cartService.items.push(item);
	  }
	
	  function BulkRemoveFareClassFilter() {
	    angular.forEach(service.results.flail, function (flail, flailIndex) {
	      removeFilter('fareClass', 'flail', flailIndex);
	      removeFilter('matchingFares', 'flail', flailIndex);
	    });
	  }
	
	  function checkFareFilters() {
	    if (cartService.items.length === 0) {
	      BulkRemoveFareClassFilter();
	    }
	  }
	
	  function orderClasses(classes) {
	    var classesOrdered = [];
	
	    settingsService.settings.FlightConfiguration.FareClasses.forEach(function (fareClass) {
	      var match = _.find(classes, function (className) {
	        return fareClass.Name === className;
	      });
	
	      if (match) {
	        classesOrdered.push(match);
	      }
	    });
	
	    return classesOrdered;
	  }
	
	  // All overlapping DateTime ranges will be removed.
	  function removeOverlappingDateTimeRanges(flailIndex) {
	    if (service.results.flail.length === 1 || service.results.flail[flailIndex] == null || service.results.flail[flailIndex].currentRow == null) return;
	
	    // These values are from the select cart item.
	    var itemDepartureDateTime = moment(service.results.flail[flailIndex].currentRow.DepartureDateTime);
	    var itemArrivalDateTime = moment(service.results.flail[flailIndex].currentRow.ArrivalDateTime);
	
	    // If flailIndex is 0, then that means that the user added Trip1 to the cart.
	    // If flailIndex is 1, then that means that the user added Trip2 to the cart.
	    // We set index to be the opposite because we want to filter out results for the OTHER trip.
	    var index = flailIndex === 0 ? 1 : 0;
	    var flail = service.resultsMaster.flail;
	
	    if (flailIndex === 0) {
	      // Gets all results where Trip2's DepartureDateTime is at least 30 minutes ahead of Trip1's ArrivalDateTime.
	      flail[index].searchResults = flail[index].searchResults.filter(function (x) {
	        return getMinutesFromDuration(moment(x.DepartureDateTime), itemArrivalDateTime) >= 30;
	      });
	    } else {
	      // Gets all results where Trip1's ArrivalDateTime is at least 30 minutes before of Trip2's DepartureDateTime.
	      flail[index].searchResults = flail[index].searchResults.filter(function (x) {
	        return getMinutesFromDuration(itemDepartureDateTime, moment(x.ArrivalDateTime)) >= 30;
	      });
	    }
	
	    // Refresh the results list.
	    if (!service.results.flail[index].itemInCart) service.addFilter('', '', 'flail', index);
	  }
	
	  // Returns the amount of minutes from DateTime1 - DateTime2. DateTime1 should be the most recent DateTime.
	  function getMinutesFromDuration(dateTime1, dateTime2) {
	    return moment.duration(dateTime1.diff(dateTime2)).asMinutes();
	  }
	  function setActiveTime(target) {
	    service.activeTime = target;
	  }
	
	  function getCarrierOptions(results) {
	    var uniqueResults = _.uniqBy(results, function (item) {
	      return item.Carrier;
	    });
	
	    if (results.filter(function (x) {
	      return x.HasAcelaOption;
	    }).length > 0) {
	      uniqueResults.push({
	        Carrier: 'AcelaFake',
	        CarrierName: 'Acela'
	      });
	    }
	
	    var orderedResults = _.orderBy(uniqueResults, function (item) {
	      return item.CarrierName.toLowerCase();
	    });
	
	    return _.map(orderedResults, function (item) {
	      return {
	        value: item.Carrier,
	        label: item.CarrierName,
	        id: 'Carrier-' + item.Carrier
	      };
	    });
	  }
	
	  return service;
	};
	
	flailService.$inject = $inject;
	
	exports['default'] = flailService;
	module.exports = exports['default'];

/***/ }),
/* 1335 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i]; return arr2; } else { return Array.from(arr); } }
	
	var $inject = ['$filter', 'moment', 'settingsService', 'travelService', 'cartService', 'ENUMS', 'dateTimeService'];
	
	var flightFilterService = function flightFilterService($filter, moment, settingsService, travelService, cartService, ENUMS, dateTimeService) {
	  var TIME_FORMAT = dateTimeService.getFormat(ENUMS.dateTimeFormats.TIME_LONG);
	  var showPanel = false;
	  var service = {
	    filters: new Filters(),
	    getFilters: function getFilters() {
	      return service.filters;
	    },
	    isPanelOpen: function isPanelOpen() {
	      return showPanel;
	    },
	    openPanel: openPanel,
	    closePanel: closePanel,
	    process: process,
	    updateOptions: updateOptions,
	    clear: clear,
	    filterCheapestFares: filterCheapestFares,
	    filtersApplied: 0
	  };
	
	  service.filters = new Filters();
	  updateOptions();
	
	  function Filters() {
	    var self = this;
	
	    this.cartItems = {
	      label: 'Cart',
	      filterName: 'travelCartItemsFilter',
	      cartItems: cartService.items,
	      resultsIndex: 0,
	      isActive: function isActive() {
	        return this.cartItems.length;
	      }
	    };
	
	    this.stops = {
	      label: 'Stops',
	      id: 'stops',
	      filterName: 'anyInArrayFilter',
	      isResultsFilter: true,
	      open: true,
	      type: 'checkboxGroup',
	      reference: 'Stops',
	      options: [],
	      selected: [],
	      pkgCustomCount: function pkgCustomCount(packages) {
	        var options = service.filters.stops.options;
	        var counts = travelService.packageResults[0].Segments.map(function (segment, i) {
	          var count = {
	            0: 0,
	            1: 0,
	            2: 0,
	            all: 0
	          };
	          var _iteratorNormalCompletion = true;
	          var _didIteratorError = false;
	          var _iteratorError = undefined;
	
	          try {
	            for (var _iterator = packages[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	              var pkg = _step.value;
	
	              var stops = pkg.Segments[i].flight.Stops;
	              count[stops]++;
	            }
	          } catch (err) {
	            _didIteratorError = true;
	            _iteratorError = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion && _iterator['return']) {
	                _iterator['return']();
	              }
	            } finally {
	              if (_didIteratorError) {
	                throw _iteratorError;
	              }
	            }
	          }
	
	          return count;
	        });
	
	        travelService.packageResults[0].Segments.forEach(function (segment, i) {
	          options[i].forEach(function (opt) {
	            opt.count = counts[i][opt.value];
	          });
	        });
	      },
	      pkgSegmentFilter: pkgSegmentsOptionsFilter,
	      clear: function clear() {
	        this.options.forEach(function (opt) {
	          return opt.forEach(function (o) {
	            return o.isActive = false;
	          });
	        });
	        this.selected = [];
	      }
	    };
	
	    this.carrier = {
	      label: 'Airlines',
	      id: 'carrier',
	      filterName: 'pkgCarrierFilter',
	      isResultsFilter: true,
	      open: true,
	      type: 'checkboxGroup',
	      maxOptions: 8,
	      maxOptionsCur: 8,
	      reference: 'Carrier',
	      options: [],
	      pkgCustomCount: function pkgCustomCount(packages) {
	        var options = service.filters.carrier.options.map(function (optionSet) {
	          return optionSet.filter(function (o) {
	            return o.value !== 'all';
	          });
	        });
	        travelService.packageResults[0].Segments.forEach(function (segment, i) {
	          options[i].forEach(function (opt) {
	            packages.forEach(function (pkg) {
	              if (pkg.Segments[i].flight.Carrier === opt.value) opt.count++;
	            });
	          });
	        });
	
	        // set all preferred count
	        service.filters.carrier.options.forEach(function (optionSet) {
	          var sumPreferredCounts = optionSet.reduce(function (sum, option) {
	            return option.preferred ? sum + option.count : sum;
	          }, 0);
	          var allOption = optionSet.find(function (option) {
	            return option.value === 'all';
	          });
	          if (allOption) allOption.count = sumPreferredCounts;
	        });
	      },
	      pkgSegmentFilter: pkgSegmentsOptionsFilter,
	      clear: function clear() {
	        this.options.forEach(function (opt) {
	          return opt.forEach(function (o) {
	            return o.isActive = false;
	          });
	        });
	        this.selected = [];
	      }
	    };
	
	    this.flightTime = {
	      label: 'Times',
	      filterName: 'travelTimeFilter',
	      isResultsFilter: true,
	      open: true,
	      type: 'departArrivalTime',
	      defaultMax: 1439,
	      defaultMin: 0,
	      options: [],
	      rzslider: {
	        ceil: 1439,
	        floor: 0,
	        step: 5,
	        noSwitching: true,
	        interval: 1000,
	        translate: translateMinutesTime,
	        onChange: function onChange() {
	          process(self.flightTime);
	        }
	      },
	      pkgSegmentFilter: function pkgSegmentFilter(packages, i) {
	        var option = this.options[i];
	        var ceil = this.rzslider.ceil;
	        var minArrive = option.minArrive;
	        var maxArrive = option.maxArrive;
	        var minDepart = option.minDepart;
	        var maxDepart = option.maxDepart;
	
	        var isActive = minArrive > 0 || maxArrive < ceil || minDepart > 0 || maxDepart < ceil;
	        if (!isActive) return;
	        if (isActive && this.isResultsFilter) bumpFiltersApplied(this, i);
	        packages.filter(function (pkg) {
	          return pkg.visible;
	        }).forEach(function (pkg) {
	          var segment = pkg.Segments[i];
	          if (!segment.visible) return;
	          var flight = segment.flight;
	          var departTime = dateTimeService.getMinutesFromTime(flight.DepartureTime);
	          var arriveTime = dateTimeService.getMinutesFromTime(flight.ArrivalTime);
	          segment.visible = departTime >= minDepart && departTime <= maxDepart && arriveTime >= minArrive && arriveTime <= maxArrive;
	        });
	      },
	      isActive: function isActive() {
	        return this.min > this.defaultMin || this.max < this.defaultMax;
	      },
	      clear: function clear() {
	        var ceil = this.rzslider.ceil;
	        this.options.forEach(function (o) {
	          o.minArrive = 0;
	          o.minDepart = 0;
	          o.maxDepart = ceil;
	          o.maxArrive = ceil;
	        });
	      }
	    };
	
	    this.priceRange = {
	      label: 'Price',
	      id: 'price',
	      labelSuffix: '(' + settingsService.settings.Currency.Code + ')',
	      filterName: 'travelPriceRangeFilter',
	      isResultsFilter: true,
	      open: true,
	      type: 'range',
	      reference: 'Price',
	      options: [],
	      rzslider: {
	        id: 'price',
	        floor: 0,
	        noSwitching: true,
	        interval: 1000,
	        translate: function translate(value) {
	          return $filter('currency')(value, '', 0);
	        },
	        onChange: function onChange() {
	          process(this);
	        }
	      },
	      pkgFareClassFilter: function pkgFareClassFilter(packages) {
	        var option = this.options[0];
	        var min = option.min;
	        var max = option.max;
	        var defaultMin = option.defaultMin;
	        var defaultMax = option.defaultMax;
	
	        var isActive = min > defaultMin || max < defaultMax;
	        if (!isActive) return;
	        if (isActive && this.isResultsFilter) bumpFiltersApplied(this);
	        packages.filter(function (pkg) {
	          return pkg.visible;
	        }).forEach(function (pkg) {
	          Object.values(pkg.FareClasses).filter(function (fc) {
	            return fc && fc.visible;
	          }).forEach(function (fc) {
	            var cheapestFare = null;
	            fc.Fares.filter(function (fare) {
	              return fare.visible;
	            }).forEach(function (fare) {
	              var fareInRange = fare.Amount >= min && fare.Amount <= max;
	              fare.visible = fareInRange;
	              if (fareInRange) {
	                if (!cheapestFare || fare.Amount < cheapestFare.Amount) cheapestFare = fare;
	              }
	            });
	            if (cheapestFare) fc.DisplayFare = cheapestFare;
	            fc.visible = !!cheapestFare;
	          });
	        });
	      },
	      isActive: function isActive() {
	        return this.min > this.defaultMin || this.max < this.defaultMax;
	      },
	      clear: function clear() {
	        this.options.forEach(function (o) {
	          o.min = o.defaultMin;
	          o.max = o.defaultMax;
	        });
	      }
	    };
	
	    this.airports = {
	      label: 'Connecting airports',
	      id: 'airport',
	      filterName: 'anyInArrayFilter',
	      isResultsFilter: true,
	      open: true,
	      type: 'checkboxGroup',
	      maxOptions: 8,
	      maxOptionsCur: 8,
	      options: [],
	      selected: [],
	      pkgCount: function pkgCount(segment, opt) {
	        segment.flight.Legs.forEach(function (leg) {
	          if (leg.Origin.Code === opt.value) opt.count++;
	        });
	      },
	      pkgSegmentFilter: pkgSegmentsOptionsFilter,
	      clear: function clear() {
	        this.options.forEach(function (opt) {
	          return opt.forEach(function (o) {
	            return o.isActive = false;
	          });
	        });
	        this.selected = [];
	      }
	    };
	
	    this.layover = {
	      label: 'Layover duration',
	      id: 'layover',
	      filterName: 'travelCarbonFootprintRangeFilter',
	      isResultsFilter: true,
	      open: false,
	      type: 'range',
	      reference: 'CarbonEmission',
	      options: [],
	      rzslider: {
	        step: 5,
	        noSwitching: true,
	        interval: 1000,
	        translate: function translate(mins, sliderId, label) {
	          if (isNaN(mins) || mins === Infinity || mins === -Infinity) return self.layover.options[0].defaultMin + ' min';
	          var days = Math.floor(mins / 1440);
	          var hours = Math.floor(mins % 1440 / 60);
	          var minutes = mins % 60;
	          var pre = label === 'model' ? 'Min' : label === 'high' ? 'Max' : '';
	          if (days === 0 && hours === 0) return pre + ' ' + minutes + ' min';
	          if (days === 0) return pre + ' ' + hours + ' hr ' + minutes + ' min';
	          return pre + ' ' + days + ' d ' + hours + ' hr ' + minutes + ' minutes';
	        },
	        onChange: function onChange() {
	          process(self.layover);
	        }
	      },
	      pkgSegmentFilter: function pkgSegmentFilter(packages, i) {
	        var option = this.options[i];
	        var min = option.min;
	        var max = option.max;
	        var defaultMin = option.defaultMin;
	        var defaultMax = option.defaultMax;
	
	        var isActive = min > defaultMin || max < defaultMax;
	        if (!isActive) return;
	        bumpFiltersApplied(this, i);
	        packages.filter(function (pkg) {
	          return pkg.visible;
	        }).forEach(function (pkg) {
	          var segment = pkg.Segments[i];
	          if (!segment.visible) return;
	          var layover = segment.flight.Details.filter(function (leg) {
	            return leg.Layover;
	          }).map(function (leg) {
	            return leg.Layover;
	          });
	          var layoverInMinutes = layover.map(function (time) {
	            return time.split(',').reduce(function (acc, val) {
	              return acc + parseInt(val);
	            }, 0);
	          });
	          segment.visible = layoverInMinutes.some(function (time) {
	            return time >= min && time <= max;
	          });
	        });
	      },
	      clear: function clear() {
	        this.options.forEach(function (o) {
	          o.min = o.defaultMin;
	          o.max = o.defaultMax;
	        });
	      }
	    };
	
	    this.policy = {
	      label: 'Policy',
	      id: 'policy',
	      filterName: 'anyInArrayFilter',
	      isResultsFilter: true,
	      open: false,
	      type: 'checkboxGroup',
	      reference: 'Stops',
	      options: [],
	      pkgCustomCount: function pkgCustomCount(packages) {
	        var counts = {
	          'in': 0,
	          out: 0
	        };
	        var _iteratorNormalCompletion2 = true;
	        var _didIteratorError2 = false;
	        var _iteratorError2 = undefined;
	
	        try {
	          for (var _iterator2 = packages[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	            var pkg = _step2.value;
	
	            var inPolicy = Object.values(pkg.FareClasses).some(function (fare) {
	              return fare && fare.Details.PolicyExceptionDetails.InPolicy;
	            });
	            counts[inPolicy ? 'in' : 'out']++;
	          }
	        } catch (err) {
	          _didIteratorError2 = true;
	          _iteratorError2 = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion2 && _iterator2['return']) {
	              _iterator2['return']();
	            }
	          } finally {
	            if (_didIteratorError2) {
	              throw _iteratorError2;
	            }
	          }
	        }
	
	        service.filters.policy.options.forEach(function (opt) {
	          return opt.forEach(function (o) {
	            return o.count = counts[o.value];
	          });
	        });
	      },
	      pkgFareClassFilter: pkgFareClassOptionsFilter,
	      clear: function clear() {
	        this.options.forEach(function (opt) {
	          return opt.forEach(function (o) {
	            return o.isActive = false;
	          });
	        });
	        this.selected = [];
	      }
	    };
	
	    this.cabin = {
	      label: 'Cabin class',
	      id: 'cabin',
	      filterName: 'pkgCarrierFilter',
	      isResultsFilter: true,
	      open: false,
	      type: 'checkboxGroup',
	      reference: 'Carrier',
	      selectedReference: 'value',
	      options: [],
	      pkgCustomCount: function pkgCustomCount(packages) {
	        this.options.forEach(function (opt) {
	          return opt.forEach(function (o) {
	            return o.count = packages.filter(function (pkg) {
	              return pkg.FareClasses[o.label];
	            }).length;
	          });
	        });
	      },
	      pkgFareClassFilter: pkgFareClassOptionsFilter,
	      clear: function clear() {
	        this.options.forEach(function (opt) {
	          return opt.forEach(function (o) {
	            return o.isActive = false;
	          });
	        });
	        this.selected = [];
	      }
	    };
	
	    this.carbonFootprintRange = {
	      label: 'Carbon footprint',
	      id: 'carbonFootprint',
	      filterName: 'travelCarbonFootprintRangeFilter',
	      isResultsFilter: true,
	      open: false,
	      type: 'range',
	      reference: 'CarbonEmission',
	      options: [],
	      rzslider: {
	        floor: 0,
	        noSwitching: true,
	        interval: 1000,
	        translate: function translate(value) {
	          return $filter('currency')(value, '', 0);
	        },
	        onChange: function onChange() {
	          process(this);
	        }
	      },
	      isActive: function isActive() {
	        return this.min > this.defaultMin || this.max < this.defaultMax;
	      },
	      pkgSegmentFilter: function pkgSegmentFilter(packages, i) {
	        var option = this.options[i];
	        var min = option.min;
	        var max = option.max;
	        var defaultMin = option.defaultMin;
	        var defaultMax = option.defaultMax;
	
	        var isActive = min > defaultMin || max < defaultMax;
	        if (!isActive) return;
	        if (isActive && this.isResultsFilter) bumpFiltersApplied(this, i);
	        packages.filter(function (pkg) {
	          return pkg.visible;
	        }).forEach(function (pkg) {
	          var segment = pkg.Segments[i];
	          if (!segment.visible) return;
	          var carbonValue = segment.flight.MinCarbonEmission;
	          segment.visible = !!(carbonValue >= min && carbonValue <= max);
	        });
	      },
	      clear: function clear() {
	        this.options.forEach(function (o) {
	          o.min = o.defaultMin;
	          o.max = o.defaultMax;
	        });
	      }
	    };
	
	    this.aircraft = {
	      label: 'Aircraft Type',
	      id: 'aircraft',
	      filterName: 'pkgCarrierFilter',
	      isResultsFilter: true,
	      open: false,
	      type: 'checkboxGroup',
	      filterbar: true,
	      maxOptions: 8,
	      maxOptionsCur: 8,
	      reference: 'Carrier',
	      selectedReference: 'value',
	      options: [],
	      pkgCount: function pkgCount(segment, opt) {
	        segment.flight.Details.forEach(function (leg) {
	          if (leg.EquipmentType === opt.value) opt.count++;
	        });
	      },
	      pkgSegmentFilter: pkgSegmentsOptionsFilter,
	      clear: function clear() {
	        this.options.forEach(function (opt) {
	          return opt.forEach(function (o) {
	            return o.isActive = false;
	          });
	        });
	      }
	    };
	
	    this.segment = {
	      id: 'segment',
	      pkgSegmentFilter: function pkgSegmentFilter(packages, i) {
	        var values = [].concat(_toConsumableArray(new Set(packages.flatMap(function (pkg) {
	          return pkg.Segments.filter(function (s) {
	            return s.selected;
	          }).map(function (s) {
	            return s.flight.Identifier;
	          });
	        }))));
	        if (!values.length) return;
	        bumpFiltersApplied(this, i);
	        packages.forEach(function (pkg) {
	          if (!pkg.visible || pkg.Segments.find(function (s) {
	            return s.selected;
	          })) return;
	          var segment = pkg.Segments[i];
	          segment.selected = segment.visible = values.includes(segment.flight.Identifier);
	        });
	      },
	      clear: function clear() {
	        travelService.packageResults.forEach(function (pkg) {
	          pkg.Segments.forEach(function (segment) {
	            return segment.selected = false;
	          });
	        });
	      }
	    };
	  }
	
	  function bumpFiltersApplied(filter, i) {
	    if (i && i > 0) return;
	    service.filtersApplied++;
	  }
	
	  function createCarrierOptions(segment, i) {
	    var options = service.filters.carrier.options;
	    if (!options[i]) options[i] = [];
	    var key = segment.flight.Carrier;
	    var id = 'carrier-' + key;
	    var option = options[i].find(function (opt) {
	      return opt.id === id;
	    });
	    if (option) return;
	    options[i].push({
	      label: segment.flight.CarrierName,
	      value: key,
	      count: 0,
	      id: id,
	      preferred: segment.flight.Preferred
	    });
	  }
	
	  function createAircraftOptions(segment, i) {
	    var options = service.filters.aircraft.options;
	    if (!options[i]) options[i] = [];
	
	    var _iteratorNormalCompletion3 = true;
	    var _didIteratorError3 = false;
	    var _iteratorError3 = undefined;
	
	    try {
	      var _loop = function () {
	        var leg = _step3.value;
	
	        if (!leg.EquipmentType) return 'continue';
	        var key = leg.EquipmentType;
	        var id = 'aircraft-' + key.replace(/[^a-zA-Z0-9]/g, '');
	        var option = options[i].find(function (opt) {
	          return opt.id === id;
	        });
	        if (option) return 'continue';
	        options[i].push({
	          label: leg.EquipmentType,
	          value: key,
	          count: 0,
	          id: id
	        });
	        options[i].sort(function (a, b) {
	          return a.label.localeCompare(b.label);
	        });
	      };
	
	      for (var _iterator3 = segment.flight.Details[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	        var _ret = _loop();
	
	        if (_ret === 'continue') continue;
	      }
	    } catch (err) {
	      _didIteratorError3 = true;
	      _iteratorError3 = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion3 && _iterator3['return']) {
	          _iterator3['return']();
	        }
	      } finally {
	        if (_didIteratorError3) {
	          throw _iteratorError3;
	        }
	      }
	    }
	  }
	
	  function createAirportsOptions(segment, i) {
	    var options = service.filters.airports.options;
	    if (!options[i]) options[i] = [];
	    segment.flight.Legs.forEach(function (leg) {
	      var key = leg.Origin.Code;
	      var id = 'airport-' + key;
	      var option = options[i].find(function (opt) {
	        return opt.id === id;
	      });
	      if (!option) {
	        options[i].push({
	          label: leg.Origin.City,
	          value: key,
	          count: 1,
	          id: id
	        });
	      }
	    });
	  }
	
	  function createLayoverOptions(activeFltr) {
	    if (activeFltr && activeFltr.id === 'layover') return;
	    var filter = service.filters.layover;
	    var options = filter.options;
	    if (options.length) return;
	    var layoverInMinutes = travelService.packageResults.filter(function (pkg) {
	      return pkg.visible;
	    }).flatMap(function (pkg) {
	      return pkg.Segments.flatMap(function (segment) {
	        return segment.flight.Details.filter(function (leg) {
	          return leg.Layover;
	        }).map(function (leg) {
	          return leg.Layover;
	        });
	      });
	    }).map(function (time) {
	      return time.split(',').reduce(function (acc, val) {
	        return acc + parseInt(val);
	      }, 0);
	    });
	
	    if (!layoverInMinutes.length) layoverInMinutes = [];
	    var min = Math.min.apply(Math, _toConsumableArray(layoverInMinutes));
	    var max = Math.max.apply(Math, _toConsumableArray(layoverInMinutes));
	    filter.rzslider.floor = min;
	    filter.rzslider.ceil = max;
	
	    travelService.packageResults[0].Segments.forEach(function (segment, i) {
	      if (options[i]) return;
	      options[i] = {
	        min: min,
	        max: max,
	        defaultMin: min,
	        defaultMax: max
	      };
	    });
	  }
	
	  function addAllPreferredCarriers() {
	    var options = service.filters.carrier.options;
	    options.forEach(function (option, i) {
	      if (option.some(function (carrier) {
	        return carrier.value === 'all';
	      })) return;
	      option.sort(function (a, b) {
	        return a.label.localeCompare(b.label);
	      });
	      if (option.some(function (carrier) {
	        return carrier.preferred;
	      })) {
	        var preferredCount = option.reduce(function (sum, carrier) {
	          return sum + (carrier.preferred ? carrier.count : 0);
	        }, 0);
	        option.unshift({
	          label: 'All Preferred Airlines',
	          value: 'all',
	          id: 'carrier-all-preferred-' + i,
	          preferred: true,
	          count: preferredCount
	        });
	      }
	    });
	  }
	
	  function createStopOptions() {
	    var options = service.filters.stops.options;
	    travelService.packageResults[0].Segments.forEach(function (segment, i) {
	      if (options[i]) return;
	      options[i] = [{
	        label: 'Nonstop Only',
	        value: 0,
	        id: 'stops-' + i + '-0'
	      }, {
	        label: '2 stops',
	        value: 2,
	        id: 'stops-' + i + '-2'
	      }, {
	        label: '1 stop',
	        value: 1,
	        id: 'stops-' + i + '-1'
	      }, {
	        label: '3 or more stops',
	        value: 'all',
	        id: 'stops-' + i + '-all'
	      }];
	    });
	  }
	
	  function createPolicyOptions() {
	    var options = service.filters.policy.options;
	    var inPolicyFalse = travelService.packageResults.filter(function (pkg) {
	      return Object.values(pkg.FareClasses).some(function (fare) {
	        return fare && !fare.Details.PolicyExceptionDetails.InPolicy;
	      });
	    }).length;
	    var inPolicyTrue = travelService.packageResults.length - inPolicyFalse;
	    travelService.packageResults[0].Segments.forEach(function (segment, i) {
	      if (options[i]) return;
	      options[i] = [{
	        label: 'Out of policy',
	        value: 'out',
	        id: 'policy-' + i + '-out',
	        count: inPolicyFalse
	      }, {
	        label: 'In policy',
	        value: 'in',
	        id: 'policy-' + i + '-in',
	        count: inPolicyTrue
	      }];
	    });
	  }
	
	  function createPriceOptions() {
	    var filter = service.filters.priceRange;
	    var options = filter.options;
	    var min = Number.MAX_VALUE;
	    var max = 0;
	
	    travelService.packageResults.forEach(function (pkg) {
	      Object.values(pkg.FareClasses).forEach(function (fare) {
	        if (!fare) return;
	        var fareAmount = Math.round(fare.Details.Amount);
	        if (fareAmount < min) min = fareAmount;
	        if (fareAmount > max) max = fareAmount;
	      });
	    });
	
	    filter.rzslider.floor = min;
	    filter.rzslider.ceil = max;
	
	    travelService.packageResults[0].Segments.forEach(function (segment, i) {
	      if (options[i]) return;
	      options[i] = {
	        min: min,
	        max: max,
	        defaultMin: min,
	        defaultMax: max
	      };
	    });
	  }
	
	  function createCabinOptions(segment, i) {
	    var options = service.filters.cabin.options;
	    travelService.packageResults[0].Segments.forEach(function (segment, i) {
	      if (!options[i]) options[i] = [];
	      travelService.pkgFareClasses.forEach(function (fareClass) {
	        var key = fareClass.replace(/\s/g, '');
	        var id = 'cabin-' + key;
	        var option = options[i].find(function (opt) {
	          return opt.id === id;
	        });
	        if (!option) {
	          options[i].push({
	            label: fareClass,
	            value: key,
	            count: 0,
	            id: id
	          });
	        }
	      });
	      options[i].sort(function (a, b) {
	        return a.label.localeCompare(b.label);
	      });
	    });
	  }
	
	  function createCarbonOptions() {
	    var filter = service.filters.carbonFootprintRange;
	    var options = filter.options;
	    var carbonEmissions = travelService.packageResults.flatMap(function (pkg) {
	      return pkg.Segments.map(function (s) {
	        return s.flight.MinCarbonEmission;
	      });
	    });
	    var max = Math.max.apply(Math, _toConsumableArray(carbonEmissions));
	    var min = Math.min.apply(Math, _toConsumableArray(carbonEmissions));
	
	    filter.rzslider.floor = min;
	    filter.rzslider.ceil = max;
	
	    travelService.packageResults[0].Segments.forEach(function (segment, i) {
	      if (options[i]) return;
	      options[i] = {
	        min: min,
	        max: max,
	        defaultMin: min,
	        defaultMax: max
	      };
	    });
	  }
	
	  function createTimeOptions() {
	    var options = service.filters.flightTime.options;
	    travelService.packageResults[0].Segments.forEach(function (segment, i) {
	      if (options[i]) return;
	      options[i] = {
	        minDepart: 0,
	        maxDepart: 1439,
	        minArrive: 0,
	        maxArrive: 1439
	      };
	    });
	  }
	
	  function resetPackageVisibility() {
	    travelService.packageResults.forEach(function (pkg) {
	      pkg.visible = true;
	      Object.values(pkg.FareClasses).filter(function (fare) {
	        return fare;
	      }).forEach(function (fc) {
	        fc.visible = true;
	        fc.Fares.forEach(function (fare) {
	          return fare.visible = true;
	        });
	      });
	      pkg.Segments.forEach(function (segment) {
	        return segment.visible = true;
	      });
	    });
	  }
	
	  function process(activeFltr) {
	    resetPackageVisibility();
	    var packages = travelService.packageResultsMaster;
	    var filters = Object.values(service.filters);
	    var segmentFilters = filters.filter(function (flt) {
	      return flt.pkgSegmentFilter;
	    });
	    var fareClassesFilters = filters.filter(function (flt) {
	      return flt.pkgFareClassFilter;
	    });
	    service.filtersApplied = 0;
	
	    //segement filters (i.e. stops, carrier, airport, aircraft)
	    packages[0].Segments.forEach(function (segment, i) {
	      segmentFilters.forEach(function (flt) {
	        return flt.pkgSegmentFilter(packages, i);
	      });
	    });
	    packages.forEach(function (pkg) {
	      return pkg.visible = pkg.Segments.every(function (segment) {
	        return segment.visible;
	      });
	    });
	
	    // fareclass filters (i.e. cabin, policy, price)
	    packages = packages.filter(function (pkg) {
	      return pkg.visible;
	    });
	    fareClassesFilters.forEach(function (flt) {
	      return flt.pkgFareClassFilter(packages);
	    });
	    packages.forEach(function (pkg) {
	      var fareClasses = Object.values(pkg.FareClasses).filter(function (fc) {
	        return fc;
	      });
	      pkg.visible = fareClasses.some(function (fc) {
	        return fc.visible;
	      });
	    });
	
	    updateOptions(activeFltr);
	  }
	
	  function updateOptions(activeFltr) {
	    var packages = travelService.packageResults;
	    var filters = Object.values(service.filters);
	    var activeFilterIndex = filters.findIndex(function (filter) {
	      return filter === activeFltr;
	    });
	
	    createStopOptions();
	    createTimeOptions();
	    createPriceOptions();
	    createCarbonOptions();
	    createCabinOptions();
	    createPolicyOptions();
	    createLayoverOptions(activeFltr);
	
	    for (var i = 0; i < packages.length; i++) {
	      var pkg = packages[i];
	      var segments = pkg.Segments;
	
	      for (var j = 0; j < segments.length; j++) {
	        var segment = segments[j];
	        createCarrierOptions(segment, j);
	        createAirportsOptions(segment, j);
	        createAircraftOptions(segment, j);
	      }
	    }
	
	    addAllPreferredCarriers();
	
	    countFilteredOptions(activeFltr);
	
	    if (activeFilterIndex !== -1) {
	      filters.splice(activeFilterIndex, 1);
	    }
	  }
	
	  function countFilteredOptions(activeFltr) {
	    var packages = travelService.packageResults.filter(function (pkg) {
	      return pkg.visible;
	    });
	
	    var filters = Object.values(service.filters);
	    if (activeFltr) filters = filters.filter(function (f) {
	      return f !== activeFltr;
	    }); //don't filter the passed in filter (the one that was toggled)
	
	    clearFilteredCounts(filters);
	    var countFunctions = filters.filter(function (f) {
	      return f.pkgCount;
	    });
	    packages.forEach(function (pkg) {
	      pkg.Segments.forEach(function (segment, i) {
	        countFunctions.forEach(function (f) {
	          return f.options[i].forEach(function (o) {
	            return f.pkgCount(segment, o);
	          });
	        });
	      });
	    });
	
	    //find filters that have a pkgCustomCount function and call it
	    filters.filter(function (f) {
	      return f.pkgCustomCount;
	    }).forEach(function (f) {
	      return f.pkgCustomCount(packages);
	    });
	  }
	
	  function clearFilteredCounts(filters) {
	    filters.forEach(function (flt) {
	      if (flt.options) flt.options.forEach(function (opt) {
	        return Array.isArray(opt) ? opt.forEach(function (o) {
	          return o.count = 0;
	        }) : opt.count = 0;
	      });
	    });
	  }
	
	  function pkgSegmentsOptionsFilter(packages, i) {
	    var _this = this;
	
	    this.selected = this.selected || [];
	    var values = this.selected[i] || [];
	    if (!values.length) return;
	
	    bumpFiltersApplied(this);
	    packages.forEach(function (pkg) {
	      if (!pkg.visible) return;
	      var segment = pkg.Segments[i];
	      var flight = segment.flight;
	      if (!segment.visible) return;
	      switch (_this.id) {
	        case 'airport':
	          segment.visible = flight.Legs.some(function (leg) {
	            return values.includes(leg.Origin.Code);
	          });
	          break;
	        case 'aircraft':
	          segment.visible = flight.Details.some(function (leg) {
	            return values.includes(leg.EquipmentType);
	          });
	          break;
	        default:
	          segment.visible = values.includes(flight[_this.reference]);
	      }
	    });
	  }
	  pkgSegmentsOptionsFilter = memoize(pkgSegmentsOptionsFilter);
	
	  function pkgFareClassOptionsFilter(packages) {
	    var _this2 = this;
	
	    this.selected = this.selected || [];
	    var values = this.selected[0] || [];
	    if (!values.length) return;
	
	    bumpFiltersApplied(this);
	    packages.forEach(function (pkg) {
	      if (!pkg.visible) return;
	      var fareClasses = Object.entries(pkg.FareClasses).filter(function (_ref) {
	        var _ref2 = _slicedToArray(_ref, 2);
	
	        var key = _ref2[0];
	        var fc = _ref2[1];
	        return fc && fc.visible;
	      });
	
	      fareClasses.forEach(function (_ref3) {
	        var _ref32 = _slicedToArray(_ref3, 2);
	
	        var key = _ref32[0];
	        var fc = _ref32[1];
	
	        switch (_this2.id) {
	          case 'cabin':
	            fc.visible = values.includes(key.replace(/\s/g, ''));
	            break;
	          case 'policy':
	            values.forEach(function (val) {
	              var policy = fc.Details.PolicyExceptionDetails.InPolicy;
	              fc.visible = val === 'in' ? policy : !policy;
	            });
	            break;
	        }
	      });
	    });
	  }
	  pkgFareClassOptionsFilter = memoize(pkgFareClassOptionsFilter);
	
	  function memoize(func) {
	    var cache = new Map();
	    return function () {
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      var key = JSON.stringify(args);
	      if (cache.has(key)) return cache.get(key);
	      var result = func.apply(this, args);
	      cache.set(key, result);
	      return result;
	    };
	  }
	
	  function clear() {
	    Object.values(service.filters).forEach(function (flt) {
	      if (typeof flt.clear === 'function') flt.clear();
	    });
	    process();
	  }
	
	  function openPanel() {
	    showPanel = true;
	    document.body.style.overflow = 'hidden';
	  }
	
	  function closePanel() {
	    showPanel = false;
	    document.body.style.overflow = 'auto';
	  }
	
	  function translateMinutesTime(mins) {
	    if (mins === 0) return '12:00 AM';
	    var hours = Math.floor(mins / 60);
	    var minutes = mins % 60;
	    if (hours === 24 && minutes === 0) {
	      hours = 23;
	      minutes = 59;
	    }
	    if (minutes < 10) minutes = '0' + minutes;
	    return moment(hours + ':' + minutes, 'H:mm').format(TIME_FORMAT);
	  }
	
	  function filterCheapestFares() {
	    clear();
	    var packages = travelService.packageResults;
	    var distinctCarriers = new Set();
	    packages.forEach(function (pkg) {
	      return pkg.Segments.forEach(function (segment) {
	        return distinctCarriers.add(segment.flight.Carrier);
	      });
	    });
	    var carriers = [].concat(_toConsumableArray(distinctCarriers));
	
	    var cheapestFares = {};
	    packages.forEach(function (pkg) {
	      pkg.visible = false;
	
	      pkg.Segments.forEach(function (segment) {
	        var Carrier = segment.flight.Carrier;
	
	        if (carriers.includes(Carrier)) {
	          Object.entries(pkg.FareClasses).filter(function (_ref4) {
	            var _ref42 = _slicedToArray(_ref4, 2);
	
	            var fareClassName = _ref42[0];
	            var fareClass = _ref42[1];
	            return fareClass;
	          }).forEach(function (_ref5) {
	            var _ref52 = _slicedToArray(_ref5, 2);
	
	            var fareClassName = _ref52[0];
	            var fareClass = _ref52[1];
	            var Amount = fareClass.Details.Amount;
	
	            if (!cheapestFares[Carrier] || Amount < cheapestFares[Carrier].Amount) {
	              cheapestFares[Carrier] = { fareClassName: fareClassName, Amount: Amount };
	              pkg.visible = true;
	            }
	          });
	        }
	      });
	    });
	  }
	
	  return service;
	};
	
	flightFilterService.$inject = $inject;
	
	exports['default'] = flightFilterService;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(205)))

/***/ }),
/* 1336 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['moment'];
	
	var guestTravellerService = function guestTravellerService(moment) {
	  var service = {};
	  service.activeGuest = new Guest();
	
	  service.addLoyaltyProgram = function (programs) {
	    return programs.concat([new LoyaltyProgram()]);
	  };
	
	  service.addSecureFlightVisa = function (visas) {
	    if (visas.constructor === Array && visas.length < 8) return visas.concat(new PassportOrVisa());else return visas;
	  };
	
	  service.removeLoyaltyProgram = function (programs) {
	    return programs.slice(0, -1);
	  };
	
	  service.removeSecureFlightVisa = function (visas) {
	    if (visas.constructor === Array) return visas.slice(0, -1);else return visas;
	  };
	
	  service.clear = function () {
	    service.activeGuest = new Guest();
	  };
	
	  service.setActiveGuest = function (traveller) {
	    var loyaltyPrograms = _.map(traveller.PersonalMemberships, function (program) {
	      return {
	        number: program.MembershipNumber,
	        supplier: {
	          Value: program.CompanyCode,
	          Title: program.CompanyName,
	          Type: program.MembershipTypeCode
	        }
	      };
	    });
	
	    var customerVisas = _.map(traveller.SecureFlight.Visas, function (sfi) {
	      return {
	        number: sfi.Number,
	        country: sfi.Country,
	        expiration: sfi.IssueDate ? new Date(moment(sfi.IssueDate, 'YYYY-MM-DD[T]HH:mm:ss').format('YYYY-MM-DD')) : null
	      };
	    });
	
	    var customerPassport = new PassportOrVisa();
	    if (traveller.SecureFlight.Passport) {
	      customerPassport.number = traveller.SecureFlight.Passport.number, customerPassport.country = traveller.SecureFlight.Passport.country, customerPassport.expiration = traveller.SecureFlight.Passport.expiration ? new Date(moment(traveller.SecureFlight.Passport.expiration, 'YYYY-MM-DD[T]HH:mm:ss').format('YYYY-MM-DD')) : null;
	    }
	
	    if (loyaltyPrograms.length === 0) {
	      loyaltyPrograms = loyaltyPrograms.concat([new LoyaltyProgram()]);
	    }
	
	    if (customerVisas.length === 0) {
	      customerVisas = customerVisas.concat([new PassportOrVisa()]);
	    }
	
	    service.activeGuest = _.extend(new Guest(), {
	      firstName: traveller.Firstname,
	      middleName: traveller.Middlename,
	      lastName: traveller.Lastname,
	      suffix: traveller.Suffix,
	      email: traveller.Email,
	      phone: traveller.Mobile,
	      dob: traveller.DateOfBirth ? new Date(moment(traveller.DateOfBirth, 'YYYY-MM-DD[T]HH:mm:ss').format('YYYY-MM-DD')) : null,
	      isLapChild: traveller.IsLapChild,
	      gender: traveller.Gender,
	      guestID: traveller.guestID,
	      costCentre: {
	        Code: traveller.CostCentreCode,
	        Title: traveller.CostCentreName
	      },
	      department: {
	        Code: traveller.DepartmentCode,
	        Title: traveller.DepartmentName
	      },
	      loyaltyPrograms: loyaltyPrograms,
	      secureFlightInfo: {
	        knownTraveller: traveller.SecureFlight.KnownTraveller.toUpperCase(),
	        knownTravellerCountry: traveller.SecureFlight.KnownTravellerCountry,
	        redressNumber: traveller.SecureFlight.RedressNumber,
	        redressCountry: traveller.SecureFlight.RedressCountry,
	        passport: customerPassport,
	        visas: customerVisas
	      }
	    });
	  };
	
	  function Guest() {
	    return {
	      title: null,
	      firstName: null,
	      middleName: null,
	      lastName: null,
	      suffix: null,
	      email: null,
	      phone: null,
	      dob: null, // don't use epoch
	      gender: null,
	      loyaltyPrograms: [new LoyaltyProgram()],
	      secureFlightInfo: new SecureFlight(),
	      costCentre: null,
	      department: null
	    };
	  }
	
	  function LoyaltyProgram() {
	    return {
	      supplier: null,
	      number: null
	    };
	  }
	
	  function PassportOrVisa() {
	    return {
	      number: null,
	      country: null,
	      expiration: null };
	  }
	
	  // don't use epoch
	  function SecureFlight() {
	    return {
	      knownTraveller: null,
	      knownTravellerCountry: null,
	      redressNumber: null,
	      redressCountry: null,
	      passport: new PassportOrVisa(),
	      visas: [new PassportOrVisa()]
	    };
	  }
	  service.GetAge = function (dob) {
	    if (!dob) return;
	    var today = new Date();
	    var birthDate = new Date(dob);
	    var age = today.getFullYear() - birthDate.getFullYear();
	    var monthDiff = today.getMonth() - birthDate.getMonth();
	    if (monthDiff < 0 || monthDiff === 0 && today.getDate() < birthDate.getDate()) age--;
	    return age;
	  };
	  return service;
	};
	
	guestTravellerService.$inject = $inject;
	
	exports['default'] = guestTravellerService;
	module.exports = exports['default'];

/***/ }),
/* 1337 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _angular = __webpack_require__(8);
	
	var $inject = ['$q', '$http', 'APP_CONFIG'];
	
	var iataSearchService = function iataSearchService($q, $http, APP_CONFIG) {
	  var service = {};
	
	  service.get = get;
	  service.getGrouped = getGrouped;
	  service.getMetroGrouped = getMetroGrouped;
	  service.getIataFromLocation = getIataFromLocation;
	  service.getIata = getIata;
	
	  function get(params, grouped) {
	    var deferred = $q.defer();
	    var url = APP_CONFIG.api.iata;
	
	    if (grouped) {
	      url = APP_CONFIG.api.iataGrouped;
	    }
	
	    $http.get(url, { params: params }).then(function (response) {
	      if (!grouped) {
	        (function () {
	          var responseData = [];
	          var groupKeys = [];
	
	          _.forEach(response.data, function (location) {
	            var groupedBy = groupedByKey(location);
	            var displayLabel = location.Name + ' - ' + location.City + ', ' + location.Country;
	            var hasCode = !!location.Value;
	
	            if (groupedBy && _.indexOf(groupKeys, groupedBy) === -1) {
	              var selectedGroupLabel = groupedBySelectedLabel(location);
	              var groupByLabel = groupedByLabel(location);
	              var groupItem = _.extend({}, location, {
	                isGroupHeader: true,
	                groupedBy: groupedBy,
	                displayLabel: groupByLabel,
	                hasCode: !!location.GroupCode,
	                Label: selectedGroupLabel,
	                Value: location.GroupCode || location.Group
	              });
	
	              responseData.push(groupItem);
	
	              groupKeys.push(groupedBy);
	            }
	
	            location = _.extend(location, { displayLabel: displayLabel, groupedBy: groupedBy, hasCode: hasCode });
	
	            responseData.push(location);
	          });
	
	          deferred.resolve(responseData);
	        })();
	      } else {
	        deferred.resolve(response.data);
	      }
	    })['catch'](function (err) {
	      deferred.reject('there was an error');
	    });
	
	    return deferred.promise;
	  }
	
	  function getIata(code) {
	    var deferred = $q.defer();
	    var url = APP_CONFIG.api.iata;
	
	    $http.get(url, {
	      params: {
	        code: code
	      }
	    }).then(function (response) {
	      deferred.resolve(response.data);
	      if (response.data) {}
	    })['catch'](function (err) {
	      deferred.reject('there was an error');
	    });
	
	    return deferred.promise;
	  }
	
	  function getGrouped(params) {
	    var deferred = $q.defer();
	    var url = APP_CONFIG.api.iata;
	
	    $http.get(url, { params: params }).then(function (response) {
	      var responseData = [];
	
	      _.forEach(response.data, function (location) {
	        var groupedBy = groupedByKey(location);
	        var displayLabel = location.Name + ' - ' + location.City + (location.StateCode ? ', ' + location.StateCode : '') + ', ' + location.Country;
	        var hasCode = !!location.Value;
	
	        location = _.extend(location, { displayLabel: displayLabel, groupedBy: groupedBy, hasCode: hasCode });
	
	        responseData.push(location);
	      });
	
	      deferred.resolve(responseData);
	    })['catch'](function (err) {
	      deferred.reject('there was an error');
	    });
	
	    return deferred.promise;
	  }
	
	  function getMetroGrouped(params, isPublic) {
	    var deferred = $q.defer();
	    var url = isPublic ? APP_CONFIG.api.iataSct : APP_CONFIG.api.iata;
	
	    $http.get(url, { params: params, isPublic: isPublic }).then(function (response) {
	      var responseData = [];
	      var groupKeys = [];
	
	      _.forEach(response.data, function (location) {
	        var groupedBy = groupedByMetroKey(location);
	        var displayLabel = location.Name + ' - ' + location.City + (location.StateCode ? ', ' + location.StateCode : '') + ', ' + location.Country;
	        var hasCode = !!location.Value;
	
	        if (groupedBy && _.indexOf(groupKeys, groupedBy) === -1) {
	          var selectedGroupLabel = groupedBySelectedLabel(location);
	          var groupByLabel = groupedByLabel(location);
	          var groupItem = _.extend({}, location, {
	            isGroupHeader: true,
	            groupedBy: groupedBy,
	            displayLabel: groupByLabel,
	            hasCode: !!location.GroupCode,
	            Label: selectedGroupLabel,
	            Value: location.GroupCode || location.Group
	          });
	
	          responseData.push(groupItem);
	
	          groupKeys.push(groupedBy);
	        }
	
	        location = _.extend(location, { displayLabel: displayLabel, groupedBy: groupedBy, hasCode: hasCode });
	
	        responseData.push(location);
	      });
	
	      deferred.resolve(responseData);
	    })['catch'](function (err) {
	      deferred.reject('there was an error');
	    });
	
	    return deferred.promise;
	  }
	
	  function groupedByKey(location) {
	    return location.Group ? location.Group + ' (All Airports)' : undefined;
	  }
	
	  function groupedByMetroKey(location) {
	    return location.GroupCode || location.Group || undefined;
	  }
	
	  function groupedByLabel(location) {
	    var label = undefined;
	
	    if (location.Group) {
	      label = location.Group + ' (All Airports) - ' + location.City + (location.StateCode ? ', ' + location.StateCode : '') + ', ' + location.Country;
	    }
	
	    return label;
	  }
	
	  function groupedBySelectedLabel(location) {
	    var label = location.Group;
	
	    if (location.GroupCode) {
	      label += ' (' + location.GroupCode + ')';
	    }
	
	    return label;
	  }
	
	  function getIataFromLocation(location) {
	    return {
	      Value: location.Code,
	      City: location.City,
	      Country: location.Country,
	      CountryCode: location.CountryCode,
	      Name: location.Location,
	      displayLabel: location.Location + ' - ' + location.City + ', ' + location.Country
	    };
	  }
	
	  return service;
	};
	
	iataSearchService.$inject = $inject;
	
	exports['default'] = iataSearchService;
	module.exports = exports['default'];

/***/ }),
/* 1338 */,
/* 1339 */,
/* 1340 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _angularAnimate = __webpack_require__(1077);
	
	var $inject = ['$q', '$http', 'apiService'];
	
	var locationsSearchService = function locationsSearchService($q, $http, apiService) {
	  var service = {};
	  service.get = get;
	  service.getPoiFromSearchLocation = getPoiFromSearchLocation;
	  service.getAirportPoi = getAirportPoi;
	  service.getCarPoiFromSearchLocation = getCarPoiFromSearchLocation;
	  service.getCompanyLocations = getCompanyLocations;
	
	  function get(params) {
	    var endpoint = arguments.length <= 1 || arguments[1] === undefined ? 'poi' : arguments[1];
	
	    var apiUrl = apiService.getUrl('locations');
	    if (endpoint === 'companyLocations') {
	      return getCompanyLocations();
	    } else {
	      return $http.get(apiUrl, { params: params }).then(function (response) {
	        return response.data;
	      });
	    }
	  }
	
	  function getPoiFromSearchLocation(searchLocation) {
	    return _.extend({}, searchLocation, {
	      Title: searchLocation.Name ? searchLocation.Name : searchLocation.Location ? searchLocation.Location : '',
	      City: {
	        Code: searchLocation.Code
	      }
	    });
	  }
	  function getCarPoiFromSearchLocation(searchLocation) {
	    return _.extend({}, searchLocation, {
	      Title: searchLocation.Name ? searchLocation.Name : searchLocation.Location ? searchLocation.Location : '',
	      Iata: searchLocation.Code,
	      City: {
	        Code: searchLocation.CityCode || searchLocation.Code,
	        Name: searchLocation.City
	      },
	      Country: {
	        Name: searchLocation.Country,
	        Code: searchLocation.CountryCode
	      },
	      Address: searchLocation.Location,
	      Type: searchLocation.Code.length === 3 ? 'Airport' : 'Location'
	    });
	  }
	  function getAirportPoi(airportCode) {
	    return get({ term: airportCode, maxRows: 10, searchTypes: 'Airport' }).then(function (searchResults) {
	      var retAirport = _.find(searchResults, function (option) {
	        return option.Iata === airportCode;
	      });
	      return retAirport;
	    });
	  }
	
	  // Because the endpoint does not use the same prefix as the other endpoints, I replace the /poi with an empty string
	  function getCompanyLocations() {
	    var apiUrl = apiService.getUrl('locations').replace('/poi', '') + '/companyLocations';
	    return $http.get(apiUrl, {}).then(function (response) {
	      return response.data;
	    });
	  }
	
	  return service;
	};
	
	locationsSearchService.$inject = $inject;
	
	exports['default'] = locationsSearchService;
	module.exports = exports['default'];

/***/ }),
/* 1341 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['$filter', 'moment', 'settingsService', 'ENUMS', 'dateTimeService'];
	
	var lostSavingsService = function lostSavingsService($filter, moment, settingsService, ENUMS, dateTimeService) {
	  var service = {
	    getMessage: getMessage
	  };
	
	  function getMessage(policyExceptionDetails) {
	    var p = policyExceptionDetails;
	    var currencyCode = settingsService.currencyCode();
	    var timeFormat = dateTimeService.getFormat(ENUMS.dateTimeFormats.TIME_LONG);
	    var priceCheapestOption = $filter('currency')(p.PriceOfCheapestOption, '', 0);
	    var minimumTimeOfCheapestOption = moment(p.MinimumTimeOfCheapestOption, 'HH:mm').format(timeFormat);
	    var maximumTimeOfCheapestOption = moment(p.MaximumTimeOfCheapestOption, 'HH:mm').format(timeFormat);
	
	    var message = '';
	
	    if (p.MultipleCheapestOptions) {
	      var flightText = p.IsCombinableFare ? 'combinable flights' : 'flights';
	
	      if (p.MinimumTimeOfCheapestOption === p.MaximumTimeOfCheapestOption) {
	        message = 'There were multiple cheaper ' + flightText + ' departing at ' + minimumTimeOfCheapestOption + ' for ' + priceCheapestOption + currencyCode;
	      } else {
	        message = 'There were multiple cheaper ' + flightText + ' departing between ' + minimumTimeOfCheapestOption + ' and ' + maximumTimeOfCheapestOption + ', at ' + priceCheapestOption + ' ' + currencyCode;
	      }
	    } else {
	      if (p.IsCombinableFare) {
	        message = 'Flight ' + p.NameOfCheapestOption + ' departs at ' + maximumTimeOfCheapestOption + ' and has a cheaper combinable option at ' + priceCheapestOption + currencyCode;
	      } else {
	        message = 'Flight ' + p.NameOfCheapestOption + ' departs at ' + maximumTimeOfCheapestOption + ' and is cheaper at ' + priceCheapestOption + currencyCode;
	      }
	    }
	
	    return message;
	  }
	
	  return service;
	};
	
	lostSavingsService.$inject = $inject;
	
	exports['default'] = lostSavingsService;
	module.exports = exports['default'];

/***/ }),
/* 1342 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	paymentMethodsService.$inject = ['$http', '$q', 'APP_CONFIG'];
	function paymentMethodsService($http, $q, APP_CONFIG) {
	  var service = {
	    fetch: function fetch(itineraryId) {
	      return $q(function (resolve, reject) {
	        service.paymentMethodsLoading = true;
	        $http.get(APP_CONFIG.api.root + ('api/Itinerary/' + itineraryId + '/PaymentMethod'), {}).success(function (data) {
	          service.paymentMethods = data;
	          service.paymentMethodsLoading = false;
	          resolve(data);
	        }).error(function () {
	          service.paymentMethodsLoading = false;
	          reject();
	        });
	      });
	    },
	    fetchExpiringHotelPaymentMethods: function fetchExpiringHotelPaymentMethods(itineraryId) {
	      return $q(function (resolve, reject) {
	        $http.get(APP_CONFIG.api.root + ('api/Itinerary/' + itineraryId + '/ExpiringHotelPaymentMethods'), {}).success(function (data) {
	          data.forEach(function (paymentMethod) {
	            paymentMethod.Payment.Last4Digits = paymentMethod.Payment.Number.substring(paymentMethod.Payment.Number.length - 4);
	          });
	
	          service.paymentMethods = data;
	          resolve(data);
	        }).error(function () {
	          reject();
	        });
	      });
	    },
	    addPaymentMethod: function addPaymentMethod(newPaymentMethod, groupIds) {
	      var newPaymentObj = {
	        Payment: {
	          ExpiryMonth: newPaymentMethod.cardExpiryMonth,
	          ExpiryYear: newPaymentMethod.cardExpiryYear,
	          Holder: newPaymentMethod.cardHolder,
	          Number: newPaymentMethod.cardNumber,
	          PaymentType: 'Card',
	          Reference: null,
	          SecurityCode: null,
	          SecurityCodeRequired: true,
	          Type: {
	            Code: newPaymentMethod.Card.Type.Code,
	            Value: newPaymentMethod.Card.Type.Code
	          }
	        },
	        SectorGroups: groupIds,
	        MandatorySectorGroups: []
	      };
	
	      service.paymentMethods.push(newPaymentObj);
	      return newPaymentObj;
	    },
	    populateEachPaxWithSelectedPaymentMethods: function populateEachPaxWithSelectedPaymentMethods(paymentMethods, travellers) {
	      var paymentMissing = 0;
	
	      _.forEach(travellers, function (pax, paxIndex) {
	        var paymentsCopy = angular.copy(pax.Configurations.PaymentMethod.PaymentItems);
	        pax.Configurations.PaymentMethod.PaymentItems = [];
	
	        _.forEach(pax.Flights, function (flight) {
	          if (_checkSectorStatusNoPayment(flight)) {
	            return;
	          }
	          if (paymentMethods.allPax && paymentMethods.allPax.flights) {
	            pax.Configurations.PaymentMethod.PaymentItems.push(buildPaymentObj(paymentMethods.allPax.flights.Payment, flight.GroupIdentifier, 'Flight'));
	          } else if (paymentMethods[paxIndex + 2] && paymentMethods[paxIndex + 2].flights[flight.GroupIdentifier]) {
	            if (!paymentMethods[paxIndex + 2].flights[flight.GroupIdentifier].Payment) {
	              var foundPayment = findPaymentWithTypeAndGrpId(paymentsCopy, 'Flight', flight.GroupIdentifier);
	
	              if (foundPayment.Card) {
	                paymentMethods[paxIndex + 2].flights[flight.GroupIdentifier].Payment = foundPayment.Card;
	              } else {
	                paymentMethods[paxIndex + 2].flights[flight.GroupIdentifier].Payment = foundPayment.Invoice;
	              }
	            }
	
	            pax.Configurations.PaymentMethod.PaymentItems.push(buildPaymentObj(paymentMethods[paxIndex + 2].flights[flight.GroupIdentifier].Payment, flight.GroupIdentifier, 'Flight'));
	          } else {
	            paymentMissing += 1;
	          }
	        });
	
	        //Ancillaries
	        _.forEach(pax.Flights, function (flight) {
	          if (!(flight.AncillaryServices && flight.AncillaryServices.length > 0)) return;
	          _.forEach(flight.AncillaryServices, function (ancillary) {
	            if (!(ancillary.QuantitySelected > 0) || ancillary.BookingStatus === 'Booked') {
	              return;
	            }
	            if (paymentMethods.allPax && paymentMethods.allPax.ancillaries) {
	              pax.Configurations.PaymentMethod.PaymentItems.push(buildPaymentObj(paymentMethods.allPax.ancillaries.Payment, ancillary.Identifier, 'Ancillary'));
	            } else if (paymentMethods[paxIndex + 2] && paymentMethods[paxIndex + 2].ancillaries[ancillary.Identifier]) {
	              if (!paymentMethods[paxIndex + 2].ancillaries[ancillary.Identifier].Payment) {
	                var foundPayment = findPaymentWithTypeAndGrpId(paymentsCopy, 'Ancillary', ancillary.Identifier);
	
	                if (foundPayment.Card) {
	                  paymentMethods[paxIndex + 2].ancillaries[ancillary.Identifier].Payment = foundPayment.Card;
	                } else {
	                  paymentMethods[paxIndex + 2].ancillaries[ancillary.Identifier].Payment = foundPayment.Invoice;
	                }
	              }
	
	              pax.Configurations.PaymentMethod.PaymentItems.push(buildPaymentObj(paymentMethods[paxIndex + 2].ancillaries[ancillary.Identifier].Payment, ancillary.Identifier, 'Ancillary'));
	            } else {
	              paymentMissing += 1;
	            }
	          });
	        });
	
	        _.forEach(pax.Rails, function (rail) {
	          if (_checkSectorStatusNoPayment(rail)) {
	            return;
	          }
	          if (paymentMethods.allPax && paymentMethods.allPax.rails) {
	            pax.Configurations.PaymentMethod.PaymentItems.push(buildPaymentObj(paymentMethods.allPax.rails.Payment, rail.GroupIdentifier, 'Rail'));
	          } else if (paymentMethods[paxIndex + 2] && paymentMethods[paxIndex + 2].rails[rail.GroupIdentifier]) {
	            if (!paymentMethods[paxIndex + 2].rails[rail.GroupIdentifier].Payment) {
	              var foundPayment = findPaymentWithTypeAndGrpId(paymentsCopy, 'Rail', rail.GroupIdentifier);
	
	              if (foundPayment.Card) {
	                paymentMethods[paxIndex + 2].rails[rail.GroupIdentifier].Payment = foundPayment.Card;
	              } else {
	                paymentMethods[paxIndex + 2].rails[rail.GroupIdentifier].Payment = foundPayment.Invoice;
	              }
	            }
	
	            pax.Configurations.PaymentMethod.PaymentItems.push(buildPaymentObj(paymentMethods[paxIndex + 2].rails[rail.GroupIdentifier].Payment, rail.GroupIdentifier, 'Rail'));
	          } else {
	            paymentMissing += 1;
	          }
	        });
	
	        _.forEach(pax.Hotels, function (hotel) {
	          if (_checkSectorStatusNoPayment(hotel)) {
	            return;
	          }
	          if (paymentMethods.allPax && paymentMethods.allPax.hotels) {
	            pax.Configurations.PaymentMethod.PaymentItems.push(buildPaymentObj(paymentMethods.allPax.hotels.Payment, hotel.GroupIdentifier, 'Hotel'));
	          } else if (paymentMethods[paxIndex + 2] && paymentMethods[paxIndex + 2].hotels[hotel.GroupIdentifier]) {
	            if (!paymentMethods[paxIndex + 2].hotels[hotel.GroupIdentifier].Payment) {
	              var foundPayment = findPaymentWithTypeAndGrpId(paymentsCopy, 'Hotel', hotel.GroupIdentifier);
	
	              if (foundPayment.Card) {
	                paymentMethods[paxIndex + 2].hotels[hotel.GroupIdentifier].Payment = foundPayment.Card;
	              } else {
	                paymentMethods[paxIndex + 2].hotels[hotel.GroupIdentifier].Payment = foundPayment.Invoice;
	              }
	            }
	
	            pax.Configurations.PaymentMethod.PaymentItems.push(buildPaymentObj(paymentMethods[paxIndex + 2].hotels[hotel.GroupIdentifier].Payment, hotel.GroupIdentifier, 'Hotel'));
	          } else {
	            paymentMissing += 1;
	          }
	        });
	
	        _.forEach(pax.Cars, function (car) {
	          if (_checkSectorStatusNoPayment(car)) {
	            return;
	          }
	          if (paymentMethods.allPax && paymentMethods.allPax.cars) {
	            pax.Configurations.PaymentMethod.PaymentItems.push(buildPaymentObj(paymentMethods.allPax.cars.Payment, car.GroupIdentifier, 'Car'));
	          } else if (paymentMethods[paxIndex + 2] && paymentMethods[paxIndex + 2].cars[car.GroupIdentifier]) {
	            if (!paymentMethods[paxIndex + 2].cars[car.GroupIdentifier].Payment) {
	              var foundPayment = findPaymentWithTypeAndGrpId(paymentsCopy, 'Car', car.GroupIdentifier);
	
	              if (foundPayment.Card) {
	                paymentMethods[paxIndex + 2].cars[car.GroupIdentifier].Payment = foundPayment.Card;
	              } else {
	                paymentMethods[paxIndex + 2].cars[car.GroupIdentifier].Payment = foundPayment.Invoice;
	              }
	            }
	
	            pax.Configurations.PaymentMethod.PaymentItems.push(buildPaymentObj(paymentMethods[paxIndex + 2].cars[car.GroupIdentifier].Payment, car.GroupIdentifier, 'Car'));
	          } else {
	            paymentMissing += 1;
	          }
	        });
	
	        ///Ground Transports
	        _.forEach(pax.GroundTransports, function (ground) {
	          if (_checkSectorStatusNoPayment(ground)) {
	            return;
	          }
	          if (paymentMethods.allPax && paymentMethods.allPax.grounds) {
	            pax.Configurations.PaymentMethod.PaymentItems.push(buildPaymentObj(paymentMethods.allPax.grounds.Payment, ground.GroupIdentifier, 'GroundTransport'));
	          } else if (paymentMethods[paxIndex + 2] && paymentMethods[paxIndex + 2].grounds[ground.GroupIdentifier]) {
	            if (!paymentMethods[paxIndex + 2].grounds[ground.GroupIdentifier].Payment) {
	              var foundPayment = findPaymentWithTypeAndGrpId(paymentsCopy, 'GroundTransport', ground.GroupIdentifier);
	
	              if (foundPayment.Card) {
	                paymentMethods[paxIndex + 2].grounds[ground.GroupIdentifier].Payment = foundPayment.Card;
	              } else {
	                paymentMethods[paxIndex + 2].grounds[ground.GroupIdentifier].Payment = foundPayment.Invoice;
	              }
	            }
	
	            pax.Configurations.PaymentMethod.PaymentItems.push(buildPaymentObj(paymentMethods[paxIndex + 2].grounds[ground.GroupIdentifier].Payment, ground.GroupIdentifier, 'GroundTransport'));
	          } else {
	            paymentMissing += 1;
	          }
	        });
	
	        //EndGroundTransports
	      });
	
	      return {
	        travellers: travellers,
	        missingPayments: paymentMissing > 0
	      };
	    },
	    checkAllPaxPaymentsSelected: function checkAllPaxPaymentsSelected(pax) {
	      if (!pax) {
	        return;
	      }
	      var eachSectorHasPayment = true;
	      var sectorGrpIds = [];
	
	      _.forEach(pax.Flights, function (flight) {
	        if (_checkSectorStatusNoPayment(flight)) {
	          return;
	        }
	        sectorGrpIds.push(flight.GroupIdentifier);
	      });
	
	      _.forEach(pax.Flights, function (flight) {
	        _.forEach(flight.AncillaryServices, function (ancillary) {
	          if (ancillary.BookingStatus === 'Booked' || ancillary.BookingStatus > 1 || ancillary.QuantitySelected == 0) {
	            return;
	          }
	          sectorGrpIds.push(ancillary.Identifier);
	        });
	      });
	
	      _.forEach(pax.Rails, function (rail) {
	        if (_checkSectorStatusNoPayment(rail)) {
	          return;
	        }
	        sectorGrpIds.push(rail.GroupIdentifier);
	      });
	
	      _.forEach(pax.Hotels, function (hotel) {
	        if (_checkSectorStatusNoPayment(hotel)) {
	          return;
	        }
	        sectorGrpIds.push(hotel.GroupIdentifier);
	      });
	
	      _.forEach(pax.Cars, function (car) {
	        if (_checkSectorStatusNoPayment(car)) {
	          return;
	        }
	        sectorGrpIds.push(car.GroupIdentifier);
	      });
	
	      _.forEach(pax.GroundTransports, function (ground) {
	        if (_checkSectorStatusNoPayment(ground)) {
	          return;
	        }
	        sectorGrpIds.push(ground.GroupIdentifier);
	      });
	
	      sectorGrpIds = _.uniq(sectorGrpIds);
	
	      sectorGrpIds.every(function (grpId) {
	        if (eachSectorHasPayment) {
	          var findMatch = _.find(pax.Configurations.PaymentMethod.PaymentItems, function (PaymentItem) {
	            return PaymentItem.SectorGroupIdentifier === grpId;
	          });
	
	          eachSectorHasPayment = !!findMatch;
	        }
	
	        return eachSectorHasPayment;
	      });
	
	      return eachSectorHasPayment;
	    },
	    purgeDuplicatePaymentMethods: function purgeDuplicatePaymentMethods(payments) {
	      var grpIds = [];
	
	      return _.filter(payments, function (payment) {
	        var groupId = payment.SectorGroupIdentifier;
	        if (payment.SectorIdentifier) {
	          groupId = payment.SectorIdentifier;
	        }
	        if (grpIds.indexOf(groupId) === -1) {
	          grpIds.push(groupId);
	          return true;
	        } else {
	          return false;
	        }
	      });
	    },
	    checkForCVV: function checkForCVV(PaymentItems, cvvObj) {
	      var allCVVsPresent = true;
	
	      PaymentItems.every(function (payment) {
	        if (allCVVsPresent && payment.Card && payment.Card.SecurityCodeRequired && payment.Type !== 'Seat') {
	          allCVVsPresent = cvvObj[payment.Card.Reference];
	        }
	
	        return allCVVsPresent;
	      });
	
	      return allCVVsPresent;
	    },
	    addCVVsToPayments: function addCVVsToPayments(paymentItems, cvvObj) {
	      return _.forEach(paymentItems, function (payment) {
	        if (payment.Card && payment.Card.SecurityCodeRequired) {
	          payment.Card.SecurityCode = cvvObj[payment.Card.Reference];
	        }
	      });
	    },
	    checkSectorStatusNoPayment: function checkSectorStatusNoPayment(sector) {
	      return _checkSectorStatusNoPayment(sector);
	    },
	    updatedPaxWithPayments: undefined,
	    paymentMethods: [],
	    paymentMethodsLoading: false
	  };
	  function _checkSectorStatusNoPayment(sector) {
	    var checkStatus = !(sector && sector.Status && sector.Status != 'CurrentItin' && sector.Status != 'CurrentItinCancel' && sector.Status != 'CurrentItinNotCancellable');
	
	    return checkStatus;
	  }
	  function buildPaymentObj(Payment, grpId, type) {
	    var paymentObj = {};
	
	    if (Payment.PaymentType === 'Invoice') {
	      paymentObj = {
	        Card: null,
	        Invoice: {
	          PaymentType: 'Invoice',
	          Reference: 'Invoice'
	        },
	        SectorGroupIdentifier: grpId,
	        Type: type
	      };
	    } else {
	      paymentObj = {
	        Card: Payment,
	        Invoice: null,
	        SectorGroupIdentifier: grpId,
	        Type: type
	      };
	    }
	
	    return paymentObj;
	  }
	
	  function findPaymentWithTypeAndGrpId(payments, type, grpId) {
	    return _.find(payments, function (payment) {
	      return payment.SectorGroupIdentifier === grpId && payment.Type === type;
	    });
	  }
	
	  return service;
	}
	
	exports['default'] = paymentMethodsService;
	module.exports = exports['default'];

/***/ }),
/* 1343 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var $inject = [];
	
	var seatNumberService = function seatNumberService() {
	  var service = {};
	
	  service.activeSeat = null;
	  service.set = set;
	
	  return service;
	
	  function set(seat) {
	    service.activeSeat = seat;
	  }
	};
	
	seatNumberService.$inject = $inject;
	
	exports["default"] = seatNumberService;
	module.exports = exports["default"];

/***/ }),
/* 1344 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(8);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var $inject = ['moment', '$filter', 'ENUMS', 'dateTimeService', 'settingsService'];
	
	var sectorChangeService = function sectorChangeService(moment, $filter, ENUMS, dateTimeService, settingsService) {
	  return {
	    initializeChangeSector: initializeChangeSector,
	    getSelectedFlightCancelSegments: getSelectedFlightCancelSegments,
	    getSelectedCancelSectors: getSelectedCancelSectors
	  };
	
	  function initializeChangeSector(sectorKey, $scope) {
	    if (!$scope.changeSectorIdentifier) return;
	    switch (sectorKey) {
	      case 'flight':
	        initializeFlights($scope);
	        break;
	      case 'car':
	        initializeCar($scope);
	        break;
	      case 'hotel':
	        initializeHotel($scope);
	        break;
	    }
	  }
	
	  function initializeTraveler($scope) {
	    var travelerInfo = { traveler: null, otherTravelers: null, changeSector: null };
	    $scope.itinerary.itineraryModel.Passengers.forEach(function (pax) {
	      var findSector = pax.Sectors.find(function (s) {
	        return s.Identifier == $scope.changeSectorIdentifier;
	      });
	      if (findSector) {
	        $scope.changeSector = findSector;
	        travelerInfo.changeSector = findSector;
	        travelerInfo.traveler = pax;
	        travelerInfo.otherTravelers = $scope.itinerary.itineraryModel.Passengers.filter(function (p) {
	          return p.Identifier !== pax.Identifier;
	        });
	        var selTraveler = $scope.addTravelers.find(function (t) {
	          return t.Identifier == pax.Identifier;
	        });
	        $scope.selectedTravelers.push(selTraveler);
	      }
	    });
	
	    return travelerInfo;
	  }
	
	  function initializeHotel($scope) {
	    var travelerInfo = initializeTraveler($scope);
	    if (travelerInfo.otherTravelers.length) {
	      travelerInfo.changeSector.linkedSectors = [];
	      travelerInfo.otherTravelers.forEach(function (pax) {
	        var matchingSector = pax.Sectors.find(function (s) {
	          return isSameHotel(s, travelerInfo.changeSector);
	        });
	        if (matchingSector) {
	          travelerInfo.changeSector.linkedSectors.push({ sector: matchingSector.Identifier, passenger: pax.Identifier });
	          var pTravel = $scope.addTravelers.find(function (t) {
	            return t.Identifier == pax.Identifier;
	          });
	          if (!$scope.selectedTravelers.includes(pTravel)) $scope.selectedTravelers.push(pTravel);
	        }
	      });
	    }
	  }
	  function isSameHotel(hotel1, hotel2) {
	    if (!hotel1 || !hotel1.HotelName || !hotel2 || !hotel2.HotelName) return false;
	    if (hotel1.HotelName !== hotel2.HotelName) return false;
	    if (hotel1.DateFrom !== hotel2.DateFrom) return false;
	    if (hotel1.DateTo !== hotel2.DateTo) return false;
	
	    return true;
	  }
	
	  function initializeCar($scope) {
	    var travelerInfo = initializeTraveler($scope);
	    if (travelerInfo.otherTravelers.length) {
	      travelerInfo.changeSector.linkedSectors = [];
	      travelerInfo.otherTravelers.forEach(function (pax) {
	        var matchingSector = pax.Sectors.find(function (s) {
	          return isSameCar(s, travelerInfo.changeSector);
	        });
	        if (matchingSector) {
	          travelerInfo.changeSector.linkedSectors.push({ sector: matchingSector.Identifier, passenger: pax.Identifier });
	          var pTravel = $scope.addTravelers.find(function (t) {
	            return t.Identifier == pax.Identifier;
	          });
	          if (!$scope.selectedTravelers.includes(pTravel)) $scope.selectedTravelers.push(pTravel);
	        }
	      });
	    }
	  }
	  function isSameCar(car1, car2) {
	    if (!car1 || !car1.PickUp || !car2 || !car2.PickUp) return false;
	    if (car1.PickUp.Code !== car2.PickUp.Code) return false;
	    if (car1.PickUp.Date !== car2.PickUp.Date) return false;
	    if (car1.DropOff.Code !== car2.DropOff.Code) return false;
	    if (car1.DropOff.Date !== car2.DropOff.Date) return false;
	    if (car1.Supplier.Code !== car2.Supplier.Code) return false;
	
	    return true;
	  }
	
	  function initializeFlights($scope) {
	    $scope.flightsSelected = [];
	    $scope.changeSector = null;
	
	    var travelerInfo = initializeTraveler($scope);
	    travelerInfo.traveler.Sectors.filter(function (sector) {
	      return sector.FlightNumber && (sector.Status == 'CurrentItin' || sector.Status == 'Pending');
	    }).forEach(function (sector) {
	      sector.cancelCurrent = sector.Identifier === $scope.changeSectorIdentifier;
	      sector.TktorExchTkt = sector.TicketNumber ? sector.TicketNumber : sector.ExchangeTicketNumber;
	      sector.itemIndex = $scope.flightsSelected.length;
	      $scope.flightsSelected.push(sector);
	      sector.linkedSectors = [];
	      var isChangeSector = sector.Identifier === $scope.changeSectorIdentifier;
	      if (travelerInfo.otherTravelers.length) {
	        travelerInfo.otherTravelers.forEach(function (pax) {
	          var matchingSector = pax.Sectors.find(function (s) {
	            return isSameFlight(s, sector);
	          });
	          if (matchingSector) {
	            sector.linkedSectors.push({ sector: matchingSector.Identifier, passenger: pax.Identifier });
	            var pTravel = $scope.addTravelers.find(function (t) {
	              return t.Identifier == pax.Identifier;
	            });
	            if (isChangeSector && !$scope.selectedTravelers.includes(pTravel)) $scope.selectedTravelers.push(pTravel);
	          }
	        });
	      }
	
	      if (isChangeSector) $scope.changeSector = sector;
	    });
	
	    $scope.flightsSelected.sort(function (item1, item2) {
	      if (item1.TktorExchTkt > item2.TktorExchTkt) return -1;
	      if (item1.itemIndex < item2.itemIndex) return -1;
	    });
	  }
	  function getSelectedCancelSectors($scope) {
	    var cancelSectors = [$scope.changeSectorIdentifier];
	    if ($scope.changeSector && $scope.changeSector.linkedSectors) {
	      $scope.changeSector.linkedSectors.forEach(function (l) {
	        if ($scope.selectedTravelers.find(function (d) {
	          return d === l.passenger;
	        })) {
	          cancelSectors.push(l.sector);
	        }
	      });
	    }
	    return cancelSectors;
	  }
	  function isSameFlight(flight1, flight2) {
	    if (!flight1 || !flight1.FlightNumber || !flight2 || !flight2.FlightNumber) return false;
	    if (flight1.FlightIdentifier && flight2.FlightIdentifier) {
	      return flight1.FlightIdentifier == flight2.FlightIdentifier;
	    }
	    if (flight1.Departure.Code !== flight2.Departure.Code) return false;
	    if (flight1.Departure.Date !== flight2.Departure.Date) return false;
	    if (flight1.Arrival.Code !== flight2.Arrival.Code) return false;
	    if (flight1.Arrival.Date !== flight2.Arrival.Date) return false;
	    if (flight1.FlightNumber !== flight2.FlightNumber) return false;
	    if (flight1.Carrier !== flight2.Carrier) return false;
	    if (flight1.GdsProvider !== flight2.GdsProvider) return false;
	    if (flight1.GDSSegmentNumber !== flight2.GDSSegmentNumber) return false;
	
	    return true;
	  }
	  function getSelectedFlightCancelSegments($scope) {
	    var flightsChange = [];
	    if ($scope && $scope.flightsSelected) {
	      $scope.flightsSelected.filter(function (flight) {
	        return flight.cancelCurrent;
	      }).forEach(function (flight) {
	        flightsChange.push(flight.Identifier);
	        if (flight.linkedSectors) {
	          flight.linkedSectors.forEach(function (l) {
	            if ($scope.selectedTravelers && $scope.selectedTravelers.find(function (d) {
	              return d === l.passenger;
	            })) {
	              flightsChange.push(l.sector);
	            }
	          });
	        }
	      });
	    }
	    return flightsChange;
	  }
	};
	sectorChangeService.$inject = $inject;
	
	exports['default'] = sectorChangeService;
	module.exports = exports['default'];

/***/ }),
/* 1345 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(8);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var $inject = ['moment', '$filter', 'ENUMS', 'dateTimeService', 'settingsService'];
	
	var sectorService = function sectorService(moment, $filter, ENUMS, dateTimeService, settingsService) {
	  return {
	    reorder: reorder,
	    abridge: abridge,
	    priceSummary: priceSummary,
	    currentStatus: currentStatus,
	    abridgeCurrentItinerary: abridgeCurrentItinerary,
	    getSeatMapAvailable: getSeatMapAvailable,
	    getPolicyDisabled: getPolicyDisabled,
	    getMatchingPolicyItem: getMatchingPolicyItem
	  };
	
	  function reorder(obj) {
	    var allSectors = [].concat(obj.Flights, obj.Rails, obj.Hotels, obj.Cars, obj.GroundTransports);
	    var sectorTypeOrder = ['flight', 'rail', 'hotel', 'car', 'ground'];
	
	    _angular2['default'].forEach(allSectors, function (sector) {
	      if (sector.Carrier) {
	        sector.sectorType = sectorTypeOrder[0];
	        sector.date = sector.Departure.Date;
	      }
	
	      if (sector.RailNumber) {
	        sector.sectorType = sectorTypeOrder[1];
	        sector.date = sector.Departure.Date;
	      }
	
	      if (sector.HotelName) {
	        sector.sectorType = sectorTypeOrder[2];
	        sector.date = sector.DateFrom;
	      }
	
	      if (sector.PickUp) {
	        sector.sectorType = sectorTypeOrder[3];
	        sector.date = sector.PickUp.Date;
	      }
	
	      if (sector.StartDateTime) {
	        sector.sectorType = sectorTypeOrder[4];
	        sector.date = sector.StartDateTime;
	      }
	    });
	
	    allSectors.sort(function (x, y) {
	      var n = moment(x.date, 'YYYY-MM-DD').format('YYYYMMDD') - moment(y.date, 'YYYY-MM-DD').format('YYYYMMDD');
	
	      return n !== 0 ? n : sectorTypeOrder.indexOf(x.sectorType) - sectorTypeOrder.indexOf(y.sectorType);
	    });
	
	    return allSectors;
	  }
	
	  function abridge(sectors) {
	    var trip = {
	      travelType: '',
	      flights: [],
	      hotels: [],
	      grounds: [],
	      land: [],
	      cars: []
	    };
	
	    _angular2['default'].forEach(sectors, function (sector) {
	      var location = {};
	
	      if (sector.sectorType === 'flight' || sector.sectorType === 'rail') {
	        location.startLocation = sector.Departure.Code;
	        location.endLocation = sector.Arrival.Code;
	        location.startDate = sector.Departure.Date;
	        location.endDate = sector.Arrival.Date;
	
	        trip.flights.push(location);
	      }
	
	      if (sector.sectorType === 'hotel') {
	        location.startLocation = sector.Location.Code;
	        location.endLocation = sector.Location.Code;
	        location.startDate = sector.DateFrom;
	        location.endDate = sector.DateTo;
	
	        trip.hotels.push(location);
	        trip.land.push(location);
	      }
	
	      if (sector.sectorType === 'car') {
	        location.startLocation = sector.PickUp.Code;
	        location.endLocation = sector.DropOff.Code;
	        location.startDate = sector.PickUp.Date;
	        location.endDate = sector.DropOff.Date;
	
	        trip.cars.push(location);
	        trip.land.push(location);
	      }
	
	      if (sector.sectorType === 'ground') {
	        location.startLocation = sector.Route[0].Type;
	        location.endLocation = sector.Route[0].Type;
	        location.startDate = sector.StartDateTime;
	        location.endDate = sector.StartDateTime;
	
	        trip.grounds.push(location);
	        trip.land.push(location);
	      }
	    });
	
	    SetTripAbrigdeDetails(trip);
	    return trip;
	  }
	
	  function abridgeCurrentItinerary(sectors) {
	    var trip = {
	      travelType: '',
	      flights: [],
	      hotels: [],
	      grounds: [],
	      land: [],
	      cars: []
	    };
	
	    _angular2['default'].forEach(sectors, function (sector) {
	      var location = {
	        startDate: sector.dateOrder
	      };
	
	      if (sector.type === 'flight') {
	        location.startLocation = sector.Start.Airport.Code;
	        location.endLocation = sector.End.Airport.Code;
	        location.startDate = sector.Start.DateLocal;
	        location.endDate = sector.End.DateLocal;
	        location.startDateUTC = sector.Start.Date;
	        location.endDateUTC = sector.End.Date;
	
	        trip.flights.push(location);
	      }
	      if (sector.type === 'rail') {
	        location.startLocation = sector.Start.Station.Code;
	        location.endLocation = sector.End.Station.Code;
	        location.startDate = sector.Start.DateLocal;
	        location.endDate = sector.End.DateLocal;
	        location.startDateUTC = sector.Start.Date;
	        location.endDateUTC = sector.End.Date;
	
	        trip.flights.push(location);
	      }
	
	      if (sector.type === 'hotel') {
	        location.startLocation = sector.Location.CityCode;
	        location.endLocation = sector.Location.CityCode;
	        location.startDate = sector.Start.DateLocal;
	        location.endDate = sector.End.DateLocal;
	        location.startDateUTC = sector.Start.Date;
	        location.endDateUTC = sector.End.Date;
	
	        trip.hotels.push(location);
	        trip.land.push(location);
	      }
	
	      if (sector.type === 'car') {
	        location.startLocation = sector.Start.Location.CityCode;
	        location.endLocation = sector.End.Location.CityCode;
	        location.startDate = sector.Start.DateLocal;
	        location.endDate = sector.End.DateLocal;
	        location.startDateUTC = sector.Start.Date;
	        location.endDateUTC = sector.End.Date;
	
	        trip.cars.push(location);
	        trip.land.push(location);
	      }
	
	      if (sector.type === 'ground') {
	        location.startLocation = sector.PickupDetails;
	        location.endLocation = sector.DropOffDetails;
	        location.startDate = sector.DateLocal;
	        location.endDate = sector.DateLocal;
	        var utcDate = moment.utc(sector.dateOrder).format('YYYYMMDDTHHmmssZ');
	        utcDate = utcDate.substring(0, utcDate.indexOf('+'));
	        location.startDateUTC = utcDate;
	        location.endDateUTC = utcDate;
	
	        trip.grounds.push(location);
	        trip.land.push(location);
	      }
	    });
	
	    SetTripAbrigdeDetails(trip);
	    return trip;
	  }
	
	  function SetTripAbrigdeDetails(trip) {
	    var DATE_FORMAT_LONG = dateTimeService.getFormat(ENUMS.dateTimeFormats.DATE_LONG);
	    var start = undefined;
	    var end = undefined;
	    var startUTC = undefined;
	    var endUTC = undefined;
	
	    if (trip.flights.length === 1) {
	      trip.travelType = 'oneway';
	
	      start = trip.flights[0].startDate;
	      end = trip.flights[0].endDate;
	      startUTC = trip.flights[0].startDateUTC;
	      endUTC = trip.flights[0].endDateUTC;
	    } else if (trip.flights.length === 2 && trip.flights[0].startLocation === trip.flights[trip.flights.length - 1].endLocation) {
	      trip.travelType = 'return';
	
	      start = trip.flights[0].startDate;
	      end = trip.flights[1].endDate;
	      startUTC = trip.flights[0].startDateUTC;
	      endUTC = trip.flights[1].endDateUTC;
	    } else if (trip.flights.length > 1) {
	      trip.travelType = 'multi';
	
	      start = trip.flights[0].startDate;
	      end = trip.flights[trip.flights.length - 1].endDate;
	      startUTC = trip.flights[0].startDateUTC;
	      endUTC = trip.flights[trip.flights.length - 1].endDateUTC;
	    } else {
	      if (trip.hotels.length && trip.cars.length) {
	        trip.travelType = 'land';
	
	        start = trip.land[0].startDate;
	        end = trip.land[trip.land.length - 1].endDate;
	        startUTC = trip.land[0].startDateUTC;
	        endUTC = trip.land[trip.land.length - 1].endDateUTC;
	      } else if (trip.hotels.length) {
	        trip.travelType = 'hotel';
	
	        start = trip.hotels[0].startDate;
	        end = trip.hotels[trip.hotels.length - 1].endDate;
	        startUTC = trip.hotels[0].startDateUTC;
	        endUTC = trip.hotels[trip.hotels.length - 1].endDateUTC;
	      } else if (trip.cars.length) {
	        trip.travelType = 'car';
	
	        start = trip.cars[0].startDate;
	        end = trip.cars[trip.cars.length - 1].endDate;
	        startUTC = trip.cars[0].startDateUTC;
	        endUTC = trip.cars[trip.cars.length - 1].endDateUTC;
	      } else if (trip.grounds.length) {
	        trip.travelType = 'ground';
	
	        start = trip.grounds[0].startDate;
	        end = trip.grounds[trip.grounds.length - 1].endDate;
	        startUTC = trip.grounds[0].startDateUTC;
	        endUTC = trip.grounds[0].endDateUTC;
	      }
	    }
	
	    if (start && end) {
	      var startMoment = moment(start, 'YYYY-MM-DD').startOf('day');
	      var endMoment = moment(end, 'YYYY-MM-DD').startOf('day');
	
	      trip.length = endMoment.diff(startMoment, 'days');
	      trip.startDate = startMoment.format(DATE_FORMAT_LONG);
	      trip.endDate = endMoment.format(DATE_FORMAT_LONG);
	    }
	
	    if (startUTC && endUTC) {
	      trip.startDateUTC = startUTC.replace(/[\W_]+/g, '') + 'Z';
	      trip.endDateUTC = endUTC.replace(/[\W_]+/g, '') + 'Z';
	    }
	
	    trip.title = tripTitle(trip);
	  }
	
	  function priceSummary(sectors, currentItinerarySegments, config) {
	    var priceTotals = {
	      Flight: [],
	      Rail: [],
	      Hotel: [],
	      Car: [],
	      GroundTransport: [],
	      Seat: [],
	      Ancillary: [],
	      flights: 0,
	      rails: 0,
	      hotels: 0,
	      cars: 0,
	      grounds: 0,
	      combined: 0,
	      lostSavings: 0,
	      sectorSavings: []
	    };
	
	    var groupedSectors = {};
	
	    _.forEach(config.PaymentMethod.PaymentItems, function (paymentMethod) {
	      paymentMethod = buildPaymentMethodTitle(paymentMethod, sectors);
	
	      if (paymentMethod.Invoice) {
	        paymentMethod.Invoice.titleArray = paymentMethod.sectorTitlesArray;
	        priceTotals[paymentMethod.Type].push(paymentMethod.Invoice);
	      } else {
	        paymentMethod.Card.titleArray = paymentMethod.sectorTitlesArray;
	        priceTotals[paymentMethod.Type].push(paymentMethod.Card);
	      }
	    });
	
	    _angular2['default'].forEach(sectors, function (sector) {
	      priceTotals.lostSavings += sector.LostSavingsAmount;
	      if (sector.LostSavingsAmount > 0) {
	        var item = priceTotals.sectorSavings.find(function (s) {
	          return s.sectorType === sector.sectorType;
	        });
	        if (item) {
	          item.savings += sector.LostSavingsAmount;
	        } else {
	          priceTotals.sectorSavings.push({
	            sectorType: sector.sectorType,
	            savings: sector.LostSavingsAmount
	          });
	        }
	      }
	      if (sector.sectorType === 'flight') {
	        priceTotals.flights += sector.TotalAmount;
	      }
	
	      if (sector.sectorType === 'rail') {
	        var sectorIdentifier = sector.RailNumber + '-' + sector.Departure.Code + '-' + sector.Arrival.Code + '-' + sector.Departure.Date;
	        if (!Object.hasOwn(groupedSectors, sectorIdentifier)) {
	          groupedSectors[sectorIdentifier] = {};
	          priceTotals.rails += sector.TotalAmount;
	        }
	      }
	    });
	
	    _angular2['default'].forEach(currentItinerarySegments, function (segment) {
	      if (segment.type === 'hotel') {
	        if (segment.TotalCost != null) {
	          priceTotals.hotels += segment.TotalCost.Amount;
	          priceTotals.disclaimer = segment.TotalCost.Disclaimer;
	        } else {
	          var startMoment = moment(segment.Start.Date, 'YYYY-MM-DD').startOf('day');
	          var endMoment = moment(segment.End.Date, 'YYYY-MM-DD').startOf('day');
	          var days = endMoment.diff(startMoment, 'days');
	
	          priceTotals.hotels += segment.Rate.Amount * days;
	        }
	      }
	      if (segment.type === 'car' && segment.TotalCost) {
	        priceTotals.cars += segment.TotalCost.Amount;
	      }
	
	      if (segment.type === 'ground' && segment.Rate) {
	        priceTotals.grounds += segment.Rate.Amount;
	      }
	    });
	
	    priceTotals.combined = priceTotals.flights + priceTotals.rails + priceTotals.hotels + priceTotals.cars + priceTotals.grounds;
	
	    return priceTotals;
	  }
	
	  function currentStatus(passenger) {
	    var approvalStates = {
	      Auto: {
	        id: 'AU',
	        message: 'Auto approval',
	        'class': 'approvalApproved'
	      },
	      Pending: {
	        id: 'AW',
	        message: 'Awaiting approval',
	        'class': 'approvalPending'
	      },
	      Approved: {
	        id: 'AP',
	        message: 'Approved',
	        'class': 'approvalApproved'
	      },
	      Declined: {
	        id: 'DN',
	        message: 'Denied',
	        'class': 'approvalDenied'
	      },
	      Expired: {
	        id: 'EX',
	        message: 'Expired',
	        'class': 'approvalExpired'
	      },
	      // LOBT-2525 Frontend - My Bookings Confirm booking on hold
	      UserHold: {
	        id: 'UH',
	        message: 'User Hold',
	        'class': 'approvalPending'
	      }
	    };
	
	    return approvalStates[passenger.ApprovalState];
	  }
	
	  function tripTitle(trip) {
	    switch (trip.travelType) {
	      case 'oneway':
	        return trip.flights[0].startLocation + ' to ' + trip.flights[0].endLocation;
	        break;
	      case 'return':
	        return trip.flights[0].startLocation + ' to ' + trip.flights[0].endLocation;
	        break;
	      case 'multi':
	        return _.join(_.map(trip.flights, 'startLocation'), ' > ');
	        break;
	      case 'land':
	        return 'Hotel and Car Booking';
	        break;
	      case 'hotel':
	        return 'Hotel booking';
	        break;
	      case 'car':
	        return 'Car booking';
	        break;
	      case 'ground':
	        return 'Ground booking';
	        break;
	      default:
	        return 'Lightning booking';
	    }
	  }
	
	  function buildPaymentMethodTitle(paymentMethod, sectors) {
	    var grpId = paymentMethod.SectorGroupIdentifier;
	
	    paymentMethod.sectorTitlesArray = [];
	
	    _.forEach(sectors, function (sector) {
	      if (sector.GroupIdentifier === grpId && sector.sectorType === 'flight') {
	        paymentMethod.sectorTitlesArray.push(sector.Carrier + ' ' + sector.FlightNumber);
	      }
	    });
	
	    return paymentMethod;
	  }
	
	  function getSeatMapAvailable(booking) {
	    if (booking && booking.Flights) {
	      if (_.some(booking.Flights, function (flight) {
	        return flight.SeatMapAvailable;
	      })) {
	        return true;
	      }
	    }
	    if (booking && booking.CurrentItinerary && booking.CurrentItinerary.Air) {
	      if (_.some(booking.CurrentItinerary.Air, function (flight) {
	        return flight.SeatMapAvailable;
	      })) {
	        return true;
	      }
	    }
	  }
	
	  function getPolicyDisabled(sector, selectedTravelers, reasonForTravel) {
	    var sectorSettings = settingsService.settings[sector + 'Configuration'];
	    if (!sectorSettings) return true;
	    if ('Enable' in sectorSettings && !sectorSettings.Enable) return false;
	    if ('Enabled' in sectorSettings && !sectorSettings.Enabled) return false;
	    var disablesName = sector === 'GroundTransportation' ? 'GroundTrans' : sector;
	    var policyDisables = sectorSettings[disablesName + 'PolicyDisables'];
	    var policyKey = 'Disable' + sector;
	    var sectorEnabled = true;
	    if (!policyDisables || !policyDisables.length) return true;
	
	    //If any set it to disable go ahead and disable.
	    //This covers when no travelers are selected so it defaults the traveler
	    var policyDisable = policyDisables.find(function (policy) {
	      return policy[policyKey];
	    });
	    if (policyDisable) sectorEnabled = !policyDisable[policyKey];
	
	    if (!selectedTravelers || !selectedTravelers.length) return sectorEnabled;
	    var traveler = selectedTravelers[0]; //Only Look at first traveler
	
	    var policyFind = getMatchingPolicyItem(traveler, reasonForTravel, policyDisables);
	    if (policyFind) {
	      sectorEnabled = !policyFind[policyKey];
	      return sectorEnabled;
	    }
	
	    return sectorEnabled;
	  }
	};
	
	function getMatchingPolicyItem(traveler, reasonForTravel, polcies) {
	  // most restrictive policy applies for example AgencyReasonCodes & EmployeeTypes policy applies first over EmployeeTypes only policy and AgencyReasonCodes only policy
	  //matches backend itineraryPolicyManager.cs logic
	  var levels = [];
	  levels.push(polcies.filter(function (policy) {
	    return policy.AgencyReasonCodes && policy.AgencyReasonCodes.length && policy.EmployeeTypes && policy.EmployeeTypes.length;
	  }));
	
	  levels.push(polcies.filter(function (policy) {
	    return policy.EmployeeTypes && policy.EmployeeTypes.length;
	  }));
	  levels.push(polcies.filter(function (policy) {
	    return policy.AgencyReasonCodes && policy.AgencyReasonCodes.length;
	  }));
	  levels.push(polcies);
	  var policyFind = null;
	  levels.forEach(function (level) {
	    if (policyFind) return;
	    policyFind = _.find(level, function (policy) {
	      if (policy.AgencyReasonCodes && policy.AgencyReasonCodes.length > 0) {
	        if (!reasonForTravel) return false;
	        if (policy.AgencyReasonCodes.indexOf(reasonForTravel.Value) < 0) return false;
	      }
	      if (policy.EmployeeTypes && policy.EmployeeTypes.length > 0) {
	        if (!traveler.EmployeeCode) return false;
	        if (policy.EmployeeTypes.indexOf(traveler.EmployeeCode) < 0) return false;
	      }
	      return true;
	    });
	    if (policyFind) {
	      return policyFind;
	    }
	  });
	  return policyFind;
	}
	sectorService.$inject = $inject;
	
	exports['default'] = sectorService;
	module.exports = exports['default'];

/***/ }),
/* 1346 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['$q', '$state', 'itinerariesService', 'seatMapService'];
	
	var stateResolveService = function stateResolveService($q, $state, itinerariesService, seatMapService) {
	  var service = {
	    setActivePax: setActivePax,
	    setActiveSeatMap: setActiveSeatMap,
	    setTransport: setTransport
	  };
	
	  function setActivePax($stateParams, deferred) {
	    if ($stateParams.source == 'livebooking') {
	      itinerariesService.postModifyCurrent($stateParams.paxId, true).then(function (itinerary) {
	        $state.go('app.seatmaps', { itineraryId: itinerary.Identifier, paxId: itinerary.Passengers[0].Identifier });
	        deferred.resolve();
	      });
	      return deferred.promise;
	    }
	    itinerariesService.get($stateParams.itineraryId).then(function () {
	      seatMapService.init(itinerariesService.itinerary.Passengers, $stateParams.paxId);
	
	      var activePaxId = seatMapService.findIdentifierIn($stateParams.paxId, itinerariesService.itinerary, 'Passengers');
	
	      if (activePaxId) {
	        deferred.resolve();
	      } else {
	        deferred.reject('No passenger found');
	      }
	    });
	
	    return deferred.promise;
	  }
	
	  function setActiveSeatMap($stateParams, deferred) {
	    var activePax = seatMapService.findIdentifierIn($stateParams.activePaxId, seatMapService, 'paxArray');
	
	    if (!activePax) {
	      seatMapService.error = true;
	      deferred.reject('No passenger found');
	      return;
	    }
	
	    seatMapService.setActive(activePax, 'activePax');
	
	    var flight = seatMapService.findIdentifierIn($stateParams.flightId, seatMapService.activePax, 'Flights');
	
	    if (!flight) {
	      seatMapService.error = true;
	      deferred.reject('No flight found');
	      return;
	    }
	
	    flight.showStops = true;
	    flight.seatmaps = true;
	    seatMapService.setActive(flight, 'activeFlight');
	
	    if (!seatMapService.activeSeatMap) {
	      //seatMapService.activeSeatMap = true;
	
	      seatMapService.get($stateParams.itineraryId, $stateParams.activePaxId, $stateParams.flightId).then(function (data) {
	        flight.transports = data.Transport;
	        service.setTransport($stateParams.transportIndex, flight);
	
	        deferred.resolve();
	      });
	    } else {
	      service.setTransport($stateParams.transportIndex, flight);
	
	      deferred.resolve();
	    }
	
	    return deferred.promise;
	  }
	
	  function setTransport(transportIndex, flight) {
	    if (flight.transports.length === 0) {
	      return;
	    }
	
	    seatMapService.setActiveSeatMap(flight.transports[transportIndex]);
	    seatMapService.setActive(flight.transports[transportIndex], 'activeTransport');
	
	    if (seatMapService.activeSeatMap.Decks.length > 0) {
	      seatMapService.setActive(seatMapService.activeSeatMap.Decks[0], 'activeDeck');
	      seatMapService.activeDeck.formatted = seatMapService.buildDeck(seatMapService.activeDeck);
	    }
	  }
	
	  return service;
	};
	
	stateResolveService.$inject = $inject;
	
	exports['default'] = stateResolveService;
	module.exports = exports['default'];

/***/ }),
/* 1347 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['$filter', 'moment'];
	
	var timesService = function timesService($filter, moment) {
	  var service = {
	    getSelectOptions: getSelectOptions
	  };
	
	  return service;
	
	  function getSelectOptions(timeFormat, includeAnytime) {
	    var timeOptions = [];
	
	    if (includeAnytime) {
	      timeOptions.push({
	        value: moment('12:00 AM', 'h:mm A').format(timeFormat),
	        label: 'Anytime'
	      });
	    }
	
	    for (var i = 0; i <= 23; i++) {
	      var amPm = i < 12 ? 'AM' : 'PM';
	      var j = i > 12 || i === 0 ? Math.abs(i - 12) : i;
	      var startHour = j + ':00 ' + amPm;
	      var halfHour = j + ':30 ' + amPm;
	
	      timeOptions.push({
	        value: moment(startHour, 'h:mm A').format(timeFormat),
	        label: moment(startHour, 'h:mm A').format(timeFormat)
	      });
	
	      timeOptions.push({
	        value: moment(halfHour, 'h:mm A').format(timeFormat),
	        label: moment(halfHour, 'h:mm A').format(timeFormat)
	      });
	    }
	
	    return timeOptions;
	  }
	};
	
	timesService.$inject = $inject;
	
	exports['default'] = timesService;
	module.exports = exports['default'];

/***/ }),
/* 1348 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['$document', '$timeout', '$q'];
	
	var toggleService = function toggleService($document, $timeout, $q) {
	  var service = {
	    elements: []
	  };
	
	  $document.bind('mousedown', function (event) {
	    var isClickedElementChildOfPopup = false;
	    var scope = undefined;
	
	    angular.forEach(service.elements, function (element) {
	      if (!isClickedElementChildOfPopup) {
	        isClickedElementChildOfPopup = element[0].contains(event.target);
	      }
	
	      scope = element.pageScope;
	    });
	
	    if (!isClickedElementChildOfPopup) {
	      angular.forEach(service[scope], function (item, key) {
	        service[scope][key] = false;
	      });
	
	      $timeout(function () {
	        service[scope] = service[scope];
	      }, 0);
	    } else {
	      event.preventDefault();
	      event.stopPropagation();
	    }
	  });
	
	  service.subscribe = function subscribe(scope, name, element) {
	    element.pageScope = scope;
	    service.elements.push(element);
	
	    if (!service[scope]) {
	      service[scope] = {};
	    }
	    service[scope][name] = false;
	  };
	
	  service.reset = function reset(scope) {
	    delete service[scope];
	    service.elements = [];
	  };
	
	  service.remove = function reset(scope, key) {
	    if (service[scope]) {
	      delete service[scope][key];
	    }
	  };
	
	  service.toggle = function toggle(scope, name) {
	    var deferred = $q.defer();
	
	    angular.forEach(service[scope], function (item, key) {
	      if (name == key) {
	        service[scope][key] = !service[scope][key];
	      } else {
	        service[scope][key] = false;
	      }
	    });
	
	    deferred.resolve(service[scope][name]);
	
	    return deferred.promise;
	  };
	
	  return service;
	};
	
	toggleService.$inject = $inject;
	
	exports['default'] = toggleService;
	module.exports = exports['default'];

/***/ }),
/* 1349 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['$filter', 'moment', 'settingsService', 'cartService', 'ENUMS', 'dateTimeService'];
	
	var travelFiltersService = function travelFiltersService($filter, moment, settingsService, cartService, ENUMS, dateTimeService) {
	  var service = {};
	
	  var TIME_FORMAT = dateTimeService.getFormat(ENUMS.dateTimeFormats.TIME_LONG);
	
	  service.getFilters = getFilters;
	
	  function getFilters() {
	    return new Filters();
	  }
	
	  function Filters() {
	    this.clean = {
	      filterName: 'travelCleanFilter',
	      settings: {
	        isActive: function isActive() {
	          return true;
	        }
	      }
	    };
	
	    this.cartItems = {
	      label: 'Cart',
	      filterName: 'travelCartItemsFilter',
	      settings: {
	        cartItems: cartService.items,
	        resultsIndex: 0,
	        isActive: function isActive() {
	          return this.cartItems.length;
	        }
	      }
	    };
	
	    this.cheapestFare = {
	      name: 'cheapestFare',
	      filterName: 'cheapestFareFilter',
	      clearActiveFilters: true,
	      settings: {
	        enabled: false,
	        isActive: function isActive() {
	          return this.enabled;
	        }
	      }
	    };
	
	    this.timeRange = {
	      filterName: 'timeOfDayFilter',
	      settings: {
	        reference: 'DepartureTime',
	        start: 0,
	        end: 1440,
	        val: 'All',
	        isActive: function isActive() {
	          return this.start > 0 || this.end < 1440;
	        }
	      }
	    };
	
	    this.priceRange = {
	      label: 'Price',
	      labelSuffix: '(' + settingsService.settings.Currency.Code + ')',
	      filterName: 'travelPriceRangeFilter',
	      isResultsFilter: true,
	      settings: {
	        type: 'range',
	        reference: 'Price',
	        defaultMax: 0,
	        defaultMin: 0,
	        maxValue: 0,
	        minValue: 0,
	        step: 1,
	        translateFunc: function translateFunc(value) {
	          return $filter('currency')(value, '', 0);
	        },
	        isActive: function isActive() {
	          return this.minValue > this.defaultMin || this.maxValue < this.defaultMax;
	        },
	        clear: function clear() {
	          this.minValue = this.defaultMin;
	          this.maxValue = this.defaultMax;
	        }
	      }
	    };
	
	    this.departureTimeRange = {
	      label: 'Departure Time',
	      filterName: 'travelTimeFilter',
	      isResultsFilter: true,
	      settings: {
	        type: 'range',
	        reference: 'DepartureTime',
	        defaultMax: 1439,
	        defaultMin: 0,
	        maxValue: 1439,
	        minValue: 0,
	        step: 5,
	        translateFunc: translateMinutesTime,
	        isActive: function isActive() {
	          return this.minValue > this.defaultMin || this.maxValue < this.defaultMax;
	        },
	        clear: function clear() {
	          this.minValue = this.defaultMin;
	          this.maxValue = this.defaultMax;
	        }
	      }
	    };
	
	    this.arrivalTimeRange = {
	      label: 'Arrival Time',
	      filterName: 'travelTimeFilter',
	      isResultsFilter: true,
	      settings: {
	        type: 'range',
	        reference: 'ArrivalTime',
	        defaultMax: 1439,
	        defaultMin: 0,
	        maxValue: 1439,
	        minValue: 0,
	        step: 5,
	        translateFunc: translateMinutesTime,
	        isActive: function isActive() {
	          return this.minValue > this.defaultMin || this.maxValue < this.defaultMax;
	        },
	        clear: function clear() {
	          this.minValue = this.defaultMin;
	          this.maxValue = this.defaultMax;
	        }
	      }
	    };
	
	    this.carbonFootprintRange = {
	      label: 'Carbon footprint',
	      filterName: 'travelCarbonFootprintRangeFilter',
	      isResultsFilter: true,
	      settings: {
	        type: 'range',
	        reference: 'CarbonEmission',
	        defaultMax: 0,
	        defaultMin: 0,
	        maxValue: 0,
	        minValue: 0,
	        step: 1,
	        isActive: function isActive() {
	          return this.minValue > this.defaultMin || this.maxValue < this.defaultMax;
	        },
	        clear: function clear() {
	          this.minValue = this.defaultMin;
	          this.maxValue = this.defaultMax;
	        }
	      }
	    };
	
	    this.carrier = {
	      label: 'Airlines',
	      filterName: 'anyInCollectionFilter',
	      isResultsFilter: true,
	      settings: {
	        type: 'multiSelect',
	        reference: 'Carrier',
	        selectedReference: 'value',
	        options: [],
	        selected: [],
	        isActive: function isActive() {
	          return this.selected.length > 0;
	        },
	        clear: function clear() {
	          this.selected = [];
	        }
	      }
	    };
	
	    this.stopsOptionList = {
	      label: 'Stops',
	      filterName: 'anyInArrayFilter',
	      isResultsFilter: true,
	      settings: {
	        type: 'checkboxGroup',
	        reference: 'Stops',
	        options: [{
	          value: 0,
	          label: 'Nonstop',
	          id: 'Stops-0'
	        }, {
	          value: 1,
	          label: '1 stop',
	          id: 'Stops-1'
	        }, {
	          value: 2,
	          label: '2 stops',
	          id: 'Stops-2'
	        }, {
	          value: 3,
	          label: '3 stops',
	          id: 'Stops-3'
	        }],
	        selected: [],
	        isActive: function isActive() {
	          return this.selected.length;
	        },
	        clear: function clear() {
	          this.selected = [];
	        }
	      }
	    };
	
	    this.displayFare = {
	      filterName: 'travelDisplayFareFilter',
	      settings: {
	        isActive: function isActive() {
	          return true;
	        }
	      }
	    };
	  }
	
	  function translateMinutesTime(mins) {
	    var hours = Math.floor(mins / 60);
	    var minutes = mins % 60;
	
	    if (hours === 24 && minutes === 0) {
	      hours = 23;
	      minutes = 59;
	    }
	
	    if (minutes < 10) {
	      minutes = '0' + minutes;
	    }
	
	    return moment(hours + ':' + minutes, 'H:mm').format(TIME_FORMAT);
	  }
	
	  return service;
	};
	
	travelFiltersService.$inject = $inject;
	
	exports['default'] = travelFiltersService;
	module.exports = exports['default'];

/***/ }),
/* 1350 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i]; return arr2; } else { return Array.from(arr); } }
	
	var _lodash = __webpack_require__(387);
	
	var $inject = ['$http', '$q', '$filter', '$rootScope', 'apiService', 'cartService', 'settingsService', 'travelFiltersService', 'APP_CONFIG', 'itinerariesService', '$stateParams'];
	
	var travelService = function travelService($http, $q, $filter, $rootScope, apiService, cartService, settingsService, travelFiltersService, APP_CONFIG, itinerariesService, $stateParams) {
	  var service = {
	    resultsMaster: [],
	    results: [],
	    packageResults: [],
	    setPackageResults: function setPackageResults(results) {
	      return service.packageResults = results;
	    },
	    getPackageResults: function getPackageResults() {
	      return service.packageResults;
	    },
	    fareClasses: [],
	    flightMessages: [],
	    hasLoaded: false,
	    hasResults: false,
	    hasPackages: false,
	    hasBackendError: false,
	    policyMessagePopups: [],
	    policyViolations: [],
	    showPackages: localStorage.getItem('showPackages') === 'true',
	    init: init,
	    getResults: getResults,
	    setResults: setResults,
	    getSeatMap: getSeatMap,
	    getSeatmapSearches: getSeatmapSearches,
	    getTravelDetail: getTravelDetail,
	    getFareRules: getFareRules,
	    prepData: prepData,
	    addFilter: addFilter,
	    addFilters: addFilters,
	    updateFilters: updateFilters,
	    removeFilter: removeFilter,
	    process: process,
	    sort: sort,
	    itemAddedToCart: itemAddedToCart,
	    getFareIsOutOfPolicyMsg: getFareIsOutOfPolicyMsg,
	    processAllLinked: processAllLinked,
	    setPolicyMsgViolations: setPolicyMsgViolations,
	    pkgFareClasses: [],
	    pkgSortProcess: pkgSortProcess,
	    pkgSortAsc: true
	  };
	
	  $rootScope.$on('cartService:rail:removed', service.checkFareFilters);
	
	  function init() {
	    service.resultsMaster = [];
	    service.results = [];
	    service.flightMessages = [];
	    service.fareClasses = [];
	    service.hasLoaded = false;
	    service.hasPackages = false;
	    service.hasResults = false;
	    service.showFareCode = settingsService.settings.FlightConfiguration.EnableFareCodeDisplay || false;
	  }
	
	  function getResults(searches, callback) {
	    var searchRequest = _.clone(searches);
	    service.hasBackendError = false;
	    service.hasLoaded = false;
	    service.hasPackages = false;
	    var apiUrl = apiService.getUrl('travel');
	
	    _.forEach(searchRequest, function (search) {
	      search.PaxCount = search.Passengers.length;
	      search.Searches = [{
	        Identifier: search.Identifier,
	        Type: 'Flight'
	      }];
	    });
	
	    $http[apiService.isMockActive('travel') ? 'get' : 'post'](apiUrl, searchRequest, { errorMessage: 'searching for travel' }).success(function (data) {
	      service.flightMessages = data.DisplayMessages;
	      service.policyMessagePopups = data.PolicyMessagePopups;
	      service.policyViolations = data.PolicyViolations;
	      service.packageResults = null;
	      service.hasPackages = false;
	      var trips = data.TravelAvailabilityResponses.map(function (result, resultIndex) {
	        return prepData(result, resultIndex, data.length);
	      });
	
	      if (data.Packages && data.Packages.length) {
	        service.packageResults = pkgPrepData(data, trips);
	        service.hasPackages = true;
	      }
	      _.forEach(trips, function (result, resultIndex) {
	        if (_.isInteger(result.matchingResultsIndex)) {
	          result.matchingResultsIndexes = getMatchingIndexes(resultIndex, result.matchingResultsIndex);
	          result.resultsFilters.filters.cartItems.settings.matchingResultsIndexes = result.matchingResultsIndexes;
	        }
	      });
	
	      service.results = trips;
	      service.resultsMaster = $filter('deepCopyFilter')(service.results);
	      service.hasResults = trips.some(function (trip) {
	        return trip.searchResults.length > 0;
	      });
	      service.hasLoaded = true;
	
	      if (typeof callback === 'function') callback();
	    }).error(function () {
	      service.hasBackendError = true;
	      if (typeof callback === 'function') callback();
	    });
	  }
	
	  function setResults(results) {
	    service.results = results;
	  }
	
	  function getSeatMap(flights) {
	    var deferred = $q.defer();
	    var apiUrl = apiService.getUrl('travelSeatMap');
	
	    $http.post(apiUrl, {
	      SeatMapSearches: flights
	    }).success(function (response) {
	      deferred.resolve(response);
	    }).error(function () {
	      deferred.reject();
	    });
	
	    return deferred.promise;
	  }
	
	  function getFareClassGroupTypes(flight) {
	    var groupTypes = {};
	
	    _.forEach(flight.FareClasses, function (fareClass) {
	      if (fareClass) {
	        if (!groupTypes[fareClass.GroupType]) {
	          groupTypes[fareClass.GroupType] = fareClass.ResBookDesignCode[0];
	        }
	      }
	    });
	
	    return _.isEmpty(groupTypes) ? undefined : groupTypes;
	  }
	
	  function getSeatmapSearch(gdsProvider, from, to, outboundFlight, inboundFlight, parentFlight) {
	    return {
	      OriginLocationCode: from,
	      DestinationLocationCode: to,
	      FlightNumber: outboundFlight.TripNumber,
	      CarrierCode: outboundFlight.Carrier,
	      OperatingCarrierCode: outboundFlight.OperatingCarrier,
	      OperatingCarrierFlightNumber: outboundFlight.OperatingCarrierTripNumber,
	      DepartureDateTimeOffset: outboundFlight.DepartureDateTimeOffset,
	      ArrivalDateTimeOffset: inboundFlight.DepartureDateTimeOffset,
	      GdsProvider: gdsProvider,
	      FareClassGroupTypes: getFareClassGroupTypes(parentFlight)
	    };
	  }
	
	  function getSeatmapSearches(flight) {
	    var searches = [];
	
	    if (flight.Legs.length === 0) {
	      searches.push(getSeatmapSearch(flight.GdsProvider, flight.OriginLocationCode, flight.DestinationLocationCode, flight, flight, flight));
	    } else {
	      searches.push(getSeatmapSearch(flight.GdsProvider, flight.OriginLocationCode, flight.Legs[0].Origin.Code, flight, flight.Legs[0], flight));
	
	      _.forEach(flight.Legs, function (leg, legIndex) {
	        if (legIndex === flight.Legs.length - 1) {
	          searches.push(getSeatmapSearch(flight.GdsProvider, leg.Origin.Code, flight.DestinationLocationCode, leg, flight, flight));
	        } else {
	          searches.push(getSeatmapSearch(flight.GdsProvider, leg.Origin.Code, flight.Legs[legIndex + 1].Origin.Code, leg, flight.Legs[legIndex + 1], flight));
	        }
	      });
	    }
	
	    return searches;
	  }
	
	  function getTravelDetail(travel) {
	    var deferred = $q.defer();
	
	    if (travel.Details.length) {
	      deferred.resolve(travel.Details);
	    } else {
	      var apiUrl = apiService.getUrl('travelDetail', {
	        type: travel.Type,
	        travelId: travel.Identifier
	      });
	
	      var params = {
	        searchIdentifier: travel.SearchIdentifier
	      };
	
	      $http.get(apiUrl, { params: params }).success(function (data) {
	        travel.Details = data;
	        deferred.resolve(travel.Details);
	      }).error(function () {
	        deferred.reject();
	      });
	    }
	
	    return deferred.promise;
	  }
	
	  function getFareRules(sector, fare) {
	    var deferred = $q.defer();
	
	    if (fare.RemarksCollection) {
	      var fareRuleData = function fareRuleData() {
	        var text = '';
	        _.forEach(fare.RemarksCollection, function (obj) {
	          text = text + obj.Code + '\n' + obj.Value + '\n\n';
	        });
	        return text;
	      };
	
	      var fareRules = {
	        Type: 'Text',
	        Data: fareRuleData()
	      };
	
	      deferred.resolve(fareRules);
	    } else {
	      var apiUrl = apiService.getUrl('travelFareRules', {
	        type: sector.Type,
	        travelId: sector.Identifier,
	        fareId: fare.Identifier
	      });
	
	      var params = {
	        searchIdentifier: sector.SearchIdentifier
	      };
	
	      $http.get(apiUrl, { params: params }).success(function (data) {
	        deferred.resolve(data);
	      }).error(function () {
	        deferred.reject();
	      });
	    }
	
	    return deferred.promise;
	  }
	
	  function formatBundle(bundle, baseFare, index) {
	    var bundleItems = bundle.Description.split(/\s*and\s*|,\s*/);
	    var formattedBundle = {
	      id: index,
	      brandedFareName: baseFare.FareName,
	      items: bundleItems,
	      price: bundle.Price,
	      currencyCode: bundle.CurrencyCode,
	      selected: false
	    };
	    return formattedBundle;
	  }
	
	  function prepData(data, index, totalSets) {
	    var obj = {
	      selected: false,
	      index: index,
	      matchingResultsIndex: data.MatchingResultsIndex,
	      searchDate: data.Date,
	      destination: data.Destination,
	      origin: data.Origin,
	      searchResults: data.Results,
	      classes: [],
	      economyClasses: [],
	      activeSort: null,
	      resultLimitIncrement: 20,
	      resultLimit: getResultLimit(totalSets),
	      resultsFilters: {
	        filters: travelFiltersService.getFilters(),
	        searchFilterTotal: 0
	      }
	    };
	    _.forEach(data.Results, function (item) {
	      var fareClasses = item.FareClasses;
	
	      item.$state = {};
	      item.TotalFares = 0;
	      item.SupplierName = item.SupplierName || item.CarrierName;
	      item.ReturnPricing = _.isInteger(obj.matchingResultsIndex);
	
	      // TODO move to a filter
	      if (item.Rating) {
	        item.Rating.OnTimeLevel = item.Rating.OntimePercent < 0.7 ? 'low' : item.Rating.OntimePercent < 0.9 ? 'mid' : 'high';
	      }
	
	      angular.forEach(fareClasses, function (fare, key) {
	        if (fare === null) {
	          return delete fareClasses[key];
	        }
	
	        fare.$state = {};
	        fare.Class = key;
	
	        var defaultFare = _.omit(fare, 'AdditionalFares');
	
	        if (APP_CONFIG.bundles.enabled) {
	          defaultFare.Bundles = _.map(fare.Bundles, function (bundle, index) {
	            return formatBundle(bundle, fare, index);
	          });
	        }
	
	        fare.AdditionalFares.unshift(defaultFare);
	
	        fare.AdditionalFares = _.map(fare.AdditionalFares, function (additionalFare) {
	          additionalFare.$state = {};
	          additionalFare.FareCode = additionalFare.FareCode ? additionalFare.FareCode.trim() : '';
	          additionalFare.FareCodeDescription = additionalFare.FareCode ? '(' + additionalFare.FareCode + ')' : '';
	          additionalFare.MatchingResultsIndex = data.MatchingResultsIndex;
	          additionalFare.Class = key;
	          additionalFare.Bundles = APP_CONFIG.bundles.enabled ? _.map(additionalFare.Bundles, function (bundle, index) {
	            return bundle.items != null ? bundle : formatBundle(bundle, additionalFare, index);
	          }) : [];
	
	          return additionalFare;
	        });
	
	        if (fare.GroupType === 'Economy') {
	          if (!obj.economyClasses.includes(fare.Class)) {
	            obj.economyClasses.push(fare.Class);
	          }
	        }
	
	        item.TotalFares += fare.AdditionalFares.length;
	      });
	
	      obj.classes = obj.classes.concat(Object.keys(fareClasses));
	
	      var priceFilterSettings = obj.resultsFilters.filters.priceRange.settings;
	
	      if (item.MaxRate > priceFilterSettings.maxValue) {
	        var roundedMaxRate = Math.ceil(item.MaxRate);
	        priceFilterSettings.maxValue = roundedMaxRate;
	        priceFilterSettings.defaultMax = roundedMaxRate;
	      }
	
	      item.TripDays = calculateDayChanges(item.DepartureDateTime, item.ArrivalDateTime);
	    });
	
	    obj.resultsFilters.filters.carrier.settings.options = getCarrierOptions(data.Results);
	
	    var maxRate = getMaxRate(data.Results);
	    obj.resultsFilters.filters.priceRange.settings.defaultMax = maxRate;
	    obj.resultsFilters.filters.priceRange.settings.maxValue = maxRate;
	
	    var maxCarbonEmission = getMaxCarbonEmission(data.Results);
	    obj.resultsFilters.filters.carbonFootprintRange.settings.defaultMax = maxCarbonEmission;
	    obj.resultsFilters.filters.carbonFootprintRange.settings.maxValue = maxCarbonEmission;
	    obj.resultsFilters.filters.cartItems.settings.resultsIndex = index;
	    obj.resultsFilters.filters.cartItems.settings.matchingResultsIndex = data.MatchingResultsIndex;
	
	    // countFilteredResults(obj);
	
	    buildFareClasses(obj.classes);
	
	    obj.classes = service.fareClasses;
	    OrderSelectedItems(data, index);
	    return obj;
	  }
	
	  function calculateDayChanges(departureDateTime, arrivalDateTime) {
	    var depart = new Date(departureDateTime);
	    var arrive = new Date(arrivalDateTime);
	    if (isNaN(depart.getTime()) || isNaN(arrive.getTime())) return 0;
	
	    var departDate = new Date(depart.getFullYear(), depart.getMonth(), depart.getDate());
	    var arriveDate = new Date(arrive.getFullYear(), arrive.getMonth(), arrive.getDate());
	
	    var diff = arriveDate.getTime() - departDate.getTime();
	    return Math.floor(diff / (1000 * 60 * 60 * 24));
	  }
	
	  function OrderSelectedItems(data, index) {
	    if (!($stateParams.selectedItems && $stateParams.selectedItems.length > 0 && data && data.Results)) return;
	    for (var i = 0; i < $stateParams.selectedItems.length; i++) {
	      for (var r = 0; r < data.Results.length; r++) {
	        if ($stateParams.selectedItems[i] && data.Results[r].TripIdentifier === $stateParams.selectedItems[i].TripIdentifier) {
	          data.Results.splice(0, 0, data.Results.splice(r, 1)[0]);
	          $stateParams.selectedItems[i].SearchIdentifier = data.Results[r].SearchIdentifier;
	          $stateParams.selectedItems[i].SearchIndex = index;
	          return;
	        }
	      }
	    }
	  }
	
	  function getResultLimit(totalSets) {
	    var MAX_TOTAL = 100;
	
	    return totalSets === 3 ? 30 : MAX_TOTAL / totalSets;
	  }
	
	  function getMaxRate(results) {
	    return _.reduce(results, function (maxRate, result) {
	      return Math.ceil(result.MaxRate > maxRate ? result.MaxRate : maxRate);
	    }, 0);
	  }
	
	  function getMaxCarbonEmission(results) {
	    return _.reduce(results, function (minCarbonEmission, result) {
	      return Math.ceil(result.MinCarbonEmission > minCarbonEmission ? result.MinCarbonEmission : minCarbonEmission);
	    }, 0);
	  }
	
	  function getCarrierOptions(results) {
	    var uniqueResults = _.uniqBy(results, function (item) {
	      return item.Carrier;
	    });
	
	    var orderedResults = _.orderBy(uniqueResults, function (item) {
	      return item.CarrierName.toLowerCase();
	    });
	
	    return _.map(orderedResults, function (item) {
	      return {
	        value: item.Carrier,
	        label: item.CarrierName,
	        id: 'Carrier-' + item.Carrier
	      };
	    });
	  }
	
	  function orderFareClasses(fareClasses) {
	    var fareBucketClasses = settingsService.settings.FlightConfiguration.FareBucketClasses;
	
	    if (!fareBucketClasses) {
	      return fareClasses;
	    }
	
	    return _.orderBy(fareClasses, function (fareClass) {
	      var fareBucketClassSettings = _.find(fareBucketClasses, function (bucketClass) {
	        return bucketClass.Name === fareClass;
	      });
	
	      return fareBucketClassSettings ? fareBucketClassSettings.Sort : Number.MAX_SAFE_INTEGER;
	    });
	  }
	
	  function buildFareClasses(classes) {
	    service.fareClasses = service.fareClasses.concat(classes);
	    service.fareClasses = _.uniq(service.fareClasses);
	    service.fareClasses = orderFareClasses(service.fareClasses);
	
	    angular.forEach(service.results, function (result) {
	      result.classes = service.fareClasses;
	    });
	  }
	
	  function addFilters(filters, index, clear) {
	    if (clear) {
	      service.results[index].resultsFilters.filters = {};
	    }
	
	    _.forOwn(filters, function (filter, key) {
	      service.results[index].resultsFilters.filters[key] = filter;
	    });
	
	    process(index);
	  }
	
	  function updateFilters(filters, index, clear) {
	    if (clear) {
	      service.results[index].resultsFilters.filters = {};
	    }
	
	    _.forOwn(filters, function (filter, key) {
	      service.results[index].resultsFilters.filters[key] = filter;
	    });
	
	    process(index);
	  }
	
	  function clearFilters(index) {
	    service.results[index].selected = false;
	
	    _.forOwn(service.results[index].resultsFilters.filters, function (filter) {
	      if (_.isFunction(filter.settings.clear)) {
	        filter.settings.clear();
	      }
	    });
	  }
	
	  function addFilter(filter, index, clear) {
	    if (clear) {
	      clearFilters(index);
	    }
	
	    if (filter) {
	      service.results[index].resultsFilters.filters[filter.name] = filter;
	    }
	
	    process(index);
	  }
	
	  function removeFilter(filterName, index) {
	    delete service.results[index].resultsFilters.filters[filterName];
	
	    process(index);
	  }
	
	  function sort(sortOption, index) {
	    service.results[index].activeSort = sortOption;
	    process(index);
	  }
	
	  function getMatchingIndexes(currentIndex, matchingIndex) {
	    var resultsSet = service.results[matchingIndex];
	    var indexes = [matchingIndex];
	
	    if (service.results.length > 2) {
	      service.results.forEach(function (item, i) {
	        if ((item.matchingResultsIndex == matchingIndex || item.matchingResultsIndex == currentIndex || item.orderBy == resultsSet.matchingResultsIndex) && i !== currentIndex && indexes.indexOf(i) === -1) {
	          indexes.push(i);
	        }
	      });
	    }
	    return indexes;
	  }
	
	  function processAllLinked(currentIndex, matchingIndex) {
	    getMatchingIndexes(currentIndex, matchingIndex).forEach(function (ind) {
	      process(ind);
	    });
	  }
	
	  function process(index) {
	    var resultsSet = service.results[index];
	    var processedResults = _.clone(service.resultsMaster[index].searchResults);
	    var clearActiveFilters = false;
	
	    resultsSet.resultsFilters.searchFilterTotal = 0;
	    Object.values(resultsSet.resultsFilters.filters).forEach(function (filter) {
	      if (!filter.settings.isActive()) return;
	      var clearActiveFilters = filter.clearActiveFilters && typeof filter.settings.clear === 'function';
	      if (filter.isResultsFilter) resultsSet.resultsFilters.searchFilterTotal++;
	      processedResults = clearActiveFilters ? filter.settings.clear() : $filter(filter.filterName)(processedResults, filter.settings);
	    });
	
	    if (resultsSet.activeSort) {
	      // custom sorting needed for carbon emissions, so > 0 and non null list in ascending order first
	      // == 0 and null display last
	      if (resultsSet.activeSort.sortField === 'MinCarbonEmission') {
	        resultsSet.searchResults = processedResults.sort(sortCarbonEmissions());
	        return;
	      }
	
	      processedResults = _.orderBy(processedResults, function (result) {
	        return result[resultsSet.activeSort.sortField];
	      });
	
	      if (resultsSet.activeSort.isReverse) {
	        processedResults = processedResults.reverse();
	      }
	    }
	
	    resultsSet.searchResults = processedResults;
	  }
	
	  function sortCarbonEmissions() {
	    return function (a, b) {
	      if (a.MinCarbonEmission === null) return 1; // return 1 so that b goes first
	      if (b.MinCarbonEmission === null) return -1; // return -1 so that a goes first
	      if (a.MinCarbonEmission === 0) return 1; // return 1 so that b goes first
	      if (b.MinCarbonEmission === 0) return -1; // return -1 so that a goes first
	
	      // return -1 so that a goes first, as it is < b, otherwise return 1 so b goes first
	      return a.MinCarbonEmission < b.MinCarbonEmission ? -1 : 1;
	    };
	  }
	
	  function itemAddedToCart(parentIndex, row, item) {
	    var resultsSet = service.results[parentIndex];
	    resultsSet.selected = true;
	    setAnchoredFlight(row, item);
	
	    var selectedFare = {
	      type: 'flight',
	      fare: item,
	      selectedBundle: item.Bundles.filter(function (bundle) {
	        return bundle.selected === true;
	      })[0],
	      result: row,
	      orderBy: parentIndex,
	      matchingIndex: resultsSet.matchingResultsIndex,
	      matchingIndexes: resultsSet.matchingResultsIndexes
	    };
	
	    if (cartService.items.filter(function (item) {
	      return item.orderBy === parentIndex;
	    }).length > 0) {
	      for (var i = 0; i < cartService.items.length; i++) {
	        if (cartService.items[i].orderBy === parentIndex) {
	          cartService.items[i] = selectedFare;
	          break;
	        }
	      }
	    } else {
	      // lbCartPanel.js will detect this push via $scope.$watchCollection(vm.cartService.items).
	      cartService.items.push(selectedFare);
	    }
	    var matchingCartItems = cartService.items.filter(function (item) {
	      return item.orderBy !== parentIndex && (item.orderBy === resultsSet.matchingResultsIndex || resultsSet.matchingResultsIndexes && resultsSet.matchingResultsIndexes.indexOf(item.orderBy) !== -1);
	    });
	    if (matchingCartItems) {
	      matchingCartItems.forEach(function (matchingCartItem) {
	        var matchingFare = _.find(matchingCartItem.fare.MatchedFares, function (fare) {
	          return fare.Identifier === selectedFare.fare.Identifier;
	        });
	        if (!matchingFare) {
	          var additionalFares = matchingCartItem.result.FareClasses[matchingCartItem.fare.Class].AdditionalFares;
	          for (var i = 0; i < additionalFares.length; i++) {
	            var subFare = additionalFares[i].MatchedFares.find(function (matchedFare) {
	              return selectedFare.fare.Identifier === matchedFare.Identifier;
	            });
	            if (subFare) {
	              var policyException = matchingCartItem.fare.PolicyException;
	              matchingCartItem.fare = additionalFares[i];
	              matchingCartItem.fare.PolicyException = policyException;
	            }
	          }
	        }
	      });
	    }
	
	    process(parentIndex);
	    if (_.isInteger(resultsSet.matchingResultsIndex)) {
	      processAllLinked(parentIndex, resultsSet.matchingResultsIndex);
	    }
	  }
	
	  function setAnchoredFlight(flightResult, fare) {
	    var anchoredFlight = flightResult.Identifier;
	    var searchIdentifier = flightResult.SearchIdentifier;
	    itinerariesService.itinerary.Search.Flights.forEach(function (flight) {
	      var searchItem = flight.Searches.find(function (s) {
	        return s.Identifier == searchIdentifier;
	      });
	      if (searchItem) {
	        flight.anchoredFlight = anchoredFlight;
	        flight.anchoredFare = fare;
	        flight.anchoredTripIdentifier = { TripIdentifier: flightResult.TripIdentifier, Fare: fare, Flight: flightResult };
	      }
	    });
	  }
	
	  function getFareIsOutOfPolicyMsg(fare) {
	    var msg = '';
	    var separator = '<br/>';
	    if (!(fare && fare.PolicyExceptionDetails)) return msg;
	
	    if (fare.PolicyExceptionDetails.InPolicy === false) {
	      if (fare.PolicyExceptionDetails.PolicyMessage) {
	        msg += (msg != '' ? separator : '') + fare.PolicyExceptionDetails.PolicyMessage;
	      } else {
	        msg += (msg != '' ? separator : '') + 'Out of Policy: Lost Savings';
	      }
	    }
	    if (fare.PolicyExceptionDetails.PolicyViolations && fare.PolicyExceptionDetails.PolicyViolations.length > 0) {
	      service.setPolicyMsgViolations(fare.PolicyExceptionDetails);
	      msg += (msg != '' ? separator : '') + fare.PolicyExceptionDetails.PolicyViolations.map(function (policy) {
	        return policy.ViolationMessage ? policy.ViolationMessage : 'Out of Policy';
	      }).join(separator);
	    }
	    return msg;
	  }
	
	  function setPolicyMsgViolations(policyExceptionDetails) {
	    if (service.policyViolations && service.policyViolations.length && policyExceptionDetails && policyExceptionDetails.PolicyViolations && policyExceptionDetails.PolicyViolations.length) {
	      (function () {
	        var items = [];
	        policyExceptionDetails.PolicyViolations.forEach(function (item) {
	          var lookupUp = service.policyViolations.find(function (f) {
	            return f.id === item.id;
	          });
	          if (lookupUp) {
	            items.push(lookupUp);
	          } else {
	            items.push(item);
	          }
	        });
	        policyExceptionDetails.PolicyViolations = items;
	      })();
	    }
	
	    if (service.policyMessagePopups && service.policyMessagePopups.length && policyExceptionDetails && policyExceptionDetails.PolicyMessagePopups && policyExceptionDetails.PolicyMessagePopups.length) {
	      (function () {
	        var items = [];
	        policyExceptionDetails.PolicyMessagePopups.forEach(function (item) {
	          var lookupUp = service.policyMessagePopups.find(function (f) {
	            return f.id === item.id;
	          });
	          if (lookupUp) {
	            items.push(lookupUp);
	          } else {
	            items.push(item);
	          }
	        });
	        policyExceptionDetails.PolicyMessagePopups = items;
	      })();
	    }
	  }
	
	  function findFare(fareIdentifier, trips) {
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	      for (var _iterator = trips[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	        var trip = _step.value;
	        var _iteratorNormalCompletion2 = true;
	        var _didIteratorError2 = false;
	        var _iteratorError2 = undefined;
	
	        try {
	          for (var _iterator2 = trip.searchResults[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	            var result = _step2.value;
	
	            var foundFare = Object.values(result.FareClasses).find(function (fare) {
	              if (fare.Identifier === fareIdentifier) return fare;
	              return fare.AdditionalFares.find(function (af) {
	                if (af.Identifier === fareIdentifier) return af;
	              });
	            });
	            if (foundFare) return foundFare;
	          }
	        } catch (err) {
	          _didIteratorError2 = true;
	          _iteratorError2 = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion2 && _iterator2['return']) {
	              _iterator2['return']();
	            }
	          } finally {
	            if (_didIteratorError2) {
	              throw _iteratorError2;
	            }
	          }
	        }
	      }
	    } catch (err) {
	      _didIteratorError = true;
	      _iteratorError = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion && _iterator['return']) {
	          _iterator['return']();
	        }
	      } finally {
	        if (_didIteratorError) {
	          throw _iteratorError;
	        }
	      }
	    }
	
	    return {};
	  }
	
	  function pkgPrepData(data, trips) {
	    service.hasPackages = true;
	    service.pkgFareClasses = [].concat(_toConsumableArray(new Set(data.Packages.flatMap(function (pkg) {
	      return Object.keys(pkg.FareClasses);
	    }))));
	
	    var order = settingsService.settings.FlightConfiguration.FareBucketClasses;
	    order.sort(function (a, b) {
	      return a.Sort - b.Sort;
	    });
	    service.pkgFareClasses = order.filter(function (item) {
	      return service.pkgFareClasses.includes(item.Name);
	    }).map(function (item) {
	      return item.Name;
	    });
	
	    var packages = data.Packages.map(function (pkg, i) {
	      var _loop = function (fc) {
	        var fareClass = pkg.FareClasses[fc];
	        fareClass.Details.PackageFares = fareClass.FareIdentifiers.map(function (f) {
	          return findFare(f, trips);
	        });
	        fareClass.Fares = [fareClass.Details];
	        fareClass.AdditionalFares.forEach(function (af) {
	          af.Details.PackageFares = af.FareIdentifiers.map(function (f) {
	            return findFare(f, trips);
	          });
	          fareClass.Fares.push(af.Details);
	        });
	        fareClass.Fares.forEach(function (fare) {
	          return fare.visible = true;
	        });
	        fareClass.Fares.sort(function (a, b) {
	          return a.Amount - b.Amount;
	        });
	        fareClass.DisplayFare = fareClass.Fares[0];
	        fareClass.visible = true;
	      };
	
	      for (var fc in pkg.FareClasses) {
	        _loop(fc);
	      }
	
	      pkg.FareClasses.$state = {};
	
	      var packageFares = service.pkgFareClasses.reduce(function (fares, fareClass) {
	        fares[fareClass] = pkg.FareClasses[fareClass] || null;
	        return fares;
	      }, {});
	
	      var cleanPackage = {
	        FareClasses: packageFares,
	        Segments: [],
	        visible: true,
	        cheapest: false,
	        defaultSort: i,
	        id: Date.now().toString(36) + Math.random().toString(36).substr(2, 5)
	      };
	
	      pkg.Segments.forEach(function (segment) {
	        var resultTrip = data.TravelAvailabilityResponses.find(function (trip) {
	          return trip.Identifier === segment.TripIdentifier;
	        });
	        if (!resultTrip) return;
	
	        var cleanSegment = {
	          origin: resultTrip.Origin,
	          destination: resultTrip.Destination,
	          identifier: resultTrip.Identifier,
	          visible: true
	        };
	
	        var resultFlight = pkgFindFlight(segment.FlightIdentifier, resultTrip.Results);
	        if (!resultFlight) return;
	
	        resultFlight.TripDays = calculateDayChanges(resultFlight.DepartureDateTime, resultFlight.ArrivalDateTime);
	
	        cleanSegment.flight = pkgPrepFlight(resultFlight);
	        cleanPackage.Segments.push(cleanSegment);
	      });
	      return cleanPackage;
	    });
	
	    pkgMarkCheapest(packages);
	    pkgMarkPreferred(packages);
	
	    service.packageResultsMaster = packages;
	
	    return packages;
	  }
	
	  function pkgMarkPreferred(packages) {
	    packages.forEach(function (pkg) {
	      return pkg.preferred = pkg.Segments.some(function (segment) {
	        return segment.flight.Preferred;
	      });
	    });
	  }
	
	  function pkgMarkCheapest(packages) {
	    var distinctCarriers = new Set();
	    packages.forEach(function (pkg) {
	      return pkg.Segments.forEach(function (segment) {
	        return distinctCarriers.add(segment.flight.Carrier);
	      });
	    });
	    var carriers = [].concat(_toConsumableArray(distinctCarriers));
	    var cheapestFares = {};
	    packages.forEach(function (pkg) {
	      pkg.Segments.forEach(function (segment) {
	        var Carrier = segment.flight.Carrier;
	
	        if (carriers.includes(Carrier)) {
	          Object.entries(pkg.FareClasses).filter(function (_ref) {
	            var _ref2 = _slicedToArray(_ref, 2);
	
	            var fareClassName = _ref2[0];
	            var fareClass = _ref2[1];
	            return fareClass;
	          }).forEach(function (_ref3) {
	            var _ref32 = _slicedToArray(_ref3, 2);
	
	            var fareClassName = _ref32[0];
	            var fareClass = _ref32[1];
	            var Amount = fareClass.Details.Amount;
	
	            if (!cheapestFares[Carrier] || Amount < cheapestFares[Carrier].Amount) {
	              cheapestFares[Carrier] = { fareClassName: fareClassName, Amount: Amount };
	              pkg.cheapest = true;
	              fareClass.Details.cheapest = true;
	            }
	          });
	        }
	      });
	    });
	  }
	
	  function pkgPrepFlight(flight) {
	    var equiptmentTypeArray = flight.AircraftName.split('/');
	    if (flight.Details && flight.Details.length === equiptmentTypeArray.length) {
	      for (var i = 0; i < flight.Details.length; i++) {
	        if (!flight.Details[i].EquipmentType) flight.Details[i].EquipmentType = equiptmentTypeArray[i];
	      }
	    }
	
	    return flight;
	  }
	
	  function pkgFindFlight(flightIdentifier, flights) {
	    return flights.find(function (flight) {
	      return flight.Identifier === flightIdentifier;
	    });
	  }
	
	  function pkgSortProcess(data) {
	    if (!data.property) return;
	
	    var getPropertySum = function getPropertySum(pkg, property) {
	      if (property === 'Amount') {
	        var cleanedFareClasses = Object.values(pkg.FareClasses).filter(function (fc) {
	          return fc !== null;
	        });
	        return Math.min.apply(Math, _toConsumableArray(cleanedFareClasses.map(function (fc) {
	          return fc.Details.Amount;
	        })));
	      } else if (property === 'defaultSort') {
	        return pkg[property];
	      } else {
	        return pkg.Segments.reduce(function (sum, sgmt) {
	          return sum + sgmt.flight[property];
	        }, 0);
	      }
	    };
	
	    service.packageResults.sort(function (a, b) {
	      var aSum = getPropertySum(a, data.property);
	      var bSum = getPropertySum(b, data.property);
	      return service.pkgSortAsc ? aSum - bSum : bSum - aSum;
	    });
	
	    service.pkgSortAsc = !service.pkgSortAsc;
	  }
	
	  return service;
	};
	
	travelService.$inject = $inject;
	
	exports['default'] = travelService;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(205)))

/***/ }),
/* 1351 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['$http', '$q', 'APP_CONFIG'];
	
	var unusedCreditsService = function unusedCreditsService($http, $q, APP_CONFIG) {
	  var service = {
	    get: get,
	    set: set,
	    getTravellerSectorsGrouped: getTravellerSectorsGrouped,
	    getAllTravellerSectorsGrouped: getAllTravellerSectorsGrouped,
	    findGroupIdsFoundInEverySector: findGroupIdsFoundInEverySector,
	    getAllTravellerAllSectorsGrouped: getAllTravellerAllSectorsGrouped,
	    addUnusedCredit: addUnusedCredit,
	    populateEachPaxWithSelectedUnusedCredits: populateEachPaxWithSelectedUnusedCredits,
	    doGroupIdsMatchToInvoiceUnusedCredit: doGroupIdsMatchToInvoiceUnusedCredit,
	    checkAllPaxPaymentsSelected: checkAllPaxPaymentsSelected,
	    purgeDuplicateUnusedCredits: purgeDuplicateUnusedCredits,
	    checkForCVV: checkForCVV,
	    addCVVsToPayments: addCVVsToPayments,
	    updatedPaxWithPayments: undefined,
	    unusedCredits: [],
	    activeGroupedSectors: [],
	    activeAllSectors: [],
	    activeSelectedAllPayment: undefined,
	    overrideSectorPaymentChoice: {},
	    selectedUnusedCredits: {}
	  };
	
	  function get(itineraryId) {
	    var deferred = $q.defer();
	
	    $http.get(APP_CONFIG.api.root + ('api/Itinerary/' + itineraryId + '/UnusedCredit'), {}).success(function (data) {
	      deferred.resolve(data);
	    }).error(function () {
	      deferred.reject();
	    });
	
	    return deferred.promise;
	  }
	
	  function set(data) {
	    service.unusedCredits = data;
	  }
	
	  function getTravellerSectorsGrouped(traveller) {
	    return _.flowRight(createGroupDescriptions, createPaymentOptionsArray, createSectorGrpArray, createSectorArray)(traveller);
	  }
	
	  function getAllTravellerSectorsGrouped(travellers) {
	    var sectors = [];
	
	    _.forEach(travellers, function (traveller) {
	      sectors.push(createSectorArray(traveller));
	    });
	
	    sectors = _.flatten(sectors);
	
	    return _.flowRight(checkUnusedCreditsIncludeEveryGroupId, combineGroupIds, groupSectorTypes, createGroupDescriptions, createPaymentOptionsArray, createSectorGrpArray)(sectors);
	  }
	
	  function createSectorArray(traveller) {
	    var sectors = [];
	
	    if (traveller.Flights.length > 0) {
	      sectors.push({
	        sectorType: 'flights',
	        sectors: traveller.Flights
	      });
	    }
	
	    if (traveller.Hotels.length > 0) {
	      sectors.push({
	        sectorType: 'hotels',
	        sectors: traveller.Hotels
	      });
	    }
	
	    if (traveller.Cars.length > 0) {
	      sectors.push({
	        sectorType: 'cars',
	        sectors: traveller.Cars
	      });
	    }
	
	    if (traveller.Rails.length > 0) {
	      sectors.push({
	        sectorType: 'rails',
	        sectors: traveller.Rails
	      });
	    }
	
	    return sectors;
	  }
	
	  function createSectorGrpArray(sectors) {
	    return _.map(sectors, function (sectorType) {
	      sectorType.groups = [];
	
	      _.forEach(sectorType.sectors, function (sector) {
	        var group = _.find(sectorType.groups, function (group) {
	          return group.groupId === sector.GroupIdentifier;
	        });
	
	        if (!group) {
	          sectorType.groups.push({
	            groupId: sector.GroupIdentifier,
	            sectors: [sector]
	          });
	        } else {
	          group.sectors.push(sector);
	        }
	      });
	
	      return sectorType;
	    });
	  }
	
	  function createPaymentOptionsArray(groupedSectors) {
	    var unusedCredits = service.unusedCredits;
	
	    return _.map(groupedSectors, function (sectorType) {
	      _.forEach(sectorType.groups, function (group) {
	        group.paymentOptions = _.filter(unusedCredits, function (unusedCredit) {
	          return unusedCredit.SectorGroups.indexOf(group.groupId) > -1;
	        });
	      });
	
	      return sectorType;
	    });
	  }
	
	  function createGroupDescriptions(groupedSectors) {
	    return _.map(groupedSectors, function (sectorGroup) {
	      _.forEach(sectorGroup.groups, function (group) {
	        var descriptions = [];
	
	        if (sectorGroup.sectorType === 'flights') {
	          _.forEach(group.sectors, function (sector) {
	            descriptions.push(sector.Carrier + ' ' + sector.FlightNumber);
	          });
	        }
	
	        if (sectorGroup.sectorType === 'hotels') {
	          _.forEach(group.sectors, function (sector) {
	            descriptions.push('' + sector.HotelName);
	          });
	        }
	
	        group.groupDescriptions = descriptions.join(', ');
	      });
	
	      return sectorGroup;
	    });
	  }
	
	  function findGroupIdsFoundInEverySector(sectors) {
	    var allGroupIdsInSectors = [];
	    var unusedCreditsFoundInAllActiveGroupIds = [];
	
	    _.forEach(sectors, function (sector) {
	      _.forEach(sector.groups, function (group) {
	        allGroupIdsInSectors.push(group.groupId);
	      });
	    });
	
	    allGroupIdsInSectors = _.uniq(allGroupIdsInSectors);
	
	    _.forEach(service.unusedCredits, function (unusedCredit) {
	      var intersection = _.intersection(allGroupIdsInSectors, unusedCredit.SectorGroups);
	
	      if (intersection.length === allGroupIdsInSectors.length) {
	        unusedCreditsFoundInAllActiveGroupIds.push(unusedCredit);
	      }
	    });
	
	    return unusedCreditsFoundInAllActiveGroupIds;
	  }
	
	  function addUnusedCredit(newUnusedCredit) {
	    var allGroupIds = [];
	
	    _.forEach(service.unusedCredits, function (unusedCredit) {
	      if (unusedCredit.Payment.PaymentType != 'Invoice') {
	        allGroupIds.push(unusedCredit.SectorGroups);
	      }
	    });
	
	    var groupIds = _.flowRight(_.uniq, _.flatten)(allGroupIds);
	
	    var newPaymentObj = {
	      Payment: {
	        ExpiryMonth: newUnusedCredit.cardExpiryMonth,
	        ExpiryYear: newUnusedCredit.cardExpiryYear,
	        Holder: newUnusedCredit.cardHolder,
	        Number: newUnusedCredit.cardNumber,
	        PaymentType: 'Card',
	        Reference: null,
	        SecurityCode: null,
	        SecurityCodeRequired: true,
	        Type: {
	          Code: newUnusedCredit.Card.Type.Code,
	          Value: newUnusedCredit.Card.Type.Code
	        }
	      },
	      SectorGroups: groupIds
	    };
	
	    service.unusedCredits.push(newPaymentObj);
	    service.activeAllSectors.push(newPaymentObj);
	    service.activeSelectedAllPayment = newPaymentObj;
	  }
	
	  function groupSectorTypes(sectorGroups) {
	    var sectorsByGroup = {
	      flights: [],
	      rails: [],
	      hotels: [],
	      cars: []
	    };
	
	    _.forEach(sectorGroups, function (sectorGroup) {
	      sectorsByGroup[sectorGroup.sectorType].push(sectorGroup);
	    });
	
	    return sectorsByGroup;
	  }
	
	  function combineGroupIds(sectorsByGroup) {
	    var groupIDsBySectorType = {};
	
	    _.forEach(sectorsByGroup, function (sectors, sectorType) {
	      if (sectors.length > 0) {
	        groupIDsBySectorType[sectorType] = [];
	        _.forEach(sectors, function (sector) {
	          _.forEach(sector.groups, function (group) {
	            groupIDsBySectorType[sectorType].push(group.groupId);
	          });
	        });
	      }
	    });
	
	    return groupIDsBySectorType;
	  }
	
	  function checkUnusedCreditsIncludeEveryGroupId(groupIDsBySectorType) {
	    // forgive me
	    var paymentsAvailableToEachSectorType = {};
	
	    _.forEach(groupIDsBySectorType, function (sectorGroupIds, sectorType) {
	      paymentsAvailableToEachSectorType[sectorType] = [];
	
	      _.forEach(service.unusedCredits, function (unusedCredit) {
	        var existsInAll = sectorGroupIds.every(function (v, i) {
	          return unusedCredit.SectorGroups.indexOf(v) !== -1;
	        });
	
	        if (existsInAll) {
	          paymentsAvailableToEachSectorType[sectorType].push(unusedCredit);
	        }
	      });
	    });
	
	    return paymentsAvailableToEachSectorType;
	  }
	
	  function getAllTravellerAllSectorsGrouped(groupedSectorPayments) {
	    return _.flowRight(findUnusedCreditByGroupIds, findGroupIdsFoundInEverySectorGroup)(groupedSectorPayments);
	  }
	
	  function findGroupIdsFoundInEverySectorGroup(groupedSectorPayments) {
	    var groupIds = [];
	
	    _.forIn(groupedSectorPayments, function (sectorPaymentGroup) {
	      _.forEach(sectorPaymentGroup, function (sectorPayment) {
	        groupIds.push(sectorPayment.SectorGroups);
	      });
	    });
	
	    return _.uniq(_.flatten(groupIds));
	  }
	
	  function findUnusedCreditByGroupIds(groupIds) {
	    var matchedPayments = [];
	
	    _.forEach(service.unusedCredits, function (unusedCredit) {
	      if (_.difference(groupIds, unusedCredit.SectorGroups).length === 0) {
	        matchedPayments.push(unusedCredit);
	      }
	    });
	
	    return matchedPayments;
	  }
	
	  function populateEachPaxWithSelectedUnusedCredits(unusedCredits, travellers) {
	    return matchPaymentsToTravellers(unusedCredits, travellers);
	  }
	
	  function matchPaymentsToTravellers(unusedCredits, travellers) {
	    var paymentMissing = 0;
	
	    _.forEach(travellers, function (pax, paxIndex) {
	      var paymentsCopy = angular.copy(pax.Configurations.UnusedCredit.PaymentItems);
	      pax.Configurations.UnusedCredit.PaymentItems = [];
	
	      _.forEach(pax.Flights, function (flight) {
	        if (unusedCredits.allPax && unusedCredits.allPax.flights) {
	          pax.Configurations.UnusedCredit.PaymentItems.push(buildPaymentObj(unusedCredits.allPax.flights.Payment, flight.GroupIdentifier, 'Flight'));
	        } else if (unusedCredits[paxIndex + 2] && unusedCredits[paxIndex + 2].flights[flight.GroupIdentifier]) {
	          if (!unusedCredits[paxIndex + 2].flights[flight.GroupIdentifier].Payment) {
	            var foundPayment = findPaymentWithTypeAndGrpId(paymentsCopy, 'Flight', flight.GroupIdentifier);
	
	            if (foundPayment.Card) {
	              unusedCredits[paxIndex + 2].flights[flight.GroupIdentifier].Payment = foundPayment.Card;
	            } else {
	              unusedCredits[paxIndex + 2].flights[flight.GroupIdentifier].Payment = foundPayment.Invoice;
	            }
	          }
	
	          pax.Configurations.UnusedCredit.PaymentItems.push(buildPaymentObj(unusedCredits[paxIndex + 2].flights[flight.GroupIdentifier].Payment, flight.GroupIdentifier, 'Flight'));
	        } else {
	          paymentMissing += 1;
	        }
	      });
	
	      _.forEach(pax.Rails, function (rail) {
	        if (unusedCredits.allPax && unusedCredits.allPax.rails) {
	          pax.Configurations.UnusedCredit.PaymentItems.push(buildPaymentObj(unusedCredits.allPax.rails.Payment, rail.GroupIdentifier, 'Rail'));
	        } else if (unusedCredits[paxIndex + 2] && unusedCredits[paxIndex + 2].rails[rail.GroupIdentifier]) {
	          if (!unusedCredits[paxIndex + 2].rails[rail.GroupIdentifier].Payment) {
	            var foundPayment = findPaymentWithTypeAndGrpId(paymentsCopy, 'Rail', rail.GroupIdentifier);
	
	            if (foundPayment.Card) {
	              unusedCredits[paxIndex + 2].rails[rail.GroupIdentifier].Payment = foundPayment.Card;
	            } else {
	              unusedCredits[paxIndex + 2].rails[rail.GroupIdentifier].Payment = foundPayment.Invoice;
	            }
	          }
	
	          pax.Configurations.UnusedCredit.PaymentItems.push(buildPaymentObj(unusedCredits[paxIndex + 2].rails[rail.GroupIdentifier].Payment, rail.GroupIdentifier, 'Rail'));
	        } else {
	          paymentMissing += 1;
	        }
	      });
	
	      _.forEach(pax.Hotels, function (hotel) {
	        if (unusedCredits.allPax && unusedCredits.allPax.hotels) {
	          pax.Configurations.UnusedCredit.PaymentItems.push(buildPaymentObj(unusedCredits.allPax.hotels.Payment, hotel.GroupIdentifier, 'Hotel'));
	        } else if (unusedCredits[paxIndex + 2] && unusedCredits[paxIndex + 2].hotels[hotel.GroupIdentifier]) {
	          if (!unusedCredits[paxIndex + 2].hotels[hotel.GroupIdentifier].Payment) {
	            var foundPayment = findPaymentWithTypeAndGrpId(paymentsCopy, 'Hotel', hotel.GroupIdentifier);
	
	            if (foundPayment.Card) {
	              unusedCredits[paxIndex + 2].hotels[hotel.GroupIdentifier].Payment = foundPayment.Card;
	            } else {
	              unusedCredits[paxIndex + 2].hotels[hotel.GroupIdentifier].Payment = foundPayment.Invoice;
	            }
	          }
	
	          pax.Configurations.UnusedCredit.PaymentItems.push(buildPaymentObj(unusedCredits[paxIndex + 2].hotels[hotel.GroupIdentifier].Payment, hotel.GroupIdentifier, 'Hotel'));
	        } else {
	          paymentMissing += 1;
	        }
	      });
	
	      _.forEach(pax.Cars, function (car) {
	        if (unusedCredits.allPax && unusedCredits.allPax.cars) {
	          pax.Configurations.UnusedCredit.PaymentItems.push(buildPaymentObj(unusedCredits.allPax.cars.Payment, car.GroupIdentifier, 'Car'));
	        } else if (unusedCredits[paxIndex + 2] && unusedCredits[paxIndex + 2].cars[car.GroupIdentifier]) {
	          if (!unusedCredits[paxIndex + 2].cars[car.GroupIdentifier].Payment) {
	            var foundPayment = findPaymentWithTypeAndGrpId(paymentsCopy, 'Car', car.GroupIdentifier);
	
	            if (foundPayment.Card) {
	              unusedCredits[paxIndex + 2].cars[car.GroupIdentifier].Payment = foundPayment.Card;
	            } else {
	              unusedCredits[paxIndex + 2].cars[car.GroupIdentifier].Payment = foundPayment.Invoice;
	            }
	          }
	
	          pax.Configurations.UnusedCredit.PaymentItems.push(buildPaymentObj(unusedCredits[paxIndex + 2].cars[car.GroupIdentifier].Payment, car.GroupIdentifier, 'Car'));
	        } else {
	          paymentMissing += 1;
	        }
	      });
	    });
	
	    return {
	      travellers: travellers,
	      missingPayments: paymentMissing > 0
	    };
	  }
	
	  function doGroupIdsMatchToInvoiceUnusedCredit(grpIds, unusedCredits) {
	    var typeInvoice = false;
	
	    _.each(grpIds, function (grpId) {
	      if (!typeInvoice) {
	        _.each(unusedCredits, function (payment) {
	          if (payment.SectorGroups.indexOf(grpId) > -1 && !typeInvoice && payment.Payment.PaymentType === 'Invoice') {
	            typeInvoice = true;
	          }
	        });
	      }
	    });
	
	    return typeInvoice;
	  }
	
	  function buildPaymentObj(Payment, grpId, type) {
	    var paymentObj = {};
	
	    if (Payment.PaymentType === 'Invoice') {
	      paymentObj = {
	        Card: null,
	        Invoice: {
	          PaymentType: 'Invoice',
	          Reference: 'Invoice'
	        },
	        SectorGroupIdentifier: grpId,
	        Type: type
	      };
	    } else {
	      paymentObj = {
	        Card: Payment,
	        Invoice: null,
	        SectorGroupIdentifier: grpId,
	        Type: type
	      };
	    }
	
	    return paymentObj;
	  }
	
	  function checkAllPaxPaymentsSelected(pax) {
	    if (!pax) {
	      return;
	    }
	    var eachSectorHasPayment = true;
	    var sectorGrpIds = [];
	
	    _.forEach(pax.Flights, function (flight) {
	      sectorGrpIds.push(flight.GroupIdentifier);
	    });
	
	    _.forEach(pax.Rails, function (rail) {
	      sectorGrpIds.push(rail.GroupIdentifier);
	    });
	
	    _.forEach(pax.Hotels, function (hotel) {
	      sectorGrpIds.push(hotel.GroupIdentifier);
	    });
	
	    _.forEach(pax.Cars, function (car) {
	      sectorGrpIds.push(car.GroupIdentifier);
	    });
	
	    sectorGrpIds = _.uniq(sectorGrpIds);
	
	    sectorGrpIds.every(function (grpId) {
	      if (eachSectorHasPayment) {
	        var findMatch = _.find(pax.Configurations.UnusedCredit.PaymentItems, function (PaymentItem) {
	          return PaymentItem.SectorGroupIdentifier === grpId;
	        });
	
	        eachSectorHasPayment = !!findMatch;
	      }
	
	      return eachSectorHasPayment;
	    });
	
	    return eachSectorHasPayment;
	  }
	
	  function findPaymentWithTypeAndGrpId(payments, type, grpId) {
	    return _.find(payments, function (payment) {
	      return payment.SectorGroupIdentifier === grpId && payment.Type === type;
	    });
	  }
	
	  function purgeDuplicateUnusedCredits(payments) {
	    var grpIds = [];
	
	    return _.filter(payments, function (payment) {
	      if (grpIds.indexOf(payment.SectorGroupIdentifier) === -1) {
	        grpIds.push(payment.SectorGroupIdentifier);
	        return true;
	      } else {
	        return false;
	      }
	    });
	  }
	
	  function checkForCVV(PaymentItems, cvvObj) {
	    var allCVVsPresent = true;
	
	    PaymentItems.every(function (payment) {
	      if (allCVVsPresent && payment.Card && payment.Card.SecurityCodeRequired) {
	        allCVVsPresent = cvvObj[payment.Card.Reference];
	      }
	
	      return allCVVsPresent;
	    });
	
	    return allCVVsPresent;
	  }
	
	  function addCVVsToPayments(paymentItems, cvvObj) {
	    return _.forEach(paymentItems, function (payment) {
	      if (payment.Card && payment.Card.SecurityCodeRequired) {
	        payment.Card.SecurityCode = cvvObj[payment.Card.Reference];
	      }
	    });
	  }
	
	  return service;
	};
	
	unusedCreditsService.$inject = $inject;
	
	exports['default'] = unusedCreditsService;
	module.exports = exports['default'];

/***/ }),
/* 1352 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['$rootScope', '$q', '$http', 'cartService', 'apiService', 'itinerariesService'];
	
	var unusedTicketsService = function unusedTicketsService($rootScope, $q, $http, cartService, apiService, itinerariesService) {
	  var service = {
	    isActive: false,
	    isEnabled: true,
	    tickets: [],
	    getTickets: getTickets,
	    toggle: toggle,
	    clear: clear
	  };
	
	  $rootScope.$watchCollection(function () {
	    return cartService.items;
	  }, validate);
	  $rootScope.$watchCollection(function () {
	    return cartService.tickets;
	  }, validate);
	
	  return service;
	
	  function getTickets() {
	    var deferred = $q.defer();
	    service.clear();
	
	    try {
	      // JLF 2018-09-07 use the itinerary service instead
	      for (var paxIndex in itinerariesService.itinerary.Search.Passengers) {
	        for (var uutcIndex in itinerariesService.itinerary.Search.Passengers[paxIndex].UnusedTicketCredits) {
	          var ticket = itinerariesService.itinerary.Search.Passengers[paxIndex].UnusedTicketCredits[uutcIndex];
	
	          service.tickets.push({
	            BookingCode: 'UUTC',
	            Carrier: ticket.AirLineCode,
	            CarrierLogoUrl: ticket.CarrierImage,
	            ClientId: ticket.PassengerId,
	            Comment: 'UUTC - ' + itinerariesService.itinerary.Search.Passengers[paxIndex].DepartmentCode, // TODO: update this to be more accurate
	            DebtorName: itinerariesService.itinerary.Search.Passengers[paxIndex].DepartmentName, // TODO: update this to be more accurate
	            DestinationCityCode: 'NA', // Not Applicable
	            EffectiveDate: ticket.EffectiveDate,
	            ExpiryDate: ticket.ExpirationDate,
	            GDSId: ticket.GDSId,
	            OriginCityCode: 'NA', // Not Applicable
	            Currency: ticket.Currency,
	            PassengerIdentifier: ticket.PassengerIdentifier,
	            TicketNumber: service.tickets.length + 1,
	            Traveller: itinerariesService.itinerary.Search.Passengers[paxIndex].FullName,
	            Value: ticket.Amount,
	            isDisabled: true,
	            UseCredit: ticket.UseCredit
	          });
	        }
	
	        deferred.resolve(service.tickets);
	        validate();
	      }
	    } catch (ex) {
	      service.clear();
	      console.error('unusedTicketsService.getTickets', ex.toString());
	      deferred.reject(ex);
	    }
	
	    return deferred.promise;
	  }
	
	  function validate() {
	    var orderedTickets = _.orderBy(service.tickets, 'Amount');
	
	    orderedTickets.forEach(function (ticket) {
	      var matchingTicket = cartService.getMatchingTicket(ticket);
	
	      ticket.isDisabled = !_.some(cartService.items, function (item) {
	        return item.type == 'flight' && item.result.Carrier === ticket.Carrier;
	      });
	
	      if (ticket.isDisabled || !matchingTicket) {
	        cartService.removeTicket(ticket);
	      }
	    });
	  }
	
	  function toggle() {
	    service.isActive = !service.isActive;
	  }
	
	  function clear() {
	    service.isActive = false;
	    service.tickets = [];
	  }
	};
	
	unusedTicketsService.$inject = $inject;
	
	exports['default'] = unusedTicketsService;
	module.exports = exports['default'];

/***/ }),
/* 1353 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['$q', '$http', 'apiService'];
	
	var userDebtorService = function userDebtorService($q, $http, apiService) {
	  var service = {};
	  service.debtor = null;
	  service.get = get;
	  service.getAny = getAny;
	  service.update = update;
	  service.bookingRules = bookingRules;
	  service.paymentMethod = paymentMethod;
	  service.paymentMethods = paymentMethods;
	  service.removePaymentMethod = removePaymentMethod;
	  service.clear = clear;
	
	  return service;
	
	  function getAny(debtorId) {
	    var deferred = $q.defer();
	
	    if (service.debtor) {
	      deferred.resolve(service.debtor);
	    } else {
	      deferred.resolve(get(debtorId));
	    }
	
	    return deferred.promise;
	  }
	
	  function get(debtorId) {
	    var deferred = $q.defer();
	
	    var apiUrl = apiService.getUrl('userDebtor', { debtorId: debtorId });
	
	    $http.get(apiUrl).success(function (response, status, headers) {
	      service.debtor = _.merge(response, { ETag: headers('ETag') });
	      deferred.resolve(service.debtor);
	    }).error(function () {
	      deferred.reject();
	    });
	
	    return deferred.promise;
	  }
	
	  function update(debtor) {
	    var deferred = $q.defer();
	    var debtorId = debtor.Name;
	
	    var apiUrl = apiService.getUrl('userDebtor', { debtorId: debtorId });
	
	    $http.put(apiUrl, _.omit(debtor, 'ETag'), {
	      headers: {
	        'If-Match': debtor.ETag
	      }
	    }).success(function () {
	      return get(debtorId).then(function (response) {
	        deferred.resolve(response);
	      }, function (error) {
	        deferred.reject(error);
	      });
	    }).error(function (error) {
	      deferred.reject(error);
	    });
	
	    return deferred.promise;
	  }
	
	  function bookingRules() {
	    return _.merge({}, _.pick(service.debtor, ['CompanyReference', 'Policy']));
	  }
	
	  function paymentMethod(id) {
	    return _.cloneDeep(_.find(service.debtor.DebtorAgencyCreditCards, function (paymentMethod) {
	      return paymentMethod.Id === id;
	    }));
	  }
	
	  function paymentMethods() {
	    return _.clone(service.debtor.DebtorAgencyCreditCards);
	  }
	
	  function removePaymentMethod(debtor, paymentMethod) {
	    debtor.DebtorAgencyCreditCards = _.filter(debtor.DebtorAgencyCreditCards, function (card) {
	      return card.Id !== paymentMethod.Id;
	    });
	
	    return debtor;
	  }
	
	  function clear() {
	    service.debtor = null;
	  }
	};
	
	userDebtorService.$inject = $inject;
	
	exports['default'] = userDebtorService;
	module.exports = exports['default'];

/***/ }),
/* 1354 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['$q', '$http', 'apiService'];
	
	var userProfileService = function userProfileService($q, $http, apiService) {
	  var service = {};
	  service.profile = null;
	  service.getPerson = getPerson;
	  service.getAny = getAny;
	  service.updatePerson = updatePerson;
	  service.register = register;
	  service.clear = clear;
	  service.store = store;
	
	  return service;
	
	  function getAny() {
	    if (service.profile) {
	      var deferred = $q.defer();
	      deferred.resolve(service.profile);
	      return deferred.promise;
	    } else {
	      return getPerson();
	    }
	  }
	
	  function getPerson() {
	    var deferred = $q.defer();
	    var apiUrl = apiService.getUrl('userProfile');
	
	    $http.get(apiUrl).success(function (data) {
	      service.profile = data;
	      deferred.resolve(service.profile);
	    });
	
	    return deferred.promise;
	  }
	
	  function updatePerson(profile) {
	    var deferred = $q.defer();
	
	    var apiUrl = apiService.getUrl('userProfile');
	    var userProfile = profile || service.profile;
	
	    $http.put(apiUrl, userProfile).success(function () {
	      service.profile = userProfile;
	      deferred.resolve(service.profile);
	    }).error(function () {
	      deferred.reject();
	    });
	
	    return deferred.promise;
	  }
	
	  function register(profile) {
	    var deferred = $q.defer();
	
	    var apiUrl = apiService.getUrl('userRegister');
	
	    $http.post(apiUrl, profile).success(function () {
	      deferred.resolve();
	    }).error(function () {
	      deferred.reject();
	    });
	
	    return deferred.promise;
	  }
	
	  function clear() {
	    localStorage.removeItem('profile');
	  }
	
	  function store(profile) {
	    service.profile = profile;
	    return service.profile;
	  }
	};
	
	userProfileService.$inject = $inject;
	
	exports['default'] = userProfileService;
	module.exports = exports['default'];

/***/ }),
/* 1355 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * angular-addtocalendar v1.1.3
	 * An AngularJS directive for adding an event to calendar apps.
	 *
	 * Controller and directive.
	 */
	'use strict';
	
	angular.module('jshor.angular-addtocalendar', []).config(['$compileProvider', function ($compileProvider) {
	  $compileProvider.aHrefSanitizationWhitelist(/^\s*(http(s)?|data):/);
	}]).controller('AddtocalendarCtrl', ['$scope', function ($scope) {
	  $scope.description = $scope.description || '';
	
	  /**
	   * Renders a .ics file and downloads it to the client browser.
	   * The name of the file will be the event title with alphanumeric chars
	   * having the extension `.ics`.
	   *
	   * @param  {Boolean} encodeUri  encode the
	   * @return {String}  ics calendar data
	   */
	  function getIcsCalendar(encodeUri) {
	    function formatIcsText(s, maxLength) {
	      if (!s || !s.length) return s;
	      return wrap(s.replace(/\n/g, '\\n'), maxLength);
	    }
	
	    function wrap(s, maxLength) {
	      if (!maxLength) maxLength = 75;
	      if (!s || s.length <= maxLength) {
	        return s;
	      } else {
	        return s.substring(0, maxLength).replace(/\n/g, '\\n') + '\r\n ' + wrap(s.substring(maxLength), 75);
	      }
	    }
	
	    var elements = ['BEGIN:VCALENDAR', 'VERSION:2.0', 'BEGIN:VEVENT', 'CLASS:PUBLIC', 'X-ALT-DESC;FMTTYPE=text/html:' + $scope.description, $scope.startDateUtc ? 'DTSTART:' + $scope.startDateUtc : 'DTSTART;VALUE=DATE:' + $scope.startDate, $scope.endDateUtc ? 'DTEND:' + $scope.endDateUtc : 'DTEND;VALUE=DATE:' + $scope.endDate, 'LOCATION:' + formatIcsText($scope.location, 64), 'SUMMARY:' + formatIcsText($scope.title, 66), 'TRANSP:TRANSPARENT', 'END:VEVENT', 'END:VCALENDAR'];
	
	    return elements.join('\n');
	  }
	
	  /**
	   * Generates a url to add event to Yahoo! Calendar.
	   *
	   * @return {String} yahoo cal url
	   */
	  function getYahooCalendarUrl() {
	    var yahooCalendarUrl = 'http://calendar.yahoo.com/?v=60&view=d&type=20';
	    yahooCalendarUrl += '&title=' + encodeURIComponent($scope.title);
	    yahooCalendarUrl += '&st=' + encodeURIComponent($scope.startDate) + '&et=' + encodeURIComponent($scope.endDate);
	    yahooCalendarUrl += '&desc=' + encodeURIComponent($scope.description);
	    yahooCalendarUrl += '&in_loc=' + encodeURIComponent($scope.location);
	
	    return yahooCalendarUrl;
	  }
	
	  /**
	   * Generates a url to add event to Google Calendar.
	   *
	   * @return {String} google cal url
	   */
	  function getGoogleCalendarUrl() {
	    var googleCalendarUrl = 'https://www.google.com/calendar/render?action=TEMPLATE';
	    googleCalendarUrl += '&text=' + encodeURIComponent($scope.title);
	    googleCalendarUrl += '&dates=' + encodeURIComponent($scope.startDate) + '/' + encodeURIComponent($scope.endDate);
	    googleCalendarUrl += '&details=' + encodeURIComponent($scope.description);
	    googleCalendarUrl += '&location=' + encodeURIComponent($scope.location);
	
	    return googleCalendarUrl;
	  }
	
	  /**
	   * Generates a url to add event to Windows Live Calendar.
	   *
	   * @return {String} microsoft cal url
	   */
	  function getMicrosoftCalendarUrl() {
	    var microsoftCalendarUrl = 'http://calendar.live.com/calendar/calendar.aspx?rru=addevent';
	    microsoftCalendarUrl += '&summary=' + encodeURIComponent($scope.title);
	    microsoftCalendarUrl += '&dtstart=' + encodeURIComponent($scope.startDate) + '&dtend=' + encodeURIComponent($scope.endDate);
	    microsoftCalendarUrl += '&description=' + encodeURIComponent($scope.description);
	    microsoftCalendarUrl += '&location=' + encodeURIComponent($scope.location);
	
	    return microsoftCalendarUrl;
	  }
	
	  function dlIcal() {
	    var fileName = $scope.fileName.replace(/[^\w ]+/g, '') + '.ics';
	    var cal = getIcsCalendar();
	    __webpack_require__(1610)(cal, fileName, 'application/octet-stream');
	  }
	
	  $scope.calendarUrl = {
	    microsoft: getMicrosoftCalendarUrl(),
	    google: getGoogleCalendarUrl(),
	    yahoo: getYahooCalendarUrl(),
	    icalendar: getIcsCalendar(),
	    dlIcal: dlIcal
	  };
	}]).directive('addtocalendar', function () {
	  return {
	    restrict: 'E',
	    scope: {
	      startDate: '@',
	      startDateUtc: '@',
	      endDate: '@',
	      endDateUtc: '@',
	      title: '@',
	      fileName: '@',
	      description: '@',
	      location: '@',
	      className: '@',
	      btnText: '@'
	    },
	    controller: 'AddtocalendarCtrl',
	    template: '<a class="{{ className }}" ng-click="calendarUrl.dlIcal()" title="Add to calendar"><i class="ico-cal"></i> <span>Add to calendar</span></a>'
	  };
	});

/***/ }),
/* 1356 */
/***/ (function(module, exports) {

	'use strict';
	
	(function (angular) {
	  'use strict';
	  var indexOf = [].indexOf || function (item) {
	    for (var i = 0, l = this.length; i < l; i++) {
	      if (i in this && this[i] === item) return i;
	    }
	    return -1;
	  };
	
	  function map(items, property) {
	    var mappedArray = [];
	    angular.forEach(items, function (item) {
	      mappedArray.push(angular.isFunction(property) ? property(item) : item[property]);
	    });
	    return mappedArray;
	  }
	
	  angular.module('pickadate', []).provider('pickadateI18n', function () {
	    var defaults = {
	      prev: 'prev',
	      next: 'next'
	    };
	
	    this.translations = {};
	
	    this.$get = function () {
	      var translations = this.translations;
	
	      return {
	        t: function t(key) {
	          return translations[key] || defaults[key];
	        }
	      };
	    };
	  }).factory('pickadateModalBindings', ['$window', '$document', function ($window, $document) {
	    var supportPageOffset = $window.pageXOffset !== undefined,
	        isCSS1Compat = ($document.compatMode || '') === 'CSS1Compat';
	
	    var computeStyles = function computeStyles(element) {
	      var scrollX = supportPageOffset ? $window.pageXOffset : isCSS1Compat ? $document.documentElement.scrollLeft : $document.body.scrollLeft,
	          scrollY = supportPageOffset ? $window.pageYOffset : isCSS1Compat ? $document.documentElement.scrollTop : $document.body.scrollTop,
	          innerWidth = $window.innerWidth || $document.documentElement.clientWidth || $document.body.clientWidth,
	          styles = { top: scrollY + element.getBoundingClientRect().bottom + 'px' };
	
	      if (innerWidth - element.getBoundingClientRect().left >= 300) {
	        styles.left = scrollX + element.getBoundingClientRect().left + 'px';
	      } else {
	        styles.right = innerWidth - element.getBoundingClientRect().right - scrollX + 'px';
	      }
	
	      return styles;
	    };
	
	    var isDescendant = function isDescendant(parent, child) {
	      var node = child.parentNode;
	      while (node !== null) {
	        if (node === parent) return true;
	        node = node.parentNode;
	      }
	      return false;
	    };
	
	    return function (scope, element, rootNode) {
	      var togglePicker = function togglePicker(toggle) {
	        scope.displayPicker = toggle;
	        scope.$apply();
	      };
	
	      element.on('focus', function () {
	        scope.modalStyles = computeStyles(element[0]);
	        togglePicker(true);
	      });
	
	      element.on('keydown', function (e) {
	        if (indexOf.call([9, 13, 27], e.keyCode) >= 0) togglePicker(false);
	      });
	
	      $document.on('click', function (e) {
	        if (isDescendant(rootNode, e.target) || e.target === element[0]) return;
	        togglePicker(false);
	      });
	    };
	  }]).factory('pickadateDateHelper', ['$locale', 'dateFilter', function ($locale, dateFilter) {
	    function getPartName(part) {
	      switch (part) {
	        case 'dd':
	          return 'day';
	        case 'MM':
	          return 'month';
	        case 'yyyy':
	          return 'year';
	      }
	    }
	
	    return function (format, options) {
	      var minDate, maxDate, formattedFrom, formattedTo, fromDate, toDate, showBetween, disabledDates, currentDate, weekStartsOn, noExtraRows;
	
	      options = options || {};
	      format = format || 'yyyy-MM-dd';
	      weekStartsOn = options.weekStartsOn;
	      noExtraRows = options.noExtraRows;
	
	      if (!angular.isNumber(weekStartsOn) || weekStartsOn < 0 || weekStartsOn > 6) weekStartsOn = 0;
	
	      return {
	        parseDate: function parseDate(dateString) {
	          if (!dateString) return;
	          if (angular.isDate(dateString)) return new Date(dateString);
	
	          var formatRegex = '(dd|MM|yyyy)',
	              separator = format.match(/[-|/]/)[0],
	              dateParts = dateString.split(separator),
	              regexp = new RegExp([formatRegex, formatRegex, formatRegex].join(separator)),
	              formatParts = format.match(regexp),
	              dateObj = {};
	
	          formatParts.shift();
	
	          angular.forEach(formatParts, function (part, i) {
	            dateObj[getPartName(part)] = parseInt(dateParts[i], 10);
	          });
	
	          if (isNaN(dateObj.year) || isNaN(dateObj.month) || isNaN(dateObj.day)) return;
	
	          return new Date(dateObj.year, dateObj.month - 1, dateObj.day, 3);
	        },
	
	        setRestrictions: function setRestrictions(restrictions) {
	          formattedFrom = restrictions.rangeFrom || null;
	          formattedTo = restrictions.rangeTo || null;
	          fromDate = this.parseDate(restrictions.rangeFrom);
	          toDate = this.parseDate(restrictions.rangeTo);
	          showBetween = fromDate && toDate;
	          minDate = this.parseDate(restrictions.minDate) || new Date(0);
	          maxDate = this.parseDate(restrictions.maxDate) || new Date(99999999999999);
	          currentDate = restrictions.currentDate;
	          disabledDates = restrictions.disabledDates || [];
	        },
	
	        allowPrevMonth: function allowPrevMonth() {
	          return currentDate > minDate;
	        },
	
	        allowNextMonth: function allowNextMonth() {
	          var nextMonth = angular.copy(currentDate);
	          nextMonth.setMonth(nextMonth.getMonth() + 1);
	          return nextMonth <= maxDate;
	        },
	
	        buildDateObject: function buildDateObject(date) {
	          var localDate = angular.copy(date),
	              formattedDate = dateFilter(localDate, format),
	              disabled = indexOf.call(disabledDates, formattedDate) >= 0,
	              monthOffset = this.getMonthOffset(localDate, currentDate),
	              outOfMinRange = localDate < minDate,
	              outOfMaxRange = localDate > maxDate,
	              outOfMonth = monthOffset === -1 && !options.previousMonthSelectable || monthOffset === 1 && !options.nextMonthSelectable;
	
	          return {
	            date: localDate,
	            formattedDate: formattedDate,
	            today: formattedDate === dateFilter(new Date(), format),
	            fromDate: formattedDate === formattedFrom,
	            toDate: formattedDate === formattedTo,
	            betweenDate: showBetween && localDate > fromDate && localDate < toDate,
	            disabled: disabled,
	            outOfMinRange: outOfMinRange,
	            outOfMaxRange: outOfMaxRange,
	            monthOffset: monthOffset,
	            outOfMonth: outOfMonth,
	            enabled: !(disabled || outOfMinRange || outOfMaxRange || outOfMonth)
	          };
	        },
	
	        buildDates: function buildDates(year, month, options) {
	          var dates = [],
	              date = new Date(year, month, 1, 3),
	              lastDate = new Date(year, month + 1, 0, 3);
	
	          options = options || {};
	          currentDate = angular.copy(date);
	
	          while (date.getDay() !== weekStartsOn) date.setDate(date.getDate() - 1);
	
	          for (var i = 0; i < 42; i++) {
	            // 42 == 6 rows of dates
	            if (noExtraRows && date.getDay() === weekStartsOn && date > lastDate) break;
	
	            dates.push(this.buildDateObject(date));
	            date.setDate(date.getDate() + 1);
	          }
	
	          return dates;
	        },
	
	        buildDayNames: function buildDayNames() {
	          var dayNames = $locale.DATETIME_FORMATS.SHORTDAY;
	
	          if (weekStartsOn) {
	            dayNames = dayNames.slice(0);
	            for (var i = 0; i < weekStartsOn; i++) dayNames.push(dayNames.shift());
	          }
	          return dayNames;
	        },
	
	        getMonthOffset: function getMonthOffset(date1, date2) {
	          return date1.getMonth() - date2.getMonth() + 12 * (date1.getFullYear() - date2.getFullYear());
	        }
	      };
	    };
	  }]).directive('pickadate', ['$locale', '$sce', '$compile', '$document', '$window', 'pickadateDateHelper', 'pickadateI18n', 'pickadateModalBindings', 'filterFilter', 'moment', function ($locale, $sce, $compile, $document, $window, dateHelperFactory, i18n, modalBindings, filter, moment) {
	    var TEMPLATE = '<div class="pickadate" ng-show="displayPicker" ng-style="modalStyles">' + '<div class="pickadate-header">' + '<div class="pickadate-prev" ng-click="changeMonth(-1)" ng-show="allowPrevMonth">' + '<i class="ico-chevron-left"></i>' + '</div>' + '<div class="pickadate-next" ng-click="changeMonth(1)" ng-show="allowNextMonth">' + '<i class="ico-chevron-right"></i>' + '</div>' + '<h3 class="pickadate-centered-heading">' + '{{currentDate | date:"MMMM yyyy"}}' + '</h3>' + '</div>' + '<div class="pickadate-body">' + '<div class="pickadate-main">' + '<ul class="pickadate-cell pickadate-cell-header">' + '<li class="pickadate-head" ng-repeat="dayName in dayNames">' + '{{dayName}}' + '</li>' + '</ul>' + '<ul class="pickadate-cell">' + '<li ng-repeat="dateObj in dates" ng-click="setDate(dateObj)" ng-class="classesFor(dateObj)"' + ' ng-mouseenter="dateOver(dateObj)" ng-mouseleave="dateOut(dateObj)">' + '<span>' + '{{dateObj.date | date:"d"}}' + '</span>' + '</li>' + '</ul>' + '</div>' + '</div>' + '</div>';
	
	    return {
	      require: 'ngModel',
	      scope: {
	        defaultDate: '=',
	        minDate: '=',
	        maxDate: '=',
	        rangeFrom: '=',
	        rangeTo: '=',
	        disabledDates: '=',
	        weekStartsOn: '=',
	        onDateSelect: '&'
	      },
	
	      link: function link(scope, element, attrs, ngModel) {
	        var allowMultiple = attrs.hasOwnProperty('multiple'),
	            selectedDates = [],
	            wantsModal = element[0] instanceof HTMLInputElement,
	            compiledHtml = $compile(TEMPLATE)(scope),
	            format = (attrs.format || 'yyyy-MM-dd').replace(/m/g, 'M'),
	            dateHelper = dateHelperFactory(format, {
	          previousMonthSelectable: /^(previous|both)$/.test(attrs.selectOtherMonths),
	          nextMonthSelectable: /^(next|both)$/.test(attrs.selectOtherMonths),
	          weekStartsOn: scope.weekStartsOn,
	          noExtraRows: attrs.hasOwnProperty('noExtraRows')
	        });
	
	        scope.displayPicker = !wantsModal;
	
	        scope.setDate = function (dateObj) {
	          if (!dateObj.enabled) return;
	          selectedDates = allowMultiple ? toggleDate(dateObj, selectedDates) : [dateObj];
	
	          setViewValue(selectedDates);
	          scope.onDateSelect(dateObj);
	
	          scope.changeMonth(dateObj.monthOffset);
	          scope.displayPicker = !wantsModal;
	        };
	
	        scope.dateOver = function (dateObj) {
	          /*var overDate = moment(dateObj.formattedDate, 'dd/mm/yyyy');
	             _.forEach(scope.dates, (date) => {
	           var thisDate = moment(date.formattedDate, 'dd/mm/yyyy');
	             if(thisDate.isBefore(overDate)) {
	           console.log(date.formattedDate + 'is before');
	           date.classNames.push('pickadate-rangeBetween');
	           }
	           });*/
	        };
	
	        scope.dateOut = function (dateObj) {
	          /*_.forEach(scope.dates, (date) => {
	           _.remove(date.classNames, function (className) {
	           return className === 'pickadate-rangeBetween';
	           });
	           });*/
	        };
	
	        var $render = ngModel.$render = function (options) {
	          if (angular.isArray(ngModel.$viewValue)) {
	            selectedDates = ngModel.$viewValue;
	          } else if (ngModel.$viewValue) {
	            selectedDates = [ngModel.$viewValue];
	          }
	
	          scope.currentDate = dateHelper.parseDate(scope.defaultDate || selectedDates[0]) || new Date();
	
	          dateHelper.setRestrictions(scope);
	
	          selectedDates = map(selectedDates, function (date) {
	            return dateHelper.buildDateObject(dateHelper.parseDate(date));
	          });
	
	          selectedDates = filter(selectedDates, { enabled: true });
	
	          setViewValue(selectedDates, options);
	          render();
	        };
	
	        scope.classesFor = function (date) {
	          var formattedDates = map(selectedDates, 'formattedDate');
	          var classes = indexOf.call(formattedDates, date.formattedDate) >= 0 ? 'pickadate-active' : null;
	          return date.classNames.concat(classes);
	        };
	
	        scope.changeMonth = function (offset) {
	          if (!offset) return;
	          // If the current date is January 31th, setting the month to date.getMonth() + 1
	          // sets the date to March the 3rd, since the date object adds 30 days to the current
	          // date. Settings the date to the 2nd day of the month is a workaround to prevent this
	          // behaviour
	          scope.currentDate.setDate(1);
	          scope.currentDate.setMonth(scope.currentDate.getMonth() + offset);
	          render();
	        };
	
	        // Workaround to watch multiple properties. XXX use $scope.$watchGroup in angular 1.3
	        scope.$watch(function () {
	          return angular.toJson([scope.minDate, scope.maxDate, scope.disabledDates]);
	        }, $render);
	
	        // Insert datepicker into DOM
	        if (wantsModal) {
	          modalBindings(scope, element, compiledHtml[0]);
	
	          // if the user types a date, update the picker and set validity
	          scope.$watch(function () {
	            return ngModel.$viewValue;
	          }, function (val) {
	            var isValidDate = dateHelper.parseDate(val);
	
	            if (isValidDate) $render({ skipRenderInput: true });
	            ngModel.$setValidity('date', !!isValidDate);
	          });
	
	          // if the input element has a value, set it as the ng-model
	          scope.$$postDigest(function () {
	            if (attrs.value) {
	              ngModel.$viewValue = attrs.value;
	              $render();
	            }
	          });
	
	          element.after(compiledHtml.addClass('pickadate-modal'));
	        } else {
	          element.append(compiledHtml);
	        }
	
	        function render() {
	          var dates = dateHelper.buildDates(scope.currentDate.getFullYear(), scope.currentDate.getMonth());
	
	          scope.allowPrevMonth = dateHelper.allowPrevMonth();
	          scope.allowNextMonth = dateHelper.allowNextMonth();
	          scope.dayNames = dateHelper.buildDayNames();
	
	          scope.dates = map(dates, function (date) {
	            date.classNames = [date.enabled ? 'pickadate-enabled' : 'pickadate-disabled'];
	
	            if (date.outOfMonth) date.classNames.push('pickadate-outOfMonth');
	            if (date.today) date.classNames.push('pickadate-today');
	            if (date.disabled) date.classNames.push('pickadate-unavailable');
	            if (date.fromDate && date.fromDate !== date.toDate) date.classNames.push('pickadate-rangeStart');
	            if (date.toDate && date.toDate !== date.fromDate) date.classNames.push('pickadate-rangeEnd');
	            if (date.betweenDate) date.classNames.push('pickadate-rangeBetween');
	
	            return date;
	          });
	        }
	
	        function setViewValue(value, options) {
	          options = options || {};
	
	          if (allowMultiple) {
	            ngModel.$setViewValue(map(value, 'formattedDate'));
	          } else {
	            ngModel.$setViewValue(value[0] && value[0].formattedDate);
	          }
	
	          if (!options.skipRenderInput) element.val(ngModel.$viewValue);
	        }
	
	        function toggleDate(dateObj, dateArray) {
	          var index = indexOf.call(dateArray, dateObj);
	          if (index === -1) {
	            dateArray.push(dateObj);
	          } else {
	            dateArray.splice(index, 1);
	          }
	          return dateArray;
	        }
	      }
	    };
	  }]);
	})(window.angular);

/***/ }),
/* 1357 */
/***/ (function(module, exports) {

	/**
	 * @license AngularJS v1.5.5
	 * (c) 2010-2016 Google, Inc. http://angularjs.org
	 * License: MIT
	 */
	'use strict';
	
	(function (window, angular) {
	  'use strict';
	
	  /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	   *     Any commits to this file should be reviewed with security in mind.  *
	   *   Changes to this file can potentially create security vulnerabilities. *
	   *          An approval from 2 Core members with history of modifying      *
	   *                         this file is required.                          *
	   *                                                                         *
	   *  Does the change somehow allow for arbitrary javascript to be executed? *
	   *    Or allows for someone to change the prototype of built-in objects?   *
	   *     Or gives undesired access to variables likes document or window?    *
	   * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */
	
	  var $sanitizeMinErr = angular.$$minErr('$sanitize');
	
	  /**
	   * @ngdoc module
	   * @name ngSanitize
	   * @description
	   *
	   * # ngSanitize
	   *
	   * The `ngSanitize` module provides functionality to sanitize HTML.
	   *
	   *
	   * <div doc-module-components="ngSanitize"></div>
	   *
	   * See {@link ngSanitize.$sanitize `$sanitize`} for usage.
	   */
	
	  /**
	  * @ngdoc service
	  * @name $sanitize
	  * @kind function
	  *
	  * @description
	  *   Sanitizes an html string by stripping all potentially dangerous tokens.
	  *
	  *   The input is sanitized by parsing the HTML into tokens. All safe tokens (from a whitelist) are
	  *   then serialized back to properly escaped html string. This means that no unsafe input can make
	  *   it into the returned string.
	  *
	  *   The whitelist for URL sanitization of attribute values is configured using the functions
	  *   `aHrefSanitizationWhitelist` and `imgSrcSanitizationWhitelist` of {@link ng.$compileProvider
	  *   `$compileProvider`}.
	  *
	  *   The input may also contain SVG markup if this is enabled via {@link $sanitizeProvider}.
	  *
	  * @param {string} html HTML input.
	  * @returns {string} Sanitized HTML.
	  *
	  * @example
	   <example module="sanitizeExample" deps="angular-sanitize.js">
	   <file name="index.html">
	     <script>
	         angular.module('sanitizeExample', ['ngSanitize'])
	           .controller('ExampleController', ['$scope', '$sce', function($scope, $sce) {
	             $scope.snippet =
	               '<p style="color:blue">an html\n' +
	               '<em onmouseover="this.textContent=\'PWN3D!\'">click here</em>\n' +
	               'snippet</p>';
	             $scope.deliberatelyTrustDangerousSnippet = function() {
	               return $sce.trustAsHtml($scope.snippet);
	             };
	           }]);
	     </script>
	     <div ng-controller="ExampleController">
	        Snippet: <textarea ng-model="snippet" cols="60" rows="3"></textarea>
	       <table>
	         <tr>
	           <td>Directive</td>
	           <td>How</td>
	           <td>Source</td>
	           <td>Rendered</td>
	         </tr>
	         <tr id="bind-html-with-sanitize">
	           <td>ng-bind-html</td>
	           <td>Automatically uses $sanitize</td>
	           <td><pre>&lt;div ng-bind-html="snippet"&gt;<br/>&lt;/div&gt;</pre></td>
	           <td><div ng-bind-html="snippet"></div></td>
	         </tr>
	         <tr id="bind-html-with-trust">
	           <td>ng-bind-html</td>
	           <td>Bypass $sanitize by explicitly trusting the dangerous value</td>
	           <td>
	           <pre>&lt;div ng-bind-html="deliberatelyTrustDangerousSnippet()"&gt;
	  &lt;/div&gt;</pre>
	           </td>
	           <td><div ng-bind-html="deliberatelyTrustDangerousSnippet()"></div></td>
	         </tr>
	         <tr id="bind-default">
	           <td>ng-bind</td>
	           <td>Automatically escapes</td>
	           <td><pre>&lt;div ng-bind="snippet"&gt;<br/>&lt;/div&gt;</pre></td>
	           <td><div ng-bind="snippet"></div></td>
	         </tr>
	       </table>
	       </div>
	   </file>
	   <file name="protractor.js" type="protractor">
	     it('should sanitize the html snippet by default', function() {
	       expect(element(by.css('#bind-html-with-sanitize div')).getInnerHtml()).
	         toBe('<p>an html\n<em>click here</em>\nsnippet</p>');
	     });
	       it('should inline raw snippet if bound to a trusted value', function() {
	       expect(element(by.css('#bind-html-with-trust div')).getInnerHtml()).
	         toBe("<p style=\"color:blue\">an html\n" +
	              "<em onmouseover=\"this.textContent='PWN3D!'\">click here</em>\n" +
	              "snippet</p>");
	     });
	       it('should escape snippet without any filter', function() {
	       expect(element(by.css('#bind-default div')).getInnerHtml()).
	         toBe("&lt;p style=\"color:blue\"&gt;an html\n" +
	              "&lt;em onmouseover=\"this.textContent='PWN3D!'\"&gt;click here&lt;/em&gt;\n" +
	              "snippet&lt;/p&gt;");
	     });
	       it('should update', function() {
	       element(by.model('snippet')).clear();
	       element(by.model('snippet')).sendKeys('new <b onclick="alert(1)">text</b>');
	       expect(element(by.css('#bind-html-with-sanitize div')).getInnerHtml()).
	         toBe('new <b>text</b>');
	       expect(element(by.css('#bind-html-with-trust div')).getInnerHtml()).toBe(
	         'new <b onclick="alert(1)">text</b>');
	       expect(element(by.css('#bind-default div')).getInnerHtml()).toBe(
	         "new &lt;b onclick=\"alert(1)\"&gt;text&lt;/b&gt;");
	     });
	   </file>
	   </example>
	  */
	
	  /**
	   * @ngdoc provider
	   * @name $sanitizeProvider
	   *
	   * @description
	   * Creates and configures {@link $sanitize} instance.
	   */
	  function $SanitizeProvider() {
	    var svgEnabled = false;
	
	    this.$get = ['$$sanitizeUri', function ($$sanitizeUri) {
	      if (svgEnabled) {
	        angular.extend(validElements, svgElements);
	      }
	      return function (html) {
	        var buf = [];
	        htmlParser(html, htmlSanitizeWriter(buf, function (uri, isImage) {
	          return !/^unsafe:/.test($$sanitizeUri(uri, isImage));
	        }));
	        return buf.join('');
	      };
	    }];
	
	    /**
	     * @ngdoc method
	     * @name $sanitizeProvider#enableSvg
	     * @kind function
	     *
	     * @description
	     * Enables a subset of svg to be supported by the sanitizer.
	     *
	     * <div class="alert alert-warning">
	     *   <p>By enabling this setting without taking other precautions, you might expose your
	     *   application to click-hijacking attacks. In these attacks, sanitized svg elements could be positioned
	     *   outside of the containing element and be rendered over other elements on the page (e.g. a login
	     *   link). Such behavior can then result in phishing incidents.</p>
	     *
	     *   <p>To protect against these, explicitly setup `overflow: hidden` css rule for all potential svg
	     *   tags within the sanitized content:</p>
	     *
	     *   <br>
	     *
	     *   <pre><code>
	     *   .rootOfTheIncludedContent svg {
	     *     overflow: hidden !important;
	     *   }
	     *   </code></pre>
	     * </div>
	     *
	     * @param {boolean=} regexp New regexp to whitelist urls with.
	     * @returns {boolean|ng.$sanitizeProvider} Returns the currently configured value if called
	     *    without an argument or self for chaining otherwise.
	     */
	    this.enableSvg = function (enableSvg) {
	      if (angular.isDefined(enableSvg)) {
	        svgEnabled = enableSvg;
	        return this;
	      } else {
	        return svgEnabled;
	      }
	    };
	  }
	
	  function sanitizeText(chars) {
	    var buf = [];
	    var writer = htmlSanitizeWriter(buf, angular.noop);
	    writer.chars(chars);
	    return buf.join('');
	  }
	
	  // Regular Expressions for parsing tags and attributes
	  var SURROGATE_PAIR_REGEXP = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g,
	
	  // Match everything outside of normal chars and " (quote character)
	  NON_ALPHANUMERIC_REGEXP = /([^\#-~ |!])/g;
	
	  // Good source of info about elements and attributes
	  // http://dev.w3.org/html5/spec/Overview.html#semantics
	  // http://simon.html5.org/html-elements
	
	  // Safe Void Elements - HTML5
	  // http://dev.w3.org/html5/spec/Overview.html#void-elements
	  var voidElements = toMap('area,br,col,hr,img,wbr');
	
	  // Elements that you can, intentionally, leave open (and which close themselves)
	  // http://dev.w3.org/html5/spec/Overview.html#optional-tags
	  var optionalEndTagBlockElements = toMap('colgroup,dd,dt,li,p,tbody,td,tfoot,th,thead,tr'),
	      optionalEndTagInlineElements = toMap('rp,rt'),
	      optionalEndTagElements = angular.extend({}, optionalEndTagInlineElements, optionalEndTagBlockElements);
	
	  // Safe Block Elements - HTML5
	  var blockElements = angular.extend({}, optionalEndTagBlockElements, toMap('address,article,' + 'aside,blockquote,caption,center,del,dir,div,dl,figure,figcaption,footer,h1,h2,h3,h4,h5,' + 'h6,header,hgroup,hr,ins,map,menu,nav,ol,pre,section,table,ul'));
	
	  // Inline Elements - HTML5
	  var inlineElements = angular.extend({}, optionalEndTagInlineElements, toMap('a,abbr,acronym,b,' + 'bdi,bdo,big,br,cite,code,del,dfn,em,font,i,img,ins,kbd,label,map,mark,q,ruby,rp,rt,s,' + 'samp,small,span,strike,strong,sub,sup,time,tt,u,var'));
	
	  // SVG Elements
	  // https://wiki.whatwg.org/wiki/Sanitization_rules#svg_Elements
	  // Note: the elements animate,animateColor,animateMotion,animateTransform,set are intentionally omitted.
	  // They can potentially allow for arbitrary javascript to be executed. See #11290
	  var svgElements = toMap('circle,defs,desc,ellipse,font-face,font-face-name,font-face-src,g,glyph,' + 'hkern,image,linearGradient,line,marker,metadata,missing-glyph,mpath,path,polygon,polyline,' + 'radialGradient,rect,stop,svg,switch,text,title,tspan');
	
	  // Blocked Elements (will be stripped)
	  var blockedElements = toMap('script,style');
	
	  var validElements = angular.extend({}, voidElements, blockElements, inlineElements, optionalEndTagElements);
	
	  //Attributes that have href and hence need to be sanitized
	  var uriAttrs = toMap('background,cite,href,longdesc,src,xlink:href');
	
	  var htmlAttrs = toMap('abbr,align,alt,axis,bgcolor,border,cellpadding,cellspacing,class,clear,' + 'color,cols,colspan,compact,coords,dir,face,headers,height,hreflang,hspace,' + 'ismap,lang,language,nohref,nowrap,rel,rev,rows,rowspan,rules,' + 'scope,scrolling,shape,size,span,start,summary,tabindex,target,title,type,' + 'valign,value,vspace,width');
	
	  // SVG attributes (without "id" and "name" attributes)
	  // https://wiki.whatwg.org/wiki/Sanitization_rules#svg_Attributes
	  var svgAttrs = toMap('accent-height,accumulate,additive,alphabetic,arabic-form,ascent,' + 'baseProfile,bbox,begin,by,calcMode,cap-height,class,color,color-rendering,content,' + 'cx,cy,d,dx,dy,descent,display,dur,end,fill,fill-rule,font-family,font-size,font-stretch,' + 'font-style,font-variant,font-weight,from,fx,fy,g1,g2,glyph-name,gradientUnits,hanging,' + 'height,horiz-adv-x,horiz-origin-x,ideographic,k,keyPoints,keySplines,keyTimes,lang,' + 'marker-end,marker-mid,marker-start,markerHeight,markerUnits,markerWidth,mathematical,' + 'max,min,offset,opacity,orient,origin,overline-position,overline-thickness,panose-1,' + 'path,pathLength,points,preserveAspectRatio,r,refX,refY,repeatCount,repeatDur,' + 'requiredExtensions,requiredFeatures,restart,rotate,rx,ry,slope,stemh,stemv,stop-color,' + 'stop-opacity,strikethrough-position,strikethrough-thickness,stroke,stroke-dasharray,' + 'stroke-dashoffset,stroke-linecap,stroke-linejoin,stroke-miterlimit,stroke-opacity,' + 'stroke-width,systemLanguage,target,text-anchor,to,transform,type,u1,u2,underline-position,' + 'underline-thickness,unicode,unicode-range,units-per-em,values,version,viewBox,visibility,' + 'width,widths,x,x-height,x1,x2,xlink:actuate,xlink:arcrole,xlink:role,xlink:show,xlink:title,' + 'xlink:type,xml:base,xml:lang,xml:space,xmlns,xmlns:xlink,y,y1,y2,zoomAndPan', true);
	
	  var validAttrs = angular.extend({}, uriAttrs, svgAttrs, htmlAttrs);
	
	  function toMap(str, lowercaseKeys) {
	    var obj = {},
	        items = str.split(','),
	        i;
	    for (i = 0; i < items.length; i++) {
	      obj[lowercaseKeys ? angular.lowercase(items[i]) : items[i]] = true;
	    }
	    return obj;
	  }
	
	  var inertBodyElement;
	  (function (window) {
	    var doc;
	    if (window.document && window.document.implementation) {
	      doc = window.document.implementation.createHTMLDocument('inert');
	    } else {
	      throw $sanitizeMinErr('noinert', "Can't create an inert html document");
	    }
	    var docElement = doc.documentElement || doc.getDocumentElement();
	    var bodyElements = docElement.getElementsByTagName('body');
	
	    // usually there should be only one body element in the document, but IE doesn't have any, so we need to create one
	    if (bodyElements.length === 1) {
	      inertBodyElement = bodyElements[0];
	    } else {
	      var html = doc.createElement('html');
	      inertBodyElement = doc.createElement('body');
	      html.appendChild(inertBodyElement);
	      doc.appendChild(html);
	    }
	  })(window);
	
	  /**
	   * @example
	   * htmlParser(htmlString, {
	   *     start: function(tag, attrs) {},
	   *     end: function(tag) {},
	   *     chars: function(text) {},
	   *     comment: function(text) {}
	   * });
	   *
	   * @param {string} html string
	   * @param {object} handler
	   */
	  function htmlParser(html, handler) {
	    if (html === null || html === undefined) {
	      html = '';
	    } else if (typeof html !== 'string') {
	      html = '' + html;
	    }
	    inertBodyElement.innerHTML = html;
	
	    //mXSS protection
	    var mXSSAttempts = 5;
	    do {
	      if (mXSSAttempts === 0) {
	        throw $sanitizeMinErr('uinput', 'Failed to sanitize html because the input is unstable');
	      }
	      mXSSAttempts--;
	
	      // strip custom-namespaced attributes on IE<=11
	      if (window.document.documentMode) {
	        stripCustomNsAttrs(inertBodyElement);
	      }
	      html = inertBodyElement.innerHTML; //trigger mXSS
	      inertBodyElement.innerHTML = html;
	    } while (html !== inertBodyElement.innerHTML);
	
	    var node = inertBodyElement.firstChild;
	    while (node) {
	      switch (node.nodeType) {
	        case 1:
	          // ELEMENT_NODE
	          handler.start(node.nodeName.toLowerCase(), attrToMap(node.attributes));
	          break;
	        case 3:
	          // TEXT NODE
	          handler.chars(node.textContent);
	          break;
	      }
	
	      var nextNode;
	      if (!(nextNode = node.firstChild)) {
	        if (node.nodeType == 1) {
	          handler.end(node.nodeName.toLowerCase());
	        }
	        nextNode = node.nextSibling;
	        if (!nextNode) {
	          while (nextNode == null) {
	            node = node.parentNode;
	            if (node === inertBodyElement) break;
	            nextNode = node.nextSibling;
	            if (node.nodeType == 1) {
	              handler.end(node.nodeName.toLowerCase());
	            }
	          }
	        }
	      }
	      node = nextNode;
	    }
	
	    while (node = inertBodyElement.firstChild) {
	      inertBodyElement.removeChild(node);
	    }
	  }
	
	  function attrToMap(attrs) {
	    var map = {};
	    for (var i = 0, ii = attrs.length; i < ii; i++) {
	      var attr = attrs[i];
	      map[attr.name] = attr.value;
	    }
	    return map;
	  }
	
	  /**
	   * Escapes all potentially dangerous characters, so that the
	   * resulting string can be safely inserted into attribute or
	   * element text.
	   * @param value
	   * @returns {string} escaped text
	   */
	  function encodeEntities(value) {
	    return value.replace(/&/g, '&amp;').replace(SURROGATE_PAIR_REGEXP, function (value) {
	      var hi = value.charCodeAt(0);
	      var low = value.charCodeAt(1);
	      return '&#' + ((hi - 0xd800) * 0x400 + (low - 0xdc00) + 0x10000) + ';';
	    }).replace(NON_ALPHANUMERIC_REGEXP, function (value) {
	      return '&#' + value.charCodeAt(0) + ';';
	    }).replace(/</g, '&lt;').replace(/>/g, '&gt;');
	  }
	
	  /**
	   * create an HTML/XML writer which writes to buffer
	   * @param {Array} buf use buf.join('') to get out sanitized html string
	   * @returns {object} in the form of {
	   *     start: function(tag, attrs) {},
	   *     end: function(tag) {},
	   *     chars: function(text) {},
	   *     comment: function(text) {}
	   * }
	   */
	  function htmlSanitizeWriter(buf, uriValidator) {
	    var ignoreCurrentElement = false;
	    var out = angular.bind(buf, buf.push);
	    return {
	      start: function start(tag, attrs) {
	        tag = angular.lowercase(tag);
	        if (!ignoreCurrentElement && blockedElements[tag]) {
	          ignoreCurrentElement = tag;
	        }
	        if (!ignoreCurrentElement && validElements[tag] === true) {
	          out('<');
	          out(tag);
	          angular.forEach(attrs, function (value, key) {
	            var lkey = angular.lowercase(key);
	            var isImage = tag === 'img' && lkey === 'src' || lkey === 'background';
	            if (validAttrs[lkey] === true && (uriAttrs[lkey] !== true || uriValidator(value, isImage))) {
	              out(' ');
	              out(key);
	              out('="');
	              out(encodeEntities(value));
	              out('"');
	            }
	          });
	          out('>');
	        }
	      },
	      end: function end(tag) {
	        tag = angular.lowercase(tag);
	        if (!ignoreCurrentElement && validElements[tag] === true && voidElements[tag] !== true) {
	          out('</');
	          out(tag);
	          out('>');
	        }
	        if (tag == ignoreCurrentElement) {
	          ignoreCurrentElement = false;
	        }
	      },
	      chars: function chars(_chars) {
	        if (!ignoreCurrentElement) {
	          out(encodeEntities(_chars));
	        }
	      }
	    };
	  }
	
	  /**
	   * When IE9-11 comes across an unknown namespaced attribute e.g. 'xlink:foo' it adds 'xmlns:ns1' attribute to declare
	   * ns1 namespace and prefixes the attribute with 'ns1' (e.g. 'ns1:xlink:foo'). This is undesirable since we don't want
	   * to allow any of these custom attributes. This method strips them all.
	   *
	   * @param node Root element to process
	   */
	  function stripCustomNsAttrs(node) {
	    if (node.nodeType === window.Node.ELEMENT_NODE) {
	      var attrs = node.attributes;
	      for (var i = 0, l = attrs.length; i < l; i++) {
	        var attrNode = attrs[i];
	        var attrName = attrNode.name.toLowerCase();
	        if (attrName === 'xmlns:ns1' || attrName.indexOf('ns1:') === 0) {
	          node.removeAttributeNode(attrNode);
	          i--;
	          l--;
	        }
	      }
	    }
	
	    var nextNode = node.firstChild;
	    if (nextNode) {
	      stripCustomNsAttrs(nextNode);
	    }
	
	    nextNode = node.nextSibling;
	    if (nextNode) {
	      stripCustomNsAttrs(nextNode);
	    }
	  }
	
	  // define ngSanitize module and register $sanitize service
	  angular.module('ngSanitize', []).provider('$sanitize', $SanitizeProvider);
	
	  /* global sanitizeText: false */
	
	  /**
	  * @ngdoc filter
	  * @name linky
	  * @kind function
	  *
	  * @description
	  * Finds links in text input and turns them into html links. Supports `http/https/ftp/mailto` and
	  * plain email address links.
	  *
	  * Requires the {@link ngSanitize `ngSanitize`} module to be installed.
	  *
	  * @param {string} text Input text.
	  * @param {string} target Window (`_blank|_self|_parent|_top`) or named frame to open links in.
	  * @param {object|function(url)} [attributes] Add custom attributes to the link element.
	  *
	  *    Can be one of:
	  *
	  *    - `object`: A map of attributes
	  *    - `function`: Takes the url as a parameter and returns a map of attributes
	  *
	  *    If the map of attributes contains a value for `target`, it overrides the value of
	  *    the target parameter.
	  *
	  *
	  * @returns {string} Html-linkified and {@link $sanitize sanitized} text.
	  *
	  * @usage
	   <span ng-bind-html="linky_expression | linky"></span>
	  *
	  * @example
	   <example module="linkyExample" deps="angular-sanitize.js">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	       Snippet: <textarea ng-model="snippet" cols="60" rows="3"></textarea>
	       <table>
	         <tr>
	           <th>Filter</th>
	           <th>Source</th>
	           <th>Rendered</th>
	         </tr>
	         <tr id="linky-filter">
	           <td>linky filter</td>
	           <td>
	             <pre>&lt;div ng-bind-html="snippet | linky"&gt;<br>&lt;/div&gt;</pre>
	           </td>
	           <td>
	             <div ng-bind-html="snippet | linky"></div>
	           </td>
	         </tr>
	         <tr id="linky-target">
	          <td>linky target</td>
	          <td>
	            <pre>&lt;div ng-bind-html="snippetWithSingleURL | linky:'_blank'"&gt;<br>&lt;/div&gt;</pre>
	          </td>
	          <td>
	            <div ng-bind-html="snippetWithSingleURL | linky:'_blank'"></div>
	          </td>
	         </tr>
	         <tr id="linky-custom-attributes">
	          <td>linky custom attributes</td>
	          <td>
	            <pre>&lt;div ng-bind-html="snippetWithSingleURL | linky:'_self':{rel: 'nofollow'}"&gt;<br>&lt;/div&gt;</pre>
	          </td>
	          <td>
	            <div ng-bind-html="snippetWithSingleURL | linky:'_self':{rel: 'nofollow'}"></div>
	          </td>
	         </tr>
	         <tr id="escaped-html">
	           <td>no filter</td>
	           <td><pre>&lt;div ng-bind="snippet"&gt;<br>&lt;/div&gt;</pre></td>
	           <td><div ng-bind="snippet"></div></td>
	         </tr>
	       </table>
	     </file>
	     <file name="script.js">
	       angular.module('linkyExample', ['ngSanitize'])
	         .controller('ExampleController', ['$scope', function($scope) {
	           $scope.snippet =
	             'Pretty text with some links:\n'+
	             'http://angularjs.org/,\n'+
	             'mailto:us@somewhere.org,\n'+
	             'another@somewhere.org,\n'+
	             'and one more: ftp://127.0.0.1/.';
	           $scope.snippetWithSingleURL = 'http://angularjs.org/';
	         }]);
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should linkify the snippet with urls', function() {
	         expect(element(by.id('linky-filter')).element(by.binding('snippet | linky')).getText()).
	             toBe('Pretty text with some links: http://angularjs.org/, us@somewhere.org, ' +
	                  'another@somewhere.org, and one more: ftp://127.0.0.1/.');
	         expect(element.all(by.css('#linky-filter a')).count()).toEqual(4);
	       });
	         it('should not linkify snippet without the linky filter', function() {
	         expect(element(by.id('escaped-html')).element(by.binding('snippet')).getText()).
	             toBe('Pretty text with some links: http://angularjs.org/, mailto:us@somewhere.org, ' +
	                  'another@somewhere.org, and one more: ftp://127.0.0.1/.');
	         expect(element.all(by.css('#escaped-html a')).count()).toEqual(0);
	       });
	         it('should update', function() {
	         element(by.model('snippet')).clear();
	         element(by.model('snippet')).sendKeys('new http://link.');
	         expect(element(by.id('linky-filter')).element(by.binding('snippet | linky')).getText()).
	             toBe('new http://link.');
	         expect(element.all(by.css('#linky-filter a')).count()).toEqual(1);
	         expect(element(by.id('escaped-html')).element(by.binding('snippet')).getText())
	             .toBe('new http://link.');
	       });
	         it('should work with the target property', function() {
	        expect(element(by.id('linky-target')).
	            element(by.binding("snippetWithSingleURL | linky:'_blank'")).getText()).
	            toBe('http://angularjs.org/');
	        expect(element(by.css('#linky-target a')).getAttribute('target')).toEqual('_blank');
	       });
	         it('should optionally add custom attributes', function() {
	        expect(element(by.id('linky-custom-attributes')).
	            element(by.binding("snippetWithSingleURL | linky:'_self':{rel: 'nofollow'}")).getText()).
	            toBe('http://angularjs.org/');
	        expect(element(by.css('#linky-custom-attributes a')).getAttribute('rel')).toEqual('nofollow');
	       });
	     </file>
	   </example>
	  */
	  angular.module('ngSanitize').filter('linky', ['$sanitize', function ($sanitize) {
	    var LINKY_URL_REGEXP = /((ftp|https?):\/\/|(www\.)|(mailto:)?[A-Za-z0-9._%+-]+@)\S*[^\s.;,(){}<>"\u201d\u2019]/i,
	        MAILTO_REGEXP = /^mailto:/i;
	
	    var linkyMinErr = angular.$$minErr('linky');
	    var isString = angular.isString;
	
	    return function (text, target, attributes) {
	      if (text == null || text === '') return text;
	      if (!isString(text)) throw linkyMinErr('notstring', 'Expected string but received: {0}', text);
	
	      var match;
	      var raw = text;
	      var html = [];
	      var url;
	      var i;
	      while (match = raw.match(LINKY_URL_REGEXP)) {
	        // We can not end in these as they are sometimes found at the end of the sentence
	        url = match[0];
	        // if we did not match ftp/http/www/mailto then assume mailto
	        if (!match[2] && !match[4]) {
	          url = (match[3] ? 'http://' : 'mailto:') + url;
	        }
	        i = match.index;
	        addText(raw.substr(0, i));
	        addLink(url, match[0].replace(MAILTO_REGEXP, ''));
	        raw = raw.substring(i + match[0].length);
	      }
	      addText(raw);
	      return $sanitize(html.join(''));
	
	      function addText(text) {
	        if (!text) {
	          return;
	        }
	        html.push(sanitizeText(text));
	      }
	
	      function addLink(url, text) {
	        var key;
	        html.push('<a ');
	        if (angular.isFunction(attributes)) {
	          attributes = attributes(url);
	        }
	        if (angular.isObject(attributes)) {
	          for (key in attributes) {
	            html.push(key + '="' + attributes[key] + '" ');
	          }
	        } else {
	          attributes = {};
	        }
	        if (angular.isDefined(target) && !('target' in attributes)) {
	          html.push('target="', target, '" ');
	        }
	        html.push('href="', url.replace(/"/g, '&quot;'), '">');
	        addText(text);
	        html.push('</a>');
	      }
	    };
	  }]);
	})(window, window.angular);

/***/ }),
/* 1358 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {/**
	 * x is a value between 0 and 1, indicating where in the animation you are.
	 */
	'use strict';
	
	var duScrollDefaultEasing = function duScrollDefaultEasing(x) {
	  'use strict';
	
	  if (x < 0.5) {
	    return Math.pow(x * 2, 2) / 2;
	  }
	  return 1 - Math.pow((1 - x) * 2, 2) / 2;
	};
	
	var duScroll = angular.module('duScroll', ['duScroll.scrollspy', 'duScroll.smoothScroll', 'duScroll.scrollContainer', 'duScroll.spyContext', 'duScroll.scrollHelpers'])
	//Default animation duration for smoothScroll directive
	.value('duScrollDuration', 350)
	//Scrollspy debounce interval, set to 0 to disable
	.value('duScrollSpyWait', 100)
	//Wether or not multiple scrollspies can be active at once
	.value('duScrollGreedy', false)
	//Default offset for smoothScroll directive
	.value('duScrollOffset', 0)
	//Default easing function for scroll animation
	.value('duScrollEasing', duScrollDefaultEasing)
	//Which events on the container (such as body) should cancel scroll animations
	.value('duScrollCancelOnEvents', 'scroll mousedown mousewheel touchmove keydown')
	//Whether or not to activate the last scrollspy, when page/container bottom is reached
	.value('duScrollBottomSpy', false)
	//Active class name
	.value('duScrollActiveClass', 'active');
	
	if (typeof module !== 'undefined' && module && module.exports) {
	  module.exports = duScroll;
	}
	
	angular.module('duScroll.scrollHelpers', ['duScroll.requestAnimation']).run(['$window', '$q', 'cancelAnimation', 'requestAnimation', 'duScrollEasing', 'duScrollDuration', 'duScrollOffset', 'duScrollCancelOnEvents', function ($window, $q, cancelAnimation, requestAnimation, duScrollEasing, duScrollDuration, duScrollOffset, duScrollCancelOnEvents) {
	  'use strict';
	
	  var proto = {};
	
	  var isDocument = function isDocument(el) {
	    return typeof HTMLDocument !== 'undefined' && el instanceof HTMLDocument || el.nodeType && el.nodeType === el.DOCUMENT_NODE;
	  };
	
	  var isElement = function isElement(el) {
	    return typeof HTMLElement !== 'undefined' && el instanceof HTMLElement || el.nodeType && el.nodeType === el.ELEMENT_NODE;
	  };
	
	  var unwrap = function unwrap(el) {
	    return isElement(el) || isDocument(el) ? el : el[0];
	  };
	
	  proto.duScrollTo = function (left, top, duration, easing) {
	    var aliasFn;
	    if (angular.isElement(left)) {
	      aliasFn = this.duScrollToElement;
	    } else if (angular.isDefined(duration)) {
	      aliasFn = this.duScrollToAnimated;
	    }
	    if (aliasFn) {
	      return aliasFn.apply(this, arguments);
	    }
	    var el = unwrap(this);
	    if (isDocument(el)) {
	      return $window.scrollTo(left, top);
	    }
	    el.scrollLeft = left;
	    el.scrollTop = top;
	  };
	
	  var scrollAnimation, deferred;
	  proto.duScrollToAnimated = function (left, top, duration, easing) {
	    if (duration && !easing) {
	      easing = duScrollEasing;
	    }
	    var startLeft = this.duScrollLeft(),
	        startTop = this.duScrollTop(),
	        deltaLeft = Math.round(left - startLeft),
	        deltaTop = Math.round(top - startTop);
	
	    var startTime = null,
	        progress = 0;
	    var el = this;
	
	    var cancelScrollAnimation = function cancelScrollAnimation($event) {
	      if (!$event || progress && $event.which > 0) {
	        if (duScrollCancelOnEvents) {
	          el.unbind(duScrollCancelOnEvents, cancelScrollAnimation);
	        }
	        cancelAnimation(scrollAnimation);
	        deferred.reject();
	        scrollAnimation = null;
	      }
	    };
	
	    if (scrollAnimation) {
	      cancelScrollAnimation();
	    }
	    deferred = $q.defer();
	
	    if (duration === 0 || !deltaLeft && !deltaTop) {
	      if (duration === 0) {
	        el.duScrollTo(left, top);
	      }
	      deferred.resolve();
	      return deferred.promise;
	    }
	
	    var animationStep = function animationStep(timestamp) {
	      if (startTime === null) {
	        startTime = timestamp;
	      }
	
	      progress = timestamp - startTime;
	      var percent = progress >= duration ? 1 : easing(progress / duration);
	
	      el.scrollTo(startLeft + Math.ceil(deltaLeft * percent), startTop + Math.ceil(deltaTop * percent));
	      if (percent < 1) {
	        scrollAnimation = requestAnimation(animationStep);
	      } else {
	        if (duScrollCancelOnEvents) {
	          el.unbind(duScrollCancelOnEvents, cancelScrollAnimation);
	        }
	        scrollAnimation = null;
	        deferred.resolve();
	      }
	    };
	
	    //Fix random mobile safari bug when scrolling to top by hitting status bar
	    el.duScrollTo(startLeft, startTop);
	
	    if (duScrollCancelOnEvents) {
	      el.bind(duScrollCancelOnEvents, cancelScrollAnimation);
	    }
	
	    scrollAnimation = requestAnimation(animationStep);
	    return deferred.promise;
	  };
	
	  proto.duScrollToElement = function (target, offset, duration, easing) {
	    var el = unwrap(this);
	    if (!angular.isNumber(offset) || isNaN(offset)) {
	      offset = duScrollOffset;
	    }
	    var top = this.duScrollTop() + unwrap(target).getBoundingClientRect().top - offset;
	    if (isElement(el)) {
	      top -= el.getBoundingClientRect().top;
	    }
	    return this.duScrollTo(0, top, duration, easing);
	  };
	
	  proto.duScrollLeft = function (value, duration, easing) {
	    if (angular.isNumber(value)) {
	      return this.duScrollTo(value, this.duScrollTop(), duration, easing);
	    }
	    var el = unwrap(this);
	    if (isDocument(el)) {
	      return $window.scrollX || document.documentElement.scrollLeft || document.body.scrollLeft;
	    }
	    return el.scrollLeft;
	  };
	  proto.duScrollTop = function (value, duration, easing) {
	    if (angular.isNumber(value)) {
	      return this.duScrollTo(this.duScrollLeft(), value, duration, easing);
	    }
	    var el = unwrap(this);
	    if (isDocument(el)) {
	      return $window.scrollY || document.documentElement.scrollTop || document.body.scrollTop;
	    }
	    return el.scrollTop;
	  };
	
	  proto.duScrollToElementAnimated = function (target, offset, duration, easing) {
	    return this.duScrollToElement(target, offset, duration || duScrollDuration, easing);
	  };
	
	  proto.duScrollTopAnimated = function (top, duration, easing) {
	    return this.duScrollTop(top, duration || duScrollDuration, easing);
	  };
	
	  proto.duScrollLeftAnimated = function (left, duration, easing) {
	    return this.duScrollLeft(left, duration || duScrollDuration, easing);
	  };
	
	  angular.forEach(proto, function (fn, key) {
	    angular.element.prototype[key] = fn;
	
	    //Remove prefix if not already claimed by jQuery / ui.utils
	    var unprefixed = key.replace(/^duScroll/, 'scroll');
	    if (angular.isUndefined(angular.element.prototype[unprefixed])) {
	      angular.element.prototype[unprefixed] = fn;
	    }
	  });
	}]);
	
	//Adapted from https://gist.github.com/paulirish/1579671
	angular.module('duScroll.polyfill', []).factory('polyfill', ['$window', function ($window) {
	  'use strict';
	
	  var vendors = ['webkit', 'moz', 'o', 'ms'];
	
	  return function (fnName, fallback) {
	    if ($window[fnName]) {
	      return $window[fnName];
	    }
	    var suffix = fnName.substr(0, 1).toUpperCase() + fnName.substr(1);
	    for (var key, i = 0; i < vendors.length; i++) {
	      key = vendors[i] + suffix;
	      if ($window[key]) {
	        return $window[key];
	      }
	    }
	    return fallback;
	  };
	}]);
	
	angular.module('duScroll.requestAnimation', ['duScroll.polyfill']).factory('requestAnimation', ['polyfill', '$timeout', function (polyfill, $timeout) {
	  'use strict';
	
	  var lastTime = 0;
	  var fallback = function fallback(callback, element) {
	    var currTime = new Date().getTime();
	    var timeToCall = Math.max(0, 16 - (currTime - lastTime));
	    var id = $timeout(function () {
	      callback(currTime + timeToCall);
	    }, timeToCall);
	    lastTime = currTime + timeToCall;
	    return id;
	  };
	
	  return polyfill('requestAnimationFrame', fallback);
	}]).factory('cancelAnimation', ['polyfill', '$timeout', function (polyfill, $timeout) {
	  'use strict';
	
	  var fallback = function fallback(promise) {
	    $timeout.cancel(promise);
	  };
	
	  return polyfill('cancelAnimationFrame', fallback);
	}]);
	
	angular.module('duScroll.spyAPI', ['duScroll.scrollContainerAPI']).factory('spyAPI', ['$rootScope', '$timeout', '$window', '$document', 'scrollContainerAPI', 'duScrollGreedy', 'duScrollSpyWait', 'duScrollBottomSpy', 'duScrollActiveClass', function ($rootScope, $timeout, $window, $document, scrollContainerAPI, duScrollGreedy, duScrollSpyWait, duScrollBottomSpy, duScrollActiveClass) {
	  'use strict';
	
	  var createScrollHandler = function createScrollHandler(context) {
	    var timer = false,
	        queued = false;
	    var handler = function handler() {
	      queued = false;
	      var container = context.container,
	          containerEl = container[0],
	          containerOffset = 0,
	          bottomReached;
	
	      if (typeof HTMLElement !== 'undefined' && containerEl instanceof HTMLElement || containerEl.nodeType && containerEl.nodeType === containerEl.ELEMENT_NODE) {
	        containerOffset = containerEl.getBoundingClientRect().top;
	        bottomReached = Math.round(containerEl.scrollTop + containerEl.clientHeight) >= containerEl.scrollHeight;
	      } else {
	        var documentScrollHeight = $document[0].body.scrollHeight || $document[0].documentElement.scrollHeight; // documentElement for IE11
	        bottomReached = Math.round($window.pageYOffset + $window.innerHeight) >= documentScrollHeight;
	      }
	      var compareProperty = duScrollBottomSpy && bottomReached ? 'bottom' : 'top';
	
	      var i, currentlyActive, toBeActive, spies, spy, pos;
	      spies = context.spies;
	      currentlyActive = context.currentlyActive;
	      toBeActive = undefined;
	
	      for (i = 0; i < spies.length; i++) {
	        spy = spies[i];
	        pos = spy.getTargetPosition();
	        if (!pos) continue;
	
	        if (duScrollBottomSpy && bottomReached || pos.top + spy.offset - containerOffset < 20 && (duScrollGreedy || (pos.top + spy.offsetBottom) * -1 + containerOffset) < pos.height) {
	          //Find the one closest the viewport top or the page bottom if it's reached
	          if (!toBeActive || toBeActive[compareProperty] < pos[compareProperty]) {
	            toBeActive = {
	              spy: spy
	            };
	            toBeActive[compareProperty] = pos[compareProperty];
	          }
	        }
	      }
	
	      if (toBeActive) {
	        toBeActive = toBeActive.spy;
	      }
	      if (currentlyActive === toBeActive || duScrollGreedy && !toBeActive) return;
	      if (currentlyActive) {
	        currentlyActive.$element.removeClass(duScrollActiveClass);
	        $rootScope.$broadcast('duScrollspy:becameInactive', currentlyActive.$element, angular.element(currentlyActive.getTargetElement()));
	      }
	      if (toBeActive) {
	        toBeActive.$element.addClass(duScrollActiveClass);
	        $rootScope.$broadcast('duScrollspy:becameActive', toBeActive.$element, angular.element(toBeActive.getTargetElement()));
	      }
	      context.currentlyActive = toBeActive;
	    };
	
	    if (!duScrollSpyWait) {
	      return handler;
	    }
	
	    //Debounce for potential performance savings
	    return function () {
	      if (!timer) {
	        handler();
	        timer = $timeout(function () {
	          timer = false;
	          if (queued) {
	            handler();
	          }
	        }, duScrollSpyWait, false);
	      } else {
	        queued = true;
	      }
	    };
	  };
	
	  var contexts = {};
	
	  var createContext = function createContext($scope) {
	    var id = $scope.$id;
	    var context = {
	      spies: []
	    };
	
	    context.handler = createScrollHandler(context);
	    contexts[id] = context;
	
	    $scope.$on('$destroy', function () {
	      destroyContext($scope);
	    });
	
	    return id;
	  };
	
	  var destroyContext = function destroyContext($scope) {
	    var id = $scope.$id;
	    var context = contexts[id],
	        container = context.container;
	    if (container) {
	      container.off('scroll', context.handler);
	    }
	    delete contexts[id];
	  };
	
	  var defaultContextId = createContext($rootScope);
	
	  var getContextForScope = function getContextForScope(_x) {
	    var _again = true;
	
	    _function: while (_again) {
	      var scope = _x;
	      _again = false;
	
	      if (contexts[scope.$id]) {
	        return contexts[scope.$id];
	      }
	      if (scope.$parent) {
	        _x = scope.$parent;
	        _again = true;
	        continue _function;
	      }
	      return contexts[defaultContextId];
	    }
	  };
	
	  var getContextForSpy = function getContextForSpy(spy) {
	    var context,
	        contextId,
	        scope = spy.$scope;
	    if (scope) {
	      return getContextForScope(scope);
	    }
	    //No scope, most likely destroyed
	    for (contextId in contexts) {
	      context = contexts[contextId];
	      if (context.spies.indexOf(spy) !== -1) {
	        return context;
	      }
	    }
	  };
	
	  var isElementInDocument = function isElementInDocument(element) {
	    while (element.parentNode) {
	      element = element.parentNode;
	      if (element === document) {
	        return true;
	      }
	    }
	    return false;
	  };
	
	  var addSpy = function addSpy(spy) {
	    var context = getContextForSpy(spy);
	    if (!context) return;
	    context.spies.push(spy);
	    if (!context.container || !isElementInDocument(context.container)) {
	      if (context.container) {
	        context.container.off('scroll', context.handler);
	      }
	      context.container = scrollContainerAPI.getContainer(spy.$scope);
	      context.container.on('scroll', context.handler).triggerHandler('scroll');
	    }
	  };
	
	  var removeSpy = function removeSpy(spy) {
	    var context = getContextForSpy(spy);
	    if (spy === context.currentlyActive) {
	      $rootScope.$broadcast('duScrollspy:becameInactive', context.currentlyActive.$element);
	      context.currentlyActive = null;
	    }
	    var i = context.spies.indexOf(spy);
	    if (i !== -1) {
	      context.spies.splice(i, 1);
	    }
	    spy.$element = null;
	  };
	
	  return {
	    addSpy: addSpy,
	    removeSpy: removeSpy,
	    createContext: createContext,
	    destroyContext: destroyContext,
	    getContextForScope: getContextForScope
	  };
	}]);
	
	angular.module('duScroll.scrollContainerAPI', []).factory('scrollContainerAPI', ['$document', function ($document) {
	  'use strict';
	
	  var containers = {};
	
	  var setContainer = function setContainer(scope, element) {
	    var id = scope.$id;
	    containers[id] = element;
	    return id;
	  };
	
	  var getContainerId = function getContainerId(_x2) {
	    var _again2 = true;
	
	    _function2: while (_again2) {
	      var scope = _x2;
	      _again2 = false;
	
	      if (containers[scope.$id]) {
	        return scope.$id;
	      }
	      if (scope.$parent) {
	        _x2 = scope.$parent;
	        _again2 = true;
	        continue _function2;
	      }
	      return;
	    }
	  };
	
	  var getContainer = function getContainer(scope) {
	    var id = getContainerId(scope);
	    return id ? containers[id] : $document;
	  };
	
	  var removeContainer = function removeContainer(scope) {
	    var id = getContainerId(scope);
	    if (id) {
	      delete containers[id];
	    }
	  };
	
	  return {
	    getContainerId: getContainerId,
	    getContainer: getContainer,
	    setContainer: setContainer,
	    removeContainer: removeContainer
	  };
	}]);
	
	angular.module('duScroll.smoothScroll', ['duScroll.scrollHelpers', 'duScroll.scrollContainerAPI']).directive('duSmoothScroll', ['duScrollDuration', 'duScrollOffset', 'scrollContainerAPI', function (duScrollDuration, duScrollOffset, scrollContainerAPI) {
	  'use strict';
	
	  return {
	    link: function link($scope, $element, $attr) {
	      $element.on('click', function (e) {
	        if ((!$attr.href || $attr.href.indexOf('#') === -1) && $attr.duSmoothScroll === '') return;
	
	        var id = $attr.href ? $attr.href.replace(/.*(?=#[^\s]+$)/, '').substring(1) : $attr.duSmoothScroll;
	
	        var target = document.getElementById(id) || document.getElementsByName(id)[0];
	        if (!target || !target.getBoundingClientRect) return;
	
	        if (e.stopPropagation) e.stopPropagation();
	        if (e.preventDefault) e.preventDefault();
	
	        var offset = $attr.offset ? parseInt($attr.offset, 10) : duScrollOffset;
	        var duration = $attr.duration ? parseInt($attr.duration, 10) : duScrollDuration;
	        var container = scrollContainerAPI.getContainer($scope);
	
	        container.duScrollToElement(angular.element(target), isNaN(offset) ? 0 : offset, isNaN(duration) ? 0 : duration);
	      });
	    }
	  };
	}]);
	
	angular.module('duScroll.spyContext', ['duScroll.spyAPI']).directive('duSpyContext', ['spyAPI', function (spyAPI) {
	  'use strict';
	
	  return {
	    restrict: 'A',
	    scope: true,
	    compile: function compile(tElement, tAttrs, transclude) {
	      return {
	        pre: function preLink($scope, iElement, iAttrs, controller) {
	          spyAPI.createContext($scope);
	        }
	      };
	    }
	  };
	}]);
	
	angular.module('duScroll.scrollContainer', ['duScroll.scrollContainerAPI']).directive('duScrollContainer', ['scrollContainerAPI', function (scrollContainerAPI) {
	  'use strict';
	
	  return {
	    restrict: 'A',
	    scope: true,
	    compile: function compile(tElement, tAttrs, transclude) {
	      return {
	        pre: function preLink($scope, iElement, iAttrs, controller) {
	          iAttrs.$observe('duScrollContainer', function (element) {
	            if (angular.isString(element)) {
	              element = document.getElementById(element);
	            }
	
	            element = angular.isElement(element) ? angular.element(element) : iElement;
	            scrollContainerAPI.setContainer($scope, element);
	            $scope.$on('$destroy', function () {
	              scrollContainerAPI.removeContainer($scope);
	            });
	          });
	        }
	      };
	    }
	  };
	}]);
	
	angular.module('duScroll.scrollspy', ['duScroll.spyAPI']).directive('duScrollspy', ['spyAPI', 'duScrollOffset', '$timeout', '$rootScope', function (spyAPI, duScrollOffset, $timeout, $rootScope) {
	  'use strict';
	
	  var Spy = function Spy(targetElementOrId, $scope, $element, offset, offsetBottom) {
	    if (angular.isElement(targetElementOrId)) {
	      this.target = targetElementOrId;
	    } else if (angular.isString(targetElementOrId)) {
	      this.targetId = targetElementOrId;
	    }
	    this.$scope = $scope;
	    this.$element = $element;
	    this.offset = offset;
	    this.offsetBottom = offsetBottom;
	  };
	
	  Spy.prototype.getTargetElement = function () {
	    if (!this.target && this.targetId) {
	      this.target = document.getElementById(this.targetId) || document.getElementsByName(this.targetId)[0];
	    }
	    return this.target;
	  };
	
	  Spy.prototype.getTargetPosition = function () {
	    var target = this.getTargetElement();
	    if (target) {
	      return target.getBoundingClientRect();
	    }
	  };
	
	  Spy.prototype.flushTargetCache = function () {
	    if (this.targetId) {
	      this.target = undefined;
	    }
	  };
	
	  return {
	    link: function link($scope, $element, $attr) {
	      var href = $attr.ngHref || $attr.href;
	      var targetId;
	
	      if (href && href.indexOf('#') !== -1) {
	        targetId = href.replace(/.*(?=#[^\s]+$)/, '').substring(1);
	      } else if ($attr.duScrollspy) {
	        targetId = $attr.duScrollspy;
	      } else if ($attr.duSmoothScroll) {
	        targetId = $attr.duSmoothScroll;
	      }
	      if (!targetId) return;
	
	      // Run this in the next execution loop so that the scroll context has a chance
	      // to initialize
	      var timeoutPromise = $timeout(function () {
	        var spy = new Spy(targetId, $scope, $element, -($attr.offset ? parseInt($attr.offset, 10) : duScrollOffset), -($attr.offsetBottom ? parseInt($attr.offsetBottom, 10) : 0));
	        spyAPI.addSpy(spy);
	
	        $scope.$on('$locationChangeSuccess', spy.flushTargetCache.bind(spy));
	        var deregisterOnStateChange = $rootScope.$on('$stateChangeSuccess', spy.flushTargetCache.bind(spy));
	        $scope.$on('$destroy', function () {
	          spyAPI.removeSpy(spy);
	          deregisterOnStateChange();
	        });
	      }, 0, false);
	      $scope.$on('$destroy', function () {
	        $timeout.cancel(timeoutPromise);
	      });
	    }
	  };
	}]);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(453)(module)))

/***/ }),
/* 1359 */
/***/ (function(module, exports) {

	/**
	 * angular-fancy-modal - the definitive modal/popup/dialog solution for AngularJS.
	 * @author Alessandro Arnodo
	 * @author Arseny Peisakhov
	 *    06-08-2015 - modified module to re-use an existing overlay and disable animations
	 * @url http://alessandro.arnodo.net
	 * @version v0.1.5
	 * @link https://github.com/vesparny/angular-fancy-modal
	 * @license MIT
	 */
	'use strict';
	
	(function (angular, document, window, undefined) {
	  'use strict';
	  angular.module('vesparny.fancyModal', []).provider('$fancyModal', function () {
	    var defaults = this.defaults = {
	      templateUrl: '',
	      template: '<div></div>',
	      resolve: {},
	      controller: '',
	      scope: '',
	      showCloseButton: true,
	      closeOnEscape: true,
	      closeOnOverlayClick: true,
	      overlay: true,
	      themeClass: '',
	      openingClass: 'fancymodal-content-opening',
	      closingClass: 'fancymodal-content-closing',
	      openingOverlayClass: 'fancymodal-overlay-opening',
	      closingOverlayClass: 'fancymodal-overlay-closing',
	      bodyClass: 'fancymodal-open'
	    };
	
	    /**
	     * [setDefaults overriding defaults]
	     * @param {[Object]} options [new defaults]
	     */
	    this.setDefaults = function (options) {
	      angular.extend(this.defaults, options);
	    };
	
	    this.$get = ['$controller', '$timeout', '$rootScope', '$injector', '$compile', '$http', '$templateCache', '$window', '$document', '$q', function ($controller, $timeout, $rootScope, $injector, $compile, $http, $templateCache, $window, $document, $q) {
	      var isieEdge = navigator.appName == 'Netscape' && navigator.appVersion.indexOf('Trident') === -1;
	      var modalCounter = 0;
	      var incrementalId = 0;
	      var isClosing = false;
	
	      var style = (document.body || document.documentElement).style;
	
	      var animationEndSupport = angular.isDefined(style.animation) || angular.isDefined(style.WebkitAnimation) || angular.isDefined(style.MozAnimation) || angular.isDefined(style.MsAnimation) || angular.isDefined(style.OAnimation);
	
	      var animationEndEvent = 'animationend webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend';
	
	      var $body = angular.element(document).find('body');
	      var $html = angular.element(document).find('html');
	
	      // private methds
	
	      function onKeydown(event) {
	        if (event.keyCode === 27) {
	          _close();
	        }
	      }
	
	      //http://davidwalsh.name/detect-scrollbar-width
	      function getScrollBarWidth() {
	        var scrollDiv = document.createElement('div');
	
	        scrollDiv.style.cssText = 'width: 99px; height: 99px; overflow: scroll; position: absolute; top: -9999px;';
	
	        document.body.appendChild(scrollDiv);
	
	        var size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
	        document.body.removeChild(scrollDiv);
	
	        return size;
	      }
	
	      function hasScrollbars() {
	        return $body[0].scrollHeight > $window.innerHeight;
	      }
	
	      function getTemplatePromise(options) {
	        var deferred = $q.defer();
	
	        if (options.templateUrl) {
	          $http.get(options.templateUrl, {
	            cache: $templateCache
	          }).then(function (result) {
	            deferred.resolve(result.data);
	          });
	        } else {
	          deferred.resolve(options.template);
	        }
	
	        return deferred.promise;
	      }
	
	      function getResolvePromises(resolves) {
	        var promisesArr = [];
	
	        angular.forEach(resolves, function (value) {
	          promisesArr.push($q.when($injector.invoke(value)));
	        });
	
	        return promisesArr;
	      }
	
	      function cleanUp($modal) {
	        var elementId = $modal.attr('id');
	
	        //$modal.scope().$destroy();
	        $modal.remove();
	
	        isClosing = false;
	
	        if (modalCounter <= 0) {
	          // Updated by Seny
	          $body.removeClass(defaults.bodyClass);
	          $html.css('margin-right', '');
	        }
	
	        $rootScope.$emit('$fancyModal.closed', elementId);
	      }
	
	      function bodyFreezeScroll() {
	        var $bod = $(window.document.body);
	        var bodyWidth = $bod.innerWidth();
	        $bod.css('overflow', 'hidden');
	        $bod.css('marginRight', ($bod.css('marginRight') ? '+=' : '') + ($bod.innerWidth() - bodyWidth));
	      }
	
	      function bodyUnfreezeScroll() {
	        var $bod = $(window.document.body);
	        var bodyWidth = $bod.innerWidth();
	        $bod.css('marginRight', '-=' + (bodyWidth - $body.innerWidth()));
	        $bod.css('overflow', 'auto');
	      }
	
	      function closeModal(modal) {
	        var $modal = angular.element(modal);
	        var options = $modal.data('options');
	
	        isClosing = true;
	
	        $modal.unbind('click');
	
	        if (modalCounter === 1) {
	          $document.unbind('keydown');
	        }
	
	        modalCounter -= 1;
	
	        // Updated by Seny
	        var overlay = $('body > .fancymodal-overlay');
	
	        if (animationEndSupport && !$body.hasClass('quickModalTransition')) {
	          var content = angular.element(modal.children[0]);
	
	          if (options.overlay) {
	            // Updated by Seny
	            if (overlay.length) {
	              overlay.removeClass(options.openingOverlayClass).addClass(options.closingOverlayClass);
	            } else {
	              overlay = angular.element(modal.children[0]);
	              overlay.addClass(options.closingOverlayClass);
	              content = angular.element(modal.children[1]);
	            }
	          }
	
	          content.unbind(animationEndEvent).bind(animationEndEvent, function () {
	            content.remove();
	            cleanUp($modal);
	          }).removeClass(options.openingClass).addClass(options.closingClass);
	        } else {
	          cleanUp($modal);
	        }
	
	        // Updated by Seny
	        if ($body.hasClass('noModalAnimation')) {
	          $body.removeClass('quickModalTransition noModalAnimation');
	          overlay.removeClass(options.openingOverlayClass);
	        }
	      }
	
	      function closeAll() {
	        var modals = document.querySelectorAll('.fancymodal');
	
	        angular.forEach(modals, function (modal) {
	          closeModal(modal);
	        });
	      }
	
	      // public API
	
	      /**
	       * open a modal
	       * @param  {[object]} opts [modal params]
	       * @return Promise
	       */
	      function _open(opts) {
	        function closeByAction(event) {
	          var overlay = angular.element(event.target).hasClass('fancymodal-overlay');
	          var closeBtn = angular.element(event.target).hasClass('fancymodal-close');
	
	          if (overlay && options.closeOnOverlayClick || closeBtn) {
	            _close(modal.attr('id'));
	          }
	        }
	
	        function execOpen($modal) {
	          var defer = $q.defer();
	          var htmlTemplate;
	
	          getTemplatePromise(options).then(function (template) {
	            htmlTemplate = template;
	            return $q.all(getResolvePromises(options.resolve));
	          }).then(function (locals) {
	            if (!isClosing) {
	              var data = {};
	              var resolveCounter = 0;
	              var ctrl;
	              angular.forEach(options.resolve, function (value, key) {
	                data[key] = locals[resolveCounter];
	                resolveCounter += 1;
	              });
	              scope.$modal = $modal;
	              data.$scope = scope;
	              if (options.controller) {
	                ctrl = $controller(options.controller, data);
	              }
	
	              if (isieEdge) {
	                $timeout(function () {
	                  contentData.append($compile(htmlTemplate)(scope));
	                }, 0);
	              } else {
	                contentData.append($compile(htmlTemplate)(scope));
	              }
	
	              $rootScope.$emit('$fancyModal.opened', modal);
	              defer.resolve();
	            } else {
	              defer.reject();
	            }
	          });
	
	          return defer.promise;
	        }
	
	        var options = angular.copy(defaults);
	        opts = opts || {};
	        angular.extend(options, opts);
	        modalCounter += 1;
	        incrementalId += 1;
	
	        $body.addClass(options.bodyClass);
	
	        if (hasScrollbars()) {
	          $html.css('margin-right', getScrollBarWidth() + 'px');
	        }
	
	        var scope = (options.scope || $rootScope).$new();
	
	        var modal = angular.element('<div id="fancymodal-' + incrementalId + '" class="fancymodal"></div>').addClass(options.themeClass);
	
	        modal.data('options', options);
	        var content = angular.element('<div>').addClass('fancymodal-content');
	
	        if (options.showCloseButton) {
	          var closeButton = angular.element('<div>').addClass('fancymodal-close');
	          content.append(closeButton);
	        }
	
	        if (options.closeOnEscape) {
	          $document.bind('keydown', onKeydown);
	        }
	
	        var contentData = angular.element('<div>').addClass('fancymodal-data');
	
	        if (options.overlay) {
	          var overlay = $('body > .fancymodal-overlay');
	
	          if (overlay.length) {
	            $('body > .fancymodal-overlay').removeClass(options.closingOverlayClass).addClass(options.openingOverlayClass);
	          } else {
	            overlay = angular.element('<div>').addClass('fancymodal-overlay').addClass(options.openingOverlayClass);
	
	            modal.append(overlay);
	          }
	        }
	
	        content.append(contentData);
	        content.addClass(options.openingClass);
	
	        modal.bind('click', closeByAction);
	        modal.append(content);
	
	        if (isieEdge) {
	          $timeout(function () {
	            $body.append($compile(modal)(scope));
	          }, 0);
	        } else {
	          $body.append($compile(modal)(scope));
	        }
	
	        //$body.append($compile(modal)(scope));
	
	        var id = 'fancymodal-' + incrementalId;
	        var $modal = {
	          id: id,
	          close: function close() {
	            return _close(id);
	          }
	        };
	        // open the dialog
	        var openPromise = execOpen($modal);
	
	        return angular.extend({
	          opened: openPromise
	        }, $modal);
	      }
	      /**
	       * [close close a modal]
	       * @param  {[integer]} id [the id of the modal to be closed]
	       */
	      function _close(id) {
	        var modal = document.getElementById(id);
	        if (modal) {
	          closeModal(modal);
	        } else {
	          closeAll();
	        }
	      }
	
	      return {
	        open: function open(options) {
	          return _open(options);
	        },
	        close: function close(id) {
	          return _close(id);
	        },
	        getDefaults: function getDefaults() {
	          return angular.copy(defaults);
	        }
	      };
	    }];
	  }).directive('fancyModal', ['$fancyModal', function ($fancyModal) {
	    return {
	      restrict: 'A',
	      link: function link(scope, element, attrs) {
	        var modal;
	        var options;
	        // Trigger
	        element.on(attrs.trigger || 'click', function () {
	          options = $fancyModal.getDefaults();
	          angular.forEach(Object.keys(options), function (key) {
	            if (angular.isDefined(attrs[key])) {
	              //TODO fix this, it sucks bad
	              if (attrs[key] === 'true') {
	                options[key] = true;
	              } else if (attrs[key] === 'false') {
	                options[key] = false;
	              } else {
	                options[key] = attrs[key];
	              }
	            }
	          });
	          modal = $fancyModal.open(options);
	        });
	
	        // Garbage collection
	        scope.$on('$destroy', function () {
	          if (modal) {
	            modal.opened.then(function () {
	              modal.close();
	              modal = null;
	            });
	          } else {
	            modal = null;
	          }
	          options = null;
	        });
	      }
	    };
	  }]);
	})(angular, document, window);

/***/ }),
/* 1360 */
/***/ (function(module, exports) {

	/*** Directives and services for responding to idle users in AngularJS
	 * @author Mike Grabski <me@mikegrabski.com>
	 * @version v1.2.2
	 * @link https://github.com/HackedByChinese/ng-idle.git
	 * @license MIT
	 */
	'use strict';
	
	(function (window, angular, undefined) {
	  'use strict';
	  angular.module('ngIdle', ['ngIdle.keepalive', 'ngIdle.idle', 'ngIdle.countdown', 'ngIdle.title', 'ngIdle.localStorage']);
	  angular.module('ngIdle.keepalive', []).provider('Keepalive', function () {
	    var options = {
	      http: null,
	      interval: 10 * 60
	    };
	
	    this.http = function (value) {
	      if (!value) throw new Error('Argument must be a string containing a URL, or an object containing the HTTP request configuration.');
	      if (angular.isString(value)) {
	        value = {
	          url: value,
	          method: 'GET'
	        };
	      }
	
	      value.cache = false;
	
	      options.http = value;
	    };
	
	    var setInterval = this.interval = function (seconds) {
	      seconds = parseInt(seconds);
	
	      if (isNaN(seconds) || seconds <= 0) throw new Error('Interval must be expressed in seconds and be greater than 0.');
	      options.interval = seconds;
	    };
	
	    this.$get = ['$rootScope', '$log', '$interval', '$http', function ($rootScope, $log, $interval, $http) {
	      var state = {
	        ping: null
	      };
	
	      function handleResponse(data, status) {
	        $rootScope.$broadcast('KeepaliveResponse', data, status);
	      }
	
	      function _ping() {
	        $rootScope.$broadcast('Keepalive');
	
	        if (angular.isObject(options.http)) {
	          $http(options.http).success(handleResponse).error(handleResponse);
	        }
	      }
	
	      return {
	        _options: function _options() {
	          return options;
	        },
	        setInterval: setInterval,
	        start: function start() {
	          $interval.cancel(state.ping);
	
	          state.ping = $interval(_ping, options.interval * 1000);
	          return state.ping;
	        },
	        stop: function stop() {
	          $interval.cancel(state.ping);
	        },
	        ping: function ping() {
	          _ping();
	        }
	      };
	    }];
	  });
	
	  angular.module('ngIdle.idle', ['ngIdle.keepalive', 'ngIdle.localStorage']).provider('Idle', function () {
	    var options = {
	      idle: 20 * 60, // in seconds (default is 20min)
	      timeout: 30, // in seconds (default is 30sec)
	      autoResume: 'idle', // lets events automatically resume (unsets idle state/resets warning)
	      interrupt: 'mousemove keydown DOMMouseScroll mousewheel mousedown touchstart touchmove scroll',
	      windowInterrupt: null,
	      keepalive: true
	    };
	
	    /**
	     *  Sets the number of seconds a user can be idle before they are considered timed out.
	     *  @param {Number|Boolean} seconds A positive number representing seconds OR 0 or false to disable this feature.
	     */
	    var _setTimeout = this.timeout = function (seconds) {
	      if (seconds === false) options.timeout = 0;else if (angular.isNumber(seconds) && seconds >= 0) options.timeout = seconds;else throw new Error('Timeout must be zero or false to disable the feature, or a positive integer (in seconds) to enable it.');
	    };
	
	    this.interrupt = function (events) {
	      options.interrupt = events;
	    };
	
	    this.windowInterrupt = function (events) {
	      options.windowInterrupt = events;
	    };
	
	    var _setIdle = this.idle = function (seconds) {
	      if (seconds <= 0) throw new Error('Idle must be a value in seconds, greater than 0.');
	
	      options.idle = seconds;
	    };
	
	    this.autoResume = function (value) {
	      if (value === true) options.autoResume = 'idle';else if (value === false) options.autoResume = 'off';else options.autoResume = value;
	    };
	
	    this.keepalive = function (enabled) {
	      options.keepalive = enabled === true;
	    };
	
	    this.$get = ['$interval', '$log', '$rootScope', '$document', 'Keepalive', 'IdleLocalStorage', '$window', function ($interval, $log, $rootScope, $document, Keepalive, LocalStorage, $window) {
	      var state = {
	        idle: null,
	        timeout: null,
	        idling: false,
	        running: false,
	        countdown: null
	      };
	
	      var id = new Date().getTime();
	
	      function startKeepalive() {
	        if (!options.keepalive) return;
	
	        if (state.running) Keepalive.ping();
	
	        Keepalive.start();
	      }
	
	      function stopKeepalive() {
	        if (!options.keepalive) return;
	
	        Keepalive.stop();
	      }
	
	      function toggleState() {
	        state.idling = !state.idling;
	        var name = state.idling ? 'IdleStart' : 'IdleEnd';
	
	        if (state.idling) {
	          $rootScope.$broadcast(name);
	          stopKeepalive();
	          if (options.timeout) {
	            state.countdown = options.timeout;
	            countdown();
	            state.timeout = $interval(countdown, 1000, options.timeout, false);
	          }
	        } else {
	          startKeepalive();
	          $rootScope.$broadcast(name);
	        }
	
	        $interval.cancel(state.idle);
	      }
	
	      function countdown() {
	        // check not called when no longer idling
	        // possible with multiple tabs
	        if (!state.idling) {
	          return;
	        }
	
	        // countdown has expired, so signal timeout
	        if (state.countdown <= 0) {
	          timeout();
	          return;
	        }
	
	        // countdown hasn't reached zero, so warn and decrement
	        $rootScope.$broadcast('IdleWarn', state.countdown);
	        state.countdown--;
	      }
	
	      function timeout() {
	        stopKeepalive();
	        $interval.cancel(state.idle);
	        $interval.cancel(state.timeout);
	
	        state.idling = true;
	        state.running = false;
	        state.countdown = 0;
	
	        $rootScope.$broadcast('IdleTimeout');
	      }
	
	      function changeOption(self, fn, value) {
	        var reset = self.running();
	
	        self.unwatch();
	        fn(value);
	        if (reset) self.watch();
	      }
	
	      function getExpiry() {
	        var obj = LocalStorage.get('expiry');
	
	        return obj && obj.time ? new Date(obj.time) : null;
	      }
	
	      function setExpiry(date) {
	        if (!date) LocalStorage.remove('expiry');else LocalStorage.set('expiry', { id: id, time: date });
	      }
	
	      var svc = {
	        _options: function _options() {
	          return options;
	        },
	        _getNow: function _getNow() {
	          return new Date();
	        },
	        getIdle: function getIdle() {
	          return options.idle;
	        },
	        getTimeout: function getTimeout() {
	          return options.timeout;
	        },
	        setIdle: function setIdle(seconds) {
	          changeOption(this, _setIdle, seconds);
	        },
	        setTimeout: function setTimeout(seconds) {
	          changeOption(this, _setTimeout, seconds);
	        },
	        isExpired: function isExpired() {
	          var expiry = getExpiry();
	          return expiry !== null && expiry <= this._getNow();
	        },
	        running: function running() {
	          return state.running;
	        },
	        idling: function idling() {
	          return state.idling;
	        },
	        watch: function watch(noExpiryUpdate) {
	          $interval.cancel(state.idle);
	          $interval.cancel(state.timeout);
	
	          // calculate the absolute expiry date, as added insurance against a browser sleeping or paused in the background
	          var timeout = !options.timeout ? 0 : options.timeout;
	          if (!noExpiryUpdate) setExpiry(new Date(new Date().getTime() + (options.idle + timeout) * 1000));
	
	          if (state.idling) toggleState();
	          // clears the idle state if currently idling
	          else if (!state.running) startKeepalive(); // if about to run, start keep alive
	
	          state.running = true;
	
	          state.idle = $interval(toggleState, options.idle * 1000, 0, false);
	        },
	        unwatch: function unwatch() {
	          $interval.cancel(state.idle);
	          $interval.cancel(state.timeout);
	
	          state.idling = false;
	          state.running = false;
	          setExpiry(null);
	
	          stopKeepalive();
	        },
	        interrupt: function interrupt(anotherTab) {
	          if (!state.running) return;
	
	          if (options.timeout && this.isExpired()) {
	            timeout();
	            return;
	          }
	
	          // note: you can no longer auto resume once we exceed the expiry; you will reset state by calling watch() manually
	          if (anotherTab || options.autoResume === 'idle' || options.autoResume === 'notIdle' && !state.idling) this.watch(anotherTab);
	        }
	      };
	
	      var lastMove = {
	        clientX: null,
	        clientY: null,
	        swap: function swap(event) {
	          var last = { clientX: this.clientX, clientY: this.clientY };
	          this.clientX = event.clientX;
	          this.clientY = event.clientY;
	          return last;
	        },
	        hasMoved: function hasMoved(event) {
	          var last = this.swap(event);
	          if (this.clientX === null || event.movementX || event.movementY) return true;else if (last.clientX != event.clientX || last.clientY != event.clientY) return true;else return false;
	        }
	      };
	
	      $document.find('html').on(options.interrupt, function (event) {
	        if (event.type === 'mousemove' && event.originalEvent && event.originalEvent.movementX === 0 && event.originalEvent.movementY === 0) {
	          return; // Fix for Chrome desktop notifications, triggering mousemove event.
	        }
	
	        if (event.type !== 'mousemove' || lastMove.hasMoved(event)) {
	          svc.interrupt();
	        }
	      });
	
	      if (options.windowInterrupt) {
	        var eventList = options.windowInterrupt.split(' ');
	        var fn = function fn() {
	          svc.interrupt();
	        };
	
	        for (var i = 0; i < eventList.length; i++) {
	          if ($window.addEventListener) $window.addEventListener(eventList[i], fn, false);else $window.attachEvent(eventList[i], fn);
	        }
	      }
	
	      var wrap = function wrap(event) {
	        if (event.key === 'ngIdle.expiry' && event.newValue && event.newValue !== event.oldValue) {
	          var val = angular.fromJson(event.newValue);
	          if (val.id === id) return;
	          svc.interrupt(true);
	        }
	      };
	
	      if ($window.addEventListener) $window.addEventListener('storage', wrap, false);else $window.attachEvent('onstorage', wrap);
	
	      return svc;
	    }];
	  });
	
	  angular.module('ngIdle.countdown', ['ngIdle.idle']).directive('idleCountdown', ['Idle', function (Idle) {
	    return {
	      restrict: 'A',
	      scope: {
	        value: '=idleCountdown'
	      },
	      link: function link($scope) {
	        // Initialize the scope's value to the configured timeout.
	        $scope.value = Idle.getTimeout();
	
	        $scope.$on('IdleWarn', function (e, countdown) {
	          $scope.$evalAsync(function () {
	            $scope.value = countdown;
	          });
	        });
	
	        $scope.$on('IdleTimeout', function () {
	          $scope.$evalAsync(function () {
	            $scope.value = 0;
	          });
	        });
	      }
	    };
	  }]);
	
	  angular.module('ngIdle.title', []).provider('Title', function () {
	    var options = {
	      enabled: true
	    };
	
	    var setEnabled = this.enabled = function (enabled) {
	      options.enabled = enabled === true;
	    };
	
	    function padLeft(nr, n, str) {
	      return new Array(n - String(nr).length + 1).join(str || '0') + nr;
	    }
	
	    this.$get = ['$document', '$interpolate', function ($document, $interpolate) {
	      var state = {
	        original: null,
	        idle: '{{minutes}}:{{seconds}} until your session times out!',
	        timedout: 'Your session has expired.'
	      };
	
	      return {
	        setEnabled: setEnabled,
	        isEnabled: function isEnabled() {
	          return options.enabled;
	        },
	        original: function original(val) {
	          if (angular.isUndefined(val)) return state.original;
	
	          state.original = val;
	        },
	        store: function store(overwrite) {
	          if (overwrite || !state.original) state.original = this.value();
	        },
	        value: function value(val) {
	          if (angular.isUndefined(val)) return $document[0].title;
	
	          $document[0].title = val;
	        },
	        idleMessage: function idleMessage(val) {
	          if (angular.isUndefined(val)) return state.idle;
	
	          state.idle = val;
	        },
	        timedOutMessage: function timedOutMessage(val) {
	          if (angular.isUndefined(val)) return state.timedout;
	
	          state.timedout = val;
	        },
	        setAsIdle: function setAsIdle(countdown) {
	          this.store();
	
	          var remaining = { totalSeconds: countdown };
	          remaining.minutes = Math.floor(countdown / 60);
	          remaining.seconds = padLeft(countdown - remaining.minutes * 60, 2);
	
	          this.value($interpolate(this.idleMessage())(remaining));
	        },
	        setAsTimedOut: function setAsTimedOut() {
	          this.store();
	
	          this.value(this.timedOutMessage());
	        },
	        restore: function restore() {
	          if (this.original()) this.value(this.original());
	        }
	      };
	    }];
	  }).directive('title', ['Title', function (Title) {
	    return {
	      restrict: 'E',
	      link: function link($scope, $element, $attr) {
	        if (!Title.isEnabled() || $attr.idleDisabled) return;
	
	        Title.store(true);
	
	        $scope.$on('IdleStart', function () {
	          Title.original($element[0].innerText);
	        });
	
	        $scope.$on('IdleWarn', function (e, countdown) {
	          Title.setAsIdle(countdown);
	        });
	
	        $scope.$on('IdleEnd', function () {
	          Title.restore();
	        });
	
	        $scope.$on('IdleTimeout', function () {
	          Title.setAsTimedOut();
	        });
	      }
	    };
	  }]);
	
	  angular.module('ngIdle.localStorage', []).service('IdleStorageAccessor', ['$window', function ($window) {
	    return {
	      get: function get() {
	        return $window.localStorage;
	      }
	    };
	  }]).service('IdleLocalStorage', ['IdleStorageAccessor', function (IdleStorageAccessor) {
	    function AlternativeStorage() {
	      var storageMap = {};
	
	      this.setItem = function (key, value) {
	        storageMap[key] = value;
	      };
	
	      this.getItem = function (key) {
	        if (typeof storageMap[key] !== 'undefined') {
	          return storageMap[key];
	        }
	        return null;
	      };
	
	      this.removeItem = function (key) {
	        storageMap[key] = undefined;
	      };
	    }
	
	    function getStorage() {
	      try {
	        var s = IdleStorageAccessor.get();
	        s.setItem('ngIdleStorage', '');
	        s.removeItem('ngIdleStorage');
	
	        return s;
	      } catch (err) {
	        return new AlternativeStorage();
	      }
	    }
	
	    // Safari, in Private Browsing Mode, looks like it supports localStorage but all calls to setItem
	    // throw QuotaExceededError. We're going to detect this and just silently drop any calls to setItem
	    // to avoid the entire page breaking, without having to do a check at each usage of Storage.
	    var storage = getStorage();
	
	    return {
	      set: function set(key, value) {
	        storage.setItem('ngIdle.' + key, angular.toJson(value));
	      },
	      get: function get(key) {
	        return angular.fromJson(storage.getItem('ngIdle.' + key));
	      },
	      remove: function remove(key) {
	        storage.removeItem('ngIdle.' + key);
	      },
	      _wrapped: function _wrapped() {
	        return storage;
	      }
	    };
	  }]);
	})(window, window.angular);

/***/ }),
/* 1361 */
/***/ (function(module, exports) {

	/*!
	 * ui-select
	 * http://github.com/angular-ui/ui-select
	 * Version: 0.19.7 - 2017-04-15T14:28:36.649Z
	 * License: MIT
	 */
	
	'use strict';
	
	(function () {
	  'use strict';
	  var KEY = {
	    TAB: 9,
	    ENTER: 13,
	    ESC: 27,
	    SPACE: 32,
	    LEFT: 37,
	    UP: 38,
	    RIGHT: 39,
	    DOWN: 40,
	    SHIFT: 16,
	    CTRL: 17,
	    ALT: 18,
	    PAGE_UP: 33,
	    PAGE_DOWN: 34,
	    HOME: 36,
	    END: 35,
	    BACKSPACE: 8,
	    DELETE: 46,
	    COMMAND: 91,
	
	    MAP: {
	      91: 'COMMAND',
	      8: 'BACKSPACE',
	      9: 'TAB',
	      13: 'ENTER',
	      16: 'SHIFT',
	      17: 'CTRL',
	      18: 'ALT',
	      19: 'PAUSEBREAK',
	      20: 'CAPSLOCK',
	      27: 'ESC',
	      32: 'SPACE',
	      33: 'PAGE_UP',
	      34: 'PAGE_DOWN',
	      35: 'END',
	      36: 'HOME',
	      37: 'LEFT',
	      38: 'UP',
	      39: 'RIGHT',
	      40: 'DOWN',
	      43: '+',
	      44: 'PRINTSCREEN',
	      45: 'INSERT',
	      46: 'DELETE',
	      48: '0',
	      49: '1',
	      50: '2',
	      51: '3',
	      52: '4',
	      53: '5',
	      54: '6',
	      55: '7',
	      56: '8',
	      57: '9',
	      59: ';',
	      61: '=',
	      65: 'A',
	      66: 'B',
	      67: 'C',
	      68: 'D',
	      69: 'E',
	      70: 'F',
	      71: 'G',
	      72: 'H',
	      73: 'I',
	      74: 'J',
	      75: 'K',
	      76: 'L',
	      77: 'M',
	      78: 'N',
	      79: 'O',
	      80: 'P',
	      81: 'Q',
	      82: 'R',
	      83: 'S',
	      84: 'T',
	      85: 'U',
	      86: 'V',
	      87: 'W',
	      88: 'X',
	      89: 'Y',
	      90: 'Z',
	      96: '0',
	      97: '1',
	      98: '2',
	      99: '3',
	      100: '4',
	      101: '5',
	      102: '6',
	      103: '7',
	      104: '8',
	      105: '9',
	      106: '*',
	      107: '+',
	      109: '-',
	      110: '.',
	      111: '/',
	      112: 'F1',
	      113: 'F2',
	      114: 'F3',
	      115: 'F4',
	      116: 'F5',
	      117: 'F6',
	      118: 'F7',
	      119: 'F8',
	      120: 'F9',
	      121: 'F10',
	      122: 'F11',
	      123: 'F12',
	      144: 'NUMLOCK',
	      145: 'SCROLLLOCK',
	      186: ';',
	      187: '=',
	      188: ',',
	      189: '-',
	      190: '.',
	      191: '/',
	      192: '`',
	      219: '[',
	      220: '\\',
	      221: ']',
	      222: "'"
	    },
	
	    isControl: function isControl(e) {
	      var k = e.which;
	      switch (k) {
	        case KEY.COMMAND:
	        case KEY.SHIFT:
	        case KEY.CTRL:
	        case KEY.ALT:
	          return true;
	      }
	
	      if (e.metaKey || e.ctrlKey || e.altKey) return true;
	
	      return false;
	    },
	    isFunctionKey: function isFunctionKey(k) {
	      k = k.which ? k.which : k;
	      return k >= 112 && k <= 123;
	    },
	    isVerticalMovement: function isVerticalMovement(k) {
	      return ~[KEY.UP, KEY.DOWN].indexOf(k);
	    },
	    isHorizontalMovement: function isHorizontalMovement(k) {
	      return ~[KEY.LEFT, KEY.RIGHT, KEY.BACKSPACE, KEY.DELETE].indexOf(k);
	    },
	    toSeparator: function toSeparator(k) {
	      var sep = ({ ENTER: '\n', TAB: '\t', SPACE: ' ' })[k];
	      if (sep) return sep;
	      // return undefined for special keys other than enter, tab or space.
	      // no way to use them to cut strings.
	      return KEY[k] ? undefined : k;
	    }
	  };
	
	  function isNil(value) {
	    return angular.isUndefined(value) || value === null;
	  }
	
	  /**
	   * Add querySelectorAll() to jqLite.
	   *
	   * jqLite find() is limited to lookups by tag name.
	   * TODO This will change with future versions of AngularJS, to be removed when this happens
	   *
	   * See jqLite.find - why not use querySelectorAll? https://github.com/angular/angular.js/issues/3586
	   * See feat(jqLite): use querySelectorAll instead of getElementsByTagName in jqLite.find https://github.com/angular/angular.js/pull/3598
	   */
	  if (angular.element.prototype.querySelectorAll === undefined) {
	    angular.element.prototype.querySelectorAll = function (selector) {
	      return angular.element(this[0].querySelectorAll(selector));
	    };
	  }
	
	  /**
	   * Add closest() to jqLite.
	   */
	  if (angular.element.prototype.closest === undefined) {
	    angular.element.prototype.closest = function (selector) {
	      var elem = this[0];
	      var matchesSelector = elem.matches || elem.webkitMatchesSelector || elem.mozMatchesSelector || elem.msMatchesSelector;
	
	      while (elem) {
	        if (matchesSelector.bind(elem)(selector)) {
	          return elem;
	        } else {
	          elem = elem.parentElement;
	        }
	      }
	      return false;
	    };
	  }
	
	  var latestId = 0;
	
	  var uis = angular.module('ui.select', []).constant('uiSelectConfig', {
	    theme: 'bootstrap',
	    searchEnabled: true,
	    sortable: false,
	    placeholder: '', // Empty by default, like HTML tag <select>
	    refreshDelay: 1000, // In milliseconds
	    closeOnSelect: true,
	    skipFocusser: false,
	    dropdownPosition: 'auto',
	    removeSelected: true,
	    resetSearchInput: true,
	    generateId: function generateId() {
	      return latestId++;
	    },
	    appendToBody: false,
	    spinnerEnabled: false,
	    spinnerClass: 'glyphicon glyphicon-refresh ui-select-spin',
	    backspaceReset: true
	  })
	
	  // See Rename minErr and make it accessible from outside https://github.com/angular/angular.js/issues/6913
	  .service('uiSelectMinErr', function () {
	    var minErr = angular.$$minErr('ui.select');
	    return function () {
	      var error = minErr.apply(this, arguments);
	      var message = error.message.replace(new RegExp('\nhttp://errors.angularjs.org/.*'), '');
	      return new Error(message);
	    };
	  })
	
	  // Recreates old behavior of ng-transclude. Used internally.
	  .directive('uisTranscludeAppend', function () {
	    return {
	      link: function link(scope, element, attrs, ctrl, transclude) {
	        transclude(scope, function (clone) {
	          element.append(clone);
	        });
	      }
	    };
	  })
	
	  /**
	   * Highlights text that matches $select.search.
	   *
	   * Taken from AngularUI Bootstrap Typeahead
	   * See https://github.com/angular-ui/bootstrap/blob/0.10.0/src/typeahead/typeahead.js#L340
	   */
	  .filter('highlight', function () {
	    function escapeRegexp(queryToEscape) {
	      return ('' + queryToEscape).replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1');
	    }
	
	    return function (matchItem, query) {
	      return query && matchItem ? ('' + matchItem).replace(new RegExp(escapeRegexp(query), 'gi'), '<span class="ui-select-highlight">$&</span>') : matchItem;
	    };
	  })
	
	  /**
	   * A read-only equivalent of jQuery's offset function: http://api.jquery.com/offset/
	   *
	   * Taken from AngularUI Bootstrap Position:
	   * See https://github.com/angular-ui/bootstrap/blob/master/src/position/position.js#L70
	   */
	  .factory('uisOffset', ['$document', '$window', function ($document, $window) {
	    return function (element) {
	      var boundingClientRect = element[0].getBoundingClientRect();
	      return {
	        width: boundingClientRect.width || element.prop('offsetWidth'),
	        height: boundingClientRect.height || element.prop('offsetHeight'),
	        top: boundingClientRect.top + ($window.pageYOffset || $document[0].documentElement.scrollTop),
	        left: boundingClientRect.left + ($window.pageXOffset || $document[0].documentElement.scrollLeft)
	      };
	    };
	  }]);
	
	  /**
	   * Debounces functions
	   *
	   * Taken from UI Bootstrap $$debounce source code
	   * See https://github.com/angular-ui/bootstrap/blob/master/src/debounce/debounce.js
	   *
	   */
	  uis.factory('$$uisDebounce', ['$timeout', function ($timeout) {
	    return function (callback, debounceTime) {
	      var timeoutPromise;
	
	      return function () {
	        var self = this;
	        var args = Array.prototype.slice.call(arguments);
	        if (timeoutPromise) {
	          $timeout.cancel(timeoutPromise);
	        }
	
	        timeoutPromise = $timeout(function () {
	          callback.apply(self, args);
	        }, debounceTime);
	      };
	    };
	  }]);
	
	  uis.directive('uiSelectChoices', ['uiSelectConfig', 'uisRepeatParser', 'uiSelectMinErr', '$compile', '$window', function (uiSelectConfig, RepeatParser, uiSelectMinErr, $compile, $window) {
	    return {
	      restrict: 'EA',
	      require: '^uiSelect',
	      replace: true,
	      transclude: true,
	      templateUrl: function templateUrl(tElement) {
	        // Needed so the uiSelect can detect the transcluded content
	        tElement.addClass('ui-select-choices');
	
	        // Gets theme attribute from parent (ui-select)
	        var theme = tElement.parent().attr('theme') || uiSelectConfig.theme;
	        return theme + '/choices.tpl.html';
	      },
	
	      compile: function compile(tElement, tAttrs) {
	        if (!tAttrs.repeat) throw uiSelectMinErr('repeat', "Expected 'repeat' expression.");
	
	        // var repeat = RepeatParser.parse(attrs.repeat);
	        var groupByExp = tAttrs.groupBy;
	        var groupFilterExp = tAttrs.groupFilter;
	
	        if (groupByExp) {
	          var groups = tElement.querySelectorAll('.ui-select-choices-group');
	          if (groups.length !== 1) throw uiSelectMinErr('rows', "Expected 1 .ui-select-choices-group but got '{0}'.", groups.length);
	          groups.attr('ng-repeat', RepeatParser.getGroupNgRepeatExpression());
	        }
	
	        var parserResult = RepeatParser.parse(tAttrs.repeat);
	
	        var choices = tElement.querySelectorAll('.ui-select-choices-row');
	        if (choices.length !== 1) {
	          throw uiSelectMinErr('rows', "Expected 1 .ui-select-choices-row but got '{0}'.", choices.length);
	        }
	
	        choices.attr('ng-repeat', parserResult.repeatExpression(groupByExp)).attr('ng-if', '$select.open'); //Prevent unnecessary watches when dropdown is closed
	
	        var rowsInner = tElement.querySelectorAll('.ui-select-choices-row-inner');
	        if (rowsInner.length !== 1) {
	          throw uiSelectMinErr('rows', "Expected 1 .ui-select-choices-row-inner but got '{0}'.", rowsInner.length);
	        }
	        rowsInner.attr('uis-transclude-append', ''); //Adding uisTranscludeAppend directive to row element after choices element has ngRepeat
	
	        // If IE8 then need to target rowsInner to apply the ng-click attr as choices will not capture the event.
	        var clickTarget = $window.document.addEventListener ? choices : rowsInner;
	        clickTarget.attr('ng-click', '$select.select(' + parserResult.itemName + ',$select.skipFocusser,$event)');
	
	        return function link(scope, element, attrs, $select) {
	          $select.parseRepeatAttr(attrs.repeat, groupByExp, groupFilterExp); //Result ready at $select.parserResult
	          $select.disableChoiceExpression = attrs.uiDisableChoice;
	          $select.onHighlightCallback = attrs.onHighlight;
	          $select.minimumInputLength = parseInt(attrs.minimumInputLength) || 0;
	          $select.dropdownPosition = attrs.position ? attrs.position.toLowerCase() : uiSelectConfig.dropdownPosition;
	
	          scope.$watch('$select.search', function (newValue) {
	            if (newValue && !$select.open && $select.multiple) $select.activate(false, true);
	            $select.activeIndex = $select.tagging.isActivated ? -1 : 0;
	            if (!attrs.minimumInputLength || $select.search.length >= attrs.minimumInputLength) {
	              $select.refresh(attrs.refresh);
	            } else {
	              $select.items = [];
	            }
	          });
	
	          attrs.$observe('refreshDelay', function () {
	            // $eval() is needed otherwise we get a string instead of a number
	            var refreshDelay = scope.$eval(attrs.refreshDelay);
	            $select.refreshDelay = refreshDelay !== undefined ? refreshDelay : uiSelectConfig.refreshDelay;
	          });
	
	          scope.$watch('$select.open', function (open) {
	            if (open) {
	              tElement.attr('role', 'listbox');
	              $select.refresh(attrs.refresh);
	            } else {
	              element.removeAttr('role');
	            }
	          });
	        };
	      }
	    };
	  }]);
	
	  /**
	   * Contains ui-select "intelligence".
	   *
	   * The goal is to limit dependency on the DOM whenever possible and
	   * put as much logic in the controller (instead of the link functions) as possible so it can be easily tested.
	   */
	  uis.controller('uiSelectCtrl', ['$scope', '$element', '$timeout', '$filter', '$$uisDebounce', 'uisRepeatParser', 'uiSelectMinErr', 'uiSelectConfig', '$parse', '$injector', '$window', function ($scope, $element, $timeout, $filter, $$uisDebounce, RepeatParser, uiSelectMinErr, uiSelectConfig, $parse, $injector, $window) {
	    var ctrl = this;
	
	    var EMPTY_SEARCH = '';
	
	    ctrl.placeholder = uiSelectConfig.placeholder;
	    ctrl.searchEnabled = uiSelectConfig.searchEnabled;
	    ctrl.sortable = uiSelectConfig.sortable;
	    ctrl.refreshDelay = uiSelectConfig.refreshDelay;
	    ctrl.paste = uiSelectConfig.paste;
	    ctrl.resetSearchInput = uiSelectConfig.resetSearchInput;
	    ctrl.refreshing = false;
	    ctrl.spinnerEnabled = uiSelectConfig.spinnerEnabled;
	    ctrl.spinnerClass = uiSelectConfig.spinnerClass;
	    ctrl.removeSelected = uiSelectConfig.removeSelected; //If selected item(s) should be removed from dropdown list
	    ctrl.closeOnSelect = true; //Initialized inside uiSelect directive link function
	    ctrl.skipFocusser = false; //Set to true to avoid returning focus to ctrl when item is selected
	    ctrl.search = EMPTY_SEARCH;
	
	    ctrl.activeIndex = 0; //Dropdown of choices
	    ctrl.items = []; //All available choices
	
	    ctrl.open = false;
	    ctrl.focus = false;
	    ctrl.disabled = false;
	    ctrl.selected = undefined;
	
	    ctrl.dropdownPosition = 'auto';
	
	    ctrl.focusser = undefined; //Reference to input element used to handle focus events
	    ctrl.multiple = undefined; // Initialized inside uiSelect directive link function
	    ctrl.disableChoiceExpression = undefined; // Initialized inside uiSelectChoices directive link function
	    ctrl.tagging = { isActivated: false, fct: undefined };
	    ctrl.taggingTokens = { isActivated: false, tokens: undefined };
	    ctrl.lockChoiceExpression = undefined; // Initialized inside uiSelectMatch directive link function
	    ctrl.clickTriggeredSelect = false;
	    ctrl.$filter = $filter;
	    ctrl.$element = $element;
	
	    // Use $injector to check for $animate and store a reference to it
	    ctrl.$animate = (function () {
	      try {
	        return $injector.get('$animate');
	      } catch (err) {
	        // $animate does not exist
	        return null;
	      }
	    })();
	
	    ctrl.searchInput = $element.querySelectorAll('input.ui-select-search');
	    if (ctrl.searchInput.length !== 1) {
	      throw uiSelectMinErr('searchInput', "Expected 1 input.ui-select-search but got '{0}'.", ctrl.searchInput.length);
	    }
	
	    ctrl.isEmpty = function () {
	      return isNil(ctrl.selected) || ctrl.selected === '' || ctrl.multiple && ctrl.selected.length === 0;
	    };
	
	    function _findIndex(collection, predicate, thisArg) {
	      if (collection.findIndex) {
	        return collection.findIndex(predicate, thisArg);
	      } else {
	        var list = Object(collection);
	        var length = list.length >>> 0;
	        var value;
	
	        for (var i = 0; i < length; i++) {
	          value = list[i];
	          if (predicate.call(thisArg, value, i, list)) {
	            return i;
	          }
	        }
	        return -1;
	      }
	    }
	
	    // Most of the time the user does not want to empty the search input when in typeahead mode
	    function _resetSearchInput() {
	      if (ctrl.resetSearchInput) {
	        ctrl.search = EMPTY_SEARCH;
	        //reset activeIndex
	        if (ctrl.selected && ctrl.items.length && !ctrl.multiple) {
	          ctrl.activeIndex = _findIndex(ctrl.items, function (item) {
	            return angular.equals(this, item);
	          }, ctrl.selected);
	        }
	      }
	    }
	
	    function _groupsFilter(groups, groupNames) {
	      var i,
	          j,
	          result = [];
	      for (i = 0; i < groupNames.length; i++) {
	        for (j = 0; j < groups.length; j++) {
	          if (groups[j].name == [groupNames[i]]) {
	            result.push(groups[j]);
	          }
	        }
	      }
	      return result;
	    }
	
	    // When the user clicks on ui-select, displays the dropdown list
	    ctrl.activate = function (initSearchValue, avoidReset) {
	      if (!ctrl.disabled && !ctrl.open) {
	        if (!avoidReset) _resetSearchInput();
	
	        $scope.$broadcast('uis:activate');
	        ctrl.open = true;
	        ctrl.activeIndex = ctrl.activeIndex >= ctrl.items.length ? 0 : ctrl.activeIndex;
	        // ensure that the index is set to zero for tagging variants
	        // that where first option is auto-selected
	        if (ctrl.activeIndex === -1 && ctrl.taggingLabel !== false) {
	          ctrl.activeIndex = 0;
	        }
	
	        var container = $element.querySelectorAll('.ui-select-choices-content');
	        var searchInput = $element.querySelectorAll('.ui-select-search');
	        if (ctrl.$animate && ctrl.$animate.on && ctrl.$animate.enabled(container[0])) {
	          var animateHandler = function animateHandler(elem, phase) {
	            if (phase === 'start' && ctrl.items.length === 0) {
	              // Only focus input after the animation has finished
	              ctrl.$animate.off('removeClass', searchInput[0], animateHandler);
	              $timeout(function () {
	                ctrl.focusSearchInput(initSearchValue);
	              });
	            } else if (phase === 'close') {
	              // Only focus input after the animation has finished
	              ctrl.$animate.off('enter', container[0], animateHandler);
	              $timeout(function () {
	                ctrl.focusSearchInput(initSearchValue);
	              });
	            }
	          };
	
	          if (ctrl.items.length > 0) {
	            ctrl.$animate.on('enter', container[0], animateHandler);
	          } else {
	            ctrl.$animate.on('removeClass', searchInput[0], animateHandler);
	          }
	        } else {
	          $timeout(function () {
	            ctrl.focusSearchInput(initSearchValue);
	            if (!ctrl.tagging.isActivated && ctrl.items.length > 1) {
	              _ensureHighlightVisible();
	            }
	          });
	        }
	      } else if (ctrl.open && !ctrl.searchEnabled) {
	        // Close the selection if we don't have search enabled, and we click on the select again
	        ctrl.close();
	      }
	    };
	
	    ctrl.focusSearchInput = function (initSearchValue) {
	      ctrl.search = initSearchValue || ctrl.search;
	      ctrl.searchInput[0].focus();
	    };
	
	    ctrl.findGroupByName = function (name) {
	      return ctrl.groups && ctrl.groups.filter(function (group) {
	        return group.name === name;
	      })[0];
	    };
	
	    ctrl.parseRepeatAttr = function (repeatAttr, groupByExp, groupFilterExp) {
	      function updateGroups(items) {
	        var groupFn = $scope.$eval(groupByExp);
	        ctrl.groups = [];
	        angular.forEach(items, function (item) {
	          var groupName = angular.isFunction(groupFn) ? groupFn(item) : item[groupFn];
	          var group = ctrl.findGroupByName(groupName);
	          if (group) {
	            group.items.push(item);
	          } else {
	            ctrl.groups.push({ name: groupName, items: [item] });
	          }
	        });
	        if (groupFilterExp) {
	          var groupFilterFn = $scope.$eval(groupFilterExp);
	          if (angular.isFunction(groupFilterFn)) {
	            ctrl.groups = groupFilterFn(ctrl.groups);
	          } else if (angular.isArray(groupFilterFn)) {
	            ctrl.groups = _groupsFilter(ctrl.groups, groupFilterFn);
	          }
	        }
	        ctrl.items = [];
	        ctrl.groups.forEach(function (group) {
	          ctrl.items = ctrl.items.concat(group.items);
	        });
	      }
	
	      function setPlainItems(items) {
	        ctrl.items = items || [];
	      }
	
	      ctrl.setItemsFn = groupByExp ? updateGroups : setPlainItems;
	
	      ctrl.parserResult = RepeatParser.parse(repeatAttr);
	
	      ctrl.isGrouped = !!groupByExp;
	      ctrl.itemProperty = ctrl.parserResult.itemName;
	
	      //If collection is an Object, convert it to Array
	
	      var originalSource = ctrl.parserResult.source;
	
	      //When an object is used as source, we better create an array and use it as 'source'
	      var createArrayFromObject = function createArrayFromObject() {
	        var origSrc = originalSource($scope);
	        $scope.$uisSource = Object.keys(origSrc).map(function (v) {
	          var result = {};
	          result[ctrl.parserResult.keyName] = v;
	          result.value = origSrc[v];
	          return result;
	        });
	      };
	
	      if (ctrl.parserResult.keyName) {
	        // Check for (key,value) syntax
	        createArrayFromObject();
	        ctrl.parserResult.source = $parse('$uisSource' + ctrl.parserResult.filters);
	        $scope.$watch(originalSource, function (newVal, oldVal) {
	          if (newVal !== oldVal) createArrayFromObject();
	        }, true);
	      }
	
	      ctrl.refreshItems = function (data) {
	        data = data || ctrl.parserResult.source($scope);
	        var selectedItems = ctrl.selected;
	        //TODO should implement for single mode removeSelected
	        if (ctrl.isEmpty() || angular.isArray(selectedItems) && !selectedItems.length || !ctrl.multiple || !ctrl.removeSelected) {
	          ctrl.setItemsFn(data);
	        } else {
	          if (data !== undefined && data !== null) {
	            var filteredItems = data.filter(function (i) {
	              return angular.isArray(selectedItems) ? selectedItems.every(function (selectedItem) {
	                return !angular.equals(i, selectedItem);
	              }) : !angular.equals(i, selectedItems);
	            });
	            ctrl.setItemsFn(filteredItems);
	          }
	        }
	        if (ctrl.dropdownPosition === 'auto' || ctrl.dropdownPosition === 'up') {
	          $scope.calculateDropdownPos();
	        }
	        $scope.$broadcast('uis:refresh');
	      };
	
	      // See https://github.com/angular/angular.js/blob/v1.2.15/src/ng/directive/ngRepeat.js#L259
	      $scope.$watchCollection(ctrl.parserResult.source, function (items) {
	        if (items === undefined || items === null) {
	          // If the user specifies undefined or null => reset the collection
	          // Special case: items can be undefined if the user did not initialized the collection on the scope
	          // i.e $scope.addresses = [] is missing
	          ctrl.items = [];
	        } else {
	          if (!angular.isArray(items)) {
	            throw uiSelectMinErr('items', "Expected an array but got '{0}'.", items);
	          } else {
	            //Remove already selected items (ex: while searching)
	            //TODO Should add a test
	            ctrl.refreshItems(items);
	
	            //update the view value with fresh data from items, if there is a valid model value
	            if (angular.isDefined(ctrl.ngModel.$modelValue)) {
	              ctrl.ngModel.$modelValue = null; //Force scope model value and ngModel value to be out of sync to re-run formatters
	            }
	          }
	        }
	      });
	    };
	
	    var _refreshDelayPromise;
	
	    /**
	     * Typeahead mode: lets the user refresh the collection using his own function.
	     *
	     * See Expose $select.search for external / remote filtering https://github.com/angular-ui/ui-select/pull/31
	     */
	    ctrl.refresh = function (refreshAttr) {
	      if (refreshAttr !== undefined) {
	        // Debounce
	        // See https://github.com/angular-ui/bootstrap/blob/0.10.0/src/typeahead/typeahead.js#L155
	        // FYI AngularStrap typeahead does not have debouncing: https://github.com/mgcrea/angular-strap/blob/v2.0.0-rc.4/src/typeahead/typeahead.js#L177
	        if (_refreshDelayPromise) {
	          $timeout.cancel(_refreshDelayPromise);
	        }
	        _refreshDelayPromise = $timeout(function () {
	          if ($scope.$select.search.length >= $scope.$select.minimumInputLength) {
	            var refreshPromise = $scope.$eval(refreshAttr);
	            if (refreshPromise && angular.isFunction(refreshPromise.then) && !ctrl.refreshing) {
	              ctrl.refreshing = true;
	              refreshPromise['finally'](function () {
	                ctrl.refreshing = false;
	              });
	            }
	          }
	        }, ctrl.refreshDelay);
	      }
	    };
	
	    ctrl.isActive = function (itemScope) {
	      if (!ctrl.open) {
	        return false;
	      }
	      var itemIndex = ctrl.items.indexOf(itemScope[ctrl.itemProperty]);
	      var isActive = itemIndex == ctrl.activeIndex;
	
	      if (!isActive || itemIndex < 0) {
	        return false;
	      }
	
	      if (isActive && !angular.isUndefined(ctrl.onHighlightCallback)) {
	        itemScope.$eval(ctrl.onHighlightCallback);
	      }
	
	      return isActive;
	    };
	
	    var _isItemSelected = function _isItemSelected(item) {
	      return ctrl.selected && angular.isArray(ctrl.selected) && ctrl.selected.filter(function (selection) {
	        return angular.equals(selection, item);
	      }).length > 0;
	    };
	
	    var disabledItems = [];
	
	    function _updateItemDisabled(item, isDisabled) {
	      var disabledItemIndex = disabledItems.indexOf(item);
	      if (isDisabled && disabledItemIndex === -1) {
	        disabledItems.push(item);
	      }
	
	      if (!isDisabled && disabledItemIndex > -1) {
	        disabledItems.splice(disabledItemIndex, 1);
	      }
	    }
	
	    function _isItemDisabled(item) {
	      return disabledItems.indexOf(item) > -1;
	    }
	
	    ctrl.isDisabled = function (itemScope) {
	      if (!ctrl.open) return;
	
	      var item = itemScope[ctrl.itemProperty];
	      var itemIndex = ctrl.items.indexOf(item);
	      var isDisabled = false;
	
	      if (itemIndex >= 0 && (angular.isDefined(ctrl.disableChoiceExpression) || ctrl.multiple)) {
	        if (item.isTag) return false;
	
	        if (ctrl.multiple) {
	          isDisabled = _isItemSelected(item);
	        }
	
	        if (!isDisabled && angular.isDefined(ctrl.disableChoiceExpression)) {
	          isDisabled = !!itemScope.$eval(ctrl.disableChoiceExpression);
	        }
	
	        _updateItemDisabled(item, isDisabled);
	      }
	
	      return isDisabled;
	    };
	
	    // When the user selects an item with ENTER or clicks the dropdown
	    ctrl.select = function (item, skipFocusser, $event) {
	      if (isNil(item) || !_isItemDisabled(item)) {
	        if (!ctrl.items && !ctrl.search && !ctrl.tagging.isActivated) return;
	
	        if (!item || !_isItemDisabled(item)) {
	          // if click is made on existing item, prevent from tagging, ctrl.search does not matter
	          ctrl.clickTriggeredSelect = false;
	          if ($event && ($event.type === 'click' || $event.type === 'touchend') && item) ctrl.clickTriggeredSelect = true;
	
	          if (ctrl.tagging.isActivated && ctrl.clickTriggeredSelect === false) {
	            // if taggingLabel is disabled and item is undefined we pull from ctrl.search
	            if (ctrl.taggingLabel === false) {
	              if (ctrl.activeIndex < 0) {
	                if (item === undefined) {
	                  item = ctrl.tagging.fct !== undefined ? ctrl.tagging.fct(ctrl.search) : ctrl.search;
	                }
	                if (!item || angular.equals(ctrl.items[0], item)) {
	                  return;
	                }
	              } else {
	                // keyboard nav happened first, user selected from dropdown
	                item = ctrl.items[ctrl.activeIndex];
	              }
	            } else {
	              // tagging always operates at index zero, taggingLabel === false pushes
	              // the ctrl.search value without having it injected
	              if (ctrl.activeIndex === 0) {
	                // ctrl.tagging pushes items to ctrl.items, so we only have empty val
	                // for `item` if it is a detected duplicate
	                if (item === undefined) return;
	
	                // create new item on the fly if we don't already have one;
	                // use tagging function if we have one
	                if (ctrl.tagging.fct !== undefined && typeof item === 'string') {
	                  item = ctrl.tagging.fct(item);
	                  if (!item) return;
	                  // if item type is 'string', apply the tagging label
	                } else if (typeof item === 'string') {
	                    // trim the trailing space
	                    item = item.replace(ctrl.taggingLabel, '').trim();
	                  }
	              }
	            }
	            // search ctrl.selected for dupes potentially caused by tagging and return early if found
	            if (_isItemSelected(item)) {
	              ctrl.close(skipFocusser);
	              return;
	            }
	          }
	          _resetSearchInput();
	          $scope.$broadcast('uis:select', item);
	
	          if (ctrl.closeOnSelect) {
	            ctrl.close(skipFocusser);
	          }
	        }
	      }
	    };
	
	    // Closes the dropdown
	    ctrl.close = function (skipFocusser) {
	      if (!ctrl.open) return;
	      if (ctrl.ngModel && ctrl.ngModel.$setTouched) ctrl.ngModel.$setTouched();
	      ctrl.open = false;
	      _resetSearchInput();
	      $scope.$broadcast('uis:close', skipFocusser);
	    };
	
	    ctrl.setFocus = function () {
	      if (!ctrl.focus) ctrl.focusInput[0].focus();
	    };
	
	    ctrl.clear = function ($event) {
	      ctrl.select(null);
	      $event.stopPropagation();
	      $timeout(function () {
	        ctrl.focusser[0].focus();
	      }, 0, false);
	    };
	
	    // Toggle dropdown
	    ctrl.toggle = function (e) {
	      if (ctrl.open) {
	        ctrl.close();
	        e.preventDefault();
	        e.stopPropagation();
	      } else {
	        ctrl.activate();
	      }
	    };
	
	    // Set default function for locked choices - avoids unnecessary
	    // logic if functionality is not being used
	    ctrl.isLocked = function () {
	      return false;
	    };
	
	    $scope.$watch(function () {
	      return angular.isDefined(ctrl.lockChoiceExpression) && ctrl.lockChoiceExpression !== '';
	    }, _initaliseLockedChoices);
	
	    function _initaliseLockedChoices(doInitalise) {
	      if (!doInitalise) return;
	
	      var lockedItems = [];
	
	      function _updateItemLocked(item, isLocked) {
	        var lockedItemIndex = lockedItems.indexOf(item);
	        if (isLocked && lockedItemIndex === -1) {
	          lockedItems.push(item);
	        }
	
	        if (!isLocked && lockedItemIndex > -1) {
	          lockedItems.splice(lockedItemIndex, 1);
	        }
	      }
	
	      function _isItemlocked(item) {
	        return lockedItems.indexOf(item) > -1;
	      }
	
	      ctrl.isLocked = function (itemScope, itemIndex) {
	        var isLocked = false,
	            item = ctrl.selected[itemIndex];
	
	        if (item) {
	          if (itemScope) {
	            isLocked = !!itemScope.$eval(ctrl.lockChoiceExpression);
	            _updateItemLocked(item, isLocked);
	          } else {
	            isLocked = _isItemlocked(item);
	          }
	        }
	
	        return isLocked;
	      };
	    }
	
	    var sizeWatch = null;
	    var updaterScheduled = false;
	    ctrl.sizeSearchInput = function () {
	      var input = ctrl.searchInput[0],
	          container = ctrl.$element[0],
	          calculateContainerWidth = function calculateContainerWidth() {
	        // Return the container width only if the search input is visible
	        return container.clientWidth * !!input.offsetParent;
	      },
	          updateIfVisible = function updateIfVisible(containerWidth) {
	        if (containerWidth === 0) {
	          return false;
	        }
	        var inputWidth = containerWidth - input.offsetLeft;
	        if (inputWidth < 50) inputWidth = containerWidth;
	        ctrl.searchInput.css('width', '100%');
	        return true;
	      };
	
	      ctrl.searchInput.css('width', '10px');
	      $timeout(function () {
	        //Give tags time to render correctly
	        if (sizeWatch === null && !updateIfVisible(calculateContainerWidth())) {
	          sizeWatch = $scope.$watch(function () {
	            if (!updaterScheduled) {
	              updaterScheduled = true;
	              $scope.$$postDigest(function () {
	                updaterScheduled = false;
	                if (updateIfVisible(calculateContainerWidth())) {
	                  sizeWatch();
	                  sizeWatch = null;
	                }
	              });
	            }
	          }, angular.noop);
	        }
	      });
	    };
	
	    function _handleDropDownSelection(key) {
	      var processed = true;
	      switch (key) {
	        case KEY.DOWN:
	          if (!ctrl.open && ctrl.multiple) ctrl.activate(false, true);
	          //In case its the search input in 'multiple' mode
	          else if (ctrl.activeIndex < ctrl.items.length - 1) {
	              var idx = ++ctrl.activeIndex;
	              while (_isItemDisabled(ctrl.items[idx]) && idx < ctrl.items.length) {
	                ctrl.activeIndex = ++idx;
	              }
	            }
	          break;
	        case KEY.UP:
	          var minActiveIndex = ctrl.search.length === 0 && ctrl.tagging.isActivated ? -1 : 0;
	          if (!ctrl.open && ctrl.multiple) ctrl.activate(false, true);
	          //In case its the search input in 'multiple' mode
	          else if (ctrl.activeIndex > minActiveIndex) {
	              var idxmin = --ctrl.activeIndex;
	              while (_isItemDisabled(ctrl.items[idxmin]) && idxmin > minActiveIndex) {
	                ctrl.activeIndex = --idxmin;
	              }
	            }
	          break;
	        case KEY.TAB:
	          if (!ctrl.multiple || ctrl.open) ctrl.select(ctrl.items[ctrl.activeIndex], true);
	          break;
	        case KEY.ENTER:
	          if (ctrl.open && (ctrl.tagging.isActivated || ctrl.activeIndex >= 0)) {
	            ctrl.select(ctrl.items[ctrl.activeIndex], ctrl.skipFocusser); // Make sure at least one dropdown item is highlighted before adding if not in tagging mode
	          } else {
	              ctrl.activate(false, true); //In case its the search input in 'multiple' mode
	            }
	          break;
	        case KEY.ESC:
	          ctrl.close();
	          break;
	        default:
	          processed = false;
	      }
	      return processed;
	    }
	
	    // Bind to keyboard shortcuts
	    ctrl.searchInput.on('keydown', function (e) {
	      var key = e.which;
	
	      if (~[KEY.ENTER, KEY.ESC].indexOf(key)) {
	        e.preventDefault();
	        e.stopPropagation();
	      }
	
	      $scope.$apply(function () {
	        var tagged = false;
	
	        if (ctrl.items.length > 0 || ctrl.tagging.isActivated) {
	          if (!_handleDropDownSelection(key) && !ctrl.searchEnabled) {
	            e.preventDefault();
	            e.stopPropagation();
	          }
	          if (ctrl.taggingTokens.isActivated) {
	            for (var i = 0; i < ctrl.taggingTokens.tokens.length; i++) {
	              if (ctrl.taggingTokens.tokens[i] === KEY.MAP[e.keyCode]) {
	                // make sure there is a new value to push via tagging
	                if (ctrl.search.length > 0) {
	                  tagged = true;
	                }
	              }
	            }
	            if (tagged) {
	              $timeout(function () {
	                ctrl.searchInput.triggerHandler('tagged');
	                var newItem = ctrl.search.replace(KEY.MAP[e.keyCode], '').trim();
	                if (ctrl.tagging.fct) {
	                  newItem = ctrl.tagging.fct(newItem);
	                }
	                if (newItem) ctrl.select(newItem, true);
	              });
	            }
	          }
	        }
	      });
	
	      if (KEY.isVerticalMovement(key) && ctrl.items.length > 0) {
	        _ensureHighlightVisible();
	      }
	
	      if (key === KEY.ENTER || key === KEY.ESC) {
	        e.preventDefault();
	        e.stopPropagation();
	      }
	    });
	
	    ctrl.searchInput.on('paste', function (e) {
	      var data;
	
	      if (window.clipboardData && window.clipboardData.getData) {
	        // IE
	        data = window.clipboardData.getData('Text');
	      } else {
	        data = (e.originalEvent || e).clipboardData.getData('text/plain');
	      }
	
	      // Prepend the current input field text to the paste buffer.
	      data = ctrl.search + data;
	
	      if (data && data.length > 0) {
	        // If tagging try to split by tokens and add items
	        if (ctrl.taggingTokens.isActivated) {
	          var items = [];
	          for (var i = 0; i < ctrl.taggingTokens.tokens.length; i++) {
	            // split by first token that is contained in data
	            var separator = KEY.toSeparator(ctrl.taggingTokens.tokens[i]) || ctrl.taggingTokens.tokens[i];
	            if (data.indexOf(separator) > -1) {
	              items = data.split(separator);
	              break; // only split by one token
	            }
	          }
	          if (items.length === 0) {
	            items = [data];
	          }
	          var oldsearch = ctrl.search;
	          angular.forEach(items, function (item) {
	            var newItem = ctrl.tagging.fct ? ctrl.tagging.fct(item) : item;
	            if (newItem) {
	              ctrl.select(newItem, true);
	            }
	          });
	          ctrl.search = oldsearch || EMPTY_SEARCH;
	          e.preventDefault();
	          e.stopPropagation();
	        } else if (ctrl.paste) {
	          ctrl.paste(data);
	          ctrl.search = EMPTY_SEARCH;
	          e.preventDefault();
	          e.stopPropagation();
	        }
	      }
	    });
	
	    ctrl.searchInput.on('tagged', function () {
	      $timeout(function () {
	        _resetSearchInput();
	      });
	    });
	
	    // See https://github.com/ivaynberg/select2/blob/3.4.6/select2.js#L1431
	    function _ensureHighlightVisible() {
	      var container = $element.querySelectorAll('.ui-select-choices-content');
	      var choices = container.querySelectorAll('.ui-select-choices-row');
	      if (choices.length < 1) {
	        throw uiSelectMinErr('choices', "Expected multiple .ui-select-choices-row but got '{0}'.", choices.length);
	      }
	
	      if (ctrl.activeIndex < 0) {
	        return;
	      }
	
	      var highlighted = choices[ctrl.activeIndex];
	      var posY = highlighted.offsetTop + highlighted.clientHeight - container[0].scrollTop;
	      var height = container[0].offsetHeight;
	
	      if (posY > height) {
	        container[0].scrollTop += posY - height;
	      } else if (posY < highlighted.clientHeight) {
	        if (ctrl.isGrouped && ctrl.activeIndex === 0) container[0].scrollTop = 0;
	        //To make group header visible when going all the way up
	        else container[0].scrollTop -= highlighted.clientHeight - posY;
	      }
	    }
	
	    var onResize = $$uisDebounce(function () {
	      ctrl.sizeSearchInput();
	    }, 50);
	
	    angular.element($window).bind('resize', onResize);
	
	    $scope.$on('$destroy', function () {
	      ctrl.searchInput.off('keyup keydown tagged blur paste');
	      angular.element($window).off('resize', onResize);
	    });
	
	    $scope.$watch('$select.activeIndex', function (activeIndex) {
	      if (activeIndex) $element.find('input').attr('aria-activedescendant', 'ui-select-choices-row-' + ctrl.generatedId + '-' + activeIndex);
	    });
	
	    $scope.$watch('$select.open', function (open) {
	      if (!open) $element.find('input').removeAttr('aria-activedescendant');
	    });
	  }]);
	
	  uis.directive('uiSelect', ['$document', 'uiSelectConfig', 'uiSelectMinErr', 'uisOffset', '$compile', '$parse', '$timeout', function ($document, uiSelectConfig, uiSelectMinErr, uisOffset, $compile, $parse, $timeout) {
	    return {
	      restrict: 'EA',
	      templateUrl: function templateUrl(tElement, tAttrs) {
	        var theme = tAttrs.theme || uiSelectConfig.theme;
	        return theme + (angular.isDefined(tAttrs.multiple) ? '/select-multiple.tpl.html' : '/select.tpl.html');
	      },
	      replace: true,
	      transclude: true,
	      require: ['uiSelect', '^ngModel'],
	      scope: true,
	
	      controller: 'uiSelectCtrl',
	      controllerAs: '$select',
	      compile: function compile(tElement, tAttrs) {
	        // Allow setting ngClass on uiSelect
	        var match = /{(.*)}\s*{(.*)}/.exec(tAttrs.ngClass);
	        if (match) {
	          var combined = '{' + match[1] + ', ' + match[2] + '}';
	          tAttrs.ngClass = combined;
	          tElement.attr('ng-class', combined);
	        }
	
	        //Multiple or Single depending if multiple attribute presence
	        if (angular.isDefined(tAttrs.multiple)) tElement.append('<ui-select-multiple/>').removeAttr('multiple');else tElement.append('<ui-select-single/>');
	
	        if (tAttrs.inputId) tElement.querySelectorAll('input.ui-select-search')[0].id = tAttrs.inputId;
	
	        return function (scope, element, attrs, ctrls, transcludeFn) {
	          var $select = ctrls[0];
	          var ngModel = ctrls[1];
	
	          $select.generatedId = uiSelectConfig.generateId();
	          $select.baseTitle = attrs.title || 'Select box';
	          $select.focusserTitle = $select.baseTitle + ' focus';
	          $select.focusserId = 'focusser-' + $select.generatedId;
	
	          $select.closeOnSelect = (function () {
	            if (angular.isDefined(attrs.closeOnSelect)) {
	              return $parse(attrs.closeOnSelect)();
	            } else {
	              return uiSelectConfig.closeOnSelect;
	            }
	          })();
	
	          scope.$watch('skipFocusser', function () {
	            var skipFocusser = scope.$eval(attrs.skipFocusser);
	            $select.skipFocusser = skipFocusser !== undefined ? skipFocusser : uiSelectConfig.skipFocusser;
	          });
	
	          $select.onSelectCallback = $parse(attrs.onSelect);
	          $select.onRemoveCallback = $parse(attrs.onRemove);
	
	          //Set reference to ngModel from uiSelectCtrl
	          $select.ngModel = ngModel;
	
	          $select.choiceGrouped = function (group) {
	            return $select.isGrouped && group && group.name;
	          };
	
	          if (attrs.tabindex) {
	            attrs.$observe('tabindex', function (value) {
	              $select.focusInput.attr('tabindex', value);
	              element.removeAttr('tabindex');
	            });
	          }
	
	          scope.$watch(function () {
	            return scope.$eval(attrs.searchEnabled);
	          }, function (newVal) {
	            $select.searchEnabled = newVal !== undefined ? newVal : uiSelectConfig.searchEnabled;
	          });
	
	          scope.$watch('sortable', function () {
	            var sortable = scope.$eval(attrs.sortable);
	            $select.sortable = sortable !== undefined ? sortable : uiSelectConfig.sortable;
	          });
	
	          attrs.$observe('backspaceReset', function () {
	            // $eval() is needed otherwise we get a string instead of a boolean
	            var backspaceReset = scope.$eval(attrs.backspaceReset);
	            $select.backspaceReset = backspaceReset !== undefined ? backspaceReset : true;
	          });
	
	          attrs.$observe('limit', function () {
	            //Limit the number of selections allowed
	            $select.limit = angular.isDefined(attrs.limit) ? parseInt(attrs.limit, 10) : undefined;
	          });
	
	          scope.$watch('removeSelected', function () {
	            var removeSelected = scope.$eval(attrs.removeSelected);
	            $select.removeSelected = removeSelected !== undefined ? removeSelected : uiSelectConfig.removeSelected;
	          });
	
	          attrs.$observe('disabled', function () {
	            // No need to use $eval() (thanks to ng-disabled) since we already get a boolean instead of a string
	            $select.disabled = attrs.disabled !== undefined ? attrs.disabled : false;
	          });
	
	          attrs.$observe('resetSearchInput', function () {
	            // $eval() is needed otherwise we get a string instead of a boolean
	            var resetSearchInput = scope.$eval(attrs.resetSearchInput);
	            $select.resetSearchInput = resetSearchInput !== undefined ? resetSearchInput : true;
	          });
	
	          attrs.$observe('paste', function () {
	            $select.paste = scope.$eval(attrs.paste);
	          });
	
	          attrs.$observe('tagging', function () {
	            if (attrs.tagging !== undefined) {
	              // $eval() is needed otherwise we get a string instead of a boolean
	              var taggingEval = scope.$eval(attrs.tagging);
	              $select.tagging = { isActivated: true, fct: taggingEval !== true ? taggingEval : undefined };
	            } else {
	              $select.tagging = { isActivated: false, fct: undefined };
	            }
	          });
	
	          attrs.$observe('taggingLabel', function () {
	            if (attrs.tagging !== undefined) {
	              // check eval for FALSE, in this case, we disable the labels
	              // associated with tagging
	              if (attrs.taggingLabel === 'false') {
	                $select.taggingLabel = false;
	              } else {
	                $select.taggingLabel = attrs.taggingLabel !== undefined ? attrs.taggingLabel : '(new)';
	              }
	            }
	          });
	
	          attrs.$observe('taggingTokens', function () {
	            if (attrs.tagging !== undefined) {
	              var tokens = attrs.taggingTokens !== undefined ? attrs.taggingTokens.split('|') : [',', 'ENTER'];
	              $select.taggingTokens = { isActivated: true, tokens: tokens };
	            }
	          });
	
	          attrs.$observe('spinnerEnabled', function () {
	            // $eval() is needed otherwise we get a string instead of a boolean
	            var spinnerEnabled = scope.$eval(attrs.spinnerEnabled);
	            $select.spinnerEnabled = spinnerEnabled !== undefined ? spinnerEnabled : uiSelectConfig.spinnerEnabled;
	          });
	
	          attrs.$observe('spinnerClass', function () {
	            var spinnerClass = attrs.spinnerClass;
	            $select.spinnerClass = spinnerClass !== undefined ? attrs.spinnerClass : uiSelectConfig.spinnerClass;
	          });
	
	          //Automatically gets focus when loaded
	          if (angular.isDefined(attrs.autofocus)) {
	            $timeout(function () {
	              $select.setFocus();
	            });
	          }
	
	          //Gets focus based on scope event name (e.g. focus-on='SomeEventName')
	          if (angular.isDefined(attrs.focusOn)) {
	            scope.$on(attrs.focusOn, function () {
	              $timeout(function () {
	                $select.setFocus();
	              });
	            });
	          }
	
	          function onDocumentClick(e) {
	            if (!$select.open) return; //Skip it if dropdown is close
	
	            var contains = false;
	
	            if (window.jQuery) {
	              // Firefox 3.6 does not support element.contains()
	              // See Node.contains https://developer.mozilla.org/en-US/docs/Web/API/Node.contains
	              contains = window.jQuery.contains(element[0], e.target);
	            } else {
	              contains = element[0].contains(e.target);
	            }
	
	            if (!contains && !$select.clickTriggeredSelect) {
	              var skipFocusser;
	              if (!$select.skipFocusser) {
	                //Will lose focus only with certain targets
	                var focusableControls = ['input', 'button', 'textarea', 'select'];
	                var targetController = angular.element(e.target).controller('uiSelect'); //To check if target is other ui-select
	                skipFocusser = targetController && targetController !== $select; //To check if target is other ui-select
	                if (!skipFocusser) skipFocusser = ~focusableControls.indexOf(e.target.tagName.toLowerCase()); //Check if target is input, button or textarea
	              } else {
	                  skipFocusser = true;
	                }
	              $select.close(skipFocusser);
	              scope.$digest();
	            }
	            $select.clickTriggeredSelect = false;
	          }
	
	          // See Click everywhere but here event http://stackoverflow.com/questions/12931369
	          $document.on('click', onDocumentClick);
	
	          scope.$on('$destroy', function () {
	            $document.off('click', onDocumentClick);
	          });
	
	          // Move transcluded elements to their correct position in main template
	          transcludeFn(scope, function (clone) {
	            // See Transclude in AngularJS http://blog.omkarpatil.com/2012/11/transclude-in-angularjs.html
	
	            // One day jqLite will be replaced by jQuery and we will be able to write:
	            // var transcludedElement = clone.filter('.my-class')
	            // instead of creating a hackish DOM element:
	            var transcluded = angular.element('<div>').append(clone);
	
	            var transcludedMatch = transcluded.querySelectorAll('.ui-select-match');
	            transcludedMatch.removeAttr('ui-select-match'); //To avoid loop in case directive as attr
	            transcludedMatch.removeAttr('data-ui-select-match'); // Properly handle HTML5 data-attributes
	            if (transcludedMatch.length !== 1) {
	              throw uiSelectMinErr('transcluded', "Expected 1 .ui-select-match but got '{0}'.", transcludedMatch.length);
	            }
	            element.querySelectorAll('.ui-select-match').replaceWith(transcludedMatch);
	
	            var transcludedChoices = transcluded.querySelectorAll('.ui-select-choices');
	            transcludedChoices.removeAttr('ui-select-choices'); //To avoid loop in case directive as attr
	            transcludedChoices.removeAttr('data-ui-select-choices'); // Properly handle HTML5 data-attributes
	            if (transcludedChoices.length !== 1) {
	              throw uiSelectMinErr('transcluded', "Expected 1 .ui-select-choices but got '{0}'.", transcludedChoices.length);
	            }
	            element.querySelectorAll('.ui-select-choices').replaceWith(transcludedChoices);
	
	            var transcludedNoChoice = transcluded.querySelectorAll('.ui-select-no-choice');
	            transcludedNoChoice.removeAttr('ui-select-no-choice'); //To avoid loop in case directive as attr
	            transcludedNoChoice.removeAttr('data-ui-select-no-choice'); // Properly handle HTML5 data-attributes
	            if (transcludedNoChoice.length == 1) {
	              element.querySelectorAll('.ui-select-no-choice').replaceWith(transcludedNoChoice);
	            }
	          });
	
	          // Support for appending the select field to the body when its open
	          var appendToBody = scope.$eval(attrs.appendToBody);
	          if (appendToBody !== undefined ? appendToBody : uiSelectConfig.appendToBody) {
	            scope.$watch('$select.open', function (isOpen) {
	              if (isOpen) {
	                positionDropdown();
	              } else {
	                resetDropdown();
	              }
	            });
	
	            // Move the dropdown back to its original location when the scope is destroyed. Otherwise
	            // it might stick around when the user routes away or the select field is otherwise removed
	            scope.$on('$destroy', function () {
	              resetDropdown();
	            });
	          }
	
	          // Hold on to a reference to the .ui-select-container element for appendToBody support
	          var placeholder = null,
	              originalWidth = '';
	
	          function positionDropdown() {
	            // Remember the absolute position of the element
	            var offset = uisOffset(element);
	
	            // Clone the element into a placeholder element to take its original place in the DOM
	            placeholder = angular.element('<div class="ui-select-placeholder"></div>');
	            placeholder[0].style.width = offset.width + 'px';
	            placeholder[0].style.height = offset.height + 'px';
	            element.after(placeholder);
	
	            // Remember the original value of the element width inline style, so it can be restored
	            // when the dropdown is closed
	            originalWidth = element[0].style.width;
	
	            // Now move the actual dropdown element to the end of the body
	            $document.find('body').append(element);
	
	            element[0].style.position = 'absolute';
	            element[0].style.left = offset.left + 'px';
	            element[0].style.top = offset.top + 'px';
	            element[0].style.width = offset.width + 'px';
	          }
	
	          function resetDropdown() {
	            if (placeholder === null) {
	              // The dropdown has not actually been display yet, so there's nothing to reset
	              return;
	            }
	
	            // Move the dropdown element back to its original location in the DOM
	            placeholder.replaceWith(element);
	            placeholder = null;
	
	            element[0].style.position = '';
	            element[0].style.left = '';
	            element[0].style.top = '';
	            element[0].style.width = originalWidth;
	
	            // Set focus back on to the moved element
	            $select.setFocus();
	          }
	
	          // Hold on to a reference to the .ui-select-dropdown element for direction support.
	          var dropdown = null,
	              directionUpClassName = 'direction-up';
	
	          // Support changing the direction of the dropdown if there isn't enough space to render it.
	          scope.$watch('$select.open', function () {
	            if ($select.dropdownPosition === 'auto' || $select.dropdownPosition === 'up') {
	              scope.calculateDropdownPos();
	            }
	          });
	
	          var setDropdownPosUp = function setDropdownPosUp(offset, offsetDropdown) {
	            offset = offset || uisOffset(element);
	            offsetDropdown = offsetDropdown || uisOffset(dropdown);
	
	            dropdown[0].style.position = 'absolute';
	            dropdown[0].style.top = offsetDropdown.height * -1 + 'px';
	            element.addClass(directionUpClassName);
	          };
	
	          var setDropdownPosDown = function setDropdownPosDown(offset, offsetDropdown) {
	            element.removeClass(directionUpClassName);
	
	            offset = offset || uisOffset(element);
	            offsetDropdown = offsetDropdown || uisOffset(dropdown);
	
	            dropdown[0].style.position = '';
	            dropdown[0].style.top = '';
	          };
	
	          var calculateDropdownPosAfterAnimation = function calculateDropdownPosAfterAnimation() {
	            // Delay positioning the dropdown until all choices have been added so its height is correct.
	            $timeout(function () {
	              if ($select.dropdownPosition === 'up') {
	                //Go UP
	                setDropdownPosUp();
	              } else {
	                //AUTO
	                element.removeClass(directionUpClassName);
	
	                var offset = uisOffset(element);
	                var offsetDropdown = uisOffset(dropdown);
	
	                //https://code.google.com/p/chromium/issues/detail?id=342307#c4
	                var scrollTop = $document[0].documentElement.scrollTop || $document[0].body.scrollTop; //To make it cross browser (blink, webkit, IE, Firefox).
	
	                // Determine if the direction of the dropdown needs to be changed.
	                if (offset.top + offset.height + offsetDropdown.height > scrollTop + $document[0].documentElement.clientHeight) {
	                  //Go UP
	                  setDropdownPosUp(offset, offsetDropdown);
	                } else {
	                  //Go DOWN
	                  setDropdownPosDown(offset, offsetDropdown);
	                }
	              }
	
	              // Display the dropdown once it has been positioned.
	              dropdown[0].style.opacity = 1;
	            });
	          };
	
	          var opened = false;
	
	          scope.calculateDropdownPos = function () {
	            if ($select.open) {
	              dropdown = angular.element(element).querySelectorAll('.ui-select-dropdown');
	
	              if (dropdown.length === 0) {
	                return;
	              }
	
	              // Hide the dropdown so there is no flicker until $timeout is done executing.
	              if ($select.search === '' && !opened) {
	                dropdown[0].style.opacity = 0;
	                opened = true;
	              }
	
	              if (!uisOffset(dropdown).height && $select.$animate && $select.$animate.on && $select.$animate.enabled(dropdown)) {
	                var needsCalculated = true;
	
	                $select.$animate.on('enter', dropdown, function (elem, phase) {
	                  if (phase === 'close' && needsCalculated) {
	                    calculateDropdownPosAfterAnimation();
	                    needsCalculated = false;
	                  }
	                });
	              } else {
	                calculateDropdownPosAfterAnimation();
	              }
	            } else {
	              if (dropdown === null || dropdown.length === 0) {
	                return;
	              }
	
	              // Reset the position of the dropdown.
	              dropdown[0].style.opacity = 0;
	              dropdown[0].style.position = '';
	              dropdown[0].style.top = '';
	              element.removeClass(directionUpClassName);
	            }
	          };
	        };
	      }
	    };
	  }]);
	
	  uis.directive('uiSelectMatch', ['uiSelectConfig', function (uiSelectConfig) {
	    return {
	      restrict: 'EA',
	      require: '^uiSelect',
	      replace: true,
	      transclude: true,
	      templateUrl: function templateUrl(tElement) {
	        // Needed so the uiSelect can detect the transcluded content
	        tElement.addClass('ui-select-match');
	
	        var parent = tElement.parent();
	        // Gets theme attribute from parent (ui-select)
	        var theme = getAttribute(parent, 'theme') || uiSelectConfig.theme;
	        var multi = angular.isDefined(getAttribute(parent, 'multiple'));
	
	        return theme + (multi ? '/match-multiple.tpl.html' : '/match.tpl.html');
	      },
	      link: function link(scope, element, attrs, $select) {
	        $select.lockChoiceExpression = attrs.uiLockChoice;
	        attrs.$observe('placeholder', function (placeholder) {
	          $select.placeholder = placeholder !== undefined ? placeholder : uiSelectConfig.placeholder;
	        });
	
	        function setAllowClear(allow) {
	          $select.allowClear = angular.isDefined(allow) ? allow === '' ? true : allow.toLowerCase() === 'true' : false;
	        }
	
	        attrs.$observe('allowClear', setAllowClear);
	        setAllowClear(attrs.allowClear);
	
	        if ($select.multiple) {
	          $select.sizeSearchInput();
	        }
	      }
	    };
	
	    function getAttribute(elem, attribute) {
	      if (elem[0].hasAttribute(attribute)) return elem.attr(attribute);
	
	      if (elem[0].hasAttribute('data-' + attribute)) return elem.attr('data-' + attribute);
	
	      if (elem[0].hasAttribute('x-' + attribute)) return elem.attr('x-' + attribute);
	    }
	  }]);
	
	  uis.directive('uiSelectMultiple', ['uiSelectMinErr', '$timeout', function (uiSelectMinErr, $timeout) {
	    return {
	      restrict: 'EA',
	      require: ['^uiSelect', '^ngModel'],
	
	      controller: ['$scope', '$timeout', function ($scope, $timeout) {
	        var ctrl = this,
	            $select = $scope.$select,
	            ngModel;
	
	        if (angular.isUndefined($select.selected)) $select.selected = [];
	
	        //Wait for link fn to inject it
	        $scope.$evalAsync(function () {
	          ngModel = $scope.ngModel;
	        });
	
	        ctrl.activeMatchIndex = -1;
	
	        ctrl.updateModel = function () {
	          ngModel.$setViewValue(Date.now()); //Set timestamp as a unique string to force changes
	          ctrl.refreshComponent();
	        };
	
	        ctrl.refreshComponent = function () {
	          //Remove already selected items
	          //e.g. When user clicks on a selection, the selected array changes and
	          //the dropdown should remove that item
	          if ($select.refreshItems) {
	            $select.refreshItems();
	          }
	          if ($select.sizeSearchInput) {
	            $select.sizeSearchInput();
	          }
	        };
	
	        // Remove item from multiple select
	        ctrl.removeChoice = function (index) {
	          // if the choice is locked, don't remove it
	          if ($select.isLocked(null, index)) return false;
	
	          var removedChoice = $select.selected[index];
	
	          var locals = {};
	          locals[$select.parserResult.itemName] = removedChoice;
	
	          $select.selected.splice(index, 1);
	          ctrl.activeMatchIndex = -1;
	          $select.sizeSearchInput();
	
	          // Give some time for scope propagation.
	          $timeout(function () {
	            $select.onRemoveCallback($scope, {
	              $item: removedChoice,
	              $model: $select.parserResult.modelMapper($scope, locals)
	            });
	          });
	
	          ctrl.updateModel();
	
	          return true;
	        };
	
	        ctrl.getPlaceholder = function () {
	          //Refactor single?
	          if ($select.selected && $select.selected.length) return;
	          return $select.placeholder;
	        };
	      }],
	      controllerAs: '$selectMultiple',
	
	      link: function link(scope, element, attrs, ctrls) {
	        var $select = ctrls[0];
	        var ngModel = scope.ngModel = ctrls[1];
	        var $selectMultiple = scope.$selectMultiple;
	
	        //$select.selected = raw selected objects (ignoring any property binding)
	
	        $select.multiple = true;
	
	        //Input that will handle focus
	        $select.focusInput = $select.searchInput;
	        $select.$element.find('.select2-choices').on('click', function (e) {
	          e.preventDefault();
	          e.stopPropagation();
	          setTimeout(function () {
	            if ($select.$element.hasClass('select2-container-active')) return;
	            $select.searchInput.triggerHandler('click');
	          }, 200);
	        });
	
	        //Properly check for empty if set to multiple
	        ngModel.$isEmpty = function (value) {
	          return !value || value.length === 0;
	        };
	
	        //From view --> model
	        ngModel.$parsers.unshift(function () {
	          var locals = {},
	              result,
	              resultMultiple = [];
	          for (var j = $select.selected.length - 1; j >= 0; j--) {
	            locals = {};
	            locals[$select.parserResult.itemName] = $select.selected[j];
	            result = $select.parserResult.modelMapper(scope, locals);
	            resultMultiple.unshift(result);
	          }
	          return resultMultiple;
	        });
	
	        // From model --> view
	        ngModel.$formatters.unshift(function (inputValue) {
	          var data = $select.parserResult && $select.parserResult.source(scope, { $select: { search: '' } }),
	              //Overwrite $search
	          locals = {},
	              result;
	          if (!data) return inputValue;
	          var resultMultiple = [];
	          var checkFnMultiple = function checkFnMultiple(list, value) {
	            if (!list || !list.length) return;
	            for (var p = list.length - 1; p >= 0; p--) {
	              locals[$select.parserResult.itemName] = list[p];
	              result = $select.parserResult.modelMapper(scope, locals);
	              if ($select.parserResult.trackByExp) {
	                var propsItemNameMatches = /(\w*)\./.exec($select.parserResult.trackByExp);
	                var matches = /\.([^\s]+)/.exec($select.parserResult.trackByExp);
	                if (propsItemNameMatches && propsItemNameMatches.length > 0 && propsItemNameMatches[1] == $select.parserResult.itemName) {
	                  if (matches && matches.length > 0 && result[matches[1]] == value[matches[1]]) {
	                    resultMultiple.unshift(list[p]);
	                    return true;
	                  }
	                }
	              }
	              if (angular.equals(result, value)) {
	                resultMultiple.unshift(list[p]);
	                return true;
	              }
	            }
	            return false;
	          };
	          if (!inputValue) return resultMultiple; //If ngModel was undefined
	          for (var k = inputValue.length - 1; k >= 0; k--) {
	            //Check model array of currently selected items
	            if (!checkFnMultiple($select.selected, inputValue[k])) {
	              //Check model array of all items available
	              if (!checkFnMultiple(data, inputValue[k])) {
	                //If not found on previous lists, just add it directly to resultMultiple
	                resultMultiple.unshift(inputValue[k]);
	              }
	            }
	          }
	          return resultMultiple;
	        });
	
	        //Watch for external model changes
	        scope.$watchCollection(function () {
	          return ngModel.$modelValue;
	        }, function (newValue, oldValue) {
	          if (oldValue != newValue) {
	            //update the view value with fresh data from items, if there is a valid model value
	            if (angular.isDefined(ngModel.$modelValue)) {
	              ngModel.$modelValue = null; //Force scope model value and ngModel value to be out of sync to re-run formatters
	            }
	            $selectMultiple.refreshComponent();
	          }
	        });
	
	        ngModel.$render = function () {
	          // Make sure that model value is array
	          if (!angular.isArray(ngModel.$viewValue)) {
	            // Have tolerance for null or undefined values
	            if (isNil(ngModel.$viewValue)) {
	              ngModel.$viewValue = [];
	            } else {
	              throw uiSelectMinErr('multiarr', "Expected model value to be array but got '{0}'", ngModel.$viewValue);
	            }
	          }
	          $select.selected = ngModel.$viewValue;
	          $selectMultiple.refreshComponent();
	          scope.$evalAsync(); //To force $digest
	        };
	
	        scope.$on('uis:select', function (event, item) {
	          if ($select.selected.length >= $select.limit) {
	            return;
	          }
	          $select.selected.push(item);
	          var locals = {};
	          locals[$select.parserResult.itemName] = item;
	
	          $timeout(function () {
	            $select.onSelectCallback(scope, {
	              $item: item,
	              $model: $select.parserResult.modelMapper(scope, locals)
	            });
	          });
	          $selectMultiple.updateModel();
	        });
	
	        scope.$on('uis:activate', function () {
	          $selectMultiple.activeMatchIndex = -1;
	        });
	
	        scope.$watch('$select.disabled', function (newValue, oldValue) {
	          // As the search input field may now become visible, it may be necessary to recompute its size
	          if (oldValue && !newValue) $select.sizeSearchInput();
	        });
	
	        $select.searchInput.on('keydown', function (e) {
	          var key = e.which;
	          scope.$apply(function () {
	            var processed = false;
	            // var tagged = false; //Checkme
	            if (KEY.isHorizontalMovement(key)) {
	              processed = _handleMatchSelection(key);
	            }
	            if (processed && key != KEY.TAB) {
	              //TODO Check si el tab selecciona aun correctamente
	              //Crear test
	              e.preventDefault();
	              e.stopPropagation();
	            }
	          });
	        });
	        function _getCaretPosition(el) {
	          if (angular.isNumber(el.selectionStart)) return el.selectionStart;
	          // selectionStart is not supported in IE8 and we don't want hacky workarounds so we compromise
	          else return el.value.length;
	        }
	        // Handles selected options in "multiple" mode
	        function _handleMatchSelection(key) {
	          var caretPosition = _getCaretPosition($select.searchInput[0]),
	              length = $select.selected.length,
	
	          // none  = -1,
	          first = 0,
	              last = length - 1,
	              curr = $selectMultiple.activeMatchIndex,
	              next = $selectMultiple.activeMatchIndex + 1,
	              prev = $selectMultiple.activeMatchIndex - 1,
	              newIndex = curr;
	
	          if (caretPosition > 0 || $select.search.length && key == KEY.RIGHT) return false;
	
	          $select.close();
	
	          function getNewActiveMatchIndex() {
	            switch (key) {
	              case KEY.LEFT:
	                // Select previous/first item
	                if (~$selectMultiple.activeMatchIndex) return prev;
	                // Select last item
	                else return last;
	                break;
	              case KEY.RIGHT:
	                // Open drop-down
	                if (! ~$selectMultiple.activeMatchIndex || curr === last) {
	                  $select.activate();
	                  return false;
	                }
	                // Select next/last item
	                else return next;
	                break;
	              case KEY.BACKSPACE:
	                // Remove selected item and select previous/first
	                if (~$selectMultiple.activeMatchIndex) {
	                  if ($selectMultiple.removeChoice(curr)) {
	                    return prev;
	                  } else {
	                    return curr;
	                  }
	                } else {
	                  // If nothing yet selected, select last item
	                  return last;
	                }
	                break;
	              case KEY.DELETE:
	                // Remove selected item and select next item
	                if (~$selectMultiple.activeMatchIndex) {
	                  $selectMultiple.removeChoice($selectMultiple.activeMatchIndex);
	                  return curr;
	                } else return false;
	            }
	          }
	
	          newIndex = getNewActiveMatchIndex();
	
	          if (!$select.selected.length || newIndex === false) $selectMultiple.activeMatchIndex = -1;else $selectMultiple.activeMatchIndex = Math.min(last, Math.max(first, newIndex));
	
	          return true;
	        }
	
	        $select.searchInput.on('keyup', function (e) {
	          if (!KEY.isVerticalMovement(e.which)) {
	            scope.$evalAsync(function () {
	              $select.activeIndex = $select.taggingLabel === false ? -1 : 0;
	            });
	          }
	          // Push a "create new" item into array if there is a search string
	          if ($select.tagging.isActivated && $select.search.length > 0) {
	            // return early with these keys
	            if (e.which === KEY.TAB || KEY.isControl(e) || KEY.isFunctionKey(e) || e.which === KEY.ESC || KEY.isVerticalMovement(e.which)) {
	              return;
	            }
	            // always reset the activeIndex to the first item when tagging
	            $select.activeIndex = $select.taggingLabel === false ? -1 : 0;
	            // taggingLabel === false bypasses all of this
	            if ($select.taggingLabel === false) return;
	
	            var items = angular.copy($select.items);
	            var stashArr = angular.copy($select.items);
	            var newItem;
	            var item;
	            var hasTag = false;
	            var dupeIndex = -1;
	            var tagItems;
	            var tagItem;
	
	            // case for object tagging via transform `$select.tagging.fct` function
	            if ($select.tagging.fct !== undefined) {
	              tagItems = $select.$filter('filter')(items, { isTag: true });
	              if (tagItems.length > 0) {
	                tagItem = tagItems[0];
	              }
	              // remove the first element, if it has the `isTag` prop we generate a new one with each keyup, shaving the previous
	              if (items.length > 0 && tagItem) {
	                hasTag = true;
	                items = items.slice(1, items.length);
	                stashArr = stashArr.slice(1, stashArr.length);
	              }
	              newItem = $select.tagging.fct($select.search);
	              // verify the new tag doesn't match the value of a possible selection choice or an already selected item.
	              if (stashArr.some(function (origItem) {
	                return angular.equals(origItem, newItem);
	              }) || $select.selected.some(function (origItem) {
	                return angular.equals(origItem, newItem);
	              })) {
	                scope.$evalAsync(function () {
	                  $select.activeIndex = 0;
	                  $select.items = items;
	                });
	                return;
	              }
	              if (newItem) newItem.isTag = true;
	              // handle newItem string and stripping dupes in tagging string context
	            } else {
	                // find any tagging items already in the $select.items array and store them
	                tagItems = $select.$filter('filter')(items, function (item) {
	                  return item.match($select.taggingLabel);
	                });
	                if (tagItems.length > 0) {
	                  tagItem = tagItems[0];
	                }
	                item = items[0];
	                // remove existing tag item if found (should only ever be one tag item)
	                if (item !== undefined && items.length > 0 && tagItem) {
	                  hasTag = true;
	                  items = items.slice(1, items.length);
	                  stashArr = stashArr.slice(1, stashArr.length);
	                }
	                newItem = $select.search + ' ' + $select.taggingLabel;
	                if (_findApproxDupe($select.selected, $select.search) > -1) {
	                  return;
	                }
	                // verify the the tag doesn't match the value of an existing item from
	                // the searched data set or the items already selected
	                if (_findCaseInsensitiveDupe(stashArr.concat($select.selected))) {
	                  // if there is a tag from prev iteration, strip it / queue the change
	                  // and return early
	                  if (hasTag) {
	                    items = stashArr;
	                    scope.$evalAsync(function () {
	                      $select.activeIndex = 0;
	                      $select.items = items;
	                    });
	                  }
	                  return;
	                }
	                if (_findCaseInsensitiveDupe(stashArr)) {
	                  // if there is a tag from prev iteration, strip it
	                  if (hasTag) {
	                    $select.items = stashArr.slice(1, stashArr.length);
	                  }
	                  return;
	                }
	              }
	            if (hasTag) dupeIndex = _findApproxDupe($select.selected, newItem);
	            // dupe found, shave the first item
	            if (dupeIndex > -1) {
	              items = items.slice(dupeIndex + 1, items.length - 1);
	            } else {
	              items = [];
	              if (newItem) items.push(newItem);
	              items = items.concat(stashArr);
	            }
	            scope.$evalAsync(function () {
	              $select.activeIndex = 0;
	              $select.items = items;
	
	              if ($select.isGrouped) {
	                // update item references in groups, so that indexOf will work after angular.copy
	                var itemsWithoutTag = newItem ? items.slice(1) : items;
	                $select.setItemsFn(itemsWithoutTag);
	                if (newItem) {
	                  // add tag item as a new group
	                  $select.items.unshift(newItem);
	                  $select.groups.unshift({ name: '', items: [newItem], tagging: true });
	                }
	              }
	            });
	          }
	        });
	        function _findCaseInsensitiveDupe(arr) {
	          if (arr === undefined || $select.search === undefined) {
	            return false;
	          }
	          var hasDupe = arr.filter(function (origItem) {
	            if ($select.search.toUpperCase() === undefined || origItem === undefined) {
	              return false;
	            }
	            return origItem.toUpperCase() === $select.search.toUpperCase();
	          }).length > 0;
	
	          return hasDupe;
	        }
	        function _findApproxDupe(haystack, needle) {
	          var dupeIndex = -1;
	          if (angular.isArray(haystack)) {
	            var tempArr = angular.copy(haystack);
	            for (var i = 0; i < tempArr.length; i++) {
	              // handle the simple string version of tagging
	              if ($select.tagging.fct === undefined) {
	                // search the array for the match
	                if (tempArr[i] + ' ' + $select.taggingLabel === needle) {
	                  dupeIndex = i;
	                }
	                // handle the object tagging implementation
	              } else {
	                  var mockObj = tempArr[i];
	                  if (angular.isObject(mockObj)) {
	                    mockObj.isTag = true;
	                  }
	                  if (angular.equals(mockObj, needle)) {
	                    dupeIndex = i;
	                  }
	                }
	            }
	          }
	          return dupeIndex;
	        }
	
	        $select.searchInput.on('blur', function () {
	          $timeout(function () {
	            $selectMultiple.activeMatchIndex = -1;
	          });
	        });
	      }
	    };
	  }]);
	
	  uis.directive('uiSelectNoChoice', ['uiSelectConfig', function (uiSelectConfig) {
	    return {
	      restrict: 'EA',
	      require: '^uiSelect',
	      replace: true,
	      transclude: true,
	      templateUrl: function templateUrl(tElement) {
	        // Needed so the uiSelect can detect the transcluded content
	        tElement.addClass('ui-select-no-choice');
	
	        // Gets theme attribute from parent (ui-select)
	        var theme = tElement.parent().attr('theme') || uiSelectConfig.theme;
	        return theme + '/no-choice.tpl.html';
	      }
	    };
	  }]);
	
	  uis.directive('uiSelectSingle', ['$timeout', '$compile', function ($timeout, $compile) {
	    return {
	      restrict: 'EA',
	      require: ['^uiSelect', '^ngModel'],
	      link: function link(scope, element, attrs, ctrls) {
	        var $select = ctrls[0];
	        var ngModel = ctrls[1];
	
	        //From view --> model
	        ngModel.$parsers.unshift(function (inputValue) {
	          // Keep original value for undefined and null
	          if (isNil(inputValue)) {
	            return inputValue;
	          }
	
	          var locals = {},
	              result;
	          locals[$select.parserResult.itemName] = inputValue;
	          result = $select.parserResult.modelMapper(scope, locals);
	          return result;
	        });
	
	        //From model --> view
	        ngModel.$formatters.unshift(function (inputValue) {
	          // Keep original value for undefined and null
	          if (isNil(inputValue)) {
	            return inputValue;
	          }
	
	          var data = $select.parserResult && $select.parserResult.source(scope, { $select: { search: '' } }),
	              //Overwrite $search
	          locals = {},
	              result;
	          if (data) {
	            var checkFnSingle = function checkFnSingle(d) {
	              locals[$select.parserResult.itemName] = d;
	              result = $select.parserResult.modelMapper(scope, locals);
	              return result === inputValue;
	            };
	            //If possible pass same object stored in $select.selected
	            if ($select.selected && checkFnSingle($select.selected)) {
	              return $select.selected;
	            }
	            for (var i = data.length - 1; i >= 0; i--) {
	              if (checkFnSingle(data[i])) return data[i];
	            }
	          }
	          return inputValue;
	        });
	
	        //Update viewValue if model change
	        scope.$watch('$select.selected', function (newValue) {
	          if (ngModel.$viewValue !== newValue) {
	            ngModel.$setViewValue(newValue);
	          }
	        });
	
	        ngModel.$render = function () {
	          $select.selected = ngModel.$viewValue;
	        };
	
	        scope.$on('uis:select', function (event, item) {
	          $select.selected = item;
	          var locals = {};
	          locals[$select.parserResult.itemName] = item;
	
	          $timeout(function () {
	            $select.onSelectCallback(scope, {
	              $item: item,
	              $model: isNil(item) ? item : $select.parserResult.modelMapper(scope, locals)
	            });
	          });
	        });
	
	        scope.$on('uis:close', function (event, skipFocusser) {
	          $timeout(function () {
	            $select.focusser.prop('disabled', false);
	            if (!skipFocusser) $select.focusser[0].focus();
	          }, 0, false);
	        });
	
	        scope.$on('uis:activate', function () {
	          focusser.prop('disabled', true); //Will reactivate it on .close()
	        });
	
	        //Idea from: https://github.com/ivaynberg/select2/blob/79b5bf6db918d7560bdd959109b7bcfb47edaf43/select2.js#L1954
	        var focusser = angular.element("<input ng-disabled='$select.disabled' class='ui-select-focusser ui-select-offscreen' type='text' id='{{ $select.focusserId }}' aria-label='{{ $select.focusserTitle }}' aria-haspopup='true' role='button' />");
	        $compile(focusser)(scope);
	        $select.focusser = focusser;
	
	        //Input that will handle focus
	        $select.focusInput = focusser;
	
	        element.parent().append(focusser);
	        focusser.bind('focus', function () {
	          scope.$evalAsync(function () {
	            $select.focus = true;
	          });
	        });
	        focusser.bind('blur', function () {
	          scope.$evalAsync(function () {
	            $select.focus = false;
	          });
	        });
	        focusser.bind('keydown', function (e) {
	          if (e.which === KEY.BACKSPACE && $select.backspaceReset !== false) {
	            e.preventDefault();
	            e.stopPropagation();
	            $select.select(undefined);
	            scope.$apply();
	            return;
	          }
	
	          if (e.which === KEY.TAB || KEY.isControl(e) || KEY.isFunctionKey(e) || e.which === KEY.ESC) {
	            return;
	          }
	
	          if (e.which == KEY.DOWN || e.which == KEY.UP || e.which == KEY.ENTER || e.which == KEY.SPACE) {
	            e.preventDefault();
	            e.stopPropagation();
	            $select.activate();
	          }
	
	          scope.$digest();
	        });
	
	        focusser.bind('keyup input', function (e) {
	          if (e.which === KEY.TAB || KEY.isControl(e) || KEY.isFunctionKey(e) || e.which === KEY.ESC || e.which == KEY.ENTER || e.which === KEY.BACKSPACE) {
	            return;
	          }
	
	          $select.activate(focusser.val()); //User pressed some regular key, so we pass it to the search input
	          focusser.val('');
	          scope.$digest();
	        });
	      }
	    };
	  }]);
	
	  // Make multiple matches sortable
	  uis.directive('uiSelectSort', ['$timeout', 'uiSelectConfig', 'uiSelectMinErr', function ($timeout, uiSelectConfig, uiSelectMinErr) {
	    return {
	      require: ['^^uiSelect', '^ngModel'],
	      link: function link(scope, element, attrs, ctrls) {
	        if (scope[attrs.uiSelectSort] === null) {
	          throw uiSelectMinErr('sort', 'Expected a list to sort');
	        }
	
	        var $select = ctrls[0];
	        var $ngModel = ctrls[1];
	
	        var options = angular.extend({
	          axis: 'horizontal'
	        }, scope.$eval(attrs.uiSelectSortOptions));
	
	        var axis = options.axis;
	        var draggingClassName = 'dragging';
	        var droppingClassName = 'dropping';
	        var droppingBeforeClassName = 'dropping-before';
	        var droppingAfterClassName = 'dropping-after';
	
	        scope.$watch(function () {
	          return $select.sortable;
	        }, function (newValue) {
	          if (newValue) {
	            element.attr('draggable', true);
	          } else {
	            element.removeAttr('draggable');
	          }
	        });
	
	        element.on('dragstart', function (event) {
	          element.addClass(draggingClassName);
	
	          (event.dataTransfer || event.originalEvent.dataTransfer).setData('text', scope.$index.toString());
	        });
	
	        element.on('dragend', function () {
	          removeClass(draggingClassName);
	        });
	
	        var move = function move(from, to) {
	          /*jshint validthis: true */
	          this.splice(to, 0, this.splice(from, 1)[0]);
	        };
	
	        var removeClass = function removeClass(className) {
	          angular.forEach($select.$element.querySelectorAll('.' + className), function (el) {
	            angular.element(el).removeClass(className);
	          });
	        };
	
	        var dragOverHandler = function dragOverHandler(event) {
	          event.preventDefault();
	
	          var offset = axis === 'vertical' ? event.offsetY || event.layerY || (event.originalEvent ? event.originalEvent.offsetY : 0) : event.offsetX || event.layerX || (event.originalEvent ? event.originalEvent.offsetX : 0);
	
	          if (offset < this[axis === 'vertical' ? 'offsetHeight' : 'offsetWidth'] / 2) {
	            removeClass(droppingAfterClassName);
	            element.addClass(droppingBeforeClassName);
	          } else {
	            removeClass(droppingBeforeClassName);
	            element.addClass(droppingAfterClassName);
	          }
	        };
	
	        var dropTimeout;
	
	        var dropHandler = function dropHandler(event) {
	          event.preventDefault();
	
	          var droppedItemIndex = parseInt((event.dataTransfer || event.originalEvent.dataTransfer).getData('text'), 10);
	
	          // prevent event firing multiple times in firefox
	          $timeout.cancel(dropTimeout);
	          dropTimeout = $timeout(function () {
	            _dropHandler(droppedItemIndex);
	          }, 20);
	        };
	
	        var _dropHandler = function _dropHandler(droppedItemIndex) {
	          var theList = scope.$eval(attrs.uiSelectSort);
	          var itemToMove = theList[droppedItemIndex];
	          var newIndex = null;
	
	          if (element.hasClass(droppingBeforeClassName)) {
	            if (droppedItemIndex < scope.$index) {
	              newIndex = scope.$index - 1;
	            } else {
	              newIndex = scope.$index;
	            }
	          } else {
	            if (droppedItemIndex < scope.$index) {
	              newIndex = scope.$index;
	            } else {
	              newIndex = scope.$index + 1;
	            }
	          }
	
	          move.apply(theList, [droppedItemIndex, newIndex]);
	
	          $ngModel.$setViewValue(Date.now());
	
	          scope.$apply(function () {
	            scope.$emit('uiSelectSort:change', {
	              array: theList,
	              item: itemToMove,
	              from: droppedItemIndex,
	              to: newIndex
	            });
	          });
	
	          removeClass(droppingClassName);
	          removeClass(droppingBeforeClassName);
	          removeClass(droppingAfterClassName);
	
	          element.off('drop', dropHandler);
	        };
	
	        element.on('dragenter', function () {
	          if (element.hasClass(draggingClassName)) {
	            return;
	          }
	
	          element.addClass(droppingClassName);
	
	          element.on('dragover', dragOverHandler);
	          element.on('drop', dropHandler);
	        });
	
	        element.on('dragleave', function (event) {
	          if (event.target != element) {
	            return;
	          }
	
	          removeClass(droppingClassName);
	          removeClass(droppingBeforeClassName);
	          removeClass(droppingAfterClassName);
	
	          element.off('dragover', dragOverHandler);
	          element.off('drop', dropHandler);
	        });
	      }
	    };
	  }]);
	
	  uis.directive('uisOpenClose', ['$parse', '$timeout', function ($parse, $timeout) {
	    return {
	      restrict: 'A',
	      require: 'uiSelect',
	      link: function link(scope, element, attrs, $select) {
	        $select.onOpenCloseCallback = $parse(attrs.uisOpenClose);
	
	        scope.$watch('$select.open', function (isOpen, previousState) {
	          if (isOpen !== previousState) {
	            $timeout(function () {
	              $select.onOpenCloseCallback(scope, {
	                isOpen: isOpen
	              });
	            });
	          }
	        });
	      }
	    };
	  }]);
	
	  /**
	   * Parses "repeat" attribute.
	   *
	   * Taken from AngularJS ngRepeat source code
	   * See https://github.com/angular/angular.js/blob/v1.2.15/src/ng/directive/ngRepeat.js#L211
	   *
	   * Original discussion about parsing "repeat" attribute instead of fully relying on ng-repeat:
	   * https://github.com/angular-ui/ui-select/commit/5dd63ad#commitcomment-5504697
	   */
	
	  uis.service('uisRepeatParser', ['uiSelectMinErr', '$parse', function (uiSelectMinErr, $parse) {
	    var self = this;
	
	    /**
	     * Example:
	     * expression = "address in addresses | filter: {street: $select.search} track by $index"
	     * itemName = "address",
	     * source = "addresses | filter: {street: $select.search}",
	     * trackByExp = "$index",
	     */
	    self.parse = function (expression) {
	      var match;
	      //var isObjectCollection = /\(\s*([\$\w][\$\w]*)\s*,\s*([\$\w][\$\w]*)\s*\)/.test(expression);
	      // If an array is used as collection
	
	      // if (isObjectCollection){
	      // 000000000000000000000000000000111111111000000000000000222222222222220033333333333333333333330000444444444444444444000000000000000055555555555000000000000000000000066666666600000000
	      match = expression.match(/^\s*(?:([\s\S]+?)\s+as\s+)?(?:([\$\w][\$\w]*)|(?:\(\s*([\$\w][\$\w]*)\s*,\s*([\$\w][\$\w]*)\s*\)))\s+in\s+(\s*[\s\S]+?)?(?:\s+track\s+by\s+([\s\S]+?))?\s*$/);
	
	      // 1 Alias
	      // 2 Item
	      // 3 Key on (key,value)
	      // 4 Value on (key,value)
	      // 5 Source expression (including filters)
	      // 6 Track by
	
	      if (!match) {
	        throw uiSelectMinErr('iexp', "Expected expression in form of '_item_ in _collection_[ track by _id_]' but got '{0}'.", expression);
	      }
	
	      var source = match[5],
	          filters = '';
	
	      // When using (key,value) ui-select requires filters to be extracted, since the object
	      // is converted to an array for $select.items
	      // (in which case the filters need to be reapplied)
	      if (match[3]) {
	        // Remove any enclosing parenthesis
	        source = match[5].replace(/(^\()|(\)$)/g, '');
	        // match all after | but not after ||
	        var filterMatch = match[5].match(/^\s*(?:[\s\S]+?)(?:[^\|]|\|\|)+([\s\S]*)\s*$/);
	        if (filterMatch && filterMatch[1].trim()) {
	          filters = filterMatch[1];
	          source = source.replace(filters, '');
	        }
	      }
	
	      return {
	        itemName: match[4] || match[2], // (lhs) Left-hand side,
	        keyName: match[3], //for (key, value) syntax
	        source: $parse(source),
	        filters: filters,
	        trackByExp: match[6],
	        modelMapper: $parse(match[1] || match[4] || match[2]),
	        repeatExpression: function repeatExpression(grouped) {
	          var expression = this.itemName + ' in ' + (grouped ? '$group.items' : '$select.items');
	          if (this.trackByExp) {
	            expression += ' track by ' + this.trackByExp;
	          }
	          return expression;
	        }
	      };
	    };
	
	    self.getGroupNgRepeatExpression = function () {
	      return '$group in $select.groups track by $group.name';
	    };
	  }]);
	})();
	angular.module('ui.select').run(['$templateCache', function ($templateCache) {
	  $templateCache.put('bootstrap/choices.tpl.html', '<ul class="ui-select-choices ui-select-choices-content ui-select-dropdown dropdown-menu" ng-show="$select.open && $select.items.length > 0"><li class="ui-select-choices-group" id="ui-select-choices-{{ $select.generatedId }}"><div class="divider" ng-show="$select.isGrouped && $index > 0"></div><div ng-show="$select.isGrouped" class="ui-select-choices-group-label dropdown-header" ng-bind="$group.name"></div><div ng-attr-id="ui-select-choices-row-{{ $select.generatedId }}-{{$index}}" class="ui-select-choices-row" ng-class="{active: $select.isActive(this), disabled: $select.isDisabled(this)}" role="option"><span class="ui-select-choices-row-inner"></span></div></li></ul>');
	  $templateCache.put('bootstrap/match-multiple.tpl.html', '<span class="ui-select-match"><span ng-repeat="$item in $select.selected track by $index"><span class="ui-select-match-item btn btn-default btn-xs" tabindex="-1" type="button" ng-disabled="$select.disabled" ng-click="$selectMultiple.activeMatchIndex = $index;" ng-class="{\'btn-primary\':$selectMultiple.activeMatchIndex === $index, \'select-locked\':$select.isLocked(this, $index)}" ui-select-sort="$select.selected"><span class="close ui-select-match-close" ng-hide="$select.disabled" ng-click="$selectMultiple.removeChoice($index)">&nbsp;&times;</span> <span uis-transclude-append=""></span></span></span></span>');
	  $templateCache.put('bootstrap/match.tpl.html', '<div class="ui-select-match" ng-hide="$select.open && $select.searchEnabled" ng-disabled="$select.disabled" ng-class="{\'btn-default-focus\':$select.focus}"><span tabindex="-1" class="btn btn-default form-control ui-select-toggle" aria-label="{{ $select.baseTitle }} activate" ng-disabled="$select.disabled" ng-click="$select.activate()" style="outline: 0;"><span ng-show="$select.isEmpty()" class="ui-select-placeholder text-muted">{{$select.placeholder}}</span> <span ng-hide="$select.isEmpty()" class="ui-select-match-text pull-left" ng-class="{\'ui-select-allow-clear\': $select.allowClear && !$select.isEmpty()}" ng-transclude=""></span> <i class="caret pull-right" ng-click="$select.toggle($event)"></i> <a ng-show="$select.allowClear && !$select.isEmpty() && ($select.disabled !== true)" aria-label="{{ $select.baseTitle }} clear" style="margin-right: 10px" ng-click="$select.clear($event)" class="btn btn-xs btn-link pull-right"><i class="glyphicon glyphicon-remove" aria-hidden="true"></i></a></span></div>');
	  $templateCache.put('bootstrap/no-choice.tpl.html', '<ul class="ui-select-no-choice dropdown-menu" ng-show="$select.items.length == 0"><li ng-transclude=""></li></ul>');
	  $templateCache.put('bootstrap/select-multiple.tpl.html', '<div class="ui-select-container ui-select-multiple ui-select-bootstrap dropdown form-control" ng-class="{open: $select.open}"><div><div class="ui-select-match"></div><input type="search" autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false" class="ui-select-search input-xs" placeholder="{{$selectMultiple.getPlaceholder()}}" ng-disabled="$select.disabled" ng-hide="$select.disabled" ng-click="$select.activate()" ng-model="$select.search" role="combobox" aria-expanded="{{$select.open}}" aria-label="{{$select.baseTitle}}" ng-class="{\'spinner\': $select.refreshing}" ondrop="return false;"></div><div class="ui-select-choices"></div><div class="ui-select-no-choice"></div></div>');
	  $templateCache.put('bootstrap/select.tpl.html', '<div class="ui-select-container ui-select-bootstrap dropdown" ng-class="{open: $select.open}"><div class="ui-select-match"></div><span ng-show="$select.open && $select.refreshing && $select.spinnerEnabled" class="ui-select-refreshing {{$select.spinnerClass}}"></span> <input type="search" autocomplete="off" tabindex="-1" aria-expanded="true" aria-label="{{ $select.baseTitle }}" aria-owns="ui-select-choices-{{ $select.generatedId }}" class="form-control ui-select-search" ng-class="{ \'ui-select-search-hidden\' : !$select.searchEnabled }" placeholder="{{$select.placeholder}}" ng-model="$select.search" ng-show="$select.open"><div class="ui-select-choices"></div><div class="ui-select-no-choice"></div></div>');
	  $templateCache.put('select2/choices.tpl.html', '<ul tabindex="-1" class="ui-select-choices ui-select-choices-content select2-results"><li class="ui-select-choices-group" ng-class="{\'select2-result-with-children\': $select.choiceGrouped($group) }"><div ng-show="$select.choiceGrouped($group)" class="ui-select-choices-group-label select2-result-label" ng-bind="$group.name"></div><ul id="ui-select-choices-{{ $select.generatedId }}" ng-class="{\'select2-result-sub\': $select.choiceGrouped($group), \'select2-result-single\': !$select.choiceGrouped($group) }"><li role="option" ng-attr-id="ui-select-choices-row-{{ $select.generatedId }}-{{$index}}" class="ui-select-choices-row" ng-class="{\'select2-highlighted\': $select.isActive(this), \'select2-disabled\': $select.isDisabled(this)}"><div class="select2-result-label ui-select-choices-row-inner"></div></li></ul></li></ul>');
	  $templateCache.put('select2/match-multiple.tpl.html', '<span class="ui-select-match"><li class="ui-select-match-item select2-search-choice" ng-repeat="$item in $select.selected track by $index" ng-class="{\'select2-search-choice-focus\':$selectMultiple.activeMatchIndex === $index, \'select2-locked\':$select.isLocked(this, $index)}" ui-select-sort="$select.selected"><span uis-transclude-append=""></span> <a href="javascript:;" class="ui-select-match-close select2-search-choice-close" ng-click="$selectMultiple.removeChoice($index)" tabindex="-1"></a></li></span>');
	  $templateCache.put('select2/match.tpl.html', '<a class="select2-choice ui-select-match" ng-class="{\'select2-default\': $select.isEmpty()}" ng-click="$select.toggle($event)" aria-label="{{ $select.baseTitle }} select"><span ng-show="$select.isEmpty()" class="select2-chosen">{{$select.placeholder}}</span> <span ng-hide="$select.isEmpty()" class="select2-chosen" ng-transclude=""></span> <abbr ng-if="$select.allowClear && !$select.isEmpty()" class="select2-search-choice-close" ng-click="$select.clear($event)"></abbr> <span class="select2-arrow ui-select-toggle"><b></b></span></a>');
	  $templateCache.put('select2/no-choice.tpl.html', '<div class="ui-select-no-choice dropdown" ng-show="$select.items.length == 0"><div class="dropdown-content"><div data-selectable="" ng-transclude=""></div></div></div>');
	  $templateCache.put('select2/select-multiple.tpl.html', '<div class="ui-select-container ui-select-multiple select2 select2-container select2-container-multi" ng-class="{\'select2-container-active select2-dropdown-open open\': $select.open, \'select2-container-disabled\': $select.disabled}"><ul class="select2-choices"><span class="ui-select-match"></span><li class="select2-search-field"><input type="search" autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false" role="combobox" aria-expanded="true" aria-owns="ui-select-choices-{{ $select.generatedId }}" aria-label="{{ $select.baseTitle }}" aria-activedescendant="ui-select-choices-row-{{ $select.generatedId }}-{{ $select.activeIndex }}" class="select2-input ui-select-search" placeholder="{{$selectMultiple.getPlaceholder()}}" ng-disabled="$select.disabled" ng-hide="$select.disabled" ng-model="$select.search" ng-click="$select.activate()" style="width: 34px;" ondrop="return false;"></li></ul><div class="ui-select-dropdown select2-drop select2-with-searchbox select2-drop-active" ng-class="{\'select2-display-none\': !$select.open || $select.items.length === 0}"><div class="ui-select-choices"></div></div></div>');
	  $templateCache.put('select2/select.tpl.html', '<div class="ui-select-container select2 select2-container" ng-class="{\'select2-container-active select2-dropdown-open open\': $select.open, \'select2-container-disabled\': $select.disabled, \'select2-container-active\': $select.focus, \'select2-allowclear\': $select.allowClear && !$select.isEmpty()}"><div class="ui-select-match"></div><div class="ui-select-dropdown select2-drop select2-with-searchbox select2-drop-active" ng-class="{\'select2-display-none\': !$select.open}"><div class="search-container" ng-class="{\'ui-select-search-hidden\':!$select.searchEnabled, \'select2-search\':$select.searchEnabled}"><input type="search" autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false" ng-class="{\'select2-active\': $select.refreshing}" role="combobox" aria-expanded="true" aria-owns="ui-select-choices-{{ $select.generatedId }}" aria-label="{{ $select.baseTitle }}" class="ui-select-search select2-input" ng-model="$select.search"></div><div class="ui-select-choices"></div><div class="ui-select-no-choice"></div></div></div>');
	
	  $templateCache.put('selectize/choices.tpl.html', '<div ng-show="$select.open" class="ui-select-choices ui-select-dropdown selectize-dropdown single"><div class="ui-select-choices-content selectize-dropdown-content"><div class="ui-select-choices-group optgroup" ng-class="{\'ui-select-choices-ungrouped\' : !$group.name}" role="listbox"><div ng-show="$select.isGrouped" class="ui-select-choices-group-label optgroup-header" ng-if="$group.name && $select.showGroupHeaders"' + ' ng-bind-html="$group.name | highlight: $select.search"></div><div role="option" class="ui-select-choices-row" ng-class="{active: $select.isActive(this), disabled: $select.isDisabled(this)}"><div class="option ui-select-choices-row-inner" data-selectable=""></div></div></div></div></div>');
	
	  // $templateCache.put(
	  //   'selectize/choices.tpl.html',
	  //   '<div ng-show="$select.open" class="ui-select-choices ui-select-dropdown selectize-dropdown" ng-class="{\'single\': !$select.multiple, \'multi\': $select.multiple}"><div class="ui-select-choices-content selectize-dropdown-content"><div class="ui-select-choices-group optgroup"><div ng-show="$select.isGrouped" class="ui-select-choices-group-label optgroup-header" ng-bind="$group.name"></div><div role="option" class="ui-select-choices-row" ng-class="{active: $select.isActive(this), disabled: $select.isDisabled(this)}"><div class="option ui-select-choices-row-inner" data-selectable=""></div></div></div></div></div>'
	  // );
	
	  $templateCache.put('selectize/match-multiple.tpl.html', '<div class="ui-select-match" data-value="" ng-repeat="$item in $select.selected track by $index" ng-click="$selectMultiple.activeMatchIndex = $index;" ng-class="{\'active\':$selectMultiple.activeMatchIndex === $index}" ui-select-sort="$select.selected"><span class="ui-select-match-item" ng-class="{\'select-locked\':$select.isLocked(this, $index)}"><span uis-transclude-append=""></span> <span class="remove ui-select-match-close" ng-hide="$select.disabled" ng-click="$selectMultiple.removeChoice($index)">&times;</span></span></div>');
	  $templateCache.put('selectize/match.tpl.html', '<div ng-hide="$select.searchEnabled && ($select.open || $select.isEmpty())" class="ui-select-match"><span ng-show="!$select.searchEnabled && ($select.isEmpty() || $select.open)" class="ui-select-placeholder text-muted">{{$select.placeholder}}</span> <span ng-hide="$select.isEmpty() || $select.open" ng-transclude=""></span></div>');
	  $templateCache.put('selectize/no-choice.tpl.html', '<div class="ui-select-no-choice selectize-dropdown" ng-show="$select.items.length == 0"><div class="selectize-dropdown-content"><div data-selectable="" ng-transclude=""></div></div></div>');
	  $templateCache.put('selectize/select-multiple.tpl.html', '<div class="ui-select-container selectize-control multi plugin-remove_button" ng-class="{\'open\': $select.open}"><div class="selectize-input" ng-class="{\'focus\': $select.open, \'disabled\': $select.disabled, \'selectize-focus\' : $select.focus}" ng-click="$select.open && !$select.searchEnabled ? $select.toggle($event) : $select.activate()"><div class="ui-select-match"></div><input type="search" autocomplete="off" tabindex="-1" class="ui-select-search" ng-class="{\'ui-select-search-hidden\':!$select.searchEnabled}" placeholder="{{$selectMultiple.getPlaceholder()}}" ng-model="$select.search" ng-disabled="$select.disabled" aria-expanded="{{$select.open}}" aria-label="{{ $select.baseTitle }}" ondrop="return false;"></div><div class="ui-select-choices"></div><div class="ui-select-no-choice"></div></div>');
	  $templateCache.put('selectize/select.tpl.html', '<div class="ui-select-container selectize-control single" ng-class="{\'open\': $select.open}"><div class="selectize-input" ng-class="{\'focus\': $select.open, \'disabled\': $select.disabled, \'selectize-focus\' : $select.focus}" ng-click="$select.open && !$select.searchEnabled ? $select.toggle($event) : $select.activate()"><div class="ui-select-match"></div><input type="search" autocomplete="off" tabindex="-1" class="ui-select-search ui-select-toggle" ng-class="{\'ui-select-search-hidden\':!$select.searchEnabled}" ng-click="$select.toggle($event)" placeholder="{{$select.placeholder}}" ng-model="$select.search" ng-hide="!$select.isEmpty() && !$select.open" ng-disabled="$select.disabled" aria-label="{{ $select.baseTitle }}"></div><div class="ui-select-choices"></div><div class="ui-select-no-choice"></div></div>');
	
	  // Fix for filter
	  $templateCache.put('select3/choices.tpl.html', '<ul tabindex="-1" class="ui-select-choices ui-select-choices-content select2-results"><li class="ui-select-choices-group" ng-class="{\'select2-result-with-children\': $select.choiceGrouped($group) }"><div ng-show="$select.choiceGrouped($group)" class="ui-select-choices-group-label select2-result-label" ng-bind="$group.name"></div><ul id="ui-select-choices-{{ $select.generatedId }}" ng-class="{\'select2-result-sub\': $select.choiceGrouped($group), \'select2-result-single\': !$select.choiceGrouped($group) }"><li role="option" ng-attr-id="ui-select-choices-row-{{ $select.generatedId }}-{{$index}}" class="ui-select-choices-row" ng-class="{\'select2-highlighted\': $select.isActive(this), \'select2-disabled\': $select.isDisabled(this)}"><div class="select2-result-label ui-select-choices-row-inner"></div></li></ul></li></ul>');
	  $templateCache.put('select3/match-multiple.tpl.html', '<span class="ui-select-match"><li class="ui-select-match-item select2-search-choice" ng-repeat="$item in $select.selected" ng-class="{\'select2-search-choice-focus\':$selectMultiple.activeMatchIndex === $index, \'select2-locked\':$select.isLocked(this, $index)}" ui-select-sort="$select.selected"><span uis-transclude-append=""></span> <a href="javascript:;" class="ui-select-match-close select2-search-choice-close" ng-click="$selectMultiple.removeChoice($index)" tabindex="-1"></a></li></span>');
	  $templateCache.put('select3/match.tpl.html', '<a class="select2-choice ui-select-match" ng-class="{\'select2-default\': $select.isEmpty()}" ng-click="$select.toggle($event)" aria-label="{{ $select.baseTitle }} select"><span ng-show="$select.isEmpty()" class="select2-chosen">{{$select.placeholder}}</span> <span ng-hide="$select.isEmpty()" class="select2-chosen" ng-transclude=""></span> <abbr ng-if="$select.allowClear && !$select.isEmpty()" class="select2-search-choice-close" ng-click="$select.clear($event)"></abbr> <span class="select2-arrow ui-select-toggle"><b></b></span></a>');
	  $templateCache.put('select3/no-choice.tpl.html', '<div class="ui-select-no-choice dropdown" ng-show="$select.items.length == 0"><div class="dropdown-content"><div data-selectable="" ng-transclude=""></div></div></div>');
	  $templateCache.put('select3/select-multiple.tpl.html', '<div class="ui-select-container ui-select-multiple select2 select2-container select2-container-multi" ng-class="{\'select2-container-active select2-dropdown-open open\': $select.open, \'select2-container-disabled\': $select.disabled}"><ul class="select2-choices"><span class="ui-select-match"></span><li class="select2-search-field"><input type="search" autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false" role="combobox" aria-expanded="true" aria-owns="ui-select-choices-{{ $select.generatedId }}" aria-label="{{ $select.baseTitle }}" aria-activedescendant="ui-select-choices-row-{{ $select.generatedId }}-{{ $select.activeIndex }}" class="select2-input ui-select-search" placeholder="{{$selectMultiple.getPlaceholder()}}" ng-disabled="$select.disabled" ng-hide="$select.disabled" ng-model="$select.search" ng-click="$select.activate()" style="width: 34px;" ondrop="return false;"></li></ul><div class="ui-select-dropdown select2-drop select2-with-searchbox select2-drop-active" ng-class="{\'select2-display-none\': !$select.open || $select.items.length === 0}"><div class="ui-select-choices"></div></div></div>');
	  $templateCache.put('select3/select.tpl.html', '<div class="ui-select-container select2 select2-container" ng-class="{\'select2-container-active select2-dropdown-open open\': $select.open, \'select2-container-disabled\': $select.disabled, \'select2-container-active\': $select.focus, \'select2-allowclear\': $select.allowClear && !$select.isEmpty()}"><div class="ui-select-match"></div><div class="ui-select-dropdown select2-drop select2-with-searchbox select2-drop-active" ng-class="{\'select2-display-none\': !$select.open}"><div class="search-container" ng-class="{\'ui-select-search-hidden\':!$select.searchEnabled, \'select2-search\':$select.searchEnabled}"><input type="search" autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false" ng-class="{\'select2-active\': $select.refreshing}" role="combobox" aria-expanded="true" aria-owns="ui-select-choices-{{ $select.generatedId }}" aria-label="{{ $select.baseTitle }}" class="ui-select-search select2-input" ng-model="$select.search"></div><div class="ui-select-choices"></div><div class="ui-select-no-choice"></div></div></div>');
	}]);

/***/ }),
/* 1362 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	__webpack_require__(1562);
	
	__webpack_require__(1768);
	
	__webpack_require__(1363);
	
	if (global._babelPolyfill) {
	  throw new Error("only one instance of babel-polyfill is allowed");
	}
	global._babelPolyfill = true;
	
	var DEFINE_PROPERTY = "defineProperty";
	function define(O, key, value) {
	  O[key] || Object[DEFINE_PROPERTY](O, key, {
	    writable: true,
	    configurable: true,
	    value: value
	  });
	}
	
	define(String.prototype, "padLeft", "".padStart);
	define(String.prototype, "padRight", "".padEnd);
	
	"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
	  [][key] && define(Array, key, Function.call.bind([][key]));
	});
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1363 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1370);
	module.exports = __webpack_require__(45).RegExp.escape;


/***/ }),
/* 1364 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(7);
	var isArray = __webpack_require__(458);
	var SPECIES = __webpack_require__(10)('species');
	
	module.exports = function (original) {
	  var C;
	  if (isArray(original)) {
	    C = original.constructor;
	    // cross-realm fallback
	    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
	    if (isObject(C)) {
	      C = C[SPECIES];
	      if (C === null) C = undefined;
	    }
	  } return C === undefined ? Array : C;
	};


/***/ }),
/* 1365 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
	var fails = __webpack_require__(6);
	var getTime = Date.prototype.getTime;
	var $toISOString = Date.prototype.toISOString;
	
	var lz = function (num) {
	  return num > 9 ? num : '0' + num;
	};
	
	// PhantomJS / old WebKit has a broken implementations
	module.exports = (fails(function () {
	  return $toISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
	}) || !fails(function () {
	  $toISOString.call(new Date(NaN));
	})) ? function toISOString() {
	  if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
	  var d = this;
	  var y = d.getUTCFullYear();
	  var m = d.getUTCMilliseconds();
	  var s = y < 0 ? '-' : y > 9999 ? '+' : '';
	  return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
	    '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
	    'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
	    ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
	} : $toISOString;


/***/ }),
/* 1366 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var anObject = __webpack_require__(4);
	var toPrimitive = __webpack_require__(69);
	var NUMBER = 'number';
	
	module.exports = function (hint) {
	  if (hint !== 'string' && hint !== NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
	  return toPrimitive(anObject(this), hint != NUMBER);
	};


/***/ }),
/* 1367 */
/***/ (function(module, exports, __webpack_require__) {

	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__(138);
	var gOPS = __webpack_require__(462);
	var pIE = __webpack_require__(315);
	module.exports = function (it) {
	  var result = getKeys(it);
	  var getSymbols = gOPS.f;
	  if (getSymbols) {
	    var symbols = getSymbols(it);
	    var isEnum = pIE.f;
	    var i = 0;
	    var key;
	    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
	  } return result;
	};


/***/ }),
/* 1368 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(316)('native-function-to-string', Function.toString);


/***/ }),
/* 1369 */
/***/ (function(module, exports) {

	module.exports = function (regExp, replace) {
	  var replacer = replace === Object(replace) ? function (part) {
	    return replace[part];
	  } : replace;
	  return function (it) {
	    return String(it).replace(regExp, replacer);
	  };
	};


/***/ }),
/* 1370 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/benjamingr/RexExp.escape
	var $export = __webpack_require__(3);
	var $re = __webpack_require__(1369)(/[\\^$*+?.()|[\]{}]/g, '\\$&');
	
	$export($export.S, 'RegExp', { escape: function escape(it) { return $re(it); } });


/***/ }),
/* 1371 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	var $export = __webpack_require__(3);
	
	$export($export.P, 'Array', { copyWithin: __webpack_require__(1088) });
	
	__webpack_require__(92)('copyWithin');


/***/ }),
/* 1372 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3);
	var $every = __webpack_require__(66)(4);
	
	$export($export.P + $export.F * !__webpack_require__(47)([].every, true), 'Array', {
	  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
	  every: function every(callbackfn /* , thisArg */) {
	    return $every(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 1373 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	var $export = __webpack_require__(3);
	
	$export($export.P, 'Array', { fill: __webpack_require__(704) });
	
	__webpack_require__(92)('fill');


/***/ }),
/* 1374 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3);
	var $filter = __webpack_require__(66)(2);
	
	$export($export.P + $export.F * !__webpack_require__(47)([].filter, true), 'Array', {
	  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
	  filter: function filter(callbackfn /* , thisArg */) {
	    return $filter(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 1375 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
	var $export = __webpack_require__(3);
	var $find = __webpack_require__(66)(6);
	var KEY = 'findIndex';
	var forced = true;
	// Shouldn't skip holes
	if (KEY in []) Array(1)[KEY](function () { forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  findIndex: function findIndex(callbackfn /* , that = undefined */) {
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(92)(KEY);


/***/ }),
/* 1376 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
	var $export = __webpack_require__(3);
	var $find = __webpack_require__(66)(5);
	var KEY = 'find';
	var forced = true;
	// Shouldn't skip holes
	if (KEY in []) Array(1)[KEY](function () { forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  find: function find(callbackfn /* , that = undefined */) {
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(92)(KEY);


/***/ }),
/* 1377 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3);
	var $forEach = __webpack_require__(66)(0);
	var STRICT = __webpack_require__(47)([].forEach, true);
	
	$export($export.P + $export.F * !STRICT, 'Array', {
	  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
	  forEach: function forEach(callbackfn /* , thisArg */) {
	    return $forEach(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 1378 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var ctx = __webpack_require__(46);
	var $export = __webpack_require__(3);
	var toObject = __webpack_require__(17);
	var call = __webpack_require__(1099);
	var isArrayIter = __webpack_require__(712);
	var toLength = __webpack_require__(11);
	var createProperty = __webpack_require__(706);
	var getIterFn = __webpack_require__(728);
	
	$export($export.S + $export.F * !__webpack_require__(460)(function (iter) { Array.from(iter); }), 'Array', {
	  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
	  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
	    var O = toObject(arrayLike);
	    var C = typeof this == 'function' ? this : Array;
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var index = 0;
	    var iterFn = getIterFn(O);
	    var length, result, step, iterator;
	    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
	    // if object isn't iterable or it's array with default iterator - use simple case
	    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
	      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
	        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
	      }
	    } else {
	      length = toLength(O.length);
	      for (result = new C(length); length > index; index++) {
	        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
	      }
	    }
	    result.length = index;
	    return result;
	  }
	});


/***/ }),
/* 1379 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3);
	var $indexOf = __webpack_require__(455)(false);
	var $native = [].indexOf;
	var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;
	
	$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(47)($native)), 'Array', {
	  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
	  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
	    return NEGATIVE_ZERO
	      // convert -0 to +0
	      ? $native.apply(this, arguments) || 0
	      : $indexOf(this, searchElement, arguments[1]);
	  }
	});


/***/ }),
/* 1380 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Array', { isArray: __webpack_require__(458) });


/***/ }),
/* 1381 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.13 Array.prototype.join(separator)
	var $export = __webpack_require__(3);
	var toIObject = __webpack_require__(39);
	var arrayJoin = [].join;
	
	// fallback for not array-like strings
	$export($export.P + $export.F * (__webpack_require__(314) != Object || !__webpack_require__(47)(arrayJoin)), 'Array', {
	  join: function join(separator) {
	    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
	  }
	});


/***/ }),
/* 1382 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3);
	var toIObject = __webpack_require__(39);
	var toInteger = __webpack_require__(48);
	var toLength = __webpack_require__(11);
	var $native = [].lastIndexOf;
	var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;
	
	$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(47)($native)), 'Array', {
	  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
	  lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
	    // convert -0 to +0
	    if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
	    var O = toIObject(this);
	    var length = toLength(O.length);
	    var index = length - 1;
	    if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
	    if (index < 0) index = length + index;
	    for (;index >= 0; index--) if (index in O) if (O[index] === searchElement) return index || 0;
	    return -1;
	  }
	});


/***/ }),
/* 1383 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3);
	var $map = __webpack_require__(66)(1);
	
	$export($export.P + $export.F * !__webpack_require__(47)([].map, true), 'Array', {
	  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
	  map: function map(callbackfn /* , thisArg */) {
	    return $map(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 1384 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3);
	var createProperty = __webpack_require__(706);
	
	// WebKit Array.of isn't generic
	$export($export.S + $export.F * __webpack_require__(6)(function () {
	  function F() { /* empty */ }
	  return !(Array.of.call(F) instanceof F);
	}), 'Array', {
	  // 22.1.2.3 Array.of( ...items)
	  of: function of(/* ...args */) {
	    var index = 0;
	    var aLen = arguments.length;
	    var result = new (typeof this == 'function' ? this : Array)(aLen);
	    while (aLen > index) createProperty(result, index, arguments[index++]);
	    result.length = aLen;
	    return result;
	  }
	});


/***/ }),
/* 1385 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3);
	var $reduce = __webpack_require__(1090);
	
	$export($export.P + $export.F * !__webpack_require__(47)([].reduceRight, true), 'Array', {
	  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
	  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
	    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
	  }
	});


/***/ }),
/* 1386 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3);
	var $reduce = __webpack_require__(1090);
	
	$export($export.P + $export.F * !__webpack_require__(47)([].reduce, true), 'Array', {
	  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
	  reduce: function reduce(callbackfn /* , initialValue */) {
	    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
	  }
	});


/***/ }),
/* 1387 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3);
	var html = __webpack_require__(710);
	var cof = __webpack_require__(44);
	var toAbsoluteIndex = __webpack_require__(142);
	var toLength = __webpack_require__(11);
	var arraySlice = [].slice;
	
	// fallback for not array-like ES3 strings and DOM objects
	$export($export.P + $export.F * __webpack_require__(6)(function () {
	  if (html) arraySlice.call(html);
	}), 'Array', {
	  slice: function slice(begin, end) {
	    var len = toLength(this.length);
	    var klass = cof(this);
	    end = end === undefined ? len : end;
	    if (klass == 'Array') return arraySlice.call(this, begin, end);
	    var start = toAbsoluteIndex(begin, len);
	    var upTo = toAbsoluteIndex(end, len);
	    var size = toLength(upTo - start);
	    var cloned = new Array(size);
	    var i = 0;
	    for (; i < size; i++) cloned[i] = klass == 'String'
	      ? this.charAt(start + i)
	      : this[start + i];
	    return cloned;
	  }
	});


/***/ }),
/* 1388 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3);
	var $some = __webpack_require__(66)(3);
	
	$export($export.P + $export.F * !__webpack_require__(47)([].some, true), 'Array', {
	  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
	  some: function some(callbackfn /* , thisArg */) {
	    return $some(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 1389 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3);
	var aFunction = __webpack_require__(23);
	var toObject = __webpack_require__(17);
	var fails = __webpack_require__(6);
	var $sort = [].sort;
	var test = [1, 2, 3];
	
	$export($export.P + $export.F * (fails(function () {
	  // IE8-
	  test.sort(undefined);
	}) || !fails(function () {
	  // V8 bug
	  test.sort(null);
	  // Old WebKit
	}) || !__webpack_require__(47)($sort)), 'Array', {
	  // 22.1.3.25 Array.prototype.sort(comparefn)
	  sort: function sort(comparefn) {
	    return comparefn === undefined
	      ? $sort.call(toObject(this))
	      : $sort.call(toObject(this), aFunction(comparefn));
	  }
	});


/***/ }),
/* 1390 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(141)('Array');


/***/ }),
/* 1391 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.3.3.1 / 15.9.4.4 Date.now()
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Date', { now: function () { return new Date().getTime(); } });


/***/ }),
/* 1392 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
	var $export = __webpack_require__(3);
	var toISOString = __webpack_require__(1365);
	
	// PhantomJS / old WebKit has a broken implementations
	$export($export.P + $export.F * (Date.prototype.toISOString !== toISOString), 'Date', {
	  toISOString: toISOString
	});


/***/ }),
/* 1393 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3);
	var toObject = __webpack_require__(17);
	var toPrimitive = __webpack_require__(69);
	
	$export($export.P + $export.F * __webpack_require__(6)(function () {
	  return new Date(NaN).toJSON() !== null
	    || Date.prototype.toJSON.call({ toISOString: function () { return 1; } }) !== 1;
	}), 'Date', {
	  // eslint-disable-next-line no-unused-vars
	  toJSON: function toJSON(key) {
	    var O = toObject(this);
	    var pv = toPrimitive(O);
	    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
	  }
	});


/***/ }),
/* 1394 */
/***/ (function(module, exports, __webpack_require__) {

	var TO_PRIMITIVE = __webpack_require__(10)('toPrimitive');
	var proto = Date.prototype;
	
	if (!(TO_PRIMITIVE in proto)) __webpack_require__(25)(proto, TO_PRIMITIVE, __webpack_require__(1366));


/***/ }),
/* 1395 */
/***/ (function(module, exports, __webpack_require__) {

	var DateProto = Date.prototype;
	var INVALID_DATE = 'Invalid Date';
	var TO_STRING = 'toString';
	var $toString = DateProto[TO_STRING];
	var getTime = DateProto.getTime;
	if (new Date(NaN) + '' != INVALID_DATE) {
	  __webpack_require__(26)(DateProto, TO_STRING, function toString() {
	    var value = getTime.call(this);
	    // eslint-disable-next-line no-self-compare
	    return value === value ? $toString.call(this) : INVALID_DATE;
	  });
	}


/***/ }),
/* 1396 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
	var $export = __webpack_require__(3);
	
	$export($export.P, 'Function', { bind: __webpack_require__(1091) });


/***/ }),
/* 1397 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var isObject = __webpack_require__(7);
	var getPrototypeOf = __webpack_require__(38);
	var HAS_INSTANCE = __webpack_require__(10)('hasInstance');
	var FunctionProto = Function.prototype;
	// 19.2.3.6 Function.prototype[@@hasInstance](V)
	if (!(HAS_INSTANCE in FunctionProto)) __webpack_require__(16).f(FunctionProto, HAS_INSTANCE, { value: function (O) {
	  if (typeof this != 'function' || !isObject(O)) return false;
	  if (!isObject(this.prototype)) return O instanceof this;
	  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
	  while (O = getPrototypeOf(O)) if (this.prototype === O) return true;
	  return false;
	} });


/***/ }),
/* 1398 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(16).f;
	var FProto = Function.prototype;
	var nameRE = /^\s*function ([^ (]*)/;
	var NAME = 'name';
	
	// 19.2.4.2 name
	NAME in FProto || __webpack_require__(14) && dP(FProto, NAME, {
	  configurable: true,
	  get: function () {
	    try {
	      return ('' + this).match(nameRE)[1];
	    } catch (e) {
	      return '';
	    }
	  }
	});


/***/ }),
/* 1399 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.3 Math.acosh(x)
	var $export = __webpack_require__(3);
	var log1p = __webpack_require__(1102);
	var sqrt = Math.sqrt;
	var $acosh = Math.acosh;
	
	$export($export.S + $export.F * !($acosh
	  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
	  && Math.floor($acosh(Number.MAX_VALUE)) == 710
	  // Tor Browser bug: Math.acosh(Infinity) -> NaN
	  && $acosh(Infinity) == Infinity
	), 'Math', {
	  acosh: function acosh(x) {
	    return (x = +x) < 1 ? NaN : x > 94906265.62425156
	      ? Math.log(x) + Math.LN2
	      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
	  }
	});


/***/ }),
/* 1400 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.5 Math.asinh(x)
	var $export = __webpack_require__(3);
	var $asinh = Math.asinh;
	
	function asinh(x) {
	  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
	}
	
	// Tor Browser bug: Math.asinh(0) -> -0
	$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });


/***/ }),
/* 1401 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.7 Math.atanh(x)
	var $export = __webpack_require__(3);
	var $atanh = Math.atanh;
	
	// Tor Browser bug: Math.atanh(-0) -> 0
	$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
	  atanh: function atanh(x) {
	    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
	  }
	});


/***/ }),
/* 1402 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.9 Math.cbrt(x)
	var $export = __webpack_require__(3);
	var sign = __webpack_require__(716);
	
	$export($export.S, 'Math', {
	  cbrt: function cbrt(x) {
	    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
	  }
	});


/***/ }),
/* 1403 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.11 Math.clz32(x)
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Math', {
	  clz32: function clz32(x) {
	    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
	  }
	});


/***/ }),
/* 1404 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.12 Math.cosh(x)
	var $export = __webpack_require__(3);
	var exp = Math.exp;
	
	$export($export.S, 'Math', {
	  cosh: function cosh(x) {
	    return (exp(x = +x) + exp(-x)) / 2;
	  }
	});


/***/ }),
/* 1405 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.14 Math.expm1(x)
	var $export = __webpack_require__(3);
	var $expm1 = __webpack_require__(715);
	
	$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });


/***/ }),
/* 1406 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.16 Math.fround(x)
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Math', { fround: __webpack_require__(1101) });


/***/ }),
/* 1407 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
	var $export = __webpack_require__(3);
	var abs = Math.abs;
	
	$export($export.S, 'Math', {
	  hypot: function hypot(value1, value2) { // eslint-disable-line no-unused-vars
	    var sum = 0;
	    var i = 0;
	    var aLen = arguments.length;
	    var larg = 0;
	    var arg, div;
	    while (i < aLen) {
	      arg = abs(arguments[i++]);
	      if (larg < arg) {
	        div = larg / arg;
	        sum = sum * div * div + 1;
	        larg = arg;
	      } else if (arg > 0) {
	        div = arg / larg;
	        sum += div * div;
	      } else sum += arg;
	    }
	    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
	  }
	});


/***/ }),
/* 1408 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.18 Math.imul(x, y)
	var $export = __webpack_require__(3);
	var $imul = Math.imul;
	
	// some WebKit versions fails with big numbers, some has wrong arity
	$export($export.S + $export.F * __webpack_require__(6)(function () {
	  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
	}), 'Math', {
	  imul: function imul(x, y) {
	    var UINT16 = 0xffff;
	    var xn = +x;
	    var yn = +y;
	    var xl = UINT16 & xn;
	    var yl = UINT16 & yn;
	    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
	  }
	});


/***/ }),
/* 1409 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.21 Math.log10(x)
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Math', {
	  log10: function log10(x) {
	    return Math.log(x) * Math.LOG10E;
	  }
	});


/***/ }),
/* 1410 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.20 Math.log1p(x)
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Math', { log1p: __webpack_require__(1102) });


/***/ }),
/* 1411 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.22 Math.log2(x)
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Math', {
	  log2: function log2(x) {
	    return Math.log(x) / Math.LN2;
	  }
	});


/***/ }),
/* 1412 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.28 Math.sign(x)
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Math', { sign: __webpack_require__(716) });


/***/ }),
/* 1413 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.30 Math.sinh(x)
	var $export = __webpack_require__(3);
	var expm1 = __webpack_require__(715);
	var exp = Math.exp;
	
	// V8 near Chromium 38 has a problem with very small numbers
	$export($export.S + $export.F * __webpack_require__(6)(function () {
	  return !Math.sinh(-2e-17) != -2e-17;
	}), 'Math', {
	  sinh: function sinh(x) {
	    return Math.abs(x = +x) < 1
	      ? (expm1(x) - expm1(-x)) / 2
	      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
	  }
	});


/***/ }),
/* 1414 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.33 Math.tanh(x)
	var $export = __webpack_require__(3);
	var expm1 = __webpack_require__(715);
	var exp = Math.exp;
	
	$export($export.S, 'Math', {
	  tanh: function tanh(x) {
	    var a = expm1(x = +x);
	    var b = expm1(-x);
	    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
	  }
	});


/***/ }),
/* 1415 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.34 Math.trunc(x)
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Math', {
	  trunc: function trunc(it) {
	    return (it > 0 ? Math.floor : Math.ceil)(it);
	  }
	});


/***/ }),
/* 1416 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(5);
	var has = __webpack_require__(36);
	var cof = __webpack_require__(44);
	var inheritIfRequired = __webpack_require__(711);
	var toPrimitive = __webpack_require__(69);
	var fails = __webpack_require__(6);
	var gOPN = __webpack_require__(137).f;
	var gOPD = __webpack_require__(37).f;
	var dP = __webpack_require__(16).f;
	var $trim = __webpack_require__(204).trim;
	var NUMBER = 'Number';
	var $Number = global[NUMBER];
	var Base = $Number;
	var proto = $Number.prototype;
	// Opera ~12 has broken Object#toString
	var BROKEN_COF = cof(__webpack_require__(136)(proto)) == NUMBER;
	var TRIM = 'trim' in String.prototype;
	
	// 7.1.3 ToNumber(argument)
	var toNumber = function (argument) {
	  var it = toPrimitive(argument, false);
	  if (typeof it == 'string' && it.length > 2) {
	    it = TRIM ? it.trim() : $trim(it, 3);
	    var first = it.charCodeAt(0);
	    var third, radix, maxCode;
	    if (first === 43 || first === 45) {
	      third = it.charCodeAt(2);
	      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
	    } else if (first === 48) {
	      switch (it.charCodeAt(1)) {
	        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
	        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
	        default: return +it;
	      }
	      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
	        code = digits.charCodeAt(i);
	        // parseInt parses a string to a first unavailable symbol
	        // but ToNumber should return NaN if a string contains unavailable symbols
	        if (code < 48 || code > maxCode) return NaN;
	      } return parseInt(digits, radix);
	    }
	  } return +it;
	};
	
	if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
	  $Number = function Number(value) {
	    var it = arguments.length < 1 ? 0 : value;
	    var that = this;
	    return that instanceof $Number
	      // check on 1..constructor(foo) case
	      && (BROKEN_COF ? fails(function () { proto.valueOf.call(that); }) : cof(that) != NUMBER)
	        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
	  };
	  for (var keys = __webpack_require__(14) ? gOPN(Base) : (
	    // ES3:
	    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
	    // ES6 (in case, if modules with ES6 Number statics required before):
	    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
	    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
	  ).split(','), j = 0, key; keys.length > j; j++) {
	    if (has(Base, key = keys[j]) && !has($Number, key)) {
	      dP($Number, key, gOPD(Base, key));
	    }
	  }
	  $Number.prototype = proto;
	  proto.constructor = $Number;
	  __webpack_require__(26)(global, NUMBER, $Number);
	}


/***/ }),
/* 1417 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.1 Number.EPSILON
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });


/***/ }),
/* 1418 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.2 Number.isFinite(number)
	var $export = __webpack_require__(3);
	var _isFinite = __webpack_require__(5).isFinite;
	
	$export($export.S, 'Number', {
	  isFinite: function isFinite(it) {
	    return typeof it == 'number' && _isFinite(it);
	  }
	});


/***/ }),
/* 1419 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Number', { isInteger: __webpack_require__(1098) });


/***/ }),
/* 1420 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.4 Number.isNaN(number)
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Number', {
	  isNaN: function isNaN(number) {
	    // eslint-disable-next-line no-self-compare
	    return number != number;
	  }
	});


/***/ }),
/* 1421 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.5 Number.isSafeInteger(number)
	var $export = __webpack_require__(3);
	var isInteger = __webpack_require__(1098);
	var abs = Math.abs;
	
	$export($export.S, 'Number', {
	  isSafeInteger: function isSafeInteger(number) {
	    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
	  }
	});


/***/ }),
/* 1422 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.6 Number.MAX_SAFE_INTEGER
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });


/***/ }),
/* 1423 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.10 Number.MIN_SAFE_INTEGER
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });


/***/ }),
/* 1424 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(3);
	var $parseFloat = __webpack_require__(1110);
	// 20.1.2.12 Number.parseFloat(string)
	$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });


/***/ }),
/* 1425 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(3);
	var $parseInt = __webpack_require__(1111);
	// 20.1.2.13 Number.parseInt(string, radix)
	$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', { parseInt: $parseInt });


/***/ }),
/* 1426 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3);
	var toInteger = __webpack_require__(48);
	var aNumberValue = __webpack_require__(1087);
	var repeat = __webpack_require__(723);
	var $toFixed = 1.0.toFixed;
	var floor = Math.floor;
	var data = [0, 0, 0, 0, 0, 0];
	var ERROR = 'Number.toFixed: incorrect invocation!';
	var ZERO = '0';
	
	var multiply = function (n, c) {
	  var i = -1;
	  var c2 = c;
	  while (++i < 6) {
	    c2 += n * data[i];
	    data[i] = c2 % 1e7;
	    c2 = floor(c2 / 1e7);
	  }
	};
	var divide = function (n) {
	  var i = 6;
	  var c = 0;
	  while (--i >= 0) {
	    c += data[i];
	    data[i] = floor(c / n);
	    c = (c % n) * 1e7;
	  }
	};
	var numToString = function () {
	  var i = 6;
	  var s = '';
	  while (--i >= 0) {
	    if (s !== '' || i === 0 || data[i] !== 0) {
	      var t = String(data[i]);
	      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
	    }
	  } return s;
	};
	var pow = function (x, n, acc) {
	  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
	};
	var log = function (x) {
	  var n = 0;
	  var x2 = x;
	  while (x2 >= 4096) {
	    n += 12;
	    x2 /= 4096;
	  }
	  while (x2 >= 2) {
	    n += 1;
	    x2 /= 2;
	  } return n;
	};
	
	$export($export.P + $export.F * (!!$toFixed && (
	  0.00008.toFixed(3) !== '0.000' ||
	  0.9.toFixed(0) !== '1' ||
	  1.255.toFixed(2) !== '1.25' ||
	  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
	) || !__webpack_require__(6)(function () {
	  // V8 ~ Android 4.3-
	  $toFixed.call({});
	})), 'Number', {
	  toFixed: function toFixed(fractionDigits) {
	    var x = aNumberValue(this, ERROR);
	    var f = toInteger(fractionDigits);
	    var s = '';
	    var m = ZERO;
	    var e, z, j, k;
	    if (f < 0 || f > 20) throw RangeError(ERROR);
	    // eslint-disable-next-line no-self-compare
	    if (x != x) return 'NaN';
	    if (x <= -1e21 || x >= 1e21) return String(x);
	    if (x < 0) {
	      s = '-';
	      x = -x;
	    }
	    if (x > 1e-21) {
	      e = log(x * pow(2, 69, 1)) - 69;
	      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
	      z *= 0x10000000000000;
	      e = 52 - e;
	      if (e > 0) {
	        multiply(0, z);
	        j = f;
	        while (j >= 7) {
	          multiply(1e7, 0);
	          j -= 7;
	        }
	        multiply(pow(10, j, 1), 0);
	        j = e - 1;
	        while (j >= 23) {
	          divide(1 << 23);
	          j -= 23;
	        }
	        divide(1 << j);
	        multiply(1, 1);
	        divide(2);
	        m = numToString();
	      } else {
	        multiply(0, z);
	        multiply(1 << -e, 0);
	        m = numToString() + repeat.call(ZERO, f);
	      }
	    }
	    if (f > 0) {
	      k = m.length;
	      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
	    } else {
	      m = s + m;
	    } return m;
	  }
	});


/***/ }),
/* 1427 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3);
	var $fails = __webpack_require__(6);
	var aNumberValue = __webpack_require__(1087);
	var $toPrecision = 1.0.toPrecision;
	
	$export($export.P + $export.F * ($fails(function () {
	  // IE7-
	  return $toPrecision.call(1, undefined) !== '1';
	}) || !$fails(function () {
	  // V8 ~ Android 4.3-
	  $toPrecision.call({});
	})), 'Number', {
	  toPrecision: function toPrecision(precision) {
	    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
	    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
	  }
	});


/***/ }),
/* 1428 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(3);
	
	$export($export.S + $export.F, 'Object', { assign: __webpack_require__(1104) });


/***/ }),
/* 1429 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(3);
	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	$export($export.S, 'Object', { create: __webpack_require__(136) });


/***/ }),
/* 1430 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(3);
	// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
	$export($export.S + $export.F * !__webpack_require__(14), 'Object', { defineProperties: __webpack_require__(1105) });


/***/ }),
/* 1431 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(3);
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(14), 'Object', { defineProperty: __webpack_require__(16).f });


/***/ }),
/* 1432 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.5 Object.freeze(O)
	var isObject = __webpack_require__(7);
	var meta = __webpack_require__(94).onFreeze;
	
	__webpack_require__(68)('freeze', function ($freeze) {
	  return function freeze(it) {
	    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
	  };
	});


/***/ }),
/* 1433 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	var toIObject = __webpack_require__(39);
	var $getOwnPropertyDescriptor = __webpack_require__(37).f;
	
	__webpack_require__(68)('getOwnPropertyDescriptor', function () {
	  return function getOwnPropertyDescriptor(it, key) {
	    return $getOwnPropertyDescriptor(toIObject(it), key);
	  };
	});


/***/ }),
/* 1434 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.7 Object.getOwnPropertyNames(O)
	__webpack_require__(68)('getOwnPropertyNames', function () {
	  return __webpack_require__(1106).f;
	});


/***/ }),
/* 1435 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.9 Object.getPrototypeOf(O)
	var toObject = __webpack_require__(17);
	var $getPrototypeOf = __webpack_require__(38);
	
	__webpack_require__(68)('getPrototypeOf', function () {
	  return function getPrototypeOf(it) {
	    return $getPrototypeOf(toObject(it));
	  };
	});


/***/ }),
/* 1436 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.11 Object.isExtensible(O)
	var isObject = __webpack_require__(7);
	
	__webpack_require__(68)('isExtensible', function ($isExtensible) {
	  return function isExtensible(it) {
	    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
	  };
	});


/***/ }),
/* 1437 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.12 Object.isFrozen(O)
	var isObject = __webpack_require__(7);
	
	__webpack_require__(68)('isFrozen', function ($isFrozen) {
	  return function isFrozen(it) {
	    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
	  };
	});


/***/ }),
/* 1438 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.13 Object.isSealed(O)
	var isObject = __webpack_require__(7);
	
	__webpack_require__(68)('isSealed', function ($isSealed) {
	  return function isSealed(it) {
	    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
	  };
	});


/***/ }),
/* 1439 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.10 Object.is(value1, value2)
	var $export = __webpack_require__(3);
	$export($export.S, 'Object', { is: __webpack_require__(1114) });


/***/ }),
/* 1440 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__(17);
	var $keys = __webpack_require__(138);
	
	__webpack_require__(68)('keys', function () {
	  return function keys(it) {
	    return $keys(toObject(it));
	  };
	});


/***/ }),
/* 1441 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.15 Object.preventExtensions(O)
	var isObject = __webpack_require__(7);
	var meta = __webpack_require__(94).onFreeze;
	
	__webpack_require__(68)('preventExtensions', function ($preventExtensions) {
	  return function preventExtensions(it) {
	    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
	  };
	});


/***/ }),
/* 1442 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.17 Object.seal(O)
	var isObject = __webpack_require__(7);
	var meta = __webpack_require__(94).onFreeze;
	
	__webpack_require__(68)('seal', function ($seal) {
	  return function seal(it) {
	    return $seal && isObject(it) ? $seal(meta(it)) : it;
	  };
	});


/***/ }),
/* 1443 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.19 Object.setPrototypeOf(O, proto)
	var $export = __webpack_require__(3);
	$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(720).set });


/***/ }),
/* 1444 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.3.6 Object.prototype.toString()
	var classof = __webpack_require__(201);
	var test = {};
	test[__webpack_require__(10)('toStringTag')] = 'z';
	if (test + '' != '[object z]') {
	  __webpack_require__(26)(Object.prototype, 'toString', function toString() {
	    return '[object ' + classof(this) + ']';
	  }, true);
	}


/***/ }),
/* 1445 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(3);
	var $parseFloat = __webpack_require__(1110);
	// 18.2.4 parseFloat(string)
	$export($export.G + $export.F * (parseFloat != $parseFloat), { parseFloat: $parseFloat });


/***/ }),
/* 1446 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(3);
	var $parseInt = __webpack_require__(1111);
	// 18.2.5 parseInt(string, radix)
	$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });


/***/ }),
/* 1447 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(93);
	var global = __webpack_require__(5);
	var ctx = __webpack_require__(46);
	var classof = __webpack_require__(201);
	var $export = __webpack_require__(3);
	var isObject = __webpack_require__(7);
	var aFunction = __webpack_require__(23);
	var anInstance = __webpack_require__(134);
	var forOf = __webpack_require__(135);
	var speciesConstructor = __webpack_require__(317);
	var task = __webpack_require__(725).set;
	var microtask = __webpack_require__(717)();
	var newPromiseCapabilityModule = __webpack_require__(718);
	var perform = __webpack_require__(1112);
	var userAgent = __webpack_require__(468);
	var promiseResolve = __webpack_require__(1113);
	var PROMISE = 'Promise';
	var TypeError = global.TypeError;
	var process = global.process;
	var versions = process && process.versions;
	var v8 = versions && versions.v8 || '';
	var $Promise = global[PROMISE];
	var isNode = classof(process) == 'process';
	var empty = function () { /* empty */ };
	var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
	var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;
	
	var USE_NATIVE = !!function () {
	  try {
	    // correct subclassing with @@species support
	    var promise = $Promise.resolve(1);
	    var FakePromise = (promise.constructor = {})[__webpack_require__(10)('species')] = function (exec) {
	      exec(empty, empty);
	    };
	    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
	    return (isNode || typeof PromiseRejectionEvent == 'function')
	      && promise.then(empty) instanceof FakePromise
	      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
	      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
	      // we can't detect it synchronously, so just check versions
	      && v8.indexOf('6.6') !== 0
	      && userAgent.indexOf('Chrome/66') === -1;
	  } catch (e) { /* empty */ }
	}();
	
	// helpers
	var isThenable = function (it) {
	  var then;
	  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
	};
	var notify = function (promise, isReject) {
	  if (promise._n) return;
	  promise._n = true;
	  var chain = promise._c;
	  microtask(function () {
	    var value = promise._v;
	    var ok = promise._s == 1;
	    var i = 0;
	    var run = function (reaction) {
	      var handler = ok ? reaction.ok : reaction.fail;
	      var resolve = reaction.resolve;
	      var reject = reaction.reject;
	      var domain = reaction.domain;
	      var result, then, exited;
	      try {
	        if (handler) {
	          if (!ok) {
	            if (promise._h == 2) onHandleUnhandled(promise);
	            promise._h = 1;
	          }
	          if (handler === true) result = value;
	          else {
	            if (domain) domain.enter();
	            result = handler(value); // may throw
	            if (domain) {
	              domain.exit();
	              exited = true;
	            }
	          }
	          if (result === reaction.promise) {
	            reject(TypeError('Promise-chain cycle'));
	          } else if (then = isThenable(result)) {
	            then.call(result, resolve, reject);
	          } else resolve(result);
	        } else reject(value);
	      } catch (e) {
	        if (domain && !exited) domain.exit();
	        reject(e);
	      }
	    };
	    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
	    promise._c = [];
	    promise._n = false;
	    if (isReject && !promise._h) onUnhandled(promise);
	  });
	};
	var onUnhandled = function (promise) {
	  task.call(global, function () {
	    var value = promise._v;
	    var unhandled = isUnhandled(promise);
	    var result, handler, console;
	    if (unhandled) {
	      result = perform(function () {
	        if (isNode) {
	          process.emit('unhandledRejection', value, promise);
	        } else if (handler = global.onunhandledrejection) {
	          handler({ promise: promise, reason: value });
	        } else if ((console = global.console) && console.error) {
	          console.error('Unhandled promise rejection', value);
	        }
	      });
	      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
	      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
	    } promise._a = undefined;
	    if (unhandled && result.e) throw result.v;
	  });
	};
	var isUnhandled = function (promise) {
	  return promise._h !== 1 && (promise._a || promise._c).length === 0;
	};
	var onHandleUnhandled = function (promise) {
	  task.call(global, function () {
	    var handler;
	    if (isNode) {
	      process.emit('rejectionHandled', promise);
	    } else if (handler = global.onrejectionhandled) {
	      handler({ promise: promise, reason: promise._v });
	    }
	  });
	};
	var $reject = function (value) {
	  var promise = this;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  promise._v = value;
	  promise._s = 2;
	  if (!promise._a) promise._a = promise._c.slice();
	  notify(promise, true);
	};
	var $resolve = function (value) {
	  var promise = this;
	  var then;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  try {
	    if (promise === value) throw TypeError("Promise can't be resolved itself");
	    if (then = isThenable(value)) {
	      microtask(function () {
	        var wrapper = { _w: promise, _d: false }; // wrap
	        try {
	          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
	        } catch (e) {
	          $reject.call(wrapper, e);
	        }
	      });
	    } else {
	      promise._v = value;
	      promise._s = 1;
	      notify(promise, false);
	    }
	  } catch (e) {
	    $reject.call({ _w: promise, _d: false }, e); // wrap
	  }
	};
	
	// constructor polyfill
	if (!USE_NATIVE) {
	  // 25.4.3.1 Promise(executor)
	  $Promise = function Promise(executor) {
	    anInstance(this, $Promise, PROMISE, '_h');
	    aFunction(executor);
	    Internal.call(this);
	    try {
	      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
	    } catch (err) {
	      $reject.call(this, err);
	    }
	  };
	  // eslint-disable-next-line no-unused-vars
	  Internal = function Promise(executor) {
	    this._c = [];             // <- awaiting reactions
	    this._a = undefined;      // <- checked in isUnhandled reactions
	    this._s = 0;              // <- state
	    this._d = false;          // <- done
	    this._v = undefined;      // <- value
	    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
	    this._n = false;          // <- notify
	  };
	  Internal.prototype = __webpack_require__(140)($Promise.prototype, {
	    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
	    then: function then(onFulfilled, onRejected) {
	      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
	      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
	      reaction.fail = typeof onRejected == 'function' && onRejected;
	      reaction.domain = isNode ? process.domain : undefined;
	      this._c.push(reaction);
	      if (this._a) this._a.push(reaction);
	      if (this._s) notify(this, false);
	      return reaction.promise;
	    },
	    // 25.4.5.1 Promise.prototype.catch(onRejected)
	    'catch': function (onRejected) {
	      return this.then(undefined, onRejected);
	    }
	  });
	  OwnPromiseCapability = function () {
	    var promise = new Internal();
	    this.promise = promise;
	    this.resolve = ctx($resolve, promise, 1);
	    this.reject = ctx($reject, promise, 1);
	  };
	  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
	    return C === $Promise || C === Wrapper
	      ? new OwnPromiseCapability(C)
	      : newGenericPromiseCapability(C);
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
	__webpack_require__(203)($Promise, PROMISE);
	__webpack_require__(141)(PROMISE);
	Wrapper = __webpack_require__(45)[PROMISE];
	
	// statics
	$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
	  // 25.4.4.5 Promise.reject(r)
	  reject: function reject(r) {
	    var capability = newPromiseCapability(this);
	    var $$reject = capability.reject;
	    $$reject(r);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
	  // 25.4.4.6 Promise.resolve(x)
	  resolve: function resolve(x) {
	    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
	  }
	});
	$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(460)(function (iter) {
	  $Promise.all(iter)['catch'](empty);
	})), PROMISE, {
	  // 25.4.4.1 Promise.all(iterable)
	  all: function all(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var resolve = capability.resolve;
	    var reject = capability.reject;
	    var result = perform(function () {
	      var values = [];
	      var index = 0;
	      var remaining = 1;
	      forOf(iterable, false, function (promise) {
	        var $index = index++;
	        var alreadyCalled = false;
	        values.push(undefined);
	        remaining++;
	        C.resolve(promise).then(function (value) {
	          if (alreadyCalled) return;
	          alreadyCalled = true;
	          values[$index] = value;
	          --remaining || resolve(values);
	        }, reject);
	      });
	      --remaining || resolve(values);
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  },
	  // 25.4.4.4 Promise.race(iterable)
	  race: function race(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var reject = capability.reject;
	    var result = perform(function () {
	      forOf(iterable, false, function (promise) {
	        C.resolve(promise).then(capability.resolve, reject);
	      });
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  }
	});


/***/ }),
/* 1448 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
	var $export = __webpack_require__(3);
	var aFunction = __webpack_require__(23);
	var anObject = __webpack_require__(4);
	var rApply = (__webpack_require__(5).Reflect || {}).apply;
	var fApply = Function.apply;
	// MS Edge argumentsList argument is optional
	$export($export.S + $export.F * !__webpack_require__(6)(function () {
	  rApply(function () { /* empty */ });
	}), 'Reflect', {
	  apply: function apply(target, thisArgument, argumentsList) {
	    var T = aFunction(target);
	    var L = anObject(argumentsList);
	    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
	  }
	});


/***/ }),
/* 1449 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
	var $export = __webpack_require__(3);
	var create = __webpack_require__(136);
	var aFunction = __webpack_require__(23);
	var anObject = __webpack_require__(4);
	var isObject = __webpack_require__(7);
	var fails = __webpack_require__(6);
	var bind = __webpack_require__(1091);
	var rConstruct = (__webpack_require__(5).Reflect || {}).construct;
	
	// MS Edge supports only 2 arguments and argumentsList argument is optional
	// FF Nightly sets third argument as `new.target`, but does not create `this` from it
	var NEW_TARGET_BUG = fails(function () {
	  function F() { /* empty */ }
	  return !(rConstruct(function () { /* empty */ }, [], F) instanceof F);
	});
	var ARGS_BUG = !fails(function () {
	  rConstruct(function () { /* empty */ });
	});
	
	$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
	  construct: function construct(Target, args /* , newTarget */) {
	    aFunction(Target);
	    anObject(args);
	    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
	    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
	    if (Target == newTarget) {
	      // w/o altered newTarget, optimization for 0-4 arguments
	      switch (args.length) {
	        case 0: return new Target();
	        case 1: return new Target(args[0]);
	        case 2: return new Target(args[0], args[1]);
	        case 3: return new Target(args[0], args[1], args[2]);
	        case 4: return new Target(args[0], args[1], args[2], args[3]);
	      }
	      // w/o altered newTarget, lot of arguments case
	      var $args = [null];
	      $args.push.apply($args, args);
	      return new (bind.apply(Target, $args))();
	    }
	    // with altered newTarget, not support built-in constructors
	    var proto = newTarget.prototype;
	    var instance = create(isObject(proto) ? proto : Object.prototype);
	    var result = Function.apply.call(Target, instance, args);
	    return isObject(result) ? result : instance;
	  }
	});


/***/ }),
/* 1450 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
	var dP = __webpack_require__(16);
	var $export = __webpack_require__(3);
	var anObject = __webpack_require__(4);
	var toPrimitive = __webpack_require__(69);
	
	// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
	$export($export.S + $export.F * __webpack_require__(6)(function () {
	  // eslint-disable-next-line no-undef
	  Reflect.defineProperty(dP.f({}, 1, { value: 1 }), 1, { value: 2 });
	}), 'Reflect', {
	  defineProperty: function defineProperty(target, propertyKey, attributes) {
	    anObject(target);
	    propertyKey = toPrimitive(propertyKey, true);
	    anObject(attributes);
	    try {
	      dP.f(target, propertyKey, attributes);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});


/***/ }),
/* 1451 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.4 Reflect.deleteProperty(target, propertyKey)
	var $export = __webpack_require__(3);
	var gOPD = __webpack_require__(37).f;
	var anObject = __webpack_require__(4);
	
	$export($export.S, 'Reflect', {
	  deleteProperty: function deleteProperty(target, propertyKey) {
	    var desc = gOPD(anObject(target), propertyKey);
	    return desc && !desc.configurable ? false : delete target[propertyKey];
	  }
	});


/***/ }),
/* 1452 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 26.1.5 Reflect.enumerate(target)
	var $export = __webpack_require__(3);
	var anObject = __webpack_require__(4);
	var Enumerate = function (iterated) {
	  this._t = anObject(iterated); // target
	  this._i = 0;                  // next index
	  var keys = this._k = [];      // keys
	  var key;
	  for (key in iterated) keys.push(key);
	};
	__webpack_require__(713)(Enumerate, 'Object', function () {
	  var that = this;
	  var keys = that._k;
	  var key;
	  do {
	    if (that._i >= keys.length) return { value: undefined, done: true };
	  } while (!((key = keys[that._i++]) in that._t));
	  return { value: key, done: false };
	});
	
	$export($export.S, 'Reflect', {
	  enumerate: function enumerate(target) {
	    return new Enumerate(target);
	  }
	});


/***/ }),
/* 1453 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
	var gOPD = __webpack_require__(37);
	var $export = __webpack_require__(3);
	var anObject = __webpack_require__(4);
	
	$export($export.S, 'Reflect', {
	  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
	    return gOPD.f(anObject(target), propertyKey);
	  }
	});


/***/ }),
/* 1454 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.8 Reflect.getPrototypeOf(target)
	var $export = __webpack_require__(3);
	var getProto = __webpack_require__(38);
	var anObject = __webpack_require__(4);
	
	$export($export.S, 'Reflect', {
	  getPrototypeOf: function getPrototypeOf(target) {
	    return getProto(anObject(target));
	  }
	});


/***/ }),
/* 1455 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.6 Reflect.get(target, propertyKey [, receiver])
	var gOPD = __webpack_require__(37);
	var getPrototypeOf = __webpack_require__(38);
	var has = __webpack_require__(36);
	var $export = __webpack_require__(3);
	var isObject = __webpack_require__(7);
	var anObject = __webpack_require__(4);
	
	function get(target, propertyKey /* , receiver */) {
	  var receiver = arguments.length < 3 ? target : arguments[2];
	  var desc, proto;
	  if (anObject(target) === receiver) return target[propertyKey];
	  if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value')
	    ? desc.value
	    : desc.get !== undefined
	      ? desc.get.call(receiver)
	      : undefined;
	  if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
	}
	
	$export($export.S, 'Reflect', { get: get });


/***/ }),
/* 1456 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.9 Reflect.has(target, propertyKey)
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Reflect', {
	  has: function has(target, propertyKey) {
	    return propertyKey in target;
	  }
	});


/***/ }),
/* 1457 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.10 Reflect.isExtensible(target)
	var $export = __webpack_require__(3);
	var anObject = __webpack_require__(4);
	var $isExtensible = Object.isExtensible;
	
	$export($export.S, 'Reflect', {
	  isExtensible: function isExtensible(target) {
	    anObject(target);
	    return $isExtensible ? $isExtensible(target) : true;
	  }
	});


/***/ }),
/* 1458 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.11 Reflect.ownKeys(target)
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Reflect', { ownKeys: __webpack_require__(1109) });


/***/ }),
/* 1459 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.12 Reflect.preventExtensions(target)
	var $export = __webpack_require__(3);
	var anObject = __webpack_require__(4);
	var $preventExtensions = Object.preventExtensions;
	
	$export($export.S, 'Reflect', {
	  preventExtensions: function preventExtensions(target) {
	    anObject(target);
	    try {
	      if ($preventExtensions) $preventExtensions(target);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});


/***/ }),
/* 1460 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.14 Reflect.setPrototypeOf(target, proto)
	var $export = __webpack_require__(3);
	var setProto = __webpack_require__(720);
	
	if (setProto) $export($export.S, 'Reflect', {
	  setPrototypeOf: function setPrototypeOf(target, proto) {
	    setProto.check(target, proto);
	    try {
	      setProto.set(target, proto);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});


/***/ }),
/* 1461 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
	var dP = __webpack_require__(16);
	var gOPD = __webpack_require__(37);
	var getPrototypeOf = __webpack_require__(38);
	var has = __webpack_require__(36);
	var $export = __webpack_require__(3);
	var createDesc = __webpack_require__(139);
	var anObject = __webpack_require__(4);
	var isObject = __webpack_require__(7);
	
	function set(target, propertyKey, V /* , receiver */) {
	  var receiver = arguments.length < 4 ? target : arguments[3];
	  var ownDesc = gOPD.f(anObject(target), propertyKey);
	  var existingDescriptor, proto;
	  if (!ownDesc) {
	    if (isObject(proto = getPrototypeOf(target))) {
	      return set(proto, propertyKey, V, receiver);
	    }
	    ownDesc = createDesc(0);
	  }
	  if (has(ownDesc, 'value')) {
	    if (ownDesc.writable === false || !isObject(receiver)) return false;
	    if (existingDescriptor = gOPD.f(receiver, propertyKey)) {
	      if (existingDescriptor.get || existingDescriptor.set || existingDescriptor.writable === false) return false;
	      existingDescriptor.value = V;
	      dP.f(receiver, propertyKey, existingDescriptor);
	    } else dP.f(receiver, propertyKey, createDesc(0, V));
	    return true;
	  }
	  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
	}
	
	$export($export.S, 'Reflect', { set: set });


/***/ }),
/* 1462 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(5);
	var inheritIfRequired = __webpack_require__(711);
	var dP = __webpack_require__(16).f;
	var gOPN = __webpack_require__(137).f;
	var isRegExp = __webpack_require__(459);
	var $flags = __webpack_require__(313);
	var $RegExp = global.RegExp;
	var Base = $RegExp;
	var proto = $RegExp.prototype;
	var re1 = /a/g;
	var re2 = /a/g;
	// "new" creates a new object, old webkit buggy here
	var CORRECT_NEW = new $RegExp(re1) !== re1;
	
	if (__webpack_require__(14) && (!CORRECT_NEW || __webpack_require__(6)(function () {
	  re2[__webpack_require__(10)('match')] = false;
	  // RegExp constructor can alter flags and IsRegExp works correct with @@match
	  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
	}))) {
	  $RegExp = function RegExp(p, f) {
	    var tiRE = this instanceof $RegExp;
	    var piRE = isRegExp(p);
	    var fiU = f === undefined;
	    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
	      : inheritIfRequired(CORRECT_NEW
	        ? new Base(piRE && !fiU ? p.source : p, f)
	        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
	      , tiRE ? this : proto, $RegExp);
	  };
	  var proxy = function (key) {
	    key in $RegExp || dP($RegExp, key, {
	      configurable: true,
	      get: function () { return Base[key]; },
	      set: function (it) { Base[key] = it; }
	    });
	  };
	  for (var keys = gOPN(Base), i = 0; keys.length > i;) proxy(keys[i++]);
	  proto.constructor = $RegExp;
	  $RegExp.prototype = proto;
	  __webpack_require__(26)(global, 'RegExp', $RegExp);
	}
	
	__webpack_require__(141)('RegExp');


/***/ }),
/* 1463 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var anObject = __webpack_require__(4);
	var toLength = __webpack_require__(11);
	var advanceStringIndex = __webpack_require__(703);
	var regExpExec = __webpack_require__(463);
	
	// @@match logic
	__webpack_require__(457)('match', 1, function (defined, MATCH, $match, maybeCallNative) {
	  return [
	    // `String.prototype.match` method
	    // https://tc39.github.io/ecma262/#sec-string.prototype.match
	    function match(regexp) {
	      var O = defined(this);
	      var fn = regexp == undefined ? undefined : regexp[MATCH];
	      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
	    },
	    // `RegExp.prototype[@@match]` method
	    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@match
	    function (regexp) {
	      var res = maybeCallNative($match, regexp, this);
	      if (res.done) return res.value;
	      var rx = anObject(regexp);
	      var S = String(this);
	      if (!rx.global) return regExpExec(rx, S);
	      var fullUnicode = rx.unicode;
	      rx.lastIndex = 0;
	      var A = [];
	      var n = 0;
	      var result;
	      while ((result = regExpExec(rx, S)) !== null) {
	        var matchStr = String(result[0]);
	        A[n] = matchStr;
	        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
	        n++;
	      }
	      return n === 0 ? null : A;
	    }
	  ];
	});


/***/ }),
/* 1464 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var anObject = __webpack_require__(4);
	var toObject = __webpack_require__(17);
	var toLength = __webpack_require__(11);
	var toInteger = __webpack_require__(48);
	var advanceStringIndex = __webpack_require__(703);
	var regExpExec = __webpack_require__(463);
	var max = Math.max;
	var min = Math.min;
	var floor = Math.floor;
	var SUBSTITUTION_SYMBOLS = /\$([$&`']|\d\d?|<[^>]*>)/g;
	var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&`']|\d\d?)/g;
	
	var maybeToString = function (it) {
	  return it === undefined ? it : String(it);
	};
	
	// @@replace logic
	__webpack_require__(457)('replace', 2, function (defined, REPLACE, $replace, maybeCallNative) {
	  return [
	    // `String.prototype.replace` method
	    // https://tc39.github.io/ecma262/#sec-string.prototype.replace
	    function replace(searchValue, replaceValue) {
	      var O = defined(this);
	      var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
	      return fn !== undefined
	        ? fn.call(searchValue, O, replaceValue)
	        : $replace.call(String(O), searchValue, replaceValue);
	    },
	    // `RegExp.prototype[@@replace]` method
	    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
	    function (regexp, replaceValue) {
	      var res = maybeCallNative($replace, regexp, this, replaceValue);
	      if (res.done) return res.value;
	
	      var rx = anObject(regexp);
	      var S = String(this);
	      var functionalReplace = typeof replaceValue === 'function';
	      if (!functionalReplace) replaceValue = String(replaceValue);
	      var global = rx.global;
	      if (global) {
	        var fullUnicode = rx.unicode;
	        rx.lastIndex = 0;
	      }
	      var results = [];
	      while (true) {
	        var result = regExpExec(rx, S);
	        if (result === null) break;
	        results.push(result);
	        if (!global) break;
	        var matchStr = String(result[0]);
	        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
	      }
	      var accumulatedResult = '';
	      var nextSourcePosition = 0;
	      for (var i = 0; i < results.length; i++) {
	        result = results[i];
	        var matched = String(result[0]);
	        var position = max(min(toInteger(result.index), S.length), 0);
	        var captures = [];
	        // NOTE: This is equivalent to
	        //   captures = result.slice(1).map(maybeToString)
	        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
	        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
	        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
	        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
	        var namedCaptures = result.groups;
	        if (functionalReplace) {
	          var replacerArgs = [matched].concat(captures, position, S);
	          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
	          var replacement = String(replaceValue.apply(undefined, replacerArgs));
	        } else {
	          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
	        }
	        if (position >= nextSourcePosition) {
	          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
	          nextSourcePosition = position + matched.length;
	        }
	      }
	      return accumulatedResult + S.slice(nextSourcePosition);
	    }
	  ];
	
	    // https://tc39.github.io/ecma262/#sec-getsubstitution
	  function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
	    var tailPos = position + matched.length;
	    var m = captures.length;
	    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
	    if (namedCaptures !== undefined) {
	      namedCaptures = toObject(namedCaptures);
	      symbols = SUBSTITUTION_SYMBOLS;
	    }
	    return $replace.call(replacement, symbols, function (match, ch) {
	      var capture;
	      switch (ch.charAt(0)) {
	        case '$': return '$';
	        case '&': return matched;
	        case '`': return str.slice(0, position);
	        case "'": return str.slice(tailPos);
	        case '<':
	          capture = namedCaptures[ch.slice(1, -1)];
	          break;
	        default: // \d\d?
	          var n = +ch;
	          if (n === 0) return match;
	          if (n > m) {
	            var f = floor(n / 10);
	            if (f === 0) return match;
	            if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
	            return match;
	          }
	          capture = captures[n - 1];
	      }
	      return capture === undefined ? '' : capture;
	    });
	  }
	});


/***/ }),
/* 1465 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var anObject = __webpack_require__(4);
	var sameValue = __webpack_require__(1114);
	var regExpExec = __webpack_require__(463);
	
	// @@search logic
	__webpack_require__(457)('search', 1, function (defined, SEARCH, $search, maybeCallNative) {
	  return [
	    // `String.prototype.search` method
	    // https://tc39.github.io/ecma262/#sec-string.prototype.search
	    function search(regexp) {
	      var O = defined(this);
	      var fn = regexp == undefined ? undefined : regexp[SEARCH];
	      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
	    },
	    // `RegExp.prototype[@@search]` method
	    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@search
	    function (regexp) {
	      var res = maybeCallNative($search, regexp, this);
	      if (res.done) return res.value;
	      var rx = anObject(regexp);
	      var S = String(this);
	      var previousLastIndex = rx.lastIndex;
	      if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
	      var result = regExpExec(rx, S);
	      if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
	      return result === null ? -1 : result.index;
	    }
	  ];
	});


/***/ }),
/* 1466 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var isRegExp = __webpack_require__(459);
	var anObject = __webpack_require__(4);
	var speciesConstructor = __webpack_require__(317);
	var advanceStringIndex = __webpack_require__(703);
	var toLength = __webpack_require__(11);
	var callRegExpExec = __webpack_require__(463);
	var regexpExec = __webpack_require__(719);
	var fails = __webpack_require__(6);
	var $min = Math.min;
	var $push = [].push;
	var $SPLIT = 'split';
	var LENGTH = 'length';
	var LAST_INDEX = 'lastIndex';
	var MAX_UINT32 = 0xffffffff;
	
	// babel-minify transpiles RegExp('x', 'y') -> /x/y and it causes SyntaxError
	var SUPPORTS_Y = !fails(function () { RegExp(MAX_UINT32, 'y'); });
	
	// @@split logic
	__webpack_require__(457)('split', 2, function (defined, SPLIT, $split, maybeCallNative) {
	  var internalSplit;
	  if (
	    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
	    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
	    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
	    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
	    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
	    ''[$SPLIT](/.?/)[LENGTH]
	  ) {
	    // based on es5-shim implementation, need to rework it
	    internalSplit = function (separator, limit) {
	      var string = String(this);
	      if (separator === undefined && limit === 0) return [];
	      // If `separator` is not a regex, use native split
	      if (!isRegExp(separator)) return $split.call(string, separator, limit);
	      var output = [];
	      var flags = (separator.ignoreCase ? 'i' : '') +
	                  (separator.multiline ? 'm' : '') +
	                  (separator.unicode ? 'u' : '') +
	                  (separator.sticky ? 'y' : '');
	      var lastLastIndex = 0;
	      var splitLimit = limit === undefined ? MAX_UINT32 : limit >>> 0;
	      // Make `global` and avoid `lastIndex` issues by working with a copy
	      var separatorCopy = new RegExp(separator.source, flags + 'g');
	      var match, lastIndex, lastLength;
	      while (match = regexpExec.call(separatorCopy, string)) {
	        lastIndex = separatorCopy[LAST_INDEX];
	        if (lastIndex > lastLastIndex) {
	          output.push(string.slice(lastLastIndex, match.index));
	          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
	          lastLength = match[0][LENGTH];
	          lastLastIndex = lastIndex;
	          if (output[LENGTH] >= splitLimit) break;
	        }
	        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
	      }
	      if (lastLastIndex === string[LENGTH]) {
	        if (lastLength || !separatorCopy.test('')) output.push('');
	      } else output.push(string.slice(lastLastIndex));
	      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
	    };
	  // Chakra, V8
	  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
	    internalSplit = function (separator, limit) {
	      return separator === undefined && limit === 0 ? [] : $split.call(this, separator, limit);
	    };
	  } else {
	    internalSplit = $split;
	  }
	
	  return [
	    // `String.prototype.split` method
	    // https://tc39.github.io/ecma262/#sec-string.prototype.split
	    function split(separator, limit) {
	      var O = defined(this);
	      var splitter = separator == undefined ? undefined : separator[SPLIT];
	      return splitter !== undefined
	        ? splitter.call(separator, O, limit)
	        : internalSplit.call(String(O), separator, limit);
	    },
	    // `RegExp.prototype[@@split]` method
	    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@split
	    //
	    // NOTE: This cannot be properly polyfilled in engines that don't support
	    // the 'y' flag.
	    function (regexp, limit) {
	      var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== $split);
	      if (res.done) return res.value;
	
	      var rx = anObject(regexp);
	      var S = String(this);
	      var C = speciesConstructor(rx, RegExp);
	
	      var unicodeMatching = rx.unicode;
	      var flags = (rx.ignoreCase ? 'i' : '') +
	                  (rx.multiline ? 'm' : '') +
	                  (rx.unicode ? 'u' : '') +
	                  (SUPPORTS_Y ? 'y' : 'g');
	
	      // ^(? + rx + ) is needed, in combination with some S slicing, to
	      // simulate the 'y' flag.
	      var splitter = new C(SUPPORTS_Y ? rx : '^(?:' + rx.source + ')', flags);
	      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
	      if (lim === 0) return [];
	      if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
	      var p = 0;
	      var q = 0;
	      var A = [];
	      while (q < S.length) {
	        splitter.lastIndex = SUPPORTS_Y ? q : 0;
	        var z = callRegExpExec(splitter, SUPPORTS_Y ? S : S.slice(q));
	        var e;
	        if (
	          z === null ||
	          (e = $min(toLength(splitter.lastIndex + (SUPPORTS_Y ? 0 : q)), S.length)) === p
	        ) {
	          q = advanceStringIndex(S, q, unicodeMatching);
	        } else {
	          A.push(S.slice(p, q));
	          if (A.length === lim) return A;
	          for (var i = 1; i <= z.length - 1; i++) {
	            A.push(z[i]);
	            if (A.length === lim) return A;
	          }
	          q = p = e;
	        }
	      }
	      A.push(S.slice(p));
	      return A;
	    }
	  ];
	});


/***/ }),
/* 1467 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	__webpack_require__(1120);
	var anObject = __webpack_require__(4);
	var $flags = __webpack_require__(313);
	var DESCRIPTORS = __webpack_require__(14);
	var TO_STRING = 'toString';
	var $toString = /./[TO_STRING];
	
	var define = function (fn) {
	  __webpack_require__(26)(RegExp.prototype, TO_STRING, fn, true);
	};
	
	// 21.2.5.14 RegExp.prototype.toString()
	if (__webpack_require__(6)(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
	  define(function toString() {
	    var R = anObject(this);
	    return '/'.concat(R.source, '/',
	      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
	  });
	// FF44- RegExp#toString has a wrong name
	} else if ($toString.name != TO_STRING) {
	  define(function toString() {
	    return $toString.call(this);
	  });
	}


/***/ }),
/* 1468 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.2 String.prototype.anchor(name)
	__webpack_require__(27)('anchor', function (createHTML) {
	  return function anchor(name) {
	    return createHTML(this, 'a', 'name', name);
	  };
	});


/***/ }),
/* 1469 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.3 String.prototype.big()
	__webpack_require__(27)('big', function (createHTML) {
	  return function big() {
	    return createHTML(this, 'big', '', '');
	  };
	});


/***/ }),
/* 1470 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.4 String.prototype.blink()
	__webpack_require__(27)('blink', function (createHTML) {
	  return function blink() {
	    return createHTML(this, 'blink', '', '');
	  };
	});


/***/ }),
/* 1471 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.5 String.prototype.bold()
	__webpack_require__(27)('bold', function (createHTML) {
	  return function bold() {
	    return createHTML(this, 'b', '', '');
	  };
	});


/***/ }),
/* 1472 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3);
	var $at = __webpack_require__(466)(false);
	$export($export.P, 'String', {
	  // 21.1.3.3 String.prototype.codePointAt(pos)
	  codePointAt: function codePointAt(pos) {
	    return $at(this, pos);
	  }
	});


/***/ }),
/* 1473 */
/***/ (function(module, exports, __webpack_require__) {

	// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])
	'use strict';
	var $export = __webpack_require__(3);
	var toLength = __webpack_require__(11);
	var context = __webpack_require__(722);
	var ENDS_WITH = 'endsWith';
	var $endsWith = ''[ENDS_WITH];
	
	$export($export.P + $export.F * __webpack_require__(709)(ENDS_WITH), 'String', {
	  endsWith: function endsWith(searchString /* , endPosition = @length */) {
	    var that = context(this, searchString, ENDS_WITH);
	    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
	    var len = toLength(that.length);
	    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
	    var search = String(searchString);
	    return $endsWith
	      ? $endsWith.call(that, search, end)
	      : that.slice(end - search.length, end) === search;
	  }
	});


/***/ }),
/* 1474 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.6 String.prototype.fixed()
	__webpack_require__(27)('fixed', function (createHTML) {
	  return function fixed() {
	    return createHTML(this, 'tt', '', '');
	  };
	});


/***/ }),
/* 1475 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.7 String.prototype.fontcolor(color)
	__webpack_require__(27)('fontcolor', function (createHTML) {
	  return function fontcolor(color) {
	    return createHTML(this, 'font', 'color', color);
	  };
	});


/***/ }),
/* 1476 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.8 String.prototype.fontsize(size)
	__webpack_require__(27)('fontsize', function (createHTML) {
	  return function fontsize(size) {
	    return createHTML(this, 'font', 'size', size);
	  };
	});


/***/ }),
/* 1477 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(3);
	var toAbsoluteIndex = __webpack_require__(142);
	var fromCharCode = String.fromCharCode;
	var $fromCodePoint = String.fromCodePoint;
	
	// length should be 1, old FF problem
	$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
	  // 21.1.2.2 String.fromCodePoint(...codePoints)
	  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
	    var res = [];
	    var aLen = arguments.length;
	    var i = 0;
	    var code;
	    while (aLen > i) {
	      code = +arguments[i++];
	      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
	      res.push(code < 0x10000
	        ? fromCharCode(code)
	        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
	      );
	    } return res.join('');
	  }
	});


/***/ }),
/* 1478 */
/***/ (function(module, exports, __webpack_require__) {

	// 21.1.3.7 String.prototype.includes(searchString, position = 0)
	'use strict';
	var $export = __webpack_require__(3);
	var context = __webpack_require__(722);
	var INCLUDES = 'includes';
	
	$export($export.P + $export.F * __webpack_require__(709)(INCLUDES), 'String', {
	  includes: function includes(searchString /* , position = 0 */) {
	    return !!~context(this, searchString, INCLUDES)
	      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});


/***/ }),
/* 1479 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.9 String.prototype.italics()
	__webpack_require__(27)('italics', function (createHTML) {
	  return function italics() {
	    return createHTML(this, 'i', '', '');
	  };
	});


/***/ }),
/* 1480 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $at = __webpack_require__(466)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(714)(String, 'String', function (iterated) {
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var index = this._i;
	  var point;
	  if (index >= O.length) return { value: undefined, done: true };
	  point = $at(O, index);
	  this._i += point.length;
	  return { value: point, done: false };
	});


/***/ }),
/* 1481 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.10 String.prototype.link(url)
	__webpack_require__(27)('link', function (createHTML) {
	  return function link(url) {
	    return createHTML(this, 'a', 'href', url);
	  };
	});


/***/ }),
/* 1482 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(3);
	var toIObject = __webpack_require__(39);
	var toLength = __webpack_require__(11);
	
	$export($export.S, 'String', {
	  // 21.1.2.4 String.raw(callSite, ...substitutions)
	  raw: function raw(callSite) {
	    var tpl = toIObject(callSite.raw);
	    var len = toLength(tpl.length);
	    var aLen = arguments.length;
	    var res = [];
	    var i = 0;
	    while (len > i) {
	      res.push(String(tpl[i++]));
	      if (i < aLen) res.push(String(arguments[i]));
	    } return res.join('');
	  }
	});


/***/ }),
/* 1483 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(3);
	
	$export($export.P, 'String', {
	  // 21.1.3.13 String.prototype.repeat(count)
	  repeat: __webpack_require__(723)
	});


/***/ }),
/* 1484 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.11 String.prototype.small()
	__webpack_require__(27)('small', function (createHTML) {
	  return function small() {
	    return createHTML(this, 'small', '', '');
	  };
	});


/***/ }),
/* 1485 */
/***/ (function(module, exports, __webpack_require__) {

	// 21.1.3.18 String.prototype.startsWith(searchString [, position ])
	'use strict';
	var $export = __webpack_require__(3);
	var toLength = __webpack_require__(11);
	var context = __webpack_require__(722);
	var STARTS_WITH = 'startsWith';
	var $startsWith = ''[STARTS_WITH];
	
	$export($export.P + $export.F * __webpack_require__(709)(STARTS_WITH), 'String', {
	  startsWith: function startsWith(searchString /* , position = 0 */) {
	    var that = context(this, searchString, STARTS_WITH);
	    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
	    var search = String(searchString);
	    return $startsWith
	      ? $startsWith.call(that, search, index)
	      : that.slice(index, index + search.length) === search;
	  }
	});


/***/ }),
/* 1486 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.12 String.prototype.strike()
	__webpack_require__(27)('strike', function (createHTML) {
	  return function strike() {
	    return createHTML(this, 'strike', '', '');
	  };
	});


/***/ }),
/* 1487 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.13 String.prototype.sub()
	__webpack_require__(27)('sub', function (createHTML) {
	  return function sub() {
	    return createHTML(this, 'sub', '', '');
	  };
	});


/***/ }),
/* 1488 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.14 String.prototype.sup()
	__webpack_require__(27)('sup', function (createHTML) {
	  return function sup() {
	    return createHTML(this, 'sup', '', '');
	  };
	});


/***/ }),
/* 1489 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 21.1.3.25 String.prototype.trim()
	__webpack_require__(204)('trim', function ($trim) {
	  return function trim() {
	    return $trim(this, 3);
	  };
	});


/***/ }),
/* 1490 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var global = __webpack_require__(5);
	var has = __webpack_require__(36);
	var DESCRIPTORS = __webpack_require__(14);
	var $export = __webpack_require__(3);
	var redefine = __webpack_require__(26);
	var META = __webpack_require__(94).KEY;
	var $fails = __webpack_require__(6);
	var shared = __webpack_require__(316);
	var setToStringTag = __webpack_require__(203);
	var uid = __webpack_require__(143);
	var wks = __webpack_require__(10);
	var wksExt = __webpack_require__(1117);
	var wksDefine = __webpack_require__(727);
	var enumKeys = __webpack_require__(1367);
	var isArray = __webpack_require__(458);
	var anObject = __webpack_require__(4);
	var isObject = __webpack_require__(7);
	var toObject = __webpack_require__(17);
	var toIObject = __webpack_require__(39);
	var toPrimitive = __webpack_require__(69);
	var createDesc = __webpack_require__(139);
	var _create = __webpack_require__(136);
	var gOPNExt = __webpack_require__(1106);
	var $GOPD = __webpack_require__(37);
	var $GOPS = __webpack_require__(462);
	var $DP = __webpack_require__(16);
	var $keys = __webpack_require__(138);
	var gOPD = $GOPD.f;
	var dP = $DP.f;
	var gOPN = gOPNExt.f;
	var $Symbol = global.Symbol;
	var $JSON = global.JSON;
	var _stringify = $JSON && $JSON.stringify;
	var PROTOTYPE = 'prototype';
	var HIDDEN = wks('_hidden');
	var TO_PRIMITIVE = wks('toPrimitive');
	var isEnum = {}.propertyIsEnumerable;
	var SymbolRegistry = shared('symbol-registry');
	var AllSymbols = shared('symbols');
	var OPSymbols = shared('op-symbols');
	var ObjectProto = Object[PROTOTYPE];
	var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
	var QObject = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function () {
	  return _create(dP({}, 'a', {
	    get: function () { return dP(this, 'a', { value: 7 }).a; }
	  })).a != 7;
	}) ? function (it, key, D) {
	  var protoDesc = gOPD(ObjectProto, key);
	  if (protoDesc) delete ObjectProto[key];
	  dP(it, key, D);
	  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
	} : dP;
	
	var wrap = function (tag) {
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};
	
	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
	  return typeof it == 'symbol';
	} : function (it) {
	  return it instanceof $Symbol;
	};
	
	var $defineProperty = function defineProperty(it, key, D) {
	  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if (has(AllSymbols, key)) {
	    if (!D.enumerable) {
	      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
	      D = _create(D, { enumerable: createDesc(0, false) });
	    } return setSymbolDesc(it, key, D);
	  } return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P) {
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P));
	  var i = 0;
	  var l = keys.length;
	  var key;
	  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P) {
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key) {
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
	  it = toIObject(it);
	  key = toPrimitive(key, true);
	  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
	  var D = gOPD(it, key);
	  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it) {
	  var names = gOPN(toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
	  var IS_OP = it === ObjectProto;
	  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
	  } return result;
	};
	
	// 19.4.1.1 Symbol([description])
	if (!USE_NATIVE) {
	  $Symbol = function Symbol() {
	    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function (value) {
	      if (this === ObjectProto) $set.call(OPSymbols, value);
	      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
	    return this._k;
	  });
	
	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f = $defineProperty;
	  __webpack_require__(137).f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__(315).f = $propertyIsEnumerable;
	  $GOPS.f = $getOwnPropertySymbols;
	
	  if (DESCRIPTORS && !__webpack_require__(93)) {
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	
	  wksExt.f = function (name) {
	    return wrap(wks(name));
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });
	
	for (var es6Symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);
	
	for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);
	
	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function (key) {
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(sym) {
	    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
	    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
	  },
	  useSetter: function () { setter = true; },
	  useSimple: function () { setter = false; }
	});
	
	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
	// https://bugs.chromium.org/p/v8/issues/detail?id=3443
	var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });
	
	$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
	  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
	    return $GOPS.f(toObject(it));
	  }
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it) {
	    var args = [it];
	    var i = 1;
	    var replacer, $replacer;
	    while (arguments.length > i) args.push(arguments[i++]);
	    $replacer = replacer = args[1];
	    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
	    if (!isArray(replacer)) replacer = function (key, value) {
	      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
	      if (!isSymbol(value)) return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});
	
	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(25)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 1491 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3);
	var $typed = __webpack_require__(467);
	var buffer = __webpack_require__(726);
	var anObject = __webpack_require__(4);
	var toAbsoluteIndex = __webpack_require__(142);
	var toLength = __webpack_require__(11);
	var isObject = __webpack_require__(7);
	var ArrayBuffer = __webpack_require__(5).ArrayBuffer;
	var speciesConstructor = __webpack_require__(317);
	var $ArrayBuffer = buffer.ArrayBuffer;
	var $DataView = buffer.DataView;
	var $isView = $typed.ABV && ArrayBuffer.isView;
	var $slice = $ArrayBuffer.prototype.slice;
	var VIEW = $typed.VIEW;
	var ARRAY_BUFFER = 'ArrayBuffer';
	
	$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), { ArrayBuffer: $ArrayBuffer });
	
	$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
	  // 24.1.3.1 ArrayBuffer.isView(arg)
	  isView: function isView(it) {
	    return $isView && $isView(it) || isObject(it) && VIEW in it;
	  }
	});
	
	$export($export.P + $export.U + $export.F * __webpack_require__(6)(function () {
	  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
	}), ARRAY_BUFFER, {
	  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
	  slice: function slice(start, end) {
	    if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix
	    var len = anObject(this).byteLength;
	    var first = toAbsoluteIndex(start, len);
	    var fin = toAbsoluteIndex(end === undefined ? len : end, len);
	    var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(fin - first));
	    var viewS = new $DataView(this);
	    var viewT = new $DataView(result);
	    var index = 0;
	    while (first < fin) {
	      viewT.setUint8(index++, viewS.getUint8(first++));
	    } return result;
	  }
	});
	
	__webpack_require__(141)(ARRAY_BUFFER);


/***/ }),
/* 1492 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(3);
	$export($export.G + $export.W + $export.F * !__webpack_require__(467).ABV, {
	  DataView: __webpack_require__(726).DataView
	});


/***/ }),
/* 1493 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(75)('Float32', 4, function (init) {
	  return function Float32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 1494 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(75)('Float64', 8, function (init) {
	  return function Float64Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 1495 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(75)('Int16', 2, function (init) {
	  return function Int16Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 1496 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(75)('Int32', 4, function (init) {
	  return function Int32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 1497 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(75)('Int8', 1, function (init) {
	  return function Int8Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 1498 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(75)('Uint16', 2, function (init) {
	  return function Uint16Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 1499 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(75)('Uint32', 4, function (init) {
	  return function Uint32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 1500 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(75)('Uint8', 1, function (init) {
	  return function Uint8Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 1501 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(75)('Uint8', 1, function (init) {
	  return function Uint8ClampedArray(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	}, true);


/***/ }),
/* 1502 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var weak = __webpack_require__(1094);
	var validate = __webpack_require__(144);
	var WEAK_SET = 'WeakSet';
	
	// 23.4 WeakSet Objects
	__webpack_require__(456)(WEAK_SET, function (get) {
	  return function WeakSet() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.4.3.1 WeakSet.prototype.add(value)
	  add: function add(value) {
	    return weak.def(validate(this, WEAK_SET), value, true);
	  }
	}, weak, false, true);


/***/ }),
/* 1503 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatMap
	var $export = __webpack_require__(3);
	var flattenIntoArray = __webpack_require__(1095);
	var toObject = __webpack_require__(17);
	var toLength = __webpack_require__(11);
	var aFunction = __webpack_require__(23);
	var arraySpeciesCreate = __webpack_require__(705);
	
	$export($export.P, 'Array', {
	  flatMap: function flatMap(callbackfn /* , thisArg */) {
	    var O = toObject(this);
	    var sourceLen, A;
	    aFunction(callbackfn);
	    sourceLen = toLength(O.length);
	    A = arraySpeciesCreate(O, 0);
	    flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
	    return A;
	  }
	});
	
	__webpack_require__(92)('flatMap');


/***/ }),
/* 1504 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatten
	var $export = __webpack_require__(3);
	var flattenIntoArray = __webpack_require__(1095);
	var toObject = __webpack_require__(17);
	var toLength = __webpack_require__(11);
	var toInteger = __webpack_require__(48);
	var arraySpeciesCreate = __webpack_require__(705);
	
	$export($export.P, 'Array', {
	  flatten: function flatten(/* depthArg = 1 */) {
	    var depthArg = arguments[0];
	    var O = toObject(this);
	    var sourceLen = toLength(O.length);
	    var A = arraySpeciesCreate(O, 0);
	    flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toInteger(depthArg));
	    return A;
	  }
	});
	
	__webpack_require__(92)('flatten');


/***/ }),
/* 1505 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/Array.prototype.includes
	var $export = __webpack_require__(3);
	var $includes = __webpack_require__(455)(true);
	
	$export($export.P, 'Array', {
	  includes: function includes(el /* , fromIndex = 0 */) {
	    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	
	__webpack_require__(92)('includes');


/***/ }),
/* 1506 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
	var $export = __webpack_require__(3);
	var microtask = __webpack_require__(717)();
	var process = __webpack_require__(5).process;
	var isNode = __webpack_require__(44)(process) == 'process';
	
	$export($export.G, {
	  asap: function asap(fn) {
	    var domain = isNode && process.domain;
	    microtask(domain ? domain.bind(fn) : fn);
	  }
	});


/***/ }),
/* 1507 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/ljharb/proposal-is-error
	var $export = __webpack_require__(3);
	var cof = __webpack_require__(44);
	
	$export($export.S, 'Error', {
	  isError: function isError(it) {
	    return cof(it) === 'Error';
	  }
	});


/***/ }),
/* 1508 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-global
	var $export = __webpack_require__(3);
	
	$export($export.G, { global: __webpack_require__(5) });


/***/ }),
/* 1509 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
	__webpack_require__(464)('Map');


/***/ }),
/* 1510 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
	__webpack_require__(465)('Map');


/***/ }),
/* 1511 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export = __webpack_require__(3);
	
	$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(1093)('Map') });


/***/ }),
/* 1512 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Math', {
	  clamp: function clamp(x, lower, upper) {
	    return Math.min(upper, Math.max(lower, x));
	  }
	});


/***/ }),
/* 1513 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Math', { DEG_PER_RAD: Math.PI / 180 });


/***/ }),
/* 1514 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(3);
	var RAD_PER_DEG = 180 / Math.PI;
	
	$export($export.S, 'Math', {
	  degrees: function degrees(radians) {
	    return radians * RAD_PER_DEG;
	  }
	});


/***/ }),
/* 1515 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(3);
	var scale = __webpack_require__(1103);
	var fround = __webpack_require__(1101);
	
	$export($export.S, 'Math', {
	  fscale: function fscale(x, inLow, inHigh, outLow, outHigh) {
	    return fround(scale(x, inLow, inHigh, outLow, outHigh));
	  }
	});


/***/ }),
/* 1516 */
/***/ (function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Math', {
	  iaddh: function iaddh(x0, x1, y0, y1) {
	    var $x0 = x0 >>> 0;
	    var $x1 = x1 >>> 0;
	    var $y0 = y0 >>> 0;
	    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
	  }
	});


/***/ }),
/* 1517 */
/***/ (function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Math', {
	  imulh: function imulh(u, v) {
	    var UINT16 = 0xffff;
	    var $u = +u;
	    var $v = +v;
	    var u0 = $u & UINT16;
	    var v0 = $v & UINT16;
	    var u1 = $u >> 16;
	    var v1 = $v >> 16;
	    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
	    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
	  }
	});


/***/ }),
/* 1518 */
/***/ (function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Math', {
	  isubh: function isubh(x0, x1, y0, y1) {
	    var $x0 = x0 >>> 0;
	    var $x1 = x1 >>> 0;
	    var $y0 = y0 >>> 0;
	    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
	  }
	});


/***/ }),
/* 1519 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Math', { RAD_PER_DEG: 180 / Math.PI });


/***/ }),
/* 1520 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(3);
	var DEG_PER_RAD = Math.PI / 180;
	
	$export($export.S, 'Math', {
	  radians: function radians(degrees) {
	    return degrees * DEG_PER_RAD;
	  }
	});


/***/ }),
/* 1521 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Math', { scale: __webpack_require__(1103) });


/***/ }),
/* 1522 */
/***/ (function(module, exports, __webpack_require__) {

	// http://jfbastien.github.io/papers/Math.signbit.html
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Math', { signbit: function signbit(x) {
	  // eslint-disable-next-line no-self-compare
	  return (x = +x) != x ? x : x == 0 ? 1 / x == Infinity : x > 0;
	} });


/***/ }),
/* 1523 */
/***/ (function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Math', {
	  umulh: function umulh(u, v) {
	    var UINT16 = 0xffff;
	    var $u = +u;
	    var $v = +v;
	    var u0 = $u & UINT16;
	    var v0 = $v & UINT16;
	    var u1 = $u >>> 16;
	    var v1 = $v >>> 16;
	    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
	    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
	  }
	});


/***/ }),
/* 1524 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3);
	var toObject = __webpack_require__(17);
	var aFunction = __webpack_require__(23);
	var $defineProperty = __webpack_require__(16);
	
	// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
	__webpack_require__(14) && $export($export.P + __webpack_require__(461), 'Object', {
	  __defineGetter__: function __defineGetter__(P, getter) {
	    $defineProperty.f(toObject(this), P, { get: aFunction(getter), enumerable: true, configurable: true });
	  }
	});


/***/ }),
/* 1525 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3);
	var toObject = __webpack_require__(17);
	var aFunction = __webpack_require__(23);
	var $defineProperty = __webpack_require__(16);
	
	// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
	__webpack_require__(14) && $export($export.P + __webpack_require__(461), 'Object', {
	  __defineSetter__: function __defineSetter__(P, setter) {
	    $defineProperty.f(toObject(this), P, { set: aFunction(setter), enumerable: true, configurable: true });
	  }
	});


/***/ }),
/* 1526 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(3);
	var $entries = __webpack_require__(1108)(true);
	
	$export($export.S, 'Object', {
	  entries: function entries(it) {
	    return $entries(it);
	  }
	});


/***/ }),
/* 1527 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-getownpropertydescriptors
	var $export = __webpack_require__(3);
	var ownKeys = __webpack_require__(1109);
	var toIObject = __webpack_require__(39);
	var gOPD = __webpack_require__(37);
	var createProperty = __webpack_require__(706);
	
	$export($export.S, 'Object', {
	  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
	    var O = toIObject(object);
	    var getDesc = gOPD.f;
	    var keys = ownKeys(O);
	    var result = {};
	    var i = 0;
	    var key, desc;
	    while (keys.length > i) {
	      desc = getDesc(O, key = keys[i++]);
	      if (desc !== undefined) createProperty(result, key, desc);
	    }
	    return result;
	  }
	});


/***/ }),
/* 1528 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3);
	var toObject = __webpack_require__(17);
	var toPrimitive = __webpack_require__(69);
	var getPrototypeOf = __webpack_require__(38);
	var getOwnPropertyDescriptor = __webpack_require__(37).f;
	
	// B.2.2.4 Object.prototype.__lookupGetter__(P)
	__webpack_require__(14) && $export($export.P + __webpack_require__(461), 'Object', {
	  __lookupGetter__: function __lookupGetter__(P) {
	    var O = toObject(this);
	    var K = toPrimitive(P, true);
	    var D;
	    do {
	      if (D = getOwnPropertyDescriptor(O, K)) return D.get;
	    } while (O = getPrototypeOf(O));
	  }
	});


/***/ }),
/* 1529 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3);
	var toObject = __webpack_require__(17);
	var toPrimitive = __webpack_require__(69);
	var getPrototypeOf = __webpack_require__(38);
	var getOwnPropertyDescriptor = __webpack_require__(37).f;
	
	// B.2.2.5 Object.prototype.__lookupSetter__(P)
	__webpack_require__(14) && $export($export.P + __webpack_require__(461), 'Object', {
	  __lookupSetter__: function __lookupSetter__(P) {
	    var O = toObject(this);
	    var K = toPrimitive(P, true);
	    var D;
	    do {
	      if (D = getOwnPropertyDescriptor(O, K)) return D.set;
	    } while (O = getPrototypeOf(O));
	  }
	});


/***/ }),
/* 1530 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(3);
	var $values = __webpack_require__(1108)(false);
	
	$export($export.S, 'Object', {
	  values: function values(it) {
	    return $values(it);
	  }
	});


/***/ }),
/* 1531 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/zenparsing/es-observable
	var $export = __webpack_require__(3);
	var global = __webpack_require__(5);
	var core = __webpack_require__(45);
	var microtask = __webpack_require__(717)();
	var OBSERVABLE = __webpack_require__(10)('observable');
	var aFunction = __webpack_require__(23);
	var anObject = __webpack_require__(4);
	var anInstance = __webpack_require__(134);
	var redefineAll = __webpack_require__(140);
	var hide = __webpack_require__(25);
	var forOf = __webpack_require__(135);
	var RETURN = forOf.RETURN;
	
	var getMethod = function (fn) {
	  return fn == null ? undefined : aFunction(fn);
	};
	
	var cleanupSubscription = function (subscription) {
	  var cleanup = subscription._c;
	  if (cleanup) {
	    subscription._c = undefined;
	    cleanup();
	  }
	};
	
	var subscriptionClosed = function (subscription) {
	  return subscription._o === undefined;
	};
	
	var closeSubscription = function (subscription) {
	  if (!subscriptionClosed(subscription)) {
	    subscription._o = undefined;
	    cleanupSubscription(subscription);
	  }
	};
	
	var Subscription = function (observer, subscriber) {
	  anObject(observer);
	  this._c = undefined;
	  this._o = observer;
	  observer = new SubscriptionObserver(this);
	  try {
	    var cleanup = subscriber(observer);
	    var subscription = cleanup;
	    if (cleanup != null) {
	      if (typeof cleanup.unsubscribe === 'function') cleanup = function () { subscription.unsubscribe(); };
	      else aFunction(cleanup);
	      this._c = cleanup;
	    }
	  } catch (e) {
	    observer.error(e);
	    return;
	  } if (subscriptionClosed(this)) cleanupSubscription(this);
	};
	
	Subscription.prototype = redefineAll({}, {
	  unsubscribe: function unsubscribe() { closeSubscription(this); }
	});
	
	var SubscriptionObserver = function (subscription) {
	  this._s = subscription;
	};
	
	SubscriptionObserver.prototype = redefineAll({}, {
	  next: function next(value) {
	    var subscription = this._s;
	    if (!subscriptionClosed(subscription)) {
	      var observer = subscription._o;
	      try {
	        var m = getMethod(observer.next);
	        if (m) return m.call(observer, value);
	      } catch (e) {
	        try {
	          closeSubscription(subscription);
	        } finally {
	          throw e;
	        }
	      }
	    }
	  },
	  error: function error(value) {
	    var subscription = this._s;
	    if (subscriptionClosed(subscription)) throw value;
	    var observer = subscription._o;
	    subscription._o = undefined;
	    try {
	      var m = getMethod(observer.error);
	      if (!m) throw value;
	      value = m.call(observer, value);
	    } catch (e) {
	      try {
	        cleanupSubscription(subscription);
	      } finally {
	        throw e;
	      }
	    } cleanupSubscription(subscription);
	    return value;
	  },
	  complete: function complete(value) {
	    var subscription = this._s;
	    if (!subscriptionClosed(subscription)) {
	      var observer = subscription._o;
	      subscription._o = undefined;
	      try {
	        var m = getMethod(observer.complete);
	        value = m ? m.call(observer, value) : undefined;
	      } catch (e) {
	        try {
	          cleanupSubscription(subscription);
	        } finally {
	          throw e;
	        }
	      } cleanupSubscription(subscription);
	      return value;
	    }
	  }
	});
	
	var $Observable = function Observable(subscriber) {
	  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
	};
	
	redefineAll($Observable.prototype, {
	  subscribe: function subscribe(observer) {
	    return new Subscription(observer, this._f);
	  },
	  forEach: function forEach(fn) {
	    var that = this;
	    return new (core.Promise || global.Promise)(function (resolve, reject) {
	      aFunction(fn);
	      var subscription = that.subscribe({
	        next: function (value) {
	          try {
	            return fn(value);
	          } catch (e) {
	            reject(e);
	            subscription.unsubscribe();
	          }
	        },
	        error: reject,
	        complete: resolve
	      });
	    });
	  }
	});
	
	redefineAll($Observable, {
	  from: function from(x) {
	    var C = typeof this === 'function' ? this : $Observable;
	    var method = getMethod(anObject(x)[OBSERVABLE]);
	    if (method) {
	      var observable = anObject(method.call(x));
	      return observable.constructor === C ? observable : new C(function (observer) {
	        return observable.subscribe(observer);
	      });
	    }
	    return new C(function (observer) {
	      var done = false;
	      microtask(function () {
	        if (!done) {
	          try {
	            if (forOf(x, false, function (it) {
	              observer.next(it);
	              if (done) return RETURN;
	            }) === RETURN) return;
	          } catch (e) {
	            if (done) throw e;
	            observer.error(e);
	            return;
	          } observer.complete();
	        }
	      });
	      return function () { done = true; };
	    });
	  },
	  of: function of() {
	    for (var i = 0, l = arguments.length, items = new Array(l); i < l;) items[i] = arguments[i++];
	    return new (typeof this === 'function' ? this : $Observable)(function (observer) {
	      var done = false;
	      microtask(function () {
	        if (!done) {
	          for (var j = 0; j < items.length; ++j) {
	            observer.next(items[j]);
	            if (done) return;
	          } observer.complete();
	        }
	      });
	      return function () { done = true; };
	    });
	  }
	});
	
	hide($Observable.prototype, OBSERVABLE, function () { return this; });
	
	$export($export.G, { Observable: $Observable });
	
	__webpack_require__(141)('Observable');


/***/ }),
/* 1532 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-promise-finally
	'use strict';
	var $export = __webpack_require__(3);
	var core = __webpack_require__(45);
	var global = __webpack_require__(5);
	var speciesConstructor = __webpack_require__(317);
	var promiseResolve = __webpack_require__(1113);
	
	$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
	  var C = speciesConstructor(this, core.Promise || global.Promise);
	  var isFunction = typeof onFinally == 'function';
	  return this.then(
	    isFunction ? function (x) {
	      return promiseResolve(C, onFinally()).then(function () { return x; });
	    } : onFinally,
	    isFunction ? function (e) {
	      return promiseResolve(C, onFinally()).then(function () { throw e; });
	    } : onFinally
	  );
	} });


/***/ }),
/* 1533 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-promise-try
	var $export = __webpack_require__(3);
	var newPromiseCapability = __webpack_require__(718);
	var perform = __webpack_require__(1112);
	
	$export($export.S, 'Promise', { 'try': function (callbackfn) {
	  var promiseCapability = newPromiseCapability.f(this);
	  var result = perform(callbackfn);
	  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
	  return promiseCapability.promise;
	} });


/***/ }),
/* 1534 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(74);
	var anObject = __webpack_require__(4);
	var toMetaKey = metadata.key;
	var ordinaryDefineOwnMetadata = metadata.set;
	
	metadata.exp({ defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey) {
	  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
	} });


/***/ }),
/* 1535 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(74);
	var anObject = __webpack_require__(4);
	var toMetaKey = metadata.key;
	var getOrCreateMetadataMap = metadata.map;
	var store = metadata.store;
	
	metadata.exp({ deleteMetadata: function deleteMetadata(metadataKey, target /* , targetKey */) {
	  var targetKey = arguments.length < 3 ? undefined : toMetaKey(arguments[2]);
	  var metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
	  if (metadataMap === undefined || !metadataMap['delete'](metadataKey)) return false;
	  if (metadataMap.size) return true;
	  var targetMetadata = store.get(target);
	  targetMetadata['delete'](targetKey);
	  return !!targetMetadata.size || store['delete'](target);
	} });


/***/ }),
/* 1536 */
/***/ (function(module, exports, __webpack_require__) {

	var Set = __webpack_require__(1121);
	var from = __webpack_require__(1089);
	var metadata = __webpack_require__(74);
	var anObject = __webpack_require__(4);
	var getPrototypeOf = __webpack_require__(38);
	var ordinaryOwnMetadataKeys = metadata.keys;
	var toMetaKey = metadata.key;
	
	var ordinaryMetadataKeys = function (O, P) {
	  var oKeys = ordinaryOwnMetadataKeys(O, P);
	  var parent = getPrototypeOf(O);
	  if (parent === null) return oKeys;
	  var pKeys = ordinaryMetadataKeys(parent, P);
	  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
	};
	
	metadata.exp({ getMetadataKeys: function getMetadataKeys(target /* , targetKey */) {
	  return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
	} });


/***/ }),
/* 1537 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(74);
	var anObject = __webpack_require__(4);
	var getPrototypeOf = __webpack_require__(38);
	var ordinaryHasOwnMetadata = metadata.has;
	var ordinaryGetOwnMetadata = metadata.get;
	var toMetaKey = metadata.key;
	
	var ordinaryGetMetadata = function (MetadataKey, O, P) {
	  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
	  if (hasOwn) return ordinaryGetOwnMetadata(MetadataKey, O, P);
	  var parent = getPrototypeOf(O);
	  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
	};
	
	metadata.exp({ getMetadata: function getMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ }),
/* 1538 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(74);
	var anObject = __webpack_require__(4);
	var ordinaryOwnMetadataKeys = metadata.keys;
	var toMetaKey = metadata.key;
	
	metadata.exp({ getOwnMetadataKeys: function getOwnMetadataKeys(target /* , targetKey */) {
	  return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
	} });


/***/ }),
/* 1539 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(74);
	var anObject = __webpack_require__(4);
	var ordinaryGetOwnMetadata = metadata.get;
	var toMetaKey = metadata.key;
	
	metadata.exp({ getOwnMetadata: function getOwnMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryGetOwnMetadata(metadataKey, anObject(target)
	    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ }),
/* 1540 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(74);
	var anObject = __webpack_require__(4);
	var getPrototypeOf = __webpack_require__(38);
	var ordinaryHasOwnMetadata = metadata.has;
	var toMetaKey = metadata.key;
	
	var ordinaryHasMetadata = function (MetadataKey, O, P) {
	  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
	  if (hasOwn) return true;
	  var parent = getPrototypeOf(O);
	  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
	};
	
	metadata.exp({ hasMetadata: function hasMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ }),
/* 1541 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(74);
	var anObject = __webpack_require__(4);
	var ordinaryHasOwnMetadata = metadata.has;
	var toMetaKey = metadata.key;
	
	metadata.exp({ hasOwnMetadata: function hasOwnMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryHasOwnMetadata(metadataKey, anObject(target)
	    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ }),
/* 1542 */
/***/ (function(module, exports, __webpack_require__) {

	var $metadata = __webpack_require__(74);
	var anObject = __webpack_require__(4);
	var aFunction = __webpack_require__(23);
	var toMetaKey = $metadata.key;
	var ordinaryDefineOwnMetadata = $metadata.set;
	
	$metadata.exp({ metadata: function metadata(metadataKey, metadataValue) {
	  return function decorator(target, targetKey) {
	    ordinaryDefineOwnMetadata(
	      metadataKey, metadataValue,
	      (targetKey !== undefined ? anObject : aFunction)(target),
	      toMetaKey(targetKey)
	    );
	  };
	} });


/***/ }),
/* 1543 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
	__webpack_require__(464)('Set');


/***/ }),
/* 1544 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
	__webpack_require__(465)('Set');


/***/ }),
/* 1545 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export = __webpack_require__(3);
	
	$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(1093)('Set') });


/***/ }),
/* 1546 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/mathiasbynens/String.prototype.at
	var $export = __webpack_require__(3);
	var $at = __webpack_require__(466)(true);
	var $fails = __webpack_require__(6);
	
	var FORCED = $fails(function () {
	  return '𠮷'.at(0) !== '𠮷';
	});
	
	$export($export.P + $export.F * FORCED, 'String', {
	  at: function at(pos) {
	    return $at(this, pos);
	  }
	});


/***/ }),
/* 1547 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/String.prototype.matchAll/
	var $export = __webpack_require__(3);
	var defined = __webpack_require__(67);
	var toLength = __webpack_require__(11);
	var isRegExp = __webpack_require__(459);
	var getFlags = __webpack_require__(313);
	var RegExpProto = RegExp.prototype;
	
	var $RegExpStringIterator = function (regexp, string) {
	  this._r = regexp;
	  this._s = string;
	};
	
	__webpack_require__(713)($RegExpStringIterator, 'RegExp String', function next() {
	  var match = this._r.exec(this._s);
	  return { value: match, done: match === null };
	});
	
	$export($export.P, 'String', {
	  matchAll: function matchAll(regexp) {
	    defined(this);
	    if (!isRegExp(regexp)) throw TypeError(regexp + ' is not a regexp!');
	    var S = String(this);
	    var flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp);
	    var rx = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
	    rx.lastIndex = toLength(regexp.lastIndex);
	    return new $RegExpStringIterator(rx, S);
	  }
	});


/***/ }),
/* 1548 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-string-pad-start-end
	var $export = __webpack_require__(3);
	var $pad = __webpack_require__(1115);
	var userAgent = __webpack_require__(468);
	
	// https://github.com/zloirock/core-js/issues/280
	var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);
	
	$export($export.P + $export.F * WEBKIT_BUG, 'String', {
	  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
	  }
	});


/***/ }),
/* 1549 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-string-pad-start-end
	var $export = __webpack_require__(3);
	var $pad = __webpack_require__(1115);
	var userAgent = __webpack_require__(468);
	
	// https://github.com/zloirock/core-js/issues/280
	var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);
	
	$export($export.P + $export.F * WEBKIT_BUG, 'String', {
	  padStart: function padStart(maxLength /* , fillString = ' ' */) {
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
	  }
	});


/***/ }),
/* 1550 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
	__webpack_require__(204)('trimLeft', function ($trim) {
	  return function trimLeft() {
	    return $trim(this, 1);
	  };
	}, 'trimStart');


/***/ }),
/* 1551 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
	__webpack_require__(204)('trimRight', function ($trim) {
	  return function trimRight() {
	    return $trim(this, 2);
	  };
	}, 'trimEnd');


/***/ }),
/* 1552 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(727)('asyncIterator');


/***/ }),
/* 1553 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(727)('observable');


/***/ }),
/* 1554 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-global
	var $export = __webpack_require__(3);
	
	$export($export.S, 'System', { global: __webpack_require__(5) });


/***/ }),
/* 1555 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
	__webpack_require__(464)('WeakMap');


/***/ }),
/* 1556 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
	__webpack_require__(465)('WeakMap');


/***/ }),
/* 1557 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.from
	__webpack_require__(464)('WeakSet');


/***/ }),
/* 1558 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.of
	__webpack_require__(465)('WeakSet');


/***/ }),
/* 1559 */
/***/ (function(module, exports, __webpack_require__) {

	var $iterators = __webpack_require__(729);
	var getKeys = __webpack_require__(138);
	var redefine = __webpack_require__(26);
	var global = __webpack_require__(5);
	var hide = __webpack_require__(25);
	var Iterators = __webpack_require__(202);
	var wks = __webpack_require__(10);
	var ITERATOR = wks('iterator');
	var TO_STRING_TAG = wks('toStringTag');
	var ArrayValues = Iterators.Array;
	
	var DOMIterables = {
	  CSSRuleList: true, // TODO: Not spec compliant, should be false.
	  CSSStyleDeclaration: false,
	  CSSValueList: false,
	  ClientRectList: false,
	  DOMRectList: false,
	  DOMStringList: false,
	  DOMTokenList: true,
	  DataTransferItemList: false,
	  FileList: false,
	  HTMLAllCollection: false,
	  HTMLCollection: false,
	  HTMLFormElement: false,
	  HTMLSelectElement: false,
	  MediaList: true, // TODO: Not spec compliant, should be false.
	  MimeTypeArray: false,
	  NamedNodeMap: false,
	  NodeList: true,
	  PaintRequestList: false,
	  Plugin: false,
	  PluginArray: false,
	  SVGLengthList: false,
	  SVGNumberList: false,
	  SVGPathSegList: false,
	  SVGPointList: false,
	  SVGStringList: false,
	  SVGTransformList: false,
	  SourceBufferList: false,
	  StyleSheetList: true, // TODO: Not spec compliant, should be false.
	  TextTrackCueList: false,
	  TextTrackList: false,
	  TouchList: false
	};
	
	for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
	  var NAME = collections[i];
	  var explicit = DOMIterables[NAME];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  var key;
	  if (proto) {
	    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
	    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	    Iterators[NAME] = ArrayValues;
	    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
	  }
	}


/***/ }),
/* 1560 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(3);
	var $task = __webpack_require__(725);
	$export($export.G + $export.B, {
	  setImmediate: $task.set,
	  clearImmediate: $task.clear
	});


/***/ }),
/* 1561 */
/***/ (function(module, exports, __webpack_require__) {

	// ie9- setTimeout & setInterval additional parameters fix
	var global = __webpack_require__(5);
	var $export = __webpack_require__(3);
	var userAgent = __webpack_require__(468);
	var slice = [].slice;
	var MSIE = /MSIE .\./.test(userAgent); // <- dirty ie9- check
	var wrap = function (set) {
	  return function (fn, time /* , ...args */) {
	    var boundArgs = arguments.length > 2;
	    var args = boundArgs ? slice.call(arguments, 2) : false;
	    return set(boundArgs ? function () {
	      // eslint-disable-next-line no-new-func
	      (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
	    } : fn, time);
	  };
	};
	$export($export.G + $export.B + $export.F * MSIE, {
	  setTimeout: wrap(global.setTimeout),
	  setInterval: wrap(global.setInterval)
	});


/***/ }),
/* 1562 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1490);
	__webpack_require__(1429);
	__webpack_require__(1431);
	__webpack_require__(1430);
	__webpack_require__(1433);
	__webpack_require__(1435);
	__webpack_require__(1440);
	__webpack_require__(1434);
	__webpack_require__(1432);
	__webpack_require__(1442);
	__webpack_require__(1441);
	__webpack_require__(1437);
	__webpack_require__(1438);
	__webpack_require__(1436);
	__webpack_require__(1428);
	__webpack_require__(1439);
	__webpack_require__(1443);
	__webpack_require__(1444);
	__webpack_require__(1396);
	__webpack_require__(1398);
	__webpack_require__(1397);
	__webpack_require__(1446);
	__webpack_require__(1445);
	__webpack_require__(1416);
	__webpack_require__(1426);
	__webpack_require__(1427);
	__webpack_require__(1417);
	__webpack_require__(1418);
	__webpack_require__(1419);
	__webpack_require__(1420);
	__webpack_require__(1421);
	__webpack_require__(1422);
	__webpack_require__(1423);
	__webpack_require__(1424);
	__webpack_require__(1425);
	__webpack_require__(1399);
	__webpack_require__(1400);
	__webpack_require__(1401);
	__webpack_require__(1402);
	__webpack_require__(1403);
	__webpack_require__(1404);
	__webpack_require__(1405);
	__webpack_require__(1406);
	__webpack_require__(1407);
	__webpack_require__(1408);
	__webpack_require__(1409);
	__webpack_require__(1410);
	__webpack_require__(1411);
	__webpack_require__(1412);
	__webpack_require__(1413);
	__webpack_require__(1414);
	__webpack_require__(1415);
	__webpack_require__(1477);
	__webpack_require__(1482);
	__webpack_require__(1489);
	__webpack_require__(1480);
	__webpack_require__(1472);
	__webpack_require__(1473);
	__webpack_require__(1478);
	__webpack_require__(1483);
	__webpack_require__(1485);
	__webpack_require__(1468);
	__webpack_require__(1469);
	__webpack_require__(1470);
	__webpack_require__(1471);
	__webpack_require__(1474);
	__webpack_require__(1475);
	__webpack_require__(1476);
	__webpack_require__(1479);
	__webpack_require__(1481);
	__webpack_require__(1484);
	__webpack_require__(1486);
	__webpack_require__(1487);
	__webpack_require__(1488);
	__webpack_require__(1391);
	__webpack_require__(1393);
	__webpack_require__(1392);
	__webpack_require__(1395);
	__webpack_require__(1394);
	__webpack_require__(1380);
	__webpack_require__(1378);
	__webpack_require__(1384);
	__webpack_require__(1381);
	__webpack_require__(1387);
	__webpack_require__(1389);
	__webpack_require__(1377);
	__webpack_require__(1383);
	__webpack_require__(1374);
	__webpack_require__(1388);
	__webpack_require__(1372);
	__webpack_require__(1386);
	__webpack_require__(1385);
	__webpack_require__(1379);
	__webpack_require__(1382);
	__webpack_require__(1371);
	__webpack_require__(1373);
	__webpack_require__(1376);
	__webpack_require__(1375);
	__webpack_require__(1390);
	__webpack_require__(729);
	__webpack_require__(1462);
	__webpack_require__(1119);
	__webpack_require__(1467);
	__webpack_require__(1120);
	__webpack_require__(1463);
	__webpack_require__(1464);
	__webpack_require__(1465);
	__webpack_require__(1466);
	__webpack_require__(1447);
	__webpack_require__(1118);
	__webpack_require__(1121);
	__webpack_require__(1122);
	__webpack_require__(1502);
	__webpack_require__(1491);
	__webpack_require__(1492);
	__webpack_require__(1497);
	__webpack_require__(1500);
	__webpack_require__(1501);
	__webpack_require__(1495);
	__webpack_require__(1498);
	__webpack_require__(1496);
	__webpack_require__(1499);
	__webpack_require__(1493);
	__webpack_require__(1494);
	__webpack_require__(1448);
	__webpack_require__(1449);
	__webpack_require__(1450);
	__webpack_require__(1451);
	__webpack_require__(1452);
	__webpack_require__(1455);
	__webpack_require__(1453);
	__webpack_require__(1454);
	__webpack_require__(1456);
	__webpack_require__(1457);
	__webpack_require__(1458);
	__webpack_require__(1459);
	__webpack_require__(1461);
	__webpack_require__(1460);
	__webpack_require__(1505);
	__webpack_require__(1503);
	__webpack_require__(1504);
	__webpack_require__(1546);
	__webpack_require__(1549);
	__webpack_require__(1548);
	__webpack_require__(1550);
	__webpack_require__(1551);
	__webpack_require__(1547);
	__webpack_require__(1552);
	__webpack_require__(1553);
	__webpack_require__(1527);
	__webpack_require__(1530);
	__webpack_require__(1526);
	__webpack_require__(1524);
	__webpack_require__(1525);
	__webpack_require__(1528);
	__webpack_require__(1529);
	__webpack_require__(1511);
	__webpack_require__(1545);
	__webpack_require__(1510);
	__webpack_require__(1544);
	__webpack_require__(1556);
	__webpack_require__(1558);
	__webpack_require__(1509);
	__webpack_require__(1543);
	__webpack_require__(1555);
	__webpack_require__(1557);
	__webpack_require__(1508);
	__webpack_require__(1554);
	__webpack_require__(1507);
	__webpack_require__(1512);
	__webpack_require__(1513);
	__webpack_require__(1514);
	__webpack_require__(1515);
	__webpack_require__(1516);
	__webpack_require__(1518);
	__webpack_require__(1517);
	__webpack_require__(1519);
	__webpack_require__(1520);
	__webpack_require__(1521);
	__webpack_require__(1523);
	__webpack_require__(1522);
	__webpack_require__(1532);
	__webpack_require__(1533);
	__webpack_require__(1534);
	__webpack_require__(1535);
	__webpack_require__(1537);
	__webpack_require__(1536);
	__webpack_require__(1539);
	__webpack_require__(1538);
	__webpack_require__(1540);
	__webpack_require__(1541);
	__webpack_require__(1542);
	__webpack_require__(1506);
	__webpack_require__(1531);
	__webpack_require__(1561);
	__webpack_require__(1560);
	__webpack_require__(1559);
	module.exports = __webpack_require__(45);


/***/ }),
/* 1563 */,
/* 1564 */,
/* 1565 */,
/* 1566 */,
/* 1567 */,
/* 1568 */,
/* 1569 */,
/* 1570 */,
/* 1571 */,
/* 1572 */,
/* 1573 */,
/* 1574 */,
/* 1575 */,
/* 1576 */,
/* 1577 */,
/* 1578 */,
/* 1579 */,
/* 1580 */,
/* 1581 */,
/* 1582 */,
/* 1583 */,
/* 1584 */,
/* 1585 */,
/* 1586 */,
/* 1587 */,
/* 1588 */,
/* 1589 */,
/* 1590 */,
/* 1591 */,
/* 1592 */,
/* 1593 */,
/* 1594 */,
/* 1595 */,
/* 1596 */,
/* 1597 */,
/* 1598 */,
/* 1599 */,
/* 1600 */,
/* 1601 */,
/* 1602 */,
/* 1603 */,
/* 1604 */,
/* 1605 */,
/* 1606 */,
/* 1607 */,
/* 1608 */,
/* 1609 */
/***/ (function(module, exports, __webpack_require__) {

	!function(t,e){if(true)module.exports=e();else if("function"==typeof define&&define.amd)define([],e);else{var n=e();for(var r in n)("object"==typeof exports?exports:t)[r]=n[r]}}(this,function(){return function(t){function e(r){if(n[r])return n[r].exports;var o=n[r]={exports:{},id:r,loaded:!1};return t[r].call(o.exports,o,o.exports,e),o.loaded=!0,o.exports}var n={};return e.m=t,e.c=n,e.p="",e(0)}([function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{"default":t}}n(84);var o=n(41),i=r(o),a=function(){i["default"].addPickerToOtherInputs(),i["default"].supportsDateInput()||i["default"].addPickerToDateInputs()};a(),document.addEventListener("DOMContentLoaded",function(){a()}),document.querySelector("body").addEventListener("mousedown",function(){a()})},function(t,e,n){t.exports=!n(11)(function(){return 7!=Object.defineProperty({},"a",{get:function(){return 7}}).a})},function(t,e){var n=t.exports="undefined"!=typeof window&&window.Math==Math?window:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")();"number"==typeof __g&&(__g=n)},function(t,e){var n={}.hasOwnProperty;t.exports=function(t,e){return n.call(t,e)}},function(t,e,n){var r=n(9),o=n(32),i=n(25),a=Object.defineProperty;e.f=n(1)?Object.defineProperty:function(t,e,n){if(r(t),e=i(e,!0),r(n),o)try{return a(t,e,n)}catch(u){}if("get"in n||"set"in n)throw TypeError("Accessors not supported!");return"value"in n&&(t[e]=n.value),t}},function(t,e,n){var r=n(59),o=n(16);t.exports=function(t){return r(o(t))}},function(t,e,n){var r=n(4),o=n(14);t.exports=n(1)?function(t,e,n){return r.f(t,e,o(1,n))}:function(t,e,n){return t[e]=n,t}},function(t,e,n){var r=n(23)("wks"),o=n(15),i=n(2).Symbol,a="function"==typeof i,u=t.exports=function(t){return r[t]||(r[t]=a&&i[t]||(a?i:o)("Symbol."+t))};u.store=r},function(t,e){var n=t.exports={version:"2.4.0"};"number"==typeof __e&&(__e=n)},function(t,e,n){var r=n(12);t.exports=function(t){if(!r(t))throw TypeError(t+" is not an object!");return t}},function(t,e,n){var r=n(2),o=n(8),i=n(56),a=n(6),u="prototype",s=function(t,e,n){var c,l,f,d=t&s.F,p=t&s.G,h=t&s.S,y=t&s.P,m=t&s.B,v=t&s.W,b=p?o:o[e]||(o[e]={}),g=b[u],x=p?r:h?r[e]:(r[e]||{})[u];p&&(n=e);for(c in n)l=!d&&x&&void 0!==x[c],l&&c in b||(f=l?x[c]:n[c],b[c]=p&&"function"!=typeof x[c]?n[c]:m&&l?i(f,r):v&&x[c]==f?function(t){var e=function(e,n,r){if(this instanceof t){switch(arguments.length){case 0:return new t;case 1:return new t(e);case 2:return new t(e,n)}return new t(e,n,r)}return t.apply(this,arguments)};return e[u]=t[u],e}(f):y&&"function"==typeof f?i(Function.call,f):f,y&&((b.virtual||(b.virtual={}))[c]=f,t&s.R&&g&&!g[c]&&a(g,c,f)))};s.F=1,s.G=2,s.S=4,s.P=8,s.B=16,s.W=32,s.U=64,s.R=128,t.exports=s},function(t,e){t.exports=function(t){try{return!!t()}catch(e){return!0}}},function(t,e){t.exports=function(t){return"object"==typeof t?null!==t:"function"==typeof t}},function(t,e,n){var r=n(38),o=n(17);t.exports=Object.keys||function(t){return r(t,o)}},function(t,e){t.exports=function(t,e){return{enumerable:!(1&t),configurable:!(2&t),writable:!(4&t),value:e}}},function(t,e){var n=0,r=Math.random();t.exports=function(t){return"Symbol(".concat(void 0===t?"":t,")_",(++n+r).toString(36))}},function(t,e){t.exports=function(t){if(void 0==t)throw TypeError("Can't call method on  "+t);return t}},function(t,e){t.exports="constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(",")},function(t,e){t.exports={}},function(t,e){t.exports=!0},function(t,e){e.f={}.propertyIsEnumerable},function(t,e,n){var r=n(4).f,o=n(3),i=n(7)("toStringTag");t.exports=function(t,e,n){t&&!o(t=n?t:t.prototype,i)&&r(t,i,{configurable:!0,value:e})}},function(t,e,n){var r=n(23)("keys"),o=n(15);t.exports=function(t){return r[t]||(r[t]=o(t))}},function(t,e,n){var r=n(2),o="__core-js_shared__",i=r[o]||(r[o]={});t.exports=function(t){return i[t]||(i[t]={})}},function(t,e){var n=Math.ceil,r=Math.floor;t.exports=function(t){return isNaN(t=+t)?0:(t>0?r:n)(t)}},function(t,e,n){var r=n(12);t.exports=function(t,e){if(!r(t))return t;var n,o;if(e&&"function"==typeof(n=t.toString)&&!r(o=n.call(t)))return o;if("function"==typeof(n=t.valueOf)&&!r(o=n.call(t)))return o;if(!e&&"function"==typeof(n=t.toString)&&!r(o=n.call(t)))return o;throw TypeError("Can't convert object to primitive value")}},function(t,e,n){var r=n(2),o=n(8),i=n(19),a=n(27),u=n(4).f;t.exports=function(t){var e=o.Symbol||(o.Symbol=i?{}:r.Symbol||{});"_"==t.charAt(0)||t in e||u(e,t,{value:a.f(t)})}},function(t,e,n){e.f=n(7)},function(t,e){"use strict";e.__esModule=!0,e["default"]=function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{"default":t}}e.__esModule=!0;var o=n(45),i=r(o);e["default"]=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),(0,i["default"])(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}()},function(t,e){var n={}.toString;t.exports=function(t){return n.call(t).slice(8,-1)}},function(t,e,n){var r=n(12),o=n(2).document,i=r(o)&&r(o.createElement);t.exports=function(t){return i?o.createElement(t):{}}},function(t,e,n){t.exports=!n(1)&&!n(11)(function(){return 7!=Object.defineProperty(n(31)("div"),"a",{get:function(){return 7}}).a})},function(t,e,n){"use strict";var r=n(19),o=n(10),i=n(39),a=n(6),u=n(3),s=n(18),c=n(61),l=n(21),f=n(67),d=n(7)("iterator"),p=!([].keys&&"next"in[].keys()),h="@@iterator",y="keys",m="values",v=function(){return this};t.exports=function(t,e,n,b,g,x,M){c(n,e,b);var w,S,O,D=function(t){if(!p&&t in k)return k[t];switch(t){case y:return function(){return new n(this,t)};case m:return function(){return new n(this,t)}}return function(){return new n(this,t)}},T=e+" Iterator",_=g==m,A=!1,k=t.prototype,E=k[d]||k[h]||g&&k[g],j=E||D(g),C=g?_?D("entries"):j:void 0,N="Array"==e?k.entries||E:E;if(N&&(O=f(N.call(new t)),O!==Object.prototype&&(l(O,T,!0),r||u(O,d)||a(O,d,v))),_&&E&&E.name!==m&&(A=!0,j=function(){return E.call(this)}),r&&!M||!p&&!A&&k[d]||a(k,d,j),s[e]=j,s[T]=v,g)if(w={values:_?j:D(m),keys:x?j:D(y),entries:C},M)for(S in w)S in k||i(k,S,w[S]);else o(o.P+o.F*(p||A),e,w);return w}},function(t,e,n){var r=n(9),o=n(35),i=n(17),a=n(22)("IE_PROTO"),u=function(){},s="prototype",c=function(){var t,e=n(31)("iframe"),r=i.length,o="<",a=">";for(e.style.display="none",n(58).appendChild(e),e.src="javascript:",t=e.contentWindow.document,t.open(),t.write(o+"script"+a+"document.F=Object"+o+"/script"+a),t.close(),c=t.F;r--;)delete c[s][i[r]];return c()};t.exports=Object.create||function(t,e){var n;return null!==t?(u[s]=r(t),n=new u,u[s]=null,n[a]=t):n=c(),void 0===e?n:o(n,e)}},function(t,e,n){var r=n(4),o=n(9),i=n(13);t.exports=n(1)?Object.defineProperties:function(t,e){o(t);for(var n,a=i(e),u=a.length,s=0;u>s;)r.f(t,n=a[s++],e[n]);return t}},function(t,e,n){var r=n(38),o=n(17).concat("length","prototype");e.f=Object.getOwnPropertyNames||function(t){return r(t,o)}},function(t,e){e.f=Object.getOwnPropertySymbols},function(t,e,n){var r=n(3),o=n(5),i=n(55)(!1),a=n(22)("IE_PROTO");t.exports=function(t,e){var n,u=o(t),s=0,c=[];for(n in u)n!=a&&r(u,n)&&c.push(n);for(;e.length>s;)r(u,n=e[s++])&&(~i(c,n)||c.push(n));return c}},function(t,e,n){t.exports=n(6)},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{"default":t}}function o(t,e){for(t=String(t),e=e||2;t.length<e;)t="0"+t;return t}function i(t){var e=new Date(t.getFullYear(),t.getMonth(),t.getDate());e.setDate(e.getDate()-(e.getDay()+6)%7+3);var n=new Date(e.getFullYear(),0,4);n.setDate(n.getDate()-(n.getDay()+6)%7+3);var r=e.getTimezoneOffset()-n.getTimezoneOffset();e.setHours(e.getHours()-r);var o=(e-n)/6048e5;return 1+Math.floor(o)}function a(t){var e=t.getDay();return 0===e&&(e=7),e}function u(t){return null===t?"null":void 0===t?"undefined":"object"!==("undefined"==typeof t?"undefined":(0,c["default"])(t))?"undefined"==typeof t?"undefined":(0,c["default"])(t):Array.isArray(t)?"array":{}.toString.call(t).slice(8,-1).toLowerCase()}Object.defineProperty(e,"__esModule",{value:!0});var s=n(48),c=r(s),l=function(){var t=/d{1,4}|m{1,4}|yy(?:yy)?|([HhMsTt])\1?|[LloSZWN]|'[^']*'|'[^']*'/g,e=/\b(?:[PMCEA][SDP]T|(?:Pacific|Mountain|Central|Eastern|Atlantic) (?:Standard|Daylight|Prevailing) Time|(?:GMT|UTC)(?:[-+]\d{4})?)\b/g,n=/[^-+\dA-Z]/g;return function(r,s,c,f){if(1!==arguments.length||"string"!==u(r)||/\d/.test(r)||(s=r,r=void 0),r=r||new Date,r instanceof Date||(r=new Date(r)),isNaN(r))throw TypeError("Invalid date");s=String(l.masks[s]||s||l.masks["default"]);var d=s.slice(0,4);"UTC:"!==d&&"GMT:"!==d||(s=s.slice(4),c=!0,"GMT:"===d&&(f=!0));var p=c?"getUTC":"get",h=r[p+"Date"](),y=r[p+"Day"](),m=r[p+"Month"](),v=r[p+"FullYear"](),b=r[p+"Hours"](),g=r[p+"Minutes"](),x=r[p+"Seconds"](),M=r[p+"Milliseconds"](),w=c?0:r.getTimezoneOffset(),S=i(r),O=a(r),D={d:h,dd:o(h),ddd:l.i18n.dayNames[y],dddd:l.i18n.dayNames[y+7],m:m+1,mm:o(m+1),mmm:l.i18n.monthNames[m],mmmm:l.i18n.monthNames[m+12],yy:String(v).slice(2),yyyy:v,h:b%12||12,hh:o(b%12||12),H:b,HH:o(b),M:g,MM:o(g),s:x,ss:o(x),l:o(M,3),L:o(Math.round(M/10)),t:b<12?"a":"p",tt:b<12?"am":"pm",T:b<12?"A":"P",TT:b<12?"AM":"PM",Z:f?"GMT":c?"UTC":(String(r).match(e)||[""]).pop().replace(n,""),o:(w>0?"-":"+")+o(100*Math.floor(Math.abs(w)/60)+Math.abs(w)%60,4),S:["th","st","nd","rd"][h%10>3?0:(h%100-h%10!=10)*h%10],W:S,N:O};return s.replace(t,function(t){return t in D?D[t]:t.slice(1,t.length-1)})}}();l.masks={"default":"ddd mmm dd yyyy HH:MM:ss",shortDate:"m/d/yy",mediumDate:"mmm d, yyyy",longDate:"mmmm d, yyyy",fullDate:"dddd, mmmm d, yyyy",shortTime:"h:MM TT",mediumTime:"h:MM:ss TT",longTime:"h:MM:ss TT Z",isoDate:"yyyy-mm-dd",isoTime:"HH:MM:ss",isoDateTime:"yyyy-mm-dd'T'HH:MM:sso",isoUtcDateTime:"UTC:yyyy-mm-dd'T'HH:MM:ss'Z'",expiresHeaderFormat:"ddd, dd mmm yyyy HH:MM:ss Z"},l.i18n={dayNames:["Sun","Mon","Tue","Wed","Thu","Fri","Sat","Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],monthNames:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec","January","February","March","April","May","June","July","August","September","October","November","December"]},e["default"]=l},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{"default":t}}Object.defineProperty(e,"__esModule",{value:!0});var o=n(44),i=r(o),a=n(28),u=r(a),s=n(29),c=r(s),l=n(43),f=r(l),d=n(42),p=r(d),h=n(40),y=r(h),m=function(){function t(e){var n=this;(0,u["default"])(this,t),this.element=e,this.element.setAttribute("data-has-picker",""),this.locale=this.element.getAttribute("lang")||document.body.getAttribute("lang")||"en",this.format=this.element.getAttribute("date-format")||document.body.getAttribute("date-format")||this.element.getAttribute("data-date-format")||document.body.getAttribute("data-date-format")||"yyyy-mm-dd",this.localeText=this.getLocaleText(),(0,i["default"])(this.element,{valueAsDate:{get:function(){if(!n.element.value)return null;var t=n.format||"yyyy-mm-dd",e=n.element.value.match(/(\d+)/g),r=0,o={};return t.replace(/(yyyy|dd|mm)/g,function(t){o[t]=r++}),new Date(e[o.yyyy],e[o.mm]-1,e[o.dd])},set:function(t){n.element.value=(0,y["default"])(t,n.format)}},valueAsNumber:{get:function(){return n.element.value?n.element.valueAsDate.valueOf():NaN},set:function(t){n.element.valueAsDate=new Date(t)}}});var r=function(t){var e=n.element;e.locale=n.localeText,f["default"].attachTo(e)};this.element.addEventListener("focus",r),this.element.addEventListener("mouseup",r),this.element.addEventListener("keydown",function(t){var e=new Date;switch(t.keyCode){case 9:case 27:f["default"].hide();break;case 38:n.element.valueAsDate&&(e.setDate(n.element.valueAsDate.getDate()+1),n.element.valueAsDate=e,f["default"].pingInput());break;case 40:n.element.valueAsDate&&(e.setDate(n.element.valueAsDate.getDate()-1),n.element.valueAsDate=e,f["default"].pingInput())}f["default"].sync()}),this.element.addEventListener("keyup",function(t){f["default"].sync()})}return(0,c["default"])(t,[{key:"getLocaleText",value:function(){var t=this.locale.toLowerCase();for(var e in p["default"]){var n=e.split("_");if(n.map(function(t){return t.toLowerCase()}),~n.indexOf(t)||~n.indexOf(t.substr(0,2)))return p["default"][e]}}}],[{key:"supportsDateInput",value:function(){var t=document.createElement("input");t.setAttribute("type","date");var e="not-a-date";return t.setAttribute("value",e),!(t.value===e)}},{key:"addPickerToDateInputs",value:function(){var e=document.querySelectorAll('input[type="date"]:not([data-has-picker])'),n=e.length;if(!n)return!1;for(var r=0;r<n;++r)new t(e[r])}},{key:"addPickerToOtherInputs",value:function(){var e=document.querySelectorAll('input[type="text"].date-polyfill:not([data-has-picker])'),n=e.length;if(!n)return!1;for(var r=0;r<n;++r)new t(e[r])}}]),t}();e["default"]=m},function(t,e){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var n={"en_en-US_en-UK":{days:["Su","Mo","Tu","We","Th","Fr","Sa"],months:["January","February","March","April","May","June","July","August","September","October","November","December"]},"zh_zh-CN":{days:["星期天","星期一","星期二","星期三","星期四","星期五","星期六"],months:["一月","二月","三月","四月","五月","六月","七月","八月","九月","十月","十一月","十二月"]},"zh-Hans_zh-Hans-CN":{days:["周日","周一","周二","周三","周四","周五","周六"],months:["一月","二月","三月","四月","五月","六月","七月","八月","九月","十月","十一月","十二月"]},"zh-Hant_zh-Hant-TW":{days:["週日","週一","週二","週三","週四","週五","週六"],months:["一月","二月","三月","四月","五月","六月","七月","八月","九月","十月","十一月","十二月"]},"de_de-DE":{days:["Sonntag","Montag","Dienstag","Mittwoch","Donnerstag","Freitag","Samstag"],months:["Januar","Februar","März","April","Mai","Juni","Juli","August","September","Oktober","November","Dezember"]},"nl_nl-NL_nl-BE":{days:["Zondag","Maandag","Dinsdag","Woensdag","Donderdag","Vrijdag","Zaterdag"],months:["Januari","Februari","Maart","April","Mei","Juni","Juli","Augustus","September","Oktober","November","December"],today:"Vandaag",format:"D/M/Y"},"pt_pt-BR":{days:["Dom","Seg","Ter","Qua","Qui","Sex","Sáb"],months:["Janeiro","Fevereiro","Março","Abril","Maio","Junho","Julho","Agosto","Setembro","Outubro","Novembro","Dezembro"],today:"Hoje"},"fr_fr-FR_fr-BE":{days:["Di","Lu","Ma","Me","Je","Ve","Sa"],months:["Janvier","Février","Mars","Avril","Mai","Juin","Juillet","Août","Septembre","Octobre","Novembre","Décembre"],today:"Aujourd'hui",format:"D/M/Y"},"es_es-VE":{days:["Do","Lu","Ma","Mi","Ju","Vi","Sa"],months:["Enero","Febrero","Marzo","Abril","Mayo","Junio","Julio","Agosto","Septiembre","Octubre","Noviembre","Diciembre"],today:"Hoy",format:"D/M/Y"},"da_da-dk":{days:["Søndag","Mandag","Tirsdag","Onsdag","Torsdag","Fredag","Lørdag"],months:["Januar","Februar","Marts","April","Maj","Juni","Juli","August","September","Oktober","November","December"],today:"I dag",format:"dd/MM-YYYY"},"ru_ru-RU_ru-UA_ru-KZ_ru-MD":{days:["Вс","Пн","Вт","Ср","Чт","Пт","Сб"],months:["Январь","Февраль","Март","Апрель","Май","Июнь","Июль","Август","Сентябрь","Октябрь","Ноябрь","Декабрь"],today:"Сегодня",format:"D.M.Y"},"uk_uk-UA":{days:["Нд","Пн","Вт","Ср","Чт","Пт","Сб"],months:["Січень","Лютий","Березень","Квітень","Травень","Червень","Липень","Серпень","Вересень","Жовтень","Листопад","Грудень"],today:"Cьогодні",format:"D.M.Y"},"sv_sv-SE":{days:["Söndag","Måndag","Tisdag","Onsdag","Torsdag","Fredag","Lördag"],months:["Januari","Februari","Mars","April","Maj","Juni","Juli","Augusti","September","Oktober","November","December"],today:"Idag",format:"YYYY-MM-dd"},"test_test-TEST":{days:["Foo","Mon","Tue","Wed","Thu","Fri","Sat"],months:["Foo","February","March","April","May","June","July","August","September","October","November","December"]},ja:{days:["日","月","火","水","木","金","土"],months:["一月","二月","三月","四月","五月","六月","七月","八月","九月","十月","十一月","十二月"],today:"今日",format:"YYYY-MM-dd"}};e["default"]=n},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{"default":t}}Object.defineProperty(e,"__esModule",{value:!0});var o=n(28),i=r(o),a=n(29),u=r(a),s=function(){function t(){var e=this;if((0,i["default"])(this,t),window.thePicker)return window.thePicker;this.date=new Date,this.input=null,this.isOpen=!1,this.container=document.createElement("date-input-polyfill"),this.year=document.createElement("select"),t.createRangeSelect(this.year,1890,this.date.getFullYear()+20),this.year.className="yearSelect",this.year.addEventListener("change",function(){e.date.setYear(e.year.value),e.refreshDaysMatrix()});var n=document.createElement("span");n.className="yearSelect-wrapper",n.appendChild(this.year),this.container.appendChild(n),this.month=document.createElement("select"),this.month.className="monthSelect",this.month.addEventListener("change",function(){e.date.setMonth(e.month.value),e.refreshDaysMatrix()});var r=document.createElement("span");r.className="monthSelect-wrapper",r.appendChild(this.month),this.container.appendChild(r),this.today=document.createElement("button"),this.today.textContent="Today",this.today.addEventListener("click",function(){var t=new Date;e.date=new Date(t.getFullYear()+"/"+("0"+(t.getMonth()+1)).slice(-2)+"/"+("0"+t.getDate()).slice(-2)),e.setInput()}),this.container.appendChild(this.today);var o=document.createElement("table");this.daysHead=document.createElement("thead"),this.days=document.createElement("tbody"),this.days.addEventListener("click",function(t){var n=t.target;if(!n.hasAttribute("data-day"))return!1;var r=e.days.querySelector("[data-selected]");r&&r.removeAttribute("data-selected"),n.setAttribute("data-selected",""),e.date.setDate(parseInt(n.textContent)),e.setInput()}),o.appendChild(this.daysHead),o.appendChild(this.days),this.container.appendChild(o),this.hide(),document.body.appendChild(this.container),this.removeClickOut=function(t){if(e.isOpen){for(var n=t.target,r=n===e.container||n===e.input;!r&&(n=n.parentNode);)r=n===e.container;("date"!==t.target.getAttribute("type")&&!r||!r)&&e.hide()}},this.removeBlur=function(t){e.isOpen&&e.hide()}}return(0,u["default"])(t,[{key:"hide",value:function(){this.container.setAttribute("data-open",this.isOpen=!1),this.input&&this.input.blur(),document.removeEventListener("mousedown",this.removeClickOut),document.removeEventListener("touchstart",this.removeClickOut)}},{key:"show",value:function(){var t=this;this.container.setAttribute("data-open",this.isOpen=!0),setTimeout(function(){document.addEventListener("mousedown",t.removeClickOut),document.addEventListener("touchstart",t.removeClickOut)},500),window.onpopstate=function(){t.hide()}}},{key:"goto",value:function(t){var e=this,n=t.getBoundingClientRect();this.container.style.top=n.top+n.height+(document.documentElement.scrollTop||document.body.scrollTop)+3+"px";var r=this.container.getBoundingClientRect(),o=r.width?r.width:280,i=function(){return e.container.className.replace("polyfill-left-aligned","").replace("polyfill-right-aligned","").replace(/\s+/g," ").trim()},a=n.right-o;n.right<o?(a=n.left,this.container.className=i()+" polyfill-left-aligned"):this.container.className=i()+" polyfill-right-aligned",this.container.style.left=a+(document.documentElement.scrollLeft||document.body.scrollLeft)+"px",this.show()}},{key:"attachTo",value:function(t){return!(t===this.input&&this.isOpen||(this.input=t,this.refreshLocale(),this.sync(),this["goto"](this.input),0))}},{key:"sync",value:function(){isNaN(Date.parse(this.input.valueAsDate))?this.date=new Date:this.date=t.absoluteDate(this.input.valueAsDate),this.year.value=this.date.getFullYear(),this.month.value=this.date.getMonth(),this.refreshDaysMatrix()}},{key:"setInput",value:function(){var t=this;this.input.valueAsDate=this.date,this.input.focus(),setTimeout(function(){t.hide()},100),this.pingInput()}},{key:"refreshLocale",value:function(){if(this.locale===this.input.locale)return!1;this.locale=this.input.locale,this.today.textContent=this.locale.today||"Today";for(var e=["<tr>"],n=0,r=this.locale.days.length;n<r;++n)e.push('<th scope="col">'+this.locale.days[n]+"</th>");this.daysHead.innerHTML=e.join(""),t.createRangeSelect(this.month,0,11,this.locale.months)}},{key:"refreshDaysMatrix",value:function(){this.refreshLocale();for(var e=this.date.getFullYear(),n=this.date.getMonth(),r=new Date(e,n,1).getDay(),o=new Date(this.date.getFullYear(),n+1,0).getDate(),i=t.absoluteDate(this.input.valueAsDate)||!1,a=i&&e===i.getFullYear()&&n===i.getMonth(),u=[],s=0;s<o+r;++s)if(s%7===0&&u.push("\n          "+(0!==s?"</tr>":"")+"\n          <tr>\n        "),s+1<=r)u.push("<td></td>");else{var c=s+1-r,l=a&&i.getDate()===c;u.push("<td data-day "+(l?"data-selected":"")+">\n          "+c+"\n        </td>")}this.days.innerHTML=u.join("")}},{key:"pingInput",value:function(){var t=void 0,e=void 0;try{t=new Event("input"),e=new Event("change")}catch(n){t=document.createEvent("KeyboardEvent"),t.initEvent("input",!0,!1),e=document.createEvent("KeyboardEvent"),e.initEvent("change",!0,!1)}this.input.dispatchEvent(t),this.input.dispatchEvent(e)}}],[{key:"createRangeSelect",value:function(t,e,n,r){t.innerHTML="";for(var o=e;o<=n;++o){var i=document.createElement("option");t.appendChild(i);var a=r?r[o-e]:o;i.text=a,i.value=o}return t}},{key:"absoluteDate",value:function(t){return t&&new Date(t.getTime()+60*t.getTimezoneOffset()*1e3)}}]),t}();window.thePicker=new s,e["default"]=window.thePicker},function(t,e,n){t.exports={"default":n(49),__esModule:!0}},function(t,e,n){t.exports={"default":n(50),__esModule:!0}},function(t,e,n){t.exports={"default":n(51),__esModule:!0}},function(t,e,n){t.exports={"default":n(52),__esModule:!0}},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{"default":t}}e.__esModule=!0;var o=n(47),i=r(o),a=n(46),u=r(a),s="function"==typeof u["default"]&&"symbol"==typeof i["default"]?function(t){return typeof t}:function(t){return t&&"function"==typeof u["default"]&&t.constructor===u["default"]?"symbol":typeof t};e["default"]="function"==typeof u["default"]&&"symbol"===s(i["default"])?function(t){return"undefined"==typeof t?"undefined":s(t)}:function(t){return t&&"function"==typeof u["default"]&&t.constructor===u["default"]?"symbol":"undefined"==typeof t?"undefined":s(t)}},function(t,e,n){n(73);var r=n(8).Object;t.exports=function(t,e){return r.defineProperties(t,e)}},function(t,e,n){n(74);var r=n(8).Object;t.exports=function(t,e,n){return r.defineProperty(t,e,n)}},function(t,e,n){n(77),n(75),n(78),n(79),t.exports=n(8).Symbol},function(t,e,n){n(76),n(80),t.exports=n(27).f("iterator")},function(t,e){t.exports=function(t){if("function"!=typeof t)throw TypeError(t+" is not a function!");return t}},function(t,e){t.exports=function(){}},function(t,e,n){var r=n(5),o=n(70),i=n(69);t.exports=function(t){return function(e,n,a){var u,s=r(e),c=o(s.length),l=i(a,c);if(t&&n!=n){for(;c>l;)if(u=s[l++],u!=u)return!0}else for(;c>l;l++)if((t||l in s)&&s[l]===n)return t||l||0;return!t&&-1}}},function(t,e,n){var r=n(53);t.exports=function(t,e,n){if(r(t),void 0===e)return t;switch(n){case 1:return function(n){return t.call(e,n)};case 2:return function(n,r){return t.call(e,n,r)};case 3:return function(n,r,o){return t.call(e,n,r,o)}}return function(){return t.apply(e,arguments)}}},function(t,e,n){var r=n(13),o=n(37),i=n(20);t.exports=function(t){var e=r(t),n=o.f;if(n)for(var a,u=n(t),s=i.f,c=0;u.length>c;)s.call(t,a=u[c++])&&e.push(a);return e}},function(t,e,n){t.exports=n(2).document&&document.documentElement},function(t,e,n){var r=n(30);t.exports=Object("z").propertyIsEnumerable(0)?Object:function(t){return"String"==r(t)?t.split(""):Object(t)}},function(t,e,n){var r=n(30);t.exports=Array.isArray||function(t){return"Array"==r(t)}},function(t,e,n){"use strict";var r=n(34),o=n(14),i=n(21),a={};n(6)(a,n(7)("iterator"),function(){return this}),t.exports=function(t,e,n){t.prototype=r(a,{next:o(1,n)}),i(t,e+" Iterator")}},function(t,e){t.exports=function(t,e){return{value:e,done:!!t}}},function(t,e,n){var r=n(13),o=n(5);t.exports=function(t,e){for(var n,i=o(t),a=r(i),u=a.length,s=0;u>s;)if(i[n=a[s++]]===e)return n}},function(t,e,n){var r=n(15)("meta"),o=n(12),i=n(3),a=n(4).f,u=0,s=Object.isExtensible||function(){return!0},c=!n(11)(function(){return s(Object.preventExtensions({}))}),l=function(t){a(t,r,{value:{i:"O"+ ++u,w:{}}})},f=function(t,e){if(!o(t))return"symbol"==typeof t?t:("string"==typeof t?"S":"P")+t;if(!i(t,r)){if(!s(t))return"F";if(!e)return"E";l(t)}return t[r].i},d=function(t,e){if(!i(t,r)){if(!s(t))return!0;if(!e)return!1;l(t)}return t[r].w},p=function(t){return c&&h.NEED&&s(t)&&!i(t,r)&&l(t),t},h=t.exports={KEY:r,NEED:!1,fastKey:f,getWeak:d,onFreeze:p}},function(t,e,n){var r=n(20),o=n(14),i=n(5),a=n(25),u=n(3),s=n(32),c=Object.getOwnPropertyDescriptor;e.f=n(1)?c:function(t,e){if(t=i(t),e=a(e,!0),s)try{return c(t,e)}catch(n){}if(u(t,e))return o(!r.f.call(t,e),t[e])}},function(t,e,n){var r=n(5),o=n(36).f,i={}.toString,a="object"==typeof window&&window&&Object.getOwnPropertyNames?Object.getOwnPropertyNames(window):[],u=function(t){try{return o(t)}catch(e){return a.slice()}};t.exports.f=function(t){return a&&"[object Window]"==i.call(t)?u(t):o(r(t))}},function(t,e,n){var r=n(3),o=n(71),i=n(22)("IE_PROTO"),a=Object.prototype;t.exports=Object.getPrototypeOf||function(t){return t=o(t),r(t,i)?t[i]:"function"==typeof t.constructor&&t instanceof t.constructor?t.constructor.prototype:t instanceof Object?a:null}},function(t,e,n){var r=n(24),o=n(16);t.exports=function(t){return function(e,n){var i,a,u=String(o(e)),s=r(n),c=u.length;return s<0||s>=c?t?"":void 0:(i=u.charCodeAt(s),i<55296||i>56319||s+1===c||(a=u.charCodeAt(s+1))<56320||a>57343?t?u.charAt(s):i:t?u.slice(s,s+2):(i-55296<<10)+(a-56320)+65536)}}},function(t,e,n){var r=n(24),o=Math.max,i=Math.min;t.exports=function(t,e){return t=r(t),t<0?o(t+e,0):i(t,e)}},function(t,e,n){var r=n(24),o=Math.min;t.exports=function(t){return t>0?o(r(t),9007199254740991):0}},function(t,e,n){var r=n(16);t.exports=function(t){return Object(r(t))}},function(t,e,n){"use strict";var r=n(54),o=n(62),i=n(18),a=n(5);t.exports=n(33)(Array,"Array",function(t,e){this._t=a(t),this._i=0,this._k=e},function(){var t=this._t,e=this._k,n=this._i++;return!t||n>=t.length?(this._t=void 0,o(1)):"keys"==e?o(0,n):"values"==e?o(0,t[n]):o(0,[n,t[n]])},"values"),i.Arguments=i.Array,r("keys"),r("values"),r("entries")},function(t,e,n){var r=n(10);r(r.S+r.F*!n(1),"Object",{defineProperties:n(35)})},function(t,e,n){var r=n(10);r(r.S+r.F*!n(1),"Object",{defineProperty:n(4).f})},function(t,e){},function(t,e,n){"use strict";var r=n(68)(!0);n(33)(String,"String",function(t){this._t=String(t),this._i=0},function(){var t,e=this._t,n=this._i;return n>=e.length?{value:void 0,done:!0}:(t=r(e,n),this._i+=t.length,{value:t,done:!1})})},function(t,e,n){"use strict";var r=n(2),o=n(3),i=n(1),a=n(10),u=n(39),s=n(64).KEY,c=n(11),l=n(23),f=n(21),d=n(15),p=n(7),h=n(27),y=n(26),m=n(63),v=n(57),b=n(60),g=n(9),x=n(5),M=n(25),w=n(14),S=n(34),O=n(66),D=n(65),T=n(4),_=n(13),A=D.f,k=T.f,E=O.f,j=r.Symbol,C=r.JSON,N=C&&C.stringify,L="prototype",P=p("_hidden"),F=p("toPrimitive"),J={}.propertyIsEnumerable,H=l("symbol-registry"),I=l("symbols"),Y=l("op-symbols"),R=Object[L],z="function"==typeof j,U=r.QObject,B=!U||!U[L]||!U[L].findChild,W=i&&c(function(){return 7!=S(k({},"a",{get:function(){return k(this,"a",{value:7}).a}})).a})?function(t,e,n){var r=A(R,e);r&&delete R[e],k(t,e,n),r&&t!==R&&k(R,e,r)}:k,Z=function(t){var e=I[t]=S(j[L]);return e._k=t,e},G=z&&"symbol"==typeof j.iterator?function(t){return"symbol"==typeof t}:function(t){return t instanceof j},K=function(t,e,n){return t===R&&K(Y,e,n),g(t),e=M(e,!0),g(n),o(I,e)?(n.enumerable?(o(t,P)&&t[P][e]&&(t[P][e]=!1),n=S(n,{enumerable:w(0,!1)})):(o(t,P)||k(t,P,w(1,{})),t[P][e]=!0),W(t,e,n)):k(t,e,n)},V=function(t,e){g(t);for(var n,r=v(e=x(e)),o=0,i=r.length;i>o;)K(t,n=r[o++],e[n]);return t},q=function(t,e){return void 0===e?S(t):V(S(t),e)},Q=function(t){var e=J.call(this,t=M(t,!0));return!(this===R&&o(I,t)&&!o(Y,t))&&(!(e||!o(this,t)||!o(I,t)||o(this,P)&&this[P][t])||e)},X=function(t,e){if(t=x(t),e=M(e,!0),t!==R||!o(I,e)||o(Y,e)){var n=A(t,e);return!n||!o(I,e)||o(t,P)&&t[P][e]||(n.enumerable=!0),n}},$=function(t){for(var e,n=E(x(t)),r=[],i=0;n.length>i;)o(I,e=n[i++])||e==P||e==s||r.push(e);return r},tt=function(t){for(var e,n=t===R,r=E(n?Y:x(t)),i=[],a=0;r.length>a;)!o(I,e=r[a++])||n&&!o(R,e)||i.push(I[e]);return i};z||(j=function(){if(this instanceof j)throw TypeError("Symbol is not a constructor!");var t=d(arguments.length>0?arguments[0]:void 0),e=function(n){this===R&&e.call(Y,n),o(this,P)&&o(this[P],t)&&(this[P][t]=!1),W(this,t,w(1,n))};return i&&B&&W(R,t,{configurable:!0,set:e}),Z(t)},u(j[L],"toString",function(){return this._k}),D.f=X,T.f=K,n(36).f=O.f=$,n(20).f=Q,n(37).f=tt,i&&!n(19)&&u(R,"propertyIsEnumerable",Q,!0),h.f=function(t){return Z(p(t))}),a(a.G+a.W+a.F*!z,{Symbol:j});for(var et="hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables".split(","),nt=0;et.length>nt;)p(et[nt++]);for(var et=_(p.store),nt=0;et.length>nt;)y(et[nt++]);a(a.S+a.F*!z,"Symbol",{"for":function(t){return o(H,t+="")?H[t]:H[t]=j(t)},keyFor:function(t){if(G(t))return m(H,t);throw TypeError(t+" is not a symbol!")},useSetter:function(){B=!0},useSimple:function(){B=!1}}),a(a.S+a.F*!z,"Object",{create:q,defineProperty:K,defineProperties:V,getOwnPropertyDescriptor:X,getOwnPropertyNames:$,getOwnPropertySymbols:tt}),C&&a(a.S+a.F*(!z||c(function(){var t=j();return"[null]"!=N([t])||"{}"!=N({a:t})||"{}"!=N(Object(t))})),"JSON",{stringify:function(t){if(void 0!==t&&!G(t)){for(var e,n,r=[t],o=1;arguments.length>o;)r.push(arguments[o++]);return e=r[1],"function"==typeof e&&(n=e),!n&&b(e)||(e=function(t,e){if(n&&(e=n.call(this,t,e)),!G(e))return e}),r[1]=e,N.apply(C,r)}}}),j[L][F]||n(6)(j[L],F,j[L].valueOf),f(j,"Symbol"),f(Math,"Math",!0),f(r.JSON,"JSON",!0)},function(t,e,n){n(26)("asyncIterator")},function(t,e,n){n(26)("observable")},function(t,e,n){n(72);for(var r=n(2),o=n(6),i=n(18),a=n(7)("toStringTag"),u=["NodeList","DOMTokenList","MediaList","StyleSheetList","CSSRuleList"],s=0;s<5;s++){var c=u[s],l=r[c],f=l&&l.prototype;f&&!f[a]&&o(f,a,c),i[c]=i.Array}},function(t,e,n){e=t.exports=n(82)(),e.push([t.id,"date-input-polyfill{background:#fff;color:#000;text-shadow:none;border:0;padding:0;height:auto;width:auto;line-height:normal;font-family:sans-serif;font-size:14px;position:absolute!important;text-align:center;box-shadow:0 3px 10px 1px rgba(0,0,0,.22);cursor:default;z-index:1;border-radius:5px;-moz-border-radius:5px;-webkit-border-radius:5px;overflow:hidden;display:block}date-input-polyfill[data-open=false]{visibility:hidden;z-index:-100!important;top:0}date-input-polyfill[data-open=true]{visibility:visible}date-input-polyfill select,date-input-polyfill table,date-input-polyfill td,date-input-polyfill th{background:#fff;color:#000;text-shadow:none;border:0;padding:0;height:auto;width:auto;line-height:normal;font-family:sans-serif;font-size:14px;box-shadow:none;font-family:Lato,Helvetica,Arial,sans-serif}date-input-polyfill button,date-input-polyfill select{border:0;border-radius:0;border-bottom:1px solid #dadfe1;height:24px;vertical-align:top;-webkit-appearance:none;-moz-appearance:none}date-input-polyfill .monthSelect-wrapper{width:55%;display:inline-block}date-input-polyfill .yearSelect-wrapper{width:25%;display:inline-block}date-input-polyfill select{width:100%}date-input-polyfill select:first-of-type{border-right:1px solid #dadfe1;border-radius:5px 0 0 0;-moz-border-radius:5px 0 0 0;-webkit-border-radius:5px 0 0 0}date-input-polyfill button{width:20%;background:#dadfe1;border-radius:0 5px 0 0;-moz-border-radius:0 5px 0 0;-webkit-border-radius:0 5px 0 0}date-input-polyfill button:hover{background:#eee}date-input-polyfill table{border-collapse:separate!important;border-radius:0 0 5px 5px;-moz-border-radius:0 0 5px 5px;-webkit-border-radius:0 0 5px 5px;overflow:hidden;max-width:280px;width:280px}date-input-polyfill td,date-input-polyfill th{width:32px;padding:4px;text-align:center;box-sizing:content-box}date-input-polyfill td[data-day]{cursor:pointer}date-input-polyfill td[data-day]:hover{background:#dadfe1}date-input-polyfill [data-selected]{font-weight:700;background:#d8eaf6}",""]);
	},function(t,e){t.exports=function(){var t=[];return t.toString=function(){for(var t=[],e=0;e<this.length;e++){var n=this[e];n[2]?t.push("@media "+n[2]+"{"+n[1]+"}"):t.push(n[1])}return t.join("")},t.i=function(e,n){"string"==typeof e&&(e=[[null,e,""]]);for(var r={},o=0;o<this.length;o++){var i=this[o][0];"number"==typeof i&&(r[i]=!0)}for(o=0;o<e.length;o++){var a=e[o];"number"==typeof a[0]&&r[a[0]]||(n&&!a[2]?a[2]=n:n&&(a[2]="("+a[2]+") and ("+n+")"),t.push(a))}},t}},function(t,e,n){function r(t,e){for(var n=0;n<t.length;n++){var r=t[n],o=p[r.id];if(o){o.refs++;for(var i=0;i<o.parts.length;i++)o.parts[i](r.parts[i]);for(;i<r.parts.length;i++)o.parts.push(c(r.parts[i],e))}else{for(var a=[],i=0;i<r.parts.length;i++)a.push(c(r.parts[i],e));p[r.id]={id:r.id,refs:1,parts:a}}}}function o(t){for(var e=[],n={},r=0;r<t.length;r++){var o=t[r],i=o[0],a=o[1],u=o[2],s=o[3],c={css:a,media:u,sourceMap:s};n[i]?n[i].parts.push(c):e.push(n[i]={id:i,parts:[c]})}return e}function i(t,e){var n=m(),r=g[g.length-1];if("top"===t.insertAt)r?r.nextSibling?n.insertBefore(e,r.nextSibling):n.appendChild(e):n.insertBefore(e,n.firstChild),g.push(e);else{if("bottom"!==t.insertAt)throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");n.appendChild(e)}}function a(t){t.parentNode.removeChild(t);var e=g.indexOf(t);e>=0&&g.splice(e,1)}function u(t){var e=document.createElement("style");return e.type="text/css",i(t,e),e}function s(t){var e=document.createElement("link");return e.rel="stylesheet",i(t,e),e}function c(t,e){var n,r,o;if(e.singleton){var i=b++;n=v||(v=u(e)),r=l.bind(null,n,i,!1),o=l.bind(null,n,i,!0)}else t.sourceMap&&"function"==typeof URL&&"function"==typeof URL.createObjectURL&&"function"==typeof URL.revokeObjectURL&&"function"==typeof Blob&&"function"==typeof btoa?(n=s(e),r=d.bind(null,n),o=function(){a(n),n.href&&URL.revokeObjectURL(n.href)}):(n=u(e),r=f.bind(null,n),o=function(){a(n)});return r(t),function(e){if(e){if(e.css===t.css&&e.media===t.media&&e.sourceMap===t.sourceMap)return;r(t=e)}else o()}}function l(t,e,n,r){var o=n?"":r.css;if(t.styleSheet)t.styleSheet.cssText=x(e,o);else{var i=document.createTextNode(o),a=t.childNodes;a[e]&&t.removeChild(a[e]),a.length?t.insertBefore(i,a[e]):t.appendChild(i)}}function f(t,e){var n=e.css,r=e.media;if(r&&t.setAttribute("media",r),t.styleSheet)t.styleSheet.cssText=n;else{for(;t.firstChild;)t.removeChild(t.firstChild);t.appendChild(document.createTextNode(n))}}function d(t,e){var n=e.css,r=e.sourceMap;r&&(n+="\n/*# sourceMappingURL=data:application/json;base64,"+btoa(unescape(encodeURIComponent(JSON.stringify(r))))+" */");var o=new Blob([n],{type:"text/css"}),i=t.href;t.href=URL.createObjectURL(o),i&&URL.revokeObjectURL(i)}var p={},h=function(t){var e;return function(){return"undefined"==typeof e&&(e=t.apply(this,arguments)),e}},y=h(function(){return/msie [6-9]\b/.test(window.navigator.userAgent.toLowerCase())}),m=h(function(){return document.head||document.getElementsByTagName("head")[0]}),v=null,b=0,g=[];t.exports=function(t,e){e=e||{},"undefined"==typeof e.singleton&&(e.singleton=y()),"undefined"==typeof e.insertAt&&(e.insertAt="bottom");var n=o(t);return r(n,e),function(t){for(var i=[],a=0;a<n.length;a++){var u=n[a],s=p[u.id];s.refs--,i.push(s)}if(t){var c=o(t);r(c,e)}for(var a=0;a<i.length;a++){var s=i[a];if(0===s.refs){for(var l=0;l<s.parts.length;l++)s.parts[l]();delete p[s.id]}}}};var x=function(){var t=[];return function(e,n){return t[e]=n,t.filter(Boolean).join("\n")}}()},function(t,e,n){var r=n(81);"string"==typeof r&&(r=[[t.id,r,""]]),n(83)(r,{}),r.locals&&(t.exports=r.locals)}])});

/***/ }),
/* 1610 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;//download.js v4.2, by dandavis; 2008-2016. [MIT] see http://danml.com/download.html for tests/usage
	// v1 landed a FF+Chrome compat way of downloading strings to local un-named files, upgraded to use a hidden frame and optional mime
	// v2 added named files via a[download], msSaveBlob, IE (10+) support, and window.URL support for larger+faster saves than dataURLs
	// v3 added dataURL and Blob Input, bind-toggle arity, and legacy dataURL fallback was improved with force-download mime and base64 support. 3.1 improved safari handling.
	// v4 adds AMD/UMD, commonJS, and plain browser support
	// v4.1 adds url download capability via solo URL argument (same domain/CORS only)
	// v4.2 adds semantic variable names, long (over 2MB) dataURL support, and hidden by default temp anchors
	// https://github.com/rndme/download
	
	(function (root, factory) {
		if (true) {
			// AMD. Register as an anonymous module.
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof exports === 'object') {
			// Node. Does not work with strict CommonJS, but
			// only CommonJS-like environments that support module.exports,
			// like Node.
			module.exports = factory();
		} else {
			// Browser globals (root is window)
			root.download = factory();
	  }
	}(this, function () {
	
		return function download(data, strFileName, strMimeType) {
	
			var self = window, // this script is only for browsers anyway...
				defaultMime = "application/octet-stream", // this default mime also triggers iframe downloads
				mimeType = strMimeType || defaultMime,
				payload = data,
				url = !strFileName && !strMimeType && payload,
				anchor = document.createElement("a"),
				toString = function(a){return String(a);},
				myBlob = (self.Blob || self.MozBlob || self.WebKitBlob || toString),
				fileName = strFileName || "download",
				blob,
				reader;
				myBlob= myBlob.call ? myBlob.bind(self) : Blob ;
		  
			if(String(this)==="true"){ //reverse arguments, allowing download.bind(true, "text/xml", "export.xml") to act as a callback
				payload=[payload, mimeType];
				mimeType=payload[0];
				payload=payload[1];
			}
	
	
			if(url && url.length< 2048){ // if no filename and no mime, assume a url was passed as the only argument
				fileName = url.split("/").pop().split("?")[0];
				anchor.href = url; // assign href prop to temp anchor
			  	if(anchor.href.indexOf(url) !== -1){ // if the browser determines that it's a potentially valid url path:
	        		var ajax=new XMLHttpRequest();
	        		ajax.open( "GET", url, true);
	        		ajax.responseType = 'blob';
	        		ajax.onload= function(e){ 
					  download(e.target.response, fileName, defaultMime);
					};
	        		setTimeout(function(){ ajax.send();}, 0); // allows setting custom ajax headers using the return:
				    return ajax;
				} // end if valid url?
			} // end if url?
	
	
			//go ahead and download dataURLs right away
			if(/^data:([\w+-]+\/[\w+.-]+)?[,;]/.test(payload)){
			
				if(payload.length > (1024*1024*1.999) && myBlob !== toString ){
					payload=dataUrlToBlob(payload);
					mimeType=payload.type || defaultMime;
				}else{			
					return navigator.msSaveBlob ?  // IE10 can't do a[download], only Blobs:
						navigator.msSaveBlob(dataUrlToBlob(payload), fileName) :
						saver(payload) ; // everyone else can save dataURLs un-processed
				}
				
			}else{//not data url, is it a string with special needs?
				if(/([\x80-\xff])/.test(payload)){			  
					var i=0, tempUiArr= new Uint8Array(payload.length), mx=tempUiArr.length;
					for(i;i<mx;++i) tempUiArr[i]= payload.charCodeAt(i);
				 	payload=new myBlob([tempUiArr], {type: mimeType});
				}		  
			}
			blob = payload instanceof myBlob ?
				payload :
				new myBlob([payload], {type: mimeType}) ;
	
	
			function dataUrlToBlob(strUrl) {
				var parts= strUrl.split(/[:;,]/),
				type= parts[1],
				decoder= parts[2] == "base64" ? atob : decodeURIComponent,
				binData= decoder( parts.pop() ),
				mx= binData.length,
				i= 0,
				uiArr= new Uint8Array(mx);
	
				for(i;i<mx;++i) uiArr[i]= binData.charCodeAt(i);
	
				return new myBlob([uiArr], {type: type});
			 }
	
			function saver(url, winMode){
	
				if ('download' in anchor) { //html5 A[download]
					anchor.href = url;
					anchor.setAttribute("download", fileName);
					anchor.className = "download-js-link";
					anchor.innerHTML = "downloading...";
					anchor.style.display = "none";
					document.body.appendChild(anchor);
					setTimeout(function() {
						anchor.click();
						document.body.removeChild(anchor);
						if(winMode===true){setTimeout(function(){ self.URL.revokeObjectURL(anchor.href);}, 250 );}
					}, 66);
					return true;
				}
	
				// handle non-a[download] safari as best we can:
				if(/(Version)\/(\d+)\.(\d+)(?:\.(\d+))?.*Safari\//.test(navigator.userAgent)) {
					if(/^data:/.test(url))	url="data:"+url.replace(/^data:([\w\/\-\+]+)/, defaultMime);
					if(!window.open(url)){ // popup blocked, offer direct download:
						if(confirm("Displaying New Document\n\nUse Save As... to download, then click back to return to this page.")){ location.href=url; }
					}
					return true;
				}
	
				//do iframe dataURL download (old ch+FF):
				var f = document.createElement("iframe");
				document.body.appendChild(f);
	
				if(!winMode && /^data:/.test(url)){ // force a mime that will download:
					url="data:"+url.replace(/^data:([\w\/\-\+]+)/, defaultMime);
				}
				f.src=url;
				setTimeout(function(){ document.body.removeChild(f); }, 333);
	
			}//end saver
	
	
	
	
			if (navigator.msSaveBlob) { // IE10+ : (has Blob, but not a[download] or URL)
				return navigator.msSaveBlob(blob, fileName);
			}
	
			if(self.URL){ // simple fast and modern way using Blob and URL:
				saver(self.URL.createObjectURL(blob), true);
			}else{
				// handle non-Blob()+non-URL browsers:
				if(typeof blob === "string" || blob.constructor===toString ){
					try{
						return saver( "data:" +  mimeType   + ";base64,"  +  self.btoa(blob)  );
					}catch(y){
						return saver( "data:" +  mimeType   + "," + encodeURIComponent(blob)  );
					}
				}
	
				// Blob but not URL support:
				reader=new FileReader();
				reader.onload=function(e){
					saver(this.result);
				};
				reader.readAsDataURL(blob);
			}
			return true;
		}; /* end download() */
	}));


/***/ }),
/* 1611 */,
/* 1612 */,
/* 1613 */,
/* 1614 */,
/* 1615 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1616 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1617 */,
/* 1618 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1619 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1620 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1621 */,
/* 1622 */,
/* 1623 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1624 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1625 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1626 */,
/* 1627 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1628 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1629 */,
/* 1630 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1631 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1632 */,
/* 1633 */,
/* 1634 */,
/* 1635 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1636 */,
/* 1637 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1638 */,
/* 1639 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1640 */,
/* 1641 */,
/* 1642 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1643 */,
/* 1644 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1645 */,
/* 1646 */,
/* 1647 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1648 */,
/* 1649 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1650 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1651 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1652 */,
/* 1653 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1654 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1655 */,
/* 1656 */,
/* 1657 */,
/* 1658 */,
/* 1659 */,
/* 1660 */,
/* 1661 */,
/* 1662 */,
/* 1663 */,
/* 1664 */,
/* 1665 */,
/* 1666 */,
/* 1667 */,
/* 1668 */,
/* 1669 */,
/* 1670 */,
/* 1671 */,
/* 1672 */,
/* 1673 */,
/* 1674 */,
/* 1675 */,
/* 1676 */,
/* 1677 */,
/* 1678 */,
/* 1679 */,
/* 1680 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1681 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1682 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;;(function () {
		'use strict';
	
		/**
		 * @preserve FastClick: polyfill to remove click delays on browsers with touch UIs.
		 *
		 * @codingstandard ftlabs-jsv2
		 * @copyright The Financial Times Limited [All Rights Reserved]
		 * @license MIT License (see LICENSE.txt)
		 */
	
		/*jslint browser:true, node:true*/
		/*global define, Event, Node*/
	
	
		/**
		 * Instantiate fast-clicking listeners on the specified layer.
		 *
		 * @constructor
		 * @param {Element} layer The layer to listen on
		 * @param {Object} [options={}] The options to override the defaults
		 */
		function FastClick(layer, options) {
			var oldOnClick;
	
			options = options || {};
	
			/**
			 * Whether a click is currently being tracked.
			 *
			 * @type boolean
			 */
			this.trackingClick = false;
	
	
			/**
			 * Timestamp for when click tracking started.
			 *
			 * @type number
			 */
			this.trackingClickStart = 0;
	
	
			/**
			 * The element being tracked for a click.
			 *
			 * @type EventTarget
			 */
			this.targetElement = null;
	
	
			/**
			 * X-coordinate of touch start event.
			 *
			 * @type number
			 */
			this.touchStartX = 0;
	
	
			/**
			 * Y-coordinate of touch start event.
			 *
			 * @type number
			 */
			this.touchStartY = 0;
	
	
			/**
			 * ID of the last touch, retrieved from Touch.identifier.
			 *
			 * @type number
			 */
			this.lastTouchIdentifier = 0;
	
	
			/**
			 * Touchmove boundary, beyond which a click will be cancelled.
			 *
			 * @type number
			 */
			this.touchBoundary = options.touchBoundary || 10;
	
	
			/**
			 * The FastClick layer.
			 *
			 * @type Element
			 */
			this.layer = layer;
	
			/**
			 * The minimum time between tap(touchstart and touchend) events
			 *
			 * @type number
			 */
			this.tapDelay = options.tapDelay || 200;
	
			/**
			 * The maximum time for a tap
			 *
			 * @type number
			 */
			this.tapTimeout = options.tapTimeout || 700;
	
			if (FastClick.notNeeded(layer)) {
				return;
			}
	
			// Some old versions of Android don't have Function.prototype.bind
			function bind(method, context) {
				return function() { return method.apply(context, arguments); };
			}
	
	
			var methods = ['onMouse', 'onClick', 'onTouchStart', 'onTouchMove', 'onTouchEnd', 'onTouchCancel'];
			var context = this;
			for (var i = 0, l = methods.length; i < l; i++) {
				context[methods[i]] = bind(context[methods[i]], context);
			}
	
			// Set up event handlers as required
			if (deviceIsAndroid) {
				layer.addEventListener('mouseover', this.onMouse, true);
				layer.addEventListener('mousedown', this.onMouse, true);
				layer.addEventListener('mouseup', this.onMouse, true);
			}
	
			layer.addEventListener('click', this.onClick, true);
			layer.addEventListener('touchstart', this.onTouchStart, false);
			layer.addEventListener('touchmove', this.onTouchMove, false);
			layer.addEventListener('touchend', this.onTouchEnd, false);
			layer.addEventListener('touchcancel', this.onTouchCancel, false);
	
			// Hack is required for browsers that don't support Event#stopImmediatePropagation (e.g. Android 2)
			// which is how FastClick normally stops click events bubbling to callbacks registered on the FastClick
			// layer when they are cancelled.
			if (!Event.prototype.stopImmediatePropagation) {
				layer.removeEventListener = function(type, callback, capture) {
					var rmv = Node.prototype.removeEventListener;
					if (type === 'click') {
						rmv.call(layer, type, callback.hijacked || callback, capture);
					} else {
						rmv.call(layer, type, callback, capture);
					}
				};
	
				layer.addEventListener = function(type, callback, capture) {
					var adv = Node.prototype.addEventListener;
					if (type === 'click') {
						adv.call(layer, type, callback.hijacked || (callback.hijacked = function(event) {
							if (!event.propagationStopped) {
								callback(event);
							}
						}), capture);
					} else {
						adv.call(layer, type, callback, capture);
					}
				};
			}
	
			// If a handler is already declared in the element's onclick attribute, it will be fired before
			// FastClick's onClick handler. Fix this by pulling out the user-defined handler function and
			// adding it as listener.
			if (typeof layer.onclick === 'function') {
	
				// Android browser on at least 3.2 requires a new reference to the function in layer.onclick
				// - the old one won't work if passed to addEventListener directly.
				oldOnClick = layer.onclick;
				layer.addEventListener('click', function(event) {
					oldOnClick(event);
				}, false);
				layer.onclick = null;
			}
		}
	
		/**
		* Windows Phone 8.1 fakes user agent string to look like Android and iPhone.
		*
		* @type boolean
		*/
		var deviceIsWindowsPhone = navigator.userAgent.indexOf("Windows Phone") >= 0;
	
		/**
		 * Android requires exceptions.
		 *
		 * @type boolean
		 */
		var deviceIsAndroid = navigator.userAgent.indexOf('Android') > 0 && !deviceIsWindowsPhone;
	
	
		/**
		 * iOS requires exceptions.
		 *
		 * @type boolean
		 */
		var deviceIsIOS = /iP(ad|hone|od)/.test(navigator.userAgent) && !deviceIsWindowsPhone;
	
	
		/**
		 * iOS 4 requires an exception for select elements.
		 *
		 * @type boolean
		 */
		var deviceIsIOS4 = deviceIsIOS && (/OS 4_\d(_\d)?/).test(navigator.userAgent);
	
	
		/**
		 * iOS 6.0-7.* requires the target element to be manually derived
		 *
		 * @type boolean
		 */
		var deviceIsIOSWithBadTarget = deviceIsIOS && (/OS [6-7]_\d/).test(navigator.userAgent);
	
		/**
		 * BlackBerry requires exceptions.
		 *
		 * @type boolean
		 */
		var deviceIsBlackBerry10 = navigator.userAgent.indexOf('BB10') > 0;
	
		/**
		 * Determine whether a given element requires a native click.
		 *
		 * @param {EventTarget|Element} target Target DOM element
		 * @returns {boolean} Returns true if the element needs a native click
		 */
		FastClick.prototype.needsClick = function(target) {
			switch (target.nodeName.toLowerCase()) {
	
			// Don't send a synthetic click to disabled inputs (issue #62)
			case 'button':
			case 'select':
			case 'textarea':
				if (target.disabled) {
					return true;
				}
	
				break;
			case 'input':
	
				// File inputs need real clicks on iOS 6 due to a browser bug (issue #68)
				if ((deviceIsIOS && target.type === 'file') || target.disabled) {
					return true;
				}
	
				break;
			case 'label':
			case 'iframe': // iOS8 homescreen apps can prevent events bubbling into frames
			case 'video':
				return true;
			}
	
			return (/\bneedsclick\b/).test(target.className);
		};
	
	
		/**
		 * Determine whether a given element requires a call to focus to simulate click into element.
		 *
		 * @param {EventTarget|Element} target Target DOM element
		 * @returns {boolean} Returns true if the element requires a call to focus to simulate native click.
		 */
		FastClick.prototype.needsFocus = function(target) {
			switch (target.nodeName.toLowerCase()) {
			case 'textarea':
				return true;
			case 'select':
				return !deviceIsAndroid;
			case 'input':
				switch (target.type) {
				case 'button':
				case 'checkbox':
				case 'file':
				case 'image':
				case 'radio':
				case 'submit':
					return false;
				}
	
				// No point in attempting to focus disabled inputs
				return !target.disabled && !target.readOnly;
			default:
				return (/\bneedsfocus\b/).test(target.className);
			}
		};
	
	
		/**
		 * Send a click event to the specified element.
		 *
		 * @param {EventTarget|Element} targetElement
		 * @param {Event} event
		 */
		FastClick.prototype.sendClick = function(targetElement, event) {
			var clickEvent, touch;
	
			// On some Android devices activeElement needs to be blurred otherwise the synthetic click will have no effect (#24)
			if (document.activeElement && document.activeElement !== targetElement) {
				document.activeElement.blur();
			}
	
			touch = event.changedTouches[0];
	
			// Synthesise a click event, with an extra attribute so it can be tracked
			clickEvent = document.createEvent('MouseEvents');
			clickEvent.initMouseEvent(this.determineEventType(targetElement), true, true, window, 1, touch.screenX, touch.screenY, touch.clientX, touch.clientY, false, false, false, false, 0, null);
			clickEvent.forwardedTouchEvent = true;
			targetElement.dispatchEvent(clickEvent);
		};
	
		FastClick.prototype.determineEventType = function(targetElement) {
	
			//Issue #159: Android Chrome Select Box does not open with a synthetic click event
			if (deviceIsAndroid && targetElement.tagName.toLowerCase() === 'select') {
				return 'mousedown';
			}
	
			return 'click';
		};
	
	
		/**
		 * @param {EventTarget|Element} targetElement
		 */
		FastClick.prototype.focus = function(targetElement) {
			var length;
	
			// Issue #160: on iOS 7, some input elements (e.g. date datetime month) throw a vague TypeError on setSelectionRange. These elements don't have an integer value for the selectionStart and selectionEnd properties, but unfortunately that can't be used for detection because accessing the properties also throws a TypeError. Just check the type instead. Filed as Apple bug #15122724.
			if (deviceIsIOS && targetElement.setSelectionRange && targetElement.type.indexOf('date') !== 0 && targetElement.type !== 'time' && targetElement.type !== 'month') {
				length = targetElement.value.length;
				targetElement.setSelectionRange(length, length);
			} else {
				targetElement.focus();
			}
		};
	
	
		/**
		 * Check whether the given target element is a child of a scrollable layer and if so, set a flag on it.
		 *
		 * @param {EventTarget|Element} targetElement
		 */
		FastClick.prototype.updateScrollParent = function(targetElement) {
			var scrollParent, parentElement;
	
			scrollParent = targetElement.fastClickScrollParent;
	
			// Attempt to discover whether the target element is contained within a scrollable layer. Re-check if the
			// target element was moved to another parent.
			if (!scrollParent || !scrollParent.contains(targetElement)) {
				parentElement = targetElement;
				do {
					if (parentElement.scrollHeight > parentElement.offsetHeight) {
						scrollParent = parentElement;
						targetElement.fastClickScrollParent = parentElement;
						break;
					}
	
					parentElement = parentElement.parentElement;
				} while (parentElement);
			}
	
			// Always update the scroll top tracker if possible.
			if (scrollParent) {
				scrollParent.fastClickLastScrollTop = scrollParent.scrollTop;
			}
		};
	
	
		/**
		 * @param {EventTarget} targetElement
		 * @returns {Element|EventTarget}
		 */
		FastClick.prototype.getTargetElementFromEventTarget = function(eventTarget) {
	
			// On some older browsers (notably Safari on iOS 4.1 - see issue #56) the event target may be a text node.
			if (eventTarget.nodeType === Node.TEXT_NODE) {
				return eventTarget.parentNode;
			}
	
			return eventTarget;
		};
	
	
		/**
		 * On touch start, record the position and scroll offset.
		 *
		 * @param {Event} event
		 * @returns {boolean}
		 */
		FastClick.prototype.onTouchStart = function(event) {
			var targetElement, touch, selection;
	
			// Ignore multiple touches, otherwise pinch-to-zoom is prevented if both fingers are on the FastClick element (issue #111).
			if (event.targetTouches.length > 1) {
				return true;
			}
	
			targetElement = this.getTargetElementFromEventTarget(event.target);
			touch = event.targetTouches[0];
	
			if (deviceIsIOS) {
	
				// Only trusted events will deselect text on iOS (issue #49)
				selection = window.getSelection();
				if (selection.rangeCount && !selection.isCollapsed) {
					return true;
				}
	
				if (!deviceIsIOS4) {
	
					// Weird things happen on iOS when an alert or confirm dialog is opened from a click event callback (issue #23):
					// when the user next taps anywhere else on the page, new touchstart and touchend events are dispatched
					// with the same identifier as the touch event that previously triggered the click that triggered the alert.
					// Sadly, there is an issue on iOS 4 that causes some normal touch events to have the same identifier as an
					// immediately preceeding touch event (issue #52), so this fix is unavailable on that platform.
					// Issue 120: touch.identifier is 0 when Chrome dev tools 'Emulate touch events' is set with an iOS device UA string,
					// which causes all touch events to be ignored. As this block only applies to iOS, and iOS identifiers are always long,
					// random integers, it's safe to to continue if the identifier is 0 here.
					if (touch.identifier && touch.identifier === this.lastTouchIdentifier) {
						event.preventDefault();
						return false;
					}
	
					this.lastTouchIdentifier = touch.identifier;
	
					// If the target element is a child of a scrollable layer (using -webkit-overflow-scrolling: touch) and:
					// 1) the user does a fling scroll on the scrollable layer
					// 2) the user stops the fling scroll with another tap
					// then the event.target of the last 'touchend' event will be the element that was under the user's finger
					// when the fling scroll was started, causing FastClick to send a click event to that layer - unless a check
					// is made to ensure that a parent layer was not scrolled before sending a synthetic click (issue #42).
					this.updateScrollParent(targetElement);
				}
			}
	
			this.trackingClick = true;
			this.trackingClickStart = event.timeStamp;
			this.targetElement = targetElement;
	
			this.touchStartX = touch.pageX;
			this.touchStartY = touch.pageY;
	
			// Prevent phantom clicks on fast double-tap (issue #36)
			if ((event.timeStamp - this.lastClickTime) < this.tapDelay) {
				event.preventDefault();
			}
	
			return true;
		};
	
	
		/**
		 * Based on a touchmove event object, check whether the touch has moved past a boundary since it started.
		 *
		 * @param {Event} event
		 * @returns {boolean}
		 */
		FastClick.prototype.touchHasMoved = function(event) {
			var touch = event.changedTouches[0], boundary = this.touchBoundary;
	
			if (Math.abs(touch.pageX - this.touchStartX) > boundary || Math.abs(touch.pageY - this.touchStartY) > boundary) {
				return true;
			}
	
			return false;
		};
	
	
		/**
		 * Update the last position.
		 *
		 * @param {Event} event
		 * @returns {boolean}
		 */
		FastClick.prototype.onTouchMove = function(event) {
			if (!this.trackingClick) {
				return true;
			}
	
			// If the touch has moved, cancel the click tracking
			if (this.targetElement !== this.getTargetElementFromEventTarget(event.target) || this.touchHasMoved(event)) {
				this.trackingClick = false;
				this.targetElement = null;
			}
	
			return true;
		};
	
	
		/**
		 * Attempt to find the labelled control for the given label element.
		 *
		 * @param {EventTarget|HTMLLabelElement} labelElement
		 * @returns {Element|null}
		 */
		FastClick.prototype.findControl = function(labelElement) {
	
			// Fast path for newer browsers supporting the HTML5 control attribute
			if (labelElement.control !== undefined) {
				return labelElement.control;
			}
	
			// All browsers under test that support touch events also support the HTML5 htmlFor attribute
			if (labelElement.htmlFor) {
				return document.getElementById(labelElement.htmlFor);
			}
	
			// If no for attribute exists, attempt to retrieve the first labellable descendant element
			// the list of which is defined here: http://www.w3.org/TR/html5/forms.html#category-label
			return labelElement.querySelector('button, input:not([type=hidden]), keygen, meter, output, progress, select, textarea');
		};
	
	
		/**
		 * On touch end, determine whether to send a click event at once.
		 *
		 * @param {Event} event
		 * @returns {boolean}
		 */
		FastClick.prototype.onTouchEnd = function(event) {
			var forElement, trackingClickStart, targetTagName, scrollParent, touch, targetElement = this.targetElement;
	
			if (!this.trackingClick) {
				return true;
			}
	
			// Prevent phantom clicks on fast double-tap (issue #36)
			if ((event.timeStamp - this.lastClickTime) < this.tapDelay) {
				this.cancelNextClick = true;
				return true;
			}
	
			if ((event.timeStamp - this.trackingClickStart) > this.tapTimeout) {
				return true;
			}
	
			// Reset to prevent wrong click cancel on input (issue #156).
			this.cancelNextClick = false;
	
			this.lastClickTime = event.timeStamp;
	
			trackingClickStart = this.trackingClickStart;
			this.trackingClick = false;
			this.trackingClickStart = 0;
	
			// On some iOS devices, the targetElement supplied with the event is invalid if the layer
			// is performing a transition or scroll, and has to be re-detected manually. Note that
			// for this to function correctly, it must be called *after* the event target is checked!
			// See issue #57; also filed as rdar://13048589 .
			if (deviceIsIOSWithBadTarget) {
				touch = event.changedTouches[0];
	
				// In certain cases arguments of elementFromPoint can be negative, so prevent setting targetElement to null
				targetElement = document.elementFromPoint(touch.pageX - window.pageXOffset, touch.pageY - window.pageYOffset) || targetElement;
				targetElement.fastClickScrollParent = this.targetElement.fastClickScrollParent;
			}
	
			targetTagName = targetElement.tagName.toLowerCase();
			if (targetTagName === 'label') {
				forElement = this.findControl(targetElement);
				if (forElement) {
					this.focus(targetElement);
					if (deviceIsAndroid) {
						return false;
					}
	
					targetElement = forElement;
				}
			} else if (this.needsFocus(targetElement)) {
	
				// Case 1: If the touch started a while ago (best guess is 100ms based on tests for issue #36) then focus will be triggered anyway. Return early and unset the target element reference so that the subsequent click will be allowed through.
				// Case 2: Without this exception for input elements tapped when the document is contained in an iframe, then any inputted text won't be visible even though the value attribute is updated as the user types (issue #37).
				if ((event.timeStamp - trackingClickStart) > 100 || (deviceIsIOS && window.top !== window && targetTagName === 'input')) {
					this.targetElement = null;
					return false;
				}
	
				this.focus(targetElement);
				this.sendClick(targetElement, event);
	
				// Select elements need the event to go through on iOS 4, otherwise the selector menu won't open.
				// Also this breaks opening selects when VoiceOver is active on iOS6, iOS7 (and possibly others)
				if (!deviceIsIOS || targetTagName !== 'select') {
					this.targetElement = null;
					event.preventDefault();
				}
	
				return false;
			}
	
			if (deviceIsIOS && !deviceIsIOS4) {
	
				// Don't send a synthetic click event if the target element is contained within a parent layer that was scrolled
				// and this tap is being used to stop the scrolling (usually initiated by a fling - issue #42).
				scrollParent = targetElement.fastClickScrollParent;
				if (scrollParent && scrollParent.fastClickLastScrollTop !== scrollParent.scrollTop) {
					return true;
				}
			}
	
			// Prevent the actual click from going though - unless the target node is marked as requiring
			// real clicks or if it is in the whitelist in which case only non-programmatic clicks are permitted.
			if (!this.needsClick(targetElement)) {
				event.preventDefault();
				this.sendClick(targetElement, event);
			}
	
			return false;
		};
	
	
		/**
		 * On touch cancel, stop tracking the click.
		 *
		 * @returns {void}
		 */
		FastClick.prototype.onTouchCancel = function() {
			this.trackingClick = false;
			this.targetElement = null;
		};
	
	
		/**
		 * Determine mouse events which should be permitted.
		 *
		 * @param {Event} event
		 * @returns {boolean}
		 */
		FastClick.prototype.onMouse = function(event) {
	
			// If a target element was never set (because a touch event was never fired) allow the event
			if (!this.targetElement) {
				return true;
			}
	
			if (event.forwardedTouchEvent) {
				return true;
			}
	
			// Programmatically generated events targeting a specific element should be permitted
			if (!event.cancelable) {
				return true;
			}
	
			// Derive and check the target element to see whether the mouse event needs to be permitted;
			// unless explicitly enabled, prevent non-touch click events from triggering actions,
			// to prevent ghost/doubleclicks.
			if (!this.needsClick(this.targetElement) || this.cancelNextClick) {
	
				// Prevent any user-added listeners declared on FastClick element from being fired.
				if (event.stopImmediatePropagation) {
					event.stopImmediatePropagation();
				} else {
	
					// Part of the hack for browsers that don't support Event#stopImmediatePropagation (e.g. Android 2)
					event.propagationStopped = true;
				}
	
				// Cancel the event
				event.stopPropagation();
				event.preventDefault();
	
				return false;
			}
	
			// If the mouse event is permitted, return true for the action to go through.
			return true;
		};
	
	
		/**
		 * On actual clicks, determine whether this is a touch-generated click, a click action occurring
		 * naturally after a delay after a touch (which needs to be cancelled to avoid duplication), or
		 * an actual click which should be permitted.
		 *
		 * @param {Event} event
		 * @returns {boolean}
		 */
		FastClick.prototype.onClick = function(event) {
			var permitted;
	
			// It's possible for another FastClick-like library delivered with third-party code to fire a click event before FastClick does (issue #44). In that case, set the click-tracking flag back to false and return early. This will cause onTouchEnd to return early.
			if (this.trackingClick) {
				this.targetElement = null;
				this.trackingClick = false;
				return true;
			}
	
			// Very odd behaviour on iOS (issue #18): if a submit element is present inside a form and the user hits enter in the iOS simulator or clicks the Go button on the pop-up OS keyboard the a kind of 'fake' click event will be triggered with the submit-type input element as the target.
			if (event.target.type === 'submit' && event.detail === 0) {
				return true;
			}
	
			permitted = this.onMouse(event);
	
			// Only unset targetElement if the click is not permitted. This will ensure that the check for !targetElement in onMouse fails and the browser's click doesn't go through.
			if (!permitted) {
				this.targetElement = null;
			}
	
			// If clicks are permitted, return true for the action to go through.
			return permitted;
		};
	
	
		/**
		 * Remove all FastClick's event listeners.
		 *
		 * @returns {void}
		 */
		FastClick.prototype.destroy = function() {
			var layer = this.layer;
	
			if (deviceIsAndroid) {
				layer.removeEventListener('mouseover', this.onMouse, true);
				layer.removeEventListener('mousedown', this.onMouse, true);
				layer.removeEventListener('mouseup', this.onMouse, true);
			}
	
			layer.removeEventListener('click', this.onClick, true);
			layer.removeEventListener('touchstart', this.onTouchStart, false);
			layer.removeEventListener('touchmove', this.onTouchMove, false);
			layer.removeEventListener('touchend', this.onTouchEnd, false);
			layer.removeEventListener('touchcancel', this.onTouchCancel, false);
		};
	
	
		/**
		 * Check whether FastClick is needed.
		 *
		 * @param {Element} layer The layer to listen on
		 */
		FastClick.notNeeded = function(layer) {
			var metaViewport;
			var chromeVersion;
			var blackberryVersion;
			var firefoxVersion;
	
			// Devices that don't support touch don't need FastClick
			if (typeof window.ontouchstart === 'undefined') {
				return true;
			}
	
			// Chrome version - zero for other browsers
			chromeVersion = +(/Chrome\/([0-9]+)/.exec(navigator.userAgent) || [,0])[1];
	
			if (chromeVersion) {
	
				if (deviceIsAndroid) {
					metaViewport = document.querySelector('meta[name=viewport]');
	
					if (metaViewport) {
						// Chrome on Android with user-scalable="no" doesn't need FastClick (issue #89)
						if (metaViewport.content.indexOf('user-scalable=no') !== -1) {
							return true;
						}
						// Chrome 32 and above with width=device-width or less don't need FastClick
						if (chromeVersion > 31 && document.documentElement.scrollWidth <= window.outerWidth) {
							return true;
						}
					}
	
				// Chrome desktop doesn't need FastClick (issue #15)
				} else {
					return true;
				}
			}
	
			if (deviceIsBlackBerry10) {
				blackberryVersion = navigator.userAgent.match(/Version\/([0-9]*)\.([0-9]*)/);
	
				// BlackBerry 10.3+ does not require Fastclick library.
				// https://github.com/ftlabs/fastclick/issues/251
				if (blackberryVersion[1] >= 10 && blackberryVersion[2] >= 3) {
					metaViewport = document.querySelector('meta[name=viewport]');
	
					if (metaViewport) {
						// user-scalable=no eliminates click delay.
						if (metaViewport.content.indexOf('user-scalable=no') !== -1) {
							return true;
						}
						// width=device-width (or less than device-width) eliminates click delay.
						if (document.documentElement.scrollWidth <= window.outerWidth) {
							return true;
						}
					}
				}
			}
	
			// IE10 with -ms-touch-action: none or manipulation, which disables double-tap-to-zoom (issue #97)
			if (layer.style.msTouchAction === 'none' || layer.style.touchAction === 'manipulation') {
				return true;
			}
	
			// Firefox version - zero for other browsers
			firefoxVersion = +(/Firefox\/([0-9]+)/.exec(navigator.userAgent) || [,0])[1];
	
			if (firefoxVersion >= 27) {
				// Firefox 27+ does not have tap delay if the content is not zoomable - https://bugzilla.mozilla.org/show_bug.cgi?id=922896
	
				metaViewport = document.querySelector('meta[name=viewport]');
				if (metaViewport && (metaViewport.content.indexOf('user-scalable=no') !== -1 || document.documentElement.scrollWidth <= window.outerWidth)) {
					return true;
				}
			}
	
			// IE11: prefixed -ms-touch-action is no longer supported and it's recomended to use non-prefixed version
			// http://msdn.microsoft.com/en-us/library/windows/apps/Hh767313.aspx
			if (layer.style.touchAction === 'none' || layer.style.touchAction === 'manipulation') {
				return true;
			}
	
			return false;
		};
	
	
		/**
		 * Factory method for creating a FastClick object
		 *
		 * @param {Element} layer The layer to listen on
		 * @param {Object} [options={}] The options to override the defaults
		 */
		FastClick.attach = function(layer, options) {
			return new FastClick(layer, options);
		};
	
	
		if (true) {
	
			// AMD. Register as an anonymous module.
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
				return FastClick;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module.exports) {
			module.exports = FastClick.attach;
			module.exports.FastClick = FastClick;
		} else {
			window.FastClick = FastClick;
		}
	}());


/***/ }),
/* 1683 */,
/* 1684 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "8ac244fcbfd3b734c5d5cc285633154a.svg";

/***/ }),
/* 1685 */,
/* 1686 */,
/* 1687 */,
/* 1688 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "f9b4d6f8239c5bdfe31e02ffc8dd8ae7.svg";

/***/ }),
/* 1689 */
/***/ (function(module, exports) {

	module.exports = {"general":{"Traveler":"Traveller","traveler":"traveller","travelers":"travellers","Travelers":"Travellers","traveler_s":"traveller's","traveling":"travelling","Cost_Centre":"Cost Center"},"dates":{"dateFormat":"dd/mm/yyyy","DateFormat":"DD/MM/YYYY","DateFormatMedium":"DD MMM, YYYY","DateFormatLong":"ddd Do MMM YYYY","DateTimeFormat":"dddd Do MMM h:mm a","DateTimeFormatLong":"ddd, D MMM YYYY [at] h:mm a","TimeFormat":"h:mm","TimeFormatLong":"h:mm a","TimeFormatMeridiem":"a"},"phone":{"phoneFormat":"(?:[+]|[0-9])?(?:[0-9\\s]{9,14})"},"mail":{"mailFormat":"(?:[a-z0-9!#$%&'*+\\/=?^_`{|}~-]+(?:\\.[a-z0-9!#$%&'*+\\/=?^_`{|}~-]+)*|\"(?:[\\x01-\\x08\\x0b\\x0c\\x0e-\\x1f\\x21\\x23-\\x5b\\x5d-\\x7f]|\\[\\x01-\\x09\\x0b\\x0c\\x0e-\\x7f])*\")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\\x01-\\x08\\x0b\\x0c\\x0e-\\x1f\\x21-\\x5a\\x53-\\x7f]|\\[\\x01-\\x09\\x0b\\x0c\\x0e-\\x7f])+)\\])"},"modals":{"costCentre":{"HEADER":"Select Cost Center"},"department":{"HEADER":"Select Department"},"paymentMethod":{"HEADER":"Select Payment Method"},"unusedCredit":{"HEADER":"Select Unused Ticket Credit"},"companyReference":{"HEADER":"Set Company References"},"addFlightSector":{"HEADER":"Add flights to your trip","SUBHEADING":"Select your flights","INSTRUCTIONS":"One ticket will be booked for each individual traveller on this trip for each flight chosen."},"addHotelSector":{"HEADER":"Add a hotel to your trip","SUBHEADING":"Select travellers who need a room","INSTRUCTIONS":"One identical room will be booked in the name of each selected traveller","SELECT_HOTEL_SUBHEADING":"Select hotel details","SELECT_HOTEL_INSTRUCTIONS":"All travellers will need to stay at the same hotel on the same days","SELECT_LOCATION_LABEL":"Location","SELECT_CHECK_IN_LABEL":"Check in","SELECT_CHECK_OUT_LABEL":"Check out"},"changeHotelSector":{"HEADER":"Change your existing hotel reservation","SELECT_HOTEL_SUBHEADING":"Select hotel details","SELECT_CHECK_IN_LABEL":"Check in","SELECT_CHECK_OUT_LABEL":"Check out"},"addCarSector":{"HEADER":"Add a car to your trip","SUBHEADING":"Select travellers who need a car","INSTRUCTIONS":"One identical car will be booked in the name of each selected traveller","SELECT_PICK_UP_LOCATION":"Pick up","SELECT_DROP_OFF_LOCATION":"Drop off","ALL_CARS_SAME_LOCATION":"All cars will need to be picked up at the same location on the same day","ALL_CARS_SAME_DROP_LOCATION":"All cars will need to be dropped off at the same location on the same day","NO_RESULTS":"No results"},"changeCarSector":{"HEADER":"Change your car reservation"},"errorMessage":{"FORM":"Your inputs did not validate successfully","TECHNICAL":"We're sorry, there seems to be a technical error","ITINERARY_INCOMPLETE":"Your itinerary is incomplete","MISSING_DATA_APPROVER":"Missing data for approver section","REQUEST_ERROR_HOTEL":"There is a problem with the hotel request"},"approver":{"HEADER":"Select Approver","ADD_A_COMMENT_FOR_APPROVER_OPTIONAL":"Add a comment for approver (optional)","NON_REFUNDABLE":"Non-refundable. Your company will still be charged if your booking is not approved by your chosen approver."}},"http":{"NONE":"Service is inaccessible","OTHER":"Request may not have been correctly formatted","NOT_FOUND":"A resource with the specified identifier could not be found","GATEWAY_TIMEOUT":"Server did not respond in a timely manner","SERVICE_UNAVAILABLE":"Service is unavailable. Please try again later","INTERNAL_SERVER_ERROR":"Server experienced a critical error","METHOD_NOT_ALLOWED":"Access to the service is denied","UNAUTHORISED":"You do not have permission to access this service. Your Access Token may have expired, please try logging in again."},"validation":{"INVALID_ALPHA":"May only contain letters. ","INVALID_ALPHA_SPACE":"May only contain letters and spaces. ","INVALID_ALPHA_NUM":"May only contain letters and numbers. ","INVALID_ALPHA_NUM_SPACE":"May only contain letters, numbers and spaces. ","INVALID_ALPHA_DASH":"May only contain letters, numbers and dashes. ","INVALID_ALPHA_DASH_SPACE":"May only contain letters, numbers, dashes and spaces. ","INVALID_BETWEEN_CHAR":"Text must be between {0} and {1} characters in length. ","INVALID_BETWEEN_NUM":"Needs to be a numeric value, between {0} and {1}. ","INVALID_BOOLEAN":"May only contain a true or false value. ","INVALID_CREDIT_CARD":"Must be a valid credit card number. ","INVALID_DATE_EURO_LONG":"Must be a valid date format (dd-mm-yyyy) OR (dd/mm/yyyy). ","INVALID_DATE_EURO_LONG_BETWEEN":"Needs to be a valid date format (dd-mm-yyyy) OR (dd/mm/yyyy) between {0} and {1}. ","INVALID_DATE_EURO_LONG_MAX":"Needs to be a valid date format (dd-mm-yyyy) OR (dd/mm/yyyy), equal to, or lower than {0}. ","INVALID_DATE_EURO_LONG_MIN":"Needs to be a valid date format (dd-mm-yyyy) OR (dd/mm/yyyy), equal to, or higher than {0}. ","INVALID_DATE_EURO_SHORT":"Must be a valid date format (dd-mm-yy) OR (dd/mm/yy). ","INVALID_DATE_EURO_SHORT_BETWEEN":"Needs to be a valid date format (dd-mm-yy) OR (dd/mm/yy) between {0} and {1}. ","INVALID_DATE_EURO_SHORT_MAX":"Needs to be a valid date format (dd-mm-yy) OR (dd/mm/yy), equal to, or lower than {0}. ","INVALID_DATE_EURO_SHORT_MIN":"Needs to be a valid date format (dd-mm-yy) OR (dd/mm/yy), equal to, or higher than {0}. ","INVALID_DATE_ISO":"Must be a valid date format (yyyy-mm-dd). ","INVALID_DATE_ISO_BETWEEN":"Needs to be a valid date format (yyyy-mm-dd) between {0} and {1}. ","INVALID_DATE_ISO_MAX":"Needs to be a valid date format (yyyy-mm-dd), equal to, or lower than {0}. ","INVALID_DATE_ISO_MIN":"Needs to be a valid date format (yyyy-mm-dd), equal to, or higher than {0}. ","INVALID_DATE_US_LONG":"Must be a valid date format (mm/dd/yyyy) OR (mm-dd-yyyy). ","INVALID_DATE_US_LONG_BETWEEN":"Needs to be a valid date format (mm/dd/yyyy) OR (mm-dd-yyyy) between {0} and {1}. ","INVALID_DATE_US_LONG_MAX":"Needs to be a valid date format (mm/dd/yyyy) OR (mm-dd-yyyy), equal to, or lower than {0}. ","INVALID_DATE_US_LONG_MIN":"Needs to be a valid date format (mm/dd/yyyy) OR (mm-dd-yyyy), equal to, or higher than {0}. ","INVALID_DATE_US_SHORT":"Must be a valid date format (mm/dd/yy) OR (mm-dd-yy). ","INVALID_DATE_US_SHORT_BETWEEN":"Needs to be a valid date format (mm/dd/yy) OR (mm-dd-yy) between {0} and {1}. ","INVALID_DATE_US_SHORT_MAX":"Needs to be a valid date format (mm/dd/yy) OR (mm-dd-yy), equal to, or lower than {0}. ","INVALID_DATE_US_SHORT_MIN":"Needs to be a valid date format (mm/dd/yy) OR (mm-dd-yy), equal to, or higher than {0}. ","INVALID_EMAIL":"Must be a valid email address. ","INVALID_EXACT_LEN":"Must have a length of exactly {0} characters. ","INVALID_FLOAT":"May only contain a positive float value (integer excluded). ","INVALID_FLOAT_SIGNED":"May only contain a positive or negative float value (integer excluded). ","INVALID_IBAN":"Must be a valid IBAN. ","INVALID_INPUT_MATCH":"Confirmation field does not match specified field \"{0}\". ","INVALID_INTEGER":"Must be a positive integer. ","INVALID_INTEGER_SIGNED":"Must be a positive or negative integer. ","INVALID_IPV4":"Must be a valid IP (IPV4). ","INVALID_IPV6":"Must be a valid IP (IPV6). ","INVALID_IPV6_HEX":"Must be a valid IP (IPV6 Hex). ","INVALID_KEY_CHAR":"Invalid keyboard entry on a field of type \"number\". ","INVALID_MAX_CHAR":"May not be greater than {0} characters. ","INVALID_MAX_NUM":"Needs to be a numeric value, equal to, or lower than {0}. ","INVALID_MIN_CHAR":"Must be at least {0} characters. ","INVALID_MIN_NUM":"Needs to be a numeric value, equal to, or higher than {0}. ","INVALID_NUMERIC":"Must be a positive number. ","INVALID_NUMERIC_SIGNED":"Must be a positive or negative number. ","INVALID_PATTERN":"Must be following this format: {0}. ","INVALID_REQUIRED":"Field is required. ","INVALID_URL":"Must be a valid URL. ","INVALID_TIME":"Must be a valid time format (hh:mm) OR (hh:mm:ss). ","INVALID_CHECKBOX_SELECTED":"Checkbox must be selected. ","ERRORS":"Errors","FIRST_NAME":"First Name","LAST_NAME":"Last Name","RESET_FORM":"Reset Form","SAVE":"Save","SHOW_VALIDATION_SUMMARY":"Show Validation Summary","INVALID_DATE_AUSTRALIA":"Please enter a valid date in the format: dd/mm/yyyy","INVALID_TIME_AUSTRALIA":"Please enter a valid time","COST_CENTRES_REQUIRED":"Please select a Cost Center for all travellers","DEPARTMENTS_REQUIRED":"Please select a Department for all travellers","PAYMENT_METHODS_REQUIRED":"Please select a Payment Method for all travellers","ALL_MANDATORY_REQUIRED":"Please fill out all mandatory fields","CREDIT_CARD_INVALID_EXP":"Please enter an expiration date in the future","CREDIT_CARD_NUMBER_REQUIRED":"Please enter a valid card number","CREDIT_CARD_EXPIRY_MM_REQUIRED":"Please enter a valid expiry month","CREDIT_CARD_EXPIRY_YYYY_REQUIRED":"Please enter a valid expiry year","CREDIT_CARD_HOLDER_REQUIRED":"Please enter the card holder's name","CREDIT_CARD_HOLDER_INVALID":"Please enter a valid card holder's name","CREDIT_CARD_CCV_REQUIRED":"Please enter a valid CCV","PASSENGER_SELECTION_REQUIRED":"Please select at least one passenger","DEPARTURE_LOCATION_REQUIRED":"Please specify your departure location","ARRIVAL_LOCATION_REQUIRED":"Please specify your arrival location","HOTEL_LOCATION_REQUIRED":"Please specify your hotel location","HOTEL_CHECK_IN_DATE_REQUIRED":"Please specify your hotel check in date","HOTEL_CHECK_OUT_DATE_REQUIRED":"Please specify your hotel check out date","PICK_UP_LOCATION_REQUIRED":"Please select a pick-up city","PICK_UP_DEPOT_REQUIRED":"Please select a pick-up location","PICK_UP_DATE_REQUIRED":"Please select a pick-up date","PICK_UP_TIME_REQUIRED":"Please select a pick-up time","DROP_OFF_LOCATION_REQUIRED":"Please select a drop-off city","DROP_OFF_DEPOT_REQUIRED":"Please select a drop-off location","DROP_OFF_DATE_REQUIRED":"Please select a drop-off date","DROP_OFF_TIME_REQUIRED":"Please select a drop-off time","INVALID_PICK_UP_TIME_AUSTRALIA":"Please select a valid pick-up time","INVALID_DROP_OFF_TIME_AUSTRALIA":"Please select a valid drop-off time","APPROVER_REQUIRED":"Please select an Approver"},"home":{"SELECT_PICK_UP":"Pick up city","SELECT_DROP_OFF":"Drop off city","DEPOT":"Location","PICK_UP_DATE":"Pick up date","DROP_OFF_DATE":"Drop off date"}}

/***/ }),
/* 1690 */
/***/ (function(module, exports) {

	module.exports = {"dates":{"DateTimeFormat":"dddd Do MMM HH:mm","DateTimeFormatLong":"ddd, D MMM YYYY [at] HH:mm","TimeFormat":"HH:mm","TimeFormatLong":"HH:mm","TimeFormatMeridiem":""},"phone":{"phoneFormat":"(?:[+]|[0-9])?(?:[0-9\\s]{9,14})"},"mail":{"mailFormat":"(?:[a-z0-9!#$%&'*+\\/=?^_`{|}~-]+(?:\\.[a-z0-9!#$%&'*+\\/=?^_`{|}~-]+)*|\"(?:[\\x01-\\x08\\x0b\\x0c\\x0e-\\x1f\\x21\\x23-\\x5b\\x5d-\\x7f]|\\[\\x01-\\x09\\x0b\\x0c\\x0e-\\x7f])*\")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\\x01-\\x08\\x0b\\x0c\\x0e-\\x1f\\x21-\\x5a\\x53-\\x7f]|\\[\\x01-\\x09\\x0b\\x0c\\x0e-\\x7f])+)\\])"}}

/***/ }),
/* 1691 */
/***/ (function(module, exports) {

	module.exports = {"general":{"Traveler":"Traveler","traveler":"traveler","travelers":"travelers","Travelers":"Travelers","traveler_s":"traveler's","traveling":"traveling","Cost_Centre":"Cost Center"},"dates":{"dateFormat":"mm/dd/yyyy","DateFormat":"MM/DD/YYYY","DateFormatMedium":"MMM DD, YYYY","DateFormatLong":"MMM Do YYYY","DateTimeFormat":"dddd MMM Do h:mm a","DateTimeFormatLong":"ddd, MMM D YYYY [at] h:mm a","TimeFormat":"h:mm","TimeFormatLong":"h:mm a","TimeFormatMeridiem":"a","DateTimeFullTimezone":"M/D/YYYY [at] h:mm a Z"},"phone":{"phoneFormat":"^[0-9\\s.-]{1,20}$"},"mail":{"mailFormat":"(?:[a-z0-9!#$%&'*+\\/=?^_`{|}~-]+(?:\\.[a-z0-9!#$%&'*+\\/=?^_`{|}~-]+)*|\"(?:[\\x01-\\x08\\x0b\\x0c\\x0e-\\x1f\\x21\\x23-\\x5b\\x5d-\\x7f]|\\[\\x01-\\x09\\x0b\\x0c\\x0e-\\x7f])*\")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\\x01-\\x08\\x0b\\x0c\\x0e-\\x1f\\x21-\\x5a\\x53-\\x7f]|\\[\\x01-\\x09\\x0b\\x0c\\x0e-\\x7f])+)\\])"},"modals":{"costCentre":{"HEADER":"Select Cost Center","INSTRUCTIONS":"One ticket will be booked for each individual traveler on this trip for each flight chosen."},"department":{},"paymentMethod":{"HEADER":"Select Payment Method"},"unusedCredit":{"HEADER":"Select Unused Ticket Credit"},"companyReference":{},"addFlightSector":{"INSTRUCTIONS":"One ticket will be booked for each individual traveler on this trip for each flight chosen."},"addHotelSector":{"SUBHEADING":"Select travelers who need a room","INSTRUCTIONS":"One identical room will be booked in the name of each selected traveler","SELECT_HOTEL_INSTRUCTIONS":"All travelers will need to stay at the same hotel on the same days"},"addCarSector":{"SUBHEADING":"Select travelers who need a car","INSTRUCTIONS":"One identical car will be booked in the name of each selected traveler"},"errorMessage":{},"approver":{}},"http":{},"validation":{"INVALID_DATE_EURO_LONG":"Must be a valid date format (mm-dd-yyyy) OR (mm/dd/yyyy). ","INVALID_DATE_EURO_LONG_BETWEEN":"Needs to be a valid date format (mm-dd-yyyy) OR (mm/dd/yyyy) between {0} and {1}. ","INVALID_DATE_EURO_LONG_MAX":"Needs to be a valid date format (mm-dd-yyyy) OR (mm/dd/yyyy), equal to, or lower than {0}. ","INVALID_DATE_EURO_LONG_MIN":"Needs to be a valid date format (mm-dd-yyyy) OR (mm/dd/yyyy), equal to, or higher than {0}. ","INVALID_DATE_EURO_SHORT":"Must be a valid date format (mm-dd-yy) OR (mm/dd/yy). ","INVALID_DATE_EURO_SHORT_BETWEEN":"Needs to be a valid date format (mm-dd-yy) OR (mm/dd/yy) between {0} and {1}. ","INVALID_DATE_EURO_SHORT_MAX":"Needs to be a valid date format (mm-dd-yy) OR (mm/dd/yy), equal to, or lower than {0}. ","INVALID_DATE_EURO_SHORT_MIN":"Needs to be a valid date format (mm-dd-yy) OR (mm/dd/yy), equal to, or higher than {0}. ","INVALID_DATE_ISO":"Must be a valid date format (yyyy-mm-dd). ","INVALID_DATE_ISO_BETWEEN":"Needs to be a valid date format (yyyy-mm-dd) between {0} and {1}. ","INVALID_DATE_ISO_MAX":"Needs to be a valid date format (yyyy-mm-dd), equal to, or lower than {0}. ","INVALID_DATE_ISO_MIN":"Needs to be a valid date format (yyyy-mm-dd), equal to, or higher than {0}. ","INVALID_DATE_US_LONG":"Must be a valid date format (mm/dd/yyyy) OR (mm-dd-yyyy). ","INVALID_DATE_US_LONG_BETWEEN":"Needs to be a valid date format (mm/dd/yyyy) OR (mm-dd-yyyy) between {0} and {1}. ","INVALID_DATE_US_LONG_MAX":"Needs to be a valid date format (mm/dd/yyyy) OR (mm-dd-yyyy), equal to, or lower than {0}. ","INVALID_DATE_US_LONG_MIN":"Needs to be a valid date format (mm/dd/yyyy) OR (mm-dd-yyyy), equal to, or higher than {0}. ","INVALID_DATE_US_SHORT":"Must be a valid date format (mm/dd/yy) OR (mm-dd-yy). ","INVALID_DATE_US_SHORT_BETWEEN":"Needs to be a valid date format (mm/dd/yy) OR (mm-dd-yy) between {0} and {1}. ","INVALID_DATE_US_SHORT_MAX":"Needs to be a valid date format (mm/dd/yy) OR (mm-dd-yy), equal to, or lower than {0}. ","INVALID_DATE_US_SHORT_MIN":"Needs to be a valid date format (mm/dd/yy) OR (mm-dd-yy), equal to, or higher than {0}. ","INVALID_TIME":"Must be a valid time format (hh:mm) OR (hh:mm:ss). ","INVALID_DATE_AUSTRALIA":"Please enter a valid date in the format: mm/dd/yyyy","COST_CENTRES_REQUIRED":"Please select a Cost Center for all travelers","DEPARTMENTS_REQUIRED":"Please select a Department for all travelers","PAYMENT_METHODS_REQUIRED":"Please select a Payment Method for all travelers"},"home":{}}

/***/ }),
/* 1692 */,
/* 1693 */,
/* 1694 */,
/* 1695 */,
/* 1696 */
/***/ (function(module, exports) {

	var angular=window.angular,ngModule;
	try {ngModule=angular.module(["ng"])}
	catch(e){ngModule=angular.module("ng",[])}
	var v1="<section ng-if=\"vm.IsAuthenticated && vm.IsEnabled\" class=\"lbWidget\">\n<div ng-if=\"vm.WidgetState === 'icon'\" class=\"lb_agentChatBackground\">\n<a ng-click=\"vm.transitionState('open-information')\">\n<div class=\"lb_agentChatIcon\"></div>\n</a>\n</div>\n<div ng-if=\"vm.WidgetState === 'open-information' || vm.WidgetState === 'open-iframe'\" class=\"lbWidget_model\">\n<div class=\"widget_Header\">\n<label>{{vm.title}}</label>\n<a class=\"widget_Close\" ng-click=\"vm.transitionState('icon')\"><i class=\"ico-down\"></i></a>\n</div>\n<div ng-if=\"vm.WidgetState === 'open-information'\" class=\"widget_Body\">\n<div ng-if=\"!!vm.feature\" class=\"widget_Action\">\n<a ng-click=\"vm.transitionState('open-iframe')\" class=\"widget_Title\">Chat with Agent <i class=\"ico-login\"></i></a>\n</div>\n<div class=\"widget_Information\">\n<div class=\"section\">\n<div ng-if=\"!!vm.SupportInformation.Phone || !!vm.SupportInformation.Email\">\n<label>Agent Support Team</label>\n<br/>\n<div ng-if=\"!!vm.SupportInformation.Phone && !!vm.SupportInformation.Email\">\n<a href=\"tel:{{vm.SupportInformation.Phone}}\">{{vm.SupportInformation.Phone}}</a> |\n<a href=\"mailto: {{vm.SupportInformation.Email}}\">{{vm.SupportInformation.Email}}</a>\n</div>\n<div ng-if=\"!!vm.SupportInformation.Phone && !vm.SupportInformation.Email\">\n<a href=\"tel:{{vm.SupportInformation.Phone}}\">{{vm.SupportInformation.Phone}}</a>\n</div>\n<div ng-if=\"!vm.SupportInformation.Phone && !!vm.SupportInformation.Email\">\n<a href=\"mailto: {{vm.SupportInformation.Email}}\">{{vm.SupportInformation.Email}}</a>\n</div>\n</div>\n<div ng-if=\"!!vm.DebtorSupportInformation.Phone || !!vm.DebtorSupportInformation.Email\">\n<br/>\n<label>Lightning Online Booking Tool</label>\n<br/>\n<label>Technical Assistance</label>\n<br/>\n<div ng-if=\"!!vm.DebtorSupportInformation.Phone && !!vm.DebtorSupportInformation.Email\">\n<a href=\"tel:{{vm.DebtorSupportInformation.Phone}}\">{{vm.DebtorSupportInformation.Phone}}</a> |\n<a href=\"mailto: {{vm.DebtorSupportInformation.Email}}\">{{vm.DebtorSupportInformation.Email}}</a>\n</div>\n<div ng-if=\"!!vm.DebtorSupportInformation.Phone && !vm.DebtorSupportInformation.Email\">\n<a href=\"tel:{{vm.DebtorSupportInformation.Phone}}\">{{vm.DebtorSupportInformation.Phone}}</a>\n</div>\n<div ng-if=\"!vm.DebtorSupportInformation.Phone && !!vm.DebtorSupportInformation.Email\">\n<a href=\"mailto: {{vm.DebtorSupportInformation.Email}}\">{{vm.DebtorSupportInformation.Email}}</a>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n<iframe ng-if=\"!!vm.feature && (vm.WidgetState === 'open-information' || vm.WidgetState === 'open-iframe')\" src=\"{{vm.IFrameSrc}}\" class=\"{{vm.IFrameClass}}\"></iframe>\n</section>\n";
	var id1="components/lbAgentChatWidget/lbAgentChatWidget.html";
	var inj=angular.element(window.document).injector();
	if(inj){inj.get("$templateCache").put(id1,v1);}
	else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
	module.exports=v1;

/***/ }),
/* 1697 */
/***/ (function(module, exports) {

	var angular=window.angular,ngModule;
	try {ngModule=angular.module(["ng"])}
	catch(e){ngModule=angular.module("ng",[])}
	var v1="<div id=\"beamerOverlay\" ng-class=\"{show: $ctrl.show}\" ng-click=\"$ctrl.close()\">\n<div id=\"beamerContainer\">\n<iframe id=\"beamerFrame\" aria-label=\"Beamer widget\" title=\"Beamer\" allowfullscreen sandbox=\"allow-scripts allow-popups allow-forms allow-top-navigation allow-same-origin\" ng-class=\"{left: $ctrl.show}\"></iframe>\n</div>\n</div>\n";
	var id1="components/lbBeamer/lbBeamer.html";
	var inj=angular.element(window.document).injector();
	if(inj){inj.get("$templateCache").put(id1,v1);}
	else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
	module.exports=v1;

/***/ }),
/* 1698 */,
/* 1699 */,
/* 1700 */,
/* 1701 */,
/* 1702 */
/***/ (function(module, exports) {

	var angular=window.angular,ngModule;
	try {ngModule=angular.module(["ng"])}
	catch(e){ngModule=angular.module("ng",[])}
	var v1="<div class=\"lbCO2message\">\nCO2 emissions data is based on an average use of {{ vm.emissionsAverageDailyKilometers }}km per day\n<i class=\"lbCurrencyMessage_infoIcon\" lb-tooltip tooltip-content=\"vm.message\" tooltip-inline=\"true\"></i>\n</div>\n";
	var id1="components/lbCO2Message/lbCO2Message.html";
	var inj=angular.element(window.document).injector();
	if(inj){inj.get("$templateCache").put(id1,v1);}
	else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
	module.exports=v1;

/***/ }),
/* 1703 */
/***/ (function(module, exports) {

	var angular=window.angular,ngModule;
	try {ngModule=angular.module(["ng"])}
	catch(e){ngModule=angular.module("ng",[])}
	var v1="<form id=\"carHandlingForm\" name=\"vm.form\" ng-submit=\"vm.form.$valid && vm.submit()\" novalidate autocomplete=\"off\">\n<div class=\"lbCarHandlingModal_body\">\n<button class=\"lbModal_close\" type=\"button\" ng-click=\"vm.cancel()\"><span>close</span></button>\n<h2>Get your car delivered/collected</h2>\n<p>\nSome depots offer to deliver and/or collect your requested vehicle at an address of your choosing. If you would like to request this service please do so below.\n</p>\n<div class=\"lbCarHandlingModal_validation\" ng-if=\"vm.form.$invalid && vm.form.$submitted\">\n<strong>Incomplete form</strong><br/>\nAll form fields are required.\n<button type=\"button\" class=\"carHandlingModal_validation_close\" ng-click=\"vm.form.$submitted = false;\">\n<i class=\"ico-cancel\"></i>\n</button>\n</div>\n<div class=\"lbCarHandlingModal_toggle\" ng-if=\"vm.delivery.isEnabled\">\n<input type=\"checkbox\" ng-change=\"vm.request('delivery', vm.delivery.isActive)\" ng-model=\"vm.delivery.isActive\" id=\"deliveryToggle\"/>\n<label for=\"deliveryToggle\">Deliver my car to me</label>\n</div>\n<ng-form name=\"vm.deliveryForm\" ng-if=\"vm.delivery.isActive\">\n<div class=\"carHandlingModal_form\">\n<div class=\"carHandlingModal_alert\" ng-show=\"!vm.delivery.isEditing\">\n<span ng-if=\"vm.deliveryForm.$valid\"> {{ vm.delivery.location | toAddressFilter }} </span>\n<span ng-if=\"vm.deliveryForm.$invalid\"> Same as collection address </span>\n<a ng-click=\"vm.edit('delivery');\">edit</a>\n</div>\n<div ng-show=\"vm.delivery.isEditing\">\n<div class=\"carHandlingModal_formRow\">\n<label>Address*</label>\n<input type=\"text\" ng-model=\"vm.delivery.location.Address\" maxlength=\"60\" ng-pattern=\"/^[A-Za-z0-9 ]*$/i\" ng-pattern-restrict ng-required=\"true\"/>\n</div>\n<div class=\"carHandlingModal_formRow\">\n<div class=\"carHandlingModal_formRow_col\">\n<label>City*</label>\n<input type=\"text\" ng-model=\"vm.delivery.location.City\" maxlength=\"30\" ng-pattern=\"/^[A-Za-z0-9 ]*$/i\" ng-pattern-restrict ng-required=\"true\"/>\n</div>\n<div class=\"carHandlingModal_formRow_col\">\n<label>Country*</label>\n<lb-country-select required=\"true\" country=\"vm.delivery.location.Country\"></lb-country-select>\n</div>\n</div>\n<div class=\"carHandlingModal_formRow\">\n<div class=\"carHandlingModal_formRow_col\" ng-if=\"vm.delivery.location.Country.Code === 'US'\">\n<label>State*</label>\n<ui-select ng-model=\"vm.delivery.location.State\" ng-required=\"true\">\n<ui-select-match placeholder=\"Select a state\"> {{ $select.selected.name }} </ui-select-match>\n<ui-select-choices repeat=\"state.code as state in vm.usStates | filter: $select.search\">\n<span ng-bind-html=\"state.name\"></span>\n</ui-select-choices>\n</ui-select>\n</div>\n<div class=\"carHandlingModal_formRow_col\">\n<label>Postcode*</label>\n<input type=\"text\" ng-model=\"vm.delivery.location.Postcode\" maxlength=\"10\" ng-pattern=\"/^[A-Za-z0-9 ]*$/i\" ng-pattern-restrict ng-required=\"true\"/>\n</div>\n</div>\n</div>\n</div>\n</ng-form>\n<div class=\"lbCarHandlingModal_toggle\" ng-if=\"vm.collection.isEnabled\">\n<input type=\"checkbox\" ng-change=\"vm.request('collection', vm.collection.isActive)\" ng-model=\"vm.collection.isActive\" id=\"collectionToggle\"/>\n<label for=\"collectionToggle\">Collect my car from me</label>\n</div>\n<ng-form name=\"vm.collectionForm\" ng-if=\"vm.collection.isActive\">\n<div class=\"carHandlingModal_form\">\n<div class=\"carHandlingModal_alert\" ng-show=\"!vm.collection.isEditing\">\n<span ng-if=\"vm.collectionForm.$valid\"> {{ vm.collection.location | toAddressFilter }} </span>\n<span ng-if=\"vm.collectionForm.$invalid\"> Same as delivery address </span>\n<a ng-click=\"vm.edit('collection');\">edit</a>\n</div>\n<div ng-show=\"vm.collection.isEditing\">\n<div class=\"carHandlingModal_formRow\">\n<label>Address*</label>\n<input type=\"text\" ng-model=\"vm.collection.location.Address\" ng-pattern=\"/^[A-Za-z0-9 ]*$/i\" ng-pattern-restrict ng-required=\"true\"/>\n</div>\n<div class=\"carHandlingModal_formRow\">\n<div class=\"carHandlingModal_formRow_col\">\n<label>City*</label>\n<input type=\"text\" ng-model=\"vm.collection.location.City\" ng-pattern=\"/^[A-Za-z0-9 ]*$/i\" ng-pattern-restrict ng-required=\"true\"/>\n</div>\n<div class=\"carHandlingModal_formRow_col\">\n<label>Country*</label>\n<lb-country-select required=\"true\" country=\"vm.collection.location.Country\"></lb-country-select>\n</div>\n</div>\n<div class=\"carHandlingModal_formRow\">\n<div class=\"carHandlingModal_formRow_col\" ng-if=\"vm.collection.location.Country.Code === 'US'\">\n<label>State*</label>\n<ui-select ng-model=\"vm.collection.location.State\" ng-required=\"true\">\n<ui-select-match placeholder=\"Select a state\"> {{ $select.selected.name }} </ui-select-match>\n<ui-select-choices repeat=\"state.code as state in vm.usStates | filter: $select.search\">\n<span ng-bind-html=\"state.name\"></span>\n</ui-select-choices>\n</ui-select>\n</div>\n<div class=\"carHandlingModal_formRow_col\">\n<label>Postcode*</label>\n<input type=\"text\" ng-model=\"vm.collection.location.Postcode\" ng-pattern=\"/^[A-Za-z0-9 ]*$/i\" ng-pattern-restrict ng-required=\"true\"/>\n</div>\n</div>\n</div>\n</div>\n</ng-form>\n</div>\n<div class=\"lbModal_actions\">\n<button class=\"button-link\" type=\"button\" ng-click=\"vm.cancel()\">Cancel</button>\n<button class=\"button-primary\" type=\"submit\">Save</button>\n</div>\n</form>\n";
	var id1="components/lbCarHandlingModal/lbCarHandlingModal.html";
	var inj=angular.element(window.document).injector();
	if(inj){inj.get("$templateCache").put(id1,v1);}
	else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
	module.exports=v1;

/***/ }),
/* 1704 */,
/* 1705 */,
/* 1706 */
/***/ (function(module, exports) {

	var angular=window.angular,ngModule;
	try {ngModule=angular.module(["ng"])}
	catch(e){ngModule=angular.module("ng",[])}
	var v1="<div class=\"lbCountrySelect\">\n<ui-select class=\"lbCountrySelect_input\" ng-model=\"vm.country\" ng-required=\"vm.required\" ng-disabled=\"vm.disabled\">\n<ui-select-match placeholder=\"{{ ::vm.placeholder }}\"> {{ $select.selected.Name }} </ui-select-match>\n<ui-select-choices repeat=\"item in vm.countries | filter: $select.search\">\n<span ng-bind-html=\"item.Name\"></span>\n</ui-select-choices>\n</ui-select>\n</div>\n";
	var id1="components/lbCountrySelect/lbCountrySelect.html";
	var inj=angular.element(window.document).injector();
	if(inj){inj.get("$templateCache").put(id1,v1);}
	else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
	module.exports=v1;

/***/ }),
/* 1707 */
/***/ (function(module, exports) {

	var angular=window.angular,ngModule;
	try {ngModule=angular.module(["ng"])}
	catch(e){ngModule=angular.module("ng",[])}
	var v1="<div class=\"lbCurrencyMessage\">\nAll prices shown in {{ vm.currencyCode }} unless otherwise stated &nbsp;\n<i class=\"lbCurrencyMessage_infoIcon\" lb-tooltip tooltip-content=\"vm.message\" tooltip-inline=\"true\"></i>\n</div>\n";
	var id1="components/lbCurrencyMessage/lbCurrencyMessage.html";
	var inj=angular.element(window.document).injector();
	if(inj){inj.get("$templateCache").put(id1,v1);}
	else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
	module.exports=v1;

/***/ }),
/* 1708 */
/***/ (function(module, exports) {

	var angular=window.angular,ngModule;
	try {ngModule=angular.module(["ng"])}
	catch(e){ngModule=angular.module("ng",[])}
	var v1="<div class=\"lbDateInput {{vm.class}}\" ng-click=\"vm.openDatePicker($event)\">\n<label><i class=\"ico-calendar\"></i>\n<input type=\"text\" name=\"{{vm.name}}\" id=\"{{vm.name}}\" ng-model=\"vm.date\" ng-focus=\"vm.openDatePicker($event)\" ng-required=\"vm.required\" ng-disabled=\"vm.disabled\" readonly=\"readonly\"/></label>\n</div>\n";
	var id1="components/lbDateInput/lbDateInput.html";
	var inj=angular.element(window.document).injector();
	if(inj){inj.get("$templateCache").put(id1,v1);}
	else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
	module.exports=v1;

/***/ }),
/* 1709 */
/***/ (function(module, exports) {

	var angular=window.angular,ngModule;
	try {ngModule=angular.module(["ng"])}
	catch(e){ngModule=angular.module("ng",[])}
	var v1="<div class=\"lbDatePicker\" ng-click=\"vm.closeDatePicker()\">\n<div class=\"lbDatePicker_calendar\" ng-click=\"$event.stopPropagation()\">\n<div pickadate ng-model=\"vm.date\" format=\"{{ vm.dateFormat }}\" on-date-select=\"vm.dateSelected(date)\" min-date=\"vm.minDateFormatted\" max-date=\"vm.maxDateFormatted\" range-from=\"vm.rangeFromFormatted\" range-to=\"vm.rangeToFormatted\"></div>\n<div class=\"lbDatePicker_close\">\n<button class=\"lbDatePicker_close_button\" ng-click=\"vm.closeDatePicker()\" id=\"lbDatePickerClose\">Close</button>\n</div>\n</div>\n</div>\n";
	var id1="components/lbDatePicker/lbDatePicker.html";
	var inj=angular.element(window.document).injector();
	if(inj){inj.get("$templateCache").put(id1,v1);}
	else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
	module.exports=v1;

/***/ }),
/* 1710 */,
/* 1711 */
/***/ (function(module, exports) {

	var angular=window.angular,ngModule;
	try {ngModule=angular.module(["ng"])}
	catch(e){ngModule=angular.module("ng",[])}
	var v1="<div class=\"lbDialog\" ng-if=\"vm.lbDialogService.visible\" ng-class=\"vm.lbDialogService.options.warningLevel\">\n<div class=\"lbDialog_bg\" ng-click=\"vm.lbDialogService.cancel()\" ng-if=\"vm.lbDialogService.options.showCancelButton\"></div>\n<div class=\"lbDialog_modalBoxWrapper\">\n<div class=\"lbDialog_modalBox\">\n<header class=\"lbDialog_header\">\n<h3 class=\"lbDialog_heading\">\n<i class=\"ico {{ ::vm.lbDialogService.options.icon }}\" ng-if=\"vm.lbDialogService.options.icon\"></i>\n<em ng-if=\"!vm.lbDialogService.options.icon\"></em>\n<span ng-bind-html=\"vm.lbDialogService.options.title\"></span>\n</h3>\n<button class=\"lbDialog_cancel ico-cancel\" ng-click=\"vm.lbDialogService.cancel()\" title=\"cancel\" ng-if=\"vm.lbDialogService.options.showCancelButton\"></button>\n</header>\n<div class=\"lbDialog_content\">\n<div class=\"lbDialog_content_message\" ng-bind-html=\"::vm.lbDialogService.options.message\"></div>\n<div class=\"lbDialog_content_message\" ng-bind-html=\"::vm.lbDialogService.options.message2\" ng-if=\"::vm.lbDialogService.options.message2\"></div>\n<ui-select ng-model=\"vm.lbDialogService.selectedItem\" class=\"lbDialog_select\" ng-if=\"vm.lbDialogService.options.selections.length > 0\">\n<ui-select-match class=\"lbDialog_selected\">\n<span ng-bind=\"$select.selected.name\"></span>\n</ui-select-match>\n<ui-select-choices repeat=\"item in (vm.lbDialogService.options.selections) track by item.name\">\n<span ng-bind=\"item.name\"></span>\n</ui-select-choices>\n</ui-select>\n</div>\n<div class=\"lbDialog_actions\">\n<button class=\"button-link\" ng-click=\"vm.lbDialogService.cancel()\" ng-if=\"vm.lbDialogService.options.showCancelButton\">\nCancel\n</button>\n<button class=\"button-primary\" ng-click=\"vm.lbDialogService.submit()\">{{ ::vm.lbDialogService.options.submitButtonText }}</button>\n</div>\n</div>\n</div>\n</div>\n";
	var id1="components/lbDialog/lbDialog.html";
	var inj=angular.element(window.document).injector();
	if(inj){inj.get("$templateCache").put(id1,v1);}
	else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
	module.exports=v1;

/***/ }),
/* 1712 */
/***/ (function(module, exports) {

	var angular=window.angular,ngModule;
	try {ngModule=angular.module(["ng"])}
	catch(e){ngModule=angular.module("ng",[])}
	var v1="<div class=\"lbErrorModal\" ng-class=\"{ 'lbErrorModal-warning': vm.warnLevel === 'warning' }\">\n<header class=\"lbModal_header\" ng-switch=\"vm.warnLevel\">\n<button class=\"lbModal_close\" ng-click=\"vm.close()\"><span>close</span></button>\n<h2 ng-switch-when=\"info\"><i class=\"ico-info-circle\"></i> {{ ::vm.errorMessage }}</h2>\n<h2 ng-switch-default><i class=\"ico-fontawesome-webfont\"></i> {{ ::vm.errorMessage }}</h2>\n</header>\n<div class=\"lbModal_body\">\n<p>{{ ::vm.errorDesc }}</p>\n<p class=\"modal_note\" ng-if=\"vm.instructions\">\n{{ ::vm.instructions }}\n<br/>\n<br/>\n{{ ::vm.errorSupportMessage }}\n</p>\n</div>\n<div class=\"lbModal_actions\">\n<button class=\"button-primary\" ng-click=\"vm.close()\">OK</button>\n</div>\n</div>\n";
	var id1="components/lbErrorModal/lbErrorModal.html";
	var inj=angular.element(window.document).injector();
	if(inj){inj.get("$templateCache").put(id1,v1);}
	else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
	module.exports=v1;

/***/ }),
/* 1713 */,
/* 1714 */
/***/ (function(module, exports) {

	var angular=window.angular,ngModule;
	try {ngModule=angular.module(["ng"])}
	catch(e){ngModule=angular.module("ng",[])}
	var v1="<header class=\"lbModal_header\">\n<button class=\"lbModal_close\" ng-click=\"vm.close()\"><span>close</span></button>\n<h2>Fare Conditions - {{ vm.carrierName }}</h2>\n</header>\n<div id=\"tabs\">\n<div ng-repeat=\"tab in tabs track by $index\" class=\"tab\" ng-click=\"setActiveTab(tab)\">\n<small>{{ tab.title }}</small>\n</div>\n</div>\n<div id=\"content\">\n<div ng-repeat=\"tab in tabs track by $index\" ng-show=\"tab.active\">\n<h4>{{ tab.title }}</h4>\n<div class=\"detail\" ng-bind-html=\"tab.content\"></div>\n</div>\n</div>\n<style>\n.lbModal_wrapper {\r\n    width: 600px;\r\n    overflow: hidden !important;\r\n    max-height: 79vh !important;\r\n  }\n</style>";
	var id1="components/lbFareRulesModal/lbFareRulesModal.html";
	var inj=angular.element(window.document).injector();
	if(inj){inj.get("$templateCache").put(id1,v1);}
	else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
	module.exports=v1;

/***/ }),
/* 1715 */
/***/ (function(module, exports) {

	var angular=window.angular,ngModule;
	try {ngModule=angular.module(["ng"])}
	catch(e){ngModule=angular.module("ng",[])}
	var v1="<div class=\"lbHotelResultsCardItem_rating rating-stars\" ng-attr-title=\"{{::vm.rating}} out of 5\">\n<i ng-class=\"{ 'ico-star-filled': vm.shouldBeWholeStar(1), 'ico-star-half': vm.shouldBeHalfStar(1), 'ico-star-empty': vm.shouldBeEmptyStar(1) }\"></i>\n<i ng-class=\"{ 'ico-star-filled': vm.shouldBeWholeStar(2), 'ico-star-half': vm.shouldBeHalfStar(2), 'ico-star-empty': vm.shouldBeEmptyStar(2) }\"></i>\n<i ng-class=\"{ 'ico-star-filled': vm.shouldBeWholeStar(3), 'ico-star-half': vm.shouldBeHalfStar(3), 'ico-star-empty': vm.shouldBeEmptyStar(3) }\"></i>\n<i ng-class=\"{ 'ico-star-filled': vm.shouldBeWholeStar(4), 'ico-star-half': vm.shouldBeHalfStar(4), 'ico-star-empty': vm.shouldBeEmptyStar(4) }\"></i>\n<i ng-class=\"{ 'ico-star-filled': vm.shouldBeWholeStar(5), 'ico-star-half': vm.shouldBeHalfStar(5), 'ico-star-empty': vm.shouldBeEmptyStar(5) }\"></i>\n</div>\n";
	var id1="components/lbFiveStarRating/lbFiveStarRatingTemplate.html";
	var inj=angular.element(window.document).injector();
	if(inj){inj.get("$templateCache").put(id1,v1);}
	else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
	module.exports=v1;

/***/ }),
/* 1716 */,
/* 1717 */,
/* 1718 */,
/* 1719 */
/***/ (function(module, exports, __webpack_require__) {

	var angular=window.angular,ngModule;
	try {ngModule=angular.module(["ng"])}
	catch(e){ngModule=angular.module("ng",[])}
	var v1="\n<header id=\"lbHeader\">\n<nav>\n<menu class=\"menu-left\">\n<li>\n<a ng-click=\"vm.goMain()\" class=\"logo\"><img src=\"" + __webpack_require__(1688) + "\" alt=\"Lightning\"/></a>\n</li>\n<li><a ng-click=\"vm.goTo('app.home')\" ng-class=\"vm.getClass('/')\">New Booking</a></li>\n<li><a ng-click=\"vm.goTo('app.mybookings')\" ng-class=\"vm.getClass('/my-bookings')\">Manage Bookings</a></li>\n</menu>\n<menu class=\"menu-right\">\n<li class=\"notification\" title=\"Open Lightning notifications\" ng-if=\"vm.showNotifications\">\n<img src=\"" + __webpack_require__(1684) + "\" alt=\"Notifications\" id=\"notificationIcon\" ng-click=\"vm.openNotifications()\"/>\n<span id=\"notificationBadge\" ng-if=\"vm.notificationCount >= 1\" title=\"You have unread notifications\">{{vm.notificationCount}}</span>\n</li>\n<menu class=\"user\">\n<li>\n<div class=\"circle\">\n<span class=\"initials\">{{ vm.userInitials}}</span>\n</div>\n</li>\n<li><a>{{::vm.fullName}}</a></li>\n<li><i class=\"ico-chevron-down\"></i></li>\n<div class=\"userMenu\">\n<a ng-click=\"vm.logout()\" title=\"Log out\">Log out</a>\n</div>\n</menu>\n</menu>\n</nav>\n</header>";
	var id1="components/lbHeader/lbHeader.html";
	var inj=angular.element(window.document).injector();
	if(inj){inj.get("$templateCache").put(id1,v1);}
	else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
	module.exports=v1;

/***/ }),
/* 1720 */,
/* 1721 */
/***/ (function(module, exports) {

	var angular=window.angular,ngModule;
	try {ngModule=angular.module(["ng"])}
	catch(e){ngModule=angular.module("ng",[])}
	var v1="<div ng-if=\"vm.status == 'BadRequest'\">\n<header class=\"lbModal_header\">\n<button class=\"lbModal_close\" ng-click=\"vm.close()\"><span>close</span></button>\n<h2><em></em> Room/Rate selected is not available</h2>\n</header>\n<div class=\"lbModal_body\">The room/rate selected is not available. Please remove the room and select another before continuing.</div>\n<div class=\"lbModal_actions\">\n<button class=\"button-primary\" ng-click=\"vm.close()\">OK</button>\n</div>\n</div>\n<div ng-if=\"vm.status == 'PriceChanged'\">\n<header class=\"lbModal_header\">\n<button class=\"lbModal_close\" ng-click=\"vm.close()\"><span>close</span></button>\n<h2><em></em> Price Change</h2>\n</header>\n<div class=\"lbModal_body\">\nThe hotel has returned a different rate for the selected room. Refresh your search to check for the price change or select another rate.\n</div>\n<div class=\"lbModal_actions\">\n<button class=\"button-primary\" ng-click=\"vm.close()\">OK</button>\n</div>\n</div>\n";
	var id1="components/lbHotelPriceCheckModal/lbHotelPriceCheckModal.html";
	var inj=angular.element(window.document).injector();
	if(inj){inj.get("$templateCache").put(id1,v1);}
	else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
	module.exports=v1;

/***/ }),
/* 1722 */,
/* 1723 */
/***/ (function(module, exports) {

	var angular=window.angular,ngModule;
	try {ngModule=angular.module(["ng"])}
	catch(e){ngModule=angular.module("ng",[])}
	var v1="<div class=\"lbLoadingPlaceholder\">\n<div class=\"lbLoadingPlaceholder_content\" ng-transclude></div>\n</div>\n";
	var id1="components/lbLoadingPlaceholder/lbLoadingPlaceholder.html";
	var inj=angular.element(window.document).injector();
	if(inj){inj.get("$templateCache").put(id1,v1);}
	else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
	module.exports=v1;

/***/ }),
/* 1724 */
/***/ (function(module, exports) {

	var angular=window.angular,ngModule;
	try {ngModule=angular.module(["ng"])}
	catch(e){ngModule=angular.module("ng",[])}
	var v1="<div class=\"lbLoadingPlaceholderItem\" ng-class=\"{ 'lbLoadingPlaceholderItem-heading': vm.isHeading }\" style=\"width: {{ ::item.width }};\" ng-repeat=\"item in ::vm.items\"></div>\n";
	var id1="components/lbLoadingPlaceholder/lbLoadingPlaceholderItem.html";
	var inj=angular.element(window.document).injector();
	if(inj){inj.get("$templateCache").put(id1,v1);}
	else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
	module.exports=v1;

/***/ }),
/* 1725 */
/***/ (function(module, exports) {

	var angular=window.angular,ngModule;
	try {ngModule=angular.module(["ng"])}
	catch(e){ngModule=angular.module("ng",[])}
	var v1="<div class=\"lbLocationSelect\">\n<ui-select class=\"lbLocationSelect_input\" name=\"{{ ::vm.name }}\" on-select=\"vm.select($select.selected)\" ng-model=\"vm.location\" ng-required=\"vm.required\" ng-disabled=\"vm.disabled\" use-custom-group-label=\"true\" ng-class=\"{ sctUiSelect: vm.sct }\">\n<ui-select-match class=\"lbLocationSelect_match\" allow-clear=\"true\" placeholder=\"{{ vm.placeholder }}\">\n<i class=\"ico-marker lbLocationSelect_inputIcon\"></i> {{ $select.selected.displayLabel || $select.selected.Name }}\n<a ng-if=\"$select.selected\" ng-click=\"vm.remove();\" class=\"lbLocationSelect_remove\"><i class=\"ico-cancel\"></i></a>\n</ui-select-match>\n<ui-select-choices repeat=\"item in vm.locations\" refresh=\"vm.refreshLocations($select.search)\" refresh-delay=\"200\" group-by=\"vm.groupBy\" disable-group-headers=\"true\">\n<span class=\"location_choice\" ng-class=\"{ 'location_choice_header': item.isGroupHeader }\">\n<span ng-if=\"item.hasCode\" ng-bind-html=\"item.Value | highlight: $select.search\" class=\"location_choice_code\"></span>\n<span ng-bind-html=\"item.displayLabel | highlight: $select.search\"></span>\n</span>\n</ui-select-choices>\n</ui-select>\n<i class=\"button_spinner lbLocationSelect_loader\" ng-if=\"vm.showLoader\"></i>\n</div>\n";
	var id1="components/lbLocationSelect/lbLocationSelect.html";
	var inj=angular.element(window.document).injector();
	if(inj){inj.get("$templateCache").put(id1,v1);}
	else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
	module.exports=v1;

/***/ }),
/* 1726 */,
/* 1727 */,
/* 1728 */
/***/ (function(module, exports) {

	var angular=window.angular,ngModule;
	try {ngModule=angular.module(["ng"])}
	catch(e){ngModule=angular.module("ng",[])}
	var v1="<div role=\"dialog\" class=\"lbModal {{ ::vm.options.className }}\" ng-class=\"{ 'lbModal-scroll': vm.options.scroll }\" ng-if=\"vm.modalContent\">\n<div class=\"lbModal_wrapper\" ng-style=\"{ 'width': vm.options.width, 'max-width': '80vw', 'overflow': 'auto', 'max-height': '75vh' }\">\n<div class=\"lbModal_content\"></div>\n</div>\n</div>\n";
	var id1="components/lbModal/lbModal.html";
	var inj=angular.element(window.document).injector();
	if(inj){inj.get("$templateCache").put(id1,v1);}
	else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
	module.exports=v1;

/***/ }),
/* 1729 */,
/* 1730 */
/***/ (function(module, exports) {

	var angular=window.angular,ngModule;
	try {ngModule=angular.module(["ng"])}
	catch(e){ngModule=angular.module("ng",[])}
	var v1="<div class=\"lbPoiSelect\">\n<ui-select class=\"lbPoiSelect_input\" name=\"{{ ::vm.name }}\" ng-model=\"vm.location\" ng-required=\"vm.required\" ng-disabled=\"vm.disabled\" on-select=\"vm.onSelect({location:vm.location})\">\n<ui-select-match placeholder=\"{{ ::vm.placeholder }}\">\n{{ $select.selected.Title }}\n<button class=\"lbPoiSelect_clear\" ng-if=\"vm.allowClear\" ng-click=\"$select.clear($event);vm.onRemove();\">\n<i class=\"ico-cancel\"></i>\n</button>\n</ui-select-match>\n<ui-select-choices repeat=\"item in vm.options\" refresh=\"vm.refreshOptions($select.search)\" refresh-delay=\"vm.refreshDelay\">\n<i class=\"ui-select-choices-row_icon {{ item.Type | locationIconFilter }}\"></i>\n<span ng-bind-html=\"item.Title | poiHighlightFilter: $select.search\" title=\"{{::item.Title}}\"></span>\n</ui-select-choices>\n</ui-select>\n<i class=\"{{ ::vm.iconClassName }} lbPoiSelect_icon\"></i>\n<i class=\"button_spinner lbPoiSelect_loader\" ng-if=\"vm.showLoader\"></i>\n</div>\n";
	var id1="components/lbPoiSelect/lbPoiSelect.html";
	var inj=angular.element(window.document).injector();
	if(inj){inj.get("$templateCache").put(id1,v1);}
	else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
	module.exports=v1;

/***/ }),
/* 1731 */,
/* 1732 */,
/* 1733 */,
/* 1734 */,
/* 1735 */,
/* 1736 */
/***/ (function(module, exports) {

	var angular=window.angular,ngModule;
	try {ngModule=angular.module(["ng"])}
	catch(e){ngModule=angular.module("ng",[])}
	var v1="<div class=\"lbTimeSelect\">\n<ui-select name=\"{{ ::vm.name }}\" ng-model=\"vm.selectedTime\" search-enabled=\"true\" ng-required=\"vm.required\" time-format=\"{{ vm.timeFormat }}\" lb-future-time=\"{{ vm.date }}\" lb-sequential-time=\"{{ vm.sequentialTime }}\" lb-sequential-time-date=\"{{ vm.date }}\" lb-sequential-time-before-date=\"{{ vm.beforeDate }}\" lb-sequential-time-before-time=\"{{ vm.beforeTime }}\">\n<ui-select-match>\n<i class=\"ico-clock bookingform_match_icon\"></i>\n<span class=\"bookingform_match_span\">{{ $select.selected.label }}</span>\n</ui-select-match>\n<ui-select-choices repeat=\"time.value as time in vm.times | filter: $select.search\"> {{ time.label }} </ui-select-choices>\n</ui-select>\n</div>\n";
	var id1="components/lbTimeSelect/lbTimeSelect.html";
	var inj=angular.element(window.document).injector();
	if(inj){inj.get("$templateCache").put(id1,v1);}
	else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
	module.exports=v1;

/***/ }),
/* 1737 */
/***/ (function(module, exports) {

	var angular=window.angular,ngModule;
	try {ngModule=angular.module(["ng"])}
	catch(e){ngModule=angular.module("ng",[])}
	var v1="<header class=\"lbModal_header\">\n<h2><i class=\"ico-fontawesome-webfont\"></i> Idle Timeout</h2>\n</header>\n<div class=\"lbModal_body\" idle-countdown=\"countdown\">\n<p ng-switch=\"countdown\">You will be logged out in {{ countdown }} {{ vm.getCountdownNoun(countdown) }} due to inactivity.</p>\n<div class=\"modalProgress\">\n<span class=\"modalProgress_indicator\" ng-show=\"countdown > 0\" style=\"width:{{\r\n    (countdown / vm.timeoutValue) * 100 }}%\"></span>\n</div>\n</div>\n<div class=\"lbModal_actions\">\n<button type=\"button\" class=\"button-primary\" ng-click=\"vm.close()\">Continue using Lightning book</button>\n</div>\n";
	var id1="components/lbTimeoutModal/lbTimeoutModal.html";
	var inj=angular.element(window.document).injector();
	if(inj){inj.get("$templateCache").put(id1,v1);}
	else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
	module.exports=v1;

/***/ }),
/* 1738 */
/***/ (function(module, exports) {

	var angular=window.angular,ngModule;
	try {ngModule=angular.module(["ng"])}
	catch(e){ngModule=angular.module("ng",[])}
	var v1="<div class=\"lbToggle\" ng-click=\"vm.toggle()\" ng-class=\"{ 'lbToggle-active': vm.isActive }\">\n<div class=\"lbToggle_icon\"></div>\n</div>\n";
	var id1="components/lbToggle/lbToggle.html";
	var inj=angular.element(window.document).injector();
	if(inj){inj.get("$templateCache").put(id1,v1);}
	else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
	module.exports=v1;

/***/ }),
/* 1739 */,
/* 1740 */
/***/ (function(module, exports) {

	var angular=window.angular,ngModule;
	try {ngModule=angular.module(["ng"])}
	catch(e){ngModule=angular.module("ng",[])}
	var v1="<ng-form name=\"vm.lbTripOptionsCarForm\" class=\"lbTripOptionsCarForm\">\n<div ng-repeat=\"search in vm.searches track by $index\">\n<lb-trip-options-car-form-item search=\"search\" is-last=\"$last\" index=\"$index\"> </lb-trip-options-car-form-item>\n</div>\n</ng-form>\n";
	var id1="components/lbTripOptionsModal/lbTripOptionsCarForm.html";
	var inj=angular.element(window.document).injector();
	if(inj){inj.get("$templateCache").put(id1,v1);}
	else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
	module.exports=v1;

/***/ }),
/* 1741 */
/***/ (function(module, exports) {

	var angular=window.angular,ngModule;
	try {ngModule=angular.module(["ng"])}
	catch(e){ngModule=angular.module("ng",[])}
	var v1="<div class=\"lbTripOptionsFormItem\" ng-class=\"{\r\n         'lbTripOptionsFormItem-disabled': !vm.search.isActive,\r\n         'lbTripOptionsFormItem-last': vm.isLast\r\n     }\">\n<div class=\"lbTripOptionsFormItem_flightDetails\">\n<h3 class=\"lbTripOptionsFormItem_flightDetails_title\">\n<i>{{ vm.index + 1 }}.</i>\n{{ ::vm.search.flight.Arrival.Location }} ({{ ::vm.search.flight.Arrival.Code }})\n</h3>\n<div class=\"lbTripOptionsFormItem_flightDetails_times\">\n<div title=\"Departure time\">\n<i class=\"ico-icon-takeoff\"></i> {{ ::vm.search.flight.Departure.Date | amParse:'YYYY-MM-DD HH:mm:ss' | amDateFormat: vm.flightDateTimeFormat }}\n</div>\n<div title=\"Arrival time\">\n<i class=\"ico-icon-landing\"></i> {{ ::vm.search.flight.Arrival.Date | amParse:'YYYY-MM-DD HH:mm:ss' | amDateFormat: vm.flightDateTimeFormat }}\n</div>\n</div>\n<lb-toggle is-active=\"vm.search.isActive\"></lb-toggle>\n</div>\n<div class=\"lbTripOptionsFormItem_form\">\n<div class=\"lbTripOptionsFormItem_form_row\">\n<div class=\"lbTripOptionsCarFormItem_form_location\">\n<label class=\"lbTripOptionsFormItem_formLabel\">Pick up</label>\n<div class=\"lbTripOptionsHotelFormItem_form_inputHolder\">\n<lb-location-select name=\"{{ 'carPickUpLocation.' + vm.index }}\" location=\"vm.search.car.pickUp.Location\" required=\"vm.search.isActive\" disabled=\"!vm.search.isActive\">\n</lb-location-select>\n</div>\n</div>\n<div class=\"lbTripOptionsHotelFormItem_form_dates\">\n<div class=\"lbTripOptionsHotelFormItem_form_fromDate\">\n<label class=\"lbTripOptionsFormItem_formLabel\">Date</label>\n<div class=\"lbTripOptionsHotelFormItem_form_inputHolder\">\n<lb-date-select name=\"{{ 'carPickUpDate.' + vm.index }}\" date=\"vm.search.car.pickUp.Date\" min=\"vm.search.car.pickUp.minDate\" max=\"vm.search.car.pickUp.maxDate\" range-from=\"vm.search.car.pickUp.Date\" range-to=\"vm.search.car.dropOff.Date\" required=\"vm.search.isActive\" disabled=\"!vm.search.isActive\">\n</lb-date-select>\n</div>\n</div>\n<div class=\"lbTripOptionsHotelFormItem_form_toDate\">\n<label class=\"lbTripOptionsFormItem_formLabel\">Time</label>\n<div class=\"lbTripOptionsHotelFormItem_form_inputHolder\">\n<lb-time-select name=\"{{ 'carPickUpTime.' + vm.index }}\" date=\"vm.search.car.pickUp.Date\" time=\"vm.search.car.pickUp.Time\" sequential-time=\"false\" anytime=\"false\" required=\"vm.search.isActive\" disabled=\"!vm.search.isActive\">\n</lb-time-select>\n</div>\n</div>\n</div>\n</div>\n<div class=\"lbTripOptionsFormItem_form_row\">\n<div class=\"lbTripOptionsCarFormItem_form_location\">\n<label class=\"lbTripOptionsFormItem_formLabel\">Drop off</label>\n<div class=\"lbTripOptionsHotelFormItem_form_inputHolder\">\n<lb-location-select name=\"{{ 'carDropOffLocation.' + vm.index }}\" location=\"vm.search.car.dropOff.Location\" required=\"vm.search.isActive\" disabled=\"!vm.search.isActive\">\n</lb-location-select>\n</div>\n</div>\n<div class=\"lbTripOptionsHotelFormItem_form_dates\">\n<div class=\"lbTripOptionsHotelFormItem_form_fromDate\">\n<label class=\"lbTripOptionsFormItem_formLabel\">Date</label>\n<div class=\"lbTripOptionsHotelFormItem_form_inputHolder\">\n<lb-date-select name=\"{{ 'carDropOffDate.' + vm.index }}\" date=\"vm.search.car.dropOff.Date\" min=\"vm.search.car.dropOff.minDate\" max=\"vm.search.car.dropOff.maxDate\" range-from=\"vm.search.car.pickUp.Date\" range-to=\"vm.search.car.dropOff.Date\" required=\"vm.search.isActive\" disabled=\"!vm.search.isActive\">\n</lb-date-select>\n</div>\n</div>\n<div class=\"lbTripOptionsHotelFormItem_form_toDate\">\n<label class=\"lbTripOptionsFormItem_formLabel\">Time</label>\n<div class=\"lbTripOptionsHotelFormItem_form_inputHolder\">\n<lb-time-select name=\"{{ 'carDropOffTime.' + vm.index }}\" date=\"vm.search.car.dropOff.Date\" time=\"vm.search.car.dropOff.Time\" sequential-time=\"false\" anytime=\"false\" required=\"vm.search.isActive\" disabled=\"!vm.search.isActive\">\n</lb-time-select>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n";
	var id1="components/lbTripOptionsModal/lbTripOptionsCarFormItem.html";
	var inj=angular.element(window.document).injector();
	if(inj){inj.get("$templateCache").put(id1,v1);}
	else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
	module.exports=v1;

/***/ }),
/* 1742 */
/***/ (function(module, exports) {

	var angular=window.angular,ngModule;
	try {ngModule=angular.module(["ng"])}
	catch(e){ngModule=angular.module("ng",[])}
	var v1="<ng-form name=\"vm.lbTripOptionsHotelForm\" class=\"lbTripOptionsHotelForm\">\n<div ng-repeat=\"search in vm.searches track by $index\">\n<lb-trip-options-hotel-form-item search=\"search\" is-last=\"$last\" index=\"$index\"> </lb-trip-options-hotel-form-item>\n</div>\n</ng-form>\n";
	var id1="components/lbTripOptionsModal/lbTripOptionsHotelForm.html";
	var inj=angular.element(window.document).injector();
	if(inj){inj.get("$templateCache").put(id1,v1);}
	else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
	module.exports=v1;

/***/ }),
/* 1743 */
/***/ (function(module, exports) {

	var angular=window.angular,ngModule;
	try {ngModule=angular.module(["ng"])}
	catch(e){ngModule=angular.module("ng",[])}
	var v1="<div class=\"lbTripOptionsFormItem\" ng-class=\"{\r\n         'lbTripOptionsFormItem-disabled': !vm.search.isActive,\r\n         'lbTripOptionsFormItem-last': vm.isLast\r\n     }\">\n<div class=\"lbTripOptionsFormItem_flightDetails\">\n<h3 class=\"lbTripOptionsFormItem_flightDetails_title\">\n<i>{{ vm.index + 1 }}.</i>\n{{ ::vm.search.flight.Arrival.Location }} ({{ ::vm.search.flight.Arrival.Code }})\n</h3>\n<div class=\"lbTripOptionsFormItem_flightDetails_times\">\n<div title=\"Departure time\">\n<i class=\"ico-icon-takeoff\"></i> {{ ::vm.search.flight.Departure.Date | amParse:'YYYY-MM-DD HH:mm:ss' | amDateFormat: vm.flightDateTimeFormat }}\n</div>\n<div title=\"Arrival time\">\n<i class=\"ico-icon-landing\"></i> {{ ::vm.search.flight.Arrival.Date | amParse:'YYYY-MM-DD HH:mm:ss' | amDateFormat: vm.flightDateTimeFormat }}\n</div>\n</div>\n<lb-toggle is-active=\"vm.search.isActive\"></lb-toggle>\n</div>\n<div class=\"lbTripOptionsFormItem_form\">\n<div class=\"lbTripOptionsHotelFormItem_form_location\">\n<label class=\"lbTripOptionsFormItem_formLabel\">Location</label>\n<div class=\"lbTripOptionsHotelFormItem_form_inputHolder\">\n<lb-poi-select name=\"{{ 'hoteLocation.' + vm.index }}\" required=\"vm.search.isActive\" location=\"vm.search.hotel.Location\" disabled=\"!vm.search.isActive\" disable-placeholder=\"true\">\n</lb-poi-select>\n</div>\n</div>\n<div class=\"lbTripOptionsHotelFormItem_form_dates\">\n<div class=\"lbTripOptionsHotelFormItem_form_fromDate\">\n<label class=\"lbTripOptionsFormItem_formLabel\">Check in</label>\n<div class=\"lbTripOptionsHotelFormItem_form_inputHolder\">\n<lb-date-input name=\"{{ 'hotelCheckIn.' + vm.index }}\" date=\"vm.search.hotel.dateFrom\" min-date=\"vm.search.hotel.minDateFrom\" max-date=\"vm.search.hotel.maxDate\" range-from=\"vm.search.hotel.dateFrom\" range-to=\"vm.search.hotel.dateTo\" required=\"vm.search.isActive\" disabled=\"!vm.search.isActive\" class=\"form_date_input\" date-format=\"vm.dateFormat\">\n</lb-date-input>\n</div>\n</div>\n<div class=\"lbTripOptionsHotelFormItem_form_toDate\">\n<label class=\"lbTripOptionsFormItem_formLabel\">Check out</label>\n<div class=\"lbTripOptionsHotelFormItem_form_inputHolder\">\n<lb-date-input name=\"{{ 'hotelCheckOut.' + vm.index }}\" date=\"vm.search.hotel.dateTo\" min-date=\"vm.search.hotel.dateFrom\" max-date=\"vm.search.hotel.maxDate\" range-from=\"vm.search.hotel.dateFrom\" range-to=\"vm.search.hotel.dateTo\" required=\"vm.search.isActive\" disabled=\"!vm.search.isActive\" class=\"form_date_input\" date-format=\"vm.dateFormat\">\n</lb-date-input>\n</div>\n</div>\n</div>\n</div>\n</div>\n";
	var id1="components/lbTripOptionsModal/lbTripOptionsHotelFormItem.html";
	var inj=angular.element(window.document).injector();
	if(inj){inj.get("$templateCache").put(id1,v1);}
	else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
	module.exports=v1;

/***/ }),
/* 1744 */
/***/ (function(module, exports) {

	var angular=window.angular,ngModule;
	try {ngModule=angular.module(["ng"])}
	catch(e){ngModule=angular.module("ng",[])}
	var v1="<header class=\"lbTripOptionsModal_header-hotel\" ng-if=\"vm.options[vm.activeOptionIndex] === 'hotel'\">\n<div class=\"lbTripOptionsModal_headerIcon\">\n<i class=\"ico-bed lbTripOptionsModal_headerIcon-main\"></i>\n<i class=\"ico-add lbTripOptionsModal_headerIcon-sub\"></i>\n</div>\n<p class=\"lbTripOptionsModal_headerIntro\">Add a hotel to your trip</p>\n<button class=\"lbModal_close\" ng-click=\"vm.close()\"><span>close</span></button>\n</header>\n<header class=\"lbTripOptionsModal_header-car\" ng-if=\"vm.options[vm.activeOptionIndex] === 'car'\">\n<div class=\"lbTripOptionsModal_headerIcon\">\n<i class=\"ico-car lbTripOptionsModal_headerIcon-main\"></i>\n<i class=\"ico-add lbTripOptionsModal_headerIcon-sub\"></i>\n</div>\n<p class=\"lbTripOptionsModal_headerIntro\">Add a car to your trip</p>\n<button class=\"lbModal_close\" ng-click=\"vm.close()\"><span>close</span></button>\n</header>\n<form name=\"vm.form\" ng-submit=\"vm.submit()\" novalidate>\n<div class=\"lbModal_body lbTripOptionsModal_body\">\n<div class=\"lbTripOptionsModal_validation\" ng-if=\"vm.form.$invalid && vm.form.$submitted\">\n<div class=\"lbTripOptionsModal_validation_error\" ng-if=\"vm.form['vm.lbTripOptionsHotelForm'].$invalid\">\nPlease check all active hotel searches\n</div>\n<div class=\"lbTripOptionsModal_validation_error\" ng-if=\"vm.form['vm.lbTripOptionsCarForm'].$invalid\">\nPlease check all active car searches\n</div>\n<button type=\"button\" class=\"lbTripOptionsModal_validation_close\" ng-click=\"vm.form.$submitted = false;\">\n<i class=\"ico-cancel\"></i>\n</button>\n</div>\n<div ng-show=\"vm.options[vm.activeOptionIndex] === 'hotel'\">\n<lb-trip-options-hotel-form searches=\"vm.searches.hotels\" options-form=\"vm.form\"></lb-trip-options-hotel-form>\n</div>\n<div ng-show=\"vm.options[vm.activeOptionIndex] === 'car'\">\n<lb-trip-options-car-form searches=\"vm.searches.cars\" options-form=\"vm.form\"></lb-trip-options-car-form>\n</div>\n</div>\n<div class=\"lbModal_actions lbTripOptionsModal_actions\">\n<button type=\"button\" class=\"button-primary\" ng-click=\"vm.prev()\" ng-if=\"vm.activeOptionIndex > 0\">\n<i class=\"ico-chevron-left\"></i> Prev\n</button>\n<button type=\"button\" class=\"button-primary\" ng-click=\"vm.next()\" ng-if=\"vm.activeOptionIndex === 0 && vm.options.length > 1\">\nNext <i class=\"ico-chevron-right\"></i>\n</button>\n<button type=\"submit\" class=\"lbTripOptionsModal_submit button-primary\" ng-disabled=\"vm.saving\" ng-switch=\"vm.saving\" ng-if=\"vm.activeOptionIndex === vm.options.length - 1\">\n<span ng-switch-when=\"true\"><i class=\"button_spinner\"></i> Updating...</span>\n<span ng-switch-default>Update &amp; Continue <i class=\"ico-chevron-right\"></i></span>\n</button>\n</div>\n</form>\n";
	var id1="components/lbTripOptionsModal/lbTripOptionsModal.html";
	var inj=angular.element(window.document).injector();
	if(inj){inj.get("$templateCache").put(id1,v1);}
	else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
	module.exports=v1;

/***/ }),
/* 1745 */
/***/ (function(module, exports) {

	var angular=window.angular,ngModule;
	try {ngModule=angular.module(["ng"])}
	catch(e){ngModule=angular.module("ng",[])}
	var v1="<div class=\"lbUutcMessage\">\nUnused Tickets\n<i class=\"lbUutcMessage_infoIcon\" lb-tooltip tooltip-content=\"vm.message\" tooltip-inline=\"true\"></i>\n</div>\n";
	var id1="components/lbUutcMessage/lbUutcMessage.html";
	var inj=angular.element(window.document).injector();
	if(inj){inj.get("$templateCache").put(id1,v1);}
	else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
	module.exports=v1;

/***/ }),
/* 1746 */,
/* 1747 */,
/* 1748 */,
/* 1749 */,
/* 1750 */,
/* 1751 */,
/* 1752 */,
/* 1753 */,
/* 1754 */,
/* 1755 */,
/* 1756 */,
/* 1757 */,
/* 1758 */,
/* 1759 */,
/* 1760 */,
/* 1761 */,
/* 1762 */,
/* 1763 */,
/* 1764 */,
/* 1765 */,
/* 1766 */,
/* 1767 */,
/* 1768 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Copyright (c) 2014, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
	 * additional grant of patent rights can be found in the PATENTS file in
	 * the same directory.
	 */
	
	!(function(global) {
	  "use strict";
	
	  var Op = Object.prototype;
	  var hasOwn = Op.hasOwnProperty;
	  var undefined; // More compressible than void 0.
	  var $Symbol = typeof Symbol === "function" ? Symbol : {};
	  var iteratorSymbol = $Symbol.iterator || "@@iterator";
	  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
	  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
	
	  var inModule = typeof module === "object";
	  var runtime = global.regeneratorRuntime;
	  if (runtime) {
	    if (inModule) {
	      // If regeneratorRuntime is defined globally and we're in a module,
	      // make the exports object identical to regeneratorRuntime.
	      module.exports = runtime;
	    }
	    // Don't bother evaluating the rest of this file if the runtime was
	    // already defined globally.
	    return;
	  }
	
	  // Define the runtime globally (as expected by generated code) as either
	  // module.exports (if we're in a module) or a new, empty object.
	  runtime = global.regeneratorRuntime = inModule ? module.exports : {};
	
	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
	    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
	    var generator = Object.create(protoGenerator.prototype);
	    var context = new Context(tryLocsList || []);
	
	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    generator._invoke = makeInvokeMethod(innerFn, self, context);
	
	    return generator;
	  }
	  runtime.wrap = wrap;
	
	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }
	
	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";
	
	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};
	
	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}
	
	  // This is a polyfill for %IteratorPrototype% for environments that
	  // don't natively support it.
	  var IteratorPrototype = {};
	  IteratorPrototype[iteratorSymbol] = function () {
	    return this;
	  };
	
	  var getProto = Object.getPrototypeOf;
	  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
	  if (NativeIteratorPrototype &&
	      NativeIteratorPrototype !== Op &&
	      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
	    // This environment has a native %IteratorPrototype%; use it instead
	    // of the polyfill.
	    IteratorPrototype = NativeIteratorPrototype;
	  }
	
	  var Gp = GeneratorFunctionPrototype.prototype =
	    Generator.prototype = Object.create(IteratorPrototype);
	  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	  GeneratorFunctionPrototype.constructor = GeneratorFunction;
	  GeneratorFunctionPrototype[toStringTagSymbol] =
	    GeneratorFunction.displayName = "GeneratorFunction";
	
	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function(method) {
	      prototype[method] = function(arg) {
	        return this._invoke(method, arg);
	      };
	    });
	  }
	
	  runtime.isGeneratorFunction = function(genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor
	      ? ctor === GeneratorFunction ||
	        // For the native GeneratorFunction constructor, the best we can
	        // do is to check its .name property.
	        (ctor.displayName || ctor.name) === "GeneratorFunction"
	      : false;
	  };
	
	  runtime.mark = function(genFun) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	      if (!(toStringTagSymbol in genFun)) {
	        genFun[toStringTagSymbol] = "GeneratorFunction";
	      }
	    }
	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  };
	
	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `hasOwn.call(value, "__await")` to determine if the yielded value is
	  // meant to be awaited.
	  runtime.awrap = function(arg) {
	    return { __await: arg };
	  };
	
	  function AsyncIterator(generator) {
	    function invoke(method, arg, resolve, reject) {
	      var record = tryCatch(generator[method], generator, arg);
	      if (record.type === "throw") {
	        reject(record.arg);
	      } else {
	        var result = record.arg;
	        var value = result.value;
	        if (value &&
	            typeof value === "object" &&
	            hasOwn.call(value, "__await")) {
	          return Promise.resolve(value.__await).then(function(value) {
	            invoke("next", value, resolve, reject);
	          }, function(err) {
	            invoke("throw", err, resolve, reject);
	          });
	        }
	
	        return Promise.resolve(value).then(function(unwrapped) {
	          // When a yielded Promise is resolved, its final value becomes
	          // the .value of the Promise<{value,done}> result for the
	          // current iteration. If the Promise is rejected, however, the
	          // result for this iteration will be rejected with the same
	          // reason. Note that rejections of yielded Promises are not
	          // thrown back into the generator function, as is the case
	          // when an awaited Promise is rejected. This difference in
	          // behavior between yield and await is important, because it
	          // allows the consumer to decide what to do with the yielded
	          // rejection (swallow it and continue, manually .throw it back
	          // into the generator, abandon iteration, whatever). With
	          // await, by contrast, there is no opportunity to examine the
	          // rejection reason outside the generator function, so the
	          // only option is to throw it from the await expression, and
	          // let the generator function handle the exception.
	          result.value = unwrapped;
	          resolve(result);
	        }, reject);
	      }
	    }
	
	    if (typeof global.process === "object" && global.process.domain) {
	      invoke = global.process.domain.bind(invoke);
	    }
	
	    var previousPromise;
	
	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return new Promise(function(resolve, reject) {
	          invoke(method, arg, resolve, reject);
	        });
	      }
	
	      return previousPromise =
	        // If enqueue has been called before, then we want to wait until
	        // all previous Promises have been resolved before calling invoke,
	        // so that results are always delivered in the correct order. If
	        // enqueue has not been called before, then it is important to
	        // call invoke immediately, without waiting on a callback to fire,
	        // so that the async generator function has the opportunity to do
	        // any necessary setup in a predictable way. This predictability
	        // is why the Promise constructor synchronously invokes its
	        // executor callback, and why async functions synchronously
	        // execute code before the first await. Since we implement simple
	        // async functions in terms of async generators, it is especially
	        // important to get this right, even though it requires care.
	        previousPromise ? previousPromise.then(
	          callInvokeWithMethodAndArg,
	          // Avoid propagating failures to Promises returned by later
	          // invocations of the iterator.
	          callInvokeWithMethodAndArg
	        ) : callInvokeWithMethodAndArg();
	    }
	
	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    this._invoke = enqueue;
	  }
	
	  defineIteratorMethods(AsyncIterator.prototype);
	  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
	    return this;
	  };
	  runtime.AsyncIterator = AsyncIterator;
	
	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
	    var iter = new AsyncIterator(
	      wrap(innerFn, outerFn, self, tryLocsList)
	    );
	
	    return runtime.isGeneratorFunction(outerFn)
	      ? iter // If outerFn is a generator, return the full iterator.
	      : iter.next().then(function(result) {
	          return result.done ? result.value : iter.next();
	        });
	  };
	
	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;
	
	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }
	
	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }
	
	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }
	
	      context.method = method;
	      context.arg = arg;
	
	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          var delegateResult = maybeInvokeDelegate(delegate, context);
	          if (delegateResult) {
	            if (delegateResult === ContinueSentinel) continue;
	            return delegateResult;
	          }
	        }
	
	        if (context.method === "next") {
	          // Setting context._sent for legacy support of Babel's
	          // function.sent implementation.
	          context.sent = context._sent = context.arg;
	
	        } else if (context.method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw context.arg;
	          }
	
	          context.dispatchException(context.arg);
	
	        } else if (context.method === "return") {
	          context.abrupt("return", context.arg);
	        }
	
	        state = GenStateExecuting;
	
	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done
	            ? GenStateCompleted
	            : GenStateSuspendedYield;
	
	          if (record.arg === ContinueSentinel) {
	            continue;
	          }
	
	          return {
	            value: record.arg,
	            done: context.done
	          };
	
	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(context.arg) call above.
	          context.method = "throw";
	          context.arg = record.arg;
	        }
	      }
	    };
	  }
	
	  // Call delegate.iterator[context.method](context.arg) and handle the
	  // result, either by returning a { value, done } result from the
	  // delegate iterator, or by modifying context.method and context.arg,
	  // setting context.delegate to null, and returning the ContinueSentinel.
	  function maybeInvokeDelegate(delegate, context) {
	    var method = delegate.iterator[context.method];
	    if (method === undefined) {
	      // A .throw or .return when the delegate iterator has no .throw
	      // method always terminates the yield* loop.
	      context.delegate = null;
	
	      if (context.method === "throw") {
	        if (delegate.iterator.return) {
	          // If the delegate iterator has a return method, give it a
	          // chance to clean up.
	          context.method = "return";
	          context.arg = undefined;
	          maybeInvokeDelegate(delegate, context);
	
	          if (context.method === "throw") {
	            // If maybeInvokeDelegate(context) changed context.method from
	            // "return" to "throw", let that override the TypeError below.
	            return ContinueSentinel;
	          }
	        }
	
	        context.method = "throw";
	        context.arg = new TypeError(
	          "The iterator does not provide a 'throw' method");
	      }
	
	      return ContinueSentinel;
	    }
	
	    var record = tryCatch(method, delegate.iterator, context.arg);
	
	    if (record.type === "throw") {
	      context.method = "throw";
	      context.arg = record.arg;
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    var info = record.arg;
	
	    if (! info) {
	      context.method = "throw";
	      context.arg = new TypeError("iterator result is not an object");
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    if (info.done) {
	      // Assign the result of the finished delegate to the temporary
	      // variable specified by delegate.resultName (see delegateYield).
	      context[delegate.resultName] = info.value;
	
	      // Resume execution at the desired location (see delegateYield).
	      context.next = delegate.nextLoc;
	
	      // If context.method was "throw" but the delegate handled the
	      // exception, let the outer generator proceed normally. If
	      // context.method was "next", forget context.arg since it has been
	      // "consumed" by the delegate iterator. If context.method was
	      // "return", allow the original .return call to continue in the
	      // outer generator.
	      if (context.method !== "return") {
	        context.method = "next";
	        context.arg = undefined;
	      }
	
	    } else {
	      // Re-yield the result returned by the delegate method.
	      return info;
	    }
	
	    // The delegate iterator is finished, so forget it and continue with
	    // the outer generator.
	    context.delegate = null;
	    return ContinueSentinel;
	  }
	
	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);
	
	  Gp[toStringTagSymbol] = "Generator";
	
	  // A Generator should always return itself as the iterator object when the
	  // @@iterator function is called on it. Some browsers' implementations of the
	  // iterator prototype chain incorrectly implement this, causing the Generator
	  // object to not be returned from this call. This ensures that doesn't happen.
	  // See https://github.com/facebook/regenerator/issues/274 for more details.
	  Gp[iteratorSymbol] = function() {
	    return this;
	  };
	
	  Gp.toString = function() {
	    return "[object Generator]";
	  };
	
	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };
	
	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }
	
	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }
	
	    this.tryEntries.push(entry);
	  }
	
	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }
	
	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }
	
	  runtime.keys = function(object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();
	
	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }
	
	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };
	
	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }
	
	      if (typeof iterable.next === "function") {
	        return iterable;
	      }
	
	      if (!isNaN(iterable.length)) {
	        var i = -1, next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }
	
	          next.value = undefined;
	          next.done = true;
	
	          return next;
	        };
	
	        return next.next = next;
	      }
	    }
	
	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  runtime.values = values;
	
	  function doneResult() {
	    return { value: undefined, done: true };
	  }
	
	  Context.prototype = {
	    constructor: Context,
	
	    reset: function(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      // Resetting context._sent for legacy support of Babel's
	      // function.sent implementation.
	      this.sent = this._sent = undefined;
	      this.done = false;
	      this.delegate = null;
	
	      this.method = "next";
	      this.arg = undefined;
	
	      this.tryEntries.forEach(resetTryEntry);
	
	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" &&
	              hasOwn.call(this, name) &&
	              !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },
	
	    stop: function() {
	      this.done = true;
	
	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }
	
	      return this.rval;
	    },
	
	    dispatchException: function(exception) {
	      if (this.done) {
	        throw exception;
	      }
	
	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;
	
	        if (caught) {
	          // If the dispatched exception was caught by a catch block,
	          // then let that catch block handle the exception normally.
	          context.method = "next";
	          context.arg = undefined;
	        }
	
	        return !! caught;
	      }
	
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;
	
	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }
	
	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");
	
	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }
	
	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },
	
	    abrupt: function(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev &&
	            hasOwn.call(entry, "finallyLoc") &&
	            this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }
	
	      if (finallyEntry &&
	          (type === "break" ||
	           type === "continue") &&
	          finallyEntry.tryLoc <= arg &&
	          arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }
	
	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;
	
	      if (finallyEntry) {
	        this.method = "next";
	        this.next = finallyEntry.finallyLoc;
	        return ContinueSentinel;
	      }
	
	      return this.complete(record);
	    },
	
	    complete: function(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }
	
	      if (record.type === "break" ||
	          record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = this.arg = record.arg;
	        this.method = "return";
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }
	
	      return ContinueSentinel;
	    },
	
	    finish: function(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },
	
	    "catch": function(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }
	
	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },
	
	    delegateYield: function(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };
	
	      if (this.method === "next") {
	        // Deliberately forget the last sent value so that we don't
	        // accidentally pass it on to the delegate.
	        this.arg = undefined;
	      }
	
	      return ContinueSentinel;
	    }
	  };
	})(
	  // Among the various tricks for obtaining a reference to the global
	  // object, this seems to be the most reliable technique that does not
	  // use indirect eval (which violates Content Security Policy).
	  typeof global === "object" ? global :
	  typeof window === "object" ? window :
	  typeof self === "object" ? self : this
	);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1769 */,
/* 1770 */,
/* 1771 */,
/* 1772 */,
/* 1773 */
/***/ (function(module, exports) {

	module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 1774 */,
/* 1775 */,
/* 1776 */
/***/ (function(module, exports, __webpack_require__) {

	/*jslint browser: true, plusplus: true, indent: 2 */
	
	// This will be removed by uglify, along with the DEBUG code
	if (false) {
	  DEBUG = true;
	}
	
	// Logic and fallbacks based on the following SO answers:
	// - Getting caret position cross browser: http://stackoverflow.com/a/9370239/147507
	// - Selection API on non input-text fields: http://stackoverflow.com/a/24247942/147507
	// - Set cursor position on input text: http://stackoverflow.com/q/5755826/147507
	angular.module('ngPatternRestrict', []).directive('ngPatternRestrict', [
	  '$log',
	  function ($log) {
	    'use strict';
	
	    function showDebugInfo() {
	      $log.debug('[ngPatternRestrict] ' + Array.prototype.join.call(arguments, ' '));
	    }
	
	    return {
	      restrict: 'A',
	      require: '?ngModel',
	      compile: function uiPatternRestrictCompile() {
	        (false) && showDebugInfo('Loaded');
	
	        return function ngPatternRestrictLinking(scope, iElement, iAttrs, ngModelController) {
	          var regex, // validation regex object
	            oldValue, // keeping track of the previous value of the element
	            caretPosition, // keeping track of where the caret is at to avoid jumpiness
	            // housekeeping
	            initialized = false, // have we initialized our directive yet?
	            eventsBound = false, // have we bound our events yet?
	            // functions
	            getCaretPosition, // function to get the caret position, set in detectGetCaretPositionMethods
	            setCaretPosition; // function to set the caret position, set in detectSetCaretPositionMethods
	
	          //-------------------------------------------------------------------
	          // caret position
	          function getCaretPositionWithInputSelectionStart() {
	            return iElement[0].selectionStart; // we need to go under jqlite
	          }
	
	          function getCaretPositionWithDocumentSelection() {
	            // create a selection range from where we are to the beggining
	            // and measure how much we moved
	            var range = document.selection.createRange();
	            range.moveStart('character', -iElement.val().length);
	            return range.text.length;
	          }
	
	          function getCaretPositionWithWindowSelection() {
	            var s = window.getSelection(),
	              originalSelectionLength = String(s).length,
	              selectionLength,
	              didReachZero = false,
	              detectedCaretPosition,
	              restorePositionCounter;
	
	            do {
	              selectionLength = String(s).length;
	              s.modify('extend', 'backward', 'character');
	              // we're undoing a selection, and starting a new one towards the beggining of the string
	              if (String(s).length === 0) {
	                didReachZero = true;
	              }
	            } while (selectionLength !== String(s).length);
	
	            detectedCaretPosition = didReachZero ? selectionLength : selectionLength - originalSelectionLength;
	            s.collapseToStart();
	
	            restorePositionCounter = detectedCaretPosition;
	            while (restorePositionCounter-- > 0) {
	              s.modify('move', 'forward', 'character');
	            }
	            while (originalSelectionLength-- > 0) {
	              s.modify('extend', 'forward', 'character');
	            }
	
	            return detectedCaretPosition;
	          }
	
	          function setCaretPositionWithSetSelectionRange(position) {
	            iElement[0].setSelectionRange(position, position);
	          }
	
	          function setCaretPositionWithCreateTextRange(position) {
	            var textRange = iElement[0].createTextRange();
	            textRange.collapse(true);
	            textRange.moveEnd('character', position);
	            textRange.moveStart('character', position);
	            textRange.select();
	          }
	
	          function setCaretPositionWithWindowSelection(position) {
	            var s = window.getSelection(),
	              selectionLength;
	
	            do {
	              selectionLength = String(s).length;
	              s.modify('extend', 'backward', 'line');
	            } while (selectionLength !== String(s).length);
	            s.collapseToStart();
	
	            while (position--) {
	              s.modify('move', 'forward', 'character');
	            }
	          }
	
	          // HACK: Opera 12 won't give us a wrong validity status although the input is invalid
	          // we can select the whole text and check the selection size
	          // Congratulations to IE 11 for doing the same but not returning the selection.
	          function getValueLengthThroughSelection(input) {
	            // only do this on opera, since it'll mess up the caret position
	            // and break Firefox functionality
	            if (!/Opera/i.test(navigator.userAgent)) {
	              return 0;
	            }
	
	            input.focus();
	            document.execCommand('selectAll');
	            var focusNode = window.getSelection().focusNode;
	            return (focusNode || {}).selectionStart || 0;
	          }
	
	          //-------------------------------------------------------------------
	          // event handlers
	          function revertToPreviousValue() {
	            if (ngModelController) {
	              scope.$apply(function () {
	                ngModelController.$setViewValue(oldValue);
	              });
	            }
	            iElement.val(oldValue);
	
	            if (!angular.isUndefined(caretPosition)) {
	              setCaretPosition(caretPosition);
	            }
	          }
	
	          function updateCurrentValue(newValue) {
	            oldValue = newValue;
	            caretPosition = getCaretPosition();
	          }
	
	          function genericEventHandler(evt) {
	            (false) && showDebugInfo('Reacting to event:', evt.type);
	
	            //HACK Chrome returns an empty string as value if user inputs a non-numeric string into a number type input
	            // and this may happen with other non-text inputs soon enough. As such, if getting the string only gives us an
	            // empty string, we don't have the chance of validating it against a regex. All we can do is assume it's wrong,
	            // since the browser is rejecting it either way.
	            var newValue = iElement.val(),
	              inputValidity = iElement.prop('validity');
	            if (newValue === '' && iElement.attr('type') !== 'text' && inputValidity && inputValidity.badInput) {
	              (false) && showDebugInfo('Value cannot be verified. Should be invalid. Reverting back to:', oldValue);
	              evt.preventDefault();
	              revertToPreviousValue();
	            } else if (newValue === '' && getValueLengthThroughSelection(iElement[0]) !== 0) {
	              (false) && showDebugInfo('Invalid input. Reverting back to:', oldValue);
	              evt.preventDefault();
	              revertToPreviousValue();
	            } else if (regex.test(newValue)) {
	              (false) && showDebugInfo('New value passed validation against', regex, newValue);
	              updateCurrentValue(newValue);
	            } else {
	              (false) && showDebugInfo('New value did NOT pass validation against', regex, newValue, 'Reverting back to:', oldValue);
	              evt.preventDefault();
	              revertToPreviousValue();
	            }
	          }
	
	          //-------------------------------------------------------------------
	          // setup based on attributes
	          function tryParseRegex(regexString) {
	            try {
	              regex = new RegExp(regexString);
	            } catch (e) {
	              throw 'Invalid RegEx string parsed for ngPatternRestrict: ' + regexString;
	            }
	          }
	
	          //-------------------------------------------------------------------
	          // setup events
	          function bindListeners() {
	            if (eventsBound) {
	              return;
	            }
	
	            iElement.bind('input keyup click', genericEventHandler);
	
	            (false) && showDebugInfo('Bound events: input, keyup, click');
	          }
	
	          function unbindListeners() {
	            if (!eventsBound) {
	              return;
	            }
	
	            iElement.unbind('input', genericEventHandler);
	            //input: HTML5 spec, changes in content
	
	            iElement.unbind('keyup', genericEventHandler);
	            //keyup: DOM L3 spec, key released (possibly changing content)
	
	            iElement.unbind('click', genericEventHandler);
	            //click: DOM L3 spec, mouse clicked and released (possibly changing content)
	
	            (false) && showDebugInfo('Unbound events: input, keyup, click');
	
	            eventsBound = false;
	          }
	
	          //-------------------------------------------------------------------
	          // initialization
	          function readPattern() {
	            var entryRegex = !!iAttrs.ngPatternRestrict ? iAttrs.ngPatternRestrict : iAttrs.pattern;
	            (false) && showDebugInfo('RegEx to use:', entryRegex);
	            tryParseRegex(entryRegex);
	          }
	
	          function notThrows(testFn, shouldReturnTruthy) {
	            try {
	              return testFn() || !shouldReturnTruthy;
	            } catch (e) {
	              return false;
	            }
	          }
	
	          function detectGetCaretPositionMethods() {
	            var input = iElement[0];
	
	            // Chrome will throw on input.selectionStart of input type=number
	            // See http://stackoverflow.com/a/21959157/147507
	            if (
	              notThrows(function () {
	                return input.selectionStart;
	              })
	            ) {
	              getCaretPosition = getCaretPositionWithInputSelectionStart;
	            } else {
	              // IE 9- will use document.selection
	              // TODO support IE 11+ with document.getSelection()
	              if (
	                notThrows(function () {
	                  return document.selection;
	                }, true)
	              ) {
	                getCaretPosition = getCaretPositionWithDocumentSelection;
	              } else {
	                getCaretPosition = getCaretPositionWithWindowSelection;
	              }
	            }
	          }
	
	          function detectSetCaretPositionMethods() {
	            var input = iElement[0];
	            if (typeof input.setSelectionRange === 'function') {
	              setCaretPosition = setCaretPositionWithSetSelectionRange;
	            } else if (typeof input.createTextRange === 'function') {
	              setCaretPosition = setCaretPositionWithCreateTextRange;
	            } else {
	              setCaretPosition = setCaretPositionWithWindowSelection;
	            }
	          }
	
	          function initialize() {
	            if (initialized) {
	              return;
	            }
	            (false) && showDebugInfo('Initializing');
	
	            readPattern();
	
	            oldValue = iElement.val();
	            if (!oldValue) {
	              oldValue = '';
	            }
	            (false) && showDebugInfo('Original value:', oldValue);
	
	            bindListeners();
	
	            detectGetCaretPositionMethods();
	            detectSetCaretPositionMethods();
	
	            initialized = true;
	          }
	
	          function uninitialize() {
	            (false) && showDebugInfo('Uninitializing');
	            unbindListeners();
	          }
	
	          iAttrs.$observe('ngPatternRestrict', readPattern);
	          iAttrs.$observe('pattern', readPattern);
	
	          scope.$on('$destroy', uninitialize);
	
	          initialize();
	        };
	      },
	    };
	  },
	]);


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// app.js